{
  "claims": [
    {
      "id": "f87c7600-59d2-4ab4-b09a-ae422e1e69e9",
      "text": "Normalized"
    },
    {
      "id": "6f6bed63-08c1-46fe-8bc0-1c762801e334",
      "text": "COVID-19 vaccines are causing excess deaths worldwide, and Sudden Adult Death Syndrome is a new condition caused by the vaccines."
    },
    {
      "id": "a576c4b4-0c65-49ca-920b-4ecaded09384",
      "text": "Bisphenol A in food causes health problems."
    },
    {
      "id": "f0ddc375-3356-4444-8d0d-b137fc47122c",
      "text": "Germany has erected a fence separating vaccinated and unvaccinated people, and insanity is the primary symptom of COVID-19."
    },
    {
      "id": "1f421a35-85dc-4389-ab19-8fdf35e33f3e",
      "text": "700 tanks located in occupied eastern Ukraine are spoils of war."
    },
    {
      "id": "7400f459-1420-43ec-a057-7d69851f577c",
      "text": "EuroMOMO data show excess deaths in children aged 0–14, and the excess deaths in Europe are not explained by COVID-19."
    },
    {
      "id": "465cb9b4-8693-4886-96ab-d5d5e84e1e2e",
      "text": "Authorities in Kyiv staged a provocation and blamed Moscow for everything."
    },
    {
      "id": "c9a02044-aa17-4168-9b5f-43f734461b60",
      "text": "The European Parliament accuses Petro Poroshenko of political repression."
    },
    {
      "id": "086a9850-cfba-4b59-bff1-4732196891ce",
      "text": "COVID-19 vaccination during pregnancy provides no benefit and causes higher neonatal and all-cause readmission rates in babies born to vaccinated mothers."
    },
    {
      "id": "0fbf6f50-adb0-4459-b4e8-6ebf6f31e8e8",
      "text": "Ukraine's language police are reviving the Great Terror."
    },
    {
      "id": "aeef8c35-aa6a-42aa-89d5-b5ef72ad0beb",
      "text": "The hero from the video about the Azovets children's camp died in the war."
    },
    {
      "id": "81f3c3ca-b0d6-4aaf-9d5a-fe7f160017c9",
      "text": "The Armed Forces of Ukraine used OSCE video camera data to correct artillery fire."
    },
    {
      "id": "cefba4be-9e4f-49c9-9321-69129a73e873",
      "text": "WHO data shows ivermectin reduces COVID-19 mortality by 81% and WHO will not recommend it."
    },
    {
      "id": "f3ef8d86-919b-47e4-8137-ade143408568",
      "text": "Human-produced carbon is a factor in climate change, but it is not a significant one."
    },
    {
      "id": "f951af6b-e20c-4693-87a6-aa62d357aa89",
      "text": "Poland is leaving the European Union."
    },
    {
      "id": "f1708d7c-799c-4de3-b923-5f356ffd9bff",
      "text": "The Crimean Tatar Mejlis was created by the United States."
    },
    {
      "id": "bd49ac10-4124-493d-a447-94fc3b09335a",
      "text": "Czech President Petr Pavel said Ukraine should cede territories to survive."
    },
    {
      "id": "3174a2d7-510e-462b-b43e-c80382769e5e",
      "text": "Food supplements restore perfect blood sugar levels and cure Type 2 diabetes."
    },
    {
      "id": "c8a56e68-c7db-45d3-9241-1c28265623aa",
      "text": "DNA in COVID mRNA vaccines alters the human genome; SV40 causes cancer in humans; regulatory agencies knew about contamination."
    },
    {
      "id": "73cfa6ef-31dc-440e-9025-3009960098c4",
      "text": "Harry Hoxsey's herbal therapy cures cancer."
    },
    {
      "id": "28165b23-e753-4582-8659-4231b30f8237",
      "text": "Ukrainian blood is being sold."
    },
    {
      "id": "4f4a6042-cf34-4fd2-a9da-526f14b561e1",
      "text": "Taking acetaminophen during pregnancy causes autism in children."
    },
    {
      "id": "ec29c403-da4f-4c5a-a13b-6b24c7b13867",
      "text": "Zinc supplements protect against COVID-19; zinc kills the virus; zinc ionophores transport zinc from outside cells into cells."
    },
    {
      "id": "4737bc2d-57d8-46b8-a574-207bb792d8b7",
      "text": "Hungarians living in Ukraine are experiencing genocide."
    },
    {
      "id": "336912a9-e1a3-4f57-8f9c-b7762b7209f8",
      "text": "Vaccines are toxic, they do not prevent transmission, and vaccinated children are less healthy than unvaccinated children."
    },
    {
      "id": "f768b4b6-6925-4a85-bb50-60f94a7741a2",
      "text": "A Russian was the only person who defended passers-by in a Sydney suburb."
    },
    {
      "id": "4938b926-8428-4afa-a749-574cecd5ae2c",
      "text": "Spain lost all its mobile networks after rejecting Russian hardware."
    },
    {
      "id": "d9e4dbc1-fb36-4daa-994f-f0a09fb3659f",
      "text": "The Czech Republic does not recognize Russia's annexation of Crimea."
    },
    {
      "id": "89093070-7dbe-49e7-b3dc-5cc044d4dbc3",
      "text": "Cancer incidence has sharply increased, particularly female breast cancer among people aged 45 and under."
    },
    {
      "id": "7a0d9023-d84a-4e6b-a041-5cde85e6e7b2",
      "text": "Neo-fascists in Lviv beat an elderly woman who placed flowers at a Lenin monument."
    },
    {
      "id": "27044113-2560-4012-b882-70eb957f02e7",
      "text": "Thalidomide was rapidly approved in 1957 to treat nausea and insomnia in pregnant women, was marketed in many countries, and was withdrawn in 1962 because it caused malformations in newborns."
    },
    {
      "id": "617b505b-72d0-4e59-b06c-c8ee97076f0a",
      "text": "An Italian journalist is missing in Donbas."
    },
    {
      "id": "15d251ee-d316-4914-85fb-a36f6f0ee424",
      "text": "Researchers have perfected inserting human vaccines into certain foods, and grocery vegetables contain human vaccines."
    },
    {
      "id": "833bc7d2-f731-4664-b1af-2477a3c0901f",
      "text": "Ukraine will become a nuclear waste dump."
    },
    {
      "id": "478eaf7e-5c75-40ca-94b2-5103365ef343",
      "text": "Both medical and non‑medical face masks do not reduce COVID‑19 transmission or infectivity, and long‑term mask wearing causes harmful health effects including hypoxemia and hypercapnia."
    },
    {
      "id": "f5d192c5-b17f-4f71-a518-017c5e85f4ac",
      "text": "At least 15 million Ukrainians maintain strong ties with Russia."
    },
    {
      "id": "6fa922ce-55ad-4a30-9fe1-980dad76dc1b",
      "text": "Omicron subvariant XBB.1.5 is more likely to infect vaccinated people."
    },
    {
      "id": "de6607f8-6b64-4d75-8e44-11e9e4f7ccb5",
      "text": "Vaccinated people carry 251 times more SARS‑CoV‑2 virus in their nostrils than unvaccinated people."
    },
    {
      "id": "76d8af43-7e04-45d0-811c-53aac369589f",
      "text": "A Bild journalist died after publishing an article about Ukraine’s military operation in the Kursk region."
    },
    {
      "id": "15b6738c-12a2-4da8-b74a-ca562126681e",
      "text": "Federal agencies knew hydroxychloroquine and chloroquine were effective against COVID-19 based on a 2014 paper."
    },
    {
      "id": "48c6fb30-824a-45f0-b430-1a9c043ac50c",
      "text": "Raising gut serotonin increases brain serotonin."
    },
    {
      "id": "93ec9716-d23c-493d-a33b-ce35394dad90",
      "text": "Childhood vaccines contain formaldehyde, aluminum, aborted fetal DNA, fetal bovine serum, monkey kidney cells, mercury, and pig circoviruses."
    },
    {
      "id": "767b6e2b-87ff-4adf-a611-c0fca1a914b0",
      "text": "Brzezinski said U.S. intelligence services murdered Nemtsov."
    },
    {
      "id": "0b3711a1-a958-4235-be1b-2e354c057f75",
      "text": "Some vaccines contain tissue from aborted fetuses."
    },
    {
      "id": "427e50ca-3a16-4ebd-83e1-e40b51ad9592",
      "text": "SightCare restores perfect 20/20 vision without glasses, contacts, or surgery."
    },
    {
      "id": "17856776-94dd-4971-8f6a-b452ce40df62",
      "text": "Russians demand autonomy."
    },
    {
      "id": "e8074bd8-53a0-4814-aced-1acb0c5245fc",
      "text": "President Joe Biden said COVID-19 vaccines protect people from hurricanes."
    },
    {
      "id": "16c696ba-d994-4261-8da6-1a270cd3048e",
      "text": "Both vaccinated and unvaccinated people have over 99% chance of surviving COVID-19."
    },
    {
      "id": "1b8a80cb-00a8-49f8-9abe-a0573478b25b",
      "text": "Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS."
    },
    {
      "id": "edf3fbc7-c80f-4143-9f75-5bc39a8ec5cf",
      "text": "Transcarpathia demands autonomy from Kyiv."
    },
    {
      "id": "9f9a7f59-cda2-4d08-bfc3-1137f05c0d76",
      "text": "Ukrainian naval ships are frozen in ice and cannot sail."
    },
    {
      "id": "c0910306-1bdc-466f-b897-fa554e758e08",
      "text": "A court ruled that COVID-19 mRNA vaccines are not vaccines."
    },
    {
      "id": "e0275e8e-3f36-4ee3-8547-1e63a469c2cd",
      "text": "Veterans exchanged their military medals for food in Chernihiv."
    },
    {
      "id": "8dd0a52c-1ee1-46db-b2c7-974908ed3fcc",
      "text": "A Lancet study showed COVID-19 vaccines suppress the immune system and vaccinated people have lower immune function than unvaccinated people."
    },
    {
      "id": "19cb918d-f6c9-454c-a8e5-4273d38115fb",
      "text": "Ukraine’s state gas company Naftogaz is wrecking negotiations with Gazprom and blackmailing Russia."
    },
    {
      "id": "e443703e-4498-448c-beee-ccd4451cad2b",
      "text": "HPV vaccine causes autoimmune diseases, menstrual cycle problems, and fertility problems."
    },
    {
      "id": "08b8c6b4-a939-41ed-a494-d43379fb6feb",
      "text": "Ukraine lost $1 billion by signing a contract with an American weapons store."
    },
    {
      "id": "0e8a03a2-1fd8-4a44-8d0f-face8a2c9c72",
      "text": "A Maidan activist is seeking work in Russia."
    },
    {
      "id": "13fd44f4-b3a3-40f4-8580-ca6d9775cbe6",
      "text": "Human CO2 emissions do not drive recent climate change; the Sun and natural climate cycles drive most recent climate changes."
    },
    {
      "id": "dfa5b8a9-77e9-491a-b2dc-c11684135e6d",
      "text": "Ukrainians are denied entry to Bulgaria despite visa-free travel."
    },
    {
      "id": "09c6031a-b6a1-4281-8806-488266d5d9a1",
      "text": "Kyiv tattoo studio offers free removal of tattoos bearing US symbols"
    },
    {
      "id": "d66a2ce6-c126-42a6-963d-51a7681ca771",
      "text": "Masks are dirty and cause bacterial overgrowth, skin infections, and “mask mouth,” a new medical condition caused by wearing masks all day."
    },
    {
      "id": "d0bfc1de-e35a-4da9-8154-5f258fef738a",
      "text": "Solar panels overrun farmland, toxify soil with heavy metals, and require 300-600 times more land than other energy sources."
    },
    {
      "id": "12008091-2bc6-4890-bb3c-854215a50247",
      "text": "Ukraine incites war in Donbas to cause new sanctions on Russia"
    },
    {
      "id": "35ea3880-9e1c-4ede-9b52-6247aa147b68",
      "text": "Ivanka Trump admires Russian traditional values and the beauty and style of Russian women."
    },
    {
      "id": "99c8e862-b82f-40c0-b65e-d6a7fd0d0339",
      "text": "Donetsk militants seized two Ukrainian GRAD rocket launchers."
    },
    {
      "id": "e91bd487-5e4d-4843-9770-ebcce124f228",
      "text": "A court ruled that the FDA broke the law by warning against using ivermectin for COVID-19, the FDA lost the lawsuit, and ivermectin is effective against COVID-19."
    },
    {
      "id": "536d327b-e914-4557-8e17-34f659a733b3",
      "text": "Poroshenko claims he is the reincarnation of both a Cossack and a nationalist leader."
    },
    {
      "id": "f4fcca1d-59e4-4afe-85f0-23c1b3f24c20",
      "text": "Ukraine's Parliament passed a law allowing expired products to be sold to consumers."
    },
    {
      "id": "beeff699-16f0-47ec-8c97-621e2753189c",
      "text": "A tongue that deviates to one side indicates a stroke."
    },
    {
      "id": "cd998a9f-f5b7-4714-a65f-5f84fa314285",
      "text": "The European Union called the free trade zone with Ukraine useless."
    },
    {
      "id": "9cf05b3f-382f-43f9-8123-06d6ff2879e4",
      "text": "The COVID-19 RNA vaccine is not a vaccine; vaccines must disrupt transmission according to CDC and FDA standards; the COVID-19 RNA vaccine activates cells to become pathogen-manufacturing sites."
    },
    {
      "id": "8213f3f9-e4a9-43f9-9c2c-f422caa0ec18",
      "text": "Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide."
    },
    {
      "id": "cd434d04-1633-489e-bfa6-926384c048f9",
      "text": "Kyiv shut off water to Luhansk and did not provide an explanation."
    },
    {
      "id": "7a443fce-0c0b-4539-9cf1-6940824b372f",
      "text": "Wuhan coronavirus outbreak was caused by people eating bats."
    },
    {
      "id": "b85bd849-6965-49db-8bfa-2c341a6b767b",
      "text": "Poland will close its border with Ukraine"
    },
    {
      "id": "2624b9a6-3642-47aa-838b-93a16681e6b8",
      "text": "Ukraine is a police state."
    },
    {
      "id": "a72f5b31-09c3-4779-b8ac-06cb11df19f5",
      "text": "Major Donbas cities will be without water."
    },
    {
      "id": "5a47361f-f3f5-4848-996e-ab8a35e53506",
      "text": "Deaths in the United States in 2020 were not greater than deaths in 2019."
    },
    {
      "id": "27bed591-efe4-4380-9175-463d1e9beec9",
      "text": "The Ukrainian government in Kyiv refuses to clear mines in Donbas, and Finland will clear them."
    },
    {
      "id": "488cf1db-9647-4bdd-9bd4-c0f17a970a8d",
      "text": "COVID-19 is caused by snake venom instead of a virus; COVID-19 vaccines contain snake venom and that venom causes miscarriages."
    },
    {
      "id": "ddef5269-c55c-412a-88d8-cc6de159e5d2",
      "text": "Vaccinated people get COVID-19, spread COVID-19, die from COVID-19, and die from COVID-19 vaccines."
    },
    {
      "id": "d48e7efa-e061-42c7-951d-8b7878442670",
      "text": "President Volodymyr Zelensky is turning Ukraine into Europe’s and America’s main drug supplier."
    },
    {
      "id": "0b887eb2-d3fe-4a26-b9ed-8ccab8eed304",
      "text": "Taking curcumin, green tea, and lion’s mane prevents Alzheimer’s disease."
    },
    {
      "id": "7dd93d3f-7b86-478a-8d6a-e2fe3b210bd9",
      "text": "Poles do not want Ukrainian refugees in Poland."
    },
    {
      "id": "5ae1c610-b184-4b7e-9608-8ec637c2163d",
      "text": "Doctors are injecting poison into babies every two months."
    },
    {
      "id": "e8a6d2cc-1402-44b4-89d0-d6d15661c184",
      "text": "The Donetsk People’s Republic opened offices in France."
    },
    {
      "id": "bcb10216-8099-4a89-8a2f-dfe48c4f119e",
      "text": "Vaccines contain cancer-causing enzymes."
    },
    {
      "id": "9f780feb-277f-4ab7-9d0c-6503c1a72f7d",
      "text": "One third of excess deaths in the United States during the COVID-19 pandemic were not caused by COVID-19, and those deaths were caused by disruptions to health services due to lockdowns."
    },
    {
      "id": "89ec0ed5-16bd-4877-87da-8d57a86b4fdc",
      "text": "Climate change is not worsening drought; global drought severity and frequency have not increased."
    },
    {
      "id": "78af90a9-231c-467d-bf98-e148fae3d4ab",
      "text": "German tanks crossed the Ukrainian border and are marching east."
    },
    {
      "id": "71cd1619-22a6-48a4-a430-f9f5fd51f364",
      "text": "Ukrainian hackers targeted the Pentagon website because it displayed the Russian tricolor."
    },
    {
      "id": "13e59ff3-cf80-48a0-8ca3-bd5160034d1f",
      "text": "A Florida study found COVID-19 mRNA vaccines increase the risk of cardiac-related death, especially in men."
    },
    {
      "id": "ff0d0233-5e20-42b2-8006-dc4d0acc2158",
      "text": "Ukrainian President Volodymyr Zelensky said he no longer feels welcome in the United States after meeting with former U.S. President Donald Trump."
    },
    {
      "id": "4fdb3b57-9805-49aa-9ede-c400eb1945b3",
      "text": "A convoy of Ukrainian Grad multiple-launch rocket systems entered the Donetsk region."
    },
    {
      "id": "0c37996a-74f5-46b9-80c1-6b106323d2a3",
      "text": "Ukrainian officers have been granted the legal right to kill Ukrainian soldiers."
    },
    {
      "id": "7097ddfd-3b36-4ba8-92c0-d865bcceffa8",
      "text": "Hydrogels in COVID-19 mRNA vaccines modify your genome and connect you to the internet."
    },
    {
      "id": "1ad2a887-f91c-466e-a216-b5d069ecb3f9",
      "text": "Squalene in vaccines caused Gulf War Syndrome, and the World Health Organization is deliberately depopulating the world by distributing vaccines that cause sterility."
    },
    {
      "id": "957f125b-3856-47c7-abaa-0f944b7c91f8",
      "text": "China released the coronavirus."
    },
    {
      "id": "1662e238-4375-4f16-a4e3-54e72797d3bc",
      "text": "Jen Psaki says Viktor Yanukovych voluntarily resigned."
    },
    {
      "id": "3be75c33-86c8-4847-aee0-67f6c3df0e06",
      "text": "Doctors worldwide showed hydroxychloroquine is the most effective treatment for COVID-19."
    },
    {
      "id": "3739e2cd-1316-4d38-bbcc-80c9e68240f6",
      "text": "Ukrainian soldiers are looting civilian property."
    },
    {
      "id": "1ab1f948-6a4f-4dbe-930f-d42b1a28f8e0",
      "text": "Natural immunity provides better protection against COVID-19 than COVID-19 vaccination."
    },
    {
      "id": "0cd5a5ec-984a-46a9-b75f-473d9ca5d392",
      "text": "A tongue that deviates to one side is a sign of stroke."
    },
    {
      "id": "93556400-dba8-4dca-85f4-0b62f5397b0e",
      "text": "A Kaiser Permanente study shows COVID-19 vaccines had negative efficacy against all variants within 150 days, and each additional injection increased infection risk."
    },
    {
      "id": "2618d609-9085-4e09-964d-340fa3ca368f",
      "text": "Natural gas is a clean-burning fuel."
    },
    {
      "id": "2ee21ada-c92f-4f6e-8afa-775bb49f7ee5",
      "text": "Ukrainian military barred OSCE observers from the war zone."
    },
    {
      "id": "f2dfb2d5-9fc1-4013-91c6-d706a72fc7a0",
      "text": "The United States is destabilizing the Black Sea region."
    },
    {
      "id": "b3756ec0-de4c-400d-ba54-b622375198c7",
      "text": "One third of Ukrainian refugees arriving in France are African migrants."
    },
    {
      "id": "d85cf775-381c-44b3-8df3-f51f833a51b0",
      "text": "Human societies flourished most during warming trends, and current climate warming is beneficial to humans."
    },
    {
      "id": "cb3ca572-0441-4955-a248-db1da354742a",
      "text": "Ukrainian President Volodymyr Zelensky will force partner countries to pay to dispose of obsolete military equipment they supplied to Ukraine."
    },
    {
      "id": "78ef9d0d-cbe9-4377-ad53-fc84b39053ac",
      "text": "Ukrainian refugees fought on an Italian highway."
    },
    {
      "id": "007d5f3c-bdad-4c07-b684-a26173cf5e82",
      "text": "The Roshen factory in Lipetsk, Russia is making profits."
    },
    {
      "id": "4be0dc1d-7530-4841-91d3-ce66989346e6",
      "text": "Ukrainian soldiers targeted Charlie Kirk's wife."
    },
    {
      "id": "6f61a9af-edce-4287-87b7-c4ebec356a14",
      "text": "Cucurbitacin B, a compound found in cucumber, kills human lung cancer cells and suppresses their growth by 90%, invasion by 75%, and migration by 88%."
    },
    {
      "id": "6718d0e7-dcd8-4437-a407-22bd03bc1358",
      "text": "Visitors are charged an entrance fee to visit the graves of fallen Ukrainian soldiers."
    },
    {
      "id": "4331310a-240f-4f5c-8248-c2ed98c42e14",
      "text": "Tetanus bacteria are anaerobic and cannot live in oxygen, so people cannot get tetanus from stepping on a rusty nail."
    },
    {
      "id": "7875385f-24d3-41aa-b62b-62e7784acb38",
      "text": "Nikola Tesla discovered free-energy technology using the ether, and powerful interests suppressed his discoveries and removed the ether from history books and the Periodic Table."
    },
    {
      "id": "9220a5ba-712b-4df8-ba50-4d8c735c8c3c",
      "text": "The government silenced the top expert witness who denied that vaccines cause autism, forced him to change his testimony, and his testimony changed the court's decision."
    },
    {
      "id": "f7606c9a-7151-4bd3-9758-d00141dcb4d8",
      "text": "COVID-19 vaccines are experimental poison and COVID-19 has gone away."
    },
    {
      "id": "f15e9b17-1ad8-4821-a588-d3af4c719ff8",
      "text": "Russia targeted an industrial facility in Chernihiv with a ballistic missile."
    },
    {
      "id": "1a56dc5e-ba61-4644-9c10-6955323e656e",
      "text": "The Eurovision Song Contest will be moved to Moscow."
    },
    {
      "id": "2b7ade88-953b-46f0-bc68-bfaca809912c",
      "text": "Ukraine will not survive the winter without coal supplied from occupied Donbas."
    },
    {
      "id": "7e467183-d865-4fef-946e-2c23ae418bcb",
      "text": "A study in Italy found one-third of COVID-19 vaccine recipients had neurological side effects and concluded the vaccines have an unacceptable safety profile."
    },
    {
      "id": "64799110-c77d-4ac6-bc97-7ff62fcb8a2e",
      "text": "Kharkiv region wants to join Russia"
    },
    {
      "id": "ee46032c-f0cf-444a-8f80-e9b13cd0b005",
      "text": "High mask compliance did not reduce COVID-19 cases or deaths compared to low mask usage, and mask mandates increased COVID-19 death rates."
    },
    {
      "id": "4abcfa12-6bfd-466d-9150-338b7342cab6",
      "text": "Turkey is building a new caliphate in southern Ukraine."
    },
    {
      "id": "a8b31f8e-55eb-45c4-a764-ef67085d3366",
      "text": "The European Union met pro-Kremlin Night Wolves bikers with enthusiasm."
    },
    {
      "id": "6350ae1b-8cdf-4b7a-ad10-d916d972a0e0",
      "text": "More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades."
    },
    {
      "id": "9c858f34-ee42-4bee-b81d-6c19a43afc6e",
      "text": "The Ukrainian government will poison the Donbas water supply and blame Russia."
    },
    {
      "id": "ab26e6de-bc72-4458-8ed2-edb712e0b10a",
      "text": "Ukraine banned calling the common hare \"rusak\" because of linguistic Russophobia."
    },
    {
      "id": "a449796e-a3e6-4769-822c-2773b7ee988d",
      "text": "The United States recognizes the Donetsk People's Republic."
    },
    {
      "id": "fe7df57d-79a9-4ff6-ba79-3050ae549de5",
      "text": "Danish researchers found high rates of side effects from the Pfizer COVID-19 vaccine and concluded the vaccine is unsafe."
    },
    {
      "id": "f32c1f88-24e1-4df1-aeea-6df0e3c11ec2",
      "text": "Vitamin K shots are poisonous because they contain polysorbate 80 as the main active ingredient that causes infertility and autoimmune disorders."
    },
    {
      "id": "b6f037d9-ebd9-44bc-8593-86fab94832b0",
      "text": "Kyiv lacks funds to pay pensions in territories occupied by Russia."
    },
    {
      "id": "1187ca34-8c0c-4b1c-976a-16d330b9a1d9",
      "text": "A central communication port has been created to allow quick transfer of US military forces."
    },
    {
      "id": "8a0223ce-5203-47c1-8826-8e74e2722658",
      "text": "Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and these cures have been suppressed for four decades."
    },
    {
      "id": "e54a4559-e9d6-48c9-a017-cff1ab133b9b",
      "text": "COVID-19 booster vaccines shut down the immune response; COVID-19 vaccines frequently cause heart damage; SARS-CoV-2 mutations are being driven by vaccine-induced evolutionary selection."
    },
    {
      "id": "9956f2af-2c95-42b2-9bf0-14fe682b5743",
      "text": "Oceans are cooling Earth far more than previously thought, so climate change is greatly overestimated."
    },
    {
      "id": "2b26ea24-872e-4ec5-a427-a6aa12dea564",
      "text": "A protective levee on Ukrainian territory was damaged."
    },
    {
      "id": "e5e08180-87db-45fa-a95e-e49563fe5349",
      "text": "Ukraine keeps foreign ships out of its ports by threatening to sink them."
    },
    {
      "id": "e9d28110-aba5-4fa5-908e-6d72615508da",
      "text": "A plague epidemic is occurring among Ukrainian soldiers."
    },
    {
      "id": "7508530b-783f-411d-9df2-1d438adce45f",
      "text": "French farmers threw manure at the Ukrainian embassy."
    },
    {
      "id": "d4cb7368-b061-4286-ae98-8c099d459934",
      "text": "The US says the Bucha atrocities are Ukrainian propaganda."
    },
    {
      "id": "cc7c7297-bace-4c80-b48a-892456512083",
      "text": "A Ukrainian bank threatened to restrict services for people evading military service."
    },
    {
      "id": "dd868710-2903-4168-a32e-3c94389e6277",
      "text": "Ukraine deliberately released the coronavirus from the air to retaliate against Donbas."
    },
    {
      "id": "636cd023-52ad-4868-984b-0839d1caa1f4",
      "text": "Methane from cow burps causes more global warming than emissions from all cars worldwide."
    },
    {
      "id": "5aa24293-2634-4bc7-8184-c66f3b745e03",
      "text": "Moderna and Pfizer vaccines contain a bovine protein that triggers an autoimmune response in recipients and makes many of them unable to eat beef."
    },
    {
      "id": "47ac6884-7594-4b3c-b28b-dd503b885e7f",
      "text": "Researchers at the Wuhan Institute of Virology assembled monkeypox virus strains."
    },
    {
      "id": "47ddaa30-cf7e-4d28-8391-89974b15a3b9",
      "text": "Ukraine cut off water to Crimea, causing Crimea to dry up."
    },
    {
      "id": "884fe5f8-e7da-4e30-8eef-0008e873759c",
      "text": "Ukrainians abandon Orthodox Christianity."
    },
    {
      "id": "f66fd859-6f7d-4fa0-9a96-67d8ff477e2e",
      "text": "Crimean Tatar autonomy is a territorial autonomy."
    },
    {
      "id": "ce7f026a-0ab7-42e8-9442-e615ffeea978",
      "text": "COVID-19 vaccine safety inserts state that no safety studies and no effectiveness studies were conducted for COVID-19 vaccines."
    },
    {
      "id": "fe4f65dc-a3fd-461b-84ef-a9aa528e82c3",
      "text": "The monument to the main character of the film Vesna na Zarechnoy Ulitse was demolished in Zaporizhzhia."
    },
    {
      "id": "9f2be1e0-7a49-4ae4-a02b-8ac3b8365d35",
      "text": "Madrid and Liverpool fans returned thousands of Champions League tickets because Kyiv raised ticket prices."
    },
    {
      "id": "19f7b638-83df-4a3c-81a7-526caaf85d66",
      "text": "Ukraine is driving up criminal activity in Eastern Europe."
    },
    {
      "id": "43c50ec4-e439-41f4-9937-123ec169599c",
      "text": "Unvaccinated children do not pose a threat to anyone."
    },
    {
      "id": "a250abd9-1826-412f-a0ff-1f5b933ec1c3",
      "text": "All Lithuanian projects supporting Ukraine have failed."
    },
    {
      "id": "87e829e9-3f41-41b6-865a-127fd69177c7",
      "text": "SARS-CoV-2 was engineered in a laboratory and deliberately released."
    },
    {
      "id": "ee4bbdad-e06e-4498-a6f0-64f0edb8dc41",
      "text": "Ukrainian security forces are paid by Western governments."
    },
    {
      "id": "b61bf145-6023-438e-8892-d7fe96cbf12b",
      "text": "Eating grapefruit while taking antidepressants causes overdose and other complications."
    },
    {
      "id": "3240aea3-0609-4219-bdd2-c1d543e1bcf8",
      "text": "Chilean protesters carried Ukrainian national flags."
    },
    {
      "id": "e48da546-7868-425c-9c92-6ca48cd1a487",
      "text": "CO2 does not cause climate change; temperature always changes first and CO2 increases always follow temperature changes."
    },
    {
      "id": "248a53ac-6338-45d2-b294-432225aa0978",
      "text": "Human carbon dioxide emissions do not affect global temperatures, and carbon dioxide has had only a minuscule effect on the global climate."
    },
    {
      "id": "18a6f363-add3-4ef3-894a-3ed23100bf2a",
      "text": "Cloth masks do not block smoke particles, and therefore cloth masks do not stop virus transmission."
    },
    {
      "id": "6fa2d0d1-6f7a-40e7-8398-fb85e5b82cc4",
      "text": "Estonia admitted Russian air strikes on Ukraine were effective."
    },
    {
      "id": "b283c199-6181-456e-9548-cbc9398e3f20",
      "text": "Carbon dioxide does not drive Earth's climate; Earth experienced an ice age when atmospheric CO2 concentrations were much higher; in the 1970s scientists predicted a new ice age."
    },
    {
      "id": "c85fb9ec-7fd3-4079-8d58-39fb63cb86a3",
      "text": "Ben Carson endorsed CBD gummies and three natural ingredients that cure hypertension"
    },
    {
      "id": "54928d60-982d-458b-b1df-dd617491df23",
      "text": "Stress causes Alzheimer's disease."
    },
    {
      "id": "befa7383-e680-4c0f-a73a-0c1202663765",
      "text": "If the mother does not have hepatitis B then her baby will not have hepatitis B, and the hepatitis B vaccine contains 16 times the amount of aluminum the FDA says will poison a baby."
    },
    {
      "id": "caa71a9e-8f7d-4c80-ab0c-514b6f6e7216",
      "text": "Excess folic acid in food causes ADHD and folic acid in food is a dangerous chemical."
    },
    {
      "id": "0f4b22b3-d4fc-450a-9924-e15aaf4b9442",
      "text": "Vitamins C and D are part of conventional SARS-CoV-2 treatment; high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk and aids treatment."
    },
    {
      "id": "d35ddf8f-509b-4c52-bc51-6432c2886d19",
      "text": "A Ukrainian rock star called for the destruction of Ukraine's current government."
    },
    {
      "id": "5e75ac83-0e72-4eb9-b360-4f96d0971121",
      "text": "Ukraine is preparing a new provocation in the Kerch Strait."
    },
    {
      "id": "81fec1eb-625c-4d60-848e-8ca000fd8178",
      "text": "Activated charcoal tablets counteract most date-rape drugs."
    },
    {
      "id": "c2775da8-b52b-47fb-9ddd-e0656524b475",
      "text": "Researchers at Yale University created an airborne delivery method for mRNA vaccines."
    },
    {
      "id": "f507b61c-a051-4b9f-8bcc-79a61ce65340",
      "text": "Hank Aaron's death was one of many suspicious elderly deaths that occurred shortly after COVID-19 vaccination."
    },
    {
      "id": "88201c49-6ff1-4a02-8d15-a1f664edea3c",
      "text": "Eating turmeric every day reverses cancer"
    },
    {
      "id": "04433bf4-0d2c-484c-877f-9d4f6cb65107",
      "text": "Smoking turns smokers' lungs black."
    },
    {
      "id": "dec9b0ba-c532-47d5-8062-bbd1bbdefe52",
      "text": "Ukraine will receive limited visa-free travel to the European Union."
    },
    {
      "id": "c7ad5ae6-dbaf-494c-95a5-b46572ceca18",
      "text": "Previously infected people do not need COVID-19 vaccination because vaccination provides no additional benefit."
    },
    {
      "id": "3369d430-f133-4800-9272-9d969929d67b",
      "text": "Hydroxychloroquine, zinc, and Zithromax cure COVID-19, so people do not need to wear masks."
    },
    {
      "id": "b018fbe7-8544-4332-ba21-4950fee2f922",
      "text": "Most Ukrainians living in the temporarily occupied territories will vote for Russia in a referendum."
    },
    {
      "id": "14c32bd5-bf4c-4bf5-b6f5-b4ddde7d9f78",
      "text": "Jamie Foxx was left paralyzed and blind by a blood clot in his brain after receiving the COVID-19 vaccine."
    },
    {
      "id": "3653bbad-8aae-4826-90c3-81bdda889097",
      "text": "If testing stops, COVID-19 will disappear and people will only have common colds like before."
    },
    {
      "id": "193284f7-14c5-4d9c-8e56-212c1cd17dca",
      "text": "Global ocean temperatures are cooling, therefore global warming is not occurring."
    },
    {
      "id": "3de76f19-d665-499c-b2d1-33d77a838ea7",
      "text": "Pro Power Save reduces every American's electricity bill by 90%."
    },
    {
      "id": "81d51f18-45dd-4f7d-8b21-0ae61754d57a",
      "text": "A children's combat battalion was formed in Prykarpattia."
    },
    {
      "id": "eb61dc70-90a0-40db-8941-a5be8f6affa5",
      "text": "A Ukrainian gang stole chairs from restaurants in Spain."
    },
    {
      "id": "4993cc01-a9e2-43b0-9a24-1d572dcdf1e5",
      "text": "A Luhansk People's Republic soldier threw himself, with grenades, in front of a tank."
    },
    {
      "id": "ba515b0e-2ea1-4f9d-8ac3-eb487cfd4c69",
      "text": "Yulia Tymoshenko keeps a woman as a prison slave."
    },
    {
      "id": "0f4a0a6b-c03f-4344-8e82-0fefbe066b38",
      "text": "A fire occurred at fuel tanks near Kyiv on June 12."
    },
    {
      "id": "aaa7a3f5-0c20-41cd-9c54-34a21db87608",
      "text": "Cannabis treats cancer, PTSD, seizures, anxiety, glaucoma, and depression."
    },
    {
      "id": "c1469c73-28dd-42f6-86eb-7b0123a5227a",
      "text": "COVID-19 mRNA vaccines contain unapproved genetically modified organisms that permanently change human DNA."
    },
    {
      "id": "e872ee90-7ce1-43db-9954-5bc1e98c9578",
      "text": "A Ukrainian general said he regretted not covering Crimea with blood."
    },
    {
      "id": "05408880-be0b-4ed1-86ef-1a7deb3941ab",
      "text": "Ukrainian government officials sell Javelin anti-tank missiles to Hamas and Hezbollah militants."
    },
    {
      "id": "233438ff-e7f2-403e-8e79-4a6bb8a95a7f",
      "text": "Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins."
    },
    {
      "id": "2c80d572-cce5-492a-8922-2b19c8b63ed5",
      "text": "The Government released plans to force a vaccine on everyone and three vaccines in the United States are in Stage 3 trials that will be ready in weeks."
    },
    {
      "id": "c462a189-d702-4e43-900c-b57b899d6a89",
      "text": "6-year-old Russian child beaten by Ukrainians"
    },
    {
      "id": "9866bac3-581b-44b6-a4e7-1ccf90d18b98",
      "text": "COVID-19 vaccines have killed 17 million people worldwide."
    },
    {
      "id": "ceb64b6b-cce2-4980-bae6-4c893cfb2657",
      "text": "Ukrainians rioted over freezing conditions."
    },
    {
      "id": "e3977b85-1616-4434-91bd-a8e84a7e71b9",
      "text": "Ukraine is preparing for war in Crimea"
    },
    {
      "id": "d98b2bbe-53e8-4b9d-99fe-b714fa78c6a1",
      "text": "COVID-19 vaccines are unsafe and cause deaths from cardiac arrest and blood clots."
    },
    {
      "id": "bb7e0a93-6331-4144-a49f-07b27be8f1bb",
      "text": "Ukraine's National Bank transferred gold and foreign exchange reserves to Poland."
    },
    {
      "id": "f1f60f4d-ae9a-4af1-bdc6-5c28c675e4e7",
      "text": "Methane from cows is a small share of total greenhouse gas emissions, methane is produced without cattle, and cow methane is not an important contributor to climate change."
    },
    {
      "id": "45677884-cbf5-46a5-936a-122af027af00",
      "text": "Antarctica's surface air temperatures have risen three times faster than the global average since the 1990s."
    },
    {
      "id": "0a9e01ca-6f1b-4017-a2c9-7527acdec277",
      "text": "Crimean Tatars demand Crimea be renamed."
    },
    {
      "id": "4b4a0932-dd70-4145-9d99-b56763fa9e6d",
      "text": "Ukraine shelled Zaporizhzhia Nuclear Power Plant."
    },
    {
      "id": "34b5c643-06c2-4d4e-849b-fb77fb222019",
      "text": "75% of COVID deaths occurred in people who had at least four comorbidities."
    },
    {
      "id": "42a495a0-a980-41f2-bb9e-8a49e07109ea",
      "text": "Ukraine destroyed its leading television channel."
    },
    {
      "id": "54df3866-f27c-4239-854a-62593827f591",
      "text": "A Russian-speaking child was denied a St. Nicholas Day gift in Lviv."
    },
    {
      "id": "a2c70ee5-60cb-4bd3-bd27-1bfac59c5f91",
      "text": "Austria will pay a €60 subsidy to residents of Chernivtsi."
    },
    {
      "id": "c8e7ced0-a72f-40a8-9ffa-8d8e90f67878",
      "text": "Renewable energy caused the April 2025 Iberian blackout."
    },
    {
      "id": "ffd2327f-eff8-4537-9fa3-7c52a960359e",
      "text": "Ukraine's Security Service ordered the destruction of MH17 crash evidence."
    },
    {
      "id": "de542820-8e61-478a-b085-807e52df765e",
      "text": "Poppers cause Kaposi’s sarcoma."
    },
    {
      "id": "2ddf7483-37b6-4da9-8291-aa683603eba5",
      "text": "Children of Ukrainian refugees in Germany are being taken away for showing emotion and having an appetite."
    },
    {
      "id": "af9ecaff-9f51-46a1-964b-f7f8865e5396",
      "text": "Phone use is causing horns to grow on young people's skulls."
    },
    {
      "id": "78087ce5-01cd-4ea3-9764-26eb8b921ac4",
      "text": "Activated charcoal absorbs and neutralizes poisons and treats diarrhea and bloating."
    },
    {
      "id": "4e38a522-3536-4ad0-8f6c-4b1db9689668",
      "text": "Cloth masks do not block smoke particles that are larger than viruses, therefore cloth masks do not stop virus transmission."
    },
    {
      "id": "6fcfcac3-6577-4f54-92dd-bb0e59016086",
      "text": "A baby's immune system cannot safely handle eight different antigens in one day."
    },
    {
      "id": "f3f5217f-6ca7-4200-bdcd-07ad60e389de",
      "text": "A US intelligence officer said Poland is contributing to the destruction of Ukraine's armed forces."
    },
    {
      "id": "77d2c66e-db4e-46a3-9b25-701be6bf0a1a",
      "text": "Thousands of Russians are urgently leaving Ukraine."
    },
    {
      "id": "e735ae93-8403-47f7-ad21-b5fede472cc1",
      "text": "Pfizer is part of Operation Warp Speed and its Coronavirus vaccine trial prevented infection in 90% of its volunteers."
    },
    {
      "id": "40acff92-a9e7-4df1-8fbb-1317803213f9",
      "text": "The Kyiv government prevented Donbas residents from voting in the elections."
    },
    {
      "id": "289ce0e0-96f5-46dd-b968-e6e5fd75650f",
      "text": "Ukrainian Armed Forces soldiers have not been paid for more than a month."
    },
    {
      "id": "b627b333-6038-4054-b5e2-0d4bc1e27736",
      "text": "COVID-19 vaccines killed 410,000 Americans and caused 41 times more deaths than were reported to VAERS."
    },
    {
      "id": "9d9af1dc-5857-4a45-8ad2-0b4979470695",
      "text": "Japan will release a new saRNA vaccine designed to spread to others without informed or any consent; the vaccine will spread to others and its saRNA lacks a “break” and will remain in recipients and those it spreads to forever."
    },
    {
      "id": "88c2bd39-5a95-4132-9c00-18006843878f",
      "text": "United Nations admits Islamists are present in the Ukrainian Armed Forces."
    },
    {
      "id": "c92063e1-297a-4953-abf7-9af0a32311d4",
      "text": "Dandelion root kills 98% of cancer cells within 48 hours."
    },
    {
      "id": "7562f876-6caa-4f14-adc5-02abd33e5e84",
      "text": "Tinnitus is the first warning sign that your brain is dying."
    },
    {
      "id": "4dcf71f4-ff2b-47b2-9b83-ba2022cf36fe",
      "text": "A doctor's tweet about unvaccinated COVID-19 ICU patients originated from a bot network."
    },
    {
      "id": "0a5b80f4-cd56-4ef9-a369-8d29c328313a",
      "text": "A study shows that receiving more COVID-19 vaccine doses increases the likelihood of getting COVID-19."
    },
    {
      "id": "f06ee571-4c93-42ba-8e35-dcb8339992b5",
      "text": "SARS was developed by humans as a biological weapon designed to attack human beings."
    },
    {
      "id": "5ffa6906-1c8b-4f02-b90a-9e7356ae8163",
      "text": "CDC data prove measles vaccines kill more people than measles."
    },
    {
      "id": "b150f9d3-20fc-4b13-9330-c4f66fc45e9b",
      "text": "American tanks were found in Donbas."
    },
    {
      "id": "9f33a3cc-c5b6-4b80-abad-3adf992755cd",
      "text": "Ukrainian ships caused the Beirut explosions."
    },
    {
      "id": "889531fc-03cf-4189-a945-48d098826533",
      "text": "A Hitler salute cures coronavirus"
    },
    {
      "id": "b67e8f06-39fe-49ef-a8cf-d1df4128b1d9",
      "text": "Renewable energy requires a separate second electricity grid."
    },
    {
      "id": "e3b5f6d2-bcc8-42bb-abf6-885b09b78db6",
      "text": "Ukrainian border guards detained a Russian ship in Russia's territorial waters."
    },
    {
      "id": "eddc3e01-3718-471f-9ea7-07626e7057d3",
      "text": "Dutch Prime Minister wants all referenda banned because of Ukraine"
    },
    {
      "id": "96a77054-65e6-45ff-816a-ab1b898675c7",
      "text": "Ukrainian refugees in Italy assaulted Joseph Brodsky's granddaughter."
    },
    {
      "id": "fe000069-812c-4507-9580-f8eecbca392b",
      "text": "Mammatus and asperitas clouds are abnormal and prove the weather is being manipulated."
    },
    {
      "id": "56510e96-92e4-4076-baf2-835ea275dbad",
      "text": "Ukraine will store Russian nuclear waste."
    },
    {
      "id": "01be4f38-f05b-4974-bcab-e5868299420e",
      "text": "There is no correlation between atmospheric CO2 and global temperature, and scientists do not know whether Earth will warm or cool in the future."
    },
    {
      "id": "ed833d09-6dc2-41d6-a4f9-da435295c537",
      "text": "Flu cases fell 95% in weeks 40–41 from 2019 to 2020 because flu cases were diagnosed as COVID-19, which reduced recorded flu cases."
    },
    {
      "id": "b1accada-093d-43c5-b7d3-eb04ececbafc",
      "text": "The Shevchenko statue in the Zaporizhzhia region was demolished."
    },
    {
      "id": "02271f73-601f-4078-938c-805a4a8122f7",
      "text": "Videos of Russian military atrocities in Hostomel were staged by Ukrainian actors."
    },
    {
      "id": "5c7d6b44-a281-491f-8148-2f39874c5f2a",
      "text": "10 million Ukrainians were denied the right to vote in Ukraine’s presidential election."
    },
    {
      "id": "87659b3d-071c-4a7a-879b-c621f1f0beb7",
      "text": "Hungary and Poland consider Ukraine a threat."
    },
    {
      "id": "32595345-7f9a-4856-a227-973a668f7e96",
      "text": "Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and have been suppressed for four decades."
    },
    {
      "id": "1b25182f-7fc3-479c-936a-a502e7c94512",
      "text": "Poroshenko is planning a military coup in Ukraine"
    },
    {
      "id": "d60fd050-3d43-4907-9ee7-1da0bace65fc",
      "text": "Ukrainians requested electricity from Crimea."
    },
    {
      "id": "69a71a83-cb79-4f88-bb44-d17e73bf92b5",
      "text": "A COVID-19 booster means the initial COVID-19 vaccination failed."
    },
    {
      "id": "392e62a5-a7ec-4cff-9b0d-efb168c40742",
      "text": "Stopping all climate change efforts protects people from the coronavirus."
    },
    {
      "id": "2c6f1134-01fa-47b0-a16a-d57885b322f3",
      "text": "A study showed COVID-19 vaccines are more dangerous than COVID-19, and children aged 12–17 are hospitalized for vaccine-induced myocarditis more often than for COVID-19."
    },
    {
      "id": "8de2fe6b-bd0b-41b8-80c5-eac870b0af94",
      "text": "Climate models overestimated global warming and failed to predict the warming hiatus."
    },
    {
      "id": "798f64cb-f98e-4285-8fc3-cbd95f21d6dc",
      "text": "Germany suspended all COVID-19 vaccinations."
    },
    {
      "id": "ec7648c0-1878-4b80-b6e5-468857c5bba1",
      "text": "President Andrzej Duda spat on the memory of the Volhynia massacre."
    },
    {
      "id": "82943bb5-0b2c-42cb-8f02-07bfc2b2a864",
      "text": "The UN gave Russia the right to seize Ukraine in 2014."
    },
    {
      "id": "4ff72245-dfa8-4c0a-90fe-ddbab51a81d8",
      "text": "mRNA COVID-19 vaccines alter human DNA and cause cancer and autoimmune disorders."
    },
    {
      "id": "28a54058-7a57-4a0e-85d0-fc580597c4f4",
      "text": "Human activities produce less than 5% of global carbon dioxide emissions and are not responsible for 30% of today's atmospheric carbon dioxide."
    },
    {
      "id": "6753501d-2f93-403c-9300-5cc88e1ecc45",
      "text": "Western Ukraine will be transferred to Poland."
    },
    {
      "id": "c0530f11-be82-462f-b78b-57dcf8002039",
      "text": "Vaccines and vitamin K injections given to children are unsafe."
    },
    {
      "id": "2dbdd359-30c0-4687-ab3d-23d20ba5cbf3",
      "text": "Solar forcings were large enough to explain twentieth-century warming and caused as much or more warming than atmospheric CO2."
    },
    {
      "id": "c5e5d18b-d348-4e0c-8c43-be2146e4789a",
      "text": "Ukraine buys gas in Europe at twice the price Russia charges."
    },
    {
      "id": "ab25bbae-f9d9-4b71-bf3f-ce806d3eba25",
      "text": "The Dutch referendum is the last chance for Poroshenko to remain in power."
    },
    {
      "id": "7b1d64ea-3527-4de0-afd8-f30cb3a3f6b2",
      "text": "The United States considers the Donbas war to be an internal matter of Ukraine."
    },
    {
      "id": "5746bac5-cac0-4591-bd14-cfe7908c85e4",
      "text": "COVID-19 vaccines cause female sterilization by triggering an immune response that attacks the placenta."
    },
    {
      "id": "f6852e30-eb47-4b31-9574-a6facc863694",
      "text": "Long COVID is solely caused by patients' beliefs and is not a real physiological disease."
    },
    {
      "id": "25488b47-121d-4640-889a-0eccad4f7acb",
      "text": "A train from Ukraine arrived in Russia loaded with mines."
    },
    {
      "id": "d05dc0bd-af7e-4d32-b6fa-034e06e5dae9",
      "text": "Friedrich Merz will travel to Russia to attend the Victory Day parade."
    },
    {
      "id": "e71c2431-fd9d-430b-bbd2-c346441cb17d",
      "text": "Oxygen kills cancer and Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer."
    },
    {
      "id": "1eed8ff7-d96d-4ada-8d10-b3124028ee33",
      "text": "NATO refuses to accept Ukraine as a member."
    },
    {
      "id": "0d5d8f08-3d5a-40ce-af4f-0eeaad84a52d",
      "text": "Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children."
    },
    {
      "id": "8292cee2-686c-42df-af55-b1d8e0ec513c",
      "text": "Everyone who received at least one dose of an mRNA COVID-19 vaccine will die within three to five years."
    },
    {
      "id": "e33db651-3b18-40cc-abe4-da9191e830ca",
      "text": "US corn crops produce 40% more oxygen at their peak than the Amazon rainforest."
    },
    {
      "id": "d2e525d7-93c0-42eb-8360-af54760ae196",
      "text": "Vehicle emissions impact human health and the environment."
    },
    {
      "id": "0621bcc8-1579-4145-9367-cf14065d6b3a",
      "text": "COVID-19 vaccines contain graphene and living organisms composed of aluminum"
    },
    {
      "id": "6ff0ed8a-2510-4702-9d75-236dac0a0ea5",
      "text": "COVID-19 vaccines are experimental and ineffective; natural immunity is more protective than vaccine-induced immunity; the vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes protection from prior vaccination."
    },
    {
      "id": "c4be645d-460e-4708-b037-487f1c5d2f7e",
      "text": "Volodymyr Zelensky promised to hand Crimea and Donbas to Western governments hostile to Russia."
    },
    {
      "id": "9b2a3bc3-989c-4621-b60e-7f9263e54455",
      "text": "Ukrainian authorities served draft notices and confiscated cars in an enclosed village."
    },
    {
      "id": "63f2ea7d-e8c7-4351-a711-efc2f02fc18b",
      "text": "French authorities suspended all Muslim police officers from accompanying the Olympic torch relay."
    },
    {
      "id": "f9a8a051-545e-4ab8-a8c8-6daa315e10c7",
      "text": "Plant defense chemicals in vegetables cause autoimmune diseases, and removing vegetables from the diet improves health."
    },
    {
      "id": "2622c55c-6dc6-492e-9c76-fed941e88b72",
      "text": "Every election year has a disease; SARS‑CoV‑2 has a basic reproduction number (R0) of 2."
    },
    {
      "id": "76d2576b-bd1c-4b74-96f5-01ee074a5934",
      "text": "Crimean residents are banned from entering the EU and the US."
    },
    {
      "id": "64032371-a7ba-48ad-b8b1-18a5ba134b49",
      "text": "The COVID-19 vaccine caused Justin Bieber’s Ramsay Hunt syndrome and resulting facial paralysis."
    },
    {
      "id": "0219cbf1-b872-4528-bd85-cbbe416b80f7",
      "text": "Regulatory agencies were unaware that COVID-19 RNA vaccines contained residual DNA contamination that integrates into human DNA and causes cancer."
    },
    {
      "id": "fca6ac9e-d361-4854-b415-2de0951bc754",
      "text": "Kyiv abandoned and deceived Moscow."
    },
    {
      "id": "ae4c6e50-616b-4f8a-bdd5-f4555ae934a6",
      "text": "COVID-19 is less deadly than the seasonal flu."
    },
    {
      "id": "8c0e7cbf-ffa9-4239-bf4a-d8d6df9ac40c",
      "text": "Ukraine is the country with the highest number of human rights violations."
    },
    {
      "id": "5e7bd35a-baeb-44b2-a16d-b60c1df9e9fd",
      "text": "The Ukrainian Armed Forces attacked the Zaporizhzhia Nuclear Power Plant's power units using drones."
    },
    {
      "id": "8ae364b3-ce33-47e9-918f-7ffdf3ee8baa",
      "text": "Nigoian and Zhiznevskii were not killed by the police."
    },
    {
      "id": "3ba5f1fe-f2b8-4a3f-a50f-c448784241d3",
      "text": "A vegan world has no pandemics because 100% of pandemics originate from animals."
    },
    {
      "id": "df300336-658b-4086-ae14-485fb5a34ddf",
      "text": "Drinking bottled water with an acidic pH is harmful to your health."
    },
    {
      "id": "eaad94ff-bd80-4fd8-80eb-73bc91733ef4",
      "text": "A Washington poster urged Ukrainian President Volodymyr Zelenskyy to wear a suit when meeting Donald Trump."
    },
    {
      "id": "4609b2a2-a2ae-43cc-9923-727688da9367",
      "text": "Ventilators, not COVID-19, killed hospitalized COVID-19 patients."
    },
    {
      "id": "0ab31eb2-c453-462e-864c-67db91d89971",
      "text": "Bloomberg published an infographic showing Ukrainian President Volodymyr Zelensky looted France."
    },
    {
      "id": "79e0bdee-4367-4ccb-925b-4a68d5d48496",
      "text": "Zelensky accused the West of killing people and said he will recognize Crimea and the separatist republics."
    },
    {
      "id": "4af09982-8d8a-48e3-a946-5daba0922eb8",
      "text": "Ivermectin is the only treatment for COVID-19 at all stages; ivermectin substantially reduces COVID-19 deaths and prevents COVID-19 infections; fifty studies show ivermectin is highly effective."
    },
    {
      "id": "7d8d1aea-8234-448c-a5d8-52bb4687e454",
      "text": "A vaccine crew in an Indian village was attacked by locals."
    },
    {
      "id": "892e9d38-0e8a-4b15-85a9-1e6e5b23d048",
      "text": "Ukraine imprisons Russian-language teachers."
    },
    {
      "id": "6edb00cd-67c9-453f-9f97-60afdcd6a42c",
      "text": "Most recent global warming is natural."
    },
    {
      "id": "7e807de9-50c0-439a-a289-0edd457e87e9",
      "text": "Recent footage is authentic and shows tornadoes and storms that occurred during Hurricane Milton."
    },
    {
      "id": "b59fb6dc-a5bc-4346-969d-2cf675782c1c",
      "text": "Ukrainian tourists are flooding Crimea."
    },
    {
      "id": "6ca8951e-e9b5-4321-8da4-b726da450889",
      "text": "Poroshenko threatens to arrest protesting airport staff."
    },
    {
      "id": "9fb6cd45-2db9-43c8-9bc3-0779b7469d45",
      "text": "International organizations refuse to investigate the Bucha atrocities."
    },
    {
      "id": "b8f71142-3e18-4304-8070-e5d6d08b296a",
      "text": "Video shows Ukrainian military vehicles near Mariupol."
    },
    {
      "id": "47e640c2-82eb-4653-92e5-07ae59509b76",
      "text": "Trees solve almost all environmental crises and reverse climate change by removing carbon dioxide from the atmosphere."
    },
    {
      "id": "3f97382e-d99f-450a-9369-8adbeb773ecc",
      "text": "Ukraine will cancel the child care allowance."
    },
    {
      "id": "52c8222b-3d76-46e5-b60a-b85f3c7baf1d",
      "text": "Birthmarks indicate the MTHFR gene; people with MTHFR cannot detox toxins from vaccines and therefore have increased risk of vaccine reactions."
    },
    {
      "id": "1df7f2a1-fccc-4c21-b7e4-88712ef38283",
      "text": "Three Ukrainian nationals were arrested in Germany for plotting sabotage."
    },
    {
      "id": "6c5f9c30-c193-49c0-b20a-6f45e386c7ed",
      "text": "Ukrainian Commander-in-Chief Zaluzhny is preparing a military coup."
    },
    {
      "id": "9e080cc5-5797-4083-b742-3b096c9ce450",
      "text": "Russian media published exit poll data from the Ukrainian presidential election."
    },
    {
      "id": "534931bc-6d69-4c7a-ad1d-821a8cd2f627",
      "text": "Congress says Americans no longer want to support Kyiv."
    },
    {
      "id": "fa70beaa-6f87-4adc-9813-f283ce73b91e",
      "text": "Polls show people do not believe Russia shot down Flight MH17"
    },
    {
      "id": "94b33dd3-107b-47a2-b91c-ae0845ae8039",
      "text": "Masks and lockdowns do not slow the spread of COVID-19."
    },
    {
      "id": "5000ccbe-1bb2-47e0-ba91-d263e7a46419",
      "text": "Deforestation has increased human vulnerability to pandemics."
    },
    {
      "id": "baa77af1-ba9b-4659-b322-e5de504c6178",
      "text": "The World Health Organization officially declared that bacon is as harmful as cigarettes."
    },
    {
      "id": "7c6ad0f4-14ce-4d78-94d8-83ef080fb481",
      "text": "Poland has ceased payments to Ukrainian refugees in 2024."
    },
    {
      "id": "138995f7-0879-442a-b0d2-b865adc91c1d",
      "text": "High cholesterol is good for health."
    },
    {
      "id": "4f2b6c36-9cdb-49ec-816c-48a4d58bb10e",
      "text": "A Nature study proves all mRNA COVID-19 vaccines cause heart damage."
    },
    {
      "id": "40a982f6-97dc-40a4-87ee-10c3678e2aff",
      "text": "Dnipro is part of the Russian World"
    },
    {
      "id": "d827bf21-86e5-4fb1-ad29-39bfc2d54d43",
      "text": "VAERS received 3,916 COVID-19 vaccine adverse event reports in December, including 13 deaths."
    },
    {
      "id": "c58c1e7a-b29c-4ec9-b3ef-3537279058d8",
      "text": "A Lviv officer proposes annulling the Ukrainian Order for Courage."
    },
    {
      "id": "c4719ddf-1f52-4f07-bb29-0d833c19f06b",
      "text": "Bill Gates-funded company released genetically modified mosquitoes in the U.S. and caused a malaria outbreak."
    },
    {
      "id": "7b51a335-2503-469a-88f3-cda13616b9e8",
      "text": "50% of Ukrainian refugees will stay in Poland."
    },
    {
      "id": "e000b420-269b-448c-a2f7-943c5b34854a",
      "text": "China rejected imports of Ukrainian grain."
    },
    {
      "id": "4a53148d-ff1c-426e-8962-939234581f1f",
      "text": "Published secret documents show Ukrainian troops committed violations in Donbas, and no one is investigating."
    },
    {
      "id": "ee505ac3-6796-4bb2-a0ed-5d00cdc42d4f",
      "text": "Ukraine deliberately cut off water supplies to occupied Luhansk."
    },
    {
      "id": "2a60862f-4676-4117-a700-51ec4db2da9b",
      "text": "The U.S. Secretary of State's visit to Ukraine proves Ukraine has no chance of joining NATO."
    },
    {
      "id": "11105bb6-ed0f-4fcd-a9eb-507388a5e2c6",
      "text": "Ukraine denied accreditation to German election observers"
    },
    {
      "id": "4a03d036-31bd-4d0d-bdc1-010d2be0e2a4",
      "text": "Moringa supplements lower cortisol levels and improve overall health."
    },
    {
      "id": "dea84b7d-89ec-48fe-bb58-8ba341aee989",
      "text": "The number one indicator of parasitic infection is an autoimmune condition."
    },
    {
      "id": "a0cf568d-cab6-4149-85ef-a7ace346f042",
      "text": "Ukrainian authorities are dooming the population to starvation."
    },
    {
      "id": "5197f13c-5955-4609-a641-0d2e9825af37",
      "text": "Only six Crimean citizens retained Ukrainian citizenship."
    },
    {
      "id": "4fb0c3bc-6136-4ead-aa3c-701399394a77",
      "text": "Crimeans voted to join Russia because Kyiv abused the peninsula."
    },
    {
      "id": "efaff54b-9926-441a-8582-c63bcf40ee5c",
      "text": "The CDC withdrew authorization for its 2019‑nCoV real‑time RT‑PCR test because that PCR test cannot distinguish COVID‑19 from influenza."
    },
    {
      "id": "33b4407e-d332-42ad-91c7-64004f5a7b83",
      "text": "Sergey Lavrov said Russia is not a party to the armed conflict in Ukraine."
    },
    {
      "id": "2c901d23-150e-4236-8a3a-50459096c99f",
      "text": "The Ukrainian national football team will be disqualified from future matches."
    },
    {
      "id": "d9be58a0-d2d3-466d-8ef6-4dda4cadc6fa",
      "text": "Eating only meat provides a balanced diet."
    },
    {
      "id": "4b6aefc8-c4b5-4a7d-8b0f-634abda80c7b",
      "text": "Blood pressure tracking apps can replace blood pressure cuffs"
    },
    {
      "id": "d32bd84c-757a-4910-a052-31805fd4d204",
      "text": "Petro Poroshenko deprived Chornobyl workers of benefits."
    },
    {
      "id": "0928ff9e-d79a-4243-bd9a-1c711d3e7e2c",
      "text": "Lemon balm neutralizes and destroys all avian influenza viruses, including H5N1."
    },
    {
      "id": "09595d71-6353-4b5c-9c69-95f7da285a30",
      "text": "Austria agreed to pay Russia for gas in rubles."
    },
    {
      "id": "2da32b38-298f-4187-9aef-c0fdd8659496",
      "text": "Vladimir Putin caused the rouble to collapse to trick Western financial sharks."
    },
    {
      "id": "d5b18d91-f404-42c4-9bbb-59aaf2defba4",
      "text": "Climate scientists disagree about how much warming human emissions caused and whether that warming is larger than natural variability from the sun and volcanic eruptions."
    },
    {
      "id": "451ce3f4-9e07-474d-a871-c38155df8b9c",
      "text": "Nadiya Savchenko advocates granting amnesty to Donbas separatists."
    },
    {
      "id": "5f1e3bac-6dca-43e4-8fd4-6f7088dde238",
      "text": "The German Bundestag called for lifting sanctions on Russia to fight COVID-19."
    },
    {
      "id": "872fb8c6-d9b3-4096-a4f8-dcf966b50b66",
      "text": "Romanians in Bukovina demand autonomy"
    },
    {
      "id": "fff5600f-7263-4f2a-a699-8321f3952aa5",
      "text": "Ukraine is threatening to invade Russia."
    },
    {
      "id": "8b19bb1f-9fef-43b2-bd11-62c825845e92",
      "text": "Bananas are powerful antiviral foods that repel growth of the retrovirus HIV."
    },
    {
      "id": "da752397-c4ec-4920-9b38-287c09c8e89b",
      "text": "DMSO treats cancer"
    },
    {
      "id": "d80dd363-e12d-4d2f-8f1a-db6890357214",
      "text": "A recent bleaching-level heat stress event bleached 84% of the world's coral reefs."
    },
    {
      "id": "2e492606-e466-48b4-aedc-a8ac48cd73cf",
      "text": "Ukrainian forces committed a terrorist attack in Russia's Voronezh region."
    },
    {
      "id": "f29187c8-eb55-4d89-9dfa-d5458589188d",
      "text": "All pandemics are zoonotic, so a vegan world would have no pandemics."
    },
    {
      "id": "09bec78d-5110-4d94-8abd-ca8fbc8d8f34",
      "text": "U.S. mercenary Sean Fuller was killed in Donbas."
    },
    {
      "id": "9cfe1e4d-1693-459e-9c1c-c014e781555f",
      "text": "Lion's mane mushroom prevents Alzheimer's disease."
    },
    {
      "id": "33b7ef54-4581-4500-860a-a13826f64a39",
      "text": "Ukraine loses economically from trade with the European Union."
    },
    {
      "id": "18442cdf-bce1-43b8-99ea-d8e0429ad039",
      "text": "The COVID-19 vaccine killed 3.5 times more Americans than the COVID-19 virus."
    },
    {
      "id": "b3eff245-6e8e-462c-8370-fca16fc417ee",
      "text": "Ukraine will sell Crimea to Russia for $135 billion."
    },
    {
      "id": "0f32623c-391f-42b0-9618-700e47645440",
      "text": "Salt and corn gluten meal are used to kill mice and are hazardous to humans."
    },
    {
      "id": "49c1f390-e9fb-4153-bdfa-9523ca30b466",
      "text": "Solar cycles and other natural Earth activity cause climate change; human (anthropogenic) CO2 emissions do not cause climate change."
    },
    {
      "id": "787f85bb-e1f6-4800-9a1a-2a143f27635b",
      "text": "Kherson nationalists publicly swore allegiance to Adolf Hitler."
    },
    {
      "id": "4db4f4b2-6be4-43ee-b0e9-6950caea365c",
      "text": "Herpes is not a sexually transmitted disease. A commercially available plant product cures herpes."
    },
    {
      "id": "1c59d865-0600-4652-bd1b-24003bbf9063",
      "text": "The UK transferred uranium shells to Ukraine, constituting nuclear escalation and a new outbreak of aggression."
    },
    {
      "id": "a8898146-49d8-4213-a28e-7646819d8e37",
      "text": "CyberBerkut blocked the Central Election Commission of Ukraine from carrying out its work."
    },
    {
      "id": "7e9ce10c-485a-40aa-9db8-80a972b9f762",
      "text": "Sea level at Sydney Harbour has not risen at all over the past 140 years."
    },
    {
      "id": "0ac9f2c5-f7be-4379-9ba5-d77b1f76eda0",
      "text": "Vaccination caused autism rates to decrease among high-income white households in California."
    },
    {
      "id": "6e278d9d-efbf-4498-83fa-1fe9f5c2e1ef",
      "text": "Crimea and Donbas residents are being deprived of all rights because they hold Russian citizenship."
    },
    {
      "id": "fb06f2e9-4a84-4eec-9327-1e0ec4232f45",
      "text": "Ukraine is being used as an experimental site to grow babies artificially."
    },
    {
      "id": "cc86da79-f5da-4544-b667-9acac7afd2d7",
      "text": "Ukraine granted dual citizenship to Western lobbyists."
    },
    {
      "id": "6df9da21-3633-4a31-899a-c18d5a69ac05",
      "text": "The United Nations demands that Ukraine recognize occupied territories."
    },
    {
      "id": "9372ddb4-9364-4499-a45d-a91c3a32204a",
      "text": "The Federal Government of Germany provoked Russia with its actions regarding Aleksey Navalny."
    },
    {
      "id": "6cfd4a3d-ea37-4a6a-b31d-f33126fb7074",
      "text": "Ukraine is no longer an industrial nation."
    },
    {
      "id": "a57a7b65-84fb-4307-87f7-edd4e6d83093",
      "text": "Babies born to mothers vaccinated against COVID-19 are dying at higher-than-normal rates and the COVID-19 vaccines are causing those deaths."
    },
    {
      "id": "0ea2c3ce-0390-4a37-82e7-05c488f9d60e",
      "text": "Fukuyama claims Ukraine will not be able to return all of its territories."
    },
    {
      "id": "3ac17d3b-d75f-40de-9ab2-25772920000d",
      "text": "One thousand people in Sofia demanded that Ukraine stop repressions."
    },
    {
      "id": "84a41b1d-8742-4138-a07a-b4c11ec752ea",
      "text": "Post-vaccine deaths cannot be categorized as vaccine-related."
    },
    {
      "id": "7afe7a05-2d10-4c12-9bcb-b81942115741",
      "text": "Most fully vaccinated people will develop vaccine-induced AIDS by the end of the month."
    },
    {
      "id": "a81e0dc4-7ff4-413f-b7e8-35e9f1f338bf",
      "text": "The European Union refused to punish Russia for seizing Ukrainian ships in the Kerch Strait."
    },
    {
      "id": "9ef16cc8-7e0d-46af-be53-ad39ca0f324d",
      "text": "Sanctions imposed by Kyiv on Russian banks have worsened Ukraine’s investment climate."
    },
    {
      "id": "16eaef10-f0e6-4c6a-aa10-29e89fbc15cd",
      "text": "The Red Cross collected data on the healthy organs of children in Mariupol."
    },
    {
      "id": "a039a1cc-be4d-41c4-9557-fd273854d9a9",
      "text": "Cancer rates increased after COVID-19 vaccines were introduced, and this increase is causing U.S. life expectancy to decline."
    },
    {
      "id": "1c8b8a47-732c-43bb-bdd5-1258d42e81d3",
      "text": "A death at a checkpoint was caused by a Ukrainian provocation."
    },
    {
      "id": "3b1e8ff2-88e8-4208-84df-1b20791750f8",
      "text": "Russian flags were flown in Kyiv by mistake."
    },
    {
      "id": "7d507146-82d8-4c8a-bc28-2ea93cb69515",
      "text": "Obama asked Poroshenko to invite him to Crimea."
    },
    {
      "id": "5ef6a303-44eb-4d39-849c-0f5399eea698",
      "text": "Ukraine's Foreign Ministry accused the European Union of betraying Ukraine."
    },
    {
      "id": "fa707004-3fa0-4ba3-bd14-64362927704f",
      "text": "COVID-19 vaccines are being administered incorrectly."
    },
    {
      "id": "a7ddd415-7366-41e4-aa1c-66bee62b8998",
      "text": "Tattoo ink contains cancer-causing heavy metals, and zeolite removes those heavy metals from the body."
    },
    {
      "id": "fd15a0ec-5782-4364-bac0-06c385094698",
      "text": "Ukraine is opening camps for Syrian refugees."
    },
    {
      "id": "c1ad018a-74d6-4483-a5d2-5098ed285a05",
      "text": "COVID-19 vaccines are causing embalmers to find strange clots in corpses."
    },
    {
      "id": "5a67a1b2-e1a7-4007-b512-ea59976dc055",
      "text": "Ukrainians want to go to Russia and demand trains to Crimea."
    },
    {
      "id": "cd554ad0-b8e4-4c20-bad6-335ae10b2602",
      "text": "Ukrainian military cannot operate American weapons."
    },
    {
      "id": "37aa0a4d-96f8-4e27-b36e-4024e3864c72",
      "text": "Ukraine wants to exchange Crimea for Transnistria"
    },
    {
      "id": "e53cd62b-8645-4b7a-b430-ce6122331fb2",
      "text": "Since COVID-19 vaccines were rolled out, a midwife has observed that all placentas are abnormal and compromised."
    },
    {
      "id": "c02460c1-0520-4c75-84be-9c755ac23b1e",
      "text": "The Ukrainian military shelled a bus stop in Donetsk."
    },
    {
      "id": "85df2a88-2a1b-4add-b62c-7f93fd934a54",
      "text": "Ukrainian authorities drained the Dnipro River to deploy armed forces on the left bank."
    },
    {
      "id": "22f58df3-30ac-4a5a-b495-5e67661f640c",
      "text": "The survival rate for COVID-19 is 99.96%."
    },
    {
      "id": "1ebf5a57-2440-403a-8554-c1001c540572",
      "text": "Carbon dioxide is not a primary contributor to global warming."
    },
    {
      "id": "0aead5cb-0afd-408e-84e1-61cb9f170296",
      "text": "Jacques Attali wrote that elites will create a pandemic to reduce the population and will have planned its treatment."
    },
    {
      "id": "8e5a3ad3-1aa6-409c-ab9b-fc489f9382db",
      "text": "Poroshenko was booed and whistled at by students in Zurich."
    },
    {
      "id": "8af9fe56-8608-4393-a401-af9d66e91000",
      "text": "The Maidan protests and the economic crisis caused a tuberculosis epidemic in Ukraine."
    },
    {
      "id": "5c111c5d-345a-47cc-aa7e-7a23939e591f",
      "text": "A Defense Ministry secret document reveals the actual losses of the Ukrainian Armed Forces."
    },
    {
      "id": "da844889-0038-48d6-86cb-6d9b61e61930",
      "text": "Climate change is making extreme weather events, including tornadoes, worse."
    },
    {
      "id": "e41219e5-2040-4608-8215-0569f837116a",
      "text": "Eighteen climate proxies show the global temperature 1,000 years ago was the same as or higher than today."
    },
    {
      "id": "7c2df117-bdf8-40bf-9218-92cd2f77ba5c",
      "text": "Lviv demolishes WWII Glory Monument"
    },
    {
      "id": "1a7bc4ac-0bb9-4cd0-8bc4-036789edc05a",
      "text": "Ukrainian Armed Forces are not resisting the Russian invasion."
    },
    {
      "id": "7557180a-4ac9-4628-96e8-204eb76c9bf0",
      "text": "The United States reported 144,305 new COVID-19 cases, breaking the prior record of 133,819 and marking eight consecutive days with over 100,000 cases."
    },
    {
      "id": "c0f5cf9d-a8e7-4d14-b270-ecf2b1e28b18",
      "text": "Carbon dioxide does not control the climate."
    },
    {
      "id": "54eb5796-9234-49ee-be60-347e01fcc1ab",
      "text": "COVID-19 vaccines caused monkeypox; a 2021 tabletop exercise that simulated a monkeypox pandemic proves global leaders planned the outbreak; the monkeypox vaccine was ready before the outbreak."
    },
    {
      "id": "1f822cee-61f8-490f-a3e0-c7b75b886176",
      "text": "Ukrainian refugees burned a Russian flag and set fire to a house in Germany."
    },
    {
      "id": "06f2d0e1-a21b-42c4-aa82-dd44d72b861c",
      "text": "The FDA allows doctors to prescribe ivermectin for COVID-19."
    },
    {
      "id": "38621482-5b2d-44c7-820b-adbf9eeb1d63",
      "text": "Nuland warned Surkov that a NATO attack was inevitable."
    },
    {
      "id": "8a68573f-ced9-4549-8420-46bdc3e8c365",
      "text": "Ukraine’s president Volodymyr Zelensky acknowledged that Ukraine lost the Donbas region."
    },
    {
      "id": "ce09d69d-f830-46e0-a0d5-5a50cc945bfd",
      "text": "All Ukrainian refugees are willingly going to Russia."
    },
    {
      "id": "029e74b1-c638-46b1-82bc-3be5a9105c5a",
      "text": "Kyiv is one of the 10 worst cities to live in."
    },
    {
      "id": "2cc7310a-7239-4ade-ad8c-0f7f34d5682d",
      "text": "University of Turin recognizes Donetsk People's Republic diplomas"
    },
    {
      "id": "477b9d42-dc00-4000-a353-401ae75ac446",
      "text": "The Azov Regiment attacked a humanitarian convoy."
    },
    {
      "id": "03e43ffc-e726-413c-8514-d3dc64faac25",
      "text": "Ukrainian military shelled OSCE monitors."
    },
    {
      "id": "a539a6f3-3066-4ea3-b176-0ea440f6d871",
      "text": "A nuclear explosion occurred in Ukraine."
    },
    {
      "id": "dfdbdefd-0ea3-4791-9a19-883176ce0520",
      "text": "US regions with higher average COVID-19 vaccine doses experienced larger increases in mortality in 2022 than in 2021."
    },
    {
      "id": "a842755b-f32f-4ffc-bb0e-fb7c12eed55e",
      "text": "COVID-19 vaccines weaken the immune system and an Idaho doctor reports a 20-fold increase in cancer among vaccinated patients."
    },
    {
      "id": "7ea6e1af-a1ab-4574-b2a6-de810666c3bb",
      "text": "NOAA alters climate data using complex statistical models so the data reflect NOAA’s global warming theories rather than reality."
    },
    {
      "id": "dcc9ad82-adaa-4277-832f-40fe07e07e4e",
      "text": "COVID-19 vaccines have caused as many deaths in young people as COVID-19 disease has."
    },
    {
      "id": "f0e557a3-c422-4388-81df-60332a604a31",
      "text": "A memorial plaque in Kyiv was destroyed."
    },
    {
      "id": "98d2a36d-e4c8-4788-be7b-251ef8ed3e69",
      "text": "Antarctica's perimeter is larger than Earth's circumference, proving Antarctica is an ice wall and the Earth is flat."
    },
    {
      "id": "f30c2aba-14a3-47f8-8eb3-31bf2697ec10",
      "text": "Kyiv deliberately caused a blackout in Moldova."
    },
    {
      "id": "8c2695a2-b90b-4d90-8cd7-4fd1a95e9915",
      "text": "The United States supported federalization of Ukraine."
    },
    {
      "id": "7f38bd49-2b61-4485-ad92-826f4622b98a",
      "text": "A RAND Corporation document shows the US planned to cause a conflict and an energy crisis in Europe."
    },
    {
      "id": "6a0b5371-4a1d-4a33-9cf2-6ed229397386",
      "text": "The Bucha atrocities, the chemical attack in Syria, and the White Helmets' rescue operations were staged by Western governments."
    },
    {
      "id": "d803c8a8-1959-4a78-9323-dac5106fa3c8",
      "text": "Zelenskyy expressed condolences and urged Turkey to supply Ukraine more aid."
    },
    {
      "id": "fa08c157-a681-4a26-b553-93c830dee2e0",
      "text": "The American Medical Association reversed course and authorized doctors to prescribe hydroxychloroquine for COVID-19 patients."
    },
    {
      "id": "09be098b-2ee2-4d5e-8bf2-c10d759502be",
      "text": "Oral contraceptive pills are the leading cause of polycystic ovary syndrome, and wild yam combined with castor oil cures polycystic ovary syndrome and uterine fibroids."
    },
    {
      "id": "a237951f-5603-4b3d-98f5-4530944e0799",
      "text": "Hundreds of children were killed to create COVID-19 vaccines."
    },
    {
      "id": "9f82b403-f37d-47ae-b12d-954966d567d8",
      "text": "A Ukrainian refugee drew a swastika in a British mall."
    },
    {
      "id": "067bb5eb-6d31-4dfa-8cbd-19615eed89ba",
      "text": "Receiving the Pfizer COVID-19 vaccine increases the risk of getting COVID-19."
    },
    {
      "id": "83761374-b6a9-40c4-8a0b-42763aea2d5e",
      "text": "Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins."
    },
    {
      "id": "a05b5678-a8bd-4b6c-80a4-7d6b295509ee",
      "text": "An American COVID-19 vaccine killed a Ukrainian serviceman."
    },
    {
      "id": "b921b051-537d-408a-a1eb-67b0ab77f0f0",
      "text": "The first AI-led peer-reviewed climate science paper confirmed that climate change is a hoax."
    },
    {
      "id": "ad77754d-a55d-4863-ab2b-c74d01f22f96",
      "text": "A Ukrainian airliner that was downed in Iran was controlled by the United States."
    },
    {
      "id": "5aabbe3b-4ee1-4cf5-a307-e5972d7d441a",
      "text": "Minors in Ukraine are eligible for military contracts."
    },
    {
      "id": "4849399f-d01a-4947-8d84-70e6370761b4",
      "text": "Kyiv expelled homeless people from the city for Eurovision"
    },
    {
      "id": "4672ae95-fe94-4529-992a-9bd9f2450237",
      "text": "Russia threatens Ukraine’s civilian population."
    },
    {
      "id": "50dc1fd1-29df-4667-a38c-9cca6c573245",
      "text": "The HPV vaccine increases the risk of developing cervical cancer."
    },
    {
      "id": "4bce2060-09d4-4098-b63b-f9dc678c472b",
      "text": "A missile serial number confirms that the Kramatorsk train station was hit by a Ukrainian Tochka‑U missile."
    },
    {
      "id": "e1b163ae-328d-4f1c-8421-612b4cb01a03",
      "text": "Ukraine's Parliamentary Speaker calls for a new Maidan."
    },
    {
      "id": "41762dec-9af9-454b-a084-74fdb6d5933e",
      "text": "Ukraine threatened Russia with war."
    },
    {
      "id": "f991e96c-ee58-44c3-8da5-9f2e65dff516",
      "text": "Terrorists were arrested in Crimea."
    },
    {
      "id": "c0397fd6-d957-4664-938f-51c149f52869",
      "text": "Fitch issued a disappointing forecast for Ukraine."
    },
    {
      "id": "cb5c1d3f-6abb-4d7c-9539-5794000724f8",
      "text": "A Ukrainian plane was shot down in Iran because it carried Iranian nuclear physicists."
    },
    {
      "id": "20b20009-55af-45e1-ad7a-f77568f0d0ec",
      "text": "Poland blocks cargo transports from Ukraine to Europe"
    },
    {
      "id": "d8927e01-bf42-48d9-87be-c2a1007db420",
      "text": "The government of Ukraine refuses to respect human rights in the southeast of the country."
    },
    {
      "id": "366f952c-f98a-4fa4-91bd-ea7fc8f9828f",
      "text": "The President of Poland called for the return of Ukrainian territory to Poland."
    },
    {
      "id": "07e907bf-4736-4110-94d6-ad50986f0520",
      "text": "A Ukrainian activist called the September 11 attacks \"God's punishment for Americans.\""
    },
    {
      "id": "abc78ee6-9a74-4c31-b3fa-aaf984c98e07",
      "text": "Women are not warned that their daily steroidal hormone pill causes blood clots."
    },
    {
      "id": "457886fa-6643-4453-924e-55c6694e6c9a",
      "text": "Measles prevents cancer and provides long-term health benefits."
    },
    {
      "id": "a322dc3b-9865-4443-be3c-f9fdea386fe7",
      "text": "Ukrainian military beat Andrey Makarevich at a concert in Kharkiv."
    },
    {
      "id": "1771bf97-ae85-40bb-8e02-f07fe11ffe91",
      "text": "Polish students attacked a Ukrainian schoolgirl."
    },
    {
      "id": "6a58e3a8-8d21-459e-b42f-19871735ddae",
      "text": "Ukrainians demanded ransom from the family of a deceased Hamas hostage."
    },
    {
      "id": "6c5a5880-c721-4166-84f9-b9f10b46d797",
      "text": "A South Korean study found that COVID-19 vaccines increase the risk of cancer."
    },
    {
      "id": "a08d6e56-7f7e-47cf-81de-e8122a610abd",
      "text": "Ukraine exported grain to Western countries and did not export grain to needy African countries."
    },
    {
      "id": "ad7a9f0d-ae4f-40bf-bf11-ecd7d8e1a2cf",
      "text": "Most Ukrainians consider the Donbas conflict a civil war."
    },
    {
      "id": "37581388-5272-4892-bce8-93f42575e2da",
      "text": "Coronavirus spread rapidly worldwide in October 2019."
    },
    {
      "id": "420426ac-d677-4e71-9409-3c580a810304",
      "text": "The European Union no longer trusts NATO or the United States."
    },
    {
      "id": "51c31872-6c22-496d-8db0-350086738cc9",
      "text": "Ukraine is preparing a Bucha-style provocation using Supernova Airlines passengers."
    },
    {
      "id": "9da039ab-cd2c-4ac1-92f9-5bb3b0ac032e",
      "text": "The European Union seeks to improve relations with Russia at any cost."
    },
    {
      "id": "0853fabd-817d-4700-8463-b223b3d9a9a3",
      "text": "The Pfizer COVID-19 bivalent vaccine increases the risk of stroke."
    },
    {
      "id": "551f6a3f-7ee1-4220-9218-10240e4e6736",
      "text": "Tillerson said the United States will recognize Crimea as Russian if specified conditions are met."
    },
    {
      "id": "2b1cccb7-07df-443d-b883-4aeab0541083",
      "text": "Kyiv forcibly drafted ethnic Hungarians."
    },
    {
      "id": "b64b0df8-d092-4873-b18e-8ee940b1188f",
      "text": "The Lviv Jazz Festival was cancelled due to uncollected garbage."
    },
    {
      "id": "dd28c9e1-3524-4de6-bbf3-2db2158124db",
      "text": "Covid-19 vaccine effectiveness fell from 100% to 20%; early reported vaccine effectiveness figures were lies."
    },
    {
      "id": "b3fb1932-a775-4fed-9c1c-8d700ed98f3c",
      "text": "Renewable energy is not green: by 2050, 78 million metric tonnes of solar panels will reach end of life and cannot be recycled."
    },
    {
      "id": "24fda3b8-a767-431b-a557-22af840dd04f",
      "text": "Arseniy Yatsenyuk sided with the Right Sector in the Zakarpattia Oblast conflict."
    },
    {
      "id": "311bd324-53e2-40c0-a0e9-129aa64d4542",
      "text": "Ukrainian President Volodymyr Zelensky calls for a preemptive nuclear strike on Russia."
    },
    {
      "id": "394b3ed1-93cf-4622-86bd-45daf5632dfc",
      "text": "Islamic radicals are flocking to southern Ukraine."
    },
    {
      "id": "4f28cf1b-eeb4-4f98-9d72-3d16d8a364ab",
      "text": "Andriy Parubiy was behind the Maidan shootings, the Odessa Trade Union arson, and the Ukraine coup."
    },
    {
      "id": "7cce2a59-de6c-45b5-9890-bb26bd782446",
      "text": "Documents show Crimea belongs to Russia."
    },
    {
      "id": "84180699-3401-4067-a323-c18de91df8a0",
      "text": "Eating onions cures RSV and makes you sleep at night."
    },
    {
      "id": "ffad9e9c-f463-432b-922c-b04a447efd4c",
      "text": "The Ukrainian authorities demand the extradition of an EU Member of Parliament."
    },
    {
      "id": "6bb78db7-bfa8-4e89-a5a4-231579174345",
      "text": "The exact same group of experts who claimed there was global cooling in 1977 now claim there is global warming."
    },
    {
      "id": "540ecfcd-d63c-4a16-8fc4-99bed69936b7",
      "text": "The CDC admits that being fully vaccinated does not protect against the Delta variant and increases infections."
    },
    {
      "id": "76d3150d-566a-437c-a07b-ba31f7754271",
      "text": "An FDA study found vaccines made in living cells are contaminated with hidden viral fragments that cause cancer."
    },
    {
      "id": "04565754-2efa-4a04-ad4f-47a3b69df633",
      "text": "Poland recognizes Crimea as part of Russia"
    },
    {
      "id": "45988828-987d-41f9-9910-a69e0b6b266c",
      "text": "Bill Gates is pumping mRNA into the food supply to force-vaccinate unvaccinated people."
    },
    {
      "id": "8184bdb0-d238-4442-b9e4-88964c551e5a",
      "text": "Ukraine refuses to claim custody of its prisoners of war held in territories occupied by Russia."
    },
    {
      "id": "f7f4494c-d23f-46bc-95ad-55e481020949",
      "text": "A Ukrainian general predicts Ukraine will lose control of the Sea of Azov and the Black Sea."
    },
    {
      "id": "8d0e5935-493d-40dd-86c0-2179f8a97908",
      "text": "Recent climate change is normal because past hot and cold periods occurred, and future climate change cannot be predicted because weather cannot be predicted accurately over days to weeks."
    },
    {
      "id": "d870ab1b-50ae-4474-a007-a3b3b7ede249",
      "text": "Official figures show mean global temperature declined over the past 10 years."
    },
    {
      "id": "665223ae-15a5-40d1-b029-3082c0364604",
      "text": "COVID-19 vaccines are causing a massive tsunami of COVID-19 hospitalizations and deaths through immune escape, and vaccine-induced immune dysregulation is turning COVID-19 into a chronic disease called long COVID."
    },
    {
      "id": "9faf8cdb-f734-4c8b-a184-83176178c4e1",
      "text": "European governments accuse Ukraine of flooding the EU with heroin."
    },
    {
      "id": "35a9dcf0-4cae-42aa-ad49-b78de8e6a2de",
      "text": "The Ukrainian Army deployed Polish soldiers to Donbas."
    },
    {
      "id": "76f38dc8-7183-4718-8907-c647e8fb8b2e",
      "text": "Mass COVID-19 vaccination caused the excess deaths observed through 2022."
    },
    {
      "id": "7a922f37-4c04-4b1a-939d-f05336063961",
      "text": "HAARP deliberately creates global-scale earthquakes, cyclones, floods, and snowstorms and deliberately attacks the world's citizens by telepathically influencing their thoughts with low-frequency vibrations."
    },
    {
      "id": "b156d810-c926-4b49-93be-bbd349028310",
      "text": "Zhytomyr city authorities called on residents not to oppose the Russian army."
    },
    {
      "id": "4c9db928-374c-4dd7-a717-f789724effe9",
      "text": "Cow milk contains the most relevant carcinogen ever identified and triggers cancer."
    },
    {
      "id": "c9c854e8-b4e4-4054-bf94-68d3c8d21c91",
      "text": "Gargling with warm salt water or vinegar eliminates SARS-CoV-2."
    },
    {
      "id": "0813d21f-b8a9-46d0-852c-e35d7a6b2107",
      "text": "Ukraine plotted the assassination of French President Emmanuel Macron."
    },
    {
      "id": "0f1302f3-58b6-4c74-b747-90a0f169b860",
      "text": "The Ukrainian hryvnia will collapse."
    },
    {
      "id": "6513150c-e717-4597-8bda-c069fd2ec66d",
      "text": "Poroshenko blocks visa-free entry of Ukrainians to Russia."
    },
    {
      "id": "78dd7176-866b-40c3-ac5b-ac8a56744bbe",
      "text": "Ukraine solicited funds to host Eurovision 2017."
    },
    {
      "id": "68058236-e8a0-4c0e-8ea8-4e9fbad8892e",
      "text": "US state governments have banned chemtrails, confirming that secret government programs use chemtrails to harm the public and the environment."
    },
    {
      "id": "021a2b2d-f94d-4d7f-a79b-98cc50562a16",
      "text": "COVID-19 vaccines are unnecessary because vaccinated people still get COVID-19 and are required to wear masks."
    },
    {
      "id": "94b7d2a0-309a-4377-b78e-9387cb60a617",
      "text": "COVID-19 vaccines are sexually transmitted to unvaccinated people, cause blood discoloration, and weaken the immune system."
    },
    {
      "id": "87fe6fe7-6741-4b4d-a004-7c63f9e8fc69",
      "text": "Robert Fico, Viktor Orban, and Aleksandar Vucic's approval ratings increased after their trip to Moscow."
    },
    {
      "id": "7a567ea2-81b6-420f-98b5-f699eaedb85a",
      "text": "Ukrainian troops killed a separatist defector."
    },
    {
      "id": "0fe90583-3a97-4b9a-b64f-8acba9619caf",
      "text": "Russia's war in Ukraine conforms with the UN Charter."
    },
    {
      "id": "1e7778f2-669a-4098-9803-8a2c8c4f2bda",
      "text": "Ukrainian President Volodymyr Zelensky will legalize Poland's seizure of Ukrainian territory."
    },
    {
      "id": "b55c0787-864a-4d79-bd3d-090b61e5f7d0",
      "text": "The Ukrainian cities Kharkiv, Mykolayiv and Odesa want to return to Russia."
    },
    {
      "id": "eed31450-13c7-4a12-a6f5-87c6bee4c1d2",
      "text": "A Ukrainian UJ-22 airborne drone was shot down over Kursk Province."
    },
    {
      "id": "96a1e432-163e-4821-8cba-d4b5417f9f48",
      "text": "Yulia Tymoshenko is planning a coup."
    },
    {
      "id": "8c55c063-c680-48b6-8ba6-64ac9886ba32",
      "text": "Antarctic sea ice is increasing to record levels; Antarctica is getting colder and its sea ice and ice cap are not melting."
    },
    {
      "id": "6ce85de8-d097-4553-8939-cddc44ac7afc",
      "text": "Electric vehicles are less environmentally friendly than combustion vehicles because their metal production causes greater environmental harm, and electrifying road transport simply shifts CO2 emissions from tailpipes to power plants."
    },
    {
      "id": "f5307467-deb6-4fd6-92d7-cd40b933d49c",
      "text": "Sea level rise predates human influence and has not accelerated."
    },
    {
      "id": "e31a626b-6477-4fd6-995b-cd4796ae7896",
      "text": "Ukraine secretly ceded its borders to the EU."
    },
    {
      "id": "61ef2b5e-ba4a-4387-b511-d95280b5758f",
      "text": "Cooking with aluminum foil causes Alzheimer’s disease and cancer."
    },
    {
      "id": "661405a4-20f3-45ba-9dcd-c6aabc7da03b",
      "text": "The Governor of Maine ordered restaurant staff to wear COVID visors shaped like dog cones."
    },
    {
      "id": "dd9c34d2-e328-404e-9262-ef8ba5e31c00",
      "text": "Ukraine’s Culture Minister falsified history and denied the Holocaust."
    },
    {
      "id": "b0760fb7-31e2-4253-a9e7-088762a7adf4",
      "text": "Alzheimer's disease existed 40 years ago, and cholesterol-lowering drugs and cholesterol-lowering diets cause Alzheimer's disease."
    },
    {
      "id": "a78f8423-7ff6-436b-bb86-b2d81950dba4",
      "text": "International observers accuse the Ukrainian military of committing genocide against civilians."
    },
    {
      "id": "ce8a9b13-d2ba-43a3-91ba-1e54add14e25",
      "text": "A Ukrainian soldier willingly joined separatist forces"
    },
    {
      "id": "37205a70-045d-45fb-a659-745be3a25f44",
      "text": "Prenatal ultrasound causes miscarriage and heritable genetic damage."
    },
    {
      "id": "936a910e-c127-46cf-854c-f9f45c4172c4",
      "text": "A rainbow flag was raised over Kyiv to replace Ukrainian values and falsify history."
    },
    {
      "id": "31cbe0ed-02e8-4c9d-98ea-753e0ab3babe",
      "text": "Kharkiv has no electricity while Kyiv sells surplus electricity abroad."
    },
    {
      "id": "a717a742-4cc5-408a-8a35-4286bff0e4e4",
      "text": "The 4 July 2025 Texas floods were caused by a dam release and no footage shows rain during the floods."
    },
    {
      "id": "864f721b-f058-4fa2-9aa7-84f986dd34c9",
      "text": "COVID-19 vaccines increase the incidence of heart conditions and cancer."
    },
    {
      "id": "ab03c143-5c30-4a99-9014-887c91d422e6",
      "text": "Acting Minister of Health bans antiseptics"
    },
    {
      "id": "3220bfc2-e818-4aa6-99e1-0fe729cee492",
      "text": "One in 1,000 children vaccinated against COVID-19 died from the vaccine."
    },
    {
      "id": "870b6aee-39e4-44ab-8369-c44251be45de",
      "text": "Ukrainian Orthodox Churches celebrate Halloween."
    },
    {
      "id": "f34accd5-1589-4a52-82fd-77643ec0941f",
      "text": "The CDC illegally inflated COVID-19 death counts by at least 1,600% by issuing NVSS COVID‑19 Alert No. 2, which shifted underlying causes from Part I to Part II of death certificates and reversed the 2003 certification guidance."
    },
    {
      "id": "a76fd6ba-7552-4af7-9c53-13e1dbf01800",
      "text": "The European Union is using new colonization methods to take control of countries."
    },
    {
      "id": "8eb3868f-1de4-4758-bcd9-776496ea6d87",
      "text": "Danish researchers found that COVID-19 vaccine protection against the Omicron variant became negative three months after the second dose."
    },
    {
      "id": "4b294b6e-1494-4eb8-ab32-b4e0af0ee624",
      "text": "Poroshenko said European armies are militarily superior to Ukraine’s armed forces."
    },
    {
      "id": "aa3f2dae-31fc-4d1e-85ee-711ed8179455",
      "text": "Raw manuka honey kills every bacterium scientists expose to it, including antibiotic-resistant superbugs."
    },
    {
      "id": "c2eb7027-7f02-4640-a1e8-3178709b3d6c",
      "text": "Flu vaccines contain ingredients derived from dogs."
    },
    {
      "id": "51da2545-3036-4376-9031-a272d71f4745",
      "text": "Russian specialists modernized the Kakhovka Hydroelectric Power Plant and increased its capacity by 30%."
    },
    {
      "id": "4b7146ae-eb62-46f7-a74d-dfb114e0c51a",
      "text": "5G at 60 GHz prevents the human body and blood from absorbing oxygen, and doctors describe this in COVID-19 cases."
    },
    {
      "id": "c433c64e-4d49-46b1-b558-2374391d828b",
      "text": "Roman Shukhevych’s bust from the destroyed Lviv museum was recycled into scrap metal."
    },
    {
      "id": "4babb15c-0432-4c14-a80c-8a89bb99daf4",
      "text": "Speaking foreign languages is prohibited in Latvia."
    },
    {
      "id": "c691c40b-0da2-4fba-8405-1d8ee2563aea",
      "text": "Ukraine issued maps that omit its temporarily occupied territories and its western regions."
    },
    {
      "id": "dfb119ab-0905-4f66-9996-9575684b6e27",
      "text": "Armenia resumed flights to Crimea."
    },
    {
      "id": "a84ae567-4401-4340-9020-62272d966ea8",
      "text": "Mucus is the cause of all diseases and soursop is 10,000 times more effective than chemotherapy at treating cancer."
    },
    {
      "id": "0016daed-4c8a-4f04-82a6-93d276191cf2",
      "text": "Raw milk and raw eggs are safe to consume and are more nutritious than pasteurised milk and cooked eggs."
    },
    {
      "id": "06c9eb45-978c-4b10-a3d5-4e009293d7c0",
      "text": "A pathologist reports that COVID-19 vaccination causes a 52% increase in cancer risk for people aged 15–59."
    },
    {
      "id": "c46387b0-beff-4ba1-b2f4-5f52c8f5f329",
      "text": "The Ukrainian Prime Minister called the people of Luhansk and Donetsk \"untermensch\"."
    },
    {
      "id": "2be2682b-3fcb-45ed-9120-9ffd003ad2e6",
      "text": "The UK prevented the UN Security Council from making a decision on Mariupol."
    },
    {
      "id": "81764a78-278d-4f62-87bb-53accd6c2144",
      "text": "80% of people who received the Moderna COVID-19 vaccine experienced significant side effects; children in Sudan contracted polio from the polio vaccine."
    },
    {
      "id": "88a2d097-7fb9-436a-bce9-304796f073e2",
      "text": "Cannabis use causes no deaths anywhere."
    },
    {
      "id": "0e3b3e82-2f17-47a0-b8a5-0911a030245e",
      "text": "Intravenous vitamin C kills cancer cells and does not kill healthy cells."
    },
    {
      "id": "84eab2ec-0421-4ec5-adde-98da233799c2",
      "text": "All coronaviruses, including those that cause SARS and MERS, are seasonal and always disappear on their own; ivermectin is effective for preventing and treating COVID-19; and COVID-19 vaccines are gene therapy that do not provide immunity or prevent transmission."
    },
    {
      "id": "b1cfeae3-7f20-4959-8338-5c2742e6739f",
      "text": "The pandemic was planned, and the respiratory illness surges in New York and China are caused by chlorine and benzene contamination in food and water, not by airborne transmission."
    },
    {
      "id": "1068b99b-afa6-4480-a25b-e2729c14f279",
      "text": "A Ukrainian journalist arrested in Russia is a spy."
    },
    {
      "id": "3970be47-9533-41fa-9996-110c725cf92e",
      "text": "Volodymyr Zelenskyy launders Western aid through United Arab Emirates bank accounts."
    },
    {
      "id": "cd5f2c50-555c-4b25-b9a8-384f188c664a",
      "text": "The clothing industry produces 10% of the pollution that drives the climate crisis."
    },
    {
      "id": "5a5e634f-a429-49c4-b8ef-cebfc06153b3",
      "text": "COVID-19 vaccines increase the risk of heart attacks."
    },
    {
      "id": "1658783f-c143-44c0-a0bd-d86a2d59e278",
      "text": "Russian army destroyed Ukrainian troops who raised the Ukrainian flag on Snake Island"
    },
    {
      "id": "b1b40546-ec71-46aa-9691-08e0f2e9b586",
      "text": "Ukraine will dump the remains of a Soviet-era general."
    },
    {
      "id": "46604d93-2806-448b-8c25-c7363eb20a06",
      "text": "Organs of Ukrainian soldiers are extracted and sold."
    },
    {
      "id": "86207384-0583-4a85-80f9-90268d07f502",
      "text": "UNICEF payments require registration on Viber and Telegram."
    },
    {
      "id": "942531b4-dec6-433b-a397-2a34822a7db2",
      "text": "People in France protested after President Macron announced he would send French troops to Ukraine."
    },
    {
      "id": "c58cca54-9dbf-4739-a076-57ed426b15fb",
      "text": "Carbon dioxide does not cause global warming; observed warming is caused by the Sun; CO2-driven ocean acidification and CO2-related harm to polar bears are not occurring."
    },
    {
      "id": "6c3e9aeb-75f0-4a81-a3c6-6ccb162d3595",
      "text": "Adding more carbon dioxide to the atmosphere is beneficial and carbon dioxide does not cause the Earth to warm."
    },
    {
      "id": "9c2af4b3-f21e-41ba-84e3-147806af306b",
      "text": "Injured parishioners from a fight in Cherkasy were denied medical treatment because of their religious affiliation."
    },
    {
      "id": "36370dfa-344e-42cd-b175-35522618f57b",
      "text": "Crimean Tatars owe gratitude to Stalin."
    },
    {
      "id": "94a437c0-a658-4ee1-ba24-09607845efac",
      "text": "Fluoride is a neurotoxin that causes lower IQ in children, causes thyroid dysfunction, and causes reduced bone density."
    },
    {
      "id": "8f9adad7-7268-42d1-8052-67cf463f8936",
      "text": "baking soda cures cancer"
    },
    {
      "id": "46a0c3b9-3856-4db1-a886-180abac23d55",
      "text": "European leaders are considering Russia's plan for the Eastern Ukraine conflict."
    },
    {
      "id": "8013c6f5-a136-41c4-87cb-8d5e885b05d2",
      "text": "Video shows an explosion on the road to Komsomolske."
    },
    {
      "id": "84e31776-201e-4b09-8fa4-f3c1b0a1c99f",
      "text": "GRU forces were exchanged for Ukrainian security officers."
    },
    {
      "id": "17b8e47c-1760-47a5-b51b-ebd91629693d",
      "text": "A new paper proves Covid-19 mRNA vaccination rates are linked to increases in overall deaths."
    },
    {
      "id": "373b210c-8381-4d76-84d2-0517d2a5fae1",
      "text": "Taking Truvada protects against HIV and does not increase the risk of kidney or bone problems."
    },
    {
      "id": "b0e88103-9182-428d-a786-fd65d7cfc76a",
      "text": "Only 6% of the 153,504 recorded deaths were caused by COVID-19; the other 94% died from other serious illnesses."
    },
    {
      "id": "dc18ed86-33df-41ba-9de2-a0ec4e7462b8",
      "text": "Poroshenko was drunk and gave a soccer ball to a legless soldier."
    },
    {
      "id": "af9b140e-b5b6-4c11-8276-f58139175533",
      "text": "The FDA admitted young children are at a significantly elevated risk of seizures after receiving the COVID-19 vaccine."
    },
    {
      "id": "64fc6ae9-27d6-47aa-83ce-0abdfc9c3126",
      "text": "Belarusian protesters were paid to demonstrate."
    },
    {
      "id": "6616e213-4d96-4494-8c81-5d7ef80cfe7a",
      "text": "Ukraine is demolishing and desecrating Red Army soldiers' monuments."
    },
    {
      "id": "51e7f666-0050-488c-9d20-f9c3d4e7a675",
      "text": "Volyn and Vinnytsia have seceded from Ukraine."
    },
    {
      "id": "183d0198-9ef2-4007-8324-b1d156ee1306",
      "text": "Birthmarks indicate a person has MTHFR mutations, and people with MTHFR mutations have increased risk of vaccine reactions because they cannot detox toxins from vaccines."
    },
    {
      "id": "9a96fcb7-3f24-461c-abff-40ee26d60bbd",
      "text": "Ukraine bans conscripts from enrolling in universities."
    },
    {
      "id": "5d6e3c65-5625-42fb-9762-29770ac69d70",
      "text": "WHO stated asymptomatic spread of COVID-19 is very rare, therefore physical distancing and face masks are unnecessary."
    },
    {
      "id": "416a7f2f-5a8f-4b2e-af1a-ed544ee6262c",
      "text": "Moderna covered up mass heart attacks among toddlers in COVID-19 vaccine trials."
    },
    {
      "id": "b3ad4cab-a5e0-4720-b764-876a113500e2",
      "text": "The majority of IT specialists left Ukraine."
    },
    {
      "id": "4289d0aa-4385-4d1f-b208-ed86b86771c5",
      "text": "Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, which kills viruses including SARS‑CoV‑2."
    },
    {
      "id": "abebfc28-65a2-45e1-8d3d-74cba4088fc5",
      "text": "The UN Security Council refused to support Ukraine."
    },
    {
      "id": "c7a05342-7ea2-482a-ae7d-a4773af7eb46",
      "text": "Underage refugees tore down the Ukrainian flag from a school near Kyiv."
    },
    {
      "id": "bb5ea732-fc0b-42e6-915e-dc5845af26a0",
      "text": "Video footage shows a giant tree stump in Antarctica that grew when Earth's climate was warmer."
    },
    {
      "id": "11ebb2bc-c822-40ef-9a48-f56030baf816",
      "text": "The Sun and Charlie Hebdo reported that Angelina Jolie was extorted in Ukraine."
    },
    {
      "id": "12585130-a603-4a16-af27-1e1fcce40159",
      "text": "All privileges and compensations in Ukraine have been abolished."
    },
    {
      "id": "bfb2d618-fbdd-4aa4-9ec8-fd066b137ccf",
      "text": "NATO troops entered Donbas"
    },
    {
      "id": "3c9d6334-c309-4acf-95f8-b5d5e69ba433",
      "text": "90% of the world's glaciers are growing."
    },
    {
      "id": "3bdd3464-3b56-41c5-b23f-c9175e8cb79a",
      "text": "The U.S. CDC recommends that children receive a COVID-19 flu shot."
    },
    {
      "id": "4a490611-8667-498f-b795-aa3c60360577",
      "text": "Sea level rise does not depend on ocean temperature or CO2."
    },
    {
      "id": "f58640de-8679-4344-8e02-c81e2d56cf3e",
      "text": "Ukraine established a new public holiday called \"Day of the Avenger\"."
    },
    {
      "id": "7f2f4983-adf6-4346-8154-b7de3cf8139d",
      "text": "COVID-19 vaccines will force continued mask-wearing and physical distancing and will keep restaurants, pubs, and cinemas closed."
    },
    {
      "id": "ad0bb58c-bd77-4852-ab78-fc14a7ada568",
      "text": "USSR symbols were projected on the Brandenburg Gate in Berlin."
    },
    {
      "id": "e59b958a-d4b1-4c92-a490-dad0c9ad6b85",
      "text": "Bloomberg announced that giant deposits were found in Crimea."
    },
    {
      "id": "65aeed1b-3262-431e-a71d-2bd16f74bba2",
      "text": "A pill that combines more than 60 natural herbs cures COPD in three days."
    },
    {
      "id": "a8d3b3f2-8f28-4997-b8fb-d356c28fc9fd",
      "text": "In children, COVID-19 causes lower mortality than influenza and the same rate of severe disease or hospitalization as influenza."
    },
    {
      "id": "d41000c9-686d-42f9-a48c-6ec348be7bfb",
      "text": "Depression is defined by low serotonin; low serotonin means a person is depressed."
    },
    {
      "id": "96fb4452-25bd-4554-b732-f23f41adbf38",
      "text": "Ukraine will sign security agreements with the United States only if the United States gives Ukraine money."
    },
    {
      "id": "ccfeabe0-28f9-4439-a265-f75474b223dd",
      "text": "OSCE confirms the Ukrainian army shelled Donetsk."
    },
    {
      "id": "4b4a656e-4325-448c-8c08-e151c7fbb241",
      "text": "COVID-19 vaccines have caused 21,000 cases of myocarditis and the number is climbing; young people should never receive these vaccines."
    },
    {
      "id": "b4bcb059-a88f-4ecc-afc9-4a8ffb58deaa",
      "text": "COVID-19 vaccines are 98 times more harmful than SARS-CoV-2 infection."
    },
    {
      "id": "d7982fd2-b552-45b9-9ac6-e7c2c5fc0916",
      "text": "Vaccines contain unhealthy levels of aluminum, and Japan eliminated vaccines and infant mortality decreased."
    },
    {
      "id": "db4562b0-997d-4fbf-9616-cd9cc79f842d",
      "text": "Babies under six months must not drink fluoridated water because their blood-brain barrier is not fully formed until six months of age."
    },
    {
      "id": "843ad762-b206-4f47-b606-70a915950b5e",
      "text": "Ukrainian President Volodymyr Zelenskyy is faking blackouts to secure more aid from European countries."
    },
    {
      "id": "4644bce0-c9cd-4728-a3ac-eeedce4ddcfa",
      "text": "Covid-19 vaccines are ineffective because the majority of COVID-19 deaths occurred among vaccinated people."
    },
    {
      "id": "a3f09e08-ba96-48b9-8cf5-2e23612fc92a",
      "text": "Serbian Defense Ministry says Euromaidan was a coup."
    },
    {
      "id": "04201b64-11b5-4a5b-ab03-c26dfe98eaa0",
      "text": "There are no Russian troops in Donbas."
    },
    {
      "id": "f1d4fcbb-0069-4d08-a24e-77e962a05585",
      "text": "Foreign Policy used its banner to promote a pro‑Russian story."
    },
    {
      "id": "3381dd29-87a6-4bc8-96d1-4fdace7560cc",
      "text": "The FDA says doctors can prescribe ivermectin for COVID-19."
    },
    {
      "id": "96f1b602-4d0b-49a5-b639-456163508b1d",
      "text": "Brussels falsifies and rewrites European history."
    },
    {
      "id": "020f8349-87b4-471e-aa33-4627090a42ce",
      "text": "Marchers in Kharkiv chanted \"Death to Russians.\""
    },
    {
      "id": "96c1386f-d62f-4eb4-9546-ab7c52e088cb",
      "text": "5G technology caused the coronavirus outbreak."
    },
    {
      "id": "63151421-595c-49e6-97f2-2451fc80eaf1",
      "text": "Dr. Anthony Fauci acknowledged that large numbers of positive COVID-19 cases were caused by oversensitive PCR tests detecting noninfectious viral fragments, resulting in many false-positive results."
    },
    {
      "id": "92cb575c-b924-4e40-9aba-517d60cb2e8e",
      "text": "One million people in the U.S. have died from COVID-19."
    },
    {
      "id": "f74c9c19-08b5-4767-85e3-bdd2b04e897e",
      "text": "European Parliament found that Russia does not sponsor terrorism."
    },
    {
      "id": "54f31316-749c-45c5-a935-bcbfe6582195",
      "text": "Ukraine handed military draft notices to minors."
    },
    {
      "id": "f84fbb9e-84ba-43ed-9a8e-58d0df3a265d",
      "text": "Ukraine will force residents of Crimea and Donbas to repent."
    },
    {
      "id": "6a9a5709-418b-4dab-8b4e-1380b6e2fee5",
      "text": "The US lost 90% of the weapons it supplied to Ukraine."
    },
    {
      "id": "fdf418a5-239c-4a3b-84f1-ccb5c655dfc1",
      "text": "A women's battalion consisting of females aged 16 to 30 was announced in the Chernihiv region."
    },
    {
      "id": "7d057666-c938-4ff2-9b34-b005972c9385",
      "text": "Ukraine is selling stale leftover bread because of bread shortages."
    },
    {
      "id": "ac2c8b74-62cc-436f-8f86-38c3f3214c51",
      "text": "Higher COVID-19 vaccination rates among White people are associated with higher COVID-19 death rates."
    },
    {
      "id": "990c66a4-8474-4ba5-a743-ec1d7ae76287",
      "text": "The Czech Republic supplied tanks to Ukraine."
    },
    {
      "id": "2bcb6263-41a2-4b19-a182-585c686a8b0b",
      "text": "Ukrainian soldiers were ordered to shell peaceful villages."
    },
    {
      "id": "71668436-2847-4d3d-9e3e-60442f2829ae",
      "text": "Abortions are never medically necessary."
    },
    {
      "id": "fb5985fd-da02-40bd-9b2e-973038f62427",
      "text": "Ukraine has no heating and is operating public warming centers."
    },
    {
      "id": "a20f5161-5da8-4019-a84b-b9d70eb9e2ad",
      "text": "Volunteers are getting rich from the war in Eastern Ukraine."
    },
    {
      "id": "bc09529a-9338-422a-b1ed-4aed6227f9f8",
      "text": "Coconut oil treats and prevents Alzheimer's."
    },
    {
      "id": "94baf93b-4cca-44d7-a782-b5c3d2894ba2",
      "text": "Ukraine announced a new foreign policy toward Africa."
    },
    {
      "id": "f0946bc1-4e64-4617-a24a-fe963016e054",
      "text": "The United States will bomb Siberia according to a Ukrainian plan."
    },
    {
      "id": "623ba596-2602-4da0-b167-c51bd2531534",
      "text": "COVID-19 vaccines' spike protein binds to and irreversibly alters human DNA, the vaccines contain multiple lipid types never before injected into humans, and the vaccines have caused 12,000 deaths."
    },
    {
      "id": "a263f78b-e32d-482d-91ed-81deca9f04d3",
      "text": "Ukraine deceptively recruits South Africans."
    },
    {
      "id": "fe87c798-bb32-461b-8114-2f55d8ef06a3",
      "text": "A toxin found in coffee attacks the bladder and kidneys and causes cancer."
    },
    {
      "id": "e9dbfbe6-3daf-4d0e-88d0-22294b85c258",
      "text": "Ukraine's Foreign Ministry acknowledged that Crimea is permanently lost to Ukraine."
    },
    {
      "id": "0ea03c18-e531-413a-afc8-9fd758a13242",
      "text": "Ukraine revoked the Geneva Conventions."
    },
    {
      "id": "8cce7f5b-945c-4ca6-9592-46c32642f963",
      "text": "Aircraft-dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth's life support systems."
    },
    {
      "id": "c1e740d7-b80f-476e-9d43-8800d71b253b",
      "text": "Peanut oil in vaccines causes peanut allergies."
    },
    {
      "id": "de4a5845-e616-46de-8e18-2ccf4891c7af",
      "text": "The US banned Ukraine from buying the Russian vaccine and is testing its own vaccine on Ukrainians."
    },
    {
      "id": "ec7ab2fc-d2bf-4dc4-af4a-6a78a161b65c",
      "text": "The Pentagon says the U.S. will no longer provide HIMARS and missiles to Ukraine."
    },
    {
      "id": "ada738ce-b6fe-4f78-8507-95e1190b547f",
      "text": "It took 15 years to uncover Chantix’s carcinogenic effects, and Chantix was not approved or confirmed safe during its first 12 months on the market."
    },
    {
      "id": "f36a0cb4-ca00-46f0-babd-8371f6eaf1cd",
      "text": "A South African scientist successfully removed HIV from a sperm cell in a laboratory."
    },
    {
      "id": "dccb2688-1856-4a1a-87b7-4ee0424e01e4",
      "text": "Excess deaths in late 2022 exceeded the pandemic peak and were caused by COVID-19 vaccines."
    },
    {
      "id": "9b394eca-d05c-4ddc-9dd1-294a8cfe08dc",
      "text": "Ukrainian ancestors dug up the Black Sea."
    },
    {
      "id": "a9395453-3f62-4979-b184-b9574fed4e44",
      "text": "France will lift sanctions on Russia."
    },
    {
      "id": "4c740324-ff57-4648-8ed7-61327f6ce31c",
      "text": "Ivermectin sterilizes 85% of men who take it."
    },
    {
      "id": "c5d25191-6901-47c5-8d4c-636d712c9cf5",
      "text": "The United States has a better handle on COVID-19 than Europe, and COVID-19 is less deadly in the United States than in most European countries based on case fatality data."
    },
    {
      "id": "1ae70a9e-9821-41e3-b84e-86b6e5ca8240",
      "text": "A review of autopsy cases found that 74% of deaths were caused by COVID-19 vaccines."
    },
    {
      "id": "9f0ea2b0-c156-4bc5-92af-b04cb04a02cd",
      "text": "WHO says a child's presence at school alone constitutes informed consent for vaccination."
    },
    {
      "id": "7b39a91e-e20e-432f-b965-c4698ab22ff3",
      "text": "Environmental laws cause California wildfires to be much worse by preventing massive amounts of available water from being used and diverting that water into the Pacific Ocean."
    },
    {
      "id": "3f63c72c-b008-41e9-907a-65aca35610bf",
      "text": "Sunscreen causes cancer and the sun does not cause cancer."
    },
    {
      "id": "b732d76a-2b06-4284-abcd-bc387bc8c1cd",
      "text": "Massive volcanic CO2 emissions discredit the theory of global warming."
    },
    {
      "id": "8c4e7ac4-8c04-46c3-a97d-e48934a16af6",
      "text": "An international medical crisis is occurring because COVID-19 vaccines are causing widespread diseases and deaths."
    },
    {
      "id": "8f22e45c-5446-4628-8451-99e1ca4e880b",
      "text": "Scientists predict 6 billion people will be slaughtered or starve to death this century."
    },
    {
      "id": "c4677d1e-9db7-4190-9924-793e642c8435",
      "text": "COVID-19 vaccine recipients are not eligible to donate blood."
    },
    {
      "id": "7af3c507-526a-45ce-b2dd-61b801d21fe0",
      "text": "The HIV VB variant is highly infectious and makes people ill twice as quickly."
    },
    {
      "id": "96500fb1-16ab-4e8f-b6c7-c35d72fd2de1",
      "text": "France jails citizens for questioning or opposing mRNA vaccines."
    },
    {
      "id": "a18aa87f-3a29-4776-85db-d25a86cbd228",
      "text": "Ukraine establishes maritime borders only by recognizing Russia’s annexation of Crimea."
    },
    {
      "id": "17298b54-7092-46ee-9c28-4acf297ff748",
      "text": "A Russian drummer from the band Metal Corrosion was forced to serve in the Azov Battalion."
    },
    {
      "id": "f57e9765-ae8c-4cb1-a9bd-02639581ef21",
      "text": "Deaths reported to VAERS after vaccination are caused by the vaccine."
    },
    {
      "id": "3ac795c8-d51c-4298-a87b-214912d9d6b4",
      "text": "Ukraine's currency market will collapse without transfers from Russia."
    },
    {
      "id": "52466996-0059-4953-98fa-5cedb078c1c3",
      "text": "Regenerative agriculture improves soil health more than conventional agriculture."
    },
    {
      "id": "2104bd63-b9b4-4456-a8b8-646d0cb147b4",
      "text": "A review found that COVID-19 mRNA vaccines aid cancer development."
    },
    {
      "id": "d4c15268-dd03-4bb9-b579-ad2e9d197f56",
      "text": "Polish company ASBS Othago is fighting alongside the Ukrainian military forces."
    },
    {
      "id": "62956cb9-8b3c-4684-8727-ab704ca7a45f",
      "text": "Climate change is not new and climate change is not caused by humans."
    },
    {
      "id": "e22e1484-240f-4364-bef2-27197cbab294",
      "text": "Kyiv's electronic warfare forced Russian drones off course into Poland."
    },
    {
      "id": "a7644128-356d-426d-a72f-e9ccaca044fc",
      "text": "Ukraine has banned the Belgian Foreign Minister from visiting Ukraine because he visited Crimea."
    },
    {
      "id": "58ea73c6-2eeb-4934-a39e-bd6e1d791d97",
      "text": "In the 1980s–1990s people died from the antiretroviral drug AZT instead of from HIV/AIDS, and Anthony Fauci pushed AZT as the treatment."
    },
    {
      "id": "aee737c4-a386-4460-bb22-c9a90c10bad3",
      "text": "Nearly 90% of Odesa residents like Russia."
    },
    {
      "id": "a87006c6-a37e-44aa-b418-b90844e6d18e",
      "text": "Ukrainian soldiers wore Russian uniforms in Donbas."
    },
    {
      "id": "03bbf6a8-e994-47e1-93e4-0c1992c89568",
      "text": "Ventilators, not COVID-19, caused the deaths of hospitalized COVID-19 patients."
    },
    {
      "id": "2cb20498-f180-4af4-8f9a-817025296a86",
      "text": "COVID-19 vaccines caused an increase in abnormal blood clots observed by embalmers."
    },
    {
      "id": "641375ef-beb6-46e7-80af-90bdb12b074f",
      "text": "Russian militant Motorola was killed by a Latvian mercenary."
    },
    {
      "id": "6b595781-d1d6-4ca0-bb23-9a044256b930",
      "text": "Crimean Tatars asked Turkey to recognize Crimea as part of Russia."
    },
    {
      "id": "45022a65-88e8-4eff-9ed7-e9aed1e85ba0",
      "text": "Side effects of the HPV vaccine outweigh its benefits."
    },
    {
      "id": "64c2f63a-56d2-46e0-8abe-ff40035acd85",
      "text": "Ukraine boycotts the Paralympics."
    },
    {
      "id": "02f2861c-459c-420a-8105-6710bb5b977e",
      "text": "NATO confirmed Russia is fighting in Ukraine at reduced strength."
    },
    {
      "id": "6b3d7248-ead8-4f23-88a2-6645c651cbe1",
      "text": "The FDA admitted young children are at a significantly elevated risk of seizure after taking the COVID-19 vaccine."
    },
    {
      "id": "a2d9f955-833e-494f-a522-8983dbe3a28d",
      "text": "The European Parliament accused Petro Poroshenko of causing a church schism to win the election."
    },
    {
      "id": "3e03a02d-349b-468f-a5cb-ed740d95b05f",
      "text": "Polish and British special forces fought in Ukraine from the first days of the Russian invasion."
    },
    {
      "id": "05f5fec2-3369-489b-a94e-b9bfcc251a1a",
      "text": "Oil and gas are renewable energy sources produced by a geothermal reaction between the solid mantle and liquid core; hydrocarbons form in the upper mantle, migrate through deep faults, and are deposited throughout Earth’s crust in any rock type and structural position."
    },
    {
      "id": "a2c7b8dd-50cb-426b-9bcc-a31227a8ca85",
      "text": "Russian military captured German PzH 2000 howitzer"
    },
    {
      "id": "4ccc6622-0ab3-4807-aa62-fd81cd5dca86",
      "text": "More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades."
    },
    {
      "id": "62c4c72d-70a2-472c-bcf3-193476bc0f15",
      "text": "Spanish media call the Ukrainian coat of arms ultra‑nationalist and paramilitary."
    },
    {
      "id": "6d70a893-521c-400e-9941-96785e5ad0d0",
      "text": "There will be herd immunity to COVID-19 by April because 55% of Americans have natural immunity."
    },
    {
      "id": "f24622db-4923-411c-8797-144755e2de66",
      "text": "U.S. doctors found that 70% of long COVID cases developed after COVID vaccination, not after infection."
    },
    {
      "id": "7aefc389-9540-4437-951c-1c190167095e",
      "text": "A Harvard study confirms fluoride reduces children’s IQ."
    },
    {
      "id": "9a562a62-374e-4b09-bfd6-4b09c8d58a93",
      "text": "Marijuana is not addictive, cures cancer, and causes brain cells to grow."
    },
    {
      "id": "23833acc-ceea-47bd-89ec-81ece2ea7dee",
      "text": "Ukraine used video game footage as evidence in its ICJ suit against Russia."
    },
    {
      "id": "3257e97d-7af3-4599-9280-a8ece0196021",
      "text": "Ukrainian general kneels before the former US ambassador"
    },
    {
      "id": "8ef4bf67-7cd6-4006-b358-4c34fa1cfbbb",
      "text": "A Ukrainian missile destroyed an apartment building in Kyiv."
    },
    {
      "id": "131a2710-8ce1-4c28-8d5f-38b1e00f7315",
      "text": "Russian forces destroyed an all-female unit of the Ukrainian Armed Forces."
    },
    {
      "id": "58ae0f5c-42dd-4e1d-ba86-398feb744cc4",
      "text": "The daughter of the SSU head organizes howitzer shooting tours."
    },
    {
      "id": "74f6adc8-d3ea-49aa-b8f3-a2bf36a09897",
      "text": "Ukrainians were drafted into volunteer battalions in Israel."
    },
    {
      "id": "75db5fa6-073a-44c0-8965-caf7b4deed7f",
      "text": "A police officer confirmed that 10 civilians were killed in Donetsk."
    },
    {
      "id": "2568521e-8586-4e71-a3a6-e54c9dd1a93c",
      "text": "U.S. Ambassador to Russia laid flowers with blue and yellow ribbons at the scene of Nemtsov's murder"
    },
    {
      "id": "b4bf2eab-e1d3-47f5-90d7-b582087895ba",
      "text": "American mercenaries are operating in Donetsk."
    },
    {
      "id": "a9d4fbc8-c8c7-4d93-957c-cec78f52d3c8",
      "text": "Fluoridated toothpaste is deadly to children and fluoride causes dental fluorosis, cavities, and cancer."
    },
    {
      "id": "a0501e70-1977-4522-a0ee-e76a259691cf",
      "text": "Cayenne pepper is the most powerful blood thinner."
    },
    {
      "id": "7754c771-cbbb-477b-9075-d667f3ca2060",
      "text": "Yatsenyuk says Galicia was illegally annexed."
    },
    {
      "id": "5170b10e-8ae5-472a-b8b4-865fceabeaa5",
      "text": "Masks prevent influenza but fail to prevent COVID-19; influenza cases were largely renamed COVID-19."
    },
    {
      "id": "f28d8885-754e-4856-b649-c6bea110441f",
      "text": "Arctic sea ice and polar icecaps are melting at unnatural rates and this melting constitutes evidence of human-caused climate change."
    },
    {
      "id": "c42dccc6-9330-4981-81a9-d16c8ca59174",
      "text": "82% of Czechs believe Malaysia Airlines Flight MH17 was shot down by the Ukrainian army."
    },
    {
      "id": "901f433b-f0f3-454c-aedd-2757b0e01baf",
      "text": "German tanks painted with Nazi symbols are being transported to Ukraine."
    },
    {
      "id": "ec769d42-4192-4ecf-9491-4cc677a2a64f",
      "text": "No COVID-19 vaccines were FDA-approved and available in the United States as of May 2023."
    },
    {
      "id": "f0bc4708-3024-458f-b26b-a56e742362e9",
      "text": "Kolomoiskii's enforcers beat and kicked soldiers' mothers from Western Ukraine with sticks."
    },
    {
      "id": "29dc0b96-e0bf-42bc-8a57-0ede89709852",
      "text": "Photos show descendants of Banderovits committing atrocities."
    },
    {
      "id": "44f198c1-f272-49a0-a145-49eb04b378f7",
      "text": "Japan officially named COVID-19 mRNA vaccines the most deadly drug in human history."
    },
    {
      "id": "2636aef0-bc84-44ab-a740-8e82aac9565b",
      "text": "The HAARP facility deliberately creates global-scale destruction — earthquakes, cyclones, floods, and snowstorms — and attacks the world's citizens telepathically by influencing their thoughts with low-frequency vibrations."
    },
    {
      "id": "6845238d-ffa0-480e-ad20-dc70bd916dfb",
      "text": "The Polish ambassador wants a Yugoslav-style breakup of Ukraine."
    },
    {
      "id": "af026343-e2e0-4e95-af43-802e830830dd",
      "text": "Sauna bathing detoxes the body by causing sweating."
    },
    {
      "id": "f8e8a37e-6a86-4071-8a46-c17486c6a426",
      "text": "Barack Obama accuses Ukrainian authorities of committing genocide."
    },
    {
      "id": "5e17f8d0-3190-4e64-9c88-7ecf86c72a4d",
      "text": "Biden said Ukraine is the most corrupt country in the world."
    },
    {
      "id": "4b246f2c-26cd-41f9-a527-6f1d6476d5cc",
      "text": "The Mykolayiv Shipbuilding Plant was cut up for scrap metal."
    },
    {
      "id": "e6d93d6d-3518-4400-b450-5f48fe896cec",
      "text": "NASA adjusted historical temperatures downward and recent temperatures upward, and those adjustments are responsible for most of the reported global warming."
    },
    {
      "id": "2a27e2da-beaa-497a-958c-527da5ef4335",
      "text": "90% of the world's coral reefs will disappear within 35 years due to coral bleaching caused by global warming, pollution, and over-development."
    },
    {
      "id": "d7b4f1b3-35c7-4658-9644-8fa6c89b17f2",
      "text": "ISW says that after Trump's election victory, the Ukrainian military surrendered more often."
    },
    {
      "id": "d07afc6c-f8bf-4950-9736-abb677633b8d",
      "text": "The UK visa center in Kyiv closed after Russian shelling."
    },
    {
      "id": "ac9c574b-d539-4fe7-8d70-6980324b0d5e",
      "text": "Total deaths from COVID-19 are much lower than officially reported."
    },
    {
      "id": "a88b2527-91c6-4d02-858e-633868b1e316",
      "text": "Vaccinated children have poorer health outcomes than unvaccinated children."
    },
    {
      "id": "2452b572-745d-4e14-b417-4111e352b92d",
      "text": "The British Embassy in Ukraine recommends that British citizens flee from drafting officers."
    },
    {
      "id": "8356bc2a-d254-4687-bfca-d0574d34234d",
      "text": "Ukrainian soldiers claim Ukrainian authorities are deliberately prolonging the war to profit from it."
    },
    {
      "id": "1edae4f0-e767-425e-b9ef-a2582e50803c",
      "text": "Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead."
    },
    {
      "id": "18be4b88-72b8-4ba0-a38c-6fea58782b35",
      "text": "The coronavirus outbreak was caused by 5G technology, not by a virus."
    },
    {
      "id": "201bd170-dafb-4b7f-8992-8ca1076fa5c0",
      "text": "Ukraine will not have enough gas to last the winter."
    },
    {
      "id": "f48228a1-9226-4a72-8363-5b731e9f40f7",
      "text": "Massive protests occurred in Germany opposing sending tanks to Ukraine."
    },
    {
      "id": "8d33e790-22e2-4d63-bb4b-6b1fa1107dbb",
      "text": "A Ukrainian military missile launch went wrong during maneuvers."
    },
    {
      "id": "0fdc3f1e-a803-49d7-8551-6143d0d355b1",
      "text": "A Western ratings agency reports that Kyiv has defaulted."
    },
    {
      "id": "3c73cae0-75fb-4152-bf44-4e18473a5e5d",
      "text": "Starbucks plans to return to Russia"
    },
    {
      "id": "1f17b118-8369-4029-a521-a42b43a53117",
      "text": "People with blood type O are more protected against COVID-19 than people with other blood types."
    },
    {
      "id": "f2be7c90-9b9b-4fb0-a65c-4f848a11c4ec",
      "text": "FDA guidelines state that babies are too small to safely handle the amount of aluminum in childhood vaccines."
    },
    {
      "id": "2ebc44ff-8117-4192-829c-584395c41f04",
      "text": "Ukraine jails Russians for visiting Crimea"
    },
    {
      "id": "4d3d9bba-fe97-4063-8039-8189ff9eb830",
      "text": "Poroshenko ordered a total blockade of Crimea."
    },
    {
      "id": "3765ef51-6b00-4412-b8b5-d783322a2f98",
      "text": "The EU ignored Russia distributing passports to residents of Donbas."
    },
    {
      "id": "1b6c65e0-53a5-4b0a-8362-e35b991c32d2",
      "text": "Ukrainian military attempted a chemical attack in Donbas."
    },
    {
      "id": "8b897291-7570-45a3-ad27-c89c40e46fa6",
      "text": "Ukraine has the highest electricity prices in Europe."
    },
    {
      "id": "4d0c614b-0cb6-499c-8dcb-bf785e560cfa",
      "text": "Flu shots cause people to spread the flu."
    },
    {
      "id": "6b602515-6205-4c47-abf3-c12f4e1efdd8",
      "text": "Tumors are bubbles of toxins expelled by the body; cancer is beneficial; biopsies and mammograms cause cancer."
    },
    {
      "id": "c3af0855-cf17-4b0d-bcda-fad670ded500",
      "text": "COVID-19 vaccines commonly cause myocarditis and cause sudden death"
    },
    {
      "id": "e6683a4b-da3c-499c-a23f-bb273f0a18fe",
      "text": "Euromaidan participants were paid."
    },
    {
      "id": "25fd6249-e949-4631-84fb-f1405e61dea4",
      "text": "Natural variation explains a substantial part of the global warming observed since 1850, and global warming is not intensifying natural disasters or increasing their frequency."
    },
    {
      "id": "705ecf79-6e86-4810-b490-c16d6a7e79df",
      "text": "COVID-19 causes prolonged, progressive hypoxia by binding to the heme groups in hemoglobin in red blood cells."
    },
    {
      "id": "c9488325-cda6-4175-8aab-76fc0f8bd6d4",
      "text": "A court ruled that COVID-19 mRNA vaccines are not vaccines."
    },
    {
      "id": "04a33121-8c9f-4e66-b86e-04b2bc7ae9b3",
      "text": "The surrender of Bakhmut will collapse the Ukrainian front to its western borders."
    },
    {
      "id": "b10e74b5-8563-4e07-a785-d9e62c029e0c",
      "text": "Alexis Lorenze became severely ill due to vaccines, and vaccines aggravate paroxysmal nocturnal hemoglobinuria."
    },
    {
      "id": "ba5e111e-c865-426b-bfa9-766e567f9b00",
      "text": "A freelance journalist was shot dead in Kyiv, Ukraine."
    },
    {
      "id": "e7bda970-2973-461d-bf8f-13801534e927",
      "text": "The Ukrainian National Memory Institute promotes hatred and incites conflict."
    },
    {
      "id": "a256890c-78e3-4b94-b0a6-adfbd7fcd013",
      "text": "Ukrainian paratroopers resigned from the military because they refused to fight."
    },
    {
      "id": "a9d64ed5-d644-4f06-bc99-b14bd6b9ad36",
      "text": "The CDC director admitted that COVID-19 deaths were over-counted."
    },
    {
      "id": "d4b1b125-6251-4b00-b38d-d36e119b32a4",
      "text": "Makeevka was hit by ballistic missiles."
    },
    {
      "id": "7b268201-9047-4d4a-a308-879db7198ea3",
      "text": "John Kerry praised Russian efforts to secure a ceasefire in Syria."
    },
    {
      "id": "cb07e2af-aff1-49c2-b82c-eac07c8917dd",
      "text": "Crimeans are under military pressure to support Russian annexation."
    },
    {
      "id": "a8c9c515-3996-4b03-9b74-2439120b001d",
      "text": "COVID-19 vaccines killed people and COVID-19 has a 99.97% survival rate."
    },
    {
      "id": "ddb36507-88b7-494f-8e9e-f9d8f9920656",
      "text": "People do not wear masks for tuberculosis because CNN has not instructed them to."
    },
    {
      "id": "13bc353e-afcb-45d4-a669-5c74b8b3974b",
      "text": "Antarctic ice increased from 2021 to 2023, reversing the Antarctic ice-loss trend."
    },
    {
      "id": "45b43966-a14f-4601-aa6f-f71455455a6a",
      "text": "Russian Proton rocket crashed while carrying a satellite."
    },
    {
      "id": "41fe581b-fd35-4726-8562-d8b53adbc04d",
      "text": "Earth’s mean temperature over the last 2,000 years was higher during 1–200 AD (the Roman Warm Period) and 900–1100 AD (the Medieval Warm Period) than it is now."
    },
    {
      "id": "eb95bd57-4eb2-46ba-a0dd-fba6ea1f6bda",
      "text": "Ukrainian soldiers fired on a car carrying a Russian-speaking mother and her child."
    },
    {
      "id": "717e16a2-b4d8-477a-86c2-54a02be5ffe2",
      "text": "Andriy Yermak paid TIME magazine to secure a spot on TIME's 2024 Most Influential list."
    },
    {
      "id": "7256ebf7-6850-4ad1-b34e-fbca0739ae2d",
      "text": "No one has died from the coronavirus."
    },
    {
      "id": "8a0c1978-1d61-4edc-94e7-56a5fa204143",
      "text": "The Ukrainian Armed Forces are recruiting mercenaries from Croatia."
    },
    {
      "id": "14252dd5-081b-48c5-a9bb-81baa766b054",
      "text": "Latvians want to establish a ghetto for Russians."
    },
    {
      "id": "3704c051-75f4-481a-a47f-2eec66167fbf",
      "text": "COVID-19 RNA vaccines were not made with messenger RNA; vaccine RNA cannot be broken down in the body."
    },
    {
      "id": "b380f9a0-cb02-43c3-a4d4-33c16744b821",
      "text": "Cooking with aluminum foil causes Alzheimer’s disease and cancer."
    },
    {
      "id": "e6f94f3b-de14-46dc-8947-0892c54963d9",
      "text": "Children injected with Pfizer’s mRNA COVID-19 vaccine had weakened immune responses to other viruses."
    },
    {
      "id": "1095ef48-c0a4-4bfc-8a82-ee80cec0f80e",
      "text": "The influenza vaccine has existed for 78 years and influenza still exists."
    },
    {
      "id": "53ab3c6a-5466-42a0-9451-1e63fb55016b",
      "text": "The world considers Ukraine a Nazi state."
    },
    {
      "id": "e4707b72-cdd0-49e5-9d11-b19f9d30d22d",
      "text": "Ukraine is forced to purchase the Russian COVID-19 vaccine."
    },
    {
      "id": "58a8417f-f648-4a83-b4be-780d4c190a88",
      "text": "Moderna produced COVID-19 vaccines before the pandemic began."
    },
    {
      "id": "55bf2059-688f-43e6-ade3-8ce980649e1d",
      "text": "Ukrainian authorities will mobilize workers at nuclear power plants."
    },
    {
      "id": "0d403ca7-7770-44ac-96dc-2a56f17d8b3c",
      "text": "DMSO effectively treats pain."
    },
    {
      "id": "74600ca3-b2a9-4375-9cfd-fd2742ec9d4d",
      "text": "Crimea benefits economically from its reunification with Russia."
    },
    {
      "id": "b057b3b9-cd53-4894-92a5-f2830f70b8d3",
      "text": "Vaccinated people face no danger from unvaccinated people; unvaccinated people have natural immunity and are less likely to get sick from COVID-19 than vaccinated people."
    },
    {
      "id": "a6f82707-218f-43ec-aad2-6faa25593c13",
      "text": "Ukraine imported spent nuclear fuel to build a dirty bomb."
    },
    {
      "id": "b45e717d-ffa8-4ab5-8872-95370f8027f9",
      "text": "Zelensky’s entourage act as intermediaries in weapons schemes"
    },
    {
      "id": "cd9c32c3-81d0-44d8-bbff-fc8c2896a4e4",
      "text": "CDC admits 146.6 million Americans have natural immunity and 94% of COVID-related deaths were not caused by COVID-19."
    },
    {
      "id": "2b147f86-fc25-44d1-aeab-ecd8aefa2b6e",
      "text": "The EU fears that Ukraine is smuggling weapons and drugs."
    },
    {
      "id": "598aeb2e-dece-423d-91ce-264ed870d837",
      "text": "The Netherlands accuses Ukraine of criminal conduct in the MH17 investigation."
    },
    {
      "id": "e6095ac2-1356-414e-8a1c-f0b2cc8822b9",
      "text": "U.S. delegation leader condemned NATO actions in the Black Sea."
    },
    {
      "id": "fae51888-22a7-4826-b71d-1d9befc16cd4",
      "text": "A quarter of U.S. COVID-19 deaths were preventable with vaccination."
    },
    {
      "id": "12055060-feef-4713-8995-9a76c8499749",
      "text": "Britain has ruled that Ukraine is responsible for Yanukovych's debt."
    },
    {
      "id": "887b0d36-bbc8-43a7-b5e1-4d384e2568d9",
      "text": "Blades from failing wind farms will be launched at people."
    },
    {
      "id": "e59fd3ee-63ae-4ece-accb-0fcf50901d4b",
      "text": "Chemotherapy is 100% mustard gas and causes cancer."
    },
    {
      "id": "fa85abfb-5251-4852-855a-ef9fdeeec1c1",
      "text": "Ukraine’s Internal Affairs Ministry says Russia’s strikes are highly precise."
    },
    {
      "id": "be579522-ce94-4a53-8c1f-c8f8e2b35ad0",
      "text": "Ukraine makes opposing NATO and the EU illegal."
    },
    {
      "id": "51af9d48-4a9c-4ea4-9f7e-70c38d0ca666",
      "text": "The coronavirus was created in a laboratory and patented in 2015."
    },
    {
      "id": "812e2115-60b4-452f-b44d-cd5777875496",
      "text": "Poroshenko allows lumber to be smuggled into the EU."
    },
    {
      "id": "21027d00-a6f2-4c55-88ee-86c3a70d6d53",
      "text": "Moderna reported that serious adverse events affected 1 in 200 toddlers and concluded the mRNA vaccine was safe in children."
    },
    {
      "id": "d0c13a79-f140-46e4-acfb-c1195305cd65",
      "text": "NATO is illegally occupying Ukraine."
    },
    {
      "id": "cc2f09e1-bc82-40a5-90db-e1040af323d4",
      "text": "Polio was renamed to hide that it still exists; the polio vaccine does not work; vaccines contain harmful mercury, SV40, and DNA contamination."
    },
    {
      "id": "1eba351b-5552-4e28-ae20-82867d650d2b",
      "text": "There has been no long-term change in sea level rise rates over the last 120 years."
    },
    {
      "id": "fac74e7f-c900-4f5f-91ec-4a777460f35c",
      "text": "Viruses do not exist and terrain theory fully explains why diseases occur."
    },
    {
      "id": "8e8ca0bf-e85d-42c0-88f3-d5cb63349dd9",
      "text": "Ukrainian soldiers committed suicide instead of shooting at Russian separatists."
    },
    {
      "id": "0964821f-62b5-4f6d-957a-cf486c6ef6f4",
      "text": "You can determine a person's immune system strength by looking at their eyes."
    },
    {
      "id": "8858128f-3967-4c92-b226-f140e0a703ed",
      "text": "Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead."
    },
    {
      "id": "5acfcc66-a473-4cf8-b96b-b77390d3a232",
      "text": "mRNA COVID-19 vaccine lipid nanoparticles concentrate in the ovaries, causing the ovaries to produce large amounts of toxic spike protein."
    },
    {
      "id": "49dcec77-6a80-4a31-b76d-f30a6bbcc836",
      "text": "Ukrainians in Poland are slaves."
    },
    {
      "id": "08ae94a3-a979-4f67-af67-7d21fcc158d7",
      "text": "The COVID-19 vaccine is unsafe and ineffective because its trial is still underway, and thousands of people who received the vaccine have died or been seriously injured."
    },
    {
      "id": "93db5c3d-f473-4e51-9442-ddc704bd6f34",
      "text": "Sea-level rise is independent of ocean temperature and CO2."
    },
    {
      "id": "800677b4-581f-457c-9366-8c4d0574d7d2",
      "text": "Leaders of self‑proclaimed separatist republics appeared before the UN Security Council."
    },
    {
      "id": "7c80c70b-5355-4101-a131-3fb5033c5466",
      "text": "The EU is bringing Ukraine to its knees."
    },
    {
      "id": "f818e45f-f7fa-4a5f-8f89-f842f6c6ecec",
      "text": "Bill Gates said genetically modified organisms are being injected into children's arms and shot into their veins."
    },
    {
      "id": "6ba3f0b0-cccc-4453-9c4e-7dc9f180b7cb",
      "text": "Ukraine continues to buy gas from Russia."
    },
    {
      "id": "57e5f68f-fef5-4d51-a787-8cfbb1f2b7da",
      "text": "Merck scrapped its COVID-19 vaccine program and said getting infected and recovering provides better protection than vaccination."
    },
    {
      "id": "cdbde4b9-7685-4c13-8654-d1417a5d5ee0",
      "text": "Previously healthy people are being seriously harmed and dying from the flu shot."
    },
    {
      "id": "b6c27490-dd7a-46bc-b782-cfd7f9bead27",
      "text": "Regulators reduced approval standards so the COVID-19 vaccine was approved regardless of evidence, and the COVID-19 vaccine does not prevent transmission."
    },
    {
      "id": "a27ce914-e260-4d08-ac3a-432980fd62b2",
      "text": "U.S. senators armed Ukraine to capture the Donbas region."
    },
    {
      "id": "490533e1-dfdd-4459-8e69-84a77de32982",
      "text": "Putin plans to militarily retake Crimea."
    },
    {
      "id": "77e80b1b-3b86-497e-9307-f52b8e26e1f6",
      "text": "Czech data shows COVID-19 vaccines reduce fertility."
    },
    {
      "id": "48931092-1268-4b65-8ed1-3d8321ab4607",
      "text": "Ukraine sent soldiers to Germany for training without testing them for COVID-19."
    },
    {
      "id": "1ec753ae-0076-44ca-96d3-6c8bef211a7e",
      "text": "One million mRNA COVID-19 vaccine doses given to teenagers prevent at most one death and cause 100,000–200,000 severe side effects."
    },
    {
      "id": "93cacc91-bec7-49ba-85fc-fdd8c3a4e356",
      "text": "Building a wind turbine requires a very large amount of energy and materials, and wind turbines are expensive, inefficient, and kill birds and bats."
    },
    {
      "id": "b7300488-7bab-4bc6-a126-b997fe7c37a7",
      "text": "Infection-induced immunity is by far the most robust immunity against COVID-19."
    },
    {
      "id": "1d9d7c36-2de2-4de3-9779-1b514ea4cb97",
      "text": "The Mriya transport plane wreckage was disposed of."
    },
    {
      "id": "ab8713ea-0916-4c03-b7ea-9bed8792db33",
      "text": "NATO is dissatisfied with the too-soft mobilization measures for Ukrainians abroad."
    },
    {
      "id": "910f325a-ceb8-4483-be45-d62d7acc3a6d",
      "text": "The government has released plans to force everyone to receive a vaccine and three vaccines in U.S. Stage 3 trials will be ready in weeks."
    },
    {
      "id": "dcebb25d-c474-4240-aae5-10924c56f7d8",
      "text": "VAERS reports in Florida rose 1,700% after COVID-19 vaccines became available, demonstrating that COVID-19 vaccines are unsafe."
    },
    {
      "id": "47c8f442-152b-47d6-afd9-09434f7556ae",
      "text": "Federal study found marijuana is 100 times less toxic than alcohol and is safer than tobacco"
    },
    {
      "id": "a4202ed7-037f-4047-85e5-bfc3bb24d142",
      "text": "American media claim Ukraine's government is a neo‑Nazi regime and is illegitimate."
    },
    {
      "id": "514a8a9b-bc78-4e9a-9d68-8eb6b36fed1d",
      "text": "People are fined for planting potatoes"
    },
    {
      "id": "f5785d4e-bb24-4967-93a2-a6279cdb2aa3",
      "text": "920 women lost their unborn babies after getting vaccinated."
    },
    {
      "id": "7fbe7e93-7fdf-4ab5-9d0a-b2224b8c001d",
      "text": "Ukraine will replace Victory Day with Europe Day."
    },
    {
      "id": "7ca8d60f-df10-4ca4-9389-05952701211e",
      "text": "Not living at an officially registered residence in Ukraine is punishable by law."
    },
    {
      "id": "fe8cfbf5-a62f-4e4e-a3d8-4fce6f205412",
      "text": "Fungi cause cancer."
    },
    {
      "id": "4f61b269-b18f-440f-86f2-071070cf39f7",
      "text": "Lavrov says Odesa and Mykolaiv were created by Russian people."
    },
    {
      "id": "48dcacb1-a6d4-4ffd-ae0d-19020e4a4256",
      "text": "Kyiv and Washington are dividing Ukraine."
    },
    {
      "id": "140c722b-2bd4-4e8e-b7a7-faab1c343974",
      "text": "Vaccinated individuals have higher rates of COVID-19 infection and more musculoskeletal problems than unvaccinated individuals."
    },
    {
      "id": "e893b0cb-deff-41b0-8a58-d9f7e330290b",
      "text": "A spontaneous memorial was erected on the Tisza River for men who died while attempting to cross the border."
    },
    {
      "id": "67e3ddb6-2eb8-443a-91e4-4a47d24d0ca2",
      "text": "The Maldives are not threatened by climate change"
    },
    {
      "id": "9d307cba-10c6-4d4c-85a8-ea190c9e38f1",
      "text": "The U.S. CDC is lowering the PCR cycle threshold (Ct) for tests of suspected vaccine breakthrough infections to reduce the number of officially recorded COVID-19 cases."
    },
    {
      "id": "381b986c-714c-4d28-bf25-4946c45f7085",
      "text": "US intelligence found reasons to pursue regime change in Ukraine."
    },
    {
      "id": "3d172aba-15cd-41a3-875f-232cf07ac7a3",
      "text": "Climate change is not new and is not caused by humans."
    },
    {
      "id": "8c4e658b-c2f4-40d6-acb0-e120aa2aad0f",
      "text": "Abortions are never medically necessary"
    },
    {
      "id": "496f09c0-85ea-419e-b170-6ca90d3cbc34",
      "text": "Lviv graduates were given ribbons depicting a map of Ukraine that excludes Crimea."
    },
    {
      "id": "3c7bbead-a5a5-4a68-9acf-7d3319a7fb38",
      "text": "Amish communities have herd immunity because everyone already had COVID, so vaccines are unnecessary."
    },
    {
      "id": "4ce45b79-2cbe-4d99-96eb-07d582e80fd8",
      "text": "Massive demonstrations across Europe are supporting Donbas."
    },
    {
      "id": "0ed14139-129e-443f-b11b-fdde310f75d9",
      "text": "Ukraine will suffer an economic disaster."
    },
    {
      "id": "cb71a94d-8f0d-4be5-9737-fa44d24d6c90",
      "text": "Ukraine admitted foreign mercenaries left Ukraine to fight in the war in Israel."
    },
    {
      "id": "2c259afd-f542-4627-88d8-3750d2b59ae7",
      "text": "No one has died of cancer or heart disease since the COVID-19 pandemic began."
    },
    {
      "id": "9f5848cf-a05d-421e-9dc8-0d8ecdda8e58",
      "text": "Vitamins C and D are now part of conventional SARS-CoV-2 treatment; very high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk."
    },
    {
      "id": "0c61da08-e4df-4b4f-944f-c5a065acace5",
      "text": "Romanian authorities prioritize evacuating Ukrainians from Gaza before evacuating Romanian citizens."
    },
    {
      "id": "b61e932c-d0e5-4154-be32-f0ac3c52fed0",
      "text": "Coronavirus does not exist."
    },
    {
      "id": "8ed4f17b-38af-4dfb-9181-18f56598cd3c",
      "text": "A video shows a Russian Oreshnik missile used in an attack on Dnipro."
    },
    {
      "id": "8f7421cf-82dc-48c1-98f5-c7e7321e37b3",
      "text": "Hurricane Milton is a targeted geo-engineered storm, and hurricanes never develop in the western Gulf of Mexico and always head straight east to Florida."
    },
    {
      "id": "ce31105a-13fb-4324-877c-1143670d251b",
      "text": "Most people are infected with harmful parasites and need to regularly cleanse their bodies using pills, juices, seeds, or cleansers that detoxify the body and eliminate parasites."
    },
    {
      "id": "4b5dde87-2185-48d5-8f08-8cf82f888f78",
      "text": "Ukraine will cut off gas supplies to Europe."
    },
    {
      "id": "0c13fc8f-d3f9-42e0-afb5-4e1ec4d48ca2",
      "text": "Crimean self-defence units took over the parliament building, and a professional actor was used as a witness."
    },
    {
      "id": "a7ea3f1a-7b3e-4f52-8f24-7549557e04ad",
      "text": "Robert Kiyosaki said financial aid to Ukraine is pointless."
    },
    {
      "id": "3b2128b4-4590-4671-b7cd-02a16eadf477",
      "text": "More than 10 million Ukrainians left Ukraine because Ukraine pursued a pro‑NATO course."
    },
    {
      "id": "833d8aa2-87f3-43d9-b6a7-840cca9c261a",
      "text": "Kurt Volker says Ukraine cannot regain Crimea and Donbas."
    },
    {
      "id": "1d535066-043b-48ae-b72f-bb725a0dc533",
      "text": "Uman Synagogue houses a Ukrainian nationalist military base."
    },
    {
      "id": "6f64e734-8b4d-4d8f-a346-c4d16a69ba8b",
      "text": "HAARP experiments caused the May 2024 auroras."
    },
    {
      "id": "4e631d9f-285f-4597-9acc-f7fcd2a9c064",
      "text": "COVID-19 vaccines cause female sterilization by triggering an immune response against the placenta."
    },
    {
      "id": "e7d790dc-8255-4a27-8ca9-8ecc3deb5bc4",
      "text": "2016 was not a global temperature record."
    },
    {
      "id": "d51a391a-6570-4599-b28e-5b0598458b94",
      "text": "A Turkish delegation arrived in Crimea."
    },
    {
      "id": "0885b665-80fc-405b-98c3-3ee4dc2ebc96",
      "text": "SSU Head Nalyvaychenko has a United States passport."
    },
    {
      "id": "34b64dd0-60ec-464a-b7f8-af46028d73d4",
      "text": "EU countries are massively denying visas to Ukrainians."
    },
    {
      "id": "66edd251-7fa8-42f8-b860-e9fdc90e657a",
      "text": "Relations between Russia and the West are deteriorating because of the war in Ukraine."
    },
    {
      "id": "45e07c52-5893-42d9-a89a-35ed3e29e4d3",
      "text": "Natural immunity to COVID-19 is stronger and longer-lasting than immunity from COVID-19 vaccines."
    },
    {
      "id": "a595315e-7ec1-4c80-abff-07725d6dcf14",
      "text": "A Lancet study shows vaccinated people have lower immune function than unvaccinated people and that COVID-19 vaccines suppress the immune system."
    },
    {
      "id": "cc1c0b2e-c509-4ed2-93ee-ff392da24a6f",
      "text": "More children will die from the COVID-19 vaccine than from COVID-19, and there is proof."
    },
    {
      "id": "0f7df7e2-9b40-4791-bf10-de0aaa56e74c",
      "text": "Photo shows a Polish military order to attack Ukraine."
    },
    {
      "id": "5770a376-3a58-45b3-b9c7-4139b4da1cf5",
      "text": "COVID-19 is not dangerous."
    },
    {
      "id": "a08c9c34-13b1-4b32-94c7-c670511aeb6b",
      "text": "Wind turbine disposal creates a large environmental footprint."
    },
    {
      "id": "9481983d-c22e-4db3-9b32-4c294f36a4ee",
      "text": "Covid-19 vaccination in pregnancy provides no benefit and causes higher rates of neonatal and all-cause readmissions among babies born to vaccinated mothers."
    },
    {
      "id": "b59d921d-d502-41a8-9bd6-26a16eea2d90",
      "text": "Consuming turpentine kills parasites"
    },
    {
      "id": "bb0ac974-dba1-485f-85a8-d2f0f99db330",
      "text": "A review found that COVID-19 mRNA vaccines aid cancer development."
    },
    {
      "id": "5ccdbbf0-2376-4f95-8321-d746fa931186",
      "text": "Wagner Group destroyed a Leopard tank and killed its Polish-German crew."
    },
    {
      "id": "f1e088e6-b878-443c-ad67-f37a3c1428ab",
      "text": "CO2 is a plant nutrient and is not a pollutant that threatens human civilization; installing CO2 generators in greenhouses does not kill plants."
    },
    {
      "id": "57ceec33-a712-42be-83b1-0bbe6b69f3a2",
      "text": "Ukraine and Western countries are preparing terrorist attacks in Crimea."
    },
    {
      "id": "c7da2e2a-b68c-45ad-a5c6-61096ce211be",
      "text": "The 1986 National Childhood Vaccine Injury Act prevents people from suing vaccine manufacturers for injuries or deaths caused by vaccines."
    },
    {
      "id": "040dec4c-2428-4f42-b5a0-68d2f5e4071e",
      "text": "Sunscreen causes skin cancer and reduces vitamin D production, and wearing sunglasses increases the risk of sunburn."
    },
    {
      "id": "df336382-0e90-41dd-8ebd-a899eae43674",
      "text": "Separatists obtained military hardware as spoils of war."
    },
    {
      "id": "81a64a01-ce6c-4c66-9537-c97b8fad0a54",
      "text": "The Great Barrier Reef currently has record-high levels of coral and is not threatened by climate change."
    },
    {
      "id": "3aa43b0e-368d-4d2d-920c-2bdf99fb3216",
      "text": "A pro-mask study was withdrawn after researchers found virus spread in the analyzed counties; masks do not work."
    },
    {
      "id": "21a386c6-a8c0-48cd-9378-79cc4cf98735",
      "text": "The UN confirmed that Russian intelligence agencies were behind the Odessa House of Trade Unions tragedy."
    },
    {
      "id": "1db9ddb6-3d68-48a0-be81-b5b62a2a1b11",
      "text": "Vaccinated and boosted people were more likely to be hospitalized with the Omicron variant than unvaccinated people."
    },
    {
      "id": "97e7a0bd-d797-473c-a610-4279ac90663f",
      "text": "Global warming saves 166,000 lives each year; reported increases in heat-related deaths are caused by population growth and aging, not by climate change."
    },
    {
      "id": "be6c4f4b-813c-437b-9081-5cdae97ea306",
      "text": "Ukraine is blackmailing the West by using EU membership as leverage."
    },
    {
      "id": "d20c48d1-f568-44d9-a525-23bd770a03ab",
      "text": "Ukraine canceled a 15 million hryvnia payment to the families of fallen soldiers."
    },
    {
      "id": "50aafcf4-a03e-4155-8c97-9aac0561190d",
      "text": "Ukraine gives half of its national budget to Western creditors."
    },
    {
      "id": "683f15ce-dced-4660-85d4-c95cd43c23c7",
      "text": "A German restaurant's advertisement urges customers to stop talking about Ukraine."
    },
    {
      "id": "dd96c0e8-8609-47ec-a1a8-bf3ea961e073",
      "text": "Ukraine is preparing to carry out a chemical attack near Odesa."
    },
    {
      "id": "a1d9fa60-1b33-407a-8a7b-098c15f781e2",
      "text": "Queensland Health researchers found that long COVID does not exist."
    },
    {
      "id": "ade8b013-f783-45c1-98c2-1a7f3507d997",
      "text": "The EU will impose retaliatory sanctions against the US."
    },
    {
      "id": "780cdf62-aff5-4110-8e69-01754cc6c09e",
      "text": "UNICEF accuses Kyiv of committing aggression against Donetsk and Luhansk."
    },
    {
      "id": "4e679122-0ca3-4471-a107-5f85bb5443bf",
      "text": "A new medicine normalizes blood sugar levels after the first use."
    },
    {
      "id": "b1eb74a2-49a0-41d3-b342-abdbfa1efe71",
      "text": "Italians asked Vladimir Putin to save the world."
    },
    {
      "id": "4aa72748-0ad2-49be-aad1-b95e37da3a2a",
      "text": "There is no factual evidence for global warming; scientists do not know whether CO2, solar activity, or natural variability cause it."
    },
    {
      "id": "fca8eab7-2aa1-4276-a101-a285da0affbc",
      "text": "Coughing repeatedly and very vigorously helps people who are experiencing a heart attack."
    },
    {
      "id": "03574c37-742c-4770-ba1b-d8c6c3e4d8be",
      "text": "Doctors in Donetsk refused to treat a wounded Ukrainian soldier."
    },
    {
      "id": "b26a0e68-fde1-4d66-a7d2-5c1e54629b60",
      "text": "Scientists adjusted sea level data to create a false impression that oceans are rising."
    },
    {
      "id": "0ec7f5cc-5e61-471e-b6ba-654ac11c0af5",
      "text": "NATO's nuclear drills are causing a world war."
    },
    {
      "id": "301a9f91-1c50-4467-83f2-77688d7deb19",
      "text": "Unvaccinated people infect vaccinated people with the same virus the vaccinated were vaccinated against."
    },
    {
      "id": "a260e8e8-ef5f-4e64-8f76-0bc6fbe678ae",
      "text": "A quarter of U.S. COVID-19 deaths were preventable with vaccination."
    },
    {
      "id": "d572be63-43ec-4f6b-9196-a4fc78e203a6",
      "text": "Solar cycles and natural variations in solar and Earth activity cause climate change, and anthropogenic CO2 emissions do not cause climate change."
    },
    {
      "id": "ba39436c-49bc-48c4-ab96-805ef9ca0590",
      "text": "Kateryna Prokopenko is an influential German politician."
    },
    {
      "id": "f39abf0d-00c9-4096-8087-54873ff61fa6",
      "text": "Pfizer admitted that vaccinated people can shed the vaccine onto unvaccinated people."
    },
    {
      "id": "4bc13bbb-6196-4f52-8bd7-0e0ec095f388",
      "text": "HAARP caused the October 2024 auroras."
    },
    {
      "id": "02046bbf-5ad3-45ff-b1c1-e73942023b9b",
      "text": "Donbas residents are being forcibly resettled to Lviv for reeducation."
    },
    {
      "id": "fec5595b-21ec-460d-bafb-b5b19c7ef652",
      "text": "COVID-19 vaccines caused 26.6 million injuries and 1.36 million disabilities in 2022 and cost the economy billions of dollars."
    },
    {
      "id": "fa53f6ea-9cb9-45ca-ae67-e1f013dd59de",
      "text": "Svoboda political party designed a banknote depicting Adolf Hitler."
    },
    {
      "id": "8fd7bf1a-45d1-4bf4-a6cb-3d32320b7683",
      "text": "Authorities in Barcelona removed children from a Russian woman because of anti-Russian bias."
    },
    {
      "id": "858266a5-5598-4215-8544-ed58b34b026c",
      "text": "U.S. doctors found that long COVID developed in 70 percent of cases after vaccination rather than after infection."
    },
    {
      "id": "8d49ec4b-b1e8-406b-8b1f-8c5fdb7a636b",
      "text": "Three Ukrainians were detained in Israel for looting."
    },
    {
      "id": "0aa879c0-b7fe-47c4-8027-e48da678618f",
      "text": "Ukrainian Greek Catholics are exempt from mobilization."
    },
    {
      "id": "00ab1807-cf95-4e72-8394-2e9689140536",
      "text": "Jihadists participated in the Crimean Tatar World Congress."
    },
    {
      "id": "0a551238-3582-446a-806e-0f8443f302cb",
      "text": "Lithuania teaches war to Ukrainian children."
    },
    {
      "id": "d18e9a0b-a6d7-47a4-b673-21d5f2eaf483",
      "text": "Ukraine opposes medals commemorating the 75th anniversary of Victory over Nazism."
    },
    {
      "id": "a40e602a-c272-43c8-8c71-cebb6598a675",
      "text": "Kyiv ignored the Minsk Protocol meeting."
    },
    {
      "id": "86b9cf66-03d4-4167-9c04-a1450db98ded",
      "text": "Kyiv City Council proposed a complete ban on the Russian language."
    },
    {
      "id": "c9a5e64f-b02b-49dc-8775-3842f4736fd7",
      "text": "Most cases of Alzheimer's disease are preventable, Alzheimer's disease is not genetic, and Alzheimer's disease is type 3 diabetes (insulin resistance of the brain)."
    },
    {
      "id": "1d7a571f-302c-43bb-9c0e-d22f93415455",
      "text": "Global temperatures are rising two to three times more slowly than climate models predicted."
    },
    {
      "id": "cca498e1-8ac8-460c-a82d-4e0e49181f6e",
      "text": "Foreign mercenaries serving in the National Guard are filming the atrocities they commit."
    },
    {
      "id": "c64cbb4b-58a9-4606-9025-8605cf79296d",
      "text": "Magnetic pole reversals cause the Earth to flip vertically and stop rotating for six days, causing cataclysmic events."
    },
    {
      "id": "68309499-78da-4bbe-af16-4f5b2d11c215",
      "text": "Ukraine's autumn recruitment efforts failed."
    },
    {
      "id": "9f4836cc-879c-4406-8ed7-bdce9b8b99e1",
      "text": "Pfizer's data show COVID-19 vaccines are unsafe for pregnant women."
    },
    {
      "id": "44a3fb61-0f2b-41bd-9c56-dedb56b38786",
      "text": "People vaccinated against COVID-19 are more likely to be hospitalized than unvaccinated people."
    },
    {
      "id": "d1abf8d0-9d30-4d4f-8219-bb00fdef6ac5",
      "text": "Fighter jets drew a star over Alaska to honor Vladimir Putin."
    },
    {
      "id": "938259cd-de6f-4630-996d-bca53f1e39f4",
      "text": "Crimeans who left the peninsula after Russia annexed it are returning to Crimea."
    },
    {
      "id": "12391047-4214-4422-bc58-91fbdadc33b7",
      "text": "There are plans to blow up the Luhansk-area railway overpass to disrupt evacuations to Russia."
    },
    {
      "id": "a4a77ccd-9f42-4633-a11f-13e95e7fd6d0",
      "text": "The LifeNews journalist ordered separatists to open fire."
    },
    {
      "id": "2a6c92de-99b2-4e5e-8618-d3097c99ff5d",
      "text": "The United States officially recognized Donbas as an independent state."
    },
    {
      "id": "1b92e69c-30d7-4aab-9caf-027682c0f685",
      "text": "One Mt. Etna eruption released more than 10,000 times the CO2 emitted by all humans in history."
    },
    {
      "id": "8929cf51-2c57-4301-871a-351e37841df3",
      "text": "More children will die from COVID-19 vaccines than from COVID-19."
    },
    {
      "id": "9b42133b-cf29-42c8-b877-34e158bd928d",
      "text": "Australian temperatures increased by 0.3°C over the past century, not 1°C."
    },
    {
      "id": "af5ce828-ecb0-4b25-98ec-a073e63c0268",
      "text": "Zelensky ordered schools and universities to work offline starting September 1."
    },
    {
      "id": "f09a8f81-dd52-4d4a-9570-5491befa2a8f",
      "text": "The World Bank website shows that countries purchased COVID-19 test kits in 2017 and 2018."
    },
    {
      "id": "92e48c53-cdf7-4f84-946f-ac5adcbdd891",
      "text": "Pro-Russian banners with the Russian flag appeared on Ukrainian streets."
    },
    {
      "id": "76ca2ffa-87aa-4737-829e-cc18600a8876",
      "text": "Ukraine formed a military alliance with the United States."
    },
    {
      "id": "e2f3bbec-8541-4429-984c-cc8a9e76bda2",
      "text": "SARS-CoV-2 is spreading quickly from gas pumps and from shopping carts."
    },
    {
      "id": "898b4b67-6431-4909-b142-2dda0251889e",
      "text": "Giving water to babies under six months causes serious health risks."
    },
    {
      "id": "51aaa1c6-de52-447f-9184-f66d905b0b93",
      "text": "Bill Gates said genetically modified organisms are injected directly into children's arms and into their veins."
    },
    {
      "id": "4824b6b2-aa5e-4068-8799-3a75ca4e3b50",
      "text": "19% of American children have ADHD and 0.5% of French children have ADHD."
    },
    {
      "id": "b0d9dc0c-0877-48bd-b103-1c083b7b4875",
      "text": "Sweden banned mandatory vaccinations because of serious health concerns."
    },
    {
      "id": "56abb7cb-a819-437e-a5cf-51e900a41396",
      "text": "COVID-19 vaccines are experimental and ineffective; natural immunity is superior to vaccine-induced immunity; vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes prior vaccination."
    },
    {
      "id": "b4c58eaf-eb3f-48ba-b081-0f97d60df67b",
      "text": "Ukraine will imprison residents of Crimea and other occupied Ukrainian territories who hold Russian passports."
    },
    {
      "id": "e9981269-f7c9-4625-9b7b-988f7f6e4ba3",
      "text": "COVID-19 vaccines contain luciferase to tag and track people."
    },
    {
      "id": "bf2c855c-eb7d-44e5-b5fe-720972907414",
      "text": "Electric vehicles are highly prone to catching fire."
    },
    {
      "id": "86f36e67-beb8-4a42-a030-2cc80150100d",
      "text": "Half of the 0.9°C of global warming is caused by greenhouse gases."
    },
    {
      "id": "d793e6a8-97af-4229-a114-e6ecc6f0abdf",
      "text": "The Ministry of Defense does not receive any images from the ICEYE satellite."
    },
    {
      "id": "cf4b4ab5-e024-4963-9e53-684e4e1f377c",
      "text": "Wilhelm Reich invented a cure for cancer."
    },
    {
      "id": "5416a7a8-6006-48b8-8076-7eb615d10765",
      "text": "Ukraine's National Corps developed an atomic bomb to use against Russians."
    },
    {
      "id": "ecd6420a-6280-446f-8516-ea47473e1bc4",
      "text": "The United Nations is dissatisfied with Western tanks sent to Ukraine."
    },
    {
      "id": "0bf57117-f8d0-4da8-a7d6-7a414366d8d1",
      "text": "COVID-19 infection and COVID-19 vaccination cause HIV tests to turn positive and cause immunodeficiency."
    },
    {
      "id": "7b9b4cf9-59e5-4fab-bd12-349123ec46b5",
      "text": "A Turkish ship transported military equipment from Bulgaria to Ukraine."
    },
    {
      "id": "c6386624-3e0b-4641-a3f2-812f177da49f",
      "text": "Diet and lifestyle changes, instead of chemotherapy or radiation, cause spontaneous remission of cancer."
    },
    {
      "id": "fb147f68-fa76-40a2-90df-f4b00b9c712c",
      "text": "The SARS virus has circulated since 2003 and recurs every three to four years, so everyone in the world is immune."
    },
    {
      "id": "a8994599-1956-426c-85b4-a903f194b187",
      "text": "Ukraine distributed counterfeit banknotes contaminated with tuberculosis in occupied Donbas."
    },
    {
      "id": "f7784c93-abea-470a-9986-7999412af8fb",
      "text": "COVID-19 has a 99.991% survival rate, so vaccines are unnecessary because vaccines were developed only for deadly diseases like smallpox that had no treatments."
    },
    {
      "id": "38b53111-629e-4701-964c-d5a98dab0b48",
      "text": "Kyiv increased electricity prices to fund hosting the Eurovision Song Contest."
    },
    {
      "id": "21ab5123-456a-4440-9bbe-73d1fb8575f3",
      "text": "The Ukrainian government refuses to finance Kharkiv, and Kyiv has resigned itself to Russia’s occupation of Kharkiv."
    },
    {
      "id": "0394f585-476b-45c6-9515-ea451b79ccc9",
      "text": "COVID-19 vaccines have killed millions of people worldwide, at a rate of one death per 1,000 doses."
    },
    {
      "id": "50261868-0760-408c-847e-db061e167d2a",
      "text": "The Ukrainian military bombed Snizhne."
    },
    {
      "id": "a5d59357-18c2-4f05-9c3f-7b7628df3eec",
      "text": "COVID-19 and COVID-19 vaccines are causing a global epidemic of terrifyingly aggressive cancers."
    },
    {
      "id": "e52bef89-83ca-49da-8cbe-7dc95e29b77b",
      "text": "Humans caused the Texas floods using cloud seeding, and the floods would not have occurred otherwise."
    },
    {
      "id": "5326d90b-c708-46d2-ac2f-4c3538990e9d",
      "text": "In 2009, 50% of Ukrainian citizens wanted to hold Russian citizenship."
    },
    {
      "id": "f9c88fc1-bfad-4629-a9bb-79734eaee82b",
      "text": "The Kadyrov Foundation repaired an abandoned hospital in Rubizhne."
    },
    {
      "id": "7fea8be9-3838-4114-8b5e-c170a507a2cc",
      "text": "The U.S. Climate Reference Network finds there has been no warming in the United States for at least the past 14 years."
    },
    {
      "id": "36f017c8-f887-4fef-aaa0-3d76d2d3ffaf",
      "text": "A new language law prohibits the use of any language other than Ukrainian."
    },
    {
      "id": "07d5ccad-b012-4006-945d-684f26fb7453",
      "text": "The Netherlands says Ukraine lied about a downed Boeing-777."
    },
    {
      "id": "b0a04d0a-f88e-440b-9162-46d25831ddb4",
      "text": "Ukraine will stop gas transit in 2021"
    },
    {
      "id": "f9e063d5-7dcf-41b5-afcb-04878ca726ca",
      "text": "Polar bear populations are increasing and polar bears are thriving despite diminishing sea ice."
    },
    {
      "id": "ef854841-2805-4237-a8d5-6cd7b7936870",
      "text": "The Ukrainian Ministry funds radical nationalist organizations."
    },
    {
      "id": "fa2b9817-fb16-4e1c-92f0-db463dc26a73",
      "text": "The atmosphere is less sensitive to CO2 than climate models forecast."
    },
    {
      "id": "82024663-672b-4205-9001-5efad1525661",
      "text": "Ukraine is a drug entry point for Russia and Europe."
    },
    {
      "id": "7b636bf6-2231-4d09-a5a5-a2bc207be079",
      "text": "Margarine is chemically only one molecule different from plastic."
    },
    {
      "id": "4ff2c46a-29f2-4b6a-972b-ca8feecf0dd4",
      "text": "Patent US5676977A is for AIDS, patent US8835624B1 is for H1N1, and patents US7897744B2 and US8506968B2 are for SARS."
    },
    {
      "id": "01440c79-b4af-435a-b2d3-9f6e68d2ebad",
      "text": "Unadjusted temperature data show Australian temperatures increased by 0.3°C over the past century, not by 1.0°C."
    },
    {
      "id": "43494523-f6c1-4d5d-8eaf-20c099381363",
      "text": "Big Pharma murdered doctors to protect its profits and to silence holistic health practitioners."
    },
    {
      "id": "1e6ef59b-b97d-4bbe-baa9-9dd55b985cfc",
      "text": "Ukraine has implemented juvenile justice."
    },
    {
      "id": "106355c0-5f33-4152-9329-80d8cd93fd91",
      "text": "mRNA COVID-19 vaccines do more harm than good."
    },
    {
      "id": "7ac18437-d326-4a31-92d1-f6c4b9f3acc4",
      "text": "The cow feed additive Bovaer is unsafe and makes milk unfit for human consumption."
    },
    {
      "id": "341b7583-7cae-4ae6-95ac-e11dcc0e29e1",
      "text": "Lviv officials urged that Crimea and Donbas be recognized as territories of Russia."
    },
    {
      "id": "ac1ea412-c8f5-4d1c-8e19-03dc3ae75d56",
      "text": "A peer-reviewed study found ivermectin reduces COVID-19 death risk by 92%, and the NIH lists ivermectin as a COVID-19 therapy."
    },
    {
      "id": "f41216bd-b2cf-4575-9949-f27343ea781f",
      "text": "Ukraine cannot guarantee the security of its nuclear power plants without NATO."
    },
    {
      "id": "a2b312fa-88d5-4614-8069-bf3ecf3de787",
      "text": "The Moderna COVID-19 vaccine caused heart damage in 1 in 35 people and is a kill shot."
    },
    {
      "id": "084a5e5f-4ea4-4a61-b599-9e39c1069298",
      "text": "The CDC says COVID-19 vaccination increases the likelihood of infection with the BA.2.86 variant."
    },
    {
      "id": "6aaf8382-3a8c-4bd9-a1f0-00751972af02",
      "text": "Chrystia Freeland is an adviser to Ukrainian president Volodymyr Zelensky and is a descendant of a Nazi collaborator."
    },
    {
      "id": "ae8245df-51af-4469-9186-e7dd7bf76c40",
      "text": "Ukrainian businesses are planning mass redundancies"
    },
    {
      "id": "f65d41cb-fc8a-47b7-8a48-2d4eb9377096",
      "text": "Human CO2 emissions do not drive recent climate change; solar activity and natural climate cycles drive most recent climate change."
    },
    {
      "id": "bbfb8767-23ec-4520-8e1c-be6dd2ab6d86",
      "text": "COVID-19 vaccines are dangerous for children; they cause myocarditis and bypass children's innate immunity that protects them from COVID-19."
    },
    {
      "id": "77e3123c-bcfe-4e1b-b4c4-4699aa8c7a92",
      "text": "The Ukrainian government forced schoolchildren to study in shelters as a PR stunt."
    },
    {
      "id": "a09cfbeb-9296-4296-8a6b-cccd5211b0b4",
      "text": "Trump sent National Guard troops to Alaska in response to Ukrainian protests."
    },
    {
      "id": "116d1290-adae-4a0c-afde-ebe2246e93f0",
      "text": "The FDA says Pfizer's COVID-19 vaccine causes blood clotting."
    },
    {
      "id": "58ffab6b-fa0a-454b-b303-57a5b0ea6909",
      "text": "Ukrainians in Poland are slaves."
    },
    {
      "id": "45ad6727-3b1d-4f45-86a5-853b7d2b7e74",
      "text": "Ukrainian Prime Minister was hospitalized after a nervous breakdown"
    },
    {
      "id": "7e50b278-7168-4642-ac16-4936bb59dd46",
      "text": "A Ukrainian missile destroyed an apartment building in Kyiv."
    },
    {
      "id": "db06a8e5-9666-4016-a019-7b509c500925",
      "text": "Climate models systematically overestimate climate sensitivity to CO2, and modelers exclude forcings and feedbacks that contradict that overestimate."
    },
    {
      "id": "1f058c8c-08ac-46ad-877c-0208691256a3",
      "text": "Elections in Donbas are controlled by armed Ukrainian punishers."
    },
    {
      "id": "dd3a5f5e-8f8b-413c-aeea-d834efd4e544",
      "text": "Countries with high mask compliance and mask mandates experienced increased COVID-19 death rates and performed no better than countries with low mask usage."
    },
    {
      "id": "6bf545cb-3bff-4ddc-8f89-114d02659460",
      "text": "Lviv displayed a swastika during City Day celebrations."
    },
    {
      "id": "3c5f8517-91df-41c8-8459-0d77c6dc7d7e",
      "text": "An air raid siren was intentionally sounded during U.S. President Joe Biden's visit to Kyiv."
    },
    {
      "id": "da2a8837-bd8a-488f-b164-1c4fae90ea79",
      "text": "The IMF and Kyiv failed to reach an agreement on Ukraine aid."
    },
    {
      "id": "a76a4188-0e42-4ace-8773-87e990cd6889",
      "text": "Sanctions on Russia are destroying Ukraine's economy."
    },
    {
      "id": "eb148cdc-958c-4243-8ce8-3c11c0a12781",
      "text": "A Ukrainian minister urges banning Russian and Belarusian tennis players from winning matches against Ukrainian players."
    },
    {
      "id": "dd3c8ab9-8224-4615-94cc-d1f1cb267c2c",
      "text": "Pfizer released a list stating the Pfizer–BioNTech COVID-19 vaccine causes more than forty specific medical side effects."
    },
    {
      "id": "28d22d59-1bc2-476b-9215-4cdcb989a85d",
      "text": "Said the Ukrainian parliamentary speaker is a neo‑Nazi and an anti‑Semite."
    },
    {
      "id": "e9eefdee-16bf-495f-a832-ee0139b509cc",
      "text": "Ukrainian flags were banned at a refugee center in Spain."
    },
    {
      "id": "c75d19d0-b827-4f7c-b170-1ef7d2a1981c",
      "text": "No hurricanes occurred this season despite forecasts for high activity; this proves climate change theory is wrong and the season was a light hurricane season."
    },
    {
      "id": "f9c52047-618d-4331-88dc-f291d6a4ce80",
      "text": "More than 500 scientists and professionals told the U.N. there is no climate emergency."
    },
    {
      "id": "bc454b72-954f-46b7-aade-de6e5b24af23",
      "text": "London apologized to Aeroflot for a UK Border Force search."
    },
    {
      "id": "13af3e5a-4df9-47c5-98ee-bc08c1c5913c",
      "text": "StopTheEvolution has fought Russian propaganda in Ukraine for five years."
    },
    {
      "id": "4dff9410-a9bc-4ecc-a307-76f78973442f",
      "text": "The Organization for the Prohibition of Chemical Weapons did not determine the origin of the nerve agent used in the Skripal poisoning."
    },
    {
      "id": "c92e9220-0252-4c02-8acb-b3c2083cba47",
      "text": "The Ukrainian government will punish people who refuse to speak Ukrainian."
    },
    {
      "id": "c96c6387-3f57-4c7f-a8e8-f0e06f5e9739",
      "text": "A captured soldier erased a \"Banderivets\" tattoo."
    },
    {
      "id": "3e3e514f-a344-49e3-9ae4-aa583531de37",
      "text": "Rheinmetall's shares fell drastically after Ukraine's counteroffensive failed."
    },
    {
      "id": "790acdda-db12-4c6f-8116-86ea91021854",
      "text": "Ukraine's Foreign Ministry wants to make peace with Russia."
    },
    {
      "id": "5d722fd0-ca08-44f7-a983-221076de71b0",
      "text": "French President François Hollande regrets sanctions against Russia."
    },
    {
      "id": "3debbefc-996d-46cb-a12a-4ac0af7f86d0",
      "text": "More than 500 scientists and professionals sent a declaration to the United Nations stating there is no climate emergency."
    },
    {
      "id": "f96b20fc-1ab4-4491-b9f1-630b04cbe616",
      "text": "Americans tested a coronavirus vaccine on Ukraine's military."
    },
    {
      "id": "5f8731d0-460d-4542-8385-9bcb6bc5981b",
      "text": "COVID-19 case numbers are inflated because PCR tests are overly sensitive; 90% of positive COVID-19 PCR tests are false positives."
    },
    {
      "id": "b2c9d261-a6a2-4709-a811-9be31d2f457e",
      "text": "AIDS is spreading across Ukraine and originates in Donbas."
    },
    {
      "id": "6a9746d2-5c0b-44e5-a69e-6b27616cd607",
      "text": "Vaccines cause sudden infant death syndrome, and infant deaths fell dramatically during lockdowns because far fewer vaccines were administered."
    },
    {
      "id": "87da1479-4c72-46b2-ad3b-3ef960418972",
      "text": "Ukraine's blockade of water to Crimea caused an environmental disaster."
    },
    {
      "id": "6295178e-d150-4ad0-b2b4-bde698a910b4",
      "text": "Friends of Ukraine tore down Russian flags in Burgos, Spain."
    },
    {
      "id": "1487337e-caf6-43ec-972a-52a6255f4bea",
      "text": "A new oral spray deactivates 98% of the coronavirus in the mouth."
    },
    {
      "id": "c98ab273-00fa-4c64-b3ca-2a928745714e",
      "text": "Pfizer CEO's wife died from complications of the COVID-19 vaccine."
    },
    {
      "id": "3d5c69d0-3692-4fd9-a879-931941f5f802",
      "text": "Ukraine is the leading importer of agricultural products into Crimea."
    },
    {
      "id": "a7959296-3463-4b6b-ac53-a3b5e6f20c25",
      "text": "Ocean waters and the marine environment are the primary drivers of climate change."
    },
    {
      "id": "46dfe14e-2446-41b3-8747-a3a01d5aba71",
      "text": "Bill Gates and health agencies are staging a new pandemic targeting children, which the WHO and the UK government say is already happening."
    },
    {
      "id": "8d8afe95-d204-4f32-bd7a-b64c673c9a80",
      "text": "Intravenous hydrogen peroxide enables the body to cure itself of all diseases."
    },
    {
      "id": "bcd2ffe8-1e6d-4dcf-9357-644c21234bcc",
      "text": "Russia’s actions are justified by international law"
    },
    {
      "id": "6cdd0296-e032-4a5c-b6dc-7d6233af6947",
      "text": "The European Union will force Ukraine to accept African refugees."
    },
    {
      "id": "872e2a83-256e-44e0-9dd8-4401545586db",
      "text": "A Ukrainian MP proposed mass deportation of Crimeans."
    },
    {
      "id": "ff1d84ad-9d70-4739-8deb-adf84694c761",
      "text": "The Parliamentary Assembly of the Council of Europe approved a resolution abolishing political sanctions against Russia."
    },
    {
      "id": "538fcc42-d402-4e1c-aa53-1b48fd92e7bd",
      "text": "Volodymyr Zelensky bought Bill Cosby's New York townhouse for $30 million."
    },
    {
      "id": "ab291336-2b55-470b-96e8-5a65d246d084",
      "text": "Poland refuses to admit Ukrainian refugees."
    },
    {
      "id": "e8bffc79-ebb0-494b-8a55-67a20c377fdb",
      "text": "COVID-19 is a type of flu and is not a pandemic; PCR tests have a 94% false positive rate; only 98 people died of COVID-19 in Ireland."
    },
    {
      "id": "566193e3-aa65-4122-bb4d-3d4d7a216c13",
      "text": "The US called on NATO countries to prepare for war with Russia and to deploy troops to Ukraine."
    },
    {
      "id": "2bb8aa19-18f7-489f-adc2-cb4407229de6",
      "text": "Ivermectin augments the effects of cancer therapies"
    },
    {
      "id": "ac72e986-3f42-4894-a51b-3f463b4c4847",
      "text": "The WHO declared a public health emergency to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus."
    },
    {
      "id": "ec663f1d-8af0-4505-9c17-ea09a60e57b8",
      "text": "AFU Brigade holds a rally and seizes control."
    },
    {
      "id": "4cd0e4e5-8f7a-4621-9e10-b10679c29f79",
      "text": "The dam blocking water to Crimea was blown up."
    },
    {
      "id": "77407c57-d36f-48f7-b5d4-3cf0ba9fc3a4",
      "text": "Ukrainian forces shelled the UN mission office in Siverodonetsk."
    },
    {
      "id": "3e182aa3-750a-475f-9344-ece860104732",
      "text": "Ukrainian refugees in Europe illegally tap power grids to mine cryptocurrency."
    },
    {
      "id": "5896fac0-b57f-4633-97af-f0e71c90112a",
      "text": "The climate has always changed and will always change."
    },
    {
      "id": "807c7ea3-225f-45ad-9015-6b748822e6ac",
      "text": "All long-term tide gauge datasets show sea level rise has not accelerated."
    },
    {
      "id": "a0f4a3b8-e427-4208-b02c-9b5eb0b8a8cf",
      "text": "Tilapia contain high levels of omega-6 fatty acids that increase the risk of Alzheimer’s disease."
    },
    {
      "id": "00e918f9-e1ad-4cb6-82ea-c57ef9f80f87",
      "text": "A study showed Pfizer’s COVID-19 vaccine weakened children’s immune responses to other viruses."
    },
    {
      "id": "79868006-5b4b-4920-8227-9896c47f4145",
      "text": "The West lost the Russian propaganda war."
    },
    {
      "id": "74cbf840-383d-4abb-a196-7cc930a7b248",
      "text": "The United States will not hand over Abrams tanks to Ukraine."
    },
    {
      "id": "42f04497-b4b3-4afb-9d2d-de42d308d3c3",
      "text": "A CDC report confirms that nearly 120,000 children and adolescents in the USA died suddenly by October 2022 as a result of COVID-19 vaccination."
    },
    {
      "id": "0601535a-5232-49d6-ac8a-f339184b8117",
      "text": "The Kyiv government admits Kyiv's smog was caused by low-grade coal."
    },
    {
      "id": "5cda20d0-a6e6-4c3c-8593-cc0b033e9c5e",
      "text": "The EU ends visa-free travel for Ukrainians because of the Donbas war."
    },
    {
      "id": "f66f4c85-4df6-43f8-a55e-eca41f06bea1",
      "text": "Cholera was found in the Azov Sea."
    },
    {
      "id": "0e6fca58-3d0b-46e9-b950-d945afd31999",
      "text": "There is a torture chamber in the Kharkiv area."
    },
    {
      "id": "76041811-58a8-45f0-904e-d755003438d3",
      "text": "A monument to Stepan Bandera in Lviv was torn down."
    },
    {
      "id": "f2e65053-2d71-4b6a-9137-3d0a10b89f19",
      "text": "Polar bear populations are increasing and are thriving despite diminishing sea ice."
    },
    {
      "id": "651fa07f-027d-4660-9414-920e8e11c88e",
      "text": "Doctors were murdered to protect Big Pharma profits and to silence holistic health practitioners."
    },
    {
      "id": "45c0f4a0-2167-4cdc-93c8-d916583cc974",
      "text": "Official observed temperatures are consistently below global warming projections; melting polar ice causes an ice age."
    },
    {
      "id": "e623426b-f1ef-4797-b377-5be61d70af2d",
      "text": "Russian troops mined the Zaporizhzhia Nuclear Power Plant."
    },
    {
      "id": "1ccc23c1-d3ed-4fcf-9782-521addcd2f77",
      "text": "Ukraine's nuclear energy system has collapsed."
    },
    {
      "id": "878edfcc-e3b6-49e1-b4b1-902ef152c55e",
      "text": "The Ukrainian government will fire all feldshers."
    },
    {
      "id": "d43d3481-5742-4c58-b1c9-badc139150c1",
      "text": "The Johnson & Johnson vaccine contains aborted fetal retinal and kidney cells."
    },
    {
      "id": "23af801d-509e-4d13-85ba-aa38818ea8a7",
      "text": "Le Parisien reports an AIDS epidemic is sweeping through Ukraine's armed forces."
    },
    {
      "id": "e4866b76-12de-4374-aa13-8007f1d044c6",
      "text": "Roshen produces chocolate bars featuring Vladimir Putin."
    },
    {
      "id": "efbf5b1c-1b5e-41b7-a8f1-62089a598ada",
      "text": "Sean Penn refused to travel to Ukraine because of a corruption scandal."
    },
    {
      "id": "ddc2535e-ae0f-434b-9768-1fa0764dbb0b",
      "text": "Ukraine's military is preparing sabotage operations in Crimea."
    },
    {
      "id": "e5c14dc3-196c-44f7-a92e-381ff2a9404e",
      "text": "Non-vaccinated people are not tested, so the increase in COVID-19 cases is entirely caused by vaccinated people."
    },
    {
      "id": "ef776dbf-e915-450c-92a7-cdb90bea6369",
      "text": "A French journalist reported that Ukrainian forces bombed the Donbas."
    },
    {
      "id": "60aacdab-d3d7-4fb3-9782-d187daf68d2e",
      "text": "The EU called on Ukraine to lift its ban on Russian-language education."
    },
    {
      "id": "ec042255-3b6c-48b9-b4cb-ba5cfadee254",
      "text": "Bulgaria invited Recep Tayyip Erdoğan instead of Vladimir Putin to the commemoration of Bulgaria's liberation from Ottoman rule."
    },
    {
      "id": "af0baa1b-e5a3-440f-b047-1812f1485d82",
      "text": "Human activity is not causing the observed increase in atmospheric carbon dioxide."
    },
    {
      "id": "8ba73e30-7316-4bd2-8e27-627a554098b5",
      "text": "A study found electric vehicles are considerably worse for the climate than diesel cars."
    },
    {
      "id": "c2283ea3-0288-429d-b859-4af79cf5bfe0",
      "text": "Ukraine’s Presidential Administration does not know who founded Canada."
    },
    {
      "id": "0a30e6a2-2ecb-4080-bb75-910ab4a7bcff",
      "text": "Ukrainian authorities are seizing cars from all Ukrainian citizens."
    },
    {
      "id": "9a6fdaf1-bfe1-4cd2-a54d-d21955fb6eb4",
      "text": "Great Barrier Reef sea surface temperature has not changed in the past 150 years."
    },
    {
      "id": "3712e970-6cda-45e7-bedd-818a6e1a11d4",
      "text": "A court ruled PCR COVID-19 tests are 97% inaccurate and unfit for purpose, and mainstream media did not report this."
    },
    {
      "id": "2232fd36-afdc-4f1f-8969-f02be4e9d63a",
      "text": "Mifepristone is unsafe and causes serious health harm."
    },
    {
      "id": "af3d86ef-53f0-4580-8880-ce57b587280f",
      "text": "The EU will deport Ukrainians who mobilize for military service in Ukraine."
    },
    {
      "id": "c8eaf52b-6580-4071-9e29-9c2cf6aafc79",
      "text": "The Finance Ministry says Ukraine will face economic collapse without an IMF bailout."
    },
    {
      "id": "036a2d59-d909-4bb5-9f34-5ef7c0deac6f",
      "text": "A pizzeria removed a Nazi chevron and a photo of the burning Trade Unions House in Odesa from its wall before U.S. Secretary of State Antony Blinken arrived."
    },
    {
      "id": "cb3af57e-49b2-4874-ba84-c7d384dec42f",
      "text": "COVID-19 vaccines were not tested in animals or in humans before being released to the public and are unsafe."
    },
    {
      "id": "989cf3db-1df9-43c5-a742-683491db2209",
      "text": "The EU has reinstated visa requirements for Georgia and will next impose visa requirements on Ukraine."
    },
    {
      "id": "184a591a-6388-4cf3-8aba-ee33dac18ee4",
      "text": "An Italian journalist says Ukrainians are fighting alongside ISIS."
    },
    {
      "id": "442a9332-d235-4c4e-8005-e099521eb2d5",
      "text": "A US advertisement urges people not to financially support Israel and to instead financially support Ukraine."
    },
    {
      "id": "46403870-19ff-4ad8-8ef0-14f1f2d46780",
      "text": "Victoria Nuland did not demand that Ukraine implement the Minsk agreements."
    },
    {
      "id": "8ca5dd5c-0d80-4823-82d0-3dc17b6c640b",
      "text": "Germany supports the annexation of Crimea."
    },
    {
      "id": "b5b0acb6-0c0e-4c74-8cd8-c9934226037e",
      "text": "Ukrainians decorate Christmas trees with swastikas."
    },
    {
      "id": "839cea27-8092-4523-827e-6d8fbc40ff8f",
      "text": "Ukrainians choose Russia because Kyiv committed atrocities."
    },
    {
      "id": "e6c7fc38-eaa7-401b-b455-e32295ee969d",
      "text": "Ukrainian mobile operators charged residents of the Luhansk People’s Republic for the antiterrorist operation."
    },
    {
      "id": "9ba58870-e662-45a5-beae-091bfa16e49e",
      "text": "President Volodymyr Zelenskyy requested that foreign troops be deployed to Ukraine."
    },
    {
      "id": "808f70bf-16bf-40a3-bc4e-ad826c69f05a",
      "text": "Ukraine admits Ukrainian-made parts were used in North Korean missile engines."
    },
    {
      "id": "ceb27820-5d30-455b-b348-a5ae9803d431",
      "text": "A Ukrainian colonel proposed razing Donbas and Crimea."
    },
    {
      "id": "170e5188-3fdf-4846-894e-f89b08183c86",
      "text": "Babies must not drink fluoridated water because their blood-brain barrier is not fully formed until six months old."
    },
    {
      "id": "9e987e03-e570-493b-a318-ff4663b45779",
      "text": "Angela Merkel supports ending sanctions against Russia."
    },
    {
      "id": "cabce7be-e46d-4bbf-bda0-e2c027ff8945",
      "text": "American farmers supported Russia's response to EU sanctions."
    },
    {
      "id": "1ecda97a-611c-48d8-9ece-7a0b19668b9f",
      "text": "SARS-CoV-2 (the virus that causes COVID-19) does not exist and has never been isolated."
    },
    {
      "id": "6219d853-203f-4cd8-a7ed-eaccc37db4e5",
      "text": "Vitamin K shots contain toxic levels of aluminum, and Hepatitis B vaccines contain toxic ingredients."
    },
    {
      "id": "25525cdf-c733-4a85-91ab-f2adc6192748",
      "text": "A Ukrainian soldier's widow was forced to pay for the equipment that killed him."
    },
    {
      "id": "d948ec84-aa50-4245-b854-5ee6998c7962",
      "text": "COVID deaths were vastly overcounted."
    },
    {
      "id": "ecfc4818-605c-4c8b-91a2-04ed27c8e3cb",
      "text": "The Vinnytsia Moscow Patriarchate Orthodox Church has been seized."
    },
    {
      "id": "f8b32d99-e10d-4e9d-b2cf-02d421202d9c",
      "text": "Ukraine says Crimea is experiencing a drought."
    },
    {
      "id": "a53beda4-d9d7-4a1d-b20e-c55ef5fdc365",
      "text": "Ukrainian teenagers have the lowest average IQ of all European countries."
    },
    {
      "id": "9dc49aa7-fb08-4c49-ab0d-d233037511f7",
      "text": "A Ukrainian admiral praised Russian military might in Crimea."
    },
    {
      "id": "9afd40ce-83d2-4ba6-b3d4-846849c4f834",
      "text": "Antisemitism has increased in Ukraine."
    },
    {
      "id": "55d2779c-e217-438b-a824-b709c22a345c",
      "text": "The DTaP vaccine causes sudden infant death syndrome (SIDS)."
    },
    {
      "id": "0dfab435-0854-4cbc-ad80-25e02d0ed5b4",
      "text": "Russia is launching an offensive and foreign embassies have evacuated Kyiv."
    },
    {
      "id": "012f7414-c063-4bb0-821e-03ae3200a374",
      "text": "A volunteer in Oxford University's COVID-19 vaccine trial died."
    },
    {
      "id": "16679f67-f92b-4c97-8b93-52f58e61267c",
      "text": "Russian forces landed in Odesa, Mariupol, and Kharkiv."
    },
    {
      "id": "4a4dc838-cdb8-4cd2-a8e8-b7565b489463",
      "text": "A person is 300 to 900 times more likely to die after receiving the COVID-19 vaccine than after receiving the flu vaccine, and vaccine adverse events are widely underreported."
    },
    {
      "id": "5bd060ce-e57a-4b9e-8ce7-adb07d86cbe0",
      "text": "Ukraine's Health Ministry abandoned cancer patients."
    },
    {
      "id": "a367c419-5c06-4d96-b3aa-e68d07bfe89b",
      "text": "A Yale study found that COVID-19 mRNA vaccines cause vaccine-acquired immunodeficiency syndrome (VAIDS) and post-vaccination syndrome (PVS)."
    },
    {
      "id": "2d2a3a96-0b99-495f-8ccf-3917ec3328a7",
      "text": "Pfizer documents confirm mRNA COVID-19 vaccines contain graphene oxide."
    },
    {
      "id": "f56313c6-4c1b-41ae-abb7-5b3adcd6fcda",
      "text": "Western media disclosed that American mercenaries are fighting for Ukraine."
    },
    {
      "id": "2db09ac7-7480-488d-95a4-cd52c3d6852d",
      "text": "Flu shots cause false positive COVID-19 test results."
    },
    {
      "id": "76c5a892-9eec-44fb-b18a-8dc8f6ec54d5",
      "text": "A photo shows Ukrainian tanks gathering in the ATO area in Ukraine."
    },
    {
      "id": "1975bd25-208c-49f9-81ab-e7ba511bdcd1",
      "text": "The Moderna and Pfizer vaccines contain a bovine protein that causes an autoimmune response in recipients, making many of them unable to eat beef."
    },
    {
      "id": "c2f9ead9-e144-4a77-a370-18b0e465aa10",
      "text": "The Pentagon will not use $5.8 billion allocated for aid to Ukraine by the end of the fiscal year."
    },
    {
      "id": "0518a0f6-d6fb-445b-a6b2-de32bb4966d7",
      "text": "The SBU concluded that Russia did not murder Andriy Parubiy."
    },
    {
      "id": "87b8a5d6-25e2-4a58-b32f-2b9fd63d7259",
      "text": "Scientists ignored solar particles, cosmic rays, the interplanetary magnetic field, and Earth's weakening magnetic field and concluded that climate change is caused by human activity."
    },
    {
      "id": "ea68f6bb-d8e9-4d0b-9fac-e359016c7dbf",
      "text": "The WHO declaration of a public health emergency is a scheme to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus rebranded."
    },
    {
      "id": "ab184fe7-413c-4714-9a1b-9f2c04d1ded4",
      "text": "Kyiv will cull stray dogs for the Eurovision Song Contest."
    },
    {
      "id": "c4b7ef6a-e82f-45ce-9dc2-1ef84742ea6c",
      "text": "The Ukrainian Army is funded by money from Viktor Yanukovych."
    },
    {
      "id": "21557975-8f55-475c-9113-1599cc88d48e",
      "text": "Ukrainians will participate in the Syrian war."
    },
    {
      "id": "87c7e218-1700-44f0-8a1e-ccef92bb6df1",
      "text": "Most victims of the 1918 Spanish flu died of bacterial pneumonia caused by wearing face masks."
    },
    {
      "id": "346f5eac-8083-44de-a2a5-c22b0a3c68b0",
      "text": "Valerii Zaluzhnyi told Ukrainian soldiers not to fear death because they had no chance of survival."
    },
    {
      "id": "e4b05630-1cf1-473b-9935-4d9df2441747",
      "text": "France's best sniper was killed in Ukraine."
    },
    {
      "id": "59db8bb7-8c32-4cb4-b93a-9377f27e5bb9",
      "text": "The Ukrainian government is repressing ethnic Hungarians in Transcarpathia."
    },
    {
      "id": "214150b4-7ba4-4e26-99e8-8ca6b7d24035",
      "text": "NASA officially recognizes Crimea as part of Russia."
    },
    {
      "id": "867c8371-61c7-4133-9fe0-a60250a5dafa",
      "text": "Ukrainian TV channels are forbidden from broadcasting footage of a handshake between Vladimir Putin and Petro Poroshenko."
    },
    {
      "id": "7d1184be-08c7-4303-bb74-bb6301ab3676",
      "text": "Grid batteries are fire hazards."
    },
    {
      "id": "3f363d10-544f-4a29-bd9f-7e7a84fd3014",
      "text": "The two largest banks in Ukraine will default."
    },
    {
      "id": "be5ca216-b212-4b53-8373-356a889d9f75",
      "text": "COVID-19 vaccination of pregnant women caused an increase in the U.S. infant mortality rate in 2022."
    },
    {
      "id": "992e777b-2d2d-4164-9166-21819ed67314",
      "text": "Governments and health authorities lied about COVID-19 case numbers, treatments, natural immunity, and the virus’s origin, and COVID-19 vaccines and control measures did not work."
    },
    {
      "id": "67d60464-0d44-475b-a6ff-e2ba49d1366e",
      "text": "The UN confirms that a Ukrainian military strike in Odesa caused no injuries."
    },
    {
      "id": "7089e061-f356-4b79-b1f2-651d5988f658",
      "text": "80% of people who received the Moderna COVID-19 vaccine experienced significant side effects, and children in Sudan contracted polio from the polio vaccine."
    },
    {
      "id": "e57ae7e6-185e-465f-bf0a-b4ae49ea0b5b",
      "text": "Ukrainian train security detects passengers who oppose the Zelenskyi regime."
    },
    {
      "id": "28d0a5e2-e288-4da3-865d-b61255d8b0a2",
      "text": "If I don't get the vaccine, only I will be harmed and no one else will be harmed."
    },
    {
      "id": "1d882ab7-3448-4e70-aceb-c9654f71e66b",
      "text": "The United States violated the INF Treaty."
    },
    {
      "id": "6e785240-8ffb-4abe-a014-d7a8b7f6fb74",
      "text": "79.4% of infants who died from SIDS received a vaccine on the same day they died."
    },
    {
      "id": "3bd375a2-f60c-4e67-95d2-8dd33dda54c4",
      "text": "The EU and US accuse the Kremlin of disinformation and hide their pandemic failures."
    },
    {
      "id": "a6a36d51-bf43-429e-ace3-d335b25e878a",
      "text": "UK government Vaccine Surveillance Reports show fully vaccinated people are developing AIDS."
    },
    {
      "id": "37bec350-cb9c-4cf5-b0e9-f634d9686f01",
      "text": "President Joe Biden told people to get vaccinated to protect themselves from hurricanes."
    },
    {
      "id": "d365e127-d27c-4834-a1de-fc0930515ddd",
      "text": "A World War II veteran was beaten in Kyiv."
    },
    {
      "id": "ebf98039-232c-4282-8676-4453abfe60ac",
      "text": "The UN Secretary‑General has launched tribunal proceedings against Petro Poroshenko."
    },
    {
      "id": "b8b39438-ddcf-47ac-852c-d9a001d59edf",
      "text": "A California study found vaccinated individuals are more susceptible to COVID-19 variant infections than unvaccinated individuals."
    },
    {
      "id": "b8b3465b-e078-4efb-ae6e-e6a1726f2fa9",
      "text": "Vaccines contain the complete genetic code of an abnormal human containing cancer-causing genes."
    },
    {
      "id": "5ab140aa-857e-442d-bd98-0f4a3815b9bf",
      "text": "Charcoal absorbs and neutralizes poisons and treats diarrhea and bloating."
    },
    {
      "id": "b0ba9c40-a67a-46d7-b196-e03f3c5aaa9c",
      "text": "Erdogan says Turkey will build a nuclear bomb."
    },
    {
      "id": "1dcbd6fb-23d1-4f37-8d0b-c3715e918db3",
      "text": "Babies born to mothers who received COVID-19 vaccines are dying at higher-than-normal rates and the COVID-19 vaccines caused those deaths."
    },
    {
      "id": "41702860-e9aa-4135-bcb7-e01f4817b34d",
      "text": "The German Foreign Minister said that supporting Ukraine is more important than the interests of German voters."
    },
    {
      "id": "cd7c217a-f1df-4b12-ba39-e679935643a3",
      "text": "COVID-19 mRNA vaccines alter the human genome; SV40 causes cancer in humans; regulatory agencies knew COVID-19 vaccines were contaminated."
    },
    {
      "id": "ae993dea-9d4f-41e4-9864-aa6def24b890",
      "text": "Erecting a single wind turbine produces a staggering quantity of CO2 emissions, and a significant proportion of retired turbine blades are sent to landfill and cannot be recycled."
    },
    {
      "id": "d18ea420-7fc8-4f4d-b3f8-69befdaee398",
      "text": "COVID-19 vaccines cause more hospitalizations than they prevent."
    },
    {
      "id": "82223086-44ab-4f8a-bb20-2469fbc0fe5f",
      "text": "Ukrainians were detained at the Poland–Germany border."
    },
    {
      "id": "970dbc26-0b71-46b5-9e3b-d3d66cffe827",
      "text": "Coral cover on the Great Barrier Reef is at record-high levels, and the Great Barrier Reef is not threatened by climate change."
    },
    {
      "id": "6ae0e573-7a63-4ebf-8915-b6673547e7a5",
      "text": "This is a brush rake used to clear underbrush and forest-floor debris that creates fuel for wildfires."
    },
    {
      "id": "1cbefbd5-9c0b-427d-bb6e-c17b315e53bd",
      "text": "Ukraine recognizes a one-legged person as fit for military service."
    },
    {
      "id": "0bccaf8d-81f8-4dc6-a43b-f49b0a453569",
      "text": "Kyiv admits it shelled civilian areas in the Donbas."
    },
    {
      "id": "11066e29-dc62-4fd0-83f9-58da50d5bc4d",
      "text": "E-cigarettes cause milder lung damage than combustible cigarettes but cause equal or greater harm to the cardiovascular system than combustible cigarettes."
    },
    {
      "id": "66083cd8-4f78-4c40-aaea-4e52211f0454",
      "text": "A chemical in Cheerios and Quaker Oats causes infertility and delayed puberty."
    },
    {
      "id": "e37a656e-2b55-482a-a4d0-7e3cc66ebe0b",
      "text": "One in every 500 children under five who received the Pfizer mRNA COVID-19 vaccine was hospitalized with a vaccine injury."
    },
    {
      "id": "05bdc8cc-dd35-4620-a59d-ec3c72ed2731",
      "text": "Vaccines did not eliminate polio."
    },
    {
      "id": "65cbc702-99e8-4621-8a81-899b350a7a83",
      "text": "Russian media reported that a football player was appointed as ambassador."
    },
    {
      "id": "7b229a8c-d88f-46c0-b447-c58879a2e92e",
      "text": "Pfizer’s COVID-19 vaccine causes “turbo cancer.”"
    },
    {
      "id": "7a9d517e-5f42-4e1c-8c54-b33b67939c08",
      "text": "The United States State Department recognized Vladimir Putin as the President of Russia."
    },
    {
      "id": "5e4f1ea6-61f3-40d0-a513-02d3958732cf",
      "text": "Food supplements restore perfect blood sugar levels and cure Type 2 diabetes."
    },
    {
      "id": "e33b45ec-40c9-4bac-a8d9-ffdf4be25ed0",
      "text": "An Italian landmark collapsed because Italy diverted public funds to Ukraine."
    },
    {
      "id": "de88b89a-982e-47ea-8d7a-c0b2fbd6dabb",
      "text": "Changes in Earth's orbit and axial tilt are responsible for the observed warming, and humans are not warming or cooling the planet."
    },
    {
      "id": "0ee2c48e-a733-454d-8a13-3b84573113c4",
      "text": "COVID-19 vaccines are experimental."
    },
    {
      "id": "26d73c11-429e-418c-917d-8941d43cf025",
      "text": "A Ukrainian town asked President Vladimir Putin of Russia to provide natural gas."
    },
    {
      "id": "a3cb0615-5ec8-4cff-ae0d-afc22f1c70c2",
      "text": "Trump persuaded Putin not to strike Kyiv while Western leaders were in Kyiv."
    },
    {
      "id": "426cabef-a0b8-48c3-b48a-30b49a193166",
      "text": "COVID-19 vaccinations caused an increase in COVID-19 cases."
    },
    {
      "id": "225bd941-a6dc-49cf-af65-19811da32bf6",
      "text": "The Sun, not human emissions of carbon dioxide, is the main cause of warming in recent decades, and the UN IPCC systematically biases its data selection."
    },
    {
      "id": "20dc25ab-5389-4dff-a43c-dfe9d7bfc7ce",
      "text": "Ivermectin and fenbendazole cure stage-four cancer."
    },
    {
      "id": "a15196b8-40cf-4a2e-9b8d-b3d7e099060c",
      "text": "Russia has no obligation to Ukraine under the Budapest Memorandum."
    },
    {
      "id": "19b94fb9-4b53-49f7-a541-698272ac5600",
      "text": "Ending trade with Russia has destroyed Ukraine's economy."
    },
    {
      "id": "a8f04bd3-0b9f-4afc-9958-ee3fd9b741a1",
      "text": "Germans are uneasy about the Ukraine–Russia debt repayment lawsuit."
    },
    {
      "id": "3992463a-fde6-4ecd-b942-29d355ec638b",
      "text": "Solar panels heat up their surroundings and harm the surrounding environment."
    },
    {
      "id": "d465212c-f927-43a4-9067-b9959b145c98",
      "text": "Colloidal silver is effective for all infections."
    },
    {
      "id": "8dd89c11-2e8d-425a-b0b7-0d1e37f27418",
      "text": "The coronavirus is as deadly and as dangerous as seasonal flu."
    },
    {
      "id": "46def0c8-57f7-4a96-b04c-91488bfcbbe6",
      "text": "Russia is the top importer of Ukrainian arms."
    },
    {
      "id": "01d537f0-cceb-4074-a220-f7352b73d9af",
      "text": "The bodies of 286 women were found near Krasnoarmiisk."
    },
    {
      "id": "3eaa9fd6-d488-4d05-bb97-db904c045b1f",
      "text": "The pandemic is over in the UK; most people already had prior immunity and the UK has reached community immunity; viruses do not cause waves."
    },
    {
      "id": "6834f333-8ff8-4fa0-830a-d95ad9536868",
      "text": "Children with mitochondrial disorders are at increased risk of severe adverse reactions caused by vaccines."
    },
    {
      "id": "34d3a385-3440-4419-813f-5a6f201b8e8c",
      "text": "The MMR vaccine contains toxic ingredients that cause encephalopathy."
    },
    {
      "id": "3b05075a-6249-4034-8d5f-0b4b61ae375e",
      "text": "In the UK, vaccinated people have a higher SARS-CoV-2 infection rate than unvaccinated people."
    },
    {
      "id": "9b905695-6c43-4956-b510-5ede2c0cadea",
      "text": "Hydroxychloroquine, azithromycin, and zinc cure COVID-19."
    },
    {
      "id": "9edfd059-7cba-4282-b685-3ff4a5c6784f",
      "text": "Josep Borrell supports resolving the conflict in Ukraine by military force."
    },
    {
      "id": "1c5f3940-618f-445f-8bae-498cf3a57328",
      "text": "New research shows the COVID-19 vaccine spike protein enters the bloodstream and causes blood clots, heart damage, and brain damage."
    },
    {
      "id": "5187f6b9-b01a-48c8-a5cb-7b50f59b98cd",
      "text": "The MHRA has declared COVID-19 vaccines unsafe for use in humans based on Yellow Card evidence."
    },
    {
      "id": "7c020a8b-3a1d-4bf5-9b2b-f68ed67a83ce",
      "text": "Scientists found that the SARS-CoV-2 virus contains a tiny DNA sequence identical to a sequence patented by Moderna three years before the pandemic began."
    },
    {
      "id": "0097c1c4-91ca-4efc-9c12-92cb73fe1d48",
      "text": "\"Ukraine's EU Association Agreement was a five-year disaster.\""
    },
    {
      "id": "fadaf7a0-1951-41a0-be28-ce7cbbfd2e13",
      "text": "World Jewish Congress recognizes Crimea as part of Russia."
    },
    {
      "id": "75fd2ea3-890e-407e-bc4e-bb4dcffb1d52",
      "text": "The most vaccinated communities have higher COVID-19 case rates than less vaccinated communities, according to a Harvard study."
    },
    {
      "id": "c1e9c5d8-d9bf-4f24-a146-4466e09a1c9c",
      "text": "Ukraine had no money to host Eurovision 2017."
    },
    {
      "id": "7d63bb14-86c5-4e7c-9908-d12838f5a1e2",
      "text": "N-acetylcysteine inhibits viral replication, breaks up mucus, and effectively treats COVID-19."
    },
    {
      "id": "53b2073c-0f69-4c80-b1f7-2216bcce8ae6",
      "text": "COVID-19 vaccines are dangerous: they cause immune overreactions, suppress natural killer (NK) cells, and increase virus lethality."
    },
    {
      "id": "efb2f3a4-4a6f-4b82-891a-6e49b2a5f523",
      "text": "People who receive vaccines authorized under Emergency Use cannot sue the manufacturers; once those vaccines receive full approval people can sue the manufacturers, unless the vaccines are recommended for children, in which case people cannot sue the manufacturers."
    },
    {
      "id": "f5b4fc6e-6e89-47bc-924f-48d1652def42",
      "text": "Dr. Anthony Fauci said he wore a mask indoors for appearances, not for scientific reasons."
    },
    {
      "id": "e7a172a6-e210-4871-ba5b-5beab36f133e",
      "text": "Ukraine is preparing a nuclear provocation in Kharkiv"
    },
    {
      "id": "4afb68a8-bbcc-4e8d-af34-d5edf6095e82",
      "text": "A hepatitis A epidemic is occurring in Ukraine."
    },
    {
      "id": "46b182ba-f8b0-486e-a971-d6d8d29dcfef",
      "text": "Many locations warming faster than the global average proves climate science is false."
    },
    {
      "id": "2469a626-6d12-4a3f-8609-e8853ef4366b",
      "text": "Human actions caused more than 100% of the global warming over the past century."
    },
    {
      "id": "3eaa4b01-8d12-46ab-ab47-1870221edd96",
      "text": "The Ukrainian government will introduce food ration cards."
    },
    {
      "id": "246ad0b2-a33b-4452-9680-a021c86e97e5",
      "text": "ISIS operates training camps in southern Ukraine."
    },
    {
      "id": "37499fab-2fe7-40bd-b11e-ab87731202f7",
      "text": "Crimea has disappeared from the international agenda."
    },
    {
      "id": "91a4d43b-edc0-49ec-b3bc-3867f659b730",
      "text": "Russia destroyed several HIMARS near Kharkiv"
    },
    {
      "id": "189f80a7-6ff9-4b7b-903d-887d097cff2b",
      "text": "The flu shot contains ingredients that cause cancer."
    },
    {
      "id": "6a75e685-16dd-40a9-943b-267048380ebe",
      "text": "Ukrainian mines are killing soldiers and children in Donbas."
    },
    {
      "id": "f0a2c749-6388-420c-bdf9-1c4ee803e96d",
      "text": "Poroshenko announced that Ukraine should align its policy with Russia."
    },
    {
      "id": "02810d0a-a801-4de0-844c-925df942cad1",
      "text": "COVID-19 vaccines caused the rise in heart attacks among young people."
    },
    {
      "id": "ea9527d3-b5f8-405d-9e71-493a16e21670",
      "text": "Ivermectin sterilizes 85% of men who take it."
    },
    {
      "id": "fe728252-2f9c-4815-b02f-7699b2550a2e",
      "text": "Russian shelling in Ukraine caused an explosion that damaged an OSCE vehicle."
    },
    {
      "id": "d7aca388-acbd-4f7f-a855-c7d5c20fa685",
      "text": "The U.S. government has paid over $4.5 billion since 1986 to individuals for vaccine injuries, so vaccines are unsafe."
    },
    {
      "id": "429e49d4-f23e-4cc2-a86b-ee2c5103945b",
      "text": "Separatist forces regained control of Avdiivka."
    },
    {
      "id": "7ae75a6a-6f33-4618-8d40-749b6de55028",
      "text": "Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, and shikimic acid kills viruses including SARS-CoV-2."
    },
    {
      "id": "c8ea9f81-466b-4497-b45d-3223d1ee8247",
      "text": "Ukraine national football team excludes Roman Zozulya from its roster."
    },
    {
      "id": "72eaf4c2-1ace-4637-a279-69574883c8d2",
      "text": "Massive COVID-19 outbreaks occurred among Ukrainian military personnel during NATO exercises."
    },
    {
      "id": "465bece8-37d9-4e52-a1ec-faf9186dca40",
      "text": "Ukraine banned music performed in the Russian language."
    },
    {
      "id": "3a116cf1-f864-46f2-91a3-8becc0027791",
      "text": "ADHD is a fabricated disorder created by pharmaceutical companies to drug children for profit."
    },
    {
      "id": "e16ed705-04cc-4390-aca3-42a049dd05bc",
      "text": "A preprint of an ivermectin study in Itajaí found that prophylactic ivermectin reduced COVID-19 hospitalization and mortality by 50%."
    },
    {
      "id": "a587e2e2-5f98-4b88-911b-409af3406d82",
      "text": "Dr. Fauci said the COVID-19 vaccine that appeared safe in initial trials makes vaccinated people more likely to become infected."
    },
    {
      "id": "b49e3698-2d1f-4006-93ae-7a09a858e833",
      "text": "The graves of ATO soldiers were bulldozed."
    },
    {
      "id": "6b2476c6-a052-47ae-a228-56b6f553ca74",
      "text": "The EchoEase nasal inhaler cures tinnitus."
    },
    {
      "id": "23ca88b5-5732-4b74-9c33-93b2fdb7eb32",
      "text": "Vitamin K injections are poisonous because they contain polysorbate 80 as the main active ingredient and polysorbate 80 causes infertility and autoimmune disorders."
    },
    {
      "id": "fd8ab294-5b27-4e9c-825b-ec44b6ba1867",
      "text": "Deserts produce heat by reflecting 60–70% of incoming solar energy back into the atmosphere, and addressing global warming requires acting on deserts."
    },
    {
      "id": "5602148c-549e-4749-84e9-dad0aa357385",
      "text": "Poppers cause Kaposi's sarcoma."
    },
    {
      "id": "323c6763-57ea-48ee-87c5-c6eafc928cae",
      "text": "Biden admits he is afraid of the Russian Kinzhal missile."
    },
    {
      "id": "c4274737-78c6-4b47-a485-ba7aa9e58eec",
      "text": "Nattokinase dissolves the SARS‑CoV‑2 spike protein, and long COVID is caused by persistent spike protein in the body."
    },
    {
      "id": "b71c4569-f760-4ec8-98df-cec6d9c6793f",
      "text": "44% of pregnant women in Pfizer's COVID-19 vaccine trial miscarried."
    },
    {
      "id": "7f7a99d7-4cf6-44b2-b0b6-0de0e235dc3d",
      "text": "Ukraine increased its territory."
    },
    {
      "id": "4dc63b6d-f7f6-4201-81db-2a5e9c6a5198",
      "text": "Ukrainian military fired on civilian vehicles in Donbas."
    },
    {
      "id": "5bec62cc-de7e-4032-87af-d61602c98417",
      "text": "Kyiv will close its nuclear power plants because it lacks enriched uranium."
    },
    {
      "id": "a164e5e1-6c36-4c70-b5c6-9787277d7cf5",
      "text": "Covid-19 vaccine mRNA cannot be broken down and Covid-19 vaccines cause excess deaths and unprecedented blood clots."
    },
    {
      "id": "23c7ac75-736f-4aea-833a-28c03650c893",
      "text": "NASA says a deepening solar minimum will cause cold weather to grip the world."
    },
    {
      "id": "0b283a06-4ee5-4503-bfe0-9b2beb8081b2",
      "text": "Flu vaccines do not protect, they increase the risk of getting influenza, and they damage the immune system and the nervous system."
    },
    {
      "id": "bb8efabd-a8bb-4e5f-bd1c-fd5a7bc57468",
      "text": "The NATO chief said the Alliance has been preparing for war with Russia for eight years."
    },
    {
      "id": "59410815-11d4-4a2e-9972-0e45092f256c",
      "text": "Kyiv is preparing a PR operation targeting Crimea to disrupt Crimea's tourist season."
    },
    {
      "id": "0162d47f-70f8-40f8-a6d6-321e1f67464b",
      "text": "Boris Johnson is tired of Ukraine."
    },
    {
      "id": "953328b9-1c72-4ae1-9261-3d122cdf3d99",
      "text": "Oceanic pH levels did not decrease over the last century."
    },
    {
      "id": "ed2428ab-ce07-462c-904c-9122cd1ba168",
      "text": "Coconut oil cures Alzheimer's disease."
    },
    {
      "id": "a7a7f1ae-fd6b-4da5-b669-3516ad890958",
      "text": "Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide."
    },
    {
      "id": "8477b1b0-2cb7-48d0-b224-7367c519ff94",
      "text": "The WHO says children must not receive COVID-19 vaccines."
    },
    {
      "id": "d1122fc8-22ba-49ee-b1a7-b0292caeea93",
      "text": "A Donetsk People’s Republic separatist fell from a tower while hanging the Donetsk People’s Republic flag."
    },
    {
      "id": "e048a637-c913-454e-b38a-9e567b3309fe",
      "text": "The Kyiv government tested dangerous drugs on its own citizens."
    },
    {
      "id": "1b2b8340-6e26-4af6-99f1-7a2fe4c25820",
      "text": "Melanoma did not exist before sunscreen was invented, and low vitamin D causes melanoma."
    },
    {
      "id": "8f2585bf-bc2a-41f3-af10-5a7cef3a2716",
      "text": "Poroshenko says returning Crimea is unrealistic."
    },
    {
      "id": "7494523e-d14d-462e-8096-f2fcaa9cced4",
      "text": "Babies under 6 months have the second-highest hospitalization rate after elderly people."
    },
    {
      "id": "363767c1-812f-4b42-8491-a284197694ba",
      "text": "Ukraine is losing control of Transcarpathia"
    },
    {
      "id": "86364755-d394-481c-8c8c-312bdb7f9789",
      "text": "OSCE walked out of Donbas talks because Ukrainian officials threatened OSCE delegates."
    },
    {
      "id": "60692431-97b1-4bfb-bcbb-9d32815dea0b",
      "text": "Global media reported that Ukrainian refugees committed mass crimes in France."
    },
    {
      "id": "a9100648-867a-425d-b31e-08facd6d7ff9",
      "text": "Transcarpathia has separated economically from Kyiv."
    },
    {
      "id": "0756090e-6ed5-4879-ba64-2fa9f664c398",
      "text": "Four Ukrainian soldiers were killed in a mortar explosion."
    },
    {
      "id": "6766b9c1-406d-4828-8659-a18545ca193d",
      "text": "Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS."
    },
    {
      "id": "0a153042-81b8-458e-b186-8360e0fbc2b5",
      "text": "A photo shows refugees in Rostov being sent to filtration camps."
    },
    {
      "id": "a5fa33f1-9c5c-442c-a3b9-3e80c19749b3",
      "text": "Ukraine's new language law violates Ukraine's constitution and makes violators criminally liable."
    },
    {
      "id": "d66f6d8a-9250-454f-b215-5b34d55b6e07",
      "text": "Ukraine abandoned the Minsk agreements and is preparing to occupy Donbas."
    },
    {
      "id": "81a3712a-94f8-48c2-b3bc-6fb8cb3120ee",
      "text": "A U.S. bowling tournament broadcast an announcement saying \"Stop Funding Ukraine\"."
    },
    {
      "id": "99d12199-f4f7-4c93-90b5-7946d74fedcc",
      "text": "Pope Francis last spoke with Ukrainian President Volodymyr Zelensky."
    },
    {
      "id": "53402c0f-23bc-425f-b153-ce081085ebb8",
      "text": "Most fully vaccinated individuals will develop full-blown vaccine-induced acquired immunodeficiency syndrome by the end of the month."
    },
    {
      "id": "21aa88dc-310a-45ee-845d-deabdbade650",
      "text": "Maddie de Garay's case shows COVID-19 vaccines cause functional neurological disorder and are harmful"
    },
    {
      "id": "00df4a79-1dde-4f15-839d-cb6bf604c4a6",
      "text": "Deaths occurring within 20 days of a positive COVID-19 test are counted as COVID-19 deaths regardless of other causes, and deaths occurring after vaccination are systematically excluded from being attributed to the vaccine."
    },
    {
      "id": "36577aca-4963-4024-a0a0-7ef666c33679",
      "text": "Zaporizhia veterans were shown footage of Soviet soldiers raping Ukrainian girls."
    },
    {
      "id": "6a00b265-a1c2-4633-84bc-1379e6fb6b3f",
      "text": "A nurse fainted after receiving a COVID-19 vaccine."
    },
    {
      "id": "edfafc83-4cde-4255-8a4f-9d89f0220509",
      "text": "Anyone who brings a friend to a recruiting office will receive 20,000 hryvnia."
    },
    {
      "id": "6556fa0f-7605-4ab6-81a2-f99e0802e367",
      "text": "The U.S. did not lose substantially more lives in 2020 than in 2019; the increase over 2019’s 18,433 deaths was negligible."
    },
    {
      "id": "06292199-7dd0-43db-afde-7ae66493d4d5",
      "text": "Carbon dioxide does not cause global warming; scientists are 90% sure the Sun causes global warming; ocean acidification and harm to polar bears blamed on CO2 are not real."
    },
    {
      "id": "f7fb6eba-fa20-46e4-a4e0-5a755dd9a270",
      "text": "Smokers' lungs turn black."
    },
    {
      "id": "a1a5269c-96c4-48bb-b8cb-6724368b2007",
      "text": "2014 Ukrainian military losses are being passed off as current Ukrainian casualties."
    },
    {
      "id": "af39a7c0-63c4-43e2-aa19-fa2ce144ead2",
      "text": "A child died in Donbas as a result of a Ukrainian drone attack."
    },
    {
      "id": "1c51ce2e-fda1-4273-aeec-c291f3c753bd",
      "text": "A Morgellons cranberry-juice test extracts nanoparticles from chemtrails and air pollution."
    },
    {
      "id": "194c83a2-8011-41ad-84b4-5776ff4a4ccb",
      "text": "President Joe Biden said Ukraine must give up territory to end the war."
    },
    {
      "id": "c89a8df6-10c4-42ec-ab6f-4f235f1d6fb3",
      "text": "Pope Francis presented Russian President Vladimir Putin with the Guardian Angel of Peace medal."
    },
    {
      "id": "bd9fc77a-0eef-4c3a-ab91-047c2568670b",
      "text": "Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children."
    },
    {
      "id": "5b288e9b-9de5-487a-af64-e3301611a079",
      "text": "Greenland ice cores show no significant warming and human-caused climate change is false."
    },
    {
      "id": "8cb1b7e4-b0f6-4322-9523-e8c7544f76f0",
      "text": "Boris Johnson was paid to pressure Kyiv to oppose peace talks."
    },
    {
      "id": "9120cc9b-5192-4ad3-9f58-f0d1f74efd73",
      "text": "Dmytro Yarosh brought a machine gun to the Verkhovna Rada meeting."
    },
    {
      "id": "2e0827b1-fbe8-467c-989c-3d8579ac9421",
      "text": "A new study shows climate change is greatly overestimated because oceans are cooling the Earth far more than previously believed."
    },
    {
      "id": "d34d499f-105a-42d9-83d2-ad2031a8f07e",
      "text": "Vaginal gels with probiotics treat HPV infection."
    },
    {
      "id": "fcc04898-c13d-46f5-bf54-7bbe635d86ca",
      "text": "Ukrainian children were forced to play with a stuffed toy depicting Adolf Hitler."
    },
    {
      "id": "098b52d5-8a51-4954-9bbc-1cc8535ba6dd",
      "text": "CDC covered up a 1999 study showing a 1,135% increased risk of autism after hepatitis B vaccination."
    },
    {
      "id": "0c0e7306-ac48-4f56-8f28-b99b87fa1199",
      "text": "A Coca-Cola product tested positive for Covid-19."
    },
    {
      "id": "b681fe85-1bd7-4f44-810c-0b62519a0c80",
      "text": "In 1943 the Ukrainian Insurgent Army crucified four children."
    },
    {
      "id": "81f97fe6-7431-4f57-8955-2767cfc133ec",
      "text": "Vitamin D insufficiency accounts for the majority of COVID-19 deaths."
    },
    {
      "id": "8b33178d-bada-4494-a9ee-81b8ccf9246b",
      "text": "Global warming is only the recovery from the Little Ice Age; warming has been slower than climate models predicted; carbon dioxide benefits the Earth; global warming is not increasing the intensity or frequency of natural disasters."
    },
    {
      "id": "78cf9ac9-6b48-4912-a10a-e504a59deaa6",
      "text": "COVID-19 vaccines caused 895 serious adverse reactions in military veterans."
    },
    {
      "id": "b1cec25b-6abc-42da-9d5a-2069e6d588fd",
      "text": "European Court of Human Rights says the Russian government was not involved in Anna Politkovskaya's murder."
    },
    {
      "id": "e6280bcc-1394-4734-b33a-9210d5dd657a",
      "text": "Vaccines cause autism, ADHD, and cancer; statins provide no benefit and cause cancer and memory loss."
    },
    {
      "id": "9cf61297-8c4e-46e4-8962-f26e488d9602",
      "text": "Ukrainian TikTok users mock Charlie Kirk's murder."
    },
    {
      "id": "46e1bf37-c531-4407-93c4-8e1e35475b18",
      "text": "COVID-19 cases are directly caused by exposure to 5G electromagnetic radiation."
    },
    {
      "id": "9aaa26b2-ed57-4999-90b4-829e65b1513e",
      "text": "The video report showing civilian casualties in Ukraine was staged."
    },
    {
      "id": "ecec4097-a695-43eb-8b4c-422e968635eb",
      "text": "U.S. forces will fight for control of the Kerch Strait."
    },
    {
      "id": "0445898d-c78b-4144-8eda-758b3dd164b9",
      "text": "COVID-19 is caused by snake venom, not by a virus; COVID-19 vaccines contain snake venom that causes miscarriage."
    },
    {
      "id": "db280b6a-5898-4c98-a836-efb473b37d81",
      "text": "No healthy child in the United States died from COVID-19; one in 2,700 people is developing myocarditis from COVID-19 vaccines; athletes are collapsing during play because the vaccines cause myocarditis; and Moderna filed a patent in 2019 that links the company to the COVID-19 pandemic."
    },
    {
      "id": "736c792b-c93d-4f63-a5ad-4cc89227466a",
      "text": "Oxygen kills cancer; Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer."
    },
    {
      "id": "e4ed39b7-d2ef-4064-864f-d3c0ca196278",
      "text": "Microsoft said the Paris Olympics received the most negative feedback in the last 10 years."
    },
    {
      "id": "b557e313-9c02-40c5-b077-13c10297f514",
      "text": "COVID-19 vaccines cause blood clotting, infertility, and immune escape."
    },
    {
      "id": "87195b27-1879-4bb2-a3df-0a55408ef30d",
      "text": "55,000 years ago global temperatures were 2°C higher than today; current warming is entirely cyclical, human greenhouse-gas emissions are insignificant, and sea level rise will not occur."
    },
    {
      "id": "9d89afbd-42cd-4665-98a5-36d61a09dd4e",
      "text": "The World Health Organization and the U.S. Centers for Disease Control and Prevention discourage people from wearing face masks."
    },
    {
      "id": "bfec0579-ba3d-4480-800c-a2af8552c46e",
      "text": "The Swedish government pays 30,000 euros to each Ukrainian refugee to leave Sweden."
    },
    {
      "id": "e4bd9a5e-54db-49c0-bc0e-a1f3319f41b2",
      "text": "A Ukrainian engine caused a Vega rocket to crash in Europe."
    },
    {
      "id": "223583c4-ea91-4fb0-bc4e-6603bd51303a",
      "text": "Odesa has withdrawn from Ukraine."
    },
    {
      "id": "9da0944d-b296-4828-a890-95d79d08fc2e",
      "text": "The woman presented as the heroine in the “Sloviansk Boy’s Crucifixion” report was found among the victims of the Donetsk explosion."
    },
    {
      "id": "d4873ebc-9fb4-4d1d-b399-bd350edf35cb",
      "text": "Masks do not significantly reduce transmission of respiratory diseases."
    },
    {
      "id": "37ddfba5-8974-4a9e-8af2-98d4b5a634cb",
      "text": "Folic acid and similar compounds deplete folate, which is very serious for people with MTHFR."
    },
    {
      "id": "10eb4524-cc0d-4c59-9a55-9eb3bfdbcdb6",
      "text": "Vitamin D is more effective than the influenza vaccine at preventing influenza infection."
    },
    {
      "id": "bb37d28a-8d63-40c8-8c8c-2980333262fd",
      "text": "A video shows Kharkiv residents leaving the city en masse."
    },
    {
      "id": "ea43da93-e80d-4470-a29f-bd6a20784faa",
      "text": "The United States is unhappy with Ukraine and is seeking to replace Petro Poroshenko as Ukraine's leader."
    },
    {
      "id": "084c812c-89ae-4e1e-8844-39f37dd38c4a",
      "text": "Ukraine will intern millions of Russian citizens living in Ukraine."
    },
    {
      "id": "d552adef-ca70-4aee-9e7c-8fc83a25e7b4",
      "text": "COVID-19 vaccination increases the risk of sudden cardiac death."
    },
    {
      "id": "fc71e4be-3c6e-47dc-a1f9-513916590b5f",
      "text": "Climate models predicted three times as much global warming since 1988 as actually occurred."
    },
    {
      "id": "3de0f031-a44c-4ef8-b51e-ba461cde1b8f",
      "text": "Ukrainian is an artificial language created in the USSR."
    },
    {
      "id": "eee9305f-cab5-431b-8ccc-1d1567aa3a30",
      "text": "Fruits and vegetables with five-digit stickers starting with 8 are genetically modified and should not be bought."
    },
    {
      "id": "0c55e31a-c6b6-4d90-8886-b06d2e9921d6",
      "text": "600,000 Americans die each year from COVID-19 vaccines."
    },
    {
      "id": "523cc482-5018-4a9f-bf89-01328f70f288",
      "text": "Ivanpah's closure proves that solar power is unreliable."
    },
    {
      "id": "67bc5609-6f41-49d7-a47a-86971a7db8cd",
      "text": "A former NATO commander praised the Russian army and said Ukrainian forces should surrender."
    },
    {
      "id": "53cde36e-b505-42de-bf4a-183b7e653698",
      "text": "A Ukrainian fighting vehicle entered Donetsk displaying a swastika."
    },
    {
      "id": "97e719d0-06c0-4566-a327-e80ecfdb8eff",
      "text": "The Ukrainian military hid ammunition at the Zaporizhzhia Nuclear Power Plant and attacked the facility."
    },
    {
      "id": "30f26d7e-7d65-4925-a45f-8b4a229e28e6",
      "text": "Nationalists prevented a paramedic from saving a wounded person."
    },
    {
      "id": "1c45e614-e629-4df6-9c53-2c88e272a6be",
      "text": "Ivermectin caused the steep decline in COVID-19 cases in Indonesia."
    },
    {
      "id": "15c44e96-a11c-4de9-bde5-402e1c42549f",
      "text": "The United States deployed 400 mercenaries to Ukraine."
    },
    {
      "id": "78083908-48a8-4be3-a6be-474174355e21",
      "text": "Britons want to end all military aid to Ukraine."
    },
    {
      "id": "b743e680-f8c6-4e72-9eb0-2f4ee2ae965f",
      "text": "Natural immunity protects better than vaccination; unboosted people under age 30 had zero mortality risk; cloth face masks and school closures provided no benefits to children and caused harm."
    },
    {
      "id": "fac8cb04-fc3a-4229-9798-9943e1d279eb",
      "text": "Sales of Ukrainian seat covers will revive Ukraine's economy."
    },
    {
      "id": "529a5652-12c3-477c-a97f-f03c0aea19ee",
      "text": "Face masks do not reduce the spread of respiratory infections; COVID-19 vaccines are ineffective and cause more severe disease; ivermectin, vitamin D, and zinc effectively treat COVID-19."
    },
    {
      "id": "75d6e4b2-8ffa-4fe7-8847-527575597f9d",
      "text": "India's most populous state has declared it is officially COVID-19 free after promoting widespread use of a safe, proven medicine."
    },
    {
      "id": "5c1096fe-d81e-469c-8dcf-ea91b134de78",
      "text": "Herbs heal illnesses and Vitamin C does not, because the human body is not composed of any Vitamin C."
    },
    {
      "id": "ee76c9a0-f9fd-449f-a743-2d8ef8929e88",
      "text": "The Odessa schoolgirl's suicide was caused by the May 2 events."
    },
    {
      "id": "9bbcb642-5a9b-4821-8e6c-4f6dbf879b9d",
      "text": "Warsaw learned from Moscow how to silence hostile voices."
    },
    {
      "id": "968e7ea3-fda1-4688-8a28-4220eebe29f8",
      "text": "A top Ukrainian commander threatened to stage a revolt if President Zelensky capitulates."
    },
    {
      "id": "9cb96040-8b46-46be-a544-c2ed6385b215",
      "text": "The chance of dying from COVID-19 in California is 0.03% and COVID-19 is similar to the flu."
    },
    {
      "id": "7666b8ae-0dd8-44d7-b730-f29fb7e24f4f",
      "text": "All long-term tide gauge datasets agree that sea level rise has not accelerated."
    },
    {
      "id": "a83189a8-34cf-457f-8d7a-64232125f4e2",
      "text": "The injured child shown in Mariupol footage is not from Mariupol."
    },
    {
      "id": "8f1ab946-4c1c-47f4-9369-87bc4ede4612",
      "text": "In the United States, a person is six times more likely to be killed by a doctor than by a gun."
    },
    {
      "id": "b61d27b5-67be-4aac-b991-4c463d94cb6d",
      "text": "This is a brush rake used to clear underbrush and debris from the forest floor to remove fuel for wildfires."
    },
    {
      "id": "39baffd5-3aea-40f1-9530-55a17c607cfc",
      "text": "Ukraine’s General Staff extended the terms of service for conscripts."
    },
    {
      "id": "cd85dca8-d905-493d-aade-b80a44a8fdfb",
      "text": "The COVID-19 virus does not exist and has never been isolated."
    },
    {
      "id": "13c7c5b1-2d5d-4435-981c-edecb42f0d70",
      "text": "Turkey will seize Crimea and Donbas from Russia."
    },
    {
      "id": "c3cdb631-c5d8-40c4-9f1e-febbbfea5ca9",
      "text": "Antibodies produced against the SARS-CoV-2 spike protein cause myocarditis."
    },
    {
      "id": "f898bd5b-3db6-4e02-9f4e-cca47361e39e",
      "text": "The United States allocated $250 million to Ukraine to fund war and provocations against Russia."
    },
    {
      "id": "66c410df-05e4-49c6-bc27-30f7de73703c",
      "text": "The U.S. Embassy in Kyiv and the U.S. Consulate in Odesa were evacuated."
    },
    {
      "id": "4117e56c-a08c-40fc-b996-98b43966f125",
      "text": "Countries with higher COVID-19 vaccination rates have higher excess mortality."
    },
    {
      "id": "4591a46b-7300-465e-9949-03baf246f461",
      "text": "Ukrainian water bodies have been contaminated by the rapid expansion of cemeteries."
    },
    {
      "id": "cf032c80-cd0b-48d2-a3a5-3284519a1310",
      "text": "Ukraine postponed salary increases for its military by one year."
    },
    {
      "id": "1e50fdeb-c36d-46b3-802d-22f9866e50f4",
      "text": "Twenty-five percent of Ukrainians consider themselves Soviet citizens."
    },
    {
      "id": "a5966d2a-f407-47e3-8a42-4a1282f0e485",
      "text": "Climate scientists disagree about how much warming is caused by human emissions and whether that warming is larger than natural variability from the sun and volcanic eruptions."
    },
    {
      "id": "102b1f5f-acda-48b1-9991-3270e7b4d909",
      "text": "The United Nations recognized Crimea as part of Russia."
    },
    {
      "id": "18f01061-511e-40a4-9d51-74d81fda04d7",
      "text": "More than 70% of Ukrainians are willing to compromise with Russia to achieve peace in Eastern Ukraine."
    },
    {
      "id": "48aa9679-9512-43c5-ae3e-ddb6dfbff73a",
      "text": "Cats carry coronavirus and infect humans"
    },
    {
      "id": "ef6b9f01-065e-4d04-8b3a-f7447639a20e",
      "text": "Ukraine is hiding recordings of the Malaysian Boeing flight controllers' conversation."
    },
    {
      "id": "28d0fac9-14f5-448d-8b53-8c0cb4dd9579",
      "text": "A major autopsy report shows people who died suddenly were killed by the COVID-19 vaccine."
    },
    {
      "id": "79bf234f-2f4a-4563-8307-083e1161440a",
      "text": "Ukraine is preparing an attack on Russian nuclear facilities."
    },
    {
      "id": "10fc7bc6-6b01-4653-899e-b1a4b55ea372",
      "text": "The COVID-19 vaccine contains bacteria and HIV and prevents the body from making new white blood cells."
    },
    {
      "id": "ec13176c-6ccd-4e5c-961b-22ffa6e0dc69",
      "text": "A Harvard study found vaccinated people are twice as likely to be hospitalized after exposure to the Delta variant than people with prior natural SARS-CoV-2 infection."
    },
    {
      "id": "f8f126a8-063c-48cb-8de6-8d604b399254",
      "text": "Mass civilian casualties in the Kyiv region were staged."
    },
    {
      "id": "3417b059-848a-45db-b984-f5828b7e0775",
      "text": "Antarctica gained ice from 2021 to 2023 and global warming is over."
    },
    {
      "id": "c3dff2e4-49e4-483c-9299-2dbfb10634df",
      "text": "Recent climate change is caused entirely by changes in solar activity, and CO₂ has no connection to climate change."
    },
    {
      "id": "15c077bc-099b-4d93-8dce-aa71f092dea0",
      "text": "A virus is not the cause of an illness; it is only a necessary factor."
    },
    {
      "id": "5312ee60-8654-44b5-baee-82132f069b57",
      "text": "The U.S. government claimed vaccines gave far greater immunity than natural infection, that masks were effective, and that myocarditis was more common after infection than after vaccination."
    },
    {
      "id": "e8d68e32-e4be-43f0-a70a-913b968c2dee",
      "text": "The OSCE found that Mariupol was shelled from Ukrainian positions."
    },
    {
      "id": "6111a086-ec30-4127-8141-62b797b6ac3a",
      "text": "The U.S. is breaking high-temperature records much more often than it is breaking low-temperature records."
    },
    {
      "id": "e48cf645-1df7-4c3e-9a96-308dc5f930a6",
      "text": "Human-caused carbon emissions have no discernible effect on climate; carbon isotope ratios show recent atmospheric CO2 increases were caused by expansion of a more productive biosphere."
    },
    {
      "id": "e435799a-de64-4c69-966c-d1f15a3485ac",
      "text": "HAARP caused the recent floods in Spain, New Mexico, and elsewhere."
    },
    {
      "id": "6ab65c39-651b-4387-a0fd-0cef0e5e1e7e",
      "text": "National Security Chief urges Ukraine to prepare for war with Russia."
    },
    {
      "id": "d0faad36-3549-4637-ac1e-26d0f3a435ed",
      "text": "Russia sends only humanitarian aid to Donbas."
    },
    {
      "id": "632177bb-ffc5-4d67-afdf-5a819358649a",
      "text": "Ukraine seeks to remove the Russian language from protections under the European Charter for Regional or Minority Languages."
    },
    {
      "id": "4a32340b-0dc2-4055-a540-4eba24f18316",
      "text": "The UN admitted that a Bill Gates-funded vaccine is causing a polio outbreak in Africa."
    },
    {
      "id": "01bc9bbb-94b1-4953-ad41-e0012c776da1",
      "text": "Anti-corruption probes uncovered offshore accounts and escape passports tied to Zelensky aide Andriy Yermak."
    },
    {
      "id": "08df049d-815e-43e2-a676-499d54cc9bf9",
      "text": "Global warming stopped more than two decades ago, and half of the global temperature increase from January 1910 to January 2000 was caused by administrative adjustments."
    },
    {
      "id": "03652bb1-007e-45f9-8e4f-9f08d9cf265c",
      "text": "Wearing face masks causes carbon dioxide toxicity and weakens the immune system."
    },
    {
      "id": "d22b31b8-a526-47bb-be4e-280c5072e0d0",
      "text": "Peru suspended its contract to purchase Ukrainian aircraft."
    },
    {
      "id": "12cf2e50-bbba-4ffe-a538-dff6e687b7f3",
      "text": "Poland is responsible for starting World War II."
    },
    {
      "id": "b7ffeacd-5073-4386-9bb2-5a80e5cba7bd",
      "text": "COVID-19 vaccine contains an aborted male fetus."
    },
    {
      "id": "53a637cf-5570-40f1-b152-4d36671c4e62",
      "text": "Ukraine pays four times more for gas than Russia."
    },
    {
      "id": "a0e03745-c934-4002-849b-279c0d7ca85d",
      "text": "No Amish children have been diagnosed with cancer, diabetes, or autism; Amish children are largely unvaccinated; COVID-19 death rates in Amish communities are 90 times lower than in the rest of the United States."
    },
    {
      "id": "52c0e6c7-af69-4b03-90b5-60bd0aecb43b",
      "text": "A Ukrainian missile struck a Kharkiv government building."
    },
    {
      "id": "a9720f8c-19bc-421d-a856-3a25464a4f11",
      "text": "George Soros said that only Russia cares about Ukrainians."
    },
    {
      "id": "c3a50ba2-8f19-4548-91c1-576ba23fb11d",
      "text": "The Ukrainian diaspora condemns sanctions imposed on Crimea."
    },
    {
      "id": "d41a6028-398e-4752-a435-f4dc2fff1a61",
      "text": "Ukraine is preparing legislation to transfer Lviv Region to Poland."
    },
    {
      "id": "a136f141-6116-48cb-8ff4-a351e75c2348",
      "text": "Ukrainian military personnel are defecting to the self-proclaimed Luhansk People's Republic."
    },
    {
      "id": "ba369e39-ec45-4ed7-93a9-3a04b478b590",
      "text": "COVID-19 vaccines cause fibrous clots in the lungs and blood vessels."
    },
    {
      "id": "24af3b1b-9176-44bf-9cb2-d0a28e6191a2",
      "text": "Corruption in Ukraine increased by 500% over the past year, and U.S. aid is not reaching its intended targets."
    },
    {
      "id": "dfbfe160-e97b-487b-bd63-6307020b0438",
      "text": "Distributing weapons to the population caused crime to increase by 270%."
    },
    {
      "id": "8e703566-cce7-4eb6-b60e-6cbe8bda9bb2",
      "text": "UEFA is investigating a Ukrainian team for doping."
    },
    {
      "id": "a117cf36-9039-43b3-b502-f38e0afc8153",
      "text": "Some mouthwashes curb the coronavirus."
    },
    {
      "id": "d7fb78a5-05e9-4de0-b3a9-64b90fbd2106",
      "text": "COVID-19 vaccination increases the risk of autoimmune rheumatic diseases."
    },
    {
      "id": "72b10684-8987-4e6c-9934-4701614da7c1",
      "text": "The New York Times calls for redefining death in Ukraine to permit harvesting organs from living people for transplantation."
    },
    {
      "id": "fe24812a-97c6-476c-9baa-1103a9653551",
      "text": "Scientists and policy-makers agree humanity will pass a point of no return once global mean temperature rises above 2°C."
    },
    {
      "id": "52896f5f-991a-4b65-a529-2f922b6a31ea",
      "text": "Published studies show COVID-19 mRNA vaccines cause metabolic cardiomyopathy and sudden cardiac death."
    },
    {
      "id": "3f914465-e5f4-4f05-84df-db17b776b2c5",
      "text": "Dr. Robert Malone invented mRNA vaccines."
    },
    {
      "id": "6a84663f-f127-4280-96a3-0776bc7bcd78",
      "text": "The COVID-19 pandemic was planned; COVID-19 vaccines are experimental and VAERS shows they have killed thousands; vaccine-induced spike protein causes damage; people previously infected have permanent immunity."
    },
    {
      "id": "14800c14-8301-405f-8273-4181fead0b91",
      "text": "Wind turbines kill eagles, but more eagles are killed by other causes."
    },
    {
      "id": "4bd74752-050d-4066-aa80-69ad72c07ed1",
      "text": "Ukrainian military used phosphorus bombs against Russian forces."
    },
    {
      "id": "1fdb61b5-3227-4c6c-b623-ee5994261c71",
      "text": "Most Ukrainian refugees fled to Russia."
    },
    {
      "id": "db638b74-73a7-4ef0-a77c-7ee167075ba9",
      "text": "Placing a raw onion on the soles of the feet eliminates illnesses."
    },
    {
      "id": "64d07b78-8176-4333-b0a9-435e55537cba",
      "text": "50% of internally displaced persons from Donbas are unemployed in Ukraine."
    },
    {
      "id": "a68db6b4-00e0-44e0-a53c-7d461a4c5a33",
      "text": "Russia returned captured Ukrainian ships as an act of goodwill."
    },
    {
      "id": "0bd91c7f-188d-4ac9-bfa2-ed23772b7839",
      "text": "Anti-NATO protests occurred in Bratislava and caused public unrest."
    },
    {
      "id": "f9cf5e65-d39a-49cb-9e90-f611127654f5",
      "text": "The Washington Post reports Western countries are sending weapons and troops to Ukraine."
    },
    {
      "id": "b84ae49b-ac57-4579-aa6d-644ea4a451ed",
      "text": "Harry Hoxsey's herbal therapy cures cancer."
    },
    {
      "id": "751488c6-fb35-4d4a-b4ff-143b277d9a60",
      "text": "Richard Bartlett discovered a silver-bullet COVID-19 protocol and was silenced."
    },
    {
      "id": "450057dc-4dee-4d4a-a352-f45e8a148e8f",
      "text": "The National Guard committed the Saurivka Massacre."
    },
    {
      "id": "2ef546a5-b82b-4961-a634-d891566717cb",
      "text": "Ukraine is a leading violator of Russians' rights"
    },
    {
      "id": "fe072c3e-a390-4bfb-9639-e3d3aef7f89d",
      "text": "The Normandy Format meeting was canceled because Ukraine failed to keep its word."
    },
    {
      "id": "9c4ee012-99d0-4552-8ceb-9444421b77dd",
      "text": "Brain blood clots are 112,000% more likely to occur after COVID-19 vaccination than after influenza vaccination."
    },
    {
      "id": "a007fae1-b18b-474c-b05c-f4f09ad6ffa1",
      "text": "The increase in cancer after water fluoridation began proves fluoride causes cancer and water fluoridation is public murder on a grand scale."
    },
    {
      "id": "f76c2b0d-e0db-45c6-be46-076f5caf99ad",
      "text": "European governments accuse Ukraine of increasing radioactivity."
    },
    {
      "id": "9f7c75f9-12b1-4273-8a6f-ec449a5a3e40",
      "text": "Face masks, vaccines, and frequent handwashing suppress our immune systems."
    },
    {
      "id": "10a1584e-2796-4a75-b1af-556789b76995",
      "text": "Kyiv ended prisoner exchange talks with occupied territories."
    },
    {
      "id": "7659a98e-7d46-4a48-9bfd-b379e1608b2a",
      "text": "No tests reliably detect the SARS-CoV-2 virus."
    },
    {
      "id": "e0de3107-736c-462b-88ca-80ac07a22385",
      "text": "COVID-19 vaccines cause blood clotting, infertility, and immune escape."
    },
    {
      "id": "252cf072-286f-454a-a807-ea3fa5398883",
      "text": "The World Health Organization is pushing a vaccine-based depopulation agenda across Africa."
    },
    {
      "id": "29ab53fe-1f96-4405-82de-f10f2733963e",
      "text": "Carbon dioxide is not a pollutant; it is a harmless natural gas like water vapor and is beneficial for plants."
    },
    {
      "id": "d3611e87-51c2-4d02-85fa-7af37e6165b0",
      "text": "WHO admits high-cycle PCR tests produce COVID false positives; WHO guidance includes lower PCR cycle thresholds."
    },
    {
      "id": "1bdcdd86-8b98-45b8-ade9-9162e65e0f28",
      "text": "Mouth swabs are as accurate as nasopharyngeal swabs for COVID-19 testing, so nasopharyngeal swabs are unnecessary."
    },
    {
      "id": "363394df-152d-40b2-ac62-d490a96c6324",
      "text": "55,000 years ago global temperatures were 2°C higher than today; current warming is purely cyclical, human greenhouse gas emissions have no significant effect, and sea level will not rise."
    },
    {
      "id": "149651fd-033d-43b1-87d3-665446966eb9",
      "text": "Poland is increasing its influence in the EU to settle old scores with Germany."
    },
    {
      "id": "9f730df3-0a30-4356-9fb5-3da44426f7ea",
      "text": "Ukraine is a nuclear burying ground and is experiencing a second Chernobyl."
    },
    {
      "id": "52b34824-1373-40d1-83be-3018e61ae605",
      "text": "One-third of Antarctic ice shelves will collapse due to global warming."
    },
    {
      "id": "dea6733b-6020-4f8a-bb8e-8c60954965b6",
      "text": "The January 2025 Los Angeles wildfires were caused by non-climatic factors and were not influenced by climate change."
    },
    {
      "id": "ced68cf4-b495-4acb-a046-9612864342c4",
      "text": "Ukraine sold Moldovan missiles to ISIS."
    },
    {
      "id": "94aaec06-525e-41e8-abea-4a063c8d258c",
      "text": "Mikheil Saakashvili fired officials to save 4 million hryvnias to move his family to Odesa."
    },
    {
      "id": "7045d31a-2fff-4ed5-88f2-f70ba117865a",
      "text": "700 Ukrainian prosecutors received combatant status during the full-scale war."
    },
    {
      "id": "c53e0722-31cd-4216-b4ae-898a6c808315",
      "text": "Covid-19 vaccine mRNA cannot be broken down, and Covid-19 vaccines cause excess deaths and unprecedented blood clots."
    },
    {
      "id": "bb488946-5e6c-4e91-866d-5430c56b7ee1",
      "text": "Russia saved the Zaporizhzhia Nuclear Power Plant from catastrophic conditions."
    },
    {
      "id": "ecae8d19-6ad9-4d7d-8d32-0bb0062c4bcc",
      "text": "Asymptomatic carriers cannot spread COVID-19; COVID-19 is not contagious; masks are not needed to reduce COVID-19 transmission from asymptomatic carriers"
    },
    {
      "id": "a623bf10-1bc0-4bbe-a810-62f28445d4f5",
      "text": "The use of chemical weapons in Syria did not occur, and the attempt to poison Sergei Skripal did not occur."
    },
    {
      "id": "968ad657-031c-49e2-963e-443fbd372a02",
      "text": "Ukraine legalized private armies to fight in Donbas."
    },
    {
      "id": "0b793eb8-460d-4d54-a9c0-6fb4873518f9",
      "text": "The United Kingdom invented reusable toilet paper because of anti-Russia sanctions."
    },
    {
      "id": "eeb9c461-a753-461d-8f50-a2404bad2189",
      "text": "All signs at the Kharkiv Unity March were in English."
    },
    {
      "id": "feb308fb-89d7-4094-8142-ce7a2b1e6715",
      "text": "Anti-Ukrainian billboards appeared in Poland"
    },
    {
      "id": "47d10127-8b88-453e-b9b9-9ac3fec996d9",
      "text": "Biden’s climate plan limits Americans' meat consumption by 90% and restricts them to one burger per month."
    },
    {
      "id": "d4bb636a-ef12-4e0d-99ec-9d63b895cc16",
      "text": "The Russian language is banned in Lviv, Ukraine."
    },
    {
      "id": "ad0d9484-a7cf-4622-9a6a-fc59f917b9ff",
      "text": "The Pfizer bivalent COVID-19 vaccine causes strokes."
    },
    {
      "id": "06a3e8a5-24e0-404f-bdf4-12b6e222fc18",
      "text": "China backs Russia's aggression in Crimea."
    },
    {
      "id": "1d51047a-8bca-4664-bba8-aabca8a4a441",
      "text": "Medicare data show COVID-19 vaccines increase the risk of death."
    },
    {
      "id": "ef3d54fb-135c-4f91-83be-3f3bde8746d4",
      "text": "Embalmers have observed that COVID-19 vaccines cause an increase in abnormal blood clots."
    },
    {
      "id": "fa57cb9e-6ccf-475d-8f43-70972d672647",
      "text": "Poland is pushing for the overthrow of Belarusian President Alexander Lukashenko at the European Union level."
    },
    {
      "id": "07860eb4-7e2c-4546-9bc6-7ca701048da8",
      "text": "Wisdom teeth are meridian lines connected to the heart, and removing them causes heart problems."
    },
    {
      "id": "f5be3f3f-5b0b-41e3-af54-35a878dd3fb8",
      "text": "Mixing urine with salt determines whether a person is pregnant."
    },
    {
      "id": "1992dd80-35dd-46a9-bccd-0cf139aecbc2",
      "text": "Eighteen proxy records show global temperatures were as warm or warmer 1,000 years ago."
    },
    {
      "id": "77d68ce8-66fc-42bc-a8d0-0495a4c960b6",
      "text": "OSCE confirmed 29 civilians were killed in Donbas in late January."
    },
    {
      "id": "4ce202c4-ee9f-4ab4-bc4b-d87abc617ed8",
      "text": "European countries cancel visa-free travel for Ukrainian travelers because of a measles epidemic in Ukraine."
    },
    {
      "id": "4ba11038-ee3b-48f3-94e9-85863cc1e604",
      "text": "The Central Communication Port is being built to enable rapid transfer of US military forces."
    },
    {
      "id": "ce9c9e32-2219-4f66-83a7-989550bdabe5",
      "text": "Increases in atmospheric CO2 are primarily caused by natural sources such as ocean outgassing, and human CO2 emissions are negligible in comparison."
    },
    {
      "id": "3b0b5562-9d6a-4197-a16f-1ad69b1cc4a0",
      "text": "British military expert says Ukraine cannot retake Crimea."
    },
    {
      "id": "e04aabd2-3b11-4d85-9454-5293b1eef028",
      "text": "Polish TV used a map that showed neighboring Ukrainian regions as part of Poland."
    },
    {
      "id": "f7759163-a314-4b80-86d0-b7637b3cd643",
      "text": "Video shows people preparing body bags for an evening news clip during the COVID-19 pandemic."
    },
    {
      "id": "d9fca8eb-fc43-4ccd-866c-6a62a072e2f9",
      "text": "COVID-19 vaccines cause menstrual problems in women and vaccinated people cause health problems in unvaccinated people."
    },
    {
      "id": "72f2090b-17c4-4faf-b2be-bc36323f1e2b",
      "text": "A Russian strike caused a blackout in Odesa, and apocalyptic images from the blackout were shared online."
    },
    {
      "id": "64d045e9-0660-4692-b1f8-8b191f6cd9b2",
      "text": "Colostrum improves gut health and boosts immunity"
    },
    {
      "id": "4b646847-1cb5-4f88-90a1-ce18b12cd313",
      "text": "The COVID-19 pandemic is a planned, staged pandemic created by PCR testing, not by the coronavirus."
    },
    {
      "id": "2e13e180-291c-45bc-a491-c8cd8f430264",
      "text": "A video shows an explosion at the Zhovti Vody uranium plant."
    },
    {
      "id": "6d117aeb-ccd3-4e78-8899-ddad3c137ea6",
      "text": "The world's largest EV charging station is powered exclusively by diesel generators."
    },
    {
      "id": "de2c1ee0-8549-40d1-8446-21411e0d089a",
      "text": "Hormonal birth control causes PCOS, hormonal imbalances, depression, and infertility."
    },
    {
      "id": "82c5ec92-7d92-4548-9470-04867fdf8828",
      "text": "Studies prove geological forces, not atmospheric forces, are responsible for melting Earth's polar ice sheets."
    },
    {
      "id": "736d9e03-dc3d-4f14-8419-90e558838823",
      "text": "Petro Poroshenko was drunk and removed from a Kyiv–Moscow flight."
    },
    {
      "id": "ddce07da-f9dc-4166-932b-b52520d4d2b5",
      "text": "Trump criticized U.S. aid to Ukraine and called Ukraine impoverished."
    },
    {
      "id": "ac90a491-ea82-4572-a011-004f6b3e29e7",
      "text": "A photosynthesis study shows Earth is not warming as predicted by climate models."
    },
    {
      "id": "fc63bc3d-8079-4434-ba23-c70ccb3592a4",
      "text": "Dr. Robert Malone invented mRNA vaccines."
    },
    {
      "id": "2c42f23b-b2e9-431d-951f-51cfe3051581",
      "text": "Ukrainians called Russian children to stage a gas attack hoax."
    },
    {
      "id": "651343a0-1855-404e-9bca-18e93f2d5a77",
      "text": "Birth control causes a far greater risk of blood clots than any COVID-19 vaccine."
    },
    {
      "id": "6181efef-91d7-46cb-be69-cbde16defa0f",
      "text": "Eating specific foods based on your blood type optimizes your health."
    },
    {
      "id": "1abc1279-e2d0-4488-8b82-46263c61dcda",
      "text": "Ukrainian refugees broke Van Gogh's chair in a museum."
    },
    {
      "id": "a6383900-6404-4d3f-8aba-0687e070ebc7",
      "text": "Brigitte Macron's personal doctor was found dead in Paris and planned to reveal the First Lady's secret to the press."
    },
    {
      "id": "322008f0-3241-4a93-b5d4-df5fb6ca9a96",
      "text": "Pathogens do not initiate disease; an acidic, compromised cellular terrain initiates disease and pathogens only appear as a result."
    },
    {
      "id": "45054bb5-98c4-4cfe-9680-35000796ee24",
      "text": "\"Vatnik\" renounced Ukrainian citizenship."
    },
    {
      "id": "b49be27f-cd32-4e61-8e4f-45de2432e05e",
      "text": "Dr. Anthony Fauci's 2004 interview remarks about the flu vaccine prove that natural immunity is the best protection against COVID-19."
    },
    {
      "id": "2b89486b-0ab3-4157-b0de-77774c409613",
      "text": "A photo of shelling in Israel is presented as showing shelling in Donetsk."
    },
    {
      "id": "1abb2f07-9cf8-48b2-bbf1-d78cad1a62e4",
      "text": "The Hague Tribunal will investigate Ukrainian crimes in Donbas."
    },
    {
      "id": "8d5d7861-9d12-4c60-805b-c0152ee0c78d",
      "text": "More babies die from abortion in two days than have died from coronavirus so far."
    },
    {
      "id": "447dd20c-66d9-47e0-b122-5a27bc28aa15",
      "text": "The European Court refused to return Crimea to Ukraine."
    },
    {
      "id": "82b3bde1-e7fb-4c19-b8d1-78fcf4f4f472",
      "text": "Arseniy Yatsenyuk and Oleksandr Turchynov were booed and whistled at the Eternal Flame in Kyiv."
    },
    {
      "id": "e753e65c-048c-4f62-b90b-dce6303a03d1",
      "text": "Exipure is scientifically proven to cause weight loss; BPS-5 effectively reduces blood pressure."
    },
    {
      "id": "c06a2666-40ff-496c-862a-430c79f26354",
      "text": "Drunken US mercenaries rampaged through Mariupol."
    },
    {
      "id": "f8d94da2-78a7-41b9-bca7-32fc74a9adb4",
      "text": "Petro Poroshenko calls for ending sanctions against Russia."
    },
    {
      "id": "e255c9b3-68b0-46d2-9a2a-ba4bcded54a1",
      "text": "Scores of Ukrainian stars performed in Russia."
    },
    {
      "id": "ed417166-4ba2-4b0b-ac3e-6aa5232a0d5e",
      "text": "Berkut commandos who refused to kneel were burned alive in Lviv, Ukraine."
    },
    {
      "id": "546e7fcd-17ae-4983-9cf8-82284e24b39b",
      "text": "COVID-19 deaths were vastly overcounted."
    },
    {
      "id": "b4eee16f-516f-4bc7-a4e6-0ee7facbd68d",
      "text": "COVID-19 vaccine recipients are ineligible to donate blood."
    },
    {
      "id": "706987e6-afc1-4f06-ad55-7a4abe9b2eb2",
      "text": "Carbon dioxide does not control the climate."
    },
    {
      "id": "5501761a-5b10-4728-a8a3-305eed365584",
      "text": "82% of women who received the COVID-19 vaccine between 30 days and 20 weeks of pregnancy had miscarriages."
    },
    {
      "id": "485705b8-64f1-4937-b4c1-475d0bf42370",
      "text": "People who receive a vaccine under Emergency Use Authorization cannot sue vaccine manufacturers; after full approval they can sue, unless the vaccine is recommended for children, in which case they cannot sue."
    },
    {
      "id": "87aed28e-ad53-407c-a04a-af3b0e1015ee",
      "text": "NATO is preparing for war with Russia."
    },
    {
      "id": "38e66b36-6f12-4189-883a-2d2e79d627a7",
      "text": "The vaccine causes death in 33% of people, while the virus causes death in 0.06% of people."
    },
    {
      "id": "0a7a602e-58ed-48e7-880e-a6a2881376a5",
      "text": "Vaccines, an MTHFR genetic mutation, and glyphosate exposure cause autism in children with brain injuries."
    },
    {
      "id": "2908fd39-9ca7-4a1e-984b-ef0485bb1cd8",
      "text": "Ukrainian men in Germany are recruited into Ukraine's armed forces in exchange for German citizenship."
    },
    {
      "id": "e709b53a-f0b3-42a3-a3c9-f194801b8eaf",
      "text": "A Ukrainian deputy minister called for using the Ukrainian army to retake Crimea."
    },
    {
      "id": "f3482401-f636-4769-8a6e-01b1b53ccd94",
      "text": "Ukraine's credit rating has fallen."
    },
    {
      "id": "50dd51fa-63ef-4307-87b0-455a8d787703",
      "text": "The American Journal of Medicine admits it was wrong about hydroxychloroquine and published evidence that hydroxychloroquine prevents COVID-19."
    },
    {
      "id": "c3d8d26b-ab72-4684-bfbd-296bbdcf9a7b",
      "text": "Pope Francis congratulates Vladimir Putin on his presidential election victory."
    },
    {
      "id": "d283bd77-2689-4ff7-943f-a906148645aa",
      "text": "Ukrainian food prices are equal to EU food prices."
    },
    {
      "id": "651a25ba-535b-453b-9f80-85525734d412",
      "text": "Russia is depriving Ukraine of water from the Dnipro River by cutting off the river upstream."
    },
    {
      "id": "b4ca2a6e-2153-4976-9199-941915539996",
      "text": "Raw thermometer data show the US cooled for 80 to 90 years, and official temperature graphs were altered to falsely show warming."
    },
    {
      "id": "95819ed2-6fea-4da0-8adc-b11616db0c19",
      "text": "The Red Cross has ceased operations in Ukraine."
    },
    {
      "id": "f02ae4fd-dfd7-4a34-9d71-f0f3326534dc",
      "text": "One vaccine injury occurs for every 39 vaccine doses administered."
    },
    {
      "id": "bbf92366-7621-4b54-878d-8d640f7d00ec",
      "text": "Rising atmospheric CO2 has slightly cooled the planet."
    },
    {
      "id": "0c207476-8b95-45b5-8537-d0137808b419",
      "text": "Ukrainian soldiers rejected a patriotic greeting."
    },
    {
      "id": "71ac27db-e609-47dd-9edc-ad973ee7832e",
      "text": "The Ukrainian military violates the ceasefire most."
    },
    {
      "id": "6fd6f299-2bc5-4cd1-b7db-411b475af0f8",
      "text": "Alzheimer’s disease did not exist 40 years ago; cholesterol-lowering drugs and cholesterol-reducing diets cause Alzheimer’s disease."
    },
    {
      "id": "d2e895d3-6f8f-45b0-8f2e-594dea520523",
      "text": "The Red Cross says people who received a COVID-19 vaccine cannot donate convalescent plasma because the vaccine destroys SARS-CoV-2 antibodies."
    },
    {
      "id": "6c30c088-4430-4f1e-bea0-16e5f3939ba6",
      "text": "COVID-19 infection fatality rate (IFR) is 0.1% to 0.3% and COVID-19 is as lethal as severe influenza."
    },
    {
      "id": "58ca5117-68d3-48a5-ba9e-c55f3b0c979f",
      "text": "Conscription notices are being handed out at voting stations."
    },
    {
      "id": "ac00d441-3a77-4269-bcc6-e6e791cbb06e",
      "text": "Zaporizhzhia City Council rejected the Ukrainian language."
    },
    {
      "id": "f0a1f347-7468-4968-8bf4-947f482fbd0c",
      "text": "The governor of Kherson Oblast said that Hitler was justified."
    },
    {
      "id": "92e2aa1f-7896-4d02-b097-114d0eb2d684",
      "text": "Denmark asked Ukraine to return military aid."
    },
    {
      "id": "c9ab584b-166f-48ee-93a8-a068efe520a8",
      "text": "ICC arrest warrants for Russian military leaders have had no consequences."
    },
    {
      "id": "45b36f9f-2701-407c-bb41-2da5cf74f4da",
      "text": "The Russian military captured Mariupol in less than one hour and the Ukrainian army was completely incompetent."
    },
    {
      "id": "f231c676-5eee-4509-9a0f-ae36631ff30d",
      "text": "Vitamin B17 was banned by the United States because it kills cancer cells."
    },
    {
      "id": "2cc8f02b-f6f7-4b00-acbb-48afe8748ec0",
      "text": "The Ukrainian government refuses to evacuate its citizens from Israel."
    },
    {
      "id": "44921dd7-fb68-4673-9d91-d3c7d39bf5ae",
      "text": "An Italian restaurant advertises a \"Diablo Zelensky\" pizza topped with the bodies of Ukrainian soldiers."
    },
    {
      "id": "291156e6-b34b-454a-a4a5-234d1b5a9b37",
      "text": "Vaccines contain toxic aluminum and mercury"
    },
    {
      "id": "bd51b6da-c68f-4d00-a66d-ac47ba7a5598",
      "text": "Climate scientists say aspects of Hurricane Harvey show that global warming made the storm worse."
    },
    {
      "id": "385112f9-b5f3-4bdc-8cfd-95878a4457c1",
      "text": "Vaccines cause autism."
    },
    {
      "id": "adc2e10c-ef34-40a9-a1b5-99f334f56fd7",
      "text": "COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people are not a threat to vaccinated people."
    },
    {
      "id": "c0017158-5ec9-4fbc-8e2b-e5be9bf948e8",
      "text": "Ivermectin and mebendazole are effective treatments for cancer."
    },
    {
      "id": "b16d536e-4a06-4640-a9ed-1354ae306aae",
      "text": "Charlie Hebdo ridiculed Ukrainian fencer Olha Kharlan."
    },
    {
      "id": "5fc68f54-02e5-4dcc-bf66-6782dc973afe",
      "text": "A pro-Russia mass rally occurred in the United States."
    },
    {
      "id": "c741471f-7be4-41e6-872b-a89b949145b6",
      "text": "A NATO brigade arrived in Donbas."
    },
    {
      "id": "593862ba-9e8d-460c-b843-16a9919801bc",
      "text": "Ocean acidification does not harm marine life."
    },
    {
      "id": "0683ebf0-51d7-446e-ae91-9a60cf532735",
      "text": "The Ukrainian government in Kyiv forbids citizens from keeping in touch with Ukrainians in the temporarily occupied territories."
    },
    {
      "id": "c3a11704-5ca5-4d3b-b989-4151dca867dd",
      "text": "Ukrainian saboteurs were intercepted in Luhansk."
    },
    {
      "id": "b658e2b4-f861-49b7-822f-9d60d545a8fa",
      "text": "The United States banned vitamin B17 because it kills cancer cells."
    },
    {
      "id": "871435cd-e0dc-43c8-82ff-47803cfead5f",
      "text": "Mammograms cause cancer."
    },
    {
      "id": "d9f0695f-a41b-4f1f-b51f-57d0a6859c8b",
      "text": "COVID-19 vaccines weaken the immune system and caused a 20-fold increase in cancer in vaccinated patients, an Idaho doctor reported."
    },
    {
      "id": "fc39d71b-5191-4106-baf8-5af64493684d",
      "text": "Ukraine will blow up 550 tons of ammonia in Novotroitske."
    },
    {
      "id": "1292f243-95fe-4e8d-b668-0561b4d9f934",
      "text": "500 Ukrainian security officers block Kiev Street."
    },
    {
      "id": "e08a30eb-1c20-400b-8446-ac1b78bea4a6",
      "text": "The Ukrainian army shelled Donetsk."
    },
    {
      "id": "98eff29f-6b83-432c-b28b-927ec4b83a7c",
      "text": "A new study shows mRNA from COVID-19 vaccines is present in breast milk and is dangerous to infants."
    },
    {
      "id": "609f12e8-ad23-49e1-abab-57a8195e8af6",
      "text": "Ukrainian Right Sector radicals attacked peaceful Russian civilians in Athens."
    },
    {
      "id": "b612352c-d6f4-4820-9245-cbdc7a728701",
      "text": "The IPCC concedes there has been no increase in extreme weather events."
    },
    {
      "id": "f03f1e47-b185-4b08-8ff3-c014963ea848",
      "text": "The EU provides financial aid to Ukraine in exchange for migrants."
    },
    {
      "id": "66154323-d238-462c-95db-6390cf14013b",
      "text": "The United States will pay reparations to Ukraine."
    },
    {
      "id": "5923c121-b933-4b0c-8c5e-8ec99a127cec",
      "text": "Natural immunity to COVID-19 persists for decades; pregnant women are not at risk from COVID-19; COVID-19 vaccines contain DNA plasmids; COVID-19 boosters are unsafe."
    },
    {
      "id": "ed2e0bed-abfb-497c-9ffb-c5fd005a4278",
      "text": "Receiving more COVID-19 vaccine doses increases your risk of getting COVID-19, and COVID-19 vaccines contain DNA fragments that modify your genome and cause cancer."
    },
    {
      "id": "751252eb-c248-4e27-a607-510c64f2f866",
      "text": "Ukraine lost 50% of its GDP due to sanctions related to Russia."
    },
    {
      "id": "6932d003-f34e-4235-87eb-e7cd45ec36c3",
      "text": "The United States banned 155 imports from Ukraine because of Ukraine's political situation."
    },
    {
      "id": "e0fb6168-f755-420a-bba6-5da68728897c",
      "text": "The son of a German tankman donated a World War II tank to Ukraine."
    },
    {
      "id": "ea294df8-d351-4b71-9ef7-6acdce1bdf21",
      "text": "COVID-19 vaccines cause autism in rats."
    },
    {
      "id": "07112370-1b0e-4aba-9663-35f7e03a3646",
      "text": "Ukrainian paratroopers infected fellow Ukrainian soldiers after training in Western Ukraine."
    },
    {
      "id": "75e6a60a-f387-4967-b042-d1c6fd158f36",
      "text": "COVID-19 mRNA vaccines do not work and are causing serious harm, including death."
    },
    {
      "id": "f5b2b00e-ba38-4547-a0b9-3092f6091cef",
      "text": "RSV vaccines cause deaths and neurological disorders, and the CDC covered up reports of deaths among vaccinated individuals."
    },
    {
      "id": "41ed43a2-38e1-476a-8304-8f12a9f67878",
      "text": "Ukraine disrupted NATO's Sea Breeze naval exercises."
    },
    {
      "id": "05191600-57d5-415e-b4f4-c412f47f41a6",
      "text": "Huge numbers of Ukrainians hate the Kyiv regime."
    },
    {
      "id": "9c495b9b-667e-433f-9dab-51269cfe4ea4",
      "text": "The World Trade Organization forced Ukraine to buy Russian fertilizer."
    },
    {
      "id": "368de859-722c-4662-9e5d-083bd074caf0",
      "text": "More than 200,000 people died due to the COVID-19 vaccine."
    },
    {
      "id": "457c7f59-3b69-4f57-a82e-eca71fe7656f",
      "text": "Ukraine is Europe’s poorest country."
    },
    {
      "id": "4d05a7f2-89f8-45fc-b32d-b3b1d5fec6f0",
      "text": "Ukrainian military refused to help a teenager injured by an explosive device."
    },
    {
      "id": "3e3765b1-eaf3-4bba-9591-48394d3143e1",
      "text": "A TIME employee posted a magazine cover showing Vladimir Putin labeled \"Man of the Year\""
    },
    {
      "id": "49603d79-aab0-4745-b291-b320f6ab4409",
      "text": "Ukrainian women impregnated by Russian soldiers are forced to have abortions."
    },
    {
      "id": "f45aed36-6ef1-4d69-822b-6f2f4982179c",
      "text": "Arms supplies to Ukraine are lost and unaccounted for."
    },
    {
      "id": "2a9844d1-065a-40c8-8cb6-dbf1cf798ff3",
      "text": "COVID-19 vaccination increases the risk of myocarditis in young adults by 800 times compared with being unvaccinated."
    },
    {
      "id": "b3c74b9c-d96a-4447-9a9e-6a0ac43bec8d",
      "text": "The majority of Ukrainians are waiting for Russia to rescue them."
    },
    {
      "id": "86ccc3a3-9bf2-4315-90bb-e4090352abc2",
      "text": "Unvaccinated Amish do not get cancer, autism, or heart disease."
    },
    {
      "id": "2a625bb3-0488-4532-98e8-0cd6f90748c7",
      "text": "Russian troops destroyed an oil depot in Syria."
    },
    {
      "id": "8bd6557f-ec53-4465-b0a8-3f71d5b51659",
      "text": "A majority of Europeans oppose new sanctions on Russia."
    },
    {
      "id": "d337f025-3d3e-4881-9db1-26a9cc34fc60",
      "text": "The increase in solar activity during the twentieth century accounts for 50% to 66% of all climate change."
    },
    {
      "id": "d118ff64-c246-49b2-b6dd-8119a5bdbd34",
      "text": "A majority of Ukrainians oppose both the Ukrainian Army and President Volodymyr Zelensky's war in Donbas."
    },
    {
      "id": "5f5e53a0-8662-4d96-8adb-4d1f861b5ba7",
      "text": "Benzene in benzoyl peroxide-containing skincare products causes cancer."
    },
    {
      "id": "5ca6668a-af13-413c-81ee-eadecac59929",
      "text": "Ukraine's currency has collapsed due to the Turkey crisis, IMF actions, and the collapse of the National Bank of Ukraine."
    },
    {
      "id": "8a238a7c-f96a-415d-a339-07d5f96f0b45",
      "text": "Germany has stopped supplying weapons to Ukraine"
    },
    {
      "id": "0fd219cf-7794-4e20-9d7a-bd0f952d8847",
      "text": "Switzerland abolishes refugee status for Ukrainians"
    },
    {
      "id": "511305e3-08a8-47bd-ba35-92e850caf3d8",
      "text": "Ukrainian National Guard soldiers are throwing the bodies of killed men."
    },
    {
      "id": "af738d60-42d9-4182-b743-c15060b3b799",
      "text": "A Ukrainian crowd beat a Russian boy to death in Germany."
    },
    {
      "id": "6b296eea-2fd8-472f-9fea-997008bc21b3",
      "text": "An autoimmune condition is the number one indicator of parasite infection."
    },
    {
      "id": "79868c5a-81e7-447d-9f0e-e7d3ced773f5",
      "text": "Cultivated meat is made from cancerous and precancerous cells."
    },
    {
      "id": "1c742d5f-4f38-4dbf-a3f8-5ea02c118d90",
      "text": "Russian language is being suppressed in Ukraine."
    },
    {
      "id": "fd2f32b7-550e-400e-a654-d1c8d25a01f3",
      "text": "The ozone layer is healing."
    },
    {
      "id": "4b16a3e1-3eb3-4c01-9ffc-8e057a849168",
      "text": "The Ukrainian military suffered losses in eastern Ukraine."
    },
    {
      "id": "d61a4f40-3482-4719-be2d-5a97dbe2f20d",
      "text": "Ukrainian sailors threatened to return to Crimea."
    },
    {
      "id": "2edc566a-662a-48eb-9f6a-06f9b3f71ef9",
      "text": "Atmospheric CO2 concentration is not correlated with global temperatures."
    },
    {
      "id": "3ef65eb1-1d0c-4cd8-873a-c2e6b2ec18d5",
      "text": "The European Parliament accuses Ukraine of committing Soviet crimes."
    },
    {
      "id": "2fa3d5b3-e3dc-4d6a-9b27-00715d3ba168",
      "text": "Ukraine will classify residents of Crimea and Donbas as terrorists."
    },
    {
      "id": "60e72e41-ea27-4630-b2b8-d2a69192d55b",
      "text": "Vitamin D3 is irradiated sheep’s wool mixed with chloroform and is rat poison; low vitamin D levels are caused by lack of sunlight and high vitamin A diets."
    },
    {
      "id": "9503763c-7449-4178-849e-610ba6134ea6",
      "text": "Sunscreens and sunless tanning products cause cancer and contain cancer-causing ingredients, and the sun does not cause cancer."
    },
    {
      "id": "c225cecc-fbc4-42f9-b662-389b8449adc8",
      "text": "Ukraine will lose several regions to Russia."
    },
    {
      "id": "57353be9-8323-4c01-a15b-a358286bcc76",
      "text": "There has been no excess mortality from COVID; lockdowns do not prevent the spread of COVID; masks do not work to prevent transmission; PCR tests were not designed to diagnose illness."
    },
    {
      "id": "80f98ec2-b840-4020-a19d-c9ef321f581a",
      "text": "A Ukrainian serviceman was sent to Avdiyivka to be killed for posting a TikTok."
    },
    {
      "id": "775ec7d2-331c-4113-ba9f-8ec35702f009",
      "text": "A separatist was buried alive in Ukraine."
    },
    {
      "id": "dfaa1764-c3e1-450f-a71a-f7e11f966f70",
      "text": "Vaccines caused autism to increase from 1 in 10,000 to 1 in 50."
    },
    {
      "id": "a2c95989-878c-4089-bb17-8155df3fcccc",
      "text": "U.S. regions with higher average COVID-19 vaccine doses had larger increases in mortality in 2022 than in 2021."
    },
    {
      "id": "f9eac5f3-6751-4192-85e6-5ff9a684b5ba",
      "text": "Medical exemptions are unavailable for people with contraindications to the COVID-19 vaccine, including those with a history of blood clotting or prior adverse reactions to vaccines."
    },
    {
      "id": "15ed2e39-9578-433f-ba74-c276daed508c",
      "text": "Normalised Diatomaceous earth contains silica that absorbs minerals, water, and vitamins, and diatomaceous earth is antiparasitic and detoxes the body."
    },
    {
      "id": "ba280fb7-61fb-41f2-b800-9919def41677",
      "text": "Vaccines caused an explosion in childhood cancer, and vaccine package inserts state vaccines were not tested for mutagenic effects."
    },
    {
      "id": "b401c9aa-19d5-40ab-8658-520adac91bd0",
      "text": "President Poroshenko’s confectionery company is opening new branches in Russia."
    },
    {
      "id": "45e9572f-4e25-4790-aee0-bebc5eb39d5e",
      "text": "A survey found that the majority of Ukrainians liked living in the USSR."
    },
    {
      "id": "75da4af8-5a1b-4f40-9c0e-a2e1b8ff0482",
      "text": "Oleg Sentsov has a star on the Hollywood Walk of Fame."
    },
    {
      "id": "640c728f-8be2-473d-ad7d-502c6a1e1829",
      "text": "COVID-19 vaccines caused over 4,000 deaths; COVID-19 survivors cannot be reinfected and do not need vaccination; natural immunity is stronger than vaccine immunity; vaccine-produced spike protein is dangerous."
    },
    {
      "id": "913f68f5-8331-4420-bc8a-c649254faa99",
      "text": "The Earth has cooled continuously for 4,000 years and is cooler now than during the Medieval Warm Period; reported recent warming is only an artifact of the measurement start date."
    },
    {
      "id": "bd9a9dd2-0105-4d29-a032-62bd305b6e43",
      "text": "The Russian flag was burned in Belarus."
    },
    {
      "id": "3cfc2483-90d2-4c7a-8eac-a1fb89531809",
      "text": "Patents for weather-modification technologies prove that HAARP and NEXRAD are used to manipulate hurricanes."
    },
    {
      "id": "addcb655-a008-4fe7-b130-ecc2ff51b64f",
      "text": "The European Parliament says Kyiv cannot pay off its debts."
    },
    {
      "id": "d8a89786-9032-4e97-800a-d94a3e6cb02d",
      "text": "The United States is preparing a new revolution in Ukraine."
    },
    {
      "id": "07c7eadf-eced-4f28-94d1-a3f3aff2b1d6",
      "text": "Kyiv is blackmailing the West over Crimea."
    },
    {
      "id": "f6914820-56bc-429f-9a23-9ee686516844",
      "text": "In the United States, doctors kill six times as many people as guns do."
    },
    {
      "id": "be368ea7-a509-48f9-a3c9-9d281436a081",
      "text": "Leaky COVID-19 vaccines are causing SARS-CoV-2 to evolve rapidly; COVID-19 vaccines do not prevent disease or death; childhood vaccines are unsafe."
    },
    {
      "id": "b4d92106-34b0-4251-9ce2-d54fe3fbc420",
      "text": "Kirovograd residents overwhelmingly prefer the city's tsarist-era name."
    },
    {
      "id": "47df24f4-8606-426b-9cee-667f9c8df0c0",
      "text": "Pfizer documents prove mRNA COVID-19 vaccines contain graphene oxide."
    },
    {
      "id": "58b5190d-ce6a-4fc4-9edc-11d2a480f911",
      "text": "Petro Poroshenko allows Ukrainian civilians to legally possess and carry firearms."
    },
    {
      "id": "f5de99ae-33e0-4256-9407-b097cbd646bc",
      "text": "A Ukrainian general admitted that Ukraine's professional army has been knocked out."
    },
    {
      "id": "b0acd26c-c9a6-4552-ad9d-ea0b44968974",
      "text": "Data centers cannot run entirely on renewable energy."
    },
    {
      "id": "e44ced54-bbc4-4fe9-9925-086c3be735ed",
      "text": "Great Barrier Reef sea surface temperatures have not changed in the past 150 years."
    },
    {
      "id": "b3320e18-5e27-4a98-bfb3-9b8a18694f71",
      "text": "SARS was developed by humans and weaponized to attack human beings."
    },
    {
      "id": "0d04ae10-ad0e-4f53-891a-e7cdc4751e7b",
      "text": "There was no unusual excess mortality from COVID; lockdowns did not prevent disease spread; masks did not work to prevent spread; PCR tests were not designed to diagnose illness."
    },
    {
      "id": "33bd5081-6fe1-480c-9fd8-c94f6d44aeba",
      "text": "COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people do not pose a threat to vaccinated people."
    },
    {
      "id": "4c9ba839-bc22-44c0-ac8c-6ec8edc75085",
      "text": "Data from 145 countries shows that COVID-19 vaccines cause increases in COVID-19 cases and deaths."
    },
    {
      "id": "725ac9c2-bb18-4002-bd08-67981daaf6a0",
      "text": "Raising more cows and eating more beef will save the planet because cows are carbon‑negative."
    },
    {
      "id": "2f3d3b59-bb08-42a9-8a03-1792491fee63",
      "text": "A video shows American trainers teaching Ukrainian military personnel how to use an FGM-148 Javelin missile system."
    },
    {
      "id": "155eb26c-e15b-4e3e-a085-683747910dc3",
      "text": "Ukraine lost 234 planes and 137 helicopters since the war began."
    },
    {
      "id": "172053f7-c475-4ba5-9e5b-d74241bbe64a",
      "text": "Cow burps cause more damage to the climate than all cars on Earth."
    },
    {
      "id": "fb4b7724-a0fd-4547-98c7-26503f3a7d9d",
      "text": "mRNA vaccines force children’s bodies to produce toxic spike proteins that often cause permanent damage to children’s vital organs, and vaccinating children provides no benefit to them or their families."
    },
    {
      "id": "4d21b835-341e-494a-be3a-330340cde702",
      "text": "Natural immunity provides stronger protection than vaccine-induced immunity, and public health authorities lied when they said it was not better."
    },
    {
      "id": "4af2eec6-df79-4f7e-8d67-62d9045e7add",
      "text": "Gas station owners are refusing to lower fuel prices."
    },
    {
      "id": "c3f6e2a2-bf0a-4eb4-88f9-8603500d5674",
      "text": "More than 100% of the warming over the past century was caused by human actions."
    },
    {
      "id": "6413782b-b038-491f-9361-f3b3150efa2d",
      "text": "The Kerch Strait incidents were a Ukrainian provocation."
    },
    {
      "id": "fa8fb0cb-387d-45bf-86da-e5a93f6424e0",
      "text": "A study showed COVID-19 vaccines are more dangerous than COVID-19; children aged 12–17 are more likely to be hospitalized for myocarditis caused by the vaccine than for COVID-19."
    },
    {
      "id": "de23e9a7-26ca-43c3-a9c3-b184324c8585",
      "text": "Moscow Patriarchate priests were removed from President Volodymyr Zelensky's office after a false alarm."
    },
    {
      "id": "20a51398-2fc5-4cc1-a831-7e135590681f",
      "text": "Methane from cows is a small share of total greenhouse gas emissions, would be produced without cattle, and is not an important contributor to climate change."
    },
    {
      "id": "14addd9b-d054-452d-98ec-4906dd68c00d",
      "text": "Garlic is 100 times more effective than antibiotics."
    },
    {
      "id": "636cccd0-6554-42ac-acf1-237a07de714a",
      "text": "VAERS reports show HPV vaccines are ineffective and cause autoimmune and neurological disorders."
    },
    {
      "id": "e19d4626-676f-46c8-a860-8a1ae27e4c3b",
      "text": "CDC admits 146.6 million Americans have natural immunity to COVID-19, and 94% of COVID-related deaths were not caused by COVID-19."
    },
    {
      "id": "2aa60b28-354a-4deb-b9ca-9740137c0c66",
      "text": "Video shows a Ukrainian soldier looting in Chechnya"
    },
    {
      "id": "47e06e70-dc3d-4ba5-9c42-8784eb5b06e1",
      "text": "Britain proved it was involved in attacks on Crimea."
    },
    {
      "id": "9a8dd729-abcc-4567-8a42-89096437946c",
      "text": "The Czech Republic refuses to accept migrants because of Ukraine."
    },
    {
      "id": "92b58bda-45cc-44f2-a5b0-2bd0cbacac33",
      "text": "The State Duma passed a law forbidding Russian citizens from leaving the country."
    },
    {
      "id": "bd383d7d-5d38-43fc-9a92-f6bef332f4df",
      "text": "Ukrainian military shelled Olenivka with HIMARS on President Zelensky's orders."
    },
    {
      "id": "dd091e24-7eb4-4929-bdb1-9d781d4ae3f9",
      "text": "COVID-19 vaccines make SARS-CoV-2 more dangerous by causing antibody-dependent enhancement (ADE)."
    },
    {
      "id": "94d3fa58-3367-4ea5-ae67-7b8f8b279c09",
      "text": "A poll shows Ukrainians do not want peace and only want to fight Russia."
    },
    {
      "id": "99e579d9-e26c-45db-abd6-543e14d5f19c",
      "text": "The Vatican was the first to pay Russia for gas in rubles."
    },
    {
      "id": "f60a71cd-e4bc-4358-a0a7-f041b6f6a64a",
      "text": "The spring sowing campaign is under threat because all grain was taken out of Ukraine."
    },
    {
      "id": "c91a56a8-e896-423d-adbb-ca92bf44dc9d",
      "text": "Some mouthwashes help curb coronavirus"
    },
    {
      "id": "227cdcce-5687-4bf1-9f5a-a8836adedac1",
      "text": "Earth will enter a 30-year mini ice age."
    },
    {
      "id": "293b21e7-38f5-46fc-811e-c5e6536b3f8f",
      "text": "The low death rate is caused by human memory T cells providing immunity beyond antibodies."
    },
    {
      "id": "4c6ed350-eaac-442a-bcec-bc0413c9cf58",
      "text": "Ukrainian soldiers are promised a parcel of land and two slaves."
    },
    {
      "id": "23a4a319-3e03-446f-88cb-31b0f2c7fd44",
      "text": "The COVID-19 pandemic was planned; the SARS‑CoV‑2 virus was deliberately manipulated and did not jump directly to humans but was created through accelerated viral evolution."
    },
    {
      "id": "da292357-2462-42bc-b4ec-4e895f68f578",
      "text": "The West will use weapons of mass destruction in Ukraine and then blame Russia."
    },
    {
      "id": "625f25c3-8b12-45ac-8ce9-969d6a18a61f",
      "text": "The rate and magnitude of the reported late twentieth century (1979–2000) surface warming were within normal natural variability."
    },
    {
      "id": "1b7f21e9-b087-46d6-b057-af8f6f234184",
      "text": "The United States and Ukraine are preparing a new Chernobyl in Russia."
    },
    {
      "id": "3df1f8a8-552b-4efc-b21e-abc022e1ff34",
      "text": "Global leaders planned the pandemic and an 89-page PDF explains how they would implement the plan."
    },
    {
      "id": "21c3523d-ca4e-4d30-ac7c-af819b31b098",
      "text": "Poles demand autonomy from Kyiv."
    },
    {
      "id": "8d1914c7-c298-4bd9-aed5-632813d94822",
      "text": "CO2 concentrations in Earth's atmosphere are increasing faster than at any time in the past 50,000 years."
    },
    {
      "id": "7244ae56-e1c5-46e2-a543-7317f009b913",
      "text": "CDC has classified monkeypox as an airborne form of herpes that infects anyone within 15 feet, lasts 2–4 months, and causes paralysis."
    },
    {
      "id": "f525332a-aad7-4bd1-ba01-a81435bda985",
      "text": "Mask mandates do not stop the spread of COVID-19, and overwhelming scientific evidence shows masks do not work."
    },
    {
      "id": "2e54a056-be8a-4ab8-89b7-92e1542d6553",
      "text": "Ukraine will face new language divisions."
    },
    {
      "id": "63a0626d-0199-42df-b653-83dac89f44d6",
      "text": "European governments refuse to recognize Russia’s invasion of Ukraine as aggression and refuse to establish a special tribunal."
    },
    {
      "id": "6204e89f-a742-484f-b4b1-907aa765d851",
      "text": "Ukraine is deploying women to frontline combat due to heavy military losses."
    },
    {
      "id": "7593089a-7a8e-4de4-85ef-a1426aa3cff9",
      "text": "Whooping cough (DTaP) vaccine is unnecessary and causes sudden infant death syndrome."
    },
    {
      "id": "62d01d04-f080-49a5-86bc-cb74d32f6149",
      "text": "Foreigners are buying land in Crimea and sanctions have failed to stop it."
    },
    {
      "id": "77c96df2-9930-42f5-8e51-5087e65e1464",
      "text": "Being in an electric car lowers a person's testosterone and causes infertility."
    },
    {
      "id": "64666dca-81c0-4f77-8e27-11a65af4908d",
      "text": "COVID-19 vaccines are experimental poisons, and COVID-19 has disappeared."
    },
    {
      "id": "f889abfc-b20c-4691-9f7a-372f491a3000",
      "text": "European countries have closed their borders to Ukrainian refugees."
    },
    {
      "id": "7ae45b9b-6980-44f2-b068-b1496f49e43e",
      "text": "Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls domestic policy, mandates vaccinations and lockdowns, and arrests vaccine opponents."
    },
    {
      "id": "9d79b691-d9c4-46d5-a6b8-b1445cb6e6a4",
      "text": "The Italian Higher Institute of Health reduced Italy's official COVID-19 death toll by over 97% by changing the fatality definition to deaths caused by COVID rather than deaths with COVID."
    },
    {
      "id": "ed2e397a-705f-4c94-995f-d9156f17a977",
      "text": "Video shows a Syrian mercenary praying inside a Ukrainian grocery store."
    },
    {
      "id": "9e8abd16-691d-4049-9eb0-3ad5e4589074",
      "text": "By May 31, 2020, COVID-19 was a leading cause of death globally."
    },
    {
      "id": "ddbb5e44-b4ad-4c11-ae5b-a2bdb771c918",
      "text": "Ukraine’s Health Ministry allows Ukrainians to be sold for organs."
    },
    {
      "id": "96074d83-4149-4a8e-95a9-4a7f0069c03f",
      "text": "Anti-Russian sanctions have caused a bedbug influx in France."
    },
    {
      "id": "3d847759-a5a6-4b77-985b-5a351e634bfe",
      "text": "Poroshenko binge drank for a week."
    },
    {
      "id": "3bccd83c-9fd3-4504-a728-2ae929f05ac6",
      "text": "The Ukrainian diaspora in Canada supports forced mobilization."
    },
    {
      "id": "befed9b2-e17c-44f1-9c3c-7d11496a4a66",
      "text": "The Red Cross says people vaccinated against COVID-19 cannot donate convalescent plasma because the vaccine eliminates SARS-CoV-2 antibodies."
    },
    {
      "id": "2533f22b-6d0f-49f3-9255-8b9c3a6484c9",
      "text": "California wildfires are made much worse by environmental laws that prevent using abundant available water, and that water is diverted into the Pacific Ocean."
    },
    {
      "id": "f08f91a6-c902-44bf-8aa8-264968dda7c7",
      "text": "Folic acid and similar compounds deplete folate and this is very serious for people with MTHFR."
    },
    {
      "id": "54404614-30dd-4714-b748-07251cf5d96e",
      "text": "Pennyroyal, blue cohosh, black cohosh, and mugwort effectively induce abortions."
    },
    {
      "id": "0add574a-18c3-4e8e-9431-ce4b01d7713e",
      "text": "The CDC lowered developmental milestone standards to avoid acknowledging that COVID-19 restrictions harmed children's development."
    },
    {
      "id": "dd7a9c97-1eee-4e6d-b54c-5fa09301b2ea",
      "text": "The OSCE provided communications and intelligence to the Azov battalion in Mariupol."
    },
    {
      "id": "9226bd71-b042-472e-8759-f2e8e2c7c9cc",
      "text": "Researchers at the Wuhan Institute of Virology assembled monkeypox strains."
    },
    {
      "id": "35773a2d-d14c-42aa-88b3-687a2b8859a5",
      "text": "Crimeans received Russian passports with Magadan registration."
    },
    {
      "id": "9f92d96d-4308-4ddb-b7e0-250051b35d4c",
      "text": "Photo shows dozens of miniature explosive devices discovered in Lviv."
    },
    {
      "id": "08821dc0-3504-4b0f-9450-9c7b8b3145f3",
      "text": "There are zero deaths from influenza and zero deaths from pneumonia for the first time in history."
    },
    {
      "id": "4c0d834d-a849-4164-a31d-2c12469d05ee",
      "text": "There has been no global warming trend for the past 7.5 years, and human-caused global warming causes temperatures to rise at a steady rate."
    },
    {
      "id": "a2e0ca91-66bd-4120-ac00-e5d094187c97",
      "text": "The Ukrainian government curtailed freedom of assembly."
    },
    {
      "id": "63c77996-d578-49ff-a7d5-3087f29eb083",
      "text": "Certain herbs and supplements prevent and cure the harmful effects of bisphenol."
    },
    {
      "id": "273f2939-bb92-4cd5-b33b-c8dd1f33921e",
      "text": "Japan reported a surge in heart failure cases among people vaccinated against COVID-19."
    },
    {
      "id": "7d768a4f-0e69-457a-bc28-e263d9e83f41",
      "text": "Aircraft‑dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth's life support systems."
    },
    {
      "id": "6a9ce6c1-b856-43c9-83c9-b007385edb91",
      "text": "Eating coconut oil cures Alzheimer's disease."
    },
    {
      "id": "3a816ab3-76e8-4b09-8f80-c22151e9d200",
      "text": "A person was crucified in Slovyansk."
    },
    {
      "id": "a0c391cd-ae5f-479a-9f98-6b01c1162dea",
      "text": "Ukrainian media report that people in Russia are starving."
    },
    {
      "id": "83e130ce-6945-4d0d-b53f-d6e5ae90d013",
      "text": "FDA guidelines state infants cannot safely handle the amount of aluminum in childhood vaccines."
    },
    {
      "id": "fc8788d7-4beb-4e83-be38-71bc70131b4d",
      "text": "The European Commission abolished visa requirements for Ukrainian citizens despite the Dutch referendum results."
    },
    {
      "id": "bee9ca73-5c90-423a-bda6-cc40b0d089e8",
      "text": "Ukraine will resume train service to Crimea."
    },
    {
      "id": "ed763e3a-042e-4236-ae32-19b545a0942b",
      "text": "The Pfizer/BioNTech vaccine contains mRNA encoding the SARS-CoV-2 spike protein, lipids, sucrose, and salts."
    },
    {
      "id": "7f5c4a4d-fa3e-409c-9584-f23883a8eea0",
      "text": "U.S. rejected Umerov’s ambassadorial nomination because Umerov was an American citizen."
    },
    {
      "id": "5443ea63-f07c-43ad-ac4b-6a2569e1f360",
      "text": "Taking ivermectin cuts the risk of dying from COVID-19."
    },
    {
      "id": "27285168-d87c-46d5-b795-95c75474a413",
      "text": "Coronavirus is not a new virus"
    },
    {
      "id": "9c791913-e09c-4e9e-a09a-095800602b5d",
      "text": "The EU will seize and scrap any old car that does not meet EU climate criteria."
    },
    {
      "id": "b91fddc8-4368-4d68-b665-5ef12e76519d",
      "text": "More than 80% of MEP candidates oppose Ukraine joining the EU."
    },
    {
      "id": "a286990c-f924-4861-b1f5-11adc6525f83",
      "text": "SARS-CoV-2 was created by genetic experiments using bat coronavirus RaTG13 as a template."
    },
    {
      "id": "f3816555-9899-45e1-ab43-5f94a8bf10aa",
      "text": "Aluminium in vaccines causes cognitive deficits, Parkinson's disease, and Alzheimer's disease."
    },
    {
      "id": "a9022ebd-de7d-4111-b77d-91d91f5a0c87",
      "text": "The EU and the US opened a criminal case against Poroshenko."
    },
    {
      "id": "0fdf030e-76b2-404f-b9fa-d5ce5442f261",
      "text": "The US created a schismatic, disenfranchised church in Ukraine."
    },
    {
      "id": "29b0d668-c065-4cd9-9b19-a5126bdd0f5b",
      "text": "The \"CGG CGG\" codons and the furin cleavage site in the SARS-CoV-2 spike gene do not occur in nature and prove the virus was engineered and not transmitted from animals to humans."
    },
    {
      "id": "e5b71e08-b9c6-4d7e-9499-bf91654d8f96",
      "text": "The European Union admitted that Russia won the war in Ukraine."
    },
    {
      "id": "155b3063-7f23-4da8-a16a-a89ff2ce42c7",
      "text": "COVID-19 mRNA vaccines are experimental, ineffective, and harmful."
    },
    {
      "id": "c71e8be2-7486-453c-be1d-b9c75dd815fb",
      "text": "The Ukrainian government officially recognizes that Russia is protecting Donbas residents."
    },
    {
      "id": "919b7d95-1dd5-4408-a49a-504a37005d6c",
      "text": "Wind turbines are killing bald eagles and causing consumers to pay higher electricity bills."
    },
    {
      "id": "157a3f9d-f4b5-4baa-ac8d-e0cbecbe4c65",
      "text": "U.S. Ambassador in Kyiv said St. George’s Ribbon is a Russian army insignia."
    },
    {
      "id": "220c9490-1e41-4647-b70e-5e11d5b7f9ed",
      "text": "Kyiv claims Russia has lost a third of its army in the Ukraine war."
    },
    {
      "id": "75374dcc-d1c6-4bd9-a6b3-7eb2980f0d5b",
      "text": "A study by Rössner et al. found vaccines are useful and clearly superior to natural immunity."
    },
    {
      "id": "cfcc8341-a799-42c7-b833-bdbe0d148be8",
      "text": "Hungary will shoot down a Ukrainian airliner."
    },
    {
      "id": "217552fc-2ca8-430c-8b02-d361a5851175",
      "text": "The OSCE declared the Russian presidential elections were open and fair."
    },
    {
      "id": "2b73d0ee-3da7-4a76-b910-a9d437a5f51f",
      "text": "COVID-19 is less deadly than seasonal flu."
    },
    {
      "id": "6b6da3a4-46b0-42e2-b535-3942dd778814",
      "text": "Ukrainian military destroys OSCE drones"
    },
    {
      "id": "4f66e2cb-59d1-4ec6-8d5e-9bbab812bd5d",
      "text": "The United States is preparing the final aid package for Ukraine."
    },
    {
      "id": "73cc86da-816a-4162-a2ea-4d17641ac220",
      "text": "Ukraine recognized new Russian entities."
    },
    {
      "id": "bde9d065-4da5-4122-84e2-a2a71d3d397d",
      "text": "Vaccines harm children, fully unvaccinated children are healthier, and vaccines cause chronic disease in America."
    },
    {
      "id": "b85ed737-53e4-4c4f-89dc-30ea24f8522e",
      "text": "Olena Zelenska spent over one million euros on designer clothes."
    },
    {
      "id": "c1ae1e08-3b9c-4e6d-ab94-e36c93e1210b",
      "text": "Nicotine cures Parkinson's disease, Alzheimer's disease, ulcerative colitis, and multiple sclerosis and is a treatment for autism."
    },
    {
      "id": "90b935d2-1136-49d0-90a5-0d6f0cd8fd73",
      "text": "Blinken acknowledged that Russia would grind Ukraine."
    },
    {
      "id": "562026e1-3ea1-40be-bb7a-064c265fc22a",
      "text": "Cultivated meat is produced using cancerous and precancerous cells."
    },
    {
      "id": "f08e815a-d586-4bfb-94c0-ebd0ab4bee9a",
      "text": "A photograph of a boy from Donbas was used in a protest against Muslim migrants in Sweden."
    },
    {
      "id": "e2cf4b2f-b2df-4b22-a695-ce32cc4b7f8a",
      "text": "Remdesivir kills people"
    },
    {
      "id": "0c0b743f-c802-46d4-b763-5b0569776cb8",
      "text": "A man in Bila Tserkva was killed while being served draft papers."
    },
    {
      "id": "d49f1242-551c-4681-88e3-48b841342491",
      "text": "The United States and Canada have ended military cooperation with Ukraine."
    },
    {
      "id": "c4cb067e-bbe4-4071-8c9b-8006ed778d69",
      "text": "Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely."
    },
    {
      "id": "2edf27e1-e806-4061-9ed7-968dd0e6ac84",
      "text": "Nasal swabs used for COVID-19 testing contain ethylene oxide and are harmful."
    },
    {
      "id": "787fd6fd-2ddf-4f9f-84b6-9f779f67c4b3",
      "text": "Ukrainian authorities will lift sanctions on Russia."
    },
    {
      "id": "56bb2e7c-8484-4855-bb44-49f93543bd19",
      "text": "Ukraine's Foreign Minister wants to identify and expel holders of Russian passports."
    },
    {
      "id": "9aa1ce99-1ccd-4c48-90f8-4f90b370df74",
      "text": "Georgian snipers shot Maidan demonstrators."
    },
    {
      "id": "f1738e70-73f1-40c1-950a-c03f9ea23c76",
      "text": "The Czech president recognizes Crimea as part of Russia."
    },
    {
      "id": "6f0df810-320c-45cb-9e6c-3b3dbbc667e6",
      "text": "Ukrainian President Volodymyr Zelensky admitted that Ukraine lost Crimea."
    },
    {
      "id": "e721ed2f-cf0f-44d3-a6c1-1a24735d877a",
      "text": "The Ukrainian Orthodox Church canonized Stepan Bandera, the assassinated Ukrainian nationalist leader."
    },
    {
      "id": "0308a072-47c5-4260-b16d-5658fe09cd8d",
      "text": "Producing enough COVID-19 vaccine to vaccinate the entire world population will take decades."
    },
    {
      "id": "df53c2c0-c395-468e-bb2e-26218921a087",
      "text": "Germany's Bundestag recognizes that Russia will not give up Crimea."
    },
    {
      "id": "b858d41f-05e4-40bb-a45c-3887f0b5fd1d",
      "text": "Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic."
    },
    {
      "id": "77a079b2-ee48-41ba-8507-454e8d25592f",
      "text": "The CDC admits that 98 million Americans received polio vaccines over an eight-year span that were contaminated with a cancer-causing virus."
    },
    {
      "id": "005bd7ce-1396-456e-8eee-0bd7d6c8574e",
      "text": "Forest fires are caused by poor management, and climate change does not cause forest fires."
    },
    {
      "id": "61082364-4f43-42f4-b547-011b0b54111a",
      "text": "Ukraine caused the fire at the Warsaw shopping centre."
    },
    {
      "id": "73b15efc-b9e7-4a74-a59b-6b200ea91739",
      "text": "Researchers from Yale University created an airborne delivery method for mRNA vaccines."
    },
    {
      "id": "2e147448-c306-49ad-9fef-d0dada94258d",
      "text": "COVID-19 vaccines are an unqualified disaster that did not halt viral spread and caused high morbidity and mortality."
    },
    {
      "id": "bdf0f963-60ea-4633-a086-26f0ea0b2d42",
      "text": "45% of Ukrainians work abroad and Ukraine has record-high unemployment."
    },
    {
      "id": "db788cf1-32db-4d5c-81b0-a5c2676bf0d6",
      "text": "Apple AirPods emit dangerous levels of radiation that harm the human body."
    },
    {
      "id": "61e80615-2fec-4038-aaa3-0bcf5a2848af",
      "text": "Asymptomatic spread of COVID-19 does not occur."
    },
    {
      "id": "d6bfa4fd-4472-413d-af99-68d64e7ca707",
      "text": "Fascism has returned to Ukraine."
    },
    {
      "id": "eac18877-33c0-46a2-bce9-20fffdca5b22",
      "text": "Ukraine returned Yanukovych's billions to Russia with interest."
    },
    {
      "id": "560790a8-689e-4fe2-bd9f-c6d867654701",
      "text": "The UN condemns Ukrainian attacks on the Zaporizhzhia Nuclear Power Plant."
    },
    {
      "id": "1917a5b3-9a61-409b-9ef2-a3ae28ce7476",
      "text": "Valery Zaluzhnyi joined the European Solidarity political party."
    },
    {
      "id": "1114b133-176b-4fcb-bfa2-39ab1a7f2233",
      "text": "Ukrainian aircraft from Kyiv entered Russian airspace."
    },
    {
      "id": "477a61c2-bcae-48d9-9047-5af98157bde9",
      "text": "Ukraine cut the Chornobyl power lines and refused to repair them."
    },
    {
      "id": "b61fe9a5-7456-42c5-926b-90ebbcdd79f8",
      "text": "The Lublin Triangle organized a coup in Belarus."
    },
    {
      "id": "1d52a278-2548-4be5-b8e9-85b1e1f457b7",
      "text": "Poland demands official status for the Ukrainian language."
    },
    {
      "id": "ca39f7af-44af-4a9b-aae6-1388ead9b5ee",
      "text": "Ukrainian nationalists shelled Kherson."
    },
    {
      "id": "04c9412b-bbed-4091-a914-6dc969953182",
      "text": "People do not wear masks for tuberculosis because CNN has not instructed them to."
    },
    {
      "id": "ea1594a0-615f-4ffc-8dfc-b1def5b9dfc3",
      "text": "The CDC says face masks do not prevent COVID-19 and mask mandates had no statistical effect on COVID-19 case numbers."
    },
    {
      "id": "66ced45a-b323-4e56-a143-2292b8db962f",
      "text": "Bukovina Romanians demand territorial autonomy from Ukraine."
    },
    {
      "id": "7113e5a5-a4aa-431e-8b49-b4e85e5b3230",
      "text": "Naftogaz lost a legal case against Gazprom in an EU court."
    },
    {
      "id": "72c2d36a-c9a2-4fac-8a4a-3725b096e974",
      "text": "Apple AirPods emit dangerous levels of radiation that harm the human body."
    },
    {
      "id": "ff58331a-224c-4522-932a-a86dd264f8d3",
      "text": "The media exaggerates the harm of measles cases and ignores millions of vaccine injury reports."
    },
    {
      "id": "2a34a81c-7f8f-469d-b3e2-0ae4bd923626",
      "text": "One in 35 people showed signs of heart damage after receiving the Moderna COVID-19 vaccine; the Moderna vaccine is a kill shot; taking the Moderna vaccine is madness."
    },
    {
      "id": "276d53d4-40d6-4396-bead-e57b8683665a",
      "text": "Ukraine's language police punish children for speaking Russian."
    },
    {
      "id": "78169a0b-75f2-4830-896f-9056dcae8c86",
      "text": "Ukrainian military shelled the OSCE mission."
    },
    {
      "id": "ca89c722-a39a-4f71-97bd-af7e85c2f6d6",
      "text": "The NIH researched chloroquine and concluded it effectively stopped SARS coronavirus infection and spread."
    },
    {
      "id": "93dc2389-7725-4bfd-aa6d-0f5e7a002603",
      "text": "Global weather is controlled by secret geoengineering programs using chemtrails and ionospheric heating facilities."
    },
    {
      "id": "25cb42f3-b7ab-4687-8682-b0df8e276a21",
      "text": "Progesterone reverses an abortion after taking mifepristone."
    },
    {
      "id": "9aab8a4a-4cbc-46bb-93ea-531d1ace5ba9",
      "text": "Burning sage removes bacteria from the air."
    },
    {
      "id": "10a59df0-25fd-4c52-80ff-367b12e6a6cd",
      "text": "Maia Sandu's party will raise the retirement age, increase taxes, and extend mandatory military service terms."
    },
    {
      "id": "875bdd9c-f618-4ae3-859a-2f2941fa6415",
      "text": "Italy's Liguria region officially recognizes Crimea as part of Russia."
    },
    {
      "id": "c9c3253c-b9a6-4fd9-85f2-e27a00c0b6aa",
      "text": "Estonians will become a minority in Estonia due to an influx of Ukrainian immigrants."
    },
    {
      "id": "e7259cd4-641d-4c35-8240-9e5b6eccdf14",
      "text": "Poland is merging Lithuania."
    },
    {
      "id": "d11b7ac1-5f7b-4232-bbcb-3378e317d050",
      "text": "Ultra-right groups are patrolling Kyiv public transport during the COVID-19 quarantine."
    },
    {
      "id": "95737f58-3e4b-48c3-be9c-d7ac586f92ab",
      "text": "Pfizer CEO's wife died from complications caused by the COVID-19 vaccine."
    },
    {
      "id": "86969868-4746-4e4b-b91e-da0c9d8dda79",
      "text": "Photo shows a Ukrainian prisoner of war with a Nazi coat tattoo."
    },
    {
      "id": "1d260ccf-c916-4d6e-8c87-5b7e63e401c3",
      "text": "A study showed that COVID-19 vaccines cause a high number of serious adverse events."
    },
    {
      "id": "182bd972-a7e0-4c8b-b3f5-33eef3f0edd8",
      "text": "President Poroshenko proposes depriving Crimeans of Ukrainian citizenship."
    },
    {
      "id": "1946c57f-c5ac-4487-b355-5338816d61be",
      "text": "Masks work to prevent COVID-19 transmission, so voting in person is safe when people wear masks."
    },
    {
      "id": "987fae78-c69c-4ae1-87a2-1783d4df0a8b",
      "text": "A complete cure for cancer will be available within one year."
    },
    {
      "id": "30da1f6b-f79a-4f5d-9704-e8804aed132e",
      "text": "A vaccine caused people to become zombies in the movie \"I Am Legend\"."
    },
    {
      "id": "79fb148b-5b6b-4fb0-becd-9d53f2ad3be5",
      "text": "Antibodies from common-cold coronaviruses cause positive COVID-19 antibody test results and are responsible for the reported COVID-19 cases in the U.S."
    },
    {
      "id": "a2a3fc3e-ab7d-4a1b-8404-f01a97d0af23",
      "text": "Artificial sweeteners cause cancer; people in the 1930s ate cake, cookies, and ice cream with sugar and were healthy."
    },
    {
      "id": "35088c9d-c4b5-45a7-8b74-288b070bb212",
      "text": "A gold-standard scientific trial found that N95 and surgical masks do not stop COVID."
    },
    {
      "id": "ea0ea37c-cb3a-4795-b344-da65b07ff1dd",
      "text": "World Health Organization declares bacon is as harmful as cigarettes"
    },
    {
      "id": "ebe8bc4e-1757-407a-8cd2-ee631c8c11e7",
      "text": "Donald Trump asked European Commission President Ursula von der Leyen to step out of a meeting with other leaders."
    },
    {
      "id": "7478c1f9-2d96-4035-9cc6-828f2516be85",
      "text": "The United States is preparing a new color revolution in Ukraine."
    },
    {
      "id": "dcf03b2f-69bb-4512-a5f4-483f998abacd",
      "text": "Science confirmed eating turmeric every day reverses cancer."
    },
    {
      "id": "b0d48266-96c9-4672-9d0d-180af4f746b6",
      "text": "Ukraine will not receive a COVID-19 vaccine before April 2022."
    },
    {
      "id": "5e2f3926-67a0-4510-8b6b-ca6546e4ca03",
      "text": "Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely."
    },
    {
      "id": "c4f5cb28-559e-4c76-99b2-e6e0f4621d6e",
      "text": "A study and headline claiming that homegrown food is more carbon intensive than conventional agriculture were intended to discourage and stop people from growing their own food."
    },
    {
      "id": "56bf3714-590c-4c73-b341-71f048a2366a",
      "text": "77% of Europeans believe in Russian unity."
    },
    {
      "id": "19497ff6-291a-4c5c-abc3-61abaaf0308c",
      "text": "Mass COVID-19 vaccination selects for more virulent SARS-CoV-2 variants that escape vaccine-induced immunity and cause more severe disease."
    },
    {
      "id": "d156d71a-fe2d-4d63-9a18-423d0ecaf3cd",
      "text": "Ukrainian presidential elections are illegitimate"
    },
    {
      "id": "8b198f66-df0e-45d3-baa7-17c01dc6e575",
      "text": "Poroshenko declared the Stepan Bandera flag the official symbol of Victory Day."
    },
    {
      "id": "1bccfbf1-34fd-45b1-8a0e-d466bbcc080b",
      "text": "Abortion is never medically necessary."
    },
    {
      "id": "766a17e5-e340-42cc-ad95-c5f9edc91933",
      "text": "The National Guard received an order to surrender soldiers, and those soldiers were executed."
    },
    {
      "id": "3c0edcf9-b28b-4b96-ba4f-1b328d91a133",
      "text": "Ukrainians in Poland are cleaners and dishwashers."
    },
    {
      "id": "a1a34e57-69ee-4070-841d-5b90d76d211b",
      "text": "Poles escaped military training and fled to Germany in panic."
    },
    {
      "id": "f74f111b-8ae8-43bd-8aae-72707a95b433",
      "text": "Coronavirus relief funds in Ukraine were diverted to support patriotic cinema."
    },
    {
      "id": "37413551-3a0d-46af-a81d-f37c6fd47d58",
      "text": "Poland introduced censorship of World War II history on orders from the United States."
    },
    {
      "id": "a667f48f-8745-4f2a-8286-426e6fad417e",
      "text": "All Crimean Tatars support Russia’s special military operation in Ukraine."
    },
    {
      "id": "8c88f73c-85de-4477-af26-a24e852c54f0",
      "text": "Ukrainian minister called for convicts to be sent into battle with shovels."
    },
    {
      "id": "c8d7bec3-38b5-43be-923a-1a6e55e6017f",
      "text": "The US sold defective Javelins to Ukraine."
    },
    {
      "id": "a30a9052-88ad-4420-8689-703abc36bb2e",
      "text": "More people died from COVID-19 during Biden's administration than during Trump's administration."
    },
    {
      "id": "9441a8c9-7e9e-4baf-be1f-d370158a43ff",
      "text": "Dietary supplements containing AHCC treat HPV infection."
    },
    {
      "id": "5c2f1cdd-0a0b-40b1-bc68-8742aa3a3d48",
      "text": "Russian forces destroyed the Georgian Legion."
    },
    {
      "id": "7d40c681-2ef3-4d2e-95ee-9827d1b93589",
      "text": "Western governments want an urgent peace treaty with Russia because Ukraine will suffer a catastrophe."
    },
    {
      "id": "06f4a3e5-b0e3-4d9e-9fb1-38b19ec5cff6",
      "text": "Finnish farmers are losing income because of Russian sanctions."
    },
    {
      "id": "624d6091-1fe3-4572-bdbf-b81bac9a871b",
      "text": "Erdoğan’s son defended purchasing oil from ISIL."
    },
    {
      "id": "081b2b41-5d2f-468a-8eda-4d4c95d9f977",
      "text": "The COVID-19 pandemic is a planned, staged pandemic manufactured through PCR testing."
    },
    {
      "id": "3791a65c-265a-42c0-ada5-4d83f9d23a6c",
      "text": "Kyiv is forcing waiters and shop clerks to speak Ukrainian."
    },
    {
      "id": "75eb9293-d877-4a9b-a68b-1978f9ce494e",
      "text": "Thousands of European bikers joined the Night Wolves in Berlin."
    },
    {
      "id": "8f954d51-f4fc-4309-ba61-b0094d0fd645",
      "text": "The Netherlands will not ratify the EU-Ukraine Association Agreement."
    },
    {
      "id": "c75efdf2-f439-4cc5-a3a4-cfc244981056",
      "text": "Western governments blackmailed Ukrainian President Volodymyr Zelensky."
    },
    {
      "id": "00c985ec-b5b5-4575-8daa-509ab455dd63",
      "text": "Online interest in Volodymyr Zelensky dropped by 63%."
    },
    {
      "id": "a8d63af7-5112-49c2-a95a-d10fa6cd6f10",
      "text": "Western countries have begun partitioning Ukrainian regions."
    },
    {
      "id": "b5fad97a-c940-4eb5-9348-f3275f2ffab4",
      "text": "Kyiv is deserted and Ukrainians are leaving Ukraine."
    },
    {
      "id": "bb6e3d80-a5b9-4d0e-941d-032c3f720829",
      "text": "An Israeli study proves COVID-19 does not increase the risk of heart inflammation."
    },
    {
      "id": "eb56e2ca-fcac-4e1c-b941-c92ae6761bbb",
      "text": "Olena Zelenska canceled a lecture at Ljubljana University because students protested."
    },
    {
      "id": "d30c6914-f4a7-41a8-81c8-8e7b455498da",
      "text": "Volodymyr Zelensky provoked a nuclear crisis."
    },
    {
      "id": "b8011f98-a6a4-4042-b9f0-473b601a8aea",
      "text": "Photo shows dogs eating the body of a Ukrainian soldier."
    },
    {
      "id": "eb38c7e2-9e1f-4e77-a649-5768d011d58e",
      "text": "Crimean Tatars will vote for Putin in the March presidential election."
    },
    {
      "id": "4abbf66c-c32f-4597-83b9-82aae5c19f37",
      "text": "Ukrainian troops blew up nitric acid tanks in Rubizhne."
    },
    {
      "id": "75a03f36-1521-47d2-bc3e-52f932e91ec6",
      "text": "Luciferase is present in COVID-19 vaccines and is used to tag and track people."
    },
    {
      "id": "410d7f41-8cb7-49b7-a408-7780cefbec44",
      "text": "Ukraine cancels Victory Day and dismantles the Vatutin Monument."
    },
    {
      "id": "57a25bac-e26f-49eb-9426-9fdf3ee70d6d",
      "text": "Vaccines did not eradicate polio."
    },
    {
      "id": "249d58f4-05a8-4d8c-b470-983e698ab693",
      "text": "The U.S. Ambassador to Russia called for the lifting of U.S. sanctions on Russia."
    },
    {
      "id": "f71a7b74-67f3-4a39-8e9b-8317ed8580ee",
      "text": "Ukrainian president left Kyiv in haste"
    },
    {
      "id": "de9a742a-d87b-46a6-997b-e317436bae74",
      "text": "Ukrainian mass media are avoiding coverage of refugees."
    },
    {
      "id": "bf356d95-2792-494a-9c53-723a7d138cc9",
      "text": "Castor oil breaks up scar tissue, bone spurs, and tumors."
    },
    {
      "id": "97dc3544-0bc6-439b-837c-f643d25780c3",
      "text": "A portrait of Symon Petliura hangs instead of an icon in a Ukrainian Orthodox Church of Canada church."
    },
    {
      "id": "7222b469-b151-49bc-acd6-0be874ba7920",
      "text": "Kyiv cancels the heating season because of Russian sanctions."
    },
    {
      "id": "98f6cf72-868f-440b-85db-ec6f14c39793",
      "text": "Human breast milk naturally contains the same cannabinoids as the cannabis plant."
    },
    {
      "id": "fc0e950c-2062-4497-8b15-3820ad4d8861",
      "text": "Right Sector members were attacked by helicopter fire in Zakarpattia Oblast."
    },
    {
      "id": "e18baf6a-6871-464b-9cb4-a5a5b94071a8",
      "text": "Children hospitalized for non-COVID reasons were the ones on ventilators, and children hospitalized for COVID-19 were not on ventilators."
    },
    {
      "id": "f66ef738-8db0-4a21-a79a-44e8d3fdbdf7",
      "text": "Ukraine armed civilians; shops were looted and civilians were shot."
    },
    {
      "id": "cce4f4c5-55ff-4594-ad63-db2ba7336564",
      "text": "Ukrainian military shelled the bus near Volnovakha."
    },
    {
      "id": "0d22b873-3bcd-46f0-ac8d-be55d657c3d5",
      "text": "President Volodymyr Zelensky publicly downplayed the deaths of Irish personnel serving in Ukraine's armed forces."
    },
    {
      "id": "94a1ce17-80ad-4be5-af57-c87d3443e0ad",
      "text": "Fluoride exposure repeatedly reduces IQ and causes brain damage."
    },
    {
      "id": "039ac62f-753d-4687-85d4-fe380baf1e9b",
      "text": "The CDC is a vaccine company, not an independent agency; it owns over 20 vaccine patents and sells $4.6 billion of vaccines each year."
    },
    {
      "id": "129eda25-7e65-4bd7-85d2-2cbf45fb11cf",
      "text": "Poroshenko offered to exchange Crimea for NATO membership."
    },
    {
      "id": "b3eec49f-990e-4af0-99ce-b5b1674ce1ce",
      "text": "An NIH-published study found that N95 COVID masks expose wearers to dangerous levels of toxic compounds linked to seizures and cancer."
    },
    {
      "id": "e0a8a269-5e6a-40ca-b2d5-cae2eb3ab4f3",
      "text": "Ukrainian military sabotages elections in Donbas."
    },
    {
      "id": "9e079658-a585-464b-a262-b8382a78b4bb",
      "text": "Bloody Canadian mercenaries are in Donbas."
    },
    {
      "id": "fdf896da-e199-4be6-b7f6-8c2bd776562e",
      "text": "Belarusian pilots are long dead and are not fighting against Ukraine."
    },
    {
      "id": "999e662e-08b9-49b2-b175-8dd13a767110",
      "text": "COVID-19 vaccines are 98 times more harmful than COVID-19 infection."
    },
    {
      "id": "3b8a9b74-84cf-4774-919f-c0e17240e45e",
      "text": "Mothers of Russian soldiers were found to have received grants from the United States government."
    },
    {
      "id": "334a9b32-ce27-48e6-b0bc-b8ea89c75156",
      "text": "Arseniy Yatsenyuk rejected a debt restructuring proposal."
    },
    {
      "id": "11832956-c82c-44b0-91c4-4840f8ca62a7",
      "text": "Masks protect people from COVID-19, so no one needs a flu shot right now."
    },
    {
      "id": "47c717b3-851d-4eb5-88b5-b17088e768c9",
      "text": "A COVID-19 vaccine contains an aborted male fetus."
    },
    {
      "id": "c0109198-ee1a-4099-955c-d818edf37cee",
      "text": "Masks on children are ineffective"
    },
    {
      "id": "278a0146-212e-405b-8949-d4c04cb5f338",
      "text": "Ukraine is placed on a map of modern Nazism."
    },
    {
      "id": "28c27d9d-9d42-4e63-b688-e63184d2da1b",
      "text": "Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls their domestic policies, forces vaccinations and lockdowns, and arrests vaccine opponents."
    },
    {
      "id": "bdb21458-dbfe-4275-9fa8-0f9835290487",
      "text": "Danish researchers found high rates of adverse events following the Pfizer COVID-19 vaccine, and the vaccine is unsafe."
    },
    {
      "id": "945ed028-9468-4bb8-a245-d462906aafb8",
      "text": "A randomized controlled trial of 2.7 billion people showed hydroxychloroquine reduced the COVID-19 death rate by 79.1%."
    },
    {
      "id": "dbe21f83-60a8-4568-bb55-34d127142232",
      "text": "Azov threatened to destroy Dutch citizens if the Netherlands rejected the association deal with Ukraine."
    },
    {
      "id": "f38bbeb4-28fa-4f3f-9d83-3c9ccda84be2",
      "text": "Scientists have found CO2 and global temperature are not consistently correlated, and scientists do not know whether Earth will warm or cool in the future."
    },
    {
      "id": "7ae47a7d-066d-40fe-a8a1-8bc552a48008",
      "text": "The measles vaccine caused the measles outbreak in Texas and measles vaccines cause measles outbreaks."
    },
    {
      "id": "497d5038-273a-402d-9e56-2b2e9fe72bc9",
      "text": "The Amazon is switching from tropical rainforest to savannah."
    },
    {
      "id": "14204ab1-80b5-4131-96d6-b20416510a3f",
      "text": "Volodymyr Zelenskyy bought a hotel-casino in Cyprus using U.S. government funds."
    },
    {
      "id": "e5c5cfed-e553-4c1b-ac88-2713c8b637c2",
      "text": "Russia deliberately slowed its offensive to avoid civilian casualties."
    },
    {
      "id": "a900d61c-14d8-49c7-9d31-8c052482804b",
      "text": "Kyiv bans Easter by forbidding people from entering churches."
    },
    {
      "id": "62594f26-90d1-4fb4-94d2-76d96a5a4670",
      "text": "The Coalition of the Willing plans to partition Ukraine to seize its resources."
    },
    {
      "id": "5613b471-f5b7-4770-8150-226427574bf4",
      "text": "Sanctions on Russia cost Ukraine $98 billion."
    },
    {
      "id": "e378c0e4-784a-400f-83ab-44acd7efff8f",
      "text": "American missiles were found in Luhansk."
    },
    {
      "id": "5d287179-1913-49a6-a2dc-52aa26f47a04",
      "text": "Conflicting numbers on Ukrainian children abductions show that deportations did not occur."
    },
    {
      "id": "c3bc63e4-3848-4ca2-8707-206e5c2af2b2",
      "text": "COVID-19 vaccines are experimental, do not prevent infection or transmission, and most people have a 0.05% chance of dying from COVID-19."
    },
    {
      "id": "b16188b6-0bfd-4e86-aec8-758e1788ac7d",
      "text": "Sweden's COVID-19 death rate was lower than Spain's, Italy's, and the U.K.'s, despite Sweden not implementing a lockdown."
    },
    {
      "id": "636986f4-7d28-4292-b06e-7144ac4b1cda",
      "text": "Britain apologized to Boris Johnson."
    },
    {
      "id": "2610f24b-2b31-4670-b760-f239b5e6fa97",
      "text": "Hundreds of Ukrainian soldiers deserted to Russia and asked for asylum there."
    },
    {
      "id": "604bab64-fcae-4b2a-9e35-f1f01336aa83",
      "text": "Members of the British Parliament denounced EU interference in Ukraine."
    },
    {
      "id": "bd5fc61e-f04d-474c-8059-3dab5253b183",
      "text": "International MH17 investigation team ignored Russian radar data."
    },
    {
      "id": "42f09db3-551d-4166-8b95-eac38932ccf7",
      "text": "Ukraine has banned New Year celebrations because Ded Moroz is Russian."
    },
    {
      "id": "34faaaca-1b92-447b-ba8f-2a9e760060fb",
      "text": "The Ukrainian parliament registered a law that criminalizes criticism of the government."
    },
    {
      "id": "ff17c431-3371-4f1b-90f4-92249ef3c30f",
      "text": "Ukraine has one of the highest levels of organized crime in the world."
    },
    {
      "id": "1f50ab6e-06e6-4323-8f2d-970dd2aaa5ff",
      "text": "Solfeggio frequencies regenerate the human body, remove bodily toxins, and eliminate negativity."
    },
    {
      "id": "2a3d2c14-0c4e-4df4-83b9-1697054ce7c6",
      "text": "The United Nations recognized Russia's telephone code for Crimea."
    },
    {
      "id": "2e65a4c7-e471-453a-a9b4-5828f81768fc",
      "text": "Ukraine cut off electrical power to Crimea"
    },
    {
      "id": "cac625ec-a0cd-4362-931f-e60127b9e0ed",
      "text": "Ukrainians want referendums in Russian-occupied territories."
    },
    {
      "id": "c2726e3b-de4f-4025-bcf7-aa4a83298e58",
      "text": "Climate change is a natural, constant cycle that occurred without human influence and human activity does not significantly affect the climate."
    },
    {
      "id": "b49fd94f-a2e9-4402-a8fb-04c957603726",
      "text": "Pfizer's COVID-19 vaccine was tested on only 250 people."
    },
    {
      "id": "35f1768b-5b75-4726-af15-53b8453bf960",
      "text": "Wind energy kills more birds than fossil fuels, and renewable energy is causing mass bird deaths."
    },
    {
      "id": "a341c062-e189-4526-9e17-0a4302d82684",
      "text": "Shark Tank investors, Dr. Phil, and Dr. Oz endorsed CBD gummies, and CBD gummies provide numerous health benefits."
    },
    {
      "id": "400dda24-5642-4eaa-b0cb-21895e10b95a",
      "text": "Colored blocks printed on toothpaste tubes indicate whether the toothpaste is made of safe ingredients."
    },
    {
      "id": "5cfe33f3-fea8-49f4-9ed4-eee6a3217253",
      "text": "The Ukrainian government demands 75% of radio airtime be Ukrainian music."
    },
    {
      "id": "1f803c39-679e-4b18-af7a-67db88ade0a2",
      "text": "OSCE confirmed there are no Russian military forces in Donbas."
    },
    {
      "id": "cc97e4d7-39ac-46ac-ab8e-e2e0f8480d08",
      "text": "President Petro Poroshenko was stripped of Verona honorary citizenship because he stole paintings."
    },
    {
      "id": "30992d07-6067-4261-8356-d56b2fd9b710",
      "text": "Samoa withdrew the MMR vaccine after two babies died within minutes of receiving the MMR shot."
    },
    {
      "id": "85b61735-9032-4a87-af70-6f181c7a1dda",
      "text": "Wisdom teeth are meridian lines connected to the heart and removing wisdom teeth causes heart problems."
    },
    {
      "id": "baa6ae57-ce52-4790-9177-e3e7b2392be4",
      "text": "The United States is using Ukraine as a guinea pig to test vaccines."
    },
    {
      "id": "c9aca791-24e8-4105-8a1c-f43879aca0e3",
      "text": "Hydroxychloroquine, azithromycin, and zinc cure COVID-19."
    },
    {
      "id": "5dfba5cb-799d-4b07-87b5-8e2980417a6b",
      "text": "A 51-million-person study found COVID-19 vaccines increase the risk of respiratory infections by 559%."
    },
    {
      "id": "ea8e283b-182c-4143-be2f-de77f5d27cba",
      "text": "Aircraft are spraying chemical gases containing aluminum, barium, and other metals to block the sun and create chemical rain and fog to manipulate the weather."
    },
    {
      "id": "8c2d291f-df81-468d-85a3-0e1fc31ede57",
      "text": "Ukrainian President Volodymyr Zelensky ordered the Catherine II statue in Odesa to be replaced with a monument of a US porn star."
    },
    {
      "id": "5caaa189-9220-4884-8396-ddfdeb8e9a35",
      "text": "Pfizer's clinical trial showed equal numbers of deaths in the vaccine and placebo groups, so the vaccine had no benefit."
    },
    {
      "id": "35177478-d6ba-4d8e-b6b0-d026b89a18b3",
      "text": "A person's immune system strength can be determined by looking at their eyes."
    },
    {
      "id": "164555ef-1d96-44b4-8f2c-a56ac2c400bd",
      "text": "More than 88% of ICU patients in Germany are vaccinated, and COVID-19 vaccines do not protect against severe disease."
    },
    {
      "id": "1b9e3d5a-e548-4979-9072-bc0a417162a5",
      "text": "The Great Barrier Reef is experiencing the largest bleaching event ever recorded."
    },
    {
      "id": "79113d89-5d52-41ad-8205-38de4d4905a5",
      "text": "Ukraine supplied Azerbaijan with phosphorus weapons."
    },
    {
      "id": "a2ed6adc-50b0-4f09-9db8-fb2a75a24925",
      "text": "World leaders were duped into investing billions because global warming data was manipulated."
    },
    {
      "id": "36c7062c-b507-4d27-bfab-ca6f4b494394",
      "text": "The Delta variant of SARS-CoV-2 has a lower fatality rate than the original (Wuhan) variant."
    },
    {
      "id": "514684a4-216a-43b8-89b4-796e192c499c",
      "text": "The UN will not provide money to the Ukrainian government."
    },
    {
      "id": "05366e38-604d-43f6-b486-b13216dc32f1",
      "text": "Ukraine authorized Poland to distribute Ukrainian passports."
    },
    {
      "id": "cc9c1faf-f971-4aad-bee5-4f46968b9f0a",
      "text": "Nicotine patches cure Parkinson’s disease."
    },
    {
      "id": "8aeeea15-aa9e-4a7a-ac13-8421e1c1f6c6",
      "text": "A Ukrainian Army tank crushed a car containing a passenger."
    },
    {
      "id": "94eef71a-da34-4277-a1f1-3afbc1c2a534",
      "text": "A record number of Ukrainian tourists visited Crimea."
    },
    {
      "id": "e2b7a9e2-4169-4e2a-82cc-818f5dbdf36e",
      "text": "COVID-19 PCR tests are inaccurate, have been discontinued, and cannot differentiate influenza from COVID-19."
    },
    {
      "id": "54a34012-19fb-4e45-96e9-9f7d1cf417c3",
      "text": "Ukrainian President Volodymyr Zelenskyy exempted relatives of Galicia Division soldiers from conscription."
    },
    {
      "id": "174d2d07-cece-44ec-bff4-d6647249a61c",
      "text": "COVID-19 vaccines are causing a rise in heart attacks among young people."
    },
    {
      "id": "48106139-5b3f-4a6e-9465-2a535b8dff53",
      "text": "Ukraine refuses Western arms due to supply difficulties."
    },
    {
      "id": "5555a3e9-f056-4401-98d7-334e7c38bed0",
      "text": "Lockdowns and face masks do not control the COVID-19 pandemic."
    },
    {
      "id": "2363ff10-3235-432d-913b-658d5f2453d3",
      "text": "The European Union warned Ukraine against militarizing the Sea of Azov."
    },
    {
      "id": "7d9ded32-cfd4-472c-b8e6-639d3e8e7c2b",
      "text": "COVID-19 vaccine spike proteins accumulate in cell nuclei, destroy DNA repair pathways causing cancer, and destroy the immune system."
    },
    {
      "id": "2d731179-770f-46ec-8cff-cdc71213ab2e",
      "text": "COVID-19 immunity lasts for years."
    },
    {
      "id": "74724b14-e8b2-4ed4-bbdd-94566006218f",
      "text": "Ukraine is preparing terrorist attacks in Crimea."
    },
    {
      "id": "06442e9b-bfee-45f4-96d3-f5cbde74c12e",
      "text": "Rockefeller suppressed natural healing modalities to profit from petroleum-based medicine and had natural medicine practitioners arrested and jailed."
    },
    {
      "id": "859e3451-91df-41d7-9b35-30e293b2db5a",
      "text": "Flights from New Zealand to Argentina connect through the U.S., which proves the Earth is flat."
    },
    {
      "id": "c8b6c191-aa5f-4a01-a9b3-7f5ab792cb55",
      "text": "The CDC is a vaccine company that owns over 20 vaccine patents and sells $4.6 billion in vaccines every year."
    },
    {
      "id": "c0e76ce0-91b7-4426-8580-548fe286b428",
      "text": "Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic."
    },
    {
      "id": "73540cd3-dc5a-4e7a-b48a-87b447fccd37",
      "text": "A new language law makes Ukrainian the only official language."
    },
    {
      "id": "16a1efe5-5a02-41dd-9a47-0d530689fdf9",
      "text": "Birch trees were chopped down in Lviv to prevent Russian influence."
    },
    {
      "id": "60d005f6-07f6-4f28-9fbd-3287183b009c",
      "text": "Smoking protects against COVID-19."
    },
    {
      "id": "b0dbda2c-722c-48c6-8dcf-06d13f0ff79c",
      "text": "Vaccinated people are more likely to die from the Delta variant than unvaccinated people."
    },
    {
      "id": "86683180-8d4c-43cd-93b5-f7aefe9a07fc",
      "text": "Ukraine’s Defense Minister declared World War III and urged the West to raise the stakes."
    },
    {
      "id": "bf5f91e6-8c18-466f-a8dd-eac3650d3939",
      "text": "Vaccination causes two deaths for every three deaths it prevents."
    },
    {
      "id": "014ed6d2-14a6-4b25-b4d0-56327e826885",
      "text": "Global warming is causing polar bears to go extinct."
    },
    {
      "id": "53cfb7f0-c2ff-4d26-a2aa-737cdc1dedab",
      "text": "Natalie Jaresko, Ukraine's Minister of Finance, is the sister of former president Viktor Yushchenko's wife."
    },
    {
      "id": "263eb8da-8c39-424c-b6a6-dbcad9df2dcb",
      "text": "Ukraine recruits mentally unstable foreign fighters."
    },
    {
      "id": "afa073a5-82d5-42b2-8a5c-972cb0b1a9d3",
      "text": "Germany asked the United States to ease sanctions on Russia."
    }
  ],
  "events": [
    {
      "id": "84e152f2-fa18-4730-8436-ae5868f07e84",
      "text": "Event1"
    },
    {
      "id": "4c5754f0-e690-4c37-8ac5-89c6b1886ae5",
      "text": "Event2"
    },
    {
      "id": "e75e4d20-06f6-4d3c-bec3-b01d9ef39ba6",
      "text": "Event3"
    },
    {
      "id": "1ee8cf44-cebf-4220-a190-81aff7f6362c",
      "text": "Event4"
    },
    {
      "id": "ab16a202-77eb-433f-a95d-8a5c32382587",
      "text": "Event5"
    },
    {
      "id": "925e012a-7b2b-46ed-9b92-fee628879d10",
      "text": "Japan suspended use of multiple Moderna COVID‑19 vaccine lots after reports of black/foreign particles found in vials (September 2021)."
    },
    {
      "id": "970e6f4d-f145-4e08-88bb-8b775120a572",
      "text": "Media coverage and public records requests highlighted increases and registration of 'Sudden Adult Death Syndrome' (SADS) entries and prompted local registries/news stories in 2021–2022 (e.g., ONS FOI data and June 2022 press stories)."
    },
    {
      "id": "ffb34bd6-7690-4d59-b1ea-e3df21125aaf",
      "text": "Federal judge orders FDA to hasten release of Pfizer COVID-19 vaccine documents after agency proposed a 75‑year timeline."
    },
    {
      "id": "8c5f4025-aa29-4b77-9333-f49a177101a3",
      "text": "Public health agencies (including the CDC) acknowledged a rare association between mRNA COVID‑19 vaccines and myocarditis/pericarditis, particularly in younger males (June 2021 and onward)."
    },
    {
      "id": "9a10a4c8-d6d4-40b4-afa3-7b1430b44a12",
      "text": "Canada officially declared bisphenol A a 'toxic substance' and banned BPA in baby bottles (widely reported in October 2010)."
    },
    {
      "id": "1b3be0de-f336-4d77-9018-5cacd2638d84",
      "text": "EU Regulation 2018/213 restricting the use of BPA in varnishes and coatings intended to come into contact with food (adopted 12 February 2018)."
    },
    {
      "id": "8293afe9-596b-46e3-9a99-a40916ec1804",
      "text": "Authoritative public health pages (e.g., NIEHS) and large NGOs published accessible summaries about BPA being an endocrine disruptor and a substance under active study for health effects (updated educational pages in 2020–2021)."
    },
    {
      "id": "5cf646d1-647b-4ff5-a477-efe2d006cc48",
      "text": "German federal and state governments adopted and publicised '2G' rules that restricted access to restaurants, cultural venues and events to vaccinated or recovered people."
    },
    {
      "id": "395a9807-e7a3-4ab3-94b4-498e499a5709",
      "text": "Large anti-lockdown/anti-vaccine protests in Berlin where police used barriers, cordons and force to control crowds."
    },
    {
      "id": "bf3d4f0a-3cf2-40bc-9347-70f81eb72707",
      "text": "Lancet Psychiatry cohort study (Taquet et al.) reporting increased incidence of neurological and psychiatric diagnoses — including psychotic disorders — in the six months after COVID-19 infection."
    },
    {
      "id": "04f15057-3aed-4d7d-a1ce-a1ed60652382",
      "text": "NATO commander publicly reported sightings of columns of Russian tanks and troops crossing into eastern Ukraine."
    },
    {
      "id": "cee770f3-7c9f-4178-9c74-654b0a079459",
      "text": "Investigative reporting (e.g., Bellingcat) published satellite analysis and open‑source investigations documenting cross‑border convoys and movements of heavy weapons into separatist‑held areas."
    },
    {
      "id": "69b54743-69ff-4a08-818f-3f34fa3103f2",
      "text": "The February 2015 Minsk II agreement called for withdrawal and monitoring of heavy weapons but left verification and inventories contested."
    },
    {
      "id": "b59a915c-4a63-4d9f-a50e-20ff35f19092",
      "text": "National Child Mortality Database (NCMD) data release: child death notifications in England Apr 2021–Mar 2022 (3,470 deaths; 396 more than previous year)"
    },
    {
      "id": "951c2a71-d688-4dd2-895c-f68662968dc4",
      "text": "Kerch Strait incident — Russian forces fired on and seized three Ukrainian naval vessels near the Kerch Strait."
    },
    {
      "id": "94f80ec4-2cc3-4557-83eb-9dfab510cfa7",
      "text": "Odesa Trade Unions building fire — violent clashes on 2 May 2014 ended with a fire that killed dozens; accounts of responsibility were disputed."
    },
    {
      "id": "cddf823c-29ba-406d-9d4c-a908fa0144cb",
      "text": "Maidan sniper shootings — dozens of protesters and police were killed during the February 2014 Maidan clashes; responsibility for the snipers remained contested."
    },
    {
      "id": "edd2b72d-6442-4656-aab4-f03a4a38c553",
      "text": "GUE/NGL (European United Left/Nordic Green Left) letter to President Poroshenko expressing concern about banning the Communist Party and alleged persecution of left‑wing groups"
    },
    {
      "id": "2add510d-82f0-4d5c-9dc5-a97ddccba76f",
      "text": "Court ban on the Communist Party of Ukraine (Kyiv administrative court decision reported December 2015)"
    },
    {
      "id": "305fda9b-19da-4f40-8a6b-dd9dcd2e373f",
      "text": "Panama Papers revelations naming Poroshenko's offshore connections (widespread reporting in April 2016)"
    },
    {
      "id": "88a4b9ac-a4ef-4d31-b258-078d5929dfa3",
      "text": "Fugitive lawmaker Oleksandr Onyshchenko's public corruption accusations against Poroshenko (June 2016)"
    },
    {
      "id": "9becb736-cbb7-43af-b42b-e7efd7fcafaf",
      "text": "Court-ordered release and ongoing discussion of Pfizer/BioNTech vaccine documents (PHMPT/FDA document release process)"
    },
    {
      "id": "0911f635-e117-4a63-960f-87a757d833cd",
      "text": "Venice Commission (Council of Europe) publishes an expert opinion on the 2019 language law raising concerns about minority-language guarantees"
    },
    {
      "id": "cd44330b-fa1c-49b8-889e-4f60abb1948a",
      "text": "Ukrainian parliament adopts the law 'On Ensuring the Functioning of Ukrainian as the State Language'"
    },
    {
      "id": "a1663ab3-1573-41d6-b61e-125f36ef72b5",
      "text": "Immediate political/media backlash and Kremlin-linked commentary framing the law as an attack on Russian speakers"
    },
    {
      "id": "a6a07057-e2be-4abb-a102-d1ff864ddae5",
      "text": "Long‑running Kremlin/state media narrative labeling the Azov movement and affiliated groups as 'neo‑Nazi' and dangerous."
    },
    {
      "id": "06716448-d748-4bcc-9d29-709595db86e6",
      "text": "Denis Pushilin / DPR authorities declared OSCE activities in DPR unlawful and ordered SMM property removed (escalatory political declaration)."
    },
    {
      "id": "23f1861f-9600-4e6e-bcda-e17290f2aa90",
      "text": "OSCE SMM evacuated international monitors and then discontinued the Special Monitoring Mission (loss of on‑the‑ground oversight and telemetry)."
    },
    {
      "id": "39463f3a-f93e-4fc4-81fc-fbf6f203c465",
      "text": "High-profile advocacy and testimony for ivermectin (FLCCC / Dr. Pierre Kory Senate testimony, Dec 8, 2020)"
    },
    {
      "id": "73ef133e-2e7a-4d4a-b9c2-0afcb4bbdfb4",
      "text": "Circulation of prominent preprints and small trials (notably the Elgazzar et al. preprint, Nov 2020) reporting large mortality benefits that fed pooled meta-analyses"
    },
    {
      "id": "88583943-069b-4732-b145-80a54a783005",
      "text": "U.S. announcement to withdraw from the Paris Agreement (President Trump)"
    },
    {
      "id": "a560f278-4f3d-4e87-a291-dc062e6e9562",
      "text": "High‑profile congressional testimony by climate skeptic John R. Christy asserting climate models overstate warming"
    },
    {
      "id": "9aa968e2-cdcd-4bd0-ae6e-db3b7a550990",
      "text": "Poland warns it could veto the EU budget over rule‑of‑law conditionality"
    },
    {
      "id": "7350d91d-6408-4345-9369-78eb520a02d4",
      "text": "European Commission/legal action over refusal to accept refugee relocation quotas"
    },
    {
      "id": "fb703d7b-7566-46ce-87a6-338cbccd27f1",
      "text": "European Commission triggers Article 7 procedure against Poland"
    },
    {
      "id": "9463f49d-31e2-47bb-aeba-88b26e0eaaff",
      "text": "Mass protests after president signs contested judicial reform laws"
    },
    {
      "id": "618c1ef0-a692-466c-b963-89ea7243c3be",
      "text": "Documented NGO and foundation support for Crimean Tatar NGOs (e.g., listings of NED and other international support for Crimean NGO activity after 2014)"
    },
    {
      "id": "bb1bd6e8-303f-4ed0-9dfa-3f0919d2e099",
      "text": "Russian courts moved to ban and label the Mejlis 'extremist' (legal actions and formal prohibition)"
    },
    {
      "id": "8adee013-069c-486c-93d0-9361c778763b",
      "text": "High-profile visits and statements by Mejlis leaders to international bodies (OSCE/UN/US) — e.g., Mustafa Dzhemilev meetings in 2015"
    },
    {
      "id": "c9763a61-b691-4150-a4d6-286b290ccac9",
      "text": "Czech President Petr Pavel said in public interviews that Ukraine may need to be 'realistic' about the prospects of liberating all occupied territory and that some areas could remain under Russian control temporarily."
    },
    {
      "id": "c1c46137-389d-4bf3-a508-0df6760ca0ec",
      "text": "Joint Prague press conference (Pavel and Zelenskiy) and Reuters coverage where Pavel warned the West not to pressure Ukraine into immediate liberation of all territories and said Russia 'has all the cards' to end the war."
    },
    {
      "id": "61c505f4-7c2c-4e12-8853-97ed1f2b95db",
      "text": "Peer-reviewed meta-analysis reported that berberine (a plant alkaloid) showed glucose‑lowering effects in randomized trials, with some comparisons to metformin (systematic review and meta‑analysis, PubMed)."
    },
    {
      "id": "63d361ed-d80d-486b-96b3-587c68b4764e",
      "text": "U.S. FDA and FTC jointly sent warning letters to 10 companies for marketing dietary supplements with unlawful claims to prevent, treat or cure diabetes."
    },
    {
      "id": "0348d2b7-6176-40f0-8b89-d8fcabe47875",
      "text": "Japan finds stainless‑steel/foreign particles in multiple Moderna vaccine vials, triggering recalls/pauses"
    },
    {
      "id": "458962f4-39a7-49c7-93c4-ffe550b06aef",
      "text": "Historical FDA enforcement and public warnings against Hoxsey’s remedies (including 1956–1957 inspections and widely distributed FDA 'Beware' posters)."
    },
    {
      "id": "139b2601-d9aa-4412-b035-49159c4fc066",
      "text": "Ukrainian Cabinet of Ministers issued a permit allowing Biopharma Plasma to export 32 blood‑derived medicinal products (Cabinet resolution No.1005)."
    },
    {
      "id": "6db163de-95c0-49df-b814-1d89da588703",
      "text": "Publication of a large Danish national birth‑cohort study (Liew et al.) reporting an association between maternal acetaminophen use in pregnancy and autism spectrum disorder (ASD) with hyperkinetic symptoms."
    },
    {
      "id": "fa3b2a1f-10f3-41ec-9d6b-06b8a56e9f91",
      "text": "2014 J. Agric. Food Chem. study: quercetin and EGCG shown to have zinc ionophore activity in models"
    },
    {
      "id": "5bfd217e-b4e3-4698-a671-853a469c1a85",
      "text": "2014 PLoS ONE report: chloroquine acts as a zinc ionophore"
    },
    {
      "id": "262c9c9c-f3c5-44e4-a1d0-01947c0c5501",
      "text": "Mid‑2020 public promotion: clinicians/influencers (eg. Dr. Vladimir Zelenko) advocated hydroxychloroquine + zinc as a COVID‑19 treatment"
    },
    {
      "id": "076ebc36-d450-46a6-ba2b-2a82d07b55d3",
      "text": "October 2020 multicenter cohort (NYU) preprint: 'Zinc with an ionophore associated with reduced in‑hospital mortality'"
    },
    {
      "id": "c3488754-8e08-4402-b2a0-85331fff963b",
      "text": "2010 PLoS Pathogens paper: in vitro inhibition of coronavirus polymerase by Zn2+ and blockade of replication by zinc ionophores"
    },
    {
      "id": "24a451dc-483c-4c83-90ec-f9810c097d83",
      "text": "Hungary vetoed a joint NATO statement on Ukraine citing concerns about the rights of the ethnic Hungarian minority"
    },
    {
      "id": "ba89b7d5-0234-4982-ab98-56b648aa5a9d",
      "text": "Hungary’s simplified naturalisation (citizenship-by‑descent) program resulting in large numbers of passports issued to ethnic Hungarians in Transcarpathia/Zakarpattia"
    },
    {
      "id": "47c5cbc0-38ac-4145-83fc-adb129b8a28b",
      "text": "Hungarian Prime Minister Viktor Orbán publicly stated during the 2022 Russian invasion that the lives and security of Hungarians in Transcarpathia/Ukraine were a priority for his government"
    },
    {
      "id": "ecc9b611-102b-4b4b-b0a9-3ddf7f7a28fd",
      "text": "Media and human‑rights coverage documenting tensions and complaints by the Hungarian minority in Zakarpattia/Transcarpathia during 2017–2022 (language disputes, local political friction)"
    },
    {
      "id": "07778b1f-b8cd-449c-ae6c-5f704a14dccc",
      "text": "U.S. issues Emergency Use Authorization and rapid rollout of Pfizer‑BioNTech vaccine (December 2020)"
    },
    {
      "id": "e1827af4-5212-4e67-9651-9f7cb1021ab5",
      "text": "UK regulator (MHRA) issues guidance after two reports of anaphylaxis following the first Pfizer/BioNTech vaccinations"
    },
    {
      "id": "3d943bcc-f75f-4abc-9e2b-6abbbfa07af8",
      "text": "Pfizer/BioNTech EUA fact sheets and clinical publications note limited data in children and absence of long‑term safety data at authorization"
    },
    {
      "id": "a16a0af6-54e6-40ad-b4d6-0580573f8262",
      "text": "Mass stabbing at Westfield Bondi Junction created a chaotic breaking-news environment"
    },
    {
      "id": "ce9032db-2a19-40b8-af12-ec438a6ece7e",
      "text": "Major Iberian power blackout on 28 April 2025 that disrupted electricity across Spain and Portugal"
    },
    {
      "id": "9f1e0b10-f3b9-4110-a148-2ec0f8f50515",
      "text": "Nationwide Telefónica network update caused widespread mobile and emergency-service outages across Spain"
    },
    {
      "id": "f565afca-6eec-40ab-b60e-39070f028961",
      "text": "Czech Ministry of Foreign Affairs published an official statement saying the Crimea referendum was held in violation of the Ukrainian constitution, that the Czech Republic does not recognize the referendum results and continues to recognise Crimea as part of Ukraine."
    },
    {
      "id": "d3b19056-328f-47b8-b4af-f85f9656a684",
      "text": "Czech President Miloš Zeman publicly criticised Western sanctions and expressed skepticism about their effectiveness in interviews/statements in March 2014."
    },
    {
      "id": "452436c8-3d1b-40c3-8efa-d978e367bc75",
      "text": "Release of GLOBOCAN 2022 global cancer estimates showing large numbers of new cancer cases and highlighting female breast cancer as one of the most common cancers"
    },
    {
      "id": "a803e4bf-7243-49a0-af5f-2029ff92b91d",
      "text": "Publication of national cancer registration statistics for England (Cancer registrations 2022) showing higher numbers of cancers diagnosed in 2022 compared with 2021"
    },
    {
      "id": "405388de-0b9e-4980-b174-36e7f057144b",
      "text": "GRELL cooperative study (2013) and similar national registry analyses showing modest annual increases in breast cancer incidence among women under 40 in several European countries"
    },
    {
      "id": "5f074750-a6eb-4bc7-b8c2-bb71a36d7d7c",
      "text": "Publication of analyses and commentary about the impact of COVID‑19 on cancer services and screening (UK/NHS context) documenting diagnostic backlogs and subsequent rises in diagnoses when services resumed"
    },
    {
      "id": "2a6fc254-1269-458f-8a30-9f2f870a60e9",
      "text": "Prominent visibility of far‑right/ultranationalist groups (e.g., Right Sector) in Maidan protests"
    },
    {
      "id": "8adb6909-17d6-4caf-931f-a2874497a9d5",
      "text": "Seizures of regional government buildings and street clashes in eastern/southern Ukraine (Donetsk, Kharkiv) in early March 2014"
    },
    {
      "id": "d2457389-c3d9-47cc-a513-cab7d7fdc8ca",
      "text": "Widespread toppling/removal of Lenin statues across Ukraine (the 'Leninopad')"
    },
    {
      "id": "1e96ff68-3faf-4f64-9309-c3fd81619485",
      "text": "High local tensions and protests in Lviv during February 2014, with public gatherings and confrontations around symbolic sites"
    },
    {
      "id": "38ab785c-3e01-47bb-954c-90b12bfbbd95",
      "text": "Russian/state media narratives framing the Kyiv movement as 'fascists' and amplifying isolated incidents"
    },
    {
      "id": "cda74b8c-f8e1-43b3-97ea-f10b8662e7d7",
      "text": "President Trump publicly urged the FDA to 'fast-track' potential COVID-19 treatments, including hydroxychloroquine"
    },
    {
      "id": "15d565d3-fd46-4488-948e-1e1d2ec92989",
      "text": "ClinicalTrials.gov registrations for thalidomide trials in COVID-19 (e.g., NCT04273581)"
    },
    {
      "id": "33ac0e90-a934-4be1-8500-d703efc8fe1d",
      "text": "Moderna announces first participant dosed in NIH-led mRNA-1273 Phase 1 vaccine trial"
    },
    {
      "id": "53818edf-d20a-4280-b405-d6631088ec3c",
      "text": "OSCE Representative on Freedom of the Media condemns attacks and detentions of journalists in eastern Ukraine"
    },
    {
      "id": "15fa5012-49f2-4fe0-b2fc-c036c78dfe23",
      "text": "Two Russian state television journalists (Igor Kornelyuk and Anton Voloshin) killed by mortar fire near Luhansk"
    },
    {
      "id": "c71e0105-7c15-496e-9e5d-9ad87554a6d3",
      "text": "Italian photojournalist Andrea Rocchelli killed near Sloviansk while reporting on Donbas fighting"
    },
    {
      "id": "f594392c-a4dc-4c76-b795-28d998459538",
      "text": "Scientific literature demonstrating decades of 'edible vaccine' research (2019 review 'Edible Vaccines: Promises and Challenges')"
    },
    {
      "id": "cbb81680-9122-4150-9b14-5fde22755d97",
      "text": "U.S. House passes amendment to prohibit funding for 'transgenic edible vaccines' (Massie amendment)"
    },
    {
      "id": "21faff8f-7b2a-4bd9-aa48-b3fff46bdbf8",
      "text": "Health Canada approval of Medicago's plant‑based COVID-19 vaccine (COVIFENZ)"
    },
    {
      "id": "c4fc88e3-814b-4889-bff4-556056c4912b",
      "text": "2014 reports and analyses on prevention of smuggling of nuclear and radioactive materials at the Ukraine–Moldova border"
    },
    {
      "id": "bb138d5e-1bd0-43f8-8c6a-e0c9519dded0",
      "text": "2015 reporting on large volumes of spent nuclear fuel stored in exposed open-air yards at Zaporizhia NPP"
    },
    {
      "id": "e875ca96-e4d0-4af7-9a3d-1428f4ed7a9a",
      "text": "WHO interim guidance on mask use (published 5 June 2020) noted there was 'no direct evidence' from community studies on universal masking"
    },
    {
      "id": "d38c0d0d-a75e-4854-8acd-8ce2ba04c25a",
      "text": "Russia began issuing Russian passports to residents of occupied Donetsk and Luhansk (passportisation program, reported from 2019 onward)"
    },
    {
      "id": "5c86b624-3bf8-41c0-9ef3-0881445603c3",
      "text": "Pre‑war remittance and labour links between Ukraine and Russia documented in World Bank data (substantial remittance inflows historically)"
    },
    {
      "id": "8f904b01-783a-4203-a9f8-4d3a6e7a90f3",
      "text": "2001 Ukrainian census shows large Russian‑language population (≈29.6% reported Russian as mother tongue)"
    },
    {
      "id": "c1cdb795-eef3-4d83-b2cf-fc7b4f142e4a",
      "text": "Media reports (e.g., Reuters, 11 Jan 2023) relayed WHO and other experts saying XBB.1.5 may be driving recent case increases in some areas."
    },
    {
      "id": "38a40083-ba49-4c7e-b6a1-0d8ad9e16a68",
      "text": "Oxford/UK analyses and technical briefings in July–August 2021 documenting reduced vaccine effectiveness against symptomatic infection with Delta and reporting viral-load related findings."
    },
    {
      "id": "586c490e-494f-4e24-87a3-09fb08b48cf5",
      "text": "CDC MMWR report on the Provincetown (Barnstable County) outbreak showing many cases among fully vaccinated people and reporting similar viral loads in some vaccinated and unvaccinated cases."
    },
    {
      "id": "f8ad6006-14cd-42b8-9f41-ac32b1e2a1c8",
      "text": "Ongoing pattern of journalists killed or injured while reporting on the Russia–Ukraine war since 2022."
    },
    {
      "id": "38e9e7d0-ff0d-47f5-ab45-be36a362e697",
      "text": "Escalation of cross‑border fighting and reported Ukrainian incursions into Russia's Kursk region in early August 2024."
    },
    {
      "id": "33f06504-34f5-4ddc-9f7d-6977df239b00",
      "text": "Retraction of high-profile hydroxychloroquine research (Surgisphere-related Lancet study)"
    },
    {
      "id": "09f3b156-9142-4170-b82c-d6e48fd74216",
      "text": "U.S. Food and Drug Administration revoked the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID‑19"
    },
    {
      "id": "0547cf7c-f4fc-4f88-881e-f354799d394b",
      "text": "Publication of a 2015 review clarifying that peripheral (gut) serotonin and central (brain) serotonin are separate pools because serotonin itself cannot cross the blood–brain barrier."
    },
    {
      "id": "99388c57-039d-4450-a2ea-77d39164f936",
      "text": "Vatican note on the morality of using some COVID-19 vaccines (explicit discussion of fetal‑cell‑line origins)"
    },
    {
      "id": "de0877d2-e5b8-4dc0-abcb-4d999de7b03d",
      "text": "Public-facing CDC guidance page describing vaccine additives and manufacturing substances (e.g., formaldehyde, aluminum) made widely available"
    },
    {
      "id": "af8c4621-5743-4ab5-b75f-a10982b627f3",
      "text": "CDC / AAP precautionary move to remove/reduce thimerosal from childhood vaccines (timeline publicity)"
    },
    {
      "id": "e68ea319-a743-4063-8a6b-a57f7b693345",
      "text": "Detection of porcine circovirus DNA (PCV1) in the Rotarix rotavirus vaccine and global regulator review"
    },
    {
      "id": "d295f0d3-9153-4814-85db-70ed8ee95007",
      "text": "Assassination of Boris Nemtsov on a bridge near the Kremlin"
    },
    {
      "id": "e7ba6c83-fd4f-4845-861d-7416006c77a2",
      "text": "Vatican Congregation for the Doctrine of the Faith published a note stating it is morally acceptable to receive some COVID-19 vaccines developed using cell lines from aborted fetuses (approved by Pope Francis)."
    },
    {
      "id": "9fde4b91-1e88-4275-b6d7-a293610dfff4",
      "text": "CDC Pink Book Appendix B (Vaccine Excipient and Media Summary) lists cell lines such as WI-38 and MRC-5 in vaccine production context (table circulated online, edition info in use January 2021)."
    },
    {
      "id": "f4f24cf5-1439-45d8-8416-872bde8b9671",
      "text": "American Optometric Association consumer alert about at‑home/online vision tests and devices"
    },
    {
      "id": "820dbe4e-83e3-4ea1-af12-b4e14d598494",
      "text": "Russian proposals and measures to fast-track citizenship for Crimean residents"
    },
    {
      "id": "28bb7190-953a-4a8d-a25b-abfc2ded7b69",
      "text": "Pro-Russian separatists declare Donetsk 'People's Republic' after seizing regional building"
    },
    {
      "id": "67aeabae-2f28-4de2-9c18-746e97c6ff30",
      "text": "Putin's Kremlin speech endorsing Crimea accession"
    },
    {
      "id": "9d4cf030-6541-4767-9e93-bb36756e465d",
      "text": "Delta-variant surge and public messaging (summer 2021) urging vaccination ahead of difficult hurricane-season scenarios"
    },
    {
      "id": "2a085237-4836-4154-98f0-9f710d9832b1",
      "text": "Israel reports drop in observed vaccine effectiveness against infection (94% → ~64%) amid Delta"
    },
    {
      "id": "9e3e000c-4764-4206-bac6-bdcd3f0133d6",
      "text": "Great Barrington Declaration advocating 'focused protection' published"
    },
    {
      "id": "2f24c199-c87c-411b-be26-4f3f75b8cd6b",
      "text": "Systematic review estimating COVID-19 infection-fatality rate ~0.68%"
    },
    {
      "id": "2e9cc47a-173b-422c-b53b-2f26ae0482c1",
      "text": "Age‑stratified IFR analysis showing extremely low fatality risk for younger people"
    },
    {
      "id": "9ffd3bc2-8394-44e0-8da9-eec5d9fbaa87",
      "text": "Public availability of VAERS as a passive reporting system and official CDC/FDA guidance about its limitations"
    },
    {
      "id": "504c325b-a327-4bc7-9702-a9c23fc4826a",
      "text": "ACIP/CDC recommendation during the 2009 H1N1 pandemic that pregnant women receive H1N1 and seasonal influenza vaccines"
    },
    {
      "id": "0cd08bab-1c16-466b-9d97-d512cdb3e045",
      "text": "Publication of Goldman GS (2013) 'Comparison of VAERS fetal‑loss reports during three consecutive influenza seasons' (Human & Experimental Toxicology)"
    },
    {
      "id": "37fe491a-4683-4a84-92a8-9eb4d4f308c9",
      "text": "Reports and analyses in 2015 highlighted growing Hungarian activism in Zakarpattia (large numbers receiving Hungarian passports and political pressure over minority rights throughout 2015)."
    },
    {
      "id": "87740410-18dc-43f6-8b3a-dfb1e442eef4",
      "text": "Think‑tank analysis and regional commentaries described longstanding identity, linguistic and historical fault lines in Zakarpattia and proposals for a «Trans‑Tisa/Transcarpathian» administrative unit (OSW commentary, Sept 2015)."
    },
    {
      "id": "2dc81d64-1251-487b-8ebc-c1e96d5a010e",
      "text": "Armed clash (Mukachevo shootout) between Right Sector fighters and local security forces in Mukachevo, Zakarpattia, leaving several wounded (11 July 2015)."
    },
    {
      "id": "cc779605-8036-4dcd-adc3-6a7f8ced5971",
      "text": "Local reporting and human-rights outlets flagged that the ‘‘Transcarpathian Rus’’/Rusyn congress and statements by Petro (Pyotr) Getsko were likely provocations amplified by Moscow (coverage March 2015)."
    },
    {
      "id": "466b0be3-a108-433b-ad5b-8aab49d16b31",
      "text": "Scuttling of Ukrainian vessels in Donuzlav Bay (6 March 2014) to block naval exits"
    },
    {
      "id": "66e492cc-628c-4066-bfb2-29d02e77d639",
      "text": "Official/legal exhibits and scientific analyses documenting that the Sea of Azov and Kerch Strait routinely experience ice cover that can obstruct navigation (analysis covering up to 2017)"
    },
    {
      "id": "76c8703d-7904-486e-b008-51a836c2d852",
      "text": "Severe Black Sea freeze restricted navigation and stranded vessels in January 2017"
    },
    {
      "id": "96054146-c21a-4c87-97f2-9161af7b504a",
      "text": "Russian forces seized multiple Ukrainian naval vessels during the March 2014 Crimea operation"
    },
    {
      "id": "62235204-50c1-4ae0-bd7a-5bb86c3d0d34",
      "text": "U.S. Ninth Circuit Court of Appeals issued an opinion (June 7, 2024) vacating the district court's dismissal and allowing a lawsuit challenging LAUSD's COVID‑19 vaccine mandate to proceed; the opinion noted that, at the pleading stage, the court must accept plaintiffs' allegation that the vaccines do not prevent transmission."
    },
    {
      "id": "b76e1028-54ea-4e7a-97ff-dcae5e37ba19",
      "text": "The U.S. Centers for Disease Control and Prevention revised wording on its website for 'vaccine' and 'vaccination' in September 2021 (shorter/modernized wording replacing earlier phrasing about 'producing immunity')."
    },
    {
      "id": "87b0077e-0141-4590-8618-4d3583e7cd53",
      "text": "Local activist action in Chernihiv ('Feed the Communist') in May 2015 where activists distributed food kits and removed or replaced communist symbols."
    },
    {
      "id": "7b56002c-8c94-47bb-8e98-a0489250c31d",
      "text": "Publication and publicity of studies showing reduced antibody responses in clinically immunocompromised groups (OCTAVE/related studies reported in The BMJ)"
    },
    {
      "id": "ce112929-14cc-4e58-8382-26363d0b1a18",
      "text": "Stockholm arbitration tribunal ruled in favour of Naftogaz against Gazprom (final award and related rulings published 28 February 2018), ordering significant payments in Naftogaz's favor."
    },
    {
      "id": "c1ee117f-0c0f-494d-be3c-0eb8b31c1078",
      "text": "Publication of a 2015 Danish case series (Brinth et al.) reporting suspected postural tachycardia syndrome (POTS) and related autonomic symptoms following quadrivalent HPV vaccination."
    },
    {
      "id": "e5400c13-6955-4e7f-8ce1-97f02f2581c4",
      "text": "Danish Medicines Agency and European regulators reviewed reports from Denmark about suspected HPV vaccine adverse events and produced public assessments and data summaries."
    },
    {
      "id": "5d4bf37c-3e45-47b0-93d1-4452450157cb",
      "text": "2014 French case-control study published in Clinical Rheumatology examining possible associations between the quadrivalent HPV vaccine and new‑onset autoimmune disorders."
    },
    {
      "id": "2ea4834d-e0b7-48fe-978d-3db1b6cb1c5c",
      "text": "Ukraine’s security service (SBU) announced an investigation that alleged nearly $40 million was embezzled in a mortar‑shell procurement scheme"
    },
    {
      "id": "ca18db01-64ae-4f7b-af77-b58223dc999d",
      "text": "Pentagon Inspector General report found about $1 billion of U.S. weapons sent to Ukraine were not properly tracked"
    },
    {
      "id": "4cc69e6b-088b-456a-aa2c-66bb5cda35da",
      "text": "Widespread media reports documented an increase in Ukrainians (including some displaced by 2014 unrest) travelling to or taking up work in Russia to escape economic hardship and instability."
    },
    {
      "id": "e2ae750f-bd2f-4b8a-b113-685b1344db2c",
      "text": "Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers highlighting that recent warming is 'unequivocally' driven by human activities (strong attribution to greenhouse gas emissions)."
    },
    {
      "id": "74eece4e-027a-4fcd-a614-30c38e2df8db",
      "text": "Global Carbon Project press release and Global Carbon Budget 2021 reporting that global fossil CO2 emissions rebounded close to pre-COVID levels (published early November 2021)."
    },
    {
      "id": "a9042610-53a1-49f6-897c-4537a68bd04a",
      "text": "UNFCCC COP26 (Glasgow, Nov 2021) international climate summit and high-profile policy announcements on phasing down fossil fuels."
    },
    {
      "id": "24cb8c6a-0ca7-47cd-ab09-f8ccf313d3cd",
      "text": "The extraordinary Pacific Northwest heat wave in late June 2021 and rapid attribution studies published in the weeks after the event."
    },
    {
      "id": "338a6e3b-3418-4a7d-941b-ec10b497cb0a",
      "text": "Council of the EU adopted visa‑liberalisation regulation for Ukrainian citizens (moving Ukraine to visa‑free Annex II)."
    },
    {
      "id": "b9016207-12a5-47c8-abf0-886586d3945a",
      "text": "Major outlets explained how the visa‑free scheme would operate and its limits (e.g., that it allowed 90 days' travel within any 180‑day period and depended on biometric passports)."
    },
    {
      "id": "90b2621e-baa8-4075-aa10-ccae5c1cf0e6",
      "text": "Legal and normative context: Ukrainian prohibition on promotion/distribution of totalitarian symbols (noted in fact checks of similar claims)"
    },
    {
      "id": "bb22cdd2-06b4-4469-a87d-4c76ab4fe0fa",
      "text": "CDC guidance promoting widespread use of cloth face coverings and advising regular washing/maintenance"
    },
    {
      "id": "3e6db30e-ded5-4658-b27f-d0cef081d848",
      "text": "Dentistry and trade press reports warning about 'mask mouth' and increased oral health issues"
    },
    {
      "id": "8d853396-b772-4678-8b21-d54392993e09",
      "text": "Public demonstrations by scientists/microbiologists using petri-dish or droplet-capture experiments to show masks block droplets"
    },
    {
      "id": "94ec6777-664c-4b7d-9759-39c0d7a2bd4c",
      "text": "Industry and research reports (IEA-PVPS and others) documenting end-of-life management challenges and the need to scale PV recycling infrastructure."
    },
    {
      "id": "e747d535-762d-4e0b-a2ec-e3a175575171",
      "text": "Coordinated farmer and rural groups' campaigns and protests against 'mega' solar farms on productive farmland in the UK (national days of action and rallies organized by rural campaigners)."
    },
    {
      "id": "afe1ead5-1aed-474e-985a-3e97a9a02c20",
      "text": "Laboratory leaching studies showing that crushed or non-encapsulated cadmium‑telluride (CdTe) thin‑film solar cell material can release cadmium and tellurium under extreme test conditions."
    },
    {
      "id": "a2acefbd-c6a4-4b32-a8ff-3bfbb8c45adc",
      "text": "OSCE Special Monitoring Mission (SMM) recorded a marked increase in ceasefire violations in Donbas in early 2021 (multiple daily reports documenting dozens to hundreds of violations)."
    },
    {
      "id": "1b6d7754-0f5f-4684-a918-e2eec4807eaf",
      "text": "U.S. Department of State 'Ukraine 2020 Human Rights Report' (published March 2021) documented the activity and influence of volunteer/paramilitary and nationalist groups (e.g., units linked to political parties) active in eastern Ukraine and at the front line."
    },
    {
      "id": "dab780cc-2893-405e-9364-778210326efa",
      "text": "Verkhovna Rada (Ukrainian parliament) passed the 2018 'On the peculiarities of state policy to ensure Ukraine's state sovereignty over temporarily occupied territories of Donetsk and Luhansk regions' (the 'reintegration of Donbas' law) declaring parts of Donbas occupied and Russia an aggressor."
    },
    {
      "id": "b95529c5-7b9f-48fb-9a4c-37ab0a491330",
      "text": "President Zelenskyy's 2019 public handling of the Steinmeier Formula (acceptance/clarification) and the related domestic protests over concessions for the Donbas."
    },
    {
      "id": "45df0e47-67dc-407c-a742-cab16d53dbae",
      "text": "EU and US adopted rounds of sanctions against Russia following the 2014 annexation of Crimea and continued to maintain restrictive measures in subsequent years."
    },
    {
      "id": "e9bf8f60-c979-49e6-b95d-09ffc6f94217",
      "text": "Public reporting and analysis of contacts between Trump‑family advisers (including Ivanka/Kushner) and Russian figures during and after the 2016 campaign (coverage of the Mueller report, 2019)."
    },
    {
      "id": "b37f56c1-d8ec-44b6-9f51-71bedd748aad",
      "text": "Pro‑Russian activists stormed SBU (security service) offices in Donetsk and Luhansk and reportedly took weapons from armories."
    },
    {
      "id": "19b39938-7518-435d-8045-b77bcd17e92f",
      "text": "Ukraine's defence ministry publicly acknowledged that a number of its vehicles/equipment had been seized by pro‑Russian forces."
    },
    {
      "id": "764a63e8-70c4-44e2-8685-71474c046ffa",
      "text": "State-level policy changes in 2022 loosening access to ivermectin (pharmacist dispensing/OTC measures in several U.S. states)"
    },
    {
      "id": "dec1b8d9-e6fd-4204-91b9-5acb9e4a20d3",
      "text": "Apter v. Department of Health & Human Services — Fifth Circuit opinion allowing doctors' claims against FDA to proceed and criticizing agency messaging"
    },
    {
      "id": "5f07a8e7-1b2d-4df5-b547-53edbec94853",
      "text": "President Poroshenko signed the 2015 'de-communization' laws (May 2015) that, among other provisions, publicly recognized fighters of the OUN‑UPA (associated historically with Stepan Bandera)."
    },
    {
      "id": "8fb7f94c-b42a-487d-a2bf-e75d6472fdff",
      "text": "Russian state media had for months portrayed Ukraine’s post‑Euromaidan authorities as 'Bandera' nationalists and used the term 'Bandera junta' in reports (widespread from 2014 onward)."
    },
    {
      "id": "8c93f48f-cd97-41d7-8071-bf33f5ef5a27",
      "text": "The new law altered expiry/labeling requirements (e.g., month/year vs day/month) and set a delayed entry-into-force date"
    },
    {
      "id": "287eeae0-30ac-4391-8e0b-a92604678a04",
      "text": "Verkhovna Rada (Ukraine's Parliament) adopted Bill No. 8450 \"On Information for Consumers of Food Products\""
    },
    {
      "id": "8c58258a-054c-4c2e-a256-0c03f926b4e2",
      "text": "2012 research proposing a quantitative 'tongue deviation angle' threshold as a possible early warning sign of stroke (Wei et al., August 2012)."
    },
    {
      "id": "2a64b747-3eff-40c8-9171-4394af0a45e0",
      "text": "Launch of the UK 'Act F.A.S.T.' national stroke-awareness campaign emphasizing Face/Arm/Speech/Time (first rolled out February 2009)."
    },
    {
      "id": "4b7c9126-7687-453a-94c5-617255028897",
      "text": "European Commission public warnings about Ukraine’s unfinished anti‑corruption and reform agenda"
    },
    {
      "id": "da7fa7b1-a74a-439e-85d2-687919f7c128",
      "text": "EU–Ukraine DCFTA implementation raised in trilateral talks with Russia amid practical concerns"
    },
    {
      "id": "c280d2d1-4e95-48f6-911d-93b54fe8369e",
      "text": "2013 Ukrainian government suspended signing of the Association Agreement (Vilnius), fuelling narratives of failure"
    },
    {
      "id": "8064bfc2-7024-4f06-9497-986a1e975c0f",
      "text": "CDC MMWR report on the Barnstable County, MA outbreak showing many 'breakthrough' infections among fully vaccinated people (July 2021)"
    },
    {
      "id": "09c142a4-5c80-4531-a037-d8568610ded5",
      "text": "Health Canada advisory and recall/alert over face masks containing graphene (public advisory that graphene in masks may present inhalation risks)."
    },
    {
      "id": "f78c939e-82d0-4c4f-a838-fd1250ba7971",
      "text": "Published transmission‑electron microscopy (TEM) and SEM images of graphene oxide in the scientific literature (e.g., ACS Nano structural analysis of graphene oxide)."
    },
    {
      "id": "36cf21d5-796f-4744-9cc1-a42f82021e3d",
      "text": "OSCE report documenting repeated interruptions to water access in Donetsk and Luhansk due to hostilities and infrastructure damage"
    },
    {
      "id": "ca063694-43d3-4dc1-a538-2895b55cceec",
      "text": "Shelling damaged the Donetsk filtration plant, leaving much of Donetsk without running water"
    },
    {
      "id": "a57107be-6e07-4363-94d1-0ebcadc66c0c",
      "text": "China’s temporary nationwide ban on trade and consumption of wild animals announced amid the outbreak"
    },
    {
      "id": "496fb930-7235-4aa3-b62e-868b8ab98f1a",
      "text": "Public‑health assessments linking many early cases to Wuhan’s Huanan Seafood Wholesale Market"
    },
    {
      "id": "4f52da85-e4c1-4efd-9478-eb694741c62d",
      "text": "Poland publicly resisted EU migrant relocation quotas and signalled tighter migration controls (Nov 2015)"
    },
    {
      "id": "5cca2f98-a550-4a3e-9542-da2e648b992d",
      "text": "Poland and Ukraine temporarily closed or restricted certain crossings amid transport disputes (reports of Russian lorries stuck)"
    },
    {
      "id": "71749530-08cc-490b-b851-4665970d6156",
      "text": "Europol and Polish Border Guard dismantled an international people-smuggling network (September 2016)"
    },
    {
      "id": "97914efc-b72a-45e9-ba29-907d16d037db",
      "text": "Passage of post‑Euromaidan lustration (vetting) laws and criticism from rights groups"
    },
    {
      "id": "47427ce7-8514-42d1-9bea-9650fac07e2d",
      "text": "Security Service of Ukraine (SBU) searches, surveillance and raids on media outlets and journalists (reported 2018–2019)"
    },
    {
      "id": "5ee94827-5ae5-42fa-bb8f-1a2178f4e6a2",
      "text": "Kerch Strait incident and temporary imposition of martial‑law measures after the November 2018 naval clash"
    },
    {
      "id": "188d2a63-2cd4-4b15-b11b-b29437874cc5",
      "text": "Government blocking of major Russian social networks and internet services under sanctions"
    },
    {
      "id": "9d0656e1-91a7-4568-a8c6-6145a17c6c4e",
      "text": "OSCE SMM spot report (22 January 2015) documents shelling incidents impacting civilian infrastructure, including water facilities, in Donetsk"
    },
    {
      "id": "e4d29b02-ebaf-4515-8642-499825b90c32",
      "text": "UN/UNICEF appeal (July 2015) calling for help to restore damaged water facilities in Donetsk and Luhansk"
    },
    {
      "id": "ed283ab5-9f4a-4aa8-b6ef-9d773773c737",
      "text": "NCHS publishes final report 'Mortality in the United States, 2019' (finalized 2019 death counts and age‑adjusted death rates)"
    },
    {
      "id": "bcde2733-2496-48bf-8dc7-e7b39c4fde0b",
      "text": "Unusually low seasonal influenza activity and deaths during 2020 (CDC FluView reports for 2019–2020 and 2020–2021 showing steep decline)"
    },
    {
      "id": "e9fe3473-b79a-428a-b152-938869ca5bce",
      "text": "UN Mine Action Service (UNMAS) 2019 reporting and annual material describing extensive contamination by mines/ERW in Ukraine and the long-term nature of clearance"
    },
    {
      "id": "a2b525c1-f547-4226-9fd2-d90a827de375",
      "text": "Media reporting on international NGOs (HALO Trust) conducting humanitarian demining in Donbas and expanding operations in 2019"
    },
    {
      "id": "08f06c6d-d2b7-4425-a7e5-ec96e91f0466",
      "text": "Peer‑reviewed and preprint research discussing biochemical/sequence similarities between portions of the SARS‑CoV‑2 spike protein and snake neurotoxins (studies and tests of the \"nicotinic\" hypothesis)"
    },
    {
      "id": "e8aa4390-6332-4929-b285-0ce0d69d2812",
      "text": "Norwegian health authorities reported deaths among very frail, elderly people shortly after receiving the Pfizer–BioNTech COVID-19 vaccine and opened reviews (reports in mid‑January 2021 said 23 deaths were reported and some were judged possibly linked to vaccine side effects in very frail patients)."
    },
    {
      "id": "1a11be3a-b17d-4777-a790-4e41fa0143cf",
      "text": "Reports and a CDC MMWR analysis documented cases of allergic reactions and anaphylaxis after initial Pfizer–BioNTech vaccine doses in December 2020 (MMWR published January 2021 summarizing early anaphylaxis reports)."
    },
    {
      "id": "098c1a39-fa6a-4fc1-bcc0-0f833a274e1e",
      "text": "Public release and wide circulation of raw VAERS (Vaccine Adverse Event Reporting System) reports documenting deaths reported after COVID‑19 vaccination in late 2020 and early 2021."
    },
    {
      "id": "350a513d-eaad-4ca4-bac2-fd018fe7b558",
      "text": "UNODC report and national statistics showing Ukraine as a significant transit country and location of large heroin seizures in Europe"
    },
    {
      "id": "c089cd94-21ba-4043-9f02-b312ba442b1b",
      "text": "Europol / Eurojust-linked investigations and cross‑border law‑enforcement operations that identified networks using Ukrainian territory/ports to move cocaine and other drugs into the EU"
    },
    {
      "id": "e2bd56d7-c3a9-4fc6-a07b-4c44e736665f",
      "text": "FTC and FDA joint warning letters and public enforcement actions targeting companies that market dietary supplements with unproven Alzheimer's or dementia treatment/prevention claims (e.g., joint letters and advisories in 2019)."
    },
    {
      "id": "0ec34392-7927-416a-97ed-ede221ecb2c4",
      "text": "18-month randomized, double-blind, placebo‑controlled trial of a bioavailable curcumin formulation (Theracurmin) reporting memory and PET biomarker improvements in non-demented adults (Small et al.)."
    },
    {
      "id": "cae69692-e77c-4bd9-983f-d7e0a368a1c3",
      "text": "Small randomized, double-blind, placebo-controlled trial (Mori et al.) reporting improved cognitive scores in mild cognitive impairment after Hericium erinaceus (lion's mane) supplementation."
    },
    {
      "id": "556c65b9-2e06-41a6-b9d3-5ced8e2b68a2",
      "text": "Prospective cohort studies (e.g., Ohsaki cohort and related epidemiologic research) reporting associations between higher green tea consumption and lower risk of cognitive decline / incident dementia or functional disability."
    },
    {
      "id": "b3bcd9d2-ee33-4858-b64d-275faa36fa1a",
      "text": "CBOS national poll showing sharp fall in Polish support for accepting Ukrainian refugees (April 2023)"
    },
    {
      "id": "8cd731d8-8d53-4a4d-a07f-c15214766715",
      "text": "EDMO/Fact‑checking reports documenting early disinformation narratives about Ukrainian refugees in Poland (April 2022)"
    },
    {
      "id": "f8527199-6830-4e21-a052-7f5c6b8ecf3b",
      "text": "Political rhetoric and electoral pressure around Ukraine support (Reuters report, 19 Sep 2023)"
    },
    {
      "id": "1005cfdd-f328-4004-887b-6052f4bfa6da",
      "text": "Abbott/Similac powdered infant formula recalls and linked Cronobacter infections reported February 2022 (product recalls and infant illnesses/deaths)."
    },
    {
      "id": "a1d85e0f-f4ca-43fe-8c73-3b7382a9f07b",
      "text": "Conviction of neonatal nurse Lucy Letby for murdering and attempting to murder infants (trial verdict reported August 2023)."
    },
    {
      "id": "8bbd3f20-f76e-47c4-a33b-75e14299d88c",
      "text": "Reports in 2023 about a US clinician case involving allegations of destroying government COVID vaccine doses and administering saline (case reporting and later procedural developments in 2023)."
    },
    {
      "id": "b62e467a-7383-423e-b2db-36022673bd12",
      "text": "Local Marseille municipal councillor Gerald‑Hubert Fayard publicly associated himself with a planned DPR 'representation' (reported in regional and Ukraine‑focused outlets)."
    },
    {
      "id": "3892000c-47aa-4755-8d1c-d759dcfcf658",
      "text": "Thimerosal (ethylmercury) removal efforts and public controversy (ACIP/FDA actions beginning 1999; IOM review 2004)"
    },
    {
      "id": "2c900a2a-cb87-43f3-8e60-e63de79f3846",
      "text": "EMA guidance describes use of porcine trypsin (an enzyme) in manufacture of some vaccines"
    },
    {
      "id": "fe4407e1-2c58-4a48-aac8-8738ca900cd7",
      "text": "IARC classifies formaldehyde as carcinogenic to humans"
    },
    {
      "id": "20fff54e-3944-4c7f-b960-6c30b9553484",
      "text": "Immunization Safety Review and public concern over SV40 contamination of polio vaccine (1955–1963) and subsequent reviews"
    },
    {
      "id": "22ec386d-2816-4822-8a28-ff0303dbb36e",
      "text": "CDC MMWR report: 'Delay or Avoidance of Medical Care Because of COVID‑19–Related Concerns — United States, June 2020'"
    },
    {
      "id": "ba0406c0-1eb5-47f0-8568-1e8cc3246f72",
      "text": "CMS guidance: 'CMS Releases Recommendations on Adult Elective Surgeries, Non‑Essential Medical, Surgical, and Dental Procedures' (recommendation to postpone elective care)"
    },
    {
      "id": "4064599a-92e3-4d1a-861d-e5dcc4543c95",
      "text": "European and Global Drought Observatories annual progress/ data release (JRC/EDO-GDO report covering 2021)"
    },
    {
      "id": "71b4d6aa-c10b-42c5-a855-7e4f76bf6279",
      "text": "Release of IPCC Sixth Assessment Report (AR6) Working Group II Summary for Policymakers"
    },
    {
      "id": "eff487a7-144b-43ed-9bf7-a81b8eb300b4",
      "text": "Ukrainian President Petro Poroshenko warned of 'hundreds of foreign tanks' in Ukraine"
    },
    {
      "id": "862e5564-7ed4-4431-bc87-301f42a6f9ff",
      "text": "Large military parades and visible tank movements in neighbouring countries (e.g., Poland's Armed Forces Day parade showing tanks on public roads)"
    },
    {
      "id": "babb07ce-6461-4c01-8c46-35291a233a46",
      "text": "Reports that Russian tanks and armoured columns had crossed from Russia into Ukraine"
    },
    {
      "id": "cb7d24fb-92ea-453e-a2e7-23ee01a5bf14",
      "text": "Pentagon websites underwent a major content purge and reorganization earlier in 2025 (reported March 19, 2025), producing visible changes and confusion on DoD web properties"
    },
    {
      "id": "6505bf7e-a28b-4f90-81af-8e8806402064",
      "text": "Japan suspended use/recall of some Moderna vaccine batches after reports of foreign particles (contamination) in vials"
    },
    {
      "id": "746c62c4-228a-4f2e-a8a3-2d7a29e70163",
      "text": "FDA and CDC safety communications acknowledging rare myocarditis/pericarditis risk after mRNA COVID-19 vaccination"
    },
    {
      "id": "3bceb9ed-308a-4d20-9e15-e43ed722a41a",
      "text": "Florida Department of Health issues guidance/analysis claiming an 84% increase in the relative incidence of cardiac-related death among males 18–39 within 28 days of mRNA vaccination"
    },
    {
      "id": "efc25508-34ea-4b2d-b056-e09159f5e65e",
      "text": "Public criticisms and sparring by U.S. officials (including Vice President comments accusing Zelensky of being ungrateful) after the Oval Office exchange."
    },
    {
      "id": "8beb0182-4a6d-4773-bace-6843617f1729",
      "text": "Human Rights Watch report 'Unguided Rockets Killing Civilians' documented use of Grad (MLRS) rockets in Donetsk in July 2014."
    },
    {
      "id": "9a99a603-b48a-42f6-a5cd-97faca06e3f1",
      "text": "Simferopol base shooting — Ukrainian serviceman reportedly shot dead during Crimea takeover"
    },
    {
      "id": "c1d329c8-b5d6-4cc7-a6da-b13d361d2b9e",
      "text": "Euromaidan 'snipers' massacre and government/official statements about 'shooting to kill' (Kyiv)"
    },
    {
      "id": "86a0d544-0af2-48a1-8dc5-6ce0fff5551a",
      "text": "Killing of nationalist figure Oleksandr 'Sashko Bilyi' Muzychko during police operation (Rivne)"
    },
    {
      "id": "34aecffc-bfee-4e91-b571-37c65138c110",
      "text": "Acting Interior Minister Avakov implicates members of elite police units in Maidan shootings"
    },
    {
      "id": "913af525-e568-4c5b-8ce4-89da8089677f",
      "text": "Battle of Ilovaisk and the lethal 'green corridor' ambush during Ukrainian retreat"
    },
    {
      "id": "9600bcc7-d0ab-41ed-9a55-cff1567158c4",
      "text": "2020 research coverage: injectable hydrogels proposed as sustained‑release vaccine delivery platforms"
    },
    {
      "id": "e19958bb-c864-47ff-b697-31925e6f45d2",
      "text": "2019 review article: 'Hydrogel bioelectronics' (conductive/ionically conductive hydrogels for interfacing biology and electronics)"
    },
    {
      "id": "034cc14d-278d-40c6-a14b-c9f85da480a8",
      "text": "Licensure and use of squalene-containing adjuvant MF59 in licensed influenza vaccines (first licensed in Italy)"
    },
    {
      "id": "b7c9a674-5222-4e76-8357-23419815bd79",
      "text": "US Congressional hearings and report scrutinizing the Department of Defense Anthrax Vaccine Immunization Program"
    },
    {
      "id": "1a9cafe7-86d1-494b-902c-873da5aaca74",
      "text": "Publication and media coverage of research finding antibodies to squalene in Gulf War veterans"
    },
    {
      "id": "5766004f-5539-4fec-8594-aff527a3c6f4",
      "text": "1990s allegations that tetanus vaccination campaigns (Philippines, Mexico, Nicaragua) involved conjugation with hCG causing sterilization"
    },
    {
      "id": "aa4cef80-f44b-4276-b5a2-2b391127382e",
      "text": "Wuhan city lockdown and rapid travel restrictions were imposed as cases spread (city lockdown announced 23 January 2020) amid reports of limited early transparency"
    },
    {
      "id": "e20f2626-174f-48f4-bc51-5f4f6c668dfc",
      "text": "U.S. State Department fact sheet and public reporting describing activities and international collaborations at the Wuhan Institute of Virology"
    },
    {
      "id": "aed3a285-b1bb-472d-8c99-be38917e4ee1",
      "text": "Published, peer‑reviewed and public research showing Wuhan scientists (including Shi Zhengli) studying SARS‑like bat coronaviruses and collecting bat samples"
    },
    {
      "id": "dc6d7b6a-8093-4315-aa36-84690a1ab200",
      "text": "Ukrainian parliament voted to remove Yanukovych (328-0)"
    },
    {
      "id": "c545c24e-620e-4274-bb42-f77c2c191bba",
      "text": "U.S. FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine on March 28, 2020."
    },
    {
      "id": "8e8c4b4f-9c03-46d7-8214-d6ddcd586c7f",
      "text": "Publication of an early open‑label, non‑randomized trial from Marseille (Gautret et al.) reporting viral clearance with hydroxychloroquine ± azithromycin."
    },
    {
      "id": "cee5220d-75e6-40f4-8c6e-3dc54f0cc12a",
      "text": "Reporting from liberated towns (e.g., Trostianets) documenting looting and pillage by occupying Russian forces, published in major outlets in early April 2022."
    },
    {
      "id": "12c8d553-539d-44a4-916a-2115adb302e3",
      "text": "Scandinavian booster policy narrowing in 2022 (Denmark recommended boosters primarily for those 50+; Norway targeted boosters to older/risk groups)"
    },
    {
      "id": "4dba2a71-3b72-4530-b7d1-3035aab05e0a",
      "text": "NEJM analysis using Israeli Ministry of Health data showing protection and waning patterns of natural, vaccine-induced and hybrid immunity"
    },
    {
      "id": "4e9714da-d06e-47a1-a14e-0febb6ad3390",
      "text": "Publication of a quantified-method study suggesting tongue deviation angle >3.2° may predict stroke (Biomed Eng Online)."
    },
    {
      "id": "07570ec8-fe9e-44ab-a378-535f60a98aa8",
      "text": "Public Health England / NHS Act FAST stroke public awareness campaigns emphasising Face, Arms, Speech, Time (FAST) without mentioning tongue."
    },
    {
      "id": "340b926b-ada8-4988-88a9-06af47219f36",
      "text": "UKHSA (UK Health Security Agency) vaccine surveillance reports documenting low or rapidly waning effectiveness against Omicron infection at some timepoints in 2022"
    },
    {
      "id": "d2f49b39-a8ba-4bf0-a777-027f04ee78e2",
      "text": "U.S. Energy Information Administration (EIA) published accessible guidance and emissions-coefficient data explaining that burning natural gas produces less CO2 per unit of energy than burning coal."
    },
    {
      "id": "61bd6e7e-caf9-4c9f-badc-e923a4398824",
      "text": "European Commission proposal and subsequent approval to allow some natural gas projects to be labelled as 'transitional' / investable under the EU Taxonomy, followed by high-profile legal challenges and media coverage."
    },
    {
      "id": "e680d741-d0d2-417c-a836-e077af2c5147",
      "text": "Clean Creatives published its F‑List 2024 report documenting over 1,000 recent advertising and PR contracts between major agencies and fossil fuel companies (including gas companies)."
    },
    {
      "id": "fdc6b92f-6215-4eca-b466-b494c9508aaa",
      "text": "ClientEarth and partners announced they were joining legal action against Washington Gas over customer-facing marketing that described gas as 'clean' and 'sustainable'."
    },
    {
      "id": "692464af-4268-4b2b-a4e8-89ceb16c5307",
      "text": "OSCE convoy came under fire near Mariinka (monitors shot at while travelling between Ukrainian checkpoints)"
    },
    {
      "id": "f4fc46ca-6b73-4af0-94c4-688c0051de69",
      "text": "OSCE observers blocked from full access to the MH17 crash site by armed pro‑Russian fighters"
    },
    {
      "id": "2fe63ed3-3ec1-4910-b184-b5af8e1eb5c1",
      "text": "OSCE national staff detained by separatist forces in eastern Ukraine (several detained in April 2014)"
    },
    {
      "id": "da14c251-f3e4-496c-aacf-4d16d5c0420b",
      "text": "Four OSCE armoured vehicles torched in Donetsk (apparent arson)"
    },
    {
      "id": "d4af23d7-6dbe-4a13-92ea-f8860568b19c",
      "text": "U.S. Department of Defense announced $250 million in additional security assistance for Ukraine"
    },
    {
      "id": "01cbf676-2b81-4b2a-825d-68b1a2870483",
      "text": "Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained sailors"
    },
    {
      "id": "82baefd0-b223-41d2-a271-b477a89ee344",
      "text": "United States confirmed delivery of Javelin anti-tank missile systems to Ukraine"
    },
    {
      "id": "7b26b50c-4dd1-4644-9689-84dd0433369d",
      "text": "Sea Breeze 2019 multinational naval exercise (co-hosted by the US and Ukraine) concluded in Odesa"
    },
    {
      "id": "f9d77bc7-f0c8-4518-9725-14cf3100fc4d",
      "text": "USS Ross (Arleigh Burke-class destroyer) entered the Black Sea (routine US Navy presence) in April 2019"
    },
    {
      "id": "5d30f3af-649e-4a09-9a10-e989577c7ade",
      "text": "Official counts and reporting on refugees arriving in France showed large aggregate flow (roughly 30,000 reported late March 2022) but initial public summaries lacked detailed nationality/ethnicity breakdowns"
    },
    {
      "id": "5fee4a2d-aff8-4df9-be77-17e0c65b5b63",
      "text": "Reports and media on opening Arctic sea routes and economic opportunities from reduced sea ice (UK Foresight/academic analyses, mid-2010s)"
    },
    {
      "id": "86eb9930-5dc6-40af-b50a-ba48949c7f89",
      "text": "UNDP published 'Enhancing Mine Action Finance in Ukraine' (feasibility study) highlighting very large costs for demining and explosive ordnance disposal (EOD) in Ukraine"
    },
    {
      "id": "0754569f-7dde-4001-b445-2b9905332dae",
      "text": "U.S. Government Accountability Office (GAO) report 'Ukraine: Status and Challenges of DOD Weapon Replacement Efforts' documented replacement costs and tracking challenges for U.S. weapons provided to Ukraine"
    },
    {
      "id": "6ff36566-6826-4d97-b606-43ba3e46ea05",
      "text": "World Bank released an updated Ukraine recovery and reconstruction needs assessment estimating hundreds of billions in reconstruction costs and prompting public debate over who will pay"
    },
    {
      "id": "f3807869-b8a5-43c8-97e0-aefd9201fe00",
      "text": "Large influx of Ukrainian refugees into Italy by mid‑2022 (UNHCR reporting tens of thousands in June 2022)."
    },
    {
      "id": "093fa1c5-1ce1-4a27-8af8-eca7b7f8cbf7",
      "text": "Extinction Rebellion activists blocked Rome’s Grande Raccordo Anulare, leading to drivers physically removing protesters."
    },
    {
      "id": "ca1da258-49e6-4a70-aeb5-e78a1b90c123",
      "text": "Rospotrebnadzor and Russian authorities banned imports of Ukrainian confectionery (including Roshen) and imposed trade restrictions in 2013–2014."
    },
    {
      "id": "ec5286c0-072f-45c5-a076-4567fa7a532a",
      "text": "April 2015: Russian authorities seized or froze assets related to the Lipetsk Roshen factory and reported legal/administrative actions against the plant."
    },
    {
      "id": "4f2cdb73-7039-40b5-a2f7-b262f95f8559",
      "text": "Fatal shooting of conservative activist Charlie Kirk at Utah Valley University"
    },
    {
      "id": "ae65d107-6eb7-4313-9186-f3cbb1789d11",
      "text": "Publication of Kausar H. et al., 'Cucurbitacin B potently suppresses non-small-cell lung cancer growth' (Cancer Letters)"
    },
    {
      "id": "91ccb453-5fb0-4cb4-bf34-baf2b1b34bf3",
      "text": "Pre-war and tourist-focused references showing some Ukrainian cemeteries charge small admission or camera fees (example: Lychakiv Cemetery visitor fees noted in travel guides/reviews in 2019)"
    },
    {
      "id": "d652b088-92b8-43ab-9e9b-a599a32f964a",
      "text": "Drohobych municipal regulation (pre-2022) introducing paid vehicle access for cemetery maintenance, cited by local officials when responding to the viral clip"
    },
    {
      "id": "528448a9-71b6-490f-bae3-1cfa996191c8",
      "text": "WHO issues 'Tetanus vaccines: WHO position paper' summarising tetanus epidemiology and prevention"
    },
    {
      "id": "2fc47767-208d-4cf4-832f-59fb3b8e97d7",
      "text": "Peer‑reviewed medical review 'Tetanus' (Farrar et al.) describes Clostridium tetani as an obligate anaerobic, spore‑forming bacterium and details anaerobic germination in wounds"
    },
    {
      "id": "5068d9e5-ee6b-4935-b62c-464f72b9018d",
      "text": "The Tesla Science Center crowdfunded and purchased the Wardenclyffe lab site to create a museum and drew renewed attention to Tesla's archival material."
    },
    {
      "id": "7bd320e5-c8a0-4493-b871-050f0d769f51",
      "text": "News reporting that the historic Wardenclyffe site was damaged/at risk after a major fire and related incidents."
    },
    {
      "id": "4e8f6b10-a2ac-44db-a4ca-fcdc8bd5de91",
      "text": "U.S. Vaccine Court (Omnibus Autism Proceedings) issued final test-case rulings (March 10, 2010) finding insufficient evidence that vaccines cause autism"
    },
    {
      "id": "cef362d2-7e39-43ef-9824-cb10d85638c1",
      "text": "U.S. CDC and FDA temporarily pause and later resume use of the Johnson & Johnson COVID‑19 vaccine over rare blood clot reports"
    },
    {
      "id": "36dff2e7-9a23-442e-a3a7-16e2201e782b",
      "text": "Public health agencies report rare myocarditis cases after mRNA COVID‑19 vaccination and discuss benefits vs. risks"
    },
    {
      "id": "94535f85-af39-49e1-8579-790d85f2072c",
      "text": "Russian Defence Ministry repeatedly publicly stated it was striking Ukraine’s “military‑industrial complex” and energy infrastructure (examples across 2022–2024 reporting by major outlets)."
    },
    {
      "id": "53b4f370-ab1d-47ff-aa92-c4be63e52fc3",
      "text": "Multiple Russian missile and aerial strikes on Chernihiv during March 2022, causing civilian casualties and damage across the city."
    },
    {
      "id": "8dd16a15-63da-4b55-ae8b-3840364bfdeb",
      "text": "European Broadcasting Union (EBU) announces Kyiv as host city for Eurovision 2017"
    },
    {
      "id": "e6f80efe-99ad-40fc-9b5e-7b0f5d024763",
      "text": "Jamala (Ukraine) wins the Eurovision Song Contest with the song '1944'"
    },
    {
      "id": "0dbcac4d-824a-48f8-8554-df0bd03f3ca6",
      "text": "Ukraine publicly sought large anthracite imports (including from South Africa) amid shortages in late 2015"
    },
    {
      "id": "b1fcfdf2-64b0-43ec-b1ba-68b56b3335db",
      "text": "Sharp drop in Ukrainian coal production after Donbas fighting in 2014"
    },
    {
      "id": "73df9d94-7df5-47d9-85fc-37c3a2162b6b",
      "text": "Closure, flooding and damage to many Donbas mines after occupation in 2014"
    },
    {
      "id": "b9a38b44-ac73-4f47-83a9-657082aae0a0",
      "text": "Publication of the NEURO-COVAX study in Vaccines (MDPI) reporting 31.2% of participants self-reported at least one neurological symptom after COVID-19 vaccination."
    },
    {
      "id": "91f8878d-9aaa-4359-94f3-12b9a5498f11",
      "text": "Study design and limitations (self‑reported questionnaire, single‑center sampling, no unvaccinated comparator, and no hospitalizations/deaths recorded) were present in the paper but largely omitted in shareable summaries."
    },
    {
      "id": "159dcdc5-f266-45cf-a278-23a9f95d31a7",
      "text": "KIIS telephone poll (May 13–18, 2022) reporting very high levels of negative attitudes toward Russia (e.g., ~82% negative among people in occupied areas)"
    },
    {
      "id": "4effbcdb-9e1c-41c1-a3f1-2b6024fcf64e",
      "text": "Russian forces seized/controlled substantial parts of Kharkiv oblast in the initial invasion (late Feb–early March 2022), including border towns and districts"
    },
    {
      "id": "ff2a10da-8e67-47af-b406-5835519d3357",
      "text": "State-level policy changes removing mask mandates (example: Texas lifting its statewide mask mandate and reopening, March 2, 2021)"
    },
    {
      "id": "f12a6b76-a059-4df6-ac6e-ae2b26ccc9e6",
      "text": "CDC guidance updating mask recommendations for fully vaccinated people (May 13, 2021)"
    },
    {
      "id": "540e3ead-5b5a-466f-ba8a-dcbaf8fdd5fc",
      "text": "Turkish President Recep Tayyip Erdogan offered financial assistance to Ukraine and publicly urged protection for Crimean Tatars, reiterating Ankara's support for the Tatar community."
    },
    {
      "id": "db3aa80f-6044-4a98-bad7-82c93249331c",
      "text": "Turkey launched Operation Euphrates Shield and backed Syrian rebel groups in northern Syria (including 2016 operations such as the capture of Jarablus)."
    },
    {
      "id": "cd930d5e-8e35-4acf-bfc9-8cc6042ef7d1",
      "text": "Repeated international reports and accusations that Turkey had allowed foreign fighters to cross its border into Syria during the civil war."
    },
    {
      "id": "dbff6aa5-b76f-470d-8bb3-87dc3497b774",
      "text": "Crimean Tatar World Congress held in Ankara where leaders and diaspora groups met and called for international support against Russia's annexation."
    },
    {
      "id": "92519052-196e-4492-808b-4c95581ebc32",
      "text": "U.S. and Western sanctions were imposed on the Night Wolves and their leader (December 2014), marking the group as pro‑Kremlin and controversial in Western diplomatic reporting."
    },
    {
      "id": "13e91f18-b948-4979-90a2-5cefc638595b",
      "text": "Earlier influential scientific framing of an Amazon 'tipping point' (Lovejoy & Nobre / Science Advances) estimating thresholds (often cited ~40% deforestation) for large‑scale dieback to savanna."
    },
    {
      "id": "a71ac078-651a-47fb-bbf7-bfd8e459584c",
      "text": "UN experts warn of chemical disaster and water‑safety risks after shelling near installations containing chlorine and other chemicals in Donetsk region"
    },
    {
      "id": "bd5cb87a-089b-4f5c-91da-e5d1d1eca347",
      "text": "OSCE thematic report: 'Access to water in conflict‑affected areas of Donetsk and Luhansk'"
    },
    {
      "id": "8225f2b8-fa81-4508-9347-72e066b4edf5",
      "text": "ICRC: 'More than 350,000 people face acute water shortage in eastern Ukraine' after damage to pumping stations and staff unable to remain on duty"
    },
    {
      "id": "25181eed-c798-4390-b9e5-2b733fe0131c",
      "text": "Power supplies to a Donetsk filtration plant hit by shelling, leaving large areas without water"
    },
    {
      "id": "f84bd64e-b7d5-4b67-b03b-4712251d4a81",
      "text": "Adoption and public debate around Ukraine's 2019 language law ('On Ensuring the Functioning of Ukrainian as the State Language')."
    },
    {
      "id": "749e270c-0df9-4de6-a9f0-b30fed003e8e",
      "text": "Post‑invasion 'derussification' measures and rapid renaming/removal of Russian/Soviet toponyms and monuments across Ukraine in 2022."
    },
    {
      "id": "2a76e34b-09d2-4203-838a-c7a7f41d1fb3",
      "text": "U.S. Department of the Treasury designates the 'Donetsk People's Republic' and 'Luhansk People's Republic' in an expanded Ukraine-related sanctions package"
    },
    {
      "id": "920f6e67-114e-40e7-b689-2c784158a87d",
      "text": "EU/European institutions tie sanctions policy to implementation of the Minsk agreements (2015) and list the so-called DPR/LPR in sanctions contexts"
    },
    {
      "id": "cf8f4415-e018-4f89-b75a-ff0806218bcf",
      "text": "U.S. Executive Orders and related sanctions authorities (E.O. 13660 / 13661 / 13662) invoked in 2014 to address actors 'asserting governmental authority' in parts of Ukraine"
    },
    {
      "id": "8ef6bdf8-6bb8-49ac-aba7-8d88ee45e8fa",
      "text": "Pro-Russian separatist authorities in Donetsk proclaim the 'Donetsk People's Republic' after seizing regional buildings (widely reported)"
    },
    {
      "id": "6bb0a5d1-8ecf-4b8d-a603-564da52db3ee",
      "text": "Minsk II agreement (Feb 12, 2015) signed after talks in which leaders of the self-proclaimed Donetsk and Luhansk entities were included as signatories"
    },
    {
      "id": "c37dd408-ef96-42fb-aa14-f4272835891f",
      "text": "Japan found stainless‑steel/foreign particles in multiple Moderna COVID‑19 vaccine vials and recalled batches (high‑profile contamination incident)."
    },
    {
      "id": "934e714c-0c64-467c-9d29-ee93627e25cd",
      "text": "Danish population‑based study reporting increased incidence of myopericarditis after Pfizer mRNA vaccination in adolescents."
    },
    {
      "id": "2a957629-1994-4504-bd4e-5a500088abef",
      "text": "Publication of 'Batch-dependent safety of the BNT162b2 mRNA COVID-19 vaccine' (Denmark) reporting heterogeneous rates of suspected adverse events between Pfizer vaccine batches."
    },
    {
      "id": "0640f999-82c9-4245-985b-1c046a916479",
      "text": "U.S. court orders and publicized releases/requests for large numbers of FDA documents related to the Pfizer‑BioNTech vaccine."
    },
    {
      "id": "731ec64a-4fdb-477e-93d9-8d4ca3a8f3bd",
      "text": "Peer‑reviewed drug‑delivery studies (e.g., polysorbate 80‑coated PLGA nanoparticles, PubMed ID 26407669) demonstrating that polysorbate 80 can increase blood‑brain barrier permeability in experimental formulations."
    },
    {
      "id": "f42e9730-3a71-4a1b-890b-dc79bbe5e142",
      "text": "ASHP drug‑shortage / product detail page for Vitamin K notes Amphastar formulation contains polysorbate 80 and propylene glycol (clinical pharmacy resource)."
    },
    {
      "id": "5d211f49-cdc5-4a7c-89e2-24c4fa6e3193",
      "text": "American College of Pediatricians (ACPeds) statement (Jan 2016) flagged concerns about HPV vaccine and possible premature ovarian failure (POF)—invoked by some groups to link polysorbate 80 and infertility."
    },
    {
      "id": "0e4f9b6a-ce2a-40dc-91b6-b874ee651eda",
      "text": "Kyiv suspended routine pension and social payments to residents in non-government-controlled parts of Donetsk and Luhansk in late 2014, requiring IDP registration and in-person collection in government-controlled areas."
    },
    {
      "id": "db797985-3f3c-4e0c-86cf-ff34d2353f0d",
      "text": "Ukraine passed major pension-reform legislation in 2017 amid warnings from the IMF and World Bank about fiscal sustainability and pension costs."
    },
    {
      "id": "f9a5d31a-8263-45f1-b471-f0795fd547c4",
      "text": "Ukraine’s 2015 fiscal crisis and international bailout needs (IMF programs 2014–2015) created repeated reporting of severe budgetary pressure on Kyiv."
    },
    {
      "id": "ab3fb0e4-f741-4b2c-b3d2-bc1e0de90aaa",
      "text": "After Russia’s 2014 annexation of Crimea, Moscow moved to apply Russian pension law and budget subsidies to Crimea and began assuming responsibility for pension payments there."
    },
    {
      "id": "c1b698fb-9634-4b3a-9c21-2a7cbeb5b38d",
      "text": "Visible US troop rotations and equipment deliveries to Poland (arrival of US armor and rotational forces)"
    },
    {
      "id": "a7315e32-6b37-48bb-bfc5-f72a2a24db1d",
      "text": "NATO Communications and Information Agency exercise 'RAMSTEIN DUST‑II' testing deployable NATO air/communications connectivity (DACCC) capabilities"
    },
    {
      "id": "c8179441-57a7-45a1-8f23-9c4a01396d6e",
      "text": "NATO defence ministers approve creation of the Joint Support and Enabling Command (JSEC) in Ulm, Germany"
    },
    {
      "id": "db9eae80-bfc5-46f9-8c22-e744bf40dbc5",
      "text": "Public descriptions of Ramstein Air Base as a key US/NATO European hub (US EUCOM reporting and public pages describing Ramstein's C4ISR/logistics role)"
    },
    {
      "id": "f195824e-e406-4010-8b24-ab80840f08bc",
      "text": "Peer-reviewed reviews and renewed clinical-trial activity on high‑dose intravenous vitamin C in cancer (major review published 2022)"
    },
    {
      "id": "689326b1-b3d5-4344-9142-6513e77f8e88",
      "text": "NCI PDQ summary on Curcumin (turmeric) and cancer published — evidence reviewed but clinical benefit unproven"
    },
    {
      "id": "d8bdd26f-c6d5-4c04-86db-c78c94c932de",
      "text": "Systematic reviews and clinical reports on ketogenic diets and cancer published (e.g., systematic review assessing evidence published 2021)"
    },
    {
      "id": "54aba49f-e63c-4131-b8e3-5be975c2c899",
      "text": "Public communications and study data showing waning antibody protection over months and consequent official booster recommendations (e.g., booster guidance issued September 2021)"
    },
    {
      "id": "b9059891-c143-4807-aba9-bde4721cb9dd",
      "text": "Large Israeli nationwide study published on vaccine safety that reported an increased risk of myocarditis after BNT162b2 (Pfizer) vaccination but characterized the events as rare"
    },
    {
      "id": "2cd3f4ad-58ef-4698-a39f-3378d8ff0c5f",
      "text": "Regulatory vaccine trial and EUA briefing documents (Pfizer/BioNTech FDA briefing) that reported transient laboratory changes including short‑lived lymphocyte count decreases in some participants"
    },
    {
      "id": "5b52b8cf-5ace-4757-ae69-7a7fe7c09434",
      "text": "NOAA/observational reports noting rapid SST changes in the equatorial Atlantic in 2024 (reported by news agencies)"
    },
    {
      "id": "592787a6-94e6-48f7-b5a6-5665f686b8c9",
      "text": "UNICEF situational reporting on widespread attacks and disruptions to water and sanitation in eastern Ukraine (June 2018 SitRep)"
    },
    {
      "id": "70da14db-5840-44ae-aa98-53daa8ed6bd0",
      "text": "HotSpots H2O briefing: continued shelling damaging water infrastructure despite ceasefires (Circle of Blue, July 30, 2018)"
    },
    {
      "id": "b299d081-9429-4b11-8274-4a51e14cc166",
      "text": "Severe thunderstorms and heavy rains cause flooding and high river levels (KyivPost, June 28, 2018)"
    },
    {
      "id": "ccebdffa-4ee6-45af-9997-498fa76ebdcc",
      "text": "Donetsk Filtration Station shelled and operations halted, disrupting water supply"
    },
    {
      "id": "fb9408d6-c971-413b-9cea-2e3322ba3162",
      "text": "Joint War Committee (insurers) placed Ukrainian and Russian waters in the Black Sea and Sea of Azov on its high‑risk/war-listed areas (amendment effective 15 February 2022)"
    },
    {
      "id": "0f2abd3b-64fd-49f3-971c-a1db3e57aff2",
      "text": "Shipping industry appeals for safe passage for hundreds of merchant vessels and seafarers stranded in Ukrainian ports"
    },
    {
      "id": "2b87a490-d010-4798-81c2-a3a0ed1d0082",
      "text": "Russian Black Sea flagship Moskva damaged and later sank after reported Ukrainian Neptune anti-ship missile strike"
    },
    {
      "id": "7c5374ae-854b-4158-b038-318ea55733d4",
      "text": "UN OCHA warning of high risk of communicable‑disease outbreaks among internally displaced persons in Donbas (electricity/water outages, damaged health infrastructure)"
    },
    {
      "id": "456f56c3-aabe-494a-a25d-6540a141d9e6",
      "text": "WHO Global Tuberculosis Report (2016) and other analyses showing Ukraine’s high burden of tuberculosis and multidrug‑resistant TB"
    },
    {
      "id": "7d6bd4a6-d05d-4b18-9955-b9692cd59be3",
      "text": "Circulating vaccine‑derived poliovirus outbreak confirmed in Ukraine (two paralytic cases)"
    },
    {
      "id": "a8e9a4dc-4d6f-418d-99ac-ea623698886a",
      "text": "Nationwide tractor convoys and roadblocks as French farmers marched on Paris in late January 2024"
    },
    {
      "id": "205dcff4-c5bc-47d7-ae42-47b01da83046",
      "text": "Farmers dumped manure and rotting produce in city centres during protests (reported in Toulouse)"
    },
    {
      "id": "931abfca-db8c-4718-812b-de8adb5d675e",
      "text": "Russian Defence Ministry and Kremlin officials call Bucha scenes \"staged provocation\""
    },
    {
      "id": "a0cb6afb-ecd3-4526-bc22-bb8bfbd5027e",
      "text": "Public statements and media coverage discussing possible measures against draft dodgers, including asset/account seizure among proposed penalties"
    },
    {
      "id": "2132ccf9-08cb-4938-900f-a1a294b77a36",
      "text": "Public disinfection operations reported and photographed in Ukrainian cities (street/transport spraying, workers in hazmat suits)"
    },
    {
      "id": "bb028d86-d744-4c84-a61a-3a184bc6c646",
      "text": "Ukrainian government declares nationwide quarantine (Resolution No. 211)"
    },
    {
      "id": "d9f3e7a5-3ac7-4ff9-b5c7-57d45587e0e6",
      "text": "FAO follow-up report 'Tackling climate change through livestock: A global assessment' (FAO)"
    },
    {
      "id": "cb829a74-e67a-471c-8f59-96b7c970d052",
      "text": "Takeda and Moderna published an investigation report (Oct 1, 2021) into the Japan incident, concluding the particles were 316L stainless steel and describing manufacturing root causes and corrective actions."
    },
    {
      "id": "f2266466-c679-495d-aa32-a1547dd029f0",
      "text": "WHO reported a multi-country monkeypox outbreak in non-endemic countries"
    },
    {
      "id": "5e58b411-987e-43e6-b1c4-5e9565e9bbc9",
      "text": "U.S. president ordered review of COVID origins amid publicized, divided intelligence assessments (fuelling lab-leak narratives)"
    },
    {
      "id": "dccc509d-c576-4034-9361-2b1eb47591e5",
      "text": "Ukrainian authorities built a temporary flow-control dam near Kalanchak in 2014 to restrict canal water into Crimea"
    },
    {
      "id": "ab3f8106-b455-47de-9e0e-3c1b0ffb094c",
      "text": "Reports of chronic water shortages, rationing and Russian attempts to substitute supplies (desalination, reservoirs, pipelines) in Crimea"
    },
    {
      "id": "f0f810a4-4ff6-4c29-a46f-40740a2f111c",
      "text": "Reports of clergy splits and competing loyalties in Crimea and eastern Ukraine as Russian forces moved in (priests aligning with Russian-backed authorities)"
    },
    {
      "id": "fc1eae68-c39e-41f7-8a4f-bf75fe7b9265",
      "text": "Reports of numerous attacks, seizures or conflicts around Orthodox church buildings and clergy amid 2014 unrest"
    },
    {
      "id": "6fda58f9-892b-49db-a478-679621b09c8f",
      "text": "Mejlis of the Crimean Tatar People called for a boycott of the March 2014 referendum"
    },
    {
      "id": "8cff213e-b552-46a4-b12e-65b8aca843fc",
      "text": "Russian leadership publicly framed the referendum and subsequent annexation as a legitimate territorial decision (Putin’s statements/speech coverage mid‑March 2014)"
    },
    {
      "id": "bafafe5d-7c33-4700-a0e8-fbe832774ef8",
      "text": "Armed seizure of the Crimean parliament and buildings by unmarked pro‑Russian forces"
    },
    {
      "id": "94f93f21-b399-43b6-8c1a-6dc7c2680520",
      "text": "Court battles and FOIA demands (PHMPT lawsuit) over release of Pfizer documents, and initial FDA proposals to release documents over decades (the 75‑year timeline headline), stoked distrust and narratives that regulators lacked underlying safety/effectiveness data."
    },
    {
      "id": "30ee29c0-7572-4257-944c-bfea6990238a",
      "text": "Local activists attempted to topple the Felix Dzerzhinsky monument in Zaporizhzhia but failed (public attempt and clashes reported)."
    },
    {
      "id": "a949eb99-fee2-42fb-92cc-5ed10da638c8",
      "text": "City unveiled a sculptural composition (‘The Steelworker and the Teacher’) — a bench-like monument to the characters of the film 'Vesna na Zarechnoy Ulitse' — on Shevchenko Boulevard in Zaporizhzhia."
    },
    {
      "id": "258ba6cf-e3b4-48da-aa2a-505f8615c449",
      "text": "Wider wave of removals/topplings of Soviet-era monuments across Ukraine in 2014 (including highly publicized removals of Lenin statues earlier that year)."
    },
    {
      "id": "f030637b-114d-4e7f-8d7c-eeda43cd9190",
      "text": "Local media and classifieds flagged massive accommodation and flight price spikes in Kyiv ahead of the final (rooms and short-term rentals listed at many times their usual rates)."
    },
    {
      "id": "e933f4d1-5305-4d96-b283-b161bb49c5d7",
      "text": "Press report that more than 2,000 Real Madrid supporters returned tickets citing logistics and 'sky‑rocketing expenses' related to attending the Kyiv final."
    },
    {
      "id": "c4e240db-18a0-4924-a3d5-b007ef851e0e",
      "text": "Polish police statistics and reporting showing a rise in thefts in 2022 (reported Jan 20, 2023)"
    },
    {
      "id": "75b5e2b4-7f78-40b0-a89e-76e5a55f40ce",
      "text": "Europol-coordinated EU-wide action leading to the arrest of around 130 suspected human traffickers (operation announced June/July 2022)"
    },
    {
      "id": "53bc33f3-da8b-439e-bb2e-1ac545b26a3d",
      "text": "Mass exodus of civilians from Ukraine into neighbouring EU states after Russia's full-scale invasion (millions crossed borders beginning 24 Feb 2022)"
    },
    {
      "id": "d3c3e61d-d06e-4ee5-8174-28cc6ad30648",
      "text": "Media coverage and local backlash in Poland documenting xenophobia and the spread of anti-refugee narratives, including claims that Ukrainian refugees are responsible for crime (BBC report)"
    },
    {
      "id": "ba9e2600-a590-4127-970b-4e2742cad854",
      "text": "Large measles outbreak linked to a theme-park (Disneyland) that spread across multiple states (December 2014–February 2015)"
    },
    {
      "id": "611fc9fc-abfb-489f-b812-71a34196257e",
      "text": "PNAS study showing acellular pertussis vaccines protect against disease but may fail to prevent infection and transmission in a nonhuman primate model (often cited 2014)"
    },
    {
      "id": "62e9127a-fd2c-4286-9575-6887ef9060fa",
      "text": "Independent assessments of donor assistance (2018) noting limited impact of some programmes"
    },
    {
      "id": "18cefcf3-97f2-452a-a1b1-b8e4c67b206f",
      "text": "Lithuania presents a high‑profile 'Marshall Plan for Ukraine' proposal"
    },
    {
      "id": "481d2f1a-071d-4f18-934e-8f3340af485e",
      "text": "European Court of Auditors special report: 'EU assistance to Ukraine' finds results 'fragile'"
    },
    {
      "id": "253a86f7-a466-4e40-9e0f-eedd68395199",
      "text": "U.S. President ordered the U.S. intelligence community to further investigate the origins of COVID‑19 and report findings (public announcement of an intelligence review)"
    },
    {
      "id": "8e764b53-09e5-435a-b7e0-d11593a27175",
      "text": "Media reports (citing U.S. intelligence) that three Wuhan Institute of Virology researchers sought hospital care in November 2019"
    },
    {
      "id": "ce7c040d-9c54-4fb8-a121-f8cbd3b50719",
      "text": "WHO-convened Global Study of Origins of SARS‑CoV‑2: China Part report released, offering assessments of possible origin hypotheses but noting limited access to raw data and calling for further study"
    },
    {
      "id": "483c9e14-f9bc-41de-aa9d-b4464edf1721",
      "text": "European Union Advisory Mission (EUAM) begins operations in Kyiv to advise on civilian security-sector reform"
    },
    {
      "id": "c49b0cf9-c099-42be-a7d5-d56311c0726b",
      "text": "Launch of new Kyiv patrol police (major public-facing police reform supported by international partners)"
    },
    {
      "id": "091f83e3-bba0-4e4a-bfca-8d8aa10aafa8",
      "text": "U.S. announces a $200 million security assistance package for Ukraine (release reported July 20, 2018)"
    },
    {
      "id": "7b5c612b-1d79-44c2-8593-f25282ac9b20",
      "text": "Canada launches Operation UNIFIER — Canadian Armed Forces training mission for Ukrainian personnel"
    },
    {
      "id": "91047411-6884-495a-b270-1c812c9a5302",
      "text": "Peer‑reviewed review article (CMAJ) summarising mechanisms and multiple case reports showing grapefruit (furanocoumarins) can irreversibly inhibit intestinal CYP3A4 and cause dangerous increases in blood levels of many drugs (including some CNS agents)."
    },
    {
      "id": "59724a0a-a7ec-49be-a9c7-5332610aa537",
      "text": "Case report published describing a presentation mimicking quetiapine (an antipsychotic) overdose linked to grapefruit juice consumption ('Grapefruit Juice Cleanse Mimicking Quetiapine Overdose', J Clin Psychopharmacol)."
    },
    {
      "id": "a14530b8-0fc3-49af-a1c6-562df417f2f7",
      "text": "Existence and public use of the Mapuche (Wenufoye) flag in Chilean demonstrations"
    },
    {
      "id": "dab32f1e-f3ae-4d6e-bf38-c9ee4ac23cbb",
      "text": "Large Euromaidan demonstrations in Kyiv with widespread display of Ukrainian blue-and-yellow flags"
    },
    {
      "id": "b23bc7bc-98f0-4012-b0f6-192ac391443e",
      "text": "IPCC Fifth Assessment Report (AR5) discussion of a temporary slowdown ('hiatus') in surface warming (1998–2012)"
    },
    {
      "id": "9efbffa2-9434-46b3-9ebb-519b727679f8",
      "text": "Publication and promotion of Lindzen & Choi's low climate‑sensitivity analysis (2011)"
    },
    {
      "id": "aa902029-1061-4cbe-9f1d-9be774e8fc3b",
      "text": "IPCC Fifth Assessment Report (AR5) publication stating with high confidence that recent warming is caused by human activities"
    },
    {
      "id": "f7b613a9-3314-4b9d-bffb-61b6124d76de",
      "text": "WHO interim guidance on mask use early in the pandemic (initial cautious messaging)"
    },
    {
      "id": "0e002bec-5fe4-4d7b-9e0e-353142b25b67",
      "text": "CDC recommendation that the public wear cloth face coverings (press guidance)"
    },
    {
      "id": "20496504-fba2-4e08-90ea-6babbc089958",
      "text": "Russia launched one of the largest waves of missile and drone strikes across Ukraine on 29 December 2023, hitting cities and critical infrastructure"
    },
    {
      "id": "876a5840-d36d-4596-9666-20f3ceda7779",
      "text": "Estonian Defence Forces Intelligence Centre head Col. Ants Kiviselg gave a press briefing describing intensified Russian missile/drone waves, saturation tactics and damage to Ukrainian infrastructure (remarks later taken out of context)"
    },
    {
      "id": "e2622e7f-1580-44d4-8057-8538c9966ca1",
      "text": "Publication of Rasool & Schneider (Science) 1971 paper on aerosols and cooling"
    },
    {
      "id": "c8939582-76cc-4531-8547-139a15ded32e",
      "text": "FTC warned hundreds of marketers (April 2023) about potential civil penalties for unsubstantiated health claims, including for CBD products."
    },
    {
      "id": "3357401c-35a7-476f-876d-c29a22cabc32",
      "text": "Meta‑analysis showing PTSD is associated with increased risk of later dementia (British Journal of Psychiatry, 2020)"
    },
    {
      "id": "13aac186-d0ed-4535-a881-a5a4bdb87364",
      "text": "FDA enacted rule and labeling requirements to limit aluminum contamination in parenteral nutrition products (Final rule enacted July 2004)."
    },
    {
      "id": "eef92b74-64d9-4527-9f75-e23c22ad00fa",
      "text": "Published research documenting parental refusal and hesitancy specifically around the hepatitis B birth dose (study investigating reasons parents decline newborn HepB immunisation)."
    },
    {
      "id": "92b0013d-9c76-4791-ab68-c99ebaca5af7",
      "text": "Publication of Mitkus et al., 'Updated aluminum pharmacokinetics following infant exposures through diet and vaccination' (Vaccine, 2011)."
    },
    {
      "id": "78685855-268d-4cac-9e6c-75f169f87513",
      "text": "PNAS paper documenting very slow and variable human liver dihydrofolate reductase (DHFR) activity (Bailey & Ayling, 2009)"
    },
    {
      "id": "1b08795f-959a-412e-8533-9faf731604db",
      "text": "Report/analysis identifying threshold folic acid doses above which unmetabolized folic acid appears in serum (Sweeney et al., BMC Public Health)"
    },
    {
      "id": "c7744804-cada-43bd-b31f-a98632fd26fd",
      "text": "Reports from China and international press noting use or trials of high‑dose vitamin C in Chinese hospitals"
    },
    {
      "id": "9f157653-aafb-41ef-9fc9-da58bf871755",
      "text": "Surge in consumer demand and sales for immune‑support supplements (vitamin C and D) during March 2020"
    },
    {
      "id": "ee9c48df-0509-454e-a426-03f65a311a72",
      "text": "Svyatoslav Vakarchuk’s public record of outspoken political commentary and criticism of Ukraine’s political class"
    },
    {
      "id": "17f927ab-9b78-43ff-8cd2-151101d87067",
      "text": "Kerch Strait incident: Russian coastguard fired on and seized three Ukrainian naval vessels attempting to transit the Kerch Strait."
    },
    {
      "id": "131b3f67-cd28-4304-8493-4ef0d561ddb2",
      "text": "Ukraine introduced temporary martial law in regions bordering Russia and the Azov-Kerch water area."
    },
    {
      "id": "ac9e4919-d616-446a-981f-359a36e898e2",
      "text": "Russian officials publicly accused Ukraine of deliberately provoking the Kerch incident and warned of further Ukrainian 'provocations'."
    },
    {
      "id": "8e4ecb78-2cd5-4a31-831c-4bee4f699ca2",
      "text": "In vitro study examining activated charcoal and GHB adsorption (toxicology literature)"
    },
    {
      "id": "a84eaee9-201f-4d8d-b27b-768be7e814c1",
      "text": "Peer‑reviewed publication demonstrating intranasal/intratracheal delivery of mRNA to mouse lungs using polymer nanoparticles (Sci Transl Med)."
    },
    {
      "id": "eb3b9426-ad3d-4fc4-83c1-c97df52a6830",
      "text": "Hank Aaron publicly received his first dose of the Moderna COVID-19 vaccine at Morehouse School of Medicine to encourage vaccination among Black Americans."
    },
    {
      "id": "7daabd93-b1c9-4167-adee-62a5a406806b",
      "text": "Hank Aaron died at age 86 (widely reported on Jan 22, 2021) a few weeks after his public vaccination."
    },
    {
      "id": "10d9dcb1-82e1-4045-acca-984f4a4e6b55",
      "text": "Publication of a Phase II clinical trial showing curcumin was safe and produced biological effects in patients with advanced pancreatic cancer (Dhillon et al.)."
    },
    {
      "id": "616f6f68-f401-4fa0-ba4c-64cdc24121d9",
      "text": "Rapid growth in the commercial turmeric/curcumin supplement market and aggressive product marketing by supplement companies (industry coverage 2015–2018)."
    },
    {
      "id": "aa6dd177-a776-4665-ab7b-bffc42996a33",
      "text": "CDC report on resurgence of 'black lung' (progressive massive fibrosis) in coal miners"
    },
    {
      "id": "6df8661c-1208-4a7a-b84f-dad337aa9a8a",
      "text": "Informal agreement reached between the Maltese Presidency and the European Parliament on visa liberalisation for Ukrainians"
    },
    {
      "id": "38532f76-a8d3-4a92-8e5c-2b120ab21c7f",
      "text": "Commission's visa‑liberalisation proposal specified biometric‑passport holders"
    },
    {
      "id": "cc44ee2c-d62e-4d43-aeed-cca51553bc91",
      "text": "Statement that Ireland and the United Kingdom are not subject to the new visa regime"
    },
    {
      "id": "c046013e-6009-405f-89b8-ca146753bde5",
      "text": "EU Council adopts revision of the visa‑waiver suspension mechanism"
    },
    {
      "id": "4a16ebcb-82bf-4c8d-ad7e-466d21217073",
      "text": "France's health authority (HAS) recommends a single COVID-19 vaccine dose for people previously infected"
    },
    {
      "id": "0b4bccd2-1a09-4415-8393-a00d8b01963f",
      "text": "NEJM research letter (Krammer et al.) showing rapid, high antibody responses in seropositive persons after a single mRNA vaccine dose"
    },
    {
      "id": "e4c84464-0a89-4baf-b942-1308b3b32900",
      "text": "U.S. FDA revokes the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID-19."
    },
    {
      "id": "74c4307b-5e3b-4b5c-b655-6114d055f24f",
      "text": "WHO temporarily halts the hydroxychloroquine arm of the Solidarity Trial over safety concerns."
    },
    {
      "id": "1db17dca-a60a-4963-ac75-6614e7621bf0",
      "text": "Russian presidential decree fast-tracking Russian citizenship for Ukrainians"
    },
    {
      "id": "81ab6954-cd5d-4243-bfa3-685098227060",
      "text": "Installation of Russian-backed local administrations and visible propaganda campaigns in occupied cities (e.g., Kherson)"
    },
    {
      "id": "2687e56a-7e91-4a01-b7b0-a9f5e4f13ff1",
      "text": "Widespread passport issuance (‘passportization’) in occupied Ukrainian cities"
    },
    {
      "id": "5cd35820-333e-448b-96e2-788eb0f2bb91",
      "text": "Pre-war and wartime local public-opinion surveys showing mixed but non-negligible support for closer ties with Russia in parts of Donbas"
    },
    {
      "id": "478e87c3-687c-4384-9639-d343f99a2cde",
      "text": "Prior public reporting and regulatory actions in 2021 about rare blood-clotting events with some COVID-19 vaccines (e.g., Johnson & Johnson/AstraZeneca) established a persistent vaccine–blood clot association in public discourse."
    },
    {
      "id": "eb0e4b07-531d-4804-9b48-c48258c4b257",
      "text": "Government statement ending the legal duty to self-isolate in England as part of the 'Living with COVID' approach"
    },
    {
      "id": "55ed0ca1-fb2b-41c2-b3cb-33ec62c3e4e9",
      "text": "Great Barrington Declaration (October 4, 2020) advocating 'focused protection' and arguing against ongoing mass interventions"
    },
    {
      "id": "5f68ea44-90f4-4964-bd73-81d69fe6d6a6",
      "text": "Publication and circulation of official guidance clarifying limitations of PCR cycle threshold (Ct) values (explaining PCR can detect non-infectious viral fragments)"
    },
    {
      "id": "84e4c275-2cb8-4157-8584-96786b1e11be",
      "text": "NOAA AOML study documents an unusually rapid cooling phase in the equatorial Atlantic following record-warm conditions in 2024"
    },
    {
      "id": "6547f701-a4f0-411c-97d2-1f949e69d53f",
      "text": "Safety and technical evaluations by consumer-safety groups (Electrical Safety First and independent lab tests) showing plug-in ‘power saver’ devices do not reduce residential bills and can pose fire/shock hazards."
    },
    {
      "id": "63e9a4ea-23b5-4a68-9930-207afc06a78c",
      "text": "Reports of volunteer militias forming in Ivano‑Frankivsk region (local volunteer militia of Prykarpattia reported by Interfax)"
    },
    {
      "id": "33407265-94ba-4284-9925-81dd4a2ca2bb",
      "text": "UN/UNICEF campaign 'Children, Not Soldiers' and international attention to child recruitment (launched March 2014)"
    },
    {
      "id": "7743b8b3-8dac-4152-83ce-f43c0bee9d9e",
      "text": "Anti‑migrant unrest in Torre Pacheco (July 2025) that was inflamed by a misleading social‑media video and triggered violent reprisals and arrests."
    },
    {
      "id": "89248d71-ce8a-41e3-a22a-a2345dffdfd7",
      "text": "Ongoing monitoring by EUvsDisinfo and similar fact‑checking bodies documenting a recurring pro‑Kremlin pattern of inserting 'Ukrainians' into unrelated crimes abroad to discredit Ukrainian citizens."
    },
    {
      "id": "8755ba75-eaca-4e19-8dea-ce787a5efa22",
      "text": "Spanish National Police arrested seven people suspected of stealing more than 1,100 chairs from restaurants and bars in Madrid and Talavera de la Reina."
    },
    {
      "id": "e575aa8e-464e-489b-a664-70ab7a7cb07b",
      "text": "Reuters special report documenting separatists' access to grenades and grenade launchers in Luhansk/Donbas"
    },
    {
      "id": "fac83173-c379-427e-9657-21a1713d394c",
      "text": "Visual evidence of tanks displayed in Luhansk public spaces and on-the-ground photos around early July 2014 (T-34‑85 in Luhansk report)"
    },
    {
      "id": "fcedaa29-9c12-4801-a93f-2d25b4768c4a",
      "text": "Odesa deadly clashes (May 2, 2014) with dozens killed and widely circulated graphic images"
    },
    {
      "id": "c89ccfae-db15-4f80-8115-7a03e8dcad52",
      "text": "European Court of Human Rights ruled her pre-trial detention was arbitrary/unlawful (June 2013)"
    },
    {
      "id": "2de0391a-c6d2-4cd6-b820-9d688b482963",
      "text": "Tymoshenko released from prison during the Euromaidan upheaval (22 February 2014)"
    },
    {
      "id": "8f534fd9-f814-4641-87a9-04a1426c7613",
      "text": "Massive oil depot fire/explosion began near Vasylkiv (outside Kyiv) on June 8, 2015"
    },
    {
      "id": "07d2b96c-e7dd-497a-813c-527a2060559d",
      "text": "Reports of renewed outbreaks/explosions at the depot after partial containment (June 11, 2015)"
    },
    {
      "id": "b4a2e5f1-2540-46d3-81e4-e2e544763ab8",
      "text": "State-level legalization and commercialization expansion (New York signs Marijuana Regulation and Taxation Act)"
    },
    {
      "id": "98b2aff6-bca3-44a3-ba54-b68ffbd832d6",
      "text": "National Academies report: The Health Effects of Cannabis and Cannabinoids (comprehensive evidence review)"
    },
    {
      "id": "151711bb-8755-4a67-aa98-e1adeb5c92d1",
      "text": "FDA approves Epidiolex (cannabidiol) for treatment of specific severe epilepsy syndromes"
    },
    {
      "id": "42258c5f-d0e7-485b-885e-3e3bfdc304ed",
      "text": "Japan suspension of multiple Moderna vaccine batches after discovery of foreign/metal particles (September 2021)."
    },
    {
      "id": "a91f3488-dbae-4651-a7a1-71416fa1d8ae",
      "text": "Publication of Lund University in vitro study reporting reverse transcription of Pfizer-BioNTech mRNA in human liver cell line (Huh7)."
    },
    {
      "id": "e95e2c86-5cf5-4e2f-bfd1-8ab731e857eb",
      "text": "2014 Simferopol incidents and defections of Ukrainian officers during Russia's annexation of Crimea."
    },
    {
      "id": "f73f876c-af9b-44f5-a348-0937fa930305",
      "text": "U.S. delivery of Javelin anti-tank missiles and launchers to Ukraine"
    },
    {
      "id": "360a8c46-e6d8-492e-bde7-3bdf7f02b104",
      "text": "Statements and claims from Russian officials and state media accusing Western-supplied arms to Ukraine of being diverted or becoming a broader security threat"
    },
    {
      "id": "ded85493-80e4-4f5b-a532-744960395d4d",
      "text": "IARC (WHO) evaluation and monograph work classifying formaldehyde as carcinogenic to humans (Group 1)"
    },
    {
      "id": "7839b325-4a85-43da-856c-b57c97205728",
      "text": "American Academy of Pediatrics and U.S. Public Health Service joint statement recommending reduction/removal of thimerosal from infant vaccines"
    },
    {
      "id": "dc57462e-f58d-4301-8a18-8ecc5bebc69b",
      "text": "ACIP / CDC guidance and publications clarifying influenza vaccination in persons with egg allergy (making ovalbumin/egg protein salient)"
    },
    {
      "id": "cdd0c405-98b0-49db-8ea9-8ac94256b27a",
      "text": "Pfizer and BioNTech began their large Phase 3 COVID‑19 vaccine trial and publicly stated trial enrollment had started."
    },
    {
      "id": "f944ae1d-075d-498b-a803-1f145d06cde3",
      "text": "Reports of children killed or injured in Kharkiv region shelling (multiple local reports and rights groups)"
    },
    {
      "id": "2e57aac3-7da7-4f92-88ab-1a2534a142cc",
      "text": "Prior high‑profile vaccine safety scares (e.g., Japan’s temporary suspension/recall of some Moderna batches after finding foreign particles)"
    },
    {
      "id": "6da8b312-412e-41b5-97c2-320220ed5504",
      "text": "Public availability of population‑level mortality datasets (World Mortality Dataset / Our World in Data) used by the authors to compute excess deaths"
    },
    {
      "id": "3e0cb12c-8fa8-4bc3-bd34-b35b74430180",
      "text": "Publication of large peer‑reviewed estimates of lives saved by COVID‑19 vaccination (Lancet study, June 2022)"
    },
    {
      "id": "1d902c0e-3b2f-4211-b144-2c47a1918793",
      "text": "Protests and roadblocks in multiple towns as gas-dispute left houses without heating"
    },
    {
      "id": "95fbc391-139d-4b74-bab7-54c98c57a2bb",
      "text": "Large-scale winter protests on Maidan (Euromaidan) in cold conditions, Nov 2013–Feb 2014"
    },
    {
      "id": "fe81f0df-bad3-45f2-9a1f-c50df83a836d",
      "text": "Local Kyiv residents block a street to demand restoration of heating after prolonged outages"
    },
    {
      "id": "50e1baad-2edc-4b4e-b3ed-7433803a9740",
      "text": "National gas-price increase announced and implemented, triggering utility cutoffs for non‑paying customers"
    },
    {
      "id": "80eab4aa-e080-4ddb-a409-7928e2405d96",
      "text": "U.S. delivery/confirmation of Javelin anti-tank missiles to Ukraine"
    },
    {
      "id": "c1efc833-9789-4e82-b10f-013ba81a9a7c",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels"
    },
    {
      "id": "f7820ae8-03eb-4cdb-a315-b5574a7284d1",
      "text": "Ukraine lawmakers approve a significantly increased defence budget for 2020"
    },
    {
      "id": "7907f512-3891-422c-b167-7a2ec07a79e3",
      "text": "Large multinational Sea Breeze 2019 naval and amphibious exercises in the Black Sea near Ukraine and Crimea"
    },
    {
      "id": "cfa63295-1a34-4cdb-8201-fc3619deef3b",
      "text": "CDC and FDA acknowledged increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination and reviewed the evidence (June 2021 ACIP/MMWR updates)"
    },
    {
      "id": "b1f1eb74-be8d-45bb-b878-aeb4451b3315",
      "text": "U.S. CDC and FDA recommended a temporary pause on the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare clotting events (April 2021)"
    },
    {
      "id": "eb7cf401-50cb-4091-952e-3b6afb69fbfc",
      "text": "Norwegian Medicines Agency investigation into 23 deaths of very frail elderly people after Pfizer/BioNTech vaccination (investigation reported publicly)"
    },
    {
      "id": "f1b90ad2-9e41-47ed-b4e8-1c3eaa4a8111",
      "text": "European Medicines Agency (EMA) finds a possible link between the AstraZeneca COVID-19 vaccine and very rare blood clots with low platelets"
    },
    {
      "id": "b8afc355-0d3b-4b78-8e52-f51a350d83ea",
      "text": "Reporting on targeted Russian disinformation campaigns aimed at Poland–Ukraine relations (contextual, enabling environment)"
    },
    {
      "id": "126eae67-4a76-4364-a533-375bb10f6c72",
      "text": "Publication of Rabbit Hole interview with Sergiy Nikolaychuk (Deputy Governor, National Bank of Ukraine)"
    },
    {
      "id": "cc4501fc-11d1-4e7b-8e44-ddd88a405d9b",
      "text": "FAO releases 'Pathways towards lower livestock emissions' at COP28 (FAO report on livestock methane and mitigation)"
    },
    {
      "id": "11d3f25f-6719-4690-b5d7-c65950aaecf4",
      "text": "Publication and industry publicity for papers endorsing GWP* as a better metric for methane (coverage by AHDB and others)"
    },
    {
      "id": "b9fee561-458c-4021-a790-653c39480351",
      "text": "IPCC Special Report on Global Warming of 1.5°C (2018) — discussion of polar amplification and regional differences"
    },
    {
      "id": "6849dfaf-8ca2-4b18-b601-9eef2c9e238c",
      "text": "SCAR (Scientific Committee on Antarctic Research) report: 'Antarctic Climate Change and the Environment' — 2019 update"
    },
    {
      "id": "a6160e6c-5484-40f4-9600-e21d9ac905d1",
      "text": "Crimea's supreme court banned the Mejlis (the representative body of the Crimean Tatar people), declaring it an 'extremist' organization."
    },
    {
      "id": "05ddcda8-e6d3-43d8-a4ce-1356f99b3ed6",
      "text": "Prominent Crimean Tatar leaders (e.g., Mustafa Dzhemilev) gave repeated public statements and interviews emphasizing that Crimea is the historical homeland of Crimean Tatars and calling for protection of their rights and autonomy within Ukraine."
    },
    {
      "id": "fccab78a-fa33-4db4-bb24-62e5e2a113ae",
      "text": "Large Crimean Tatar-led protest in Simferopol (Day of Resistance), where thousands marched on 26 February 2014 opposing annexation and asserting Crimean Tatar identity and rights."
    },
    {
      "id": "7966b150-ab5e-430d-8dd8-0b6cc2a52590",
      "text": "ATR, the only mainstream Crimean Tatar–language TV channel operating in Crimea, was denied a Russian broadcasting licence and forced off the air in the occupied peninsula."
    },
    {
      "id": "9b43e23d-6e67-4a55-bff8-88a4dd7e0222",
      "text": "Soviet-era mass renaming of Crimean toponyms (large-scale replacement of Crimean Tatar place names with Russian names, principally 1944–1949)."
    },
    {
      "id": "e4e9833d-2b95-431e-bd45-33d54b1159b5",
      "text": "The IAEA publicly condemned shelling near the Zaporizhzhia plant and warned the situation was dangerous (IAEA statements in early August 2022)."
    },
    {
      "id": "4fd5cba6-5ef8-4f7e-88a7-cc0e21801f03",
      "text": "Russian forces seized control of the Zaporizhzhia Nuclear Power Plant during initial invasion operations."
    },
    {
      "id": "b3905ba9-04c9-4087-abe7-fae021d91781",
      "text": "CDC publishes MMWR report (Risk Factors for Severe COVID-19 Outcomes) showing that among vaccinated persons who died after completing a primary vaccination series, 77.8% of those deaths had four or more risk factors."
    },
    {
      "id": "85c23183-95b6-47bf-8162-cf1d77e20f54",
      "text": "Repeated regulatory actions (2014–2016) by Ukraine's media regulator removed or blocked numerous Russian channels and programming from Ukrainian airwaves."
    },
    {
      "id": "12db9005-ba29-49f1-9b27-a3b203a2b06b",
      "text": "Heavy shelling and bombardment in Donetsk during fighting in late 2014 damaged infrastructure, disrupting TV transmissions and showing visibly destroyed broadcast facilities."
    },
    {
      "id": "9aacb493-235e-4c62-985a-961ed8ee8fa6",
      "text": "2021 Ukrainian government sanctions that removed three pro‑Russian TV channels (112 Ukrayina, NewsOne, ZIK) from broadcast."
    },
    {
      "id": "728c3997-6622-4111-a278-d680c1b50c96",
      "text": "Long‑running Russian state and proxy narratives alleging systemic persecution of Russian‑speakers in Ukraine (used as framing and justification since 2022)."
    },
    {
      "id": "cf7b861a-ab3c-4a9b-ac59-549ac3ef0af0",
      "text": "Context of real international humanitarian assistance to Ukraine in 2015 (EU/Austria aid packages) — e.g., European Commission announced additional humanitarian assistance in January 2015."
    },
    {
      "id": "2e9ef9b7-a1a4-47f6-8450-0d4d53b6a973",
      "text": "The stories invoked an historical Austro-Hungarian practice (dating to 1774) of paying soldiers stationed in Bukovina to compensate for climatic conditions."
    },
    {
      "id": "25771af9-52d2-4703-abce-50f51dd79499",
      "text": "High public awareness of large solar PV penetration in Spain (record generation in 2024)"
    },
    {
      "id": "81d8088a-9576-4107-a172-0b313558170f",
      "text": "Dutch-led teams recovered wreckage and human remains from rebel-held areas with local actors cutting and loading debris (reported removal of 'crucial debris')"
    },
    {
      "id": "81609bf2-06aa-4215-b85e-1172352ab4fd",
      "text": "OSCE and investigators documented limited access, delays, and chaotic control of the crash site by armed groups"
    },
    {
      "id": "dfbf618b-e02f-4074-9549-2e0686b74d34",
      "text": "1994 discovery and publication identifying Kaposi’s sarcoma‑associated herpesvirus (KSHV/HHV‑8) as the viral agent linked to Kaposi’s sarcoma"
    },
    {
      "id": "b6eee547-04e8-421c-8bf4-f939c1f700e5",
      "text": "Publication and media coverage of a 2017 MACS cohort analysis reporting links between heavy popper use and some virus‑associated cancers in older HIV‑negative MSM"
    },
    {
      "id": "b1f6871b-fb0b-4b53-b754-feb19895b71c",
      "text": "UNICEF press release and mapping (July 13, 2022) on protection and care of unaccompanied and separated children fleeing Ukraine, highlighting legal complexity and cross‑border guardianship issues."
    },
    {
      "id": "a5ab1168-82e2-40e1-88e4-2739fd94022a",
      "text": "High‑profile 'Jugendamt' child‑removal case (Ariha Shah): German youth welfare authorities removed an infant from her Indian parents in Berlin (reported September 2021)."
    },
    {
      "id": "d520bc36-9485-48c7-bb02-b172d8979bac",
      "text": "Furdui family case (April 26, 2021): Seven children of the Furdui family were taken into custody by a German Jugendamt office, generating international coverage and long‑running dispute."
    },
    {
      "id": "fbcc72f3-a1bb-4fc5-9188-1f0d06b36c2c",
      "text": "Publication of peer‑reviewed study reporting enlarged external occipital protuberances (EEOP) in young adults"
    },
    {
      "id": "703963f3-6fe9-4ee6-ac11-bd823769cfbf",
      "text": "StatPearls / NCBI review and guidance summarising when activated charcoal is indicated for poisoning (clinical toxicology guidance update)"
    },
    {
      "id": "176f09da-4858-4cf5-b55e-bb3752716f63",
      "text": "Major news coverage of charcoal consumer products (BBC story noting popularity and celebrity effect for charcoal toothpastes/products)"
    },
    {
      "id": "60b361fd-2a30-437f-b677-cc825abd8fc8",
      "text": "WHO interim guidance on mask use in the context of COVID‑19 (update)"
    },
    {
      "id": "46cbfd54-f8ad-4e6e-b27e-b823d716a47a",
      "text": "Publication of van Doremalen et al. laboratory study on aerosol and surface stability of SARS‑CoV‑2"
    },
    {
      "id": "2706d054-122f-4a83-94d3-c9b19038c3df",
      "text": "Open letter and media coverage by scientists arguing for recognition of airborne transmission (239 scientists)"
    },
    {
      "id": "36946f31-0798-432a-b6f5-53f99b080734",
      "text": "FDA emergency use authorization of the Pfizer‑BioNTech COVID‑19 vaccine for children 5–11, sparking public debate about pediatric vaccination schedules"
    },
    {
      "id": "a09ffa5c-ddba-4c36-9336-1e74696e9105",
      "text": "Peer‑reviewed immunology review concluding there is no evidence that recommended vaccines 'overload' or weaken infants' immune systems (literature on 'antigenic overload')"
    },
    {
      "id": "6ea5a1bb-1fe2-4405-8e70-ca7cb8012135",
      "text": "U.S. officials publicly rejected or expressed serious concerns about Poland's proposal to transfer MiG-29s via a U.S. base, citing escalation and alliance complications."
    },
    {
      "id": "35802410-2120-432e-a966-e73755191cc3",
      "text": "Polish government and analysts documented and warned about sustained Russian disinformation campaigns targeting Poland after the start of the war in Ukraine."
    },
    {
      "id": "0bb21a62-d4f7-459a-b582-17d7077bec94",
      "text": "Open-source documentation (Oryx) and media reports catalogued numerous photographed and video-documented losses of Ukrainian equipment (including Western-supplied systems) during 2022."
    },
    {
      "id": "147fbe63-1b55-4169-9c46-c0e320e92d21",
      "text": "30 November 2018: Ukraine announced a ban on entry for Russian men of military age (reported by multiple outlets)."
    },
    {
      "id": "31c21d42-48d3-4ff9-a7b1-3b2da97242bc",
      "text": "June 2019: Russian president Vladimir Putin signed a decree simplifying the procedure for residents of Donetsk and Luhansk to obtain Russian passports (accelerated 'passportisation')."
    },
    {
      "id": "f863d674-bb62-45b0-88aa-140c964047c2",
      "text": "August 2014: Large-scale displacement from Donbas with thousands crossing into Russia during the summer 2014 fighting."
    },
    {
      "id": "a8650c12-bd32-446f-97a6-67fe735cb4f2",
      "text": "U.S. government purchase agreement announced earlier in July 2020 (Pfizer/BioNTech $1.95B deal for 100 million doses) linking Pfizer to federal vaccine procurement."
    },
    {
      "id": "3e164c73-1d27-4225-a4cf-4558189223bd",
      "text": "Pfizer and BioNTech press release announcing their vaccine candidate was >90% effective in interim Phase 3 analysis"
    },
    {
      "id": "c3994da9-9d30-4cf2-8bd2-c4fae3919464",
      "text": "Reporting on Pfizer's funding sources and relationship to Operation Warp Speed that highlighted nuance (e.g., Fortune/other Nov 9, 2020 pieces saying Pfizer did not take OWS R&D funding but had U.S. supply deals)."
    },
    {
      "id": "44257917-be31-4c40-860c-9253f4dfe5f6",
      "text": "Ukrainian Central Election Commission (CEC) formally listed electoral districts and polling stations in Donetsk and Luhansk where voting would not be organized for the 2019 presidential election."
    },
    {
      "id": "a86c33ef-0961-4a4b-b386-c0afb307ca26",
      "text": "Historical precedent of electoral disruption in eastern Ukraine (2014): pro-Russian militants previously occupied or disrupted polling stations and seized ballot materials in Donetsk and Luhansk during earlier elections."
    },
    {
      "id": "ea7fa834-93eb-417d-8c19-1a32fa6fc323",
      "text": "Pro‑Russian protesters seized regional government buildings in eastern Ukraine"
    },
    {
      "id": "c4be31f8-b067-4d84-a740-33099a4ad1ad",
      "text": "Delivery of a $2 billion Russian credit to Ukraine was delayed"
    },
    {
      "id": "502d2682-d775-4d0c-a054-5cc48fbc722e",
      "text": "Unmarked (Russian) troops and seizures in Crimea disrupted Ukrainian military units"
    },
    {
      "id": "b5d04b72-b082-4875-ac37-416d3e8ab195",
      "text": "Interim Ukrainian government formation delayed, creating administrative uncertainty"
    },
    {
      "id": "b08c2c0c-4d30-480a-b095-f8bf6fdc0d4c",
      "text": "Ukraine's currency (hryvnia) plunged after central bank policy change"
    },
    {
      "id": "ec6202e2-c5da-4ca9-9c80-19a8c4f5df38",
      "text": "U.S. COVID-19 vaccine reporting rules tied to Emergency Use Authorization: healthcare providers were required to report all serious adverse events and certain other events to VAERS (policy in effect since the COVID EUA rollout, December 2020 onwards)."
    },
    {
      "id": "7c07149e-0c8b-4886-a2b3-c830e7e08b9f",
      "text": "Public availability of raw VAERS datasets and third-party dashboards (VAERS data downloadable and publicly accessible since the system's creation)."
    },
    {
      "id": "60d11947-1ee3-4a64-9896-45b120df033a",
      "text": "Japan's Ministry of Health, Labour and Welfare approved ARCT-154, the first commercial self-amplifying (saRNA) COVID-19 vaccine (CSL/Arcturus)."
    },
    {
      "id": "e163903f-04ee-4409-9f45-b8aa604b3413",
      "text": "Japan paused and recalled some Moderna COVID-19 vaccine lots after discovery of foreign (stainless-steel/black) particles in vials at vaccination sites (investigation and voluntary recall reported)."
    },
    {
      "id": "0455a97a-fd77-40f2-a5a7-e14f0b27c5c2",
      "text": "UN Human Rights Monitoring Mission report noting an inflow/presence of \"foreign fighters\" in eastern Ukraine"
    },
    {
      "id": "3fd36b82-7c7e-4ee7-b8a7-e201b53263c4",
      "text": "Death of Isa Munayev, commander of the Dzhokhar Dudayev (Chechen) battalion fighting for Ukraine (killed near Debaltseve)"
    },
    {
      "id": "3550264d-3a3a-4421-9827-eeef6d8bed16",
      "text": "New York Times article: \"Islamic Battalions, Stocked With Chechens, Aid Ukraine in War With Rebels\""
    },
    {
      "id": "9af8c9fd-d1ba-4776-b745-76d6c56d08fc",
      "text": "CBC News coverage (Apr 2012) of University of Windsor research and a $157K grant for 'cancer‑killing dandelion tea'"
    },
    {
      "id": "271671d9-d9f0-4701-acb9-ebf12b3d4d51",
      "text": "2012 PLOS ONE study showing dandelion root extract induces apoptosis in leukemia (CMML) cell lines"
    },
    {
      "id": "e3dceb77-f7bd-460f-9054-fcbbc021f866",
      "text": "Research on cognitive impairments in chronic tinnitus patients (e.g., 'The characteristics of cognitive impairment in subjective chronic tinnitus', PubMed 29541537, 2018)"
    },
    {
      "id": "6249d787-d536-4b0e-bfbb-86aa83694f66",
      "text": "Lancet Commission report 'Dementia prevention, intervention, and care' identifies hearing loss as a major modifiable dementia risk factor"
    },
    {
      "id": "fb63438f-dc9c-4e56-be6b-4dd7cf6837fb",
      "text": "Local reporting documented a sharp rise in COVID-19 hospitalizations in Jacksonville and UF Health Jacksonville reported 175 hospitalized with COVID-19 (July 26, 2021)."
    },
    {
      "id": "b1b37881-0460-450f-9656-568a14bbc224",
      "text": "Public Health England / UKHSA technical briefings (mid-2021) showing many COVID cases and deaths among vaccinated older adults that were widely shared without age‑adjustment context"
    },
    {
      "id": "11364990-cd4e-4992-824e-ea8bff3d869b",
      "text": "Large case surges in highly vaccinated countries (example: Israel, summer 2021) that circulated widely on social media suggesting temporal link between vaccination campaigns and rising infections"
    },
    {
      "id": "9cf74e25-9924-4266-bdda-c3b792219632",
      "text": "Early Omicron reporting (Dec 2021) showing large reduction in vaccine protection against infection"
    },
    {
      "id": "75f0b194-74a7-49de-858f-7ef0259e6771",
      "text": "2019 CDC shutdown of biosafety operations at Fort Detrick (US Army medical research lab) after safety inspection"
    },
    {
      "id": "53f866a2-6e47-48b6-9ce5-afdce3518b0d",
      "text": "President Biden orders U.S. intelligence agencies to 'redouble' investigation into COVID-19 origins"
    },
    {
      "id": "7579cb22-cd0f-4ca0-96cf-f1896ed7914f",
      "text": "Reports that California lawmakers planned to introduce legislation to end personal-belief vaccine exemptions in response to the outbreak."
    },
    {
      "id": "c7be7841-96cf-4b23-9c1c-46477853c367",
      "text": "CDC Health Alert Network (HAN) advisory announcing a U.S. multi-state measles outbreak linked to Disneyland theme parks."
    },
    {
      "id": "0d7a1eb6-374d-42c5-a792-5330c955b1e5",
      "text": "US Operation Atlantic Resolve deployed rotational armored units (tanks/Bradleys) into Eastern Europe (to reassure NATO)"
    },
    {
      "id": "6f02c190-25e0-4fce-a84e-81944124ad81",
      "text": "OSCE SMM reported observing unmarked convoys and multiple tanks operating in Donetsk/Donbas territory"
    },
    {
      "id": "b8661f52-58e5-4305-87f5-ca659edf9304",
      "text": "Reporting of foreign volunteers and irregular fighters in Donbas (documented by major outlets)"
    },
    {
      "id": "b07caca7-03ba-4311-a1d1-a85a8814fca4",
      "text": "Russian and pro‑Kremlin media/public figures repeatedly alleged Western/NATO involvement (including claims of NATO personnel/equipment in Ukraine)"
    },
    {
      "id": "40a75594-3952-4884-a0d6-443085589381",
      "text": "The MV Rhosus delivered and was detained with 2,750 tonnes of ammonium nitrate in Beirut after an unscheduled stop."
    },
    {
      "id": "84387a4d-e511-45af-a35a-ed52ac000f82",
      "text": "Viral videos show Italians performing coordinated gestures (singing/dancing) on balconies during lockdown (mid‑March 2020)"
    },
    {
      "id": "ef847f2b-0c64-4ca5-ad89-cda8af0b35cd",
      "text": "IEA publishes 'Electricity Grids and Secure Energy Transitions' calling for major transmission build-out and doubling of power-system flexibility needs to 2030."
    },
    {
      "id": "90e5876a-ce2f-4e79-86e4-791b5196ea9d",
      "text": "European Commission publishes the EU Offshore Renewable Energy Strategy recommending cross-border planning and consideration of a more 'meshed' offshore grid and hybrid projects."
    },
    {
      "id": "5ef29add-5e93-442f-b2d9-1b0ae2ad3aff",
      "text": "U.S. DOE publishes 'Microgrid Overview' fact sheet describing microgrids as entities that can operate grid-connected or in island (isolated) mode."
    },
    {
      "id": "180cc7a3-c694-4485-a9ce-4c90d0ce1988",
      "text": "NREL publishes a 'Research Roadmap on Grid‑Forming Inverters' and related analyses explaining that high shares of inverter‑based resources require new inverter controls and grid‑forming capabilities for stability."
    },
    {
      "id": "f1df6fcd-82a8-4f29-862b-b17d197720dd",
      "text": "TenneT proposes a 6-GW North Sea 'hub' / wind power booster and publishes plans toward a meshed offshore transmission approach."
    },
    {
      "id": "b24bad6a-9fd6-4823-8d2b-0d5fea798256",
      "text": "Russian authorities repeatedly detained Ukrainian civilian fishermen and ships in the Sea of Azov (reported detentions of Ukrainian fishing crews)."
    },
    {
      "id": "4e4e81da-6501-4c86-a385-5525a45585fa",
      "text": "Russian troops and pro‑Russian forces seized multiple Ukrainian navy vessels and naval bases during the 2014 Crimea annexation (including the capture of three Ukrainian warships)."
    },
    {
      "id": "32edd82e-0217-4813-bec8-1a1dce864bf3",
      "text": "Advisory Referendum Act (Wet raadgevend referendum) had recently entered into force (1 July 2015) enabling citizen-initiated national referendums"
    },
    {
      "id": "53a61ac2-5f7b-41dd-bb0e-e5a7d2c4c0db",
      "text": "Prime Minister Mark Rutte calls the referendum 'disastrous' and says he is 'totally, totally, totally against referendums'"
    },
    {
      "id": "00d72ee4-c25c-4509-ab7e-63cb9ee79800",
      "text": "Large, highly visible arrival of Ukrainian refugees into Italy in March–April 2022 (Italian draft plan to take up to 175,000 and steadily rising refugee numbers reported)."
    },
    {
      "id": "16d5f277-e1c8-4439-a591-3bfea8c06823",
      "text": "March 2017: The World Meteorological Organization added asperitas as a recognized cloud feature in the updated International Cloud Atlas."
    },
    {
      "id": "5eb4a6c0-107d-4b2f-a23d-dee9a04242cb",
      "text": "Longstanding practice of sending Ukrainian spent nuclear fuel to Russia for reprocessing (and return of reprocessing waste)"
    },
    {
      "id": "4f97be6d-c6d5-4fd2-8649-0bdd2f1fb2e0",
      "text": "Holtec (project contractor) published confirmatory functional testing of ISF‑2 interim spent fuel storage at Chernobyl (technical milestone)"
    },
    {
      "id": "956b3170-294c-47bc-849e-3345201fda22",
      "text": "Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers"
    },
    {
      "id": "fc4649f8-8e16-4c02-aece-aedcfdeef725",
      "text": "NOAA/NCEI global climate reporting for 2021 (annual analysis released Jan 2022) showing year-to-year variability and La Niña-linked cooling influence"
    },
    {
      "id": "b7724a1f-eea6-474c-b701-2f031cf9fc56",
      "text": "Publication of Karl et al. (2015) and the 'hiatus' data-adjustment debate (NOAA/Science) that revised surface temperature trends"
    },
    {
      "id": "7207fa75-c0f2-435b-9696-7acee5f2af99",
      "text": "CDC FluView weekly surveillance report (Week 41, data through Oct 16, 2020) showing unusually low influenza activity and low percent-positivity in respiratory specimens"
    },
    {
      "id": "b1622aae-b90f-470f-bfe8-51c55bed106b",
      "text": "Adoption of Ukraine's 'decommunization' laws in April 2015 and subsequent municipal actions to remove or rename Soviet-era symbols and monuments."
    },
    {
      "id": "c60d8400-68ef-4604-95a2-0f5b96a38f78",
      "text": "Widespread toppling and removal of Soviet-era monuments during and after Euromaidan (2013–2014) — high-profile removals of Lenin statues and related coverage created a recent precedent for 'monuments being taken down'."
    },
    {
      "id": "358c93bf-c503-4f8a-9709-78f3c5027f02",
      "text": "Reports and imagery documenting heavy fighting, civilian deaths and damage in Hostomel and nearby areas during the Russian offensive (March–April 2022)"
    },
    {
      "id": "71aa2d9f-ab06-45e7-97cf-248cb50efd98",
      "text": "Discovery and wide circulation of video and photo evidence showing dozens of dead civilians in Bucha (near Kyiv)"
    },
    {
      "id": "e5037d73-ad6a-403c-8a6a-a405132eecc3",
      "text": "Advocacy/analysis note and reports on voting rights of internally displaced persons (IDPs) in Ukraine noting ~1.4 million registered IDPs and barriers to their participation in local elections (reports circulated February 2019)."
    },
    {
      "id": "2290ebe9-b56d-4b7f-a27d-1990eac79898",
      "text": "Central Election Commission (CEC) announced that presidential voting would not be organized in Crimea, Sevastopol and parts of Donetsk and Luhansk (list of districts where vote will not be held)."
    },
    {
      "id": "5853bc70-e5ff-4c09-ada0-041fe0401e19",
      "text": "Guides and reporting on practical difficulties for Ukrainians voting abroad ahead of the 2019 presidential vote (limited polling stations, complex registration procedures noted in Feb 2019 coverage)."
    },
    {
      "id": "99b6d9fc-3cbd-43dc-b069-102f955ba2f9",
      "text": "Poland announced it would stop new weapons transfers to Ukraine"
    },
    {
      "id": "d8d5b1d1-97cf-4035-b4bf-d3121364b428",
      "text": "Poland and Ukraine entered a bitter grain-dispute diplomatic row (restrictions on Ukrainian grain)"
    },
    {
      "id": "c52ddb05-8e7a-4b12-a26d-91c6987d7438",
      "text": "Hungary vetoed/blocked a major EU aid package for Ukraine at an EU summit"
    },
    {
      "id": "46d547f9-9df8-47c2-9248-ec0c9873a7db",
      "text": "Diplomatic expulsions and mutual espionage accusations between Hungary and Ukraine (spy scandal)"
    },
    {
      "id": "5135b149-7874-4048-9faa-aa7e73afbd47",
      "text": "December 2021 reporting and market data (SPINS / Whole Foods coverage) documenting a rapid consumer boom in adaptogen supplements (ashwagandha, reishi, etc.)."
    },
    {
      "id": "7075c1bb-4e96-4d35-9f62-d6e8832d3809",
      "text": "Publication of a 2021 peer-reviewed review summarizing preclinical anti‑cancer activity of curcumin but concluding clinical evidence is limited."
    },
    {
      "id": "afdb0635-2d31-45b9-937f-b7b6970f99df",
      "text": "FDA public enforcement and health‑fraud warning letters in 2019 targeting unapproved ozone medical claims and other alternative 'therapies'."
    },
    {
      "id": "d681260c-e06e-4422-826a-30eb58a9eeae",
      "text": "Publication and widespread citation of Mayo Clinic / NEJM-era randomized trials (1985) showing high‑dose vitamin C had no benefit in advanced cancer patients."
    },
    {
      "id": "5b7868af-db6b-4e90-bdce-140b83805c8b",
      "text": "Government legal actions and sanctions against Poroshenko and his circle in early 2022"
    },
    {
      "id": "f4c67b8f-f721-4b6d-b214-82b231ed674d",
      "text": "Poroshenko appears in combat role and publicly joins territorial defence units after Russia's full-scale invasion"
    },
    {
      "id": "571ef3b1-218a-41ea-ba3a-184082016906",
      "text": "Public statements by Crimean authorities (Sergei Aksyonov) saying Crimea would refuse Ukrainian electricity even if restored"
    },
    {
      "id": "f1dbfefe-5e9e-4e2c-ac33-07a571ea1f31",
      "text": "Reporting in August 2021 that the UK government and advisers were preparing/considering booster programmes (coverage of policy options and possible mass booster rollouts for older adults and vulnerable groups)."
    },
    {
      "id": "75fb3ff2-7efa-498c-aed9-04cad1e8e90b",
      "text": "WHO publicly called for a moratorium on widespread booster campaigns on August 4, 2021, arguing doses should be prioritized for unvaccinated populations globally."
    },
    {
      "id": "c8e2dcdc-113e-4f0a-89e7-af844b5e74c1",
      "text": "Israel announced it would offer a third (booster) COVID-19 dose to people aged over 60, becoming one of the first countries to roll out a booster programme."
    },
    {
      "id": "52439a57-ace8-4f0e-a58e-2ea25ed850ba",
      "text": "CDC published an MMWR (July 2021) on a large July outbreak in Barnstable County, Massachusetts, in which a high proportion of identified cases were among fully vaccinated people (Delta-driven breakthrough infections)."
    },
    {
      "id": "3fc6ab64-6a58-46dc-88a1-5eba220a3e07",
      "text": "Pfizer/BioNTech published initial data and public statements in July 2021 highlighting a planned booster program and that a third dose substantially increased neutralizing antibody titers."
    },
    {
      "id": "6eb14920-b3ef-47c3-a818-d5a00297bbe7",
      "text": "Reports and satellite data show reduced air pollution over northern Italy after lockdowns"
    },
    {
      "id": "6b48c1d9-1669-429c-af35-4b0d572ba8be",
      "text": "Satellite images show sharp drops in NO2 over China during lockdowns"
    },
    {
      "id": "0db32998-01ec-430e-939a-655122441935",
      "text": "Climate strikes and mass mobilizations moved online or were paused (Fridays for Future/Greta Thunberg urged digital action)"
    },
    {
      "id": "c2c8ab49-308c-4b42-85b2-6fd772d339e7",
      "text": "WHO declares COVID-19 a pandemic"
    },
    {
      "id": "47da981d-850b-44ac-a0d6-c94219998be6",
      "text": "CDC and US advisory panels publishing VAERS-based myocarditis reports and guidance (MMWR/ACIP reviews in June 2021) acknowledging myocarditis reports after mRNA vaccination while concluding benefits outweigh risks."
    },
    {
      "id": "2b2b9ca9-f40d-425e-8561-7b063b8b887f",
      "text": "IPCC Fifth Assessment Report (AR5, WG1) release and SPM (2013) noting short-term variability and model/observation differences"
    },
    {
      "id": "e1156b4d-4874-489c-89a7-ebb6555f0b26",
      "text": "NOAA/Karl et al. Science paper and NOAA press release revising observational records (June 2015)"
    },
    {
      "id": "c81b5cbd-4f13-4372-be7c-e7e77aa70d19",
      "text": "Testimony by John R. Christy to U.S. House committee (December 11, 2013) arguing climate models exaggerate warming"
    },
    {
      "id": "c859396c-60e7-430e-bbd1-6f173c056c6a",
      "text": "Germany's federal and state health ministers decided to restrict routine use of the AstraZeneca vaccine to people over 60 following blood‑clot concerns."
    },
    {
      "id": "7c073262-b778-4ca0-95cb-b243b7982ffb",
      "text": "Japan recalled and halted distribution of some Moderna COVID-19 vaccine doses after contamination/foreign particle reports were detected in early August 2021."
    },
    {
      "id": "3913c195-df6f-46a1-a77b-234d06be4e5d",
      "text": "Public safety reports and media coverage in spring 2021 highlighted suspected deaths and serious adverse events reported after COVID-19 vaccination in Germany (data summarized by the Paul‑Ehrlich‑Institut and discussed in studies/media)."
    },
    {
      "id": "5acea283-52dc-4be7-af91-1351ea96ad69",
      "text": "Duda visited the Bykivnia National Historic Memorial / Polish war cemetery near Kyiv during the October 2020 trip"
    },
    {
      "id": "f735f149-adea-40bb-85b9-e39ed7f943b6",
      "text": "Andrzej Duda's previous public statements and commemorations framing the Volhynia killings as ethnic cleansing/genocide (past ceremonies and remarks)"
    },
    {
      "id": "c399ffed-e74d-4781-8755-ff6d46ccfcb6",
      "text": "Duda and Zelensky signed a joint declaration and attended economic events in Odesa during the October 2020 visit"
    },
    {
      "id": "4874937d-d2a4-4b84-be8e-078fc60273ee",
      "text": "UN Secretary-General Ban Ki-moon publicly expresses concern about the Crimea referendum"
    },
    {
      "id": "c965ed77-55a5-4f50-85d6-97b66474f50b",
      "text": "CDC and ACIP public reports (June 2021) documenting increased reports of myocarditis/pericarditis after mRNA COVID‑19 vaccination in younger males and recommending continued monitoring."
    },
    {
      "id": "6b7ea435-638a-4b49-a8ac-7dc2acf3df98",
      "text": "Contamination and recall incidents in Japan involving Moderna vaccine vials (stainless‑steel/black particles) reported widely in media."
    },
    {
      "id": "881a9b4e-f791-4953-8c1f-94e0fdf4e503",
      "text": "EMA publication of the Comirnaty (BNT162b2) public assessment report including preclinical biodistribution and safety data."
    },
    {
      "id": "9e666dbe-591b-4fc1-8a5d-cbbfca6652ad",
      "text": "IPCC Fifth Assessment (AR5) and associated carbon‑cycle graphics made public (figures showing large natural CO2 fluxes compared to anthropogenic fluxes)"
    },
    {
      "id": "2ef1b714-3d18-4370-a67e-499877b45151",
      "text": "Russian MP Vladimir Zhirinovsky sent letters proposing the division of Ukraine and suggested neighboring countries (including Poland) could take western regions."
    },
    {
      "id": "d41efa9d-b94c-413e-8a82-a278a1b220c4",
      "text": "Polish officials publicly denied any territorial claims and reiterated support for Ukraine (coverage: 'Lviv is Ukraine'—Warsaw assures it has no territorial claims)."
    },
    {
      "id": "52ab28d1-e615-4350-9e4d-8080034e84e0",
      "text": "American College of Pediatricians (ACPeds) January 2016 statement raising concerns about polysorbate 80 in the HPV vaccine"
    },
    {
      "id": "9a091402-3c03-4297-9d34-3435e1bc34b2",
      "text": "Manufacturer label for Amphastar/Phytonadione injectable lists excipients (e.g., polysorbate 80, propylene glycol) in some formulations"
    },
    {
      "id": "7dc86030-7a19-4350-a39f-49cdfa360c00",
      "text": "ACRIM–PMOD Total Solar Irradiance (TSI) composite controversy and Fröhlich PMOD revision (mid-2000s)"
    },
    {
      "id": "582f74d4-d5ef-4fe1-8c27-f7ebb9b7b1eb",
      "text": "Scafetta papers arguing a large solar contribution to recent warming (e.g., 2009 empirical analyses)"
    },
    {
      "id": "48c4a319-7cf0-4fd0-bc09-68cd21f0626e",
      "text": "Release of the NIPCC/Heartland 'Nature, Not Human Activity, Rules the Climate' summary (NIPCC)"
    },
    {
      "id": "2d1e731f-a3c2-4528-b58a-449901a76c18",
      "text": "Publication of Soon & Baliunas 'Proxy climatic and environmental changes of the past 1000 years' (Climate Research)"
    },
    {
      "id": "bde590cd-9b48-4b9b-b5f0-8bce36a24ff3",
      "text": "Ukraine enacted gas-market reforms in 2015 (Gas Market Law, IMF-backed liberalisation) moving to market-based pricing (law effective 1 Oct 2015)."
    },
    {
      "id": "a0907cde-a1ec-40f3-9787-912b1d3b935d",
      "text": "Naftogaz disclosed it procured all imported gas in 2016 from 15 European suppliers and published average Q1 2016 import price (~$198 per 1,000 m3)."
    },
    {
      "id": "2ac0eef9-cde6-4446-a483-d338c3dd199b",
      "text": "Reporting showed Poroshenko's approval ratings and political standing were weak in early April 2016 (analysis reported 7 April 2016)."
    },
    {
      "id": "4c5f8bce-dd61-44b7-b834-9cdbf9da9728",
      "text": "Russian and other foreign/state-aligned media amplified the Dutch result as evidence of Western unreliability on Ukraine (analysis and commentary in days after the vote, e.g. Financial Times 8 April 2016)."
    },
    {
      "id": "79fbeb52-b612-4dd7-a96a-b3dab751bc62",
      "text": "Ukraine experienced visible political instability in early 2016 (Prime Minister Arseniy Yatsenyuk resigned/was asked to resign and government survived no-confidence votes in February 2016)."
    },
    {
      "id": "c2a1619b-1e8a-4cc4-bad3-e513b4662d11",
      "text": "Dutch advisory referendum rejected the EU–Ukraine Association Agreement (61% against) on 6 April 2016."
    },
    {
      "id": "defc77ff-cbfc-48bd-8b8c-c94b79d5d3ee",
      "text": "U.S. Secretary of State discussions tying sanctions relief and diplomatic pressure to implementation of Minsk political measures (Kerry remarks, 2015)"
    },
    {
      "id": "c3383913-b97c-4698-bc6e-dfa86f94252e",
      "text": "U.S. leaders publicly ruled out direct military intervention in Ukraine (statements from 2014)"
    },
    {
      "id": "9b91b525-00e7-4e48-a008-f8b5f09e52cd",
      "text": "BMJ commentary highlighting that pregnant women were routinely excluded from COVID‑19 vaccine trials (and calling for their inclusion)."
    },
    {
      "id": "b7ea1cf0-ee58-4c87-816e-4f6b0a636fc5",
      "text": "Pfizer/BioNTech press release (Nov 9, 2020) announcing interim Phase 3 efficacy results for their mRNA vaccine encoding the SARS‑CoV‑2 spike protein."
    },
    {
      "id": "3907e1af-90e2-482f-a144-f7748e0038c9",
      "text": "UK government / ONS releases reporting ~945,000 people self‑reporting long COVID in July/August 2021 (publication 5 August 2021)."
    },
    {
      "id": "e2a23296-e072-49f1-9153-9cb10c17f747",
      "text": "Early cohort studies (e.g., Lancet 6‑month outcomes, Jan 2021) reported wide-ranging, multi‑system persistent symptoms with unclear mechanisms."
    },
    {
      "id": "26e695e0-9c2a-4dd4-9ff2-b9e3b46338ea",
      "text": "WHO published a clinical case definition of post‑COVID‑19 condition (long COVID) using Delphi consensus, noting heterogeneous symptoms and lack of a single diagnostic biomarker."
    },
    {
      "id": "5ddf863e-80ba-40a7-9326-35d6a8d80405",
      "text": "OSCE Special Monitoring Mission reports and situation updates documenting mines, UXO and restricted access along roads and rail in Donbas (2015 SMM reporting)."
    },
    {
      "id": "f0065d0f-c46a-428f-9a5a-a696aeb5fac5",
      "text": "Mine Action Review and national mine‑action reporting showing large-scale anti‑personnel/anti‑vehicle mine contamination in eastern Ukraine (Clearing the Mines report, 2017)."
    },
    {
      "id": "af25c83d-0d32-4118-9d9f-19e0080c4a84",
      "text": "2014 Russian 'humanitarian' convoy and other cross‑border convoys/shipments that entered eastern Ukraine without Kyiv's full control."
    },
    {
      "id": "5a85052e-a1b7-4165-8b2a-69c906c41b16",
      "text": "Analyses of Russian information operations documenting rapid, repetitive amplification tactics (the 'firehose of falsehood' model)."
    },
    {
      "id": "472106a5-95aa-4a0c-86fd-4bbc45da01cf",
      "text": "Politico reporting (April 29, 2025) that several major European leaders declined Ukrainian President Zelensky's invitation to Kyiv on May 9."
    },
    {
      "id": "5d182855-0f10-4b73-a406-7cb2a6b5d3e3",
      "text": "Berliner Zeitung opinion column titled 'Herr Merz, zeigen Sie Mut – fliegen Sie am 9. Mai zu Putin nach Moskau!' urging Merz to fly to Moscow for Victory Day (op-ed)."
    },
    {
      "id": "34420d7f-cff5-4569-84cd-74b4c1264c12",
      "text": "Kremlin announcement (May 6, 2025) that 29 foreign leaders had been invited / would attend Moscow's Victory Day parade."
    },
    {
      "id": "8f8d57ad-bace-4ecc-ba07-a75b5b70cabe",
      "text": "Reuters reporting (Feb 20, 2025) that Friedrich Merz had been targeted by a coordinated pro‑Russian disinformation network during the German election period."
    },
    {
      "id": "3f9258dc-40b2-4707-87e0-17ccef7ddc3c",
      "text": "Official public-health recommendations for widespread mask use (CDC guidance published April 3, 2020)."
    },
    {
      "id": "a1d5fb20-590f-45a2-994a-6de1aef1ae6f",
      "text": "High-profile news coverage of medical oxygen shortages during the COVID-19 crisis (notably India, April 2021)."
    },
    {
      "id": "b1c5bec7-8c75-4bfc-b1ef-03e432b736fd",
      "text": "2010 Ukrainian law under President Yanukovych formalized a non‑aligned/neutral foreign policy position."
    },
    {
      "id": "6f8e99cb-9eac-42f8-baaf-7d5fb1ec4b66",
      "text": "Key NATO allies (notably Germany and France) opposed offering a Membership Action Plan for Ukraine at the 2008 Bucharest summit."
    },
    {
      "id": "78c6dc0a-7aef-495a-a9fb-b652131b9a52",
      "text": "Earlier (2017) Mawson pilot study reporting similar vaccinated vs unvaccinated differences"
    },
    {
      "id": "542b87db-3865-4252-ab38-1fef10e84787",
      "text": "CDC and FDA investigation and public reporting of myocarditis/pericarditis cases after mRNA vaccination"
    },
    {
      "id": "1cffb107-1569-46e6-a9e3-c0000872fae9",
      "text": "Japan suspends and inspects Moderna batches after discovery of foreign (stainless-steel/black) particles in vials"
    },
    {
      "id": "cc8b09bc-cb25-4f9c-a6b8-19f74f36a20b",
      "text": "NASA press release: 'Satellite Shows High Productivity from U.S. Corn Belt' (Goddard/JPL coverage)"
    },
    {
      "id": "a8823aaa-97b6-4788-b780-517c9261fa6d",
      "text": "Publication of Guanter et al. (PNAS) 2014 paper showing space‑based chlorophyll fluorescence detects very high peak photosynthetic activity in the U.S. Corn Belt"
    },
    {
      "id": "4c2093dd-1e8c-4155-85d3-aaffaf245046",
      "text": "U.S. and international tightening of vehicle tailpipe standards and multipollutant rules (March 2024 announcements and implementation plans)"
    },
    {
      "id": "21c8b0e0-0435-491f-81b2-87fd340173f7",
      "text": "WHO updates Global Air Quality Guidelines highlighting health risks from PM2.5, NO2 and other pollutants"
    },
    {
      "id": "86a7ac0c-e6c5-46a8-ba85-7c26b269a478",
      "text": "Investigations (2023) and NGO press releases alleging hundreds of thousands of vehicles still use defeat devices or emit far more pollution in real-world driving than tests indicate"
    },
    {
      "id": "20fb0ed2-b748-41ad-afdc-0c498f54fd95",
      "text": "2023 systematic reviews and studies linking long-term traffic-related air pollution to higher dementia and cognitive decline risks"
    },
    {
      "id": "fff1af7e-274b-4d88-8915-f7c9ff6bb7fc",
      "text": "Japan finds black/foreign particles in Moderna vaccine vials; batches put on hold"
    },
    {
      "id": "e7868079-84ab-4879-9148-df64a7f540e9",
      "text": "Japan suspends use and recalls batches of Moderna COVID-19 vaccine after detection of black/foreign particles in vials (multiple reports in early September 2021)."
    },
    {
      "id": "308b0fbb-cdf9-4b3e-bd75-a035c3989203",
      "text": "UK Health Security Agency Technical Briefing (31 Dec 2021) and contemporaneous studies reporting reduced vaccine effectiveness against symptomatic infection with Omicron and partial restoration after boosters."
    },
    {
      "id": "c93ece72-3991-47d1-a1cc-078067203fb3",
      "text": "Publication of Israeli retrospective study (Gazit et al.) reporting previously infected people had substantially lower risk of Delta reinfection than vaccinated, often cited as \"natural immunity 13 times\" stronger."
    },
    {
      "id": "f395dce6-501c-4bb2-90d3-d8e75b35a094",
      "text": "CDC / ACIP acknowledgement and published review of myocarditis/pericarditis cases following mRNA COVID-19 vaccination (summarized in MMWR)."
    },
    {
      "id": "7a2624fc-76c9-4968-a3d1-e347ecff910c",
      "text": "Zelensky's high-profile visit to Washington and his address to the U.S. Congress on 21 December 2022, in which he sought continued Western political and military support."
    },
    {
      "id": "710ccf32-7e3b-45ca-9ae2-62ce4edbceed",
      "text": "President Zelensky presented a diplomatic \"10-point peace formula\" to world leaders at the G20 summit (Bali) on 15 November 2022, emphasising diplomatic channels and international guarantees as part of a peace framework."
    },
    {
      "id": "30b128ba-4d8d-4caf-9ba0-507ade647b3f",
      "text": "Cabinet of Ministers Resolution No. 318 — allows territorial recruitment centers to serve summons regardless of registration"
    },
    {
      "id": "b922483b-ca38-4bb5-92e6-bc6d9cd8e778",
      "text": "Media coverage that Ukraine was urgently drafting reinforcements for a spring offensive"
    },
    {
      "id": "9fb0c90c-2388-4cb4-808c-cced91fe0867",
      "text": "Legal regime of martial law (authorises requisition of property for public needs)"
    },
    {
      "id": "131116cf-1869-4bd2-bd12-8dfd6249cfca",
      "text": "Official and watchdog reporting noted prior government measures and decisions restricting visible Muslim dress in sporting contexts (the 2023/2024 debate and a government decision referenced in the 2023 International Religious Freedom report regarding hijab and athletes at Paris 2024)."
    },
    {
      "id": "2a5cabbd-0f11-480f-aeb1-738c11f2f7a8",
      "text": "French authorities announced heightened security and a dedicated police escort for the 2024 Olympic torch relay, noting specific selection and protection measures."
    },
    {
      "id": "899c7e3e-ee42-45f8-877c-dade5b1e3465",
      "text": "Longstanding French laïcité law and past controversies (2004 ban on conspicuous religious symbols in public schools) and continuing national debates about secularism and visible religious signs."
    },
    {
      "id": "d9eb600f-07a9-43c2-85a1-267b40754c4a",
      "text": "Annual Environmental Working Group 'Dirty Dozen' coverage (media reporting on pesticide residues in produce, e.g., CNN coverage of 2023 list)."
    },
    {
      "id": "c691e33e-5392-482d-9b5d-8eea0f8dd4e9",
      "text": "Scientific reviews and peer‑reviewed articles showing plant‑derived bioactive compounds can modulate immune responses (scholarly reviews on medicinal plants and immunomodulation, e.g., PMC review)."
    },
    {
      "id": "ac5ef9d8-d7e6-41cc-9409-cfcf6d93f012",
      "text": "World Health Organization declared the novel coronavirus outbreak a Public Health Emergency of International Concern (PHEIC)."
    },
    {
      "id": "8ac12e53-8fc9-4794-9d71-16e590409c47",
      "text": "Public political messaging from the U.S. president and other high‑profile figures asserting the outbreak was 'under control' (e.g., Feb 26, 2020), amid increasing partisan debate."
    },
    {
      "id": "e9c713f8-7fd8-4245-9d1d-2a091b3e8c2f",
      "text": "EU guidelines on handling Schengen visa applications from residents of Crimea"
    },
    {
      "id": "b4a0c843-111a-4e9b-83ac-f24907a880e0",
      "text": "EU travel bans and asset freezes on individuals linked to the annexation of Crimea"
    },
    {
      "id": "8bad62bb-f014-4f00-8801-8cfcbf482f07",
      "text": "Published scientific and regulatory reports from 2021 documented rare cases of facial paralysis (Bell's palsy) reported after COVID‑19 vaccination."
    },
    {
      "id": "e9b1b107-a17d-41fc-9252-d6bdda1ddb67",
      "text": "WHO publication of regulatory considerations for mRNA vaccines noting evolving guidance (post‑2020 development)"
    },
    {
      "id": "5765f2af-b42b-4678-9a5f-69b58bd3a023",
      "text": "Japan suspension/recall of several Moderna COVID‑19 vaccine lots after foreign particles (stainless‑steel) were found"
    },
    {
      "id": "14be8132-51cb-4f2a-8a62-0eb16f84241b",
      "text": "Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained 24 sailors."
    },
    {
      "id": "7691c906-9452-450c-8fba-b94921dfc3e9",
      "text": "Ukraine imposed bans and broad restrictions on major Russian websites, social networks and media."
    },
    {
      "id": "ce1e79be-c15e-4b37-a0d5-c5130c80d079",
      "text": "Volodymyr Zelensky elected President of Ukraine in a landslide (defeating incumbent Petro Poroshenko)."
    },
    {
      "id": "6207eb7d-803d-456d-91b0-0a9356df9f37",
      "text": "Ecumenical Patriarchate granted autocephaly to the Orthodox Church of Ukraine."
    },
    {
      "id": "8aae4da4-c6c6-4d8e-b18e-81949526f70f",
      "text": "Ukraine deepened ties with the EU by signing/implementing the EU–Ukraine Association Agreement after 2014 (formal post‑Euromaidan pivot toward the EU)."
    },
    {
      "id": "cc516e39-1c65-4879-a641-4bfaec9fb492",
      "text": "Wuhan authorities report a cluster of 'pneumonia of unknown cause' linked to a seafood market (Huanan) and notify WHO"
    },
    {
      "id": "d928ebff-a115-453e-b7cd-a8fa8856f24f",
      "text": "U.S. CDC establishes an Incident Management Structure and begins active monitoring of the outbreak"
    },
    {
      "id": "61e1f3d9-d3e6-4680-a108-f43330a1b309",
      "text": "Wuhan Municipal Health Commission statement saying there was 'no obvious evidence' of human-to-human transmission"
    },
    {
      "id": "558474da-6058-4ea5-ade5-569c6a34175b",
      "text": "OSCE/Representative condemns killing of journalist Oles Buzina in Kyiv (16 April 2015)"
    },
    {
      "id": "8333bdd8-feac-4112-aa25-5e0b53675aaa",
      "text": "Human Rights Watch: 'Ukraine: Rebel Forces Detain, Torture Civilians' (reporting on abuses in 2014)"
    },
    {
      "id": "4d260240-ee9c-4013-95fc-adfd97d8e8ef",
      "text": "IAEA Director General Rafael Mariano Grossi confirmed 'physical impact' from drone strikes at the Zaporizhzhia Nuclear Power Plant and called the incident 'serious', noting hits on reactor-related structures."
    },
    {
      "id": "31ef5786-3116-4f8a-aea5-6e178bc400aa",
      "text": "Reuters and other outlets reported that a Ukrainian drone crashed near the Zaporizhzhia nuclear plant in early April 2023 (reported 5 April 2023 by Russian media), indicating prior drone activity in the plant vicinity."
    },
    {
      "id": "e23ae7b9-7735-4b43-9ad3-8348a3cc7a8e",
      "text": "IAEA and Reuters reporting documented earlier damage to off-site power infrastructure and backup power lines near Zaporizhzhia (notably on 7 September 2022), which affected the plant's power connections."
    },
    {
      "id": "c98bc55a-17cc-4765-9ff5-1a646cbe53fc",
      "text": "Reuters special report (Oct 2014) documenting flaws and gaps in Ukraine's investigations into the Maidan shootings"
    },
    {
      "id": "1cedc6f7-c156-4315-b1bd-f9008b4b24d6",
      "text": "Deaths of Serhiy Nigoyan and Mikhail Zhiznevsky on Hrushevskoho Street during Euromaidan (initial chaotic reporting)"
    },
    {
      "id": "30cfdcae-a082-44ff-88ed-042545fdac8f",
      "text": "Academic and analytical publications debating shooter locations and responsibility for the 'snipers' massacre (analysis circulated online in 2014)"
    },
    {
      "id": "6fa2180b-71b1-4dba-b39e-a0559c7554ea",
      "text": "Lancet Planetary Health commentary 'COVID‑19, wet markets, and planetary health' highlighting zoonotic risk at live‑animal markets"
    },
    {
      "id": "ee537e39-4429-40e3-8845-ee67ca23d544",
      "text": "Consumer watchdog reporting and class-action lawsuits against alkaline bottled-water marketing (coverage of multiple 2017–2018 suits)"
    },
    {
      "id": "c2cb8f2e-88ac-4001-b4ed-4d7207083a16",
      "text": "Scientific/dental research highlighting that some bottled beverages (including waters) have low pH and can be erosive to teeth (JADA/published research)"
    },
    {
      "id": "0b7e09d8-a27c-4fe9-b181-633946dc6ea5",
      "text": "Axios reporting (Aug 18, 2025) that White House officials asked Ukrainian counterparts whether Zelensky would wear a suit for his Aug 18 meeting with President Trump."
    },
    {
      "id": "65d3863e-ca86-4022-9d34-a133345d03fb",
      "text": "Publication of Northwestern-led JCI study (April 27, 2023) showing unresolving ventilator-associated secondary pneumonia was linked to mortality in severe pneumonia including COVID-19."
    },
    {
      "id": "599d6b90-776a-4f56-87ef-3d2d60246da0",
      "text": "Pandora Papers disclosure linking Zelensky and associates to offshore companies"
    },
    {
      "id": "b222b17a-80d4-4064-94f0-24f909d52578",
      "text": "News reporting of French aid totals to Ukraine (official French figures circulated)"
    },
    {
      "id": "af19d067-b948-47c7-98fd-27809f978e69",
      "text": "Public statements by Russian officials and the State Duma in Feb–Mar 2022 pushing narratives that Zelensky had 'refused' Minsk or was open to concessions, and urging Russia to legitimise breakaway regions"
    },
    {
      "id": "8df23cbc-2b04-4468-8a18-14731f0017fb",
      "text": "Zelensky's March 8, 2022 address to the UK Parliament / House of Commons in which he appealed for stronger Western action (including implied criticism of slow/no‑fly‑zone decisions)"
    },
    {
      "id": "0fc47699-b995-470d-a364-c3f6358a2b00",
      "text": "Russian recognition of the self‑proclaimed Donetsk and Luhansk People's Republics (DPR/LPR) and related escalatory diplomacy in late February 2022"
    },
    {
      "id": "34978d71-5cd6-4bcc-b8fb-1af8ab14cf93",
      "text": "U.S. FDA issues consumer warning against using veterinary ivermectin to treat or prevent COVID‑19 (consumer update)"
    },
    {
      "id": "8ddf5fc5-3bf5-41e0-95af-544f8ff32143",
      "text": "Pierre Kory testimony to U.S. Senate Homeland Security committee advocating ivermectin as an 'early treatment' (video + written testimony)"
    },
    {
      "id": "b1b0f19e-2187-4758-9f75-14aac08259e9",
      "text": "WHO identified vaccine hesitancy as a top-10 global health threat (2019) and warned about misinformation undermining vaccination programs"
    },
    {
      "id": "5709690d-c5cc-4770-a64c-a2fc10bc7c7a",
      "text": "Gunmen attacked polio vaccination teams (and their police escorts) in the region, including a December 2019 attack in Pakistan that killed police escorting vaccinators"
    },
    {
      "id": "7da30077-3d2d-4fe1-8c1b-fd241f74ec38",
      "text": "Several European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine over reports of rare blood clots"
    },
    {
      "id": "e8de1b7e-6b74-4c3f-b3ac-e16793d17d46",
      "text": "Multiple incidents of healthcare workers being spat at, harassed or attacked in India during the early COVID-19 pandemic"
    },
    {
      "id": "4975ed13-95c3-4dfd-817a-d35b4508e64f",
      "text": "Hungary and other neighbouring states publicly protested Ukraine's education/language measures and Hungary blocked NATO-Ukraine commission meetings in protest (April 2018)."
    },
    {
      "id": "d5983009-517d-4c25-8d0b-45531de5eacf",
      "text": "Nationwide implementation phase began for the education reform shifting instruction toward Ukrainian (mass implementation from 1 September 2018)."
    },
    {
      "id": "e79c9566-b494-4c71-85a7-fe6f8ab5c57e",
      "text": "Verkhovna Rada adopts the Law 'On ensuring the functioning of Ukrainian as the state language' strengthening Ukrainian's role in public life."
    },
    {
      "id": "50d01ee9-5c85-4fed-b808-8d69cdbc9da8",
      "text": "Council of Europe's Venice Commission issues an opinion scrutinizing the 2019 language law (plenary opinion published December 2019)."
    },
    {
      "id": "4bed780a-c77d-43f8-b6fe-392eeafaacfa",
      "text": "Strong 2015–2016 El Niño and record global temperatures (reported in early 2017)"
    },
    {
      "id": "e262fb85-8cbc-4876-9555-f8bab2f04923",
      "text": "Hurricane Milton made landfall in Florida and produced a real outbreak of tornadoes on Oct 9, 2024, causing widespread damage and intense media attention."
    },
    {
      "id": "b6750573-4fc6-4872-8536-11b5ea807dab",
      "text": "Deputy speaker Andrey Kozenko publicly claimed about 120,000 Ukrainians had visited Crimea, representing about 10% of the peninsula's tourists."
    },
    {
      "id": "bb4e58f4-c815-4b72-84c3-a13d90c6fec5",
      "text": "RIA Novosti published a report quoting Crimean officials that border crossings had to increase personnel because of a 'flood of vacationers from Ukraine'."
    },
    {
      "id": "7b4cd620-c2ee-4e4d-a396-fef2ad37c6ab",
      "text": "Boryspil International Airport workers staged strikes and picket lines over dismissals in early March 2015."
    },
    {
      "id": "f78c8c13-6953-42fb-9dba-3a217cb3704c",
      "text": "Recent intense fighting over airports (e.g., Donetsk airport battle in Jan 2015) made 'airport' a charged and symbolic setting in Ukrainian public discourse."
    },
    {
      "id": "f83d17ec-eb10-4831-acc0-dc9c4bb2de3e",
      "text": "On-camera exchange at Boryspil: Poroshenko told protesting workers 'Don't raise your voice at me, or else you'll quickly be taken out,' which some outlets portrayed as a threat of arrest."
    },
    {
      "id": "e0b2c89c-e1b7-42d0-99a7-db7173cdeb27",
      "text": "United Nations senior officials (Secretary‑General and OHCHR) publicly called for an independent investigation into the civilian killings seen in Bucha."
    },
    {
      "id": "68c6a597-9911-4249-85a2-3907f4308006",
      "text": "Russia announced it would ask the U.N. Security Council to meet over what Moscow called 'provocations' in Bucha and denied responsibility, urging investigation of alleged staging."
    },
    {
      "id": "fad79309-d414-43a1-9a9d-2d4a5d42eae3",
      "text": "International media published graphic on‑the‑ground footage and reports from Bucha (journalists and outlets entering the town after Russian withdrawal) documenting corpses and destruction."
    },
    {
      "id": "bfe4cc35-f75c-478f-8182-e7abfaa57df8",
      "text": "ICC Prosecutor Karim A. A. Khan announces opening of a formal investigation into the situation in Ukraine, but as of early April had not published a specific, on‑the‑ground Bucha investigative timeline."
    },
    {
      "id": "60ce23c3-a9cd-4599-9b3b-71a8ee7b089a",
      "text": "Ukrainian government forces launched operations and reclaimed parts of Mariupol in May–June 2014 amid heavy fighting."
    },
    {
      "id": "741b64eb-0898-424a-93e5-d57095113352",
      "text": "Battle of Ilovaisk (August 2014) and open-source analyses showing use of Russian tanks and weapons in eastern Ukraine."
    },
    {
      "id": "8b469abc-5c4b-46d0-a323-62abbf9586d0",
      "text": "Formation and deployment of the Azov volunteer battalion in May–June 2014, with operations around Mariupol."
    },
    {
      "id": "11e972ec-8fdd-4957-90ee-084529346007",
      "text": "IPCC Special Report on Global Warming of 1.5°C (SR15) emphasizing land-based mitigation options"
    },
    {
      "id": "1f20599e-7de4-440c-93e1-60e756213623",
      "text": "Launch of the Trillion Trees initiative (WWF, BirdLife International, WCS)"
    },
    {
      "id": "08af0b8f-6d64-4d24-8866-99133676279d",
      "text": "Heightened fiscal pressure and passage of an IMF‑compliant state budget in December 2015 (public calls for a 'fiscally sustainable' budget; budget package passed late December 2015)"
    },
    {
      "id": "98a69c88-4aa5-4797-9504-38a3379a6e4b",
      "text": "Parliament adopted the emergency law \"On Prevention of Financial Catastrophe...\" that amended social protection rules and changed the structure/timing of some child benefits (law adopted 27 March 2014; some provisions effective later)"
    },
    {
      "id": "243688f2-31ba-420b-bdd1-55f3774ea934",
      "text": "FDA authorization for consumer genetic testing expanded in 2018 (e.g., March 6, 2018 FDA action on 23andMe), signalling regulatory acceptance of DTC genetic information."
    },
    {
      "id": "a8b7c5e7-0626-44fb-aace-1d52e4c2fd3b",
      "text": "Publication of a clinical review: 'MTHFR genetic testing: Controversy and clinical implications' (Aust Fam Physician, 2016) documenting widespread promotion of MTHFR testing by alternative practitioners and pharmacies."
    },
    {
      "id": "7b1297ab-5862-486f-9071-4f90b1855190",
      "text": "German federal prosecutors publicly announced the arrest of three Ukrainian nationals suspected of planning parcel/explosive attacks and other acts of sabotage in Germany and Switzerland."
    },
    {
      "id": "e94d7fbd-75f0-44d3-b424-5299cb09f6f5",
      "text": "Public warnings from German domestic-intelligence officials in late 2024 that Russian sabotage and intelligence activity targeting European logistics and critical infrastructure were an ongoing threat."
    },
    {
      "id": "f2009dec-48f9-472c-8a6c-72ec907820ff",
      "text": "News coverage noting a recent string of fires and security incidents at European courier and freight depots in months prior to the arrests."
    },
    {
      "id": "b82828fb-72b4-438d-8217-b3285d06e625",
      "text": "Commander‑in‑Chief Valerii Zaluzhnyi publishes a high‑profile piece and interview in The Economist outlining that the war has entered 'positional'/stalemate phase and calling for major technological/strategic changes"
    },
    {
      "id": "b34702c2-abc2-41c6-b039-5462213ac454",
      "text": "Western press coverage highlights growing tensions and public debate over the relationship between President Zelensky and Commander Zaluzhnyi amid frustration over the stalled counteroffensive"
    },
    {
      "id": "38672460-e6a2-4e57-aa25-0580a615e984",
      "text": "Official national exit‑poll consortium (Razumkov/NI Consortia: DIF, KIIS, Razumkov) published large‑margin results showing Volodymyr Zelensky’s landslide victory on April 21, 2019."
    },
    {
      "id": "393a7139-371c-44aa-8032-069fe7cdb7f5",
      "text": "Pew Research Center survey (released July 29, 2024) showing wide partisan divisions on U.S. responsibility and support for the war in Ukraine."
    },
    {
      "id": "e9f5af32-2194-4ad4-9d31-fd32286912f7",
      "text": "House Speaker Mike Johnson repeatedly delayed or conditioned votes on Ukraine aid and publicly signaled limited appetite for further Ukraine funding among House Republicans in spring 2024."
    },
    {
      "id": "62c8ffd3-d63a-4c18-a39f-e713c858561a",
      "text": "Republican infighting and public GOP messaging in early April 2024 explicitly citing polls and voter fatigue to justify delaying or opposing further Ukraine assistance."
    },
    {
      "id": "41859453-3ca7-42e5-ab9d-59bbdf9c64f2",
      "text": "Joint Investigation Team (JIT) announced criminal investigation findings implicating a Buk missile from territory held by pro-Russian separatists (September 2016)"
    },
    {
      "id": "f41106cb-4f98-417b-97a3-ee550457e74e",
      "text": "Media coverage of shifting Russian public opinion (Levada/Moscow Times report, Feb 2020) showing changes in who Russians say is responsible"
    },
    {
      "id": "5088ae91-c41e-4b3b-92ac-10fb6253f083",
      "text": "Great Barrington Declaration (Oct 4, 2020) calling for \"focused protection\" and opposing lockdowns"
    },
    {
      "id": "f2aefb8c-88ae-4546-a2ba-f328776f4d19",
      "text": "WHO interim guidance advised masks mainly for symptomatic people and healthcare settings (interim guidance PDF)"
    },
    {
      "id": "8a4b6346-bdb7-45ab-b8e5-216e21331f64",
      "text": "CDC publicly recommended cloth face coverings for the general public (press release)"
    },
    {
      "id": "046df810-54d5-4ea9-9d48-26543a907c8c",
      "text": "China temporarily bans wildlife trade nationwide in response to the novel coronavirus (reported by Reuters)"
    },
    {
      "id": "94f80fa6-0445-46be-82c2-c6464ae6e031",
      "text": "IPBES 2019 Global Assessment report on biodiversity and ecosystem services publicly released"
    },
    {
      "id": "f56e724b-f666-418a-9641-60030e9a6e78",
      "text": "IARC (WHO cancer agency) issued a press release classifying processed meat as 'carcinogenic to humans' (Group 1)."
    },
    {
      "id": "cba76ec1-2e4f-4cc5-aaf8-8514021bc6ff",
      "text": "WHO/IARC published clarifying Q&A and statements explaining that Group 1 classifies hazard (evidence of carcinogenicity) but does not indicate the magnitude of risk relative to other Group 1 agents (e.g., smoking)."
    },
    {
      "id": "12ceeaa3-7219-4f4c-8c7f-7dd8c7b97e27",
      "text": "International Rescue Committee (IRC) and other NGOs issued warnings and reports (late Sep 2023) expressing concern about legal uncertainty and the future of support for Ukrainians in Poland."
    },
    {
      "id": "e913e2bd-7e82-4b5d-a9ff-9aa52fe9d532",
      "text": "Polish government spokesman Piotr (Piotr) Müller publicly said Poland will likely not extend special support measures for Ukrainian refugees into 2024."
    },
    {
      "id": "85be5d28-9be0-4f96-b52a-a84d13ba804c",
      "text": "Poland's Social Insurance Institution (ZUS) suspended childcare/family benefit payments for thousands of Ukrainian refugees who had left Poland."
    },
    {
      "id": "4edaedb4-1177-4c33-8fe3-a9c57ff64be5",
      "text": "Multiple news outlets (e.g., Kyiv Independent) and regional reporting reproduced Polish officials' remarks that support may be curtailed in 2024, producing headline-driven coverage in mid-September 2023."
    },
    {
      "id": "b34f9294-31af-458f-9f7a-e810c428c647",
      "text": "2015 U.S. Dietary Guidelines Advisory Committee recommended removing a quantitative limit on dietary cholesterol"
    },
    {
      "id": "cfc8dac5-eae7-44fe-b864-2482df74dca6",
      "text": "CDC/ACIP MMWR update on myocarditis after mRNA COVID‑19 vaccination and policy guidance (MMWR report / ACIP review)"
    },
    {
      "id": "76779a0a-a497-45d3-960f-6b7640ef3be9",
      "text": "Renaming of Dnipropetrovsk to 'Dnipro' under Ukraine's decommunization/renaming process"
    },
    {
      "id": "c81c8c92-df86-4bef-8972-2c3dced462e8",
      "text": "Adoption of Ukraine's 2017 education law strengthening the use of Ukrainian in schools"
    },
    {
      "id": "ff19f0b5-e0d1-47f2-99b1-fd16c13252ab",
      "text": "Pro‑Russian unrest and separatist seizures in eastern Ukraine (including activity in Dnipropetrovsk region)"
    },
    {
      "id": "2b377322-508b-4291-976a-ef44e85e47f4",
      "text": "Norwegian review of deaths in very frail elderly after Pfizer vaccination (widely reported mid‑January 2021)"
    },
    {
      "id": "780ed672-740b-42db-bbb9-1c3cfe15c884",
      "text": "FDA issues Emergency Use Authorization (EUA) for the Pfizer–BioNTech COVID-19 vaccine"
    },
    {
      "id": "44e8bf4b-1ea1-4a06-837d-f5d274fc6298",
      "text": "First U.S. COVID-19 vaccinations administered and public rollout begins"
    },
    {
      "id": "049dc814-2eea-465a-ae77-96f8303282b5",
      "text": "Press conference by Reserve Colonel Mykhailo Slobodianiuk in Lviv (March 11, 2015) in which he discussed adding additional grades/medals to the Order for Courage rather than annulling it."
    },
    {
      "id": "fdec233d-6dc1-4acd-a0fe-ee5a2450d5d2",
      "text": "Widespread toppling and removal of Soviet-era monuments across Ukraine during 2013–2014 (including multiple high-profile Lenin statue removals)."
    },
    {
      "id": "551694f8-1f83-4aae-9c9c-41e537b939b0",
      "text": "Target Malaria (a Gates Foundation‑supported research consortium) conducted the first small‑scale releases of genetically modified sterile male Anopheles mosquitoes in Bana, Burkina Faso (July 2019)."
    },
    {
      "id": "2db5c7f5-ea01-4b89-ae5e-8c37f503a871",
      "text": "Oxitec conducted pilot releases and community engagement in the Florida Keys (2021) and faced local protests over planned releases of genetically modified Aedes aegypti."
    },
    {
      "id": "a26573e7-d94c-4d97-b963-0a2f88d078a6",
      "text": "Bill & Melinda Gates Foundation publicly funded Oxitec to develop genetically engineered mosquitoes for malaria control (reported 2018)."
    },
    {
      "id": "16ee9cf2-3b9a-4256-bf89-3596588e2d8b",
      "text": "Controversy over Oxitec field trials in Jacobina, Brazil (2013–2015) culminated in 2019 scientific disputes and papers suggesting rare viable progeny/hybridization, prompting public debate."
    },
    {
      "id": "2e286ee4-f7c4-4ce4-a624-6aa5fbe4cdd1",
      "text": "ACAPS / briefings and national reports show large concentrations of Ukrainians remaining in Polish cities (May 2022 briefing)"
    },
    {
      "id": "8dd2c93f-1d8a-4a4a-ad86-633bda279731",
      "text": "Early UNHCR / IOM intention surveys (April–May 2022) reporting many refugees' immediate plans and diverse intentions to stay or return"
    },
    {
      "id": "f75f429b-c285-4736-8bb9-77a0444909b7",
      "text": "Poland introduces PESEL registration for Ukrainian arrivals, enabling access to services"
    },
    {
      "id": "d12cb5c7-b7f9-47be-b6b4-700896da05da",
      "text": "EU Council adopts Temporary Protection Directive for people fleeing Ukraine"
    },
    {
      "id": "83856f5d-cd5d-42a7-8bb8-86fc5023ba6c",
      "text": "Polish border guard reports over 2 million refugees have entered Poland since the invasion"
    },
    {
      "id": "301e6dd0-28d1-4fa7-93e7-d1e276348db1",
      "text": "China's documented prior practice of rejecting incoming grain shipments for reasons such as unapproved GMO varieties or contamination (e.g., several U.S. corn cargoes rejected in 2013)."
    },
    {
      "id": "895a1573-a6e8-42d5-b8a3-63fd2799a409",
      "text": "Ukrainian inspectors / Consumer Protection Agency reported a small detection of pests/nematodes in certain fields designated for export."
    },
    {
      "id": "90948fe5-444a-4293-8d27-d4e7b5644413",
      "text": "Human Rights Watch documents abuses by volunteer battalions and excessive detentions by Ukrainian security services"
    },
    {
      "id": "981e2b7e-9aa1-4557-9067-b3e3be09f2f7",
      "text": "OSCE Special Monitoring Mission (SMM) publishes thematic reporting and daily monitoring documenting civilian casualties and incidents in Donetsk and Luhansk"
    },
    {
      "id": "46e5b7e0-08b0-4865-b903-843b9996b895",
      "text": "Ukrainian officials and ombudsman reports attributing water supply interruptions in parts of Donetsk and Luhansk to artillery damage and actions by occupying forces (2014–2015)"
    },
    {
      "id": "1c6df9bd-4737-4ab4-82f7-3eb4f752c444",
      "text": "Power cuts and shelling halted pumping stations and water supply in Luhansk (summer 2014)"
    },
    {
      "id": "503b473d-f061-4805-be91-d667d63484bb",
      "text": "U.S. Secretary of State Antony Blinken visits Kyiv and reaffirms support but makes no commitment on NATO membership"
    },
    {
      "id": "6b2df06c-a07c-49f9-b5cc-626c29f8439e",
      "text": "Ukraine amends its constitution to enshrine EU and NATO membership aspirations (constitutional change enters into force)"
    },
    {
      "id": "69d75edd-3449-4b43-a59e-e9fd47b7ae01",
      "text": "Public opposition from major NATO members (e.g., Germany and France) to immediate Ukrainian accession around the 2008 summit"
    },
    {
      "id": "5abcc1de-96c1-448c-a6d2-4ea7fb6cf619",
      "text": "Ukrainian officials publicly warned that individuals who visited temporarily occupied Crimea or separatist‑controlled Donbas without Kyiv's permission would be banned from observing Ukrainian elections"
    },
    {
      "id": "cae0288a-9c2b-403c-8e17-3d152591cb2e",
      "text": "Ukraine's Central Election Commission had publicly registered hundreds of international observers ahead of the March 31, 2019 presidential vote"
    },
    {
      "id": "d5619de6-e379-4c21-9e41-7b82d2e9cf09",
      "text": "Verkhovna Rada passed amendments banning citizens of the Russian Federation from serving as official election observers in Ukraine"
    },
    {
      "id": "f38ee2fc-4c47-402d-9dc1-e453902b37dc",
      "text": "A specific German activist/politician (Andreas Maurer, Die Linke) who had previously visited occupied Ukrainian territories and held pro‑Russian positions was not accredited as an observer"
    },
    {
      "id": "7dd19033-9011-4652-a273-02ba7b167fbe",
      "text": "Publication of small, legitimate human moringa studies for other outcomes (e.g., 2021 randomized trial on glycemic control)"
    },
    {
      "id": "5d015e2b-e346-4f80-bbc2-2d133e230e4a",
      "text": "Peer-reviewed research and clinical-trial literature on helminth (worm) immunomodulation and 'helminth therapy' for autoimmune conditions (reviews and trials published in mid-2010s)"
    },
    {
      "id": "56b67639-9bd2-4892-a5b3-68dd79b4da68",
      "text": "Analysts and Ukrainian officials reported a sharp projected fall in spring sowing area (up to ~39% decline) because of the invasion, threatening the next harvest."
    },
    {
      "id": "f61b81e2-62fd-460d-80c9-6bf63aa9c42d",
      "text": "Russian naval blockade of Black Sea ports blocked Ukrainian grain shipments, threatening export revenue and leaving grain on vessels."
    },
    {
      "id": "62ca5e08-c759-40cb-bfe4-9e7efd707a0e",
      "text": "Sanctions and the war disrupted fertilizer and fertilizer-ingredient supplies (Russia/Belarus are major suppliers), raising alarms about reduced crop yields globally and in Ukraine."
    },
    {
      "id": "4a1d7ffd-9e6c-41be-87e9-e7b2bb5ada22",
      "text": "Reports from newly occupied areas (e.g., Kherson) of empty stores, local food shortages and looting after Russian forces captured territory."
    },
    {
      "id": "5f29be91-c5bd-4152-8198-05bf8559430f",
      "text": "Reports of long queues as Crimeans applied for Russian passports (coverage March 19–20, 2014)"
    },
    {
      "id": "12ebd395-a9a9-48a9-93d5-f22ee31eb5a0",
      "text": "Defection of Ukraine navy commander Denys Berezovsky to pro‑Russian Crimean authorities (early March 2014)"
    },
    {
      "id": "659db844-2578-4f14-a374-26004e52686d",
      "text": "Verkhovna Rada vote to repeal the 2012 language law (widely reported as a 'ban' on Russian)"
    },
    {
      "id": "3a38d6d4-0713-4982-8aff-3d58bd79458c",
      "text": "Deadly clashes and Trade Unions House fire in Odesa"
    },
    {
      "id": "65eedcdb-e7eb-4498-b22c-60af062d17cf",
      "text": "Reports of attacks, intimidation and disappearances of activists in Crimea during the March 2014 takeover"
    },
    {
      "id": "8a36bca0-072a-4757-8ae6-18b33483385b",
      "text": "Euromaidan protests, violent escalation and ouster of President Yanukovych"
    },
    {
      "id": "2da13781-4048-4b5f-b4cb-a78577f53431",
      "text": "CDC lab alert language recommending adoption of multiplex assays that can 'facilitate detection and differentiation of SARS‑CoV‑2 and influenza viruses'"
    },
    {
      "id": "8256eadd-706a-446e-a58c-9cc14fa415e9",
      "text": "CDC Lab Alert announcing it will withdraw its request for EUA for the CDC 2019‑nCoV Real‑Time RT‑PCR Diagnostic Panel"
    },
    {
      "id": "c6345b60-d5ec-4372-b335-bcf12bd680cb",
      "text": "OSCE Special Monitoring Mission reports documenting weapons, movements and indicators of cross-border support to armed groups in Donbas"
    },
    {
      "id": "b786b12a-50eb-40a8-aee4-17dbff29a504",
      "text": "FIFA precedent of suspending a national association for government interference (Kuwait suspended)"
    },
    {
      "id": "30bf0937-8a19-471d-95a6-cb0d6e8a310e",
      "text": "UEFA opened fresh disciplinary proceedings and charges related to crowd disturbances and racist behaviour involving Dynamo Kyiv (follow-up enforcement actions)"
    },
    {
      "id": "ad4528b2-4f55-499b-af2d-b03fbedd1e7f",
      "text": "UEFA bans Crimean clubs from Russian competitions and declares Crimea a 'special zone' for football"
    },
    {
      "id": "b597baf7-408d-4792-9acc-5679c205c646",
      "text": "Publication of Lennerz et al. survey of 2,029 self‑identified carnivore dieters (Current Developments in Nutrition)"
    },
    {
      "id": "966f752b-1058-43b6-b60f-d845aa2120e1",
      "text": "WHO highlights a multi‑country validation study of the OptiBP smartphone blood‑pressure application"
    },
    {
      "id": "45ecf42f-bf63-49b6-b2da-85a73193e857",
      "text": "European Society of Hypertension working‑group statement on cuffless blood‑pressure devices (review and guidance)"
    },
    {
      "id": "67cb95e5-2f8d-436a-be98-cf9a58fef5c1",
      "text": "Peer‑reviewed npj Digital Medicine study (CamBP/OptiBP) reports ISO‑aligned accuracy in select populations"
    },
    {
      "id": "ecb44f8a-8e35-467d-8ca2-17673dfd6e43",
      "text": "Approaching 30th anniversary of the Chornobyl disaster and official commemorations (Poroshenko declared 2016 'Year of Remembrance' for liquidators and victims)"
    },
    {
      "id": "62336475-296d-4838-9a8a-b833a4d4142c",
      "text": "President Petro Poroshenko vetoed law No.2093 and returned it to parliament with proposals"
    },
    {
      "id": "860124bc-f2a7-4ab6-9e29-44cc8b056d61",
      "text": "Verkhovna Rada (Ukrainian parliament) passed draft law No.2093 restoring certain Chernobyl benefits"
    },
    {
      "id": "cc7fd350-9a27-4fd5-9054-e6c7b35e05fc",
      "text": "Publication of in vitro research showing antiviral activity of Melissa officinalis extracts against some influenza strains (e.g., lab studies on H1N1 / H9N2)"
    },
    {
      "id": "cfa0a8a3-c151-4166-a74f-93d11dbf5202",
      "text": "Putin signed decree requiring buyers from 'unfriendly' countries to pay for gas in roubles."
    },
    {
      "id": "cfcd7cc0-f8b2-410a-b690-144365d976fc",
      "text": "Austrian government statement: Russian gas still flowing while Austria scrambles for alternatives."
    },
    {
      "id": "85358ada-ded2-4e3c-a579-c736936f7e8c",
      "text": "OMV (Austrian energy firm) said it had initial contact with Gazprom about rouble payment demands."
    },
    {
      "id": "dbe30528-7d99-4b74-8614-cf0c78e26962",
      "text": "OPEC (led by Saudi Arabia) decided not to cut output, triggering a sharp oil price fall"
    },
    {
      "id": "79d49a22-5863-4981-889b-19072d9fbed9",
      "text": "Kremlin and Putin publicly blamed Western sanctions and falling oil prices for the rouble slump"
    },
    {
      "id": "fd0e1ca9-5c9f-4ff3-96d7-c06309f99fb1",
      "text": "Reports Russia spent tens of billions defending the rouble in 2014 (estimates ~USD 80bn)"
    },
    {
      "id": "7fd37d9b-515e-4e44-8623-a14228b18536",
      "text": "Emergency Bank of Russia decision: key rate hiked to 17% as rouble plunged"
    },
    {
      "id": "fc9326d4-bea3-465f-8300-9c4cd0d0d64d",
      "text": "Western sanctions on Russia expanded through 2014 over Ukraine/Crimea"
    },
    {
      "id": "9758342d-846f-48e2-8b92-5eeebda6d84f",
      "text": "NOAA press release and reports (Jan 2024) documenting 2023 as one of the warmest years on record while noting the roles of greenhouse gases and natural variability"
    },
    {
      "id": "d29761e6-4997-42d1-93ea-195b123004a8",
      "text": "Peer‑reviewed opinion piece (Sherwood & Forest) in Atmospheric Chemistry and Physics (2024) discussing remaining uncertainty in equilibrium climate sensitivity (ECS)"
    },
    {
      "id": "339098bd-e1e6-4550-b6d1-60f25374586b",
      "text": "Investigative reports (April 2024) documenting widespread climate misinformation and enforcement failures on short‑form social platforms such as TikTok"
    },
    {
      "id": "2f3fc5c4-6bcf-4eac-81b9-d55526479821",
      "text": "Republican-led U.S. congressional hearings on climate science that featured skeptical expert witnesses and took place across March–April 2024"
    },
    {
      "id": "4e26b60c-4367-4953-9339-80b88881cb04",
      "text": "Ukrainian parliament actions in September 2014 approving laws on special status/self-governance and amnesty provisions related to Donbas"
    },
    {
      "id": "e43e52f7-2fa4-4458-969b-ae3a70bed2f0",
      "text": "Minsk II agreement (Package of Measures) contained an instruction to 'provide pardon and amnesty' for persons involved in events in parts of Donetsk and Luhansk"
    },
    {
      "id": "0cb5aab1-def6-45ea-a897-dd13a4fcb291",
      "text": "High-profile interviews and statements by Nadiya Savchenko urging peace talks and negotiation with separatists"
    },
    {
      "id": "b5543f8e-006b-454f-b7e4-1c6ed17817fa",
      "text": "Nadiya Savchenko's high-profile release and return to Ukraine in a prisoner swap (pardoned and flown back)"
    },
    {
      "id": "196b27e2-32f7-4bf1-b456-88904d80aec9",
      "text": "German Communist Party (DKP) launched a petition asking the Bundestag and government to lift sanctions that hinder exchange of medical supplies and cooperation during the COVID-19 crisis."
    },
    {
      "id": "c04f81b8-5be6-4f6d-b8da-32d6aa21d84f",
      "text": "Russian leadership/public diplomacy pushed a narrative that international sanctions hampered pandemic response — including Putin’s appeals at G20/UN fora to suspend some sanctions for humanitarian reasons in late March 2020."
    },
    {
      "id": "59bf1e25-ae86-4f29-97b8-78581d3d04f3",
      "text": "EU/commission reporting showed a sharp rise in applications by Ukrainians for Romanian citizenship in 2014–2015"
    },
    {
      "id": "60bf6c70-bd10-4413-b426-9d11a9653a75",
      "text": "Local media reports of a 'Constituent conference' of an \"Assembly of the Romanians of Bukovina\" in Chernivtsi allegedly deciding on autonomy"
    },
    {
      "id": "ca0212d6-7c4b-4e02-b239-11ce52df0bc4",
      "text": "Russian officials warn of a sharp increase in shelling in the Donbas and publicly blame Ukrainian forces (Russian statements about escalated shelling)"
    },
    {
      "id": "b110c694-281d-45ef-92e8-c0b9affcb346",
      "text": "Moscow says a projectile fired from Ukraine destroyed a Russian border facility (Rostov region)"
    },
    {
      "id": "0e3d2cc6-1066-48dd-a27e-244e62a48617",
      "text": "Russia launches a full-scale invasion of Ukraine (24 February 2022); Ukrainian leaders publicly vow to repel and drive back Russian forces"
    },
    {
      "id": "bcc544a2-efaa-40b7-84c7-71cbad343f84",
      "text": "Peer-reviewed laboratory study found a banana-derived lectin (BanLec) inhibits HIV replication in vitro"
    },
    {
      "id": "1d65d8ef-b267-4c53-9e26-c6c5beaced86",
      "text": "Publication of peer-reviewed reviews and preclinical studies summarizing DMSO's immunomodulatory and in vitro anticancer effects (science literature available by 2020)"
    },
    {
      "id": "4a658a81-28d6-4abe-9832-22c1a7e3e16a",
      "text": "1978 FDA approval of RIMSO-50 (a 50% DMSO solution) for intravesical use in interstitial cystitis"
    },
    {
      "id": "da266b40-9b7e-4f6b-b6b9-b4f5073e68af",
      "text": "International Coral Reef Initiative (ICRI) published an update stating that bleaching-level heat stress impacted 84% of the world’s coral reefs."
    },
    {
      "id": "b7bbcc42-c9a1-444b-9fef-ed1c7e0ad146",
      "text": "Wagner Group rebellion and armed column movement near Voronezh"
    },
    {
      "id": "9ef0d9f0-7a35-4e5b-ad5b-6dc0c299e527",
      "text": "Explosions/drone incidents over central Moscow (including near the Kremlin) and official accusations"
    },
    {
      "id": "e4b1d43c-bbc0-4bc4-8b5a-09ae200e4b31",
      "text": "Fuel tank fire at a Rosneft oil depot in Voronezh region"
    },
    {
      "id": "0d409954-3f1f-4a11-a677-fabc5e45f83c",
      "text": "CDC One Health guidance noting most emerging infectious diseases are zoonotic"
    },
    {
      "id": "459f6d39-89f1-4124-b6d3-782d4a49df4f",
      "text": "Two Ukrainian servicemen (including Dmytro Krasnohrud) were killed near Zaitseve on July 13, 2020; bodies were later handed over — a real battlefield casualty incident."
    },
    {
      "id": "c8b58a8c-445b-433a-993c-fc7a82490c95",
      "text": "Mainstream health articles and reviews (e.g., Healthline overview updated June 29, 2023) summarizing promising lion’s mane research for cognition and Alzheimer’s"
    },
    {
      "id": "d9878fd5-bcaf-429d-8863-615171a1955a",
      "text": "2016 mouse study (Tsai‑Teng et al.) showing erinacine‑A enriched Hericium mycelia reduced amyloid pathology in APP/PS1 Alzheimer’s model mice"
    },
    {
      "id": "72eb9227-e645-411f-9e19-1b02d4ed398f",
      "text": "July 20, 2021: FDA warning letter(s) and subsequent press attention about dietary‑supplement sellers making disease claims for mushroom products (including lion’s mane)"
    },
    {
      "id": "567319b3-8cbb-4fec-8699-f5d50156c4da",
      "text": "Russia imposes bans on Ukrainian food imports after 2014 sanctions"
    },
    {
      "id": "075cddf6-23f3-4430-888a-d7e4bceaf569",
      "text": "Sharp GDP contraction during 2014–2015 amid conflict and economic shock"
    },
    {
      "id": "64a4b6bb-e6f8-4c75-98cb-8cbcd3022f9c",
      "text": "Provisional application of the EU–Ukraine Association Agreement including the DCFTA"
    },
    {
      "id": "253ccb87-0251-4c30-99c8-3f6544a04ff8",
      "text": "September 2021 reports of black/foreign particles found in some Moderna vials in Japan and large batches paused"
    },
    {
      "id": "26d0e6cc-2b41-475c-8845-f74aa9d04201",
      "text": "Center for Economic Strategy published an assessment placing Ukraine's economic losses from the temporary occupation of Crimea at about $135 billion."
    },
    {
      "id": "073afdee-e01b-46aa-a9c6-1829a7761aea",
      "text": "U.S. EPA and other regulators/extension services have published fact sheets explaining corn gluten meal is a food/feed product, classified as minimum‑risk for pesticide use, and that its rodenticidal effects depend on a physical/dehydrating mode of action not applicable to humans (EPA fact sheet Nov 2002; Cornell IPM profile)."
    },
    {
      "id": "1294ad29-53d1-48f4-810e-59099cff540e",
      "text": "IPCC Synthesis Report released attributing recent warming predominantly to human activities"
    },
    {
      "id": "00490e88-4c69-439f-840a-b6f48abec599",
      "text": "Publication of Nicola Scafetta et al. paper in 2023 arguing a larger role for the Sun in recent climate change"
    },
    {
      "id": "9e3c28e4-6c0a-44a5-8ad1-a17e10e5fded",
      "text": "Local reporting: large pro‑Ukraine demonstrators in Kherson outnumbered pro‑Russian activists (Svoboda Square, Kherson)"
    },
    {
      "id": "f11bc561-5265-46b4-be24-784619995d03",
      "text": "BBC analysis 'Ukraine underplays role of far right in conflict' documenting Azov and use of Nazi‑linked symbols (Wolf's Hook) in 2014"
    },
    {
      "id": "32a66506-57c7-45bd-982c-36465c065377",
      "text": "BBC profile of the ultra‑nationalist Right Sector and its role in the 2014 Maidan protests"
    },
    {
      "id": "f30b12d4-dcd1-4f56-aebf-112510f25d5f",
      "text": "Randomized, double‑blind clinical trial (Koytchev et al., Phytomedicine 1999) found topical lemon balm extract reduced symptoms and accelerated healing of herpes labialis (cold sores)."
    },
    {
      "id": "45421d92-486f-4312-b002-49b5d0a5a857",
      "text": "FDA warning letter to Applied Health Solutions (Oct 22, 2021) cites Grapefruit Seed Extract product claims including effectiveness against 'herpes' and other viral diseases."
    },
    {
      "id": "48b2d768-230a-4aa5-ab8a-5743244c1e3a",
      "text": "UK Ministry of Defence announced it would send Challenger 2 tanks to Ukraine along with armour‑piercing rounds that contain depleted uranium."
    },
    {
      "id": "4acf7638-53e6-40c9-a142-69a12748f1f2",
      "text": "Historical precedent: Reporting and investigations documenting previous UK/US use of depleted uranium munitions in conflicts (Iraq, Balkans) were widely available."
    },
    {
      "id": "80cc3b20-787e-416c-b035-1cd977c998e2",
      "text": "Russian President Vladimir Putin publicly condemned the UK move and warned Moscow would be 'forced to react', calling the ammunition a weapon with a 'nuclear component'."
    },
    {
      "id": "b3b31d70-3d5f-4d91-b7cb-39885ce4fcc6",
      "text": "Parliamentary elections scheduled for October 26, 2014 (the 'day of silence' was October 25), creating heightened public attention and low tolerance for reports of interference."
    },
    {
      "id": "966a16e0-bee9-4168-8b73-67eea3f7ae0c",
      "text": "Publication of Nerem et al. (PNAS) showing recent acceleration of global sea-level rise (2018)"
    },
    {
      "id": "2404a11f-7524-43e2-a24c-41424b74bb3c",
      "text": "Release of the Bureau of Meteorology / CSIRO 'State of the Climate 2018' report"
    },
    {
      "id": "c9bc0260-f4d6-4947-ba76-41372364aa42",
      "text": "Marin County measles cases and public reporting on vaccine exemptions (2014–2015)"
    },
    {
      "id": "26adcb73-598e-4f08-976b-f78de7e92ed2",
      "text": "Publication of Nevison & Parker county-level analysis showing plateau/decline in ASD prevalence among wealthy white California counties"
    },
    {
      "id": "b4881885-8b42-4b2b-bc5e-2427d67b85b7",
      "text": "Ukraine adopts law and official policies on 'temporarily occupied territories' and Donbas reintegration (2018)"
    },
    {
      "id": "c55607db-643a-4cbc-b25f-1a43cc9cbce4",
      "text": "Putin decree simplifying acquisition of Russian citizenship for residents of Donetsk and Luhansk (passportisation of Donbas)"
    },
    {
      "id": "b1e5a97e-b8a4-452d-8367-66915839ebfd",
      "text": "Graphic reporting and images of women giving birth in bomb shelters, basements and damaged maternity hospitals (including Mariupol) during early 2022 attacks"
    },
    {
      "id": "cbf18eaa-c607-475a-81b4-cbf05023e7bb",
      "text": "Reporting that Ukraine was a major international destination for commercial surrogacy and fertility tourism"
    },
    {
      "id": "e1772e61-1e20-4382-be94-490d349fea1c",
      "text": "President Petro Poroshenko granted Ukrainian citizenship to three foreign-born technocrats nominated for ministerial posts ahead of a 2014 cabinet vote."
    },
    {
      "id": "e3bf6429-0f20-4ba4-8b26-665f3b75e5a4",
      "text": "Media coverage highlighted several foreign‑born ministers and officials (e.g., Natalia Yaresko, Aivaras Abromavicius) being granted citizenship to take government posts in late 2014."
    },
    {
      "id": "ceb9cdf7-9d46-4c9f-8740-f061565ccfa8",
      "text": "Former Georgian president Mikheil Saakashvili was granted Ukrainian citizenship and appointed governor of Odesa region (later stripped and restored at different times)."
    },
    {
      "id": "2e025176-d873-4617-8b4e-6f437ac9d311",
      "text": "Minsk II agreement sets political steps for Donbas (Package of measures)"
    },
    {
      "id": "5562bd6c-3644-4029-b8b5-49f3069414b8",
      "text": "OSCE deploys the Special Monitoring Mission (SMM) to Ukraine"
    },
    {
      "id": "ed917cad-09cd-471c-b261-f1d3e72fd003",
      "text": "UN General Assembly adopts Resolution 68/262 affirming Ukraine's territorial integrity"
    },
    {
      "id": "d6bc271e-34c2-44c8-beaf-77b2fd2c80fd",
      "text": "UN Secretary‑General issues statements urging restraint on Crimea/Ukraine"
    },
    {
      "id": "4015b7c3-dd2a-4989-a19d-85367b1ffbff",
      "text": "Russia summoned the German ambassador after Berlin's public statements on the Navalny case"
    },
    {
      "id": "99e605c6-f488-456b-bf0d-9dbd2b9f9003",
      "text": "Aleksey Navalny airlifted from Omsk to Berlin for medical treatment"
    },
    {
      "id": "fee08dde-a2d5-4671-bebb-7cfa33586d86",
      "text": "Germany handed laboratory test data and facilitated OPCW technical assistance regarding Navalny's poisoning"
    },
    {
      "id": "8e31e618-084f-41ef-b498-669073ce1420",
      "text": "Chancellor Angela Merkel said Navalny's poisoning was an attempted murder and called on Russia to explain"
    },
    {
      "id": "eeb0fdb7-038c-4e03-9e57-dce06231b27f",
      "text": "World Bank reported sharp GDP and industrial-production declines linked to the 2014 conflict"
    },
    {
      "id": "08a265de-ddd4-41d9-9c9b-e726f7e578c2",
      "text": "Avdiivka Coke and Chemical Plant heavily shelled and production repeatedly disrupted"
    },
    {
      "id": "22efaf13-bae7-48b9-ac24-b658143c6474",
      "text": "Large share of Donbas industrial capacity cut off after 2014 fighting and separatist control"
    },
    {
      "id": "7779dd72-ca1b-4c1b-9903-d28e8dc1faab",
      "text": "Japan paused use of a large Moderna vaccine lot after pharmacists found black/foreign particles in vials (investigations later identified contaminants and some lots were recalled); mainstream outlets (BBC, others) reported the pause in Sept 2021."
    },
    {
      "id": "ea62de52-12d4-4d81-8a68-5fe74dc5074e",
      "text": "Francis Fukuyama interview with Radio Svoboda published containing a cautious line that 'the issue that Ukraine will face in the future is the possibility that not 100 percent can be liberated'"
    },
    {
      "id": "70d7fa7f-606d-4df7-a886-ac349df9049e",
      "text": "‘Support Free Ukraine’ demonstration outside the Ukrainian embassy in Sofia"
    },
    {
      "id": "96fbbb85-f272-4a7f-beb5-baf8b1586d33",
      "text": "Public rallies by the nationalist Ataka party in 2014 (large street demonstrations)"
    },
    {
      "id": "d71b3006-88b0-41b1-b3e5-9186f225d79d",
      "text": "Reporting on Bulgaria’s divided stance over Crimea and visits by Bulgarian politicians"
    },
    {
      "id": "eeb6921f-9f1d-4f99-a547-4bbd68995d30",
      "text": "Reports (2010–2011) linking the Pandemrix H1N1 influenza vaccine to increased narcolepsy cases in children in Finland and Sweden and subsequent EMA/GSK reviews"
    },
    {
      "id": "8191a74c-d1ab-47a8-9174-f0d5cbfd58ca",
      "text": "June 2013: Japan's Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine after reports of alleged adverse events"
    },
    {
      "id": "b53eff8f-aadc-42a8-ab34-a617398456c5",
      "text": "Public-health data and surveillance reports (UKHSA, ONS and CDC studies in 2021) showed waning vaccine effectiveness and higher absolute numbers of cases or deaths among vaccinated people in some age groups—driven by high vaccine coverage and timing—during late 2021."
    },
    {
      "id": "abcf1a28-13cf-40e8-947d-de677b477c2d",
      "text": "Reports of contamination in vaccine batches in Japan (stainless-steel/foreign particles in Moderna vials) and subsequent recalls/suspensions during September–October 2021."
    },
    {
      "id": "4e94fa2f-75fd-435f-9008-7932c588c0e3",
      "text": "International media reporting of Russia's seizure of three Ukrainian naval vessels and detention of crew (wounded sailors reported)"
    },
    {
      "id": "ed3e4012-24a0-4a30-aef0-11715ad3f744",
      "text": "Coverage and analysis noting EU reluctance or political obstacles to imposing new Russia sanctions after the Kerch incident"
    },
    {
      "id": "afca75d1-e3a8-40b8-b590-69bddd25646a",
      "text": "G7 foreign ministers' joint statement expressing 'utmost concern' about Russian actions in the Kerch Strait"
    },
    {
      "id": "ac1155ef-570d-42ff-9439-4132f58aa74d",
      "text": "IMF and international lenders publicly warned Ukraine to accelerate reforms and tackle corruption to preserve investor confidence."
    },
    {
      "id": "a8695eab-8246-4726-b5e9-2e579aabe031",
      "text": "Kyiv issued formal sanctions on Russian-owned banks (blocking capital outflows and imposing restrictions)."
    },
    {
      "id": "d0146263-c582-47b2-8757-4deb785b6900",
      "text": "Sharp falls in foreign direct investment and international capital flows to Ukraine following the 2014 crisis (documented in UNCTAD/World Investment reports)."
    },
    {
      "id": "302853a2-fb88-4896-9616-6741fd099aac",
      "text": "Nationalisation of PrivatBank, Ukraine's largest commercial bank."
    },
    {
      "id": "914af81b-99f3-4771-ad7a-a28ece1a25e1",
      "text": "Reports that thousands of Mariupol residents, including children, were forcibly deported or taken through 'filtration' after Russian forces captured parts of the city"
    },
    {
      "id": "0f0a3feb-fe9f-44dd-866d-26c18406276a",
      "text": "Red Cross / national Red Cross societies publicized medical aid, psychosocial support and programs for displaced Ukrainian children and families in early 2022"
    },
    {
      "id": "b5731f9d-93e5-410c-b508-af876a95e93e",
      "text": "Red Cross-led evacuation attempts to reach and extract civilians from besieged Mariupol failed or were halted amid heavy fighting"
    },
    {
      "id": "d1e32d54-7605-4c03-9379-6fb1f04f9705",
      "text": "Bombing of the Donetsk Academic Regional Drama Theatre in Mariupol that sheltered civilians (including children), producing graphic images and uncertainty about many casualties"
    },
    {
      "id": "a5a0e63e-a40f-4653-b49f-b08501abfb44",
      "text": "ICRC activated a Central Tracing Agency (family‑tracing) bureau to collect information about missing people and reconnect families after the escalation in Ukraine"
    },
    {
      "id": "8b83fac7-c728-4306-a23a-fa7239f16085",
      "text": "CDC and advocacy groups warn that pandemic-related delays in cancer screening and care could produce downstream increases in advanced cancers and mortality"
    },
    {
      "id": "92aedbd2-b062-4251-8a00-dc65bac74d4c",
      "text": "CDC releases provisional life expectancy estimates for 2021 showing a sharp decline in U.S. life expectancy"
    },
    {
      "id": "c0188ef1-6375-4482-98b4-030fb26f3e5a",
      "text": "OSCE SMM reporting of civilian casualties at/near checkpoints in Donetsk/Luhansk (2019 summaries)"
    },
    {
      "id": "b0b293e8-0639-41aa-b1a3-39f70d6c4033",
      "text": "Karlivka (Karlivka/Karlivka area) checkpoint ambush and fatalities"
    },
    {
      "id": "c97a3438-9ff1-491b-a8e6-64b881df842a",
      "text": "Volnovakha bus attack near a Ukrainian checkpoint (passenger bus hit)"
    },
    {
      "id": "0b41f824-fa87-4638-b004-e5ce1e8425a8",
      "text": "Earlier (March–April 2014) incidents where pro‑Russian activists raised Russian flags on government buildings in eastern Ukrainian cities (e.g., Kharkiv, Donetsk) were widely photographed and reported."
    },
    {
      "id": "b2c435b6-21f1-4e3e-9b9e-70fd33a7816e",
      "text": "Official visit of Bulgarian President Rosen Plevneliev to Kyiv (July 7–8, 2015) — Bulgarian flags and official decorations were displayed in central Kyiv for the visit."
    },
    {
      "id": "b4054bff-2507-43d7-aafc-6ffe90087e86",
      "text": "President Barack Obama met and publicly expressed support for Petro Poroshenko in meetings around mid-2014 (e.g., June 4, 2014 meeting during Poroshenko's European visits)."
    },
    {
      "id": "ee09ba8a-7d35-40f4-8c9a-596a029c42cf",
      "text": "Poroshenko repeatedly and publicly vowed to restore Ukrainian control over Crimea (kept the topic in headlines through 2015)."
    },
    {
      "id": "f73719c7-0c81-4646-8507-3d12750a599b",
      "text": "Deputy Foreign Minister Olena Zerkal interviewed by the Financial Times, saying the EU delay on visa‑free travel 'feels like some kind of betrayal'"
    },
    {
      "id": "625c1b7f-d304-4eb3-bfaf-a0c0a690ca38",
      "text": "EU‑Ukraine summit and statements in late November 2016 confirming Ukraine had met visa‑liberalisation criteria but formal implementation remained pending"
    },
    {
      "id": "aba98aef-afc1-4471-a4a7-7dde428a52b2",
      "text": "CDC review and guidance on COVID-19 vaccine administration errors and deviations"
    },
    {
      "id": "22f5e4e6-4a0e-4665-a396-03104cfc11d4",
      "text": "Foreign particles found in Moderna vials in Japan leading to batch suspension and recall"
    },
    {
      "id": "b379680b-f10c-4990-be8d-21679d10a1fb",
      "text": "EU REACH restrictions on hazardous substances in tattoo inks came into force and ECHA held an industry webinar explaining implementation."
    },
    {
      "id": "3f3e0fb1-eae8-4080-bf01-d3e1fff5f2f2",
      "text": "Peer-reviewed analysis identified hexavalent chromium (a known carcinogen) as an impurity in some tattoo inks and discussed dermal exposure risk."
    },
    {
      "id": "0164cbdb-5835-494f-bea8-4b0f499cbdbf",
      "text": "FDA warning letter (Ambaya Gold, Dec 5 2023) naming products promoted with claims that clinoptilolite (zeolite) 'removes heavy metals' and warning the company about unapproved/misbranded therapeutic claims."
    },
    {
      "id": "50755e27-77b6-427f-93dd-a87731a11646",
      "text": "UNHCR report documents extensive 'collective centres' for internally displaced people in Ukraine"
    },
    {
      "id": "d4c1d571-a06c-4ee5-91dd-4159cee958ba",
      "text": "Widespread, dramatic coverage of refugee 'camps' in Europe (Roszke, Hungary) during 2015 crisis"
    },
    {
      "id": "512e237d-55d7-490d-85d4-0108fd54bbe8",
      "text": "Regulatory findings and widespread media coverage in March 2021 that the AstraZeneca vaccine was associated with very rare clotting events (VITT) and subsequent safety reviews."
    },
    {
      "id": "8a7c278b-a05a-47e5-a782-f333e3abd311",
      "text": "Ukraine's state rail company suspends passenger and cargo train services to Crimea"
    },
    {
      "id": "3719c3d8-be42-4a6d-aea6-0faa841a3224",
      "text": "U.S. provides non‑lethal aid including Humvees to Ukraine (March 2015 announcement)"
    },
    {
      "id": "463e2730-3293-4e8d-b87b-d16f9fde8c30",
      "text": "Western-led training and re-tooling exercises with Ukrainian forces reported (early 2016 coverage)"
    },
    {
      "id": "39d81057-c893-47a6-afa4-6c36c27b7236",
      "text": "U.S. State Department approves sale of Javelin anti-tank missiles to Ukraine"
    },
    {
      "id": "f88219d8-400c-4903-9cf1-aaf5dc8c6ce1",
      "text": "Reports that separatists and Russian‑backed forces captured equipment from Ukrainian units"
    },
    {
      "id": "231bd0ea-a301-44d9-a0fd-8b1f75fb9a13",
      "text": "Early‑post‑Crimea (March 2014) statements by Transnistrian officials (e.g., Mikhail Burla) requesting accession to Russia and broader media discussion that Transnistria might be a candidate for ‘the next Crimea.’"
    },
    {
      "id": "0781a0fb-13c1-4dac-8c1c-fbccebd5d447",
      "text": "Reports of foreign/black particles found in some Moderna vials in Japan, triggering recalls and headlines (September 2021)."
    },
    {
      "id": "f134ec02-dc6c-40cd-af19-e83401adec30",
      "text": "Early pregnancy‑safety surveillance of mRNA COVID‑19 vaccines reported no safety signal in vaccinated pregnant persons (v‑safe/pregnancy registry; NEJM preliminary findings, June 2021)."
    },
    {
      "id": "73ce06b7-ecbd-4700-b340-1fae1a530920",
      "text": "UN OCHA Situation Report No.5 documenting rising fatalities and urban combat around Donetsk"
    },
    {
      "id": "37be92fe-4739-4a8d-a3a8-9967c770e07b",
      "text": "Ukrainian and international leaders publicly warned that explosives or sabotage could threaten Dnipro dam infrastructure (public warnings and diplomatic appeals, Oct 2022)"
    },
    {
      "id": "f36fd863-41fb-4892-8b41-fa4f145056b2",
      "text": "Russian forces captured the Kakhovka (Nova Kakhovka) hydroelectric power plant on the Dnipro early in the 2022 invasion"
    },
    {
      "id": "75e474b7-52a7-4ce0-93d3-5c5b15d37224",
      "text": "Satellite imagery and reporting showed Russian forces building pontoon/ferry crossings across the Dnipro in Kherson region (summer 2022)"
    },
    {
      "id": "87bdf665-a018-48bc-b1bb-90ecd420038c",
      "text": "Reports that the Russian-held Nova Kakhovka dam was damaged by shelling (reported in Russian media) and experienced operational problems"
    },
    {
      "id": "6f78ac5b-4203-4c69-a66e-58f34b29e192",
      "text": "Ukraine stopped water flow to Crimea via the North Crimean Canal after Russia's 2014 annexation (closure and water cut-offs widely reported)"
    },
    {
      "id": "46ee1a0b-a0b7-49f9-8b25-48fbc78eec74",
      "text": "Public political downplaying of COVID-19 risk (early statements by high-profile politicians, March 2020)"
    },
    {
      "id": "a64fb6fe-0fc8-43ff-8d37-977d9877692b",
      "text": "Stanford (Santa Clara) seroprevalence preprint (Bendavid et al.) suggesting many more infections and lower IFR (April 2020)"
    },
    {
      "id": "b146c3bc-b08a-4983-be17-739e144ab07a",
      "text": "Release of the NIPCC report 'Climate Change Reconsidered' (Heartland Institute / Nongovernmental International Panel on Climate Change)"
    },
    {
      "id": "6fe08ef8-5a44-4e36-84d5-fded1981aaea",
      "text": "Jacques Attali's well‑known public profile (former special adviser to President François Mitterrand, prolific author and commentator) and periodic controversial commentary on euthanasia/ageing (often cited out of context)."
    },
    {
      "id": "5d2dd122-64ca-430f-8ef0-a4833c97a70c",
      "text": "World Economic Forum launched the 'Great Reset' initiative (public messaging beginning June 2020)."
    },
    {
      "id": "87ec48c4-b7e0-4dda-b630-292aba0fe9ad",
      "text": "Poroshenko cut short his Davos visit to return to Ukraine amid a 'worsening situation', as reported by multiple outlets."
    },
    {
      "id": "b79ffa68-6e5b-440f-90cc-fa63873d6110",
      "text": "Students and activists disrupted and booed high‑profile figures at Zurich university events earlier (notably Sepp Blatter at ETH Zurich in November 2014)."
    },
    {
      "id": "5c4118aa-ea83-4a17-94be-41b87f24e9e2",
      "text": "Protests and demonstrations around the World Economic Forum in Davos (anti‑WEF/anti‑globalisation actions) were occurring and widely reported in mid‑January 2015."
    },
    {
      "id": "05eac3b3-ebba-40d5-90e8-e137e96d3021",
      "text": "WHO mission on tuberculosis control and human rights in Ukraine"
    },
    {
      "id": "f29f0dfd-548c-4256-b7b3-e1a619c23c14",
      "text": "IMF approves a US$17.5 billion Extended Fund Facility for Ukraine"
    },
    {
      "id": "be9ee0b6-56dc-4278-bde1-49d32891bb4f",
      "text": "Euromaidan protests escalate and government change in Kyiv"
    },
    {
      "id": "755794e1-02c5-4711-b795-71a6f11e2345",
      "text": "Recent public casualty statements by Ukrainian leadership (e.g., Zaluzhnyi referenced cumulative losses) created uncertainty about true figures."
    },
    {
      "id": "431df094-aa85-427f-a056-e553a0b60b40",
      "text": "High-profile extreme-event attribution coverage just before the campaign date: World Weather Attribution/Oxford analysis (published 2 August 2019) concluding the 2019 European heatwave was made far more likely by human-caused climate change."
    },
    {
      "id": "50cb179b-a08b-466c-8c5b-1a1879c7fc80",
      "text": "Early March 2019 tornado outbreak across the U.S. Southeast (notably March 3, 2019) produced lethal tornadoes and extensive coverage of storm damage."
    },
    {
      "id": "ba04f4a7-d816-4938-8fb3-f9075b90b071",
      "text": "Publication/coverage of studies emphasizing that the Medieval Warm Period was not globally synchronous (e.g., Columbia Climate School coverage of regional MWP findings)"
    },
    {
      "id": "5b999078-8c20-41b4-8f1a-0aa73a32b435",
      "text": "IPCC Fifth Assessment Report (AR5) release, including past‑millennium reconstructions"
    },
    {
      "id": "7c3be797-44d5-4e4f-b318-d24f976e74ec",
      "text": "Longstanding local debate in Lviv about the fate of Soviet-era memorials and periodic proposals to repurpose or relocate elements of the Hill/Monument of Glory (discussion ongoing for years prior to 2017)."
    },
    {
      "id": "9a7b32ab-adad-4f12-a6d6-9303b5436a96",
      "text": "Passage and signing of Ukraine's 'decommunization' laws that required removal of communist symbols and monuments."
    },
    {
      "id": "15a96114-e2bd-485c-aa5d-b964e9f557d5",
      "text": "Lviv City Hall press office statement denying plans to dismantle the monument, noting the site was fenced off because it was in poor condition and that a committee would make recommendations."
    },
    {
      "id": "9f7a7753-8a9a-46c9-8cb8-efe4ed91f99e",
      "text": "Russian airborne assault and fighting at Hostomel (Antonov) Airport"
    },
    {
      "id": "6b55a69b-e063-423b-b214-33e4d517fc9f",
      "text": "Ilovaisk encirclement ('Ilovaisk cauldron') and heavy Ukrainian losses in August 2014"
    },
    {
      "id": "e1132d0a-c744-45d4-b6e4-4608e9abdeab",
      "text": "Authoritative trackers (e.g., New York Times / Johns Hopkins) showed a sustained period of daily new-case counts above 100,000 in early–mid November."
    },
    {
      "id": "2c6b89e1-e849-4daf-83a2-ed6eef4731fd",
      "text": "IPCC Sixth Assessment Report (Working Group I) release asserting strong human attribution for recent warming"
    },
    {
      "id": "fe43aed4-9f28-4fc4-b48c-9489789f7459",
      "text": "Publication and media coverage of studies showing 'global greening' connected to CO2 fertilization (widely reported from 2016 onward)"
    },
    {
      "id": "aa857a91-bc00-438a-a783-6a2f7a4230e2",
      "text": "Japan suspended and recalled Moderna COVID-19 vaccine batches after foreign particles were found (September 2021)"
    },
    {
      "id": "c62cf8da-abf3-43bf-94cc-e12ff7085cc2",
      "text": "FDA approval of JYNNEOS (smallpox and monkeypox vaccine)"
    },
    {
      "id": "6517a7fb-4a3b-454e-a3af-f52a9e6f5199",
      "text": "NTI published summary/report of the 2021 tabletop exercise"
    },
    {
      "id": "a6568a79-5d7d-40ab-a6ff-612ccd37292f",
      "text": "Historical arson attacks and anti-refugee incidents in Germany (e.g., Bautzen fire of Feb 2016)"
    },
    {
      "id": "45646d38-96b8-4175-8594-8b2a0b3c72d1",
      "text": "Court orders and litigation over giving ivermectin to hospitalized COVID‑19 patients (notably a widely reported Ohio case)"
    },
    {
      "id": "4bee0fdf-d6c3-4441-8326-91778e5e490e",
      "text": "Authoritative explanations that FDA does not regulate the practice of medicine / off‑label prescribing (Congressional Research Service and longstanding FDA position, 2021)"
    },
    {
      "id": "8d653be1-298c-4b9d-b6ad-ee802b9bbaf0",
      "text": "European Union places Vladislav Surkov on sanctions list in response to the Crimea/Ukraine crisis (EU decisions, March 2014)."
    },
    {
      "id": "c70af5b9-8ff9-47dc-8923-58d2a3de24c2",
      "text": "Victoria Nuland's public visits and meetings with Ukrainian leaders and opposition figures in Kyiv (February 2014)."
    },
    {
      "id": "0a95aae4-dc65-4e88-a746-6b0ccc441a7b",
      "text": "NATO Wales Summit adopts the Readiness Action Plan and publicly increases reassurance measures for eastern allies (Wales Summit Declaration, September 2014)."
    },
    {
      "id": "0dc997c4-c48b-4969-b36a-a7b3f9b227d3",
      "text": "Minsk II 'Package of measures' signed, setting a ceasefire and political roadmap for Donbas."
    },
    {
      "id": "878f60f7-2c9c-456b-bd0a-98b48d713d6b",
      "text": "Self-proclaimed Donetsk and Luhansk 'people's republics' declared independence and maintained de facto control over parts of Donbas."
    },
    {
      "id": "32cd072d-1d55-46c3-9fcb-967982981b41",
      "text": "EU establishes the East StratCom Task Force (EUvsDisinfo) to counter Russian disinformation (and documents active Russian information operations)."
    },
    {
      "id": "9e4e2c61-938a-47d9-8d90-f15250db1a88",
      "text": "Volodymyr Zelensky stars as a fictional president in the TV series 'Servant of the People' (premiered 2015)."
    },
    {
      "id": "88c9155f-d83c-4a5a-bd85-300b457d50b0",
      "text": "UNHCR and humanitarian organizations published operational data and guidance in March 2022 showing how displaced Ukrainians were being registered and assisted across multiple countries (including coordination with Russian Red Cross in Russia)."
    },
    {
      "id": "fb36dc49-7f11-4386-9852-41847d1f0cd1",
      "text": "Russian Human Rights Commissioner Tatyana Moskalkova publicly denied forced transfers and Russian media cited large numbers of Ukrainians having gone to Russia (statements reported in mid‑April 2022)."
    },
    {
      "id": "18657478-bf97-495b-b772-5db4e7bf42e3",
      "text": "U.S. State Department and other governments maintained high-level 'do not travel' advisories for Ukraine"
    },
    {
      "id": "9faa1b2f-3604-464c-82bc-dcc620f3be67",
      "text": "UNHCR published guidance and cautioned about voluntary return amid ongoing safety, protection and infrastructure concerns in 2023"
    },
    {
      "id": "ab7b07e9-0211-423f-807a-5eaf90fcbc3b",
      "text": "Kyiv's mayor reported that a large share of the city's population fled after the Russian invasion"
    },
    {
      "id": "62fb3a39-8949-44f1-aa76-ead5da769f4d",
      "text": "Widespread Russian strikes damaged Ukraine's energy infrastructure, causing prolonged blackouts in Kyiv"
    },
    {
      "id": "b1a06f5c-9114-4179-893a-dd7aa8909812",
      "text": "University of Turin's publicly available rules on recognition of foreign degrees (procedures for evaluating and recognizing foreign diplomas)."
    },
    {
      "id": "349cc3b2-246e-4b61-b4b8-0b99b9f179d1",
      "text": "Donetsk higher-education institutions continued operations in exile (relocated to central Ukraine) and kept issuing Ukrainian diplomas after 2014."
    },
    {
      "id": "706089a4-2389-45ca-833f-2cb91c20612c",
      "text": "EUvsDisinfo reported that Turin University's Department of Economics had admitted a student from occupied Donbas whose degrees were issued by Donetsk National University before 2014."
    },
    {
      "id": "7445b65e-78b0-4696-862f-f23d49d0534f",
      "text": "Documented incidents earlier in the spring where Russian forces impeded or seized humanitarian/evacuation convoys (e.g., capture of drivers and buses at Mangush)."
    },
    {
      "id": "6e6f56e2-0357-4089-a86a-306d5191e154",
      "text": "Repeated breakdowns and contested humanitarian corridors and evacuations in Mariupol during March–April 2022, with both sides blaming each other."
    },
    {
      "id": "5bca25b0-64f2-4e68-9241-834a044e8575",
      "text": "OSCE monitors detained by pro‑Russian separatists (multiple incidents, including Slaviansk/Kramatorsk)"
    },
    {
      "id": "59d20052-ccf1-4c25-ad4f-5086069feef5",
      "text": "OSCE monitoring‑mission vehicles destroyed in Donetsk (apparent arson attack)"
    },
    {
      "id": "226ceb8b-abf4-44b9-af59-ea096de45e23",
      "text": "OSCE SMM reported nearby mortar impacts and SMM assets struck/damaged (examples of SMM being hit by indirect fire)"
    },
    {
      "id": "c5c758cd-d80a-4980-a891-99320447bccf",
      "text": "Established concerns and reporting about illicit trafficking and unsecured radioactive materials in post‑Soviet states (IAEA Illicit Trafficking work, 1990s onward)"
    },
    {
      "id": "3bfef735-f736-4651-b093-622fec87b359",
      "text": "Ukraine relinquished Soviet-era nuclear weapons under the 1994 Budapest Memorandum"
    },
    {
      "id": "ba7e4c8a-4ba4-4438-be04-8079d06e2888",
      "text": "ONS (UK) bulletin: 'Deaths involving COVID-19 by vaccination status, England' showing monthly age-standardised mortality rates (ASMRs) by vaccination status (including notes that some ASMRs for vaccinated groups were similar to or higher than unvaccinated in certain months)."
    },
    {
      "id": "b9c77f05-bf4b-4ac1-aa19-d41b8f87ffa8",
      "text": "BBC coverage (Jan 10, 2023) reporting unusually high excess deaths in the UK during 2022 ('Excess deaths in 2022 among worst in 50 years')."
    },
    {
      "id": "53564912-43b7-4dc3-b199-27238fc54085",
      "text": "Japan reports and temporary suspension/recall of a Moderna vaccine lot after black/foreign particles were found (late August–early September 2021)."
    },
    {
      "id": "0be6a6cb-99f1-4df2-a393-55d344d7a96e",
      "text": "NOAA releases ERSST version 4 sea-surface temperature dataset (ERSST v4) used in later global surface temperature products"
    },
    {
      "id": "d4ca4811-8423-48d7-8341-7d95c29ca43c",
      "text": "FDA expanded Emergency Use Authorization for the Pfizer–BioNTech vaccine to adolescents aged 12–15 (May 10, 2021)."
    },
    {
      "id": "cd239cb6-4ddc-4fbe-b1a3-4efb0781c923",
      "text": "CDC issues guidance (May 27, 2021) acknowledging increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination, particularly in adolescents and young adults."
    },
    {
      "id": "8f093309-41f8-46b7-a897-d0b92c2d89ec",
      "text": "American Academy of Pediatrics (AAP) and Children's Hospital Association public report (May 20, 2021) summarizing COVID-19 cases and deaths in children."
    },
    {
      "id": "6ed9017a-8290-483a-b596-237e4d9a8691",
      "text": "Assassination of pro‑Russian journalist Oles Buzyna in Kyiv"
    },
    {
      "id": "85f18008-d73c-4be7-a7ef-d9583d4603b6",
      "text": "Reported vandalism of Holocaust and other memorials in Ukraine (2014 incidents)"
    },
    {
      "id": "faaf2a04-99b6-4eda-a468-4babd23b34ed",
      "text": "Widespread toppling/removal of Lenin statues and other Soviet monuments in 2013–2014"
    },
    {
      "id": "8e04e7f5-ebfa-4e96-97d6-6daf2585c48b",
      "text": "Publication of the Antarctic Surface Accumulation and Ice Discharge (ASAID) map work/NASA Earth Observatory coverage that reported scientists connecting 3.5 million geographic points to estimate Antarctica's icy edge perimeter at ~53,610 km."
    },
    {
      "id": "5f57dd5b-0ae7-40d5-a5ca-9367e781b141",
      "text": "Widespread public misunderstanding of the coastline paradox and map-projection distortions highlighted by reputable outlets (coverage during 2024–early 2025 explaining why complex coastlines can yield large perimeter measurements)."
    },
    {
      "id": "8541b447-be43-4696-b3c3-5bdfa1d5a546",
      "text": "Previous precedent: Russian missile strikes on Ukraine’s energy infrastructure caused large Moldova blackouts in November 2022"
    },
    {
      "id": "97b37768-0d05-4cec-963e-4480131aae91",
      "text": "Voltage collapse on the 400 kV Isaccea–Vulcanesti–MGRES transmission line that Moldova uses to import electricity"
    },
    {
      "id": "f781bac7-dd39-4977-955c-df979d834d8f",
      "text": "Russian Foreign Minister Sergey Lavrov publicly stated federalization was an important component of resolving the Ukrainian crisis (public remarks end of March 2014)."
    },
    {
      "id": "3f72006d-2cca-4708-a17e-4e5d64891aee",
      "text": "Pavel Gubarev proclaimed himself the 'people's governor' of Donetsk and publicly called for a referendum on the region's status (early March 2014)."
    },
    {
      "id": "835df69e-1dfc-4ef9-a704-e9ac185f1811",
      "text": "Russia/Gazprom sharply reduced and in places halted natural gas flows to Europe (Nord Stream 1 disruptions) in August 2022."
    },
    {
      "id": "d27385f6-dc81-41f1-bd61-a8d1042beff5",
      "text": "EU leaders and institutions announced plans in spring 2022 (REPowerEU) to drastically reduce dependence on Russian fossil fuels."
    },
    {
      "id": "becfd5d5-1ee9-4d06-80a8-a79a26aa2477",
      "text": "The 7 April 2018 Douma chemical attack (widely reported and later attributed by Western governments to the Syrian government)"
    },
    {
      "id": "4a2448c9-7554-4b09-bd39-f9e0e083b9ca",
      "text": "Discovery and widespread publication of photos and videos showing dead civilians in Bucha after Russian forces withdrew"
    },
    {
      "id": "42458045-832d-4bd1-92d2-d4c694c26f6a",
      "text": "Zelensky's public appeals for faster, increased military aid from allies (NATO talks/weapons appeals)"
    },
    {
      "id": "5436c0c4-f842-44ed-8cc7-21090a503ef6",
      "text": "Turkey's prior military-technical support to Ukraine (notably Bayraktar TB2 drones supplied in 2021–2022)"
    },
    {
      "id": "1cafa29a-dd5f-40e2-9527-b695d279038f",
      "text": "February 2023 Türkiye earthquakes — world leaders, including Zelensky, publicly expressed condolences and offered assistance"
    },
    {
      "id": "4237e997-e389-47a7-8c3c-920d420cadd9",
      "text": "AMA, APhA and ASHP issued a joint statement (June 23, 2020) noting FDA review and actions regarding hydroxychloroquine and other COVID-19 medications."
    },
    {
      "id": "eb87c822-aa00-40d8-9132-8436825cc3b6",
      "text": "Regulatory and industry safety reviews of wild yam (Dioscorea villosa) and public-facing summaries cautioning that wild yam extracts have hormonal activity and are not proven to treat fibroids."
    },
    {
      "id": "061f2a7f-a450-490d-8a05-29766f1c9832",
      "text": "Early reports of allergic and other adverse reactions after initial COVID-19 vaccine rollouts (for example, two NHS workers had allergic reactions after Pfizer shots in the UK)."
    },
    {
      "id": "5b910185-927d-4126-ad30-34c4c4e875ac",
      "text": "Public reporting that several COVID-19 vaccine candidates used historically derived human fetal cell lines (HEK-293, PER.C6) in development/manufacture."
    },
    {
      "id": "c01d4753-8ca2-4cc3-b5fa-d6582dc6d580",
      "text": "UK 'Homes for Ukraine' sponsorship scheme launched, enabling rapid arrival of large numbers of Ukrainian refugees to the UK (scheme launched 14 March 2022)."
    },
    {
      "id": "2a90d6e5-3007-4530-9648-5f391357af33",
      "text": "Russian leadership publicly framed the invasion as needing to 'denazify' Ukraine (Putin's rhetoric from late February 2022 onward)."
    },
    {
      "id": "7aba1bf9-7b64-4cd3-be68-21f773aecd32",
      "text": "Multiple reported incidents of swastika vandalism and a May 2022 prosecution for carving swastikas in a London shopping centre (Westfield) received local/national coverage."
    },
    {
      "id": "80eab844-5ee7-4d91-b64d-53159cfca350",
      "text": "CDC reinstated recommendation on July 27, 2021 that fully vaccinated people wear masks in public indoor settings in areas of substantial or high transmission (mask guidance change due to Delta)."
    },
    {
      "id": "846a8102-f54e-45d8-af36-9011340fc325",
      "text": "Israeli public-health reports in July 2021 showing decreased Pfizer-BioNTech effectiveness against infection with the Delta variant (while remaining strong against severe disease)."
    },
    {
      "id": "1aa4a657-e845-4ac3-8dad-66938da4aa28",
      "text": "Japan suspended and recalled Moderna vaccine batches in late August–early September 2021 after discovery of foreign (stainless steel/black) particles in some vials."
    },
    {
      "id": "70ea83d9-60d5-4779-baa5-92ec4617ee80",
      "text": "CDC MMWR report (published May 28, 2021) documenting COVID-19 vaccine 'breakthrough' infections occurring January–April 2021 and announcing a change in CDC surveillance focus."
    },
    {
      "id": "c3b5f389-950a-448e-a93b-cbc1155537cf",
      "text": "IARC/WHO evaluation classifying formaldehyde as a Group 1 (carcinogenic to humans) agent (IARC working group meeting, 2004)"
    },
    {
      "id": "05266523-2b9f-4ee2-94d2-77d005fa5d9e",
      "text": "CDC Vaccine Excipient & Media Summary (Pink Book Appendix B) listing ingredients and substances used in vaccine manufacture (publicly available CDC excipient table)"
    },
    {
      "id": "19c0c942-6db9-406c-9807-f992d3e1b895",
      "text": "1999 joint statement by the American Academy of Pediatrics and U.S. Public Health Service (reported by CDC) calling for removal of thimerosal from childhood vaccines as a precaution"
    },
    {
      "id": "038a37c6-587a-4f25-a13b-0060d10e76b6",
      "text": "Pause of high-profile vaccine trials (AstraZeneca paused global trials after an unexplained illness in a participant)"
    },
    {
      "id": "7d607d2b-c2b4-41c0-80d6-59cc1f874fad",
      "text": "Public revelations (2015) that climate contrarian Willie Soon received substantial fossil-fuel industry funding."
    },
    {
      "id": "d7b28e21-78df-411a-bb94-fcad5275b2a2",
      "text": "Major publishers (e.g., Springer Nature) publicly stated policies that AI tools cannot be credited as authors (January 2023), sparking debate over AI authorship in science."
    },
    {
      "id": "ebe94c24-895e-44db-a93b-e32d2ab0659b",
      "text": "Iran launched missile strikes on bases housing US forces in Iraq (retaliation)"
    },
    {
      "id": "deac6fbe-1f71-4bac-b1b7-c5b1dc0f1774",
      "text": "US drone strike killed Iranian General Qasem Soleimani"
    },
    {
      "id": "7d64a856-24be-44dd-a9da-520d2e65c291",
      "text": "Ukraine International Airlines Flight PS752 was shot down near Tehran, killing all 176 aboard"
    },
    {
      "id": "2a79c149-117c-4238-8185-4e0749498fe5",
      "text": "UN Office of the High Commissioner for Human Rights (OHCHR) report on children's rights in Ukraine documenting large numbers of children killed, injured, deported and otherwise affected by hostilities"
    },
    {
      "id": "ec6e8289-3019-4927-8667-3a447ba0d51f",
      "text": "Ukrainian authorities announce \"Contract 18-24\" recruitment drive offering one‑year voluntary contracts with financial incentives for recruits aged 18–24"
    },
    {
      "id": "8e11e6b5-a90f-4e1c-9b23-8c17083004b7",
      "text": "Official Kyiv Eurovision preparations publicized large security measures (10,000 law‑enforcement personnel, thousands of cameras, road closures and 'clean‑up' operations)."
    },
    {
      "id": "9b1d093f-de0f-46ef-8565-0e1e1e296258",
      "text": "Kyiv placed under curfew and residents ordered to shelter/prepare to defend the city"
    },
    {
      "id": "0193104e-6045-4742-86f6-04bf99e3c2b1",
      "text": "Airborne assault on Hostomel (Antonov) airport with helicopters and paratroopers near Kyiv"
    },
    {
      "id": "a822948a-1959-4fef-ac9b-454dd71b7ebd",
      "text": "Multiple missile strikes reported on Kyiv and other Ukrainian cities"
    },
    {
      "id": "b7521441-865b-4d5b-8f9e-0fae92ec0a98",
      "text": "Apartment building in Kharkiv shelled; civilian casualties reported (boy killed)"
    },
    {
      "id": "2f4d1d64-a278-4bc2-a3f0-9eefb7d52ec3",
      "text": "Russian President Vladimir Putin announces a 'special military operation' in Ukraine"
    },
    {
      "id": "ea38c269-5631-4bcc-b8d3-27432d6d205d",
      "text": "Federal court consolidated more than 140 lawsuits against Merck over the Gardasil HPV vaccine into a multidistrict litigation (MDL No. 3036), bringing sustained media attention to plaintiffs' claims that Gardasil caused serious harms."
    },
    {
      "id": "320f8044-4928-405e-98ad-346aac87e661",
      "text": "Japan's Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine in June 2013 (a decision that drastically reduced uptake and has been repeatedly cited in vaccine-safety debates)."
    },
    {
      "id": "500fd674-8c2b-49dc-b3d8-929f25693844",
      "text": "Russian missile strike on Kramatorsk railway station that killed dozens of civilians"
    },
    {
      "id": "fb0ebb50-3e74-49d1-af14-f0368e2f4ccf",
      "text": "President Volodymyr Zelensky requested an extraordinary parliamentary session on May 21–22, 2019 to amend electoral legislation, producing a heated parliamentary session and partisan exchanges."
    },
    {
      "id": "3f0cfc3c-6092-41fa-b4e0-4e3a1dc9a762",
      "text": "Opposition deputy Alexander Dolzhenkov publicly threatened to seek repeal of laws on decommunization and the language law during the May 22 debate, prompting Parubiy’s defensive remarks."
    },
    {
      "id": "15c1dfe3-0363-4cff-be4f-224832389ab8",
      "text": "Andriy Parubiy’s May 22, 2019 parliamentary remarks including the line 'You think the smell of revenge is in the air? Smell it! It’s the smell of burning tires.'"
    },
    {
      "id": "19c8dceb-ba49-4083-9bd2-9bf694c04895",
      "text": "Kerch Strait incident where Russian forces seized three Ukrainian naval vessels and detained crews"
    },
    {
      "id": "850ae654-2d8d-49c3-9520-1138ba8eb41b",
      "text": "Sea Breeze multinational naval and military exercises hosted by Ukraine and NATO partners in the Black Sea (Sea Breeze 2018)"
    },
    {
      "id": "8b689eb0-99c2-4b6b-bec0-a95434f5c6b5",
      "text": "U.S. approval and delivery of Javelin anti-tank missiles to Ukraine"
    },
    {
      "id": "bf4001ea-43c2-406d-a13a-2b8b6cad0303",
      "text": "Formation and integration of volunteer units such as the Azov Battalion into Ukraine's forces (2014 onward)"
    },
    {
      "id": "e059f732-82f9-4913-a509-434e9c5747cd",
      "text": "UN Human Rights Office report documenting multiple arbitrary arrests, detentions and prosecutions in Russian‑occupied Crimea"
    },
    {
      "id": "bd7254eb-60f0-4a5a-9010-4872e83eb688",
      "text": "Fitch Ratings sovereign rating actions and downgrades around the 2014–2015 crisis (example: Feb 13, 2015 Fitch rating action)"
    },
    {
      "id": "66017d11-b8de-45e4-97a0-4407d199553e",
      "text": "IMF statement concluding the 2016 Article IV consultation with Ukraine (April 3, 2017)"
    },
    {
      "id": "3e187232-2098-4d5a-9214-b01fb3db2fd2",
      "text": "Iran announced arrests related to the downing and police cracked down on protests over the incident."
    },
    {
      "id": "38608f01-edd3-4b98-bf21-80f5ae498ba3",
      "text": "Ukraine International Airlines Flight PS752 was shot down shortly after takeoff from Tehran, killing all 176 aboard."
    },
    {
      "id": "e4eb03db-324c-497b-b470-d26162590c0d",
      "text": "Reporting noted many passengers were Iranian nationals, students and researchers (including academics), and several countries pressed for answers about passenger lists."
    },
    {
      "id": "38b8faf4-24b6-4c13-8487-555b40638b4a",
      "text": "EU published COM(2017)235 (12 May 2017) — a strategy to step up the fight against illicit tobacco trade affecting eastern EU borders"
    },
    {
      "id": "c8d99fb4-a377-4d8c-9a97-646b22b0a25c",
      "text": "Poland and Ukraine signed a memorandum on cooperation for the Via Carpathia transport corridor (signed Oct 22, 2017) and media reported growing cross‑border freight volumes"
    },
    {
      "id": "7d0eea2c-fa47-4916-a830-68d3b0a9a8e6",
      "text": "Ukraine’s Infrastructure Minister Volodymyr Omelyan publicly discussed bilateral transport permit numbers (citing ~10,000 Polish permits for Ukrainian carriers) in the same period"
    },
    {
      "id": "142e6f0f-66ee-4e30-8fb6-5d1231933c62",
      "text": "Former Ukrainian Transport Minister Yevhen Chervonenko said on ZIK TV thousands of trucks were stuck on Ukraine’s western borders and could not enter Europe"
    },
    {
      "id": "b4b93ab7-a67d-477c-98ef-76796d962b14",
      "text": "Amnesty International press release calling on Ukraine to stop abuses by pro‑Ukrainian volunteer battalions (Aidar, etc.), citing unlawful detentions and summary killings."
    },
    {
      "id": "59a2e99c-785e-4708-9cab-e248cdc6dd5f",
      "text": "Office of the High Commissioner for Human Rights (OHCHR) report documenting egregious human‑rights abuses in Donetsk and Luhansk, including killings, abductions and restrictions on movement."
    },
    {
      "id": "53df0d0e-5777-43a7-b6a5-13dbe796107c",
      "text": "OHCHR/UN press release (2 March 2015) reporting that the death toll in eastern Ukraine had crossed 6,000 and documenting civilian casualties and impediments to people leaving conflict areas."
    },
    {
      "id": "8dda944c-daf5-4de1-abd2-519df4af39a7",
      "text": "Election of Andrzej Duda as President of Poland (conservative, Law and Justice party) in May 2015"
    },
    {
      "id": "7672a79d-ae4d-4dd0-a071-2e0e0ffc6d1c",
      "text": "Public reporting and leadership statements about slow or delayed Western arms deliveries to Ukraine (widely covered in mid‑September 2024)."
    },
    {
      "id": "6352eb6a-310e-4990-aa9d-97fb6f01ca44",
      "text": "Serhii Sternenko's profile as a high‑visibility Ukrainian activist with prior legal controversies and a large social following (making him a frequent target for smears and falsified attributions)."
    },
    {
      "id": "ee405ef0-07c3-43ed-a7a1-315200fbb76f",
      "text": "EMA Article‑31 referral and EU-wide review of combined hormonal contraceptives (procedure started Feb 2013; review communicated Nov 21, 2013)"
    },
    {
      "id": "40bf4e92-c095-4b70-949c-2ce4acdf7675",
      "text": "UK Drug Safety Update / MHRA communications and updated patient/prescriber leaflets on CHCs and VTE risk (published March 2014 and accompanying materials)"
    },
    {
      "id": "8e8e10a5-f251-4923-9aec-713685c45ce4",
      "text": "European Commission adoption of legally binding decision to update CHC product information (decision adopted 16 January 2014)"
    },
    {
      "id": "2685e2d0-c53b-4131-873c-e4506a1f0397",
      "text": "1995 UK 'pill scare' — Committee on Safety of Medicines advised that pills containing desogestrel/gestodene were linked to doubled VTE risk"
    },
    {
      "id": "2b7f1d81-e1c8-41a2-89d6-d34c18e9e551",
      "text": "Large-scale lawsuits and media coverage alleging manufacturers downplayed clot risks from newer contraceptives (Bayer Yaz/Yasmin settlements reported 2012)"
    },
    {
      "id": "7c174032-c3d6-4588-a644-ec1743e86a8c",
      "text": "Publication of a review summarizing research into engineered/measles-based oncolytic viruses as cancer immunotherapy (\"Measles Virus as an Oncolytic Immunotherapy\", PMC review)."
    },
    {
      "id": "473dea4a-3002-4416-a691-6b01312e1875",
      "text": "Andrei Makarevich performed charity concerts for displaced children in eastern Ukraine (Slov'yansk/Svyatohirsk)."
    },
    {
      "id": "860458dd-eabd-4f82-952f-5ddb0e5ba089",
      "text": "Makarevich attracted hostility earlier for publicly showing pro‑Ukrainian symbols (attending a Moscow peace march wearing Ukrainian‑coloured ribbons)."
    },
    {
      "id": "71d4a8ff-625e-4525-a6ab-860eefb4532d",
      "text": "Prominent pro‑Kremlin politicians publicly denounced Makarevich and called for stripping his state honors."
    },
    {
      "id": "be7102cb-0b57-4bc1-9d3a-f4ab5e05daf7",
      "text": "Clashes between Polish and Ukrainian football fans at Euro 2016 in Marseille (physical fights and arrests ahead of the Poland–Ukraine match)."
    },
    {
      "id": "0316ccf9-6f70-4db7-8f6b-5b8c19d9d765",
      "text": "Media reporting in 2016 of rising xenophobia and harassment directed at Ukrainians in Poland."
    },
    {
      "id": "54d4e00f-cf3a-42e9-a73b-ea9d732d99cd",
      "text": "Visible growth of far‑right and nationalist street movements and demonstrations in Poland during 2016."
    },
    {
      "id": "d4c4d200-1d08-4c8e-a9dd-35eda11cdfaf",
      "text": "Hamas attack on Israel and mass abductions created a large population of hostages and distressed families"
    },
    {
      "id": "44069781-87ef-498a-99ba-22f1d64541a8",
      "text": "Publication of a large South Korean retrospective cohort study in Biomarker Research reporting associations between COVID-19 vaccination and increased one‑year risks for six cancer types"
    },
    {
      "id": "88e2c9e1-bfa1-4d99-a82c-318741c224f9",
      "text": "FAO and other UN agencies warned of global food impacts from the Ukraine conflict and launched efforts to save Ukraine's harvest and keep exports flowing"
    },
    {
      "id": "05729b15-4eb7-4f82-a0b8-028aab48cbfe",
      "text": "European Union temporarily lifted import duties / quotas on Ukrainian agricultural products to support Ukraine's economy"
    },
    {
      "id": "e9d64a2b-a2bd-41aa-a143-f2c539d9bfee",
      "text": "Signing of the UN‑brokered Black Sea Grain Initiative (Istanbul) enabling safe maritime export corridor from Ukrainian ports"
    },
    {
      "id": "947907d3-1145-4f78-ac7c-d6cab87838c1",
      "text": "Human rights reports documenting abuses by both separatist forces and Ukrainian government forces (Human Rights Watch / Amnesty reports, 2014–2015)"
    },
    {
      "id": "83dbeb35-e014-4551-966a-5f97f62c8308",
      "text": "Polls reporting that many Ukrainians characterized the Donbas fighting as an 'intrastate' or internal conflict (KIIS / Democratic Initiatives Foundation, October 2015)"
    },
    {
      "id": "1b1b77c7-882b-4e3f-bba9-1f841f27246c",
      "text": "Signing of the Minsk II agreements (February 2015)"
    },
    {
      "id": "e2d654e4-dbb7-4eb1-97ec-2e7d3c55c4ac",
      "text": "Self‑declared independence referendums and proclamations by Donetsk and Luhansk 'people's republics' (May 2014)"
    },
    {
      "id": "bd31ef10-7bcd-4b4c-b37c-4a3b59cc3763",
      "text": "WHO published a public timeline of COVID‑19 events (WHO timeline) summarising early December 2019 detection milestones"
    },
    {
      "id": "ee4850dd-7ffb-488a-8195-1b9ae464b1e7",
      "text": "News reports (May 4–5, 2020) that a French pneumonia sample from December 27, 2019 later tested positive for SARS‑CoV‑2"
    },
    {
      "id": "219e1b1c-8243-46cd-ac04-413e5b148da6",
      "text": "European Union launched Permanent Structured Cooperation (PESCO) to deepen EU defence cooperation (formal decision adopted Dec 11, 2017)."
    },
    {
      "id": "ba602c99-8f43-4cd6-b850-ff63349886b1",
      "text": "U.S. imposed tariffs on steel and aluminium (March 2018) and the EU adopted retaliatory measures."
    },
    {
      "id": "9d543810-cd90-4ea8-9a60-e10f583ca1d0",
      "text": "President Trump ordered the withdrawal of U.S. troops from Syria (announced Dec 19, 2018)."
    },
    {
      "id": "76a2ce33-876f-41ad-be02-4b81d4ed8b2f",
      "text": "President Trump publicly berates NATO allies at the Brussels summit, warning the U.S. might 'go it alone' if allies do not meet defense spending targets."
    },
    {
      "id": "05ab73c2-13ed-4c61-9755-a7404dfd3d9d",
      "text": "U.S. announced it would withdraw from the Intermediate-Range Nuclear Forces (INF) Treaty (six‑month notice given Feb 2019)."
    },
    {
      "id": "72686c67-9f6f-4d0a-b620-e6f21ba98772",
      "text": "Ukrainian carrier Supernova reported to have received permits to operate scheduled Lviv–Prague and Kyiv–Prague routes (announced in media)"
    },
    {
      "id": "4421bcf8-b453-4431-ab63-16355715a87a",
      "text": "European (EASA) Part-TCO authorization for Supernova Airlines announced"
    },
    {
      "id": "d1e22a56-4fb4-48ea-8923-c7fd6cfda446",
      "text": "European Parliament / EU analyses and statistics showing significant trade and energy interdependence with Russia (2014–2017 trade data and briefings published in 2017)."
    },
    {
      "id": "6aa639db-03c0-4b01-9fbc-777e189f69c0",
      "text": "Campaign and political support in parts of Germany and among some EU businesses for the Nord Stream 2 gas pipeline (prominent coverage and analysis in 2016)."
    },
    {
      "id": "2ace17d3-8f02-490e-b49d-2b64f09dd61a",
      "text": "CDC/ACIP recommend use of the updated (bivalent) COVID-19 boosters"
    },
    {
      "id": "92da8ffe-8e6a-4c30-9fd3-a933e0c7944f",
      "text": "Russian official and media reaction emphasizing Tillerson's comments as signaling possible U.S. softness"
    },
    {
      "id": "2060306d-5f4b-41bb-ada9-748a449d8478",
      "text": "Hungary repeatedly raised public complaints and blocked aspects of Ukraine's Western integration over alleged mistreatment of the Hungarian minority in Zakarpattia, increasing bilateral tensions."
    },
    {
      "id": "bcf1bd89-e271-4922-887f-bb5f7e70e390",
      "text": "Reporting and analyses documented both an exodus of ethnic Hungarians from Transcarpathia after the 2022 invasion and cases of ethnic Hungarians voluntarily joining Ukrainian forces or local defense units."
    },
    {
      "id": "50f056ee-90f1-422e-a611-e7daa11ac02e",
      "text": "Ukraine's Security Service (SBU) and Ukrainian authorities reported Russian information‑operations specifically targeting the ethnic Hungarian community in Transcarpathia / Zakarpattia (including spoofed calls and other PSYOPs)."
    },
    {
      "id": "fc25b3c7-be1c-4b96-84cb-69e99ad4c46d",
      "text": "Ukraine imposed wartime restrictions and a de facto travel ban preventing most men aged 18–60 from leaving the country after the 2022 full‑scale invasion."
    },
    {
      "id": "953c492b-c744-4a84-b213-e9b94428c223",
      "text": "Alfa/Leopolis Jazz Fest was scheduled and ran in late June 2017 (festival dates June 23–27, 2017), contrary to claims of cancellation."
    },
    {
      "id": "1c00f5d4-6fe1-4dbc-ac7a-45c85eeb3e41",
      "text": "Reuters photo/coverage showing volunteers cleaning piles of trash in Lviv in the days before the festival (coverage dated June 21, 2017)."
    },
    {
      "id": "a71b831a-178e-4862-9a84-511f15e6709d",
      "text": "CDC MMWR report on large Delta-era outbreak in Provincetown, Massachusetts with many breakthrough infections among fully vaccinated people"
    },
    {
      "id": "e3500e27-e888-4724-a6b4-5960e5f31fed",
      "text": "UK Health Security Agency vaccine surveillance reports showing sharp drops in vaccine effectiveness against symptomatic Omicron infection after two doses"
    },
    {
      "id": "88fb0996-ffb1-445c-9668-1dcff6819ee4",
      "text": "Pfizer–BioNTech phase 3 trial press release reporting ~95% efficacy"
    },
    {
      "id": "e1657114-b637-4214-876d-1c44cbd5f35a",
      "text": "NEJM national Israel study showing measurable waning of BNT162b2 protection over months (Delta wave)"
    },
    {
      "id": "ae33c0c0-db6b-42ae-aa47-975f070d66a6",
      "text": "Pfizer–BioNTech press release reporting markedly reduced two‑dose neutralization of Omicron and restored neutralization after a booster"
    },
    {
      "id": "24a40309-8f9f-4bd0-a892-5f2c93b2a71b",
      "text": "Publication of IRENA & IEA-PVPS report projecting up to 78 million tonnes of PV waste by 2050"
    },
    {
      "id": "3d4673a3-de27-44d3-a1e5-effb6dc1176d",
      "text": "NREL analysis and surveys showing low recycling rates (less than ~10% of decommissioned panels recycled in the U.S.)"
    },
    {
      "id": "70547dff-f284-427f-879e-9e6023ef461f",
      "text": "BBC article 'Challenge to stop solar panels becoming a \"waste mountain\"' reporting experts' warnings"
    },
    {
      "id": "67c55d7f-e71d-4611-97f5-3bdb8dfe8633",
      "text": "Right Sector set up roadblocks and staged protests demanding the resignation of Interior Minister Arsen Avakov"
    },
    {
      "id": "29ff471a-38cc-4972-b722-d1604d010a06",
      "text": "Prime Minister Yatsenyuk ordered dismissal/replacement of Zakarpattia customs officers and heads in response to the Mukachevo events"
    },
    {
      "id": "67a93fc9-671c-47e0-aee7-dfb451276b9e",
      "text": "Mukachevo shootout between fighters linked to Right Sector and local police"
    },
    {
      "id": "bcb0a24f-a79e-48e3-8437-97fbd88492f0",
      "text": "Interior Minister Arsen Avakov suspended the Mukachevo police chief and launched an inspection of the regional police force"
    },
    {
      "id": "bf4d637a-e05a-4d3e-a455-88cdf3508e2c",
      "text": "Russian forces seize the Zaporizhzhia nuclear power plant (Europe's largest)"
    },
    {
      "id": "dc6827a3-d30d-4619-96df-ff5f48a04539",
      "text": "Russian President Vladimir Putin orders Russia's nuclear deterrent forces put on high alert"
    },
    {
      "id": "0a200067-762c-46ac-9ffa-57243ea19fec",
      "text": "President Zelensky’s public address to the Lowy Institute where he said NATO must 'eliminate the possibility' of Russia using nuclear weapons (speech and Q&A)"
    },
    {
      "id": "2d80d376-920e-4758-a774-6a5040fc0c0b",
      "text": "Reports of Chechen fighters volunteering in eastern Ukraine (Donbas)"
    },
    {
      "id": "42c2c04c-9907-43f9-8431-3121cb83ddd5",
      "text": "Crimean court bans the Mejlis (representative body of Crimean Tatars) as 'extremist' (April 2016)"
    },
    {
      "id": "ef246cff-ebb6-4e72-9c34-5ca9e92ad60a",
      "text": "European Parliament written question citing concerns about ISIS/Islamist sympathizers in territories disputed by Russia and Ukraine (July 2015)"
    },
    {
      "id": "b9f75f2f-b912-4eb7-a715-2a3476fd4d61",
      "text": "Assassination of former Ukrainian parliament speaker Andriy Parubiy in Lviv"
    },
    {
      "id": "2db0b5e8-a206-476c-aa14-7b391e6b99ad",
      "text": "Odessa Trade Unions House fire (May 2, 2014) and its contested narratives"
    },
    {
      "id": "83a51209-5cc5-4215-b5e9-78fd152529c7",
      "text": "The Federation Council of the Russian Federation approved President Vladimir Putin's request to use Russian armed forces in Ukraine."
    },
    {
      "id": "e97875a8-c2b6-4a26-bc2d-30b0ecf2ca4d",
      "text": "Unmarked armed personnel occupied airports, checkpoints and key sites across Crimea (the so-called 'little green men')."
    },
    {
      "id": "122f4e4d-2e37-49c2-9210-c4159692e31f",
      "text": "Masked gunmen seized the Crimean parliament and other government buildings in Simferopol, raising Russian flags."
    },
    {
      "id": "f49a66da-ca39-46c7-8ccb-816574d6aeee",
      "text": "Crimean parliament voted to hold a referendum (initially set for 16 March) on joining Russia and announced steps toward joining the Russian Federation."
    },
    {
      "id": "f932614e-5d4c-4983-a922-4fb00292c1d4",
      "text": "Large, atypical RSV surges in 2022 (U.S. and other countries) produced heightened public anxiety and searches for home remedies during and after the wave."
    },
    {
      "id": "735005b5-6c0f-4213-9991-80fff97528e3",
      "text": "Ukrainian authorities (SBU / MFA) declared some foreign visitors persona non grata and warned of entry bans after delegations visited occupied Crimea (reported March 2017)."
    },
    {
      "id": "56bf2861-efba-4614-9bf8-f103ed3ce2e3",
      "text": "INTERPOL issued Red Notices at Ukraine's request for former Ukrainian officials (including Yanukovych and Azarov)."
    },
    {
      "id": "0b2e1f7a-901a-493e-b33c-49abea435d30",
      "text": "European parliamentarians and other EU politicians (including MEPs) made unsanctioned visits to Russian-occupied Crimea and to separatist-held Donbas in 2015."
    },
    {
      "id": "8c023135-f2cd-4fdb-aaa0-7cb9bfa05242",
      "text": "Release of the IPCC Special Report 'Global Warming of 1.5°C' (high‑profile 2018 scientific assessment)"
    },
    {
      "id": "4063fbc8-7b7d-4331-850a-655023233079",
      "text": "CDC updates mask guidance for fully vaccinated people, recommending indoor masking in areas of substantial/high transmission."
    },
    {
      "id": "3496e957-884e-4e03-b8ca-f518cee17c14",
      "text": "Public Health England (PHE) monitoring and technical reports in mid‑2021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant compared with Alpha, while retaining strong protection against severe disease."
    },
    {
      "id": "3a18f009-e0b6-4e80-bf48-657ccaa32702",
      "text": "MMWR report on a large July 2021 outbreak in Barnstable County, Massachusetts found that a high proportion of cases were in fully vaccinated persons (reported in late July)."
    },
    {
      "id": "935ed015-beb2-49c7-b3ce-45b73a49fa97",
      "text": "FDA issued Guidance for Industry on 'Characterization and Qualification of Cell Substrates and Other Biological Materials Used in the Production of Viral Vaccines' (published March 4, 2010)."
    },
    {
      "id": "7dbda8b7-6dc2-4f99-9efd-c4b25f52bec3",
      "text": "Academic researchers (reported March 2010) detected DNA from porcine circovirus type 1 (PCV1) in batches of the oral rotavirus vaccine Rotarix; WHO and other regulators issued interim statements and convened reviews."
    },
    {
      "id": "8a4b0241-342c-4827-8a9e-3613060f8a2e",
      "text": "Historical contamination of early polio vaccines with simian virus 40 (SV40) used monkey kidney cell cultures; exposure occurred in vaccines administered 1955–1963."
    },
    {
      "id": "f0d69e4c-dea2-4889-ad46-5b748ccfdb27",
      "text": "Presence of Polish pro‑Russia political figures (e.g., Mateusz Piskorski) among 'international observers' who visited Crimea after the 2014 referendum."
    },
    {
      "id": "22ba4a14-399b-432d-91fb-360385c7bca3",
      "text": "Bill Gates invested in plant-based and cell-cultured meat companies (e.g., Impossible Foods, Beyond Meat, Memphis Meats/Upside Foods)."
    },
    {
      "id": "b9ca7673-b522-478a-9560-bdcbb303a813",
      "text": "Gates-funded research on microneedle patches and 'quantum-dot' vaccine markers that could encode vaccination history in skin."
    },
    {
      "id": "abfa0f4e-0a36-46e2-b9b4-97e806ceefe5",
      "text": "Development and trials of oral/tablet COVID-19 vaccine candidates (e.g., Vaxart dosing subjects in Phase II trials)."
    },
    {
      "id": "c2a81773-1b1f-43a1-a01f-72b8ee98337d",
      "text": "OHCHR reported lack of access to detainees held by armed groups in Donetsk and Luhansk, identifying numerous detention sites and documenting arbitrary detention"
    },
    {
      "id": "f0f7f5e7-cac1-4f62-bdee-68fbdbcfd4e5",
      "text": "ICRC participated in and confirmed large, complex detainee release/transfers in eastern Ukraine (largest exchange to date in 2017) at the request of the parties"
    },
    {
      "id": "d93f6f6c-3364-44b6-bda3-b17afee0e7ff",
      "text": "Minsk II agreement (Feb 2015) required 'release and exchange of all hostages and illegally held persons' (principle of 'all for all')"
    },
    {
      "id": "b338c65b-f306-44ea-b0b0-dd2cf6411423",
      "text": "European Parliament / international reporting on Russian restrictions and de facto blockade of shipping access to Ukrainian ports in the Sea of Azov."
    },
    {
      "id": "d7c58d96-458f-4f49-bf5a-18b1b8b77ae7",
      "text": "Kerch Strait incident: Russian forces fired on and captured three Ukrainian naval vessels attempting to transit the Kerch Strait."
    },
    {
      "id": "4cbc186a-b813-456f-bb6a-e010b138c2ca",
      "text": "Deployment of advanced Russian coastal and air‑defense systems (S-400/Bastion/Bal) to Crimea and surrounding Black Sea region."
    },
    {
      "id": "da287e57-b1d7-47c8-b66f-9376a1577d52",
      "text": "IPCC Sixth Assessment Synthesis Report (AR6 SYR) published — clear attribution of recent warming to human activities"
    },
    {
      "id": "6e955dd5-abae-45ae-b58c-2a25b9bdeacb",
      "text": "NOAA educational page summarising limits of weather‑forecast skill (noting 5–7 day forecasts are much more reliable than 10+ day forecasts)"
    },
    {
      "id": "71af64b6-cc21-4c97-b9df-d1f091361b50",
      "text": "Publication on multi‑centennial Holocene climate variability in proxy records (peer‑reviewed synthesis)"
    },
    {
      "id": "bec49b2d-abe0-4438-97ae-8114b1d576d6",
      "text": "Congressional scrutiny and subpoenas over the Karl et al. (2015) NOAA paper (House Science Committee inquiries led by Rep. Lamar Smith in summer–fall 2015)."
    },
    {
      "id": "f9c60b69-b6de-4c88-91b4-2f9ca3baf7b6",
      "text": "IPCC AR5 (Working Group I) reported a reduced rate of surface warming during 1998–2012 compared with the late 20th century, noting variability and shorter-term trends."
    },
    {
      "id": "e2cc944e-8a81-4438-83eb-08e38d9b479c",
      "text": "Public vaccine surveillance reports (e.g., UK Health Security Agency vaccine surveillance reports 2022) showing waning vaccine effectiveness against infection and, in some high‑coverage populations, increasing proportions of cases occurring in vaccinated people"
    },
    {
      "id": "dbb0569a-302d-4f5c-b3cf-3a621d6d4b2f",
      "text": "WHO classification and global reporting of the Omicron (B.1.1.529) variant showing substantial immune escape from prior infection and reducing vaccine neutralisation (press statement and technical brief)"
    },
    {
      "id": "5146a220-e5e7-48de-9436-17e028427749",
      "text": "CDC confirmation and public communication about rare cases of myocarditis/pericarditis following mRNA COVID-19 vaccination (recognition, safety monitoring and guidance)"
    },
    {
      "id": "188ad611-b2ac-49e2-a256-aa170e3d2b3e",
      "text": "WHO publication and recognition of 'post‑COVID‑19 condition' (long COVID) with a clinical case definition (Delphi consensus)"
    },
    {
      "id": "4dc240ff-2439-42ae-9041-8ee9ee997a0f",
      "text": "Regulatory authorisations and public announcements of updated (bivalent) COVID-19 boosters for fall 2022 citing the need to match evolving variants (FDA/other regulators authorization and press releases)"
    },
    {
      "id": "4dd8251d-5251-4520-8558-720daed2ff0c",
      "text": "Transparency International / Global Corruption Barometer findings (2016) documenting pervasive corruption in Ukraine"
    },
    {
      "id": "e9675adb-0f21-4945-b4f2-dd37623e09f8",
      "text": "World Customs Organization press release on a large heroin seizure in Ukraine (Odessa/Illichivsk), June 2015"
    },
    {
      "id": "384dfcd4-e781-4db3-90f5-e95202c64b81",
      "text": "Polish government/NGO training and support for Ukrainian forces (Poland offered to train Ukrainian military staff)"
    },
    {
      "id": "3085bd89-d3bb-4c87-a766-de3c40938e9f",
      "text": "Documented reports of individual Polish nationals killed or wounded while fighting in Donbas"
    },
    {
      "id": "ae04d801-546a-4bb5-890c-ef37544c9aee",
      "text": "NATO's enhanced forward presence and increased multinational troop rotations in Poland (2016)"
    },
    {
      "id": "915f5621-6d1b-4b9d-aa6d-d4e936f4532c",
      "text": "Contamination reports and temporary suspension of some Moderna vaccine batches in Japan"
    },
    {
      "id": "6f09bd0c-0e65-4bb7-b328-075cce279abd",
      "text": "Regulatory and public reporting of rare myocarditis/pericarditis cases after mRNA COVID-19 vaccination"
    },
    {
      "id": "7d776a28-7b36-4b50-9d79-600c7c814f14",
      "text": "Media reports in late 2022 highlighting rising non-COVID excess deaths (e.g., increased deaths at home and concerns about NHS pressures)"
    },
    {
      "id": "0dea2bad-4966-43e5-9b98-11201c1df71d",
      "text": "2015 transfer of HAARP operations from the U.S. Air Force to the University of Alaska–Fairbanks (publicized as HAARP reopening for civilian research)."
    },
    {
      "id": "4b8c7205-ffdb-4751-b92c-67b4ce7f2008",
      "text": "Reporting on the so‑called \"Havana Syndrome\" (2016–2018) and investigations into possible microwave or directed‑energy causes, including a 2018 New York Times piece."
    },
    {
      "id": "b0eb15c0-c4de-4a46-addd-03f1a89f3421",
      "text": "Venezuelan President Hugo Chávez suggested HAARP or a \"tectonic weapon\" was responsible for the 2010 Haiti earthquake."
    },
    {
      "id": "4f129350-7db8-4427-9b00-04dce5d486ea",
      "text": "Intense Russian airstrikes and attacks on Zhytomyr region widely reported in international media (creating fear of occupation and evacuation)"
    },
    {
      "id": "eeed5b28-33d1-4972-95cb-16d716b43dc8",
      "text": "IARC/WHO press release classifying processed meat as a Group 1 carcinogen"
    },
    {
      "id": "ec1376a1-9b3c-404c-8cd8-9f9902afcb67",
      "text": "Longstanding public-health/home‑remedy guidance and consumer health sites recommend salt‑water gargles to soothe sore throats (widely available on NHS and similar sites)"
    },
    {
      "id": "d4dc283f-b1c3-459a-bfec-67d2ecc4af27",
      "text": "Previous French domestic plots / trials over assassination attempts on Macron (far-right militants convicted/trialed)"
    },
    {
      "id": "7ebce2cb-ebc2-4687-af49-e93e9583f48c",
      "text": "France announced plans to send long-range SCALP missiles to Ukraine"
    },
    {
      "id": "2a613509-27f3-4c6a-8d5a-53cba97112f0",
      "text": "French presidency postpones Macron's planned visit to Kyiv citing security concerns"
    },
    {
      "id": "67125cac-09db-4955-96c3-0b30d5ed593e",
      "text": "IMF approved a large $17.5 billion extended loan programme for Ukraine, making Kyiv dependent on sizeable external financing and programme conditionality."
    },
    {
      "id": "c7818cf5-a11a-46a6-89ad-10c0a908a17c",
      "text": "National Bank of Ukraine unexpectedly raised its key policy rate to 17.5% to combat inflation risks and warned that delays with IMF support posed a risk to stability."
    },
    {
      "id": "ebec5226-e1a3-41dc-aadc-8c4d372988e5",
      "text": "Government nationalised PrivatBank, Ukraine's largest commercial bank, to protect financial stability after identifying large capital shortfalls at the lender."
    },
    {
      "id": "f7f20864-e23f-4165-ab6e-b8e2e6f7132a",
      "text": "The hryvnia plunged sharply in 2014 after the central bank abandoned foreign-currency auctions and the exchange rate was allowed to adjust amid political and security shocks."
    },
    {
      "id": "cf3a8103-e2e8-492a-9f1f-a7dd04cc356c",
      "text": "Ukraine's President signed a package of laws and administrative measures in late 2015 intended to meet benchmarks for EU visa liberalisation."
    },
    {
      "id": "f1cd3541-52d1-4c2b-b35f-d77cdbb63f03",
      "text": "Ukraine announced introduction of new plastic/passport-card style internal passports to be issued from January 2016."
    },
    {
      "id": "e21d969f-a42d-4c4b-8725-212fe1e8088d",
      "text": "Direct air links and other travel ties between Russia and Ukraine were suspended/curtailed in 2015 (e.g., bans on direct flights announced in October 2015)."
    },
    {
      "id": "64e42c4d-df6b-4b15-b5dc-f14f3b4fc034",
      "text": "European Commission published its final report/conclusions on Ukraine's readiness for a visa-free regime with the EU (COM(2015)905) and related publicity in mid-December 2015."
    },
    {
      "id": "41f6a186-93a6-4690-83c2-2d9877871901",
      "text": "Ukraine's Finance Minister Oleksandr Danyliuk warns Ukraine may forgo hosting due to high costs and urges sober assessment"
    },
    {
      "id": "51cbcb31-0b5c-4bd7-ae82-dc02ba6017bc",
      "text": "Government announces open national selection for host city and says municipalities/investors/donors must share financial risks"
    },
    {
      "id": "9b854e37-9c9e-4f39-a6a5-816a922b9cbb",
      "text": "Ukraine wins Eurovision 2016 (Jamala) — international expectation that Ukraine must host Eurovision 2017"
    },
    {
      "id": "2401f7d5-d48e-4e43-9dc9-08014ecfb9ef",
      "text": "White House OSTP releases the Congressionally-Mandated Report on Solar Radiation Modification (SRM) research plan"
    },
    {
      "id": "fbe9998c-0872-4191-9671-4703a96531fc",
      "text": "Mexican government announces a ban on solar geoengineering experiments (SEMARNAT press release)"
    },
    {
      "id": "7489dbad-ad68-456a-a7f1-aad2fd62f893",
      "text": "Israel's booster campaign and reporting in July–August 2021 on reduced effectiveness of two doses vs Delta and need for third dose"
    },
    {
      "id": "3c13d2b5-6089-49e4-9322-256539a27b03",
      "text": "CDC reverses earlier guidance and on July 27, 2021 recommends indoor masking for vaccinated people in areas of substantial/high transmission"
    },
    {
      "id": "63985ce7-5217-4874-aa7e-24ca4ef61575",
      "text": "U.S. federal Order requiring masks on conveyances and at transportation hubs (published in Federal Register, Feb 2021)"
    },
    {
      "id": "7361180e-2a2f-4df7-ae35-2f45e047a9e4",
      "text": "CDC MMWR report on Barnstable County (Provincetown) outbreak showing many vaccine breakthrough infections"
    },
    {
      "id": "141eae5a-1061-484d-80c5-2ea0fa66e353",
      "text": "Japan suspended ~1.63 million doses of Moderna vaccine over reports of foreign particles (August 2021)"
    },
    {
      "id": "309aaf99-7ac7-4ac2-abed-8aeacdbab127",
      "text": "European Medicines Agency (EMA) concluded there was a possible link between AstraZeneca's vaccine and very rare blood clots (April 7, 2021)"
    },
    {
      "id": "e5390f9e-da3a-4148-80de-bf8344b833d4",
      "text": "NATO publicly said Viktor Orbán’s planned Moscow trip had been flagged to the alliance in advance."
    },
    {
      "id": "b0d99ec5-93b7-4482-8ede-56df90294fbd",
      "text": "Serbian President Aleksandar Vučić attended Russia’s Victory Day events in Moscow (including presence at May 9 commemorations) and posted images from the trip."
    },
    {
      "id": "3d45140a-ed02-4989-9a2c-1c430911137a",
      "text": "Slovak Prime Minister Robert Fico made a surprise visit to Moscow and met with President Vladimir Putin."
    },
    {
      "id": "b4598419-3888-470c-af66-54e429df15bf",
      "text": "Amnesty International briefing calling on Ukrainian authorities to investigate abuses by Aidar and other volunteer battalions operating alongside regular forces"
    },
    {
      "id": "637e855b-69a7-450a-887a-26e9d48f94ad",
      "text": "OSCE Special Monitoring Mission spot report on civilian fatalities and damage after shelling of residential areas in Donetsk"
    },
    {
      "id": "ddbca3ee-3ce3-4f10-a6be-56733bb2151e",
      "text": "Assassination of Denis Voronenkov, a Russian defector, who was shot dead in Kyiv"
    },
    {
      "id": "e4e829f8-e504-4cee-b1aa-f2baf9a93288",
      "text": "UN General Assembly adopted a resolution (March 2, 2022) overwhelmingly deploring Russia's aggression and stating it was in violation of the UN Charter."
    },
    {
      "id": "4376bf3f-5cf3-40a8-8f0c-41c20cad6dc5",
      "text": "Russia formally recognized the independence of the Donetsk and Luhansk People's Republics and ordered troop deployments to the regions."
    },
    {
      "id": "4e458c17-6cf6-466b-9154-435a6288efd2",
      "text": "President Vladimir Putin announced a 'special military operation' in Ukraine, describing aims like 'demilitarisation' and protection of people in Donbas."
    },
    {
      "id": "88769019-7241-46e9-89a4-31caadd73597",
      "text": "Announcements that Ukraine would open additional consulates in Poland to assist large numbers of Ukrainian citizens/refugees."
    },
    {
      "id": "f572f129-d8bb-4d0f-9092-aa36d5fd0212",
      "text": "Polish President Andrzej Duda visited Kyiv and addressed Ukraine's parliament, emphasizing deep political solidarity and saying only Ukraine should decide its future (public statements of unity)."
    },
    {
      "id": "1baeb73c-ac77-4cb4-8916-b2601cef55ba",
      "text": "Earlier Russian security/intelligence figures publicly alleged Polish preparations to annex parts of western Ukraine (remarks by Russian officials reported Nov 30, 2021 onward)."
    },
    {
      "id": "0646c5a9-5c8f-49eb-9cdc-2558df2f7305",
      "text": "Pro‑Russian activists in Kharkiv occupied the regional administration and declared a short‑lived 'Kharkiv People's Republic'."
    },
    {
      "id": "757568b7-5fb3-450a-a580-24ec7dcfa129",
      "text": "Deadly clashes in Odesa on 2 May 2014, culminating in a Trade Unions House fire with dozens killed."
    },
    {
      "id": "1c591bd1-dbaa-4054-972f-d74e7ab91f32",
      "text": "Parliamentary moves in Feb 2014 to repeal the 2012 'regional language' law and intense debate over language rights."
    },
    {
      "id": "aded59d1-81bb-4062-88ec-1b2e1e7280a1",
      "text": "Widespread pro‑Russian 'anti‑Maidan' protests and occupations across eastern and southern Ukraine (including demonstrations in Mykolaiv) in March–April 2014."
    },
    {
      "id": "49c572cb-93f0-43ca-967a-98c59897f32d",
      "text": "May 2014 'referendums' in parts of Donetsk and Luhansk and subsequent Russian recognition of separatist results."
    },
    {
      "id": "f22893c8-3eff-4926-a412-e01a874ff8ee",
      "text": "Mass drone attacks and reported strikes on Kursk region (fires, evacuations)"
    },
    {
      "id": "62fbb347-74d8-4b62-b3a1-4365c6c770ad",
      "text": "Tymoshenko proposes creation of an 'operative headquarters' of defense and military specialists to respond to Russian aggression"
    },
    {
      "id": "02047144-2738-4eae-997b-c9787c165309",
      "text": "A draft resolution to dismiss Prime Minister Yatsenyuk is registered in the Verkhovna Rada (parliament) after coalition tensions"
    },
    {
      "id": "2ca134f3-5109-4df4-a29d-3cdda4a037a5",
      "text": "Leader of Batkivshchyna (Yulia Tymoshenko) announces her party is quitting Ukraine’s ruling coalition"
    },
    {
      "id": "352c1b61-38ec-42ec-962a-8f2fda4f862f",
      "text": "Parliament holds and fails to pass a no‑confidence motion against Prime Minister Arseniy Yatsenyuk, deepening government crisis"
    },
    {
      "id": "cfbfad32-bf43-45f1-82f7-50acd200b119",
      "text": "National Snow and Ice Data Center (NSIDC) satellite record: Antarctic sea ice reached a daily/seasonal maximum record (20.11 million km²) on 22 September 2014."
    },
    {
      "id": "2d5fa91c-6d11-4f83-a35b-5bad53ec7012",
      "text": "Peer-reviewed synthesis and high-profile press coverage showing Antarctic land-ice (ice sheet) mass loss accelerated in recent decades (IMBIE / Nature analysis publicized June 2018)."
    },
    {
      "id": "11d456c9-0719-478d-aca3-53788064de86",
      "text": "Research identifying the Southern Annular Mode (SAM), ozone‑hole effects, and wind-driven ocean processes as major drivers of Antarctic sea-ice variability (peer-reviewed work and reviews, mid-2010s)."
    },
    {
      "id": "21cdf176-577c-473e-a896-32788b43445c",
      "text": "Amnesty International / IBGDH report documenting human-rights abuses and environmental harm linked to cobalt mining in the Democratic Republic of Congo."
    },
    {
      "id": "634f6a08-dbbe-4adc-b386-e4e4cabfe4ec",
      "text": "AP and international reporting on environmental concerns around large nickel/nickel-processing projects for EV batteries in Indonesia (coverage of environmental NGO warnings about mining/processing impacts)."
    },
    {
      "id": "77e453a4-b968-43ee-ba2f-2f8f4f402e47",
      "text": "Major media coverage summarising life‑cycle analyses that show EV battery manufacture can be carbon‑intensive (New York Times feature on EV battery emissions)."
    },
    {
      "id": "86962d4c-646b-4814-bed6-c43ad623d9f6",
      "text": "IEA Electricity Mid‑Year Update 2024 noting faster global electricity demand growth and a temporary plateau in power‑sector emissions in 2024."
    },
    {
      "id": "7777291f-bd26-463c-aceb-ef76ba3549fe",
      "text": "IPCC Fifth Assessment Report (AR5) release documenting observed increases in sea‑level rise rate and attributing recent changes largely to human influence"
    },
    {
      "id": "c0f58f86-2857-4261-aff7-9ae691852fce",
      "text": "NOAA / national tide‑gauge and satellite datasets made public (NOAA sea level trends pages and graphics widely cited in media, 2013–2016)"
    },
    {
      "id": "5036018a-13f3-41b2-8d57-c2b8539ee8a8",
      "text": "Visa‑free travel for Ukrainian citizens to the Schengen area came into effect"
    },
    {
      "id": "ba84c644-7454-4df8-8b26-8847ed80bb8f",
      "text": "Launch of the European Union Advisory Mission (EUAM) to Ukraine (civilian security reform)"
    },
    {
      "id": "4352707d-d0be-4b31-a45d-0a646b63f2aa",
      "text": "Signing of the EU–Ukraine Association Agreement (including Justice, Freedom and Security provisions)"
    },
    {
      "id": "7bc32684-567d-4629-8d1a-f8d2316ff03f",
      "text": "2008 EFSA scientific opinion sets a tolerable weekly intake for aluminium and warns dietary exposure may exceed it"
    },
    {
      "id": "7b8cb1db-e06f-46ea-9024-40ba0b35f6ba",
      "text": "State-level restaurant COVID‑19 prevention checklist (published Aug 14, 2020) that included the specific line about inverted face shields for front‑of‑house staff."
    },
    {
      "id": "142ed585-ebe1-4eaa-a149-9415efcd90f6",
      "text": "Passage and implementation of laws and measures recognizing certain WWII-era Ukrainian nationalist formations (e.g., granting veteran status to surviving members of the Ukrainian Insurgent Army in 2019) and debates about nationalist memory."
    },
    {
      "id": "7dc05c9d-0db8-4449-baee-f75aa2104f1d",
      "text": "Earlier controversy over proposals to 'universalize' the Babi Yar memorial (design competition and wording), which Jewish groups and historians publicly criticized as potentially downplaying the site's Holocaust significance."
    },
    {
      "id": "f4263275-9b32-4ed9-b972-fc6d18183e50",
      "text": "Decommunization laws and large-scale removal/renaming of Soviet-era monuments and symbols (2015) that shifted public commemorations and provoked international debate over historical memory in Ukraine."
    },
    {
      "id": "0f6cce71-8ea2-4fd8-984d-daac4761d8d1",
      "text": "NIA-AA (National Institute on Aging–Alzheimer's Association) publishes revised diagnostic framework recognizing preclinical stages of Alzheimer's disease"
    },
    {
      "id": "87a6bcaf-9d2f-47e0-bd9f-67b9b1645d88",
      "text": "OSCE Special Monitoring Mission spot reports of repeated shelling incidents in Donetsk city (late January 2015)"
    },
    {
      "id": "201ff659-56bf-4fad-8c16-6c89a915998b",
      "text": "Amnesty International briefing documenting summary/extrajudicial killings in eastern Ukraine"
    },
    {
      "id": "b8d1de50-bd34-4c0f-8aee-fed5d630ee6f",
      "text": "Shelling of Mariupol market and residential areas, killing dozens of civilians"
    },
    {
      "id": "02a296f9-7cb5-40c4-8127-126855d90c32",
      "text": "Reports documented Ukrainian policemen and small military units in eastern Ukraine siding with or defecting to pro-Russian separatists during the spring 2014 unrest."
    },
    {
      "id": "1bd6ec24-448e-4a14-8f18-82099dd796ff",
      "text": "Pro‑Russian separatists shot down a Ukrainian military helicopter in late May 2014 and widely publicized battlefield successes and captures."
    },
    {
      "id": "2194d3c4-cf89-4d0e-ae1e-827648bcbe1c",
      "text": "ISUOG/other professional statements discouraging non‑diagnostic/'keepsake' ultrasound use (position on non‑diagnostic ultrasound)"
    },
    {
      "id": "18ddd34a-9fa0-4725-90cb-2d8e26369028",
      "text": "Small clinical study reporting increased apoptosis in human chorionic villus cells after transvaginal ultrasound exposure"
    },
    {
      "id": "6e9d08e7-e9f8-40c8-9f92-dc69836d6373",
      "text": "Reports that politicians and foreign diplomats joined or publicly supported Kyiv Pride 2019"
    },
    {
      "id": "fdddd839-4566-469f-9d0c-0f675b3b4917",
      "text": "Eurovision Song Contest hosted in Kyiv with 'Celebrate Diversity' messaging (Eurovision 2017)"
    },
    {
      "id": "c2821d80-7208-495d-847c-7f11fb7194a5",
      "text": "Kharkiv region introduced scheduled/rolling electricity restrictions (blackout schedules) for large numbers of consumers after infrastructure damage."
    },
    {
      "id": "50b2f529-578d-47e2-9c73-e314c368fe32",
      "text": "Ukrenergo announced plans to export a record volume of electricity (planned 13,264 MWh) to neighboring EU countries on March 4, 2024."
    },
    {
      "id": "f00928b3-8beb-49ff-a99b-33ba4c9c14f9",
      "text": "Russian missile/drone strikes on Kharkiv energy infrastructure knocked out power across the city."
    },
    {
      "id": "3a67b905-6bc5-4a63-a38a-674a9505a860",
      "text": "Official public messaging (e.g., Ukrainian energy minister and Ukrenergo statements) emphasizing that exports occur only when domestic supply is sufficient and that domestic priority is maintained."
    },
    {
      "id": "f127102b-7adb-4e68-a451-2425dbba1859",
      "text": "National Weather Service offices issued multiple Flash Flood Warnings and at least one Flash Flood Emergency for the Guadalupe River corridor (noting automated gauges and forecasts indicated a large, deadly flood wave)."
    },
    {
      "id": "4e37ba87-f258-4e45-aa42-2637e01fc449",
      "text": "Reports of foreign/black particles found in some Moderna vials in Japan led to temporary suspension/recall of batches (September 2021)."
    },
    {
      "id": "af00b07a-963b-4f13-a913-e5d137abd6bf",
      "text": "Publication of Israeli population-based analyses documenting cases of myocarditis after BNT162b2 (Pfizer–BioNTech) vaccination (peer‑reviewed NEJM report)."
    },
    {
      "id": "fe2508ca-6116-4a3d-9737-4aa7db42765e",
      "text": "U.S. FDA and other regulators moved in 2016–2018 to restrict or review certain antiseptic/antimicrobial ingredients (e.g., FDA final rule on triclosan and other antiseptic ingredients in consumer wash products in Sept 2016)."
    },
    {
      "id": "1b015b0e-a03c-4937-9823-1bacacf9829b",
      "text": "Ukraine’s State Service for Drug Control recalled 18 products manufactured by the Bioorganic Chemistry Institute’s experimental plant (licensing violations reported)."
    },
    {
      "id": "4b04968a-40d3-40cb-8c8c-0b5c8f8f8725",
      "text": "Public controversy and intense debate around Suprun’s health‑care reforms (wide press and academic coverage, including critical and supportive pieces in 2017–2018)."
    },
    {
      "id": "ee9c0543-ba4c-4325-86bf-12846a45e075",
      "text": "FDA expanded Emergency Use Authorization for the Pfizer–BioNTech COVID-19 vaccine to adolescents aged 12–15."
    },
    {
      "id": "bd97003f-74ba-4fd8-b575-c82690bdbc1b",
      "text": "Discovery of foreign (stainless steel) particles in some Moderna vaccine vials in Japan led to temporary lot suspensions and recalls."
    },
    {
      "id": "23ef675c-fb76-413b-862f-99a1e72bbe7d",
      "text": "Public reports and CDC/ACIP review of rare myocarditis/pericarditis cases occurring after mRNA vaccination in adolescents and young adults."
    },
    {
      "id": "863f8eb6-77ed-4cef-a8fd-1980608e3e64",
      "text": "The Orthodox Church of Ukraine and other Ukrainian church bodies publicly reiterated they do not endorse Halloween celebrations (OCU posted an explanatory statement on its official Facebook page on the eve of Halloween)."
    },
    {
      "id": "710fc521-cb74-480a-9af7-4ec589ecdc6d",
      "text": "WHO and national agencies adopted/issued interim coding guidance and the emergency ICD-10 code (U07.1) for COVID-19 to standardize mortality reporting in Spring 2020."
    },
    {
      "id": "eeefd7e6-0935-4089-a906-74c5a26488f5",
      "text": "Local jurisdictions (notably New York City) added 'probable' COVID-19 deaths to counts in April 2020, producing sudden, large increases in reported death totals."
    },
    {
      "id": "b1b2ebea-a5ff-4862-8b01-03ef9d085242",
      "text": "Launch of the EU External Investment Plan (EIP) / European Fund for Sustainable Development"
    },
    {
      "id": "f1d018c9-5f57-468e-a553-f54406863636",
      "text": "EU–Turkey migration statement and related migration-management deals"
    },
    {
      "id": "b8abbef3-c963-4eaf-839c-91e40f2a474e",
      "text": "Establishment and deployment of EU military training missions in the Sahel (EUTM Mali)"
    },
    {
      "id": "6cc5144d-233a-4d4f-9640-ad6d90f72bf5",
      "text": "UK Health Security Agency technical briefing reporting substantially reduced vaccine effectiveness against symptomatic Omicron (Technical Briefing, Dec 31, 2021)."
    },
    {
      "id": "a4e248bb-f94a-4156-905d-17848d31e342",
      "text": "Mainstream news coverage summarising Danish results and the impact of boosters (e.g., Reuters coverage, Dec 22, 2021)."
    },
    {
      "id": "85681712-7d60-4155-8edf-867cd1052f0c",
      "text": "Poroshenko publicly sought NATO/allied military cooperation and repeatedly called for allied support at NATO meetings (joint press conference at NATO Headquarters)."
    },
    {
      "id": "3b6b889a-8e36-4d97-a4a7-771df6caa01e",
      "text": "Visible NATO exercises and increased allied air policing on NATO’s eastern flank (e.g., NATO and partner air forces training over the Baltic Sea, April 21, 2016)."
    },
    {
      "id": "404a1fc2-b7e5-42ec-9a0d-c3fbed70fd5a",
      "text": "Frontiers in Microbiology review highlighting mechanisms and clinical interest in manuka honey's antibacterial properties."
    },
    {
      "id": "0b0c9c20-af04-44ba-8190-bf7deeebc033",
      "text": "FDA approval of Flucelvax Quadrivalent (cell‑based quadrivalent influenza vaccine) and release of package/clinical documents mentioning MDCK cells"
    },
    {
      "id": "75e9d959-28f3-4ac3-b543-a46afb1c8735",
      "text": "Russian forces seized and occupied the Kakhovka (Nova Kakhovka) Hydroelectric Power Plant; satellite imagery showed Russian troops and equipment at the facility."
    },
    {
      "id": "75a831c9-64bc-48da-b175-a2437e47dd83",
      "text": "The Kakhovka HPP and Nova Kakhovka were repeatedly struck and reported damaged during summer 2022 (including reported HIMARS strikes on July 11, 2022)."
    },
    {
      "id": "97350da0-d1db-4b53-a3fc-ef06b13b945c",
      "text": "Arson and vandalism of mobile phone masts reported in the UK"
    },
    {
      "id": "2950345a-e866-4de3-92f1-2cb1e4c25f8f",
      "text": "Russian drone strike destroyed the Roman Shukhevych (UPA) Museum on the outskirts of Lviv."
    },
    {
      "id": "7db6c8a6-60bc-4662-b2dc-199aa561b87e",
      "text": "Widespread reporting since 2022 documented Russian forces looting and removing artifacts from Ukrainian museums (establishing a precedent of cultural theft and illicit sales)."
    },
    {
      "id": "ea7a2b72-7d1f-4c73-a073-a7b027631757",
      "text": "Implementation of the 2004 education reform increasing Latvian-language instruction in minority schools (the '60/40' reform)"
    },
    {
      "id": "201f7365-3e62-47f1-9210-042b45108003",
      "text": "2012 constitutional referendum on making Russian a second official language, which was decisively rejected (18 February 2012)"
    },
    {
      "id": "b7b32401-5690-41a0-af65-8ece78fd91fe",
      "text": "A 2022 edition of 11th‑grade history outline maps was published by Kartohrafiya (ISBN 978-966-946-460-6), a commonly used educational map source in Ukraine."
    },
    {
      "id": "c8de3f3a-96b2-48a0-bace-ff2c0f38239c",
      "text": "Precedent of flights from occupied Crimea to third countries (despite sanctions) documented in prior years (examples 2016–2018), showing routes and carriers operating non‑Ukrainian international services."
    },
    {
      "id": "157e34be-f855-4ce9-bf07-9c26d1427230",
      "text": "Russian carrier Ikar (Pegas Fly) reported/planned to launch flights linking Yerevan and Simferopol (Crimea)."
    },
    {
      "id": "a5d1d62e-20f0-40cd-9604-245b0e5f8830",
      "text": "Major cancer-care organizations publish warnings that there is no reliable clinical evidence soursop (graviola) cures cancer and note potential harms"
    },
    {
      "id": "61eb6e4e-8226-4649-a28c-6a1d5143a326",
      "text": "Peer-reviewed isolation and characterization of annonaceous acetogenins from Graviola showing potent in vitro anti-proliferative activity against human cancer cell lines"
    },
    {
      "id": "6ee233fb-18ce-46c2-9236-b4b2ba49b6e8",
      "text": "State‑level legislative changes and debates in 2024 expanding legality or easing restrictions on raw‑milk sales (e.g., new limited sales allowances in some states)"
    },
    {
      "id": "f9972a21-0ed8-4c53-8835-ca063429c525",
      "text": "Large disruptions and later rebounds in cancer screening and diagnoses during the COVID‑19 pandemic became widely reported (fewer screenings in 2020 then partial catch-up), creating confusing temporal patterns in cancer incidence data."
    },
    {
      "id": "471b5c6a-be85-43f0-8f08-c5d4074a62de",
      "text": "OSCE Special Monitoring Mission (SMM) spot reports documenting civilian casualties and intensified fighting in Donetsk and Luhansk in October 2014."
    },
    {
      "id": "3254bd8f-d52e-4eb5-9cac-a67f2dc656e4",
      "text": "UN Office of the High Commissioner for Human Rights (OHCHR) report on the human rights situation in the context of the anti‑terrorist operation (ATO) documenting detentions, abuses and civilian harm (July 2014)."
    },
    {
      "id": "e1e86014-5779-43c2-a83e-e8910c811c28",
      "text": "President Petro Poroshenko and other Ukrainian officials publicly described pro‑Russian fighters as 'terrorists' in mid‑2014 interviews and statements."
    },
    {
      "id": "e5f9b0d6-7e73-4a08-aa88-88ca82ea4f7a",
      "text": "High‑profile activity and imagery of far‑right Ukrainian groups (e.g., Svoboda torchlit march, January 2014) widely reported in international media."
    },
    {
      "id": "c265307b-a45e-40d2-942e-064e09203a3b",
      "text": "Russia blocked a Western-backed UN Security Council statement condemning the shelling of Mariupol."
    },
    {
      "id": "80874662-775d-4097-ab12-519fd35a8af0",
      "text": "UN Secretary-General Ban Ki-moon publicly condemned the rocket attack on Mariupol in a UN spokesperson/secretariat statement."
    },
    {
      "id": "b6debf5b-3fd9-4758-8d65-ddcfa76159c1",
      "text": "OSCE Special Monitoring Mission (SMM) spot report and multiple media outlets reported heavy MLRS/rocket shelling in Mariupol with dozens of civilian casualties."
    },
    {
      "id": "98bf6bd9-3571-4fc4-a522-793f28993ff1",
      "text": "CDC MMWR report on allergic reactions (including anaphylaxis) after first doses of Pfizer‑BioNTech vaccine (covering Dec 14–23, 2020)"
    },
    {
      "id": "de7db6fd-2ae6-4f7a-b2d2-140c467a7909",
      "text": "FDA VRBPAC briefing and safety review documents for Moderna COVID-19 vaccine (presented to advisory committee)"
    },
    {
      "id": "3737c0e5-0ce0-43f5-85a5-06097bb825b7",
      "text": "Publication of Moderna (mRNA-1273) Phase 3 (COVE) trial reporting safety/reactogenicity data in NEJM"
    },
    {
      "id": "041efd3d-3637-4fdb-883e-7e7a15720adb",
      "text": "WHO/UNICEF reporting on Sudan circulating vaccine‑derived poliovirus type 2 (cVDPV2) outbreak (declared Aug 2020; press coverage Sept 2020)"
    },
    {
      "id": "e0fadef7-8cb0-400b-87ba-015ee4371568",
      "text": "CFSRE (Center for Forensic Science Research & Education) issues Q2 2024 Trend Report documenting rising harms, emergency admissions and deaths linked to synthetic cannabinoids (K2/Spice), and distinguishes these products from plant cannabis."
    },
    {
      "id": "2f08b13a-ecf0-4799-a14d-58bf972dd8ec",
      "text": "Peer‑reviewed study (Journal of Cannabis Research) publishes results (April 6, 2024) reporting that a history of cannabis use was associated with lower in‑hospital mortality among hospitalized COVID‑19 patients in a large national inpatient sample."
    },
    {
      "id": "7e44b6c6-7d56-4232-819d-53ec3fa86eca",
      "text": "White House issues 'Statement from President Biden on Marijuana Reform' (October 6, 2022) and subsequent federal/state-level policy shifts and public discussions around decriminalization/rescheduling continue through 2023–2024."
    },
    {
      "id": "e044f66e-1051-432c-9447-d98bcbe37e2d",
      "text": "Systematic reviews and clinical‑trial summaries (e.g., Antioxidants 2018; other reviews and NIH/NCI summaries) documenting safety, mixed/limited efficacy signals, and ongoing early‑phase trials of high‑dose IV ascorbate in cancer therapy."
    },
    {
      "id": "806cfcc9-2fa9-44ee-85fa-be86fd0c140b",
      "text": "Longstanding promotion and clinical use of IV vitamin C by integrative clinics (e.g., Riordan Clinic) including published protocols and patient‑case material used to market IVC as an adjunctive cancer therapy."
    },
    {
      "id": "3d0c34ba-5eed-4155-8048-07dea2acc752",
      "text": "Emergency use authorizations and publication of phase‑3 results for mRNA COVID‑19 vaccines (Pfizer/BioNTech and Moderna) in late 2020"
    },
    {
      "id": "58bcf34f-8ba3-4b84-a26f-99d50d09da47",
      "text": "WHO guidance advising that ivermectin should only be used to treat COVID‑19 within clinical trials"
    },
    {
      "id": "595f845c-20e2-4266-9c19-52b6519191bf",
      "text": "WHO request and international attention on China’s late‑2023 surge in pediatric respiratory illnesses"
    },
    {
      "id": "a3dbd081-e0b4-447f-a34f-0188df7b1cfd",
      "text": "High‑profile reporting in 2023 about widespread chemical contaminants in U.S. tap water (PFAS / 'forever chemicals')"
    },
    {
      "id": "c1c0f08b-a7e7-47dc-b2ab-3e7f98dedc81",
      "text": "August 2021 discovery of foreign particles in some Moderna COVID‑19 vaccine vials in Japan (batches paused)"
    },
    {
      "id": "2a7b8375-e2a4-40b6-8703-a6867c26ee76",
      "text": "Event 201 pandemic tabletop exercise (Johns Hopkins/WEF/Bill & Melinda Gates Foundation)"
    },
    {
      "id": "5ad531ab-4764-4ef7-baba-70398900776e",
      "text": "Arrest and conviction of Ukrainian filmmaker Oleg Sentsov on terrorism charges (Crimea cases)"
    },
    {
      "id": "20591f9f-e0ef-4998-90e0-cea448297dde",
      "text": "UAE action and reporting around Russian-linked assets and banks (examples: cancellation of MTS Bank licence)"
    },
    {
      "id": "108e779d-9db3-4fd0-9788-b9157c4ab56e",
      "text": "Ukrainian authorities charged individuals in an embezzlement scheme linked to arms procurement (~$40 million)"
    },
    {
      "id": "dd631f5a-6080-4281-9adc-8fdb88632983",
      "text": "Pentagon Inspector General report finding about $1 billion in U.S. weapons to Ukraine not properly tracked"
    },
    {
      "id": "1e36d9a5-24c2-4358-9d06-5f639bbe88fb",
      "text": "Pandora Papers release showing extensive use of UAE-linked offshore structures"
    },
    {
      "id": "aa40d2ac-2714-4625-babf-90088c7be49f",
      "text": "Greenpeace 'Dirty Laundry' investigative reports exposing toxic discharges from textile supply chains"
    },
    {
      "id": "87097f69-f45d-4265-af3b-f1353bd44cc8",
      "text": "Publication of 'A New Textiles Economy' report by the Ellen MacArthur Foundation (widely cited analysis of fashion's environmental footprint)"
    },
    {
      "id": "dddd9c26-ce0a-4e7e-a0e6-93e55f2f4446",
      "text": "Peer‑reviewed studies (2017) quantifying microfiber shedding from synthetic textiles as a major source of microplastics"
    },
    {
      "id": "f4e3a9e3-3c3d-4ab1-8c3a-b7b4f00b7da0",
      "text": "CDC/ACIP review and MMWR reporting of myocarditis and pericarditis cases following mRNA COVID-19 vaccination"
    },
    {
      "id": "b4f143e6-4e35-4c18-a988-79f21ab9c179",
      "text": "Regulatory findings and media coverage of rare blood‑clotting events linked to the AstraZeneca COVID-19 vaccine (EMA review)"
    },
    {
      "id": "0e7c3843-8c18-486d-87e7-d205bfd1bddf",
      "text": "Sinking of the Russian cruiser Moskva in mid-April 2022 near the Black Sea theatre"
    },
    {
      "id": "3d446a56-a3cf-4d57-befe-1d011f977087",
      "text": "Ukrainian forces raised the Ukrainian flag on Snake Island after Russian withdrawal"
    },
    {
      "id": "895c4b1a-bfdd-43b5-88e8-3f03cee20224",
      "text": "Enactment of Ukraine's decommunization laws"
    },
    {
      "id": "1f31387f-602f-4406-b683-3349a0445c7a",
      "text": "Kyiv City Council renamed General Vatutin Avenue to Roman Shukhevych Avenue"
    },
    {
      "id": "fa88a2cd-c10a-4c93-a187-e5e358d897f2",
      "text": "OSCE Special Monitoring Mission observed civilian fatalities and bodies after shelling in Donetsk"
    },
    {
      "id": "6849375f-6011-4635-b9c4-b17ee24abba1",
      "text": "Odessa Trade Union House fire and mass fatalities during clashes"
    },
    {
      "id": "bb15e0f0-16db-4581-a33d-49bdce475328",
      "text": "Killing and torture of local politician Volodymyr Rybak reported from Donetsk region"
    },
    {
      "id": "f73ccc40-9526-460c-ad2f-f60fad7ce28b",
      "text": "Exhumation of a mass grave in Sloviansk, eastern Ukraine"
    },
    {
      "id": "f2e1273d-63f8-445e-a431-b0e75cdf5564",
      "text": "UNICEF launched a humanitarian cash transfer programme in Ukraine (real cash payments to vulnerable families began in March 2022)."
    },
    {
      "id": "485eb0cd-4bd1-4c5b-a0bc-f24751f1688c",
      "text": "Sharp rise in Telegram (early 2022) and already-dominant Viber use (Ukraine: high market share reported Sept 2021) as primary messaging channels in the region."
    },
    {
      "id": "ee6b2298-47b7-4481-8fe6-951504b15004",
      "text": "French farming unions warned they could stage further protests and blockades (reported March 3, 2024)."
    },
    {
      "id": "1ce1328d-6ce2-489f-b6b2-35da0faba554",
      "text": "President Macron publicly said he did not \"rule out\" sending Western troops to Ukraine during a leaders' meeting in Paris."
    },
    {
      "id": "f73fdbd4-3902-4798-a160-be278afda5fe",
      "text": "IUCN Polar Bear Specialist Group released its 2023 status/criteria report on polar bear subpopulations and abundance estimates (PBSG status report, Oct 2023)."
    },
    {
      "id": "8126a34c-5ee8-475b-8526-f4d565d7db8f",
      "text": "The Oceanography Society / research syntheses in 2023 published accessible overviews of observational evidence for ongoing global surface ocean acidification."
    },
    {
      "id": "ab43d039-96d0-4d64-8845-a0f23f6afccd",
      "text": "NOAA/SWPC issued a revised forecast that Solar Cycle 25 would rise more quickly and peak higher than earlier predictions, and highlighted recent large solar flares (X‑class) in late 2023."
    },
    {
      "id": "d0ad0b02-60ab-4619-a430-6da20b6c1436",
      "text": "Peer‑reviewed 2023 papers documented high spatial and temporal variability in coastal and upwelling pH (e.g., high‑frequency pH dynamics in regional systems), showing local short‑term pH fluctuations."
    },
    {
      "id": "c7cdea89-036d-4bcf-85df-916f09f07798",
      "text": "U.S. federal political actions and rhetoric undermining climate policy (example: President Trump announces withdrawal from Paris Agreement)"
    },
    {
      "id": "5487ccd1-6b00-4e12-8e12-04bad8b9c440",
      "text": "Nature Climate Change paper: 'Temporary reduction in daily global CO2 emissions during the COVID‑19 forced confinement'"
    },
    {
      "id": "ecc020ce-fecb-452a-af8c-ad9709949f72",
      "text": "Violent clash between rival Orthodox groups at St. Michael's Cathedral in Cherkasy"
    },
    {
      "id": "f63b0a7e-2f78-4a73-829e-07523b9f1f51",
      "text": "Local reporting about the contested transfer/seizure of the cathedral and services held in Ukrainian amid the dispute"
    },
    {
      "id": "3022932c-02eb-48c9-b138-d812dbb39ec7",
      "text": "Russia/occupation authorities ban the Mejlis of the Crimean Tatar people as 'extremist'"
    },
    {
      "id": "f2bf68ae-a55c-4529-8841-e51b1e49ccfd",
      "text": "Surge in positive public attitudes toward Stalin in Russia (Levada poll, April 2019)"
    },
    {
      "id": "6a04f59f-82ff-415c-8bec-2ed8a8f679e8",
      "text": "Release and public circulation of National Toxicology Program (NTP) draft monograph materials on fluoride and neurodevelopment (documents publicly posted and widely reported in 2023)."
    },
    {
      "id": "1aaa012c-a242-4929-96eb-70b19589f395",
      "text": "Publication of mouse-study showing sodium bicarbonate reduced metastasis (Robert Gillies et al.)"
    },
    {
      "id": "85fb84b0-0122-40e9-b27c-d5a75ab417c4",
      "text": "Case report of severe metabolic alkalosis from topical sodium bicarbonate use (clinical harm reported)"
    },
    {
      "id": "c807536c-627d-4ea7-a757-b1fc516650c4",
      "text": "2018 conviction and sentencing news about Tullio Simoncini for treating cancer with bicarbonate"
    },
    {
      "id": "fdfe3472-c5ba-49de-8042-03f87d3b22f2",
      "text": "European Union re‑affirms and extends sanctions on Russia amid Minsk implementation stalemate (summer 2017)"
    },
    {
      "id": "bfa887a6-b322-4da1-a76b-7b5b3f653cc4",
      "text": "German foreign minister Frank‑Walter Steinmeier publicly favours gradual phasing‑out of Russia sanctions if progress is made (Reuters)"
    },
    {
      "id": "c0bc1a44-9b42-4cf0-aab0-ae80b02a03c6",
      "text": "Heavy fighting in Avdiivka, Donetsk region — major escalation reported (Battle of Avdiivka)"
    },
    {
      "id": "6b35feeb-649a-4826-af85-82f8a6706455",
      "text": "‘Steinmeier formula’ concept emerges in Normandy/Minsk negotiations (implementation idea for political clauses)"
    },
    {
      "id": "7bb2184d-04eb-4cc5-9bba-24bbaa1c88fe",
      "text": "OSCE/UN reports of restricted access and harassment of journalists in eastern Ukraine (summer 2014)."
    },
    {
      "id": "f40486a0-ea1d-4cfb-a807-029ece0cb041",
      "text": "Ukrainian National Guard reported taking control of Komsomolske (Donetsk region) after fighting."
    },
    {
      "id": "d179af4f-4114-4e08-96db-ce490af45be1",
      "text": "Large Russian military convoy and movement of heavy vehicles near the Ukraine border (August 2014) and competing official narratives about incursions."
    },
    {
      "id": "be52d413-c060-46df-ae49-6f8e865d0ae2",
      "text": "Ukrainian forces captured two Russian nationals identified as GRU officers (Yevgeny Yerofeyev and Aleksandr Aleksandrov) during fighting near Schastya."
    },
    {
      "id": "b82e31c4-552a-444b-a496-ff8aa9a48878",
      "text": "Large prisoner exchange between Kyiv and pro-Russian rebels around the end of December 2014, involving hundreds of detainees."
    },
    {
      "id": "3cd90d92-1f2f-4bb7-bf4a-32e93f89acf3",
      "text": "Signing of Minsk II (Package of Measures) which included clauses calling for 'release and exchange of all hostages and unlawfully detained persons' on an 'all-for-all' basis."
    },
    {
      "id": "2318fe24-10d8-4966-a4b3-8bc37a734c13",
      "text": "EuroMOMO surveillance reports flagged elevated excess all-cause mortality in parts of Europe during 2021"
    },
    {
      "id": "e02ac3bc-7a18-4bfb-9c46-d2b7239b6583",
      "text": "Office for National Statistics publishes 'Deaths involving COVID-19 by vaccination status' dataset covering deaths occurring Jan 2021–31 May 2022"
    },
    {
      "id": "5a2bf5df-c9e2-4260-aacc-208208da8e1a",
      "text": "Federal judge orders FDA to accelerate public release of Pfizer COVID-19 vaccine documents"
    },
    {
      "id": "0d4aa265-11b9-4915-b054-93ec17930f3a",
      "text": "CDC issues 'Preexposure Prophylaxis for the Prevention of HIV Infection' clinical practice guideline"
    },
    {
      "id": "956e3474-5618-4c81-9e49-a51567c16fcf",
      "text": "FDA approval of Descovy (emtricitabine/tenofovir alafenamide) for PrEP, with messaging highlighting improved renal and bone safety compared with TDF-based Truvada"
    },
    {
      "id": "a0f28cd3-c641-4002-8200-92f884c4cf8e",
      "text": "Publication of reviews and studies documenting tenofovir disoproxil fumarate (TDF)–associated renal dysfunction and decreases in bone mineral density"
    },
    {
      "id": "5d23ebd4-1e86-43e3-81c7-16ad606a11d8",
      "text": "CDC issues formal guidance on certifying COVID-19 deaths (death-certificate guidance)"
    },
    {
      "id": "18bd5197-ea18-4065-a9e0-567e3b1c277d",
      "text": "Italian Istituto Superiore di Sanità (ISS) reports high prevalence of pre-existing conditions among COVID-19 fatalities"
    },
    {
      "id": "f726ffc2-3647-400d-80a6-f52985797422",
      "text": "Poroshenko appeared publicly with wounded soldiers as guests at a Dynamo Kyiv match (visuals of him handing/being near gifts including a football)."
    },
    {
      "id": "68dd5299-7fd4-430f-8b60-388906a72882",
      "text": "Established medical context: febrile seizures are a known, usually benign reaction to fever and occur after many vaccines/infections (public understanding limited)"
    },
    {
      "id": "67b03e9b-943d-4bbc-a124-9c5578ef7ef2",
      "text": "Russian government statements alleging 'outside meddling' in Belarus"
    },
    {
      "id": "93f6b1a4-8c3f-4a06-9824-0ba2df7d17d9",
      "text": "President Petro Poroshenko signs Ukraine's 'decommunisation' laws banning communist symbols and requiring removal/renaming of Soviet-era monuments and toponyms."
    },
    {
      "id": "13d2edcb-24dc-4bec-bcab-c09b3c14e8f8",
      "text": "Large Lenin statue toppled and demolished in Kharkiv during anti‑government protests."
    },
    {
      "id": "7dff7322-4805-4518-8f58-584aac64f379",
      "text": "Polish Sejm resolution recognising the Volyn (Volhynia) killings and raising attention to Volyn (22 July 2016)"
    },
    {
      "id": "6c94502c-3a79-4e01-b9d8-632621273814",
      "text": "Wider pro‑Russian unrest and short‑lived 'people's republic' claims in cities such as Kharkiv and Odesa (April 2014)"
    },
    {
      "id": "ef73f4bd-2cd1-4b72-9c3c-c2591a929a40",
      "text": "WHO names vaccine hesitancy among the top global health threats in 2019, and public debate about vaccine 'toxins' and 'detox' ramps up on social platforms in the late 2010s."
    },
    {
      "id": "6776a7d5-beaf-4c41-aa38-300a0801b709",
      "text": "American College of Medical Genetics and Genomics (ACMG) issues a 2013 practice guideline stating there is a lack of evidence supporting clinical MTHFR polymorphism testing."
    },
    {
      "id": "d8891a94-9140-46bb-bcdb-3d29d91975f5",
      "text": "Ukrainian government approved a draft law narrowing eligibility for military deferments for students and educators"
    },
    {
      "id": "bcbce5e1-e6dd-4fb3-b640-98dccec00c92",
      "text": "Verkhovna Rada extended martial law and general mobilization and described categories (including students) eligible/exempt from mobilization"
    },
    {
      "id": "46a1a4b3-5947-4f7a-937a-1787f32e8bcb",
      "text": "WHO interim guidance 'Advice on the use of masks in the context of COVID-19' published (5 June 2020) noting there was \"no direct evidence\" from studies on universal masking of healthy people in the community."
    },
    {
      "id": "f2f46d22-9183-4d22-a258-f7deec1e4667",
      "text": "Publication (Epub May 13, 2020) of Gao et al., 'A study on infectivity of asymptomatic SARS-CoV-2 carriers' (Respiratory Medicine), reporting 455 contacts of an asymptomatic carrier tested negative."
    },
    {
      "id": "eee7a4d9-8e2d-47ee-8999-987c6555cb58",
      "text": "Complaints and regulator notices in the UK about inappropriate recruitment incentives (reports that children were offered large payments, e.g., £1,500, to join a Moderna pediatric trial) and subsequent PMCPA action."
    },
    {
      "id": "11e6af92-7c17-44a8-9ab1-609463443a49",
      "text": "Publication of the KidCOVE phase 2/3 trial results showing mRNA‑1273 (Moderna) was safe and immunogenic in children 6 months to 5 years (NEJM)."
    },
    {
      "id": "f4b9f0d4-2a14-40af-9ab6-151433206f04",
      "text": "Widespread civilian refugee exodus from Ukraine reported across media"
    },
    {
      "id": "dfc78b17-77bb-4229-957b-d80d3ad115c8",
      "text": "DOU industry survey (conducted March 23–26, 2022) found many IT specialists had moved to safer locations (61% reported leaving their homes)"
    },
    {
      "id": "67774ca3-9e92-4d08-8579-3aaf1352ddf2",
      "text": "Public statements and interviews by Ukrainian officials describing the size and mobilization of the IT sector (coverage citing ~300,000 IT professionals)"
    },
    {
      "id": "53c56e4f-f7aa-498b-a6a2-d571622c455c",
      "text": "Multiple international tech firms publicly evacuated or offered relocation support for Ukrainian staff"
    },
    {
      "id": "c563fc88-dbde-45c0-91ec-aa24573796f5",
      "text": "2010 laboratory work demonstrating water extraction methods recover shikimic acid from sweetgum bark/wood"
    },
    {
      "id": "cff7a05d-3faf-4626-9e30-2425b37b803b",
      "text": "2009 news coverage linking shikimic acid (from star anise) to Tamiflu production and documenting supply shortages during flu scares"
    },
    {
      "id": "12f512c6-9447-45bf-84b7-c471a724c050",
      "text": "Russia vetoed a UN Security Council draft resolution to establish an international tribunal for the downing of Malaysia Airlines Flight MH17"
    },
    {
      "id": "3d663718-e7d2-4e18-9008-11c863444483",
      "text": "UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine’s territorial integrity while the Security Council was unable to act"
    },
    {
      "id": "72464dda-73dc-42a3-bd28-c42b8e02f4f9",
      "text": "Humanitarian situation reports documenting growing social tensions and incidents between host communities and IDPs in host areas"
    },
    {
      "id": "3c5df01c-39f1-48ad-b488-cc651a5bee87",
      "text": "High‑profile cases earlier in 2014 of pro‑Russian protesters/separatists removing or replacing Ukrainian flags from government buildings in eastern Ukraine (Donetsk)"
    },
    {
      "id": "55149787-986d-45e4-b225-54181d7d8cf7",
      "text": "Large influx of internally displaced persons (IDPs) from Donbas and Crimea to Kyiv region (tens of thousands reported)"
    },
    {
      "id": "6d127b3c-a603-4734-96e1-89cef5a4128a",
      "text": "Existing, well-known SANAE IV research station and local geology (Vesleskarvet nunatak composed of dolerite/diabase) available in public records and studies"
    },
    {
      "id": "93d5589d-ec1b-403e-b7b7-ca6f4146db7d",
      "text": "Angelina Jolie made an unannounced humanitarian visit to frontline cities in Ukraine (Kherson, Mykolaiv/Lviv region)."
    },
    {
      "id": "eaf5b6ba-8898-4839-b6a9-fc7cdd78ce02",
      "text": "UN reporting and human‑rights agencies warned of 'persistent and grave' human rights violations and widespread deprivation in conflict‑affected areas of eastern Ukraine."
    },
    {
      "id": "0534dd3a-1108-4c6c-8042-56dd3e0e1de4",
      "text": "Verkhovna Rada submission/declaration to the UN indicating derogation from certain international obligations (official deposition notifying international bodies)."
    },
    {
      "id": "2c70aa6c-a47a-4ec6-9c2f-3780e8077140",
      "text": "Widespread suspension or non‑payment of pensions and social payments to people in non‑government controlled areas of Donetsk and Luhansk."
    },
    {
      "id": "1827b39d-2e75-4c43-b9b5-819bcccd1336",
      "text": "Western bilateral training missions inside Ukraine (for example, Canada's Operation UNIFIER launched in 2015 with rotating Canadian personnel training Ukrainian forces)."
    },
    {
      "id": "4d27344b-c507-440a-ae52-1d0a68fdf680",
      "text": "NATO formalized intensified political/military cooperation with Ukraine (NATO factsheets and liaison presence describing NATO-Ukraine dialogue and support)."
    },
    {
      "id": "a5e721d6-d4b5-4676-b0ef-6635440090c5",
      "text": "Sea Breeze 2019 multinational naval and maritime exercise co-hosted by Ukraine and NATO/allied partners in the Black Sea (visible allied ships and aircraft operating near Ukraine)."
    },
    {
      "id": "e83bbc87-dc53-4e0a-aa7a-894dca93d5ca",
      "text": "Reports since 2014 of foreign fighters and international volunteers operating in Donbas (documented by major outlets such as the BBC)."
    },
    {
      "id": "0cffc2cc-b1b1-4d89-9f69-ca6b18367663",
      "text": "Antarctic winter sea‑ice extent reached a satellite‑era record high (widely reported in 2014)"
    },
    {
      "id": "b148b335-5477-4655-b6a6-2f5cfaac025f",
      "text": "World Glacier Monitoring Service (WGMS) database expansion and 2019 reporting on glacier observations"
    },
    {
      "id": "8cdda31c-9b71-4441-865a-81116c144f4c",
      "text": "CDC releases 2020–2021 flu vaccination recommendations calling for yearly flu vaccine for everyone 6 months and older"
    },
    {
      "id": "58adc6a2-015b-4cf4-929a-9090cc1d2ce7",
      "text": "NOAA 'State of the Climate — 2012' reporting on global sea level contributions noted that recent sea-level rise included large contributions from glacier and ice-sheet melt as well as thermal expansion"
    },
    {
      "id": "c0961ef4-9fc4-4628-a2ba-f575365a0926",
      "text": "Research showing Pacific trade-wind/ENSO-driven decadal variability strongly affects regional sea-level trends (studies published 2016–2017 demonstrating wind-driven variability and model under-representation)"
    },
    {
      "id": "8a1af2e7-35aa-4ae4-a3a9-dba8d0e29550",
      "text": "Coverage of apparent 'slowing' or data-artifact issues in satellite altimeter sea-level records (widely reported articles in 2014–2015 discussing measurement corrections and inter-dataset differences)"
    },
    {
      "id": "f1b56084-1b4d-4858-b1c5-fe109cb7b38a",
      "text": "Verkhovna Rada adopted a resolution establishing 'Day of the Ukrainian Volunteer' (Day of Volunteer Fighters)"
    },
    {
      "id": "3a41d540-b1a0-4c5c-b596-8e90a640fa55",
      "text": "Presidential Decree No.806/2014 established 'Day of the Defender of Ukraine' (14 October 2014)"
    },
    {
      "id": "43ad7424-4c77-4dc0-8c36-9d1d1d14dd12",
      "text": "UK government announced new national lockdown in England on Jan 4, 2021 despite vaccine rollout"
    },
    {
      "id": "06c72a80-84c2-4b99-b900-146c339b7cb5",
      "text": "IATA and airlines public plans for a digital 'travel pass' / health pass tied to testing and vaccination (December 2020)"
    },
    {
      "id": "63fbc0f1-49c8-4b3e-9954-75d114dce032",
      "text": "WHO warnings that vaccines are not a 'silver bullet' and will not immediately end the pandemic"
    },
    {
      "id": "9bf4b261-5604-4e7d-bdf4-1d258b3c8c67",
      "text": "Berlin authorities publicly considered or enforced bans on display of Russian/Soviet symbols around May 8–9 commemorations"
    },
    {
      "id": "bf8c3e12-552a-4a71-843a-f89c91b6389e",
      "text": "Major oil and gas companies (Shell, Exxon) suspend or pull back Black Sea projects after Crimea’s annexation"
    },
    {
      "id": "47086825-ea05-4d6c-a4fb-5290780b5f88",
      "text": "Russian appropriation and U.S. sanctions on Chernomorneftegaz after the 2014 annexation of Crimea"
    },
    {
      "id": "e3ab09fc-1684-492b-adb9-d899f0428e95",
      "text": "Peer‑reviewed review article published (Natural Product Communications) summarizing multiple Chinese herbal medicines and their potential mechanisms in COPD (preclinical and small clinical studies)."
    },
    {
      "id": "d941fba6-fd74-4a83-9e8e-d451475571b9",
      "text": "FDA issued high‑profile warning letters and enforcement actions in 2023–2024 against supplement makers for making unlawful disease‑treatment claims."
    },
    {
      "id": "538ca86c-a065-4064-bc05-9aa8e765059b",
      "text": "CDC COVID-NET MMWR report on pediatric COVID-19 hospitalizations (March–July 2020)"
    },
    {
      "id": "f3374e00-912a-4a2b-a295-21f6bee73d8d",
      "text": "Publication of Moncrieff et al., 'The serotonin theory of depression: a systematic umbrella review of the evidence' in Molecular Psychiatry, concluding no consistent evidence that depression is caused by decreased serotonin activity (widely reported July 2022)."
    },
    {
      "id": "48c00d52-4142-44d8-8055-adaf8e806d65",
      "text": "Royal College of Psychiatrists position statement 'Antidepressants and depression' (PS04/19, May 2019) stating the 'chemical imbalance' explanation is an oversimplification and not supported as a literal cause of depression."
    },
    {
      "id": "75d8bd40-d695-4208-bab5-37205811fc6f",
      "text": "U.S. Senate passed a $95 billion foreign aid package including funds for Ukraine and security assistance"
    },
    {
      "id": "b797142f-6e6b-4e92-947e-f1eac9cf2441",
      "text": "Ukrainian President Volodymyr Zelensky's visit to Washington to plead for more U.S. aid and meetings with lawmakers"
    },
    {
      "id": "c4d166ac-fb2b-4908-b29e-b5e60db0c750",
      "text": "United Kingdom announced a formal 10-year security/cooperation arrangement with Ukraine (high-profile bilateral security pact coverage)"
    },
    {
      "id": "2aad08c3-7a9d-4088-a0c8-7173322b568e",
      "text": "OSCE regular situation summaries noting continued shelling damage in Donetsk (SMM monitoring summaries in Jan–Feb 2015)"
    },
    {
      "id": "f7b9b2d6-8f53-43d9-99fd-bb3b69e7b89c",
      "text": "CDC/ACIP public report (MMWR) acknowledging increased reports of myocarditis after mRNA COVID-19 vaccination and concluding benefits outweigh risks"
    },
    {
      "id": "369fae54-d19e-45f4-b266-bf30cf97a1aa",
      "text": "Discovery of black/foreign particles in some Moderna vaccine vials in Japan, triggering local pauses and recalls"
    },
    {
      "id": "7564e306-9381-4331-a0f1-0dbf0fb1bba9",
      "text": "CDC/ACIP and MMWR reports (June 2021) documenting an elevated but rare risk of myocarditis after mRNA vaccination in young males"
    },
    {
      "id": "b07f9e83-4828-4d6c-9655-aaf9e032b958",
      "text": "EMA statement (April 2021) finding a possible link between AstraZeneca vaccine and very rare blood clots"
    },
    {
      "id": "c5d32957-0250-4e27-883f-1614716b7a5a",
      "text": "Media coverage and public attention on regulatory/clinical debate about aluminum adjuvant safety (coverage of CDC/advisory discussions)"
    },
    {
      "id": "144a50c2-b370-4909-b53f-80f34729e342",
      "text": "CDC guidance on infant formula and fluorosis advising caution with fluoridated water when preparing infant formula"
    },
    {
      "id": "661f3ede-e539-43ba-97be-c3c6c34b20d1",
      "text": "NTP (National Toxicology Program) systematic review/monograph assessing fluoride exposure and neurodevelopmental outcomes"
    },
    {
      "id": "d5908ec5-3ffb-41c4-a73b-cce528382f43",
      "text": "EU and other Western emergency energy/aid packages delivered to Ukraine after strikes on energy infrastructure"
    },
    {
      "id": "63723f47-361c-4376-807a-db90f7e6a177",
      "text": "Public health briefings and technical reports about Omicron (Dec 2021–Jan 2022) from agencies such as CDC/UKHSA describing reduced vaccine effectiveness against infection and many 'breakthrough' cases"
    },
    {
      "id": "64afbd72-1116-4c9e-be6c-75364f693bd2",
      "text": "Widespread driver-led protests and road blockades across Serbia over fuel-price hikes (early June 2018)."
    },
    {
      "id": "f5025228-2ba3-471c-b1c3-23a1505e1738",
      "text": "OSCE Special Monitoring Mission (SMM) reports (2014–2015) documenting heavy weapons and noting that withdrawal of foreign armed formations and verification remained incomplete (e.g., OSCE SMM updates in 2015)."
    },
    {
      "id": "bc099959-037b-43e1-81ab-0a360d9be0b0",
      "text": "Signing of the Minsk II package of measures (Normandy Format) on 12 February 2015, which called for withdrawal of 'all foreign armed formations, military equipment and mercenaries' from Ukraine."
    },
    {
      "id": "98c7e671-e565-411e-842f-6573296ff33e",
      "text": "Ukraine released footage and publicly displayed captured Russian paratroopers in August 2014; Moscow described the detentions as a mistake or denied direct responsibility."
    },
    {
      "id": "7a2b81d2-3671-4bb5-b252-146ae07d2184",
      "text": "Russia launched a direct military intervention and air campaign in Syria (widely reported on 30 Sept 2015)."
    },
    {
      "id": "891028a4-9c48-4a22-9b0c-8e72a1f0c9ea",
      "text": "Apter et al. v. Department of Health & Human Services — lawsuit filed by three physicians (complaint filed June 2, 2022)"
    },
    {
      "id": "2218b201-0cff-4061-95fc-3e9f5fb5ffef",
      "text": "DOJ lawyer's remark during Fifth Circuit oral arguments (Apter v. HHS) that “FDA explicitly recognizes that doctors do have the authority to prescribe ivermectin”"
    },
    {
      "id": "c683eead-b9f6-409e-98ea-ca86a80fe6b3",
      "text": "Calls in EU institutions and the Platform of European Memory and Conscience for EU-supported remembrance projects and funding (referenced in EP documents, 2019)"
    },
    {
      "id": "319e2b16-8188-4643-b573-840838be97c9",
      "text": "International backlash to Poland's 2018 'Holocaust law' (Amendment to the Act on the Institute of National Remembrance) and subsequent diplomatic controversy"
    },
    {
      "id": "dec0aa9e-5fd8-4c97-949a-d4e94ae3538d",
      "text": "Ukrainian security forces moved to clear separatist/pro‑Russian protesters from the Kharkiv administration building and arrested dozens (early April 2014)."
    },
    {
      "id": "190837d7-d1a4-4fd5-90d4-a7a51760571a",
      "text": "Deadly clashes in Odesa on May 2, 2014, that left dozens dead in street fighting and a Trade Unions House fire between pro‑Ukrainian and pro‑Russian groups."
    },
    {
      "id": "b5463219-98c5-448f-9531-85d2be5f4d74",
      "text": "Increased visibility and international coverage of Ukrainian nationalist groups (e.g., Right Sector, Svoboda) and their mobilizations in early 2014."
    },
    {
      "id": "ae9feba2-1286-4e90-8d19-f6c6fb5695bc",
      "text": "5G Appeal / International EMF scientists' moratorium call"
    },
    {
      "id": "29c88596-19ba-4c92-889a-93d36cedb885",
      "text": "China's commercial 5G launch in 50 cities"
    },
    {
      "id": "0f1e349e-33e1-410f-a80e-7f7a15a64def",
      "text": "US National Toxicology Program (NTP) cell-phone radiofrequency final reports"
    },
    {
      "id": "2907752a-dd04-43a3-81f8-99aed282cd51",
      "text": "Public Health Ontario technical brief on interpreting PCR cycle threshold (Ct) values (Sept 2020)"
    },
    {
      "id": "e2d6ea9f-2930-4d6a-88e9-e46e90562a30",
      "text": "IDSA/AMP joint statement cautioning against using Ct values for clinical decision-making"
    },
    {
      "id": "9837e2d1-81a9-4dda-a544-9966e203d52f",
      "text": "NEJM perspective arguing testing strategy should prioritize frequency/turnaround over analytic sensitivity (Mina et al., \"Rethinking Covid-19 Test Sensitivity\")"
    },
    {
      "id": "cf9857de-8137-45c9-b5fa-915993e74b08",
      "text": "Study showing PCR cycle threshold values correlate with loss of recoverable live virus (Bullard et al.)"
    },
    {
      "id": "ff9436f6-f297-4eb4-912f-7a157e3d12fe",
      "text": "CDC/NCHS provisional counts showed the U.S. COVID-19 death tally reached roughly 1,000,000, prompting broad press coverage."
    },
    {
      "id": "30d95fcc-b794-4439-8991-acda681c53e1",
      "text": "President Biden and the White House publicly marked the milestone, issuing statements and remarks acknowledging 'one million Americans' dead from COVID-19."
    },
    {
      "id": "38511aaf-9163-4d65-81dd-224ed0e0b81d",
      "text": "Lithuanian parliament unanimously declared Russia a 'terrorist state'"
    },
    {
      "id": "40f52c99-ebfd-45ff-98f5-952306d27151",
      "text": "Pattern of prior Kremlin disinformation accusing Ukrainian authorities of preparing to mobilize or militarize children (examples documented across 2022)."
    },
    {
      "id": "11cd3da1-ec29-4a09-b90a-f36ba252d061",
      "text": "A December 30, 2022 parliamentary decision changed the official summons form and administrative terminology (new Territorial Recruitment and Social Support Centers), making older or doctored forms appear superficially plausible to non-experts."
    },
    {
      "id": "48abfe8f-9f46-4310-9097-df2faacdef21",
      "text": "Amnesty International documenting abuses by pro‑Ukrainian volunteer battalions in Donbas"
    },
    {
      "id": "383b2738-9a06-4fbb-b686-d25d6df14cd6",
      "text": "Passage of Ukraine's decommunization laws banning Soviet symbols"
    },
    {
      "id": "9a836402-72b1-4d2e-8da1-84843dda9b7b",
      "text": "Adoption of the Ukrainian 'lustration' (vetting) law for officials"
    },
    {
      "id": "611ba306-98a9-4679-8657-f9c54c244a4e",
      "text": "Adoption and implementation of the 2017 Education (language) law restricting minority‑language instruction"
    },
    {
      "id": "6c4cddc2-2c7c-432e-8213-e905a1d3738a",
      "text": "Ukrainian investigations and prosecutions for 'collaboration' with occupying authorities in Crimea (starting 2014)"
    },
    {
      "id": "51b2f815-411e-43f8-a5c1-336bea1219da",
      "text": "Europol / international law‑enforcement warnings about the risk of diversion of weapons from the Ukraine conflict to black markets"
    },
    {
      "id": "782c2526-0417-4dc7-8284-5083afa85621",
      "text": "CBS Reports documentary 'Arming Ukraine' (briefly released, then pulled) examined problems getting aid to frontline and described shipment shortfalls"
    },
    {
      "id": "dbe3b7f9-9c71-45eb-b905-98ec6f50ca3d",
      "text": "Public debate over mobilisation/conscription policy in Ukraine (Reuters: 'Female conscription not part of Ukraine's new draft law')"
    },
    {
      "id": "5c56c859-c655-41f6-ba71-d6caa0f72e3b",
      "text": "Widespread reporting of Russian strikes that damaged or destroyed Ukrainian grain storage facilities (grain silos)"
    },
    {
      "id": "f058d856-1ce9-45cf-9d35-23956aa81d73",
      "text": "Disruption of Black Sea grain exports after Russia’s pullback from the UN/Turkey‑brokered Black Sea Grain Initiative"
    },
    {
      "id": "68d7b0c8-243a-418d-b915-b2bed9b72c41",
      "text": "Reports and images early in the war of attacks on bakeries and food‑production infrastructure (bread factories/bakeries hit by strikes)"
    },
    {
      "id": "43d0da75-6cdb-4b26-9b82-eb000d5742c4",
      "text": "CDC MMWR and other US reports documenting racial/ethnic differences in vaccine uptake (published analyses in early 2023 showing complex patterns of uptake across age and race)."
    },
    {
      "id": "ef8872a9-7c5f-45a1-8cee-50f47b855f12",
      "text": "Office for National Statistics (ONS) release showing that, for some reporting periods, the majority of COVID-19 deaths in England occurred among vaccinated people (because most older people were vaccinated)."
    },
    {
      "id": "7f03d95e-812e-49fc-9c20-0456009ed9e6",
      "text": "Czech arms firm Excalibur Group announced and began shipping refurbished T-72 tanks and other heavy equipment to Nigeria via Antonov An-225 flights out of Ostrava."
    },
    {
      "id": "2de3db1c-8206-4c97-ae05-14fa38749525",
      "text": "Human Rights Watch report: 'Unguided rockets killing civilians' in rebel-held Donetsk"
    },
    {
      "id": "2fa1a6c5-df78-45bf-b911-a34b2cf8635f",
      "text": "OSCE Special Monitoring Mission spot report: residential area in Donetsk severely damaged by artillery"
    },
    {
      "id": "6ac1abfd-0548-4b06-add3-4ebb0962bfaa",
      "text": "Battle and shelling around Ilovaisk with documented civilian casualties"
    },
    {
      "id": "e5d0fd9a-f56b-4b5e-bff1-04b44d086cf5",
      "text": "Russian statements alleging Ukrainian cross-border shelling into Rostov/Donetsk (Russian claims)"
    },
    {
      "id": "a3564e9b-3a80-4277-b28a-f7cc608ae50e",
      "text": "Medical organizations publish guidance clarifying medical‑emergency exceptions and clinical decision‑making after Dobbs (e.g., ACOG August 2022 resources)"
    },
    {
      "id": "868f36b1-faaa-45fc-99da-436b401f1b8f",
      "text": "CMS issues July 2022 EMTALA guidance and related communications about emergency care for pregnant patients"
    },
    {
      "id": "8ef9e457-666c-4977-8ad8-a6188f7bb8b2",
      "text": "U.S. Supreme Court decision in Dobbs v. Jackson Women's Health Organization overturns Roe v. Wade"
    },
    {
      "id": "004c8568-374a-4517-8f8b-8bad54f4d762",
      "text": "UN warning (Nov 2015) that hundreds of thousands of children in Donetsk and Luhansk were at risk from potential failure of heating systems due to conflict damage"
    },
    {
      "id": "b29529c6-004d-4947-93f4-3254e37e260e",
      "text": "2009 Russia–Ukraine gas dispute: Gazprom cut gas supplies to Ukraine (and affected transit to Europe)"
    },
    {
      "id": "b40ce322-87a1-4be7-8027-452a7d47efc3",
      "text": "Reuters special report: 'Ukraine struggles to control maverick battalions' documenting undisciplined volunteer units and links to criminality"
    },
    {
      "id": "7ea2566d-1b56-4eb1-b668-d5efb760cb02",
      "text": "UN OCHA situation reporting and media coverage documenting humanitarian access problems and reports of diverted/looted aid in Donbas (2014)"
    },
    {
      "id": "46be5e6f-5e7c-4dac-bf19-ba511307d0b4",
      "text": "Kyiv Post coverage of volunteer battalion leaders publicly declaring assets, showing some leaders with property and cash"
    },
    {
      "id": "e07167f0-429b-416e-9454-dec0d9045cb6",
      "text": "Randomized, double‑blind multicenter trial of the MCT-based product AC‑1202 (Axona) reporting cognitive benefit in ApoE4‑negative Alzheimer's patients (Henderson et al., Nutrition & Metabolism)"
    },
    {
      "id": "f4250b4f-185e-4240-84f1-06dd55ea2513",
      "text": "Mainstream media coverage of coconut oil as a 'health trend'/'miracle food' that emphasized potential benefits while downplaying uncertainty (e.g., New York Times explainer on coconut oil)"
    },
    {
      "id": "dcf6c7fd-72a2-4fc0-b404-e0a1efed57c6",
      "text": "SIPRI background paper and data documenting substantial Ukrainian arms supplies and military-technical cooperation with several sub-Saharan African countries (report published 2011)."
    },
    {
      "id": "e9e73205-eea9-4079-8e2f-017d20cd34e9",
      "text": "High-level Ukrainian diplomatic visits to Africa (e.g., Ukrainian Deputy Foreign Minister Viktor Maiko visited Dakar, Senegal on 22–23 February 2013)."
    },
    {
      "id": "27a7e73d-295d-494b-aa25-d05f32b9905f",
      "text": "UN General Assembly adopted a resolution declaring the Crimea referendum invalid (27 March 2014), with many states (including African votes and abstentions) visible in the roll call."
    },
    {
      "id": "52d05306-7b3e-4b56-905c-52d9adf81a77",
      "text": "Ukraine opened new embassies in African states (DRC, Ivory Coast) as part of a push to increase presence on the continent."
    },
    {
      "id": "b09a9896-1292-49b9-9661-23c3fe0cec8f",
      "text": "U.S. delivery of Javelin anti-tank missiles to Ukraine (2018)"
    },
    {
      "id": "e980e670-fd3b-4604-bf30-f315710cdea3",
      "text": "U.S. missile strike on a Syrian airbase (April 2017)"
    },
    {
      "id": "ca8cd41a-bcd6-41ba-bbe2-0940279c571c",
      "text": "U.S. B-52 bomber deployments and training flights in Northern Europe (March 2019)"
    },
    {
      "id": "037b5584-31b3-45ac-9f69-070ac5eb8829",
      "text": "NATO’s Trident Juncture 2018 large-scale exercise in Norway"
    },
    {
      "id": "f8013c0f-cc01-4be6-93f6-384857421899",
      "text": "Russian leadership accusations that Ukraine was plotting attacks in Crimea (August 2016)"
    },
    {
      "id": "ca905cfb-ae15-4198-ba0d-051609c335cb",
      "text": "Several European countries paused use of the Oxford–AstraZeneca COVID-19 vaccine over reports of rare blood clots."
    },
    {
      "id": "fd40e2f8-9a3a-4d18-a733-cd715f9ce076",
      "text": "Public availability of the VAERS adverse‑event reporting system and its raw data (VAERS data guide / public access documentation)."
    },
    {
      "id": "704783bc-11f4-4d6c-b839-d9f3b7f1324b",
      "text": "Kenya says over 200 of its nationals are fighting for Russia in Ukraine"
    },
    {
      "id": "2d271a5c-928a-4930-96b4-129efebe1df5",
      "text": "South African Presidency (SANews) confirmation that government is helping 'suspected' nationals stranded after joining mercenary forces"
    },
    {
      "id": "07510bdb-9489-442b-a192-8176369edcf6",
      "text": "European Food Safety Authority (EFSA) published a comprehensive scientific opinion on acrylamide in food highlighting potential cancer risks from dietary acrylamide exposure and identifying roasted/heat-processed products (including coffee) as contributors."
    },
    {
      "id": "aa1cb9f2-79f1-41a5-9ed1-df995778d99a",
      "text": "Major news coverage (CNN) in April 2024 about concerns over chemicals used in decaffeination (methylene chloride/ethyl acetate) and calls from some health groups to restrict certain decaffeination methods."
    },
    {
      "id": "bfb94fe4-4411-47f5-af22-944d54d6257d",
      "text": "Public statement attributed to U.S. envoy Kurt Volker that Crimea \"cannot be returned by force\""
    },
    {
      "id": "258719ec-bc17-4161-8038-22aaea9045ea",
      "text": "Apple Maps controversy and Ukrainian diplomatic protest after Crimea appeared as part of Russia on some platforms (Ukraine diplomat publicly criticized mapping depiction, Nov 2019)"
    },
    {
      "id": "8a30da06-0220-4593-bd3d-77e921c8e4ac",
      "text": "Media reports that U.S. Secretary of State Mike Pompeo allegedly told Ukrainian interlocutors \"Crimea is lost\" (reported in press coverage)"
    },
    {
      "id": "3ffd80c2-fde7-4f2c-8c31-8e29baaa1b45",
      "text": "Widespread reporting of attacks on hospitals and medical personnel in Ukraine that cited Geneva Convention protections (60 Minutes / CBS News coverage)."
    },
    {
      "id": "6f22db37-dbab-4c70-b00a-de4ab5e1a28f",
      "text": "Ukraine's parliamentary ombudswoman and other officials publicly accused Russia of mistreating Ukrainian POWs, saying Russia's conduct may violate the Geneva Conventions."
    },
    {
      "id": "7bf352ce-20a1-4705-b44e-d284a64f2dc9",
      "text": "Release of policy/guidance analyses on solar climate intervention and governance (C2ES report)"
    },
    {
      "id": "f158a18e-8e7f-4fdf-88ac-f48f70fc099b",
      "text": "Public reporting that Bill Gates funded geoengineering research (FICER / early funding disclosures)"
    },
    {
      "id": "78d2be66-b720-4f0f-8d4c-478dd5acbe21",
      "text": "1964 NEJM publication on a vegetable-oil adjuvant (Adjuvant 65) tested in influenza vaccine trials"
    },
    {
      "id": "7310ed04-5712-4000-8ce7-8ed3d2ae62d4",
      "text": "Children’s Hospital of Philadelphia (Vaccine Education Center) guidance explaining peanut/corn oils are not used in routine vaccines"
    },
    {
      "id": "55f8ab79-cb3a-4bfe-b0cd-7f7e568f60c0",
      "text": "Ukraine’s health regulators updated guidance on clinical trials (28 Sept 2020) and Ukraine received inquiries/applications related to vaccine trials in autumn 2020 (reported in contemporaneous summaries of trial activity)."
    },
    {
      "id": "348f73f2-5d04-4cf7-bdee-7a8f5ec3e67c",
      "text": "Johnson & Johnson temporarily paused its global COVID‑19 vaccine trials after an unexplained illness in a participant (widely reported Oct 12–13, 2020)."
    },
    {
      "id": "6b437726-a25f-48f1-a4df-2d46e7e4af00",
      "text": "Viktor Medvedchuk (pro‑Moscow Ukrainian politician) publicly criticized Kyiv’s refusal to engage with Sputnik V and urged use of the Russian vaccine (comments reported Oct 26, 2020)."
    },
    {
      "id": "dfef6cce-2e7b-4cb8-a568-6acc38367d08",
      "text": "First U.S. HIMARS systems delivered to Ukraine (first arrivals announced)"
    },
    {
      "id": "4c3bfbf2-3a8e-4c7d-8bc5-348fdbbc48b2",
      "text": "U.S. National Security Adviser Jake Sullivan said the U.S. was 'not prepared to provide' ATACMS long-range missiles to Ukraine"
    },
    {
      "id": "58f8bf85-a0a3-46a2-bea7-181eb9477611",
      "text": "Russia’s defence ministry claimed it destroyed four U.S.-supplied HIMARS launchers"
    },
    {
      "id": "dac09be7-9dcb-44dd-a432-f9b40d387ea9",
      "text": "2018 global valsartan/ARB recalls for nitrosamine impurities (heightened nitrosamine scrutiny)"
    },
    {
      "id": "402de313-dc2a-4179-9d33-756d322fa7c6",
      "text": "Pfizer records settlement charges resolving thousands of Chantix lawsuits (~$273 million)"
    },
    {
      "id": "367702f2-91ad-4a93-9dd2-0f8bb2859c71",
      "text": "FDA approves Chantix (varenicline) for smoking cessation"
    },
    {
      "id": "335a890c-6ec5-456c-a805-47ac70e391fe",
      "text": "FDA adds boxed warning for serious neuropsychiatric events (postmarketing, 2009)"
    },
    {
      "id": "9e8d5433-b960-46a3-b4a3-41a029fb9d00",
      "text": "Longstanding scientific practice of 'semen washing'—techniques to remove HIV from semen—has been reported in the literature since 1989 and studied in subsequent reviews (e.g., 2015), information available before May 28, 2022."
    },
    {
      "id": "2e574775-b70d-43d2-acb7-8d97dc6fe61d",
      "text": "ONS regional excess-mortality update published showing higher-than-expected deaths through November 2022"
    },
    {
      "id": "64b63c87-6a47-40dd-90df-bb9b12f57bc6",
      "text": "Peer‑reviewed reports of rare vaccine-associated myocarditis (published 2021–2022) received ongoing media attention"
    },
    {
      "id": "5834073d-b787-43e0-aef8-e4171853a791",
      "text": "VAERS / adverse-event report releases and summaries through late 2022 widely circulated"
    },
    {
      "id": "75b664c9-cdd2-4d8c-9dc9-5ba708cd4eb0",
      "text": "Construction and commissioning of the North Crimean Canal (Soviet-era large-scale diversion of Dnieper waters to Crimea, main works 1961–1971)"
    },
    {
      "id": "dc1adbc4-c3a2-4026-a250-03f9a8f6ebef",
      "text": "PBS/NOVA special 'The Quest for Noah's Flood' airs (TV documentary presenting the Black Sea deluge hypothesis to broad audiences)"
    },
    {
      "id": "a512f7db-5a67-4c26-8411-0d908211a5f8",
      "text": "French National Assembly (lower house) adopted a non‑binding resolution calling for non‑renewal of EU sanctions on Russia"
    },
    {
      "id": "0432a5dc-9139-4f9e-8346-33d3633cf2f2",
      "text": "High-profile promotion of ivermectin as a COVID-19 treatment by advocacy groups and physicians (e.g., Dr. Pierre Kory's Senate testimony) increased public attention to the drug"
    },
    {
      "id": "8987703c-09a0-4a89-b7de-26177897cfb5",
      "text": "Italy imposes national lockdown amid surging deaths in Lombardy"
    },
    {
      "id": "b2da0a15-df9d-4652-8e36-56d2c0f29af2",
      "text": "Launch and widespread use of the Johns Hopkins global cases-and-deaths dashboard"
    },
    {
      "id": "73442f47-7f8e-472e-9206-3f32b19a5161",
      "text": "Publication of legitimate but small, case‑based autopsy and myocarditis reports showing rare fatal events after vaccination (peer‑reviewed case reports and small series)"
    },
    {
      "id": "abac13d2-7169-4c1d-b450-72fae04f1142",
      "text": "WHO publication 'Considerations regarding consent in vaccinating children and adolescents between 6 and 17 years old' describes 'implied consent' as one approach"
    },
    {
      "id": "64edff3f-a376-4056-b11b-027d0773ca96",
      "text": "Public controversy and regulatory curtailment of Delta water export pumping to protect endangered delta smelt"
    },
    {
      "id": "a6b153e0-68cf-4345-b16a-5d5466f30f29",
      "text": "2002 Klamath River fish kill and disputes over irrigation curtailment"
    },
    {
      "id": "bb26bcd8-0a0f-4bba-8469-7880dae97789",
      "text": "Governor Jerry Brown issues Executive Order B-29-15 mandating 25% statewide urban water-use reductions"
    },
    {
      "id": "373f6412-6baf-43eb-8677-2ed1f31c6eaa",
      "text": "Oroville Dam spillway failure and emergency releases that forced evacuations"
    },
    {
      "id": "4a142742-30f0-48ff-9d5c-cad9814da2e8",
      "text": "Regulatory debate and slow approval process for new sunscreen active ingredients (Sunscreen Innovation Act enacted Nov 26, 2014; ongoing FDA reviews of sunscreen ingredient safety)."
    },
    {
      "id": "c1357c61-adf8-4bbc-8ee2-91964a807394",
      "text": "Published toxicology and endocrine-disruption research and reviews (e.g., reviews summarizing in vitro/animal evidence that some chemical UV filters like oxybenzone have endocrine activity)."
    },
    {
      "id": "37f4799e-ac16-4d40-9bf7-7b2e33db04b4",
      "text": "April 2015 Calbuco eruption (Chile) — satellite and news reports quantified large volcanic gas/ash emissions during the explosive event."
    },
    {
      "id": "7c0622b6-4c06-434c-a1c1-e220f0a5abd0",
      "text": "Publication and dissemination (2011) of quantitative comparisons of volcanic vs. anthropogenic CO2 emissions (T.M. Gerlach, EOS/AGU summary and related USGS-hosted PDF)."
    },
    {
      "id": "9d3d7a4c-8dfa-4061-8966-1c80e104d1dd",
      "text": "CDC and FDA recommend a temporary pause (April 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of a rare clotting disorder (TTS)"
    },
    {
      "id": "f422c635-230d-4085-894e-77e4bc8d2a2b",
      "text": "European Medicines Agency (EMA) finds a possible link between the AstraZeneca vaccine and very rare blood clotting events and recommends listing them as very rare side effects"
    },
    {
      "id": "48871f40-b374-43ad-acd0-10030f089443",
      "text": "Israel reports a probable link between the Pfizer-BioNTech vaccine and a small number of myocarditis cases following vaccination"
    },
    {
      "id": "65bfb0ea-7932-43c3-913f-5df60038e8ab",
      "text": "Japan finds foreign (black/stainless steel) particles in multiple Moderna vaccine vials, prompting suspension of specific lots"
    },
    {
      "id": "88135041-5a6a-4054-b86b-377b5fcc84a6",
      "text": "IPCC release of the Special Report 'Global Warming of 1.5°C' (SR1.5)"
    },
    {
      "id": "2e24562f-fb40-4a6a-a30a-ae3834c49445",
      "text": "IPBES Global Assessment Report on Biodiversity and Ecosystem Services (press release)"
    },
    {
      "id": "9b6368f5-3479-4185-8bdd-eb93154ad53a",
      "text": "Regulatory updates and clarifications on convalescent plasma donor eligibility by U.S. regulators (FDA guidance changes)"
    },
    {
      "id": "f319eb18-5151-41ec-ab61-08335d766535",
      "text": "American Red Cross public guidance clarifying vaccinated people are eligible to donate (FAQ)"
    },
    {
      "id": "e8e3ddc6-6a6c-4652-a4e0-4667177529de",
      "text": "Different national blood-service wait times after COVID vaccination (e.g., Australia Lifeblood 3‑day deferral)"
    },
    {
      "id": "bdbccbbe-eee1-446c-b0a8-4d84bc8334a1",
      "text": "National HIV surveillance/monitoring reporting showing ongoing variant diversity and surveillance activity in the Netherlands (HIV Monitoring Report 2021)"
    },
    {
      "id": "7b2fc77e-9928-4b79-a078-6220f6106ae5",
      "text": "Earlier research documenting an HIV recombinant (CRF19_cpx) associated with rapid progression to AIDS in Cuba (2015)"
    },
    {
      "id": "fc2221fd-331e-4e4d-9500-ee288d246c3c",
      "text": "Earlier punitive COVID-era measures: France suspends about 3,000 unvaccinated healthcare workers without pay after mandatory vaccination rules (September 2021)."
    },
    {
      "id": "22e284db-951a-4166-9096-35c264340b2e",
      "text": "French National Assembly adopts (first reading) Article 4 creating a new offence of \"provocation à l'abandon ou à l'abstention de soins\" (encouraging people to abandon medical treatment)."
    },
    {
      "id": "a44177d6-2464-4605-b4b7-dbeef94f5949",
      "text": "Large, recurring anti‑vaccine and anti‑pass protests in France (e.g., national rallies with >100,000 participants on 9 January 2022 and major protests in 2021)."
    },
    {
      "id": "636d70cc-b434-4ae6-9e92-4d776254bd53",
      "text": "Article 4's text (as adopted) includes penalties up to one year in prison and €15,000 fine, rising to three years and €45,000 when the provocation 'has been followed by effects'."
    },
    {
      "id": "b69b00bd-1c0f-4c05-bc07-81f2e3e39b4e",
      "text": "Ukraine files case and ITLOS issues provisional measures in dispute over detained Ukrainian naval vessels (Ukraine v. Russian Federation)"
    },
    {
      "id": "61bedcf1-152f-4e4c-8cc2-f36e308c8054",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels"
    },
    {
      "id": "b19f7cda-33d5-40f6-b0d5-eb8e9af54659",
      "text": "Coverage noting Russia's gain of maritime/sea resource claims after annexation (media analysis of rights to offshore resources)"
    },
    {
      "id": "f9605271-979c-44cc-ad70-a9223ad34a55",
      "text": "Reporting on foreign volunteers and fighters joining both sides in the Donbas conflict (including fighters who joined Azov)"
    },
    {
      "id": "16f99f21-2a2b-411d-b650-b44faaad6bb2",
      "text": "Publicised incidents in August 2014 where Ukraine displayed captured Russian servicemen"
    },
    {
      "id": "228dafec-172f-4d6f-a160-297e589c447b",
      "text": "Norway investigation (January 2021) into deaths of 23 frail elderly patients shortly after Pfizer/BioNTech vaccination"
    },
    {
      "id": "7d27a311-e2d7-4230-9432-759924944e8e",
      "text": "World Bank reports sharp contraction in remittances to Ukraine in 2014–2015 (noting drops from Russia)"
    },
    {
      "id": "c17b3626-b338-48e3-b571-2baade16e313",
      "text": "IMF approves a $17.5 billion loan program for Ukraine (March 2015)"
    },
    {
      "id": "59e758c1-c8a0-4494-ac3a-233f6cf71575",
      "text": "Russia announces and enforces bans/restrictions on Ukrainian food and agricultural imports"
    },
    {
      "id": "63801b9b-1d6b-45df-937d-05ef8f6c6465",
      "text": "Gazprom reduced/cut natural gas supplies to Ukraine amid pricing and payment disputes"
    },
    {
      "id": "4c8e9da5-5bdc-4932-8d55-41984416cd05",
      "text": "USDA launches the 'Partnerships for Climate‑Smart Commodities' program and announces $1 billion investment to support climate‑smart practices, including regenerative approaches (Feb 7, 2022)."
    },
    {
      "id": "4470e99a-dacf-40c0-92d2-cf36af84c32e",
      "text": "General Mills publicly commits to advancing regenerative agriculture on one million acres and launches partnerships and promotional materials (announced in 2020)."
    },
    {
      "id": "c7a5bcbc-2006-4764-8207-620d09886a38",
      "text": "Publication of scholarly review 'What Is Regenerative Agriculture? A Review of Scholar and Practitioner Definitions' (Frontiers in Sustainable Food Systems, 2020) documenting inconsistent definitions and mixed empirical evidence on soil outcomes."
    },
    {
      "id": "69fda331-49f4-41e8-91fd-54e672b4af61",
      "text": "Case report: 'Development of High‑Grade Sarcoma After Second Dose of Moderna Vaccine' (Cureus case report)."
    },
    {
      "id": "c48d12ac-4849-4c1d-a010-8c0445099769",
      "text": "Publication describing diagnostic pitfalls after COVID‑19 vaccination (e.g., post‑vaccine lymphadenopathy causing false‑positive oncologic imaging findings)."
    },
    {
      "id": "218979e2-6346-46d5-84e7-bcf3652d7a9b",
      "text": "Ukrainian leadership publicly framed parts of the conflict as involving 'foreign mercenaries' (statement by President Petro Poroshenko), drawing international attention to non‑Ukrainian fighters."
    },
    {
      "id": "78cfbbbe-314b-4a70-9cb8-db5cf39b5d72",
      "text": "Media reporting and profiles linked ASBS Othago to former Polish Interior Minister Bartłomiej Sienkiewicz and documented the firm's past activity/contracts (company background coverage in June 2014)."
    },
    {
      "id": "af2ce867-2914-4513-8c2f-62a70058b763",
      "text": "Separatist commander Igor Strelkov (Girkin) and associated militia briefings in late July 2014 repeatedly alleged that foreign mercenaries (including Poles) were operating and being killed in Donbas."
    },
    {
      "id": "b79c0518-028b-42b2-a7b8-55238d2da5d2",
      "text": "IPCC Fifth Assessment Report (AR5) — Summary for Policymakers (WG1)"
    },
    {
      "id": "04b492a5-c4c7-4b19-bb3c-45a7054015bb",
      "text": "U.S. announcement of withdrawal from the Paris Agreement (President Trump, June 2017)"
    },
    {
      "id": "c92d754a-4f19-4748-bb42-dd99695f6ae4",
      "text": "Detailed reporting on Ukraine's use of electronic warfare to jam drones and communications"
    },
    {
      "id": "ca3c207a-2dd4-4d6e-b63a-2a6eb4f34133",
      "text": "Explosion in Przewodów, Poland kills two amid Russia-Ukraine attacks"
    },
    {
      "id": "56582cd1-f8c4-4a94-a701-1c06b71c798e",
      "text": "Coverage of the proliferation of small, portable EW systems ('EW backpacks') used by Ukrainian forces"
    },
    {
      "id": "fcfe8808-9e01-45de-93f6-29d62e4ecc7e",
      "text": "Reporting on routine use of drone swarms and the complexity of attribution in drone warfare"
    },
    {
      "id": "999182db-2625-4ed4-bee4-2651ff7ab1f4",
      "text": "Precedent: Ukraine imposed sanctions/entry bans on foreign politicians (e.g., three French MEPs) who visited Crimea without Kyiv's permission."
    },
    {
      "id": "d5c07d75-9a2b-4f52-9375-4e117e5c9de0",
      "text": "ACT UP protests and high‑profile demonstrations targeting Burroughs Wellcome and regulators over AZT pricing, access and trial practices (1988–1989)"
    },
    {
      "id": "762e6407-10e1-4560-b0ca-3d37bb092d6c",
      "text": "FDA approval of AZT (zidovudine) in March 1987"
    },
    {
      "id": "39a925b2-b74c-4874-bc92-c3cbfdc46c80",
      "text": "2019 electoral performance of pro‑Russia parties (Opposition Platform — For Life) showing notable support in southern/eastern Ukraine in parliamentary elections."
    },
    {
      "id": "fb3a1bf0-a119-4364-a911-6554bb3613f7",
      "text": "Release/presentation of the Resilient Ukraine 'National resilience characteristics' survey including Odesa results (Resilient Ukraine/ICDS research presented mid-November 2021)."
    },
    {
      "id": "bd6239fd-09e8-4ff6-8c9a-79bb5394f59b",
      "text": "2001 Ukrainian census language data for Odesa region showing a high share of Russian speakers."
    },
    {
      "id": "b9666832-ade3-4dd6-98de-b270acc661b6",
      "text": "May 2, 2014 Odesa trade union building fire and subsequent portrayal in Russian/state and pro‑Kremlin media."
    },
    {
      "id": "60f86427-d4ae-47e8-bb90-2baa9a16eaa3",
      "text": "Reporting on volunteer battalions and Ukrainian units using mixed, Soviet- or foreign-origin uniforms and equipment because of shortages (Reuters special report)"
    },
    {
      "id": "c40215cb-f88d-4c3c-bef4-40584de842fc",
      "text": "OSCE Special Monitoring Mission reported observing convoys and personnel in Donetsk/Luhansk in unmarked dark-green uniforms and unmarked armoured vehicles (spot reports 2014)"
    },
    {
      "id": "29d17b68-96a8-410d-acb8-8f586fd813c3",
      "text": "Publication of JAMA case series reporting 88.1% mortality among mechanically ventilated COVID‑19 patients in New York (Richardson et al., 5700 patients)."
    },
    {
      "id": "60b4df88-018b-4498-9d6b-675151d5ae0a",
      "text": "Japan suspends use/shipments of some Moderna vaccine batches after reports of foreign particles in vials"
    },
    {
      "id": "5d6392b7-7672-4984-90c2-2bbc04d3e340",
      "text": "Assassination of Arsen 'Motorola' Pavlov in an elevator explosion in Donetsk"
    },
    {
      "id": "42e7d87f-ac81-49a4-b5ef-227fee56c62f",
      "text": "Reports by human rights groups documenting repression and propaganda targeting Crimean Tatars (2014)"
    },
    {
      "id": "3fa92da9-bf8a-476c-b420-e17386dc2c3d",
      "text": "Large pro‑Ukraine rally organised by the Mejlis (February 26, 2014)"
    },
    {
      "id": "91111922-c5d4-4a81-8de2-6b66f1c3279b",
      "text": "Japan suspends proactive recommendation for the HPV vaccine"
    },
    {
      "id": "d1ab25fa-1cfd-41e4-bd76-cdd74ca6bb2c",
      "text": "Controversy and parliamentary inquiry into HPV vaccine projects in India (PATH studies)"
    },
    {
      "id": "acc49a20-eaf2-404b-9bec-b4368de91130",
      "text": "Increased public reporting and media coverage of adverse events (VAERS data highlighted) around 2015–2016"
    },
    {
      "id": "bdb876f5-73e9-4c5d-b8b8-24a290e4ffe4",
      "text": "International Paralympic Committee (IPC) decision to allow Russian and Belarusian athletes to compete under their national flags at the Milano Cortina 2026 Paralympics."
    },
    {
      "id": "effb38df-4036-4437-9033-bcf6992ca029",
      "text": "Ukrainian government/officials announced they would boycott Paralympic officials' attendance (ceremonies) in protest while specifying that athletes would still compete."
    },
    {
      "id": "cf2b8c88-247b-4d9c-8c52-d1ab5bfcda93",
      "text": "New York Times report (June 25, 2022) on a covert 'commando network' of U.S. and allied forces coordinating weapons and assistance in Ukraine"
    },
    {
      "id": "472f2da8-0427-4361-9b25-4d93d7c41104",
      "text": "CIA Director William Burns publicly estimated roughly 15,000 Russian troops killed (U.S. intelligence estimate) at the Aspen Security Forum"
    },
    {
      "id": "7213d7a8-55b7-41c7-8d70-7dc155ca102f",
      "text": "FDA pediatric vaccine briefing document noted reported seizure events in surveillance/clinical data"
    },
    {
      "id": "c5f9c08b-5324-42f7-a3c5-bb9deb54375f",
      "text": "European Parliamentary Research Service brief explaining the religious split and the Tomos process (EPRS brief on Ukraine and religion published Jan 2019)."
    },
    {
      "id": "68bc38f6-99cb-4a95-9d9f-fecd624d95d2",
      "text": "Media reports and commentary documented Poroshenko's 'Tomos tour' and use of the Tomos in his re-election campaign (coverage in KyivPost, Financial Times and others in Jan–Feb 2019)."
    },
    {
      "id": "35ea6519-3949-4886-af7c-a16415792eca",
      "text": "Ecumenical Patriarch Bartholomew signed and handed over the Tomos of Autocephaly for the Orthodox Church of Ukraine (Tomos ceremony and handover in Istanbul/Kyiv, early January 2019)."
    },
    {
      "id": "c1724b7f-f234-404c-a369-09e839958054",
      "text": "Ukrainska Pravda report that Polish special‑forces personnel guarded Ukrainian negotiators (Brest/early March 2022)"
    },
    {
      "id": "eff22e41-0c9b-40c6-af46-0f65af2be234",
      "text": "New York Times report revealing a 'commando network' of Western special-operations personnel assisting Ukraine"
    },
    {
      "id": "621e30a8-e3a6-4a1e-8148-625c788f17ba",
      "text": "Persistent academic and policy‑community discussions in Russia and elsewhere promoting the 'deep/abiogenic oil' idea (conferences, review articles and summaries circulated throughout the 2010s and continuing into the early 2020s)"
    },
    {
      "id": "7c23a944-c1c8-4e60-ad55-a315dd953f0a",
      "text": "Experimental laboratory evidence (Kolesnikov et al., Nature Geoscience) showing that methane can produce heavier hydrocarbons under upper-mantle pressure‑temperature conditions (widely cited by abiogenic proponents)"
    },
    {
      "id": "508d98f3-daa9-48ab-94e6-c84842abd664",
      "text": "First confirmed delivery/arrival of German PzH 2000 howitzers to Ukraine"
    },
    {
      "id": "db1a7681-204e-4a6e-bee8-7555e7d1e7bb",
      "text": "Published research on extreme droughts and increased tree mortality in the Amazon (e.g., record‑breaking 2015/2016 drought analyses and 2016 Nature Scientific Reports paper)."
    },
    {
      "id": "5702700a-9e3a-4d47-bd2f-f6267d3bfb8a",
      "text": "Public interviews and quotes from climatologist Carlos Nobre (2019) stating that 'over fifty percent of the Amazon may be lost within decades' if tipping points are crossed."
    },
    {
      "id": "45c89f5e-2f92-41fc-9e61-9a7bdd31acef",
      "text": "Passage of Ukraine's 'decommunisation' laws and ensuing public debate, including renewed official attention to OUN/UPA memory"
    },
    {
      "id": "e11cd318-1c62-482d-956c-1e3fef6d9597",
      "text": "Existence and history of paramilitary/nationalist groups using 'tryzub'‑related names and insignia (e.g., Tryzub organisation formed 1993)"
    },
    {
      "id": "0a63eac9-8b10-4812-845e-27384d4011ce",
      "text": "International reporting on the Azov volunteer unit's far‑right links and symbols (including 2014–2015 coverage)"
    },
    {
      "id": "051ea1e9-5523-46c7-9da6-88c538586f18",
      "text": "Spanish‑language press and analyses highlighting the rise/role of ultranationalist groups in Ukraine"
    },
    {
      "id": "18627898-a921-455c-93d6-8ce216b6c674",
      "text": "Great Barrington Declaration advocating 'focused protection' and natural herd immunity"
    },
    {
      "id": "71b6d51c-90a4-4139-852f-aee305ae0835",
      "text": "CDC launched the COVID-19 Seroprevalence Studies Hub (SeroHub)"
    },
    {
      "id": "6b5b3209-851c-45f6-85da-5cd1c52ea48c",
      "text": "SeroTracker dashboard providing compiled seroprevalence estimates"
    },
    {
      "id": "a97c39db-1aed-4a0c-904d-6b9a2bdc8ce9",
      "text": "Office for National Statistics (ONS) dataset 'Deaths by vaccination status, England' (period analyses up to May 2023)"
    },
    {
      "id": "19e3f2e7-1f5f-4057-8c33-eaa88ecd8b11",
      "text": "Early patient‑led surveys and small observational preprints reporting mixed effects of vaccination on long‑COVID symptoms (e.g., Massey et al. medRxiv July 2021)"
    },
    {
      "id": "755c3d09-13eb-488d-aafe-355aee37e54a",
      "text": "Publication of Choi et al., 'Developmental Fluoride Neurotoxicity: A Systematic Review and Meta‑Analysis' in Environmental Health Perspectives (lead author Anna L. Choi, Harvard affiliation)."
    },
    {
      "id": "8f8a1fe0-054c-4805-91d2-1f315564e9e2",
      "text": "WHO Expert Committee review and public statements on cannabis (pre-review June 2018; outcomes published Jan 2019)"
    },
    {
      "id": "c04e7acb-a195-4fa0-bd8a-2ac9d90dc9f1",
      "text": "Preclinical studies showing cannabinoids can promote hippocampal neurogenesis (mid‑2000s lab research)"
    },
    {
      "id": "8f08754d-53ef-4d85-8001-af0a15e08cc7",
      "text": "Ukraine filed an application instituting proceedings against the Russian Federation at the International Court of Justice (ICJ)."
    },
    {
      "id": "fda6b7dd-0801-43b6-b4eb-0387977a987d",
      "text": "Reports that U.S. intelligence and law‑enforcement personnel were advising Ukraine"
    },
    {
      "id": "40536ea9-1e09-4388-9c4e-a20eb9b71204",
      "text": "U.S. Ambassador Geoffrey Pyatt photographed paying respects at Kyiv's Maidan"
    },
    {
      "id": "5d664621-21f3-4440-8668-201728d0a3f0",
      "text": "Ukraine's State Emergency Service and local reporting confirmed an apartment building on Lobanovs'koho Avenue was hit by a missile during strikes on Kyiv."
    },
    {
      "id": "c2e16897-3bc7-44c5-ae38-8d5b76119a14",
      "text": "Russian missile strikes and intensified attacks in Sumy region (producing civilian casualties and damaged infrastructure)"
    },
    {
      "id": "6dd11535-10d3-47ab-b07b-308c6c7ab99c",
      "text": "Previous high-profile deaths of Ukrainian servicewomen (example: combat medic Yana Rykhlitska killed in action)"
    },
    {
      "id": "e124c13f-6a31-4552-b776-9c8cd3da2e20",
      "text": "Public announcement and press coverage of Ukraine's new all-female drone unit ('Harpies') and recruitment drive"
    },
    {
      "id": "b0d60f47-6669-4391-b656-a5f96dccbc74",
      "text": "Valentyn Nalyvaichenko had been appointed Head of the Security Service of Ukraine (SBU) in February 2014 and became a high-profile security official."
    },
    {
      "id": "f8254991-a263-4f0f-b469-53086ef94686",
      "text": "Publicly known foreign-volunteer pathways to serve in the IDF (the 'Mahal' / volunteers-from-abroad tradition)"
    },
    {
      "id": "4964ca25-06aa-4cf2-876f-69e4a7690652",
      "text": "Large influx of Ukrainian refugees to Israel after Russia's 2022 invasion"
    },
    {
      "id": "2e07a7b1-49cf-4d84-9b94-641aea283ddf",
      "text": "Hamas surprise attack on Israel and ensuing nationwide mobilization (Oct 7, 2023)"
    },
    {
      "id": "865462a9-8a34-448c-bb8c-328656ba28e6",
      "text": "Heavy fighting and Ukrainian forces retake Donetsk airport, with immediate reports of dozens killed and injured"
    },
    {
      "id": "fb123684-7415-483d-a978-fec91ccba8b5",
      "text": "Widespread reporting that Boris Nemtsov was a prominent Kremlin critic and vocal supporter of Ukraine"
    },
    {
      "id": "b3f91f51-786d-436f-9d18-3ff001743926",
      "text": "U.S. Ambassador John Tefft publicly laid flowers at the makeshift Nemtsov memorial near the Kremlin"
    },
    {
      "id": "ed690654-d87d-4362-9e8d-10d320020a00",
      "text": "Reports of foreigners and 'protest tourists' crossing from Russia into eastern Ukraine"
    },
    {
      "id": "d6d7c667-9bc6-4290-b657-06e4474549ec",
      "text": "High‑profile history and public memory of U.S. private military firms (e.g., Blackwater) from Iraq"
    },
    {
      "id": "994b681b-2928-4c7f-a53a-6f9dad1c6bac",
      "text": "Pro‑Russian protesters and armed men seize Donetsk regional government building"
    },
    {
      "id": "da46e9b8-c3ee-4f06-a499-08731c676f75",
      "text": "Unmarked, heavily armed 'little green men' operate in Crimea, raising questions about covert foreign forces"
    },
    {
      "id": "a5f1b802-c83e-4b26-b021-63db9730cf9a",
      "text": "CDC release and analyses of NHANES dental fluorosis data (analysis of 1999–2004 and 2011–2016 data; Vital and Health Statistics Series 2 No. 183)."
    },
    {
      "id": "589b69b1-8cf4-47d6-9557-8ed7a4dbe822",
      "text": "FDA‑required poison warning language on fluoride toothpastes and Poison Control guidance advising to contact poison control if a child swallows more than used for brushing."
    },
    {
      "id": "947eb814-56a8-407d-abce-805377cabbd3",
      "text": "Later laboratory research reporting synergistic inhibitory effects of capsaicinoids on platelet aggregation (e.g., Blood Coag Fibrinolysis / related 2018 study)."
    },
    {
      "id": "3035d86b-acc0-4403-bffd-6700fef7bb0c",
      "text": "Polish media coverage of the Bykivnia visit and related Polish‑Ukrainian historical memory issues (coverage in outlets such as Dziennik.pl / Polskie Radio)."
    },
    {
      "id": "a2baeb15-6e10-4fd9-805d-c5d5f7720324",
      "text": "CDC recommended community use of cloth face coverings (change in U.S. guidance)"
    },
    {
      "id": "042d73a9-eff0-48d9-87f1-42da99cdea5f",
      "text": "CDC/NCHS issued expanded guidance on certifying deaths due to COVID-19"
    },
    {
      "id": "c16348f4-f677-4500-9bce-e94363964920",
      "text": "WHO interim guidance stated limited direct evidence for universal masking in healthy community members"
    },
    {
      "id": "850cf0c3-c0b7-4270-a07b-2845822447ed",
      "text": "Official surveillance reporting showed an unusually low influenza season during the COVID-19 pandemic"
    },
    {
      "id": "eb81506a-1e5d-49a4-b1e0-78fa8d5785ab",
      "text": "IPCC Fifth Assessment Report (AR5) Summary for Policymakers states strong evidence of human influence on the climate system"
    },
    {
      "id": "d42a2ca4-b7f8-4e98-a8a3-231bc4ccccff",
      "text": "NSIDC and NASA report record-low Arctic sea ice extent in 2007"
    },
    {
      "id": "876cafe0-7630-405c-b6e1-94aad8874fe2",
      "text": "Adoption of the Paris Agreement at COP21, driving major political attention to climate policy"
    },
    {
      "id": "5f1983cf-65eb-463a-8550-1f6af19a3988",
      "text": "Ukrainian authorities released video footage they said showed a Buk missile launcher being moved in rebel‑held eastern Ukraine"
    },
    {
      "id": "d2e60abb-a3b6-4cdb-8512-655a66edd080",
      "text": "Pro‑Russian separatists and armed groups restricted and controlled access to the MH17 crash site, and international observers reported limited/unfettered access and allegations of tampering"
    },
    {
      "id": "42af163d-b12c-48f8-8f72-f5bf6759e608",
      "text": "Germany publicly approved and announced it would send Leopard 2 main battle tanks to Ukraine, prompting high-profile media coverage."
    },
    {
      "id": "9eec3efe-4807-4322-886e-22aa5f0309a5",
      "text": "Russian leadership and state media advanced a 'denazification' narrative about Ukraine beginning with Putin's public addresses in February 2022."
    },
    {
      "id": "9ed66cda-429d-4b92-8a4c-8184ff773926",
      "text": "FDA issued authorizations in September 2022 for updated (bivalent) COVID‑19 booster doses under Emergency Use Authorization rather than new full biologics license approvals."
    },
    {
      "id": "36a12859-4750-4aaa-9c12-392e90d727eb",
      "text": "FDA formally approved the Pfizer–BioNTech COVID-19 vaccine (Comirnaty) — first COVID-19 vaccine to receive full FDA approval."
    },
    {
      "id": "1c97aaf9-42ae-463e-a597-d94917fde197",
      "text": "UN and international media reporting (May 2014) documenting allegations of abuses by volunteer battalions and armed groups in eastern Ukraine"
    },
    {
      "id": "1fb3f6d4-c8cd-4d56-9cec-0948e64aaeda",
      "text": "Formation of the Dnipro‑1 volunteer/special police battalion in April 2014, linked to local oligarchic support"
    },
    {
      "id": "e2ac372d-a166-4881-9474-9c11807b1178",
      "text": "Violent crackdown on Euromaidan protesters in Feb 2014, including widely reported beatings with batons and sticks"
    },
    {
      "id": "a6f8b9a8-185b-4f04-bcf2-404080257ea8",
      "text": "Ihor Kolomoisky appointed governor of Dnipropetrovsk Oblast, giving him formal regional authority and visibility"
    },
    {
      "id": "3a958841-35e3-4334-b6b0-5e888a760ced",
      "text": "Odessa trade-union building fire and mass deaths during clashes"
    },
    {
      "id": "37fce88b-2358-4766-9435-a0717c3405c5",
      "text": "Public torchlight marches and commemorations for Stepan Bandera in 2014 (Lviv and elsewhere)"
    },
    {
      "id": "8426f0f1-04a1-4750-92e4-99b90403eae0",
      "text": "Prominent role and publicized violence of Right Sector during Euromaidan/early 2014"
    },
    {
      "id": "04c77015-a45b-4365-9b9e-74d977cbc12f",
      "text": "Japan suspended use/withdrew batches of Moderna COVID‑19 vaccine in August 2021 after reports of particulate contamination in some vials."
    },
    {
      "id": "c0b7a5eb-b0bf-47b5-a328-58a0f3ff8bd0",
      "text": "Publication of Tokyo autopsy series (Legal Medicine) reporting autopsy findings for deaths occurring shortly after COVID‑19 vaccination and noting a small number of cases with possible vaccine‑related causes (e.g., myocarditis, thrombosis) — November 2022."
    },
    {
      "id": "2fe478ae-a877-44a3-8f18-668db21a5348",
      "text": "National Academies report (December 2020) assessing unexplained health incidents among U.S. government personnel concluded that directed, pulsed radio‑frequency (RF) energy is a plausible mechanism for some cases ('Havana Syndrome' assessment)."
    },
    {
      "id": "f61d6cc9-2903-4136-884f-7b3e17d13179",
      "text": "Media reporting on China’s expansion of large-scale weather‑modification programs (cloud‑seeding and the proposed ‘Sky River/Tianhe’ projects) intensified in late 2017–2020 (notably coverage in Dec 2020)."
    },
    {
      "id": "eea34e2f-2775-4904-93fe-62aaaaabe850",
      "text": "University of Alaska Fairbanks (UAF) formally received operation of the HAARP facility from the U.S. Air Force and opened the site to civilian researchers and public outreach (transfer ceremony and subsequent open house)."
    },
    {
      "id": "29a35ac1-ec35-49be-b7b3-426e424bdfa5",
      "text": "Venezuelan President Hugo Chávez publicly suggested a 'tectonic weapon' or U.S. involvement caused the 2010 Haiti earthquake, and political leaders and commentators repeated similar claims after major quakes (2010–2011)."
    },
    {
      "id": "a2ecdc6a-41ca-4b32-92be-1de1a2628ea6",
      "text": "Ukrainian Foreign Ministry summoned the Polish Ambassador to Kyiv (Jan Piekło) in response to statements by Poland's foreign minister."
    },
    {
      "id": "933adce9-9b87-4807-b8f6-6cbb181e88fc",
      "text": "Poland's Ambassador to Ukraine Jan Piekło publicly said Poland and the United States could be part of alternatives to the Minsk process and argued that Crimea should be on the Minsk talks agenda."
    },
    {
      "id": "06831552-14e5-4569-9ca9-c47d8f2f1201",
      "text": "Reports quoting former Polish foreign minister Radosław Sikorski that Vladimir Putin in 2008 allegedly suggested dividing Ukraine with Poland (widely publicized in 2014)."
    },
    {
      "id": "06d044b0-5302-484d-85db-51994723b229",
      "text": "Polish Foreign Minister Witold Waszczykowski gave a combative interview to weekly 'wSieci', saying, among other remarks, 'With Bandera you won't enter Europe' and criticizing Ukrainian historical politics."
    },
    {
      "id": "5d1a9831-cc92-4115-a2ec-ff7210d9087a",
      "text": "2012 'Blood, Urine, and Sweat (BUS)' studies reporting detectable levels of some toxicants in sweat"
    },
    {
      "id": "4600efc9-06a8-4dff-8c12-b27c8914405b",
      "text": "FDA warning letter (July 5, 2022) to a company marketing an infrared sauna with unapproved therapeutic/detox claims"
    },
    {
      "id": "561d7581-dc0e-40b9-b96b-ac143f095121",
      "text": "Publication of 2015 JAMA Internal Medicine study linking frequent sauna use to lower all-cause and cardiovascular mortality"
    },
    {
      "id": "1150a8df-dadc-4460-8904-03d1f9c58dfb",
      "text": "Amnesty International published reporting documenting civilian deaths and indiscriminate attacks in Donbas, Ukraine (providing background of real civilian suffering)"
    },
    {
      "id": "1b7ef4c2-1108-40b4-9481-c4e4be2b09e6",
      "text": "Public U.S. warnings linking continued international support to Ukraine's anti‑corruption progress (December 2015 coverage)"
    },
    {
      "id": "f6d886b4-d0a4-4969-bc31-c67b520d2a5c",
      "text": "Hunter Biden appointed to the Burisma board (widely reported in 2014)"
    },
    {
      "id": "dbe8b6ac-605c-4478-be22-c0b7129ee99d",
      "text": "Historical precedent of Ukrainian naval vessels being decommissioned and scrapped in prior years (public records and lists of former warships show multiple vessels written off or dismantled)."
    },
    {
      "id": "6b1d58c8-d531-46d1-a3de-d3942338e3a8",
      "text": "The Okean (Ocean) Mykolaiv shipyard complex was sold at auction to Annona Trading House for UAH 122.195 million (about $4.3 million)."
    },
    {
      "id": "01aa59fb-ce8d-4b3d-a98a-b57b041b163e",
      "text": "Local reporting and commentary documented the shipyard's long-term decline and degraded equipment under previous ownership (public discussion by local officials and regional press about dereliction and need for investment)."
    },
    {
      "id": "e13d298d-79b0-4aee-909e-3952b920571e",
      "text": "House Science Committee hearing and whistleblower accusations about NOAA data handling"
    },
    {
      "id": "6bf705ce-a12a-4f60-949e-6c0cae0a8d0c",
      "text": "NASA GISS documentation of methodological updates to the GISTEMP record"
    },
    {
      "id": "b1f8420d-1434-4ed7-9e9b-2f5b401ea971",
      "text": "NOAA Coral Reef Watch documents a global-scale coral bleaching episode affecting reefs worldwide during 2014–2016 (the largest recorded to date)."
    },
    {
      "id": "72373a32-4718-429d-865f-959e3973a9d6",
      "text": "ISW Russian Offensive Campaign Assessment (weekly assessments around Nov 11, 2024 noting Russian tactical gains such as leveraging Vuhledar seizure)"
    },
    {
      "id": "b11bf74a-611d-494c-8e3f-958935e00c4c",
      "text": "Reporting that Trump advisers proposed halting U.S. military aid to Ukraine unless Kyiv negotiated (June 25, 2024 Reuters)"
    },
    {
      "id": "b72f4d99-5380-4d0e-915e-78d8f4f84bbd",
      "text": "CNN publishes/airborne footage and reporting in early September 2024 showing videos of Ukrainian soldiers attempting to surrender and one apparent execution"
    },
    {
      "id": "f167b354-bd64-4739-bc03-653bb6852739",
      "text": "Russian strikes on Kyiv (10 June 2025) damaged a building identified by some outlets as the 'former British visa centre'"
    },
    {
      "id": "463757ac-1c31-450b-a9d8-1f782bf7eb1f",
      "text": "Official suspension/relocation of UK visa/consular services from Kyiv during March 2022"
    },
    {
      "id": "4616c099-332d-48b0-be2a-147071ab69a7",
      "text": "CDC issued expanded guidance on certifying COVID-19 deaths allowing confirmed and probable cases to be recorded and included in counts."
    },
    {
      "id": "06d01bdf-9277-442b-b673-b5c5a365b0ce",
      "text": "Italian National Institute of Health (ISS) reports showed a high proportion of COVID-19 deaths had multiple pre-existing conditions."
    },
    {
      "id": "67c0c967-1278-4a1b-a074-7121b12841f5",
      "text": "FDA authorizes Pfizer-BioNTech and Moderna COVID-19 vaccines for children down to 6 months old"
    },
    {
      "id": "48b3fcf6-2759-4a7a-8c1d-a26c0c29ee77",
      "text": "CDC publishes MMWR update on cases of myocarditis after mRNA COVID-19 vaccination in adolescents and young adults"
    },
    {
      "id": "9f35f38b-3794-4d37-a1c4-bf60d8e4a48b",
      "text": "President Zelensky announced the creation of an 'International Legion' and Ukraine openly called for foreign volunteers in late February 2022."
    },
    {
      "id": "41ac5159-bb0b-47a6-bb2f-f18ba9c57586",
      "text": "Ukraine imposed martial law and restrictions on men aged 18–60 leaving the country after the full‑scale invasion, generating widespread reports that men could not leave to avoid conscription."
    },
    {
      "id": "9a4d6d1a-bfe6-4637-9368-05a0a90b2fcb",
      "text": "UK Foreign Office advised British nationals to leave Ukraine and temporarily relocated its embassy office from Kyiv to Lviv amid the Russian build‑up."
    },
    {
      "id": "c0920958-79a0-44a2-bbc3-7e899fb22b93",
      "text": "Ukraine enacted further mobilization/conscription measures and parliamentary changes to expand recruitment in mid‑2024, attracting renewed international media attention."
    },
    {
      "id": "4f1c0efe-9bc3-44aa-a1b9-1a380a3cf4fa",
      "text": "Major anti-corruption probe and arrests tied to alleged fraud in Ukrainian arms procurement"
    },
    {
      "id": "4a46bc74-222c-4fe2-98d3-e36e76688bb5",
      "text": "Reporting on soldier and veteran grievances over pay, conditions and budget shortfalls"
    },
    {
      "id": "b257e337-06ca-43af-ac54-206bb782b9ce",
      "text": "Media coverage that Western defence contractors and arms firms saw revenue gains linked to the Ukraine war"
    },
    {
      "id": "2efd1f8e-6d3f-4e58-a5d7-d2874f20715f",
      "text": "Documentation of pro‑Kremlin narratives claiming Western military aid ‘prolongs the war’"
    },
    {
      "id": "ca9816ae-1d2d-49ea-a74f-44b004b3a8fb",
      "text": "Mainstream reporting on official research into solar geoengineering / stratospheric aerosol injection (interpreted by some as 'admissions' of atmospheric spraying)."
    },
    {
      "id": "50fd46cc-8d8f-4fe7-a98c-155464bb72a9",
      "text": "Publication of the 2017 '5G Appeal' by >180 scientists and doctors calling for a moratorium on 5G"
    },
    {
      "id": "d0c00902-401a-4f43-ab0f-ce04bcc0cafe",
      "text": "Germany granted final permit for Nord Stream 2 (March 2018)"
    },
    {
      "id": "017d0131-e8e6-4734-97f5-63d75131529d",
      "text": "Naftogaz announced Ukraine would resume buying gas from Russia in 2018"
    },
    {
      "id": "3dbcfda4-9a03-4305-9433-8138b360536a",
      "text": "Late-November 2018 cold snap in Europe caused sharp rise in gas demand and prices"
    },
    {
      "id": "abb4ef4b-2dca-49fb-82f9-00b5e7c75dca",
      "text": "Opinion polls in late January 2023 showing German public divided on sending heavy tanks to Ukraine"
    },
    {
      "id": "ed07c339-370d-44ac-99ba-4d39888dab8b",
      "text": "Media coverage (e.g., The Guardian, Jan 25 2023) highlighting Chancellor Scholz's hesitation and street‑level opposition rhetoric"
    },
    {
      "id": "8578fb81-6248-4821-b911-ce350c918471",
      "text": "Human Rights Watch report documenting use of unguided rockets in eastern Ukraine"
    },
    {
      "id": "5c12efda-8298-413a-9c12-4b36fb624d7c",
      "text": "Amnesty International / civil‑society reporting of widespread artillery and rocket casualties in summer 2014"
    },
    {
      "id": "54518935-b171-45ea-a2dc-7eeabe29f399",
      "text": "Downing of Malaysia Airlines Flight MH17 over eastern Ukraine"
    },
    {
      "id": "226db66c-43ac-43b7-b276-389ceb6fcbf6",
      "text": "Ukraine imposed a moratorium on repayment of a $3 billion eurobond held by Russia (Kyiv halted the payment)."
    },
    {
      "id": "35a8f742-b752-4acc-9240-051519a6aec5",
      "text": "The IMF publicly delayed/withheld a scheduled loan tranche to Ukraine in mid-2016 amid concerns over reform benchmarks and governance."
    },
    {
      "id": "9d6ae165-bc8c-4b5c-b106-e9f72d811855",
      "text": "Fitch Ratings downgraded Ukraine's long-term foreign-currency issuer default rating to 'CC' (placing it close to default territory)."
    },
    {
      "id": "4816eefb-d760-4c17-81ff-d99b1489f626",
      "text": "Ukraine agreed a major debt restructuring with private creditors (restructuring of roughly $15–18 billion of foreign debt)."
    },
    {
      "id": "e0dcc4e2-a5cd-490b-a35f-436d888941b5",
      "text": "Business Insider coverage highlights Starbucks filing multiple trademark/patent applications in Russia"
    },
    {
      "id": "bc87f35a-0a70-4f5b-8422-86653c75f043",
      "text": "Starbucks suspends operations and announces exit from Russia after invasion of Ukraine"
    },
    {
      "id": "281cb847-000f-4b27-bbda-89dfb3c7d33d",
      "text": "MedRxiv preprint by Zhao et al. reported an association between ABO blood group and COVID-19 susceptibility (blood group O less frequent among cases)."
    },
    {
      "id": "18935a3f-99e7-4246-b12b-b70d0518ae60",
      "text": "FDA communication and draft guidance clarifying aluminum limits for parenteral nutrition (recommending total allowable aluminum exposure from parenteral nutrition should not exceed 5 mcg/kg/day)"
    },
    {
      "id": "e7c874de-8ed7-47a0-b3cc-0883535ac190",
      "text": "Authoritative vaccine‑education pages comparing vaccine aluminum to dietary/environmental exposures (e.g., Children's Hospital of Philadelphia vaccine education center material explaining aluminum exposure context)"
    },
    {
      "id": "c30eddb3-a102-48ad-a621-91d4ebcd55a5",
      "text": "Ukrainian authorities announced lists/blacklists of Russian artists (around 40) who were banned from entering Ukraine for illegal visits to Crimea (2014–2017 reporting)."
    },
    {
      "id": "47540f62-880d-4495-a45c-d4a8e901debd",
      "text": "Ukraine and international reports (US State Department, EU statements) documented legal and administrative restrictions and sanctions related to Crimea as an occupied territory (2014–2018 reporting)."
    },
    {
      "id": "c35488c0-3e55-4d1a-949f-a25c144e3c97",
      "text": "Hundreds of trucks were reported stranded/blocked at checkpoints on the Ukraine–Crimea administrative border during the September 2015 blockade."
    },
    {
      "id": "d6e286ba-6e9c-48de-8d81-3c326f52ed71",
      "text": "President Petro Poroshenko signed Decree No. 549/2015 (September 16, 2015) introducing personal and economic sanctions related to the Crimea/Russia situation."
    },
    {
      "id": "97901ddd-6840-4fd4-8e81-248a7d8fc759",
      "text": "EU and Western measures enacted in 2014 imposed trade and import bans on goods/services related to Crimea (broader international restrictions on commerce with the peninsula)."
    },
    {
      "id": "ab865bf3-a564-4ebc-b231-3711ee9ae979",
      "text": "Explosions damaged power lines on November 22, 2015, causing a near‑islandwide blackout in Crimea."
    },
    {
      "id": "d6ffd937-63c8-4937-b8bc-2680e5603706",
      "text": "Russia begins issuing passports to residents of occupied parts of Donetsk and Luhansk (first issuance mid‑June 2019)"
    },
    {
      "id": "0904d2cb-95a1-4ca9-be6e-fc7300123c0b",
      "text": "Reporting that the EU was developing guidance on non‑recognition and visa handling for Russia‑issued Donbas passports (summer 2019)"
    },
    {
      "id": "cdcc6f3d-5b6c-4e81-9e04-05d8810ee886",
      "text": "March 2017 — Reporting on shelling risks to water‑treatment sites storing large chlorine stocks around Donetsk"
    },
    {
      "id": "202cb877-3015-439e-a30a-1822d69a1d24",
      "text": "May 2015 — DPR (pro‑Russian) claims alleging Kyiv/US plotting to use chemical weapons against separatists"
    },
    {
      "id": "1b5acd67-526c-4ff0-860f-e8c440307f91",
      "text": "Parliament adopted the Law of Ukraine 'On the Electricity Market' (electricity market reform)"
    },
    {
      "id": "e8a37bbc-823e-44da-ad0a-c6e9eaff6cb0",
      "text": "Ukrenergo / NCER announced a tariff rise for the national grid (12.2% increase) from April 2017"
    },
    {
      "id": "b839dc0b-24d9-452e-ab64-ab44b118877b",
      "text": "CDC/ACIP recommendation against using the FluMist (live attenuated intranasal) vaccine for the 2016–2017 season due to low effectiveness"
    },
    {
      "id": "1740bd82-9fc3-42b3-a80c-990595a405f7",
      "text": "Scientific and clinical literature reviews (2023) documenting that needle-biopsy 'seeding' is rare and biopsies remain standard practice"
    },
    {
      "id": "4cb31582-398a-46c1-8ddf-2854eaa9691b",
      "text": "Conviction and high-profile reporting on Tullio Simoncini, promoter of baking-soda and antifungal cancer theories"
    },
    {
      "id": "285be22e-0747-41c0-b4f1-f4dadc6756a1",
      "text": "Israeli health ministry study reported a probable link between Pfizer-BioNTech vaccine and a small number of myocarditis cases"
    },
    {
      "id": "5f8a8580-c98a-4db6-8994-d04b4a9d0e58",
      "text": "Public documentation of Western grants to Ukrainian civil society (e.g., National Endowment for Democracy annual reports listing grants to Ukraine-related groups)."
    },
    {
      "id": "4ff43d32-493b-4704-ba11-bb6a385dab0c",
      "text": "Ukraine Prosecutor General announced identification of 'titushky' operatives and people who hired them (investigations in March 2014)."
    },
    {
      "id": "8aef4794-569c-4d72-a08d-33e5086110df",
      "text": "U.S. officials and media reported evidence that pro‑Russian demonstrators in eastern Ukraine were likely being paid (statements and coverage around 7–8 April 2014)."
    },
    {
      "id": "1010388f-1e3e-44c3-a510-abf1b78faa77",
      "text": "IPCC Working Group II (AR6) report release — 'Climate Change 2022: Impacts, Adaptation and Vulnerability' (press release)"
    },
    {
      "id": "90bba792-9843-48c9-9e97-3d7085af8444",
      "text": "Western/Central Europe extreme rainfall and floods (July 2021) and attribution analyses"
    },
    {
      "id": "048c95d9-91ed-4ba0-abf2-1ba5dc8c1617",
      "text": "Pacific Northwest extreme heatwave (late June 2021) and rapid attribution studies"
    },
    {
      "id": "5c1726d3-4f7c-4a82-ab4d-e8b1a118ed77",
      "text": "Early clinical reports and case series documented severe hypoxemia and respiratory failure in COVID‑19 patients (e.g., Huang et al., The Lancet clinical features report)."
    },
    {
      "id": "db796729-ef7d-4250-af39-af43585a2e38",
      "text": "U.S. Ninth Circuit Court of Appeals opinion reviving lawsuit over LAUSD COVID-19 vaccine mandate (panel decision referenced plaintiffs' arguments about whether mRNA COVID-19 shots meet a legal/medical definition of \"vaccine\")."
    },
    {
      "id": "180acd4d-4778-4c28-90a1-ca94875592fa",
      "text": "CDC wording change on its web definition of \"vaccine\" in 2021 (language shifted from phrasing that implied absolute prevention of disease to wording emphasizing stimulating an immune response / producing immunity)."
    },
    {
      "id": "461e82dd-7599-4f59-83c6-3cccc96baf31",
      "text": "Ukrainian tactical pullbacks around Bakhmut reported amid renewed Russian assaults"
    },
    {
      "id": "231a0449-6132-4f06-970f-cbae52ee9afb",
      "text": "Peer-reviewed case report: PNH diagnosis and hemolytic flare following mRNA COVID-19 vaccination"
    },
    {
      "id": "92ca9dcf-ae92-4e9c-86b6-bc238956a0fd",
      "text": "Prominent pro‑Russian journalist Oles Buzina shot dead in Kyiv"
    },
    {
      "id": "6b004ef3-1883-418c-9791-f6efd45096f4",
      "text": "International press‑freedom monitors document multiple journalist deaths and attacks in Ukraine (2014–2015)"
    },
    {
      "id": "88a3dcec-9c0b-4238-9770-91adeb6a711a",
      "text": "Italian photojournalist Andrea Rocchelli killed while covering fighting in eastern Ukraine"
    },
    {
      "id": "a88c634a-c4ca-467d-be35-25181bd97292",
      "text": "Verkhovna Rada passes Law No. 314‑VIII recognizing OUN‑UPA and other groups as 'fighters for Ukrainian independence'"
    },
    {
      "id": "f7bbb825-6e31-4836-94fc-c9c21877a002",
      "text": "Ukraine enacts 'decommunization' laws banning Soviet/Nazi symbols and mandating removal of related monuments"
    },
    {
      "id": "7aca12db-b65a-4dd7-9b88-4ba2c84432bf",
      "text": "Kyiv City Council renames Moskovskyi (Moscow) Prospekt to Stepan Bandera Avenue"
    },
    {
      "id": "177d5bfc-b7fc-4976-862b-bd50c7e00821",
      "text": "Ukrainian Il‑76 transport aircraft carrying troops (including paratroopers) was shot down near Luhansk, killing dozens of soldiers."
    },
    {
      "id": "8f4ca7c4-7aeb-4e04-ae22-928a97fbbdd2",
      "text": "Standoffs and non‑engagements by Ukrainian servicemen in Crimea (notably the Belbek air base confrontation) where troops were shown not to fire on Russian forces."
    },
    {
      "id": "f75b18ce-ace3-4943-b15a-a61a8af1f693",
      "text": "CDC released guidance on certifying COVID-19 deaths that allowed listing confirmed or probable COVID-19 as the underlying cause"
    },
    {
      "id": "31ba559f-4607-4a4b-8ff1-fc95c31d06c7",
      "text": "Ukrainian government spokespeople and Ukrainian media reported that separatist/Pro‑Russian fighters were shelling residential areas in and around Donetsk, including Makeevka."
    },
    {
      "id": "dbce0965-3a6a-44fb-bebf-62e9d85bd5f2",
      "text": "Wire and photo services (Reuters / Thomson Reuters Trust) published images and on‑the‑ground reporting showing apartment blocks and streets in Makiivka/Makeevka damaged by shelling (images dated 19–20 August 2014)."
    },
    {
      "id": "ac41466e-8fb9-4f3a-b52e-57d3a0dc542f",
      "text": "Kerry defends the US effort to forge a Syria ceasefire amid public and Pentagon skepticism."
    },
    {
      "id": "56cd3399-ff94-403e-b870-abe99d4dd294",
      "text": "US and Russia announce terms for a 'cessation of hostilities' in Syria after talks in Munich."
    },
    {
      "id": "a88ebf1b-3427-4f5e-9a06-516d1fdba7e7",
      "text": "Human Rights Watch report documenting abductions, arbitrary detentions and other abuses against Crimean Tatars and pro‑Ukrainian activists"
    },
    {
      "id": "b95cbcfb-1859-44f6-8426-cefe788205d4",
      "text": "Russian-appointed courts/authorities banned the Mejlis, the representative body of Crimean Tatars, as an 'extremist' organization"
    },
    {
      "id": "41f2951c-d0a7-4ac9-9169-ef151bcf971d",
      "text": "Blocking of international observers and incidents of violence during the March 2014 Crimea referendum (shots fired, OSCE observers blocked)"
    },
    {
      "id": "3f934331-cfc9-4ec1-928b-e20288e4d2c6",
      "text": "Deployment of unmarked Russian troops ('little green men') who seized key sites in Crimea (parliament, airports, bases)"
    },
    {
      "id": "1371df07-807d-4c84-8049-638650fd3c90",
      "text": "Reports in Norway of deaths among frail elderly after Pfizer vaccination (23 deaths discussed)"
    },
    {
      "id": "e3b9f8a4-eb6a-484a-a53d-e57425a80639",
      "text": "CDC and FDA recommended a pause on the Johnson & Johnson COVID-19 vaccine over rare blood clot reports"
    },
    {
      "id": "54e46ee3-95e6-4cfb-8445-16db2423c0cb",
      "text": "WHO updated its interim guidance on mask use for COVID-19, advising use of masks in community settings (interim guidance published 5 June 2020)."
    },
    {
      "id": "6d6f556d-e0db-4156-a673-9ad50fc2fdbd",
      "text": "CDC recommended the public wear cloth face coverings in public settings (initial public recommendation announced April 3, 2020; guidance amplified through April–June 2020)."
    },
    {
      "id": "64978861-84fa-4ed8-bc86-52aeda4a8e84",
      "text": "Coverage documented how face masks became a politicized symbol in the United States (e.g., New York Times feature, June 2, 2020)."
    },
    {
      "id": "b09279b2-e529-4b35-b8b1-0d90aedad64b",
      "text": "NASA / Earth Observatory and related agencies reported exceptionally low Antarctic sea‑ice extents in 2022–2023 (record lows for seasonal maxima/minima)."
    },
    {
      "id": "b5a63837-c8c4-4d64-ab33-45ea0718de8c",
      "text": "Concern about toxic rocket propellant and debris after Proton failures (public safety headlines)"
    },
    {
      "id": "df2043c4-1c1e-4eff-a2c3-58e6130552d2",
      "text": "IPCC Fourth Assessment Report (AR4) release (Working Group I) stating recent decades were likely the warmest in at least the past 1,300 years"
    },
    {
      "id": "31f0493f-3a54-4dc6-aebf-92b2c556d73c",
      "text": "Wegman report (US Congress/2006) critical of statistical methods in the 'hockey stick' reconstructions"
    },
    {
      "id": "b8cfb2fa-2f84-4e66-92c7-2b808351286f",
      "text": "Ban on dashboard cameras (dashcams) in Ukraine (announced March 2022)"
    },
    {
      "id": "46bd38d3-dcc2-426a-a963-5db999a932ba",
      "text": "Established pattern of Russian disinformation and use of staged footage to smear Ukrainian forces (documented by human rights and media watchdogs)"
    },
    {
      "id": "327b4e57-b635-4aac-9dca-cb9b6ead7c78",
      "text": "Prior documented attacks on civilian evacuation convoys and cars during the 2022 invasion (widely reported, e.g., Reuters report of convoy strike)"
    },
    {
      "id": "728b488b-9ce7-49a7-9117-5c9e56b28899",
      "text": "TIME published its 2024 TIME100 list including Andriy Yermak in the 'Leaders' category."
    },
    {
      "id": "4ec2079c-6a43-421b-b2c1-7902900dd7b8",
      "text": "Pre‑existing reporting and public scrutiny about Yermak and his circle (including a previously reported corruption investigation involving his brother) created an underlying credibility gap."
    },
    {
      "id": "258a754a-0776-4907-951c-96c7047a7dc0",
      "text": "CDC/NCHS guidance (April 2020) on certifying and reporting COVID‑19 deaths that allowed listing COVID‑19 as an underlying cause when clinically suspected (including 'probable' cases)."
    },
    {
      "id": "819c7079-e076-42eb-a9ad-1828cd7d30dc",
      "text": "Repeated public downplaying of COVID‑19 severity by political leaders (e.g., President Trump saying the virus 'will go away' or 'disappear')."
    },
    {
      "id": "bb8aaf34-7901-4d6b-8e46-2d0728bcc4c0",
      "text": "Croatian officials acknowledge nationals fighting in Donbas"
    },
    {
      "id": "2a9cff89-c049-4c4a-9e5f-5522c1593479",
      "text": "Russian Defence Ministry summons Croatian military attaché alleging 'Croatian mercenaries' in Ukraine"
    },
    {
      "id": "bb15de34-8f26-42ed-b3ad-221235bff97a",
      "text": "Media coverage of the Azov battalion attracting foreign volunteers and far‑right fighters"
    },
    {
      "id": "ad3b954b-1091-49ce-b778-17d438f96d8f",
      "text": "Media reports describing Latvia's non-citizen policy as leaving thousands feeling stateless"
    },
    {
      "id": "5fdae4e2-c22f-4c43-86c0-be6b6fa3bc36",
      "text": "FDA authorizes Pfizer–BioNTech COVID-19 vaccine and releases EUA materials describing the product as a nucleoside-modified mRNA vaccine (technical briefings made public, Dec 2020)."
    },
    {
      "id": "c4d32fe9-81e1-448e-bcf7-fe8455ffad08",
      "text": "Animal and nanoparticle biodistribution studies showing lipid nanoparticle formulations can distribute beyond injection site (published/posted 2020–2021; e.g., peer-reviewed nanoparticle accumulation studies and regulator review summaries)."
    },
    {
      "id": "7c7e2884-2e16-43ba-ae99-f2e49fcb11b7",
      "text": "Peer-reviewed studies and preprints reporting trace detection of vaccine-derived mRNA fragments or spike protein components in human breast milk or blood samples after vaccination (published 2021)."
    },
    {
      "id": "bfd3bcf0-a950-4f4d-8860-33af03978c35",
      "text": "European Food Safety Authority (EFSA) establishes and publicizes a tolerable weekly intake (TWI) for aluminum from food"
    },
    {
      "id": "8d5df244-0e28-4a6a-ae4d-b90dadb3a8ca",
      "text": "2006 Meat Science study measuring aluminum content of baked meats wrapped in aluminum foil"
    },
    {
      "id": "7a46bd74-7779-40f5-aebe-ffa7f7ea18fb",
      "text": "UK Health Security Agency report: Unusually high Group A streptococcal (GAS/iGAS) and scarlet fever activity in 2022–23 season"
    },
    {
      "id": "f0a4a85f-cdfb-40b1-83d4-4fcfb707d3e6",
      "text": "Preclinical mouse studies showing mRNA‑LNP formulations strongly modulate innate immune responses (Ndeupen et al., iScience)"
    },
    {
      "id": "c6a908cf-12f1-459b-8f33-779927db7075",
      "text": "CDC Health Advisory: Early, elevated respiratory virus activity among children (co-circulation of RSV, influenza, SARS‑CoV‑2)"
    },
    {
      "id": "e3ea3796-f949-46b5-bb3f-3f68dd2bbcc5",
      "text": "2009 H1N1 (swine flu) pandemic required development of an additional vaccine"
    },
    {
      "id": "fbf353d8-ec47-42e3-9828-31180f164c59",
      "text": "Very low measured effectiveness of the 2014–2015 seasonal influenza vaccine"
    },
    {
      "id": "24b0b149-2595-42aa-9718-73681c300ead",
      "text": "U.S. congressional restrictions/amendments addressing assistance to units with alleged extremist links (e.g., Azov-related amendments)"
    },
    {
      "id": "35121ed1-891f-4881-b73c-9fdcbab4eb0a",
      "text": "Clashes and far‑right attempts to disrupt Kyiv Pride (police detained far‑right activists)"
    },
    {
      "id": "12d45049-de41-4341-b3a8-0b222ac2854c",
      "text": "Visible commemoration and monuments to Stepan Bandera in western Ukraine"
    },
    {
      "id": "5e6b38d1-6cbc-4588-aa7f-246cbe88558c",
      "text": "Passage and signing of Ukraine's 'decommunization' laws (removing Soviet-era names and symbols)"
    },
    {
      "id": "4fcaface-4768-44b8-ba40-d0f6bcd6b89b",
      "text": "Media reporting on the Azov Battalion's origins and extremist symbols"
    },
    {
      "id": "34ba6106-153e-4d6a-8628-0deba86545b5",
      "text": "Russian government announces regulatory approval and promotion of Sputnik V (first COVID-19 vaccine) internationally"
    },
    {
      "id": "910b861b-ebe9-4983-ae71-fcbdde128309",
      "text": "Contamination reports and a large temporary suspension of Moderna vaccine doses in Japan after foreign particles were found in vials."
    },
    {
      "id": "240c370a-3709-4e6b-802f-cf3545dc04e1",
      "text": "Media reports in 2022 documenting large, pre-planned insider sales of Moderna shares by CEO Stéphane Bancel during the pandemic period."
    },
    {
      "id": "77165de3-a791-40c3-8efd-b693f985ad63",
      "text": "IAEA mission and international attention at Zaporizhzhia Nuclear Power Plant (IAEA experts arrived and were stationed at ZNPP beginning 1 September 2022)"
    },
    {
      "id": "ea463e10-c39b-40b0-b336-1b6fdb29a1e4",
      "text": "Reporting of intimidation, abductions and coercion of Zaporizhzhia NPP staff under Russian occupation (including abduction of plant director)"
    },
    {
      "id": "c1cb00fe-3502-405b-a6ab-0d448cd92e7c",
      "text": "Changes to Ukrainian mobilization/reservation rules for critical infrastructure employees (Parliament adopted amendments on reserving/exempting conscripts, early November 2022)"
    },
    {
      "id": "b7328816-8b70-4137-8e00-c64d9f42f0e8",
      "text": "2019 systematic review summarizing clinical uses and adverse reactions of DMSO in humans (F1000Research)"
    },
    {
      "id": "ffa9efc7-e24b-496f-be05-08f89416a77d",
      "text": "FDA approval and long-standing labeling of RIMSO-50 (50% DMSO) for intravesical treatment of interstitial cystitis"
    },
    {
      "id": "138c4462-87cc-410f-bc8d-2ef119d15bd8",
      "text": "Investigative reporting on TikTok as a major vector for unverified/false medical cures in the Philippines (Rappler investigative feature)"
    },
    {
      "id": "8acb8e9a-b980-4aa2-b9d3-91ba041f4ce3",
      "text": "Russian authorities publicly pledged hundreds of billions of roubles (report: 680 billion roubles) of investment into Crimea up to 2020"
    },
    {
      "id": "45ebeebb-89cc-4ab7-b27b-7ec391464963",
      "text": "Russian government raised pensions and some salaries for Crimean residents after the 2014 annexation"
    },
    {
      "id": "b1052026-44b4-4684-9390-7d2478ae71ac",
      "text": "Israeli data reported reductions in Pfizer/BioNTech effectiveness against infection (Delta-era reports)"
    },
    {
      "id": "50d67449-92cd-4b37-ae42-abfaac7619f9",
      "text": "CDC changed surveillance (May 1, 2021) to track only breakthrough cases resulting in hospitalization or death"
    },
    {
      "id": "7175103d-b7f9-4570-85a2-673f72108e12",
      "text": "CDC report on Barnstable County (Provincetown) outbreak showing many infections in fully vaccinated persons"
    },
    {
      "id": "4e05695e-f1a7-4138-afcc-4cc21a904e57",
      "text": "Published and reported studies showing antibody levels wane within months after vaccination"
    },
    {
      "id": "da7b8fa8-4e45-431f-9e24-5baa47caaf33",
      "text": "IAEA expert mission visits and publishes a report on the Zaporizhzhia Nuclear Power Plant (IAEA mission and report published in September 2022)."
    },
    {
      "id": "5252bdae-fae8-404f-9f9f-19b6a7cc8fbf",
      "text": "Public announcements (July 2025) of deepening Ukraine–Westinghouse cooperation on nuclear fuel supply and plans for domestic fuel assembly capability in Ukraine."
    },
    {
      "id": "980fc750-a12c-4d0d-99a6-b8cf9f5e7d79",
      "text": "Russian delegation and state media publicly accused Ukraine of planning a 'dirty bomb' at the United Nations Security Council."
    },
    {
      "id": "4b3d21da-17a0-4671-9b0c-cb8e2f09c2df",
      "text": "Reports and imagery in March–April 2022 documenting Russian troops looting and disturbing equipment at the Chernobyl exclusion zone (including allegations of removal of radioactive monitoring equipment)."
    },
    {
      "id": "e968f688-f65e-4c2d-9614-30a30a4b1e67",
      "text": "Reporting on rapid, large Western arms shipments to Ukraine (e.g., New York Times: 'Arming Ukraine: 17,000 Anti‑Tank Weapons in 6 Days')."
    },
    {
      "id": "42c3ca8f-6b5c-4786-8e60-b5e841dd430e",
      "text": "Reuters reporting on Zelensky's 'dramatic call' to EU leaders that prompted an unprecedented collective EU decision to provide arms to Ukraine."
    },
    {
      "id": "bb1119af-cc0c-4cb5-9e2b-372c006a5615",
      "text": "Pandora Papers (ICIJ/OCCRP) reporting on Oct 3, 2021 linking Zelensky and close associates to offshore companies and property purchases."
    },
    {
      "id": "177cb85a-ce3e-4e46-9e38-95b1eb71a1c8",
      "text": "Politico profile 'The influencers behind the Ukrainian PR machine' quoted former US Ambassador Michael McFaul describing people around Zelensky as 'intermediaries and interlocutors'."
    },
    {
      "id": "b573fb16-d274-420d-b3dd-b10e9a2e04a0",
      "text": "CDC/NCHS issued guidance for certifying COVID-19 deaths clarifying how to report underlying versus contributing causes on death certificates (guidance and FAQs for certifiers)."
    },
    {
      "id": "e1d81b4f-65e3-4407-9c6a-93128d5a53da",
      "text": "Publication of large US seroprevalence analyses (blood-donor and CDC/JAMA analyses, mid-2021) showing a substantial proportion of Americans had SARS‑CoV‑2 antibodies by spring–early summer 2021."
    },
    {
      "id": "33356a44-4e77-4163-bc68-3eee1fe3a711",
      "text": "EU launches Support Hub for Internal Security and Border Management in Moldova"
    },
    {
      "id": "ae81d2ef-de6f-45f3-b800-4dfb5a7bdfdf",
      "text": "EU drugs agency warns the Ukraine war is shifting drug trafficking routes to Europe"
    },
    {
      "id": "1948e678-c2c8-4706-abc6-484e56225a6b",
      "text": "European Commission announces EU financing for purchase and delivery of weapons to Ukraine"
    },
    {
      "id": "bf531250-c7e0-42b2-a0b1-96e2fc7d2950",
      "text": "Interpol warns of a likely surge in illicit arms linked to the Ukraine conflict"
    },
    {
      "id": "27d48414-b3f8-489e-973a-ad9f6fe83ffe",
      "text": "Dutch Public Prosecution Service opens a criminal investigation into MH17 (Dutch-led criminal probe announced)"
    },
    {
      "id": "f5a2995f-193c-4bbe-b4c3-a69acddc8f22",
      "text": "Establishment of the Joint Investigation Team (JIT) for MH17 including Ukraine as a participating partner"
    },
    {
      "id": "be683cad-5ff8-4916-a8b5-778dbac3fc7b",
      "text": "Early reports of limited access and evidence handling at the MH17 crash site (security and access restrictions under rebel control)"
    },
    {
      "id": "a6f4a4f2-0e5e-455c-bcd4-baf8a3dd3724",
      "text": "NATO announced increased patrols and a stepped-up maritime presence in the Black Sea in 2018 (Standing NATO Maritime Groups' presence rose to ~120 days)."
    },
    {
      "id": "2ef830d9-9250-41ff-96cf-c32099ec79ee",
      "text": "Russian and pro‑Kremlin media and official statements framed NATO Black Sea exercises as 'provocative' and warned of 'consequences' (July–Nov 2018)."
    },
    {
      "id": "d0c5ca2b-230a-421a-8ff4-fa02093493c5",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels, prompting NATO emergency meetings and condemnation."
    },
    {
      "id": "39dd2991-e610-4df5-afbd-5799d0b4365b",
      "text": "CDC/NCHS guidance on certifying deaths due to COVID-19 (guidance documents published early in the pandemic, April 2020)."
    },
    {
      "id": "ea9db0fe-391d-4fc5-86d9-9c4488f46eda",
      "text": "Russia's appeal argued at the UK Supreme Court that Ukraine should be forced to pay the $3bn 'Yanukovych' bond"
    },
    {
      "id": "fd3c6f58-c889-4567-93c5-3a56a7ecabc2",
      "text": "Earlier High Court summary-judgment proceedings (2017) and legal filings showing shifting rulings and dense legal language"
    },
    {
      "id": "fa76eebd-850f-43a5-8fe7-0478ad1524c6",
      "text": "Reporting and features on mounting disposal problems for decommissioned turbine blades ('turbine graveyards' / landfill stockpiles)"
    },
    {
      "id": "cf19da29-e597-4a89-89b1-9ed74e22d7c4",
      "text": "Nantucket and other Cape Cod beaches closed while crews recovered fiberglass debris after the Vineyard Wind incident"
    },
    {
      "id": "71c8f9eb-2666-4961-a599-9dca493f7a00",
      "text": "Siemens Gamesa blade (72m, ~22 tonnes) detached and fell from a turbine at Odal Vind in Norway, prompting road closures and an investigation"
    },
    {
      "id": "a60933bf-eb6d-4640-95da-e65af0f74bbe",
      "text": "Peer‑reviewed literature documenting therapy‑related secondary cancers (eg. therapy‑related AML) after certain chemotherapy agents"
    },
    {
      "id": "12468af9-c3a4-4b64-a4a9-df596f578bf0",
      "text": "Historical reporting about nitrogen mustard research at Yale and the 1940s origins of some chemotherapy agents"
    },
    {
      "id": "1cd015e1-f4fb-4439-8be4-9db8a355be68",
      "text": "Ukrainian Interior Ministry public briefings reporting scale of Russian strikes (Deputy Interior Minister: ~30,000 strikes)"
    },
    {
      "id": "1535b092-2f4c-46b3-a6aa-0f47acfce530",
      "text": "Widespread Russian missile and drone barrages across Ukrainian cities in late March 2024"
    },
    {
      "id": "46ffce94-2f87-4972-920f-76a2e7524c41",
      "text": "Financial Times publishes analysis of Russian 'glide bombs' and upgrades to Soviet-era bombs"
    },
    {
      "id": "97e727e7-960e-4a2b-abf7-0793ea312243",
      "text": "2015 'decommunization' laws restricting public expression of Soviet symbols and related narratives"
    },
    {
      "id": "33ae4456-5a7c-4a22-b627-bd9f9c50773e",
      "text": "2018 reports of SBU actions, searches and prosecutions of pro‑Russian journalists/organizations"
    },
    {
      "id": "6e3be3bb-0b31-40c2-9c4c-86d033a52acc",
      "text": "2017 presidential decree blocking Russian social networks (VKontakte, Odnoklassniki)"
    },
    {
      "id": "2d41128c-909b-427b-8694-6449842d91e9",
      "text": "2019 constitutional amendment enshrining Ukraine’s EU and NATO course"
    },
    {
      "id": "c6ca0ef0-9643-4ec2-a666-d2c0c25f9594",
      "text": "2014 ban on multiple Russian TV channels for spreading 'war propaganda'"
    },
    {
      "id": "adddaf0b-1b58-49fc-8a33-15236b222e4b",
      "text": "U.S. government announcement (October 2014) of a funding 'pause' and review on certain gain-of-function (GOF) research involving influenza, MERS and SARS viruses (NOT-OD-15-011 and related guidance)."
    },
    {
      "id": "7548bb88-0c7f-4620-8757-ff3d81ed63d3",
      "text": "Existence and circulation of U.S. government-held coronavirus patents (example: US Patent No. 7,220,852 B1, 'Coronavirus isolated from humans', assigned to CDC, granted May 22, 2007)."
    },
    {
      "id": "83dfea00-70fb-48cd-aebd-04e1dc8f1702",
      "text": "NGO/OCCRP coverage linking major EU buyers (e.g., IKEA) to Ukrainian illegal wood supply chains"
    },
    {
      "id": "fbae0e6a-df1a-4f80-8faa-70c21e501e8b",
      "text": "President Petro Poroshenko vetoes bill on combating timber smuggling (Bill No. 5495)"
    },
    {
      "id": "1680d51b-a411-47ab-aa9f-fa25d53a8c28",
      "text": "Earthsight publishes 'Complicit in Corruption' investigative report on illegal logging in Ukraine"
    },
    {
      "id": "72f482e4-4c9b-400e-b22c-aec5e947cd6d",
      "text": "Regulatory/authorization context: CDC/ACIP and FDA discussions and authorization decisions for COVID-19 vaccination in young children (June 2022), which increased scrutiny of pediatric trial data."
    },
    {
      "id": "e9ff4476-2dee-4c1f-adf4-50aa9b1cca55",
      "text": "Trial data-cutoff and interim analysis date reported in KidCOVE safety results (data included through February 21, 2022)."
    },
    {
      "id": "e40c33f9-d7fa-4137-9f80-4c8229c27471",
      "text": "Publication of NEJM KidCOVE interim results for mRNA-1273 (Moderna) in children 6 months–5 years, reporting safety data including 8 serious adverse events in the 6–23 month mRNA-1273 group and none in the placebo group."
    },
    {
      "id": "d546313d-55a7-4c55-8727-d1442d5d9758",
      "text": "Sea Breeze multinational naval/air exercises hosted in Ukraine with US/NATO participation (July 2017)"
    },
    {
      "id": "63aaf013-8d50-412c-81a0-96ec60af11f7",
      "text": "NATO‑Ukraine Trust Funds and tangible NATO assistance (established 2015)"
    },
    {
      "id": "893ebd52-72c9-4155-ab25-1ebc612f8af1",
      "text": "2019 constitutional amendment enshrining EU and NATO as Ukraine's strategic course"
    },
    {
      "id": "923d78a6-0f1a-4090-b098-22127570f45d",
      "text": "Presence of foreign volunteers and fighters from Western countries in Donbas (documented 2014–2015)"
    },
    {
      "id": "1e20843e-0217-4c07-ac4d-1ebad8424cac",
      "text": "Japan suspension and recall of Moderna COVID-19 vaccine batches after reports of foreign particles"
    },
    {
      "id": "72f22cf7-f130-4e72-83aa-7a8643dc108b",
      "text": "Reports of circulating vaccine-derived poliovirus (cVDPV) outbreaks and WHO emergency committee statements"
    },
    {
      "id": "f45cbc4e-f37f-4dd2-9353-0c7aa03f7174",
      "text": "Precautionary removal/reduction of thimerosal (a mercury-based preservative) from childhood vaccines"
    },
    {
      "id": "3d6ce7a2-691b-4ee8-8fa2-4899f39986e3",
      "text": "Detection of porcine circovirus (PCV1) DNA in Rotarix rotavirus vaccine"
    },
    {
      "id": "06f007c0-e0de-480a-93d5-26f93d3f7cea",
      "text": "Publication of Nerem et al., PNAS: 'Climate-change–driven accelerated sea-level rise detected in the altimeter era'."
    },
    {
      "id": "038860ed-0644-4a78-a26c-ddfd467df0af",
      "text": "IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) released."
    },
    {
      "id": "97d91213-c2e1-4a9f-ad2e-c13b57d37aae",
      "text": "Publication of Alberto Boretti's analyses challenging mainstream estimates of sea-level acceleration."
    },
    {
      "id": "c958ba33-3ea5-4da4-980c-022f38695458",
      "text": "German measles-denier Stefan Lanka loses appeal after offering €100,000 prize over existence of measles virus; court rules in favour of claimant (widespread media coverage)."
    },
    {
      "id": "2f98b85a-d39e-438e-b66a-d505d2606979",
      "text": "Ukraine's chief military prosecutor Anatoliy Matios publicly stated that two to three servicemen were committing suicide every week in the Donbas ATO zone."
    },
    {
      "id": "eab631c3-da72-4370-a532-a31a42572838",
      "text": "The battle of Ilovaisk (August 2014) in which Ukrainian units were encircled and suffered heavy losses became widely reported and politicized."
    },
    {
      "id": "aba49bda-c2b0-4003-9209-e6890812b61e",
      "text": "EUvsDisinfo / DisinfoLab and other monitoring organisations catalogued repeated pro‑Kremlin narratives claiming Ukrainian forces were demoralized, corrupt or unwilling to fight (ongoing since 2014)."
    },
    {
      "id": "cbc67cf5-9419-43f3-9dc7-c44b2733ba3e",
      "text": "Peer‑reviewed OCTA studies report retinal/ocular microvascular changes after COVID-19 infection (example: Guemes‑Villahoz et al.)"
    },
    {
      "id": "db44defa-3c36-4859-b748-caa84afa1fcc",
      "text": "Longstanding scientific review concluding iridology lacks diagnostic validity published (Ernst systematic review)"
    },
    {
      "id": "67b8b108-aefe-44f0-897e-f627629cd681",
      "text": "1996 USAF planning paper 'Weather as a Force Multiplier: Owning the Weather in 2025' circulated publicly"
    },
    {
      "id": "6f39a42e-d0a7-4152-9012-db5be6eeadef",
      "text": "Publication of Shearer et al., 'Quantifying expert consensus against the existence of a secret, large‑scale atmospheric spraying program' (Environmental Research Letters)"
    },
    {
      "id": "6361e3fa-8bbc-4e57-b2ec-32d1afda5b97",
      "text": "Preexisting nanoparticle research showing some nanocarriers can accumulate in ovaries in animal models (Schädlich et al., 2012)"
    },
    {
      "id": "0d9787a5-5dce-46f2-b517-8a5b9b184f48",
      "text": "U.S. Department of State 2018 Trafficking in Persons Report — Poland country narrative noting increased vulnerability of Ukrainian migrants to labor trafficking"
    },
    {
      "id": "39ef7077-d79e-4496-bc0b-3c003a80e3cb",
      "text": "Financial Times coverage on Poland’s heavy reliance on cheap Ukrainian labour and the precarious conditions many workers faced"
    },
    {
      "id": "289de12e-9f31-4ce0-8bac-9174a0700012",
      "text": "June 26, 2016 — Attack on a Ukrainian religious procession in Przemyśl by local nationalist groups (documented by regional and international press)"
    },
    {
      "id": "c7fdf878-5fac-41b8-b934-f21635dbda20",
      "text": "Pfizer–BioNTech received Emergency Use Authorisation while continuing to follow trial participants for safety/efficacy"
    },
    {
      "id": "7b4a72aa-0324-4d1b-9335-9805b28f7966",
      "text": "UK regulator (MHRA) issued guidance after two reports of anaphylaxis following Pfizer–BioNTech vaccinations"
    },
    {
      "id": "037ebe25-c4a1-4188-b565-8419ca9a9ad9",
      "text": "Multiple reports in Norway of deaths among frail, elderly people after receiving the Pfizer–BioNTech vaccine"
    },
    {
      "id": "61fff634-9e30-41df-a329-fb86fad4bc7c",
      "text": "AstraZeneca paused its global COVID‑19 vaccine trials after a participant developed a serious neurological illness"
    },
    {
      "id": "c55ee29e-3bab-4ba1-bbe7-ca82e627ca35",
      "text": "NOAA technical report and public release of regional sea-level rise scenarios and tools (NOAA NOS CO-OPS Technical Report)"
    },
    {
      "id": "995c7333-e54f-48cb-a82e-96fb67dc3a32",
      "text": "Availability and public access to local tide-gauge records showing regional variability (example: Stockholm tide gauge, PSMSL station page)"
    },
    {
      "id": "fe4ddb1b-a94f-4e6f-ad4e-e6707844c3ef",
      "text": "Allegations and media coverage of NOAA data-handling controversy (John Bates / 'NOAA whistleblower' coverage)"
    },
    {
      "id": "1bba37c6-dcbf-4c61-b3cf-bad3ef1aec62",
      "text": "OSCE Permanent Council decision to deploy the Special Monitoring Mission to Ukraine (SMM) following the outbreak of unrest in eastern Ukraine."
    },
    {
      "id": "adfe034a-1d47-4b01-a3b4-3ee50f4c4d29",
      "text": "Self‑proclaimed Donetsk and Luhansk 'people's republics' declared independence after May 2014 referendums and issued international statements."
    },
    {
      "id": "10340ecb-3315-4a89-9a44-9c2bb1cf8484",
      "text": "Minsk II talks (Package of Measures) signed in Minsk with representatives of the self‑proclaimed Donetsk and Luhansk People’s Republics participating as signatories."
    },
    {
      "id": "75cfb33e-0352-48ea-9780-f5bdda5e717a",
      "text": "United Nations Security Council held emergency meetings and public briefings on the Ukraine/Crimea crisis (e.g., press briefing and meeting coverage in February–April 2014)."
    },
    {
      "id": "d5a5bf2a-04e3-4d0e-af38-0a7519015383",
      "text": "European Union adopts €1.8 billion macro‑financial assistance (MFA) for Ukraine"
    },
    {
      "id": "0acf27d2-2674-482f-90c5-bde37a973fb6",
      "text": "EU visa‑free travel for Ukrainian citizens enters into force"
    },
    {
      "id": "f9c8fbc1-67a7-4704-a2e1-e99fec527735",
      "text": "Publication of Microsoft patent WO/2020/060606 (cryptocurrency system using body activity data)"
    },
    {
      "id": "97c3bcc5-ad71-4bcd-8a13-c1f3a049f14c",
      "text": "Coverage of Gates/Foundation funding for genetically modified mosquito research (Oxitec grant reported 2018)"
    },
    {
      "id": "c9333206-b8e8-4ce9-b191-0ffd93b8118f",
      "text": "Ukraine sharply increased 'reverse flow' imports from EU in 2015"
    },
    {
      "id": "39b41e96-06be-47c3-af2e-77866a296fea",
      "text": "January 2009 Russia–Ukraine gas cut-offs"
    },
    {
      "id": "6d170253-a0d2-4d39-9138-c5d4a72fde42",
      "text": "Merck announces it will discontinue development of two COVID-19 vaccine candidates (V590 and V591)"
    },
    {
      "id": "92151bb0-7996-4fac-9dff-54ae5c2b8076",
      "text": "1976 U.S. swine flu vaccination program linked to increased Guillain–Barré syndrome reports"
    },
    {
      "id": "0c82cd62-35e8-4be1-a241-0e3314700361",
      "text": "Pandemrix (2009 H1N1 vaccine) association with increased narcolepsy reports in some countries"
    },
    {
      "id": "4409d09e-8edd-4492-9963-1938986c6ac9",
      "text": "2014–2015 influenza vaccine effectiveness decline due to antigenic drift"
    },
    {
      "id": "794b08a1-59b7-4f7b-9499-7fbae5270e8a",
      "text": "European Medicines Agency (EMA) announces and uses 'rolling review' procedures for COVID-19 vaccines"
    },
    {
      "id": "378fa6ea-1c37-4b64-99cc-af69758c9482",
      "text": "UK Medicines and Healthcare products Regulatory Agency (MHRA) grants temporary (emergency) authorization for the Pfizer–BioNTech vaccine under Regulation 174"
    },
    {
      "id": "dabcf4bf-2b03-4def-901a-62f22fac965d",
      "text": "Publication of the Phase 3 trial results in NEJM showing vaccine efficacy against symptomatic COVID-19 (Polack et al.)"
    },
    {
      "id": "aebd57ab-6dd7-4b0d-a553-681a4786cb36",
      "text": "Reporting on longstanding U.S. transfers of anti-armor and other defensive equipment to Ukraine (e.g., Politico coverage of U.S.-supplied weapons to Ukraine since 2018)"
    },
    {
      "id": "018d1ede-175c-4fdf-8470-711815c56a6f",
      "text": "U.S. intelligence warnings and press reporting that Russia was planning a large-scale offensive (wide coverage, Dec 3, 2021)"
    },
    {
      "id": "87364eda-63bf-49ce-b81b-f809767d1673",
      "text": "Bipartisan Senate delegation visited Kyiv and met President Zelensky (Portman, Shaheen, Murphy)"
    },
    {
      "id": "608fbe47-ff8c-4b68-b402-04fc938c52f5",
      "text": "Russian navy holds Black Sea drills near Crimea amid rising tensions (April 2021)."
    },
    {
      "id": "1903542d-2ade-4a19-9eb6-1de53f3b5652",
      "text": "Russia publishes draft security proposals demanding NATO guarantees (including no eastward expansion)."
    },
    {
      "id": "9087f738-7475-44fa-85d8-57cc7e9ae9a4",
      "text": "Deployment of advanced S-400 surface-to-air missile systems and other air defenses to Crimea (reported in 2019 and earlier)."
    },
    {
      "id": "4f751d6c-aef6-4e8f-a7d8-9fe179abe261",
      "text": "Large-scale Russian troop buildup on and near the Ukrainian border reported in January 2022."
    },
    {
      "id": "83361a24-6725-4af5-bba8-d7dd76c82c5b",
      "text": "Vladimir Putin publishes essay 'On the Historical Unity of Russians and Ukrainians'."
    },
    {
      "id": "fb00d190-2fd6-4778-863e-7fc44c538a44",
      "text": "Czech Statistical Office published official vital statistics showing a marked decline in live births (drop in number of births) between 2021 and 2022/2023."
    },
    {
      "id": "3910d908-f09d-460f-8007-dcc095faf253",
      "text": "Peer-reviewed modelling paper published examining how COVID-19 vaccination timing and behavior could affect total fertility rate in Czechia (discusses scenarios like avoiding conception around vaccination)."
    },
    {
      "id": "78373792-dfb0-44fe-bd62-df4b0c3a7776",
      "text": "Public reporting and policy changes earlier in 2020 showing NATO/European military exercises were scaled back or adjusted because of COVID‑19 (concern about cross‑border transmission)."
    },
    {
      "id": "7c73d6b8-d639-4da0-9d65-d9d84007a99d",
      "text": "Official reporting that Ukrainian units (e.g., the 80th Air Assault Brigade) were participating in Saber Junction / multinational exercises in Germany."
    },
    {
      "id": "7a13e2e1-73ef-46cd-af16-09ed228a8441",
      "text": "Peer‑reviewed reports from Israel (NEJM and related surveillance studies, 2021–2022) documenting rare myocarditis cases after mRNA vaccination in adolescents and young men (e.g., NEJM letter on Israeli adolescents published Nov. 10, 2022)"
    },
    {
      "id": "e00c9545-9529-4da3-b581-5296167763f0",
      "text": "CDC/ACIP Sept. 12, 2023 presentation slides on updated COVID-19 vaccines that included projections of hospitalizations, deaths prevented in adolescents and estimates of vaccine reactogenicity (Grade 3/4)"
    },
    {
      "id": "084941a3-0dfc-476c-b4d7-5fe00f7d1222",
      "text": "IEA special report 'The Role of Critical Minerals in Clean Energy Transitions' highlighting large and growing demand for minerals (copper, rare earths, etc.) used in wind turbines and other clean technologies."
    },
    {
      "id": "fc9424cb-6ac1-4c16-a4cb-6b301d640d6c",
      "text": "Reuters reporting (September 2023) on U.S. offshore wind projects facing major cost increases, cancellations and financial write‑downs amid inflation, supply‑chain problems and policy changes."
    },
    {
      "id": "cb886c61-9b24-495c-af33-773416babf42",
      "text": "C&EN feature (August 2022) documenting that many retired wind turbine blades have been landfilled and describing the technical and economic challenges of blade recycling."
    },
    {
      "id": "e59c9a36-25da-4583-b301-8b536a7a6a5d",
      "text": "Arnett et al. review and field studies (circa 2008) documenting consistent patterns of bat fatalities at wind energy facilities and identifying operational conditions that drive bat collisions."
    },
    {
      "id": "fa16f634-12a6-4b65-ba49-51dbe1ac2549",
      "text": "Loss, Will & Marra (Biological Conservation, Dec 2013) published widely‑cited estimates of bird collision mortality at U.S. wind facilities (commonly quoted range ~140,000–328,000 birds/year)."
    },
    {
      "id": "c1389a43-915a-4c33-a0a1-07e3063944c1",
      "text": "Israel Ministry of Health presentation on booster-dose effectiveness and evidence of waning two‑dose vaccine protection."
    },
    {
      "id": "aa6572aa-aad1-495f-9010-60dea2946df0",
      "text": "Ukrainian authorities and security services announced investigations and potential legal action against Antonov company officials over failures linked to the Mriya's destruction."
    },
    {
      "id": "5119233f-1bde-4d13-a8de-e2dc2a367cfb",
      "text": "Hostomel (Antonov) airport was the scene of capture, heavy fighting and later reported withdrawal/retreat of Russian forces during March 2022."
    },
    {
      "id": "dac912ef-7f2f-4e85-834c-b0b208f705bf",
      "text": "Ukraine suspends consular services for military‑age men living abroad"
    },
    {
      "id": "32a5e08d-a068-4ab9-83cf-7712a622f533",
      "text": "President Zelensky signs a major overhaul of Ukraine's mobilization law"
    },
    {
      "id": "9dd8dd34-cc32-45cf-a8ab-06f7eeba66ca",
      "text": "BBC World Service 'BBC Eye' investigation: nearly 20,000 men fled Ukraine to avoid conscription (investigation published Aug 2023)"
    },
    {
      "id": "666548b4-4b73-47de-bd9c-9d5669fe9239",
      "text": "NATO‑Ukraine Council (defence ministers) meets and publicly reiterates stepped-up support"
    },
    {
      "id": "0216cbda-8ba0-4a88-b35b-782f37194994",
      "text": "The UK Coronavirus Act 2020 received Royal Assent, creating expanded emergency powers for government pandemic response."
    },
    {
      "id": "731bb2e7-f349-4150-8d45-c7a663dc4e1a",
      "text": "The White House issued a proclamation declaring a national emergency concerning COVID-19."
    },
    {
      "id": "239443a4-d8d6-47c5-ac36-4a98580c9e41",
      "text": "President Trump and other US officials publicly expressed unusually optimistic timelines for a vaccine, saying a vaccine might be available in a few months."
    },
    {
      "id": "654f84f5-583e-4aa7-be94-d3c0d95c5318",
      "text": "Moderna announced the first participant was dosed in its NIH-led Phase 1 trial of mRNA-1273."
    },
    {
      "id": "e0001ab0-ea1d-4131-945c-8d9a05240394",
      "text": "Florida Department of Health press release stating VAERS reports from Florida increased 1,700% after COVID-19 vaccine rollout"
    },
    {
      "id": "dcd3d9cc-a3f7-4de1-9f89-e1aa2e2c4da1",
      "text": "Florida Surgeon General Joseph Ladapo issued mRNA COVID-19 vaccine guidance recommending against mRNA vaccines for males aged 18–39"
    },
    {
      "id": "d8fd4d90-e8e8-4f0a-b95c-466cadf04a04",
      "text": "Record-high public support for marijuana legalization reported by Gallup (64% in favor)."
    },
    {
      "id": "e0253ed0-24e0-4426-b0b9-9bfb63ca5111",
      "text": "Publication of David Nutt et al.'s Lancet paper ranking drug harms, which placed alcohol high and cannabis low."
    },
    {
      "id": "8da00518-0a95-4f45-b6bc-4d2e0e85d560",
      "text": "Sacking of Professor David Nutt from the UK Advisory Council on the Misuse of Drugs after public comments comparing alcohol's harms to those of illegal drugs."
    },
    {
      "id": "315d889f-8b63-4b74-9306-370992b51965",
      "text": "Ukraine's parliament passed 'decommunization' laws criminalizing propaganda of totalitarian symbols and prompting removal/renaming of Soviet‑era monuments and toponyms."
    },
    {
      "id": "82514ec5-9684-4e7e-b8c3-3f9261e8c203",
      "text": "International outlets reported that nationalist and far‑right groups had gained influence and were under scrutiny in post‑Maidan Ukraine."
    },
    {
      "id": "9bb85cec-e218-42dc-8d26-2028bdd2d6c6",
      "text": "Right Sector, an umbrella of ultranationalist groups, played a prominent and public role during the Euromaidan protests."
    },
    {
      "id": "e661d56d-02cf-49ac-9ae4-5dfd32f12de2",
      "text": "Svoboda party members held ministerial posts in Ukraine's 2014 interim government after Yanukovych fled."
    },
    {
      "id": "26f38863-34a4-4baa-a6bb-528432254308",
      "text": "Ukraine's Cabinet of Ministers increased administrative fines for quarantine breaches via Resolution No.255."
    },
    {
      "id": "f35aab89-abde-48df-90da-f4bc0871106e",
      "text": "Legal summaries and guidance published in April 2020 explaining strengthened quarantine rules and penalties in Ukraine (legal/firm briefings and PDF guides)."
    },
    {
      "id": "3a81ca66-f500-4e6b-92a7-0400526c47e9",
      "text": "Publication of preliminary safety data on mRNA COVID‑19 vaccines in pregnancy (v‑safe/VAERS analyses)"
    },
    {
      "id": "ee46c6d3-5649-405a-9bfd-474650c7f68b",
      "text": "Verkhovna Rada adopts 'decommunization' laws banning Soviet symbols and renaming places (spring 2015)"
    },
    {
      "id": "89df43ba-e28b-4105-adea-e98ec69e07c8",
      "text": "Ukraine adopts the red poppy and promotes May 8 remembrance practices (media coverage, May 2015)"
    },
    {
      "id": "ec19c603-ba0a-4451-82ce-b8ac2bcff24e",
      "text": "Ukraine criminalises public promotion/use of the Russian/St. George ribbon (amendment creating administrative offence), reinforcing break with Soviet/Russian WWII symbolism"
    },
    {
      "id": "b0ef9cfb-447e-4a08-8801-cab9d103a008",
      "text": "Wave of Lenin statue topplings across Ukraine during 2014 'Leninfall'"
    },
    {
      "id": "62bdd436-24bc-45ee-ac5b-deaa1f9d4b13",
      "text": "Passage of the Law 'On Ensuring the Rights and Freedoms of Internally Displaced Persons' (IDP law)"
    },
    {
      "id": "78f3ed54-d775-4796-b00d-1a7d215338d1",
      "text": "Cabinet of Ministers Resolution No. 302 (25 March 2015) on passport issuance and registration procedures"
    },
    {
      "id": "c23caf4e-5a67-448f-a6e9-5b10ed0837a6",
      "text": "Law No. 1382‑IV 'On freedom of movement and free choice of place of residence' (adopted)"
    },
    {
      "id": "645a89bf-77d9-4f28-b0df-fbdc93a6b911",
      "text": "Abolition of the Soviet 'propiska' system and lingering public confusion about registration (historical/legal context)"
    },
    {
      "id": "48555f17-882d-48b9-a03a-0c1a3711c0e6",
      "text": "Publication of large 2022 pan‑cancer mycobiome analyses showing tumor‑associated fungal signatures across multiple cancer types (pan‑cancer mycobiome studies)."
    },
    {
      "id": "3226a3e3-1e00-4386-bb16-3d567fba77f9",
      "text": "Public debate and symbolic acts over Odesa's Russian imperial monuments (removal of Catherine II statue)"
    },
    {
      "id": "2b0b5fe1-bfad-4c0e-b5e0-76bf9af80f36",
      "text": "NATO Wales Summit pledges concrete support to Ukraine (Readiness Action Plan)"
    },
    {
      "id": "4ae84f5e-59ea-487c-b407-5bfbcfe9d271",
      "text": "US announces $53 million in non-lethal military assistance to Ukraine"
    },
    {
      "id": "e86761d9-fa89-4480-bf36-115dfe98c6b0",
      "text": "John McCain visits Maidan and publicly supports protesters"
    },
    {
      "id": "7954bc6b-c492-453c-9796-f6c5a5dfe4d4",
      "text": "Japan suspends use of some Moderna COVID-19 vaccine batches amid contamination concerns (reported by Reuters)."
    },
    {
      "id": "a4353cb2-f322-4a31-b4d3-6ac1693c1d88",
      "text": "Office for National Statistics (ONS) public 'Deaths by vaccination status, England' dataset and periodic releases (dataset page with major updates accessible 25 August 2023)."
    },
    {
      "id": "38d6788e-799f-4d5d-8d97-1d8b7c99665b",
      "text": "UKHSA 'Vaccine surveillance report' (Week 4) published figures showing substantially reduced or 'negative' vaccine effectiveness against symptomatic Omicron infection in some analyses."
    },
    {
      "id": "ff67ba3b-46c2-42ff-be54-e2eb64f3b42b",
      "text": "Publication of case series and reports documenting short-term inflammatory musculoskeletal events after COVID-19 vaccination (e.g., 'Spectrum of short-term inflammatory musculoskeletal manifestations after COVID-19 vaccine administration: a report of 66 cases')."
    },
    {
      "id": "fc9b5ba0-b2c6-4fd3-bd70-03456c965cea",
      "text": "Historic precedent of drownings at the Hungary–Serbia/Tisza border route and UNHCR public concern (reported in 2016)."
    },
    {
      "id": "f1dfc5e7-8a60-496c-9552-9ad86c0f72b0",
      "text": "Recent regional examples of formal memorials for migrants who drowned in border rivers (AP coverage of a Drina River memorial in Bosnia)."
    },
    {
      "id": "5ee678f8-8298-42b2-8c29-48e1c8f13db1",
      "text": "Local reports in early May 2024 that multiple bodies were recovered from the Tisza River (State Border Guard Service reported three more drowned people)."
    },
    {
      "id": "05a00692-badd-43b7-97ac-20a484aa8c2c",
      "text": "Launch/inauguration of Hulhumalé Phase 3 land-reclamation works (government announcement, inaugurated September 22, 2023)"
    },
    {
      "id": "53b8ba4f-0b4e-464a-b32e-a2a399aa2f36",
      "text": "Publication of Duvat 2019 review 'A global assessment of atoll island planform changes over the past decades' reporting that 88.6% of studied atoll islands were stable or increased in area"
    },
    {
      "id": "d7a3fe53-881e-4eff-bd66-7599825f5bfa",
      "text": "MIT Self-Assembly Lab / National Geographic-supported 'Growing Islands' projects in the Maldives (projects and demonstrations, including 2022 fieldwork)"
    },
    {
      "id": "bfab812f-f35f-4434-b8c9-931f6a095d07",
      "text": "CDC public guidance for health departments/laboratories on reporting breakthrough cases which states: for cases with a known RT-PCR cycle threshold (Ct) value, submit only specimens with Ct value ≤28 to CDC for sequencing."
    },
    {
      "id": "99eab8ce-9692-45b3-8ef3-e1c6be42f203",
      "text": "Mainstream media coverage and criticism of the CDC decision to limit active investigation and public reporting of breakthrough infections to hospitalized/fatal cases (coverage highlighting concerns this could 'hide' milder breakthroughs)."
    },
    {
      "id": "bf43c495-6334-4bc0-9698-1441bfc6e8a2",
      "text": "Documented U.S. support for Ukrainian civil society and opposition groups via NGOs and grants (e.g., National Endowment for Democracy activities in Ukraine around 2013–2014)."
    },
    {
      "id": "f0bbdab9-ccc4-4a48-8e87-69328f9d2cec",
      "text": "Victoria Nuland public remark that the U.S. has invested about $5 billion in Ukraine since 1991."
    },
    {
      "id": "bac2779e-65a3-4bb1-a15c-5896e1b277ea",
      "text": "Removal of President Viktor Yanukovych after mass Euromaidan protests; Yanukovych flees Kyiv and parliament votes to remove him."
    },
    {
      "id": "2bd643ab-04dd-42d8-8b9c-f459af0c1d6c",
      "text": "IPCC Fifth Assessment Report (AR5) notes a reduced rate of surface warming for 1998–2012 (the so‑called 'global warming hiatus')"
    },
    {
      "id": "b2ba8839-0f81-45f8-8999-b2c1360ff592",
      "text": "IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) published and approved"
    },
    {
      "id": "7118efe7-4a74-4b7d-9603-c9a06dec22b7",
      "text": "2019–20 Australian 'Black Summer' bushfires (widespread, high‑impact fires across eastern and southern Australia)"
    },
    {
      "id": "56e832cf-c75e-4b19-b939-958843af5e48",
      "text": "Major polar vortex breakdown and cold snap across North America and parts of Europe"
    },
    {
      "id": "d076e1e4-cb01-4830-b778-89ad0d5d2d0f",
      "text": "Dublin Declaration on Maternal Health Care issued (pro‑life clinicians declare 'abortion is not medically necessary')"
    },
    {
      "id": "6086d3ec-6e14-4e5a-97e5-abcc68acd1ba",
      "text": "Ohio 'heartbeat' (Human Rights and Heartbeat Protection) bill signed into law"
    },
    {
      "id": "b2db9a74-3810-496a-8336-83ee8026fd39",
      "text": "Alabama Human Life Protection Act signed into law (near‑total abortion ban)"
    },
    {
      "id": "c0543dc9-93ec-4472-b679-5a93806f0f77",
      "text": "Prior high‑profile 'map without Crimea' incidents (e.g., Human Rights Watch map controversy) primed public sensitivity to any depiction of Ukraine that appears to exclude Crimea."
    },
    {
      "id": "b0ad41ab-0fbe-421f-b0f8-b5820cfab9cb",
      "text": "CDC MMWR report on a rapid COVID-19 outbreak in an Ohio Amish community (May 2020) showing very high attack rates after social gatherings."
    },
    {
      "id": "c21686c5-492d-47ed-a7dc-74dbabe21e49",
      "text": "Local reporting claimed up to 90% of Lancaster County 'Plain' households had been infected, suggesting community-level 'herd immunity'."
    },
    {
      "id": "8509f258-1a84-4c3e-881d-8e34fe030827",
      "text": "Reporting of foreign volunteers and sympathizers (including Europeans) joining separatists in Donbas (2014)"
    },
    {
      "id": "4c13fa25-8bb8-4651-b117-8c16579c165d",
      "text": "Large government‑sanctioned pro‑Crimea/Putin demonstrations in Moscow (March 2014)"
    },
    {
      "id": "4fa6e076-c198-48ad-ac22-9996dcaaaac6",
      "text": "Nationalisation of PrivatBank after capital shortfall (18 December 2016)"
    },
    {
      "id": "bd84f781-f0b2-443a-86c1-1de0da98affc",
      "text": "Outbreak of large‑scale fighting in Donbas and its measured economic impact (2014–2015)"
    },
    {
      "id": "2e6a3ac6-876f-4bdb-b5d6-ec1962d7cac9",
      "text": "Sharp hryvnia devaluation and currency crisis (February 2014)"
    },
    {
      "id": "aa4c4361-bd70-4c16-8b8d-a8d8e16e8564",
      "text": "Background: Ukraine's International Legion and widespread coverage of thousands of foreign volunteers (Feb 2022)"
    },
    {
      "id": "93b9d616-36b6-407b-ad9e-1fb9962ff572",
      "text": "NCHS/CDC published official guidance on how to certify deaths involving COVID-19 (guidance on listing COVID-19 on death certificates)."
    },
    {
      "id": "083b147a-37da-49e9-b89b-80b1206f92f3",
      "text": "Official explanations and reporting about provisional mortality data and reporting lags in the NCHS/CDC mortality system."
    },
    {
      "id": "a9730833-1cbc-41a7-981f-380069816fe2",
      "text": "Clinical trial registration for high‑dose intravenous vitamin C in COVID-19 (NCT04264533) announced on ClinicalTrials.gov"
    },
    {
      "id": "77fe070d-3c75-456e-b8eb-3b2323bec095",
      "text": "Ukraine reported hundreds of its citizens were trapped in Gaza and said it was working to evacuate them (public statements, mid‑October 2023)."
    },
    {
      "id": "45bf98f3-dfe7-4c7b-805c-f5a4309f585f",
      "text": "Large, ongoing presence of Ukrainian refugees in Romania (official UNHCR and government figures published in 2022–early 2023)."
    },
    {
      "id": "d77df6cb-bf52-4891-bfcb-2c327a3ea055",
      "text": "Brazil President Jair Bolsonaro publicly downplayed COVID‑19, calling it 'a little cold' and criticizing lockdowns in a March 24, 2020 address."
    },
    {
      "id": "9cbaf22f-5db4-42dd-8dc7-b3aee930ef0d",
      "text": "WHO statement (and tweet) on January 14, 2020 saying preliminary investigations found no clear evidence of human‑to‑human transmission."
    },
    {
      "id": "68f4113b-fa65-47cd-b9c9-00630b24aaf1",
      "text": "Russian missile strike on Dnipro (widely reported Nov 21, 2024)"
    },
    {
      "id": "7188e349-5551-48b8-a82d-ae8ce0e1608b",
      "text": "Rapid intensification and an unusual track of Tropical Storm Milton as documented by official National Hurricane Center advisories in early October 2024."
    },
    {
      "id": "1b4f37ec-096c-4542-a2b5-2e6328a8fcb1",
      "text": "Hurricane Helene (late September 2024) severely impacted Florida days earlier, prompting online discussion about consecutive destructive storms."
    },
    {
      "id": "234107a1-2d51-40dd-86d6-b8887f339749",
      "text": "WHO fact sheet reporting ~1.5 billion people globally infected with soil‑transmitted helminths"
    },
    {
      "id": "a415d643-ac0e-4216-a102-a2f12264e028",
      "text": "FDA public warning about 'Miracle Mineral Solution' (MMS) marketed as a cure-all including for parasites"
    },
    {
      "id": "f4e17a2a-d83f-42d0-9c98-c8b76a75a3e3",
      "text": "Sharp surge in European wholesale gas and power prices, raising fears of winter supply shortages"
    },
    {
      "id": "2e545ac9-0408-49ef-acbd-eebc010bc0f5",
      "text": "Completion of Nord Stream 2 pipeline construction reported in early September 2021"
    },
    {
      "id": "28e872e1-54c2-4629-adba-821071b37393",
      "text": "Signing of the 2019 Russia–Ukraine gas transit agreement (dec. 30, 2019) defining transit volumes through Ukraine for 2020–24"
    },
    {
      "id": "1474e2b8-6074-4173-a8bc-660920f8d84c",
      "text": "The Crimean parliament, while under occupation, appointed pro‑Russian politician Sergey Aksyonov as prime minister."
    },
    {
      "id": "c0708339-d06a-4d2f-9640-e90ba5065484",
      "text": "Masked, unmarked armed men (the so-called 'little green men') seized the Crimean parliament building in Simferopol, occupying the legislature and preventing normal sessions."
    },
    {
      "id": "054735a2-d878-49d2-a85a-78ab7f20b354",
      "text": "Ukraine announces a nearly $40 million embezzlement scheme tied to mortar-shell procurement (SBU investigation)"
    },
    {
      "id": "161af1f3-b533-4865-8e8b-ce4e87edee12",
      "text": "Rising conservative/public skepticism about continued U.S. assistance to Ukraine documented in 2023 media coverage"
    },
    {
      "id": "1b943fa2-7492-4be5-baba-7b276458d36c",
      "text": "Rapid growth of labor migration from Ukraine to Poland (Poland issued ~1.8 million employers' declarations in 2017; analysis 2018)"
    },
    {
      "id": "57f00d8f-79ab-4e3f-8432-c5cd5b080a3a",
      "text": "Large-scale internal displacement and civilian displacement from Donbas (UNHCR reports, 2015)"
    },
    {
      "id": "05ea2b41-7f2c-4b98-9986-f0043518081a",
      "text": "EU Schengen visa‑free regime for Ukrainian citizens comes into force"
    },
    {
      "id": "a6bb481b-95ed-4927-b068-02899e5acb8e",
      "text": "U.S. decision and delivery timeline in spring 2018 to supply Javelin anti‑tank systems to Ukraine"
    },
    {
      "id": "82f8df41-62a4-4c60-b1e2-3bc51397ef77",
      "text": "Kurt Volker’s visit to Ukraine (mid‑May 2018) and on‑the‑ground briefings about Donbas/Crimea"
    },
    {
      "id": "42f69999-16fd-4192-8a90-6f4a9bddb2cc",
      "text": "Uman’s profile as a major Hasidic pilgrimage site and reports of thousands of visitors in March 2022"
    },
    {
      "id": "54fa120c-bf41-4acb-b703-c002ce29bfab",
      "text": "Putin's February 24, 2022 justification for the invasion invoking 'demilitarisation' and 'denazification' of Ukraine"
    },
    {
      "id": "9dc120af-a0aa-4d5e-aef0-3f64615ce66e",
      "text": "HAARP published a transmission notice / research campaign for May 8–10, 2024 (ionospheric heating experiments)"
    },
    {
      "id": "857d79b5-d04d-4378-b6e2-21108e81bec5",
      "text": "NOAA Space Weather Prediction Center issued a Severe (G4) Geomagnetic Storm Watch"
    },
    {
      "id": "c024f0d5-d740-4ee7-b9e9-22987e13f9d0",
      "text": "Registration of the Pfizer/BioNTech BNT162b2 Phase 1/2/3 clinical trial on ClinicalTrials.gov (NCT04368728), first posted in April 2020, with trial documents showing pregnancy as an exclusion criterion."
    },
    {
      "id": "ddf9fd9b-4935-4514-8aa2-b4fba931d670",
      "text": "2014 Kenya tetanus vaccine sterilization allegations and subsequent WHO/UNICEF denial (HCG claim) — high‑profile historical sterilization scare."
    },
    {
      "id": "396eedea-a0df-4b80-92de-3d9452c164c8",
      "text": "NOAA/NCEI (Karl et al.) 2015 paper revising ocean temperature bias and updating the global surface-temperature record"
    },
    {
      "id": "3fca0deb-dcca-4917-bbb1-c4081d0a8912",
      "text": "Prior high-profile contacts between Turkish officials and Crimean Tatar leaders (e.g., Turkish FM Mevlüt Çavuşoğlu met Mustafa Dzhemilev, Jan 26, 2016)"
    },
    {
      "id": "eed0a2af-58e6-4bfd-b251-a9afdf857973",
      "text": "Public biographical records show Nalyvaychenko served at the Ukrainian Embassy in the United States (Consular service/Consul in Washington, D.C., 2001–2003)."
    },
    {
      "id": "b95db0c1-f08e-47e0-844c-fdcad8e31dd5",
      "text": "Press coverage in Feb 2014 publicised close cooperation between Ukraine’s SBU and U.S. intelligence partners (coverage emphasising U.S.–SBU ties)."
    },
    {
      "id": "a6bd6b25-ba3d-4850-b5c2-8e0287cff121",
      "text": "European Commission publishes staff analysis showing rising short‑term visa refusal rates for Ukrainian applicants (2013→2014)"
    },
    {
      "id": "4aca75c3-c165-4f17-843f-046db2679cc6",
      "text": "EU adopts Sixth Progress Report on Ukraine's Visa Liberalisation Action Plan (Commission decision communicated in December 2015)"
    },
    {
      "id": "8f7c65bc-aaa5-4afd-afb0-4e3edfa22f58",
      "text": "Several Schengen states reintroduce internal border controls during the 2015 migration crisis"
    },
    {
      "id": "4af8450d-2bb0-437b-8014-0cd241e50d77",
      "text": "EU decision to prolong economic sanctions on Russia (June 2019)"
    },
    {
      "id": "d73463a1-5438-4300-ac9d-930dadca166a",
      "text": "Kerch Strait naval confrontation — Russia seizes Ukrainian ships"
    },
    {
      "id": "0534fdf6-a82b-41fc-b06d-21e023f1ea24",
      "text": "Skripal poisoning and mass expulsions of Russian diplomats"
    },
    {
      "id": "9e9c0237-da1e-4af7-8f48-cecebd8dca83",
      "text": "Downing of Malaysia Airlines flight MH17 over eastern Ukraine"
    },
    {
      "id": "86a14342-af6d-4056-aa63-8dcd47006a73",
      "text": "Preprint and early reports (June–July 2021) documented multiple vaccine 'breakthrough' infections with the Delta variant, including clusters where fully vaccinated people became infected."
    },
    {
      "id": "164abe24-6e10-49b3-ba08-593644130278",
      "text": "CDC clinical guidance (May 2021) noted people with recent SARS-CoV-2 infection may consider delaying vaccination for up to three months and that infection can confer temporary immunity."
    },
    {
      "id": "028b5959-8bc5-46f0-809d-c6469b06172d",
      "text": "Israeli Ministry of Health and Reuters reported in early July 2021 that measured effectiveness of the Pfizer–BioNTech vaccine against infection had declined (headline figure reported ~64% in early July amid Delta spread)."
    },
    {
      "id": "55bb880b-433a-4f90-85b9-1938e89ba0cb",
      "text": "SIREN study (healthcare workers) reported substantially lower reinfection rates among antibody-positive participants compared with antibody-negative participants."
    },
    {
      "id": "39f5ed96-dc5f-4d39-839b-6d6e5c18be9c",
      "text": "Lancet Rheumatology paper reported lower humoral (antibody) responses after COVID-19 vaccination in patients with immune‑mediated inflammatory diseases"
    },
    {
      "id": "d6e5d0ec-a287-4c85-aaea-293d330b05a6",
      "text": "Japan suspends use of some Moderna COVID-19 vaccine batches after discovery of foreign/black particles"
    },
    {
      "id": "683796d7-fd83-4d96-8114-5d3ce3862e85",
      "text": "FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children 5–11"
    },
    {
      "id": "88e7d9ca-6337-4303-9f4e-3459cb5b0080",
      "text": "Public reporting and CDC guidance on rare myocarditis/pericarditis cases after mRNA vaccination in adolescents and young adults"
    },
    {
      "id": "bc63a604-0288-4ac9-91e0-1ac813d262ed",
      "text": "U.S. publicly rejected Poland’s proposal to transfer its MiG‑29s via a U.S. base, citing NATO concerns"
    },
    {
      "id": "4fcc8039-7dd5-48b5-b18b-3c35026981a3",
      "text": "NATO announced plans to reinforce its eastern flank with additional troops and assets in response to the Russian invasion"
    },
    {
      "id": "22c8c250-6974-4ac0-a7bc-85c57fa97817",
      "text": "Analysis and reporting documented an uptick in Kremlin disinformation targeting Poland and Poland–Ukraine relations"
    },
    {
      "id": "b1bc7ef5-ba2f-4ac7-9441-542d10fb5d51",
      "text": "WHO-China Joint Mission final report noted roughly 80% of confirmed COVID-19 cases were mild."
    },
    {
      "id": "900f0d59-882e-48bb-8068-faadd341686a",
      "text": "Early WHO/CDC public guidance said masks were primarily for symptomatic people and caregivers and were not routinely required for healthy members of the public."
    },
    {
      "id": "699a4af5-75d6-42db-a04f-798074f56283",
      "text": "Industry/academic report 'Sustainable Decommissioning: Wind Turbine Blade Recycling' (March 2021) documented technical and commercial barriers to large-scale blade recycling and called for solutions."
    },
    {
      "id": "2409363a-85ec-4eec-b018-6d215e71357f",
      "text": "Public Health Scotland / national reports on births and pregnancy outcomes for year ending 31 March 2023 published (routine surveillance showing fluctuations in stillbirth/neonatal rates)."
    },
    {
      "id": "4fd10c59-57d3-4f84-ab30-85e11a35ae70",
      "text": "Published medical case reports and toxicology literature documenting severe turpentine poisoning"
    },
    {
      "id": "a0532d2b-b781-4d22-b19a-f140e497e286",
      "text": "Radiology literature (2021) documenting vaccine-associated axillary/supraclavicular lymphadenopathy and FDG PET/CT uptake"
    },
    {
      "id": "62f432a4-e789-437b-ad39-5d0879fde1b7",
      "text": "Publication of a case report describing rapid progression of marginal zone B‑cell lymphoma following BNT162b2 vaccination (Frontiers in Medicine)"
    },
    {
      "id": "8a40ef2a-7e19-4ee7-8d2c-14d80b5c22d6",
      "text": "Germany publicly approved supplying Leopard 2 tanks to Ukraine and allowed other countries to re-export their Leopard tanks."
    },
    {
      "id": "ec45dd9c-8476-4ca4-8716-3447aeaaff68",
      "text": "High-profile coverage of Wagner Group operations and heavy losses around Bakhmut in February 2023 increased attention on Wagner's battlefield role."
    },
    {
      "id": "d7517e48-9bd4-49ba-8321-6ae9a929e42a",
      "text": "EPA issues the 2009 Endangerment Finding that greenhouse gases (including CO2) threaten public health and welfare."
    },
    {
      "id": "83e941d2-2d4c-462a-ada6-2662be655124",
      "text": "Scientific and industry literature documenting routine CO2 enrichment in greenhouses to boost plant growth (longstanding agricultural practice; review articles dating back decades)."
    },
    {
      "id": "023a3a03-92bd-4dfa-b4d8-ed4ca639438c",
      "text": "U.S. Rep. John Shimkus publicly refers to carbon dioxide as 'plant food' during a House Energy and Commerce subcommittee hearing."
    },
    {
      "id": "4355567f-f64b-428f-940a-54888926dacf",
      "text": "Drone/sea‑drone attacks on ships and the Sevastopol/Black Sea Fleet anchorage"
    },
    {
      "id": "2d7d05b8-6a8b-4471-896c-1e99aa152da9",
      "text": "Explosions at Saky (Novofedorivka) air base in western Crimea"
    },
    {
      "id": "2f787b43-5648-40b8-af1a-ce6489975e0c",
      "text": "Russian reports of arrests/detentions over alleged plots to sabotage Crimean infrastructure"
    },
    {
      "id": "fa2510b2-5e3f-4313-95b0-2440af717372",
      "text": "Passage of the National Childhood Vaccine Injury Act (NCVIA) establishing the National Vaccine Injury Compensation Program (VICP)"
    },
    {
      "id": "c13298b9-61bd-4a7a-96f1-e75eb5933ea9",
      "text": "FDA proposed sunscreen monograph update and limited 'GRASE' designation (only zinc oxide and titanium dioxide)"
    },
    {
      "id": "b18559d0-6625-4df8-84f6-d6b9f030e6f1",
      "text": "Edgewell (Banana Boat) voluntary recall for sunscreens due to benzene contamination"
    },
    {
      "id": "7f59b6be-620e-4011-a17a-e99f10acfed5",
      "text": "Seizure of Sloviansk and other towns (April 2014) — separatists quickly occupied checkpoints and were reported driving captured Ukrainian armoured vehicles"
    },
    {
      "id": "ff9240ed-fc40-4246-8fb4-084cf8be6aa2",
      "text": "Battle of Ilovaisk (August 2014) — encirclement and heavy Ukrainian losses with numerous troops killed, wounded or captured"
    },
    {
      "id": "df28a2d0-2357-4af3-a4f5-b4f636d4887c",
      "text": "UNESCO expert recommendation to list the Great Barrier Reef as 'in danger'"
    },
    {
      "id": "6d57745f-f537-4a34-9959-ced8d105f77c",
      "text": "AIMS press release: 'Reef in recovery window after decade of disturbances' (AIMS Long‑Term Monitoring Program results)"
    },
    {
      "id": "e8111f10-d07b-4362-a05c-fd60042d4a9e",
      "text": "Australian government and political backlash/lobbying over UNESCO recommendation"
    },
    {
      "id": "e0d54a0c-eece-48bb-8f50-cd3eaafc0fa9",
      "text": "Earlier inconsistent public messaging on mask use by health authorities (CDC guidance evolution, April 3, 2020 recommendation to wear cloth face coverings)"
    },
    {
      "id": "29a4e505-4099-47a6-998e-2154a79c4650",
      "text": "Publication of the DANMASK-19 randomized trial (Danish mask study) in the Annals of Internal Medicine"
    },
    {
      "id": "cbc20e83-8597-40f4-a223-ff847caa8763",
      "text": "UN OHCHR Human Rights Monitoring Mission (HRMMU) report on Ukraine noting incomplete/inconclusive investigations into the Odessa 2 May deaths"
    },
    {
      "id": "c73d8b2c-c98d-404d-b0eb-4e7f458a1c68",
      "text": "South African National Institute for Communicable Diseases (NICD) early assessment reported Omicron appeared less severe on average but produced a rapid surge in cases and hospitalisations (report released Dec 21, 2021)."
    },
    {
      "id": "265d0497-7c7f-4aaa-97e5-c3e3f9b9a5d9",
      "text": "Publication of a major global study quantifying temperature-related mortality (Zhao et al.) in Lancet Planetary Health"
    },
    {
      "id": "167e4a22-6387-4899-9281-5bd108afc174",
      "text": "EU agreement on visa‑free travel for Ukrainian citizens (visa liberalisation process confirmed in 2017)"
    },
    {
      "id": "44c4e67f-e11c-4a5b-abb7-d66838bc1680",
      "text": "EU sanctions on Russia in response to the annexation of Crimea and destabilisation of eastern Ukraine (sanctions imposed and expanded in 2014)"
    },
    {
      "id": "9021bbcd-8ce7-4eeb-91ac-db6bedfae0f6",
      "text": "Ukrainian Cabinet fixes one‑time payment of 15 million UAH for families of fallen servicemen (decree published)"
    },
    {
      "id": "dc87d64e-7133-4ab2-9822-5b4dad563276",
      "text": "Government measures earlier in 2022 to simplify/adjust compensation procedures for families (administrative changes and rolling implementation)"
    },
    {
      "id": "b5c3dfbe-a902-4930-9123-0e9d9bfb1f9b",
      "text": "Amendments to the law on social/legal protection of servicemen came into force (changed wording about how one‑time payments are regulated)"
    },
    {
      "id": "305f1c79-5f44-45b3-8aad-5c5125a53dda",
      "text": "Verkhovna Rada approved Ukraine's 2020 state budget (official figures: revenues ~UAH 1.093 trillion, expenditures ~UAH 1.18 trillion, UAH 141.5 billion allocated for debt servicing)."
    },
    {
      "id": "42074ae2-3944-45c8-b8f5-a31e31728ae8",
      "text": "IMF approved a US$3.9 billion Stand‑By arrangement for Ukraine (IMF press release documenting large external financing and conditionality)."
    },
    {
      "id": "947bd4ad-0681-4fcd-917e-bf454d698358",
      "text": "World Bank / multilateral reporting (Ukraine Economic Update, Nov 2019) warned of sizable financing needs and public‑debt pressures for 2019–21."
    },
    {
      "id": "86a5d119-e0d3-4b14-9574-eff13e1bba20",
      "text": "Reporting of social tensions and local backlash in Germany over the large influx of Ukrainian refugees (coverage throughout 2022 highlighting strains on communities and rising anti‑refugee sentiment)."
    },
    {
      "id": "fd1ae651-a295-4fb7-aa7d-e0c20925c0b3",
      "text": "Rizzi restaurant in Baden‑Baden was reported to have fired a Ukrainian employee after he posted a video condemning Russia (reported and condemned by Ukrainian officials in March 2022)."
    },
    {
      "id": "0ce6df1f-de08-4e37-81dd-b059d2f9a721",
      "text": "Explosions and missile strikes at Odesa port and nearby industrial sites were widely reported (e.g., reported explosions at Odesa port on April 3, 2022 and a deadly strike on April 23, 2022)."
    },
    {
      "id": "3813ea57-62ec-4431-980e-559b659d3259",
      "text": "Media reports of Western deliveries of gas masks and CBRN protective equipment to Ukraine (e.g., UK announced sending thousands of gas masks in April 2022)."
    },
    {
      "id": "9376e72a-49a8-4fed-9912-59965f0d4884",
      "text": "United Nations letter (dated 6 April 2022) referencing alleged planned provocations and preparations for chemical weapons use in Ukraine."
    },
    {
      "id": "5c8cb8c9-8ece-4977-bcbd-d2e4cffc1a57",
      "text": "Russian Ministry of Defence publicly claimed Ukrainian special services were preparing a chemical 'provocation' using toxic chemicals near the Yuzhny (South) port outside Odesa."
    },
    {
      "id": "caef5161-88f8-4f7b-b0bf-bac754f2b8b4",
      "text": "Release/presentation of a Queensland Health study reporting that rates of persistent symptoms 12 weeks after Omicron infection were similar to rates after influenza in a highly vaccinated Queensland population."
    },
    {
      "id": "35e13dd4-e5b1-46f5-9779-5910c9c89ff4",
      "text": "European officials and media flagged that the proposed U.S. sanctions could target firms involved in Nord Stream 2 and other European energy projects"
    },
    {
      "id": "bb4557ee-951a-432e-aeb0-b7ac0227446f",
      "text": "U.S. Senate overwhelmingly passed a bill imposing new sanctions on Russia (CAATSA)"
    },
    {
      "id": "f9cbbdaa-f4dc-4f8e-814e-576477baa645",
      "text": "President Trump announced U.S. withdrawal from the Paris Climate Agreement, triggering strong EU criticism"
    },
    {
      "id": "07a7f429-0b04-4bb2-9b73-31695a425c61",
      "text": "OSCE Special Monitoring Mission (SMM) spot reports document shelling incidents and civilian casualties in Donetsk"
    },
    {
      "id": "fbd73d33-2ca0-4697-9ee8-edf14741a73f",
      "text": "UNICEF report: over 1,000 children sheltering underground in Donetsk city (bomb shelters) and urgent needs appeal"
    },
    {
      "id": "c2d956be-c010-4d63-8ca4-73abb047cd6c",
      "text": "International media reports 'Ukraine, rebels trade blame over shelling of central Donetsk' after July 2015 strikes"
    },
    {
      "id": "f978a9ba-a72a-4d76-ad65-4fc16420acf4",
      "text": "Signing of the Minsk II agreement (February 2015) and subsequent claims of non‑implementation and ongoing violations"
    },
    {
      "id": "4870f0af-991a-4d27-a5f9-cef54f4d7d80",
      "text": "Official supply‑shortage notices for semaglutide (Ozempic) and related GLP‑1 drugs in early 2023."
    },
    {
      "id": "09cd458a-ad60-4918-b2d1-344d0996dbf0",
      "text": "Deep energy and commercial ties between Italian energy firm Eni and Russia's Gazprom, including extensions of strategic agreements (reported 2011–2012)."
    },
    {
      "id": "ec955636-b8ce-43b4-bdb6-4b52b0f60f67",
      "text": "Release of the U.S. Fourth National Climate Assessment (NCA4), emphasizing strong human influence on recent warming"
    },
    {
      "id": "8a6f7da5-6f97-4723-b387-160cd81f8eaf",
      "text": "Release of UAH Version 6.0 satellite temperature dataset showing a reduced lower-troposphere warming trend"
    },
    {
      "id": "fe0ab7d0-5acf-42f6-8d11-4410eb81005f",
      "text": "Publication of a 1980 study documenting systemic perfusion produced by vigorous coughing in humans and animals"
    },
    {
      "id": "70741f36-330a-4765-a621-855856897516",
      "text": "Resuscitation Council UK public statement warning the public that 'cough CPR' is incorrect advice and should not be used outside monitored clinical settings"
    },
    {
      "id": "901090a6-06b9-4600-b248-c7bc52f2b33f",
      "text": "OSCE Special Monitoring Mission reports from early 2015 described restricted access, movement limitations and damage affecting medical services in Donetsk region, complicating independent verification of medical treatment claims."
    },
    {
      "id": "391f37e2-a85d-4207-991b-bc64b2b1d453",
      "text": "The existence and release of wounded Ukrainian soldier Roman Kapatsiy (treated after captivity) — reports showed he had severe injuries, attracted media attention, and his condition and treatment became contested facts."
    },
    {
      "id": "73bbc6b1-7507-43c5-b47e-df9f5a3fa756",
      "text": "Community publications and documentation describing routine reprocessing and geophysical corrections for satellite altimetry (ESA/AVISO and ESA CCI overview papers, 2016)"
    },
    {
      "id": "e4614d97-76f8-464c-87e9-5e00cd0e98a0",
      "text": "PNAS paper reporting detectable acceleration in global mean sea level (Nerem et al., 2018)"
    },
    {
      "id": "2df72a4e-2d4e-4310-8419-dd7b8caee3ae",
      "text": "Shelling and a fire were reported at the Zaporizhzhia nuclear power plant during early March 2022 hostilities."
    },
    {
      "id": "57078c34-49ef-40e1-97cc-1bd6a7f3aba2",
      "text": "US Air Force B-52 bomber task force conducted long-range integration flights through Europe (Bomber Task Force Europe) in March 2022."
    },
    {
      "id": "0a4dd1e7-aba8-40f6-aa1b-b91867f98acd",
      "text": "Russian President Vladimir Putin ordered Russian nuclear deterrence forces put on high alert."
    },
    {
      "id": "12287211-b799-467b-ac65-9921283f2620",
      "text": "NATO annual nuclear exercise 'Steadfast Noon' commenced, involving dozens of aircraft and allied nations."
    },
    {
      "id": "ee8a9520-1592-4aa6-ba78-e6d3348a11c9",
      "text": "NATO adopted its 2022 Strategic Concept at the Madrid Summit, explicitly addressing Russia as the most significant and direct threat to Allies’ security."
    },
    {
      "id": "4af338f2-92aa-41fc-abd0-d816738ca401",
      "text": "CDC MMWR report documenting thousands of vaccine 'breakthrough' infections reported January–April 2021"
    },
    {
      "id": "e4a17a8b-1a7c-4da0-9e91-f1c49111ee2f",
      "text": "NIH / Health Affairs summary reporting that COVID-19 vaccines prevented nearly 140,000 U.S. deaths in the first months of rollout"
    },
    {
      "id": "942c17a3-a28c-48b2-8150-0f346cb8a272",
      "text": "IPCC AR6 Synthesis Report released (summarizing strong attribution of recent warming to human greenhouse gas emissions)"
    },
    {
      "id": "5d144e6c-0172-4295-85b0-d471a3a7359c",
      "text": "NOAA / NASA updates and public discussion of Solar Cycle 25 progress (solar-cycle forecasts/plots revised/updated in early 2023)"
    },
    {
      "id": "40be193a-bde9-42b6-b43a-6e1b513e00b8",
      "text": "Publication of Nicola Scafetta's paper arguing a large solar influence on recent climate change"
    },
    {
      "id": "f3edd9ad-4e7a-42e5-8560-e4a8141035fe",
      "text": "Kateryna Prokopenko (head of the Association of Azovstal Defenders' Families) visited Germany in early April 2023 to hold meetings with German MPs and ministry representatives seeking humanitarian and rehabilitation support for families and released soldiers."
    },
    {
      "id": "10370b60-b6d5-4e58-84e3-bb99d84b57b1",
      "text": "News reports of contamination concerns after foreign particles were found in some Moderna vials in Japan (leading to temporary pauses/collections of batches)."
    },
    {
      "id": "dbb7b443-25c7-4477-97da-b099f151c261",
      "text": "Public HAARP transmission schedules / community notices in 2024 (routine test announcements, e.g., August 2024 transmission notice)"
    },
    {
      "id": "17f13200-d0c9-4962-867c-9258ba566722",
      "text": "International Organization for Migration and other agencies repaired and expanded collective centres and integration/housing projects for internally displaced persons (IDPs) in Lviv region."
    },
    {
      "id": "ca06531c-e8d4-44b4-ba96-588241c99fb6",
      "text": "Adoption of Ukraine's 'On Education' law (Sept 2017) which phases in greater use of Ukrainian as the language of instruction."
    },
    {
      "id": "62394e44-2e3d-4879-b2f4-addda51d3474",
      "text": "Media reports (international and domestic) on national‑patriotic youth camps and 'patriotic education' programs in Ukraine (coverage in 2018)."
    },
    {
      "id": "363e6fcb-13c9-405b-ae89-318d01bdd863",
      "text": "Government and research reports quantifying long COVID's prevalence and labour‑market impact in 2022 (UK ONS and research briefs)"
    },
    {
      "id": "6d1072d3-bdb2-4476-816f-6ec12e977fca",
      "text": "Japan discovered metal contaminants in multiple Moderna vaccine batches (led to recalls and paused use)"
    },
    {
      "id": "b4480d63-fe94-4e57-99a7-30518a54dae6",
      "text": "EMA safety updates reporting millions of spontaneous adverse‑event reports in EudraVigilance (December 2022 update)"
    },
    {
      "id": "bd644c9c-610f-4fdd-aaa2-9b1398d9bfd8",
      "text": "Reporting in 2014 highlighted Svoboda's nationalist/controversial imagery and its roles in government after Euromaidan (e.g., BBC coverage of far‑right role in late 2014)."
    },
    {
      "id": "98342ee6-0977-4f0c-a3dc-0e09f0b6f30c",
      "text": "Catalan child-protection agency (DGAIA) removed two schoolgirls from a Barcelona school and took them into protective custody on or after 17 June 2022."
    },
    {
      "id": "17b5c061-8a0f-4741-9e55-8350b0a6f7a8",
      "text": "Russian state television (Channel One, program Vremya) broadcast segments accusing Catalan authorities of 'Russophobia' in connection with the Barcelona custody case (late July 2022 coverage)."
    },
    {
      "id": "1c0e90be-fe07-4fb5-8eca-8fa4a9d63345",
      "text": "Broader bilateral tensions between Spain/EU and Russia in 2022 (e.g., Spain expelled Russian diplomats in May 2022), increasing a receptive environment for claims of anti-Russian actions abroad."
    },
    {
      "id": "ee3fe76a-6f8c-4313-8914-17a0cbce118a",
      "text": "Opinion op-ed in The Hill by Drs. Pierre Kory and Paul Marik claiming ~70% of patients in a private practice reported symptom onset after vaccination (coining/advancing 'long vax')."
    },
    {
      "id": "2fbadc7f-0a31-4d3b-974a-62946d1fa866",
      "text": "Official reports that Ukrainian nationals were among foreign victims and contacts with the Ukrainian embassy (Zelenskiy statement)"
    },
    {
      "id": "9e1033af-514d-40d9-8043-bfcb5559e972",
      "text": "Large-scale Hamas-led attack on Israel caused mass casualties and chaos"
    },
    {
      "id": "390a0f6c-3271-4d89-9def-b9099ca6d093",
      "text": "Parliamentary measures (July 2022) and legislative proposals expanding categories eligible for exemption or deferment during mobilization"
    },
    {
      "id": "f7447847-d7cb-43a9-bf6a-2a34237e6243",
      "text": "Cabinet of Ministers Resolution No. 76 establishing the procedure for reservation (deferment) of employees during mobilization"
    },
    {
      "id": "4dc604dd-ff2c-4cb5-9485-c298aa8d6be7",
      "text": "Law on Mobilization amendments and implementing rules entering into force clarifying grounds and procedures for booking/reserving conscripts"
    },
    {
      "id": "e9685bf6-4435-496a-aad0-67339144be17",
      "text": "State license granted to the Kyiv Three Saints Theological Seminary to offer a first (bachelor’s) level degree in Theology"
    },
    {
      "id": "3cb10e35-b70a-4e35-9bc8-0b6323028162",
      "text": "International analyses documenting flows of foreign fighters into Syria/Iraq (The Soufan Group updates, 2014–Dec 2015)"
    },
    {
      "id": "08a8e2ce-1c6e-4368-a829-680c4555465c",
      "text": "Second World Congress of Crimean Tatars convened in Ankara with hundreds of delegates from many countries (international diaspora gathering, Aug 1–2, 2015)"
    },
    {
      "id": "ac28e2ea-de98-44db-b15f-8efda41cf373",
      "text": "Media reports that some Crimean Tatars (and other individuals from the region) had fought in the Syrian conflict"
    },
    {
      "id": "5b48e9a1-a870-4978-bcd4-60d8b4a01145",
      "text": "Lithuanian Riflemen's Union hosts a five-day camp for 30 children from eastern Ukraine (Donbass)"
    },
    {
      "id": "125f05cc-1fb8-4a4b-a3f5-daa08d0d3c0a",
      "text": "Passage of Ukraine's 'decommunization' laws banning public promotion of Soviet symbols and requiring removal/renaming of Soviet‑era memorials and street names."
    },
    {
      "id": "09d00e6f-03c7-4256-a351-aa6ba0bb64b7",
      "text": "Ukrainian authorities (Ministry of Veterans Affairs / regional outlets) distributed Ukrainian commemorative medals to some WWII veterans in spring 2020."
    },
    {
      "id": "5602e897-4263-40db-983e-f751d1289418",
      "text": "Ukrainian lawmakers amended administrative code to prohibit public production and promotion of the St. George's (Victory) ribbon."
    },
    {
      "id": "4d490a29-9d11-445f-b79f-a6dfcf6b674e",
      "text": "OSCE Special Monitoring Mission (SMM) daily reports in late August–early September 2018 documented continuing ceasefire violations along the contact line (Donetsk/Luhansk)."
    },
    {
      "id": "7bc04a5a-2610-492a-bd4e-6ac4c4efab63",
      "text": "Russian Foreign Ministry and other Russian officials publicly condemned Kyiv's reintegration law, saying it 'untied the hands of the war party' and undermined the Minsk process."
    },
    {
      "id": "0d1a7174-88e9-498e-b1d4-e1f4ae813e1d",
      "text": "European Parliament / policy briefings in 2018 and commentary highlighted tensions between Ukraine's domestic reforms (e.g., decentralisation/legislation) and the interpretation/implementation of Minsk II."
    },
    {
      "id": "f6fd9164-7b07-4ac8-9eab-636f169adbdd",
      "text": "Ukraine signs the 'Law on the Reintegration of the Donbas' which defines Russia as an 'aggressor' and sets a new legal framework for retaking occupied territories."
    },
    {
      "id": "6d45de8f-261e-4b0d-9624-00564698fef8",
      "text": "Legacy controversy over the 2012 Kivalov–Kolesnichenko language law and its political fallout (language policy highly politicized since 2012)"
    },
    {
      "id": "a2e6496a-27dd-43d6-bf2e-e6e5d3f3233a",
      "text": "Kyiv City Council member Yuriy Syrotiuk registers a draft proposal to require Ukrainian in city advertising, record keeping and official communications"
    },
    {
      "id": "3dbd115e-607e-4c28-a5ec-5ca4c7dac23a",
      "text": "Publication and coverage of genetic‑risk research showing APOE and common variants alter Alzheimer's risk/timing (Lancet Neurology 2018 and related coverage)"
    },
    {
      "id": "c176ebce-1701-4035-ba6a-31ff5c47e475",
      "text": "Publication of the FINGER multidomain randomized trial showing diet, exercise, cognitive training and vascular monitoring improved cognition in at‑risk older adults"
    },
    {
      "id": "7cb1e360-e3e6-43be-a1c2-4df98a02568d",
      "text": "IPCC Fifth Assessment Report (AR5) Summary for Policymakers acknowledges smaller observed warming trends 1998–2012 than many model simulations and cites internal variability as a likely contributor."
    },
    {
      "id": "e34a708e-7958-4919-bfbd-a00065d97651",
      "text": "Amnesty International published a briefing documenting abuses and possible war crimes by pro-government volunteer battalions (e.g., Aidar) operating alongside official forces."
    },
    {
      "id": "069673ab-fcaf-463d-a280-db1b9f50dc4d",
      "text": "Ukrainian President Petro Poroshenko publicly said Ukrainian forces were fighting 'foreign mercenaries' in the east."
    },
    {
      "id": "0ace144a-883d-455f-a69f-7c95f297209d",
      "text": "NASA/NOAA public messaging about Solar Cycle 25 and increased space weather activity"
    },
    {
      "id": "451fbd13-5ece-4d53-b46e-c6816efe2135",
      "text": "Out‑of‑cycle update to the World Magnetic Model (WMM2020) after rapid movement of the magnetic north pole"
    },
    {
      "id": "7731b716-ba63-4fa8-a146-9875413ac64e",
      "text": "Ukraine reinstated military conscription to meet manpower needs after unrest in the east"
    },
    {
      "id": "f9430af8-c65d-4712-bf56-6735831ab122",
      "text": "Summaries and timelines noted multiple, uneven waves of mobilization (including difficult autumn stages) with administrative complications"
    },
    {
      "id": "b1359cf2-e916-4c3b-951e-dbcfb91228b8",
      "text": "Feature reporting documented men hiding or fleeing to avoid conscription and the social backlash against mobilization"
    },
    {
      "id": "813a7097-75bc-4c0f-8ef2-db8268ff9773",
      "text": "Federal judge orders the FDA to accelerate release of Pfizer COVID-19 vaccine documents (55,000 pages per month)."
    },
    {
      "id": "36cfd210-d06b-405b-9f24-0b95636db2a8",
      "text": "UKHSA published weekly COVID-19 surveillance tables (four weeks to 2 January 2022) showing counts of cases, hospitalisations and deaths broken down by vaccination status."
    },
    {
      "id": "1bb7068b-f675-4d37-8b29-eb4ac7b27ab8",
      "text": "UKHSA published guidance and commentary (Transparency & data blog, 2 November 2021) explaining that raw counts by vaccination status should not be used to estimate vaccine effectiveness because of differing risk, behaviour and testing patterns."
    },
    {
      "id": "08832f1f-1e9d-4560-bcf1-086be71ff254",
      "text": "CDC and other public-health reports covering the Omicron period and bivalent booster era (e.g., MMWR analyses covering Oct 2021–Dec 2022, published early 2023) documented many breakthrough infections and complex changing relative rates of cases and hospitalisations."
    },
    {
      "id": "ce180f9a-7b6f-424b-890b-5c098fcd67e7",
      "text": "NORAD and U.S. military routinely intercept and track Russian military aircraft operating near Alaska (documented intercepts in prior years)."
    },
    {
      "id": "b9122ba0-8bf3-4d37-be60-68c9a8e6d891",
      "text": "Historical pattern of military formation flights and public aerobatic displays over Alaska (large multi‑aircraft formation exercises reported previously)."
    },
    {
      "id": "94029f94-bfa4-46ce-85a1-102fb3438ebf",
      "text": "Russian/Crimean resettlement and incentive programs announced for Crimea"
    },
    {
      "id": "8de55777-91cc-4500-8eb9-00391cfd1996",
      "text": "Large‑scale issuance of Russian passports to Crimean residents after annexation"
    },
    {
      "id": "b30a890f-bb1e-4dcf-8f4a-7da32d5fd2ec",
      "text": "Resumption and growth of scheduled flights and transport connections to Simferopol (2015 onward)"
    },
    {
      "id": "6f1c091f-2d5d-4ccf-9148-6a7144b3728f",
      "text": "OSCE Special Monitoring Mission (SMM) reporting of increased ceasefire violations/explosions and damage in Luhansk frontline areas (SMM daily monitoring around mid‑February 2022, including Stanytsia Luhanska and Zolote)."
    },
    {
      "id": "7c48ff9c-3572-4d1f-af8d-a28071ad3e88",
      "text": "Leaders of the self‑proclaimed Donetsk and Luhansk ‘people’s republics’ announced mass evacuations to Russia (official evacuation orders and state messaging)."
    },
    {
      "id": "c604a848-73e4-47d9-911c-ab0b2f44f9ad",
      "text": "Historical precedent of bridges and rail infrastructure being blown up during fighting in eastern Ukraine (documented incidents in 2014 where rail/road bridges were destroyed)."
    },
    {
      "id": "130c0ed0-197a-441a-affe-5b87f347f7a4",
      "text": "LifeNews crew detained near Kramatorsk by Ukrainian forces, drawing attention to the channel’s activities in conflict zones."
    },
    {
      "id": "b76a8e41-ea5e-46ab-8afd-273b69e724d7",
      "text": "Early-March videos and eyewitness accounts documented violent attacks by pro-Russian separatists on protesters and demonstrators in eastern Ukraine."
    },
    {
      "id": "3119678a-5fd7-4f1e-a362-401a8f99b6b2",
      "text": "Self‑declared Donetsk and Luhansk 'people's republics' announced independence after May 2014 referendums"
    },
    {
      "id": "77e135a3-c11f-4f48-b351-38a792b72478",
      "text": "Trilateral Contact Group negotiations included representatives of the self‑proclaimed Donetsk and Luhansk authorities (OSCE mediation, mid‑2014)"
    },
    {
      "id": "6ee76e7a-4bd0-404b-abab-03d01a57ea06",
      "text": "Publication and wide circulation of quantitative comparisons of volcanic vs anthropogenic CO2 (e.g., Gerlach 2011) providing concrete numbers showing volcanic CO2 is far smaller than human emissions."
    },
    {
      "id": "d2420cfd-d81a-4d8a-9d9c-2dafefab70fa",
      "text": "IPCC Special Report on Global Warming of 1.5°C (high-profile report, October 2018) that refocused public debate on CO2 budgets and human emissions."
    },
    {
      "id": "1e771bf3-49a5-44b9-9445-735d725cfa2c",
      "text": "Reports and recall after discovery of foreign (black) particles in Moderna vaccine vials in Japan (late August–September 2021)"
    },
    {
      "id": "e291a5da-d21f-4619-96ef-ce2d2ff75968",
      "text": "CDC reports increased cases of myocarditis/pericarditis after mRNA COVID-19 vaccination in adolescents and young adults (public reporting began June 2021)"
    },
    {
      "id": "ecdc5e87-0734-41de-9be7-f76522dd49da",
      "text": "FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children aged 5–11"
    },
    {
      "id": "91496a2d-e3b3-4b43-9df6-217b8662cc7f",
      "text": "Technical advisory scrutiny and Bureau response on ACORN‑SAT adjustments (ACORN‑SAT Technical Advisory Forum response)"
    },
    {
      "id": "96c7ba3e-250c-4e59-a015-d908813b2161",
      "text": "Release of the ACORN‑SAT homogenised temperature dataset by the Bureau of Meteorology"
    },
    {
      "id": "48fdf656-134e-4e2f-947d-ab46a493fe4b",
      "text": "Widespread use of distance learning by mid‑2022 (reports noting that by June 2022 most districts were providing remote classes)"
    },
    {
      "id": "c7031f37-932e-4f20-b1f0-ad805c418d7e",
      "text": "Ministry of Education and UNICEF launch 'Back to Learning Together' initiative encouraging return to in-person schooling"
    },
    {
      "id": "4678a09c-7907-45d5-bc3c-1cf48fe82a4e",
      "text": "WHO and World Customs Organization published an HS classification reference for COVID-19 medical supplies (including simplified labels) on April 9, 2020"
    },
    {
      "id": "320d06c2-1801-4f37-832c-c689ba25fa8b",
      "text": "Adoption/use of the sixth edition Harmonized System (HS) nomenclature for commodity codes (introduced in 2017) that underpins WITS historical trade classifications"
    },
    {
      "id": "3bfa0b44-82e8-46c4-baec-c2540f1c85b5",
      "text": "Russian flags and pro‑Russian banners were visibly displayed in Russian‑occupied Ukrainian cities (e.g., Melitopol, Kherson) after Russian forces took control."
    },
    {
      "id": "9c0a5f5b-884b-47d0-8a88-2fc8c6138662",
      "text": "Reports the US was sending military advisers and gear to Ukraine"
    },
    {
      "id": "7f844310-acc5-4a3f-92f1-abac2e63d440",
      "text": "U.S. Congress passes the Ukraine Support Act (H.R.4278)"
    },
    {
      "id": "984d798b-65ca-481c-a6fd-8b4a2a459f92",
      "text": "President Obama meets President-elect Petro Poroshenko (bilateral meeting in Warsaw)"
    },
    {
      "id": "8504e0ca-b54f-4a5b-9b47-cf9d1a45fb89",
      "text": "CDC interim guidance recommending routine cleaning and disinfection of high-touch surfaces in public and private facilities"
    },
    {
      "id": "c1415165-6ad5-4522-a309-629f404ef316",
      "text": "Mainstream consumer guidance advising precautions when pumping gas (Consumer Reports article advising wipes/precautions)"
    },
    {
      "id": "2bd80a18-8bff-480f-994d-68d37192db5b",
      "text": "NEJM correspondence showing SARS-CoV-2 remains viable in aerosols and on surfaces (van Doremalen et al.)"
    },
    {
      "id": "d26c872a-78d8-4320-b5f2-e0033b5b2abb",
      "text": "News coverage and retailer actions showing grocery stores providing wipes and installing cart-sanitizing measures"
    },
    {
      "id": "ad99cdd7-f0b0-4d1c-93b7-1d96068758a7",
      "text": "WHO/UNICEF updated and re-emphasised global guidance recommending exclusive breastfeeding for the first 6 months and advising not to give additional water to infants under 6 months."
    },
    {
      "id": "cb7405f5-b619-4f66-9b7b-4d562a8fc6d6",
      "text": "CDC MMWR report summarising cases of hyponatremic seizures among infants fed excessive solute‑free water (including bottled water) in Wisconsin (1993) and urging clinicians to discourage use of solute‑free water as a supplement for infants under 6 months."
    },
    {
      "id": "60700a47-9ea0-4dce-a491-4559115f0b62",
      "text": "Gates Foundation funding of genetically engineered mosquito/gene-drive research (2016–2018 coverage, e.g., Oxitec funding)"
    },
    {
      "id": "d886f5bc-664c-429c-9754-67530af6439e",
      "text": "Study reporting very low methylphenidate (Ritalin) prescription prevalence in France based on drug reimbursement databases (published 2007–2008)"
    },
    {
      "id": "b412355e-81dd-48f3-a462-70fd74d23a27",
      "text": "CDC report 'Mental Health Surveillance Among Children — United States, 2005–2011' stating 'up to 1 in 5 children suffer from a mental disorder'"
    },
    {
      "id": "0ec94a00-7242-4423-b564-9baf54723262",
      "text": "French national telephone prevalence study (Lecendreux et al.) estimating childhood ADHD prevalence ~3.5%–5.6% (published 2011)"
    },
    {
      "id": "1276b48a-4aa4-4922-aef4-4f038cbfbb97",
      "text": "Measles outbreak in the Gothenburg area (outbreak period Dec 2017–Jan 2018) reported in Eurosurveillance (article published April 25, 2019)."
    },
    {
      "id": "f6bf258c-c08e-4db5-9460-a91e3e5f12c9",
      "text": "Public Health Agency of Sweden (Folkhälsomyndigheten) information emphasising that vaccinations in Sweden are recommended (not compulsory) and are implemented regionally."
    },
    {
      "id": "ffd7678d-00ac-4300-868a-ef2229fb89f9",
      "text": "European pauses and safety reviews of the AstraZeneca vaccine after rare clot reports (March–April 2021)"
    },
    {
      "id": "9dca14dc-8e09-4ce9-bc08-504e8a677f71",
      "text": "Japan recalls some Moderna COVID-19 vaccine doses after foreign particles found in vials (September 2021)"
    },
    {
      "id": "b9d88390-2a0f-45c9-821c-da2a75aaf2d8",
      "text": "WHO designation of Omicron (B.1.1.529) as a Variant of Concern and early statements on mutations/immune escape"
    },
    {
      "id": "c3c07c77-af4b-4204-aabc-6aa4aa674f5d",
      "text": "CDC/ACIP updates and MMWR reporting on myocarditis cases after mRNA vaccination"
    },
    {
      "id": "97e9dcc9-5f54-4f83-b653-40d574bdafb2",
      "text": "Ukrainian law on temporarily occupied territories (Law No. 1207‑VII, 15 April 2014) — non‑recognition of documents issued by occupation authorities"
    },
    {
      "id": "94db3d3a-fce0-4c90-bfb1-3758ab374e4b",
      "text": "Russian presidential decree (April 2019) simplifying and fast‑tracking Russian citizenship for residents of the self‑proclaimed Donetsk and Luhansk 'republics'"
    },
    {
      "id": "427c91a8-7ad7-4918-a7dd-f76a14ce3b91",
      "text": "Publication of research using luciferase reporters in SARS‑CoV‑2 laboratory assays"
    },
    {
      "id": "a779aee6-ebd1-4097-a98d-ba7a139404a4",
      "text": "NFPA / Fire Protection Research Foundation published reports and guidance describing the unique firefighting challenges posed by electric vehicle 'stranded energy' and battery fires."
    },
    {
      "id": "ffd49188-632d-4b7b-a9e5-5a53a52c624f",
      "text": "General Motors issued a high-profile recall of Chevrolet Bolt EVs over a risk of battery-related fires (recalls and repair campaigns announced starting November 2020 and updated subsequently)."
    },
    {
      "id": "af0f83b2-a044-45d7-a820-3b7af9266a72",
      "text": "Ford announced recalls and investigations into a small number of F-150 Lightning pickups over battery-pack issues after several battery-related fire incidents and a temporary production halt (recall notices and reports in early 2025)."
    },
    {
      "id": "69107281-2506-4b5d-ad9c-33de7589fcc9",
      "text": "Multiple electric buses in London caught fire (high-visibility incidents in May 2024), prompting safety checks of hundreds of vehicles and broad media coverage."
    },
    {
      "id": "659d2172-0bd9-48a1-bd4e-33d1367d832a",
      "text": "Publication of Otto et al., 'Energy budget constraints on climate response' (Nature Geoscience, May 2013), which produced observational energy-budget estimates of climate sensitivity on the lower end of model ranges."
    },
    {
      "id": "835dff59-f9d8-4192-9930-64aaadcaa5bb",
      "text": "IPCC AR5 Summary for Policymakers (Sep 2013) stated it is \"extremely likely\" that more than half of the observed increase in global average surface temperature from 1951 to 2010 was caused by anthropogenic greenhouse gases."
    },
    {
      "id": "a1458d74-452e-4b95-854c-fd6204bfd7ae",
      "text": "ICEYE and Ukraine's Ministry of Defence sign a Memorandum of Cooperation to strengthen remote-sensing support for Ukraine (publicised July 2024)"
    },
    {
      "id": "1e3994e0-1d0d-49d4-9d43-09c8589b99ad",
      "text": "Reporting that the 'Prytula' / 'People's Satellite' warranty period expired while GUR continued to use the asset (media coverage raising questions about operational status, July 4, 2025)"
    },
    {
      "id": "94eb1e79-dfe0-47e9-94f8-ff7b6b531e28",
      "text": "Ukraine's Defence Intelligence (GUR/DIU) and media reports state the 'People's Satellite' supplied thousands of SAR images used to identify Russian military targets (mid‑2024 reporting of ~4,000+ images)"
    },
    {
      "id": "52f824fc-6777-4d31-ae8e-0b0d83e13dce",
      "text": "Cultural/history articles revisiting Reich's orgone accumulator (e.g., Open Culture piece) were published in early 2021 and circulated thereafter, describing the accumulator, its devotees, and DIY plans online."
    },
    {
      "id": "57aab8ea-02d6-4c09-b173-144d4f8c9012",
      "text": "Documented paramilitary training and transnational links involving Azov/National Corps veterans (analyses and reports up to 2021)"
    },
    {
      "id": "5d30da82-103d-48ce-8488-ed7168079cca",
      "text": "Ukraine surrendered the Soviet-era nuclear arsenal under the 1994 Budapest Memorandum"
    },
    {
      "id": "515aca24-3240-4fc9-8782-c2e7439ec022",
      "text": "A group of countries (UK, Poland, Netherlands and others) publicly pledged to pursue 'unprecedented' military support including main battle tanks for Ukraine."
    },
    {
      "id": "13727699-8b9a-4d25-b74b-7990b71f76c4",
      "text": "Germany approves sending Leopard 2 tanks to Ukraine, paving way for allied tank deliveries."
    },
    {
      "id": "863817b6-14dc-4206-bcc9-a6f86320d92f",
      "text": "Russian officials publicly denounced Western promises to send tanks as an escalation and framed them as direct Western involvement in the conflict."
    },
    {
      "id": "a3460dbc-2bb3-468e-ae47-1048dcc494b8",
      "text": "UN Secretary-General António Guterres called for de‑escalation and warned about risks of wider war in public remarks at Davos."
    },
    {
      "id": "c2044de8-6008-4dae-b756-39e02b4f336d",
      "text": "Peer‑reviewed retrospective study (Argentina) found higher rates of false‑positive HIV ELISA results among people with prior COVID‑19 or detectable anti‑SARS‑CoV‑2 antibodies"
    },
    {
      "id": "98b91f13-53ee-4bf1-a84f-46cbdbe22cfe",
      "text": "NATO maritime group (including Turkish navy participation) visited the Bulgarian Black Sea port of Varna during Black Sea deployment"
    },
    {
      "id": "c1a8afb9-3dd3-4d26-b831-94baea535cff",
      "text": "Investigations and reporting showing Bulgarian-made weapons appearing in Middle Eastern conflict zones"
    },
    {
      "id": "1af3f1f6-7fc0-4f65-84c9-ab73efc8a94b",
      "text": "Ukraine detained a Turkish-owned cargo ship after it visited a Crimean port"
    },
    {
      "id": "ebf309fb-72f4-4aa8-9fce-de1b2954f161",
      "text": "Reuters report that Turkey's state intelligence agency helped ship arms to Syrian rebel areas"
    },
    {
      "id": "a78a0d1d-fb23-486e-8d7c-31e54b1f6b80",
      "text": "Investigative reporting on crowdfunding for alternative cancer treatments and rise in patient fundraising for unproven therapies."
    },
    {
      "id": "19c3bba1-fa0a-46fa-ba1b-60b9d8ea36cc",
      "text": "WHO commentary warning against 'immunity passports' and noting uncertainty about post‑infection immunity"
    },
    {
      "id": "9e25fe9c-a7fb-4089-b0ce-b5450684df86",
      "text": "Publication: 'Seasonal coronavirus protective immunity is short‑lasting' (Edridge et al., Nature Medicine, May 2020)"
    },
    {
      "id": "138a0535-0d17-4fe8-8ae1-2165b21e315c",
      "text": "WHO told Reuters it had advised Ukraine in March 2022 to destroy certain high‑risk pathogens in public health laboratories to prevent accidental release during the war"
    },
    {
      "id": "8b7f373b-537a-4a7c-9177-bce487373ca9",
      "text": "A prior 2020 incident: Ukrainian volunteers dropped ruble‑shaped leaflets over occupied Luhansk (Slavyanoserbsk/Stepove), which local separatist authorities later claimed were contaminated"
    },
    {
      "id": "da7bede6-7a01-4a88-8ee2-8487491580d2",
      "text": "FDA issues Emergency Use Authorization for Pfizer–BioNTech COVID‑19 vaccine (Dec 2020)"
    },
    {
      "id": "25469249-14a0-4d3c-b927-3fcd39e306b8",
      "text": "Publication of early seroprevalence studies suggesting lower infection fatality rates (e.g., Stanford/Santa Clara preprint)"
    },
    {
      "id": "b9f61132-8496-4398-a695-fd09dcbf8995",
      "text": "IMF / national energy-policy documents and regulator schedules (2015–2016) documented planned increases in household energy tariffs as part of energy-market reform and commitments to creditors."
    },
    {
      "id": "aea49fae-06ed-4218-960f-84a8e7dff779",
      "text": "Kyiv City Council approved additional municipal budget allocations for organizing and hosting Eurovision (including reported allocations for surveillance/security and event costs)."
    },
    {
      "id": "d4854f09-6b5d-45dd-ad64-57ee66a031ad",
      "text": "European Broadcasting Union (EBU) confirmed Kyiv as host city for the 2017 Eurovision Song Contest."
    },
    {
      "id": "3b1ac5b5-c528-4a0f-96af-d9bbc0ad402f",
      "text": "Russian strikes and shelling left Kharkiv without water and power, with dozens of civilian casualties reported"
    },
    {
      "id": "cef7cf93-eb17-4334-ad4b-619188793fd2",
      "text": "Evacuations and chaotic flight from Kharkiv, including reports of students and residents fleeing on foot after nearby shelling"
    },
    {
      "id": "ba6ff167-e8c8-40a9-9a84-61f53e1f342a",
      "text": "Frequent reporting and situation updates showing Ukrainian forces prioritizing defense and counterattacks around Kyiv while fighting continued in the northeast"
    },
    {
      "id": "03e3beb0-ecbe-4656-bcdd-f724ae845e9c",
      "text": "Norwegian review of deaths among very frail elderly shortly after Pfizer vaccination (investigation reported March 2021)"
    },
    {
      "id": "f3a8343a-d979-47b7-815c-831df4ef2799",
      "text": "CDC / ACIP communication and MMWR reports on myocarditis after mRNA vaccines (June 2021)"
    },
    {
      "id": "eeda927f-0cf9-4701-8464-ee83c49a371d",
      "text": "OSCE Special Monitoring Mission reports and daily summaries recorded clashes, alleged atrocities and contested reports around Donetsk/Snizhne in Aug 2014"
    },
    {
      "id": "bd99aeb0-773d-4bd1-a916-0b224aff6474",
      "text": "Airstrike hits residential buildings in Snizhne, killing civilians"
    },
    {
      "id": "51ced878-c7a3-4b0b-94ea-fe890b9f18ee",
      "text": "Japan reports contamination (black/foreign particles) in batches of Moderna COVID-19 vaccine vials, prompting recalls and temporary suspension of some batches"
    },
    {
      "id": "a1d27647-8ea4-473b-a900-c1a08dcc2af4",
      "text": "Coverage and commentary noting a post-pandemic rise in late-stage and some rare/aggressive cancer diagnoses — analysts and clinicians pointed to missed screenings, delayed diagnoses and possible biological mechanisms tied to SARS‑CoV‑2 infection"
    },
    {
      "id": "a5fec585-45ef-4e77-acb2-44a4eb77e056",
      "text": "U.S. Government Accountability Office (GAO) report on cloud‑seeding technology (GAO‑25‑107328) concluded in December 2024 that evidence for cloud‑seeding effectiveness is limited and uncertain."
    },
    {
      "id": "a8e91066-2bad-4046-99e9-01080c342e9b",
      "text": "A private cloud‑seeding company (Rainmaker Technology) conducted a brief cloud‑seeding flight over south‑central Texas two days before the floods."
    },
    {
      "id": "b18211ac-bc7a-480e-8886-4ea26acbfe0e",
      "text": "Russian president's decree simplifying the naturalization process for Ukrainians (widely reported July 2022)"
    },
    {
      "id": "14644813-a1fa-4256-8100-1202ecc87880",
      "text": "Local and national Ukrainian reports (mid-March 2022) documented that Russian shelling had heavily damaged parts of Rubizhne City Multidisciplinary Hospital (e.g., maternity/obstetrics department destroyed)."
    },
    {
      "id": "6aa42f60-59db-4177-9a34-b9d050386ad3",
      "text": "Ramzan Kadyrov publicly announced Chechen forces' deployment to Ukraine and frequently posted videos and claims via his Telegram/state-affiliated channels in Feb–May 2022."
    },
    {
      "id": "43a98ba9-e0cc-46b6-b06f-d5ff92020ba2",
      "text": "The Rubizhne Central City Hospital infectious diseases department had been renovated in 2017 with funds from UNDP and the Government of Japan (official works and signage)."
    },
    {
      "id": "18fc5214-0e1a-4582-bd8e-68e7df91da5c",
      "text": "IPCC AR5 and public messaging about decadal/short‑term variability vs. long‑term warming (IPCC WGI report, 2013)"
    },
    {
      "id": "3c81b0a8-0ec3-44d5-9e23-b6886684a510",
      "text": "Commissioning and public release of the U.S. Climate Reference Network (USCRN) as a high‑quality, ‘pristine’ temperature station network (began 2005; ongoing rollout)"
    },
    {
      "id": "b8aaffa6-27c2-47ef-afa7-238f612eb2a5",
      "text": "Publication of Karl et al. (NOAA) in Science revising global surface temperature records and rebutting the idea of a global 'hiatus' (June 2015)"
    },
    {
      "id": "9ed245ca-3c9a-4ee3-8019-4ff857adca60",
      "text": "Local bans/restrictions on Russian‑language cultural products in parts of Ukraine (example: Lviv restrictions/public measures)."
    },
    {
      "id": "05b4f83a-d62a-4bc4-8ac6-f243c3eca0ba",
      "text": "Constitutional Court declared the 2012 Kivalov–Kolesnichenko 'regional languages' law unconstitutional."
    },
    {
      "id": "dbcf6044-164e-48b0-a8bb-9b20202a86ca",
      "text": "Public and parliamentary clashes around the second reading of the language bill, with pro‑Russian MPs and media framing the draft as discriminatory/anti‑Russian (disruption and heated debate around Feb–Mar 2019)."
    },
    {
      "id": "495f7684-da08-4796-a97f-20763a81934c",
      "text": "Verkhovna Rada approved draft bill No. 5670-d (the new state language bill) at first reading."
    },
    {
      "id": "07ef1c9d-9e02-48fa-894e-9aa9ac00825f",
      "text": "Dutch Safety Board (Onderzoeksraad) formally took charge of the international investigation into the MH17 crash"
    },
    {
      "id": "ee64a014-2ae8-4581-af12-44746c5eac31",
      "text": "Gazprom and Naftogaz sign settlement and five-year transit agreement"
    },
    {
      "id": "1ca9b445-a7f1-4e4d-a7c3-b2b10215d91d",
      "text": "Longstanding precedent: Russia cut gas to Ukraine and Europe in January 2009"
    },
    {
      "id": "ab2f6972-f2b3-43ba-ad67-ccdea1dc15ea",
      "text": "Inauguration of TurkStream pipeline (alternative southern route)"
    },
    {
      "id": "9219490f-23d2-4d56-9e71-68248cfd250b",
      "text": "Published analysis noting reduced guaranteed transit volumes from 2021 under the 2019 deal"
    },
    {
      "id": "b66fd564-56e0-4dbc-af75-4d728a3b595b",
      "text": "IUCN / Polar Bear Specialist Group published 2015 Red List assessment with a global population estimate (≈22,000–31,000) and noted the overall population trend as 'unknown'."
    },
    {
      "id": "cf1261a7-6ec6-4d9b-96a1-7fa516cb00ba",
      "text": "Amnesty International and Human Rights Watch published 2018 findings that Ukrainian authorities failed to investigate and punish far‑right violence"
    },
    {
      "id": "8bdd3630-0b71-4a27-9152-988a27b64b02",
      "text": "Volunteer battalions (including Azov) were brought under the Interior Ministry/National Guard command in 2014"
    },
    {
      "id": "b22c5196-0753-459c-b19e-6a661a3c6cfa",
      "text": "Reports that some volunteer regiments were financed or sponsored by political figures/oligarchs while operating under ministry structures (example: Dnipro-1)"
    },
    {
      "id": "d5b40b40-4fd8-4809-825d-74c396c5e1c1",
      "text": "IPCC AR5 (2013) assessment noting divergence among lines of evidence for equilibrium climate sensitivity"
    },
    {
      "id": "816a5a49-d869-42ce-80e4-5a2519321ae8",
      "text": "Release of UAH Version 6 satellite temperature product (Spencer & Christy), reporting reduced tropospheric warming trend"
    },
    {
      "id": "17438dff-d991-4c0d-b588-21ff8e0929ad",
      "text": "Ukraine's 2018 national drug situation report (2017 data) noted transit and domestic production of various drugs"
    },
    {
      "id": "a0a3eef5-73dc-4c61-8d1e-ddc2688f0947",
      "text": "Large heroin seizure transiting through Odesa/Illichivsk port (reported 12 June 2015)"
    },
    {
      "id": "738bdcc9-d4ba-4518-ae26-cd7d5fa251dd",
      "text": "Growing media and scientific attention to microplastics in the food chain (scholarly reviews and coverage 2021–2024)"
    },
    {
      "id": "b11c29a2-7c09-4c5b-914e-bdff2ac00a4a",
      "text": "Public-health agencies (including the U.S. CDC) and research institutions historically filed patents on viral isolates or related sequences (e.g., CDC and others filed patent applications around the 2003 SARS outbreak to ensure public access to samples)."
    },
    {
      "id": "c91771dd-4604-4c1c-9b41-f6f997180a75",
      "text": "Publication of the Independent Peer Review and technical reports documenting ACORN‑SAT methods (technical advisory documents made public)."
    },
    {
      "id": "c12ca3f8-34f3-4cef-a02d-9a0b67614a19",
      "text": "Release of the ACORN‑SAT homogenised temperature dataset by the Australian Bureau of Meteorology (the official long‑term Australian temperature series)."
    },
    {
      "id": "310da8a6-11f0-4449-846e-b764c9debe0b",
      "text": "Government discussion of investigating the Bureau after public controversy over temperature adjustments (reported discussions in 2015)."
    },
    {
      "id": "879b8025-cd29-49f3-b9bf-9b4eaa9be7dd",
      "text": "FDA enforcement actions and public warnings against numerous for‑profit stem cell clinics selling unapproved therapies"
    },
    {
      "id": "52a46197-0688-4cff-bec6-ee4af2d7945c",
      "text": "UN human-rights submissions and NGO reports (2012) documented development and piloting of restorative/diversion programmes for children in conflict with the law across multiple Ukrainian communities."
    },
    {
      "id": "366a6246-8c85-4924-b0d2-5b86bfc2c2d7",
      "text": "Parliament passed an amnesty law and released many protesters (including minors) detained during Euromaidan, creating visible cases of youths being freed from criminal charges."
    },
    {
      "id": "dfedbaec-39b4-4897-a75d-46aac34780e4",
      "text": "Legislative activity and draft bills on child‑friendly procedures and mediation (alternative bills on mediation submitted to the Verkhovna Rada) were reported in 2013."
    },
    {
      "id": "b421ab5e-bc05-4b8c-af63-8a7421ab0851",
      "text": "Longstanding NGO-led restorative justice pilot projects (first initiated in 2003) and subsequent local pilots expanded through the 2000s and early 2010s."
    },
    {
      "id": "c583f936-7449-4241-a0b5-700f8583bebd",
      "text": "Japan suspends ~1.6 million Moderna doses over contamination reports"
    },
    {
      "id": "e24b553c-a7d4-4b94-bad9-2938a45a2352",
      "text": "Israel study reports cases of myocarditis after Pfizer mRNA vaccine"
    },
    {
      "id": "bf678fbf-bf14-49a4-907f-4109729b3b0a",
      "text": "Study/analysis showing waning protection of BNT162b2 against Delta (Israel)"
    },
    {
      "id": "0972955b-ece9-47bd-88c3-e8585e08f124",
      "text": "Arla Foods announced a UK trial of the methane-reducing feed additive Bovaer across ~30 farms (with Tesco, Aldi and Morrisons named partners)."
    },
    {
      "id": "68c3d94c-0fd4-4c94-8ee5-79c9666237b8",
      "text": "The UK Food Standards Agency published a detailed technical safety assessment (RP1059) on 3‑nitrooxypropanol (3‑NOP, the active in Bovaer), including residue analysis and limits of quantification for milk."
    },
    {
      "id": "9433cc9e-44dd-4514-a4e8-8df2fa8e65e1",
      "text": "dsm-firmenich (maker of Bovaer) announced that the US FDA had completed its review and that Bovaer met safety and efficacy requirements, paving the way for a US market launch."
    },
    {
      "id": "06d20d03-85c5-49c3-b962-c5d05ead6130",
      "text": "EFSA / scientific assessments (including a 2021 EFSA feed-additive opinion / published scientific summaries) of 3‑NOP (Bovaer) were publicly available prior to 2024."
    },
    {
      "id": "7ee60054-be86-47e7-8f19-418ebd357da1",
      "text": "May 11, 2014 Donetsk and Luhansk 'referendums' claiming overwhelming support for separation"
    },
    {
      "id": "436663dd-5aff-4330-ba83-ec791399568e",
      "text": "NIH COVID‑19 Treatment Guidelines panel statement (early 2021) that there was insufficient evidence to recommend ivermectin for COVID‑19 (revisions in/around February 2021)."
    },
    {
      "id": "28eb1db8-9fc7-4f38-83d7-6cbc590f3620",
      "text": "Reported incident and grid disconnection at Zaporizhzhia nuclear plant (December 2014)"
    },
    {
      "id": "1eed73cf-b401-4aad-b6fb-40dab881fd02",
      "text": "Budapest Memorandum (security assurances to Ukraine)"
    },
    {
      "id": "1319e96c-f08f-4509-8966-9cca047160d7",
      "text": "CDC and FDA June 2021 review and public reporting of myocarditis and pericarditis cases after mRNA COVID‑19 vaccination."
    },
    {
      "id": "6c2dda8c-ea69-4ecf-a0d2-8bbc59e85879",
      "text": "Federal judge orders accelerated public release of Pfizer vaccine documents (reported Jan 7, 2022), drawing attention to internal vaccine trial materials."
    },
    {
      "id": "cbcc4d41-e1a4-4631-9bd0-f44199ef2491",
      "text": "Ogata et al. (Clinical Infectious Diseases, 2021) reported detection of SARS‑CoV‑2 vaccine antigens (spike protein fragments) in plasma of some mRNA‑1273 recipients."
    },
    {
      "id": "a70ba9ce-892e-48c3-a0e0-14cce6f091bf",
      "text": "Genomic surveillance identified BA.2.86 in U.S. samples (pooled swabs collected Aug 10; individual sample confirmed Aug 20) and CDC reported early detections."
    },
    {
      "id": "7d5d4a7b-f0e9-4bb2-97ed-7a3546ae51b8",
      "text": "Ukrainian President Volodymyr Zelensky appoints Chrystia Freeland as an economic development adviser"
    },
    {
      "id": "80e76425-e94c-4e6e-b18c-5d0e2458f3df",
      "text": "World Bank / government-backed moves to restructure Naftogaz (ownership unbundling debate, May 2019)"
    },
    {
      "id": "c1db1293-d3f9-4ba1-811b-e39f23953a4a",
      "text": "Ukrainian government public administration reform (Strategy for Public Administration Reform 2019) including targets to streamline staff"
    },
    {
      "id": "ee163317-e616-4d92-ac13-19bb01d1412a",
      "text": "World Bank: Ukraine Economic Update warns manufacturing and investment weak (press release)"
    },
    {
      "id": "4ce9bd1c-33a5-414a-a8cf-ddff35b9944e",
      "text": "WHO declares COVID-19 a Public Health Emergency of International Concern (PHEIC)"
    },
    {
      "id": "7a9c7aa3-b9ec-4447-8ad5-14f53b8a99dc",
      "text": "Publication of a peer‑reviewed paper arguing a 'Modern Grand Solar Minimum' could cause decades of cooling"
    },
    {
      "id": "af60bf05-c6ff-44be-bab4-82baf4596d98",
      "text": "Nordic countries (Sweden, Denmark, Norway, Finland) limited or paused use of Moderna in younger people citing myocarditis signals (Oct 2021)"
    },
    {
      "id": "230d6126-a06f-4719-a4e4-ee47b7d9dfc8",
      "text": "CDC/ACIP report and guidance noting rare myocarditis cases after mRNA COVID-19 vaccination (June 2021)"
    },
    {
      "id": "7fd0faa7-72aa-4187-9f9d-b0ad8cf14b73",
      "text": "FDA emergency authorization of Pfizer‑BioNTech COVID‑19 vaccine for children 5–11 (Oct 29, 2021)"
    },
    {
      "id": "5ab2833b-6968-45cd-b20e-3d6a4d94962e",
      "text": "MedRxiv/academic preprint showing children have stronger pre‑activated innate airway antiviral responses to SARS‑CoV‑2 (June 2021)"
    },
    {
      "id": "a709cd8e-97a4-4015-9336-5bd9ed38bb12",
      "text": "Local/municipal moves to formalise 'underground' schooling in frontline areas (Kharkiv announced plans and preparatory works for an underground school; subway‑based classes were reported in Kharkiv)."
    },
    {
      "id": "50796783-fd71-48a3-b820-83a169765006",
      "text": "UNICEF photo essay and reporting documenting children sleeping and studying in basements, bomb shelters and other protected spaces in wartime Ukraine."
    },
    {
      "id": "01cac53c-ae09-444b-8c7a-4d8983acba5b",
      "text": "Commentary and analysis documenting a broader trend of 'atrocity denial' and claims that wartime suffering (in Gaza and Ukraine) is 'staged' — media pieces in November 2023 noted this pattern."
    },
    {
      "id": "b16284c8-e200-4b13-9554-b82faa004f1c",
      "text": "Earlier 2025 federalized National Guard deployments to U.S. cities (e.g., Los Angeles in June 2025)"
    },
    {
      "id": "a1355bbd-fdad-48a3-8e4f-5b2bbb3471d0",
      "text": "Japan suspends use of multiple Moderna vaccine batches after reports of foreign particles/contamination found in vials."
    },
    {
      "id": "8713027e-2d87-46f0-8c1c-d199a2b4a510",
      "text": "CDC and FDA recommend a pause in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis (blood clots) in recipients."
    },
    {
      "id": "08aed31c-7eb9-4c4a-8202-846ae0d621e7",
      "text": "European Medicines Agency (EMA) concludes that the Oxford–AstraZeneca COVID-19 vaccine is associated with very rare unusual blood clots combined with low blood platelets and updates safety information."
    },
    {
      "id": "c5a3ecce-7031-464f-a033-0f25096bf05a",
      "text": "EU Agency for Fundamental Rights (FRA) / EU research on 'severe forms of labour exploitation' highlighted cases and structural vulnerabilities of migrant workers in Poland"
    },
    {
      "id": "fc9c12f8-858e-4cd9-83cf-a3e04b25fe51",
      "text": "Poland ratified the 2014 Protocol to the ILO Forced Labour Convention in October 2016 (official recognition and legal steps on forced labour)"
    },
    {
      "id": "a9642145-43cc-469b-b0d8-1de850452963",
      "text": "Polish government statistic: 420,000 Ukrainian citizens paid Social Insurance contributions in 2018 while estimates suggested up to 1–2 million Ukrainian migrants in Poland"
    },
    {
      "id": "cd12d1b2-fd96-4f7e-92a4-60647d717334",
      "text": "Yatsenyuk faced pronounced political pressure and very low public approval in July 2015 (KIIS poll showed extremely low support), creating a background narrative of a weakened leader."
    },
    {
      "id": "2e788f0c-75c7-4cc1-9c6d-ab3bf104216c",
      "text": "U.S. and Western officials had publicly warned in early February 2022 about the possibility of Russian 'false flag' operations to justify invasion."
    },
    {
      "id": "7ca7d363-1dca-4657-8ef2-203fbc63b00c",
      "text": "A Russian missile struck a high-rise apartment building in southwestern Kyiv and was widely reported on Feb 26, 2022."
    },
    {
      "id": "2d56b4cc-06d2-42fc-96ec-29e8f62f2884",
      "text": "IPCC AR5 (2013) Summary for Policymakers: no single best estimate for equilibrium climate sensitivity given wide uncertainty across lines of evidence"
    },
    {
      "id": "a1629251-5ff9-438d-82c3-c953fa276a4d",
      "text": "Reuters special reporting on the Ukrainian government's struggle to control independent volunteer/maverick battalions (reports of units operating beyond official command)."
    },
    {
      "id": "5bec55e8-6809-46ea-85ad-3c7b4426a4a2",
      "text": "Amnesty International documented abuses by the Aidar volunteer battalion operating in Luhansk and areas around Donbas."
    },
    {
      "id": "1f694e3e-1c2a-40f8-bbc7-36e8ce3fb57e",
      "text": "Human Rights Watch published 'You Don't Exist' documenting arbitrary detentions, enforced disappearances and torture in eastern Ukraine by actors including pro‑government forces."
    },
    {
      "id": "9b5d9422-c502-48e7-ae6c-be43eebd021c",
      "text": "Minsk II agreement (February 12, 2015) set security, disarmament and withdrawal conditions as prerequisites for holding local elections in Donbas."
    },
    {
      "id": "92eccd30-8e15-4b0a-824d-735cca1c2192",
      "text": "Pro‑Russian separatists held disputed 'elections' in Donetsk and Luhansk on 2 November 2014 amid reports of armed men at polling stations and chaotic scenes."
    },
    {
      "id": "f3a645dd-68f9-4487-b73e-30f2e3ea4d04",
      "text": "Israel reintroduced indoor mask requirements amid a surge driven by the Delta variant."
    },
    {
      "id": "a6d12d64-4e35-421c-bef2-f601d348316c",
      "text": "Texas governor lifts statewide mask mandate and business restrictions (rescind mask orders)."
    },
    {
      "id": "13cee0c9-ef25-445e-82a6-b02b00b2c1fb",
      "text": "Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine showing limited protection for mask wearers (DANMASK-19)."
    },
    {
      "id": "0d4831b9-1c60-4e5b-b0b9-72bc0ccfcae3",
      "text": "Widespread visibility of Ukrainian nationalist symbols (UPA red-and-black flag, Bandera monuments) in Lviv and media coverage of those symbols"
    },
    {
      "id": "e7dd94b7-56b1-49b9-bbc8-e0391e96f07d",
      "text": "Documented incidents of swastika graffiti and antisemitic vandalism in Ukraine in 2014–2015"
    },
    {
      "id": "170e6f93-eed9-4548-9823-e63b11639f8c",
      "text": "Air‑raid sirens sounded across Kyiv while President Biden and President Zelensky were visiting St. Michael's Cathedral (audio and footage captured live)"
    },
    {
      "id": "4b87c2d4-b0bc-4bcd-b2d9-b7f06d0da126",
      "text": "IMF staff in Kyiv discussed draft anti-corruption court legislation as part of program-related conditions"
    },
    {
      "id": "a5c99aa4-f17c-43ae-b34e-509a65aa9fd9",
      "text": "IMF technical mission visited Kyiv to discuss continuation of the Extended Fund Facility (EFF) and held meetings with Ukrainian authorities"
    },
    {
      "id": "2bea5ecd-17cf-4178-ab03-db01a041b647",
      "text": "IMF public statements linking further financial support to Ukraine with implementation of pension reform and other policy conditions"
    },
    {
      "id": "e3e3e85f-f8fb-4a8a-8ccb-600f18cbdcad",
      "text": "IMF said the timing of the next review of Ukraine’s program (and related decisions) was 'not yet decided', creating public uncertainty about disbursement timing"
    },
    {
      "id": "f435f62c-ad3b-4efa-aa1f-9ff8d3fe62ce",
      "text": "IMF approval of a $17.5 billion bailout program for Ukraine"
    },
    {
      "id": "aabd0189-1323-4f67-92ca-fda61971db3e",
      "text": "Russia's retaliatory ban on food imports from the EU, US and other countries"
    },
    {
      "id": "679cb10d-d348-44e6-b2f6-01cb567790a2",
      "text": "Sharp contraction of Ukraine's economy and currency devaluation during 2014–2015 (World Bank reporting)"
    },
    {
      "id": "7c3b8401-43bd-4f8a-b967-6e2bb3c08280",
      "text": "EU and US impose sanctions on Russia after the annexation of Crimea"
    },
    {
      "id": "c4c8d590-6cdf-48bf-8957-5096693fce2b",
      "text": "Russia cuts natural gas supplies to Ukraine amid pricing/dispute"
    },
    {
      "id": "aa01c2c4-8749-4bb4-a2cd-1b8bb0a95fba",
      "text": "Ukrainian government policy and public statements (reported by major outlets) urging Ukrainian athletes to avoid competitions where they may face Russian or Belarusian competitors and, at times, withdrawing athletes from events for this reason."
    },
    {
      "id": "9ac2f976-c4da-470b-b294-e79f98fc2b54",
      "text": "International Tennis Federation (ITF) suspends the Russian Tennis Federation and Belarus Tennis Federation from ITF membership and from participation in international team competition."
    },
    {
      "id": "25703fba-ae53-45aa-b648-a763cd3e39c4",
      "text": "Federal judge orders the FDA to accelerate public release of Pfizer vaccine documents after a FOIA lawsuit (PHMPT), resulting in large batches of internal Pfizer/FDA files becoming publicly accessible."
    },
    {
      "id": "e0d3d359-f166-4dd2-aca8-a35110d78fd2",
      "text": "Parubiy's documented early political activism: co‑founding the Social‑National Party of Ukraine in 1991 and leading the paramilitary group 'Patriot of Ukraine' (1998–2004)."
    },
    {
      "id": "43f8b899-885b-4050-ac77-5ce53ea324bc",
      "text": "Established Kremlin disinformation pattern of portraying Ukraine (and Ukrainian officials) as 'neo‑Nazis' used repeatedly since 2014."
    },
    {
      "id": "7307d455-2137-4fa5-bc7c-4cdea871a9dc",
      "text": "Spanish authorities had opened and publicised large reception/assistance centres for Ukrainian refugees in spring 2022 (e.g., Malaga centre opened 6 April; PM visited 20 April)."
    },
    {
      "id": "a65d001c-cca8-4840-9b32-1af336faff8b",
      "text": "Science outlets published explanations (early September 2024) that a combination of factors—dry Saharan air, pockets of wind shear, and short-term atmospheric anomalies—had temporarily suppressed Atlantic tropical cyclone formation."
    },
    {
      "id": "24e21450-cd50-46c3-b94e-55ca3db9664c",
      "text": "NOAA issues an \"above-normal\" 2024 Atlantic hurricane season outlook predicting 17–25 named storms and a high probability of above-normal activity."
    },
    {
      "id": "14e53ed3-1d34-4287-b912-5cda80c785f1",
      "text": "An unusually quiet Labor Day weekend (early September 2024) with no named storms in the Atlantic—reported as a seasonal rarity and record for recent decades."
    },
    {
      "id": "399ec5a7-19c0-4a7b-abf9-391f68e2ff17",
      "text": "Greta Thunberg's high-profile speech at the U.N. Climate Action Summit (widely covered and quoted in the days around Sep 23, 2019)."
    },
    {
      "id": "fc6b77f7-dc25-493e-850a-8a5678ac62f1",
      "text": "Russian embassy in London publicly accused UK authorities of searching an Aeroflot aircraft at Heathrow and sent a diplomatic note demanding an explanation."
    },
    {
      "id": "cd833903-1d88-435a-be20-65d7f3030c1d",
      "text": "Ukrainian government creates Ministry of Information Policy (established 2 December 2014)"
    },
    {
      "id": "9969c3be-cc0d-4004-9170-83f03be8a37a",
      "text": "NATO StratCom and academic reports documenting Russian information operations against Ukraine (2014–2016)"
    },
    {
      "id": "c29e77b6-be2b-4ba7-85e6-435b4a27cae4",
      "text": "UK government’s March 14 expulsions of 23 Russian diplomats and strong public accusations against Russia over the Skripal poisoning."
    },
    {
      "id": "48993eae-6239-4819-9397-c0e535b16ede",
      "text": "Porton Down (Defence Science and Technology Laboratory) public statements (early April) that its scientists identified the substance as a Novichok-type agent but said they had not verified the precise source of the agent."
    },
    {
      "id": "dc3e294e-d8f5-4f83-8645-15c73a692917",
      "text": "Civil service reform and new requirements for Ukrainian in public administration (law adopted Dec 2015, implemented 2016)"
    },
    {
      "id": "2cbd592e-9b27-43bf-9981-257b2c95850a",
      "text": "Passage of Ukraine's 'Law on Education' (which set Ukrainian as the primary language of instruction)"
    },
    {
      "id": "d90b6765-794f-452a-a742-a154dec3b293",
      "text": "2015 'decommunization' laws and related campaigns to remove Soviet-era names and symbols"
    },
    {
      "id": "17726f06-0a1b-4e84-a2da-8c4383fc6422",
      "text": "Adoption and entry into force of the Kivalov–Kolesnichenko 'regional languages' law (widely debated and later contested)"
    },
    {
      "id": "6cb42a3b-90dc-4c1c-9f7b-c798da81dc3b",
      "text": "Radio Free Europe/Radio Liberty coverage of Oleksandr Hurov (May 2014) describing capture and alleged torture by pro‑Russian separatists (includes account of attempts to remove or mutilate markings)."
    },
    {
      "id": "fd57d3a4-1075-477d-ac07-7a5b2f8cf5f6",
      "text": "Russian President Vladimir Putin publicly said Ukraine's counteroffensive had 'failed so far', characterising Ukrainian losses as 'vast'."
    },
    {
      "id": "06ec29b7-82cf-4072-b4d9-152399a5e654",
      "text": "Rheinmetall had experienced a dramatic run-up in revenue, orders and share price since the 2022 invasion (company Q1/2023 reporting highlighted strong defence demand)."
    },
    {
      "id": "f9c3779a-12b0-4cd5-8f95-525ca13037dd",
      "text": "Major international outlets reported the long‑awaited Ukrainian counteroffensive had begun in early June but initial progress looked limited and uncertain."
    },
    {
      "id": "6342e2b7-055f-465b-bfa2-b4ddccaaebb4",
      "text": "Trilateral Contact Group and parties agreed a new ceasefire for eastern Ukraine effective 27 July 2020 (reported by Reuters/OSCE)."
    },
    {
      "id": "c046e6b5-72ee-496c-918b-4be3f500e0ba",
      "text": "President Zelensky's endorsement/implementation of the 'Steinmeier Formula' (October 2019) and related public statements about negotiating a settlement in Donbas."
    },
    {
      "id": "ba975775-fff0-4df5-a3bf-e0ca58335c08",
      "text": "Major prisoner exchange between Ukraine and Russia (reported 7 September 2019), widely covered as confidence-building step."
    },
    {
      "id": "c6f3ddf6-1bab-4d23-b714-953fb57eff01",
      "text": "Appointment of Dmytro Kuleba as Ukraine's Foreign Minister (4 March 2020) and his public rhetoric emphasising diplomacy and dialogue alongside deterrence."
    },
    {
      "id": "69e5b66f-97d1-4101-ae74-59610cb88559",
      "text": "Russia's 2014 agricultural import ban hit French farmers (loss of export markets), creating domestic political sensitivity to the cost of sanctions."
    },
    {
      "id": "9e3880ce-a29d-43cd-874f-cfef33aa127d",
      "text": "Earlier Hollande statements (2015) publicly floated lifting sanctions if progress were made on Ukraine, establishing a precedent for claims he favored easing sanctions."
    },
    {
      "id": "91fe841d-800b-4739-bd2d-d81c8f002fb8",
      "text": "Publication and mailing of the 'European Climate Declaration' / World Climate Declaration (organised by Guus Berkhout / CLINTEL) to the UN asserting 'There is no climate emergency'."
    },
    {
      "id": "7391c888-79ea-4e6f-87cd-27e151639497",
      "text": "Greta Thunberg's high-profile speech to the U.N. Climate Action Summit in New York (widely covered and polarising)."
    },
    {
      "id": "1d4c16e0-d010-4863-9727-9cf42723cae9",
      "text": "Global climate strikes and mass protests in the week of 20–27 September 2019 (Global Week for Future)."
    },
    {
      "id": "bf10fde4-add0-4ec3-9223-e8f98213cb4d",
      "text": "U.S. Department of Defense Biological Threat Reduction Program (BTRP) provided funding, equipment upgrades and technical assistance to Ukrainian public‑health and research laboratories (BTRP cooperation with Ukraine began in 2005)."
    },
    {
      "id": "ef6c5885-5dcf-4ea1-8216-8f32472257f6",
      "text": "Cooperative Biological Engagement Program project in Ukraine with defined implementation period (example: project implementation period listed as 06.03.2015–31.12.2020 on Ukrainian project pages)."
    },
    {
      "id": "4d67b61c-8473-4dc6-95a1-580c9649bb7f",
      "text": "U.S. government announced Operation Warp Speed to accelerate COVID‑19 vaccine development and manufacturing, with involvement from HHS, DOD and other agencies."
    },
    {
      "id": "b2496dbd-12c0-465b-835a-ba1729136df0",
      "text": "Novavax announced it was awarded a Department of Defense contract related to COVID‑19 vaccine development."
    },
    {
      "id": "c09ce2fc-390b-4863-9fc5-d1930b2f2ff1",
      "text": "U.S. government apology (2010) for the Guatemala syphilis experiments, in which U.S.-linked researchers deliberately infected subjects decades earlier."
    },
    {
      "id": "eb6c052e-7bf2-4485-9d67-51aa2085d18e",
      "text": "CDC updates guidance to discourage a test-based strategy for ending isolation, noting people can remain PCR-positive without being infectious"
    },
    {
      "id": "9b6d9a3a-ada9-41e1-b87d-b843716d0776",
      "text": "Published study (Bullard et al.) showing SARS-CoV-2 PCR cycle threshold (Ct) correlates with likelihood of culturing live virus (higher Ct → less likely infectious)"
    },
    {
      "id": "4c401541-ab70-4b74-8c2e-5cd24cc436b9",
      "text": "UNAIDS/Ukraine country report documents a large, growing HIV epidemic in Ukraine (estimated ~238,000 people living with HIV in 2016)."
    },
    {
      "id": "75716968-673d-4617-a46d-a6f490fcd10e",
      "text": "Mass internal displacement after the 2014 conflict: hundreds of thousands of internally displaced persons (IDPs) from Donbas by 2015, disrupting continuity of care."
    },
    {
      "id": "503e9999-94ea-4dcd-8c73-e9fc77be30d1",
      "text": "WHO interim guidance recommending postponement of mass vaccination campaigns and adaptation/prioritization of immunization services during COVID-19"
    },
    {
      "id": "98240cd1-a78c-4795-9c7d-26b9f65b0f6a",
      "text": "WHO and UNICEF joint press release warning of an alarming decline in routine childhood vaccinations worldwide"
    },
    {
      "id": "499c415d-6d0e-405a-92ea-56852a59047b",
      "text": "Ukraine erected flow-control measures/temporary dam in Kherson/Kalanchak to cut canal deliveries to occupied Crimea (2014)"
    },
    {
      "id": "bf525db6-d0fe-4882-9a12-8adcd84a4fd8",
      "text": "Academic/technical assessments documenting socio‑economic and environmental impacts of Crimea's water shortages (peer‑reviewed/technical publications 2016)"
    },
    {
      "id": "de69b62a-c856-4aa7-9a3e-3fafbd094da4",
      "text": "Municipal regulations (Plan Especial del Centro Histórico and local ordinances) prohibit unauthorised banners/flags on protected facades; the town hall cited these rules when ordering removal."
    },
    {
      "id": "944b2729-f7d8-4888-b155-b4742dfa7d8e",
      "text": "Clinical/dental literature and reviews (including proposals to use povidone‑iodine nasal/mouth preparations) circulated in spring 2020 reporting in‑vitro virucidal activity of certain antiseptic oral rinses against SARS‑CoV‑2."
    },
    {
      "id": "ccfb3e7c-5f10-4ff4-9e50-b7367383ee17",
      "text": "Regulatory and market environment: reports of unproven oral-spray and supplement COVID claims and subsequent enforcement/crackdowns (e.g., China crackdown on adverts making antiviral claims for oral sprays) in spring 2020."
    },
    {
      "id": "5602e0f4-d219-40d1-b7cf-dc9a28d01309",
      "text": "September 2021 reports that foreign/stainless‑steel particles were found in some Moderna vaccine vials in Japan and several lots were suspended."
    },
    {
      "id": "8f4acf67-0350-4998-bea5-99144f2284fc",
      "text": "Russian formal ban on imports of Ukrainian food products (announcement reported November 2015)"
    },
    {
      "id": "0cd4f6a5-2bfa-4bb5-97c4-0f00629d8196",
      "text": "Ukrainian activists impose a land and transport blockade of supplies into Crimea"
    },
    {
      "id": "a191825f-6de9-4d87-8a4d-30409d13d4b4",
      "text": "IPCC AR5 (WG1) chapter on oceans noting that the oceans have absorbed the vast majority of excess heat from global warming"
    },
    {
      "id": "90a516e1-5fec-49da-9932-7d18620d8b22",
      "text": "UKHSA update on scarlet fever and invasive Group A streptococcus noting increased cases in children"
    },
    {
      "id": "4eacb1da-29c5-4742-acfc-7218c4550e65",
      "text": "Event 201 pandemic tabletop exercise (Johns Hopkins / World Economic Forum / Bill & Melinda Gates Foundation)"
    },
    {
      "id": "02afaa47-b21e-459d-acce-148ab6f92cf0",
      "text": "FDA and public‑health warnings against internal use of high‑strength hydrogen peroxide (35% 'food grade') and warning letters to vendors."
    },
    {
      "id": "c49fb060-81cd-4e18-802d-4101bbcaf813",
      "text": "Russian President Vladimir Putin asks the Federation Council to authorize the use of Russian armed forces in Ukraine; authorization granted"
    },
    {
      "id": "3dbbe6c8-09df-4e25-b23c-5e7cc9d7526d",
      "text": "Ousted Ukrainian president Viktor Yanukovych reportedly sends a letter requesting Russian assistance"
    },
    {
      "id": "f8f68b07-5c9e-42b8-b2ab-2883893a0e69",
      "text": "ICJ advisory opinion on Kosovo's declaration of independence (found not to violate international law)"
    },
    {
      "id": "c379708e-1d1f-4214-910d-94840f38fee8",
      "text": "Armed men seize the Crimean parliament building and raise the Russian flag"
    },
    {
      "id": "945e80be-a5a3-4199-b65a-3bece6b7699a",
      "text": "EU representatives agree (Council conclusions of 20 July 2015) to resettle 22,504 persons in need of international protection from outside the EU (including Middle East, North Africa and Horn of Africa)"
    },
    {
      "id": "4cb6beca-973b-40dc-b67c-0064201fba5e",
      "text": "European Commission proposes mandatory relocation of 40,000 asylum-seekers from Italy and Greece"
    },
    {
      "id": "df1e89aa-6e0c-49cb-bd7b-b0657dff90a5",
      "text": "Strong public opposition from several member states (Visegrad group and others) to EU relocation/quota proposals in mid-2015"
    },
    {
      "id": "24b77652-38fd-4c08-8b22-a14a1d9a2811",
      "text": "Hungary orders closure of its border with Serbia and begins building a fence to stop migrants"
    },
    {
      "id": "7342c0b7-9bb6-45ae-8c6c-294a3543c93d",
      "text": "April 2015 Mediterranean shipwreck off Libya killing hundreds of migrants"
    },
    {
      "id": "ac75ab80-c1ac-450f-9d26-54e49897e0d9",
      "text": "Ukraine's Verkhovna Rada formally recognized the 1944 deportation of Crimean Tatars as genocide (resolution passed in November 2015)."
    },
    {
      "id": "a091cb20-bdd6-46a4-b260-73d734a445d1",
      "text": "Ukrainian law and parliamentary debate on the legal regime for 'temporarily occupied territories' (Law No.1207‑VII and related 2014 legislative measures criminalizing collaboration with occupying authorities)."
    },
    {
      "id": "828a1401-a9cd-4280-b0e0-d6113ee19bfd",
      "text": "Russia 'passportised' Crimean residents after the 2014 annexation (widespread issuance of Russian passports), documented by human rights reporting in 2014."
    },
    {
      "id": "5698e2f9-b7f2-4ad2-aeab-4540a3f4a34e",
      "text": "Andriy Senchenko made televised remarks on Shuster Live calling for 'tough' measures toward people who moved to Crimea after Feb 20, 2014 (interpreted as calling for rapid removal)."
    },
    {
      "id": "659afe69-c95b-4fda-a2b4-b48856bad257",
      "text": "Parliamentary Assembly of the Council of Europe (PACE) adopted a resolution (drafted by Michele Nicoletti) that set out mechanisms for reconciling participation rules between PACE and the Committee of Ministers and which media reported could pave the way to restore Russian delegation rights."
    },
    {
      "id": "ac2660ea-85e9-4122-bbc2-278ed03028a9",
      "text": "Pandora Papers and subsequent reporting (Oct 2021) documenting links between Zelensky's circle and offshore companies / expensive property purchases"
    },
    {
      "id": "5170d91f-7079-47ae-9a0d-71d25e98fd09",
      "text": "Earlier 2025 media coverage of Bill Cosby listing a second Manhattan townhouse for sale (about $7 million) amid foreclosure/legal troubles"
    },
    {
      "id": "8e3d0510-fe87-4f90-868a-80eae47ac2ea",
      "text": "Poland says it cannot accept migrants under EU relocation quotas after the Paris attacks"
    },
    {
      "id": "549a2c5d-d36b-424b-bbd6-4767abb2e041",
      "text": "Financial Times analysis highlighting Poland's low intake of Syrian refugees and rising anti-immigrant rhetoric"
    },
    {
      "id": "a57fc600-fd62-4a15-9d6e-e00d1b4108d5",
      "text": "UK government technical note on the impact of false positives and false negatives in the RT-PCR testing programme (operational specificity discussion)"
    },
    {
      "id": "12281cc7-1e7f-4156-9f27-30ed66ab507f",
      "text": "Publication of study linking RT-PCR cycle threshold (Ct) values to culturable virus (Singanayagam et al., correlating Ct and infectiousness)"
    },
    {
      "id": "4c0b373b-ea92-429c-a7ab-0032bb94ca10",
      "text": "Publication and media amplification of the Great Barrington Declaration advocating 'focused protection' (early October 2020)"
    },
    {
      "id": "c74064d8-77a8-4e11-969d-65b7f7a49d54",
      "text": "Swiss Federal Office of Public Health (BAG) / Swissmedic leaflet on COVID-19 testing published (Merkblatt, referenced wording on PCR/NAT)"
    },
    {
      "id": "627b0e61-d6de-45a7-843b-f20cfb2da184",
      "text": "High-profile political minimization and comparisons of COVID-19 to seasonal influenza (examples in March 2020, e.g., statements by then-US President Donald Trump)"
    },
    {
      "id": "ed9b7284-387d-4093-ba08-d501f3fb89ae",
      "text": "US security-assistance packages to Ukraine (e.g., $125M March 2021)"
    },
    {
      "id": "d3396119-d872-44b0-8deb-e5eb249a90b3",
      "text": "Joint NATO/US public warnings calling on Russia to de-escalate (press points April 2021)"
    },
    {
      "id": "7c38c3e8-093f-42b1-8174-9b06a63c1893",
      "text": "DEFENDER-Europe 21 large US/NATO exercises in Europe"
    },
    {
      "id": "4a539e12-4ecb-4728-a340-d11ee79796b0",
      "text": "NATO Brussels Summit communique reaffirming support for Ukraine"
    },
    {
      "id": "b0510283-9cb0-49bd-ba35-369c2de4a045",
      "text": "Publication (September 7, 2022) of experiments showing ivermectin (alone or combined) enhanced paclitaxel efficacy in chemoresistant high‑grade serous carcinoma cell models (Nunes et al., Cancers)."
    },
    {
      "id": "eff633d9-738e-4c7a-af7a-9bf8ef276695",
      "text": "U.S. Department of Health and Human Services ordered millions of doses of the JYNNEOS monkeypox vaccine for response and Strategic National Stockpile delivery."
    },
    {
      "id": "13fcbb30-b184-4dd0-ad67-687bb5a32710",
      "text": "WHO declared the global monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)."
    },
    {
      "id": "7361ba00-780c-4294-83ff-7a605090c8ea",
      "text": "WHO/FAO/WOAH and other agencies published repeated updates and risk assessments about avian influenza (H5Nx) outbreaks and zoonotic risk during 2023–2024."
    },
    {
      "id": "67d491b8-372c-4357-8853-fb6d0e78c0c4",
      "text": "European Centre for Disease Prevention and Control (ECDC) reported an increased circulation/rebound of human parvovirus B19 in multiple EU/EEA countries (public advisory/report)."
    },
    {
      "id": "60e7b0fe-5374-480d-af09-321afee17ed5",
      "text": "Rapid formation and public visibility of volunteer combat units (e.g., the Azov Battalion) in 2014 that appeared at checkpoints, rallies and front-line actions."
    },
    {
      "id": "f9af94f9-d0bd-4905-b27f-8bad1d50532f",
      "text": "Euromaidan protesters occupied Kyiv's Independence Square (Maidan) and established barricades, driving out police during the February 2014 protests."
    },
    {
      "id": "3ac93f54-f31a-40c2-9c9f-89c85be55235",
      "text": "Pro‑Russian separatists seized Sloviansk and other towns in Donetsk oblast in April 2014, setting up armed checkpoints and exercising local control for months."
    },
    {
      "id": "7f2f55cc-063d-4542-a910-41b5995a8b43",
      "text": "Ukraine blocked the North Crimean Canal in 2014 (built a dam/flow-control to stop water to Crimea)"
    },
    {
      "id": "f57edc70-ae95-41b6-aef2-49ea3a1fca81",
      "text": "UN and humanitarian agencies publicly reported reaching and assisting civilians in Sievierodonetsk earlier in 2022 (e.g., UN humanitarian convoy reached Sievierodonetsk in April 2022)."
    },
    {
      "id": "f3a58a27-5f45-44aa-9bf7-bc5c8c2202e2",
      "text": "United Nations had ceased operations in Siverodonetsk by the end of February 2022 (UN office vacated)."
    },
    {
      "id": "28feaf79-870c-4ab7-a66a-2b220c21d5db",
      "text": "Intense Russian shelling and urban combat in Sievierodonetsk in June 2022 produced extensive destruction of civilian and administrative buildings (including fires at the Azot plant)."
    },
    {
      "id": "9da7657c-470e-4730-80ff-14ccdada87c9",
      "text": "Police in Abkhazia (de facto region) seize hundreds of crypto‑mining rigs amid power shortages (reported June 2023)"
    },
    {
      "id": "0087ec71-efef-48bd-a9b0-ad70397607b7",
      "text": "Europol / Ukrainian police arrest cryptojacker accused of mining ~€1.8M (cloud/cryptojacking) in Mykolaiv"
    },
    {
      "id": "9d2a8db7-5155-407d-8436-8d7cee3e5b07",
      "text": "West Midlands Police (UK) uncover bitcoin mining operation stealing electricity at an industrial site"
    },
    {
      "id": "cb11b99e-dea4-44ec-b3f8-b061844a08f2",
      "text": "Global Climate Strikes led by youth (September 20–27, 2019)"
    },
    {
      "id": "e9f283cd-f4a6-4739-97f0-60b479c8c50f",
      "text": "IPCC Special Report on Global Warming of 1.5°C released"
    },
    {
      "id": "cf7273eb-95f6-4d64-8982-3c77a54eb37c",
      "text": "Publication of Nerem et al. (PNAS) reporting statistically significant acceleration in global mean sea level from satellite altimetry (1993–2016)"
    },
    {
      "id": "35b0bed3-1f4d-4d22-9506-3ffde0094728",
      "text": "Release of the IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) summarizing recent acceleration and future sea-level projections"
    },
    {
      "id": "0afc5e37-1078-418e-9712-600d479f1b63",
      "text": "Publication of Houston & Dean (2011) analysis arguing little or no acceleration in U.S. tide-gauge records"
    },
    {
      "id": "dea74892-770e-46a2-b6a0-b224a7cc797d",
      "text": "Peer‑reviewed 2009 review 'Omega‑6 (n‑6) and omega‑3 (n‑3) fatty acids in tilapia and human health' (International Journal of Food Sciences and Nutrition)"
    },
    {
      "id": "44bb52cb-2b43-4b01-8e82-ca3f82d435b9",
      "text": "2013 systematic review 'The omega‑6/omega‑3 ratio and dementia or cognitive decline' (Loef & Walach) summarizing evidence linking n‑6/n‑3 balance to dementia risk"
    },
    {
      "id": "37d99c23-6cd1-45cc-92df-c11680a66be5",
      "text": "Japan finds stainless-steel/foreign particles in multiple Moderna vaccine vials leading to recalls (September 2021)"
    },
    {
      "id": "f2ddd3a0-eaae-49d2-8c91-7e83372075fe",
      "text": "Widespread pediatric RSV and other respiratory virus surges after COVID-19 restrictions lifted (late 2022)"
    },
    {
      "id": "9f027cbc-e19c-4bb5-8261-cabc26180c9b",
      "text": "Noted rise in invasive Group A Streptococcus (iGAS) and scarlet fever among children in late 2022–early 2023"
    },
    {
      "id": "10e8edc7-51fd-4a67-96a7-0b2ec0458508",
      "text": "Publication showing systemic mRNA COVID-19 vaccines induce variable or limited mucosal (IgA) responses"
    },
    {
      "id": "236295a2-6dc4-432c-950b-cd8ec055a997",
      "text": "NATO and Western institutions publicly warn about 'weaponisation of information' by Russia"
    },
    {
      "id": "94db85e1-1e45-488e-961c-1852016eb144",
      "text": "Reuters reported the U.S. was 'poised' to drop opposition and start a process that could eventually send Abrams tanks to Ukraine (policy debate/turnaround coverage)."
    },
    {
      "id": "eacf0c25-ed4c-482d-897c-68a487f7e75d",
      "text": "Germany announced it would supply Leopard 2 tanks and permit partner countries to re-export theirs to Ukraine."
    },
    {
      "id": "c6f0e97b-89d2-4817-8b4b-14549e4f7132",
      "text": "Media coverage warned that even if Abrams were provided, they were 'not expected in Ukraine for months' because of training, logistics and suitability issues."
    },
    {
      "id": "1ba18464-64e0-4a02-b45c-1bcd8fd1fd2f",
      "text": "Widespread attention to provisional NCHS/CDC all‑cause and excess death data for 2021–2022 (public NCHS/CDC provisional death tables and dashboards)."
    },
    {
      "id": "be27228c-d989-4f16-9133-a47c0cc58596",
      "text": "CDC/FDA communications and studies acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID‑19 vaccination in adolescents and young adults (public reporting in 2021)."
    },
    {
      "id": "ad49483c-8b2d-485f-8b1d-4e7c1f885fdd",
      "text": "WHO/air‑quality data (2016) flagged Ukraine among countries with very high air‑pollution‑related mortality"
    },
    {
      "id": "f67d414d-8b31-4350-bc2e-0fc2b65b527c",
      "text": "Investigations and reporting on illegal/low‑quality coal supply in Ukraine (Donbas) documented dirty, unregulated coal entering markets"
    },
    {
      "id": "cdd93ecc-dec3-49d2-8519-57fb729a6a6c",
      "text": "Kyiv officials describe mid‑January haze as a 'meteorological haze' while experts point to coal‑fired heating plants"
    },
    {
      "id": "1eb822b5-1044-4452-9b7d-5da64b2e1637",
      "text": "Central Geophysical Observatory registered elevated formaldehyde, carbon monoxide and nitrogen dioxide levels in mid‑January 2017"
    },
    {
      "id": "57349056-a914-484b-b96a-5e1c0add2dec",
      "text": "State services report monitoring found 'no exceedances' despite public reports of burning smell and breathing problems"
    },
    {
      "id": "d4755858-bd8c-4c93-9c06-e217f923e761",
      "text": "European Parliament approves visa‑free travel for Ukrainians (vote)"
    },
    {
      "id": "1363095c-21ad-4ef8-8981-9d3e06617cf7",
      "text": "EU adopts a revised Visa Suspension Mechanism as a precondition to liberalisation"
    },
    {
      "id": "519c5fae-9511-4646-8e94-46823089e695",
      "text": "Documented large industrial wastewater discharges into the Sea of Azov (Azovstal and other metallurgical plants)"
    },
    {
      "id": "886b25be-3682-4289-925b-472fa91130c0",
      "text": "Scientific and media publications documenting rising pollution and ecological stress in the Sea of Azov (numerical/satellite assessments, 2017)"
    },
    {
      "id": "a2ddcf5d-e29c-4ca6-82b3-bd018543286f",
      "text": "Isolation of toxigenic Vibrio cholerae O1 (Ogawa) from seawater near Taganrog after the 2011 outbreak"
    },
    {
      "id": "48f9f82a-a285-4d1a-9f55-4e78e4a90559",
      "text": "Amnesty International and other human rights organisations publicly highlighted mass graves and documented allegations of torture in recaptured Kharkiv oblast territory"
    },
    {
      "id": "fe3acca7-a1a2-431c-a994-c81bec1ded2c",
      "text": "Passage of Ukraine's decommunization laws (April 2015) increasing attention to removal/renaming of monuments"
    },
    {
      "id": "feeb4bde-2a9f-40ea-b58a-1808e9ea7038",
      "text": "Heightened media coverage and public demonstrations around Stepan Bandera (e.g., anniversary marches) in early 2015"
    },
    {
      "id": "fe75fa37-84c5-45c4-85a9-0b535ade106a",
      "text": "IUCN Polar Bear Specialist Group (PBSG) population estimates and status reporting (Regehr et al. / PBSG updates) releasing updated global population ranges (~22,000–31,000)"
    },
    {
      "id": "a8947dc0-f568-42c5-8ff5-8327af960ae5",
      "text": "General Medical Council (GMC) publishes report on doctors who died while under investigation (report published March 2023; covers deaths through Dec 2022)"
    },
    {
      "id": "70efff1e-de29-4845-8168-e788f396d3f4",
      "text": "FDA/FTC public enforcement and warning letters against companies and individuals selling fraudulent COVID‑19 cures and unapproved therapies (series of letters and press releases, 2020–2022)"
    },
    {
      "id": "9c2b371f-388f-47ee-b206-3e82809389d5",
      "text": "NASA/NSIDC reporting that Antarctic sea ice reached record high extent in 2014"
    },
    {
      "id": "da2933a9-afa9-4f22-bee2-2b77b8a9c354",
      "text": "IPCC Special Report on the Ocean and Cryosphere (SROCC) documents complex impacts of ice melt on ocean circulation and regional climate"
    },
    {
      "id": "c0b1cd72-bf4b-45fc-a1e8-02b82878530e",
      "text": "Nature paper reports fingerprint of a weakening Atlantic Meridional Overturning Circulation (AMOC)"
    },
    {
      "id": "704a2e5b-dcc1-471d-af03-9a5258158cad",
      "text": "IAEA Director General Rafael Grossi publicly called for an urgent IAEA mission to the occupied Zaporizhzhia plant and warned about militarisation (June 2022)."
    },
    {
      "id": "d5ed7a1d-604c-4293-aa09-c48775956696",
      "text": "Satellite imagery and reporting in 2022 showed military vehicles and damage close to key Zaporizhzhia reactors and infrastructure."
    },
    {
      "id": "38caa6b6-11c3-40cb-9ff0-a181a610eb4e",
      "text": "Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the opening days of the 2022 invasion."
    },
    {
      "id": "1da59117-46a6-4dda-bc0b-beea5612a755",
      "text": "Shelling and a fire at a training facility inside the Zaporizhzhia site during the March 4, 2022 assault."
    },
    {
      "id": "db3fa2b4-6e19-4bb1-a206-75c8de9b1a5a",
      "text": "IAEA/Ukraine national reporting on ageing Soviet-era reactors and safety challenges (2005)"
    },
    {
      "id": "4c4999a9-83ad-4b37-af5c-bea47b7609eb",
      "text": "Verkhovna Rada adopts Law No. 6327 on state financial guarantees for medical services (healthcare reform)"
    },
    {
      "id": "93ccacee-2583-4de9-8575-665d987e7ec5",
      "text": "New national classification of professions (reclassification of medical job titles) took effect on November 1, 2017"
    },
    {
      "id": "5b9478ed-b921-456e-af42-1a76ccbf2caa",
      "text": "U.S. FDA issues Emergency Use Authorization for Janssen (Johnson & Johnson) COVID-19 vaccine and publishes EUA fact sheets that reference the PER.C6 cell line used in production/testing."
    },
    {
      "id": "eb586cec-0bd1-4d4b-a6e3-b3ff9fd986cf",
      "text": "Surveillance data showing higher-than-expected HIV diagnoses among people born in Ukraine reported by EU/EEA countries after the 2022 refugee movements (peer-reviewed / public health surveillance summary)"
    },
    {
      "id": "833328b9-c48d-439f-983a-13bfc8de9b56",
      "text": "Russia had banned imports of Roshen products and Roshen faced factory/market disputes in Russia (2013–2014), including Roshen activity tied to Lipetsk"
    },
    {
      "id": "434108ca-f12e-486b-993b-8050154681d9",
      "text": "Poroshenko’s ownership of Roshen and his 2014 pledge to sell/transfer the company after his election kept Roshen highly politicized and newsworthy"
    },
    {
      "id": "69d0969d-9f05-415e-a0ac-fe2a141abd94",
      "text": "Pentagon Inspector General report that about $1 billion in U.S. weapons sent to Ukraine were not properly tracked."
    },
    {
      "id": "d9d6f93d-7229-421e-8b8a-10cc701fb7b5",
      "text": "National Anti‑Corruption Bureau of Ukraine (NABU) announces a large-scale probe into alleged corruption in the energy sector."
    },
    {
      "id": "55e622ec-6a9b-4f53-9e13-2c63b8d4c085",
      "text": "Sean Penn's repeated, high‑profile visits to Ukraine (documented reporting on his November 2021 and subsequent trips)."
    },
    {
      "id": "3bdf0dac-34e7-4c26-a068-02dcae5374c8",
      "text": "Ukraine uncovers embezzlement of nearly $40 million intended to buy mortar shells; arrests and charges announced."
    },
    {
      "id": "4feb4de2-57f8-4d45-98a2-90445dcf8903",
      "text": "Human Rights Watch reports intensifying prosecutions in Crimea accusing Crimean Tatars and others of 'terrorism' or 'sabotage' (2016–2017)"
    },
    {
      "id": "da07339d-e02d-4916-a798-4d30ade2a3af",
      "text": "FSB announces detention of a Ukrainian citizen in occupied Crimea on espionage/sabotage-related charges (Simferopol, February 2018)"
    },
    {
      "id": "50802117-fbd2-4c1c-b79f-3d872b116060",
      "text": "Large explosions at the Kalynivka ammunition depot in central Ukraine, causing evacuations and widespread coverage"
    },
    {
      "id": "44fb80fa-2bf5-4161-ba19-539be4b7a8f8",
      "text": "Exercise Sea Breeze 2018 — multinational naval exercises in the Black Sea co-hosted by the United States and Ukraine (July 2018)"
    },
    {
      "id": "153a0453-50cc-4c08-83cf-fd6773ae36e1",
      "text": "Israeli reports of rising Delta-variant cases with a substantial share among vaccinated people"
    },
    {
      "id": "c7f4ad23-d007-4211-b4dc-1cf6b489c385",
      "text": "CDC updates guidance for fully vaccinated people stating they can often refrain from testing and quarantine (interim guidance released)"
    },
    {
      "id": "9a3d525a-4adb-4cda-827e-d15ade12f31a",
      "text": "Public Health England (PHE) vaccine surveillance reports with age-stratified case tables (week 26 / June 2021)"
    },
    {
      "id": "a8fcce40-59d3-4693-bb0e-d1d791ec5743",
      "text": "Provincetown, Massachusetts July 2021 COVID-19 outbreak where many positive cases were fully vaccinated"
    },
    {
      "id": "32ce1237-00d3-47c7-b25f-75e182d37bd7",
      "text": "Long‑running pro‑Kremlin narrative that 'Ukraine’s armed forces shell Donbas civilians' (disinformation theme dating from 2014) was active in March 2022."
    },
    {
      "id": "5d6da8e3-4367-4339-83c3-b0e5b5db407c",
      "text": "Venice Commission (Council of Europe) issues an opinion urging changes to Ukraine's Education Law over minority-language provisions"
    },
    {
      "id": "243bcd2e-93bd-407b-b8fa-10811871553d",
      "text": "Contextual sensitivity: Bulgaria's Liberation Day (March 3) commemorates liberation from Ottoman rule (historically 1878)."
    },
    {
      "id": "d1a9bab9-76dc-4796-bde7-6a13c17a1bdd",
      "text": "President Erdoğan was on an official African tour (in Guinea) on March 3, 2016."
    },
    {
      "id": "060f49f6-ce30-4b27-a91b-845c676656e1",
      "text": "WMO Greenhouse Gas Bulletin No. 21 reports a record-breaking annual CO2 increase and highlights contributions from continued human emissions plus an upsurge from wildfires and ecosystem feedbacks."
    },
    {
      "id": "a03e9d57-73d4-4bdf-be88-1780212a4ad5",
      "text": "Hunga Tonga–Hunga Haʻapai submarine volcanic eruption (15 January 2022) injected exceptional amounts of water vapor and volcanic gases into the atmosphere and received intense global media coverage."
    },
    {
      "id": "a4bead56-90d4-4f28-8095-8a5d20f8f4f1",
      "text": "Transport & Environment / press coverage (October 2017) of lifecycle studies reporting EVs emit significantly less GHG over their lifetime than diesel"
    },
    {
      "id": "bd2e82a8-49f0-40e5-96fc-8ea991ee5507",
      "text": "European Parliament / EU briefings and research in 2015 documented coordinated Russian disinformation campaigns targeting Ukraine and portraying Ukrainian authorities as corrupt or incompetent."
    },
    {
      "id": "b9024f6a-090d-4bd0-ad59-02b83ef9a31a",
      "text": "Cabinet of Ministers Resolution No. 405 amended rules on 'military-transport duty' allowing requisitioning of vehicles for army needs"
    },
    {
      "id": "4acedc34-7444-4087-8ac8-f0ab81d756e2",
      "text": "High-profile seizure/attention to Viktor Yanukovych's car collection after his ouster in 2014"
    },
    {
      "id": "5b4e4e0c-8d90-4af7-bb86-d6a21c16772c",
      "text": "March 2016 — Large, well-documented mass coral bleaching across the Great Barrier Reef (AIMS/GBRMPA surveys)"
    },
    {
      "id": "74cdc5c7-2bd7-47c8-8917-190eb14b02b3",
      "text": "2019 — 'State of the Climate 2019' (WMO/BoM/CSIRO) and related national summaries documenting global and regional ocean heating and record ocean heat content"
    },
    {
      "id": "6bd4e5df-786a-4eae-8115-052c576a4329",
      "text": "Lisbon Court of Appeal ruling (Portugal) referenced PCR test reliability in a quarantine case"
    },
    {
      "id": "b5755505-20fd-4cdd-be8a-c385417ab02f",
      "text": "Early peer‑reviewed studies showing correlation between PCR cycle threshold (Ct) and viral culture/infectivity (e.g., Bullard et al.) published in 2020"
    },
    {
      "id": "e8b49fdd-51a0-4209-b02c-12aa70cb3d55",
      "text": "WHO information notice reminding labs to follow manufacturers' instructions and consider Ct thresholds (WHO notice for IVD users)"
    },
    {
      "id": "67ff8a4d-3d4c-42ea-a799-b5bf7cfd1c27",
      "text": "CDC announced it would withdraw its EUA request for the original CDC-only RT‑PCR panel (laboratory notice, mid‑2021)"
    },
    {
      "id": "f59198d8-a484-4249-9e4c-cb120eb06ccc",
      "text": "FDA paused enforcement of the in-person dispensing requirement during the COVID-19 pandemic enabling telemedicine and mail distribution"
    },
    {
      "id": "07f79ea0-c692-4baa-9119-0f5368f1d699",
      "text": "Government audit and historical regulatory reporting (GAO report) documenting FDA regulatory decisions on Mifeprex/mifepristone"
    },
    {
      "id": "44646b63-c5a5-421d-a5db-b8bdf9ace828",
      "text": "Anti-abortion medical groups filed Alliance for Hippocratic Medicine v. FDA challenging FDA approval of mifepristone"
    },
    {
      "id": "aaf71c84-1b11-495a-9c4e-cee86667e148",
      "text": "Dobbs v. Jackson Women's Health Organization (Supreme Court decision overturning Roe v. Wade) intensified public debate over abortion"
    },
    {
      "id": "741729c0-95bd-443c-b190-7f90d0ca9e84",
      "text": "Regional NGOs and refugee policy briefs highlight ambiguities about the end or transition of Temporary Protection"
    },
    {
      "id": "87864deb-9b02-400c-9156-594929a9d8fa",
      "text": "Ukraine imposes martial law and restricts men aged 18–60 from leaving the country"
    },
    {
      "id": "0876b24e-ada1-414f-99f5-fbb75a2ce1d8",
      "text": "Ukraine imposes moratorium / signals risk of default on Russian‑held debt (December 2015)"
    },
    {
      "id": "c666a329-62b7-460d-8880-c5f0d94f6cc9",
      "text": "Ukraine's parliament approves the 2016 budget tied to IMF‑agreed deficit targets (conditioning release of IMF tranche)"
    },
    {
      "id": "f270c33e-858b-4306-9fe4-5bd6bfe6a4fc",
      "text": "World Bank forecasts a sharp GDP contraction for Ukraine in 2015 (projected ~12% decline)"
    },
    {
      "id": "6caeaf94-869d-4164-b22a-e0d6cc091305",
      "text": "The 2014 burning of the Odesa Trade Unions House (widely photographed and reported)."
    },
    {
      "id": "323a384e-2961-4844-bb5e-caeb44529087",
      "text": "U.S. Secretary of State Antony Blinken visited Veterano Pizza in Kyiv and was photographed having lunch with Ukrainian officials."
    },
    {
      "id": "b8a644d1-1a59-4a57-a12c-3e97043b444c",
      "text": "U.S. FDA Emergency Use Authorization for the Pfizer–BioNTech COVID-19 vaccine (vaccine moved from trials to public use under EUA in December 2020)"
    },
    {
      "id": "5cad67d2-e08d-4e47-ae5d-3de0c4b4479f",
      "text": "Publication of preclinical animal study results showing BNT162b vaccine candidates protected rhesus macaques (Nature article)"
    },
    {
      "id": "02a16f64-1041-448c-85e0-93941aebabb2",
      "text": "EU Council / Commission adopted visa-free travel for Georgia (short stays up to 90 days)"
    },
    {
      "id": "a8a03368-4889-42d0-b210-bbf16a481d35",
      "text": "EU/agency reporting and media coverage noted increases in asylum/irregular-migration claims from Georgian nationals after visa liberalisation"
    },
    {
      "id": "feee77bd-03c4-4b90-8356-f40b90706c1d",
      "text": "EU revised and strengthened the Visa Suspension (waiver) Mechanism"
    },
    {
      "id": "d1c4ccfc-8cec-44f4-a6b9-efe9f164ab6c",
      "text": "Reports of Chechen fighters present in Donbas fighting alongside pro‑Russian separatists"
    },
    {
      "id": "2cd9142f-905e-4ab8-b3c9-fe284e5e8b02",
      "text": "UN/OHCHR reporting on the presence and inflow of foreign fighters into the conflict in eastern Ukraine (2015)"
    },
    {
      "id": "1cecf870-454e-441f-9f74-fdca57707139",
      "text": "Death of Italian photo‑journalist Andrea Rocchelli while reporting in Donbas (May 2014) and subsequent high‑profile Italian media/legal coverage"
    },
    {
      "id": "dc7674b3-e329-4328-bd62-aabc0cfd248f",
      "text": "Oct. 10, 2023 public statements and policy messaging about balancing U.S. aid to both Israel and Ukraine (e.g., Pentagon/Army leadership urging Congress to ensure resources for both)"
    },
    {
      "id": "f28c2f82-5f27-4b43-a421-02ef44a350cb",
      "text": "Sep. 18, 2023 launch of a high‑profile pro‑Ukraine ad campaign targeting U.S. Republicans (e.g., 'Republicans for Ukraine')"
    },
    {
      "id": "8ee9b76e-0f2d-4f24-a5fb-f63e07db02c1",
      "text": "Earlier Nuland testimony/statements (October 8, 2015) emphasizing sanctions if parties (including Russia) fail to implement Minsk"
    },
    {
      "id": "26476e3e-0255-4374-ad8f-5f995f4d2382",
      "text": "A delegation of Alternative für Deutschland (AfD) regional deputies travelled to Crimea from February 3–9, 2018, despite international protest and the German government distancing itself from the visit."
    },
    {
      "id": "f3c12118-c8a6-4eae-99f9-ad90880ce29c",
      "text": "Russian leadership publicly framed Ukraine as 'Nazi' and claimed a need to 'denazify' it in speeches and statements ahead of the 2022 invasion."
    },
    {
      "id": "0bb33664-bc8c-4f5e-936b-5765fc3b8eb1",
      "text": "Discovery and widespread reporting of civilian killings in Bucha after Russian withdrawal"
    },
    {
      "id": "aecc93d8-f903-49e9-a789-08975bfec032",
      "text": "Repeated reporting of heavy civilian casualties and strikes in Mariupol (including attacks on civilian shelters/theatre)"
    },
    {
      "id": "c213632f-f81d-4a1e-8f04-a90bd92d702e",
      "text": "Russian recognition of the Donetsk and Luhansk 'people's republics' and public accusations against Kyiv"
    },
    {
      "id": "1d77d116-bcdf-49da-a814-c26fc172f941",
      "text": "Kyivstar publicly switched off mobile service in militant-controlled areas of Donetsk and Luhansk (company statement explaining suspension for network integrity and subscriber data safety)."
    },
    {
      "id": "18c8ea30-f6d5-4e01-b748-a6ddae01c225",
      "text": "Previous Ukrainian president Petro Poroshenko publicly called for UN peacekeepers to monitor the ceasefire in Donbas (widely reported)"
    },
    {
      "id": "af79e1ac-966c-4bef-a69b-9adc9093c1eb",
      "text": "Canada’s Operation UNIFIER (training mission) and other Western training/adviser missions in Ukraine beginning in 2015"
    },
    {
      "id": "7ffc3f24-8a49-4463-b575-ccabf41b348b",
      "text": "Large multinational Sea Breeze naval and military exercises in the Black Sea involving Ukraine and NATO partners (summer 2019)"
    },
    {
      "id": "68e2f391-6cae-4e76-9468-e3f4dec7df67",
      "text": "Normandy Format summit in Paris where President Zelensky met Putin and European leaders (significant public peace talks)"
    },
    {
      "id": "f9633764-fbf4-4111-a58c-752a023c9f47",
      "text": "UN Panel of Experts (DPRK) midterm report noting foreign/European components recovered from North Korean missile debris (April 2017)"
    },
    {
      "id": "7ed72f95-8073-41ce-b0bd-ed25d6f99ca1",
      "text": "Public denials from Ukrainian state aerospace firms (Yuzhmash/Yuzhnoye) rejecting allegations they supplied engines or parts to North Korea (Aug 2017)"
    },
    {
      "id": "c56a9adc-dc99-49cb-ac26-2bf255b073a6",
      "text": "Publication of an Online.ua interview with Lieutenant Vsevolod Stebliuk in which he used the word \"raze\" when discussing past destructions (referencing Grozny) and the costs of a forceful retaking of occupied territories."
    },
    {
      "id": "f8165c18-9264-47aa-a01c-0b8c4f073f3c",
      "text": "Public criticism and documented history of REN TV as a channel prone to propagandistic framing (Presidential Council on Human Rights public concerns about REN TV coverage in early April 2017)."
    },
    {
      "id": "bce91ab8-09f7-46e8-bd90-18e20c9bc00c",
      "text": "CDC guidance and FAQs noting that regularly mixing powdered or concentrated infant formula with fluoridated tap water may increase the chance of very mild dental fluorosis in infants"
    },
    {
      "id": "49090a4a-0445-4ea4-a0cd-c4c893b6b2a4",
      "text": "Publication and subsequent media/activist attention to the 2019 systematic review 'Developmental fluoride neurotoxicity: an updated review' summarizing evidence that fluoride can cross biological barriers and reporting associations between early-life fluoride exposure and neurodevelopment outcomes"
    },
    {
      "id": "68dc7eaa-f18f-4ebe-b8a6-9d84a9d89954",
      "text": "Reporting on the economic impact of sanctions on German businesses and trade ties with Russia highlighted pressure from German industry."
    },
    {
      "id": "4ed72a1c-8710-4154-909b-3ddb2ecb8590",
      "text": "Public statements and EU-level reporting in 2016 described the sanctions regime as conditional and tied to progress on Minsk, prompting debate within EU capitals about sequencing and duration."
    },
    {
      "id": "cea3d47c-35f6-414b-a754-8e95a7de3988",
      "text": "Merkel participated in high-profile meetings and talks (including four-way Ukraine talks) with Putin and other leaders addressing the Ukraine conflict."
    },
    {
      "id": "daaf1b89-a36d-435b-8fbe-d84791ad228b",
      "text": "USDA Foreign Agricultural Service publishes a bulletin detailing Russia’s ban, listing affected products and estimating trade impacts for U.S. exporters."
    },
    {
      "id": "407d90f4-5543-4002-bf08-feccffa3e66e",
      "text": "The Moscow Times and other outlets report U.S. poultry and other farm sectors were 'bracing' for Russian retaliation following sanctions earlier in August 2014."
    },
    {
      "id": "7ba3f4f0-ca89-4d70-bd13-db461a2b110a",
      "text": "Reports that some early cultured isolates were shared between labs (e.g., first culture reports referencing Jan 28, 2020 Australian culture and rapid global sharing)"
    },
    {
      "id": "20938efc-458b-4b5d-93c0-0a51a2cfcd1f",
      "text": "Publication of early RT‑PCR primer/probe protocols (short target sequences) for SARS‑CoV‑2 detection (Corman et al., Eurosurveillance)"
    },
    {
      "id": "93210245-0ed3-478e-9610-7f95ab51dbf9",
      "text": "FDA labeling and communications warning that certain parenteral products 'contain aluminum that may be toxic' (premature neonates at risk) for prolonged administration"
    },
    {
      "id": "d2bce9ba-13fd-4487-8da4-1d633fc463f8",
      "text": "Amphastar (phytonadione) product labeling and manufacturer information listing benzyl alcohol and polysorbate 80 in some Vitamin K injectable formulations"
    },
    {
      "id": "7ee3653f-32aa-47b8-9acb-799f35f05c3d",
      "text": "Scientific and review publications and data tables listing aluminum adjuvant amounts across vaccines (showing large variation and values up to ~0.85 mg per dose for some combination vaccines)"
    },
    {
      "id": "b36796d3-aa35-487d-a37f-dccc9d59d67b",
      "text": "International coverage on the financial and social hardships faced by Ukrainian war widows and families (feature reporting on widows’ struggles)"
    },
    {
      "id": "0fffe169-4ede-41cf-b588-2b5433b67d07",
      "text": "Ukrainian investigators and the SBU disclosed a major arms procurement fraud (scheme to buy artillery shells involving nearly $40m embezzlement)"
    },
    {
      "id": "956c2edd-5ea2-4d90-9314-5e85b00a6ce1",
      "text": "OCCRP reporting on SBU arrest of criminals who racketeered/extorted families of fallen soldiers (caught trying to extract money from a widow)"
    },
    {
      "id": "0292cb7d-cd08-428b-b4eb-7dbee8453962",
      "text": "WHO and international coding/ICD guidance on how to record and code COVID-19 on death certificates (emergency ICD codes and guidance issued 2020)."
    },
    {
      "id": "5dfd5799-baac-4921-a943-ef7c64ec847e",
      "text": "Local parish and Bishop Simeon of Vinnytsia publicly moved from the UOC‑MP to the newly formed Orthodox Church of Ukraine (reported as a transfer by parishioners/administration)."
    },
    {
      "id": "a1006103-1fdd-48e7-a258-db0dca424b2c",
      "text": "Ecumenical Patriarch and Ukrainian bishops hold the Unification Council creating the Orthodox Church of Ukraine (OCU)."
    },
    {
      "id": "f6e64bb4-2626-46e9-848c-f77fc7551f29",
      "text": "Crimean leader Sergei Aksyonov publicly acknowledges an unprecedented drought"
    },
    {
      "id": "f4a93dcf-0bdd-4552-a02e-60e6535b598d",
      "text": "International outlets reported chronic water shortages in occupied Crimea (e.g., Al Jazeera feature on water shortage and reservoir problems)"
    },
    {
      "id": "54e56b8b-c19a-4d50-b0cc-2aabd9cc108d",
      "text": "Large-scale war-related disruption to schooling and displacement of children in and from Ukraine was documented by UN/NGO reports (e.g., UNICEF/UN briefings in 2022–2023)."
    },
    {
      "id": "24139cff-94b4-435c-89d8-37bd588d1cd0",
      "text": "PISA 2018 results showed Ukrainian 15‑year‑olds scored below the OECD average in reading, maths and science — a widely reported education result that can be (mis)framed as evidence of low intelligence."
    },
    {
      "id": "737ca22d-17b0-4b71-a1dc-96df8deec3bb",
      "text": "Repeated international reporting on Russian military build-up and base modernization in Crimea (e.g., Reuters special report documenting new/rewamped bases)."
    },
    {
      "id": "d1e1a312-d14f-443e-8ecf-d5749a4e57f4",
      "text": "Kerch Strait incident in which Russian forces seized three Ukrainian vessels and detained sailors."
    },
    {
      "id": "69e8cef3-0f97-4f56-9d24-1c39fea0e151",
      "text": "UN OHCHR monitoring report documents multiple antisemitic incidents in Ukraine (2017)"
    },
    {
      "id": "c205a767-0407-484a-a644-3d2f7095cf27",
      "text": "Nationalist march in Kyiv where some marchers chanted 'Jews out' (reported)"
    },
    {
      "id": "57d38d6f-b4e3-4c4e-a71b-09a0f515f264",
      "text": "Report of vandalism at old Jewish cemetery in Delyatin (swastika and hate symbols painted)"
    },
    {
      "id": "92e94f9c-d067-4f8b-a258-f7d343bd4044",
      "text": "1974–1975 Japan temporarily suspended whole-cell pertussis (DTP) vaccination after reports of infant deaths following vaccination, prompting development and later adoption of acellular pertussis vaccine."
    },
    {
      "id": "6cd113e2-9c3a-4e55-b281-7226cd7b3716",
      "text": "Establishment and public availability of the Vaccine Adverse Event Reporting System (VAERS) in 1990, a passive reporting database where temporal associations between vaccination and events (including infant deaths) can be reported publicly."
    },
    {
      "id": "a9830400-0edf-40b4-b51e-33131d956951",
      "text": "U.S. State Department ordered non-emergency U.S. embassy staff to leave Ukraine and advised U.S. citizens to depart (partial drawdown) amid Russian troop buildup."
    },
    {
      "id": "67f5e913-cd9d-419b-a4e8-8628d477d227",
      "text": "Large-scale Russian missile and drone strikes across Ukraine, including strikes that hit Kyiv's infrastructure and caused blackouts and sheltering of civilians."
    },
    {
      "id": "2f542fe7-1497-4ca8-a4ab-b6647fd05366",
      "text": "Oxford/AstraZeneca paused its COVID-19 vaccine trials after a participant experienced a 'potentially unexplained illness' (routine safety pause announced)."
    },
    {
      "id": "02ef3bf3-20e0-4322-aad1-8462d20ee747",
      "text": "Shelling and strikes on Mariupol reported on Feb 24, with Reuters and other outlets describing residential areas hit and civilians affected."
    },
    {
      "id": "107d5c29-2f33-4fc4-acd6-2fee20c6c791",
      "text": "Airstrikes and reports of Russian naval activity in the Black Sea and attacks near Odesa were reported early on Feb 24, including strikes on coastal infrastructure and claims of naval force movements."
    },
    {
      "id": "adaeae49-d1ad-483e-9b00-5c144f3efe02",
      "text": "Widespread airstrikes and explosions reported in Kharkiv at the start of the invasion, with residents and officials posting footage of strikes and military vehicles in the city."
    },
    {
      "id": "e0bbe7e4-58e6-428f-9c40-667d31c60035",
      "text": "CDC MMWR published early safety monitoring showing reports of allergic reactions and 21 cases of anaphylaxis after first doses of the Pfizer-BioNTech vaccine (dec 14–23, 2020; published Jan 6, 2021)"
    },
    {
      "id": "e8580e4b-012d-486d-b924-72b24ddb93ce",
      "text": "Norwegian health authorities reported deaths in very frail elderly following vaccination with the Pfizer vaccine; media coverage appeared mid-January 2021"
    },
    {
      "id": "e7e18802-a542-4d2d-acfb-bfa827d3f70e",
      "text": "Transfer of centralized medicines procurement to international organisations (UNDP, UNICEF, Crown Agents) as an anti‑corruption measure (2015)"
    },
    {
      "id": "9d7ccf0a-6dca-4a27-a0aa-99c3068c8cb0",
      "text": "Appointment of Ulyana Suprun as Acting Minister of Health amid public controversy over her reform agenda and foreign background"
    },
    {
      "id": "e36cb072-83e2-420d-8cf4-ced1f4fe3938",
      "text": "WHO / European Observatory health system review documenting chronic underfunding, high out‑of‑pocket payments and systemic weaknesses in Ukraine’s health system (2015)"
    },
    {
      "id": "e0167f84-ce1f-4d81-b352-b885ea3a42ac",
      "text": "Publication (medRxiv / PMC entry) of the Yale LISTEN study / related analyses describing self-referred cases of post-vaccination syndrome and immunophenotyping (preprint posted Nov 10, 2023; PMC entry available)."
    },
    {
      "id": "ce51a3b6-4ec1-4741-9641-e65ecd97209b",
      "text": "Reports of black/foreign particles found in some Moderna vaccine vials in Japan, leading to temporary suspension and recalls of lots."
    },
    {
      "id": "7f8a1cf5-7e86-44c6-8963-92a353bfbb76",
      "text": "Publication of Prof. Pablo Campra's technical report claiming Raman/microscopy detection of graphene/graphene oxide in some COVID-19 vaccine samples."
    },
    {
      "id": "fa21c44f-10de-494a-bbbe-7455764fce61",
      "text": "Reporting on volunteer battalions (Azov, Aidar and others) emphasised recruitment of foreign fighters and the existence of organised volunteer units in 2014."
    },
    {
      "id": "450824d4-1392-40e7-b3f9-e852eda731e6",
      "text": "Press coverage of allegations that US-linked private security firms (e.g., reports referencing Academi/Blackwater) had personnel in Ukraine circulated in May 2014."
    },
    {
      "id": "a407f1ea-84a9-4862-9623-d0f02324a925",
      "text": "CDC guidance on serology (antibody) testing noting possible cross‑reactivity with other coronaviruses"
    },
    {
      "id": "1fb6cbaa-6f17-4673-9222-f8aa61df3dfe",
      "text": "OSCE Special Monitoring Mission reported observation of tanks and movements of heavy weapons in eastern Ukraine (daily SMM reports, e.g. 14 April 2015 noted tanks moving near Hirne)."
    },
    {
      "id": "fb1d07b2-9e47-4a10-88aa-536aa36cc193",
      "text": "Regulatory and scientific guidance acknowledging residual host‑cell/production‑related proteins are monitored in biologic manufacture (EMA position statement on residual host cell DNA and host cell proteins)."
    },
    {
      "id": "586ec689-5403-43fe-b4c5-d134115e8f07",
      "text": "Reports of black/foreign particles found in multiple Moderna COVID-19 vaccine vials in Japan, prompting suspension and recall of affected lots."
    },
    {
      "id": "434a0c97-e17d-4d14-97e5-31f3d65ff4c7",
      "text": "MHRA Freedom of Information response stating that the AstraZeneca, Pfizer/BioNTech and Moderna COVID-19 vaccines do not contain any components of animal origin."
    },
    {
      "id": "22930da2-2dab-4788-a79f-737b7cbe2160",
      "text": "Pentagon Inspector General audit (reported Jan 11, 2024) finding about $1 billion in U.S. weapons sent to Ukraine were not properly tracked."
    },
    {
      "id": "a6699444-1c15-4a1b-b989-45e880eb841f",
      "text": "Reuters reporting (Sept 19, 2024) that Congress and the administration were nearing a deal to extend expiring military aid of roughly $5.8–6.0 billion to Ukraine."
    },
    {
      "id": "7fee2983-68d8-4bea-8382-aaf5b47fcd8e",
      "text": "Pentagon press briefing in which Deputy Press Secretary Sabrina Singh discussed expiring authorities and said the Pentagon intends to 'use every dollar and cent' of available authority for Ukraine."
    },
    {
      "id": "0595b59b-0e70-4c72-ad8e-a4d827e02569",
      "text": "Assassination of Andriy Parubiy in Lviv"
    },
    {
      "id": "492a03d8-43e7-45a3-a2e5-13f7ba6ce2dc",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, strongly attributing recent warming to human activities."
    },
    {
      "id": "87a6eddd-368b-4b2c-8ce6-4183e0883d0e",
      "text": "European Space Agency (ESA) Swarm mission publications and press releases reporting an accelerating weakening and expansion of the South Atlantic Anomaly in Earth's magnetic field."
    },
    {
      "id": "b5f6a11b-a40d-4ef3-8f9d-f4de13cd21bc",
      "text": "U.S. government places an approximately $119 million order (option for ~13 million doses) for Bavarian Nordic’s Jynneos smallpox/monkeypox vaccine (reported May 2022)."
    },
    {
      "id": "5284affc-9a33-44ef-a031-0b316285fc1b",
      "text": "WHO declares the multi-country monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)."
    },
    {
      "id": "c9ec4dfe-5a42-4ba1-bee9-2706c05e1576",
      "text": "Reports and government accounts of large unused or expired COVID-19 vaccine stockpiles and write-offs (examples include national write‑offs reported in 2022–2024)."
    },
    {
      "id": "e9996b37-aa80-4b89-958d-cd2794166a31",
      "text": "WHO announces it will adopt 'mpox' as the preferred synonym for 'monkeypox' and phase out the old name."
    },
    {
      "id": "2ea323ee-7eb0-4343-a31e-85470c2314ba",
      "text": "Local authorities' animal-control history and municipal programs noted in press (Kyiv had earlier programs to manage stray animals, and NGOs warned of 'dog hunters' operating independently)"
    },
    {
      "id": "bedd2194-59d1-48fc-86f9-f0234b938fda",
      "text": "Large online petitions launched and amplified claims of planned mass killings (Change.org and other petition platforms) asking EBU, Kyiv mayor and international public to stop dog killings for Eurovision"
    },
    {
      "id": "f185416f-21f7-499d-9024-947736bf13bb",
      "text": "Ukrainian authorities announce seizures and freezes of assets linked to Yanukovych and his entourage"
    },
    {
      "id": "88903702-9d9c-4e73-add2-00c128a3b948",
      "text": "Viktor Yanukovych flees Kyiv and is ousted amid Euromaidan protests"
    },
    {
      "id": "f648189b-ffd4-42ba-80ab-e7d0cb4e0d27",
      "text": "The Soufan Group's June 2014 report documenting large flows of foreign fighters to Syria from many countries, including from the wider post‑Soviet space."
    },
    {
      "id": "44ccc072-a642-46b2-a1ed-e8af44115c6e",
      "text": "Reporting on Chechen fighters active in both theatres (Donbas and Syria) — e.g., Carnegie Endowment analysis 'Chechen Mysteries in Donetsk' (Oct 2014) documented Chechen involvement around Donetsk."
    },
    {
      "id": "cfdf0f43-c18b-4607-b426-1b3665ed9f5d",
      "text": "The Guardian reporting (1 Oct 2015) that Russian state media were shifting attention from Ukraine to Syria, reframing coverage and drawing links between the conflicts."
    },
    {
      "id": "6da6f4c0-936b-4b29-9006-5bf428fde525",
      "text": "CDC recommendation for public use of cloth face coverings"
    },
    {
      "id": "c80aca95-f4ee-4db0-9443-79b99f87f2d9",
      "text": "Publication of Morens, Taubenberger & Fauci analyses concluding secondary bacterial pneumonia caused many 1918 deaths"
    },
    {
      "id": "4275f6cd-180d-40e0-90e7-59efab35c9a6",
      "text": "Russian media / monitoring reports repeatedly amplifying negative narratives about Zaluzhnyi (April 2024)"
    },
    {
      "id": "f3818da0-99d5-4657-ae45-99914fdb6909",
      "text": "French and international coverage from early in the war (March 2022) profiled Ernesto Barbieri (videos/interviews on France 2/Euronews and his YouTube channel), making him a known figure."
    },
    {
      "id": "70ace6f5-ba45-4bcf-8217-e6dd2bb2b27e",
      "text": "Adoption of the 2012 \"On the Principles of State Language Policy\" (Kolesnichenko–Kivalov law) granting expanded regional status to minority languages"
    },
    {
      "id": "11f8aac3-1ffa-48e7-80f7-f68918c4a2ad",
      "text": "Public complaints and statements by Hungarian organizations and diaspora groups about the situation of ethnic Hungarians in Transcarpathia (AHF statements and local reporting, March 2014)"
    },
    {
      "id": "91062d1e-d101-49f1-9191-a3f8b2dbbc0c",
      "text": "Public OSCE monitoring and commentary on minority-rights tensions in Ukraine (OSCE updates and reporting, mid‑2014)"
    },
    {
      "id": "ae95c7d1-8919-48a3-b7af-269c6f2fd92b",
      "text": "Verkhovna Rada vote to repeal the 2012 language law (attempted repeal, 23 February 2014)"
    },
    {
      "id": "185c2416-6c1c-4899-82c6-53a5a453c87e",
      "text": "Analyses and reporting on cross‑border tensions (KyivPost feature coverage of Transcarpathia and Hungary‑Ukraine disputes, 2014)"
    },
    {
      "id": "5570d93e-328c-4a37-84e4-2e8f29e8928f",
      "text": "U.S. government agencies and NASA suspended or curtailed certain cooperation with Russia in response to the 2014 annexation"
    },
    {
      "id": "96dec6e5-f568-4d57-812f-b87d6c8daf10",
      "text": "National Geographic announced it would show Crimea as part of Russia on its maps following the 2014 annexation debate"
    },
    {
      "id": "2aa899b0-a95e-44e8-8f1f-d08495395787",
      "text": "Human Rights Watch and other observers reported steps by Ukrainian authorities in 2015 restricting access (e.g., blacklists, travel/media restrictions) for certain journalists and commentators."
    },
    {
      "id": "bd90e9ad-9d3e-4cf4-bd00-4ea1d6f8be9a",
      "text": "Earlier in 2015 Ukraine moved to block multiple Russian TV channels (press/ regulator actions widely reported, e.g., April 2015 ban of 14 Russian channels for 'propaganda')."
    },
    {
      "id": "85966416-7d92-405c-bc31-56bbbd8253e8",
      "text": "Series of lithium-ion battery fires at Convergent Energy storage sites in Warwick, New York (multiple alarms and containment responses reported June 26–27, 2023), prompting local media coverage and community concern."
    },
    {
      "id": "b6ca2d96-e2af-4332-8644-c3bbbd11b213",
      "text": "LG Chem (RESU) residential energy-storage battery recall(s) following multiple reports of overheating and fires in home battery units (recalls/public warnings issued December 2020 and expanded in 2021)."
    },
    {
      "id": "21277a00-c4c4-43b8-ae10-036e94a1c107",
      "text": "IMF approval of a large Extended Fund Facility for Ukraine (US$17.5 billion) in March 2015, accompanied by IMF warnings about the banking sector's contingent liabilities and need for recapitalization."
    },
    {
      "id": "4e69c14f-7443-4d0a-af69-5182a6c98b4d",
      "text": "National Bank of Ukraine (NBU) extended loan repayment periods and implemented emergency liquidity measures to support banks under strain."
    },
    {
      "id": "3a13ed57-ac5e-43c8-90bf-8cd66bf6f503",
      "text": "Credit-rating agency downgrades of major Ukrainian banks (e.g., Fitch downgraded PrivatBank and ProCredit's viability ratings in December 2014)."
    },
    {
      "id": "c91195b0-2dd3-4cc4-bdd0-48f3f2bdbdb4",
      "text": "Ukraine's hryvnia plunged after the central bank abandoned foreign currency auctions, triggering sharp currency devaluation and market panic."
    },
    {
      "id": "74caf7c4-d50f-4495-8c68-52fe77e6cf1d",
      "text": "Central bank closures and a wave of bank shutdowns during the 2014 financial turmoil in Ukraine (multiple banks shut or declared insolvent)."
    },
    {
      "id": "47582a6e-7aee-49e6-9a90-70c25b54b570",
      "text": "Official recommendations to offer COVID‑19 vaccination to pregnant and lactating people (ACOG/CDC guidance issued in December 2020 and subsequently maintained)."
    },
    {
      "id": "6e95a689-eb28-4092-8f24-54d8232f394e",
      "text": "NCHS provisional report showing a 3% rise in the U.S. infant mortality rate for 2022 (first year‑to‑year increase since 2001–2002)."
    },
    {
      "id": "66307a24-6752-47c1-b14e-19ba5f2f2e2b",
      "text": "Peer‑reviewed VAERS analysis summarizing adverse event reports in pregnant people (covers reports through April 1, 2022) published in European Journal of Clinical Pharmacology (PMC)."
    },
    {
      "id": "e1188dc5-0c3a-40ea-b10c-c1a4ce18f3f9",
      "text": "Published evidence of waning vaccine effectiveness and breakthrough infections in Israel"
    },
    {
      "id": "aba505df-97c2-44ee-af3c-185123d8d571",
      "text": "Japan suspended and recalled Moderna vaccine batches after discovery of foreign particles"
    },
    {
      "id": "e00d5c72-1582-479f-9bcc-d377cd91304b",
      "text": "CDC changed mask guidance in May 2021 allowing fully vaccinated people to stop wearing masks, then later revised recommendations as variants spread"
    },
    {
      "id": "ccca6a2c-bbf6-41c6-b927-d092d6835a64",
      "text": "Local Ukrainian authorities reported civilian casualties and injuries from the July strikes"
    },
    {
      "id": "73eb341e-b0a3-419e-8644-315fefca12f8",
      "text": "UN Secretary-General and UN spokesperson publicly condemn reported strikes on Odesa"
    },
    {
      "id": "0f36c619-8e14-445d-9ff6-652907201f8d",
      "text": "Istanbul 'grain corridor' agreement signed between Russia, Ukraine, Turkey and the UN"
    },
    {
      "id": "e85fec14-f53d-4f03-8782-2d509817cdcf",
      "text": "Missile strikes hit Odesa port and city (reported by multiple outlets)"
    },
    {
      "id": "560e0e32-05d2-442c-8f26-f2984ba3dda8",
      "text": "Several countries temporarily suspended use of the AstraZeneca COVID-19 vaccine in mid-March 2021 while regulators investigated rare clotting reports."
    },
    {
      "id": "3c065b5a-a536-4694-be46-2fa75a6abad9",
      "text": "FDA Vaccines and Related Biological Products Advisory Committee briefing document for Moderna (mRNA-1273) published, including detailed safety/reactogenicity tables from phase 3 trial."
    },
    {
      "id": "32c16bd5-4905-4d1f-9dc9-527ca0e29b56",
      "text": "Public-facing CDC guidance summarizing common, expected side effects after COVID-19 vaccination (local pain, fatigue, headache, fever)."
    },
    {
      "id": "c0954b16-8dca-44c9-9bc8-66debbd14700",
      "text": "UNICEF and WHO confirmation and public statements about a circulating vaccine-derived poliovirus type 2 (cVDPV2) outbreak in Sudan and coordinated vaccination response."
    },
    {
      "id": "5cdb36f6-ae0d-4c33-85a4-c023f5d57ee9",
      "text": "Reporting in October 2023 documented an uptick in Russian strikes and drone attacks on Ukraine's rail network and passenger trains."
    },
    {
      "id": "9d29c1dd-4f43-4ab8-88f8-11e3b2827272",
      "text": "Ukrzaliznytsia publicly announced introduction of undercover 'railway safety marshals' working on stations and trains."
    },
    {
      "id": "1e1a3c21-bcf0-4394-89a7-ce8a6ebb377c",
      "text": "CDC updates guidance on May 13, 2021 saying fully vaccinated people could resume activities without masks or physical distancing in most settings."
    },
    {
      "id": "2a85d5f1-e5cc-45b3-a1b3-97e6e9999e08",
      "text": "CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing a high proportion of cases in fully vaccinated people and evidence of possible transmission from vaccinated individuals."
    },
    {
      "id": "9935cc06-404f-446f-ab6b-5ab2fb7602ee",
      "text": "UK Health Security Agency and related UK analyses in July 2021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant while retaining protection against severe illness."
    },
    {
      "id": "429193ad-842f-44da-afc5-3dec6e99744f",
      "text": "U.S. officials publicly sought funds and announced plans to test and develop ground‑launched intermediate‑range missiles after INF collapse"
    },
    {
      "id": "ecdd329a-e084-4edb-97b8-6cd18aef672b",
      "text": "NATO publicly stated Russia was in material breach of the INF Treaty"
    },
    {
      "id": "5571cb87-63cc-47c7-8d84-d91f1754a41d",
      "text": "Trump administration announced suspension of U.S. obligations under the INF Treaty and delivered six‑month notice of withdrawal"
    },
    {
      "id": "58187aec-19c3-49ac-b926-cc221022d989",
      "text": "FactCheck.org SciCheck explainer on what VAERS can and can't do (widespread June 2023 coverage)"
    },
    {
      "id": "5d78dde1-be3f-4bf2-ba05-56ce0a3bd4f4",
      "text": "Italy and some Italian officials publicly criticized the EU and fellow member states for a slow and inadequate early response to Italy's COVID-19 crisis."
    },
    {
      "id": "c304c132-ef7f-42b3-add5-d5b7d3fb88a5",
      "text": "U.S. officials publicly accused Russia of running a coronavirus disinformation campaign (statements reported in February–March 2020)."
    },
    {
      "id": "66349fdb-aedd-4e71-bc33-b55b90c3a03c",
      "text": "UKHSA (PHE) published weekly COVID-19 Vaccine Surveillance Report (Week 43) containing counts of cases, hospitalisations and deaths broken down by vaccination status."
    },
    {
      "id": "f83bdf2e-7c16-426a-9bf7-f80d7cb0bb3c",
      "text": "Reports of contamination (black/stainless-steel particles) found in batches of Moderna COVID-19 vaccine vials in Japan; large numbers of doses temporarily suspended/withdrawn."
    },
    {
      "id": "21859aaa-2d71-4c1a-8366-63800b3db547",
      "text": "CDC guidance recommending vaccination as part of hurricane preparedness (site guidance last reviewed)"
    },
    {
      "id": "3bc6fa9c-20b7-4020-a917-396b142d7587",
      "text": "Clashes and beatings during spring 2014 rallies in Kharkiv where pro‑Russian activists and counter‑protesters attacked each other and journalists were beaten."
    },
    {
      "id": "ca5532c8-cdca-4755-8314-fa874bb46c3c",
      "text": "Investigative reconstructions (Bellingcat, Jan 28, 2015) of May 9, 2014 violence in eastern Ukraine documenting how video fragments and poor sourcing can produce misleading narratives."
    },
    {
      "id": "73c9e515-b050-482c-a37c-960afe733109",
      "text": "OHCHR periodic reports documenting alleged human-rights violations in Ukraine (2014)"
    },
    {
      "id": "37a4f01b-94b1-423e-80e0-2683732abcb9",
      "text": "Ukraine accepts International Criminal Court (ICC) jurisdiction for alleged crimes (ad hoc declaration)"
    },
    {
      "id": "bda421f3-b15a-4ef0-8627-b9e4ff9795af",
      "text": "UN General Assembly adopts Resolution 68/262 on the territorial integrity of Ukraine"
    },
    {
      "id": "cb67794a-bd78-40b6-b30e-648c7caea549",
      "text": "CDC publishes guidance and reporting mechanism on vaccine breakthrough infections and explains expected breakthrough cases as vaccination coverage rises"
    },
    {
      "id": "f2c01a33-1ddc-412a-ad6e-7b1540c343bf",
      "text": "CDC designates California variants B.1.427/B.1.429 (CAL.20C) and reports potential reduced susceptibility to antibodies"
    },
    {
      "id": "95a03a51-dbf0-403d-90f9-f300942b3ba2",
      "text": "Laboratory studies report reduced neutralization of certain variants (eg. B.1.351) by vaccine-elicited or convalescent sera"
    },
    {
      "id": "1b4a205b-74f1-44bd-81fe-e1ce90cf9854",
      "text": "News coverage of the emergence and spread of CAL.20C (B.1.427/B.1.429) in California"
    },
    {
      "id": "9d0b0b48-481f-4015-8133-45d4dc81c3c2",
      "text": "Detection of porcine circovirus (PCV1) DNA in Rotarix and regulatory review (2010)"
    },
    {
      "id": "ed5a38cd-1053-4c15-a8ee-77255d3682a0",
      "text": "Widely cited medical review summarising clinical uses of activated charcoal in poisoning and emergency medicine (accessible on PubMed/PMC)"
    },
    {
      "id": "906b4a52-a777-4545-92dc-c04cf5c063ac",
      "text": "Local/national news coverage warning experts about the TikTok 'parasite cleanse' trend and the use of 'binders' including activated charcoal"
    },
    {
      "id": "cbe55de5-2caf-43ee-ba13-5ad9e99bd3d3",
      "text": "Turkish naval leadership and media reported ambitions to develop nuclear-powered submarines under the national MILDEN program and discussed cultivating reactor expertise domestically."
    },
    {
      "id": "cc635954-d212-406c-af7b-64d61e9232a7",
      "text": "Rosatom and Turkish authorities advanced the Akkuyu nuclear power plant project; Rosatom announced the first unit entered commissioning-stage work and earlier delivered fuel components."
    },
    {
      "id": "5fc8c4c4-d8df-4a71-bfab-f21ac22ba5d5",
      "text": "Turkish ministers (including Foreign Minister Hakan Fidan) visited Niger and signed a provisional agreement to enhance energy and mining cooperation, reported as an effort to secure uranium supplies."
    },
    {
      "id": "f3bcdfdc-f86a-49ca-b399-1aabe7da2bbc",
      "text": "Foundation for Defense of Democracies (FDD) published an analysis titled 'FAQ: Is Turkey the Next Nuclear Proliferant State?' outlining potential Turkish moves (e.g., securing uranium, expanding fuel-cycle capabilities) that could — in theory — support future weapons work."
    },
    {
      "id": "23f4ac65-fc79-4c77-a7d0-07d4377b7d20",
      "text": "President Erdoğan publicly questioned why some countries have nuclear weapons while others cannot, saying “this, I cannot accept” in a speech to his party."
    },
    {
      "id": "446b57ea-cf92-4a32-b8cb-8b784adc0166",
      "text": "CDC/FDA VAERS surveillance paper (Vaccine) published summarising VAERS reports in pregnant persons (Dec 2020–Oct 2021), noting 12 neonatal deaths reported but concluding crude reporting rates were below background."
    },
    {
      "id": "50663370-4f1d-4512-8b35-0ed7418f2bf4",
      "text": "Reports in September 2021 that black/foreign particles were found in some Moderna vaccine vials in Japan, prompting suspension/recall of specific lots."
    },
    {
      "id": "5b1e3132-4460-4a38-8cb3-ff9a2ac8826a",
      "text": "Annalena Baerbock's remarks at the Forum 2000 panel in Prague where she said, in English, a line widely quoted as 'no matter what my German voters think' during a discussion on support for Ukraine."
    },
    {
      "id": "80f2656e-a02e-4cab-beb2-a1f99619cefe",
      "text": "Japan identified black/stainless-steel particles in multiple Moderna vaccine vials leading to recalls and temporary halts (reported September 2021)."
    },
    {
      "id": "b085f7e0-13f6-45fa-a7b9-aeeda8e4bb0b",
      "text": "FDA inspection and public reporting on Emergent BioSolutions Baltimore plant problems that ruined millions of J&J vaccine doses and cited sanitation/cross-contamination concerns."
    },
    {
      "id": "aa7c1c7f-0d44-49c5-ae8e-b066be962441",
      "text": "Scientific reviews and debates about Simian Virus 40 (SV40) and its detection in some human tumors (literature reviews summarizing associations and uncertainties)."
    },
    {
      "id": "66ad7bc0-9ff5-4228-a9e6-565bf22c9f50",
      "text": "Vestas press release (8 February 2023) announcing a new chemical recycling approach and reporting steps toward recycling end-of-life blades (including a 2022 figure of recycled blades claimed by the company)"
    },
    {
      "id": "3fa896da-b3be-44c8-85b3-060314d71ec8",
      "text": "American Clean Power (ACP) white paper 'Decommissioned Wind Turbine Blade Management Strategies' (ACP/industry analysis) documents that current end-of-life options are limited and that landfill is often the lowest-cost route"
    },
    {
      "id": "aac764ea-a66b-4f31-941d-ffbb819af7d0",
      "text": "University of Strathclyde 'PRoGrESS' blade recycling pilot (project launch and pilot development, 2022–2023) to separate glass fibre from resin and commercialise recycling methods"
    },
    {
      "id": "b2e5de87-855f-4995-8336-4d6a9399c505",
      "text": "CNN long-read on blade waste (May 2023) highlighting viral images of piles of decommissioned blades (e.g., Casper Regional Landfill) and describing the growing volume of blade waste"
    },
    {
      "id": "10b1b3a9-c651-481a-b1e1-63205a836346",
      "text": "Reports in September 2021 of contamination/foreign particles found in some Moderna vaccine vials in Japan and temporary recalls/collection of affected batches"
    },
    {
      "id": "42c459b3-603b-4fea-b100-496e7c644a74",
      "text": "CDC and other agencies reporting rare myocarditis/pericarditis cases after mRNA vaccination (June 2021) and subsequent media coverage noting hospital admissions for evaluation and treatment"
    },
    {
      "id": "84349328-6cbe-4c1f-93c4-830596e9ea8e",
      "text": "Release of UK Health Security Agency (formerly PHE) vaccine surveillance reports showing that a high proportion of COVID-19 hospitalisations/deaths in autumn 2021 were among fully vaccinated people in older age groups"
    },
    {
      "id": "31e6662a-c5e2-4acf-8ce6-df814b728b1a",
      "text": "Published Israeli analyses and policy statements (mid–late 2021) documenting waning protection from two doses of BNT162b2 and the decision to roll out third-dose boosters"
    },
    {
      "id": "ca55d25a-0401-4df1-936a-1376aebf51d6",
      "text": "Germany reintroduced internal border controls with Poland, Czechia and Switzerland (official notification to EU)"
    },
    {
      "id": "139daf56-007b-42d6-aa9b-9b1cfcbaf5a6",
      "text": "Reports and footage of German police cracking down on illegal crossings at the Polish border"
    },
    {
      "id": "e4816de5-8656-4e3a-8adb-cc3827118755",
      "text": "UNESCO recommendation that the Great Barrier Reef should be listed as 'in danger'"
    },
    {
      "id": "bf10343b-f909-43fd-af82-06c1e21d46dc",
      "text": "AIMS Long-Term Monitoring Program Annual Summary Report (2019/20) showing regional increases in hard coral cover"
    },
    {
      "id": "b852f69b-afb4-4dfb-af15-e891f23b224d",
      "text": "New York Times: Coverage of fewer tourists and clearer reef images during COVID-19"
    },
    {
      "id": "c63eced6-5d16-4f1e-88a0-0091665a90c0",
      "text": "NWCG publishes PMS 501 (Standards for Aerial Ignition) including Appendix B covering helitorch operations and training materials"
    },
    {
      "id": "66be13c3-6124-4d46-9fbd-e2f1aae2457a",
      "text": "Australian Department of Defence confirms Orroral Valley bushfire was likely started by an Army helicopter landing light (investigation / press release)"
    },
    {
      "id": "f222f463-960a-41c7-8add-ca05baf14cdf",
      "text": "NSW National Parks posts video documenting a trial of a helicopter-mounted drip torch (aerial drip torch/helitorch) used for hazard reduction in Kosciuszko National Park"
    },
    {
      "id": "b0eae12c-8aea-4fd6-ad6e-c46f1e03cf3b",
      "text": "Media reporting in 2023 on expansion and tightening of mobilization and medical‑fitness procedures (Ministry of Defence changes to the Regulations on Military Medical Examination, referenced in coverage of Order No.490)."
    },
    {
      "id": "5e77b394-bb3a-4aa7-96b7-903d5eb45d32",
      "text": "Major international coverage during 2023 reported a sharp rise in Ukrainian war amputees and stories about some wounded servicemen returning to roles after prosthetics and rehabilitation (BBC feature on amputees)."
    },
    {
      "id": "8c107dd6-605d-4017-a9bd-33e6ba2712aa",
      "text": "Human Rights Watch publishes findings that cluster munitions were used by Ukrainian forces in populated parts of Donetsk in October 2014."
    },
    {
      "id": "2e7877d8-7bc2-44aa-97f3-885ee1f7b7c8",
      "text": "Human Rights Watch warns that unguided Grad rockets used in populated areas in eastern Ukraine led to civilian deaths and injuries."
    },
    {
      "id": "92170761-229f-4faa-9360-128f73ee18ea",
      "text": "Multiple international news outlets reported deadly shelling incidents in Donetsk (e.g., bus-stop and residential strikes in January 2015) with both sides trading blame."
    },
    {
      "id": "8d56a805-acf8-4a80-b4f7-742343c9065c",
      "text": "OSCE SMM spot report documents residential buildings in Donetsk severely damaged by artillery fire observed by monitors."
    },
    {
      "id": "a1cec6e8-9f55-45dc-8b12-ac0c718e1958",
      "text": "Royal College of Physicians report 'Nicotine without smoke: Tobacco harm reduction' endorsing e-cigarettes as a reduced-harm alternative."
    },
    {
      "id": "339603cf-d217-443d-84aa-919573e582a3",
      "text": "2019 EVALI outbreak (vaping-associated severe lung injury) and CDC investigation/public reporting."
    },
    {
      "id": "2cbcdcf5-3172-4520-9520-fe93506b4118",
      "text": "Publication of peer‑reviewed study detecting chlormequat in U.S. foods and urine samples (Temkin et al.)"
    },
    {
      "id": "38efc9d6-8d2c-44e2-b8ef-a3cfcec9d8ab",
      "text": "2019 mainstream reporting on glyphosate (Roundup) residues in oat‑based cereals (including Cheerios/Quaker)"
    },
    {
      "id": "740097a6-3475-4c42-a063-6d57bd424dce",
      "text": "2019 consumer lawsuits and complaints over 'natural' labeling after pesticide detections in Quaker/other oat products"
    },
    {
      "id": "fafefd80-e2e8-4b59-8a21-8df1b96decf8",
      "text": "Earlier vaccine contamination/quality incidents (Japan pauses Moderna batches over foreign particles, Aug 2021)"
    },
    {
      "id": "8eb4cb0e-7b9a-4f13-8e1a-da24d629fdfa",
      "text": "FDA Emergency Use Authorization announcement for Pfizer pediatric dosing (3 μg) for ages 6 months–4 years"
    },
    {
      "id": "3549f487-ce14-40df-b2d6-fcc4513c8785",
      "text": "Global OPV 'switch' (withdrawal of type‑2 component) and related operational challenges — April 2016"
    },
    {
      "id": "f6716a58-9b2f-455c-90ca-18000499c8fd",
      "text": "Suspension of mass polio vaccination campaigns during the early COVID‑19 pandemic — March 2020"
    },
    {
      "id": "e6253f6d-ecac-49af-9e41-e9fabbfd8e44",
      "text": "Official appointment of Andriy Shevchenko (politician) as Ukraine's Ambassador to Canada"
    },
    {
      "id": "fe1f81b2-1744-41f8-b4e4-aabc8202821e",
      "text": "High public profile of footballer Andriy Shevchenko (former Ukraine/AC Milan striker; Ballon d'Or 2004)"
    },
    {
      "id": "f2d0d656-bd3e-4ab3-a57e-5277628a2f0f",
      "text": "Federal judge orders FDA to speed release of Pfizer COVID-19 vaccine documents (55,000 pages/month)."
    },
    {
      "id": "004e3aa8-4727-4367-8257-4ebff0af8a68",
      "text": "News reports that the United States and many European countries would not send representatives to Vladimir Putin’s May 7, 2024 swearing‑in ceremony."
    },
    {
      "id": "82c9f4b5-c38c-451a-8ad2-14f8edcc6b84",
      "text": "U.S. State Department March 19, 2024 press statement ('On Russia’s Presidential Elections') that criticized the election as undemocratic while discussing the outcome and Russian leadership."
    },
    {
      "id": "03a0c294-e976-4333-841a-97588c9807cd",
      "text": "FTC and FDA/FTC enforcement actions against companies marketing supplements as diabetes treatments (joint warning letters / cease-and-desist demands)."
    },
    {
      "id": "cf85300d-422f-4309-8986-fbd3de9faa9e",
      "text": "Publication of systematic reviews / meta-analyses (e.g., berberine) showing modest glucose‑lowering effects of certain supplements."
    },
    {
      "id": "64a9d99e-8e91-4678-aa7f-b728bd5c53b2",
      "text": "Reporting of budget pressures and cuts to municipal funding in Italy (municipalities face first funding cuts in years)"
    },
    {
      "id": "80af9af0-d58c-4a6e-ac4f-b9c6247b5718",
      "text": "Pentagon Inspector General report that around $1 billion in U.S. weapons sent to Ukraine were not properly tracked (publicised January 2024)"
    },
    {
      "id": "ec64a4a4-f829-484d-8869-7c9eb4db9c7e",
      "text": "Italian government approvals/extensions of multiple military/financial aid packages to Ukraine (ongoing through 2023–2024)"
    },
    {
      "id": "bbb5cc6b-3b9d-484e-85ce-d24c3c292f70",
      "text": "Partial collapse of the medieval Torre dei Conti during restoration work in central Rome"
    },
    {
      "id": "d67d3d85-394c-406e-82a3-52cfde1c0d91",
      "text": "IPCC Special Report on Global Warming of 1.5°C published and widely reported"
    },
    {
      "id": "ecbd4e9f-56e6-4e10-9bd2-e280c4a7a058",
      "text": "CDC and other agencies publicly reported and investigated rare myocarditis/pericarditis signals after mRNA vaccination (mid‑2021)"
    },
    {
      "id": "dc94773d-e525-4ece-af42-d49b116e49ec",
      "text": "Ongoing clinical trials and phased authorizations for children and boosters (e.g., Pfizer EUA for 5–11 on Oct 29, 2021)"
    },
    {
      "id": "d187f29f-d494-4ca9-8866-e9da236be814",
      "text": "Initial U.S. authorizations delivered under Emergency Use Authorization (EUA) rather than full licensure (December 2020 onward)"
    },
    {
      "id": "6294c61a-6abc-46e0-a49a-abf7a17ad549",
      "text": "Public guidance describing mRNA COVID-19 vaccines as a new type of vaccine (CDC explainer updated Nov 2021)"
    },
    {
      "id": "66b58dc0-50b5-4540-adba-a4e76fb91d67",
      "text": "Gazprom announced it could exempt rebel‑held Donetsk and Luhansk areas from Ukraine’s main gas contract and effectively supply those territories."
    },
    {
      "id": "383b6c54-a4cb-4059-ad3e-ea0d13e45cc6",
      "text": "International monitors and humanitarian agencies reported acute winter fuel and heating shortages in parts of Donbas after 2014 fighting, generating local appeals for external assistance."
    },
    {
      "id": "ca6674d7-a991-469f-b21e-3b470642ac02",
      "text": "Crimean authorities nationalised local energy company Chornomornaftohaz after Russia’s 2014 annexation of Crimea."
    },
    {
      "id": "87749de4-8e3e-4246-b0ec-0e253eef0c89",
      "text": "Earlier major Russia–Ukraine gas disputes (notably the 2009 cutoff) established a pattern of Russia using gas supply as leverage in relations with Ukraine and Europe."
    },
    {
      "id": "a68aadc4-aa7a-498a-b29f-5219ac9ea826",
      "text": "Separatist leaders in Donetsk and Luhansk declared independence and publicly requested closer ties / assistance from Russia (including calls to join Russia) during spring 2014."
    },
    {
      "id": "7ad52f94-06d7-49c7-b712-801ca6ebb7c8",
      "text": "Trump publicly admonishes Putin — 'Vladimir, STOP!' after a deadly Kyiv strike"
    },
    {
      "id": "a362be59-a2b3-4756-9a27-ec194cf888a1",
      "text": "High-profile visit of European/Western leaders to Kyiv (May 10, 2025)"
    },
    {
      "id": "2d27cb07-d273-4ff8-a885-a605607e9399",
      "text": "Seychelles experienced a COVID-19 surge despite very high vaccination coverage, prompting WHO review of the data"
    },
    {
      "id": "c7eaa53f-6708-4973-a6e1-5dd6a6496de3",
      "text": "Israeli studies and policy in July 2021 showed waning protection of two-dose BNT162b2 and led Israel to authorize booster (third) doses"
    },
    {
      "id": "9f69dfad-b79e-4698-a00f-9c9919cf9cff",
      "text": "CDC reversed earlier guidance and in late July 2021 recommended fully vaccinated people wear masks indoors in areas of substantial or high transmission"
    },
    {
      "id": "730ccba6-46f4-4db1-900e-da737dcaf207",
      "text": "Release of IPCC AR6 Working Group I report (Climate Change 2021: The Physical Science Basis)"
    },
    {
      "id": "380afa3f-981c-4fb0-9861-b18e3bcbf7a6",
      "text": "Announcement that solar minimum occurred December 2019 and start of Solar Cycle 25 (NASA/NOAA communications)"
    },
    {
      "id": "6d335fdd-9f9d-41fe-95a7-51649780ed03",
      "text": "Publication and press coverage of NOAA/Science analysis challenging the 'global warming hiatus' (Karl et al. / June 2015)"
    },
    {
      "id": "e5dde201-20e3-4ed7-8581-0ce2fc39ce70",
      "text": "Large-scale online spread and patient self-medication episode around fenbendazole in South Korea (widely reported as the 'fenbendazole scandal' affecting cancer patients)."
    },
    {
      "id": "6c07e308-30de-4c20-8eed-8cb8fab78ac0",
      "text": "Public statements by Russian officials (including Foreign Minister Sergey Lavrov) after Crimea asserting Russia did not violate the Budapest Memorandum / offering narrow readings of its obligations"
    },
    {
      "id": "e3bd4def-67ea-4e41-acd9-45bdc62350df",
      "text": "Academic and policy analyses (post‑2014) arguing the Budapest Memorandum is politically binding but legally ambiguous / not a treaty-level guarantee"
    },
    {
      "id": "4eb1e6c6-4c04-4fb1-9b4a-e12422fcbe0c",
      "text": "Russia blocked transit of Ukrainian goods and imposed extra border controls in 2014, disrupting shipments to third countries"
    },
    {
      "id": "949cc13b-3f00-4a84-872f-1468848fa3cb",
      "text": "Ukraine GDP contracted ~6.8% in 2014 amid the Crimea annexation and eastern conflict (IMF/official statistics reporting)"
    },
    {
      "id": "e0d59cbd-fe06-44e6-9e57-683460942560",
      "text": "Multilateral economic assessments (World Bank / EBRD / IMF) in 2014–2015 attributing Ukraine’s deep 2014–15 recession to conflict, loss of territory, banking crisis and trade disruptions"
    },
    {
      "id": "63603e7b-a791-4901-af75-8d07266dac3c",
      "text": "Ukraine government announced a moratorium on repayment of a $3 billion Eurobond held by Russia."
    },
    {
      "id": "e9fec56b-bda7-405e-9874-715a2d84cc3c",
      "text": "The 2015 Greek debt crisis and high-profile standoffs with EU creditors earlier in 2015 (July 2015) increased German public and political sensitivity to sovereign default risks."
    },
    {
      "id": "0531bca5-6f01-407b-a777-e27ae1b12d71",
      "text": "23 March 2025 BBC coverage of community protests against the proposed 2,700‑acre East Pye solar farm in Norfolk, UK (residents citing impacts to farmland, wildlife and local character)"
    },
    {
      "id": "452f19a1-c9a7-4dc9-a417-a4163cc29164",
      "text": "2014 Frontiers in Environmental Science paper 'Solar panels reduce both global warming and urban heat island' (Masson et al.) concluding rooftop PV can reduce cooling demand and in some cases reduce UHI"
    },
    {
      "id": "d05ea7fe-5f24-45d6-9a3d-fcbd501c5e60",
      "text": "FDA final rule: Over‑the‑counter drug products containing colloidal silver ingredients or silver salts declared not generally recognized as safe and effective."
    },
    {
      "id": "15147e88-47de-416d-9926-84fe660a5bd2",
      "text": "Widespread clinical use of silver‑based products (e.g., nanocrystalline silver dressings like ACTICOAT) for wound care and device coatings documented in medical literature (early 2000s)."
    },
    {
      "id": "76b329bb-fe43-4d94-8dc1-903b6344d0c1",
      "text": "Publication of the Great Barrington Declaration advocating 'focused protection' instead of broad restrictions"
    },
    {
      "id": "d7007eff-53ac-46e5-8d8b-f2f5808280ef",
      "text": "UK government's early 'herd immunity' / mitigation messaging under Prime Minister Boris Johnson"
    },
    {
      "id": "8cd7d895-d72f-40f2-812f-beff65f4fbc3",
      "text": "2014 ban and export‑freeze context (post‑Crimea) on Ukrainian arms sales to Russia, and related SIPRI footnotes noting many deliveries had been completed before the ban."
    },
    {
      "id": "c2d2c458-bce0-4b94-b0e3-fd1544161903",
      "text": "Human Rights Watch reported exhumation of a mass grave in Sloviansk (eastern Ukraine)."
    },
    {
      "id": "a8e258d0-7a7b-4aef-b1a3-9162e909dee2",
      "text": "OSCE Special Monitoring Mission published observations about unmarked graves found near Komunar / Nyzhnia Krynka (Donetsk region)."
    },
    {
      "id": "3fba4d5c-3ee1-4b90-9114-934702074018",
      "text": "Launch of the government \"Eat Out to Help Out\" dining subsidy scheme and public encouragement to return to restaurants (August 2020)."
    },
    {
      "id": "2bc6299f-653a-4d72-baa1-8b71416e12a1",
      "text": "Publication of the Great Barrington Declaration advocating \"focused protection\" and arguing against broad restrictions (4 October 2020)."
    },
    {
      "id": "c9fe7617-e8d9-453c-be7c-26d3d7a1e970",
      "text": "Prime Minister Boris Johnson said the UK was \"past the peak\" of the outbreak in official briefings."
    },
    {
      "id": "b37d9311-a201-4634-b0be-4b9dc697c076",
      "text": "Senior UK scientists publicly discussed \"herd immunity\" as part of early pandemic strategy (Sir Patrick Vallance interview/comments)."
    },
    {
      "id": "801625a1-7548-4660-b67e-c9b4e1df4d39",
      "text": "Stanford press release/clinical trial announcement (2010) recruiting mitochondrial‑disorder patients to study vaccine responses"
    },
    {
      "id": "14d759b1-9f29-43bd-88c8-de19d3207ad3",
      "text": "Government concession and media coverage of the Hannah Poling VICP matter (discussed in NEJM and major outlets)"
    },
    {
      "id": "3695f38b-cdde-4db9-99a4-262c0769b252",
      "text": "Scientific American and other national outlets published explanatory pieces about the Poling case and its limits"
    },
    {
      "id": "12390c88-6802-4a75-b1f8-15c7a30d1011",
      "text": "1999–2000 public health statements recommending removal of thimerosal from some vaccines"
    },
    {
      "id": "b3d0ff6d-32e2-4e8f-a950-bd3ced38cfed",
      "text": "1993 withdrawal of the MMR vaccine (Urabe AM9 mumps strain) in Japan after reports of aseptic meningitis"
    },
    {
      "id": "affe057e-7142-43d7-927a-362e3310a150",
      "text": "2010 post‑licensure findings of a small increased risk of febrile seizures after MMRV (leading to CDC guidance to consider separate MMR and varicella shots)"
    },
    {
      "id": "c2557ada-2ecf-4c1d-a428-6aa2952f7811",
      "text": "UK/academic analyses (early 2022) and UKHSA/NEJM reports showing substantially reduced vaccine effectiveness against symptomatic infection with the Omicron variant and rapid waning after two doses."
    },
    {
      "id": "53f6ba38-107e-4a6a-8496-19ed4d5c8d9c",
      "text": "UKHSA published the COVID-19 Vaccine Surveillance Report (Week 4) including unadjusted case rates by vaccination status that showed higher case rates in vaccinated people for some age groups."
    },
    {
      "id": "d3f8fc98-2bd0-4e1c-84ef-848db8385d6e",
      "text": "FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine for donated supplies for hospitalized COVID‑19 patients"
    },
    {
      "id": "093af7ef-f8c3-4277-b887-feb350730d2c",
      "text": "EU decision to finance and supply lethal military assistance (European Peace Facility decisions, Feb–Mar 2022)"
    },
    {
      "id": "57c8255d-a207-45bd-a773-01c8b3e004b0",
      "text": "Visit of EU Commission President Ursula von der Leyen and HR/VP Josep Borrell to Kyiv"
    },
    {
      "id": "15321a4a-1154-4fe6-89f7-f3e8de6e2ca6",
      "text": "Emerging reports and media coverage of myocarditis/pericarditis following mRNA COVID‑19 vaccination (April–May 2021), including Israeli surveillance data."
    },
    {
      "id": "b6853fbf-e30d-4aeb-929e-61d3239aca0d",
      "text": "Publication of Ogata et al. pilot study detecting SARS‑CoV‑2 vaccine antigen (spike) in plasma of mRNA‑1273 (Moderna) recipients."
    },
    {
      "id": "426173ef-9f0b-4c2f-a119-f5f2aa095d55",
      "text": "Multiple European countries temporarily suspended use of the AstraZeneca vaccine in mid-March 2021 while authorities investigated clotting reports."
    },
    {
      "id": "17c44ab0-58b1-4dab-8cf7-2264ccf37aec",
      "text": "Office for National Statistics (ONS) Freedom of Information note and related discussion in June 2021 about deaths reported around the time of COVID-19 vaccination and the complexity of linking those deaths to vaccination."
    },
    {
      "id": "fec02486-c6e8-4284-bb05-729f62a1101b",
      "text": "MHRA and GOV.UK Yellow Card publications and vaccine-safety updates (May 2021) that published cumulative Yellow Card report summaries and guidance on interpreting them."
    },
    {
      "id": "59f262f9-054b-4bee-8ad9-ab207a5ab04e",
      "text": "MHRA press release (7 April 2021) concluding a possible link between the AstraZeneca COVID-19 vaccine and extremely rare blood clots (CVST with thrombocytopenia)."
    },
    {
      "id": "9bfa6c99-6397-4e36-9292-be2b2e541947",
      "text": "Moderna U.S. patent US 9,587,003 (containing SEQ ID NO:11652) granted and publicly available (patent issued March 2017)"
    },
    {
      "id": "ff080f9f-615b-48e7-b27c-7d16d778d50c",
      "text": "Moderna publicly announced rapid efforts to make an mRNA vaccine for the novel coronavirus and received funding/collaboration in January 2020 (CEPI/NIH coverage)"
    },
    {
      "id": "80a18546-a9f1-4a36-a3f3-a225649be4bb",
      "text": "World Bank report showing uneven poverty recovery and slow household welfare rebound (2016–2019 analysis)"
    },
    {
      "id": "72cbdf45-7fcd-4c0b-a5b3-813722f29224",
      "text": "Transparency International/other assessments showing persistent corruption and weak governance (CPI 2019 coverage)"
    },
    {
      "id": "8f0ffecd-2bd2-4568-afb4-65dda8d35d01",
      "text": "Sharp economic contraction in 2014–2015 after Crimea annexation and eastern conflict (World Bank reporting)"
    },
    {
      "id": "3980372c-6d98-4653-89d9-f9049985a93f",
      "text": "EU–Ukraine Association Agreement (DCFTA) provisionally applied from 1 January 2016"
    },
    {
      "id": "39055a63-9c6d-45c9-98ef-8513c7e78bc6",
      "text": "Statement by Crimea’s chief rabbi Binyamin Volf at a November 2017 Chabad conference (badge reading 'Sevastopol, Russia')"
    },
    {
      "id": "fb531a15-8aff-4353-a2a1-9aa5eccb96b4",
      "text": "Publicized meetings between World Jewish Congress leadership (Ronald Lauder) and Russian officials, including meetings at the Kremlin"
    },
    {
      "id": "4d204bc2-434c-43a4-b9df-86516e0bab5a",
      "text": "2014 controversy: Ukrainian Jewish leaders criticized visits/statements by top rabbis to Crimea"
    },
    {
      "id": "e0b2503d-fda4-4211-8c27-f6408b345eac",
      "text": "Official communications and data about breakthrough infections and transmission by vaccinated people (e.g., CDC director statements and news coverage in early August 2021)"
    },
    {
      "id": "aaa01355-379b-4cd3-b1f5-4111a86b3987",
      "text": "Kyiv city council and local authorities publicly discussing and approving additional allocations/guarantees to cover Eurovision hosting costs"
    },
    {
      "id": "f2221136-70d5-4fe1-b53b-7b08a207d33b",
      "text": "High-profile resignations from the Eurovision organising team amid disputes over transparency and finances"
    },
    {
      "id": "09cb4d32-703f-41a9-a5b7-5dad4743a3d3",
      "text": "FDA final guidance on enforcement discretion for certain N‑acetyl‑L‑cysteine (NAC) products, which received industry and media attention."
    },
    {
      "id": "b7642cd3-0bc8-4a1d-b545-580ddca192a6",
      "text": "Registration/publication of randomized trial activity and small clinical studies evaluating NAC for severe COVID‑19 (trial protocol/early trial entries 2021)."
    },
    {
      "id": "476a23f9-b992-437b-90c5-f963e8166938",
      "text": "CDC MMWR report of anaphylaxis after first doses of Pfizer-BioNTech COVID-19 vaccine"
    },
    {
      "id": "e876aa55-ccc6-4a86-a82c-6c131c26edee",
      "text": "CDC/ACIP recommendation and CDC endorsement for Pfizer pediatric vaccine for ages 5–11 (Nov 2, 2021)"
    },
    {
      "id": "299d2e55-bc61-4a50-bba6-66ed46b5363e",
      "text": "FDA grants full approval to Pfizer–BioNTech (Comirnaty) on Aug 23, 2021"
    },
    {
      "id": "497b8a3d-7b34-449a-b6a8-91e83200040e",
      "text": "HRSA/CDC guidance and public pages explaining COVID-19 vaccine injuries are handled under the Countermeasures Injury Compensation Program (CICP) rather than the National Vaccine Injury Compensation Program (VICP)"
    },
    {
      "id": "4947b34a-d70e-46a6-abf7-55b3d0fccc5e",
      "text": "April 3, 2020 CDC guidance changed to recommend cloth face coverings for the public"
    },
    {
      "id": "e838c843-c42f-494b-a37e-ced69281e703",
      "text": "Russian strikes reportedly hit a radioactive‑waste / radioactive source facility near Kyiv in late February 2022."
    },
    {
      "id": "1eff0a3d-f6cd-4aa1-8d3a-9043c2e6c613",
      "text": "EU outbreak reports and guidance showing increases in hepatitis A cases across Europe (not limited to Ukraine)"
    },
    {
      "id": "cc7198f8-4301-4ba1-8356-b86060cdac49",
      "text": "Large numbers of internally displaced persons (IDPs) and documented WASH challenges in Ukraine (2014–2016)"
    },
    {
      "id": "37543867-7a98-45b0-8d61-4b2251b582c0",
      "text": "IPCC Sixth Assessment Report (WG1) release summarising regional variation including land warming faster than oceans"
    },
    {
      "id": "62b4e71d-6e74-4807-808d-08787c84c8af",
      "text": "Pacific Northwest / Western North America extreme heat wave and record highs (June 25–30, 2021)"
    },
    {
      "id": "3ccc3a01-a487-4b8a-be47-6d4a3a2a0904",
      "text": "Arctic temperature record of +38°C at Verkhoyansk (measured 20 June 2020, widely reported/confirmed later)"
    },
    {
      "id": "21f033b2-695d-4e52-b95f-b558e097f44b",
      "text": "IPCC AR5 Summary for Policymakers (September 2013) conclusion: 'It is extremely likely that human influence has been the dominant cause of the observed warming since the mid-20th century.'"
    },
    {
      "id": "08258c5a-06ae-4452-83ce-367944e44347",
      "text": "Media reports and clips referenced proposals to replace universal subsidies with targeted assistance (compared by some reports to 'food-stamp' style programs)"
    },
    {
      "id": "40c10979-07ed-44f9-86c3-b6799b7f54a1",
      "text": "Analyses and reports documenting that Ukraine was used as a transit or logistical route by foreign fighters bound for Syria/Iraq (The Soufan Group foreign fighters updates, 2014–2015)"
    },
    {
      "id": "c275bfbb-ffe1-4a47-98af-9b5a80b6c744",
      "text": "European Parliament/public sources flagged presence of foreign Islamist volunteers or sympathizers in eastern Ukrainian conflict zones (July 2015 references to press reporting)"
    },
    {
      "id": "72ecc1dc-d64c-429f-9c9f-4be7d17d858f",
      "text": "Ukrainian Security Service (SBU) detained and expelled several foreign nationals described as Islamic State supporters (SBU press reports)"
    },
    {
      "id": "50c0933b-59f9-46d0-94dd-8f90735528aa",
      "text": "Crimean official Ruslan Balbek publicly claimed there are ISIS training camps in Kherson (southern Ukraine)"
    },
    {
      "id": "2e9de352-9347-4d4d-a8bc-e3956c08af2d",
      "text": "US decision to withdraw troops from northern Syria (announced early October 2019) and the ensuing Turkish incursion drew rapid regional and global attention"
    },
    {
      "id": "abb7f778-870e-40b2-a550-5eab36008d6e",
      "text": "US impeachment inquiry into President Trump after the Ukraine whistleblower shifted US political and media attention away from foreign-policy issues such as Crimea"
    },
    {
      "id": "178c06f6-c2d7-4166-bf7e-d2614914d85b",
      "text": "UK prorogation (suspension) of Parliament by Prime Minister Boris Johnson and the constitutional crisis around it in late August–September 2019"
    },
    {
      "id": "b34894b9-0db5-4b79-9f77-90483625254e",
      "text": "Public arrival and frontline deployment of US-supplied HIMARS in Ukraine was widely reported (first systems arrived in late June 2022)."
    },
    {
      "id": "5d97b84f-d0d3-4586-bb21-05b4cf519290",
      "text": "Russian Ministry of Defence later claimed it had destroyed four HIMARS launchers between July 5–20, 2022."
    },
    {
      "id": "f34e68a5-70eb-4dfe-ad1c-a0bfcb57e6fc",
      "text": "WHO SAGE identifies vaccine hesitancy and misinformation as major threats (working group/report)"
    },
    {
      "id": "2ef0b41e-8e8f-49b8-9316-58dfe374c259",
      "text": "IARC classification of formaldehyde as ‘carcinogenic to humans’ (Group 1)"
    },
    {
      "id": "041a4de6-f275-4268-a290-15cab46201b5",
      "text": "1999 US Public Health Service and American Academy of Pediatrics recommend removal of thimerosal from many childhood vaccines as a precaution"
    },
    {
      "id": "0a2d2ef5-2997-4280-ba09-2cf99a6347d6",
      "text": "UN/UNICEF warning that tens or hundreds of thousands of children in eastern Ukraine are threatened by landmines and explosive remnants of war"
    },
    {
      "id": "27af4d41-3321-43cd-adde-e2cf8cdda644",
      "text": "Mine Action Review report 'Clearing the Mines 2017' documents extensive contamination and cites OHCHR findings that Ukrainian armed forces and armed groups continued to lay landmines (including antipersonnel types) during 2016"
    },
    {
      "id": "99344ff5-7033-46e5-a172-2343c8b0a751",
      "text": "Bellingcat investigation & reporting on risks in Donbas ('Donbas: A Ticking Toxic Time Bomb') highlighting flooded and unmanaged minefields and environmental hazards in former coal-mining areas"
    },
    {
      "id": "a1c1ee08-ed28-4db5-a831-59acdf22f269",
      "text": "Minsk II text included provisions on decentralization / 'special status' for Donbas that Poroshenko accepted to negotiate."
    },
    {
      "id": "e95ec72b-b6d6-4417-bb16-2497cd4cff59",
      "text": "Poroshenko announced a unilateral ceasefire (June 2014) and subsequent pauses/cessations of offensive actions."
    },
    {
      "id": "cb696a27-f7ad-46bd-a24a-1c2511c4b536",
      "text": "Poroshenko and Putin met and were photographed/filmed together at international talks (including February 2015 Minsk meetings and earlier encounters such as the June 2014 D-Day meeting)."
    },
    {
      "id": "b34d7d81-77a6-41f9-866c-0d5d976e923a",
      "text": "Japan reports and temporary pauses after discovery of foreign/black particles in some Moderna vaccine vials"
    },
    {
      "id": "a76f28a8-e514-4778-afec-dbf62ede3de5",
      "text": "CDC/ACIP public acknowledgement and MMWR report of increased myocarditis cases after mRNA COVID-19 vaccination"
    },
    {
      "id": "d2b529d6-7af6-4f04-957b-b557fb40ccd8",
      "text": "Court dispute and media coverage over FDA’s proposed slow timetable and subsequent judge’s order to accelerate release of Pfizer vaccine documents"
    },
    {
      "id": "d3130946-bf20-4d88-bbfc-7a743c19f84d",
      "text": "CDC Health Advisory and public warnings (late August 2021) about a sharp rise in ivermectin misuse, poisonings, and related emergency visits."
    },
    {
      "id": "a38c53fc-6805-46bb-978a-b98d01c02b1e",
      "text": "OSCE armoured vehicle damaged by an explosion near Pryshyb (one monitor killed, two wounded)"
    },
    {
      "id": "18dde5d9-a8c1-4134-8a1a-b48330358cae",
      "text": "Publication of the Harvard Pilgrim (ESP:VAERS) final report (AHRQ grant) finding that automated surveillance suggested many adverse events were not reported to passive VAERS."
    },
    {
      "id": "118bfe4a-22c6-4acd-a632-2f96f78840a3",
      "text": "Congressional/public pressure: Rep. Bill Posey’s 2019 public questioning (and associated media coverage) that highlighted the multi‑billion dollar VICP figure and prompted scrutiny/discussion online."
    },
    {
      "id": "029326f0-ab23-4cc2-b665-28cb99c7ab3d",
      "text": "OSCE SMM observed heavy weapons and armoured vehicles in violation of withdrawal lines (e.g., tanks near Avdiivka; a surface‑to‑air missile system near Hannivka) during the late‑January 2017 escalation."
    },
    {
      "id": "43e5cea7-5aa8-40fd-b513-fa7aa13d81d6",
      "text": "Ukrainian authorities declared a state of emergency in Avdiivka and organised evacuations as civilians were left without power, heating and water following the shelling."
    },
    {
      "id": "6725a1ba-4023-4162-8159-537ec94e6771",
      "text": "Multiple news outlets and local reporting documented both Ukrainian forces and pro‑Russian separatists accusing each other of initiating the offensive around the Avdiivka 'industrial zone' (Almaz‑2) and making competing claims of tactical gains."
    },
    {
      "id": "9726f123-3a84-47e7-a294-1eed84f61a26",
      "text": "Peer‑reviewed research and industry reports documented that Liquidambar (sweetgum) seedpods contain measurable shikimic acid and could be an alternative feedstock for industrial extraction (published research e.g., Appl Biochem Biotechnol, Epub May 27, 2010)."
    },
    {
      "id": "da87ff37-ca2b-47c1-831b-8b46e125edb8",
      "text": "Mainstream coverage during flu/Tamiflu shortages (2005) highlighted that shikimic acid—traditionally sourced from star anise—was a critical precursor for manufacturing Tamiflu, prompting searches for alternative natural sources."
    },
    {
      "id": "81e0c562-9db7-4aa3-a2c1-b4f864f16a9c",
      "text": "Zozulya was included in Ukraine's squad for the March 24, 2017 Croatia qualifier but did not play in the match."
    },
    {
      "id": "eea13ed3-dccf-446f-998f-735b0ea2d09a",
      "text": "Rayo Vallecano fans publicly protested and the club cancelled Zozulya's loan from Real Betis after accusations he had neo‑Nazi links."
    },
    {
      "id": "ef520cf2-7d18-4465-bea8-d978c2295e1e",
      "text": "Rapid Trident 2021 multinational land exercise in Ukraine (≈6,000 personnel) with explicit COVID-19 mitigation measures"
    },
    {
      "id": "04c0c80a-9c9f-4838-807e-9a86f6df2526",
      "text": "Sea Breeze 2021 multinational maritime exercise in the Black Sea (June–July 2021) involving thousands of personnel, ships and aircraft"
    },
    {
      "id": "fa7e1324-b0b9-4ff6-bdc0-6259cd84da93",
      "text": "High-profile military COVID-19 outbreak: USS Theodore Roosevelt outbreak and ship quarantine (April 2020)"
    },
    {
      "id": "8324920a-9890-442b-96d7-0dc92b7918e2",
      "text": "Post‑invasion 'derussification' actions, including Kyiv renaming nearly 100 streets and removing Soviet/Russian monuments as part of wider cultural de‑Russification."
    },
    {
      "id": "c6582463-5f7d-4cfe-a8f8-6c66c1c335da",
      "text": "Kyiv City Council imposed a moratorium on the public use of Russian‑language cultural products (books, songs, films, theatrical works) in the capital."
    },
    {
      "id": "6cfac1b0-30a7-4afb-a149-90cfba3368ae",
      "text": "Verkhovna Rada adopted the 2019 law 'On ensuring the functioning of Ukrainian as the state language' strengthening use of Ukrainian in public life."
    },
    {
      "id": "9a382c40-da0c-4d85-8cd1-9c2ebea1c96b",
      "text": "President Zelensky imposed sanctions and broadcasting suspensions on three pro‑Russian TV channels (112 Ukraine, NewsOne, ZIK)."
    },
    {
      "id": "2a63e9a0-e29d-4060-bb0d-3468106d7324",
      "text": "Major criminal/civil enforcement actions against drugmakers for improper marketing (example: Novartis pleads guilty and agrees to pay $422.5M for off‑label marketing, Oct 2010)"
    },
    {
      "id": "e3a2dbb7-08c2-4c29-9af0-05d39d0c1db5",
      "text": "Publication of DSM‑5 (May 2013) which changed ADHD diagnostic criteria (e.g., raising the age of onset criterion from 7 to 12 and adjusting symptom thresholds)"
    },
    {
      "id": "9f90264c-7944-46c7-8681-78318e8d1355",
      "text": "Itajaí city government announcement and distribution program for ivermectin (mayor/prefeitura public rollout)"
    },
    {
      "id": "68641234-420a-4329-90f9-bffadf38cf2c",
      "text": "Itajaí municipal health department 'Nota de esclarecimento - tratamentos profiláticos' (clarification note) revealing rapid drop-off in adherence to the distributed ivermectin regimen"
    },
    {
      "id": "6eed197c-bb50-4b7c-a189-a980a1656ac3",
      "text": "July 5, 2021 media reports (based on Israeli data) that Pfizer vaccine protection against infection had declined amid Delta variant spread, while still protecting strongly against severe disease."
    },
    {
      "id": "990812e0-4f86-494f-beef-eba27006dff4",
      "text": "Sept 24, 2021 CDC/FDA authorizations and public communications expanding booster recommendations while acknowledging breakthrough infections and waning immunity."
    },
    {
      "id": "c2c64aec-c935-49b0-afcc-72fccbdcc3a5",
      "text": "March 19, 2020 livestream interview where Fauci discussed antibody-dependent enhancement (ADE) as a theoretical vaccine safety concern during early COVID-19 vaccine development."
    },
    {
      "id": "f968d171-b816-46c0-bfa0-fba146815ece",
      "text": "Earlier documented exhumations/mass‑grave discoveries in Donbas (Sloviansk mass grave exhumed)"
    },
    {
      "id": "9f765438-218d-4074-9cbb-6a99cfc6b719",
      "text": "Visible cemetery work (small tractor stuck in mud and manual removal of soil) at the Sumy cemetery"
    },
    {
      "id": "d803b683-bf2d-480e-b71a-2f96bdbcf286",
      "text": "Publication of a 2017 pilot study showing short‑term tinnitus reduction after intranasal oxytocin (peer‑reviewed)"
    },
    {
      "id": "7bbf868a-826e-4db5-a17c-44573886c777",
      "text": "FDA clearance and media coverage in 2023 of Lenire (a novel device for treating tinnitus), elevating public interest in new tinnitus treatments"
    },
    {
      "id": "a3483f04-4bc2-48ff-ab5f-da1743021afe",
      "text": "Surge of TikTok posts and hashtag activity (#tinnitushelp) in early–mid 2024 promoting quick fixes, including nasal sprays/inhalers"
    },
    {
      "id": "e27900e5-e395-41bd-9e8f-7e9184605552",
      "text": "Public availability of Phytonadione (vitamin K) package insert listing polysorbate 80 (DailyMed / FDA label; label file updated Jan 19, 2017)."
    },
    {
      "id": "15ba355f-65bd-41c2-bb80-d915bc29a320",
      "text": "IPCC Sixth Assessment WG1 (AR6) press release and summary (August 2021) asserting that human influence has unequivocally warmed the climate system."
    },
    {
      "id": "bef21526-75d8-4ec5-8762-f4c10f0c6966",
      "text": "Nature Geoscience and related studies (circa 2017) reporting large uncertainties about whether airborne mineral dust from deserts has a net warming or cooling radiative effect."
    },
    {
      "id": "6385f0ee-fc6e-4be6-a532-2d855f27de42",
      "text": "Zhu et al. (2016) 'Greening of the Earth and its drivers' (Nature Climate Change) documenting global increases in vegetation, including expansion in some dry regions, largely attributed to CO2 fertilization and land-use changes."
    },
    {
      "id": "be9d0715-a081-4e4b-bfc0-abb30b56e22f",
      "text": "NASA/MODIS public data and Earth Observatory coverage showing deserts as among the highest-reflectivity (high albedo) land surfaces."
    },
    {
      "id": "4413ab91-f03a-4a79-8f9f-bc195fa9468a",
      "text": "2017 peer-reviewed modelling studies and simulations proposing desert-focused geoengineering or land-surface modification (e.g., irrigating deserts or increasing desert albedo) to alter global/regional climate."
    },
    {
      "id": "de7f06e0-ab3a-4af8-a892-e30335092fc1",
      "text": "April 2017 reporting of new research (covered by AIDSMap) about long-term nitrate inhalant exposure and cancer risk that noted elevated cancer signals in some subgroups."
    },
    {
      "id": "a389d09d-c70e-4f32-8f4f-fe1d1a9181d9",
      "text": "June 1994 coverage and activism (New York Native / related reports) documenting calls for research into a poppers–Kaposi's sarcoma connection (NIDA-era attention to the hypothesis)."
    },
    {
      "id": "7982bb8c-32dc-46d0-b1fb-bdd657baab28",
      "text": "Russian Ministry of Defense announced first operational use of the Kh-47M2 'Kinzhal' hypersonic missile, claiming it destroyed an underground Ukrainian ammunition depot in Delyatyn."
    },
    {
      "id": "1fbaaae1-6e8b-4e15-ba6e-69100367c7cf",
      "text": "President Joe Biden publicly acknowledged Russia's use of hypersonic missiles, saying the weapon was \"a consequential weapon... almost impossible to stop,\" as reported by news outlets in mid‑late March 2022."
    },
    {
      "id": "e9e5e622-efb4-497d-a4d0-2e931b17806d",
      "text": "Publication showing vaccine‑derived spike antigen detectable in plasma after mRNA vaccination (Ogata et al., Clinical Infectious Diseases)"
    },
    {
      "id": "18af0ef6-7e14-4b53-8284-cbd053fc539d",
      "text": "Publication of an in vitro study showing nattokinase degrades SARS‑CoV‑2 spike protein (Tanikawa et al., Molecules)"
    },
    {
      "id": "ebaea4e5-dcd3-4432-a770-e32381475f95",
      "text": "Publication reporting persistence of SARS‑CoV‑2 S1 protein in CD16+ monocytes up to 15 months in PASC patients (Patterson et al., Frontiers in Immunology)"
    },
    {
      "id": "0ef1fdb2-1350-4739-9a5a-6090cf7b4a06",
      "text": "Judge Mark Pittman ordered the FDA to accelerate public release of Pfizer vaccine trial documents (court order reported Jan 7, 2022)"
    },
    {
      "id": "f648b2b3-3a41-4e93-85c0-b818c09744fd",
      "text": "Public availability of large troves of Pfizer documents via the PHMPT/FOIA process (public repository of Pfizer documents made accessible in 2022)"
    },
    {
      "id": "2bd084e4-6041-473c-ace8-09633da445b7",
      "text": "UN General Assembly Resolution 68/262 reaffirming Ukraine's territorial integrity"
    },
    {
      "id": "ab296a5c-ee22-4d81-b8ad-0840632776be",
      "text": "Ukrainian government regains control of Mariupol (June 2014)"
    },
    {
      "id": "49b6f7ee-c490-4e97-b9be-cd1cdb389f4d",
      "text": "Ukrainian forces retake Sloviansk and Kramatorsk from pro‑Russian separatists"
    },
    {
      "id": "2f765095-3367-4bc4-bb5f-c8c33226edc8",
      "text": "Minsk II ceasefire agreement and delineation of frontlines (February 2015)"
    },
    {
      "id": "22b397c9-5e00-40bd-8e3b-a23dd98284d9",
      "text": "OSCE SMM: patrol vehicles and civilians hit by fire in eastern Ukraine (multiple incidents, Sept 2014 example)"
    },
    {
      "id": "df7a3803-f91f-4992-af44-ab4dde913c7c",
      "text": "Amnesty International reporting on indiscriminate attacks and civilian deaths in Donbas"
    },
    {
      "id": "df1f4076-07b7-4f91-a688-776170514a2c",
      "text": "Human Rights Watch report: unguided Grad rockets killed civilians in Donetsk suburbs"
    },
    {
      "id": "c72ffe7e-58cc-4d2a-86b6-10bd9f697b5f",
      "text": "Volnovakha bus attack — passenger bus hit near checkpoint, 12 killed"
    },
    {
      "id": "804c22b2-4b27-4c7a-a9c1-8e0d56576d0b",
      "text": "Energoatom presents national report at the IAEA General Conference noting diversification of fuel supply and construction of centralized spent fuel storage (IAEA General Conference coverage)"
    },
    {
      "id": "87e47acc-97a6-4c7f-baaf-2ab092ddd69d",
      "text": "Country profile and industry analyses documenting Ukraine’s historical reliance on Russian fuel-cycle services (conversion/enrichment) and stated efforts to diversify suppliers"
    },
    {
      "id": "c2ff0ebe-998f-49d8-9a26-7fb72ec51dcb",
      "text": "Japan suspended ~1.63 million Moderna vaccine doses after reports of contamination in vials"
    },
    {
      "id": "1b4302fa-4db0-4d8f-9ca7-83cf593a5a08",
      "text": "Norwegian Medicines Agency investigated deaths of frail elderly occurring shortly after Pfizer vaccination"
    },
    {
      "id": "9d86fdf6-7f59-44ca-b7a2-4f9d5dde13c8",
      "text": "CDC/ACIP acknowledged increased reports of myocarditis following mRNA COVID-19 vaccination"
    },
    {
      "id": "0151bbcd-c972-42d3-b86b-cb399c6266fa",
      "text": "NOAA/NASA Solar Cycle 25 Prediction Panel preliminary forecast released"
    },
    {
      "id": "56869913-81a3-4dc9-8932-4a209478fb3f",
      "text": "Publication of randomized trial (Cowling et al.) reporting increased non-influenza respiratory infections in children after inactivated seasonal influenza vaccine"
    },
    {
      "id": "f4405dfb-c941-412f-857e-5a77f34b5f32",
      "text": "NATO Readiness Action Plan (RAP) launched after Russia's 2014 actions"
    },
    {
      "id": "71efcdd0-feba-4f17-9df6-806c0141cbb0",
      "text": "Public statements by NATO Secretary General Jens Stoltenberg in June 2022 urging preparation for a 'long haul'"
    },
    {
      "id": "b42bcfde-d9f8-4371-9d21-99670eef9a28",
      "text": "Decision to deploy NATO enhanced Forward Presence (eFP) battlegroups to the Baltic states and Poland"
    },
    {
      "id": "09aaf704-8467-4143-952d-96f41284f4f8",
      "text": "Large NATO exercise Trident Juncture (2018) held near NATO's northern flank"
    },
    {
      "id": "d7440efb-31e2-4628-944f-50e9967a0277",
      "text": "Reporting in June 2018 that Crimea was expected to see a major tourism surge for summer 2018 while airlines cut flights—intense media focus on the 2018 tourist season."
    },
    {
      "id": "957fb997-6d99-4b89-adf6-7215d9d822c9",
      "text": "‘Day of Crimean Resistance’ and related pro-Crimea/anti-occupation rallies and activism in Kyiv (26 February 2018 demonstrations of Kyiv-based support for Crimean Tatars and Ukrainian claims on Crimea)."
    },
    {
      "id": "3eb91f38-46c0-4be0-a1aa-bf07ae9029bb",
      "text": "Trial/indictment proceedings in April 2018 against Yevhen (Evgenii) Panov, accused by Russian/Crimean authorities of preparing sabotage in Crimea."
    },
    {
      "id": "0d60cc1f-bd32-4137-85e7-ee7f9f32a2d3",
      "text": "Opening of the Kerch (Crimean) Bridge by President Putin, a high-profile infrastructure and tourist-access milestone for Crimea."
    },
    {
      "id": "83a46f8f-bd63-4e99-ba08-b42d237718ca",
      "text": "Prime Minister's housing/cost-of-living speech emphasizing domestic agenda"
    },
    {
      "id": "3ff00e48-74c1-481f-bb84-249163637132",
      "text": "Conservative Party confidence vote in Boris Johnson's leadership"
    },
    {
      "id": "9e295537-0a8e-4c97-956f-25a628caf5e8",
      "text": "Prime Minister issued a fixed penalty notice in the 'Partygate' inquiry"
    },
    {
      "id": "7c0677e7-a1de-46b4-8537-3e039fd956a2",
      "text": "Surprise visit to Kyiv and public walk with President Zelensky"
    },
    {
      "id": "2de1d368-987c-4a5d-b412-16dff48d5432",
      "text": "NOAA PMEL published guidance 'Quality of pH Measurements in the NODC Data Archives' explaining that many pre‑1990 seawater pH measurements have large, poorly documented uncertainties and that consistent, high‑quality pH detection has only been possible since the 1990s."
    },
    {
      "id": "feb784eb-895c-4e56-9470-0934560c08a7",
      "text": "Release/public availability of the World Ocean Database (WOD) 2013, which aggregated historic in‑situ ocean profiles (including pH) but documented large metadata gaps and methodological inconsistencies in older records."
    },
    {
      "id": "7caf2bc7-0a29-4338-a5b3-d8d5314c896f",
      "text": "Small 2018 pilot study published in the Journal of Alzheimer's Disease reported cognitive improvements after a coconut oil‑enriched Mediterranean diet in a limited sample of Alzheimer's patients."
    },
    {
      "id": "10e12017-766f-4a88-b89e-72b4241f43cb",
      "text": "Health Canada and other national bodies issued advisories/removals in spring 2021 concerning graphene‑coated face masks (potential inhalation risk), and some jurisdictions pulled graphene‑containing masks from distribution."
    },
    {
      "id": "cd07651b-ca7f-4ba7-a292-e24bbb89d3e6",
      "text": "Published scientific literature and reviews (pre‑2021) described graphene oxide's biomedical research applications and its use in nanomaterials and delivery systems."
    },
    {
      "id": "43ef1665-1991-439b-b5b0-341027e7c7f6",
      "text": "WHO SAGE 'Roadmap for Prioritizing Uses of COVID-19 Vaccines' (draft) updated 29 June 2021 emphasizing prioritization of high‑risk groups and limited vaccine supply."
    },
    {
      "id": "1055602a-6022-4325-9031-c9da36278c1f",
      "text": "Regulatory approvals in some countries for adolescent vaccination (Pfizer authorization/recommendation for ages 12–15 in May 2021) created divergent national vs. WHO messaging."
    },
    {
      "id": "12dd4744-5275-4005-9cba-eee738bae219",
      "text": "Ukrainian forces recaptured the television tower in Slovyansk (reported May 5, 2014)"
    },
    {
      "id": "3d87295a-229b-4465-8a0b-4118c603b1de",
      "text": "Widespread photo galleries and agency images of pro‑Russian flag‑raising in Donetsk (e.g., BBC gallery, April 2014)"
    },
    {
      "id": "6a39f53a-dbbc-49de-a3d5-8a727b162557",
      "text": "The World Health Organization told Reuters (March 11, 2022) it had advised Ukraine to destroy high‑risk pathogens in public health laboratories to prevent any potential spills amid the Russian invasion."
    },
    {
      "id": "6cc6428f-3e2c-40ec-8a01-e3bc7f71b9e5",
      "text": "Hawaii state law (SB2571/Act 104) banning sale of sunscreens containing oxybenzone and octinoxate (effective Jan 1, 2021)."
    },
    {
      "id": "12414278-10a5-4efe-aa75-6b5147a06ade",
      "text": "Nambour randomized trial follow-up reporting reduced melanoma incidence with regular sunscreen use (long-term follow-up published 2011)."
    },
    {
      "id": "2921d6b4-fdb1-4fac-b774-3b44892c9a47",
      "text": "Clinical research linking low serum 25-hydroxyvitamin D levels with worse melanoma prognosis (ASCO/JCO abstracts and peer-reviewed studies published across 2014–2021)."
    },
    {
      "id": "7e453dda-1f5a-4c77-8439-29ccd17a064a",
      "text": "Poroshenko's annual address to parliament included the line that retaking Crimea by force was 'realisticly — no' (statement made in context of legal/diplomatic strategy)."
    },
    {
      "id": "cce6161f-61e1-495e-856c-b460794e60d9",
      "text": "UKHSA/other national surveillance dashboards showing age breakdowns of respiratory‑virus hospital admission rates (including infants) during 2022–2024 seasons"
    },
    {
      "id": "c8740bfc-0d91-49ed-a628-3e66fdb712d4",
      "text": "‘Self-determination for Zakarpattia’ rally held near Ukraine's embassy in Budapest (Oct 13, 2017)"
    },
    {
      "id": "ec1eaadc-9853-423b-bd50-674470b40015",
      "text": "OSW analysis: 'Zakarpattia – together, but separated' noting low mobilisation and governance problems (Sept 30, 2015)"
    },
    {
      "id": "1e8f66d1-24b7-4b3a-b1ee-0a878d3a35c8",
      "text": "Armed shootout in Mukachevo (July 11, 2015)"
    },
    {
      "id": "2c3a68fc-ce0f-41b8-b95e-db9820f85184",
      "text": "Ukraine's 2017 education law and ensuing Hungarian protests (Oct 2017)"
    },
    {
      "id": "969a892f-fce1-45f5-8bde-d9e50e52490d",
      "text": "OSCE Special Monitoring Mission statements and reports documenting detentions, restricted access and impediments to monitors in Donbas (e.g., SMM updates 21 June 2017)"
    },
    {
      "id": "3fe9ba56-574a-4fbd-bd89-3efc650e8933",
      "text": "Attack on an OSCE SMM patrol in Yasynuvata where armed men engaged/attacked monitors (reported June 20–21, 2017)"
    },
    {
      "id": "9d121a0d-cbfc-4f4d-a9b8-25602f209f3e",
      "text": "Large-scale arrival and public statistics on Ukrainian refugees in France (UNHCR/France reports, early 2023)"
    },
    {
      "id": "a1143634-530f-4ddf-bd27-0031ce6cbeff",
      "text": "Widespread France riots after the police shooting of teenager Nahel Merzouk that generated intense domestic and international attention"
    },
    {
      "id": "3f813fdc-4ad6-4f05-bd8c-cb458b63dcc4",
      "text": "Local population in Zakarpattia (Transcarpathia) increasingly sought Hungarian citizenship and cross-border permits, highlighting strong economic and social ties with Hungary."
    },
    {
      "id": "898253d6-a20b-4ea7-a680-4ea6a8e5e591",
      "text": "2015 Mukacheve armed clash (July 11, 2015) between local gunmen, police and paramilitary-linked groups over control of smuggling routes."
    },
    {
      "id": "98c3fc99-045a-41b1-9608-c4606dec0d90",
      "text": "Analyses and commentary (2015) documenting Zakarpattia's long‑standing cross‑border economic orientation and weak integration with central Kyiv policies."
    },
    {
      "id": "f8ddd071-d05b-4c10-a854-e72bfabfc89b",
      "text": "OSCE Special Monitoring Mission (SMM) reporting in October 2020 documented multiple explosions and frequent ceasefire violations in Donetsk and Luhansk regions, with restricted access to some non‑government‑controlled areas."
    },
    {
      "id": "c8a184f1-5f20-40eb-b092-438c9d095f14",
      "text": "Prior deadly Molot mortar accident at the Rivne training ground (Molot M120-15) prompted government tests and probes after a mortar blast that killed multiple service members."
    },
    {
      "id": "7ad56b41-6460-472b-ae3a-26765fb583ca",
      "text": "VAERS reports of fetal loss increased in the 2009–2010 season and were summarized in a 2011 review of reports after H1N1 vaccination (Moro et al.)"
    },
    {
      "id": "a2f350e8-ddd6-458b-9ff0-ecce809962be",
      "text": "Authoritative guidance that VAERS is a passive reporting system and cannot be used alone to establish causation"
    },
    {
      "id": "947ca0f5-5a3e-42e0-87e9-0791cccea0e6",
      "text": "UN reports sharp rise in people fleeing eastern Ukraine to Rostov region, with tent camps and thousands accommodated"
    },
    {
      "id": "8d97a4be-b332-4539-aa7b-7570086c9276",
      "text": "Well-documented historical use of 'filtration camps' during the Chechnya wars (Human Rights Watch and Amnesty reporting from 2000)"
    },
    {
      "id": "ab28cf16-2c3b-417f-8c2d-799f61852361",
      "text": "Hungary and minority-rights actors publicly criticise the law and warn of harm to minority languages, prompting diplomatic pushback"
    },
    {
      "id": "3c9347df-8ffe-420e-820c-4842e49256f9",
      "text": "Ukraine's Constitutional Court had recently struck down the 2012 Kivalov–Kolesnichenko language law (decision of 28 February 2018)"
    },
    {
      "id": "0c724668-85d6-4a8c-9d9a-0f5348c06218",
      "text": "Verkhovna Rada adopts the Law on Ensuring the Functioning of Ukrainian as the State Language"
    },
    {
      "id": "ba943773-f4ec-4b72-b99d-3fd70ccd5b96",
      "text": "Media and analysts report the law requires Ukrainian in public sector, raises media quotas and tightens administrative penalties"
    },
    {
      "id": "43bf57ac-6257-460f-8d73-80f921e28db0",
      "text": "OSCE SMM daily reports in November 2019 documenting renewed ceasefire violations, weapons and troop movements near the contact line"
    },
    {
      "id": "a0cfeb9e-171f-4591-87c1-7f275bfea3da",
      "text": "Sea Breeze multinational military exercises in Ukraine (Sea Breeze 2019) involving NATO partners"
    },
    {
      "id": "f7281147-4afd-4fcc-a868-83b976f36e7a",
      "text": "Verkhovna Rada adopts the Donbas 'reintegration' law (commonly cited as ending Minsk framework)"
    },
    {
      "id": "9986cc55-bad0-4c51-a4f2-64526ad8eef9",
      "text": "Public statements by President Volodymyr Zelensky and senior Ukrainian officials in mid‑2019 expressing scepticism about Minsk (describing Minsk as a 'trap' or calling for its overhaul)"
    },
    {
      "id": "5c10b624-e027-43ef-a580-72ae4235ada6",
      "text": "Ukraine replaces the ATO with the Joint Forces Operation (JFO), moving military command and framing a more overt military response in Donbas"
    },
    {
      "id": "2cd38244-2816-4d92-95c4-7397788434fa",
      "text": "Growing public and political debate within the U.S. GOP over further Ukraine aid in 2023–early 2024, including prominent Republican calls to reduce or stop funding."
    },
    {
      "id": "63a76f1c-0c99-43b6-b1bc-49035b7d3502",
      "text": "Pope Francis placed public phone calls with President Volodymyr Zelensky shortly after Russia's full‑scale invasion (first reported 26 February 2022)."
    },
    {
      "id": "02863339-38b5-4c5b-ad5c-759fea14668f",
      "text": "Reports of foreign/black particles found in Moderna vaccine vials in Japan and subsequent batch suspensions"
    },
    {
      "id": "701c30c1-0733-4df8-b0d1-eb0ce9f034c8",
      "text": "Legal filings and public petitions by the de Garay family and allied lawyers seeking Pfizer/FDA records about the 12–15 trial (documents and filings posted May 2023)."
    },
    {
      "id": "7d2f369e-4792-4f44-a2fd-c8db8dc7b072",
      "text": "Several countries temporarily paused use of the AstraZeneca COVID-19 vaccine in March 2021 amid reports of rare blood-clot events; EMA and national agencies investigated and later issued conclusions balancing risks and benefits."
    },
    {
      "id": "1a25a97c-fb17-4d43-87d7-ece424c49c11",
      "text": "Norwegian health authorities reviewed several deaths of very frail, elderly nursing-home residents that occurred shortly after Pfizer–BioNTech vaccination and issued more cautious guidance on vaccinating the most frail."
    },
    {
      "id": "b43b7493-d28e-474e-92b1-627bc2df5911",
      "text": "CDC/NCHS published 'Guidance for Certifying Deaths Due to Coronavirus Disease 2019 (COVID-19)' (NCHS Alert/Guidance allowing COVID-19 to be reported as probable or presumed when appropriate, not always requiring a positive lab test)."
    },
    {
      "id": "e546b4d6-4a47-48e7-bd13-1e7753dbb866",
      "text": "Public Health England (PHE)/UK consolidated COVID death reporting to 'deaths within 28 days of a positive test' (clarifying that different measures exist between PHE daily counts and ONS death-certificate-based counts)."
    },
    {
      "id": "4eb4ba3e-a782-475b-b2c4-9d6db34814ec",
      "text": "UN/OHCHR and other international monitors reported a deterioration in human rights in eastern Ukraine during 2014, noting cases of torture, abduction and some incidents of sexual abuse"
    },
    {
      "id": "06c0a5b5-8e16-4f9f-9f0e-ab5664de4825",
      "text": "CDC guidance and longstanding vaccine-safety literature noting that fainting (syncope) can occur after injections and is often related to pain or anxiety rather than the vaccine itself."
    },
    {
      "id": "5f45c6bd-882a-409c-af4d-d2d5713430fc",
      "text": "President Zelensky announces creation of an International Legion / call for foreign volunteers"
    },
    {
      "id": "a0807413-350d-497a-957b-476c99bb7942",
      "text": "2022 general mobilisation decree in Ukraine"
    },
    {
      "id": "6516a31b-abc5-4f9b-aa9b-e52da0bd84d4",
      "text": "CDC/NCHS released provisional COVID-19 death counts and official guidance for certifying COVID-19 deaths"
    },
    {
      "id": "cbe425dd-91d0-4c9e-814f-307d666dfb05",
      "text": "Preprint and early analyses showing large excess deaths in the US and New York City during March–April 2020"
    },
    {
      "id": "f13763ab-b797-4cfc-b23a-dfda1e34d18d",
      "text": "Widespread media coverage showing overwhelmed New York City hospitals and temporary morgues (refrigerated trucks) in early April 2020"
    },
    {
      "id": "6793396c-a9aa-4a0b-84c1-27723d157956",
      "text": "Publication of Nicola Scafetta (2023) paper arguing a larger solar role in recent climate change"
    },
    {
      "id": "67e1df4f-0b25-4eb8-ae60-da8ed780fa20",
      "text": "Implementation of pictorial/graphic cigarette pack warnings (example: Canada began pictorial warnings in early 2000s)"
    },
    {
      "id": "42e1e786-eb16-4811-ac5a-3670a7e9f8cf",
      "text": "Publication describing bronchial anthracofibrosis/anthracosis with visibly blackened bronchial mucosa (Chung et al., Chest)"
    },
    {
      "id": "0662725c-2816-4d30-bdaa-0bc0158a79b9",
      "text": "NIOSH/CDC public information and media coverage about 'Black Lung' (coal workers' pneumoconiosis)"
    },
    {
      "id": "21321047-f657-460f-9cc4-e78bc25fb3fe",
      "text": "Battle of Ilovaisk (large Ukrainian military losses; widely published 2014 photos)"
    },
    {
      "id": "16c7e6a0-3a3e-46d8-afe7-c7ca955a57fa",
      "text": "Russian authorities publicly announced an investigation into the reported child death"
    },
    {
      "id": "0a078b3a-374d-49fe-af7e-9e2d0fe930f4",
      "text": "CDC PLoS One investigation of 'unexplained dermopathy' (commonly called Morgellons)"
    },
    {
      "id": "f3f9277b-7b33-4da8-bc76-dd68b1a43d28",
      "text": "President Biden publishes New York Times op-ed outlining U.S. role in Ukraine without explicitly repeating phrase 'within its internationally recognized borders'"
    },
    {
      "id": "e8d5e569-cd34-4e09-92ae-637153b746d6",
      "text": "The Vatican had produced (and publicised) a papal commemorative 'peace' medal in 2018 (designed by Chiara Principe) — a routine commemorative medal which can be given as a gift."
    },
    {
      "id": "3c0ec261-34f4-4f25-93bc-c9313bd979a1",
      "text": "Publication of Mawson et al. 'Pilot comparative study on the health of vaccinated and unvaccinated 6- to 12-year-old U.S. children' claiming higher odds of developmental delays, asthma and ear infections in vaccinated children."
    },
    {
      "id": "263b32f2-4856-4bd7-ad65-7bc111192dec",
      "text": "NOAA / Arctic Report Card and mainstream coverage documenting strong year‑to‑year variability in Greenland mass balance (including exceptional melt events)"
    },
    {
      "id": "3ca46107-397e-421b-b4d6-0dde20cd7129",
      "text": "Parliamentary records and news reports showed Boris Johnson’s office/company received a £1 million donation from investor Christopher Harborne."
    },
    {
      "id": "a7b94326-202d-41d5-a38e-7f325df8eebc",
      "text": "Reports disclosed large paid speaking advances and fees received by Boris Johnson after leaving office (including a £2.5m advance)."
    },
    {
      "id": "604fbd99-45fc-464d-83c4-c999705544cb",
      "text": "Coverage that Johnson was evasive with the advisory watchdog (Acoba) about proposed paid roles and consultancy work, including reports about a paid consultancy/hedge-fund role."
    },
    {
      "id": "191250d7-2c7b-44a0-84ad-1a7a97290061",
      "text": "Dmytro Yarosh's public profile as leader of Right Sector and commander of volunteer units, including statements he could 'send several battalions to Kyiv', was widely reported in the months before the Rada session."
    },
    {
      "id": "bac0f5a3-ea5d-44df-a3c1-9fcb9dd2e680",
      "text": "The first session of the newly elected Verkhovna Rada (8th convocation) on November 27, 2014 featured numerous newly elected MPs who were war veterans and volunteer battalion commanders attending in military fatigues."
    },
    {
      "id": "93b14285-af1e-4f08-84b9-e93ba8eda306",
      "text": "Publication/press coverage (Nov 28, 2024) highlighting that oceans emit cooling aerosols (sulfur) and can have a stronger cooling effect than previously quantified"
    },
    {
      "id": "161373df-fc56-4929-9699-2af1f305042d",
      "text": "NOAA report and data notes documenting record high sea surface temperatures in 2023"
    },
    {
      "id": "a98dad60-c241-402a-a088-d428675b3092",
      "text": "Strong negative Pacific Decadal Oscillation (PDO) signal in October 2024 noted by climate monitoring outlets"
    },
    {
      "id": "2ac71266-2c71-4d0d-8737-421fba19a828",
      "text": "Publication on improving full‑depth ocean observations using Deep Argo floats (Frontiers, 2023)"
    },
    {
      "id": "63ce55d7-4535-4422-bfa8-d00a22e51d68",
      "text": "Peer‑reviewed pilot trial published showing intravaginal Lactobacillus crispatus (chen‑01) transplantation reduced HPV viral load and improved clearance rates."
    },
    {
      "id": "a0797c91-72c2-4cbc-a7a2-eb2143464cd0",
      "text": "Ukraine's 2015 'decommunisation' laws and the domestic/international controversy over honoring OUN/UPA figures (e.g., Bandera) and historical memory debates."
    },
    {
      "id": "5ed0f63d-df88-4580-8a8e-48d5c9df57ad",
      "text": "Ongoing Kremlin information campaign and pro-Kremlin media narratives portraying Ukraine as 'glorifying Nazism' and repeatedly amplifying isolated incidents as systemic (documented in EUvsDisinfo reporting)."
    },
    {
      "id": "c267f3f8-4c62-40c9-8ed3-103959675502",
      "text": "Prior whistleblower allegations about CDC data handling (William Thompson statement alleging omissions in a 2004 CDC MMR study)."
    },
    {
      "id": "2763957d-043d-4c6f-90e7-3af562830017",
      "text": "Austria had launched a large-scale rapid antigen mass‑testing programme in early December 2020, putting antigen tests at the center of political and public debate."
    },
    {
      "id": "f046c44a-a2a4-49a4-b33f-4a775d713df4",
      "text": "Historical context: documented 1943 Volhynia massacres carried out by UPA (mass killings of Polish civilians in Volhynia and Eastern Galicia)."
    },
    {
      "id": "9a744018-8525-4ae6-8e3a-5c4aa6c6552b",
      "text": "Mainstream reporting (BBC) highlighted disproportionate COVID-19 deaths among Black, Asian and minority ethnic (BAME) communities in early April 2020."
    },
    {
      "id": "75c453eb-2738-450f-87f5-31098166ede2",
      "text": "Peer-reviewed analyses of 'normalized' disaster losses (e.g., Nature Sustainability 2018 study on normalized hurricane damage) showing that rising economic losses are driven largely by increased exposure and wealth rather than a clear climate-driven increase in frequency."
    },
    {
      "id": "297e88f8-7910-405d-bc54-514e7ab6044d",
      "text": "Nature commentary 'Climate simulations: recognize the \"hot model\" problem' highlighting that some new climate models run 'too hot' relative to historical warming."
    },
    {
      "id": "e99f2056-cf88-4c64-86df-0a48013a8870",
      "text": "Veterans Affairs slide-deck (interim guidance + VAERS tables) cited in the Judicial Watch release (data described as \"as of April 2021\")"
    },
    {
      "id": "83c742a8-914b-43e6-9971-d322cacd6287",
      "text": "European Court of Human Rights judgment (Mazepa and Others v. Russia) finding the investigation into Anna Politkovskaya's 2006 murder was inadequate and a violation of Article 2."
    },
    {
      "id": "13c7dc85-89b0-4e43-aa45-849ba1aa958e",
      "text": "Earlier acquittals and retrials in the Russian domestic process (initial acquittals in 2008–2009 and a 2009 order for further investigation)."
    },
    {
      "id": "f0932c14-0b9e-42a3-9963-dcfbfcf6bf87",
      "text": "May 2014 convictions of five men for Politkovskaya's murder without identifying or prosecuting an alleged mastermind."
    },
    {
      "id": "2dc6eb24-8335-40ca-90b6-c9398dfa00c9",
      "text": "Japan’s temporary suspension/recall and public reporting of Moderna COVID-19 vaccine batches after discovery of black/foreign particles in vials."
    },
    {
      "id": "25ecf7d1-558b-42d9-bf57-2bc303b8f36e",
      "text": "U.S. FDA Drug Safety Communication adding label warnings to statins about rare risks including memory loss and increased blood sugar (potential diabetes risk)."
    },
    {
      "id": "6638cc19-c306-44fc-999e-34ecb6344f36",
      "text": "Fatal shooting of conservative activist Charlie Kirk at a Utah university event"
    },
    {
      "id": "11f8567e-f853-4c9b-9c0b-ecbed2ab46bd",
      "text": "Series of arson and vandalism attacks on 5G masts in the UK amid COVID-19 lockdown"
    },
    {
      "id": "1a5858cb-924a-4f99-9863-0e4a6f688c72",
      "text": "Russian law signed criminalizing 'knowingly false' information about the military (encouraging tighter control of narratives)"
    },
    {
      "id": "305809ba-0615-43e6-9a5b-5171703b2b34",
      "text": "U.S. approval of Javelin anti‑tank missile sale to Ukraine (U.S. military assistance increases)."
    },
    {
      "id": "31ec4e9d-d48f-44e2-8a6f-c7bd59206baf",
      "text": "Kerch Strait incident — Russian FSB seized three Ukrainian naval vessels after a clash in the Kerch Strait."
    },
    {
      "id": "66daa508-94e3-4524-99cf-9dd30b99355d",
      "text": "Sea Breeze / NATO maritime activity in the Black Sea (mid‑2018 exercises, increased SNMG presence)."
    },
    {
      "id": "44c2738a-f13d-4a49-b5de-f70fe3e55d56",
      "text": "Contamination reports and suspension of Moderna vaccine batches in Japan (Aug–Sep 2021)"
    },
    {
      "id": "7c3c831b-2105-43a8-8ad0-76c73aee5715",
      "text": "January 2020 paper suggested snakes as a possible reservoir based on codon‑usage analysis"
    },
    {
      "id": "3f5b7328-b9a4-4069-b53d-757422e4629e",
      "text": "University of Arizona press release (Aug 2021) described an enzyme linked to severe COVID‑19 that is similar to neurotoxins in rattlesnake venom"
    },
    {
      "id": "68f43613-d2ab-47fa-b7af-29833557ed2b",
      "text": "CDC and FDA acknowledged rare cases of myocarditis/pericarditis after mRNA COVID-19 vaccination and updated guidance/warnings (June 2021)."
    },
    {
      "id": "ce2dddd3-4322-4e87-b3f8-f7e629923e04",
      "text": "High-visibility athlete cardiac incidents in 2021 (for example Christian Eriksen's on-field cardiac arrest at Euro 2020, June 12, 2021) and other sudden collapses widely reported."
    },
    {
      "id": "fcbbee15-4882-4121-9f07-7e273696aca8",
      "text": "Media coverage in 2021 of Moderna's patent filings and subsequent legal actions over mRNA intellectual property (e.g., Moderna sues Pfizer/BioNTech, patent filings/provisional applications cited dating before or during 2019–2020)."
    },
    {
      "id": "3b71ae7b-1b52-40e8-bee3-d373b84cc8b6",
      "text": "Increased promotion and discussion of ozone/oxygen therapies during COVID-19 (peer-reviewed reviews and preprints)"
    },
    {
      "id": "e214f73a-49c9-4a2d-b29e-9723e9a7174c",
      "text": "French audit and reporting of rising Paris 2024 budget concerns/overruns"
    },
    {
      "id": "61e54a09-0f7a-4c03-875f-2d3a5d4747df",
      "text": "Large-scale unrest and transport disruption in France (including the June 2023 riots after Nahel's killing and ongoing strikes)"
    },
    {
      "id": "4dd9a224-cfbf-4cd6-897b-6d2c3c3c063d",
      "text": "Ipsos global/European polling on attitudes toward Paris 2024 (May–June 2024 survey period)"
    },
    {
      "id": "2741f754-b74b-4c46-b971-fcef82ac4768",
      "text": "Anti-corruption police raid of the Paris 2024 organising committee headquarters"
    },
    {
      "id": "d55af143-5861-4236-8d45-a7c0d5ea6c83",
      "text": "South Africa suspends use of the AstraZeneca vaccine after a study suggested low efficacy against mild-to-moderate illness caused by the B.1.351 (Beta) variant."
    },
    {
      "id": "5279d4a3-a951-4943-b696-ec9d2055d349",
      "text": "Norwegian Medicines Agency reports (January 2021) deaths among very frail, elderly people shortly after receiving the Pfizer–BioNTech vaccine; authorities reviewed whether reactions contributed to fatal outcomes."
    },
    {
      "id": "3ee5c31d-14a2-4f64-be3b-b972347128e3",
      "text": "CDC and FDA recommend a pause (April 13, 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis in some recipients."
    },
    {
      "id": "c21d0dbb-a95b-4ceb-a71e-8fc3df881d95",
      "text": "EMA PRAC releases safety review concluding a possible link between the AstraZeneca vaccine and very rare blood clots with low platelets."
    },
    {
      "id": "3bb9c600-54d7-4db5-80d5-f9e07ae9b04d",
      "text": "John R. Christy congressional testimony asserting climate models overestimate warming and that policy actions would have negligible temperature impacts"
    },
    {
      "id": "6c6f1682-69b6-4831-be94-3557272332dd",
      "text": "CDC guidance shift and prior messaging that medical masks should be reserved for health workers; on 3 April 2020 CDC issued new guidance recommending cloth face coverings for the public."
    },
    {
      "id": "79699b3e-4c16-4dea-9c40-aab3eaaabdd7",
      "text": "WHO updated advice (5 June 2020) noting 'there is no direct evidence (from studies on COVID‑19 and in healthy people in the community) on the effectiveness of universal masking of healthy people'."
    },
    {
      "id": "4f781d9a-7f8e-4869-a794-a727324fac4d",
      "text": "Swedish government proposal to raise the voluntary repatriation (repatriation) grant to 350,000 SEK per adult (announced in government/media coverage)"
    },
    {
      "id": "13f0d944-6cf6-43c5-9220-7687d06e00be",
      "text": "Immediate clarifications and explanatory articles noting who is eligible (coverage by outlets like The Local and Swedish Migration Agency pages)"
    },
    {
      "id": "ec218a04-2242-49d9-b1d8-715213b7c515",
      "text": "Publicly known fact that Vega’s AVUM upper stage uses a Ukrainian‑designed RD‑843 liquid engine (manufactured by Yuzhmash/Yuzhnoye)"
    },
    {
      "id": "7eacfe5f-3336-4bdc-bc19-96e33288a5ce",
      "text": "Anti-Maidan tent camp at Kulykove (Kulikovo) Pole and sustained pro‑Russian protests"
    },
    {
      "id": "6a6ce671-7575-4245-941b-223ed81a25d0",
      "text": "Deadly clashes and Trade Unions building fire in Odesa (mass casualties)"
    },
    {
      "id": "2113de29-0bea-45ac-b7f2-5e321f002776",
      "text": "Pro‑Russian demonstrators stormed Odesa police headquarters and freed detainees"
    },
    {
      "id": "b12104e0-292f-4267-a6a6-1acc6bcc36cf",
      "text": "Large‑scale rocket/shelling attack on Mariupol and OSCE spot reporting on Jan 24, 2015 (high civilian casualties; intense media attention)."
    },
    {
      "id": "92d1fcfb-d3b8-479c-b78b-53de4f6df3c7",
      "text": "Donetsk bus-stop/mortar shelling that killed civilians and produced circulating images of victims (Donetsk bus station attack)."
    },
    {
      "id": "ae152faa-631f-4b0b-bf9e-7452367962ba",
      "text": "World Health Organization interim guidance (March 19, 2020) that did not recommend routine mask use by asymptomatic members of the public"
    },
    {
      "id": "10753f07-df9a-4f52-8209-d82451128083",
      "text": "2006 study linking unmetabolized folic acid (UMFA) to reduced natural killer (NK) cell cytotoxicity"
    },
    {
      "id": "68f0cb2c-642a-4030-a9b8-033e606d295f",
      "text": "Clinical reviews and professional guidance highlighting controversy over MTHFR testing and folate form choice"
    },
    {
      "id": "f78e8fb3-a5f5-4218-9658-3435aead73ba",
      "text": "Mid-season reports of low influenza vaccine effectiveness during the 2014–2015 Northern Hemisphere season (notably against A/H3N2)"
    },
    {
      "id": "eaff01f0-4388-4ced-be4a-e328a91d96d0",
      "text": "Publication of BMJ individual participant data meta-analysis reporting that vitamin D supplementation reduced risk of acute respiratory tract infections"
    },
    {
      "id": "28dd6232-27c1-41d7-88b4-2f787f02440d",
      "text": "Intensified Russian strikes and repeated damage to Kharkiv's energy and infrastructure in March–April 2024 (blackouts, strikes on power plants and residential areas)."
    },
    {
      "id": "302e816b-f422-46c4-86df-22ab149772ca",
      "text": "U.S. and international lenders publicly urged Ukraine to accelerate anti‑corruption reforms amid threats of aid reduction"
    },
    {
      "id": "7ff744b6-6709-480c-8c99-b17b322ef721",
      "text": "U.S. Assistant Secretary Victoria Nuland publicly warned in Senate testimony that 'oligarchs' and backsliding reforms threatened Ukraine's progress"
    },
    {
      "id": "acde9344-bbbe-415a-92ed-e790f274ea8b",
      "text": "Public opinion and polls in early 2016 showed a sharp decline in Poroshenko’s approval ratings, signaling political vulnerability"
    },
    {
      "id": "ead2fbdd-5723-42fc-ab0d-93d87a438a0b",
      "text": "Ukraine parliament dismisses Prosecutor General Viktor Shokin after months of pressure"
    },
    {
      "id": "a2d274d7-5dcf-4eb7-81b7-622b8e2e97a8",
      "text": "Panama Papers revealed President Poroshenko had registered an offshore company, prompting investigations and political criticism"
    },
    {
      "id": "87dce773-da40-4685-bc94-7aff0bcddddf",
      "text": "Amnesty International documents abductions, unlawful detention and makeshift detention facilities used by Ukrainian volunteer battalions (Aidar) in eastern Ukraine"
    },
    {
      "id": "716847ee-a725-462c-a6c0-1f9b9b407538",
      "text": "Russia issues large numbers of Russian passports to residents of Crimea after annexation"
    },
    {
      "id": "0f197dd8-0c8a-4426-919b-85d947fa246e",
      "text": "Israeli observational study reported increased emergency cardiovascular events in people under 40 during the vaccine rollout and third COVID‑19 wave (Sci Reports, 2022)"
    },
    {
      "id": "07b5174c-0004-467f-abed-bc4b6e7f8b04",
      "text": "Science/AAAS coverage noting that a subset of the newest climate models were running 'too hot' and discussing implications for impact studies."
    },
    {
      "id": "86c1ce58-0a09-4472-aa59-6b6e3cde7f37",
      "text": "Release of UAH Version 6.0 satellite temperature dataset (Roy Spencer & John Christy) showing lower tropospheric trends than some surface records."
    },
    {
      "id": "db1cb6eb-4be9-49d3-93dd-957097533883",
      "text": "1933 Soviet orthography reform (Kharkiv/1933 orthography) that altered Ukrainian spelling norms"
    },
    {
      "id": "f6019ddf-aedb-490c-b225-361650f56322",
      "text": "Ems Ukaz banning many forms of Ukrainian-language print and performance (1876)"
    },
    {
      "id": "8dda9808-2665-4d8e-9f16-d03edf53b7a3",
      "text": "Valuev Circular limiting Ukrainian-language publications (1863)"
    },
    {
      "id": "6a373685-7592-4b18-9be4-7713a5157089",
      "text": "USDA published the National Bioengineered Food Disclosure Standard final rule (Dec 21, 2018)"
    },
    {
      "id": "574761de-312b-4720-bbda-afab392d4054",
      "text": "June 2021 CDC/ACIP review and MMWR publications acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID-19 vaccination in younger males."
    },
    {
      "id": "2ebc3f44-7446-4a79-a097-f252f3e44d7d",
      "text": "Associated Press published coverage (Jan 2025) that Ivanpah, once the world's largest concentrated solar facility, was likely headed for partial closure because it couldn't compete with cheaper photovoltaic (PV) technologies and faced environmental criticisms."
    },
    {
      "id": "d1d894f2-aa78-4b33-a4fd-1fb32b34b23e",
      "text": "Investigations and reporting (2014–2015) including U.S. Fish & Wildlife/press coverage documented elevated avian mortality at Ivanpah (widely reported estimates of thousands of bird deaths and descriptions of birds being burned by concentrated-solar 'streamers')."
    },
    {
      "id": "a74e82ad-2c97-4e7d-a8b5-14aeca0b1233",
      "text": "NRG Energy and the U.S. Department of Energy announced they finalized negotiations with Pacific Gas & Electric to terminate two long-term Ivanpah power‑purchase agreements (PPAs), setting in motion shutdown of two units beginning in 2026 if regulators approve."
    },
    {
      "id": "7a4afd2e-583b-4d1b-a751-28c295503c50",
      "text": "Public attention on waning Western political support for Ukraine (Zelensky's December 2023 pleas in Washington)"
    },
    {
      "id": "05008ca2-9f51-47b9-bcca-461e749a6dd1",
      "text": "Bloomberg opinion column by retired Admiral James Stavridis noting Russia's current aviation advantage"
    },
    {
      "id": "fba5a612-bb2d-4564-8e52-759918f1788f",
      "text": "Pro‑Russian protesters seized Donetsk regional administration and other government/SBU buildings and declared a 'People's Republic'"
    },
    {
      "id": "b9be3a7d-7b16-488a-9236-4f95aca31052",
      "text": "Public visibility of far‑right groups and symbols during Euromaidan (Right Sector, Bandera portraits, Celtic cross flags)"
    },
    {
      "id": "98f37028-97a3-4ac8-b09e-145a9b1fab36",
      "text": "Pro‑Russian separatists seized Ukrainian armoured personnel carriers and drove them through towns in eastern Ukraine"
    },
    {
      "id": "8fe772b0-3ed9-4ebc-a64a-9d70e8cacb35",
      "text": "IAEA Director General Rafael Grossi publicly expressed 'grave' or 'extreme' concern about the safety and security situation at the Zaporizhzhia plant under military control."
    },
    {
      "id": "a6b3be4f-41ad-4a8b-9d1a-da03c46f9462",
      "text": "Russian forces seized the Zaporizhzhia Nuclear Power Plant after nearby shelling; a fire was reported at the site."
    },
    {
      "id": "fc234567-2d65-4f37-960b-e9df75ff8fe3",
      "text": "Visible participation of nationalist groups (e.g., Maidan Self‑Defence/Right Sector elements) in the Odessa march and subsequent clashes."
    },
    {
      "id": "fc688e50-6c5a-4726-af4a-d7a1df92d2db",
      "text": "Indonesian drug regulator (BPOM) circulated guidance mentioning ivermectin among medicines for COVID-19-related distribution, prompting reports that it had been authorised for emergency use"
    },
    {
      "id": "02bcd9eb-45c6-4482-b342-3b8a229fe307",
      "text": "Official U.S. assistance and advisory activity for Ukraine was publicly documented (White House fact sheet on U.S. assistance to Ukraine, Nov 21, 2014)."
    },
    {
      "id": "bb80b8bb-dbb0-46ba-8994-3f0cf55d2f78",
      "text": "German newspaper Bild am Sonntag published a report (citing unnamed intelligence sources) alleging ~400 Academi (ex-Blackwater) mercenaries were operating in eastern Ukraine."
    },
    {
      "id": "ddedc3e3-39bd-46d0-baa5-3ddbae068501",
      "text": "YouGov poll (20 June 2022) showing Britons remain supportive of sanctions/assistance but growing wary as costs bite"
    },
    {
      "id": "227e6703-d39e-46a9-a329-3b7f3f31f194",
      "text": "Hansard parliamentary debate on UK and NATO military commitment regarding Ukraine (20 June 2022)"
    },
    {
      "id": "c73b9e35-7577-42d5-87bc-e70a594c5ae6",
      "text": "UK Health Security Agency technical briefings and early reports (Dec 2021–Jan 2022) documenting reduced vaccine effectiveness against symptomatic infection with the emergent Omicron variant"
    },
    {
      "id": "9838b08a-1ace-4d74-ba8b-fef731e6a024",
      "text": "Office for National Statistics (ONS) age‑specific COVID‑19 mortality data/releases showing very low death rates in younger age groups"
    },
    {
      "id": "df297219-9656-49d2-8640-9d432c60083b",
      "text": "Large cluster-randomized Bangladesh mask trial published in Science (Nov 2021) reporting a modest reduction in symptomatic SARS‑CoV‑2 infections and differing effects by mask type"
    },
    {
      "id": "ecae77c8-c18b-42b0-b44d-6cae9d7c6d13",
      "text": "Formation and large-scale fundraising by the 'Come Back Alive' foundation (Povernys zhyvym) to support Ukrainian forces starting in 2014."
    },
    {
      "id": "ab3e765b-00ed-46bf-bbca-4867fce50f80",
      "text": "Street vendors and souvenir sales around Maidan popularized buying Ukrainian-themed goods for fundraising and solidarity."
    },
    {
      "id": "8fb95e4e-2538-4403-b5d4-71f4f08ec94e",
      "text": "Vyshyvanka Day / 'Give the vyshyvanka to a defender' 2015 campaign increased sales/donations connected to traditional Ukrainian garments."
    },
    {
      "id": "58469760-1625-4a46-ae12-25b624877ece",
      "text": "Sharp decline in domestic automobile production in Ukraine documented in 2015–2016 (major contraction of car manufacturing)."
    },
    {
      "id": "a2f08d79-7fe6-4418-9146-13672ec98ce0",
      "text": "CDC guidance (May 13, 2021) stating fully vaccinated people could resume activities without wearing masks in most settings"
    },
    {
      "id": "a9d8cdb1-fc8f-4f3a-86ea-ef27564a398e",
      "text": "Regulatory investigations and temporary pauses over rare thrombotic events associated with the AstraZeneca COVID-19 vaccine (March–April 2021)"
    },
    {
      "id": "7c591d07-890a-4e2b-b07f-2101e9811438",
      "text": "Uttar Pradesh state government endorsed large-scale prophylactic and therapeutic use of ivermectin in its COVID-19 protocol and publicly attributed part of its relatively low case/fatality metrics to ivermectin use (reported May 12, 2021)"
    },
    {
      "id": "54715ef2-9d6d-43d2-b786-a9fcb1146ef2",
      "text": "Uttar Pradesh reports large number of ‘COVID‑free’ districts / very low active cases (official counts)"
    },
    {
      "id": "5a9df2c6-1051-481f-8995-20bb7f272aa9",
      "text": "WHO issues guidance advising ivermectin only be used for COVID‑19 within clinical trials"
    },
    {
      "id": "1fb7b3ec-b48f-4a41-907f-b3fc93458af9",
      "text": "Surge in herbal and immune‑support supplement sales during the COVID-19 pandemic (record growth in 2020)"
    },
    {
      "id": "b9bb18de-39bd-4aa5-bf88-038fde6b416e",
      "text": "Cochrane review reporting limited preventive effect of regular vitamin C on common cold incidence in ordinary population"
    },
    {
      "id": "cf7aabbd-5f45-4051-a00f-aaaa4b74a45d",
      "text": "Human Rights Watch (and other NGOs) called for a thorough investigation into the Odessa deaths, highlighting possible official inaction or failures"
    },
    {
      "id": "ff9a4801-3809-4274-8ff2-b61887727e12",
      "text": "Deadly clashes and Trade Unions House fire in Odessa (dozens killed)"
    },
    {
      "id": "0ca1163c-36fa-49e2-a8b3-ee240478ca9c",
      "text": "Media reporting and analysis documenting police/authorities' limited intervention and chaotic law‑enforcement response during the May 2 clashes"
    },
    {
      "id": "8fe8e09b-94f9-4887-bbe9-53ce062738d1",
      "text": "Amnesty International and other human-rights organisations document police crackdowns, intimidation and legal pressure on peaceful protesters in Poland (reports published 2017 onward)."
    },
    {
      "id": "6b80f2ca-5717-45fb-8509-1d1318b1f234",
      "text": "Poland’s president signs laws giving the government power to appoint and dismiss public broadcaster executives, effectively placing public TV and radio under direct government control."
    },
    {
      "id": "36275120-af4f-4f42-937b-825cf7b1bba5",
      "text": "The European Union triggers the Article 7 procedure against Poland (December 2017) over concerns about rule-of-law breaches, judicial independence and broader institutional capture by the government."
    },
    {
      "id": "ad1f6d5a-6fbe-4991-b391-6eea097ba6ca",
      "text": "Reporters Without Borders and other press-freedom indices record a marked decline in Poland’s press freedom ranking in 2016, citing government interference in public media and political pressure on journalists."
    },
    {
      "id": "ff4b0218-6ad8-4158-a09d-ccc01098b13c",
      "text": "Large public and veterans' protests against Zelensky over anti‑corruption and governance moves"
    },
    {
      "id": "8542cdd9-b0b6-48b8-9de3-00467d99bdbf",
      "text": "President Zelensky dismisses Ukraine's Commander-in-Chief Valerii Zaluzhnyi"
    },
    {
      "id": "340865f4-4105-45f5-971c-91b0196fa214",
      "text": "Analyses and warnings about growing far‑right mobilization and past armed clashes involving nationalist groups"
    },
    {
      "id": "b0bdc020-aa8a-4957-a82a-19757ff66f58",
      "text": "Early limits and inconsistencies in U.S. testing guidance that undercounted cases"
    },
    {
      "id": "efb16d49-67a5-4fdc-82a9-8f602f332fb2",
      "text": "Authoritative agencies published comparisons noting similarities but important differences between COVID-19 and influenza"
    },
    {
      "id": "0e74f67b-3e61-4007-b6be-80bd0aac365c",
      "text": "NOAA 'Sea Level Trends' / Tides & Currents long‑term tide gauge dataset publication and guidance pages"
    },
    {
      "id": "a01511d4-be5d-44a9-8aef-f8ef676cdb9d",
      "text": "Major media coverage summarizing Nerem et al. (2018) (e.g., The Guardian 27 Feb 2018)"
    },
    {
      "id": "40aa8d69-a7d4-49c3-bdd0-de57bbff31d7",
      "text": "Publication of Nerem et al. (2018) PNAS 'Climate‑change–driven accelerated sea‑level rise detected in the altimeter era'"
    },
    {
      "id": "2ee0655e-d858-4d91-a7c4-7ab020f8b20d",
      "text": "Early–mid March 2022: Evacuations of wounded Mariupol civilians (including children) to hospitals in other Ukrainian cities such as Zaporizhzhia; news outlets published photos of evacuees being treated elsewhere."
    },
    {
      "id": "7d808e92-d4f1-41c4-a2ce-59bcc07b90e6",
      "text": "CDC/NCHS release on 2020 firearm-related deaths (March 17, 2021)"
    },
    {
      "id": "0457a908-d117-491a-8ee5-7d6ba6c19257",
      "text": "Journal of Patient Safety 2013 estimates of 210,000–440,000 deaths from preventable harm"
    },
    {
      "id": "6a4fd329-e94b-427b-aea1-bb26e6c34aed",
      "text": "Record 2018 California wildfire season (e.g., Mendocino Complex Fire in July 2018)"
    },
    {
      "id": "b6e556ba-5f57-429d-af0f-a86c90db91b4",
      "text": "President Poroshenko had signed a demobilization decree (No. 328/2015) in June 2015 scheduling demobilization during July–September 2015."
    },
    {
      "id": "539280bf-56c8-4465-bdcf-441cc11c40b0",
      "text": "Ukraine’s Ministry of Defence and other officials issued immediate denials, stating that conscription schedules are governed by law and the General Staff cannot unilaterally extend conscript terms."
    },
    {
      "id": "0cbdc320-0d45-45b1-bada-45f660611394",
      "text": "Widespread administrative complexity and public confusion over multiple mobilization/de‑mobilization orders since 2014 (partial mobilizations, different presidential decrees) created an environment where contradictory claims about service terms were plausible."
    },
    {
      "id": "7fd4d209-92d8-43f6-a978-4d0546466515",
      "text": "Peer‑reviewed reports describing isolation and characterization of the novel coronavirus (e.g., Zhu et al., NEJM)"
    },
    {
      "id": "bd58c05f-b93f-4af8-bdad-fc72957680f4",
      "text": "Russia recognised Donetsk and Luhansk as independent and ordered troop deployments"
    },
    {
      "id": "3bc54be7-e813-4259-b9e4-4803b179b0c3",
      "text": "High‑profile Turkish Bayraktar TB2 drone use for Ukraine highlighted internationally"
    },
    {
      "id": "40386eeb-3c9d-4768-ba69-df110a9669ad",
      "text": "Public Turkish statements emphasising support for Crimean Tatars and calling for Crimea's return to Ukraine"
    },
    {
      "id": "bffa340b-2243-4598-9c38-2f2d8e63cb48",
      "text": "Turkish President Erdoğan visited Kyiv and offered to mediate between Ukraine and Russia"
    },
    {
      "id": "45933205-c402-44c5-a3d4-8c4d29f3324b",
      "text": "U.S. Advisory Committee on Immunization Practices (ACIP) / CDC review and public statement (MMWR) in June 2021 acknowledging myocarditis reports after mRNA COVID‑19 vaccines while concluding benefits outweigh risks."
    },
    {
      "id": "bc2e8f0f-278c-41d2-8dc7-abe26dfb5c60",
      "text": "In vitro studies published in 2021 reporting that isolated SARS‑CoV‑2 spike protein can affect endothelial cells, pericytes or ACE2 signalling (e.g., Lei et al., Avolio et al.)."
    },
    {
      "id": "3a5825b4-b7fe-443e-baed-008f74f91a28",
      "text": "U.S. Department of Defense announced a $250 million security-assistance package for Ukraine."
    },
    {
      "id": "db314afe-80f3-46e6-b3e6-34d6477bd634",
      "text": "Kerch Strait incident: Russian forces seized Ukrainian navy vessels and detained sailors."
    },
    {
      "id": "2969412c-ef5d-4f42-bd8c-e2ae776e312a",
      "text": "Earlier U.S. transfers of lethal defensive systems (e.g., Javelin anti-tank missiles in 2018)."
    },
    {
      "id": "dc95d029-058e-44d0-82c7-d35a3250c5be",
      "text": "Text of the FY2020 National Defense Authorization Act (NDAA) circulated with provisions directing security assistance and reporting on Ukraine."
    },
    {
      "id": "9cb961b0-2975-4edc-b037-462ad4a4acd3",
      "text": "U.S. temporarily relocated embassy operations from Kyiv to Lviv amid Russian force buildup"
    },
    {
      "id": "c51c936d-dc4d-4413-907b-eedc9391ab1f",
      "text": "Russian missile strikes and attacks on Odesa region in early July 2022 (civilian casualties reported)"
    },
    {
      "id": "a2a21b0f-6a99-4285-8a53-f8faff778f2c",
      "text": "U.S. ordered evacuation of most embassy staff in early February 2022"
    },
    {
      "id": "245a35f3-5b3a-496e-afa6-cd0a9d64d880",
      "text": "U.S. Embassy in Kyiv officially reopened after months of suspension (May 18, 2022)"
    },
    {
      "id": "9173eff4-97ad-4bb5-8e6b-14709e083d90",
      "text": "ONS technical analysis (March 2022) 'Deaths involving COVID-19 by vaccination status' explaining that differences in non-COVID mortality by vaccination status were driven by changing composition of vaccinated groups"
    },
    {
      "id": "2b4a71c2-c0a0-495b-b631-8f80095ab4f1",
      "text": "Publication of the World Mortality Dataset and accompanying eLife paper (Karlinsky & Kobak) documenting cross-country excess-mortality estimates"
    },
    {
      "id": "bdb3e1ee-adc1-4b32-8391-fa9ea101b91e",
      "text": "Reports that cities (including Lviv) were reusing or digging up old graves and opening new burial areas to accommodate war dead"
    },
    {
      "id": "008f646a-c5e7-48e9-b395-853b78648e67",
      "text": "Collapse of the Nova Kakhovka (Kakhovka) dam on the Dnipro River, releasing large volumes of water and exposing reservoir sediments"
    },
    {
      "id": "cecfdd0e-e11b-4f69-a180-678077307002",
      "text": "Forensic teams exhumed mass graves in Bucha after Russian forces withdrew"
    },
    {
      "id": "611bc014-08ef-4abc-bb78-46cec459f5c8",
      "text": "Publication of scientific reviews and studies showing cemetery leachate can affect groundwater under certain conditions"
    },
    {
      "id": "ed81bfcd-bb28-485a-ad33-22c208f0ecc9",
      "text": "BBC report on corruption allegations in Ukraine's defence procurement, highlighting opaque contracting and alleged diversion of funds."
    },
    {
      "id": "1a401108-cec9-4a29-8ebb-bdd082fb667f",
      "text": "Verkhovna Rada passes the 2017 state budget under IMF conditions, with tight fiscal limits on public spending."
    },
    {
      "id": "7f84a657-9499-4925-b019-156b43762020",
      "text": "Media coverage (KyivPost) of targeted pay increases in 2017 that boosted frontline soldiers' wages more than others."
    },
    {
      "id": "3fcab9b8-b6dd-4bbc-946b-27da40e232d4",
      "text": "IMF staff report and government commentary (2016) warning about a high public-sector wage bill and urging fiscal restraint and reform."
    },
    {
      "id": "8f07eb68-00a2-4867-b067-e9865a538313",
      "text": "Razumkov Center identity survey (fieldwork March 3–9, 2017) reported regionally varied answers on 'citizen of the former USSR' (cited in coverage)"
    },
    {
      "id": "04ba5a5c-9527-43f5-916e-b911c3a441d2",
      "text": "Gorshenin Institute / Friedrich‑Ebert‑Stiftung publicised a July 2017 survey ('Ukrainian society and European values') whose mixed subgroup breakdowns were publicly presented"
    },
    {
      "id": "9d1576e4-3a78-4fdb-8e00-0e46b85db6fd",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I – Summary for Policymakers released, stating 'It is unequivocal that human influence has warmed the atmosphere, ocean and land' while also presenting ranges/uncertainty for climate sensitivity and attribution details."
    },
    {
      "id": "49441f57-cb4b-439b-ae80-7dc20ca68fa5",
      "text": "Hunga Tonga–Hunga Ha'apai volcanic eruption (massive explosive eruption and atmospheric injection of water vapor and aerosols)."
    },
    {
      "id": "32f79435-fe11-4d8a-859b-4156f982c7a1",
      "text": "A small number of UN member states publicly recognized or expressed support for Russia’s annexation of Crimea (reported examples e.g., statements by Syria, Venezuela)"
    },
    {
      "id": "107525d3-a6d1-4661-8fc3-97818c3422d7",
      "text": "UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine’s territorial integrity"
    },
    {
      "id": "3a56cb72-b74a-4223-ac3d-0dcbe7a192e9",
      "text": "UN Security Council veto blocked a draft resolution condemning the Crimea referendum"
    },
    {
      "id": "43f86fbb-c78a-4fae-925c-8e1363978e79",
      "text": "Ukraine’s government signalled acceptance of the 'Steinmeier Formula' (early October 2019) committing to steps on special status/elections for Donbas"
    },
    {
      "id": "87c7fc14-b153-4c4c-bb81-721cba1b85ec",
      "text": "High-profile Russia–Ukraine prisoner exchanges in September 2019 (major swaps reported Sept 2019)"
    },
    {
      "id": "019c4880-7921-44f3-a24b-4ead99231cb3",
      "text": "Atlantic Council analysis (Oct 30, 2019) summarising polls that show many Ukrainians want peace but with important caveats (e.g., polls indicating ~69% favour compromise in some formulations)"
    },
    {
      "id": "b7470a85-016a-411a-956c-431a292989eb",
      "text": "Large 'Stop Capitulation' / 'No Surrender' protests across Ukraine opposing concessions (early October 2019, mass rally Oct 6, 2019)"
    },
    {
      "id": "09601652-9278-414f-9e73-debea62d2b9c",
      "text": "Ilko Kucheriv Democratic Initiatives Foundation / KIIS November 2019 public opinion survey (national) reported majorities on negotiating and preconditions for talks"
    },
    {
      "id": "18b49d65-cda8-4c8a-b14a-5e9183dd8f9b",
      "text": "Preprint serosurvey reporting SARS‑CoV‑2 antibodies in cats in Wuhan"
    },
    {
      "id": "0a9a6e37-c995-44c2-b020-eb4e95a33536",
      "text": "Public health caveats and cautious messaging (CDC/WHO) about animals and COVID‑19"
    },
    {
      "id": "cb25b9d1-b962-4e5f-857d-fe0ff139d644",
      "text": "Belgian domestic cat tested positive after owner with COVID‑19 (human→cat transmission)"
    },
    {
      "id": "b657d758-6cb0-4f50-9705-1ecc489c1cae",
      "text": "Russian officials publicly demanded the release/publication of recordings and black box data, accusing investigators of withholding material."
    },
    {
      "id": "565e426e-e98e-48c0-8ddc-0b094636d559",
      "text": "Conflicting official statements about why MH17 was allowed to fly over conflict‑torn eastern Ukraine and whether Ukrainian authorities had closed relevant airspace."
    },
    {
      "id": "344bc6bf-1087-4258-874a-612ea4554b85",
      "text": "Japan suspended use of some Moderna COVID-19 vaccine batches after reports of particulate contamination in vials (August 2021)."
    },
    {
      "id": "d0b97879-7a8d-4815-88e9-070893f31d88",
      "text": "Norwegian health authorities reviewed reports of 23 frail elderly patients who died shortly after receiving the Pfizer/BioNTech vaccine and issued guidance about vaccinating very frail elderly (January 2021)."
    },
    {
      "id": "33a8f32d-d60a-400b-a04d-678bcd8bb932",
      "text": "December 2022 peer-reviewed autopsy study examining 35 people who died unexpectedly within 20 days of COVID-19 vaccination reported possible vaccine-induced myocarditis in a small number of cases and was widely shared."
    },
    {
      "id": "a29fe756-de69-48fe-a88b-c881add7f1bd",
      "text": "Russian leadership accuses Ukraine of plotting terrorist/armed incursions (Crimea)"
    },
    {
      "id": "92f05824-1cf6-48fd-adb3-12ccb30e92c3",
      "text": "Rapid Trident 2018: Ukraine‑NATO joint military exercises in Lviv region"
    },
    {
      "id": "b8460d5b-4ae0-43bc-b8e6-8920c60104dd",
      "text": "FDA Vaccines and Related Biological Products Advisory Committee briefing documents (December 2020) for the Pfizer‑BioNTech vaccine noted transient changes in trial participants' lymphocyte counts"
    },
    {
      "id": "9ed82274-4dfd-4a08-9cf0-e54b6ed05a27",
      "text": "Reports of contamination (black/foreign particles) found in multiple Moderna vaccine vials in Japan, prompting suspension and investigation of batches"
    },
    {
      "id": "161c3e6c-1a57-4298-b101-4d55aa85ef1c",
      "text": "Public Health England (PHE) Technical Briefing 17 published with breakdowns of Delta cases, hospitalisations and vaccination status"
    },
    {
      "id": "595f05b3-4923-4276-a40b-30ff906894e4",
      "text": "Discovery of dozens of civilian bodies in Bucha after Russian forces withdrew"
    },
    {
      "id": "fc414cf9-8ffc-4069-8353-392b7823db8e",
      "text": "Pattern of Russian accusations that Ukraine stages 'provocations' or 'false flag' incidents"
    },
    {
      "id": "f2b852a5-2358-425c-b489-7e98c562db41",
      "text": "WMO/other agencies reported unusually low Antarctic sea‑ice extents in 2022–2023 (e.g., WMO note on record low winter extent, September 13, 2023)."
    },
    {
      "id": "001367d2-684d-4b59-9805-f097572ee62a",
      "text": "IPCC Sixth Assessment Report (AR6) Summary for Policymakers released, strongly attributing recent warming to human influence"
    },
    {
      "id": "853d4468-5466-4497-ac59-9fb3906d05b5",
      "text": "Publication/coverage of papers predicting a 'modern grand solar minimum' and potential cooling (e.g., Zharkova et al. 2020)"
    },
    {
      "id": "20da7166-f5ce-4d8c-83f1-29c7e9cb057c",
      "text": "CDC released guidance for certifying deaths due to COVID-19 (guidance on cause-of-death reporting, explaining comorbidities often listed alongside COVID-19)."
    },
    {
      "id": "2882fc70-2d99-436c-9600-d832cb340c87",
      "text": "Publication and wide circulation of the Great Barrington Declaration (Oct 4, 2020), advocating 'focused protection' and highlighting differences in individual risk."
    },
    {
      "id": "78c6bf47-3270-4907-8e54-57ced25689d2",
      "text": "CDC reverses mask guidance for vaccinated people (July 27, 2021) following Provincetown/Barnstable County outbreak and director's statement"
    },
    {
      "id": "16c1596f-0638-4c9d-b521-04f920c7f851",
      "text": "Peer‑reviewed reports of myocarditis temporally associated with mRNA vaccination (Israel / NEJM reporting increased risk in young males)"
    },
    {
      "id": "e03ffb94-e08e-4651-9cc1-0095b2efd08f",
      "text": "Russia blocked an OSCE council statement condemning the Mariupol attack and publicly blamed Kyiv for the shelling"
    },
    {
      "id": "eb5e9dd2-7d04-4532-acfd-fb5f1aae9ef3",
      "text": "OSCE Special Monitoring Mission spot report (24 January 2015) published crater/direction analysis of the Mariupol strike (found impacts from north-east/east)"
    },
    {
      "id": "f4014cc2-8e57-4abb-bf52-07bcfb0f3b44",
      "text": "NOAA/NCDC summary reporting 2012 as the warmest and second-most-extreme year for the contiguous United States, citing ~34,008 daily record highs vs ~6,664 daily record lows."
    },
    {
      "id": "27897f54-49e3-4fae-9828-505f78bf9d1f",
      "text": "Publication of Keeling et al. (PNAS, 2017) reporting a global secular increase in carbon isotopic discrimination by land photosynthesis."
    },
    {
      "id": "707cfe8f-a312-4565-a0e8-0b194b657b05",
      "text": "Publication and broad media coverage of the 2016 'Greening of the Earth' study showing large CO2-driven vegetation increases (Zhu et al., Nature Climate Change) and NASA press releases highlighting a global 'greening' trend."
    },
    {
      "id": "163a3d3e-a21f-40ae-9fa8-3ad5e284327e",
      "text": "Coverage in mid‑2024 of Morocco’s expanded cloud‑seeding (Al‑Ghaith) programme and Spanish media concern that artificial rainfall efforts could affect neighbouring territories (reported August 28, 2024)."
    },
    {
      "id": "d7d98017-ceab-473b-9d1d-550fea381397",
      "text": "Catastrophic late‑October 2024 floods in eastern Spain (DANA) that produced widespread destruction and many viral images/videos."
    },
    {
      "id": "b662b0d5-6387-4160-9e87-512993dc9a40",
      "text": "Ukrainian government reported a substantial increase in defence spending for 2018, publicly committing more resources to the armed forces."
    },
    {
      "id": "e5e5ef80-c4d3-4483-95c6-0cd446834cdb",
      "text": "Verkhovna Rada adopted a new Law on National Security intended to bring Ukraine's security institutions closer to NATO standards (adopted June 2018; signed July 2018)."
    },
    {
      "id": "89c39233-7f7d-4a37-ad84-11944dc610f1",
      "text": "OSCE Special Monitoring Mission reported a noticeable rise in ceasefire violations and incidents in Donetsk and Luhansk during mid-2018."
    },
    {
      "id": "0c9bea1c-696e-45be-8e98-9455cb0f2893",
      "text": "Russia held its Vostok-2018 strategic military exercises involving ~300,000 personnel, heavy air and naval assets, and participation from China and Mongolia."
    },
    {
      "id": "cd094463-97a5-4de0-93ed-1325af5ef9fb",
      "text": "Russian authorities repeatedly announced large totals of 'humanitarian aid' deliveries to Donbas (official claims in 2015 of tens of thousands of tonnes delivered)"
    },
    {
      "id": "7c13746a-776d-491b-9b30-589340d3a403",
      "text": "Putin signed a decree simplifying Russian citizenship for residents of Donetsk and Luhansk"
    },
    {
      "id": "f6af0590-2398-4b94-9a2c-3853a58d618d",
      "text": "Russian 'humanitarian convoy' of hundreds of trucks crossed into eastern Ukraine without Kyiv's authorization"
    },
    {
      "id": "4279a432-41f9-4319-a3e0-6dbc7b8e4a6c",
      "text": "Kyiv City Council imposes moratorium on public use of Russian‑language cultural products in the capital (July 2023)"
    },
    {
      "id": "9cfc36a5-9f99-47a7-ad87-279683192158",
      "text": "Kyiv city renamed 95 streets as part of derussification campaign (August 2022)"
    },
    {
      "id": "4ab374f8-cf52-4af7-a885-10d80a4e5b2b",
      "text": "Presidential/National Security decision to sanction and take three pro‑Russian TV channels (112 Ukraine, NewsOne, ZIK) off the air (Feb 2021)"
    },
    {
      "id": "bd5ac819-2c81-4c5c-af79-03220d8e3334",
      "text": "Passage of Ukraine's 2019 language law strengthening the role of Ukrainian (Law No. 5670‑d)"
    },
    {
      "id": "a927a42f-bfe4-4e8f-b1eb-bdef9190965f",
      "text": "Court ban of the Opposition Platform — For Life political party (June 2022) following its suspension during martial law"
    },
    {
      "id": "c444c044-c221-4210-b7fa-34b86f049f7d",
      "text": "UNICEF/WHO joint statement announcing support to close a vaccine-derived polio outbreak in Sudan"
    },
    {
      "id": "e82efdc4-5571-4b8d-9765-cd146c3dd097",
      "text": "Government changes and public confusion over passport issuance procedures (Cabinet decision)"
    },
    {
      "id": "430ec1c2-241c-4cda-aa92-6aed75322855",
      "text": "Major Enerhoatom/energy‑sector $100 million kickback probe by anti‑graft authorities"
    },
    {
      "id": "650fc0df-e0d7-4bfb-860c-8f224e30a3fd",
      "text": "Anti‑corruption agencies search Andriy Yermak’s apartment/home"
    },
    {
      "id": "f7818a82-9d09-4ed7-8218-f09097a03a92",
      "text": "Pandora Papers disclosure linking Zelensky and close associates to offshore companies"
    },
    {
      "id": "495f48f0-a384-449d-89c3-48a288420008",
      "text": "House Science Committee oversight and subpoena of NOAA over the 2015 'pause-buster' study (Rep. Lamar Smith)"
    },
    {
      "id": "68889765-9ee5-49d1-b266-6c9e6048720b",
      "text": "CDC changes stance and recommends the public wear cloth face coverings (official recommendation)"
    },
    {
      "id": "135c3530-e90a-45f3-8a06-8ee429d8f40a",
      "text": "US Surgeon General Jerome Adams urges public to 'stop buying masks' amid shortages"
    },
    {
      "id": "94e71162-6f12-43d4-ba70-ab877e9b6516",
      "text": "Antonov and media reports noted AN‑178 production and delivery disruptions under COVID‑19/quarantine conditions in mid‑2020"
    },
    {
      "id": "1ab4c62b-51ea-4810-b93f-ee607919f70c",
      "text": "Ukroboronprom / Spetstechnoexport signed the export contract with Peru for the Antonov AN‑178 (first reported publicly)"
    },
    {
      "id": "c5204050-e2a2-4b54-85b3-15ef65842fe8",
      "text": "Poland's 2018 'Holocaust speech' / IPN amendment (criminalising some statements about Polish responsibility in the Holocaust)"
    },
    {
      "id": "354067ed-7f02-4349-9879-a50784d2ba8e",
      "text": "Scientific coverage that some COVID-19 vaccine candidates used long‑established fetal cell lines (HEK‑293, PER.C6)"
    },
    {
      "id": "3de16f03-4ac2-453c-a425-1cf9f45fa46d",
      "text": "Russia's domestic gas prices reported far below European levels (Gazprom commentary)"
    },
    {
      "id": "2f16d0f9-a68c-4d59-ba09-140b6999aa36",
      "text": "Ukraine suspends/begins to reduce purchases of Russian gas and pivots to European reverse‑flows"
    },
    {
      "id": "e1131622-5f85-4824-8567-9c32f350bc73",
      "text": "Pre‑existing academic and public‑health research documenting lower vaccination uptake in some Amish communities (example: 2021 study of northeast Ohio Amish vaccination patterns)."
    },
    {
      "id": "f7b91efc-6423-48b9-97fc-178304a45a95",
      "text": "Destruction of collateral sites (for example the Slovenian consulate in Kharkiv) and multiple simultaneous strikes in the city"
    },
    {
      "id": "99ad98ff-e094-4304-9d11-5284f0406703",
      "text": "Missile strike hit Kharkiv Regional State Administration building in Freedom Square (large explosion captured on CCTV)"
    },
    {
      "id": "00c0c884-7362-48f2-ba91-ceea4b4a9e24",
      "text": "Russian authorities designated Open Society Foundations 'undesirable' and banned OSF activities in Russia (2015)"
    },
    {
      "id": "71a1364f-ecb0-4cca-ab44-0b2ce7c4be17",
      "text": "Exiled Crimean Tatar leaders and other legitimate diaspora organizations publicly urged continuation or expansion of sanctions on Russia (e.g., calls from exiled Crimean Tatar leaders for more EU sanctions)."
    },
    {
      "id": "c5d07542-e14a-4255-890e-b87779f91086",
      "text": "Large-scale humanitarian presence by Polish authorities, NGOs and aid projects operating in Western Ukraine (shelters, joint UK‑Polish projects in Lviv) as part of wartime assistance."
    },
    {
      "id": "49486281-bb55-4060-a8ab-626377399a5a",
      "text": "Polish parliament (Sejm) adopted the \"Act on aid for Ukrainian citizens\" (special law) that simplified legal stay, work and social assistance for Ukrainians in Poland."
    },
    {
      "id": "fa3821ac-e9e0-4a8d-a6f2-d7335a37436b",
      "text": "Leaders of Poland, Lithuania and Ukraine (the Lublin Triangle) issued a joint statement and high‑level meetings in Kyiv demonstrating accelerated political cooperation."
    },
    {
      "id": "489b9acc-002d-4c9c-aa6a-76cfb525e91d",
      "text": "Reporting that Ukrainian troops ran out of ammunition and fled posts in Luhansk (June 2014), including accounts of units abandoning positions."
    },
    {
      "id": "83a03f8b-a852-4b0a-831c-c217ae86a7e2",
      "text": "Reports in 2014 that several Ukrainian troops crossed the border into Russia during heavy fighting in eastern Ukraine."
    },
    {
      "id": "eb66c65e-7b3f-4c2c-b083-de751245e517",
      "text": "Russia's formal recognition of the independence of the self-proclaimed Donetsk and Luhansk People’s Republics on Feb 21, 2022."
    },
    {
      "id": "94175f26-ab9a-4fab-94f9-cceb21ab1ed0",
      "text": "Japan suspends use of some Moderna vaccine lots after reports of foreign particulate matter found in vials."
    },
    {
      "id": "7ee48907-cc9c-43c9-ad87-8a0e9940923d",
      "text": "EMA declares a possible link between the AstraZeneca vaccine and very rare cases of unusual blood clots with low platelets."
    },
    {
      "id": "c06a7150-78ed-40ae-aac7-81b9f53c150f",
      "text": "Transparency International publication of the Corruption Perceptions Index 2022 (released Jan 31, 2023) showing Ukraine's CPI score and ranking"
    },
    {
      "id": "a119e35c-f046-4c85-b1f1-071ab9bd8e61",
      "text": "Release of the Joint Strategic Oversight Plan (JSOP) for the U.S. Ukraine response by the DoD/State/USAID Offices of Inspector General"
    },
    {
      "id": "420f7996-128b-4313-9010-4b8f4e19aef7",
      "text": "Media reporting that U.S. Congress was turning attention to oversight of Ukraine aid (Roll Call coverage)"
    },
    {
      "id": "d94c4350-9ee2-4657-a287-b9cc227a1c8e",
      "text": "Reporting that Kyiv and other areas organized distribution of rifles and ammunition to civilian militias (e.g., plans to distribute tens of thousands of small arms and millions of rounds)."
    },
    {
      "id": "ea8a6908-b00d-4ea8-8587-45b94d8b0aa8",
      "text": "Analyses and expert commentary raised early concerns that weapons flowing into/conflict zones could be diverted to illicit markets and organized crime in the region."
    },
    {
      "id": "b21ee972-2f02-48a4-b18a-5d96a751ea4e",
      "text": "Ukrainian president publicly urged citizens to 'take up arms' and promised to arm those willing to defend the country."
    },
    {
      "id": "665a5e96-ffeb-49b5-a375-bcd7d84ca008",
      "text": "Multiple reports described looting, chaotic seizures and movement of weapons during early weeks of the invasion, including eyewitness accounts of armory looting and seized materiel."
    },
    {
      "id": "0406c3cd-e5cb-4516-bf21-63c67e2af8e9",
      "text": "WADA added meldonium to the prohibited list effective 1 January 2016 and high-profile meldonium cases (e.g., widespread media coverage in early–mid 2016) kept doping in the headlines throughout 2016."
    },
    {
      "id": "940d45b3-70e6-46f0-a780-9809a99095b3",
      "text": "UEFA had run its largest-ever anti-doping programme at Euro 2016 and on 1 July 2016 published that all tournament doping tests had returned negative results."
    },
    {
      "id": "7eea76c1-8239-491a-b86c-c31c9c30d16f",
      "text": "Publication of a health-technology rapid review recommending consideration of pre‑treatment mouth rinses in dental settings (CADTH report on pre‑treatment mouth rinses)."
    },
    {
      "id": "ba7f3ae8-8319-4da8-85e6-0a669cd417b1",
      "text": "Publication of a peer‑reviewed review article (Use of mouthwashes against COVID‑19 in dentistry) noting that povidone‑iodine mouthwash/nasal spray may reduce viral load and cross‑infection in dental settings (May 4, 2020)."
    },
    {
      "id": "0590b5c9-0753-4758-96e1-e5cd76bd1166",
      "text": "Case series and literature review reporting 22 cases of new-onset inflammatory rheumatic diseases after COVID-19 vaccination (European Review for Medical and Pharmacological Sciences)"
    },
    {
      "id": "f4f4ef97-8303-45ba-9603-91a3735fb8d5",
      "text": "Release of a medRxiv preprint protocol and early scoping material (Sept 3, 2023) on COVID-19 vaccines and autoimmune disorders"
    },
    {
      "id": "305a64ce-3d96-48b9-967b-6c4e672c9be4",
      "text": "The New York Times publishes an opinion essay 'Donor Organs Are Too Rare. We Need a New Definition of Death.'"
    },
    {
      "id": "f4edccd9-7fcb-463d-8294-2bf292462be6",
      "text": "IPCC Special Report on Global Warming of 1.5 °C released, emphasizing much greater risks at 2 °C and urgency of rapid mitigation"
    },
    {
      "id": "a34b9494-4eaa-41ab-92cd-bc9b4997f860",
      "text": "United Nations Secretary-General and UN agencies issued high-profile warnings in 2018 about nearing a 'point of no return' and called for emergency action"
    },
    {
      "id": "4064f9b2-6d78-4be6-b53b-8c5fb1755764",
      "text": "Peer‑reviewed reports of increased myocarditis cases after mRNA COVID‑19 vaccination (large health‑care organization study)"
    },
    {
      "id": "2a499c9f-f3ec-4921-a1eb-3deb54c320c5",
      "text": "Steven R. Gundry AHA (Circulation) abstract reporting raised PULS cardiac‑test inflammatory markers after mRNA vaccination (abstract 10712)"
    },
    {
      "id": "fa4aa885-5e37-48f9-8d0a-08d2a35c8175",
      "text": "Patent filings in 1989 listing Robert W. Malone as an inventor on early RNA/mRNA delivery and vaccine‑related patents."
    },
    {
      "id": "43adff84-61a6-4eb0-af48-ef6a6f1e9198",
      "text": "Indexing and citation of Malone's 1989 work in biomedical databases (PubMed/Europe PMC) and secondary summaries."
    },
    {
      "id": "591b54f0-234f-48aa-9b47-5cc82c1a123c",
      "text": "Publication of 'Cationic liposome-mediated RNA transfection' (Malone, Felgner, Verma) demonstrating mRNA can be delivered into cells."
    },
    {
      "id": "55243c7c-b698-46e8-8008-84bface2b7d6",
      "text": "Reports of foreign/black particles found in Moderna vaccine vials in Japan and temporary batch suspensions (September 2021)"
    },
    {
      "id": "c5cd55fb-50c6-4f51-b2f0-29fb82011b39",
      "text": "Small pilot study reporting detectable SARS‑CoV‑2 spike antigen in plasma of some mRNA‑1273 (Moderna) vaccine recipients (Ogata et al.)"
    },
    {
      "id": "71402e8a-ca22-40f1-9cd8-a07cfd02c777",
      "text": "American Bird Conservancy (and other conservation NGOs) public statements and campaigns highlighting risks of wind farms to raptors and calling for 'bird‑smart' planning (e.g., ABC 'Rethinking Wind Turbines' materials and Vineyard Wind statement)"
    },
    {
      "id": "eb954d49-5502-4206-835c-3a10a98118b2",
      "text": "U.S. Fish & Wildlife Service final rule revising eagle incidental take permitting, including a general permit option for wind energy (Federal Register/public guidance)"
    },
    {
      "id": "a5e6f28a-ffd1-43ba-ac54-e6d89fb9b787",
      "text": "Release of Loss et al. (2013) meta‑analysis estimating annual bird collision mortality at U.S. wind facilities (widely cited ranges: ~140,000–328,000 birds/yr and broader ranges cited elsewhere)"
    },
    {
      "id": "fe4980dc-3fc5-42dd-808a-4f77b6a3e7d5",
      "text": "Russian Defence Ministry public statement accusing Ukrainian forces of using phosphorus-filled munitions near Hostomel (Gostomel) airfield."
    },
    {
      "id": "f0ed4a48-5cf3-449b-9af4-4103c61d6ee7",
      "text": "Pre-existing precedent of mutual accusations over incendiary/phosphorus use in earlier Ukraine conflicts (2014–2015), documented by monitoring bodies."
    },
    {
      "id": "7315e2cf-aa2a-44ac-9b7d-9e4011640123",
      "text": "UNICEF / UN agencies' early displacement reporting (end‑March 2022) showed millions fled Ukraine but the largest single share went to neighbouring EU countries (e.g., ~2.3 million to Poland by March 30, 2022)."
    },
    {
      "id": "be88cd00-7c75-437d-a4ed-2bce23314946",
      "text": "Multiple media reports in April–May 2022 documented evacuations from besieged cities (notably Mariupol) in which some evacuation corridors or buses ended up routing civilians into Russia rather than to Ukrainian‑held territory."
    },
    {
      "id": "5bf0bfe9-23b1-4f8f-831b-9226d131f1b2",
      "text": "Russian government issued a decree to simplify and fast‑track acquisition of Russian citizenship for residents of occupied Ukrainian regions (passportisation/policy announced May 2022)."
    },
    {
      "id": "73355a88-b3ab-4736-9530-0bf8fd22f429",
      "text": "Russian foreign minister Sergey Lavrov publicly claimed that more than 1 million people had been 'evacuated' from Ukraine into Russia."
    },
    {
      "id": "e8e77ba2-5e31-4ffc-a630-5e46fb225165",
      "text": "Publication of peer-reviewed lab research (Heliyon, PubMed Central) showing antimicrobial activity of onion skin extracts (in vitro)."
    },
    {
      "id": "6e1811d7-a4c1-4a6e-9814-a4a3571c86db",
      "text": "Ukrainian Ministry of Social Policy announced registration of 1.58 million IDPs from Donbas and Crimea."
    },
    {
      "id": "ee8baadc-7356-435a-b043-e036316c736f",
      "text": "IOM National Monitoring System report (June 2017) identified unemployment as the most problematic issue for IDPs and documented barriers to employment."
    },
    {
      "id": "6771a937-9b7e-4308-8778-5933007f13dd",
      "text": "Atlantic Council report (2015) and related studies documented employer discrimination and negative media portrayals against IDPs from Donbas (including job adverts excluding Donbas residents)."
    },
    {
      "id": "11b64097-6c56-48c5-b7f0-6c66a88ce389",
      "text": "International Tribunal for the Law of the Sea (ITLOS) ordered Russia to release three Ukrainian naval vessels and their crews"
    },
    {
      "id": "9d2dad3a-95e3-42b2-8f1a-365b650177e9",
      "text": "September 2019 Russia–Ukraine prisoner swap that included the release of 24 Ukrainian sailors seized in the Kerch incident"
    },
    {
      "id": "c0036d38-f86f-43a1-9d36-18b6cd875492",
      "text": "Anti‑NATO demonstration in front of the U.S. Embassy in Bratislava"
    },
    {
      "id": "30306578-b0f0-4d7b-95ec-b7ce6dffad27",
      "text": "Washington Post reports Western countries supplying more and heavier weapons to Ukraine (coverage of weapons shipments and policy shifts)."
    },
    {
      "id": "fcbc729e-4ebb-4e03-9ba1-bd46577a1afd",
      "text": "NATO and the United States announced reinforcements to Eastern Europe (ships, fighter jets and additional troops put on alert)."
    },
    {
      "id": "1e9aaf0c-a0a3-4e6c-9d50-f3a37bfc6b98",
      "text": "Reports that U.S. military trainers previously operating in Ukraine were being withdrawn as the invasion threat rose (indicating U.S. personnel had been present inside Ukraine)."
    },
    {
      "id": "de11a555-90f2-46ba-89ef-5e92182e5dd3",
      "text": "Continued availability/promotion of Hoxsey therapy in Tijuana, Mexico (clinics offering the regimen)"
    },
    {
      "id": "fd8214fe-d447-43f4-9384-6c07f29437c1",
      "text": "Regulatory and enforcement actions against colloidal silver and related products marketed as COVID-19 treatments (FDA warning letters in 2020; DOJ injunction halting sale of silver product April 29, 2020)."
    },
    {
      "id": "bec8002a-957a-4b2d-bd52-ecd09a473411",
      "text": "Publication of randomized trials showing some benefit for inhaled budesonide in early COVID-19 (STOIC trial / Lancet Respiratory Medicine reporting, April 2021)."
    },
    {
      "id": "9e897f33-59ed-4230-895d-0ade8df6be15",
      "text": "Amnesty International briefing (October 2014) documenting summary killings in eastern Ukraine while cautioning that some atrocity reports had been misreported or exaggerated."
    },
    {
      "id": "7a0c3805-7034-4d3f-93c1-658b2953d611",
      "text": "Discovery and media reporting of a mass grave near Sloviansk (exhumed July 24, 2014) during the eastern Ukraine fighting."
    },
    {
      "id": "e70b9ad6-7291-4149-b3cb-9a37e8322e8e",
      "text": "Formation and visible operations of the Azov volunteer battalion (formed May 2014) alongside National Guard units in 2014, generating reports about far‑right elements within volunteer units linked to the state security apparatus."
    },
    {
      "id": "123b1d82-f1cd-4622-86c1-30cbc193b7d7",
      "text": "Parliament adopts the 2019 'On ensuring the functioning of Ukrainian as the State language' law"
    },
    {
      "id": "64b6ac59-947b-4ff6-ae5d-2d3f567513fa",
      "text": "President Zelenskiy/NSDC sanctions and broadcasting blocks on three pro‑Russian TV channels"
    },
    {
      "id": "98d9880a-94a8-43e1-8692-398e6eb9ab41",
      "text": "Passage of decommunization laws banning Soviet symbols and reshaping public memory"
    },
    {
      "id": "72a28c90-6734-41ff-99bd-7e7f704a0df1",
      "text": "Adoption of the 2017 Education Law with provisions on language of instruction"
    },
    {
      "id": "b43897b3-fbd6-4677-96a7-879a951f0d8f",
      "text": "Zelensky withdrew or delayed controversial decentralization/reintegration bills (including a draft on decentralization/reintegration of Donbas) in early 2020 amid criticism and revision."
    },
    {
      "id": "983cf193-fe53-4ef7-9d0a-1e4afaf5d452",
      "text": "Domestic controversy in Ukraine over the ‘Steinmeier formula’ (autumn 2019) and protests against implementing Minsk‑related measures."
    },
    {
      "id": "39aabe6b-de06-4d4c-bd1c-6b45416c94d9",
      "text": "Early 2021 reports and papers documenting vaccine‑induced immune thrombotic thrombocytopenia (VITT) after adenoviral-vector COVID-19 vaccines (e.g., AstraZeneca), including cases of cerebral venous sinus thrombosis."
    },
    {
      "id": "73a2d70c-6ae8-4ab3-9243-499877a9229a",
      "text": "Israel ends mandatory water fluoridation (policy change reported August 2014)"
    },
    {
      "id": "6e6a39f4-391f-45b1-96f8-5db1f260e0dc",
      "text": "National Research Council (NRC) report 'Fluoride in Drinking Water: A Scientific Review of EPA's Standards' (2006)"
    },
    {
      "id": "8af698c2-5055-44a6-b5f7-112ad08b0b43",
      "text": "Arrest of four men by the SBU alleged to be smuggling uranium‑238 in western Ukraine"
    },
    {
      "id": "00ab3b97-6e21-4f23-b4c5-3d7a07cef906",
      "text": "Reports that conflict damaged or destroyed radiation detection/monitoring equipment supplied to Ukraine"
    },
    {
      "id": "54874259-749a-48ec-b11e-773e0bdb8c69",
      "text": "Peer‑reviewed assessment of radionuclide resuspension and atmospheric transport from the 2015 Chernobyl fires"
    },
    {
      "id": "0f81c463-7fc8-419c-b1cb-c8b675c31f82",
      "text": "WHO interim guidance on mask use updated (June 5, 2020)"
    },
    {
      "id": "681e732b-6457-4afc-be2c-ffa829b4b6c4",
      "text": "Publication of the Great Barrington Declaration advocating 'focused protection' (October 4, 2020)"
    },
    {
      "id": "3cfde12d-2dad-4c2e-aa55-b283a69f332c",
      "text": "Announcement of Operation Warp Speed / rapid vaccine development programs (May 15, 2020)"
    },
    {
      "id": "efad7ff7-104e-4b5f-9f70-db6054dfedfb",
      "text": "Public remarks by Ukraine’s TCG representative Iryna Herashchenko noting lack of progress on exchanges"
    },
    {
      "id": "c7445ec4-c898-413b-ab18-14896d7e1407",
      "text": "Background context: prisoner exchanges had been irregular/stalled since late 2017 (last major swap Dec 27, 2017), creating a longer-term perception of negotiation breakdowns"
    },
    {
      "id": "b77c3439-e11b-4cf4-b980-ef7fa9556cd4",
      "text": "Trilateral Contact Group (Minsk) humanitarian subgroup meeting (early May 2018) reported to have produced 'no results' on prisoner lists"
    },
    {
      "id": "ac0f6f8a-8d44-4d77-a4f9-b18247cb3c79",
      "text": "WHO interim laboratory testing guidance (March 19, 2020) describing that nucleic acid detection indicates viral RNA presence but does not directly specify infectious virus for all sample types."
    },
    {
      "id": "002ad764-192c-4309-9aaf-6df338407edf",
      "text": "Publication of the WHO-recommended/early RT‑PCR assay protocols (Corman et al., Eurosurveillance) that specify short primer/probe targets."
    },
    {
      "id": "54d08603-b334-4505-85e4-2e560ce4f257",
      "text": "CDC and FDA recommended a temporary pause in the use of the Johnson & Johnson (Janssen) COVID-19 vaccine following reports of rare blood clotting events."
    },
    {
      "id": "762e7eb9-c8a4-4aa9-b191-bee023e61b2e",
      "text": "United Nations’ admission of a role in the 2010–2016 Haiti cholera outbreak (U.N. acknowledgement, 2016)"
    },
    {
      "id": "980a2f59-eb2c-4c4d-abd3-431daae5ef23",
      "text": "1996 Pfizer Trovan drug trial in Kano, Nigeria (reports of child deaths and subsequent lawsuits)"
    },
    {
      "id": "3cfad4f3-6fc2-4f26-a834-a43a7b0794b7",
      "text": "Release of the NIPCC report 'Climate Change Reconsidered II' (skeptic alternative to IPCC) that downplays harms of rising CO2 and highlights perceived benefits."
    },
    {
      "id": "34b91876-9c9a-4c8c-ba6d-7e30fca86167",
      "text": "Public-health guidance and technical documents (e.g., UK 'Understanding cycle threshold (Ct) in SARS-CoV-2 RT‑PCR') explaining Ct interpretation variability and assay differences circulated during 2020."
    },
    {
      "id": "8d356c7e-c604-4cd5-811b-038ceb0c38b0",
      "text": "Peer‑reviewed/clinical comparisons published showing comparable detection rates between saliva and nasopharyngeal swabs (Journal of Infection letter, June 2020)"
    },
    {
      "id": "57e029f6-f514-4250-98b0-9829baf98d0e",
      "text": "FDA issues Emergency Use Authorization for Rutgers' saliva-based COVID-19 test"
    },
    {
      "id": "05e5f4e3-b600-4ab8-a59e-1dc2981fb49b",
      "text": "IPCC Fifth Assessment Report (AR5, 2013) presentation of sea-level projections with explicit uncertainty ranges and caveats."
    },
    {
      "id": "e1934da6-d4f8-409d-be74-719425fd79d4",
      "text": "US political signal: announcement of intent to withdraw from the Paris Agreement (President Trump, June 1, 2017) and sustained political amplification."
    },
    {
      "id": "9e63d817-1f55-40ca-a35c-e00a82a3a99f",
      "text": "Poland's competition watchdog opens proceedings against Gazprom over Nord Stream 2"
    },
    {
      "id": "fe346ac3-50e6-4b71-a9a5-9e964fe80cce",
      "text": "Poland's controversial 'Holocaust law' sparks international criticism"
    },
    {
      "id": "fd6df1e7-3ca7-42ed-b882-b39f19350f40",
      "text": "European Commission triggers Article 7 procedure against Poland over judicial reforms"
    },
    {
      "id": "d6ba753b-c0e4-42b7-bd2d-a92f2ee0dbc5",
      "text": "Law and Justice (PiS) strong performance in the 2019 European Parliament elections"
    },
    {
      "id": "f9699cb3-e907-45c3-9661-478a013893b5",
      "text": "Reports of illicit trafficking and discovery of radioactive sources in scrap/transport (Ukraine, 2015)"
    },
    {
      "id": "9194eb05-876a-4b47-a2b3-88a2a01df4e0",
      "text": "2015 wildfires in the Chernobyl Exclusion Zone and fears of radionuclide resuspension"
    },
    {
      "id": "0a98d06d-023c-44a0-9fc5-509d19b38745",
      "text": "Calving of iceberg A‑68 from the Larsen C ice shelf (July 2017)."
    },
    {
      "id": "b5b0482e-4cc2-4e41-ab3d-f19bb86d1812",
      "text": "California expanded laws and funding to increase prescribed and cultural burning (state bills and Newsom signings, October 2021) to reduce fuels."
    },
    {
      "id": "26b3f753-b6a2-48c1-9d6a-cbe595e9cf9a",
      "text": "California utilities implemented mass Public Safety Power Shutoffs (PSPS) in 2019 to prevent power‑line ignitions during high‑wind conditions."
    },
    {
      "id": "2f9cbcfd-eb09-4056-a5ff-7cf0d1db3fd7",
      "text": "Public statements and media interviews by frontline firefighters expressing that poor forest conditions and suppression policy (not climate change alone) drive severe fires (example: Sky News interview with California firefighter, Aug 2020)."
    },
    {
      "id": "f70c19fe-3505-4ab2-9ab0-6a45af387624",
      "text": "PG&E pleaded guilty to 84 counts of involuntary manslaughter and unlawfully starting the 2018 Camp Fire, confirming utility equipment ignition of a major California blaze."
    },
    {
      "id": "3779b2b4-72ad-4216-a393-f6f1dabd000c",
      "text": "UNDP/SEESAC and other surveys (2012–2016) documenting large numbers of small arms and light weapons — including unregistered/illicit stockpiles — in Moldova and the region"
    },
    {
      "id": "b2200702-6b63-4b01-87ff-017000ff0260",
      "text": "Kuwait arrests members of an alleged ISIS-supporting cell who reportedly claimed to have bought weapons via Ukraine"
    },
    {
      "id": "e90e8db6-9ef8-4098-9557-3bea5226e758",
      "text": "Public and political skepticism, local resistance and commentary about his appointment in Odesa (reports of local political tensions)"
    },
    {
      "id": "2ed54469-0ca1-4594-b9cd-6a4dd1ac5d39",
      "text": "Appointment of Mikheil Saakashvili as Governor (head) of Odesa Oblast"
    },
    {
      "id": "3ee694bb-64d1-4524-953b-9b6fce34fdc3",
      "text": "Cabinet of Ministers submits Draft Law No. 10449 on mobilization to the Verkhovna Rada"
    },
    {
      "id": "e31cb900-b1ee-4f20-b242-745cf43b93f5",
      "text": "Israel / NEJM studies (2021) reporting a small increased incidence of myocarditis after Pfizer mRNA vaccination, especially in young males"
    },
    {
      "id": "2617e451-8f84-4920-b2d0-2ef415157476",
      "text": "Japan suspends and recalls Moderna vaccine batches after discovery of black/stainless‑steel particles in vials"
    },
    {
      "id": "b4a79b96-99a9-4a91-b088-49b7050f5b95",
      "text": "UN/IAEA inspection mission planning and travel to Zaporizhzhia amid continued shelling and accusations by both sides."
    },
    {
      "id": "066b4c74-1302-45b0-baca-be4260f7c315",
      "text": "A fire and visible shelling at the Zaporizhzhia site during early March combat (surveillance footage showed a flare/impact on site)."
    },
    {
      "id": "5e40c84a-3e2d-4524-9438-1802d3a8cf3f",
      "text": "Repeated losses of external (off‑site) power to the Zaporizhzhia plant and reports that the plant was at times disconnected from its last external power line."
    },
    {
      "id": "c005ff75-a064-4a3c-86eb-eb86647b34a4",
      "text": "Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the Battle of Enerhodar."
    },
    {
      "id": "eb7f51c7-52d8-484f-be71-f870e79c177c",
      "text": "CDC changes public guidance to recommend cloth face coverings in public settings (official guidance posted April 3, 2020)"
    },
    {
      "id": "05cc23e5-451f-45c4-a3d8-baf02ed8b1cf",
      "text": "Study estimating high proportion of asymptomatic SARS-CoV-2 infections on the Diamond Princess cruise ship (Mizumoto et al., Euro Surveill., published Feb 2020)"
    },
    {
      "id": "14a7a112-b7eb-44ae-885d-f26b79d04d94",
      "text": "NEJM correspondence reporting transmission of 2019-nCoV from an apparently asymptomatic contact in Germany (Rothe et al., published Jan 30, 2020)"
    },
    {
      "id": "4a9507d7-da94-42f8-9b2e-a49c83431f77",
      "text": "OPCW Investigation and Identification Team (IIT) first report identifying Syrian government responsibility"
    },
    {
      "id": "c44b7722-081b-4cd1-93d5-faf1089228fa",
      "text": "Human-rights organisations report abuses by volunteer battalions deployed in Donbas"
    },
    {
      "id": "f531b748-c838-4a44-9e54-b10e5b546449",
      "text": "Integration of volunteer battalions (including Azov) into Ukraine's National Guard"
    },
    {
      "id": "30571462-7d39-4198-a6af-6fc2f680789c",
      "text": "March 2015 incident where armed men linked to oligarch Ihor Kolomoisky occupied state oil company offices"
    },
    {
      "id": "6c2dd03d-486d-4383-8487-648cc09d3bb4",
      "text": "Reports of timber import restrictions and new controls on Russian wood across Europe and the UK"
    },
    {
      "id": "58eac9be-2d07-44e7-9e0c-987bc00cd292",
      "text": "UK and allies impose wide-ranging sanctions on Russia after the 2022 invasion"
    },
    {
      "id": "87166f51-253e-4199-a77e-38acc46791b1",
      "text": "News coverage of reusable/eco toilet-paper products appearing on the UK market"
    },
    {
      "id": "718332a4-dd29-4f25-a473-6e8bd0cb22a3",
      "text": "Euronews published video coverage (Feb 5, 2022) of the Kharkiv Unity March showing large Ukrainian-language banners (e.g., 'Kharkiv is Ukraine') and many Ukrainian flags, with only a small number of English-language signs visible in brief shots."
    },
    {
      "id": "b82e5675-9079-4d76-af45-acd9d76427b1",
      "text": "Growing public debate and some evidence of souring Polish attitudes toward Ukrainian refugees documented in 2022 news reports and surveys."
    },
    {
      "id": "71aac4ad-c4ba-437f-88e3-7a7dd911dcb1",
      "text": "Leszek Sykulski and collaborators announced a Polish anti-war movement and proposed billboard campaign with the slogan 'This is not our war'."
    },
    {
      "id": "2219de3f-c10d-44d9-8348-98d0f76ea054",
      "text": "White House announces 50–52% economy-wide greenhouse gas reduction target (Leaders Summit on Climate fact sheet)"
    },
    {
      "id": "4467b4d6-6db4-4ae3-897f-c71b39b99b75",
      "text": "Poore & Nemecek (Science) meta-analysis showing high emissions from beef and animal products"
    },
    {
      "id": "fa4768e3-042a-4590-b80d-f9ed21f8bf63",
      "text": "EAT-Lancet Commission releases 'planetary health diet' recommendations (widely covered)"
    },
    {
      "id": "a00993e4-3a22-4689-a941-c00084c02859",
      "text": "Adoption of Ukraine's 2017 'On Education' law increasing Ukrainian-language instruction (and subsequent Venice Commission attention/criticism)"
    },
    {
      "id": "3644af40-9a18-458c-9b5a-baa30fcd42af",
      "text": "Lviv Oblast Council approves a moratorium on public use of Russian-language books, films and music in the region"
    },
    {
      "id": "ac7d8fef-743f-44d8-8eac-628150b093cb",
      "text": "2015 restrictions on Russian films and cultural imports (bans/curbs on films and some cultural products after 2014)"
    },
    {
      "id": "37d16f32-1c1a-4192-9912-dec4b8037c52",
      "text": "Reversal of the 2012 regional-language law (the Kivalov–Kolesnichenko law) after the 2014 Maidan changes"
    },
    {
      "id": "32886ec4-0e74-4f78-801d-9b086ef6e27b",
      "text": "U.S. safety monitoring system (CDC Vaccine Safety Datalink) detected a statistical signal for ischemic stroke in people aged 65+ after the Pfizer–BioNTech bivalent booster; CDC/FDA announced they were investigating the signal."
    },
    {
      "id": "47b8a608-dcab-4933-8d24-5f247103731b",
      "text": "Earlier vaccine safety controversies (notably rare clotting events linked to adenovirus-vector COVID-19 vaccines such as AstraZeneca in 2021) remained widely recalled and were used as precedent by commentators to suggest COVID vaccines can cause serious cerebrovascular events."
    },
    {
      "id": "fe0ea5fa-1a6c-42cb-8ea0-31fffcfc9bc8",
      "text": "Russia’s parliament approved President Putin’s request to use armed forces in Ukraine"
    },
    {
      "id": "bd31d7a2-a935-4379-88ae-94c01218bbbd",
      "text": "Chinese Foreign Ministry urged restraint and avoided direct comment on the Crimea referendum"
    },
    {
      "id": "82593280-f906-4578-88d1-6b4e7405ff9c",
      "text": "Unidentified armed men (widely reported as Russian forces) seized Crimean airports (Simferopol and Belbek) and other sites"
    },
    {
      "id": "c948621e-8d8e-4620-87ae-06fef41b1734",
      "text": "CMS release of the Medicare COVID-19 Vaccine Public Use File (PUF) / Medicare COVID-19 vaccine analysis"
    },
    {
      "id": "e711ca11-d42c-45bf-9930-5701725b1316",
      "text": "April 2021 pause and review of the Johnson & Johnson (Janssen) COVID‑19 vaccine after reports of rare blood‑clotting events (TTS)."
    },
    {
      "id": "84a2dfe6-43f4-460a-94a1-8b232d4f8d88",
      "text": "Japan suspended and recalled multiple Moderna vaccine batches after reports of contamination (stainless‑steel particles) at some vaccination sites."
    },
    {
      "id": "e5859b67-f473-4db3-b82a-d4d4fef700e0",
      "text": "Poland publicly pushed for coordinated EU action over Belarus and called for an extraordinary EU response after the election"
    },
    {
      "id": "c5a26d30-1663-472e-b98d-390d4844fdbe",
      "text": "Belarus opposition figure Sviatlana Tsikhanouskaya flees Belarus to neighbouring Lithuania"
    },
    {
      "id": "31934143-3c72-48e5-be8e-a14ffd12d5a4",
      "text": "Lukashenko publicly accused opponents and foreign states of meddling in Belarusian affairs (blaming outside influence) in early August 2020"
    },
    {
      "id": "e385647e-3102-4792-bcd1-19242a4fbbde",
      "text": "Scientific and review literature summarizing Traditional Chinese Medicine meridian theory and the popular \"tooth-to-organ/meridian\" charts (peer-reviewed reviews / PMC article)"
    },
    {
      "id": "e65b3ae6-623b-4823-972e-85f5db1077bd",
      "text": "Peer‑reviewed survey showing TikTok is a major source of health information for young women (published May 21, 2024)"
    },
    {
      "id": "c7568f75-5d33-4f78-ac5f-2b22b319ad9b",
      "text": "Longstanding 'hockey stick' controversy and critiques (McIntyre & McKitrick and public debate 2003–2007)"
    },
    {
      "id": "e806c81b-121d-4434-b5f9-7d826a8c8157",
      "text": "OSCE SMM spot report on shelling incidents in Mariupol (Olimpiiska Street) reporting civilian casualties"
    },
    {
      "id": "1e546e61-b8e7-495e-96a2-c3490a50dd21",
      "text": "High-profile shelling of a bus/trolleybus stop in Donetsk reported to have killed civilians (media reports, Jan 22, 2015)"
    },
    {
      "id": "7ad1f552-9b72-414f-8930-825c8c13f43b",
      "text": "OSCE SMM statement (weekly update) noting 29 people had been killed 'this year' as of mid-January"
    },
    {
      "id": "54359d28-7f5e-486b-a6de-9a497f40a798",
      "text": "IFRC deployment to assist Ukraine outbreak response (Red Cross mobilised to help contain largest measles outbreak in Europe)"
    },
    {
      "id": "dae23334-c486-4c05-99f8-ba15b075567e",
      "text": "EU visa‑suspension mechanism in law (Regulation creating a mechanism to temporarily suspend visa‑free travel, adopted 2013)"
    },
    {
      "id": "87ea2344-d684-49dc-8b7e-74f7e5c8236a",
      "text": "Deployment/arrival of U.S. troops to Poland as part of NATO rotations (Zagan arrival reported)"
    },
    {
      "id": "866df254-eab6-4e0f-9839-df235e8e45c8",
      "text": "Polish government passes resolution to create the Central Communication Port (CPK) programme"
    },
    {
      "id": "91e53de0-d41e-4e9b-8346-05a13a63aaea",
      "text": "NATO/US-led exercise Saber Strike 2017 mobilises thousands of troops and long tactical movements across Poland and the Baltics"
    },
    {
      "id": "268d049a-ff0d-446c-892e-be63bae981f7",
      "text": "U.S. President Donald Trump’s high‑profile visit to Warsaw and public expressions of closer US‑Poland ties"
    },
    {
      "id": "b3bf3acf-8658-4438-8fc3-9121b6ef3cf4",
      "text": "Public descriptions of CPK emphasise a large rail logistics centre and high‑speed rail links connecting the planned airport to the national network"
    },
    {
      "id": "a6a0d394-94e6-4004-b0a4-e2a766da0990",
      "text": "IPCC AR6 Synthesis Report (approved and released March 2023) summarizing complex carbon cycle information"
    },
    {
      "id": "0b9816b1-a151-4873-868b-f96734498575",
      "text": "Global Carbon Project publishes the Global Carbon Budget 2022 showing large natural carbon fluxes alongside high anthropogenic emissions"
    },
    {
      "id": "bde486b8-5144-404b-8859-bb1c36e4a7cb",
      "text": "The Economist published analysis 'A Ukrainian attempt to retake Crimea would be bloody and difficult' framing retaking Crimea as high‑risk and costly"
    },
    {
      "id": "19c2f557-90c5-4d02-b5b7-4fe2bedf2697",
      "text": "Poland announced it would transfer Leopard tanks/Leopard tank company to Ukraine (President Duda’s statement in Lviv)"
    },
    {
      "id": "ef8d9f19-4eb5-4e71-90c2-29af1784a1a7",
      "text": "Madrid (Spain) converted an Olympic-sized ice rink into a temporary morgue amid COVID-19 deaths (widely reported March 24, 2020)."
    },
    {
      "id": "f7f58c67-cfd7-44a8-bed6-6d2cf84f1177",
      "text": "Regulatory reviews and media coverage of rare AstraZeneca blood‑clotting events (European/UK reviews and reporting)"
    },
    {
      "id": "1aac101d-dacc-4be2-a5ce-3356f3be8bba",
      "text": "Large overnight Russian attack on Odesa's power grid caused region-wide blackouts"
    },
    {
      "id": "20b68f2c-ede3-4b79-8b30-f4f92f82e291",
      "text": "Publication of a broad 2021 review (Nutrients) summarizing diverse immune effects of bovine colostrum"
    },
    {
      "id": "df8f7af0-995d-4491-b720-0ed74aff1bd7",
      "text": "Contamination and design problems with the CDC's initial COVID-19 test kits (early 2020)"
    },
    {
      "id": "06b23df9-0ca4-4b22-9144-0b8fe4c6cc7b",
      "text": "Study showing RT-PCR cycle threshold (Ct) correlates with viral culture positivity (Bullard et al.)"
    },
    {
      "id": "9ba5945d-a92f-4753-8e7c-6950d4334327",
      "text": "IAEA and Ukrainian authorities publicly highlighted nuclear‑safety and remediation needs for Ukraine’s legacy nuclear and uranium sites, with heightened attention after 2014."
    },
    {
      "id": "8f16a64f-19ca-4010-9a3a-d0d2f845c4e9",
      "text": "Longstanding presence of large uranium mining and processing facilities in Zhovti Vody (Eastern Mining and Processing Plant), which has processed uranium ores since the late 1950s."
    },
    {
      "id": "5a10c5b4-40de-4c27-bc08-d2db418600f5",
      "text": "Ferrybridge motorway service station (UK) brought in a generator to power new EV chargers because of local grid-supply issues."
    },
    {
      "id": "24a7bb0e-8f0b-4530-9cd4-877c382ceb83",
      "text": "Reporting that Tesla's high-profile Harris Ranch 'Mega' Supercharger location has historically been supplemented at times by diesel generation to meet peak demand."
    },
    {
      "id": "4bdfc6c9-8b0d-4081-9009-7df88df8ca84",
      "text": "BMJ coverage summarising tens of thousands of reports of menstrual changes after COVID-19 vaccination (BMJ report on MHRA Yellow Card reports)."
    },
    {
      "id": "56f50319-d69b-4260-b71b-2e15ce63525b",
      "text": "Publication of a large Danish cohort study linking hormonal contraception with increased rates of antidepressant use and diagnoses of depression (Skovlund et al.)."
    },
    {
      "id": "57973400-71de-4136-93ea-3cd72006e34b",
      "text": "Release of international PCOS management guidance and reviews identifying combined oral contraceptives as first-line therapy for menstrual regulation and hyperandrogenism in PCOS (International evidence‑based PCOS guideline, 2018)."
    },
    {
      "id": "bb766db9-0ed3-48fa-a230-75de0238867f",
      "text": "High‑profile scientific attention on rapid changes at Thwaites Glacier (BAS reporting, Sept 2019)"
    },
    {
      "id": "6ddf7466-bb26-4196-b780-b6a7d105ddc9",
      "text": "Poroshenko had a documented public engagement on 23 September 2015 — a meeting with U.S. Senator John McCain in Kyiv."
    },
    {
      "id": "b40c1e53-d4ad-431f-9d68-08aa979479f4",
      "text": "Pentagon Inspector General report found that about $1 billion worth of U.S. weapons sent to Ukraine were not properly tracked."
    },
    {
      "id": "5ec8ac77-d6c6-4b49-ad58-6e7ed13bc035",
      "text": "President Trump ordered a temporary 'pause' on deliveries of U.S. military assistance to Ukraine following a heated Oval Office exchange."
    },
    {
      "id": "3a16f7f5-193e-45b4-9365-51e6a77e3c98",
      "text": "Prominent U.S. conservative media figures and commentators publicly questioned the scope and effectiveness of U.S. aid to Ukraine (for example, Laura Ingraham called continued aid 'a losing cause')."
    },
    {
      "id": "a591ba5f-94a6-48b5-ac58-cad39c32c43b",
      "text": "IPCC Sixth Assessment Report (AR6 WG1) release summarizing model performance and attribution of recent warming"
    },
    {
      "id": "fb6a025b-c13f-4d8d-ae4b-86c9bf023863",
      "text": "Publication (1989) of Malone et al., 'Cationic liposome-mediated RNA transfection' (PNAS), an early demonstration of RNA delivery into cells."
    },
    {
      "id": "24d68e62-8527-4803-a6fa-26ca777c2034",
      "text": "Think‑tank and Western analyst warnings that the Kremlin was building informational conditions to blame Ukraine for chemical or radiological false‑flag attacks"
    },
    {
      "id": "db778365-385d-4330-8788-2907d8173af1",
      "text": "Multiple European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine after reports of blood clots (mid-March 2021)"
    },
    {
      "id": "0d0f16d3-7244-40d6-8623-7bbc698bb8c1",
      "text": "Peer-reviewed genome-wide association studies (GWAS) identified an association between the ABO blood-group locus and COVID-19 susceptibility and severity, widely reported in the media in 2020."
    },
    {
      "id": "778d9125-bcbc-4421-8105-7e56bba3ac9c",
      "text": "Pre-existing disinformation narratives and documented propaganda techniques had been actively denigrating Ukrainian refugees across Europe since 2022 (e.g., claims that refugees are violent or criminal)."
    },
    {
      "id": "9fedbf3b-a1f8-43c1-a02f-d7906d208ace",
      "text": "Rise of anti-Macron / far-right political sentiment in 2024 (EU and national election results and commentary)"
    },
    {
      "id": "15d90801-1802-47bb-85d8-7cf0a6dadba7",
      "text": "WHO-China Joint Mission report (final report) published, summarizing early clinical findings and noting the role of underlying conditions and comorbidities among severe COVID-19 cases."
    },
    {
      "id": "60ef0746-59f8-4545-b93a-25210ec76915",
      "text": "Mass issuance of Russian passports to Crimea residents after annexation, with many seen lining up to exchange Ukrainian passports for Russian ones"
    },
    {
      "id": "ee2b5dde-c6a4-44e6-91e9-f790e10f5c1a",
      "text": "Media reports of waning Pfizer vaccine effectiveness from Israel (mid‑2021)"
    },
    {
      "id": "6b276ef2-2523-4c59-9fa1-fd01456deefd",
      "text": "Human Rights Watch report on unguided rockets and civilian harm in Donetsk"
    },
    {
      "id": "a455b48b-d608-4d35-8e42-fb15238e3c1e",
      "text": "Operation Protective Edge (Israel–Gaza), heavy photographic coverage of urban shelling"
    },
    {
      "id": "36551982-daa0-4a06-9ce2-7a5b46b08a44",
      "text": "UN OHCHR published reports documenting thousands of civilian casualties and human-rights violations in Donetsk and Luhansk since 2014"
    },
    {
      "id": "531512c9-2ff0-45a1-94e5-5f41bd786ffa",
      "text": "Government of Ukraine lodged an Article 12(3) declaration accepting ICC jurisdiction over alleged crimes on its territory (covering events since February 2014)"
    },
    {
      "id": "3042955d-53a1-4769-a6b6-37d95536e374",
      "text": "International Criminal Court opened a preliminary examination into the situation in Ukraine"
    },
    {
      "id": "0c0c7555-4cc9-4ac2-8d94-c6de26942ea5",
      "text": "Multiple U.S. states sought to restrict or suspend abortion services as 'non-essential' during COVID-19 emergency orders (March–April 2020)."
    },
    {
      "id": "1746fc40-2a42-4e97-a0c1-37b0a4e68a4a",
      "text": "Guttmacher Institute releases 'Abortion Worldwide 2017' report estimating ~55.9 million abortions per year (2010–2014)."
    },
    {
      "id": "501e49c3-266a-4a6b-a595-bcbb93614985",
      "text": "World Health Organization declares COVID-19 a pandemic (March 11, 2020)."
    },
    {
      "id": "a2d84b93-0df4-4e63-9670-f3d9a9a9dc14",
      "text": "European Court of Human Rights applied urgent interim measures (Rule 39) in the Ukraine v. Russia matter (13 March 2014)"
    },
    {
      "id": "064c16c3-68f4-41b1-be9e-990d256b0466",
      "text": "PACE (Parliamentary Assembly of the Council of Europe) suspension of the Russian delegation (10 April 2014)"
    },
    {
      "id": "e72daad4-3b24-4846-a74e-4a1d8b895eda",
      "text": "Public confusion about the ECHR's mandate versus courts that decide territorial sovereignty (March 2014)"
    },
    {
      "id": "c70dff2c-a58e-47a1-af56-83c11341163f",
      "text": "Heightened political polarization and emotionally charged Victory Day (May 9, 2014) events in Kyiv, with veterans, Communist Party contingents and pro-Russian demonstrators present."
    },
    {
      "id": "3bb8debd-6d9d-416a-9f04-208936f4533a",
      "text": "Regulatory enforcement and warning letters by FDA/FTC in 2021 highlighted widespread illegal disease/treatment claims in supplement marketing."
    },
    {
      "id": "351498c8-2a08-49fa-b6ac-4c644436ffe6",
      "text": "Reports of foreign fighters travelling to Donbas in 2014 (volunteers from Europe and beyond)."
    },
    {
      "id": "cbb7f4ca-acb8-4b3e-a9d2-1cc7a9064d6d",
      "text": "U.S. convictions of former Blackwater guards (October 2014) renewed media attention on private contractors' misconduct."
    },
    {
      "id": "448455c0-dec0-4c30-9c5f-aab743506784",
      "text": "Nisour Square massacre: Blackwater contractors opened fire in Baghdad, killing civilians."
    },
    {
      "id": "9d0098f8-dd9a-46f3-84b1-d414eaa77b49",
      "text": "Heavy fighting and shifting control in Mariupol, May–June 2014 (city taken and later retaken during the Donbas conflict)."
    },
    {
      "id": "03fc25c8-6565-4956-b018-43689aad9c23",
      "text": "Russian and pro‑separatist media claims in 2014 alleging American mercenaries operating in eastern Ukraine."
    },
    {
      "id": "6d0467df-7983-4515-ac57-1f12a57ca12b",
      "text": "Interview in Berliner Morgenpost where Poroshenko made a nuanced comment about sanctions during an official visit to Germany (covered 2 Feb 2017)"
    },
    {
      "id": "251313a8-e1f4-418f-b7ec-999fc0fb8382",
      "text": "High‑profile cases of Ukrainian artists (e.g., Ani Lorak) continuing to perform in Russia after 2014 and facing public criticism (documented controversies and petitions in 2014–2015)."
    },
    {
      "id": "5e82075f-1456-452c-aa6b-fdc95e1abdbf",
      "text": "Publicised blacklists, bans and ambiguous records of cross‑border performances (e.g., compilation lists and public debates about banned performers from 2014–2015)."
    },
    {
      "id": "5fceb450-5102-4bbc-9eb7-6c8ec2ddac81",
      "text": "Deadly Maidan shootings and clashes (Feb 18–20) with widespread reporting that Berkut units used lethal force"
    },
    {
      "id": "4de30eb0-80c4-47bc-aef3-b0084f707f82",
      "text": "Ukrainian government announced disbandment of the Berkut special police unit"
    },
    {
      "id": "7ff40f6e-eaec-4880-9537-3c9b00bbca5b",
      "text": "WHO published its COVID-19 excess mortality estimation methodology and model outputs (October 2021), highlighting gaps between reported COVID-19 deaths and modelled excess deaths across countries."
    },
    {
      "id": "3a076af1-11af-418f-aa40-3c6fa44ee4d0",
      "text": "Divergent national blood-donation guidance on post-vaccination deferral times (e.g., NHS/Blood Services clarifying differences)"
    },
    {
      "id": "3095f1fa-376e-45ba-be02-3c582ac40c20",
      "text": "Reports of vaccine vial contamination (e.g., Japan suspended use of some Moderna lots after foreign particles found)"
    },
    {
      "id": "0be4bc5c-7b5a-4ef4-a8d4-07615ddc8057",
      "text": "Documented frequency of climate-skeptic segments on major cable/news programmes (analysis of Fox News coverage up to May 2021)"
    },
    {
      "id": "175cfdfb-482b-40b7-841b-1ab0f30b4ad4",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I release and media coverage"
    },
    {
      "id": "dc0c35f8-e154-4f77-9985-1c9b26049328",
      "text": "Release of CDC v‑safe pregnancy registry supplemental tables and data used in the NEJM report"
    },
    {
      "id": "2332057b-0bbe-47b7-b70a-de96fc18e69c",
      "text": "Publication of NEJM 'Preliminary Findings of mRNA Covid-19 Vaccine Safety in Pregnant Persons' (Shimabukuro et al.)"
    },
    {
      "id": "2e1d7402-b82b-4b0a-9fb9-326fef12586b",
      "text": "FDA full approval of Pfizer–BioNTech vaccine (Comirnaty)"
    },
    {
      "id": "1046d912-9eb5-473e-b1e3-e44a58d9efc5",
      "text": "FDA expands emergency use authorization to adolescents (ages 12–15)"
    },
    {
      "id": "20687b4c-4568-43d0-a364-3e7b62415b93",
      "text": "HHS General Counsel Advisory Opinion clarifying PREP Act scope"
    },
    {
      "id": "f90c99fb-0f68-4211-8cea-f680b42202d2",
      "text": "NATO deployed Enhanced Forward Presence battlegroups to Estonia, Latvia, Lithuania and Poland"
    },
    {
      "id": "ebed6d47-3655-4cdb-9e0d-3e4b8b5250f4",
      "text": "Operation Atlantic Resolve rotations — U.S. armored and aviation rotations to Poland (2019)"
    },
    {
      "id": "8917d070-5d0c-4de1-956f-8133fb84f3b3",
      "text": "Trident Juncture 2018 — large NATO exercise in Norway with ~50,000 participants, aircraft and ships"
    },
    {
      "id": "951a6889-48e1-4ae7-9de3-f25591fa9d6b",
      "text": "Preprints and analyses estimating low infection fatality rates (IFR) from early seroprevalence data (John Ioannidis seroprevalence analysis, May 2020 preprint)"
    },
    {
      "id": "18930930-1a7a-4b78-b149-ff1350f161e4",
      "text": "Historical precedent: 1976 swine‑flu vaccination program and Guillain–Barré reports"
    },
    {
      "id": "624a8794-6072-4c14-b064-3cd0f7176f27",
      "text": "Professional guidance discouraging routine MTHFR testing (ACMG practice guideline)"
    },
    {
      "id": "ca820777-5138-42b0-83f8-a271af01a0d5",
      "text": "Peer‑reviewed 2020 paper (Mesnage et al.) reporting glyphosate effects on the gut microbiome / shikimate pathway"
    },
    {
      "id": "c41b52a3-cc15-4d6a-a1f7-a2b34b2bbbf9",
      "text": "President Zelensky announced draft legislation proposing a route to Ukrainian citizenship for foreign fighters"
    },
    {
      "id": "9353fc2d-ebee-4790-a39e-97f99d698f2c",
      "text": "Ukrainian Defence Minister Rustem Umerov interview saying Ukrainian men living abroad would be asked to report to recruitment offices"
    },
    {
      "id": "d13c190d-6b0f-4280-82c0-547610a559a4",
      "text": "Establishment and publicity around Ukraine’s International Legion and the large number of foreign volunteers since Feb 2022"
    },
    {
      "id": "91b4971b-0ca4-497f-b743-324a75fb24ec",
      "text": "German Justice Minister Marco Buschmann public comments that Germany will not force Ukrainians in Germany to return or serve for Ukraine (Welt interview referenced)"
    },
    {
      "id": "05a8230a-9e18-47f4-a599-5a2e22951aa4",
      "text": "Large multinational naval exercise Sea Breeze took place in the Black Sea (Sea Breeze 2018 concluded July 17, 2018), increasing military activity and public attention on the Black Sea/Crimea security situation."
    },
    {
      "id": "5d26cae6-70ae-4538-bffb-13c8cfdd12d3",
      "text": "Deputy Information Minister Emine Dzhaparova spoke at a round table titled ‘Returning of Crimea: the vision of Ukrainians’ and said Ukraine must be prepared for different scenarios to reclaim Crimea (ambiguous phrasing about readiness)."
    },
    {
      "id": "d929b334-9fdd-4c58-a430-ec532b3d7d49",
      "text": "Nationalisation of PrivatBank, Ukraine's largest lender (government takeover announced/implemented)."
    },
    {
      "id": "4b497d85-1ab7-4531-878e-a50a0bcdacd6",
      "text": "S&P and other agencies moved some Ukraine instruments toward default status after missed payments on GDP‑linked securities in mid‑2015."
    },
    {
      "id": "a02608af-40bb-43d5-8e01-4571f9e25918",
      "text": "Moody's downgraded Ukraine's sovereign rating to Ca amid debt-restructuring talks."
    },
    {
      "id": "e13fe5cc-b563-4cc5-b79a-229ae44115f0",
      "text": "American Journal of Medicine publishes McCullough et al., 'Pathophysiological Basis and Rationale for Early Outpatient Treatment' (includes discussion of hydroxychloroquine)"
    },
    {
      "id": "137c3a2c-b285-4f79-9f8e-668e81a104a3",
      "text": "High-profile political promotion of hydroxychloroquine (notably President Trump) in March–April 2020"
    },
    {
      "id": "5682313f-865a-458f-8e62-452d573278ed",
      "text": "Pope Francis’s earlier controversial 'white flag' remarks (widely discussed in March 2024)"
    },
    {
      "id": "50e0fbe0-6c0d-4be2-b076-f81b92f1837c",
      "text": "EU visa‑free travel for Ukrainian citizens comes into force"
    },
    {
      "id": "a4320de0-a712-485f-abda-679489aa1b6c",
      "text": "World Bank Ukraine Economic Update highlighting market and price pressures (Spring 2017)"
    },
    {
      "id": "0f7061b6-6043-4410-b704-61d7dd78a521",
      "text": "Publicly available cost‑of‑living/grocery index comparisons (Numbeo 2017 country rankings)"
    },
    {
      "id": "d154989b-b1ce-4814-bd5b-a69ca1172f9a",
      "text": "Provisional application of the EU–Ukraine Association Agreement (DCFTA) reducing trade barriers"
    },
    {
      "id": "7c2c28be-6cfa-4db3-8b1e-6de54c0cc24d",
      "text": "Ukraine installed a temporary dam and flow-control measures near Kalanchak in summer 2014 to block the North Crimean Canal."
    },
    {
      "id": "44da0a37-f82c-4cad-bfe5-e204c1db5323",
      "text": "报道 and explainers in 2014 noting Crimea previously relied on the Dnipro (via the North Crimean Canal) for up to ~80–85% of its freshwater, creating an acute water-security crisis when the canal was blocked."
    },
    {
      "id": "53494bc0-80d7-4d7e-96ba-5759ddcd5040",
      "text": "Historical wartime precedent: strategic destruction or manipulation of Dnieper/Dnipro dams (e.g., demolition of Dnieper infrastructure during WWII) documented in historical and reference sources."
    },
    {
      "id": "fe17246d-1e8c-4742-998a-439fed22ca9a",
      "text": "U.S. House Science Committee and partisan media attention to NOAA's 2015 study and whistleblower allegations (2017)"
    },
    {
      "id": "e8eb66b4-7cc2-4c98-9599-381d976cafd3",
      "text": "ICRC and Ukrainian Red Cross facilitated large evacuations from Sumy (joint operations to move civilians out)"
    },
    {
      "id": "f07a5bb2-52e0-4447-921c-e5afec933df2",
      "text": "Red Cross convoy to besieged Mariupol turned back and postponed evacuations after being unable to reach the city"
    },
    {
      "id": "f7a81fa7-f979-436f-8060-bb1009d450bc",
      "text": "VAERS is a public, passive adverse‑event reporting system (established 1990)"
    },
    {
      "id": "738d2afd-7833-497f-8017-f2aabab1b1a4",
      "text": "U.S. measles outbreak (highest cases in 25 years)"
    },
    {
      "id": "8fd28181-b001-45e4-9ee3-ed5e32911dcf",
      "text": "NOAA reporting and headlines on record atmospheric CO2 milestones (Mauna Loa surpassing ~410 ppm) in 2019"
    },
    {
      "id": "65cee6b7-dc37-42c9-8eed-7fba599b7d7e",
      "text": "Ukrainian government files bill to make 'Glory to Ukraine — Glory to the heroes' the official military greeting (bill No. 7549 registered)"
    },
    {
      "id": "e5178884-c3bd-49ae-b6c3-45172799ae66",
      "text": "Public debate and media coverage about the historical/political meaning of 'Slava Ukraini' (discussion of its origins and politicisation)"
    },
    {
      "id": "9697d1ed-6eb3-4678-ba13-e0e4ce60c850",
      "text": "Amnesty International report on abuses by the Aidar volunteer battalion operating under Ukrainian command"
    },
    {
      "id": "098bcd9d-ddf1-4c65-b0fc-34b8bea61b74",
      "text": "OSCE SMM Daily Report recorded outgoing artillery fire from government-controlled Svitlodarsk"
    },
    {
      "id": "80eae812-9302-4821-b61e-1bdd4f3addec",
      "text": "OSCE SMM documented fresh craters near a Ukrainian Armed Forces compound in Sartana assessed as caused by MLRS rounds fired from the south‑south‑east"
    },
    {
      "id": "23224cad-e128-4f5a-a52e-22a839d6851d",
      "text": "OSCE SMM reports noting the Mission was denied access on multiple occasions by Ukrainian Armed Forces personnel"
    },
    {
      "id": "109456e7-36bb-4930-9d93-ea01d1f2c8af",
      "text": "NIA-AA (National Institute on Aging–Alzheimer's Association) issues revised 2011 diagnostic framework introducing 'preclinical' and biomarker-based stages of Alzheimer's disease."
    },
    {
      "id": "5d6028ad-e08a-4e90-a37d-73ad42daa692",
      "text": "FDA narrows Emergency Use Authorization for COVID‑19 convalescent plasma to 'high‑titer' units"
    },
    {
      "id": "91f9f092-8711-4eec-8493-04025fd5e3c9",
      "text": "Reports of foreign/black particles found in Moderna vaccine vials in Japan"
    },
    {
      "id": "acdbdbb6-8f0c-4877-9f47-0cffb856d645",
      "text": "Scientific and public messaging on which antibodies vaccines induce vs. which antibody tests detect (spike vs. nucleocapsid)"
    },
    {
      "id": "af2cd870-1bfd-4c78-8511-26fb2be73bd3",
      "text": "Early New York State antibody study publicity suggesting many more infections than confirmed cases"
    },
    {
      "id": "2f77db8a-bdb2-4505-bafa-638be4613c24",
      "text": "Presidential election day (Ukraine) — March 31, 2019 — heightened political tension and information flows around polling stations."
    },
    {
      "id": "282392b6-8e67-4518-bf69-6d86fe0553bd",
      "text": "Zaporizhzhia local authorities moved to implement the 2012 regional-language provisions (local implementation granting Russian regional status)"
    },
    {
      "id": "a082ac54-2c02-41a7-ac77-27b198d48fa6",
      "text": "Vladimir Putin and Russian officials publicly labelled the post‑Maidan Ukrainian authorities 'fascist' and repeatedly evoked Nazi-era language (Putin speech on Crimea)"
    },
    {
      "id": "ff0e6625-2708-48a0-a9cf-76e34d20b270",
      "text": "Reporting on far‑right groups (Svoboda, torchlit marches) and far‑right figures appearing in the Maidan period"
    },
    {
      "id": "de7c7a6e-0670-4c9f-aaba-f57baab5ab18",
      "text": "Danish Defence Minister publicly notified parliament that Denmark will significantly reduce its military support for Ukraine in 2026 (planned allocation cut to DKK 9.4 billion)."
    },
    {
      "id": "a928cfbf-3c70-4ff1-a75c-c403bb49867c",
      "text": "Danish government publicised the multi‑year “Ukraine Fund” and large cumulative commitments to Ukraine (multi‑billion euro/kroner pledges across 2023–2028)."
    },
    {
      "id": "c356e4eb-e27d-4a3e-abe8-009c48fde26a",
      "text": "Official Danish Ministry of Defence material and public briefings documented multiple high‑profile equipment donations (F‑16s, tanks, air‑defence, coastal missiles and other packages) and ongoing deliveries through 2022–2024."
    },
    {
      "id": "16612cfd-8068-41f7-8172-2f740d431c9e",
      "text": "Analysts and media highlighted that non‑state‑party countries (e.g., India) are not legally bound to arrest ICC indictees"
    },
    {
      "id": "a555c8b9-1afa-4f97-b4dc-4481e73cbc26",
      "text": "International Criminal Court issues arrest warrants for Vladimir Putin and Maria Lvova‑Belova"
    },
    {
      "id": "8d221e15-abaa-4b86-bcd8-6c8f3992df82",
      "text": "Donetsk People's Republic leader Denis Pushilin announced DPR/Russian forces aimed to encircle Mariupol"
    },
    {
      "id": "35abddd0-8c9c-4eac-8f42-8331b2dc89b2",
      "text": "Russian troops entered the centre of Kherson and local officials reported rapid Russian advances"
    },
    {
      "id": "fc2341a7-a527-42d8-9b4e-47a15bdee23c",
      "text": "Reports and rapidly circulating images/videos showed Mariupol under heavy shelling and effectively blockaded by early March"
    },
    {
      "id": "c3c8f8e1-9283-4b90-97ed-3ac662aafa45",
      "text": "1979 U.S. Supreme Court decision (United States v. Rutherford) upholding federal restrictions on interstate shipment of laetrile"
    },
    {
      "id": "5331b603-f4f9-4c0e-8c5f-004eb0a84c42",
      "text": "Publication of major clinical evaluations showing no clinical benefit and cyanide risk (e.g., Moertel et al., NEJM clinical trial 1982 and later systematic reviews)"
    },
    {
      "id": "f1f95a39-34bc-46b6-8e23-9f376df7ccce",
      "text": "Reports that around 1,000 Ukrainians had contacted the embassy in Israel seeking help"
    },
    {
      "id": "459611c4-0b55-4923-91d6-d7adcad302d1",
      "text": "Hamas attack on Israel triggers widespread conflict and civilian displacement"
    },
    {
      "id": "3f8fdb93-471b-47ba-b68a-64e3317ebb5f",
      "text": "Mixed early reports about evacuation status: embassy statements that evacuation planning was underway alongside reports of delays"
    },
    {
      "id": "007f723c-0723-48e4-b50f-8d0dfe461ddb",
      "text": "Widespread Russian dehumanizing propaganda portraying Ukrainians and Zelensky as 'monstrous' or 'cannibalistic' figures"
    },
    {
      "id": "3f95d40a-106b-42a7-89f1-14b558e7a54f",
      "text": "WHO names 'vaccine hesitancy' as a top global health threat (2019)"
    },
    {
      "id": "373910f6-e433-4432-8fd1-36130b42aa58",
      "text": "Publication of high-profile scientific reviews and discussions about aluminium adjuvants (e.g., 2018 Nature review)"
    },
    {
      "id": "c4ba973e-5883-4b1a-b720-9168a9331158",
      "text": "1999 US recommendation to reduce/eliminate thimerosal (a mercury-containing preservative) from childhood vaccines"
    },
    {
      "id": "bc88db62-48ed-4917-9bb5-a865c3d0db76",
      "text": "Prominent climate scientist Michael E. Mann publicly stated that climate change worsened Hurricane Harvey in opinion/commentary and interviews."
    },
    {
      "id": "5288810b-8f88-4c33-a5e1-554dc6f37a57",
      "text": "General Medical Council (GMC) found Andrew Wakefield guilty of serious professional misconduct and struck him off the medical register."
    },
    {
      "id": "d55a0a6c-e4ad-4aeb-9e20-2b8b02de62c6",
      "text": "FDA issued Emergency Use Authorization for the Pfizer–BioNTech COVID‑19 vaccine"
    },
    {
      "id": "036b26ef-e527-40b6-ac69-92cd098d5a15",
      "text": "Japan suspended and recalled multiple Moderna vaccine batches after contamination reports"
    },
    {
      "id": "0c565dd5-edf4-4578-986c-6641418f5db6",
      "text": "FDA VRBPAC briefing document noted median ~2 months safety follow‑up for Pfizer Phase 3 participants"
    },
    {
      "id": "65eb6438-fe45-4492-b34b-a62197cf6a90",
      "text": "CDC updated guidance allowing fully vaccinated people to resume many activities without masks"
    },
    {
      "id": "5708038d-77b5-4d13-a3e0-17bf63cb3747",
      "text": "Sen. Ron Johnson and allied events highlighted raw VAERS report counts in hearings/press conferences"
    },
    {
      "id": "b8e1aa44-e0a9-4ac8-84c4-9b8d11ecc023",
      "text": "Publication of a Johns Hopkins patent application / patent covering an enhanced mebendazole polymorph (polymorph C) claimed to improve tumor delivery."
    },
    {
      "id": "334e0219-555f-4c2a-9e39-8bf18a633bfc",
      "text": "Publication of a widely-cited review 'Ivermectin, a potential anticancer drug derived from an antiparasitic drug' summarizing in vitro and mechanistic evidence that ivermectin can affect cancer pathways."
    },
    {
      "id": "27059d4c-ff52-4e1d-be06-22d58f3310cb",
      "text": "Registration and start of a human clinical trial (ClinicalTrials.gov NCT05318469) testing ivermectin in combination with immune checkpoint inhibitors (balstilimab or pembrolizumab) for metastatic triple‑negative breast cancer (trial start listed Oct 13, 2023)."
    },
    {
      "id": "c3bdd91c-c749-452e-9569-4a2f9ae816b5",
      "text": "International attention and IOC intervention after Kharlan's disqualification (IOC awarded her Olympic qualification spot)"
    },
    {
      "id": "465078fd-c082-499c-a845-cc0d9d17870a",
      "text": "Olha (Olga) Kharlan disqualified at World Fencing Championships after refusing to shake Russian opponent's hand"
    },
    {
      "id": "64c5c7aa-d736-4d89-ae48-bfbe4db56db1",
      "text": "Brighton Beach 'Victory Day' parade with visible Russian flags and veterans in Brooklyn"
    },
    {
      "id": "1ad1da71-c024-4520-94ef-d41f9192778d",
      "text": "Small anti‑war/anti‑intervention rallies in Washington where some attendees praised Vladimir Putin (reported by U.S. outlets in 2015)"
    },
    {
      "id": "8e768813-5b66-4e37-83ec-123e5540c0d2",
      "text": "NATO's Enhanced Forward Presence (eFP) battlegroups deployed to the Baltic states and Poland (2017)."
    },
    {
      "id": "debe366f-8ffa-4a17-a0ef-0aee5ed2f924",
      "text": "Sea Breeze multinational naval exercise in Odesa and Black Sea (Sea Breeze 2018)."
    },
    {
      "id": "cf99a0ac-603e-44ac-ae2e-09dda24cbbfd",
      "text": "Documented presence of foreign volunteers/foreign fighters in the Donbas conflict (2014 onwards)."
    },
    {
      "id": "ccbb31ba-c8f7-4e64-8d55-3478e29a9482",
      "text": "Repeated Russian accusations and official statements alleging NATO or Western troops were operating in Ukraine (and NATO rebuttals in 2014)."
    },
    {
      "id": "337fa8d2-b644-433d-b4e8-bdefe78aa9cf",
      "text": "Rapid Trident multinational exercise held in Yavoriv, Ukraine."
    },
    {
      "id": "cf62689b-6516-4810-8e42-520e8a51af3e",
      "text": "G7 Science Academies statement: 'Future of the Ocean' highlighting ocean acidification (G7, April 2015)"
    },
    {
      "id": "12665c7c-4759-4bff-8dd9-6ffe68c66a7e",
      "text": "Oregon State University / NOAA-linked study on oyster hatchery failures attributed to ocean acidification"
    },
    {
      "id": "f4b0e001-14ea-4e19-9fd3-d2673261ef60",
      "text": "Ukraine enacts anti‑collaboration legislation (Article 111‑1) criminalizing cooperation with an aggressor and occupation administrations."
    },
    {
      "id": "589cf6ad-04e0-4e4e-823a-bb0feaeeec39",
      "text": "Administrative changes and practical disruptions to social payments (pensions) for residents in temporarily occupied territories (procedures changed and payments routed to bank accounts; suspension rules existed if no receipt for months)."
    },
    {
      "id": "e175e96e-c4ee-4119-a591-68c65331d271",
      "text": "High‑profile arrests/prosecutions for 'collaboration' (example: Reuters report of an MP arrested on suspicion of collaborating with Russia)."
    },
    {
      "id": "f228463b-3209-4ab5-b4b1-b2e7c7ef4fa7",
      "text": "Reports of Russian control and disruption of communications in occupied areas (e.g., Russia rerouting/shutting down Ukrainian internet in Kherson and other occupied territories)."
    },
    {
      "id": "65c93c29-c19f-4bfb-adce-c6ff88be5baf",
      "text": "Earlier precedent of arrests and accusations of 'sabotage' in eastern Ukraine (April 2014): Ukrainian authorities detained suspected plotters in Luhansk."
    },
    {
      "id": "79a8797d-4911-444f-adbd-25112da20ee6",
      "text": "Reports of chaotic security conditions in Luhansk during 2014 (sieges, captures of observers, clashes) documented by international media and monitors."
    },
    {
      "id": "17c165a7-f46b-434b-b40d-59beec4cf8f0",
      "text": "U.S. Supreme Court upheld a federal ban on interstate shipment of laetrile (Amygdalin/\"Laetrile\" regulation upheld)"
    },
    {
      "id": "6bc80891-f4c9-43ca-83b2-d406d3cced6e",
      "text": "EFSA scientific opinion and public statement on acute health risks from cyanogenic glycosides in raw apricot kernels"
    },
    {
      "id": "52a4d931-645e-4f35-b15b-21d72e941182",
      "text": "N Engl J Med clinical trial (Moertel et al.) showing no anticancer benefit for amygdalin/Laetrile and reporting toxicity concerns"
    },
    {
      "id": "9371a93f-f012-48ac-a32f-1459138040b5",
      "text": "Peer‑reviewed measurement study showing non‑zero scattered dose to the thyroid during mammography and that specialized collars reduce that scatter (but concluding routine collars are not mandatory)"
    },
    {
      "id": "1d81f6e5-45a5-4b20-82c9-3a1c00a30b73",
      "text": "Pandemic‑related declines and disruptions in cancer screening and care were reported widely in 2020–2021"
    },
    {
      "id": "8fee9afa-94f1-4d3b-b00b-698f144156eb",
      "text": "Court decision and transfer of seized Russian-owned ammonia to Odesa Portside Plant for safekeeping after seizure by Ukrainian authorities."
    },
    {
      "id": "d974f925-7d5b-4af9-b23c-9339c4d670e2",
      "text": "Russian-backed separatists reported an ammonia leak after alleged Ukrainian shelling of a brewery in Donetsk, warning of a corrosive ammonia cloud and local evacuations."
    },
    {
      "id": "5d64db84-5725-45de-a4cc-af6f00b0de13",
      "text": "Ukraine's intelligence accused Russia of rigging a Crimean chemical plant with mines that could release about 200 tonnes of ammonia, an allegation reported in international media."
    },
    {
      "id": "81cb26cc-7a20-435f-9938-82133fb91546",
      "text": "Reports that the Togliatti–Odesa ammonia pipeline was damaged during the conflict, with both Moscow and Kyiv trading blame for the disruption of large ammonia shipments."
    },
    {
      "id": "810c1c1b-61db-4b62-a549-c29cdde268e4",
      "text": "EADaily publishes article repeating 'nearly 500' protesters blocking central Kyiv street"
    },
    {
      "id": "b080216c-ca3d-4222-b50b-c56fcb284fb6",
      "text": "On-the-ground situation was two small rallies and only a brief blockage (StopFake reconstruction)"
    },
    {
      "id": "b7cdada0-3565-44e2-89d4-19e85b983dfa",
      "text": "United Nations reported 'persistent and grave' human rights violations in eastern Ukraine, including civilian deaths from shelling (June 2015)"
    },
    {
      "id": "53901b4c-be30-4b13-9f82-7cfead29a8ad",
      "text": "Bus-stop shelling in Donetsk that killed multiple civilians, widely reported and investigated by OSCE"
    },
    {
      "id": "6bf7b171-73de-4735-b6ae-d178c397473c",
      "text": "Public health guidance (CDC/WHO) acknowledging limited data for infants and urging discussion between breastfeeding mothers and healthcare providers (CDC: COVID‑19 vaccines while pregnant or breastfeeding guidance)."
    },
    {
      "id": "c66b4692-19b9-41a5-a090-ccb6f50a7e2a",
      "text": "Large street brawl in Kolonaki (central Athens) involving Dynamo Kyiv supporters, with 18 people detained"
    },
    {
      "id": "550b2a2d-7bd6-4a73-9e39-0824d7ae2d79",
      "text": "Well-known past violent incidents involving Right Sector (e.g., Mukachevo shootout where Right Sector members exchanged fire with police)"
    },
    {
      "id": "1f7261c4-80f3-49e0-af1b-986a26c89dd7",
      "text": "IPCC Fifth Assessment Report (AR5, WGI) Summary for Policymakers published with cautious language on extremes, noting low confidence in long-term changes in tropical cyclone activity and stating current datasets indicate no significant observed trends in global tropical cyclone frequency over the past century."
    },
    {
      "id": "a5b7f496-f670-4373-ba88-6a8ab16932fa",
      "text": "High-profile political moments and media amplification of single cold/snow events used to dispute warming (for example, Senator Jim Inhofe throwing a snowball on the Senate floor in February 2015)."
    },
    {
      "id": "82697b90-a087-4e35-b0f9-705fd9546781",
      "text": "EU Emergency Trust Fund for Africa (EUTF) launched to address root causes of migration (Nov 2015)"
    },
    {
      "id": "7db588eb-ddae-490a-8882-0fbf8d168f6d",
      "text": "EU–Turkey statement (migration deal) committing EU funds to Turkey to manage refugee flows"
    },
    {
      "id": "1dd490f9-ca8a-40a7-bd5d-e3272082f00b",
      "text": "Visa‑free travel for Ukrainian citizens to the EU came into force (June 11, 2017)"
    },
    {
      "id": "28580450-6272-4d02-9a2c-f19fc0a0cadf",
      "text": "EU macro-financial assistance and broader aid packages to Ukraine after 2014"
    },
    {
      "id": "9fc21c98-7526-4b78-ae62-cd995e88e0a4",
      "text": "2015 European migrant/refugee crisis with large arrivals to the EU"
    },
    {
      "id": "56840951-e957-4b40-8408-90e8fe903357",
      "text": "UK government statement (June 19, 2023) to keep Russian assets frozen until Russia compensates Ukraine"
    },
    {
      "id": "699e06aa-9b2f-4b4f-9f76-95fc574a0ffd",
      "text": "H.Con.Res.66 (118th Congress) expresses support for using reparations paid by Russia while urging the burden not fall on U.S. taxpayers"
    },
    {
      "id": "e10eaa2e-0fc1-44fe-af4c-61b04e674d8c",
      "text": "Court orders and media coverage accelerating release of Pfizer vaccine trial and safety documents (judge ordered faster FDA disclosure)"
    },
    {
      "id": "9193020b-9629-4752-b592-6b6478600257",
      "text": "Public reporting and CDC/ACIP discussion of myocarditis/pericarditis cases after mRNA COVID‑19 vaccination (young males)"
    },
    {
      "id": "9316f4cf-149d-4a01-bb74-cbc75ae143f7",
      "text": "Contamination reports and suspension/recall of Moderna vaccine batches in Japan (August–September 2021)"
    },
    {
      "id": "dbb3a021-512a-4c53-a16e-530b1fe8ca13",
      "text": "Public reporting of reduced/negative vaccine effectiveness against Omicron infections (UKHSA/early 2022 analyses)"
    },
    {
      "id": "c51c441b-f875-4e14-b8a1-63786973cd3a",
      "text": "In‑vitro report that Pfizer/BioNTech vaccine mRNA can be reverse‑transcribed in a human liver cell line (Aldén et al., Curr. Issues Mol. Biol./PMC)"
    },
    {
      "id": "37d9a2a5-ee4b-41f7-8007-1c62d3954975",
      "text": "Russian bans and embargoes on Ukrainian imports (food and other goods) in 2014–2015"
    },
    {
      "id": "95fb97ff-0415-4bba-8c78-d0c21ca3e4e2",
      "text": "Sharp national GDP contractions reported for 2014–2015 (double-digit annual declines in quarters)"
    },
    {
      "id": "9ec6a6f6-9490-4023-93e3-c850eb34c1f3",
      "text": "Bilateral trade turnover between Russia and Ukraine collapsed (trade fell by around two-thirds in early 2015)"
    },
    {
      "id": "7124b769-715f-42dd-a1ef-40df517223f7",
      "text": "OFAC Crimean Sanctions Advisory (July 30, 2015) clarifying prohibitions on goods/services from Crimea"
    },
    {
      "id": "f427e28d-21d4-4a63-a8a1-00ccd3887e93",
      "text": "U.S. tariffs on steel and aluminum announced under Section 232 (March 8, 2018)"
    },
    {
      "id": "9ab78178-379e-4730-812d-2e5b680528b8",
      "text": "Department of Commerce antidumping petition — Carbon and Alloy Wire Rod from Ukraine (March 28, 2017)"
    },
    {
      "id": "819dffb2-0572-4f90-92c6-c41eef6a76e0",
      "text": "Exhibition of captured heavy equipment at the National Museum of the History of Ukraine in the Second World War (Kyiv) showcasing tanks and large vehicles"
    },
    {
      "id": "6d137a2b-7c97-41ae-95ba-3135144296c6",
      "text": "High-profile 2014 coverage of private ownership and legal disputes over WWII German tanks (Panzer IV auction / Paul Allen dispute, Sept 2014)"
    },
    {
      "id": "65dc0e58-bf84-41b7-b9dc-c03b479517c1",
      "text": "Publication of a peer‑reviewed rat study claiming prenatal exposure to Pfizer/BioNTech BNT162b2 produced ‘autism‑like’ behaviors in male neonatal rats."
    },
    {
      "id": "21a58d87-2911-4e0f-ac4e-1eab6d209d8e",
      "text": "Rapid Trident 2020 multinational exercise at the Yavoriv training ground in western Ukraine involving thousands of troops, including airborne units"
    },
    {
      "id": "252a33a2-7596-4ebc-813c-cd41a36e4854",
      "text": "Ukrainian Armed Forces reported 2,650 COVID‑19 cases among personnel"
    },
    {
      "id": "65fad128-4613-43ff-b921-391965d5747a",
      "text": "Norwegian reports of deaths in very frail elderly after Pfizer/BioNTech vaccination and subsequent national guidance to use caution in the most frail"
    },
    {
      "id": "2e82249f-7daf-4890-8ed1-8937ec73e255",
      "text": "Peer-reviewed reports of an association between mRNA vaccination and rare myocarditis cases (Israel, large health‑care database)"
    },
    {
      "id": "aac50ae1-a885-4137-b384-62bb31844f54",
      "text": "CDC and other agencies expanding booster recommendations and reporting reduced protection against infection over time"
    },
    {
      "id": "899e6a00-6f74-4b8e-a39f-40b710e636c9",
      "text": "CDC release of early real‑world effectiveness and policy messaging on RSV immunization (CDC newsroom release on nirsevimab effectiveness)"
    },
    {
      "id": "c3447a89-06cf-43fa-8a0e-fbac8fce1614",
      "text": "Russian seizure and loss of Ukrainian naval assets in Crimea (March 2014) weakened perceived Ukrainian naval capability"
    },
    {
      "id": "b835e906-d882-41eb-9501-c849698aac45",
      "text": "Sea Breeze 2016 actually began on July 18 with US, NATO and partner forces participating"
    },
    {
      "id": "68b756d7-f0c3-4d46-94c9-32214154be65",
      "text": "Russian forces install local, pro‑Russian administrators in occupied Kherson (Volodymyr Saldo appointed)"
    },
    {
      "id": "dd761619-d96b-428f-892c-73f53aa52d08",
      "text": "Mass refugee flows and internal displacement from Ukraine in March 2022 (millions fleeing abroad or displaced internally)"
    },
    {
      "id": "5984d932-6e0d-489b-85b7-61da3f544b00",
      "text": "Arrest of pro‑Russian politician Viktor Medvedchuk by Ukraine's security service"
    },
    {
      "id": "7d2a6301-1e44-4b4c-9a93-336484d1b689",
      "text": "President Zelenskyy signs decrees blocking pro‑Russian TV channels and licences revoked"
    },
    {
      "id": "cce8b016-f0dd-402a-88fc-d8fbdd754c14",
      "text": "Suspension and later bans of multiple pro‑Russian political parties in Ukraine"
    },
    {
      "id": "34a9fd8b-13bb-4d40-aaa2-c66e0122e71c",
      "text": "WTO Panel report circulated in Ukraine — Anti-Dumping Measures on Ammonium Nitrate (panel report circulated 20 July 2018)."
    },
    {
      "id": "473cbecc-ca21-4835-9483-63711d14e0a1",
      "text": "WTO dispute DS493 initiated/established (Russia files complaint; panel established 22 April 2016)."
    },
    {
      "id": "3c1dfdeb-f300-40f2-9032-3094fe4645c7",
      "text": "Official recognition and investigation of rare myocarditis/pericarditis following mRNA COVID-19 vaccination (ACIP/CDC review)"
    },
    {
      "id": "bd37a9b0-e07b-448c-bd28-89d7129c468b",
      "text": "CDC/FDA recommended pause on the Johnson & Johnson (Janssen) COVID-19 vaccine over rare blood clots"
    },
    {
      "id": "0692b4d7-b7aa-43b0-903f-54db8a567957",
      "text": "Reports of deaths among frail, elderly Norwegian patients shortly after receiving COVID-19 vaccines"
    },
    {
      "id": "a6669dc9-5788-4322-affc-8536d6461d31",
      "text": "World Bank Poverty and Equity briefs (published 2016) showing poverty rates rose sharply in 2014–2015 and remained a prominent policy concern."
    },
    {
      "id": "9207c4cc-83d3-4107-8881-63caee372452",
      "text": "Transparency International Corruption Perceptions Index 2016 (published January 2017) showing Ukraine with a low CPI score and poor governance indicators."
    },
    {
      "id": "cc4063b3-4027-43d0-b1c9-66dd68822ae0",
      "text": "IMF staff report (July 2015) documenting deep recession, large output losses, and a challenging recovery path for Ukraine."
    },
    {
      "id": "dd453d27-3f21-498c-84bf-f8587daa8696",
      "text": "Sharp economic contraction and macro crisis in 2014–2015: GDP collapsed and the hryvnia plunged after the central bank allowed it to float (February 2015 reports)."
    },
    {
      "id": "55b1edd0-40e0-43cb-bcab-dd9c2b23313d",
      "text": "OSCE thematic report on the impact of mines and unexploded ordnance (2018–2019)"
    },
    {
      "id": "33721b3a-5cdc-443e-8599-43e7d7955653",
      "text": "Vladimir Putin had previously been named TIME's Person of the Year (2007), a well-known precedent linking Putin with Time magazine covers in public memory."
    },
    {
      "id": "f762beea-6bb1-4d3b-993d-f8e4bc97273b",
      "text": "Study and media coverage showing Ukrainian refugees in some EU countries had to return to Ukraine to obtain abortions or contraception because of legal, cost and access barriers (Independent report, 18 May 2023)."
    },
    {
      "id": "fffa8076-beec-4801-9da0-5fd5da0a9ad7",
      "text": "UN/OHCHR documented widespread conflict-related sexual violence (including rape) by Russian forces in occupied areas and published monitoring reports covering 2022–2023."
    },
    {
      "id": "8cfe2e5e-b34d-4b5f-ae79-3e932c830bf2",
      "text": "Airstrike on Mariupol maternity/children's hospital (Maternity Hospital No. 3) that injured pregnant women and resulted in deaths and a stillbirth — widely reported with graphic images (attack on 9 March 2022)."
    },
    {
      "id": "bfd30f43-97af-4390-9f37-9bb404565a96",
      "text": "EU launches 'Support Hub' in Moldova to counter firearms trafficking and organised crime linked to the Ukraine conflict"
    },
    {
      "id": "221f03ad-dab7-49eb-b731-a3a3aa267d2a",
      "text": "Photographs of abandoned military equipment, shells and weapon boxes found near Andriivka (April 12, 2022)"
    },
    {
      "id": "c6593794-fb12-4c9f-a31a-9bf8f3922e3d",
      "text": "Publication of an Israeli nationwide surveillance study (Mevorach et al., NEJM) showing increased myocarditis incidence after the second dose, concentrated in young males (published Oct 6, 2021)."
    },
    {
      "id": "20a0b653-3a14-4146-a66f-02dc074c2da9",
      "text": "Reports that Russia offered/organized evacuation routes from Mariupol that included routes into Russia (early–mid March 2022)"
    },
    {
      "id": "2d712861-399b-43c7-94f1-2d30b47a4e13",
      "text": "Abduction and detention of Melitopol mayor Ivan Fedorov (reported March 11, 2022) and pressure on local officials in occupied towns"
    },
    {
      "id": "13b4f8bd-1e4b-46c7-9f06-f8acb44b5eff",
      "text": "Local occupation media and accounts in Kherson reported orchestrated or staged displays of support for Russian forces (early March 2022)"
    },
    {
      "id": "6e5270e8-581e-4a73-876e-199bffc453fe",
      "text": "2014 measles outbreak in an under‑immunized Amish community in Ohio (large local outbreak tied to travel and low MMR coverage)"
    },
    {
      "id": "6e9b56c2-1846-4a98-a834-cc0f642212d2",
      "text": "Publication of the peer‑reviewed study 'Low cancer incidence rates in Ohio Amish' (Cancer Causes Control) reporting substantially lower cancer incidence in an Ohio Amish population (1996–2003)"
    },
    {
      "id": "4d71a58c-31b8-4ef3-96bb-15762eaa2eee",
      "text": "Dan Olmsted’s 2005 ‘Amish Anomaly’ reporting (Age of Autism / UPI coverage) claiming an unusually low observed rate of autism in Amish communities"
    },
    {
      "id": "45ebb88b-bf33-4fba-9eec-b607bc7fcfae",
      "text": "U.S.-led coalition strikes in mid‑November 2015 destroyed scores/hundreds of ISIS fuel tanker trucks in north‑east Syria (widely reported Nov 2015)."
    },
    {
      "id": "069a2f64-e114-4ae3-b560-fee65a490053",
      "text": "Russian General Staff publicly stated Russian air strikes hit Islamic State oil refining assets during its November 2015 campaign."
    },
    {
      "id": "cf25d15d-0e56-4196-8bd6-b1dd2623d721",
      "text": "ISIS/ISIL militants deliberately set fire to oil fields and wells in 2015 (e.g., Ajil/Tikrit area, March 2015), producing widespread imagery of burning oil infrastructure."
    },
    {
      "id": "f56b635b-046a-4a07-a7a4-5dbed4e93211",
      "text": "Hungary publicly refused to back an EU oil embargo, signalling a national veto risk"
    },
    {
      "id": "a2d5e081-969b-4ff8-bc6a-3147ec0b0e4f",
      "text": "Gazprom sharply cut Nord Stream 1 gas flows in late July 2022"
    },
    {
      "id": "e32952af-965a-4a63-ba6b-a39cf2c81ff6",
      "text": "Hungarian Prime Minister Viktor Orbán publicly said EU sanctions on Russia had 'failed'"
    },
    {
      "id": "f6b553c2-e6b2-4faf-9a69-26959b763881",
      "text": "Reporting that worries about winter energy shortages and rising bills were eroding domestic support for sanctions"
    },
    {
      "id": "d720c73e-98a8-47f5-a0ac-7e558e0ca630",
      "text": "YouGov polling shows public willingness to keep sanctions falls if they raise cost of living"
    },
    {
      "id": "741a9cb5-886a-4ac3-a0db-6fca78a7b9ac",
      "text": "Publication of Scafetta & West (2007) paper estimating a large solar contribution to 20th-century warming"
    },
    {
      "id": "f0b094b1-7f25-47a8-9482-96e4884c43bd",
      "text": "Nationwide Razumkov Center / Ilko Kucheriv Democratic Initiatives poll (fieldwork May 14–19, 2021) on attitudes toward Donbas and Russian aggression."
    },
    {
      "id": "a17c93dc-3520-401e-836b-e0f5271b501e",
      "text": "President Volodymyr Zelensky's interview with foreign media (transcript published mid‑June 2021) in which he warned Ukraine may need to become a 'very strong, most powerful army in Europe'."
    },
    {
      "id": "37e8e1cb-3b0a-4a97-ae1a-1e27ff54f208",
      "text": "Earlier independent testing and reporting (2021–2022) found benzene contamination in sunscreens and other personal-care products, producing recalls and regulatory attention."
    },
    {
      "id": "b8af46a0-ca5b-496e-b89a-7bd1510de742",
      "text": "News that IMF programme delays and conditionality were creating uncertainty for Ukraine’s external financing in mid‑2018"
    },
    {
      "id": "6c9c2bf7-38e2-471a-b041-0a9da2658639",
      "text": "NBU's August 2018 Macroeconomic and Monetary Review noting global volatility and risk of spillovers to Ukraine"
    },
    {
      "id": "c2f3e630-f08f-47fd-b98a-fae1a6a78b87",
      "text": "Reporting on contagion fears from Turkey’s currency turmoil to other emerging markets"
    },
    {
      "id": "b7586629-3176-4504-9dae-01e07234abba",
      "text": "Germany announced an initial reversal of its pre‑invasion restraint by approving shipments from Bundeswehr stocks (1,000 anti‑tank weapons and 500 Stinger missiles)"
    },
    {
      "id": "b973d87c-9102-4220-874e-88d661ccab11",
      "text": "German Foreign Minister Annalena Baerbock publicly explained Germany’s reluctance to supply arms, citing the country’s WWII history (statement reported by Reuters)"
    },
    {
      "id": "ac87588b-bc99-4d48-8233-a5daf7fc1a53",
      "text": "Swiss parliament votes in favour of several measures to tighten asylum policy (including proposals affecting temporary admissions and family reunification)"
    },
    {
      "id": "c489a63d-e632-4a3d-8efe-40552e4c6545",
      "text": "Media reports (June 20, 2025) covering proposals and parliamentary initiatives suggesting Switzerland 'may end' or 'revoke' S protection for Ukrainian refugees"
    },
    {
      "id": "ba122ebc-29b7-4ac8-b2ae-a36bb297bce4",
      "text": "Federal Council decision (Nov 2023) to extend temporary protection status 'S' for Ukrainians (clarifying it was provisional and subject to later review)"
    },
    {
      "id": "8fedb62c-7243-4ccc-9df8-dad2d50416e5",
      "text": "Euromaidan 'Heavenly Hundred' killings and makeshift morgues"
    },
    {
      "id": "8ffbe2bc-3e02-4c4d-bc44-4f503c12fad3",
      "text": "Odessa Trade Unions House fire and deaths"
    },
    {
      "id": "049c387f-d38b-493e-80c0-9209a0fc42ec",
      "text": "German police reported a rise in anti-Russian attacks and politically motivated assaults"
    },
    {
      "id": "f404d690-a7bd-4f1c-a5e0-7f1735b9720c",
      "text": "Large pro-Ukraine demonstrations and visible Ukrainian refugee presence in German cities"
    },
    {
      "id": "f7cf7d1c-ea4a-4708-a6f4-9f7fee9cdaba",
      "text": "Frontiers / parasitology commentary (2022) and coverage highlighting patient-driven helminth/\"worm therapy\" experiments and unregulated self‑treatment"
    },
    {
      "id": "d7ba524a-1bbd-40da-96de-92ca7fdcf38a",
      "text": "Major regulatory and media attention as U.S. agencies granted inspection/clearance for cell-cultivated meat products (June 2023)"
    },
    {
      "id": "6204f81c-dfd9-47d7-8753-4c2c8239bd26",
      "text": "Industry disclosures and patent filings describing immortalization approaches for commercial cell lines (publicly cited in literature)"
    },
    {
      "id": "33a0e312-cbc6-4d2b-96b2-ab0d852134dd",
      "text": "Parliament approves TV language quotas requiring major channels to broadcast ~75% Ukrainian content"
    },
    {
      "id": "851fc306-2f78-48f7-b113-7dce1164a69d",
      "text": "Revocation of the 2012 'Kivalov–Kolesnichenko' regional language law (removing legal regional status for Russian in some areas)"
    },
    {
      "id": "43f76c7d-f08f-461f-a904-091ec5f12488",
      "text": "Passage of Ukraine's 'Law on Education' (affecting language of instruction)"
    },
    {
      "id": "3e950ab0-2b39-43ff-9a5f-062a36c00af9",
      "text": "Presidential decree to block major Russian websites and social networks (VKontakte, Odnoklassniki, Yandex)"
    },
    {
      "id": "3e3750ac-2b6b-430a-aa67-2bfc15bcfa67",
      "text": "Ban on import/distribution of 38 Russian books (listed as promoting 'hate' or 'separatism')"
    },
    {
      "id": "6323d3ca-f688-48d5-9fab-83b587579296",
      "text": "UNEP/Ozone Secretariat and related press releases in Oct 2019 emphasized that the ozone layer is 'slowly healing' and that the Montreal Protocol has been effective."
    },
    {
      "id": "9150a81d-6528-4275-b8a8-a9a1706e24bf",
      "text": "NOAA and NASA announced that the 2019 Antarctic ozone hole was the smallest on record (annual peak extent), attributed in part to unusual stratospheric warming."
    },
    {
      "id": "8d625518-abdd-441a-b740-7b507d8c73e8",
      "text": "UN/OHCHR reporting of thousands killed in eastern Ukraine (2014–2015)"
    },
    {
      "id": "aa7f6c28-3a60-47d1-9301-c2ced8a6c136",
      "text": "Defense and fall of Donetsk International Airport ('Cyborgs') with heavy casualties"
    },
    {
      "id": "d33b5e59-6951-4a55-90d5-de0ad14275bd",
      "text": "Battle of Avdiivka — intense frontline fighting and elevated casualties"
    },
    {
      "id": "36f28729-fe34-4e6d-b99e-ee9fcaa7c05f",
      "text": "Battle of Debaltseve and Ukrainian withdrawal under pressure"
    },
    {
      "id": "1c7cedb5-74a3-41a2-82f3-ff92f5641ead",
      "text": "Reports of Ukrainian sailors being pressured to take Russian oaths or detained during Crimea takeover"
    },
    {
      "id": "97979628-3420-44ec-aef8-12b24f583328",
      "text": "Tense stand‑off aboard blockaded Ukrainian ship Slavutych in Sevastopol where crew resisted takeover"
    },
    {
      "id": "41966921-2f3e-42bb-b09a-495a25971795",
      "text": "NOAA/NCEI released a major update to its global surface temperature dataset (NOAAGlobalTemp update) that changed historical coverage/adjustments."
    },
    {
      "id": "6ed59500-2ddc-47f5-ba2d-8ade023152f5",
      "text": "UN Human Rights Monitoring Mission reports on conflict-related killings and impunity in Donetsk and Luhansk"
    },
    {
      "id": "e270824c-080c-4953-bf30-6c931abd61b9",
      "text": "European Parliament adopts 'Importance of European remembrance' resolution condemning both Nazi and Stalinist crimes"
    },
    {
      "id": "d4bdac66-4616-4c2f-83ac-7682a496fc28",
      "text": "Lviv Oblast declares 2019 the 'Year of Stepan Bandera', prompting protest from Israeli and Jewish groups"
    },
    {
      "id": "aec337db-26f4-4278-88a8-00eeb563ef5c",
      "text": "Ukraine passes 'decommunization' laws banning communist symbols and reshaping public memory"
    },
    {
      "id": "91edbaa3-c938-4cc3-b2ce-252d3114fae5",
      "text": "UN/OHCHR reporting on detentions, security operations and use of anti‑terror measures in eastern Ukraine"
    },
    {
      "id": "0118ddd2-f152-417d-9b54-05cf86103a1c",
      "text": "Sanctions and regulatory restrictions targeting Crimea after Russia's 2014 annexation (EU/US measures from June 2014 onward)"
    },
    {
      "id": "510ee834-19fd-41ef-8d4f-43d524c50082",
      "text": "Media and veterinary reporting in 2022–2023 documented increasing use of cholecalciferol (vitamin D3) in commercial rodenticides and clinical cases of cholecalciferol poisoning in pets and wildlife."
    },
    {
      "id": "33969a83-f98a-4002-9274-f3c13ff9c373",
      "text": "Hawaii law banning oxybenzone and octinoxate in sunscreens (signed 2018; implementation and attention into 2020–2021)"
    },
    {
      "id": "915748ad-4a99-4921-9200-7ad0f63b3634",
      "text": "Johnson & Johnson voluntary recall of specific Neutrogena and Aveeno aerosol sunscreens after detecting low levels of benzene"
    },
    {
      "id": "88fa7a1e-fec4-4e4e-a036-e28471e1785b",
      "text": "2004 Mutat Res study finding dihydroxyacetone (DHA, active in sunless tanning) causes DNA damage, cell‑cycle arrest and apoptosis in cultured keratinocytes"
    },
    {
      "id": "3372e7b2-3af6-403b-9533-ca3f0f2e242b",
      "text": "Large Russian military exercises near Europe (e.g., Zapad 2017)"
    },
    {
      "id": "c5ef65de-3e9a-4d95-b685-671192868f4d",
      "text": "Kerch Strait incident — Russia seized Ukrainian naval vessels"
    },
    {
      "id": "d86844d0-23a9-4b88-8229-737a1ccab748",
      "text": "Minsk II ceasefire agreement (and its incomplete implementation)"
    },
    {
      "id": "cdcc4cb5-2bec-4805-9a7f-cd3173409efb",
      "text": "CDC guidance update allowing fully vaccinated people to stop wearing masks in most settings (May 13, 2021)."
    },
    {
      "id": "e9ce639b-b0f7-4d33-b373-cac3937c6b6d",
      "text": "CDC/NCHS guidance on certifying COVID-19 deaths (April 2020) and subsequent public discussion of death-coding."
    },
    {
      "id": "7cc31dcc-0efa-4e05-a02e-1fbce072139b",
      "text": "Great Barrington Declaration (Oct 4, 2020) promoting 'focused protection' and criticizing lockdowns."
    },
    {
      "id": "38f53e15-3f6d-4e4e-8988-ef767fae2cce",
      "text": "Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine reporting no statistically significant protective effect to wearers from recommending surgical masks (November 2020)."
    },
    {
      "id": "0adb6990-ff2b-421a-ab99-df94f72bf4af",
      "text": "Public reporting (e.g., Foreign Policy, OSINT coverage) that social media posts and geotagged content have been used to locate and target soldiers in the Ukraine war (OSINT used operationally)."
    },
    {
      "id": "851308e8-afce-4654-97d3-ad29ed078b8c",
      "text": "Independent reports in 2014 documenting summary killings, alleged mass graves and executions in eastern Ukraine (Amnesty International briefing, Oct 2014)."
    },
    {
      "id": "d31f3897-6484-4f9f-859d-dc84f80394a1",
      "text": "CDC MMWR (March 2012) reporting autism spectrum disorder prevalence of about 1 in 88 in US surveillance areas (data for 2008)"
    },
    {
      "id": "237a6f9c-8425-4703-bee8-d512a40c8092",
      "text": "Public reporting of rising measles cases in the UK attributed to declines in MMR uptake following the MMR scare"
    },
    {
      "id": "8b05fc9f-1aba-45bc-8a5f-875af5aed5a2",
      "text": "1999 precautionary recommendation to remove thimerosal (a mercury-containing preservative) from childhood vaccines in the United States"
    },
    {
      "id": "7d208f2e-cd63-42c0-8e76-e048299ab995",
      "text": "CDC/NCHS provisional reports and public pages in late 2022–early 2023 highlighted continued high counts of non‑COVID causes of death (notably drug overdose and heart disease) in 2021–2022 (CDC provisional drug overdose data page updated Jan 2023)."
    },
    {
      "id": "95493ec3-5c76-4932-afe1-03535f25401e",
      "text": "CDC published and maintained public, downloadable jurisdiction‑ and county‑level COVID‑19 vaccine administration/coverage datasets and maps (e.g., CDC Stacks dataset release March 1, 2022)."
    },
    {
      "id": "ea97cfae-0ddf-4b15-93d7-99ed2e3e60ed",
      "text": "UK guidance and primary‑care instructions on narrow criteria and formal processes for issuing COVID‑19 medical exemption certificates (GPs required to follow specified criteria)"
    },
    {
      "id": "9520f831-fc95-4505-b1ef-f59d7c4babc9",
      "text": "Temporary pause and safety review of the Johnson & Johnson (Janssen) COVID‑19 vaccine after reports of rare blood clots (CVST)"
    },
    {
      "id": "75244adf-d5fa-4e9b-aecd-fa8520a5cb68",
      "text": "News coverage of hospitals and transplant programs declining care (including organ transplants) for unvaccinated patients"
    },
    {
      "id": "ce6fa6be-ead1-4088-b52e-bf53f3c4157e",
      "text": "OSHA/NIOSH hazard communications and guidance on diatomaceous earth/silica hazards (e.g., OSHA interpretation clarifying DE silica content and hazard communication, April 5, 1999; NIOSH silica guidance)"
    },
    {
      "id": "4ca90c87-c4e6-4c7f-94f0-ea9daba911e6",
      "text": "Peer‑reviewed and technical studies showing diatomite/diatomaceous earth has sorption/adsorption properties in water treatment (e.g., fluoride/heavy‑metal removal studies, 2019)"
    },
    {
      "id": "726f005e-8131-460c-9463-d6964a2251c7",
      "text": "GOV.UK Summary of the Public Assessment Report for the Pfizer/BioNTech COVID-19 vaccine (authorisation documents, Dec 2020) and WHO/regulatory guidance cited therein stating carcinogenicity/genotoxicity testing is generally not required for many vaccines."
    },
    {
      "id": "71bb8186-e063-41c0-901d-221f213e112f",
      "text": "UK MHRA Freedom of Information release (FOI_22-1223) and related correspondence (published 22 Dec 2023) stating 'Neither genotoxicity nor carcinogenicity studies were performed' for certain Comirnaty components and that components 'are not expected to have genotoxic potential.'"
    },
    {
      "id": "c708f5de-2751-4a8c-9fb1-241d533a4dcf",
      "text": "Public release/update of childhood cancer incidence data/registries (e.g., National Childhood Cancer Registry Explorer / US cancer surveillance datasets updated 2022–2023) showing short‑term fluctuations or small upticks in incidence that were reported in the media."
    },
    {
      "id": "ee196b61-e304-461e-a463-d5ae45a016a4",
      "text": "Russia imposed an import ban on Roshen confectionery products (Rospotrebnadzor cited safety concerns)."
    },
    {
      "id": "efea0255-2ea4-4369-a4fd-dc32db53107e",
      "text": "Armed police and plainclothes officials entered the Lipetsk Roshen factory amid court cases and commercial disputes (widely reported tensions at the Lipetsk site)."
    },
    {
      "id": "cb59b418-04fb-4379-a5d3-0fad9684bf2e",
      "text": "Roshen announced it would close its Lipetsk (Russia) factory and halt operations, laying off workers (company statement reported January 2017; operations stopped by April 2017)."
    },
    {
      "id": "e4bd4597-6c95-42b6-8ea0-95f932932c30",
      "text": "Petro Poroshenko transferred his Roshen stake into a blind trust managed by Rothschild Trust (announcement and confirmations in January 2016)."
    },
    {
      "id": "6d505685-fb18-4996-b440-3537c58c3f23",
      "text": "Pre‑existing, reputable polls with mixed results (GfK Ukraine 2018) showing regional variation in nostalgia"
    },
    {
      "id": "05beab80-30fe-4554-ae31-69577b6c546e",
      "text": "Historical 1991 independence referendum (92% voted for independence) — widely reported figure available in public records"
    },
    {
      "id": "e2e86f81-529f-4675-a88a-f4cb35ba63d3",
      "text": "Oleg Sentsov began an indefinite hunger strike on 14 May 2018 to demand the release of Ukrainian political prisoners, drawing intense international attention to his case."
    },
    {
      "id": "69ee56c9-cc8b-4db0-bafe-7b715277e65f",
      "text": "Human-rights organisations and public petitions mobilised around Sentsov in mid‑2018 (Amnesty International and other advocacy actions in June 2018 used #FreeSentsov widely)."
    },
    {
      "id": "391c290d-4d33-46d1-a6fc-ec24553a697a",
      "text": "Norway reports and investigations of frail elderly deaths temporally associated with vaccination"
    },
    {
      "id": "29cc9f60-6154-4ad6-93d1-6804d8134a36",
      "text": "U.S. pause of the Johnson & Johnson (Janssen) vaccine after rare blood clot reports"
    },
    {
      "id": "8e1043cc-2dca-495f-8d63-e75c5ae5387f",
      "text": "Publication of Karl et al. (2015) NOAA/Science paper revising recent global surface temperature analyses and addressing the so‑called 'hiatus'"
    },
    {
      "id": "d9f42efe-10eb-4163-90db-2d36b388e3b0",
      "text": "Local incidents and campaigns (e.g., Holy Rus' Movement activity reported in Pastavy) around November 2014 that raised tensions over flags, national identity and pro‑Russian vs pro‑European messaging."
    },
    {
      "id": "08fc4aaa-001c-499e-b2bc-1bc0f4e5aa2b",
      "text": "Annual Shrovetide/Maslenitsa effigy‑burning traditions observed across Slavic countries (including Belarus) where effigies are publicly burned as part of festival rites."
    },
    {
      "id": "755c31cf-ca4d-4874-93d4-5d07f9d7e130",
      "text": "Visible use of alternative Belarusian opposition symbols (white‑red‑white flags) and frequent protest imagery in 2014 that foregrounded flags and symbols in public demonstrations."
    },
    {
      "id": "7c90f385-a416-416c-9ba0-87f159085a81",
      "text": "U.S. Patent US4686605A ('Method and apparatus for altering a region in the Earth's atmosphere, ionosphere, and/or magnetosphere') granted to Bernard J. Eastlund (patent text describes possible weather-modification applications)."
    },
    {
      "id": "b3345a2a-fe41-4be3-8ef9-5166e14dfb0d",
      "text": "IMF staff report on Ukraine's emergency financing needs under the Rapid Financing Instrument (IMF staff report published March 7, 2022)"
    },
    {
      "id": "50384329-e3d9-48a5-93bc-83cc4d763718",
      "text": "World Bank warning Ukraine economy could shrink sharply in 2022 (World Bank press release, April 10, 2022)"
    },
    {
      "id": "e963d97a-8c6b-4628-94cd-73d0bfcbd002",
      "text": "Parliamentarian warning Ukraine needs $5 billion a month in external aid (reported by Reuters)"
    },
    {
      "id": "725773c9-8f3f-4822-9346-a7020aa3ac84",
      "text": "S&P Global Ratings cuts Ukraine's sovereign credit rating (Reuters)"
    },
    {
      "id": "ab4dc4b1-a625-45f0-b3fb-38d06409de86",
      "text": "U.S.-led training of Ukrainian military personnel at sites such as the Yavoriv training center (Joint Multinational Training Group – Ukraine began operations in 2015)."
    },
    {
      "id": "5cc6d900-a391-49b9-aaa7-310336dd2c4d",
      "text": "National Endowment for Democracy (NED) grants and NGO funding programs in Ukraine following Euromaidan (published in NED annual reports and grant records)."
    },
    {
      "id": "2ef611e1-b729-446e-959a-b9dc97b37d9c",
      "text": "U.S. announces major economic assistance and loan guarantees to Ukraine as part of post-Maidan support (including a White House fact sheet detailing assistance)."
    },
    {
      "id": "970d01a7-2623-44ac-9bc2-138a3179e97b",
      "text": "Visit by U.S. Senator John McCain to Kyiv's Maidan protests and public expressions of support for pro-European protesters."
    },
    {
      "id": "a71d8cfa-f5e8-4f18-998a-6204aef07bc1",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels attempting to transit the Kerch Strait, injuring sailors and sharply escalating tensions."
    },
    {
      "id": "c4e720ce-0d97-4a36-8c23-6c78b6521969",
      "text": "Verkhovna Rada debated and adopted the Law on the Reintegration of Donbas (early 2018) and passed parliamentary resolutions emphasising de-occupation and reintegration of territories lost in 2014, including Crimea."
    },
    {
      "id": "2d47fdb1-a065-43d7-b9d4-8e29ea65754f",
      "text": "European Union extended sanctions related to Russia's 2014 annexation of Crimea after diplomatic deliberations in December 2019."
    },
    {
      "id": "31153ee6-b71b-49c4-b2ab-586daaf0c002",
      "text": "President Volodymyr Zelensky publicly vowed to restore Ukrainian control over Crimea during his inauguration, stressing Crimea remains part of Ukraine."
    },
    {
      "id": "0389fee0-e5b0-4b6d-9750-ec7e37751939",
      "text": "CDC Vital Signs (MMWR) documenting a sharp rise in firearm homicides in 2020"
    },
    {
      "id": "00de697f-97cd-4ebc-a9fb-9de4c1fe389a",
      "text": "Reports and recall actions after discovery of foreign/black particles in Moderna vaccine vials in Japan (investigation and lot suspensions)"
    },
    {
      "id": "a82dced5-0442-4343-8602-c3ee4319f011",
      "text": "NEJM study showing substantial waning of Pfizer–BioNTech (BNT162b2) protection against SARS‑CoV‑2 infection over months in Qatar"
    },
    {
      "id": "ff856f4d-0e11-403a-982f-e86414ddea01",
      "text": "ACIP/CDC review and MMWR reporting of myocarditis/pericarditis cases after mRNA COVID‑19 vaccination in young males"
    },
    {
      "id": "cb9a225b-b8d9-4863-bded-41002e213aae",
      "text": "Passage of Ukraine's decommunization laws (adopted April 9, 2015)"
    },
    {
      "id": "68e658a7-87b7-4feb-bc49-8a98c415edda",
      "text": "Verkhovna Rada officially renamed the city of Kirovohrad to Kropyvnytskyi"
    },
    {
      "id": "5a78c0b5-ea57-4bce-9e0e-103c30c48f52",
      "text": "City council-organized public survey (Oct 25, 2015) reported that around 77% of participating respondents favoured restoring the historical name 'Yelysavetgrad' (low turnout)"
    },
    {
      "id": "f0b78019-fc88-4133-87c6-d5dc3b5ddf72",
      "text": "Reports of foreign/black particles found in some vaccine vials (Japan, September 2021) and subsequent temporary suspensions/recalls"
    },
    {
      "id": "4e756dc8-42ee-4525-9931-5b21f8a028bc",
      "text": "Court-ordered public release of Pfizer/FDA review documents (rolling release beginning March 1, 2022)"
    },
    {
      "id": "b90c9c7d-8ee2-4cbf-9324-9485701f2402",
      "text": "Reports and rights‑group coverage of extra-legal self‑defence units and weapons proliferation in occupied/contested areas (Human Rights Watch World Report 2015)"
    },
    {
      "id": "3ea55b05-e64e-4a51-b455-4cd56d19c028",
      "text": "Poroshenko sacks Ihor Kolomoisky as governor after armed men seize oil company offices; publicly warns no regional 'pocket armies' will be tolerated"
    },
    {
      "id": "e9587647-c97e-4a21-ac83-8717ce46d6f6",
      "text": "E‑petition filed calling for formalisation of citizens' right to bear firearms (Reg. №1135-1 submitted)"
    },
    {
      "id": "5018bc81-8adb-4e6f-96fa-ac5d951ada7a",
      "text": "Presidential decree and public events strengthening/celebrating the National Guard and deployment of National Guard battalions (march 2015)"
    },
    {
      "id": "834752c5-4367-4977-9bc7-8fdca0b7efad",
      "text": "Widespread formation and operation of volunteer battalions (e.g., Azov, Donbas) during 2014–early 2015"
    },
    {
      "id": "e3929cb9-d9bf-44fe-8eb3-431bce5cc092",
      "text": "Public debate and reporting on Ukraine's mobilization and need to replenish/rotate forces"
    },
    {
      "id": "3c496ecd-36b2-46b7-a3dc-5fa2c28c013f",
      "text": "Claims of territorial setbacks (Soledar) early 2023 that were amplified by Russian sources"
    },
    {
      "id": "8385b239-35f0-4b4a-b4d8-cebe460666d6",
      "text": "Summer–autumn 2021 'wind drought' across the UK and parts of Western Europe produced unusually low wind output and a noticeable drop in renewable electricity generation."
    },
    {
      "id": "c2bf0c47-4735-4576-9964-8dbe9c634b2a",
      "text": "February 2021 Texas winter storm caused widespread grid failures and stressed electricity supply; some industrial sites (including data centers) relied on backup power and experienced operational impacts."
    },
    {
      "id": "a26c5d27-1a41-49e2-a665-a7e20594af90",
      "text": "NOAA / Coral Reef Watch reporting and technical briefs documenting the 2020 GBR marine heatwave and unprecedented bleaching risk (March 2020)"
    },
    {
      "id": "d4666577-80d5-4393-af93-c3c07c2fd745",
      "text": "UNESCO/World Heritage publicity around suggestion to list the Great Barrier Reef as 'in danger' (July 2021)"
    },
    {
      "id": "da653844-4256-45cc-8273-f87fcc346bb8",
      "text": "Reporting and congressional attention on EcoHealth Alliance and funded coronavirus research with the Wuhan Institute (NIH correspondence and investigations, Oct 2021 onward)"
    },
    {
      "id": "148c615a-c714-4ab2-bf8c-5af7057fa0a7",
      "text": "U.S. Department of Energy reported an assessment favoring a laboratory origin (covered in Feb 2023 press)"
    },
    {
      "id": "fd031dea-82ae-4214-b800-07eee7e5716e",
      "text": "Russian and other state‑backed media amplified allegations of U.S. biological labs and research being part of hostile programs (March 2022)"
    },
    {
      "id": "4a3d5220-cb8b-4170-ac6a-98c32da8fffd",
      "text": "Great Barrington Declaration (4 October 2020) — public statement by a group of scientists advocating 'focused protection' instead of broad lockdowns."
    },
    {
      "id": "2727f1dc-96ca-4448-8e40-efad4366f0c5",
      "text": "Publication and media coverage of the DANMASK-19 randomized trial (Denmark) in November 2020, reporting limited protective effect of recommending surgical masks for wearers in a low-transmission setting."
    },
    {
      "id": "79060d8f-adb6-497a-b312-d7d7335d3ca3",
      "text": "Imperial College COVID-19 Response Team Report 9 (16 March 2020) modelling high projected deaths and showing large effects from non-pharmaceutical interventions (NPIs), widely cited by policymakers and media."
    },
    {
      "id": "c756adeb-3a86-439c-953b-7e81f14df065",
      "text": "Publicised requests to retract or critique the early Corman–Drosten RT‑PCR protocol (late 2020) and widespread online debate about PCR sensitivity, cycle thresholds, and false positives."
    },
    {
      "id": "8f8bd225-18e7-459d-8caa-6c1a605d96e0",
      "text": "Israeli Health Ministry report (June 2021) identifying a probable link between Pfizer vaccine and rare myocarditis cases"
    },
    {
      "id": "4fe6f1c0-42e1-4624-9724-0f3a607b1ad5",
      "text": "FDA Emergency Use Authorization (EUA) for the Pfizer–BioNTech COVID-19 vaccine"
    },
    {
      "id": "8a336d3a-0a98-4e49-a5b1-dc54520f9680",
      "text": "CDC MMWR report on the Provincetown (Massachusetts) July 2021 outbreak with a high proportion of cases in fully vaccinated people"
    },
    {
      "id": "8f6b1e84-266b-412f-bf9f-c4180186fa63",
      "text": "Announcement of 'Operation Warp Speed' to accelerate COVID-19 vaccine development"
    },
    {
      "id": "c2c48b13-0da9-4a70-90b3-0a2dcf6a44f3",
      "text": "WHO designation and global spread of the Omicron variant (variant of concern declared 26 November 2021) and subsequent large waves of infections in late 2021–early 2022"
    },
    {
      "id": "1f75d58f-e21f-4a32-8be6-6f03fa2583b2",
      "text": "Preprint released claiming a 'Worldwide Bayesian Causal Impact Analysis' of 145 countries showing vaccine deployment increased COVID-19 cases and deaths"
    },
    {
      "id": "a7af8ad7-124f-45c3-9c15-92e6e377bc92",
      "text": "Major meat company sustainability commitments and reports (example: JBS releases 2022 Sustainability Report and net‑zero framing)"
    },
    {
      "id": "84546613-04c9-4ea6-a46a-04af0d15ed76",
      "text": "Wide media coverage and debate around the GWP* methane metric (interpretation and promotion of GWP* as an alternative to GWP100)"
    },
    {
      "id": "b24ffb2c-2472-4d2a-811c-26c1b050e679",
      "text": "Publication of peer‑review studies and meta‑analyses showing mixed evidence on soil carbon gains from grazing/regenerative practices (example: Nature 2024 grazing/carbon meta‑analysis)"
    },
    {
      "id": "a940d181-cd29-467e-b97e-dec0bc61b3ea",
      "text": "Public U.S. statements (late 2014) denying provision of lethal weapons to Ukraine under Obama administration"
    },
    {
      "id": "00a0ec8c-2e64-4107-82df-2cdb7d4833de",
      "text": "Rapid Trident 2014 multinational exercise at Yavoriv (September 2014)"
    },
    {
      "id": "853abfef-64ce-49bd-a2d8-eecd7f1452f2",
      "text": "U.S. 2nd Cavalry Regiment Javelin live‑fire range at Grafenwöhr/Vilseck (Sept 23, 2014)"
    },
    {
      "id": "5006627b-b293-43d9-8e73-d6b5a7567e40",
      "text": "Destruction of the Antonov AN-225 'Mriya' and visible damage at Hostomel/Antonov airport after Russian strikes"
    },
    {
      "id": "1cd4ddaf-aaea-4acc-a028-74a6d7933399",
      "text": "FAO publishes 'Livestock's Long Shadow' quantifying livestock's share of global greenhouse gases and comparing it to transport"
    },
    {
      "id": "0689fba7-b805-40ed-8cfa-956bc0b5639f",
      "text": "June 2021 reports and ACIP discussions documenting rare cases of myocarditis/pericarditis after mRNA vaccination in adolescents and young adults."
    },
    {
      "id": "f761c1de-a725-49a2-9f05-5e810c664681",
      "text": "October 29, 2021: FDA Emergency Use Authorization and ACIP recommendation for Pfizer‑BioNTech COVID‑19 vaccine in children aged 5–11."
    },
    {
      "id": "9fab087a-2b8b-4638-b3b9-84915e913387",
      "text": "Publication of Ogata et al. (May 20, 2021): small pilot study detecting SARS‑CoV‑2 vaccine antigen (spike protein) in the plasma of 11 of 13 mRNA‑1273 (Moderna) recipients."
    },
    {
      "id": "1267f7fa-73d9-44e8-950a-a0dee6897774",
      "text": "Published evidence of waning vaccine effectiveness and Israel's booster campaign (e.g., Bar‑On et al., NEJM showing booster restored protection after demonstrated waning)."
    },
    {
      "id": "22815f4d-1308-4d07-a08f-e7acebf98655",
      "text": "Release and dissemination of the Great Barrington Declaration (October 2020), advocating 'focused protection' and emphasizing immunity from infection."
    },
    {
      "id": "c4d39634-abdf-4664-bdad-d6e78eb7bbb0",
      "text": "Publication of Israeli preprint by Gazit et al. reporting that, during the Delta wave, SARS‑CoV‑2‑naive vaccinees had a 13.06‑fold increased risk of infection compared with previously infected individuals (medRxiv preprint)."
    },
    {
      "id": "90ef49c0-710f-4b96-81f9-3d83ddeba200",
      "text": "New York Attorney General pursued civil actions and publicized dozens of price-gouging complaints against gas stations after Hurricane Sandy (2012)."
    },
    {
      "id": "663b4f93-67b7-4083-b91d-62cb28710640",
      "text": "Federal Reserve Bank of St. Louis discussion of the 'rockets and feathers' effect (October 2014) showing retail gasoline prices often rise quickly but fall slowly after crude price declines."
    },
    {
      "id": "49f76802-5e87-499f-8e75-f14098ec6093",
      "text": "UK government and consumer groups publicly urged petrol retailers to cut prices after steep falls in global oil prices (November 2014 coverage)."
    },
    {
      "id": "f70405cb-f7f6-4863-bc7a-c931d82c2550",
      "text": "Release of the IPCC Fifth Assessment (AR5) Summary for Policymakers (September 2013) with quantified attributions and separate estimates for greenhouse gases and aerosol cooling"
    },
    {
      "id": "eae1880d-3590-4fa9-9cbb-842e0a396bfb",
      "text": "Russian seizure of three Ukrainian naval vessels in the Kerch Strait"
    },
    {
      "id": "266913ed-2eef-4ab7-911a-105100da0e02",
      "text": "Ukraine announced partial martial law in response to the incident"
    },
    {
      "id": "06e389e5-f96e-4d33-9f6e-1932526e6f19",
      "text": "Russian Foreign Ministry publicly accused Ukraine of deliberately provoking the incident"
    },
    {
      "id": "57710820-589c-48a2-bfcb-33ad32e2c665",
      "text": "FDA emergency use authorization (EUA) for Pfizer-BioNTech vaccine expanded to adolescents aged 12–15"
    },
    {
      "id": "d3789df5-39f9-4f88-9edf-85bf0035efc4",
      "text": "Publication of Israeli active-surveillance study reporting increased myocarditis cases after BNT162b2 (Pfizer) vaccination"
    },
    {
      "id": "72f2cfd0-b507-449e-9770-85beb184878a",
      "text": "Air-raid alert sounded near central Kyiv while a group of Moscow‑aligned clergy were at the Presidential Office; Ukrainian air defences detected and shot down a drone."
    },
    {
      "id": "a6cc1c20-7887-40a1-aabf-bfb7e06a7449",
      "text": "Public fallout from Patriarch Kirill and parts of the Russian Orthodox leadership publicly backing Russia’s invasion (2022), prompting Ukrainian clergy and parishioners to cut ties with Moscow."
    },
    {
      "id": "c786f26e-12c2-4535-a429-4e452628cffe",
      "text": "UNEP Global Methane Assessment names agriculture (including livestock) as a major short‑lived climate forcer"
    },
    {
      "id": "6a2d7a4b-4915-4e96-8761-56cffaf93b4a",
      "text": "Launch of the Global Methane Pledge at COP26"
    },
    {
      "id": "929e1daf-b76b-4dcc-bef3-f9333ae4e759",
      "text": "Industry advocacy/PR programs to defend beef (e.g., 'Masters of Beef Advocacy' and NCBA campaigns)"
    },
    {
      "id": "fce12da3-bb37-4057-b532-66704b519802",
      "text": "Publication of major reports in 2019 (CDC/WHO) highlighting antimicrobial resistance as a growing global health threat"
    },
    {
      "id": "90ceca1b-3c57-4f9c-9fa7-8efa71128ef7",
      "text": "Japan's 2013 suspension of proactive HPV‑vaccine recommendation after media reports of adverse events, and the official resumption of active recommendations on Nov 26, 2021."
    },
    {
      "id": "9a9f6fb9-cf76-48ee-9a70-677d6c110efa",
      "text": "April 2023 court developments in U.S. Gardasil litigation: plaintiffs secured orders/access to adverse‑event databases and internal documents related to Gardasil safety."
    },
    {
      "id": "48d0d409-30e5-428f-8ea5-91b8cae163bb",
      "text": "Publication of a November 2022 Journal of Autoimmunity paper (Mehlsen et al.) reporting clinical and pathophysiological findings in a cohort of patients who self‑reported long‑term complications after HPV vaccination."
    },
    {
      "id": "4d05f40f-071e-4ec6-9402-83d6f6728d05",
      "text": "NCHS/CDC data summary noted that 94% of death certificates mentioning COVID-19 also listed other health conditions (widely reported Sept 2020)."
    },
    {
      "id": "61fbfe05-fc35-4760-85bc-5bad7ae4ded7",
      "text": "Publication of seroprevalence analyses (JAMA/CDC-linked studies, mid–late 2021) showing infection-induced antibodies were substantially more common than reported case counts indicated."
    },
    {
      "id": "28039044-3710-423a-a4bd-2fbbf3e54855",
      "text": "Public debate and official briefings in 2021 (WHO and national public-health commentary) about the extent and durability of 'natural immunity' after infection."
    },
    {
      "id": "de0e3abf-ceba-49b9-8828-79c50e38b815",
      "text": "Human-rights reports documenting abuses (including looting) by some pro‑Ukrainian volunteer battalions (e.g., Aidar)"
    },
    {
      "id": "c02542da-91d7-4dcd-8711-22502b1933c2",
      "text": "Reporting that Chechen fighters were present in eastern Ukraine (widely covered in 2014)"
    },
    {
      "id": "5f73d540-43b8-4265-b8ff-aa19a825cccd",
      "text": "Russian officials and state media accused the UK and US of involvement after the October 29, 2022 drone attack on the Sevastopol/Black Sea Fleet facilities; coverage noted Russian claims of foreign participation."
    },
    {
      "id": "5c85d134-3901-4755-b71a-1b2eb75fb815",
      "text": "Reporting on leaked documents and media investigations that suggested UK special forces and other British personnel were operating in Ukraine (e.g., reporting that up to ~50 UK special forces were present)."
    },
    {
      "id": "10e90a91-8e71-43ae-8b59-e0b1a43a6907",
      "text": "Visegrad (Central European) leaders, including the Czech leadership, publicly underlined opposition to EU migrant/relocation quotas"
    },
    {
      "id": "287b2f37-c4a8-4ee8-a189-3a6c0f1582b8",
      "text": "Large and growing population of Ukrainian workers/residents in the Czech Republic (Ukrainians became the largest foreign national group)"
    },
    {
      "id": "03902357-f4c2-4df8-9882-232e48bd71e7",
      "text": "President Miloš Zeman and other officials made repeated anti-refugee/anti-Muslim public remarks during 2015"
    },
    {
      "id": "663097e0-4b95-4728-8608-8d19438f7d7d",
      "text": "European Court of Human Rights judgments finding domestic travel bans (imposed by bailiffs/authorities) problematic (e.g. Khlyustov v. Russia)"
    },
    {
      "id": "300f0d0c-3195-4f56-8af4-3e5a93c40f57",
      "text": "Passage of other high‑profile restrictive laws by the Duma (e.g. 2012 'foreign agents' NGO law)"
    },
    {
      "id": "dc0fbaec-ae96-4c16-9fc7-5b16fd8c8b15",
      "text": "Widespread travel bans imposed by the Federal Bailiff Service on debtors (reports ~500,000 affected)"
    },
    {
      "id": "15443277-29b8-44dd-bc8b-e751eb349fa8",
      "text": "Public reporting in late June–July 2022 that Ukraine had received and begun using U.S.-supplied HIMARS systems in combat."
    },
    {
      "id": "56e4391a-703c-4ed9-a325-0165561cee88",
      "text": "Media reporting that many of the victims/prisoners at Olenivka were fighters from the Azov Regiment captured after the fall of Mariupol/Azovstal."
    },
    {
      "id": "24abea91-0dac-40b9-9770-ed51f91c5c5f",
      "text": "International Committee of the Red Cross (ICRC) and other agencies reported limited or denied independent access to the Olenivka site and called for impartial investigation."
    },
    {
      "id": "3b16bfd7-7b38-422e-8168-de5f079314e7",
      "text": "WHO and regulatory guidance documents explicitly listing vaccine-associated enhanced disease/ADE as a safety consideration during COVID-19 vaccine development and evaluation"
    },
    {
      "id": "4a4a3486-453b-4e0f-b099-3969db2e42ef",
      "text": "Preclinical animal studies (e.g., Tseng et al., PLoS ONE) reporting pulmonary immunopathology after SARS coronavirus vaccine challenge in mice"
    },
    {
      "id": "76b6c6cf-86b2-42d9-badc-c8bd382b4aa9",
      "text": "International Republican Institute (IRI) / Rating Group national survey (September 2023) reporting strong majorities believe Ukraine can defeat Russia and support recapturing lost territory"
    },
    {
      "id": "75b0643e-6526-4dd1-a6c5-ec972c9437f4",
      "text": "Atlantic Council / DFRLab analysis of pro‑Kremlin information operations (reporting on Russian info tactics aimed at undermining confidence in Ukraine, Feb 2023)"
    },
    {
      "id": "2f98e229-8833-4116-8716-f73260c19e20",
      "text": "Kyiv International Institute of Sociology (KIIS) omnibus poll on readiness for territorial concessions (data collection Nov 29–Dec 9, 2023)"
    },
    {
      "id": "c568daa3-1f6c-437f-a2b8-c047b1e273d8",
      "text": "President Volodymyr Zelenskyy's speech to the UN General Assembly (full text published Sept 20, 2023)"
    },
    {
      "id": "fb5e89ab-7a85-43ae-a4f2-098d2753ec2a",
      "text": "G7 public rejection of Russia’s ruble-for-gas demand"
    },
    {
      "id": "8c8f1924-d68f-416b-8d8e-58c11e08a9bc",
      "text": "Confusion about how the ruble-payment mechanism would work (Gazprombank conversion accounts)"
    },
    {
      "id": "fa13c6d0-b2e5-474b-9f53-d4a52a63806a",
      "text": "UK government publicly called for investigation into allegations that Russia was stealing Ukrainian grain"
    },
    {
      "id": "a7792d10-d764-4230-90f7-ac06b4636202",
      "text": "AP/PBS Frontline investigation documents large-scale removal of Ukrainian grain from occupied territories using satellite imagery and ship-tracking data"
    },
    {
      "id": "b1976276-72b8-4011-90e9-c0aea7bc389e",
      "text": "UN‑brokered Black Sea Grain Initiative led to the first ship leaving Odesa carrying grain under the safe‑passage deal"
    },
    {
      "id": "17c096b5-452d-4531-bc5a-882057a7929b",
      "text": "Longstanding public health and cultural practice in Japan of routine gargling to prevent respiratory infections, and official encouragement of gargling during the 2009 H1N1 outbreak (documented in peer‑reviewed literature)."
    },
    {
      "id": "a9001056-daab-416a-bddf-6062cc82c7ae",
      "text": "Pre‑existing in‑vitro research (2015) showed povidone‑iodine (PVP‑I) oral rinses can rapidly inactivate related coronaviruses (SARS‑CoV, MERS‑CoV) in laboratory tests."
    },
    {
      "id": "a0960191-05cf-4a3d-b3b5-463142b35563",
      "text": "2018 studies and media coverage reporting a significant slowdown of the Atlantic Meridional Overturning Circulation (AMOC)"
    },
    {
      "id": "35e718bf-4fb0-4c92-b4e1-8fb977118393",
      "text": "2015 Scientific Reports paper by Zharkova et al. proposing a forthcoming 'modern grand solar minimum' (linked to multi-decadal cooling)"
    },
    {
      "id": "4a103dd4-b72c-4209-98ce-c3609d5ebbe1",
      "text": "Late-January 2019 polar vortex cold snap widely covered in US media"
    },
    {
      "id": "c26143cc-60dc-4cc5-85f5-ea1998788b28",
      "text": "WHO scientific brief and multiple seroprevalence reports during mid-2020 indicating lower-than-feared infection fatality rates in some populations"
    },
    {
      "id": "ac11415d-d1f0-49ae-bf3c-e809f385565f",
      "text": "Ukrainian authorities publicly reported large-scale allocation of state land to ATO participants (land-for-soldiers program)"
    },
    {
      "id": "5f8c9e85-7db4-472f-bebd-dbe581560237",
      "text": "May 2014 Land Agency initiative announced to provide mobilized servicemen and displaced soldiers with free land parcels (10–12 ares up to 2 hectares)"
    },
    {
      "id": "39a20b14-9486-4645-846f-a5d3a05a411d",
      "text": "Early volunteer recruitment drives and public discussions of material incentives for volunteers and battalions (wide volunteer mobilisation in March 2014)"
    },
    {
      "id": "729bd517-f48b-4458-86d3-c7b80c90a419",
      "text": "Documented abductions, ill-treatment and forced labour by armed groups in Donbas during 2014"
    },
    {
      "id": "eee21b3a-7680-4b10-9582-b74325004fff",
      "text": "NIH announces suspension/withdrawal of funding to EcoHealth Alliance projects involving the Wuhan Institute of Virology (political scrutiny and reporting intensified)"
    },
    {
      "id": "4300ed1d-249d-4eb3-a8e3-2977bf86206e",
      "text": "Early suppression and censure of whistleblower doctor Li Wenliang and his subsequent death, widely reported internationally"
    },
    {
      "id": "65c14409-94a3-4eb2-8441-805a55ed7592",
      "text": "Lancet clinical report and early epidemiology (first cluster descriptions) noting both links to the Huanan market and an earliest case with no market link, creating ambiguity about initial spillover"
    },
    {
      "id": "2d827743-6247-4e6b-a57b-dafc824a08bd",
      "text": "Douma suspected chemical attack and subsequent U.S./UK/France strikes"
    },
    {
      "id": "ca494079-582d-4085-964a-16eb13213ade",
      "text": "Salisbury Novichok poisonings linked to Russia (Sergei and Yulia Skripal)"
    },
    {
      "id": "d130f78e-0f60-4aee-a423-c35f5aaa102e",
      "text": "IPCC Fifth Assessment Report (AR5) Summary for Policymakers released, synthesizing evidence on anthropogenic warming and acknowledging internal (natural) variability on decadal scales."
    },
    {
      "id": "943e4f34-59eb-4222-a1ae-6b920d69ab63",
      "text": "Publication of Karl et al. (2015) in Science revising NOAA surface temperature dataset and concluding biases partly explained the so‑called 'hiatus'."
    },
    {
      "id": "abf56087-ecd6-4e4c-ae65-1897149ad7e8",
      "text": "Release and publicity around discrepancies between satellite lower‑troposphere trends (UAH/RSS) and surface temperature records, including UAH Version 6.0 release (April 2015)."
    },
    {
      "id": "396176b5-f265-4891-be47-52b337eb773a",
      "text": "U.S. announces major defensive military assistance increases to Ukraine (e.g., $200 million package)"
    },
    {
      "id": "172cf672-4338-4d7f-9bb6-ea44525201d7",
      "text": "U.S. Defense Threat Reduction Agency (DTRA) Biological Threat Reduction Program activities publicly documented in Ukraine"
    },
    {
      "id": "6c174445-80ed-497e-b27a-f0ee25657bc0",
      "text": "Westinghouse announced extended nuclear fuel supply to Ukraine (contract extension)"
    },
    {
      "id": "c11336cd-72ab-4022-9eb7-8330b56c200a",
      "text": "Sea Breeze multinational naval exercises co-hosted by the U.S. and Ukraine (Black Sea)"
    },
    {
      "id": "b22df674-8d6a-4eac-9c5c-4a6b65a8be49",
      "text": "U.S.–Ukraine Nuclear Safety Arrangement signed (Rockville)"
    },
    {
      "id": "f546c638-ba96-4832-b699-e89ff607a5a5",
      "text": "Event 201 pandemic tabletop exercise hosted by the Johns Hopkins Center for Health Security with the World Economic Forum and the Bill & Melinda Gates Foundation."
    },
    {
      "id": "9061c2d6-b97b-4e66-9c41-0f9fdb8855b7",
      "text": "Polish government rhetoric about protecting Poles and restricting entry for Ukrainians with 'anti‑Polish views' (reported by Reuters)."
    },
    {
      "id": "71137349-c545-4726-a3fb-95eb051d846d",
      "text": "Polish Sejm passes a resolution on the Volhynia/Volyn killings (frames the 1943 massacres as 'genocide'), heightening Polish‑Ukrainian historical tensions."
    },
    {
      "id": "a902748c-6ee2-4618-887c-aaa065629c33",
      "text": "Keeling Curve (Scripps/UC San Diego) update and commentary (June 6, 2024) reporting unusually large recent annual and multi-year jumps in atmospheric CO2 at Mauna Loa and in the Keeling record."
    },
    {
      "id": "c51a371a-2861-4e4a-bebe-05bfd37ac05e",
      "text": "Publication of a PNAS-backed study (led by Oregon State University and University of St Andrews) reporting that today's atmospheric CO2 increase is ~10 times faster than at any point in the last 50,000 years."
    },
    {
      "id": "58a8a0fb-d8e4-4062-8e49-77fbaa8c4af4",
      "text": "Public familiarity and heightened sensitivity to the term \"airborne\" after prolonged COVID-19 airborne-transmission debates (CDC scientific brief acknowledging airborne transmission dynamics, May 2021)"
    },
    {
      "id": "a889b71b-e769-4400-9de4-484e46923b84",
      "text": "WHO declares the monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)"
    },
    {
      "id": "a1afbbcb-0045-4cb3-a80a-c94f23c033f6",
      "text": "CDC public guidance stating infectious period normally lasts 2–4 weeks (not months)"
    },
    {
      "id": "1ec08fa1-6515-4fb9-a585-16241d52e937",
      "text": "World Health Organization interim guidance on mask use updated (interim guidance published/updated in March–June 2020, with a notable update 5 June 2020)."
    },
    {
      "id": "65415f11-d162-41f9-a436-55fa225f8ce1",
      "text": "US CDC recommended on April 3, 2020 that members of the public should wear cloth face coverings in public settings where social distancing is difficult."
    },
    {
      "id": "f223b73f-a2ba-4f6f-946c-77a1b03ec42e",
      "text": "The Great Barrington Declaration was published (October 4, 2020), advocating 'focused protection' and opposing broad lockdowns and some mitigation measures."
    },
    {
      "id": "4e312d90-6877-4ad1-a1c5-7420a43c99a7",
      "text": "Adoption of the Kivalov–Kolesnichenko language law expanding regional languages (2012)"
    },
    {
      "id": "1fb2122c-caff-46d0-8d3c-6d03fba686fd",
      "text": "Verkhovna Rada voted to repeal the 2012 language law (23 February 2014)"
    },
    {
      "id": "8ee37723-897a-4a6f-8b39-4c7dd211b1c1",
      "text": "Pro‑Russian unrest and separatist seizures in eastern Ukraine; local councils declared Russian a regional language (March–April 2014)"
    },
    {
      "id": "f4fd4123-302b-40c8-810b-b64de82dab57",
      "text": "Poland’s prime minister and other Eastern European leaders publicly call for an international tribunal to investigate Russia’s actions"
    },
    {
      "id": "4bf2c361-66ac-43d9-a57d-69eda5f68ff3",
      "text": "Legal analyses and reporting highlight that the ICC cannot currently prosecute the crime of aggression against a non‑party state like Russia without a UN Security Council referral"
    },
    {
      "id": "0486887d-f3e6-4ad8-8318-f61fc63d4e4c",
      "text": "Divergent public language among Western leaders over strong legal labels (e.g., 'genocide' versus 'possible genocide') in April 2022"
    },
    {
      "id": "9a34b22b-fed3-4c7b-beb3-c3fe6294db09",
      "text": "Major international media profiles and frontline reporting highlighted large numbers of Ukrainian women serving in combat roles."
    },
    {
      "id": "661d6da5-a118-40c0-b59e-fa784c68d780",
      "text": "Parliamentary debate and media attention around Ukraine's draft/mobilization laws, with officials explicitly saying female conscription was not part of the new draft law."
    },
    {
      "id": "89761b78-37d3-436a-9172-1aa0b3e7271b",
      "text": "Documented increases in pertussis (whooping cough) activity in 2023–early 2024 reported by public health agencies"
    },
    {
      "id": "3611d703-5b2b-459a-b6d0-1f1799963c5d",
      "text": "Reports that Chinese firms/state-linked investors had shown interest in financing large Crimea projects (transport/energy/ports)."
    },
    {
      "id": "536b54e1-1e4a-419d-a557-b81756067a32",
      "text": "Siemens turbine deliveries controversy highlighted limits in enforcing sanctions on equipment shipments to Crimea."
    },
    {
      "id": "12275ffe-4629-436e-b10f-abd6ce599ef3",
      "text": "RFE/RL investigation reporting that numerous EU firms and intermediaries were finding ways to do business in Crimea despite sanctions."
    },
    {
      "id": "e11a0225-cab5-42e3-a921-41c80652ca9a",
      "text": "Publication of a broad scoping review 'Electric vehicles and health: A scoping review' (Environmental Research) that summarized limited and mixed evidence about EV-specific health outcomes and pointed to evidence gaps (June 2024)."
    },
    {
      "id": "bcb56a36-ec91-4877-92e9-b98d49434429",
      "text": "A 2021 systematic review in Frontiers in Physiology summarized animal and limited human studies on radiofrequency electromagnetic radiation (RF‑EMR) from wireless devices and reported that many animal studies found reduced testosterone after RF‑EMR exposure (September 24, 2021)."
    },
    {
      "id": "93685c4c-4575-4523-97d2-ea10d32fa0e5",
      "text": "U.S. ends COVID-19 national and public health emergencies"
    },
    {
      "id": "eda9cd0e-6a9f-4236-8a98-031b010dae5d",
      "text": "Court dispute over FDA's proposed slow release of Pfizer vaccine documents (initial 75‑year timeline)"
    },
    {
      "id": "747298e5-3a4f-4b7d-97df-c50347bf7bb7",
      "text": "Reports of black/metallic particles found in Moderna vaccine vials in Japan"
    },
    {
      "id": "536ccc45-bd29-414b-b18d-e863954871e3",
      "text": "UNHCR / humanitarian agencies reporting large numbers of Ukrainians remaining under temporary protection across Europe (data briefs, 2024)"
    },
    {
      "id": "92720b4b-9773-4329-93c9-b45f67ca61f5",
      "text": "Hungary tightens border-control procedures and increases checks for certain categories (early 2023)"
    },
    {
      "id": "0c839794-7745-4572-be7b-dddd47fd12f6",
      "text": "Polish president vetoes law extending social benefits and protections for Ukrainian refugees"
    },
    {
      "id": "202de205-f1d1-4bf8-bf64-f00ec54f1552",
      "text": "Large-scale border disruption at Poland–Ukraine crossings after Polish trucker protests temporarily blocked traffic"
    },
    {
      "id": "d0020a67-fc35-4342-a323-11be9087d48a",
      "text": "EU Commission / Council actions on temporary protection timing (proposal/extension toward a defined transition period)"
    },
    {
      "id": "d4a0d688-6659-43f4-b729-ba11a12764b1",
      "text": "World Health Assembly adopted a package of amendments to the International Health Regulations (IHR)"
    },
    {
      "id": "38f3fcd7-ac4b-48ac-97a7-869b0ebf0b39",
      "text": "A coordinated public letter and statements by many U.S. Republican governors saying they would not comply with a WHO pandemic agreement"
    },
    {
      "id": "d111af52-467d-4ee5-a2ad-0cb7697fb6dc",
      "text": "WHO/PAHO international guidance on certification and coding of COVID-19 deaths published (guidelines on identifying COVID-19 as cause of death)"
    },
    {
      "id": "94df8f53-4787-4085-9cca-4355cf2800d5",
      "text": "New York Times coverage that Russia was sending mercenaries and Syrian fighters to Ukraine"
    },
    {
      "id": "b8556f5f-e15a-4c1d-8734-58d81e74cab3",
      "text": "WHO Situation Report 132 (PDF) released on May 31, 2020, summarizing global confirmed COVID-19 cases and deaths through that date."
    },
    {
      "id": "365f4d0c-f744-4264-8da9-40b644656575",
      "text": "Media coverage in March–April 2020 documenting overwhelmed hospitals and surging deaths in Lombardy and other early hotspots (e.g., New York, Lombardy) that highlighted acute local mortality spikes."
    },
    {
      "id": "352f7f27-61cb-4116-94b9-02f2bb7fc6aa",
      "text": "Ukraine Health Ministry backs new organ-transplant law and announces 2018 pilot for cadaveric kidney donation"
    },
    {
      "id": "7371e316-7520-4859-8923-9f49a2fd0bc4",
      "text": "OSCE report and regional analysis on trafficking for organ removal (2013)"
    },
    {
      "id": "30f8683d-3aa4-45fe-a452-4101b6211ad3",
      "text": "French authorities and national media reported a sudden surge in bedbug sightings across Paris (including verified infestations in at least one school) that prompted government coordination meetings."
    },
    {
      "id": "9f8afa71-583a-4075-a1b6-4a16a0225b80",
      "text": "Poroshenko's profile as a wealthy oligarch and highly polarising figure following his 2014 election (widely reported in 2014), which made character attacks and rumors about personal misconduct more plausible to hostile audiences."
    },
    {
      "id": "d2de2683-5301-4e88-a6af-de7b857d55b7",
      "text": "Canadian government issues travel advisories urging citizens to avoid travel to Ukraine"
    },
    {
      "id": "3ac65615-295e-43b0-bd1e-295acce11b24",
      "text": "Ukrainian president signs decree on general mobilization"
    },
    {
      "id": "8edaf8f8-cee1-403a-bb85-08ab937a3c86",
      "text": "Large-scale Canadian charitable and advocacy campaigns raising funds and political support for Ukraine"
    },
    {
      "id": "136e92b4-2535-4767-a92a-7ba13709179c",
      "text": "Reports of foreign/stainless‑steel particles found in some Moderna vaccine vials in Japan, prompting pauses of affected lots."
    },
    {
      "id": "97af48fd-228b-4ae1-8b4b-c1d114bd42f2",
      "text": "FDA revises Emergency Use Authorization (EUA) for COVID-19 convalescent plasma, narrowing use to high‑titer units for specific hospitalized patients."
    },
    {
      "id": "81034bab-34ca-449a-8125-efe9bd3febf1",
      "text": "American Red Cross published/updated guidance on COVID‑19 vaccination and blood donation explaining eligibility rules and referring to FDA guidance (including notes about convalescent plasma collection changes)."
    },
    {
      "id": "6d5abe6a-278c-4409-9c45-30f3af0e0f88",
      "text": "U.S. Fish and Wildlife Service 2008 Biological Opinion to protect the endangered Delta smelt"
    },
    {
      "id": "fd1034b1-5b65-4663-8ad8-50feb371cd77",
      "text": "Media analysis and commentary on large volumes of stormwater/capture shortfalls (2015 coverage)"
    },
    {
      "id": "c974f6d6-113a-462f-a937-3a50bb6f876d",
      "text": "California governor issues first-ever statewide mandatory urban water restrictions"
    },
    {
      "id": "cdc2e360-c720-4bea-b351-bdf839c88f03",
      "text": "2017 Northern California 'Wine Country' wildfires (Napa, Sonoma, Mendocino)"
    },
    {
      "id": "7bd2872a-0b55-457d-a26e-3d1c22d3c6de",
      "text": "Oroville Dam spillway failure and mass evacuation"
    },
    {
      "id": "11234eed-3a0b-461d-a2e4-30ff96dc483d",
      "text": "Cleveland Clinic (laboratory guidance/fact sheet) and other clinical bodies publishing guidance that MTHFR genotyping has limited clinical value (2020–2021)."
    },
    {
      "id": "b08c723f-b7b9-4359-b317-16d091bf3b21",
      "text": "Publication of PNAS paper showing extremely slow and highly variable human DHFR activity (Bailey & Ayling, 2009)."
    },
    {
      "id": "a1e1ffbe-a8e0-47f4-a01c-cd3b536c3a39",
      "text": "BMC Public Health report on threshold doses above which unmetabolized folic acid appears in serum (Sweeney et al./BMC Public Health, 2007)."
    },
    {
      "id": "c3394cb0-7f38-434e-b842-6b01a620b052",
      "text": "1979 and subsequent clinical reports: Published case reports and toxicology reviews documenting pennyroyal ingestion as a historical abortifacient and a cause of severe hepatotoxicity."
    },
    {
      "id": "be00ff73-c861-4bd7-b6d4-8a447568e602",
      "text": "July 15, 2004: Case report in the New England Journal of Medicine linking maternal use of blue cohosh to perinatal stroke and other neonatal harms."
    },
    {
      "id": "26c3f605-3001-4112-9321-01545614593d",
      "text": "CDC updated its 'Learn the Signs. Act Early.' developmental milestone checklists, adding new checklists for 15- and 30-month visits and publishing revised milestone wording on the CDC site."
    },
    {
      "id": "5c99bbde-646b-490b-853d-f167d22f76bb",
      "text": "OSCE SMM reduced/ceased control of its Mariupol office amid the early invasion and reports that the Mission 'had not controlled its office' in Mariupol since March 2022 (and the Mission publicly called for the release of detained SMM members in late May)."
    },
    {
      "id": "b69bb252-8716-4cad-aca0-20858633f361",
      "text": "OSCE Special Monitoring Mission (SMM) publicly operated monitoring cameras and posts along the contact line prior to the 2022 full-scale invasion (public SMM daily reports noted monitors and equipment deployed)."
    },
    {
      "id": "683089cf-de34-464a-91b4-29c055e7034f",
      "text": "Release and reporting on 2018 U.S. diplomatic cables that raised safety and staffing concerns about the Wuhan Institute of Virology."
    },
    {
      "id": "0c6e5fcc-3e05-4d45-9517-055b88d7fcf2",
      "text": "Russian authorities begin large-scale issuance of Russian passports to Crimean residents and publicly announce high application numbers"
    },
    {
      "id": "2019fa13-4954-4783-ab8a-b6d58fb3767c",
      "text": "Widespread reporting during 2022 that huge areas of Ukraine were contaminated with unexploded ordnance and mines (official estimates in Aug 2022)."
    },
    {
      "id": "9583ac2e-6d33-435f-b5aa-c463766577f7",
      "text": "Russian missile strikes on Lviv damaged critical infrastructure and caused power outages (reported 11 Oct 2022)."
    },
    {
      "id": "044ac721-0b4b-42c6-a6fa-df1a1fe7d2a1",
      "text": "Anonymous bomb threats led to evacuations of Lviv supermarkets and shopping malls (mass evacuations reported 22 Oct 2022)."
    },
    {
      "id": "ffe6f633-c3dc-4185-ad58-053703bb06bd",
      "text": "CDC FluView weekly report showed influenza detections dropped to near zero by week 14 (week ending Apr 4, 2020)."
    },
    {
      "id": "ba93a92a-87bc-4eb5-b06e-8c6119100af6",
      "text": "Council of State and Territorial Epidemiologists (CSTE) interim position statement published (Apr 5, 2020) updating COVID-19 case/death definitions to include probable cases."
    },
    {
      "id": "b8f25f7c-1b81-4e37-9f35-478976c1b8fb",
      "text": "CDC/NCHS released a provisional death counts report (PDF) with technical notes emphasizing that counts are provisional, delayed, and that multiple causes can be listed on death certificates (released Apr 10, 2020)."
    },
    {
      "id": "675a521a-b49e-4a50-bd55-7b385ae2368f",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I — Summary for Policymakers published"
    },
    {
      "id": "d8f1116e-b8e4-44c8-b2e0-e3a9f21c6ca8",
      "text": "NOAA issues La Niña advisory / 'double-dip' La Niña announcement"
    },
    {
      "id": "268224a1-81a0-40a0-b100-0e3b897c7a24",
      "text": "Passage of Ukraine's 'decommunization' laws (April 9, 2015) banning public display of Soviet symbols and changing commemorative practices."
    },
    {
      "id": "f7b3741e-3ff3-477e-833d-510531c56e36",
      "text": "Verkhovna Rada passes sweeping 'anti-protest' laws (known as the 'dictatorship laws') restricting public assembly, internet access and media on January 16, 2014."
    },
    {
      "id": "aa8ced11-33e8-4dfa-a777-998135937715",
      "text": "Deadly police crackdown on Euromaidan protests in Kyiv (notably February 18–20, 2014) where security forces used live fire against demonstrators."
    },
    {
      "id": "652002d2-8a3d-47b5-83a2-1bc03a3d02d1",
      "text": "April 2014 'anti-terrorist operation' (ATO) launched in eastern Ukraine (Donetsk/Luhansk) with security operations, checkpoints and restrictions on movement and gatherings."
    },
    {
      "id": "3884db69-6ca6-4ea3-9050-5a4f1a38d906",
      "text": "Rapid growth of the global 'detox' / detox‑supplement market (industry reports and press releases 2020–2021 showing large and growing commercial market for detox supplements)."
    },
    {
      "id": "332e1724-af40-488b-98b4-34de0d227565",
      "text": "Publication of a 2022 peer-reviewed review 'Can Antioxidants Reduce the Toxicity of Bisphenol?' summarizing multiple studies that several dietary antioxidants (curcumin, quercetin, melatonin, lycopene, genistein, etc.) reduce BPA‑induced oxidative stress in vitro and in animal models."
    },
    {
      "id": "8d73d89f-a149-40ab-a9d8-3bd1bf052237",
      "text": "Regulatory controversy and mixed messaging about BPA safety after regulatory reviews (e.g., FDA’s 2018 BPA assessment) prompted public debate and critical commentary from scientists."
    },
    {
      "id": "da8b0d27-574d-4160-874f-3dfd267572ea",
      "text": "Takeda and Moderna publish investigation and voluntary recall statement after foreign-particle findings in Japan"
    },
    {
      "id": "de66ea25-fe29-493e-9ca1-a9c48d258a0c",
      "text": "Publication and reporting of excess-mortality analyses in Japan showing increased deaths during/after the pandemic with cardiovascular diseases among contributing causes"
    },
    {
      "id": "9a96fed9-679f-4d77-8bae-cfea4c180fe9",
      "text": "Public-health reports and peer-reviewed case reports document myocarditis/pericarditis occurring after mRNA COVID-19 vaccination (identified in 2021 monitoring and guidance)"
    },
    {
      "id": "9636e7f7-f323-42f3-9678-018b36dca663",
      "text": "Harvard launches the Solar Geoengineering Research Program (SGRP), formalizing academic research into stratospheric aerosol methods."
    },
    {
      "id": "bbf6cbba-ed02-4c30-884a-e2f6eb5f8ec2",
      "text": "IPCC Special Report on Global Warming of 1.5°C (SR1.5) discusses solar radiation management (SRM) as a theoretical option and highlights governance and uncertainty issues."
    },
    {
      "id": "1d9c7f8c-7c46-41ed-9120-4d1ccad37e23",
      "text": "Major media coverage highlighting geoengineering as a contested climate option (e.g., The Guardian: 'Geoengineering may be used to combat global warming, experts say')."
    },
    {
      "id": "0ae871e4-c93b-499e-9729-35dd7eea531d",
      "text": "2018 pilot study published in the Journal of Alzheimer's Disease reporting cognitive improvements after a 21-day coconut oil–enriched Mediterranean diet"
    },
    {
      "id": "6fe2ff24-1c4b-4a04-94ba-def1daaaae8e",
      "text": "International media and human-rights organizations reported abductions, torture and summary killings in eastern Ukraine (including areas around Slovyansk) during April–May 2014."
    },
    {
      "id": "2cd17608-a3a1-4148-bac5-8ff63680024d",
      "text": "Pro‑Russian militants abandoned Slovyansk and Ukrainian forces re-entered the city after the siege, leaving a chaotic information environment and reports of casualties and abuses."
    },
    {
      "id": "a138054c-510f-4593-b3ab-f16d92c84668",
      "text": "Russia imposes a one‑year ban on many Western food imports (fruit, vegetables, meat, dairy) in retaliation to sanctions"
    },
    {
      "id": "719debe7-77ec-4ef4-b4fa-3292b895aacd",
      "text": "Coverage in early 2015 highlighting that Russians were spending a much larger share of income on food amid economic turmoil"
    },
    {
      "id": "76c16e04-c75e-43c7-9a3f-ff2ecdcb6adb",
      "text": "Russian rouble crashes in December 2014, prompting emergency central‑bank action"
    },
    {
      "id": "5aac0275-2df4-4079-9a43-f4d551720f5a",
      "text": "FDA published a draft guidance clarifying aluminum limits for small-volume parenteral products used in parenteral nutrition (widely covered Dec 2022)"
    },
    {
      "id": "10d5a29b-3409-4a51-9ace-43d54e3fb5eb",
      "text": "Publication of Vaccine pharmacokinetic analysis that became the benchmark for vaccine aluminum safety assessments (Mitkus et al., 2011)"
    },
    {
      "id": "41be2912-a92c-49cf-8992-e53ca8442812",
      "text": "FDA warning about aluminum risk from an unapproved Hospira potassium phosphates product (FDA alert)"
    },
    {
      "id": "b422ade6-fe37-4342-9c94-f558dc1f6d06",
      "text": "European Commission progress report concluded Ukraine met the benchmarks for visa liberalisation and announced it would present a legislative proposal to lift short-stay visa requirements."
    },
    {
      "id": "42ed635a-b8e2-47a3-adc0-3096844abd7a",
      "text": "Immediate Dutch government reaction was cautious — officials said they would reconsider ratification and seek a formal response, but announced no immediate legal block to EU-level procedures."
    },
    {
      "id": "12fb89a8-7d3a-44d8-9034-eb35ba71efe1",
      "text": "Historical precedent: Ukraine suspended passenger and cargo rail/bus links to Crimea in December 2014 citing security concerns"
    },
    {
      "id": "1b13c812-81e5-4522-8a73-474b58c8824a",
      "text": "UK MHRA conditional authorisation and patient information leaflets published (regulatory materials listing ingredients and usage information)"
    },
    {
      "id": "3bda60e7-ed94-4ec2-9405-c9c81258a1cf",
      "text": "FDA/BioNTech briefing documents for the VRBPAC EUA review that list vaccine components (mRNA, lipid nanoparticle constituents including PEG, salts, and sucrose)"
    },
    {
      "id": "be63afc2-aba4-4262-8fa9-91dd6c829ea2",
      "text": "Ukrainian President Volodymyr Zelensky publicly floated Rustem Umerov as a possible candidate to be Ukraine's ambassador to the United States during the International Ukraine Recovery Conference (URC2025) in Rome."
    },
    {
      "id": "2f7812a5-0f4b-4681-a35b-85b384b624c8",
      "text": "U.S. FDA public warning against using veterinary or unapproved ivermectin products to treat or prevent COVID‑19"
    },
    {
      "id": "4f14a3d3-a2af-4fb4-9c5b-77e81db0e24c",
      "text": "CDC public information noting 'common human coronaviruses' (229E, NL63, OC43, HKU1) have been identified for decades"
    },
    {
      "id": "6a6243b9-18f2-454b-a36e-eaca6ac954ea",
      "text": "Implementation of selective city-level bans on older diesel vehicles (example: Munich introduced restrictions on Euro 4 diesel vehicles in its low‑emission zone)."
    },
    {
      "id": "8bb44fdc-fdb0-4a26-882a-fc0bc28cb158",
      "text": "European Commission publishes proposal COM(2023)451 — a draft Regulation on circularity requirements for vehicle design and management of end‑of‑life vehicles (revising ELV rules)."
    },
    {
      "id": "50412109-04a6-4ae7-95f1-52dcd65d0f33",
      "text": "EU ‘Fit for 55’ / CO2 standards debate and widespread coverage of the EU aim for zero‑emission new cars by 2035."
    },
    {
      "id": "c089f020-2b1d-4af0-b3cf-0dfdea7e1451",
      "text": "Hungarian Prime Minister Viktor Orbán publicly opposed fast‑tracking Ukraine’s EU accession (Dec 13, 2023)"
    },
    {
      "id": "c5635cfb-1ed4-443a-b1da-b1c51e0f1cdd",
      "text": "‘For Ukraine, for their Freedom and Ours!’ campaign urged MEP candidates to sign a pro‑Ukraine Commitment Charter (May 11, 2024)"
    },
    {
      "id": "f80084e1-f78e-45e5-afad-1851567b2f30",
      "text": "Yle launched/ran its European election 'compass' showing candidate positions (May 2024)"
    },
    {
      "id": "9c18abc8-e211-4150-99de-08279282031e",
      "text": "European Parliament Special Committee warned of foreign interference and disinformation ahead of the June 2024 elections (May 24, 2024)"
    },
    {
      "id": "fb0583c0-c588-458e-ab4c-cbb0dc8d6e19",
      "text": "Public release/submission of the RaTG13 genome sequence to public databases (GenBank accession MN996532 / GISAID submission in January 2020)."
    },
    {
      "id": "8b45eff6-3eec-4abe-be2b-171304c22e14",
      "text": "BMJ Case Report (2018) and wider media attention on Macrophagic Myofasciitis (MMF) case reports linking persistent aluminium deposits at injection sites to chronic symptoms."
    },
    {
      "id": "036c29b2-0aed-4e11-9f8c-b89c77df016e",
      "text": "2013 BMC Medicine study 'Slow CCL2‑dependent translocation of biopersistent particles from muscle to brain' (Khan et al.)."
    },
    {
      "id": "62354f10-9854-4b6b-a2f0-76f2bbbb9d5c",
      "text": "Publication of 2015 review 'Biopersistence and Brain Translocation of Aluminum Adjuvants of Vaccines' by Gherardi et al."
    },
    {
      "id": "596dadca-7ecf-4ad3-9240-155524a0321a",
      "text": "EU publicly criticises Poroshenko's anti‑corruption court bill and signals consequences (January 2018)"
    },
    {
      "id": "f0934c56-ec5b-4af0-a746-6e2b253770b7",
      "text": "U.S. criminal indictment of Paul Manafort (October 2017) for unregistered lobbying related to Ukraine"
    },
    {
      "id": "f2549918-16ff-4631-a465-2b9b49adae82",
      "text": "Investigative exposé on defence procurement implicating son of Poroshenko ally (Hladkovskyi)"
    },
    {
      "id": "4f1c4513-d2ef-45af-8edd-7f7c6d7acec7",
      "text": "Ukrainian President Petro Poroshenko signs a cooperation agreement with Ecumenical Patriarch Bartholomew in Istanbul to advance autocephaly for a Ukrainian church."
    },
    {
      "id": "f5a77d26-097c-4c34-9a8d-741665227f16",
      "text": "Reporting that President Poroshenko publicly used the Tomos and the new church as part of his 2019 re-election messaging."
    },
    {
      "id": "67dff1f5-a16f-4d8a-8246-08683f4356dd",
      "text": "U.S. administration ordered an intelligence review into the origins of COVID‑19 (President Biden, public announcement and press coverage), which brought renewed political attention to lab‑origin claims (May 2021)."
    },
    {
      "id": "87f1afab-9886-497e-bd50-ded7dc234038",
      "text": "Reporting in mid‑2023 that Ukraine’s 2023 summer counteroffensive produced only limited gains (e.g., BBC and other outlets in August 2023) created a broader narrative of stalled Ukrainian progress"
    },
    {
      "id": "c892815e-ba02-4fbe-aaf9-7e5ab8e32444",
      "text": "Japan suspends and recalls Moderna vaccine doses after foreign particles found (August–September 2021)"
    },
    {
      "id": "1379ed5a-dc8f-4dc0-b83c-3ac31cd9020a",
      "text": "CDC guidance allowing fully vaccinated people to resume most activities without masks (May 13, 2021) and subsequent reversals with Delta/Omicron"
    },
    {
      "id": "facf3501-0244-4305-9925-f7c9aa3bba25",
      "text": "Federal judge orders expedited release of large batches of FDA/Pfizer vaccine documents after FOIA litigation (January 2022)"
    },
    {
      "id": "4039d703-a1d4-4cc6-ae5d-87f162f75e59",
      "text": "CDC/ACIP update and MMWR on myocarditis reports after mRNA vaccines (June 2021)"
    },
    {
      "id": "75eac795-7813-4c90-849e-a328ea85cdac",
      "text": "CDC VISION Network MMWR showing waning mRNA vaccine effectiveness during Omicron (Feb 2022)"
    },
    {
      "id": "2c54f3fc-53e6-4314-aef4-ec5de9731cf0",
      "text": "Russia sends 'humanitarian convoy' toward eastern Ukraine and insists on involvement (August 2014)"
    },
    {
      "id": "a225fb8e-01e5-4bc0-83bc-1cd4443cbf55",
      "text": "Ukrainian parliament adopts law granting 'special status' to certain areas of Donetsk and Luhansk"
    },
    {
      "id": "17b8c008-0413-43ef-8e62-1b3e41a4a0c4",
      "text": "President Vladimir Putin’s public justification (March 2014) for actions in Crimea citing protection of Russian speakers/compatriots"
    },
    {
      "id": "15eff4ff-752f-469d-ac3d-cf27e57e7342",
      "text": "Longstanding monitoring and studies at Altamont Pass Wind Resource Area documenting unusually high raptor (including golden eagle) mortality at that site (estimates cited of ~75–110 golden eagles killed annually in some monitoring periods)."
    },
    {
      "id": "54325ce3-1512-4768-992a-66f0f8e920f0",
      "text": "U.S. Fish & Wildlife Service final eagle incidental-take rule (2024) — revised permitting framework and creation/clarification of general permits for qualifying wind projects (rulemaking completed Feb 2024)."
    },
    {
      "id": "f512e1cc-18eb-4be6-ace2-84dfa7e939d9",
      "text": "Europe’s 2022 energy-price shock and widespread reporting (Eurostat summary Apr 26, 2023) showing record household electricity and gas price increases in 2022."
    },
    {
      "id": "90acb2f0-5b14-4c2c-b233-ea7d144bdb5c",
      "text": "Winter Storm Uri (Feb 2021) — widespread reporting and official ERCOT analyses showing frozen equipment across fuel and renewable sources and public debate blaming frozen wind turbines for Texas outages."
    },
    {
      "id": "c7e20b17-7466-4ce1-894e-90163480399c",
      "text": "Adoption of Ukraine's 'decommunization' laws banning communist symbols (including measures that led to restricting St. George's ribbon) by the Verkhovna Rada."
    },
    {
      "id": "c6950cb3-e288-4c5a-87c6-4dce2df15ab4",
      "text": "High‑profile coverage in Western and regional media documenting the St. George's ribbon's revival in Russia and its adoption by pro‑Russian activists in eastern Ukraine around Victory Day (widely reported in 2014–2015)."
    },
    {
      "id": "67df963f-093e-4ca0-8223-a134f2b01be7",
      "text": "British intelligence assessment reported that Russia may have lost a third of the ground forces it committed to the Ukraine offensive"
    },
    {
      "id": "b0aa8582-a02b-482c-97fc-31bc9bc0988b",
      "text": "Ukrainian General Staff released casualty figures for Russian forces (tens of thousands) in mid‑May and publicized high cumulative loss numbers"
    },
    {
      "id": "3c456844-3843-408e-bba9-e1b938e9c122",
      "text": "Public drone and ground imagery showing multiple destroyed Russian tanks and armoured vehicles around Kyiv and in Bucha after Russian withdrawals"
    },
    {
      "id": "413a6954-3ccb-4496-859b-9e64fcf48ad9",
      "text": "Maxar and other commercial satellite imagery releases in May 2022 showing destroyed equipment and damage across multiple frontline areas"
    },
    {
      "id": "953d0f4e-de91-4c9a-857c-d602fd9feb09",
      "text": "WHO designation of Omicron as a variant of concern and rising discussion of immune escape (Nov 26, 2021)"
    },
    {
      "id": "33ccea91-e7e3-422a-9dc2-d9a8020f0bdc",
      "text": "Public‑health guidance reiterating vaccination after prior infection (CDC and other authorities, 2021–early 2022)"
    },
    {
      "id": "f7ef0dab-8917-472f-a8a6-63f35eba88ff",
      "text": "Publication of Dagan et al. (Israel) showing high real-world effectiveness of the BNT162b2 (Pfizer) vaccine"
    },
    {
      "id": "a962fc5f-24ff-4c6e-a247-1ff2fd6df37a",
      "text": "Hungary blocked a NATO–Ukraine commission meeting over Ukraine's 2017 education law"
    },
    {
      "id": "a1ee7052-c980-4fb2-8d5a-4cd6a16a06c2",
      "text": "Hungarian government rhetoric defending the Hungarian minority in Zakarpattia and threatening to obstruct Ukraine's Euro-Atlantic integration (2017)"
    },
    {
      "id": "ec33a170-1453-40a4-8f20-6d255d78fe65",
      "text": "Hungary's close energy and political ties with Russia (Paks II nuclear deal signed in January 2014)"
    },
    {
      "id": "a3cbf3f9-5255-4738-8bb1-30d03f5ea612",
      "text": "Malaysia Airlines Flight MH17 shot down over eastern Ukraine"
    },
    {
      "id": "4df60cd2-ed44-49d4-af98-a38d8a7f2b7d",
      "text": "EU/East StratCom and Western coverage documenting Russian disinformation campaigns in Europe (2015–2017)"
    },
    {
      "id": "96b80c06-b64d-48a0-a866-fa12a69c8022",
      "text": "The OSCE Parliamentary Assembly (OSCE PA) deployed a separate observer delegation and issued a statement describing the election as 'well administered' while also noting it took place in an 'overly controlled environment'."
    },
    {
      "id": "5d3c8522-8b54-444e-996e-00ed7e252767",
      "text": "CIS (Commonwealth of Independent States) and other regional observer missions publicly declared the election legitimate, transparent or free."
    },
    {
      "id": "52d563db-56f0-4713-8419-820df9a6af1a",
      "text": "OSCE/ODIHR published a preliminary statement saying the 18 March 2018 Russian presidential election 'lacked real choice' and noted pressure on critical voices."
    },
    {
      "id": "371d4c61-e8be-4e96-8f8b-41fbd855bb80",
      "text": "Brazilian President Jair Bolsonaro publicly called COVID‑19 'a little flu' and urged reopening despite rising cases."
    },
    {
      "id": "361583a1-3ab5-4990-b50e-486b2864d236",
      "text": "U.S. CDC published its estimated burden for the 2019–2020 influenza season (tens of thousands of flu deaths) during spring 2020."
    },
    {
      "id": "358b2051-a2c0-4f07-a722-49419301d4ac",
      "text": "U.S. CDC issued guidance for certifying deaths due to COVID‑19 allowing certifiers to report COVID‑19 on death certificates without laboratory confirmation in certain circumstances (Guidance for Certifying COVID‑19 Deaths, April 2020)."
    },
    {
      "id": "cfe79470-7eb9-4ab4-8c55-75b6311329e8",
      "text": "International monitors curtailed/paused long-range drone surveillance after repeated shoot-downs and jamming"
    },
    {
      "id": "c6969ea7-2cb0-48fc-a29e-5d0e2e3dcc0a",
      "text": "OSCE long-range UAV lost after spotting a surface-to-air missile system near Donetsk"
    },
    {
      "id": "2be8f441-d916-4f8a-bbd3-87bb25330991",
      "text": "Pentagon comments and reporting that a limited amount of Presidential Drawdown Authority/stockpiles remained to provide to Ukraine (public discussion of remaining resources)"
    },
    {
      "id": "b30e4341-3899-4e8e-9c88-1b334e46e7a4",
      "text": "President Biden formally requested roughly $24 billion in new aid for Ukraine (public request to Congress)"
    },
    {
      "id": "970ef17c-9ae1-4064-bafa-37436103dbfb",
      "text": "U.S. State Department and other reports described Ukrainian procedures allowing some civil-status acts (for example, births) occurring in occupied areas to be registered using documents produced by occupation authorities to ensure access to services."
    },
    {
      "id": "ccd393be-47d2-41d6-871b-4624f8aca860",
      "text": "Ukrainian Ombudsman statement noting Ukraine does not recognize Russian passports issued in occupied territories, while discussing legislative options for how residents might renounce such documents after liberation."
    },
    {
      "id": "274701e0-c87e-4a92-8ffc-f0e549a34634",
      "text": "Verkhovna Rada approved a mechanism to evaluate/validate educational documents issued in temporarily occupied territories (draft law passed to create testing/validation procedures)."
    },
    {
      "id": "3cbf07f1-46b7-4d3c-9da2-4e78f0de56fd",
      "text": "Ukraine engaged in limited, practical negotiations and humanitarian arrangements (e.g., corridors for ships, humanitarian talks) with actors linked to occupied areas and with mediators in 2023."
    },
    {
      "id": "e0b9ec6a-ef37-4be8-9a8f-fb3a4eaed21c",
      "text": "Samoa measles outbreak and prior botched MMR injections that caused two infant deaths, undermining local vaccine confidence"
    },
    {
      "id": "d9cfc5d8-142b-4158-8b7d-58772f988b60",
      "text": "CDC reporting of rare myocarditis/pericarditis cases after mRNA COVID‑19 vaccination in adolescents"
    },
    {
      "id": "db26f402-9699-4f53-adc2-5c49174a685c",
      "text": "New York Times feature 'In Washington, Olena Zelenska Dressed for Ukraine' describing her Washington wardrobe, the role of her stylist, and the diplomatic messaging in her clothing choices."
    },
    {
      "id": "b448de85-22bb-4921-bedf-84e814f19ea8",
      "text": "Tobacco industry pivot and public messaging promoting nicotine products (e.g., BAT reporting growth in vaping/oral nicotine)"
    },
    {
      "id": "abd62fb9-dfd6-451a-b1e2-5c9a1b4eb5a6",
      "text": "Cochrane systematic review finding transdermal nicotine superior to placebo for active ulcerative colitis (with important limitations)"
    },
    {
      "id": "b3afa837-aa0d-4eb9-a7c8-517a907dfa27",
      "text": "Small Phase 1 trial of an alpha7‑nicotinic agonist showing biomarker and attention effects in two adults with autism"
    },
    {
      "id": "29685c61-610b-4a8b-99ab-2e16778e13f1",
      "text": "Early reporting and analysis warned that Russian tactics could include heavy artillery, siege and attrition that would 'grind down' Ukrainian defenses and cities."
    },
    {
      "id": "f051cc8c-6a20-4d6c-a0cb-43d0d946125c",
      "text": "U.S. Secretary of State Antony Blinken made multiple public remarks in early March emphasizing both the scale of Russian forces and U.S. support for Ukraine (including a March 6 interview where he said Putin 'is destined to lose')."
    },
    {
      "id": "b8deb308-1885-4578-90fc-5e30e5808a8d",
      "text": "USDA and FDA announce formal agreement on regulation of cell‑cultured food products"
    },
    {
      "id": "b3be0f40-8fdc-4f79-aeeb-9a3360f22c21",
      "text": "GFI (Good Food Institute) '2022 Cultivated Meat State of the Industry' report (published Jan 2023)"
    },
    {
      "id": "80e39e30-3b7e-41fc-a1c4-99fb925668b9",
      "text": "First PEGIDA offshoot rally in Sweden (Malmö) and associated media coverage of anti‑Islam/anti‑migration street demonstrations"
    },
    {
      "id": "19e97047-b708-411c-b6f1-59ca118e857a",
      "text": "U.S. FDA approval of VEKLURY (remdesivir) for COVID‑19 treatment (press announcement and approval) in October 2020."
    },
    {
      "id": "be38e493-a4a0-49ec-abd2-bb6182778ce7",
      "text": "PALM (Ebola) randomized trial (NEJM, 2019) stopped remdesivir arm after interim results showed higher 28‑day mortality in the remdesivir group compared with certain monoclonal antibody treatments."
    },
    {
      "id": "e25d9cc2-d1d6-41c0-aa75-5ef3d6ae4d81",
      "text": "President Zelensky dismissed all regional military recruitment centre heads amid a corruption scandal (public firing announced 11 August 2023)."
    },
    {
      "id": "759bc274-fc7e-4c8c-875f-5d9d3e0bc6d1",
      "text": "Verified reports of real civilian fatalities in Bila Tserkva from previous Russian attacks (example: kamikaze drone/strike reported 05 October 2022 with at least one casualty)."
    },
    {
      "id": "aa77c6dd-6815-4ee7-95cc-9f476723df75",
      "text": "A separate, real violent incident linked to conscription/document checks was reported (draft officer fatally wounded during a papers check in Lviv)."
    },
    {
      "id": "436ac542-f466-477c-90f1-8779404eafbf",
      "text": "President Obama and some Western leaders publicly deferred sending lethal weapons to Ukraine (reported agreement not to supply lethal defensive arms at that time)."
    },
    {
      "id": "c38dd94a-ab02-4ef1-bb83-5b2fcecec724",
      "text": "Canada launched Operation UNIFIER, a Canadian Armed Forces training mission to Ukraine."
    },
    {
      "id": "48530f0d-bb14-4da4-9e07-c07bd14e1a91",
      "text": "Pentagon suspended planned military exercises and activities with Russia amid the Ukraine crisis."
    },
    {
      "id": "b3888e25-51f1-4dc1-8dc9-941a6e307477",
      "text": "NATO Secretary-General publicly stated NATO had no plans to deploy combat troops to Ukraine."
    },
    {
      "id": "0a12843a-9484-48c5-92c6-08e7bbd4cdab",
      "text": "NSIDC analysis: unusually rapid December 2023 sea-ice expansion noted in early January 2024 ('Fast December expansion')"
    },
    {
      "id": "9d9565d5-8ea3-4db0-911c-a1ab63581ca2",
      "text": "IPCC AR6 (WGI) projection showing Arctic likely to be 'practically ice-free' in summer near mid-century (released Aug 2021)"
    },
    {
      "id": "149b435e-0838-4b78-ac8a-64e644aa02d5",
      "text": "Sterigenics / Willowbrook ethylene oxide emissions controversy and EPA/CDC assessments (facility operations suspended/closed amid cancer‑risk concerns)."
    },
    {
      "id": "d2f0ec5a-c60f-47ad-8641-9bb20c727dd0",
      "text": "Ukrainian authorities agreed to implement the 'Steinmeier formula' as part of efforts to restart Minsk-format negotiations (announced Oct 1–2, 2019)."
    },
    {
      "id": "a5df38b9-2deb-4820-9ba6-667ae40ca26d",
      "text": "Volodymyr Zelensky publicly proposed direct talks and a conciliatory approach to Russia after taking office, signalling a priority on negotiation and rapprochement."
    },
    {
      "id": "a822c036-5334-41e1-8f49-d66ea1f5558b",
      "text": "Russia and Ukraine carried out a high-profile prisoner exchange in early September 2019, swapping dozens of detainees."
    },
    {
      "id": "07afca8c-75c7-4e63-b710-40046c2ea030",
      "text": "Ukraine's legal framework largely prohibits/does not recognize dual citizenship (Law on Citizenship of Ukraine, enacted)"
    },
    {
      "id": "2b6a207f-016f-41c5-b2cd-490c79cdd5ed",
      "text": "Russia begins mass issuance of Russian passports in annexed Crimea (widely reported)"
    },
    {
      "id": "e1e40157-3022-4baf-a59b-3802d4ce6a78",
      "text": "Italian TV documentary 'Ucraina, le verità nascoste' by Gian Micalessin aired on Canale 5 (Matrix) and presented testimony alleging Georgian snipers fired on Maidan protesters."
    },
    {
      "id": "314b9885-f959-4540-8a81-6db59af29278",
      "text": "Zeman's high‑profile engagement with Russia (including attending Moscow Victory Day events and meeting Putin in May 2015)."
    },
    {
      "id": "3f33bcc6-16fd-4146-9119-4063190d2547",
      "text": "Zeman's October 2017 PACE remarks calling the annexation of Crimea a 'fait accompli' and suggesting compensation."
    },
    {
      "id": "37bb4f09-1949-4ca9-925f-f2f7f5fae02a",
      "text": "Pro‑Kremlin Crimean Tatar group Kyrym Birligi was invited to the presidential Independence Day reception at Prague Castle."
    },
    {
      "id": "6dba0146-ee5c-4d22-8202-366446328116",
      "text": "Widespread news stories and headlines (e.g., Meduza) summarising Zelensky's comments emphasizing Ukraine could pursue a diplomatic return of Crimea rather than costly military operations"
    },
    {
      "id": "8c6381d1-06d3-48cd-9fcb-f6d47803b1c8",
      "text": "DFRLab report documenting increasing use of AI‑generated audio/video and synthetic media in the Ukraine information space (showing precedent and tools available for falsifying statements)"
    },
    {
      "id": "afa3f769-5fb0-4994-aa0a-de98c97a7804",
      "text": "Pre-existing public commemorations of Stepan Bandera in Ukraine (e.g., Kyiv renaming Moscow Avenue to Bandera Avenue in 2016)"
    },
    {
      "id": "e1ed5bff-cfaa-4746-a821-bb42e9eee497",
      "text": "India (Serum Institute) placed temporary export restrictions on AstraZeneca/COVISHIELD supplies as domestic COVID-19 cases surged, delaying shipments to COVAX and other countries."
    },
    {
      "id": "a6488430-f13d-4976-8ffa-b5d2a3a03f1d",
      "text": "WHO leaders publicly warned that vaccine supply was limited and urged countries to prioritise high-risk groups and support equitable distribution rather than assume immediate universal coverage."
    },
    {
      "id": "9e7eed4f-220c-42c1-8287-6912c7842d0e",
      "text": "COVAX cut its 2021 delivery target after supply problems, announcing a lower-than-expected dose forecast and warning it would fall short of initial goals."
    },
    {
      "id": "94c08630-0cd5-48a4-ac1e-abb0096a007d",
      "text": "Contamination and production errors at Emergent BioSolutions' Baltimore plant led to the destruction or sequestering of millions of vaccine doses and an FDA-ordered manufacturing pause."
    },
    {
      "id": "e4020dee-d50d-426e-abc1-808bd759fcd8",
      "text": "Reports in early 2021 that lipid nanoparticles and other specialized raw materials used in mRNA vaccines faced constrained global supply with few suppliers."
    },
    {
      "id": "51c79555-6f9f-43e9-bffc-8e400d241a59",
      "text": "German Bundestag held a special session (27 February 2022) condemning Russia’s full‑scale invasion and reaffirming Ukraine’s territorial integrity"
    },
    {
      "id": "1b6307cb-cc36-4ffc-a619-8d593dbd8424",
      "text": "WHO declaration of a Public Health Emergency of International Concern (PHEIC) for the novel coronavirus"
    },
    {
      "id": "61c5a464-83ba-41ba-a8e3-4ea93188d477",
      "text": "ClinicalTrials.gov registration NCT04264533: 'Vitamin C Infusion for the Treatment of Novel Coronavirus Pneumonia (COVID-19)' (trial listing for high‑dose IV vitamin C in Wuhan)"
    },
    {
      "id": "914a2057-3abf-4b5e-bf8d-7a86635735ff",
      "text": "Institute of Medicine (IOM) report 'Immunization Safety Review: SV40 Contamination of Polio Vaccine and Cancer' published"
    },
    {
      "id": "77f2d1fe-fcaa-4e36-af2a-d7e947ebc3b5",
      "text": "Major media coverage attributing growing fire severity to climate change (e.g., New York Times analysis, Nov 2018)"
    },
    {
      "id": "d31e760e-221b-405a-b2a4-4d4e8770860f",
      "text": "Camp Fire (California, 2018) linked to failing utility equipment (PG&E)"
    },
    {
      "id": "4338c56d-1ee1-42e6-8b86-59066fe99e57",
      "text": "2019–20 Australian 'Black Summer' bushfires and public debate blaming land management policies"
    },
    {
      "id": "5b404305-a187-4827-a04c-da7ccb6139a8",
      "text": "Precedent of cross-border attribution confusion: Przewodów missile incident (Poland, Nov 2022)"
    },
    {
      "id": "ac80fb30-7c46-4efa-8203-8849169b83ab",
      "text": "Poland officially accused Russian intelligence of ordering the arson (government announcement)"
    },
    {
      "id": "462638c9-c9ce-4650-af3c-bfb23f68d25a",
      "text": "Reports that Ukrainian nationals were among suspects detained/charged in connection with the fire"
    },
    {
      "id": "474f5052-9cdd-45c6-950f-9afa02aad4d8",
      "text": "Massive fire destroyed the Marywilska 44 shopping centre in Warsaw (original incident)"
    },
    {
      "id": "2351854f-aaf1-4bfd-984c-3bc9d980c1b0",
      "text": "bioRxiv preprint demonstrating inhalable polymer nanoparticles for mRNA delivery (preprint posted March 23, 2022)."
    },
    {
      "id": "84cb69d6-6cbf-4df8-8678-144ef113fd4a",
      "text": "Regulatory findings and national pauses/age‑restrictions after reports of very rare thrombosis with thrombocytopenia syndrome (TTS) following the AstraZeneca vaccine."
    },
    {
      "id": "a994e659-49e3-4806-825e-e666077e798c",
      "text": "Official statistics showing substantial 'excess deaths' in 2022 (published reports covering March 2020–Dec 2022), prompting public debate about causes of excess mortality."
    },
    {
      "id": "f6142039-3fc7-4af3-a3a9-87d0c7da5003",
      "text": "Published studies showing markedly reduced vaccine effectiveness at preventing infection with the Omicron variant (while protection against severe disease remained better)."
    },
    {
      "id": "2b07e9d4-c9eb-4255-bac4-e301f267a58e",
      "text": "Peer‑reviewed reports and surveillance data linking mRNA vaccines to rare cases of myocarditis, especially in adolescent and young adult males."
    },
    {
      "id": "bb748b52-4304-4eed-b247-e4d11a492e1f",
      "text": "Press coverage reporting ~1 million Ukrainians working legally in Poland (KyivPost article, April 27, 2017)."
    },
    {
      "id": "0d7d7cd6-18a4-4333-9251-d959fbe2f715",
      "text": "ILO / national labour statistics for 2017 showing Ukraine's unemployment rate around ~9–10% (not a new historical high) and contrasting definitions between 'registered' unemployment and ILO measures."
    },
    {
      "id": "99d986ba-d36c-4bd0-ba02-28432c62c77b",
      "text": "World Bank / Migration and Remittances Factbook 2016 and related World Bank migration data showing migrant stocks/remittances far lower than 45% of Ukraine's population (Migration & Remittances Factbook 2016)."
    },
    {
      "id": "b3692450-a4bf-4345-8f0e-6dbb92d3e3a6",
      "text": "US NTP/NIEHS 2018 partial findings on cell‑phone radiation and tumors in rats"
    },
    {
      "id": "1f48df8f-b219-4947-8919-21cc9365cf67",
      "text": "IARC classifies radiofrequency electromagnetic fields as 'possibly carcinogenic' (Group 2B)"
    },
    {
      "id": "2bc1e157-e741-4377-899a-793c3a322854",
      "text": "Publication: 'Static magnetic fields from earphones: Detailed measurements plus some open questions' (Environmental Research)"
    },
    {
      "id": "bf48e0c8-6b76-4bd1-bb96-cfe6388a9243",
      "text": "CDC laboratory/testing guidance updates in September 2020 clarifying testing recommendations for asymptomatic people (CDC posted a laboratory update clarifying testing for SARS-CoV-2 on Sept 18, 2020)."
    },
    {
      "id": "b753f791-7516-41db-940f-1798e0fdfbf0",
      "text": "WHO EMRO (Eastern Mediterranean Regional Office) guidance page (June 11, 2020) summarised evidence as indicating 'most transmission occurs from symptomatic people' while discussing asymptomatic cases."
    },
    {
      "id": "bc24047c-2c1a-409c-8084-6070c6077d84",
      "text": "Kyiv renamed a major thoroughfare (Moskovskyi/Moscow Avenue) after Stepan Bandera (renaming enacted July 2016)."
    },
    {
      "id": "80264d7f-d885-40ac-9716-ec548a6a18a9",
      "text": "Torch‑lit nationalist marches in Kyiv commemorating Stepan Bandera and other WWII nationalist figures (widely reported torchlight marches, e.g. 14 October 2018)."
    },
    {
      "id": "527dc6f0-d251-4dee-8108-e6d965d1acff",
      "text": "Passage of Ukraine's 'decommunization' laws that banned Soviet symbols and rewrote certain aspects of public memory (April–May 2015)."
    },
    {
      "id": "bfd00629-aad9-4669-991f-7ce7632d7aed",
      "text": "March 2019 law/instruments extending veteran status or recognition to surviving members/participants of the UPA/OUN (legal changes coming into force in March 2019)."
    },
    {
      "id": "2988ed3f-8d55-42a9-aeb8-1e289dc22a22",
      "text": "Media reports documenting neo‑Nazi links in the Azov volunteer unit (coverage of ideology, symbols and far‑right volunteers)."
    },
    {
      "id": "794945b4-9967-4114-b28b-9b21276600bf",
      "text": "Swiss authorities announced an immediate freeze on assets linked to Yanukovych and members of his entourage (Switzerland froze assets and opened probes in February 2014)."
    },
    {
      "id": "8d3033f8-b26c-49a6-bbbd-29649925f2d7",
      "text": "Ukrainian authorities announced confiscation/transfer of roughly $1.5 billion in assets allegedly linked to Yanukovych and his circle into state accounts (reported April 2017)."
    },
    {
      "id": "763490bf-d450-4201-b047-b5795f2a279c",
      "text": "Ukraine imposed a moratorium/default on repayment of the $3 billion Russian-held Eurobond that matured in December 2015."
    },
    {
      "id": "6f3937e0-0969-4b7c-a2d8-449c9102e2e4",
      "text": "Russia filed a lawsuit in London's High Court seeking repayment of a $3 billion Eurobond the Yanukovych-era government issued to Russia."
    },
    {
      "id": "7cd1d0a8-4b6b-4508-a82c-dee4ee393d40",
      "text": "UN Secretary-General Antonio Guterres warned the shelling around Zaporizhzhia was 'suicidal' and called for cessation of military activity"
    },
    {
      "id": "b1a14284-7971-48a7-af1e-919877929a63",
      "text": "March 4, 2022 shelling and fire at Zaporizhzhia during Russia's seizure of the plant (initial chaos and conflicting reports)"
    },
    {
      "id": "06b40460-322d-4c00-a603-7425c216f72c",
      "text": "Russian officials and state media publicly accused Ukrainian forces of shelling/damaging Zaporizhzhia and pushed narratives blaming Kyiv"
    },
    {
      "id": "3b680279-da88-4981-ac94-ffeb7428e442",
      "text": "Public opinion polls in early February 2024 showed Zaluzhnyi with very high trust ratings in Ukraine."
    },
    {
      "id": "a5948f0b-108c-4450-9313-80c4b9d2bf63",
      "text": "President Zelensky dismissed Valerii Zaluzhnyi as Commander‑in‑Chief of the Armed Forces of Ukraine."
    },
    {
      "id": "2e53e34e-8b05-4afd-b21e-a0cdf3cdd9f6",
      "text": "OSCE announced deployment/observer activity at Russian checkpoints on the Russia–Ukraine border (Gukovo and Donetsk) and documented cross‑border security incidents in July 2014."
    },
    {
      "id": "1efdbb35-4dfb-439c-868f-834c7b846857",
      "text": "Russian authorities reported mortar and artillery rounds fired from Ukrainian-held territory landing in Russia's Rostov region (claim that shells hit Russian towns, July 2014)."
    },
    {
      "id": "d9f48841-a61f-46f7-9539-6a5c05b24109",
      "text": "Media coverage in April 2014 and thereafter reported repeated airspace violations and frequent scrambling of jets around the Russia–Ukraine border (Pentagon/BBC/other outlets described routine airspace breaches during the 2014 crisis)."
    },
    {
      "id": "de49b199-c805-4af8-86b0-6d89346ccf9f",
      "text": "WENRA (Western European Nuclear Regulators Association) published a position (11 March 2022) documenting the loss of external power supplies to facilities in the Chornobyl exclusion zone and assessed risks"
    },
    {
      "id": "ec647ebf-9926-4360-bc7b-b5ce0e925bce",
      "text": "Ukraine's national operator and officials said restoring the damaged transmission lines to the exclusion zone was not immediately possible"
    },
    {
      "id": "533a7bd6-e829-42a4-9db0-d65325e0a19b",
      "text": "Russian forces seized control of the Chornobyl site and exclusion zone early in the invasion (reported 24 February 2022)"
    },
    {
      "id": "e158fda9-8d0a-47f7-b059-e84c1c800e8e",
      "text": "Belarus opposition candidate Sviatlana Tsikhanouskaya fled to Lithuania amid the crackdown on protesters."
    },
    {
      "id": "ab431245-f9f2-4fc8-9151-1a933d1cc17a",
      "text": "Public demonstrations of support for Belarusian protesters in neighbouring countries (large rallies and solidarity events in Poland and elsewhere around Aug 13)."
    },
    {
      "id": "13d983ca-227d-4fce-a25c-5601ce01e1b8",
      "text": "Formation of the Lublin Triangle (Poland–Lithuania–Ukraine trilateral platform announced)."
    },
    {
      "id": "59ba3908-5409-4ccc-a9c8-03413841cd4f",
      "text": "Mass influx of Ukrainian refugees into Poland after Russia's full-scale invasion (activation of EU Temporary Protection, March 2022 onwards)."
    },
    {
      "id": "b2bdcd0b-beea-4a69-a3e2-7a51305b0555",
      "text": "Gazeta Wyborcza article reports rapid rise of Ukrainian residents in Wrocław ('Almost every third resident of Wroclaw is Ukrainian')."
    },
    {
      "id": "69cc96b7-da30-47d5-8424-4e395d087944",
      "text": "Polish media outlets and public services launched Ukrainian-language sections and information hubs (example: Polish newsrooms adding Ukrainian-language content, Ukrainian support centres established)."
    },
    {
      "id": "ed0ec28b-9f14-4602-b693-8e65024224e6",
      "text": "Explosions and missile strikes hit nearby cities (notably Mykolaiv and Odesa) on 12–13 May 2022; local officials said some strikes on Mykolaiv/Odesa were linked to launches from the Kherson area."
    },
    {
      "id": "7b589fb6-b848-4438-b798-8bbc2aa8a6cb",
      "text": "Prominent international coverage of far‑right Ukrainian units (notably the Azov regiment) and their integration into national forces during spring 2022."
    },
    {
      "id": "d0d92bc5-9c68-46c6-9788-5f5e4bd08bdd",
      "text": "Earlier Russian Defence Ministry / RIA-style reports accused Ukrainian forces of striking civilian sites in the Kherson region (e.g., schools, cemeteries) at the start of May 2022."
    },
    {
      "id": "bde37614-97d3-4d15-b062-c738dd33f745",
      "text": "CDC recommends cloth face coverings for the public (source control)"
    },
    {
      "id": "fe2cb97c-fe95-4131-9801-37c0348a8a00",
      "text": "WHO issues 'COVID-19: considerations for tuberculosis (TB) care' information note"
    },
    {
      "id": "1a5b6ba3-e0fc-4c63-8ff0-c46957cbc8b6",
      "text": "July 2021 Provincetown, MA outbreak where many cases occurred among vaccinated people (CDC MMWR published August 2021)"
    },
    {
      "id": "c48a7be2-6dcc-42a1-8ce9-14c71ebcbfbf",
      "text": "Large cluster-randomized Bangladesh mask promotion trial (Abaluck et al./Science) published August 2021 with nuanced results"
    },
    {
      "id": "ce8beb5a-1438-4adc-a947-a64fd2fb1c03",
      "text": "CDC reversed earlier guidance and in July 2021 again recommended indoor masks for vaccinated people because of the Delta variant"
    },
    {
      "id": "240a0d40-b046-4558-ba3a-102a30c4af61",
      "text": "DANMASK-19 randomized trial (Denmark) published November 2020 found limited measurable protection to the wearer"
    },
    {
      "id": "70c05f1a-ed99-4420-a739-2e3fb45d6e38",
      "text": "Earlier (2015) online reports claimed an 'Assembly of the Romanians of Bukovina' had been formed and had previously voiced grievances about status/rights in northern Bukovina."
    },
    {
      "id": "dad945d1-7f00-4509-8a65-103e7f8afbe2",
      "text": "Following the awards, Gazprom refused/reserved deliveries and reduced transit pressure to Ukraine in early March 2018"
    },
    {
      "id": "7da6de1a-35b8-4a75-a954-1c24437d58d6",
      "text": "Naftogaz published the full Stockholm award texts and initiated enforcement actions in multiple jurisdictions (e.g., Swiss/UK enforcement steps were announced)"
    },
    {
      "id": "5f808033-32ef-47a2-8cf8-fe0d1db9977a",
      "text": "The awards were legally complex and split across separate supply and transit rulings with offsetting liabilities rather than a single, simple judgment"
    },
    {
      "id": "dc1d910d-a266-4155-a4df-137451cf698c",
      "text": "U.S. National Toxicology Program (NTP) publishes high‑profile rodent RFR studies (final reports/public summaries circulated in 2018)"
    },
    {
      "id": "2bfb27e5-8f73-4a0f-9c57-06def4d4564c",
      "text": "International EMF Scientist Appeal (roughly 250 scientists sign public appeal calling for stricter RF limits, 2015)"
    },
    {
      "id": "00e97291-053f-40c0-8f73-0927fe29385d",
      "text": "IARC (WHO) classifies radiofrequency electromagnetic fields as 'possibly carcinogenic to humans' (Group 2B)"
    },
    {
      "id": "a821d7c6-d6e1-48de-9505-56526b0c68ce",
      "text": "Major measles outbreak in Samoa (late 2019) that caused thousands of cases and dozens of deaths and led to a national state of emergency."
    },
    {
      "id": "349a4808-5100-43dc-bb93-0a3696bc93c0",
      "text": "Two infants in Samoa died after receiving MMR vaccine due to incorrect diluent administration, sparking local fear of vaccines."
    },
    {
      "id": "57bf6299-78f3-4468-8703-37069d49fbea",
      "text": "Nordic countries (Sweden, Denmark, Finland) restricted or paused use of Moderna’s mRNA vaccine for younger people over myocarditis concerns"
    },
    {
      "id": "eed4e8b4-0522-483b-8749-518e3904ed41",
      "text": "Japan identifies stainless-steel/foreign particles in multiple Moderna vaccine vials, leading to suspension/recall of specific lots"
    },
    {
      "id": "2f0d2e62-8a4b-4aad-988c-697711c78a85",
      "text": "Verkhovna Rada adopts the Law 'On Ensuring the Functioning of Ukrainian as the State Language'."
    },
    {
      "id": "4f631004-9ca8-46a8-abc0-375b2a381ce5",
      "text": "The 2019 language law entered into force (implementation date announced/commenced)."
    },
    {
      "id": "ac1702a8-31f0-43f1-8a23-564f62f7bea5",
      "text": "Passage of the 2017 Education Law that restricted minority‑language instruction (including limits affecting Russian‑language schooling)."
    },
    {
      "id": "897cfbf4-b0f6-4c58-9b83-b6b3531ac3cf",
      "text": "OSCE monitor wounded after coming under fire leading the OSCE to review operations in the conflict zone"
    },
    {
      "id": "d8aa675d-70d7-41d6-8136-614334dea547",
      "text": "OSCE spot report documenting heavy shelling and multiple shell craters near Donetsk (including school shelling)"
    },
    {
      "id": "9f4f2079-e0e1-4455-a99e-e13c6b676c41",
      "text": "OSCE SMM vehicles struck by artillery/mortar fragments near Kirovske while on patrol"
    },
    {
      "id": "feb7be62-542f-4fda-98d2-d62b041b7e4e",
      "text": "FDA issued an Emergency Use Authorization (EUA) for chloroquine/hydroxychloroquine to treat COVID‑19 (announced in late March 2020)"
    },
    {
      "id": "47e1651b-b1de-4e01-bcad-20e5d94c4d6e",
      "text": "Wang et al. in vitro study showing remdesivir and chloroquine inhibit SARS-CoV-2 in cultured cells published (Cell Research)"
    },
    {
      "id": "b5802323-7512-44b7-a2c3-95a5d43334ad",
      "text": "National Academies report 'Reflecting Sunlight' recommends a research program on solar geoengineering (including stratospheric aerosol injection)"
    },
    {
      "id": "0cad8084-1fb8-40fb-891c-30a8b4e846e3",
      "text": "Operation Popeye (U.S. cloud-seeding program in Vietnam, 1967–1972) documented in declassified reporting"
    },
    {
      "id": "8042590e-9b0e-458b-8097-3fb2fc4e378e",
      "text": "HAARP facility transferred from US Air Force to University of Alaska (facility described publicly as a powerful ionospheric heater)"
    },
    {
      "id": "0c64d8cd-4d2e-4cd3-827f-152ecf89cd6a",
      "text": "1996 USAF paper ‘Weather as a Force Multiplier: Owning the Weather in 2025’ published"
    },
    {
      "id": "250dfb59-beb0-473d-bcfa-07bba81b251a",
      "text": "Harvard SCoPEx geoengineering balloon test in Sweden paused after public controversy and advisory review (SCoPEx advisory committee recommendation)"
    },
    {
      "id": "f808aef8-b4f3-4d04-9092-ead8a7ea4b52",
      "text": "Arkansas legislature passed HB1578 (2015), a law that required abortion providers to inform patients about the possibility of reversing a medication abortion."
    },
    {
      "id": "27f39ead-207c-4f99-9b63-e2741885a881",
      "text": "Media reporting in December 2019 (e.g., NPR) that a randomized clinical trial testing progesterone to antagonize mifepristone was stopped early because several participants experienced severe bleeding."
    },
    {
      "id": "ea5487cb-bfc0-42cc-939b-3e2c476660f8",
      "text": "Publication of 'Medicinal smoke reduces airborne bacteria' (Journal of Ethnopharmacology, 2007)."
    },
    {
      "id": "35c63cbc-56e1-4b7c-addf-1efbf72b74dd",
      "text": "Early COVID-19 pandemic surge in March 2020 driving widespread sharing of home remedies and 'air-cleansing' tips on social media and messaging apps."
    },
    {
      "id": "6d655859-153d-4ca8-9eb1-061406ef278e",
      "text": "IMF Article IV / Staff report highlighted Moldova's fiscal pressures and recommended pension-system sustainability measures."
    },
    {
      "id": "ccf58259-edef-418e-bf13-39bfcdab2d92",
      "text": "2023 budget law amendments that changed tax regulations (Law No. 212 / Gazette publication August 2023)."
    },
    {
      "id": "1c54c370-6580-412e-aead-a07fdebd2ba0",
      "text": "Government conscription/draft calls in 2024–2025 (e.g., plans to conscript ~1,200 in Nov 2024–Jan 2025 and further calls in spring 2025)."
    },
    {
      "id": "7f28a7bc-70ce-4f0a-87b6-75423e554efa",
      "text": "Legally scheduled gradual equalization and increases in retirement age for women (increment applied July 1, 2024)."
    },
    {
      "id": "1d967dcf-2dc6-4846-9278-42ad23f9103e",
      "text": "Public warnings by President Maia Sandu about anticipated Russian interference and disinformation in the 2025 election campaign."
    },
    {
      "id": "6fb200b9-76cb-4e7a-9da7-c612ff8f45de",
      "text": "Liguria Regional Council adopted a non‑binding motion urging the Italian government to review EU sanctions on Russia and to acknowledge Crimea's 'right to self‑determination' (widely misreported as formal recognition)."
    },
    {
      "id": "4cfd60ef-933f-4a85-9639-8e8f76160982",
      "text": "Lega Nord regional councillor (Giancarlo Piana/Piana) travelled to Crimea and publicly advocated closer ties and opposing sanctions; local press covered the visit and statements in late June 2016."
    },
    {
      "id": "480fdcfe-9df0-49d9-827d-49a35cd43537",
      "text": "Sharp rise in short-term employment registrations in 2018, dominated by Ukrainian nationals (Police and Border Guard Board data showing short-term employment registrations rose to 19,858 in 2018)."
    },
    {
      "id": "d665ad60-4c24-4eb5-8ff4-f9aca6191179",
      "text": "Statistics Estonia reported a small population increase and noted changing composition with rising numbers of foreign nationals/immigrants in the 2018 data release (Statistics Estonia news releases on population, January 2019)."
    },
    {
      "id": "d211d8ee-2556-497d-be81-2865b576a377",
      "text": "Rise of the far-right EKRE party in the 2019 parliamentary elections and April 2019 coalition talks (EKRE entered coalition discussions on April 6, 2019), accompanied by strong anti-immigration rhetoric in campaign coverage."
    },
    {
      "id": "922400ce-ba75-4f8f-a222-f8cb9e8ff341",
      "text": "Rail Baltica cross‑border integration steps and EU documentation advancing Poland‑Lithuania rail connection (project materials published, technical/operational coordination at border sections)."
    },
    {
      "id": "26df25ea-ebb8-4523-b4f6-0e534c9ae98a",
      "text": "Original intergovernmental agreement establishing the Lithuanian‑Polish‑Ukrainian Brigade (LITPOLUKRBRIG) signed in Warsaw (formal creation and headquarters placement in Poland)."
    },
    {
      "id": "9f2c235c-00dc-467c-bda5-b638f7d5931f",
      "text": "Increased NATO/Polish military activity and formal commitments on the eastern flank in 2020 (Poland and Lithuania assigned brigades to NATO multinational structures; documented interoperability activities)."
    },
    {
      "id": "618c034b-41a8-4f29-a823-8e13421cc4fb",
      "text": "Kyiv shut metro services and further restricted public transportation in mid‑March 2020 (national/local announcements)"
    },
    {
      "id": "98f18c47-1019-4558-afd0-14a46c1a1b53",
      "text": "Background existence of Kyiv ‘Municipal Guard’ (created 2015) with some members drawn from volunteer/veteran communities"
    },
    {
      "id": "b249d910-8a47-4262-8dc7-297740f4a7a7",
      "text": "Authorities announced joint patrols involving the National Police, National Guard and Military Police beginning around March 22, 2020"
    },
    {
      "id": "5f1040ab-f1b0-405c-9765-93d1480dcc96",
      "text": "January 2021 reports from Norway that some very frail, elderly patients died after receiving the Pfizer/BioNTech vaccine and subsequent official reviews."
    },
    {
      "id": "e4684dd9-7a98-4f31-a99d-dd05c67773bd",
      "text": "Russian leadership framed the 2022 invasion as a 'denazification' mission."
    },
    {
      "id": "10105712-0635-4e4a-8fcc-db4546350110",
      "text": "International reporting and analysis on the Azov regiment's far‑right imagery and controversies."
    },
    {
      "id": "9cf44ede-37dd-4147-8e93-89a5b38604fa",
      "text": "Reports and temporary suspension in Japan of some Moderna vaccine batches after detection of foreign particles (August 2021)"
    },
    {
      "id": "9f5ea13d-dbcb-4125-8e01-5e0baaf11160",
      "text": "CDC reports and ACIP review of myocarditis signals after mRNA vaccination (June 2021 MMWR/ACIP update)"
    },
    {
      "id": "86e752df-f478-4714-b1d7-0b9fd5e2c12a",
      "text": "EMA determination of a possible link between AstraZeneca vaccine and very rare blood clots with low platelets (VITT), April 2021"
    },
    {
      "id": "1ff3eb76-86fd-4185-9efe-c263bc93099f",
      "text": "Poroshenko strips high-profile individuals of Ukrainian citizenship (e.g., Mikheil Saakashvili)"
    },
    {
      "id": "21bd8c67-264e-42eb-8b0e-db6c24c5c21c",
      "text": "CDC interim guidance for election polling locations and voters recommending masks and other measures"
    },
    {
      "id": "0cb2ce22-eec1-4086-8d9d-aeffcdc506d7",
      "text": "Nature Medicine study showing face masks reduce respiratory virus shedding (Leung et al.)"
    },
    {
      "id": "f19197e0-4097-457f-8a6f-30ca2c690b11",
      "text": "Wisconsin in-person primary conducted during pandemic with long lines and media coverage"
    },
    {
      "id": "9ebbd19c-1b2c-41b2-9e3b-01e96f03ba4f",
      "text": "CDC recommends cloth face coverings for the public"
    },
    {
      "id": "42add791-b448-41e4-b232-feb4502ab26c",
      "text": "FDA’s tissue‑agnostic accelerated approval of pembrolizumab for MSI‑H/dMMR tumors"
    },
    {
      "id": "da01f00d-df9a-44d9-bb12-f41c09aed89b",
      "text": "2018 Nobel Prize in Physiology or Medicine awarded to James Allison and Tasuku Honjo for cancer immunotherapy"
    },
    {
      "id": "5a816559-a964-4ecf-a8d4-147202021cee",
      "text": "First US approval of a CAR‑T cell therapy (Kymriah, tisagenlecleucel)"
    },
    {
      "id": "51c0d92f-0651-465b-99bf-de8081c26d82",
      "text": "AstraZeneca paused its COVID-19 vaccine trial after a volunteer developed an unexplained serious illness."
    },
    {
      "id": "8cada1de-aec0-4ba8-97e5-04e36d363054",
      "text": "Large, high-profile seroprevalence releases (e.g., New York State antibody study) showing many people with antibodies"
    },
    {
      "id": "9bcf8d43-87e4-411f-8731-00fa3640de8d",
      "text": "Media reports and investigations documenting a flood of unvalidated/poor-quality COVID-19 antibody tests on the U.S. market after relaxed FDA oversight"
    },
    {
      "id": "4e359298-f7bc-44e1-a224-0d0d64bb4b78",
      "text": "CDC serology guidance updated to note possible cross-reactivity of antibody tests with other coronaviruses"
    },
    {
      "id": "75f2c098-7112-4a25-8031-e3a6116f5af5",
      "text": "IARC (WHO) classified aspartame as 'possibly carcinogenic to humans' (Group 2B), prompting widespread media coverage."
    },
    {
      "id": "a55c1b2e-bab8-49b4-ac95-ac161af5ec93",
      "text": "WHO published a guideline (Use of non-sugar sweeteners) recommending that non-sugar sweeteners should not be used for weight control or reducing noncommunicable disease risk."
    },
    {
      "id": "4e0bbe89-492f-4dfa-be07-cd56528fc90b",
      "text": "U.S. Federal Trade Commission (FTC) sent warning letters (Nov 2023) to two trade associations and a dozen influencers about inadequate disclosures for paid posts promoting aspartame/sugar products."
    },
    {
      "id": "4566b36e-d3ea-4ec7-9e9b-7343a650fdce",
      "text": "WHO updated interim guidance on mask use (June 5, 2020)"
    },
    {
      "id": "0d8ba46f-3371-4146-b302-4566ce200350",
      "text": "Systematic review and meta-analysis (Bartoszko et al.) on medical masks vs N95 respirators (Influenza and Other Respiratory Viruses, 2020)"
    },
    {
      "id": "191a7f33-31c9-4830-b540-0254a53cf820",
      "text": "IARC (WHO) press release classifying processed meat as 'carcinogenic to humans' (Group 1)"
    },
    {
      "id": "c81fe284-1d56-4884-b3a3-e8ed8c832f00",
      "text": "Recent legal and public debate weakening restrictions on AI‑generated political deepfakes (U.S. court decision striking down a California restriction, reported Aug 7, 2025)."
    },
    {
      "id": "f645f5ef-5ac1-44fb-9a14-8f8569b07972",
      "text": "U.S. begins or expands training of Ukrainian military and security forces"
    },
    {
      "id": "316f2580-65a7-4aae-97c7-ab89b390be62",
      "text": "Documented U.S.-funded democracy support by the National Endowment for Democracy (NED) in Ukraine"
    },
    {
      "id": "65085434-99ed-4d57-85cd-82de6d7b4516",
      "text": "U.S. and EU impose sanctions on Russian and Ukrainian actors after Crimea annexation"
    },
    {
      "id": "e9510a84-35a9-4de4-9ad9-e222d2348cab",
      "text": "2018 market reports showing a sharp rise in turmeric/curcumin supplement sales and mainstreaming of 'golden milk' wellness trends"
    },
    {
      "id": "6dd190ff-6495-464b-9ba5-23b2d0f6fd1b",
      "text": "2004 Phase I clinical trial of oral curcumin in advanced colorectal cancer patients (Clinical Cancer Research)"
    },
    {
      "id": "6e529b19-2c91-444a-bb36-d523d8781149",
      "text": "Ukraine signed a contract to purchase about 1.8–1.9 million doses of China’s Sinovac vaccine (announcement reported Dec 30, 2020)."
    },
    {
      "id": "75cbabf8-745f-4fc9-bd9b-38f0fc91ea4b",
      "text": "Pfizer publicly reported supply-chain challenges and acknowledged it had cut its near-term production target (news reported Dec 3, 2020)."
    },
    {
      "id": "a2e3ed81-ed7c-4eac-b0c7-03c8d993a25e",
      "text": "COVAX (WHO/Gavi/CEPI/UNICEF) announced additional advance purchase deals and said the global rollout was planned to begin in Q1 2021 (press release Dec 18, 2020)."
    },
    {
      "id": "87c2241d-5cb0-4f5c-923e-09dfac33f675",
      "text": "Reporting of procurement dysfunction and delays within Ukraine’s vaccine procurement machinery in late 2020 (media coverage of missed contracts, agency disputes and slow negotiations)."
    },
    {
      "id": "c45886e7-dc61-4725-8d00-6f8b9809f869",
      "text": "NOAA / Arctic Report Card 2023 coverage documenting seasonal and regional variability in sea ice (and that 2023 minimum ranked among the low end but not a new record)."
    },
    {
      "id": "69044bfe-47b2-4ba7-a16d-a09a754a0188",
      "text": "Publication of peer-reviewed study 'Comparing the carbon footprints of urban and conventional agriculture' in Nature Cities"
    },
    {
      "id": "b6b5be45-4cbf-4a44-a03e-37809ce8f12e",
      "text": "Publication of Standard Eurobarometer 101 (Spring 2024) with headline EU-level percentages on attitudes to the war, security and EU unity"
    },
    {
      "id": "cb892764-de04-416d-bdc1-9ef20b1cff7d",
      "text": "Pew Research Center release 'Views of Russia and Putin' (July 2, 2024) with country‑by‑country favorable/unfavorable figures"
    },
    {
      "id": "7392faa0-a150-4dba-b56e-4c4d39dc7010",
      "text": "Large pro‑Russia demonstrations in Belgrade and other European cities (e.g., Belgrade pro‑Russia march reported by Reuters and BBC in April 2022)"
    },
    {
      "id": "3f4eefe0-a285-45ea-8839-1c7e19cc039f",
      "text": "South Africa pauses/limits rollout of the Oxford–AstraZeneca COVID‑19 vaccine after trial data showed minimal protection against mild–moderate disease vs the 501Y.V2 variant"
    },
    {
      "id": "121be1b2-8931-49a8-bd34-ebed27987497",
      "text": "UK NERVTAG / Public Health briefings (Jan 2021) indicating the B.1.1.7 (UK) variant may be associated with increased severity/mortality"
    },
    {
      "id": "24544b2e-6718-43dc-829c-de46e2861ae6",
      "text": "Ukraine's 2004 'Orange Revolution' — Supreme Court annulled disputed runoff and ordered a re-run"
    },
    {
      "id": "b10a4c06-189b-4684-b12d-ef17a210f307",
      "text": "May 2014 early presidential election held amid armed conflict — polling could not be held in parts of Donbas and Crimea"
    },
    {
      "id": "8df7b50c-2cba-47fb-9c3e-c89f142bf026",
      "text": "Crimea 'referendum' (16 March 2014) and UN General Assembly non-recognition (Resolution 68/262)"
    },
    {
      "id": "cb9c24bb-09fe-44c3-a42c-c14e13eb9174",
      "text": "Russian/state narratives calling the post‑Euromaidan Ukrainian authorities a 'coup' and 'illegitimate' (2014 onward)"
    },
    {
      "id": "2cb8d986-13a4-4fa7-abe9-aa38098c38e4",
      "text": "Parliament and state moves in late 2014 to recognize OUN/UPA fighters with veteran/combatant status"
    },
    {
      "id": "c2acff46-466e-4233-bfca-55b8dc61128e",
      "text": "International and regional criticism of Ukraine's decommunization bills as potentially glorifying WWII-era nationalists"
    },
    {
      "id": "15b5725f-bc53-476b-8f02-9e2be6e1a862",
      "text": "Poroshenko issues decree establishing May 8 as a Day of Remembrance and Reconciliation (shifting commemoration context)"
    },
    {
      "id": "53352fb2-8c41-4ae8-ae51-998a77fbdfe7",
      "text": "Verkhovna Rada passes 'decommunization' package of laws equating Soviet and Nazi regimes and banning Soviet symbols"
    },
    {
      "id": "10a3df8f-584c-4799-8f82-c3f4d6d0b7d7",
      "text": "Widespread use and international coverage of the red-and-black UPA/Bandera flag during Euromaidan and subsequent protests"
    },
    {
      "id": "4d2183f0-82c6-4df9-8187-fa672a4fb201",
      "text": "Alaska Supreme Court struck down a 2014 law/regulation attempting to define which abortions were 'medically necessary' for Medicaid funding (ruling reported Feb 15–16, 2019)."
    },
    {
      "id": "8f9b6c6f-e4b8-4d86-a137-ec8c58e2c655",
      "text": "Alabama signed the near‑total Human Life Protection Act (near‑total abortion ban) on May 15, 2019."
    },
    {
      "id": "7476149c-2f26-41e2-b83b-793fe442956c",
      "text": "Amnesty International reports on apparent extrajudicial executions by Russian forces"
    },
    {
      "id": "5529ee13-0c0a-40d8-a3c2-aaa819adc808",
      "text": "Discovery of bound and shot civilian bodies in Bucha"
    },
    {
      "id": "bf9df6e7-1986-4c04-bd62-320f195b6453",
      "text": "Sharp surge in temporary employment declarations for Ukrainians in Poland (about 400,000 declarations in H1 2015)"
    },
    {
      "id": "d099c61e-1609-48c0-8e30-c260de609e9e",
      "text": "International media human‑interest coverage (e.g., BBC) highlighting Ukrainians taking low‑paid/manual jobs in Poland"
    },
    {
      "id": "9ebe3258-70a3-47d1-b749-005bc04bdb2c",
      "text": "Media reports of increased civilian familiarisation and voluntary training courses in Poland amid the war in Ukraine (surge in civilians getting military‑style training)."
    },
    {
      "id": "3cfb3615-e7f1-4836-894f-7ed0d170c634",
      "text": "Polish Ministry of Defence draft/plans reported to call up or train up to 200,000 reservists and Territorial Defence volunteers in 2023."
    },
    {
      "id": "7341ff10-94e4-4f2c-99ca-69e035432945",
      "text": "Large NATO/U.S.-led military exercises in Poland in 2022 (e.g., DEFENDER-Europe 2022 and SWIFT RESPONSE 2022 in May 2022)."
    },
    {
      "id": "4173bed8-d09d-4a99-baf2-6806725ecf32",
      "text": "Reports and sector assessments (Ministry/PPV/experts) documenting urgent appeals and emergency measures for the cultural and creative industries because of COVID‑19 impact (spring 2020)."
    },
    {
      "id": "eb0ebcb7-de5a-46d1-aa61-3144f6040af2",
      "text": "Previous and well‑documented state support for patriotic films (example: state/State Film Agency funding for films such as 'Cyborgs' in 2017)."
    },
    {
      "id": "fa9cfb6f-bb9e-4ca8-86b4-3aa13f3288f8",
      "text": "Verkhovna Rada adopts amendments to the 2020 state budget to create an anti‑coronavirus fund and reallocate spending (April 2020)."
    },
    {
      "id": "baa30782-ad77-4b2e-9e57-4310d3a8ab29",
      "text": "U.S. embassy cultural and education grant programs in Poland (U.S. Embassy cultural exchanges and museum/project funding)."
    },
    {
      "id": "93eeec64-dd20-4d3c-85ae-53b9f9492d59",
      "text": "Public concern and criticism by international institutions and U.S.‑linked organisations (including the U.S. Holocaust Memorial Museum) over Poland's 2018 memory law."
    },
    {
      "id": "c41b050b-1bc4-4d61-8530-280de69289ef",
      "text": "Polish education reform (2016–2017) introducing a stronger 'patriotic education' and changes to history curricula."
    },
    {
      "id": "fc1016ac-2073-4906-8e3c-1ada64d0efed",
      "text": "High‑profile U.S. governmental rhetoric in Poland on WWII memory: Vice President Mike Pence's speech at the 80th anniversary WWII commemoration in Warsaw."
    },
    {
      "id": "69ebe80c-dbb8-47c1-b3ac-0ff61794fcff",
      "text": "Russian courts declared the Mejlis of the Crimean Tatar people an 'extremist organization' and effectively banned it (decision upheld by the Russian Supreme Court)."
    },
    {
      "id": "83715690-0689-407f-9183-ed0c09ae668b",
      "text": "Prominent Crimean Tatar figures (for example Ruslan Balbek) publicly endorsed the 2014 annexation of Crimea and later served in Russian administration or political posts."
    },
    {
      "id": "71d8f507-dd09-48b2-a6ac-51f4219d35f5",
      "text": "Reports that Russian/occupation authorities organized or amplified a purported 'congress' or staged meetings of Crimean Tatar delegates framed as endorsing the 'special operation'."
    },
    {
      "id": "f68bdad8-0be6-4339-bc36-f6095a91184f",
      "text": "Ukrainian Ministry of Justice public discussion / press reporting on proposals to allow people with criminal records (non‑incarcerated) to be mobilised or volunteer for service"
    },
    {
      "id": "e07db0a8-30ba-47c9-8e98-8e58bdb237d0",
      "text": "Justice Minister Denys Malyuska's telethon remarks suggesting mobilising people with criminal records and noting some could do non‑combat tasks ('shovels' mentioned in context)"
    },
    {
      "id": "997279b1-98ed-426a-8f71-1dfe00c0cfc3",
      "text": "Precedent of Russian/Wagner recruitment of prisoners (widely reported in 2022–2023)"
    },
    {
      "id": "f47e498b-8eae-45e5-8bec-baa76263240f",
      "text": "U.S. confirms delivery of Javelin anti-tank missiles to Ukraine"
    },
    {
      "id": "6f851f63-6752-4173-9f20-a83b89928c7f",
      "text": "U.S. passed the milestone of 1 million reported COVID-19 deaths in mid‑May 2022."
    },
    {
      "id": "ee48e0ea-0842-4c9e-b212-24a573dfe883",
      "text": "CDC changed its COVID-19 data presentation and surveillance focus after the U.S. public health emergency ended (2023), shifting emphasis to severe outcomes and revising some reporting dashboards."
    },
    {
      "id": "088e6079-22cf-4c60-8f79-e7bf4be92bc8",
      "text": "Publication of a randomized, double‑blind, placebo‑controlled Phase II trial reporting AHCC cleared persistent high‑risk HPV in a majority of treated patients"
    },
    {
      "id": "0f74ee7b-f75b-4e23-8554-9d4fd3997e45",
      "text": "Russian Defence Ministry spokesman Igor Konashenkov publicly announced that Russian forces had \"liquidated\" groups of foreign mercenaries including members of the 'Georgian Legion' near Lysychansk."
    },
    {
      "id": "dc4d58b6-b6a5-4e33-8113-1104de0660cf",
      "text": "French President Emmanuel Macron says 'we must not humiliate Russia' (calls for dialogue)"
    },
    {
      "id": "1626dc53-6141-43e8-b9d3-3cf657bec12b",
      "text": "United Nations / humanitarian agencies warn of catastrophic humanitarian needs in Ukraine"
    },
    {
      "id": "b5d18da2-37ec-43db-9cf5-11a16315155a",
      "text": "Russian seizure and military control of the Zaporizhzhia nuclear power plant"
    },
    {
      "id": "fc7fa7f8-d6aa-46a0-814f-d7777e07ee50",
      "text": "NATO Madrid Summit (new strategic concept and high‑level discussions)"
    },
    {
      "id": "c446fa31-103d-4be7-a20a-9fdf249fee0c",
      "text": "Fall of Sievierodonetsk / Russian capture of a key Donbas city"
    },
    {
      "id": "50229a45-d8db-4d1a-b9aa-633cced12c5a",
      "text": "European Commission emergency aid package for farmers affected by the Russian embargo (initial €125 million announced)"
    },
    {
      "id": "b5b1f2ce-8e67-4fdd-9274-0fda8fb105d3",
      "text": "Finnish industry and producers (e.g., dairy sector) publicly warned of impacts and potential job talks after the Russian ban"
    },
    {
      "id": "91a10dc8-8b8a-42ef-b656-40c78c73476b",
      "text": "Sharp month‑on‑month fall in Finnish food exports to Russia after the ban (reported as exports plummeting over 60% in one month)"
    },
    {
      "id": "2f44b72b-9ed9-4836-a422-74659e144491",
      "text": "Turkey shot down a Russian Su‑24 warplane on the Syria border, sharply escalating tensions between Moscow and Ankara."
    },
    {
      "id": "3ca2f12a-dda8-4f5e-aeb4-350f5128b99e",
      "text": "Russian Defence Ministry publicly accused President Erdoğan and his family of profiting from illegal oil shipments from Islamic State (IS/ISIL) in Syria and Iraq."
    },
    {
      "id": "742b16e2-457f-4473-89e7-7d79fc6a6162",
      "text": "WHO issued information notices clarifying interpretation of PCR cycle thresholds (advising careful interpretation of weak positives and use of clinical context)"
    },
    {
      "id": "0f058be5-6f03-44df-9cc2-ebdfb8ab7143",
      "text": "Peer‑reviewed study showing PCR cycle threshold (Ct) correlates with ability to culture live virus (low Ct more likely infectious)"
    },
    {
      "id": "37725301-cd6c-4f8b-ba53-7ac89bb7d93c",
      "text": "Kyiv City Council adopted a 2015 regulation and local initiatives promoting the use of Ukrainian in public life (programs 2015–2020)."
    },
    {
      "id": "619d943c-5d2a-4a21-a577-d21c72210782",
      "text": "Parliament passed and enacted quotas for Ukrainian-language songs on radio (law approved June 16, 2016; quota measures came into force in 2016–2017), increasing legal requirements for media language use."
    },
    {
      "id": "630ad209-9fb0-4b78-88c6-e02f76c0fc74",
      "text": "Adoption of the Kivalov–Kolesnichenko Law on the Principles of State Language Policy (entered into force August 10, 2012)."
    },
    {
      "id": "c9b72f24-65bb-4256-b0e4-1717a833ac47",
      "text": "Verkhovna Rada voted to repeal (23 February 2014) the 2012 language law amid the 2014 political upheaval (subsequent legal uncertainty and debates followed)."
    },
    {
      "id": "2325e83b-a7fe-400a-968f-882df203a73d",
      "text": "Establishment of presidential and advisory bodies to promote Ukrainian language and national unity (e.g., Board for National Unity created by decree, December 2015) and public campaigns encouraging Ukrainian-language use."
    },
    {
      "id": "27fc317a-76e6-4e92-8463-532e1c1889fd",
      "text": "Poland refused entry to the Night Wolves in late April 2015, blocking their planned land route to Germany."
    },
    {
      "id": "5ab691c3-fa6b-46e5-b127-a5ce5a000062",
      "text": "Night Wolves' active, visible role in Crimea (2014) and frequent state-linked publicity established them as a high-profile, Kremlin‑linked biker group prior to 2015."
    },
    {
      "id": "1ec3575f-6c04-469f-92c5-ba4d89f117de",
      "text": "Prime Minister Mark Rutte publicly said the Netherlands was unlikely to ratify the Agreement and sought 'legally binding' assurances from EU partners"
    },
    {
      "id": "d13dadf0-4167-4441-a621-b37a7b72e753",
      "text": "Dutch advisory referendum on the EU–Ukraine Association Agreement produced a 61% 'No' vote"
    },
    {
      "id": "99f1753a-60d3-44ab-bb03-dd91fc18e35a",
      "text": "The International Monetary Fund approved a $5 billion loan arrangement for Ukraine on June 9, 2020, contingent on economic reforms and anti-corruption measures."
    },
    {
      "id": "de4ab1ba-1dad-4112-ac67-2abf280c8f37",
      "text": "The U.S. government temporarily froze nearly $400 million in security assistance to Ukraine in July 2019, around the time of the Trump–Zelensky call."
    },
    {
      "id": "2a2c3af2-a77f-4bfa-8412-7dfd2714a7fd",
      "text": "Then-Vice President Joe Biden publicly recounted in 2018 pressuring Ukraine to fire a prosecutor by threatening to withhold roughly $1 billion in loan guarantees."
    },
    {
      "id": "7a402d5d-a0ce-4678-be45-af2e707a57d2",
      "text": "A whistleblower complaint about the July 2019 call prompted a formal House impeachment inquiry into President Trump in September 2019."
    },
    {
      "id": "43fb4834-7616-44da-9a18-09041bb3b486",
      "text": "President Trump’s July 25, 2019 phone call with President Zelensky in which Trump asked Ukraine to investigate Joe Biden and his son."
    },
    {
      "id": "6b8e73d8-6258-42aa-92a4-ff23daec341b",
      "text": "Zelensky cancelled a planned US Senate briefing amid a funding impasse (December 2023)"
    },
    {
      "id": "0bb3c38e-09ef-43eb-891c-1d85703bde14",
      "text": "Domestic polls and reporting in late 2023 showed a measurable dip in Zelensky's approval/ trust indicators"
    },
    {
      "id": "55a5fa6c-a334-4d94-865f-60a02ae595f8",
      "text": "Pandora Papers (Oct 2021) revelations about offshore connections of Zelensky and associates"
    },
    {
      "id": "81456b8e-23b0-4a74-8743-2e58b6813f55",
      "text": "Reuters Institute Digital News Report 2023 documented widespread 'news fatigue' and falling news engagement"
    },
    {
      "id": "916ebf00-2e5e-46fa-b5de-8ee2ca328a22",
      "text": "Russian officials publicly accuse the West of direct involvement and hostile aims in Ukraine (e.g., Lavrov's public remarks at the UN accusing the West of 'de facto' fighting)"
    },
    {
      "id": "2ccb1cd7-4eca-4a60-9da7-b509302d44b6",
      "text": "Russia announces annexation of Donetsk, Luhansk, Kherson and Zaporizhzhia following contested 'referendums'"
    },
    {
      "id": "5fd1dbf4-f4ae-4bb8-9195-ea964920209d",
      "text": "NATO/Western officials publicly debate long‑term security packages for Ukraine, with reporting highlighting differences among allies"
    },
    {
      "id": "248a9bf7-40f3-4da9-863a-6d903eea0663",
      "text": "Foreign embassies began withdrawing some staff and dependants from Kyiv"
    },
    {
      "id": "2e75e421-b3fc-47fe-9ef6-09d2d33af214",
      "text": "UNHCR/IOM reporting of large-scale internal displacement from eastern Ukraine (Donbas) during 2014"
    },
    {
      "id": "a0fc6d93-fe8c-4e8e-a8d7-9e45d64c7ecb",
      "text": "Violent Euromaidan clashes and clearing of Independence (Maidan) Square in central Kyiv"
    },
    {
      "id": "3ac87666-f63a-4e9c-812c-b18af694a7c0",
      "text": "Cross-border refugee flows and media coverage of Ukrainians seeking refuge in neighbouring countries (2014)"
    },
    {
      "id": "9d6d3d56-0ee4-44b5-a102-774c5e33a91e",
      "text": "Publication of Israeli cohort study reporting no increased incidence of myocarditis/pericarditis in unvaccinated patients after COVID-19 infection (Tuvali et al., Journal of Clinical Medicine)"
    },
    {
      "id": "8a163198-c8d4-4b88-a7bf-cd5fc98c4160",
      "text": "University of Ljubljana press release describing Zelenska's meetings with faculty and projects (and not attributing the cancelled lecture to protests)."
    },
    {
      "id": "0e0ab341-4bda-4673-a025-971a69075eef",
      "text": "A man shouting anti‑Ukraine/pro‑Russia slogans appeared and was detained during Zelenska's visit to the National and University Library (reported by multiple outlets)."
    },
    {
      "id": "b37c3cac-8bb5-460b-b7d2-eb33414b5fc7",
      "text": "IAEA chief condemns shelling near Zaporizhzhia nuclear power plant"
    },
    {
      "id": "24b15dbd-56ea-4ece-a1b0-5aa688b711f6",
      "text": "Zelensky publicly urges partners to allow truly long-range strikes (September 2024)"
    },
    {
      "id": "b2c2ade4-37c2-48da-819b-624b5a9bfd1c",
      "text": "Putin puts Russia's nuclear forces on high alert after invasion began"
    },
    {
      "id": "788ab935-4533-44cb-bf0b-926954d8bf02",
      "text": "Series of Ukrainian strikes against Russian targets in Crimea, including attacks on Sevastopol and military infrastructure (2023)"
    },
    {
      "id": "ef45ee2f-a90b-4522-a5ef-835dc927c319",
      "text": "OSCE Special Monitoring Mission report (23 August 2014) noting heavily shelled residential areas in Donetsk and civilian reports of damage and danger"
    },
    {
      "id": "8b3d734d-3752-4511-8163-4338dd74beb2",
      "text": "Amnesty International research missions documenting summary killings and abuses in eastern Ukraine (late August–September 2014)"
    },
    {
      "id": "ba9c253c-7260-4ccb-b433-2cf15d3e9217",
      "text": "Court ban on the Mejlis of the Crimean Tatar people declared 'extremist' (April 2016)"
    },
    {
      "id": "6a9e9c87-d858-412c-b112-3e45da1dbdab",
      "text": "Rapid issuance/acceptance of Russian passports in Crimea after annexation"
    },
    {
      "id": "11f22217-1c3a-4534-bd5e-df89b12c7750",
      "text": "Intense Russian offensive and heavy shelling around Rubizhne (Battle of Rubizhne) with reports Russian forces took large parts of the town"
    },
    {
      "id": "69bfde9f-78f1-43f8-9ea2-86df6169332b",
      "text": "Local authorities issued shelter and safety warnings after the explosion, noting toxic fumes and urging people to stay indoors"
    },
    {
      "id": "fc645500-a1c3-43be-aac2-10992f86dcd3",
      "text": "Nitric-acid tanker at Zarya chemical plant damaged/exploded after shelling in Rubizhne"
    },
    {
      "id": "bdb671dd-0d75-4f91-ab6e-132ae191b45e",
      "text": "Publication of patent applications describing fusion proteins containing luciferase (public patent records, e.g., US patent applications from 2018–2020)."
    },
    {
      "id": "039940c2-8769-41b6-8e24-bc42bd2df3fe",
      "text": "Publication of research using luciferase reporter systems to study SARS-CoV-2 entry and for rapid neutralization testing (e.g., nanoluciferase SARS-CoV-2 assays published in 2020)."
    },
    {
      "id": "c81bbf61-f731-4178-8ce9-126dc09503cb",
      "text": "Verkhovna Rada passed a package of four 'decommunization' laws mandating removal/ban of communist symbols and renaming of public places"
    },
    {
      "id": "70da26a2-352f-4784-974f-a96926d40818",
      "text": "Parliamentary action to establish May 8 as a Day of Remembrance and Reconciliation alongside changes to how May 9 was observed"
    },
    {
      "id": "722ff441-3624-4290-9633-b6e564f438d0",
      "text": "Public dispute and protests around the future of the Vatutin grave/monument in Kyiv (rallies and media reports in April 2015)"
    },
    {
      "id": "6db7bc6b-d875-4968-a306-ba8cd0b84592",
      "text": "Widespread toppling/removal of Lenin and other Soviet monuments across Ukraine in 2014–2015 ('Leninfall') and reporting on mass removals"
    },
    {
      "id": "055d0702-1678-42d0-962d-d04f89cdfd1b",
      "text": "Ongoing wild poliovirus transmission in Pakistan and Afghanistan documented in GPEI 2019 annual report"
    },
    {
      "id": "12e8d861-ad53-4863-bde6-fe0e33ffe000",
      "text": "COVID-19 pandemic disrupted mass immunization campaigns, prompting WHO/UNICEF warnings about millions of children at risk (May 2020)"
    },
    {
      "id": "3444cd08-df07-4dd7-8622-dc2db9e5f4ea",
      "text": "European leaders and diplomats publicly debated conditions and timelines for easing Russia sanctions (e.g., calls to consider step-by-step easing if Minsk progress made)."
    },
    {
      "id": "75e60699-cc61-4e72-9d34-3786cbed846c",
      "text": "Multiple foreign embassies ordered non‑essential staff to leave or relocated operations from Kyiv"
    },
    {
      "id": "dbe6bc50-37e5-422e-9c48-1d03b7c6b417",
      "text": "Heavy fighting around Hostomel (Antonov) airport and other approaches to Kyiv as Russian forces advanced"
    },
    {
      "id": "87e0fdc9-8c76-40a7-ac4e-4676e5f4d10e",
      "text": "Large numbers of civilians seen fleeing Kyiv and images/videos of chaotic departures"
    },
    {
      "id": "cb08a76c-10e2-4478-aa20-448daa882f86",
      "text": "IOM / Ukrainian government data: registered internally displaced persons (IDPs) exceed one million (reported February 2015)."
    },
    {
      "id": "d7f48cfd-8d2a-41e9-ab1e-b1b3ebea5857",
      "text": "Council of Europe / pan-European analyses of 2015 refugee coverage identify uneven framing and limited humanising coverage in parts of the press during the 2015 refugee crisis."
    },
    {
      "id": "770c002c-9b9c-4946-b141-beb31de606de",
      "text": "Monitoring by Thomson Foundation / MEMO 98 (published December 2015) reports problems and inconsistencies in Ukrainian regional media coverage of IDPs."
    },
    {
      "id": "56a021c2-c9ff-43e5-996f-c6d7ec23a91b",
      "text": "Prominent alternative-health websites and how‑to blogs publishing step‑by‑step guides and testimonials for using castor oil against bone spurs, scars, cysts and tumors (2022–2023)"
    },
    {
      "id": "cb168328-3638-4a2d-ac14-48401092d43a",
      "text": "Public criticism from Jewish organizations and commentators about commemorations of Petliura (e.g., World Jewish Congress reaction and critical coverage following monument unveilings)."
    },
    {
      "id": "2849b109-7dcd-46b5-9a90-5d44ec00e9c7",
      "text": "Analysis and reporting on disputes over church affiliation, symbolism and politicization of religious spaces in Ukraine and the diaspora (e.g., 'Who Owns Tradition? Ukraine's Church Controversy' — Wilson Center)."
    },
    {
      "id": "f2507425-09cd-40be-9ca3-40f697844728",
      "text": "End-2020 decision and architectural competition announced for a Petliura monument in Poltava (projects selected in 2020–2021)."
    },
    {
      "id": "f6ef2b20-ecea-4c28-ae8e-e31bf9960385",
      "text": "Gazprom sharply reduced Nord Stream 1 flows to around 20% capacity and publicly linked the cuts to maintenance delays and sanctions-related equipment issues."
    },
    {
      "id": "a23f5f77-f0d2-4767-97ec-758c1d52ff48",
      "text": "Ukraine's Center for Countering Disinformation (NSDC/CPD) and other monitoring bodies documented and warned about Russian propaganda narratives around Ukraine's winter preparedness and energy dependence."
    },
    {
      "id": "cc33b652-dc5c-4d0f-96f9-841a4ed6c523",
      "text": "Ukraine ended the 2021/2022 heating season with record‑low gas reserves in storage."
    },
    {
      "id": "40077f46-8f07-4aaa-a346-c4a3699dafd4",
      "text": "Publication of the review 'The endocannabinoid-CB1 receptor system in pre- and postnatal life' (Fride et al.), which notes that endocannabinoids have been detected in maternal milk (mostly from animal studies)."
    },
    {
      "id": "016b4f58-0480-4b0b-a396-5e410315f527",
      "text": "November 7, 2012 — Voter approval of recreational marijuana legalization measures in Colorado and Washington (major expansion of public debate on cannabis)."
    },
    {
      "id": "62a49154-df4b-4a91-a074-6ae7072d7d08",
      "text": "Reports mentioning use of military equipment (helicopters, armoured vehicles) during the government response"
    },
    {
      "id": "31b7ba04-1249-4c6b-b648-190f940337f1",
      "text": "Mukachevo shootout between Right Sector-affiliated fighters and local police"
    },
    {
      "id": "95d37594-6ae4-4bd5-b088-9925445a3fbe",
      "text": "Media and hospital-system reporting during the Delta surge highlighting 'incidental' COVID-19 hospital admissions (Florida example)"
    },
    {
      "id": "27241f85-fa16-4ac4-a8b7-15b736e792b8",
      "text": "Local officials and media reported Russian troops looting shops and homes in occupied towns such as Trostianets (Sumy region) in early March."
    },
    {
      "id": "7754564e-329f-4dd9-8f29-c0a8ada7e40c",
      "text": "Ukrainian president Volodymyr Zelensky called on citizens to take up arms and promised weapons would be issued to those willing to defend cities."
    },
    {
      "id": "0b3347dd-ff45-4789-ae4d-123e9ce44041",
      "text": "Videos and news reports documented civilians in Kyiv and other cities preparing Molotov cocktails and receiving basic instructions on improvised weapons."
    },
    {
      "id": "20c808b1-fae8-4461-9cd2-903c3c6dd6ce",
      "text": "A passenger bus was struck near a Ukrainian Armed Forces checkpoint outside Volnovakha, killing and wounding civilians (reported immediately after the incident)."
    },
    {
      "id": "ff9ba1ec-0a5b-4a94-8022-4f958ba98e46",
      "text": "Since early 2022, President Zelensky and Ukrainian authorities publicly invited and organized foreign volunteers via the International Legion and appeals for foreign fighters."
    },
    {
      "id": "ce6b82ae-c945-45da-84eb-0cf1f30cea4d",
      "text": "Irish media and security sources reported unidentified drones in Irish airspace on the night of Zelensky's arrival in Dublin, prompting government briefings and heightened coverage of his visit."
    },
    {
      "id": "eff50442-47e8-4b6c-be30-a7d2f7ffca40",
      "text": "President Volodymyr Zelensky presented posthumous awards to the families of three Irish volunteer servicemembers during his official visit to Dublin."
    },
    {
      "id": "636d36e0-43e5-47d3-936b-6007b9f3d49b",
      "text": "UK and Irish reporting had previously documented multiple Irish nationals serving and killed or missing while fighting in Ukraine (coverage naming Rory Mason, Finbar Cafferkey, Graham Dale and reporting Alex Ryzhuk as missing/presumed dead)."
    },
    {
      "id": "42c05943-b9ac-4ead-bb6a-948856fc47af",
      "text": "Fluoride Action Network (FAN) national campaigning and reporting (2016–2017), including petitions and litigation efforts to challenge U.S. EPA regulation of fluoride."
    },
    {
      "id": "0a000d18-ecff-446c-a924-6d82d3d98023",
      "text": "CDC/NHANES analyses and reporting on increased prevalence of dental fluorosis in U.S. surveys."
    },
    {
      "id": "7d4dfb1c-7fe3-4a96-8bdf-09d038389f7a",
      "text": "CDC public description of its Technology Transfer Office and the fact that CDC researchers can patent inventions and license technologies to industry."
    },
    {
      "id": "96f5d8f6-6d67-435e-99b5-5e35770b7fed",
      "text": "Ukraine passed and the president signed constitutional amendments in February 2019 enshrining EU and NATO membership as state policy"
    },
    {
      "id": "a1bc332a-893a-4b04-bcfc-a272cfefd776",
      "text": "ECHA (European Chemicals Agency) opinion/proposal to classify titanium dioxide as a suspected carcinogen by inhalation (RAC opinion)"
    },
    {
      "id": "c47450ff-8e1c-4402-abce-e241cb06f390",
      "text": "Scientific Reports paper (Sciensano-led) found titanium dioxide particles in all examined face masks"
    },
    {
      "id": "a9e63a08-bc8c-44ad-a902-ff7af830b08c",
      "text": "EU and public‑health coverage reassuring that there was ‘no evidence’ masks pose health risks after TiO2 concerns were reported (widely reported by Reuters and others)"
    },
    {
      "id": "73cfe112-4ba5-4214-a482-67a9a39b4768",
      "text": "On 21 April 2019 (second round presidential voting) some polling stations near the contact line experienced delays or local disruptions (reports noted at-the-day irregularities in frontline areas)."
    },
    {
      "id": "5f02da39-e150-40f8-948c-4977f9916faa",
      "text": "Voting did not take place in Crimea and large parts of Donetsk and Luhansk during Ukraine's early parliamentary election (26 October 2014)."
    },
    {
      "id": "b640d8ba-898d-4f84-aeb2-2da68325a5c4",
      "text": "Russia‑backed authorities held another round of unrecognized ‘elections’ in occupied Donbas on 11 November 2018 that Western bodies condemned as illegitimate."
    },
    {
      "id": "5a481af2-58fd-4c86-873b-9b91d28d078e",
      "text": "International analyses documenting large numbers of foreign fighters/volunteers in Donbas (ICCT and other reports, mid‑2010s)"
    },
    {
      "id": "ed7c927d-f12c-4123-b39e-593052cb5b1e",
      "text": "Canadian defence delegation visit to the Donbas withdrawal line (reported delegation visit led by Deputy Minister Peter Hammerschmidt) — December 2019"
    },
    {
      "id": "2bc4fa4e-55eb-4fa9-9fb1-9fc1dd0ed0db",
      "text": "Canada launches Operation UNIFIER (Canadian Armed Forces trainers deployed to Ukraine) in 2015"
    },
    {
      "id": "2e4f5cbb-4aee-44db-b53e-1ac19783f8f4",
      "text": "Deployment of Russian private military company Wagner to Crimea/Donbas in 2014–2015"
    },
    {
      "id": "3166f662-04a5-4569-b8ef-e4a13f9635b1",
      "text": "Satellite imagery and reporting in February 2022 showed substantial Russian troop and equipment deployments in Belarus and flights out of Belarusian bases toward Ukraine."
    },
    {
      "id": "a9d7cb0f-ef46-4fd0-8eae-149d9bc36c77",
      "text": "Ukrainian Defence Ministry's Military Intelligence published a roster naming Belarusian Air Force personnel allegedly involved in strikes, triggering circulation of lists linking Belarusian officers to combat operations."
    },
    {
      "id": "f5968a16-3ae9-4016-a310-331ee57638dc",
      "text": "Conflicting official messaging in late February 2022: Belarusian leadership publicly denied plans to send Belarusian troops, even while allowing Russian forces to mobilize on Belarusian soil."
    },
    {
      "id": "79da912d-dbc1-4ae6-bd23-28e93c64cffc",
      "text": "The 2009 Su-27 crash at the Radom air show (30 August 2009) that killed two Belarusian pilots (A. Marfitski and A. Zhuraulevich)."
    },
    {
      "id": "5f8c89ed-c59f-43ea-8fbf-f1fd778aaeba",
      "text": "High‑profile resignations of senior FDA vaccine officials amid booster controversy (Marion Gruber and Phillip Krause)"
    },
    {
      "id": "44320b4b-b5f5-4371-b8cb-e0bab284904e",
      "text": "Audit published of USAID's 'Strengthening Civil Society in Ukraine' project"
    },
    {
      "id": "83a28186-9fc4-4973-89fe-3045be17f87c",
      "text": "Russian officials publicly accused the U.S. of meddling and funding protesters in Ukraine"
    },
    {
      "id": "3f13e771-2787-4f74-878d-01ec9328e304",
      "text": "U.S. Congress/administration announcements of large financial assistance to Ukraine (including a $1 billion loan guarantee)"
    },
    {
      "id": "24442cca-df16-40ec-b4c2-36fa92e8bf64",
      "text": "Public records and reporting of National Endowment for Democracy (NED) grants to Ukrainian groups during Euromaidan"
    },
    {
      "id": "d059b70c-37c2-47c2-8675-75a805809e38",
      "text": "IMF program in March 2015 tied continued financial support to debt restructuring and private‑sector involvement"
    },
    {
      "id": "ac7eb1a9-e2b2-4f4b-b565-0da0ed4aee2a",
      "text": "Reuters reports Ukraine completed a major $15 billion debt restructuring in March 2015"
    },
    {
      "id": "8e1f7e07-8213-400a-914d-0c01cae6ccea",
      "text": "DW reports Yatsenyuk warning Ukraine might suspend repayments and refusing to accept Russia’s terms (October 2015 coverage)"
    },
    {
      "id": "d6e42b72-be4b-464e-b7c4-f3d17051dbf8",
      "text": "Ukrainian prime minister publicly rebuffs Putin’s offer to restructure the $3bn Russian bond"
    },
    {
      "id": "22b8c6a4-fe2a-4fac-b173-004611eea7cd",
      "text": "Sharp decline in reported influenza activity in the U.S. during March 2020 as COVID-19 measures began"
    },
    {
      "id": "1dc02e1c-809b-457a-8693-035cb92127e6",
      "text": "Nature Medicine study (Leung et al.) showing face masks reduce respiratory virus shedding in exhaled breath"
    },
    {
      "id": "56744768-0e76-42ad-bfc8-a7813124b91a",
      "text": "CDC recommends public use of nonmedical cloth face coverings"
    },
    {
      "id": "7f920669-c960-4ee2-9c6b-57c6ddcea98f",
      "text": "High‑profile Pfizer/BioNTech vaccine efficacy announcement (press release and global media coverage) reporting ~90% effectiveness"
    },
    {
      "id": "09d344d6-907c-472b-b21a-e2d032b8b503",
      "text": "Historical origin of the MRC‑5 cell line (derived from a 14‑week male fetus in 1966) documented by cell banks (ATCC) and widely reported"
    },
    {
      "id": "dc8edab8-f7ea-4d28-8264-ac56b6c65571",
      "text": "Release of a Research Square preprint (ChAdOx1 nCoV-19) showing experiments using MRC‑5 and HEK293 cell lines (preclinical/transcriptomic analysis)"
    },
    {
      "id": "28449dff-ab57-4dc5-9bbe-718511d0beac",
      "text": "CDC recommendation on July 27, 2021 for universal indoor masking in K–12 schools regardless of vaccination status due to Delta variant concerns."
    },
    {
      "id": "9a8a3eed-fab6-443e-a46b-9adb0b65aab4",
      "text": "Publication of MacIntyre et al. (2015) cluster randomized trial finding cloth masks offered less protection than medical masks among healthcare workers."
    },
    {
      "id": "e22e01a4-aa93-4c65-bcd7-d529d935d18b",
      "text": "Torchlight marches and public rallies honouring WWII-era nationalist Stepan Bandera attended by far‑right groups and covered in the media (e.g., Lviv torchlight march)."
    },
    {
      "id": "3f92d0af-93ee-44f1-a853-b4668e51263d",
      "text": "Passage of Ukraine's 'decommunization' laws in April 2015, banning Soviet symbols and changing official commemorations and place names."
    },
    {
      "id": "8af9e40f-53d9-4962-af42-2b1b546eae95",
      "text": "Profiles in 2014 highlighting the Right Sector movement's role in the Maidan protests and its radical nationalist ideology."
    },
    {
      "id": "9eeac9e1-1f53-42bc-89f3-a3971a645d0b",
      "text": "Reports in 2014 that the Azov militia (later a National Guard unit) used symbols and insignia associated with neo‑Nazi groups and had leaders with far‑right views."
    },
    {
      "id": "da383908-9cae-4334-94f5-b4b1d0bac067",
      "text": "World Health Assembly adoption of a package of amendments to the International Health Regulations (IHR) (adopted 1 June 2024)"
    },
    {
      "id": "b3c7c16d-d44b-42a1-86e3-3bd88bc2b166",
      "text": "Earlier high‑profile vaccine contamination reports (Japan paused some Moderna batches after black/foreign particles were found)"
    },
    {
      "id": "aa56ac21-7511-471f-8f06-f604afabce09",
      "text": "Publication of Danish research letter reporting batch-dependent variation in suspected adverse events after the Pfizer (BNT162b2) vaccine"
    },
    {
      "id": "4dd03931-2066-4f6c-b70f-aff356e9b46b",
      "text": "Publication and high-profile retraction (Surgisphere) of large observational studies on hydroxychloroquine (The Lancet retraction, June 2020)"
    },
    {
      "id": "b1af2bea-91fd-482b-8051-a51dfdb38a21",
      "text": "Publication of Didier Raoult / Gautret open-label non-randomized Marseille study reporting viral-load reduction after hydroxychloroquine ± azithromycin"
    },
    {
      "id": "1634687c-de17-4492-a1e9-6bd2d7fd3d75",
      "text": "Prior international reporting (2014–2015) documented Azov's origins in far‑right volunteer networks and the use of extremist symbols by some members."
    },
    {
      "id": "9f19ec7f-44a6-4225-9fe9-d4b4160833e9",
      "text": "Dutch advisory referendum on the EU–Ukraine Association Agreement had been activated and was widely reported (petition drive and referendum scheduled for April 2016)."
    },
    {
      "id": "5acdcdd3-cfc6-4837-b656-f34ca3d48661",
      "text": "IPCC AR6 (Working Group I) released findings noting that internal variability can modulate near‑term global temperature trends, creating uncertainty in short‑term (years to a decade) temperature trajectories."
    },
    {
      "id": "fb718e29-8b18-4fcf-81ea-c75ba72067bd",
      "text": "Japan suspends use of about 1.63 million Moderna COVID‑19 vaccine doses after 'foreign materials' were found in some vials, prompting international media coverage and public concern about vaccine contamination."
    },
    {
      "id": "38c2efac-70d5-45dc-b1a6-bc298b341cb0",
      "text": "Two infants died shortly after receiving MMR vaccine in Samoa, prompting national investigation and temporary suspension of some vaccine supplies (widely reported and later traced to preparation error)."
    },
    {
      "id": "b92cc24d-296a-48a1-a7b2-fa3c54829c4e",
      "text": "Reports of a July 2020 surge in Amazon deforestation and fires, and international concern about weakened enforcement under Brazil's government (reported August 2020)"
    },
    {
      "id": "0bc5430a-3aa3-435e-9c11-e70b0e7ec6c9",
      "text": "Science Advances editorial 'Amazon Tipping Point: Last Chance for Action' by Thomas Lovejoy and Carlos Nobre (Dec 2019)"
    },
    {
      "id": "249bb7f1-30c7-450e-8e4f-789fd79f5cf5",
      "text": "Investigations and reporting documenting Cyprus as a secrecy hub for Russian and other foreign wealth (‘Cyprus Confidential’ ICIJ series, 2023) highlighted Cyprus as a destination for opaque property holdings."
    },
    {
      "id": "5f12de65-de31-4eb2-9198-02fe51497958",
      "text": "Ukraine's SBU announced it uncovered a scheme to embezzle about $40 million from weapons procurement (reported Jan 27, 2024)."
    },
    {
      "id": "76b6d07b-6776-4eab-a9db-0943a7a939d5",
      "text": "The Pandora Papers (ICIJ coverage and major press, Oct 3, 2021) revealed offshore companies tied to Zelenskyy’s inner circle."
    },
    {
      "id": "2fc74655-a5b5-4262-89fb-72ae40f44418",
      "text": "Russian Defence Minister Sergei Shoigu publicly said Russia was \"deliberately slowing\" its offensive to allow civilians to evacuate."
    },
    {
      "id": "413fd5c4-93fb-4975-926e-949600553baa",
      "text": "Negotiations and agreements (limited implementation) to open humanitarian corridors between Russia and Ukraine were publicly reported."
    },
    {
      "id": "13de59f0-aa18-4f33-a9e8-a1421ebb700a",
      "text": "Precedent: Ukrainian church leaders previously (April 2022) urged faithful to forgo night Easter vigils in areas affected by fighting and to use online prayer options."
    },
    {
      "id": "add2b4cf-c6e3-45ea-a301-649db7e48b58",
      "text": "Kyiv city administration published wartime guidance advising limited mass gatherings for Easter and urging online broadcasts (curfew remained in force)."
    },
    {
      "id": "7c8dbfe9-4904-44b4-a304-26ac404eebc5",
      "text": "Kyiv Military Administration clarified churches would be open but worshippers who entered before the midnight curfew could not leave until it ended (and urged switching to online broadcasts)."
    },
    {
      "id": "c9805034-b42f-4db1-86d3-68bfbc00296b",
      "text": "U.S.–Ukraine critical minerals/resources memorandum reported"
    },
    {
      "id": "a17def6a-a457-4e97-8d32-baf304f29c7f",
      "text": "Ukraine Recovery Conference (URC) — large Western reconstruction pledges and private‑sector investment commitments"
    },
    {
      "id": "9a2c6e26-52bf-41c9-a7ca-4c5324135706",
      "text": "Prominent think‑tank analyses raising 'partition' as a plausible risk/outcome"
    },
    {
      "id": "95e68321-4757-42ae-bd68-b039cda7ef8b",
      "text": "Russian customs effectively suspended or heavily restricted imports from Ukraine (placing Ukrainian exporters on a 'risk' list), producing a de facto trade embargo in August 2013."
    },
    {
      "id": "a58798e9-6101-4ef5-ae6e-77e43a751d70",
      "text": "Separatists and protestors had seized Ukrainian security service buildings and weapons stores in Luhansk in 2014"
    },
    {
      "id": "68cb46dc-d705-4372-9682-85134cf51860",
      "text": "Public debate in 2015 about supplying Western weapons to Ukraine (media/policy discussions)"
    },
    {
      "id": "6a3a9b49-a121-4d77-9bf9-605d700fc9fc",
      "text": "Ukrainian government announces figure of 19,546 Ukrainian children deported/forcibly transferred"
    },
    {
      "id": "e057b111-30c8-44fe-9341-21d1472eee87",
      "text": "Russian officials and state media publicly characterize transfers as 'evacuations', 'adoptions', or humanitarian relocations and dispute foreign reports"
    },
    {
      "id": "8a80fc92-c2af-4e5f-b8b1-efbcffb2cbf9",
      "text": "U.S. FDA granted Emergency Use Authorization (EUA) for the first COVID-19 vaccine (Pfizer–BioNTech)."
    },
    {
      "id": "4bf80e3a-27d8-464d-99d4-867b4ef33b10",
      "text": "CDC updated indoor masking guidance on July 27, 2021, advising fully vaccinated people to wear masks in public indoor settings in areas of substantial or high transmission due to Delta."
    },
    {
      "id": "abdb6419-f54d-4ea6-a065-163aaececd61",
      "text": "Israeli Ministry of Health and media reports (early July 2021) indicated reduced Pfizer vaccine effectiveness at preventing infection with the Delta variant (while still protecting against severe disease)."
    },
    {
      "id": "0c4c6b51-6c7e-43db-8c57-33e148f4390a",
      "text": "CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing many infections in fully vaccinated people (including high viral loads)."
    },
    {
      "id": "865f4db0-ac94-4b66-8fe3-5e5997b63fb1",
      "text": "Publication of meta‑analyses / preprints (e.g., John Ioannidis' seroprevalence‑based estimates in May 2020) reporting relatively low infection fatality rate (IFR) estimates in some settings."
    },
    {
      "id": "07a758f4-3009-4887-9f52-6cffc024f332",
      "text": "Swedish state epidemiologist Anders Tegnell publicly defended Sweden's decision not to impose a strict lockdown and said parts of Stockholm were showing signs of immunity"
    },
    {
      "id": "b572c1d4-063f-470f-b701-dbc590cfba2f",
      "text": "Global dashboards and WHO/academic mortality pages publishing country-level COVID death counts and per-capita metrics were widely circulated in summer 2020"
    },
    {
      "id": "016ecb78-c51d-4325-8a45-51c77774d814",
      "text": "Gordon Brown's public apology to former child migrants (UK government apology)"
    },
    {
      "id": "cae2e348-f492-4176-9df7-4a6c0ff875c0",
      "text": "Reuters reported Ukraine was in talks with Moscow over the return of 311 Ukrainian soldiers and border guards who had crossed into Russia, while Russian border authorities said the troops were seeking asylum."
    },
    {
      "id": "82d0ee32-e4ab-4df0-8159-0ab7318b0482",
      "text": "OSCE Special Monitoring Mission reported witnessing the passage of 437 Ukrainian servicemen through Russian checkpoints and stated it had inquired about asylum requests and found none."
    },
    {
      "id": "fd20d16c-a389-464d-83df-7f273015c324",
      "text": "EU Foreign Ministers agree to begin targeted measures (reported in UK parliamentary scrutiny documents)"
    },
    {
      "id": "d1bf9838-df80-44e2-82d9-088bb376a2be",
      "text": "European Parliament adopts resolution condemning Russian actions in Ukraine"
    },
    {
      "id": "21dd5abc-de08-4ba0-95a1-a69d8f1ff422",
      "text": "UK Prime Minister David Cameron signals support for strong EU sanctions on Russia"
    },
    {
      "id": "8e446813-8f7c-4b01-841f-0f4f41e401df",
      "text": "Reporting of UK MPs meeting or engaging with Russian officials and pro‑Kremlin voices (summer 2014)"
    },
    {
      "id": "9e783071-932d-44c4-b72c-073dde1ba831",
      "text": "The Joint Investigation Team (JIT) held a public presentation of interim MH17 criminal-investigation results describing the likely weapon type and launch area."
    },
    {
      "id": "d8dab0c0-3b5b-43b5-bbe4-899087df653b",
      "text": "Ukrainian authorities/activists compiled and publicised lists of Russian artists and cultural figures to be blacklisted from entry or broadcasting in Ukraine (summer 2014 announcements)."
    },
    {
      "id": "7a0e5497-26f7-4bf3-b1ce-9acfada7df29",
      "text": "Repeal/controversy over the 2012 Kolesnichenko–Kivalov 'regional language' law and moves to strengthen the status of Ukrainian after February 2014."
    },
    {
      "id": "0c49a33e-052f-49ba-bf55-1ae3ff4a816a",
      "text": "Kyiv city administration replaced Soviet-era Ded Moroz (Father Frost) in its official New Year program with the Orthodox figure Saint Mykolay."
    },
    {
      "id": "f702eca4-3df3-43f4-ba88-8f82b221f0c6",
      "text": "Widespread removal/toppling of Lenin statues across Ukraine ('Leninopad') during early 2014."
    },
    {
      "id": "6830bac0-33f7-4f3d-b9f4-50a6770990b9",
      "text": "Verkhovna Rada adopts four 'decommunization' laws banning communist/Nazi symbols and related propaganda"
    },
    {
      "id": "e9f26f83-5107-4efe-ba57-4e58c267e160",
      "text": "Assassination of pro‑Russian journalist Oles Buzina in Kyiv"
    },
    {
      "id": "9e55106a-7482-4706-a33f-a00cd680d924",
      "text": "Adoption of the 'lustration' (cleansing) law removing/formally barring former officials from public office"
    },
    {
      "id": "f4cc7d28-2245-4715-877f-7e297453bf71",
      "text": "Reports of Ukrainian authorities detaining and denying entry to journalists (SBU detentions, denied access to some Russian reporters)"
    },
    {
      "id": "14934671-25ef-4fcb-ac30-7e7a0a24bc5e",
      "text": "UNODC/trafficking and organized crime reports covering Ukraine (Global and regional reports up to 2014)"
    },
    {
      "id": "af0e6a14-792c-405d-b028-abba5677a364",
      "text": "U.S. State Department 2016 International Narcotics Control Strategy Report (INCSR) and related country assessments"
    },
    {
      "id": "f709e126-d65f-4650-8f20-26c6f29e7376",
      "text": "Panama Papers revelations linking Ukrainian elites and offshore companies"
    },
    {
      "id": "0d50ed39-c695-45a0-adf1-647e9acb58b6",
      "text": "Mainstream press coverage of the booming 'sound bath' and sound‑healing trend (New York Times feature, Aug 3, 2019)"
    },
    {
      "id": "cc964293-43dc-4ac6-b3f6-64826eb075e3",
      "text": "Publication of a small 2018 study 'Effect of 528 Hz Music on the Endocrine System and Autonomic Nervous System' reporting short‑term stress‑reduction biomarkers after exposure"
    },
    {
      "id": "aee0d9b5-873e-4876-8143-ded63ba56d81",
      "text": "Wellness platforms and apps published accessible explainers promoting 528 Hz as relaxing/'healing' (example: Calm blog explainer on 528 Hz)"
    },
    {
      "id": "17021d81-1db1-4e4b-bfec-2b8ab480913a",
      "text": "Russian authorities completed a domestic switch of Crimea's public telephone numbering to the Russian system (transfer of city codes to Russian numbering, widely reported May 2015)."
    },
    {
      "id": "9e2c67f0-d232-4772-bff4-99e0672e6621",
      "text": "United Nations General Assembly Resolution 68/262 (27 March 2014) reaffirmed Ukraine's territorial integrity and non‑recognition of the 2014 Crimean 'referendum'."
    },
    {
      "id": "f37a2d41-3591-4675-b8b3-45aecfd0c1b7",
      "text": "An ITU Operational Bulletin issue published information submitted by the Russian Federation about numbering in Crimea (the bulletin included Russian-requested codes but carried an ITU disclaimer that publication did not imply recognition of territorial status)."
    },
    {
      "id": "d24b3f28-0f8b-4a28-8b04-e32be4bb071d",
      "text": "Ukrenergo confirms restriction of power flow from the Ukrainian grid to Crimea"
    },
    {
      "id": "0748ae90-600e-4ee4-bfe0-075c8f9e1544",
      "text": "Russia announced a fast-track citizenship/passport scheme for residents in occupied Kherson and Zaporizhzhia"
    },
    {
      "id": "424761bf-f0dc-48e5-af5a-cac0413c3ec6",
      "text": "The Russian-installed head of the occupied part of Zaporizhzhia signed a decree to begin preparations for a referendum on joining Russia"
    },
    {
      "id": "d5950ac7-0671-4798-adcc-972fdf905721",
      "text": "Russian President Vladimir Putin recognized the self-proclaimed Donetsk and Luhansk 'people's republics' as independent entities"
    },
    {
      "id": "fa95aa46-bb79-4138-86fe-7e6ab9b3242d",
      "text": "NOAA and international reports showing greenhouse gas concentrations and ocean heat content reached record highs in 2021 despite pandemic-era emissions dip."
    },
    {
      "id": "e24110d5-1180-4c16-bc38-795134e27b4f",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, stating human influence on climate is 'unequivocal'."
    },
    {
      "id": "79d35ee0-ac57-4239-b894-633b79dbbca3",
      "text": "Unprecedented Pacific Northwest heatwave that broke all-time temperature records across parts of the US and Canada."
    },
    {
      "id": "1fa91e98-dfdf-4d17-a1c2-0e55453f5f68",
      "text": "The Pfizer–BioNTech Phase 3 clinical trial protocol (NEJM supplementary material, published with the trial paper) contains wording that 'each lot of \"Process 2\"-manufactured BNT162b2 will be administered to approximately 250 participants...'."
    },
    {
      "id": "cee11ac5-ee9e-4d90-b6b8-a84a489a312a",
      "text": "Regulatory assessment documents (EMA/UK regulator summaries and later EMA follow-ups in 2022) described two manufacturing processes (Process 1 and Process 2) and required post‑authorization comparability analyses that were later reported as fulfilled."
    },
    {
      "id": "d8e60c1f-58fd-434f-944c-4ce72c545008",
      "text": "Publication and long-running media attention to the Altamont Pass Wind Resource Area bird-fatality monitoring and final report showing substantial raptor deaths at a major U.S. wind zone."
    },
    {
      "id": "a3b4508c-58cd-474d-8161-5429b8d23b20",
      "text": "2020 study/news coverage showing that painting or visually marking turbine blades (Smøla, Norway) reduced raptor collisions by a large percentage."
    },
    {
      "id": "26dbb4b5-ff59-4c9f-815c-e1f87e0122c8",
      "text": "U.S. Food and Drug Administration issued public statements and warning letters (Nov 2019 and subsequent actions) about companies illegally marketing CBD products with unproven health claims."
    },
    {
      "id": "9517f92c-be11-4f77-b5ee-47c14548bfee",
      "text": "Mainstream consumer interest in 'clean'/'natural' personal-care labels (clean-beauty trend coverage)"
    },
    {
      "id": "e6277357-fcd9-48e6-a897-eec71ba573e6",
      "text": "Ukrainian authorities/Parliament and agencies moved to blacklist or restrict performances by some Russian artists (summer 2015)"
    },
    {
      "id": "b455d2a9-7776-47f3-bfc2-6bd1840b4e90",
      "text": "Verkhovna Rada passed 'decommunization' laws and other cultural-memory legislation"
    },
    {
      "id": "5462430f-9209-443c-bf3f-61c34bb63bea",
      "text": "Adoption and controversy around the Kivalov–Kolesnichenko 'language policy' law (entered into force August 2012)"
    },
    {
      "id": "73a8a531-40d0-4db2-84e2-becc6fa725c6",
      "text": "Ukraine's National Council for TV and Radio Broadcasting ordered cable operators to stop retransmitting several Russian TV channels"
    },
    {
      "id": "216ca709-f69d-498f-b4f4-786c1e244b9e",
      "text": "Russian leadership publicly denied deployment of regular Russian troops to eastern Ukraine (e.g. Vladimir Putin statements denying regular Russian troops are in Ukraine)."
    },
    {
      "id": "4b51393a-45b7-443a-bff4-0a494e99f6c3",
      "text": "OSCE Secretary General Lamberto Zannier and OSCE Chief Monitor Ertugrul Apakan issue a joint statement after Minsk talks noting the SMM could not verify removal of 'foreign armed formations' and stressing need for access to verify compliance."
    },
    {
      "id": "cbd4739a-100c-4f24-a7b8-c3247ecbca13",
      "text": "Ukraine's ambassador to Italy publicly criticized Verona's revocation and called it orchestrated by external (Kremlin) influence."
    },
    {
      "id": "a42bf906-e647-42b7-92d7-36ebf96c9b4f",
      "text": "Ukraine recovered and returned 17 paintings stolen from Verona's Castelvecchio museum; Poroshenko took part in return ceremonies."
    },
    {
      "id": "c021dd4d-806a-4032-8bf1-7ebf4d93c3bc",
      "text": "Widespread public fear and vaccine hesitancy in Samoa after the 2018 deaths—many parents reportedly stopped taking children for routine immunisations."
    },
    {
      "id": "c381469c-31d4-4198-b0b3-e812ef317ace",
      "text": "Two senior Samoan nurses were sentenced to five years' imprisonment for their role in the infants' deaths after incorrectly administering the vaccine."
    },
    {
      "id": "8a295faf-9404-48e0-a62b-27c2f552136f",
      "text": "Published clinical case reports and reviews documented rare but real cardiac or severe complications occurring around dental procedures (e.g., cardiac arrest during recovery after tooth extraction)."
    },
    {
      "id": "e78e8eb1-4810-4e35-a9c3-b2dcd8790b99",
      "text": "U.S. Defense Threat Reduction Agency (DTRA) and the U.S. Embassy publicly documented long-running U.S. cooperative biological threat reduction work with Ukraine (lab upgrades, surveillance, diagnostics)"
    },
    {
      "id": "93f0c2dd-8870-43fa-9452-41202cc779dc",
      "text": "Ukraine experienced major vaccine-preventable disease outbreaks and entrenched vaccine hesitancy (notably large measles outbreaks in 2017–2019)"
    },
    {
      "id": "d02dcf65-6a38-45fb-a525-077a35bf4ef7",
      "text": "AstraZeneca temporarily paused its global COVID-19 vaccine trials after an unexplained illness in a trial participant"
    },
    {
      "id": "57a02ad8-4448-44e4-a141-520c03160428",
      "text": "U.S. FDA issued an Emergency Use Authorization (EUA) permitting distribution of donated hydroxychloroquine from the Strategic National Stockpile (EUA issued March 28, 2020)."
    },
    {
      "id": "90a9d5a6-f8af-4493-8fa5-a42bb8db9d4f",
      "text": "Dr. Vladimir Zelenko publicly promoted his outpatient 'Zelenko protocol'—hydroxychloroquine + azithromycin + zinc—for early COVID-19 and gained local/regional media attention."
    },
    {
      "id": "96e3dce7-9eba-4438-ace4-aa43e5d214d6",
      "text": "Publication of Cowling et al. 2012 randomized trial reporting increased non‑influenza respiratory virus infections after inactivated influenza vaccination"
    },
    {
      "id": "0a6a1145-a3d4-4a65-ad60-e225a9c91c46",
      "text": "National Academies report 'Reflecting Sunlight: Recommendations for Solar Geoengineering Research' (June 2021)"
    },
    {
      "id": "d9bbb9e7-9567-43cf-b61a-226860dd80e3",
      "text": "Release of the 1996 Air Force study 'Weather as a Force Multiplier: Owning the Weather 2025'"
    },
    {
      "id": "f2d28ca5-a4ff-4723-afa9-d0c2392f65b2",
      "text": "Declassification and press reporting on Operation Popeye (U.S. cloud‑seeding in Vietnam, 1967–1972)"
    },
    {
      "id": "3134a2b8-f439-43c9-8be8-b77d0679cc74",
      "text": "President Zelensky’s office formally responded to petitions about the Catherine II monument and forwarded them to the Odesa City Council for consideration (per presidential response practice)."
    },
    {
      "id": "bf33dd8d-4985-4073-8f29-e88dd634f265",
      "text": "Separate electronic petition to dismantle the Catherine II monument was registered on the President of Ukraine’s petitions platform (petition 22/145072‑ep)."
    },
    {
      "id": "0ae7dfd1-35fa-40e0-9e47-14a3f14848bb",
      "text": "Online petition to replace Odesa's Catherine II statue with a monument of US gay adult performer Billy Herrington reached required threshold for presidential consideration."
    },
    {
      "id": "89e102d9-1bc7-4f63-bffd-7fda65291691",
      "text": "Sustained local activism and public debate in Odesa in mid‑2022 calling for removal or relocation of Russian‑imperial and Soviet monuments."
    },
    {
      "id": "4800cff6-05ef-4559-b9b5-a060f3cb3d0c",
      "text": "Large releases of internal Pfizer/FDA documents following the PHMPT FOIA lawsuit and judge-ordered accelerated disclosure (documents began being released publicly in early 2022)."
    },
    {
      "id": "7c273f10-c8b5-434f-be52-45e323e4b064",
      "text": "FDA briefing documents for the Dec. 2020 Vaccines and Related Biological Products Advisory Committee (VRBPAC) meeting that listed trial deaths and stated investigators assessed none as related to the study intervention."
    },
    {
      "id": "0fbbb965-1633-4ea5-9ce9-928f175f5658",
      "text": "Early COVID-era clinical reports and reviews highlighted that the eye can show signs of infection (e.g., conjunctivitis as a presenting sign of COVID-19)."
    },
    {
      "id": "0efe9f04-6dda-42a8-987f-1cce1fdd533e",
      "text": "Popular science and health journalism pieces explaining how eye exams can reveal systemic health issues (diabetes, jaundice, hypertension) reached wide audiences."
    },
    {
      "id": "2a20c42f-31d4-49e4-9328-7b3282f6e95c",
      "text": "Published analyses and meta‑analyses in 2022 documented reduced vaccine effectiveness against Omicron infection and waning protection over time, with lower effectiveness for preventing symptomatic infection and some reduction for hospitalization in older/longer‑since‑vaccinated groups."
    },
    {
      "id": "b9c1a642-6b35-4068-9dc3-d7b1c57c987b",
      "text": "Academic commentary and public explanations (e.g., Lancet / public‑health pieces in 2021–2022) highlighted the 'base‑rate fallacy'—how, in highly vaccinated populations, the majority of cases can be vaccinated even when vaccines work."
    },
    {
      "id": "c3cd41e0-2bb7-4e09-b02f-d168d847ab28",
      "text": "DIVI (German intensive care registry) added fields to record COVID-19 patients' vaccination status, enabling routine recording of vaccinated/unvaccinated counts on ICUs."
    },
    {
      "id": "fbea327b-7fd0-40ce-beea-46f16a9dbf94",
      "text": "Scientists and aerial surveys announced a third mass bleaching event on the Great Barrier Reef during the 2019–2020 summer, widely reported as 'third mass bleaching in five years'."
    },
    {
      "id": "083aa95c-3d27-4a40-8b2b-c6dbb45571a6",
      "text": "UNESCO and the Australian governments’ 2019 reporting on the Reef’s deteriorating outlook (2019 Great Barrier Reef Outlook Report / World Heritage Committee concerns) signalled long-term decline."
    },
    {
      "id": "33f55771-cf51-4296-b261-8bcf53c93068",
      "text": "Armenian NGOs and civil society groups (in early November 2020) issued public statements condemning Azerbaijan’s reported use of white phosphorus munitions."
    },
    {
      "id": "ba324eb4-9fbf-4cd7-b4aa-f8445cf55c58",
      "text": "Open-source satellite imagery and videos in November 2020 showed burn patterns and footage consistent with reported use of white phosphorus munitions in the Second Nagorno-Karabakh War."
    },
    {
      "id": "091ff2a4-b374-4426-a33d-f7e23441452b",
      "text": "Azerbaijan formally responded to Armenia's accusations at an OPCW session, denying the claims and disputing evidence (official statement recorded in OPCW documentation)."
    },
    {
      "id": "5fdb36f1-22ad-46b1-9e69-2e4bfe4e544e",
      "text": "IPCC Fifth Assessment Report (AR5) discussion of the 1998–2012 'hiatus' in surface warming"
    },
    {
      "id": "43a3c668-1c99-4d67-9f07-2295e4fa2080",
      "text": "Hockey-stick controversy and critiques (McIntyre & McKitrick critiques and 2006 NRC review)"
    },
    {
      "id": "24d78005-f0d3-4ce1-8a38-c5f713bfa53e",
      "text": "Public Health England technical briefing (Technical Briefing 16) published with early variant case and death tables"
    },
    {
      "id": "df94d9a3-14cb-4884-8808-85de69e39f11",
      "text": "Publication and press coverage of the Scottish EAVE II analysis showing Delta linked to higher hospitalisation risk"
    },
    {
      "id": "d97816b9-dc50-4549-9310-8f2a26c9df84",
      "text": "UN OCHA/partners publish Ukraine Strategic Response Plan (humanitarian appeals for Ukraine, 2015)"
    },
    {
      "id": "57d0e2b5-f4e4-4932-9b99-14b636e2d8fb",
      "text": "UN Security Council action on Crimea blocked after Russia veto (UN inability to act on Ukraine-related measures)"
    },
    {
      "id": "7381c9e5-6728-47f0-b327-03b0b0082787",
      "text": "IMF delayed/suspended loan tranches to Ukraine amid governance and reform concerns (2015–2016)"
    },
    {
      "id": "f4cd8341-4133-4ece-98c5-3f1ae86bfb81",
      "text": "UN humanitarian funding shortfalls reported in 2017 (large gaps between appeal requirements and funding)"
    },
    {
      "id": "f5e3fa72-fb2b-4c8e-8937-2731018dc071",
      "text": "UNDP policy guidance states UNDP will not contribute to general budget support (direct government budget transfers)"
    },
    {
      "id": "6060e61e-be0c-4d1f-8878-1c1691b915b0",
      "text": "Poland passed the 'Special Act' on assistance to Ukrainian citizens (granting temporary protection, PESEL registration and access to services) that entered into force in March 2022."
    },
    {
      "id": "4cceac16-67f1-48e7-8030-b9a52678e11b",
      "text": "Ukraine's Cabinet adopted Resolution No. 678 approving an experimental project to allow issuance of Ukrainian ID-cards and foreign passports to Ukrainian citizens abroad."
    },
    {
      "id": "494e5828-8795-4c50-ad8d-fc4c2c209197",
      "text": "Major reporting on rapid mass issuance of Polish ID numbers (PESEL) to Ukrainian refugees and the setup of document/ID help points (e.g., coverage of refugees receiving IDs at Warsaw sites)."
    },
    {
      "id": "bc22ef75-a7e4-4de0-ae26-55f122fe2cdb",
      "text": "Ukrainian document service announced opening of a centre/representation in Warsaw (Blue Office / Blue City) to process Ukrainian passport and ID applications."
    },
    {
      "id": "a1d7fb2b-8edc-4915-91fc-fe18cad847db",
      "text": "Publication of the NIC‑PD randomized, double‑blind trial (Transdermal Nicotine Treatment and Progression of Early Parkinson's Disease), published online Aug 22, 2023 (NEJM Evidence / PubMed)."
    },
    {
      "id": "81f0649e-10ef-4038-901d-eb4f190f3980",
      "text": "Statement by Eduard Basurin (DPR deputy defence minister) claiming drunken Ukrainian soldiers stole a tank and crushed a civilian car in Zoria, near Mariupol."
    },
    {
      "id": "918addad-d5e4-491e-8588-7c777292ac5a",
      "text": "Kerch ferry operator reports unusually high passenger volumes in summer 2016"
    },
    {
      "id": "bdac5e50-c5ac-4987-a66f-56d660418bf7",
      "text": "Crimean tourism minister (Sergei Strelbitsky) publicly claims sharp rises in Ukrainian visitors during 2016"
    },
    {
      "id": "008fdc96-62f2-4c1c-b1d6-f6f399651308",
      "text": "Russian media cites security claims that alleged Ukrainian sabotage aimed to 'destroy tourism' in Crimea (Reuters coverage)"
    },
    {
      "id": "23817343-8b81-46a8-9320-6fa8dee46184",
      "text": "Early, well‑publicized problems with the CDC's original PCR test rollout in February–March 2020 (flawed reagents and re‑validation), widely reported in the press"
    },
    {
      "id": "97852f8a-f5b8-43ae-a75a-95eb5ed90c03",
      "text": "CDC promotion and availability of a multiplex 'Influenza SARS‑CoV‑2 (Flu SC2) Multiplex Assay' that detects and differentiates influenza A/B and SARS‑CoV‑2"
    },
    {
      "id": "b56599e9-ad72-4144-9d60-987d74ff264b",
      "text": "Zelenskyy's public denunciations (Aug 2023) of corruption in military medical exemptions and announced reviews"
    },
    {
      "id": "fe6f6fa5-3c2e-4e35-aa6a-0adf5b433b80",
      "text": "Law / parliamentary changes expanding categories eligible for exemption or deferment from mobilization (July 2022 amendments and related guidance)"
    },
    {
      "id": "f63db715-5bd4-4e51-bd67-35cb0f93c1c3",
      "text": "Canadian Parliament standing ovation for Yaroslav Hunka (a veteran who served in a WWII Galicia-linked formation)"
    },
    {
      "id": "33e94dd0-492b-499c-83b2-f52adabde777",
      "text": "Japan suspended use of ~1.63 million doses of Moderna's COVID‑19 vaccine after 'foreign materials'/contaminant reports were found in some vials (batch recalls/inspections)."
    },
    {
      "id": "d472a84b-ab39-4837-a279-74b14e2731b4",
      "text": "Federal judge ordered the U.S. FDA to accelerate public release of internal documents related to Pfizer's COVID‑19 vaccine (court‑ordered accelerated disclosure ruling)."
    },
    {
      "id": "839b62b4-9b33-4648-88dd-6cc8e85f656f",
      "text": "Publication of an Israeli health‑system study (NEJM, Oct 6, 2021) reporting higher incidence of myocarditis among males 16–29 after BNT162b2 (Pfizer) vaccination, with most cases mild or moderate."
    },
    {
      "id": "23a1676d-b41f-4b99-b09a-8f17c643747c",
      "text": "Ukrainian adviser says counteroffensive is months behind because of slow Western arms deliveries"
    },
    {
      "id": "6e5165d6-1bd5-4ce7-91c6-45f010d28978",
      "text": "Analyses warn Western help for Ukraine may diminish due to production and political limits"
    },
    {
      "id": "54ae4560-4a71-4358-8e33-fef3a52ab75e",
      "text": "UN Security Council briefings raise concerns about diversion and proliferation of weapons sent to Ukraine"
    },
    {
      "id": "d8f8a2c0-bf07-461d-99c1-9859649a61e0",
      "text": "EU admits it will miss target to supply Ukraine with one million artillery shells"
    },
    {
      "id": "d3425a87-4b6e-42bf-b2fa-eff4512c53bc",
      "text": "Countries reimposing or tightening lockdowns despite earlier measures (e.g., Israel second lockdown September 2020)"
    },
    {
      "id": "040d00aa-47e1-4c98-ad24-df042df860e3",
      "text": "WHO interim guidance on mask use that did not recommend universal mask-wearing for healthy people (interim guidance)"
    },
    {
      "id": "646b569c-f662-4221-962a-ee7e0f3a48ae",
      "text": "Great Barrington Declaration advocating 'focused protection' instead of lockdowns"
    },
    {
      "id": "acf7757c-4a99-480b-8ee7-b09918bbffca",
      "text": "Sweden's no-lockdown approach widely publicized"
    },
    {
      "id": "9866e716-7537-48dd-956a-7bf35f3b3741",
      "text": "CDC recommendation for cloth face coverings in public (policy change)"
    },
    {
      "id": "7821f6dc-af3a-49ec-b236-d2ddae3f9d02",
      "text": "Ukrainian authorities move to redeploy ships/hovercraft and increase patrols in the Sea of Azov (reported August–September 2018)"
    },
    {
      "id": "e3089e01-dca9-435b-b9f9-e996f3add74f",
      "text": "Kerch (Crimea) bridge opening and its reported impact on navigation to Azov ports"
    },
    {
      "id": "dc3b4953-1867-4ab4-9561-7206fe782a8e",
      "text": "Public recall and investigation of foreign particles (stainless steel/black particles) found in some Moderna vaccine vials in Japan"
    },
    {
      "id": "1a072915-3b62-4d18-89ca-4e5b22d19ce2",
      "text": "Pfizer–BioNTech and Moderna vaccine efficacy announcements showing ~90-95% protection in trials (Nov 2020)"
    },
    {
      "id": "2bdcca91-cc30-45f0-91c7-e6e19e2b0c33",
      "text": "Large cohort study showing robust neutralizing antibodies to SARS-CoV-2 persist for several months after infection (Wajnberg et al., Science)"
    },
    {
      "id": "c79bfc63-8fee-4065-942a-5bd69c39be00",
      "text": "Arrests and terrorism charges against Crimean Tatars by Russian authorities"
    },
    {
      "id": "b4e5ffeb-5b1e-4223-b639-c6993b27b0a8",
      "text": "Ukrainian President Petro Poroshenko publicly vows to 'retake' Crimea / 'de-occupy' the peninsula"
    },
    {
      "id": "b3c01f64-695b-45dd-86ac-3532acdb540a",
      "text": "Repeated legal actions and arrests of high-profile alternative practitioners (example: Harry Hoxsey prosecuted repeatedly for practicing without a license, 1920s–1950s)"
    },
    {
      "id": "5f892b3d-872c-4d53-bbc2-e4db6eea1682",
      "text": "Air New Zealand suspended its Auckland–Buenos Aires service during the COVID-19 period (service brought forward in March 2020)"
    },
    {
      "id": "6f7d4055-8be6-4fdc-938a-fabe5e516197",
      "text": "CDC filed and was assigned patents on coronavirus isolates/genomic sequences (e.g., patent US7220852B1)."
    },
    {
      "id": "c483ea93-8523-41f9-a61e-ee868ad4cf6e",
      "text": "Widespread availability and consumer use of over‑the‑counter vitamin C supplements (NIH/Oregon State fact sheets documenting common use and safety perceptions)"
    },
    {
      "id": "17172956-7a49-4cad-bad7-acba17942b4a",
      "text": "Parliament vote to repeal the 2012 language law (February 2014) following the Maidan changes."
    },
    {
      "id": "204e0cc1-634d-4ed1-9f7f-d97c784c7c31",
      "text": "Adoption of the Kivalov–Kolesnichenko language law in July 2012 (Law on the Principles of State Language Policy)."
    },
    {
      "id": "9c0f6744-34e1-4673-b6d4-390fb27b1a9e",
      "text": "Introduction and entry into force of Ukrainian-language content quotas for radio and media beginning in 2016 (e.g., Ukrainian music quotas on radio adopted Nov 2016)."
    },
    {
      "id": "fbebad4c-0764-4bb1-ac23-cf33fefb6479",
      "text": "Ukraine's 1996 Constitution declares Ukrainian the state language."
    },
    {
      "id": "1a4978e3-02e9-4fa6-b620-2cccd43851ab",
      "text": "Visible nationalist rhetoric and high public sensitivity in Lviv and Western Ukraine during the Euromaidan/early‑2014 period (local protests, symbolic actions by nationalist groups)."
    },
    {
      "id": "e7b35665-d6ee-4f1a-8e50-f74ec2d2acec",
      "text": "Systematic review (Farsalinos et al.) published April 2020 summarizing multiple Chinese hospitalized case series and noting lower prevalence of current smokers among COVID-19 patients."
    },
    {
      "id": "00a2a27d-32c8-4a8b-be3b-9ed3e06ffdc7",
      "text": "Comptes Rendus paper by Changeux et al. ('A nicotinic hypothesis for Covid-19') proposing nicotine-receptor involvement and suggesting nicotine could have preventive or therapeutic implications (manuscript received 16 Apr; accepted 18 Apr 2020)."
    },
    {
      "id": "42c87d2d-b408-49a1-902f-92ac472bdaff",
      "text": "Public reporting and official statistics showing very high vaccine uptake among older adults in the UK by early July 2021 (large majority of elderly vaccinated)."
    },
    {
      "id": "25aada7e-13e3-4369-bf9b-717144c5afd7",
      "text": "Ukrainian statements in late June warning that failure to stop Russian aggression risks broader geopolitical consequences (coverage in Ukrainian press)"
    },
    {
      "id": "2aeb304e-6e62-44c1-b9a6-7aec1b078436",
      "text": "Regulatory safety updates and post‑authorization adverse‑event summaries published by national agencies in June 2021 (compiled safety figures made public)"
    },
    {
      "id": "f39a7b76-7b7d-4b55-b6f5-022ab5954c22",
      "text": "Publication of Israeli real‑world vaccine effectiveness analyses estimating infections, hospitalisations and deaths averted by the national vaccination campaign"
    },
    {
      "id": "2eaa4d5f-5434-4b0c-97c1-dfe2fa199bab",
      "text": "U.S. Fish and Wildlife Service listed polar bears as 'threatened' under the Endangered Species Act (ESA)"
    },
    {
      "id": "9160fce3-639a-404f-bc2d-247e2f635b91",
      "text": "Record-low Arctic sea ice minimum in September 2012 reported by NSIDC (new modern-era low extent)"
    },
    {
      "id": "fb3a0ff9-85fd-4a72-80a0-e6867be164fe",
      "text": "Natalie Jaresko was granted Ukrainian citizenship and appointed Minister of Finance in Poroshenko’s new cabinet."
    },
    {
      "id": "50193c60-d618-4f3a-abf1-4f0b12109764",
      "text": "Kateryna Yushchenko (wife of former President Viktor Yushchenko) is publicly known to be American-born (born in Chicago)."
    },
    {
      "id": "b47f6e2a-d3a4-4ae5-bd22-18f9947d3e27",
      "text": "Reporting that Ukrainian authorities and units were struggling to vet, equip and deploy newly arrived foreign fighters."
    },
    {
      "id": "4c69ec36-cf69-48e0-9359-b8cb2ff98b4a",
      "text": "Ukrainian president announces creation of an \"International Legion\" and publicly appeals for foreign volunteers."
    },
    {
      "id": "351cc15c-a27f-47ca-b694-732d51544410",
      "text": "Analyses and warnings about the presence of extremist and fringe foreign volunteers (scholarly/think‑tank reporting noting far-right and other fringe actors among some volunteers)."
    },
    {
      "id": "3f9f599e-0545-407d-a228-856b831a5cb2",
      "text": "German industry and officials warned that proposed U.S. sanctions (and pressure) risked harming projects such as the Nord Stream 2 pipeline"
    },
    {
      "id": "05f75e3c-f07a-4364-88d3-a266a0b06c8b",
      "text": "German Foreign Minister Sigmar Gabriel said sanctions on Russia could be eased if there is progress on implementing the Minsk agreements"
    },
    {
      "id": "2760a08d-440e-473a-8c1e-715e05679c7d",
      "text": "Chancellor Angela Merkel publicly urged dialogue with Russia after Vladimir Putin's 2018 re-election"
    }
  ],
  "claim_clusters": [
    {
      "cluster_id": "54385df9-c5b3-4372-ae3b-cfd7db571df8",
      "members": [
        "f87c7600-59d2-4ab4-b09a-ae422e1e69e9"
      ]
    },
    {
      "cluster_id": "6f7b7d52-9a91-4f92-8a4e-4062c6360cda",
      "members": [
        "6f6bed63-08c1-46fe-8bc0-1c762801e334"
      ]
    },
    {
      "cluster_id": "3198b672-2780-47ef-8885-73e8c5597d80",
      "members": [
        "a576c4b4-0c65-49ca-920b-4ecaded09384"
      ]
    },
    {
      "cluster_id": "8bdd6183-6e5d-4862-87e8-003b661f98ce",
      "members": [
        "f0ddc375-3356-4444-8d0d-b137fc47122c"
      ]
    },
    {
      "cluster_id": "d08db747-1994-456e-82f1-cca372892842",
      "members": [
        "1f421a35-85dc-4389-ab19-8fdf35e33f3e"
      ]
    },
    {
      "cluster_id": "85d98ed5-328a-4d59-91fb-32ddcf786d50",
      "members": [
        "7400f459-1420-43ec-a057-7d69851f577c"
      ]
    },
    {
      "cluster_id": "1ef62c3d-3750-43b9-855b-d4624938de1e",
      "members": [
        "465cb9b4-8693-4886-96ab-d5d5e84e1e2e"
      ]
    },
    {
      "cluster_id": "528a9885-82c7-4bee-beac-f85e4c7c3f1b",
      "members": [
        "c9a02044-aa17-4168-9b5f-43f734461b60"
      ]
    },
    {
      "cluster_id": "000d729d-1afe-4b59-b42a-5d8012efd354",
      "members": [
        "086a9850-cfba-4b59-bff1-4732196891ce",
        "9481983d-c22e-4db3-9b32-4c294f36a4ee"
      ]
    },
    {
      "cluster_id": "25acea26-0f6c-421d-8050-ebc9dac75b8d",
      "members": [
        "0fbf6f50-adb0-4459-b4e8-6ebf6f31e8e8"
      ]
    },
    {
      "cluster_id": "c58f6371-bd47-4b22-b946-60358a570901",
      "members": [
        "aeef8c35-aa6a-42aa-89d5-b5ef72ad0beb"
      ]
    },
    {
      "cluster_id": "c0fbbbbf-776a-47c5-9e8d-f798f722abf7",
      "members": [
        "81f3c3ca-b0d6-4aaf-9d5a-fe7f160017c9"
      ]
    },
    {
      "cluster_id": "e50a9fba-a791-4b5a-bed8-e0accc690c1a",
      "members": [
        "cefba4be-9e4f-49c9-9321-69129a73e873",
        "ac1ea412-c8f5-4d1c-8e19-03dc3ae75d56",
        "e16ed705-04cc-4390-aca3-42a049dd05bc",
        "5443ea63-f07c-43ad-ac4b-6a2569e1f360"
      ]
    },
    {
      "cluster_id": "a604694d-4fcd-48e0-a074-6eaa09488a89",
      "members": [
        "f3ef8d86-919b-47e4-8137-ade143408568",
        "e48cf645-1df7-4c3e-9a96-308dc5f930a6"
      ]
    },
    {
      "cluster_id": "7bfb1246-c004-4c78-a34d-8e0a5cdad287",
      "members": [
        "f951af6b-e20c-4693-87a6-aa62d357aa89"
      ]
    },
    {
      "cluster_id": "c5298737-21d9-47c4-b52e-e662ee88b15b",
      "members": [
        "f1708d7c-799c-4de3-b923-5f356ffd9bff"
      ]
    },
    {
      "cluster_id": "2edb056a-640a-40d9-89e2-36dbc25022b5",
      "members": [
        "bd49ac10-4124-493d-a447-94fc3b09335a"
      ]
    },
    {
      "cluster_id": "0e92b3d1-2946-4cb0-a0ae-5e9e0cf674a5",
      "members": [
        "3174a2d7-510e-462b-b43e-c80382769e5e",
        "5e4f1ea6-61f3-40d0-a513-02d3958732cf"
      ]
    },
    {
      "cluster_id": "6d600ff4-5ee2-443b-9049-7fb530fb454c",
      "members": [
        "c8a56e68-c7db-45d3-9241-1c28265623aa",
        "cd7c217a-f1df-4b12-ba39-e679935643a3"
      ]
    },
    {
      "cluster_id": "21b4d7af-e8bf-408f-b63a-f91c28b7ba72",
      "members": [
        "73cfa6ef-31dc-440e-9025-3009960098c4",
        "b84ae49b-ac57-4579-aa6d-644ea4a451ed"
      ]
    },
    {
      "cluster_id": "1977f04e-4cc8-4af7-ae78-39ce7804eadf",
      "members": [
        "28165b23-e753-4582-8659-4231b30f8237"
      ]
    },
    {
      "cluster_id": "6fa599b7-9959-44ea-a8f2-40b7f43bb558",
      "members": [
        "4f4a6042-cf34-4fd2-a9da-526f14b561e1"
      ]
    },
    {
      "cluster_id": "5102f7b6-4554-4836-b695-c4ff3c598adf",
      "members": [
        "ec29c403-da4f-4c5a-a13b-6b24c7b13867"
      ]
    },
    {
      "cluster_id": "58bf9f4a-adda-4853-802b-78d04aa711fa",
      "members": [
        "4737bc2d-57d8-46b8-a574-207bb792d8b7"
      ]
    },
    {
      "cluster_id": "f2df1c45-9507-438e-92d8-0a523b9a842a",
      "members": [
        "336912a9-e1a3-4f57-8f9c-b7762b7209f8",
        "a88b2527-91c6-4d02-858e-633868b1e316",
        "bde9d065-4da5-4122-84e2-a2a71d3d397d"
      ]
    },
    {
      "cluster_id": "1cf25dc0-5ba1-4372-8fe0-913839532e6d",
      "members": [
        "f768b4b6-6925-4a85-bb50-60f94a7741a2"
      ]
    },
    {
      "cluster_id": "903d2f0d-f14e-42ff-a685-a20e841d8f7b",
      "members": [
        "4938b926-8428-4afa-a749-574cecd5ae2c"
      ]
    },
    {
      "cluster_id": "98459a3d-d71e-40dc-bfe8-895082c9d11c",
      "members": [
        "d9e4dbc1-fb36-4daa-994f-f0a09fb3659f"
      ]
    },
    {
      "cluster_id": "821946a1-401a-4657-be17-b3ed51371c13",
      "members": [
        "89093070-7dbe-49e7-b3dc-5cc044d4dbc3"
      ]
    },
    {
      "cluster_id": "d6f2cb3f-8705-43f8-a523-1b8fab745bf8",
      "members": [
        "7a0d9023-d84a-4e6b-a041-5cde85e6e7b2"
      ]
    },
    {
      "cluster_id": "2c49dd92-a97e-4b1e-bac2-607670a0a86d",
      "members": [
        "27044113-2560-4012-b882-70eb957f02e7"
      ]
    },
    {
      "cluster_id": "d2f81fce-8c92-45e8-8294-41af7752f1db",
      "members": [
        "617b505b-72d0-4e59-b06c-c8ee97076f0a"
      ]
    },
    {
      "cluster_id": "901f6891-5f9b-4fa4-a368-69a4f20e9617",
      "members": [
        "15d251ee-d316-4914-85fb-a36f6f0ee424"
      ]
    },
    {
      "cluster_id": "16667fe1-8cf7-4fec-9aa8-c5bb30920e90",
      "members": [
        "833bc7d2-f731-4664-b1af-2477a3c0901f",
        "56510e96-92e4-4076-baf2-835ea275dbad"
      ]
    },
    {
      "cluster_id": "925ee56a-7eb9-4c7c-aeb3-1eb168cbca46",
      "members": [
        "478eaf7e-5c75-40ca-94b2-5103365ef343"
      ]
    },
    {
      "cluster_id": "6015f261-315c-43b5-ae1a-b6f1ad2e1ce6",
      "members": [
        "f5d192c5-b17f-4f71-a518-017c5e85f4ac"
      ]
    },
    {
      "cluster_id": "b9579765-0e2f-429b-a723-006d6265617d",
      "members": [
        "6fa922ce-55ad-4a30-9fe1-980dad76dc1b"
      ]
    },
    {
      "cluster_id": "fe684e64-4226-4567-8e1f-5613fae2c8f8",
      "members": [
        "de6607f8-6b64-4d75-8e44-11e9e4f7ccb5"
      ]
    },
    {
      "cluster_id": "19ef8fca-6a45-4387-be0d-efc3fd245b80",
      "members": [
        "76d8af43-7e04-45d0-811c-53aac369589f"
      ]
    },
    {
      "cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
      "members": [
        "15b6738c-12a2-4da8-b74a-ca562126681e",
        "3be75c33-86c8-4847-aee0-67f6c3df0e06",
        "fa08c157-a681-4a26-b553-93c830dee2e0",
        "50dd51fa-63ef-4307-87b0-455a8d787703"
      ]
    },
    {
      "cluster_id": "22107865-2cc2-437f-be8c-dd105a24eaaa",
      "members": [
        "48c6fb30-824a-45f0-b430-1a9c043ac50c"
      ]
    },
    {
      "cluster_id": "8b44daa7-629e-4db8-81b7-5ed88669eb86",
      "members": [
        "93ec9716-d23c-493d-a33b-ce35394dad90"
      ]
    },
    {
      "cluster_id": "0653516b-f642-4236-857e-3f4989809104",
      "members": [
        "767b6e2b-87ff-4adf-a611-c0fca1a914b0"
      ]
    },
    {
      "cluster_id": "bfa96159-d0c2-4735-8c1a-2d33b2346d24",
      "members": [
        "0b3711a1-a958-4235-be1b-2e354c057f75"
      ]
    },
    {
      "cluster_id": "0298b49f-bf28-40f5-acd6-4e9587c690ae",
      "members": [
        "427e50ca-3a16-4ebd-83e1-e40b51ad9592"
      ]
    },
    {
      "cluster_id": "5a77fa7e-06f0-487a-a93b-f15e590aa54a",
      "members": [
        "17856776-94dd-4971-8f6a-b452ce40df62"
      ]
    },
    {
      "cluster_id": "c0a45d49-4b4d-4871-845a-e13c06e06fa2",
      "members": [
        "e8074bd8-53a0-4814-aced-1acb0c5245fc",
        "37bec350-cb9c-4cf5-b0e9-f634d9686f01"
      ]
    },
    {
      "cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "members": [
        "16c696ba-d994-4261-8da6-1a270cd3048e",
        "22f58df3-30ac-4a5a-b495-5e67661f640c",
        "a8c9c515-3996-4b03-9b74-2439120b001d",
        "c3bc63e4-3848-4ca2-8707-206e5c2af2b2"
      ]
    },
    {
      "cluster_id": "c6d2f5c4-bb51-435b-a664-174b47ed38ef",
      "members": [
        "1b8a80cb-00a8-49f8-9abe-a0573478b25b",
        "6766b9c1-406d-4828-8659-a18545ca193d"
      ]
    },
    {
      "cluster_id": "db9b9c53-4b26-4d88-83d5-c4c2d8189711",
      "members": [
        "edf3fbc7-c80f-4143-9f75-5bc39a8ec5cf"
      ]
    },
    {
      "cluster_id": "b2635760-bcd6-46c7-88fb-9bbbb7349033",
      "members": [
        "9f9a7f59-cda2-4d08-bfc3-1137f05c0d76"
      ]
    },
    {
      "cluster_id": "d6c74194-ae1f-4099-a13b-0f247e76b288",
      "members": [
        "c0910306-1bdc-466f-b897-fa554e758e08",
        "9cf05b3f-382f-43f9-8123-06d6ff2879e4",
        "c9488325-cda6-4175-8aab-76fc0f8bd6d4"
      ]
    },
    {
      "cluster_id": "6b8a2895-80e5-4b3c-853c-39abf201a8b0",
      "members": [
        "e0275e8e-3f36-4ee3-8547-1e63a469c2cd"
      ]
    },
    {
      "cluster_id": "db6d1f55-1378-42e6-ab38-0b1046e37cc0",
      "members": [
        "8dd0a52c-1ee1-46db-b2c7-974908ed3fcc",
        "a595315e-7ec1-4c80-abff-07725d6dcf14"
      ]
    },
    {
      "cluster_id": "68142908-c71d-4106-9ef3-2de00198c72e",
      "members": [
        "19cb918d-f6c9-454c-a8e5-4273d38115fb"
      ]
    },
    {
      "cluster_id": "91ccf699-eaec-41a7-8213-08934dbe2395",
      "members": [
        "e443703e-4498-448c-beee-ccd4451cad2b"
      ]
    },
    {
      "cluster_id": "9096173e-de4b-47e9-9e39-b39282b05e47",
      "members": [
        "08b8c6b4-a939-41ed-a494-d43379fb6feb"
      ]
    },
    {
      "cluster_id": "6f59c0c4-2b1f-4873-80b4-3766eb7b28aa",
      "members": [
        "0e8a03a2-1fd8-4a44-8d0f-face8a2c9c72"
      ]
    },
    {
      "cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "members": [
        "13fd44f4-b3a3-40f4-8580-ca6d9775cbe6",
        "49c1f390-e9fb-4153-bdfa-9523ca30b466",
        "d572be63-43ec-4f6b-9196-a4fc78e203a6",
        "f65d41cb-fc8a-47b7-8a48-2d4eb9377096"
      ]
    },
    {
      "cluster_id": "745389b6-9b21-4dd2-89bd-e66fab0ff334",
      "members": [
        "dfa5b8a9-77e9-491a-b2dc-c11684135e6d"
      ]
    },
    {
      "cluster_id": "2c44608d-8e33-4f88-ad5e-7e4885719e31",
      "members": [
        "09c6031a-b6a1-4281-8806-488266d5d9a1"
      ]
    },
    {
      "cluster_id": "bc630aac-e921-4ad6-990d-40d804192d55",
      "members": [
        "d66a2ce6-c126-42a6-963d-51a7681ca771"
      ]
    },
    {
      "cluster_id": "616e962d-58a9-42e5-9a6d-decd8139ddf7",
      "members": [
        "d0bfc1de-e35a-4da9-8154-5f258fef738a"
      ]
    },
    {
      "cluster_id": "e4184b4a-b3b8-45cd-9a60-442e840d1a7e",
      "members": [
        "12008091-2bc6-4890-bb3c-854215a50247"
      ]
    },
    {
      "cluster_id": "7051d37c-4575-4653-97a5-3052e1c2b344",
      "members": [
        "35ea3880-9e1c-4ede-9b52-6247aa147b68"
      ]
    },
    {
      "cluster_id": "2c1958a0-e83a-4912-9902-e6456b756f14",
      "members": [
        "99c8e862-b82f-40c0-b65e-d6a7fd0d0339",
        "4fdb3b57-9805-49aa-9ede-c400eb1945b3"
      ]
    },
    {
      "cluster_id": "689e5dcf-938b-411b-9e5b-4de3aa6f026b",
      "members": [
        "e91bd487-5e4d-4843-9770-ebcce124f228"
      ]
    },
    {
      "cluster_id": "be7f1195-f177-4bc7-91dc-0cfb479ebb8e",
      "members": [
        "536d327b-e914-4557-8e17-34f659a733b3"
      ]
    },
    {
      "cluster_id": "f90286ec-0f96-4266-aa5f-350beb9c1d91",
      "members": [
        "f4fcca1d-59e4-4afe-85f0-23c1b3f24c20"
      ]
    },
    {
      "cluster_id": "18fe8f4b-896d-47b4-a019-0383dc22d38e",
      "members": [
        "beeff699-16f0-47ec-8c97-621e2753189c",
        "0cd5a5ec-984a-46a9-b75f-473d9ca5d392"
      ]
    },
    {
      "cluster_id": "aac18326-5af8-47ed-b7a7-209e78b29dfe",
      "members": [
        "cd998a9f-f5b7-4714-a65f-5f84fa314285"
      ]
    },
    {
      "cluster_id": "2567422d-b366-451c-a271-4cb76dc8196c",
      "members": [
        "8213f3f9-e4a9-43f9-9c2c-f422caa0ec18",
        "2d2a3a96-0b99-495f-8ccf-3917ec3328a7",
        "a7a7f1ae-fd6b-4da5-b669-3516ad890958",
        "47df24f4-8606-426b-9cee-667f9c8df0c0"
      ]
    },
    {
      "cluster_id": "3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9",
      "members": [
        "cd434d04-1633-489e-bfa6-926384c048f9"
      ]
    },
    {
      "cluster_id": "3e1920d2-6038-4d0b-b122-137c458f6d99",
      "members": [
        "7a443fce-0c0b-4539-9cf1-6940824b372f"
      ]
    },
    {
      "cluster_id": "de1f8a69-eaff-4387-87ee-35fc20ea4a2f",
      "members": [
        "b85bd849-6965-49db-8bfa-2c341a6b767b"
      ]
    },
    {
      "cluster_id": "843e2174-20bd-4386-beb4-ad4f8d0ba790",
      "members": [
        "2624b9a6-3642-47aa-838b-93a16681e6b8"
      ]
    },
    {
      "cluster_id": "8cc2fa20-28d1-44d8-bdd2-f42d8dc30f18",
      "members": [
        "a72f5b31-09c3-4779-b8ac-06cb11df19f5"
      ]
    },
    {
      "cluster_id": "ee9a474d-ce93-4992-ac4b-8d9da4087257",
      "members": [
        "5a47361f-f3f5-4848-996e-ab8a35e53506",
        "6556fa0f-7605-4ab6-81a2-f99e0802e367"
      ]
    },
    {
      "cluster_id": "7c045c5d-d9cb-4901-a4fe-8f8a68090a83",
      "members": [
        "27bed591-efe4-4380-9175-463d1e9beec9"
      ]
    },
    {
      "cluster_id": "f10ad797-ad79-4629-861d-4af809502a09",
      "members": [
        "488cf1db-9647-4bdd-9bd4-c0f17a970a8d",
        "0445898d-c78b-4144-8eda-758b3dd164b9"
      ]
    },
    {
      "cluster_id": "175bdcd7-0fff-45d5-9e67-f78e69286a6f",
      "members": [
        "ddef5269-c55c-412a-88d8-cc6de159e5d2"
      ]
    },
    {
      "cluster_id": "746085cd-6635-459a-8b25-138f4d67d9dc",
      "members": [
        "d48e7efa-e061-42c7-951d-8b7878442670"
      ]
    },
    {
      "cluster_id": "b26a4469-2931-4dab-aa78-be1b6fba8a36",
      "members": [
        "0b887eb2-d3fe-4a26-b9ed-8ccab8eed304"
      ]
    },
    {
      "cluster_id": "e7e80c41-a749-4b0c-a666-715bedd44f52",
      "members": [
        "7dd93d3f-7b86-478a-8d6a-e2fe3b210bd9",
        "ab291336-2b55-470b-96e8-5a65d246d084"
      ]
    },
    {
      "cluster_id": "8992a182-5ede-4dbb-9979-4dcf0e10c546",
      "members": [
        "5ae1c610-b184-4b7e-9608-8ec637c2163d"
      ]
    },
    {
      "cluster_id": "43d1e3ac-04ef-4f83-99ee-76241c79a7a0",
      "members": [
        "e8a6d2cc-1402-44b4-89d0-d6d15661c184"
      ]
    },
    {
      "cluster_id": "86160f22-53c1-4e04-a28d-86c0e883fa44",
      "members": [
        "bcb10216-8099-4a89-8a2f-dfe48c4f119e"
      ]
    },
    {
      "cluster_id": "09287807-b3db-4547-9baf-8656d4a8733f",
      "members": [
        "9f780feb-277f-4ab7-9d0c-6503c1a72f7d"
      ]
    },
    {
      "cluster_id": "87b92fb4-b0e3-4b01-9c2e-cfd9469245f7",
      "members": [
        "89ec0ed5-16bd-4877-87da-8d57a86b4fdc"
      ]
    },
    {
      "cluster_id": "9920b872-a377-485c-97d1-65b98d038806",
      "members": [
        "78af90a9-231c-467d-bf98-e148fae3d4ab"
      ]
    },
    {
      "cluster_id": "41d64b2b-508f-4c89-9c48-7c598989efd1",
      "members": [
        "71cd1619-22a6-48a4-a430-f9f5fd51f364"
      ]
    },
    {
      "cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "members": [
        "13e59ff3-cf80-48a0-8ca3-bd5160034d1f",
        "4f2b6c36-9cdb-49ec-816c-48a4d58bb10e",
        "864f721b-f058-4fa2-9aa7-84f986dd34c9",
        "5a5e634f-a429-49c4-b8ef-cebfc06153b3",
        "02810d0a-a801-4de0-844c-925df942cad1",
        "52896f5f-991a-4b65-a529-2f922b6a31ea",
        "174d2d07-cece-44ec-bff4-d6647249a61c"
      ]
    },
    {
      "cluster_id": "fb1e3132-0050-4db5-a637-391574f70b71",
      "members": [
        "ff0d0233-5e20-42b2-8006-dc4d0acc2158"
      ]
    },
    {
      "cluster_id": "28aee566-0979-4444-a6e1-cda00f681d91",
      "members": [
        "0c37996a-74f5-46b9-80c1-6b106323d2a3"
      ]
    },
    {
      "cluster_id": "cc37a7b6-46fd-4cda-8faf-63a00cd3c131",
      "members": [
        "7097ddfd-3b36-4ba8-92c0-d865bcceffa8"
      ]
    },
    {
      "cluster_id": "73fff1e2-bc77-421c-8436-e9bf094a9733",
      "members": [
        "1ad2a887-f91c-466e-a216-b5d069ecb3f9"
      ]
    },
    {
      "cluster_id": "8346c5bc-af0f-44c1-b155-e89d63c46a37",
      "members": [
        "957f125b-3856-47c7-abaa-0f944b7c91f8"
      ]
    },
    {
      "cluster_id": "c1587edf-f13c-4a02-9534-a3653325bfee",
      "members": [
        "1662e238-4375-4f16-a4e3-54e72797d3bc"
      ]
    },
    {
      "cluster_id": "2b77fdbc-c4ed-4e0c-99a3-6dbf568aa8a5",
      "members": [
        "3739e2cd-1316-4d38-bbcc-80c9e68240f6"
      ]
    },
    {
      "cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "members": [
        "1ab1f948-6a4f-4dbe-930f-d42b1a28f8e0",
        "b7300488-7bab-4bc6-a126-b997fe7c37a7",
        "45e07c52-5893-42d9-a89a-35ed3e29e4d3"
      ]
    },
    {
      "cluster_id": "cbbcd94e-9982-4e51-989e-706618e8fd67",
      "members": [
        "93556400-dba8-4dca-85f4-0b62f5397b0e"
      ]
    },
    {
      "cluster_id": "5ab9d303-668f-48d9-893f-546437484767",
      "members": [
        "2618d609-9085-4e09-964d-340fa3ca368f"
      ]
    },
    {
      "cluster_id": "4e71d535-1646-4ea5-9c47-04fb1464f390",
      "members": [
        "2ee21ada-c92f-4f6e-8afa-775bb49f7ee5"
      ]
    },
    {
      "cluster_id": "c7e21d17-7b1c-44ba-9b2b-db5a38de4e97",
      "members": [
        "f2dfb2d5-9fc1-4013-91c6-d706a72fc7a0"
      ]
    },
    {
      "cluster_id": "8347f82c-28cc-4206-8266-0d33250fbc4f",
      "members": [
        "b3756ec0-de4c-400d-ba54-b622375198c7"
      ]
    },
    {
      "cluster_id": "ff26fc04-79ea-483a-b7fa-30217f23ef0c",
      "members": [
        "d85cf775-381c-44b3-8df3-f51f833a51b0"
      ]
    },
    {
      "cluster_id": "2d2ebd07-a80d-4a48-b320-cc68d39bdc10",
      "members": [
        "cb3ca572-0441-4955-a248-db1da354742a"
      ]
    },
    {
      "cluster_id": "13ce1de8-c90f-43f4-ae08-251f1aed012e",
      "members": [
        "78ef9d0d-cbe9-4377-ad53-fc84b39053ac"
      ]
    },
    {
      "cluster_id": "af167078-1ea4-4d05-a491-aca4808cafd4",
      "members": [
        "007d5f3c-bdad-4c07-b684-a26173cf5e82"
      ]
    },
    {
      "cluster_id": "7b2b0362-dab0-48fd-8877-b1ece626a827",
      "members": [
        "4be0dc1d-7530-4841-91d3-ce66989346e6"
      ]
    },
    {
      "cluster_id": "5a772e21-6b8f-413d-9915-01833aadc67f",
      "members": [
        "6f61a9af-edce-4287-87b7-c4ebec356a14"
      ]
    },
    {
      "cluster_id": "60ed7bd8-a38c-4b99-a08f-6210e30fac23",
      "members": [
        "6718d0e7-dcd8-4437-a407-22bd03bc1358"
      ]
    },
    {
      "cluster_id": "73e672aa-47a1-430b-843b-82f236a93650",
      "members": [
        "4331310a-240f-4f5c-8248-c2ed98c42e14"
      ]
    },
    {
      "cluster_id": "2b4fc83f-18c3-4ff7-b918-64e0981dd3b2",
      "members": [
        "7875385f-24d3-41aa-b62b-62e7784acb38"
      ]
    },
    {
      "cluster_id": "0d1ccd4f-6f42-4604-a9be-95ea8fe5adc0",
      "members": [
        "9220a5ba-712b-4df8-ba50-4d8c735c8c3c"
      ]
    },
    {
      "cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "members": [
        "f7606c9a-7151-4bd3-9758-d00141dcb4d8",
        "0ee2c48e-a733-454d-8a13-3b84573113c4",
        "64666dca-81c0-4f77-8e27-11a65af4908d"
      ]
    },
    {
      "cluster_id": "cbafab62-ed48-49fc-9623-dbadef5cfd91",
      "members": [
        "f15e9b17-1ad8-4821-a588-d3af4c719ff8"
      ]
    },
    {
      "cluster_id": "e42f3c12-f894-47fd-b892-02c051609420",
      "members": [
        "1a56dc5e-ba61-4644-9c10-6955323e656e"
      ]
    },
    {
      "cluster_id": "388dcf56-c13f-4ec5-bbc7-b3c71eaffd35",
      "members": [
        "2b7ade88-953b-46f0-bc68-bfaca809912c"
      ]
    },
    {
      "cluster_id": "61ed0aed-dc5b-413d-8a18-4362324862cc",
      "members": [
        "7e467183-d865-4fef-946e-2c23ae418bcb"
      ]
    },
    {
      "cluster_id": "59bf3043-2eaa-48fb-880e-613249cbd976",
      "members": [
        "64799110-c77d-4ac6-bc97-7ff62fcb8a2e"
      ]
    },
    {
      "cluster_id": "fc40e900-5f3a-4200-9723-06366e139ab4",
      "members": [
        "ee46032c-f0cf-444a-8f80-e9b13cd0b005",
        "dd3a5f5e-8f8b-413c-aeea-d834efd4e544"
      ]
    },
    {
      "cluster_id": "c8d47411-ab85-4f96-b286-cd76451823f8",
      "members": [
        "4abcfa12-6bfd-466d-9150-338b7342cab6"
      ]
    },
    {
      "cluster_id": "6d176455-78b5-4454-a405-3f0ba5b91ecb",
      "members": [
        "a8b31f8e-55eb-45c4-a764-ef67085d3366",
        "75eb9293-d877-4a9b-a68b-1978f9ce494e"
      ]
    },
    {
      "cluster_id": "bdc7e61b-1cd4-494f-b965-4387369e6df2",
      "members": [
        "6350ae1b-8cdf-4b7a-ad10-d916d972a0e0",
        "4ccc6622-0ab3-4807-aa62-fd81cd5dca86"
      ]
    },
    {
      "cluster_id": "bde9febe-9a28-4f0f-b67c-15f9a243538b",
      "members": [
        "9c858f34-ee42-4bee-b81d-6c19a43afc6e"
      ]
    },
    {
      "cluster_id": "642bd570-9063-4bca-8050-702e322b8b3c",
      "members": [
        "ab26e6de-bc72-4458-8ed2-edb712e0b10a"
      ]
    },
    {
      "cluster_id": "eb38044c-3282-4492-916e-08a1ddd715ef",
      "members": [
        "a449796e-a3e6-4769-822c-2773b7ee988d"
      ]
    },
    {
      "cluster_id": "7e265407-1dda-4e06-a69c-824b7e191f01",
      "members": [
        "fe7df57d-79a9-4ff6-ba79-3050ae549de5",
        "bdb21458-dbfe-4275-9fa8-0f9835290487"
      ]
    },
    {
      "cluster_id": "166b6595-ba80-4fe0-a5a2-70307703e855",
      "members": [
        "f32c1f88-24e1-4df1-aeea-6df0e3c11ec2",
        "23ca88b5-5732-4b74-9c33-93b2fdb7eb32"
      ]
    },
    {
      "cluster_id": "a4d61819-30e3-46aa-ab08-cf879db00de1",
      "members": [
        "b6f037d9-ebd9-44bc-8593-86fab94832b0"
      ]
    },
    {
      "cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "members": [
        "1187ca34-8c0c-4b1c-976a-16d330b9a1d9",
        "4ba11038-ee3b-48f3-94e9-85863cc1e604"
      ]
    },
    {
      "cluster_id": "c75ee75a-e51c-413b-b72e-c2160bcb40c1",
      "members": [
        "8a0223ce-5203-47c1-8826-8e74e2722658",
        "32595345-7f9a-4856-a227-973a668f7e96"
      ]
    },
    {
      "cluster_id": "2870dcce-8def-47de-9196-c66889a0a474",
      "members": [
        "e54a4559-e9d6-48c9-a017-cff1ab133b9b",
        "be368ea7-a509-48f9-a3c9-9d281436a081"
      ]
    },
    {
      "cluster_id": "3d5e8f72-7611-4d2c-a35c-668790f97298",
      "members": [
        "9956f2af-2c95-42b2-9bf0-14fe682b5743",
        "2e0827b1-fbe8-467c-989c-3d8579ac9421"
      ]
    },
    {
      "cluster_id": "a3c357ac-5159-4eec-ad16-09366a144d09",
      "members": [
        "2b26ea24-872e-4ec5-a427-a6aa12dea564"
      ]
    },
    {
      "cluster_id": "544ac6da-d621-4fd5-bbf8-4a2cd6254e41",
      "members": [
        "e5e08180-87db-45fa-a95e-e49563fe5349"
      ]
    },
    {
      "cluster_id": "aa95c9e4-8d02-4bc6-90e1-de547f4e4e60",
      "members": [
        "e9d28110-aba5-4fa5-908e-6d72615508da"
      ]
    },
    {
      "cluster_id": "02e7a900-bce3-4812-8137-1246791846bb",
      "members": [
        "7508530b-783f-411d-9df2-1d438adce45f"
      ]
    },
    {
      "cluster_id": "5764cc12-79c5-4e4e-b170-52997cac0e07",
      "members": [
        "d4cb7368-b061-4286-ae98-8c099d459934"
      ]
    },
    {
      "cluster_id": "2f4149f0-f4a5-4695-86fa-9ea760cb8651",
      "members": [
        "cc7c7297-bace-4c80-b48a-892456512083"
      ]
    },
    {
      "cluster_id": "2408ad82-3b39-4925-be26-13cd9f14bf98",
      "members": [
        "dd868710-2903-4168-a32e-3c94389e6277"
      ]
    },
    {
      "cluster_id": "9dbb0955-d2fa-4dce-a46f-5ed43c9e3231",
      "members": [
        "636cd023-52ad-4868-984b-0839d1caa1f4",
        "172053f7-c475-4ba5-9e5b-d74241bbe64a"
      ]
    },
    {
      "cluster_id": "c8416335-0a4e-4b5d-aa9e-40e533302d3c",
      "members": [
        "5aa24293-2634-4bc7-8184-c66f3b745e03",
        "1975bd25-208c-49f9-81ab-e7ba511bdcd1"
      ]
    },
    {
      "cluster_id": "9ffb85b8-5080-4f27-85ad-554406cf7402",
      "members": [
        "47ac6884-7594-4b3c-b28b-dd503b885e7f",
        "9226bd71-b042-472e-8759-f2e8e2c7c9cc"
      ]
    },
    {
      "cluster_id": "9142e74b-a217-4be0-8685-ab7ea89b683d",
      "members": [
        "47ddaa30-cf7e-4d28-8391-89974b15a3b9",
        "87da1479-4c72-46b2-ad3b-3ef960418972"
      ]
    },
    {
      "cluster_id": "a3a558f9-9b36-49bc-be77-b1d77d8074f6",
      "members": [
        "884fe5f8-e7da-4e30-8eef-0008e873759c"
      ]
    },
    {
      "cluster_id": "9c5c6743-3894-4e82-b69e-bc4e0c19f869",
      "members": [
        "f66fd859-6f7d-4fa0-9a96-67d8ff477e2e"
      ]
    },
    {
      "cluster_id": "8b72504b-7ef9-4a36-b0a5-32d0b76c4553",
      "members": [
        "ce7f026a-0ab7-42e8-9442-e615ffeea978"
      ]
    },
    {
      "cluster_id": "abd83725-20da-4a40-a5cf-bb6715d5460b",
      "members": [
        "fe4f65dc-a3fd-461b-84ef-a9aa528e82c3"
      ]
    },
    {
      "cluster_id": "49ede63e-a1af-4931-8ab4-034fed7764ad",
      "members": [
        "9f2be1e0-7a49-4ae4-a02b-8ac3b8365d35"
      ]
    },
    {
      "cluster_id": "d2c2f402-f56b-4dfa-98d3-daf63239156d",
      "members": [
        "19f7b638-83df-4a3c-81a7-526caaf85d66"
      ]
    },
    {
      "cluster_id": "efb75ced-ba33-4f51-8892-e54a26a45d00",
      "members": [
        "43c50ec4-e439-41f4-9937-123ec169599c"
      ]
    },
    {
      "cluster_id": "5767d0cf-3070-412a-9136-a29c287f15a1",
      "members": [
        "a250abd9-1826-412f-a0ff-1f5b933ec1c3"
      ]
    },
    {
      "cluster_id": "3dc82114-c98e-4342-a6ab-854d95d9efa7",
      "members": [
        "87e829e9-3f41-41b6-865a-127fd69177c7"
      ]
    },
    {
      "cluster_id": "71acf2d0-be7b-4d8e-b3fc-93baaa073aa1",
      "members": [
        "ee4bbdad-e06e-4498-a6f0-64f0edb8dc41"
      ]
    },
    {
      "cluster_id": "5904fe8c-6989-4981-93c1-c6202b0b4d88",
      "members": [
        "b61bf145-6023-438e-8892-d7fe96cbf12b"
      ]
    },
    {
      "cluster_id": "f5798794-c4ea-4a9f-ad2e-0bf496c0ed12",
      "members": [
        "3240aea3-0609-4219-bdd2-c1d543e1bcf8"
      ]
    },
    {
      "cluster_id": "5f2c5e5a-f6ae-4d50-91e8-eee0bd665636",
      "members": [
        "e48da546-7868-425c-9c92-6ca48cd1a487"
      ]
    },
    {
      "cluster_id": "76e8427a-4f65-4a81-bf8d-354e00b7198e",
      "members": [
        "248a53ac-6338-45d2-b294-432225aa0978"
      ]
    },
    {
      "cluster_id": "8f4c47af-fb0d-428c-b422-7767f77bc38d",
      "members": [
        "18a6f363-add3-4ef3-894a-3ed23100bf2a",
        "4e38a522-3536-4ad0-8f6c-4b1db9689668"
      ]
    },
    {
      "cluster_id": "72a7c01f-5ad0-4d37-b9bd-84c255cc3d32",
      "members": [
        "6fa2d0d1-6f7a-40e7-8398-fb85e5b82cc4"
      ]
    },
    {
      "cluster_id": "b247d35e-9452-4e26-8399-17fe2d8e1df5",
      "members": [
        "b283c199-6181-456e-9548-cbc9398e3f20"
      ]
    },
    {
      "cluster_id": "59b8d1fe-1725-4325-a7c8-5abd450e3124",
      "members": [
        "c85fb9ec-7fd3-4079-8d58-39fb63cb86a3"
      ]
    },
    {
      "cluster_id": "7561e4ca-9d0c-4966-9181-2c8e8d681852",
      "members": [
        "54928d60-982d-458b-b1df-dd617491df23"
      ]
    },
    {
      "cluster_id": "6b38f355-a80e-4449-8c83-c5ac56d5a2e6",
      "members": [
        "befa7383-e680-4c0f-a73a-0c1202663765"
      ]
    },
    {
      "cluster_id": "1cd94f5b-6850-44c5-b48e-2bcdab6eefd2",
      "members": [
        "caa71a9e-8f7d-4c80-ab0c-514b6f6e7216"
      ]
    },
    {
      "cluster_id": "589240bc-a0dc-4961-944a-a3594262e220",
      "members": [
        "0f4b22b3-d4fc-450a-9924-e15aaf4b9442",
        "9f5848cf-a05d-421e-9dc8-0d8ecdda8e58"
      ]
    },
    {
      "cluster_id": "c80e0125-43dd-49de-bff5-42885acf8ee9",
      "members": [
        "d35ddf8f-509b-4c52-bc51-6432c2886d19"
      ]
    },
    {
      "cluster_id": "3d44d914-cf73-4d8b-b531-5db2be83da48",
      "members": [
        "5e75ac83-0e72-4eb9-b360-4f96d0971121",
        "6413782b-b038-491f-9361-f3b3150efa2d"
      ]
    },
    {
      "cluster_id": "a5514e09-1046-4832-bdea-694c3e6ab12a",
      "members": [
        "81fec1eb-625c-4d60-848e-8ca000fd8178"
      ]
    },
    {
      "cluster_id": "48ac478a-0a47-432d-9d71-30bc821691af",
      "members": [
        "c2775da8-b52b-47fb-9ddd-e0656524b475",
        "73b15efc-b9e7-4a74-a59b-6b200ea91739"
      ]
    },
    {
      "cluster_id": "245874be-060a-4ca6-afe3-3a367b00ddb5",
      "members": [
        "f507b61c-a051-4b9f-8bcc-79a61ce65340"
      ]
    },
    {
      "cluster_id": "7b36cbc9-6f57-4b29-9c6b-010607eb3738",
      "members": [
        "88201c49-6ff1-4a02-8d15-a1f664edea3c",
        "dcf03b2f-69bb-4512-a5f4-483f998abacd"
      ]
    },
    {
      "cluster_id": "2c834413-ef2b-486b-81d5-2e0a687a8ca7",
      "members": [
        "04433bf4-0d2c-484c-877f-9d4f6cb65107",
        "f7fb6eba-fa20-46e4-a4e0-5a755dd9a270"
      ]
    },
    {
      "cluster_id": "d7cbd37c-10fd-4628-bba8-b434c41ec43f",
      "members": [
        "dec9b0ba-c532-47d5-8062-bbd1bbdefe52"
      ]
    },
    {
      "cluster_id": "1e74d1b1-7b73-446d-b88a-11111e499ad8",
      "members": [
        "c7ad5ae6-dbaf-494c-95a5-b46572ceca18"
      ]
    },
    {
      "cluster_id": "a6506a53-789c-4447-b726-b2dd59d9b862",
      "members": [
        "3369d430-f133-4800-9272-9d969929d67b"
      ]
    },
    {
      "cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "members": [
        "b018fbe7-8544-4332-ba21-4950fee2f922",
        "cac625ec-a0cd-4362-931f-e60127b9e0ed"
      ]
    },
    {
      "cluster_id": "f3072807-ef6c-4e5e-9a52-03328278d096",
      "members": [
        "14c32bd5-bf4c-4bf5-b6f5-b4ddde7d9f78"
      ]
    },
    {
      "cluster_id": "7e639892-5cda-4557-94c4-87321bdc3233",
      "members": [
        "3653bbad-8aae-4826-90c3-81bdda889097"
      ]
    },
    {
      "cluster_id": "bbe7fdd5-62f8-403f-97fb-16e838e19a59",
      "members": [
        "193284f7-14c5-4d9c-8e56-212c1cd17dca"
      ]
    },
    {
      "cluster_id": "bdb0efc8-0563-4b0b-a277-072e3cddd7c6",
      "members": [
        "3de76f19-d665-499c-b2d1-33d77a838ea7"
      ]
    },
    {
      "cluster_id": "5d657ce1-e484-4e48-b720-f4927cd733dd",
      "members": [
        "81d51f18-45dd-4f7d-8b21-0ae61754d57a"
      ]
    },
    {
      "cluster_id": "7781df4b-26ca-4879-a33c-cb83ade5ffa4",
      "members": [
        "eb61dc70-90a0-40db-8941-a5be8f6affa5"
      ]
    },
    {
      "cluster_id": "2dc250b5-58d8-4c44-80d2-2c17640ea117",
      "members": [
        "4993cc01-a9e2-43b0-9a24-1d572dcdf1e5"
      ]
    },
    {
      "cluster_id": "9bdb548d-7392-42e2-81f0-dc3db0c2af7a",
      "members": [
        "ba515b0e-2ea1-4f9d-8ac3-eb487cfd4c69"
      ]
    },
    {
      "cluster_id": "0dc504d4-9f05-4936-a43a-c912683c5ac2",
      "members": [
        "0f4a0a6b-c03f-4344-8e82-0fefbe066b38"
      ]
    },
    {
      "cluster_id": "11c93b57-586c-4cef-a254-66245b297aca",
      "members": [
        "aaa7a3f5-0c20-41cd-9c54-34a21db87608"
      ]
    },
    {
      "cluster_id": "df65bddb-06ed-4815-9cbc-5ae170dbdeae",
      "members": [
        "c1469c73-28dd-42f6-86eb-7b0123a5227a"
      ]
    },
    {
      "cluster_id": "25c37968-26df-4a13-8b6c-ef9270b22369",
      "members": [
        "e872ee90-7ce1-43db-9954-5bc1e98c9578"
      ]
    },
    {
      "cluster_id": "5a140171-9551-46fb-8eb7-bce434648b1a",
      "members": [
        "05408880-be0b-4ed1-86ef-1a7deb3941ab"
      ]
    },
    {
      "cluster_id": "dc9039b4-da9a-4fd0-b97d-d822536a716c",
      "members": [
        "233438ff-e7f2-403e-8e79-4a6bb8a95a7f",
        "83761374-b6a9-40c4-8a0b-42763aea2d5e"
      ]
    },
    {
      "cluster_id": "09505049-ee83-46bc-bc41-216c4501ccc0",
      "members": [
        "2c80d572-cce5-492a-8922-2b19c8b63ed5",
        "910f325a-ceb8-4483-be45-d62d7acc3a6d"
      ]
    },
    {
      "cluster_id": "c68ce84b-91a0-4925-97f3-1ea49e062e4b",
      "members": [
        "c462a189-d702-4e43-900c-b57b899d6a89"
      ]
    },
    {
      "cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "members": [
        "9866bac3-581b-44b6-a4e7-1ccf90d18b98",
        "b627b333-6038-4054-b5e2-0d4bc1e27736",
        "18442cdf-bce1-43b8-99ea-d8e0429ad039",
        "0394f585-476b-45c6-9515-ea451b79ccc9",
        "0c55e31a-c6b6-4d90-8886-b06d2e9921d6",
        "368de859-722c-4662-9e5d-083bd074caf0"
      ]
    },
    {
      "cluster_id": "11e43ecc-22c8-4f1c-b13a-fb97013ce963",
      "members": [
        "ceb64b6b-cce2-4980-bae6-4c893cfb2657"
      ]
    },
    {
      "cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "members": [
        "e3977b85-1616-4434-91bd-a8e84a7e71b9",
        "57ceec33-a712-42be-83b1-0bbe6b69f3a2",
        "ddc2535e-ae0f-434b-9768-1fa0764dbb0b",
        "74724b14-e8b2-4ed4-bbdd-94566006218f"
      ]
    },
    {
      "cluster_id": "411175f7-0ca0-4fb5-9db2-35822ef1cc0a",
      "members": [
        "d98b2bbe-53e8-4b9d-99fe-b714fa78c6a1",
        "c3af0855-cf17-4b0d-bcda-fad670ded500",
        "d552adef-ca70-4aee-9e7c-8fc83a25e7b4"
      ]
    },
    {
      "cluster_id": "5fb2043e-87e6-4ef1-829c-b51f962dada4",
      "members": [
        "bb7e0a93-6331-4144-a49f-07b27be8f1bb"
      ]
    },
    {
      "cluster_id": "5e700671-a24a-4c8f-a1e4-abbfb82f4537",
      "members": [
        "f1f60f4d-ae9a-4af1-bdc6-5c28c675e4e7",
        "20a51398-2fc5-4cc1-a831-7e135590681f"
      ]
    },
    {
      "cluster_id": "41369b57-1c08-440a-90c0-cacb7036a45e",
      "members": [
        "45677884-cbf5-46a5-936a-122af027af00"
      ]
    },
    {
      "cluster_id": "762409bf-96e2-43cc-99d8-45783ade1b1f",
      "members": [
        "0a9e01ca-6f1b-4017-a2c9-7527acdec277"
      ]
    },
    {
      "cluster_id": "9be5c43d-4ef1-465d-bdbc-ed35d95c0689",
      "members": [
        "4b4a0932-dd70-4145-9d99-b56763fa9e6d"
      ]
    },
    {
      "cluster_id": "20030c5c-45db-460b-8663-d9950dc53ebf",
      "members": [
        "34b5c643-06c2-4d4e-849b-fb77fb222019"
      ]
    },
    {
      "cluster_id": "f80dd275-a1a9-4cb7-becc-0fe298aae99d",
      "members": [
        "42a495a0-a980-41f2-bb9e-8a49e07109ea"
      ]
    },
    {
      "cluster_id": "8038fcc7-29f8-406c-90cf-ee3b351c6e15",
      "members": [
        "54df3866-f27c-4239-854a-62593827f591"
      ]
    },
    {
      "cluster_id": "1ff9104e-969b-469f-b204-88f04894d01f",
      "members": [
        "a2c70ee5-60cb-4bd3-bd27-1bfac59c5f91"
      ]
    },
    {
      "cluster_id": "86bae394-d674-498b-bd18-aa3046f40d19",
      "members": [
        "c8e7ced0-a72f-40a8-9ffa-8d8e90f67878"
      ]
    },
    {
      "cluster_id": "5aec5e12-6df7-45c2-ae07-2921310e080b",
      "members": [
        "ffd2327f-eff8-4537-9fa3-7c52a960359e"
      ]
    },
    {
      "cluster_id": "b5b35a39-f79a-45e8-82ea-b87d21bbba55",
      "members": [
        "de542820-8e61-478a-b085-807e52df765e",
        "5602148c-549e-4749-84e9-dad0aa357385"
      ]
    },
    {
      "cluster_id": "c6e50b1a-e795-43fc-baca-c835ba2bf14d",
      "members": [
        "2ddf7483-37b6-4da9-8291-aa683603eba5"
      ]
    },
    {
      "cluster_id": "a604c242-b8d1-4d4c-9595-5b1b3d840615",
      "members": [
        "af9ecaff-9f51-46a1-964b-f7f8865e5396"
      ]
    },
    {
      "cluster_id": "04938aaa-1985-4664-bfb5-337fffd62a6d",
      "members": [
        "78087ce5-01cd-4ea3-9764-26eb8b921ac4",
        "5ab140aa-857e-442d-bd98-0f4a3815b9bf"
      ]
    },
    {
      "cluster_id": "d20d47b3-a32a-48d4-a8d3-2dd3f07fe8a9",
      "members": [
        "6fcfcac3-6577-4f54-92dd-bb0e59016086"
      ]
    },
    {
      "cluster_id": "bdecd7b0-3449-4d8c-9710-468d872a6514",
      "members": [
        "f3f5217f-6ca7-4200-bdcd-07ad60e389de"
      ]
    },
    {
      "cluster_id": "e0b3b058-f41a-4ebc-b9bd-9e20a141c340",
      "members": [
        "77d2c66e-db4e-46a3-9b25-701be6bf0a1a"
      ]
    },
    {
      "cluster_id": "8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4",
      "members": [
        "e735ae93-8403-47f7-ad21-b5fede472cc1"
      ]
    },
    {
      "cluster_id": "94ea82f9-8fc1-4541-8fab-b8354c3ea8f2",
      "members": [
        "40acff92-a9e7-4df1-8fbb-1317803213f9"
      ]
    },
    {
      "cluster_id": "d5ad62ab-dd96-48fa-a092-0724cb0c06f6",
      "members": [
        "289ce0e0-96f5-46dd-b968-e6e5fd75650f"
      ]
    },
    {
      "cluster_id": "5ee6d6d6-e296-4f40-9760-4a7737f5c631",
      "members": [
        "9d9af1dc-5857-4a45-8ad2-0b4979470695"
      ]
    },
    {
      "cluster_id": "5e128621-af42-4a93-b091-b4e768efec3b",
      "members": [
        "88c2bd39-5a95-4132-9c00-18006843878f"
      ]
    },
    {
      "cluster_id": "6dfdb047-f69b-420b-87ec-fbcb72244cc6",
      "members": [
        "c92063e1-297a-4953-abf7-9af0a32311d4"
      ]
    },
    {
      "cluster_id": "93459608-ccd3-4b8a-af7b-ede8b22e8c94",
      "members": [
        "7562f876-6caa-4f14-adc5-02abd33e5e84"
      ]
    },
    {
      "cluster_id": "53536317-4b6e-4e5f-bcd2-6b2bb3ef9bcb",
      "members": [
        "4dcf71f4-ff2b-47b2-9b83-ba2022cf36fe"
      ]
    },
    {
      "cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "members": [
        "0a5b80f4-cd56-4ef9-a369-8d29c328313a",
        "067bb5eb-6d31-4dfa-8cbd-19615eed89ba",
        "ed2e0bed-abfb-497c-9ffb-c5fd005a4278"
      ]
    },
    {
      "cluster_id": "6222d4f0-7c6d-42f0-83ec-17412b1907f1",
      "members": [
        "f06ee571-4c93-42ba-8e35-dcb8339992b5",
        "b3320e18-5e27-4a98-bfb3-9b8a18694f71"
      ]
    },
    {
      "cluster_id": "cfa086e7-654e-40fa-9e14-980617b91e89",
      "members": [
        "5ffa6906-1c8b-4f02-b90a-9e7356ae8163"
      ]
    },
    {
      "cluster_id": "891e1da4-bfc6-4524-a5da-153bde60b165",
      "members": [
        "b150f9d3-20fc-4b13-9330-c4f66fc45e9b"
      ]
    },
    {
      "cluster_id": "22ca72b9-d5a1-4be2-9dc0-99fc0a38f586",
      "members": [
        "9f33a3cc-c5b6-4b80-abad-3adf992755cd"
      ]
    },
    {
      "cluster_id": "da4ff089-352e-46ec-bdf8-8e7b8cd2001b",
      "members": [
        "889531fc-03cf-4189-a945-48d098826533"
      ]
    },
    {
      "cluster_id": "4313d034-31f9-4eb9-9451-e9a5dda6e7c3",
      "members": [
        "b67e8f06-39fe-49ef-a8cf-d1df4128b1d9"
      ]
    },
    {
      "cluster_id": "d6145953-8619-428f-9b84-07cd47d4180d",
      "members": [
        "e3b5f6d2-bcc8-42bb-abf6-885b09b78db6"
      ]
    },
    {
      "cluster_id": "f6aedae8-b368-419e-9158-abbe718748ba",
      "members": [
        "eddc3e01-3718-471f-9ea7-07626e7057d3"
      ]
    },
    {
      "cluster_id": "f20df5bd-42ea-43d0-88bb-1d05f549a0e4",
      "members": [
        "96a77054-65e6-45ff-816a-ab1b898675c7"
      ]
    },
    {
      "cluster_id": "452589b4-0af9-45d5-aee2-979a0dc78876",
      "members": [
        "fe000069-812c-4507-9580-f8eecbca392b"
      ]
    },
    {
      "cluster_id": "90ef35f7-8880-490a-bacc-f600f6a11162",
      "members": [
        "01be4f38-f05b-4974-bcab-e5868299420e",
        "f38bbeb4-28fa-4f3f-9d83-3c9ccda84be2"
      ]
    },
    {
      "cluster_id": "6c51a8d1-6797-4e1d-8707-408a46a11bf5",
      "members": [
        "ed833d09-6dc2-41d6-a4f9-da435295c537"
      ]
    },
    {
      "cluster_id": "807e0902-55ee-4c2b-a271-40fd2fb58b9a",
      "members": [
        "b1accada-093d-43c5-b7d3-eb04ececbafc"
      ]
    },
    {
      "cluster_id": "5c7c452c-db3f-4741-97ef-77d49e8c75b4",
      "members": [
        "02271f73-601f-4078-938c-805a4a8122f7"
      ]
    },
    {
      "cluster_id": "2ebece0c-e502-49a9-94b9-5df90f1b8e51",
      "members": [
        "5c7d6b44-a281-491f-8148-2f39874c5f2a"
      ]
    },
    {
      "cluster_id": "221f2ccb-c412-4e42-8d5c-82e681a61d32",
      "members": [
        "87659b3d-071c-4a7a-879b-c621f1f0beb7"
      ]
    },
    {
      "cluster_id": "4f63d722-2816-4701-89a0-6f6efadc8656",
      "members": [
        "1b25182f-7fc3-479c-936a-a502e7c94512"
      ]
    },
    {
      "cluster_id": "14ffc7a5-e5c3-48de-a2b4-8b721ff34fcc",
      "members": [
        "d60fd050-3d43-4907-9ee7-1da0bace65fc",
        "2e65a4c7-e471-453a-a9b4-5828f81768fc"
      ]
    },
    {
      "cluster_id": "34e272f8-beb9-408f-a252-0fa71406dc4b",
      "members": [
        "69a71a83-cb79-4f88-bb44-d17e73bf92b5"
      ]
    },
    {
      "cluster_id": "1b5c8541-b848-4f05-865e-43826009d4e7",
      "members": [
        "392e62a5-a7ec-4cff-9b0d-efb168c40742"
      ]
    },
    {
      "cluster_id": "16b63ffa-da4e-4cff-8fab-fffc1644a634",
      "members": [
        "2c6f1134-01fa-47b0-a16a-d57885b322f3",
        "4b4a656e-4325-448c-8c08-e151c7fbb241",
        "2a9844d1-065a-40c8-8cb6-dbf1cf798ff3",
        "fa8fb0cb-387d-45bf-86da-e5a93f6424e0"
      ]
    },
    {
      "cluster_id": "d017f7be-45ae-4ae5-b72e-a6e53f0a589b",
      "members": [
        "8de2fe6b-bd0b-41b8-80c5-eac870b0af94"
      ]
    },
    {
      "cluster_id": "595531c2-a2b0-4686-b3ae-4f5525fff05a",
      "members": [
        "798f64cb-f98e-4285-8fc3-cbd95f21d6dc"
      ]
    },
    {
      "cluster_id": "5f9b6057-0fab-4c3c-b1af-a7c26bc6c692",
      "members": [
        "ec7648c0-1878-4b80-b6e5-468857c5bba1"
      ]
    },
    {
      "cluster_id": "3ea6c360-e1ff-4b61-9454-07814cabc76c",
      "members": [
        "82943bb5-0b2c-42cb-8f02-07bfc2b2a864"
      ]
    },
    {
      "cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "members": [
        "4ff72245-dfa8-4c0a-90fe-ddbab51a81d8",
        "2104bd63-b9b4-4456-a8b8-646d0cb147b4",
        "bb0ac974-dba1-485f-85a8-d2f0f99db330",
        "106355c0-5f33-4152-9329-80d8cd93fd91",
        "75e6a60a-f387-4967-b042-d1c6fd158f36",
        "155b3063-7f23-4da8-a16a-a89ff2ce42c7"
      ]
    },
    {
      "cluster_id": "ab5ca9cd-1ca3-48b3-9ae1-79a096d75528",
      "members": [
        "28a54058-7a57-4a0e-85d0-fc580597c4f4"
      ]
    },
    {
      "cluster_id": "33a57504-12fb-4d65-b0de-90b983174e92",
      "members": [
        "6753501d-2f93-403c-9300-5cc88e1ecc45"
      ]
    },
    {
      "cluster_id": "554fbe05-7cef-438d-8e82-567521788239",
      "members": [
        "c0530f11-be82-462f-b78b-57dcf8002039"
      ]
    },
    {
      "cluster_id": "ded98049-aef1-4b4f-a8a6-f68c10032b7f",
      "members": [
        "2dbdd359-30c0-4687-ab3d-23d20ba5cbf3"
      ]
    },
    {
      "cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
      "members": [
        "c5e5d18b-d348-4e0c-8c43-be2146e4789a",
        "6ba3f0b0-cccc-4453-9c4e-7dc9f180b7cb",
        "53a637cf-5570-40f1-b152-4d36671c4e62"
      ]
    },
    {
      "cluster_id": "e9d22d46-e0d1-45b7-b109-afc6516146e1",
      "members": [
        "ab25bbae-f9d9-4b71-bf3f-ce806d3eba25"
      ]
    },
    {
      "cluster_id": "c462838a-420c-4b5a-ad06-676939effe93",
      "members": [
        "7b1d64ea-3527-4de0-afd8-f30cb3a3f6b2",
        "ad7a9f0d-ae4f-40bf-bf11-ecd7d8e1a2cf"
      ]
    },
    {
      "cluster_id": "235bfc4a-e3f2-4850-83c2-a78043ab464b",
      "members": [
        "5746bac5-cac0-4591-bd14-cfe7908c85e4",
        "4e631d9f-285f-4597-9acc-f7fcd2a9c064"
      ]
    },
    {
      "cluster_id": "cf399998-137e-4270-8827-7c726197fb9d",
      "members": [
        "f6852e30-eb47-4b31-9574-a6facc863694"
      ]
    },
    {
      "cluster_id": "281fca06-ede2-40bc-9960-0788b1d20c23",
      "members": [
        "25488b47-121d-4640-889a-0eccad4f7acb"
      ]
    },
    {
      "cluster_id": "e9280ed1-20ec-4c75-8468-086e8c6749dc",
      "members": [
        "d05dc0bd-af7e-4d32-b6fa-034e06e5dae9"
      ]
    },
    {
      "cluster_id": "8d550fbc-5131-4294-a815-b9e32f81ad7a",
      "members": [
        "e71c2431-fd9d-430b-bbd2-c346441cb17d",
        "736c792b-c93d-4f63-a5ad-4cc89227466a"
      ]
    },
    {
      "cluster_id": "c7013046-8aa1-434c-87b8-1e3317f5578c",
      "members": [
        "1eed8ff7-d96d-4ada-8d10-b3124028ee33",
        "2a60862f-4676-4117-a700-51ec4db2da9b"
      ]
    },
    {
      "cluster_id": "64f152e4-be60-464e-a365-613ea259a5ff",
      "members": [
        "0d5d8f08-3d5a-40ce-af4f-0eeaad84a52d",
        "bd9fc77a-0eef-4c3a-ab91-047c2568670b"
      ]
    },
    {
      "cluster_id": "e3489bfa-95e8-439b-81da-6d84615a5721",
      "members": [
        "8292cee2-686c-42df-af55-b1d8e0ec513c"
      ]
    },
    {
      "cluster_id": "1c5f9ea9-d432-4800-9abd-5af5c927568b",
      "members": [
        "e33db651-3b18-40cc-abe4-da9191e830ca"
      ]
    },
    {
      "cluster_id": "bd4c7f11-9866-4656-98e3-7341cfc6de34",
      "members": [
        "d2e525d7-93c0-42eb-8360-af54760ae196"
      ]
    },
    {
      "cluster_id": "4b18f200-0ad0-4f45-9303-c7be1cc1c733",
      "members": [
        "0621bcc8-1579-4145-9367-cf14065d6b3a"
      ]
    },
    {
      "cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "members": [
        "6ff0ed8a-2510-4702-9d75-236dac0a0ea5",
        "56abb7cb-a819-437e-a5cf-51e900a41396"
      ]
    },
    {
      "cluster_id": "0f8d7640-e263-43ac-9294-0e526087824c",
      "members": [
        "c4be645d-460e-4708-b037-487f1c5d2f7e"
      ]
    },
    {
      "cluster_id": "9314aa75-84de-490c-95e7-6484ecdba212",
      "members": [
        "9b2a3bc3-989c-4621-b60e-7f9263e54455"
      ]
    },
    {
      "cluster_id": "ce4379b5-864c-4150-b826-c6825e39d887",
      "members": [
        "63f2ea7d-e8c7-4351-a711-efc2f02fc18b"
      ]
    },
    {
      "cluster_id": "2fe163fe-8ed3-4202-aad1-5f84672917c4",
      "members": [
        "f9a8a051-545e-4ab8-a8c8-6daa315e10c7"
      ]
    },
    {
      "cluster_id": "7eddd539-ebe9-47f6-b0c9-dd9f02f0c8a0",
      "members": [
        "2622c55c-6dc6-492e-9c76-fed941e88b72"
      ]
    },
    {
      "cluster_id": "7b1c03fe-e3e1-476b-ab84-c44a6ea52022",
      "members": [
        "76d2576b-bd1c-4b74-96f5-01ee074a5934"
      ]
    },
    {
      "cluster_id": "2432e361-2cb6-4e28-a81d-a8ee7dce9c29",
      "members": [
        "64032371-a7ba-48ad-b8b1-18a5ba134b49"
      ]
    },
    {
      "cluster_id": "6910074e-7bb8-4a4e-9f37-3e335d1a57a0",
      "members": [
        "0219cbf1-b872-4528-bd85-cbbe416b80f7"
      ]
    },
    {
      "cluster_id": "457d88a0-1b8d-406f-8eeb-01fdd00cdc30",
      "members": [
        "fca6ac9e-d361-4854-b415-2de0951bc754"
      ]
    },
    {
      "cluster_id": "60269200-21dc-4ddd-bed2-414eb8acfbb9",
      "members": [
        "ae4c6e50-616b-4f8a-bdd5-f4555ae934a6",
        "2b73d0ee-3da7-4a76-b910-a9d437a5f51f"
      ]
    },
    {
      "cluster_id": "992ef0ee-f6fc-4177-b75b-0a3511a615a6",
      "members": [
        "8c0e7cbf-ffa9-4239-bf4a-d8d6df9ac40c"
      ]
    },
    {
      "cluster_id": "1c703565-77f6-4eda-962e-77ec869d886d",
      "members": [
        "5e7bd35a-baeb-44b2-a16d-b60c1df9e9fd"
      ]
    },
    {
      "cluster_id": "ff3f6026-485f-4fce-9d57-b8206b8e11c5",
      "members": [
        "8ae364b3-ce33-47e9-918f-7ffdf3ee8baa"
      ]
    },
    {
      "cluster_id": "20eecf26-3fb0-4e96-b07f-0dfffef9c628",
      "members": [
        "3ba5f1fe-f2b8-4a3f-a50f-c448784241d3",
        "f29187c8-eb55-4d89-9dfa-d5458589188d"
      ]
    },
    {
      "cluster_id": "f42001e5-7364-43c2-8d35-74c3552a9ccb",
      "members": [
        "df300336-658b-4086-ae14-485fb5a34ddf"
      ]
    },
    {
      "cluster_id": "aaf76232-aab7-40b7-8e1a-16d6b39c4f6b",
      "members": [
        "eaad94ff-bd80-4fd8-80eb-73bc91733ef4"
      ]
    },
    {
      "cluster_id": "9a6fa43d-c803-4c20-bac3-545db67a8241",
      "members": [
        "4609b2a2-a2ae-43cc-9923-727688da9367",
        "03bbf6a8-e994-47e1-93e4-0c1992c89568"
      ]
    },
    {
      "cluster_id": "e7287d47-759e-41f0-9641-093ab1e3e04c",
      "members": [
        "0ab31eb2-c453-462e-864c-67db91d89971"
      ]
    },
    {
      "cluster_id": "3da4f222-08f1-4864-8aa3-3576d8a64207",
      "members": [
        "79e0bdee-4367-4ccb-925b-4a68d5d48496"
      ]
    },
    {
      "cluster_id": "b1abd415-ce48-46da-b8bf-36f727bba7c7",
      "members": [
        "4af09982-8d8a-48e3-a946-5daba0922eb8"
      ]
    },
    {
      "cluster_id": "469c5194-5b04-4e90-b62c-73b3f79a0955",
      "members": [
        "7d8d1aea-8234-448c-a5d8-52bb4687e454"
      ]
    },
    {
      "cluster_id": "f9f7a124-b259-44e6-a922-abc880fe6775",
      "members": [
        "892e9d38-0e8a-4b15-85a9-1e6e5b23d048",
        "276d53d4-40d6-4396-bead-e57b8683665a"
      ]
    },
    {
      "cluster_id": "f8d50aad-e630-4fcd-a643-313737fc528f",
      "members": [
        "6edb00cd-67c9-453f-9f97-60afdcd6a42c"
      ]
    },
    {
      "cluster_id": "f5a86628-9ae6-4d94-ad96-d00a9cad52bb",
      "members": [
        "7e807de9-50c0-439a-a289-0edd457e87e9"
      ]
    },
    {
      "cluster_id": "06a88819-5b14-47a3-9604-8a61db70f52b",
      "members": [
        "b59fb6dc-a5bc-4346-969d-2cf675782c1c"
      ]
    },
    {
      "cluster_id": "df0cd74b-d230-4260-9a29-b0bc91923404",
      "members": [
        "6ca8951e-e9b5-4321-8da4-b726da450889"
      ]
    },
    {
      "cluster_id": "325111bb-e15c-4f08-a4a4-3f81e99d9f35",
      "members": [
        "9fb6cd45-2db9-43c8-9bc3-0779b7469d45"
      ]
    },
    {
      "cluster_id": "06f63413-3561-4a53-933b-589b1f942c37",
      "members": [
        "b8f71142-3e18-4304-8070-e5d6d08b296a"
      ]
    },
    {
      "cluster_id": "64b43278-d723-4b63-bcf0-181e1a1658f9",
      "members": [
        "47e640c2-82eb-4653-92e5-07ae59509b76"
      ]
    },
    {
      "cluster_id": "29c6f9fc-e1e6-4dfe-a45c-59ee8d9a4489",
      "members": [
        "3f97382e-d99f-450a-9369-8adbeb773ecc"
      ]
    },
    {
      "cluster_id": "837dbefb-7b54-4aa1-aad3-56f0ea97f9ed",
      "members": [
        "52c8222b-3d76-46e5-b60a-b85f3c7baf1d",
        "183d0198-9ef2-4007-8324-b1d156ee1306"
      ]
    },
    {
      "cluster_id": "47fbc359-0497-4aac-8a4b-e63bd060a1e2",
      "members": [
        "1df7f2a1-fccc-4c21-b7e4-88712ef38283"
      ]
    },
    {
      "cluster_id": "ccc50930-0ce2-4cb5-aa76-281b7202368b",
      "members": [
        "6c5f9c30-c193-49c0-b20a-6f45e386c7ed"
      ]
    },
    {
      "cluster_id": "a837b2bf-502e-4024-b245-761701b0a6d5",
      "members": [
        "9e080cc5-5797-4083-b742-3b096c9ce450"
      ]
    },
    {
      "cluster_id": "1c1848e6-9c28-4252-9e24-4dc5cb477be6",
      "members": [
        "534931bc-6d69-4c7a-ad1d-821a8cd2f627"
      ]
    },
    {
      "cluster_id": "7c2161be-91e7-4c74-9f49-fb997b3c5857",
      "members": [
        "fa70beaa-6f87-4adc-9813-f283ce73b91e"
      ]
    },
    {
      "cluster_id": "5e0fea08-89fc-42fe-8906-484d762a1714",
      "members": [
        "94b33dd3-107b-47a2-b91c-ae0845ae8039",
        "f525332a-aad7-4bd1-ba01-a81435bda985",
        "5555a3e9-f056-4401-98d7-334e7c38bed0"
      ]
    },
    {
      "cluster_id": "468c9eea-e420-4271-9b73-0e2e747f6185",
      "members": [
        "5000ccbe-1bb2-47e0-ba91-d263e7a46419"
      ]
    },
    {
      "cluster_id": "f636e358-668e-41dd-bffc-037f53b4ab48",
      "members": [
        "baa77af1-ba9b-4659-b322-e5de504c6178",
        "ea0ea37c-cb3a-4795-b344-da65b07ff1dd"
      ]
    },
    {
      "cluster_id": "6d2a1320-d829-403b-913c-d7cdbf1cbf14",
      "members": [
        "7c6ad0f4-14ce-4d78-94d8-83ef080fb481"
      ]
    },
    {
      "cluster_id": "9028c8ac-b264-4318-be25-6d627ad54b1d",
      "members": [
        "138995f7-0879-442a-b0d2-b865adc91c1d"
      ]
    },
    {
      "cluster_id": "3200fc3a-bd08-4faf-ac3c-69eb812ef575",
      "members": [
        "40a982f6-97dc-40a4-87ee-10c3678e2aff"
      ]
    },
    {
      "cluster_id": "58b4a566-79d9-4559-809f-ffd9a84468b4",
      "members": [
        "d827bf21-86e5-4fb1-ad29-39bfc2d54d43"
      ]
    },
    {
      "cluster_id": "a8aabd5b-4955-40cb-b78a-086cb1601de5",
      "members": [
        "c58c1e7a-b29c-4ec9-b3ef-3537279058d8"
      ]
    },
    {
      "cluster_id": "daf13a88-450f-40a7-bca6-ccfb46ede159",
      "members": [
        "c4719ddf-1f52-4f07-bb29-0d833c19f06b"
      ]
    },
    {
      "cluster_id": "ac1a90d2-3517-43fd-8e60-dd7d570db743",
      "members": [
        "7b51a335-2503-469a-88f3-cda13616b9e8"
      ]
    },
    {
      "cluster_id": "3de3b456-a38d-41d1-85eb-8ea198492839",
      "members": [
        "e000b420-269b-448c-a2f7-943c5b34854a"
      ]
    },
    {
      "cluster_id": "9b2175d9-8d49-4d83-857c-16d8550ab216",
      "members": [
        "4a53148d-ff1c-426e-8962-939234581f1f"
      ]
    },
    {
      "cluster_id": "2ee00586-87af-465c-8466-d1bc41c3886f",
      "members": [
        "ee505ac3-6796-4bb2-a0ed-5d00cdc42d4f"
      ]
    },
    {
      "cluster_id": "fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec",
      "members": [
        "11105bb6-ed0f-4fcd-a9eb-507388a5e2c6"
      ]
    },
    {
      "cluster_id": "1d1fb1a1-0351-478a-ac00-eb42c21a03d9",
      "members": [
        "4a03d036-31bd-4d0d-bdc1-010d2be0e2a4"
      ]
    },
    {
      "cluster_id": "8cb0435b-3218-46a5-88b4-47481d4dee85",
      "members": [
        "dea84b7d-89ec-48fe-bb58-8ba341aee989",
        "6b296eea-2fd8-472f-9fea-997008bc21b3"
      ]
    },
    {
      "cluster_id": "f7c875b0-a0b4-45f6-b382-0915f179b2e6",
      "members": [
        "a0cf568d-cab6-4149-85ef-a7ace346f042"
      ]
    },
    {
      "cluster_id": "89d1d1b7-a65c-42c4-be89-c592ae13b6a1",
      "members": [
        "5197f13c-5955-4609-a641-0d2e9825af37"
      ]
    },
    {
      "cluster_id": "ab829976-d7fb-4b30-9b92-89eed4e94cc4",
      "members": [
        "4fb0c3bc-6136-4ead-aa3c-701399394a77"
      ]
    },
    {
      "cluster_id": "043b0606-561e-4868-8354-4c45ee5a2f95",
      "members": [
        "efaff54b-9926-441a-8582-c63bcf40ee5c"
      ]
    },
    {
      "cluster_id": "4df0c9e7-49c0-478b-aeb5-0b3833932e62",
      "members": [
        "33b4407e-d332-42ad-91c7-64004f5a7b83"
      ]
    },
    {
      "cluster_id": "7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9",
      "members": [
        "2c901d23-150e-4236-8a3a-50459096c99f"
      ]
    },
    {
      "cluster_id": "a0d6a00c-f05d-49fd-9f81-54bc418a2aec",
      "members": [
        "d9be58a0-d2d3-466d-8ef6-4dda4cadc6fa"
      ]
    },
    {
      "cluster_id": "d9041723-b3d2-4f6c-85e6-435010ef6231",
      "members": [
        "4b6aefc8-c4b5-4a7d-8b0f-634abda80c7b"
      ]
    },
    {
      "cluster_id": "a5114ace-99b6-4b39-875b-8b7056c70002",
      "members": [
        "d32bd84c-757a-4910-a052-31805fd4d204"
      ]
    },
    {
      "cluster_id": "0e225927-1e3a-42e7-9ee8-7f9c2bae0dc2",
      "members": [
        "0928ff9e-d79a-4243-bd9a-1c711d3e7e2c"
      ]
    },
    {
      "cluster_id": "c98491ce-51cb-40b0-93ae-d389e1c9d7a5",
      "members": [
        "09595d71-6353-4b5c-9c69-95f7da285a30"
      ]
    },
    {
      "cluster_id": "470bd6d3-39cf-4a39-9a1c-be6c638cdd0d",
      "members": [
        "2da32b38-298f-4187-9aef-c0fdd8659496"
      ]
    },
    {
      "cluster_id": "dfa7b9d2-5920-4d57-8445-e48ac5ce73da",
      "members": [
        "d5b18d91-f404-42c4-9bbb-59aaf2defba4",
        "a5966d2a-f407-47e3-8a42-4a1282f0e485"
      ]
    },
    {
      "cluster_id": "4f331c05-6fa5-4bd8-adc2-5458e8c80843",
      "members": [
        "451ce3f4-9e07-474d-a871-c38155df8b9c"
      ]
    },
    {
      "cluster_id": "3e505b9a-116f-472b-bc43-8ee1a23943f5",
      "members": [
        "5f1e3bac-6dca-43e4-8fd4-6f7088dde238"
      ]
    },
    {
      "cluster_id": "bac292de-05f4-4fd3-a4df-f073c8f09553",
      "members": [
        "872fb8c6-d9b3-4096-a4f8-dcf966b50b66",
        "66ced45a-b323-4e56-a143-2292b8db962f"
      ]
    },
    {
      "cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "members": [
        "fff5600f-7263-4f2a-a699-8321f3952aa5",
        "41762dec-9af9-454b-a084-74fdb6d5933e"
      ]
    },
    {
      "cluster_id": "cd8495d7-023b-4c43-b6e6-6e4c88a0cd79",
      "members": [
        "8b19bb1f-9fef-43b2-bd11-62c825845e92"
      ]
    },
    {
      "cluster_id": "e2d7dae8-0d86-4de0-93de-0fca88fdbecd",
      "members": [
        "da752397-c4ec-4920-9b38-287c09c8e89b"
      ]
    },
    {
      "cluster_id": "d0814fdc-170f-48fa-8def-5a656118ed2d",
      "members": [
        "d80dd363-e12d-4d2f-8f1a-db6890357214"
      ]
    },
    {
      "cluster_id": "68617739-11a1-4108-8d8c-6d8db53fd247",
      "members": [
        "2e492606-e466-48b4-aedc-a8ac48cd73cf"
      ]
    },
    {
      "cluster_id": "489e26fc-76fe-4cad-b09b-b941f099b2bd",
      "members": [
        "09bec78d-5110-4d94-8abd-ca8fbc8d8f34"
      ]
    },
    {
      "cluster_id": "bd6de2da-8b5f-4e38-83bd-28294e175aca",
      "members": [
        "9cfe1e4d-1693-459e-9c1c-c014e781555f"
      ]
    },
    {
      "cluster_id": "c02665b8-8535-44f4-96b2-764b54985f66",
      "members": [
        "33b7ef54-4581-4500-860a-a13826f64a39"
      ]
    },
    {
      "cluster_id": "5a6d9d35-00b4-429a-8850-2262dfa520df",
      "members": [
        "b3eff245-6e8e-462c-8370-fca16fc417ee"
      ]
    },
    {
      "cluster_id": "427b0ddc-d215-4989-8bcc-336ea7f1f9cd",
      "members": [
        "0f32623c-391f-42b0-9618-700e47645440"
      ]
    },
    {
      "cluster_id": "f236d68f-fe39-4432-9a36-341eb8900ee6",
      "members": [
        "787f85bb-e1f6-4800-9a1a-2a143f27635b"
      ]
    },
    {
      "cluster_id": "b8c8cd38-7dea-46d6-b8a1-7316916dd462",
      "members": [
        "4db4f4b2-6be4-43ee-b0e9-6950caea365c"
      ]
    },
    {
      "cluster_id": "469a2781-0070-451c-bc21-b7ee2b0da3f0",
      "members": [
        "1c59d865-0600-4652-bd1b-24003bbf9063"
      ]
    },
    {
      "cluster_id": "8468be9d-aa33-430a-a3f3-b08169c7651a",
      "members": [
        "a8898146-49d8-4213-a28e-7646819d8e37"
      ]
    },
    {
      "cluster_id": "650bbf0e-b896-4929-a2ae-2f9899d4868f",
      "members": [
        "7e9ce10c-485a-40aa-9db8-80a972b9f762"
      ]
    },
    {
      "cluster_id": "6606b076-6fdd-4a94-a7c5-b6bfc5191980",
      "members": [
        "0ac9f2c5-f7be-4379-9ba5-d77b1f76eda0"
      ]
    },
    {
      "cluster_id": "bba799e9-6e80-4ce6-b96c-fc89b2b8200c",
      "members": [
        "6e278d9d-efbf-4498-83fa-1fe9f5c2e1ef"
      ]
    },
    {
      "cluster_id": "43fb6e85-e148-46ac-99f5-6e9cc985487b",
      "members": [
        "fb06f2e9-4a84-4eec-9327-1e0ec4232f45"
      ]
    },
    {
      "cluster_id": "04ba7876-53cc-44c3-8149-fe7ba435f124",
      "members": [
        "cc86da79-f5da-4544-b667-9acac7afd2d7"
      ]
    },
    {
      "cluster_id": "77de864b-c2fe-4a23-a506-d0665b0f08bf",
      "members": [
        "6df9da21-3633-4a31-899a-c18d5a69ac05"
      ]
    },
    {
      "cluster_id": "d14315a8-aa93-4c64-a42e-a4307dd0814a",
      "members": [
        "9372ddb4-9364-4499-a45d-a91c3a32204a"
      ]
    },
    {
      "cluster_id": "4f2be876-d890-4fd4-a767-3f52bbc9c4c4",
      "members": [
        "6cfd4a3d-ea37-4a6a-b31d-f33126fb7074"
      ]
    },
    {
      "cluster_id": "b877e703-7bf9-4587-919b-bf207b22c607",
      "members": [
        "a57a7b65-84fb-4307-87f7-edd4e6d83093",
        "be5ca216-b212-4b53-8373-356a889d9f75",
        "1dcbd6fb-23d1-4f37-8d0b-c3715e918db3"
      ]
    },
    {
      "cluster_id": "d5e58122-8595-4ce1-b4a3-aa9160204856",
      "members": [
        "0ea2c3ce-0390-4a37-82e7-05c488f9d60e"
      ]
    },
    {
      "cluster_id": "86ef5628-f267-4ce6-97b4-2f06bd91a5fa",
      "members": [
        "3ac17d3b-d75f-40de-9ab2-25772920000d"
      ]
    },
    {
      "cluster_id": "147befcf-c605-4967-82de-77dc8f9513dd",
      "members": [
        "84a41b1d-8742-4138-a07a-b4c11ec752ea"
      ]
    },
    {
      "cluster_id": "9367c0e9-bbdd-4398-9de3-210a1f73c88e",
      "members": [
        "7afe7a05-2d10-4c12-9bcb-b81942115741",
        "53402c0f-23bc-425f-b153-ce081085ebb8"
      ]
    },
    {
      "cluster_id": "516e99dd-d52c-4f12-8e2e-b0ba0e0b515d",
      "members": [
        "a81e0dc4-7ff4-413f-b7e8-35e9f1f338bf"
      ]
    },
    {
      "cluster_id": "6c812e58-19af-4264-b856-e922307ab466",
      "members": [
        "9ef16cc8-7e0d-46af-be53-ad39ca0f324d"
      ]
    },
    {
      "cluster_id": "b7190356-8b3c-4107-b9f7-680aa8b73b90",
      "members": [
        "16eaef10-f0e6-4c6a-aa10-29e89fbc15cd"
      ]
    },
    {
      "cluster_id": "e2a085c3-49f3-4799-87cc-2b59f85d4bb4",
      "members": [
        "a039a1cc-be4d-41c4-9557-fd273854d9a9"
      ]
    },
    {
      "cluster_id": "a7d1cc33-aa3a-4ee3-86f6-065986a716af",
      "members": [
        "1c8b8a47-732c-43bb-bdd5-1258d42e81d3"
      ]
    },
    {
      "cluster_id": "226f9322-c9c6-4f2f-948c-b45757d94aa7",
      "members": [
        "3b1e8ff2-88e8-4208-84df-1b20791750f8"
      ]
    },
    {
      "cluster_id": "8f273fa4-f8bd-4413-8ce1-7183b77e2566",
      "members": [
        "7d507146-82d8-4c8a-bc28-2ea93cb69515",
        "129eda25-7e65-4bd7-85d2-2cbf45fb11cf"
      ]
    },
    {
      "cluster_id": "838e6a9b-36b6-4be2-87e8-cb3d0595dcf6",
      "members": [
        "5ef6a303-44eb-4d39-849c-0f5399eea698"
      ]
    },
    {
      "cluster_id": "546f63e2-ef89-4f69-bd49-cde47599b05e",
      "members": [
        "fa707004-3fa0-4ba3-bd14-64362927704f"
      ]
    },
    {
      "cluster_id": "203655c2-f1ad-4fb6-94c5-5fc8218603d3",
      "members": [
        "a7ddd415-7366-41e4-aa1c-66bee62b8998"
      ]
    },
    {
      "cluster_id": "aa908c8f-4075-45ac-a932-631e5efec76c",
      "members": [
        "fd15a0ec-5782-4364-bac0-06c385094698"
      ]
    },
    {
      "cluster_id": "0f733538-ef56-427f-ad23-04cb6fae87ae",
      "members": [
        "c1ad018a-74d6-4483-a5d2-5098ed285a05",
        "2cb20498-f180-4af4-8f9a-817025296a86",
        "ef3d54fb-135c-4f91-83be-3f3bde8746d4"
      ]
    },
    {
      "cluster_id": "4a8ddb73-8e8c-4981-b0f4-e38510f4f712",
      "members": [
        "5a67a1b2-e1a7-4007-b512-ea59976dc055"
      ]
    },
    {
      "cluster_id": "fd554d0c-cd25-4da2-adf1-dcccfd01f292",
      "members": [
        "cd554ad0-b8e4-4c20-bad6-335ae10b2602"
      ]
    },
    {
      "cluster_id": "ceec9597-cc69-4304-a584-0cec50748ec3",
      "members": [
        "37aa0a4d-96f8-4e27-b36e-4024e3864c72"
      ]
    },
    {
      "cluster_id": "266128fe-9d68-4687-b95c-b0654a1c7f0e",
      "members": [
        "e53cd62b-8645-4b7a-b430-ce6122331fb2"
      ]
    },
    {
      "cluster_id": "0fde95b6-db57-45cd-b6ac-fb0edd1b186b",
      "members": [
        "c02460c1-0520-4c75-84be-9c755ac23b1e",
        "e08a30eb-1c20-400b-8446-ac1b78bea4a6"
      ]
    },
    {
      "cluster_id": "28e936b6-8a48-4d96-b4e6-7c0ff60a51fd",
      "members": [
        "85df2a88-2a1b-4add-b62c-7f93fd934a54"
      ]
    },
    {
      "cluster_id": "26ee8f8d-a289-4bb8-af4e-67dfc3cca301",
      "members": [
        "1ebf5a57-2440-403a-8554-c1001c540572",
        "c0f5cf9d-a8e7-4d14-b270-ecf2b1e28b18",
        "706987e6-afc1-4f06-ad55-7a4abe9b2eb2"
      ]
    },
    {
      "cluster_id": "a8c6b9dc-b961-4a1b-bb6d-3aff208b396f",
      "members": [
        "0aead5cb-0afd-408e-84e1-61cb9f170296"
      ]
    },
    {
      "cluster_id": "8308c2eb-92cf-4ca4-876b-d1d947564441",
      "members": [
        "8e5a3ad3-1aa6-409c-ab9b-fc489f9382db"
      ]
    },
    {
      "cluster_id": "a4182192-73bb-4165-ad72-05ff39be899d",
      "members": [
        "8af9fe56-8608-4393-a401-af9d66e91000"
      ]
    },
    {
      "cluster_id": "a9a65207-69ea-45b8-ac25-c8ee16fc4a08",
      "members": [
        "5c111c5d-345a-47cc-aa7e-7a23939e591f",
        "4b16a3e1-3eb3-4c01-9ffc-8e057a849168"
      ]
    },
    {
      "cluster_id": "4180dc5e-36b2-4900-9bf9-c6ecf67fdc08",
      "members": [
        "da844889-0038-48d6-86cb-6d9b61e61930"
      ]
    },
    {
      "cluster_id": "c94810e3-5711-44bc-a55f-5ef59645cf78",
      "members": [
        "e41219e5-2040-4608-8215-0569f837116a",
        "1992dd80-35dd-46a9-bccd-0cf139aecbc2"
      ]
    },
    {
      "cluster_id": "924c4170-d405-438e-937c-13478012b72c",
      "members": [
        "7c2df117-bdf8-40bf-9218-92cd2f77ba5c"
      ]
    },
    {
      "cluster_id": "a8dc28b0-9676-46fe-a3b7-8eb8e563deb8",
      "members": [
        "1a7bc4ac-0bb9-4cd0-8bc4-036789edc05a"
      ]
    },
    {
      "cluster_id": "c1b9998a-8864-4f22-be23-89209993bf02",
      "members": [
        "7557180a-4ac9-4628-96e8-204eb76c9bf0"
      ]
    },
    {
      "cluster_id": "323efa20-d8ad-424c-9c0e-ac5d255b9276",
      "members": [
        "54eb5796-9234-49ee-be60-347e01fcc1ab"
      ]
    },
    {
      "cluster_id": "b8109116-4fcc-41ae-af96-4f441a585df4",
      "members": [
        "1f822cee-61f8-490f-a3e0-c7b75b886176"
      ]
    },
    {
      "cluster_id": "aa973fc5-c596-49d2-86f1-80f2a9f419e9",
      "members": [
        "06f2d0e1-a21b-42c4-aa82-dd44d72b861c",
        "3381dd29-87a6-4bc8-96d1-4fdace7560cc"
      ]
    },
    {
      "cluster_id": "bbc8c147-b447-4af6-82fb-e416f6108e70",
      "members": [
        "38621482-5b2d-44c7-820b-adbf9eeb1d63"
      ]
    },
    {
      "cluster_id": "d59582f7-7e86-41f9-a084-db1da2a740db",
      "members": [
        "8a68573f-ced9-4549-8420-46bdc3e8c365"
      ]
    },
    {
      "cluster_id": "56dc9727-1db9-4dc8-acf2-c70b7f101883",
      "members": [
        "ce09d69d-f830-46e0-a0d5-5a50cc945bfd",
        "1fdb61b5-3227-4c6c-b623-ee5994261c71"
      ]
    },
    {
      "cluster_id": "b5aab15d-0623-4834-b9a0-c066e3616369",
      "members": [
        "029e74b1-c638-46b1-82bc-3be5a9105c5a"
      ]
    },
    {
      "cluster_id": "24e1d750-e055-449a-83a7-236e590f0e5b",
      "members": [
        "2cc7310a-7239-4ade-ad8c-0f7f34d5682d"
      ]
    },
    {
      "cluster_id": "f4b62b28-f2fe-4807-a41e-80bf6c8bad68",
      "members": [
        "477b9d42-dc00-4000-a353-401ae75ac446"
      ]
    },
    {
      "cluster_id": "3312bf71-bb24-4752-866e-3b29580d70d1",
      "members": [
        "03e43ffc-e726-413c-8514-d3dc64faac25"
      ]
    },
    {
      "cluster_id": "7659f671-e41e-464a-9184-a08b114b3636",
      "members": [
        "a539a6f3-3066-4ea3-b176-0ea440f6d871"
      ]
    },
    {
      "cluster_id": "61fe3afa-76aa-4838-9dd9-a22a879ae31e",
      "members": [
        "dfdbdefd-0ea3-4791-9a19-883176ce0520",
        "4117e56c-a08c-40fc-b996-98b43966f125",
        "a2c95989-878c-4089-bb17-8155df3fcccc"
      ]
    },
    {
      "cluster_id": "ff7a6df5-d64b-4e14-803a-5339b1cffda2",
      "members": [
        "a842755b-f32f-4ffc-bb0e-fb7c12eed55e",
        "d9f0695f-a41b-4f1f-b51f-57d0a6859c8b"
      ]
    },
    {
      "cluster_id": "29cb7e64-a98d-4be8-8dd8-aa5a3b83d517",
      "members": [
        "7ea6e1af-a1ab-4574-b2a6-de810666c3bb"
      ]
    },
    {
      "cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "members": [
        "dcc9ad82-adaa-4277-832f-40fe07e07e4e",
        "a237951f-5603-4b3d-98f5-4530944e0799",
        "3220bfc2-e818-4aa6-99e1-0fe729cee492",
        "cc1c0b2e-c509-4ed2-93ee-ff392da24a6f",
        "8929cf51-2c57-4301-871a-351e37841df3"
      ]
    },
    {
      "cluster_id": "f68dc41c-3947-416c-8f93-49c606c24bd2",
      "members": [
        "f0e557a3-c422-4388-81df-60332a604a31"
      ]
    },
    {
      "cluster_id": "58021478-0a50-495e-b059-4560ef7c90f4",
      "members": [
        "98d2a36d-e4c8-4788-be7b-251ef8ed3e69"
      ]
    },
    {
      "cluster_id": "5e767ae7-5475-4d58-9919-b74b88492c8d",
      "members": [
        "f30c2aba-14a3-47f8-8eb3-31bf2697ec10"
      ]
    },
    {
      "cluster_id": "f02faf57-c72f-4377-8759-469d56737085",
      "members": [
        "8c2695a2-b90b-4d90-8cd7-4fd1a95e9915"
      ]
    },
    {
      "cluster_id": "3bc352c0-0d5e-42f4-ad88-e7f025e20e88",
      "members": [
        "7f38bd49-2b61-4485-ad92-826f4622b98a"
      ]
    },
    {
      "cluster_id": "5ebc5950-a889-49b1-a0d8-0d905803d030",
      "members": [
        "6a0b5371-4a1d-4a33-9cf2-6ed229397386"
      ]
    },
    {
      "cluster_id": "e25eede3-3242-446d-a439-2c4becea51cf",
      "members": [
        "d803c8a8-1959-4a78-9323-dac5106fa3c8"
      ]
    },
    {
      "cluster_id": "67d719d1-a600-418b-b08c-286005c2cb08",
      "members": [
        "09be098b-2ee2-4d5e-8bf2-c10d759502be"
      ]
    },
    {
      "cluster_id": "db91531a-0712-431d-a04b-9b798db3d3b4",
      "members": [
        "9f82b403-f37d-47ae-b12d-954966d567d8"
      ]
    },
    {
      "cluster_id": "799387af-65e2-4baa-bed7-0f025e3fbc39",
      "members": [
        "a05b5678-a8bd-4b6c-80a4-7d6b295509ee"
      ]
    },
    {
      "cluster_id": "756853a7-6f00-41a1-87fe-40396a3fd247",
      "members": [
        "b921b051-537d-408a-a1eb-67b0ab77f0f0"
      ]
    },
    {
      "cluster_id": "f4c860ae-1c6c-4478-89c7-fac05f3999c6",
      "members": [
        "ad77754d-a55d-4863-ab2b-c74d01f22f96"
      ]
    },
    {
      "cluster_id": "4259fe50-2c67-4157-ba4a-43d33835df49",
      "members": [
        "5aabbe3b-4ee1-4cf5-a307-e5972d7d441a"
      ]
    },
    {
      "cluster_id": "f4de84ae-8f6f-4a0d-afb7-35839203b010",
      "members": [
        "4849399f-d01a-4947-8d84-70e6370761b4"
      ]
    },
    {
      "cluster_id": "a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f",
      "members": [
        "4672ae95-fe94-4529-992a-9bd9f2450237"
      ]
    },
    {
      "cluster_id": "43de0036-79a8-44f6-b066-25424acf3535",
      "members": [
        "50dc1fd1-29df-4667-a38c-9cca6c573245"
      ]
    },
    {
      "cluster_id": "5cb260df-5e4a-4685-94d3-087687f5dbed",
      "members": [
        "4bce2060-09d4-4098-b63b-f9dc678c472b"
      ]
    },
    {
      "cluster_id": "f3d66a5d-cd26-4b6d-a341-2fdc2524c28a",
      "members": [
        "e1b163ae-328d-4f1c-8421-612b4cb01a03"
      ]
    },
    {
      "cluster_id": "b320fe25-40ac-4b0e-8605-df06f6384218",
      "members": [
        "f991e96c-ee58-44c3-8da5-9f2e65dff516"
      ]
    },
    {
      "cluster_id": "0cd50f6d-7e09-46ef-815c-37b05bef94d0",
      "members": [
        "c0397fd6-d957-4664-938f-51c149f52869"
      ]
    },
    {
      "cluster_id": "fec0d44e-dff3-4478-9317-1b1d954f03c6",
      "members": [
        "cb5c1d3f-6abb-4d7c-9539-5794000724f8"
      ]
    },
    {
      "cluster_id": "4c95b4a9-d005-4c7c-8a55-a5a0821d7611",
      "members": [
        "20b20009-55af-45e1-ad7a-f77568f0d0ec"
      ]
    },
    {
      "cluster_id": "bcc578f8-a745-46e1-ac64-5315a3ec6900",
      "members": [
        "d8927e01-bf42-48d9-87be-c2a1007db420"
      ]
    },
    {
      "cluster_id": "ba2401d3-a8f2-4ce4-bda0-30f38f532e31",
      "members": [
        "366f952c-f98a-4fa4-91bd-ea7fc8f9828f"
      ]
    },
    {
      "cluster_id": "43e40d68-962f-4fc6-83f4-ab836f751e9e",
      "members": [
        "07e907bf-4736-4110-94d6-ad50986f0520"
      ]
    },
    {
      "cluster_id": "aaf51226-d11b-4c1b-82db-25727f24712a",
      "members": [
        "abc78ee6-9a74-4c31-b3fa-aaf984c98e07"
      ]
    },
    {
      "cluster_id": "f4e0a38c-1349-4970-a962-5d6d7478cce6",
      "members": [
        "457886fa-6643-4453-924e-55c6694e6c9a"
      ]
    },
    {
      "cluster_id": "de4f148f-cf69-426b-b5bb-f722fb88313c",
      "members": [
        "a322dc3b-9865-4443-be3c-f9fdea386fe7"
      ]
    },
    {
      "cluster_id": "e762d6c7-8067-4852-8232-49501526397d",
      "members": [
        "1771bf97-ae85-40bb-8e02-f07fe11ffe91"
      ]
    },
    {
      "cluster_id": "b66f67b6-3e85-4a7d-9029-7480f97d9f48",
      "members": [
        "6a58e3a8-8d21-459e-b42f-19871735ddae"
      ]
    },
    {
      "cluster_id": "962affe3-ba24-4db1-8a1a-d157fa469f0c",
      "members": [
        "6c5a5880-c721-4166-84f9-b9f10b46d797"
      ]
    },
    {
      "cluster_id": "516d27f7-0cda-468f-b3b6-27af200d408b",
      "members": [
        "a08d6e56-7f7e-47cf-81de-e8122a610abd"
      ]
    },
    {
      "cluster_id": "49a8c8f2-03df-436a-8634-670fd40a145c",
      "members": [
        "37581388-5272-4892-bce8-93f42575e2da"
      ]
    },
    {
      "cluster_id": "02e82f7d-c446-4fc6-9794-94910a46d2ac",
      "members": [
        "420426ac-d677-4e71-9409-3c580a810304"
      ]
    },
    {
      "cluster_id": "216f7d8c-4948-4e84-9b61-7c4fc880e123",
      "members": [
        "51c31872-6c22-496d-8db0-350086738cc9"
      ]
    },
    {
      "cluster_id": "8ba29c52-b42b-44a3-86e2-12fd13d42596",
      "members": [
        "9da039ab-cd2c-4ac1-92f9-5bb3b0ac032e"
      ]
    },
    {
      "cluster_id": "8d06f8b9-e6ed-4b99-89ef-90434792b924",
      "members": [
        "0853fabd-817d-4700-8463-b223b3d9a9a3",
        "ad0d9484-a7cf-4622-9a6a-fc59f917b9ff"
      ]
    },
    {
      "cluster_id": "d489ee78-15f6-46b4-8adc-818181d95968",
      "members": [
        "551f6a3f-7ee1-4220-9218-10240e4e6736"
      ]
    },
    {
      "cluster_id": "abfcf3df-912d-43b6-968f-0f586e4e242c",
      "members": [
        "2b1cccb7-07df-443d-b883-4aeab0541083"
      ]
    },
    {
      "cluster_id": "75816fb8-77fb-4eee-a3ec-bbb68393ff86",
      "members": [
        "b64b0df8-d092-4873-b18e-8ee940b1188f"
      ]
    },
    {
      "cluster_id": "d2830923-6260-4e70-9fc4-f723af340d1f",
      "members": [
        "dd28c9e1-3524-4de6-bbf3-2db2158124db"
      ]
    },
    {
      "cluster_id": "075f7aea-756f-4e67-bf46-f4305230821b",
      "members": [
        "b3fb1932-a775-4fed-9c1c-8d700ed98f3c"
      ]
    },
    {
      "cluster_id": "784725f9-7f56-4fd8-bbd1-9c94d01f5505",
      "members": [
        "24fda3b8-a767-431b-a557-22af840dd04f"
      ]
    },
    {
      "cluster_id": "b4e4a860-8721-4ac3-8eb3-a9dec18b336d",
      "members": [
        "311bd324-53e2-40c0-a0e9-129aa64d4542"
      ]
    },
    {
      "cluster_id": "1b178ff0-cd2a-415f-bd8a-4daf71e452c3",
      "members": [
        "394b3ed1-93cf-4622-86bd-45daf5632dfc"
      ]
    },
    {
      "cluster_id": "d521ac4e-4810-4638-bb77-9fbf7ba74f52",
      "members": [
        "4f28cf1b-eeb4-4f98-9d72-3d16d8a364ab"
      ]
    },
    {
      "cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "members": [
        "7cce2a59-de6c-45b5-9890-bb26bd782446",
        "214150b4-7ba4-4e26-99e8-8ca6b7d24035",
        "102b1f5f-acda-48b1-9991-3270e7b4d909"
      ]
    },
    {
      "cluster_id": "a0016e91-a98c-4dd9-8feb-b0afadf02f44",
      "members": [
        "84180699-3401-4067-a323-c18de91df8a0"
      ]
    },
    {
      "cluster_id": "e52244b2-1143-48cf-9735-ce26094681d1",
      "members": [
        "ffad9e9c-f463-432b-922c-b04a447efd4c"
      ]
    },
    {
      "cluster_id": "94a3af2d-ef6e-49ef-84ee-4d1aa3f90aff",
      "members": [
        "6bb78db7-bfa8-4e89-a5a4-231579174345"
      ]
    },
    {
      "cluster_id": "1c30353a-a7dc-48dd-bca2-56c91aa06ab6",
      "members": [
        "540ecfcd-d63c-4a16-8fc4-99bed69936b7",
        "b0dbda2c-722c-48c6-8dcf-06d13f0ff79c"
      ]
    },
    {
      "cluster_id": "a2f5a4b1-ccba-4cac-9bde-f079d3027db4",
      "members": [
        "76d3150d-566a-437c-a07b-ba31f7754271"
      ]
    },
    {
      "cluster_id": "38eef897-6e59-4836-bf0e-1e7e106baf53",
      "members": [
        "04565754-2efa-4a04-ad4f-47a3b69df633",
        "f1738e70-73f1-40c1-950a-c03f9ea23c76"
      ]
    },
    {
      "cluster_id": "e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37",
      "members": [
        "45988828-987d-41f9-9910-a69e0b6b266c"
      ]
    },
    {
      "cluster_id": "83605bab-42d6-405a-ab45-fb6b68e0609c",
      "members": [
        "8184bdb0-d238-4442-b9e4-88964c551e5a"
      ]
    },
    {
      "cluster_id": "d7eb8bf6-179c-440e-ad1d-a97e186809d1",
      "members": [
        "f7f4494c-d23f-46bc-95ad-55e481020949"
      ]
    },
    {
      "cluster_id": "c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9",
      "members": [
        "8d0e5935-493d-40dd-86c0-2179f8a97908"
      ]
    },
    {
      "cluster_id": "21b491b2-20db-42c2-af5c-70af377f068d",
      "members": [
        "d870ab1b-50ae-4474-a007-a3b3b7ede249"
      ]
    },
    {
      "cluster_id": "d87f03ea-124e-4e30-80f4-ce890ca4d97b",
      "members": [
        "665223ae-15a5-40d1-b029-3082c0364604"
      ]
    },
    {
      "cluster_id": "b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10",
      "members": [
        "9faf8cdb-f734-4c8b-a184-83176178c4e1"
      ]
    },
    {
      "cluster_id": "ce2b0119-85f6-4619-9c50-256557181c73",
      "members": [
        "35a9dcf0-4cae-42aa-ad49-b78de8e6a2de"
      ]
    },
    {
      "cluster_id": "dd24c0fd-c274-4b3f-aabc-3dbac6784aa9",
      "members": [
        "76f38dc8-7183-4718-8907-c647e8fb8b2e",
        "dccb2688-1856-4a1a-87b7-4ee0424e01e4"
      ]
    },
    {
      "cluster_id": "88c2038a-24a0-497f-bac0-84ee519d160d",
      "members": [
        "7a922f37-4c04-4b1a-939d-f05336063961",
        "2636aef0-bc84-44ab-a740-8e82aac9565b"
      ]
    },
    {
      "cluster_id": "5dd21bbf-0c74-46d7-a4e4-48789f1b2436",
      "members": [
        "b156d810-c926-4b49-93be-bbd349028310"
      ]
    },
    {
      "cluster_id": "32dde553-bbf3-44a2-afd4-d60807ce0ab7",
      "members": [
        "4c9db928-374c-4dd7-a717-f789724effe9"
      ]
    },
    {
      "cluster_id": "4ab7d21d-36fc-4f12-857a-8e07c61bf688",
      "members": [
        "c9c854e8-b4e4-4054-bf94-68d3c8d21c91"
      ]
    },
    {
      "cluster_id": "692c12d0-dff2-4fe9-a351-80422ee99320",
      "members": [
        "0813d21f-b8a9-46d0-852c-e35d7a6b2107"
      ]
    },
    {
      "cluster_id": "d30cdd9d-92e1-44ac-aad9-845702e1559f",
      "members": [
        "0f1302f3-58b6-4c74-b747-90a0f169b860"
      ]
    },
    {
      "cluster_id": "d89e632e-b2af-4331-9344-c7d1e373d49b",
      "members": [
        "6513150c-e717-4597-8bda-c069fd2ec66d"
      ]
    },
    {
      "cluster_id": "80a02b1a-c045-453f-ad92-9681e40dad83",
      "members": [
        "78dd7176-866b-40c3-ac5b-ac8a56744bbe",
        "c1e9c5d8-d9bf-4f24-a146-4466e09a1c9c"
      ]
    },
    {
      "cluster_id": "9bab62f9-a196-4e9b-9809-8d8f41f0576f",
      "members": [
        "68058236-e8a0-4c0e-8ea8-4e9fbad8892e"
      ]
    },
    {
      "cluster_id": "cdfd2024-64ea-4945-8131-782266513caf",
      "members": [
        "021a2b2d-f94d-4d7f-a79b-98cc50562a16",
        "f7784c93-abea-470a-9986-7999412af8fb"
      ]
    },
    {
      "cluster_id": "73184e14-aff1-4c97-a2f0-0508b86fc3db",
      "members": [
        "94b7d2a0-309a-4377-b78e-9387cb60a617"
      ]
    },
    {
      "cluster_id": "d8704200-daac-4e95-873c-20cc39771b1c",
      "members": [
        "87fe6fe7-6741-4b4d-a004-7c63f9e8fc69"
      ]
    },
    {
      "cluster_id": "ff763739-26e3-4daa-93bc-7ecf065c5275",
      "members": [
        "7a567ea2-81b6-420f-98b5-f699eaedb85a"
      ]
    },
    {
      "cluster_id": "d86ea948-08a0-4829-9e48-4f9273b2967d",
      "members": [
        "0fe90583-3a97-4b9a-b64f-8acba9619caf"
      ]
    },
    {
      "cluster_id": "6bdcff96-571d-4879-91a7-d6084340625f",
      "members": [
        "1e7778f2-669a-4098-9803-8a2c8c4f2bda"
      ]
    },
    {
      "cluster_id": "91e94583-4b9d-4847-9825-9ed7293c7a0e",
      "members": [
        "b55c0787-864a-4d79-bd3d-090b61e5f7d0"
      ]
    },
    {
      "cluster_id": "0b331741-7f54-4613-ad60-e935b60f7fbe",
      "members": [
        "eed31450-13c7-4a12-a6f5-87c6bee4c1d2"
      ]
    },
    {
      "cluster_id": "cb357706-7b58-4396-aa24-1c59beae87fa",
      "members": [
        "96a1e432-163e-4821-8cba-d4b5417f9f48"
      ]
    },
    {
      "cluster_id": "7e1a378e-1366-4ff2-9282-46ddc9975cc6",
      "members": [
        "8c55c063-c680-48b6-8ba6-64ac9886ba32"
      ]
    },
    {
      "cluster_id": "72a6b38a-23a2-43db-a788-32ae774a5c77",
      "members": [
        "6ce85de8-d097-4553-8939-cddc44ac7afc"
      ]
    },
    {
      "cluster_id": "a55a36be-0edb-44d4-8400-10d53525802c",
      "members": [
        "f5307467-deb6-4fd6-92d7-cd40b933d49c"
      ]
    },
    {
      "cluster_id": "69fa7886-741a-440f-8a20-2b9ce60729ac",
      "members": [
        "e31a626b-6477-4fd6-995b-cd4796ae7896"
      ]
    },
    {
      "cluster_id": "aae7438c-bb2b-4e87-86b8-fc77cf6148d1",
      "members": [
        "61ef2b5e-ba4a-4387-b511-d95280b5758f",
        "b380f9a0-cb02-43c3-a4d4-33c16744b821"
      ]
    },
    {
      "cluster_id": "6f4632e9-24cc-42ed-87c9-747133ea5b31",
      "members": [
        "661405a4-20f3-45ba-9dcd-c6aabc7da03b"
      ]
    },
    {
      "cluster_id": "910b6c18-44e1-4b51-b616-1f6016486c69",
      "members": [
        "dd9c34d2-e328-404e-9262-ef8ba5e31c00"
      ]
    },
    {
      "cluster_id": "6075c9de-cd99-4e5f-9302-f1b6177720a7",
      "members": [
        "b0760fb7-31e2-4253-a9e7-088762a7adf4",
        "6fd6f299-2bc5-4cd1-b7db-411b475af0f8"
      ]
    },
    {
      "cluster_id": "883c65b8-c8f1-4a3b-8bd5-fb9d61a95876",
      "members": [
        "a78f8423-7ff6-436b-bb86-b2d81950dba4"
      ]
    },
    {
      "cluster_id": "84b73ec4-88f0-4587-a147-47771c41db07",
      "members": [
        "ce8a9b13-d2ba-43a3-91ba-1e54add14e25"
      ]
    },
    {
      "cluster_id": "b7635b58-ad1e-4cb4-a317-8d48ce1cdddd",
      "members": [
        "37205a70-045d-45fb-a659-745be3a25f44"
      ]
    },
    {
      "cluster_id": "b2ae7e4a-67e9-4eed-bd5c-afaef2c19efc",
      "members": [
        "936a910e-c127-46cf-854c-f9f45c4172c4"
      ]
    },
    {
      "cluster_id": "be023ca2-f865-4811-854e-b40ab442412b",
      "members": [
        "31cbe0ed-02e8-4c9d-98ea-753e0ab3babe"
      ]
    },
    {
      "cluster_id": "f006e419-46e2-4ca6-a34c-afa36d7458b2",
      "members": [
        "a717a742-4cc5-408a-8a35-4286bff0e4e4"
      ]
    },
    {
      "cluster_id": "989e42eb-c62e-4e68-87e6-6b230317d087",
      "members": [
        "ab03c143-5c30-4a99-9014-887c91d422e6"
      ]
    },
    {
      "cluster_id": "29b7e7cf-ad7f-43ae-a8c7-822d865d97f4",
      "members": [
        "870b6aee-39e4-44ab-8369-c44251be45de"
      ]
    },
    {
      "cluster_id": "78bccd7b-b8a1-4e70-bdf2-26a8b9ac339a",
      "members": [
        "f34accd5-1589-4a52-82fd-77643ec0941f"
      ]
    },
    {
      "cluster_id": "8a60fc08-ff21-49d9-8858-dcff37e21d18",
      "members": [
        "a76fd6ba-7552-4af7-9c53-13e1dbf01800"
      ]
    },
    {
      "cluster_id": "6cfce6ce-fb64-4bfa-a23f-01cbee46c275",
      "members": [
        "8eb3868f-1de4-4758-bcd9-776496ea6d87"
      ]
    },
    {
      "cluster_id": "c31ea39d-ce0d-46ee-be4c-e32d46721b78",
      "members": [
        "4b294b6e-1494-4eb8-ab32-b4e0af0ee624"
      ]
    },
    {
      "cluster_id": "772127a5-d049-4874-9828-2ed65010852d",
      "members": [
        "aa3f2dae-31fc-4d1e-85ee-711ed8179455"
      ]
    },
    {
      "cluster_id": "17b4175b-7c9e-4cac-8f06-6d2c5a65e803",
      "members": [
        "c2eb7027-7f02-4640-a1e8-3178709b3d6c"
      ]
    },
    {
      "cluster_id": "42302660-b692-4e66-870b-37970eee6c13",
      "members": [
        "51da2545-3036-4376-9031-a272d71f4745"
      ]
    },
    {
      "cluster_id": "08372c18-8eed-4c93-adee-9002e00e29bd",
      "members": [
        "4b7146ae-eb62-46f7-a74d-dfb114e0c51a"
      ]
    },
    {
      "cluster_id": "38d2a616-9f37-42ea-8e5e-3010dc76a2ba",
      "members": [
        "c433c64e-4d49-46b1-b558-2374391d828b"
      ]
    },
    {
      "cluster_id": "19867279-c3e5-4f1b-afe9-d36652a4bc2b",
      "members": [
        "4babb15c-0432-4c14-a80c-8a89bb99daf4"
      ]
    },
    {
      "cluster_id": "f997f1c7-5ae9-4bf5-bd1f-2f46bb8d4a16",
      "members": [
        "c691c40b-0da2-4fba-8405-1d8ee2563aea"
      ]
    },
    {
      "cluster_id": "b331f46e-c31d-4c56-81c9-c40834960e1f",
      "members": [
        "dfb119ab-0905-4f66-9996-9575684b6e27"
      ]
    },
    {
      "cluster_id": "3ece6224-aab7-493b-83b2-1f9fc56d3136",
      "members": [
        "a84ae567-4401-4340-9020-62272d966ea8"
      ]
    },
    {
      "cluster_id": "6d0fc82b-e82f-4ea0-897a-429340b5d2e7",
      "members": [
        "0016daed-4c8a-4f04-82a6-93d276191cf2"
      ]
    },
    {
      "cluster_id": "1a006b70-5bcf-42d1-91c0-d02ee212c0eb",
      "members": [
        "06c9eb45-978c-4b10-a3d5-4e009293d7c0"
      ]
    },
    {
      "cluster_id": "2d5d8472-462a-48f6-89fe-e8182a74e9c6",
      "members": [
        "c46387b0-beff-4ba1-b2f4-5f52c8f5f329"
      ]
    },
    {
      "cluster_id": "773a0c25-df3d-4865-86dd-a73825ed69b0",
      "members": [
        "2be2682b-3fcb-45ed-9120-9ffd003ad2e6"
      ]
    },
    {
      "cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "members": [
        "81764a78-278d-4f62-87bb-53accd6c2144",
        "7089e061-f356-4b79-b1f2-651d5988f658"
      ]
    },
    {
      "cluster_id": "a0fab421-41ab-435c-b6c1-ee353c134771",
      "members": [
        "88a2d097-7fb9-436a-bce9-304796f073e2"
      ]
    },
    {
      "cluster_id": "6f8b0a89-8965-4d5d-9b89-f48b23ed61a1",
      "members": [
        "0e3b3e82-2f17-47a0-b8a5-0911a030245e"
      ]
    },
    {
      "cluster_id": "e28e105a-739c-4f5f-8b79-8f56f435e121",
      "members": [
        "84eab2ec-0421-4ec5-adde-98da233799c2"
      ]
    },
    {
      "cluster_id": "5c1d5636-b62a-4962-911d-1136d9629b6a",
      "members": [
        "b1cfeae3-7f20-4959-8338-5c2742e6739f"
      ]
    },
    {
      "cluster_id": "06dab846-f17e-48d2-94e4-d604af613859",
      "members": [
        "1068b99b-afa6-4480-a25b-e2729c14f279"
      ]
    },
    {
      "cluster_id": "21c29f8c-34b7-47c4-8021-91ec84cff803",
      "members": [
        "3970be47-9533-41fa-9996-110c725cf92e"
      ]
    },
    {
      "cluster_id": "6e63c4ba-f9ee-49c7-a87f-b38ea11837c4",
      "members": [
        "cd5f2c50-555c-4b25-b9a8-384f188c664a"
      ]
    },
    {
      "cluster_id": "a6683ed0-4b78-4420-9494-296c3493439d",
      "members": [
        "1658783f-c143-44c0-a0bd-d86a2d59e278"
      ]
    },
    {
      "cluster_id": "62be0386-404f-434a-884b-4dc379430917",
      "members": [
        "b1b40546-ec71-46aa-9691-08e0f2e9b586"
      ]
    },
    {
      "cluster_id": "29469bb2-a496-413c-802b-5a8d1b46d374",
      "members": [
        "46604d93-2806-448b-8c25-c7363eb20a06",
        "ddbb5e44-b4ad-4c11-ae5b-a2bdb771c918"
      ]
    },
    {
      "cluster_id": "dad0da03-60db-4f17-9025-e5a1ac65e552",
      "members": [
        "86207384-0583-4a85-80f9-90268d07f502"
      ]
    },
    {
      "cluster_id": "3a5853fd-eaf4-497d-b7fc-b13a9208544c",
      "members": [
        "942531b4-dec6-433b-a397-2a34822a7db2"
      ]
    },
    {
      "cluster_id": "beb979e4-f486-4e3c-ba15-47b099971ff0",
      "members": [
        "c58cca54-9dbf-4739-a076-57ed426b15fb",
        "06292199-7dd0-43db-afde-7ae66493d4d5"
      ]
    },
    {
      "cluster_id": "949ec20d-24b3-4de5-a36b-32e35cbe9392",
      "members": [
        "6c3e9aeb-75f0-4a81-a3c6-6ccb162d3595"
      ]
    },
    {
      "cluster_id": "a950be1b-733b-40a8-b78b-7a36e0c5c2ac",
      "members": [
        "9c2af4b3-f21e-41ba-84e3-147806af306b"
      ]
    },
    {
      "cluster_id": "99bf6cc4-ca7c-40f2-9d7f-294c761aeaaf",
      "members": [
        "36370dfa-344e-42cd-b175-35522618f57b"
      ]
    },
    {
      "cluster_id": "8bcf86f9-8509-4d9f-8550-8839a96fa515",
      "members": [
        "94a437c0-a658-4ee1-ba24-09607845efac"
      ]
    },
    {
      "cluster_id": "5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6",
      "members": [
        "8f9adad7-7268-42d1-8052-67cf463f8936"
      ]
    },
    {
      "cluster_id": "7e112a5c-41d4-4f1c-b974-99256b5d357b",
      "members": [
        "46a0c3b9-3856-4db1-a886-180abac23d55"
      ]
    },
    {
      "cluster_id": "a5d39319-660b-4b6e-acb4-246464538db6",
      "members": [
        "8013c6f5-a136-41c4-87cb-8d5e885b05d2"
      ]
    },
    {
      "cluster_id": "b198bd93-5f96-4992-9aa2-29e396814e39",
      "members": [
        "84e31776-201e-4b09-8fa4-f3c1b0a1c99f"
      ]
    },
    {
      "cluster_id": "64de7b14-ea9c-48fe-a9a0-a30f01aecc3e",
      "members": [
        "17b8e47c-1760-47a5-b51b-ebd91629693d"
      ]
    },
    {
      "cluster_id": "c9367bb7-c2e3-4341-a799-6ff36d655556",
      "members": [
        "373b210c-8381-4d76-84d2-0517d2a5fae1"
      ]
    },
    {
      "cluster_id": "d8581e68-7fcf-4616-92c1-9daff0a2d8ae",
      "members": [
        "b0e88103-9182-428d-a786-fd65d7cfc76a"
      ]
    },
    {
      "cluster_id": "94c7e352-c14a-45a1-b0c5-cccdc2ef1122",
      "members": [
        "dc18ed86-33df-41ba-9de2-a0ec4e7462b8"
      ]
    },
    {
      "cluster_id": "da70552d-1a69-4dd8-bc9d-ca358f3caefe",
      "members": [
        "af9b140e-b5b6-4c11-8276-f58139175533",
        "6b3d7248-ead8-4f23-88a2-6645c651cbe1"
      ]
    },
    {
      "cluster_id": "cfde4319-eb6f-4277-956f-9a094157160f",
      "members": [
        "64fc6ae9-27d6-47aa-83ce-0abdfc9c3126"
      ]
    },
    {
      "cluster_id": "b4ee4418-ee26-4134-986b-8e220ef5da22",
      "members": [
        "6616e213-4d96-4494-8c81-5d7ef80cfe7a"
      ]
    },
    {
      "cluster_id": "bec9cb65-cf13-44b3-b77b-95d99bace1e4",
      "members": [
        "51e7f666-0050-488c-9d20-f9c3d4e7a675"
      ]
    },
    {
      "cluster_id": "4cc6a578-5e10-41d7-a578-fba88da2dc13",
      "members": [
        "9a96fcb7-3f24-461c-abff-40ee26d60bbd"
      ]
    },
    {
      "cluster_id": "5feff95a-4d00-4a01-9b49-f3df3eb263ca",
      "members": [
        "5d6e3c65-5625-42fb-9762-29770ac69d70"
      ]
    },
    {
      "cluster_id": "71f3d08b-aa01-4b41-b89d-7fb725538d72",
      "members": [
        "416a7f2f-5a8f-4b2e-af1a-ed544ee6262c"
      ]
    },
    {
      "cluster_id": "bfc6790e-9007-4b03-90bf-5da6fcce01b7",
      "members": [
        "b3ad4cab-a5e0-4720-b764-876a113500e2"
      ]
    },
    {
      "cluster_id": "f401d633-0e2b-4935-b7d9-1761c201c058",
      "members": [
        "4289d0aa-4385-4d1f-b208-ed86b86771c5",
        "7ae75a6a-6f33-4618-8d40-749b6de55028"
      ]
    },
    {
      "cluster_id": "74bc9e46-31ab-4e9e-9240-87a035b90601",
      "members": [
        "abebfc28-65a2-45e1-8d3d-74cba4088fc5"
      ]
    },
    {
      "cluster_id": "09a92b68-8f29-435d-b853-f4c47f64d9da",
      "members": [
        "c7a05342-7ea2-482a-ae7d-a4773af7eb46"
      ]
    },
    {
      "cluster_id": "7fbd47ed-2abf-42a7-9e7d-74c06dc8b729",
      "members": [
        "bb5ea732-fc0b-42e6-915e-dc5845af26a0"
      ]
    },
    {
      "cluster_id": "5b935620-b425-4241-8333-a51c2e077394",
      "members": [
        "11ebb2bc-c822-40ef-9a48-f56030baf816"
      ]
    },
    {
      "cluster_id": "fdbce6fb-9c6c-48ff-a187-88c668f79277",
      "members": [
        "12585130-a603-4a16-af27-1e1fcce40159"
      ]
    },
    {
      "cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "members": [
        "bfb2d618-fbdd-4aa4-9ec8-fd066b137ccf",
        "c741471f-7be4-41e6-872b-a89b949145b6"
      ]
    },
    {
      "cluster_id": "ec868d12-f24d-450d-bca9-2e8a9f4e8021",
      "members": [
        "3c9d6334-c309-4acf-95f8-b5d5e69ba433"
      ]
    },
    {
      "cluster_id": "11aef681-a744-409f-8cc3-69822e3a86b2",
      "members": [
        "3bdd3464-3b56-41c5-b23f-c9175e8cb79a",
        "8477b1b0-2cb7-48d0-b224-7367c519ff94"
      ]
    },
    {
      "cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
      "members": [
        "4a490611-8667-498f-b795-aa3c60360577",
        "93db5c3d-f473-4e51-9442-ddc704bd6f34"
      ]
    },
    {
      "cluster_id": "04c040d8-393f-4b27-af55-1f60d7802605",
      "members": [
        "f58640de-8679-4344-8e02-c81e2d56cf3e"
      ]
    },
    {
      "cluster_id": "13a07f14-45d6-4b31-8d23-23b540ac8090",
      "members": [
        "7f2f4983-adf6-4346-8154-b7de3cf8139d"
      ]
    },
    {
      "cluster_id": "1542a1c0-0498-4551-b3c6-794eb9ae6305",
      "members": [
        "ad0bb58c-bd77-4852-ab78-fc14a7ada568"
      ]
    },
    {
      "cluster_id": "7ddce93b-3cfb-4112-a70b-f91eb14e7082",
      "members": [
        "e59b958a-d4b1-4c92-a490-dad0c9ad6b85"
      ]
    },
    {
      "cluster_id": "9f936fe4-6962-4447-9269-bd4c45c0f95e",
      "members": [
        "65aeed1b-3262-431e-a71d-2bd16f74bba2"
      ]
    },
    {
      "cluster_id": "e7606791-adc1-47d9-b4e0-1e86a03f87ad",
      "members": [
        "a8d3b3f2-8f28-4997-b8fb-d356c28fc9fd"
      ]
    },
    {
      "cluster_id": "ce659db6-9043-4f18-a410-39321ba5fd81",
      "members": [
        "d41000c9-686d-42f9-a48c-6ec348be7bfb"
      ]
    },
    {
      "cluster_id": "b1da6225-3a48-4f38-b0fb-dac29be99682",
      "members": [
        "96fb4452-25bd-4554-b732-f23f41adbf38"
      ]
    },
    {
      "cluster_id": "f0d99bfd-e20a-4b87-9be0-a227af6f681d",
      "members": [
        "ccfeabe0-28f9-4439-a265-f75474b223dd",
        "78169a0b-75f2-4830-896f-9056dcae8c86"
      ]
    },
    {
      "cluster_id": "0727da75-801a-4ea8-bc54-bca9f4c0cbfc",
      "members": [
        "b4bcb059-a88f-4ecc-afc9-4a8ffb58deaa",
        "999e662e-08b9-49b2-b175-8dd13a767110"
      ]
    },
    {
      "cluster_id": "12b139d6-738c-48c1-b240-a723ec803e43",
      "members": [
        "d7982fd2-b552-45b9-9ac6-e7c2c5fc0916"
      ]
    },
    {
      "cluster_id": "8b3203a2-f473-4957-9689-fdf6ee974697",
      "members": [
        "db4562b0-997d-4fbf-9616-cd9cc79f842d",
        "170e5188-3fdf-4846-894e-f89b08183c86"
      ]
    },
    {
      "cluster_id": "11f5ada1-39d8-46a5-b3e1-ae12a04328c2",
      "members": [
        "843ad762-b206-4f47-b606-70a915950b5e"
      ]
    },
    {
      "cluster_id": "c70207c5-86bf-4f7f-b715-56b9c8674c3b",
      "members": [
        "4644bce0-c9cd-4728-a3ac-eeedce4ddcfa",
        "08ae94a3-a979-4f67-af67-7d21fcc158d7"
      ]
    },
    {
      "cluster_id": "f97e4f6c-a73e-4c35-8e7a-51a335141d67",
      "members": [
        "a3f09e08-ba96-48b9-8cf5-2e23612fc92a"
      ]
    },
    {
      "cluster_id": "1e19ebda-0ce5-4c42-b6ac-f081acdf5974",
      "members": [
        "04201b64-11b5-4a5b-ab03-c26dfe98eaa0",
        "1f803c39-679e-4b18-af7a-67db88ade0a2"
      ]
    },
    {
      "cluster_id": "00ac14b3-c6d6-458b-b4cd-3981a1a2b9f9",
      "members": [
        "f1d4fcbb-0069-4d08-a24e-77e962a05585"
      ]
    },
    {
      "cluster_id": "6eb878e4-969f-49ca-8ac8-5c68ead2c13e",
      "members": [
        "96f1b602-4d0b-49a5-b639-456163508b1d"
      ]
    },
    {
      "cluster_id": "57752645-2ac6-4482-9e7c-bbaea1506cc5",
      "members": [
        "020f8349-87b4-471e-aa33-4627090a42ce"
      ]
    },
    {
      "cluster_id": "99dfb4e4-9788-4ea5-81a7-c0dd44f60aba",
      "members": [
        "96c1386f-d62f-4eb4-9546-ab7c52e088cb",
        "18be4b88-72b8-4ba0-a38c-6fea58782b35"
      ]
    },
    {
      "cluster_id": "4a575d85-5f97-4baa-be78-2c26ecefb471",
      "members": [
        "63151421-595c-49e6-97f2-2451fc80eaf1"
      ]
    },
    {
      "cluster_id": "cfda7d82-87df-49b1-8db2-82b62b174a67",
      "members": [
        "92cb575c-b924-4e40-9aba-517d60cb2e8e"
      ]
    },
    {
      "cluster_id": "64b71712-5c8b-4ba5-9b04-b6b37a4ef8bd",
      "members": [
        "f74c9c19-08b5-4767-85e3-bdd2b04e897e"
      ]
    },
    {
      "cluster_id": "018f6f1c-b2e7-43ca-a443-3a5d27b5033c",
      "members": [
        "54f31316-749c-45c5-a935-bcbfe6582195"
      ]
    },
    {
      "cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "members": [
        "f84fbb9e-84ba-43ed-9a8e-58d0df3a265d",
        "2fa3d5b3-e3dc-4d6a-9b27-00715d3ba168"
      ]
    },
    {
      "cluster_id": "444e2d84-e3c4-4a82-a2fc-3577e6124f09",
      "members": [
        "6a9a5709-418b-4dab-8b4e-1380b6e2fee5"
      ]
    },
    {
      "cluster_id": "f1f9481a-c3b7-4912-be82-d974b52e8f30",
      "members": [
        "fdf418a5-239c-4a3b-84f1-ccb5c655dfc1"
      ]
    },
    {
      "cluster_id": "de30ed78-2cf8-480b-aacb-665d9572f1b4",
      "members": [
        "7d057666-c938-4ff2-9b34-b005972c9385"
      ]
    },
    {
      "cluster_id": "f854f83f-364d-470a-8cd8-f0bec2c15e68",
      "members": [
        "ac2c8b74-62cc-436f-8f86-38c3f3214c51"
      ]
    },
    {
      "cluster_id": "061a86ec-2126-4e4d-85ba-8472db7a97a3",
      "members": [
        "990c66a4-8474-4ba5-a743-ec1d7ae76287"
      ]
    },
    {
      "cluster_id": "1e12b1a7-9bc4-4a98-b698-8392df483432",
      "members": [
        "2bcb6263-41a2-4b19-a182-585c686a8b0b"
      ]
    },
    {
      "cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "members": [
        "71668436-2847-4d3d-9e3e-60442f2829ae",
        "8c4e658b-c2f4-40d6-acb0-e120aa2aad0f",
        "1bccfbf1-34fd-45b1-8a0e-d466bbcc080b"
      ]
    },
    {
      "cluster_id": "ff42e3e5-bb75-45af-be07-89d36dae0d5c",
      "members": [
        "fb5985fd-da02-40bd-9b2e-973038f62427"
      ]
    },
    {
      "cluster_id": "baa70e51-5ce2-4e6f-8994-d85027e6b1d9",
      "members": [
        "a20f5161-5da8-4019-a84b-b9d70eb9e2ad"
      ]
    },
    {
      "cluster_id": "506e309f-6f87-418b-b660-0ad635976c9d",
      "members": [
        "bc09529a-9338-422a-b1ed-4aed6227f9f8",
        "ed2428ab-ce07-462c-904c-9122cd1ba168",
        "6a9ce6c1-b856-43c9-83c9-b007385edb91"
      ]
    },
    {
      "cluster_id": "fdec6a13-5351-4fa5-9920-1456738e3b76",
      "members": [
        "94baf93b-4cca-44d7-a782-b5c3d2894ba2"
      ]
    },
    {
      "cluster_id": "7cad6507-3550-4760-99ab-581f5b103f29",
      "members": [
        "f0946bc1-4e64-4617-a24a-fe963016e054"
      ]
    },
    {
      "cluster_id": "9d85f9b8-6204-4844-9707-8c2e9351d730",
      "members": [
        "623ba596-2602-4da0-b167-c51bd2531534"
      ]
    },
    {
      "cluster_id": "6e99d559-c095-46a1-a671-2a3d2e8566bb",
      "members": [
        "a263f78b-e32d-482d-91ed-81deca9f04d3"
      ]
    },
    {
      "cluster_id": "34db5d7a-86ad-4cf4-abae-67c617853bac",
      "members": [
        "fe87c798-bb32-461b-8114-2f55d8ef06a3"
      ]
    },
    {
      "cluster_id": "255ea174-3e00-4506-8a6d-78f62eccfecc",
      "members": [
        "e9dbfbe6-3daf-4d0e-88d0-22294b85c258"
      ]
    },
    {
      "cluster_id": "7a7464b2-8279-45dc-b2ed-48f2c4d22d10",
      "members": [
        "0ea03c18-e531-413a-afc8-9fd758a13242"
      ]
    },
    {
      "cluster_id": "78064e33-a38e-4112-b3b2-c02951368282",
      "members": [
        "8cce7f5b-945c-4ca6-9592-46c32642f963",
        "7d768a4f-0e69-457a-bc28-e263d9e83f41"
      ]
    },
    {
      "cluster_id": "b6c851f0-a597-49e8-982b-650d02a8ba55",
      "members": [
        "c1e740d7-b80f-476e-9d43-8800d71b253b"
      ]
    },
    {
      "cluster_id": "fc1c32c1-8212-46dc-b3e4-29a2254a34ba",
      "members": [
        "de4a5845-e616-46de-8e18-2ccf4891c7af"
      ]
    },
    {
      "cluster_id": "69315435-638a-4ef2-abe8-1d91d23ff51a",
      "members": [
        "ec7ab2fc-d2bf-4dc4-af4a-6a78a161b65c"
      ]
    },
    {
      "cluster_id": "2cfb50e6-37ad-47a2-87b2-da1a9a512e46",
      "members": [
        "ada738ce-b6fe-4f78-8507-95e1190b547f"
      ]
    },
    {
      "cluster_id": "8e9cb96a-0ee8-44fc-9406-1bb5188864ec",
      "members": [
        "f36a0cb4-ca00-46f0-babd-8371f6eaf1cd"
      ]
    },
    {
      "cluster_id": "729ff499-2dcf-4524-91fd-7e53fd6e6ad7",
      "members": [
        "9b394eca-d05c-4ddc-9dd1-294a8cfe08dc"
      ]
    },
    {
      "cluster_id": "b056d050-cc91-4967-a6df-ddb4af36891b",
      "members": [
        "a9395453-3f62-4979-b184-b9574fed4e44"
      ]
    },
    {
      "cluster_id": "ebad899d-9cc8-49e0-a908-87f53dd79063",
      "members": [
        "4c740324-ff57-4648-8ed7-61327f6ce31c",
        "ea9527d3-b5f8-405d-9e71-493a16e21670"
      ]
    },
    {
      "cluster_id": "a990d90c-b1b0-4148-b047-5b63c9eb7a78",
      "members": [
        "c5d25191-6901-47c5-8d4c-636d712c9cf5"
      ]
    },
    {
      "cluster_id": "94f243ab-1521-4874-b5fc-b80847a7fefc",
      "members": [
        "1ae70a9e-9821-41e3-b84e-86b6e5ca8240",
        "28d0fac9-14f5-448d-8b53-8c0cb4dd9579"
      ]
    },
    {
      "cluster_id": "51b16b2e-6404-4d18-a4d1-46e0d25d726f",
      "members": [
        "9f0ea2b0-c156-4bc5-92af-b04cb04a02cd"
      ]
    },
    {
      "cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "members": [
        "7b39a91e-e20e-432f-b965-c4698ab22ff3",
        "2533f22b-6d0f-49f3-9255-8b9c3a6484c9"
      ]
    },
    {
      "cluster_id": "c35d9889-06cc-4a13-8fea-d00c7024488b",
      "members": [
        "3f63c72c-b008-41e9-907a-65aca35610bf",
        "9503763c-7449-4178-849e-610ba6134ea6"
      ]
    },
    {
      "cluster_id": "36f68109-962e-490e-9101-85d84c5de66a",
      "members": [
        "b732d76a-2b06-4284-abcd-bc387bc8c1cd"
      ]
    },
    {
      "cluster_id": "174a0855-e1b9-4e2b-9a6a-957eb12d4b1a",
      "members": [
        "8c4e7ac4-8c04-46c3-a97d-e48934a16af6",
        "a5d59357-18c2-4f05-9c3f-7b7628df3eec"
      ]
    },
    {
      "cluster_id": "0f3a2cc5-8301-476a-b658-747594635542",
      "members": [
        "8f22e45c-5446-4628-8451-99e1ca4e880b"
      ]
    },
    {
      "cluster_id": "6d12ca3e-2e36-40ab-9cf4-0663df64745d",
      "members": [
        "c4677d1e-9db7-4190-9924-793e642c8435",
        "b4eee16f-516f-4bc7-a4e6-0ee7facbd68d"
      ]
    },
    {
      "cluster_id": "43605210-6be3-4d52-9b42-d4a4a1838ade",
      "members": [
        "7af3c507-526a-45ce-b2dd-61b801d21fe0"
      ]
    },
    {
      "cluster_id": "f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3",
      "members": [
        "96500fb1-16ab-4e8f-b6c7-c35d72fd2de1"
      ]
    },
    {
      "cluster_id": "e82ed51a-4d19-4b2d-96bc-cb54f9b70858",
      "members": [
        "a18aa87f-3a29-4776-85db-d25a86cbd228"
      ]
    },
    {
      "cluster_id": "1473286e-ca60-4128-b82b-a6695a32595a",
      "members": [
        "17298b54-7092-46ee-9c28-4acf297ff748"
      ]
    },
    {
      "cluster_id": "98177424-a992-4818-bd6e-9e0e3d0899af",
      "members": [
        "f57e9765-ae8c-4cb1-a9bd-02639581ef21"
      ]
    },
    {
      "cluster_id": "c5d18c78-4df0-44fa-9f69-67266b1079e2",
      "members": [
        "3ac795c8-d51c-4298-a87b-214912d9d6b4"
      ]
    },
    {
      "cluster_id": "7f94beb2-9a43-4280-9734-5045402a0714",
      "members": [
        "52466996-0059-4953-98fa-5cedb078c1c3"
      ]
    },
    {
      "cluster_id": "d0228864-78be-4fd7-94b7-908de0276e80",
      "members": [
        "d4c15268-dd03-4bb9-b579-ad2e9d197f56"
      ]
    },
    {
      "cluster_id": "72804ca3-611f-4b19-ada2-8bfb14c2e98a",
      "members": [
        "62956cb9-8b3c-4684-8727-ab704ca7a45f",
        "3d172aba-15cd-41a3-875f-232cf07ac7a3"
      ]
    },
    {
      "cluster_id": "8e873c15-6407-475e-841a-2dcbbce28e18",
      "members": [
        "e22e1484-240f-4364-bef2-27197cbab294"
      ]
    },
    {
      "cluster_id": "e0f8bbeb-8967-4f3f-ae0d-4b809311c515",
      "members": [
        "a7644128-356d-426d-a72f-e9ccaca044fc"
      ]
    },
    {
      "cluster_id": "45931062-6efb-4850-9df7-4bff0b9b4a16",
      "members": [
        "58ea73c6-2eeb-4934-a39e-bd6e1d791d97"
      ]
    },
    {
      "cluster_id": "5389eae7-83b1-4726-86c2-9a8dff51be59",
      "members": [
        "aee737c4-a386-4460-bb22-c9a90c10bad3"
      ]
    },
    {
      "cluster_id": "691c3c1b-0058-48a0-aaa7-5a38747b8c58",
      "members": [
        "a87006c6-a37e-44aa-b418-b90844e6d18e"
      ]
    },
    {
      "cluster_id": "ca064fa8-d12d-4c48-9fc5-aca6df7f2dc9",
      "members": [
        "641375ef-beb6-46e7-80af-90bdb12b074f"
      ]
    },
    {
      "cluster_id": "e1ad3c4e-eefb-42e0-8fe7-edf486c4da19",
      "members": [
        "6b595781-d1d6-4ca0-bb23-9a044256b930"
      ]
    },
    {
      "cluster_id": "51086a98-c771-4b7c-8eaa-b6fbb8629a30",
      "members": [
        "45022a65-88e8-4eff-9ed7-e9aed1e85ba0"
      ]
    },
    {
      "cluster_id": "b39ca7cb-8663-4bff-829b-b432d59670f9",
      "members": [
        "64c2f63a-56d2-46e0-8abe-ff40035acd85"
      ]
    },
    {
      "cluster_id": "02f58db8-b951-46f8-9ff7-76980a66fc66",
      "members": [
        "02f2861c-459c-420a-8105-6710bb5b977e"
      ]
    },
    {
      "cluster_id": "4a4d472c-cd13-4ccf-9f30-e866d14bdbf8",
      "members": [
        "a2d9f955-833e-494f-a522-8983dbe3a28d"
      ]
    },
    {
      "cluster_id": "7ff438ec-b701-48aa-b613-4bfeaba7bcce",
      "members": [
        "3e03a02d-349b-468f-a5cb-ed740d95b05f"
      ]
    },
    {
      "cluster_id": "9d39778d-eb5c-4c0e-b35c-894a4378bc37",
      "members": [
        "05f5fec2-3369-489b-a94e-b9bfcc251a1a"
      ]
    },
    {
      "cluster_id": "42b60cc5-5a50-48f5-a8c0-713eeb591918",
      "members": [
        "a2c7b8dd-50cb-426b-9bcc-a31227a8ca85"
      ]
    },
    {
      "cluster_id": "eb68c709-6220-48fe-b376-95a4f6f10b6d",
      "members": [
        "62c4c72d-70a2-472c-bcf3-193476bc0f15"
      ]
    },
    {
      "cluster_id": "702a4627-2eae-451d-b2a9-154358319e24",
      "members": [
        "6d70a893-521c-400e-9941-96785e5ad0d0"
      ]
    },
    {
      "cluster_id": "2e620f14-db3f-4f94-9e90-7ae11cf68067",
      "members": [
        "f24622db-4923-411c-8797-144755e2de66",
        "858266a5-5598-4215-8544-ed58b34b026c"
      ]
    },
    {
      "cluster_id": "503584d7-75a5-4f03-adb1-4844dd4d9b9f",
      "members": [
        "7aefc389-9540-4437-951c-1c190167095e",
        "94a1ce17-80ad-4be5-af57-c87d3443e0ad"
      ]
    },
    {
      "cluster_id": "639596e6-4b0c-464a-9fa5-8272920e87b4",
      "members": [
        "9a562a62-374e-4b09-bfd6-4b09c8d58a93"
      ]
    },
    {
      "cluster_id": "29bf0ceb-12c5-4f73-8a36-f5d689e7afd2",
      "members": [
        "23833acc-ceea-47bd-89ec-81ece2ea7dee"
      ]
    },
    {
      "cluster_id": "d3123cbc-3543-4f46-aee9-7941c8669a07",
      "members": [
        "3257e97d-7af3-4599-9280-a8ece0196021"
      ]
    },
    {
      "cluster_id": "9d1065d7-3830-4746-a836-8da581c0bbb5",
      "members": [
        "8ef4bf67-7cd6-4006-b358-4c34fa1cfbbb",
        "7e50b278-7168-4642-ac16-4936bb59dd46"
      ]
    },
    {
      "cluster_id": "dfbc19e5-8117-4d40-9c25-774ed7aee906",
      "members": [
        "131a2710-8ce1-4c28-8d5f-38b1e00f7315"
      ]
    },
    {
      "cluster_id": "df17d3e5-8709-4518-a32e-ebe9d39b417e",
      "members": [
        "58ae0f5c-42dd-4e1d-ba86-398feb744cc4"
      ]
    },
    {
      "cluster_id": "ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb",
      "members": [
        "74f6adc8-d3ea-49aa-b8f3-a2bf36a09897"
      ]
    },
    {
      "cluster_id": "b196eb88-ee2e-4367-8e6b-08f9890e6fe0",
      "members": [
        "75db5fa6-073a-44c0-8965-caf7b4deed7f"
      ]
    },
    {
      "cluster_id": "f46e8240-2cb3-437d-9e2e-c04f6db7a813",
      "members": [
        "2568521e-8586-4e71-a3a6-e54c9dd1a93c"
      ]
    },
    {
      "cluster_id": "5ece0141-8dd6-405b-93cf-5585050f4efe",
      "members": [
        "b4bf2eab-e1d3-47f5-90d7-b582087895ba"
      ]
    },
    {
      "cluster_id": "61ac97d3-e62e-41a3-b910-360985f7af21",
      "members": [
        "a9d4fbc8-c8c7-4d93-957c-cec78f52d3c8"
      ]
    },
    {
      "cluster_id": "e0a2030b-8c63-4b35-9a46-36f1f22b5601",
      "members": [
        "a0501e70-1977-4522-a0ee-e76a259691cf"
      ]
    },
    {
      "cluster_id": "897e2456-ff2b-43b5-9a48-23b6c36b2d95",
      "members": [
        "7754c771-cbbb-477b-9075-d667f3ca2060"
      ]
    },
    {
      "cluster_id": "eea02be7-fd53-47b5-9804-7a2f89de23f2",
      "members": [
        "5170b10e-8ae5-472a-b8b4-865fceabeaa5"
      ]
    },
    {
      "cluster_id": "eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0",
      "members": [
        "f28d8885-754e-4856-b649-c6bea110441f"
      ]
    },
    {
      "cluster_id": "8db7f2ee-28e7-4abd-b214-9d334508a075",
      "members": [
        "c42dccc6-9330-4981-81a9-d16c8ca59174"
      ]
    },
    {
      "cluster_id": "292629c2-32f2-451e-b64e-e8f73bb87975",
      "members": [
        "901f433b-f0f3-454c-aedd-2757b0e01baf"
      ]
    },
    {
      "cluster_id": "0dad0e38-e0db-46d5-a25f-8e95be6a721f",
      "members": [
        "ec769d42-4192-4ecf-9491-4cc677a2a64f"
      ]
    },
    {
      "cluster_id": "02fc2c1c-e5e4-40d6-92bc-a975544e0e30",
      "members": [
        "f0bc4708-3024-458f-b26b-a56e742362e9"
      ]
    },
    {
      "cluster_id": "59905a93-0117-4d6a-a153-cacf3c9feeb8",
      "members": [
        "29dc0b96-e0bf-42bc-8a57-0ede89709852"
      ]
    },
    {
      "cluster_id": "08c235e3-44d9-4f4b-9af7-a9491ce983db",
      "members": [
        "44f198c1-f272-49a0-a145-49eb04b378f7"
      ]
    },
    {
      "cluster_id": "ab52850c-7dc5-4f99-b37e-0c628b078043",
      "members": [
        "6845238d-ffa0-480e-ad20-dc70bd916dfb"
      ]
    },
    {
      "cluster_id": "0e2fe0e5-314e-4455-88c7-a13f3f6e7728",
      "members": [
        "af026343-e2e0-4e95-af43-802e830830dd"
      ]
    },
    {
      "cluster_id": "e6794d6d-e8b8-42e9-8f90-b2940e146fb9",
      "members": [
        "f8e8a37e-6a86-4071-8a46-c17486c6a426"
      ]
    },
    {
      "cluster_id": "658de6ad-fa34-4d62-b1a8-d4dba2ffb3d8",
      "members": [
        "5e17f8d0-3190-4e64-9c88-7ecf86c72a4d"
      ]
    },
    {
      "cluster_id": "d41663c0-a43a-40f6-ae8e-9e6eeb720de9",
      "members": [
        "4b246f2c-26cd-41f9-a527-6f1d6476d5cc"
      ]
    },
    {
      "cluster_id": "31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8",
      "members": [
        "e6d93d6d-3518-4400-b450-5f48fe896cec"
      ]
    },
    {
      "cluster_id": "68637c5d-53b2-4a1b-b193-4fe1333f1416",
      "members": [
        "2a27e2da-beaa-497a-958c-527da5ef4335"
      ]
    },
    {
      "cluster_id": "02e0cfd6-814a-4276-b8cf-66540b7686e7",
      "members": [
        "d7b4f1b3-35c7-4658-9644-8fa6c89b17f2"
      ]
    },
    {
      "cluster_id": "310f4e19-f7f5-403e-af6f-b2064fadd246",
      "members": [
        "d07afc6c-f8bf-4950-9736-abb677633b8d"
      ]
    },
    {
      "cluster_id": "914ca89d-e967-443c-9856-6a5b040a0496",
      "members": [
        "ac9c574b-d539-4fe7-8d70-6980324b0d5e"
      ]
    },
    {
      "cluster_id": "151738b2-0d24-44aa-896c-fa16a74db380",
      "members": [
        "2452b572-745d-4e14-b417-4111e352b92d"
      ]
    },
    {
      "cluster_id": "0f047203-3949-4e82-86d9-77d6fe7af9c8",
      "members": [
        "8356bc2a-d254-4687-bfca-d0574d34234d"
      ]
    },
    {
      "cluster_id": "469e17e6-447a-4bc6-9bab-f2cb595f07e0",
      "members": [
        "1edae4f0-e767-425e-b9ef-a2582e50803c",
        "8858128f-3967-4c92-b226-f140e0a703ed"
      ]
    },
    {
      "cluster_id": "38711d17-ac82-464c-a077-7a82e0d362fd",
      "members": [
        "201bd170-dafb-4b7f-8992-8ca1076fa5c0"
      ]
    },
    {
      "cluster_id": "0ecc8673-156d-41da-a0bd-8ceb3bd503b8",
      "members": [
        "f48228a1-9226-4a72-8363-5b731e9f40f7"
      ]
    },
    {
      "cluster_id": "594e0474-2d9d-4582-8963-9fe946d49a1e",
      "members": [
        "8d33e790-22e2-4d63-bb4b-6b1fa1107dbb"
      ]
    },
    {
      "cluster_id": "719ee837-abdf-462d-a985-984d0a2eb167",
      "members": [
        "0fdc3f1e-a803-49d7-8551-6143d0d355b1"
      ]
    },
    {
      "cluster_id": "d68f430a-9578-4b21-a27f-13f1a9f8f629",
      "members": [
        "3c73cae0-75fb-4152-bf44-4e18473a5e5d"
      ]
    },
    {
      "cluster_id": "08dc80e4-6332-48c1-99f1-a1bc6a88f48b",
      "members": [
        "1f17b118-8369-4029-a521-a42b43a53117"
      ]
    },
    {
      "cluster_id": "1c849e20-6024-47fa-80b4-e611385ba612",
      "members": [
        "f2be7c90-9b9b-4fb0-a65c-4f848a11c4ec",
        "83e130ce-6945-4d0d-b53f-d6e5ae90d013"
      ]
    },
    {
      "cluster_id": "4a942b66-0607-413f-8ee5-b6f6ddbbd034",
      "members": [
        "2ebc44ff-8117-4192-829c-584395c41f04"
      ]
    },
    {
      "cluster_id": "35ff7a5e-40b8-42ad-9379-7ba830c9445f",
      "members": [
        "4d3d9bba-fe97-4063-8039-8189ff9eb830"
      ]
    },
    {
      "cluster_id": "5f266248-0a3e-4fc2-afec-4bfc7ba1a633",
      "members": [
        "3765ef51-6b00-4412-b8b5-d783322a2f98"
      ]
    },
    {
      "cluster_id": "990aca8f-a2db-4ebd-85da-744c488a8d2b",
      "members": [
        "1b6c65e0-53a5-4b0a-8362-e35b991c32d2"
      ]
    },
    {
      "cluster_id": "bba9ba69-2957-4432-9f56-bcb77e8342e2",
      "members": [
        "8b897291-7570-45a3-ad27-c89c40e46fa6"
      ]
    },
    {
      "cluster_id": "38b659e5-9f63-40c6-bab6-c8934148aa21",
      "members": [
        "4d0c614b-0cb6-499c-8dcb-bf785e560cfa"
      ]
    },
    {
      "cluster_id": "93429ef7-e07c-4686-85f7-679d49d1274f",
      "members": [
        "6b602515-6205-4c47-abf3-c12f4e1efdd8"
      ]
    },
    {
      "cluster_id": "24accb31-401b-42c1-bd69-e81c04cb2530",
      "members": [
        "e6683a4b-da3c-499c-a23f-bb273f0a18fe"
      ]
    },
    {
      "cluster_id": "4cf8f034-c2c7-4891-81cd-bb23d16f75ec",
      "members": [
        "25fd6249-e949-4631-84fb-f1405e61dea4"
      ]
    },
    {
      "cluster_id": "f20e8a65-5412-4f81-81b6-1570f9619cbd",
      "members": [
        "705ecf79-6e86-4810-b490-c16d6a7e79df"
      ]
    },
    {
      "cluster_id": "478c6562-e71b-47f9-8079-8463bc1262ba",
      "members": [
        "04a33121-8c9f-4e66-b86e-04b2bc7ae9b3"
      ]
    },
    {
      "cluster_id": "03ec1dbc-4ed4-48f3-b875-cc73a019f7f0",
      "members": [
        "b10e74b5-8563-4e07-a785-d9e62c029e0c"
      ]
    },
    {
      "cluster_id": "3d9f2bb4-f1d6-41ac-be1a-ac1194130144",
      "members": [
        "ba5e111e-c865-426b-bfa9-766e567f9b00"
      ]
    },
    {
      "cluster_id": "45803076-0698-48ef-a2b4-10f190885998",
      "members": [
        "e7bda970-2973-461d-bf8f-13801534e927"
      ]
    },
    {
      "cluster_id": "035bc55a-3ae4-48b4-942f-bbef3d308147",
      "members": [
        "a256890c-78e3-4b94-b0a6-adfbd7fcd013"
      ]
    },
    {
      "cluster_id": "4ef708bd-198e-4a9e-9652-a1b08bc50fd9",
      "members": [
        "a9d64ed5-d644-4f06-bc99-b14bd6b9ad36",
        "d948ec84-aa50-4245-b854-5ee6998c7962",
        "546e7fcd-17ae-4983-9cf8-82284e24b39b"
      ]
    },
    {
      "cluster_id": "dfbd57d9-b4af-48fe-adde-4b27c203374e",
      "members": [
        "d4b1b125-6251-4b00-b38d-d36e119b32a4"
      ]
    },
    {
      "cluster_id": "02774183-9d71-4dfd-8f60-b54cf275fbb8",
      "members": [
        "7b268201-9047-4d4a-a308-879db7198ea3"
      ]
    },
    {
      "cluster_id": "29fe240a-81f6-4aef-a8b5-3cacf3e3985a",
      "members": [
        "cb07e2af-aff1-49c2-b82c-eac07c8917dd"
      ]
    },
    {
      "cluster_id": "463ff506-01da-43ee-96ab-3704e89855e2",
      "members": [
        "ddb36507-88b7-494f-8e9e-f9d8f9920656",
        "04c9412b-bbed-4091-a914-6dc969953182"
      ]
    },
    {
      "cluster_id": "8d20ee1c-7a34-4de3-a19e-635d0eb460b0",
      "members": [
        "13bc353e-afcb-45d4-a669-5c74b8b3974b",
        "3417b059-848a-45db-b984-f5828b7e0775"
      ]
    },
    {
      "cluster_id": "c537cca1-8aec-41b9-96db-837f4d59c8e4",
      "members": [
        "45b43966-a14f-4601-aa6f-f71455455a6a"
      ]
    },
    {
      "cluster_id": "55a85a41-dc09-4546-82c9-33ba7368eb9a",
      "members": [
        "41fe581b-fd35-4726-8562-d8b53adbc04d"
      ]
    },
    {
      "cluster_id": "b8208758-3ffb-41f1-97e7-30e90da08e44",
      "members": [
        "eb95bd57-4eb2-46ba-a0dd-fba6ea1f6bda"
      ]
    },
    {
      "cluster_id": "d37ab208-5122-4b14-a2ce-fa0d51ab2a4b",
      "members": [
        "717e16a2-b4d8-477a-86c2-54a02be5ffe2"
      ]
    },
    {
      "cluster_id": "b9ff3223-8bd6-4360-8edc-fa3409378e90",
      "members": [
        "7256ebf7-6850-4ad1-b34e-fbca0739ae2d",
        "2c259afd-f542-4627-88d8-3750d2b59ae7"
      ]
    },
    {
      "cluster_id": "5443e2c0-e92d-4c21-ba1b-b0cdb2302769",
      "members": [
        "8a0c1978-1d61-4edc-94e7-56a5fa204143"
      ]
    },
    {
      "cluster_id": "227d3de7-5437-4b66-857c-d51afef721c1",
      "members": [
        "14252dd5-081b-48c5-a9bb-81baa766b054"
      ]
    },
    {
      "cluster_id": "634ebbc5-474d-42c0-bf34-498666dade49",
      "members": [
        "3704c051-75f4-481a-a47f-2eec66167fbf"
      ]
    },
    {
      "cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "members": [
        "e6f94f3b-de14-46dc-8947-0892c54963d9",
        "00e918f9-e1ad-4cb6-82ea-c57ef9f80f87"
      ]
    },
    {
      "cluster_id": "f502dcb8-0d11-41eb-afba-f50e74157a5b",
      "members": [
        "1095ef48-c0a4-4bfc-8a82-ee80cec0f80e"
      ]
    },
    {
      "cluster_id": "252d476c-5ce3-4a28-9ab5-6406955b15b2",
      "members": [
        "53ab3c6a-5466-42a0-9451-1e63fb55016b"
      ]
    },
    {
      "cluster_id": "1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07",
      "members": [
        "e4707b72-cdd0-49e5-9d11-b19f9d30d22d",
        "b0d48266-96c9-4672-9d0d-180af4f746b6"
      ]
    },
    {
      "cluster_id": "774b6df5-ef29-47f3-9ae9-d88dbd184e38",
      "members": [
        "58a8417f-f648-4a83-b4be-780d4c190a88"
      ]
    },
    {
      "cluster_id": "4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8",
      "members": [
        "55bf2059-688f-43e6-ade3-8ce980649e1d"
      ]
    },
    {
      "cluster_id": "ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db",
      "members": [
        "0d403ca7-7770-44ac-96dc-2a56f17d8b3c"
      ]
    },
    {
      "cluster_id": "07e66c00-a616-4a75-b1a2-efe8ff1edd22",
      "members": [
        "74600ca3-b2a9-4375-9cfd-fd2742ec9d4d"
      ]
    },
    {
      "cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "members": [
        "b057b3b9-cd53-4894-92a5-f2830f70b8d3",
        "140c722b-2bd4-4e8e-b7a7-faab1c343974",
        "44a3fb61-0f2b-41bd-9c56-dedb56b38786",
        "b8b39438-ddcf-47ac-852c-d9a001d59edf"
      ]
    },
    {
      "cluster_id": "4d2dc30e-97f5-49d3-80df-c343048e6856",
      "members": [
        "a6f82707-218f-43ec-aad2-6faa25593c13"
      ]
    },
    {
      "cluster_id": "fe6adf14-e7af-49eb-8b83-de4001fbc495",
      "members": [
        "b45e717d-ffa8-4ab5-8872-95370f8027f9"
      ]
    },
    {
      "cluster_id": "060a7355-d23c-448a-8514-2034a0d11495",
      "members": [
        "cd9c32c3-81d0-44d8-bbff-fc8c2896a4e4",
        "e19d4626-676f-46c8-a860-8a1ae27e4c3b"
      ]
    },
    {
      "cluster_id": "bed08ef5-4cb1-4f05-b2d4-a996242acd93",
      "members": [
        "2b147f86-fc25-44d1-aeab-ecd8aefa2b6e"
      ]
    },
    {
      "cluster_id": "ff920ca0-1e39-41be-ac8f-cd0534048634",
      "members": [
        "598aeb2e-dece-423d-91ce-264ed870d837"
      ]
    },
    {
      "cluster_id": "1cffe038-9a46-45f7-bcc3-f26914315286",
      "members": [
        "e6095ac2-1356-414e-8a1c-f0b2cc8822b9"
      ]
    },
    {
      "cluster_id": "ea08b9f4-137e-40ca-ae54-2e396aa18fc5",
      "members": [
        "fae51888-22a7-4826-b71d-1d9befc16cd4",
        "a260e8e8-ef5f-4e64-8f76-0bc6fbe678ae"
      ]
    },
    {
      "cluster_id": "3b355bb3-b565-4742-b6f4-50c6f509a1ec",
      "members": [
        "12055060-feef-4713-8995-9a76c8499749"
      ]
    },
    {
      "cluster_id": "0726cfa9-d89b-45b4-922f-553fde14346a",
      "members": [
        "887b0d36-bbc8-43a7-b5e1-4d384e2568d9"
      ]
    },
    {
      "cluster_id": "7f7310ca-5512-45fa-8f93-1b6555e791c0",
      "members": [
        "e59fd3ee-63ae-4ece-accb-0fcf50901d4b"
      ]
    },
    {
      "cluster_id": "54a8d4bb-c88c-46df-a439-6be0dfcdce0d",
      "members": [
        "fa85abfb-5251-4852-855a-ef9fdeeec1c1"
      ]
    },
    {
      "cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "members": [
        "be579522-ce94-4a53-8c1f-c8f8e2b35ad0",
        "d0c13a79-f140-46e4-acfb-c1195305cd65"
      ]
    },
    {
      "cluster_id": "18699af2-76ba-4b44-8dd8-cbb2b538e559",
      "members": [
        "51af9d48-4a9c-4ea4-9f7e-70c38d0ca666"
      ]
    },
    {
      "cluster_id": "f74a80e3-1327-4636-a252-f4ca8a5b90f7",
      "members": [
        "812e2115-60b4-452f-b44d-cd5777875496"
      ]
    },
    {
      "cluster_id": "e12046ad-ffee-4bf5-90ec-51d127135711",
      "members": [
        "21027d00-a6f2-4c55-88ee-86c3a70d6d53"
      ]
    },
    {
      "cluster_id": "4692c588-5e24-491c-9044-3d7dd7c0a2d7",
      "members": [
        "cc2f09e1-bc82-40a5-90db-e1040af323d4"
      ]
    },
    {
      "cluster_id": "481b0645-4bcd-4df1-ae15-b184375e551e",
      "members": [
        "1eba351b-5552-4e28-ae20-82867d650d2b"
      ]
    },
    {
      "cluster_id": "5eea51f7-7e2e-46d8-8dff-0d1a87db87b5",
      "members": [
        "fac74e7f-c900-4f5f-91ec-4a777460f35c"
      ]
    },
    {
      "cluster_id": "d10a4ec7-a74e-4016-996b-f1f3a3c6527f",
      "members": [
        "8e8ca0bf-e85d-42c0-88f3-d5cb63349dd9"
      ]
    },
    {
      "cluster_id": "23adc402-b3b7-489f-bbe8-5d7825946d77",
      "members": [
        "0964821f-62b5-4f6d-957a-cf486c6ef6f4",
        "35177478-d6ba-4d8e-b6b0-d026b89a18b3"
      ]
    },
    {
      "cluster_id": "571676ab-8830-47d5-a21a-ef55f09caa73",
      "members": [
        "5acfcc66-a473-4cf8-b96b-b77390d3a232"
      ]
    },
    {
      "cluster_id": "8b0aef83-1693-4fa2-8559-a133b18a2dbb",
      "members": [
        "49dcec77-6a80-4a31-b76d-f30a6bbcc836",
        "58ffab6b-fa0a-454b-b303-57a5b0ea6909"
      ]
    },
    {
      "cluster_id": "840ac263-91de-449d-b701-c05a4522f3b3",
      "members": [
        "800677b4-581f-457c-9366-8c4d0574d7d2"
      ]
    },
    {
      "cluster_id": "fd537f2d-3616-4303-9edb-81c90d602f6d",
      "members": [
        "7c80c70b-5355-4101-a131-3fb5033c5466"
      ]
    },
    {
      "cluster_id": "9c52e5bb-8493-4b3c-8444-69598adc8932",
      "members": [
        "f818e45f-f7fa-4a5f-8f89-f842f6c6ecec",
        "51aaa1c6-de52-447f-9184-f66d905b0b93"
      ]
    },
    {
      "cluster_id": "707f482d-8ff7-4cc9-a14d-99540ac35950",
      "members": [
        "57e5f68f-fef5-4d51-a787-8cfbb1f2b7da"
      ]
    },
    {
      "cluster_id": "35218630-91b1-47a4-87cf-29094bd87289",
      "members": [
        "cdbde4b9-7685-4c13-8654-d1417a5d5ee0"
      ]
    },
    {
      "cluster_id": "6d7d1320-a896-4471-aa98-60a45946bc57",
      "members": [
        "b6c27490-dd7a-46bc-b782-cfd7f9bead27"
      ]
    },
    {
      "cluster_id": "f17dbb9a-8968-4ade-a774-02688b6da89a",
      "members": [
        "a27ce914-e260-4d08-ac3a-432980fd62b2"
      ]
    },
    {
      "cluster_id": "17eaa25c-625f-4414-b1ad-78d904209f81",
      "members": [
        "490533e1-dfdd-4459-8e69-84a77de32982"
      ]
    },
    {
      "cluster_id": "317ae87f-a4ca-4e46-9ff8-1bebad9fd04f",
      "members": [
        "77e80b1b-3b86-497e-9307-f52b8e26e1f6"
      ]
    },
    {
      "cluster_id": "0ee142b2-6805-43f4-b8d5-34f76c2c799e",
      "members": [
        "48931092-1268-4b65-8ed1-3d8321ab4607"
      ]
    },
    {
      "cluster_id": "2df1a526-a92c-44a2-a3b2-202bf1d7f6d9",
      "members": [
        "1ec753ae-0076-44ca-96d3-6c8bef211a7e"
      ]
    },
    {
      "cluster_id": "c9335a55-7c59-42cb-98be-e69b4262faa0",
      "members": [
        "93cacc91-bec7-49ba-85fc-fdd8c3a4e356"
      ]
    },
    {
      "cluster_id": "22c3b77e-fa98-44e1-b509-f721cef0815f",
      "members": [
        "1d9d7c36-2de2-4de3-9779-1b514ea4cb97"
      ]
    },
    {
      "cluster_id": "af503db6-fcf4-45f9-9501-f2732e2af4f7",
      "members": [
        "ab8713ea-0916-4c03-b7ea-9bed8792db33"
      ]
    },
    {
      "cluster_id": "5528714b-b0b8-40d9-850a-99905744c056",
      "members": [
        "dcebb25d-c474-4240-aae5-10924c56f7d8"
      ]
    },
    {
      "cluster_id": "90a4e218-d5e9-4e12-b842-f6c8e272cb28",
      "members": [
        "47c8f442-152b-47d6-afd9-09434f7556ae"
      ]
    },
    {
      "cluster_id": "170448e1-fefc-424b-b5a4-23941f88389e",
      "members": [
        "a4202ed7-037f-4047-85e5-bfc3bb24d142"
      ]
    },
    {
      "cluster_id": "6717f23b-7a46-4774-9d7d-76c5eb0bdde2",
      "members": [
        "514a8a9b-bc78-4e9a-9d68-8eb6b36fed1d"
      ]
    },
    {
      "cluster_id": "7b578c6f-7be6-4c78-8bf3-3f66b6797db5",
      "members": [
        "f5785d4e-bb24-4967-93a2-a6279cdb2aa3"
      ]
    },
    {
      "cluster_id": "4e7d68ff-7bd2-4949-affb-c71a8a76240a",
      "members": [
        "7fbe7e93-7fdf-4ab5-9d0a-b2224b8c001d"
      ]
    },
    {
      "cluster_id": "61922f77-a020-4916-b901-44fe7982b789",
      "members": [
        "7ca8d60f-df10-4ca4-9389-05952701211e"
      ]
    },
    {
      "cluster_id": "6e8d0f46-aead-4efe-a267-3f325cfe8dec",
      "members": [
        "fe8cfbf5-a62f-4e4e-a3d8-4fce6f205412"
      ]
    },
    {
      "cluster_id": "6c2771d0-bfd3-428e-a6d5-47a3f027d3a6",
      "members": [
        "4f61b269-b18f-440f-86f2-071070cf39f7"
      ]
    },
    {
      "cluster_id": "8a2e1f2c-6d19-479b-811f-3ccec4820a64",
      "members": [
        "48dcacb1-a6d4-4ffd-ae0d-19020e4a4256"
      ]
    },
    {
      "cluster_id": "b31e61b9-2010-4063-88bd-0eced0599429",
      "members": [
        "e893b0cb-deff-41b0-8a58-d9f7e330290b"
      ]
    },
    {
      "cluster_id": "f4cd4d9b-6b2b-454a-ae24-3a0150790009",
      "members": [
        "67e3ddb6-2eb8-443a-91e4-4a47d24d0ca2"
      ]
    },
    {
      "cluster_id": "33e1162a-91ae-476d-b4d5-3b1e2f01a5c1",
      "members": [
        "9d307cba-10c6-4d4c-85a8-ea190c9e38f1"
      ]
    },
    {
      "cluster_id": "f8cc40a9-e215-46da-bdf5-b5efc622bb40",
      "members": [
        "381b986c-714c-4d28-bf25-4946c45f7085"
      ]
    },
    {
      "cluster_id": "f8052bb9-bad3-47eb-9141-dec76f63f661",
      "members": [
        "496f09c0-85ea-419e-b170-6ca90d3cbc34"
      ]
    },
    {
      "cluster_id": "ffb2c778-a1f6-402c-8381-54550bf56799",
      "members": [
        "3c7bbead-a5a5-4a68-9acf-7d3319a7fb38"
      ]
    },
    {
      "cluster_id": "500957af-7f87-40ca-b575-44450d181bfa",
      "members": [
        "4ce45b79-2cbe-4d99-96eb-07d582e80fd8"
      ]
    },
    {
      "cluster_id": "b874b38b-169d-4b90-b373-ae919f14c5a0",
      "members": [
        "0ed14139-129e-443f-b11b-fdde310f75d9"
      ]
    },
    {
      "cluster_id": "fc264446-1206-43b0-b6e2-29d7fc43d99c",
      "members": [
        "cb71a94d-8f0d-4be5-9737-fa44d24d6c90"
      ]
    },
    {
      "cluster_id": "fa484c7a-b508-4b38-90f3-04e6ca143d03",
      "members": [
        "0c61da08-e4df-4b4f-944f-c5a065acace5"
      ]
    },
    {
      "cluster_id": "e9c91d2d-9c77-43dc-9ccc-c00049984a01",
      "members": [
        "b61e932c-d0e5-4154-be32-f0ac3c52fed0",
        "27285168-d87c-46d5-b795-95c75474a413"
      ]
    },
    {
      "cluster_id": "bd0e72d0-0f07-4c8e-ba6f-6a4178be6cee",
      "members": [
        "8ed4f17b-38af-4dfb-9181-18f56598cd3c"
      ]
    },
    {
      "cluster_id": "5fbc247f-99df-408a-8188-29a28a5f5737",
      "members": [
        "8f7421cf-82dc-48c1-98f5-c7e7321e37b3"
      ]
    },
    {
      "cluster_id": "558e806a-d249-4f8a-8e7e-fb4b28552537",
      "members": [
        "ce31105a-13fb-4324-877c-1143670d251b"
      ]
    },
    {
      "cluster_id": "a6d51f65-13a0-42d8-b6fe-66f9daf5bd01",
      "members": [
        "4b5dde87-2185-48d5-8f08-8cf82f888f78"
      ]
    },
    {
      "cluster_id": "87e60b81-7893-469a-8c14-40e3d6122aa1",
      "members": [
        "0c13fc8f-d3f9-42e0-afb5-4e1ec4d48ca2"
      ]
    },
    {
      "cluster_id": "c2417696-bc64-4d4a-b3a4-d5d9e3cefb38",
      "members": [
        "a7ea3f1a-7b3e-4f52-8f24-7549557e04ad"
      ]
    },
    {
      "cluster_id": "0a79d737-f594-464b-b3d2-afd57c6349f1",
      "members": [
        "3b2128b4-4590-4671-b7cd-02a16eadf477"
      ]
    },
    {
      "cluster_id": "ce637d4c-890f-483b-9ed8-d8130682b8ac",
      "members": [
        "833d8aa2-87f3-43d9-b6a7-840cca9c261a"
      ]
    },
    {
      "cluster_id": "5a50a1fe-c68d-46bc-b14a-9fe07afb2e36",
      "members": [
        "1d535066-043b-48ae-b72f-bb725a0dc533"
      ]
    },
    {
      "cluster_id": "f4175686-5e4d-4fb0-a465-bed7586f6615",
      "members": [
        "6f64e734-8b4d-4d8f-a346-c4d16a69ba8b",
        "4bc13bbb-6196-4f52-8bd7-0e0ec095f388"
      ]
    },
    {
      "cluster_id": "a0977c56-cc0a-4fc9-a35d-0f1fe8c43b6d",
      "members": [
        "e7d790dc-8255-4a27-8ca9-8ecc3deb5bc4"
      ]
    },
    {
      "cluster_id": "09183ea2-b51f-4c35-a3c2-3fbf476237cb",
      "members": [
        "d51a391a-6570-4599-b28e-5b0598458b94"
      ]
    },
    {
      "cluster_id": "db5a201e-a58a-46dc-91a0-0072432f56c4",
      "members": [
        "0885b665-80fc-405b-98c3-3ee4dc2ebc96"
      ]
    },
    {
      "cluster_id": "40460222-6c35-47b7-be68-29a1138ce819",
      "members": [
        "34b64dd0-60ec-464a-b7f8-af46028d73d4"
      ]
    },
    {
      "cluster_id": "767a107b-6141-45c6-9ffe-6f7fde1b3426",
      "members": [
        "66edd251-7fa8-42f8-b860-e9fdc90e657a"
      ]
    },
    {
      "cluster_id": "1a689731-c588-4661-b0b5-8beb94a95bb4",
      "members": [
        "0f7df7e2-9b40-4791-bf10-de0aaa56e74c"
      ]
    },
    {
      "cluster_id": "2247b006-05c5-406e-a6b2-d87e6eb59702",
      "members": [
        "5770a376-3a58-45b3-b9c7-4139b4da1cf5"
      ]
    },
    {
      "cluster_id": "12ce4240-07a8-40e1-acc7-141144ad6c5d",
      "members": [
        "a08c9c34-13b1-4b32-94c7-c670511aeb6b"
      ]
    },
    {
      "cluster_id": "52f4370b-6902-4abd-9ee9-d4310ae49cb2",
      "members": [
        "b59d921d-d502-41a8-9bd6-26a16eea2d90"
      ]
    },
    {
      "cluster_id": "4575f267-4553-4c7c-916e-359800e4fb24",
      "members": [
        "5ccdbbf0-2376-4f95-8321-d746fa931186"
      ]
    },
    {
      "cluster_id": "cef32527-0357-47cf-9fee-19bd0f13e11a",
      "members": [
        "f1e088e6-b878-443c-ad67-f37a3c1428ab"
      ]
    },
    {
      "cluster_id": "a80ecbee-c55e-46fb-a302-1137d87bdcfa",
      "members": [
        "c7da2e2a-b68c-45ad-a5c6-61096ce211be"
      ]
    },
    {
      "cluster_id": "df94ae50-99ca-4e54-802c-ae4f92bf2a1d",
      "members": [
        "040dec4c-2428-4f42-b5a0-68d2f5e4071e"
      ]
    },
    {
      "cluster_id": "4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1",
      "members": [
        "df336382-0e90-41dd-8ebd-a899eae43674"
      ]
    },
    {
      "cluster_id": "dd5764ad-ed57-4067-b6a4-35ca15790cc2",
      "members": [
        "81a64a01-ce6c-4c66-9537-c97b8fad0a54",
        "970dbc26-0b71-46b5-9e3b-d3d66cffe827"
      ]
    },
    {
      "cluster_id": "bd0a892b-884e-4c98-8690-8f25949dbaed",
      "members": [
        "3aa43b0e-368d-4d2d-920c-2bdf99fb3216"
      ]
    },
    {
      "cluster_id": "d78f22d5-c64c-4786-833e-21ebb584c006",
      "members": [
        "21a386c6-a8c0-48cd-9378-79cc4cf98735"
      ]
    },
    {
      "cluster_id": "b65267b2-a6b3-4938-aff4-8dde024d5b46",
      "members": [
        "1db9ddb6-3d68-48a0-be81-b5b62a2a1b11"
      ]
    },
    {
      "cluster_id": "6635c105-dcdb-4bd7-9a1d-4db57f43d53b",
      "members": [
        "97e7a0bd-d797-473c-a610-4279ac90663f"
      ]
    },
    {
      "cluster_id": "9a03a84a-f375-4382-bf36-e4f5df1b4795",
      "members": [
        "be6c4f4b-813c-437b-9081-5cdae97ea306"
      ]
    },
    {
      "cluster_id": "4f68034e-7758-4136-94fe-82331ab7df47",
      "members": [
        "d20c48d1-f568-44d9-a525-23bd770a03ab"
      ]
    },
    {
      "cluster_id": "621b2187-e651-4a6f-becc-2a2a2cd444a2",
      "members": [
        "50aafcf4-a03e-4155-8c97-9aac0561190d"
      ]
    },
    {
      "cluster_id": "0de86638-0241-412b-ab2a-b233d85153a4",
      "members": [
        "683f15ce-dced-4660-85d4-c95cd43c23c7"
      ]
    },
    {
      "cluster_id": "fb6ff34e-94b0-4910-b613-9ebb9af0b6b6",
      "members": [
        "dd96c0e8-8609-47ec-a1a8-bf3ea961e073"
      ]
    },
    {
      "cluster_id": "e9b06ff3-55a4-46a5-87d3-266dff0dc9c1",
      "members": [
        "a1d9fa60-1b33-407a-8a7b-098c15f781e2"
      ]
    },
    {
      "cluster_id": "f9741213-db12-438e-ba4b-5df13a3381e4",
      "members": [
        "ade8b013-f783-45c1-98c2-1a7f3507d997"
      ]
    },
    {
      "cluster_id": "f72eb4bb-112f-4556-a279-ad745cb4894c",
      "members": [
        "780cdf62-aff5-4110-8e69-01754cc6c09e"
      ]
    },
    {
      "cluster_id": "65545a07-9406-46c5-9357-571d95749394",
      "members": [
        "4e679122-0ca3-4471-a107-5f85bb5443bf"
      ]
    },
    {
      "cluster_id": "c8657dfd-ec8f-4884-9c32-c4d6cac2c0f4",
      "members": [
        "b1eb74a2-49a0-41d3-b342-abdbfa1efe71"
      ]
    },
    {
      "cluster_id": "0c398c2c-4672-4f1e-ba98-17d7320a9537",
      "members": [
        "4aa72748-0ad2-49be-aad1-b95e37da3a2a"
      ]
    },
    {
      "cluster_id": "cf096384-5ede-4929-b992-9e6ee20d6a8b",
      "members": [
        "fca8eab7-2aa1-4276-a101-a285da0affbc"
      ]
    },
    {
      "cluster_id": "0261ee84-1c1e-4042-9226-f1085216eef2",
      "members": [
        "03574c37-742c-4770-ba1b-d8c6c3e4d8be"
      ]
    },
    {
      "cluster_id": "ccd87163-f5c4-4a49-b3d3-5d5c4788834c",
      "members": [
        "b26a0e68-fde1-4d66-a7d2-5c1e54629b60"
      ]
    },
    {
      "cluster_id": "1e35c814-682d-4b74-be8b-2867b370b971",
      "members": [
        "0ec7f5cc-5e61-471e-b6ba-654ac11c0af5"
      ]
    },
    {
      "cluster_id": "3db5575b-e4cd-4afc-835e-707980be99ac",
      "members": [
        "301a9f91-1c50-4467-83f2-77688d7deb19"
      ]
    },
    {
      "cluster_id": "a986747d-76c4-4786-b8af-6e1c3537a9eb",
      "members": [
        "ba39436c-49bc-48c4-ab96-805ef9ca0590"
      ]
    },
    {
      "cluster_id": "d3b98f44-6b27-4d30-a29b-fd80c7643f1b",
      "members": [
        "f39abf0d-00c9-4096-8087-54873ff61fa6"
      ]
    },
    {
      "cluster_id": "ea54647f-e4a4-46e7-bf16-66e30583a4a6",
      "members": [
        "02046bbf-5ad3-45ff-b1c1-e73942023b9b"
      ]
    },
    {
      "cluster_id": "d089a914-1c7d-48b8-9c48-7a1b65f152b1",
      "members": [
        "fec5595b-21ec-460d-bafb-b5b19c7ef652"
      ]
    },
    {
      "cluster_id": "2568c212-fcce-44e5-930c-3fe63b8f0d65",
      "members": [
        "fa53f6ea-9cb9-45ca-ae67-e1f013dd59de"
      ]
    },
    {
      "cluster_id": "4d2c8d1c-73d7-42b1-87cb-56c8ddf68982",
      "members": [
        "8fd7bf1a-45d1-4bf4-a6cb-3d32320b7683"
      ]
    },
    {
      "cluster_id": "e0b76993-43d7-4b38-b891-9ad858a2c5f6",
      "members": [
        "8d49ec4b-b1e8-406b-8b1f-8c5fdb7a636b"
      ]
    },
    {
      "cluster_id": "d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3",
      "members": [
        "0aa879c0-b7fe-47c4-8027-e48da678618f"
      ]
    },
    {
      "cluster_id": "54bf8eb2-6975-454f-a48b-59abffdfe4f4",
      "members": [
        "00ab1807-cf95-4e72-8394-2e9689140536"
      ]
    },
    {
      "cluster_id": "12605708-2ac7-455e-a636-1d8a235af813",
      "members": [
        "0a551238-3582-446a-806e-0f8443f302cb"
      ]
    },
    {
      "cluster_id": "818db8b7-0e38-4d06-8f87-4de475ce7556",
      "members": [
        "d18e9a0b-a6d7-47a4-b673-21d5f2eaf483"
      ]
    },
    {
      "cluster_id": "42fd849e-0fa9-43a8-b5fa-5cc192351c79",
      "members": [
        "a40e602a-c272-43c8-8c71-cebb6598a675"
      ]
    },
    {
      "cluster_id": "2b7a55b4-92f1-4438-b42d-086b564be154",
      "members": [
        "86b9cf66-03d4-4167-9c04-a1450db98ded"
      ]
    },
    {
      "cluster_id": "5b5325b9-59bb-4b91-9a19-8889095dd496",
      "members": [
        "c9a5e64f-b02b-49dc-8775-3842f4736fd7"
      ]
    },
    {
      "cluster_id": "f55fbefe-4ee7-4bc9-a05f-0bee3b933ccd",
      "members": [
        "1d7a571f-302c-43bb-9c0e-d22f93415455"
      ]
    },
    {
      "cluster_id": "6e5c19c1-853c-4797-84d8-7f68386994d3",
      "members": [
        "cca498e1-8ac8-460c-a82d-4e0e49181f6e"
      ]
    },
    {
      "cluster_id": "43966195-88ed-478f-bd22-9c59b6eda45a",
      "members": [
        "c64cbb4b-58a9-4606-9025-8605cf79296d"
      ]
    },
    {
      "cluster_id": "27b386d8-58df-4b19-a269-36bb2400c94c",
      "members": [
        "68309499-78da-4bbe-af16-4f5b2d11c215"
      ]
    },
    {
      "cluster_id": "8dca8952-fbff-4b47-ba25-a7640fe52fba",
      "members": [
        "9f4836cc-879c-4406-8ed7-bdce9b8b99e1",
        "5923c121-b933-4b0c-8c5e-8ec99a127cec"
      ]
    },
    {
      "cluster_id": "894e29d9-1e82-4e00-b1eb-e5092d46e327",
      "members": [
        "d1abf8d0-9d30-4d4f-8219-bb00fdef6ac5"
      ]
    },
    {
      "cluster_id": "bc70c00b-dffe-4092-a775-4a9734094547",
      "members": [
        "938259cd-de6f-4630-996d-bca53f1e39f4"
      ]
    },
    {
      "cluster_id": "d14e115a-dd46-437f-8a57-5893395dde5f",
      "members": [
        "12391047-4214-4422-bc58-91fbdadc33b7"
      ]
    },
    {
      "cluster_id": "a5744137-28c3-42a2-94a7-6f90f74e8a86",
      "members": [
        "a4a77ccd-9f42-4633-a11f-13e95e7fd6d0"
      ]
    },
    {
      "cluster_id": "60b95622-d70d-459f-9ef4-53d53c239154",
      "members": [
        "2a6c92de-99b2-4e5e-8618-d3097c99ff5d"
      ]
    },
    {
      "cluster_id": "98a5a190-c887-4ce2-b53f-011c39183ade",
      "members": [
        "1b92e69c-30d7-4aab-9caf-027682c0f685"
      ]
    },
    {
      "cluster_id": "99b20734-bb32-4aff-b60b-a976139937c2",
      "members": [
        "9b42133b-cf29-42c8-b877-34e158bd928d",
        "01440c79-b4af-435a-b2d3-9f6e68d2ebad"
      ]
    },
    {
      "cluster_id": "5b0ba6ac-d65c-49f0-9ed7-62610378c0e1",
      "members": [
        "af5ce828-ecb0-4b25-98ec-a073e63c0268"
      ]
    },
    {
      "cluster_id": "fd127341-6938-4e10-8b5d-771537846e8c",
      "members": [
        "f09a8f81-dd52-4d4a-9570-5491befa2a8f"
      ]
    },
    {
      "cluster_id": "9f69b38a-0ed5-48e5-ac15-7f5ccfedc99f",
      "members": [
        "92e48c53-cdf7-4f84-946f-ac5adcbdd891"
      ]
    },
    {
      "cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "members": [
        "76ca2ffa-87aa-4737-829e-cc18600a8876",
        "d49f1242-551c-4681-88e3-48b841342491"
      ]
    },
    {
      "cluster_id": "4a817862-6fa5-4e7c-8998-977aaad70250",
      "members": [
        "e2f3bbec-8541-4429-984c-cc8a9e76bda2"
      ]
    },
    {
      "cluster_id": "cb7188de-21fe-4631-9d3e-697f1fa246b9",
      "members": [
        "898b4b67-6431-4909-b142-2dda0251889e"
      ]
    },
    {
      "cluster_id": "636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd",
      "members": [
        "4824b6b2-aa5e-4068-8799-3a75ca4e3b50"
      ]
    },
    {
      "cluster_id": "464aaab3-50a7-44d6-8c7a-bdc722ee9f18",
      "members": [
        "b0d9dc0c-0877-48bd-b103-1c083b7b4875"
      ]
    },
    {
      "cluster_id": "b407290e-0e65-4bff-90dc-c2ececfb37ab",
      "members": [
        "b4c58eaf-eb3f-48ba-b081-0f97d60df67b"
      ]
    },
    {
      "cluster_id": "17be823a-a533-4e33-9ba0-969c3b8ddbd0",
      "members": [
        "e9981269-f7c9-4625-9b7b-988f7f6e4ba3",
        "75a03f36-1521-47d2-bc3e-52f932e91ec6"
      ]
    },
    {
      "cluster_id": "626c75be-9b85-4ac5-97e0-e03b79d0191e",
      "members": [
        "bf2c855c-eb7d-44e5-b5fe-720972907414"
      ]
    },
    {
      "cluster_id": "d3777022-58bb-45d2-9153-3e33e4a367f9",
      "members": [
        "86f36e67-beb8-4a42-a030-2cc80150100d"
      ]
    },
    {
      "cluster_id": "e2676bcb-4f6e-4d98-ba58-3d2aff04d940",
      "members": [
        "d793e6a8-97af-4229-a114-e6ecc6f0abdf"
      ]
    },
    {
      "cluster_id": "3d1d7e4c-d40b-4ec4-9450-9fc635a45afd",
      "members": [
        "cf4b4ab5-e024-4963-9e53-684e4e1f377c"
      ]
    },
    {
      "cluster_id": "be3c4edf-6251-45c4-b310-ec9b6650b95f",
      "members": [
        "5416a7a8-6006-48b8-8076-7eb615d10765"
      ]
    },
    {
      "cluster_id": "38520096-281c-4b53-ba64-f7e18dbd525f",
      "members": [
        "ecd6420a-6280-446f-8516-ea47473e1bc4"
      ]
    },
    {
      "cluster_id": "3d545073-748d-4207-8e53-2f9ae214848a",
      "members": [
        "0bf57117-f8d0-4da8-a7d6-7a414366d8d1"
      ]
    },
    {
      "cluster_id": "3dc0cbd1-b381-4df2-846d-e07147e83cbe",
      "members": [
        "7b9b4cf9-59e5-4fab-bd12-349123ec46b5"
      ]
    },
    {
      "cluster_id": "08f66922-af24-4cf8-ae47-3d7a8d80fec9",
      "members": [
        "c6386624-3e0b-4641-a3f2-812f177da49f"
      ]
    },
    {
      "cluster_id": "4b605940-f896-4b59-bf12-36fbeec83b94",
      "members": [
        "fb147f68-fa76-40a2-90df-f4b00b9c712c"
      ]
    },
    {
      "cluster_id": "cbe32f56-0dc5-4870-8a2a-874435ed2ed9",
      "members": [
        "a8994599-1956-426c-85b4-a903f194b187"
      ]
    },
    {
      "cluster_id": "8fed35fe-4af1-484a-bd4d-74f9fac960c8",
      "members": [
        "38b53111-629e-4701-964c-d5a98dab0b48"
      ]
    },
    {
      "cluster_id": "f3735996-484c-447a-8fe4-4cd5c645a0a9",
      "members": [
        "21ab5123-456a-4440-9bbe-73d1fb8575f3"
      ]
    },
    {
      "cluster_id": "5e3e9898-c954-4e10-be52-6e36f5b36c5c",
      "members": [
        "50261868-0760-408c-847e-db061e167d2a"
      ]
    },
    {
      "cluster_id": "3b1124a1-83ad-4acf-aefc-fa570a669706",
      "members": [
        "e52bef89-83ca-49da-8cbe-7dc95e29b77b"
      ]
    },
    {
      "cluster_id": "88dffe0c-cf6a-4d54-b70b-1d2c41a95f47",
      "members": [
        "5326d90b-c708-46d2-ac2f-4c3538990e9d"
      ]
    },
    {
      "cluster_id": "304f9508-2cf0-4ef2-b524-7a5c78978d94",
      "members": [
        "f9c88fc1-bfad-4629-a9bb-79734eaee82b"
      ]
    },
    {
      "cluster_id": "de15f7d6-5167-45b1-bad6-235dd16ae15e",
      "members": [
        "7fea8be9-3838-4114-8b5e-c170a507a2cc"
      ]
    },
    {
      "cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "members": [
        "36f017c8-f887-4fef-aaa0-3d76d2d3ffaf",
        "73540cd3-dc5a-4e7a-b48a-87b447fccd37"
      ]
    },
    {
      "cluster_id": "ad1e5e4c-10d0-4756-a4c9-29132a1c66dc",
      "members": [
        "07d5ccad-b012-4006-945d-684f26fb7453"
      ]
    },
    {
      "cluster_id": "81a839cf-9fe4-4f39-95e1-2ebc94ae6380",
      "members": [
        "b0a04d0a-f88e-440b-9162-46d25831ddb4"
      ]
    },
    {
      "cluster_id": "fefd3acb-14d6-4c0d-ac4a-19da8e48bc75",
      "members": [
        "f9e063d5-7dcf-41b5-afcb-04878ca726ca",
        "f2e65053-2d71-4b6a-9137-3d0a10b89f19"
      ]
    },
    {
      "cluster_id": "664823cc-3309-42a4-9224-e9eaa7ee3fe5",
      "members": [
        "ef854841-2805-4237-a8d5-6cd7b7936870"
      ]
    },
    {
      "cluster_id": "39f5f705-55d1-4470-8928-bfce04d4f7be",
      "members": [
        "fa2b9817-fb16-4e1c-92f0-db463dc26a73"
      ]
    },
    {
      "cluster_id": "c03b0c98-53e3-4757-8e78-30293d823fdb",
      "members": [
        "82024663-672b-4205-9001-5efad1525661"
      ]
    },
    {
      "cluster_id": "aa4340e9-32f1-4ade-ab1e-eae7e384d7d5",
      "members": [
        "7b636bf6-2231-4d09-a5a5-a2bc207be079"
      ]
    },
    {
      "cluster_id": "cb239c20-3722-49db-94a4-29c15a45d8b1",
      "members": [
        "4ff2c46a-29f2-4b6a-972b-ca8feecf0dd4"
      ]
    },
    {
      "cluster_id": "06da14b8-536e-4d2e-83b1-118cfb44829b",
      "members": [
        "43494523-f6c1-4d5d-8eaf-20c099381363",
        "651fa07f-027d-4660-9414-920e8e11c88e"
      ]
    },
    {
      "cluster_id": "7cacaa03-4763-4931-91bd-306a3231361c",
      "members": [
        "1e6ef59b-b97d-4bbe-baa9-9dd55b985cfc"
      ]
    },
    {
      "cluster_id": "c3383556-4a09-4d9a-b202-b1b017162bd3",
      "members": [
        "7ac18437-d326-4a31-92d1-f6c4b9f3acc4"
      ]
    },
    {
      "cluster_id": "71a82b79-aaaf-4fee-8e73-d292675a2e3a",
      "members": [
        "341b7583-7cae-4ae6-95ac-e11dcc0e29e1"
      ]
    },
    {
      "cluster_id": "758ea826-ee1f-4a18-bdaa-e713f20f5573",
      "members": [
        "f41216bd-b2cf-4575-9949-f27343ea781f"
      ]
    },
    {
      "cluster_id": "8567d4c9-fb06-4505-b09d-13b1efafa073",
      "members": [
        "a2b312fa-88d5-4614-8069-bf3ecf3de787",
        "2a34a81c-7f8f-469d-b3e2-0ae4bd923626"
      ]
    },
    {
      "cluster_id": "f75e1405-c093-4f18-a3c7-d59d8bfe94d0",
      "members": [
        "084a5e5f-4ea4-4a61-b599-9e39c1069298"
      ]
    },
    {
      "cluster_id": "b6c282dd-0c14-4dab-a6ce-3f5caafc52b8",
      "members": [
        "6aaf8382-3a8c-4bd9-a1f0-00751972af02"
      ]
    },
    {
      "cluster_id": "9398c496-5e62-4d1b-94c1-e1eeaf48778c",
      "members": [
        "ae8245df-51af-4469-9186-e7dd7bf76c40"
      ]
    },
    {
      "cluster_id": "2d7a7088-3ced-40a0-9677-1d14e1c26d8f",
      "members": [
        "bbfb8767-23ec-4520-8e1c-be6dd2ab6d86"
      ]
    },
    {
      "cluster_id": "a1593cbe-8c39-423f-abae-2707e84a1e5e",
      "members": [
        "77e3123c-bcfe-4e1b-b4c4-4699aa8c7a92"
      ]
    },
    {
      "cluster_id": "04a0ae4a-7a1f-4b83-aea9-9fb4dfa80e1a",
      "members": [
        "a09cfbeb-9296-4296-8a6b-cccd5211b0b4"
      ]
    },
    {
      "cluster_id": "24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca",
      "members": [
        "116d1290-adae-4a0c-afde-ebe2246e93f0"
      ]
    },
    {
      "cluster_id": "90cb536f-af14-4df1-9bdd-da6d690522b4",
      "members": [
        "45ad6727-3b1d-4f45-86a5-853b7d2b7e74"
      ]
    },
    {
      "cluster_id": "d6b6cc03-8c7b-497a-ad1e-0435bb03fbcc",
      "members": [
        "db06a8e5-9666-4016-a019-7b509c500925"
      ]
    },
    {
      "cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "members": [
        "1f058c8c-08ac-46ad-877c-0208691256a3",
        "e0a8a269-5e6a-40ca-b2d5-cae2eb3ab4f3"
      ]
    },
    {
      "cluster_id": "0a8b23b0-e002-4dc9-aefa-6b8b8922f3ff",
      "members": [
        "6bf545cb-3bff-4ddc-8f89-114d02659460"
      ]
    },
    {
      "cluster_id": "4c161c1e-d86e-4fbd-9e49-e99d43b2eedc",
      "members": [
        "3c5f8517-91df-41c8-8459-0d77c6dc7d7e"
      ]
    },
    {
      "cluster_id": "51f9e6ae-7c8a-46e3-8fa3-070377ae9030",
      "members": [
        "da2a8837-bd8a-488f-b164-1c4fae90ea79"
      ]
    },
    {
      "cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "members": [
        "a76a4188-0e42-4ace-8773-87e990cd6889",
        "19b94fb9-4b53-49f7-a541-698272ac5600"
      ]
    },
    {
      "cluster_id": "2b132e72-8cc9-4107-a55f-19ac99e2caf3",
      "members": [
        "eb148cdc-958c-4243-8ce8-3c11c0a12781"
      ]
    },
    {
      "cluster_id": "95ba204b-d839-49c0-9233-3f2add81da86",
      "members": [
        "dd3c8ab9-8224-4615-94cc-d1f1cb267c2c"
      ]
    },
    {
      "cluster_id": "749b3ec0-39f9-4e3b-bcf2-7f9377d72178",
      "members": [
        "28d22d59-1bc2-476b-9215-4cdcb989a85d"
      ]
    },
    {
      "cluster_id": "4eb1a4b5-b71a-4034-93b6-28860ce56821",
      "members": [
        "e9eefdee-16bf-495f-a832-ee0139b509cc"
      ]
    },
    {
      "cluster_id": "7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1",
      "members": [
        "c75d19d0-b827-4f7c-b170-1ef7d2a1981c"
      ]
    },
    {
      "cluster_id": "755e1910-15d6-4530-b0f7-b73a35ac9c64",
      "members": [
        "f9c52047-618d-4331-88dc-f291d6a4ce80",
        "3debbefc-996d-46cb-a12a-4ac0af7f86d0"
      ]
    },
    {
      "cluster_id": "89d92c43-6368-4ce1-8b52-63274b65d5df",
      "members": [
        "bc454b72-954f-46b7-aade-de6e5b24af23"
      ]
    },
    {
      "cluster_id": "cf33198d-096c-4e25-8d65-13fe91addce9",
      "members": [
        "13af3e5a-4df9-47c5-98ee-bc08c1c5913c"
      ]
    },
    {
      "cluster_id": "9f14caef-27ce-4bca-afff-6e691839a8df",
      "members": [
        "4dff9410-a9bc-4ecc-a307-76f78973442f"
      ]
    },
    {
      "cluster_id": "dd5d0634-bc30-45f9-b45a-97773c63db2a",
      "members": [
        "c92e9220-0252-4c02-8acb-b3c2083cba47"
      ]
    },
    {
      "cluster_id": "a0209bc1-2ecf-46c2-8b3d-8258fc85b6a8",
      "members": [
        "c96c6387-3f57-4c7f-a8e8-f0e06f5e9739"
      ]
    },
    {
      "cluster_id": "73dcede2-49d2-4bc1-a599-b15a7d0094cf",
      "members": [
        "3e3e514f-a344-49e3-9ae4-aa583531de37"
      ]
    },
    {
      "cluster_id": "763dcb28-8161-4ef1-bcee-20cbd6af7670",
      "members": [
        "790acdda-db12-4c6f-8116-86ea91021854"
      ]
    },
    {
      "cluster_id": "1f8ca860-66b4-4b57-a63c-e13332662c2e",
      "members": [
        "5d722fd0-ca08-44f7-a983-221076de71b0"
      ]
    },
    {
      "cluster_id": "f8c898ca-36a7-47ac-838a-8091321433d0",
      "members": [
        "f96b20fc-1ab4-4491-b9f1-630b04cbe616"
      ]
    },
    {
      "cluster_id": "4b037322-86a6-4af9-bfe1-49f968f04baf",
      "members": [
        "5f8731d0-460d-4542-8385-9bcb6bc5981b"
      ]
    },
    {
      "cluster_id": "e0c5a85f-7145-4366-aac8-58cd212f7e6a",
      "members": [
        "b2c9d261-a6a2-4709-a811-9be31d2f457e"
      ]
    },
    {
      "cluster_id": "bf76e0b1-c54e-4ab8-82d0-979d68c35a65",
      "members": [
        "6a9746d2-5c0b-44e5-a69e-6b27616cd607"
      ]
    },
    {
      "cluster_id": "1450e6e0-be6b-4ab7-8d94-7070623cadb4",
      "members": [
        "6295178e-d150-4ad0-b2b4-bde698a910b4"
      ]
    },
    {
      "cluster_id": "d67b58dd-cbc9-4a99-aab7-b31e7a922343",
      "members": [
        "1487337e-caf6-43ec-972a-52a6255f4bea"
      ]
    },
    {
      "cluster_id": "9747ef56-b31a-4050-8bc2-6df45c0ffbd7",
      "members": [
        "c98ab273-00fa-4c64-b3ca-2a928745714e",
        "95737f58-3e4b-48c3-be9c-d7ac586f92ab"
      ]
    },
    {
      "cluster_id": "d65bf625-e91c-49ac-a498-dc2e95df1f93",
      "members": [
        "3d5c69d0-3692-4fd9-a879-931941f5f802"
      ]
    },
    {
      "cluster_id": "5f10e7fa-9adf-4e59-961b-ac04facb9f2b",
      "members": [
        "a7959296-3463-4b6b-ac53-a3b5e6f20c25"
      ]
    },
    {
      "cluster_id": "84900de4-4822-40e2-a41f-f9013bcc0bbe",
      "members": [
        "46dfe14e-2446-41b3-8747-a3a01d5aba71"
      ]
    },
    {
      "cluster_id": "3a1f2987-e024-4481-9d2c-9a6882a3fb9a",
      "members": [
        "8d8afe95-d204-4f32-bd7a-b64c673c9a80"
      ]
    },
    {
      "cluster_id": "2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6",
      "members": [
        "bcd2ffe8-1e6d-4dcf-9357-644c21234bcc"
      ]
    },
    {
      "cluster_id": "2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4",
      "members": [
        "6cdd0296-e032-4a5c-b6dc-7d6233af6947"
      ]
    },
    {
      "cluster_id": "ddd4b5a0-2eee-4ff9-bb50-de940c2541e2",
      "members": [
        "872e2a83-256e-44e0-9dd8-4401545586db"
      ]
    },
    {
      "cluster_id": "6778e0f8-10fc-4d30-8039-d81e67c9992c",
      "members": [
        "ff1d84ad-9d70-4739-8deb-adf84694c761"
      ]
    },
    {
      "cluster_id": "63fd0e17-6b29-4f19-b984-a861fba2eb14",
      "members": [
        "538fcc42-d402-4e1c-aa53-1b48fd92e7bd"
      ]
    },
    {
      "cluster_id": "b398f217-24d9-4c22-8d5a-732320853c1b",
      "members": [
        "e8bffc79-ebb0-494b-8a55-67a20c377fdb"
      ]
    },
    {
      "cluster_id": "2da1e2c0-6b7f-4a59-bbad-c83252a70f91",
      "members": [
        "566193e3-aa65-4122-bb4d-3d4d7a216c13"
      ]
    },
    {
      "cluster_id": "0a4b2521-caa9-4365-ba6f-ee42c89824c7",
      "members": [
        "2bb8aa19-18f7-489f-adc2-cb4407229de6"
      ]
    },
    {
      "cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "members": [
        "ac72e986-3f42-4894-a51b-3f463b4c4847",
        "ea68f6bb-d8e9-4d0b-9fac-e359016c7dbf"
      ]
    },
    {
      "cluster_id": "bd3c25bb-6683-4bdd-8e97-11de485116b2",
      "members": [
        "ec663f1d-8af0-4505-9c17-ea09a60e57b8"
      ]
    },
    {
      "cluster_id": "13f086c1-e440-480a-a882-8d8a742c1d5e",
      "members": [
        "4cd0e4e5-8f7a-4621-9e10-b10679c29f79"
      ]
    },
    {
      "cluster_id": "dcc1a857-7e25-4b1e-bb30-c67434a5f183",
      "members": [
        "77407c57-d36f-48f7-b5d4-3cf0ba9fc3a4"
      ]
    },
    {
      "cluster_id": "0e6f398e-1206-46db-a98b-ff1425e1c634",
      "members": [
        "3e182aa3-750a-475f-9344-ece860104732"
      ]
    },
    {
      "cluster_id": "1ae95d89-cea7-4f27-8ed8-d4f49e95c5db",
      "members": [
        "5896fac0-b57f-4633-97af-f0e71c90112a"
      ]
    },
    {
      "cluster_id": "0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f",
      "members": [
        "807c7ea3-225f-45ad-9015-6b748822e6ac",
        "7666b8ae-0dd8-44d7-b730-f29fb7e24f4f"
      ]
    },
    {
      "cluster_id": "5cab19a1-9532-4ca5-8f94-e19c788f807b",
      "members": [
        "a0f4a3b8-e427-4208-b02c-9b5eb0b8a8cf"
      ]
    },
    {
      "cluster_id": "52b4a518-aae8-40ab-8a78-e641ed7c28ce",
      "members": [
        "79868006-5b4b-4920-8227-9896c47f4145"
      ]
    },
    {
      "cluster_id": "3dcf8216-5e70-4cd4-962e-dc4b036a0071",
      "members": [
        "74cbf840-383d-4abb-a196-7cc930a7b248"
      ]
    },
    {
      "cluster_id": "3f09a0f3-521e-4c59-84d0-5adbf02dbf98",
      "members": [
        "42f04497-b4b3-4afb-9d2d-de42d308d3c3"
      ]
    },
    {
      "cluster_id": "c6b3d942-ded2-4171-9d53-bf87a1b48b52",
      "members": [
        "0601535a-5232-49d6-ac8a-f339184b8117"
      ]
    },
    {
      "cluster_id": "da33c07b-485b-43b6-8165-46193fb1720d",
      "members": [
        "5cda20d0-a6e6-4c3c-8593-cc0b033e9c5e"
      ]
    },
    {
      "cluster_id": "c0426c3e-a327-4be7-b689-905cba5cdfca",
      "members": [
        "f66f4c85-4df6-43f8-a55e-eca41f06bea1"
      ]
    },
    {
      "cluster_id": "84209a17-a4a4-4c15-a21f-0800fd75d6d8",
      "members": [
        "0e6fca58-3d0b-46e9-b950-d945afd31999"
      ]
    },
    {
      "cluster_id": "d9f9cf14-d4ad-4c0a-9482-99b75f7c247f",
      "members": [
        "76041811-58a8-45f0-904e-d755003438d3"
      ]
    },
    {
      "cluster_id": "9971c68f-8d21-4436-a5d3-4897996181e7",
      "members": [
        "45c0f4a0-2167-4cdc-93c8-d916583cc974"
      ]
    },
    {
      "cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "members": [
        "e623426b-f1ef-4797-b377-5be61d70af2d",
        "bb488946-5e6c-4e91-866d-5430c56b7ee1"
      ]
    },
    {
      "cluster_id": "905fb380-0de3-42c4-abca-6fd6383deba6",
      "members": [
        "1ccc23c1-d3ed-4fcf-9782-521addcd2f77"
      ]
    },
    {
      "cluster_id": "36ed05e4-cb6f-4b4e-a07c-39d608cb863f",
      "members": [
        "878edfcc-e3b6-49e1-b4b1-902ef152c55e"
      ]
    },
    {
      "cluster_id": "3368fed2-7688-4846-a7ac-3bfa3045311c",
      "members": [
        "d43d3481-5742-4c58-b1c9-badc139150c1"
      ]
    },
    {
      "cluster_id": "b916d619-a85d-4cf6-9af8-c531be4fd3c4",
      "members": [
        "23af801d-509e-4d13-85ba-aa38818ea8a7"
      ]
    },
    {
      "cluster_id": "2b47973e-934f-45a0-98dd-aacefd7432f8",
      "members": [
        "e4866b76-12de-4374-aa13-8007f1d044c6"
      ]
    },
    {
      "cluster_id": "2c7cf7ec-47d1-4b9e-8095-5a313fd3166e",
      "members": [
        "efbf5b1c-1b5e-41b7-a8f1-62089a598ada"
      ]
    },
    {
      "cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "members": [
        "e5c14dc3-196c-44f7-a92e-381ff2a9404e",
        "d18ea420-7fc8-4f4d-b3f8-69befdaee398",
        "426cabef-a0b8-48c3-b48a-30b49a193166",
        "4c9ba839-bc22-44c0-ac8c-6ec8edc75085"
      ]
    },
    {
      "cluster_id": "de5ecea9-1de6-4f23-a787-2b6cd366c836",
      "members": [
        "ef776dbf-e915-450c-92a7-cdb90bea6369"
      ]
    },
    {
      "cluster_id": "db897944-fc77-42b4-ab1a-b566912e00b0",
      "members": [
        "60aacdab-d3d7-4fb3-9782-d187daf68d2e"
      ]
    },
    {
      "cluster_id": "501b66f7-8e87-4810-b05d-6bb95d09a79e",
      "members": [
        "ec042255-3b6c-48b9-b4cb-ba5cfadee254"
      ]
    },
    {
      "cluster_id": "226ceb68-980d-4b72-b053-36c7b5c7f61b",
      "members": [
        "af0baa1b-e5a3-440f-b047-1812f1485d82"
      ]
    },
    {
      "cluster_id": "1363d4a2-5ea7-481a-b7e3-3e161a6db765",
      "members": [
        "8ba73e30-7316-4bd2-8e27-627a554098b5"
      ]
    },
    {
      "cluster_id": "163270c6-b91d-429e-9c2d-5cf8a4ff0d2e",
      "members": [
        "c2283ea3-0288-429d-b859-4af79cf5bfe0"
      ]
    },
    {
      "cluster_id": "209935ed-d0a0-4dbe-82d8-2d7d5a2aa866",
      "members": [
        "0a30e6a2-2ecb-4080-bb75-910ab4a7bcff"
      ]
    },
    {
      "cluster_id": "6efc04ea-c5a7-40f2-bf74-98f55c06f1df",
      "members": [
        "9a6fdaf1-bfe1-4cd2-a54d-d21955fb6eb4",
        "e44ced54-bbc4-4fe9-9925-086c3be735ed"
      ]
    },
    {
      "cluster_id": "a0698f9c-4bc8-48b3-b669-44befd54559c",
      "members": [
        "3712e970-6cda-45e7-bedd-818a6e1a11d4"
      ]
    },
    {
      "cluster_id": "a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0",
      "members": [
        "2232fd36-afdc-4f1f-8969-f02be4e9d63a"
      ]
    },
    {
      "cluster_id": "36472627-9945-496e-89a2-063ceee22d24",
      "members": [
        "af3d86ef-53f0-4580-8880-ce57b587280f"
      ]
    },
    {
      "cluster_id": "3769f810-e5f7-4d0a-9821-1876b6cadf34",
      "members": [
        "c8eaf52b-6580-4071-9e29-9c2cf6aafc79"
      ]
    },
    {
      "cluster_id": "4bf14550-b17d-4304-b7d7-0f4f8ea4d2d6",
      "members": [
        "036a2d59-d909-4bb5-9f34-5ef7c0deac6f"
      ]
    },
    {
      "cluster_id": "61fac83f-0dd7-4c15-88bc-e40fee962783",
      "members": [
        "cb3af57e-49b2-4874-ba84-c7d384dec42f"
      ]
    },
    {
      "cluster_id": "ba6f293a-cb12-4697-ba51-b7964934f25d",
      "members": [
        "989cf3db-1df9-43c5-a742-683491db2209"
      ]
    },
    {
      "cluster_id": "42314335-3518-45c0-909b-96111c0955f6",
      "members": [
        "184a591a-6388-4cf3-8aba-ee33dac18ee4"
      ]
    },
    {
      "cluster_id": "22c13a77-51bd-41df-afeb-444adbde288e",
      "members": [
        "442a9332-d235-4c4e-8005-e099521eb2d5"
      ]
    },
    {
      "cluster_id": "90c28686-07e5-47d2-8675-847924fbe9c3",
      "members": [
        "46403870-19ff-4ad8-8ef0-14f1f2d46780"
      ]
    },
    {
      "cluster_id": "bc48e3cd-6317-4a4a-b06b-f8629ebbbbcd",
      "members": [
        "8ca5dd5c-0d80-4823-82d0-3dc17b6c640b"
      ]
    },
    {
      "cluster_id": "3eac5298-75f1-4e1e-94ec-db408d17729a",
      "members": [
        "b5b0acb6-0c0e-4c74-8cd8-c9934226037e"
      ]
    },
    {
      "cluster_id": "64599826-faee-4fcf-9432-967663d05451",
      "members": [
        "839cea27-8092-4523-827e-6d8fbc40ff8f"
      ]
    },
    {
      "cluster_id": "d3ee5536-f1ec-4a1b-9b1a-82ff92aa04a4",
      "members": [
        "e6c7fc38-eaa7-401b-b455-e32295ee969d"
      ]
    },
    {
      "cluster_id": "c8265999-6e3a-4835-bb5a-9e081a27e9bd",
      "members": [
        "9ba58870-e662-45a5-beae-091bfa16e49e"
      ]
    },
    {
      "cluster_id": "a3a8e335-b1fe-4cbe-b6f9-626c39d5f0dd",
      "members": [
        "808f70bf-16bf-40a3-bc4e-ad826c69f05a"
      ]
    },
    {
      "cluster_id": "d602e1f1-5446-4c60-aadc-beabd56dedd8",
      "members": [
        "ceb27820-5d30-455b-b348-a5ae9803d431"
      ]
    },
    {
      "cluster_id": "7553f34f-d61f-419e-8976-cecf89bafb0e",
      "members": [
        "9e987e03-e570-493b-a318-ff4663b45779"
      ]
    },
    {
      "cluster_id": "3b7e3ce4-4e60-4c09-986c-9b9376d80c8a",
      "members": [
        "cabce7be-e46d-4bbf-bda0-e2c027ff8945"
      ]
    },
    {
      "cluster_id": "3ea1c92f-805f-4ecb-b23d-a77a7a362e5b",
      "members": [
        "1ecda97a-611c-48d8-9ece-7a0b19668b9f",
        "cd85dca8-d905-493d-aade-b80a44a8fdfb"
      ]
    },
    {
      "cluster_id": "5cd897af-cb8c-4335-a548-c9963c43f060",
      "members": [
        "6219d853-203f-4cd8-a7ed-eaccc37db4e5"
      ]
    },
    {
      "cluster_id": "3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8",
      "members": [
        "25525cdf-c733-4a85-91ab-f2adc6192748"
      ]
    },
    {
      "cluster_id": "02dd8817-131f-4c62-a0d0-fa32952b2e01",
      "members": [
        "ecfc4818-605c-4c8b-91a2-04ed27c8e3cb"
      ]
    },
    {
      "cluster_id": "4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9",
      "members": [
        "f8b32d99-e10d-4e9d-b2cf-02d421202d9c"
      ]
    },
    {
      "cluster_id": "b4a81fcd-1fa0-4fbe-88f0-692419c6082a",
      "members": [
        "a53beda4-d9d7-4a1d-b20e-c55ef5fdc365"
      ]
    },
    {
      "cluster_id": "c9f87e7e-e0a4-4be1-aaa4-54f6d3bedaaf",
      "members": [
        "9dc49aa7-fb08-4c49-ab0d-d233037511f7"
      ]
    },
    {
      "cluster_id": "4bc5d44b-029d-49ff-82cb-bbcd84067673",
      "members": [
        "9afd40ce-83d2-4ba6-b3d4-846849c4f834"
      ]
    },
    {
      "cluster_id": "59e6bbb6-5982-4df0-b59c-33f07ce159f4",
      "members": [
        "55d2779c-e217-438b-a824-b709c22a345c",
        "7593089a-7a8e-4de4-85ef-a1426aa3cff9"
      ]
    },
    {
      "cluster_id": "954a4240-7358-4649-966c-6f08bf5b088e",
      "members": [
        "0dfab435-0854-4cbc-ad80-25e02d0ed5b4"
      ]
    },
    {
      "cluster_id": "99892bd6-22b5-4bc1-bade-41a91e788227",
      "members": [
        "012f7414-c063-4bb0-821e-03ae3200a374"
      ]
    },
    {
      "cluster_id": "5900a7ab-7cb4-45d4-8807-d20dee337670",
      "members": [
        "16679f67-f92b-4c97-8b93-52f58e61267c"
      ]
    },
    {
      "cluster_id": "fc4ce4ef-b019-44c8-8060-59b10a33a92b",
      "members": [
        "4a4dc838-cdb8-4cd2-a8e8-b7565b489463"
      ]
    },
    {
      "cluster_id": "8a0accb4-caf5-4741-9038-3360a1a08c25",
      "members": [
        "5bd060ce-e57a-4b9e-8ce7-adb07d86cbe0"
      ]
    },
    {
      "cluster_id": "fd3ca8c5-bfa9-4e66-bc57-721306073eb0",
      "members": [
        "a367c419-5c06-4d96-b3aa-e68d07bfe89b"
      ]
    },
    {
      "cluster_id": "c3dda95e-e922-4b18-b7fd-9f071350fa6d",
      "members": [
        "f56313c6-4c1b-41ae-abb7-5b3adcd6fcda"
      ]
    },
    {
      "cluster_id": "746179fc-962b-4500-916f-ca22a3a202d9",
      "members": [
        "2db09ac7-7480-488d-95a4-cd52c3d6852d"
      ]
    },
    {
      "cluster_id": "7686685c-6e82-408b-a7b9-2e453038450e",
      "members": [
        "76c5a892-9eec-44fb-b18a-8dc8f6ec54d5"
      ]
    },
    {
      "cluster_id": "f7fbb95e-08d7-410a-8e1f-290e984463d7",
      "members": [
        "c2f9ead9-e144-4a77-a370-18b0e465aa10"
      ]
    },
    {
      "cluster_id": "fa9ba14d-4628-4fac-b94e-953f493cb218",
      "members": [
        "0518a0f6-d6fb-445b-a6b2-de32bb4966d7"
      ]
    },
    {
      "cluster_id": "380726cc-73a4-4dde-ac40-f10c2a1f6e60",
      "members": [
        "87b8a5d6-25e2-4a58-b32f-2b9fd63d7259"
      ]
    },
    {
      "cluster_id": "ae201524-ae4c-4b92-afa7-2801ac429060",
      "members": [
        "ab184fe7-413c-4714-9a1b-9f2c04d1ded4"
      ]
    },
    {
      "cluster_id": "5d8665ac-7337-470b-ae27-2d46610e9f97",
      "members": [
        "c4b7ef6a-e82f-45ce-9dc2-1ef84742ea6c"
      ]
    },
    {
      "cluster_id": "b7e33865-58b2-4984-a7e1-eed1512539bb",
      "members": [
        "21557975-8f55-475c-9113-1599cc88d48e"
      ]
    },
    {
      "cluster_id": "44d600b5-1259-4b0f-a45c-73f5507156e1",
      "members": [
        "87c7e218-1700-44f0-8a1e-ccef92bb6df1"
      ]
    },
    {
      "cluster_id": "66cd9492-ff5e-477d-9ab7-967722c94dcd",
      "members": [
        "346f5eac-8083-44de-a2a5-c22b0a3c68b0"
      ]
    },
    {
      "cluster_id": "25934933-94e9-444f-a664-f57c4cea7d17",
      "members": [
        "e4b05630-1cf1-473b-9935-4d9df2441747"
      ]
    },
    {
      "cluster_id": "09c923c5-0d10-40d6-8825-821711e43905",
      "members": [
        "59db8bb7-8c32-4cb4-b93a-9377f27e5bb9"
      ]
    },
    {
      "cluster_id": "12f1ab8f-20c6-41db-928a-d52afb8bd227",
      "members": [
        "867c8371-61c7-4133-9fe0-a60250a5dafa"
      ]
    },
    {
      "cluster_id": "a45b0120-f89a-4fb7-9d30-32c67bc23fc9",
      "members": [
        "7d1184be-08c7-4303-bb74-bb6301ab3676"
      ]
    },
    {
      "cluster_id": "df20aee7-4e88-4c5d-a2d1-ce862c311713",
      "members": [
        "3f363d10-544f-4a29-bd9f-7e7a84fd3014"
      ]
    },
    {
      "cluster_id": "ed9c7f02-d3d7-4f88-92df-80c91b7dca98",
      "members": [
        "992e777b-2d2d-4164-9166-21819ed67314"
      ]
    },
    {
      "cluster_id": "61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc",
      "members": [
        "67d60464-0d44-475b-a6ff-e2ba49d1366e"
      ]
    },
    {
      "cluster_id": "a39bfc74-5364-4583-b4c6-2ba30e1ddbf9",
      "members": [
        "e57ae7e6-185e-465f-bf0a-b4ae49ea0b5b"
      ]
    },
    {
      "cluster_id": "4b37762b-26f0-4956-9d1d-e433973602e1",
      "members": [
        "28d0a5e2-e288-4da3-865d-b61255d8b0a2"
      ]
    },
    {
      "cluster_id": "732c6dc2-1231-46ca-b1c1-173c0f488176",
      "members": [
        "1d882ab7-3448-4e70-aceb-c9654f71e66b"
      ]
    },
    {
      "cluster_id": "4f1efe8f-fe00-4658-8994-d5332d4cc9ed",
      "members": [
        "6e785240-8ffb-4abe-a014-d7a8b7f6fb74"
      ]
    },
    {
      "cluster_id": "99955509-35d5-4623-b165-0b6dc4f83f23",
      "members": [
        "3bd375a2-f60c-4e67-95d2-8dd33dda54c4"
      ]
    },
    {
      "cluster_id": "3d986dc9-6edc-4a4e-9783-63b1c5e7bcd8",
      "members": [
        "a6a36d51-bf43-429e-ace3-d335b25e878a"
      ]
    },
    {
      "cluster_id": "563140da-8f58-4b64-8987-47bb018b6821",
      "members": [
        "d365e127-d27c-4834-a1de-fc0930515ddd"
      ]
    },
    {
      "cluster_id": "00cfa90d-eff5-4498-89d6-85dadca46eb8",
      "members": [
        "ebf98039-232c-4282-8676-4453abfe60ac"
      ]
    },
    {
      "cluster_id": "54017113-d014-48fd-b57d-6cf55f5a8ff8",
      "members": [
        "b8b3465b-e078-4efb-ae6e-e6a1726f2fa9"
      ]
    },
    {
      "cluster_id": "3f85eb0b-4d61-4e44-8414-15ce2c9f03ad",
      "members": [
        "b0ba9c40-a67a-46d7-b196-e03f3c5aaa9c"
      ]
    },
    {
      "cluster_id": "84874fe9-a25d-4d9f-9765-de9280d477c0",
      "members": [
        "41702860-e9aa-4135-bcb7-e01f4817b34d"
      ]
    },
    {
      "cluster_id": "f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f",
      "members": [
        "ae993dea-9d4f-41e4-9864-aa6def24b890"
      ]
    },
    {
      "cluster_id": "818fb1f8-d14f-4997-8e8d-f7e228560c99",
      "members": [
        "82223086-44ab-4f8a-bb20-2469fbc0fe5f"
      ]
    },
    {
      "cluster_id": "d0619b32-28c7-4624-9e6b-8c81d9ff9019",
      "members": [
        "6ae0e573-7a63-4ebf-8915-b6673547e7a5",
        "b61d27b5-67be-4aac-b991-4c463d94cb6d"
      ]
    },
    {
      "cluster_id": "82cf1bd1-8182-4744-8fc2-6d5af2292aea",
      "members": [
        "1cbefbd5-9c0b-427d-bb6e-c17b315e53bd"
      ]
    },
    {
      "cluster_id": "b54d16d2-d5db-4746-b15a-e8c01d4fc586",
      "members": [
        "0bccaf8d-81f8-4dc6-a43b-f49b0a453569"
      ]
    },
    {
      "cluster_id": "e684bea9-83ef-4337-93a3-80b8a3708ae0",
      "members": [
        "11066e29-dc62-4fd0-83f9-58da50d5bc4d"
      ]
    },
    {
      "cluster_id": "3e9990d1-ada6-4c9b-b2b3-e8220e956431",
      "members": [
        "66083cd8-4f78-4c40-aaea-4e52211f0454"
      ]
    },
    {
      "cluster_id": "2712567d-2895-48f5-8695-f726eb795979",
      "members": [
        "e37a656e-2b55-482a-a4d0-7e3cc66ebe0b"
      ]
    },
    {
      "cluster_id": "291e098d-0f3d-4fff-9906-3b21ed1a33a1",
      "members": [
        "05bdc8cc-dd35-4620-a59d-ec3c72ed2731",
        "57a25bac-e26f-49eb-9426-9fdf3ee70d6d"
      ]
    },
    {
      "cluster_id": "f96435db-3d9a-45de-8398-45bc9dbd4fc0",
      "members": [
        "65cbc702-99e8-4621-8a81-899b350a7a83"
      ]
    },
    {
      "cluster_id": "652f1be8-25e9-4267-b7cc-e5ecf9e7919b",
      "members": [
        "7b229a8c-d88f-46c0-b447-c58879a2e92e"
      ]
    },
    {
      "cluster_id": "e4f4246a-95d9-4d67-94bf-27725af4d71b",
      "members": [
        "7a9d517e-5f42-4e1c-8c54-b33b67939c08"
      ]
    },
    {
      "cluster_id": "b0b87d24-5072-4ac7-bf9b-5891dbcddd35",
      "members": [
        "e33b45ec-40c9-4bac-a8d9-ffdf4be25ed0"
      ]
    },
    {
      "cluster_id": "5ef68f23-0f9c-4c57-af44-b6d2b7f6107c",
      "members": [
        "de88b89a-982e-47ea-8d7a-c0b2fbd6dabb"
      ]
    },
    {
      "cluster_id": "748c24aa-69c4-47c4-a75f-e6da7007b74a",
      "members": [
        "26d73c11-429e-418c-917d-8941d43cf025"
      ]
    },
    {
      "cluster_id": "a0fb284d-9ce5-4422-a3d9-508052dde7fe",
      "members": [
        "a3cb0615-5ec8-4cff-ae0d-afc22f1c70c2"
      ]
    },
    {
      "cluster_id": "d9366872-6ca9-49e5-9e80-86c5b954d463",
      "members": [
        "225bd941-a6dc-49cf-af65-19811da32bf6"
      ]
    },
    {
      "cluster_id": "b840591d-33a5-402e-9f7a-8913292b283e",
      "members": [
        "20dc25ab-5389-4dff-a43c-dfe9d7bfc7ce",
        "c0017158-5ec9-4fbc-8e2b-e5be9bf948e8"
      ]
    },
    {
      "cluster_id": "83856113-7cf1-435d-bc2c-d1c5e5e5c106",
      "members": [
        "a15196b8-40cf-4a2e-9b8d-b3d7e099060c"
      ]
    },
    {
      "cluster_id": "f690f627-f1e3-428b-9d01-bfb966953069",
      "members": [
        "a8f04bd3-0b9f-4afc-9958-ee3fd9b741a1"
      ]
    },
    {
      "cluster_id": "fce90f87-0664-4b8a-bb4f-dc7bbf08cf50",
      "members": [
        "3992463a-fde6-4ecd-b942-29d355ec638b"
      ]
    },
    {
      "cluster_id": "17ea1514-c948-487c-83ee-722001d6184e",
      "members": [
        "d465212c-f927-43a4-9067-b9959b145c98"
      ]
    },
    {
      "cluster_id": "d3ef62d6-a9f2-4e02-8cb8-beabc3ead80a",
      "members": [
        "8dd89c11-2e8d-425a-b0b7-0d1e37f27418"
      ]
    },
    {
      "cluster_id": "c8b9924c-3cce-4d36-afc2-f686b12770db",
      "members": [
        "46def0c8-57f7-4a96-b04c-91488bfcbbe6"
      ]
    },
    {
      "cluster_id": "72276ba3-4193-4153-879a-b2c7cdf39af4",
      "members": [
        "01d537f0-cceb-4074-a220-f7352b73d9af"
      ]
    },
    {
      "cluster_id": "58a44cd6-3f44-4460-9d07-d5a28bd55747",
      "members": [
        "3eaa9fd6-d488-4d05-bb97-db904c045b1f"
      ]
    },
    {
      "cluster_id": "e5736d52-6864-4a19-aa95-57d6bbe8f40d",
      "members": [
        "6834f333-8ff8-4fa0-830a-d95ad9536868"
      ]
    },
    {
      "cluster_id": "89360ae3-18fa-43f0-bd2a-417e02e051c5",
      "members": [
        "34d3a385-3440-4419-813f-5a6f201b8e8c"
      ]
    },
    {
      "cluster_id": "cf8a7c88-fcb8-4b8d-aadb-46cb3168db25",
      "members": [
        "3b05075a-6249-4034-8d5f-0b4b61ae375e"
      ]
    },
    {
      "cluster_id": "21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb",
      "members": [
        "9b905695-6c43-4956-b510-5ede2c0cadea",
        "c9aca791-24e8-4105-8a1c-f43879aca0e3"
      ]
    },
    {
      "cluster_id": "39caeecf-930f-43df-a6d4-e237146a33a8",
      "members": [
        "9edfd059-7cba-4282-b685-3ff4a5c6784f"
      ]
    },
    {
      "cluster_id": "db5fd0e4-cf0a-4e94-a4a2-d71a9c25184f",
      "members": [
        "1c5f3940-618f-445f-8bae-498cf3a57328"
      ]
    },
    {
      "cluster_id": "83176725-df79-43f8-b571-b45c6b2dea8f",
      "members": [
        "5187f6b9-b01a-48c8-a5cb-7b50f59b98cd"
      ]
    },
    {
      "cluster_id": "144fa955-73da-4f76-8472-31c3ddd2636d",
      "members": [
        "7c020a8b-3a1d-4bf5-9b2b-f68ed67a83ce"
      ]
    },
    {
      "cluster_id": "f18ec76a-50ba-422f-9d7a-596708b1810a",
      "members": [
        "0097c1c4-91ca-4efc-9c12-92cb73fe1d48"
      ]
    },
    {
      "cluster_id": "0eef7600-1d71-4d26-9e91-3c6e5b0c6121",
      "members": [
        "fadaf7a0-1951-41a0-be28-ce7cbbfd2e13"
      ]
    },
    {
      "cluster_id": "7893fdb0-a005-4beb-b22f-fc8ce5bd706e",
      "members": [
        "75fd2ea3-890e-407e-bc4e-bb4dcffb1d52"
      ]
    },
    {
      "cluster_id": "4a277b87-4d75-4b75-9416-adcbd06c3a69",
      "members": [
        "7d63bb14-86c5-4e7c-9908-d12838f5a1e2"
      ]
    },
    {
      "cluster_id": "fd305e86-cd2a-4329-a45e-739147206ba8",
      "members": [
        "53b2073c-0f69-4c80-b1f7-2216bcce8ae6"
      ]
    },
    {
      "cluster_id": "ee877fbc-1f06-46ff-b006-7c974bc58cf1",
      "members": [
        "efb2f3a4-4a6f-4b82-891a-6e49b2a5f523",
        "485705b8-64f1-4937-b4c1-475d0bf42370"
      ]
    },
    {
      "cluster_id": "9d4328c2-e9a9-4e75-b63e-6e88d7b536f1",
      "members": [
        "f5b4fc6e-6e89-47bc-924f-48d1652def42"
      ]
    },
    {
      "cluster_id": "717225a3-f2cc-4921-bece-db76c2709d99",
      "members": [
        "e7a172a6-e210-4871-ba5b-5beab36f133e",
        "79bf234f-2f4a-4563-8307-083e1161440a"
      ]
    },
    {
      "cluster_id": "58953090-5955-480d-95b2-311ed2c0f653",
      "members": [
        "4afb68a8-bbcc-4e8d-af34-d5edf6095e82"
      ]
    },
    {
      "cluster_id": "d26e1561-d7b5-4c15-bc29-d5ba417f64ca",
      "members": [
        "46b182ba-f8b0-486e-a971-d6d8d29dcfef"
      ]
    },
    {
      "cluster_id": "0fc06cfb-3a25-4176-a530-ab9cb52f7632",
      "members": [
        "2469a626-6d12-4a3f-8609-e8853ef4366b",
        "c3f6e2a2-bf0a-4eb4-88f9-8603500d5674"
      ]
    },
    {
      "cluster_id": "7fbcd1a7-a676-46b6-a3c0-af823173a2b1",
      "members": [
        "3eaa4b01-8d12-46ab-ab47-1870221edd96"
      ]
    },
    {
      "cluster_id": "32bf3674-86a6-4cde-a9e5-20a5e3965e02",
      "members": [
        "246ad0b2-a33b-4452-9680-a021c86e97e5"
      ]
    },
    {
      "cluster_id": "218a3fc7-ac76-4428-aa52-1f315a03667d",
      "members": [
        "37499fab-2fe7-40bd-b11e-ab87731202f7"
      ]
    },
    {
      "cluster_id": "e7a1e23f-832f-432a-ad19-207015a794b2",
      "members": [
        "91a4d43b-edc0-49ec-b3bc-3867f659b730"
      ]
    },
    {
      "cluster_id": "bfd9a248-bf68-4994-8af5-882efd424687",
      "members": [
        "189f80a7-6ff9-4b7b-903d-887d097cff2b"
      ]
    },
    {
      "cluster_id": "e64bcf93-086e-429d-9ff7-3a1518b3ae51",
      "members": [
        "6a75e685-16dd-40a9-943b-267048380ebe"
      ]
    },
    {
      "cluster_id": "4ada70f8-8bb6-4995-8f14-e79e769b0629",
      "members": [
        "f0a2c749-6388-420c-bdf9-1c4ee803e96d"
      ]
    },
    {
      "cluster_id": "47a61e0a-9230-4c4c-962b-f6724c066435",
      "members": [
        "fe728252-2f9c-4815-b02f-7699b2550a2e"
      ]
    },
    {
      "cluster_id": "162f021a-53e9-4f3d-9231-108223f18e9b",
      "members": [
        "d7aca388-acbd-4f7f-a855-c7d5c20fa685"
      ]
    },
    {
      "cluster_id": "9e96a51d-6101-42af-b7a2-54e4dd5ae715",
      "members": [
        "429e49d4-f23e-4cc2-a86b-ee2c5103945b"
      ]
    },
    {
      "cluster_id": "47cee9e4-a547-4914-b31f-89a4963c7d37",
      "members": [
        "c8ea9f81-466b-4497-b45d-3223d1ee8247"
      ]
    },
    {
      "cluster_id": "770cc261-67a7-4ed4-85d2-93916689a978",
      "members": [
        "72eaf4c2-1ace-4637-a279-69574883c8d2"
      ]
    },
    {
      "cluster_id": "9fb5216e-3d0c-403e-a2bf-9368fa3e3592",
      "members": [
        "465bece8-37d9-4e52-a1ec-faf9186dca40"
      ]
    },
    {
      "cluster_id": "199ae7ec-217a-4cab-a030-ff0a4838c0a8",
      "members": [
        "3a116cf1-f864-46f2-91a3-8becc0027791"
      ]
    },
    {
      "cluster_id": "3232bd90-9251-47f0-ae93-ae2d51218354",
      "members": [
        "a587e2e2-5f98-4b88-911b-409af3406d82",
        "b49be27f-cd32-4e61-8e4f-45de2432e05e"
      ]
    },
    {
      "cluster_id": "159421f9-fc35-4e25-a688-4ecf97e146b4",
      "members": [
        "b49e3698-2d1f-4006-93ae-7a09a858e833"
      ]
    },
    {
      "cluster_id": "ae1e52fc-461a-4609-8b02-2589611c162e",
      "members": [
        "6b2476c6-a052-47ae-a228-56b6f553ca74"
      ]
    },
    {
      "cluster_id": "e871839f-962c-43cf-a2f7-5ebaf26de0a1",
      "members": [
        "fd8ab294-5b27-4e9c-825b-ec44b6ba1867"
      ]
    },
    {
      "cluster_id": "e7f02350-e0f8-416a-a3fa-4d7dfaaa5615",
      "members": [
        "323c6763-57ea-48ee-87c5-c6eafc928cae"
      ]
    },
    {
      "cluster_id": "1c220b25-802f-4053-89c5-d8f4805341a5",
      "members": [
        "c4274737-78c6-4b47-a485-ba7aa9e58eec"
      ]
    },
    {
      "cluster_id": "88ebdccc-4a31-4f1b-a74f-989ab096e08f",
      "members": [
        "b71c4569-f760-4ec8-98df-cec6d9c6793f"
      ]
    },
    {
      "cluster_id": "3249ee55-684b-4bbb-8b52-6766f62838f9",
      "members": [
        "7f7a99d7-4cf6-44b2-b0b6-0de0e235dc3d"
      ]
    },
    {
      "cluster_id": "c830c75d-93e2-4842-b468-b89a47252719",
      "members": [
        "4dc63b6d-f7f6-4201-81db-2a5e9c6a5198"
      ]
    },
    {
      "cluster_id": "746a6f97-55c7-4dc9-ab6a-cc007e33449e",
      "members": [
        "5bec62cc-de7e-4032-87af-d61602c98417"
      ]
    },
    {
      "cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "members": [
        "a164e5e1-6c36-4c70-b5c6-9787277d7cf5",
        "b557e313-9c02-40c5-b077-13c10297f514",
        "e0de3107-736c-462b-88ca-80ac07a22385",
        "c53e0722-31cd-4216-b4ae-898a6c808315"
      ]
    },
    {
      "cluster_id": "b17129e4-a0b0-4a1d-a70c-02e08bb380d1",
      "members": [
        "23c7ac75-736f-4aea-833a-28c03650c893"
      ]
    },
    {
      "cluster_id": "66e9edc1-c40b-47a3-96e9-eebc44c63b9c",
      "members": [
        "0b283a06-4ee5-4503-bfe0-9b2beb8081b2"
      ]
    },
    {
      "cluster_id": "cbbb2109-39b9-4308-a4ce-30a48563cab7",
      "members": [
        "bb8efabd-a8bb-4e5f-bd1c-fd5a7bc57468",
        "87aed28e-ad53-407c-a04a-af3b0e1015ee"
      ]
    },
    {
      "cluster_id": "f8618eda-effd-4eda-b2ad-66d8fec0ba02",
      "members": [
        "59410815-11d4-4a2e-9972-0e45092f256c"
      ]
    },
    {
      "cluster_id": "cce124fe-f108-4571-9074-db48a458127d",
      "members": [
        "0162d47f-70f8-40f8-a6d6-321e1f67464b"
      ]
    },
    {
      "cluster_id": "8b8d3259-7bca-4683-902c-7b72552f88ab",
      "members": [
        "953328b9-1c72-4ae1-9261-3d122cdf3d99"
      ]
    },
    {
      "cluster_id": "698d5e91-6aba-4224-9583-f0b9f9330723",
      "members": [
        "d1122fc8-22ba-49ee-b1a7-b0292caeea93"
      ]
    },
    {
      "cluster_id": "d1292088-fa7b-4c5f-a6b8-d1bbb1dc9eae",
      "members": [
        "e048a637-c913-454e-b38a-9e567b3309fe"
      ]
    },
    {
      "cluster_id": "55f659a1-e5dc-41c5-8a43-9846f564af08",
      "members": [
        "1b2b8340-6e26-4af6-99f1-7a2fe4c25820"
      ]
    },
    {
      "cluster_id": "ab0a6f16-1446-472c-af45-f55c0d8ddc3c",
      "members": [
        "8f2585bf-bc2a-41f3-af10-5a7cef3a2716"
      ]
    },
    {
      "cluster_id": "59e7addf-52f2-469c-800e-61bb55f3ed47",
      "members": [
        "7494523e-d14d-462e-8096-f2fcaa9cced4"
      ]
    },
    {
      "cluster_id": "b53db505-a920-4607-b45b-0f9423ee6d04",
      "members": [
        "363767c1-812f-4b42-8491-a284197694ba"
      ]
    },
    {
      "cluster_id": "75e57a3a-a55d-4c36-b291-226154171396",
      "members": [
        "86364755-d394-481c-8c8c-312bdb7f9789"
      ]
    },
    {
      "cluster_id": "09907625-9889-4def-8ff5-b61d82ce4a21",
      "members": [
        "60692431-97b1-4bfb-bcbb-9d32815dea0b"
      ]
    },
    {
      "cluster_id": "834f4385-ef2b-4b12-81b1-8e94ff3098e8",
      "members": [
        "a9100648-867a-425d-b31e-08facd6d7ff9"
      ]
    },
    {
      "cluster_id": "c05c40cf-fbe6-4e98-aa0e-98f1fcbb5333",
      "members": [
        "0756090e-6ed5-4879-ba64-2fa9f664c398"
      ]
    },
    {
      "cluster_id": "9477ce9c-5a6e-4e61-9f13-cf68c95b219f",
      "members": [
        "0a153042-81b8-458e-b186-8360e0fbc2b5"
      ]
    },
    {
      "cluster_id": "0c265597-6c2b-4efe-9acb-799f67a3b4d1",
      "members": [
        "a5fa33f1-9c5c-442c-a3b9-3e80c19749b3"
      ]
    },
    {
      "cluster_id": "e129ef72-bb79-4915-92ec-e1ad0c220280",
      "members": [
        "d66f6d8a-9250-454f-b215-5b34d55b6e07"
      ]
    },
    {
      "cluster_id": "71084441-cc44-4209-84ff-0b19201dd17c",
      "members": [
        "81a3712a-94f8-48c2-b3bc-6fb8cb3120ee"
      ]
    },
    {
      "cluster_id": "385e1f90-483f-4a17-bec9-dd37d561707f",
      "members": [
        "99d12199-f4f7-4c93-90b5-7946d74fedcc"
      ]
    },
    {
      "cluster_id": "04e0078c-1ff9-4d1a-8adb-a137164fd78a",
      "members": [
        "21aa88dc-310a-45ee-845d-deabdbade650"
      ]
    },
    {
      "cluster_id": "6a4b35a4-0785-4292-8587-aee85db61288",
      "members": [
        "00df4a79-1dde-4f15-839d-cb6bf604c4a6"
      ]
    },
    {
      "cluster_id": "17326b3f-1222-43e5-90d5-e26c86b0e984",
      "members": [
        "36577aca-4963-4024-a0a0-7ef666c33679"
      ]
    },
    {
      "cluster_id": "ac61e213-06f8-4e65-ac52-8d47ef547cc8",
      "members": [
        "6a00b265-a1c2-4633-84bc-1379e6fb6b3f"
      ]
    },
    {
      "cluster_id": "f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb",
      "members": [
        "edfafc83-4cde-4255-8a4f-9d89f0220509"
      ]
    },
    {
      "cluster_id": "f0bf7f4c-0a27-4681-9eca-ea221b9315a7",
      "members": [
        "a1a5269c-96c4-48bb-b8cb-6724368b2007"
      ]
    },
    {
      "cluster_id": "770fcc6f-66a8-42c3-adcc-243f958e2049",
      "members": [
        "af39a7c0-63c4-43e2-aa19-fa2ce144ead2"
      ]
    },
    {
      "cluster_id": "c3211a84-677f-449b-8204-7cc36fb3bea9",
      "members": [
        "1c51ce2e-fda1-4273-aeec-c291f3c753bd"
      ]
    },
    {
      "cluster_id": "15b9ef6b-09b3-4dc2-aa2e-09ba6d46709a",
      "members": [
        "194c83a2-8011-41ad-84b4-5776ff4a4ccb"
      ]
    },
    {
      "cluster_id": "f8dcd352-7207-4138-bd88-eb7c4051cbbf",
      "members": [
        "c89a8df6-10c4-42ec-ab6f-4f235f1d6fb3"
      ]
    },
    {
      "cluster_id": "aa09782e-9c11-4715-848f-eac275117bbe",
      "members": [
        "5b288e9b-9de5-487a-af64-e3301611a079"
      ]
    },
    {
      "cluster_id": "e370d332-674b-403f-8471-184685b21c55",
      "members": [
        "8cb1b7e4-b0f6-4322-9523-e8c7544f76f0"
      ]
    },
    {
      "cluster_id": "1d7ae3fd-fb7a-483b-9d74-2b16ea9b34ba",
      "members": [
        "9120cc9b-5192-4ad3-9f58-f0d1f74efd73"
      ]
    },
    {
      "cluster_id": "7370b2ae-5bd2-49ba-aa3a-effafe4334a0",
      "members": [
        "d34d499f-105a-42d9-83d2-ad2031a8f07e"
      ]
    },
    {
      "cluster_id": "ef74ebaa-c6e0-4356-bf8a-2ce2acf6ad70",
      "members": [
        "fcc04898-c13d-46f5-bf54-7bbe635d86ca"
      ]
    },
    {
      "cluster_id": "e0d82e7e-dd46-4e81-a408-b1cd11385d33",
      "members": [
        "098b52d5-8a51-4954-9bbc-1cc8535ba6dd"
      ]
    },
    {
      "cluster_id": "37094b58-53c9-4cd4-af90-cb17301eef9e",
      "members": [
        "0c0e7306-ac48-4f56-8f28-b99b87fa1199"
      ]
    },
    {
      "cluster_id": "8d4f670d-826e-45f3-b1fc-0b828324ae7a",
      "members": [
        "b681fe85-1bd7-4f44-810c-0b62519a0c80"
      ]
    },
    {
      "cluster_id": "ef63ab3c-4c57-460f-989f-0ac957105580",
      "members": [
        "81f97fe6-7431-4f57-8955-2767cfc133ec"
      ]
    },
    {
      "cluster_id": "865d4451-2942-47ff-84cb-46ee2b23dc46",
      "members": [
        "8b33178d-bada-4494-a9ee-81b8ccf9246b"
      ]
    },
    {
      "cluster_id": "9c240f69-7202-4a37-b1d5-a3ae10dc5998",
      "members": [
        "78cf9ac9-6b48-4912-a10a-e504a59deaa6"
      ]
    },
    {
      "cluster_id": "07bacc2e-cf13-4467-917c-ef3c2aa505ca",
      "members": [
        "b1cec25b-6abc-42da-9d5a-2069e6d588fd"
      ]
    },
    {
      "cluster_id": "c604d802-912a-4abb-ba43-e290946de463",
      "members": [
        "e6280bcc-1394-4734-b33a-9210d5dd657a"
      ]
    },
    {
      "cluster_id": "18eba947-bd55-4242-95f2-7927edd7f432",
      "members": [
        "9cf61297-8c4e-46e4-8962-f26e488d9602"
      ]
    },
    {
      "cluster_id": "d0323adb-673d-4daf-86e2-8d0f732fd9ed",
      "members": [
        "46e1bf37-c531-4407-93c4-8e1e35475b18"
      ]
    },
    {
      "cluster_id": "50262127-6a56-4d82-bc3b-4ca236eefed1",
      "members": [
        "9aaa26b2-ed57-4999-90b4-829e65b1513e"
      ]
    },
    {
      "cluster_id": "bc56200e-afec-40d7-a87d-167e90733913",
      "members": [
        "ecec4097-a695-43eb-8b4c-422e968635eb"
      ]
    },
    {
      "cluster_id": "0aded89b-0a86-47dd-8291-b59848abe762",
      "members": [
        "db280b6a-5898-4c98-a836-efb473b37d81"
      ]
    },
    {
      "cluster_id": "bfd0fa79-f057-4e1b-abfc-222496dbeabb",
      "members": [
        "e4ed39b7-d2ef-4064-864f-d3c0ca196278"
      ]
    },
    {
      "cluster_id": "cd37a888-7bea-44b1-9691-e12e7c11fac9",
      "members": [
        "87195b27-1879-4bb2-a3df-0a55408ef30d",
        "363394df-152d-40b2-ac62-d490a96c6324"
      ]
    },
    {
      "cluster_id": "c054d850-518a-42ab-a850-01492f7fb7ce",
      "members": [
        "9d89afbd-42cd-4665-98a5-36d61a09dd4e"
      ]
    },
    {
      "cluster_id": "6f473cd4-feae-4e71-a4f1-47b2820e799e",
      "members": [
        "bfec0579-ba3d-4480-800c-a2af8552c46e"
      ]
    },
    {
      "cluster_id": "e06a0883-b86c-4452-9949-2a46787f07ab",
      "members": [
        "e4bd9a5e-54db-49c0-bc0e-a1f3319f41b2"
      ]
    },
    {
      "cluster_id": "c3cd1557-129f-4369-b850-25bdf5456c16",
      "members": [
        "223583c4-ea91-4fb0-bc4e-6603bd51303a"
      ]
    },
    {
      "cluster_id": "253fbf69-01a5-4352-a109-1aea0fdf1fe3",
      "members": [
        "9da0944d-b296-4828-a890-95d79d08fc2e"
      ]
    },
    {
      "cluster_id": "910f66d9-b789-4e64-8888-a565439b59fa",
      "members": [
        "d4873ebc-9fb4-4d1d-b399-bd350edf35cb"
      ]
    },
    {
      "cluster_id": "de08eb08-92b3-4974-9e99-e79755582996",
      "members": [
        "37ddfba5-8974-4a9e-8af2-98d4b5a634cb",
        "f08f91a6-c902-44bf-8aa8-264968dda7c7"
      ]
    },
    {
      "cluster_id": "64664899-be28-4387-939b-822e6b833f08",
      "members": [
        "10eb4524-cc0d-4c59-9a55-9eb3bfdbcdb6"
      ]
    },
    {
      "cluster_id": "be207930-e097-4d94-9b71-209ad62e9e5f",
      "members": [
        "bb37d28a-8d63-40c8-8c8c-2980333262fd"
      ]
    },
    {
      "cluster_id": "294ad0e1-cad9-4655-b7de-5e21de0e4797",
      "members": [
        "ea43da93-e80d-4470-a29f-bd6a20784faa"
      ]
    },
    {
      "cluster_id": "5c890164-2642-4556-87d3-c7dbbd1d4d78",
      "members": [
        "084c812c-89ae-4e1e-8844-39f37dd38c4a"
      ]
    },
    {
      "cluster_id": "558484b7-ac90-44c3-8eec-a2f364ca9460",
      "members": [
        "fc71e4be-3c6e-47dc-a1f9-513916590b5f"
      ]
    },
    {
      "cluster_id": "e473874a-9cd2-4a8d-b926-9354bf1b7e19",
      "members": [
        "3de0f031-a44c-4ef8-b51e-ba461cde1b8f"
      ]
    },
    {
      "cluster_id": "de56a9d8-47ef-4820-ac13-06ed6f8760ef",
      "members": [
        "eee9305f-cab5-431b-8ccc-1d1567aa3a30"
      ]
    },
    {
      "cluster_id": "d47ee5b3-b3df-49e6-9a06-0dbb08c65765",
      "members": [
        "523cc482-5018-4a9f-bf89-01328f70f288"
      ]
    },
    {
      "cluster_id": "8948b384-0046-47fe-bc91-7f2737b00557",
      "members": [
        "67bc5609-6f41-49d7-a47a-86971a7db8cd"
      ]
    },
    {
      "cluster_id": "37ca2b04-06dc-444f-b96a-20f9e5902a07",
      "members": [
        "53cde36e-b505-42de-bf4a-183b7e653698"
      ]
    },
    {
      "cluster_id": "b11a9565-86ce-4b37-aea3-07e84e21fa4a",
      "members": [
        "97e719d0-06c0-4566-a327-e80ecfdb8eff"
      ]
    },
    {
      "cluster_id": "80112f8c-1c78-451e-98a6-361d1ea1a9d4",
      "members": [
        "30f26d7e-7d65-4925-a45f-8b4a229e28e6"
      ]
    },
    {
      "cluster_id": "4d3a2478-017b-48f2-862a-30c57fa5055d",
      "members": [
        "1c45e614-e629-4df6-9c53-2c88e272a6be"
      ]
    },
    {
      "cluster_id": "b6e703fc-a44f-43d6-9db6-85666a802044",
      "members": [
        "15c44e96-a11c-4de9-bde5-402e1c42549f"
      ]
    },
    {
      "cluster_id": "cc6a9454-14fd-45d5-b472-64ca4fedbe80",
      "members": [
        "78083908-48a8-4be3-a6be-474174355e21"
      ]
    },
    {
      "cluster_id": "551e444f-6554-45dd-baba-6798fd43af6b",
      "members": [
        "b743e680-f8c6-4e72-9eb0-2f4ee2ae965f"
      ]
    },
    {
      "cluster_id": "970a5cc7-9a05-4850-b0f1-f59128c441c8",
      "members": [
        "fac8cb04-fc3a-4229-9798-9943e1d279eb"
      ]
    },
    {
      "cluster_id": "ba4d4a13-eb59-48ce-b75b-0c214fe98953",
      "members": [
        "529a5652-12c3-477c-a97f-f03c0aea19ee"
      ]
    },
    {
      "cluster_id": "dc464eb9-fc48-4646-8985-9de6d7531d3d",
      "members": [
        "75d6e4b2-8ffa-4fe7-8847-527575597f9d"
      ]
    },
    {
      "cluster_id": "0c0cca84-dd68-41a0-8489-cb2d22400e3a",
      "members": [
        "5c1096fe-d81e-469c-8dcf-ea91b134de78"
      ]
    },
    {
      "cluster_id": "1cbddfd6-c491-40b1-b10c-fd4387edddf6",
      "members": [
        "ee76c9a0-f9fd-449f-a743-2d8ef8929e88"
      ]
    },
    {
      "cluster_id": "96cc3b99-284a-4ca8-957e-5bfc2a13a654",
      "members": [
        "9bbcb642-5a9b-4821-8e6c-4f6dbf879b9d"
      ]
    },
    {
      "cluster_id": "a01e0915-a285-410d-9d1b-ce9544139c90",
      "members": [
        "968e7ea3-fda1-4688-8a28-4220eebe29f8"
      ]
    },
    {
      "cluster_id": "ea43c4dd-2096-4292-b914-5c467c6f33db",
      "members": [
        "9cb96040-8b46-46be-a544-c2ed6385b215"
      ]
    },
    {
      "cluster_id": "7b36df0c-5a40-406c-8572-3bb3871611ca",
      "members": [
        "a83189a8-34cf-457f-8d7a-64232125f4e2"
      ]
    },
    {
      "cluster_id": "ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6",
      "members": [
        "8f1ab946-4c1c-47f4-9369-87bc4ede4612",
        "f6914820-56bc-429f-9a23-9ee686516844"
      ]
    },
    {
      "cluster_id": "36b91493-5f3f-412b-a861-2328c6420cc6",
      "members": [
        "39baffd5-3aea-40f1-9530-55a17c607cfc"
      ]
    },
    {
      "cluster_id": "4fe899cb-f73e-4ec7-b569-5ce5b990df8e",
      "members": [
        "13c7c5b1-2d5d-4435-981c-edecb42f0d70"
      ]
    },
    {
      "cluster_id": "543e79b8-1458-43e8-a976-eaa0fcb652ab",
      "members": [
        "c3cdb631-c5d8-40c4-9f1e-febbbfea5ca9"
      ]
    },
    {
      "cluster_id": "1be65d4d-c915-41d3-9d1c-864035425656",
      "members": [
        "f898bd5b-3db6-4e02-9f4e-cca47361e39e"
      ]
    },
    {
      "cluster_id": "327aebea-facc-4b65-a419-a9d461f7aa0f",
      "members": [
        "66c410df-05e4-49c6-bc27-30f7de73703c"
      ]
    },
    {
      "cluster_id": "404cf86d-d513-4c8d-adf3-7f2b9464b34e",
      "members": [
        "4591a46b-7300-465e-9949-03baf246f461"
      ]
    },
    {
      "cluster_id": "e045b8f3-c755-4ad1-91b0-a0b8f7878680",
      "members": [
        "cf032c80-cd0b-48d2-a3a5-3284519a1310"
      ]
    },
    {
      "cluster_id": "69638d1f-f33d-45d8-beac-6ee7ce61ea29",
      "members": [
        "1e50fdeb-c36d-46b3-802d-22f9866e50f4"
      ]
    },
    {
      "cluster_id": "a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05",
      "members": [
        "18f01061-511e-40a4-9d51-74d81fda04d7"
      ]
    },
    {
      "cluster_id": "29009c7f-3a77-46aa-91c0-d0f703c52dab",
      "members": [
        "48aa9679-9512-43c5-ae3e-ddb6dfbff73a"
      ]
    },
    {
      "cluster_id": "1b36c1d4-6613-4a77-b192-f653249b73a3",
      "members": [
        "ef6b9f01-065e-4d04-8b3a-f7447639a20e"
      ]
    },
    {
      "cluster_id": "64de434e-21f8-43c2-9395-33dcf3b86c3d",
      "members": [
        "10fc7bc6-6b01-4653-899e-b1a4b55ea372"
      ]
    },
    {
      "cluster_id": "c9073334-10d9-4fd4-905b-747ad45c136a",
      "members": [
        "ec13176c-6ccd-4e5c-961b-22ffa6e0dc69"
      ]
    },
    {
      "cluster_id": "38bae771-edb0-4c72-84b7-885ee4da4419",
      "members": [
        "f8f126a8-063c-48cb-8de6-8d604b399254"
      ]
    },
    {
      "cluster_id": "75d5bddd-c0b4-4755-8a27-ab90a5104373",
      "members": [
        "c3dff2e4-49e4-483c-9299-2dbfb10634df"
      ]
    },
    {
      "cluster_id": "f83b448c-d81d-4175-b604-2783d1df502d",
      "members": [
        "15c077bc-099b-4d93-8dce-aa71f092dea0"
      ]
    },
    {
      "cluster_id": "fa361819-d60d-4532-8084-9c75390ba17c",
      "members": [
        "5312ee60-8654-44b5-baee-82132f069b57"
      ]
    },
    {
      "cluster_id": "66a36ac1-c9eb-46aa-9ae1-0d7306ddb692",
      "members": [
        "e8d68e32-e4be-43f0-a70a-913b968c2dee"
      ]
    },
    {
      "cluster_id": "b777a261-40ed-4845-9730-51d3661e3377",
      "members": [
        "6111a086-ec30-4127-8141-62b797b6ac3a"
      ]
    },
    {
      "cluster_id": "75739be5-4b25-48e8-8d9d-d6319de6bd95",
      "members": [
        "e435799a-de64-4c69-966c-d1f15a3485ac"
      ]
    },
    {
      "cluster_id": "e03ac9ce-f105-49c9-9a2f-9442b3b31044",
      "members": [
        "6ab65c39-651b-4387-a0fd-0cef0e5e1e7e"
      ]
    },
    {
      "cluster_id": "fb95e7e0-9ac4-4fef-85ca-e17c4d83450d",
      "members": [
        "d0faad36-3549-4637-ac1e-26d0f3a435ed"
      ]
    },
    {
      "cluster_id": "2bd9ff92-4ea3-492e-a249-5de7759a5956",
      "members": [
        "632177bb-ffc5-4d67-afdf-5a819358649a"
      ]
    },
    {
      "cluster_id": "18c77ab0-e8d1-492c-912a-03ad6154fa51",
      "members": [
        "4a32340b-0dc2-4055-a540-4eba24f18316"
      ]
    },
    {
      "cluster_id": "a15b9883-60ad-4e49-8943-56ed500ab8cf",
      "members": [
        "01bc9bbb-94b1-4953-ad41-e0012c776da1"
      ]
    },
    {
      "cluster_id": "f6b0f0ef-f78c-4282-952a-d2ce7128854f",
      "members": [
        "08df049d-815e-43e2-a676-499d54cc9bf9"
      ]
    },
    {
      "cluster_id": "44260a23-35ce-4643-9869-bda1004b447a",
      "members": [
        "03652bb1-007e-45f9-8e4f-9f08d9cf265c"
      ]
    },
    {
      "cluster_id": "77119585-efc9-469f-8988-fdb1e15681f0",
      "members": [
        "d22b31b8-a526-47bb-be4e-280c5072e0d0"
      ]
    },
    {
      "cluster_id": "fced5669-e70e-41e7-920b-f76f2f50557d",
      "members": [
        "12cf2e50-bbba-4ffe-a538-dff6e687b7f3"
      ]
    },
    {
      "cluster_id": "0de2a028-10da-49bb-8b43-e7f79a0ff6dd",
      "members": [
        "b7ffeacd-5073-4386-9bb2-5a80e5cba7bd",
        "47c717b3-851d-4eb5-88b5-b17088e768c9"
      ]
    },
    {
      "cluster_id": "47085082-7091-436e-a3ee-ecf14c90e1a5",
      "members": [
        "a0e03745-c934-4002-849b-279c0d7ca85d",
        "86ccc3a3-9bf2-4315-90bb-e4090352abc2"
      ]
    },
    {
      "cluster_id": "54fa045c-bc33-4348-a964-82cb98ec67f5",
      "members": [
        "52c0e6c7-af69-4b03-90b5-60bd0aecb43b"
      ]
    },
    {
      "cluster_id": "0c8486a8-b9af-4dcb-9989-fcb363b7897e",
      "members": [
        "a9720f8c-19bc-421d-a856-3a25464a4f11"
      ]
    },
    {
      "cluster_id": "3e283bf0-1100-4773-9ebf-a90b86b62efc",
      "members": [
        "c3a50ba2-8f19-4548-91c1-576ba23fb11d"
      ]
    },
    {
      "cluster_id": "e4e03461-6763-4291-b9e4-bd4feccb46e2",
      "members": [
        "d41a6028-398e-4752-a435-f4dc2fff1a61"
      ]
    },
    {
      "cluster_id": "3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9",
      "members": [
        "a136f141-6116-48cb-8ff4-a351e75c2348"
      ]
    },
    {
      "cluster_id": "19b1602b-7236-4e52-b704-1442a85ad752",
      "members": [
        "ba369e39-ec45-4ed7-93a9-3a04b478b590"
      ]
    },
    {
      "cluster_id": "0c50e809-0f1b-4656-a0dd-110732b6e47b",
      "members": [
        "24af3b1b-9176-44bf-9cb2-d0a28e6191a2"
      ]
    },
    {
      "cluster_id": "696180e6-d43f-476a-afce-5f13dbb9929a",
      "members": [
        "dfbfe160-e97b-487b-bd63-6307020b0438"
      ]
    },
    {
      "cluster_id": "ddbc1aa3-6d67-4148-96a1-e149d5d02260",
      "members": [
        "8e703566-cce7-4eb6-b60e-6cbe8bda9bb2"
      ]
    },
    {
      "cluster_id": "908a4168-b322-4057-a44b-a100dbffbe53",
      "members": [
        "a117cf36-9039-43b3-b502-f38e0afc8153",
        "c91a56a8-e896-423d-adbb-ca92bf44dc9d"
      ]
    },
    {
      "cluster_id": "8f0344d2-3a73-4534-aa04-5391b7670e72",
      "members": [
        "d7fb78a5-05e9-4de0-b3a9-64b90fbd2106"
      ]
    },
    {
      "cluster_id": "8a444d1c-5423-4444-8123-2c225b02e57a",
      "members": [
        "72b10684-8987-4e6c-9934-4701614da7c1"
      ]
    },
    {
      "cluster_id": "7db64556-43b7-4e29-b1a9-e8fcd5d29233",
      "members": [
        "fe24812a-97c6-476c-9baa-1103a9653551"
      ]
    },
    {
      "cluster_id": "d6760008-6cbf-4c8c-b88a-b478081312d0",
      "members": [
        "3f914465-e5f4-4f05-84df-db17b776b2c5",
        "fc63bc3d-8079-4434-ba23-c70ccb3592a4"
      ]
    },
    {
      "cluster_id": "8a1c4319-f1b2-4b2f-93eb-dd1d35c5dd9e",
      "members": [
        "6a84663f-f127-4280-96a3-0776bc7bcd78"
      ]
    },
    {
      "cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
      "members": [
        "14800c14-8301-405f-8273-4181fead0b91",
        "919b7d95-1dd5-4408-a49a-504a37005d6c"
      ]
    },
    {
      "cluster_id": "13470ac2-b4c3-4aff-aa6a-418a5222958e",
      "members": [
        "4bd74752-050d-4066-aa80-69ad72c07ed1",
        "79113d89-5d52-41ad-8205-38de4d4905a5"
      ]
    },
    {
      "cluster_id": "6f18d0d0-1cda-49ba-9530-57de51dff25a",
      "members": [
        "db638b74-73a7-4ef0-a77c-7ee167075ba9"
      ]
    },
    {
      "cluster_id": "e44edb14-2754-4e0a-969f-2ab83f6f614c",
      "members": [
        "64d07b78-8176-4333-b0a9-435e55537cba"
      ]
    },
    {
      "cluster_id": "7e29e69f-6e9a-409e-8641-59692b521453",
      "members": [
        "a68db6b4-00e0-44e0-a53c-7d461a4c5a33"
      ]
    },
    {
      "cluster_id": "7ccd886b-3755-4c15-8f38-f5ccef3c92ac",
      "members": [
        "0bd91c7f-188d-4ac9-bfa2-ed23772b7839"
      ]
    },
    {
      "cluster_id": "ab7a8719-e742-49dc-b23d-904f2b97e9e2",
      "members": [
        "f9cf5e65-d39a-49cb-9e90-f611127654f5"
      ]
    },
    {
      "cluster_id": "fd424526-ed4e-4b80-99b4-1b131a22e381",
      "members": [
        "751488c6-fb35-4d4a-b4ff-143b277d9a60"
      ]
    },
    {
      "cluster_id": "7386324d-4730-4b17-8d70-6b33d62d5be3",
      "members": [
        "450057dc-4dee-4d4a-a352-f45e8a148e8f"
      ]
    },
    {
      "cluster_id": "9594285e-8196-4153-9b31-89250a7200d5",
      "members": [
        "2ef546a5-b82b-4961-a634-d891566717cb"
      ]
    },
    {
      "cluster_id": "83150260-cbcb-429e-8e22-0e5b897618ff",
      "members": [
        "fe072c3e-a390-4bfb-9639-e3d3aef7f89d"
      ]
    },
    {
      "cluster_id": "d0c2dc4d-9503-4d98-a218-6e6968c3ac55",
      "members": [
        "9c4ee012-99d0-4552-8ceb-9444421b77dd"
      ]
    },
    {
      "cluster_id": "800c3c00-df13-4716-b553-f1b7480d22b7",
      "members": [
        "a007fae1-b18b-474c-b05c-f4f09ad6ffa1"
      ]
    },
    {
      "cluster_id": "baec81f4-73ba-4194-ab31-e3d64c8a57ab",
      "members": [
        "f76c2b0d-e0db-45c6-be46-076f5caf99ad"
      ]
    },
    {
      "cluster_id": "e53d664b-c538-43f3-a025-7686ca315f8a",
      "members": [
        "9f7c75f9-12b1-4273-8a6f-ec449a5a3e40"
      ]
    },
    {
      "cluster_id": "c90c00dc-2c77-42ad-bb5e-2666e53e2bcd",
      "members": [
        "10a1584e-2796-4a75-b1af-556789b76995"
      ]
    },
    {
      "cluster_id": "612e00dc-099b-40a4-b39a-4b7adbab73ce",
      "members": [
        "7659a98e-7d46-4a48-9bfd-b379e1608b2a"
      ]
    },
    {
      "cluster_id": "81fccffb-0c5b-4efd-826c-64c3efbb0393",
      "members": [
        "252cf072-286f-454a-a807-ea3fa5398883"
      ]
    },
    {
      "cluster_id": "1ae849f8-e182-405a-a33b-006fe51f03e6",
      "members": [
        "29ab53fe-1f96-4405-82de-f10f2733963e"
      ]
    },
    {
      "cluster_id": "08f93426-27fb-4a01-8b3a-b106b5f837ec",
      "members": [
        "d3611e87-51c2-4d02-85fa-7af37e6165b0"
      ]
    },
    {
      "cluster_id": "93548381-56c4-4fb7-be49-43e644f447fb",
      "members": [
        "1bdcdd86-8b98-45b8-ade9-9162e65e0f28"
      ]
    },
    {
      "cluster_id": "bbad87a2-fdaf-4bdc-9b37-124a381131af",
      "members": [
        "149651fd-033d-43b1-87d3-665446966eb9"
      ]
    },
    {
      "cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "members": [
        "9f730df3-0a30-4356-9fb5-3da44426f7ea",
        "1b7f21e9-b087-46d6-b057-af8f6f234184"
      ]
    },
    {
      "cluster_id": "058ec7b4-d77f-44ec-81fa-004e499dce82",
      "members": [
        "52b34824-1373-40d1-83be-3018e61ae605"
      ]
    },
    {
      "cluster_id": "536df2e4-b955-48b2-8a3c-5b06a58c9d87",
      "members": [
        "dea6733b-6020-4f8a-bb8e-8c60954965b6"
      ]
    },
    {
      "cluster_id": "71211c39-a653-4c7c-bf55-0339568d069a",
      "members": [
        "ced68cf4-b495-4acb-a046-9612864342c4"
      ]
    },
    {
      "cluster_id": "e2c6a7c7-ff69-4a0f-a631-41e7e5bd25a0",
      "members": [
        "94aaec06-525e-41e8-abea-4a063c8d258c"
      ]
    },
    {
      "cluster_id": "546cb276-d6b0-40dd-8288-6659cb7989f0",
      "members": [
        "7045d31a-2fff-4ed5-88f2-f70ba117865a"
      ]
    },
    {
      "cluster_id": "7bcfb80e-f4a6-4404-be69-078e88ddce1f",
      "members": [
        "ecae8d19-6ad9-4d7d-8d32-0bb0062c4bcc"
      ]
    },
    {
      "cluster_id": "b8726f80-5b75-44d5-9a25-5d095109008d",
      "members": [
        "a623bf10-1bc0-4bbe-a810-62f28445d4f5"
      ]
    },
    {
      "cluster_id": "1574223b-5ec0-4588-8996-6510aa3052d6",
      "members": [
        "968ad657-031c-49e2-963e-443fbd372a02"
      ]
    },
    {
      "cluster_id": "ea6a2243-de2d-4dba-b6c1-70fc6e903bfb",
      "members": [
        "0b793eb8-460d-4d54-a9c0-6fb4873518f9"
      ]
    },
    {
      "cluster_id": "62083248-470f-4a86-883c-26267fb22566",
      "members": [
        "eeb9c461-a753-461d-8f50-a2404bad2189"
      ]
    },
    {
      "cluster_id": "50967b88-5546-4fd0-9e1b-6bf235297b83",
      "members": [
        "feb308fb-89d7-4094-8142-ce7a2b1e6715"
      ]
    },
    {
      "cluster_id": "729d6508-b5df-44ab-8ffd-349b7a126b16",
      "members": [
        "47d10127-8b88-453e-b9b9-9ac3fec996d9"
      ]
    },
    {
      "cluster_id": "9960f165-6141-4ca0-8dc4-0a136bfde83d",
      "members": [
        "d4bb636a-ef12-4e0d-99ec-9d63b895cc16"
      ]
    },
    {
      "cluster_id": "edec9892-cca5-4a34-b102-ebb0bb45e077",
      "members": [
        "06a3e8a5-24e0-404f-bdf4-12b6e222fc18"
      ]
    },
    {
      "cluster_id": "c25095fd-de4f-41d0-8719-35f31e51779a",
      "members": [
        "1d51047a-8bca-4664-bba8-aabca8a4a441"
      ]
    },
    {
      "cluster_id": "6d226b20-d54f-48d2-bd7d-2616184afc68",
      "members": [
        "fa57cb9e-6ccf-475d-8f43-70972d672647"
      ]
    },
    {
      "cluster_id": "ae1d4689-4f04-4acd-a0d9-2c0934c3acd4",
      "members": [
        "07860eb4-7e2c-4546-9bc6-7ca701048da8",
        "85b61735-9032-4a87-af70-6f181c7a1dda"
      ]
    },
    {
      "cluster_id": "c8c946c0-f2a9-4ddc-bd30-57a913603310",
      "members": [
        "f5be3f3f-5b0b-41e3-af54-35a878dd3fb8"
      ]
    },
    {
      "cluster_id": "c2350485-f95c-46d4-9b92-6355ceca86df",
      "members": [
        "77d68ce8-66fc-42bc-a8d0-0495a4c960b6"
      ]
    },
    {
      "cluster_id": "aae0458a-2ab8-46b3-a4d3-61a4d3fd85ca",
      "members": [
        "4ce202c4-ee9f-4ab4-bc4b-d87abc617ed8"
      ]
    },
    {
      "cluster_id": "a751c83d-9da2-48e9-83a8-bc6d8a1c455f",
      "members": [
        "ce9c9e32-2219-4f66-83a7-989550bdabe5"
      ]
    },
    {
      "cluster_id": "145c6709-d797-4b12-bf2a-a6ed41e9efad",
      "members": [
        "3b0b5562-9d6a-4197-a16f-1ad69b1cc4a0"
      ]
    },
    {
      "cluster_id": "94c9f0c7-1016-4b43-931c-9bd7dc0b2892",
      "members": [
        "e04aabd2-3b11-4d85-9454-5293b1eef028"
      ]
    },
    {
      "cluster_id": "9bd5e01f-d2aa-4157-a2fd-143c30274710",
      "members": [
        "f7759163-a314-4b80-86d0-b7637b3cd643"
      ]
    },
    {
      "cluster_id": "fc8bfdbe-11b3-42f5-b3d0-f35ef7784a93",
      "members": [
        "d9fca8eb-fc43-4ccd-866c-6a62a072e2f9"
      ]
    },
    {
      "cluster_id": "f51dc065-8987-4a56-b2b7-f53334ad4ee2",
      "members": [
        "72f2090b-17c4-4faf-b2be-bc36323f1e2b"
      ]
    },
    {
      "cluster_id": "168a2344-84cd-4fca-8692-ada3563a273d",
      "members": [
        "64d045e9-0660-4692-b1f8-8b191f6cd9b2"
      ]
    },
    {
      "cluster_id": "f74715cf-7efc-4866-8a83-4aec1b75795e",
      "members": [
        "4b646847-1cb5-4f88-90a1-ce18b12cd313",
        "081b2b41-5d2f-468a-8eda-4d4c95d9f977"
      ]
    },
    {
      "cluster_id": "3786df1e-47ff-4916-973b-ccf57ccb5e4c",
      "members": [
        "2e13e180-291c-45bc-a491-c8cd8f430264"
      ]
    },
    {
      "cluster_id": "4cef0d90-5e3b-44f3-ba12-57b1ee19455a",
      "members": [
        "6d117aeb-ccd3-4e78-8899-ddad3c137ea6"
      ]
    },
    {
      "cluster_id": "c7eb5329-6775-4d3f-aea7-7de4fbeb8175",
      "members": [
        "de2c1ee0-8549-40d1-8446-21411e0d089a"
      ]
    },
    {
      "cluster_id": "74381468-96fe-4ea3-b795-41362208378c",
      "members": [
        "82c5ec92-7d92-4548-9470-04867fdf8828"
      ]
    },
    {
      "cluster_id": "cfbbcd75-4bf0-4351-b592-afb201b74b60",
      "members": [
        "736d9e03-dc3d-4f14-8419-90e558838823"
      ]
    },
    {
      "cluster_id": "1b63ec5b-2010-4bd3-a351-328e7b4b5470",
      "members": [
        "ddce07da-f9dc-4166-932b-b52520d4d2b5"
      ]
    },
    {
      "cluster_id": "4cb70cfd-308b-45d4-a6de-94896ddf47a0",
      "members": [
        "ac90a491-ea82-4572-a011-004f6b3e29e7"
      ]
    },
    {
      "cluster_id": "b9e4bfc6-c83b-47ab-95a9-d3b6db015c07",
      "members": [
        "2c42f23b-b2e9-431d-951f-51cfe3051581"
      ]
    },
    {
      "cluster_id": "471cd849-51ac-493f-a2b6-3965a7fc582c",
      "members": [
        "651343a0-1855-404e-9bca-18e93f2d5a77"
      ]
    },
    {
      "cluster_id": "58b4fd6b-1eec-47dd-b945-a94d957a9933",
      "members": [
        "6181efef-91d7-46cb-be69-cbde16defa0f"
      ]
    },
    {
      "cluster_id": "376826e6-eaf6-4628-ab75-e400a091149e",
      "members": [
        "1abc1279-e2d0-4488-8b82-46263c61dcda"
      ]
    },
    {
      "cluster_id": "a1d5bcf5-80de-4ba5-b40d-443ea3d3eb11",
      "members": [
        "a6383900-6404-4d3f-8aba-0687e070ebc7"
      ]
    },
    {
      "cluster_id": "f66bb1c3-c6f1-4000-8eb0-82b5bd8bc518",
      "members": [
        "322008f0-3241-4a93-b5d4-df5fb6ca9a96"
      ]
    },
    {
      "cluster_id": "96cef335-1ca0-48d6-912f-d308e0729c0b",
      "members": [
        "45054bb5-98c4-4cfe-9680-35000796ee24"
      ]
    },
    {
      "cluster_id": "758d6034-7d93-4286-ae2b-f2ffde861da6",
      "members": [
        "2b89486b-0ab3-4157-b0de-77774c409613"
      ]
    },
    {
      "cluster_id": "cd21b07f-3941-439e-8ffa-59c6da9df98f",
      "members": [
        "1abb2f07-9cf8-48b2-bbf1-d78cad1a62e4"
      ]
    },
    {
      "cluster_id": "49c94f1b-b278-42a0-b8b7-d0f8ec55d536",
      "members": [
        "8d5d7861-9d12-4c60-805b-c0152ee0c78d"
      ]
    },
    {
      "cluster_id": "62fbb5b2-0ba7-4211-b72a-eb1c18543408",
      "members": [
        "447dd20c-66d9-47e0-b122-5a27bc28aa15"
      ]
    },
    {
      "cluster_id": "79c4f8c6-ab1d-43ae-9503-5af83d7fa7e6",
      "members": [
        "82b3bde1-e7fb-4c19-b8d1-78fcf4f4f472"
      ]
    },
    {
      "cluster_id": "c85112cb-b1b4-4c61-8955-fca094b1a4c4",
      "members": [
        "e753e65c-048c-4f62-b90b-dce6303a03d1"
      ]
    },
    {
      "cluster_id": "565a8eff-d3c3-4887-a42a-b357e222a101",
      "members": [
        "c06a2666-40ff-496c-862a-430c79f26354"
      ]
    },
    {
      "cluster_id": "c75e8276-e126-4693-a87d-4d748183e6fe",
      "members": [
        "f8d94da2-78a7-41b9-bca7-32fc74a9adb4"
      ]
    },
    {
      "cluster_id": "b8a67936-c036-4a45-8680-bb4909cdd3db",
      "members": [
        "e255c9b3-68b0-46d2-9a2a-ba4bcded54a1"
      ]
    },
    {
      "cluster_id": "3d52b30c-fa0d-4a4c-9240-38abdfc6ab20",
      "members": [
        "ed417166-4ba2-4b0b-ac3e-6aa5232a0d5e"
      ]
    },
    {
      "cluster_id": "8a4b9d30-600b-48dd-9a32-934835947825",
      "members": [
        "5501761a-5b10-4728-a8a3-305eed365584"
      ]
    },
    {
      "cluster_id": "b4479b0e-003b-4796-9f06-dafafe7cc27d",
      "members": [
        "38e66b36-6f12-4189-883a-2d2e79d627a7"
      ]
    },
    {
      "cluster_id": "043e7562-9880-4d36-ba06-fd8e6b3afbe1",
      "members": [
        "0a7a602e-58ed-48e7-880e-a6a2881376a5"
      ]
    },
    {
      "cluster_id": "64b58fdb-7776-47be-a603-30c85a60366e",
      "members": [
        "2908fd39-9ca7-4a1e-984b-ef0485bb1cd8"
      ]
    },
    {
      "cluster_id": "3eeddc05-77ec-4d67-9a78-4b328957fe7f",
      "members": [
        "e709b53a-f0b3-42a3-a3c9-f194801b8eaf"
      ]
    },
    {
      "cluster_id": "6f9b01a7-d717-4ce1-bd54-f5647d476287",
      "members": [
        "f3482401-f636-4769-8a6e-01b1b53ccd94"
      ]
    },
    {
      "cluster_id": "b633274f-2881-417d-afbb-e5015101f863",
      "members": [
        "c3d8d26b-ab72-4684-bfbd-296bbdcf9a7b"
      ]
    },
    {
      "cluster_id": "232994db-dcd7-4db4-9ea3-fad6185233a7",
      "members": [
        "d283bd77-2689-4ff7-943f-a906148645aa"
      ]
    },
    {
      "cluster_id": "a5408918-67c4-45bd-afb3-95d8aced1dc9",
      "members": [
        "651a25ba-535b-453b-9f80-85525734d412"
      ]
    },
    {
      "cluster_id": "5beed7c2-e377-4032-9f8d-5e0e7f3ae7e7",
      "members": [
        "b4ca2a6e-2153-4976-9199-941915539996"
      ]
    },
    {
      "cluster_id": "b7cbc93e-51f6-448c-9fc2-c1af44082069",
      "members": [
        "95819ed2-6fea-4da0-8adc-b11616db0c19"
      ]
    },
    {
      "cluster_id": "94599b0f-3332-46af-911a-e0ea949079dd",
      "members": [
        "f02ae4fd-dfd7-4a34-9d71-f0f3326534dc"
      ]
    },
    {
      "cluster_id": "c51e0b3e-03c3-4464-95af-a00db4b0bdd2",
      "members": [
        "bbf92366-7621-4b54-878d-8d640f7d00ec"
      ]
    },
    {
      "cluster_id": "5b4b432d-262c-43d8-a2ca-4d8a45a3e1de",
      "members": [
        "0c207476-8b95-45b5-8537-d0137808b419"
      ]
    },
    {
      "cluster_id": "6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4",
      "members": [
        "71ac27db-e609-47dd-9edc-ad973ee7832e"
      ]
    },
    {
      "cluster_id": "aef50142-8ad0-4099-9362-3d45c56385fc",
      "members": [
        "d2e895d3-6f8f-45b0-8f2e-594dea520523",
        "befed9b2-e17c-44f1-9c3c-7d11496a4a66"
      ]
    },
    {
      "cluster_id": "30229ad5-5242-4fd1-8256-d013e88e6413",
      "members": [
        "6c30c088-4430-4f1e-bea0-16e5f3939ba6"
      ]
    },
    {
      "cluster_id": "e3c5e173-2814-430b-ad9d-2c7612d87ea6",
      "members": [
        "58ca5117-68d3-48a5-ba9e-c55f3b0c979f"
      ]
    },
    {
      "cluster_id": "0c068743-c246-4fb1-8a38-ed41dc7e9fa3",
      "members": [
        "ac00d441-3a77-4269-bcc6-e6e791cbb06e"
      ]
    },
    {
      "cluster_id": "fd96ef0f-c2a3-47f0-b0ee-4580d498d313",
      "members": [
        "f0a1f347-7468-4968-8bf4-947f482fbd0c"
      ]
    },
    {
      "cluster_id": "0a0436c8-54af-4b5e-9725-fc8ed172d1cc",
      "members": [
        "92e2aa1f-7896-4d02-b097-114d0eb2d684"
      ]
    },
    {
      "cluster_id": "c35acce9-0a6f-4e25-8869-1a5e38bf302a",
      "members": [
        "c9ab584b-166f-48ee-93a8-a068efe520a8"
      ]
    },
    {
      "cluster_id": "d21ce376-5e68-41d1-903e-db8ea2f295f8",
      "members": [
        "45b36f9f-2701-407c-bb41-2da5cf74f4da"
      ]
    },
    {
      "cluster_id": "f8d5c2ae-ad96-41f1-8875-2d89a574f697",
      "members": [
        "f231c676-5eee-4509-9a0f-ae36631ff30d",
        "b658e2b4-f861-49b7-822f-9d60d545a8fa"
      ]
    },
    {
      "cluster_id": "a32303e6-4765-4335-9847-b5ee18494799",
      "members": [
        "2cc8f02b-f6f7-4b00-acbb-48afe8748ec0"
      ]
    },
    {
      "cluster_id": "12667ac4-7c0c-4916-8553-cead6974cc24",
      "members": [
        "44921dd7-fb68-4673-9d91-d3c7d39bf5ae"
      ]
    },
    {
      "cluster_id": "c63decfc-559c-461a-ad2c-a9922b7e06df",
      "members": [
        "291156e6-b34b-454a-a4a5-234d1b5a9b37"
      ]
    },
    {
      "cluster_id": "f799549d-5869-4a73-bd0f-66e1fb2939bc",
      "members": [
        "bd51b6da-c68f-4d00-a66d-ac47ba7a5598"
      ]
    },
    {
      "cluster_id": "5a787097-c657-4d02-a7e7-ce5ddfe404d6",
      "members": [
        "385112f9-b5f3-4bdc-8cfd-95878a4457c1",
        "dfaa1764-c3e1-450f-a71a-f7e11f966f70"
      ]
    },
    {
      "cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "members": [
        "adc2e10c-ef34-40a9-a1b5-99f334f56fd7",
        "33bd5081-6fe1-480c-9fd8-c94f6d44aeba"
      ]
    },
    {
      "cluster_id": "7eff6a8d-9ae3-41f9-9ad2-cfcb191e7380",
      "members": [
        "b16d536e-4a06-4640-a9ed-1354ae306aae"
      ]
    },
    {
      "cluster_id": "ea316b29-c411-49a8-8ebd-8e50456fc746",
      "members": [
        "5fc68f54-02e5-4dcc-bf66-6782dc973afe"
      ]
    },
    {
      "cluster_id": "a44bb3c4-918e-4230-8542-c0aebafed121",
      "members": [
        "593862ba-9e8d-460c-b843-16a9919801bc"
      ]
    },
    {
      "cluster_id": "800e7e36-7ce1-4e55-a18d-394d83673d71",
      "members": [
        "0683ebf0-51d7-446e-ae91-9a60cf532735"
      ]
    },
    {
      "cluster_id": "5b5bad5e-15a1-4d61-9521-27fe4f90522e",
      "members": [
        "c3a11704-5ca5-4d3b-b989-4151dca867dd"
      ]
    },
    {
      "cluster_id": "0884e607-6aee-438f-ad6b-dac7b6c0719c",
      "members": [
        "871435cd-e0dc-43c8-82ff-47803cfead5f"
      ]
    },
    {
      "cluster_id": "d072d7ca-3280-4412-8e76-be63e36fe491",
      "members": [
        "fc39d71b-5191-4106-baf8-5af64493684d"
      ]
    },
    {
      "cluster_id": "b26a20fa-d793-419d-b599-26d1ed57c2b3",
      "members": [
        "1292f243-95fe-4e8d-b668-0561b4d9f934"
      ]
    },
    {
      "cluster_id": "1a4ea1ae-4636-425b-b953-e3a50c80caeb",
      "members": [
        "98eff29f-6b83-432c-b28b-927ec4b83a7c"
      ]
    },
    {
      "cluster_id": "b43b3e32-d544-43ad-b781-20a883c7f4b7",
      "members": [
        "609f12e8-ad23-49e1-abab-57a8195e8af6"
      ]
    },
    {
      "cluster_id": "483b6a3b-d48b-40f7-b28f-e79dfca268e6",
      "members": [
        "b612352c-d6f4-4820-9245-cbdc7a728701"
      ]
    },
    {
      "cluster_id": "6967755e-61e4-4308-be97-cdea95a155c7",
      "members": [
        "f03f1e47-b185-4b08-8ff3-c014963ea848"
      ]
    },
    {
      "cluster_id": "0af113aa-da9f-4ed6-a163-dcb48f1459ee",
      "members": [
        "66154323-d238-462c-95db-6390cf14013b"
      ]
    },
    {
      "cluster_id": "253e1524-e402-4a4d-b7db-f94b8f989d9c",
      "members": [
        "751252eb-c248-4e27-a607-510c64f2f866"
      ]
    },
    {
      "cluster_id": "928cf7ca-8343-47ca-be27-378bc29b7fbe",
      "members": [
        "6932d003-f34e-4235-87eb-e7cd45ec36c3"
      ]
    },
    {
      "cluster_id": "243cbf96-dba8-41a3-9dc7-8def431d23c9",
      "members": [
        "e0fb6168-f755-420a-bba6-5da68728897c"
      ]
    },
    {
      "cluster_id": "d97f4faa-5b32-4a18-93ac-69c340df4581",
      "members": [
        "ea294df8-d351-4b71-9ef7-6acdce1bdf21"
      ]
    },
    {
      "cluster_id": "f6b9e37f-45a9-4864-8489-2f475476f4fc",
      "members": [
        "07112370-1b0e-4aba-9663-35f7e03a3646"
      ]
    },
    {
      "cluster_id": "b659052c-10e5-47d2-985e-c2c7d42a67a2",
      "members": [
        "f5b2b00e-ba38-4547-a0b9-3092f6091cef"
      ]
    },
    {
      "cluster_id": "30765e40-3943-483b-8e1e-27d3053ae2bd",
      "members": [
        "41ed43a2-38e1-476a-8304-8f12a9f67878"
      ]
    },
    {
      "cluster_id": "31ba7a04-0212-474b-8f8e-9374845e4ab5",
      "members": [
        "05191600-57d5-415e-b4f4-c412f47f41a6"
      ]
    },
    {
      "cluster_id": "96b36513-ec34-4deb-bc5b-c811958c3675",
      "members": [
        "9c495b9b-667e-433f-9dab-51269cfe4ea4"
      ]
    },
    {
      "cluster_id": "a7614301-2ae0-4bb1-bcf4-8bc8d82acc70",
      "members": [
        "457c7f59-3b69-4f57-a82e-eca71fe7656f"
      ]
    },
    {
      "cluster_id": "fe25e7ff-abc9-4e8c-bafa-dc9163738c4e",
      "members": [
        "4d05a7f2-89f8-45fc-b32d-b3b1d5fec6f0"
      ]
    },
    {
      "cluster_id": "1927948e-52f7-43b0-aafe-d3f160820394",
      "members": [
        "3e3765b1-eaf3-4bba-9591-48394d3143e1"
      ]
    },
    {
      "cluster_id": "ac6c3346-ea92-4da2-afed-ba431832d85e",
      "members": [
        "49603d79-aab0-4745-b291-b320f6ab4409"
      ]
    },
    {
      "cluster_id": "7be2aab8-ebba-4a53-8dd8-2f99fbdc274c",
      "members": [
        "f45aed36-6ef1-4d69-822b-6f2f4982179c"
      ]
    },
    {
      "cluster_id": "b1da162a-fb28-4547-8fd8-715c5361b7af",
      "members": [
        "b3c74b9c-d96a-4447-9a9e-6a0ac43bec8d"
      ]
    },
    {
      "cluster_id": "61152334-8dda-42a2-bb8d-9fb770fd72f7",
      "members": [
        "2a625bb3-0488-4532-98e8-0cd6f90748c7"
      ]
    },
    {
      "cluster_id": "0961c365-4261-4c91-984b-81c62260d807",
      "members": [
        "8bd6557f-ec53-4465-b0a8-3f71d5b51659"
      ]
    },
    {
      "cluster_id": "0e4acd7e-6e9e-4ec6-953b-f0301546aee1",
      "members": [
        "d337f025-3d3e-4881-9db1-26a9cc34fc60"
      ]
    },
    {
      "cluster_id": "957872f4-ebb4-47bd-9d9e-487c3755644e",
      "members": [
        "d118ff64-c246-49b2-b6dd-8119a5bdbd34"
      ]
    },
    {
      "cluster_id": "2ca08905-d2cc-4e5f-80b6-1f1b64356b18",
      "members": [
        "5f5e53a0-8662-4d96-8adb-4d1f861b5ba7"
      ]
    },
    {
      "cluster_id": "e36180c3-afe0-495c-8168-73e631f50a1c",
      "members": [
        "5ca6668a-af13-413c-81ee-eadecac59929"
      ]
    },
    {
      "cluster_id": "d832a602-46fe-4c29-83ff-f47197eab057",
      "members": [
        "8a238a7c-f96a-415d-a339-07d5f96f0b45"
      ]
    },
    {
      "cluster_id": "bee4d72b-b159-4b6c-830c-362b42a2b18d",
      "members": [
        "0fd219cf-7794-4e20-9d7a-bd0f952d8847"
      ]
    },
    {
      "cluster_id": "1075443d-c097-4cb8-acb0-3d21f48f6aca",
      "members": [
        "511305e3-08a8-47bd-ba35-92e850caf3d8"
      ]
    },
    {
      "cluster_id": "fc64cbea-821d-4f81-89aa-1c161d723583",
      "members": [
        "af738d60-42d9-4182-b743-c15060b3b799"
      ]
    },
    {
      "cluster_id": "dff8a985-ffc1-4946-ab7d-43e8406aca00",
      "members": [
        "79868c5a-81e7-447d-9f0e-e7d3ced773f5",
        "562026e1-3ea1-40be-bb7a-064c265fc22a"
      ]
    },
    {
      "cluster_id": "0e8e4003-b007-4df8-a1a5-948e64fe6342",
      "members": [
        "1c742d5f-4f38-4dbf-a3f8-5ea02c118d90"
      ]
    },
    {
      "cluster_id": "041ca325-747b-4d3c-b3c4-9ee7fabc37db",
      "members": [
        "fd2f32b7-550e-400e-a654-d1c8d25a01f3"
      ]
    },
    {
      "cluster_id": "a3cc8d63-1533-4239-bc6b-bedcff828ef9",
      "members": [
        "d61a4f40-3482-4719-be2d-5a97dbe2f20d"
      ]
    },
    {
      "cluster_id": "6a13b21b-08c5-4326-8613-c7913554f2c7",
      "members": [
        "2edc566a-662a-48eb-9f6a-06f9b3f71ef9"
      ]
    },
    {
      "cluster_id": "2c8b719a-2363-4f9f-9be2-6d1801374195",
      "members": [
        "3ef65eb1-1d0c-4cd8-873a-c2e6b2ec18d5"
      ]
    },
    {
      "cluster_id": "802c7e0c-e913-4631-9fd3-b4b457a510e0",
      "members": [
        "60e72e41-ea27-4630-b2b8-d2a69192d55b"
      ]
    },
    {
      "cluster_id": "ed1b332b-c054-4114-82a1-1e645946747e",
      "members": [
        "c225cecc-fbc4-42f9-b662-389b8449adc8"
      ]
    },
    {
      "cluster_id": "6a54c6d4-9e49-450e-95c4-f3afc0f85f6c",
      "members": [
        "57353be9-8323-4c01-a15b-a358286bcc76",
        "0d04ae10-ad0e-4f53-891a-e7cdc4751e7b"
      ]
    },
    {
      "cluster_id": "fd107d16-4df5-452b-96c2-989c72732db7",
      "members": [
        "80f98ec2-b840-4020-a19d-c9ef321f581a"
      ]
    },
    {
      "cluster_id": "bd5ae3e5-8ac9-4557-ad42-7cdcb0687b6c",
      "members": [
        "775ec7d2-331c-4113-ba9f-8ec35702f009"
      ]
    },
    {
      "cluster_id": "64ec2b0f-c55e-42e7-a532-b9948f0a43c1",
      "members": [
        "f9eac5f3-6751-4192-85e6-5ff9a684b5ba"
      ]
    },
    {
      "cluster_id": "2616e42a-b0ac-42ff-93a5-2376cee42b92",
      "members": [
        "15ed2e39-9578-433f-ba74-c276daed508c"
      ]
    },
    {
      "cluster_id": "4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d",
      "members": [
        "ba280fb7-61fb-41f2-b800-9919def41677"
      ]
    },
    {
      "cluster_id": "19ddcd3b-18db-461a-b208-f198db3e1e07",
      "members": [
        "b401c9aa-19d5-40ab-8658-520adac91bd0"
      ]
    },
    {
      "cluster_id": "1d2ba60d-53c7-4e8c-91e5-1d0e114d5708",
      "members": [
        "45e9572f-4e25-4790-aee0-bebc5eb39d5e"
      ]
    },
    {
      "cluster_id": "bbefdcbd-8560-44a4-b45a-d11652dfe311",
      "members": [
        "75da4af8-5a1b-4f40-9c0e-a2e1b8ff0482"
      ]
    },
    {
      "cluster_id": "23106ade-18c8-44c0-8d3a-ef2f743468af",
      "members": [
        "640c728f-8be2-473d-ad7d-502c6a1e1829"
      ]
    },
    {
      "cluster_id": "1e9d6c21-797f-4483-9122-2e9582f833c2",
      "members": [
        "913f68f5-8331-4420-bc8a-c649254faa99"
      ]
    },
    {
      "cluster_id": "ba694c90-be36-448b-9da2-f3ed0d816139",
      "members": [
        "bd9a9dd2-0105-4d29-a032-62bd305b6e43"
      ]
    },
    {
      "cluster_id": "5736135c-d235-4604-8803-ae7412cb8825",
      "members": [
        "3cfc2483-90d2-4c7a-8eac-a1fb89531809"
      ]
    },
    {
      "cluster_id": "30d2edfa-6d58-40ae-bac6-ec1273c415ac",
      "members": [
        "addcb655-a008-4fe7-b130-ecc2ff51b64f"
      ]
    },
    {
      "cluster_id": "4af97b54-9617-48e3-8125-aa1e8e1ee8a2",
      "members": [
        "d8a89786-9032-4e97-800a-d94a3e6cb02d"
      ]
    },
    {
      "cluster_id": "bbf2648f-d211-49b0-bf5c-a562e43902c5",
      "members": [
        "07c7eadf-eced-4f28-94d1-a3f3aff2b1d6"
      ]
    },
    {
      "cluster_id": "fdc7a586-a2b7-43cb-897c-5aacc04ceaff",
      "members": [
        "b4d92106-34b0-4251-9ce2-d54fe3fbc420"
      ]
    },
    {
      "cluster_id": "74e38083-39b2-4b0b-8874-879983366a75",
      "members": [
        "58b5190d-ce6a-4fc4-9edc-11d2a480f911"
      ]
    },
    {
      "cluster_id": "7e9a80fa-c7f8-4eeb-8f62-09cee3732838",
      "members": [
        "f5de99ae-33e0-4256-9407-b097cbd646bc"
      ]
    },
    {
      "cluster_id": "f358da84-14e4-4001-acb3-83fa23673eb8",
      "members": [
        "b0acd26c-c9a6-4552-ad9d-ea0b44968974"
      ]
    },
    {
      "cluster_id": "69290a80-8807-401f-b38b-0ff5ba27a43d",
      "members": [
        "725ac9c2-bb18-4002-bd08-67981daaf6a0"
      ]
    },
    {
      "cluster_id": "5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa",
      "members": [
        "2f3d3b59-bb08-42a9-8a03-1792491fee63"
      ]
    },
    {
      "cluster_id": "d583e7b2-dc4a-4915-a3d9-e76bbe714788",
      "members": [
        "155eb26c-e15b-4e3e-a085-683747910dc3"
      ]
    },
    {
      "cluster_id": "a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20",
      "members": [
        "fb4b7724-a0fd-4547-98c7-26503f3a7d9d"
      ]
    },
    {
      "cluster_id": "aa440a76-9b1c-4801-9031-cdac4add116a",
      "members": [
        "4d21b835-341e-494a-be3a-330340cde702"
      ]
    },
    {
      "cluster_id": "29880646-f50e-47bd-8b04-23f2c8716fdf",
      "members": [
        "4af2eec6-df79-4f7e-8d67-62d9045e7add"
      ]
    },
    {
      "cluster_id": "f57f4c9e-1d41-4f34-b42f-aa11437d6812",
      "members": [
        "de23e9a7-26ca-43c3-a9c3-b184324c8585"
      ]
    },
    {
      "cluster_id": "da661a25-9665-44d1-ac27-e2613681adf1",
      "members": [
        "14addd9b-d054-452d-98ec-4906dd68c00d"
      ]
    },
    {
      "cluster_id": "294d0346-cddf-4b1e-a6bc-ab4686137712",
      "members": [
        "636cccd0-6554-42ac-acf1-237a07de714a"
      ]
    },
    {
      "cluster_id": "2762cfd3-48ae-4a0c-baf0-bfb36bcdff70",
      "members": [
        "2aa60b28-354a-4deb-b9ca-9740137c0c66"
      ]
    },
    {
      "cluster_id": "635fb80e-2799-454a-8570-6fc3830d271b",
      "members": [
        "47e06e70-dc3d-4ba5-9c42-8784eb5b06e1"
      ]
    },
    {
      "cluster_id": "43fe48a2-ed82-4cef-9784-8e8df627f565",
      "members": [
        "9a8dd729-abcc-4567-8a42-89096437946c"
      ]
    },
    {
      "cluster_id": "24d81b39-c399-4c59-ae9b-c84548655d0b",
      "members": [
        "92b58bda-45cc-44f2-a5b0-2bd0cbacac33"
      ]
    },
    {
      "cluster_id": "fa32fcee-2bb1-444a-8515-123065611c9e",
      "members": [
        "bd383d7d-5d38-43fc-9a92-f6bef332f4df"
      ]
    },
    {
      "cluster_id": "099e4f99-da99-4f13-a242-dd05de802ab3",
      "members": [
        "dd091e24-7eb4-4929-bdb1-9d781d4ae3f9"
      ]
    },
    {
      "cluster_id": "b49a91d7-446b-421b-9670-7c99bbf5bc28",
      "members": [
        "94d3fa58-3367-4ea5-ae67-7b8f8b279c09"
      ]
    },
    {
      "cluster_id": "1010a45f-c4e6-41d3-ad44-9a27b9dc7893",
      "members": [
        "99e579d9-e26c-45db-abd6-543e14d5f19c"
      ]
    },
    {
      "cluster_id": "120d61e9-d442-4218-b8d0-9559d9880c3a",
      "members": [
        "f60a71cd-e4bc-4358-a0a7-f041b6f6a64a"
      ]
    },
    {
      "cluster_id": "f3b06230-c202-438a-8858-b8c55fa68828",
      "members": [
        "227cdcce-5687-4bf1-9f5a-a8836adedac1"
      ]
    },
    {
      "cluster_id": "232c9ea4-0513-4c68-a25b-8b7d952325d2",
      "members": [
        "293b21e7-38f5-46fc-811e-c5e6536b3f8f"
      ]
    },
    {
      "cluster_id": "511c0db2-0769-45d5-a814-00f974a659aa",
      "members": [
        "4c6ed350-eaac-442a-bcec-bc0413c9cf58"
      ]
    },
    {
      "cluster_id": "9f4059ba-333f-4054-ba5f-f1cebaed747e",
      "members": [
        "23a4a319-3e03-446f-88cb-31b0f2c7fd44"
      ]
    },
    {
      "cluster_id": "866c589b-e7dc-4cab-81ad-6d235278edf1",
      "members": [
        "da292357-2462-42bc-b4ec-4e895f68f578"
      ]
    },
    {
      "cluster_id": "8a12011e-a6e7-4e73-a321-a39426ec3d34",
      "members": [
        "625f25c3-8b12-45ac-8ce9-969d6a18a61f"
      ]
    },
    {
      "cluster_id": "f2096782-318f-42d5-a553-560f508e5016",
      "members": [
        "3df1f8a8-552b-4efc-b21e-abc022e1ff34"
      ]
    },
    {
      "cluster_id": "d60742af-37a3-43e0-afb8-5df777dac64e",
      "members": [
        "21c3523d-ca4e-4d30-ac7c-af819b31b098"
      ]
    },
    {
      "cluster_id": "4c6dd811-1cc8-4f37-9fa7-2bc4bf91d082",
      "members": [
        "8d1914c7-c298-4bd9-aed5-632813d94822"
      ]
    },
    {
      "cluster_id": "f731bc0b-cabf-4314-a5f8-e94d31589cea",
      "members": [
        "7244ae56-e1c5-46e2-a543-7317f009b913"
      ]
    },
    {
      "cluster_id": "721fca95-63af-4a1d-bae5-70b55fce9a8b",
      "members": [
        "2e54a056-be8a-4ab8-89b7-92e1542d6553"
      ]
    },
    {
      "cluster_id": "f9eb0f13-3691-4b5d-b326-0456c31b4402",
      "members": [
        "63a0626d-0199-42df-b653-83dac89f44d6"
      ]
    },
    {
      "cluster_id": "d96c8f5c-4bb9-48ae-8d6d-0625e7b9a576",
      "members": [
        "6204e89f-a742-484f-b4b1-907aa765d851"
      ]
    },
    {
      "cluster_id": "4350947c-093e-43d1-91ad-c33f75e13a1e",
      "members": [
        "62d01d04-f080-49a5-86bc-cb74d32f6149"
      ]
    },
    {
      "cluster_id": "37f5cf93-69fa-41bf-960a-1fd7783d4299",
      "members": [
        "77c96df2-9930-42f5-8e51-5087e65e1464"
      ]
    },
    {
      "cluster_id": "541a6555-c116-4473-b1ae-ac7c48578f3d",
      "members": [
        "f889abfc-b20c-4691-9f7a-372f491a3000"
      ]
    },
    {
      "cluster_id": "a8ca6792-95c5-4826-87fa-d4a8f7047a5f",
      "members": [
        "7ae45b9b-6980-44f2-b068-b1496f49e43e",
        "28c27d9d-9d42-4e63-b688-e63184d2da1b"
      ]
    },
    {
      "cluster_id": "f51c562e-c0c3-4e9a-aec5-0739526b9b5b",
      "members": [
        "9d79b691-d9c4-46d5-a6b8-b1445cb6e6a4"
      ]
    },
    {
      "cluster_id": "b4fd3f81-2344-4edd-8ae4-fd7b59d99888",
      "members": [
        "ed2e397a-705f-4c94-995f-d9156f17a977"
      ]
    },
    {
      "cluster_id": "94a84124-c591-4219-8ef7-52760d608300",
      "members": [
        "9e8abd16-691d-4049-9eb0-3ad5e4589074"
      ]
    },
    {
      "cluster_id": "1ed92023-b891-43ab-ab0c-b464c243f2b0",
      "members": [
        "96074d83-4149-4a8e-95a9-4a7f0069c03f"
      ]
    },
    {
      "cluster_id": "15c2186e-db17-4b08-bbd9-d03072fa580d",
      "members": [
        "3d847759-a5a6-4b77-985b-5a351e634bfe"
      ]
    },
    {
      "cluster_id": "de7b2349-3e46-436f-9b75-c57089eeaa3c",
      "members": [
        "3bccd83c-9fd3-4504-a728-2ae929f05ac6"
      ]
    },
    {
      "cluster_id": "9edb82af-1afe-4fbd-8da5-3bc280a95c94",
      "members": [
        "54404614-30dd-4714-b748-07251cf5d96e"
      ]
    },
    {
      "cluster_id": "02aff357-d128-4a8d-9828-60ab97d0e632",
      "members": [
        "0add574a-18c3-4e8e-9431-ce4b01d7713e"
      ]
    },
    {
      "cluster_id": "8255a43f-82ec-4f1a-8f29-78e7a247a2d1",
      "members": [
        "dd7a9c97-1eee-4e6d-b54c-5fa09301b2ea"
      ]
    },
    {
      "cluster_id": "b3c35953-f954-44b3-89de-73c75db49fd9",
      "members": [
        "35773a2d-d14c-42aa-88b3-687a2b8859a5"
      ]
    },
    {
      "cluster_id": "449f7a4c-3966-4db6-9cf4-d39a2f15feae",
      "members": [
        "9f92d96d-4308-4ddb-b7e0-250051b35d4c"
      ]
    },
    {
      "cluster_id": "cd2c9191-f97a-49fd-9d7d-f0744cdaaf72",
      "members": [
        "08821dc0-3504-4b0f-9450-9c7b8b3145f3"
      ]
    },
    {
      "cluster_id": "577be512-045b-4f32-8688-400d686a100d",
      "members": [
        "4c0d834d-a849-4164-a31d-2c12469d05ee"
      ]
    },
    {
      "cluster_id": "5317331a-d0a9-4595-acad-210a92b278d8",
      "members": [
        "a2e0ca91-66bd-4120-ac00-e5d094187c97"
      ]
    },
    {
      "cluster_id": "1db866e4-0f7e-4d67-93e0-8d1068f0369d",
      "members": [
        "63c77996-d578-49ff-a7d5-3087f29eb083"
      ]
    },
    {
      "cluster_id": "63ad18c0-00c0-4509-b669-2aff507b5502",
      "members": [
        "273f2939-bb92-4cd5-b33b-c8dd1f33921e"
      ]
    },
    {
      "cluster_id": "ef636ecf-8b34-4007-8f71-b4d5ed7d3c33",
      "members": [
        "3a816ab3-76e8-4b09-8f80-c22151e9d200"
      ]
    },
    {
      "cluster_id": "ef78627f-ce46-445c-8434-674b16f6966e",
      "members": [
        "a0c391cd-ae5f-479a-9f98-6b01c1162dea"
      ]
    },
    {
      "cluster_id": "e8bed2a1-875c-4017-abd5-83f756e2ceb2",
      "members": [
        "fc8788d7-4beb-4e83-be38-71bc70131b4d"
      ]
    },
    {
      "cluster_id": "e000263a-3f42-454e-8e66-ba1e28066da4",
      "members": [
        "bee9ca73-5c90-423a-bda6-cc40b0d089e8"
      ]
    },
    {
      "cluster_id": "f3b06c88-86f6-4833-89c1-f778a2910669",
      "members": [
        "ed763e3a-042e-4236-ae32-19b545a0942b"
      ]
    },
    {
      "cluster_id": "97507c06-9158-4dec-af84-2ca3daa906d2",
      "members": [
        "7f5c4a4d-fa3e-409c-9584-f23883a8eea0"
      ]
    },
    {
      "cluster_id": "de60bb28-4ca7-441f-814b-f2ecfe29fb54",
      "members": [
        "9c791913-e09c-4e9e-a09a-095800602b5d"
      ]
    },
    {
      "cluster_id": "db13aa73-f539-42d8-89d9-1af57cfff5a3",
      "members": [
        "b91fddc8-4368-4d68-b665-5ef12e76519d"
      ]
    },
    {
      "cluster_id": "dce54f5f-136c-474f-95c7-ae5b1e1ff60b",
      "members": [
        "a286990c-f924-4861-b1f5-11adc6525f83"
      ]
    },
    {
      "cluster_id": "28feb358-2926-4cba-8425-f09fe5ebab7a",
      "members": [
        "f3816555-9899-45e1-ab43-5f94a8bf10aa"
      ]
    },
    {
      "cluster_id": "dc3308e5-2250-431f-bef6-733e2b943275",
      "members": [
        "a9022ebd-de7d-4111-b77d-91d91f5a0c87"
      ]
    },
    {
      "cluster_id": "0998688e-32a8-4d44-8338-04f2bfaf29d8",
      "members": [
        "0fdf030e-76b2-404f-b9fa-d5ce5442f261"
      ]
    },
    {
      "cluster_id": "9df4486f-c8aa-4f08-a8cd-4ae02c748318",
      "members": [
        "29b0d668-c065-4cd9-9b19-a5126bdd0f5b"
      ]
    },
    {
      "cluster_id": "a841656a-f68d-41d2-ac94-3537d3133ce8",
      "members": [
        "e5b71e08-b9c6-4d7e-9499-bf91654d8f96"
      ]
    },
    {
      "cluster_id": "298b76c6-3ed3-4a84-8894-fa50a9f4234f",
      "members": [
        "c71e8be2-7486-453c-be1d-b9c75dd815fb"
      ]
    },
    {
      "cluster_id": "74664a64-2600-438a-b569-a9d45ae85e93",
      "members": [
        "157a3f9d-f4b5-4baa-ac8d-e0cbecbe4c65"
      ]
    },
    {
      "cluster_id": "8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4",
      "members": [
        "220c9490-1e41-4647-b70e-5e11d5b7f9ed"
      ]
    },
    {
      "cluster_id": "12ff0964-4c5c-4f91-8269-1e4ab61e9602",
      "members": [
        "75374dcc-d1c6-4bd9-a6b3-7eb2980f0d5b"
      ]
    },
    {
      "cluster_id": "99dd456b-c805-4ebb-a82a-80fe2e06dff9",
      "members": [
        "cfcc8341-a799-42c7-b833-bdbe0d148be8"
      ]
    },
    {
      "cluster_id": "01680509-ab3c-4c56-a9a9-62fe3aeaacf8",
      "members": [
        "217552fc-2ca8-430c-8b02-d361a5851175"
      ]
    },
    {
      "cluster_id": "7b4db769-a456-496c-a3b6-6f242fdb7665",
      "members": [
        "6b6da3a4-46b0-42e2-b535-3942dd778814"
      ]
    },
    {
      "cluster_id": "d71c3e1e-b92b-4fd2-a1fd-9b3951fec4df",
      "members": [
        "4f66e2cb-59d1-4ec6-8d5e-9bbab812bd5d"
      ]
    },
    {
      "cluster_id": "dad2ba1b-78a6-4e69-91a7-e473e3d79e42",
      "members": [
        "73cc86da-816a-4162-a2ea-4d17641ac220"
      ]
    },
    {
      "cluster_id": "0dedc684-9634-49f1-9f8a-88450509e30c",
      "members": [
        "b85ed737-53e4-4c4f-89dc-30ea24f8522e"
      ]
    },
    {
      "cluster_id": "71185519-3f2f-4171-84a1-11f08a933f13",
      "members": [
        "c1ae1e08-3b9c-4e6d-ab94-e36c93e1210b"
      ]
    },
    {
      "cluster_id": "d3037252-9ff2-4032-ae65-41b104560fbd",
      "members": [
        "90b935d2-1136-49d0-90a5-0d6f0cd8fd73"
      ]
    },
    {
      "cluster_id": "b932581a-a432-45a9-94c6-236d0339e45d",
      "members": [
        "f08e815a-d586-4bfb-94c0-ebd0ab4bee9a"
      ]
    },
    {
      "cluster_id": "3945d107-ebd6-4f7f-98d8-84183dc2837f",
      "members": [
        "e2cf4b2f-b2df-4b22-a695-ce32cc4b7f8a"
      ]
    },
    {
      "cluster_id": "eb2ba8af-f927-478b-bc26-2105bdb87c5f",
      "members": [
        "0c0b743f-c802-46d4-b763-5b0569776cb8"
      ]
    },
    {
      "cluster_id": "b9550306-91d4-4e1e-9632-4c73f1957d92",
      "members": [
        "c4cb067e-bbe4-4071-8c9b-8006ed778d69",
        "5e2f3926-67a0-4510-8b6b-ca6546e4ca03"
      ]
    },
    {
      "cluster_id": "a766b305-cd34-47d7-bed5-5c04c33c99ba",
      "members": [
        "2edf27e1-e806-4061-9ed7-968dd0e6ac84"
      ]
    },
    {
      "cluster_id": "e840acd4-9152-4039-820b-b347beaec131",
      "members": [
        "787fd6fd-2ddf-4f9f-84b6-9f779f67c4b3"
      ]
    },
    {
      "cluster_id": "85123ed6-1d34-44b3-9644-642bc01ff160",
      "members": [
        "56bb2e7c-8484-4855-bb44-49f93543bd19"
      ]
    },
    {
      "cluster_id": "24a47a14-4ee4-4529-96e9-02c94e429ea6",
      "members": [
        "9aa1ce99-1ccd-4c48-90f8-4f90b370df74"
      ]
    },
    {
      "cluster_id": "939cc578-da0d-4d69-94b9-0a186537275d",
      "members": [
        "6f0df810-320c-45cb-9e6c-3b3dbbc667e6"
      ]
    },
    {
      "cluster_id": "c4536202-39a9-481f-a4be-147b7620686b",
      "members": [
        "e721ed2f-cf0f-44d3-a6c1-1a24735d877a"
      ]
    },
    {
      "cluster_id": "c8cf7c39-4d6a-4fec-8451-b46f12ccd07f",
      "members": [
        "0308a072-47c5-4260-b16d-5658fe09cd8d"
      ]
    },
    {
      "cluster_id": "d946674a-0b30-4a82-a7a2-12fe77cdc3f5",
      "members": [
        "df53c2c0-c395-468e-bb2e-26218921a087"
      ]
    },
    {
      "cluster_id": "1c24dadf-70dd-4f00-84a1-ba00a5d442c5",
      "members": [
        "b858d41f-05e4-40bb-a45c-3887f0b5fd1d",
        "c0e76ce0-91b7-4426-8580-548fe286b428"
      ]
    },
    {
      "cluster_id": "f982ead8-4101-46e5-9a29-b95c416ed470",
      "members": [
        "77a079b2-ee48-41ba-8507-454e8d25592f"
      ]
    },
    {
      "cluster_id": "ba035925-8a5f-42d0-aec3-c91702a47b8d",
      "members": [
        "005bd7ce-1396-456e-8eee-0bd7d6c8574e"
      ]
    },
    {
      "cluster_id": "c8956774-b873-4e48-aca4-1d4ce1428a6f",
      "members": [
        "61082364-4f43-42f4-b547-011b0b54111a"
      ]
    },
    {
      "cluster_id": "97e04a01-6626-4196-a12d-eac1df348581",
      "members": [
        "2e147448-c306-49ad-9fef-d0dada94258d"
      ]
    },
    {
      "cluster_id": "69483fde-1234-4c7a-8580-5490aec071f7",
      "members": [
        "bdf0f963-60ea-4633-a086-26f0ea0b2d42"
      ]
    },
    {
      "cluster_id": "a7a78172-b61a-41cd-a089-5fdf5b5e9fdc",
      "members": [
        "db788cf1-32db-4d5c-81b0-a5c2676bf0d6",
        "72c2d36a-c9a2-4fac-8a4a-3725b096e974"
      ]
    },
    {
      "cluster_id": "a99b1332-e477-4168-b8e5-832daa0d6068",
      "members": [
        "61e80615-2fec-4038-aaa3-0bcf5a2848af"
      ]
    },
    {
      "cluster_id": "40621ae5-171b-4ff7-a8cc-0957a4cc93da",
      "members": [
        "d6bfa4fd-4472-413d-af99-68d64e7ca707"
      ]
    },
    {
      "cluster_id": "92df53c2-d00a-4565-ac4a-1279aad1b2ee",
      "members": [
        "eac18877-33c0-46a2-bce9-20fffdca5b22"
      ]
    },
    {
      "cluster_id": "7885c5ae-734b-4d64-8d84-fc50b9a87ad7",
      "members": [
        "560790a8-689e-4fe2-bd9f-c6d867654701"
      ]
    },
    {
      "cluster_id": "327ec0a5-4419-4d23-90f1-e220df70fed7",
      "members": [
        "1917a5b3-9a61-409b-9ef2-a3ae28ce7476"
      ]
    },
    {
      "cluster_id": "23bbf046-846b-4885-b881-e84d2ca9060e",
      "members": [
        "1114b133-176b-4fcb-bfa2-39ab1a7f2233"
      ]
    },
    {
      "cluster_id": "612e1b04-721a-48bd-b18f-300c7c5af276",
      "members": [
        "477a61c2-bcae-48d9-9047-5af98157bde9"
      ]
    },
    {
      "cluster_id": "b27abfde-f9d9-4f52-9ce7-8c541388281c",
      "members": [
        "b61fe9a5-7456-42c5-926b-90ebbcdd79f8"
      ]
    },
    {
      "cluster_id": "7576470b-cafe-4c17-9541-256e9ec07097",
      "members": [
        "1d52a278-2548-4be5-b8e9-85b1e1f457b7"
      ]
    },
    {
      "cluster_id": "1a853cc3-9e33-4539-b70a-cc51380d7526",
      "members": [
        "ca39f7af-44af-4a9b-aae6-1388ead9b5ee"
      ]
    },
    {
      "cluster_id": "70a36c06-fbb9-4f71-bf77-74f433672b24",
      "members": [
        "ea1594a0-615f-4ffc-8dfc-b1def5b9dfc3"
      ]
    },
    {
      "cluster_id": "12dfa7c9-8817-4f21-ad00-1e4244142b34",
      "members": [
        "7113e5a5-a4aa-431e-8b49-b4e85e5b3230"
      ]
    },
    {
      "cluster_id": "3af9eb7e-1c8f-4ca9-987f-f38db6d11751",
      "members": [
        "ff58331a-224c-4522-932a-a86dd264f8d3"
      ]
    },
    {
      "cluster_id": "ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8",
      "members": [
        "ca89c722-a39a-4f71-97bd-af7e85c2f6d6"
      ]
    },
    {
      "cluster_id": "902f069d-3703-489a-9dfa-fb26ee837027",
      "members": [
        "93dc2389-7725-4bfd-aa6d-0f5e7a002603"
      ]
    },
    {
      "cluster_id": "a89a4b7b-c64e-4a3c-81e8-86dec8a3dad0",
      "members": [
        "25cb42f3-b7ab-4687-8682-b0df8e276a21"
      ]
    },
    {
      "cluster_id": "dbcdf7e4-c865-4f31-a79f-0cd2eef3258f",
      "members": [
        "9aab8a4a-4cbc-46bb-93ea-531d1ace5ba9"
      ]
    },
    {
      "cluster_id": "1b8ba3f8-2b51-4433-9cf8-2a5412413277",
      "members": [
        "10a59df0-25fd-4c52-80ff-367b12e6a6cd"
      ]
    },
    {
      "cluster_id": "1dae585e-f051-41dc-8fc8-c2d3e3b3b884",
      "members": [
        "875bdd9c-f618-4ae3-859a-2f2941fa6415"
      ]
    },
    {
      "cluster_id": "83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6",
      "members": [
        "c9c3253c-b9a6-4fd9-85f2-e27a00c0b6aa"
      ]
    },
    {
      "cluster_id": "d3913637-42d6-426c-8654-a13850b8306c",
      "members": [
        "e7259cd4-641d-4c35-8240-9e5b6eccdf14"
      ]
    },
    {
      "cluster_id": "cfad4c19-24e9-4d54-8d59-d0b08718729b",
      "members": [
        "d11b7ac1-5f7b-4232-bbcb-3378e317d050"
      ]
    },
    {
      "cluster_id": "d2dff4dc-99e9-4957-9a57-be828ae1a5cf",
      "members": [
        "86969868-4746-4e4b-b91e-da0c9d8dda79"
      ]
    },
    {
      "cluster_id": "679ed917-ad46-4856-a427-b83dcc51a53c",
      "members": [
        "1d260ccf-c916-4d6e-8c87-5b7e63e401c3"
      ]
    },
    {
      "cluster_id": "a52869e4-c88e-49c1-a8d6-0ba25d6c7cfc",
      "members": [
        "182bd972-a7e0-4c8b-b3f5-33eef3f0edd8"
      ]
    },
    {
      "cluster_id": "8c18859c-7432-4cc4-af8f-8a5eb220876e",
      "members": [
        "1946c57f-c5ac-4487-b355-5338816d61be"
      ]
    },
    {
      "cluster_id": "9f34aa0e-2eb3-43e3-b4dd-54a36752af72",
      "members": [
        "987fae78-c69c-4ae1-87a2-1783d4df0a8b"
      ]
    },
    {
      "cluster_id": "d43a588c-20a7-4ed9-8abb-37e05290fde6",
      "members": [
        "30da1f6b-f79a-4f5d-9704-e8804aed132e"
      ]
    },
    {
      "cluster_id": "7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607",
      "members": [
        "79fb148b-5b6b-4fb0-becd-9d53f2ad3be5"
      ]
    },
    {
      "cluster_id": "505519a5-a059-4c9c-8b16-ce6dffe7e678",
      "members": [
        "a2a3fc3e-ab7d-4a1b-8404-f01a97d0af23"
      ]
    },
    {
      "cluster_id": "86478e14-8f65-4b25-93ee-a6036b9de886",
      "members": [
        "35088c9d-c4b5-45a7-8b74-288b070bb212"
      ]
    },
    {
      "cluster_id": "77763430-7d23-4e23-9288-5fdabfddb4bf",
      "members": [
        "ebe8bc4e-1757-407a-8cd2-ee631c8c11e7"
      ]
    },
    {
      "cluster_id": "b6dd34fe-58a4-4775-be96-ca839f926747",
      "members": [
        "7478c1f9-2d96-4035-9cc6-828f2516be85"
      ]
    },
    {
      "cluster_id": "bd7226f9-5942-4c7e-a2e1-156f8c1e7b81",
      "members": [
        "c4f5cb28-559e-4c76-99b2-e6e0f4621d6e"
      ]
    },
    {
      "cluster_id": "7bf4f678-55d5-4f6a-922f-0b5de572f033",
      "members": [
        "56bf3714-590c-4c73-b341-71f048a2366a"
      ]
    },
    {
      "cluster_id": "0ed53993-d675-4e0a-91d9-fca7f39d86fc",
      "members": [
        "19497ff6-291a-4c5c-abc3-61abaaf0308c"
      ]
    },
    {
      "cluster_id": "20e0f6a7-71df-44b4-b99e-3e278ca655e8",
      "members": [
        "d156d71a-fe2d-4d63-9a18-423d0ecaf3cd"
      ]
    },
    {
      "cluster_id": "9d21be2e-9f01-48c9-b454-3a41788e2865",
      "members": [
        "8b198f66-df0e-45d3-baa7-17c01dc6e575"
      ]
    },
    {
      "cluster_id": "0fa9f6d7-64f6-4933-aae8-3cfd512cab5c",
      "members": [
        "766a17e5-e340-42cc-ad95-c5f9edc91933"
      ]
    },
    {
      "cluster_id": "2ac87cef-db31-40dd-8c5e-d88d478fd344",
      "members": [
        "3c0edcf9-b28b-4b96-ba4f-1b328d91a133"
      ]
    },
    {
      "cluster_id": "c214c388-1bcb-48de-9ccf-d250135ec39d",
      "members": [
        "a1a34e57-69ee-4070-841d-5b90d76d211b"
      ]
    },
    {
      "cluster_id": "b654c64c-3acf-45f6-a6ea-c4584b8c70fe",
      "members": [
        "f74f111b-8ae8-43bd-8aae-72707a95b433"
      ]
    },
    {
      "cluster_id": "4f0130b7-d8c3-44c1-892f-fe74aef4cecc",
      "members": [
        "37413551-3a0d-46af-a81d-f37c6fd47d58"
      ]
    },
    {
      "cluster_id": "442dded8-bef6-49b2-b7d4-70454c6e8e79",
      "members": [
        "a667f48f-8745-4f2a-8286-426e6fad417e"
      ]
    },
    {
      "cluster_id": "d29a2d68-5d53-4ad3-9792-37db5375f45d",
      "members": [
        "8c88f73c-85de-4477-af26-a24e852c54f0"
      ]
    },
    {
      "cluster_id": "9c03f16d-4308-41ce-a6c3-c0b6eaf8e340",
      "members": [
        "c8d7bec3-38b5-43be-923a-1a6e55e6017f"
      ]
    },
    {
      "cluster_id": "4eb17e7e-a0b8-41fd-aeb6-65f4c703f9b7",
      "members": [
        "a30a9052-88ad-4420-8689-703abc36bb2e"
      ]
    },
    {
      "cluster_id": "9e71565f-1fc8-4e9e-a3ed-15e11a8ef776",
      "members": [
        "9441a8c9-7e9e-4baf-be1f-d370158a43ff"
      ]
    },
    {
      "cluster_id": "ac74ed42-e193-4a73-9fb7-633a1a28d674",
      "members": [
        "5c2f1cdd-0a0b-40b1-bc68-8742aa3a3d48"
      ]
    },
    {
      "cluster_id": "33f6801a-acda-4c2e-9708-cf1802dbdbb9",
      "members": [
        "7d40c681-2ef3-4d2e-95ee-9827d1b93589"
      ]
    },
    {
      "cluster_id": "783f85bb-dceb-450a-9a34-4a650e18ed9f",
      "members": [
        "06f4a3e5-b0e3-4d9e-9fb1-38b19ec5cff6"
      ]
    },
    {
      "cluster_id": "108c6941-b645-4904-86a8-cfa0fa34274e",
      "members": [
        "624d6091-1fe3-4572-bdbf-b81bac9a871b"
      ]
    },
    {
      "cluster_id": "14a92521-0601-421b-b904-3fc9a965cbb6",
      "members": [
        "3791a65c-265a-42c0-ada5-4d83f9d23a6c"
      ]
    },
    {
      "cluster_id": "416e4c1e-869b-468f-91eb-bba4fac5108a",
      "members": [
        "8f954d51-f4fc-4309-ba61-b0094d0fd645"
      ]
    },
    {
      "cluster_id": "1071979a-b25a-4432-8eb1-62e54bcd27e1",
      "members": [
        "c75efdf2-f439-4cc5-a3a4-cfc244981056"
      ]
    },
    {
      "cluster_id": "9bf70381-221f-4cfd-8e17-16f9ebb35e36",
      "members": [
        "00c985ec-b5b5-4575-8daa-509ab455dd63"
      ]
    },
    {
      "cluster_id": "234be4d1-d0d0-4b65-aa97-a8cd91a0a32e",
      "members": [
        "a8d63af7-5112-49c2-a95a-d10fa6cd6f10"
      ]
    },
    {
      "cluster_id": "cebef5fc-6d79-4e08-878b-8c75696aa6d2",
      "members": [
        "b5fad97a-c940-4eb5-9348-f3275f2ffab4"
      ]
    },
    {
      "cluster_id": "df6be9b1-2675-4ecd-8158-a77b9f4c36c7",
      "members": [
        "bb6e3d80-a5b9-4d0e-941d-032c3f720829"
      ]
    },
    {
      "cluster_id": "300e8b62-ec91-41e2-9809-166d3f0a78b2",
      "members": [
        "eb56e2ca-fcac-4e1c-b941-c92ae6761bbb"
      ]
    },
    {
      "cluster_id": "b12e5d28-73fe-498d-a612-a3df5aa876b3",
      "members": [
        "d30c6914-f4a7-41a8-81c8-8e7b455498da"
      ]
    },
    {
      "cluster_id": "9b7211c2-d426-4818-9305-d12ff5c6e2a5",
      "members": [
        "b8011f98-a6a4-4042-b9f0-473b601a8aea"
      ]
    },
    {
      "cluster_id": "d4d4c9f9-96b0-478b-85a5-92a5fa51e55c",
      "members": [
        "eb38c7e2-9e1f-4e77-a649-5768d011d58e"
      ]
    },
    {
      "cluster_id": "e0a99d28-f3a4-477a-b874-8d839c4523f9",
      "members": [
        "4abbf66c-c32f-4597-83b9-82aae5c19f37"
      ]
    },
    {
      "cluster_id": "d6705dc8-8def-4060-882a-9c13b62a23ad",
      "members": [
        "410d7f41-8cb7-49b7-a408-7780cefbec44"
      ]
    },
    {
      "cluster_id": "d92fe55e-695c-457a-af52-c6044f0ca9ec",
      "members": [
        "249d58f4-05a8-4d8c-b470-983e698ab693"
      ]
    },
    {
      "cluster_id": "127c457b-8cad-4a81-8d25-66dd51786fe0",
      "members": [
        "f71a7b74-67f3-4a39-8e9b-8317ed8580ee"
      ]
    },
    {
      "cluster_id": "049db6be-2ccc-4afd-97c6-e95cb1b50286",
      "members": [
        "de9a742a-d87b-46a6-997b-e317436bae74"
      ]
    },
    {
      "cluster_id": "c17fd8aa-8336-4796-9c7d-a192509f6809",
      "members": [
        "bf356d95-2792-494a-9c53-723a7d138cc9"
      ]
    },
    {
      "cluster_id": "0f106199-65cd-478b-af43-69825b16fa47",
      "members": [
        "97dc3544-0bc6-439b-837c-f643d25780c3"
      ]
    },
    {
      "cluster_id": "5c68cba2-8519-4f6e-b70e-fbda62c5445c",
      "members": [
        "7222b469-b151-49bc-acd6-0be874ba7920"
      ]
    },
    {
      "cluster_id": "91e6a8b3-0e47-4ed1-b99e-a946e23e0c33",
      "members": [
        "98f6cf72-868f-440b-85db-ec6f14c39793"
      ]
    },
    {
      "cluster_id": "17dbd7df-f3d1-4902-a103-f97b03017681",
      "members": [
        "fc0e950c-2062-4497-8b15-3820ad4d8861"
      ]
    },
    {
      "cluster_id": "b763139e-3c42-4a2e-8afc-f2941722221f",
      "members": [
        "e18baf6a-6871-464b-9cb4-a5a5b94071a8"
      ]
    },
    {
      "cluster_id": "1190ac87-5191-4e29-877a-253af15bb185",
      "members": [
        "f66ef738-8db0-4a21-a79a-44e8d3fdbdf7"
      ]
    },
    {
      "cluster_id": "b2dac904-00a6-4c9f-a283-eccc78d22ae0",
      "members": [
        "cce4f4c5-55ff-4594-ad63-db2ba7336564"
      ]
    },
    {
      "cluster_id": "63fb8530-c54e-452a-b71d-729fca3c7e67",
      "members": [
        "0d22b873-3bcd-46f0-ac8d-be55d657c3d5"
      ]
    },
    {
      "cluster_id": "b45686ea-2849-48a8-b658-78abebbff1dd",
      "members": [
        "039ac62f-753d-4687-85d4-fe380baf1e9b",
        "c8b6c191-aa5f-4a01-a9b3-7f5ab792cb55"
      ]
    },
    {
      "cluster_id": "53bc38bf-651d-46ea-8aaf-f63f52195a45",
      "members": [
        "b3eec49f-990e-4af0-99ce-b5b1674ce1ce"
      ]
    },
    {
      "cluster_id": "e521c1db-8ae4-48b6-83c6-efbd02701f4c",
      "members": [
        "9e079658-a585-464b-a262-b8382a78b4bb"
      ]
    },
    {
      "cluster_id": "0450cb4c-8816-4bbd-85b6-ac94ecde9af4",
      "members": [
        "fdf896da-e199-4be6-b7f6-8c2bd776562e"
      ]
    },
    {
      "cluster_id": "eb6a12b4-268e-4e39-8d84-ba73d40a7ffd",
      "members": [
        "3b8a9b74-84cf-4774-919f-c0e17240e45e"
      ]
    },
    {
      "cluster_id": "06aec0e1-946f-46e8-835f-efac40b3f6dd",
      "members": [
        "334a9b32-ce27-48e6-b0bc-b8ea89c75156"
      ]
    },
    {
      "cluster_id": "03b37d7e-0ed4-4014-ac24-a898719a8f87",
      "members": [
        "11832956-c82c-44b0-91c4-4840f8ca62a7"
      ]
    },
    {
      "cluster_id": "0bdfd962-fc80-4c29-8a9f-545619ab3653",
      "members": [
        "c0109198-ee1a-4099-955c-d818edf37cee"
      ]
    },
    {
      "cluster_id": "997de204-d7ea-4e15-b208-ebc2bd4ddd62",
      "members": [
        "278a0146-212e-405b-8949-d4c04cb5f338"
      ]
    },
    {
      "cluster_id": "1469928a-aef7-459b-af14-6d6ac0ca72d3",
      "members": [
        "945ed028-9468-4bb8-a245-d462906aafb8"
      ]
    },
    {
      "cluster_id": "9c68ef9f-53c9-413e-b008-51e352564820",
      "members": [
        "dbe21f83-60a8-4568-bb55-34d127142232"
      ]
    },
    {
      "cluster_id": "5d4bd659-348a-4fe3-bacf-eb25b0043f94",
      "members": [
        "7ae47a7d-066d-40fe-a8a1-8bc552a48008"
      ]
    },
    {
      "cluster_id": "554575d4-0201-41f5-aa4b-d48a76e37311",
      "members": [
        "497d5038-273a-402d-9e56-2b2e9fe72bc9"
      ]
    },
    {
      "cluster_id": "c9b6b0e3-811d-4e56-9eba-3408eb1dc06f",
      "members": [
        "14204ab1-80b5-4131-96d6-b20416510a3f"
      ]
    },
    {
      "cluster_id": "d232b59a-12d7-48e0-9945-60749a40e538",
      "members": [
        "e5c5cfed-e553-4c1b-ac88-2713c8b637c2"
      ]
    },
    {
      "cluster_id": "77e72686-2baf-45ab-a679-b8f62cdcf982",
      "members": [
        "a900d61c-14d8-49c7-9d31-8c052482804b"
      ]
    },
    {
      "cluster_id": "61b758fd-ce2c-4502-b494-9618880e66e4",
      "members": [
        "62594f26-90d1-4fb4-94d2-76d96a5a4670"
      ]
    },
    {
      "cluster_id": "b60fefc6-3713-474d-b9b3-03ebad7a4f1c",
      "members": [
        "5613b471-f5b7-4770-8150-226427574bf4"
      ]
    },
    {
      "cluster_id": "b5432b8d-5ac9-4f60-8977-fdbcdae395a3",
      "members": [
        "e378c0e4-784a-400f-83ab-44acd7efff8f"
      ]
    },
    {
      "cluster_id": "700a7ce5-024e-45ce-bc66-61c8dab09717",
      "members": [
        "5d287179-1913-49a6-a2dc-52aa26f47a04"
      ]
    },
    {
      "cluster_id": "fa79376c-183c-4b27-9b35-5eee39b30f87",
      "members": [
        "b16188b6-0bfd-4e86-aec8-758e1788ac7d"
      ]
    },
    {
      "cluster_id": "73e1870d-5a72-427f-b64a-f2b7b2817260",
      "members": [
        "636986f4-7d28-4292-b06e-7144ac4b1cda"
      ]
    },
    {
      "cluster_id": "d4352376-c595-4d9d-928a-8fabbed1e18b",
      "members": [
        "2610f24b-2b31-4670-b760-f239b5e6fa97"
      ]
    },
    {
      "cluster_id": "10317341-49c9-447e-bafb-6ef554948da9",
      "members": [
        "604bab64-fcae-4b2a-9e35-f1f01336aa83"
      ]
    },
    {
      "cluster_id": "40fee78e-be14-405f-8e91-d6685b9587a5",
      "members": [
        "bd5fc61e-f04d-474c-8059-3dab5253b183"
      ]
    },
    {
      "cluster_id": "3073b261-2ceb-46c8-bad6-3808fb657e33",
      "members": [
        "42f09db3-551d-4166-8b95-eac38932ccf7"
      ]
    },
    {
      "cluster_id": "48cca002-8003-45bd-92b2-3e2945a33b48",
      "members": [
        "34faaaca-1b92-447b-ba8f-2a9e760060fb"
      ]
    },
    {
      "cluster_id": "4801b48a-d91c-4dc3-9797-76929432b0ef",
      "members": [
        "ff17c431-3371-4f1b-90f4-92249ef3c30f"
      ]
    },
    {
      "cluster_id": "ff43bfb6-1ab6-422e-8045-756b71e70dd1",
      "members": [
        "1f50ab6e-06e6-4323-8f2d-970dd2aaa5ff"
      ]
    },
    {
      "cluster_id": "b865573b-6b72-46cd-b3c0-a1458e7df010",
      "members": [
        "2a3d2c14-0c4e-4df4-83b9-1697054ce7c6"
      ]
    },
    {
      "cluster_id": "01c08614-0081-4fbf-86e8-a41b845bc4f5",
      "members": [
        "c2726e3b-de4f-4025-bcf7-aa4a83298e58"
      ]
    },
    {
      "cluster_id": "626035be-3dc2-4608-b822-013ba6260905",
      "members": [
        "b49fd94f-a2e9-4402-a8fb-04c957603726"
      ]
    },
    {
      "cluster_id": "0cdd2771-1f79-419e-940c-c74f863377bb",
      "members": [
        "35f1768b-5b75-4726-af15-53b8453bf960"
      ]
    },
    {
      "cluster_id": "f8aea904-a823-4059-9707-77075c116ecb",
      "members": [
        "a341c062-e189-4526-9e17-0a4302d82684"
      ]
    },
    {
      "cluster_id": "ce28dc91-d0be-44b8-b551-17c831f9e07e",
      "members": [
        "400dda24-5642-4eaa-b0cb-21895e10b95a"
      ]
    },
    {
      "cluster_id": "1713cb4d-ab0f-4257-a2cb-4aec01e411ef",
      "members": [
        "5cfe33f3-fea8-49f4-9ed4-eee6a3217253"
      ]
    },
    {
      "cluster_id": "f4e47d52-0a9c-4a42-9a14-47aece599116",
      "members": [
        "cc97e4d7-39ac-46ac-ab8e-e2e0f8480d08"
      ]
    },
    {
      "cluster_id": "97e28e03-c0a3-40ba-8418-88973425525a",
      "members": [
        "30992d07-6067-4261-8356-d56b2fd9b710"
      ]
    },
    {
      "cluster_id": "06c89f07-f873-4ab4-9068-3bbe6a0c9e11",
      "members": [
        "baa6ae57-ce52-4790-9177-e3e7b2392be4"
      ]
    },
    {
      "cluster_id": "44fbf7cb-79bd-4592-b8a7-2bf2362dc392",
      "members": [
        "5dfba5cb-799d-4b07-87b5-8e2980417a6b"
      ]
    },
    {
      "cluster_id": "0626769d-4a42-43f4-8356-e89543f6dcc3",
      "members": [
        "ea8e283b-182c-4143-be2f-de77f5d27cba"
      ]
    },
    {
      "cluster_id": "2fa38dbd-c491-4579-bb95-e37ac00e125d",
      "members": [
        "8c2d291f-df81-468d-85a3-0e1fc31ede57"
      ]
    },
    {
      "cluster_id": "bbe61a29-09c0-4f9e-98e6-1cf33324aca4",
      "members": [
        "5caaa189-9220-4884-8396-ddfdeb8e9a35"
      ]
    },
    {
      "cluster_id": "71de3f5e-7d6d-4a6a-b383-b96d1ee24b30",
      "members": [
        "164555ef-1d96-44b4-8f2c-a56ac2c400bd"
      ]
    },
    {
      "cluster_id": "7cc752d0-c62a-4657-a1e6-4213c5baa7cf",
      "members": [
        "1b9e3d5a-e548-4979-9072-bc0a417162a5"
      ]
    },
    {
      "cluster_id": "3dd1bcbf-32ed-443e-a942-a8e7446ea6d1",
      "members": [
        "a2ed6adc-50b0-4f09-9db8-fb2a75a24925"
      ]
    },
    {
      "cluster_id": "89b27333-1443-478a-ae8d-2e32423dac3d",
      "members": [
        "36c7062c-b507-4d27-bfab-ca6f4b494394"
      ]
    },
    {
      "cluster_id": "f9c980a9-33b9-4834-922a-947a13f5a035",
      "members": [
        "514684a4-216a-43b8-89b4-796e192c499c"
      ]
    },
    {
      "cluster_id": "9012b6f3-2c16-482a-b276-63925d342482",
      "members": [
        "05366e38-604d-43f6-b486-b13216dc32f1"
      ]
    },
    {
      "cluster_id": "cd55cb26-f122-4354-aeec-7ffaa02af90a",
      "members": [
        "cc9c1faf-f971-4aad-bee5-4f46968b9f0a"
      ]
    },
    {
      "cluster_id": "99fbb991-8bc1-4254-9fff-a2ac5c926685",
      "members": [
        "8aeeea15-aa9e-4a7a-ac13-8421e1c1f6c6"
      ]
    },
    {
      "cluster_id": "c46be245-9f63-495f-be19-e522e39c13f9",
      "members": [
        "94eef71a-da34-4277-a1f1-3afbc1c2a534"
      ]
    },
    {
      "cluster_id": "c19d9ba5-5f1b-487d-8f8e-af1dd8c97af2",
      "members": [
        "e2b7a9e2-4169-4e2a-82cc-818f5dbdf36e"
      ]
    },
    {
      "cluster_id": "269d367a-5938-4087-911a-3256c10a910f",
      "members": [
        "54a34012-19fb-4e45-96e9-9f7d1cf417c3"
      ]
    },
    {
      "cluster_id": "2cb0cf7d-4f72-4e53-9096-b92c1763568c",
      "members": [
        "48106139-5b3f-4a6e-9465-2a535b8dff53"
      ]
    },
    {
      "cluster_id": "86f4bd2f-fbe6-4fe2-b712-f9d4acd0c218",
      "members": [
        "2363ff10-3235-432d-913b-658d5f2453d3"
      ]
    },
    {
      "cluster_id": "0c0329e4-9982-4d5f-9450-241c86955685",
      "members": [
        "7d9ded32-cfd4-472c-b8e6-639d3e8e7c2b"
      ]
    },
    {
      "cluster_id": "fcbed875-f592-4e43-93ba-c1c4ead8d38a",
      "members": [
        "2d731179-770f-46ec-8cff-cdc71213ab2e"
      ]
    },
    {
      "cluster_id": "2010e740-a26e-4489-a685-8115e3933580",
      "members": [
        "06442e9b-bfee-45f4-96d3-f5cbde74c12e"
      ]
    },
    {
      "cluster_id": "21e1972c-1d67-4f1b-a212-f7b911ed7f60",
      "members": [
        "859e3451-91df-41d7-9b35-30e293b2db5a"
      ]
    },
    {
      "cluster_id": "3ca56034-eb2b-4824-906e-24d9da4948a3",
      "members": [
        "16a1efe5-5a02-41dd-9a47-0d530689fdf9"
      ]
    },
    {
      "cluster_id": "708c11e2-cd61-4685-8e6a-35d93d6b988e",
      "members": [
        "60d005f6-07f6-4f28-9fbd-3287183b009c"
      ]
    },
    {
      "cluster_id": "91ae7c53-2f75-41de-be44-6ce7a4b47412",
      "members": [
        "86683180-8d4c-43cd-93b5-f7aefe9a07fc"
      ]
    },
    {
      "cluster_id": "ec613890-df43-48e8-bf2a-a40ccb263efc",
      "members": [
        "bf5f91e6-8c18-466f-a8dd-eac3650d3939"
      ]
    },
    {
      "cluster_id": "c3c67b90-f64b-4b19-8a14-0325205ef32e",
      "members": [
        "014ed6d2-14a6-4b25-b4d0-56327e826885"
      ]
    },
    {
      "cluster_id": "ad973751-acf4-4c7e-8032-3a95cf408206",
      "members": [
        "53cfb7f0-c2ff-4d26-a2aa-737cdc1dedab"
      ]
    },
    {
      "cluster_id": "c784871a-fcaa-4345-b3a8-ae8869019499",
      "members": [
        "263eb8da-8c39-424c-b6a6-dbcad9df2dcb"
      ]
    },
    {
      "cluster_id": "7eb7c781-85c0-4773-8374-eeb7374b471d",
      "members": [
        "afa073a5-82d5-42b2-8a5c-972cb0b1a9d3"
      ]
    }
  ],
  "event_clusters": [
    {
      "cluster_id": "0bbc69c0-3b6d-43a9-a4c6-d187b908122b",
      "members": [
        "84e152f2-fa18-4730-8436-ae5868f07e84",
        "4c5754f0-e690-4c37-8ac5-89c6b1886ae5",
        "e75e4d20-06f6-4d3c-bec3-b01d9ef39ba6",
        "1ee8cf44-cebf-4220-a190-81aff7f6362c"
      ]
    },
    {
      "cluster_id": "d64d430f-8c0f-4a8b-850b-225e57fc685a",
      "members": [
        "ab16a202-77eb-433f-a95d-8a5c32382587"
      ]
    },
    {
      "cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8",
      "members": [
        "925e012a-7b2b-46ed-9b92-fee628879d10",
        "c37dd408-ef96-42fb-aa14-f4272835891f",
        "e163903f-04ee-4409-9f45-b8aa604b3413",
        "7c073262-b778-4ca0-95cb-b243b7982ffb",
        "e7868079-84ab-4879-9148-df64a7f540e9",
        "5765f2af-b42b-4678-9a5f-69b58bd3a023",
        "aa857a91-bc00-438a-a783-6a2f7a4230e2",
        "c1c0f08b-a7e7-47dc-b2ab-3e7f98dedc81",
        "04c77015-a45b-4365-9b9e-74d977cbc12f",
        "1e20843e-0217-4c07-ac4d-1ebad8424cac",
        "7954bc6b-c492-453c-9796-f6c5a5dfe4d4",
        "d6e5d0ec-a287-4c85-aaea-293d330b05a6",
        "9dca14dc-8e09-4ce9-bc08-504e8a677f71",
        "51ced878-c7a3-4b0b-94ea-fe890b9f18ee",
        "f83bdf2e-7c16-426a-9bf7-f80d7cb0bb3c",
        "c2ff0ebe-998f-49d8-9a26-7fb72ec51dcb",
        "2dc6eb24-8335-40ca-90b6-c9398dfa00c9",
        "344bc6bf-1087-4258-874a-612ea4554b85",
        "fb718e29-8b18-4fcf-81ea-c75ba72067bd",
        "33e94dd0-492b-499c-83b2-f52adabde777"
      ]
    },
    {
      "cluster_id": "23b45144-23d0-44ff-aa24-9b637f465e0d",
      "members": [
        "970e6f4d-f145-4e08-88bb-8b775120a572"
      ]
    },
    {
      "cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c",
      "members": [
        "ffb34bd6-7690-4d59-b1ea-e3df21125aaf",
        "5a2bf5df-c9e2-4260-aacc-208208da8e1a",
        "813a7097-75bc-4c0f-8ef2-db8268ff9773",
        "6c2dda8c-ea69-4ecf-a0d2-8bbc59e85879",
        "25703fba-ae53-45aa-b648-a763cd3e39c4",
        "f2d0d656-bd3e-4ab3-a57e-5277628a2f0f",
        "0ef1fdb2-1350-4739-9a5a-6090cf7b4a06",
        "facf3501-0244-4305-9925-f7c9aa3bba25",
        "d472a84b-ab39-4837-a279-74b14e2731b4"
      ]
    },
    {
      "cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2",
      "members": [
        "8c5f4025-aa29-4b77-9333-f49a177101a3",
        "746c62c4-228a-4f2e-a8a3-2d7a29e70163",
        "36dff2e7-9a23-442e-a3a7-16e2201e782b",
        "cfa63295-1a34-4cdb-8201-fc3619deef3b",
        "c965ed77-55a5-4f50-85d6-97b66474f50b",
        "f395dce6-501c-4bb2-90d3-d8e75b35a094",
        "cfc8dac5-eae7-44fe-b864-2482df74dca6",
        "cd239cb6-4ddc-4fbe-b1a3-4efb0781c923",
        "5146a220-e5e7-48de-9436-17e028427749",
        "6f09bd0c-0e65-4bb7-b328-075cce279abd",
        "f4e3a9e3-3c3d-4ab1-8c3a-b7b4f00b7da0",
        "f7b9b2d6-8f53-43d9-99fd-bb3b69e7b89c",
        "48b3fcf6-2759-4a7a-8c1d-a26c0c29ee77",
        "e291a5da-d21f-4619-96ef-ce2d2ff75968",
        "1319e96c-f08f-4509-8966-9cca047160d7",
        "230d6126-a06f-4719-a4e4-ee47b7d9dfc8",
        "be27228c-d989-4f16-9133-a47c0cc58596",
        "15321a4a-1154-4fe6-89f7-f3e8de6e2ca6",
        "a76f28a8-e514-4778-afec-dbf62ede3de5",
        "9d86fdf6-7f59-44ca-b7a2-4f9d5dde13c8",
        "68f43613-d2ab-47fa-b7af-29833557ed2b",
        "574761de-312b-4720-bbda-afab392d4054",
        "4064f9b2-6d78-4be6-b53b-8c5fb1755764",
        "9193020b-9629-4752-b592-6b6478600257",
        "3c1dfdeb-f300-40f2-9032-3094fe4645c7",
        "ff856f4d-0e11-403a-982f-e86414ddea01",
        "9a96fed9-679f-4d77-8bae-cfea4c180fe9",
        "d9cfc5d8-142b-4158-8b7d-58772f988b60"
      ]
    },
    {
      "cluster_id": "a712c5f0-f65a-4cd7-abf6-1f0e442746d4",
      "members": [
        "9a10a4c8-d6d4-40b4-afa3-7b1430b44a12"
      ]
    },
    {
      "cluster_id": "2cbbdb0c-fd37-40a4-97e3-351c65d658dc",
      "members": [
        "1b3be0de-f336-4d77-9018-5cacd2638d84"
      ]
    },
    {
      "cluster_id": "b8d995c0-360e-40c1-b216-5c539da3c67d",
      "members": [
        "8293afe9-596b-46e3-9a99-a40916ec1804"
      ]
    },
    {
      "cluster_id": "3ad13608-e9f5-474c-8ce2-26cf09394813",
      "members": [
        "5cf646d1-647b-4ff5-a477-efe2d006cc48"
      ]
    },
    {
      "cluster_id": "84ed6834-5129-43f4-a029-0b28839b357d",
      "members": [
        "395a9807-e7a3-4ab3-94b4-498e499a5709"
      ]
    },
    {
      "cluster_id": "12d63e10-92df-43d1-9c3e-5149ff60ae94",
      "members": [
        "bf3d4f0a-3cf2-40bc-9347-70f81eb72707"
      ]
    },
    {
      "cluster_id": "2197b0cf-d748-489f-aa22-936ee02a0c14",
      "members": [
        "04f15057-3aed-4d7d-a1ce-a1ed60652382",
        "babb07ce-6461-4c01-8c46-35291a233a46"
      ]
    },
    {
      "cluster_id": "3ca85742-8366-4a09-815d-244dcb1111f9",
      "members": [
        "cee770f3-7c9f-4178-9c74-654b0a079459"
      ]
    },
    {
      "cluster_id": "0212de6c-9c69-4316-ae96-331158f2438a",
      "members": [
        "69b54743-69ff-4a08-818f-3f34fa3103f2"
      ]
    },
    {
      "cluster_id": "e10095d2-279b-4481-ac92-6fd4df698726",
      "members": [
        "b59a915c-4a63-4d9f-a50e-20ff35f19092"
      ]
    },
    {
      "cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9",
      "members": [
        "951c2a71-d688-4dd2-895c-f68662968dc4",
        "01cbf676-2b81-4b2a-825d-68b1a2870483",
        "17f927ab-9b78-43ff-8cd2-151101d87067",
        "c1efc833-9789-4e82-b10f-013ba81a9a7c",
        "14be8132-51cb-4f2a-8a62-0eb16f84241b",
        "19c8dceb-ba49-4083-9bd2-9bf694c04895",
        "d7c58d96-458f-4f49-bf5a-18b1b8b77ae7",
        "61bedcf1-152f-4e4c-8cc2-f36e308c8054",
        "d0c5ca2b-230a-421a-8ff4-fa02093493c5",
        "d73463a1-5438-4300-ac9d-930dadca166a",
        "d1e1a312-d14f-443e-8ecf-d5749a4e57f4",
        "31ec4e9d-d48f-44e2-8a6f-c7bd59206baf",
        "db314afe-80f3-46e6-b3e6-34d6477bd634",
        "c5ef65de-3e9a-4d95-b685-671192868f4d",
        "a71d8cfa-f5e8-4f18-998a-6204aef07bc1",
        "eae1880d-3590-4fa9-9cbb-842e0a396bfb"
      ]
    },
    {
      "cluster_id": "4a7e58b2-ad14-4711-92da-e24d91c0e2a2",
      "members": [
        "94f80ec4-2cc3-4557-83eb-9dfab510cfa7",
        "3a38d6d4-0713-4982-8aff-3d58bd79458c",
        "757568b7-5fb3-450a-a580-24ec7dcfa129",
        "190837d7-d1a4-4fd5-90d4-a7a51760571a",
        "6a6ce671-7575-4245-941b-223ed81a25d0"
      ]
    },
    {
      "cluster_id": "628b9939-51f6-44a8-83a8-ac677a42d942",
      "members": [
        "cddf823c-29ba-406d-9d4c-a908fa0144cb"
      ]
    },
    {
      "cluster_id": "97818d6e-d8de-47c2-bddb-148ab8c2d1b7",
      "members": [
        "edd2b72d-6442-4656-aab4-f03a4a38c553"
      ]
    },
    {
      "cluster_id": "6a63b515-0915-46a1-b528-3651a558693f",
      "members": [
        "2add510d-82f0-4d5c-9dc5-a97ddccba76f"
      ]
    },
    {
      "cluster_id": "771ff184-5478-488e-90da-69f2d3b1dfbb",
      "members": [
        "305fda9b-19da-4f40-8a6b-dd9dcd2e373f",
        "a2d274d7-5dcf-4eb7-81b7-622b8e2e97a8"
      ]
    },
    {
      "cluster_id": "37a93514-6b4c-403e-9a3e-4ceb074df89f",
      "members": [
        "88a4b9ac-a4ef-4d31-b258-078d5929dfa3"
      ]
    },
    {
      "cluster_id": "712fa0e5-9886-40f6-b761-bb1a99d5fb8c",
      "members": [
        "9becb736-cbb7-43af-b42b-e7efd7fcafaf",
        "0640f999-82c9-4245-985b-1c046a916479",
        "d2b529d6-7af6-4f04-957b-b557fb40ccd8",
        "e10eaa2e-0fc1-44fe-af4c-61b04e674d8c",
        "eda9cd0e-6a9f-4236-8a98-031b010dae5d"
      ]
    },
    {
      "cluster_id": "6d563374-a7de-4d4e-bf0b-d89a34f47ac7",
      "members": [
        "0911f635-e117-4a63-960f-87a757d833cd",
        "50d01ee9-5c85-4fed-b808-8d69cdbc9da8"
      ]
    },
    {
      "cluster_id": "d7ce0029-7c2c-40fb-8d24-32029ffa4b81",
      "members": [
        "cd44330b-fa1c-49b8-889e-4f60abb1948a",
        "f84bd64e-b7d5-4b67-b03b-4712251d4a81",
        "bd5ac819-2c81-4c5c-af79-03220d8e3334",
        "123b1d82-f1cd-4622-86c1-30cbc193b7d7"
      ]
    },
    {
      "cluster_id": "57d05796-d479-4bb6-8a2c-cdfddd5731a7",
      "members": [
        "a1663ab3-1573-41d6-b61e-125f36ef72b5"
      ]
    },
    {
      "cluster_id": "2e14b451-260d-492b-b69f-85a48e166493",
      "members": [
        "a6a07057-e2be-4abb-a102-d1ff864ddae5"
      ]
    },
    {
      "cluster_id": "ab7feba4-a1e3-49aa-a70a-5a191501e657",
      "members": [
        "06716448-d748-4bcc-9d29-709595db86e6"
      ]
    },
    {
      "cluster_id": "5abf2d27-62a3-4f2a-9794-398729b78b13",
      "members": [
        "23f1861f-9600-4e6e-bcda-e17290f2aa90"
      ]
    },
    {
      "cluster_id": "72967666-4eb9-48c4-a9dc-dc51036d287d",
      "members": [
        "39463f3a-f93e-4fc4-81fc-fbf6f203c465",
        "8ddf5fc5-3bf5-41e0-95af-544f8ff32143"
      ]
    },
    {
      "cluster_id": "36ff0bd5-8344-4d31-824c-e7dea3acb3e6",
      "members": [
        "73ef133e-2e7a-4d4a-b9c2-0afcb4bbdfb4"
      ]
    },
    {
      "cluster_id": "1f4a4adb-de76-451d-aa05-57dc41f8014d",
      "members": [
        "88583943-069b-4732-b145-80a54a783005",
        "04b492a5-c4c7-4b19-bb3c-45a7054015bb",
        "e1934da6-d4f8-409d-be74-719425fd79d4"
      ]
    },
    {
      "cluster_id": "90a7e868-64e0-420e-8b7e-dbd99dcaae03",
      "members": [
        "a560f278-4f3d-4e87-a291-dc062e6e9562",
        "c81b5cbd-4f13-4372-be7c-e7e77aa70d19",
        "3bb9c600-54d7-4db5-80d5-f9e07ae9b04d"
      ]
    },
    {
      "cluster_id": "05133a93-3ffe-4993-9c55-47f240923f20",
      "members": [
        "9aa968e2-cdcd-4bd0-ae6e-db3b7a550990"
      ]
    },
    {
      "cluster_id": "39719bfa-8761-4992-b42f-7b9ea44519ab",
      "members": [
        "7350d91d-6408-4345-9369-78eb520a02d4"
      ]
    },
    {
      "cluster_id": "58d84750-75e5-4a06-9053-f1a5a8baf564",
      "members": [
        "fb703d7b-7566-46ce-87a6-338cbccd27f1",
        "36275120-af4f-4f42-937b-825cf7b1bba5",
        "fd6df1e7-3ca7-42ed-b882-b39f19350f40"
      ]
    },
    {
      "cluster_id": "fe5794f0-39d5-4958-9baa-650967c24ce0",
      "members": [
        "9463f49d-31e2-47bb-aeba-88b26e0eaaff"
      ]
    },
    {
      "cluster_id": "9bdbcd6f-9804-4d17-b1b0-8bb5670939d2",
      "members": [
        "618c1ef0-a692-466c-b963-89ea7243c3be"
      ]
    },
    {
      "cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14",
      "members": [
        "bb1bd6e8-303f-4ed0-9dfa-3f0919d2e099",
        "a6160e6c-5484-40f4-9600-e21d9ac905d1",
        "42c2c04c-9907-43f9-8431-3121cb83ddd5",
        "3022932c-02eb-48c9-b138-d812dbb39ec7",
        "b95cbcfb-1859-44f6-8426-cefe788205d4",
        "69ebe80c-dbb8-47c1-b3ac-0ff61794fcff",
        "ba9c253c-7260-4ccb-b433-2cf15d3e9217"
      ]
    },
    {
      "cluster_id": "8c274c4a-42e3-4136-9ecf-91adb76667f9",
      "members": [
        "8adee013-069c-486c-93d0-9361c778763b"
      ]
    },
    {
      "cluster_id": "dbb1fd32-5705-43e8-a68b-a90c6757768a",
      "members": [
        "c9763a61-b691-4150-a4d6-286b290ccac9"
      ]
    },
    {
      "cluster_id": "f6fe4656-91eb-4bf2-98b2-cfac47bcc12d",
      "members": [
        "c1c46137-389d-4bf3-a508-0df6760ca0ec"
      ]
    },
    {
      "cluster_id": "24658627-4999-4848-a061-5b2350a4cf4b",
      "members": [
        "61c505f4-7c2c-4e12-8853-97ed1f2b95db",
        "cf85300d-422f-4309-8986-fbd3de9faa9e"
      ]
    },
    {
      "cluster_id": "aab98ee7-4c57-4777-942d-e109c08eee52",
      "members": [
        "63d361ed-d80d-486b-96b3-587c68b4764e",
        "03a0c294-e976-4333-841a-97588c9807cd"
      ]
    },
    {
      "cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f",
      "members": [
        "0348d2b7-6176-40f0-8b89-d8fcabe47875",
        "6505bf7e-a28b-4f90-81af-8e8806402064",
        "42258c5f-d0e7-485b-885e-3e3bfdc304ed",
        "2e57aac3-7da7-4f92-88ab-1a2534a142cc",
        "6b7ea435-638a-4b49-a8ac-7dc2acf3df98",
        "fff1af7e-274b-4d88-8915-f7c9ff6bb7fc",
        "7779dd72-ca1b-4c1b-9903-d28e8dc1faab",
        "abcf1a28-13cf-40e8-947d-de677b477c2d",
        "53564912-43b7-4dc3-b199-27238fc54085",
        "1aa4a657-e845-4ac3-8dad-66938da4aa28",
        "915f5621-6d1b-4b9d-aa6d-d4e936f4532c",
        "141eae5a-1061-484d-80c5-2ea0fa66e353",
        "bd97003f-74ba-4fd8-b575-c82690bdbc1b",
        "369fae54-d19e-45f4-b266-bf30cf97a1aa",
        "65bfb0ea-7932-43c3-913f-5df60038e8ab",
        "60b4df88-018b-4498-9d6b-675151d5ae0a",
        "910b861b-ebe9-4983-ae71-fcbdde128309",
        "1e771bf3-49a5-44b9-9445-735d725cfa2c",
        "a1355bbd-fdad-48a3-8e4f-5b2bbb3471d0",
        "5602e0f4-d219-40d1-b7cf-dc9a28d01309",
        "37d99c23-6cd1-45cc-92df-c11680a66be5",
        "ce51a3b6-4ec1-4741-9641-e65ecd97209b",
        "586ec689-5403-43fe-b4c5-d134115e8f07",
        "aba505df-97c2-44ee-af3c-185123d8d571",
        "50663370-4f1d-4512-8b35-0ed7418f2bf4",
        "80f2656e-a02e-4cab-beb2-a1f99619cefe",
        "10b1b3a9-c651-481a-b1e1-63205a836346",
        "fafefd80-e2e8-4b59-8a21-8df1b96decf8",
        "b34d7d81-77a6-41f9-866c-0d5d976e923a",
        "02863339-38b5-4c5b-ad5c-759fea14668f",
        "44c2738a-f13d-4a49-b5de-f70fe3e55d56",
        "9ed82274-4dfd-4a08-9cf0-e54b6ed05a27",
        "94175f26-ab9a-4fab-94f9-cceb21ab1ed0",
        "55243c7c-b698-46e8-8008-84bface2b7d6",
        "2617e451-8f84-4920-b2d0-2ef415157476",
        "84a2dfe6-43f4-460a-94a1-8b232d4f8d88",
        "3095f1fa-376e-45ba-be02-3c582ac40c20",
        "91f9f092-8711-4eec-8493-04025fd5e3c9",
        "036b26ef-e527-40b6-ac69-92cd098d5a15",
        "9316f4cf-149d-4a01-bb74-cbc75ae143f7",
        "00de697f-97cd-4ebc-a9fb-9de4c1fe389a",
        "f0b78019-fc88-4133-87c6-d5dc3b5ddf72",
        "747298e5-3a4f-4b7d-97df-c50347bf7bb7",
        "136e92b4-2535-4767-a92a-7ba13709179c",
        "c892815e-ba02-4fbe-aaf9-7e5ab8e32444",
        "eed4e8b4-0522-483b-8749-518e3904ed41",
        "9cf44ede-37dd-4147-8e93-89a5b38604fa",
        "b3c7c16d-d44b-42a1-86e3-3bd88bc2b166",
        "dc3b4953-1867-4ab4-9561-7206fe782a8e"
      ]
    },
    {
      "cluster_id": "12ee6320-67eb-4e37-918e-874e1948fd36",
      "members": [
        "458962f4-39a7-49c7-93c4-ffe550b06aef"
      ]
    },
    {
      "cluster_id": "e6342a31-63c5-4e60-b405-bead23c2ee06",
      "members": [
        "139b2601-d9aa-4412-b035-49159c4fc066"
      ]
    },
    {
      "cluster_id": "a42bed59-a9d3-4a76-b9d2-41f637803b1b",
      "members": [
        "6db163de-95c0-49df-b814-1d89da588703"
      ]
    },
    {
      "cluster_id": "9610bc6c-2c1c-47d3-bb20-3bc619407fd0",
      "members": [
        "fa3b2a1f-10f3-41ec-9d6b-06b8a56e9f91"
      ]
    },
    {
      "cluster_id": "84df1dd4-8c28-4b8a-bdf1-47af884e70e3",
      "members": [
        "5bfd217e-b4e3-4698-a671-853a469c1a85"
      ]
    },
    {
      "cluster_id": "9ff8b495-2fb3-4416-a1b0-68b8560f98e4",
      "members": [
        "262c9c9c-f3c5-44e4-a1d0-01947c0c5501",
        "90a9d5a6-f8af-4493-8fa5-a42bb8db9d4f"
      ]
    },
    {
      "cluster_id": "636dbb94-cbc8-4c79-b785-6d406b28db48",
      "members": [
        "076ebc36-d450-46a6-ba2b-2a82d07b55d3"
      ]
    },
    {
      "cluster_id": "a222bbbf-dfe3-47ea-9ab7-93e4d89e7fe7",
      "members": [
        "c3488754-8e08-4402-b2a0-85331fff963b"
      ]
    },
    {
      "cluster_id": "1b8daac6-2959-408e-a7dc-dd102f0defee",
      "members": [
        "24a451dc-483c-4c83-90ec-f9810c097d83"
      ]
    },
    {
      "cluster_id": "b3c5d56a-6d97-4291-aa82-9075fd6b93ba",
      "members": [
        "ba89b7d5-0234-4982-ab98-56b648aa5a9d"
      ]
    },
    {
      "cluster_id": "e069f39e-fe04-4587-9d2f-1992b7189502",
      "members": [
        "47c5cbc0-38ac-4145-83fc-adb129b8a28b"
      ]
    },
    {
      "cluster_id": "1f760b40-15ae-43cb-8956-bedcbe236708",
      "members": [
        "ecc9b611-102b-4b4b-b0a9-3ddf7f7a28fd"
      ]
    },
    {
      "cluster_id": "32516088-d496-4b04-a09c-540561be5921",
      "members": [
        "07778b1f-b8cd-449c-ae6c-5f704a14dccc",
        "780ed672-740b-42db-bbb9-1c3cfe15c884",
        "da7bede6-7a01-4a88-8ee2-8487491580d2",
        "b8a644d1-1a59-4a57-a12c-3e97043b444c",
        "d55a0a6c-e4ad-4aeb-9e20-2b8b02de62c6",
        "4fe6f1c0-42e1-4624-9724-0f3a607b1ad5",
        "8a80fc92-c2af-4e5f-b8b1-efbcffb2cbf9"
      ]
    },
    {
      "cluster_id": "7b263d1a-e07c-48cc-bbc0-8a228f72f292",
      "members": [
        "e1827af4-5212-4e67-9651-9f7cb1021ab5",
        "7b4a72aa-0324-4d1b-9335-9805b28f7966"
      ]
    },
    {
      "cluster_id": "e98042df-e94b-4a67-8387-fe8218853a1d",
      "members": [
        "3d943bcc-f75f-4abc-9e2b-6abbbfa07af8"
      ]
    },
    {
      "cluster_id": "4a667d4b-a464-4833-81f6-cd5a99658ce5",
      "members": [
        "a16a0af6-54e6-40ad-b4d6-0580573f8262"
      ]
    },
    {
      "cluster_id": "a2f20d4d-0860-445b-aa4d-0a748d8d1f73",
      "members": [
        "ce9032db-2a19-40b8-af12-ec438a6ece7e"
      ]
    },
    {
      "cluster_id": "ad4af428-e855-4639-a39a-60d90249fe21",
      "members": [
        "9f1e0b10-f3b9-4110-a148-2ec0f8f50515"
      ]
    },
    {
      "cluster_id": "7cd53b0d-1bfd-45ff-a900-1bdfd6e403a3",
      "members": [
        "f565afca-6eec-40ab-b60e-39070f028961"
      ]
    },
    {
      "cluster_id": "a821fab7-385f-4999-8399-e63f4f07d4d9",
      "members": [
        "d3b19056-328f-47b8-b4af-f85f9656a684"
      ]
    },
    {
      "cluster_id": "cc656b46-bdcc-435b-a7d6-1b15ef3a32ad",
      "members": [
        "452436c8-3d1b-40c3-8efa-d978e367bc75"
      ]
    },
    {
      "cluster_id": "c193bcc0-0d98-4b99-869b-53885d805dc1",
      "members": [
        "a803e4bf-7243-49a0-af5f-2029ff92b91d"
      ]
    },
    {
      "cluster_id": "ec791f7a-6542-44c8-9d59-4679b8301276",
      "members": [
        "405388de-0b9e-4980-b174-36e7f057144b"
      ]
    },
    {
      "cluster_id": "e1005ff4-1bb8-462d-bc29-153ca1f78b3b",
      "members": [
        "5f074750-a6eb-4bc7-b8c2-bb71a36d7d7c"
      ]
    },
    {
      "cluster_id": "6f88a50d-7c8b-451d-b706-e766cfe9a47a",
      "members": [
        "2a6fc254-1269-458f-8a30-9f2f870a60e9",
        "32a66506-57c7-45bd-982c-36465c065377",
        "8af9e40f-53d9-4962-af42-2b1b546eae95"
      ]
    },
    {
      "cluster_id": "800e3797-9c0e-40b0-9390-53c562dabc15",
      "members": [
        "8adb6909-17d6-4caf-931f-a2874497a9d5"
      ]
    },
    {
      "cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8",
      "members": [
        "d2457389-c3d9-47cc-a513-cab7d7fdc8ca",
        "258ba6cf-e3b4-48da-aa2a-505f8615c449",
        "c60d8400-68ef-4604-95a2-0f5b96a38f78",
        "fdec233d-6dc1-4acd-a0fe-ee5a2450d5d2",
        "faaf2a04-99b6-4eda-a468-4babd23b34ed",
        "b0ef9cfb-447e-4a08-8801-cab9d103a008",
        "6db7bc6b-d875-4968-a306-ba8cd0b84592",
        "f702eca4-3df3-43f4-ba88-8f82b221f0c6"
      ]
    },
    {
      "cluster_id": "3ff9d247-61b1-4db1-b0eb-87ae85150e08",
      "members": [
        "1e96ff68-3faf-4f64-9309-c3fd81619485"
      ]
    },
    {
      "cluster_id": "3bf26de2-8578-4eb2-a0d5-5c4deaf0246b",
      "members": [
        "38ab785c-3e01-47bb-954c-90b12bfbbd95"
      ]
    },
    {
      "cluster_id": "4863edc0-3025-4ffa-ba81-0d1ed977b2b9",
      "members": [
        "cda74b8c-f8e1-43b3-97ea-f10b8662e7d7"
      ]
    },
    {
      "cluster_id": "c24c8055-1228-411e-82e6-d5cc151796a6",
      "members": [
        "15d565d3-fd46-4488-948e-1e1d2ec92989"
      ]
    },
    {
      "cluster_id": "25676d7b-137f-4f70-b3ce-39af6bc7a4fe",
      "members": [
        "33ac0e90-a934-4be1-8500-d703efc8fe1d",
        "654f84f5-583e-4aa7-be94-d3c0d95c5318"
      ]
    },
    {
      "cluster_id": "238a575a-ac72-4ae9-8880-72409a39a327",
      "members": [
        "53818edf-d20a-4280-b405-d6631088ec3c",
        "7bb2184d-04eb-4cc5-9bba-24bbaa1c88fe"
      ]
    },
    {
      "cluster_id": "bbcaf773-6ffd-4bd3-98a9-fd76783316d4",
      "members": [
        "15fa5012-49f2-4fe0-b2fc-c036c78dfe23"
      ]
    },
    {
      "cluster_id": "450543ae-8630-4e48-a375-9699e4cb6925",
      "members": [
        "c71e0105-7c15-496e-9e5d-9ad87554a6d3",
        "88a3dcec-9c0b-4238-9770-91adeb6a711a",
        "1cecf870-454e-441f-9f74-fdca57707139"
      ]
    },
    {
      "cluster_id": "c595259b-ebf4-4c2b-b3d7-406a6b1c52ac",
      "members": [
        "f594392c-a4dc-4c76-b795-28d998459538"
      ]
    },
    {
      "cluster_id": "cb33e750-c57f-4e58-a355-2b249b902a62",
      "members": [
        "cbb81680-9122-4150-9b14-5fde22755d97"
      ]
    },
    {
      "cluster_id": "bdaea9bd-1088-4933-8486-42634bd70322",
      "members": [
        "21faff8f-7b2a-4bd9-aa48-b3fff46bdbf8"
      ]
    },
    {
      "cluster_id": "e3cd63c9-b877-4cb4-80a4-d872818bfe3f",
      "members": [
        "c4fc88e3-814b-4889-bff4-556056c4912b"
      ]
    },
    {
      "cluster_id": "41d69a2f-db55-4c96-81a9-27bcb85442bc",
      "members": [
        "bb138d5e-1bd0-43f8-8c6a-e0c9519dded0"
      ]
    },
    {
      "cluster_id": "84977d14-a5d8-4f51-965b-c09f3c5a291f",
      "members": [
        "e875ca96-e4d0-4af7-9a3d-1428f4ed7a9a"
      ]
    },
    {
      "cluster_id": "c4bed539-a0aa-4ff8-9be3-4afa92598dee",
      "members": [
        "d38c0d0d-a75e-4854-8acd-8ce2ba04c25a",
        "31c21d42-48d3-4ff9-a7b1-3b2da97242bc",
        "d6ffd937-63c8-4937-b8bc-2680e5603706"
      ]
    },
    {
      "cluster_id": "d18f265e-1140-4ce3-9bf4-76f0c6ccf8de",
      "members": [
        "5c86b624-3bf8-41c0-9ef3-0881445603c3",
        "7d27a311-e2d7-4230-9432-759924944e8e"
      ]
    },
    {
      "cluster_id": "32ad70e2-6724-4b9a-a0c3-bd70b56126d0",
      "members": [
        "8f904b01-783a-4203-a9f8-4d3a6e7a90f3"
      ]
    },
    {
      "cluster_id": "b816fa39-a961-4930-9c7a-6091dc870326",
      "members": [
        "c1cdb795-eef3-4d83-b2cf-fc7b4f142e4a"
      ]
    },
    {
      "cluster_id": "0d5de813-beee-4fba-8db1-09461ff50d02",
      "members": [
        "38a40083-ba49-4c7e-b6a1-0d8ad9e16a68",
        "3496e957-884e-4e03-b8ca-f518cee17c14",
        "9935cc06-404f-446f-ab6b-5ab2fb7602ee"
      ]
    },
    {
      "cluster_id": "46d5760c-bd0b-4c2e-8270-d2debd9f3dcb",
      "members": [
        "586c490e-494f-4e24-87a3-09fb08b48cf5",
        "7361180e-2a2f-4df7-ae35-2f45e047a9e4",
        "7175103d-b7f9-4570-85a2-673f72108e12"
      ]
    },
    {
      "cluster_id": "f8814fc7-2279-4d32-a22e-1e33adf9e995",
      "members": [
        "f8ad6006-14cd-42b8-9f41-ac32b1e2a1c8"
      ]
    },
    {
      "cluster_id": "701985dd-4322-488f-8c88-ea50b9053ab8",
      "members": [
        "38e9e7d0-ff0d-47f5-ab45-be36a362e697"
      ]
    },
    {
      "cluster_id": "4b36afdb-64c0-4dfe-8f4d-501930c59107",
      "members": [
        "33f06504-34f5-4ddc-9f7d-6977df239b00",
        "4dd03931-2066-4f6c-b70f-aff356e9b46b"
      ]
    },
    {
      "cluster_id": "637ffe03-032a-46cd-af4f-d7f5c220eab9",
      "members": [
        "09f3b156-9142-4170-b82c-d6e48fd74216",
        "c545c24e-620e-4274-bb42-f77c2c191bba",
        "e4c84464-0a89-4baf-b942-1308b3b32900",
        "d3f8fc98-2bd0-4e1c-84ef-848db8385d6e",
        "feb7be62-542f-4fda-98d2-d62b041b7e4e",
        "57a02ad8-4448-44e4-a141-520c03160428"
      ]
    },
    {
      "cluster_id": "ebbce66e-0d97-4659-a453-e44542e8d915",
      "members": [
        "0547cf7c-f4fc-4f88-881e-f354799d394b"
      ]
    },
    {
      "cluster_id": "8bdd7aea-e82e-44ed-9306-49ba0cde454c",
      "members": [
        "99388c57-039d-4450-a2ea-77d39164f936",
        "e7ba6c83-fd4f-4845-861d-7416006c77a2"
      ]
    },
    {
      "cluster_id": "a4ef4316-1b40-4ce1-b5cc-ef7ada4c3a2e",
      "members": [
        "de0877d2-e5b8-4dc0-abcb-4d999de7b03d"
      ]
    },
    {
      "cluster_id": "4d6eed7e-0404-4ccd-92b2-df5956550e67",
      "members": [
        "af8c4621-5743-4ab5-b75f-a10982b627f3",
        "7839b325-4a85-43da-856c-b57c97205728",
        "19c0c942-6db9-406c-9807-f992d3e1b895",
        "12390c88-6802-4a75-b1f8-15c7a30d1011",
        "041a4de6-f275-4268-a290-15cab46201b5"
      ]
    },
    {
      "cluster_id": "317ecec9-87af-4e3c-acd4-372de58135a0",
      "members": [
        "e68ea319-a743-4063-8a6b-a57f7b693345",
        "7dbda8b7-6dc2-4f99-9efd-c4b25f52bec3",
        "3d6ce7a2-691b-4ee8-8fa2-4899f39986e3",
        "9d0b0b48-481f-4015-8133-45d4dc81c3c2"
      ]
    },
    {
      "cluster_id": "7f22f643-051f-4c46-8fa4-209f55a6aff1",
      "members": [
        "d295f0d3-9153-4814-85db-70ed8ee95007"
      ]
    },
    {
      "cluster_id": "f5220f5b-8931-4ce9-bb6b-eefb8c206ace",
      "members": [
        "9fde4b91-1e88-4275-b6d7-a293610dfff4"
      ]
    },
    {
      "cluster_id": "73ef4f09-b38f-4c98-bd02-c07cf7fc2073",
      "members": [
        "f4f24cf5-1439-45d8-8416-872bde8b9671"
      ]
    },
    {
      "cluster_id": "db350168-e89e-48c8-a5ce-3b8c59130017",
      "members": [
        "820dbe4e-83e3-4ea1-af12-b4e14d598494",
        "1db17dca-a60a-4963-ac75-6614e7621bf0"
      ]
    },
    {
      "cluster_id": "4f84ccb5-4935-4023-8826-9c08d0da261a",
      "members": [
        "28bb7190-953a-4a8d-a25b-abfc2ded7b69",
        "8ef6bdf8-6bb8-49ac-aba7-8d88ee45e8fa"
      ]
    },
    {
      "cluster_id": "5b79ee45-2abd-45a2-8873-e58d11466b36",
      "members": [
        "67aeabae-2f28-4de2-9c18-746e97c6ff30",
        "17b8c008-0413-43ef-8e62-1b3e41a4a0c4"
      ]
    },
    {
      "cluster_id": "e0d33feb-9779-4cf1-a571-59040d3ea8f1",
      "members": [
        "9d4cf030-6541-4767-9e93-bb36756e465d"
      ]
    },
    {
      "cluster_id": "29477fdd-bbbe-4e39-b779-19de18778240",
      "members": [
        "2a085237-4836-4154-98f0-9f710d9832b1",
        "e1188dc5-0c3a-40ea-b10c-c1a4ce18f3f9",
        "f39a7b76-7b7d-4b55-b6f5-022ab5954c22"
      ]
    },
    {
      "cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240",
      "members": [
        "9e3e000c-4764-4206-bac6-bdcd3f0133d6",
        "55ed0ca1-fb2b-41c2-b3cb-33ec62c3e4e9",
        "5088ae91-c41e-4b3b-92ac-10fb6253f083",
        "4c0b373b-ea92-429c-a7ab-0032bb94ca10",
        "76b329bb-fe43-4d94-8dc1-903b6344d0c1",
        "2bc6299f-653a-4d72-baa1-8b71416e12a1",
        "2882fc70-2d99-436c-9600-d832cb340c87",
        "681e732b-6457-4afc-be2c-ffa829b4b6c4",
        "7cc31dcc-0efa-4e05-a02e-1fbce072139b",
        "4a3d5220-cb8b-4170-ac6a-98c32da8fffd",
        "f223b73f-a2ba-4f6f-946c-77a1b03ec42e",
        "646b569c-f662-4221-962a-ee7e0f3a48ae"
      ]
    },
    {
      "cluster_id": "338cf48b-ad2b-4dbf-8d36-1e19e9e04681",
      "members": [
        "2f24c199-c87c-411b-be26-4f3f75b8cd6b"
      ]
    },
    {
      "cluster_id": "9cacf170-b6e2-4913-a621-eaff66a64541",
      "members": [
        "2e9cc47a-173b-422c-b53b-2f26ae0482c1"
      ]
    },
    {
      "cluster_id": "fe271a39-4283-4ba9-9f74-a4db31cc4b3c",
      "members": [
        "9ffd3bc2-8394-44e0-8da9-eec5d9fbaa87"
      ]
    },
    {
      "cluster_id": "55a8e92e-7501-4ea5-a3ee-b628a536a6f9",
      "members": [
        "504c325b-a327-4bc7-9702-a9c23fc4826a"
      ]
    },
    {
      "cluster_id": "8245fae1-2de7-44c3-b580-0a610d90519c",
      "members": [
        "0cd08bab-1c16-466b-9d97-d512cdb3e045"
      ]
    },
    {
      "cluster_id": "aec45825-35ee-46b7-b2b8-bea6a7f40f69",
      "members": [
        "37fe491a-4683-4a84-92a8-9eb4d4f308c9"
      ]
    },
    {
      "cluster_id": "1541313e-804f-40cb-bfb7-78850471987c",
      "members": [
        "87740410-18dc-43f6-8b3a-dfb1e442eef4"
      ]
    },
    {
      "cluster_id": "28ea99a2-454e-42c3-b308-cf4739fc9a02",
      "members": [
        "2dc81d64-1251-487b-8ebc-c1e96d5a010e",
        "67a93fc9-671c-47e0-aee7-dfb451276b9e",
        "1e8f66d1-24b7-4b3a-b1ee-0a878d3a35c8",
        "31b7ba04-1249-4c6b-b648-190f940337f1"
      ]
    },
    {
      "cluster_id": "3680c45d-b58c-4b06-86cb-3a65bd43ebc6",
      "members": [
        "cc779605-8036-4dcd-adc3-6a7f8ced5971"
      ]
    },
    {
      "cluster_id": "a14e07b9-7624-46b7-920a-7b615bb8f39d",
      "members": [
        "466b0be3-a108-433b-ad5b-8aab49d16b31"
      ]
    },
    {
      "cluster_id": "1e84c102-c60e-427e-9c32-95517ea67008",
      "members": [
        "66e492cc-628c-4066-bfb2-29d02e77d639"
      ]
    },
    {
      "cluster_id": "777f19d6-a14f-4d35-a3bb-15bb93dcdf4d",
      "members": [
        "76c8703d-7904-486e-b008-51a836c2d852"
      ]
    },
    {
      "cluster_id": "76d7e29b-d686-4238-a931-2118cfe1bf3e",
      "members": [
        "96054146-c21a-4c87-97f2-9161af7b504a",
        "4e4e81da-6501-4c86-a385-5525a45585fa"
      ]
    },
    {
      "cluster_id": "e0229a55-a637-4111-a422-27c8a7ddb0b7",
      "members": [
        "62235204-50c1-4ae0-bd7a-5bb86c3d0d34",
        "db796729-ef7d-4250-af39-af43585a2e38"
      ]
    },
    {
      "cluster_id": "42f681bf-3cec-44f4-9b59-d7168d922923",
      "members": [
        "b76e1028-54ea-4e7a-97ff-dcae5e37ba19",
        "180acd4d-4778-4c28-90a1-ca94875592fa"
      ]
    },
    {
      "cluster_id": "abb66c4f-f4a0-43a2-8032-f5ceeec7f058",
      "members": [
        "87b0077e-0141-4590-8618-4d3583e7cd53"
      ]
    },
    {
      "cluster_id": "7b66a014-a3c8-4296-b622-d0e9055b14ee",
      "members": [
        "7b56002c-8c94-47bb-8e98-a0489250c31d"
      ]
    },
    {
      "cluster_id": "71e63580-38d2-43b7-a5b4-b06b93f3b79d",
      "members": [
        "ce112929-14cc-4e58-8382-26363d0b1a18"
      ]
    },
    {
      "cluster_id": "f1a3e12a-c3c3-4476-aaf7-ecead6148d82",
      "members": [
        "c1ee117f-0c0f-494d-be3c-0eb8b31c1078"
      ]
    },
    {
      "cluster_id": "419042ff-8e55-4ecd-bd38-c47ada6d614a",
      "members": [
        "e5400c13-6955-4e7f-8ce1-97f02f2581c4"
      ]
    },
    {
      "cluster_id": "fd129e43-f4b3-4fda-a189-8dcb11486ddb",
      "members": [
        "5d4bf37c-3e45-47b0-93d1-4452450157cb"
      ]
    },
    {
      "cluster_id": "cfc42d88-49ac-4610-a5c7-0cce12304171",
      "members": [
        "2ea4834d-e0b7-48fe-978d-3db1b6cb1c5c",
        "054735a2-d878-49d2-a85a-78ab7f20b354",
        "5f12de65-de31-4eb2-9198-02fe51497958"
      ]
    },
    {
      "cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7",
      "members": [
        "ca18db01-64ae-4f7b-af77-b58223dc999d",
        "dd631f5a-6080-4281-9adc-8fdb88632983",
        "69d0969d-9f05-415e-a0ac-fe2a141abd94",
        "22930da2-2dab-4788-a79f-737b7cbe2160",
        "80af9af0-d58c-4a6e-ac4f-b9c6247b5718",
        "b40c1e53-d4ad-431f-9d68-08aa979479f4"
      ]
    },
    {
      "cluster_id": "944bd314-7efa-4d4e-ad2d-2a560ec194da",
      "members": [
        "4cc69e6b-088b-456a-aa2c-66bb5cda35da"
      ]
    },
    {
      "cluster_id": "b83cbf56-9c77-41ae-bf34-905116236046",
      "members": [
        "e2ae750f-bd2f-4b8a-b113-685b1344db2c",
        "aa902029-1061-4cbe-9f1d-9be774e8fc3b",
        "2c6b89e1-e849-4daf-83a2-ed6eef4731fd",
        "492a03d8-43e7-45a3-a2e5-13f7ba6ce2dc",
        "001367d2-684d-4b59-9805-f097572ee62a"
      ]
    },
    {
      "cluster_id": "35d10df6-7929-4a0c-9fc1-b26cc3d884f2",
      "members": [
        "74eece4e-027a-4fcd-a614-30c38e2df8db"
      ]
    },
    {
      "cluster_id": "4e7a1657-2c4e-4bb2-bcd7-0842a01bbc47",
      "members": [
        "a9042610-53a1-49f6-897c-4537a68bd04a"
      ]
    },
    {
      "cluster_id": "7640b35f-031b-4917-bf34-5555111a4a74",
      "members": [
        "24cb8c6a-0ca7-47cd-ab09-f8ccf313d3cd",
        "048c95d9-91ed-4ba0-abf2-1ba5dc8c1617",
        "62b4e71d-6e74-4807-808d-08787c84c8af"
      ]
    },
    {
      "cluster_id": "426f797a-e7ef-4bf2-9d6b-e35d76bd66ff",
      "members": [
        "338a6e3b-3418-4a7d-941b-ec10b497cb0a"
      ]
    },
    {
      "cluster_id": "56712450-0dee-4fc4-899b-8d6600a516cb",
      "members": [
        "b9016207-12a5-47c8-abf0-886586d3945a"
      ]
    },
    {
      "cluster_id": "9a22d933-5b51-4f1a-93f6-12dfd9a6f37a",
      "members": [
        "90b2621e-baa8-4075-aa10-ccae5c1cf0e6"
      ]
    },
    {
      "cluster_id": "eb5867fb-4e30-491e-839e-081457361ded",
      "members": [
        "bb22cdd2-06b4-4469-a87d-4c76ab4fe0fa",
        "0e002bec-5fe4-4d7b-9e0e-353142b25b67",
        "8a4b6346-bdb7-45ab-b8e5-216e21331f64",
        "a2baeb15-6e10-4fd9-805d-c5d5f7720324",
        "6d6f556d-e0db-4156-a673-9ad50fc2fdbd",
        "6da6f4c0-936b-4b29-9006-5bf428fde525",
        "4947b34a-d70e-46a6-abf7-55b3d0fccc5e",
        "68889765-9ee5-49d1-b266-6c9e6048720b",
        "eb7f51c7-52d8-484f-be71-f870e79c177c",
        "65415f11-d162-41f9-a436-55fa225f8ce1",
        "bde37614-97d3-4d15-b062-c738dd33f745",
        "9ebbd19c-1b2c-41b2-9e3b-01e96f03ba4f",
        "56744768-0e76-42ad-bfc8-a7813124b91a",
        "9866e716-7537-48dd-956a-7bf35f3b3741"
      ]
    },
    {
      "cluster_id": "93b80413-3a5d-432a-887d-e727cb82d2f6",
      "members": [
        "3e6db30e-ded5-4658-b27f-d0cef081d848"
      ]
    },
    {
      "cluster_id": "ce112f29-472c-464b-84ff-3d5acaf22d38",
      "members": [
        "8d853396-b772-4678-8b21-d54392993e09"
      ]
    },
    {
      "cluster_id": "cb0a8f38-8b40-4637-bdbf-1d9a5a12407f",
      "members": [
        "94ec6777-664c-4b7d-9759-39c0d7a2bd4c"
      ]
    },
    {
      "cluster_id": "befb7ee5-b118-46a8-baef-495aee63c618",
      "members": [
        "e747d535-762d-4e0b-a2ec-e3a175575171"
      ]
    },
    {
      "cluster_id": "920638c0-7694-4767-bc82-851ade0b1652",
      "members": [
        "afe1ead5-1aed-474e-985a-3e97a9a02c20"
      ]
    },
    {
      "cluster_id": "90594f77-57da-4d80-a85e-ef6c61b0cc03",
      "members": [
        "a2acefbd-c6a4-4b32-a8ff-3bfbb8c45adc",
        "f5025228-2ba3-471c-b1c3-23a1505e1738",
        "4d490a29-9d11-445f-b79f-a6dfcf6b674e",
        "6f1c091f-2d5d-4ccf-9148-6a7144b3728f",
        "f8ddd071-d05b-4c10-a854-e72bfabfc89b"
      ]
    },
    {
      "cluster_id": "ae19516a-2181-488e-ac04-088ae5ab7d84",
      "members": [
        "1b6d7754-0f5f-4684-a918-e2eec4807eaf"
      ]
    },
    {
      "cluster_id": "ea03e48a-fe82-4735-a7d5-db2e5351b982",
      "members": [
        "dab780cc-2893-405e-9364-778210326efa"
      ]
    },
    {
      "cluster_id": "0e7e5665-e1ba-44c9-b9e8-62d3501bb81c",
      "members": [
        "b95529c5-7b9f-48fb-9a4c-37ab0a491330",
        "c046e6b5-72ee-496c-918b-4be3f500e0ba"
      ]
    },
    {
      "cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6",
      "members": [
        "45df0e47-67dc-407c-a742-cab16d53dbae",
        "fc9326d4-bea3-465f-8300-9c4cd0d0d64d",
        "44c4e67f-e11c-4a5b-abb7-d66838bc1680",
        "7c3b8401-43bd-4f8a-b967-6e2bb3c08280",
        "0118ddd2-f152-417d-9b54-05cf86103a1c",
        "2d47fdb1-a065-43d7-b9d4-8e29ea65754f",
        "65085434-99ed-4d57-85cd-82de6d7b4516"
      ]
    },
    {
      "cluster_id": "8e1bc392-1f79-4373-ac66-b625742b75e3",
      "members": [
        "e9bf8f60-c979-49e6-b95d-09ffc6f94217"
      ]
    },
    {
      "cluster_id": "f65902ca-8669-4b7e-9388-0fbc20879e59",
      "members": [
        "b37f56c1-d8ec-44b6-9f51-71bedd748aad"
      ]
    },
    {
      "cluster_id": "60b6a6af-f010-44f3-a632-e0a93f1ed5d0",
      "members": [
        "19b39938-7518-435d-8045-b77bcd17e92f"
      ]
    },
    {
      "cluster_id": "3112aa1b-4574-44ce-bed2-c9c9be423dbd",
      "members": [
        "764a63e8-70c4-44e2-8685-71474c046ffa"
      ]
    },
    {
      "cluster_id": "292fd491-c6f3-4ec8-80ae-030ae0db7baa",
      "members": [
        "dec1b8d9-e6fd-4204-91b9-5acb9e4a20d3"
      ]
    },
    {
      "cluster_id": "cc6728f4-4d83-4a2b-9077-fcd32909b298",
      "members": [
        "5f07a8e7-1b2d-4df5-b547-53edbec94853"
      ]
    },
    {
      "cluster_id": "32b69cec-10c5-48a9-adbb-1a38afa40ede",
      "members": [
        "8fb7f94c-b42a-487d-a2bf-e75d6472fdff"
      ]
    },
    {
      "cluster_id": "aeb6169d-c89e-4c20-9127-6438583dd127",
      "members": [
        "8c93f48f-cd97-41d7-8071-bf33f5ef5a27"
      ]
    },
    {
      "cluster_id": "4d4ab9a7-62c6-4187-97c0-f07bf059ad55",
      "members": [
        "287eeae0-30ac-4391-8e0b-a92604678a04"
      ]
    },
    {
      "cluster_id": "a56532e0-90ee-496a-a60d-c01066fce560",
      "members": [
        "8c58258a-054c-4c2e-a256-0c03f926b4e2",
        "4e9714da-d06e-47a1-a14e-0febb6ad3390"
      ]
    },
    {
      "cluster_id": "29022861-4975-4c12-9a9e-92bb32cd1e85",
      "members": [
        "2a64b747-3eff-40c8-9171-4394af0a45e0"
      ]
    },
    {
      "cluster_id": "51d0514d-a16c-49e4-8ac6-e122e83a4777",
      "members": [
        "4b7c9126-7687-453a-94c5-617255028897",
        "1b7ef4c2-1108-40b4-9481-c4e4be2b09e6"
      ]
    },
    {
      "cluster_id": "1072cae9-f711-4ddc-9b33-a14d4050ebba",
      "members": [
        "da7fa7b1-a74a-439e-85d2-687919f7c128"
      ]
    },
    {
      "cluster_id": "3ba6caab-43f9-4e86-aeca-830be9163573",
      "members": [
        "c280d2d1-4e95-48f6-911d-93b54fe8369e"
      ]
    },
    {
      "cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3",
      "members": [
        "8064bfc2-7024-4f06-9497-986a1e975c0f",
        "52439a57-ace8-4f0e-a58e-2ea25ed850ba",
        "a71b831a-178e-4862-9a84-511f15e6709d",
        "3a18f009-e0b6-4e80-bf48-657ccaa32702",
        "2a85d5f1-e5cc-45b3-a1b3-97e6e9999e08",
        "8a336d3a-0a98-4e49-a5b1-dc54520f9680",
        "1a5b6ba3-e0fc-4c63-8ff0-c46957cbc8b6",
        "0c4c6b51-6c7e-43db-8c57-33e148f4390a"
      ]
    },
    {
      "cluster_id": "cfb29440-b86f-4923-96db-5f6b8ae72df4",
      "members": [
        "09c142a4-5c80-4531-a037-d8568610ded5",
        "10e12017-766f-4a88-b89e-72b4241f43cb"
      ]
    },
    {
      "cluster_id": "456f0f19-c43e-4805-a01d-f15d26323d29",
      "members": [
        "f78c939e-82d0-4c4f-a838-fd1250ba7971"
      ]
    },
    {
      "cluster_id": "14d0a92d-65cb-4881-998f-aed067993e99",
      "members": [
        "36cf21d5-796f-4744-9cc1-a42f82021e3d",
        "bd5cb87a-089b-4f5c-91da-e5d1d1eca347"
      ]
    },
    {
      "cluster_id": "e42d141d-80cc-4e68-848e-2d85ecf6a58c",
      "members": [
        "ca063694-43d3-4dc1-a538-2895b55cceec",
        "25181eed-c798-4390-b9e5-2b733fe0131c",
        "ccebdffa-4ee6-45af-9997-498fa76ebdcc"
      ]
    },
    {
      "cluster_id": "c92757d9-a065-4dc2-806f-96c7c9890f76",
      "members": [
        "a57107be-6e07-4363-94d1-0ebcadc66c0c",
        "046df810-54d5-4ea9-9d48-26543a907c8c"
      ]
    },
    {
      "cluster_id": "8ec6c014-24e3-40b5-a577-20ca128d6e41",
      "members": [
        "496fb930-7235-4aa3-b62e-868b8ab98f1a"
      ]
    },
    {
      "cluster_id": "f8ba093e-142e-45ae-b5d0-aef007993c05",
      "members": [
        "4f52da85-e4c1-4efd-9478-eb694741c62d",
        "8e3d0510-fe87-4f90-868a-80eae47ac2ea"
      ]
    },
    {
      "cluster_id": "4adc477b-ccba-4820-b5c6-6a663398b338",
      "members": [
        "5cca2f98-a550-4a3e-9542-da2e648b992d"
      ]
    },
    {
      "cluster_id": "aaa9c952-e937-4295-abaa-c4968a415009",
      "members": [
        "71749530-08cc-490b-b851-4665970d6156"
      ]
    },
    {
      "cluster_id": "59d2954b-c33a-4e1c-87bb-ce014430514e",
      "members": [
        "97914efc-b72a-45e9-ba29-907d16d037db"
      ]
    },
    {
      "cluster_id": "dc2b6524-3e37-4978-9dbf-854499aadeb0",
      "members": [
        "47427ce7-8514-42d1-9bea-9650fac07e2d"
      ]
    },
    {
      "cluster_id": "6ef4a6d4-b9a1-4d80-ae23-e54049cc7170",
      "members": [
        "5ee94827-5ae5-42fa-bb8f-1a2178f4e6a2"
      ]
    },
    {
      "cluster_id": "28705389-d7d8-40a2-9a03-e4eb35877525",
      "members": [
        "188d2a63-2cd4-4b15-b11b-b29437874cc5"
      ]
    },
    {
      "cluster_id": "80650d11-8f1c-4d32-a46d-12e884243f7e",
      "members": [
        "9d0656e1-91a7-4568-a8c6-6145a17c6c4e",
        "637e855b-69a7-450a-887a-26e9d48f94ad",
        "87a6bcaf-9d2f-47e0-bd9f-67b9b1645d88",
        "fa88a2cd-c10a-4c93-a187-e5e358d897f2",
        "2aad08c3-7a9d-4088-a0c8-7173322b568e",
        "ef45ee2f-a90b-4522-a5ef-835dc927c319"
      ]
    },
    {
      "cluster_id": "1be249dd-37fb-4d60-8a83-484cbb6bc5e1",
      "members": [
        "e4d29b02-ebaf-4515-8642-499825b90c32"
      ]
    },
    {
      "cluster_id": "5cf0a8e1-26c0-4c2d-bf3f-608120510569",
      "members": [
        "ed283ab5-9f4a-4aa8-b6ef-9d773773c737"
      ]
    },
    {
      "cluster_id": "0f0292cd-5ed9-4b41-be37-f307be9f4e80",
      "members": [
        "bcde2733-2496-48bf-8dc7-e7b39c4fde0b",
        "850cf0c3-c0b7-4270-a07b-2845822447ed",
        "22b8c6a4-fe2a-4fac-b173-004611eea7cd"
      ]
    },
    {
      "cluster_id": "8a12c9b8-6999-4708-96d0-9b9b5cea643c",
      "members": [
        "e9fe3473-b79a-428a-b152-938869ca5bce",
        "f0065d0f-c46a-428f-9a5a-a696aeb5fac5",
        "27af4d41-3321-43cd-adde-e2cf8cdda644"
      ]
    },
    {
      "cluster_id": "4035a796-2dee-4cd0-986f-eb64d79cd560",
      "members": [
        "a2b525c1-f547-4226-9fd2-d90a827de375"
      ]
    },
    {
      "cluster_id": "a400da3f-ddc6-4851-b855-065d3f101c71",
      "members": [
        "08f06c6d-d2b7-4425-a7e5-ec96e91f0466"
      ]
    },
    {
      "cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c",
      "members": [
        "e8aa4390-6332-4929-b285-0ce0d69d2812",
        "eb7cf401-50cb-4091-952e-3b6afb69fbfc",
        "2b377322-508b-4291-976a-ef44e85e47f4",
        "228dafec-172f-4d6f-a160-297e589c447b",
        "1371df07-807d-4c84-8049-638650fd3c90",
        "037ebe25-c4a1-4188-b565-8419ca9a9ad9",
        "03e3beb0-ecbe-4656-bcdd-f724ae845e9c",
        "e8580e4b-012d-486d-b924-72b24ddb93ce",
        "1b4302fa-4db0-4d8f-9ca7-83cf593a5a08",
        "1a25a97c-fb17-4d43-87d7-ece424c49c11",
        "5279d4a3-a951-4943-b696-ec9d2055d349",
        "d0b97879-7a8d-4815-88e9-070893f31d88",
        "65fad128-4613-43ff-b921-391965d5747a",
        "0692b4d7-b7aa-43b0-903f-54db8a567957",
        "391c290d-4d33-46d1-a6fc-ec24553a697a",
        "5f1040ab-f1b0-405c-9765-93d1480dcc96"
      ]
    },
    {
      "cluster_id": "eff3ff70-7d42-45d0-a372-4aa15bf9f280",
      "members": [
        "1a11be3a-b17d-4777-a790-4e41fa0143cf",
        "98bf6bd9-3571-4fc4-a522-793f28993ff1",
        "e0bbe7e4-58e6-428f-9c40-667d31c60035",
        "476a23f9-b992-437b-90c5-f963e8166938"
      ]
    },
    {
      "cluster_id": "af0ec0ab-3b4f-471b-b656-e88e02335b8a",
      "members": [
        "098c1a39-fa6a-4fc1-bcc0-0f833a274e1e"
      ]
    },
    {
      "cluster_id": "08ccb8f3-d97c-4442-b830-fac7f751221a",
      "members": [
        "350a513d-eaad-4ca4-bac2-fd018fe7b558",
        "e9675adb-0f21-4945-b4f2-dd37623e09f8"
      ]
    },
    {
      "cluster_id": "241d256c-86d7-484e-8aee-4f2f15316b3d",
      "members": [
        "c089cd94-21ba-4043-9f02-b312ba442b1b"
      ]
    },
    {
      "cluster_id": "43787e95-8e23-4c32-ad24-6b1efd3b0be2",
      "members": [
        "e2bd56d7-c3a9-4fc6-a07b-4c44e736665f"
      ]
    },
    {
      "cluster_id": "e3e5aa95-d1ae-4cc4-a1f6-993b699c2d34",
      "members": [
        "0ec34392-7927-416a-97ed-ede221ecb2c4"
      ]
    },
    {
      "cluster_id": "a0c6e4b4-7d8c-425c-8ff1-2b999fb65fda",
      "members": [
        "cae69692-e77c-4bd9-983f-d7e0a368a1c3"
      ]
    },
    {
      "cluster_id": "9f686d1d-9231-4037-982f-0d37e6ded860",
      "members": [
        "556c65b9-2e06-41a6-b9d3-5ced8e2b68a2"
      ]
    },
    {
      "cluster_id": "d5f07507-9281-4cfd-81bd-0fc19ffa8a89",
      "members": [
        "b3bcd9d2-ee33-4858-b64d-275faa36fa1a"
      ]
    },
    {
      "cluster_id": "3fee6535-a988-4207-9d1e-737120abbcbb",
      "members": [
        "8cd731d8-8d53-4a4d-a07f-c15214766715"
      ]
    },
    {
      "cluster_id": "42dcf3d9-1011-484c-9355-4db97109e640",
      "members": [
        "f8527199-6830-4e21-a052-7f5c6b8ecf3b"
      ]
    },
    {
      "cluster_id": "729b06af-76d6-45d8-b842-1a087ece3b39",
      "members": [
        "1005cfdd-f328-4004-887b-6052f4bfa6da"
      ]
    },
    {
      "cluster_id": "f45eb579-66d6-44ec-ab0f-e41545f58c6c",
      "members": [
        "a1d85e0f-f4ca-43fe-8c73-3b7382a9f07b"
      ]
    },
    {
      "cluster_id": "6274b067-d713-4a61-a1f2-5f2f2d2df7fa",
      "members": [
        "8bbd3f20-f76e-47c4-a33b-75e14299d88c"
      ]
    },
    {
      "cluster_id": "ed2f46ec-4300-4232-969b-86017e6c6546",
      "members": [
        "b62e467a-7383-423e-b2db-36022673bd12"
      ]
    },
    {
      "cluster_id": "c9858cae-3215-44c8-9820-2f7cde47d95d",
      "members": [
        "3892000c-47aa-4755-8d1c-d759dcfcf658"
      ]
    },
    {
      "cluster_id": "9b0d2d04-ff3d-45df-af3c-018b55e1eabe",
      "members": [
        "2c900a2a-cb87-43f3-8e60-e63de79f3846"
      ]
    },
    {
      "cluster_id": "db5c7092-c228-4319-b130-e75471c29ec0",
      "members": [
        "fe4407e1-2c58-4a48-aac8-8738ca900cd7",
        "ded85493-80e4-4f5b-a532-744960395d4d",
        "c3b5f389-950a-448e-a93b-cbc1155537cf",
        "2ef0b41e-8e8f-49b8-9316-58dfe374c259"
      ]
    },
    {
      "cluster_id": "c7b0f267-0192-4ba8-86e6-09f6ba274d4f",
      "members": [
        "20fff54e-3944-4c7f-b960-6c30b9553484",
        "914a2057-3abf-4b5e-bf8d-7a86635735ff"
      ]
    },
    {
      "cluster_id": "0dc901d8-d48c-4458-a536-133dced8eb99",
      "members": [
        "22ec386d-2816-4822-8a28-ff0303dbb36e"
      ]
    },
    {
      "cluster_id": "a35296f0-09b1-4344-8dc2-fa3ee1b2f399",
      "members": [
        "ba0406c0-1eb5-47f0-8568-1e8cc3246f72"
      ]
    },
    {
      "cluster_id": "0afcbb16-75a7-45dc-9f96-97e351b50a83",
      "members": [
        "4064599a-92e3-4d1a-861d-e5dcc4543c95"
      ]
    },
    {
      "cluster_id": "c41e3b9a-0aaa-4ffd-84fa-92acc0346b56",
      "members": [
        "71b4d6aa-c10b-42c5-a855-7e4f76bf6279",
        "956b3170-294c-47bc-849e-3345201fda22",
        "b79c0518-028b-42b2-a7b8-55238d2da5d2",
        "675a521a-b49e-4a50-bd55-7b385ae2368f"
      ]
    },
    {
      "cluster_id": "b252b9c3-5126-48a5-aa3d-32d7e4a0465f",
      "members": [
        "eff487a7-144b-43ed-9bf7-a81b8eb300b4"
      ]
    },
    {
      "cluster_id": "75fbf587-2351-400e-b397-a778510d68fc",
      "members": [
        "862e5564-7ed4-4431-bc87-301f42a6f9ff"
      ]
    },
    {
      "cluster_id": "47b5a921-4ec9-4534-86e3-d697a2a00470",
      "members": [
        "cb7d24fb-92ea-453e-a2e7-23ee01a5bf14"
      ]
    },
    {
      "cluster_id": "00851827-de5d-4b35-bdc2-fc5215bce29f",
      "members": [
        "3bceb9ed-308a-4d20-9e15-e43ed722a41a"
      ]
    },
    {
      "cluster_id": "f5a61f8b-83ab-44ed-b769-3208e32281e7",
      "members": [
        "efc25508-34ea-4b2d-b056-e09159f5e65e"
      ]
    },
    {
      "cluster_id": "3d6b711d-93be-4839-8934-425368c03327",
      "members": [
        "8beb0182-4a6d-4773-bace-6843617f1729"
      ]
    },
    {
      "cluster_id": "80a8b2f6-3818-4f88-87e9-d88c26c8754c",
      "members": [
        "9a99a603-b48a-42f6-a5cd-97faca06e3f1"
      ]
    },
    {
      "cluster_id": "d96ea11e-5d88-4a27-8ab4-66bfb4326c28",
      "members": [
        "c1d329c8-b5d6-4cc7-a6da-b13d361d2b9e"
      ]
    },
    {
      "cluster_id": "e73d69fc-6584-4fb7-b72a-84be1893ea0f",
      "members": [
        "86a0d544-0af2-48a1-8dc5-6ce0fff5551a"
      ]
    },
    {
      "cluster_id": "ec98b249-f085-460b-ae00-454dc52d3f17",
      "members": [
        "34aecffc-bfee-4e91-b571-37c65138c110"
      ]
    },
    {
      "cluster_id": "41741032-ab51-407b-85f5-a7d6f97ca5b8",
      "members": [
        "913af525-e568-4c5b-8ce4-89da8089677f"
      ]
    },
    {
      "cluster_id": "331d66f6-8c23-4632-b4ad-7949a81b62cc",
      "members": [
        "9600bcc7-d0ab-41ed-9a55-cff1567158c4"
      ]
    },
    {
      "cluster_id": "f18619a4-4f58-4ae8-a9ef-fa5f0bef0daf",
      "members": [
        "e19958bb-c864-47ff-b697-31925e6f45d2"
      ]
    },
    {
      "cluster_id": "8eea3c6d-083a-481c-aa84-30005023f301",
      "members": [
        "034cc14d-278d-40c6-a14b-c9f85da480a8"
      ]
    },
    {
      "cluster_id": "c92bd461-8266-4e4d-aba8-e4cf7e3c1fed",
      "members": [
        "b7c9a674-5222-4e76-8357-23419815bd79"
      ]
    },
    {
      "cluster_id": "98ea14c4-be20-4ab3-b8a0-74207d1ea94c",
      "members": [
        "1a9cafe7-86d1-494b-902c-873da5aaca74"
      ]
    },
    {
      "cluster_id": "0e90187a-faaa-48f2-ae7a-c2764c47dffa",
      "members": [
        "5766004f-5539-4fec-8594-aff527a3c6f4"
      ]
    },
    {
      "cluster_id": "302853ec-6f10-46c6-b305-6047ac1af892",
      "members": [
        "aa4cef80-f44b-4276-b5a2-2b391127382e"
      ]
    },
    {
      "cluster_id": "ed2bff61-1872-4dec-a024-4d1c3d21cddc",
      "members": [
        "e20f2626-174f-48f4-bc51-5f4f6c668dfc"
      ]
    },
    {
      "cluster_id": "22db77fd-3772-400d-bc1d-2826b96b8d9c",
      "members": [
        "aed3a285-b1bb-472d-8c99-be38917e4ee1"
      ]
    },
    {
      "cluster_id": "00bd60e5-bf2a-4d15-8ed4-8906838875f9",
      "members": [
        "dc6d7b6a-8093-4315-aa36-84690a1ab200"
      ]
    },
    {
      "cluster_id": "e90ef9df-5189-4af1-8d38-f4bc22fa022a",
      "members": [
        "8e8c4b4f-9c03-46d7-8214-d6ddcd586c7f",
        "b1af2bea-91fd-482b-8051-a51dfdb38a21"
      ]
    },
    {
      "cluster_id": "f74c2283-95c8-409c-8db8-ce070f2c2a45",
      "members": [
        "cee5220d-75e6-40f4-8c6e-3dc54f0cc12a"
      ]
    },
    {
      "cluster_id": "94238db0-c74d-46ae-8d32-ad4eebd6753f",
      "members": [
        "12c8d553-539d-44a4-916a-2115adb302e3"
      ]
    },
    {
      "cluster_id": "61475130-6f49-487a-bec1-f17a9209af5f",
      "members": [
        "4dba2a71-3b72-4530-b7d1-3035aab05e0a"
      ]
    },
    {
      "cluster_id": "a1787db1-8710-47fc-b234-f265a8dd366e",
      "members": [
        "07570ec8-fe9e-44ab-a378-535f60a98aa8"
      ]
    },
    {
      "cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284",
      "members": [
        "340b926b-ada8-4988-88a9-06af47219f36",
        "9cf74e25-9924-4266-bdda-c3b792219632",
        "308b0fbb-cdf9-4b3e-bd75-a035c3989203",
        "38d6788e-799f-4d5d-8d97-1d8b7c99665b",
        "c2557ada-2ecf-4c1d-a428-6aa2952f7811",
        "c73b9e35-7577-42d5-87bc-e70a594c5ae6",
        "dbb3a021-512a-4c53-a16e-530b1fe8ca13",
        "f6142039-3fc7-4af3-a3a9-87d0c7da5003",
        "2a20c42f-31d4-49e4-9328-7b3282f6e95c"
      ]
    },
    {
      "cluster_id": "28019fcd-ae8c-42b5-8f8c-7fa226a5335a",
      "members": [
        "d2f49b39-a8ba-4bf0-a777-027f04ee78e2"
      ]
    },
    {
      "cluster_id": "2830c0e0-a35a-4015-a0c2-75079b518aa2",
      "members": [
        "61bd6e7e-caf9-4c9f-badc-e923a4398824"
      ]
    },
    {
      "cluster_id": "8bba2d5b-a20c-44b8-91e1-9dd72d1e1b07",
      "members": [
        "e680d741-d0d2-417c-a836-e077af2c5147"
      ]
    },
    {
      "cluster_id": "60930e0d-3823-4b8f-9390-0e719aa7b09e",
      "members": [
        "fdc6b92f-6215-4eca-b466-b494c9508aaa"
      ]
    },
    {
      "cluster_id": "ce87133c-df51-4ce0-8569-5d86ba96f3d3",
      "members": [
        "692464af-4268-4b2b-a4e8-89ceb16c5307"
      ]
    },
    {
      "cluster_id": "2be461a2-6406-4213-9577-fc7e617af34f",
      "members": [
        "f4fc46ca-6b73-4af0-94c4-688c0051de69"
      ]
    },
    {
      "cluster_id": "3c37960f-c2a7-40e7-ba67-6890fc5f05e4",
      "members": [
        "2fe63ed3-3ec1-4910-b184-b5af8e1eb5c1"
      ]
    },
    {
      "cluster_id": "81eafdea-26c8-4b44-b5c7-5cd6a9bfece5",
      "members": [
        "da14c251-f3e4-496c-aacf-4d16d5c0420b",
        "59d20052-ccf1-4c25-ad4f-5086069feef5"
      ]
    },
    {
      "cluster_id": "9854342f-dc2f-4d81-9468-1aeed5b01c1c",
      "members": [
        "d4af23d7-6dbe-4a13-92ea-f8860568b19c",
        "091f83e3-bba0-4e4a-bfca-8d8aa10aafa8",
        "ed9b7284-387d-4093-ba08-d501f3fb89ae",
        "3a5825b4-b7fe-443e-baed-008f74f91a28",
        "396176b5-f265-4891-be47-52b337eb773a"
      ]
    },
    {
      "cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23",
      "members": [
        "82baefd0-b223-41d2-a271-b477a89ee344",
        "f73f876c-af9b-44f5-a348-0937fa930305",
        "80eab4aa-e080-4ddb-a409-7928e2405d96",
        "39d81057-c893-47a6-afa4-6c36c27b7236",
        "8b689eb0-99c2-4b6b-bec0-a95434f5c6b5",
        "b09a9896-1292-49b9-9661-23c3fe0cec8f",
        "a6bb481b-95ed-4927-b068-02899e5acb8e",
        "305809ba-0615-43e6-9a5b-5171703b2b34",
        "f47e498b-8eae-45e5-8bec-baa76263240f"
      ]
    },
    {
      "cluster_id": "86a99b16-df58-43a2-b7eb-e1d03c6f6e5e",
      "members": [
        "7b26b50c-4dd1-4644-9689-84dd0433369d",
        "04c0c80a-9c9f-4838-807e-9a86f6df2526",
        "debe366f-8ffa-4a17-a0ef-0aee5ed2f924"
      ]
    },
    {
      "cluster_id": "a18f54d8-98f1-491a-9d47-c6333890fc51",
      "members": [
        "f9d77bc7-f0c8-4518-9725-14cf3100fc4d"
      ]
    },
    {
      "cluster_id": "325eb390-c83d-4040-b800-a93e29e11141",
      "members": [
        "5d30f3af-649e-4a09-9a10-e989577c7ade"
      ]
    },
    {
      "cluster_id": "7af9dd75-d833-4cd3-b3d8-08e6c743ac05",
      "members": [
        "5fee4a2d-aff8-4df9-be77-17e0c65b5b63"
      ]
    },
    {
      "cluster_id": "8bfff308-f565-423a-9de9-6f9eeebb617f",
      "members": [
        "86eb9930-5dc6-40af-b50a-ba48949c7f89"
      ]
    },
    {
      "cluster_id": "c695ae29-6241-4eba-94f9-8224687bf1a7",
      "members": [
        "0754569f-7dde-4001-b445-2b9905332dae"
      ]
    },
    {
      "cluster_id": "2bfb03ed-8bb2-476c-9ace-087ef4a35f09",
      "members": [
        "6ff36566-6826-4d97-b606-43ba3e46ea05"
      ]
    },
    {
      "cluster_id": "75a7abcd-ccae-4606-800a-89412da639cc",
      "members": [
        "f3807869-b8a5-43c8-97e0-aefd9201fe00",
        "00d72ee4-c25c-4509-ab7e-63cb9ee79800"
      ]
    },
    {
      "cluster_id": "782b5668-5ef8-4d83-a8fc-b6464fbee289",
      "members": [
        "093fa1c5-1ce1-4a27-8af8-eca7b7f8cbf7"
      ]
    },
    {
      "cluster_id": "ae81b069-06de-4c85-affc-804bac2e778d",
      "members": [
        "ca1da258-49e6-4a70-aeb5-e78a1b90c123",
        "ee196b61-e304-461e-a463-d5ae45a016a4"
      ]
    },
    {
      "cluster_id": "4a259022-df32-4e4f-a09e-afdcfddd1eae",
      "members": [
        "ec5286c0-072f-45c5-a076-4567fa7a532a"
      ]
    },
    {
      "cluster_id": "91e8fe58-f0fa-44e3-ae52-de74821a1034",
      "members": [
        "4f2cdb73-7039-40b5-a2f7-b262f95f8559",
        "6638cc19-c306-44fc-999e-34ecb6344f36"
      ]
    },
    {
      "cluster_id": "4c365f8e-324b-474b-8239-fe362d8fca1a",
      "members": [
        "ae65d107-6eb7-4313-9186-f3cbb1789d11"
      ]
    },
    {
      "cluster_id": "c62e089c-1780-440d-b990-8342bb6836f8",
      "members": [
        "91ccb453-5fb0-4cb4-bf34-baf2b1b34bf3"
      ]
    },
    {
      "cluster_id": "b8c71793-7735-4b85-ba5a-b3e53e437f73",
      "members": [
        "d652b088-92b8-43ab-9e9b-a599a32f964a"
      ]
    },
    {
      "cluster_id": "b4051cdc-a4f2-410e-b138-2b773f319a22",
      "members": [
        "528448a9-71b6-490f-bae3-1cfa996191c8"
      ]
    },
    {
      "cluster_id": "10df36b6-9ce0-4838-9b29-8a4b4c151281",
      "members": [
        "2fc47767-208d-4cf4-832f-59fb3b8e97d7"
      ]
    },
    {
      "cluster_id": "65583e7e-9600-4791-b957-579c81276f1b",
      "members": [
        "5068d9e5-ee6b-4935-b62c-464f72b9018d"
      ]
    },
    {
      "cluster_id": "89d55cf7-6d3f-4328-a78e-26c777948edb",
      "members": [
        "7bd320e5-c8a0-4493-b871-050f0d769f51"
      ]
    },
    {
      "cluster_id": "d0e8c17f-ac7a-4857-90ac-8a31224cb44f",
      "members": [
        "4e8f6b10-a2ac-44db-a4ca-fcdc8bd5de91"
      ]
    },
    {
      "cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5",
      "members": [
        "cef362d2-7e39-43ef-9824-cb10d85638c1",
        "b1f1eb74-be8d-45bb-b878-aeb4451b3315",
        "9d3d7a4c-8dfa-4061-8966-1c80e104d1dd",
        "e3b9f8a4-eb6a-484a-a53d-e57425a80639",
        "8713027e-2d87-46f0-8c1c-d199a2b4a510",
        "3ee5c31d-14a2-4f64-be3b-b972347128e3",
        "54d08603-b334-4505-85e4-2e560ce4f257",
        "e711ca11-d42c-45bf-9930-5701725b1316",
        "bd37a9b0-e07b-448c-bd28-89d7129c468b",
        "9520f831-fc95-4505-b1ef-f59d7c4babc9",
        "29cc9f60-6154-4ad6-93d1-6804d8134a36"
      ]
    },
    {
      "cluster_id": "bfb1dcef-eb53-42d3-9c74-0d949ffc43a7",
      "members": [
        "94535f85-af39-49e1-8579-790d85f2072c"
      ]
    },
    {
      "cluster_id": "af4322da-0cf9-4a56-9b07-d10c70b336a9",
      "members": [
        "53b4f370-ab1d-47ff-aa92-c4be63e52fc3"
      ]
    },
    {
      "cluster_id": "abbfb703-6da3-4a58-9c1e-a58cf34e5030",
      "members": [
        "8dd16a15-63da-4b55-ae8b-3840364bfdeb",
        "d4854f09-6b5d-45dd-ad64-57ee66a031ad"
      ]
    },
    {
      "cluster_id": "2ffd0f52-9465-49d4-9f47-900078ad3209",
      "members": [
        "e6f80efe-99ad-40fc-9b5e-7b0f5d024763"
      ]
    },
    {
      "cluster_id": "fc384be2-9fa7-4507-96ed-913cfeb3e5bf",
      "members": [
        "0dbcac4d-824a-48f8-8554-df0bd03f3ca6"
      ]
    },
    {
      "cluster_id": "8ea40711-b70a-408e-8b0e-c86a36b4d669",
      "members": [
        "b1fcfdf2-64b0-43ec-b1ba-68b56b3335db"
      ]
    },
    {
      "cluster_id": "16c38934-13c5-4d45-a617-8e2638f6597e",
      "members": [
        "73df9d94-7df5-47d9-85fc-37c3a2162b6b"
      ]
    },
    {
      "cluster_id": "e622291d-8809-42f1-9ac7-ff3aba01b794",
      "members": [
        "b9a38b44-ac73-4f47-83a9-657082aae0a0"
      ]
    },
    {
      "cluster_id": "3ff7a6c9-67a4-434c-ba42-8e735f72fd34",
      "members": [
        "91f8878d-9aaa-4359-94f3-12b9a5498f11"
      ]
    },
    {
      "cluster_id": "f81472fd-0486-49fc-92fd-9753ce76f44b",
      "members": [
        "159dcdc5-f266-45cf-a278-23a9f95d31a7"
      ]
    },
    {
      "cluster_id": "8c0047bf-e6f3-48a4-98c1-a7a466922ed8",
      "members": [
        "4effbcdb-9e1c-41c1-a3f1-2b6024fcf64e"
      ]
    },
    {
      "cluster_id": "94d7c196-e914-4792-9ae3-448475f12021",
      "members": [
        "ff2a10da-8e67-47af-b406-5835519d3357",
        "a6d12d64-4e35-421c-bef2-f601d348316c"
      ]
    },
    {
      "cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5",
      "members": [
        "f12a6b76-a059-4df6-ac6e-ae2b26ccc9e6",
        "80eab844-5ee7-4d91-b64d-53159cfca350",
        "4063fbc8-7b7d-4331-850a-655023233079",
        "3c13d2b5-6089-49e4-9322-256539a27b03",
        "e00d5c72-1582-479f-9bcc-d377cd91304b",
        "9f69dfad-b79e-4698-a00f-9c9919cf9cff",
        "cdcc4cb5-2bec-4805-9a7f-cd3173409efb",
        "ce8beb5a-1438-4adc-a947-a64fd2fb1c03",
        "4bf80e3a-27d8-464d-99d4-867b4ef33b10"
      ]
    },
    {
      "cluster_id": "b9cee305-a96d-440f-a08d-e2f6545e2608",
      "members": [
        "540e3ead-5b5a-466f-ba8a-dcbaf8fdd5fc"
      ]
    },
    {
      "cluster_id": "8a84554f-19d7-41fa-8647-c3608df3d4f1",
      "members": [
        "db3aa80f-6044-4a98-bad7-82c93249331c"
      ]
    },
    {
      "cluster_id": "bcbfb3b5-386e-4a9d-9149-63379d147048",
      "members": [
        "cd930d5e-8e35-4acf-bfc9-8cc6042ef7d1"
      ]
    },
    {
      "cluster_id": "9917626e-0afd-495f-82cd-6e27aa8cc73d",
      "members": [
        "dbff6aa5-b76f-470d-8bb3-87dc3497b774",
        "08a8e2ce-1c6e-4368-a829-680c4555465c"
      ]
    },
    {
      "cluster_id": "e56b6c3e-60ae-4144-ba92-480b792e396d",
      "members": [
        "92519052-196e-4492-808b-4c95581ebc32"
      ]
    },
    {
      "cluster_id": "09e091a4-d9df-4ce0-ab1e-d30b85568ee5",
      "members": [
        "13e91f18-b948-4979-90a2-5cefc638595b"
      ]
    },
    {
      "cluster_id": "8f6bcfb4-e69d-470b-bf79-44df803a0002",
      "members": [
        "a71ac078-651a-47fb-bbf7-bfd8e459584c",
        "cdcc6f3d-5b6c-4e81-9e04-05d8810ee886"
      ]
    },
    {
      "cluster_id": "13bcef3e-fd19-4989-b312-5873b1468a28",
      "members": [
        "8225f2b8-fa81-4508-9347-72e066b4edf5"
      ]
    },
    {
      "cluster_id": "f9c2516c-da15-44ca-94aa-e9d013d3a430",
      "members": [
        "749e270c-0df9-4de6-a9f0-b30fed003e8e",
        "8324920a-9890-442b-96d7-0dc92b7918e2"
      ]
    },
    {
      "cluster_id": "05b6cfa2-c45f-42a8-bb0c-d50df97483f9",
      "members": [
        "2a76e34b-09d2-4203-838a-c7a7f41d1fb3"
      ]
    },
    {
      "cluster_id": "54050443-7613-4bf2-affb-d73ac2c76683",
      "members": [
        "920f6e67-114e-40e7-b689-2c784158a87d"
      ]
    },
    {
      "cluster_id": "71cb88c3-3bc3-4a98-bd39-7a91efe626a8",
      "members": [
        "cf8f4415-e018-4f89-b75a-ff0806218bcf"
      ]
    },
    {
      "cluster_id": "32aeada3-2c0a-4dd6-b828-1733cea88e6b",
      "members": [
        "6bb0a5d1-8ecf-4b8d-a603-564da52db3ee",
        "10340ecb-3315-4a89-9a44-9c2bb1cf8484"
      ]
    },
    {
      "cluster_id": "919dc1e1-6cb7-4d54-aa99-504278bbf1f4",
      "members": [
        "934e714c-0c64-467c-9d29-ee93627e25cd"
      ]
    },
    {
      "cluster_id": "aa7dc853-a837-4fc7-af4d-cebbf4726b31",
      "members": [
        "2a957629-1994-4504-bd4e-5a500088abef",
        "aa56ac21-7511-471f-8f06-f604afabce09"
      ]
    },
    {
      "cluster_id": "e4d7e062-89f9-4cad-84e1-ea4d0fd566d5",
      "members": [
        "731ec64a-4fdb-477e-93d9-8d4ca3a8f3bd"
      ]
    },
    {
      "cluster_id": "089a2747-9d4d-40cb-b33d-a36918c7e7a4",
      "members": [
        "f42e9730-3a71-4a1b-890b-dc79bbe5e142"
      ]
    },
    {
      "cluster_id": "54fd48d0-d138-4133-9478-030523c0c632",
      "members": [
        "5d211f49-cdc5-4a7c-89e2-24c4fa6e3193"
      ]
    },
    {
      "cluster_id": "cf284659-5e8d-4417-9c7c-b41b8155ecf8",
      "members": [
        "0e4f9b6a-ce2a-40dc-91b6-b874ee651eda"
      ]
    },
    {
      "cluster_id": "5f74295c-f7d9-45d9-bee0-05eb4d5113bf",
      "members": [
        "db797985-3f3c-4e0c-86cf-ff34d2353f0d"
      ]
    },
    {
      "cluster_id": "b959db9a-a488-4838-97f9-4b51827755fb",
      "members": [
        "f9a5d31a-8263-45f1-b471-f0795fd547c4"
      ]
    },
    {
      "cluster_id": "13e53d6a-9b30-4b10-9f27-0687c15666b8",
      "members": [
        "ab3fb0e4-f741-4b2c-b3d2-bc1e0de90aaa"
      ]
    },
    {
      "cluster_id": "591d0c93-3cfa-4639-9dee-c69a3f6b0f9b",
      "members": [
        "c1b698fb-9634-4b3a-9c21-2a7cbeb5b38d"
      ]
    },
    {
      "cluster_id": "c25ff750-8a41-47e3-b517-245284092082",
      "members": [
        "a7315e32-6b37-48bb-bfc5-f72a2a24db1d"
      ]
    },
    {
      "cluster_id": "a144123b-7815-4a8e-939f-d8124e0d4a23",
      "members": [
        "c8179441-57a7-45a1-8f23-9c4a01396d6e"
      ]
    },
    {
      "cluster_id": "ba65859b-0b3d-4140-bf84-cf55b1252051",
      "members": [
        "db9eae80-bfc5-46f9-8c22-e744bf40dbc5"
      ]
    },
    {
      "cluster_id": "c1d9eed7-6c9d-4c45-a896-47b8c389cf48",
      "members": [
        "f195824e-e406-4010-8b24-ab80840f08bc",
        "d681260c-e06e-4422-826a-30eb58a9eeae"
      ]
    },
    {
      "cluster_id": "e64ee1a2-9226-4d61-b0d3-bf9e52dc9982",
      "members": [
        "689326b1-b3d5-4344-9142-6513e77f8e88",
        "10d9dcb1-82e1-4045-acca-984f4a4e6b55",
        "7075c1bb-4e96-4d35-9f62-d6e8832d3809",
        "6dd190ff-6495-464b-9ba5-23b2d0f6fd1b"
      ]
    },
    {
      "cluster_id": "c39ad689-c540-4985-928b-b1a54e619b06",
      "members": [
        "d8bdd26f-c6d5-4c04-86db-c78c94c932de"
      ]
    },
    {
      "cluster_id": "3e760dc6-7f77-441d-bf0b-d687031ab57a",
      "members": [
        "54aba49f-e63c-4131-b8e3-5be975c2c899"
      ]
    },
    {
      "cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171",
      "members": [
        "b9059891-c143-4807-aba9-bde4721cb9dd",
        "af00b07a-963b-4f13-a913-e5d137abd6bf",
        "48871f40-b374-43ad-acd0-10030f089443",
        "285be22e-0747-41c0-b4f1-f4dadc6756a1",
        "e24b553c-a7d4-4b94-bad9-2938a45a2352",
        "e31cb900-b1ee-4f20-b242-745cf43b93f5",
        "8f8bd225-18e7-459d-8caa-6c1a605d96e0",
        "d3789df5-39f9-4f88-9edf-85bf0035efc4",
        "839b62b4-9b33-4648-88dd-6cc8e85f656f"
      ]
    },
    {
      "cluster_id": "93707dc5-36b1-4b18-b721-a98eb38368ea",
      "members": [
        "2cd3f4ad-58ef-4698-a39f-3378d8ff0c5f",
        "b8460d5b-4ae0-43bc-b8e6-8920c60104dd"
      ]
    },
    {
      "cluster_id": "9fa5ddc6-feca-4449-90da-8b78638fa3ce",
      "members": [
        "5b52b8cf-5ace-4757-ae69-7a7fe7c09434"
      ]
    },
    {
      "cluster_id": "edc6ba48-0632-4236-9c24-f67f26e9b96b",
      "members": [
        "592787a6-94e6-48f7-b5a6-5665f686b8c9"
      ]
    },
    {
      "cluster_id": "6a14502a-8c63-426b-8062-c7e8472786ee",
      "members": [
        "70da14db-5840-44ae-aa98-53daa8ed6bd0"
      ]
    },
    {
      "cluster_id": "21d331a6-d043-465d-88ff-572098f9f48c",
      "members": [
        "b299d081-9429-4b11-8274-4a51e14cc166"
      ]
    },
    {
      "cluster_id": "7fb1639d-6541-40a5-8cc7-71943288089e",
      "members": [
        "fb9408d6-c971-413b-9cea-2e3322ba3162"
      ]
    },
    {
      "cluster_id": "a1f32f8a-32f7-4bba-b1fe-edc8382be9e5",
      "members": [
        "0f2abd3b-64fd-49f3-971c-a1db3e57aff2"
      ]
    },
    {
      "cluster_id": "8476cb8d-5c1a-489b-ac54-9099d01657db",
      "members": [
        "2b87a490-d010-4798-81c2-a3a0ed1d0082"
      ]
    },
    {
      "cluster_id": "418a7cf7-657b-41b9-9359-c34faf7618d7",
      "members": [
        "7c5374ae-854b-4158-b038-318ea55733d4"
      ]
    },
    {
      "cluster_id": "08ecb39e-a545-45c3-b7b6-8257d44a3e9f",
      "members": [
        "456f56c3-aabe-494a-a25d-6540a141d9e6"
      ]
    },
    {
      "cluster_id": "70bd9665-a0ef-44fe-b03d-553c56604080",
      "members": [
        "7d6bd4a6-d05d-4b18-9955-b9692cd59be3"
      ]
    },
    {
      "cluster_id": "9851f4a3-d2c8-418c-ab69-0b58a9726253",
      "members": [
        "a8e9a4dc-4d6f-418d-99ac-ea623698886a"
      ]
    },
    {
      "cluster_id": "a5ca0f47-c2ad-4e2d-8414-673ee9a9e57d",
      "members": [
        "205dcff4-c5bc-47d7-ae42-47b01da83046"
      ]
    },
    {
      "cluster_id": "504b2533-2c70-438a-a457-80634e246dfa",
      "members": [
        "931abfca-db8c-4718-812b-de8adb5d675e"
      ]
    },
    {
      "cluster_id": "d114caf2-8385-480a-a600-9c4b33ae3a55",
      "members": [
        "a0cb6afb-ecd3-4526-bc22-bb8bfbd5027e"
      ]
    },
    {
      "cluster_id": "3abfdae0-5ae4-404e-b93b-1d664986555b",
      "members": [
        "2132ccf9-08cb-4938-900f-a1a294b77a36"
      ]
    },
    {
      "cluster_id": "f35fd313-149c-4568-ab38-fa2d1f029e32",
      "members": [
        "bb028d86-d744-4c84-a61a-3a184bc6c646"
      ]
    },
    {
      "cluster_id": "a1ec3b11-8549-44c4-b19b-7113d02a1c7e",
      "members": [
        "d9f3e7a5-3ac7-4ff9-b5c7-57d45587e0e6"
      ]
    },
    {
      "cluster_id": "e4af0ca6-d383-4356-85a7-09352d68c2e9",
      "members": [
        "cb829a74-e67a-471c-8f59-96b7c970d052"
      ]
    },
    {
      "cluster_id": "af431814-360b-4c41-83d1-6147d4068846",
      "members": [
        "f2266466-c679-495d-aa32-a1547dd029f0",
        "13fcbb30-b184-4dd0-ad67-687bb5a32710",
        "5284affc-9a33-44ef-a031-0b316285fc1b",
        "a889b71b-e769-4400-9de4-484e46923b84"
      ]
    },
    {
      "cluster_id": "2bfeada4-b9e0-40b4-9be2-0655b8d49226",
      "members": [
        "5e58b411-987e-43e6-b1c4-5e9565e9bbc9",
        "253a86f7-a466-4e40-9e0f-eedd68395199",
        "67dff1f5-a16f-4d8a-8246-08683f4356dd"
      ]
    },
    {
      "cluster_id": "72fcc1d4-63ac-46e2-af29-194e69352aec",
      "members": [
        "dccc509d-c576-4034-9361-2b1eb47591e5",
        "6f78ac5b-4203-4c69-a66e-58f34b29e192",
        "499c415d-6d0e-405a-92ea-56852a59047b",
        "7f2f55cc-063d-4542-a910-41b5995a8b43",
        "7c2c28be-6cfa-4db3-8b1e-6de54c0cc24d"
      ]
    },
    {
      "cluster_id": "7c1fc423-517b-4edd-ab51-ee1fbb6a01c1",
      "members": [
        "ab3f8106-b455-47de-9e0e-3c1b0ffb094c",
        "bf525db6-d0fe-4882-9a12-8adcd84a4fd8",
        "f4a93dcf-0bdd-4552-a02e-60e6535b598d"
      ]
    },
    {
      "cluster_id": "f3e2df1f-8b35-4bab-b9e2-e82dc9f0ea1f",
      "members": [
        "f0f810a4-4ff6-4c29-a46f-40740a2f111c"
      ]
    },
    {
      "cluster_id": "fec224cb-9f4c-46ad-af9f-03437451a2c2",
      "members": [
        "fc1eae68-c39e-41f7-8a4f-bf75fe7b9265"
      ]
    },
    {
      "cluster_id": "e53b1b9b-ff90-4db8-bc8b-211c3b969cce",
      "members": [
        "6fda58f9-892b-49db-a478-679621b09c8f"
      ]
    },
    {
      "cluster_id": "a316c368-440e-4c3f-a293-cbd2c8138a8e",
      "members": [
        "8cff213e-b552-46a4-b12e-65b8aca843fc"
      ]
    },
    {
      "cluster_id": "009689fa-763a-4351-a069-4f29c46a8fcf",
      "members": [
        "bafafe5d-7c33-4700-a0e8-fbe832774ef8",
        "c379708e-1d1f-4214-910d-94840f38fee8"
      ]
    },
    {
      "cluster_id": "0affa6f2-96b0-46b9-acf1-01957217922b",
      "members": [
        "94f93f21-b399-43b6-8c1a-6dc7c2680520"
      ]
    },
    {
      "cluster_id": "dbcfd453-3fcc-4846-b99a-9b5de23fde7a",
      "members": [
        "30ee29c0-7572-4257-944c-bfea6990238a"
      ]
    },
    {
      "cluster_id": "f83e82a8-4441-4c96-b8ec-2b50e32532d9",
      "members": [
        "a949eb99-fee2-42fb-92cc-5ed10da638c8"
      ]
    },
    {
      "cluster_id": "17a371ed-b42f-4523-bba1-0b6b3e65c57e",
      "members": [
        "f030637b-114d-4e7f-8d7c-eeda43cd9190"
      ]
    },
    {
      "cluster_id": "64b86b07-89a1-4ba2-8492-bdd7801a5bbe",
      "members": [
        "e933f4d1-5305-4d96-b283-b161bb49c5d7"
      ]
    },
    {
      "cluster_id": "4b43ecc5-2325-49de-80fb-8c71f498b44d",
      "members": [
        "c4e240db-18a0-4924-a3d5-b007ef851e0e"
      ]
    },
    {
      "cluster_id": "902e4c1f-ffd6-4a43-b284-14e627b17668",
      "members": [
        "75b5e2b4-7f78-40b0-a89e-76e5a55f40ce"
      ]
    },
    {
      "cluster_id": "f7ebd749-2aba-4604-bcc7-3f28208b0612",
      "members": [
        "53bc33f3-da8b-439e-bb2e-1ac545b26a3d"
      ]
    },
    {
      "cluster_id": "b68b2c64-2b71-44ac-a7b3-c79fe12186bd",
      "members": [
        "d3c3e61d-d06e-4ee5-8174-28cc6ad30648",
        "0316ccf9-6f70-4db7-8f6b-5b8c19d9d765"
      ]
    },
    {
      "cluster_id": "0dd8b4fd-5bcd-4d2e-97ef-0ae1371a8f17",
      "members": [
        "ba9e2600-a590-4127-970b-4e2742cad854"
      ]
    },
    {
      "cluster_id": "3f7ede9c-8bb9-4467-8e40-0d78aa0f2a1a",
      "members": [
        "611fc9fc-abfb-489f-b812-71a34196257e"
      ]
    },
    {
      "cluster_id": "47cf0031-f643-4c3b-859a-e03a6b23d6e9",
      "members": [
        "62e9127a-fd2c-4286-9575-6887ef9060fa"
      ]
    },
    {
      "cluster_id": "cb297a6d-5ff4-4958-bec0-67e510f9e369",
      "members": [
        "18cefcf3-97f2-452a-a1b1-b8e4c67b206f"
      ]
    },
    {
      "cluster_id": "5cd2aca7-8312-405f-b073-d87b70cdcee0",
      "members": [
        "481d2f1a-071d-4f18-934e-8f3340af485e"
      ]
    },
    {
      "cluster_id": "586b0585-af30-4d40-9796-01be4c00d08c",
      "members": [
        "8e764b53-09e5-435a-b7e0-d11593a27175"
      ]
    },
    {
      "cluster_id": "a815c927-5e75-49a5-ad08-40e7381924c6",
      "members": [
        "ce7c040d-9c54-4fb8-a121-f8cbd3b50719"
      ]
    },
    {
      "cluster_id": "a1395f05-6f91-4eca-a911-53f15292db71",
      "members": [
        "483c9e14-f9bc-41de-aa9d-b4464edf1721",
        "ba84c644-7454-4df8-8b26-8847ed80bb8f"
      ]
    },
    {
      "cluster_id": "3d95e05f-6c78-4338-9960-bbc4049a682e",
      "members": [
        "c49b0cf9-c099-42be-a7d5-d56311c0726b"
      ]
    },
    {
      "cluster_id": "3277c81f-d2ed-42ea-acc4-bb977e68f163",
      "members": [
        "7b5c612b-1d79-44c2-8593-f25282ac9b20",
        "1827b39d-2e75-4c43-b9b5-819bcccd1336",
        "af79e1ac-966c-4bef-a69b-9adc9093c1eb",
        "c38dd94a-ab02-4ef1-bb83-5b2fcecec724",
        "2bc4fa4e-55eb-4fa9-9fb1-9fc1dd0ed0db"
      ]
    },
    {
      "cluster_id": "be74618d-f629-43fe-be50-6fcf737dd820",
      "members": [
        "91047411-6884-495a-b270-1c812c9a5302"
      ]
    },
    {
      "cluster_id": "b91a4bd2-e629-472a-9c82-852acf9ccef7",
      "members": [
        "59724a0a-a7ec-49be-a9c7-5332610aa537"
      ]
    },
    {
      "cluster_id": "c52411eb-2b24-4b6d-9936-f82ca57ebb56",
      "members": [
        "a14530b8-0fc3-49af-a1c6-562df417f2f7"
      ]
    },
    {
      "cluster_id": "d310e1f7-ee8b-4fed-be89-8b1baac91b0a",
      "members": [
        "dab32f1e-f3ae-4d6e-bf38-c9ee4ac23cbb"
      ]
    },
    {
      "cluster_id": "d878f267-808b-4a23-9202-10d08ee3053d",
      "members": [
        "b23bc7bc-98f0-4012-b0f6-192ac391443e",
        "f9c60b69-b6de-4c88-91b4-2f9ca3baf7b6",
        "2bd643ab-04dd-42d8-8b9c-f459af0c1d6c",
        "5fdb36f1-22ad-46b1-9e69-2e4bfe4e544e"
      ]
    },
    {
      "cluster_id": "7590439d-277c-48b6-9bb4-812f83d4e421",
      "members": [
        "9efbffa2-9434-46b3-9ebb-519b727679f8"
      ]
    },
    {
      "cluster_id": "784c345c-143d-4aef-b094-6eba2f83003c",
      "members": [
        "f7b613a9-3314-4b9d-bffb-61b6124d76de"
      ]
    },
    {
      "cluster_id": "5549ed3d-7dea-4eb0-ad38-1dd76c667c0c",
      "members": [
        "20496504-fba2-4e08-90ea-6babbc089958",
        "1535b092-2f4c-46b3-a6aa-0f47acfce530"
      ]
    },
    {
      "cluster_id": "b38c1227-31d6-4991-a4c5-01c6af14c400",
      "members": [
        "876a5840-d36d-4596-9666-20f3ceda7779"
      ]
    },
    {
      "cluster_id": "60cb910a-8631-4e58-9913-f906c1b2084a",
      "members": [
        "e2622e7f-1580-44d4-8057-8538c9966ca1"
      ]
    },
    {
      "cluster_id": "07499aa1-3238-4e4d-b838-020f0a58eb63",
      "members": [
        "c8939582-76cc-4531-8547-139a15ded32e"
      ]
    },
    {
      "cluster_id": "afed780e-77ff-46bf-ac41-4e66698ad45e",
      "members": [
        "3357401c-35a7-476f-876d-c29a22cabc32"
      ]
    },
    {
      "cluster_id": "7f5ce29d-718d-42a9-af2b-7bbc25320894",
      "members": [
        "13aac186-d0ed-4535-a881-a5a4bdb87364",
        "18935a3f-99e7-4246-b12b-b70d0518ae60",
        "5aac0275-2df4-4079-9a43-f4d551720f5a"
      ]
    },
    {
      "cluster_id": "d673001c-8f3c-4ad3-bd60-90a9445c79f6",
      "members": [
        "eef92b74-64d9-4527-9f75-e23c22ad00fa"
      ]
    },
    {
      "cluster_id": "df30b460-1ef4-4fe2-86e2-8192bfc9613d",
      "members": [
        "92b0013d-9c76-4791-ab68-c99ebaca5af7"
      ]
    },
    {
      "cluster_id": "6ad5e833-9ccd-4680-8847-382fff58f760",
      "members": [
        "78685855-268d-4cac-9e6c-75f169f87513"
      ]
    },
    {
      "cluster_id": "f8408d7a-6690-478f-a0da-8baa781f898e",
      "members": [
        "1b08795f-959a-412e-8533-9faf731604db",
        "a1e1ffbe-a8e0-47f4-a01c-cd3b536c3a39"
      ]
    },
    {
      "cluster_id": "fd6cf91a-5408-4a49-8b88-6ba66a82f0e7",
      "members": [
        "c7744804-cada-43bd-b31f-a98632fd26fd"
      ]
    },
    {
      "cluster_id": "50f3c500-b81e-4af2-91c4-9121494d6350",
      "members": [
        "9f157653-aafb-41ef-9fc9-da58bf871755"
      ]
    },
    {
      "cluster_id": "a954b16a-c601-4ed1-9990-0dca57e0a58e",
      "members": [
        "ee9c48df-0509-454e-a426-03f65a311a72"
      ]
    },
    {
      "cluster_id": "6e37e2a5-095e-47b2-8aff-f3c2136725ea",
      "members": [
        "131b3f67-cd28-4304-8493-4ef0d561ddb2"
      ]
    },
    {
      "cluster_id": "10b1c2ee-a471-4366-9850-b2056c01cf79",
      "members": [
        "ac9e4919-d616-446a-981f-359a36e898e2",
        "06e389e5-f96e-4d33-9f6e-1932526e6f19"
      ]
    },
    {
      "cluster_id": "65229c4d-fc92-48aa-bd10-466bee027dfd",
      "members": [
        "8e4ecb78-2cd5-4a31-831c-4bee4f699ca2"
      ]
    },
    {
      "cluster_id": "ec10f62c-ce71-4a79-9f7e-b5ddfb366f3a",
      "members": [
        "a84eaee9-201f-4d8d-b27b-768be7e814c1"
      ]
    },
    {
      "cluster_id": "094c5f6c-8f77-4ae5-86e6-0f169bca56ea",
      "members": [
        "eb3b9426-ad3d-4fc4-83c1-c97df52a6830"
      ]
    },
    {
      "cluster_id": "b794c66a-ad77-44ca-8ddd-457a68feb34b",
      "members": [
        "7daabd93-b1c9-4167-adee-62a5a406806b"
      ]
    },
    {
      "cluster_id": "0ab76786-184f-4825-8328-205b8055cb1c",
      "members": [
        "616f6f68-f401-4fa0-ba4c-64cdc24121d9",
        "e9510a84-35a9-4de4-9ad9-e222d2348cab"
      ]
    },
    {
      "cluster_id": "08d9382c-bb74-4062-afa8-3c8c1526980f",
      "members": [
        "aa6dd177-a776-4665-ab7b-bffc42996a33"
      ]
    },
    {
      "cluster_id": "c408b7c7-ef12-40e9-99e7-96b3a920e45e",
      "members": [
        "6df8661c-1208-4a7a-b84f-dad337aa9a8a"
      ]
    },
    {
      "cluster_id": "db9b2b11-8206-4448-bceb-8073d0878c9a",
      "members": [
        "38532f76-a8d3-4a92-8e5c-2b120ab21c7f"
      ]
    },
    {
      "cluster_id": "39f8cdcf-5b14-42ea-aeb8-d3dfeff54bca",
      "members": [
        "cc44ee2c-d62e-4d43-aeed-cca51553bc91"
      ]
    },
    {
      "cluster_id": "4c79fc69-3bd0-4180-9718-8d85b8c9dd85",
      "members": [
        "c046013e-6009-405f-89b8-ca146753bde5",
        "1363095c-21ad-4ef8-8981-9d3e06617cf7",
        "feee77bd-03c4-4b90-8356-f40b90706c1d",
        "dae23334-c486-4c05-99f8-ba15b075567e"
      ]
    },
    {
      "cluster_id": "682ed3da-b434-4c8b-a46d-5ea8bffc9576",
      "members": [
        "4a16ebcb-82bf-4c8d-ad7e-466d21217073"
      ]
    },
    {
      "cluster_id": "44c28ee3-0ffe-43a2-9aa6-1d7ed2463da1",
      "members": [
        "0b4bccd2-1a09-4415-8393-a00d8b01963f"
      ]
    },
    {
      "cluster_id": "181f2787-76c0-40c9-96f6-869aa09e8172",
      "members": [
        "74c4307b-5e3b-4b5c-b655-6114d055f24f"
      ]
    },
    {
      "cluster_id": "f3b3b03f-2658-4df1-9b64-e36964888fbf",
      "members": [
        "81ab6954-cd5d-4243-bfa3-685098227060"
      ]
    },
    {
      "cluster_id": "cf1d89e9-6fd3-4042-9407-6a77d0635415",
      "members": [
        "2687e56a-7e91-4a01-b7b0-a9f5e4f13ff1"
      ]
    },
    {
      "cluster_id": "2c24d987-e81b-4cb7-a369-7fc133161292",
      "members": [
        "5cd35820-333e-448b-96e2-788eb0f2bb91"
      ]
    },
    {
      "cluster_id": "4cf07546-b901-4002-a89e-1a6f0ae3d9e6",
      "members": [
        "478e87c3-687c-4384-9639-d343f99a2cde",
        "512e237d-55d7-490d-85d4-0108fd54bbe8",
        "b4f143e6-4e35-4c18-a988-79f21ab9c179"
      ]
    },
    {
      "cluster_id": "158823d9-8d73-406f-963c-db32a179210b",
      "members": [
        "eb0e4b07-531d-4804-9b48-c48258c4b257"
      ]
    },
    {
      "cluster_id": "5674d01b-2996-4ed7-850d-de449d707ce5",
      "members": [
        "5f68ea44-90f4-4964-bd73-81d69fe6d6a6",
        "12281cc7-1e7f-4156-9f27-30ed66ab507f",
        "b5755505-20fd-4cdd-be8a-c385417ab02f",
        "06b23df9-0ca4-4b22-9144-0b8fe4c6cc7b",
        "0f058be5-6f03-44df-9cc2-ebdfb8ab7143"
      ]
    },
    {
      "cluster_id": "86d86a3a-37c2-4eef-9deb-93d9580b80d1",
      "members": [
        "84e4c275-2cb8-4157-8584-96786b1e11be"
      ]
    },
    {
      "cluster_id": "9e7833e1-081b-4955-a649-df85a3c6a9e3",
      "members": [
        "6547f701-a4f0-411c-97d2-1f949e69d53f"
      ]
    },
    {
      "cluster_id": "b8e15d0d-b6bd-4105-9d0d-28c9c1a8c47e",
      "members": [
        "63e9a4ea-23b5-4a68-9930-207afc06a78c"
      ]
    },
    {
      "cluster_id": "f0d87010-6047-4ec3-814a-b7e1d93689ac",
      "members": [
        "33407265-94ba-4284-9925-81dd4a2ca2bb"
      ]
    },
    {
      "cluster_id": "e0f4c0a7-03fa-4df4-af40-cde3c562aff7",
      "members": [
        "7743b8b3-8dac-4152-83ce-f43c0bee9d9e"
      ]
    },
    {
      "cluster_id": "700f9b04-7504-490a-bc2b-7cf163528607",
      "members": [
        "89248d71-ce8a-41e3-a22a-a2345dffdfd7"
      ]
    },
    {
      "cluster_id": "30eca979-1f98-4971-a1fe-07481584311b",
      "members": [
        "8755ba75-eaca-4e19-8dea-ce787a5efa22"
      ]
    },
    {
      "cluster_id": "c55f11e7-306a-41b0-af0e-b025ab77a3ea",
      "members": [
        "e575aa8e-464e-489b-a664-70ab7a7cb07b"
      ]
    },
    {
      "cluster_id": "3f3f44f3-8e86-41c0-a601-c57bd1d46cd6",
      "members": [
        "fac83173-c379-427e-9657-21a1713d394c"
      ]
    },
    {
      "cluster_id": "41c879a5-6679-4fd4-9549-bf3854b37d7c",
      "members": [
        "fcedaa29-9c12-4801-a93f-2d25b4768c4a"
      ]
    },
    {
      "cluster_id": "3af4feb3-44a5-438e-9179-8a6158407f03",
      "members": [
        "c89ccfae-db15-4f80-8115-7a03e8dcad52"
      ]
    },
    {
      "cluster_id": "c9427285-3555-4de5-97c9-22592d01516f",
      "members": [
        "2de0391a-c6d2-4cd6-b820-9d688b482963"
      ]
    },
    {
      "cluster_id": "f1cd2dd5-074a-4fc6-a7c3-71a678833a3f",
      "members": [
        "8f534fd9-f814-4641-87a9-04a1426c7613"
      ]
    },
    {
      "cluster_id": "b9d8d6cf-41c1-428e-84c8-7e7e2b40a710",
      "members": [
        "07d2b96c-e7dd-497a-813c-527a2060559d"
      ]
    },
    {
      "cluster_id": "f0bf93b5-3fae-4f3e-8e8b-13d89108a924",
      "members": [
        "b4a2e5f1-2540-46d3-81e4-e2e544763ab8"
      ]
    },
    {
      "cluster_id": "03cfca2c-7423-4384-8df2-7f88d1994030",
      "members": [
        "98b2aff6-bca3-44a3-ba54-b68ffbd832d6"
      ]
    },
    {
      "cluster_id": "72702a81-27ae-49f8-9ece-b45b8795d927",
      "members": [
        "151711bb-8755-4a67-aa98-e1adeb5c92d1"
      ]
    },
    {
      "cluster_id": "6bd47b8f-99ce-47e4-9910-46d2ae0dd574",
      "members": [
        "a91f3488-dbae-4651-a7a1-71416fa1d8ae"
      ]
    },
    {
      "cluster_id": "b64296b1-758d-4594-84fb-3ffa5aaa094b",
      "members": [
        "e95e2c86-5cf5-4e2f-bfd1-8ab731e857eb"
      ]
    },
    {
      "cluster_id": "19904647-b456-48f0-bdd3-4c7803aa2b21",
      "members": [
        "360a8c46-e6d8-492e-bde7-3bdf7f02b104"
      ]
    },
    {
      "cluster_id": "68a2ab6a-28c5-4be5-96a5-2cd28d07739e",
      "members": [
        "dc57462e-f58d-4301-8a18-8ecc5bebc69b"
      ]
    },
    {
      "cluster_id": "4fc8d532-69fa-40fd-b28d-a301335dc7b8",
      "members": [
        "cdd0c405-98b0-49db-8ea9-8ac94256b27a"
      ]
    },
    {
      "cluster_id": "f58ab9e3-79cd-49da-af02-2a9f2fdeec8f",
      "members": [
        "f944ae1d-075d-498b-a803-1f145d06cde3"
      ]
    },
    {
      "cluster_id": "9a157342-1d61-41a4-92fb-020ea95697bc",
      "members": [
        "6da8b312-412e-41b5-97c2-320220ed5504",
        "2b4a71c2-c0a0-495b-b631-8f80095ab4f1"
      ]
    },
    {
      "cluster_id": "0dc0d897-2bc8-412a-af86-95eb382d392e",
      "members": [
        "3e0cb12c-8fa8-4bc3-bd34-b35b74430180"
      ]
    },
    {
      "cluster_id": "fbf4f33e-0e24-406c-8b43-497c4ae8f7fe",
      "members": [
        "1d902c0e-3b2f-4211-b144-2c47a1918793"
      ]
    },
    {
      "cluster_id": "294c224e-4fa2-412c-a08d-02a89eff2a7b",
      "members": [
        "95fbc391-139d-4b74-bab7-54c98c57a2bb"
      ]
    },
    {
      "cluster_id": "4e04a5f7-5879-4461-9d2b-d653343b9dbe",
      "members": [
        "fe81f0df-bad3-45f2-9a1f-c50df83a836d"
      ]
    },
    {
      "cluster_id": "e20b024a-3a40-46e1-bbc5-e9607839e91f",
      "members": [
        "50e1baad-2edc-4b4e-b3ed-7433803a9740"
      ]
    },
    {
      "cluster_id": "f9662a45-5f67-4be4-be6c-47e92690c44c",
      "members": [
        "f7820ae8-03eb-4cdb-a315-b5574a7284d1"
      ]
    },
    {
      "cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec",
      "members": [
        "7907f512-3891-422c-b167-7a2ec07a79e3",
        "850ae654-2d8d-49c3-9520-1138ba8eb41b",
        "a5e721d6-d4b5-4676-b0ef-6635440090c5",
        "d546313d-55a7-4c55-8727-d1442d5d9758",
        "44fb80fa-2bf5-4161-ba19-539be4b7a8f8",
        "7ffc3f24-8a49-4463-b575-ccabf41b348b",
        "a0cfeb9e-171f-4591-87c1-7f275bfea3da",
        "c11336cd-72ab-4022-9eb7-8330b56c200a"
      ]
    },
    {
      "cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417",
      "members": [
        "f1b90ad2-9e41-47ed-b4e8-1c3eaa4a8111",
        "309aaf99-7ac7-4ac2-abed-8aeacdbab127",
        "b07f9e83-4828-4d6c-9655-aaf9e032b958",
        "f422c635-230d-4085-894e-77e4bc8d2a2b",
        "08aed31c-7eb9-4c4a-8202-846ae0d621e7",
        "c21d0dbb-a95b-4ceb-a71e-8fc3df881d95",
        "7ee48907-cc9c-43c9-ad87-8a0e9940923d",
        "86e752df-f478-4714-b1d7-0b9fd5e2c12a"
      ]
    },
    {
      "cluster_id": "cef4b627-4828-4a00-9a55-7f92b9804c1f",
      "members": [
        "b8afc355-0d3b-4b78-8e52-f51a350d83ea",
        "35802410-2120-432e-a966-e73755191cc3",
        "bd2e82a8-49f0-40e5-96fc-8ea991ee5507",
        "4df60cd2-ed44-49d4-af98-a38d8a7f2b7d"
      ]
    },
    {
      "cluster_id": "a1887544-121f-4fbc-b25f-d4561dfb5e4b",
      "members": [
        "126eae67-4a76-4364-a533-375bb10f6c72"
      ]
    },
    {
      "cluster_id": "39687812-944b-4418-ada5-3588be43da66",
      "members": [
        "cc4501fc-11d1-4e7b-8e44-ddd88a405d9b"
      ]
    },
    {
      "cluster_id": "37dc3c46-39b6-4d4e-87ad-59040db4662a",
      "members": [
        "11d3f25f-6719-4690-b5d7-c65950aaecf4",
        "84546613-04c9-4ea6-a46a-04af0d15ed76"
      ]
    },
    {
      "cluster_id": "abe67163-2626-42e7-98cb-6e8083622029",
      "members": [
        "b9fee561-458c-4021-a790-653c39480351"
      ]
    },
    {
      "cluster_id": "a4a343c3-6168-45dd-bb83-595e1841921d",
      "members": [
        "6849dfaf-8ca2-4b18-b601-9eef2c9e238c"
      ]
    },
    {
      "cluster_id": "f520db2e-ca68-4285-80b9-7e45d3506ad3",
      "members": [
        "05ddcda8-e6d3-43d8-a4ce-1356f99b3ed6"
      ]
    },
    {
      "cluster_id": "2e1de1f1-7494-4d78-994d-deb9c207c005",
      "members": [
        "fccab78a-fa33-4db4-bb24-62e5e2a113ae"
      ]
    },
    {
      "cluster_id": "9e059116-3c55-48ed-9078-1c003c9ab524",
      "members": [
        "7966b150-ab5e-430d-8dd8-0b6cc2a52590"
      ]
    },
    {
      "cluster_id": "a8453d8d-d762-45e8-9fae-f6302e301be0",
      "members": [
        "9b43e23d-6e67-4a55-bff8-88a4dd7e0222"
      ]
    },
    {
      "cluster_id": "27baa662-c27a-403b-9e47-b67e42c90e29",
      "members": [
        "e4e9833d-2b95-431e-bd45-33d54b1159b5"
      ]
    },
    {
      "cluster_id": "d6ce2176-c8b1-49b2-89e4-f0620f06cb63",
      "members": [
        "4fd5cba6-5ef8-4f7e-88a7-cc0e21801f03",
        "bf4d637a-e05a-4d3e-a455-88cdf3508e2c",
        "38caa6b6-11c3-40cb-9ff0-a181a610eb4e",
        "a6b3be4f-41ad-4a8b-9d1a-da03c46f9462",
        "b5d18da2-37ec-43db-9cf5-11a16315155a"
      ]
    },
    {
      "cluster_id": "a3a7d7be-57b8-4862-a94f-547066bc6b8d",
      "members": [
        "b3905ba9-04c9-4087-abe7-fae021d91781"
      ]
    },
    {
      "cluster_id": "7aa12e18-818d-4e83-947b-42a4e69ce8db",
      "members": [
        "85c23183-95b6-47bf-8162-cf1d77e20f54"
      ]
    },
    {
      "cluster_id": "285237c2-514b-4d74-ada7-2be4ad6a801e",
      "members": [
        "12db9005-ba29-49f1-9b27-a3b203a2b06b"
      ]
    },
    {
      "cluster_id": "7b48e171-a32e-4aa5-90bf-b37f44678964",
      "members": [
        "9aacb493-235e-4c62-985a-961ed8ee8fa6",
        "4ab374f8-cf52-4af7-a885-10d80a4e5b2b"
      ]
    },
    {
      "cluster_id": "22d09703-f903-41b1-874f-1d44ac956d8e",
      "members": [
        "728c3997-6622-4111-a278-d680c1b50c96"
      ]
    },
    {
      "cluster_id": "c07b3261-1d07-4e89-b0d2-db74c9a1f8dd",
      "members": [
        "cf7b861a-ab3c-4a9b-ac59-549ac3ef0af0"
      ]
    },
    {
      "cluster_id": "1dde6808-a5d8-4cff-a522-2b1380a746a4",
      "members": [
        "2e9ef9b7-a1a4-47f6-8450-0d4d53b6a973"
      ]
    },
    {
      "cluster_id": "a59ccb39-5f94-4ce9-bc2c-828e0325e1b2",
      "members": [
        "25771af9-52d2-4703-abce-50f51dd79499"
      ]
    },
    {
      "cluster_id": "ffbd77e7-2b57-47a5-8bd4-9b23ebb837b5",
      "members": [
        "81d8088a-9576-4107-a172-0b313558170f"
      ]
    },
    {
      "cluster_id": "eb540b94-f26f-4993-9d85-8c7b5fc26cca",
      "members": [
        "81609bf2-06aa-4215-b85e-1172352ab4fd"
      ]
    },
    {
      "cluster_id": "2e14d9d5-92bd-4d6d-84c3-0127651e89de",
      "members": [
        "dfbf618b-e02f-4074-9549-2e0686b74d34"
      ]
    },
    {
      "cluster_id": "d6134f0a-59f2-49b7-85e1-25628c9e022f",
      "members": [
        "b6eee547-04e8-421c-8bf4-f939c1f700e5"
      ]
    },
    {
      "cluster_id": "1a9ef0f1-3f2d-4026-a13b-46206f55c61e",
      "members": [
        "b1f6871b-fb0b-4b53-b754-feb19895b71c"
      ]
    },
    {
      "cluster_id": "14c01a60-ad79-4b97-8a3e-f1a74d8a8f96",
      "members": [
        "a5ab1168-82e2-40e1-88e4-2739fd94022a"
      ]
    },
    {
      "cluster_id": "1137dcb0-70d8-4dce-ad5f-8ffbbf5dde18",
      "members": [
        "d520bc36-9485-48c7-bb02-b172d8979bac"
      ]
    },
    {
      "cluster_id": "07dbae86-71d8-45ff-b18a-4a1bf2ead8e0",
      "members": [
        "fbcc72f3-a1bb-4fc5-9188-1f0d06b36c2c"
      ]
    },
    {
      "cluster_id": "abd6036d-49e1-4e1d-8db5-cfdac174787d",
      "members": [
        "703963f3-6fe9-4ee6-ac11-bd823769cfbf",
        "ed5a38cd-1053-4c15-a8ee-77255d3682a0"
      ]
    },
    {
      "cluster_id": "50321d3e-dfc0-4504-be22-01fb2718ed93",
      "members": [
        "176f09da-4858-4cf5-b55e-bb3752716f63"
      ]
    },
    {
      "cluster_id": "1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7",
      "members": [
        "60b361fd-2a30-437f-b677-cc825abd8fc8",
        "54e46ee3-95e6-4cfb-8445-16db2423c0cb",
        "0f81c463-7fc8-419c-b1cb-c8b675c31f82",
        "1ec08fa1-6515-4fb9-a585-16241d52e937",
        "4566b36e-d3ea-4ec7-9e9b-7343a650fdce"
      ]
    },
    {
      "cluster_id": "efde2814-71d1-4a0e-959d-1e37c60dd501",
      "members": [
        "46cbfd54-f8ad-4e6e-b27e-b823d716a47a",
        "2bd80a18-8bff-480f-994d-68d37192db5b"
      ]
    },
    {
      "cluster_id": "eebdc162-9389-4ba5-ae4d-d971d7acc73a",
      "members": [
        "2706d054-122f-4a83-94d3-c9b19038c3df"
      ]
    },
    {
      "cluster_id": "18a5e98f-3e74-429b-a0f9-0bb8cb6c457c",
      "members": [
        "36946f31-0798-432a-b6f5-53f99b080734",
        "d4ca4811-8423-48d7-8341-7d95c29ca43c",
        "ee9c0543-ba4c-4325-86bf-12846a45e075",
        "67c0c967-1278-4a1b-a074-7121b12841f5",
        "683796d7-fd83-4d96-8114-5d3ce3862e85",
        "ecdc5e87-0734-41de-9be7-f76522dd49da",
        "7fd0faa7-72aa-4187-9f9d-b0ad8cf14b73",
        "f761c1de-a725-49a2-9f05-5e810c664681",
        "57710820-589c-48a2-bfcb-33ad32e2c665"
      ]
    },
    {
      "cluster_id": "45a10488-1ec2-4731-8b23-f6d502ac13b4",
      "members": [
        "a09ffa5c-ddba-4c36-9336-1e74696e9105"
      ]
    },
    {
      "cluster_id": "3a3218a4-ce54-4e61-9c08-41f52d8bf517",
      "members": [
        "6ea5a1bb-1fe2-4405-8e70-ca7cb8012135",
        "bc63a604-0288-4ac9-91e0-1ac813d262ed"
      ]
    },
    {
      "cluster_id": "7effcde4-df93-42c6-842d-c99804764bd5",
      "members": [
        "0bb21a62-d4f7-459a-b582-17d7077bec94"
      ]
    },
    {
      "cluster_id": "c213afe5-5445-4f82-8c73-fbf8e0f02000",
      "members": [
        "147fbe63-1b55-4169-9c46-c0e320e92d21"
      ]
    },
    {
      "cluster_id": "83c0c29b-58c8-41f0-80a2-462fee4f58ed",
      "members": [
        "f863d674-bb62-45b0-88aa-140c964047c2"
      ]
    },
    {
      "cluster_id": "d17ccb3f-9b25-4161-8681-42ad54f325a9",
      "members": [
        "a8650c12-bd32-446f-97a6-67fe735cb4f2"
      ]
    },
    {
      "cluster_id": "7c268167-b621-480c-ba79-7005ed13e2de",
      "members": [
        "3e164c73-1d27-4225-a4cf-4558189223bd",
        "2e1d7402-b82b-4b0a-9fb9-326fef12586b",
        "7f920669-c960-4ee2-9c6b-57c6ddcea98f",
        "1a072915-3b62-4d18-89ca-4e5b22d19ce2"
      ]
    },
    {
      "cluster_id": "b006c022-e811-42d8-ab1c-bed9f97e066b",
      "members": [
        "c3994da9-9d30-4cf2-8bd2-c4fae3919464"
      ]
    },
    {
      "cluster_id": "08918774-fef7-4ef6-9e14-8a7abce1a23c",
      "members": [
        "44257917-be31-4c40-860c-9253f4dfe5f6",
        "2290ebe9-b56d-4b7f-a27d-1990eac79898"
      ]
    },
    {
      "cluster_id": "3276e11e-189d-4a3f-af8c-0dd0ee752612",
      "members": [
        "a86c33ef-0961-4a4b-b386-c0afb307ca26"
      ]
    },
    {
      "cluster_id": "4a1b2728-75a5-43bc-8278-ab49e8c8c004",
      "members": [
        "ea7fa834-93eb-417d-8c19-1a32fa6fc323",
        "994b681b-2928-4c7f-a53a-6f9dad1c6bac",
        "fba5a612-bb2d-4564-8e52-759918f1788f"
      ]
    },
    {
      "cluster_id": "a13b9666-44db-4c37-94a0-689f377da92a",
      "members": [
        "c4be31f8-b067-4d84-a740-33099a4ad1ad"
      ]
    },
    {
      "cluster_id": "b5ae91f8-14e1-45b9-96d8-d01043f4d725",
      "members": [
        "502d2682-d775-4d0c-a054-5cc48fbc722e"
      ]
    },
    {
      "cluster_id": "8feebef1-9f0d-4302-8835-37de98ad3cf7",
      "members": [
        "b5d04b72-b082-4875-ac37-416d3e8ab195"
      ]
    },
    {
      "cluster_id": "aa24898d-2c81-430f-a430-33fb9aae0db7",
      "members": [
        "b08c2c0c-4d30-480a-b095-f8bf6fdc0d4c"
      ]
    },
    {
      "cluster_id": "f57aa067-2ae8-4cb7-8526-f9e921a1522a",
      "members": [
        "ec6202e2-c5da-4ca9-9c80-19a8c4f5df38"
      ]
    },
    {
      "cluster_id": "4bee04c1-3125-4580-8ea5-cbdb4fd88ca9",
      "members": [
        "7c07149e-0c8b-4886-a2b3-c830e7e08b9f"
      ]
    },
    {
      "cluster_id": "ea8f590f-f522-4ce0-8605-6700141bd308",
      "members": [
        "60d11947-1ee3-4a64-9896-45b120df033a"
      ]
    },
    {
      "cluster_id": "06fc9106-7925-4cb4-a52c-592a739aee82",
      "members": [
        "0455a97a-fd77-40f2-a5a7-e14f0b27c5c2",
        "2cd9142f-905e-4ab8-b3c9-fe284e5e8b02"
      ]
    },
    {
      "cluster_id": "f82b2292-d2a6-46b2-8f35-b645fd7735eb",
      "members": [
        "3fd36b82-7c7e-4ee7-b8a7-e201b53263c4"
      ]
    },
    {
      "cluster_id": "03633b9c-b0d8-43dd-b075-5cdc7b02727e",
      "members": [
        "3550264d-3a3a-4421-9827-eeef6d8bed16"
      ]
    },
    {
      "cluster_id": "91e3ebd7-7afc-4109-ab3a-203fd4f78d4d",
      "members": [
        "9af8c9fd-d1ba-4776-b745-76d6c56d08fc"
      ]
    },
    {
      "cluster_id": "f98ba1e5-efa5-4a15-9a39-7050f0a81013",
      "members": [
        "271671d9-d9f0-4701-acb9-ebf12b3d4d51"
      ]
    },
    {
      "cluster_id": "6907e408-863f-4c1c-90bf-e1763a1c2ab8",
      "members": [
        "e3dceb77-f7bd-460f-9054-fcbbc021f866"
      ]
    },
    {
      "cluster_id": "44b235b6-c03c-46c3-8783-0dedf88d2c23",
      "members": [
        "6249d787-d536-4b0e-bfbb-86aa83694f66"
      ]
    },
    {
      "cluster_id": "c2058db3-dc0f-479a-84f0-9c62df9819d4",
      "members": [
        "fb63438f-dc9c-4e56-be6b-4dd7cf6837fb"
      ]
    },
    {
      "cluster_id": "d3085fed-3741-4d75-9105-e8b0b3511de6",
      "members": [
        "b1b37881-0460-450f-9656-568a14bbc224",
        "84349328-6cbe-4c1f-93c4-830596e9ea8e",
        "42c87d2d-b408-49a1-902f-92ac472bdaff"
      ]
    },
    {
      "cluster_id": "52bd4e45-b832-46e3-9698-5812693f4546",
      "members": [
        "11364990-cd4e-4992-824e-ea8bff3d869b"
      ]
    },
    {
      "cluster_id": "f7ca28bb-5007-4654-b846-b6e439b09815",
      "members": [
        "75f0b194-74a7-49de-858f-7ef0259e6771"
      ]
    },
    {
      "cluster_id": "428b353a-55ea-4d2a-8de9-d2392f48d161",
      "members": [
        "53f866a2-6e47-48b6-9ce5-afdce3518b0d"
      ]
    },
    {
      "cluster_id": "adce1d4b-0242-41c2-b4ec-d798e0c0dbf8",
      "members": [
        "7579cb22-cd0f-4ca0-96cf-f1896ed7914f"
      ]
    },
    {
      "cluster_id": "bb3ff0db-1a95-4c2e-819a-c84235effd5e",
      "members": [
        "c7be7841-96cf-4b23-9c1c-46477853c367"
      ]
    },
    {
      "cluster_id": "ef19cef5-5810-4243-912b-66c41d184f8d",
      "members": [
        "0d7a1eb6-374d-42c5-a792-5330c955b1e5"
      ]
    },
    {
      "cluster_id": "722d06bc-1512-434a-8214-a8daff8fb8a9",
      "members": [
        "6f02c190-25e0-4fce-a84e-81944124ad81",
        "c40215cb-f88d-4c3c-bef4-40584de842fc"
      ]
    },
    {
      "cluster_id": "0e5eec12-2ab9-484e-b6c4-cc88a7b6912e",
      "members": [
        "b8661f52-58e5-4305-87f5-ca659edf9304",
        "e83bbc87-dc53-4e0a-aa7a-894dca93d5ca",
        "923d78a6-0f1a-4090-b098-22127570f45d",
        "351498c8-2a08-49fa-b6ac-4c644436ffe6",
        "cf99a0ac-603e-44ac-ae2e-09dda24cbbfd",
        "5a481af2-58fd-4c86-873b-9b91d28d078e"
      ]
    },
    {
      "cluster_id": "a7593170-7dd6-490c-af81-f78a7c4b79b2",
      "members": [
        "b07caca7-03ba-4311-a1d1-a85a8814fca4"
      ]
    },
    {
      "cluster_id": "e7dfffca-5c65-41a6-9fd7-62ccaeb4e1e2",
      "members": [
        "40a75594-3952-4884-a0d6-443085589381"
      ]
    },
    {
      "cluster_id": "379a52a5-17ca-4b52-8aeb-4f7076fdca3c",
      "members": [
        "84387a4d-e511-45af-a35a-ed52ac000f82"
      ]
    },
    {
      "cluster_id": "9e4b0a95-0efa-4ff0-926d-70d1dc9caff3",
      "members": [
        "ef847f2b-0c64-4ca5-ad89-cda8af0b35cd"
      ]
    },
    {
      "cluster_id": "30d8206d-7f35-4cfd-86b9-4ac411d8d754",
      "members": [
        "90e5876a-ce2f-4e79-86e4-791b5196ea9d"
      ]
    },
    {
      "cluster_id": "8a462401-6f97-42ba-a69e-60e2ceb6f0ac",
      "members": [
        "5ef29add-5e93-442f-b2d9-1b0ae2ad3aff"
      ]
    },
    {
      "cluster_id": "72ea99a1-516a-440d-9d00-28c65935de34",
      "members": [
        "180cc7a3-c694-4485-a9ce-4c90d0ce1988"
      ]
    },
    {
      "cluster_id": "d9cfd982-76cb-4edd-8452-01187964f15b",
      "members": [
        "f1df6fcd-82a8-4f29-862b-b17d197720dd"
      ]
    },
    {
      "cluster_id": "22f3bc98-8ed4-4355-8d05-5399a3757d7b",
      "members": [
        "b24bad6a-9fd6-4823-8d2b-0d5fea798256"
      ]
    },
    {
      "cluster_id": "8631d2bd-115e-4513-8568-952af022961b",
      "members": [
        "32edd82e-0217-4813-bec8-1a1dce864bf3"
      ]
    },
    {
      "cluster_id": "45a3ab07-2fb2-420c-9452-350f55111899",
      "members": [
        "53a61ac2-5f7b-41dd-bb0e-e5a7d2c4c0db"
      ]
    },
    {
      "cluster_id": "473a62f7-a375-4113-841d-d6bbd59826b2",
      "members": [
        "16d5f277-e1c8-4439-a591-3bfea8c06823"
      ]
    },
    {
      "cluster_id": "2de014ab-746a-455c-a496-0833ca28f9b5",
      "members": [
        "5eb4a6c0-107d-4b2f-a23d-dee9a04242cb"
      ]
    },
    {
      "cluster_id": "b5bd71be-fc38-4eed-90dd-db3dd13d58ab",
      "members": [
        "4f97be6d-c6d5-4fd2-8649-0bdd2f1fb2e0"
      ]
    },
    {
      "cluster_id": "ba73d786-afbd-4fff-a554-010d1e65a4dc",
      "members": [
        "fc4649f8-8e16-4c02-aece-aedcfdeef725"
      ]
    },
    {
      "cluster_id": "1737c28c-8f31-4855-8951-9dd1dd0b8606",
      "members": [
        "b7724a1f-eea6-474c-b701-2f031cf9fc56",
        "b8aaffa6-27c2-47ef-afa7-238f612eb2a5",
        "8e1043cc-2dca-495f-8d63-e75c5ae5387f",
        "943e4f34-59eb-4222-a1ae-6b920d69ab63"
      ]
    },
    {
      "cluster_id": "3625ee09-ea65-4286-ae5a-83daac4e66b6",
      "members": [
        "7207fa75-c0f2-435b-9696-7acee5f2af99"
      ]
    },
    {
      "cluster_id": "b1dcb694-6efc-4b22-9bc7-9254eb290f7d",
      "members": [
        "b1622aae-b90f-470f-bfe8-51c55bed106b",
        "f4263275-9b32-4ed9-b972-fc6d18183e50",
        "fe3acca7-a1a2-431c-a994-c81bec1ded2c"
      ]
    },
    {
      "cluster_id": "d8b8cb3c-4059-4ad7-99fc-df25e1b98b1b",
      "members": [
        "358c93bf-c503-4f8a-9709-78f3c5027f02"
      ]
    },
    {
      "cluster_id": "844b0e6c-6c02-4726-b2d2-097a5c40629c",
      "members": [
        "71aa2d9f-ab06-45e7-97cf-248cb50efd98"
      ]
    },
    {
      "cluster_id": "a7c7aaf0-419c-4efc-8f5e-14d3f71ed9ab",
      "members": [
        "e5037d73-ad6a-403c-8a6a-a405132eecc3"
      ]
    },
    {
      "cluster_id": "21e4a786-d932-47c3-955b-b3e7de14d033",
      "members": [
        "5853bc70-e5ff-4c09-ada0-041fe0401e19"
      ]
    },
    {
      "cluster_id": "6d365284-d631-4fba-bf61-dd8894351156",
      "members": [
        "99b6d9fc-3cbd-43dc-b069-102f955ba2f9"
      ]
    },
    {
      "cluster_id": "a4bb7e8e-38b8-4326-bf96-4782b99feba1",
      "members": [
        "d8d5b1d1-97cf-4035-b4bf-d3121364b428"
      ]
    },
    {
      "cluster_id": "28097be1-5cca-4755-b4ba-20a7ac4aa34a",
      "members": [
        "c52ddb05-8e7a-4b12-a26d-91c6987d7438"
      ]
    },
    {
      "cluster_id": "47f27689-5f68-430a-bf84-77af1b6dc7c8",
      "members": [
        "46d547f9-9df8-47c2-9248-ec0c9873a7db"
      ]
    },
    {
      "cluster_id": "c236b253-d4f6-4796-aa07-7b8f0eb372e6",
      "members": [
        "5135b149-7874-4048-9faa-aa7e73afbd47"
      ]
    },
    {
      "cluster_id": "a4ea2030-230b-4e96-b485-ae147aec2613",
      "members": [
        "afdb0635-2d31-45b9-937f-b7b6970f99df"
      ]
    },
    {
      "cluster_id": "ff9ad8d9-d483-4daa-86f0-12ffd12f76b0",
      "members": [
        "5b7868af-db6b-4e90-bdce-140b83805c8b"
      ]
    },
    {
      "cluster_id": "cc9a2a9c-6fc8-4c4a-bdf7-3321a40e8bff",
      "members": [
        "f4c67b8f-f721-4b6d-b214-82b231ed674d"
      ]
    },
    {
      "cluster_id": "a7783b6a-7d1f-4493-9664-55b728cadb9e",
      "members": [
        "571ef3b1-218a-41ea-ba3a-184082016906"
      ]
    },
    {
      "cluster_id": "209dbc84-05ee-49b9-b69d-c36d87df72b0",
      "members": [
        "f1dbfefe-5e9e-4e2c-ac33-07a571ea1f31"
      ]
    },
    {
      "cluster_id": "388f06a9-49ef-4bdf-8dec-04895f125517",
      "members": [
        "75fb3ff2-7efa-498c-aed9-04cad1e8e90b"
      ]
    },
    {
      "cluster_id": "96b1dd29-d1cf-4ea9-9b10-e52b59e1a6b5",
      "members": [
        "c8e2dcdc-113e-4f0a-89e7-af844b5e74c1"
      ]
    },
    {
      "cluster_id": "1d9de982-6324-4241-9481-7618f52a1421",
      "members": [
        "3fc6ab64-6a58-46dc-88a1-5eba220a3e07"
      ]
    },
    {
      "cluster_id": "f39790da-a4f6-4366-98f5-449851f41e29",
      "members": [
        "6eb14920-b3ef-47c3-a818-d5a00297bbe7"
      ]
    },
    {
      "cluster_id": "4dd085e4-7892-4955-a5ce-d8e90d7e23d4",
      "members": [
        "6b48c1d9-1669-429c-af35-4b0d572ba8be"
      ]
    },
    {
      "cluster_id": "c1482f2b-05b5-4755-ad11-c7c127fb4e73",
      "members": [
        "0db32998-01ec-430e-939a-655122441935"
      ]
    },
    {
      "cluster_id": "4b8668b9-ec8e-41f1-b42b-e53f7eac0641",
      "members": [
        "c2c8ab49-308c-4b42-85b2-6fd772d339e7",
        "501e49c3-266a-4a6b-a595-bcbb93614985"
      ]
    },
    {
      "cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57",
      "members": [
        "47da981d-850b-44ac-a0d6-c94219998be6",
        "7564e306-9381-4331-a0f1-0dbf0fb1bba9",
        "c3c07c77-af4b-4204-aabc-6aa4aa674f5d",
        "f3a8343a-d979-47b7-815c-831df4ef2799",
        "45933205-c402-44c5-a3d4-8c4d29f3324b",
        "4039d703-a1d4-4cc6-ae5d-87f162f75e59",
        "9f5ea13d-dbcb-4125-8e01-5e0baaf11160"
      ]
    },
    {
      "cluster_id": "78fb23f3-7fa7-436d-840c-3f1376d6f22b",
      "members": [
        "2b2b9ca9-f40d-425e-8561-7b063b8b887f"
      ]
    },
    {
      "cluster_id": "6b5cfe37-19cb-4d16-b4f9-67d51f90495a",
      "members": [
        "e1156b4d-4874-489c-89a7-ebb6555f0b26"
      ]
    },
    {
      "cluster_id": "6494604d-36ac-42cf-98fa-810683a18200",
      "members": [
        "c859396c-60e7-430e-bbd1-6f173c056c6a"
      ]
    },
    {
      "cluster_id": "de3dd2d3-d79d-4172-a1cf-b6ac1238b295",
      "members": [
        "3913c195-df6f-46a1-a77b-234d06be4e5d"
      ]
    },
    {
      "cluster_id": "930472a6-b976-45c6-814a-9c87d52eedd0",
      "members": [
        "5acea283-52dc-4be7-af91-1351ea96ad69"
      ]
    },
    {
      "cluster_id": "194f810d-af4b-491d-bdf7-3aad4b9c5e55",
      "members": [
        "f735f149-adea-40bb-85b9-e39ed7f943b6"
      ]
    },
    {
      "cluster_id": "7e4cb312-8581-481c-819b-81c1e9125f8d",
      "members": [
        "c399ffed-e74d-4781-8755-ff6d46ccfcb6"
      ]
    },
    {
      "cluster_id": "6f715c79-5b97-43d0-a5c3-09848b08ceca",
      "members": [
        "4874937d-d2a4-4b84-be8e-078fc60273ee"
      ]
    },
    {
      "cluster_id": "16f44bbb-61c5-4b72-873e-79ca1d65deb9",
      "members": [
        "881a9b4e-f791-4953-8c1f-94e0fdf4e503"
      ]
    },
    {
      "cluster_id": "5a1b9522-efaf-458a-8a08-7187a721101c",
      "members": [
        "9e666dbe-591b-4fc1-8a5d-cbbfca6652ad"
      ]
    },
    {
      "cluster_id": "8e7309fe-7380-453b-8dec-aa0848276b7f",
      "members": [
        "2ef1b714-3d18-4370-a67e-499877b45151"
      ]
    },
    {
      "cluster_id": "ab0be659-cfc3-42d5-b3a3-1d1264ed5cd9",
      "members": [
        "d41efa9d-b94c-413e-8a82-a278a1b220c4"
      ]
    },
    {
      "cluster_id": "335c4cdd-12ec-4cfe-80c0-1755c4975b84",
      "members": [
        "52ab28d1-e615-4350-9e4d-8080034e84e0"
      ]
    },
    {
      "cluster_id": "cc877779-d56b-4dd9-8cf2-4d0193c50ac9",
      "members": [
        "9a091402-3c03-4297-9d34-3435e1bc34b2"
      ]
    },
    {
      "cluster_id": "82025429-31a1-4168-809f-fb0e7a96b10b",
      "members": [
        "7dc86030-7a19-4350-a39f-49cdfa360c00"
      ]
    },
    {
      "cluster_id": "65ac3d2f-1144-42ab-9435-1522b78a54a3",
      "members": [
        "582f74d4-d5ef-4fe1-8c27-f7ebb9b7b1eb",
        "00490e88-4c69-439f-840a-b6f48abec599",
        "40be193a-bde9-42b6-b43a-6e1b513e00b8",
        "6793396c-a9aa-4a0b-84c1-27723d157956",
        "741a9cb5-886a-4ac3-a0db-6fca78a7b9ac"
      ]
    },
    {
      "cluster_id": "f2b47c96-3e62-4d1a-98f6-547e71af6858",
      "members": [
        "48c4a319-7cf0-4fd0-bc09-68cd21f0626e",
        "b146c3bc-b08a-4983-be17-739e144ab07a"
      ]
    },
    {
      "cluster_id": "7a2de756-9400-4120-b4b6-4dec07a8ec47",
      "members": [
        "2d1e731f-a3c2-4528-b58a-449901a76c18"
      ]
    },
    {
      "cluster_id": "b50d2222-7f8b-46fd-aef1-62ca57b6cc71",
      "members": [
        "bde590cd-9b48-4b9b-b5f0-8bce36a24ff3"
      ]
    },
    {
      "cluster_id": "4796f6d0-5c9d-46eb-a35f-0a235dcf3b0e",
      "members": [
        "a0907cde-a1ec-40f3-9787-912b1d3b935d"
      ]
    },
    {
      "cluster_id": "80a8792f-9489-40e4-a0a2-e1e4173e1957",
      "members": [
        "2ac0eef9-cde6-4446-a483-d338c3dd199b",
        "acde9344-bbbe-415a-92ed-e790f274ea8b"
      ]
    },
    {
      "cluster_id": "85b2637f-fff4-4688-a95a-adb041e440fa",
      "members": [
        "4c5f8bce-dd61-44b7-b834-9cdbf9da9728"
      ]
    },
    {
      "cluster_id": "60f0b8f5-f6ce-4be8-993b-d99ea8933141",
      "members": [
        "79fbeb52-b612-4dd7-a96a-b3dab751bc62"
      ]
    },
    {
      "cluster_id": "d3c9a36a-e9bd-4eb9-ae98-c8503d7abb49",
      "members": [
        "c2a1619b-1e8a-4cc4-bad3-e513b4662d11",
        "d13dadf0-4167-4441-a621-b37a7b72e753"
      ]
    },
    {
      "cluster_id": "2ad0c3d6-c24f-4917-a1f6-8d2bd77034c3",
      "members": [
        "defc77ff-cbfc-48bd-8b8c-c94b79d5d3ee"
      ]
    },
    {
      "cluster_id": "be4d477c-befe-4014-a5ff-185b3c58e5d5",
      "members": [
        "c3383913-b97c-4698-bc6e-dfa86f94252e"
      ]
    },
    {
      "cluster_id": "89e88d24-d19d-44d7-b8a5-9a1551934f01",
      "members": [
        "9b91b525-00e7-4e48-a008-f8b5f09e52cd"
      ]
    },
    {
      "cluster_id": "d00c4814-110a-4898-a26e-19970d2ed410",
      "members": [
        "b7ea1cf0-ee58-4c87-816e-4f6b0a636fc5"
      ]
    },
    {
      "cluster_id": "0903a221-6399-44af-9542-80d1c25bc816",
      "members": [
        "3907e1af-90e2-482f-a144-f7748e0038c9"
      ]
    },
    {
      "cluster_id": "97d31fcc-0a9f-4dbf-b6c8-d1db70a61d1f",
      "members": [
        "e2a23296-e072-49f1-9153-9cb10c17f747"
      ]
    },
    {
      "cluster_id": "343b7137-128b-41e4-a3ca-cc8e58193569",
      "members": [
        "26e695e0-9c2a-4dd4-9ff2-b9e3b46338ea",
        "188ad611-b2ac-49e2-a256-aa170e3d2b3e"
      ]
    },
    {
      "cluster_id": "984fa7e0-f763-4f19-b49c-d87ea5159954",
      "members": [
        "5ddf863e-80ba-40a7-9326-35d6a8d80405",
        "969a892f-fce1-45f5-8bde-d9e50e52490d"
      ]
    },
    {
      "cluster_id": "dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82",
      "members": [
        "af25c83d-0d32-4118-9d9f-19e0080c4a84",
        "f6af0590-2398-4b94-9a2c-3853a58d618d",
        "2c54f3fc-53e6-4314-aef4-ec5de9731cf0"
      ]
    },
    {
      "cluster_id": "ff805a1d-a863-4cd5-ad33-a75bc8aa6ed0",
      "members": [
        "5a85052e-a1b7-4165-8b2a-69c906c41b16"
      ]
    },
    {
      "cluster_id": "5a444351-b082-407c-bb72-a6329cc1e654",
      "members": [
        "472106a5-95aa-4a0c-86fd-4bbc45da01cf"
      ]
    },
    {
      "cluster_id": "0d486f1f-7f93-4053-a807-970ad702d674",
      "members": [
        "5d182855-0f10-4b73-a406-7cb2a6b5d3e3"
      ]
    },
    {
      "cluster_id": "3e86f418-a7c7-46c6-9106-86fe0b88ffdf",
      "members": [
        "34420d7f-cff5-4569-84cd-74b4c1264c12"
      ]
    },
    {
      "cluster_id": "ec0d2b84-2d88-4935-ba00-876f0eb3929f",
      "members": [
        "8f8d57ad-bace-4ecc-ba07-a75b5b70cabe"
      ]
    },
    {
      "cluster_id": "ce319c6f-8ace-40b1-be7e-933bd39cd9c5",
      "members": [
        "3f9258dc-40b2-4707-87e0-17ccef7ddc3c",
        "e0d54a0c-eece-48bb-8f50-cd3eaafc0fa9"
      ]
    },
    {
      "cluster_id": "e209eca1-fa4c-48e0-bce4-5bdadede98cd",
      "members": [
        "a1d5fb20-590f-45a2-994a-6de1aef1ae6f"
      ]
    },
    {
      "cluster_id": "4586dde9-ed48-4b34-aa3d-9d5f004f908c",
      "members": [
        "b1c5bec7-8c75-4bfc-b1ef-03e432b736fd"
      ]
    },
    {
      "cluster_id": "75d8830c-702b-4013-8c9b-62375f536959",
      "members": [
        "6f8e99cb-9eac-42f8-baaf-7d5fb1ec4b66"
      ]
    },
    {
      "cluster_id": "85cfe769-d38e-42c1-b06b-f313ff275d96",
      "members": [
        "78c6dc0a-7aef-495a-a9fb-b652131b9a52"
      ]
    },
    {
      "cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c",
      "members": [
        "542b87db-3865-4252-ab38-1fef10e84787",
        "23ef675c-fb76-413b-862f-99a1e72bbe7d",
        "7a13e2e1-73ef-46cd-af16-09ed228a8441",
        "88e7d9ca-6337-4303-9f4e-3459cb5b0080",
        "42c459b3-603b-4fea-b100-496e7c644a74",
        "ecbd4e9f-56e6-4e10-9bd2-e280c4a7a058",
        "16c1596f-0638-4c9d-b521-04f920c7f851",
        "2e82249f-7daf-4890-8ed1-8937ec73e255",
        "0689fba7-b805-40ed-8cfa-956bc0b5639f",
        "2b07e9d4-c9eb-4255-bac4-e301f267a58e"
      ]
    },
    {
      "cluster_id": "e2b1886a-d41d-4169-be53-e4ed1b6d9d79",
      "members": [
        "1cffb107-1569-46e6-a9e3-c0000872fae9",
        "253ccb87-0251-4c30-99c8-3f6544a04ff8",
        "22f5e4e6-4a0e-4665-a396-03104cfc11d4",
        "0781a0fb-13c1-4dac-8c1c-fbccebd5d447",
        "4e37ba87-f258-4e45-aa42-2637e01fc449",
        "10370b60-b6d5-4e58-84e3-bb99d84b57b1"
      ]
    },
    {
      "cluster_id": "88ed9b73-fcba-44e5-9474-9587e7fb5ebb",
      "members": [
        "cc8b09bc-cb25-4f9c-a6b8-19f74f36a20b"
      ]
    },
    {
      "cluster_id": "7e49c169-d21d-4097-aa83-c6ac3958ab1b",
      "members": [
        "a8823aaa-97b6-4788-b780-517c9261fa6d"
      ]
    },
    {
      "cluster_id": "712f6134-d72c-4f1f-bf01-f9fa23374d32",
      "members": [
        "4c2093dd-1e8c-4155-85d3-aaffaf245046"
      ]
    },
    {
      "cluster_id": "c056dbf1-3293-411e-a56b-f5d55e75ae9c",
      "members": [
        "21c8b0e0-0435-491f-81b2-87fd340173f7"
      ]
    },
    {
      "cluster_id": "f3b3f1d2-6fee-4073-8509-60422ce0c24d",
      "members": [
        "86a7ac0c-e6c5-46a8-ba85-7c26b269a478"
      ]
    },
    {
      "cluster_id": "ed1ec0ec-9794-4ebc-ab7f-279232e95886",
      "members": [
        "20fb0ed2-b748-41ad-afdc-0c498f54fd95"
      ]
    },
    {
      "cluster_id": "cbb25dea-baf7-49d5-b9bc-41ab2551292b",
      "members": [
        "c93ece72-3991-47d1-a1cc-078067203fb3"
      ]
    },
    {
      "cluster_id": "ad5a4bab-60d8-4977-8f90-38b233ab7dad",
      "members": [
        "7a2624fc-76c9-4968-a3d1-e347ecff910c"
      ]
    },
    {
      "cluster_id": "1d1ebfc5-8408-4d3f-ae15-fa5d518e6407",
      "members": [
        "710ccf32-7e3b-45ca-9ae2-62ce4edbceed"
      ]
    },
    {
      "cluster_id": "978715ff-b53c-4912-969e-25b8f2aa2ba5",
      "members": [
        "30b128ba-4d8d-4caf-9ba0-507ade647b3f"
      ]
    },
    {
      "cluster_id": "45a08904-45fb-4937-aec9-3d713915195b",
      "members": [
        "b922483b-ca38-4bb5-92e6-bc6d9cd8e778"
      ]
    },
    {
      "cluster_id": "dea69c71-f54b-4b5e-a6a9-8af50c3a5a8c",
      "members": [
        "9fb0c90c-2388-4cb4-808c-cced91fe0867"
      ]
    },
    {
      "cluster_id": "a1ffb94b-ce0c-4994-8b4a-5885dcc09a67",
      "members": [
        "131116cf-1869-4bd2-bd12-8dfd6249cfca"
      ]
    },
    {
      "cluster_id": "f67a1af7-61f9-40c0-beb8-34c87a985d6d",
      "members": [
        "2a5cabbd-0f11-480f-aeb1-738c11f2f7a8"
      ]
    },
    {
      "cluster_id": "4be56027-8172-47cc-b793-5f37e487c1b0",
      "members": [
        "899c7e3e-ee42-45f8-877c-dade5b1e3465"
      ]
    },
    {
      "cluster_id": "3be61476-a382-4c84-9990-67e69bae81f5",
      "members": [
        "d9eb600f-07a9-43c2-85a1-267b40754c4a"
      ]
    },
    {
      "cluster_id": "cc709bf0-3f13-4e4e-b2f5-adbdf5752221",
      "members": [
        "c691e33e-5392-482d-9b5d-8eea0f8dd4e9"
      ]
    },
    {
      "cluster_id": "d7895c1b-fc75-4aef-87f4-799e18058cdf",
      "members": [
        "ac5ef9d8-d7e6-41cc-9409-cfcf6d93f012",
        "1b6307cb-cc36-4ffc-a619-8d593dbd8424"
      ]
    },
    {
      "cluster_id": "d0fe7b5d-26f1-4baf-86ca-16d7441119ce",
      "members": [
        "8ac12e53-8fc9-4794-9d71-16e590409c47"
      ]
    },
    {
      "cluster_id": "aa310c78-7994-4d40-8f0b-2bea418f42a5",
      "members": [
        "e9c713f8-7fd8-4245-9d1d-2a091b3e8c2f"
      ]
    },
    {
      "cluster_id": "90d2821b-b505-4e57-a6e2-7f1724a94e93",
      "members": [
        "b4a0c843-111a-4e9b-83ac-f24907a880e0"
      ]
    },
    {
      "cluster_id": "516f819a-378f-4afb-ba61-51d5e2e77e27",
      "members": [
        "8bad62bb-f014-4f00-8801-8cfcbf482f07"
      ]
    },
    {
      "cluster_id": "f97d0f4b-71d3-41e4-97ea-bf25e10bfac7",
      "members": [
        "e9b1b107-a17d-41fc-9252-d6bdda1ddb67"
      ]
    },
    {
      "cluster_id": "202dbce4-7e5d-444f-8048-9175eb593dea",
      "members": [
        "7691c906-9452-450c-8fba-b94921dfc3e9"
      ]
    },
    {
      "cluster_id": "3380c11c-4d24-494b-b6f2-08440e174107",
      "members": [
        "ce1e79be-c15e-4b37-a0d5-c5130c80d079"
      ]
    },
    {
      "cluster_id": "f1447bab-26ff-4b83-b864-e0d728335c30",
      "members": [
        "6207eb7d-803d-456d-91b0-0a9356df9f37"
      ]
    },
    {
      "cluster_id": "77f11c57-3238-4a6e-9949-a3af094990cf",
      "members": [
        "8aae4da4-c6c6-4d8e-b18e-81949526f70f"
      ]
    },
    {
      "cluster_id": "f54b8dca-8c1e-4052-93b8-d1e0396181a2",
      "members": [
        "cc516e39-1c65-4879-a641-4bfaec9fb492"
      ]
    },
    {
      "cluster_id": "8da8b4f2-f2e7-44b8-b5b6-7b0f66fba285",
      "members": [
        "d928ebff-a115-453e-b7cd-a8fa8856f24f"
      ]
    },
    {
      "cluster_id": "6ad057c3-3463-4e5c-9a22-5186dd44f814",
      "members": [
        "61e1f3d9-d3e6-4680-a108-f43330a1b309"
      ]
    },
    {
      "cluster_id": "082dc58d-c56c-468c-82bc-39e8c62c9b6c",
      "members": [
        "558474da-6058-4ea5-ade5-569c6a34175b"
      ]
    },
    {
      "cluster_id": "34a1b507-fb03-489f-a79e-be687aeaabe9",
      "members": [
        "8333bdd8-feac-4112-aa25-5e0b53675aaa",
        "90948fe5-444a-4293-8d27-d4e7b5644413",
        "947907d3-1145-4f78-ac7c-d6cab87838c1",
        "1c97aaf9-42ae-463e-a597-d94917fde197",
        "de0e3abf-ceba-49b9-8828-79c50e38b815"
      ]
    },
    {
      "cluster_id": "ad9e7a2b-7924-46d4-ba72-1397b5c0801b",
      "members": [
        "4d260240-ee9c-4013-95fc-adfd97d8e8ef"
      ]
    },
    {
      "cluster_id": "4b2686df-f0ed-4fbd-b1c1-475a6406601a",
      "members": [
        "31ef5786-3116-4f8a-aea5-6e178bc400aa"
      ]
    },
    {
      "cluster_id": "207aa08d-5028-49a1-8eaa-71f4b633ccfb",
      "members": [
        "e23ae7b9-7735-4b43-9ad3-8348a3cc7a8e"
      ]
    },
    {
      "cluster_id": "824a023b-59e7-46a7-a55c-6ef905c079b9",
      "members": [
        "c98bc55a-17cc-4765-9ff5-1a646cbe53fc"
      ]
    },
    {
      "cluster_id": "8335c349-e4e7-4586-b3d0-516ccf0a3944",
      "members": [
        "1cedc6f7-c156-4315-b1bd-f9008b4b24d6"
      ]
    },
    {
      "cluster_id": "6987d44b-afbc-426b-97f6-9a507fedf197",
      "members": [
        "30cfdcae-a082-44ff-88ed-042545fdac8f"
      ]
    },
    {
      "cluster_id": "46ec4fb5-6eba-4f8a-b3a0-e40c112dfda5",
      "members": [
        "6fa2180b-71b1-4dba-b39e-a0559c7554ea"
      ]
    },
    {
      "cluster_id": "40e30cac-a785-4067-9a79-c9832fd15372",
      "members": [
        "ee537e39-4429-40e3-8845-ee67ca23d544"
      ]
    },
    {
      "cluster_id": "c9720688-df71-4db3-980b-d7e5c9b865b6",
      "members": [
        "c2cb8f2e-88ac-4001-b4ed-4d7207083a16"
      ]
    },
    {
      "cluster_id": "8b28dee8-f25f-4ea3-a58f-094086b4ac36",
      "members": [
        "0b7e09d8-a27c-4fe9-b181-633946dc6ea5"
      ]
    },
    {
      "cluster_id": "2826c59b-a252-4d3e-9bdc-eb92dc90ee16",
      "members": [
        "65d3863e-ca86-4022-9d34-a133345d03fb"
      ]
    },
    {
      "cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965",
      "members": [
        "599d6b90-776a-4f56-87ef-3d2d60246da0",
        "bb1119af-cc0c-4cb5-9e2b-372c006a5615",
        "ac2660ea-85e9-4122-bbc2-278ed03028a9",
        "f7818a82-9d09-4ed7-8218-f09097a03a92",
        "55a5fa6c-a334-4d94-865f-60a02ae595f8",
        "76b6d07b-6776-4eab-a9db-0943a7a939d5"
      ]
    },
    {
      "cluster_id": "6a5e4ef1-a4af-4de0-8b56-75c0ed9ae0bb",
      "members": [
        "b222b17a-80d4-4064-94f0-24f909d52578"
      ]
    },
    {
      "cluster_id": "8b5f4d0a-57ca-4fb0-bc01-110872004685",
      "members": [
        "af19d067-b948-47c7-98fd-27809f978e69"
      ]
    },
    {
      "cluster_id": "805b132f-a73a-418b-a147-d9899a145b6b",
      "members": [
        "8df23cbc-2b04-4468-8a18-14731f0017fb"
      ]
    },
    {
      "cluster_id": "3124bf40-7b7a-44d7-a83e-a1fe41e14ec6",
      "members": [
        "0fc47699-b995-470d-a364-c3f6358a2b00",
        "eb66c65e-7b3f-4c2c-b083-de751245e517"
      ]
    },
    {
      "cluster_id": "193775cc-4b10-4b36-baba-844635425d37",
      "members": [
        "34978d71-5cd6-4bcc-b8fb-1af8ab14cf93",
        "2f7812a5-0f4b-4681-a35b-85b384b624c8"
      ]
    },
    {
      "cluster_id": "3c52b26e-a9d9-4bd3-979f-3455beaaaaec",
      "members": [
        "b1b0f19e-2187-4758-9f75-14aac08259e9",
        "3f95d40a-106b-42a7-89f1-14b558e7a54f"
      ]
    },
    {
      "cluster_id": "28ec4a0f-45df-46a6-a92b-1e0740306f80",
      "members": [
        "5709690d-c5cc-4770-a64c-a2fc10bc7c7a"
      ]
    },
    {
      "cluster_id": "44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad",
      "members": [
        "7da30077-3d2d-4fe1-8c1b-fd241f74ec38",
        "ca905cfb-ae15-4198-ba0d-051609c335cb",
        "560e0e32-05d2-442c-8f26-f2984ba3dda8",
        "426173ef-9f0b-4c2f-a119-f5f2aa095d55",
        "7d2f369e-4792-4f44-a2fd-c8db8dc7b072",
        "db778365-385d-4330-8788-2907d8173af1"
      ]
    },
    {
      "cluster_id": "cf59a1ef-ed9e-457e-802d-c83df70e42c0",
      "members": [
        "e8de1b7e-6b74-4c3f-b3ac-e16793d17d46"
      ]
    },
    {
      "cluster_id": "7a33ed40-551f-4f38-8b8c-22ab137818a4",
      "members": [
        "4975ed13-95c3-4dfd-817a-d35b4508e64f"
      ]
    },
    {
      "cluster_id": "cc21b294-9fdf-4b80-a922-5a2fda24edfb",
      "members": [
        "d5983009-517d-4c25-8d0b-45531de5eacf"
      ]
    },
    {
      "cluster_id": "a0925808-7df0-46ec-bb06-9cb553f8b8fd",
      "members": [
        "e79c9566-b494-4c71-85a7-fe6f8ab5c57e",
        "6cfac1b0-30a7-4afb-a149-90cfba3368ae",
        "0c724668-85d6-4a8c-9d9a-0f5348c06218",
        "2f0d2e62-8a4b-4aad-988c-697711c78a85"
      ]
    },
    {
      "cluster_id": "54cb3ed2-7dba-402d-a696-00ebabb32bc1",
      "members": [
        "4bed780a-c77d-43f8-b6fe-392eeafaacfa"
      ]
    },
    {
      "cluster_id": "fc20c413-7f2c-4fbe-b8d9-0aab094ec5bd",
      "members": [
        "e262fb85-8cbc-4876-9555-f8bab2f04923"
      ]
    },
    {
      "cluster_id": "9f40653a-5e27-4d90-9510-e0680c0dbf1e",
      "members": [
        "b6750573-4fc6-4872-8536-11b5ea807dab"
      ]
    },
    {
      "cluster_id": "87cb3f5b-d497-49ea-a871-f34d7080b10b",
      "members": [
        "bb4e58f4-c815-4b72-84c3-a13d90c6fec5"
      ]
    },
    {
      "cluster_id": "bc1909a7-dd59-441d-aab0-42a7a0400bdd",
      "members": [
        "7b4cd620-c2ee-4e4d-a396-fef2ad37c6ab"
      ]
    },
    {
      "cluster_id": "25a859f3-e205-44d1-b703-8d1e9921d967",
      "members": [
        "f78c8c13-6953-42fb-9dba-3a217cb3704c"
      ]
    },
    {
      "cluster_id": "aed5d13a-0c24-4359-9236-cc780ebe021d",
      "members": [
        "f83d17ec-eb10-4831-acc0-dc9c4bb2de3e"
      ]
    },
    {
      "cluster_id": "a89bcef2-6caa-4f8e-9e33-b36ab68a4d84",
      "members": [
        "e0b2c89c-e1b7-42d0-99a7-db7173cdeb27"
      ]
    },
    {
      "cluster_id": "205d2c16-9ba3-4e14-887c-3331a1f50616",
      "members": [
        "68c6a597-9911-4249-85a2-3907f4308006"
      ]
    },
    {
      "cluster_id": "d6d06f17-e283-43e2-b5a1-66991f31adf1",
      "members": [
        "fad79309-d414-43a1-9a9d-2d4a5d42eae3"
      ]
    },
    {
      "cluster_id": "8d547757-303e-43b6-9192-6b5dc2fd34da",
      "members": [
        "bfe4cc35-f75c-478f-8182-e7abfaa57df8"
      ]
    },
    {
      "cluster_id": "d285c4ec-3955-47ea-918b-05a93083bebc",
      "members": [
        "60ce23c3-a9cd-4599-9b3b-71a8ee7b089a",
        "ab296a5c-ee22-4d81-b8ad-0840632776be"
      ]
    },
    {
      "cluster_id": "532d9503-bb11-4fbf-b9c1-5c555fd5393f",
      "members": [
        "741b64eb-0898-424a-93e5-d57095113352"
      ]
    },
    {
      "cluster_id": "783f72c7-55f3-4eb7-a87e-43b3ec9f631e",
      "members": [
        "8b469abc-5c4b-46d0-a323-62abbf9586d0",
        "834752c5-4367-4977-9bc7-8fdca0b7efad"
      ]
    },
    {
      "cluster_id": "de1e5d6e-28d7-4405-8085-e6133787bf1e",
      "members": [
        "11e972ec-8fdd-4957-90ee-084529346007"
      ]
    },
    {
      "cluster_id": "7861388f-c8b9-4ec0-99ed-6ceb81b3764b",
      "members": [
        "1f20599e-7de4-440c-93e1-60e756213623"
      ]
    },
    {
      "cluster_id": "648cf481-ce4a-42cd-869d-b9a572ac3d7d",
      "members": [
        "08af0b8f-6d64-4d24-8866-99133676279d"
      ]
    },
    {
      "cluster_id": "6c57c5d0-33e4-4282-bbc0-6b80393235a6",
      "members": [
        "98a69c88-4aa5-4797-9504-38a3379a6e4b"
      ]
    },
    {
      "cluster_id": "b560200c-3172-4ff5-9c7f-410b8ee34d25",
      "members": [
        "243688f2-31ba-420b-bdd1-55f3774ea934"
      ]
    },
    {
      "cluster_id": "a4149375-9601-4a78-ae4b-69813512b036",
      "members": [
        "a8b7c5e7-0626-44fb-aace-1d52e4c2fd3b"
      ]
    },
    {
      "cluster_id": "b6a2032e-1851-4e5a-bb1b-dbcd29c647ef",
      "members": [
        "7b1297ab-5862-486f-9071-4f90b1855190"
      ]
    },
    {
      "cluster_id": "4246d514-6e8e-4ea0-b242-f59a58eb4bb7",
      "members": [
        "e94d7fbd-75f0-44d3-b424-5299cb09f6f5"
      ]
    },
    {
      "cluster_id": "afd3270e-5e96-4569-902a-2454d2aa0df7",
      "members": [
        "f2009dec-48f9-472c-8a6c-72ec907820ff"
      ]
    },
    {
      "cluster_id": "8bd51f45-6e7b-4825-a6da-736e3f231b22",
      "members": [
        "b82828fb-72b4-438d-8217-b3285d06e625"
      ]
    },
    {
      "cluster_id": "d40b11df-00d1-4f65-b6c2-6f209bb850d8",
      "members": [
        "b34702c2-abc2-41c6-b039-5462213ac454"
      ]
    },
    {
      "cluster_id": "9288082a-2c01-4b74-9421-1882494878c4",
      "members": [
        "38672460-e6a2-4e57-aa25-0580a615e984"
      ]
    },
    {
      "cluster_id": "03682aa9-6c66-493a-b7f2-cba3c38176e4",
      "members": [
        "393a7139-371c-44aa-8032-069fe7cdb7f5"
      ]
    },
    {
      "cluster_id": "754365fe-ff15-423c-803b-8363cd1da39c",
      "members": [
        "e9f5af32-2194-4ad4-9d31-fd32286912f7"
      ]
    },
    {
      "cluster_id": "a1ee8def-adc3-431c-a4cf-3b3370e7d6e5",
      "members": [
        "62c8ffd3-d63a-4c18-a39f-e713c858561a"
      ]
    },
    {
      "cluster_id": "c4974eac-c8ce-4c10-a509-e1191979432a",
      "members": [
        "41859453-3ca7-42e5-ab9d-59bbdf9c64f2"
      ]
    },
    {
      "cluster_id": "aa771524-1314-4f8e-8195-c42cbd659c66",
      "members": [
        "f41106cb-4f98-417b-97a3-ee550457e74e"
      ]
    },
    {
      "cluster_id": "2c29846f-3295-4669-afc6-4c052b5c55d8",
      "members": [
        "f2aefb8c-88ae-4546-a2ba-f328776f4d19",
        "ae152faa-631f-4b0b-bf9e-7452367962ba",
        "040d00aa-47e1-4c98-ad24-df042df860e3"
      ]
    },
    {
      "cluster_id": "273cff70-66df-48dd-9efa-69156787ee64",
      "members": [
        "94f80fa6-0445-46be-82c2-c6464ae6e031",
        "2e24562f-fb40-4a6a-a30a-ae3834c49445"
      ]
    },
    {
      "cluster_id": "39ba0d7c-5f4e-43e3-b6a2-9f87693ee149",
      "members": [
        "f56e724b-f666-418a-9641-60030e9a6e78",
        "eeed5b28-33d1-4972-95cb-16d716b43dc8",
        "191a7f33-31c9-4830-b540-0254a53cf820"
      ]
    },
    {
      "cluster_id": "845395ad-4701-4574-ae25-f53da9fca0d2",
      "members": [
        "cba76ec1-2e4f-4cc5-aaf8-8514021bc6ff"
      ]
    },
    {
      "cluster_id": "f419c65f-41b5-4ce9-829b-e8de4a1f6af4",
      "members": [
        "12ceeaa3-7219-4f4c-8c7f-7dd8c7b97e27"
      ]
    },
    {
      "cluster_id": "96d3560e-8a14-4ba4-9eb9-c3d21f7bd78c",
      "members": [
        "e913e2bd-7e82-4b5d-a9ff-9aa52fe9d532"
      ]
    },
    {
      "cluster_id": "8ee4279e-4251-4f38-b5e1-7ebd99d489b8",
      "members": [
        "85be5d28-9be0-4f96-b52a-a84d13ba804c"
      ]
    },
    {
      "cluster_id": "5ba8f9fd-9c3a-4fe9-8167-be994f757ac9",
      "members": [
        "4edaedb4-1177-4c33-8fe3-a9c57ff64be5"
      ]
    },
    {
      "cluster_id": "1fa41b69-dd08-4cf7-879f-ed94078d9d64",
      "members": [
        "b34f9294-31af-458f-9f7a-e810c428c647"
      ]
    },
    {
      "cluster_id": "7a13b273-8feb-4f23-b79f-e5f89124c43d",
      "members": [
        "76779a0a-a497-45d3-960f-6b7640ef3be9"
      ]
    },
    {
      "cluster_id": "bddeb0a4-a8d3-413c-8b74-f7a5d1e4bffa",
      "members": [
        "c81c8c92-df86-4bef-8972-2c3dced462e8"
      ]
    },
    {
      "cluster_id": "471e4e9c-4ca9-4ee9-ad65-9f3b0fd313ec",
      "members": [
        "ff19f0b5-e0d1-47f2-99b1-fd16c13252ab",
        "8ee37723-897a-4a6f-8b39-4c7dd211b1c1"
      ]
    },
    {
      "cluster_id": "4a989aa5-e7cc-4043-809c-9f42086f32b3",
      "members": [
        "44e8bf4b-1ea1-4a06-837d-f5d274fc6298"
      ]
    },
    {
      "cluster_id": "db5ce7c4-0a90-4c8e-b702-060aaa2cd9c6",
      "members": [
        "049dc814-2eea-465a-ae77-96f8303282b5"
      ]
    },
    {
      "cluster_id": "90811b8e-940b-4a7b-bb43-2f0cfe36a594",
      "members": [
        "551694f8-1f83-4aae-9c9c-41e537b939b0"
      ]
    },
    {
      "cluster_id": "52a6626f-4f02-4c13-bf77-4f58640d6881",
      "members": [
        "2db5c7f5-ea01-4b89-ae5e-8c37f503a871"
      ]
    },
    {
      "cluster_id": "104cce1d-7dd6-445b-b83a-f1e498dd3f09",
      "members": [
        "a26573e7-d94c-4d97-b963-0a2f88d078a6"
      ]
    },
    {
      "cluster_id": "117ab6df-7ea4-4ab9-806f-9ec47da0be63",
      "members": [
        "16ee9cf2-3b9a-4256-bf89-3596588e2d8b"
      ]
    },
    {
      "cluster_id": "e1314480-d543-4a51-a6ee-6dc61dbfa929",
      "members": [
        "2e286ee4-f7c4-4ce4-a624-6aa5fbe4cdd1"
      ]
    },
    {
      "cluster_id": "db72597d-c5a9-4920-978e-26eb63ca559c",
      "members": [
        "8dd2c93f-1d8a-4a4a-ad86-633bda279731"
      ]
    },
    {
      "cluster_id": "a80e30ca-b2de-458a-9b37-eea9f6f3a278",
      "members": [
        "f75f429b-c285-4736-8bb9-77a0444909b7"
      ]
    },
    {
      "cluster_id": "cfc691ea-395c-407e-9d4f-47222067d9ee",
      "members": [
        "d12cb5c7-b7f9-47be-b6b4-700896da05da"
      ]
    },
    {
      "cluster_id": "e2a8c8cd-cdce-473b-b2cd-fa97668f4fb5",
      "members": [
        "83856f5d-cd5d-42a7-8bb8-86fc5023ba6c"
      ]
    },
    {
      "cluster_id": "b5146023-e397-4082-afc2-a8c71c288767",
      "members": [
        "301e6dd0-28d1-4fa7-93e7-d1e276348db1"
      ]
    },
    {
      "cluster_id": "60581c58-3e78-4ab6-b577-5edbcc9dc29c",
      "members": [
        "895a1573-a6e8-42d5-b8a3-63fd2799a409"
      ]
    },
    {
      "cluster_id": "6773439f-27bf-46ee-884f-6f78667de502",
      "members": [
        "981e2b7e-9aa1-4557-9067-b3e3be09f2f7",
        "c0188ef1-6375-4482-98b4-030fb26f3e5a",
        "471b5c6a-be85-43f0-8f08-c5d4074a62de",
        "07a7f429-0b04-4bb2-9b73-31695a425c61"
      ]
    },
    {
      "cluster_id": "d5fb5705-8036-4366-acc0-f2b5f625126b",
      "members": [
        "46e5b7e0-08b0-4865-b903-843b9996b895"
      ]
    },
    {
      "cluster_id": "63ff4667-bd37-45e5-853a-bf5f312c00b3",
      "members": [
        "1c6df9bd-4737-4ab4-82f7-3eb4f752c444"
      ]
    },
    {
      "cluster_id": "4c667681-74f7-4591-9add-d06796315d33",
      "members": [
        "503b473d-f061-4805-be91-d667d63484bb"
      ]
    },
    {
      "cluster_id": "6a85e8dd-d86f-4e00-b252-62364be2e0ab",
      "members": [
        "6b2df06c-a07c-49f9-b5cc-626c29f8439e",
        "2d41128c-909b-427b-8694-6449842d91e9",
        "893ebd52-72c9-4155-ab25-1ebc612f8af1",
        "96f5d8f6-6d67-435e-99b5-5e35770b7fed"
      ]
    },
    {
      "cluster_id": "fb8928a2-09db-488e-818b-8455b9d3b5aa",
      "members": [
        "69d75edd-3449-4b43-a59e-e9fd47b7ae01"
      ]
    },
    {
      "cluster_id": "ecf70116-2753-4a2e-946e-961f8655a246",
      "members": [
        "5abcc1de-96c1-448c-a6d2-4ea7fb6cf619"
      ]
    },
    {
      "cluster_id": "69a4b47b-f3fa-41cb-94e3-29a8741c8bf2",
      "members": [
        "cae0288a-9c2b-403c-8e17-3d152591cb2e"
      ]
    },
    {
      "cluster_id": "5c321eda-59e0-4788-8faa-0808e6c83192",
      "members": [
        "d5619de6-e379-4c21-9e41-7b82d2e9cf09"
      ]
    },
    {
      "cluster_id": "dedbca30-3396-4307-a69b-7d7c22f5347b",
      "members": [
        "f38ee2fc-4c47-402d-9dc1-e453902b37dc"
      ]
    },
    {
      "cluster_id": "bf7032f5-cf58-46a3-b595-6510ffda5c2d",
      "members": [
        "7dd19033-9011-4652-a273-02ba7b167fbe"
      ]
    },
    {
      "cluster_id": "ae6a51a8-019c-4d5d-a0b6-079828d681e6",
      "members": [
        "5d015e2b-e346-4f80-bbc2-2d133e230e4a",
        "f7cf7d1c-ea4a-4708-a6f4-9f7fee9cdaba"
      ]
    },
    {
      "cluster_id": "c749df3e-51ac-4d1a-87c6-d17e674f6446",
      "members": [
        "56b67639-9bd2-4892-a5b3-68dd79b4da68"
      ]
    },
    {
      "cluster_id": "065d4388-2dbc-4873-991f-3569f0444b8e",
      "members": [
        "f61b81e2-62fd-460d-80c9-6bf63aa9c42d"
      ]
    },
    {
      "cluster_id": "eee5559c-ba4e-40fd-8448-3d09c753f9ba",
      "members": [
        "62ca5e08-c759-40cb-bfe4-9e7efd707a0e"
      ]
    },
    {
      "cluster_id": "d1dbd6e1-d934-4ffc-ba5a-8d6ce10501d3",
      "members": [
        "4a1d7ffd-9e6c-41be-87e9-e7b2bb5ada22"
      ]
    },
    {
      "cluster_id": "c2075982-499b-4dcd-9327-be17e07c166f",
      "members": [
        "5f29be91-c5bd-4152-8198-05bf8559430f"
      ]
    },
    {
      "cluster_id": "120d5e71-28b6-4974-a584-3c9108ae5780",
      "members": [
        "12ebd395-a9a9-48a9-93d5-f22ee31eb5a0"
      ]
    },
    {
      "cluster_id": "2a492648-efc4-44a2-9eee-4d95d05d104b",
      "members": [
        "659db844-2578-4f14-a374-26004e52686d",
        "ae95c7d1-8919-48a3-b7af-269c6f2fd92b",
        "1fb2122c-caff-46d0-8d3c-6d03fba686fd",
        "c9b72f24-65bb-4256-b0e4-1717a833ac47"
      ]
    },
    {
      "cluster_id": "fece93a1-7734-48a4-99b6-9dce302454b2",
      "members": [
        "65eedcdb-e7eb-4498-b22c-60af062d17cf",
        "6c4cddc2-2c7c-432e-8213-e905a1d3738a"
      ]
    },
    {
      "cluster_id": "fef1afb7-cb5b-46ac-9d94-a3b448d7fa82",
      "members": [
        "8a36bca0-072a-4757-8ae6-18b33483385b"
      ]
    },
    {
      "cluster_id": "41739d94-ef7a-4bdc-b95f-35d9d4daaddf",
      "members": [
        "2da13781-4048-4b5f-b4cb-a78577f53431",
        "97852f8a-f5b8-43ae-a75a-95eb5ed90c03"
      ]
    },
    {
      "cluster_id": "fbf6086c-d11b-4ab9-9b6b-67f0d133c827",
      "members": [
        "8256eadd-706a-446e-a58c-9cc14fa415e9",
        "67ff8a4d-3d4c-42ea-a799-b5bf7cfd1c27"
      ]
    },
    {
      "cluster_id": "3c2e5bbb-18fd-4888-959d-c7aef1790267",
      "members": [
        "c6345b60-d5ec-4372-b335-bcf12bd680cb"
      ]
    },
    {
      "cluster_id": "f4ad4efd-4ba9-41ef-9de7-a560663da99f",
      "members": [
        "b786b12a-50eb-40a8-aee4-17dbff29a504"
      ]
    },
    {
      "cluster_id": "ec281f2d-d4ef-4a4e-a1f0-552896c7315d",
      "members": [
        "30bf0937-8a19-471d-95a6-cb0d6e8a310e"
      ]
    },
    {
      "cluster_id": "c6e2d109-f8d1-42b8-bb0d-16083a37ad8e",
      "members": [
        "ad4528b2-4f55-499b-af2d-b03fbedd1e7f"
      ]
    },
    {
      "cluster_id": "ccd825e8-99a9-452b-8ea7-e5e98518daca",
      "members": [
        "b597baf7-408d-4792-9acc-5679c205c646"
      ]
    },
    {
      "cluster_id": "fe82d3f9-486a-46c2-97e7-5a1b97f02537",
      "members": [
        "966f752b-1058-43b6-b60f-d845aa2120e1"
      ]
    },
    {
      "cluster_id": "21aa3ba8-e0ce-434f-bbd4-03d295297e84",
      "members": [
        "45ecf42f-bf63-49b6-b2da-85a73193e857"
      ]
    },
    {
      "cluster_id": "7fa3c63b-2bb5-48ea-95da-cc1ed541a317",
      "members": [
        "67cb95e5-2f8d-436a-be98-cf9a58fef5c1"
      ]
    },
    {
      "cluster_id": "612d697f-8136-4aba-a8a7-d6de87a2c992",
      "members": [
        "ecb44f8a-8e35-467d-8ca2-17673dfd6e43"
      ]
    },
    {
      "cluster_id": "db9f2811-0988-456d-94ba-acf8fa9e6c6e",
      "members": [
        "62336475-296d-4838-9a8a-b833a4d4142c"
      ]
    },
    {
      "cluster_id": "ab19e784-fddd-46e2-a989-cdf804b997c6",
      "members": [
        "860124bc-f2a7-4ab6-9e29-44cc8b056d61"
      ]
    },
    {
      "cluster_id": "06b0b383-d1f3-4b0b-96d7-d1ed1424d080",
      "members": [
        "cc7fd350-9a27-4fd5-9054-e6c7b35e05fc"
      ]
    },
    {
      "cluster_id": "9a693a02-7bfa-493e-8c56-142555000e80",
      "members": [
        "cfa0a8a3-c151-4166-a74f-93d11dbf5202"
      ]
    },
    {
      "cluster_id": "02bc5fb8-e0fa-4719-bd7d-c08bd3e70f93",
      "members": [
        "cfcd7cc0-f8b2-410a-b690-144365d976fc"
      ]
    },
    {
      "cluster_id": "7a1c3f26-b729-4a3f-8142-fcd9c6768773",
      "members": [
        "85358ada-ded2-4e3c-a579-c736936f7e8c"
      ]
    },
    {
      "cluster_id": "22a57fde-1c2c-4f1c-9861-888038d4fe31",
      "members": [
        "dbe30528-7d99-4b74-8614-cf0c78e26962"
      ]
    },
    {
      "cluster_id": "9fb5a955-823a-4864-b411-b2e83454581e",
      "members": [
        "79d49a22-5863-4981-889b-19072d9fbed9"
      ]
    },
    {
      "cluster_id": "a34d03f2-7fce-45f7-b77c-0c16c720e6db",
      "members": [
        "fd0e1ca9-5c9f-4ff3-96d7-c06309f99fb1"
      ]
    },
    {
      "cluster_id": "7b901b41-b4fa-460e-bc66-e732ffe7ab8c",
      "members": [
        "7fd37d9b-515e-4e44-8623-a14228b18536"
      ]
    },
    {
      "cluster_id": "b61f6891-5a9f-49aa-8194-10b89513a5a2",
      "members": [
        "9758342d-846f-48e2-8b92-5eeebda6d84f"
      ]
    },
    {
      "cluster_id": "dc991813-e94c-49ef-a261-7e441b9dfb8c",
      "members": [
        "d29761e6-4997-42d1-93ea-195b123004a8"
      ]
    },
    {
      "cluster_id": "fe283f5f-5575-4095-b65a-cb6fe0d25e44",
      "members": [
        "339098bd-e1e6-4550-b6d1-60f25374586b"
      ]
    },
    {
      "cluster_id": "442fa925-31c9-4639-8516-7ca59dfe469b",
      "members": [
        "2f3fc5c4-6bcf-4eac-81b9-d55526479821"
      ]
    },
    {
      "cluster_id": "d152f743-9bb8-4932-b2e3-17b89ab993fc",
      "members": [
        "4e26b60c-4367-4953-9339-80b88881cb04"
      ]
    },
    {
      "cluster_id": "bbb1bc4b-f3a4-434c-a53d-625f1645e395",
      "members": [
        "e43e52f7-2fa4-4458-969b-ae3a70bed2f0"
      ]
    },
    {
      "cluster_id": "d6133b17-e010-4dda-908f-2aa315f15880",
      "members": [
        "0cb5aab1-def6-45ea-a897-dd13a4fcb291"
      ]
    },
    {
      "cluster_id": "9db7cf05-3384-426e-a814-edb55b15d53c",
      "members": [
        "b5543f8e-006b-454f-b7e4-1c6ed17817fa"
      ]
    },
    {
      "cluster_id": "0affe3d3-ec5f-48dc-87ba-10392622a134",
      "members": [
        "196b27e2-32f7-4bf1-b456-88904d80aec9"
      ]
    },
    {
      "cluster_id": "5ee5ee7a-bfa2-482d-bd3e-efb0d1c8544c",
      "members": [
        "c04f81b8-5be6-4f6d-b8da-32d6aa21d84f"
      ]
    },
    {
      "cluster_id": "d09cadfe-f589-4fe2-9bf8-e5e3a0697237",
      "members": [
        "59bf1e25-ae86-4f29-97b8-78581d3d04f3"
      ]
    },
    {
      "cluster_id": "8ab3c3be-4d7d-4248-a148-6cf7cee2fef5",
      "members": [
        "60bf6c70-bd10-4413-b426-9d11a9653a75"
      ]
    },
    {
      "cluster_id": "a55753e6-8f8f-48dc-b731-3ea6f869cd52",
      "members": [
        "ca0212d6-7c4b-4e02-b239-11ce52df0bc4"
      ]
    },
    {
      "cluster_id": "ec3d0509-3f1c-4d1f-868c-ba7c16468992",
      "members": [
        "b110c694-281d-45ef-92e8-c0b9affcb346"
      ]
    },
    {
      "cluster_id": "c4df2ece-fef6-47b5-b7cc-a9846a2066d1",
      "members": [
        "0e3d2cc6-1066-48dd-a27e-244e62a48617"
      ]
    },
    {
      "cluster_id": "35826418-a010-4d4a-99fc-5e4fe849cbd8",
      "members": [
        "bcc544a2-efaa-40b7-84c7-71cbad343f84"
      ]
    },
    {
      "cluster_id": "b0d55664-d514-4b2b-87ec-b7bb14627d05",
      "members": [
        "1d65d8ef-b267-4c53-9e26-c6c5beaced86"
      ]
    },
    {
      "cluster_id": "52ede4ef-4c19-445c-ad39-2f9ff6488929",
      "members": [
        "4a658a81-28d6-4abe-9832-22c1a7e3e16a",
        "ffa9efc7-e24b-496f-be05-08f89416a77d"
      ]
    },
    {
      "cluster_id": "df890887-499a-48f3-b818-746e4296c3f6",
      "members": [
        "da266b40-9b7e-4f6b-b6b9-b4f5073e68af"
      ]
    },
    {
      "cluster_id": "efe217b1-d8a9-48f6-b1d3-7579e75d7788",
      "members": [
        "b7bbcc42-c9a1-444b-9fef-ed1c7e0ad146"
      ]
    },
    {
      "cluster_id": "4d26360a-40f3-4825-be04-23732d33f83d",
      "members": [
        "9ef0d9f0-7a35-4e5b-ad5b-6dc0c299e527"
      ]
    },
    {
      "cluster_id": "c5394d0c-cc56-4b26-835a-5c9581cceb3a",
      "members": [
        "e4b1d43c-bbc0-4bc4-8b5a-09ae200e4b31"
      ]
    },
    {
      "cluster_id": "99775dd2-fc60-40f8-87bb-cfdaeb07bbae",
      "members": [
        "0d409954-3f1f-4a11-a677-fabc5e45f83c"
      ]
    },
    {
      "cluster_id": "bf6df861-08b0-407b-91a8-c65beb04c1ff",
      "members": [
        "459f6d39-89f1-4124-b6d3-782d4a49df4f"
      ]
    },
    {
      "cluster_id": "8c2c4d45-17ad-4731-921d-8582fefe2ba4",
      "members": [
        "c8b58a8c-445b-433a-993c-fc7a82490c95"
      ]
    },
    {
      "cluster_id": "075f6940-c670-4659-a33b-590bac9f8a7f",
      "members": [
        "d9878fd5-bcaf-429d-8863-615171a1955a"
      ]
    },
    {
      "cluster_id": "ea8c27e8-3141-489f-a75f-e180b110cc1b",
      "members": [
        "72eb9227-e645-411f-9e19-1b02d4ed398f"
      ]
    },
    {
      "cluster_id": "0c9df761-94e1-484a-ad16-41bb0a7c5fb3",
      "members": [
        "567319b3-8cbb-4fec-8699-f5d50156c4da",
        "59e758c1-c8a0-4494-ac3a-233f6cf71575",
        "aabd0189-1323-4f67-92ca-fda61971db3e",
        "8f4acf67-0350-4998-bea5-99144f2284fc",
        "37d9a2a5-ee4b-41f7-8007-1c62d3954975",
        "a138054c-510f-4593-b3ab-f16d92c84668"
      ]
    },
    {
      "cluster_id": "a56438b9-f9ce-4dfd-beb8-0ced3dfad829",
      "members": [
        "075cddf6-23f3-4430-888a-d7e4bceaf569"
      ]
    },
    {
      "cluster_id": "c65c30a8-6203-4ff2-8126-866ddc1ad7ee",
      "members": [
        "64a4b6bb-e6f8-4c75-98cb-8cbcd3022f9c",
        "3980372c-6d98-4653-89d9-f9049985a93f",
        "d154989b-b1ce-4814-bd5b-a69ca1172f9a"
      ]
    },
    {
      "cluster_id": "f1494984-39fb-445c-9005-4614903b112c",
      "members": [
        "26d0e6cc-2b41-475c-8845-f74aa9d04201"
      ]
    },
    {
      "cluster_id": "c61c4f53-7efe-4e66-9392-b281164f47d2",
      "members": [
        "073afdee-e01b-46aa-a9c6-1829a7761aea"
      ]
    },
    {
      "cluster_id": "65f3a4f7-31a9-4a5f-92ab-a9f153d96b50",
      "members": [
        "1294ad29-53d1-48f4-810e-59099cff540e",
        "da287e57-b1d7-47c8-b66f-9376a1577d52"
      ]
    },
    {
      "cluster_id": "1a861c93-c5c6-48c2-b775-34eb4363839b",
      "members": [
        "9e3c28e4-6c0a-44a5-8ad1-a17e10e5fded"
      ]
    },
    {
      "cluster_id": "f7318431-bfb5-4f5f-a2ea-e4c01a34de08",
      "members": [
        "f11bc561-5265-46b4-be24-784619995d03"
      ]
    },
    {
      "cluster_id": "fe966747-5532-4145-9e61-737006d6b37e",
      "members": [
        "f30b12d4-dcd1-4f56-aebf-112510f25d5f"
      ]
    },
    {
      "cluster_id": "9fde602a-5d0b-4ab4-85c7-e2300402299d",
      "members": [
        "45421d92-486f-4312-b002-49b5d0a5a857"
      ]
    },
    {
      "cluster_id": "e6db83d3-cda9-4430-8a6e-a7718c384123",
      "members": [
        "48b2d768-230a-4aa5-ab8a-5743244c1e3a"
      ]
    },
    {
      "cluster_id": "6781bc51-3496-4995-a431-ee10c271f91c",
      "members": [
        "4acf7638-53e6-40c9-a142-69a12748f1f2"
      ]
    },
    {
      "cluster_id": "db160e2d-890a-4e75-a5da-9daa0f1dd2e9",
      "members": [
        "80cc3b20-787e-416c-b035-1cd977c998e2"
      ]
    },
    {
      "cluster_id": "9bab6bab-ced4-428f-ad92-fd02b9600f3a",
      "members": [
        "b3b31d70-3d5f-4d91-b7cb-39885ce4fcc6"
      ]
    },
    {
      "cluster_id": "2913b0c9-ef79-4e98-9ca0-9e5e2abf9938",
      "members": [
        "966a16e0-bee9-4168-8b73-67eea3f7ae0c",
        "06f007c0-e0de-480a-93d5-26f93d3f7cea",
        "40aa8d69-a7d4-49c3-bdd0-de57bbff31d7"
      ]
    },
    {
      "cluster_id": "d640924f-577c-4904-972f-ea78d30a1b14",
      "members": [
        "2404a11f-7524-43e2-a24c-41424b74bb3c"
      ]
    },
    {
      "cluster_id": "84a7917f-8218-438c-a1b9-0e45b12c8e34",
      "members": [
        "c9bc0260-f4d6-4947-ba76-41372364aa42"
      ]
    },
    {
      "cluster_id": "3804062b-b30a-4f19-918a-426ffa4b1df7",
      "members": [
        "26adcb73-598e-4f08-976b-f78de7e92ed2"
      ]
    },
    {
      "cluster_id": "ac7642b8-b25c-45db-8998-1d3c7f1c25e7",
      "members": [
        "b4881885-8b42-4b2b-bc5e-2427d67b85b7",
        "97e9dcc9-5f54-4f83-b653-40d574bdafb2",
        "a091cb20-bdd6-46a4-b260-73d734a445d1"
      ]
    },
    {
      "cluster_id": "49ec4675-cceb-45d5-bbb2-56483fcd1319",
      "members": [
        "c55607db-643a-4cbc-b25f-1a43cc9cbce4",
        "94db3d3a-fce0-4c90-bfb1-3758ab374e4b",
        "7c13746a-776d-491b-9b30-589340d3a403"
      ]
    },
    {
      "cluster_id": "f7f70f61-0229-475b-8a17-6b4740f661e4",
      "members": [
        "b1e5a97e-b8a4-452d-8367-66915839ebfd"
      ]
    },
    {
      "cluster_id": "55822882-d3bc-4c00-a9c9-30a5c71ddf43",
      "members": [
        "cbf18eaa-c607-475a-81b4-cbf05023e7bb"
      ]
    },
    {
      "cluster_id": "9e7c5d20-49ac-489c-bf49-38304a7e5439",
      "members": [
        "e1772e61-1e20-4382-be94-490d349fea1c"
      ]
    },
    {
      "cluster_id": "c9b63381-9a94-41a6-b33b-4c75f981d835",
      "members": [
        "e3bf6429-0f20-4ba4-8b26-665f3b75e5a4"
      ]
    },
    {
      "cluster_id": "e47f2b16-ab13-42c0-addb-b9a5881b56d2",
      "members": [
        "ceb9cdf7-9d46-4c9f-8740-f061565ccfa8"
      ]
    },
    {
      "cluster_id": "9a5830fb-a855-4c85-8daf-ed1be558a290",
      "members": [
        "2e025176-d873-4617-8b4e-6f437ac9d311",
        "0dc997c4-c48b-4969-b36a-a7b3f9b227d3"
      ]
    },
    {
      "cluster_id": "73b5bb5e-19ff-4738-bc4e-5908ad8a0474",
      "members": [
        "5562bd6c-3644-4029-b8b5-49f3069414b8",
        "1bba37c6-dcbf-4c61-b3cf-bad3ef1aec62"
      ]
    },
    {
      "cluster_id": "5a9527b4-7ddf-4c5a-b860-67170fb02224",
      "members": [
        "ed917cad-09cd-471c-b261-f1d3e72fd003",
        "3d663718-e7d2-4e18-9008-11c863444483",
        "bda421f3-b15a-4ef0-8627-b9e4ff9795af",
        "2bd084e4-6041-473c-ace8-09633da445b7",
        "107525d3-a6d1-4661-8fc3-97818c3422d7",
        "9e2c67f0-d232-4772-bff4-99e0672e6621"
      ]
    },
    {
      "cluster_id": "fa366373-444d-4a8e-8a61-fb8973c8426c",
      "members": [
        "d6bc271e-34c2-44c8-beaf-77b2fd2c80fd"
      ]
    },
    {
      "cluster_id": "841f304f-f4f1-471e-aa1e-5c0818b42f86",
      "members": [
        "4015b7c3-dd2a-4989-a19d-85367b1ffbff"
      ]
    },
    {
      "cluster_id": "5f903470-ae17-46df-89e3-72da3d3117a4",
      "members": [
        "99e605c6-f488-456b-bf0d-9dbd2b9f9003"
      ]
    },
    {
      "cluster_id": "bc4c213d-8b78-447a-9835-0a8c9c8149b1",
      "members": [
        "fee08dde-a2d5-4671-bebb-7cfa33586d86"
      ]
    },
    {
      "cluster_id": "7348cd32-1a61-49ec-88d2-09ed7c4e132b",
      "members": [
        "8e31e618-084f-41ef-b498-669073ce1420"
      ]
    },
    {
      "cluster_id": "ca521545-0a79-4ba0-851e-a60589334127",
      "members": [
        "eeb0fdb7-038c-4e03-9e57-dce06231b27f"
      ]
    },
    {
      "cluster_id": "e541bcb9-7f32-4df3-a682-0d185b753537",
      "members": [
        "08a265de-ddd4-41d9-9c9b-e726f7e578c2"
      ]
    },
    {
      "cluster_id": "e2835c22-b372-4e91-9b8e-5ef637ee8966",
      "members": [
        "22efaf13-bae7-48b9-ac24-b658143c6474"
      ]
    },
    {
      "cluster_id": "c8a1c00c-d162-4708-afc0-8961e0642155",
      "members": [
        "ea62de52-12d4-4d81-8a68-5fe74dc5074e"
      ]
    },
    {
      "cluster_id": "4a33c4ea-c4b1-416d-9b76-df3e2b9c5ec9",
      "members": [
        "70d7fa7f-606d-4df7-a886-ac349df9049e"
      ]
    },
    {
      "cluster_id": "ba62b16f-4f39-4172-b2c7-0b991499ca69",
      "members": [
        "96fbbb85-f272-4a7f-beb5-baf8b1586d33"
      ]
    },
    {
      "cluster_id": "fc5ae33a-0165-41ca-a5df-b2b0a56f5100",
      "members": [
        "d71b3006-88b0-41b1-b3e5-9186f225d79d"
      ]
    },
    {
      "cluster_id": "346b1dc3-219c-4228-a017-da35814deb33",
      "members": [
        "eeb6921f-9f1d-4f99-a547-4bbd68995d30",
        "0c82cd62-35e8-4be1-a241-0e3314700361"
      ]
    },
    {
      "cluster_id": "602ccd3f-b2b7-474a-9029-74260beb7902",
      "members": [
        "8191a74c-d1ab-47a8-9174-f0d5cbfd58ca",
        "320f8044-4928-405e-98ad-346aac87e661",
        "91111922-c5d4-4a81-8de2-6b66f1c3279b",
        "90ceca1b-3c57-4f9c-9fa7-8efa71128ef7"
      ]
    },
    {
      "cluster_id": "0103bebb-a8e1-4ccf-b716-fa6fd4687ac3",
      "members": [
        "b53eff8f-aadc-42a8-ab34-a617398456c5",
        "e2cc944e-8a81-4438-83eb-08e38d9b479c"
      ]
    },
    {
      "cluster_id": "c8feb5d9-ef93-4465-bcb1-5c7e4847fb27",
      "members": [
        "4e94fa2f-75fd-435f-9008-7932c588c0e3"
      ]
    },
    {
      "cluster_id": "155333a7-ab36-4219-a8f6-9496d1f00dc8",
      "members": [
        "ed3e4012-24a0-4a30-aef0-11715ad3f744"
      ]
    },
    {
      "cluster_id": "a19f2358-dc1d-4de3-8588-b9d055ccede4",
      "members": [
        "afca75d1-e3a8-40b8-b590-69bddd25646a"
      ]
    },
    {
      "cluster_id": "e228a8c4-9bff-4634-a77f-16ed4aba6a89",
      "members": [
        "ac1155ef-570d-42ff-9439-4132f58aa74d",
        "302e816b-f422-46c4-86df-22ab149772ca"
      ]
    },
    {
      "cluster_id": "adf7c833-60db-4866-83b7-e6d0f1133790",
      "members": [
        "a8695eab-8246-4726-b5e9-2e579aabe031"
      ]
    },
    {
      "cluster_id": "6e339b28-0894-4d85-a536-569236e90bbf",
      "members": [
        "d0146263-c582-47b2-8757-4deb785b6900"
      ]
    },
    {
      "cluster_id": "5eaa7b8f-5e2f-4cc2-827c-b780c20bc557",
      "members": [
        "302853a2-fb88-4896-9616-6741fd099aac",
        "ebec5226-e1a3-41dc-aadc-8c4d372988e5",
        "d929b334-9fdd-4c58-a430-ec532b3d7d49"
      ]
    },
    {
      "cluster_id": "2d92a79a-ce61-4af0-b8af-8322336cee3b",
      "members": [
        "914af81b-99f3-4771-ad7a-a28ece1a25e1"
      ]
    },
    {
      "cluster_id": "c6098f7c-9ca7-42cb-9f44-6b467087e324",
      "members": [
        "0f0a3feb-fe9f-44dd-866d-26c18406276a"
      ]
    },
    {
      "cluster_id": "ed2533cf-2013-4e49-885b-231a6c55f0fb",
      "members": [
        "b5731f9d-93e5-410c-b508-af876a95e93e",
        "f07a5bb2-52e0-4447-921c-e5afec933df2"
      ]
    },
    {
      "cluster_id": "3df2dbeb-6250-425e-8956-8daf269e1976",
      "members": [
        "d1e32d54-7605-4c03-9379-6fb1f04f9705"
      ]
    },
    {
      "cluster_id": "38fb1864-3682-4d4c-81c3-5ce8e0bbc80e",
      "members": [
        "a5a0e63e-a40f-4653-b49f-b08501abfb44"
      ]
    },
    {
      "cluster_id": "827e3030-1738-4370-a530-42878dd6927d",
      "members": [
        "8b83fac7-c728-4306-a23a-fa7239f16085",
        "1d81f6e5-45a5-4b20-82c9-3a1c00a30b73"
      ]
    },
    {
      "cluster_id": "a54ebcea-b85a-4358-b8f9-7f678d18fb51",
      "members": [
        "92aedbd2-b062-4251-8a00-dc65bac74d4c"
      ]
    },
    {
      "cluster_id": "80adf73d-0e40-41bf-902a-efc33053db25",
      "members": [
        "b0b293e8-0639-41aa-b1a3-39f70d6c4033"
      ]
    },
    {
      "cluster_id": "8b1769db-6aae-4f31-8eca-13c7641a8a79",
      "members": [
        "c97a3438-9ff1-491b-a8e6-64b881df842a",
        "c72ffe7e-58cc-4d2a-86b6-10bd9f697b5f",
        "20c808b1-fae8-4461-9cd2-903c3c6dd6ce"
      ]
    },
    {
      "cluster_id": "bd2a5352-41e8-4479-ac51-89fb57ca65cd",
      "members": [
        "0b41f824-fa87-4638-b004-e5ce1e8425a8",
        "3d87295a-229b-4465-8a0b-4118c603b1de"
      ]
    },
    {
      "cluster_id": "2ef5fcdf-761e-402d-8549-a04bd0b86028",
      "members": [
        "b2c435b6-21f1-4e3e-9b9e-70fd33a7816e"
      ]
    },
    {
      "cluster_id": "ceded39c-ad6f-4d12-9e04-8034f780e209",
      "members": [
        "b4054bff-2507-43d7-aafc-6ffe90087e86",
        "984d798b-65ca-481c-a6fd-8b4a2a459f92"
      ]
    },
    {
      "cluster_id": "c16a80f4-74b2-4799-878f-766f008df3df",
      "members": [
        "ee09ba8a-7d35-40f4-8c9a-596a029c42cf"
      ]
    },
    {
      "cluster_id": "4a121497-0e52-49d8-8aba-88f4fe1ef31b",
      "members": [
        "f73719c7-0c81-4646-8507-3d12750a599b"
      ]
    },
    {
      "cluster_id": "fc33211b-6f76-4ea3-8d05-51362bd964b0",
      "members": [
        "625c1b7f-d304-4eb3-bfaf-a0c0a690ca38"
      ]
    },
    {
      "cluster_id": "7afc1db8-da22-4a16-9a76-d5155374bce3",
      "members": [
        "aba98aef-afc1-4471-a4a7-7dde428a52b2"
      ]
    },
    {
      "cluster_id": "0f5dbdfc-39dd-4747-8fd7-3316ceae5bdf",
      "members": [
        "b379680b-f10c-4990-be8d-21679d10a1fb"
      ]
    },
    {
      "cluster_id": "50ed7708-9545-452f-b227-8fc95b9490b9",
      "members": [
        "3f3e0fb1-eae8-4080-bf01-d3e1fff5f2f2"
      ]
    },
    {
      "cluster_id": "fad9d4a0-4f96-4cbe-870b-9fccf870e5e8",
      "members": [
        "0164cbdb-5835-494f-bea8-4b0f499cbdbf"
      ]
    },
    {
      "cluster_id": "e90f8735-8232-4af5-85c8-b777502c4f0b",
      "members": [
        "50755e27-77b6-427f-93dd-a87731a11646"
      ]
    },
    {
      "cluster_id": "5bdf6eac-3c30-44f7-ad10-121cdd88f987",
      "members": [
        "d4c1d571-a06c-4ee5-91dd-4159cee958ba"
      ]
    },
    {
      "cluster_id": "e0af4c3d-214d-424d-955e-14071d90129c",
      "members": [
        "8a7c278b-a05a-47e5-a782-f333e3abd311",
        "12fb89a8-7d3a-44d8-9034-eb35ba71efe1"
      ]
    },
    {
      "cluster_id": "cb5e091b-477e-46e6-aa3e-6f7875bd065d",
      "members": [
        "3719c3d8-be42-4a6d-aea6-0faa841a3224"
      ]
    },
    {
      "cluster_id": "418af057-88c5-4485-917f-178851436407",
      "members": [
        "463e2730-3293-4e8d-b87b-d16f9fde8c30"
      ]
    },
    {
      "cluster_id": "afc0b94b-3d14-41ac-a746-8c4fbe3bd721",
      "members": [
        "f88219d8-400c-4903-9cf1-aaf5dc8c6ce1",
        "98f37028-97a3-4ac8-b09e-145a9b1fab36"
      ]
    },
    {
      "cluster_id": "748efe6a-9ff2-447f-9d13-f72501f7e924",
      "members": [
        "231bd0ea-a301-44d9-a0fd-8b1f75fb9a13"
      ]
    },
    {
      "cluster_id": "b4d1a337-88d8-4989-8d52-1a04d38e6e21",
      "members": [
        "f134ec02-dc6c-40cd-af19-e83401adec30",
        "3a81ca66-f500-4e6b-92a7-0400526c47e9",
        "2332057b-0bbe-47b7-b70a-de96fc18e69c"
      ]
    },
    {
      "cluster_id": "ecb3f4fd-fe1b-4ef4-a13b-94c4c7eea90e",
      "members": [
        "73ce06b7-ecbd-4700-b340-1fae1a530920"
      ]
    },
    {
      "cluster_id": "b9b5e870-c720-4c60-8d9c-ce6b4803fb78",
      "members": [
        "37be92fe-4739-4a8d-a3a8-9967c770e07b"
      ]
    },
    {
      "cluster_id": "63fb948c-76fb-4787-aafa-ea3ce79ec01f",
      "members": [
        "f36fd863-41fb-4892-8b41-fa4f145056b2"
      ]
    },
    {
      "cluster_id": "f004205a-4f06-4d9f-aafe-357afc465bbc",
      "members": [
        "75e474b7-52a7-4ce0-93d3-5c5b15d37224"
      ]
    },
    {
      "cluster_id": "d3accedd-14e9-432e-a272-98af2dae3b98",
      "members": [
        "87bdf665-a018-48bc-b1bb-90ecd420038c"
      ]
    },
    {
      "cluster_id": "ee97e835-1007-4cd5-b270-714f0880c07e",
      "members": [
        "46ee1a0b-a0b7-49f9-8b25-48fbc78eec74",
        "819c7079-e076-42eb-a9ad-1828cd7d30dc"
      ]
    },
    {
      "cluster_id": "d32bd6fd-0fc9-411f-b6d0-ef85e52f9cf2",
      "members": [
        "a64fb6fe-0fc8-43ff-8d37-977d9877692b"
      ]
    },
    {
      "cluster_id": "107cb2f5-f373-4a33-aa9c-b2f0173d4807",
      "members": [
        "6fe08ef8-5a44-4e36-84d5-fded1981aaea"
      ]
    },
    {
      "cluster_id": "763d8e8c-b156-404c-ae43-97e544b0ec16",
      "members": [
        "5d2dd122-64ca-430f-8ef0-a4833c97a70c"
      ]
    },
    {
      "cluster_id": "7abc7765-0bd9-4361-a00a-d261cc270c4f",
      "members": [
        "87ec48c4-b7e0-4dda-b630-292aba0fe9ad"
      ]
    },
    {
      "cluster_id": "b56ca1ab-f300-4476-ac21-f73e07a1dfa9",
      "members": [
        "b79ffa68-6e5b-440f-90cc-fa63873d6110"
      ]
    },
    {
      "cluster_id": "fbda0675-25d1-4968-aecf-16ed15e84db5",
      "members": [
        "5c4118aa-ea83-4a17-94be-41b87f24e9e2"
      ]
    },
    {
      "cluster_id": "f4bde172-477b-497a-9e85-fb7b55ca0d1c",
      "members": [
        "05eac3b3-ebba-40d5-90e8-e137e96d3021"
      ]
    },
    {
      "cluster_id": "27ea6d31-8a5e-414e-9f29-f8f54c4dba1b",
      "members": [
        "f29f0dfd-548c-4256-b7b3-e1a619c23c14",
        "67125cac-09db-4955-96c3-0b30d5ed593e",
        "c17b3626-b338-48e3-b571-2baade16e313",
        "42074ae2-3944-45c8-b8f5-a31e31728ae8",
        "21277a00-c4c4-43b8-ae10-036e94a1c107"
      ]
    },
    {
      "cluster_id": "c7e4e067-9226-4d57-b404-ebdc121f49ed",
      "members": [
        "be9ee0b6-56dc-4278-bde1-49d32891bb4f"
      ]
    },
    {
      "cluster_id": "97ffbb55-ab53-43e7-aa63-34930f97c42a",
      "members": [
        "755794e1-02c5-4711-b795-71a6f11e2345"
      ]
    },
    {
      "cluster_id": "2caf488d-b467-4866-8066-64992d68542c",
      "members": [
        "431df094-aa85-427f-a056-e553a0b60b40"
      ]
    },
    {
      "cluster_id": "76557fca-1139-4be6-b8fd-797e3828c438",
      "members": [
        "50cb179b-a08b-466c-8c5b-1a1879c7fc80"
      ]
    },
    {
      "cluster_id": "e1299aca-73c3-4bf2-9656-1a4bc5aa21cd",
      "members": [
        "ba04f4a7-d816-4938-8fb3-f9075b90b071"
      ]
    },
    {
      "cluster_id": "d77c268e-3ade-486d-9ca6-faf269499c35",
      "members": [
        "5b999078-8c20-41b4-8f1a-0aa73a32b435"
      ]
    },
    {
      "cluster_id": "79c33296-4152-4931-a84a-5c44d838a216",
      "members": [
        "7c3be797-44d5-4e4f-b318-d24f976e74ec"
      ]
    },
    {
      "cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981",
      "members": [
        "9a7b32ab-adad-4f12-a6d6-9303b5436a96",
        "383b2738-9a06-4fbb-b686-d25d6df14cd6",
        "f7bbb825-6e31-4836-94fc-c9c21877a002",
        "5e6b38d1-6cbc-4588-aa7f-246cbe88558c",
        "315d889f-8b63-4b74-9306-370992b51965",
        "125f05cc-1fb8-4a4b-a3f5-daa08d0d3c0a",
        "98d9880a-94a8-43e1-8692-398e6eb9ab41",
        "aec337db-26f4-4278-88a8-00eeb563ef5c",
        "268224a1-81a0-40a0-b100-0e3b897c7a24",
        "527dc6f0-d251-4dee-8108-e6d965d1acff",
        "3f92d0af-93ee-44f1-a853-b4668e51263d"
      ]
    },
    {
      "cluster_id": "d2d5d22c-9f8f-472b-b123-61d32af5f64f",
      "members": [
        "15a96114-e2bd-485c-aa5d-b964e9f557d5"
      ]
    },
    {
      "cluster_id": "40e574c7-e1d8-4cc8-a46a-a5e8d1efd793",
      "members": [
        "9f7a7753-8a9a-46c9-8cb8-efe4ed91f99e",
        "5119233f-1bde-4d13-a8de-e2dc2a367cfb"
      ]
    },
    {
      "cluster_id": "4eaa501e-252e-4e04-8606-fd467f380267",
      "members": [
        "6b55a69b-e063-423b-b214-33e4d517fc9f"
      ]
    },
    {
      "cluster_id": "8a948aba-63b5-4bbf-9ee5-595eefc57f01",
      "members": [
        "e1132d0a-c744-45d4-b6e4-4608e9abdeab"
      ]
    },
    {
      "cluster_id": "b0630042-6031-4b80-9db0-071e1119e981",
      "members": [
        "fe43aed4-9f28-4fc4-b48c-9489789f7459"
      ]
    },
    {
      "cluster_id": "84d3d5e2-5fb1-4388-9576-0de3210a0439",
      "members": [
        "c62cf8da-abf3-43bf-94cc-e12ff7085cc2"
      ]
    },
    {
      "cluster_id": "f37e4c75-6082-4bd0-a321-a0f77cf2c5cf",
      "members": [
        "6517a7fb-4a3b-454e-a3af-f52a9e6f5199"
      ]
    },
    {
      "cluster_id": "a40aca49-8fcc-4409-91ff-d18e1fba8028",
      "members": [
        "a6568a79-5d7d-40ab-a6ff-612ccd37292f"
      ]
    },
    {
      "cluster_id": "4262a8eb-f5c3-4d49-bd20-1198efa845c5",
      "members": [
        "45646d38-96b8-4175-8594-8b2a0b3c72d1"
      ]
    },
    {
      "cluster_id": "410ec318-9df5-41c9-964f-b2ab6d13b1bf",
      "members": [
        "4bee0fdf-d6c3-4441-8326-91778e5e490e"
      ]
    },
    {
      "cluster_id": "ddc05fce-b4da-4da7-88d2-dbf6d447379a",
      "members": [
        "8d653be1-298c-4b9d-b6ad-ee802b9bbaf0"
      ]
    },
    {
      "cluster_id": "f5124798-4595-40cb-94e4-b0f1143b648a",
      "members": [
        "c70af5b9-8ff9-47dc-8923-58d2a3de24c2"
      ]
    },
    {
      "cluster_id": "dbf1c410-0096-4098-84d3-5c9270d536df",
      "members": [
        "0a95aae4-dc65-4e88-a746-6b0ccc441a7b"
      ]
    },
    {
      "cluster_id": "34d1bb66-1439-414b-aa89-28ecbed93a5f",
      "members": [
        "878f60f7-2c9c-456b-bd0a-98b48d713d6b"
      ]
    },
    {
      "cluster_id": "c1eef27a-1e7c-4cf7-af1a-61c89699baa9",
      "members": [
        "32cd072d-1d55-46c3-9fcb-967982981b41"
      ]
    },
    {
      "cluster_id": "4dfac31b-2847-4ea8-85ec-0e74ca3ab755",
      "members": [
        "9e4e2c61-938a-47d9-8d90-f15250db1a88"
      ]
    },
    {
      "cluster_id": "3de2ede6-0765-4692-aac5-cd554d7b3943",
      "members": [
        "88c9155f-d83c-4a5a-bd85-300b457d50b0"
      ]
    },
    {
      "cluster_id": "2d62bce3-b515-4666-bea6-d3d1e123e654",
      "members": [
        "fb36dc49-7f11-4386-9852-41847d1f0cd1"
      ]
    },
    {
      "cluster_id": "a59be105-d89d-41df-ade9-920d14216360",
      "members": [
        "18657478-bf97-495b-b772-5db4e7bf42e3"
      ]
    },
    {
      "cluster_id": "0c90c874-03f1-47c0-b8b4-7fe34021d559",
      "members": [
        "9faa1b2f-3604-464c-82bc-dcc620f3be67"
      ]
    },
    {
      "cluster_id": "09cc9ddb-b9ec-4c5d-8b8e-25af134763fe",
      "members": [
        "ab7b07e9-0211-423f-807a-5eaf90fcbc3b"
      ]
    },
    {
      "cluster_id": "ed35cf79-8410-4493-b5e5-ebfe6d51aab0",
      "members": [
        "62fb3a39-8949-44f1-aa76-ead5da769f4d"
      ]
    },
    {
      "cluster_id": "bb498dfb-0342-4611-a82f-6ce424759a23",
      "members": [
        "b1a06f5c-9114-4179-893a-dd7aa8909812"
      ]
    },
    {
      "cluster_id": "20ed0e78-890f-400b-a5b8-9f3252623084",
      "members": [
        "349cc3b2-246e-4b61-b4b8-0b99b9f179d1"
      ]
    },
    {
      "cluster_id": "800e1de8-b1a3-400a-bda3-2e81d524609f",
      "members": [
        "706089a4-2389-45ca-833f-2cb91c20612c"
      ]
    },
    {
      "cluster_id": "43cd70ef-d6cc-421f-9e30-15cc399119b7",
      "members": [
        "7445b65e-78b0-4696-862f-f23d49d0534f"
      ]
    },
    {
      "cluster_id": "09d77729-56d6-4baf-a41c-830b574929ac",
      "members": [
        "6e6f56e2-0357-4089-a86a-306d5191e154"
      ]
    },
    {
      "cluster_id": "b6f8ab92-0a99-4ae3-a84c-c1ab0b6d7d39",
      "members": [
        "5bca25b0-64f2-4e68-9241-834a044e8575"
      ]
    },
    {
      "cluster_id": "c9d26401-7e49-4279-ad09-55dcf3457ac8",
      "members": [
        "226ceb8b-abf4-44b9-af59-ea096de45e23"
      ]
    },
    {
      "cluster_id": "f19998d7-da9d-4ad2-b0f0-03ca5c82143c",
      "members": [
        "c5c758cd-d80a-4980-a891-99320447bccf",
        "f9699cb3-e907-45c3-9661-478a013893b5"
      ]
    },
    {
      "cluster_id": "9c4cbf68-9385-4898-9bf2-17346263f863",
      "members": [
        "3bfef735-f736-4651-b093-622fec87b359",
        "5d30da82-103d-48ce-8488-ed7168079cca"
      ]
    },
    {
      "cluster_id": "88bb793a-f03a-44d3-bc64-124f3010e3b7",
      "members": [
        "ba7e4c8a-4ba4-4438-be04-8079d06e2888",
        "ef8872a9-7c5f-45a1-8cee-50f47b855f12"
      ]
    },
    {
      "cluster_id": "95af035b-c14e-4753-b211-c4a8a4ddbdf2",
      "members": [
        "b9c77f05-bf4b-4ac1-aa19-d41b8f87ffa8",
        "a994e659-49e3-4806-825e-e666077e798c"
      ]
    },
    {
      "cluster_id": "7ed8137c-2279-4400-b674-1dd86eab9aa5",
      "members": [
        "0be6a6cb-99f1-4df2-a393-55d344d7a96e"
      ]
    },
    {
      "cluster_id": "67c7f204-fd07-4c45-80b1-5b0bd873efd4",
      "members": [
        "8f093309-41f8-46b7-a897-d0b92c2d89ec",
        "538ca86c-a065-4064-bc05-9aa8e765059b"
      ]
    },
    {
      "cluster_id": "249e8c50-f68d-47af-99c9-2bc6ddfd52ad",
      "members": [
        "6ed9017a-8290-483a-b596-237e4d9a8691",
        "92ca9dcf-ae92-4e9c-86b6-bc238956a0fd",
        "e9f26f83-5107-4efe-ba57-4e58c267e160"
      ]
    },
    {
      "cluster_id": "c557e9b2-c812-48ee-97cb-707e7e40672b",
      "members": [
        "85f18008-d73c-4be7-a7ef-d9583d4603b6"
      ]
    },
    {
      "cluster_id": "7ccf5ec9-3916-43b6-a44f-7cfb24300693",
      "members": [
        "8e04e7f5-ebfa-4e96-97d6-6daf2585c48b"
      ]
    },
    {
      "cluster_id": "e52fcc8f-16ac-4c0e-8ef2-f3d55d44895d",
      "members": [
        "5f57dd5b-0ae7-40d5-a5ca-9367e781b141"
      ]
    },
    {
      "cluster_id": "f3090987-9e96-4cf1-95d6-22fba3e8d946",
      "members": [
        "8541b447-be43-4696-b3c3-5bdfa1d5a546"
      ]
    },
    {
      "cluster_id": "86faa30d-3051-4174-a28e-c3bb4b4beacf",
      "members": [
        "97b37768-0d05-4cec-963e-4480131aae91"
      ]
    },
    {
      "cluster_id": "d327e87e-5fd2-4607-86c2-9433a227a64c",
      "members": [
        "f781bac7-dd39-4977-955c-df979d834d8f"
      ]
    },
    {
      "cluster_id": "7e7ac228-2e81-4fa8-abfb-35fbbdf2b4b2",
      "members": [
        "3f72006d-2cca-4708-a17e-4e5d64891aee"
      ]
    },
    {
      "cluster_id": "1bbcb23d-9835-462a-b09f-6a4c89faa361",
      "members": [
        "835df69e-1dfc-4ef9-a704-e9ac185f1811",
        "a2d5e081-969b-4ff8-bc6a-3147ec0b0e4f"
      ]
    },
    {
      "cluster_id": "f17de551-5a88-4bbe-a63a-f23269257469",
      "members": [
        "d27385f6-dc81-41f1-bd61-a8d1042beff5"
      ]
    },
    {
      "cluster_id": "b14f50e3-04b1-4e58-a4b1-8a1de6c4e2d2",
      "members": [
        "becfd5d5-1ee9-4d06-80a8-a79a26aa2477"
      ]
    },
    {
      "cluster_id": "01d21517-243e-4d94-b9c5-641f8bca7cbf",
      "members": [
        "4a2448c9-7554-4b09-bd39-f9e0e083b9ca",
        "0bb33664-bc8c-4f5e-936b-5765fc3b8eb1",
        "595f05b3-4923-4276-a40b-30ff906894e4"
      ]
    },
    {
      "cluster_id": "61dc215b-cc5e-49f1-add7-65f02e137ed1",
      "members": [
        "42458045-832d-4bd1-92d2-d4c694c26f6a"
      ]
    },
    {
      "cluster_id": "5d6331d6-8b39-45dc-b069-c03168d82aac",
      "members": [
        "5436c0c4-f842-44ed-8cc7-21090a503ef6",
        "3bc54be7-e813-4259-b9e4-4803b179b0c3"
      ]
    },
    {
      "cluster_id": "76f2f5fc-c5b8-4d6e-932c-655254df8fc2",
      "members": [
        "1cafa29a-dd5f-40e2-9527-b695d279038f"
      ]
    },
    {
      "cluster_id": "398a087e-4a63-4bd1-8ad7-e71ca757db9e",
      "members": [
        "4237e997-e389-47a7-8c3c-920d420cadd9"
      ]
    },
    {
      "cluster_id": "94f3a60f-f903-4813-b891-508644ee87e0",
      "members": [
        "eb87c822-aa00-40d8-9132-8436825cc3b6"
      ]
    },
    {
      "cluster_id": "a300ab57-0a8d-448b-8ceb-9af6a492c83c",
      "members": [
        "061f2a7f-a450-490d-8a05-29766f1c9832"
      ]
    },
    {
      "cluster_id": "1f210f48-5853-4bb8-8fc2-d9a334fec30a",
      "members": [
        "5b910185-927d-4126-ad30-34c4c4e875ac",
        "354067ed-7f02-4349-9879-a50784d2ba8e"
      ]
    },
    {
      "cluster_id": "bc5a19f9-2b61-40ac-ae39-5951370b4cf0",
      "members": [
        "c01d4753-8ca2-4cc3-b5fa-d6582dc6d580"
      ]
    },
    {
      "cluster_id": "21518841-2c46-4292-abad-aff342a4f1ac",
      "members": [
        "2a90d6e5-3007-4530-9648-5f391357af33",
        "9eec3efe-4807-4322-886e-22aa5f0309a5",
        "f3c12118-c8a6-4eae-99f9-ad90880ce29c"
      ]
    },
    {
      "cluster_id": "88714dc6-72d5-4f7f-9067-219b66b31c42",
      "members": [
        "7aba1bf9-7b64-4cd3-be68-21f773aecd32"
      ]
    },
    {
      "cluster_id": "b2894bf3-d539-4a31-9d16-59a88bacee25",
      "members": [
        "846a8102-f54e-45d8-af36-9011340fc325",
        "b1052026-44b4-4684-9390-7d2478ae71ac"
      ]
    },
    {
      "cluster_id": "3035cab4-7bf7-4e5f-b8ff-717930d9caf2",
      "members": [
        "70ea83d9-60d5-4779-baa5-92ec4617ee80",
        "4af338f2-92aa-41fc-abd0-d816738ca401",
        "cb67794a-bd78-40b6-b30e-648c7caea549",
        "e0b2503d-fda4-4211-8c27-f6408b345eac"
      ]
    },
    {
      "cluster_id": "38a250d4-c72a-4095-9b75-66d5fbc4da25",
      "members": [
        "05266523-2b9f-4ee2-94d2-77d005fa5d9e"
      ]
    },
    {
      "cluster_id": "acb8c5a5-3818-4898-ace2-3330d0f18d6b",
      "members": [
        "038a37c6-587a-4f25-a13b-0060d10e76b6",
        "61fff634-9e30-41df-a329-fb86fad4bc7c",
        "2f542fe7-1497-4ca8-a4ab-b6647fd05366",
        "51c0d92f-0651-465b-99bf-de8081c26d82",
        "d02dcf65-6a38-45fb-a525-077a35bf4ef7"
      ]
    },
    {
      "cluster_id": "126f7904-d5da-4bb4-861e-215114767499",
      "members": [
        "7d607d2b-c2b4-41c0-80d6-59cc1f874fad"
      ]
    },
    {
      "cluster_id": "0be2a099-9ff6-4c81-a576-b1f6726557d6",
      "members": [
        "d7b28e21-78df-411a-bb94-fcad5275b2a2"
      ]
    },
    {
      "cluster_id": "27e1dbcf-9461-42c2-9fb6-7b948072caae",
      "members": [
        "ebe94c24-895e-44db-a93b-e32d2ab0659b"
      ]
    },
    {
      "cluster_id": "bd0a5021-3a05-428a-a728-61f8cfe02fc4",
      "members": [
        "deac6fbe-1f71-4bac-b1b7-c5b1dc0f1774"
      ]
    },
    {
      "cluster_id": "720ca61f-9942-490c-ab91-755d5a979ee2",
      "members": [
        "7d64a856-24be-44dd-a9da-520d2e65c291",
        "38608f01-edd3-4b98-bf21-80f5ae498ba3"
      ]
    },
    {
      "cluster_id": "68efa2f8-df62-4c55-a56e-6a0d6368d6f1",
      "members": [
        "2a79c149-117c-4238-8185-4e0749498fe5"
      ]
    },
    {
      "cluster_id": "1543a0aa-5824-449c-b496-3562005d2d52",
      "members": [
        "ec6e8289-3019-4927-8667-3a447ba0d51f"
      ]
    },
    {
      "cluster_id": "a7e57243-5f25-4292-b208-646cbc973faf",
      "members": [
        "8e11e6b5-a90f-4e1c-9b23-8c17083004b7"
      ]
    },
    {
      "cluster_id": "0480c8ed-40a7-40dc-ac24-9b8fa7551edc",
      "members": [
        "9b1d093f-de0f-46ef-8565-0e1e1e296258"
      ]
    },
    {
      "cluster_id": "2e675266-c3ed-4fac-a036-217c24ac28e2",
      "members": [
        "0193104e-6045-4742-86f6-04bf99e3c2b1",
        "dbe6bc50-37e5-422e-9c48-1d03b7c6b417"
      ]
    },
    {
      "cluster_id": "2648c3b9-64e2-4596-9353-c37ae996dcce",
      "members": [
        "a822948a-1959-4fef-ac9b-454dd71b7ebd",
        "67f5e913-cd9d-419b-a4e8-8628d477d227"
      ]
    },
    {
      "cluster_id": "5e5c65ad-4c51-4a27-ad63-eac217deb431",
      "members": [
        "b7521441-865b-4d5b-8f9e-0fae92ec0a98"
      ]
    },
    {
      "cluster_id": "02e73dfc-86f2-4fe6-a79c-d071e07721fd",
      "members": [
        "2f4d1d64-a278-4bc2-a3f0-9eefb7d52ec3",
        "4e458c17-6cf6-466b-9154-435a6288efd2"
      ]
    },
    {
      "cluster_id": "11875278-ef5e-43b1-8558-2410f47e68af",
      "members": [
        "ea38c269-5631-4bcc-b8d3-27432d6d205d"
      ]
    },
    {
      "cluster_id": "ac86516b-573a-4ca5-9a1d-d4dd1666f20a",
      "members": [
        "500fd674-8c2b-49dc-b3d8-929f25693844"
      ]
    },
    {
      "cluster_id": "d9df9f73-2328-4c08-a547-bba4c4ece24c",
      "members": [
        "fb0ebb50-3e74-49d1-af14-f0368e2f4ccf"
      ]
    },
    {
      "cluster_id": "a9de4b16-c663-4b5e-933f-b9821d2cc80d",
      "members": [
        "3f0cfc3c-6092-41fa-b4e0-4e3a1dc9a762"
      ]
    },
    {
      "cluster_id": "870cf570-e7db-4612-8845-9e41f8062b78",
      "members": [
        "15c1dfe3-0363-4cff-be4f-224832389ab8"
      ]
    },
    {
      "cluster_id": "dafa634a-37de-4d53-8bbc-fae67a8455d0",
      "members": [
        "bf4001ea-43c2-406d-a13a-2b8b6cad0303",
        "f531b748-c838-4a44-9e54-b10e5b546449"
      ]
    },
    {
      "cluster_id": "823a1b7a-305d-4292-886b-7974a056d98e",
      "members": [
        "e059f732-82f9-4913-a509-434e9c5747cd"
      ]
    },
    {
      "cluster_id": "bc907223-19f6-4c59-ade2-142b6a28be4c",
      "members": [
        "bd7254eb-60f0-4a5a-9010-4872e83eb688"
      ]
    },
    {
      "cluster_id": "9040babf-0be0-48e4-a916-be2a06953769",
      "members": [
        "66017d11-b8de-45e4-97a0-4407d199553e"
      ]
    },
    {
      "cluster_id": "568dc264-fa77-45fb-8b1b-5c901f185f7a",
      "members": [
        "3e187232-2098-4d5a-9214-b01fb3db2fd2"
      ]
    },
    {
      "cluster_id": "5da78bf8-d65b-4a01-8353-c40daa91e80b",
      "members": [
        "e4eb03db-324c-497b-b470-d26162590c0d"
      ]
    },
    {
      "cluster_id": "5035fa8a-cb8a-4b4a-a412-c85f5b3586dd",
      "members": [
        "38b8faf4-24b6-4c13-8487-555b40638b4a"
      ]
    },
    {
      "cluster_id": "8f06b71d-e458-4241-be0b-c89c223296af",
      "members": [
        "c8d99fb4-a377-4d8c-9a97-646b22b0a25c"
      ]
    },
    {
      "cluster_id": "dc2b8b73-2640-4b6c-a7d1-9e5c9873bbf6",
      "members": [
        "7d0eea2c-fa47-4916-a830-68d3b0a9a8e6"
      ]
    },
    {
      "cluster_id": "690596f3-57f6-4044-a245-63584bb2f8ea",
      "members": [
        "142e6f0f-66ee-4e30-8fb6-5d1231933c62"
      ]
    },
    {
      "cluster_id": "7e23b4ba-cb72-4329-9b5e-d475d9898055",
      "members": [
        "b4b93ab7-a67d-477c-98ef-76796d962b14"
      ]
    },
    {
      "cluster_id": "9ed0391b-e831-497d-9d87-ba9ea12680b7",
      "members": [
        "59a2e99c-785e-4708-9cab-e248cdc6dd5f",
        "36551982-daa0-4a06-9ce2-7a5b46b08a44"
      ]
    },
    {
      "cluster_id": "19c9dde1-93ad-454a-9809-5f87d3869615",
      "members": [
        "53df0d0e-5777-43a7-b6a5-13dbe796107c"
      ]
    },
    {
      "cluster_id": "212923c3-f34e-4b5a-bb85-95bfbbff9db0",
      "members": [
        "8dda944c-daf5-4de1-abd2-519df4af39a7"
      ]
    },
    {
      "cluster_id": "b10b3160-e0dc-461b-a456-f6327586eb6a",
      "members": [
        "7672a79d-ae4d-4dd0-a071-2e0e0ffc6d1c",
        "e968f688-f65e-4c2d-9614-30a30a4b1e67"
      ]
    },
    {
      "cluster_id": "752e0a5d-00fb-472d-909a-65284c58e6d5",
      "members": [
        "6352eb6a-310e-4990-aa9d-97fb6f01ca44"
      ]
    },
    {
      "cluster_id": "1c2050b3-8746-45bf-a7a2-7907e141c266",
      "members": [
        "ee405ef0-07c3-43ed-a7a1-315200fbb76f"
      ]
    },
    {
      "cluster_id": "433a8504-6f95-4801-98c2-808b28575d4f",
      "members": [
        "40bf4e92-c095-4b70-949c-2ce4acdf7675"
      ]
    },
    {
      "cluster_id": "71167ddf-4ec9-4903-a616-db6af6caed15",
      "members": [
        "8e8e10a5-f251-4923-9aec-713685c45ce4"
      ]
    },
    {
      "cluster_id": "4fb659e6-6366-4a40-9ae4-1332edb2d8b2",
      "members": [
        "2685e2d0-c53b-4131-873c-e4506a1f0397"
      ]
    },
    {
      "cluster_id": "00fbd015-4c36-4680-a582-bfc7271c3275",
      "members": [
        "2b7f1d81-e1c8-41a2-89d6-d34c18e9e551"
      ]
    },
    {
      "cluster_id": "ad846634-778f-48a1-8b99-37387f981b3f",
      "members": [
        "7c174032-c3d6-4588-a644-ec1743e86a8c"
      ]
    },
    {
      "cluster_id": "0c4c6169-f685-4aa8-b6de-d396766a5c80",
      "members": [
        "473dea4a-3002-4416-a691-6b01312e1875"
      ]
    },
    {
      "cluster_id": "7512ed6a-dee9-4a0a-b3bd-71a36d7ff111",
      "members": [
        "860458dd-eabd-4f82-952f-5ddb0e5ba089"
      ]
    },
    {
      "cluster_id": "6b61dc7f-0dcc-4798-86a9-dfa23b5c3897",
      "members": [
        "71d4a8ff-625e-4525-a6ab-860eefb4532d"
      ]
    },
    {
      "cluster_id": "f50f4ad4-412c-4470-94b2-718ecc122ebe",
      "members": [
        "be7102cb-0b57-4bc1-9d3a-f4ab5e05daf7"
      ]
    },
    {
      "cluster_id": "30d2097c-43cf-415c-84fd-ec7c279c4c87",
      "members": [
        "54d4e00f-cf3a-42e9-a73b-ea9d732d99cd"
      ]
    },
    {
      "cluster_id": "3f25d73b-25b5-4e43-b335-2f8f8664eb00",
      "members": [
        "d4c4d200-1d08-4c8e-a9dd-35eda11cdfaf"
      ]
    },
    {
      "cluster_id": "6e27c008-554e-490f-bd40-be5dceee83e2",
      "members": [
        "44069781-87ef-498a-99ba-22f1d64541a8"
      ]
    },
    {
      "cluster_id": "a2518533-4468-4125-948f-3516caac3b26",
      "members": [
        "88e2c9e1-bfa1-4d99-a82c-318741c224f9"
      ]
    },
    {
      "cluster_id": "e262a7ae-4e83-451f-b2c4-34917839f661",
      "members": [
        "05729b15-4eb7-4f82-a0b8-028aab48cbfe"
      ]
    },
    {
      "cluster_id": "71236786-30d7-40e5-8b9f-3cc8f5e06fd8",
      "members": [
        "e9d64a2b-a2bd-41aa-a143-f2c539d9bfee"
      ]
    },
    {
      "cluster_id": "9a5d054e-318a-4826-9d5f-20df372185b2",
      "members": [
        "83dbeb35-e014-4551-966a-5f97f62c8308"
      ]
    },
    {
      "cluster_id": "31dfadd3-c8f6-437b-b8ec-a69992a26cb8",
      "members": [
        "1b1b77c7-882b-4e3f-bba9-1f841f27246c",
        "f978a9ba-a72a-4d76-ad65-4fc16420acf4"
      ]
    },
    {
      "cluster_id": "d291acf3-7cf8-4c9d-9ab4-df11bad39953",
      "members": [
        "e2d654e4-dbb7-4eb1-97ec-2e7d3c55c4ac",
        "adfe034a-1d47-4b01-a3b4-3ee50f4c4d29",
        "3119678a-5fd7-4f1e-a362-401a8f99b6b2"
      ]
    },
    {
      "cluster_id": "cb3aa2af-d703-4ae9-b53d-f7c0ae589678",
      "members": [
        "bd31ef10-7bcd-4b4c-b37c-4a3b59cc3763"
      ]
    },
    {
      "cluster_id": "019a31da-45d0-4ffd-a58b-773a16c0362f",
      "members": [
        "ee4850dd-7ffb-488a-8195-1b9ae464b1e7"
      ]
    },
    {
      "cluster_id": "152183a2-1d35-42be-bb3a-d49654ea4707",
      "members": [
        "219e1b1c-8243-46cd-ac04-413e5b148da6"
      ]
    },
    {
      "cluster_id": "317eba1c-3b6f-43f0-a757-dddfa7966147",
      "members": [
        "ba602c99-8f43-4cd6-b850-ff63349886b1"
      ]
    },
    {
      "cluster_id": "f70d2311-4ede-4f3e-b4d9-bb1c5def4b48",
      "members": [
        "9d543810-cd90-4ea8-9a60-e10f583ca1d0"
      ]
    },
    {
      "cluster_id": "5502f4b5-10c2-450c-b072-20a0d153fef3",
      "members": [
        "76a2ce33-876f-41ad-be02-4b81d4ed8b2f"
      ]
    },
    {
      "cluster_id": "ed113c66-0348-4af6-b4bc-60c420311e2a",
      "members": [
        "05ab73c2-13ed-4c61-9755-a7404dfd3d9d"
      ]
    },
    {
      "cluster_id": "5bb2e685-4a07-4889-91ac-49a28d63a36e",
      "members": [
        "72686c67-9f6f-4d0a-b620-e6f21ba98772"
      ]
    },
    {
      "cluster_id": "d335936b-95df-4111-8cb1-decd8664543a",
      "members": [
        "4421bcf8-b453-4431-ab63-16355715a87a"
      ]
    },
    {
      "cluster_id": "994a89fa-3e4a-45ec-b0ad-a34f5031641f",
      "members": [
        "d1e22a56-4fb4-48ea-8923-c7fd6cfda446"
      ]
    },
    {
      "cluster_id": "eafe4828-2ad9-4259-92a7-b6017492bd06",
      "members": [
        "6aa639db-03c0-4b01-9fbc-777e189f69c0"
      ]
    },
    {
      "cluster_id": "ddcbcb82-918f-4d21-a3ab-fc58bc049dc2",
      "members": [
        "2ace17d3-8f02-490e-b49d-2b64f09dd61a"
      ]
    },
    {
      "cluster_id": "667cedb1-d001-4a4c-af7f-98106fe11ae7",
      "members": [
        "92da8ffe-8e6a-4c30-9fd3-a933e0c7944f"
      ]
    },
    {
      "cluster_id": "79d39e26-3c77-4ccb-be20-fd89e10bc54c",
      "members": [
        "2060306d-5f4b-41bb-ada9-748a449d8478"
      ]
    },
    {
      "cluster_id": "e05bca7f-c97e-42b2-a75d-fdded1101b44",
      "members": [
        "bcf1bd89-e271-4922-887f-bb5f7e70e390"
      ]
    },
    {
      "cluster_id": "a330dd7b-988a-4c80-81be-2d4ba1af385f",
      "members": [
        "50f056ee-90f1-422e-a611-e7daa11ac02e"
      ]
    },
    {
      "cluster_id": "4dfd1143-30a8-4e10-a390-f29a1b58e6a8",
      "members": [
        "fc25b3c7-be1c-4b96-84cb-69e99ad4c46d"
      ]
    },
    {
      "cluster_id": "136ce880-e6d8-4791-8b14-3c42846dc7f3",
      "members": [
        "953c492b-c744-4a84-b213-e9b94428c223"
      ]
    },
    {
      "cluster_id": "02ad021c-7d4f-4141-9a02-a5ad1ae95f65",
      "members": [
        "1c00f5d4-6fe1-4dbc-ac7a-45c85eeb3e41"
      ]
    },
    {
      "cluster_id": "afb80000-29ea-4260-b454-0363d71c9855",
      "members": [
        "e3500e27-e888-4724-a6b4-5960e5f31fed"
      ]
    },
    {
      "cluster_id": "0b355c81-92f1-4102-a729-a2af4b606bfe",
      "members": [
        "88fb0996-ffb1-445c-9668-1dcff6819ee4"
      ]
    },
    {
      "cluster_id": "6b2b1fd9-ebe6-4e20-9f18-a97a395c8d10",
      "members": [
        "e1657114-b637-4214-876d-1c44cbd5f35a",
        "bf678fbf-bf14-49a4-907f-4109729b3b0a"
      ]
    },
    {
      "cluster_id": "e886744b-894f-4cf5-9248-234d88f9a4f4",
      "members": [
        "ae33c0c0-db6b-42ae-aa47-975f070d66a6"
      ]
    },
    {
      "cluster_id": "12d9ff77-3eea-4aa4-b8ee-4d436789ff3b",
      "members": [
        "24a40309-8f9f-4bd0-a892-5f2c93b2a71b"
      ]
    },
    {
      "cluster_id": "447c9e43-212c-427e-bbf7-d86cadb216eb",
      "members": [
        "3d4673a3-de27-44d3-a1e5-effb6dc1176d"
      ]
    },
    {
      "cluster_id": "a5b4fdb0-8d5b-49c2-aabd-e64213ff8027",
      "members": [
        "70547dff-f284-427f-879e-9e6023ef461f"
      ]
    },
    {
      "cluster_id": "48f7f24e-52e0-4527-a4e1-e5a83b50fb40",
      "members": [
        "67c55d7f-e71d-4611-97f5-3bdb8dfe8633"
      ]
    },
    {
      "cluster_id": "d0ea565b-64ab-44f3-9679-c2236d37aa42",
      "members": [
        "29ff471a-38cc-4972-b722-d1604d010a06"
      ]
    },
    {
      "cluster_id": "51a5661a-48dd-44af-9a97-7d7620877cc6",
      "members": [
        "bcb0a24f-a79e-48e3-8437-97fbd88492f0"
      ]
    },
    {
      "cluster_id": "03b556ab-fe42-4f7d-954a-c2484c0fac43",
      "members": [
        "dc6827a3-d30d-4619-96df-ff5f48a04539",
        "0a4dd1e7-aba8-40f6-aa1b-b91867f98acd",
        "b2c2ade4-37c2-48da-819b-624b5a9bfd1c"
      ]
    },
    {
      "cluster_id": "205e16cc-f356-4fc1-9b0e-0b31bf6aed12",
      "members": [
        "0a200067-762c-46ac-9ffa-57243ea19fec"
      ]
    },
    {
      "cluster_id": "1997b709-7204-4376-b1e8-77d6b8518a0f",
      "members": [
        "2d80d376-920e-4758-a774-6a5040fc0c0b",
        "c02542da-91d7-4dcd-8711-22502b1933c2"
      ]
    },
    {
      "cluster_id": "1249af1e-88d3-4d61-950a-0799adc2edf0",
      "members": [
        "ef246cff-ebb6-4e72-9c34-5ca9e92ad60a"
      ]
    },
    {
      "cluster_id": "d6f2ede4-7d0b-48ff-b867-ebcd3c6ff871",
      "members": [
        "b9f75f2f-b912-4eb7-a715-2a3476fd4d61",
        "0595b59b-0e70-4c72-ad8e-a4d827e02569"
      ]
    },
    {
      "cluster_id": "b92f2bdb-a4c9-478b-a96f-1f47457a005d",
      "members": [
        "2db0b5e8-a206-476c-aa14-7b391e6b99ad",
        "6849375f-6011-4635-b9c4-b17ee24abba1",
        "3a958841-35e3-4334-b6b0-5e888a760ced",
        "ff9a4801-3809-4274-8ff2-b61887727e12",
        "8ffbe2bc-3e02-4c4d-bc44-4f503c12fad3"
      ]
    },
    {
      "cluster_id": "0ac8de8c-821d-4fe2-90f7-e1d30911339a",
      "members": [
        "83a51209-5cc5-4215-b5e9-78fd152529c7",
        "c49fb060-81cd-4e18-802d-4101bbcaf813",
        "fe0ea5fa-1a6c-42cb-8ea0-31fffcfc9bc8"
      ]
    },
    {
      "cluster_id": "b379da86-fb9c-4026-92d2-37b07df028cc",
      "members": [
        "e97875a8-c2b6-4a26-bc2d-30b0ecf2ca4d",
        "da46e9b8-c3ee-4f06-a499-08731c676f75",
        "3f934331-cfc9-4ec1-928b-e20288e4d2c6"
      ]
    },
    {
      "cluster_id": "e2ffc2de-64b8-4d49-9767-c601c711ffbd",
      "members": [
        "122f4e4d-2e37-49c2-9210-c4159692e31f"
      ]
    },
    {
      "cluster_id": "cba27e02-b54c-4ae0-80f7-4a7112a6558e",
      "members": [
        "f49a66da-ca39-46c7-8ccb-816574d6aeee"
      ]
    },
    {
      "cluster_id": "c006df76-d7ed-4672-b415-893f6c8476b6",
      "members": [
        "f932614e-5d4c-4983-a922-4fb00292c1d4"
      ]
    },
    {
      "cluster_id": "f41585b2-89bb-4794-90a0-40b26fb3ec23",
      "members": [
        "735005b5-6c0f-4213-9991-80fff97528e3"
      ]
    },
    {
      "cluster_id": "817f89c1-1d6c-4c1f-968d-c42db0a618b8",
      "members": [
        "56bf2861-efba-4614-9bf8-f103ed3ce2e3"
      ]
    },
    {
      "cluster_id": "5cdd32a6-f13e-42bd-94a1-e86008aa2d86",
      "members": [
        "0b2e1f7a-901a-493e-b33c-49abea435d30"
      ]
    },
    {
      "cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63",
      "members": [
        "8c023135-f2cd-4fdb-aaa0-7cb9bfa05242",
        "88135041-5a6a-4054-b86b-377b5fcc84a6",
        "d2420cfd-d81a-4d8a-9d9c-2dafefab70fa",
        "e9f283cd-f4a6-4739-97f0-60b479c8c50f",
        "d67d3d85-394c-406e-82a3-52cfde1c0d91",
        "f4edccd9-7fcb-463d-8294-2bf292462be6"
      ]
    },
    {
      "cluster_id": "6b567caa-773b-451a-88a5-247b75e87a6c",
      "members": [
        "935ed015-beb2-49c7-b3ce-45b73a49fa97"
      ]
    },
    {
      "cluster_id": "3a1ce373-9bb9-4921-899a-ff8f1e27a082",
      "members": [
        "8a4b0241-342c-4827-8a9e-3613060f8a2e"
      ]
    },
    {
      "cluster_id": "00440887-1b0e-4488-8a0b-2f9b2ba9ede3",
      "members": [
        "f0d69e4c-dea2-4889-ad46-5b748ccfdb27"
      ]
    },
    {
      "cluster_id": "64571139-4782-47d8-abc3-d973ded5245b",
      "members": [
        "22ba4a14-399b-432d-91fb-360385c7bca3"
      ]
    },
    {
      "cluster_id": "6b0c0beb-865e-4025-a8f9-7338b3bfba70",
      "members": [
        "b9ca7673-b522-478a-9560-bdcbb303a813"
      ]
    },
    {
      "cluster_id": "1d3c886f-bc05-43fd-9472-810156e4edfd",
      "members": [
        "abfa0f4e-0a36-46e2-b9b4-97e806ceefe5"
      ]
    },
    {
      "cluster_id": "03fe8498-7679-447a-af5d-563e12790d0c",
      "members": [
        "c2a81773-1b1f-43a1-a01f-72b8ee98337d"
      ]
    },
    {
      "cluster_id": "8df39116-11fd-4c52-8efc-d2dbbee81717",
      "members": [
        "f0f7f5e7-cac1-4f62-bdee-68fbdbcfd4e5"
      ]
    },
    {
      "cluster_id": "f4e22611-4a8c-420d-98fb-79e2c70d616c",
      "members": [
        "d93f6f6c-3364-44b6-bda3-b17afee0e7ff",
        "3cd90d92-1f2f-4bb7-bf4a-32e93f89acf3"
      ]
    },
    {
      "cluster_id": "aee47b3f-809d-45eb-9cd7-269dd2b5fc95",
      "members": [
        "b338c65b-f306-44ea-b0b0-dd2cf6411423"
      ]
    },
    {
      "cluster_id": "903c3f33-319a-4f0f-a3a0-b3ad86d56e86",
      "members": [
        "4cbc186a-b813-456f-bb6a-e010b138c2ca",
        "9087f738-7475-44fa-85d8-57cc7e9ae9a4"
      ]
    },
    {
      "cluster_id": "b900a5fd-9f6d-409a-b2f1-c21b24addff1",
      "members": [
        "6e955dd5-abae-45ae-b58c-2a25b9bdeacb"
      ]
    },
    {
      "cluster_id": "1bb75de7-fa9e-48e1-9651-ee91dc1ce93e",
      "members": [
        "71af64b6-cc21-4c97-b9df-d1f091361b50"
      ]
    },
    {
      "cluster_id": "71ddb5ae-a33f-4bf8-97d1-9321d27ed4a2",
      "members": [
        "bec49b2d-abe0-4438-97ae-8114b1d576d6",
        "495f48f0-a384-449d-89c3-48a288420008"
      ]
    },
    {
      "cluster_id": "3595c0cd-b164-431e-b192-61bc7dc0019f",
      "members": [
        "dbb0569a-302d-4f5c-b3cf-3a621d6d4b2f",
        "b9d88390-2a0f-45c9-821c-da2a75aaf2d8",
        "953d0f4e-de91-4c9a-857c-d602fd9feb09"
      ]
    },
    {
      "cluster_id": "cb033bf6-f8da-46c0-a5e0-962c48c82ad6",
      "members": [
        "4dc240ff-2439-42ae-9041-8ee9ee997a0f",
        "9ed66cda-429d-4b92-8a4c-8184ff773926"
      ]
    },
    {
      "cluster_id": "47f7a131-6ce1-4e01-b64c-61e5f9696bb1",
      "members": [
        "4dd8251d-5251-4520-8558-720daed2ff0c",
        "c06a7150-78ed-40ae-aac7-81b9f53c150f",
        "9207c4cc-83d3-4107-8881-63caee372452"
      ]
    },
    {
      "cluster_id": "0d989645-1d74-46cc-b203-0ae7bc83c732",
      "members": [
        "384dfcd4-e781-4db3-90f5-e95202c64b81"
      ]
    },
    {
      "cluster_id": "aa5a0292-80cc-40db-8f50-3b92fa1db057",
      "members": [
        "3085bd89-d3bb-4c87-a766-de3c40938e9f"
      ]
    },
    {
      "cluster_id": "71b3e9c3-5afb-45c8-a204-1d5b44e3a33a",
      "members": [
        "ae04d801-546a-4bb5-890c-ef37544c9aee"
      ]
    },
    {
      "cluster_id": "32e97d8a-5e17-495f-9681-46a69fce7584",
      "members": [
        "7d776a28-7b36-4b50-9d79-600c7c814f14"
      ]
    },
    {
      "cluster_id": "87ba8d5e-85d4-4d3c-8d48-82520a97a137",
      "members": [
        "0dea2bad-4966-43e5-9b98-11201c1df71d",
        "eea34e2f-2775-4904-93fe-62aaaaabe850"
      ]
    },
    {
      "cluster_id": "ff6b17a5-2973-4397-8f78-b44bc6fa5365",
      "members": [
        "4b8c7205-ffdb-4751-b92c-67b4ce7f2008"
      ]
    },
    {
      "cluster_id": "f6201dc9-cd2a-485c-86d4-622332646365",
      "members": [
        "b0eb15c0-c4de-4a46-addd-03f1a89f3421",
        "29a35ac1-ec35-49be-b7b3-426e424bdfa5"
      ]
    },
    {
      "cluster_id": "001b82c1-e0c7-4fe5-8e7f-c84ae10048f6",
      "members": [
        "4f129350-7db8-4427-9b00-04dce5d486ea"
      ]
    },
    {
      "cluster_id": "c6da85ba-cb8c-4e07-b313-69be94d682d5",
      "members": [
        "ec1376a1-9b3c-404c-8cd8-9f9902afcb67"
      ]
    },
    {
      "cluster_id": "11d8d71a-168c-43ed-b532-83903fcd58a8",
      "members": [
        "d4dc283f-b1c3-459a-bfec-67d2ecc4af27"
      ]
    },
    {
      "cluster_id": "9830a54f-6df4-4c84-a14f-819c289e70e5",
      "members": [
        "7ebce2cb-ebc2-4687-af49-e93e9583f48c"
      ]
    },
    {
      "cluster_id": "3d676a5b-4d23-4b21-beb6-27ce056b17ec",
      "members": [
        "2a613509-27f3-4c6a-8d5a-53cba97112f0"
      ]
    },
    {
      "cluster_id": "902b6a60-6994-4d2f-a5c9-4b6398d8e8c1",
      "members": [
        "c7818cf5-a11a-46a6-89ad-10c0a908a17c"
      ]
    },
    {
      "cluster_id": "2f3684a3-db51-45d5-8ab6-a0d061f2a667",
      "members": [
        "f7f20864-e23f-4165-ab6e-b8e2e6f7132a",
        "c91195b0-2dd3-4cc4-bdd0-48f3f2bdbdb4"
      ]
    },
    {
      "cluster_id": "7aadf7ec-8a12-4805-bf87-51d4575c022f",
      "members": [
        "cf3a8103-e2e8-492a-9f1f-a7dd04cc356c"
      ]
    },
    {
      "cluster_id": "4e1dd449-7872-4183-a210-7ea0e51bbd11",
      "members": [
        "f1cd3541-52d1-4c2b-b35f-d77cdbb63f03"
      ]
    },
    {
      "cluster_id": "b9f9ee97-4a90-4a60-a376-32010848d648",
      "members": [
        "e21d969f-a42d-4c4b-8725-212fe1e8088d"
      ]
    },
    {
      "cluster_id": "2dba71a0-6409-4877-bd44-bf97b9328d5f",
      "members": [
        "64e42c4d-df6b-4b15-b5dc-f14f3b4fc034"
      ]
    },
    {
      "cluster_id": "2929fcf7-736c-4b1c-b178-3fc95f1bce0c",
      "members": [
        "41f6a186-93a6-4690-83c2-2d9877871901"
      ]
    },
    {
      "cluster_id": "d64f3c9d-c55d-4ebc-9a01-43d63af153f0",
      "members": [
        "51cbcb31-0b5c-4bd7-ae82-dc02ba6017bc"
      ]
    },
    {
      "cluster_id": "6ad5a7cb-930f-4fcb-91a9-e3eccb8d8cb0",
      "members": [
        "9b854e37-9c9e-4f39-a6a5-816a922b9cbb"
      ]
    },
    {
      "cluster_id": "567b1fae-2c0d-4bd2-91bd-d03218bbd8d0",
      "members": [
        "2401f7d5-d48e-4e43-9dc9-08014ecfb9ef"
      ]
    },
    {
      "cluster_id": "f74167b8-6b2e-4397-aea5-ad26ae737cc7",
      "members": [
        "fbe9998c-0872-4191-9671-4703a96531fc"
      ]
    },
    {
      "cluster_id": "4970bf10-4486-48dd-9be4-75b2fb5e659e",
      "members": [
        "7489dbad-ad68-456a-a7f1-aad2fd62f893"
      ]
    },
    {
      "cluster_id": "8181e898-2713-41af-b776-395891458be2",
      "members": [
        "63985ce7-5217-4874-aa7e-24ca4ef61575"
      ]
    },
    {
      "cluster_id": "47e32d49-9365-4f05-bb52-852578030b2f",
      "members": [
        "e5390f9e-da3a-4148-80de-bf8344b833d4"
      ]
    },
    {
      "cluster_id": "fb3f730b-85cb-44b0-976b-06ca14bb8acb",
      "members": [
        "b0d99ec5-93b7-4482-8ede-56df90294fbd"
      ]
    },
    {
      "cluster_id": "cdf07443-9a3e-4b94-a668-1930f3a66029",
      "members": [
        "3d45140a-ed02-4989-9a2c-1c430911137a"
      ]
    },
    {
      "cluster_id": "63e3781f-5042-452b-a77e-11f62bb59587",
      "members": [
        "b4598419-3888-470c-af66-54e429df15bf",
        "48abfe8f-9f46-4310-9097-df2faacdef21",
        "5bec55e8-6809-46ea-85ad-3c7b4426a4a2",
        "9697d1ed-6eb3-4678-ba13-e0e4ce60c850"
      ]
    },
    {
      "cluster_id": "f7d6db0d-ad7a-49ba-bfea-afddcfaa06ba",
      "members": [
        "ddbca3ee-3ce3-4f10-a6be-56733bb2151e"
      ]
    },
    {
      "cluster_id": "1bb3c826-37ca-4435-8ad2-e211e6cd9444",
      "members": [
        "e4e829f8-e504-4cee-b1aa-f2baf9a93288"
      ]
    },
    {
      "cluster_id": "bc618add-d50a-4d41-b375-e0f4e3b7232b",
      "members": [
        "4376bf3f-5cf3-40a8-8f0c-41c20cad6dc5",
        "bd58c05f-b93f-4af8-bdad-fc72957680f4"
      ]
    },
    {
      "cluster_id": "37b0238b-c658-4977-a22b-36f3d3dc6e36",
      "members": [
        "88769019-7241-46e9-89a4-31caadd73597"
      ]
    },
    {
      "cluster_id": "7e615b29-206f-45ec-8b7c-74785c5252c8",
      "members": [
        "f572f129-d8bb-4d0f-9092-aa36d5fd0212"
      ]
    },
    {
      "cluster_id": "1285d3bf-ce3b-4c4d-b6ee-39e378371b65",
      "members": [
        "1baeb73c-ac77-4cb4-8916-b2601cef55ba"
      ]
    },
    {
      "cluster_id": "593dac82-590e-4efe-97bb-2666521b40b5",
      "members": [
        "0646c5a9-5c8f-49eb-9cdc-2558df2f7305"
      ]
    },
    {
      "cluster_id": "7b391ffb-dc10-4ded-babc-680617024509",
      "members": [
        "1c591bd1-dbaa-4054-972f-d74e7ab91f32"
      ]
    },
    {
      "cluster_id": "575fb3af-a2e1-40b5-8235-6bc79d73e849",
      "members": [
        "aded59d1-81bb-4062-88ec-1b2e1e7280a1"
      ]
    },
    {
      "cluster_id": "8dc116ab-03c9-451e-bd40-127719cd94fb",
      "members": [
        "49c572cb-93f0-43ca-967a-98c59897f32d",
        "7ee60054-be86-47e7-8f19-418ebd357da1"
      ]
    },
    {
      "cluster_id": "7efa0178-d8ab-468b-a654-e8cca19d755a",
      "members": [
        "f22893c8-3eff-4926-a412-e01a874ff8ee"
      ]
    },
    {
      "cluster_id": "e2e4a182-34d1-44dd-bd17-91104b15baa4",
      "members": [
        "62fbb347-74d8-4b62-b3a1-4365c6c770ad"
      ]
    },
    {
      "cluster_id": "75279036-9309-48c1-9fcd-8d4eebf44481",
      "members": [
        "02047144-2738-4eae-997b-c9787c165309"
      ]
    },
    {
      "cluster_id": "91bba9c4-4aa2-47af-b118-a7d49761b237",
      "members": [
        "2ca134f3-5109-4df4-a29d-3cdda4a037a5"
      ]
    },
    {
      "cluster_id": "2ebae150-b502-48c5-b8c2-6a7238a86864",
      "members": [
        "352c1b61-38ec-42ec-962a-8f2fda4f862f"
      ]
    },
    {
      "cluster_id": "1396142d-5fd2-4c3f-8a9f-e0d1627fb926",
      "members": [
        "cfbfad32-bf43-45f1-82f7-50acd200b119",
        "0cffc2cc-b1b1-4d89-9f69-ca6b18367663",
        "9c2b371f-388f-47ee-b206-3e82809389d5"
      ]
    },
    {
      "cluster_id": "a3b6f394-159b-439a-a766-38bc59e64bb8",
      "members": [
        "2d5fa91c-6d11-4f83-a35b-5bad53ec7012"
      ]
    },
    {
      "cluster_id": "53dbd851-31b8-4afd-8a69-b5ebc32a8f7b",
      "members": [
        "11d456c9-0719-478d-aca3-53788064de86"
      ]
    },
    {
      "cluster_id": "335df50f-3c96-4c54-9d41-b51376489798",
      "members": [
        "21cdf176-577c-473e-a896-32788b43445c"
      ]
    },
    {
      "cluster_id": "f0449899-c6ef-4a85-b5c8-5f78e0da96c1",
      "members": [
        "634f6a08-dbbe-4adc-b386-e4e4cabfe4ec"
      ]
    },
    {
      "cluster_id": "042df2bc-4559-4f30-9abb-b285376932e3",
      "members": [
        "77e453a4-b968-43ee-ba2f-2f8f4f402e47"
      ]
    },
    {
      "cluster_id": "3ef2d7ad-744b-4957-b2f1-17396d9e9cba",
      "members": [
        "86962d4c-646b-4814-bed6-c43ad623d9f6"
      ]
    },
    {
      "cluster_id": "104fb09e-1224-46b2-885e-348a5c279186",
      "members": [
        "7777291f-bd26-463c-aceb-ef76ba3549fe"
      ]
    },
    {
      "cluster_id": "4b50f48f-0dd4-4d51-a40b-e932902a32fc",
      "members": [
        "c0f58f86-2857-4261-aff7-9ae691852fce",
        "0e74f67b-3e61-4007-b6be-80bd0aac365c"
      ]
    },
    {
      "cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c",
      "members": [
        "5036018a-13f3-41b2-8d57-c2b8539ee8a8",
        "0acf27d2-2674-482f-90c5-bde37a973fb6",
        "05ea2b41-7f2c-4b98-9986-f0043518081a",
        "167e4a22-6387-4899-9281-5bd108afc174",
        "d4755858-bd8c-4c93-9c06-e217f923e761",
        "50e0fbe0-6c0d-4be2-b076-f81b92f1837c",
        "1dd490f9-ca8a-40a7-bd5d-e3272082f00b"
      ]
    },
    {
      "cluster_id": "28b9ee99-8c41-4de6-b5e4-1d006511f119",
      "members": [
        "4352707d-d0be-4b31-a45d-0a646b63f2aa"
      ]
    },
    {
      "cluster_id": "4e67b541-7502-4017-a45d-06f9dbc9f516",
      "members": [
        "7bc32684-567d-4629-8d1a-f8d2316ff03f"
      ]
    },
    {
      "cluster_id": "b5dff88c-bd24-425a-aabb-6f3428e4297a",
      "members": [
        "7b8cb1db-e06f-46ea-9024-40ba0b35f6ba"
      ]
    },
    {
      "cluster_id": "05edffd4-72ed-4cb5-ac3b-f631f2c3d46a",
      "members": [
        "142ed585-ebe1-4eaa-a149-9415efcd90f6"
      ]
    },
    {
      "cluster_id": "61d1a73d-bcca-4e5e-a4fb-5d21b8a13b97",
      "members": [
        "7dc05c9d-0db8-4449-baee-f75aa2104f1d"
      ]
    },
    {
      "cluster_id": "5c72c86b-5dfd-4f55-ab98-8ad01ed266f5",
      "members": [
        "0f6cce71-8ea2-4fd8-984d-daac4761d8d1",
        "109456e7-36bb-4930-9d93-ea01d1f2c8af"
      ]
    },
    {
      "cluster_id": "59b16d26-5dcb-404b-8589-2b9a2089c70d",
      "members": [
        "201ff659-56bf-4fad-8c16-6c89a915998b",
        "9e897f33-59ed-4230-895d-0ade8df6be15",
        "851308e8-afce-4654-97d3-ad29ed078b8c",
        "8b3d734d-3752-4511-8163-4338dd74beb2"
      ]
    },
    {
      "cluster_id": "79350a97-33bb-4081-9a5c-bebaa0641f2a",
      "members": [
        "b8d1de50-bd34-4c0f-8aee-fed5d630ee6f"
      ]
    },
    {
      "cluster_id": "22e5ae9e-51e6-4da6-a862-0555cb893e6a",
      "members": [
        "02a296f9-7cb5-40c4-8127-126855d90c32"
      ]
    },
    {
      "cluster_id": "8b8269a1-ffad-456b-b974-307474aac288",
      "members": [
        "1bd6ec24-448e-4a14-8f18-82099dd796ff"
      ]
    },
    {
      "cluster_id": "a899a63e-c3d0-425f-8700-82abc0fa345a",
      "members": [
        "2194d3c4-cf89-4d0e-ae1e-827648bcbe1c"
      ]
    },
    {
      "cluster_id": "2e33e564-22f6-46fe-85d8-8500ce2d3380",
      "members": [
        "18ddd34a-9fa0-4725-90cb-2d8e26369028"
      ]
    },
    {
      "cluster_id": "5df7d808-68d6-445c-b39d-37aecaaa35ed",
      "members": [
        "6e9d08e7-e9f8-40c8-9f92-dc69836d6373"
      ]
    },
    {
      "cluster_id": "87e69472-d284-42bf-9dfe-9535bde32efa",
      "members": [
        "fdddd839-4566-469f-9d0c-0f675b3b4917"
      ]
    },
    {
      "cluster_id": "8d692cd5-28be-4ffe-a181-b8bc827723ec",
      "members": [
        "c2821d80-7208-495d-847c-7f11fb7194a5"
      ]
    },
    {
      "cluster_id": "f15d86b1-5ec6-42af-abb5-8a53b43a9bab",
      "members": [
        "50b2f529-578d-47e2-9c73-e314c368fe32"
      ]
    },
    {
      "cluster_id": "a7318687-bec9-447f-89a2-3a9e7981d92c",
      "members": [
        "f00928b3-8beb-49ff-a99b-33ba4c9c14f9"
      ]
    },
    {
      "cluster_id": "18ed12f0-a6ed-4c61-bb56-179e38c03061",
      "members": [
        "3a67b905-6bc5-4a63-a38a-674a9505a860"
      ]
    },
    {
      "cluster_id": "073edba6-a930-4e69-b786-5decd28e9957",
      "members": [
        "f127102b-7adb-4e68-a451-2425dbba1859"
      ]
    },
    {
      "cluster_id": "49650712-227c-465d-93ab-16c3e2405aae",
      "members": [
        "fe2508ca-6116-4a3d-9737-4aa7db42765e"
      ]
    },
    {
      "cluster_id": "b36258d9-8de3-4cee-b76a-8d1ee69dd79c",
      "members": [
        "1b015b0e-a03c-4937-9823-1bacacf9829b"
      ]
    },
    {
      "cluster_id": "bb3ba302-b163-46a5-9a24-14ade245b1de",
      "members": [
        "4b04968a-40d3-40cb-8c8c-0b5c8f8f8725"
      ]
    },
    {
      "cluster_id": "1630f0d6-45b5-4a9c-9208-8292e05b3a85",
      "members": [
        "863f8eb6-77ed-4cef-a8fd-1980608e3e64"
      ]
    },
    {
      "cluster_id": "eb0ee0ba-913e-410b-b9c2-5aa8871f3d24",
      "members": [
        "710fc521-cb74-480a-9af7-4ec589ecdc6d"
      ]
    },
    {
      "cluster_id": "d862e5c2-98e9-4ead-8a8e-98d31f78f4f8",
      "members": [
        "eeefd7e6-0935-4089-a906-74c5a26488f5"
      ]
    },
    {
      "cluster_id": "2e1f7f19-b115-4df8-ab1f-76f94814091c",
      "members": [
        "b1b2ebea-a5ff-4862-8b01-03ef9d085242"
      ]
    },
    {
      "cluster_id": "bf840015-2be2-4173-ba65-4d1448510aee",
      "members": [
        "f1d018c9-5f57-468e-a553-f54406863636"
      ]
    },
    {
      "cluster_id": "fc762eee-b8ab-4b1f-86f1-0e64c2a63eae",
      "members": [
        "b8abbef3-c963-4eaf-839c-91e40f2a474e"
      ]
    },
    {
      "cluster_id": "c7824331-8340-4b01-8402-1e8e570e3b30",
      "members": [
        "6cc5144d-233a-4d4f-9640-ad6d90f72bf5",
        "63723f47-361c-4376-807a-db90f7e6a177"
      ]
    },
    {
      "cluster_id": "757b69bc-6342-44ee-8a8e-c35de9054b6d",
      "members": [
        "a4e248bb-f94a-4156-905d-17848d31e342"
      ]
    },
    {
      "cluster_id": "33028b3d-3070-4c94-af90-91fb62e4dd68",
      "members": [
        "85681712-7d60-4155-8edf-867cd1052f0c"
      ]
    },
    {
      "cluster_id": "f6f6ac6a-d140-47fb-94ad-797d11509e6a",
      "members": [
        "3b6b889a-8e36-4d97-a4a7-771df6caa01e"
      ]
    },
    {
      "cluster_id": "6b05928d-06c6-4035-8854-c47627756aaf",
      "members": [
        "404a1fc2-b7e5-42ec-9a0d-c3fbed70fd5a"
      ]
    },
    {
      "cluster_id": "5ccfc9e2-21fe-49eb-816b-e5684332d360",
      "members": [
        "0b0c9c20-af04-44ba-8190-bf7deeebc033"
      ]
    },
    {
      "cluster_id": "01800770-341b-42d0-83d8-a7e215d97f98",
      "members": [
        "75e9d959-28f3-4ac3-b543-a46afb1c8735"
      ]
    },
    {
      "cluster_id": "a83610f0-30d5-4dda-896a-6faaf1c01536",
      "members": [
        "75a831c9-64bc-48da-b175-a2437e47dd83"
      ]
    },
    {
      "cluster_id": "ed59d768-edd7-48c0-ac20-df8f0d6dc5d8",
      "members": [
        "97350da0-d1db-4b53-a3fc-ef06b13b945c"
      ]
    },
    {
      "cluster_id": "d3a2d90d-13dc-4075-9660-3952f836b150",
      "members": [
        "2950345a-e866-4de3-92f1-2cb1e4c25f8f"
      ]
    },
    {
      "cluster_id": "bc347754-e0eb-40ff-81ea-81da10f629ed",
      "members": [
        "7db6c8a6-60bc-4662-b2dc-199aa561b87e"
      ]
    },
    {
      "cluster_id": "d8bdc753-fad4-4cd8-b9f2-efb5708d6629",
      "members": [
        "ea7a2b72-7d1f-4c73-a073-a7b027631757"
      ]
    },
    {
      "cluster_id": "e4e28c57-a8cc-4df1-b26c-23b630ca06ac",
      "members": [
        "201f7365-3e62-47f1-9210-042b45108003"
      ]
    },
    {
      "cluster_id": "726b06eb-9cb3-44bc-9105-8eb731155948",
      "members": [
        "b7b32401-5690-41a0-af65-8ece78fd91fe"
      ]
    },
    {
      "cluster_id": "ad92d574-8bb8-4072-be84-8313fb209fd6",
      "members": [
        "c8de3f3a-96b2-48a0-bace-ff2c0f38239c"
      ]
    },
    {
      "cluster_id": "4c3966c5-0cc9-4924-906d-113f0618534f",
      "members": [
        "157e34be-f855-4ce9-bf07-9c26d1427230"
      ]
    },
    {
      "cluster_id": "b4dd0b00-f893-486e-8f26-56d055b47620",
      "members": [
        "a5d1d62e-20f0-40cd-9604-245b0e5f8830"
      ]
    },
    {
      "cluster_id": "99212234-66c3-470f-9dda-4b5f137ff502",
      "members": [
        "61eb6e4e-8226-4649-a28c-6a1d5143a326"
      ]
    },
    {
      "cluster_id": "bfbf1707-08cb-4022-8bc5-78477fc5de4e",
      "members": [
        "6ee233fb-18ce-46c2-9236-b4b2ba49b6e8"
      ]
    },
    {
      "cluster_id": "c2c95c94-edcb-470f-82d7-17f1cc69860f",
      "members": [
        "f9972a21-0ed8-4c53-8835-ca063429c525"
      ]
    },
    {
      "cluster_id": "91c23991-d38e-40c8-af05-0cbccbeaf641",
      "members": [
        "3254bd8f-d52e-4eb5-9cac-a67f2dc656e4"
      ]
    },
    {
      "cluster_id": "1e2063e0-1979-4024-9493-206d34c55c1f",
      "members": [
        "e1e86014-5779-43c2-a83e-e8910c811c28"
      ]
    },
    {
      "cluster_id": "3b28fd20-f6ec-4932-9943-984312470724",
      "members": [
        "e5f9b0d6-7e73-4a08-aa88-88ca82ea4f7a"
      ]
    },
    {
      "cluster_id": "1b2a4f9c-8284-4418-843c-06b19834c251",
      "members": [
        "c265307b-a45e-40d2-942e-064e09203a3b"
      ]
    },
    {
      "cluster_id": "1bb1e966-aeca-49bb-87b9-768c9cbb3254",
      "members": [
        "80874662-775d-4097-ab12-519fd35a8af0"
      ]
    },
    {
      "cluster_id": "a685f849-800e-4402-90fe-e957d6fe91e6",
      "members": [
        "b6debf5b-3fd9-4758-8d65-ddcfa76159c1"
      ]
    },
    {
      "cluster_id": "6e45b980-570a-489b-b31b-a504f6b1257e",
      "members": [
        "de7db6fd-2ae6-4f7a-b2d2-140c467a7909"
      ]
    },
    {
      "cluster_id": "f55d5834-9821-4e96-8403-e81fdf294300",
      "members": [
        "3737c0e5-0ce0-43f5-85a5-06097bb825b7"
      ]
    },
    {
      "cluster_id": "4a20b107-b497-42c8-8807-874212cad7e3",
      "members": [
        "041efd3d-3637-4fdb-883e-7e7a15720adb",
        "c0954b16-8dca-44c9-9bc8-66debbd14700",
        "c444c044-c221-4210-b7fa-34b86f049f7d"
      ]
    },
    {
      "cluster_id": "59fed447-7963-4349-9213-761a767fe70e",
      "members": [
        "e0fadef7-8cb0-400b-87ba-015ee4371568"
      ]
    },
    {
      "cluster_id": "27a6e31f-9188-49c5-afc9-f45a074457ba",
      "members": [
        "2f08b13a-ecf0-4799-a14d-58bf972dd8ec"
      ]
    },
    {
      "cluster_id": "13e00f68-1db0-4207-bb35-e56787801241",
      "members": [
        "7e44b6c6-7d56-4232-819d-53ec3fa86eca"
      ]
    },
    {
      "cluster_id": "81bcd47f-070e-4939-b97e-e26a5423d8a9",
      "members": [
        "e044f66e-1051-432c-9447-d98bcbe37e2d"
      ]
    },
    {
      "cluster_id": "5a080de2-e14b-428a-ad25-1b9fd1bb59d4",
      "members": [
        "806cfcc9-2fa9-44ee-85fa-be86fd0c140b"
      ]
    },
    {
      "cluster_id": "36b001d3-8cd6-4b58-93ae-5ad737efa236",
      "members": [
        "3d0c34ba-5eed-4155-8048-07dea2acc752"
      ]
    },
    {
      "cluster_id": "af8cdf46-4050-4634-a0b0-6bc6cfa78956",
      "members": [
        "58bcf34f-8ba3-4b84-a26f-99d50d09da47",
        "0432a5dc-9139-4f9e-8346-33d3633cf2f2",
        "5a9df2c6-1051-481f-8995-20bb7f272aa9"
      ]
    },
    {
      "cluster_id": "d81a0c92-8b3c-4dd5-8534-db608b237cf8",
      "members": [
        "595f845c-20e2-4266-9c19-52b6519191bf"
      ]
    },
    {
      "cluster_id": "1ff86b5f-b9df-4809-8840-440abb97575d",
      "members": [
        "a3dbd081-e0b4-447f-a34f-0188df7b1cfd"
      ]
    },
    {
      "cluster_id": "abca71f2-b0b7-497b-b1ed-9f04c6ea4023",
      "members": [
        "2a7b8375-e2a4-40b6-8703-a6867c26ee76",
        "4eacb1da-29c5-4742-acfc-7218c4550e65",
        "f546c638-ba96-4832-b699-e89ff607a5a5"
      ]
    },
    {
      "cluster_id": "fa13d89b-1dff-4027-a91c-143971ebb4aa",
      "members": [
        "5ad531ab-4764-4ef7-baba-70398900776e"
      ]
    },
    {
      "cluster_id": "503eed9f-ea34-45f7-b3eb-f015bdc664b3",
      "members": [
        "20591f9f-e0ef-4998-90e0-cea448297dde"
      ]
    },
    {
      "cluster_id": "cbddcfe6-4088-4603-8e7a-ed109a9fff44",
      "members": [
        "108e779d-9db3-4fd0-9788-b9157c4ab56e"
      ]
    },
    {
      "cluster_id": "128d37ad-2ce5-409d-8ce0-e9df31085f42",
      "members": [
        "1e36d9a5-24c2-4358-9d06-5f639bbe88fb"
      ]
    },
    {
      "cluster_id": "9dd9bb3f-346d-4bab-978a-64ea761a815a",
      "members": [
        "aa40d2ac-2714-4625-babf-90088c7be49f"
      ]
    },
    {
      "cluster_id": "037c02f8-bec2-4837-9533-93f63490c709",
      "members": [
        "87097f69-f45d-4265-af3b-f1353bd44cc8"
      ]
    },
    {
      "cluster_id": "05fe6713-720d-475f-867a-c6de011c5f20",
      "members": [
        "dddd9c26-ce0a-4e7e-a0e6-93e55f2f4446"
      ]
    },
    {
      "cluster_id": "21751149-a038-4fe4-a432-932902e5041b",
      "members": [
        "0e7c3843-8c18-486d-87e7-d205bfd1bddf"
      ]
    },
    {
      "cluster_id": "b929e356-d8ff-49f7-a4f5-c02953cef416",
      "members": [
        "3d446a56-a3cf-4d57-befe-1d011f977087"
      ]
    },
    {
      "cluster_id": "33b55b1e-2a6f-4f56-affb-50cf2ec05471",
      "members": [
        "895c4b1a-bfdd-43b5-88e8-3f03cee20224",
        "45c89f5e-2f92-41fc-9e61-9a7bdd31acef",
        "cb9a225b-b8d9-4863-bded-41002e213aae"
      ]
    },
    {
      "cluster_id": "4a931ec3-ec4b-489a-8ad6-020f2eb48663",
      "members": [
        "1f31387f-602f-4406-b683-3349a0445c7a"
      ]
    },
    {
      "cluster_id": "96c05405-04cf-48e3-824b-2a96332d38b7",
      "members": [
        "bb15e0f0-16db-4581-a33d-49bdce475328"
      ]
    },
    {
      "cluster_id": "94b0a214-1e60-4bbb-96cf-031169c35247",
      "members": [
        "f73ccc40-9526-460c-ad2f-f60fad7ce28b",
        "c2d2c458-bce0-4b94-b0e3-fd1544161903",
        "7a0c3805-7034-4d3f-93c1-658b2953d611"
      ]
    },
    {
      "cluster_id": "32ea90b6-1f69-462e-a6fa-1e6c1978de12",
      "members": [
        "f2e1273d-63f8-445e-a431-b0e75cdf5564"
      ]
    },
    {
      "cluster_id": "e9f22744-079e-483e-97a4-7cefb12988e9",
      "members": [
        "485eb0cd-4bd1-4c5b-a0bc-f24751f1688c"
      ]
    },
    {
      "cluster_id": "8bda5e73-cd1a-4ebf-b3bb-55b54ec157d7",
      "members": [
        "ee6b2298-47b7-4481-8fe6-951504b15004"
      ]
    },
    {
      "cluster_id": "0040fc97-03df-421f-96ac-2c09e7b8a54f",
      "members": [
        "1ce1328d-6ce2-489f-b6b2-35da0faba554"
      ]
    },
    {
      "cluster_id": "297764bc-d5fd-4054-ab93-cb0530d2df4e",
      "members": [
        "f73fdbd4-3902-4798-a160-be278afda5fe"
      ]
    },
    {
      "cluster_id": "afa23bc4-1fbb-45ef-b64c-09dde901c8b3",
      "members": [
        "8126a34c-5ee8-475b-8526-f4d565d7db8f",
        "cf62689b-6516-4810-8e42-520e8a51af3e"
      ]
    },
    {
      "cluster_id": "65c273a5-7b4a-439b-abf8-ac2e7eea9f97",
      "members": [
        "ab43d039-96d0-4d64-8845-a0f23f6afccd"
      ]
    },
    {
      "cluster_id": "22388e5b-3cdc-4eb4-8e97-052ccfe18cfd",
      "members": [
        "d0ad0b02-60ab-4619-a430-6da20b6c1436"
      ]
    },
    {
      "cluster_id": "dd4b1ab9-a797-483e-b837-bc9140aab68d",
      "members": [
        "c7cdea89-036d-4bcf-85df-916f09f07798"
      ]
    },
    {
      "cluster_id": "b9c0c358-d5e1-4c6e-9602-a307115394e0",
      "members": [
        "5487ccd1-6b00-4e12-8e12-04bad8b9c440"
      ]
    },
    {
      "cluster_id": "a1ea18ac-be18-41e4-86ed-51a5a227e8ba",
      "members": [
        "ecc020ce-fecb-452a-af8c-ad9709949f72"
      ]
    },
    {
      "cluster_id": "9c21e744-a69f-4d9f-abbc-ec67be5c4220",
      "members": [
        "f63b0a7e-2f78-4a73-829e-07523b9f1f51"
      ]
    },
    {
      "cluster_id": "34a1784c-8849-4447-8724-747b9b1cd1bd",
      "members": [
        "f2bf68ae-a55c-4529-8841-e51b1e49ccfd"
      ]
    },
    {
      "cluster_id": "4005f43b-5b4a-44f8-9781-c0a91127368f",
      "members": [
        "6a04f59f-82ff-415c-8bec-2ed8a8f679e8",
        "661f3ede-e539-43ba-97be-c3c6c34b20d1",
        "755c3d09-13eb-488d-aafe-355aee37e54a",
        "49090a4a-0445-4ea4-a0cd-c4c893b6b2a4"
      ]
    },
    {
      "cluster_id": "ac2c361f-32c9-4d71-8c96-6c8953a04d75",
      "members": [
        "1aaa012c-a242-4929-96eb-70b19589f395"
      ]
    },
    {
      "cluster_id": "d03251b2-2516-4731-9dc4-6cb10da8a70a",
      "members": [
        "85fb84b0-0122-40e9-b27c-d5a75ab417c4"
      ]
    },
    {
      "cluster_id": "6c1c53f7-282d-4c0c-a8d8-dac0c8af5a96",
      "members": [
        "c807536c-627d-4ea7-a757-b1fc516650c4"
      ]
    },
    {
      "cluster_id": "7354cd90-5ded-45c2-af70-b5cea1cc0045",
      "members": [
        "fdfe3472-c5ba-49de-8042-03f87d3b22f2"
      ]
    },
    {
      "cluster_id": "f78012d1-f500-46ba-802c-d3d1337f7f51",
      "members": [
        "bfa887a6-b322-4da1-a76b-7b5b3f653cc4"
      ]
    },
    {
      "cluster_id": "f16aab95-d35f-4386-9ea4-6a5f797bcf7f",
      "members": [
        "c0bc1a44-9b42-4cf0-aab0-ae80b02a03c6",
        "d33b5e59-6951-4a55-90d5-de0ad14275bd"
      ]
    },
    {
      "cluster_id": "c786e602-255f-4df8-a9fc-775fc1322fa2",
      "members": [
        "6b35feeb-649a-4826-af85-82f8a6706455"
      ]
    },
    {
      "cluster_id": "9db91412-4257-4b55-b7af-99ea85b2a619",
      "members": [
        "f40486a0-ea1d-4cfb-a807-029ece0cb041"
      ]
    },
    {
      "cluster_id": "bdbb752b-6e19-40a1-b874-d58f3b375de7",
      "members": [
        "d179af4f-4114-4e08-96db-ce490af45be1"
      ]
    },
    {
      "cluster_id": "f0ad65d9-233e-4737-b565-7bb483317155",
      "members": [
        "be52d413-c060-46df-ae49-6f8e865d0ae2"
      ]
    },
    {
      "cluster_id": "cb759cf9-83bb-41f1-8a60-65bf2476c5fa",
      "members": [
        "b82e31c4-552a-444b-a496-ff8aa9a48878"
      ]
    },
    {
      "cluster_id": "429b9019-55ed-4d53-b962-21e416686d27",
      "members": [
        "2318fe24-10d8-4966-a4b3-8bc37a734c13"
      ]
    },
    {
      "cluster_id": "d9598814-d7a3-48d1-b282-0aa4d0dfeb8b",
      "members": [
        "e02ac3bc-7a18-4bfb-9c46-d2b7239b6583",
        "9173eff4-97ad-4bb5-8e6b-14709e083d90"
      ]
    },
    {
      "cluster_id": "6b0217e7-2354-4152-81ca-d64e5b080b90",
      "members": [
        "0d4aa265-11b9-4915-b054-93ec17930f3a"
      ]
    },
    {
      "cluster_id": "63be6506-f9dd-4d4c-86f5-e451710401ef",
      "members": [
        "956e3474-5618-4c81-9e49-a51567c16fcf"
      ]
    },
    {
      "cluster_id": "6234ba01-768a-474f-80de-4d8b6df78d63",
      "members": [
        "a0f28cd3-c641-4002-8200-92f884c4cf8e"
      ]
    },
    {
      "cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb",
      "members": [
        "5d23ebd4-1e86-43e3-81c7-16ad606a11d8",
        "042d73a9-eff0-48d9-87f1-42da99cdea5f",
        "4616c099-332d-48b0-be2a-147071ab69a7",
        "f75b18ce-ace3-4943-b15a-a61a8af1f693",
        "258a754a-0776-4907-951c-96c7047a7dc0",
        "b573fb16-d274-420d-b3dd-b10e9a2e04a0",
        "39dd2991-e610-4df5-afbd-5799d0b4365b",
        "93b9d616-36b6-407b-ad9e-1fb9962ff572",
        "b43b7493-d28e-474e-92b1-627bc2df5911",
        "6516a31b-abc5-4f9b-aa9b-e52da0bd84d4",
        "20da7166-f5ce-4d8c-83f1-29c7e9cb057c",
        "e9ce639b-b0f7-4d33-b373-cac3937c6b6d",
        "358b2051-a2c0-4f07-a722-49419301d4ac"
      ]
    },
    {
      "cluster_id": "3b02e47c-e307-44b8-85bc-a7863107a268",
      "members": [
        "18bd5197-ea18-4065-a9e0-567e3b1c277d",
        "06d01bdf-9277-442b-b673-b5c5a365b0ce"
      ]
    },
    {
      "cluster_id": "24866e6f-4fd0-49f1-b25e-9d7dc5227353",
      "members": [
        "f726ffc2-3647-400d-80a6-f52985797422"
      ]
    },
    {
      "cluster_id": "a0e15f6d-9d91-458c-9257-5c60799b9290",
      "members": [
        "68dd5299-7fd4-430f-8b60-388906a72882"
      ]
    },
    {
      "cluster_id": "3923fc76-d76d-4386-926c-4e8e39862387",
      "members": [
        "67b03e9b-943d-4bbc-a124-9c5578ef7ef2"
      ]
    },
    {
      "cluster_id": "37f90fa7-4e1a-46b6-b513-6bfba31c2cf2",
      "members": [
        "93f6b1a4-8c3f-4a06-9824-0ba2df7d17d9"
      ]
    },
    {
      "cluster_id": "c5882250-4bcf-4c65-93ec-7937e1c0803f",
      "members": [
        "13d2edcb-24dc-4bec-bcab-c09b3c14e8f8"
      ]
    },
    {
      "cluster_id": "a74e2cea-b4c4-4a7d-a1c4-162f2fa0ad2e",
      "members": [
        "7dff7322-4805-4518-8f58-584aac64f379",
        "71137349-c545-4726-a3fb-95eb051d846d"
      ]
    },
    {
      "cluster_id": "2fed86e0-073b-4885-a91c-3e9ba6cceef8",
      "members": [
        "6c94502c-3a79-4e01-b9d8-632621273814"
      ]
    },
    {
      "cluster_id": "8914f459-9cc2-4812-af44-1d97ee5106e3",
      "members": [
        "ef73f4bd-2cd1-4b72-9c3c-c2591a929a40"
      ]
    },
    {
      "cluster_id": "8e7cadbd-1c4e-497d-b941-1d05a2c467a3",
      "members": [
        "6776a7d5-beaf-4c41-aa38-300a0801b709"
      ]
    },
    {
      "cluster_id": "1b8d5ce9-1627-406b-ad77-075419ad3508",
      "members": [
        "d8891a94-9140-46bb-bcdb-3d29d91975f5"
      ]
    },
    {
      "cluster_id": "10a3db6f-9669-4c8a-9480-85cb3dd1626c",
      "members": [
        "bcbce5e1-e6dd-4fb3-b640-98dccec00c92"
      ]
    },
    {
      "cluster_id": "e19196d4-b7bf-49e0-b42c-244f5f90725b",
      "members": [
        "46a1a4b3-5947-4f7a-937a-1787f32e8bcb",
        "79699b3e-4c16-4dea-9c40-aab3eaaabdd7"
      ]
    },
    {
      "cluster_id": "52204f25-791c-4bc8-9a84-ab506bb1cad1",
      "members": [
        "f2f46d22-9183-4d22-a258-f7deec1e4667"
      ]
    },
    {
      "cluster_id": "a6d23154-5d6d-475a-a318-8f3c90f26a02",
      "members": [
        "eee7a4d9-8e2d-47ee-8999-987c6555cb58"
      ]
    },
    {
      "cluster_id": "8017a44f-3587-48ad-93bb-373a715846dc",
      "members": [
        "11e6af92-7c17-44a8-9ab1-609463443a49",
        "e40c33f9-d7fa-4137-9f80-4c8229c27471"
      ]
    },
    {
      "cluster_id": "e21a96d2-b5b0-4a69-80bb-66020b0b8a54",
      "members": [
        "f4b9f0d4-2a14-40af-9ab6-151433206f04",
        "3ac87666-f63a-4e9c-812c-b18af694a7c0"
      ]
    },
    {
      "cluster_id": "efac6d2d-0cde-45fa-bbfd-2de2e2cbe0cc",
      "members": [
        "dfc78b17-77bb-4229-957b-d80d3ad115c8"
      ]
    },
    {
      "cluster_id": "d47fde78-a16e-43e2-a490-d66e81b31f7c",
      "members": [
        "67774ca3-9e92-4d08-8579-3aaf1352ddf2"
      ]
    },
    {
      "cluster_id": "97b1177e-80bf-4e09-83e5-b50aecee0b52",
      "members": [
        "53c56e4f-f7aa-498b-a6a2-d571622c455c"
      ]
    },
    {
      "cluster_id": "10698f29-8fe6-47a6-b30e-e5ff5dcfea6b",
      "members": [
        "c563fc88-dbde-45c0-91ec-aa24573796f5"
      ]
    },
    {
      "cluster_id": "b8d20c5e-c322-4b49-99bf-b717fffef7d5",
      "members": [
        "cff7a05d-3faf-4626-9e30-2425b37b803b",
        "da87ff37-ca2b-47c1-831b-8b46e125edb8"
      ]
    },
    {
      "cluster_id": "98e6d6ef-a2d4-4de1-80f2-7297b807d073",
      "members": [
        "12f512c6-9447-45bf-84b7-c471a724c050"
      ]
    },
    {
      "cluster_id": "fc6510d9-839e-4451-a099-a28338b3f8c9",
      "members": [
        "72464dda-73dc-42a3-bd28-c42b8e02f4f9"
      ]
    },
    {
      "cluster_id": "770085f4-c156-40e9-85de-d0bb720ad51c",
      "members": [
        "3c5df01c-39f1-48ad-b488-cc651a5bee87"
      ]
    },
    {
      "cluster_id": "d2fe7e4c-e188-41bf-8d04-054692838ea8",
      "members": [
        "55149787-986d-45e4-b225-54181d7d8cf7"
      ]
    },
    {
      "cluster_id": "cfbc5753-ac66-4d7e-b3ad-5e7f58c3e6df",
      "members": [
        "6d127b3c-a603-4734-96e1-89cef5a4128a"
      ]
    },
    {
      "cluster_id": "80e1112c-9669-4621-a0a1-38f35b5f11c3",
      "members": [
        "93d5589d-ec1b-403e-b7b7-ca6f4146db7d"
      ]
    },
    {
      "cluster_id": "49b4c78b-ed4a-40e7-bdfc-7463c3169502",
      "members": [
        "eaf5b6ba-8898-4839-b6a9-fc7cdd78ce02"
      ]
    },
    {
      "cluster_id": "895f4da6-0e6e-4170-be66-262513dfdc91",
      "members": [
        "0534dd3a-1108-4c6c-8042-56dd3e0e1de4"
      ]
    },
    {
      "cluster_id": "cb44bed2-b70b-436a-82dd-d405face631c",
      "members": [
        "2c70aa6c-a47a-4ec6-9c2f-3780e8077140"
      ]
    },
    {
      "cluster_id": "7462b6fe-d6f4-4e65-ac8e-8fa4c8e00ce3",
      "members": [
        "4d27344b-c507-440a-ae52-1d0a68fdf680"
      ]
    },
    {
      "cluster_id": "ed28ca5b-2948-4f9e-a9bc-a57f2f3f7cbd",
      "members": [
        "b148b335-5477-4655-b6a6-2f5cfaac025f"
      ]
    },
    {
      "cluster_id": "eaaf5d8a-fedf-4978-9ba0-14aae1ce95e7",
      "members": [
        "8cdda31c-9b71-4441-865a-81116c144f4c"
      ]
    },
    {
      "cluster_id": "a8acca84-268a-4542-96c5-6e8d1fb747ac",
      "members": [
        "58adc6a2-015b-4cf4-929a-9090cc1d2ce7"
      ]
    },
    {
      "cluster_id": "c021fe18-c42c-443c-8de9-a7f8d58891f4",
      "members": [
        "c0961ef4-9fc4-4628-a2ba-f575365a0926"
      ]
    },
    {
      "cluster_id": "2d8a2b96-5e68-43e2-a162-f66eeb390e13",
      "members": [
        "8a1af2e7-35aa-4ae4-a3a9-dba8d0e29550"
      ]
    },
    {
      "cluster_id": "b74d0080-2884-4f0b-b58d-88fbcf9d76d7",
      "members": [
        "f1b56084-1b4d-4858-b1c5-fe109cb7b38a"
      ]
    },
    {
      "cluster_id": "22c6704f-881c-4e99-abe5-258852387852",
      "members": [
        "3a41d540-b1a0-4c5c-b596-8e90a640fa55"
      ]
    },
    {
      "cluster_id": "f2102ba0-d90e-4134-a7ea-638b33257f3a",
      "members": [
        "43ad7424-4c77-4dc0-8c36-9d1d1d14dd12"
      ]
    },
    {
      "cluster_id": "3596032e-4fde-4840-89ec-0f1fed8a80cc",
      "members": [
        "06c72a80-84c2-4b99-b900-146c339b7cb5"
      ]
    },
    {
      "cluster_id": "4ea15f73-7350-4e50-b190-6edec6cdfa32",
      "members": [
        "63fbc0f1-49c8-4b3e-9954-75d114dce032"
      ]
    },
    {
      "cluster_id": "503d3ee0-00d1-464f-abcc-e8b8f12f26a4",
      "members": [
        "9bf4b261-5604-4e7d-bdf4-1d258b3c8c67"
      ]
    },
    {
      "cluster_id": "312c4cbe-161f-46b2-ac85-87a06a693146",
      "members": [
        "bf8c3e12-552a-4a71-843a-f89c91b6389e"
      ]
    },
    {
      "cluster_id": "1cd605a0-684c-41fb-8c06-79b227b23a9a",
      "members": [
        "47086825-ea05-4d6c-a4fb-5290780b5f88"
      ]
    },
    {
      "cluster_id": "0d47b48b-a9c1-49b3-8e15-26d394b843ea",
      "members": [
        "e3ab09fc-1684-492b-adb9-d899f0428e95"
      ]
    },
    {
      "cluster_id": "74848948-285f-4571-adb0-ad9b59d381fc",
      "members": [
        "d941fba6-fd74-4a83-9e8e-d451475571b9",
        "3bb8debd-6d9d-416a-9f04-208936f4533a"
      ]
    },
    {
      "cluster_id": "878a9636-1e8d-41b7-b38c-b1f621f47d04",
      "members": [
        "f3374e00-912a-4a2b-a295-21f6bee73d8d"
      ]
    },
    {
      "cluster_id": "9be4b289-aaff-48fa-8680-b2813e6b1340",
      "members": [
        "48c00d52-4142-44d8-8055-adaf8e806d65"
      ]
    },
    {
      "cluster_id": "3ab13bcd-fc14-4404-8b26-7f8a67a82860",
      "members": [
        "75d8bd40-d695-4208-bab5-37205811fc6f"
      ]
    },
    {
      "cluster_id": "b17935cf-677f-4da3-a3e4-c0a86cab1633",
      "members": [
        "b797142f-6e6b-4e92-947e-f1eac9cf2441"
      ]
    },
    {
      "cluster_id": "395a3f4e-39fe-411b-af09-832b0bf2ab53",
      "members": [
        "c4d166ac-fb2b-4908-b29e-b5e60db0c750"
      ]
    },
    {
      "cluster_id": "366a8fe2-ca03-46c9-b2fb-6c5f6c4014f1",
      "members": [
        "c5d32957-0250-4e27-883f-1614716b7a5a"
      ]
    },
    {
      "cluster_id": "17ce8541-8518-4283-a893-e35ad31e95fb",
      "members": [
        "144a50c2-b370-4909-b53f-80f34729e342",
        "bce91ab8-09f7-46e8-bd90-18e20c9bc00c"
      ]
    },
    {
      "cluster_id": "84f2b012-a880-401d-86eb-78a247c92358",
      "members": [
        "d5908ec5-3ffb-41c4-a73b-cce528382f43"
      ]
    },
    {
      "cluster_id": "72e8eae4-0f40-4ffb-9af3-05384f47f8b8",
      "members": [
        "64afbd72-1116-4c9e-be6c-75364f693bd2"
      ]
    },
    {
      "cluster_id": "1e6f5910-b91c-46ca-bb2a-bace35349e8b",
      "members": [
        "bc099959-037b-43e1-81ab-0a360d9be0b0"
      ]
    },
    {
      "cluster_id": "85c8c155-84b6-47ef-ae7a-060440258d20",
      "members": [
        "98c7e671-e565-411e-842f-6573296ff33e"
      ]
    },
    {
      "cluster_id": "7754f22c-30c5-465a-b231-a607a0c13504",
      "members": [
        "7a2b81d2-3671-4bb5-b252-146ae07d2184"
      ]
    },
    {
      "cluster_id": "a7db18f7-5822-426a-8676-b522df1e90e8",
      "members": [
        "891028a4-9c48-4a22-9b0c-8e72a1f0c9ea"
      ]
    },
    {
      "cluster_id": "20eb00aa-eba7-4ec7-aca2-e9f771d49a23",
      "members": [
        "2218b201-0cff-4061-95fc-3e9f5fb5ffef"
      ]
    },
    {
      "cluster_id": "dcbc849b-d40e-49ed-84ab-ec7cdf4bb695",
      "members": [
        "c683eead-b9f6-409e-98ea-ca86a80fe6b3"
      ]
    },
    {
      "cluster_id": "92dc2b29-cee7-4ea1-b9e9-d0593544c75b",
      "members": [
        "319e2b16-8188-4643-b573-840838be97c9",
        "c5204050-e2a2-4b54-85b3-15ef65842fe8",
        "fe346ac3-50e6-4b71-a9a5-9e964fe80cce"
      ]
    },
    {
      "cluster_id": "232c00d5-5161-4308-8ff9-5bf29dea48c9",
      "members": [
        "dec0aa9e-5fd8-4c97-949a-d4e94ae3538d"
      ]
    },
    {
      "cluster_id": "869d4c13-d074-42b4-bbc1-2f3f74bed7a5",
      "members": [
        "b5463219-98c5-448f-9531-85d2be5f4d74"
      ]
    },
    {
      "cluster_id": "0e78429b-c0f8-4ecd-ae8e-35ff713ba980",
      "members": [
        "ae9feba2-1286-4e90-8d19-f6c6fb5695bc"
      ]
    },
    {
      "cluster_id": "fecb08d6-7113-4fdf-93c0-d68d7f11e733",
      "members": [
        "29c88596-19ba-4c92-889a-93d36cedb885"
      ]
    },
    {
      "cluster_id": "19226ea8-73b8-405a-ba2e-087cba3fab92",
      "members": [
        "0f1e349e-33e1-410f-a80e-7f7a15a64def"
      ]
    },
    {
      "cluster_id": "714c01ca-5d76-4ae8-b75a-06245aaab86c",
      "members": [
        "2907752a-dd04-43a3-81f8-99aed282cd51"
      ]
    },
    {
      "cluster_id": "2d8ca62e-1cf1-4407-a036-bf48f62909c5",
      "members": [
        "e2d6ea9f-2930-4d6a-88e9-e46e90562a30"
      ]
    },
    {
      "cluster_id": "fcb27263-9c47-4749-8f07-d80ab25d503e",
      "members": [
        "9837e2d1-81a9-4dda-a544-9966e203d52f"
      ]
    },
    {
      "cluster_id": "b754c76a-3e29-4a89-b2c2-054b3adbaf0c",
      "members": [
        "cf9857de-8137-45c9-b5fa-915993e74b08"
      ]
    },
    {
      "cluster_id": "38118243-3439-45b9-b0a1-902687ba3cc0",
      "members": [
        "ff9436f6-f297-4eb4-912f-7a157e3d12fe"
      ]
    },
    {
      "cluster_id": "06de95aa-ea18-4201-9254-c11dee534162",
      "members": [
        "30d95fcc-b794-4439-8991-acda681c53e1"
      ]
    },
    {
      "cluster_id": "c926ce6f-72a8-4848-817d-af5dc8f10bb9",
      "members": [
        "38511aaf-9163-4d65-81dd-224ed0e0b81d"
      ]
    },
    {
      "cluster_id": "584c4eba-f170-4492-9acd-c1773318790d",
      "members": [
        "40f52c99-ebfd-45ff-98f5-952306d27151"
      ]
    },
    {
      "cluster_id": "204d066b-baf9-4cb1-b94b-16fcde9be401",
      "members": [
        "11cd3da1-ec29-4a09-b90a-f36ba252d061"
      ]
    },
    {
      "cluster_id": "411cad01-4640-4a11-9464-9f26565f44b6",
      "members": [
        "9a836402-72b1-4d2e-8da1-84843dda9b7b"
      ]
    },
    {
      "cluster_id": "f96ee044-12e8-41d9-ad21-d1cd5c1012f8",
      "members": [
        "611ba306-98a9-4679-8657-f9c54c244a4e",
        "72a28c90-6734-41ff-99bd-7e7f704a0df1"
      ]
    },
    {
      "cluster_id": "edcd5353-7d93-4a6e-9bfb-a26ec2ae09a3",
      "members": [
        "51b2f815-411e-43f8-a5c1-336bea1219da"
      ]
    },
    {
      "cluster_id": "d4eb4c1f-a715-4507-898e-b25f61a6667b",
      "members": [
        "782c2526-0417-4dc7-8284-5083afa85621"
      ]
    },
    {
      "cluster_id": "ed866655-8d58-43f9-93ba-c498e1783c16",
      "members": [
        "dbe3b7f9-9c71-45eb-b905-98ec6f50ca3d",
        "661d6da5-a118-40c0-b59e-fa784c68d780"
      ]
    },
    {
      "cluster_id": "9a05cb71-dda4-4c46-862e-16d08e1809de",
      "members": [
        "5c56c859-c655-41f6-ba71-d6caa0f72e3b"
      ]
    },
    {
      "cluster_id": "e3ef059e-984d-4158-bd79-7968854d515e",
      "members": [
        "f058d856-1ce9-45cf-9d35-23956aa81d73"
      ]
    },
    {
      "cluster_id": "7767496a-74e6-483e-a0d3-11edd8016ac2",
      "members": [
        "68d7b0c8-243a-418d-b915-b2bed9b72c41"
      ]
    },
    {
      "cluster_id": "35ff40d7-dc34-499f-b4dd-e76f13e34e0c",
      "members": [
        "43d0da75-6cdb-4b26-9b82-eb000d5742c4"
      ]
    },
    {
      "cluster_id": "074437b7-382b-4a9d-91da-57d4542a546a",
      "members": [
        "7f03d95e-812e-49fc-9c20-0456009ed9e6"
      ]
    },
    {
      "cluster_id": "814e8e7c-9951-4225-be99-2e978ab5ec4d",
      "members": [
        "2de3db1c-8206-4c97-ae05-14fa38749525",
        "df1f4076-07b7-4f91-a688-776170514a2c",
        "6b276ef2-2523-4c59-9fa1-fd01456deefd"
      ]
    },
    {
      "cluster_id": "95bc2531-eabc-48ae-aefe-417173f45673",
      "members": [
        "2fa1a6c5-df78-45bf-b911-a34b2cf8635f",
        "8d56a805-acf8-4a80-b4f7-742343c9065c"
      ]
    },
    {
      "cluster_id": "d58866d1-afac-43ae-b1bb-fbdbeb0b8d62",
      "members": [
        "6ac1abfd-0548-4b06-add3-4ebb0962bfaa"
      ]
    },
    {
      "cluster_id": "54852fe8-25a9-4bc3-8ed0-4f252eac7d21",
      "members": [
        "e5d0fd9a-f56b-4b5e-bff1-04b44d086cf5"
      ]
    },
    {
      "cluster_id": "a08d6d8c-3534-4503-908a-ad9b08709410",
      "members": [
        "a3564e9b-3a80-4277-b28a-f7cc608ae50e"
      ]
    },
    {
      "cluster_id": "3e95ef61-306a-4cf0-a217-5b910e8ffc01",
      "members": [
        "868f36b1-faaa-45fc-99da-436b401f1b8f"
      ]
    },
    {
      "cluster_id": "b5cfe764-3a89-4e77-9f9e-c720d7d22394",
      "members": [
        "8ef9e457-666c-4977-8ad8-a6188f7bb8b2",
        "aaf71c84-1b11-495a-9c4e-cee86667e148"
      ]
    },
    {
      "cluster_id": "4d4e63b8-def5-48d6-a4f3-534d39e0e25e",
      "members": [
        "004c8568-374a-4517-8f8b-8bad54f4d762"
      ]
    },
    {
      "cluster_id": "53ad86f3-97ef-4717-9f61-4666c34f7833",
      "members": [
        "b29529c6-004d-4947-93f4-3254e37e260e",
        "63801b9b-1d6b-45df-937d-05ef8f6c6465"
      ]
    },
    {
      "cluster_id": "b5e4c53f-7f15-4f0d-b014-ab5bdfef9779",
      "members": [
        "b40ce322-87a1-4be7-8027-452a7d47efc3",
        "a1629251-5ff9-438d-82c3-c953fa276a4d"
      ]
    },
    {
      "cluster_id": "99b6af80-6889-4032-9dda-54d5dbe1fafb",
      "members": [
        "7ea2566d-1b56-4eb1-b668-d5efb760cb02"
      ]
    },
    {
      "cluster_id": "637433ac-6811-450b-94c9-8c40811c8f6a",
      "members": [
        "46be5e6f-5e7c-4dac-bf19-ba511307d0b4"
      ]
    },
    {
      "cluster_id": "ef2890c7-c6b6-40d0-96fd-72f800a7cb26",
      "members": [
        "e07167f0-429b-416e-9454-dec0d9045cb6"
      ]
    },
    {
      "cluster_id": "333dab32-099d-476d-86ef-f676846f2e4b",
      "members": [
        "f4250b4f-185e-4240-84f1-06dd55ea2513"
      ]
    },
    {
      "cluster_id": "471ac06a-ad1e-40a8-b238-859f31d2504b",
      "members": [
        "dcf6c7fd-72a2-4fc0-b404-e0a1efed57c6"
      ]
    },
    {
      "cluster_id": "3465d409-db96-4545-a6fb-c388765f1b4a",
      "members": [
        "e9e73205-eea9-4079-8e2f-017d20cd34e9"
      ]
    },
    {
      "cluster_id": "14c3f0e3-2371-447c-8445-1ac6c299f633",
      "members": [
        "27a7e73d-295d-494b-aa25-d05f32b9905f",
        "8df7b50c-2cba-47fb-9c3e-c89f142bf026"
      ]
    },
    {
      "cluster_id": "8b5f2de0-fd72-48f3-8849-4ef20748a393",
      "members": [
        "52d05306-7b3e-4b56-905c-52d9adf81a77"
      ]
    },
    {
      "cluster_id": "b571b4ac-1009-4c8e-8fd0-977fefce53c9",
      "members": [
        "e980e670-fd3b-4604-bf30-f315710cdea3"
      ]
    },
    {
      "cluster_id": "099689d1-bfaf-4b3b-b795-0a924815ef02",
      "members": [
        "ca8cd41a-bcd6-41ba-bbe2-0940279c571c",
        "57078c34-49ef-40e1-97cc-1bd6a7f3aba2"
      ]
    },
    {
      "cluster_id": "78ea610b-38fc-4528-87fe-af950e4ad514",
      "members": [
        "037b5584-31b3-45ac-9f69-070ac5eb8829",
        "09aaf704-8467-4143-952d-96f41284f4f8",
        "8917d070-5d0c-4de1-956f-8133fb84f3b3"
      ]
    },
    {
      "cluster_id": "a00b5c34-3d1b-444a-9f62-57418373c9c3",
      "members": [
        "f8013c0f-cc01-4be6-93f6-384857421899",
        "a29fe756-de69-48fe-a88b-c881add7f1bd"
      ]
    },
    {
      "cluster_id": "58ab14ae-8edd-49c2-93f1-5410b8248aac",
      "members": [
        "fd40e2f8-9a3a-4d18-a733-cd715f9ce076",
        "f7a81fa7-f979-436f-8060-bb1009d450bc"
      ]
    },
    {
      "cluster_id": "2490cd6a-465d-4de9-bada-79c6b3ffed26",
      "members": [
        "704783bc-11f4-4d6c-b839-d9f3b7f1324b"
      ]
    },
    {
      "cluster_id": "07b1d44b-f7cd-4319-883a-80ea44f07316",
      "members": [
        "2d271a5c-928a-4930-96b4-129efebe1df5"
      ]
    },
    {
      "cluster_id": "2227c158-fdf5-47dd-921b-7c6ca1823ad0",
      "members": [
        "07510bdb-9489-442b-a192-8176369edcf6"
      ]
    },
    {
      "cluster_id": "94c94ebf-a12a-4db5-9455-477a88d18b1f",
      "members": [
        "aa1cb9f2-79f1-41a5-9ed1-df995778d99a"
      ]
    },
    {
      "cluster_id": "90dd5b61-524c-4738-8cae-d8d3f36a7bf8",
      "members": [
        "bfb94fe4-4411-47f5-af22-944d54d6257d"
      ]
    },
    {
      "cluster_id": "8c98812a-8a38-46cf-a002-b105988964fa",
      "members": [
        "258719ec-bc17-4161-8038-22aaea9045ea"
      ]
    },
    {
      "cluster_id": "80b2ece5-7d1f-4503-86fb-dde80c97bee5",
      "members": [
        "8a30da06-0220-4593-bd3d-77e921c8e4ac"
      ]
    },
    {
      "cluster_id": "c49cd086-ee6f-4cec-890b-ecf827080344",
      "members": [
        "3ffd80c2-fde7-4f2c-8c31-8e29baaa1b45"
      ]
    },
    {
      "cluster_id": "9dee9825-7f6c-4617-8b1e-b3ceb5b3a39f",
      "members": [
        "6f22db37-dbab-4c70-b00a-de4ab5e1a28f"
      ]
    },
    {
      "cluster_id": "6c5b6495-5a45-4608-8917-e96bd2fcb820",
      "members": [
        "7bf352ce-20a1-4705-b44e-d284a64f2dc9"
      ]
    },
    {
      "cluster_id": "c2a59237-65bd-47ee-930d-7682f70bbe46",
      "members": [
        "f158a18e-8e7f-4fdf-88ac-f48f70fc099b"
      ]
    },
    {
      "cluster_id": "0133f004-4682-4cbf-aa32-305a065f5e30",
      "members": [
        "78d2be66-b720-4f0f-8d4c-478dd5acbe21"
      ]
    },
    {
      "cluster_id": "b9961616-57c0-4002-a439-bbd0acf2194c",
      "members": [
        "7310ed04-5712-4000-8ce7-8ed3d2ae62d4"
      ]
    },
    {
      "cluster_id": "1a4aae73-4152-4a0a-830e-ec3794a86bd7",
      "members": [
        "55f8ab79-cb3a-4bfe-b0cd-7f7e568f60c0"
      ]
    },
    {
      "cluster_id": "7201e91b-d78c-4827-b8ba-6360e45574c7",
      "members": [
        "348f73f2-5d04-4cf7-bdee-7a8f5ec3e67c"
      ]
    },
    {
      "cluster_id": "bc76f539-3671-4e32-b4e8-b1326e7f32a8",
      "members": [
        "6b437726-a25f-48f1-a4df-2d46e7e4af00"
      ]
    },
    {
      "cluster_id": "f5c0430d-6c19-4e4b-815d-7de708ba52a8",
      "members": [
        "dfef6cce-2e7b-4cb8-a568-6acc38367d08",
        "b34894b9-0db5-4b79-9f77-90483625254e",
        "15443277-29b8-44dd-bc8b-e751eb349fa8"
      ]
    },
    {
      "cluster_id": "1d0959a8-981b-4a23-90dc-2a9d7c7c079f",
      "members": [
        "4c3bfbf2-3a8e-4c7d-8bc5-348fdbbc48b2"
      ]
    },
    {
      "cluster_id": "3cda3833-2d58-4e6e-a35b-5bec2cd74e4d",
      "members": [
        "58f8bf85-a0a3-46a2-bea7-181eb9477611",
        "5d97b84f-d0d3-4586-bb21-05b4cf519290"
      ]
    },
    {
      "cluster_id": "9be7eccf-749e-4a5e-97bb-089da9891c3f",
      "members": [
        "dac09be7-9dcb-44dd-a432-f9b40d387ea9"
      ]
    },
    {
      "cluster_id": "19d8a06a-0c0d-4355-9204-b73d0ebe4d12",
      "members": [
        "402de313-dc2a-4179-9d33-756d322fa7c6"
      ]
    },
    {
      "cluster_id": "e1645179-8a65-4728-91ce-ad15f6e0cef3",
      "members": [
        "367702f2-91ad-4a93-9dd2-0f8bb2859c71"
      ]
    },
    {
      "cluster_id": "0f6d8e28-a525-480c-9282-bbbd6890cc48",
      "members": [
        "335a890c-6ec5-456c-a805-47ac70e391fe"
      ]
    },
    {
      "cluster_id": "5f5241f6-dc62-4f74-8e2a-d9e564410ef8",
      "members": [
        "9e8d5433-b960-46a3-b4a3-41a029fb9d00"
      ]
    },
    {
      "cluster_id": "c3ffc4ba-bd9b-4ff0-ac0e-e1b2b01b15fd",
      "members": [
        "2e574775-b70d-43d2-acb7-8d97dc6fe61d"
      ]
    },
    {
      "cluster_id": "9d18ccac-ba43-4c43-bed8-0d742eb6d22d",
      "members": [
        "64b63c87-6a47-40dd-90df-bb9b12f57bc6"
      ]
    },
    {
      "cluster_id": "576d86b7-1d28-4f66-8319-eb34a892467d",
      "members": [
        "5834073d-b787-43e0-aef8-e4171853a791",
        "acc49a20-eaf2-404b-9bec-b4368de91130"
      ]
    },
    {
      "cluster_id": "b6692507-59c3-458b-bc20-9fc0bbf648db",
      "members": [
        "75b664c9-cdd2-4d8c-9dc9-5ba708cd4eb0"
      ]
    },
    {
      "cluster_id": "29fc6217-0253-4ea5-924b-34a8cdd037cd",
      "members": [
        "dc1adbc4-c3a2-4026-a250-03f9a8f6ebef"
      ]
    },
    {
      "cluster_id": "b785d99b-0340-4f57-a54b-f08a5b415aa2",
      "members": [
        "a512f7db-5a67-4c26-8411-0d908211a5f8"
      ]
    },
    {
      "cluster_id": "eb6bb91c-6bc8-4c0a-9783-baf41ad32ae6",
      "members": [
        "8987703c-09a0-4a89-b7de-26177897cfb5"
      ]
    },
    {
      "cluster_id": "867076a2-38a3-4bba-9e8e-00167fbd33c9",
      "members": [
        "b2da0a15-df9d-4652-8e36-56d2c0f29af2"
      ]
    },
    {
      "cluster_id": "62ebe72f-55b5-4dca-b8c6-cb9ed5b82c24",
      "members": [
        "73442f47-7f8e-472e-9206-3f32b19a5161"
      ]
    },
    {
      "cluster_id": "9f0b5b9d-5ada-4603-b28a-01eb2e4517b2",
      "members": [
        "abac13d2-7169-4c1d-b450-72fae04f1142"
      ]
    },
    {
      "cluster_id": "ce398b7c-c3fa-42df-8862-5c57ac63cf98",
      "members": [
        "64edff3f-a376-4056-b11b-027d0773ca96"
      ]
    },
    {
      "cluster_id": "09a3b73e-815c-4ea0-9da8-b1110ca8cf96",
      "members": [
        "a6b153e0-68cf-4345-b16a-5d5466f30f29"
      ]
    },
    {
      "cluster_id": "8dd2ae56-dcf0-4439-b3f0-3a7a939056df",
      "members": [
        "bb26bcd8-0a0f-4bba-8469-7880dae97789"
      ]
    },
    {
      "cluster_id": "0cb30e02-d84d-4557-96e4-2da52513f036",
      "members": [
        "373f6412-6baf-43eb-8677-2ed1f31c6eaa",
        "7bd2872a-0b55-457d-a26e-3d1c22d3c6de"
      ]
    },
    {
      "cluster_id": "a22b19c4-dd9d-4007-a380-a5d0659b9821",
      "members": [
        "4a142742-30f0-48ff-9d5c-cad9814da2e8"
      ]
    },
    {
      "cluster_id": "4da3a5b6-2b3a-469e-82e1-4fa291688db8",
      "members": [
        "c1357c61-adf8-4bbc-8ee2-91964a807394"
      ]
    },
    {
      "cluster_id": "921c5a51-cef0-491b-8b5f-a5f05c5b785f",
      "members": [
        "37f4799e-ac16-4d40-9bf7-7b2e33db04b4"
      ]
    },
    {
      "cluster_id": "e47ab492-3177-49bc-9493-e444a1518298",
      "members": [
        "7c0622b6-4c06-434c-a1c1-e220f0a5abd0",
        "6ee76e7a-4bd0-404b-abab-03d01a57ea06"
      ]
    },
    {
      "cluster_id": "558372cf-c982-49c8-8de6-cd0d8a987ae8",
      "members": [
        "9b6368f5-3479-4185-8bdd-eb93154ad53a"
      ]
    },
    {
      "cluster_id": "f859d7dc-7168-48cd-becb-1199652aaa89",
      "members": [
        "f319eb18-5151-41ec-ab61-08335d766535"
      ]
    },
    {
      "cluster_id": "4dc5e4a5-2670-454e-b212-260136221524",
      "members": [
        "e8e3ddc6-6a6c-4652-a4e0-4667177529de"
      ]
    },
    {
      "cluster_id": "d5f197ec-3802-460d-9ad7-c43d150d3ad0",
      "members": [
        "bdbccbbe-eee1-446c-b0a8-4d84bc8334a1"
      ]
    },
    {
      "cluster_id": "9fa0ae4f-fe27-4925-ae63-04bdfeb3953f",
      "members": [
        "7b2fc77e-9928-4b79-a078-6220f6106ae5"
      ]
    },
    {
      "cluster_id": "a3067b08-040a-4461-a857-7a4d88845295",
      "members": [
        "fc2221fd-331e-4e4d-9500-ee288d246c3c"
      ]
    },
    {
      "cluster_id": "1f7a8e67-3a2d-482a-a62b-2e318f3fda52",
      "members": [
        "22e284db-951a-4166-9096-35c264340b2e"
      ]
    },
    {
      "cluster_id": "47924c3b-71e9-4d32-b64c-af3ed4408382",
      "members": [
        "a44177d6-2464-4605-b4b7-dbeef94f5949"
      ]
    },
    {
      "cluster_id": "2baba0c0-38f3-43b9-8755-4293f919fe7d",
      "members": [
        "636d70cc-b434-4ae6-9e92-4d776254bd53"
      ]
    },
    {
      "cluster_id": "4fb3ad72-cc0b-4dd7-a137-fc01ed07a902",
      "members": [
        "b69b00bd-1c0f-4c05-bc07-81f2e3e39b4e"
      ]
    },
    {
      "cluster_id": "8a8f242c-8eef-4ca8-a157-47a2a04d8d4e",
      "members": [
        "b19f7cda-33d5-40f6-b0d5-eb8e9af54659"
      ]
    },
    {
      "cluster_id": "777f1392-cb45-4f46-9166-db9e19c26beb",
      "members": [
        "f9605271-979c-44cc-ad70-a9223ad34a55"
      ]
    },
    {
      "cluster_id": "3a6b381c-f068-44b8-863b-e7023960bcbf",
      "members": [
        "16f99f21-2a2b-411d-b650-b44faaad6bb2"
      ]
    },
    {
      "cluster_id": "b7685445-3aa6-4ff3-a94e-b37c9df21cb5",
      "members": [
        "4c8e9da5-5bdc-4932-8d55-41984416cd05"
      ]
    },
    {
      "cluster_id": "3662eaef-57cc-467f-a555-ca15b13b9be9",
      "members": [
        "4470e99a-dacf-40c0-92d2-cf36af84c32e"
      ]
    },
    {
      "cluster_id": "87e5a1c0-9b91-4772-b701-2e6333826ce4",
      "members": [
        "c7a5bcbc-2006-4764-8207-620d09886a38"
      ]
    },
    {
      "cluster_id": "87f027a4-571d-4212-8e96-6f46fe317fc0",
      "members": [
        "69fda331-49f4-41e8-91fd-54e672b4af61"
      ]
    },
    {
      "cluster_id": "5fafb978-3006-4010-ae1d-242c5cb188f3",
      "members": [
        "c48d12ac-4849-4c1d-a010-8c0445099769"
      ]
    },
    {
      "cluster_id": "6030a19b-208f-4624-83fa-f8e8a264fea6",
      "members": [
        "218979e2-6346-46d5-84e7-bcf3652d7a9b",
        "069673ab-fcaf-463d-a280-db1b9f50dc4d"
      ]
    },
    {
      "cluster_id": "c4ef8aa7-0a73-4837-bdda-5894dfbdb7a0",
      "members": [
        "78cfbbbe-314b-4a70-9cb8-db5cf39b5d72"
      ]
    },
    {
      "cluster_id": "ea3abea8-dde8-497c-9c04-bcf3a9757f8f",
      "members": [
        "af2ce867-2914-4513-8c2f-62a70058b763"
      ]
    },
    {
      "cluster_id": "7992895f-6a68-45c7-a087-4ea61dcfa40e",
      "members": [
        "c92d754a-4f19-4748-bb42-dd99695f6ae4"
      ]
    },
    {
      "cluster_id": "6feeb810-f8d8-4337-b308-bbd0aa0c4221",
      "members": [
        "ca3c207a-2dd4-4d6e-b63a-2a6eb4f34133"
      ]
    },
    {
      "cluster_id": "13e45fa8-d3c0-4dcf-9891-87d1abf0b71a",
      "members": [
        "56582cd1-f8c4-4a94-a701-1c06b71c798e"
      ]
    },
    {
      "cluster_id": "51102dd8-1276-45b4-9dc0-5dab1b318e57",
      "members": [
        "fcfe8808-9e01-45de-93f6-29d62e4ecc7e"
      ]
    },
    {
      "cluster_id": "6c7741a7-bba5-415f-86fa-1077ed815fec",
      "members": [
        "999182db-2625-4ed4-bee4-2651ff7ab1f4"
      ]
    },
    {
      "cluster_id": "177da242-e804-4b06-8955-3e43352e0145",
      "members": [
        "d5c07d75-9a2b-4f52-9375-4e117e5c9de0"
      ]
    },
    {
      "cluster_id": "2c4ce8c0-6662-4508-bebd-0134d7b84392",
      "members": [
        "762e6407-10e1-4560-b0ca-3d37bb092d6c"
      ]
    },
    {
      "cluster_id": "e8fdd463-9207-4e60-a84f-71fa88bf5a1b",
      "members": [
        "39a925b2-b74c-4874-bc92-c3cbfdc46c80"
      ]
    },
    {
      "cluster_id": "c6ae3e3e-9490-4f23-8d47-5a4b1fb01352",
      "members": [
        "fb3a1bf0-a119-4364-a911-6554bb3613f7"
      ]
    },
    {
      "cluster_id": "d5f940cc-5da4-46b9-a86f-4006d64c39d0",
      "members": [
        "bd6239fd-09e8-4ff6-8c9a-79bb5394f59b"
      ]
    },
    {
      "cluster_id": "365e9714-a651-4229-98f7-325862506f0b",
      "members": [
        "b9666832-ade3-4dd6-98de-b270acc661b6"
      ]
    },
    {
      "cluster_id": "7e010522-998f-4102-8a4d-417605255131",
      "members": [
        "60f86427-d4ae-47e8-bb90-2baa9a16eaa3"
      ]
    },
    {
      "cluster_id": "d63dd03a-5d4f-4d47-9f48-b37f794db992",
      "members": [
        "29d17b68-96a8-410d-acb8-8f586fd813c3"
      ]
    },
    {
      "cluster_id": "360f8a39-1f36-4965-9744-1b8bf78217a1",
      "members": [
        "5d6392b7-7672-4984-90c2-2bbc04d3e340"
      ]
    },
    {
      "cluster_id": "2528bd46-af3f-4f9d-8f91-2dbf49b3388e",
      "members": [
        "42e7d87f-ac81-49a4-b5ef-227fee56c62f",
        "a88ebf1b-3427-4f5e-9a06-516d1fdba7e7",
        "4feb4de2-57f8-4d45-98a2-90445dcf8903"
      ]
    },
    {
      "cluster_id": "41e4adfd-a702-492f-a430-46ac304993d5",
      "members": [
        "3fa92da9-bf8a-476c-b420-e17386dc2c3d"
      ]
    },
    {
      "cluster_id": "186c5c04-d5bb-4764-8a32-550ebb9ed5fd",
      "members": [
        "d1ab25fa-1cfd-41e4-bd76-cdd74ca6bb2c"
      ]
    },
    {
      "cluster_id": "67498cc0-4b03-4712-95a1-69a6b340282a",
      "members": [
        "bdb876f5-73e9-4c5d-b8b8-24a290e4ffe4"
      ]
    },
    {
      "cluster_id": "a4bee492-f45a-4aa3-94d5-709bdbcd2d39",
      "members": [
        "effb38df-4036-4437-9033-bcf6992ca029"
      ]
    },
    {
      "cluster_id": "9fea69be-9aad-4b8b-aca6-7960741c46ec",
      "members": [
        "cf2b8c88-247b-4d9c-8c52-d1ab5bfcda93",
        "eff22e41-0c9b-40c6-af46-0f65af2be234"
      ]
    },
    {
      "cluster_id": "ab91862c-85f4-4041-ad6f-31e79b4bc25f",
      "members": [
        "472f2da8-0427-4361-9b25-4d93d7c41104"
      ]
    },
    {
      "cluster_id": "454d2297-ce2d-4682-8c48-dff1e1ee7f18",
      "members": [
        "7213d7a8-55b7-41c7-8d70-7dc155ca102f"
      ]
    },
    {
      "cluster_id": "591739f1-b375-4e55-9c3b-ffe5cb8186ce",
      "members": [
        "c5f9c08b-5324-42f7-a3c5-bb9deb54375f"
      ]
    },
    {
      "cluster_id": "8a1f2e01-5e97-4b63-a054-d879e5cc37f3",
      "members": [
        "68bc38f6-99cb-4a95-9d9f-fecd624d95d2"
      ]
    },
    {
      "cluster_id": "8d987874-4ebf-4fd4-b0c2-5cd72bf55264",
      "members": [
        "35ea6519-3949-4886-af7c-a16415792eca"
      ]
    },
    {
      "cluster_id": "6b13e7ad-350b-4ea9-8771-684dda7f984a",
      "members": [
        "c1724b7f-f234-404c-a369-09e839958054"
      ]
    },
    {
      "cluster_id": "9dcce4d2-ce6e-4b1e-a8f5-c853370fae54",
      "members": [
        "621e30a8-e3a6-4a1e-8148-625c788f17ba"
      ]
    },
    {
      "cluster_id": "bd47afb3-5229-4410-873e-9a50752f0292",
      "members": [
        "7c23a944-c1c8-4e60-ad55-a315dd953f0a"
      ]
    },
    {
      "cluster_id": "7f4c9ab9-c44d-442b-a98c-55507ea1e6cb",
      "members": [
        "508d98f3-daa9-48ab-94e6-c84842abd664"
      ]
    },
    {
      "cluster_id": "859ebc03-00a8-4a19-9bda-cf26a29549d4",
      "members": [
        "db1a7681-204e-4a6e-bee8-7555e7d1e7bb"
      ]
    },
    {
      "cluster_id": "0ae555d0-f055-4458-a22e-cafea01bd69c",
      "members": [
        "5702700a-9e3a-4d47-bd2f-f6267d3bfb8a"
      ]
    },
    {
      "cluster_id": "77ada2fd-a5b1-4d46-9fd3-0fa7022914dd",
      "members": [
        "e11cd318-1c62-482d-956c-1e3fef6d9597"
      ]
    },
    {
      "cluster_id": "f4d98260-09b2-436e-8c76-b8fdadb8663b",
      "members": [
        "0a63eac9-8b10-4812-845e-27384d4011ce",
        "2988ed3f-8d55-42a9-aeb8-1e289dc22a22"
      ]
    },
    {
      "cluster_id": "7a1d05c9-2872-4724-bfbb-1dbc30578c14",
      "members": [
        "051ea1e9-5523-46c7-9da6-88c538586f18"
      ]
    },
    {
      "cluster_id": "42aaef22-3993-4ed5-8477-0e78fe2789f9",
      "members": [
        "18627898-a921-455c-93d6-8ce216b6c674"
      ]
    },
    {
      "cluster_id": "de42709f-cb35-4f62-b569-11c75f1fbe5e",
      "members": [
        "71b6d51c-90a4-4139-852f-aee305ae0835"
      ]
    },
    {
      "cluster_id": "cefafa9f-3780-4e29-9888-658635c4bf8a",
      "members": [
        "6b5b3209-851c-45f6-85da-5cd1c52ea48c"
      ]
    },
    {
      "cluster_id": "a4f84d58-e9f3-4a41-a8f9-b81736f1cea9",
      "members": [
        "a97c39db-1aed-4a0c-904d-6b9a2bdc8ce9",
        "a4353cb2-f322-4a31-b4d3-6ac1693c1d88"
      ]
    },
    {
      "cluster_id": "64ddad58-c0e5-4850-be27-0ed962a47441",
      "members": [
        "19e3f2e7-1f5f-4057-8c33-eaa88ecd8b11"
      ]
    },
    {
      "cluster_id": "77081589-555b-43cf-8723-b50b060cc231",
      "members": [
        "8f8a1fe0-054c-4805-91d2-1f315564e9e2"
      ]
    },
    {
      "cluster_id": "e4f0ca80-4588-4554-9e20-d646dd11d817",
      "members": [
        "c04e7acb-a195-4fa0-bd8a-2ac9d90dc9f1"
      ]
    },
    {
      "cluster_id": "baef31d1-0183-4a82-91e5-3ce55345b1d6",
      "members": [
        "8f08754d-53ef-4d85-8001-af0a15e08cc7"
      ]
    },
    {
      "cluster_id": "8f118d54-36b6-4cf4-a60c-7acf617e5bf4",
      "members": [
        "fda6b7dd-0801-43b6-b4eb-0387977a987d"
      ]
    },
    {
      "cluster_id": "63e1fb6c-f4d5-44b0-95bb-4b6a7af8b4d4",
      "members": [
        "40536ea9-1e09-4388-9c4e-a20eb9b71204"
      ]
    },
    {
      "cluster_id": "95a8e81f-4308-4c82-a9de-2d2f3b200b4c",
      "members": [
        "5d664621-21f3-4440-8668-201728d0a3f0"
      ]
    },
    {
      "cluster_id": "9583b42b-1878-4c5b-8b34-5a41d72c1a17",
      "members": [
        "c2e16897-3bc7-44c5-ae38-8d5b76119a14"
      ]
    },
    {
      "cluster_id": "04a95cfc-f399-41ee-9730-e984f76e78be",
      "members": [
        "6dd11535-10d3-47ab-b07b-308c6c7ab99c"
      ]
    },
    {
      "cluster_id": "713b16e4-cb6f-4c7f-8eac-cbbfee258e85",
      "members": [
        "e124c13f-6a31-4552-b776-9c8cd3da2e20"
      ]
    },
    {
      "cluster_id": "3803cd19-3379-4dcf-8227-17e8e94b50a8",
      "members": [
        "b0d60f47-6669-4391-b656-a5f96dccbc74"
      ]
    },
    {
      "cluster_id": "1faa4831-480b-4038-9fea-49267683c570",
      "members": [
        "f8254991-a263-4f0f-b469-53086ef94686"
      ]
    },
    {
      "cluster_id": "b96e892e-f2b5-4f40-833b-36af1949d85f",
      "members": [
        "4964ca25-06aa-4cf2-876f-69e4a7690652"
      ]
    },
    {
      "cluster_id": "a5511c2f-b2db-4795-9bb8-2441a998fd2e",
      "members": [
        "2e07a7b1-49cf-4d84-9b94-641aea283ddf"
      ]
    },
    {
      "cluster_id": "6c435a8a-93c9-4345-913c-85766d15d80c",
      "members": [
        "865462a9-8a34-448c-bb8c-328656ba28e6"
      ]
    },
    {
      "cluster_id": "d550236c-347c-46ce-84eb-f723bc55deec",
      "members": [
        "fb123684-7415-483d-a978-fec91ccba8b5"
      ]
    },
    {
      "cluster_id": "db605ad9-a4d6-40a9-abcb-d200ca16a403",
      "members": [
        "b3f91f51-786d-436f-9d18-3ff001743926"
      ]
    },
    {
      "cluster_id": "a66bb7d0-dc6f-4116-a7d1-4f4c8d7be3a8",
      "members": [
        "ed690654-d87d-4362-9e8d-10d320020a00"
      ]
    },
    {
      "cluster_id": "d8e63a6c-9b16-4691-ad10-679a83e7a296",
      "members": [
        "d6d7c667-9bc6-4290-b657-06e4474549ec"
      ]
    },
    {
      "cluster_id": "71c5fa4a-0b53-4202-9b3e-1c8038451d63",
      "members": [
        "a5f1b802-c83e-4b26-b021-63db9730cf9a",
        "0a000d18-ecff-446c-a924-6d82d3d98023"
      ]
    },
    {
      "cluster_id": "b60886b0-36f1-4d60-bd61-b45768791dc2",
      "members": [
        "589b69b1-8cf4-47d6-9557-8ed7a4dbe822"
      ]
    },
    {
      "cluster_id": "6d2cf6ad-226e-438c-8ae9-0f0b432c0bab",
      "members": [
        "947eb814-56a8-407d-abce-805377cabbd3"
      ]
    },
    {
      "cluster_id": "f9e6216a-ee1c-443b-8198-daf20f932faa",
      "members": [
        "3035d86b-acc0-4403-bffd-6700fef7bb0c"
      ]
    },
    {
      "cluster_id": "0d76345c-1ef8-406a-a4b5-284717ab866d",
      "members": [
        "c16348f4-f677-4500-9bce-e94363964920"
      ]
    },
    {
      "cluster_id": "83e19f20-191c-42c6-bdd7-ee466f6ee0d2",
      "members": [
        "eb81506a-1e5d-49a4-b1e0-78fa8d5785ab"
      ]
    },
    {
      "cluster_id": "1b5a113e-43ba-4a33-a76b-09db6a2b33ef",
      "members": [
        "d42a2ca4-b7f8-4e98-a8a3-231bc4ccccff",
        "9160fce3-639a-404f-bc2d-247e2f635b91"
      ]
    },
    {
      "cluster_id": "1a61f6e2-0fe8-4393-9f81-f3403bde43ac",
      "members": [
        "876cafe0-7630-405c-b6e1-94aad8874fe2"
      ]
    },
    {
      "cluster_id": "e6007b6f-2ba5-4830-8564-f98f1943ec9d",
      "members": [
        "5f1983cf-65eb-463a-8550-1f6af19a3988"
      ]
    },
    {
      "cluster_id": "25038dda-b8ca-4dd5-9e0c-c382a4d18a6e",
      "members": [
        "d2e60abb-a3b6-4cdb-8512-655a66edd080"
      ]
    },
    {
      "cluster_id": "3f1ec78d-49c2-44d1-bdc2-97cf6217c638",
      "members": [
        "42af163d-b12c-48f8-8f72-f5bf6759e608",
        "8a40ef2a-7e19-4ee7-8d2c-14d80b5c22d6",
        "13727699-8b9a-4d25-b74b-7990b71f76c4",
        "eacf0c25-ed4c-482d-897c-68a487f7e75d"
      ]
    },
    {
      "cluster_id": "d7410313-2ce6-46bc-b39a-d7543341b90b",
      "members": [
        "36a12859-4750-4aaa-9c12-392e90d727eb"
      ]
    },
    {
      "cluster_id": "0ecafb9a-2141-4b23-a024-348c4e1719da",
      "members": [
        "1fb3f6d4-c8cd-4d56-9cec-0948e64aaeda"
      ]
    },
    {
      "cluster_id": "03a9ef94-2f49-4a92-bace-dca90bc3fda0",
      "members": [
        "e2ac372d-a166-4881-9474-9c11807b1178"
      ]
    },
    {
      "cluster_id": "8d34ac69-abf2-4d47-a080-a43806db5b67",
      "members": [
        "a6f8b9a8-185b-4f04-bcf2-404080257ea8"
      ]
    },
    {
      "cluster_id": "3e954c39-38a1-4449-bb6c-9e8070f71e04",
      "members": [
        "37fce88b-2358-4766-9435-a0717c3405c5",
        "e22e01a4-aa93-4c65-bcd7-d529d935d18b"
      ]
    },
    {
      "cluster_id": "9f1d605b-541e-498f-8d37-d5763cc9a791",
      "members": [
        "8426f0f1-04a1-4750-92e4-99b90403eae0"
      ]
    },
    {
      "cluster_id": "92bbe30f-197d-426e-978f-44717acaacac",
      "members": [
        "c0b7a5eb-b0bf-47b5-a328-58a0f3ff8bd0"
      ]
    },
    {
      "cluster_id": "cf544ca5-66d4-4d37-bc28-71ce54266ee4",
      "members": [
        "2fe478ae-a877-44a3-8f18-668db21a5348"
      ]
    },
    {
      "cluster_id": "c9b1317b-d9b8-4f19-b568-8b833e155fb5",
      "members": [
        "f61d6cc9-2903-4136-884f-7b3e17d13179"
      ]
    },
    {
      "cluster_id": "507a2a11-43b9-4279-b484-7be9d201408d",
      "members": [
        "a2ecdc6a-41ca-4b32-92be-1de1a2628ea6"
      ]
    },
    {
      "cluster_id": "d53cdbb5-0ed7-4595-a5cc-31ff93c45b69",
      "members": [
        "933adce9-9b87-4807-b8f6-6cbb181e88fc"
      ]
    },
    {
      "cluster_id": "954829b5-b0de-40ec-a999-143a5f855d8b",
      "members": [
        "06831552-14e5-4569-9ca9-c47d8f2f1201"
      ]
    },
    {
      "cluster_id": "d87790ba-a7e4-42b2-87ee-50115287f374",
      "members": [
        "06d044b0-5302-484d-85db-51994723b229"
      ]
    },
    {
      "cluster_id": "674e3f33-6edf-4940-a9ac-cec9bedff257",
      "members": [
        "5d1a9831-cc92-4115-a2ec-ff7210d9087a"
      ]
    },
    {
      "cluster_id": "efc4ab9a-f965-4202-ac72-ebf2fe08724d",
      "members": [
        "4600efc9-06a8-4dff-8c12-b27c8914405b"
      ]
    },
    {
      "cluster_id": "5c31493c-9070-471a-a409-144d7a3c341a",
      "members": [
        "561d7581-dc0e-40b9-b96b-ac143f095121"
      ]
    },
    {
      "cluster_id": "30cd928f-5775-4679-a8af-3acd8dd1a21e",
      "members": [
        "1150a8df-dadc-4460-8904-03d1f9c58dfb",
        "df7a3803-f91f-4992-af44-ab4dde913c7c"
      ]
    },
    {
      "cluster_id": "3eb68d57-7c14-4dd1-91dd-ff18ff1740e4",
      "members": [
        "f6d886b4-d0a4-4969-bc31-c67b520d2a5c"
      ]
    },
    {
      "cluster_id": "0e23ab63-e410-4477-a70e-2df0f99242c1",
      "members": [
        "dbe8b6ac-605c-4478-be22-c0b7129ee99d"
      ]
    },
    {
      "cluster_id": "8ec3865c-7644-4e06-bb0d-00ab782e6cd7",
      "members": [
        "6b1d58c8-d531-46d1-a3de-d3942338e3a8"
      ]
    },
    {
      "cluster_id": "6a879b2a-d8ee-4202-a129-be28ec711b2b",
      "members": [
        "01aa59fb-ce8d-4b3d-a98a-b57b041b163e"
      ]
    },
    {
      "cluster_id": "34a8290a-940e-4582-8dbf-cb195db85e28",
      "members": [
        "e13d298d-79b0-4aee-909e-3952b920571e",
        "fe4ddb1b-a94f-4e6f-ad4e-e6707844c3ef",
        "fe17246d-1e8c-4742-998a-439fed22ca9a"
      ]
    },
    {
      "cluster_id": "cb5fae82-58a9-4d49-9da8-1886e33d1269",
      "members": [
        "6bf705ce-a12a-4f60-949e-6c0cae0a8d0c"
      ]
    },
    {
      "cluster_id": "24603ad6-f39a-4706-80ce-2840439ad61c",
      "members": [
        "b1f8420d-1434-4ed7-9e9b-2f5b401ea971",
        "5b4e4e0c-8d90-4af7-bb86-d6a21c16772c"
      ]
    },
    {
      "cluster_id": "0a5b6270-0640-4f06-bb62-1bb490df9669",
      "members": [
        "72373a32-4718-429d-865f-959e3973a9d6"
      ]
    },
    {
      "cluster_id": "5a60b1ad-2d21-44bf-9788-e9579de25e42",
      "members": [
        "b11bf74a-611d-494c-8e3f-958935e00c4c"
      ]
    },
    {
      "cluster_id": "f81e3872-fc8b-4fad-ac23-6ccf86d6cffe",
      "members": [
        "b72f4d99-5380-4d0e-915e-78d8f4f84bbd"
      ]
    },
    {
      "cluster_id": "6f277c5a-d392-4a17-b884-6fd70ae638a3",
      "members": [
        "f167b354-bd64-4739-bc03-653bb6852739"
      ]
    },
    {
      "cluster_id": "53fc6234-d563-426d-a3bc-ba15edc6f530",
      "members": [
        "463757ac-1c31-450b-a9d8-1f782bf7eb1f"
      ]
    },
    {
      "cluster_id": "5949d818-e369-4db8-949d-7a462c260498",
      "members": [
        "9f35f38b-3794-4d37-a1c4-bf60d8e4a48b",
        "5f45c6bd-882a-409c-af4d-d2d5713430fc",
        "ff9ba1ec-0a5b-4a94-8022-4f958ba98e46"
      ]
    },
    {
      "cluster_id": "5437d23d-a8b8-4a7b-b296-c42b5945a223",
      "members": [
        "41ac5159-bb0b-47a6-bb2f-f18ba9c57586",
        "87864deb-9b02-400c-9156-594929a9d8fa"
      ]
    },
    {
      "cluster_id": "35d3d7f4-4964-4980-9833-62b5e004737f",
      "members": [
        "9a4d6d1a-bfe6-4637-9368-05a0a90b2fcb"
      ]
    },
    {
      "cluster_id": "d86ceeb7-05d4-46ab-afb5-94228b85b310",
      "members": [
        "c0920958-79a0-44a2-bbc3-7e899fb22b93"
      ]
    },
    {
      "cluster_id": "371e032d-d57e-40c0-84fe-6f5fa1665409",
      "members": [
        "4f1c0efe-9bc3-44aa-a1b9-1a380a3cf4fa",
        "0fffe169-4ede-41cf-b588-2b5433b67d07"
      ]
    },
    {
      "cluster_id": "0be74e36-e76b-4fc7-9f69-d42f28778f07",
      "members": [
        "4a46bc74-222c-4fe2-98d3-e36e76688bb5"
      ]
    },
    {
      "cluster_id": "3e4bfcca-aa45-4a97-8306-e90101b4ccc0",
      "members": [
        "b257e337-06ca-43af-ac54-206bb782b9ce"
      ]
    },
    {
      "cluster_id": "2a47fd74-5995-437d-b0b5-6396ca3119f9",
      "members": [
        "2efd1f8e-6d3f-4e58-a5d7-d2874f20715f"
      ]
    },
    {
      "cluster_id": "887d717e-5da6-4cf6-995c-bcee081cd128",
      "members": [
        "ca9816ae-1d2d-49ea-a74f-44b004b3a8fb",
        "b5802323-7512-44b7-a2c3-95a5d43334ad"
      ]
    },
    {
      "cluster_id": "76ca8734-57fa-4978-bce4-584836cb98e4",
      "members": [
        "50fd46cc-8d8f-4fe7-a98c-155464bb72a9"
      ]
    },
    {
      "cluster_id": "6413f39e-1e69-4b93-9d00-8b04286c8041",
      "members": [
        "d0c00902-401a-4f43-ab0f-ce04bcc0cafe"
      ]
    },
    {
      "cluster_id": "2130a389-a1b6-4f7d-b3bc-7b83efb0ab8e",
      "members": [
        "017d0131-e8e6-4734-97f5-63d75131529d"
      ]
    },
    {
      "cluster_id": "109d7869-80dc-4ec3-9550-208fe3c6f717",
      "members": [
        "3dbcfda4-9a03-4305-9433-8138b360536a"
      ]
    },
    {
      "cluster_id": "10cad03e-00e1-4582-b61d-1c7191589376",
      "members": [
        "abb4ef4b-2dca-49fb-82f9-00b5e7c75dca"
      ]
    },
    {
      "cluster_id": "d5e18b03-3515-471f-a4d6-448fbfbfb257",
      "members": [
        "ed07c339-370d-44ac-99ba-4d39888dab8b"
      ]
    },
    {
      "cluster_id": "94a7144e-4fa6-47f3-9e46-2609b5de45b5",
      "members": [
        "8578fb81-6248-4821-b911-ce350c918471"
      ]
    },
    {
      "cluster_id": "65f7972e-2194-4ad4-97f0-1ccb32281e02",
      "members": [
        "5c12efda-8298-413a-9c12-4b36fb624d7c"
      ]
    },
    {
      "cluster_id": "67cd7c4a-a6b3-4e11-9b6b-362422489e76",
      "members": [
        "54518935-b171-45ea-a2dc-7eeabe29f399",
        "9e9c0237-da1e-4af7-8f48-cecebd8dca83",
        "a3cbf3f9-5255-4738-8bb1-30d03f5ea612"
      ]
    },
    {
      "cluster_id": "615888f6-5d35-4a8c-acd9-9e71127a4cb4",
      "members": [
        "226db66c-43ac-43b7-b276-389ceb6fcbf6",
        "63603e7b-a791-4901-af75-8d07266dac3c",
        "763490bf-d450-4201-b047-b5795f2a279c"
      ]
    },
    {
      "cluster_id": "d9484da0-ca3b-450a-a45c-787783bba3e7",
      "members": [
        "35a8f742-b752-4acc-9240-051519a6aec5",
        "7381c9e5-6728-47f0-b327-03b0b0082787"
      ]
    },
    {
      "cluster_id": "e512735b-aeb8-432c-9b72-89718eda18ba",
      "members": [
        "9d6ae165-bc8c-4b5c-b106-e9f72d811855"
      ]
    },
    {
      "cluster_id": "939d6808-ee32-41c3-8d70-73aed1d043da",
      "members": [
        "4816eefb-d760-4c17-81ff-d99b1489f626",
        "ac7eb1a9-e2b2-4f4b-b565-0da0ed4aee2a"
      ]
    },
    {
      "cluster_id": "b5f5096f-4606-455f-8c76-949d5ee72c79",
      "members": [
        "e0dcc4e2-a5cd-490b-a35f-436d888941b5"
      ]
    },
    {
      "cluster_id": "f2f62c1a-8699-46b7-b2e3-61e093884f19",
      "members": [
        "bc87f35a-0a70-4f5b-8422-86653c75f043"
      ]
    },
    {
      "cluster_id": "5014d6b5-2e76-49bd-95af-b599a74c0052",
      "members": [
        "281cb847-000f-4b27-bbda-89dfb3c7d33d"
      ]
    },
    {
      "cluster_id": "fdfba504-e492-4a5f-92f3-533547d34d6b",
      "members": [
        "e7c874de-8ed7-47a0-b3cc-0883535ac190"
      ]
    },
    {
      "cluster_id": "1d4622f2-0a7b-4423-ad78-a011864bf902",
      "members": [
        "c30eddb3-a102-48ad-a621-91d4ebcd55a5",
        "d8dab0c0-3b5b-43b5-bbe4-899087df653b",
        "e6277357-fcd9-48e6-a897-eec71ba573e6"
      ]
    },
    {
      "cluster_id": "2edd3f54-1c62-46b5-9ed0-1f1f90407326",
      "members": [
        "47540f62-880d-4495-a45c-d4a8e901debd"
      ]
    },
    {
      "cluster_id": "63531f99-fdf7-4bec-966d-ab104759e21a",
      "members": [
        "c35488c0-3e55-4d1a-949f-a25c144e3c97"
      ]
    },
    {
      "cluster_id": "cde4816a-67c9-4232-8144-e08a59a84d64",
      "members": [
        "d6e286ba-6e9c-48de-8d81-3c326f52ed71"
      ]
    },
    {
      "cluster_id": "8a9e9225-8d82-4d0e-ab43-4f387b7b1105",
      "members": [
        "97901ddd-6840-4fd4-8e81-248a7d8fc759"
      ]
    },
    {
      "cluster_id": "f0462ff7-d9e3-4bd0-94ad-a4653debf7f6",
      "members": [
        "ab865bf3-a564-4ebc-b231-3711ee9ae979"
      ]
    },
    {
      "cluster_id": "3b9a3219-78e5-4ff5-948f-415edd9701ed",
      "members": [
        "0904d2cb-95a1-4ca9-be6e-fc7300123c0b"
      ]
    },
    {
      "cluster_id": "8845b13a-d2ef-4802-8b18-edb4fbddb6a2",
      "members": [
        "202cb877-3015-439e-a30a-1822d69a1d24"
      ]
    },
    {
      "cluster_id": "fa579361-a6a5-42aa-a37b-78556d46e1d5",
      "members": [
        "1b5acd67-526c-4ff0-860f-e8c440307f91"
      ]
    },
    {
      "cluster_id": "ffc5ae60-fd21-4d4d-9cbb-be7095643849",
      "members": [
        "e8a37bbc-823e-44da-ad0a-c6e9eaff6cb0"
      ]
    },
    {
      "cluster_id": "efbb863d-f52e-42f9-a671-9fa0b8c1b1fb",
      "members": [
        "b839dc0b-24d9-452e-ab64-ab44b118877b"
      ]
    },
    {
      "cluster_id": "a7d594c1-3fc6-43ed-8545-37320216cb3f",
      "members": [
        "1740bd82-9fc3-42b3-a80c-990595a405f7"
      ]
    },
    {
      "cluster_id": "64c35a09-3986-4a44-8a95-5828f2dd463c",
      "members": [
        "4cb31582-398a-46c1-8ddf-2854eaa9691b"
      ]
    },
    {
      "cluster_id": "4c0dfd84-df3b-4660-9041-a635021908ef",
      "members": [
        "5f8a8580-c98a-4db6-8994-d04b4a9d0e58",
        "bf43c495-6334-4bc0-9698-1441bfc6e8a2"
      ]
    },
    {
      "cluster_id": "636b2daa-578a-4643-896b-342714f42b34",
      "members": [
        "4ff43d32-493b-4704-ba11-bb6a385dab0c"
      ]
    },
    {
      "cluster_id": "183ebbd4-8012-4c45-ae37-eee1b7b28721",
      "members": [
        "8aef4794-569c-4d72-a08d-33e5086110df"
      ]
    },
    {
      "cluster_id": "65f08a18-b069-4ad1-8cde-ea7ebd30b6db",
      "members": [
        "1010388f-1e3e-44c3-a510-abf1b78faa77",
        "730ccba6-46f4-4db1-900e-da737dcaf207"
      ]
    },
    {
      "cluster_id": "8b09afca-ca08-48bc-a085-c49c60e79592",
      "members": [
        "90bba792-9843-48c9-9e97-3d7085af8444"
      ]
    },
    {
      "cluster_id": "e6a2f428-c0e3-4756-a96f-639a0339b06c",
      "members": [
        "5c1726d3-4f7c-4a82-ab4d-e8b1a118ed77"
      ]
    },
    {
      "cluster_id": "dbf5db30-86b6-4686-8710-21f1a647cecd",
      "members": [
        "461e82dd-7599-4f59-83c6-3cccc96baf31"
      ]
    },
    {
      "cluster_id": "a8cd7286-4d2f-4b1f-877f-75865a61f584",
      "members": [
        "231a0449-6132-4f06-970f-cbae52ee9afb"
      ]
    },
    {
      "cluster_id": "17d2f659-e46b-4a1d-9fcb-605a5ebf0a54",
      "members": [
        "6b004ef3-1883-418c-9791-f6efd45096f4"
      ]
    },
    {
      "cluster_id": "c59b0f7e-3d57-4bed-a62c-40ef9b2d80c1",
      "members": [
        "a88c634a-c4ca-467d-be35-25181bd97292"
      ]
    },
    {
      "cluster_id": "719750be-a238-45aa-96a8-065dfd797981",
      "members": [
        "7aca12db-b65a-4dd7-9b88-4ba2c84432bf",
        "bc24047c-2c1a-409c-8084-6070c6077d84"
      ]
    },
    {
      "cluster_id": "6964b660-5818-4d1d-be3a-055b02c10ee5",
      "members": [
        "177d5bfc-b7fc-4976-862b-bd50c7e00821"
      ]
    },
    {
      "cluster_id": "5dff1a24-a2b6-4405-a930-eab85cab0d38",
      "members": [
        "8f4ca7c4-7aeb-4e04-ae22-928a97fbbdd2"
      ]
    },
    {
      "cluster_id": "e74616a0-2316-487b-b0b6-5b60062c2550",
      "members": [
        "31ba559f-4607-4a4b-8ff1-fc95c31d06c7"
      ]
    },
    {
      "cluster_id": "fd80dc8e-90e1-45e9-b475-5c0e7ce125c9",
      "members": [
        "dbce0965-3a6a-44fb-bebf-62e9d85bd5f2"
      ]
    },
    {
      "cluster_id": "95138155-e999-481e-8c57-056be5d97867",
      "members": [
        "ac41466e-8fb9-4f3a-b52e-57d3a0dc542f"
      ]
    },
    {
      "cluster_id": "ca3bd404-3299-4dd4-a75b-9491f55542a9",
      "members": [
        "56cd3399-ff94-403e-b870-abe99d4dd294"
      ]
    },
    {
      "cluster_id": "b02337c9-83ca-426b-b987-f46d1d19a244",
      "members": [
        "41f2951c-d0a7-4ac9-9169-ef151bcf971d"
      ]
    },
    {
      "cluster_id": "901320c7-5066-4de7-b012-7a995d178683",
      "members": [
        "64978861-84fa-4ed8-bc86-52aeda4a8e84"
      ]
    },
    {
      "cluster_id": "da38f087-665c-4abb-8af5-ed1c3c09563d",
      "members": [
        "b09279b2-e529-4b35-b8b1-0d90aedad64b",
        "f2b852a5-2358-425c-b489-7e98c562db41"
      ]
    },
    {
      "cluster_id": "a36a54af-ea36-46fb-b97e-4f17594784b7",
      "members": [
        "b5a63837-c8c4-4d64-ab33-45ea0718de8c"
      ]
    },
    {
      "cluster_id": "c2d811fd-2174-46c6-9d2b-9483063022fb",
      "members": [
        "df2043c4-1c1e-4eff-a2c3-58e6130552d2"
      ]
    },
    {
      "cluster_id": "eba751d5-5124-4afa-a2aa-48fe3f60fcc8",
      "members": [
        "31f0493f-3a54-4dc6-aebf-92b2c556d73c"
      ]
    },
    {
      "cluster_id": "a9f14778-a0da-48d5-9d93-8fa7cd7361ec",
      "members": [
        "b8cfb2fa-2f84-4e66-92c7-2b808351286f"
      ]
    },
    {
      "cluster_id": "a7a90cf5-cc81-4b76-b47f-bd8836b204ba",
      "members": [
        "46bd38d3-dcc2-426a-a963-5db999a932ba"
      ]
    },
    {
      "cluster_id": "238786da-a825-4e96-9851-097b2db705e0",
      "members": [
        "327b4e57-b635-4aac-9dca-cb9b6ead7c78"
      ]
    },
    {
      "cluster_id": "864c05a2-76fd-45dd-8aa5-97a6e22bcf53",
      "members": [
        "728b488b-9ce7-49a7-9117-5c9e56b28899"
      ]
    },
    {
      "cluster_id": "f63758ba-bedd-47a6-901a-a2e5321c2bbd",
      "members": [
        "4ec2079c-6a43-421b-b2c1-7902900dd7b8"
      ]
    },
    {
      "cluster_id": "90d77585-5ea5-4b42-8291-9d8389cf1b9a",
      "members": [
        "bb8aaf34-7901-4d6b-8e46-2d0728bcc4c0"
      ]
    },
    {
      "cluster_id": "fb8a3738-fc86-4011-aef4-faadf91c1772",
      "members": [
        "2a9cff89-c049-4c4a-9e5f-5522c1593479"
      ]
    },
    {
      "cluster_id": "077993b8-9cb6-4b90-bda9-8d4fd6b15198",
      "members": [
        "bb15de34-8f26-42ed-b3ad-221235bff97a"
      ]
    },
    {
      "cluster_id": "71aef7b0-37f2-43a6-87de-3439a440ada6",
      "members": [
        "ad3b954b-1091-49ce-b778-17d438f96d8f"
      ]
    },
    {
      "cluster_id": "bfe09009-b8ac-46f6-854c-5d83a7ad4a7f",
      "members": [
        "5fdae4e2-c22f-4c43-86c0-be6b6fa3bc36"
      ]
    },
    {
      "cluster_id": "af13a573-a204-482f-aa52-9623e30fedfc",
      "members": [
        "c4d32fe9-81e1-448e-bcf7-fe8455ffad08"
      ]
    },
    {
      "cluster_id": "f8620270-b25d-43a1-ab67-3efa1d1f6e6b",
      "members": [
        "7c7e2884-2e16-43ba-ae99-f2e49fcb11b7"
      ]
    },
    {
      "cluster_id": "49909022-fed5-4a4d-89a8-bdf0a26dd966",
      "members": [
        "bfd3bcf0-a950-4f4d-8860-33af03978c35"
      ]
    },
    {
      "cluster_id": "8da88efd-932e-4ef9-ba62-12fc265d9255",
      "members": [
        "8d5df244-0e28-4a6a-ae4d-b90dadb3a8ca"
      ]
    },
    {
      "cluster_id": "4f92bf5d-f880-4cc6-a2da-cbba50d74014",
      "members": [
        "7a46bd74-7779-40f5-aebe-ffa7f7ea18fb"
      ]
    },
    {
      "cluster_id": "db82285e-98ce-4ae9-a084-bb6101bb4059",
      "members": [
        "f0a4a85f-cdfb-40b1-83d4-4fcfb707d3e6"
      ]
    },
    {
      "cluster_id": "7633550e-7afa-4184-8ac2-7603de1beef0",
      "members": [
        "c6a908cf-12f1-459b-8f33-779927db7075"
      ]
    },
    {
      "cluster_id": "e91b49c0-8438-4f30-a193-2c3167f6ab7a",
      "members": [
        "e3ea3796-f949-46b5-bb3f-3f68dd2bbcc5"
      ]
    },
    {
      "cluster_id": "99814cad-01e4-492e-93e2-a867761329f7",
      "members": [
        "fbf353d8-ec47-42e3-9828-31180f164c59",
        "4409d09e-8edd-4492-9963-1938986c6ac9"
      ]
    },
    {
      "cluster_id": "24b2ce3b-aee0-470f-b1ec-7fc4ce0d6235",
      "members": [
        "24b0b149-2595-42aa-9718-73681c300ead"
      ]
    },
    {
      "cluster_id": "4ddb3ea0-b81e-40cf-8c94-adef57bca158",
      "members": [
        "35121ed1-891f-4881-b73c-9fdcbab4eb0a"
      ]
    },
    {
      "cluster_id": "5ac2f931-1ef9-4c96-8568-845f2751d03d",
      "members": [
        "12d45049-de41-4341-b3a8-0b222ac2854c",
        "afa3f769-5fb0-4994-aa0a-de98c97a7804"
      ]
    },
    {
      "cluster_id": "381be24e-814e-460f-aaf7-24ebc78ab4d4",
      "members": [
        "4fcaface-4768-44b8-ba40-d0f6bcd6b89b",
        "1634687c-de17-4492-a1e9-6bd2d7fd3d75"
      ]
    },
    {
      "cluster_id": "168ce58c-2c86-47ff-b749-0d60377b9053",
      "members": [
        "34ba6106-153e-4d6a-8628-0deba86545b5"
      ]
    },
    {
      "cluster_id": "4f8dc606-1036-443d-8754-a33caecd77d3",
      "members": [
        "240c370a-3709-4e6b-802f-cf3545dc04e1"
      ]
    },
    {
      "cluster_id": "eea04632-7eb6-45a8-afd1-95556afba561",
      "members": [
        "77165de3-a791-40c3-8efd-b693f985ad63",
        "da7b8fa8-4e45-431f-9e24-5baa47caaf33"
      ]
    },
    {
      "cluster_id": "ad9b8529-0422-40dc-8b6b-9a712020027f",
      "members": [
        "ea463e10-c39b-40b0-b336-1b6fdb29a1e4"
      ]
    },
    {
      "cluster_id": "701cfb5e-4d20-40b0-b06a-cb6fe171068d",
      "members": [
        "c1cb00fe-3502-405b-a6ab-0d448cd92e7c"
      ]
    },
    {
      "cluster_id": "b224e5a5-61c4-447f-b912-3f4a296442f7",
      "members": [
        "b7328816-8b70-4137-8e00-c64d9f42f0e8"
      ]
    },
    {
      "cluster_id": "2dc916ab-843e-4007-bf03-57e437a7dc48",
      "members": [
        "138c4462-87cc-410f-bc8d-2ef119d15bd8"
      ]
    },
    {
      "cluster_id": "b7e93309-96c4-475e-9ccd-507fa2166b0b",
      "members": [
        "8acb8e9a-b980-4aa2-b9d3-91ba041f4ce3"
      ]
    },
    {
      "cluster_id": "4724ac82-4846-4770-a7bb-6a4edd69c9dd",
      "members": [
        "45ebeebb-89cc-4ab7-b27b-7ec391464963"
      ]
    },
    {
      "cluster_id": "eb9567f9-4c3d-4f62-bea9-bc557347bb13",
      "members": [
        "50d67449-92cd-4b37-ae42-abfaac7619f9"
      ]
    },
    {
      "cluster_id": "a1ecb202-6deb-48e9-b7cd-80beb55064e2",
      "members": [
        "4e05695e-f1a7-4138-afcc-4cc21a904e57"
      ]
    },
    {
      "cluster_id": "62c268b5-d8e3-4743-b673-44ec104402b5",
      "members": [
        "5252bdae-fae8-404f-9f9f-19b6a7cc8fbf"
      ]
    },
    {
      "cluster_id": "e42d98f9-07f8-45be-ae88-1f54a5594edd",
      "members": [
        "980fc750-a12c-4d0d-99a6-b8cf9f5e7d79"
      ]
    },
    {
      "cluster_id": "d918fb3a-9d62-4cdd-89a1-68fdc8de204d",
      "members": [
        "4b3d21da-17a0-4671-9b0c-cb8e2f09c2df"
      ]
    },
    {
      "cluster_id": "d8869910-ef23-4e2c-a1a9-778ac3a96b8c",
      "members": [
        "42c3ca8f-6b5c-4786-8e60-b5e841dd430e"
      ]
    },
    {
      "cluster_id": "f1fff97c-e8ee-45ff-b0df-2544c89e909e",
      "members": [
        "177cb85a-ce3e-4e46-9e38-95b1eb71a1c8"
      ]
    },
    {
      "cluster_id": "75c9220d-327e-40e0-adbe-2a476a0c2f1a",
      "members": [
        "e1d81b4f-65e3-4407-9c6a-93128d5a53da"
      ]
    },
    {
      "cluster_id": "812a3386-bb25-454d-924b-c4a0c4d57dfa",
      "members": [
        "33356a44-4e77-4163-bc68-3eee1fe3a711"
      ]
    },
    {
      "cluster_id": "93e534a9-c780-4415-bea0-b88f8156dbb0",
      "members": [
        "ae81d2ef-de6f-45f3-b800-4dfb5a7bdfdf"
      ]
    },
    {
      "cluster_id": "823e369f-d264-405c-a8ab-0edf1095b0fc",
      "members": [
        "1948e678-c2c8-4706-abc6-484e56225a6b"
      ]
    },
    {
      "cluster_id": "0d87ab36-c271-462d-81cc-1e3930ab33e4",
      "members": [
        "bf531250-c7e0-42b2-a0b1-96e2fc7d2950"
      ]
    },
    {
      "cluster_id": "7259b8c6-e5fe-4c56-9293-e3133ae377b8",
      "members": [
        "27d48414-b3f8-489e-973a-ad9f6fe83ffe"
      ]
    },
    {
      "cluster_id": "d3c1593a-2221-4777-89bd-fb14c68a1659",
      "members": [
        "f5a2995f-193c-4bbe-b4c3-a69acddc8f22"
      ]
    },
    {
      "cluster_id": "5dcaa7f9-db6c-4bc0-81d7-916cfd750a0f",
      "members": [
        "be683cad-5ff8-4916-a8b5-778dbac3fc7b"
      ]
    },
    {
      "cluster_id": "0ffb9af7-6a71-4266-a4bc-ddac4a179c1a",
      "members": [
        "a6f4a4f2-0e5e-455c-bcd4-baf8a3dd3724"
      ]
    },
    {
      "cluster_id": "aed589a1-07ba-475f-b7f3-a645da58e97b",
      "members": [
        "2ef830d9-9250-41ff-96cf-c32099ec79ee"
      ]
    },
    {
      "cluster_id": "25505b18-cd95-4150-9d26-ae16f59d9924",
      "members": [
        "ea9db0fe-391d-4fc5-86d9-9c4488f46eda"
      ]
    },
    {
      "cluster_id": "cb34d24e-7722-4a18-bb1f-3ff1c0f4f310",
      "members": [
        "fd3c6f58-c889-4567-93c5-3a56a7ecabc2"
      ]
    },
    {
      "cluster_id": "160b6b7e-ff36-46d8-bcf4-e711c773e83e",
      "members": [
        "fa76eebd-850f-43a5-8fe7-0478ad1524c6"
      ]
    },
    {
      "cluster_id": "2bd0b47a-c8f5-4e58-b230-5a58686ed27d",
      "members": [
        "cf19da29-e597-4a89-89b1-9ed74e22d7c4"
      ]
    },
    {
      "cluster_id": "97a2e6d5-9f35-4464-ad73-ec9b3ab0029e",
      "members": [
        "71c8f9eb-2666-4961-a599-9dca493f7a00"
      ]
    },
    {
      "cluster_id": "a8171dc6-d1e7-4f00-80c9-a3281fe32c93",
      "members": [
        "a60933bf-eb6d-4640-95da-e65af0f74bbe"
      ]
    },
    {
      "cluster_id": "ea25dfa3-b506-4476-b1e0-0c164e97dea2",
      "members": [
        "12468af9-c3a4-4b64-a4a9-df596f578bf0"
      ]
    },
    {
      "cluster_id": "43152486-d4dd-4e19-b1d2-24534e09e32d",
      "members": [
        "1cd015e1-f4fb-4439-8be4-9db8a355be68"
      ]
    },
    {
      "cluster_id": "5b49dda1-0066-4031-bd05-509e4245118d",
      "members": [
        "46ffce94-2f87-4972-920f-76a2e7524c41"
      ]
    },
    {
      "cluster_id": "4ccf7bf5-90df-4621-97ed-669020415167",
      "members": [
        "97e727e7-960e-4a2b-abf7-0793ea312243",
        "d90b6765-794f-452a-a742-a154dec3b293"
      ]
    },
    {
      "cluster_id": "23bd5333-419d-453d-bf08-b1b6ca7b3af3",
      "members": [
        "33ae4456-5a7c-4a22-b627-bd9f9c50773e"
      ]
    },
    {
      "cluster_id": "d7765332-5dba-4716-b432-1311de3172a6",
      "members": [
        "6e3be3bb-0b31-40c2-9c4c-86d033a52acc",
        "3e950ab0-2b39-43ff-9a5f-062a36c00af9"
      ]
    },
    {
      "cluster_id": "7206ac0e-b88d-4695-a9fd-a007b0fa396e",
      "members": [
        "c6ca0ef0-9643-4ec2-a666-d2c0c25f9594"
      ]
    },
    {
      "cluster_id": "605679a7-417f-419b-b13a-f72296af0a8c",
      "members": [
        "adddaf0b-1b58-49fc-8a33-15236b222e4b"
      ]
    },
    {
      "cluster_id": "878ab8c3-2760-46b0-8086-c8aa996e56bc",
      "members": [
        "7548bb88-0c7f-4620-8757-ff3d81ed63d3",
        "6f7d4055-8be6-4fdc-938a-fabe5e516197"
      ]
    },
    {
      "cluster_id": "2f22684c-1c98-4774-aade-6114067fd60b",
      "members": [
        "83dfea00-70fb-48cd-aebd-04e1dc8f1702"
      ]
    },
    {
      "cluster_id": "face4903-290b-41c9-8ba8-d5aa2cfa2533",
      "members": [
        "fbae0e6a-df1a-4f80-8faa-70c21e501e8b"
      ]
    },
    {
      "cluster_id": "84fce8b4-ea2c-4b33-883a-03817afe99a2",
      "members": [
        "1680d51b-a411-47ab-aa9f-fa25d53a8c28"
      ]
    },
    {
      "cluster_id": "a3d2131c-63fa-494b-a0bb-572e611c5c5e",
      "members": [
        "72f482e4-4c9b-400e-b22c-aec5e947cd6d"
      ]
    },
    {
      "cluster_id": "904668bf-4a16-4f14-9adf-79655c2a451c",
      "members": [
        "e9ff4476-2dee-4c1f-adf4-50aa9b1cca55"
      ]
    },
    {
      "cluster_id": "a37e6820-0d6d-49d8-8dfb-fc94f1f84e73",
      "members": [
        "63aaf013-8d50-412c-81a0-96ec60af11f7"
      ]
    },
    {
      "cluster_id": "2b4b4bf2-1300-4817-8f72-f629847abed8",
      "members": [
        "72f22cf7-f130-4e72-83aa-7a8643dc108b"
      ]
    },
    {
      "cluster_id": "bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093",
      "members": [
        "f45cbc4e-f37f-4dd2-9353-0c7aa03f7174",
        "c4ba973e-5883-4b1a-b720-9168a9331158",
        "8b05fc9f-1aba-45bc-8a5f-875af5aed5a2"
      ]
    },
    {
      "cluster_id": "906602f3-b23d-4091-b462-b74d3ce8894a",
      "members": [
        "038860ed-0644-4a78-a26c-ddfd467df0af",
        "b2ba8839-0f81-45f8-8999-b2c1360ff592",
        "35b0bed3-1f4d-4d22-9506-3ffde0094728",
        "da2933a9-afa9-4f22-bee2-2b77b8a9c354"
      ]
    },
    {
      "cluster_id": "f6a33dd1-9465-4406-a3a5-1949cd825e71",
      "members": [
        "97d91213-c2e1-4a9f-ad2e-c13b57d37aae"
      ]
    },
    {
      "cluster_id": "6084620c-6cb7-4024-86d0-5c702f76e152",
      "members": [
        "c958ba33-3ea5-4da4-980c-022f38695458"
      ]
    },
    {
      "cluster_id": "906d1526-e5ff-4f4e-a0e5-f30c2dfb306d",
      "members": [
        "2f98b85a-d39e-438e-b66a-d505d2606979"
      ]
    },
    {
      "cluster_id": "2b56b1f6-1627-44ab-9460-b13751cf087b",
      "members": [
        "eab631c3-da72-4370-a532-a31a42572838",
        "ff9240ed-fc40-4246-8fb4-084cf8be6aa2",
        "21321047-f657-460f-9cc4-e78bc25fb3fe"
      ]
    },
    {
      "cluster_id": "93a61a8e-4477-45a4-b63b-bc7992dad11c",
      "members": [
        "aba49bda-c2b0-4003-9209-e6890812b61e"
      ]
    },
    {
      "cluster_id": "b6748e1b-bb47-47df-a0a7-16d2d7f95e46",
      "members": [
        "cbc67cf5-9419-43f3-9dc7-c44b2733ba3e"
      ]
    },
    {
      "cluster_id": "b6efa0ef-9a52-43da-8c24-a3f10f0aaf37",
      "members": [
        "db44defa-3c36-4859-b748-caa84afa1fcc"
      ]
    },
    {
      "cluster_id": "49854b0f-e263-4847-a942-d2497d0d1530",
      "members": [
        "67b8b108-aefe-44f0-897e-f627629cd681",
        "0c64d8cd-4d2e-4cd3-827f-152ecf89cd6a",
        "d9bbb9e7-9567-43cf-b61a-226860dd80e3"
      ]
    },
    {
      "cluster_id": "a7fcff89-a4a0-45c3-b800-3d7861e64986",
      "members": [
        "6f39a42e-d0a7-4152-9012-db5be6eeadef"
      ]
    },
    {
      "cluster_id": "a06923fa-5b7d-4810-97a1-737122cf8581",
      "members": [
        "6361e3fa-8bbc-4e57-b2ec-32d1afda5b97"
      ]
    },
    {
      "cluster_id": "b4530fdc-2dbc-4670-850f-b1965eb9d9e1",
      "members": [
        "0d9787a5-5dce-46f2-b517-8a5b9b184f48"
      ]
    },
    {
      "cluster_id": "16e2933e-aa5c-44ff-81fe-873695154b36",
      "members": [
        "39ef7077-d79e-4496-bc0b-3c003a80e3cb"
      ]
    },
    {
      "cluster_id": "e250b185-4f74-4634-99e7-3af880f034a6",
      "members": [
        "289de12e-9f31-4ce0-8bac-9174a0700012"
      ]
    },
    {
      "cluster_id": "e1c95bf3-b7f4-4783-af68-d79bcb7b55a9",
      "members": [
        "c7fdf878-5fac-41b8-b934-f21635dbda20"
      ]
    },
    {
      "cluster_id": "546b42d0-5005-442c-a548-5a747146aa92",
      "members": [
        "c55ee29e-3bab-4ba1-bbe7-ca82e627ca35"
      ]
    },
    {
      "cluster_id": "cc1a98ca-fc1c-4f29-b58b-0d99bce8b809",
      "members": [
        "995c7333-e54f-48cb-a82e-96fb67dc3a32"
      ]
    },
    {
      "cluster_id": "d72d1fb8-e77f-4607-a953-e3e224ada7a6",
      "members": [
        "75cfb33e-0352-48ea-9780-f5bdda5e717a"
      ]
    },
    {
      "cluster_id": "a06a1094-e3d5-4cdf-b982-d9ff6654fb83",
      "members": [
        "d5a5bf2a-04e3-4d0e-af38-0a7519015383"
      ]
    },
    {
      "cluster_id": "8c5f2bf0-92e9-41c9-b66d-14747ba819d6",
      "members": [
        "f9c8fbc1-67a7-4704-a2e1-e99fec527735"
      ]
    },
    {
      "cluster_id": "f387334c-114b-4f0f-8f1a-524773e4b44d",
      "members": [
        "97c3bcc5-ad71-4bcd-8a13-c1f3a049f14c",
        "60700a47-9ea0-4dce-a491-4559115f0b62"
      ]
    },
    {
      "cluster_id": "d5752cab-3caa-48c6-b67d-7ac6c89bd054",
      "members": [
        "c9333206-b8e8-4ce9-b191-0ffd93b8118f"
      ]
    },
    {
      "cluster_id": "2ec09e70-73d9-4395-9c36-0dbcac034464",
      "members": [
        "39b41e96-06be-47c3-af2e-77866a296fea",
        "1ca9b445-a7f1-4e4d-a7c3-b2b10215d91d",
        "87749de4-8e3e-4246-b0ec-0e253eef0c89"
      ]
    },
    {
      "cluster_id": "ee29d318-fee6-4bab-9dff-20d633b0297f",
      "members": [
        "6d170253-a0d2-4d39-9138-c5d4a72fde42"
      ]
    },
    {
      "cluster_id": "c1a62eb0-76d0-46fb-8060-6353e7306396",
      "members": [
        "92151bb0-7996-4fac-9dff-54ae5c2b8076",
        "18930930-1a7a-4b78-b149-ff1350f161e4"
      ]
    },
    {
      "cluster_id": "f13db706-0347-473b-9857-0fcfd7adeb37",
      "members": [
        "794b08a1-59b7-4f7b-9499-7fbae5270e8a"
      ]
    },
    {
      "cluster_id": "a0a3d302-3c42-4ec6-a980-2d9ce3d3fb0d",
      "members": [
        "378fa6ea-1c37-4b64-99cc-af69758c9482"
      ]
    },
    {
      "cluster_id": "a23c75f5-2cc2-4ad3-bbfe-8878efe773ea",
      "members": [
        "dabcf4bf-2b03-4def-901a-62f22fac965d"
      ]
    },
    {
      "cluster_id": "c21a5302-b063-4bd9-9ecc-b34fe6ec8594",
      "members": [
        "aebd57ab-6dd7-4b0d-a553-681a4786cb36"
      ]
    },
    {
      "cluster_id": "72e8bf8f-e8db-4e42-bec7-0ed7ee61d61a",
      "members": [
        "018d1ede-175c-4fdf-8470-711815c56a6f"
      ]
    },
    {
      "cluster_id": "f3475e22-43a4-45ea-ad6a-fe7e7accc82a",
      "members": [
        "87364eda-63bf-49ce-b81b-f809767d1673"
      ]
    },
    {
      "cluster_id": "6b75ad73-0fd7-443a-b60e-840a237907bc",
      "members": [
        "608fbe47-ff8c-4b68-b402-04fc938c52f5"
      ]
    },
    {
      "cluster_id": "6e55b53e-064d-4b25-b79e-bd27aee62abe",
      "members": [
        "1903542d-2ade-4a19-9eb6-1de53f3b5652"
      ]
    },
    {
      "cluster_id": "e7c86122-ad9f-42c0-8185-4eb16e495061",
      "members": [
        "4f751d6c-aef6-4e8f-a7d8-9fe179abe261"
      ]
    },
    {
      "cluster_id": "4dc44ea9-8d2b-4f60-a0c5-d10d5af77cfb",
      "members": [
        "83361a24-6725-4af5-bba8-d7dd76c82c5b"
      ]
    },
    {
      "cluster_id": "0e2a258a-cc1c-4d20-82ea-f1ebf02f74b2",
      "members": [
        "fb00d190-2fd6-4778-863e-7fc44c538a44"
      ]
    },
    {
      "cluster_id": "3f25c082-1585-41e9-8842-37a9e6419694",
      "members": [
        "3910d908-f09d-460f-8007-dcc095faf253"
      ]
    },
    {
      "cluster_id": "bad03c04-e50b-426c-824a-ff2c1f2c20d8",
      "members": [
        "78373792-dfb0-44fe-bd62-df4b0c3a7776"
      ]
    },
    {
      "cluster_id": "aaac8e79-68d5-45a4-b3d7-7bcd6881a93c",
      "members": [
        "7c73d6b8-d639-4da0-9d65-d9d84007a99d"
      ]
    },
    {
      "cluster_id": "d9b685c8-3dc8-407d-b009-8b6a472fbfe9",
      "members": [
        "e00c9545-9529-4da3-b581-5296167763f0"
      ]
    },
    {
      "cluster_id": "fccc5c68-3c5f-4b2d-8103-9431b0c4794a",
      "members": [
        "084941a3-0dfc-476c-b4d7-5fe00f7d1222"
      ]
    },
    {
      "cluster_id": "008cba92-e4d7-4655-90ad-12cb214fe197",
      "members": [
        "fc9424cb-6ac1-4c16-a4cb-6b301d640d6c"
      ]
    },
    {
      "cluster_id": "83578f15-2ee2-4dd4-ae7f-b543ba5e2a87",
      "members": [
        "cb886c61-9b24-495c-af33-773416babf42",
        "699a4af5-75d6-42db-a04f-798074f56283"
      ]
    },
    {
      "cluster_id": "89ca7fbd-adb5-4425-9a07-78efe99244cc",
      "members": [
        "e59c9a36-25da-4583-b301-8b536a7a6a5d"
      ]
    },
    {
      "cluster_id": "7681cbe0-1efe-4edf-b906-ebf02351325e",
      "members": [
        "fa16f634-12a6-4b65-ba49-51dbe1ac2549",
        "a5e6f28a-ffd1-43ba-ac54-e6d89fb9b787"
      ]
    },
    {
      "cluster_id": "66d5fd65-8e6b-405c-9801-c7ba78bd49a4",
      "members": [
        "c1389a43-915a-4c33-a0a1-07e3063944c1"
      ]
    },
    {
      "cluster_id": "65c190b4-386e-49d9-9ce5-a5d89e355ede",
      "members": [
        "aa6572aa-aad1-495f-9010-60dea2946df0"
      ]
    },
    {
      "cluster_id": "c42e5196-2b49-45c0-931e-85ce5682f952",
      "members": [
        "dac912ef-7f2f-4e85-834c-b0b208f705bf"
      ]
    },
    {
      "cluster_id": "c2b35258-6b6b-4618-98dd-3efdfd8152a2",
      "members": [
        "32a5e08d-a068-4ab9-83cf-7712a622f533"
      ]
    },
    {
      "cluster_id": "72ffc77d-60b8-420d-8327-cb12019a9c56",
      "members": [
        "9dd8dd34-cc32-45cf-a8ab-06f7eeba66ca"
      ]
    },
    {
      "cluster_id": "5a5a1e17-8382-4005-9268-9165cf015b00",
      "members": [
        "666548b4-4b73-47de-bd9c-9d5669fe9239"
      ]
    },
    {
      "cluster_id": "4693632f-2c46-4370-bcbf-41570c0b3112",
      "members": [
        "0216cbda-8ba0-4a88-b35b-782f37194994"
      ]
    },
    {
      "cluster_id": "91a996d6-946d-4317-a60d-c7b9088e7854",
      "members": [
        "731bb2e7-f349-4150-8d45-c7a663dc4e1a"
      ]
    },
    {
      "cluster_id": "be17c081-a4ac-42d9-b909-7a4f19b8160b",
      "members": [
        "239443a4-d8d6-47c5-ac36-4a98580c9e41"
      ]
    },
    {
      "cluster_id": "bb09aa05-ec64-4861-98cd-96845b502414",
      "members": [
        "e0001ab0-ea1d-4131-945c-8d9a05240394"
      ]
    },
    {
      "cluster_id": "2f6c2f5e-a3c6-4ec4-93b2-6127b5c87ee6",
      "members": [
        "dcd3d9cc-a3f7-4de1-9f89-e1aa2e2c4da1"
      ]
    },
    {
      "cluster_id": "b217e8fc-9e97-45a5-8767-f4c21e8e0b4d",
      "members": [
        "d8fd4d90-e8e8-4f0a-b95c-466cadf04a04"
      ]
    },
    {
      "cluster_id": "9893c9eb-e787-4810-bf5b-6340ac0c0c07",
      "members": [
        "e0253ed0-24e0-4426-b0b9-9bfb63ca5111"
      ]
    },
    {
      "cluster_id": "78c6a4d3-5529-4139-b6cb-7f76f21ff807",
      "members": [
        "8da00518-0a95-4f45-b6bc-4d2e0e85d560"
      ]
    },
    {
      "cluster_id": "4aba8ac6-afc1-46c8-8568-0d2d6d6bddaf",
      "members": [
        "82514ec5-9684-4e7e-b8c3-3f9261e8c203"
      ]
    },
    {
      "cluster_id": "f29c8da8-dc4f-4133-97b2-dbe8a7c642b2",
      "members": [
        "9bb85cec-e218-42dc-8d26-2028bdd2d6c6"
      ]
    },
    {
      "cluster_id": "7c038a6d-dd5c-4d1e-a387-d5620daf9907",
      "members": [
        "e661d56d-02cf-49ac-9ae4-5dfd32f12de2"
      ]
    },
    {
      "cluster_id": "83537dd5-17fd-4fd5-9899-58a782adb8f8",
      "members": [
        "26f38863-34a4-4baa-a6bb-528432254308"
      ]
    },
    {
      "cluster_id": "a3899865-60a9-4162-9d1f-4bd867347d37",
      "members": [
        "f35aab89-abde-48df-90da-f4bc0871106e"
      ]
    },
    {
      "cluster_id": "82f5beda-b460-413d-ba52-232c56bac459",
      "members": [
        "ee46c6d3-5649-405a-9bfd-474650c7f68b",
        "53352fb2-8c41-4ae8-ae51-998a77fbdfe7",
        "c81bbf61-f731-4178-8ce9-126dc09503cb",
        "6830bac0-33f7-4f3d-b9f4-50a6770990b9"
      ]
    },
    {
      "cluster_id": "42e92742-8e3a-4799-8e99-5faf8bc31f82",
      "members": [
        "89df43ba-e28b-4105-adea-e98ec69e07c8"
      ]
    },
    {
      "cluster_id": "5342c103-f887-4c11-8002-61b16e22dc39",
      "members": [
        "ec19c603-ba0a-4451-82ce-b8ac2bcff24e"
      ]
    },
    {
      "cluster_id": "edc9ab41-cf63-48e3-8098-f84524398358",
      "members": [
        "62bdd436-24bc-45ee-ac5b-deaa1f9d4b13"
      ]
    },
    {
      "cluster_id": "b2e6976f-e5a2-4669-ac3d-3e87cd376f99",
      "members": [
        "78f3ed54-d775-4796-b00d-1a7d215338d1",
        "e82efdc4-5571-4b8d-9765-cd146c3dd097"
      ]
    },
    {
      "cluster_id": "77ffe8cd-d30f-4bde-8bb0-f1fd00ff5cdf",
      "members": [
        "c23caf4e-5a67-448f-a6e9-5b10ed0837a6"
      ]
    },
    {
      "cluster_id": "455f3cb3-d253-4739-8dfa-e88137f7f063",
      "members": [
        "645a89bf-77d9-4f28-b0df-fbdc93a6b911"
      ]
    },
    {
      "cluster_id": "9809fa62-b9bf-47df-ad2e-8fa4d84399c4",
      "members": [
        "48555f17-882d-48b9-a03a-0c1a3711c0e6"
      ]
    },
    {
      "cluster_id": "c498b99d-fbf7-4e48-9c94-6d92541e239e",
      "members": [
        "3226a3e3-1e00-4386-bb16-3d567fba77f9"
      ]
    },
    {
      "cluster_id": "2e4008f0-4f9e-4c2e-bf84-cd19c2b3f87e",
      "members": [
        "2b0b5fe1-bfad-4c0e-b5e0-76bf9af80f36"
      ]
    },
    {
      "cluster_id": "acf832a3-5be5-4fad-af20-2e71b7b538f5",
      "members": [
        "4ae84f5e-59ea-487c-b407-5bfbcfe9d271"
      ]
    },
    {
      "cluster_id": "57c8d119-9759-4d0a-a7cd-9c98d4429c3f",
      "members": [
        "e86761d9-fa89-4480-bf36-115dfe98c6b0",
        "970d01a7-2623-44ac-9bc2-138a3179e97b"
      ]
    },
    {
      "cluster_id": "adcf9b34-2bf2-44ce-9216-0201823c4649",
      "members": [
        "ff67ba3b-46c2-42ff-be54-e2eb64f3b42b"
      ]
    },
    {
      "cluster_id": "c7723f2e-2c6c-486e-98b5-302326a9be1e",
      "members": [
        "fc9b5ba0-b2c6-4fd3-bd70-03456c965cea"
      ]
    },
    {
      "cluster_id": "d62a8641-ec0a-467e-8fc4-ccff76b670f1",
      "members": [
        "f1dfc5e7-8a60-496c-9552-9ad86c0f72b0"
      ]
    },
    {
      "cluster_id": "44105fe2-7f1b-4985-910c-f4a271b0cca1",
      "members": [
        "5ee678f8-8298-42b2-8c29-48e1c8f13db1"
      ]
    },
    {
      "cluster_id": "59ccfd51-c23c-4ddd-9244-d1ca28b0c8b8",
      "members": [
        "05a00692-badd-43b7-97ac-20a484aa8c2c"
      ]
    },
    {
      "cluster_id": "171d785c-3288-4a8a-90f1-9e6a8e012955",
      "members": [
        "53b8ba4f-0b4e-464a-b32e-a2a399aa2f36"
      ]
    },
    {
      "cluster_id": "aadbc964-f981-4ea2-bc24-dd4cf5de086c",
      "members": [
        "d7a3fe53-881e-4eff-bd66-7599825f5bfa"
      ]
    },
    {
      "cluster_id": "ca172ee1-fff6-4049-a2d4-1e377d7e0cd8",
      "members": [
        "bfab812f-f35f-4434-b8c9-931f6a095d07"
      ]
    },
    {
      "cluster_id": "fa141cd8-01d2-46a8-8dd5-b14aea438fec",
      "members": [
        "99eab8ce-9692-45b3-8ef3-e1c6be42f203"
      ]
    },
    {
      "cluster_id": "a5d008c6-c15a-4302-aa70-e916c52f5451",
      "members": [
        "f0bbdab9-ccc4-4a48-8e87-69328f9d2cec"
      ]
    },
    {
      "cluster_id": "e18afe50-8e61-4915-8745-6256e6a782cb",
      "members": [
        "bac2779e-65a3-4bb1-a15c-5896e1b277ea",
        "88903702-9d9c-4e73-add2-00c128a3b948"
      ]
    },
    {
      "cluster_id": "1604ef4f-6382-4413-9253-925958021968",
      "members": [
        "7118efe7-4a74-4b7d-9603-c9a06dec22b7"
      ]
    },
    {
      "cluster_id": "b0bd2a7e-c0c5-4afb-ac21-777cf1d80964",
      "members": [
        "56e832cf-c75e-4b19-b939-958843af5e48"
      ]
    },
    {
      "cluster_id": "b7e82711-b99a-4580-8fb1-a7b6465b462b",
      "members": [
        "d076e1e4-cb01-4830-b778-89ad0d5d2d0f"
      ]
    },
    {
      "cluster_id": "933d50c3-dd0d-4b5f-9957-22bbcfcc55d5",
      "members": [
        "6086d3ec-6e14-4e5a-97e5-abcc68acd1ba"
      ]
    },
    {
      "cluster_id": "2ff5212c-713e-4d80-b0b9-c7f306cf69fb",
      "members": [
        "b2db9a74-3810-496a-8336-83ee8026fd39",
        "8f9b6c6f-e4b8-4d86-a137-ec8c58e2c655"
      ]
    },
    {
      "cluster_id": "d8aa6d60-fbe4-466b-a7f6-c42801792185",
      "members": [
        "c0543dc9-93ec-4472-b679-5a93806f0f77"
      ]
    },
    {
      "cluster_id": "8a24a294-bd79-41a9-b04a-466874226ecd",
      "members": [
        "b0ad41ab-0fbe-421f-b0f8-b5820cfab9cb"
      ]
    },
    {
      "cluster_id": "a4887daa-dc3f-4a40-83f8-3598cedca9f3",
      "members": [
        "c21686c5-492d-47ed-a7dc-74dbabe21e49"
      ]
    },
    {
      "cluster_id": "14fc8edb-0dea-4ae6-b573-ec0c5512391b",
      "members": [
        "8509f258-1a84-4c3e-881d-8e34fe030827"
      ]
    },
    {
      "cluster_id": "5e3b2dc6-8e5b-4236-bdd1-0dbf9bb9618c",
      "members": [
        "4c13fa25-8bb8-4651-b117-8c16579c165d"
      ]
    },
    {
      "cluster_id": "ce807753-2437-4a69-9e26-d1ab69fdd2c7",
      "members": [
        "4fa6e076-c198-48ad-ac22-9996dcaaaac6"
      ]
    },
    {
      "cluster_id": "2c8a535e-7913-4f01-8d69-eb8f7265032f",
      "members": [
        "bd84f781-f0b2-443a-86c1-1de0da98affc"
      ]
    },
    {
      "cluster_id": "5a95085b-b1ae-4847-9e04-b0336ef06ae4",
      "members": [
        "2e6a3ac6-876f-4bdb-b5d6-ec1962d7cac9"
      ]
    },
    {
      "cluster_id": "52f03b57-8fb1-4ff1-8eda-c0d228097a8f",
      "members": [
        "aa4c4361-bd70-4c16-8b8d-a8d8e16e8564",
        "d13c190d-6b0f-4280-82c0-547610a559a4",
        "4c69ec36-cf69-48e0-9359-b8cb2ff98b4a"
      ]
    },
    {
      "cluster_id": "345af148-94b5-4202-924c-3b3712e4cb8b",
      "members": [
        "083b147a-37da-49e9-b89b-80b1206f92f3"
      ]
    },
    {
      "cluster_id": "75cc70a1-5be7-40b5-9ce1-1497b1ba2474",
      "members": [
        "a9730833-1cbc-41a7-981f-380069816fe2"
      ]
    },
    {
      "cluster_id": "5301f4d4-e78b-423c-a3a7-ca0fb632a3d4",
      "members": [
        "77fe070d-3c75-456e-b8eb-3b2323bec095"
      ]
    },
    {
      "cluster_id": "f2b5a4d3-d094-4fa0-812e-4687bf81efb7",
      "members": [
        "45bf98f3-dfe7-4c7b-805c-f5a4309f585f"
      ]
    },
    {
      "cluster_id": "bacf6a38-aa68-4722-a54e-dd8b9dbd45eb",
      "members": [
        "d77df6cb-bf52-4891-bfcb-2c327a3ea055"
      ]
    },
    {
      "cluster_id": "3bda9d5f-2f9e-4086-90e5-207bbda0f725",
      "members": [
        "9cbaf22f-5db4-42dd-8dc7-b3aee930ef0d"
      ]
    },
    {
      "cluster_id": "978027c6-a544-4944-bbb9-ca0424967ff9",
      "members": [
        "68f4113b-fa65-47cd-b9c9-00630b24aaf1"
      ]
    },
    {
      "cluster_id": "bbbc8b46-d558-43ec-8e55-d7d72928442c",
      "members": [
        "7188e349-5551-48b8-a82d-ae8ce0e1608b"
      ]
    },
    {
      "cluster_id": "ca1ecbfe-0a58-42df-b1c6-c31ad13d1a11",
      "members": [
        "1b4f37ec-096c-4542-a2b5-2e6328a8fcb1"
      ]
    },
    {
      "cluster_id": "e8d4709f-937a-436c-a2c9-ff8bff8819ca",
      "members": [
        "234107a1-2d51-40dd-86d6-b8887f339749"
      ]
    },
    {
      "cluster_id": "634b7e88-e0f0-4f5c-a26b-6d9e0a0fdc06",
      "members": [
        "a415d643-ac0e-4216-a102-a2f12264e028"
      ]
    },
    {
      "cluster_id": "c3de0789-c302-4248-804e-d8d020c50634",
      "members": [
        "f4e17a2a-d83f-42d0-9c98-c8b76a75a3e3"
      ]
    },
    {
      "cluster_id": "31fdbc6b-e989-4270-9e66-1ce2fea0d717",
      "members": [
        "2e545ac9-0408-49ef-acbd-eebc010bc0f5"
      ]
    },
    {
      "cluster_id": "145084b8-39a8-4c53-8295-e697e796d433",
      "members": [
        "28e872e1-54c2-4629-adba-821071b37393"
      ]
    },
    {
      "cluster_id": "3f86eb67-5a60-4e67-ad29-e4342d8dc8d0",
      "members": [
        "1474e2b8-6074-4173-a8bc-660920f8d84c"
      ]
    },
    {
      "cluster_id": "7a9e1845-1b7e-4301-8581-ef30d33ccad9",
      "members": [
        "c0708339-d06a-4d2f-9640-e90ba5065484"
      ]
    },
    {
      "cluster_id": "bd1a5427-07c8-4a9a-b3bd-6c833ee88f8c",
      "members": [
        "161af1f3-b533-4865-8e8b-ce4e87edee12"
      ]
    },
    {
      "cluster_id": "a0a7051e-2d37-4a4c-b40d-aaf1f0558e1e",
      "members": [
        "1b943fa2-7492-4be5-baba-7b276458d36c"
      ]
    },
    {
      "cluster_id": "619f9470-2786-4c4b-9f38-8e5494785aa1",
      "members": [
        "57f00d8f-79ab-4e3f-8432-c5cd5b080a3a"
      ]
    },
    {
      "cluster_id": "21ccf4a0-84dc-466f-876e-46fb9c86c380",
      "members": [
        "82f8df41-62a4-4c60-b1e2-3bc51397ef77"
      ]
    },
    {
      "cluster_id": "c442364e-9f75-4af3-92da-fc9202b13019",
      "members": [
        "42f69999-16fd-4192-8a90-6f4a9bddb2cc"
      ]
    },
    {
      "cluster_id": "bf2b7ba7-a6da-4f7a-bc58-63ae1a3267de",
      "members": [
        "54fa120c-bf41-4acb-b703-c002ce29bfab",
        "e4684dd9-7a98-4f31-a99d-dd05c67773bd"
      ]
    },
    {
      "cluster_id": "4c182f86-5af5-4552-bee7-286b991ac0b1",
      "members": [
        "9dc120af-a0aa-4d5e-aef0-3f64615ce66e"
      ]
    },
    {
      "cluster_id": "53a74c73-495d-4f2b-8724-c28415d16065",
      "members": [
        "857d79b5-d04d-4378-b6e2-21108e81bec5"
      ]
    },
    {
      "cluster_id": "076ca314-f50f-433c-a148-2b657f0a88ab",
      "members": [
        "c024f0d5-d740-4ee7-b9e9-22987e13f9d0"
      ]
    },
    {
      "cluster_id": "cdca7f1c-2f77-48ee-ab2a-8828f905776a",
      "members": [
        "ddf9fd9b-4935-4514-8aa2-b4fba931d670"
      ]
    },
    {
      "cluster_id": "163b9274-a266-4214-8b63-6426a20ca29b",
      "members": [
        "396eedea-a0df-4b80-92de-3d9452c164c8"
      ]
    },
    {
      "cluster_id": "0a2a726f-5f3f-4312-a1f1-087729dc4991",
      "members": [
        "3fca0deb-dcca-4917-bbb1-c4081d0a8912"
      ]
    },
    {
      "cluster_id": "442ff222-51e2-4836-a92e-ab5d99d9d014",
      "members": [
        "eed0a2af-58e6-4bfd-b251-a9afdf857973"
      ]
    },
    {
      "cluster_id": "413ea174-815d-4e35-9f99-9c6c2ede588d",
      "members": [
        "b95db0c1-f08e-47e0-844c-fdcad8e31dd5"
      ]
    },
    {
      "cluster_id": "2148fe37-01cd-4114-a714-3d111387b22d",
      "members": [
        "a6bd6b25-ba3d-4850-b5c2-8e0287cff121"
      ]
    },
    {
      "cluster_id": "b866ed85-f7f0-43c6-a093-04cf15808999",
      "members": [
        "4aca75c3-c165-4f17-843f-046db2679cc6"
      ]
    },
    {
      "cluster_id": "c1a9feb3-4c0b-486b-ae22-214c44a6619c",
      "members": [
        "8f7c65bc-aaa5-4afd-afb0-4e3edfa22f58"
      ]
    },
    {
      "cluster_id": "1fb4e8e5-4760-48f4-95b8-9dd118893a35",
      "members": [
        "4af8450d-2bb0-437b-8014-0cd241e50d77"
      ]
    },
    {
      "cluster_id": "f85fc07c-cf3e-43c8-9d67-6a3594e4fc3d",
      "members": [
        "0534fdf6-a82b-41fc-b06d-21e023f1ea24",
        "c29e77b6-be2b-4ba7-85e6-435b4a27cae4"
      ]
    },
    {
      "cluster_id": "ea0b1b6a-993e-4153-b0a6-ac182d884071",
      "members": [
        "86a14342-af6d-4056-aa63-8dcd47006a73"
      ]
    },
    {
      "cluster_id": "8d281258-aab1-4ac7-9451-b7a3fe4c46e1",
      "members": [
        "164abe24-6e10-49b3-ba08-593644130278"
      ]
    },
    {
      "cluster_id": "4027d10f-7288-4413-85e7-b5b47209b817",
      "members": [
        "028b5959-8bc5-46f0-809d-c6469b06172d"
      ]
    },
    {
      "cluster_id": "8d5cbaf2-a64f-4a10-8901-a0b4a2c4582f",
      "members": [
        "55bb880b-433a-4f90-85b9-1938e89ba0cb"
      ]
    },
    {
      "cluster_id": "85fa8f6e-2724-474a-b5e9-bb6b9d49d126",
      "members": [
        "39f5ed96-dc5f-4d39-839b-6d6e5c18be9c"
      ]
    },
    {
      "cluster_id": "48881067-b084-4793-b8c7-6423be69c261",
      "members": [
        "4fcc8039-7dd5-48b5-b18b-3c35026981a3"
      ]
    },
    {
      "cluster_id": "9997ff9b-fea6-429f-b5df-1f0640f5b200",
      "members": [
        "22c8c250-6974-4ac0-a7bc-85c57fa97817"
      ]
    },
    {
      "cluster_id": "ee8407f3-3b78-41fa-b305-9976663fec3b",
      "members": [
        "b1bc7ef5-ba2f-4ac7-9441-542d10fb5d51",
        "15d90801-1802-47bb-85d8-7cf0a6dadba7"
      ]
    },
    {
      "cluster_id": "5ee42f7d-842e-4bca-a9c2-795ed9870897",
      "members": [
        "900f0d59-882e-48bb-8068-faadd341686a"
      ]
    },
    {
      "cluster_id": "802c356d-4c20-44e7-ba85-44dda5294d0b",
      "members": [
        "2409363a-85ec-4eec-b018-6d215e71357f"
      ]
    },
    {
      "cluster_id": "6cafd456-d229-4e09-abf9-1632d52f0462",
      "members": [
        "4fd10c59-57d3-4f84-ab30-85e11a35ae70"
      ]
    },
    {
      "cluster_id": "2697eb78-b9b3-4edf-8af3-5b14bcd8c383",
      "members": [
        "a0532d2b-b781-4d22-b19a-f140e497e286"
      ]
    },
    {
      "cluster_id": "da7d71b1-1db7-40cb-a127-20a20d4dc377",
      "members": [
        "62f432a4-e789-437b-ad39-5d0879fde1b7"
      ]
    },
    {
      "cluster_id": "a61f9905-7bda-4da1-b019-fbc601e92e05",
      "members": [
        "ec45dd9c-8476-4ca4-8716-3447aeaaff68"
      ]
    },
    {
      "cluster_id": "88531805-ef1f-409a-a41f-4692202b9686",
      "members": [
        "d7517e48-9bd4-49ba-8321-6ae9a929e42a"
      ]
    },
    {
      "cluster_id": "a5d764cc-6bfa-4c0a-bd16-68401768ed12",
      "members": [
        "83e941d2-2d4c-462a-ada6-2662be655124"
      ]
    },
    {
      "cluster_id": "21b3b67f-1874-443c-9458-d23200b40680",
      "members": [
        "023a3a03-92bd-4dfa-b4d8-ed4ca639438c"
      ]
    },
    {
      "cluster_id": "f6d51725-748d-4605-90f1-5a35204e66b9",
      "members": [
        "4355567f-f64b-428f-940a-54888926dacf"
      ]
    },
    {
      "cluster_id": "b7c58dbe-be1c-46e8-b987-6a07d4c0753c",
      "members": [
        "2d7d05b8-6a8b-4471-896c-1e99aa152da9"
      ]
    },
    {
      "cluster_id": "9a51f01a-20e0-4f51-8758-8480254254f0",
      "members": [
        "2f787b43-5648-40b8-af1a-ce6489975e0c"
      ]
    },
    {
      "cluster_id": "bf9a8cce-4cc9-4b37-881c-ca94d761d671",
      "members": [
        "fa2510b2-5e3f-4313-95b0-2440af717372"
      ]
    },
    {
      "cluster_id": "bbc52822-dc9f-42d5-a92f-f6eef341a6a2",
      "members": [
        "c13298b9-61bd-4a7a-96f1-e75eb5933ea9"
      ]
    },
    {
      "cluster_id": "a2109d36-1708-4075-ac3d-fd40a7eea59b",
      "members": [
        "b18559d0-6625-4df8-84f6-d6b9f030e6f1",
        "37e8e1cb-3b0a-4a97-ae1a-1e27ff54f208"
      ]
    },
    {
      "cluster_id": "ff62f156-1b54-448d-8c41-0514a58493a5",
      "members": [
        "7f59b6be-620e-4011-a17a-e99f10acfed5",
        "3ac93f54-f31a-40c2-9c9f-89c85be55235"
      ]
    },
    {
      "cluster_id": "bd072c00-533b-4c4a-918b-097a11abe63b",
      "members": [
        "df28a2d0-2357-4af3-a4f5-b4f636d4887c",
        "e4816de5-8656-4e3a-8adb-cc3827118755",
        "d4666577-80d5-4393-af93-c3c07c2fd745"
      ]
    },
    {
      "cluster_id": "76b14a04-38e5-4c33-90b7-69079246c4ac",
      "members": [
        "6d57745f-f537-4a34-9959-ced8d105f77c"
      ]
    },
    {
      "cluster_id": "1da0b887-e497-4790-9c97-6324fa7f1453",
      "members": [
        "e8111f10-d07b-4362-a05c-fd60042d4a9e"
      ]
    },
    {
      "cluster_id": "f8fb52b1-aa75-4179-86fc-79c103280f3b",
      "members": [
        "29a4e505-4099-47a6-998e-2154a79c4650"
      ]
    },
    {
      "cluster_id": "de50b1b9-cb34-4bb1-b3ae-d6dc4e19797d",
      "members": [
        "cbc20e83-8597-40f4-a223-ff847caa8763",
        "cf7aabbd-5f45-4051-a00f-aaaa4b74a45d"
      ]
    },
    {
      "cluster_id": "ae3d775b-868a-48c9-b712-67b58ccbee8a",
      "members": [
        "c73d8b2c-c98d-404d-b0eb-4e7f458a1c68"
      ]
    },
    {
      "cluster_id": "810e8947-ee09-42d3-8a66-c23cbae93d9c",
      "members": [
        "265d0497-7c7f-4aaa-97e5-c3e3f9b9a5d9"
      ]
    },
    {
      "cluster_id": "636f9424-425e-404f-b45f-941b15951311",
      "members": [
        "9021bbcd-8ce7-4eeb-91ac-db6bedfae0f6"
      ]
    },
    {
      "cluster_id": "913d6094-0602-4c9d-90e4-9e574b9a8080",
      "members": [
        "dc87d64e-7133-4ab2-9822-5b4dad563276"
      ]
    },
    {
      "cluster_id": "f1ae2273-40a5-4bb6-b66e-75189e06260e",
      "members": [
        "b5c3dfbe-a902-4930-9123-0e9d9bfb1f9b"
      ]
    },
    {
      "cluster_id": "a16ccc88-94c6-46a6-bbdf-ea9f1e6f5d27",
      "members": [
        "305f1c79-5f44-45b3-8aad-5c5125a53dda"
      ]
    },
    {
      "cluster_id": "58be16fc-1f91-4a69-b73f-64ff2035e54c",
      "members": [
        "947bd4ad-0681-4fcd-917e-bf454d698358"
      ]
    },
    {
      "cluster_id": "f069a0c9-4a52-495b-8bf9-3f4d61e51c06",
      "members": [
        "86a5d119-e0d3-4b14-9574-eff13e1bba20"
      ]
    },
    {
      "cluster_id": "b799c029-2c45-4feb-9700-47996ca8a80f",
      "members": [
        "fd1ae651-a295-4fb7-aa7d-e0c20925c0b3"
      ]
    },
    {
      "cluster_id": "1edce2b9-2c90-4e50-8469-6e4fab4fa23c",
      "members": [
        "0ce6df1f-de08-4e37-81dd-b059d2f9a721"
      ]
    },
    {
      "cluster_id": "fa749b08-cff6-43ee-a52c-6c982c75d42a",
      "members": [
        "3813ea57-62ec-4431-980e-559b659d3259"
      ]
    },
    {
      "cluster_id": "9528f35d-9b68-417f-b3ed-2c5b3d1cbe83",
      "members": [
        "9376e72a-49a8-4fed-9912-59965f0d4884"
      ]
    },
    {
      "cluster_id": "8d7a2b69-1f50-474a-969f-950408a29268",
      "members": [
        "5c8cb8c9-8ece-4977-bcbd-d2e4cffc1a57"
      ]
    },
    {
      "cluster_id": "71b00bc6-170a-45b7-bfdf-40d740e90b1e",
      "members": [
        "caef5161-88f8-4f7b-b0bf-bac754f2b8b4"
      ]
    },
    {
      "cluster_id": "de89e6b7-8aa5-4a9d-b8b1-927da0ac9c8a",
      "members": [
        "35e13dd4-e5b1-46f5-9779-5910c9c89ff4"
      ]
    },
    {
      "cluster_id": "8822fa56-959e-4020-ae70-4e0f3f35f8fb",
      "members": [
        "bb4557ee-951a-432e-aeb0-b7ac0227446f"
      ]
    },
    {
      "cluster_id": "48b7513c-41a4-4a7e-876a-36f9b1eed5df",
      "members": [
        "f9cbbdaa-f4dc-4f8e-814e-576477baa645"
      ]
    },
    {
      "cluster_id": "16bcd20b-c8b6-445d-b90e-bca2498ccc21",
      "members": [
        "fbd73d33-2ca0-4697-9ee8-edf14741a73f"
      ]
    },
    {
      "cluster_id": "115fb915-b1b2-4ede-81d0-20680b7749d3",
      "members": [
        "c2d956be-c010-4d63-8ca4-73abb047cd6c"
      ]
    },
    {
      "cluster_id": "a1f52faa-345a-4142-abf0-5bc06a645050",
      "members": [
        "4870f0af-991a-4d27-a5f9-cef54f4d7d80"
      ]
    },
    {
      "cluster_id": "6870e10f-72e4-4775-9bf6-5b40e5853931",
      "members": [
        "09cd458a-ad60-4918-b2d1-344d0996dbf0"
      ]
    },
    {
      "cluster_id": "f9418d59-cbad-4bcd-b387-fb25a67389fd",
      "members": [
        "ec955636-b8ce-43b4-bdb6-4b52b0f60f67"
      ]
    },
    {
      "cluster_id": "7b1f2cfc-5328-4132-ac99-4d91818f60f6",
      "members": [
        "8a6f7da5-6f97-4723-b387-160cd81f8eaf",
        "816a5a49-d869-42ce-80e4-5a2519321ae8",
        "86c1ce58-0a09-4472-aa59-6b6e3cde7f37",
        "abf56087-ecd6-4e4c-ae65-1897149ad7e8"
      ]
    },
    {
      "cluster_id": "e5da69ec-b7e5-4fec-8bae-3161bd3d02ca",
      "members": [
        "fe0ab7d0-5acf-42f6-8d11-4410eb81005f"
      ]
    },
    {
      "cluster_id": "0c283d46-2055-4ab8-8bbf-4417f6667e86",
      "members": [
        "70741f36-330a-4765-a621-855856897516"
      ]
    },
    {
      "cluster_id": "aecd93e3-f175-4964-b3d0-1a8c1e2832bd",
      "members": [
        "901090a6-06b9-4600-b248-c7bc52f2b33f"
      ]
    },
    {
      "cluster_id": "87bd589d-2421-4528-b337-18cde30c4d49",
      "members": [
        "391f37e2-a85d-4207-991b-bc64b2b1d453"
      ]
    },
    {
      "cluster_id": "58061e14-9c6d-45ae-8c7f-48a44c7f7cb0",
      "members": [
        "73bbc6b1-7507-43c5-b47e-df9f5a3fa756"
      ]
    },
    {
      "cluster_id": "276946c6-5e3d-44d2-b7e3-410789a74a81",
      "members": [
        "e4614d97-76f8-464c-87e9-5e00cd0e98a0"
      ]
    },
    {
      "cluster_id": "4485e5d3-efcb-4d42-a185-349293bfd550",
      "members": [
        "2df72a4e-2d4e-4310-8419-dd7b8caee3ae",
        "b1a14284-7971-48a7-af1e-919877929a63"
      ]
    },
    {
      "cluster_id": "7f659049-c3cb-424c-9dbd-559d942783fc",
      "members": [
        "12287211-b799-467b-ac65-9921283f2620"
      ]
    },
    {
      "cluster_id": "060c1552-a1b7-4db4-9a85-766d6baf3560",
      "members": [
        "ee8a9520-1592-4aa6-ba78-e6d3348a11c9"
      ]
    },
    {
      "cluster_id": "22e69426-c76f-4b85-bc81-16af4106a7bd",
      "members": [
        "e4a17a8b-1a7c-4da0-9e91-f1c49111ee2f"
      ]
    },
    {
      "cluster_id": "6c942642-582b-452c-868b-03a353a6eca9",
      "members": [
        "942c17a3-a28c-48b2-8150-0f346cb8a272"
      ]
    },
    {
      "cluster_id": "7b4680b9-9676-4736-8ed2-d06a2da6ea63",
      "members": [
        "5d144e6c-0172-4295-85b0-d471a3a7359c",
        "0ace144a-883d-455f-a69f-7c95f297209d",
        "0151bbcd-c972-42d3-b86b-cb399c6266fa"
      ]
    },
    {
      "cluster_id": "b9db86cc-1622-42c5-b482-396c3c7c7bf5",
      "members": [
        "f3edd9ad-4e7a-42e5-8560-e4a8141035fe"
      ]
    },
    {
      "cluster_id": "bf638672-92b8-4f28-a31b-d9a286145b07",
      "members": [
        "dbb7b443-25c7-4477-97da-b099f151c261"
      ]
    },
    {
      "cluster_id": "442786eb-7f1c-4cbe-a22b-05ba612dc67d",
      "members": [
        "17f13200-d0c9-4962-867c-9258ba566722"
      ]
    },
    {
      "cluster_id": "a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4",
      "members": [
        "ca06531c-e8d4-44b4-ba96-588241c99fb6",
        "2cbd592e-9b27-43bf-9981-257b2c95850a",
        "a00993e4-3a22-4689-a941-c00084c02859",
        "43f76c7d-f08f-461f-a904-091ec5f12488"
      ]
    },
    {
      "cluster_id": "dc5ed306-20f0-45cc-ac9b-9241d0460c7d",
      "members": [
        "62394e44-2e3d-4879-b2f4-addda51d3474"
      ]
    },
    {
      "cluster_id": "b1c61f13-8002-4105-a62d-ec7191746e29",
      "members": [
        "363e6fcb-13c9-405b-ae89-318d01bdd863"
      ]
    },
    {
      "cluster_id": "9f4c8f09-a6ba-4b36-a260-db32b470a2b5",
      "members": [
        "6d1072d3-bdb2-4476-816f-6ec12e977fca"
      ]
    },
    {
      "cluster_id": "c56ca589-59b3-4908-bbf1-fd162bba08a0",
      "members": [
        "b4480d63-fe94-4e57-99a7-30518a54dae6"
      ]
    },
    {
      "cluster_id": "d14dd6b6-ea0d-4827-8ef2-ba250811ea5a",
      "members": [
        "bd644c9c-610f-4fdd-aaa2-9b1398d9bfd8"
      ]
    },
    {
      "cluster_id": "88549cc5-91d9-499e-9367-819f2a75e847",
      "members": [
        "98342ee6-0977-4f0c-a3dc-0e09f0b6f30c"
      ]
    },
    {
      "cluster_id": "36d77123-4871-42ae-b0c9-6b46e2bd9d65",
      "members": [
        "17b5c061-8a0f-4741-9e55-8350b0a6f7a8"
      ]
    },
    {
      "cluster_id": "e92ede91-314d-4f91-a23e-b6bfa200e224",
      "members": [
        "1c0e90be-fe07-4fb5-8eca-8fa4a9d63345"
      ]
    },
    {
      "cluster_id": "bac9b430-6b59-4b93-ba97-75f0f7b39814",
      "members": [
        "ee3fe76a-6f8c-4313-8914-17a0cbce118a"
      ]
    },
    {
      "cluster_id": "5b9f78e0-35e8-4e52-9ba4-34ecb628f952",
      "members": [
        "2fbadc7f-0a31-4d3b-974a-62946d1fa866"
      ]
    },
    {
      "cluster_id": "25ed23a4-7940-477a-9165-7053b4f9330d",
      "members": [
        "9e1033af-514d-40d9-8043-bfcb5559e972",
        "459611c4-0b55-4923-91d6-d7adcad302d1"
      ]
    },
    {
      "cluster_id": "3a95c736-dd02-4122-9108-f00df86397af",
      "members": [
        "390a0f6c-3271-4d89-9def-b9099ca6d093",
        "fe6f6fa5-3c2e-4e35-aa6a-0adf5b433b80"
      ]
    },
    {
      "cluster_id": "5fd9694e-e9ba-4a5a-99d6-b32c720bbf4e",
      "members": [
        "f7447847-d7cb-43a9-bf6a-2a34237e6243"
      ]
    },
    {
      "cluster_id": "96455f92-cde3-49f3-934d-a55b0a31ccd5",
      "members": [
        "4dc604dd-ff2c-4cb5-9485-c298aa8d6be7"
      ]
    },
    {
      "cluster_id": "9979222f-6af5-4d8c-85d9-81f2ad80980a",
      "members": [
        "e9685bf6-4435-496a-aad0-67339144be17"
      ]
    },
    {
      "cluster_id": "d4bc60e5-da16-45c3-909d-aa14379adeb2",
      "members": [
        "3cb10e35-b70a-4e35-9bc8-0b6323028162",
        "f648189b-ffd4-42ba-80ab-e7d0cb4e0d27"
      ]
    },
    {
      "cluster_id": "789c4f9a-6863-49ee-a41c-e12949429992",
      "members": [
        "ac28e2ea-de98-44db-b15f-8efda41cf373"
      ]
    },
    {
      "cluster_id": "86797f95-8265-40b4-9a2e-f9574ce9ab8c",
      "members": [
        "5b48e9a1-a870-4978-bcd4-60d8b4a01145"
      ]
    },
    {
      "cluster_id": "ce551d12-b33f-4043-8ad2-015e698a2cda",
      "members": [
        "09d00e6f-03c7-4256-a351-aa6ba0bb64b7"
      ]
    },
    {
      "cluster_id": "6e9ec51a-5e5f-4dab-8bcb-01b5c15fb587",
      "members": [
        "5602e897-4263-40db-983e-f751d1289418"
      ]
    },
    {
      "cluster_id": "c2d29a8c-d30d-4b99-9286-81917e79d3dd",
      "members": [
        "7bc04a5a-2610-492a-bd4e-6ac4c4efab63"
      ]
    },
    {
      "cluster_id": "ed35c2c7-9d1d-46bc-b509-54389b90afc9",
      "members": [
        "0d1a7174-88e9-498e-b1d4-e1f4ae813e1d"
      ]
    },
    {
      "cluster_id": "917875db-927e-4ac1-93db-6f7a0fd24bc3",
      "members": [
        "f6fd9164-7b07-4ac8-9eab-636f169adbdd"
      ]
    },
    {
      "cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff",
      "members": [
        "6d45de8f-261e-4b0d-9624-00564698fef8",
        "17726f06-0a1b-4e84-a2da-8c4383fc6422",
        "70ace6f5-ba45-4bcf-8217-e6dd2bb2b27e",
        "4e312d90-6877-4ad1-a1c5-7420a43c99a7",
        "630ad209-9fb0-4b78-88c6-e02f76c0fc74",
        "5462430f-9209-443c-bf3f-61c34bb63bea",
        "204e0cc1-634d-4ed1-9f7f-d97c784c7c31"
      ]
    },
    {
      "cluster_id": "e5868b04-4cec-4d02-b896-8db4cc7180db",
      "members": [
        "a2e6496a-27dd-43d6-bf2e-e6e5d3f3233a"
      ]
    },
    {
      "cluster_id": "61c6513c-5b59-4c49-919e-b92af19239e0",
      "members": [
        "3dbd115e-607e-4c28-a5ec-5ca4c7dac23a"
      ]
    },
    {
      "cluster_id": "03e89563-d271-4f75-a47c-92ec9575e524",
      "members": [
        "c176ebce-1701-4035-ba6a-31ff5c47e475"
      ]
    },
    {
      "cluster_id": "6dc5280e-6875-44c0-adc9-079542d2d0b2",
      "members": [
        "7cb1e360-e3e6-43be-a1c2-4df98a02568d",
        "d130f78e-0f60-4aee-a423-c35f5aaa102e"
      ]
    },
    {
      "cluster_id": "08dca077-8e26-493a-9038-2f3ec565da5b",
      "members": [
        "e34a708e-7958-4919-bfbd-a00065d97651"
      ]
    },
    {
      "cluster_id": "e1ec3ffd-db25-4cb3-96fb-b11f7546206a",
      "members": [
        "451fbd13-5ece-4d53-b46e-c6816efe2135"
      ]
    },
    {
      "cluster_id": "6f00b5de-be1b-4233-883c-1a484844dac3",
      "members": [
        "7731b716-ba63-4fa8-a146-9875413ac64e"
      ]
    },
    {
      "cluster_id": "2db0c2dd-c8a4-4511-9c67-695e43307f50",
      "members": [
        "f9430af8-c65d-4712-bf56-6735831ab122"
      ]
    },
    {
      "cluster_id": "45df4bbb-00df-47af-9d05-1da924dfb782",
      "members": [
        "b1359cf2-e916-4c3b-951e-dbcfb91228b8"
      ]
    },
    {
      "cluster_id": "220dfe6b-2774-4a8a-8306-3094dfce156d",
      "members": [
        "36cfd210-d06b-405b-9f24-0b95636db2a8",
        "66349fdb-aedd-4e71-bc33-b55b90c3a03c",
        "53f6ba38-107e-4a6a-8496-19ed4d5c8d9c"
      ]
    },
    {
      "cluster_id": "4d37159d-0a18-4557-9e9a-a0401bd9cb08",
      "members": [
        "1bb7068b-f675-4d37-8b29-eb4ac7b27ab8"
      ]
    },
    {
      "cluster_id": "e8e474c4-3709-41ab-99a8-21deaa3d6742",
      "members": [
        "08832f1f-1e9d-4560-bcf1-086be71ff254"
      ]
    },
    {
      "cluster_id": "c75d014e-008e-44c1-909b-263543a31c5f",
      "members": [
        "ce180f9a-7b6f-424b-890b-5c098fcd67e7"
      ]
    },
    {
      "cluster_id": "63342b93-bff9-4530-8c61-5a3714d544f1",
      "members": [
        "b9122ba0-8bf3-4d37-be60-68c9a8e6d891"
      ]
    },
    {
      "cluster_id": "2b2effa3-cad0-4ecb-9486-b078278fd3ff",
      "members": [
        "94029f94-bfa4-46ce-85a1-102fb3438ebf"
      ]
    },
    {
      "cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe",
      "members": [
        "8de55777-91cc-4500-8eb9-00391cfd1996",
        "828a1401-a9cd-4280-b0e0-d6113ee19bfd",
        "716847ee-a725-462c-a6c0-1f9b9b407538",
        "60ef0746-59f8-4545-b93a-25210ec76915",
        "0c6e5fcc-3e05-4d45-9517-055b88d7fcf2",
        "2b6a207f-016f-41c5-b2cd-490c79cdd5ed",
        "6a9e9c87-d858-412c-b112-3e45da1dbdab"
      ]
    },
    {
      "cluster_id": "513bd779-ed11-4772-ba36-c123bfde18a2",
      "members": [
        "b30a890f-bb1e-4dcf-8f4a-7da32d5fd2ec"
      ]
    },
    {
      "cluster_id": "1a910fe4-be3d-49ad-b59c-8197b841f3b0",
      "members": [
        "7c48ff9c-3572-4d1f-af8d-a28071ad3e88"
      ]
    },
    {
      "cluster_id": "49a61bc5-5b56-4867-98aa-feebd5b63106",
      "members": [
        "c604a848-73e4-47d9-911c-ab0b2f44f9ad"
      ]
    },
    {
      "cluster_id": "2b9f39b1-41ca-4c32-b583-29e0cbea9865",
      "members": [
        "130c0ed0-197a-441a-affe-5b87f347f7a4"
      ]
    },
    {
      "cluster_id": "27647283-49db-4a69-bd08-66190d0e650e",
      "members": [
        "b76a8e41-ea5e-46ab-8afd-273b69e724d7"
      ]
    },
    {
      "cluster_id": "d94203eb-6224-4f4f-ab68-6b9b570a960b",
      "members": [
        "77e135a3-c11f-4f48-b351-38a792b72478"
      ]
    },
    {
      "cluster_id": "b67dd1ae-27f1-42b9-ad69-ee83a298d216",
      "members": [
        "91496a2d-e3b3-4b43-9df6-217b8662cc7f"
      ]
    },
    {
      "cluster_id": "3531210e-caae-4d2a-9c81-92659900742b",
      "members": [
        "96c7ba3e-250c-4e59-a015-d908813b2161",
        "c12ca3f8-34f3-4cef-a02d-9a0b67614a19"
      ]
    },
    {
      "cluster_id": "9c8fceaa-2d0d-4f1b-a084-86587c4a2652",
      "members": [
        "48fdf656-134e-4e2f-947d-ab46a493fe4b"
      ]
    },
    {
      "cluster_id": "a9f4e598-1ac2-4a32-9af3-12230870507a",
      "members": [
        "c7031f37-932e-4f20-b1f0-ad805c418d7e"
      ]
    },
    {
      "cluster_id": "b680d78a-6796-4b44-a00b-5861ed074dcd",
      "members": [
        "4678a09c-7907-45d5-bc3c-1cf48fe82a4e"
      ]
    },
    {
      "cluster_id": "916a8c6f-5ca2-4b3a-b949-ca57daf6bb56",
      "members": [
        "320d06c2-1801-4f37-832c-c689ba25fa8b"
      ]
    },
    {
      "cluster_id": "fd5e9a15-8177-47a6-9a10-ec03f47d5abf",
      "members": [
        "3bfa0b44-82e8-46c4-baec-c2540f1c85b5"
      ]
    },
    {
      "cluster_id": "a644befb-dbc0-4695-b3a4-09f27c71e3c4",
      "members": [
        "9c0a5f5b-884b-47d0-8a88-2fc8c6138662"
      ]
    },
    {
      "cluster_id": "a1921f6f-8530-42a9-8f36-9fbcf1bb8941",
      "members": [
        "7f844310-acc5-4a3f-92f1-abac2e63d440"
      ]
    },
    {
      "cluster_id": "8fea2c95-9eb5-4a00-9f7e-750ec49f4c61",
      "members": [
        "8504e0ca-b54f-4a5b-9b47-cf9d1a45fb89"
      ]
    },
    {
      "cluster_id": "ce77bb3a-ea7f-4d98-a5e3-62e70b0597ed",
      "members": [
        "c1415165-6ad5-4522-a309-629f404ef316"
      ]
    },
    {
      "cluster_id": "25337f06-7f63-4f2c-9964-5f855922e638",
      "members": [
        "d26c872a-78d8-4320-b5f2-e0033b5b2abb"
      ]
    },
    {
      "cluster_id": "211a5b9b-b352-4fd9-9450-827ad138f833",
      "members": [
        "ad99cdd7-f0b0-4d1c-93b7-1d96068758a7"
      ]
    },
    {
      "cluster_id": "53924b3c-7098-4daf-8924-cb5ffede2096",
      "members": [
        "cb7405f5-b619-4f66-9b7b-4d562a8fc6d6"
      ]
    },
    {
      "cluster_id": "fe89ddfd-a999-4814-9bd3-b0162af3bbe2",
      "members": [
        "d886f5bc-664c-429c-9754-67530af6439e"
      ]
    },
    {
      "cluster_id": "bc25c1b6-b24d-4cb5-9913-b54d305182e7",
      "members": [
        "b412355e-81dd-48f3-a462-70fd74d23a27"
      ]
    },
    {
      "cluster_id": "d1e65b2e-ba15-4227-ab25-8486cb852ba1",
      "members": [
        "0ec94a00-7242-4423-b564-9baf54723262"
      ]
    },
    {
      "cluster_id": "ce2516ca-003d-4806-948a-12eea340aa15",
      "members": [
        "1276b48a-4aa4-4922-aef4-4f038cbfbb97"
      ]
    },
    {
      "cluster_id": "fc4a44e4-cde7-4210-b1dd-064e7cdc5fc4",
      "members": [
        "f6bf258c-c08e-4db5-9460-a91e3e5f12c9"
      ]
    },
    {
      "cluster_id": "208620ac-11d0-4163-9345-03d59e805961",
      "members": [
        "ffd7678d-00ac-4300-868a-ef2229fb89f9"
      ]
    },
    {
      "cluster_id": "134817e7-d143-434d-b8ad-1fa05e622296",
      "members": [
        "427c91a8-7ad7-4918-a7dd-f76a14ce3b91",
        "039940c2-8769-41b6-8e24-bc42bd2df3fe"
      ]
    },
    {
      "cluster_id": "d147629e-d16f-4224-83bb-da1109733168",
      "members": [
        "a779aee6-ebd1-4097-a98d-ba7a139404a4"
      ]
    },
    {
      "cluster_id": "dac94ab4-f251-4e9f-88eb-38ea10c9b12a",
      "members": [
        "ffd49188-632d-4b7b-a9e5-5a53a52c624f"
      ]
    },
    {
      "cluster_id": "3e73f675-0024-47f1-ab95-a4e974bdd22b",
      "members": [
        "af0f83b2-a044-45d7-a820-3b7af9266a72"
      ]
    },
    {
      "cluster_id": "f287b9aa-9568-4d24-870b-96f86f040792",
      "members": [
        "69107281-2506-4b5d-ad9c-33de7589fcc9"
      ]
    },
    {
      "cluster_id": "6d479b93-5e42-43ab-8ac4-7f31b557309c",
      "members": [
        "659d2172-0bd9-48a1-bd4e-33d1367d832a"
      ]
    },
    {
      "cluster_id": "fc55be0d-bed8-4ebb-8dc7-149fb174476c",
      "members": [
        "835dff59-f9d8-4192-9930-64aaadcaa5bb"
      ]
    },
    {
      "cluster_id": "094c0c48-56a8-4f19-bf5d-16a053900cf5",
      "members": [
        "a1458d74-452e-4b95-854c-fd6204bfd7ae"
      ]
    },
    {
      "cluster_id": "6ebfced0-5146-4720-a35b-6dac63f2989a",
      "members": [
        "1e3994e0-1d0d-49d4-9d43-09c8589b99ad"
      ]
    },
    {
      "cluster_id": "2c113efd-6d03-4fd4-9d94-78125d3c286d",
      "members": [
        "94eb1e79-dfe0-47e9-94f8-ff7b6b531e28"
      ]
    },
    {
      "cluster_id": "70ddc119-0fe5-44bb-b12a-5f9fe097cd8c",
      "members": [
        "52f824fc-6777-4d31-ae8e-0b0d83e13dce"
      ]
    },
    {
      "cluster_id": "2156a4b1-8617-407a-8feb-cc3b74e8fec4",
      "members": [
        "57aab8ea-02d6-4c09-b173-144d4f8c9012"
      ]
    },
    {
      "cluster_id": "c99071d0-4f9f-4d85-a471-8ed03007f96c",
      "members": [
        "515aca24-3240-4fc9-8782-c2e7439ec022"
      ]
    },
    {
      "cluster_id": "d316d167-369a-4e0d-ad58-337551778176",
      "members": [
        "863817b6-14dc-4206-bcc9-a6f86320d92f"
      ]
    },
    {
      "cluster_id": "d2bc0c3a-3d51-4a76-89f5-0aef4a862a3f",
      "members": [
        "a3460dbc-2bb3-468e-ae47-1048dcc494b8"
      ]
    },
    {
      "cluster_id": "b4a34e37-e56c-45d2-8766-c4fab9d7cdf4",
      "members": [
        "c2044de8-6008-4dae-b756-39e02b4f336d"
      ]
    },
    {
      "cluster_id": "a0b134b6-d0a8-434f-86d9-01697dedcb90",
      "members": [
        "98b91f13-53ee-4bf1-a84f-46cbdbe22cfe"
      ]
    },
    {
      "cluster_id": "6afac47e-4bb6-44d8-a1c9-b3063690939e",
      "members": [
        "c1a8afb9-3dd3-4d26-b831-94baea535cff"
      ]
    },
    {
      "cluster_id": "c058e393-ae39-4d59-9d56-d80b61d507dc",
      "members": [
        "1af3f1f6-7fc0-4f65-84c9-ab73efc8a94b"
      ]
    },
    {
      "cluster_id": "d1afbb7a-8d2b-4c24-9c70-b4c56fd56a43",
      "members": [
        "ebf309fb-72f4-4aa8-9fce-de1b2954f161"
      ]
    },
    {
      "cluster_id": "c79c59f4-8dd7-4aa0-bc2d-7d52bf8727f3",
      "members": [
        "a78a0d1d-fb23-486e-8d7c-31e54b1f6b80"
      ]
    },
    {
      "cluster_id": "65324661-3a29-437c-9b4b-f8ea61a6dabf",
      "members": [
        "19c3bba1-fa0a-46fa-ba1b-60b9d8ea36cc"
      ]
    },
    {
      "cluster_id": "141e6842-296d-43da-b53a-06cadf04679a",
      "members": [
        "9e25fe9c-a7fb-4089-b0ce-b5450684df86"
      ]
    },
    {
      "cluster_id": "7378ad43-a016-4ea8-a115-0123a4bd291a",
      "members": [
        "138a0535-0d17-4fe8-8ae1-2165b21e315c",
        "6a39f53a-dbbc-49de-a3d5-8a727b162557"
      ]
    },
    {
      "cluster_id": "09116da3-a819-4889-967d-7f1f71fd03cc",
      "members": [
        "8b7f373b-537a-4a7c-9177-bce487373ca9"
      ]
    },
    {
      "cluster_id": "1760a439-ca46-4fac-8653-21cfe35d860c",
      "members": [
        "25469249-14a0-4d3c-b927-3fcd39e306b8",
        "951a6889-48e1-4ae7-9de3-f25591fa9d6b",
        "c26143cc-60dc-4cc5-85f5-ea1998788b28",
        "865f4db0-ac94-4b66-8fe3-5e5997b63fb1"
      ]
    },
    {
      "cluster_id": "da21d9c5-68a7-4237-9343-1a8df452b146",
      "members": [
        "b9f61132-8496-4398-a695-fd09dcbf8995"
      ]
    },
    {
      "cluster_id": "e3403237-7c1c-4e7a-9604-df8d11301d8d",
      "members": [
        "aea49fae-06ed-4218-960f-84a8e7dff779",
        "aaa01355-379b-4cd3-b1f5-4111a86b3987"
      ]
    },
    {
      "cluster_id": "c5a76746-76c2-4937-b9a7-284d0de20709",
      "members": [
        "3b1ac5b5-c528-4a0f-96af-d9bbc0ad402f"
      ]
    },
    {
      "cluster_id": "83593077-334d-4f71-a668-e36e720c6a3d",
      "members": [
        "cef7cf93-eb17-4334-ad4b-619188793fd2"
      ]
    },
    {
      "cluster_id": "072ba410-0f15-42e7-9ef5-bee6285568c8",
      "members": [
        "ba6ff167-e8c8-40a9-9a84-61f53e1f342a"
      ]
    },
    {
      "cluster_id": "a263e3cc-09b2-4ae5-a252-4665ad483b52",
      "members": [
        "eeda927f-0cf9-4701-8464-ee83c49a371d",
        "89c39233-7f7d-4a37-ad84-11944dc610f1"
      ]
    },
    {
      "cluster_id": "113ba3fc-f5c7-4177-8c57-e763c91f7e2c",
      "members": [
        "bd99aeb0-773d-4bd1-a916-0b224aff6474"
      ]
    },
    {
      "cluster_id": "cbcdf7dd-2927-468a-83b8-036e8a1b1479",
      "members": [
        "a1d27647-8ea4-473b-a900-c1a08dcc2af4"
      ]
    },
    {
      "cluster_id": "71b309b2-2dda-4212-a921-75eae9813c5d",
      "members": [
        "a5fec585-45ef-4e77-acb2-44a4eb77e056"
      ]
    },
    {
      "cluster_id": "a7c0d5f2-2d5e-4a9e-bdf4-5365c1f262be",
      "members": [
        "a8e91066-2bad-4046-99e9-01080c342e9b"
      ]
    },
    {
      "cluster_id": "01284921-0773-415d-9ce4-f4e93b10a2af",
      "members": [
        "b18211ac-bc7a-480e-8886-4ea26acbfe0e",
        "5bf0bfe9-23b1-4f8f-831b-9226d131f1b2"
      ]
    },
    {
      "cluster_id": "8098cc1b-8836-490c-9e7f-17c6a8944eb0",
      "members": [
        "14644813-a1fa-4256-8100-1202ecc87880"
      ]
    },
    {
      "cluster_id": "247c6528-f0e7-49f9-99fb-27ef047a4410",
      "members": [
        "6aa42f60-59db-4177-9a34-b9d050386ad3"
      ]
    },
    {
      "cluster_id": "e25715ec-5983-4c68-b924-9f64b4f03d63",
      "members": [
        "43a98ba9-e0cc-46b6-b06f-d5ff92020ba2"
      ]
    },
    {
      "cluster_id": "ec825820-2066-4bfe-95cd-b11676c4d89c",
      "members": [
        "18fc5214-0e1a-4582-bd8e-68e7df91da5c"
      ]
    },
    {
      "cluster_id": "449fd6e4-9161-4742-8b9b-bd7cd0c9d571",
      "members": [
        "3c81b0a8-0ec3-44d5-9e23-b6886684a510"
      ]
    },
    {
      "cluster_id": "cd034398-fb5e-493c-9a4b-be08f05b5ca7",
      "members": [
        "9ed245ca-3c9a-4ee3-8019-4ff857adca60"
      ]
    },
    {
      "cluster_id": "1501c95d-fe6f-4129-965a-ccb56abb7afe",
      "members": [
        "05b4f83a-d62a-4bc4-8ac6-f243c3eca0ba",
        "3c9347df-8ffe-420e-820c-4842e49256f9"
      ]
    },
    {
      "cluster_id": "49feb97e-934e-4b78-b2c2-4acd4705e46e",
      "members": [
        "dbcf6044-164e-48b0-a8bb-9b20202a86ca"
      ]
    },
    {
      "cluster_id": "0208ef8f-f321-4a60-8e1f-9ae03308e345",
      "members": [
        "495f7684-da08-4796-a97f-20763a81934c"
      ]
    },
    {
      "cluster_id": "fdcc5ead-3f56-4e70-b1c1-bcb723b24f72",
      "members": [
        "07ef1c9d-9e02-48fa-894e-9aa9ac00825f"
      ]
    },
    {
      "cluster_id": "baa5172c-8725-4cca-b3be-5d512cf618a1",
      "members": [
        "ee64a014-2ae8-4581-af12-44746c5eac31"
      ]
    },
    {
      "cluster_id": "e7f6877c-917d-4e0c-ad46-e366c0fa0b67",
      "members": [
        "ab2f6972-f2b3-43ba-ad67-ccdea1dc15ea"
      ]
    },
    {
      "cluster_id": "74e4eccb-d37c-4913-a081-5e2a47430662",
      "members": [
        "9219490f-23d2-4d56-9e71-68248cfd250b"
      ]
    },
    {
      "cluster_id": "a1ca414a-357f-429e-a9a5-5290a87bd233",
      "members": [
        "b66fd564-56e0-4dbc-af75-4d728a3b595b",
        "fe75fa37-84c5-45c4-85a9-0b535ade106a"
      ]
    },
    {
      "cluster_id": "1e66818d-6709-4941-8387-4e813b228894",
      "members": [
        "cf1261a7-6ec6-4d9b-96a1-7fa516cb00ba"
      ]
    },
    {
      "cluster_id": "e24f9229-3672-4631-abf5-3ab616111d97",
      "members": [
        "8bdd3630-0b71-4a27-9152-988a27b64b02",
        "e70b9ad6-7291-4149-b3cb-9a37e8322e8e"
      ]
    },
    {
      "cluster_id": "9a1b07d6-f1d6-4b71-a6fc-885000909a93",
      "members": [
        "b22c5196-0753-459c-b19e-6a661a3c6cfa"
      ]
    },
    {
      "cluster_id": "bacd83d6-baf3-4811-8b78-eb961f99ab8f",
      "members": [
        "d5b40b40-4fd8-4809-825d-74c396c5e1c1",
        "2d56b4cc-06d2-42fc-96ec-29e8f62f2884"
      ]
    },
    {
      "cluster_id": "635b07ed-e811-4ba9-90cf-8c1aed9aaaa3",
      "members": [
        "17438dff-d991-4c0d-b588-21ff8e0929ad"
      ]
    },
    {
      "cluster_id": "1e7fb3ce-6e1c-49dc-978d-4116378d449b",
      "members": [
        "a0a3eef5-73dc-4c61-8d1e-ddc2688f0947"
      ]
    },
    {
      "cluster_id": "412eecdd-3e2f-4593-9b61-1dd3ac3a36fc",
      "members": [
        "738bdcc9-d4ba-4518-ae26-cd7d5fa251dd"
      ]
    },
    {
      "cluster_id": "71c1ae12-8809-47ac-8b8b-cc34ac436157",
      "members": [
        "b11c29a2-7c09-4c5b-914e-bdff2ac00a4a"
      ]
    },
    {
      "cluster_id": "9fe7995d-1f25-429f-b4f7-9af7bc4a7e8a",
      "members": [
        "c91771dd-4604-4c1c-9b41-f6f997180a75"
      ]
    },
    {
      "cluster_id": "988ceba9-18e9-4ef8-9eaf-742eb7f2a4f1",
      "members": [
        "310da8a6-11f0-4449-846e-b764c9debe0b"
      ]
    },
    {
      "cluster_id": "f0626ed9-6a16-4fce-b589-96b444b12fc6",
      "members": [
        "879b8025-cd29-49f3-b9bf-9b4eaa9be7dd"
      ]
    },
    {
      "cluster_id": "7628ae8d-befe-43ea-95f0-6fd9a907267a",
      "members": [
        "52a46197-0688-4cff-bec6-ee4af2d7945c"
      ]
    },
    {
      "cluster_id": "0c342dd1-f7b7-40e1-b189-103549ddece7",
      "members": [
        "366a6246-8c85-4924-b0d2-5b86bfc2c2d7"
      ]
    },
    {
      "cluster_id": "f200deff-bb81-4d41-8008-3dc621e11aae",
      "members": [
        "dfedbaec-39b4-4897-a75d-46aac34780e4"
      ]
    },
    {
      "cluster_id": "6904ee21-68e2-4e99-baa3-968e34cb10b1",
      "members": [
        "b421ab5e-bc05-4b8c-af63-8a7421ab0851"
      ]
    },
    {
      "cluster_id": "51ab0b64-787d-450c-9578-4158dfeb97cb",
      "members": [
        "c583f936-7449-4241-a0b5-700f8583bebd"
      ]
    },
    {
      "cluster_id": "a7246654-2dda-48ab-8372-7007a1d4709a",
      "members": [
        "0972955b-ece9-47bd-88c3-e8585e08f124"
      ]
    },
    {
      "cluster_id": "bf80dbed-695d-42ab-adf5-4b079e397c99",
      "members": [
        "68c3d94c-0fd4-4c94-8ee5-79c9666237b8"
      ]
    },
    {
      "cluster_id": "478586e7-cd47-4bba-a3e6-e954dd593a00",
      "members": [
        "9433cc9e-44dd-4514-a4e8-8df2fa8e65e1"
      ]
    },
    {
      "cluster_id": "ad7f3e47-f7f2-4a5d-8168-7644c3de8a32",
      "members": [
        "06d20d03-85c5-49c3-b962-c5d05ead6130"
      ]
    },
    {
      "cluster_id": "d265d5db-4035-43f0-bc76-bf5945ff3551",
      "members": [
        "436663dd-5aff-4330-ba83-ec791399568e"
      ]
    },
    {
      "cluster_id": "f2132873-f6f5-478c-99f7-99e6e3d16cc3",
      "members": [
        "28eb1db8-9fc7-4f38-83d7-6cbc590f3620"
      ]
    },
    {
      "cluster_id": "fa3326c6-c29d-4ee9-93ae-25dfe12b02b0",
      "members": [
        "1eed73cf-b401-4aad-b6fb-40dab881fd02"
      ]
    },
    {
      "cluster_id": "9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a",
      "members": [
        "cbcc4d41-e1a4-4631-9bd0-f44199ef2491",
        "b6853fbf-e30d-4aeb-929e-61d3239aca0d",
        "c5cd55fb-50c6-4f51-b2f0-29fb82011b39",
        "9fab087a-2b8b-4638-b3b9-84915e913387"
      ]
    },
    {
      "cluster_id": "991efb3f-2e53-4e93-bf2d-3ba713b91c23",
      "members": [
        "a70ba9ce-892e-48c3-a0e0-14cce6f091bf"
      ]
    },
    {
      "cluster_id": "f11e573c-d0ea-44be-a8b4-5ff5949c0ecb",
      "members": [
        "7d5d4a7b-f0e9-4bb2-97ed-7a3546ae51b8"
      ]
    },
    {
      "cluster_id": "8984a612-a2af-48f1-8868-d5d348b17de2",
      "members": [
        "80e76425-e94c-4e6e-b18c-5d0e2458f3df"
      ]
    },
    {
      "cluster_id": "9becb58f-9c06-4adb-8557-0a75a0444f56",
      "members": [
        "c1db1293-d3f9-4ba1-811b-e39f23953a4a"
      ]
    },
    {
      "cluster_id": "c219e535-0099-4f3c-9221-b32e8ae0d9a9",
      "members": [
        "ee163317-e616-4d92-ac13-19bb01d1412a"
      ]
    },
    {
      "cluster_id": "46b03cb2-bbc6-4b28-b240-16cc3f30e3bc",
      "members": [
        "4ce9bd1c-33a5-414a-a8cf-ddff35b9944e",
        "93685c4c-4575-4523-97d2-ea10d32fa0e5"
      ]
    },
    {
      "cluster_id": "71435cc5-d65b-4e3e-9454-ffe0371a42f1",
      "members": [
        "7a9c7aa3-b9ec-4447-8ad5-14f53b8a99dc",
        "853d4468-5466-4497-ac59-9fb3906d05b5",
        "35e718bf-4fb0-4c92-b4e1-8fb977118393"
      ]
    },
    {
      "cluster_id": "a378f92c-87c9-4fc4-85b1-e22948f338e6",
      "members": [
        "af60bf05-c6ff-44be-bab4-82baf4596d98"
      ]
    },
    {
      "cluster_id": "a4004e95-5738-4a9f-9ef9-273901538db0",
      "members": [
        "5ab2833b-6968-45cd-b20e-3d6a4d94962e"
      ]
    },
    {
      "cluster_id": "29c87b68-66f6-4218-b4fc-f6324d0ab7c7",
      "members": [
        "a709cd8e-97a4-4015-9336-5bd9ed38bb12"
      ]
    },
    {
      "cluster_id": "55da7c68-ac05-4727-a906-82d875d3d88f",
      "members": [
        "50796783-fd71-48a3-b820-83a169765006"
      ]
    },
    {
      "cluster_id": "6cc59f40-7aa9-413e-ae5b-64e2c17a2e71",
      "members": [
        "01cac53c-ae09-444b-8c7a-4d8983acba5b"
      ]
    },
    {
      "cluster_id": "ef20ba46-c8c3-4085-85f9-b312f9f6802a",
      "members": [
        "b16284c8-e200-4b13-9554-b82faa004f1c"
      ]
    },
    {
      "cluster_id": "64ba9893-281a-4427-95d7-8ab7818e5d93",
      "members": [
        "c5a3ecce-7031-464f-a033-0f25096bf05a"
      ]
    },
    {
      "cluster_id": "da1930dd-8986-4fa6-b320-dd6da70d644c",
      "members": [
        "fc9c12f8-858e-4cd9-83cf-a3e04b25fe51"
      ]
    },
    {
      "cluster_id": "02b41fd0-8916-41c1-8494-482e3096f186",
      "members": [
        "a9642145-43cc-469b-b0d8-1de850452963"
      ]
    },
    {
      "cluster_id": "9dec00dd-14cf-4956-9ce0-5f9d8647e24d",
      "members": [
        "cd12d1b2-fd96-4f7e-92a4-60647d717334"
      ]
    },
    {
      "cluster_id": "d6e26a99-056e-4587-a461-8e9b192ce947",
      "members": [
        "2e788f0c-75c7-4cc1-9c6d-ab3bf104216c"
      ]
    },
    {
      "cluster_id": "34782a59-6a9a-4289-8c00-12feb5c0f040",
      "members": [
        "7ca7d363-1dca-4657-8ef2-203fbc63b00c"
      ]
    },
    {
      "cluster_id": "b4c10082-ec3a-4c01-a666-d497f9480003",
      "members": [
        "1f694e3e-1c2a-40f8-bbc7-36e8ce3fb57e"
      ]
    },
    {
      "cluster_id": "1dffb0dc-1f11-4a52-8601-13d552598542",
      "members": [
        "9b5d9422-c502-48e7-ae6c-be43eebd021c"
      ]
    },
    {
      "cluster_id": "6fb5df41-d443-476b-9fcc-1bb07e6c9654",
      "members": [
        "92eccd30-8e15-4b0a-824d-735cca1c2192"
      ]
    },
    {
      "cluster_id": "d6e81e61-bb7e-4b41-8a70-469e0ff32a7a",
      "members": [
        "f3a645dd-68f9-4487-b73e-30f2e3ea4d04"
      ]
    },
    {
      "cluster_id": "4a483622-b245-4e23-bd10-793b05ae9fe2",
      "members": [
        "13cee0c9-ef25-445e-82a6-b02b00b2c1fb",
        "38f53e15-3f6d-4e4e-8988-ef767fae2cce",
        "2727f1dc-96ca-4448-8e40-efad4366f0c5"
      ]
    },
    {
      "cluster_id": "24cf159f-beda-439d-a5c9-ae442b6d0260",
      "members": [
        "0d4831b9-1c60-4e5b-b0b9-72bc0ccfcae3"
      ]
    },
    {
      "cluster_id": "39994f31-5ff9-43be-a15d-3547ec296a5a",
      "members": [
        "e7dd94b7-56b1-49b9-bbc8-e0391e96f07d"
      ]
    },
    {
      "cluster_id": "d44ce227-03db-4ccf-be04-d057a22464a7",
      "members": [
        "170e6f93-eed9-4548-9823-e63b11639f8c"
      ]
    },
    {
      "cluster_id": "e09e9595-94ee-4647-99c5-988ef1e8bcb9",
      "members": [
        "4b87c2d4-b0bc-4bcd-b2d9-b7f06d0da126"
      ]
    },
    {
      "cluster_id": "7d94faaf-dbe0-4a3f-a991-f9aa1c9db4cf",
      "members": [
        "a5c99aa4-f17c-43ae-b34e-509a65aa9fd9"
      ]
    },
    {
      "cluster_id": "7aab4a1b-073d-4317-accd-dca275b73d33",
      "members": [
        "2bea5ecd-17cf-4178-ab03-db01a041b647"
      ]
    },
    {
      "cluster_id": "531ef405-3766-417f-ac2c-f496b00a6ff0",
      "members": [
        "e3e3e85f-f8fb-4a8a-8ccb-600f18cbdcad"
      ]
    },
    {
      "cluster_id": "1b6f0e82-4a2e-409a-a651-9a7baa243dc6",
      "members": [
        "f435f62c-ad3b-4efa-aa1f-9ff8d3fe62ce"
      ]
    },
    {
      "cluster_id": "9eca8644-57d0-4b18-b62b-b394d615bf38",
      "members": [
        "679cb10d-d348-44e6-b2f6-01cb567790a2",
        "f270c33e-858b-4306-9fe4-5bd6bfe6a4fc"
      ]
    },
    {
      "cluster_id": "ab428379-3dca-4ed1-9e68-45a0cb9d3fea",
      "members": [
        "c4c8d590-6cdf-48bf-8957-5096693fce2b"
      ]
    },
    {
      "cluster_id": "10d521f9-b2ba-4e4d-ae1c-f8033a7f7147",
      "members": [
        "aa01c2c4-8749-4bb4-a2cd-1b8bb0a95fba"
      ]
    },
    {
      "cluster_id": "476dd033-427f-436a-8631-14fd97a75117",
      "members": [
        "9ac2f976-c4da-470b-b294-e79f98fc2b54"
      ]
    },
    {
      "cluster_id": "d8c7e702-0f0f-4bd0-b760-82584697ced7",
      "members": [
        "e0d3d359-f166-4dd2-aca8-a35110d78fd2"
      ]
    },
    {
      "cluster_id": "464e7bbb-1cb4-45e2-a510-f3dbf3edebfc",
      "members": [
        "43f8b899-885b-4050-ac77-5ce53ea324bc",
        "5ed0f63d-df88-4580-8a8e-48d5c9df57ad"
      ]
    },
    {
      "cluster_id": "7897b080-7853-4261-9ab5-31b7495a5563",
      "members": [
        "7307d455-2137-4fa5-bc7c-4cdea871a9dc"
      ]
    },
    {
      "cluster_id": "304159c4-71dd-47fa-8097-c06173508250",
      "members": [
        "a65d001c-cca8-4840-9b32-1af336faff8b"
      ]
    },
    {
      "cluster_id": "2a61add2-cedd-40b1-9edb-ca1cd948e8c9",
      "members": [
        "24e21450-cd50-46c3-b94e-55ca3db9664c"
      ]
    },
    {
      "cluster_id": "c46b62bc-7cc2-4635-bcb1-86c242f419fc",
      "members": [
        "14e53ed3-1d34-4287-b912-5cda80c785f1"
      ]
    },
    {
      "cluster_id": "5e5db8ed-e13c-449a-bc48-1985ab63a2df",
      "members": [
        "399ec5a7-19c0-4a7b-abf9-391f68e2ff17",
        "7391c888-79ea-4e6f-87cd-27e151639497"
      ]
    },
    {
      "cluster_id": "66723b88-51f0-432a-9dff-39c845623093",
      "members": [
        "fc6b77f7-dc25-493e-850a-8a5678ac62f1"
      ]
    },
    {
      "cluster_id": "73f48f2a-467d-4d70-aac9-42d923ea5f8c",
      "members": [
        "cd833903-1d88-435a-be20-65d7f3030c1d"
      ]
    },
    {
      "cluster_id": "668e643e-dedd-4afb-8aee-89228ecd7266",
      "members": [
        "9969c3be-cc0d-4004-9170-83f03be8a37a"
      ]
    },
    {
      "cluster_id": "73ec670b-a1e6-4252-8fc5-cd613c026c27",
      "members": [
        "48993eae-6239-4819-9397-c0e535b16ede"
      ]
    },
    {
      "cluster_id": "99e93b0d-aa99-4889-a4e7-3146b3109f12",
      "members": [
        "dc3e294e-d8f5-4f83-8645-15c73a692917"
      ]
    },
    {
      "cluster_id": "0cb0d661-8f49-489f-95ee-927e21758c32",
      "members": [
        "6cb42a3b-90dc-4c1c-9f7b-c798da81dc3b"
      ]
    },
    {
      "cluster_id": "0c6eb85b-0ae0-403f-b2fd-990121d9ade3",
      "members": [
        "fd57d3a4-1075-477d-ac07-7a5b2f8cf5f6"
      ]
    },
    {
      "cluster_id": "5733967d-8845-4b54-bab0-e2652b43f156",
      "members": [
        "06ec29b7-82cf-4072-b4d9-152399a5e654"
      ]
    },
    {
      "cluster_id": "cd9fcff5-cee9-4a86-b076-bc2c105f1372",
      "members": [
        "f9c3779a-12b0-4cd5-8f95-525ca13037dd"
      ]
    },
    {
      "cluster_id": "997b6294-e973-4686-9dd3-38c8184705a9",
      "members": [
        "6342e2b7-055f-465b-bfa2-b4ddccaaebb4"
      ]
    },
    {
      "cluster_id": "f1749a30-d414-494e-8542-2f37dca2357f",
      "members": [
        "ba975775-fff0-4df5-a3bf-e0ca58335c08",
        "87c7fc14-b153-4c4c-bb81-721cba1b85ec",
        "a822c036-5334-41e1-8f49-d66ea1f5558b"
      ]
    },
    {
      "cluster_id": "287338c2-de9c-4394-a2e1-133139492deb",
      "members": [
        "c6f3ddf6-1bab-4d23-b714-953fb57eff01"
      ]
    },
    {
      "cluster_id": "81106289-cb37-45f4-a937-0b81bb6b136a",
      "members": [
        "69e5b66f-97d1-4101-ae74-59610cb88559"
      ]
    },
    {
      "cluster_id": "3474c474-7d6c-491a-9b70-d72c3c7f2f0d",
      "members": [
        "9e3880ce-a29d-43cd-874f-cfef33aa127d"
      ]
    },
    {
      "cluster_id": "1d986f8d-82e7-4918-bcdd-07f2b4e2658d",
      "members": [
        "91fe841d-800b-4739-bd2d-d81c8f002fb8"
      ]
    },
    {
      "cluster_id": "529a3261-d48b-4317-930e-3bc02bd608d6",
      "members": [
        "1d4c16e0-d010-4863-9727-9cf42723cae9"
      ]
    },
    {
      "cluster_id": "4baddf1e-d126-4e58-b0e3-19999dfb4341",
      "members": [
        "bf10fde4-add0-4ec3-9223-e8f98213cb4d"
      ]
    },
    {
      "cluster_id": "ac20790a-e28e-426a-9c7b-f5ecf7b0aefc",
      "members": [
        "ef6c5885-5dcf-4ea1-8216-8f32472257f6"
      ]
    },
    {
      "cluster_id": "abfd51b8-1368-4f82-817b-9f3cd83502dc",
      "members": [
        "4d67b61c-8473-4dc6-95a1-580c9649bb7f"
      ]
    },
    {
      "cluster_id": "90f6170b-cac1-4488-806a-45a48e5f95f7",
      "members": [
        "b2496dbd-12c0-465b-835a-ba1729136df0"
      ]
    },
    {
      "cluster_id": "c932887c-3706-4683-bd4c-6cb5768e640e",
      "members": [
        "c09ce2fc-390b-4863-9fc5-d1930b2f2ff1"
      ]
    },
    {
      "cluster_id": "a0d901e6-2e0f-43fd-9d25-7b092459f36d",
      "members": [
        "eb6c052e-7bf2-4485-9d67-51aa2085d18e"
      ]
    },
    {
      "cluster_id": "71ff5874-dbd0-431c-b097-90e57ae45748",
      "members": [
        "9b6d9a3a-ada9-41e1-b87d-b843716d0776"
      ]
    },
    {
      "cluster_id": "b3f64145-99ff-4cb6-9aeb-55abe9921e59",
      "members": [
        "4c401541-ab70-4b74-8c2e-5cd24cc436b9"
      ]
    },
    {
      "cluster_id": "78c613ac-a6ce-4fc2-859c-265be8fa23d8",
      "members": [
        "75716968-673d-4617-a46d-a6f490fcd10e"
      ]
    },
    {
      "cluster_id": "fe5accb2-754b-4498-82d5-eaf3b4116254",
      "members": [
        "503e9999-94ea-4dcd-8c73-e9fc77be30d1"
      ]
    },
    {
      "cluster_id": "4ea8be34-570b-4271-a023-3b36e07e963b",
      "members": [
        "98240cd1-a78c-4795-9c7d-26b9f65b0f6a"
      ]
    },
    {
      "cluster_id": "c16529d9-b58f-4692-9ca3-61d534ff3c9c",
      "members": [
        "de69b62a-c856-4aa7-9a3e-3fafbd094da4"
      ]
    },
    {
      "cluster_id": "4c1f4530-7a84-49d9-bd89-b51ceb8c5ce5",
      "members": [
        "944b2729-f7d8-4888-b155-b4742dfa7d8e"
      ]
    },
    {
      "cluster_id": "d349da51-4e48-4c7b-8b12-6a3dc4608c75",
      "members": [
        "ccfb3e7c-5f10-4ff4-9e50-b7367383ee17"
      ]
    },
    {
      "cluster_id": "8e640a02-ac6c-4b9c-8244-be0e4a058359",
      "members": [
        "0cd4f6a5-2bfa-4bb5-97c4-0f00629d8196"
      ]
    },
    {
      "cluster_id": "04e99e38-59fd-4613-8ed1-1ec10ecc384c",
      "members": [
        "a191825f-6de9-4d87-8a4d-30409d13d4b4"
      ]
    },
    {
      "cluster_id": "637cde7e-0523-4cfc-a2d0-d5916b669833",
      "members": [
        "90a516e1-5fec-49da-9932-7d18620d8b22"
      ]
    },
    {
      "cluster_id": "226d057f-48c7-4bbd-a28a-0aa92cb7c9a5",
      "members": [
        "02afaa47-b21e-459d-acce-148ab6f92cf0"
      ]
    },
    {
      "cluster_id": "a8d5b3e4-8b75-49e0-a915-0b7f6f79f523",
      "members": [
        "3dbbe6c8-09df-4e25-b23c-5e7cc9d7526d"
      ]
    },
    {
      "cluster_id": "aea06698-0475-487a-a76e-80bcbad00033",
      "members": [
        "f8f68b07-5c9e-42b8-b2ab-2883893a0e69"
      ]
    },
    {
      "cluster_id": "1de54c8a-0e53-4b6b-8b96-dacd9745e0a3",
      "members": [
        "945e80be-a5a3-4199-b65a-3bece6b7699a"
      ]
    },
    {
      "cluster_id": "2adc78cc-7a32-4711-8e39-54e6c3539977",
      "members": [
        "4cb6beca-973b-40dc-b67c-0064201fba5e"
      ]
    },
    {
      "cluster_id": "0edde6ee-5047-426b-bbb4-69dd12b6fd54",
      "members": [
        "df1e89aa-6e0c-49cb-bd7b-b0657dff90a5"
      ]
    },
    {
      "cluster_id": "33e5cc06-7767-4163-b58e-c98e6d0b542f",
      "members": [
        "24b77652-38fd-4c08-8b22-a14a1d9a2811"
      ]
    },
    {
      "cluster_id": "12d89d03-baba-4a2e-8935-742fe6b4573c",
      "members": [
        "7342c0b7-9bb6-45ae-8c6c-294a3543c93d"
      ]
    },
    {
      "cluster_id": "0fd43dca-76e2-435e-9091-21e203301fc4",
      "members": [
        "ac75ab80-c1ac-450f-9d26-54e49897e0d9"
      ]
    },
    {
      "cluster_id": "639aad5f-e883-4460-bc98-aed364fefe21",
      "members": [
        "5698e2f9-b7f2-4ad2-aeab-4540a3f4a34e"
      ]
    },
    {
      "cluster_id": "867f94d2-2825-471a-801a-edc5c961ad9f",
      "members": [
        "659afe69-c95b-4fda-a2b4-b48856bad257"
      ]
    },
    {
      "cluster_id": "55326ca1-c9a2-4aca-a1ea-bd63160c25ea",
      "members": [
        "5170d91f-7079-47ae-9a0d-71d25e98fd09"
      ]
    },
    {
      "cluster_id": "9f25d197-8ec1-4d18-aeda-b095d1997826",
      "members": [
        "549a2c5d-d36b-424b-bbd6-4767abb2e041"
      ]
    },
    {
      "cluster_id": "2e94c160-31a6-438f-bf81-0a00ecfb6a2d",
      "members": [
        "a57fc600-fd62-4a15-9d6e-e00d1b4108d5"
      ]
    },
    {
      "cluster_id": "e5eb0916-6642-496c-9615-8dbd59c7dd10",
      "members": [
        "c74064d8-77a8-4e11-969d-65b7f7a49d54"
      ]
    },
    {
      "cluster_id": "e7125b37-2f58-44dc-935e-482a2f26ca14",
      "members": [
        "627b0e61-d6de-45a7-843b-f20cfb2da184"
      ]
    },
    {
      "cluster_id": "436ce4a6-0697-4461-9b3c-0feb3eafc498",
      "members": [
        "d3396119-d872-44b0-8deb-e5eb249a90b3"
      ]
    },
    {
      "cluster_id": "afff4757-e8dc-4943-90b2-48114c9bc6d7",
      "members": [
        "7c38c3e8-093f-42b1-8174-9b06a63c1893"
      ]
    },
    {
      "cluster_id": "43ab7664-f265-4e8d-9a0a-5ae73e4eeadb",
      "members": [
        "4a539e12-4ecb-4728-a340-d11ee79796b0"
      ]
    },
    {
      "cluster_id": "0a675e77-bb90-44f7-8297-ab44add96136",
      "members": [
        "b0510283-9cb0-49bd-ba35-369c2de4a045"
      ]
    },
    {
      "cluster_id": "7a5b8ce2-31ac-42cd-bb98-cbeddcf8542a",
      "members": [
        "eff633d9-738e-4c7a-af7a-9bf8ef276695"
      ]
    },
    {
      "cluster_id": "f184f109-b4af-4d4c-b5c2-73e631545fd2",
      "members": [
        "7361ba00-780c-4294-83ff-7a605090c8ea"
      ]
    },
    {
      "cluster_id": "96b587fb-4363-4d46-8a28-162c4f6a688e",
      "members": [
        "67d491b8-372c-4357-8853-fb6d0e78c0c4"
      ]
    },
    {
      "cluster_id": "505c42ee-a234-45a9-8c74-63207154db3f",
      "members": [
        "60e7b0fe-5374-480d-af09-321afee17ed5"
      ]
    },
    {
      "cluster_id": "77cb4584-fbf4-45e6-9a2b-9d46e341c831",
      "members": [
        "f9af94f9-d0bd-4905-b27f-8bad1d50532f"
      ]
    },
    {
      "cluster_id": "823bf086-9c7b-424a-8c1e-a0823a4017d5",
      "members": [
        "f57edc70-ae95-41b6-aef2-49ea3a1fca81"
      ]
    },
    {
      "cluster_id": "72ed971f-2c7c-4564-b630-36c027e0f1d2",
      "members": [
        "f3a58a27-5f45-44aa-9bf7-bc5c8c2202e2"
      ]
    },
    {
      "cluster_id": "2c59d86f-8c32-43d1-acd4-a598aa7665ee",
      "members": [
        "28feaf79-870c-4ab7-a66a-2b220c21d5db"
      ]
    },
    {
      "cluster_id": "682564dd-6904-485d-a9d9-e5a6a5b41de7",
      "members": [
        "9da7657c-470e-4730-80ff-14ccdada87c9"
      ]
    },
    {
      "cluster_id": "59e292c0-ebb5-4e44-9c6c-162e21e21b97",
      "members": [
        "0087ec71-efef-48bd-a9b0-ad70397607b7"
      ]
    },
    {
      "cluster_id": "3ebb1b75-d2e9-4210-933a-9f6e5583b377",
      "members": [
        "9d2a8db7-5155-407d-8436-8d7cee3e5b07"
      ]
    },
    {
      "cluster_id": "37ac1c3c-10ae-411e-a6f7-5a4e0cfd6c1b",
      "members": [
        "cb11b99e-dea4-44ec-b3f8-b061844a08f2"
      ]
    },
    {
      "cluster_id": "9acd0141-e648-4bf5-8aee-3bc494863f46",
      "members": [
        "cf7273eb-95f6-4d64-8982-3c77a54eb37c"
      ]
    },
    {
      "cluster_id": "d821d63f-63c7-4a38-a3fa-ddd32322fec9",
      "members": [
        "0afc5e37-1078-418e-9712-600d479f1b63"
      ]
    },
    {
      "cluster_id": "a5420c14-b12d-4c0a-ae41-dc3c93672fd7",
      "members": [
        "dea74892-770e-46a2-b6a0-b224a7cc797d"
      ]
    },
    {
      "cluster_id": "48f73ce8-5bb4-4ea5-acad-4966cfa816f8",
      "members": [
        "44bb52cb-2b43-4b01-8e82-ca3f82d435b9"
      ]
    },
    {
      "cluster_id": "89418c34-2fb2-418b-8359-739bf85f5c05",
      "members": [
        "f2ddd3a0-eaae-49d2-8c91-7e83372075fe"
      ]
    },
    {
      "cluster_id": "925ab71b-2b56-471d-b090-4d83433faa8d",
      "members": [
        "9f027cbc-e19c-4bb5-8261-cabc26180c9b"
      ]
    },
    {
      "cluster_id": "116f2145-073f-478d-a5b4-2d21196c953a",
      "members": [
        "10e8edc7-51fd-4a67-96a7-0b2ec0458508"
      ]
    },
    {
      "cluster_id": "b5c81785-6289-45db-a194-d9731e5e4109",
      "members": [
        "236295a2-6dc4-432c-950b-cd8ec055a997"
      ]
    },
    {
      "cluster_id": "f262ea70-4c26-4dcc-8a1f-52d6f8ce5558",
      "members": [
        "94db85e1-1e45-488e-961c-1852016eb144"
      ]
    },
    {
      "cluster_id": "e0151ccd-baed-452a-aaa4-6feaeeadc3d9",
      "members": [
        "c6f0e97b-89d2-4817-8b4b-14549e4f7132"
      ]
    },
    {
      "cluster_id": "9c2eabc6-f74c-4f84-b44d-2de93cf844a7",
      "members": [
        "1ba18464-64e0-4a02-b45c-1bcd8fd1fd2f"
      ]
    },
    {
      "cluster_id": "0cb84281-0a02-4551-a9b6-e0952da929f7",
      "members": [
        "ad49483c-8b2d-485f-8b1d-4e7c1f885fdd"
      ]
    },
    {
      "cluster_id": "9ebf6405-2d25-40bf-a1c7-48615c2b0e1d",
      "members": [
        "f67d414d-8b31-4350-bc2e-0fc2b65b527c"
      ]
    },
    {
      "cluster_id": "72aa7b94-9121-4289-8302-01ff0cfe298d",
      "members": [
        "cdd93ecc-dec3-49d2-8519-57fb729a6a6c"
      ]
    },
    {
      "cluster_id": "46dfd54a-6aa7-40ae-be06-53fff6d54a50",
      "members": [
        "1eb822b5-1044-4452-9b7d-5da64b2e1637"
      ]
    },
    {
      "cluster_id": "2b11b446-8d3f-43d8-b5cf-fa4f7e28a0d7",
      "members": [
        "57349056-a914-484b-b96a-5e1c0add2dec"
      ]
    },
    {
      "cluster_id": "63edca78-13df-4735-a10c-6f9089b9d044",
      "members": [
        "519c5fae-9511-4646-8e94-46823089e695"
      ]
    },
    {
      "cluster_id": "7130da69-c674-4096-9b2f-90376c9466d7",
      "members": [
        "886b25be-3682-4289-925b-472fa91130c0"
      ]
    },
    {
      "cluster_id": "2ed4b8da-36cc-414e-9362-86f9b9a7a515",
      "members": [
        "a2ddcf5d-e29c-4ca6-82b3-bd018543286f"
      ]
    },
    {
      "cluster_id": "84b99e8f-a7ed-4a77-92d2-b7e912bf0ca1",
      "members": [
        "48f9f82a-a285-4d1a-9f55-4e78e4a90559"
      ]
    },
    {
      "cluster_id": "dd156ade-c3be-4db6-9779-46772fbd155f",
      "members": [
        "feeb4bde-2a9f-40ea-b58a-1808e9ea7038"
      ]
    },
    {
      "cluster_id": "2f59f9a6-6a8f-409f-8959-e71823889fb2",
      "members": [
        "a8947dc0-f568-42c5-8ff5-8327af960ae5"
      ]
    },
    {
      "cluster_id": "64e6dbae-d0db-43b2-acc6-29b1e94d9205",
      "members": [
        "70efff1e-de29-4845-8168-e788f396d3f4"
      ]
    },
    {
      "cluster_id": "c700d9cd-e09d-4ea7-a33c-b8925d591d85",
      "members": [
        "c0b1cd72-bf4b-45fc-a1e8-02b82878530e",
        "a0960191-05cf-4a3d-b3b5-463142b35563"
      ]
    },
    {
      "cluster_id": "e80d1fc7-6571-4102-b247-59bf3fa473d7",
      "members": [
        "704a2e5b-dcc1-471d-af03-9a5258158cad"
      ]
    },
    {
      "cluster_id": "0d91b295-8dc7-41f1-8c2e-38f85451d859",
      "members": [
        "d5ed7a1d-604c-4293-aa09-c48775956696"
      ]
    },
    {
      "cluster_id": "f9d888bd-a05c-4b7c-9a69-097ffb41a69e",
      "members": [
        "1da59117-46a6-4dda-bc0b-beea5612a755",
        "066b4c74-1302-45b0-baca-be4260f7c315"
      ]
    },
    {
      "cluster_id": "832076ec-b055-496e-aae3-ea8daef2ce04",
      "members": [
        "db3fa2b4-6e19-4bb1-a206-75c8de9b1a5a"
      ]
    },
    {
      "cluster_id": "d4181e9f-8d0f-420c-9032-de5764ee8344",
      "members": [
        "4c4999a9-83ad-4b37-af5c-bea47b7609eb"
      ]
    },
    {
      "cluster_id": "e21706fa-dad7-4365-a0f1-e7a597e49a75",
      "members": [
        "93ccacee-2583-4de9-8575-665d987e7ec5"
      ]
    },
    {
      "cluster_id": "e354903e-091b-4412-9de6-d963f87ab883",
      "members": [
        "5b9478ed-b921-456e-af42-1a76ccbf2caa"
      ]
    },
    {
      "cluster_id": "25b06341-ba13-410b-909e-c700b9b55663",
      "members": [
        "eb586cec-0bd1-4d4b-a6e3-b3ff9fd986cf"
      ]
    },
    {
      "cluster_id": "8c4dfd91-f6ed-43c0-830e-f702329489e8",
      "members": [
        "833328b9-c48d-439f-983a-13bfc8de9b56"
      ]
    },
    {
      "cluster_id": "fe65ec5c-3bc8-43b1-9738-60a0ae594f25",
      "members": [
        "434108ca-f12e-486b-993b-8050154681d9"
      ]
    },
    {
      "cluster_id": "554d8f5c-047a-4e8e-b996-038e567aa26c",
      "members": [
        "d9d6f93d-7229-421e-8b8a-10cc701fb7b5"
      ]
    },
    {
      "cluster_id": "66fb628f-853d-44dd-b0f9-617fd67bcaf1",
      "members": [
        "55e622ec-6a9b-4f53-9e13-2c63b8d4c085"
      ]
    },
    {
      "cluster_id": "8585c4f1-4f02-4ac1-9a95-4cc381634f7d",
      "members": [
        "3bdf0dac-34e7-4c26-a068-02dcae5374c8"
      ]
    },
    {
      "cluster_id": "cd18cc59-c362-4812-b494-ea37654755a0",
      "members": [
        "da07339d-e02d-4916-a798-4d30ade2a3af"
      ]
    },
    {
      "cluster_id": "82015ed8-be97-4f9a-940c-6061a2380bc1",
      "members": [
        "50802117-fbd2-4c1c-b79f-3d872b116060"
      ]
    },
    {
      "cluster_id": "871a611b-da54-48a2-9c22-fa6f48cccc0c",
      "members": [
        "153a0453-50cc-4c08-83cf-fd6773ae36e1"
      ]
    },
    {
      "cluster_id": "8f75e655-8582-4cb0-9320-47aef61dad78",
      "members": [
        "c7f4ad23-d007-4211-b4dc-1cf6b489c385",
        "33ccea91-e7e3-422a-9dc2-d9a8020f0bdc"
      ]
    },
    {
      "cluster_id": "5f916a06-e83a-45ea-99cd-e223f21451ed",
      "members": [
        "9a3d525a-4adb-4cda-827e-d15ade12f31a"
      ]
    },
    {
      "cluster_id": "695d0f59-560f-43af-8f49-fe8e17880043",
      "members": [
        "a8fcce40-59d3-4693-bb0e-d1d791ec5743"
      ]
    },
    {
      "cluster_id": "e6bb5d2b-e815-44c5-957e-bfeac26fe4eb",
      "members": [
        "32ce1237-00d3-47c7-b25f-75e182d37bd7"
      ]
    },
    {
      "cluster_id": "4d738b05-171a-40b9-a505-e237572de24e",
      "members": [
        "5d6da8e3-4367-4339-83c3-b0e5b5db407c"
      ]
    },
    {
      "cluster_id": "0f37d4dc-cf7b-49dc-aecd-4803e8374e39",
      "members": [
        "243bcd2e-93bd-407b-b8fa-10811871553d"
      ]
    },
    {
      "cluster_id": "5ca3c47d-e454-491e-8306-a8bcab9a1429",
      "members": [
        "d1a9bab9-76dc-4796-bde7-6a13c17a1bdd"
      ]
    },
    {
      "cluster_id": "43efd020-0d45-4101-9278-ea22329dba55",
      "members": [
        "060f49f6-ce30-4b27-a91b-845c676656e1"
      ]
    },
    {
      "cluster_id": "dc60fa2d-dae3-4ea2-a4d5-1da4424a6919",
      "members": [
        "a03e9d57-73d4-4bdf-be88-1780212a4ad5",
        "49441f57-cb4b-439b-ae80-7dc20ca68fa5"
      ]
    },
    {
      "cluster_id": "db8f619e-f112-4abd-9c92-e8cda93ee5d3",
      "members": [
        "a4bead56-90d4-4f28-8095-8a5d20f8f4f1"
      ]
    },
    {
      "cluster_id": "bd1fd480-bf1e-49b6-a34f-4616e66e256e",
      "members": [
        "b9024f6a-090d-4bd0-ad59-02b83ef9a31a"
      ]
    },
    {
      "cluster_id": "987f4090-f0a3-43c8-9987-c964fdd04c79",
      "members": [
        "4acedc34-7444-4087-8ac8-f0ab81d756e2"
      ]
    },
    {
      "cluster_id": "2e504c36-cc23-49bf-9bfa-77adbeb06137",
      "members": [
        "74cdc5c7-2bd7-47c8-8917-190eb14b02b3"
      ]
    },
    {
      "cluster_id": "58babb7d-bd41-4196-8e7a-e844e8cfa638",
      "members": [
        "6bd4e5df-786a-4eae-8115-052c576a4329"
      ]
    },
    {
      "cluster_id": "3fd4fa60-bdae-4294-8d90-4a430127c38a",
      "members": [
        "e8b49fdd-51a0-4209-b02c-12aa70cb3d55"
      ]
    },
    {
      "cluster_id": "0c951d24-0f2c-41e0-a5be-f5200eceb7d7",
      "members": [
        "f59198d8-a484-4249-9e4c-cb120eb06ccc"
      ]
    },
    {
      "cluster_id": "27c3b9de-4f86-4091-b50b-7314a2636d6c",
      "members": [
        "07f79ea0-c692-4baa-9119-0f5368f1d699"
      ]
    },
    {
      "cluster_id": "4df23607-a04c-40e8-be3f-b8d874dc3d06",
      "members": [
        "44646b63-c5a5-421d-a5db-b8bdf9ace828"
      ]
    },
    {
      "cluster_id": "0555403d-91c7-40d0-bf24-c9c0415e9ad9",
      "members": [
        "741729c0-95bd-443c-b190-7f90d0ca9e84"
      ]
    },
    {
      "cluster_id": "d118efd6-5acc-43c8-a0da-c30ae94fc13d",
      "members": [
        "0876b24e-ada1-414f-99f5-fbb75a2ce1d8"
      ]
    },
    {
      "cluster_id": "f2a2ed3b-6c1b-49ef-92fd-f294f1deb809",
      "members": [
        "c666a329-62b7-460d-8880-c5f0d94f6cc9"
      ]
    },
    {
      "cluster_id": "7d3dad5c-ee33-4088-acfc-ba0e93d997c2",
      "members": [
        "6caeaf94-869d-4164-b22a-e0d6cc091305"
      ]
    },
    {
      "cluster_id": "1fcf2fd2-6989-429c-b569-e5ab5218738b",
      "members": [
        "323a384e-2961-4844-bb5e-caeb44529087"
      ]
    },
    {
      "cluster_id": "3defb0ae-14b9-488e-979b-534969f6eb1f",
      "members": [
        "5cad67d2-e08d-4e47-ae5d-3de0c4b4479f"
      ]
    },
    {
      "cluster_id": "997ed426-7093-49d8-afde-97f5ea1d37f4",
      "members": [
        "02a16f64-1041-448c-85e0-93941aebabb2"
      ]
    },
    {
      "cluster_id": "47933a91-e43e-4731-9328-ce609581c5cc",
      "members": [
        "a8a03368-4889-42d0-b210-bbf16a481d35"
      ]
    },
    {
      "cluster_id": "1d430602-1893-4300-910c-58f51643ea58",
      "members": [
        "d1c4ccfc-8cec-44f4-a6b9-efe9f164ab6c"
      ]
    },
    {
      "cluster_id": "a64f796d-8a90-4c29-811c-e05f5e8b113a",
      "members": [
        "dc7674b3-e329-4328-bd62-aabc0cfd248f"
      ]
    },
    {
      "cluster_id": "6e4a0e8e-51f9-46ed-8b84-bcdeb86a6f8d",
      "members": [
        "f28c2f82-5f27-4b43-a421-02ef44a350cb"
      ]
    },
    {
      "cluster_id": "d04cd0c9-b68b-4e40-8b85-d3adf9108b78",
      "members": [
        "8ee9b76e-0f2d-4f24-a5fb-f63e07db02c1"
      ]
    },
    {
      "cluster_id": "2dfd3fb6-1a3a-4beb-9bdb-2191423af570",
      "members": [
        "26476e3e-0255-4374-ad8f-5f995f4d2382"
      ]
    },
    {
      "cluster_id": "a7c1c7dd-20e8-417a-8b0d-915fb535b95c",
      "members": [
        "aecc93d8-f903-49e9-a789-08975bfec032"
      ]
    },
    {
      "cluster_id": "3ae7e3a9-52e8-497b-addf-b434f9dee4bb",
      "members": [
        "c213632f-f81d-4a1e-8f04-a90bd92d702e"
      ]
    },
    {
      "cluster_id": "437a3d9b-28c4-4057-94e1-09375ae72bc9",
      "members": [
        "1d77d116-bcdf-49da-a814-c26fc172f941"
      ]
    },
    {
      "cluster_id": "197e7b6e-783a-4813-926e-57380c838db7",
      "members": [
        "18c8ea30-f6d5-4e01-b748-a6ddae01c225"
      ]
    },
    {
      "cluster_id": "05f4f7be-1927-40b1-a507-9bb7d746892f",
      "members": [
        "68e2f391-6cae-4e76-9468-e3f4dec7df67"
      ]
    },
    {
      "cluster_id": "8b24e853-731b-4d1e-ab4f-4eadd5f933df",
      "members": [
        "f9633764-fbf4-4111-a58c-752a023c9f47"
      ]
    },
    {
      "cluster_id": "dd94c024-2472-482f-808f-4c85cd16b4f9",
      "members": [
        "7ed72f95-8073-41ce-b0bd-ed25d6f99ca1"
      ]
    },
    {
      "cluster_id": "5788deb7-8fce-4423-98fe-905a919278d0",
      "members": [
        "c56a9adc-dc99-49cb-ac26-2bf255b073a6"
      ]
    },
    {
      "cluster_id": "ea7149f6-4e64-4cea-8d02-bf248f686ab1",
      "members": [
        "f8165c18-9264-47aa-a01c-0b8c4f073f3c"
      ]
    },
    {
      "cluster_id": "67ef8b62-b165-45e4-8df0-4a9253d62b61",
      "members": [
        "68dc7eaa-f18f-4ebe-b8a6-9d84a9d89954"
      ]
    },
    {
      "cluster_id": "522dac78-ab07-4494-b1cd-d35343e02912",
      "members": [
        "4ed72a1c-8710-4154-909b-3ddb2ecb8590"
      ]
    },
    {
      "cluster_id": "1d910892-dde8-467f-8bc1-dac08ec78136",
      "members": [
        "cea3d47c-35f6-414b-a754-8e95a7de3988"
      ]
    },
    {
      "cluster_id": "5561c312-8b94-44c1-8be5-5ceb08c13061",
      "members": [
        "daaf1b89-a36d-435b-8fbe-d84791ad228b"
      ]
    },
    {
      "cluster_id": "69fc5164-f4a0-47bb-853d-0382d8d5f3c1",
      "members": [
        "407d90f4-5543-4002-bf08-feccffa3e66e"
      ]
    },
    {
      "cluster_id": "40612f57-e760-4270-afaa-ede3763cda33",
      "members": [
        "7ba3f4f0-ca89-4d70-bd13-db461a2b110a"
      ]
    },
    {
      "cluster_id": "d22d7383-71e2-4520-a5b2-8ae266a5a780",
      "members": [
        "20938efc-458b-4b5d-93c0-0a51a2cfcd1f"
      ]
    },
    {
      "cluster_id": "16bacf34-8f6f-4fd6-ad3c-f7fed8660b38",
      "members": [
        "93210245-0ed3-478e-9610-7f95ab51dbf9"
      ]
    },
    {
      "cluster_id": "37b089f1-912d-43da-b995-2ef9b56de813",
      "members": [
        "d2bce9ba-13fd-4487-8da4-1d633fc463f8"
      ]
    },
    {
      "cluster_id": "e59d2cce-34c4-49db-b0fc-9ab7a956e929",
      "members": [
        "7ee3653f-32aa-47b8-9acb-799f35f05c3d"
      ]
    },
    {
      "cluster_id": "d419e57d-59b3-4e7e-beeb-1d52b9c76608",
      "members": [
        "b36796d3-aa35-487d-a37f-dccc9d59d67b"
      ]
    },
    {
      "cluster_id": "0de6c083-ab7f-4e7e-b4a5-f3e13198d24d",
      "members": [
        "956c2edd-5ea2-4d90-9314-5e85b00a6ce1"
      ]
    },
    {
      "cluster_id": "b79a6948-c2a3-43ae-83f7-90168d6803ac",
      "members": [
        "0292cb7d-cd08-428b-b4eb-7dbee8453962",
        "d111af52-467d-4ee5-a2ad-0cb7697fb6dc"
      ]
    },
    {
      "cluster_id": "f4a62cbd-7d48-489c-b0ae-5a2ba587faca",
      "members": [
        "5dfd5799-baac-4921-a943-ef7c64ec847e"
      ]
    },
    {
      "cluster_id": "b23983b2-f833-47cb-bb9c-14955ae74418",
      "members": [
        "a1006103-1fdd-48e7-a258-db0dca424b2c"
      ]
    },
    {
      "cluster_id": "a6f0d89a-0c3c-4be5-83c6-b064b8a9c73a",
      "members": [
        "f6e64bb4-2626-46e9-848c-f77fc7551f29"
      ]
    },
    {
      "cluster_id": "4833448d-d892-46bf-bb0b-2903956326da",
      "members": [
        "54e56b8b-c19a-4d50-b0cc-2aabd9cc108d"
      ]
    },
    {
      "cluster_id": "a839d9a9-74d4-474c-bdfc-b239b6e1eb9b",
      "members": [
        "24139cff-94b4-435c-89d8-37bd588d1cd0"
      ]
    },
    {
      "cluster_id": "637f444f-2be2-49e6-9376-4e66fc8b211b",
      "members": [
        "737ca22d-17b0-4b71-a1dc-96df8deec3bb"
      ]
    },
    {
      "cluster_id": "67171e62-bbfa-470a-8469-52d1b51665da",
      "members": [
        "69e8cef3-0f97-4f56-9d24-1c39fea0e151"
      ]
    },
    {
      "cluster_id": "f29558d0-0635-4b49-8d22-a3cce142124f",
      "members": [
        "c205a767-0407-484a-a644-3d2f7095cf27"
      ]
    },
    {
      "cluster_id": "4b9443f4-821d-4fb7-8621-ed3af0ada4a9",
      "members": [
        "57d38d6f-b4e3-4c4e-a71b-09a0f515f264"
      ]
    },
    {
      "cluster_id": "3f649da1-9f4e-4906-a4fe-35e3ec3f6e86",
      "members": [
        "92e94f9c-d067-4f8b-a258-f7d343bd4044"
      ]
    },
    {
      "cluster_id": "adc5ea43-1ddd-4862-afc6-b17c270c9d83",
      "members": [
        "6cd113e2-9c3a-4e55-b281-7226cd7b3716"
      ]
    },
    {
      "cluster_id": "8e28231d-7117-46be-8655-ac03e3ec9b13",
      "members": [
        "a9830400-0edf-40b4-b51e-33131d956951"
      ]
    },
    {
      "cluster_id": "9c1a6fcf-db77-4bad-b035-88b7787ab104",
      "members": [
        "02ef3bf3-20e0-4322-aad1-8462d20ee747"
      ]
    },
    {
      "cluster_id": "d53ff534-a3d7-4ffa-9823-7bc6114763e7",
      "members": [
        "107d5c29-2f33-4fc4-acd6-2fee20c6c791"
      ]
    },
    {
      "cluster_id": "14faed7d-8ab2-4b52-8d60-40b6be3c9a21",
      "members": [
        "adaeae49-d1ad-483e-9b00-5c144f3efe02"
      ]
    },
    {
      "cluster_id": "eaf67764-9289-414e-b58d-ac157f48690c",
      "members": [
        "e7e18802-a542-4d2d-acfb-bfa827d3f70e"
      ]
    },
    {
      "cluster_id": "c2141743-76d8-4904-8bb0-fc81db4f2295",
      "members": [
        "9d7ccf0a-6dca-4a27-a0aa-99c3068c8cb0"
      ]
    },
    {
      "cluster_id": "eee93c68-9cef-40e8-a46b-ade5e4a0a57d",
      "members": [
        "e36cb072-83e2-420d-8cf4-ced1f4fe3938"
      ]
    },
    {
      "cluster_id": "b85f1177-adf6-443e-8aa8-4b882389f698",
      "members": [
        "e0167f84-ce1f-4d81-b352-b885ea3a42ac"
      ]
    },
    {
      "cluster_id": "24039860-6815-4ba8-9be1-247dda66cf25",
      "members": [
        "7f8a1cf5-7e86-44c6-8963-92a353bfbb76"
      ]
    },
    {
      "cluster_id": "70912902-8988-4e45-a0c6-4af51f1f19b7",
      "members": [
        "fa21c44f-10de-494a-bbbe-7455764fce61"
      ]
    },
    {
      "cluster_id": "d2250c76-7e85-4e68-9f7d-cb54aa712276",
      "members": [
        "450824d4-1392-40e7-b3f9-e852eda731e6"
      ]
    },
    {
      "cluster_id": "e0e1af6a-37f3-439c-b966-bdff95698e49",
      "members": [
        "a407f1ea-84a9-4862-9623-d0f02324a925",
        "4e359298-f7bc-44e1-a224-0d0d64bb4b78"
      ]
    },
    {
      "cluster_id": "20024815-8b0e-4e7c-9c28-eb57a4f0783f",
      "members": [
        "1fb6cbaa-6f17-4673-9222-f8aa61df3dfe"
      ]
    },
    {
      "cluster_id": "adf0e4d7-03fd-41b1-8559-5505d4d67e0a",
      "members": [
        "fb1d07b2-9e47-4a10-88aa-536aa36cc193"
      ]
    },
    {
      "cluster_id": "c0f8ea6d-76da-48d4-a14a-869a34f021c4",
      "members": [
        "434a0c97-e17d-4d14-97e5-31f3d65ff4c7"
      ]
    },
    {
      "cluster_id": "544dff2f-0e7b-440b-a330-646db7ed3912",
      "members": [
        "a6699444-1c15-4a1b-b989-45e880eb841f"
      ]
    },
    {
      "cluster_id": "5071d605-12eb-4c65-9753-bdff2ac75ffe",
      "members": [
        "7fee2983-68d8-4bea-8382-aaf5b47fcd8e"
      ]
    },
    {
      "cluster_id": "50755387-4b1a-4d72-9887-7b05aa4bf186",
      "members": [
        "87a6eddd-368b-4b2c-8ce6-4183e0883d0e"
      ]
    },
    {
      "cluster_id": "53832c20-28bd-4cb2-a22b-7698f81c17f5",
      "members": [
        "b5f6a11b-a40d-4ef3-8f9d-f4de13cd21bc"
      ]
    },
    {
      "cluster_id": "77e5cfa7-27f5-40a9-879d-0ba7cd2177f2",
      "members": [
        "c9ec4dfe-5a42-4ba1-bee9-2706c05e1576"
      ]
    },
    {
      "cluster_id": "08f28ba1-ced8-47f4-a0a0-4116b507d143",
      "members": [
        "e9996b37-aa80-4b89-958d-cd2794166a31"
      ]
    },
    {
      "cluster_id": "53a00b92-807b-43f5-846e-1b35127294fe",
      "members": [
        "2ea323ee-7eb0-4343-a31e-85470c2314ba"
      ]
    },
    {
      "cluster_id": "e72ec6a2-4890-4444-8e7d-1a5032e251dc",
      "members": [
        "bedd2194-59d1-48fc-86f9-f0234b938fda"
      ]
    },
    {
      "cluster_id": "56106773-dee4-4da1-bda2-7227784468b3",
      "members": [
        "f185416f-21f7-499d-9024-947736bf13bb"
      ]
    },
    {
      "cluster_id": "6c806f4f-f4b8-4c40-ad97-ff6d0d5a2a84",
      "members": [
        "44ccc072-a642-46b2-a1ed-e8af44115c6e"
      ]
    },
    {
      "cluster_id": "b7518287-9949-4ec0-a078-3d7e49009d46",
      "members": [
        "cfdf0f43-c18b-4607-b426-1b3665ed9f5d"
      ]
    },
    {
      "cluster_id": "f1adf470-c92b-4dc8-8ffc-81d2f8af3978",
      "members": [
        "c80aca95-f4ee-4db0-9443-79b99f87f2d9"
      ]
    },
    {
      "cluster_id": "a8aac635-8bd8-48b4-bd49-e815a9015bf1",
      "members": [
        "4275f6cd-180d-40e0-90e7-59efab35c9a6"
      ]
    },
    {
      "cluster_id": "c35c9880-b71e-4b4b-b29a-43c7d18291ae",
      "members": [
        "f3818da0-99d5-4657-ae45-99914fdb6909"
      ]
    },
    {
      "cluster_id": "32cbf301-8c69-47b6-aa84-5617ee08686a",
      "members": [
        "11f8aac3-1ffa-48e7-80f7-f68918c4a2ad"
      ]
    },
    {
      "cluster_id": "2e96e776-35fc-4f23-940d-ba30ac558d05",
      "members": [
        "91062d1e-d101-49f1-9191-a3f8b2dbbc0c"
      ]
    },
    {
      "cluster_id": "60b30dc1-39f7-4e54-a8fe-0ca30098499b",
      "members": [
        "185c2416-6c1c-4899-82c6-53a5a453c87e"
      ]
    },
    {
      "cluster_id": "0c9ec8a0-bb91-48f5-bf6f-13507a3c2374",
      "members": [
        "5570d93e-328c-4a37-84e4-2e8f29e8928f"
      ]
    },
    {
      "cluster_id": "efc28260-5d9d-4934-8e08-cb0eaf327cf6",
      "members": [
        "96dec6e5-f568-4d57-812f-b87d6c8daf10"
      ]
    },
    {
      "cluster_id": "5f2eb0b1-e72b-4484-b09f-d3bfdfdaf028",
      "members": [
        "2aa899b0-a95e-44e8-8f1f-d08495395787"
      ]
    },
    {
      "cluster_id": "71f8bf24-6193-4f81-97b9-208284481b4e",
      "members": [
        "bd90e9ad-9d3e-4cf4-bd00-4ea1d6f8be9a"
      ]
    },
    {
      "cluster_id": "124f0557-d721-4d00-9466-962e5e5fe3ab",
      "members": [
        "85966416-7d92-405c-bc31-56bbbd8253e8"
      ]
    },
    {
      "cluster_id": "a1617416-4daf-4173-b483-3f65d380f28c",
      "members": [
        "b6ca2d96-e2af-4332-8644-c3bbbd11b213"
      ]
    },
    {
      "cluster_id": "b5041259-ba71-468c-b2f9-83e8ea0057c6",
      "members": [
        "4e69c14f-7443-4d0a-af69-5182a6c98b4d"
      ]
    },
    {
      "cluster_id": "40a7eabf-afd2-4baa-a287-e3b8fad136d9",
      "members": [
        "3a13ed57-ac5e-43c8-90bf-8cd66bf6f503"
      ]
    },
    {
      "cluster_id": "b3909552-dab5-4658-b73f-34338b406557",
      "members": [
        "74caf7c4-d50f-4495-8c68-52fe77e6cf1d"
      ]
    },
    {
      "cluster_id": "a22c2709-36d1-4c69-91df-446cf30d0361",
      "members": [
        "47582a6e-7aee-49e6-9a90-70c25b54b570"
      ]
    },
    {
      "cluster_id": "cf071659-f57a-47ef-8e58-d5ef07d53221",
      "members": [
        "6e95a689-eb28-4092-8f24-54d8232f394e"
      ]
    },
    {
      "cluster_id": "a04f0354-7f2d-4806-8bf1-4cf23f67439b",
      "members": [
        "66307a24-6752-47c1-b14e-19ba5f2f2e2b"
      ]
    },
    {
      "cluster_id": "4f640a26-8edc-40de-bddc-8bc4a09eb227",
      "members": [
        "ccca6a2c-bbf6-41c6-b927-d092d6835a64"
      ]
    },
    {
      "cluster_id": "fcae1625-9dc6-40ce-b828-c6881213b7e1",
      "members": [
        "73eb341e-b0a3-419e-8644-315fefca12f8"
      ]
    },
    {
      "cluster_id": "173f883f-de30-4d47-bca3-522527267a76",
      "members": [
        "0f36c619-8e14-445d-9ff6-652907201f8d"
      ]
    },
    {
      "cluster_id": "88679d89-9148-493b-84ed-a40bc977a620",
      "members": [
        "e85fec14-f53d-4f03-8782-2d509817cdcf"
      ]
    },
    {
      "cluster_id": "752ad0a4-463c-4695-a371-bfed4c14cfc2",
      "members": [
        "3c065b5a-a536-4694-be46-2fa75a6abad9"
      ]
    },
    {
      "cluster_id": "35d3b29d-3d0c-4461-8663-4b180f0aaa41",
      "members": [
        "32c16bd5-4905-4d1f-9dc9-527ca0e29b56"
      ]
    },
    {
      "cluster_id": "e3188c04-70d3-4f55-ab68-49043c888c8a",
      "members": [
        "5cdb36f6-ae0d-4c33-85a4-c023f5d57ee9"
      ]
    },
    {
      "cluster_id": "6aefa1fe-d0f8-4db4-8968-8fa277506a8b",
      "members": [
        "9d29c1dd-4f43-4ab8-88f8-11e3b2827272"
      ]
    },
    {
      "cluster_id": "aca283ef-ca7e-47bb-9faa-cd0f44fb7b50",
      "members": [
        "1e1a3c21-bcf0-4394-89a7-ce8a6ebb377c",
        "a2f08d79-7fe6-4418-9146-13672ec98ce0",
        "65eb6438-fe45-4492-b34b-a62197cf6a90",
        "1379ed5a-dc8f-4dc0-b83c-3ac31cd9020a"
      ]
    },
    {
      "cluster_id": "13dc8122-3135-4fd1-a900-1e2308b14e34",
      "members": [
        "429193ad-842f-44da-afc5-3dec6e99744f"
      ]
    },
    {
      "cluster_id": "815c147f-e9cf-4afc-9a1d-d83dea6ef481",
      "members": [
        "ecdd329a-e084-4edb-97b8-6cd18aef672b"
      ]
    },
    {
      "cluster_id": "759b22c3-b9e1-49af-a4a6-7bcb4d79d24f",
      "members": [
        "5571cb87-63cc-47c7-8d84-d91f1754a41d"
      ]
    },
    {
      "cluster_id": "87b42d69-1e6c-402c-99c5-e722d6abf4ce",
      "members": [
        "58187aec-19c3-49ac-b926-cc221022d989"
      ]
    },
    {
      "cluster_id": "12b1cdcd-4e31-4b05-ae44-98d5b446ed03",
      "members": [
        "5d78dde1-be3f-4bf2-ba05-56ce0a3bd4f4"
      ]
    },
    {
      "cluster_id": "bd30dba7-ded3-462d-90f7-5fc4ff649bd4",
      "members": [
        "c304c132-ef7f-42b3-add5-d5b7d3fb88a5"
      ]
    },
    {
      "cluster_id": "5113736c-e1bd-4cef-a0d0-94d26dc8aee3",
      "members": [
        "21859aaa-2d71-4c1a-8366-63800b3db547"
      ]
    },
    {
      "cluster_id": "a0499a4f-f80f-4f0b-ab10-3a54901c48a4",
      "members": [
        "3bc6fa9c-20b7-4020-a917-396b142d7587"
      ]
    },
    {
      "cluster_id": "c577dcab-43f4-4988-b6a9-b023d7e8abb2",
      "members": [
        "ca5532c8-cdca-4755-8314-fa874bb46c3c"
      ]
    },
    {
      "cluster_id": "bd4e1aad-4b42-4afe-bdd1-8b68fcb5aa16",
      "members": [
        "73c9e515-b050-482c-a37c-960afe733109"
      ]
    },
    {
      "cluster_id": "e15ef239-9f26-4808-8bf7-31e94108dff6",
      "members": [
        "37a4f01b-94b1-423e-80e0-2683732abcb9",
        "531512c9-2ff0-45a1-94e5-5f41bd786ffa"
      ]
    },
    {
      "cluster_id": "9e044845-6768-4b18-b4e5-13d72ace241e",
      "members": [
        "f2c01a33-1ddc-412a-ad6e-7b1540c343bf"
      ]
    },
    {
      "cluster_id": "8f04e04a-ea8d-4a08-9f4b-0027f1697329",
      "members": [
        "95a03a51-dbf0-403d-90f9-f300942b3ba2"
      ]
    },
    {
      "cluster_id": "386f4b6c-ead4-4444-9916-d94cb574f068",
      "members": [
        "1b4a205b-74f1-44bd-81fe-e1ce90cf9854"
      ]
    },
    {
      "cluster_id": "3b4e6d34-1c11-4402-8f08-680cd1dda0c6",
      "members": [
        "906b4a52-a777-4545-92dc-c04cf5c063ac"
      ]
    },
    {
      "cluster_id": "21439ac6-d6cc-43c2-9360-f892b94daf83",
      "members": [
        "cbe55de5-2caf-43ee-ba13-5ad9e99bd3d3"
      ]
    },
    {
      "cluster_id": "4791dca9-cb90-4716-841a-c69798c940f2",
      "members": [
        "cc635954-d212-406c-af7b-64d61e9232a7"
      ]
    },
    {
      "cluster_id": "750243e1-18a5-4108-92d0-c8875b6d7be7",
      "members": [
        "5fc8c4c4-d8df-4a71-bfab-f21ac22ba5d5"
      ]
    },
    {
      "cluster_id": "b26ec24c-184f-463d-a8c5-4ef885956b1c",
      "members": [
        "f3bcdfdc-f86a-49ca-b399-1aabe7da2bbc"
      ]
    },
    {
      "cluster_id": "e5db8adb-166d-4129-bd9b-54f680ec3bdb",
      "members": [
        "23f4ac65-fc79-4c77-a7d0-07d4377b7d20"
      ]
    },
    {
      "cluster_id": "44ed705c-5a34-48f9-ae3d-7f96124493a0",
      "members": [
        "446b57ea-cf92-4a32-b8cb-8b784adc0166"
      ]
    },
    {
      "cluster_id": "58acdbed-8f15-402c-b1b3-c0a3be3ee80e",
      "members": [
        "5b1e3132-4460-4a38-8cb3-ff9a2ac8826a"
      ]
    },
    {
      "cluster_id": "d3ddf15f-7261-4b4f-bdd9-6823755811e6",
      "members": [
        "b085f7e0-13f6-45fa-a7b9-aeeda8e4bb0b",
        "94c08630-0cd5-48a4-ac1e-abb0096a007d"
      ]
    },
    {
      "cluster_id": "e49682e3-c065-43da-be61-a86567e3397f",
      "members": [
        "aa7c1c7f-0d44-49c5-ae8e-b066be962441"
      ]
    },
    {
      "cluster_id": "6f2fde83-d0f8-429a-88dd-e73036fda6d0",
      "members": [
        "66ad7bc0-9ff5-4228-a9e6-565bf22c9f50"
      ]
    },
    {
      "cluster_id": "c6f49d61-1bb8-4b16-b016-0bde6b721c6d",
      "members": [
        "3fa896da-b3be-44c8-85b3-060314d71ec8"
      ]
    },
    {
      "cluster_id": "121c0233-5b70-408f-8b70-e5ac0b37c748",
      "members": [
        "aac764ea-a66b-4f31-941d-ffbb819af7d0"
      ]
    },
    {
      "cluster_id": "6fca3548-19e0-4797-8ca7-1e10435f142d",
      "members": [
        "b2e5de87-855f-4995-8336-4d6a9399c505"
      ]
    },
    {
      "cluster_id": "c2f88444-099f-4cbf-b8aa-27e4b2666137",
      "members": [
        "31e6662a-c5e2-4acf-8ce6-df814b728b1a",
        "c7eaa53f-6708-4973-a6e1-5dd6a6496de3"
      ]
    },
    {
      "cluster_id": "615af33f-6193-4bde-a85a-a2576bad24e7",
      "members": [
        "ca55d25a-0401-4df1-936a-1376aebf51d6"
      ]
    },
    {
      "cluster_id": "f140fd40-63a5-49d3-9d17-1114828f483b",
      "members": [
        "139daf56-007b-42d6-aa9b-9b1cfcbaf5a6"
      ]
    },
    {
      "cluster_id": "f5b1b3d0-19e5-49a1-bbc1-690d440e299c",
      "members": [
        "bf10343b-f909-43fd-af82-06c1e21d46dc"
      ]
    },
    {
      "cluster_id": "4794bb46-add2-4c57-9ffb-caa8d6c5bb0f",
      "members": [
        "b852f69b-afb4-4dfb-af15-e891f23b224d"
      ]
    },
    {
      "cluster_id": "8e8e8bbd-6670-4f01-810a-e901866d96f8",
      "members": [
        "c63eced6-5d16-4f1e-88a0-0091665a90c0"
      ]
    },
    {
      "cluster_id": "fa2c7516-f196-48a1-815e-d89c4e4b9860",
      "members": [
        "66be13c3-6124-4d46-9fbd-e2f1aae2457a"
      ]
    },
    {
      "cluster_id": "15d3bc51-86b6-41c4-8d7b-a993e63544da",
      "members": [
        "f222f463-960a-41c7-8add-ca05baf14cdf"
      ]
    },
    {
      "cluster_id": "f315f787-a973-49cc-9719-20a3bfead1b0",
      "members": [
        "b0eae12c-8aea-4fd6-ad6e-c46f1e03cf3b"
      ]
    },
    {
      "cluster_id": "5291aa5f-51ac-492f-83f7-3c48258f1866",
      "members": [
        "5e77b394-bb3a-4aa7-96b7-903d5eb45d32"
      ]
    },
    {
      "cluster_id": "b9809c93-42b6-499a-9f8e-13df798b0605",
      "members": [
        "8c107dd6-605d-4017-a9bd-33e6ba2712aa"
      ]
    },
    {
      "cluster_id": "7b2da9c5-ac6d-44df-b539-9a5ad8a18762",
      "members": [
        "2e7877d8-7bc2-44aa-97f3-885ee1f7b7c8"
      ]
    },
    {
      "cluster_id": "00be0a5e-79b9-4671-8dc6-befc37464ba9",
      "members": [
        "92170761-229f-4faa-9360-128f73ee18ea"
      ]
    },
    {
      "cluster_id": "602cf518-8d43-4cc2-9f69-aa005257dd2f",
      "members": [
        "a1cec6e8-9f55-45dc-8b12-ac0c718e1958"
      ]
    },
    {
      "cluster_id": "c3a97d86-3ef3-41b9-9b1d-e19ad5caca74",
      "members": [
        "339603cf-d217-443d-84aa-919573e582a3"
      ]
    },
    {
      "cluster_id": "7881b67b-b21c-40a3-ac70-ae067b94075c",
      "members": [
        "2cbcdcf5-3172-4520-9520-fe93506b4118"
      ]
    },
    {
      "cluster_id": "0751c6cb-9d71-46b3-91e2-7b78341d2ce3",
      "members": [
        "38efc9d6-8d2c-44e2-b8ef-a3cfcec9d8ab"
      ]
    },
    {
      "cluster_id": "77420d84-761c-4596-b8a9-5aa8adb89a0e",
      "members": [
        "740097a6-3475-4c42-a063-6d57bd424dce"
      ]
    },
    {
      "cluster_id": "154bbf48-da4f-41b3-ba55-27ca50e6fa44",
      "members": [
        "8eb4cb0e-7b9a-4f13-8e1a-da24d629fdfa"
      ]
    },
    {
      "cluster_id": "835823ac-6b1a-4b3a-9f19-567a3d13955c",
      "members": [
        "3549f487-ce14-40df-b2d6-fcc4513c8785"
      ]
    },
    {
      "cluster_id": "ef96efc5-2acd-42e3-8b8d-c3fb75af951a",
      "members": [
        "f6716a58-9b2f-455c-90ca-18000499c8fd"
      ]
    },
    {
      "cluster_id": "66d1e8de-40d0-4ef4-80a2-bb8b898bdabc",
      "members": [
        "e6253f6d-ecac-49af-9e41-e9fabbfd8e44"
      ]
    },
    {
      "cluster_id": "9be937d1-1aab-40a0-9206-7301e1897a68",
      "members": [
        "fe1f81b2-1744-41f8-b4e4-aabc8202821e"
      ]
    },
    {
      "cluster_id": "ad140612-2296-4f06-9b90-8018512776b7",
      "members": [
        "004e3aa8-4727-4367-8257-4ebff0af8a68"
      ]
    },
    {
      "cluster_id": "9707f2e5-6c57-41c7-a2b2-7fd6a30159c3",
      "members": [
        "82c9f4b5-c38c-451a-8ad2-14f8edcc6b84"
      ]
    },
    {
      "cluster_id": "2672b11d-4ad6-44a1-9b31-f8c01c03c721",
      "members": [
        "64a9d99e-8e91-4678-aa7f-b728bd5c53b2"
      ]
    },
    {
      "cluster_id": "6a2c5b98-767a-485d-a14c-04f05f90984c",
      "members": [
        "ec64a4a4-f829-484d-8869-7c9eb4db9c7e"
      ]
    },
    {
      "cluster_id": "3a17531b-ae78-41a3-b63d-f61bcc85a26a",
      "members": [
        "bbb5cc6b-3b9d-484e-85ce-d24c3c292f70"
      ]
    },
    {
      "cluster_id": "28b8266b-a1c9-4314-9300-fcc436685496",
      "members": [
        "dc94773d-e525-4ece-af42-d49b116e49ec"
      ]
    },
    {
      "cluster_id": "0af9e942-0bcb-4d79-81df-118cf826ff70",
      "members": [
        "d187f29f-d494-4ca9-8866-e9da236be814"
      ]
    },
    {
      "cluster_id": "5e50bec2-0cb9-42e3-b94b-de915ce6a4d5",
      "members": [
        "6294c61a-6abc-46e0-a49a-abf7a17ad549"
      ]
    },
    {
      "cluster_id": "4e97ff0c-8732-4960-b274-1090e77ec733",
      "members": [
        "66b58dc0-50b5-4540-adba-a4e76fb91d67"
      ]
    },
    {
      "cluster_id": "b24ff026-a9a6-45e3-8927-422954af4cf6",
      "members": [
        "383b6c54-a4cb-4059-ad3e-ea0d13e45cc6"
      ]
    },
    {
      "cluster_id": "3014a508-0ddc-42e0-9480-97e1310e1f29",
      "members": [
        "ca6674d7-a991-469f-b21e-3b470642ac02"
      ]
    },
    {
      "cluster_id": "c04b6a1d-f91c-44bf-b579-d5d4565fc056",
      "members": [
        "a68aadc4-aa7a-498a-b29f-5219ac9ea826"
      ]
    },
    {
      "cluster_id": "c011b0e5-baf1-40ca-ae4e-97e2c4bd7b62",
      "members": [
        "7ad52f94-06d7-49c7-b712-801ca6ebb7c8"
      ]
    },
    {
      "cluster_id": "43507aa1-0b73-484a-ae6d-901aa511c57f",
      "members": [
        "a362be59-a2b3-4756-9a27-ec194cf888a1"
      ]
    },
    {
      "cluster_id": "7ef0f102-5c71-4651-96e9-1923d9bd80c5",
      "members": [
        "2d27cb07-d273-4ff8-a885-a605607e9399"
      ]
    },
    {
      "cluster_id": "1919a927-7052-4719-83c2-7118a15e11e3",
      "members": [
        "380afa3f-981c-4fb0-9861-b18e3bcbf7a6"
      ]
    },
    {
      "cluster_id": "cf0fcabf-722c-47eb-957b-91614bc676e4",
      "members": [
        "6d335fdd-9f9d-41fe-95a7-51649780ed03"
      ]
    },
    {
      "cluster_id": "5688bb4a-4059-431b-b1bc-a991bc5ccd0e",
      "members": [
        "e5dde201-20e3-4ed7-8581-0ce2fc39ce70"
      ]
    },
    {
      "cluster_id": "d7af883b-7f94-40af-b74c-503163e2b062",
      "members": [
        "6c07e308-30de-4c20-8eed-8cb8fab78ac0"
      ]
    },
    {
      "cluster_id": "c278122a-3daa-4207-bb75-b0bf1f432ea0",
      "members": [
        "e3bd4def-67ea-4e41-acd9-45bdc62350df"
      ]
    },
    {
      "cluster_id": "facc7561-4a20-4459-a43c-a6df1f7f9d23",
      "members": [
        "4eb1e6c6-4c04-4fb1-9b4a-e12422fcbe0c"
      ]
    },
    {
      "cluster_id": "aeaa0391-95c5-43bf-a72e-66d04a052ba3",
      "members": [
        "949cc13b-3f00-4a84-872f-1468848fa3cb"
      ]
    },
    {
      "cluster_id": "e45a7fdb-d8fc-4ccb-adfb-88a463256b7d",
      "members": [
        "e0d59cbd-fe06-44e6-9e57-683460942560"
      ]
    },
    {
      "cluster_id": "45e218a6-8801-4755-bcad-4c7f5bec819d",
      "members": [
        "e9fec56b-bda7-405e-9874-715a2d84cc3c"
      ]
    },
    {
      "cluster_id": "69235fb0-8a7b-49cf-8a07-8d2aa290c9c9",
      "members": [
        "0531bca5-6f01-407b-a777-e27ae1b12d71"
      ]
    },
    {
      "cluster_id": "128219b8-57d3-4f9e-bdf1-0447f6eb1ba5",
      "members": [
        "452f19a1-c9a7-4dc9-a417-a4163cc29164"
      ]
    },
    {
      "cluster_id": "7ca6b83e-0750-42ad-b001-d24a26fccbeb",
      "members": [
        "d05ea7fe-5f24-45d6-9a3d-fcbd501c5e60"
      ]
    },
    {
      "cluster_id": "dfa97197-5724-4a7b-bce9-4a9f24f7056d",
      "members": [
        "15147e88-47de-416d-9926-84fe660a5bd2"
      ]
    },
    {
      "cluster_id": "39c57d47-c79f-4298-b9b0-1dca0020b6aa",
      "members": [
        "d7007eff-53ac-46e5-8d8b-f2f5808280ef"
      ]
    },
    {
      "cluster_id": "337480a5-b05e-40ea-b813-e79cc37e4e00",
      "members": [
        "8cd7d895-d72f-40f2-812f-beff65f4fbc3"
      ]
    },
    {
      "cluster_id": "fb90f205-10b1-4a80-8c76-1265d7a47a4d",
      "members": [
        "a8e258d0-7a7b-4aef-b1a3-9162e909dee2"
      ]
    },
    {
      "cluster_id": "771e3903-1d96-4871-b3f7-ccc8c72d8493",
      "members": [
        "3fba4d5c-3ee1-4b90-9114-934702074018"
      ]
    },
    {
      "cluster_id": "9d77a640-6134-44b7-85bb-43fc8324bd77",
      "members": [
        "c9fe7617-e8d9-453c-be7c-26d3d7a1e970"
      ]
    },
    {
      "cluster_id": "b4fb9256-1ac5-4cb5-9d11-a73a825665b3",
      "members": [
        "b37d9311-a201-4634-b0be-4b9dc697c076"
      ]
    },
    {
      "cluster_id": "77a0df8c-7608-483b-a706-3897667bbac6",
      "members": [
        "801625a1-7548-4660-b67e-c9b4e1df4d39"
      ]
    },
    {
      "cluster_id": "45319dcb-5d0b-4d01-90b1-03022e3ef700",
      "members": [
        "14d759b1-9f29-43bd-88c8-de19d3207ad3"
      ]
    },
    {
      "cluster_id": "b70fcbd6-9ed5-4bd6-a526-8679fde82331",
      "members": [
        "3695f38b-cdde-4db9-99a4-262c0769b252"
      ]
    },
    {
      "cluster_id": "cac0be30-203f-425a-ae61-9f6f21636075",
      "members": [
        "b3d0ff6d-32e2-4e8f-a950-bd3ced38cfed"
      ]
    },
    {
      "cluster_id": "64e778b1-1770-4087-ac56-445bf339b8c2",
      "members": [
        "affe057e-7142-43d7-927a-362e3310a150"
      ]
    },
    {
      "cluster_id": "20c1ad4a-8c5e-407a-b67d-ed4158ca87ec",
      "members": [
        "093af7ef-f8c3-4277-b887-feb350730d2c"
      ]
    },
    {
      "cluster_id": "a1f572c9-19e4-4da8-b35a-87c376dc4fa0",
      "members": [
        "57c8255d-a207-45bd-a773-01c8b3e004b0"
      ]
    },
    {
      "cluster_id": "13220774-7cb5-4388-b12f-a0737d93673b",
      "members": [
        "17c44ab0-58b1-4dab-8cf7-2264ccf37aec"
      ]
    },
    {
      "cluster_id": "5db4a15c-7ce5-458c-89da-0e71f2e155d8",
      "members": [
        "fec02486-c6e8-4284-bb05-729f62a1101b"
      ]
    },
    {
      "cluster_id": "cf5c8ab9-6f4a-4ef6-84b1-7fb025d62c2c",
      "members": [
        "59f262f9-054b-4bee-8ad9-ab207a5ab04e"
      ]
    },
    {
      "cluster_id": "336f2ec9-9cdf-4236-a126-80e564dfeb50",
      "members": [
        "9bfa6c99-6397-4e36-9292-be2b2e541947"
      ]
    },
    {
      "cluster_id": "528d38ac-7716-475a-b7f4-71caee3d9abf",
      "members": [
        "ff080f9f-615b-48e7-b27c-7d16d778d50c"
      ]
    },
    {
      "cluster_id": "e0978a2e-1125-4e65-9d19-ea0e822bd88c",
      "members": [
        "80a18546-a9f1-4a36-a3f3-a225649be4bb"
      ]
    },
    {
      "cluster_id": "61d73230-504f-4e81-a2e0-6fec552c5517",
      "members": [
        "72cbdf45-7fcd-4c0b-a5b3-813722f29224"
      ]
    },
    {
      "cluster_id": "a663162f-90e6-470c-9356-50de41099dfc",
      "members": [
        "8f0ffecd-2bd2-4568-afb4-65dda8d35d01"
      ]
    },
    {
      "cluster_id": "bf67fbdf-c97d-45ea-aca3-181ca579afe4",
      "members": [
        "39055a63-9c6d-45c9-98ef-8513c7e78bc6"
      ]
    },
    {
      "cluster_id": "d28e35dd-84d1-4e21-9131-912aee49eabd",
      "members": [
        "fb531a15-8aff-4353-a2a1-9aa5eccb96b4"
      ]
    },
    {
      "cluster_id": "0749ed10-4e7c-4fa4-ac39-680414ad6f05",
      "members": [
        "4d204bc2-434c-43a4-b9df-86516e0bab5a"
      ]
    },
    {
      "cluster_id": "b7f1648b-9e5b-476f-a59b-84d94f8583e3",
      "members": [
        "f2221136-70d5-4fe1-b53b-7b08a207d33b"
      ]
    },
    {
      "cluster_id": "4097f204-b4ae-4826-85fe-e2f03051cdcf",
      "members": [
        "09cb4d32-703f-41a9-a5b7-5dad4743a3d3"
      ]
    },
    {
      "cluster_id": "d2a4fdc2-883c-43bb-be4a-653d77acf7ba",
      "members": [
        "b7642cd3-0bc8-4a1d-b545-580ddca192a6"
      ]
    },
    {
      "cluster_id": "bc899377-60fc-4a12-85cb-bbcd12759608",
      "members": [
        "e876aa55-ccc6-4a86-a82c-6c131c26edee"
      ]
    },
    {
      "cluster_id": "a8e462eb-2839-4295-9ab7-03216f0e8610",
      "members": [
        "299d2e55-bc61-4a50-bba6-66ed46b5363e"
      ]
    },
    {
      "cluster_id": "7738ea50-f8ba-464e-a8c6-f4b5554a926f",
      "members": [
        "497b8a3d-7b34-449a-b6a8-91e83200040e"
      ]
    },
    {
      "cluster_id": "02428d36-d8ed-40af-ab42-212bc3922840",
      "members": [
        "e838c843-c42f-494b-a37e-ced69281e703"
      ]
    },
    {
      "cluster_id": "6b8c1ab6-dc22-46f5-831a-de1a865875f0",
      "members": [
        "1eff0a3d-f6cd-4aa1-8d3a-9043c2e6c613"
      ]
    },
    {
      "cluster_id": "143fdbe0-b8f7-4368-95d7-a7983691aac9",
      "members": [
        "cc7198f8-4301-4ba1-8356-b86060cdac49"
      ]
    },
    {
      "cluster_id": "3f685716-0686-4535-807f-feecb0c1246c",
      "members": [
        "37543867-7a98-45b0-8d61-4b2251b582c0"
      ]
    },
    {
      "cluster_id": "b87bc991-27b5-4e76-ab33-22c0374b82e2",
      "members": [
        "3ccc3a01-a487-4b8a-be47-6d4a3a2a0904"
      ]
    },
    {
      "cluster_id": "38dc9a30-7314-4720-8e2e-f17990947602",
      "members": [
        "21f033b2-695d-4e52-b95f-b558e097f44b"
      ]
    },
    {
      "cluster_id": "83a91d6e-ceaf-4824-b195-eb7ebd584c9a",
      "members": [
        "08258c5a-06ae-4452-83ce-367944e44347"
      ]
    },
    {
      "cluster_id": "e91dd131-96fc-484a-8d0e-4bac856ecd99",
      "members": [
        "40c10979-07ed-44f9-86c3-b6799b7f54a1"
      ]
    },
    {
      "cluster_id": "844a0834-978f-47f2-bad3-00baad297b74",
      "members": [
        "c275bfbb-ffe1-4a47-98af-9b5a80b6c744"
      ]
    },
    {
      "cluster_id": "621f11b4-2ba1-45f0-bd1e-92caed87da0b",
      "members": [
        "72ecc1dc-d64c-429f-9c9f-4be7d17d858f"
      ]
    },
    {
      "cluster_id": "120960ec-d747-4eeb-a10b-5a0b594f24f6",
      "members": [
        "50c0933b-59f9-46d0-94dd-8f90735528aa"
      ]
    },
    {
      "cluster_id": "6ad22c58-94f1-4426-8339-5bd33e29da9e",
      "members": [
        "2e9de352-9347-4d4d-a8bc-e3956c08af2d"
      ]
    },
    {
      "cluster_id": "07d6842c-fb2e-407d-bdda-a29d80ba013b",
      "members": [
        "abb7f778-870e-40b2-a550-5eab36008d6e"
      ]
    },
    {
      "cluster_id": "f654e316-c125-44fc-9eae-66baddc079a2",
      "members": [
        "178c06f6-c2d7-4166-bf7e-d2614914d85b"
      ]
    },
    {
      "cluster_id": "00f3a914-1589-47ae-9fd7-4b841e19dce5",
      "members": [
        "f34e68a5-70eb-4dfe-ad1c-a0bfcb57e6fc"
      ]
    },
    {
      "cluster_id": "e353033e-612f-444b-a7df-06c23368eb22",
      "members": [
        "0a2d2ef5-2997-4280-ba09-2cf99a6347d6"
      ]
    },
    {
      "cluster_id": "48fd9ac4-d4c3-4877-b46e-dde80ecc5cd1",
      "members": [
        "99344ff5-7033-46e5-a172-2343c8b0a751"
      ]
    },
    {
      "cluster_id": "a6d41b3b-e930-4fdb-ae89-6fb33dda11d3",
      "members": [
        "a1c1ee08-ed28-4db5-a831-59acdf22f269"
      ]
    },
    {
      "cluster_id": "aa931a1c-d292-40d9-9c54-451d60524b03",
      "members": [
        "e95ec72b-b6d6-4417-bb16-2497cd4cff59"
      ]
    },
    {
      "cluster_id": "61ee629a-3d51-41dc-9089-461569ecf949",
      "members": [
        "cb696a27-f7ad-46bd-a24a-1c2511c4b536"
      ]
    },
    {
      "cluster_id": "01388d43-fe04-46e8-a137-ee7f321c4ae8",
      "members": [
        "d3130946-bf20-4d88-bbfc-7a743c19f84d"
      ]
    },
    {
      "cluster_id": "54f8b2dc-d3d6-42f7-bde0-a8a0038707a5",
      "members": [
        "a38c53fc-6805-46bb-978a-b98d01c02b1e"
      ]
    },
    {
      "cluster_id": "067f4b77-6a0f-43e6-a250-8a682e95f8f7",
      "members": [
        "18dde5d9-a8c1-4134-8a1a-b48330358cae"
      ]
    },
    {
      "cluster_id": "81cdaaf8-571d-4a77-8063-fa5e9510b635",
      "members": [
        "118bfe4a-22c6-4acd-a632-2f96f78840a3"
      ]
    },
    {
      "cluster_id": "c74f353a-07b1-444e-8cd6-e07be020ae58",
      "members": [
        "029326f0-ab23-4cc2-b665-28cb99c7ab3d"
      ]
    },
    {
      "cluster_id": "dae41dee-2a76-4085-8c91-121f704580c1",
      "members": [
        "43e5cea7-5aa8-40fd-b513-fa7aa13d81d6"
      ]
    },
    {
      "cluster_id": "2de07645-b8a8-45f7-bb4d-87637fd094ec",
      "members": [
        "6725a1ba-4023-4162-8159-537ec94e6771"
      ]
    },
    {
      "cluster_id": "ca922fb6-3b82-47fc-a5a7-c1ff0c4bff12",
      "members": [
        "9726f123-3a84-47e7-a294-1eed84f61a26"
      ]
    },
    {
      "cluster_id": "c3f8efea-527f-4eda-8f86-1b201d526c1e",
      "members": [
        "81e0c562-9db7-4aa3-a2c1-b4f864f16a9c"
      ]
    },
    {
      "cluster_id": "8f9c10a7-b7f4-4bce-895c-bb65278b679d",
      "members": [
        "eea13ed3-dccf-446f-998f-735b0ea2d09a"
      ]
    },
    {
      "cluster_id": "e39260dc-c205-47ec-aba4-6672ed7e1722",
      "members": [
        "ef520cf2-7d18-4465-bea8-d978c2295e1e"
      ]
    },
    {
      "cluster_id": "7b8722b8-a7de-40ea-80c1-4cf1e7b13571",
      "members": [
        "fa7e1324-b0b9-4ff6-bdc0-6259cd84da93"
      ]
    },
    {
      "cluster_id": "002cfac3-c97a-4ec1-b743-37eb0267aef0",
      "members": [
        "c6582463-5f7d-4cfe-a8f8-6c66c1c335da",
        "4279a432-41f9-4319-a3e0-6dbc7b8e4a6c"
      ]
    },
    {
      "cluster_id": "108f968f-7171-480b-9225-ebaea32953bb",
      "members": [
        "9a382c40-da0c-4d85-8cd1-9c2ebea1c96b",
        "64b6ac59-947b-4ff6-ae5d-2d3f567513fa"
      ]
    },
    {
      "cluster_id": "96dc4289-9f74-41d4-905d-780af68fcb09",
      "members": [
        "2a63e9a0-e29d-4060-bb0d-3468106d7324"
      ]
    },
    {
      "cluster_id": "a4eff04d-c7b6-4d4f-a9de-6ac6a11bad77",
      "members": [
        "e3a2dbb7-08c2-4c29-9af0-05d39d0c1db5"
      ]
    },
    {
      "cluster_id": "9d822f9c-32a6-4f43-9fd1-5ddd226c8add",
      "members": [
        "9f90264c-7944-46c7-8681-78318e8d1355"
      ]
    },
    {
      "cluster_id": "069833ab-70fd-48fa-80f9-9eed2484a21e",
      "members": [
        "68641234-420a-4329-90f9-bffadf38cf2c"
      ]
    },
    {
      "cluster_id": "c89da02e-a1bc-4522-a452-82abf8c705c4",
      "members": [
        "6eed197c-bb50-4b7c-a189-a980a1656ac3",
        "abdb6419-f54d-4ea6-a065-163aaececd61"
      ]
    },
    {
      "cluster_id": "e657af4a-ab5e-4efa-9539-dbb94e69e772",
      "members": [
        "990812e0-4f86-494f-beef-eba27006dff4"
      ]
    },
    {
      "cluster_id": "03dc9e1b-5b04-46ff-b424-59158328eb35",
      "members": [
        "c2c64aec-c935-49b0-afcc-72fccbdcc3a5"
      ]
    },
    {
      "cluster_id": "9f78a266-9f3f-46d5-948b-3b4d3da9a083",
      "members": [
        "f968d171-b816-46c0-bfa0-fba146815ece"
      ]
    },
    {
      "cluster_id": "f06698fe-6625-4ba7-9978-7a2aa54fc4c9",
      "members": [
        "9f765438-218d-4074-9cbb-6a99cfc6b719"
      ]
    },
    {
      "cluster_id": "305d4d39-012b-4cce-bd6f-017ddf94a842",
      "members": [
        "d803b683-bf2d-480e-b71a-2f96bdbcf286"
      ]
    },
    {
      "cluster_id": "11103fe7-e53a-478f-ac79-6e43af250e15",
      "members": [
        "7bbf868a-826e-4db5-a17c-44573886c777"
      ]
    },
    {
      "cluster_id": "a50cab62-c330-4a2e-b634-2fd8a82ebcfe",
      "members": [
        "a3483f04-4bc2-48ff-ab5f-da1743021afe"
      ]
    },
    {
      "cluster_id": "e614332a-840b-4b45-8ec4-5184a874c6a8",
      "members": [
        "e27900e5-e395-41bd-9e8f-7e9184605552"
      ]
    },
    {
      "cluster_id": "0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3",
      "members": [
        "15ba355f-65bd-41c2-bb80-d915bc29a320",
        "9d1576e4-3a78-4fdb-8e00-0e46b85db6fd",
        "e24110d5-1180-4c16-bc38-795134e27b4f"
      ]
    },
    {
      "cluster_id": "139b8293-aa0f-409e-8a4f-0e3ee1191f72",
      "members": [
        "bef21526-75d8-4ec5-8762-f4c10f0c6966"
      ]
    },
    {
      "cluster_id": "4ca4751a-06c9-42b9-935e-8c293fd1cd2e",
      "members": [
        "6385f0ee-fc6e-4be6-a532-2d855f27de42",
        "707cfe8f-a312-4565-a0e8-0b194b657b05"
      ]
    },
    {
      "cluster_id": "5be5d4e4-f894-4929-941a-785184a9901d",
      "members": [
        "be9d0715-a081-4e4b-bfc0-abb30b56e22f"
      ]
    },
    {
      "cluster_id": "9ceeac8a-9421-42a3-9891-76c4ef2d8151",
      "members": [
        "4413ab91-f03a-4a79-8f9f-bc195fa9468a"
      ]
    },
    {
      "cluster_id": "b4a8f883-fff2-467a-ae3a-3ea74c8cac30",
      "members": [
        "de7f06e0-ab3a-4af8-a892-e30335092fc1"
      ]
    },
    {
      "cluster_id": "5345ad5e-9fbb-47ab-a820-0caca6e3cbd3",
      "members": [
        "a389d09d-c70e-4f32-8f4f-fe1d1a9181d9"
      ]
    },
    {
      "cluster_id": "5a9b6351-c522-46ce-b100-d164df2f3ed9",
      "members": [
        "7982bb8c-32dc-46d0-b1fb-bdd657baab28"
      ]
    },
    {
      "cluster_id": "2a04252f-e78e-41fb-93da-f1bb87ae8d3a",
      "members": [
        "1fbaaae1-6e8b-4e15-ba6e-69100367c7cf"
      ]
    },
    {
      "cluster_id": "0b7b0dfe-c42a-4dfa-8860-0ff61e6cc75e",
      "members": [
        "e9e5e622-efb4-497d-a4d0-2e931b17806d"
      ]
    },
    {
      "cluster_id": "c9895da0-2b5a-466d-80f2-7637e4a4aa2f",
      "members": [
        "18af0ef6-7e14-4b53-8284-cbd053fc539d"
      ]
    },
    {
      "cluster_id": "58794c22-3f6d-401d-8ef2-ec12fd369ff0",
      "members": [
        "ebaea4e5-dcd3-4432-a770-e32381475f95"
      ]
    },
    {
      "cluster_id": "993e530a-4835-4641-a20d-ee6860332c74",
      "members": [
        "f648b2b3-3a41-4e93-85c0-b818c09744fd"
      ]
    },
    {
      "cluster_id": "c48b1546-3855-4755-8da6-3e9352505d7a",
      "members": [
        "49b6f7ee-c490-4e97-b9be-cd1cdb389f4d"
      ]
    },
    {
      "cluster_id": "3b95c6b0-416b-4f6d-9aaf-3287913c0c2f",
      "members": [
        "2f765095-3367-4bc4-bb5f-c8c33226edc8",
        "d86844d0-23a9-4b88-8229-737a1ccab748"
      ]
    },
    {
      "cluster_id": "6ea587ae-3fa9-4e28-822a-cbebc0ee85f8",
      "members": [
        "22b397c9-5e00-40bd-8e3b-a23dd98284d9"
      ]
    },
    {
      "cluster_id": "0404c137-e8e8-457f-ae4b-121032548258",
      "members": [
        "804c22b2-4b27-4c7a-a9c1-8e0d56576d0b"
      ]
    },
    {
      "cluster_id": "7167c7d7-52bf-4753-8c56-a05326df7c57",
      "members": [
        "87e47acc-97a6-4c7f-baaf-2ab092ddd69d"
      ]
    },
    {
      "cluster_id": "1dd73410-26d1-4ffe-8c70-64b5d5bf9994",
      "members": [
        "56869913-81a3-4dc9-8932-4a209478fb3f",
        "96e3dce7-9eba-4438-ace4-aa43e5d214d6"
      ]
    },
    {
      "cluster_id": "42c65788-8111-41df-929a-ce02cb092330",
      "members": [
        "f4405dfb-c941-412f-857e-5a77f34b5f32"
      ]
    },
    {
      "cluster_id": "a9534c6f-c812-46b1-a237-7680deaae455",
      "members": [
        "71efcdd0-feba-4f17-9df6-806c0141cbb0"
      ]
    },
    {
      "cluster_id": "680ddc35-25cd-424c-8914-0f7a5b222416",
      "members": [
        "b42bcfde-d9f8-4371-9d21-99670eef9a28",
        "f90c99fb-0f68-4211-8cea-f680b42202d2",
        "8e768813-5b66-4e37-83ec-123e5540c0d2"
      ]
    },
    {
      "cluster_id": "8a43f903-0edb-4ccc-94e1-29dd080da2dd",
      "members": [
        "d7440efb-31e2-4628-944f-50e9967a0277"
      ]
    },
    {
      "cluster_id": "6c73f0ba-1131-48ad-8cc3-b8a29be7cfff",
      "members": [
        "957fb997-6d99-4b89-adf6-7215d9d822c9"
      ]
    },
    {
      "cluster_id": "031a0aad-21cd-4ca2-8a60-5a981bd9de8c",
      "members": [
        "3eb91f38-46c0-4be0-a1aa-bf07ae9029bb"
      ]
    },
    {
      "cluster_id": "bb608fd7-71a8-4a13-839e-8d3ef46c08e2",
      "members": [
        "0d60cc1f-bd32-4137-85e7-ee7f9f32a2d3"
      ]
    },
    {
      "cluster_id": "272822f1-86c1-4fb0-9f4d-41ee4b639a78",
      "members": [
        "83a46f8f-bd63-4e99-ba08-b42d237718ca"
      ]
    },
    {
      "cluster_id": "fb6903ba-fc01-4c20-9ef5-d3ed23d4b4f1",
      "members": [
        "3ff00e48-74c1-481f-bb84-249163637132"
      ]
    },
    {
      "cluster_id": "d02fe9fc-02c3-4085-ae05-7b4e0277028c",
      "members": [
        "9e295537-0a8e-4c97-956f-25a628caf5e8"
      ]
    },
    {
      "cluster_id": "2fba36c8-9087-441b-9f3b-6c08ceeffdb2",
      "members": [
        "7c0677e7-a1de-46b4-8537-3e039fd956a2"
      ]
    },
    {
      "cluster_id": "dd605b4d-33b6-43de-a73f-acf3e8834d88",
      "members": [
        "2de1d368-987c-4a5d-b412-16dff48d5432"
      ]
    },
    {
      "cluster_id": "4deeb553-8438-4bc5-89db-299a071d6d12",
      "members": [
        "feb784eb-895c-4e56-9470-0934560c08a7"
      ]
    },
    {
      "cluster_id": "a42a7921-cdb2-4929-93b9-1642ac38cfed",
      "members": [
        "7caf2bc7-0a29-4338-a5b3-d8d5314c896f",
        "0ae871e4-c93b-499e-9729-35dd7eea531d"
      ]
    },
    {
      "cluster_id": "525348f0-16a2-442b-8f83-be5618731e1e",
      "members": [
        "cd07651b-ca7f-4ba7-a292-e24bbb89d3e6"
      ]
    },
    {
      "cluster_id": "39b04d3b-887f-479b-999b-c671dfd12bd6",
      "members": [
        "43ef1665-1991-439b-b5b0-341027e7c7f6"
      ]
    },
    {
      "cluster_id": "5400c461-7afa-4066-ba64-beb7aef1eede",
      "members": [
        "1055602a-6022-4325-9031-c9da36278c1f"
      ]
    },
    {
      "cluster_id": "7b5742e3-5955-46ac-9086-6f1852e5681c",
      "members": [
        "12dd4744-5275-4005-9cba-eee738bae219"
      ]
    },
    {
      "cluster_id": "970fa237-7a1d-4b64-a4c6-7a158c05542d",
      "members": [
        "6cc6428f-3e2c-40ec-8a01-e3bc7f71b9e5",
        "33969a83-f98a-4002-9274-f3c13ff9c373"
      ]
    },
    {
      "cluster_id": "e1c37a48-126a-4576-b497-f9db46d18555",
      "members": [
        "12414278-10a5-4efe-aa75-6b5147a06ade"
      ]
    },
    {
      "cluster_id": "f292e9e8-fecc-473b-b24c-ca3ad9cc0ef9",
      "members": [
        "2921d6b4-fdb1-4fac-b774-3b44892c9a47"
      ]
    },
    {
      "cluster_id": "b99d5f24-fa76-453e-adeb-2b0a207bd3de",
      "members": [
        "7e453dda-1f5a-4c77-8439-29ccd17a064a"
      ]
    },
    {
      "cluster_id": "cd47012a-5cc7-45af-9355-7ba2b5b641a1",
      "members": [
        "cce6161f-61e1-495e-856c-b460794e60d9"
      ]
    },
    {
      "cluster_id": "bd148f49-6e19-46a6-bfe3-a19a292ab17a",
      "members": [
        "c8740bfc-0d91-49ed-a628-3e66fdb712d4"
      ]
    },
    {
      "cluster_id": "83cb9288-d8bc-4d51-803b-71e04c61fa41",
      "members": [
        "ec1eaadc-9853-423b-bd50-674470b40015"
      ]
    },
    {
      "cluster_id": "a7f8bf9e-86b1-4c85-bc02-6ee66c4f9e1f",
      "members": [
        "2c3a68fc-ce0f-41b8-b95e-db9820f85184"
      ]
    },
    {
      "cluster_id": "4033f6dd-a718-42cc-9426-c47fe47bc182",
      "members": [
        "3fe9ba56-574a-4fbd-bd89-3efc650e8933"
      ]
    },
    {
      "cluster_id": "0791917d-ce61-4b44-9705-c74efbd95241",
      "members": [
        "9d121a0d-cbfc-4f4d-a9b8-25602f209f3e"
      ]
    },
    {
      "cluster_id": "08268346-74f3-44b1-a6ed-3517ea134f57",
      "members": [
        "a1143634-530f-4ddf-bd27-0031ce6cbeff"
      ]
    },
    {
      "cluster_id": "95b52cd8-d8dc-42df-9eb9-9f4f8c6db4b2",
      "members": [
        "3f813fdc-4ad6-4f05-bd8c-cb458b63dcc4"
      ]
    },
    {
      "cluster_id": "e4820af7-bf5b-455e-a72e-bb48cada6e0a",
      "members": [
        "898253d6-a20b-4ea7-a680-4ea6a8e5e591"
      ]
    },
    {
      "cluster_id": "cca26850-c71b-4446-90d7-2e4d88b1223b",
      "members": [
        "98c3fc99-045a-41b1-9608-c4606dec0d90"
      ]
    },
    {
      "cluster_id": "f07e6f30-0af3-4009-9a85-94198bcc5a45",
      "members": [
        "c8a184f1-5f20-40eb-b092-438c9d095f14"
      ]
    },
    {
      "cluster_id": "6fe0709b-66c5-4553-a6ae-89bdc6df31fc",
      "members": [
        "7ad56b41-6460-472b-ae3a-26765fb583ca"
      ]
    },
    {
      "cluster_id": "60bcdb7a-b11c-4760-96c7-2e903b89bd2e",
      "members": [
        "a2f350e8-ddd6-458b-9ff0-ecce809962be"
      ]
    },
    {
      "cluster_id": "35b22dab-25ce-4dde-ab9f-31302b06eb90",
      "members": [
        "947ca0f5-5a3e-42e0-87e9-0791cccea0e6"
      ]
    },
    {
      "cluster_id": "51c627ea-61b3-4175-b1c6-64a2c7928bc9",
      "members": [
        "8d97a4be-b332-4539-aa7b-7570086c9276"
      ]
    },
    {
      "cluster_id": "1257662d-03bb-4192-9e0e-d0d2bb753848",
      "members": [
        "ab28cf16-2c3b-417f-8c2d-799f61852361"
      ]
    },
    {
      "cluster_id": "961d386d-4d5b-4009-a39c-fb6d1a441cf5",
      "members": [
        "ba943773-f4ec-4b72-b99d-3fd70ccd5b96"
      ]
    },
    {
      "cluster_id": "9a62af93-7112-41ed-b195-640caabb9cb6",
      "members": [
        "43bf57ac-6257-460f-8d73-80f921e28db0"
      ]
    },
    {
      "cluster_id": "5661edb8-2d76-4ef2-88fa-1ef3a23ed765",
      "members": [
        "f7281147-4afd-4fcc-a868-83b976f36e7a"
      ]
    },
    {
      "cluster_id": "ad717816-6a33-4b68-8dcc-4da6a24f22b4",
      "members": [
        "9986cc55-bad0-4c51-a4f2-64526ad8eef9"
      ]
    },
    {
      "cluster_id": "0e7363bf-ba1a-40d3-b39e-9efa5e6a18ad",
      "members": [
        "5c10b624-e027-43ef-a580-72ae4235ada6"
      ]
    },
    {
      "cluster_id": "d7d8a2ba-6242-4963-a3f8-0e40fd7043dd",
      "members": [
        "2cd38244-2816-4d92-95c4-7397788434fa"
      ]
    },
    {
      "cluster_id": "5a363a3c-7ca6-45b2-98ec-b07e07ef38de",
      "members": [
        "63a76f1c-0c99-43b6-b1bc-49035b7d3502"
      ]
    },
    {
      "cluster_id": "26405a6f-ce14-487e-8e9d-f5b3ee953860",
      "members": [
        "701c30c1-0733-4df8-b0d1-eb0ce9f034c8"
      ]
    },
    {
      "cluster_id": "fc3da38c-59ab-4dde-836c-c912a95b1802",
      "members": [
        "e546b4d6-4a47-48e7-bd13-1e7753dbb866"
      ]
    },
    {
      "cluster_id": "8abd35db-2186-4408-8be6-3af382d275ab",
      "members": [
        "4eb4ba3e-a782-475b-b2c4-9d6db34814ec",
        "6fe2ff24-1c4b-4a04-94ba-def1daaaae8e"
      ]
    },
    {
      "cluster_id": "69aee0d6-8420-442f-82ab-c95f31fcf4b8",
      "members": [
        "06c0a5b5-8e16-4f9f-9f0e-ab5664de4825"
      ]
    },
    {
      "cluster_id": "d0bbd332-807a-43c4-8b16-bc8817897189",
      "members": [
        "a0807413-350d-497a-957b-476c99bb7942"
      ]
    },
    {
      "cluster_id": "b8430087-4ad5-4df6-bc7a-9f268ead6bd8",
      "members": [
        "cbe425dd-91d0-4c9e-814f-307d666dfb05"
      ]
    },
    {
      "cluster_id": "f646af3d-32fa-49f1-bcbe-d5924a767680",
      "members": [
        "f13763ab-b797-4cfc-b23a-dfda1e34d18d"
      ]
    },
    {
      "cluster_id": "1cebf7eb-146a-47ef-84f4-296315d7b4c5",
      "members": [
        "67e1df4f-0b25-4eb8-ae60-da8ed780fa20"
      ]
    },
    {
      "cluster_id": "0e9e7c31-725a-4645-86a1-d5bba7071b1e",
      "members": [
        "42e1e786-eb16-4811-ac5a-3670a7e9f8cf"
      ]
    },
    {
      "cluster_id": "6799e4ae-598d-4d1f-8409-ebaa05c79c71",
      "members": [
        "0662725c-2816-4d30-bdaa-0bc0158a79b9"
      ]
    },
    {
      "cluster_id": "88ac8370-087f-4a90-8111-103d9e01fd10",
      "members": [
        "16c7e6a0-3a3e-46d8-afe7-c7ca955a57fa"
      ]
    },
    {
      "cluster_id": "33eeb9d5-6bc2-4034-a6c6-3e0b1e59728e",
      "members": [
        "0a078b3a-374d-49fe-af7e-9e2d0fe930f4"
      ]
    },
    {
      "cluster_id": "efabc150-323f-4c88-9041-fa0370310d1e",
      "members": [
        "f3f9277b-7b33-4da8-bc76-dd68b1a43d28"
      ]
    },
    {
      "cluster_id": "ea30f761-5bdf-4c65-ac3f-905c5bb0730a",
      "members": [
        "e8d5e569-cd34-4e09-92ae-637153b746d6"
      ]
    },
    {
      "cluster_id": "bb7d1261-e586-4986-8419-b3678b999f37",
      "members": [
        "3c0ec261-34f4-4f25-93bc-c9313bd979a1"
      ]
    },
    {
      "cluster_id": "f09e8cd4-4e03-420e-a650-dd40af68dcd7",
      "members": [
        "263b32f2-4856-4bd7-ad65-7bc111192dec"
      ]
    },
    {
      "cluster_id": "dcbfce15-858c-4e65-80b3-6f982fffc5b4",
      "members": [
        "3ca46107-397e-421b-b4d6-0dde20cd7129"
      ]
    },
    {
      "cluster_id": "83314d81-ffc5-42be-b8ab-fc7049a1e48f",
      "members": [
        "a7b94326-202d-41d5-a38e-7f325df8eebc"
      ]
    },
    {
      "cluster_id": "7d17e0b1-02a8-4e94-8aaa-3bb8dcf83cf8",
      "members": [
        "604fbd99-45fc-464d-83c4-c999705544cb"
      ]
    },
    {
      "cluster_id": "1a154b18-5d3f-45d7-ac98-39d14a936806",
      "members": [
        "191250d7-2c7b-44a0-84ad-1a7a97290061"
      ]
    },
    {
      "cluster_id": "1c77e648-2237-497b-abcc-acdf4350562a",
      "members": [
        "bac0f5a3-ea5d-44df-a3c1-9fcb9dd2e680"
      ]
    },
    {
      "cluster_id": "97a63c8b-423b-4b4d-8ca6-262c543d514e",
      "members": [
        "93b14285-af1e-4f08-84b9-e93ba8eda306"
      ]
    },
    {
      "cluster_id": "3e001ec5-72ab-4ef2-bec5-7b5552144517",
      "members": [
        "161373df-fc56-4929-9699-2af1f305042d"
      ]
    },
    {
      "cluster_id": "918d1070-a60a-4619-b33f-d29c47c7f6cb",
      "members": [
        "a98dad60-c241-402a-a088-d428675b3092"
      ]
    },
    {
      "cluster_id": "44f0dccf-8fd1-49a7-88f2-e83b8d0cb422",
      "members": [
        "2ac71266-2c71-4d0d-8737-421fba19a828"
      ]
    },
    {
      "cluster_id": "b2b194c2-f397-4e76-bb84-c8a37964e533",
      "members": [
        "63ce55d7-4535-4422-bfa8-d00a22e51d68"
      ]
    },
    {
      "cluster_id": "d05207e4-1a3a-4cab-84c5-4af79b01b239",
      "members": [
        "a0797c91-72c2-4cbc-a7a2-eb2143464cd0"
      ]
    },
    {
      "cluster_id": "e0d1bce3-3239-47f8-946e-5937659f6c85",
      "members": [
        "c267f3f8-4c62-40c9-8ed3-103959675502"
      ]
    },
    {
      "cluster_id": "f7c00384-e094-4930-b95a-5105ca6ad5a9",
      "members": [
        "2763957d-043d-4c6f-90e7-3af562830017"
      ]
    },
    {
      "cluster_id": "ee698871-2543-42ca-9ed1-652a77429181",
      "members": [
        "f046c44a-a2a4-49a4-b33f-4a775d713df4"
      ]
    },
    {
      "cluster_id": "c80180fd-f416-4eda-9cf5-5aa622256189",
      "members": [
        "9a744018-8525-4ae6-8e3a-5c4aa6c6552b"
      ]
    },
    {
      "cluster_id": "2de6bb89-87af-41d9-9f6e-654985194064",
      "members": [
        "75c453eb-2738-450f-87f5-31098166ede2"
      ]
    },
    {
      "cluster_id": "a548b0a4-9a63-47ec-a6ab-6b9d50ab7aaf",
      "members": [
        "297e88f8-7910-405d-bc54-514e7ab6044d",
        "07b5174c-0004-467f-abed-bc4b6e7f8b04"
      ]
    },
    {
      "cluster_id": "927e3b68-c649-4b84-bd7c-c79eecd50812",
      "members": [
        "e99f2056-cf88-4c64-86df-0a48013a8870"
      ]
    },
    {
      "cluster_id": "ffe496a8-ba5b-46e3-94f5-ab61bd09d41a",
      "members": [
        "83c742a8-914b-43e6-9971-d322cacd6287"
      ]
    },
    {
      "cluster_id": "8b923490-b752-4fe2-9b0a-01c4a9d8d4b7",
      "members": [
        "13c7dc85-89b0-4e43-aa45-849ba1aa958e"
      ]
    },
    {
      "cluster_id": "bfff8af2-9d27-4503-baf3-3e1618c9087a",
      "members": [
        "f0932c14-0b9e-42a3-9963-dcfbfcf6bf87"
      ]
    },
    {
      "cluster_id": "6d731e69-2664-4f91-adc6-9eac800389a3",
      "members": [
        "25ecf7d1-558b-42d9-bf57-2bc303b8f36e"
      ]
    },
    {
      "cluster_id": "b2700cb5-512c-44b4-a7d2-f6f79575e42a",
      "members": [
        "11f8567e-f853-4c9b-9c0b-ecbed2ab46bd"
      ]
    },
    {
      "cluster_id": "a28c9cba-981f-4e06-b04d-bde777f88583",
      "members": [
        "1a5858cb-924a-4f99-9863-0e4a6f688c72"
      ]
    },
    {
      "cluster_id": "3e73e60d-d610-4533-a186-9f4c4620025b",
      "members": [
        "66daa508-94e3-4524-99cf-9dd30b99355d"
      ]
    },
    {
      "cluster_id": "c90c2a25-6af0-43d7-8ce5-c04e253daa5e",
      "members": [
        "7c3c831b-2105-43a8-8ad0-76c73aee5715"
      ]
    },
    {
      "cluster_id": "9fe09fbd-ca4a-419e-94ee-6e49f8b62304",
      "members": [
        "3f5b7328-b9a4-4069-b53d-757422e4629e"
      ]
    },
    {
      "cluster_id": "9f572501-f429-45f5-98fb-17c2e50fca11",
      "members": [
        "ce2dddd3-4322-4e87-b3f8-f7e629923e04"
      ]
    },
    {
      "cluster_id": "ce23ab49-6ed2-4eb9-b4ae-b0b0514251c2",
      "members": [
        "fcbbee15-4882-4121-9f07-7e273696aca8"
      ]
    },
    {
      "cluster_id": "921f4cda-4607-46f9-83ce-2b7708f3b6a9",
      "members": [
        "3b71ae7b-1b52-40e8-bee3-d373b84cc8b6"
      ]
    },
    {
      "cluster_id": "ea84d1ec-6a21-4123-9c3e-41ce618815e9",
      "members": [
        "e214f73a-49c9-4a2d-b29e-9723e9a7174c"
      ]
    },
    {
      "cluster_id": "f2531848-788a-44fc-8497-b2d0aa74b135",
      "members": [
        "61e54a09-0f7a-4c03-875f-2d3a5d4747df"
      ]
    },
    {
      "cluster_id": "4815ee62-ac65-4840-9797-7e3f61c900fd",
      "members": [
        "4dd9a224-cfbf-4cd6-897b-6d2c3c3c063d"
      ]
    },
    {
      "cluster_id": "f51d8559-af8b-4da0-bbbe-5eb4dde41ccd",
      "members": [
        "2741f754-b74b-4c46-b971-fcef82ac4768"
      ]
    },
    {
      "cluster_id": "e4c129ec-5dad-46c4-884d-38afdd290e76",
      "members": [
        "d55af143-5861-4236-8d45-a7c0d5ea6c83"
      ]
    },
    {
      "cluster_id": "8ce1b035-20cf-4e3a-b84e-8642795846fd",
      "members": [
        "6c6f1682-69b6-4831-be94-3557272332dd"
      ]
    },
    {
      "cluster_id": "54f0485d-be26-4b53-bcd8-2b1cb8ee52a3",
      "members": [
        "4f781d9a-7f8e-4869-a794-a727324fac4d"
      ]
    },
    {
      "cluster_id": "1bdc4e39-4f85-4244-acae-0889a6b1bb01",
      "members": [
        "13f0d944-6cf6-43c5-9220-7687d06e00be"
      ]
    },
    {
      "cluster_id": "8f445d44-1e7e-4d7a-9a5f-c141941a7046",
      "members": [
        "ec218a04-2242-49d9-b1d8-715213b7c515"
      ]
    },
    {
      "cluster_id": "d5e78a91-2d42-4f38-b8d5-690a40967ad3",
      "members": [
        "7eacfe5f-3336-4bdc-bc19-96e33288a5ce"
      ]
    },
    {
      "cluster_id": "4abd438c-8dff-4f9a-8a7c-0da2a36edcc9",
      "members": [
        "2113de29-0bea-45ac-b7f2-5e321f002776"
      ]
    },
    {
      "cluster_id": "2bd231ca-b95f-4da8-b52c-5b92d58eef4f",
      "members": [
        "b12104e0-292f-4267-a6a6-1acc6bcc36cf"
      ]
    },
    {
      "cluster_id": "dc0f2fc6-867e-476a-b8e1-8031edcf72a7",
      "members": [
        "92d1fcfb-d3b8-479c-b78b-53de4f6df3c7",
        "1e546e61-b8e7-495e-96a2-c3490a50dd21",
        "53901b4c-be30-4b13-9f82-7cfead29a8ad"
      ]
    },
    {
      "cluster_id": "2b58f035-89d0-48c4-ab98-0571ae348860",
      "members": [
        "10753f07-df9a-4f52-8209-d82451128083"
      ]
    },
    {
      "cluster_id": "41498260-bda6-49c5-9ad2-acb6340ff494",
      "members": [
        "68f0cb2c-642a-4030-a9b8-033e606d295f"
      ]
    },
    {
      "cluster_id": "ce2c1d0b-75ef-45c7-a23e-a0fa3e07457f",
      "members": [
        "f78e8fb3-a5f5-4218-9658-3435aead73ba"
      ]
    },
    {
      "cluster_id": "fa2c58b3-15f9-417f-89fa-2899f5ce4fe3",
      "members": [
        "eaff01f0-4388-4ced-be4a-e328a91d96d0"
      ]
    },
    {
      "cluster_id": "e4488bd7-fb22-40f5-8db9-906cdc42ac18",
      "members": [
        "28dd6232-27c1-41d7-88b4-2f787f02440d"
      ]
    },
    {
      "cluster_id": "7ba06e8a-b878-421d-9b1d-d395213d16fa",
      "members": [
        "7ff744b6-6709-480c-8c99-b17b322ef721"
      ]
    },
    {
      "cluster_id": "06406aaf-e480-4364-8dee-02d2a85bbdca",
      "members": [
        "ead2fbdd-5723-42fc-ab0d-93d87a438a0b"
      ]
    },
    {
      "cluster_id": "5993beab-a3f3-40b3-9d6d-5a8cd60d5eb3",
      "members": [
        "87dce773-da40-4685-bc94-7aff0bcddddf"
      ]
    },
    {
      "cluster_id": "afe6a321-421e-4002-b9d4-be185e9d1b93",
      "members": [
        "0f197dd8-0c8a-4426-919b-85d947fa246e"
      ]
    },
    {
      "cluster_id": "fe48b63e-4bef-4121-8e7e-7d9b8254bcfc",
      "members": [
        "db1cb6eb-4be9-49d3-93dd-957097533883"
      ]
    },
    {
      "cluster_id": "b95ab66d-3f95-45f0-b65c-f87d9de7b47c",
      "members": [
        "f6019ddf-aedb-490c-b225-361650f56322"
      ]
    },
    {
      "cluster_id": "126a290c-017d-477f-aef9-ee387468d992",
      "members": [
        "8dda9808-2665-4d8e-9f16-d03edf53b7a3"
      ]
    },
    {
      "cluster_id": "f8830cd0-0851-4651-a6ad-3f181547090d",
      "members": [
        "6a373685-7592-4b18-9be4-7713a5157089"
      ]
    },
    {
      "cluster_id": "7ef61e9b-09b3-424a-8249-c31cea2c952b",
      "members": [
        "2ebc3f44-7446-4a79-a097-f252f3e44d7d"
      ]
    },
    {
      "cluster_id": "a867149e-e951-4e73-80ca-91c6893b617b",
      "members": [
        "d1d894f2-aa78-4b33-a4fd-1fb32b34b23e"
      ]
    },
    {
      "cluster_id": "3ec46f1d-e796-464f-991a-62539b2882d1",
      "members": [
        "a74e82ad-2c97-4e7d-a8b5-14aeca0b1233"
      ]
    },
    {
      "cluster_id": "a67c3f7f-a1ca-4dac-ba63-61ecd0d76ed7",
      "members": [
        "7a4afd2e-583b-4d1b-a751-28c295503c50"
      ]
    },
    {
      "cluster_id": "fdd7487d-7bf5-4a71-8bbd-7a8cd0c6d7c4",
      "members": [
        "05008ca2-9f51-47b9-bcca-461e749a6dd1"
      ]
    },
    {
      "cluster_id": "2002baa5-6997-4ebc-9742-182fae427316",
      "members": [
        "b9be3a7d-7b16-488a-9236-4f95aca31052"
      ]
    },
    {
      "cluster_id": "4ffbb682-25e8-4ae0-936d-0f256e7b5aaa",
      "members": [
        "8fe772b0-3ed9-4ebc-a64a-9d70e8cacb35"
      ]
    },
    {
      "cluster_id": "80c21daf-780b-4d61-a882-6319319c019e",
      "members": [
        "fc234567-2d65-4f37-960b-e9df75ff8fe3"
      ]
    },
    {
      "cluster_id": "08a49e97-cae6-472e-9f1e-189f1a189718",
      "members": [
        "fc688e50-6c5a-4726-af4a-d7a1df92d2db"
      ]
    },
    {
      "cluster_id": "9b88354d-eae6-4159-b5cd-4aa560c1a939",
      "members": [
        "02bcd9eb-45c6-4482-b342-3b8a229fe307"
      ]
    },
    {
      "cluster_id": "8a36ef98-d08b-4198-b4d6-a8933da5b619",
      "members": [
        "bb80b8bb-dbb0-46ba-8994-3f0cf55d2f78"
      ]
    },
    {
      "cluster_id": "3f8c1bc5-ffc2-4f3c-9751-015716600af2",
      "members": [
        "ddedc3e3-39bd-46d0-baa5-3ddbae068501"
      ]
    },
    {
      "cluster_id": "fbc20184-6dc0-4a3f-a944-728af7954e97",
      "members": [
        "227e6703-d39e-46a9-a329-3b7f3f31f194"
      ]
    },
    {
      "cluster_id": "53102493-0297-43e7-a8fe-5dbe6ce36215",
      "members": [
        "9838b08a-1ace-4d74-ba8b-fef731e6a024"
      ]
    },
    {
      "cluster_id": "f508c62e-4dcd-4831-9789-bacd1b75b831",
      "members": [
        "df297219-9656-49d2-8640-9d432c60083b"
      ]
    },
    {
      "cluster_id": "70aec147-e46f-48a9-b67c-9dbf6b174338",
      "members": [
        "ecae77c8-c18b-42b0-b44d-6cae9d7c6d13"
      ]
    },
    {
      "cluster_id": "4074f92b-f1cb-43a1-a970-018d582db2d6",
      "members": [
        "ab3e765b-00ed-46bf-bbca-4867fce50f80"
      ]
    },
    {
      "cluster_id": "a94771e0-7b95-4bfd-9f9c-88d21171cf9e",
      "members": [
        "8fb95e4e-2538-4403-b5d4-71f4f08ec94e"
      ]
    },
    {
      "cluster_id": "8b843277-fda8-4ecf-9981-5b5f31ef86a7",
      "members": [
        "58469760-1625-4a46-ae12-25b624877ece"
      ]
    },
    {
      "cluster_id": "8463c208-4f6b-46d2-8aa4-c6b2f82bc799",
      "members": [
        "a9d8cdb1-fc8f-4f3a-86ea-ef27564a398e"
      ]
    },
    {
      "cluster_id": "22f29403-f7fd-433f-b37d-85803cc6c208",
      "members": [
        "7c591d07-890a-4e2b-b07f-2101e9811438"
      ]
    },
    {
      "cluster_id": "e6f89802-3df1-486d-8ad4-82cdb658549b",
      "members": [
        "54715ef2-9d6d-43d2-b786-a9fcb1146ef2"
      ]
    },
    {
      "cluster_id": "1480b5d9-5e00-461a-b194-d322e838f544",
      "members": [
        "1fb7b3ec-b48f-4a41-907f-b3fc93458af9"
      ]
    },
    {
      "cluster_id": "944be8a6-d37e-42a3-beed-11a9a6d47203",
      "members": [
        "b9bb18de-39bd-4aa5-bf88-038fde6b416e"
      ]
    },
    {
      "cluster_id": "5de6826d-9cc1-4c89-8c16-3e4d254ae1a9",
      "members": [
        "0ca1163c-36fa-49e2-a8b3-ee240478ca9c"
      ]
    },
    {
      "cluster_id": "9e537f59-fc8d-477f-937c-489e24e51014",
      "members": [
        "8fe8e09b-94f9-4887-bbe9-53ce062738d1"
      ]
    },
    {
      "cluster_id": "8aaf61a8-4245-40d4-9036-3767a2a55c98",
      "members": [
        "6b80f2ca-5717-45fb-8509-1d1318b1f234"
      ]
    },
    {
      "cluster_id": "0031fe05-7e53-4c0c-b89e-d86016e53d57",
      "members": [
        "ad1f6d5a-6fbe-4991-b391-6eea097ba6ca"
      ]
    },
    {
      "cluster_id": "0d423859-86f8-4f56-9318-137386b1b279",
      "members": [
        "ff4b0218-6ad8-4158-a09d-ccc01098b13c"
      ]
    },
    {
      "cluster_id": "58af047e-cbeb-4069-98f9-896633d3674d",
      "members": [
        "8542cdd9-b0b6-48b8-9de3-00467d99bdbf",
        "a5948f0b-108c-4450-9313-80c4b9d2bf63"
      ]
    },
    {
      "cluster_id": "a73d7361-cea3-47c7-84a2-2a97ab239fa4",
      "members": [
        "340865f4-4105-45f5-971c-91b0196fa214"
      ]
    },
    {
      "cluster_id": "867a2b63-9e44-4ba6-82e8-55c04ceb4f4f",
      "members": [
        "b0bdc020-aa8a-4957-a82a-19757ff66f58"
      ]
    },
    {
      "cluster_id": "9054d5e2-4b4d-475e-9960-73215a5d44f4",
      "members": [
        "efb16d49-67a5-4fdc-82a9-8f602f332fb2"
      ]
    },
    {
      "cluster_id": "0d3db024-9b87-4816-98d7-172f0864bf36",
      "members": [
        "a01511d4-be5d-44a9-8aef-f8ef676cdb9d"
      ]
    },
    {
      "cluster_id": "ab73bace-5110-4ac5-b01b-8b28976f8120",
      "members": [
        "2ee0655e-d858-4d91-a7c4-7ab020f8b20d"
      ]
    },
    {
      "cluster_id": "059d310b-b926-414f-b010-d79ad9684054",
      "members": [
        "7d808e92-d4f1-41c4-a2ce-59bcc07b90e6"
      ]
    },
    {
      "cluster_id": "83c9bf38-7be3-4a58-9128-bac3dda66b3d",
      "members": [
        "0457a908-d117-491a-8ee5-7d6ba6c19257"
      ]
    },
    {
      "cluster_id": "dfb119a6-40b5-4824-8a20-9b636bd6f4b8",
      "members": [
        "6a4fd329-e94b-427b-aea1-bb26e6c34aed"
      ]
    },
    {
      "cluster_id": "66399bf8-97ea-4b4e-aa54-9b68d82943d5",
      "members": [
        "b6e556ba-5f57-429d-af0f-a86c90db91b4"
      ]
    },
    {
      "cluster_id": "82ba6b92-1774-434f-82ee-333e96e53f03",
      "members": [
        "539280bf-56c8-4465-bdcf-441cc11c40b0"
      ]
    },
    {
      "cluster_id": "6528a411-ccde-4df7-8364-b5129e53c388",
      "members": [
        "0cbdc320-0d45-45b1-bada-45f660611394"
      ]
    },
    {
      "cluster_id": "c7cc8a7a-ef8f-4aaa-8735-139c689f3af1",
      "members": [
        "7fd4d209-92d8-43f6-a978-4d0546466515"
      ]
    },
    {
      "cluster_id": "f7069e5f-ee25-470b-986d-c157ab1e1613",
      "members": [
        "40386eeb-3c9d-4768-ba69-df110a9669ad"
      ]
    },
    {
      "cluster_id": "823656a1-093a-4e85-b706-f48d18e40c29",
      "members": [
        "bffa340b-2243-4598-9c38-2f2d8e63cb48"
      ]
    },
    {
      "cluster_id": "be58ac09-a64e-4854-a7b4-83f25a02c250",
      "members": [
        "bc2e8f0f-278c-41d2-8dc7-abe26dfb5c60"
      ]
    },
    {
      "cluster_id": "353c6f78-8367-418a-a322-9feedaea3f81",
      "members": [
        "2969412c-ef5d-4f42-bd8c-e2ae776e312a"
      ]
    },
    {
      "cluster_id": "e1f0a82d-250e-4472-bc8b-76e1029d4554",
      "members": [
        "dc95d029-058e-44d0-82c7-d35a3250c5be"
      ]
    },
    {
      "cluster_id": "72addbc1-127b-4a33-b16b-7a7f76d03f32",
      "members": [
        "9cb961b0-2975-4edc-b037-462ad4a4acd3"
      ]
    },
    {
      "cluster_id": "753c254f-8be9-4b92-b7c7-e32c2713d3c8",
      "members": [
        "c51c936d-dc4d-4413-907b-eedc9391ab1f"
      ]
    },
    {
      "cluster_id": "23c09fb4-b263-485c-8e4e-4908da7910fa",
      "members": [
        "a2a21b0f-6a99-4285-8a53-f8faff778f2c"
      ]
    },
    {
      "cluster_id": "6b25848d-e565-4f9d-b442-93bdb20750d1",
      "members": [
        "245a35f3-5b3a-496e-afa6-cd0a9d64d880"
      ]
    },
    {
      "cluster_id": "e5ca8f71-6bbd-48dc-bbcc-02165ada2157",
      "members": [
        "bdb3e1ee-adc1-4b32-8391-fa9ea101b91e"
      ]
    },
    {
      "cluster_id": "43d48fcc-7522-4b18-8344-e5b044e22838",
      "members": [
        "008f646a-c5e7-48e9-b395-853b78648e67"
      ]
    },
    {
      "cluster_id": "f5f9e060-9a81-433b-b601-5ea2fb08b956",
      "members": [
        "cecfdd0e-e11b-4f69-a180-678077307002"
      ]
    },
    {
      "cluster_id": "5e6716fc-cf64-480e-8688-e74f2a213fd8",
      "members": [
        "611bc014-08ef-4abc-bb78-46cec459f5c8"
      ]
    },
    {
      "cluster_id": "d74a5599-9b30-4d12-97d2-692e60e13661",
      "members": [
        "ed81bfcd-bb28-485a-ad33-22c208f0ecc9"
      ]
    },
    {
      "cluster_id": "64d37d6c-89cb-4974-81c1-3b1735939788",
      "members": [
        "1a401108-cec9-4a29-8ebb-bdd082fb667f"
      ]
    },
    {
      "cluster_id": "0a1dc802-b4ef-42f0-aba6-299883ef023b",
      "members": [
        "7f84a657-9499-4925-b019-156b43762020"
      ]
    },
    {
      "cluster_id": "bbe46b45-db85-4cd0-8c3a-6d46ba80584e",
      "members": [
        "3fcab9b8-b6dd-4bbc-946b-27da40e232d4"
      ]
    },
    {
      "cluster_id": "55351f66-3ce1-4720-a5bd-bce9d2bab5d2",
      "members": [
        "8f07eb68-00a2-4867-b067-e9865a538313"
      ]
    },
    {
      "cluster_id": "550b12e3-691c-45b5-8cb2-986a272d3a0f",
      "members": [
        "04ba5a5c-9527-43f5-916e-b911c3a441d2"
      ]
    },
    {
      "cluster_id": "d8fa0364-5dd8-4aab-bf01-01e24a95233b",
      "members": [
        "32f79435-fe11-4d8a-859b-4156f982c7a1"
      ]
    },
    {
      "cluster_id": "80b309de-fa0b-4abc-ace4-5a54f5c02331",
      "members": [
        "3a56cb72-b74a-4223-ac3d-0dcbe7a192e9"
      ]
    },
    {
      "cluster_id": "2b91a87f-d164-4dfd-97cb-da5b879525ca",
      "members": [
        "43f86fbb-c78a-4fae-925c-8e1363978e79"
      ]
    },
    {
      "cluster_id": "389bf865-85bd-4767-9053-03a5fcae6a23",
      "members": [
        "019c4880-7921-44f3-a24b-4ead99231cb3"
      ]
    },
    {
      "cluster_id": "7d87f4b1-866b-4dd1-b437-00afdcc9c4fe",
      "members": [
        "b7470a85-016a-411a-956c-431a292989eb"
      ]
    },
    {
      "cluster_id": "414df1fb-6d9e-4aff-a35e-819202fb6c05",
      "members": [
        "09601652-9278-414f-9e73-debea62d2b9c"
      ]
    },
    {
      "cluster_id": "bf4593ea-9aa1-40b8-a424-04287ae58886",
      "members": [
        "18b49d65-cda8-4c8a-b14a-5e9183dd8f9b"
      ]
    },
    {
      "cluster_id": "5fc308a4-b2ac-472f-a711-f5e9a8852593",
      "members": [
        "0a9a6e37-c995-44c2-b020-eb4e95a33536"
      ]
    },
    {
      "cluster_id": "718b8058-1e91-4465-aeff-7514749404e5",
      "members": [
        "cb25b9d1-b962-4e5f-857d-fe0ff139d644"
      ]
    },
    {
      "cluster_id": "5c7b360c-c61a-4fc7-88f8-807bde4dcb6a",
      "members": [
        "b657d758-6cb0-4f50-9705-1ecc489c1cae"
      ]
    },
    {
      "cluster_id": "c1d2e607-4b20-4663-b826-18bf9ec884ab",
      "members": [
        "565e426e-e98e-48c0-8ddc-0b094636d559"
      ]
    },
    {
      "cluster_id": "e4be2259-ba51-439d-9935-9584c06ee048",
      "members": [
        "33a8f32d-d60a-400b-a04d-678bcd8bb932"
      ]
    },
    {
      "cluster_id": "fa792d5d-a49f-406b-8386-4253dfbb9e11",
      "members": [
        "92f05824-1cf6-48fd-adb3-12ccb30e92c3"
      ]
    },
    {
      "cluster_id": "48d341a5-63e7-4586-8058-1ab4e4d8c613",
      "members": [
        "161c3e6c-1a57-4298-b101-4d55aa85ef1c"
      ]
    },
    {
      "cluster_id": "95b33dd9-d9c3-4168-aeae-fc027379013c",
      "members": [
        "fc414cf9-8ffc-4069-8353-392b7823db8e"
      ]
    },
    {
      "cluster_id": "9dc49f5f-af39-44e0-aabc-c941b43e1bd3",
      "members": [
        "78c6bf47-3270-4907-8e54-57ced25689d2"
      ]
    },
    {
      "cluster_id": "65cdef1a-e035-4605-9081-f663d9551b62",
      "members": [
        "e03ffb94-e08e-4651-9cc1-0095b2efd08f"
      ]
    },
    {
      "cluster_id": "d89daeba-4406-40e6-aed6-08994b1a95d9",
      "members": [
        "eb5e9dd2-7d04-4532-acfd-fb5f1aae9ef3"
      ]
    },
    {
      "cluster_id": "02502121-c7d0-43b9-afe9-c557963c5283",
      "members": [
        "f4014cc2-8e57-4abb-bf52-07bcfb0f3b44"
      ]
    },
    {
      "cluster_id": "82c2fba9-344c-4253-9cf5-a05ec938a8a6",
      "members": [
        "27897f54-49e3-4fae-9828-505f78bf9d1f"
      ]
    },
    {
      "cluster_id": "3b24d20e-ac52-4f56-955a-33bcfd5102a2",
      "members": [
        "163a3d3e-a21f-40ae-9fa8-3ad5e284327e"
      ]
    },
    {
      "cluster_id": "d79d62e1-d874-49ae-865e-dccd822f8d8e",
      "members": [
        "d7d98017-ceab-473b-9d1d-550fea381397"
      ]
    },
    {
      "cluster_id": "cd9e4a57-55ca-4538-9460-c81e764492cc",
      "members": [
        "b662b0d5-6387-4160-9e87-512993dc9a40"
      ]
    },
    {
      "cluster_id": "341aa4ce-b339-4cde-b356-d8223a398402",
      "members": [
        "e5e5ef80-c4d3-4483-95c6-0cd446834cdb"
      ]
    },
    {
      "cluster_id": "c49f13c9-2c44-44c7-b990-930a2d9264c9",
      "members": [
        "0c9bea1c-696e-45be-8e98-9455cb0f2893"
      ]
    },
    {
      "cluster_id": "7ae8bb79-06c2-4d0f-9d71-30e4b3fb8238",
      "members": [
        "cd094463-97a5-4de0-93ed-1325af5ef9fb"
      ]
    },
    {
      "cluster_id": "ead45298-e146-40a5-a729-dab15400b7c2",
      "members": [
        "9cfc36a5-9f99-47a7-ad87-279683192158"
      ]
    },
    {
      "cluster_id": "87e98045-d749-47b9-a158-8b7bfbd1d3db",
      "members": [
        "a927a42f-bfe4-4e8f-b1eb-bdef9190965f"
      ]
    },
    {
      "cluster_id": "f10425d5-24f2-425f-821e-7acb93c9e53b",
      "members": [
        "430ec1c2-241c-4cda-aa92-6aed75322855"
      ]
    },
    {
      "cluster_id": "209803f4-b6ac-40bc-97b8-024102ee5865",
      "members": [
        "650fc0df-e0d7-4bfb-860c-8f224e30a3fd"
      ]
    },
    {
      "cluster_id": "6b36db82-3876-45f8-8bf7-ad613dcd8852",
      "members": [
        "135c3530-e90a-45f3-8a06-8ee429d8f40a"
      ]
    },
    {
      "cluster_id": "79cd6f65-ee4d-4695-8b9a-e4b8c86c1536",
      "members": [
        "94e71162-6f12-43d4-ba70-ab877e9b6516"
      ]
    },
    {
      "cluster_id": "153479d3-dde3-44aa-83a6-d7e772a10308",
      "members": [
        "1ab4c62b-51ea-4810-b93f-ee607919f70c"
      ]
    },
    {
      "cluster_id": "1e8a7861-14e4-4a42-b74d-73c7bec3ba5f",
      "members": [
        "3de16f03-4ac2-453c-a425-1cf9f45fa46d"
      ]
    },
    {
      "cluster_id": "5cc3d51d-5e99-492c-82ff-4024c6eb9503",
      "members": [
        "2f16d0f9-a68c-4d59-ba09-140b6999aa36"
      ]
    },
    {
      "cluster_id": "d74efe6e-e929-4c10-ba6b-80c58b26fa38",
      "members": [
        "e1131622-5f85-4824-8567-9c32f350bc73"
      ]
    },
    {
      "cluster_id": "9d971a6e-39d0-4da3-9f9b-e8603acb9bc3",
      "members": [
        "f7b91efc-6423-48b9-97fc-178304a45a95"
      ]
    },
    {
      "cluster_id": "a6afbf41-e20a-4832-891c-6e8ecee24d06",
      "members": [
        "99ad98ff-e094-4304-9d11-5284f0406703"
      ]
    },
    {
      "cluster_id": "dc679e22-e949-4c80-8633-a19ca02db1b0",
      "members": [
        "00c0c884-7362-48f2-ba91-ceea4b4a9e24"
      ]
    },
    {
      "cluster_id": "10c5fb88-3404-4aa6-bc78-257c91344837",
      "members": [
        "71a1364f-ecb0-4cca-ab44-0b2ce7c4be17"
      ]
    },
    {
      "cluster_id": "24751f3d-988c-4f3f-9df5-95b8bdfa7bfb",
      "members": [
        "c5d07542-e14a-4255-890e-b87779f91086"
      ]
    },
    {
      "cluster_id": "3766e219-c028-4750-8fa4-03a0a967da3c",
      "members": [
        "49486281-bb55-4060-a8ab-626377399a5a"
      ]
    },
    {
      "cluster_id": "b04942a2-8d33-487f-9e37-33193a4bf9b5",
      "members": [
        "fa3821ac-e9e0-4a8d-a6f2-d7335a37436b"
      ]
    },
    {
      "cluster_id": "dfab974e-91dd-4ade-9c9d-e89b40d58378",
      "members": [
        "489b9acc-002d-4c9c-aa6a-76cfb525e91d"
      ]
    },
    {
      "cluster_id": "a8ce1bca-58fe-42ba-8464-607d5c5b57e3",
      "members": [
        "83a03f8b-a852-4b0a-831c-c217ae86a7e2"
      ]
    },
    {
      "cluster_id": "c9b1ea29-5b23-4579-928f-8f3b1f3679f1",
      "members": [
        "a119e35c-f046-4c85-b1f1-071ab9bd8e61"
      ]
    },
    {
      "cluster_id": "eab0b5ad-eda0-47fc-89d0-b12331740c85",
      "members": [
        "420f7996-128b-4313-9010-4b8f4e19aef7"
      ]
    },
    {
      "cluster_id": "58588aa2-076a-4527-9fd4-663a7871c357",
      "members": [
        "d94c4350-9ee2-4657-a287-b9cc227a1c8e"
      ]
    },
    {
      "cluster_id": "f3cb116f-ca76-4bba-949e-3c48f31bacfe",
      "members": [
        "ea8a6908-b00d-4ea8-8587-45b94d8b0aa8"
      ]
    },
    {
      "cluster_id": "ce469142-832a-40af-bb9b-acb726cab86d",
      "members": [
        "b21ee972-2f02-48a4-b18a-5d96a751ea4e"
      ]
    },
    {
      "cluster_id": "8b78f548-1c1b-488a-bf4c-04bfe2488f52",
      "members": [
        "665a5e96-ffeb-49b5-a375-bcd7d84ca008"
      ]
    },
    {
      "cluster_id": "31091b5e-03e8-4b81-8a6c-9a3d02b0c681",
      "members": [
        "0406c3cd-e5cb-4516-bf21-63c67e2af8e9"
      ]
    },
    {
      "cluster_id": "aba53f75-eaf6-4231-90b0-0d2dbfd627ce",
      "members": [
        "940d45b3-70e6-46f0-a780-9809a99095b3"
      ]
    },
    {
      "cluster_id": "7cf0c1a9-abc0-4370-b846-45ce5ff4c375",
      "members": [
        "7eea76c1-8239-491a-b86c-c31c9c30d16f"
      ]
    },
    {
      "cluster_id": "0dae78f8-77aa-48f9-a01e-03b3a39b4e44",
      "members": [
        "ba7f3ae8-8319-4da8-85e6-0a669cd417b1"
      ]
    },
    {
      "cluster_id": "3838bfb8-767c-4ce7-8ddf-06338a137af4",
      "members": [
        "0590b5c9-0753-4758-96e1-e5cd76bd1166"
      ]
    },
    {
      "cluster_id": "48334cb3-0717-4823-bc81-52cb1f9c2951",
      "members": [
        "f4f4ef97-8303-45ba-9603-91a3735fb8d5"
      ]
    },
    {
      "cluster_id": "ea5f5123-a57b-4bf9-83c5-18d3a2293db6",
      "members": [
        "305a64ce-3d96-48b9-967b-6c4e672c9be4"
      ]
    },
    {
      "cluster_id": "ba793871-eeec-487b-a1b0-5996d1bd03cf",
      "members": [
        "a34b9494-4eaa-41ab-92cd-bc9b4997f860"
      ]
    },
    {
      "cluster_id": "c80f9729-aadd-4634-8ad6-b098c5a58675",
      "members": [
        "2a499c9f-f3ec-4921-a1eb-3deb54c320c5"
      ]
    },
    {
      "cluster_id": "e2ca3c4e-ab36-4cff-8fb9-fa527a161a3f",
      "members": [
        "fa4aa885-5e37-48f9-8d0a-08d2a35c8175"
      ]
    },
    {
      "cluster_id": "6e13551c-ec8b-48ad-a58c-87108dea4e39",
      "members": [
        "43adff84-61a6-4eb0-af48-ef6a6f1e9198"
      ]
    },
    {
      "cluster_id": "b49e3614-d80a-41ae-8ee2-883e8abec97f",
      "members": [
        "591b54f0-234f-48aa-9b47-5cc82c1a123c",
        "fb6a025b-c13f-4d8d-ae4b-86c9bf023863"
      ]
    },
    {
      "cluster_id": "410a0800-e775-4016-b3ff-cc215bfaf3d1",
      "members": [
        "71402e8a-ca22-40f1-9cd8-a07cfd02c777"
      ]
    },
    {
      "cluster_id": "05905deb-04e3-4e57-afeb-f4e623c176cb",
      "members": [
        "eb954d49-5502-4206-835c-3a10a98118b2",
        "54325ce3-1512-4768-992a-66f0f8e920f0"
      ]
    },
    {
      "cluster_id": "6869c5c6-393d-450f-8dcf-3be81ce4febe",
      "members": [
        "fe4980dc-3fc5-42dd-808a-4f77b6a3e7d5"
      ]
    },
    {
      "cluster_id": "193fcb1e-c985-42f2-8058-34aadbe0ce78",
      "members": [
        "f0ed4a48-5cf3-449b-9af4-4103c61d6ee7"
      ]
    },
    {
      "cluster_id": "2b84f92b-3438-4364-9cac-d11edad425f9",
      "members": [
        "7315e2cf-aa2a-44ac-9b7d-9e4011640123"
      ]
    },
    {
      "cluster_id": "81907f87-685a-467f-b4fe-172f6390378d",
      "members": [
        "be88cd00-7c75-437d-a4ed-2bce23314946"
      ]
    },
    {
      "cluster_id": "ca92e9ac-f88f-40f7-8676-383e3ddbcb77",
      "members": [
        "73355a88-b3ab-4736-9530-0bf8fd22f429"
      ]
    },
    {
      "cluster_id": "72148a6d-891a-4283-bda4-8779feaa1601",
      "members": [
        "e8e77ba2-5e31-4ffc-a630-5e46fb225165"
      ]
    },
    {
      "cluster_id": "1a503dc4-9b3c-4c99-a076-3e0baaa545f3",
      "members": [
        "6e1811d7-a4c1-4a6e-9814-a4a3571c86db"
      ]
    },
    {
      "cluster_id": "694ef2f3-c0e0-41ec-bcd2-314b770e13f3",
      "members": [
        "ee8baadc-7356-435a-b043-e036316c736f"
      ]
    },
    {
      "cluster_id": "5c164c1e-39f8-4082-aad5-890bec3c1681",
      "members": [
        "6771a937-9b7e-4308-8778-5933007f13dd"
      ]
    },
    {
      "cluster_id": "c9514ac7-3548-4b00-95a5-e99c305bf95a",
      "members": [
        "11b64097-6c56-48c5-b7f0-6c66a88ce389"
      ]
    },
    {
      "cluster_id": "a8627187-7d21-463e-a6ef-6ef26a6c6de9",
      "members": [
        "9d2dad3a-95e3-42b2-8f1a-365b650177e9"
      ]
    },
    {
      "cluster_id": "4c7b4cd7-8288-43da-a54d-f22b707dc22e",
      "members": [
        "c0036d38-f86f-43a1-9d36-18b6cd875492"
      ]
    },
    {
      "cluster_id": "e3712e03-c7c7-4373-818a-4c6598fd68df",
      "members": [
        "30306578-b0f0-4d7b-95ec-b7ce6dffad27"
      ]
    },
    {
      "cluster_id": "be8fcb60-f85e-4def-aa6a-bd82881e44d3",
      "members": [
        "fcbc729e-4ebb-4e03-9ba1-bd46577a1afd"
      ]
    },
    {
      "cluster_id": "a5f05825-1201-440d-8dd2-454ae9c16034",
      "members": [
        "1e9aaf0c-a0a3-4e6c-9d50-f3a37bfc6b98"
      ]
    },
    {
      "cluster_id": "d29993d5-ca77-4b15-919e-f95ec679fdca",
      "members": [
        "de11a555-90f2-46ba-89ef-5e92182e5dd3"
      ]
    },
    {
      "cluster_id": "e1667646-95da-4708-8fd5-fef1ce4974fe",
      "members": [
        "fd8214fe-d447-43f4-9384-6c07f29437c1"
      ]
    },
    {
      "cluster_id": "67b88198-8628-4938-a751-4acddbc9098d",
      "members": [
        "bec8002a-957a-4b2d-bd52-ecd09a473411"
      ]
    },
    {
      "cluster_id": "ca6289c9-7aca-44b6-8a18-1a2d2282cd8d",
      "members": [
        "b43897b3-fbd6-4677-96a7-879a951f0d8f"
      ]
    },
    {
      "cluster_id": "49b59607-bcf5-4471-8809-4106f681d4d2",
      "members": [
        "983cf193-fe53-4ef7-9d0a-1e4afaf5d452",
        "d2f0ec5a-c60f-47ad-8641-9bb20c727dd0"
      ]
    },
    {
      "cluster_id": "5d70f462-c3f9-4394-a045-eee646d218c8",
      "members": [
        "39aabe6b-de06-4d4c-bd1c-6b45416c94d9"
      ]
    },
    {
      "cluster_id": "21be5a19-a4c5-4da5-a267-9d6169f7d6f0",
      "members": [
        "73a2d70c-6ae8-4ab3-9243-499877a9229a"
      ]
    },
    {
      "cluster_id": "11eba0ed-7efc-4733-b927-256265e60430",
      "members": [
        "6e6a39f4-391f-45b1-96f8-5db1f260e0dc"
      ]
    },
    {
      "cluster_id": "b88b8f26-8273-40e5-8f02-5f503edd6ce2",
      "members": [
        "8af698c2-5055-44a6-b5f7-112ad08b0b43"
      ]
    },
    {
      "cluster_id": "ed0282a9-1dce-4648-ba02-635146d8d79c",
      "members": [
        "00ab3b97-6e21-4f23-b4c5-3d7a07cef906"
      ]
    },
    {
      "cluster_id": "72521c8d-f680-4322-878b-70c3f47a7f96",
      "members": [
        "54874259-749a-48ec-b11e-773e0bdb8c69",
        "9194eb05-876a-4b47-a2b3-88a2a01df4e0"
      ]
    },
    {
      "cluster_id": "acddf1eb-d6f9-4c70-9523-034fc5a8acd5",
      "members": [
        "3cfde12d-2dad-4c2e-aa55-b283a69f332c",
        "8f6b1e84-266b-412f-bf9f-c4180186fa63"
      ]
    },
    {
      "cluster_id": "43017a0f-25bd-45a1-b94f-31383b0d5c09",
      "members": [
        "efad7ff7-104e-4b5f-9f70-db6054dfedfb"
      ]
    },
    {
      "cluster_id": "c9f98636-16e1-43ce-a03d-d6e0e40dfac6",
      "members": [
        "c7445ec4-c898-413b-ab18-14896d7e1407"
      ]
    },
    {
      "cluster_id": "77a67b7a-5038-4c86-adcc-8306f16e92e1",
      "members": [
        "b77c3439-e11b-4cf4-b980-ef7fa9556cd4"
      ]
    },
    {
      "cluster_id": "4dc1a0fa-5313-4a33-a001-984da53ababb",
      "members": [
        "ac0f6f8a-8d44-4d77-a4f9-b18247cb3c79"
      ]
    },
    {
      "cluster_id": "94f99c45-cd6a-4279-9860-a3fae3c6e14b",
      "members": [
        "002ad764-192c-4309-9aaf-6df338407edf"
      ]
    },
    {
      "cluster_id": "314440c8-19da-496d-8536-f62999889410",
      "members": [
        "762e7eb9-c8a4-4aa9-b191-bee023e61b2e"
      ]
    },
    {
      "cluster_id": "1ccab5e4-b80e-4900-88c8-f5ed9013c0df",
      "members": [
        "980a2f59-eb2c-4c4d-abd3-431daae5ef23"
      ]
    },
    {
      "cluster_id": "c814031b-97fc-4571-859f-e9e8df89373b",
      "members": [
        "3cfad4f3-6fc2-4f26-a834-a43a7b0794b7"
      ]
    },
    {
      "cluster_id": "ca50545a-7854-48c2-bb9c-e0894d7bf854",
      "members": [
        "34b91876-9c9a-4c8c-ba6d-7e30fca86167"
      ]
    },
    {
      "cluster_id": "6c452c9f-8197-4d78-94e1-5bde1551953f",
      "members": [
        "8d356c7e-c604-4cd5-811b-038ceb0c38b0"
      ]
    },
    {
      "cluster_id": "46cde8f4-4b4b-4cae-87a1-063914f15878",
      "members": [
        "57e029f6-f514-4250-98b0-9829baf98d0e"
      ]
    },
    {
      "cluster_id": "7bdac760-2a67-4126-ace8-6bee9660bcc4",
      "members": [
        "05e5f4e3-b600-4ab8-a59e-1dc2981fb49b"
      ]
    },
    {
      "cluster_id": "2fc962c7-e77d-4ca3-a166-4f1d011720db",
      "members": [
        "9e63d817-1f55-40ca-a35c-e00a82a3a99f"
      ]
    },
    {
      "cluster_id": "0b7703f0-770f-46f4-8c70-921a8b6b2ad7",
      "members": [
        "d6ba753b-c0e4-42b7-bd2d-a92f2ee0dbc5"
      ]
    },
    {
      "cluster_id": "2034d9a0-a9ba-4e99-89d7-79e736b91d31",
      "members": [
        "0a98d06d-023c-44a0-9fc5-509d19b38745"
      ]
    },
    {
      "cluster_id": "5540f6ac-c1b9-4d28-95e7-760d9496128d",
      "members": [
        "b5b0482e-4cc2-4e41-ab3d-f19bb86d1812"
      ]
    },
    {
      "cluster_id": "23aed1db-c001-4e2a-9a10-0e9f672d2101",
      "members": [
        "26b3f753-b6a2-48c1-9d6a-cbe595e9cf9a"
      ]
    },
    {
      "cluster_id": "72ff31f6-b46f-456b-85ee-5ab8c2328972",
      "members": [
        "2f9cbcfd-eb09-4056-a5ff-7cf0d1db3fd7"
      ]
    },
    {
      "cluster_id": "05daa73c-fc4c-4000-9d0c-990f237b7870",
      "members": [
        "f70c19fe-3505-4ab2-9ab0-6a45af387624"
      ]
    },
    {
      "cluster_id": "3e6833b5-d7ea-4b12-87f8-2eba62891434",
      "members": [
        "3779b2b4-72ad-4216-a393-f6f1dabd000c"
      ]
    },
    {
      "cluster_id": "fb28be3e-346f-4ae2-b2c5-0971d759b337",
      "members": [
        "b2200702-6b63-4b01-87ff-017000ff0260"
      ]
    },
    {
      "cluster_id": "a2d75661-0f1a-4093-bbb2-d5f9c836dda0",
      "members": [
        "e90e8db6-9ef8-4098-9557-3bea5226e758"
      ]
    },
    {
      "cluster_id": "afcb3ce0-1612-4cdd-a65f-fb2d5a6bf76a",
      "members": [
        "2ed54469-0ca1-4594-b9cd-6a4dd1ac5d39"
      ]
    },
    {
      "cluster_id": "51c1b08d-506f-4dea-874d-a86b8ab55fb1",
      "members": [
        "3ee694bb-64d1-4524-953b-9b6fce34fdc3"
      ]
    },
    {
      "cluster_id": "79b49988-337e-4ff8-a4e9-5a2de271d6d6",
      "members": [
        "b4a79b96-99a9-4a91-b088-49b7050f5b95"
      ]
    },
    {
      "cluster_id": "876fd136-352b-46eb-aeb5-3fca6402213f",
      "members": [
        "5e40c84a-3e2d-4524-9438-1802d3a8cf3f"
      ]
    },
    {
      "cluster_id": "941c849f-959d-4e16-a04f-2de733d8f77c",
      "members": [
        "c005ff75-a064-4a3c-86eb-eb86647b34a4"
      ]
    },
    {
      "cluster_id": "56a382af-0cf2-4fb5-ba8f-a5cad69ed381",
      "members": [
        "05cc23e5-451f-45c4-a3d8-baf02ed8b1cf"
      ]
    },
    {
      "cluster_id": "204fc215-6ab9-4083-b883-b901ca6c7818",
      "members": [
        "14a7a112-b7eb-44ae-885d-f26b79d04d94"
      ]
    },
    {
      "cluster_id": "a4a5f3c7-c987-41f6-9618-486ae48abb68",
      "members": [
        "4a9507d7-da94-42f8-9b2e-a49c83431f77"
      ]
    },
    {
      "cluster_id": "d4a86c9e-1cea-4922-914c-e44e0a71bd5f",
      "members": [
        "c44b7722-081b-4cd1-93d5-faf1089228fa"
      ]
    },
    {
      "cluster_id": "acba4f1a-9129-40e6-80cc-1b3cb9b40341",
      "members": [
        "30571462-7d39-4198-a6af-6fc2f680789c"
      ]
    },
    {
      "cluster_id": "a33e2184-c58d-453d-a647-1ef27ddf5c17",
      "members": [
        "6c2dd03d-486d-4383-8487-648cc09d3bb4"
      ]
    },
    {
      "cluster_id": "51ee5c3c-1ec7-4729-8ed7-80ffe951b756",
      "members": [
        "58eac9be-2d07-44e7-9e0c-987bc00cd292"
      ]
    },
    {
      "cluster_id": "597adccf-df25-4f4a-b01c-58baf036682b",
      "members": [
        "87166f51-253e-4199-a77e-38acc46791b1"
      ]
    },
    {
      "cluster_id": "40850d8d-b18a-4d10-bfba-dd521fe3cd4d",
      "members": [
        "718332a4-dd29-4f25-a473-6e8bd0cb22a3"
      ]
    },
    {
      "cluster_id": "5a08709f-1906-45c5-8ded-3d7e4a3851d0",
      "members": [
        "b82e5675-9079-4d76-af45-acd9d76427b1"
      ]
    },
    {
      "cluster_id": "1352c5e1-e3f4-4bd5-a309-04804d3a9c0a",
      "members": [
        "71aac4ad-c4ba-437f-88e3-7a7dd911dcb1"
      ]
    },
    {
      "cluster_id": "52587d0c-b6c9-4b93-964d-b5598a3e9ddb",
      "members": [
        "2219de3f-c10d-44d9-8348-98d0f76ea054"
      ]
    },
    {
      "cluster_id": "f795636b-a096-4302-aa9e-87494f4166de",
      "members": [
        "4467b4d6-6db4-4ae3-897f-c71b39b99b75"
      ]
    },
    {
      "cluster_id": "c3765121-fe92-4ebe-aef3-b794fa8089f1",
      "members": [
        "fa4768e3-042a-4590-b80d-f9ed21f8bf63"
      ]
    },
    {
      "cluster_id": "f9ebd297-091c-4753-9543-c123ed3c1fc3",
      "members": [
        "3644af40-9a18-458c-9b5a-baa30fcd42af"
      ]
    },
    {
      "cluster_id": "d2d04da3-8b22-4ac9-819e-ca8c7ec67255",
      "members": [
        "ac7d8fef-743f-44d8-8eac-628150b093cb"
      ]
    },
    {
      "cluster_id": "37386c6e-8d47-43fa-9d2e-223bce8f6923",
      "members": [
        "37d16f32-1c1a-4192-9912-dec4b8037c52"
      ]
    },
    {
      "cluster_id": "eb805fd1-c766-4517-8cad-81a53adf5b1e",
      "members": [
        "32886ec4-0e74-4f78-801d-9b086ef6e27b"
      ]
    },
    {
      "cluster_id": "68230774-a51a-4451-9136-5aab1d1fcce9",
      "members": [
        "47b8a608-dcab-4933-8d24-5f247103731b"
      ]
    },
    {
      "cluster_id": "9ec7d104-4eab-4fd5-9ba5-4ccd50945a34",
      "members": [
        "bd31d7a2-a935-4379-88ae-94c01218bbbd"
      ]
    },
    {
      "cluster_id": "fe1c4a63-bcaf-4dd2-88f2-589a45ffdabb",
      "members": [
        "82593280-f906-4578-88d1-6b4e7405ff9c"
      ]
    },
    {
      "cluster_id": "37e4b5f9-aa2b-41cd-b6a4-443e69596bba",
      "members": [
        "c948621e-8d8e-4620-87ae-06fef41b1734"
      ]
    },
    {
      "cluster_id": "9e3e1492-3c76-4be0-979b-239d4deb8c80",
      "members": [
        "e5859b67-f473-4db3-b82a-d4d4fef700e0"
      ]
    },
    {
      "cluster_id": "88c327f9-75c2-480a-8aa8-272d021cabe8",
      "members": [
        "c5a26d30-1663-472e-b98d-390d4844fdbe",
        "e158fda9-8d0a-47f7-b059-e84c1c800e8e"
      ]
    },
    {
      "cluster_id": "b9073e54-b54f-4298-9384-944112b843d7",
      "members": [
        "31934143-3c72-48e5-be8e-a14ffd12d5a4"
      ]
    },
    {
      "cluster_id": "b3af6432-57a3-4958-a1a0-2d28085f3e29",
      "members": [
        "e385647e-3102-4792-bcd1-19242a4fbbde"
      ]
    },
    {
      "cluster_id": "f2b07e8d-84c5-4fbf-bf1e-736428e76d16",
      "members": [
        "e65b3ae6-623b-4823-972e-85f5db1077bd"
      ]
    },
    {
      "cluster_id": "cd8387d2-f3fa-45cb-9628-ef16bef4b5fa",
      "members": [
        "c7568f75-5d33-4f78-ac5f-2b22b319ad9b",
        "43a3c668-1c99-4d67-9f07-2295e4fa2080"
      ]
    },
    {
      "cluster_id": "38dbd9f2-4706-4ca9-a837-817a4ee621f8",
      "members": [
        "e806c81b-121d-4434-b5f9-7d826a8c8157"
      ]
    },
    {
      "cluster_id": "bc23e70d-7b5e-43f0-97b5-b24c31beffb6",
      "members": [
        "7ad1f552-9b72-414f-8930-825c8c13f43b"
      ]
    },
    {
      "cluster_id": "ee1eb50f-e51b-487b-895c-d08085b62fd8",
      "members": [
        "54359d28-7f5e-486b-a6de-9a497f40a798"
      ]
    },
    {
      "cluster_id": "e80fcdb9-26cc-4925-8100-e10e8d09e8d6",
      "members": [
        "87ea2344-d684-49dc-8b7e-74f7e5c8236a"
      ]
    },
    {
      "cluster_id": "7fe41e18-746f-4276-85f6-d30d85eaa538",
      "members": [
        "866df254-eab6-4e0f-9839-df235e8e45c8"
      ]
    },
    {
      "cluster_id": "329efe6d-0194-47fc-abcf-cc9c3ee312f8",
      "members": [
        "91e53de0-d41e-4e9b-8346-05a13a63aaea"
      ]
    },
    {
      "cluster_id": "ca62b0d7-872b-4a9c-b006-86ccfd239161",
      "members": [
        "268d049a-ff0d-446c-892e-be63bae981f7"
      ]
    },
    {
      "cluster_id": "1b2e8a52-7038-453e-802e-e2b6d0c4da48",
      "members": [
        "b3bf3acf-8658-4438-8fc3-9121b6ef3cf4"
      ]
    },
    {
      "cluster_id": "8ec5c238-a613-4762-a252-bba4045dc17b",
      "members": [
        "a6a0d394-94e6-4004-b0a4-e2a766da0990"
      ]
    },
    {
      "cluster_id": "d26a88d8-31d1-4986-9e0c-b30944f01491",
      "members": [
        "0b9816b1-a151-4873-868b-f96734498575"
      ]
    },
    {
      "cluster_id": "bb00bd4b-2a33-4849-ae7f-804463c9c453",
      "members": [
        "bde486b8-5144-404b-8859-bb1c36e4a7cb"
      ]
    },
    {
      "cluster_id": "0709871d-a6ab-4aa2-93bf-03bb443f89a9",
      "members": [
        "19c2f557-90c5-4d02-b5b7-4fe2bedf2697"
      ]
    },
    {
      "cluster_id": "ed413a70-b4e1-4736-9370-9237ebadaa06",
      "members": [
        "ef8d9f19-4eb5-4e71-90c2-29af1784a1a7"
      ]
    },
    {
      "cluster_id": "53368f02-d082-40dc-87de-4a43534eebcb",
      "members": [
        "f7f58c67-cfd7-44a8-bed6-6d2cf84f1177"
      ]
    },
    {
      "cluster_id": "fb8d8d1e-9afb-496a-b65d-ca304c598e8b",
      "members": [
        "1aac101d-dacc-4be2-a5ce-3356f3be8bba"
      ]
    },
    {
      "cluster_id": "36e1cdef-b33a-4858-bed1-0bbaf9ed9bc4",
      "members": [
        "20b68f2c-ede3-4b79-8b30-f4f92f82e291"
      ]
    },
    {
      "cluster_id": "80becc29-3509-4795-9714-7ee69f928767",
      "members": [
        "df8f7af0-995d-4491-b720-0ed74aff1bd7"
      ]
    },
    {
      "cluster_id": "84599781-5c1d-4670-83ce-2909c7c1b4c9",
      "members": [
        "9ba5945d-a92f-4753-8e7c-6950d4334327"
      ]
    },
    {
      "cluster_id": "14786248-4bb0-4ea2-9421-150787f5ff33",
      "members": [
        "8f16a64f-19ca-4010-9a3a-d0d2f845c4e9"
      ]
    },
    {
      "cluster_id": "14f2fead-e1a2-4e74-b696-6e535d49d9d6",
      "members": [
        "5a10c5b4-40de-4c27-bc08-d2db418600f5"
      ]
    },
    {
      "cluster_id": "c555ba02-3f53-4880-89cc-6382472f4518",
      "members": [
        "24a7bb0e-8f0b-4530-9cd4-877c382ceb83"
      ]
    },
    {
      "cluster_id": "603bb3bf-f1f7-4182-8a09-670b111a3fe8",
      "members": [
        "4bdfc6c9-8b0d-4081-9009-7df88df8ca84"
      ]
    },
    {
      "cluster_id": "76382e4c-a4a2-4fb5-bc4f-138c970156c3",
      "members": [
        "56f50319-d69b-4260-b71b-2e15ce63525b"
      ]
    },
    {
      "cluster_id": "a08b7547-a0f1-452b-9b55-18b72ad44763",
      "members": [
        "57973400-71de-4136-93ea-3cd72006e34b"
      ]
    },
    {
      "cluster_id": "65022a70-336c-4701-8443-508f49365fb4",
      "members": [
        "bb766db9-0ed3-48fa-a230-75de0238867f"
      ]
    },
    {
      "cluster_id": "6ea91435-3e36-4fbf-82c3-faa6793916cf",
      "members": [
        "6ddf7466-bb26-4196-b780-b6a7d105ddc9"
      ]
    },
    {
      "cluster_id": "114c5c62-e2bf-4ad2-a913-3744fd25a373",
      "members": [
        "5ec8ac77-d6c6-4b49-ad58-6e7ed13bc035"
      ]
    },
    {
      "cluster_id": "df948051-689d-40a8-ad8a-28a2dedfe405",
      "members": [
        "3a16f7f5-193e-45b4-9365-51e6a77e3c98"
      ]
    },
    {
      "cluster_id": "8f35aa71-39a9-43b6-9e1f-9db20e05a30e",
      "members": [
        "a591ba5f-94a6-48b5-ac58-cad39c32c43b"
      ]
    },
    {
      "cluster_id": "182dd0dd-1319-4405-9396-03bc211809ae",
      "members": [
        "24d68e62-8527-4803-a6fa-26ca777c2034"
      ]
    },
    {
      "cluster_id": "66195131-3ad8-4241-a0d6-4ab7e32c6962",
      "members": [
        "0d0f16d3-7244-40d6-8623-7bbc698bb8c1"
      ]
    },
    {
      "cluster_id": "89a3e6a9-addb-4b72-822c-a5a7371734c9",
      "members": [
        "778d9125-bcbc-4421-8105-7e56bba3ac9c"
      ]
    },
    {
      "cluster_id": "d23ce59c-1b68-42d1-aa3b-b8143bbd9381",
      "members": [
        "9fedbf3b-a1f8-43c1-a02f-d7906d208ace"
      ]
    },
    {
      "cluster_id": "7d9d58bd-39b4-4188-a92b-2b9d72ec8bda",
      "members": [
        "ee2b5dde-c6a4-44e6-91e9-f790e10f5c1a"
      ]
    },
    {
      "cluster_id": "093f494f-e108-4f07-9dbc-35136554407c",
      "members": [
        "a455b48b-d608-4d35-8e42-fb15238e3c1e"
      ]
    },
    {
      "cluster_id": "32156667-7185-4800-9042-38e82870feff",
      "members": [
        "3042955d-53a1-4769-a6b6-37d95536e374"
      ]
    },
    {
      "cluster_id": "a51db09c-f39d-441d-9164-06ba998d58ef",
      "members": [
        "0c0c7555-4cc9-4ac2-8d94-c6de26942ea5"
      ]
    },
    {
      "cluster_id": "977581f8-a92f-4a60-b0ab-96b42b1d0d8d",
      "members": [
        "1746fc40-2a42-4e97-a0c1-37b0a4e68a4a"
      ]
    },
    {
      "cluster_id": "912fe4ed-bb41-46a5-adbb-0dc779234edb",
      "members": [
        "a2d84b93-0df4-4e63-9670-f3d9a9a9dc14"
      ]
    },
    {
      "cluster_id": "6ff9b10a-54cf-4a58-8655-1ec5ccd1ae56",
      "members": [
        "064c16c3-68f4-41b1-be9e-990d256b0466"
      ]
    },
    {
      "cluster_id": "907e5aa7-c645-41eb-a469-330fec247119",
      "members": [
        "e72daad4-3b24-4846-a74e-4a1d8b895eda"
      ]
    },
    {
      "cluster_id": "783dc097-3e45-45ff-9e18-33ccfd6d47cc",
      "members": [
        "c70dff2c-a58e-47a1-af56-83c11341163f"
      ]
    },
    {
      "cluster_id": "2bf12fd5-52d9-43a7-9a2b-ede63bb26438",
      "members": [
        "cbb7f4ca-acb8-4b3e-a9d2-1cc7a9064d6d"
      ]
    },
    {
      "cluster_id": "eaeb1421-7550-4957-9610-ed74a0bffc8e",
      "members": [
        "448455c0-dec0-4c30-9c5f-aab743506784"
      ]
    },
    {
      "cluster_id": "9d882154-e197-4475-b27e-35c54fe8fbfd",
      "members": [
        "9d0098f8-dd9a-46f3-84b1-d414eaa77b49"
      ]
    },
    {
      "cluster_id": "a868051f-7c6b-4631-b5c0-5298f1a4a3bc",
      "members": [
        "03fc25c8-6565-4956-b018-43689aad9c23"
      ]
    },
    {
      "cluster_id": "5e94868b-1054-4680-801c-eccafab6e048",
      "members": [
        "6d0467df-7983-4515-ac57-1f12a57ca12b"
      ]
    },
    {
      "cluster_id": "6b198d6b-8dea-4096-80f2-e19aa989c1d0",
      "members": [
        "251313a8-e1f4-418f-b7ec-999fc0fb8382"
      ]
    },
    {
      "cluster_id": "c0fe2a1f-22f3-4601-9b6c-36727a9d81a9",
      "members": [
        "5e82075f-1456-452c-aa6b-fdc95e1abdbf"
      ]
    },
    {
      "cluster_id": "0a56e25c-3625-49c1-8cd1-fb3ddd10b2d3",
      "members": [
        "5fceb450-5102-4bbc-9eb7-6c8ec2ddac81"
      ]
    },
    {
      "cluster_id": "6c82fce7-dc95-4a42-b643-38f90297f22f",
      "members": [
        "4de30eb0-80c4-47bc-aef3-b0084f707f82"
      ]
    },
    {
      "cluster_id": "9f093a15-003e-4c3e-b942-5c6cfb87c05d",
      "members": [
        "7ff40f6e-eaec-4880-9537-3c9b00bbca5b"
      ]
    },
    {
      "cluster_id": "cb95b455-562f-46e4-96a7-2aa2409fed5d",
      "members": [
        "3a076af1-11af-418f-aa40-3c6fa44ee4d0"
      ]
    },
    {
      "cluster_id": "51ccaad9-0af3-4189-abe9-de4b65c38edd",
      "members": [
        "0be4bc5c-7b5a-4ef4-a8d4-07615ddc8057"
      ]
    },
    {
      "cluster_id": "bfee71d5-dc3e-4049-85bd-25e416b8ce0f",
      "members": [
        "175cfdfb-482b-40b7-841b-1ab0f30b4ad4"
      ]
    },
    {
      "cluster_id": "3e8cbb71-09f5-4d7a-9358-2ef082adc4f1",
      "members": [
        "dc0c35f8-e154-4f77-9985-1c9b26049328"
      ]
    },
    {
      "cluster_id": "77f85883-e69f-43a1-9e7c-0df03c9438b4",
      "members": [
        "1046d912-9eb5-473e-b1e3-e44a58d9efc5"
      ]
    },
    {
      "cluster_id": "822c1997-a0a2-41cb-9793-22c777eab1a6",
      "members": [
        "20687b4c-4568-43d0-a364-3e7b62415b93"
      ]
    },
    {
      "cluster_id": "c4596456-6844-4eff-9082-8a0cfee4acfd",
      "members": [
        "ebed6d47-3655-4cdb-9e0d-3e4b8b5250f4"
      ]
    },
    {
      "cluster_id": "f3ad65a5-41f2-46d7-a4ab-cdfd0feea00d",
      "members": [
        "624a8794-6072-4c14-b064-3cd0f7176f27"
      ]
    },
    {
      "cluster_id": "eff030fc-3925-4754-bd4e-8589b262523a",
      "members": [
        "ca820777-5138-42b0-83f8-a271af01a0d5"
      ]
    },
    {
      "cluster_id": "31351498-4fc3-4c6e-8df2-7c515d19509b",
      "members": [
        "c41b52a3-cc15-4d6a-a1f7-a2b34b2bbbf9"
      ]
    },
    {
      "cluster_id": "6a03d110-92cd-4da9-913a-56888b17641f",
      "members": [
        "9353fc2d-ebee-4790-a39e-97f99d698f2c"
      ]
    },
    {
      "cluster_id": "2f12da3e-336e-40d2-ba41-61b838ad70f2",
      "members": [
        "91b4971b-0ca4-497f-b743-324a75fb24ec"
      ]
    },
    {
      "cluster_id": "86986259-8535-49c7-b1f7-162a0bd7065f",
      "members": [
        "05a8230a-9e18-47f4-a599-5a2e22951aa4"
      ]
    },
    {
      "cluster_id": "46b53499-f467-4b91-a839-e6551db764a7",
      "members": [
        "5d26cae6-70ae-4538-bffb-13c8cfdd12d3"
      ]
    },
    {
      "cluster_id": "46187cfd-07e9-43ce-ade9-ed6a220120f1",
      "members": [
        "4b497d85-1ab7-4531-878e-a50a0bcdacd6"
      ]
    },
    {
      "cluster_id": "0f1dfea7-22b4-4df1-ad86-305165ef36ec",
      "members": [
        "a02608af-40bb-43d5-8e01-4571f9e25918"
      ]
    },
    {
      "cluster_id": "92103df4-5a66-4430-95e6-d2ba83f705a1",
      "members": [
        "e13fe5cc-b563-4cc5-b79a-229ae44115f0"
      ]
    },
    {
      "cluster_id": "25733340-8065-4c67-9da5-97f671877eea",
      "members": [
        "137c3a2c-b285-4f79-9f8e-668e81a104a3"
      ]
    },
    {
      "cluster_id": "911f995f-4932-433d-afa5-fabf5bc995f7",
      "members": [
        "5682313f-865a-458f-8e62-452d573278ed"
      ]
    },
    {
      "cluster_id": "b89167c2-18ac-44c5-84c6-4b246cc9bd50",
      "members": [
        "a4320de0-a712-485f-abda-679489aa1b6c"
      ]
    },
    {
      "cluster_id": "b4e6a6dd-1e51-4a7f-a1bb-cfc861598a03",
      "members": [
        "0f7061b6-6043-4410-b704-61d7dd78a521"
      ]
    },
    {
      "cluster_id": "bd9f40ee-8b97-4557-aa2d-1a87da031fda",
      "members": [
        "44da0a37-f82c-4cad-bfe5-e204c1db5323"
      ]
    },
    {
      "cluster_id": "4e48f414-895d-4241-a8ae-69662f5c3d46",
      "members": [
        "53494bc0-80d7-4d7e-96ba-5759ddcd5040"
      ]
    },
    {
      "cluster_id": "e4ca57af-fa5a-4a42-8e77-8ccc8efd6660",
      "members": [
        "e8eb66b4-7cc2-4c98-9599-381d976cafd3"
      ]
    },
    {
      "cluster_id": "b223bdd2-4e37-4cb0-a50b-feb184bdfe78",
      "members": [
        "738d2afd-7833-497f-8017-f2aabab1b1a4"
      ]
    },
    {
      "cluster_id": "e47fcd0d-6eef-4992-8b24-a772ebce5f31",
      "members": [
        "8fd28181-b001-45e4-9ee3-ed5e32911dcf"
      ]
    },
    {
      "cluster_id": "cb02ee47-9033-4860-896e-93d4dd3bca66",
      "members": [
        "65cee6b7-dc37-42c9-8eed-7fba599b7d7e"
      ]
    },
    {
      "cluster_id": "d77acdbb-aa93-4e79-8f2a-2afe86ba39c8",
      "members": [
        "e5178884-c3bd-49ae-b6c3-45172799ae66"
      ]
    },
    {
      "cluster_id": "0a822774-2208-4f62-a8c9-3dc70aeef8ea",
      "members": [
        "098bcd9d-ddf1-4c65-b0fc-34b8bea61b74"
      ]
    },
    {
      "cluster_id": "474921fd-8a8d-4c36-8ea4-d0c78016b2c8",
      "members": [
        "80eae812-9302-4821-b61e-1bdd4f3addec"
      ]
    },
    {
      "cluster_id": "f9f83549-19b2-4c63-8024-bec6ccd4b48e",
      "members": [
        "23224cad-e128-4f5a-a52e-22a839d6851d"
      ]
    },
    {
      "cluster_id": "1b9aa65f-dcda-40ea-bbc1-8c1521f177ad",
      "members": [
        "5d6028ad-e08a-4e90-a37d-73ad42daa692",
        "97af48fd-228b-4ae1-8b4b-c1d114bd42f2"
      ]
    },
    {
      "cluster_id": "97137b20-3c93-43e9-b1a9-879cf76db9bf",
      "members": [
        "acdbdbb6-8f0c-4877-9f47-0cffb856d645"
      ]
    },
    {
      "cluster_id": "f69427e1-c0af-413b-916d-3232db85e095",
      "members": [
        "af2cd870-1bfd-4c78-8511-26fb2be73bd3"
      ]
    },
    {
      "cluster_id": "d88a7e63-a270-4d1c-9493-0a86c58b3e3e",
      "members": [
        "2f77db8a-bdb2-4505-bafa-638be4613c24"
      ]
    },
    {
      "cluster_id": "9a525fe9-9fb6-41e1-85e3-967787b02690",
      "members": [
        "282392b6-8e67-4518-bf69-6d86fe0553bd"
      ]
    },
    {
      "cluster_id": "51de12f3-d554-4161-b0ec-4b2186f0cb26",
      "members": [
        "a082ac54-2c02-41a7-ac77-27b198d48fa6"
      ]
    },
    {
      "cluster_id": "0be1925a-4753-4905-9510-39b869eaa6c5",
      "members": [
        "ff0e6625-2708-48a0-a9cf-76e34d20b270"
      ]
    },
    {
      "cluster_id": "eb9b2ee9-7136-4b80-93fc-c731e2546e36",
      "members": [
        "de7c7a6e-0670-4c9f-aaba-f57baab5ab18"
      ]
    },
    {
      "cluster_id": "7e444e77-337a-4bc6-8707-11c965b7d9dd",
      "members": [
        "a928cfbf-3c70-4ff1-a75c-c403bb49867c"
      ]
    },
    {
      "cluster_id": "ae0aa30d-b0b4-4bf5-a41e-7d8900417e46",
      "members": [
        "c356e4eb-e27d-4a3e-abe8-009c48fde26a"
      ]
    },
    {
      "cluster_id": "877d0ee7-3726-4284-a1ed-d3b7c9b6d67b",
      "members": [
        "16612cfd-8068-41f7-8172-2f740d431c9e"
      ]
    },
    {
      "cluster_id": "b61c8bad-f744-4e5e-908b-0b070a8f0d89",
      "members": [
        "a555c8b9-1afa-4f97-b4dc-4481e73cbc26"
      ]
    },
    {
      "cluster_id": "582e1668-0621-414e-a531-9d7ad55393e8",
      "members": [
        "8d221e15-abaa-4b86-bcd8-6c8f3992df82"
      ]
    },
    {
      "cluster_id": "634e943b-2d48-48b0-b1e8-52524e278a9f",
      "members": [
        "35abddd0-8c9c-4eac-8f42-8331b2dc89b2"
      ]
    },
    {
      "cluster_id": "b98f7184-2007-47d3-9d06-42431c2a8c92",
      "members": [
        "fc2341a7-a527-42d8-9b4e-47a15bdee23c"
      ]
    },
    {
      "cluster_id": "efefa709-c6f7-4ec6-ac92-9ac520723e87",
      "members": [
        "c3c8f8e1-9283-4b90-97ed-3ac662aafa45"
      ]
    },
    {
      "cluster_id": "32e37585-3bd0-4873-ab47-c364fef5143f",
      "members": [
        "5331b603-f4f9-4c0e-8c5f-004eb0a84c42"
      ]
    },
    {
      "cluster_id": "d3a45ffa-7001-4495-9c5e-b65ea28becba",
      "members": [
        "f1f95a39-34bc-46b6-8e23-9f376df7ccce"
      ]
    },
    {
      "cluster_id": "7e78bb5c-524d-46ad-855f-72bd9413c27e",
      "members": [
        "3f8fdb93-471b-47ba-b68a-64e3317ebb5f"
      ]
    },
    {
      "cluster_id": "43d693d1-43e9-41bf-9f49-b7662edb6922",
      "members": [
        "007f723c-0723-48e4-b50f-8d0dfe461ddb"
      ]
    },
    {
      "cluster_id": "3b30bb51-81c4-40b5-ba0f-a5b24a020dc5",
      "members": [
        "373910f6-e433-4432-8fd1-36130b42aa58"
      ]
    },
    {
      "cluster_id": "d6692fd4-0be3-4dc0-8e52-422dc764cb03",
      "members": [
        "bc88db62-48ed-4917-9bb5-a865c3d0db76"
      ]
    },
    {
      "cluster_id": "b1943af1-84eb-4734-88d0-58f88d216275",
      "members": [
        "5288810b-8f88-4c33-a5e1-554dc6f37a57"
      ]
    },
    {
      "cluster_id": "6eee7591-18a7-498f-a4ad-f5aae119dd62",
      "members": [
        "0c565dd5-edf4-4578-986c-6641418f5db6"
      ]
    },
    {
      "cluster_id": "2867ef8f-0ebb-45b2-b82a-289a3f763133",
      "members": [
        "5708038d-77b5-4d13-a3e0-17bf63cb3747"
      ]
    },
    {
      "cluster_id": "8cf3def2-907f-4b61-b37f-0d9e2ed2b954",
      "members": [
        "b8e1aa44-e0a9-4ac8-84c4-9b8d11ecc023"
      ]
    },
    {
      "cluster_id": "1b8d5fdd-83db-44f0-aa44-0aa853c3b3f8",
      "members": [
        "334e0219-555f-4c2a-9e39-8bf18a633bfc"
      ]
    },
    {
      "cluster_id": "abfe0416-9747-4ab8-9cdc-8e88fa47871d",
      "members": [
        "27059d4c-ff52-4e1d-be06-22d58f3310cb"
      ]
    },
    {
      "cluster_id": "b69ad8c1-f3a2-41d7-805d-8cc01784789b",
      "members": [
        "c3bdd91c-c749-452e-9569-4a2f9ae816b5"
      ]
    },
    {
      "cluster_id": "b25f7b20-354c-43f5-90f3-fd9a86b1ae72",
      "members": [
        "465078fd-c082-499c-a845-cc0d9d17870a"
      ]
    },
    {
      "cluster_id": "7bf16433-80b0-4f9a-878b-7a95d835ad86",
      "members": [
        "64c5c7aa-d736-4d89-ae48-bfbe4db56db1"
      ]
    },
    {
      "cluster_id": "54513007-2bf5-4c3c-8060-c65d26b45075",
      "members": [
        "1ad1da71-c024-4520-94ef-d41f9192778d"
      ]
    },
    {
      "cluster_id": "b060d900-983c-47b6-b9e8-d31f4dbd3db1",
      "members": [
        "ccbb31ba-c8f7-4e64-8d55-3478e29a9482"
      ]
    },
    {
      "cluster_id": "4fdaa1a3-7430-423b-81e3-be520cdd6936",
      "members": [
        "337fa8d2-b644-433d-b4e8-bdefe78aa9cf",
        "00a0ec8c-2e64-4107-82df-2cdb7d4833de"
      ]
    },
    {
      "cluster_id": "10142c53-0aae-468e-a5f8-9d5313be2cf3",
      "members": [
        "12665c7c-4759-4bff-8dd9-6ffe68c66a7e"
      ]
    },
    {
      "cluster_id": "966cca08-6c6e-46f9-8145-7138653fe7a5",
      "members": [
        "f4b0e001-14ea-4e19-9fd3-d2673261ef60"
      ]
    },
    {
      "cluster_id": "e6aabf8d-023e-4060-ae58-13d0d54f160c",
      "members": [
        "589cf6ad-04e0-4e4e-823a-bb0feaeeec39"
      ]
    },
    {
      "cluster_id": "ab9082a7-9db5-4c59-ad04-1242dca4509b",
      "members": [
        "e175e96e-c4ee-4119-a591-68c65331d271"
      ]
    },
    {
      "cluster_id": "866d952f-2947-45b5-a10f-e756e9288018",
      "members": [
        "f228463b-3209-4ab5-b4b1-b2e7c7ef4fa7"
      ]
    },
    {
      "cluster_id": "2972bcbb-a2e7-4468-bfb2-f2945b01a243",
      "members": [
        "65c93c29-c19f-4bfb-adce-c6ff88be5baf"
      ]
    },
    {
      "cluster_id": "991ef8e4-a40d-47b2-ae87-93bed03c964e",
      "members": [
        "79a8797d-4911-444f-adbd-25112da20ee6"
      ]
    },
    {
      "cluster_id": "1d8821bb-7f0e-41b4-86e3-603f9228f781",
      "members": [
        "17c165a7-f46b-434b-b40d-59beec4cf8f0"
      ]
    },
    {
      "cluster_id": "0e1e3fbc-262d-409a-9734-949f40c46427",
      "members": [
        "6bc80891-f4c9-43ca-83b2-d406d3cced6e"
      ]
    },
    {
      "cluster_id": "270c2a25-c40e-45fd-b4d9-9d1e09305cbf",
      "members": [
        "52a4d931-645e-4f35-b15b-21d72e941182"
      ]
    },
    {
      "cluster_id": "59e94cb9-614a-49f2-a91e-9928ad318f00",
      "members": [
        "9371a93f-f012-48ac-a32f-1459138040b5"
      ]
    },
    {
      "cluster_id": "4ab57529-2a41-4128-8cf2-496255864fad",
      "members": [
        "8fee9afa-94f1-4d3b-b00b-698f144156eb"
      ]
    },
    {
      "cluster_id": "a68c5350-6903-408f-b32c-4015ed05945f",
      "members": [
        "d974f925-7d5b-4af9-b23c-9339c4d670e2"
      ]
    },
    {
      "cluster_id": "28b85f28-71e6-4dde-8680-88495b7aecd4",
      "members": [
        "5d64db84-5725-45de-a4cc-af6f00b0de13"
      ]
    },
    {
      "cluster_id": "04828ccc-4133-4cf2-961b-b8fc2a3c6d43",
      "members": [
        "81cb26cc-7a20-435f-9938-82133fb91546"
      ]
    },
    {
      "cluster_id": "277f2c0e-e3d5-4e58-a3ad-823177ebe3dc",
      "members": [
        "810c1c1b-61db-4b62-a549-c29cdde268e4"
      ]
    },
    {
      "cluster_id": "6f732a42-b524-4da0-a300-f64610c49d4f",
      "members": [
        "b080216c-ca3d-4222-b50b-c56fcb284fb6"
      ]
    },
    {
      "cluster_id": "3a969b37-0ab9-41ab-b145-dd3f362c8638",
      "members": [
        "b7cdada0-3565-44e2-89d4-19e85b983dfa"
      ]
    },
    {
      "cluster_id": "816b8091-ba27-40e8-864f-f38a64991c28",
      "members": [
        "6bf7b171-73de-4735-b6ae-d178c397473c"
      ]
    },
    {
      "cluster_id": "ad1bfd32-94c7-4e45-b536-bb4b7ea9411e",
      "members": [
        "c66b4692-19b9-41a5-a090-ccb6f50a7e2a"
      ]
    },
    {
      "cluster_id": "3f4370f6-6231-416d-9478-d27156c80526",
      "members": [
        "550b2a2d-7bd6-4a73-9e39-0824d7ae2d79"
      ]
    },
    {
      "cluster_id": "3addd54f-eb0f-4cbc-93e6-9436080208cb",
      "members": [
        "1f7261c4-80f3-49e0-af1b-986a26c89dd7"
      ]
    },
    {
      "cluster_id": "a3d3cf62-c1c3-483c-82f2-aeee46f578e5",
      "members": [
        "a5b7f496-f670-4373-ba88-6a8ab16932fa"
      ]
    },
    {
      "cluster_id": "89bf1ecc-4cb1-4aca-b3f3-c9c14a8868b7",
      "members": [
        "82697b90-a087-4e35-b0f9-705fd9546781"
      ]
    },
    {
      "cluster_id": "aa27d9a6-1fd7-4a19-84c5-5bd88d623d31",
      "members": [
        "7db588eb-ddae-490a-8882-0fbf8d168f6d"
      ]
    },
    {
      "cluster_id": "7150af87-53e1-42a1-8fa3-98b8c7ea1c84",
      "members": [
        "28580450-6272-4d02-9a2c-f19fc0a0cadf"
      ]
    },
    {
      "cluster_id": "bf33acab-5a50-4871-8114-2bad5bcedb80",
      "members": [
        "9fc21c98-7526-4b78-ae62-cd995e88e0a4"
      ]
    },
    {
      "cluster_id": "f3afa262-5d02-4bc0-8506-783a0bf09d56",
      "members": [
        "56840951-e957-4b40-8408-90e8fe903357"
      ]
    },
    {
      "cluster_id": "d84db030-75db-4735-a947-d4f90e4deae5",
      "members": [
        "699e06aa-9b2f-4b4f-9f76-95fc574a0ffd"
      ]
    },
    {
      "cluster_id": "dcb6ab3b-ae6e-4735-8a60-de8d2d30332a",
      "members": [
        "c51c441b-f875-4e14-b8a1-63786973cd3a"
      ]
    },
    {
      "cluster_id": "d8065be4-6b3d-42e3-9693-9cfaa110346b",
      "members": [
        "95fb97ff-0415-4bba-8c78-d0c21ca3e4e2"
      ]
    },
    {
      "cluster_id": "f5ceefb1-12c2-41ea-b95c-18c5038560bd",
      "members": [
        "9ec6a6f6-9490-4023-93e3-c850eb34c1f3"
      ]
    },
    {
      "cluster_id": "5e55d80c-dfc7-448b-bcef-ae880cfffcd6",
      "members": [
        "7124b769-715f-42dd-a1ef-40df517223f7"
      ]
    },
    {
      "cluster_id": "45429530-4dcd-414e-8a37-8555d0144899",
      "members": [
        "f427e28d-21d4-4a63-a8a1-00ccd3887e93"
      ]
    },
    {
      "cluster_id": "3349d8e0-ebe5-4359-bb8d-083c8d3a9420",
      "members": [
        "9ab78178-379e-4730-812d-2e5b680528b8"
      ]
    },
    {
      "cluster_id": "f3941de8-4943-41e7-80e9-773a7b8e51ab",
      "members": [
        "819dffb2-0572-4f90-92c6-c41eef6a76e0"
      ]
    },
    {
      "cluster_id": "d82f7ea1-b85f-4ff3-af04-e3f09ca89458",
      "members": [
        "6d137a2b-7c97-41ae-95ba-3135144296c6"
      ]
    },
    {
      "cluster_id": "90dfa891-ea54-44ec-9c4c-37a32cc92299",
      "members": [
        "65dc0e58-bf84-41b7-b9dc-c03b479517c1"
      ]
    },
    {
      "cluster_id": "eb91a168-c109-40bf-9679-0913a309af40",
      "members": [
        "21a58d87-2911-4e0f-ac4e-1eab6d209d8e"
      ]
    },
    {
      "cluster_id": "8bfd9054-2484-4b95-af6e-1881fb8804d9",
      "members": [
        "252a33a2-7596-4ebc-813c-cd41a36e4854"
      ]
    },
    {
      "cluster_id": "085a40bb-586e-4634-99d1-21c6d1eb5884",
      "members": [
        "aac50ae1-a885-4137-b384-62bb31844f54"
      ]
    },
    {
      "cluster_id": "c3301dce-0e38-4465-b94b-ee10e64f783a",
      "members": [
        "899e6a00-6f74-4b8e-a39f-40b710e636c9"
      ]
    },
    {
      "cluster_id": "0ebb4caf-dfd8-4139-8988-6c07a96c4bd2",
      "members": [
        "c3447a89-06cf-43fa-8a0e-fbac8fce1614"
      ]
    },
    {
      "cluster_id": "7202d20f-cf9b-4054-aa24-3edfd3064cd7",
      "members": [
        "b835e906-d882-41eb-9501-c849698aac45"
      ]
    },
    {
      "cluster_id": "719904eb-28ef-4b29-997b-23331e60e444",
      "members": [
        "68b756d7-f0c3-4d46-94c9-32214154be65"
      ]
    },
    {
      "cluster_id": "f2253ad2-0cf7-4f4d-a01d-da6760a12103",
      "members": [
        "dd761619-d96b-428f-892c-73f53aa52d08"
      ]
    },
    {
      "cluster_id": "5f1d9f8e-2516-4e42-a0a6-815bb97110a4",
      "members": [
        "5984d932-6e0d-489b-85b7-61da3f544b00"
      ]
    },
    {
      "cluster_id": "06aade08-3010-4d09-90ab-647cfcc26947",
      "members": [
        "7d2a6301-1e44-4b4c-9a93-336484d1b689"
      ]
    },
    {
      "cluster_id": "df241613-e669-4ee0-b143-f0b24cc846e8",
      "members": [
        "cce8b016-f0dd-402a-88fc-d8fbdd754c14"
      ]
    },
    {
      "cluster_id": "761f3fb6-5695-42a3-ba7c-8aee7df904b2",
      "members": [
        "34a9fd8b-13bb-4d40-aaa2-c66e0122e71c"
      ]
    },
    {
      "cluster_id": "44bced9f-9cdf-42b9-a5c2-b5abf31749ea",
      "members": [
        "473cbecc-ca21-4835-9483-63711d14e0a1"
      ]
    },
    {
      "cluster_id": "d28f03f1-166f-4e7a-a151-3bb7c1898209",
      "members": [
        "a6669dc9-5788-4322-affc-8536d6461d31"
      ]
    },
    {
      "cluster_id": "181a2d12-ad30-4552-bb72-ee9a984fa618",
      "members": [
        "cc4063b3-4027-43d0-b1c9-66dd68822ae0"
      ]
    },
    {
      "cluster_id": "5cb4afbf-e109-4c74-8315-a2a58d421c9c",
      "members": [
        "dd453d27-3f21-498c-84bf-f8587daa8696"
      ]
    },
    {
      "cluster_id": "876a2333-137a-4c81-9d16-99847f2af4cc",
      "members": [
        "55b1edd0-40e0-43cb-bcab-dd9c2b23313d"
      ]
    },
    {
      "cluster_id": "5f7469b6-8252-4966-99ba-b5fdff4dbf90",
      "members": [
        "33721b3a-5cdc-443e-8599-43e7d7955653"
      ]
    },
    {
      "cluster_id": "265185dd-7e1c-462b-bd12-3ea2079d23c8",
      "members": [
        "f762beea-6bb1-4d3b-993d-f8e4bc97273b"
      ]
    },
    {
      "cluster_id": "d9eedc94-d312-4947-bb37-d1fdd95dcdd4",
      "members": [
        "fffa8076-beec-4801-9da0-5fd5da0a9ad7"
      ]
    },
    {
      "cluster_id": "ae8f7a24-2c15-4f25-983d-6c8e3d8467ec",
      "members": [
        "8cfe2e5e-b34d-4b5f-ae79-3e932c830bf2"
      ]
    },
    {
      "cluster_id": "17bcb338-5ed9-498a-8f4b-407445dec65f",
      "members": [
        "bfd30f43-97af-4390-9f37-9bb404565a96"
      ]
    },
    {
      "cluster_id": "edeb68e2-0660-4461-9b92-dd0ab5f321a1",
      "members": [
        "221f03ad-dab7-49eb-b731-a3a3aa267d2a"
      ]
    },
    {
      "cluster_id": "bea2fa8c-8f73-40e8-949c-4bf3e53cc1a7",
      "members": [
        "c6593794-fb12-4c9f-a31a-9bf8f3922e3d"
      ]
    },
    {
      "cluster_id": "df3f868f-20bc-4768-8496-fc1bc0744474",
      "members": [
        "20a0b653-3a14-4146-a66f-02dc074c2da9"
      ]
    },
    {
      "cluster_id": "bd0d52ba-bf23-4db8-aa70-86556a4740bf",
      "members": [
        "2d712861-399b-43c7-94f1-2d30b47a4e13"
      ]
    },
    {
      "cluster_id": "8cad6289-2663-4a76-816f-85ae55214831",
      "members": [
        "13b4f8bd-1e4b-46c7-9f06-f8acb44b5eff"
      ]
    },
    {
      "cluster_id": "6b6a1ba0-8a8c-4bf1-9799-4a4ce9b1d916",
      "members": [
        "6e5270e8-581e-4a73-876e-199bffc453fe"
      ]
    },
    {
      "cluster_id": "91b087d8-4803-4bcf-911f-18dca461d16f",
      "members": [
        "6e9b56c2-1846-4a98-a834-cc0f642212d2"
      ]
    },
    {
      "cluster_id": "f6908b42-dc9a-453f-aa2c-203da06764cf",
      "members": [
        "4d71a58c-31b8-4ef3-96bb-15762eaa2eee"
      ]
    },
    {
      "cluster_id": "745f9d2c-8956-422e-91cf-53ea37e70f82",
      "members": [
        "45ebb88b-bf33-4fba-9eec-b607bc7fcfae"
      ]
    },
    {
      "cluster_id": "18cfbf44-b988-4dd5-866b-73fc693898aa",
      "members": [
        "069a2f64-e114-4ae3-b560-fee65a490053"
      ]
    },
    {
      "cluster_id": "4cf126e0-d7f3-4437-b125-365b11c65d70",
      "members": [
        "cf25d15d-0e56-4196-8bd6-b1dd2623d721"
      ]
    },
    {
      "cluster_id": "a305ffe3-19c3-481a-9058-4247bca4ca01",
      "members": [
        "f56b635b-046a-4a07-a7a4-5dbed4e93211"
      ]
    },
    {
      "cluster_id": "230bb8e2-d4ad-487c-a1d7-42ba2ea0e5cc",
      "members": [
        "e32952af-965a-4a63-ba6b-a39cf2c81ff6"
      ]
    },
    {
      "cluster_id": "12a67c1f-74e3-4d9a-8a6a-adbec88544da",
      "members": [
        "f6b553c2-e6b2-4faf-9a69-26959b763881"
      ]
    },
    {
      "cluster_id": "ddb6cf7a-94d8-482f-b5e3-c86b7fa8181d",
      "members": [
        "d720c73e-98a8-47f5-a0ac-7e558e0ca630"
      ]
    },
    {
      "cluster_id": "7dec92f2-1d70-4104-bd41-d9c058b2c5ef",
      "members": [
        "f0b094b1-7f25-47a8-9482-96e4884c43bd"
      ]
    },
    {
      "cluster_id": "b9a01b27-65e1-4a9d-9166-e606cea6425c",
      "members": [
        "a17c93dc-3520-401e-836b-e0f5271b501e"
      ]
    },
    {
      "cluster_id": "e6b11bad-8ee1-43f8-a49c-9856a434923a",
      "members": [
        "b8af46a0-ca5b-496e-b89a-7bd1510de742"
      ]
    },
    {
      "cluster_id": "23b2fb05-29fc-4502-9ecd-a47d0a63076b",
      "members": [
        "6c9c2bf7-38e2-471a-b041-0a9da2658639"
      ]
    },
    {
      "cluster_id": "749b6cb0-84a3-49bb-a39c-84a371599d47",
      "members": [
        "c2f3e630-f08f-47fd-b98a-fae1a6a78b87"
      ]
    },
    {
      "cluster_id": "1343596d-8a4d-4776-9d4a-d41490b7cb7b",
      "members": [
        "b7586629-3176-4504-9dae-01e07234abba"
      ]
    },
    {
      "cluster_id": "28640c6e-e7eb-4b38-b099-8b9d347bd04a",
      "members": [
        "b973d87c-9102-4220-874e-88d661ccab11"
      ]
    },
    {
      "cluster_id": "99266a9c-deac-4cbf-b039-93976c0d571b",
      "members": [
        "ac87588b-bc99-4d48-8233-a5daf7fc1a53"
      ]
    },
    {
      "cluster_id": "06d3a2ea-1d2f-4456-9c1f-ca559e4c2f36",
      "members": [
        "c489a63d-e632-4a3d-8efe-40552e4c6545"
      ]
    },
    {
      "cluster_id": "10a6dfe0-81d0-453e-9f23-e9792fa39675",
      "members": [
        "ba122ebc-29b7-4ac8-b2ae-a36bb297bce4"
      ]
    },
    {
      "cluster_id": "0a7daf16-3825-48ce-beb6-0161de293451",
      "members": [
        "8fedb62c-7243-4ccc-9df8-dad2d50416e5"
      ]
    },
    {
      "cluster_id": "f544e1b7-c2c0-4236-9e51-6a506ee25e3f",
      "members": [
        "049c387f-d38b-493e-80c0-9209a0fc42ec"
      ]
    },
    {
      "cluster_id": "00bb78a2-a394-4745-839f-91ae646e4371",
      "members": [
        "f404d690-a7bd-4f1c-a5e0-7f1735b9720c"
      ]
    },
    {
      "cluster_id": "27d190cd-822a-4b37-b138-1b1b73c5196b",
      "members": [
        "d7ba524a-1bbd-40da-96de-92ca7fdcf38a"
      ]
    },
    {
      "cluster_id": "c2fa4be0-a63f-4b63-922e-7a118484c3c8",
      "members": [
        "6204f81c-dfd9-47d7-8753-4c2c8239bd26"
      ]
    },
    {
      "cluster_id": "4cf2f8c5-1a2b-498f-87b4-2397e881640d",
      "members": [
        "33a0e312-cbc6-4d2b-96b2-ab0d852134dd"
      ]
    },
    {
      "cluster_id": "35b591b0-9a65-46c0-95aa-caf3b8dedd33",
      "members": [
        "851fc306-2f78-48f7-b113-7dce1164a69d",
        "7a0e5497-26f7-4bf3-b1ce-9acfada7df29"
      ]
    },
    {
      "cluster_id": "4ae785fa-8876-494b-8048-bcaeeb28e317",
      "members": [
        "3e3750ac-2b6b-430a-aa67-2bfc15bcfa67"
      ]
    },
    {
      "cluster_id": "c829d647-4388-40da-86fd-479a810865ab",
      "members": [
        "6323d3ca-f688-48d5-9fab-83b587579296"
      ]
    },
    {
      "cluster_id": "44bec0d6-7c8b-4869-801c-2ac35f38611d",
      "members": [
        "9150a81d-6528-4275-b8a8-a9a1706e24bf"
      ]
    },
    {
      "cluster_id": "89b0a4a3-f393-4706-9a25-8103c69b53d6",
      "members": [
        "8d625518-abdd-441a-b740-7b507d8c73e8"
      ]
    },
    {
      "cluster_id": "80a104b6-58c7-416b-ac35-97712361953c",
      "members": [
        "aa7f6c28-3a60-47d1-9301-c2ced8a6c136"
      ]
    },
    {
      "cluster_id": "523ae438-64cf-40ea-839d-1a30cbcf4c63",
      "members": [
        "36f28729-fe34-4e6d-b99e-ee9fcaa7c05f"
      ]
    },
    {
      "cluster_id": "690e2bf8-3db0-482f-a93c-22f6a0d56631",
      "members": [
        "1c7cedb5-74a3-41a2-82f3-ff92f5641ead"
      ]
    },
    {
      "cluster_id": "1ee29b00-1c04-4d47-871a-4fc6d43200cc",
      "members": [
        "97979628-3420-44ec-aef8-12b24f583328"
      ]
    },
    {
      "cluster_id": "ca4d9210-71b4-4ac8-bc7c-f9b4e1772523",
      "members": [
        "41966921-2f3e-42bb-b09a-495a25971795"
      ]
    },
    {
      "cluster_id": "baaa2ca3-1dde-42fe-ad1f-1aae3e927027",
      "members": [
        "6ed59500-2ddc-47f5-ba2d-8ade023152f5"
      ]
    },
    {
      "cluster_id": "ffbf8347-0223-4c98-b559-e6237b6aac90",
      "members": [
        "e270824c-080c-4953-bf30-6c931abd61b9"
      ]
    },
    {
      "cluster_id": "4c2caa9f-9774-4e83-aa42-f46bf17280b7",
      "members": [
        "d4bdac66-4616-4c2f-83ac-7682a496fc28"
      ]
    },
    {
      "cluster_id": "c124b047-b324-4618-8299-a88ecac6f400",
      "members": [
        "91edbaa3-c938-4cc3-b2ce-252d3114fae5"
      ]
    },
    {
      "cluster_id": "0e2b1f45-559d-4cae-9f78-dbca6d3f4287",
      "members": [
        "510ee834-19fd-41ef-8d4f-43d524c50082"
      ]
    },
    {
      "cluster_id": "18718c0f-4c28-4949-a369-9bfa7d8941c1",
      "members": [
        "915748ad-4a99-4921-9200-7ad0f63b3634"
      ]
    },
    {
      "cluster_id": "15ffd9d6-a9f6-4b7b-9697-caf2e3239c3c",
      "members": [
        "88fa7a1e-fec4-4e4e-a036-e28471e1785b"
      ]
    },
    {
      "cluster_id": "c17cea6e-319f-464f-958b-423a8d716b81",
      "members": [
        "3372e7b2-3af6-403b-9533-ca3f0f2e242b"
      ]
    },
    {
      "cluster_id": "72793708-1a46-47bf-a99d-c034462d8ebe",
      "members": [
        "0adb6990-ff2b-421a-ab99-df94f72bf4af"
      ]
    },
    {
      "cluster_id": "b632a6a0-afbe-40f4-8a5f-a0054d37001d",
      "members": [
        "d31f3897-6484-4f9f-859d-dc84f80394a1"
      ]
    },
    {
      "cluster_id": "d74e9977-9a16-4baf-861a-98a8ddead66c",
      "members": [
        "237a6f9c-8425-4703-bee8-d512a40c8092"
      ]
    },
    {
      "cluster_id": "f839d2fd-5b0b-43b0-bb42-43cd3c1d733b",
      "members": [
        "7d208f2e-cd63-42c0-8e76-e048299ab995"
      ]
    },
    {
      "cluster_id": "8383b651-21df-4fb5-9d89-77f8c5fdde08",
      "members": [
        "95493ec3-5c76-4932-afe1-03535f25401e"
      ]
    },
    {
      "cluster_id": "9d5a2720-0f92-434c-867d-f7d869c56177",
      "members": [
        "ea97cfae-0ddf-4b15-93d7-99ed2e3e60ed"
      ]
    },
    {
      "cluster_id": "5d5c8795-a6be-497b-896a-30f8df4f0736",
      "members": [
        "75244adf-d5fa-4e9b-aecd-fa8520a5cb68"
      ]
    },
    {
      "cluster_id": "f6f61810-826e-4932-a627-c61739848c9f",
      "members": [
        "ce6fa6be-ead1-4088-b52e-bf53f3c4157e"
      ]
    },
    {
      "cluster_id": "8e082e26-8f01-4448-85f9-dcbb694f327e",
      "members": [
        "4ca90c87-c4e6-4c7f-94f0-ea9daba911e6"
      ]
    },
    {
      "cluster_id": "ced5af6f-55f4-47fb-a25a-cd619d213da3",
      "members": [
        "726f005e-8131-460c-9463-d6964a2251c7"
      ]
    },
    {
      "cluster_id": "f0e9965e-e941-4451-a097-f16f023a8147",
      "members": [
        "71bb8186-e063-41c0-901d-221f213e112f"
      ]
    },
    {
      "cluster_id": "32be984b-e9e5-4559-b00b-15885afc33b8",
      "members": [
        "c708f5de-2751-4a8c-9fb1-241d533a4dcf"
      ]
    },
    {
      "cluster_id": "ce6ec6f1-89a5-418d-adc6-e21b2c309bd1",
      "members": [
        "efea0255-2ea4-4369-a4fd-dc32db53107e"
      ]
    },
    {
      "cluster_id": "ef8af588-0359-41f5-af90-03db72eaaba3",
      "members": [
        "cb59b418-04fb-4379-a5d3-0fad9684bf2e"
      ]
    },
    {
      "cluster_id": "51cb3861-5c43-4303-b352-2771c991143d",
      "members": [
        "e4bd4597-6c95-42b6-8ea0-95f932932c30"
      ]
    },
    {
      "cluster_id": "34b25787-92a3-4162-bcdc-435c1ba9cd55",
      "members": [
        "6d505685-fb18-4996-b440-3537c58c3f23"
      ]
    },
    {
      "cluster_id": "5365be2b-8f70-4f67-96e5-c75ce9b7256e",
      "members": [
        "05beab80-30fe-4554-ae31-69577b6c546e"
      ]
    },
    {
      "cluster_id": "432216ce-2589-40bc-b4f7-cabc8c9d84b7",
      "members": [
        "e2e86f81-529f-4675-a88a-f4cb35ba63d3"
      ]
    },
    {
      "cluster_id": "84cbf3d1-afbc-4ba1-8495-8ff7aee7e81f",
      "members": [
        "69ee56c9-cc8b-4db0-bafe-7b715277e65f"
      ]
    },
    {
      "cluster_id": "68f4e1e3-51cf-46cb-8e4c-826f56e18aae",
      "members": [
        "d9f42efe-10eb-4163-90db-2d36b388e3b0"
      ]
    },
    {
      "cluster_id": "0af61c8d-a534-4af2-a2da-7ed4f4cc7aea",
      "members": [
        "08fc4aaa-001c-499e-b2bc-1bc0f4e5aa2b"
      ]
    },
    {
      "cluster_id": "f4f28261-ce76-46eb-a24f-4ced2c41d5f6",
      "members": [
        "755c31cf-ca4d-4874-93d4-5d07f9d7e130"
      ]
    },
    {
      "cluster_id": "c5229738-f89d-48b1-b153-7dc0f6aabc53",
      "members": [
        "7c90f385-a416-416c-9ba0-87f159085a81"
      ]
    },
    {
      "cluster_id": "c5023c65-de59-493d-807d-e173da07457d",
      "members": [
        "b3345a2a-fe41-4be3-8ef9-5166e14dfb0d"
      ]
    },
    {
      "cluster_id": "1ed0bff4-f942-4d7a-bec9-87e9c09bf276",
      "members": [
        "50384329-e3d9-48a5-93bc-83cc4d763718"
      ]
    },
    {
      "cluster_id": "f6f5b331-ac46-4d22-8195-ed8a8b14d117",
      "members": [
        "e963d97a-8c6b-4628-94cd-73d0bfcbd002"
      ]
    },
    {
      "cluster_id": "5456cf3b-8248-49e5-a577-e64c3c57ab9a",
      "members": [
        "725773c9-8f3f-4822-9346-a7020aa3ac84"
      ]
    },
    {
      "cluster_id": "fd395743-8cf0-4953-ace0-85cff9e72be0",
      "members": [
        "ab4dc4b1-a625-45f0-b3fb-38d06409de86",
        "f645f5ef-5ac1-44fb-9a14-8f8569b07972"
      ]
    },
    {
      "cluster_id": "224111ea-4ffa-46dd-984c-028b4bc55489",
      "members": [
        "5cc6d900-a391-49b9-aaa7-310336dd2c4d",
        "24442cca-df16-40ec-b4c2-36fa92e8bf64"
      ]
    },
    {
      "cluster_id": "3f0004b6-308c-4518-9fbc-e6c906329ba4",
      "members": [
        "2ef611e1-b729-446e-959a-b9dc97b37d9c"
      ]
    },
    {
      "cluster_id": "3d47a459-5f56-4e8c-a324-2a8a527df0bb",
      "members": [
        "c4e720ce-0d97-4a36-8c23-6c78b6521969"
      ]
    },
    {
      "cluster_id": "a3452ca9-6c41-42fe-8fb7-9b272b7a106d",
      "members": [
        "31153ee6-b71b-49c4-b2ab-586daaf0c002"
      ]
    },
    {
      "cluster_id": "3800fecc-81a4-49e4-a7cc-dc527d4bd612",
      "members": [
        "0389fee0-e5b0-4b6d-9750-ec7e37751939"
      ]
    },
    {
      "cluster_id": "3c10b554-db0c-4b37-99ae-e28966332651",
      "members": [
        "a82dced5-0442-4343-8602-c3ee4319f011"
      ]
    },
    {
      "cluster_id": "e581acd0-fb94-4a27-8e52-0501198c921d",
      "members": [
        "68e658a7-87b7-4feb-bc49-8a98c415edda"
      ]
    },
    {
      "cluster_id": "2fb41c0c-9dcd-4bc3-b70a-75aee83bcba5",
      "members": [
        "5a78c0b5-ea57-4bce-9e0e-103c30c48f52"
      ]
    },
    {
      "cluster_id": "d2ffb0e6-959f-4fb3-a43b-5fea64c717c0",
      "members": [
        "4e756dc8-42ee-4525-9931-5b21f8a028bc",
        "4800cff6-05ef-4559-b9b5-a060f3cb3d0c"
      ]
    },
    {
      "cluster_id": "4991bbaa-4137-4e4c-b3d4-b54d2fc23ddc",
      "members": [
        "b90c9c7d-8ee2-4cbf-9324-9485701f2402"
      ]
    },
    {
      "cluster_id": "1a52a7c3-2c3f-447c-9a23-15f3ea781daf",
      "members": [
        "3ea55b05-e64e-4a51-b455-4cd56d19c028"
      ]
    },
    {
      "cluster_id": "47db3c81-ee29-421a-b1e7-9a9b4cbbe8ce",
      "members": [
        "e9587647-c97e-4a21-ac83-8717ce46d6f6"
      ]
    },
    {
      "cluster_id": "4c4cd4c7-1e1a-4df7-8ab4-db0129f7114b",
      "members": [
        "5018bc81-8adb-4e6f-96fa-ac5d951ada7a"
      ]
    },
    {
      "cluster_id": "f62a9075-e876-4cd7-80b4-8e9a12641d53",
      "members": [
        "e3929cb9-d9bf-44fe-8eb3-431bce5cc092"
      ]
    },
    {
      "cluster_id": "37216476-5d5c-4faa-9d46-a9c7fd453ec4",
      "members": [
        "3c496ecd-36b2-46b7-a3dc-5fa2c28c013f"
      ]
    },
    {
      "cluster_id": "d249e1af-ea1c-48af-a49a-e0b42f780f6c",
      "members": [
        "8385b239-35f0-4b4a-b4d8-cebe460666d6"
      ]
    },
    {
      "cluster_id": "64689f94-8b56-49c1-bd31-9f4133ac52a7",
      "members": [
        "c2bf0c47-4735-4576-9964-8dbe9c634b2a"
      ]
    },
    {
      "cluster_id": "b777e992-68f2-4307-a472-b1ae2b933a6e",
      "members": [
        "a26c5d27-1a41-49e2-a665-a7e20594af90"
      ]
    },
    {
      "cluster_id": "7b3e2472-ab18-4258-a390-e26e567571a0",
      "members": [
        "da653844-4256-45cc-8273-f87fcc346bb8"
      ]
    },
    {
      "cluster_id": "3dc36bc1-d0c5-4f9e-be89-27d20d56e931",
      "members": [
        "148c615a-c714-4ab2-bf8c-5af7057fa0a7"
      ]
    },
    {
      "cluster_id": "21936564-78e3-425d-afce-2c71d0db68fa",
      "members": [
        "fd031dea-82ae-4214-b800-07eee7e5716e"
      ]
    },
    {
      "cluster_id": "603803f7-aada-4f64-95b6-3901092a2744",
      "members": [
        "79060d8f-adb6-497a-b312-d7d7335d3ca3"
      ]
    },
    {
      "cluster_id": "d231b87f-915c-4032-9dcd-5f1c1337576b",
      "members": [
        "c756adeb-3a86-439c-953b-7e81f14df065"
      ]
    },
    {
      "cluster_id": "e82f3b8b-97c9-4869-b282-3dfd951ace47",
      "members": [
        "c2c48b13-0da9-4a70-90b3-0a2dcf6a44f3"
      ]
    },
    {
      "cluster_id": "28c2302e-bfe1-426f-8146-f632519111cc",
      "members": [
        "1f75d58f-e21f-4a32-8be6-6f03fa2583b2"
      ]
    },
    {
      "cluster_id": "ed8f044f-96b2-4a20-8622-207bfd8ae25b",
      "members": [
        "a7af8ad7-124f-45c3-9c15-92e6e377bc92"
      ]
    },
    {
      "cluster_id": "ebb3d42c-9f56-4324-89bb-dcd764d2d3e5",
      "members": [
        "b24ffb2c-2472-4d2a-811c-26c1b050e679"
      ]
    },
    {
      "cluster_id": "b22a3d90-fc7c-4c0c-8913-b55993380bc0",
      "members": [
        "a940d181-cd29-467e-b97e-dec0bc61b3ea"
      ]
    },
    {
      "cluster_id": "faba4888-ade5-4854-a98b-43a187c3c84d",
      "members": [
        "853abfef-64ce-49bd-a2d8-eecd7f1452f2"
      ]
    },
    {
      "cluster_id": "41dff0a8-a265-4edb-a001-023373b9ecf5",
      "members": [
        "5006627b-b293-43d9-8e73-d6b5a7567e40"
      ]
    },
    {
      "cluster_id": "bf9781df-d8bf-4191-9d37-d31cf97d37ae",
      "members": [
        "1cd4ddaf-aaea-4acc-a028-74a6d7933399"
      ]
    },
    {
      "cluster_id": "d69ec96e-95a8-4ada-b02b-404a801edc90",
      "members": [
        "1267f7fa-73d9-44e8-950a-a0dee6897774"
      ]
    },
    {
      "cluster_id": "cf64a707-174e-4193-859f-9f55dd41a4a6",
      "members": [
        "22815f4d-1308-4d07-a08f-e7acebf98655"
      ]
    },
    {
      "cluster_id": "feaafeab-4622-43a8-9ce7-52d22835a7d7",
      "members": [
        "c4d39634-abdf-4664-bdad-d6e78eb7bbb0"
      ]
    },
    {
      "cluster_id": "02e9df36-756a-4f13-96b7-a64b085d932d",
      "members": [
        "90ef49c0-710f-4b96-81f9-3d83ddeba200"
      ]
    },
    {
      "cluster_id": "0c67a873-1e0f-4dd1-9e3b-40d63d120847",
      "members": [
        "663b4f93-67b7-4083-b91d-62cb28710640"
      ]
    },
    {
      "cluster_id": "0da6573a-b2db-4671-b4e0-6012c6bd63d6",
      "members": [
        "49f76802-5e87-499f-8e75-f14098ec6093"
      ]
    },
    {
      "cluster_id": "74873448-e290-4f3b-a22d-809e34d02a4e",
      "members": [
        "f70405cb-f7f6-4863-bc7a-c931d82c2550"
      ]
    },
    {
      "cluster_id": "8a1628d6-9b8d-4872-8726-128c5ec7f01c",
      "members": [
        "266913ed-2eef-4ab7-911a-105100da0e02"
      ]
    },
    {
      "cluster_id": "2f5e01bb-8b8d-4570-9736-c9caf60706be",
      "members": [
        "72f2cfd0-b507-449e-9770-85beb184878a"
      ]
    },
    {
      "cluster_id": "05de0fcd-b07f-4daf-b084-2e15c6be78b3",
      "members": [
        "a6cc1c20-7887-40a1-aabf-bfb7e06a7449"
      ]
    },
    {
      "cluster_id": "6ecdc168-b4c6-42e6-a45f-27cde46257e5",
      "members": [
        "c786f26e-12c2-4535-a429-4e452628cffe"
      ]
    },
    {
      "cluster_id": "3b3110cf-93d0-4510-9837-e4eaf9f9a935",
      "members": [
        "6a2d7a4b-4915-4e96-8761-56cffaf93b4a"
      ]
    },
    {
      "cluster_id": "ddce8749-8091-45b0-8366-637dbe518fa7",
      "members": [
        "929e1daf-b76b-4dcc-bef3-f9333ae4e759"
      ]
    },
    {
      "cluster_id": "c218f143-d00f-4444-8a1a-91fa210ebc65",
      "members": [
        "fce12da3-bb37-4057-b532-66704b519802"
      ]
    },
    {
      "cluster_id": "91d4dc33-e633-4d25-9203-969f15a268d3",
      "members": [
        "9a9f6fb9-cf76-48ee-9a70-677d6c110efa"
      ]
    },
    {
      "cluster_id": "241266d3-592d-42ac-9327-a8fa3d3a1448",
      "members": [
        "48d0d409-30e5-428f-8ea5-91b8cae163bb"
      ]
    },
    {
      "cluster_id": "297851ee-0090-4476-be7b-77ecae5b0949",
      "members": [
        "4d05f40f-071e-4ec6-9402-83d6f6728d05"
      ]
    },
    {
      "cluster_id": "c85617d1-a799-4927-848f-0f8d387e35f0",
      "members": [
        "61fbfe05-fc35-4760-85bc-5bad7ae4ded7"
      ]
    },
    {
      "cluster_id": "b03907b4-379e-44df-a2b4-6f069b3d131a",
      "members": [
        "28039044-3710-423a-a4bd-2fbbf3e54855"
      ]
    },
    {
      "cluster_id": "4fecbbe3-fb61-4e10-b666-a2cf1bec8797",
      "members": [
        "5f73d540-43b8-4265-b8ff-aa19a825cccd"
      ]
    },
    {
      "cluster_id": "0de9cc59-0656-46df-93f6-a7ec86e0802b",
      "members": [
        "5c85d134-3901-4755-b71a-1b2eb75fb815"
      ]
    },
    {
      "cluster_id": "7a75d7fe-a9ef-4bcc-bb6c-68501ebb5f56",
      "members": [
        "10e90a91-8e71-43ae-8b59-e0b1a43a6907"
      ]
    },
    {
      "cluster_id": "d7e7a762-6cbc-4c4f-9830-3d635c57a2df",
      "members": [
        "287b2f37-c4a8-4ee8-a189-3a6c0f1582b8"
      ]
    },
    {
      "cluster_id": "53b1257e-8f17-4723-a98b-5c441d647f48",
      "members": [
        "03902357-f4c2-4df8-9882-232e48bd71e7"
      ]
    },
    {
      "cluster_id": "23a31964-6a33-4514-aa2e-353b4bd3be9d",
      "members": [
        "663097e0-4b95-4728-8608-8d19438f7d7d"
      ]
    },
    {
      "cluster_id": "240e1f26-e6d5-488e-ad06-f573f8486dce",
      "members": [
        "300f0d0c-3195-4f56-8af4-3e5a93c40f57"
      ]
    },
    {
      "cluster_id": "791e282d-3184-48f1-b9b4-d9976176f1c4",
      "members": [
        "dc0fbaec-ae96-4c16-9fc7-5b16fd8c8b15"
      ]
    },
    {
      "cluster_id": "ace987dd-fefd-4144-a25e-4a8cd1ec09c0",
      "members": [
        "56e4391a-703c-4ed9-a325-0165561cee88"
      ]
    },
    {
      "cluster_id": "90376b4c-da40-4dab-8f73-1b70785d5f49",
      "members": [
        "24abea91-0dac-40b9-9770-ed51f91c5c5f"
      ]
    },
    {
      "cluster_id": "17c6aa84-f614-46fa-bf43-265da2499cba",
      "members": [
        "3b16bfd7-7b38-422e-8168-de5f079314e7"
      ]
    },
    {
      "cluster_id": "9876318f-24a7-47a3-a0cc-61a7ad5d114e",
      "members": [
        "4a4a3486-453b-4e0f-b099-3969db2e42ef"
      ]
    },
    {
      "cluster_id": "5b7d9e7f-e24f-4115-ae9c-183a9ef8183c",
      "members": [
        "76b6c6cf-86b2-42d9-badc-c8bd382b4aa9"
      ]
    },
    {
      "cluster_id": "e2924858-e631-4f3d-8b15-9f5ee8ab3b4e",
      "members": [
        "75b0643e-6526-4dd1-a6c5-ec972c9437f4"
      ]
    },
    {
      "cluster_id": "f0144a0c-5ed5-434b-884c-c56dfe8a915f",
      "members": [
        "2f98e229-8833-4116-8716-f73260c19e20"
      ]
    },
    {
      "cluster_id": "1c4341b5-18d5-4ba6-a313-e14ad3c93bc5",
      "members": [
        "c568daa3-1f6c-437f-a2b8-c047b1e273d8"
      ]
    },
    {
      "cluster_id": "ea4dda18-9c10-4944-8540-e2c0066f573b",
      "members": [
        "fb5e89ab-7a85-43ae-a4f2-098d2753ec2a"
      ]
    },
    {
      "cluster_id": "60c5d0e9-eed6-41c1-b7fa-8d8163b698f7",
      "members": [
        "8c8f1924-d68f-416b-8d8e-58c11e08a9bc"
      ]
    },
    {
      "cluster_id": "c025fbc7-332e-4457-bed4-c17718085886",
      "members": [
        "fa13c6d0-b2e5-474b-9f53-d4a52a63806a"
      ]
    },
    {
      "cluster_id": "92332b03-095b-4c9b-a429-b33ea258a0f9",
      "members": [
        "a7792d10-d764-4230-90f7-ac06b4636202"
      ]
    },
    {
      "cluster_id": "1d2ec60f-34f2-42e2-a397-916c3e7ad70d",
      "members": [
        "b1976276-72b8-4011-90e9-c0aea7bc389e"
      ]
    },
    {
      "cluster_id": "b96bf2eb-4edd-4eb7-8c42-ee3fff5f4c9c",
      "members": [
        "17c096b5-452d-4531-bc5a-882057a7929b"
      ]
    },
    {
      "cluster_id": "54e77970-df08-445b-a795-2987113391fb",
      "members": [
        "a9001056-daab-416a-bddf-6062cc82c7ae"
      ]
    },
    {
      "cluster_id": "e3deeefe-c427-4d71-816d-254495afc3ac",
      "members": [
        "4a103dd4-b72c-4209-98ce-c3609d5ebbe1"
      ]
    },
    {
      "cluster_id": "1aa19d8d-3161-4beb-8b2d-3a6a4b289e65",
      "members": [
        "ac11415d-d1f0-49ae-bf3c-e809f385565f"
      ]
    },
    {
      "cluster_id": "143e5a89-f562-4e9e-ae94-80a1636c09a2",
      "members": [
        "5f8c9e85-7db4-472f-bebd-dbe581560237"
      ]
    },
    {
      "cluster_id": "83e82b7f-d20b-43e7-8e8a-1a33199d549e",
      "members": [
        "39a20b14-9486-4645-846f-a5d3a05a411d"
      ]
    },
    {
      "cluster_id": "32ba4740-f52a-47e5-91ff-4fde0ada2a3e",
      "members": [
        "729bd517-f48b-4458-86d3-c7b80c90a419"
      ]
    },
    {
      "cluster_id": "9686ee9d-c6fe-4724-a86f-ea5424b54b58",
      "members": [
        "eee21b3a-7680-4b10-9582-b74325004fff"
      ]
    },
    {
      "cluster_id": "d3878960-69bc-4fec-92c4-b21753a35a06",
      "members": [
        "4300ed1d-249d-4eb3-a8e3-2977bf86206e"
      ]
    },
    {
      "cluster_id": "33362f90-8163-4571-a6ec-1aa8d1d2470b",
      "members": [
        "65c14409-94a3-4eb2-8441-805a55ed7592"
      ]
    },
    {
      "cluster_id": "8eff5d20-7a2a-43cd-a95d-697a2eb3fa48",
      "members": [
        "2d827743-6247-4e6b-a57b-dafc824a08bd"
      ]
    },
    {
      "cluster_id": "53168731-5f89-48eb-b975-ab6908193c3f",
      "members": [
        "ca494079-582d-4085-964a-16eb13213ade"
      ]
    },
    {
      "cluster_id": "13a151a6-c289-4cb5-8bbc-44e52c4f2c13",
      "members": [
        "172cf672-4338-4d7f-9bb6-ea44525201d7",
        "e78e8eb1-4810-4e35-a9c3-b2dcd8790b99"
      ]
    },
    {
      "cluster_id": "59fa4256-c06f-40de-a351-3b6ce5c20978",
      "members": [
        "6c174445-80ed-497e-b27a-f0ee25657bc0"
      ]
    },
    {
      "cluster_id": "7138b959-d146-418c-bd39-6ecd7cfec079",
      "members": [
        "b22df674-8d6a-4eac-9c5c-4a6b65a8be49"
      ]
    },
    {
      "cluster_id": "696c75fe-b8aa-4f76-a6f1-267a591b7b7b",
      "members": [
        "9061c2d6-b97b-4e66-9c41-0f9fdb8855b7"
      ]
    },
    {
      "cluster_id": "523b0246-0513-4295-a714-19577f713513",
      "members": [
        "a902748c-6ee2-4618-887c-aaa065629c33"
      ]
    },
    {
      "cluster_id": "b86b1a76-d691-4bc6-9266-214b0cf4e6f3",
      "members": [
        "c51a371a-2861-4e4a-bebe-05bfd37ac05e"
      ]
    },
    {
      "cluster_id": "eb6475eb-91f7-4af2-a9fa-7784d03f74bc",
      "members": [
        "58a8a0fb-d8e4-4062-8e49-77fbaa8c4af4"
      ]
    },
    {
      "cluster_id": "20d5e5ed-4ce5-4a63-9b10-3e468d3431e2",
      "members": [
        "a1afbbcb-0045-4cb3-a80a-c94f23c033f6"
      ]
    },
    {
      "cluster_id": "21c8abd4-e2f1-498b-ac7c-3e0c279db5b8",
      "members": [
        "f4fd4123-302b-40c8-810b-b64de82dab57"
      ]
    },
    {
      "cluster_id": "2d5921ac-7cf9-4259-b8e0-144908d40418",
      "members": [
        "4bf2c361-66ac-43d9-a57d-69eda5f68ff3"
      ]
    },
    {
      "cluster_id": "3749bcc6-b034-4fb0-8ff0-89b445295873",
      "members": [
        "0486887d-f3e6-4ad8-8318-f61fc63d4e4c"
      ]
    },
    {
      "cluster_id": "f5784495-7eb1-4199-8e36-89b434da6e01",
      "members": [
        "9a34b22b-fed3-4c7b-beb3-c3fe6294db09"
      ]
    },
    {
      "cluster_id": "e3c9a6ab-aa8e-4a41-9385-a9d893d2acc5",
      "members": [
        "89761b78-37d3-436a-9172-1aa0b3e7271b"
      ]
    },
    {
      "cluster_id": "64d91f5a-97ac-46c7-8034-7d2fcfc293b5",
      "members": [
        "3611d703-5b2b-459a-b6d0-1f1799963c5d"
      ]
    },
    {
      "cluster_id": "e0a277a7-e9c4-43ed-a840-95ca0c8f496c",
      "members": [
        "536b54e1-1e4a-419d-a557-b81756067a32"
      ]
    },
    {
      "cluster_id": "e8860c87-9dc3-491a-8748-575a2d051898",
      "members": [
        "12275ffe-4629-436e-b10f-abd6ce599ef3"
      ]
    },
    {
      "cluster_id": "da0898ac-2eb7-477c-8e02-e9f17ebb39af",
      "members": [
        "e11a0225-cab5-42e3-a921-41c80652ca9a"
      ]
    },
    {
      "cluster_id": "5ccf3948-9cc8-42f4-a17d-9079c20482ce",
      "members": [
        "bcb56a36-ec91-4877-92e9-b98d49434429"
      ]
    },
    {
      "cluster_id": "9132970a-f73a-4805-97b9-6e1d8581a3ef",
      "members": [
        "536ccc45-bd29-414b-b18d-e863954871e3"
      ]
    },
    {
      "cluster_id": "ff2f8c85-c8d6-49c6-8138-1b205db9afe6",
      "members": [
        "92720b4b-9773-4329-93c9-b45f67ca61f5"
      ]
    },
    {
      "cluster_id": "e5fa93bf-fdd9-4c91-8fb4-7d6499900667",
      "members": [
        "0c839794-7745-4572-be7b-dddd47fd12f6"
      ]
    },
    {
      "cluster_id": "2b3d52ec-4f80-453e-83c9-9cef80ee3ed0",
      "members": [
        "202de205-f1d1-4bf8-bf64-f00ec54f1552"
      ]
    },
    {
      "cluster_id": "d4bec07a-ec66-4aae-9ce2-624f9525e0ee",
      "members": [
        "d0020a67-fc35-4342-a323-11be9087d48a"
      ]
    },
    {
      "cluster_id": "2cf2f548-46a0-4250-995b-025b4e6eb130",
      "members": [
        "d4a0d688-6659-43f4-b729-ba11a12764b1",
        "da383908-9cae-4334-94f5-b4b1d0bac067"
      ]
    },
    {
      "cluster_id": "451b63c0-8817-432f-8656-27079c8595d0",
      "members": [
        "38f3fcd7-ac4b-48ac-97a7-869b0ebf0b39"
      ]
    },
    {
      "cluster_id": "0473444c-8fc1-4828-8ed2-8a53db5a4083",
      "members": [
        "94df8f53-4787-4085-9cca-4355cf2800d5"
      ]
    },
    {
      "cluster_id": "cdec7efe-effe-4d5a-84e5-892cd8aa5135",
      "members": [
        "b8556f5f-e15a-4c1d-8734-58d81e74cab3"
      ]
    },
    {
      "cluster_id": "ae563379-6971-495d-9872-da508cf0a3c7",
      "members": [
        "365f4d0c-f744-4264-8da9-40b644656575"
      ]
    },
    {
      "cluster_id": "f471f0e2-f8be-4060-8f3a-33826e6e00b4",
      "members": [
        "352f7f27-61cb-4116-94b9-02f2bb7fc6aa"
      ]
    },
    {
      "cluster_id": "491bc782-ae1c-45af-9f60-183d9dcb959e",
      "members": [
        "7371e316-7520-4859-8923-9f49a2fd0bc4"
      ]
    },
    {
      "cluster_id": "914bd639-81ab-4467-a8c1-07b0f59b2871",
      "members": [
        "30f8683d-3aa4-45fe-a452-4101b6211ad3"
      ]
    },
    {
      "cluster_id": "5db738fd-0af6-4d3f-8483-2d8b409e966d",
      "members": [
        "9f8afa71-583a-4075-a1b6-4a16a0225b80"
      ]
    },
    {
      "cluster_id": "739c0bc4-1bf3-45d5-b4d4-587c8689dc5a",
      "members": [
        "d2de2683-5301-4e88-a6af-de7b857d55b7"
      ]
    },
    {
      "cluster_id": "ce1129a3-23ca-4a3e-bf11-bcbe6b5d487b",
      "members": [
        "3ac65615-295e-43b0-bd1e-295acce11b24"
      ]
    },
    {
      "cluster_id": "e6396265-e4ff-4b5b-8b50-46f16a8b1b5b",
      "members": [
        "8edaf8f8-cee1-403a-bb85-08ab937a3c86"
      ]
    },
    {
      "cluster_id": "ed6634c6-cfd9-4bcd-92a4-6a9685e6700a",
      "members": [
        "81034bab-34ca-449a-8125-efe9bd3febf1"
      ]
    },
    {
      "cluster_id": "9e7a0088-26cb-464d-887d-c7e715addbcf",
      "members": [
        "6d5abe6a-278c-4409-9c45-30f3af0e0f88"
      ]
    },
    {
      "cluster_id": "a07d35a7-6217-400e-856f-516669ebb436",
      "members": [
        "fd1034b1-5b65-4663-8ad8-50feb371cd77"
      ]
    },
    {
      "cluster_id": "28df4744-3bf2-4a43-80dc-d2bea8f7af7a",
      "members": [
        "c974f6d6-113a-462f-a937-3a50bb6f876d"
      ]
    },
    {
      "cluster_id": "84147a14-72bc-486f-90ad-45e374aeaa05",
      "members": [
        "cdc2e360-c720-4bea-b351-bdf839c88f03"
      ]
    },
    {
      "cluster_id": "9c176d07-6751-4585-9c31-c558b96a7b39",
      "members": [
        "11234eed-3a0b-461d-a2e4-30ff96dc483d"
      ]
    },
    {
      "cluster_id": "7ed6cceb-29b9-4150-b16f-00796c0ac573",
      "members": [
        "b08c723f-b7b9-4359-b317-16d091bf3b21"
      ]
    },
    {
      "cluster_id": "1758ed2e-dc14-4881-941e-3bd76c244d71",
      "members": [
        "c3394cb0-7f38-434e-b842-6b01a620b052"
      ]
    },
    {
      "cluster_id": "ab43ecb5-72cd-4cd0-9f6f-d31ca04720f7",
      "members": [
        "be00ff73-c861-4bd7-b6d4-8a447568e602"
      ]
    },
    {
      "cluster_id": "aeb3174b-bc91-4fbe-9027-0eda5304183e",
      "members": [
        "26c3f605-3001-4112-9321-01545614593d"
      ]
    },
    {
      "cluster_id": "c5bc8d69-1894-4720-8281-0a21bdbe0e98",
      "members": [
        "5c99bbde-646b-490b-853d-f167d22f76bb"
      ]
    },
    {
      "cluster_id": "219dab96-d91d-4b0d-b347-235846e4bc70",
      "members": [
        "b69bb252-8716-4cad-aca0-20858633f361"
      ]
    },
    {
      "cluster_id": "5d65bb29-7381-44ed-8856-ec52d73d0a76",
      "members": [
        "683089cf-de34-464a-91b4-29c055e7034f"
      ]
    },
    {
      "cluster_id": "639772f4-84fc-47d4-a44e-cd508a3d7e6a",
      "members": [
        "2019fa13-4954-4783-ab8a-b6d58fb3767c"
      ]
    },
    {
      "cluster_id": "190c47c8-68da-42d3-b08d-822d259e964f",
      "members": [
        "9583ac2e-6d33-435f-b5aa-c463766577f7"
      ]
    },
    {
      "cluster_id": "5d61ec99-0639-4eaa-b6c6-d29d8645a85f",
      "members": [
        "044ac721-0b4b-42c6-a6fa-df1a1fe7d2a1"
      ]
    },
    {
      "cluster_id": "2d30ef5f-ee97-4df3-a64c-5e181a81321a",
      "members": [
        "ffe6f633-c3dc-4185-ad58-053703bb06bd"
      ]
    },
    {
      "cluster_id": "faa4667e-011a-4693-8171-40e817256b60",
      "members": [
        "ba93a92a-87bc-4eb5-b06e-8c6119100af6"
      ]
    },
    {
      "cluster_id": "93df5ce1-4286-44c4-8457-3b0ae5570ff2",
      "members": [
        "b8f25f7c-1b81-4e37-9f35-478976c1b8fb"
      ]
    },
    {
      "cluster_id": "01eb8b8e-096c-4892-bc91-ee4788a133cc",
      "members": [
        "d8f1116e-b8e4-44c8-b2e0-e3a9f21c6ca8"
      ]
    },
    {
      "cluster_id": "31f1de90-d456-4f9f-8590-accad42614e0",
      "members": [
        "f7b3741e-3ff3-477e-833d-510531c56e36"
      ]
    },
    {
      "cluster_id": "42214595-36bd-4891-862c-e83b3aae0a8a",
      "members": [
        "aa8ced11-33e8-4dfa-a777-998135937715"
      ]
    },
    {
      "cluster_id": "43fa0350-2309-4b93-bd2a-6e8c4a716e73",
      "members": [
        "652002d2-8a3d-47b5-83a2-1bc03a3d02d1"
      ]
    },
    {
      "cluster_id": "de8997cf-fd37-4d0e-b22a-dae890492f89",
      "members": [
        "3884db69-6ca6-4ea3-9050-5a4f1a38d906"
      ]
    },
    {
      "cluster_id": "320a9519-2826-4d38-88e0-353ff9437484",
      "members": [
        "332e1724-af40-488b-98b4-34de0d227565"
      ]
    },
    {
      "cluster_id": "7cc54def-6358-42e1-9afb-ba0b2ba2ac2c",
      "members": [
        "8d73d89f-a149-40ab-a9d8-3bd1bf052237"
      ]
    },
    {
      "cluster_id": "e3336914-7a77-4548-8764-1fd25cd393fd",
      "members": [
        "da8b0d27-574d-4160-874f-3dfd267572ea"
      ]
    },
    {
      "cluster_id": "876ae960-2467-4ffe-b0e9-9cd336bdf4a1",
      "members": [
        "de66ea25-fe29-493e-9ca1-a9c48d258a0c"
      ]
    },
    {
      "cluster_id": "2de4265b-f662-429b-82af-a99a27de61cd",
      "members": [
        "9636e7f7-f323-42f3-9678-018b36dca663"
      ]
    },
    {
      "cluster_id": "af86b76d-a390-4847-bb43-41459c4a0513",
      "members": [
        "bbf6cbba-ed02-4c30-884a-e2f6eb5f8ec2"
      ]
    },
    {
      "cluster_id": "11b98cf9-d431-4639-813c-ea19160c9631",
      "members": [
        "1d9c7f8c-7c46-41ed-9120-4d1ccad37e23"
      ]
    },
    {
      "cluster_id": "ddb7dbbd-226e-4674-859d-8c16b4f4ce9e",
      "members": [
        "2cd17608-a3a1-4148-bac5-8ff63680024d"
      ]
    },
    {
      "cluster_id": "2c8bf59a-7972-4ab1-a4ae-680a19fde855",
      "members": [
        "719debe7-77ec-4ef4-b4fa-3292b895aacd"
      ]
    },
    {
      "cluster_id": "bf418d10-64bf-4718-bddd-53c651aaa9eb",
      "members": [
        "76c16e04-c75e-43c7-9a3f-ff2ecdcb6adb"
      ]
    },
    {
      "cluster_id": "d4ecfa56-5354-4519-b8ae-d7dff0864186",
      "members": [
        "10d5a29b-3409-4a51-9ace-43d54e3fb5eb"
      ]
    },
    {
      "cluster_id": "0463ae92-c5a2-4eed-bc9a-bba00f27b6ff",
      "members": [
        "41be2912-a92c-49cf-8992-e53ca8442812"
      ]
    },
    {
      "cluster_id": "d2dc78d1-ae53-4ed9-adc5-5e6752f3a1b0",
      "members": [
        "b422ade6-fe37-4342-9c94-f558dc1f6d06"
      ]
    },
    {
      "cluster_id": "adfb27db-3208-49e3-8050-366e93400ac6",
      "members": [
        "42ed635a-b8e2-47a3-adc0-3096844abd7a"
      ]
    },
    {
      "cluster_id": "58d6742a-73cd-42e8-8a47-4ea3718af2a5",
      "members": [
        "1b13c812-81e5-4522-8a73-474b58c8824a"
      ]
    },
    {
      "cluster_id": "3d3c026b-80c1-4334-84d1-db19f80712b4",
      "members": [
        "3bda60e7-ed94-4ec2-9405-c9c81258a1cf"
      ]
    },
    {
      "cluster_id": "6ddc553f-506b-402a-87ca-b781b2c60932",
      "members": [
        "be63afc2-aba4-4262-8fa9-91dd6c829ea2"
      ]
    },
    {
      "cluster_id": "d15b1a4a-b0d0-463c-b7c1-b74ef1c0a63a",
      "members": [
        "4f14a3d3-a2af-4fb4-9c5b-77e81db0e24c"
      ]
    },
    {
      "cluster_id": "11abdc54-b039-4ec9-b836-c70099743468",
      "members": [
        "6a6243b9-18f2-454b-a36e-eaca6ac954ea"
      ]
    },
    {
      "cluster_id": "c09d9041-f33e-4fbb-bb7b-4e43f4329c75",
      "members": [
        "8bb44fdc-fdb0-4a26-882a-fc0bc28cb158"
      ]
    },
    {
      "cluster_id": "e1a7ebff-5254-4bd5-a3d1-966b6a60cd7e",
      "members": [
        "50412109-04a6-4ae7-95f1-52dcd65d0f33"
      ]
    },
    {
      "cluster_id": "0007cb01-3742-461b-b5c4-5aadc5a55eac",
      "members": [
        "c089f020-2b1d-4af0-b3cf-0dfdea7e1451"
      ]
    },
    {
      "cluster_id": "266e7b13-78e4-4d47-a479-faf867ea0a51",
      "members": [
        "c5635cfb-1ed4-443a-b1da-b1c51e0f1cdd"
      ]
    },
    {
      "cluster_id": "7f537263-14e5-41a9-8479-1de5e6a80076",
      "members": [
        "f80084e1-f78e-45e5-afad-1851567b2f30"
      ]
    },
    {
      "cluster_id": "a7b985be-e866-4775-b4be-7c7e64f9a12a",
      "members": [
        "9c18abc8-e211-4150-99de-08279282031e"
      ]
    },
    {
      "cluster_id": "2f406046-b590-4796-97c3-ab6b4e6c2d6a",
      "members": [
        "fb0583c0-c588-458e-ab4c-cbb0dc8d6e19"
      ]
    },
    {
      "cluster_id": "fd67a670-bb1f-429a-b83a-c92989f510e3",
      "members": [
        "8b45eff6-3eec-4abe-be2b-171304c22e14"
      ]
    },
    {
      "cluster_id": "94bb7f1c-2d8c-4580-8fb1-a174bd27e088",
      "members": [
        "036c29b2-0aed-4e11-9f8c-b89c77df016e"
      ]
    },
    {
      "cluster_id": "ce1afbc7-cb83-43ef-a574-f0c71eec061c",
      "members": [
        "62354f10-9854-4b6b-a2f0-76f2bbbb9d5c"
      ]
    },
    {
      "cluster_id": "86c9a6a1-8859-49b1-869c-febe929feb9d",
      "members": [
        "596dadca-7ecf-4ad3-9240-155524a0321a"
      ]
    },
    {
      "cluster_id": "6003df1f-5700-4398-bb5c-3e647fefb73f",
      "members": [
        "f0934c56-ec5b-4af0-a746-6e2b253770b7"
      ]
    },
    {
      "cluster_id": "8ab5907a-7d78-4873-b326-304fe58b10f8",
      "members": [
        "f2549918-16ff-4631-a465-2b9b49adae82"
      ]
    },
    {
      "cluster_id": "32b2643e-52f7-4ad5-a0ab-4120423c498b",
      "members": [
        "4f1c4513-d2ef-45af-8edd-7f7c6d7acec7"
      ]
    },
    {
      "cluster_id": "f6bf24ea-54ac-45f2-b1ba-27747efe5a47",
      "members": [
        "f5a77d26-097c-4c34-9a8d-741665227f16"
      ]
    },
    {
      "cluster_id": "31b521fb-d677-46b2-8db7-b2e8a8fafe49",
      "members": [
        "87f1afab-9886-497e-bd50-ded7dc234038"
      ]
    },
    {
      "cluster_id": "115eeed7-4973-4efa-aa32-369a2056fa21",
      "members": [
        "75eac795-7813-4c90-849e-a328ea85cdac"
      ]
    },
    {
      "cluster_id": "7d97e055-f53d-4979-b83c-8c058b074265",
      "members": [
        "a225fb8e-01e5-4bc0-83bc-1cd4443cbf55"
      ]
    },
    {
      "cluster_id": "31763d96-84ac-402a-a69c-ea748718f342",
      "members": [
        "15eff4ff-752f-469d-ac3d-cf27e57e7342",
        "d8e60c1f-58fd-434f-944c-4ce72c545008"
      ]
    },
    {
      "cluster_id": "938b7182-512d-4aa5-a1bc-532c7b55f96a",
      "members": [
        "f512e1cc-18eb-4be6-ace2-84dfa7e939d9"
      ]
    },
    {
      "cluster_id": "efe63a8c-0f9a-4b9f-ad60-14fabb8e67d3",
      "members": [
        "90acb2f0-5b14-4c2c-b233-ea7d144bdb5c"
      ]
    },
    {
      "cluster_id": "e0948d6f-1c68-4b82-8be1-2b7d5644b264",
      "members": [
        "c7e20b17-7466-4ce1-894e-90163480399c"
      ]
    },
    {
      "cluster_id": "02f42105-05b5-4e5d-917a-7eefa123f670",
      "members": [
        "c6950cb3-e288-4c5a-87c6-4dce2df15ab4"
      ]
    },
    {
      "cluster_id": "2a43ad41-42b1-4d3e-8501-88166518eba1",
      "members": [
        "67df963f-093e-4ca0-8223-a134f2b01be7"
      ]
    },
    {
      "cluster_id": "10c35c93-3305-488a-b928-ca8b7cb9a3d2",
      "members": [
        "b0aa8582-a02b-482c-97fc-31bc9bc0988b"
      ]
    },
    {
      "cluster_id": "f23bc705-fad4-4454-82b7-d780cad17182",
      "members": [
        "3c456844-3843-408e-bba9-e1b938e9c122"
      ]
    },
    {
      "cluster_id": "522064a5-257c-47c1-b163-e454d1155f76",
      "members": [
        "413a6954-3ccb-4496-859b-9e64fcf48ad9"
      ]
    },
    {
      "cluster_id": "ecc05d01-ffac-434e-b1f4-f1a58038c91f",
      "members": [
        "f7ef0dab-8917-472f-a8a6-63f35eba88ff"
      ]
    },
    {
      "cluster_id": "4e97d6a7-e106-4542-b474-cb57818b7b22",
      "members": [
        "a962fc5f-24ff-4c6e-a247-1ff2fd6df37a"
      ]
    },
    {
      "cluster_id": "d85e9fe5-2b49-48db-b3ed-055f19c978de",
      "members": [
        "a1ee7052-c980-4fb2-8d5a-4cd6a16a06c2"
      ]
    },
    {
      "cluster_id": "d2c0f044-52b0-4afb-ad04-975898224fdd",
      "members": [
        "ec33a170-1453-40a4-8f20-6d255d78fe65"
      ]
    },
    {
      "cluster_id": "b23a3a32-e361-4bd2-bb69-d01d98ed6b13",
      "members": [
        "96b80c06-b64d-48a0-a866-fa12a69c8022"
      ]
    },
    {
      "cluster_id": "ac2e2af1-8130-4f38-a6ff-ea4697746269",
      "members": [
        "5d3c8522-8b54-444e-996e-00ed7e252767"
      ]
    },
    {
      "cluster_id": "78fa9929-a2ff-4f4c-b21a-35134d80f026",
      "members": [
        "52d563db-56f0-4713-8419-820df9a6af1a"
      ]
    },
    {
      "cluster_id": "24b243a4-0f35-4d99-b275-1610156f7f35",
      "members": [
        "371d4c61-e8be-4e96-8f8b-41fbd855bb80"
      ]
    },
    {
      "cluster_id": "3e3518da-eab0-4220-8961-2d5489b4e97a",
      "members": [
        "361583a1-3ab5-4990-b50e-486b2864d236"
      ]
    },
    {
      "cluster_id": "e0f9e573-f9e0-44e0-aff6-2dee5ec70199",
      "members": [
        "cfe79470-7eb9-4ab4-8c55-75b6311329e8"
      ]
    },
    {
      "cluster_id": "69563b87-ed4e-43d1-a693-c379aa9b1be9",
      "members": [
        "c6969ea7-2cb0-48fc-a29e-5d0e2e3dcc0a"
      ]
    },
    {
      "cluster_id": "43fc29bf-35e5-405b-9c9f-cf4dbaccd61f",
      "members": [
        "2be8f441-d916-4f8a-bbd3-87bb25330991"
      ]
    },
    {
      "cluster_id": "2ae6e0c5-a6f5-4035-9f73-8ab31a8a805b",
      "members": [
        "b30e4341-3899-4e8e-9c88-1b334e46e7a4"
      ]
    },
    {
      "cluster_id": "cacf5ae8-cf4c-4e9d-86a7-1b95a7ab58e2",
      "members": [
        "970ef17c-9ae1-4064-bafa-37436103dbfb"
      ]
    },
    {
      "cluster_id": "2fefb93c-9c85-46df-850b-c68cfbfe7264",
      "members": [
        "ccd393be-47d2-41d6-871b-4624f8aca860"
      ]
    },
    {
      "cluster_id": "ebb80698-62b6-438e-85ac-44aff649cb30",
      "members": [
        "274701e0-c87e-4a92-8ffc-f0e549a34634"
      ]
    },
    {
      "cluster_id": "cc256628-cc7d-493f-98f7-e2382cb4b346",
      "members": [
        "3cbf07f1-46b7-4d3c-9da2-4e78f0de56fd",
        "413fd5c4-93fb-4975-926e-949600553baa"
      ]
    },
    {
      "cluster_id": "d1aa87f5-6e8b-45d2-89ab-5267e8136707",
      "members": [
        "e0b9ec6a-ef37-4be8-9a8f-fb3a4eaed21c",
        "349a4808-5100-43dc-bb93-0a3696bc93c0",
        "38c2efac-70d5-45dc-b1a6-bc298b341cb0"
      ]
    },
    {
      "cluster_id": "dbe4672e-f5d2-4914-b987-c4e89610b2b6",
      "members": [
        "db26f402-9699-4f53-adc2-5c49174a685c"
      ]
    },
    {
      "cluster_id": "7a36ef35-086a-4724-b10d-2245bacdde6a",
      "members": [
        "b448de85-22bb-4921-bedf-84e814f19ea8"
      ]
    },
    {
      "cluster_id": "036aef66-792d-4feb-a831-cb1e088b3daf",
      "members": [
        "abd62fb9-dfd6-451a-b1e2-5c9a1b4eb5a6"
      ]
    },
    {
      "cluster_id": "d8fd9aa7-8b30-418d-82de-88746b18d64d",
      "members": [
        "b3afa837-aa0d-4eb9-a7c8-517a907dfa27"
      ]
    },
    {
      "cluster_id": "f4f2acc7-50ed-478a-a3c8-fd8ce6afe67c",
      "members": [
        "29685c61-610b-4a8b-99ab-2e16778e13f1"
      ]
    },
    {
      "cluster_id": "4941bed1-24d8-4571-89bb-5872a51c53ed",
      "members": [
        "f051cc8c-6a20-4d6c-a0cb-43d0d946125c"
      ]
    },
    {
      "cluster_id": "7caf5c56-5f70-4536-ab5a-2d4f84227951",
      "members": [
        "b8deb308-1885-4578-90fc-5e30e5808a8d"
      ]
    },
    {
      "cluster_id": "dcae0b06-ee3c-4003-865d-7cc0ed9affe3",
      "members": [
        "b3be0f40-8fdc-4f79-aeeb-9a3360f22c21"
      ]
    },
    {
      "cluster_id": "2116fedb-8d8c-44ee-b7a0-a2ee29d3edd5",
      "members": [
        "80e39e30-3b7e-41fc-a1c4-99fb925668b9"
      ]
    },
    {
      "cluster_id": "66d45ba9-56c2-4b38-9b31-adec0598a967",
      "members": [
        "19e97047-b708-411c-b6f1-59ca118e857a"
      ]
    },
    {
      "cluster_id": "6faef44d-a395-4b46-93b5-ca7cbd7fcfc0",
      "members": [
        "be38e493-a4a0-49ec-abd2-bb6182778ce7"
      ]
    },
    {
      "cluster_id": "4361c487-2c7b-4ed5-a3bb-23c69a57f5ec",
      "members": [
        "e25d9cc2-d1d6-41c0-aa75-5ef3d6ae4d81"
      ]
    },
    {
      "cluster_id": "b87e7ed0-8014-419f-b604-584f2337b651",
      "members": [
        "759bc274-fc7e-4c8c-875f-5d9d3e0bc6d1"
      ]
    },
    {
      "cluster_id": "13df1ab3-c8ca-4935-bfac-bf950b3f0183",
      "members": [
        "aa77c6dd-6815-4ee7-95cc-9f476723df75"
      ]
    },
    {
      "cluster_id": "3ad1f302-26c2-471c-bf5f-e79fa32778b5",
      "members": [
        "436ac542-f466-477c-90f1-8779404eafbf"
      ]
    },
    {
      "cluster_id": "264cec13-14ac-4e28-862c-a8260aede982",
      "members": [
        "48530f0d-bb14-4da4-9e07-c07bd14e1a91"
      ]
    },
    {
      "cluster_id": "ff2f92ab-182c-47dd-8807-28fea5da8eba",
      "members": [
        "b3888e25-51f1-4dc1-8dc9-941a6e307477"
      ]
    },
    {
      "cluster_id": "73893bd5-387d-4d08-9fad-0f62b5aacd0c",
      "members": [
        "0a12843a-9484-48c5-92c6-08e7bbd4cdab"
      ]
    },
    {
      "cluster_id": "02a17fb1-29be-46e9-913d-2f11d1b37013",
      "members": [
        "9d9565d5-8ea3-4db0-911c-a1ab63581ca2"
      ]
    },
    {
      "cluster_id": "aa6b0ec7-e6ca-40be-8563-62563928ebc1",
      "members": [
        "149b435e-0838-4b78-ac8a-64e644aa02d5"
      ]
    },
    {
      "cluster_id": "bcac4aab-9cd8-4923-b998-bd470cb7fa0f",
      "members": [
        "a5df38b9-2deb-4820-9ba6-667ae40ca26d"
      ]
    },
    {
      "cluster_id": "71ca644a-cfc8-4e25-b5db-b8f4e53e1dc1",
      "members": [
        "07afca8c-75c7-4e63-b710-40046c2ea030"
      ]
    },
    {
      "cluster_id": "efada224-bd67-4a33-8ca6-01f2d398630b",
      "members": [
        "e1e40157-3022-4baf-a59b-3802d4ce6a78"
      ]
    },
    {
      "cluster_id": "e47a5c41-ef67-4e8c-bde7-553670fb6a9f",
      "members": [
        "314b9885-f959-4540-8a81-6db59af29278"
      ]
    },
    {
      "cluster_id": "8e29592d-1755-4868-982e-348b60636ba1",
      "members": [
        "3f33bcc6-16fd-4146-9119-4063190d2547"
      ]
    },
    {
      "cluster_id": "da887573-bcbf-4c6d-8541-c47ee99de6f7",
      "members": [
        "37bb4f09-1949-4ca9-925f-f2f7f5fae02a"
      ]
    },
    {
      "cluster_id": "0c52c819-873f-4721-acb7-09c8239a9862",
      "members": [
        "6dba0146-ee5c-4d22-8202-366446328116"
      ]
    },
    {
      "cluster_id": "a01dee28-83a3-45b0-ab2b-6e6c04b1fe22",
      "members": [
        "8c6381d1-06d3-48cd-9fcb-f6d47803b1c8"
      ]
    },
    {
      "cluster_id": "fd2129f3-2e6f-48c6-9418-cef28902c1e2",
      "members": [
        "e1ed5bff-cfaa-4746-a821-bb42e9eee497"
      ]
    },
    {
      "cluster_id": "8c96de89-87b9-4c63-a1e4-fab8f67f7294",
      "members": [
        "a6488430-f13d-4976-8ffa-b5d2a3a03f1d"
      ]
    },
    {
      "cluster_id": "b97fc666-43dd-4240-9de8-5f0f42a98b08",
      "members": [
        "9e7eed4f-220c-42c1-8287-6912c7842d0e"
      ]
    },
    {
      "cluster_id": "39ac0d20-baa7-48d3-8263-9b324a75c453",
      "members": [
        "e4020dee-d50d-426e-abc1-808bd759fcd8"
      ]
    },
    {
      "cluster_id": "0edc35d0-3f90-4beb-b2c7-55c511dba369",
      "members": [
        "51c79555-6f9f-43e9-bffc-8e400d241a59"
      ]
    },
    {
      "cluster_id": "98230e6a-7d95-4671-8b15-8c0dbec5af34",
      "members": [
        "61c5a464-83ba-41ba-a8e3-4ea93188d477"
      ]
    },
    {
      "cluster_id": "4cb90529-ce16-437b-99b6-c2cd5dcc786a",
      "members": [
        "77f2d1fe-fcaa-4e36-af2a-d7e947ebc3b5"
      ]
    },
    {
      "cluster_id": "3a02d9a5-2925-42fc-a9b8-bf0df52af22f",
      "members": [
        "d31e760e-221b-405a-b2a4-4d4e8770860f"
      ]
    },
    {
      "cluster_id": "d9bde049-6b0f-4d26-ad61-29d5b4dc2bc8",
      "members": [
        "4338c56d-1ee1-42e6-8b86-59066fe99e57"
      ]
    },
    {
      "cluster_id": "3038e36b-6f90-4a8b-a5ed-b89bec5c7144",
      "members": [
        "5b404305-a187-4827-a04c-da7ccb6139a8"
      ]
    },
    {
      "cluster_id": "65d8f691-42a2-4903-8a08-db7d149c26b1",
      "members": [
        "ac80fb30-7c46-4efa-8203-8849169b83ab"
      ]
    },
    {
      "cluster_id": "fa9c6e3a-5327-4294-bfff-2d638f6c4455",
      "members": [
        "462638c9-c9ce-4650-af3c-bfb23f68d25a"
      ]
    },
    {
      "cluster_id": "d5ffcb4c-8c79-4cc4-868f-bca69bb676c5",
      "members": [
        "474f5052-9cdd-45c6-950f-9afa02aad4d8"
      ]
    },
    {
      "cluster_id": "6c9f4959-d341-4a88-80e2-4c73e592884c",
      "members": [
        "2351854f-aaf1-4bfd-984c-3bc9d980c1b0"
      ]
    },
    {
      "cluster_id": "3360bff0-2a50-48df-84ce-ef5c8f91489d",
      "members": [
        "84cb69d6-6cbf-4df8-8678-144ef113fd4a"
      ]
    },
    {
      "cluster_id": "bae5df31-d0a5-4216-b755-4add987f460d",
      "members": [
        "bb748b52-4304-4eed-b247-e4d11a492e1f"
      ]
    },
    {
      "cluster_id": "2d1b7151-63a5-4414-9619-8c40fe20742a",
      "members": [
        "0d7d7cd6-18a4-4333-9251-d959fbe2f715"
      ]
    },
    {
      "cluster_id": "b46bab47-6915-405b-a8fa-be8c999e4b4c",
      "members": [
        "99d986ba-d36c-4bd0-ba02-28432c62c77b"
      ]
    },
    {
      "cluster_id": "ea81b5d1-0d91-46ec-a9b0-b349139b83e4",
      "members": [
        "b3692450-a4bf-4345-8f0e-6dbb92d3e3a6"
      ]
    },
    {
      "cluster_id": "6b780a23-d1ce-4c39-8626-c4071a335cc8",
      "members": [
        "1f48df8f-b219-4947-8919-21cc9365cf67",
        "00e97291-053f-40c0-8f73-0927fe29385d"
      ]
    },
    {
      "cluster_id": "77ff5800-b905-4e32-87cc-e4de9525bb38",
      "members": [
        "2bc1e157-e741-4377-899a-793c3a322854"
      ]
    },
    {
      "cluster_id": "86339977-5115-476b-96dd-1ca67842fea9",
      "members": [
        "bf48e0c8-6b76-4bd1-bb96-cfe6388a9243"
      ]
    },
    {
      "cluster_id": "c54aa827-069b-4ed6-b43e-bde69590b9e4",
      "members": [
        "b753f791-7516-41db-940f-1798e0fdfbf0"
      ]
    },
    {
      "cluster_id": "bc705731-4001-4b4a-a9bd-71359c405ab2",
      "members": [
        "80264d7f-d885-40ac-9716-ec548a6a18a9"
      ]
    },
    {
      "cluster_id": "baaee7cd-473c-4323-bdcb-32b41e2930f2",
      "members": [
        "bfd00629-aad9-4669-991f-7ce7632d7aed"
      ]
    },
    {
      "cluster_id": "ac3739e2-de75-46fe-a991-203fbc3a72e0",
      "members": [
        "794945b4-9967-4114-b28b-9b21276600bf"
      ]
    },
    {
      "cluster_id": "abd5930f-6db1-45e3-b882-ee3ba2f8394b",
      "members": [
        "8d3033f8-b26c-49a6-bbbd-29649925f2d7"
      ]
    },
    {
      "cluster_id": "37512ba8-d5ed-4b9e-9fba-d0ec249a1d84",
      "members": [
        "6f3937e0-0969-4b7c-a2d8-449c9102e2e4"
      ]
    },
    {
      "cluster_id": "1789e573-0855-4766-ab56-773e8cdbeef5",
      "members": [
        "7cd1d0a8-4b6b-4508-a82c-dee4ee393d40"
      ]
    },
    {
      "cluster_id": "2a4109b0-0594-4c99-979e-19f8908c65ec",
      "members": [
        "06b40460-322d-4c00-a603-7425c216f72c"
      ]
    },
    {
      "cluster_id": "3a423758-4300-46f1-8112-c2195cd0ee0a",
      "members": [
        "3b680279-da88-4981-ac94-ffeb7428e442"
      ]
    },
    {
      "cluster_id": "719a33e0-04c5-4203-a193-c262a589d49d",
      "members": [
        "2e53e34e-8b05-4afd-b21e-a0cdf3cdd9f6"
      ]
    },
    {
      "cluster_id": "7e6ac8e9-cc11-4ef0-955b-65da48ed02cd",
      "members": [
        "1efdbb35-4dfb-439c-868f-834c7b846857"
      ]
    },
    {
      "cluster_id": "88ef71b9-0470-4f94-b8a3-c2845e2f29e8",
      "members": [
        "d9f48841-a61f-46f7-9539-6a5c05b24109"
      ]
    },
    {
      "cluster_id": "69f46f33-8514-4ea2-ba72-362d6d1d202c",
      "members": [
        "de49b199-c805-4af8-86b0-6d89346ccf9f"
      ]
    },
    {
      "cluster_id": "7751d40e-e8dc-4a49-ab80-48cd61a84607",
      "members": [
        "ec647ebf-9926-4360-bc7b-b5ce0e925bce"
      ]
    },
    {
      "cluster_id": "0b61ebc9-d9b1-4e5b-9094-6829b839c660",
      "members": [
        "533a7bd6-e829-42a4-9db0-d65325e0a19b"
      ]
    },
    {
      "cluster_id": "59c81fc9-37c0-4304-9d97-9e5694d8be20",
      "members": [
        "ab431245-f9f2-4fc8-9151-1a933d1cc17a"
      ]
    },
    {
      "cluster_id": "158c7584-7298-4494-b705-f2d978c25206",
      "members": [
        "13d983ca-227d-4fce-a25c-5601ce01e1b8"
      ]
    },
    {
      "cluster_id": "ef30a0f0-6c8f-4544-8a16-49df03cd9879",
      "members": [
        "59ba3908-5409-4ccc-a9c8-03413841cd4f"
      ]
    },
    {
      "cluster_id": "170734bc-dfb6-42e4-9b5a-6f9747a63ae0",
      "members": [
        "b2bdcd0b-beea-4a69-a3e2-7a51305b0555"
      ]
    },
    {
      "cluster_id": "1fcf44f5-43a5-44f5-b144-1142863197ac",
      "members": [
        "69cc96b7-da30-47d5-8424-4e395d087944"
      ]
    },
    {
      "cluster_id": "1abec326-fbb4-4834-a440-05a48bbfed29",
      "members": [
        "ed0ec28b-9f14-4602-b693-8e65024224e6"
      ]
    },
    {
      "cluster_id": "769dd442-b312-4ca1-8bda-308188e59a4c",
      "members": [
        "7b589fb6-b848-4438-b798-8bbc2aa8a6cb"
      ]
    },
    {
      "cluster_id": "eeb2d0cb-ddf5-48d2-9af4-27f0f7c318af",
      "members": [
        "d0d92bc5-9c68-46c6-9788-5f5e4bd08bdd"
      ]
    },
    {
      "cluster_id": "1fdf700e-c5ec-4ab4-a4d5-eff0304e7a3b",
      "members": [
        "fe2cb97c-fe95-4131-9801-37c0348a8a00"
      ]
    },
    {
      "cluster_id": "f5cfebe0-089d-4908-8224-abe95a565459",
      "members": [
        "c48a7be2-6dcc-42a1-8ce9-14c71ebcbfbf"
      ]
    },
    {
      "cluster_id": "be7b3105-d76a-4aca-86c4-5d724f3e84ce",
      "members": [
        "240a0d40-b046-4558-ba3a-102a30c4af61"
      ]
    },
    {
      "cluster_id": "773f7bde-1fe5-44c5-9d2c-84b849939bc7",
      "members": [
        "70c05f1a-ed99-4420-a739-2e3fb45d6e38"
      ]
    },
    {
      "cluster_id": "ff8eb50d-ed26-4f4e-b34d-1dd10e2cdbe4",
      "members": [
        "dad945d1-7f00-4509-8a65-103e7f8afbe2"
      ]
    },
    {
      "cluster_id": "06455359-79a6-4ebb-a802-9c4a2595559c",
      "members": [
        "7da6de1a-35b8-4a75-a954-1c24437d58d6"
      ]
    },
    {
      "cluster_id": "ec52d818-47ba-4361-9b9e-62d7a7a87109",
      "members": [
        "5f808033-32ef-47a2-8cf8-fe0d1db9977a"
      ]
    },
    {
      "cluster_id": "f97c3523-e4c9-4551-a240-c5e4c7f8f532",
      "members": [
        "dc1d910d-a266-4155-a4df-137451cf698c"
      ]
    },
    {
      "cluster_id": "2bb22d37-82ad-420f-8b9d-f5e541da469b",
      "members": [
        "2bfb27e5-8f73-4a0f-9c57-06def4d4564c"
      ]
    },
    {
      "cluster_id": "632ff2a8-1423-4189-882c-4d3e14dadc3f",
      "members": [
        "a821d7c6-d6e1-48de-9505-56526b0c68ce"
      ]
    },
    {
      "cluster_id": "52307e03-a0f5-4819-b75d-6ff7244ed5dc",
      "members": [
        "57bf6299-78f3-4468-8703-37069d49fbea"
      ]
    },
    {
      "cluster_id": "a793f62f-9462-444a-a9da-d3e2c115a5b1",
      "members": [
        "4f631004-9ca8-46a8-abc0-375b2a381ce5"
      ]
    },
    {
      "cluster_id": "01196e0c-7fc3-4e40-8d9d-fcbcee3103a1",
      "members": [
        "ac1702a8-31f0-43f1-8a23-564f62f7bea5"
      ]
    },
    {
      "cluster_id": "371a45ea-84b1-459c-8153-e0d2017b4ce1",
      "members": [
        "897cfbf4-b0f6-4c58-9b83-b6b3531ac3cf"
      ]
    },
    {
      "cluster_id": "73834fa0-ff83-4c9b-a609-95e04c072ab7",
      "members": [
        "d8aa675d-70d7-41d6-8136-614334dea547"
      ]
    },
    {
      "cluster_id": "33b11fcf-85c4-4c95-b81e-d603bced718a",
      "members": [
        "9f4f2079-e0e1-4455-a99e-e13c6b676c41"
      ]
    },
    {
      "cluster_id": "42b243b1-6e2f-4145-911d-1a4fb97435e4",
      "members": [
        "47e1651b-b1de-4e01-bcad-20e5d94c4d6e"
      ]
    },
    {
      "cluster_id": "4d6e8834-c57b-472a-adbf-630fe4d997d3",
      "members": [
        "0cad8084-1fb8-40fb-891c-30a8b4e846e3",
        "f2d28ca5-a4ff-4723-afa9-d0c2392f65b2"
      ]
    },
    {
      "cluster_id": "214ffe56-f58d-4fdd-a3cd-ef399506aa9a",
      "members": [
        "8042590e-9b0e-458b-8097-3fb2fc4e378e"
      ]
    },
    {
      "cluster_id": "994afb12-0656-46cd-8fc2-48a9ab17ddc7",
      "members": [
        "250dfb59-beb0-473d-bcfa-07bba81b251a"
      ]
    },
    {
      "cluster_id": "414847cb-46dd-4cd3-8ade-e04a5900b77e",
      "members": [
        "f808aef8-b4f3-4d04-9092-ead8a7ea4b52"
      ]
    },
    {
      "cluster_id": "237a1bcd-f29b-4003-80f0-c4efc0c14bc8",
      "members": [
        "27f39ead-207c-4f99-9b63-e2741885a881"
      ]
    },
    {
      "cluster_id": "f7605d2c-c20e-498d-b5dc-8cc953b6d021",
      "members": [
        "ea5487cb-bfc0-42cc-939b-3e2c476660f8"
      ]
    },
    {
      "cluster_id": "d748319a-ab54-4e2c-9098-21db36bad1c7",
      "members": [
        "35c63cbc-56e1-4b7c-addf-1efbf72b74dd"
      ]
    },
    {
      "cluster_id": "f1a2cf3f-1311-40c2-b18c-4f973df71568",
      "members": [
        "6d655859-153d-4ca8-9eb1-061406ef278e"
      ]
    },
    {
      "cluster_id": "5adabd10-79d1-4a41-a250-38ed66b71fff",
      "members": [
        "ccf58259-edef-418e-bf13-39bfcdab2d92"
      ]
    },
    {
      "cluster_id": "a96dc83a-238f-4ad4-81c6-dfc26af2869a",
      "members": [
        "1c54c370-6580-412e-aead-a07fdebd2ba0"
      ]
    },
    {
      "cluster_id": "6d514f4a-28a3-42c1-8a0f-d24931c265ce",
      "members": [
        "7f28a7bc-70ce-4f0a-87b6-75423e554efa"
      ]
    },
    {
      "cluster_id": "f63e0793-99cd-4330-8985-abb2d981981a",
      "members": [
        "1d967dcf-2dc6-4846-9278-42ad23f9103e"
      ]
    },
    {
      "cluster_id": "d2833c21-07b4-4262-9ed6-9db3cde93c79",
      "members": [
        "6fb200b9-76cb-4e7a-9da7-c612ff8f45de"
      ]
    },
    {
      "cluster_id": "760769b6-c063-42c2-8199-157a1d623f27",
      "members": [
        "4cfd60ef-933f-4a85-9639-8e8f76160982"
      ]
    },
    {
      "cluster_id": "e6aabe2f-c2e1-4dd9-a27b-e84ebb5bc406",
      "members": [
        "480fdcfe-9df0-49d9-827d-49a35cd43537"
      ]
    },
    {
      "cluster_id": "bfb33b2a-3aae-48af-9bbe-a26cf7874798",
      "members": [
        "d665ad60-4c24-4eb5-8ff4-f9aca6191179"
      ]
    },
    {
      "cluster_id": "aa460f1b-c007-4666-8137-aaad655dfd7f",
      "members": [
        "d211d8ee-2556-497d-be81-2865b576a377"
      ]
    },
    {
      "cluster_id": "13d62766-9dfb-443f-a0be-897b64b65358",
      "members": [
        "922400ce-ba75-4f8f-a222-f8cb9e8ff341"
      ]
    },
    {
      "cluster_id": "e281f767-6c47-4711-ad9a-1c5709e1cb60",
      "members": [
        "26df25ea-ebb8-4523-b4f6-0e534c9ae98a"
      ]
    },
    {
      "cluster_id": "14a22666-bc11-493d-b981-1e91858f0777",
      "members": [
        "9f2c235c-00dc-467c-bda5-b638f7d5931f"
      ]
    },
    {
      "cluster_id": "7ea6c0c9-c370-4e5d-93ff-344450b01dd4",
      "members": [
        "618c034b-41a8-4f29-a823-8e13421cc4fb"
      ]
    },
    {
      "cluster_id": "fdf8116a-82e6-4a25-a819-a71aa4bc112a",
      "members": [
        "98f18c47-1019-4558-afd0-14a46c1a1b53"
      ]
    },
    {
      "cluster_id": "fe528005-ab2e-4ef9-9304-cfd861dc09be",
      "members": [
        "b249d910-8a47-4262-8dc7-297740f4a7a7"
      ]
    },
    {
      "cluster_id": "f92a441b-bffa-4b5d-a3f4-495ad67f7ccf",
      "members": [
        "10105712-0635-4e4a-8fcc-db4546350110"
      ]
    },
    {
      "cluster_id": "6e7eeae9-331c-4977-a841-a2cc08dd5381",
      "members": [
        "1ff3eb76-86fd-4185-9efe-c263bc93099f"
      ]
    },
    {
      "cluster_id": "29ce98a7-4a68-4b4f-be7a-d7b325128299",
      "members": [
        "21bd8c67-264e-42eb-8b0e-db6c24c5c21c"
      ]
    },
    {
      "cluster_id": "2c1c9214-d791-4513-8352-ad5103d53749",
      "members": [
        "0cb2ce22-eec1-4086-8d9d-aeffcdc506d7",
        "1dc02e1c-809b-457a-8693-035cb92127e6"
      ]
    },
    {
      "cluster_id": "47a07292-bc3b-405d-8d76-2c61690495c1",
      "members": [
        "f19197e0-4097-457f-8a6f-30ca2c690b11"
      ]
    },
    {
      "cluster_id": "e4d10cca-580c-41e1-9918-7376d930bfa1",
      "members": [
        "42add791-b448-41e4-b232-feb4502ab26c"
      ]
    },
    {
      "cluster_id": "ed814054-66d7-40f4-897b-99909fd4d531",
      "members": [
        "da01f00d-df9a-44d9-bb12-f41c09aed89b"
      ]
    },
    {
      "cluster_id": "1479c6ff-179b-497f-9932-93213bb53a6a",
      "members": [
        "5a816559-a964-4ecf-a8d4-147202021cee"
      ]
    },
    {
      "cluster_id": "088ae3ae-ad79-4cbe-9205-0c7fb4deef45",
      "members": [
        "8cada1de-aec0-4ba8-97e5-04e36d363054"
      ]
    },
    {
      "cluster_id": "ed693943-5db4-4907-b797-9fccd8ed73eb",
      "members": [
        "9bcf8d43-87e4-411f-8731-00fa3640de8d"
      ]
    },
    {
      "cluster_id": "2f8e700c-1460-4a5f-9578-58c60978917b",
      "members": [
        "75f2c098-7112-4a25-8031-e3a6116f5af5"
      ]
    },
    {
      "cluster_id": "34a2bc3b-8f85-4670-8f29-4e2b139366de",
      "members": [
        "a55c1b2e-bab8-49b4-ac95-ac161af5ec93"
      ]
    },
    {
      "cluster_id": "14ef59ab-f50d-4bc9-bdf1-1bc17697f5a4",
      "members": [
        "4e0bbe89-492f-4dfa-be07-cd56528fc90b"
      ]
    },
    {
      "cluster_id": "7e7c3417-e29c-4641-b1be-5336c04805ff",
      "members": [
        "0d8ba46f-3371-4146-b302-4566ce200350"
      ]
    },
    {
      "cluster_id": "b61e836a-7b6e-4f27-85e3-ad2994cac010",
      "members": [
        "c81fe284-1d56-4884-b3a3-e8ed8c832f00"
      ]
    },
    {
      "cluster_id": "48edb9b3-6de4-47d0-956e-e07e3a6cbfda",
      "members": [
        "316f2580-65a7-4aae-97c7-ab89b390be62"
      ]
    },
    {
      "cluster_id": "bc073191-5c75-4ed9-b991-437755cb3cd0",
      "members": [
        "6e529b19-2c91-444a-bb36-d523d8781149"
      ]
    },
    {
      "cluster_id": "e4695f74-046d-460d-a794-197c7df92c76",
      "members": [
        "75cbabf8-745f-4fc9-bd9b-38f0fc91ea4b"
      ]
    },
    {
      "cluster_id": "f53fc0bd-981e-4236-b0fe-25581f5f427a",
      "members": [
        "a2e3ed81-ed7c-4eac-b0c7-03c8d993a25e"
      ]
    },
    {
      "cluster_id": "3c292204-fc50-446f-99ed-6fd49056a887",
      "members": [
        "87c2241d-5cb0-4f5c-923e-09dfac33f675"
      ]
    },
    {
      "cluster_id": "21df275d-4ad2-4f7b-841b-bbaff7511134",
      "members": [
        "c45886e7-dc61-4725-8d00-6f8b9809f869"
      ]
    },
    {
      "cluster_id": "6eae5590-4ea2-4d5f-b4f2-a402cc15dbc9",
      "members": [
        "69044bfe-47b2-4ba7-a16d-a09a754a0188"
      ]
    },
    {
      "cluster_id": "12b80aca-12ee-4bab-a55e-bbfec7c756c7",
      "members": [
        "b6b5be45-4cbf-4a44-a03e-37809ce8f12e"
      ]
    },
    {
      "cluster_id": "2c6c7495-70ee-4e85-b85f-579b0d1c01ac",
      "members": [
        "cb892764-de04-416d-bdc1-9ef20b1cff7d"
      ]
    },
    {
      "cluster_id": "94476e0e-60e0-40ca-89ed-b2626dba60d7",
      "members": [
        "7392faa0-a150-4dba-b56e-4c4d39dc7010"
      ]
    },
    {
      "cluster_id": "03bed382-9ecc-4f84-bd88-6ff53d1b8a13",
      "members": [
        "3f4eefe0-a285-45ea-8839-1c7e19cc039f"
      ]
    },
    {
      "cluster_id": "1351fc52-175d-4410-b8b2-ff88c7747912",
      "members": [
        "121be1b2-8931-49a8-bd34-ebed27987497"
      ]
    },
    {
      "cluster_id": "75d93b8c-bf4b-43d0-94ef-7db799889fc5",
      "members": [
        "24544b2e-6718-43dc-829c-de46e2861ae6"
      ]
    },
    {
      "cluster_id": "019a6206-d313-408e-aa7d-dd9ebfe68ec1",
      "members": [
        "b10a4c06-189b-4684-b12d-ef17a210f307"
      ]
    },
    {
      "cluster_id": "bf1a6f6c-5e34-4a7f-9afc-2b63e460cf67",
      "members": [
        "cb9c24bb-09fe-44c3-a42c-c14e13eb9174"
      ]
    },
    {
      "cluster_id": "9fb4d80f-a91c-46b0-856b-b4507d71a702",
      "members": [
        "2cb8d986-13a4-4fa7-abe9-aa38098c38e4"
      ]
    },
    {
      "cluster_id": "6e25bc0a-2c7d-47cc-a81b-58dba523595b",
      "members": [
        "c2acff46-466e-4233-bfca-55b8dc61128e"
      ]
    },
    {
      "cluster_id": "ee08d940-570d-46a5-a30d-731f0f242ab4",
      "members": [
        "15b5725f-bc53-476b-8f02-9e2be6e1a862"
      ]
    },
    {
      "cluster_id": "68dfb31b-7f13-4eb1-b5bf-740e6918f0ee",
      "members": [
        "10a3df8f-584c-4799-8f82-c3f4d6d0b7d7"
      ]
    },
    {
      "cluster_id": "9cef1461-4ccb-4b2f-8a1e-1d71ef404be6",
      "members": [
        "4d2183f0-82c6-4df9-8187-fa672a4fb201"
      ]
    },
    {
      "cluster_id": "d0a50ea8-30f3-4820-8087-1083e0d5b05d",
      "members": [
        "7476149c-2f26-41e2-b83b-793fe442956c"
      ]
    },
    {
      "cluster_id": "7763c9f8-5bc5-4b00-83e7-8687863ffb36",
      "members": [
        "5529ee13-0c0a-40d8-a3c2-aaa819adc808"
      ]
    },
    {
      "cluster_id": "1484b9dc-5ed0-4d22-945e-34e17801439c",
      "members": [
        "bf9df6e7-1986-4c04-bd62-320f195b6453"
      ]
    },
    {
      "cluster_id": "fcff6be0-ae06-401d-8c01-25c7bfff466f",
      "members": [
        "d099c61e-1609-48c0-8e30-c260de609e9e"
      ]
    },
    {
      "cluster_id": "71920f88-d391-4321-a826-7f3d2ac6a5db",
      "members": [
        "9ebe3258-70a3-47d1-b749-005bc04bdb2c"
      ]
    },
    {
      "cluster_id": "a1591642-57e8-440b-a466-b4c02f9a6be6",
      "members": [
        "3cfb3615-e7f1-4836-894f-7ed0d170c634"
      ]
    },
    {
      "cluster_id": "dae2bae7-bdb4-4c33-b539-e09ed08a3e11",
      "members": [
        "7341ff10-94e4-4f2c-99ca-69e035432945"
      ]
    },
    {
      "cluster_id": "afc9e303-f841-4627-a50f-c58cb00a2220",
      "members": [
        "4173bed8-d09d-4a99-baf2-6806725ecf32"
      ]
    },
    {
      "cluster_id": "55bb591f-ecec-4f30-84a4-1528326dbb84",
      "members": [
        "eb0ebcb7-de5a-46d1-aa61-3144f6040af2"
      ]
    },
    {
      "cluster_id": "8d28e81a-99f1-4b51-9eec-891947b08d71",
      "members": [
        "fa9cfb6f-bb9e-4ca8-86b4-3aa13f3288f8"
      ]
    },
    {
      "cluster_id": "cbce7506-b8ff-4232-9cb2-70afae134899",
      "members": [
        "baa30782-ad77-4b2e-9e57-4310d3a8ab29"
      ]
    },
    {
      "cluster_id": "fdf0468f-b20d-40b0-8a2a-5519d8086286",
      "members": [
        "93eeec64-dd20-4d3c-85ae-53b9f9492d59"
      ]
    },
    {
      "cluster_id": "fcd2863d-6523-42c5-86f2-9d70faca5e49",
      "members": [
        "c41b050b-1bc4-4d61-8530-280de69289ef"
      ]
    },
    {
      "cluster_id": "1f2e46b4-6012-4c4f-8e36-ebb4e20f881f",
      "members": [
        "fc1016ac-2073-4906-8e3c-1ada64d0efed"
      ]
    },
    {
      "cluster_id": "3cb67525-0d0d-4f1e-8f2b-d44f7e022019",
      "members": [
        "83715690-0689-407f-9183-ed0c09ae668b"
      ]
    },
    {
      "cluster_id": "e078499d-145e-47da-8902-0b8d9b181179",
      "members": [
        "71d8f507-dd09-48b2-a6ac-51f4219d35f5"
      ]
    },
    {
      "cluster_id": "4a433aaf-8b78-4d61-9c2c-bc9bf2bfa734",
      "members": [
        "f68bdad8-0be6-4339-bc36-f6095a91184f"
      ]
    },
    {
      "cluster_id": "bd325bb2-82ff-445b-9556-5c3579998b1b",
      "members": [
        "e07db0a8-30ba-47c9-8e98-8e58bdb237d0"
      ]
    },
    {
      "cluster_id": "b87380f4-8f89-424b-8739-272a52634814",
      "members": [
        "997279b1-98ed-426a-8f71-1dfe00c0cfc3"
      ]
    },
    {
      "cluster_id": "07e2576d-9585-4de1-8fed-5653ce340f18",
      "members": [
        "6f851f63-6752-4173-9f20-a83b89928c7f"
      ]
    },
    {
      "cluster_id": "1122df81-54b6-4861-86f2-c9908073053f",
      "members": [
        "ee48e0ea-0842-4c9e-b212-24a573dfe883"
      ]
    },
    {
      "cluster_id": "b21b063b-f7bc-4014-8dc5-34ae0d688761",
      "members": [
        "088e6079-22cf-4c60-8f79-e7bf4be92bc8"
      ]
    },
    {
      "cluster_id": "05a27be4-d98e-42f1-b3e3-bf60c499f807",
      "members": [
        "0f74ee7b-f75b-4e23-8554-9d4fd3997e45"
      ]
    },
    {
      "cluster_id": "6fdf651c-dbd2-4ed4-85b1-ba8e9916ed27",
      "members": [
        "dc4d58b6-b6a5-4e33-8113-1104de0660cf"
      ]
    },
    {
      "cluster_id": "ec9f289c-28f3-4c8f-8168-260fc03a8183",
      "members": [
        "1626dc53-6141-43e8-b9d3-3cf657bec12b"
      ]
    },
    {
      "cluster_id": "6d9e58c9-dbd4-4963-8fe7-594077a6324e",
      "members": [
        "fc7fa7f8-d6aa-46a0-814f-d7777e07ee50"
      ]
    },
    {
      "cluster_id": "86d55ce0-7b54-4708-b491-af72b9d9ff06",
      "members": [
        "c446fa31-103d-4be7-a20a-9fdf249fee0c"
      ]
    },
    {
      "cluster_id": "778d39fb-527e-42ad-a678-aa372a58fc39",
      "members": [
        "50229a45-d8db-4d1a-b9aa-633cced12c5a"
      ]
    },
    {
      "cluster_id": "45dc7d2c-74e1-4100-9b06-cc0f631f56f5",
      "members": [
        "b5b1f2ce-8e67-4fdd-9274-0fda8fb105d3"
      ]
    },
    {
      "cluster_id": "b059c11d-95fa-4f8b-93e3-1c4f21e60f61",
      "members": [
        "91a10dc8-8b8a-42ef-b656-40c78c73476b"
      ]
    },
    {
      "cluster_id": "acda69bd-2a78-45aa-a6fc-5eeaa0b45f28",
      "members": [
        "2f44b72b-9ed9-4836-a422-74659e144491"
      ]
    },
    {
      "cluster_id": "8f3f9d3c-bc51-4937-8cc3-be36bcc68b12",
      "members": [
        "3ca2f12a-dda8-4f5e-aeb4-350f5128b99e"
      ]
    },
    {
      "cluster_id": "186e2ceb-09a9-47a1-9aac-0510446000af",
      "members": [
        "742b16e2-457f-4473-89e7-7d79fc6a6162"
      ]
    },
    {
      "cluster_id": "d635b0fd-8741-49c9-a6f1-294159c206bd",
      "members": [
        "37725301-cd6c-4f8b-ba53-7ac89bb7d93c"
      ]
    },
    {
      "cluster_id": "7eb16fe5-1729-42a0-bcb4-1a4783656ce6",
      "members": [
        "619d943c-5d2a-4a21-a577-d21c72210782",
        "9c0f6744-34e1-4673-b6d4-390fb27b1a9e"
      ]
    },
    {
      "cluster_id": "867afc59-5780-42ae-88e7-83c90a074b4d",
      "members": [
        "2325e83b-a7fe-400a-968f-882df203a73d"
      ]
    },
    {
      "cluster_id": "7598667f-d0d3-42d2-856a-51698f3f1b3c",
      "members": [
        "27fc317a-76e6-4e92-8463-532e1c1889fd"
      ]
    },
    {
      "cluster_id": "f6680d6a-ecb6-41e2-9526-051a689d4c68",
      "members": [
        "5ab691c3-fa6b-46e5-b127-a5ce5a000062"
      ]
    },
    {
      "cluster_id": "52f4f571-7b22-4977-98bd-7282b2a6c5c5",
      "members": [
        "1ec3575f-6c04-469f-92c5-ba4d89f117de"
      ]
    },
    {
      "cluster_id": "5cf38b83-9e7d-4021-9751-cdd7c1a0b38d",
      "members": [
        "99f1753a-60d3-44ab-bb03-dd91fc18e35a"
      ]
    },
    {
      "cluster_id": "65657196-d0ff-4d4a-a7ff-868fd5f099d9",
      "members": [
        "de4ab1ba-1dad-4112-ac67-2abf280c8f37"
      ]
    },
    {
      "cluster_id": "1b374305-b708-454f-b63c-7ff8ae988cdd",
      "members": [
        "2a2c3af2-a77f-4bfa-8412-7dfd2714a7fd"
      ]
    },
    {
      "cluster_id": "e8c99cdd-553e-4aba-b844-e1556f7a8787",
      "members": [
        "7a402d5d-a0ce-4678-be45-af2e707a57d2"
      ]
    },
    {
      "cluster_id": "1bf0340c-7a77-4298-96fe-bdb20d7a37a7",
      "members": [
        "43fb4834-7616-44da-9a18-09041bb3b486"
      ]
    },
    {
      "cluster_id": "6363c274-1e0e-4e09-85b0-1412131b0c25",
      "members": [
        "6b8e73d8-6258-42aa-92a4-ff23daec341b"
      ]
    },
    {
      "cluster_id": "5d1b0403-1447-4432-b6a8-ce335ce3e162",
      "members": [
        "0bb3c38e-09ef-43eb-891c-1d85703bde14"
      ]
    },
    {
      "cluster_id": "b961ace3-c2b8-4138-bb7c-fb147b603dc5",
      "members": [
        "81456b8e-23b0-4a74-8743-2e58b6813f55"
      ]
    },
    {
      "cluster_id": "1e3f8e4e-4dfb-43fa-ad30-aa52542d5f06",
      "members": [
        "916ebf00-2e5e-46fa-b5de-8ee2ca328a22"
      ]
    },
    {
      "cluster_id": "4fe16db2-c3a7-4835-89e2-e57d5e214582",
      "members": [
        "2ccb1cd7-4eca-4a60-9da7-b509302d44b6"
      ]
    },
    {
      "cluster_id": "039f8cf2-d1ad-441e-b62e-9a9fe0c8c803",
      "members": [
        "5fd1dbf4-f4ae-4bb8-9195-ea964920209d"
      ]
    },
    {
      "cluster_id": "b13b5ee0-1421-43e8-a554-5b3888a5cac7",
      "members": [
        "248a9bf7-40f3-4da9-863a-6d903eea0663",
        "75e60699-cc61-4e72-9d34-3786cbed846c"
      ]
    },
    {
      "cluster_id": "470e1b16-db3d-4438-9038-d9ecc0d37edf",
      "members": [
        "2e75e421-b3fc-47fe-9ef6-09d2d33af214"
      ]
    },
    {
      "cluster_id": "7e303676-78ac-40b1-9448-471faabb2115",
      "members": [
        "a0fc6d93-fe8c-4e8e-a8d7-9e45d64c7ecb"
      ]
    },
    {
      "cluster_id": "f1bddab0-3986-4a79-a51e-8622615c23c4",
      "members": [
        "9d6d3d56-0ee4-44b5-a102-774c5e33a91e"
      ]
    },
    {
      "cluster_id": "6e773145-449c-40f0-969b-2f16d4a7c04f",
      "members": [
        "8a163198-c8d4-4b88-a7bf-cd5fc98c4160"
      ]
    },
    {
      "cluster_id": "8b7f2a67-267c-4f34-bf57-216f33b13adb",
      "members": [
        "0e0ab341-4bda-4673-a025-971a69075eef"
      ]
    },
    {
      "cluster_id": "6351b28b-a685-4d75-9a62-c954df9226b0",
      "members": [
        "b37c3cac-8bb5-460b-b7d2-eb33414b5fc7"
      ]
    },
    {
      "cluster_id": "5ac468f5-649c-43da-ae88-dccb98a0bb4f",
      "members": [
        "24b15dbd-56ea-4ece-a1b0-5aa688b711f6"
      ]
    },
    {
      "cluster_id": "dcf0cb56-59c5-419e-a7a3-57fc57640ce0",
      "members": [
        "788ab935-4533-44cb-bf0b-926954d8bf02"
      ]
    },
    {
      "cluster_id": "0a2e15ba-2fa7-41ed-a5c1-17b66869fc7d",
      "members": [
        "11f22217-1c3a-4534-bd5e-df89b12c7750"
      ]
    },
    {
      "cluster_id": "674305e3-342c-4b85-8170-13a2aefe9456",
      "members": [
        "69bfde9f-78f1-43f8-9ea2-86df6169332b"
      ]
    },
    {
      "cluster_id": "95cbf6a7-3664-47e9-8189-3ff3dc6eb96e",
      "members": [
        "fc645500-a1c3-43be-aac2-10992f86dcd3"
      ]
    },
    {
      "cluster_id": "350bc7fa-e017-468b-abf6-4d1ab1633f69",
      "members": [
        "bdb671dd-0d75-4f91-ab6e-132ae191b45e"
      ]
    },
    {
      "cluster_id": "eaf97e4a-55db-4cdb-ae4f-9ab8ecb7e821",
      "members": [
        "70da26a2-352f-4784-974f-a96926d40818"
      ]
    },
    {
      "cluster_id": "7c7cd464-a285-4810-881b-7a151a564ae1",
      "members": [
        "722ff441-3624-4290-9633-b6e564f438d0"
      ]
    },
    {
      "cluster_id": "9a04913f-01c4-45fe-aacb-81aaa1af85ae",
      "members": [
        "055d0702-1678-42d0-962d-d04f89cdfd1b"
      ]
    },
    {
      "cluster_id": "bc3691bd-e8ea-4667-b6cf-1afd5eb88fa6",
      "members": [
        "12e8d861-ad53-4863-bde6-fe0e33ffe000"
      ]
    },
    {
      "cluster_id": "ff2e5690-b7e6-4963-9d4c-23d9e31d0e98",
      "members": [
        "3444cd08-df07-4dd7-8622-dc2db9e5f4ea"
      ]
    },
    {
      "cluster_id": "5d61b2e4-bbeb-403f-8746-07ecabf64059",
      "members": [
        "87e0fdc9-8c76-40a7-ac4e-4676e5f4d10e"
      ]
    },
    {
      "cluster_id": "32c73de2-95e1-45f0-9627-537de9f0f318",
      "members": [
        "cb08a76c-10e2-4478-aa20-448daa882f86"
      ]
    },
    {
      "cluster_id": "ea3f4ed4-bcaa-40a7-96c3-82beaa656b16",
      "members": [
        "d7f48cfd-8d2a-41e9-ab1e-b1b3ebea5857"
      ]
    },
    {
      "cluster_id": "b9b30a00-8e82-4f2f-9524-8cbb18357bed",
      "members": [
        "770c002c-9b9c-4946-b141-beb31de606de"
      ]
    },
    {
      "cluster_id": "d342ed30-fc56-4887-9c80-98861f47054d",
      "members": [
        "56a021c2-c9ff-43e5-996f-c6d7ec23a91b"
      ]
    },
    {
      "cluster_id": "81889b4e-a54e-4052-b2de-56a05ad20bc2",
      "members": [
        "cb168328-3638-4a2d-ac14-48401092d43a"
      ]
    },
    {
      "cluster_id": "49c36ab4-aedf-4b49-9372-e43ee616873e",
      "members": [
        "2849b109-7dcd-46b5-9a90-5d44ec00e9c7"
      ]
    },
    {
      "cluster_id": "32fafc3d-cccf-4a0c-872b-788d937b0241",
      "members": [
        "f2507425-09cd-40be-9ca3-40f697844728"
      ]
    },
    {
      "cluster_id": "64911a50-55cc-400d-9f35-d372b869e1a7",
      "members": [
        "f6ef2b20-ecea-4c28-ae8e-e31bf9960385"
      ]
    },
    {
      "cluster_id": "a850938a-0d12-48b8-a366-a53a16388dbb",
      "members": [
        "a23f5f77-f0d2-4767-97ec-758c1d52ff48"
      ]
    },
    {
      "cluster_id": "f629a198-d535-41eb-8981-0a2a15fcbcb9",
      "members": [
        "cc33b652-dc5c-4d0f-96f9-841a4ed6c523"
      ]
    },
    {
      "cluster_id": "fc55d0f5-c78b-4a1f-a7f3-73448361d186",
      "members": [
        "40077f46-8f07-4aaa-a346-c4a3699dafd4"
      ]
    },
    {
      "cluster_id": "6bf20e7d-0fef-44de-a032-0b603b235bf7",
      "members": [
        "016b4f58-0480-4b0b-a396-5e410315f527"
      ]
    },
    {
      "cluster_id": "63217c83-a56a-4703-b9b6-f928b5437b8a",
      "members": [
        "62a49154-df4b-4a91-a074-6ae7072d7d08"
      ]
    },
    {
      "cluster_id": "2d644f06-03ca-439d-b2dc-c42a08782eba",
      "members": [
        "95d37594-6ae4-4bd5-b088-9925445a3fbe"
      ]
    },
    {
      "cluster_id": "51b63d4e-9a9e-4f49-a1a8-d50a9f8eff02",
      "members": [
        "27241f85-fa16-4ac4-a8b7-15b736e792b8"
      ]
    },
    {
      "cluster_id": "42899209-2504-48c5-8694-2bf64d4edf90",
      "members": [
        "7754564e-329f-4dd9-8f29-c0a8ada7e40c"
      ]
    },
    {
      "cluster_id": "967932b9-89a1-4f1a-8846-57c7efec1e1b",
      "members": [
        "0b3347dd-ff45-4789-ae4d-123e9ce44041"
      ]
    },
    {
      "cluster_id": "acde1f80-8000-4b4d-8e9d-7d24f15b41d9",
      "members": [
        "ce6b82ae-c945-45da-84eb-0cf1f30cea4d"
      ]
    },
    {
      "cluster_id": "4b702552-6558-458e-b6a8-ec2e141d7258",
      "members": [
        "eff50442-47e8-4b6c-be30-a7d2f7ffca40"
      ]
    },
    {
      "cluster_id": "75ded654-747a-4edb-9577-5b6d8ad0c3a1",
      "members": [
        "636d36e0-43e5-47d3-936b-6007b9f3d49b"
      ]
    },
    {
      "cluster_id": "498d40d5-5e43-40ad-a2cf-e0c8dead042f",
      "members": [
        "42c05943-b9ac-4ead-bb6a-948856fc47af"
      ]
    },
    {
      "cluster_id": "4fd61797-afb1-460e-913b-0445bfe516c3",
      "members": [
        "7d4dfb1c-7fe3-4a96-8bdf-09d038389f7a"
      ]
    },
    {
      "cluster_id": "d223b5e1-de75-49e7-9d5b-0ab4514a4ec6",
      "members": [
        "a1bc332a-893a-4b04-bcfc-a272cfefd776"
      ]
    },
    {
      "cluster_id": "83b65fa9-1a4b-4243-9c39-2ff350a46323",
      "members": [
        "c47450ff-8e1c-4402-abce-e241cb06f390"
      ]
    },
    {
      "cluster_id": "7c123398-3043-4df1-bb86-5ded4584dc33",
      "members": [
        "a9e63a08-bc8c-44ad-a902-ff7af830b08c"
      ]
    },
    {
      "cluster_id": "5dc7d30c-f418-4e0a-bf24-d3caf57c0ec4",
      "members": [
        "73cfe112-4ba5-4214-a482-67a9a39b4768"
      ]
    },
    {
      "cluster_id": "9aa4bb60-c9b0-4bd6-9189-bb33a4f61778",
      "members": [
        "5f02da39-e150-40f8-948c-4977f9916faa"
      ]
    },
    {
      "cluster_id": "66420625-d310-4fd9-aca9-82e4fec83c68",
      "members": [
        "b640d8ba-898d-4f84-aeb2-2da68325a5c4"
      ]
    },
    {
      "cluster_id": "04675e2c-1e61-4971-b87b-4cddc78fd434",
      "members": [
        "ed7c927d-f12c-4123-b39e-593052cb5b1e"
      ]
    },
    {
      "cluster_id": "19e2179d-5af7-4b00-a62f-bafff28190d0",
      "members": [
        "2e4f5cbb-4aee-44db-b53e-1ac19783f8f4"
      ]
    },
    {
      "cluster_id": "e0dcc7af-9cb5-4c1d-b108-5d8de64148cf",
      "members": [
        "3166f662-04a5-4569-b8ef-e4a13f9635b1"
      ]
    },
    {
      "cluster_id": "a1e41680-35e4-4649-8fd5-66b72c5b42b9",
      "members": [
        "a9d7cb0f-ef46-4fd0-8eae-149d9bc36c77"
      ]
    },
    {
      "cluster_id": "d5f473e8-ffa8-45f6-bee7-fb81681c241a",
      "members": [
        "f5968a16-3ae9-4016-a310-331ee57638dc"
      ]
    },
    {
      "cluster_id": "6a2d22fd-b7e4-46b8-aa28-69039af2d9e4",
      "members": [
        "79da912d-dbc1-4ae6-bd23-28e93c64cffc"
      ]
    },
    {
      "cluster_id": "c320799e-ed57-4715-bbb9-1237e2fe3842",
      "members": [
        "5f8c89ed-c59f-43ea-8fbf-f1fd778aaeba"
      ]
    },
    {
      "cluster_id": "51212bcd-93a4-4cdc-afe3-422f70697f65",
      "members": [
        "44320b4b-b5f5-4371-b8cb-e0bab284904e"
      ]
    },
    {
      "cluster_id": "157ed6bf-eaaa-4513-ad02-a2a99adf039a",
      "members": [
        "83a28186-9fc4-4973-89fe-3045be17f87c"
      ]
    },
    {
      "cluster_id": "dd33f241-05d1-4f54-b214-172163f88f9a",
      "members": [
        "3f13e771-2787-4f74-878d-01ec9328e304"
      ]
    },
    {
      "cluster_id": "01d3c9ca-6075-43cb-a3ac-1d6094f7282d",
      "members": [
        "d059b70c-37c2-47c2-8675-75a805809e38"
      ]
    },
    {
      "cluster_id": "e8b94f0c-0366-40d5-b082-fa52ed608677",
      "members": [
        "8e1f7e07-8213-400a-914d-0c01cae6ccea"
      ]
    },
    {
      "cluster_id": "8817a4d0-4aef-4c0e-a907-ff92179dff0d",
      "members": [
        "d6e42b72-be4b-464e-b7c4-f3d17051dbf8"
      ]
    },
    {
      "cluster_id": "b21610b3-aecf-410c-9995-b99b144c12b1",
      "members": [
        "09d344d6-907c-472b-b21a-e2d032b8b503"
      ]
    },
    {
      "cluster_id": "ecb10f6a-8831-4846-bf71-113659233f12",
      "members": [
        "dc8edab8-f7ea-4d28-8264-ac56b6c65571"
      ]
    },
    {
      "cluster_id": "e297a044-750d-493d-8fab-439c72fd77f6",
      "members": [
        "28449dff-ab57-4dc5-9bbe-718511d0beac"
      ]
    },
    {
      "cluster_id": "c41f696e-07f9-4e6f-84a4-bbc219b21f87",
      "members": [
        "9a8a3eed-fab6-443e-a46b-9adb0b65aab4"
      ]
    },
    {
      "cluster_id": "b53434f6-8475-4084-8547-bceb679687ac",
      "members": [
        "9eeac9e1-1f53-42bc-89f3-a3971a645d0b"
      ]
    },
    {
      "cluster_id": "bac2fa35-75bf-4c16-a00a-24bb7ad1ff15",
      "members": [
        "9f19ec7f-44a6-4225-9fe9-d4b4160833e9"
      ]
    },
    {
      "cluster_id": "b4243b24-8de4-40d1-8e27-1dec1612406d",
      "members": [
        "5acdcdd3-cfc6-4837-b656-f34ca3d48661"
      ]
    },
    {
      "cluster_id": "22a9a9e1-a369-4cff-a2ae-69fa0403d590",
      "members": [
        "b92cc24d-296a-48a1-a7b2-fa3c54829c4e"
      ]
    },
    {
      "cluster_id": "1e9089f3-b7e2-4ef0-870f-afca46689fbf",
      "members": [
        "0bc5430a-3aa3-435e-9c11-e70b0e7ec6c9"
      ]
    },
    {
      "cluster_id": "080cf60d-e4c8-43d3-806b-a47256c29458",
      "members": [
        "249bb7f1-30c7-450e-8e4f-789fd79f5cf5"
      ]
    },
    {
      "cluster_id": "90309cf4-c7b2-4dbe-a694-62efd0012476",
      "members": [
        "2fc74655-a5b5-4262-89fb-72ae40f44418"
      ]
    },
    {
      "cluster_id": "37b4342a-fb0a-4dc5-96ce-db0bc15c1568",
      "members": [
        "13de59f0-aa18-4f33-a9e8-a1421ebb700a"
      ]
    },
    {
      "cluster_id": "651192ce-035f-4e17-8834-956bf8fefc33",
      "members": [
        "add2b4cf-c6e3-45ea-a301-649db7e48b58"
      ]
    },
    {
      "cluster_id": "8cb3d3c4-596a-4d19-9190-9681300abd40",
      "members": [
        "7c8dbfe9-4904-44b4-a304-26ac404eebc5"
      ]
    },
    {
      "cluster_id": "4fdc1bfa-2d9c-4f20-8628-a8f4ff72ccc1",
      "members": [
        "c9805034-b42f-4db1-86d3-68bfbc00296b"
      ]
    },
    {
      "cluster_id": "af917a84-5c51-4c7b-9efd-b1ddeecaeb3a",
      "members": [
        "a17def6a-a457-4e97-8d32-baf304f29c7f"
      ]
    },
    {
      "cluster_id": "519bca7c-733d-466e-b332-2cb930d5c9b0",
      "members": [
        "9a2c6e26-52bf-41c9-a7ca-4c5324135706"
      ]
    },
    {
      "cluster_id": "9bb19a50-cefb-44ce-9b28-e30fd2969d96",
      "members": [
        "95e68321-4757-42ae-bd68-b039cda7ef8b"
      ]
    },
    {
      "cluster_id": "bca4fab8-15f6-4111-ae92-b37f9696dd06",
      "members": [
        "a58798e9-6101-4ef5-ae6e-77e43a751d70"
      ]
    },
    {
      "cluster_id": "0b6b6a97-32f4-45c7-ada1-27e50504dcb5",
      "members": [
        "68cb46dc-d705-4372-9682-85134cf51860"
      ]
    },
    {
      "cluster_id": "533c13a6-e2bd-46be-9422-2e368c4b5793",
      "members": [
        "6a3a9b49-a121-4d77-9bf9-605d700fc9fc"
      ]
    },
    {
      "cluster_id": "b1375511-e3be-4083-816e-ce6ea23f39cf",
      "members": [
        "e057b111-30c8-44fe-9341-21d1472eee87"
      ]
    },
    {
      "cluster_id": "ac328a78-ba12-4fbf-888f-9c3c8967ccba",
      "members": [
        "07a758f4-3009-4887-9f52-6cffc024f332"
      ]
    },
    {
      "cluster_id": "6bdf1a93-76ba-4948-be05-d02fbb6488f4",
      "members": [
        "b572c1d4-063f-470f-b701-dbc590cfba2f"
      ]
    },
    {
      "cluster_id": "7f23e350-d82f-4791-a6df-263d08bac5c0",
      "members": [
        "016ecb78-c51d-4325-8a45-51c77774d814"
      ]
    },
    {
      "cluster_id": "83743532-1cd2-436e-9911-21445ed61af2",
      "members": [
        "cae2e348-f492-4176-9df7-4a6c0ff875c0"
      ]
    },
    {
      "cluster_id": "89fd947c-c029-4635-8b9d-ca8e953af1ce",
      "members": [
        "82d0ee32-e4ab-4df0-8159-0ab7318b0482"
      ]
    },
    {
      "cluster_id": "92102219-111c-4df9-82ec-b4c0a1a920cf",
      "members": [
        "fd20d16c-a389-464d-83df-7f273015c324"
      ]
    },
    {
      "cluster_id": "d6a1f200-a77f-4011-9cf4-4ff9dd9f9335",
      "members": [
        "d1bf9838-df80-44e2-82d9-088bb376a2be"
      ]
    },
    {
      "cluster_id": "99d7c1e6-04d8-4af7-b4d1-8b1bbaa99691",
      "members": [
        "21dd5abc-de08-4ba0-95a1-a69d8f1ff422"
      ]
    },
    {
      "cluster_id": "1dc64c65-d91b-4753-b1f9-a4cf4ca41268",
      "members": [
        "8e446813-8f7c-4b01-841f-0f4f41e401df"
      ]
    },
    {
      "cluster_id": "c9181b4b-e96f-49e6-ae73-b2dbaaa3fd9c",
      "members": [
        "9e783071-932d-44c4-b72c-073dde1ba831"
      ]
    },
    {
      "cluster_id": "49ea9af0-b84c-4f28-8cc0-a1e13e95b4c4",
      "members": [
        "0c49a33e-052f-49ba-bf55-1ae3ff4a816a"
      ]
    },
    {
      "cluster_id": "172a52ef-f6c4-4bec-a54c-6a0343aa0561",
      "members": [
        "9e55106a-7482-4706-a33f-a00cd680d924"
      ]
    },
    {
      "cluster_id": "f623c469-24ac-43e2-8e2e-e888031af996",
      "members": [
        "f4cc7d28-2245-4715-877f-7e297453bf71"
      ]
    },
    {
      "cluster_id": "9ff255c3-3bb1-4b2b-8446-496debbb40e2",
      "members": [
        "14934671-25ef-4fcb-ac30-7e7a0a24bc5e"
      ]
    },
    {
      "cluster_id": "a5d642f3-ce31-48e1-93c2-529f31b5ca8c",
      "members": [
        "af0e6a14-792c-405d-b028-abba5677a364"
      ]
    },
    {
      "cluster_id": "0d4d1a0e-a8fb-4f12-a4b0-63f68ad14434",
      "members": [
        "f709e126-d65f-4650-8f20-26c6f29e7376"
      ]
    },
    {
      "cluster_id": "4d99bd96-2995-4ee1-aaa1-1e78c622a4c4",
      "members": [
        "0d50ed39-c695-45a0-adf1-647e9acb58b6"
      ]
    },
    {
      "cluster_id": "d7349c27-6262-43ce-9388-35b7e8a7c225",
      "members": [
        "cc964293-43dc-4ac6-b3f6-64826eb075e3"
      ]
    },
    {
      "cluster_id": "d56b27d7-daff-43e9-8fd0-8b6cd93b5536",
      "members": [
        "aee0d9b5-873e-4876-8143-ded63ba56d81"
      ]
    },
    {
      "cluster_id": "75ca701d-5dd3-4eb2-b641-e9b6d4316367",
      "members": [
        "17021d81-1db1-4e4b-bfec-2b8ab480913a"
      ]
    },
    {
      "cluster_id": "a5ff0407-3f9a-4c9e-b0e5-8fe919998cf3",
      "members": [
        "f37a2d41-3591-4675-b8b3-45aecfd0c1b7"
      ]
    },
    {
      "cluster_id": "a64b48c8-6765-4ea4-add1-20cd675e1418",
      "members": [
        "d24b3f28-0f8b-4a28-8b04-e32be4bb071d"
      ]
    },
    {
      "cluster_id": "59f7148b-b06f-4868-866d-00139a58abd6",
      "members": [
        "0748ae90-600e-4ee4-bfe0-075c8f9e1544"
      ]
    },
    {
      "cluster_id": "a568feba-940a-47c6-8cff-f4910bd91144",
      "members": [
        "424761bf-f0dc-48e5-af5a-cac0413c3ec6"
      ]
    },
    {
      "cluster_id": "df593162-9ce4-4407-acdb-640e7602b7fc",
      "members": [
        "d5950ac7-0671-4798-adcc-972fdf905721"
      ]
    },
    {
      "cluster_id": "336f0b3b-fcc5-4691-826e-c234e38bf923",
      "members": [
        "fa95aa46-bb79-4138-86fe-7e6ab9b3242d"
      ]
    },
    {
      "cluster_id": "9914f862-3a85-4664-87c6-f266c89775cc",
      "members": [
        "79d35ee0-ac57-4239-b894-633b79dbbca3"
      ]
    },
    {
      "cluster_id": "1ac968af-25be-488d-9da9-e6211652dcfe",
      "members": [
        "1fa91e98-dfdf-4d17-a1c2-0e55453f5f68"
      ]
    },
    {
      "cluster_id": "4b3adf55-a27f-47ae-8d76-9cdeb5e8523c",
      "members": [
        "cee11ac5-ee9e-4d90-b6b8-a84a489a312a"
      ]
    },
    {
      "cluster_id": "4b620911-0006-4874-ad8a-a8595a7140e4",
      "members": [
        "a3b4508c-58cd-474d-8161-5429b8d23b20"
      ]
    },
    {
      "cluster_id": "053dfae5-6865-40c0-a285-b1e7c8cbaf44",
      "members": [
        "26dbb4b5-ff59-4c9f-815c-e1f87e0122c8"
      ]
    },
    {
      "cluster_id": "4468d3e5-ac94-44c3-a0b1-a59798ce1b28",
      "members": [
        "9517f92c-be11-4f77-b5ee-47c14548bfee"
      ]
    },
    {
      "cluster_id": "c770384d-399a-4efc-a9de-06d7ca1ea0d3",
      "members": [
        "b455d2a9-7776-47f3-bfc2-6bd1840b4e90"
      ]
    },
    {
      "cluster_id": "bdea90e6-def6-4640-876b-5fa83c1b85d0",
      "members": [
        "73a8a531-40d0-4db2-84e2-becc6fa725c6"
      ]
    },
    {
      "cluster_id": "ccffcdf7-168a-480f-bc2b-31955c7b549e",
      "members": [
        "216ca709-f69d-498f-b4f4-786c1e244b9e"
      ]
    },
    {
      "cluster_id": "1ba7e666-27ba-4d77-b5a9-dc9f10927af0",
      "members": [
        "4b51393a-45b7-443a-bff4-0a494e99f6c3"
      ]
    },
    {
      "cluster_id": "11246355-e976-4176-b4cb-550c91543955",
      "members": [
        "cbd4739a-100c-4f24-a7b8-c3247ecbca13"
      ]
    },
    {
      "cluster_id": "26db1e00-6a4e-4036-b6ff-c1da87b844b6",
      "members": [
        "a42bf906-e647-42b7-92d7-36ebf96c9b4f"
      ]
    },
    {
      "cluster_id": "eed368dc-e9d0-472f-90ca-6ea4839317c3",
      "members": [
        "c021dd4d-806a-4032-8bf1-7ebf4d93c3bc"
      ]
    },
    {
      "cluster_id": "ca3c690a-ee2b-4679-9ac7-f2f87ab00ae8",
      "members": [
        "c381469c-31d4-4198-b0b3-e812ef317ace"
      ]
    },
    {
      "cluster_id": "89669f9f-ac80-4abe-98e3-503ca9625f39",
      "members": [
        "8a295faf-9404-48e0-a62b-27c2f552136f"
      ]
    },
    {
      "cluster_id": "dd4be4e8-361d-46ff-9230-0b65d75e82b0",
      "members": [
        "93f0c2dd-8870-43fa-9452-41202cc779dc"
      ]
    },
    {
      "cluster_id": "e924815f-2da7-4209-b239-ad1c99e71b41",
      "members": [
        "0a6a1145-a3d4-4a65-ad60-e225a9c91c46"
      ]
    },
    {
      "cluster_id": "27d4950e-9d1e-4314-b5b5-7fcf43d21e72",
      "members": [
        "3134a2b8-f439-43c9-8be8-b77d0679cc74"
      ]
    },
    {
      "cluster_id": "3f9df2bc-6f72-4bee-88b2-8ddae64ca085",
      "members": [
        "bf33dd8d-4985-4073-8f29-e88dd634f265"
      ]
    },
    {
      "cluster_id": "02dbbaf3-2dcd-4ef2-b716-bd9080164205",
      "members": [
        "0ae7dfd1-35fa-40e0-9e47-14a3f14848bb"
      ]
    },
    {
      "cluster_id": "dcae5341-3559-46a5-8605-6aff132b23e8",
      "members": [
        "89e102d9-1bc7-4f63-bffd-7fda65291691"
      ]
    },
    {
      "cluster_id": "d301327b-e031-45ac-903a-5645a313fba7",
      "members": [
        "7c273f10-c8b5-434f-be52-45e323e4b064"
      ]
    },
    {
      "cluster_id": "460920ff-c88f-43ab-b704-4a3029ef5976",
      "members": [
        "0fbbb965-1633-4ea5-9ce9-928f175f5658"
      ]
    },
    {
      "cluster_id": "227678ba-993d-4003-9922-aa2e2a27ca74",
      "members": [
        "0efe9f04-6dda-42a8-987f-1cce1fdd533e"
      ]
    },
    {
      "cluster_id": "6cd94c1d-412f-4288-82d2-a9deb07dfbe3",
      "members": [
        "b9c1a642-6b35-4068-9dc3-d7b1c57c987b"
      ]
    },
    {
      "cluster_id": "9ef9723e-224d-4c57-9d96-bcf1933702af",
      "members": [
        "c3cd41e0-2bb7-4e09-b02f-d168d847ab28"
      ]
    },
    {
      "cluster_id": "14db711f-b761-4a49-a9c7-2b0c0895c032",
      "members": [
        "fbea327b-7fd0-40ce-beea-46f16a9dbf94"
      ]
    },
    {
      "cluster_id": "f1e3a565-29ca-414c-8fa2-90756a824cf2",
      "members": [
        "083aa95c-3d27-4a40-8b2b-c6dbb45571a6"
      ]
    },
    {
      "cluster_id": "88cb9dbf-3c86-496b-8c5d-43080d758d2a",
      "members": [
        "33f55771-cf51-4296-b261-8bcf53c93068"
      ]
    },
    {
      "cluster_id": "dd459c3b-7734-4c47-b440-fe088ff89835",
      "members": [
        "ba324eb4-9fbf-4cd7-b4aa-f8445cf55c58"
      ]
    },
    {
      "cluster_id": "f61ff023-8da9-4963-951e-7e62c4121c8c",
      "members": [
        "091ff2a4-b374-4426-a33d-f7e23441452b"
      ]
    },
    {
      "cluster_id": "b9b58ab0-89c7-43c0-9654-023c7dc7edd7",
      "members": [
        "24d78005-f0d3-4ce1-8a38-c5f713bfa53e"
      ]
    },
    {
      "cluster_id": "fa5cbe37-2f0a-489e-a2bd-a58e7dfa8418",
      "members": [
        "df94d9a3-14cb-4884-8808-85de69e39f11"
      ]
    },
    {
      "cluster_id": "3e491056-e070-48f7-a358-499c803ca16f",
      "members": [
        "d97816b9-dc50-4549-9310-8f2a26c9df84"
      ]
    },
    {
      "cluster_id": "f8e8b236-0393-4a1f-8e82-d30d9e30a2fb",
      "members": [
        "57d0e2b5-f4e4-4932-9b99-14b636e2d8fb"
      ]
    },
    {
      "cluster_id": "5c5bbff7-5569-43a1-bcbe-db0b95585d05",
      "members": [
        "f4cd8341-4133-4ece-98c5-3f1ae86bfb81"
      ]
    },
    {
      "cluster_id": "1238fc85-6b69-4536-a793-8df12f63f9c0",
      "members": [
        "f5e3fa72-fb2b-4c8e-8937-2731018dc071"
      ]
    },
    {
      "cluster_id": "18ad11bd-8c86-4313-a634-cae071e56b5c",
      "members": [
        "6060e61e-be0c-4d1f-8878-1c1691b915b0"
      ]
    },
    {
      "cluster_id": "635251ae-6796-4c05-a3b4-938f1760fe23",
      "members": [
        "4cceac16-67f1-48e7-8030-b9a52678e11b"
      ]
    },
    {
      "cluster_id": "7e14e717-108e-477a-a145-900678351362",
      "members": [
        "494e5828-8795-4c50-ad8d-fc4c2c209197"
      ]
    },
    {
      "cluster_id": "4c7b4c87-4848-4dfc-82f8-638a5803038a",
      "members": [
        "bc22ef75-a7e4-4de0-ae26-55f122fe2cdb"
      ]
    },
    {
      "cluster_id": "39225686-c932-4b86-8609-bcb573981830",
      "members": [
        "a1d7fb2b-8edc-4915-91fc-fe18cad847db"
      ]
    },
    {
      "cluster_id": "ab42726c-f378-41dc-98e2-0ce10f9d6d07",
      "members": [
        "81f0649e-10ef-4038-901d-eb4f190f3980"
      ]
    },
    {
      "cluster_id": "03a113b9-8fb7-4743-8425-b2ed80e37d97",
      "members": [
        "918addad-d5e4-491e-8588-7c777292ac5a"
      ]
    },
    {
      "cluster_id": "6f318bba-6562-4eeb-ad79-8a89fa75ae26",
      "members": [
        "bdac5e50-c5ac-4987-a66f-56d660418bf7"
      ]
    },
    {
      "cluster_id": "1eac9457-d9a9-4ee2-b922-a850e04ccef6",
      "members": [
        "008fdc96-62f2-4c1c-b1d6-f6f399651308"
      ]
    },
    {
      "cluster_id": "196c610d-29ed-4851-a66d-a936eab5709a",
      "members": [
        "23817343-8b81-46a8-9320-6fa8dee46184"
      ]
    },
    {
      "cluster_id": "2a3a89a0-063e-477e-a31a-17933d228f6f",
      "members": [
        "b56599e9-ad72-4144-9d60-987d74ff264b"
      ]
    },
    {
      "cluster_id": "5b30c301-097d-4b93-b41c-2c7775c1b518",
      "members": [
        "f63db715-5bd4-4e51-bd67-35cb0f93c1c3"
      ]
    },
    {
      "cluster_id": "2e2d4dce-467a-4329-8a65-a9b7ada8d364",
      "members": [
        "23a1676d-b41f-4b99-b09a-8f17c643747c"
      ]
    },
    {
      "cluster_id": "28c6580f-d2db-4b2f-a0b5-3530cff5de7f",
      "members": [
        "6e5165d6-1bd5-4ce7-91c6-45f010d28978"
      ]
    },
    {
      "cluster_id": "4ce53ac2-ac2e-43cc-ab0a-b530b8f75695",
      "members": [
        "54ae4560-4a71-4358-8e33-fef3a52ab75e"
      ]
    },
    {
      "cluster_id": "0357efdc-cefb-46e1-88fc-fd184c29a753",
      "members": [
        "d8f8a2c0-bf07-461d-99c1-9859649a61e0"
      ]
    },
    {
      "cluster_id": "2c046222-ca9b-481d-9b9f-68e4ebbf303a",
      "members": [
        "d3425a87-4b6e-42bf-b2fa-eff4512c53bc"
      ]
    },
    {
      "cluster_id": "af337f53-b9ac-4b98-b218-084883114074",
      "members": [
        "acf7757c-4a99-480b-8ee7-b09918bbffca"
      ]
    },
    {
      "cluster_id": "75ba7619-eb16-4658-b147-47f3f92ed383",
      "members": [
        "7821f6dc-af3a-49ec-b236-d2ddae3f9d02"
      ]
    },
    {
      "cluster_id": "1c8762e3-159f-4448-bbc9-4a59d7bfc9d5",
      "members": [
        "e3089e01-dca9-435b-b9f9-e996f3add74f"
      ]
    },
    {
      "cluster_id": "87def324-7a40-461a-a80b-cc6aa7391757",
      "members": [
        "2bdcca91-cc30-45f0-91c7-e6e19e2b0c33"
      ]
    },
    {
      "cluster_id": "0d1f3710-22b1-4ca4-9501-1c3095b8199a",
      "members": [
        "c79bfc63-8fee-4065-942a-5bd69c39be00"
      ]
    },
    {
      "cluster_id": "7a111e6b-975b-4ed3-9b97-e727f9682f28",
      "members": [
        "b4e5ffeb-5b1e-4223-b639-c6993b27b0a8"
      ]
    },
    {
      "cluster_id": "cfa0cfe9-0423-44d2-9909-74aa5f5c8e41",
      "members": [
        "b3c01f64-695b-45dd-86ac-3532acdb540a"
      ]
    },
    {
      "cluster_id": "71623d2a-780c-4e92-af1b-eb0e9b031c0d",
      "members": [
        "5f892b3d-872c-4d53-bbc2-e4db6eea1682"
      ]
    },
    {
      "cluster_id": "8945e273-b3ad-4ff1-a46f-200b7adcf6a6",
      "members": [
        "c483ea93-8523-41f9-a61e-ee868ad4cf6e"
      ]
    },
    {
      "cluster_id": "b14c3761-a874-48e7-9fb8-15aebb4dd009",
      "members": [
        "17172956-7a49-4cad-bad7-acba17942b4a"
      ]
    },
    {
      "cluster_id": "af5dc56f-c303-4ae3-a3a4-2b17b1e05cac",
      "members": [
        "fbebad4c-0764-4bb1-ac23-cf33fefb6479"
      ]
    },
    {
      "cluster_id": "6cf816f8-e003-42cf-8cf6-67f77f267b93",
      "members": [
        "1a4978e3-02e9-4fa6-b620-2cccd43851ab"
      ]
    },
    {
      "cluster_id": "282bf62f-9c0e-4150-9c45-5edc6ab7a29f",
      "members": [
        "e7b35665-d6ee-4f1a-8e50-f74ec2d2acec"
      ]
    },
    {
      "cluster_id": "81b74ec1-1e27-4ec6-a6ad-9c28cfcd7074",
      "members": [
        "00a2a27d-32c8-4a8b-be3b-9ed3e06ffdc7"
      ]
    },
    {
      "cluster_id": "cfb71f70-69b3-4e36-b2b7-df43f0d519a2",
      "members": [
        "25aada7e-13e3-4369-bf9b-717144c5afd7"
      ]
    },
    {
      "cluster_id": "7b20021b-470c-46f3-841f-c47d4c52551f",
      "members": [
        "2aeb304e-6e62-44c1-b9a6-7aec1b078436"
      ]
    },
    {
      "cluster_id": "32f448b3-33d8-4d45-9792-ba9ba2feec34",
      "members": [
        "2eaa4d5f-5434-4b0c-97c1-dfe2fa199bab"
      ]
    },
    {
      "cluster_id": "98018dbb-a9a6-4b5d-b356-863340b24362",
      "members": [
        "fb3a0ff9-85fd-4a72-80a0-e6867be164fe"
      ]
    },
    {
      "cluster_id": "cf92f2d9-5ad3-4f3b-877f-c3c333e4eaa6",
      "members": [
        "50193c60-d618-4f3a-abf1-4f0b12109764"
      ]
    },
    {
      "cluster_id": "607cc6ab-a0bd-429e-a391-92e1066b96d9",
      "members": [
        "b47f6e2a-d3a4-4ae5-bd22-18f9947d3e27"
      ]
    },
    {
      "cluster_id": "ccd586d7-5c30-4f84-8142-adc54ddef655",
      "members": [
        "351cc15c-a27f-47ca-b694-732d51544410"
      ]
    },
    {
      "cluster_id": "5db2dd2a-560f-4f51-8086-9e7ff5236782",
      "members": [
        "3f9f599e-0545-407d-a228-856b831a5cb2"
      ]
    },
    {
      "cluster_id": "e2a1f0e1-e053-4231-9242-7b160200d696",
      "members": [
        "05f75e3c-f07a-4364-88d3-a266a0b06c8b"
      ]
    },
    {
      "cluster_id": "e424d11c-d0d7-4fab-ba10-6b37559e56f0",
      "members": [
        "2760a08d-440e-473a-8c1e-715e05679c7d"
      ]
    }
  ],
  "cluster_links": [
    {
      "claim_cluster_id": "dfbc19e5-8117-4d40-9c25-774ed7aee906",
      "event_cluster_id": "713b16e4-cb6f-4c7f-8eac-cbbfee258e85"
    },
    {
      "claim_cluster_id": "e370d332-674b-403f-8471-184685b21c55",
      "event_cluster_id": "dcbfce15-858c-4e65-80b3-6f982fffc5b4"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "7fe41e18-746f-4276-85f6-d30d85eaa538"
    },
    {
      "claim_cluster_id": "dbcdf7e4-c865-4f31-a79f-0cd2eef3258f",
      "event_cluster_id": "f7605d2c-c20e-498d-b5dc-8cc953b6d021"
    },
    {
      "claim_cluster_id": "eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0",
      "event_cluster_id": "83e19f20-191c-42c6-bdd7-ee466f6ee0d2"
    },
    {
      "claim_cluster_id": "546cb276-d6b0-40dd-8288-6659cb7989f0",
      "event_cluster_id": "51c1b08d-506f-4dea-874d-a86b8ab55fb1"
    },
    {
      "claim_cluster_id": "5e0fea08-89fc-42fe-8906-484d762a1714",
      "event_cluster_id": "af337f53-b9ac-4b98-b218-084883114074"
    },
    {
      "claim_cluster_id": "1a006b70-5bcf-42d1-91c0-d02ee212c0eb",
      "event_cluster_id": "c2c95c94-edcb-470f-82d7-17f1cc69860f"
    },
    {
      "claim_cluster_id": "30d2edfa-6d58-40ae-bac6-ec1273c415ac",
      "event_cluster_id": "1ed0bff4-f942-4d7a-bec9-87e9c09bf276"
    },
    {
      "claim_cluster_id": "00cfa90d-eff5-4498-89d6-85dadca46eb8",
      "event_cluster_id": "5a9527b4-7ddf-4c5a-b860-67170fb02224"
    },
    {
      "claim_cluster_id": "d89e632e-b2af-4331-9344-c7d1e373d49b",
      "event_cluster_id": "b9f9ee97-4a90-4a60-a376-32010848d648"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "4ccf7bf5-90df-4621-97ed-669020415167"
    },
    {
      "claim_cluster_id": "a0209bc1-2ecf-46c2-8b3d-8258fc85b6a8",
      "event_cluster_id": "0cb0d661-8f49-489f-95ee-927e21758c32"
    },
    {
      "claim_cluster_id": "6f9b01a7-d717-4ce1-bd54-f5647d476287",
      "event_cluster_id": "5eaa7b8f-5e2f-4cc2-827c-b780c20bc557"
    },
    {
      "claim_cluster_id": "20e0f6a7-71df-44b4-b99e-3e278ca655e8",
      "event_cluster_id": "75d93b8c-bf4b-43d0-94ef-7db799889fc5"
    },
    {
      "claim_cluster_id": "2b47973e-934f-45a0-98dd-aacefd7432f8",
      "event_cluster_id": "fe65ec5c-3bc8-43b1-9738-60a0ae594f25"
    },
    {
      "claim_cluster_id": "a4182192-73bb-4165-ad72-05ff39be899d",
      "event_cluster_id": "c7e4e067-9226-4d57-b404-ebdc121f49ed"
    },
    {
      "claim_cluster_id": "773a0c25-df3d-4865-86dd-a73825ed69b0",
      "event_cluster_id": "1bb1e966-aeca-49bb-87b9-768c9cbb3254"
    },
    {
      "claim_cluster_id": "b5432b8d-5ac9-4f60-8977-fdbcdae395a3",
      "event_cluster_id": "bca4fab8-15f6-4111-ae92-b37f9696dd06"
    },
    {
      "claim_cluster_id": "c0fbbbbf-776a-47c5-9e8d-f798f722abf7",
      "event_cluster_id": "5abf2d27-62a3-4f2a-9794-398729b78b13"
    },
    {
      "claim_cluster_id": "47fbc359-0497-4aac-8a4b-e63bd060a1e2",
      "event_cluster_id": "afd3270e-5e96-4569-902a-2454d2aa0df7"
    },
    {
      "claim_cluster_id": "dff8a985-ffc1-4946-ab7d-43e8406aca00",
      "event_cluster_id": "27d190cd-822a-4b37-b138-1b1b73c5196b"
    },
    {
      "claim_cluster_id": "d7cbd37c-10fd-4628-bba8-b434c41ec43f",
      "event_cluster_id": "4c79fc69-3bd0-4180-9718-8d85b8c9dd85"
    },
    {
      "claim_cluster_id": "bd6de2da-8b5f-4e38-83bd-28294e175aca",
      "event_cluster_id": "8c2c4d45-17ad-4731-921d-8582fefe2ba4"
    },
    {
      "claim_cluster_id": "d37ab208-5122-4b14-a2ce-fa0d51ab2a4b",
      "event_cluster_id": "f63758ba-bedd-47a6-901a-a2e5321c2bbd"
    },
    {
      "claim_cluster_id": "d3777022-58bb-45d2-9153-3e33e4a367f9",
      "event_cluster_id": "6d479b93-5e42-43ab-8ac4-7f31b557309c"
    },
    {
      "claim_cluster_id": "6f59c0c4-2b1f-4873-80b4-3766eb7b28aa",
      "event_cluster_id": "944bd314-7efa-4d4e-ad2d-2a560ec194da"
    },
    {
      "claim_cluster_id": "d41663c0-a43a-40f6-ae8e-9e6eeb720de9",
      "event_cluster_id": "6a879b2a-d8ee-4202-a129-be28ec711b2b"
    },
    {
      "claim_cluster_id": "9ffb85b8-5080-4f27-85ad-554406cf7402",
      "event_cluster_id": "af431814-360b-4c41-83d1-6147d4068846"
    },
    {
      "claim_cluster_id": "621b2187-e651-4a6f-becc-2a2a2cd444a2",
      "event_cluster_id": "a16ccc88-94c6-46a6-bbdf-ea9f1e6f5d27"
    },
    {
      "claim_cluster_id": "c6b3d942-ded2-4171-9d53-bf87a1b48b52",
      "event_cluster_id": "46dfd54a-6aa7-40ae-be06-53fff6d54a50"
    },
    {
      "claim_cluster_id": "33e1162a-91ae-476d-b4d5-3b1e2f01a5c1",
      "event_cluster_id": "fa141cd8-01d2-46a8-8dd5-b14aea438fec"
    },
    {
      "claim_cluster_id": "500957af-7f87-40ca-b575-44450d181bfa",
      "event_cluster_id": "5e3b2dc6-8e5b-4236-bdd1-0dbf9bb9618c"
    },
    {
      "claim_cluster_id": "4d2c8d1c-73d7-42b1-87cb-56c8ddf68982",
      "event_cluster_id": "36d77123-4871-42ae-b0c9-6b46e2bd9d65"
    },
    {
      "claim_cluster_id": "83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6",
      "event_cluster_id": "bfb33b2a-3aae-48af-9bbe-a26cf7874798"
    },
    {
      "claim_cluster_id": "7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607",
      "event_cluster_id": "ed693943-5db4-4907-b797-9fccd8ed73eb"
    },
    {
      "claim_cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4",
      "event_cluster_id": "d17ccb3f-9b25-4161-8681-42ad54f325a9"
    },
    {
      "claim_cluster_id": "cebef5fc-6d79-4e08-878b-8c75696aa6d2",
      "event_cluster_id": "470e1b16-db3d-4438-9038-d9ecc0d37edf"
    },
    {
      "claim_cluster_id": "cbe32f56-0dc5-4870-8a2a-874435ed2ed9",
      "event_cluster_id": "09116da3-a819-4889-967d-7f1f71fd03cc"
    },
    {
      "claim_cluster_id": "fd127341-6938-4e10-8b5d-771537846e8c",
      "event_cluster_id": "b680d78a-6796-4b44-a00b-5861ed074dcd"
    },
    {
      "claim_cluster_id": "5904fe8c-6989-4981-93c1-c6202b0b4d88",
      "event_cluster_id": "b91a4bd2-e629-472a-9c82-852acf9ccef7"
    },
    {
      "claim_cluster_id": "cc37a7b6-46fd-4cda-8faf-63a00cd3c131",
      "event_cluster_id": "f18619a4-4f58-4ae8-a9ef-fa5f0bef0daf"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "4d37159d-0a18-4557-9e9a-a0401bd9cb08"
    },
    {
      "claim_cluster_id": "22107865-2cc2-437f-be8c-dd105a24eaaa",
      "event_cluster_id": "ebbce66e-0d97-4659-a453-e44542e8d915"
    },
    {
      "claim_cluster_id": "d2c2f402-f56b-4dfa-98d3-daf63239156d",
      "event_cluster_id": "f7ebd749-2aba-4604-bcc7-3f28208b0612"
    },
    {
      "claim_cluster_id": "8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4",
      "event_cluster_id": "7c268167-b621-480c-ba79-7005ed13e2de"
    },
    {
      "claim_cluster_id": "b5aab15d-0623-4834-b9a0-c066e3616369",
      "event_cluster_id": "0c90c874-03f1-47c0-b8b4-7fe34021d559"
    },
    {
      "claim_cluster_id": "73dcede2-49d2-4bc1-a599-b15a7d0094cf",
      "event_cluster_id": "5733967d-8845-4b54-bab0-e2652b43f156"
    },
    {
      "claim_cluster_id": "69315435-638a-4ef2-abe8-1d91d23ff51a",
      "event_cluster_id": "3cda3833-2d58-4e6e-a35b-5bec2cd74e4d"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "c80f9729-aadd-4634-8ad6-b098c5a58675"
    },
    {
      "claim_cluster_id": "5fb2043e-87e6-4ef1-829c-b51f962dada4",
      "event_cluster_id": "cef4b627-4828-4a00-9a55-7f92b9804c1f"
    },
    {
      "claim_cluster_id": "a0fab421-41ab-435c-b6c1-ee353c134771",
      "event_cluster_id": "27a6e31f-9188-49c5-afc9-f45a074457ba"
    },
    {
      "claim_cluster_id": "ffb2c778-a1f6-402c-8381-54550bf56799",
      "event_cluster_id": "8a24a294-bd79-41a9-b04a-466874226ecd"
    },
    {
      "claim_cluster_id": "fe6adf14-e7af-49eb-8b83-de4001fbc495",
      "event_cluster_id": "d8869910-ef23-4e2c-a1a9-778ac3a96b8c"
    },
    {
      "claim_cluster_id": "e36180c3-afe0-495c-8168-73e631f50a1c",
      "event_cluster_id": "e6b11bad-8ee1-43f8-a49c-9856a434923a"
    },
    {
      "claim_cluster_id": "cb357706-7b58-4396-aa24-1c59beae87fa",
      "event_cluster_id": "e2e4a182-34d1-44dd-bd17-91104b15baa4"
    },
    {
      "claim_cluster_id": "d6145953-8619-428f-9b84-07cd47d4180d",
      "event_cluster_id": "22f3bc98-8ed4-4355-8d05-5399a3757d7b"
    },
    {
      "claim_cluster_id": "4d2dc30e-97f5-49d3-80df-c343048e6856",
      "event_cluster_id": "e42d98f9-07f8-45be-ae88-1f54a5594edd"
    },
    {
      "claim_cluster_id": "298b76c6-3ed3-4a84-8894-fa50a9f4234f",
      "event_cluster_id": "5b79ee45-2abd-45a2-8873-e58d11466b36"
    },
    {
      "claim_cluster_id": "64599826-faee-4fcf-9432-967663d05451",
      "event_cluster_id": "3ae7e3a9-52e8-497b-addf-b434f9dee4bb"
    },
    {
      "claim_cluster_id": "7a7464b2-8279-45dc-b2ed-48f2c4d22d10",
      "event_cluster_id": "c49cd086-ee6f-4cec-890b-ecf827080344"
    },
    {
      "claim_cluster_id": "5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa",
      "event_cluster_id": "b22a3d90-fc7c-4c0c-8913-b55993380bc0"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff"
    },
    {
      "claim_cluster_id": "883c65b8-c8f1-4a3b-8bd5-fb9d61a95876",
      "event_cluster_id": "79350a97-33bb-4081-9a5c-bebaa0641f2a"
    },
    {
      "claim_cluster_id": "b6dd34fe-58a4-4775-be96-ca839f926747",
      "event_cluster_id": "fd395743-8cf0-4953-ace0-85cff9e72be0"
    },
    {
      "claim_cluster_id": "da661a25-9665-44d1-ac27-e2613681adf1",
      "event_cluster_id": "c218f143-d00f-4444-8a1a-91fa210ebc65"
    },
    {
      "claim_cluster_id": "a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20",
      "event_cluster_id": "9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"
    },
    {
      "claim_cluster_id": "c3cd1557-129f-4369-b850-25bdf5456c16",
      "event_cluster_id": "d5e78a91-2d42-4f38-b8d5-690a40967ad3"
    },
    {
      "claim_cluster_id": "ea08b9f4-137e-40ca-ae54-2e396aa18fc5",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "544ac6da-d621-4fd5-bbf8-4a2cd6254e41",
      "event_cluster_id": "a1f32f8a-32f7-4bba-b1fe-edc8382be9e5"
    },
    {
      "claim_cluster_id": "b633274f-2881-417d-afbb-e5015101f863",
      "event_cluster_id": "911f995f-4932-433d-afa5-fabf5bc995f7"
    },
    {
      "claim_cluster_id": "463ff506-01da-43ee-96ab-3704e89855e2",
      "event_cluster_id": "1fdf700e-c5ec-4ab4-a4d5-eff0304e7a3b"
    },
    {
      "claim_cluster_id": "12ff0964-4c5c-4f91-8269-1e4ab61e9602",
      "event_cluster_id": "3595c0cd-b164-431e-b192-61bc7dc0019f"
    },
    {
      "claim_cluster_id": "d9366872-6ca9-49e5-9e80-86c5b954d463",
      "event_cluster_id": "cf0fcabf-722c-47eb-957b-91614bc676e4"
    },
    {
      "claim_cluster_id": "b198bd93-5f96-4992-9aa2-29e396814e39",
      "event_cluster_id": "f0ad65d9-233e-4737-b565-7bb483317155"
    },
    {
      "claim_cluster_id": "e9280ed1-20ec-4c75-8468-086e8c6749dc",
      "event_cluster_id": "ec0d2b84-2d88-4935-ba00-876f0eb3929f"
    },
    {
      "claim_cluster_id": "3f09a0f3-521e-4c59-84d0-5adbf02dbf98",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "8dca8952-fbff-4b47-ba25-a7640fe52fba",
      "event_cluster_id": "712fa0e5-9886-40f6-b761-bb1a99d5fb8c"
    },
    {
      "claim_cluster_id": "c9b6b0e3-811d-4e56-9eba-3408eb1dc06f",
      "event_cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965"
    },
    {
      "claim_cluster_id": "00ac14b3-c6d6-458b-b4cd-3981a1a2b9f9",
      "event_cluster_id": "7754f22c-30c5-465a-b231-a607a0c13504"
    },
    {
      "claim_cluster_id": "f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3",
      "event_cluster_id": "a3067b08-040a-4461-a857-7a4d88845295"
    },
    {
      "claim_cluster_id": "f17dbb9a-8968-4ade-a774-02688b6da89a",
      "event_cluster_id": "72e8bf8f-e8db-4e42-bec7-0ed7ee61d61a"
    },
    {
      "claim_cluster_id": "235bfc4a-e3f2-4850-83c2-a78043ab464b",
      "event_cluster_id": "cdca7f1c-2f77-48ee-ab2a-8828f905776a"
    },
    {
      "claim_cluster_id": "7cacaa03-4763-4931-91bd-306a3231361c",
      "event_cluster_id": "f200deff-bb81-4d41-8008-3dc621e11aae"
    },
    {
      "claim_cluster_id": "c0426c3e-a327-4be7-b689-905cba5cdfca",
      "event_cluster_id": "63edca78-13df-4735-a10c-6f9089b9d044"
    },
    {
      "claim_cluster_id": "c05c40cf-fbe6-4e98-aa0e-98f1fcbb5333",
      "event_cluster_id": "f07e6f30-0af3-4009-9a85-94198bcc5a45"
    },
    {
      "claim_cluster_id": "5389eae7-83b1-4726-86c2-9a8dff51be59",
      "event_cluster_id": "365e9714-a651-4229-98f7-325862506f0b"
    },
    {
      "claim_cluster_id": "06c89f07-f873-4ab4-9068-3bbe6a0c9e11",
      "event_cluster_id": "dd4be4e8-361d-46ff-9230-0b65d75e82b0"
    },
    {
      "claim_cluster_id": "31ba7a04-0212-474b-8f8e-9374845e4ab5",
      "event_cluster_id": "f2253ad2-0cf7-4f4d-a01d-da6760a12103"
    },
    {
      "claim_cluster_id": "9e71565f-1fc8-4e9e-a3ed-15e11a8ef776",
      "event_cluster_id": "b21b063b-f7bc-4014-8dc5-34ae0d688761"
    },
    {
      "claim_cluster_id": "fc1c32c1-8212-46dc-b3e4-29a2254a34ba",
      "event_cluster_id": "1a4aae73-4152-4a0a-830e-ec3794a86bd7"
    },
    {
      "claim_cluster_id": "8b8d3259-7bca-4683-902c-7b72552f88ab",
      "event_cluster_id": "4deeb553-8438-4bc5-89db-299a071d6d12"
    },
    {
      "claim_cluster_id": "075f7aea-756f-4e67-bf46-f4305230821b",
      "event_cluster_id": "12d9ff77-3eea-4aa4-b8ee-4d436789ff3b"
    },
    {
      "claim_cluster_id": "3dc82114-c98e-4342-a6ab-854d95d9efa7",
      "event_cluster_id": "a815c927-5e75-49a5-ad08-40e7381924c6"
    },
    {
      "claim_cluster_id": "17ea1514-c948-487c-83ee-722001d6184e",
      "event_cluster_id": "7ca6b83e-0750-42ad-b001-d24a26fccbeb"
    },
    {
      "claim_cluster_id": "7386324d-4730-4b17-8d70-6b33d62d5be3",
      "event_cluster_id": "e24f9229-3672-4631-abf5-3ab616111d97"
    },
    {
      "claim_cluster_id": "2870dcce-8def-47de-9196-c66889a0a474",
      "event_cluster_id": "3c10b554-db0c-4b37-99ae-e28966332651"
    },
    {
      "claim_cluster_id": "3bc352c0-0d5e-42f4-ad88-e7f025e20e88",
      "event_cluster_id": "f17de551-5a88-4bbe-a63a-f23269257469"
    },
    {
      "claim_cluster_id": "469a2781-0070-451c-bc21-b7ee2b0da3f0",
      "event_cluster_id": "e6db83d3-cda9-4430-8a6e-a7718c384123"
    },
    {
      "claim_cluster_id": "df20aee7-4e88-4c5d-a2d1-ce862c311713",
      "event_cluster_id": "40a7eabf-afd2-4baa-a287-e3b8fad136d9"
    },
    {
      "claim_cluster_id": "3249ee55-684b-4bbb-8b52-6766f62838f9",
      "event_cluster_id": "d285c4ec-3955-47ea-918b-05a93083bebc"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "32516088-d496-4b04-a09c-540561be5921"
    },
    {
      "claim_cluster_id": "cf096384-5ede-4929-b992-9e6ee20d6a8b",
      "event_cluster_id": "e5da69ec-b7e5-4fec-8bae-3161bd3d02ca"
    },
    {
      "claim_cluster_id": "53bc38bf-651d-46ea-8aaf-f63f52195a45",
      "event_cluster_id": "d223b5e1-de75-49e7-9d5b-0ab4514a4ec6"
    },
    {
      "claim_cluster_id": "6e5c19c1-853c-4797-84d8-7f68386994d3",
      "event_cluster_id": "08dca077-8e26-493a-9038-2f3ec565da5b"
    },
    {
      "claim_cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "event_cluster_id": "44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"
    },
    {
      "claim_cluster_id": "902f069d-3703-489a-9dfa-fb26ee837027",
      "event_cluster_id": "4d6e8834-c57b-472a-adbf-630fe4d997d3"
    },
    {
      "claim_cluster_id": "5f266248-0a3e-4fc2-afec-4bfc7ba1a633",
      "event_cluster_id": "c4bed539-a0aa-4ff8-9be3-4afa92598dee"
    },
    {
      "claim_cluster_id": "51086a98-c771-4b7c-8eaa-b6fbb8629a30",
      "event_cluster_id": "186c5c04-d5bb-4764-8a32-550ebb9ed5fd"
    },
    {
      "claim_cluster_id": "ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb",
      "event_cluster_id": "b96e892e-f2b5-4f40-833b-36af1949d85f"
    },
    {
      "claim_cluster_id": "06aec0e1-946f-46e8-835f-efac40b3f6dd",
      "event_cluster_id": "01d3c9ca-6075-43cb-a3ac-1d6094f7282d"
    },
    {
      "claim_cluster_id": "563140da-8f58-4b64-8987-47bb018b6821",
      "event_cluster_id": "c577dcab-43f4-4988-b6a9-b023d7e8abb2"
    },
    {
      "claim_cluster_id": "64de434e-21f8-43c2-9395-33dcf3b86c3d",
      "event_cluster_id": "93707dc5-36b1-4b18-b721-a98eb38368ea"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "fced5669-e70e-41e7-920b-f76f2f50557d",
      "event_cluster_id": "92dc2b29-cee7-4ea1-b9e9-d0593544c75b"
    },
    {
      "claim_cluster_id": "28feb358-2926-4cba-8425-f09fe5ebab7a",
      "event_cluster_id": "ce1afbc7-cb83-43ef-a574-f0c71eec061c"
    },
    {
      "claim_cluster_id": "b8c8cd38-7dea-46d6-b8a1-7316916dd462",
      "event_cluster_id": "9fde602a-5d0b-4ab4-85c7-e2300402299d"
    },
    {
      "claim_cluster_id": "69290a80-8807-401f-b38b-0ff5ba27a43d",
      "event_cluster_id": "ed8f044f-96b2-4a20-8622-207bfd8ae25b"
    },
    {
      "claim_cluster_id": "2da1e2c0-6b7f-4a59-bbad-c83252a70f91",
      "event_cluster_id": "43ab7664-f265-4e8d-9a0a-5ae73e4eeadb"
    },
    {
      "claim_cluster_id": "c462838a-420c-4b5a-ad06-676939effe93",
      "event_cluster_id": "2ad0c3d6-c24f-4917-a1f6-8d2bd77034c3"
    },
    {
      "claim_cluster_id": "843e2174-20bd-4386-beb4-ad4f8d0ba790",
      "event_cluster_id": "28705389-d7d8-40a2-9a03-e4eb35877525"
    },
    {
      "claim_cluster_id": "235bfc4a-e3f2-4850-83c2-a78043ab464b",
      "event_cluster_id": "89e88d24-d19d-44d7-b8a5-9a1551934f01"
    },
    {
      "claim_cluster_id": "3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9",
      "event_cluster_id": "dfab974e-91dd-4ade-9c9d-e89b40d58378"
    },
    {
      "claim_cluster_id": "0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f",
      "event_cluster_id": "4b50f48f-0dd4-4d51-a40b-e932902a32fc"
    },
    {
      "claim_cluster_id": "61922f77-a020-4916-b901-44fe7982b789",
      "event_cluster_id": "77ffe8cd-d30f-4bde-8bb0-f1fd00ff5cdf"
    },
    {
      "claim_cluster_id": "4ef708bd-198e-4a9e-9652-a1b08bc50fd9",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "f4c860ae-1c6c-4478-89c7-fac05f3999c6",
      "event_cluster_id": "720ca61f-9942-490c-ab91-755d5a979ee2"
    },
    {
      "claim_cluster_id": "61922f77-a020-4916-b901-44fe7982b789",
      "event_cluster_id": "455f3cb3-d253-4739-8dfa-e88137f7f063"
    },
    {
      "claim_cluster_id": "0884e607-6aee-438f-ad6b-dac7b6c0719c",
      "event_cluster_id": "59e94cb9-614a-49f2-a91e-9928ad318f00"
    },
    {
      "claim_cluster_id": "2567422d-b366-451c-a271-4cb76dc8196c",
      "event_cluster_id": "d2ffb0e6-959f-4fb3-a43b-5fea64c717c0"
    },
    {
      "claim_cluster_id": "c98491ce-51cb-40b0-93ae-d389e1c9d7a5",
      "event_cluster_id": "9a693a02-7bfa-493e-8c56-142555000e80"
    },
    {
      "claim_cluster_id": "64664899-be28-4387-939b-822e6b833f08",
      "event_cluster_id": "fa2c58b3-15f9-417f-89fa-2899f5ce4fe3"
    },
    {
      "claim_cluster_id": "59e6bbb6-5982-4df0-b59c-33f07ce159f4",
      "event_cluster_id": "3f649da1-9f4e-4906-a4fe-35e3ec3f6e86"
    },
    {
      "claim_cluster_id": "5c1d5636-b62a-4962-911d-1136d9629b6a",
      "event_cluster_id": "abca71f2-b0b7-497b-b1ed-9f04c6ea4023"
    },
    {
      "claim_cluster_id": "2c834413-ef2b-486b-81d5-2e0a687a8ca7",
      "event_cluster_id": "6799e4ae-598d-4d1f-8409-ebaa05c79c71"
    },
    {
      "claim_cluster_id": "61152334-8dda-42a2-bb8d-9fb770fd72f7",
      "event_cluster_id": "745f9d2c-8956-422e-91cf-53ea37e70f82"
    },
    {
      "claim_cluster_id": "a950be1b-733b-40a8-b78b-7a36e0c5c2ac",
      "event_cluster_id": "9c21e744-a69f-4d9f-abbc-ec67be5c4220"
    },
    {
      "claim_cluster_id": "767a107b-6141-45c6-9ffe-6f7fde1b3426",
      "event_cluster_id": "67cd7c4a-a6b3-4e11-9b6b-362422489e76"
    },
    {
      "claim_cluster_id": "6a4b35a4-0785-4292-8587-aee85db61288",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "f8d5c2ae-ad96-41f1-8875-2d89a574f697",
      "event_cluster_id": "270c2a25-c40e-45fd-b4d9-9d1e09305cbf"
    },
    {
      "claim_cluster_id": "60269200-21dc-4ddd-bed2-414eb8acfbb9",
      "event_cluster_id": "24b243a4-0f35-4d99-b275-1610156f7f35"
    },
    {
      "claim_cluster_id": "e7287d47-759e-41f0-9641-093ab1e3e04c",
      "event_cluster_id": "6a5e4ef1-a4af-4de0-8b56-75c0ed9ae0bb"
    },
    {
      "claim_cluster_id": "54385df9-c5b3-4372-ae3b-cfd7db571df8",
      "event_cluster_id": "d64d430f-8c0f-4a8b-850b-225e57fc685a"
    },
    {
      "claim_cluster_id": "cf399998-137e-4270-8827-7c726197fb9d",
      "event_cluster_id": "97d31fcc-0a9f-4dbf-b6c8-d1db70a61d1f"
    },
    {
      "claim_cluster_id": "a0fb284d-9ce5-4422-a3d9-508052dde7fe",
      "event_cluster_id": "43507aa1-0b73-484a-ae6d-901aa511c57f"
    },
    {
      "claim_cluster_id": "38d2a616-9f37-42ea-8e5e-3010dc76a2ba",
      "event_cluster_id": "d3a2d90d-13dc-4075-9660-3952f836b150"
    },
    {
      "claim_cluster_id": "b2ae7e4a-67e9-4eed-bd5c-afaef2c19efc",
      "event_cluster_id": "87e69472-d284-42bf-9dfe-9535bde32efa"
    },
    {
      "claim_cluster_id": "1469928a-aef7-459b-af14-6d6ac0ca72d3",
      "event_cluster_id": "e90ef9df-5189-4af1-8d38-f4bc22fa022a"
    },
    {
      "claim_cluster_id": "1713cb4d-ab0f-4257-a2cb-4aec01e411ef",
      "event_cluster_id": "1d4622f2-0a7b-4423-ad78-a011864bf902"
    },
    {
      "claim_cluster_id": "fb6ff34e-94b0-4910-b613-9ebb9af0b6b6",
      "event_cluster_id": "9528f35d-9b68-417f-b3ed-2c5b3d1cbe83"
    },
    {
      "claim_cluster_id": "ea6a2243-de2d-4dba-b6c1-70fc6e903bfb",
      "event_cluster_id": "597adccf-df25-4f4a-b01c-58baf036682b"
    },
    {
      "claim_cluster_id": "8b3203a2-f473-4957-9689-fdf6ee974697",
      "event_cluster_id": "17ce8541-8518-4283-a893-e35ad31e95fb"
    },
    {
      "claim_cluster_id": "40fee78e-be14-405f-8e91-d6685b9587a5",
      "event_cluster_id": "c9181b4b-e96f-49e6-ae73-b2dbaaa3fd9c"
    },
    {
      "claim_cluster_id": "91ccf699-eaec-41a7-8213-08934dbe2395",
      "event_cluster_id": "f1a3e12a-c3c3-4476-aaf7-ecead6148d82"
    },
    {
      "claim_cluster_id": "5cd897af-cb8c-4335-a548-c9963c43f060",
      "event_cluster_id": "37b089f1-912d-43da-b995-2ef9b56de813"
    },
    {
      "claim_cluster_id": "746a6f97-55c7-4dc9-ab6a-cc007e33449e",
      "event_cluster_id": "0404c137-e8e8-457f-ae4b-121032548258"
    },
    {
      "claim_cluster_id": "511c0db2-0769-45d5-a814-00f974a659aa",
      "event_cluster_id": "143e5a89-f562-4e9e-ae94-80a1636c09a2"
    },
    {
      "claim_cluster_id": "554fbe05-7cef-438d-8e82-567521788239",
      "event_cluster_id": "cc877779-d56b-4dd9-8cf2-4d0193c50ac9"
    },
    {
      "claim_cluster_id": "1c24dadf-70dd-4f00-84a1-ba00a5d442c5",
      "event_cluster_id": "98230e6a-7d95-4671-8b15-8c0dbec5af34"
    },
    {
      "claim_cluster_id": "9fb5216e-3d0c-403e-a2bf-9368fa3e3592",
      "event_cluster_id": "a0925808-7df0-46ec-bb06-9cb553f8b8fd"
    },
    {
      "claim_cluster_id": "457d88a0-1b8d-406f-8eeb-01fdd00cdc30",
      "event_cluster_id": "77f11c57-3238-4a6e-9949-a3af094990cf"
    },
    {
      "claim_cluster_id": "29cb7e64-a98d-4be8-8dd8-aa5a3b83d517",
      "event_cluster_id": "7ed8137c-2279-4400-b674-1dd86eab9aa5"
    },
    {
      "claim_cluster_id": "3f85eb0b-4d61-4e44-8414-15ce2c9f03ad",
      "event_cluster_id": "4791dca9-cb90-4716-841a-c69798c940f2"
    },
    {
      "claim_cluster_id": "17dbd7df-f3d1-4902-a103-f97b03017681",
      "event_cluster_id": "28ea99a2-454e-42c3-b308-cf4739fc9a02"
    },
    {
      "claim_cluster_id": "f96435db-3d9a-45de-8398-45bc9dbd4fc0",
      "event_cluster_id": "66d1e8de-40d0-4ef4-80a2-bb8b898bdabc"
    },
    {
      "claim_cluster_id": "7c045c5d-d9cb-4901-a4fe-8f8a68090a83",
      "event_cluster_id": "8a12c9b8-6999-4708-96d0-9b9b5cea643c"
    },
    {
      "claim_cluster_id": "6e63c4ba-f9ee-49c7-a87f-b38ea11837c4",
      "event_cluster_id": "037c02f8-bec2-4837-9533-93f63490c709"
    },
    {
      "claim_cluster_id": "09505049-ee83-46bc-bc41-216c4501ccc0",
      "event_cluster_id": "4693632f-2c46-4370-bcbf-41570c0b3112"
    },
    {
      "claim_cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "event_cluster_id": "2c24d987-e81b-4cb7-a369-7fc133161292"
    },
    {
      "claim_cluster_id": "9142e74b-a217-4be0-8685-ab7ea89b683d",
      "event_cluster_id": "7c1fc423-517b-4edd-ab51-ee1fbb6a01c1"
    },
    {
      "claim_cluster_id": "aa973fc5-c596-49d2-86f1-80f2a9f419e9",
      "event_cluster_id": "410ec318-9df5-41c9-964f-b2ab6d13b1bf"
    },
    {
      "claim_cluster_id": "4b18f200-0ad0-4f45-9303-c7be1cc1c733",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "7ff438ec-b701-48aa-b613-4bfeaba7bcce",
      "event_cluster_id": "6b13e7ad-350b-4ea9-8771-684dda7f984a"
    },
    {
      "claim_cluster_id": "d60742af-37a3-43e0-afb8-5df777dac64e",
      "event_cluster_id": "a74e2cea-b4c4-4a7d-a1c4-162f2fa0ad2e"
    },
    {
      "claim_cluster_id": "56dc9727-1db9-4dc8-acf2-c70b7f101883",
      "event_cluster_id": "3de2ede6-0765-4692-aac5-cd554d7b3943"
    },
    {
      "claim_cluster_id": "d521ac4e-4810-4638-bb77-9fbf7ba74f52",
      "event_cluster_id": "b92f2bdb-a4c9-478b-a96f-1f47457a005d"
    },
    {
      "claim_cluster_id": "f8052bb9-bad3-47eb-9141-dec76f63f661",
      "event_cluster_id": "d8aa6d60-fbe4-466b-a7f6-c42801792185"
    },
    {
      "claim_cluster_id": "23bbf046-846b-4885-b881-e84d2ca9060e",
      "event_cluster_id": "719a33e0-04c5-4203-a193-c262a589d49d"
    },
    {
      "claim_cluster_id": "e42f3c12-f894-47fd-b892-02c051609420",
      "event_cluster_id": "abbfb703-6da3-4a58-9c1e-a58cf34e5030"
    },
    {
      "claim_cluster_id": "0dc504d4-9f05-4936-a43a-c912683c5ac2",
      "event_cluster_id": "f1cd2dd5-074a-4fc6-a7c3-71a678833a3f"
    },
    {
      "claim_cluster_id": "2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4",
      "event_cluster_id": "12d89d03-baba-4a2e-8935-742fe6b4573c"
    },
    {
      "claim_cluster_id": "2567422d-b366-451c-a271-4cb76dc8196c",
      "event_cluster_id": "24039860-6815-4ba8-9be1-247dda66cf25"
    },
    {
      "claim_cluster_id": "8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4",
      "event_cluster_id": "10c35c93-3305-488a-b928-ca8b7cb9a3d2"
    },
    {
      "claim_cluster_id": "756853a7-6f00-41a1-87fe-40396a3fd247",
      "event_cluster_id": "126f7904-d5da-4bb4-861e-215114767499"
    },
    {
      "claim_cluster_id": "990aca8f-a2db-4ebd-85da-744c488a8d2b",
      "event_cluster_id": "8845b13a-d2ef-4802-8b18-edb4fbddb6a2"
    },
    {
      "claim_cluster_id": "bfa96159-d0c2-4735-8c1a-2d33b2346d24",
      "event_cluster_id": "f5220f5b-8931-4ce9-bb6b-eefb8c206ace"
    },
    {
      "claim_cluster_id": "2b47973e-934f-45a0-98dd-aacefd7432f8",
      "event_cluster_id": "8c4dfd91-f6ed-43c0-830e-f702329489e8"
    },
    {
      "claim_cluster_id": "6d12ca3e-2e36-40ab-9cf4-0663df64745d",
      "event_cluster_id": "cb95b455-562f-46e4-96a7-2aa2409fed5d"
    },
    {
      "claim_cluster_id": "ee877fbc-1f06-46ff-b006-7c974bc58cf1",
      "event_cluster_id": "7c268167-b621-480c-ba79-7005ed13e2de"
    },
    {
      "claim_cluster_id": "910b6c18-44e1-4b51-b616-1f6016486c69",
      "event_cluster_id": "61d1a73d-bcca-4e5e-a4fb-5d21b8a13b97"
    },
    {
      "claim_cluster_id": "8cc2fa20-28d1-44d8-bdd2-f42d8dc30f18",
      "event_cluster_id": "80650d11-8f1c-4d32-a46d-12e884243f7e"
    },
    {
      "claim_cluster_id": "d583e7b2-dc4a-4915-a3d9-e76bbe714788",
      "event_cluster_id": "41dff0a8-a265-4edb-a001-023373b9ecf5"
    },
    {
      "claim_cluster_id": "1b178ff0-cd2a-415f-bd8a-4daf71e452c3",
      "event_cluster_id": "1249af1e-88d3-4d61-950a-0799adc2edf0"
    },
    {
      "claim_cluster_id": "2c834413-ef2b-486b-81d5-2e0a687a8ca7",
      "event_cluster_id": "08d9382c-bb74-4062-afa8-3c8c1526980f"
    },
    {
      "claim_cluster_id": "6b8a2895-80e5-4b3c-853c-39abf201a8b0",
      "event_cluster_id": "abb66c4f-f4a0-43a2-8032-f5ceeec7f058"
    },
    {
      "claim_cluster_id": "a0fab421-41ab-435c-b6c1-ee353c134771",
      "event_cluster_id": "13e00f68-1db0-4207-bb35-e56787801241"
    },
    {
      "claim_cluster_id": "7eddd539-ebe9-47f6-b0c9-dd9f02f0c8a0",
      "event_cluster_id": "d7895c1b-fc75-4aef-87f4-799e18058cdf"
    },
    {
      "claim_cluster_id": "949ec20d-24b3-4de5-a36b-32e35cbe9392",
      "event_cluster_id": "dd4b1ab9-a797-483e-b837-bc9140aab68d"
    },
    {
      "claim_cluster_id": "bfd0fa79-f057-4e1b-abfc-222496dbeabb",
      "event_cluster_id": "ea84d1ec-6a21-4123-9c3e-41ce618815e9"
    },
    {
      "claim_cluster_id": "4e7d68ff-7bd2-4949-affb-c71a8a76240a",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "ba035925-8a5f-42d0-aec3-c91702a47b8d",
      "event_cluster_id": "d9bde049-6b0f-4d26-ad61-29d5b4dc2bc8"
    },
    {
      "claim_cluster_id": "55f659a1-e5dc-41c5-8a43-9846f564af08",
      "event_cluster_id": "e1c37a48-126a-4576-b497-f9db46d18555"
    },
    {
      "claim_cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
      "event_cluster_id": "1e8a7861-14e4-4a42-b74d-73c7bec3ba5f"
    },
    {
      "claim_cluster_id": "28feb358-2926-4cba-8425-f09fe5ebab7a",
      "event_cluster_id": "94bb7f1c-2d8c-4580-8fb1-a174bd27e088"
    },
    {
      "claim_cluster_id": "108c6941-b645-4904-86a8-cfa0fa34274e",
      "event_cluster_id": "8f3f9d3c-bc51-4937-8cc3-be36bcc68b12"
    },
    {
      "claim_cluster_id": "626c75be-9b85-4ac5-97e0-e03b79d0191e",
      "event_cluster_id": "f287b9aa-9568-4d24-870b-96f86f040792"
    },
    {
      "claim_cluster_id": "98177424-a992-4818-bd6e-9e0e3d0899af",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "463ff506-01da-43ee-96ab-3704e89855e2",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "6635c105-dcdb-4bd7-9a1d-4db57f43d53b",
      "event_cluster_id": "810e8947-ee09-42d3-8a66-c23cbae93d9c"
    },
    {
      "claim_cluster_id": "d87f03ea-124e-4e30-80f4-ce890ca4d97b",
      "event_cluster_id": "0103bebb-a8e1-4ccf-b716-fa6fd4687ac3"
    },
    {
      "claim_cluster_id": "06aec0e1-946f-46e8-835f-efac40b3f6dd",
      "event_cluster_id": "e8b94f0c-0366-40d5-b082-fa52ed608677"
    },
    {
      "claim_cluster_id": "d59582f7-7e86-41f9-a084-db1da2a740db",
      "event_cluster_id": "9a5830fb-a855-4c85-8daf-ed1be558a290"
    },
    {
      "claim_cluster_id": "4ef708bd-198e-4a9e-9652-a1b08bc50fd9",
      "event_cluster_id": "b79a6948-c2a3-43ae-83f7-90168d6803ac"
    },
    {
      "claim_cluster_id": "efb75ced-ba33-4f51-8892-e54a26a45d00",
      "event_cluster_id": "3f7ede9c-8bb9-4467-8e40-0d78aa0f2a1a"
    },
    {
      "claim_cluster_id": "151738b2-0d24-44aa-896c-fa16a74db380",
      "event_cluster_id": "5437d23d-a8b8-4a7b-b296-c42b5945a223"
    },
    {
      "claim_cluster_id": "62be0386-404f-434a-884b-4dc379430917",
      "event_cluster_id": "33b55b1e-2a6f-4f56-affb-50cf2ec05471"
    },
    {
      "claim_cluster_id": "536df2e4-b955-48b2-8a3c-5b06a58c9d87",
      "event_cluster_id": "05daa73c-fc4c-4000-9d0c-990f237b7870"
    },
    {
      "claim_cluster_id": "a5744137-28c3-42a2-94a7-6f90f74e8a86",
      "event_cluster_id": "2b9f39b1-41ca-4c32-b583-29e0cbea9865"
    },
    {
      "claim_cluster_id": "1e35c814-682d-4b74-be8b-2867b370b971",
      "event_cluster_id": "03b556ab-fe42-4f7d-954a-c2484c0fac43"
    },
    {
      "claim_cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "event_cluster_id": "3277c81f-d2ed-42ea-acc4-bb977e68f163"
    },
    {
      "claim_cluster_id": "75739be5-4b25-48e8-8d9d-d6319de6bd95",
      "event_cluster_id": "d79d62e1-d874-49ae-865e-dccd822f8d8e"
    },
    {
      "claim_cluster_id": "0f047203-3949-4e82-86d9-77d6fe7af9c8",
      "event_cluster_id": "0be74e36-e76b-4fc7-9f69-d42f28778f07"
    },
    {
      "claim_cluster_id": "d67b58dd-cbc9-4a99-aab7-b31e7a922343",
      "event_cluster_id": "d349da51-4e48-4c7b-8b12-6a3dc4608c75"
    },
    {
      "claim_cluster_id": "c8cf7c39-4d6a-4fec-8451-b46f12ccd07f",
      "event_cluster_id": "8c96de89-87b9-4c63-a1e4-fab8f67f7294"
    },
    {
      "claim_cluster_id": "02e82f7d-c446-4fc6-9794-94910a46d2ac",
      "event_cluster_id": "ed113c66-0348-4af6-b4bc-60c420311e2a"
    },
    {
      "claim_cluster_id": "db897944-fc77-42b4-ab1a-b566912e00b0",
      "event_cluster_id": "4d738b05-171a-40b9-a505-e237572de24e"
    },
    {
      "claim_cluster_id": "541a6555-c116-4473-b1ae-ac7c48578f3d",
      "event_cluster_id": "ff2f8c85-c8d6-49c6-8138-1b205db9afe6"
    },
    {
      "claim_cluster_id": "fc1c32c1-8212-46dc-b3e4-29a2254a34ba",
      "event_cluster_id": "bc76f539-3671-4e32-b4e8-b1326e7f32a8"
    },
    {
      "claim_cluster_id": "e52244b2-1143-48cf-9735-ce26094681d1",
      "event_cluster_id": "817f89c1-1d6c-4c1f-968d-c42db0a618b8"
    },
    {
      "claim_cluster_id": "6fa599b7-9959-44ea-a8f2-40b7f43bb558",
      "event_cluster_id": "a42bed59-a9d3-4a76-b9d2-41f637803b1b"
    },
    {
      "claim_cluster_id": "8a60fc08-ff21-49d9-8858-dcff37e21d18",
      "event_cluster_id": "2e1f7f19-b115-4df8-ab1f-76f94814091c"
    },
    {
      "claim_cluster_id": "4cf8f034-c2c7-4891-81cd-bb23d16f75ec",
      "event_cluster_id": "8b09afca-ca08-48bc-a085-c49c60e79592"
    },
    {
      "claim_cluster_id": "3200fc3a-bd08-4faf-ac3c-69eb812ef575",
      "event_cluster_id": "bddeb0a4-a8d3-413c-8b74-f7a5d1e4bffa"
    },
    {
      "claim_cluster_id": "36ed05e4-cb6f-4b4e-a07c-39d608cb863f",
      "event_cluster_id": "d4181e9f-8d0f-420c-9032-de5764ee8344"
    },
    {
      "claim_cluster_id": "c3c67b90-f64b-4b19-8a14-0325205ef32e",
      "event_cluster_id": "1b5a113e-43ba-4a33-a76b-09db6a2b33ef"
    },
    {
      "claim_cluster_id": "51f9e6ae-7c8a-46e3-8fa3-070377ae9030",
      "event_cluster_id": "7aab4a1b-073d-4317-accd-dca275b73d33"
    },
    {
      "claim_cluster_id": "17eaa25c-625f-4414-b1ad-78d904209f81",
      "event_cluster_id": "e7c86122-ad9f-42c0-8185-4eb16e495061"
    },
    {
      "claim_cluster_id": "253e1524-e402-4a4d-b7db-f94b8f989d9c",
      "event_cluster_id": "d8065be4-6b3d-42e3-9693-9cfaa110346b"
    },
    {
      "claim_cluster_id": "db13aa73-f539-42d8-89d9-1af57cfff5a3",
      "event_cluster_id": "7f537263-14e5-41a9-8479-1de5e6a80076"
    },
    {
      "claim_cluster_id": "bfd0fa79-f057-4e1b-abfc-222496dbeabb",
      "event_cluster_id": "4815ee62-ac65-4840-9797-7e3f61c900fd"
    },
    {
      "claim_cluster_id": "77de864b-c2fe-4a23-a506-d0665b0f08bf",
      "event_cluster_id": "fa366373-444d-4a8e-8a61-fb8973c8426c"
    },
    {
      "claim_cluster_id": "bbc8c147-b447-4af6-82fb-e416f6108e70",
      "event_cluster_id": "f5124798-4595-40cb-94e4-b0f1143b648a"
    },
    {
      "claim_cluster_id": "d089a914-1c7d-48b8-9c48-7a1b65f152b1",
      "event_cluster_id": "c56ca589-59b3-4908-bbf1-fd162bba08a0"
    },
    {
      "claim_cluster_id": "7e265407-1dda-4e06-a69c-824b7e191f01",
      "event_cluster_id": "aa7dc853-a837-4fc7-af4d-cebbf4726b31"
    },
    {
      "claim_cluster_id": "4575f267-4553-4c7c-916e-359800e4fb24",
      "event_cluster_id": "3f1ec78d-49c2-44d1-bdc2-97cf6217c638"
    },
    {
      "claim_cluster_id": "bbf2648f-d211-49b0-bf5c-a562e43902c5",
      "event_cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6"
    },
    {
      "claim_cluster_id": "9971c68f-8d21-4436-a5d3-4897996181e7",
      "event_cluster_id": "1396142d-5fd2-4c3f-8a9f-e0d1627fb926"
    },
    {
      "claim_cluster_id": "b5aab15d-0623-4834-b9a0-c066e3616369",
      "event_cluster_id": "ed35cf79-8410-4493-b5e5-ebfe6d51aab0"
    },
    {
      "claim_cluster_id": "7cacaa03-4763-4931-91bd-306a3231361c",
      "event_cluster_id": "0c342dd1-f7b7-40e1-b189-103549ddece7"
    },
    {
      "claim_cluster_id": "b5b35a39-f79a-45e8-82ea-b87d21bbba55",
      "event_cluster_id": "2e14d9d5-92bd-4d6d-84c3-0127651e89de"
    },
    {
      "claim_cluster_id": "a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f",
      "event_cluster_id": "2648c3b9-64e2-4596-9353-c37ae996dcce"
    },
    {
      "claim_cluster_id": "551e444f-6554-45dd-baba-6798fd43af6b",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "de1f8a69-eaff-4387-87ee-35fc20ea4a2f",
      "event_cluster_id": "4adc477b-ccba-4820-b5c6-6a663398b338"
    },
    {
      "claim_cluster_id": "5389eae7-83b1-4726-86c2-9a8dff51be59",
      "event_cluster_id": "e8fdd463-9207-4e60-a84f-71fa88bf5a1b"
    },
    {
      "claim_cluster_id": "8e873c15-6407-475e-841a-2dcbbce28e18",
      "event_cluster_id": "13e45fa8-d3c0-4dcf-9891-87d1abf0b71a"
    },
    {
      "claim_cluster_id": "ba2401d3-a8f2-4ce4-bda0-30f38f532e31",
      "event_cluster_id": "212923c3-f34e-4b5a-bb85-95bfbbff9db0"
    },
    {
      "claim_cluster_id": "74e38083-39b2-4b0b-8874-879983366a75",
      "event_cluster_id": "1a52a7c3-2c3f-447c-9a23-15f3ea781daf"
    },
    {
      "claim_cluster_id": "84874fe9-a25d-4d9f-9765-de9280d477c0",
      "event_cluster_id": "58acdbed-8f15-402c-b1b3-c0a3be3ee80e"
    },
    {
      "claim_cluster_id": "060a7355-d23c-448a-8514-2034a0d11495",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "b26a4469-2931-4dab-aa78-be1b6fba8a36",
      "event_cluster_id": "43787e95-8e23-4c32-ad24-6b1efd3b0be2"
    },
    {
      "claim_cluster_id": "4692c588-5e24-491c-9044-3d7dd7c0a2d7",
      "event_cluster_id": "2b4b4bf2-1300-4817-8f72-f629847abed8"
    },
    {
      "claim_cluster_id": "81fccffb-0c5b-4efd-826c-64c3efbb0393",
      "event_cluster_id": "314440c8-19da-496d-8536-f62999889410"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "a4f84d58-e9f3-4a41-a8f9-b81736f1cea9"
    },
    {
      "claim_cluster_id": "327ec0a5-4419-4d23-90f1-e220df70fed7",
      "event_cluster_id": "3a423758-4300-46f1-8112-c2195cd0ee0a"
    },
    {
      "claim_cluster_id": "b39ca7cb-8663-4bff-829b-b432d59670f9",
      "event_cluster_id": "67498cc0-4b03-4712-95a1-69a6b340282a"
    },
    {
      "claim_cluster_id": "4a4d472c-cd13-4ccf-9f30-e866d14bdbf8",
      "event_cluster_id": "591739f1-b375-4e55-9c3b-ffe5cb8186ce"
    },
    {
      "claim_cluster_id": "9f14caef-27ce-4bca-afff-6e691839a8df",
      "event_cluster_id": "f85fc07c-cf3e-43c8-9d67-6a3594e4fc3d"
    },
    {
      "claim_cluster_id": "fdc7a586-a2b7-43cb-897c-5aacc04ceaff",
      "event_cluster_id": "33b55b1e-2a6f-4f56-affb-50cf2ec05471"
    },
    {
      "claim_cluster_id": "aa440a76-9b1c-4801-9031-cdac4add116a",
      "event_cluster_id": "feaafeab-4622-43a8-9ce7-52d22835a7d7"
    },
    {
      "claim_cluster_id": "0727da75-801a-4ea8-bc54-bca9f4c0cbfc",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "63e3781f-5042-452b-a77e-11f62bb59587"
    },
    {
      "claim_cluster_id": "807e0902-55ee-4c2b-a271-40fd2fb58b9a",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "5beed7c2-e377-4032-9f8d-5e0e7f3ae7e7",
      "event_cluster_id": "34a8290a-940e-4582-8dbf-cb195db85e28"
    },
    {
      "claim_cluster_id": "bbf2648f-d211-49b0-bf5c-a562e43902c5",
      "event_cluster_id": "a3452ca9-6c41-42fe-8fb7-9b272b7a106d"
    },
    {
      "claim_cluster_id": "291e098d-0f3d-4fff-9906-3b21ed1a33a1",
      "event_cluster_id": "9a04913f-01c4-45fe-aacb-81aaa1af85ae"
    },
    {
      "claim_cluster_id": "01c08614-0081-4fbf-86e8-a41b845bc4f5",
      "event_cluster_id": "9914f862-3a85-4664-87c6-f266c89775cc"
    },
    {
      "claim_cluster_id": "a4d61819-30e3-46aa-ab08-cf879db00de1",
      "event_cluster_id": "b959db9a-a488-4838-97f9-4b51827755fb"
    },
    {
      "claim_cluster_id": "9f936fe4-6962-4447-9269-bd4c45c0f95e",
      "event_cluster_id": "0d47b48b-a9c1-49b3-8e15-26d394b843ea"
    },
    {
      "claim_cluster_id": "6bdcff96-571d-4879-91a7-d6084340625f",
      "event_cluster_id": "7e615b29-206f-45ec-8b7c-74785c5252c8"
    },
    {
      "claim_cluster_id": "7eb7c781-85c0-4773-8374-eeb7374b471d",
      "event_cluster_id": "5db2dd2a-560f-4f51-8086-9e7ff5236782"
    },
    {
      "claim_cluster_id": "41369b57-1c08-440a-90c0-cacb7036a45e",
      "event_cluster_id": "abe67163-2626-42e7-98cb-6e8083622029"
    },
    {
      "claim_cluster_id": "47085082-7091-436e-a3ee-ecf14c90e1a5",
      "event_cluster_id": "d74efe6e-e929-4c10-ba6b-80c58b26fa38"
    },
    {
      "claim_cluster_id": "62083248-470f-4a86-883c-26267fb22566",
      "event_cluster_id": "40850d8d-b18a-4d10-bfba-dd521fe3cd4d"
    },
    {
      "claim_cluster_id": "5c1d5636-b62a-4962-911d-1136d9629b6a",
      "event_cluster_id": "1ff86b5f-b9df-4809-8840-440abb97575d"
    },
    {
      "claim_cluster_id": "1e19ebda-0ce5-4c42-b6ac-f081acdf5974",
      "event_cluster_id": "1e6f5910-b91c-46ca-bb2a-bace35349e8b"
    },
    {
      "claim_cluster_id": "69483fde-1234-4c7a-8580-5490aec071f7",
      "event_cluster_id": "b46bab47-6915-405b-a8fa-be8c999e4b4c"
    },
    {
      "claim_cluster_id": "4f63d722-2816-4701-89a0-6f6efadc8656",
      "event_cluster_id": "ff9ad8d9-d483-4daa-86f0-12ffd12f76b0"
    },
    {
      "claim_cluster_id": "758ea826-ee1f-4a18-bdaa-e713f20f5573",
      "event_cluster_id": "fa3326c6-c29d-4ee9-93ae-25dfe12b02b0"
    },
    {
      "claim_cluster_id": "e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37",
      "event_cluster_id": "64571139-4782-47d8-abc3-d973ded5245b"
    },
    {
      "claim_cluster_id": "60269200-21dc-4ddd-bed2-414eb8acfbb9",
      "event_cluster_id": "3e3518da-eab0-4220-8961-2d5489b4e97a"
    },
    {
      "claim_cluster_id": "ae201524-ae4c-4b92-afa7-2801ac429060",
      "event_cluster_id": "e72ec6a2-4890-4444-8e7d-1a5032e251dc"
    },
    {
      "claim_cluster_id": "a9a65207-69ea-45b8-ac25-c8ee16fc4a08",
      "event_cluster_id": "f16aab95-d35f-4386-9ea4-6a5f797bcf7f"
    },
    {
      "claim_cluster_id": "060a7355-d23c-448a-8514-2034a0d11495",
      "event_cluster_id": "c85617d1-a799-4927-848f-0f8d387e35f0"
    },
    {
      "claim_cluster_id": "09c923c5-0d10-40d6-8825-821711e43905",
      "event_cluster_id": "32cbf301-8c69-47b6-aa84-5617ee08686a"
    },
    {
      "claim_cluster_id": "0727da75-801a-4ea8-bc54-bca9f4c0cbfc",
      "event_cluster_id": "c320799e-ed57-4715-bbb9-1237e2fe3842"
    },
    {
      "claim_cluster_id": "ff7a6df5-d64b-4e14-803a-5339b1cffda2",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "06a88819-5b14-47a3-9604-8a61db70f52b",
      "event_cluster_id": "87cb3f5b-d497-49ea-a871-f34d7080b10b"
    },
    {
      "claim_cluster_id": "732c6dc2-1231-46ca-b1c1-173c0f488176",
      "event_cluster_id": "13dc8122-3135-4fd1-a900-1e2308b14e34"
    },
    {
      "claim_cluster_id": "f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f",
      "event_cluster_id": "c6f49d61-1bb8-4b16-b016-0bde6b721c6d"
    },
    {
      "claim_cluster_id": "4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1",
      "event_cluster_id": "ff62f156-1b54-448d-8c41-0514a58493a5"
    },
    {
      "claim_cluster_id": "6d2a1320-d829-403b-913c-d7cdbf1cbf14",
      "event_cluster_id": "8ee4279e-4251-4f38-b5e1-7ebd99d489b8"
    },
    {
      "claim_cluster_id": "3ea1c92f-805f-4ecb-b23d-a77a7a362e5b",
      "event_cluster_id": "d22d7383-71e2-4520-a5b2-8ae266a5a780"
    },
    {
      "claim_cluster_id": "0c50e809-0f1b-4656-a0dd-110732b6e47b",
      "event_cluster_id": "eab0b5ad-eda0-47fc-89d0-b12331740c85"
    },
    {
      "claim_cluster_id": "7cad6507-3550-4760-99ab-581f5b103f29",
      "event_cluster_id": "78ea610b-38fc-4528-87fe-af950e4ad514"
    },
    {
      "claim_cluster_id": "74e38083-39b2-4b0b-8874-879983366a75",
      "event_cluster_id": "4991bbaa-4137-4e4c-b3d4-b54d2fc23ddc"
    },
    {
      "claim_cluster_id": "d41663c0-a43a-40f6-ae8e-9e6eeb720de9",
      "event_cluster_id": "0e23ab63-e410-4477-a70e-2df0f99242c1"
    },
    {
      "claim_cluster_id": "970a5cc7-9a05-4850-b0f1-f59128c441c8",
      "event_cluster_id": "4074f92b-f1cb-43a1-a970-018d582db2d6"
    },
    {
      "claim_cluster_id": "64f152e4-be60-464e-a365-613ea259a5ff",
      "event_cluster_id": "bb7d1261-e586-4986-8419-b3678b999f37"
    },
    {
      "claim_cluster_id": "c7013046-8aa1-434c-87b8-1e3317f5578c",
      "event_cluster_id": "4c667681-74f7-4591-9add-d06796315d33"
    },
    {
      "claim_cluster_id": "d6c74194-ae1f-4099-a13b-0f247e76b288",
      "event_cluster_id": "42f681bf-3cec-44f4-9b59-d7168d922923"
    },
    {
      "claim_cluster_id": "6d0fc82b-e82f-4ea0-897a-429340b5d2e7",
      "event_cluster_id": "bfbf1707-08cb-4022-8bc5-78477fc5de4e"
    },
    {
      "claim_cluster_id": "170448e1-fefc-424b-b5a4-23941f88389e",
      "event_cluster_id": "7c038a6d-dd5c-4d1e-a387-d5620daf9907"
    },
    {
      "claim_cluster_id": "6717f23b-7a46-4774-9d7d-76c5eb0bdde2",
      "event_cluster_id": "a3899865-60a9-4162-9d1f-4bd867347d37"
    },
    {
      "claim_cluster_id": "6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4",
      "event_cluster_id": "474921fd-8a8d-4c36-8ea4-d0c78016b2c8"
    },
    {
      "claim_cluster_id": "9d4328c2-e9a9-4e75-b63e-6e88d7b536f1",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "729ff499-2dcf-4524-91fd-7e53fd6e6ad7",
      "event_cluster_id": "29fc6217-0253-4ea5-924b-34a8cdd037cd"
    },
    {
      "claim_cluster_id": "1d2ba60d-53c7-4e8c-91e5-1d0e114d5708",
      "event_cluster_id": "34b25787-92a3-4162-bcdc-435c1ba9cd55"
    },
    {
      "claim_cluster_id": "541a6555-c116-4473-b1ae-ac7c48578f3d",
      "event_cluster_id": "e5fa93bf-fdd9-4c91-8fb4-7d6499900667"
    },
    {
      "claim_cluster_id": "b5b35a39-f79a-45e8-82ea-b87d21bbba55",
      "event_cluster_id": "b4a8f883-fff2-467a-ae3a-3ea74c8cac30"
    },
    {
      "claim_cluster_id": "0ee142b2-6805-43f4-b8d5-34f76c2c799e",
      "event_cluster_id": "aaac8e79-68d5-45a4-b3d7-7bcd6881a93c"
    },
    {
      "claim_cluster_id": "9398c496-5e62-4d1b-94c1-e1eeaf48778c",
      "event_cluster_id": "c219e535-0099-4f3c-9221-b32e8ae0d9a9"
    },
    {
      "claim_cluster_id": "bfc6790e-9007-4b03-90bf-5da6fcce01b7",
      "event_cluster_id": "efac6d2d-0cde-45fa-bbfd-2de2e2cbe0cc"
    },
    {
      "claim_cluster_id": "1e35c814-682d-4b74-be8b-2867b370b971",
      "event_cluster_id": "060c1552-a1b7-4db4-9a85-766d6baf3560"
    },
    {
      "claim_cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "event_cluster_id": "63e3781f-5042-452b-a77e-11f62bb59587"
    },
    {
      "claim_cluster_id": "60269200-21dc-4ddd-bed2-414eb8acfbb9",
      "event_cluster_id": "6ad057c3-3463-4e5c-9a22-5186dd44f814"
    },
    {
      "claim_cluster_id": "9960f165-6141-4ca0-8dc4-0a136bfde83d",
      "event_cluster_id": "d2d04da3-8b22-4ac9-819e-ca8c7ec67255"
    },
    {
      "claim_cluster_id": "565a8eff-d3c3-4887-a42a-b357e222a101",
      "event_cluster_id": "a868051f-7c6b-4631-b5c0-5298f1a4a3bc"
    },
    {
      "claim_cluster_id": "f7c875b0-a0b4-45f6-b382-0915f179b2e6",
      "event_cluster_id": "065d4388-2dbc-4873-991f-3569f0444b8e"
    },
    {
      "claim_cluster_id": "c75ee75a-e51c-413b-b72e-c2160bcb40c1",
      "event_cluster_id": "c236b253-d4f6-4796-aa07-7b8f0eb372e6"
    },
    {
      "claim_cluster_id": "11aef681-a744-409f-8cc3-69822e3a86b2",
      "event_cluster_id": "eaaf5d8a-fedf-4978-9ba0-14aae1ce95e7"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "cd2c9191-f97a-49fd-9d7d-f0744cdaaf72",
      "event_cluster_id": "faa4667e-011a-4693-8171-40e817256b60"
    },
    {
      "claim_cluster_id": "d5ad62ab-dd96-48fa-a092-0724cb0c06f6",
      "event_cluster_id": "8feebef1-9f0d-4302-8835-37de98ad3cf7"
    },
    {
      "claim_cluster_id": "554575d4-0201-41f5-aa4b-d48a76e37311",
      "event_cluster_id": "22a9a9e1-a369-4cff-a2ae-69fa0403d590"
    },
    {
      "claim_cluster_id": "0726cfa9-d89b-45b4-922f-553fde14346a",
      "event_cluster_id": "97a2e6d5-9f35-4464-ad73-ec9b3ab0029e"
    },
    {
      "claim_cluster_id": "83150260-cbcb-429e-8e22-0e5b897618ff",
      "event_cluster_id": "ca6289c9-7aca-44b6-8a18-1a2d2282cd8d"
    },
    {
      "claim_cluster_id": "b4a81fcd-1fa0-4fbe-88f0-692419c6082a",
      "event_cluster_id": "4833448d-d892-46bf-bb0b-2903956326da"
    },
    {
      "claim_cluster_id": "c462838a-420c-4b5a-ad06-676939effe93",
      "event_cluster_id": "9a5d054e-318a-4826-9d5f-20df372185b2"
    },
    {
      "claim_cluster_id": "b4ee4418-ee26-4134-986b-8e220ef5da22",
      "event_cluster_id": "c5882250-4bcf-4c65-93ec-7937e1c0803f"
    },
    {
      "claim_cluster_id": "dcc1a857-7e25-4b1e-bb30-c67434a5f183",
      "event_cluster_id": "823bf086-9c7b-424a-8c1e-a0823a4017d5"
    },
    {
      "claim_cluster_id": "4cf8f034-c2c7-4891-81cd-bb23d16f75ec",
      "event_cluster_id": "65f08a18-b069-4ad1-8cde-ea7ebd30b6db"
    },
    {
      "claim_cluster_id": "1f8ca860-66b4-4b57-a63c-e13332662c2e",
      "event_cluster_id": "81106289-cb37-45f4-a937-0b81bb6b136a"
    },
    {
      "claim_cluster_id": "327ec0a5-4419-4d23-90f1-e220df70fed7",
      "event_cluster_id": "58af047e-cbeb-4069-98f9-896633d3674d"
    },
    {
      "claim_cluster_id": "33f6801a-acda-4c2e-9708-cf1802dbdbb9",
      "event_cluster_id": "6d9e58c9-dbd4-4963-8fe7-594077a6324e"
    },
    {
      "claim_cluster_id": "2ac87cef-db31-40dd-8c5e-d88d478fd344",
      "event_cluster_id": "1484b9dc-5ed0-4d22-945e-34e17801439c"
    },
    {
      "claim_cluster_id": "5a6d9d35-00b4-429a-8850-2262dfa520df",
      "event_cluster_id": "f1494984-39fb-445c-9005-4614903b112c"
    },
    {
      "claim_cluster_id": "4259fe50-2c67-4157-ba4a-43d33835df49",
      "event_cluster_id": "68efa2f8-df62-4c55-a56e-6a0d6368d6f1"
    },
    {
      "claim_cluster_id": "770cc261-67a7-4ed4-85d2-93916689a978",
      "event_cluster_id": "7b8722b8-a7de-40ea-80c1-4cf1e7b13571"
    },
    {
      "claim_cluster_id": "30765e40-3943-483b-8e1e-27d3053ae2bd",
      "event_cluster_id": "0ebb4caf-dfd8-4139-8988-6c07a96c4bd2"
    },
    {
      "claim_cluster_id": "21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb",
      "event_cluster_id": "9ff8b495-2fb3-4416-a1b0-68b8560f98e4"
    },
    {
      "claim_cluster_id": "5389eae7-83b1-4726-86c2-9a8dff51be59",
      "event_cluster_id": "d5f940cc-5da4-46b9-a86f-4006d64c39d0"
    },
    {
      "claim_cluster_id": "416e4c1e-869b-468f-91eb-bba4fac5108a",
      "event_cluster_id": "52f4f571-7b22-4977-98bd-7282b2a6c5c5"
    },
    {
      "claim_cluster_id": "0c0329e4-9982-4d5f-9450-241c86955685",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "7cacaa03-4763-4931-91bd-306a3231361c",
      "event_cluster_id": "6904ee21-68e2-4e99-baa3-968e34cb10b1"
    },
    {
      "claim_cluster_id": "25c37968-26df-4a13-8b6c-ef9270b22369",
      "event_cluster_id": "b64296b1-758d-4594-84fb-3ffa5aaa094b"
    },
    {
      "claim_cluster_id": "4d2dc30e-97f5-49d3-80df-c343048e6856",
      "event_cluster_id": "62c268b5-d8e3-4743-b673-44ec104402b5"
    },
    {
      "claim_cluster_id": "821946a1-401a-4657-be17-b3ed51371c13",
      "event_cluster_id": "ec791f7a-6542-44c8-9d59-4679b8301276"
    },
    {
      "claim_cluster_id": "fa484c7a-b508-4b38-90f3-04e6ca143d03",
      "event_cluster_id": "f2b5a4d3-d094-4fa0-812e-4687bf81efb7"
    },
    {
      "claim_cluster_id": "c604d802-912a-4abb-ba43-e290946de463",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "298b76c6-3ed3-4a84-8894-fa50a9f4234f",
      "event_cluster_id": "7d97e055-f53d-4979-b83c-8c058b074265"
    },
    {
      "claim_cluster_id": "4eb1a4b5-b71a-4034-93b6-28860ce56821",
      "event_cluster_id": "7897b080-7853-4261-9ab5-31b7495a5563"
    },
    {
      "claim_cluster_id": "33a57504-12fb-4d65-b0de-90b983174e92",
      "event_cluster_id": "8e7309fe-7380-453b-8dec-aa0848276b7f"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "0c9ec8a0-bb91-48f5-bf6f-13507a3c2374"
    },
    {
      "claim_cluster_id": "5b5bad5e-15a1-4d61-9521-27fe4f90522e",
      "event_cluster_id": "2972bcbb-a2e7-4468-bfb2-f2945b01a243"
    },
    {
      "claim_cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "event_cluster_id": "eff3ff70-7d42-45d0-a372-4aa15bf9f280"
    },
    {
      "claim_cluster_id": "9d85f9b8-6204-4844-9707-8c2e9351d730",
      "event_cluster_id": "58ab14ae-8edd-49c2-93f1-5410b8248aac"
    },
    {
      "claim_cluster_id": "2b4fc83f-18c3-4ff7-b918-64e0981dd3b2",
      "event_cluster_id": "65583e7e-9600-4791-b957-579c81276f1b"
    },
    {
      "claim_cluster_id": "c70207c5-86bf-4f7f-b715-56b9c8674c3b",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "2e620f14-db3f-4f94-9e90-7ae11cf68067",
      "event_cluster_id": "bac9b430-6b59-4b93-ba97-75f0f7b39814"
    },
    {
      "claim_cluster_id": "2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6",
      "event_cluster_id": "009689fa-763a-4351-a069-4f29c46a8fcf"
    },
    {
      "claim_cluster_id": "f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f",
      "event_cluster_id": "6fca3548-19e0-4797-8ca7-1e10435f142d"
    },
    {
      "claim_cluster_id": "d78f22d5-c64c-4786-833e-21ebb584c006",
      "event_cluster_id": "de50b1b9-cb34-4bb1-b3ae-d6dc4e19797d"
    },
    {
      "claim_cluster_id": "e44edb14-2754-4e0a-969f-2ab83f6f614c",
      "event_cluster_id": "1a503dc4-9b3c-4c99-a076-3e0baaa545f3"
    },
    {
      "claim_cluster_id": "3d9f2bb4-f1d6-41ac-be1a-ac1194130144",
      "event_cluster_id": "249e8c50-f68d-47af-99c9-2bc6ddfd52ad"
    },
    {
      "claim_cluster_id": "469e17e6-447a-4bc6-9bab-f2cb595f07e0",
      "event_cluster_id": "887d717e-5da6-4cf6-995c-bcee081cd128"
    },
    {
      "claim_cluster_id": "df20aee7-4e88-4c5d-a2d1-ce862c311713",
      "event_cluster_id": "b3909552-dab5-4658-b73f-34338b406557"
    },
    {
      "claim_cluster_id": "71211c39-a653-4c7c-bf55-0339568d069a",
      "event_cluster_id": "fb28be3e-346f-4ae2-b2c5-0971d759b337"
    },
    {
      "claim_cluster_id": "729d6508-b5df-44ab-8ffd-349b7a126b16",
      "event_cluster_id": "52587d0c-b6c9-4b93-964d-b5598a3e9ddb"
    },
    {
      "claim_cluster_id": "b1da6225-3a48-4f38-b0fb-dac29be99682",
      "event_cluster_id": "3ab13bcd-fc14-4404-8b26-7f8a67a82860"
    },
    {
      "claim_cluster_id": "b331f46e-c31d-4c56-81c9-c40834960e1f",
      "event_cluster_id": "ad92d574-8bb8-4072-be84-8313fb209fd6"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "0dc0d897-2bc8-412a-af86-95eb382d392e"
    },
    {
      "claim_cluster_id": "42302660-b692-4e66-870b-37970eee6c13",
      "event_cluster_id": "a83610f0-30d5-4dda-896a-6faaf1c01536"
    },
    {
      "claim_cluster_id": "9594285e-8196-4153-9b31-89250a7200d5",
      "event_cluster_id": "f96ee044-12e8-41d9-ad21-d1cd5c1012f8"
    },
    {
      "claim_cluster_id": "216f7d8c-4948-4e84-9b61-7c4fc880e123",
      "event_cluster_id": "d335936b-95df-4111-8cb1-decd8664543a"
    },
    {
      "claim_cluster_id": "c63decfc-559c-461a-ad2c-a9922b7e06df",
      "event_cluster_id": "3b30bb51-81c4-40b5-ba0f-a5b24a020dc5"
    },
    {
      "claim_cluster_id": "f502dcb8-0d11-41eb-afba-f50e74157a5b",
      "event_cluster_id": "99814cad-01e4-492e-93e2-a867761329f7"
    },
    {
      "claim_cluster_id": "0e6f398e-1206-46db-a98b-ff1425e1c634",
      "event_cluster_id": "59e292c0-ebb5-4e44-9c6c-162e21e21b97"
    },
    {
      "claim_cluster_id": "23106ade-18c8-44c0-8d3a-ef2f743468af",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "8b0aef83-1693-4fa2-8559-a133b18a2dbb",
      "event_cluster_id": "e250b185-4f74-4634-99e7-3af880f034a6"
    },
    {
      "claim_cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "event_cluster_id": "66d5fd65-8e6b-405c-9801-c7ba78bd49a4"
    },
    {
      "claim_cluster_id": "5cd897af-cb8c-4335-a548-c9963c43f060",
      "event_cluster_id": "e59d2cce-34c4-49db-b0fc-9ab7a956e929"
    },
    {
      "claim_cluster_id": "516d27f7-0cda-468f-b3b6-27af200d408b",
      "event_cluster_id": "e262a7ae-4e83-451f-b2c4-34917839f661"
    },
    {
      "claim_cluster_id": "4af97b54-9617-48e3-8125-aa1e8e1ee8a2",
      "event_cluster_id": "3f0004b6-308c-4518-9fbc-e6c906329ba4"
    },
    {
      "claim_cluster_id": "9012b6f3-2c16-482a-b276-63925d342482",
      "event_cluster_id": "18ad11bd-8c86-4313-a634-cae071e56b5c"
    },
    {
      "claim_cluster_id": "4eb17e7e-a0b8-41fd-aeb6-65f4c703f9b7",
      "event_cluster_id": "07e2576d-9585-4de1-8fed-5653ce340f18"
    },
    {
      "claim_cluster_id": "166b6595-ba80-4fe0-a5a2-70307703e855",
      "event_cluster_id": "54fd48d0-d138-4133-9478-030523c0c632"
    },
    {
      "claim_cluster_id": "e42f3c12-f894-47fd-b892-02c051609420",
      "event_cluster_id": "2ffd0f52-9465-49d4-9f47-900078ad3209"
    },
    {
      "claim_cluster_id": "c6b3d942-ded2-4171-9d53-bf87a1b48b52",
      "event_cluster_id": "2b11b446-8d3f-43d8-b5cf-fa4f7e28a0d7"
    },
    {
      "claim_cluster_id": "762409bf-96e2-43cc-99d8-45783ade1b1f",
      "event_cluster_id": "f520db2e-ca68-4285-80b9-7e45d3506ad3"
    },
    {
      "claim_cluster_id": "3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9",
      "event_cluster_id": "e42d141d-80cc-4e68-848e-2d85ecf6a58c"
    },
    {
      "claim_cluster_id": "ebad899d-9cc8-49e0-a908-87f53dd79063",
      "event_cluster_id": "af8cdf46-4050-4634-a0b0-6bc6cfa78956"
    },
    {
      "claim_cluster_id": "226ceb68-980d-4b72-b053-36c7b5c7f61b",
      "event_cluster_id": "dc60fa2d-dae3-4ea2-a4d5-1da4424a6919"
    },
    {
      "claim_cluster_id": "970a5cc7-9a05-4850-b0f1-f59128c441c8",
      "event_cluster_id": "70aec147-e46f-48a9-b67c-9dbf6b174338"
    },
    {
      "claim_cluster_id": "3200fc3a-bd08-4faf-ac3c-69eb812ef575",
      "event_cluster_id": "471e4e9c-4ca9-4ee9-ad65-9f3b0fd313ec"
    },
    {
      "claim_cluster_id": "cb7188de-21fe-4631-9d3e-697f1fa246b9",
      "event_cluster_id": "53924b3c-7098-4daf-8924-cb5ffede2096"
    },
    {
      "claim_cluster_id": "fc40e900-5f3a-4200-9723-06366e139ab4",
      "event_cluster_id": "d6e81e61-bb7e-4b41-8a70-469e0ff32a7a"
    },
    {
      "claim_cluster_id": "6eb878e4-969f-49ca-8ac8-5c68ead2c13e",
      "event_cluster_id": "dcbc849b-d40e-49ed-84ab-ec7cdf4bb695"
    },
    {
      "claim_cluster_id": "6cfce6ce-fb64-4bfa-a23f-01cbee46c275",
      "event_cluster_id": "c7824331-8340-4b01-8402-1e8e570e3b30"
    },
    {
      "claim_cluster_id": "fa361819-d60d-4532-8084-9c75390ba17c",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "event_cluster_id": "f55d5834-9821-4e96-8403-e81fdf294300"
    },
    {
      "claim_cluster_id": "0de86638-0241-412b-ab2a-b233d85153a4",
      "event_cluster_id": "f069a0c9-4a52-495b-8bf9-3f4d61e51c06"
    },
    {
      "claim_cluster_id": "eb68c709-6220-48fe-b376-95a4f6f10b6d",
      "event_cluster_id": "f4d98260-09b2-436e-8c76-b8fdadb8663b"
    },
    {
      "claim_cluster_id": "70a36c06-fbb9-4f71-bf77-74f433672b24",
      "event_cluster_id": "f5cfebe0-089d-4908-8224-abe95a565459"
    },
    {
      "claim_cluster_id": "fdbce6fb-9c6c-48ff-a187-88c668f79277",
      "event_cluster_id": "cb44bed2-b70b-436a-82dd-d405face631c"
    },
    {
      "claim_cluster_id": "840ac263-91de-449d-b701-c05a4522f3b3",
      "event_cluster_id": "32aeada3-2c0a-4dd6-b828-1733cea88e6b"
    },
    {
      "claim_cluster_id": "e4e03461-6763-4291-b9e4-bd4feccb46e2",
      "event_cluster_id": "24751f3d-988c-4f3f-9df5-95b8bdfa7bfb"
    },
    {
      "claim_cluster_id": "d9f9cf14-d4ad-4c0a-9482-99b75f7c247f",
      "event_cluster_id": "dd156ade-c3be-4db6-9779-46772fbd155f"
    },
    {
      "claim_cluster_id": "6222d4f0-7c6d-42f0-83ec-17412b1907f1",
      "event_cluster_id": "f7ca28bb-5007-4654-b846-b6e439b09815"
    },
    {
      "claim_cluster_id": "0261ee84-1c1e-4042-9226-f1085216eef2",
      "event_cluster_id": "aecd93e3-f175-4964-b3d0-1a8c1e2832bd"
    },
    {
      "claim_cluster_id": "2d7a7088-3ced-40a0-9677-1d14e1c26d8f",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "d6f2cb3f-8705-43f8-a523-1b8fab745bf8",
      "event_cluster_id": "6f88a50d-7c8b-451d-b706-e766cfe9a47a"
    },
    {
      "claim_cluster_id": "d2830923-6260-4e70-9fc4-f723af340d1f",
      "event_cluster_id": "e886744b-894f-4cf5-9248-234d88f9a4f4"
    },
    {
      "claim_cluster_id": "b198bd93-5f96-4992-9aa2-29e396814e39",
      "event_cluster_id": "f4e22611-4a8c-420d-98fb-79e2c70d616c"
    },
    {
      "claim_cluster_id": "78064e33-a38e-4112-b3b2-c02951368282",
      "event_cluster_id": "c2a59237-65bd-47ee-930d-7682f70bbe46"
    },
    {
      "claim_cluster_id": "a9a65207-69ea-45b8-ac25-c8ee16fc4a08",
      "event_cluster_id": "80a104b6-58c7-416b-ac35-97712361953c"
    },
    {
      "claim_cluster_id": "2d5d8472-462a-48f6-89fe-e8182a74e9c6",
      "event_cluster_id": "91c23991-d38e-40c8-af05-0cbccbeaf641"
    },
    {
      "claim_cluster_id": "166b6595-ba80-4fe0-a5a2-70307703e855",
      "event_cluster_id": "089a2747-9d4d-40cb-b33d-a36918c7e7a4"
    },
    {
      "claim_cluster_id": "8992a182-5ede-4dbb-9979-4dcf0e10c546",
      "event_cluster_id": "729b06af-76d6-45d8-b842-1a087ece3b39"
    },
    {
      "claim_cluster_id": "516e99dd-d52c-4f12-8e2e-b0ba0e0b515d",
      "event_cluster_id": "a19f2358-dc1d-4de3-8588-b9d055ccede4"
    },
    {
      "claim_cluster_id": "91e94583-4b9d-4847-9825-9ed7293c7a0e",
      "event_cluster_id": "7b391ffb-dc10-4ded-babc-680617024509"
    },
    {
      "claim_cluster_id": "b1da6225-3a48-4f38-b0fb-dac29be99682",
      "event_cluster_id": "395a3f4e-39fe-411b-af09-832b0bf2ab53"
    },
    {
      "claim_cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "event_cluster_id": "77e5cfa7-27f5-40a9-879d-0ba7cd2177f2"
    },
    {
      "claim_cluster_id": "516e99dd-d52c-4f12-8e2e-b0ba0e0b515d",
      "event_cluster_id": "c8feb5d9-ef93-4465-bcb1-5c7e4847fb27"
    },
    {
      "claim_cluster_id": "281fca06-ede2-40bc-9960-0788b1d20c23",
      "event_cluster_id": "984fa7e0-f763-4f19-b49c-d87ea5159954"
    },
    {
      "claim_cluster_id": "f9f7a124-b259-44e6-a922-abc880fe6775",
      "event_cluster_id": "7a33ed40-551f-4f38-8b8c-22ab137818a4"
    },
    {
      "claim_cluster_id": "eb68c709-6220-48fe-b376-95a4f6f10b6d",
      "event_cluster_id": "7a1d05c9-2872-4724-bfbb-1dbc30578c14"
    },
    {
      "claim_cluster_id": "74e38083-39b2-4b0b-8874-879983366a75",
      "event_cluster_id": "4c4cd4c7-1e1a-4df7-8ab4-db0129f7114b"
    },
    {
      "claim_cluster_id": "73dcede2-49d2-4bc1-a599-b15a7d0094cf",
      "event_cluster_id": "0c6eb85b-0ae0-403f-b2fd-990121d9ade3"
    },
    {
      "claim_cluster_id": "26ee8f8d-a289-4bb8-af4e-67dfc3cca301",
      "event_cluster_id": "b0630042-6031-4b80-9db0-071e1119e981"
    },
    {
      "claim_cluster_id": "4313d034-31f9-4eb9-9451-e9a5dda6e7c3",
      "event_cluster_id": "9e4b0a95-0efa-4ff0-926d-70d1dc9caff3"
    },
    {
      "claim_cluster_id": "9398c496-5e62-4d1b-94c1-e1eeaf48778c",
      "event_cluster_id": "9becb58f-9c06-4adb-8557-0a75a0444f56"
    },
    {
      "claim_cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "event_cluster_id": "ec3d0509-3f1c-4d1f-868c-ba7c16468992"
    },
    {
      "claim_cluster_id": "7885c5ae-734b-4d64-8d84-fc50b9a87ad7",
      "event_cluster_id": "1789e573-0855-4766-ab56-773e8cdbeef5"
    },
    {
      "claim_cluster_id": "28aee566-0979-4444-a6e1-cda00f681d91",
      "event_cluster_id": "ec98b249-f085-460b-ae00-454dc52d3f17"
    },
    {
      "claim_cluster_id": "ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8",
      "event_cluster_id": "637ffe03-032a-46cd-af4f-d7f5c220eab9"
    },
    {
      "claim_cluster_id": "55a85a41-dc09-4546-82c9-33ba7368eb9a",
      "event_cluster_id": "eba751d5-5124-4afa-a2aa-48fe3f60fcc8"
    },
    {
      "claim_cluster_id": "0e8e4003-b007-4df8-a1a5-948e64fe6342",
      "event_cluster_id": "35b591b0-9a65-46c0-95aa-caf3b8dedd33"
    },
    {
      "claim_cluster_id": "6778e0f8-10fc-4d30-8039-d81e67c9992c",
      "event_cluster_id": "867f94d2-2825-471a-801a-edc5c961ad9f"
    },
    {
      "claim_cluster_id": "69483fde-1234-4c7a-8580-5490aec071f7",
      "event_cluster_id": "2d1b7151-63a5-4414-9619-8c40fe20742a"
    },
    {
      "claim_cluster_id": "729d6508-b5df-44ab-8ffd-349b7a126b16",
      "event_cluster_id": "c3765121-fe92-4ebe-aef3-b794fa8089f1"
    },
    {
      "claim_cluster_id": "92df53c2-d00a-4565-ac4a-1279aad1b2ee",
      "event_cluster_id": "ac3739e2-de75-46fe-a991-203fbc3a72e0"
    },
    {
      "claim_cluster_id": "13ce1de8-c90f-43f4-ae08-251f1aed012e",
      "event_cluster_id": "75a7abcd-ccae-4606-800a-89412da639cc"
    },
    {
      "claim_cluster_id": "327aebea-facc-4b65-a419-a9d461f7aa0f",
      "event_cluster_id": "6b25848d-e565-4f9d-b442-93bdb20750d1"
    },
    {
      "claim_cluster_id": "ff763739-26e3-4daa-93bc-7ecf065c5275",
      "event_cluster_id": "63e3781f-5042-452b-a77e-11f62bb59587"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "e80fcdb9-26cc-4925-8100-e10e8d09e8d6"
    },
    {
      "claim_cluster_id": "de30ed78-2cf8-480b-aacb-665d9572f1b4",
      "event_cluster_id": "e3ef059e-984d-4158-bd79-7968854d515e"
    },
    {
      "claim_cluster_id": "31ba7a04-0212-474b-8f8e-9374845e4ab5",
      "event_cluster_id": "719904eb-28ef-4b29-997b-23331e60e444"
    },
    {
      "claim_cluster_id": "f3b06230-c202-438a-8858-b8c55fa68828",
      "event_cluster_id": "c700d9cd-e09d-4ea7-a33c-b8925d591d85"
    },
    {
      "claim_cluster_id": "7e29e69f-6e9a-409e-8641-59692b521453",
      "event_cluster_id": "a8627187-7d21-463e-a6ef-6ef26a6c6de9"
    },
    {
      "claim_cluster_id": "b12e5d28-73fe-498d-a612-a3df5aa876b3",
      "event_cluster_id": "5ac468f5-649c-43da-ae88-dccb98a0bb4f"
    },
    {
      "claim_cluster_id": "1b8ba3f8-2b51-4433-9cf8-2a5412413277",
      "event_cluster_id": "a96dc83a-238f-4ad4-81c6-dfc26af2869a"
    },
    {
      "claim_cluster_id": "404cf86d-d513-4c8d-adf3-7f2b9464b34e",
      "event_cluster_id": "5e6716fc-cf64-480e-8688-e74f2a213fd8"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "2c8b719a-2363-4f9f-9be2-6d1801374195",
      "event_cluster_id": "ffbf8347-0223-4c98-b559-e6237b6aac90"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "6c942642-582b-452c-868b-03a353a6eca9"
    },
    {
      "claim_cluster_id": "d602e1f1-5446-4c60-aadc-beabd56dedd8",
      "event_cluster_id": "ea7149f6-4e64-4cea-8d02-bf248f686ab1"
    },
    {
      "claim_cluster_id": "6a54c6d4-9e49-450e-95c4-f3afc0f85f6c",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "77119585-efc9-469f-8988-fdb1e15681f0",
      "event_cluster_id": "153479d3-dde3-44aa-83a6-d7e772a10308"
    },
    {
      "claim_cluster_id": "404cf86d-d513-4c8d-adf3-7f2b9464b34e",
      "event_cluster_id": "43d48fcc-7522-4b18-8344-e5b044e22838"
    },
    {
      "claim_cluster_id": "94c7e352-c14a-45a1-b0c5-cccdc2ef1122",
      "event_cluster_id": "24866e6f-4fd0-49f1-b25e-9d7dc5227353"
    },
    {
      "claim_cluster_id": "755e1910-15d6-4530-b0f7-b73a35ac9c64",
      "event_cluster_id": "5e5db8ed-e13c-449a-bc48-1985ab63a2df"
    },
    {
      "claim_cluster_id": "cf399998-137e-4270-8827-7c726197fb9d",
      "event_cluster_id": "0903a221-6399-44af-9542-80d1c25bc816"
    },
    {
      "claim_cluster_id": "232994db-dcd7-4db4-9ea3-fad6185233a7",
      "event_cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c"
    },
    {
      "claim_cluster_id": "f4e47d52-0a9c-4a42-9a14-47aece599116",
      "event_cluster_id": "26db1e00-6a4e-4036-b6ff-c1da87b844b6"
    },
    {
      "claim_cluster_id": "aaf51226-d11b-4c1b-82db-25727f24712a",
      "event_cluster_id": "71167ddf-4ec9-4903-a616-db6af6caed15"
    },
    {
      "claim_cluster_id": "1be65d4d-c915-41d3-9d1c-864035425656",
      "event_cluster_id": "9854342f-dc2f-4d81-9468-1aeed5b01c1c"
    },
    {
      "claim_cluster_id": "511c0db2-0769-45d5-a814-00f974a659aa",
      "event_cluster_id": "83e82b7f-d20b-43e7-8e8a-1a33199d549e"
    },
    {
      "claim_cluster_id": "4fe899cb-f73e-4ec7-b569-5ce5b990df8e",
      "event_cluster_id": "bc618add-d50a-4d41-b375-e0f4e3b7232b"
    },
    {
      "claim_cluster_id": "d20d47b3-a32a-48d4-a8d3-2dd3f07fe8a9",
      "event_cluster_id": "45a10488-1ec2-4731-8b23-f6d502ac13b4"
    },
    {
      "claim_cluster_id": "99dd456b-c805-4ebb-a82a-80fe2e06dff9",
      "event_cluster_id": "d2c0f044-52b0-4afb-ad04-975898224fdd"
    },
    {
      "claim_cluster_id": "7eb7c781-85c0-4773-8374-eeb7374b471d",
      "event_cluster_id": "e2a1f0e1-e053-4231-9242-7b160200d696"
    },
    {
      "claim_cluster_id": "19ddcd3b-18db-461a-b208-f198db3e1e07",
      "event_cluster_id": "ce6ec6f1-89a5-418d-adc6-e21b2c309bd1"
    },
    {
      "claim_cluster_id": "745389b6-9b21-4dd2-89bd-e66fab0ff334",
      "event_cluster_id": "56712450-0dee-4fc4-899b-8d6600a516cb"
    },
    {
      "claim_cluster_id": "28e936b6-8a48-4d96-b4e6-7c0ff60a51fd",
      "event_cluster_id": "63fb948c-76fb-4787-aafa-ea3ce79ec01f"
    },
    {
      "claim_cluster_id": "719ee837-abdf-462d-a985-984d0a2eb167",
      "event_cluster_id": "e512735b-aeb8-432c-9b72-89718eda18ba"
    },
    {
      "claim_cluster_id": "c63decfc-559c-461a-ad2c-a9922b7e06df",
      "event_cluster_id": "3c52b26e-a9d9-4bd3-979f-3455beaaaaec"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "a37e6820-0d6d-49d8-8dfb-fc94f1f84e73"
    },
    {
      "claim_cluster_id": "fdec6a13-5351-4fa5-9920-1456738e3b76",
      "event_cluster_id": "8b5f2de0-fd72-48f3-8849-4ef20748a393"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "7a111e6b-975b-4ed3-9b97-e727f9682f28"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "680ddc35-25cd-424c-8914-0f7a5b222416"
    },
    {
      "claim_cluster_id": "f854f83f-364d-470a-8cd8-f0bec2c15e68",
      "event_cluster_id": "35ff40d7-dc34-499f-b4dd-e76f13e34e0c"
    },
    {
      "claim_cluster_id": "6a54c6d4-9e49-450e-95c4-f3afc0f85f6c",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "5317331a-d0a9-4595-acad-210a92b278d8",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "e82ed51a-4d19-4b2d-96bc-cb54f9b70858",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "748c24aa-69c4-47c4-a75f-e6da7007b74a",
      "event_cluster_id": "b24ff026-a9a6-45e3-8927-422954af4cf6"
    },
    {
      "claim_cluster_id": "f80dd275-a1a9-4cb7-becc-0fe298aae99d",
      "event_cluster_id": "285237c2-514b-4d74-ada7-2be4ad6a801e"
    },
    {
      "claim_cluster_id": "f3735996-484c-447a-8fe4-4cd5c645a0a9",
      "event_cluster_id": "072ba410-0f15-42e7-9ef5-bee6285568c8"
    },
    {
      "claim_cluster_id": "dcc1a857-7e25-4b1e-bb30-c67434a5f183",
      "event_cluster_id": "2c59d86f-8c32-43d1-acd4-a598aa7665ee"
    },
    {
      "claim_cluster_id": "914ca89d-e967-443c-9856-6a5b040a0496",
      "event_cluster_id": "3b02e47c-e307-44b8-85bc-a7863107a268"
    },
    {
      "claim_cluster_id": "6f8b0a89-8965-4d5d-9b89-f48b23ed61a1",
      "event_cluster_id": "5a080de2-e14b-428a-ad25-1b9fd1bb59d4"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "f2df1c45-9507-438e-92d8-0a523b9a842a",
      "event_cluster_id": "7b263d1a-e07c-48cc-bbc0-8a228f72f292"
    },
    {
      "claim_cluster_id": "6e5c19c1-853c-4797-84d8-7f68386994d3",
      "event_cluster_id": "6030a19b-208f-4624-83fa-f8e8a264fea6"
    },
    {
      "claim_cluster_id": "b0b87d24-5072-4ac7-bf9b-5891dbcddd35",
      "event_cluster_id": "3a17531b-ae78-41a3-b63d-f61bcc85a26a"
    },
    {
      "claim_cluster_id": "b17129e4-a0b0-4a1d-a70c-02e08bb380d1",
      "event_cluster_id": "7b4680b9-9676-4736-8ed2-d06a2da6ea63"
    },
    {
      "claim_cluster_id": "3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8",
      "event_cluster_id": "371e032d-d57e-40c0-84fe-6f5fa1665409"
    },
    {
      "claim_cluster_id": "5b0ba6ac-d65c-49f0-9ed7-62610378c0e1",
      "event_cluster_id": "9c8fceaa-2d0d-4f1b-a084-86587c4a2652"
    },
    {
      "claim_cluster_id": "31ba7a04-0212-474b-8f8e-9374845e4ab5",
      "event_cluster_id": "df241613-e669-4ee0-b143-f0b24cc846e8"
    },
    {
      "claim_cluster_id": "33f6801a-acda-4c2e-9708-cf1802dbdbb9",
      "event_cluster_id": "86d55ce0-7b54-4708-b491-af72b9d9ff06"
    },
    {
      "claim_cluster_id": "463ff506-01da-43ee-96ab-3704e89855e2",
      "event_cluster_id": "901320c7-5066-4de7-b012-7a995d178683"
    },
    {
      "claim_cluster_id": "c46be245-9f63-495f-be19-e522e39c13f9",
      "event_cluster_id": "03a113b9-8fb7-4743-8425-b2ed80e37d97"
    },
    {
      "claim_cluster_id": "3dc0cbd1-b381-4df2-846d-e07147e83cbe",
      "event_cluster_id": "6afac47e-4bb6-44d8-a1c9-b3063690939e"
    },
    {
      "claim_cluster_id": "03b37d7e-0ed4-4014-ac24-a898719a8f87",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "6d12ca3e-2e36-40ab-9cf4-0663df64745d",
      "event_cluster_id": "558372cf-c982-49c8-8de6-cd0d8a987ae8"
    },
    {
      "claim_cluster_id": "08372c18-8eed-4c93-adee-9002e00e29bd",
      "event_cluster_id": "ed59d768-edd7-48c0-ac20-df8f0d6dc5d8"
    },
    {
      "claim_cluster_id": "b196eb88-ee2e-4367-8e6b-08f9890e6fe0",
      "event_cluster_id": "6c435a8a-93c9-4345-913c-85766d15d80c"
    },
    {
      "claim_cluster_id": "891e1da4-bfc6-4524-a5da-153bde60b165",
      "event_cluster_id": "a7593170-7dd6-490c-af81-f78a7c4b79b2"
    },
    {
      "claim_cluster_id": "96cc3b99-284a-4ca8-957e-5bfc2a13a654",
      "event_cluster_id": "0031fe05-7e53-4c0c-b89e-d86016e53d57"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"
    },
    {
      "claim_cluster_id": "a2f5a4b1-ccba-4cac-9bde-f079d3027db4",
      "event_cluster_id": "3a1ce373-9bb9-4921-899a-ff8f1e27a082"
    },
    {
      "claim_cluster_id": "269d367a-5938-4087-911a-3256c10a910f",
      "event_cluster_id": "2a3a89a0-063e-477e-a31a-17933d228f6f"
    },
    {
      "claim_cluster_id": "fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec",
      "event_cluster_id": "69a4b47b-f3fa-41cb-94e3-29a8741c8bf2"
    },
    {
      "claim_cluster_id": "c1b9998a-8864-4f22-be23-89209993bf02",
      "event_cluster_id": "8a948aba-63b5-4bbf-9ee5-595eefc57f01"
    },
    {
      "claim_cluster_id": "294d0346-cddf-4b1e-a6bc-ab4686137712",
      "event_cluster_id": "91d4dc33-e633-4d25-9203-969f15a268d3"
    },
    {
      "claim_cluster_id": "992ef0ee-f6fc-4177-b75b-0a3511a615a6",
      "event_cluster_id": "082dc58d-c56c-468c-82bc-39e8c62c9b6c"
    },
    {
      "claim_cluster_id": "b1da162a-fb28-4547-8fd8-715c5361b7af",
      "event_cluster_id": "bd0d52ba-bf23-4db8-aa70-86556a4740bf"
    },
    {
      "claim_cluster_id": "94f243ab-1521-4874-b5fc-b80847a7fefc",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "30229ad5-5242-4fd1-8256-d013e88e6413",
      "event_cluster_id": "f69427e1-c0af-413b-916d-3232db85e095"
    },
    {
      "claim_cluster_id": "2bd9ff92-4ea3-492e-a249-5de7759a5956",
      "event_cluster_id": "87e98045-d749-47b9-a158-8b7bfbd1d3db"
    },
    {
      "claim_cluster_id": "b0b87d24-5072-4ac7-bf9b-5891dbcddd35",
      "event_cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7"
    },
    {
      "claim_cluster_id": "63ad18c0-00c0-4509-b669-2aff507b5502",
      "event_cluster_id": "876ae960-2467-4ffe-b0e9-9cd336bdf4a1"
    },
    {
      "claim_cluster_id": "2cb0cf7d-4f72-4e53-9096-b92c1763568c",
      "event_cluster_id": "2e2d4dce-467a-4329-8a65-a9b7ada8d364"
    },
    {
      "claim_cluster_id": "221f2ccb-c412-4e42-8d5c-82e681a61d32",
      "event_cluster_id": "47f27689-5f68-430a-bf84-77af1b6dc7c8"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "9eca8644-57d0-4b18-b62b-b394d615bf38"
    },
    {
      "claim_cluster_id": "b320fe25-40ac-4b0e-8605-df06f6384218",
      "event_cluster_id": "823a1b7a-305d-4292-886b-7974a056d98e"
    },
    {
      "claim_cluster_id": "bd6de2da-8b5f-4e38-83bd-28294e175aca",
      "event_cluster_id": "075f6940-c670-4659-a33b-590bac9f8a7f"
    },
    {
      "claim_cluster_id": "3b355bb3-b565-4742-b6f4-50c6f509a1ec",
      "event_cluster_id": "cb34d24e-7722-4a18-bb1f-3ff1c0f4f310"
    },
    {
      "claim_cluster_id": "eb2ba8af-f927-478b-bc26-2105bdb87c5f",
      "event_cluster_id": "4361c487-2c7b-4ed5-a3bb-23c69a57f5ec"
    },
    {
      "claim_cluster_id": "a89a4b7b-c64e-4a3c-81e8-86dec8a3dad0",
      "event_cluster_id": "237a1bcd-f29b-4003-80f0-c4efc0c14bc8"
    },
    {
      "claim_cluster_id": "a7614301-2ae0-4bb1-bcf4-8bc8d82acc70",
      "event_cluster_id": "d28f03f1-166f-4e7a-a151-3bb7c1898209"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "e2b1886a-d41d-4169-be53-e4ed1b6d9d79"
    },
    {
      "claim_cluster_id": "52b4a518-aae8-40ab-8a78-e641ed7c28ce",
      "event_cluster_id": "b5c81785-6289-45db-a194-d9731e5e4109"
    },
    {
      "claim_cluster_id": "61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc",
      "event_cluster_id": "4f640a26-8edc-40de-bddc-8bc4a09eb227"
    },
    {
      "claim_cluster_id": "9e96a51d-6101-42af-b7a2-54e4dd5ae715",
      "event_cluster_id": "c74f353a-07b1-444e-8cd6-e07be020ae58"
    },
    {
      "claim_cluster_id": "621b2187-e651-4a6f-becc-2a2a2cd444a2",
      "event_cluster_id": "27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"
    },
    {
      "claim_cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "event_cluster_id": "0d91b295-8dc7-41f1-8c2e-38f85451d859"
    },
    {
      "claim_cluster_id": "1b178ff0-cd2a-415f-bd8a-4daf71e452c3",
      "event_cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14"
    },
    {
      "claim_cluster_id": "7553f34f-d61f-419e-8976-cecf89bafb0e",
      "event_cluster_id": "67ef8b62-b165-45e4-8df0-4a9253d62b61"
    },
    {
      "claim_cluster_id": "99b20734-bb32-4aff-b60b-a976139937c2",
      "event_cluster_id": "3531210e-caae-4d2a-9c81-92659900742b"
    },
    {
      "claim_cluster_id": "31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8",
      "event_cluster_id": "cb5fae82-58a9-4d49-9da8-1886e33d1269"
    },
    {
      "claim_cluster_id": "eb6a12b4-268e-4e39-8d84-ba73d40a7ffd",
      "event_cluster_id": "dd33f241-05d1-4f54-b214-172163f88f9a"
    },
    {
      "claim_cluster_id": "b398f217-24d9-4c22-8d5a-732320853c1b",
      "event_cluster_id": "e5eb0916-6642-496c-9615-8dbd59c7dd10"
    },
    {
      "claim_cluster_id": "32bf3674-86a6-4cde-a9e5-20a5e3965e02",
      "event_cluster_id": "844a0834-978f-47f2-bad3-00baad297b74"
    },
    {
      "claim_cluster_id": "2bd9ff92-4ea3-492e-a249-5de7759a5956",
      "event_cluster_id": "ead45298-e146-40a5-a729-dab15400b7c2"
    },
    {
      "claim_cluster_id": "3dd1bcbf-32ed-443e-a942-a8e7446ea6d1",
      "event_cluster_id": "d878f267-808b-4a23-9202-10d08ee3053d"
    },
    {
      "claim_cluster_id": "707f482d-8ff7-4cc9-a14d-99540ac35950",
      "event_cluster_id": "ee29d318-fee6-4bab-9dff-20d633b0297f"
    },
    {
      "claim_cluster_id": "1ef62c3d-3750-43b9-855b-d4624938de1e",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "a604694d-4fcd-48e0-a074-6eaa09488a89",
      "event_cluster_id": "1f4a4adb-de76-451d-aa05-57dc41f8014d"
    },
    {
      "claim_cluster_id": "e53d664b-c538-43f3-a025-7686ca315f8a",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "71211c39-a653-4c7c-bf55-0339568d069a",
      "event_cluster_id": "3e6833b5-d7ea-4b12-87f8-2eba62891434"
    },
    {
      "claim_cluster_id": "c0426c3e-a327-4be7-b689-905cba5cdfca",
      "event_cluster_id": "2ed4b8da-36cc-414e-9362-86f9b9a7a515"
    },
    {
      "claim_cluster_id": "a0698f9c-4bc8-48b3-b669-44befd54559c",
      "event_cluster_id": "fbf6086c-d11b-4ab9-9b6b-67f0d133c827"
    },
    {
      "claim_cluster_id": "4350947c-093e-43d1-91ad-c33f75e13a1e",
      "event_cluster_id": "e8860c87-9dc3-491a-8748-575a2d051898"
    },
    {
      "claim_cluster_id": "d9041723-b3d2-4f6c-85e6-435010ef6231",
      "event_cluster_id": "fe82d3f9-486a-46c2-97e7-5a1b97f02537"
    },
    {
      "claim_cluster_id": "d6f2cb3f-8705-43f8-a523-1b8fab745bf8",
      "event_cluster_id": "3bf26de2-8578-4eb2-a0d5-5c4deaf0246b"
    },
    {
      "claim_cluster_id": "7b36cbc9-6f57-4b29-9c6b-010607eb3738",
      "event_cluster_id": "e64ee1a2-9226-4d61-b0d3-bf9e52dc9982"
    },
    {
      "claim_cluster_id": "84b73ec4-88f0-4587-a147-47771c41db07",
      "event_cluster_id": "8b8269a1-ffad-456b-b974-307474aac288"
    },
    {
      "claim_cluster_id": "6d12ca3e-2e36-40ab-9cf4-0663df64745d",
      "event_cluster_id": "4dc5e4a5-2670-454e-b212-260136221524"
    },
    {
      "claim_cluster_id": "294ad0e1-cad9-4655-b7de-5e21de0e4797",
      "event_cluster_id": "06406aaf-e480-4364-8dee-02d2a85bbdca"
    },
    {
      "claim_cluster_id": "5e700671-a24a-4c8f-a1e4-abbfb82f4537",
      "event_cluster_id": "37dc3c46-39b6-4d4e-87ad-59040db4662a"
    },
    {
      "claim_cluster_id": "3de3b456-a38d-41d1-85eb-8ea198492839",
      "event_cluster_id": "60581c58-3e78-4ab6-b577-5edbcc9dc29c"
    },
    {
      "claim_cluster_id": "9b2175d9-8d49-4d83-857c-16d8550ab216",
      "event_cluster_id": "6773439f-27bf-46ee-884f-6f78667de502"
    },
    {
      "claim_cluster_id": "298b76c6-3ed3-4a84-8894-fa50a9f4234f",
      "event_cluster_id": "dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82"
    },
    {
      "claim_cluster_id": "af167078-1ea4-4d05-a491-aca4808cafd4",
      "event_cluster_id": "4a259022-df32-4e4f-a09e-afdcfddd1eae"
    },
    {
      "claim_cluster_id": "6efc04ea-c5a7-40f2-bf74-98f55c06f1df",
      "event_cluster_id": "bd072c00-533b-4c4a-918b-097a11abe63b"
    },
    {
      "claim_cluster_id": "14a92521-0601-421b-b904-3fc9a965cbb6",
      "event_cluster_id": "2a492648-efc4-44a2-9eee-4d95d05d104b"
    },
    {
      "claim_cluster_id": "ab7a8719-e742-49dc-b23d-904f2b97e9e2",
      "event_cluster_id": "e3712e03-c7c7-4373-818a-4c6598fd68df"
    },
    {
      "claim_cluster_id": "c7e21d17-7b1c-44ba-9b2b-db5a38de4e97",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "891e1da4-bfc6-4524-a5da-153bde60b165",
      "event_cluster_id": "0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"
    },
    {
      "claim_cluster_id": "cbafab62-ed48-49fc-9623-dbadef5cfd91",
      "event_cluster_id": "bfb1dcef-eb53-42d3-9c74-0d949ffc43a7"
    },
    {
      "claim_cluster_id": "221f2ccb-c412-4e42-8d5c-82e681a61d32",
      "event_cluster_id": "6d365284-d631-4fba-bf61-dd8894351156"
    },
    {
      "claim_cluster_id": "692c12d0-dff2-4fe9-a351-80422ee99320",
      "event_cluster_id": "3d676a5b-4d23-4b21-beb6-27ce056b17ec"
    },
    {
      "claim_cluster_id": "4bf14550-b17d-4304-b7d7-0f4f8ea4d2d6",
      "event_cluster_id": "1fcf2fd2-6989-429c-b569-e5ab5218738b"
    },
    {
      "claim_cluster_id": "04938aaa-1985-4664-bfb5-337fffd62a6d",
      "event_cluster_id": "3b4e6d34-1c11-4402-8f08-680cd1dda0c6"
    },
    {
      "claim_cluster_id": "cd37a888-7bea-44b1-9691-e12e7c11fac9",
      "event_cluster_id": "90a7e868-64e0-420e-8b7e-dbd99dcaae03"
    },
    {
      "claim_cluster_id": "37094b58-53c9-4cd4-af90-cb17301eef9e",
      "event_cluster_id": "f7c00384-e094-4930-b95a-5105ca6ad5a9"
    },
    {
      "claim_cluster_id": "0c8486a8-b9af-4dcb-9989-fcb363b7897e",
      "event_cluster_id": "dc679e22-e949-4c80-8633-a19ca02db1b0"
    },
    {
      "claim_cluster_id": "7bcfb80e-f4a6-4404-be69-078e88ddce1f",
      "event_cluster_id": "56a382af-0cf2-4fb5-ba8f-a5cad69ed381"
    },
    {
      "claim_cluster_id": "970a5cc7-9a05-4850-b0f1-f59128c441c8",
      "event_cluster_id": "a94771e0-7b95-4bfd-9f9c-88d21171cf9e"
    },
    {
      "claim_cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
      "event_cluster_id": "938b7182-512d-4aa5-a1bc-532c7b55f96a"
    },
    {
      "claim_cluster_id": "f4c860ae-1c6c-4478-89c7-fac05f3999c6",
      "event_cluster_id": "bd0a5021-3a05-428a-a728-61f8cfe02fc4"
    },
    {
      "claim_cluster_id": "843e2174-20bd-4386-beb4-ad4f8d0ba790",
      "event_cluster_id": "6ef4a6d4-b9a1-4d80-ae23-e54049cc7170"
    },
    {
      "claim_cluster_id": "c784871a-fcaa-4345-b3a8-ae8869019499",
      "event_cluster_id": "ccd586d7-5c30-4f84-8142-adc54ddef655"
    },
    {
      "claim_cluster_id": "ee877fbc-1f06-46ff-b006-7c974bc58cf1",
      "event_cluster_id": "7738ea50-f8ba-464e-a8c6-f4b5554a926f"
    },
    {
      "claim_cluster_id": "e045b8f3-c755-4ad1-91b0-a0b8f7878680",
      "event_cluster_id": "d74a5599-9b30-4d12-97d2-692e60e13661"
    },
    {
      "claim_cluster_id": "b8c8cd38-7dea-46d6-b8a1-7316916dd462",
      "event_cluster_id": "fe966747-5532-4145-9e61-737006d6b37e"
    },
    {
      "claim_cluster_id": "5443e2c0-e92d-4c21-ba1b-b0cdb2302769",
      "event_cluster_id": "90d77585-5ea5-4b42-8291-9d8389cf1b9a"
    },
    {
      "claim_cluster_id": "d832a602-46fe-4c29-83ff-f47197eab057",
      "event_cluster_id": "28640c6e-e7eb-4b38-b099-8b9d347bd04a"
    },
    {
      "claim_cluster_id": "0de2a028-10da-49bb-8b43-e7f79a0ff6dd",
      "event_cluster_id": "b21610b3-aecf-410c-9995-b99b144c12b1"
    },
    {
      "claim_cluster_id": "c35acce9-0a6f-4e25-8869-1a5e38bf302a",
      "event_cluster_id": "b61c8bad-f744-4e5e-908b-0b070a8f0d89"
    },
    {
      "claim_cluster_id": "925ee56a-7eb9-4c7c-aeb3-1eb168cbca46",
      "event_cluster_id": "84977d14-a5d8-4f51-965b-c09f3c5a291f"
    },
    {
      "claim_cluster_id": "c70207c5-86bf-4f7f-b715-56b9c8674c3b",
      "event_cluster_id": "acb8c5a5-3818-4898-ace2-3330d0f18d6b"
    },
    {
      "claim_cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "event_cluster_id": "61475130-6f49-487a-bec1-f17a9209af5f"
    },
    {
      "claim_cluster_id": "d017f7be-45ae-4ae5-b72e-a6e53f0a589b",
      "event_cluster_id": "90a7e868-64e0-420e-8b7e-dbd99dcaae03"
    },
    {
      "claim_cluster_id": "5a140171-9551-46fb-8eb7-bce434648b1a",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "505519a5-a059-4c9c-8b16-ce6dffe7e678",
      "event_cluster_id": "2f8e700c-1460-4a5f-9578-58c60978917b"
    },
    {
      "claim_cluster_id": "04ba7876-53cc-44c3-8149-fe7ba435f124",
      "event_cluster_id": "9e7c5d20-49ac-489c-bf49-38304a7e5439"
    },
    {
      "claim_cluster_id": "755e1910-15d6-4530-b0f7-b73a35ac9c64",
      "event_cluster_id": "529a3261-d48b-4317-930e-3bc02bd608d6"
    },
    {
      "claim_cluster_id": "aa4340e9-32f1-4ade-ab1e-eae7e384d7d5",
      "event_cluster_id": "412eecdd-3e2f-4593-9b61-1dd3ac3a36fc"
    },
    {
      "claim_cluster_id": "43fe48a2-ed82-4cef-9784-8e8df627f565",
      "event_cluster_id": "d7e7a762-6cbc-4c4f-9830-3d635c57a2df"
    },
    {
      "claim_cluster_id": "c75ee75a-e51c-413b-b72e-c2160bcb40c1",
      "event_cluster_id": "e64ee1a2-9226-4d61-b0d3-bf9e52dc9982"
    },
    {
      "claim_cluster_id": "470bd6d3-39cf-4a39-9a1c-be6c638cdd0d",
      "event_cluster_id": "7b901b41-b4fa-460e-bc66-e732ffe7ab8c"
    },
    {
      "claim_cluster_id": "85123ed6-1d34-44b3-9644-642bc01ff160",
      "event_cluster_id": "71ca644a-cfc8-4e25-b5db-b8f4e53e1dc1"
    },
    {
      "claim_cluster_id": "df65bddb-06ed-4815-9cbc-5ae170dbdeae",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "fa32fcee-2bb1-444a-8515-123065611c9e",
      "event_cluster_id": "90376b4c-da40-4dab-8f73-1b70785d5f49"
    },
    {
      "claim_cluster_id": "6222d4f0-7c6d-42f0-83ec-17412b1907f1",
      "event_cluster_id": "7b3e2472-ab18-4258-a390-e26e567571a0"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "5e50bec2-0cb9-42e3-b94b-de915ce6a4d5"
    },
    {
      "claim_cluster_id": "c8956774-b873-4e48-aca4-1d4ce1428a6f",
      "event_cluster_id": "fa9c6e3a-5327-4294-bfff-2d638f6c4455"
    },
    {
      "claim_cluster_id": "ccd87163-f5c4-4a49-b3d3-5d5c4788834c",
      "event_cluster_id": "58061e14-9c6d-45ae-8c7f-48a44c7f7cb0"
    },
    {
      "claim_cluster_id": "21e1972c-1d67-4f1b-a212-f7b911ed7f60",
      "event_cluster_id": "71623d2a-780c-4e92-af1b-eb0e9b031c0d"
    },
    {
      "claim_cluster_id": "c8cf7c39-4d6a-4fec-8451-b46f12ccd07f",
      "event_cluster_id": "fd2129f3-2e6f-48c6-9418-cef28902c1e2"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "a300ab57-0a8d-448b-8ceb-9af6a492c83c"
    },
    {
      "claim_cluster_id": "5feff95a-4d00-4a01-9b49-f3df3eb263ca",
      "event_cluster_id": "52204f25-791c-4bc8-9a84-ab506bb1cad1"
    },
    {
      "claim_cluster_id": "1c849e20-6024-47fa-80b4-e611385ba612",
      "event_cluster_id": "fdfba504-e492-4a5f-92f3-533547d34d6b"
    },
    {
      "claim_cluster_id": "42314335-3518-45c0-909b-96111c0955f6",
      "event_cluster_id": "06fc9106-7925-4cb4-a52c-592a739aee82"
    },
    {
      "claim_cluster_id": "90c28686-07e5-47d2-8675-847924fbe9c3",
      "event_cluster_id": "d04cd0c9-b68b-4e40-8b85-d3adf9108b78"
    },
    {
      "claim_cluster_id": "9bf70381-221f-4cfd-8e17-16f9ebb35e36",
      "event_cluster_id": "b961ace3-c2b8-4138-bb7c-fb147b603dc5"
    },
    {
      "claim_cluster_id": "626c75be-9b85-4ac5-97e0-e03b79d0191e",
      "event_cluster_id": "dac94ab4-f251-4e9f-88eb-38ea10c9b12a"
    },
    {
      "claim_cluster_id": "2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4",
      "event_cluster_id": "0edde6ee-5047-426b-bbb4-69dd12b6fd54"
    },
    {
      "claim_cluster_id": "5764cc12-79c5-4e4e-b170-52997cac0e07",
      "event_cluster_id": "504b2533-2c70-438a-a457-80634e246dfa"
    },
    {
      "claim_cluster_id": "ddd4b5a0-2eee-4ff9-bb50-de940c2541e2",
      "event_cluster_id": "ac7642b8-b25c-45db-8998-1d3c7f1c25e7"
    },
    {
      "claim_cluster_id": "8567d4c9-fb06-4505-b09d-13b1efafa073",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "c8b9924c-3cce-4d36-afc2-f686b12770db",
      "event_cluster_id": "337480a5-b05e-40ea-b813-e79cc37e4e00"
    },
    {
      "claim_cluster_id": "2cfb50e6-37ad-47a2-87b2-da1a9a512e46",
      "event_cluster_id": "e1645179-8a65-4728-91ce-ad15f6e0cef3"
    },
    {
      "claim_cluster_id": "3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9",
      "event_cluster_id": "3124bf40-7b7a-44d7-a83e-a1fe41e14ec6"
    },
    {
      "claim_cluster_id": "c02665b8-8535-44f4-96b2-764b54985f66",
      "event_cluster_id": "0c9df761-94e1-484a-ad16-41bb0a7c5fb3"
    },
    {
      "claim_cluster_id": "292629c2-32f2-451e-b64e-e8f73bb87975",
      "event_cluster_id": "3f1ec78d-49c2-44d1-bdc2-97cf6217c638"
    },
    {
      "claim_cluster_id": "6dfdb047-f69b-420b-87ec-fbcb72244cc6",
      "event_cluster_id": "91e3ebd7-7afc-4109-ab3a-203fd4f78d4d"
    },
    {
      "claim_cluster_id": "de60bb28-4ca7-441f-814b-f2ecfe29fb54",
      "event_cluster_id": "11abdc54-b039-4ec9-b836-c70099743468"
    },
    {
      "claim_cluster_id": "be3c4edf-6251-45c4-b310-ec9b6650b95f",
      "event_cluster_id": "2156a4b1-8617-407a-8feb-cc3b74e8fec4"
    },
    {
      "claim_cluster_id": "9fb5216e-3d0c-403e-a2bf-9368fa3e3592",
      "event_cluster_id": "f9c2516c-da15-44ca-94aa-e9d013d3a430"
    },
    {
      "claim_cluster_id": "1d2ba60d-53c7-4e8c-91e5-1d0e114d5708",
      "event_cluster_id": "5365be2b-8f70-4f67-96e5-c75ce9b7256e"
    },
    {
      "claim_cluster_id": "7cad6507-3550-4760-99ab-581f5b103f29",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "64b71712-5c8b-4ba5-9b04-b6b37a4ef8bd",
      "event_cluster_id": "c926ce6f-72a8-4848-817d-af5dc8f10bb9"
    },
    {
      "claim_cluster_id": "dfbc19e5-8117-4d40-9c25-774ed7aee906",
      "event_cluster_id": "9583b42b-1878-4c5b-8b34-5a41d72c1a17"
    },
    {
      "claim_cluster_id": "44260a23-35ce-4643-9869-bda1004b447a",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "37ca2b04-06dc-444f-b96a-20f9e5902a07",
      "event_cluster_id": "2002baa5-6997-4ebc-9742-182fae427316"
    },
    {
      "claim_cluster_id": "6e63c4ba-f9ee-49c7-a87f-b38ea11837c4",
      "event_cluster_id": "05fe6713-720d-475f-867a-c6de011c5f20"
    },
    {
      "claim_cluster_id": "71185519-3f2f-4171-84a1-11f08a933f13",
      "event_cluster_id": "036aef66-792d-4feb-a831-cb1e088b3daf"
    },
    {
      "claim_cluster_id": "4f1efe8f-fe00-4658-8994-d5332d4cc9ed",
      "event_cluster_id": "87b42d69-1e6c-402c-99c5-e722d6abf4ce"
    },
    {
      "claim_cluster_id": "f358da84-14e4-4001-acb3-83fa23673eb8",
      "event_cluster_id": "d249e1af-ea1c-48af-a49a-e0b42f780f6c"
    },
    {
      "claim_cluster_id": "6222d4f0-7c6d-42f0-83ec-17412b1907f1",
      "event_cluster_id": "428b353a-55ea-4d2a-8de9-d2392f48d161"
    },
    {
      "claim_cluster_id": "f3b06230-c202-438a-8858-b8c55fa68828",
      "event_cluster_id": "e3deeefe-c427-4d71-816d-254495afc3ac"
    },
    {
      "claim_cluster_id": "49ede63e-a1af-4931-8ab4-034fed7764ad",
      "event_cluster_id": "64b86b07-89a1-4ba2-8492-bdd7801a5bbe"
    },
    {
      "claim_cluster_id": "501b66f7-8e87-4810-b05d-6bb95d09a79e",
      "event_cluster_id": "0f37d4dc-cf7b-49dc-aecd-4803e8374e39"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "2528bd46-af3f-4f9d-8f91-2dbf49b3388e"
    },
    {
      "claim_cluster_id": "9c68ef9f-53c9-413e-b008-51e352564820",
      "event_cluster_id": "bac2fa35-75bf-4c16-a00a-24bb7ad1ff15"
    },
    {
      "claim_cluster_id": "22c13a77-51bd-41df-afeb-444adbde288e",
      "event_cluster_id": "a64f796d-8a90-4c29-811c-e05f5e8b113a"
    },
    {
      "claim_cluster_id": "eb38044c-3282-4492-916e-08a1ddd715ef",
      "event_cluster_id": "05b6cfa2-c45f-42a8-bb0c-d50df97483f9"
    },
    {
      "claim_cluster_id": "aaf51226-d11b-4c1b-82db-25727f24712a",
      "event_cluster_id": "1c2050b3-8746-45bf-a7a2-7907e141c266"
    },
    {
      "claim_cluster_id": "aa973fc5-c596-49d2-86f1-80f2a9f419e9",
      "event_cluster_id": "a7db18f7-5822-426a-8676-b522df1e90e8"
    },
    {
      "claim_cluster_id": "29fe240a-81f6-4aef-a8b5-3cacf3e3985a",
      "event_cluster_id": "b379da86-fb9c-4026-92d2-37b07df028cc"
    },
    {
      "claim_cluster_id": "99dd456b-c805-4ebb-a82a-80fe2e06dff9",
      "event_cluster_id": "4e97d6a7-e106-4542-b474-cb57818b7b22"
    },
    {
      "claim_cluster_id": "19b1602b-7236-4e52-b704-1442a85ad752",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "0450cb4c-8816-4bbd-85b6-ac94ecde9af4",
      "event_cluster_id": "e0dcc7af-9cb5-4c1d-b108-5d8de64148cf"
    },
    {
      "claim_cluster_id": "1d7ae3fd-fb7a-483b-9d74-2b16ea9b34ba",
      "event_cluster_id": "1a154b18-5d3f-45d7-ac98-39d14a936806"
    },
    {
      "claim_cluster_id": "9d21be2e-9f01-48c9-b454-3a41788e2865",
      "event_cluster_id": "68dfb31b-7f13-4eb1-b5bf-740e6918f0ee"
    },
    {
      "claim_cluster_id": "d65bf625-e91c-49ac-a498-dc2e95df1f93",
      "event_cluster_id": "0c9df761-94e1-484a-ad16-41bb0a7c5fb3"
    },
    {
      "claim_cluster_id": "e473874a-9cd2-4a8d-b926-9354bf1b7e19",
      "event_cluster_id": "126a290c-017d-477f-aef9-ee387468d992"
    },
    {
      "claim_cluster_id": "546f63e2-ef89-4f69-bd49-cde47599b05e",
      "event_cluster_id": "7afc1db8-da22-4a16-9a76-d5155374bce3"
    },
    {
      "claim_cluster_id": "0dad0e38-e0db-46d5-a25f-8e95be6a721f",
      "event_cluster_id": "cb033bf6-f8da-46c0-a5e0-962c48c82ad6"
    },
    {
      "claim_cluster_id": "0cdd2771-1f79-419e-940c-c74f863377bb",
      "event_cluster_id": "31763d96-84ac-402a-a69c-ea748718f342"
    },
    {
      "claim_cluster_id": "83856113-7cf1-435d-bc2c-d1c5e5e5c106",
      "event_cluster_id": "c278122a-3daa-4207-bb75-b0bf1f432ea0"
    },
    {
      "claim_cluster_id": "589240bc-a0dc-4961-944a-a3594262e220",
      "event_cluster_id": "fd6cf91a-5408-4a49-8b88-6ba66a82f0e7"
    },
    {
      "claim_cluster_id": "6d176455-78b5-4454-a405-3f0ba5b91ecb",
      "event_cluster_id": "e56b6c3e-60ae-4144-ba92-480b792e396d"
    },
    {
      "claim_cluster_id": "ec613890-df43-48e8-bf2a-a40ccb263efc",
      "event_cluster_id": "29477fdd-bbbe-4e39-b779-19de18778240"
    },
    {
      "claim_cluster_id": "221f2ccb-c412-4e42-8d5c-82e681a61d32",
      "event_cluster_id": "28097be1-5cca-4755-b4ba-20a7ac4aa34a"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "220dfe6b-2774-4a8a-8306-3094dfce156d"
    },
    {
      "claim_cluster_id": "bd0a892b-884e-4c98-8690-8f25949dbaed",
      "event_cluster_id": "ce319c6f-8ace-40b1-be7e-933bd39cd9c5"
    },
    {
      "claim_cluster_id": "120d61e9-d442-4218-b8d0-9559d9880c3a",
      "event_cluster_id": "c025fbc7-332e-4457-bed4-c17718085886"
    },
    {
      "claim_cluster_id": "b4a81fcd-1fa0-4fbe-88f0-692419c6082a",
      "event_cluster_id": "a839d9a9-74d4-474c-bdfc-b239b6e1eb9b"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "aeaa0391-95c5-43bf-a72e-66d04a052ba3"
    },
    {
      "claim_cluster_id": "a3c357ac-5159-4eec-ad16-09366a144d09",
      "event_cluster_id": "e42d141d-80cc-4e68-848e-2d85ecf6a58c"
    },
    {
      "claim_cluster_id": "c35d9889-06cc-4a13-8fea-d00c7024488b",
      "event_cluster_id": "970fa237-7a1d-4b64-a4c6-7a158c05542d"
    },
    {
      "claim_cluster_id": "325111bb-e15c-4f08-a4a4-3f81e99d9f35",
      "event_cluster_id": "d6d06f17-e283-43e2-b5a1-66991f31adf1"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "1501c95d-fe6f-4129-965a-ccb56abb7afe"
    },
    {
      "claim_cluster_id": "d21ce376-5e68-41d1-903e-db8ea2f295f8",
      "event_cluster_id": "634e943b-2d48-48b0-b1e8-52524e278a9f"
    },
    {
      "claim_cluster_id": "0ed53993-d675-4e0a-91d9-fca7f39d86fc",
      "event_cluster_id": "03bed382-9ecc-4f84-bd88-6ff53d1b8a13"
    },
    {
      "claim_cluster_id": "cbe32f56-0dc5-4870-8a2a-874435ed2ed9",
      "event_cluster_id": "7378ad43-a016-4ea8-a115-0123a4bd291a"
    },
    {
      "claim_cluster_id": "88dffe0c-cf6a-4d54-b70b-1d2c41a95f47",
      "event_cluster_id": "01284921-0773-415d-9ce4-f4e93b10a2af"
    },
    {
      "claim_cluster_id": "8567d4c9-fb06-4505-b09d-13b1efafa073",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "c4536202-39a9-481f-a4be-147b7620686b",
      "event_cluster_id": "5ac2f931-1ef9-4c96-8568-845f2751d03d"
    },
    {
      "claim_cluster_id": "8bdd6183-6e5d-4862-87e8-003b661f98ce",
      "event_cluster_id": "84ed6834-5129-43f4-a029-0b28839b357d"
    },
    {
      "claim_cluster_id": "a950be1b-733b-40a8-b78b-7a36e0c5c2ac",
      "event_cluster_id": "a1ea18ac-be18-41e4-86ed-51a5a227e8ba"
    },
    {
      "claim_cluster_id": "59905a93-0117-4d6a-a153-cacf3c9feeb8",
      "event_cluster_id": "9f1d605b-541e-498f-8d37-d5763cc9a791"
    },
    {
      "claim_cluster_id": "3dc0cbd1-b381-4df2-846d-e07147e83cbe",
      "event_cluster_id": "c058e393-ae39-4d59-9d56-d80b61d507dc"
    },
    {
      "claim_cluster_id": "784725f9-7f56-4fd8-bbd1-9c94d01f5505",
      "event_cluster_id": "48f7f24e-52e0-4527-a4e1-e5a83b50fb40"
    },
    {
      "claim_cluster_id": "8567d4c9-fb06-4505-b09d-13b1efafa073",
      "event_cluster_id": "52307e03-a0f5-4819-b75d-6ff7244ed5dc"
    },
    {
      "claim_cluster_id": "5d8665ac-7337-470b-ae27-2d46610e9f97",
      "event_cluster_id": "56106773-dee4-4da1-bda2-7227784468b3"
    },
    {
      "claim_cluster_id": "4e7d68ff-7bd2-4949-affb-c71a8a76240a",
      "event_cluster_id": "42e92742-8e3a-4799-8e99-5faf8bc31f82"
    },
    {
      "claim_cluster_id": "903d2f0d-f14e-42ff-a685-a20e841d8f7b",
      "event_cluster_id": "a2f20d4d-0860-445b-aa4d-0a748d8d1f73"
    },
    {
      "claim_cluster_id": "565a8eff-d3c3-4887-a42a-b357e222a101",
      "event_cluster_id": "9d882154-e197-4475-b27e-35c54fe8fbfd"
    },
    {
      "claim_cluster_id": "16b63ffa-da4e-4cff-8fab-fffc1644a634",
      "event_cluster_id": "18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"
    },
    {
      "claim_cluster_id": "dad2ba1b-78a6-4e69-91a7-e473e3d79e42",
      "event_cluster_id": "2fefb93c-9c85-46df-850b-c68cfbfe7264"
    },
    {
      "claim_cluster_id": "c9335a55-7c59-42cb-98be-e69b4262faa0",
      "event_cluster_id": "fccc5c68-3c5f-4b2d-8103-9431b0c4794a"
    },
    {
      "claim_cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "event_cluster_id": "f184f109-b4af-4d4c-b5c2-73e631545fd2"
    },
    {
      "claim_cluster_id": "5900a7ab-7cb4-45d4-8807-d20dee337670",
      "event_cluster_id": "14faed7d-8ab2-4b52-8d60-40b6be3c9a21"
    },
    {
      "claim_cluster_id": "e25eede3-3242-446d-a439-2c4becea51cf",
      "event_cluster_id": "76f2f5fc-c5b8-4d6e-932c-655254df8fc2"
    },
    {
      "claim_cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
      "event_cluster_id": "637ffe03-032a-46cd-af4f-d7f5c220eab9"
    },
    {
      "claim_cluster_id": "c9367bb7-c2e3-4341-a799-6ff36d655556",
      "event_cluster_id": "6234ba01-768a-474f-80de-4d8b6df78d63"
    },
    {
      "claim_cluster_id": "d3777022-58bb-45d2-9153-3e33e4a367f9",
      "event_cluster_id": "fc55be0d-bed8-4ebb-8dc7-149fb174476c"
    },
    {
      "claim_cluster_id": "b53db505-a920-4607-b45b-0f9423ee6d04",
      "event_cluster_id": "a7f8bf9e-86b1-4c85-bc02-6ee66c4f9e1f"
    },
    {
      "claim_cluster_id": "48ac478a-0a47-432d-9d71-30bc821691af",
      "event_cluster_id": "ec10f62c-ce71-4a79-9f7e-b5ddfb366f3a"
    },
    {
      "claim_cluster_id": "a45b0120-f89a-4fb7-9d30-32c67bc23fc9",
      "event_cluster_id": "a1617416-4daf-4173-b483-3f65d380f28c"
    },
    {
      "claim_cluster_id": "db9b9c53-4b26-4d88-83d5-c4c2d8189711",
      "event_cluster_id": "28ea99a2-454e-42c3-b308-cf4739fc9a02"
    },
    {
      "claim_cluster_id": "a7a78172-b61a-41cd-a089-5fdf5b5e9fdc",
      "event_cluster_id": "ea81b5d1-0d91-46ec-a9b0-b349139b83e4"
    },
    {
      "claim_cluster_id": "b5aab15d-0623-4834-b9a0-c066e3616369",
      "event_cluster_id": "a59be105-d89d-41df-ade9-920d14216360"
    },
    {
      "claim_cluster_id": "c70207c5-86bf-4f7f-b715-56b9c8674c3b",
      "event_cluster_id": "e1c95bf3-b7f4-4783-af68-d79bcb7b55a9"
    },
    {
      "claim_cluster_id": "a0698f9c-4bc8-48b3-b669-44befd54559c",
      "event_cluster_id": "5674d01b-2996-4ed7-850d-de449d707ce5"
    },
    {
      "claim_cluster_id": "11aef681-a744-409f-8cc3-69822e3a86b2",
      "event_cluster_id": "5400c461-7afa-4066-ba64-beb7aef1eede"
    },
    {
      "claim_cluster_id": "f6aedae8-b368-419e-9158-abbe718748ba",
      "event_cluster_id": "45a3ab07-2fb2-420c-9452-350f55111899"
    },
    {
      "claim_cluster_id": "92df53c2-d00a-4565-ac4a-1279aad1b2ee",
      "event_cluster_id": "37512ba8-d5ed-4b9e-9fba-d0ec249a1d84"
    },
    {
      "claim_cluster_id": "c3211a84-677f-449b-8204-7cc36fb3bea9",
      "event_cluster_id": "33eeb9d5-6bc2-4034-a6c6-3e0b1e59728e"
    },
    {
      "claim_cluster_id": "209935ed-d0a0-4dbe-82d8-2d7d5a2aa866",
      "event_cluster_id": "987f4090-f0a3-43c8-9987-c964fdd04c79"
    },
    {
      "claim_cluster_id": "5317331a-d0a9-4595-acad-210a92b278d8",
      "event_cluster_id": "31f1de90-d456-4f9f-8590-accad42614e0"
    },
    {
      "claim_cluster_id": "bfc6790e-9007-4b03-90bf-5da6fcce01b7",
      "event_cluster_id": "97b1177e-80bf-4e09-83e5-b50aecee0b52"
    },
    {
      "claim_cluster_id": "bed08ef5-4cb1-4f05-b2d4-a996242acd93",
      "event_cluster_id": "0d87ab36-c271-462d-81cc-1e3930ab33e4"
    },
    {
      "claim_cluster_id": "c784871a-fcaa-4345-b3a8-ae8869019499",
      "event_cluster_id": "52f03b57-8fb1-4ff1-8eda-c0d228097a8f"
    },
    {
      "claim_cluster_id": "11e43ecc-22c8-4f1c-b13a-fb97013ce963",
      "event_cluster_id": "e20b024a-3a40-46e1-bbc5-e9607839e91f"
    },
    {
      "claim_cluster_id": "5d657ce1-e484-4e48-b720-f4927cd733dd",
      "event_cluster_id": "f0d87010-6047-4ec3-814a-b7e1d93689ac"
    },
    {
      "claim_cluster_id": "e0c5a85f-7145-4366-aac8-58cd212f7e6a",
      "event_cluster_id": "b3f64145-99ff-4cb6-9aeb-55abe9921e59"
    },
    {
      "claim_cluster_id": "748c24aa-69c4-47c4-a75f-e6da7007b74a",
      "event_cluster_id": "2ec09e70-73d9-4395-9c36-0dbcac034464"
    },
    {
      "claim_cluster_id": "4f0130b7-d8c3-44c1-892f-fe74aef4cecc",
      "event_cluster_id": "fdf0468f-b20d-40b0-8a2a-5519d8086286"
    },
    {
      "claim_cluster_id": "0a79d737-f594-464b-b3d2-afd57c6349f1",
      "event_cluster_id": "619f9470-2786-4c4b-9f38-8e5494785aa1"
    },
    {
      "claim_cluster_id": "a766b305-cd34-47d7-bed5-5c04c33c99ba",
      "event_cluster_id": "aa6b0ec7-e6ca-40be-8563-62563928ebc1"
    },
    {
      "claim_cluster_id": "7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9",
      "event_cluster_id": "ec281f2d-d4ef-4a4e-a1f0-552896c7315d"
    },
    {
      "claim_cluster_id": "291e098d-0f3d-4fff-9906-3b21ed1a33a1",
      "event_cluster_id": "bc3691bd-e8ea-4667-b6cf-1afd5eb88fa6"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "b83cbf56-9c77-41ae-bf34-905116236046"
    },
    {
      "claim_cluster_id": "93459608-ccd3-4b8a-af7b-ede8b22e8c94",
      "event_cluster_id": "44b235b6-c03c-46c3-8783-0dedf88d2c23"
    },
    {
      "claim_cluster_id": "19867279-c3e5-4f1b-afe9-d36652a4bc2b",
      "event_cluster_id": "d8bdc753-fad4-4cd8-b9f2-efb5708d6629"
    },
    {
      "claim_cluster_id": "442dded8-bef6-49b2-b7d4-70454c6e8e79",
      "event_cluster_id": "3cb67525-0d0d-4f1e-8f2b-d44f7e022019"
    },
    {
      "claim_cluster_id": "544ac6da-d621-4fd5-bbf8-4a2cd6254e41",
      "event_cluster_id": "7fb1639d-6541-40a5-8cc7-71943288089e"
    },
    {
      "claim_cluster_id": "411175f7-0ca0-4fb5-9db2-35822ef1cc0a",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "a0698f9c-4bc8-48b3-b669-44befd54559c",
      "event_cluster_id": "3fd4fa60-bdae-4294-8d90-4a430127c38a"
    },
    {
      "claim_cluster_id": "db6d1f55-1378-42e6-ab38-0b1046e37cc0",
      "event_cluster_id": "85fa8f6e-2724-474a-b5e9-bb6b9d49d126"
    },
    {
      "claim_cluster_id": "d14315a8-aa93-4c64-a42e-a4307dd0814a",
      "event_cluster_id": "5f903470-ae17-46df-89e3-72da3d3117a4"
    },
    {
      "claim_cluster_id": "8a0accb4-caf5-4741-9038-3360a1a08c25",
      "event_cluster_id": "eee93c68-9cef-40e8-a46b-ade5e4a0a57d"
    },
    {
      "claim_cluster_id": "91e6a8b3-0e47-4ed1-b99e-a946e23e0c33",
      "event_cluster_id": "6bf20e7d-0fef-44de-a032-0b603b235bf7"
    },
    {
      "claim_cluster_id": "0ecc8673-156d-41da-a0bd-8ceb3bd503b8",
      "event_cluster_id": "10cad03e-00e1-4582-b61d-1c7191589376"
    },
    {
      "claim_cluster_id": "dd24c0fd-c274-4b3f-aabc-3dbac6784aa9",
      "event_cluster_id": "c3ffc4ba-bd9b-4ff0-ac0e-e1b2b01b15fd"
    },
    {
      "claim_cluster_id": "94c9f0c7-1016-4b43-931c-9bd7dc0b2892",
      "event_cluster_id": "0709871d-a6ab-4aa2-93bf-03bb443f89a9"
    },
    {
      "claim_cluster_id": "e52244b2-1143-48cf-9735-ce26094681d1",
      "event_cluster_id": "f41585b2-89bb-4794-90a0-40b26fb3ec23"
    },
    {
      "claim_cluster_id": "db91531a-0712-431d-a04b-9b798db3d3b4",
      "event_cluster_id": "88714dc6-72d5-4f7f-9067-219b66b31c42"
    },
    {
      "claim_cluster_id": "a01e0915-a285-410d-9d1b-ce9544139c90",
      "event_cluster_id": "a73d7361-cea3-47c7-84a2-2a97ab239fa4"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "b060d900-983c-47b6-b9e8-d31f4dbd3db1"
    },
    {
      "claim_cluster_id": "f46e8240-2cb3-437d-9e2e-c04f6db7a813",
      "event_cluster_id": "d550236c-347c-46ce-84eb-f723bc55deec"
    },
    {
      "claim_cluster_id": "c6e50b1a-e795-43fc-baca-c835ba2bf14d",
      "event_cluster_id": "14c01a60-ad79-4b97-8a3e-f1a74d8a8f96"
    },
    {
      "claim_cluster_id": "e50a9fba-a791-4b5a-bed8-e0accc690c1a",
      "event_cluster_id": "069833ab-70fd-48fa-80f9-9eed2484a21e"
    },
    {
      "claim_cluster_id": "17eaa25c-625f-4414-b1ad-78d904209f81",
      "event_cluster_id": "6b75ad73-0fd7-443a-b60e-840a237907bc"
    },
    {
      "claim_cluster_id": "4e7d68ff-7bd2-4949-affb-c71a8a76240a",
      "event_cluster_id": "82f5beda-b460-413d-ba52-232c56bac459"
    },
    {
      "claim_cluster_id": "1dae585e-f051-41dc-8fc8-c2d3e3b3b884",
      "event_cluster_id": "d2833c21-07b4-4262-9ed6-9db3cde93c79"
    },
    {
      "claim_cluster_id": "da33c07b-485b-43b6-8165-46193fb1720d",
      "event_cluster_id": "4c79fc69-3bd0-4180-9718-8d85b8c9dd85"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "84147a14-72bc-486f-90ad-45e374aeaa05"
    },
    {
      "claim_cluster_id": "43fe48a2-ed82-4cef-9784-8e8df627f565",
      "event_cluster_id": "7a75d7fe-a9ef-4bcc-bb6c-68501ebb5f56"
    },
    {
      "claim_cluster_id": "d30cdd9d-92e1-44ac-aad9-845702e1559f",
      "event_cluster_id": "5eaa7b8f-5e2f-4cc2-827c-b780c20bc557"
    },
    {
      "claim_cluster_id": "99dfb4e4-9788-4ea5-81a7-c0dd44f60aba",
      "event_cluster_id": "0e78429b-c0f8-4ecd-ae8e-35ff713ba980"
    },
    {
      "claim_cluster_id": "eb6a12b4-268e-4e39-8d84-ba73d40a7ffd",
      "event_cluster_id": "224111ea-4ffa-46dd-984c-028b4bc55489"
    },
    {
      "claim_cluster_id": "2c1958a0-e83a-4912-9902-e6456b756f14",
      "event_cluster_id": "3d6b711d-93be-4839-8934-425368c03327"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "d3085fed-3741-4d75-9105-e8b0b3511de6"
    },
    {
      "claim_cluster_id": "ed9c7f02-d3d7-4f88-92df-80c91b7dca98",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "243cbf96-dba8-41a3-9dc7-8def431d23c9",
      "event_cluster_id": "f3941de8-4943-41e7-80e9-773a7b8e51ab"
    },
    {
      "claim_cluster_id": "b6e703fc-a44f-43d6-9db6-85666a802044",
      "event_cluster_id": "8a36ef98-d08b-4198-b4d6-a8933da5b619"
    },
    {
      "claim_cluster_id": "5ab9d303-668f-48d9-893f-546437484767",
      "event_cluster_id": "2830c0e0-a35a-4015-a0c2-75079b518aa2"
    },
    {
      "claim_cluster_id": "e50a9fba-a791-4b5a-bed8-e0accc690c1a",
      "event_cluster_id": "9d822f9c-32a6-4f43-9fd1-5ddd226c8add"
    },
    {
      "claim_cluster_id": "543e79b8-1458-43e8-a976-eaa0fcb652ab",
      "event_cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"
    },
    {
      "claim_cluster_id": "1075443d-c097-4cb8-acb0-3d21f48f6aca",
      "event_cluster_id": "b92f2bdb-a4c9-478b-a96f-1f47457a005d"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "9398c496-5e62-4d1b-94c1-e1eeaf48778c",
      "event_cluster_id": "8984a612-a2af-48f1-8868-d5d348b17de2"
    },
    {
      "claim_cluster_id": "5a787097-c657-4d02-a7e7-ce5ddfe404d6",
      "event_cluster_id": "b632a6a0-afbe-40f4-8a5f-a0054d37001d"
    },
    {
      "claim_cluster_id": "2870dcce-8def-47de-9196-c66889a0a474",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "f8aea904-a823-4059-9707-77075c116ecb",
      "event_cluster_id": "053dfae5-6865-40c0-a285-b1e7c8cbaf44"
    },
    {
      "claim_cluster_id": "821946a1-401a-4657-be17-b3ed51371c13",
      "event_cluster_id": "cc656b46-bdcc-435b-a7d6-1b15ef3a32ad"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "b2894bf3-d539-4a31-9d16-59a88bacee25"
    },
    {
      "claim_cluster_id": "29b7e7cf-ad7f-43ae-a8c7-822d865d97f4",
      "event_cluster_id": "1630f0d6-45b5-4a9c-9208-8292e05b3a85"
    },
    {
      "claim_cluster_id": "f2df1c45-9507-438e-92d8-0a523b9a842a",
      "event_cluster_id": "e98042df-e94b-4a67-8387-fe8218853a1d"
    },
    {
      "claim_cluster_id": "a5d39319-660b-4b6e-acb4-246464538db6",
      "event_cluster_id": "238a575a-ac72-4ae9-8880-72409a39a327"
    },
    {
      "claim_cluster_id": "a986747d-76c4-4786-b8af-6e1c3537a9eb",
      "event_cluster_id": "b9db86cc-1622-42c5-b482-396c3c7c7bf5"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "695d0f59-560f-43af-8f49-fe8e17880043"
    },
    {
      "claim_cluster_id": "e871839f-962c-43cf-a2f7-5ebaf26de0a1",
      "event_cluster_id": "4ca4751a-06c9-42b9-935e-8c293fd1cd2e"
    },
    {
      "claim_cluster_id": "565a8eff-d3c3-4887-a42a-b357e222a101",
      "event_cluster_id": "2bf12fd5-52d9-43a7-9a2b-ede63bb26438"
    },
    {
      "claim_cluster_id": "a7614301-2ae0-4bb1-bcf4-8bc8d82acc70",
      "event_cluster_id": "181a2d12-ad30-4552-bb72-ee9a984fa618"
    },
    {
      "claim_cluster_id": "0961c365-4261-4c91-984b-81c62260d807",
      "event_cluster_id": "12a67c1f-74e3-4d9a-8a6a-adbec88544da"
    },
    {
      "claim_cluster_id": "10317341-49c9-447e-bafb-6ef554948da9",
      "event_cluster_id": "92102219-111c-4df9-82ec-b4c0a1a920cf"
    },
    {
      "claim_cluster_id": "2dc250b5-58d8-4c44-80d2-2c17640ea117",
      "event_cluster_id": "41c879a5-6679-4fd4-9549-bf3854b37d7c"
    },
    {
      "claim_cluster_id": "dc9039b4-da9a-4fd0-b97d-d822536a716c",
      "event_cluster_id": "68a2ab6a-28c5-4be5-96a5-2cd28d07739e"
    },
    {
      "claim_cluster_id": "02fc2c1c-e5e4-40d6-92bc-a975544e0e30",
      "event_cluster_id": "34a1b507-fb03-489f-a79e-be687aeaabe9"
    },
    {
      "claim_cluster_id": "1ae849f8-e182-405a-a33b-006fe51f03e6",
      "event_cluster_id": "c814031b-97fc-4571-859f-e9e8df89373b"
    },
    {
      "claim_cluster_id": "47085082-7091-436e-a3ee-ecf14c90e1a5",
      "event_cluster_id": "91b087d8-4803-4bcf-911f-18dca461d16f"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "09a3b73e-815c-4ea0-9da8-b1110ca8cf96"
    },
    {
      "claim_cluster_id": "3dc82114-c98e-4342-a6ab-854d95d9efa7",
      "event_cluster_id": "586b0585-af30-4d40-9796-01be4c00d08c"
    },
    {
      "claim_cluster_id": "abfcf3df-912d-43b6-968f-0f586e4e242c",
      "event_cluster_id": "4dfd1143-30a8-4e10-a390-f29a1b58e6a8"
    },
    {
      "claim_cluster_id": "de1f8a69-eaff-4387-87ee-35fc20ea4a2f",
      "event_cluster_id": "aaa9c952-e937-4295-abaa-c4968a415009"
    },
    {
      "claim_cluster_id": "61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc",
      "event_cluster_id": "88679d89-9148-493b-84ed-a40bc977a620"
    },
    {
      "claim_cluster_id": "8b44daa7-629e-4db8-81b7-5ed88669eb86",
      "event_cluster_id": "317ecec9-87af-4e3c-acd4-372de58135a0"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "8dd2ae56-dcf0-4439-b3f0-3a7a939056df"
    },
    {
      "claim_cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "event_cluster_id": "db82285e-98ce-4ae9-a084-bb6101bb4059"
    },
    {
      "claim_cluster_id": "636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd",
      "event_cluster_id": "bc25c1b6-b24d-4cb5-9913-b54d305182e7"
    },
    {
      "claim_cluster_id": "8a1c4319-f1b2-4b2f-93eb-dd1d35c5dd9e",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "event_cluster_id": "72521c8d-f680-4322-878b-70c3f47a7f96"
    },
    {
      "claim_cluster_id": "8a444d1c-5423-4444-8123-2c225b02e57a",
      "event_cluster_id": "ea5f5123-a57b-4bf9-83c5-18d3a2293db6"
    },
    {
      "claim_cluster_id": "37ca2b04-06dc-444f-b96a-20f9e5902a07",
      "event_cluster_id": "afc0b94b-3d14-41ac-a746-8c4fbe3bd721"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "af5dc56f-c303-4ae3-a3a4-2b17b1e05cac"
    },
    {
      "claim_cluster_id": "91e94583-4b9d-4847-9825-9ed7293c7a0e",
      "event_cluster_id": "4a7e58b2-ad14-4711-92da-e24d91c0e2a2"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "bbf2648f-d211-49b0-bf5c-a562e43902c5",
      "event_cluster_id": "3d47a459-5f56-4e8c-a324-2a8a527df0bb"
    },
    {
      "claim_cluster_id": "17be823a-a533-4e33-9ba0-969c3b8ddbd0",
      "event_cluster_id": "134817e7-d143-434d-b8ad-1fa05e622296"
    },
    {
      "claim_cluster_id": "6f7b7d52-9a91-4f92-8a4e-4062c6360cda",
      "event_cluster_id": "23b45144-23d0-44ff-aa24-9b637f465e0d"
    },
    {
      "claim_cluster_id": "19867279-c3e5-4f1b-afe9-d36652a4bc2b",
      "event_cluster_id": "e4e28c57-a8cc-4df1-b26c-23b630ca06ac"
    },
    {
      "claim_cluster_id": "a15b9883-60ad-4e49-8943-56ed500ab8cf",
      "event_cluster_id": "b2e6976f-e5a2-4669-ac3d-3e87cd376f99"
    },
    {
      "claim_cluster_id": "75816fb8-77fb-4eee-a3ec-bbb68393ff86",
      "event_cluster_id": "02ad021c-7d4f-4141-9a02-a5ad1ae95f65"
    },
    {
      "claim_cluster_id": "29469bb2-a496-413c-802b-5a8d1b46d374",
      "event_cluster_id": "b92f2bdb-a4c9-478b-a96f-1f47457a005d"
    },
    {
      "claim_cluster_id": "e9d22d46-e0d1-45b7-b109-afc6516146e1",
      "event_cluster_id": "80a8792f-9489-40e4-a0a2-e1e4173e1957"
    },
    {
      "claim_cluster_id": "f8c898ca-36a7-47ac-838a-8091321433d0",
      "event_cluster_id": "90f6170b-cac1-4488-806a-45a48e5f95f7"
    },
    {
      "claim_cluster_id": "b54d16d2-d5db-4746-b15a-e8c01d4fc586",
      "event_cluster_id": "b9809c93-42b6-499a-9f8e-13df798b0605"
    },
    {
      "claim_cluster_id": "c054d850-518a-42ab-a850-01492f7fb7ce",
      "event_cluster_id": "e19196d4-b7bf-49e0-b42c-244f5f90725b"
    },
    {
      "claim_cluster_id": "818fb1f8-d14f-4997-8e8d-f7e228560c99",
      "event_cluster_id": "615af33f-6193-4bde-a85a-a2576bad24e7"
    },
    {
      "claim_cluster_id": "9f936fe4-6962-4447-9269-bd4c45c0f95e",
      "event_cluster_id": "74848948-285f-4571-adb0-ad9b59d381fc"
    },
    {
      "claim_cluster_id": "145c6709-d797-4b12-bf2a-a6ed41e9efad",
      "event_cluster_id": "bb00bd4b-2a33-4849-ae7f-804463c9c453"
    },
    {
      "claim_cluster_id": "3312bf71-bb24-4752-866e-3b29580d70d1",
      "event_cluster_id": "81eafdea-26c8-4b44-b5c7-5cd6a9bfece5"
    },
    {
      "claim_cluster_id": "9e96a51d-6101-42af-b7a2-54e4dd5ae715",
      "event_cluster_id": "2de07645-b8a8-45f7-bb4d-87637fd094ec"
    },
    {
      "claim_cluster_id": "a7a78172-b61a-41cd-a089-5fdf5b5e9fdc",
      "event_cluster_id": "f97c3523-e4c9-4551-a240-c5e4c7f8f532"
    },
    {
      "claim_cluster_id": "e2a085c3-49f3-4799-87cc-2b59f85d4bb4",
      "event_cluster_id": "827e3030-1738-4370-a530-42878dd6927d"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "c5d18c78-4df0-44fa-9f69-67266b1079e2",
      "event_cluster_id": "27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"
    },
    {
      "claim_cluster_id": "26ee8f8d-a289-4bb8-af4e-67dfc3cca301",
      "event_cluster_id": "51ccaad9-0af3-4189-abe9-de4b65c38edd"
    },
    {
      "claim_cluster_id": "ab829976-d7fb-4b30-9b92-89eed4e94cc4",
      "event_cluster_id": "2a492648-efc4-44a2-9eee-4d95d05d104b"
    },
    {
      "claim_cluster_id": "cf399998-137e-4270-8827-7c726197fb9d",
      "event_cluster_id": "343b7137-128b-41e4-a3ca-cc8e58193569"
    },
    {
      "claim_cluster_id": "57752645-2ac6-4482-9e7c-bbaea1506cc5",
      "event_cluster_id": "4a7e58b2-ad14-4711-92da-e24d91c0e2a2"
    },
    {
      "claim_cluster_id": "3dcf8216-5e70-4cd4-962e-dc4b036a0071",
      "event_cluster_id": "f262ea70-4c26-4dcc-8a1f-52d6f8ce5558"
    },
    {
      "claim_cluster_id": "9f34aa0e-2eb3-43e3-b4dd-54a36752af72",
      "event_cluster_id": "e4d10cca-580c-41e1-9918-7376d930bfa1"
    },
    {
      "claim_cluster_id": "554575d4-0201-41f5-aa4b-d48a76e37311",
      "event_cluster_id": "1e9089f3-b7e2-4ef0-870f-afca46689fbf"
    },
    {
      "claim_cluster_id": "dd24c0fd-c274-4b3f-aabc-3dbac6784aa9",
      "event_cluster_id": "9d18ccac-ba43-4c43-bed8-0d742eb6d22d"
    },
    {
      "claim_cluster_id": "7893fdb0-a005-4beb-b22f-fc8ce5bd706e",
      "event_cluster_id": "3035cab4-7bf7-4e5f-b8ff-717930d9caf2"
    },
    {
      "claim_cluster_id": "83176725-df79-43f8-b571-b45c6b2dea8f",
      "event_cluster_id": "13220774-7cb5-4388-b12f-a0737d93673b"
    },
    {
      "claim_cluster_id": "679ed917-ad46-4856-a427-b83dcc51a53c",
      "event_cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"
    },
    {
      "claim_cluster_id": "411175f7-0ca0-4fb5-9db2-35822ef1cc0a",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "cef32527-0357-47cf-9fee-19bd0f13e11a",
      "event_cluster_id": "88531805-ef1f-409a-a41f-4692202b9686"
    },
    {
      "claim_cluster_id": "be3c4edf-6251-45c4-b310-ec9b6650b95f",
      "event_cluster_id": "9c4cbf68-9385-4898-9bf2-17346263f863"
    },
    {
      "claim_cluster_id": "d86ea948-08a0-4829-9e48-4f9273b2967d",
      "event_cluster_id": "bc618add-d50a-4d41-b375-e0f4e3b7232b"
    },
    {
      "claim_cluster_id": "411175f7-0ca0-4fb5-9db2-35822ef1cc0a",
      "event_cluster_id": "afe6a321-421e-4002-b9d4-be185e9d1b93"
    },
    {
      "claim_cluster_id": "a8ca6792-95c5-4826-87fa-d4a8f7047a5f",
      "event_cluster_id": "451b63c0-8817-432f-8656-27079c8595d0"
    },
    {
      "claim_cluster_id": "7cad6507-3550-4760-99ab-581f5b103f29",
      "event_cluster_id": "b571b4ac-1009-4c8e-8fd0-977fefce53c9"
    },
    {
      "claim_cluster_id": "22ca72b9-d5a1-4be2-9dc0-99fc0a38f586",
      "event_cluster_id": "e7dfffca-5c65-41a6-9fd7-62ccaeb4e1e2"
    },
    {
      "claim_cluster_id": "914ca89d-e967-443c-9856-6a5b040a0496",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6"
    },
    {
      "claim_cluster_id": "4bf14550-b17d-4304-b7d7-0f4f8ea4d2d6",
      "event_cluster_id": "7d3dad5c-ee33-4088-acfc-ba0e93d997c2"
    },
    {
      "claim_cluster_id": "af503db6-fcf4-45f9-9501-f2732e2af4f7",
      "event_cluster_id": "5a5a1e17-8382-4005-9268-9165cf015b00"
    },
    {
      "claim_cluster_id": "7ddce93b-3cfb-4112-a70b-f91eb14e7082",
      "event_cluster_id": "1cd605a0-684c-41fb-8c06-79b227b23a9a"
    },
    {
      "claim_cluster_id": "c2350485-f95c-46d4-9b92-6355ceca86df",
      "event_cluster_id": "bc23e70d-7b5e-43f0-97b5-b24c31beffb6"
    },
    {
      "claim_cluster_id": "203655c2-f1ad-4fb6-94c5-5fc8218603d3",
      "event_cluster_id": "0f5dbdfc-39dd-4747-8fd7-3316ceae5bdf"
    },
    {
      "claim_cluster_id": "511c0db2-0769-45d5-a814-00f974a659aa",
      "event_cluster_id": "1aa19d8d-3161-4beb-8b2d-3a6a4b289e65"
    },
    {
      "claim_cluster_id": "8bcf86f9-8509-4d9f-8550-8839a96fa515",
      "event_cluster_id": "4005f43b-5b4a-44f8-9781-c0a91127368f"
    },
    {
      "claim_cluster_id": "e3c5e173-2814-430b-ad9d-2c7612d87ea6",
      "event_cluster_id": "d88a7e63-a270-4d1c-9493-0a86c58b3e3e"
    },
    {
      "claim_cluster_id": "b9550306-91d4-4e1e-9632-4c73f1957d92",
      "event_cluster_id": "02a17fb1-29be-46e9-913d-2f11d1b37013"
    },
    {
      "claim_cluster_id": "049db6be-2ccc-4afd-97c6-e95cb1b50286",
      "event_cluster_id": "ea3f4ed4-bcaa-40a7-96c3-82beaa656b16"
    },
    {
      "claim_cluster_id": "d47ee5b3-b3df-49e6-9a06-0dbb08c65765",
      "event_cluster_id": "3ec46f1d-e796-464f-991a-62539b2882d1"
    },
    {
      "claim_cluster_id": "7e112a5c-41d4-4f1c-b974-99256b5d357b",
      "event_cluster_id": "f16aab95-d35f-4386-9ea4-6a5f797bcf7f"
    },
    {
      "claim_cluster_id": "d4d4c9f9-96b0-478b-85a5-92a5fa51e55c",
      "event_cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14"
    },
    {
      "claim_cluster_id": "28aee566-0979-4444-a6e1-cda00f681d91",
      "event_cluster_id": "e73d69fc-6584-4fb7-b72a-84be1893ea0f"
    },
    {
      "claim_cluster_id": "2408ad82-3b39-4925-be26-13cd9f14bf98",
      "event_cluster_id": "3abfdae0-5ae4-404e-b93b-1d664986555b"
    },
    {
      "claim_cluster_id": "6efc04ea-c5a7-40f2-bf74-98f55c06f1df",
      "event_cluster_id": "b777e992-68f2-4307-a472-b1ae2b933a6e"
    },
    {
      "claim_cluster_id": "b4e4a860-8721-4ac3-8eb3-a9dec18b336d",
      "event_cluster_id": "205e16cc-f356-4fc1-9b0e-0b31bf6aed12"
    },
    {
      "claim_cluster_id": "ddd4b5a0-2eee-4ff9-bb50-de940c2541e2",
      "event_cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"
    },
    {
      "claim_cluster_id": "10317341-49c9-447e-bafb-6ef554948da9",
      "event_cluster_id": "d6a1f200-a77f-4011-9cf4-4ff9dd9f9335"
    },
    {
      "claim_cluster_id": "8346c5bc-af0f-44c1-b155-e89d63c46a37",
      "event_cluster_id": "22db77fd-3772-400d-bc1d-2826b96b8d9c"
    },
    {
      "claim_cluster_id": "767a107b-6141-45c6-9ffe-6f7fde1b3426",
      "event_cluster_id": "f85fc07c-cf3e-43c8-9d67-6a3594e4fc3d"
    },
    {
      "claim_cluster_id": "6222d4f0-7c6d-42f0-83ec-17412b1907f1",
      "event_cluster_id": "3dc36bc1-d0c5-4f9e-be89-27d20d56e931"
    },
    {
      "claim_cluster_id": "ce2b0119-85f6-4619-9c50-256557181c73",
      "event_cluster_id": "0d989645-1d74-46cc-b203-0ae7bc83c732"
    },
    {
      "claim_cluster_id": "87e60b81-7893-469a-8c14-40e3d6122aa1",
      "event_cluster_id": "3f86eb67-5a60-4e67-ad29-e4342d8dc8d0"
    },
    {
      "claim_cluster_id": "745389b6-9b21-4dd2-89bd-e66fab0ff334",
      "event_cluster_id": "426f797a-e7ef-4bf2-9d6b-e35d76bd66ff"
    },
    {
      "claim_cluster_id": "bd3c25bb-6683-4bdd-8e97-11de485116b2",
      "event_cluster_id": "ff62f156-1b54-448d-8c41-0514a58493a5"
    },
    {
      "claim_cluster_id": "404cf86d-d513-4c8d-adf3-7f2b9464b34e",
      "event_cluster_id": "e5ca8f71-6bbd-48dc-bbcc-02165ada2157"
    },
    {
      "claim_cluster_id": "ed1b332b-c054-4114-82a1-1e645946747e",
      "event_cluster_id": "c17cea6e-319f-464f-958b-423a8d716b81"
    },
    {
      "claim_cluster_id": "3a1f2987-e024-4481-9d2c-9a6882a3fb9a",
      "event_cluster_id": "226d057f-48c7-4bbd-a28a-0aa92cb7c9a5"
    },
    {
      "claim_cluster_id": "c5d18c78-4df0-44fa-9f69-67266b1079e2",
      "event_cluster_id": "0c9df761-94e1-484a-ad16-41bb0a7c5fb3"
    },
    {
      "claim_cluster_id": "08f66922-af24-4cf8-ae47-3d7a8d80fec9",
      "event_cluster_id": "c79c59f4-8dd7-4aa0-bc2d-7d52bf8727f3"
    },
    {
      "claim_cluster_id": "68617739-11a1-4108-8d8c-6d8db53fd247",
      "event_cluster_id": "4d26360a-40f3-4825-be04-23732d33f83d"
    },
    {
      "claim_cluster_id": "83605bab-42d6-405a-ab45-fb6b68e0609c",
      "event_cluster_id": "8df39116-11fd-4c52-8efc-d2dbbee81717"
    },
    {
      "claim_cluster_id": "203655c2-f1ad-4fb6-94c5-5fc8218603d3",
      "event_cluster_id": "fad9d4a0-4f96-4cbe-870b-9fccf870e5e8"
    },
    {
      "claim_cluster_id": "baec81f4-73ba-4194-ab31-e3d64c8a57ab",
      "event_cluster_id": "72521c8d-f680-4322-878b-70c3f47a7f96"
    },
    {
      "claim_cluster_id": "758ea826-ee1f-4a18-bdaa-e713f20f5573",
      "event_cluster_id": "f2132873-f6f5-478c-99f7-99e6e3d16cc3"
    },
    {
      "claim_cluster_id": "8bdd6183-6e5d-4862-87e8-003b661f98ce",
      "event_cluster_id": "12d63e10-92df-43d1-9c3e-5149ff60ae94"
    },
    {
      "claim_cluster_id": "abfcf3df-912d-43b6-968f-0f586e4e242c",
      "event_cluster_id": "a330dd7b-988a-4c80-81be-2d4ba1af385f"
    },
    {
      "claim_cluster_id": "bec9cb65-cf13-44b3-b77b-95d99bace1e4",
      "event_cluster_id": "2fed86e0-073b-4885-a91c-3e9ba6cceef8"
    },
    {
      "claim_cluster_id": "636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd",
      "event_cluster_id": "d1e65b2e-ba15-4227-ab25-8486cb852ba1"
    },
    {
      "claim_cluster_id": "f8c898ca-36a7-47ac-838a-8091321433d0",
      "event_cluster_id": "c932887c-3706-4683-bd4c-6cb5768e640e"
    },
    {
      "claim_cluster_id": "4ada70f8-8bb6-4995-8f14-e79e769b0629",
      "event_cluster_id": "a6d41b3b-e930-4fdb-ae89-6fb33dda11d3"
    },
    {
      "claim_cluster_id": "91e94583-4b9d-4847-9825-9ed7293c7a0e",
      "event_cluster_id": "575fb3af-a2e1-40b5-8235-6bc79d73e849"
    },
    {
      "claim_cluster_id": "e2d7dae8-0d86-4de0-93de-0fca88fdbecd",
      "event_cluster_id": "52ede4ef-4c19-445c-ad39-2f9ff6488929"
    },
    {
      "claim_cluster_id": "626035be-3dc2-4608-b822-013ba6260905",
      "event_cluster_id": "1ac968af-25be-488d-9da9-e6211652dcfe"
    },
    {
      "claim_cluster_id": "86f4bd2f-fbe6-4fe2-b712-f9d4acd0c218",
      "event_cluster_id": "1c8762e3-159f-4448-bbc9-4a59d7bfc9d5"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "00851827-de5d-4b35-bdc2-fc5215bce29f"
    },
    {
      "claim_cluster_id": "58b4a566-79d9-4559-809f-ffd9a84468b4",
      "event_cluster_id": "4a989aa5-e7cc-4043-809c-9f42086f32b3"
    },
    {
      "claim_cluster_id": "bc70c00b-dffe-4092-a775-4a9734094547",
      "event_cluster_id": "513bd779-ed11-4772-ba36-c123bfde18a2"
    },
    {
      "claim_cluster_id": "8fed35fe-4af1-484a-bd4d-74f9fac960c8",
      "event_cluster_id": "da21d9c5-68a7-4237-9343-1a8df452b146"
    },
    {
      "claim_cluster_id": "cfad4c19-24e9-4d54-8d59-d0b08718729b",
      "event_cluster_id": "fe528005-ab2e-4ef9-9304-cfd861dc09be"
    },
    {
      "claim_cluster_id": "4c6dd811-1cc8-4f37-9fa7-2bc4bf91d082",
      "event_cluster_id": "523b0246-0513-4295-a714-19577f713513"
    },
    {
      "claim_cluster_id": "dd5764ad-ed57-4067-b6a4-35ca15790cc2",
      "event_cluster_id": "4794bb46-add2-4c57-9ffb-caa8d6c5bb0f"
    },
    {
      "claim_cluster_id": "d71c3e1e-b92b-4fd2-a1fd-9b3951fec4df",
      "event_cluster_id": "2ae6e0c5-a6f5-4035-9f73-8ab31a8a805b"
    },
    {
      "claim_cluster_id": "c214c388-1bcb-48de-9ccf-d250135ec39d",
      "event_cluster_id": "dae2bae7-bdb4-4c33-b539-e09ed08a3e11"
    },
    {
      "claim_cluster_id": "64f152e4-be60-464e-a365-613ea259a5ff",
      "event_cluster_id": "85cfe769-d38e-42c1-b06b-f313ff275d96"
    },
    {
      "claim_cluster_id": "732c6dc2-1231-46ca-b1c1-173c0f488176",
      "event_cluster_id": "815c147f-e9cf-4afc-9a1d-d83dea6ef481"
    },
    {
      "claim_cluster_id": "6f18d0d0-1cda-49ba-9530-57de51dff25a",
      "event_cluster_id": "72148a6d-891a-4283-bda4-8779feaa1601"
    },
    {
      "claim_cluster_id": "3e1920d2-6038-4d0b-b122-137c458f6d99",
      "event_cluster_id": "8ec6c014-24e3-40b5-a577-20ca128d6e41"
    },
    {
      "claim_cluster_id": "bde9febe-9a28-4f0f-b67c-15f9a243538b",
      "event_cluster_id": "14d0a92d-65cb-4881-998f-aed067993e99"
    },
    {
      "claim_cluster_id": "58a44cd6-3f44-4460-9d07-d5a28bd55747",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "event_cluster_id": "9cef1461-4ccb-4b2f-8a1e-1d71ef404be6"
    },
    {
      "claim_cluster_id": "d232b59a-12d7-48e0-9945-60749a40e538",
      "event_cluster_id": "90309cf4-c7b2-4dbe-a694-62efd0012476"
    },
    {
      "claim_cluster_id": "24a47a14-4ee4-4529-96e9-02c94e429ea6",
      "event_cluster_id": "efada224-bd67-4a33-8ca6-01f2d398630b"
    },
    {
      "claim_cluster_id": "8992a182-5ede-4dbb-9979-4dcf0e10c546",
      "event_cluster_id": "f45eb579-66d6-44ec-ab0f-e41545f58c6c"
    },
    {
      "claim_cluster_id": "4e7d68ff-7bd2-4949-affb-c71a8a76240a",
      "event_cluster_id": "5342c103-f887-4c11-8002-61b16e22dc39"
    },
    {
      "claim_cluster_id": "253fbf69-01a5-4352-a109-1aea0fdf1fe3",
      "event_cluster_id": "dc0f2fc6-867e-476a-b8e1-8031edcf72a7"
    },
    {
      "claim_cluster_id": "dfa7b9d2-5920-4d57-8445-e48ac5ce73da",
      "event_cluster_id": "0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3"
    },
    {
      "claim_cluster_id": "7be2aab8-ebba-4a53-8dd8-2f99fbdc274c",
      "event_cluster_id": "edeb68e2-0660-4461-9b92-dd0ab5f321a1"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "8b0aef83-1693-4fa2-8559-a133b18a2dbb",
      "event_cluster_id": "02b41fd0-8916-41c1-8494-482e3096f186"
    },
    {
      "claim_cluster_id": "471cd849-51ac-493f-a2b6-3965a7fc582c",
      "event_cluster_id": "44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"
    },
    {
      "claim_cluster_id": "beb979e4-f486-4e3c-ba15-47b099971ff0",
      "event_cluster_id": "afa23bc4-1fbb-45ef-b64c-09dde901c8b3"
    },
    {
      "claim_cluster_id": "388dcf56-c13f-4ec5-bbc7-b3c71eaffd35",
      "event_cluster_id": "8ea40711-b70a-408e-8b0e-c86a36b4d669"
    },
    {
      "claim_cluster_id": "7f94beb2-9a43-4280-9734-5045402a0714",
      "event_cluster_id": "3662eaef-57cc-467f-a555-ca15b13b9be9"
    },
    {
      "claim_cluster_id": "4a4d472c-cd13-4ccf-9f30-e866d14bdbf8",
      "event_cluster_id": "8d987874-4ebf-4fd4-b0c2-5cd72bf55264"
    },
    {
      "claim_cluster_id": "de60bb28-4ca7-441f-814b-f2ecfe29fb54",
      "event_cluster_id": "c09d9041-f33e-4fbb-bb7b-4e43f4329c75"
    },
    {
      "claim_cluster_id": "f799549d-5869-4a73-bd0f-66e1fb2939bc",
      "event_cluster_id": "d6692fd4-0be3-4dc0-8e52-422dc764cb03"
    },
    {
      "claim_cluster_id": "8567d4c9-fb06-4505-b09d-13b1efafa073",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "5a140171-9551-46fb-8eb7-bce434648b1a",
      "event_cluster_id": "19904647-b456-48f0-bdd3-4c7803aa2b21"
    },
    {
      "claim_cluster_id": "800e7e36-7ce1-4e55-a18d-394d83673d71",
      "event_cluster_id": "ab9082a7-9db5-4c59-ad04-1242dca4509b"
    },
    {
      "claim_cluster_id": "5cab19a1-9532-4ca5-8f94-e19c788f807b",
      "event_cluster_id": "48f73ce8-5bb4-4ea5-acad-4966cfa816f8"
    },
    {
      "claim_cluster_id": "ff763739-26e3-4daa-93bc-7ecf065c5275",
      "event_cluster_id": "80650d11-8f1c-4d32-a46d-12e884243f7e"
    },
    {
      "claim_cluster_id": "2bd9ff92-4ea3-492e-a249-5de7759a5956",
      "event_cluster_id": "7b48e171-a32e-4aa5-90bf-b37f44678964"
    },
    {
      "claim_cluster_id": "e4184b4a-b3b8-45cd-9a60-442e840d1a7e",
      "event_cluster_id": "0e7e5665-e1ba-44c9-b9e8-62d3501bb81c"
    },
    {
      "claim_cluster_id": "0450cb4c-8816-4bbd-85b6-ac94ecde9af4",
      "event_cluster_id": "6a2d22fd-b7e4-46b8-aa28-69039af2d9e4"
    },
    {
      "claim_cluster_id": "c70207c5-86bf-4f7f-b715-56b9c8674c3b",
      "event_cluster_id": "7b263d1a-e07c-48cc-bbc0-8a228f72f292"
    },
    {
      "claim_cluster_id": "7fbcd1a7-a676-46b6-a3c0-af823173a2b1",
      "event_cluster_id": "83a91d6e-ceaf-4824-b195-eb7ebd584c9a"
    },
    {
      "claim_cluster_id": "a32303e6-4765-4335-9847-b5ee18494799",
      "event_cluster_id": "7e78bb5c-524d-46ad-855f-72bd9413c27e"
    },
    {
      "claim_cluster_id": "f3b06230-c202-438a-8858-b8c55fa68828",
      "event_cluster_id": "71435cc5-d65b-4e3e-9454-ffe0371a42f1"
    },
    {
      "claim_cluster_id": "8255a43f-82ec-4f1a-8f29-78e7a247a2d1",
      "event_cluster_id": "c5bc8d69-1894-4720-8281-0a21bdbe0e98"
    },
    {
      "claim_cluster_id": "721fca95-63af-4a1d-bae5-70b55fce9a8b",
      "event_cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff"
    },
    {
      "claim_cluster_id": "86ef5628-f267-4ce6-97b4-2f06bd91a5fa",
      "event_cluster_id": "ba62b16f-4f39-4172-b2c7-0b991499ca69"
    },
    {
      "claim_cluster_id": "b6c851f0-a597-49e8-982b-650d02a8ba55",
      "event_cluster_id": "b9961616-57c0-4002-a439-bbd0acf2194c"
    },
    {
      "claim_cluster_id": "aaf51226-d11b-4c1b-82db-25727f24712a",
      "event_cluster_id": "4fb659e6-6366-4a40-9ae4-1332edb2d8b2"
    },
    {
      "claim_cluster_id": "5ab9d303-668f-48d9-893f-546437484767",
      "event_cluster_id": "28019fcd-ae8c-42b5-8f8c-7fa226a5335a"
    },
    {
      "claim_cluster_id": "7b36df0c-5a40-406c-8572-3bb3871611ca",
      "event_cluster_id": "ab73bace-5110-4ac5-b01b-8b28976f8120"
    },
    {
      "claim_cluster_id": "4af97b54-9617-48e3-8125-aa1e8e1ee8a2",
      "event_cluster_id": "fd395743-8cf0-4953-ace0-85cff9e72be0"
    },
    {
      "claim_cluster_id": "5a787097-c657-4d02-a7e7-ce5ddfe404d6",
      "event_cluster_id": "d74e9977-9a16-4baf-861a-98a8ddead66c"
    },
    {
      "claim_cluster_id": "15c2186e-db17-4b08-bbd9-d03072fa580d",
      "event_cluster_id": "5db738fd-0af6-4d3f-8483-2d8b409e966d"
    },
    {
      "claim_cluster_id": "1010a45f-c4e6-41d3-ad44-9a27b9dc7893",
      "event_cluster_id": "ea4dda18-9c10-4944-8540-e2c0066f573b"
    },
    {
      "claim_cluster_id": "1ff9104e-969b-469f-b204-88f04894d01f",
      "event_cluster_id": "1dde6808-a5d8-4cff-a522-2b1380a746a4"
    },
    {
      "claim_cluster_id": "8e9cb96a-0ee8-44fc-9406-1bb5188864ec",
      "event_cluster_id": "5f5241f6-dc62-4f74-8e2a-d9e564410ef8"
    },
    {
      "claim_cluster_id": "7553f34f-d61f-419e-8976-cecf89bafb0e",
      "event_cluster_id": "1d910892-dde8-467f-8bc1-dac08ec78136"
    },
    {
      "claim_cluster_id": "c94810e3-5711-44bc-a55f-5ef59645cf78",
      "event_cluster_id": "cd8387d2-f3fa-45cb-9628-ef16bef4b5fa"
    },
    {
      "claim_cluster_id": "58953090-5955-480d-95b2-311ed2c0f653",
      "event_cluster_id": "6b8c1ab6-dc22-46f5-831a-de1a865875f0"
    },
    {
      "claim_cluster_id": "f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb",
      "event_cluster_id": "d0bbd332-807a-43c4-8b16-bc8817897189"
    },
    {
      "claim_cluster_id": "b6e703fc-a44f-43d6-9db6-85666a802044",
      "event_cluster_id": "9b88354d-eae6-4159-b5cd-4aa560c1a939"
    },
    {
      "claim_cluster_id": "7eb7c781-85c0-4773-8374-eeb7374b471d",
      "event_cluster_id": "e424d11c-d0d7-4fab-ba10-6b37559e56f0"
    },
    {
      "claim_cluster_id": "ff3f6026-485f-4fce-9d57-b8206b8e11c5",
      "event_cluster_id": "824a023b-59e7-46a7-a55c-6ef905c079b9"
    },
    {
      "claim_cluster_id": "64b43278-d723-4b63-bcf0-181e1a1658f9",
      "event_cluster_id": "de1e5d6e-28d7-4405-8085-e6133787bf1e"
    },
    {
      "claim_cluster_id": "1e12b1a7-9bc4-4a98-b698-8392df483432",
      "event_cluster_id": "95bc2531-eabc-48ae-aefe-417173f45673"
    },
    {
      "claim_cluster_id": "ea54647f-e4a4-46e7-bf16-66e30583a4a6",
      "event_cluster_id": "a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"
    },
    {
      "claim_cluster_id": "5d4bd659-348a-4fe3-bacf-eb25b0043f94",
      "event_cluster_id": "d1aa87f5-6e8b-45d2-89ab-5267e8136707"
    },
    {
      "claim_cluster_id": "a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0",
      "event_cluster_id": "4df23607-a04c-40e8-be3f-b8d874dc3d06"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "28e936b6-8a48-4d96-b4e6-7c0ff60a51fd",
      "event_cluster_id": "b9b5e870-c720-4c60-8d9c-ce6b4803fb78"
    },
    {
      "claim_cluster_id": "c3cd1557-129f-4369-b850-25bdf5456c16",
      "event_cluster_id": "4abd438c-8dff-4f9a-8a7c-0da2a36edcc9"
    },
    {
      "claim_cluster_id": "6a54c6d4-9e49-450e-95c4-f3afc0f85f6c",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "e82ed51a-4d19-4b2d-96bc-cb54f9b70858",
      "event_cluster_id": "8a8f242c-8eef-4ca8-a157-47a2a04d8d4e"
    },
    {
      "claim_cluster_id": "89b27333-1443-478a-ae8d-2e32423dac3d",
      "event_cluster_id": "fa5cbe37-2f0a-489e-a2bd-a58e7dfa8418"
    },
    {
      "claim_cluster_id": "c3383556-4a09-4d9a-b202-b1b017162bd3",
      "event_cluster_id": "ad7f3e47-f7f2-4a5d-8168-7644c3de8a32"
    },
    {
      "claim_cluster_id": "da33c07b-485b-43b6-8165-46193fb1720d",
      "event_cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c"
    },
    {
      "claim_cluster_id": "bba9ba69-2957-4432-9f56-bcb77e8342e2",
      "event_cluster_id": "fa579361-a6a5-42aa-a37b-78556d46e1d5"
    },
    {
      "claim_cluster_id": "4f2be876-d890-4fd4-a767-3f52bbc9c4c4",
      "event_cluster_id": "e541bcb9-7f32-4df3-a682-0d185b753537"
    },
    {
      "claim_cluster_id": "fb6ff34e-94b0-4910-b613-9ebb9af0b6b6",
      "event_cluster_id": "fa749b08-cff6-43ee-a52c-6c982c75d42a"
    },
    {
      "claim_cluster_id": "a7d1cc33-aa3a-4ee3-86f6-065986a716af",
      "event_cluster_id": "8b1769db-6aae-4f31-8eca-13c7641a8a79"
    },
    {
      "claim_cluster_id": "f8cc40a9-e215-46da-bdf5-b5efc622bb40",
      "event_cluster_id": "4c0dfd84-df3b-4660-9041-a635021908ef"
    },
    {
      "claim_cluster_id": "a55a36be-0edb-44d4-8400-10d53525802c",
      "event_cluster_id": "104fb09e-1224-46b2-885e-348a5c279186"
    },
    {
      "claim_cluster_id": "f57f4c9e-1d41-4f34-b42f-aa11437d6812",
      "event_cluster_id": "05de0fcd-b07f-4daf-b084-2e15c6be78b3"
    },
    {
      "claim_cluster_id": "c9335a55-7c59-42cb-98be-e69b4262faa0",
      "event_cluster_id": "7681cbe0-1efe-4edf-b906-ebf02351325e"
    },
    {
      "claim_cluster_id": "c8416335-0a4e-4b5d-aa9e-40e533302d3c",
      "event_cluster_id": "e4af0ca6-d383-4356-85a7-09352d68c2e9"
    },
    {
      "claim_cluster_id": "f9c980a9-33b9-4834-922a-947a13f5a035",
      "event_cluster_id": "f8e8b236-0393-4a1f-8e82-d30d9e30a2fb"
    },
    {
      "claim_cluster_id": "ff3f6026-485f-4fce-9d57-b8206b8e11c5",
      "event_cluster_id": "8335c349-e4e7-4586-b3d0-516ccf0a3944"
    },
    {
      "claim_cluster_id": "db13aa73-f539-42d8-89d9-1af57cfff5a3",
      "event_cluster_id": "266e7b13-78e4-4d47-a479-faf867ea0a51"
    },
    {
      "claim_cluster_id": "9e96a51d-6101-42af-b7a2-54e4dd5ae715",
      "event_cluster_id": "dae41dee-2a76-4085-8c91-121f704580c1"
    },
    {
      "claim_cluster_id": "b2635760-bcd6-46c7-88fb-9bbbb7349033",
      "event_cluster_id": "1e84c102-c60e-427e-9c32-95517ea67008"
    },
    {
      "claim_cluster_id": "00cfa90d-eff5-4498-89d6-85dadca46eb8",
      "event_cluster_id": "e15ef239-9f26-4808-8bf7-31e94108dff6"
    },
    {
      "claim_cluster_id": "a6683ed0-4b78-4420-9494-296c3493439d",
      "event_cluster_id": "21751149-a038-4fe4-a432-932902e5041b"
    },
    {
      "claim_cluster_id": "38711d17-ac82-464c-a077-7a82e0d362fd",
      "event_cluster_id": "109d7869-80dc-4ec3-9550-208fe3c6f717"
    },
    {
      "claim_cluster_id": "4a575d85-5f97-4baa-be78-2c26ecefb471",
      "event_cluster_id": "fcb27263-9c47-4749-8f07-d80ab25d503e"
    },
    {
      "claim_cluster_id": "f72eb4bb-112f-4556-a279-ad745cb4894c",
      "event_cluster_id": "6773439f-27bf-46ee-884f-6f78667de502"
    },
    {
      "claim_cluster_id": "5528714b-b0b8-40d9-850a-99905744c056",
      "event_cluster_id": "bb09aa05-ec64-4861-98cd-96845b502414"
    },
    {
      "claim_cluster_id": "40621ae5-171b-4ff7-a8cc-0957a4cc93da",
      "event_cluster_id": "bc705731-4001-4b4a-a9bd-71359c405ab2"
    },
    {
      "claim_cluster_id": "544ac6da-d621-4fd5-bbf8-4a2cd6254e41",
      "event_cluster_id": "8476cb8d-5c1a-489b-ac54-9099d01657db"
    },
    {
      "claim_cluster_id": "59e6bbb6-5982-4df0-b59c-33f07ce159f4",
      "event_cluster_id": "adc5ea43-1ddd-4862-afc6-b17c270c9d83"
    },
    {
      "claim_cluster_id": "60ed7bd8-a38c-4b99-a08f-6210e30fac23",
      "event_cluster_id": "b8c71793-7735-4b85-ba5a-b3e53e437f73"
    },
    {
      "claim_cluster_id": "93548381-56c4-4fb7-be49-43e644f447fb",
      "event_cluster_id": "6c452c9f-8197-4d78-94e1-5bde1551953f"
    },
    {
      "claim_cluster_id": "7e9a80fa-c7f8-4eeb-8f62-09cee3732838",
      "event_cluster_id": "37216476-5d5c-4faa-9d46-a9c7fd453ec4"
    },
    {
      "claim_cluster_id": "1be65d4d-c915-41d3-9d1c-864035425656",
      "event_cluster_id": "e1f0a82d-250e-4472-bc8b-76e1029d4554"
    },
    {
      "claim_cluster_id": "174a0855-e1b9-4e2b-9a6a-957eb12d4b1a",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "dd5d0634-bc30-45f9-b45a-97773c63db2a",
      "event_cluster_id": "99e93b0d-aa99-4889-a4e7-3146b3109f12"
    },
    {
      "claim_cluster_id": "b654c64c-3acf-45f6-a6ea-c4584b8c70fe",
      "event_cluster_id": "8d28e81a-99f1-4b51-9eec-891947b08d71"
    },
    {
      "claim_cluster_id": "9960f165-6141-4ca0-8dc4-0a136bfde83d",
      "event_cluster_id": "a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"
    },
    {
      "claim_cluster_id": "7bfb1246-c004-4c78-a34d-8e0a5cdad287",
      "event_cluster_id": "39719bfa-8761-4992-b42f-7b9ea44519ab"
    },
    {
      "claim_cluster_id": "ee9a474d-ce93-4992-ac4b-8d9da4087257",
      "event_cluster_id": "5cf0a8e1-26c0-4c2d-bf3f-608120510569"
    },
    {
      "claim_cluster_id": "06da14b8-536e-4d2e-83b1-118cfb44829b",
      "event_cluster_id": "64e6dbae-d0db-43b2-acc6-29b1e94d9205"
    },
    {
      "claim_cluster_id": "54fa045c-bc33-4348-a964-82cb98ec67f5",
      "event_cluster_id": "a6afbf41-e20a-4832-891c-6e8ecee24d06"
    },
    {
      "claim_cluster_id": "34e272f8-beb9-408f-a252-0fa71406dc4b",
      "event_cluster_id": "1d9de982-6324-4241-9481-7618f52a1421"
    },
    {
      "claim_cluster_id": "2870dcce-8def-47de-9196-c66889a0a474",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "4cef0d90-5e3b-44f3-ba12-57b1ee19455a",
      "event_cluster_id": "c555ba02-3f53-4880-89cc-6382472f4518"
    },
    {
      "claim_cluster_id": "be023ca2-f865-4811-854e-b40ab442412b",
      "event_cluster_id": "18ed12f0-a6ed-4c61-bb56-179e38c03061"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "7640b35f-031b-4917-bf34-5555111a4a74"
    },
    {
      "claim_cluster_id": "abfcf3df-912d-43b6-968f-0f586e4e242c",
      "event_cluster_id": "79d39e26-3c77-4ccb-be20-fd89e10bc54c"
    },
    {
      "claim_cluster_id": "8e873c15-6407-475e-841a-2dcbbce28e18",
      "event_cluster_id": "6feeb810-f8d8-4337-b308-bbd0aa0c4221"
    },
    {
      "claim_cluster_id": "54a8d4bb-c88c-46df-a439-6be0dfcdce0d",
      "event_cluster_id": "43152486-d4dd-4e19-b1d2-24534e09e32d"
    },
    {
      "claim_cluster_id": "81a839cf-9fe4-4f39-95e1-2ebc94ae6380",
      "event_cluster_id": "2ec09e70-73d9-4395-9c36-0dbcac034464"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "7206ac0e-b88d-4695-a9fd-a007b0fa396e"
    },
    {
      "claim_cluster_id": "bfa96159-d0c2-4735-8c1a-2d33b2346d24",
      "event_cluster_id": "8bdd7aea-e82e-44ed-9306-49ba0cde454c"
    },
    {
      "claim_cluster_id": "924c4170-d405-438e-937c-13478012b72c",
      "event_cluster_id": "79c33296-4152-4931-a84a-5c44d838a216"
    },
    {
      "claim_cluster_id": "c8265999-6e3a-4835-bb5a-9e081a27e9bd",
      "event_cluster_id": "3277c81f-d2ed-42ea-acc4-bb977e68f163"
    },
    {
      "claim_cluster_id": "ed9c7f02-d3d7-4f88-92df-80c91b7dca98",
      "event_cluster_id": "29477fdd-bbbe-4e39-b779-19de18778240"
    },
    {
      "claim_cluster_id": "1b36c1d4-6613-4a77-b192-f653249b73a3",
      "event_cluster_id": "5c7b360c-c61a-4fc7-88f8-807bde4dcb6a"
    },
    {
      "claim_cluster_id": "cb7188de-21fe-4631-9d3e-697f1fa246b9",
      "event_cluster_id": "211a5b9b-b352-4fd9-9450-827ad138f833"
    },
    {
      "claim_cluster_id": "6f473cd4-feae-4e71-a4f1-47b2820e799e",
      "event_cluster_id": "1bdc4e39-4f85-4244-acae-0889a6b1bb01"
    },
    {
      "claim_cluster_id": "577be512-045b-4f32-8688-400d686a100d",
      "event_cluster_id": "01eb8b8e-096c-4892-bc91-ee4788a133cc"
    },
    {
      "claim_cluster_id": "294ad0e1-cad9-4655-b7de-5e21de0e4797",
      "event_cluster_id": "80a8792f-9489-40e4-a0a2-e1e4173e1957"
    },
    {
      "claim_cluster_id": "f636e358-668e-41dd-bffc-037f53b4ab48",
      "event_cluster_id": "845395ad-4701-4574-ae25-f53da9fca0d2"
    },
    {
      "claim_cluster_id": "13a07f14-45d6-4b31-8d23-23b540ac8090",
      "event_cluster_id": "4ea15f73-7350-4e50-b190-6edec6cdfa32"
    },
    {
      "claim_cluster_id": "9367c0e9-bbdd-4398-9de3-210a1f73c88e",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "28aee566-0979-4444-a6e1-cda00f681d91",
      "event_cluster_id": "80a8b2f6-3818-4f88-87e9-d88c26c8754c"
    },
    {
      "claim_cluster_id": "8c18859c-7432-4cc4-af8f-8a5eb220876e",
      "event_cluster_id": "29ce98a7-4a68-4b4f-be7a-d7b325128299"
    },
    {
      "claim_cluster_id": "bbefdcbd-8560-44a4-b45a-d11652dfe311",
      "event_cluster_id": "84cbf3d1-afbc-4ba1-8495-8ff7aee7e81f"
    },
    {
      "claim_cluster_id": "253e1524-e402-4a4d-b7db-f94b8f989d9c",
      "event_cluster_id": "0c9df761-94e1-484a-ad16-41bb0a7c5fb3"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "53bc38bf-651d-46ea-8aaf-f63f52195a45",
      "event_cluster_id": "7c123398-3043-4df1-bb86-5ded4584dc33"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "65ac3d2f-1144-42ab-9435-1522b78a54a3"
    },
    {
      "claim_cluster_id": "1b5c8541-b848-4f05-865e-43826009d4e7",
      "event_cluster_id": "4b8668b9-ec8e-41f1-b42b-e53f7eac0641"
    },
    {
      "claim_cluster_id": "3232bd90-9251-47f0-ae93-ae2d51218354",
      "event_cluster_id": "c89da02e-a1bc-4522-a452-82abf8c705c4"
    },
    {
      "claim_cluster_id": "e0a99d28-f3a4-477a-b874-8d839c4523f9",
      "event_cluster_id": "674305e3-342c-4b85-8170-13a2aefe9456"
    },
    {
      "claim_cluster_id": "d3913637-42d6-426c-8654-a13850b8306c",
      "event_cluster_id": "e281f767-6c47-4711-ad9a-1c5709e1cb60"
    },
    {
      "claim_cluster_id": "838e6a9b-36b6-4be2-87e8-cb3d0595dcf6",
      "event_cluster_id": "fc33211b-6f76-4ea3-8d05-51362bd964b0"
    },
    {
      "claim_cluster_id": "cc37a7b6-46fd-4cda-8faf-63a00cd3c131",
      "event_cluster_id": "331d66f6-8c23-4632-b4ad-7949a81b62cc"
    },
    {
      "claim_cluster_id": "043e7562-9880-4d36-ba06-fd8e6b3afbe1",
      "event_cluster_id": "eff030fc-3925-4754-bd4e-8589b262523a"
    },
    {
      "claim_cluster_id": "dd5764ad-ed57-4067-b6a4-35ca15790cc2",
      "event_cluster_id": "1da0b887-e497-4790-9c97-6324fa7f1453"
    },
    {
      "claim_cluster_id": "d97f4faa-5b32-4a18-93ac-69c340df4581",
      "event_cluster_id": "90dfa891-ea54-44ec-9c4c-37a32cc92299"
    },
    {
      "claim_cluster_id": "5f9b6057-0fab-4c3c-b1af-a7c26bc6c692",
      "event_cluster_id": "194f810d-af4b-491d-bdf7-3aad4b9c5e55"
    },
    {
      "claim_cluster_id": "1e19ebda-0ce5-4c42-b6ac-f081acdf5974",
      "event_cluster_id": "85c8c155-84b6-47ef-ae7a-060440258d20"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "e8e474c4-3709-41ab-99a8-21deaa3d6742"
    },
    {
      "claim_cluster_id": "f4cd4d9b-6b2b-454a-ae24-3a0150790009",
      "event_cluster_id": "59ccfd51-c23c-4ddd-9244-d1ca28b0c8b8"
    },
    {
      "claim_cluster_id": "9d21be2e-9f01-48c9-b454-3a41788e2865",
      "event_cluster_id": "82f5beda-b460-413d-ba52-232c56bac459"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "444e2d84-e3c4-4a82-a2fc-3577e6124f09",
      "event_cluster_id": "d4eb4c1f-a715-4507-898e-b25f61a6667b"
    },
    {
      "claim_cluster_id": "94f243ab-1521-4874-b5fc-b80847a7fefc",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "2f4149f0-f4a5-4695-86fa-9ea760cb8651",
      "event_cluster_id": "d114caf2-8385-480a-a600-9c4b33ae3a55"
    },
    {
      "claim_cluster_id": "783f85bb-dceb-450a-9a34-4a650e18ed9f",
      "event_cluster_id": "45dc7d2c-74e1-4100-9b06-cc0f631f56f5"
    },
    {
      "claim_cluster_id": "e7a1e23f-832f-432a-ad19-207015a794b2",
      "event_cluster_id": "f5c0430d-6c19-4e4b-815d-7de708ba52a8"
    },
    {
      "claim_cluster_id": "018f6f1c-b2e7-43ca-a443-3a5d27b5033c",
      "event_cluster_id": "584c4eba-f170-4492-9acd-c1773318790d"
    },
    {
      "claim_cluster_id": "4b605940-f896-4b59-bf12-36fbeec83b94",
      "event_cluster_id": "141e6842-296d-43da-b53a-06cadf04679a"
    },
    {
      "claim_cluster_id": "de7b2349-3e46-436f-9b75-c57089eeaa3c",
      "event_cluster_id": "e6396265-e4ff-4b5b-8b50-46f16a8b1b5b"
    },
    {
      "claim_cluster_id": "b398f217-24d9-4c22-8d5a-732320853c1b",
      "event_cluster_id": "e7125b37-2f58-44dc-935e-482a2f26ca14"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "66420625-d310-4fd9-aca9-82e4fec83c68"
    },
    {
      "claim_cluster_id": "74bc9e46-31ab-4e9e-9240-87a035b90601",
      "event_cluster_id": "98e6d6ef-a2d4-4de1-80f2-7297b807d073"
    },
    {
      "claim_cluster_id": "7ff438ec-b701-48aa-b613-4bfeaba7bcce",
      "event_cluster_id": "9fea69be-9aad-4b8b-aca6-7960741c46ec"
    },
    {
      "claim_cluster_id": "f8d5c2ae-ad96-41f1-8875-2d89a574f697",
      "event_cluster_id": "0e1e3fbc-262d-409a-9734-949f40c46427"
    },
    {
      "claim_cluster_id": "d29a2d68-5d53-4ad3-9792-37db5375f45d",
      "event_cluster_id": "4a433aaf-8b78-4d61-9c2c-bc9bf2bfa734"
    },
    {
      "claim_cluster_id": "ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8",
      "event_cluster_id": "42b243b1-6e2f-4145-911d-1a4fb97435e4"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "7462b6fe-d6f4-4e65-ac8e-8fa4c8e00ce3"
    },
    {
      "claim_cluster_id": "02f58db8-b951-46f8-9ff7-76980a66fc66",
      "event_cluster_id": "9fea69be-9aad-4b8b-aca6-7960741c46ec"
    },
    {
      "claim_cluster_id": "dc3308e5-2250-431f-bef6-733e2b943275",
      "event_cluster_id": "8ab5907a-7d78-4873-b326-304fe58b10f8"
    },
    {
      "claim_cluster_id": "b407290e-0e65-4bff-90dc-c2ececfb37ab",
      "event_cluster_id": "ac7642b8-b25c-45db-8998-1d3c7f1c25e7"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "712fa0e5-9886-40f6-b761-bb1a99d5fb8c"
    },
    {
      "claim_cluster_id": "88c2038a-24a0-497f-bac0-84ee519d160d",
      "event_cluster_id": "c9b1317b-d9b8-4f19-b568-8b833e155fb5"
    },
    {
      "claim_cluster_id": "4ada70f8-8bb6-4995-8f14-e79e769b0629",
      "event_cluster_id": "aa931a1c-d292-40d9-9c54-451d60524b03"
    },
    {
      "claim_cluster_id": "71084441-cc44-4209-84ff-0b19201dd17c",
      "event_cluster_id": "d7d8a2ba-6242-4963-a3f8-0e40fd7043dd"
    },
    {
      "claim_cluster_id": "041ca325-747b-4d3c-b3c4-9ee7fabc37db",
      "event_cluster_id": "c829d647-4388-40da-86fd-479a810865ab"
    },
    {
      "claim_cluster_id": "1dae585e-f051-41dc-8fc8-c2d3e3b3b884",
      "event_cluster_id": "760769b6-c063-42c2-8199-157a1d623f27"
    },
    {
      "claim_cluster_id": "f80dd275-a1a9-4cb7-becc-0fe298aae99d",
      "event_cluster_id": "7aa12e18-818d-4e83-947b-42a4e69ce8db"
    },
    {
      "claim_cluster_id": "4313d034-31f9-4eb9-9451-e9a5dda6e7c3",
      "event_cluster_id": "8a462401-6f97-42ba-a69e-60e2ceb6f0ac"
    },
    {
      "claim_cluster_id": "897e2456-ff2b-43b5-9a48-23b6c36b2d95",
      "event_cluster_id": "f9e6216a-ee1c-443b-8198-daf20f932faa"
    },
    {
      "claim_cluster_id": "8db7f2ee-28e7-4abd-b214-9d334508a075",
      "event_cluster_id": "e6007b6f-2ba5-4830-8564-f98f1943ec9d"
    },
    {
      "claim_cluster_id": "a6683ed0-4b78-4420-9494-296c3493439d",
      "event_cluster_id": "b929e356-d8ff-49f7-a4f5-c02953cef416"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "da7d71b1-1db7-40cb-a127-20a20d4dc377"
    },
    {
      "claim_cluster_id": "b331f46e-c31d-4c56-81c9-c40834960e1f",
      "event_cluster_id": "4c3966c5-0cc9-4924-906d-113f0618534f"
    },
    {
      "claim_cluster_id": "c6d2f5c4-bb51-435b-a664-174b47ed38ef",
      "event_cluster_id": "6fe0709b-66c5-4553-a6ae-89bdc6df31fc"
    },
    {
      "claim_cluster_id": "325111bb-e15c-4f08-a4a4-3f81e99d9f35",
      "event_cluster_id": "205d2c16-9ba3-4e14-887c-3331a1f50616"
    },
    {
      "claim_cluster_id": "13470ac2-b4c3-4aff-aa6a-418a5222958e",
      "event_cluster_id": "88cb9dbf-3c86-496b-8c5d-43080d758d2a"
    },
    {
      "claim_cluster_id": "0261ee84-1c1e-4042-9226-f1085216eef2",
      "event_cluster_id": "87bd589d-2421-4528-b337-18cde30c4d49"
    },
    {
      "claim_cluster_id": "6d226b20-d54f-48d2-bd7d-2616184afc68",
      "event_cluster_id": "88c327f9-75c2-480a-8aa8-272d021cabe8"
    },
    {
      "claim_cluster_id": "b65267b2-a6b3-4938-aff4-8dde024d5b46",
      "event_cluster_id": "ae3d775b-868a-48c9-b712-67b58ccbee8a"
    },
    {
      "claim_cluster_id": "3dcf8216-5e70-4cd4-962e-dc4b036a0071",
      "event_cluster_id": "3f1ec78d-49c2-44d1-bdc2-97cf6217c638"
    },
    {
      "claim_cluster_id": "060a7355-d23c-448a-8514-2034a0d11495",
      "event_cluster_id": "b03907b4-379e-44df-a2b4-6f069b3d131a"
    },
    {
      "claim_cluster_id": "f8d5c2ae-ad96-41f1-8875-2d89a574f697",
      "event_cluster_id": "efefa709-c6f7-4ec6-ac92-9ac520723e87"
    },
    {
      "claim_cluster_id": "ab829976-d7fb-4b30-9b92-89eed4e94cc4",
      "event_cluster_id": "fece93a1-7734-48a4-99b6-9dce302454b2"
    },
    {
      "claim_cluster_id": "e9280ed1-20ec-4c75-8468-086e8c6749dc",
      "event_cluster_id": "3e86f418-a7c7-46c6-9106-86fe0b88ffdf"
    },
    {
      "claim_cluster_id": "099e4f99-da99-4f13-a242-dd05de802ab3",
      "event_cluster_id": "9876318f-24a7-47a3-a0cc-61a7ad5d114e"
    },
    {
      "claim_cluster_id": "e7e80c41-a749-4b0c-a666-715bedd44f52",
      "event_cluster_id": "42dcf3d9-1011-484c-9355-4db97109e640"
    },
    {
      "claim_cluster_id": "a1593cbe-8c39-423f-abae-2707e84a1e5e",
      "event_cluster_id": "29c87b68-66f6-4218-b4fc-f6324d0ab7c7"
    },
    {
      "claim_cluster_id": "16b63ffa-da4e-4cff-8fab-fffc1644a634",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "fd3ca8c5-bfa9-4e66-bc57-721306073eb0",
      "event_cluster_id": "b85f1177-adf6-443e-8aa8-4b882389f698"
    },
    {
      "claim_cluster_id": "799387af-65e2-4baa-bed7-0f025e3fbc39",
      "event_cluster_id": "acb8c5a5-3818-4898-ace2-3330d0f18d6b"
    },
    {
      "claim_cluster_id": "035bc55a-3ae4-48b4-942f-bbef3d308147",
      "event_cluster_id": "6964b660-5818-4d1d-be3a-055b02c10ee5"
    },
    {
      "claim_cluster_id": "e2d7dae8-0d86-4de0-93de-0fca88fdbecd",
      "event_cluster_id": "b0d55664-d514-4b2b-87ec-b7bb14627d05"
    },
    {
      "claim_cluster_id": "51b16b2e-6404-4d18-a4d1-46e0d25d726f",
      "event_cluster_id": "9f0b5b9d-5ada-4603-b28a-01eb2e4517b2"
    },
    {
      "claim_cluster_id": "5aec5e12-6df7-45c2-ae07-2921310e080b",
      "event_cluster_id": "eb540b94-f26f-4993-9d85-8c7b5fc26cca"
    },
    {
      "claim_cluster_id": "27b386d8-58df-4b19-a269-36bb2400c94c",
      "event_cluster_id": "2db0c2dd-c8a4-4511-9c67-695e43307f50"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "facc7561-4a20-4459-a43c-a6df1f7f9d23"
    },
    {
      "claim_cluster_id": "2c49dd92-a97e-4b1e-bac2-607670a0a86d",
      "event_cluster_id": "25676d7b-137f-4f70-b3ce-39af6bc7a4fe"
    },
    {
      "claim_cluster_id": "9f69b38a-0ed5-48e5-ac15-7f5ccfedc99f",
      "event_cluster_id": "fd5e9a15-8177-47a6-9a10-ec03f47d5abf"
    },
    {
      "claim_cluster_id": "40621ae5-171b-4ff7-a8cc-0957a4cc93da",
      "event_cluster_id": "baaee7cd-473c-4323-bdcb-32b41e2930f2"
    },
    {
      "claim_cluster_id": "9bab62f9-a196-4e9b-9809-8d8f41f0576f",
      "event_cluster_id": "f74167b8-6b2e-4397-aea5-ad26ae737cc7"
    },
    {
      "claim_cluster_id": "489e26fc-76fe-4cad-b09b-b941f099b2bd",
      "event_cluster_id": "bf6df861-08b0-407b-91a8-c65beb04c1ff"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "a44bb3c4-918e-4230-8542-c0aebafed121",
      "event_cluster_id": "afa23bc4-1fbb-45ef-b64c-09dde901c8b3"
    },
    {
      "claim_cluster_id": "b398f217-24d9-4c22-8d5a-732320853c1b",
      "event_cluster_id": "2e94c160-31a6-438f-bf81-0a00ecfb6a2d"
    },
    {
      "claim_cluster_id": "c7e21d17-7b1c-44ba-9b2b-db5a38de4e97",
      "event_cluster_id": "9854342f-dc2f-4d81-9468-1aeed5b01c1c"
    },
    {
      "claim_cluster_id": "4b37762b-26f0-4956-9d1d-e433973602e1",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "457d88a0-1b8d-406f-8eeb-01fdd00cdc30",
      "event_cluster_id": "202dbce4-7e5d-444f-8048-9175eb593dea"
    },
    {
      "claim_cluster_id": "ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6",
      "event_cluster_id": "83c9bf38-7be3-4a58-9128-bac3dda66b3d"
    },
    {
      "claim_cluster_id": "af503db6-fcf4-45f9-9501-f2732e2af4f7",
      "event_cluster_id": "c42e5196-2b49-45c0-931e-85ce5682f952"
    },
    {
      "claim_cluster_id": "0ee142b2-6805-43f4-b8d5-34f76c2c799e",
      "event_cluster_id": "bad03c04-e50b-426c-824a-ff2c1f2c20d8"
    },
    {
      "claim_cluster_id": "83176725-df79-43f8-b571-b45c6b2dea8f",
      "event_cluster_id": "cf5c8ab9-6f4a-4ef6-84b1-7fb025d62c2c"
    },
    {
      "claim_cluster_id": "cbbb2109-39b9-4308-a4ce-30a48563cab7",
      "event_cluster_id": "680ddc35-25cd-424c-8914-0f7a5b222416"
    },
    {
      "claim_cluster_id": "b53db505-a920-4607-b45b-0f9423ee6d04",
      "event_cluster_id": "83cb9288-d8bc-4d51-803b-71e04c61fa41"
    },
    {
      "claim_cluster_id": "7e29e69f-6e9a-409e-8641-59692b521453",
      "event_cluster_id": "c9514ac7-3548-4b00-95a5-e99c305bf95a"
    },
    {
      "claim_cluster_id": "9dbb0955-d2fa-4dce-a46f-5ed43c9e3231",
      "event_cluster_id": "bf9781df-d8bf-4191-9d37-d31cf97d37ae"
    },
    {
      "claim_cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "event_cluster_id": "7138b959-d146-418c-bd39-6ecd7cfec079"
    },
    {
      "claim_cluster_id": "234be4d1-d0d0-4b65-aa97-a8cd91a0a32e",
      "event_cluster_id": "1e3f8e4e-4dfb-43fa-ad30-aa52542d5f06"
    },
    {
      "claim_cluster_id": "73e672aa-47a1-430b-843b-82f236a93650",
      "event_cluster_id": "b4051cdc-a4f2-410e-b138-2b773f319a22"
    },
    {
      "claim_cluster_id": "bee4d72b-b159-4b6c-830c-362b42a2b18d",
      "event_cluster_id": "10a6dfe0-81d0-453e-9f23-e9792fa39675"
    },
    {
      "claim_cluster_id": "aa95c9e4-8d02-4bc6-90e1-de547f4e4e60",
      "event_cluster_id": "418a7cf7-657b-41b9-9359-c34faf7618d7"
    },
    {
      "claim_cluster_id": "02e7a900-bce3-4812-8137-1246791846bb",
      "event_cluster_id": "9851f4a3-d2c8-418c-ab69-0b58a9726253"
    },
    {
      "claim_cluster_id": "1574223b-5ec0-4588-8996-6510aa3052d6",
      "event_cluster_id": "dafa634a-37de-4d53-8bbc-fae67a8455d0"
    },
    {
      "claim_cluster_id": "fe25e7ff-abc9-4e8c-bafa-dc9163738c4e",
      "event_cluster_id": "876a2333-137a-4c81-9d16-99847f2af4cc"
    },
    {
      "claim_cluster_id": "5f2c5e5a-f6ae-4d50-91e8-eee0bd665636",
      "event_cluster_id": "d878f267-808b-4a23-9202-10d08ee3053d"
    },
    {
      "claim_cluster_id": "127c457b-8cad-4a81-8d25-66dd51786fe0",
      "event_cluster_id": "2e675266-c3ed-4fac-a036-217c24ac28e2"
    },
    {
      "claim_cluster_id": "30d2edfa-6d58-40ae-bac6-ec1273c415ac",
      "event_cluster_id": "c5023c65-de59-493d-807d-e173da07457d"
    },
    {
      "claim_cluster_id": "beb979e4-f486-4e3c-ba15-47b099971ff0",
      "event_cluster_id": "65c273a5-7b4a-439b-abf8-ac2e7eea9f97"
    },
    {
      "claim_cluster_id": "daf13a88-450f-40a7-bca6-ccfb46ede159",
      "event_cluster_id": "117ab6df-7ea4-4ab9-806f-9ec47da0be63"
    },
    {
      "claim_cluster_id": "f4cd4d9b-6b2b-454a-ae24-3a0150790009",
      "event_cluster_id": "171d785c-3288-4a8a-90f1-9e6a8e012955"
    },
    {
      "claim_cluster_id": "b12e5d28-73fe-498d-a612-a3df5aa876b3",
      "event_cluster_id": "6351b28b-a685-4d75-9a62-c954df9226b0"
    },
    {
      "claim_cluster_id": "da70552d-1a69-4dd8-bc9d-ca358f3caefe",
      "event_cluster_id": "454d2297-ce2d-4682-8c48-dff1e1ee7f18"
    },
    {
      "claim_cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "event_cluster_id": "f96ee044-12e8-41d9-ad21-d1cd5c1012f8"
    },
    {
      "claim_cluster_id": "30d2edfa-6d58-40ae-bac6-ec1273c415ac",
      "event_cluster_id": "5456cf3b-8248-49e5-a577-e64c3c57ab9a"
    },
    {
      "claim_cluster_id": "ae1e52fc-461a-4609-8b02-2589611c162e",
      "event_cluster_id": "305d4d39-012b-4cce-bd6f-017ddf94a842"
    },
    {
      "claim_cluster_id": "d3913637-42d6-426c-8654-a13850b8306c",
      "event_cluster_id": "13d62766-9dfb-443f-a0be-897b64b65358"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "c35d9889-06cc-4a13-8fea-d00c7024488b",
      "event_cluster_id": "15ffd9d6-a9f6-4b7b-9697-caf2e3239c3c"
    },
    {
      "claim_cluster_id": "4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9",
      "event_cluster_id": "a6f0d89a-0c3c-4be5-83c6-b064b8a9c73a"
    },
    {
      "claim_cluster_id": "d2f81fce-8c92-45e8-8294-41af7752f1db",
      "event_cluster_id": "450543ae-8630-4e48-a375-9699e4cb6925"
    },
    {
      "claim_cluster_id": "87b92fb4-b0e3-4b01-9c2e-cfd9469245f7",
      "event_cluster_id": "c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"
    },
    {
      "claim_cluster_id": "997de204-d7ea-4e15-b208-ebc2bd4ddd62",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "fcbed875-f592-4e43-93ba-c1c4ead8d38a",
      "event_cluster_id": "87def324-7a40-461a-a80b-cc6aa7391757"
    },
    {
      "claim_cluster_id": "2247b006-05c5-406e-a6b2-d87e6eb59702",
      "event_cluster_id": "ee8407f3-3b78-41fa-b305-9976663fec3b"
    },
    {
      "claim_cluster_id": "5a77fa7e-06f0-487a-a93b-f15e590aa54a",
      "event_cluster_id": "4f84ccb5-4935-4023-8826-9c08d0da261a"
    },
    {
      "claim_cluster_id": "ff42e3e5-bb75-45af-be07-89d36dae0d5c",
      "event_cluster_id": "4d4e63b8-def5-48d6-a4f3-534d39e0e25e"
    },
    {
      "claim_cluster_id": "bfd9a248-bf68-4994-8af5-882efd424687",
      "event_cluster_id": "db5c7092-c228-4319-b130-e75471c29ec0"
    },
    {
      "claim_cluster_id": "d3037252-9ff2-4032-ae65-41b104560fbd",
      "event_cluster_id": "f4f2acc7-50ed-478a-a3c8-fd8ce6afe67c"
    },
    {
      "claim_cluster_id": "e28e105a-739c-4f5f-8b79-8f56f435e121",
      "event_cluster_id": "af8cdf46-4050-4634-a0b0-6bc6cfa78956"
    },
    {
      "claim_cluster_id": "96cc3b99-284a-4ca8-957e-5bfc2a13a654",
      "event_cluster_id": "8aaf61a8-4245-40d4-9036-3767a2a55c98"
    },
    {
      "claim_cluster_id": "9971c68f-8d21-4436-a5d3-4897996181e7",
      "event_cluster_id": "c700d9cd-e09d-4ea7-a33c-b8925d591d85"
    },
    {
      "claim_cluster_id": "255ea174-3e00-4506-8a6d-78f62eccfecc",
      "event_cluster_id": "80b2ece5-7d1f-4503-86fb-dde80c97bee5"
    },
    {
      "claim_cluster_id": "658de6ad-fa34-4d62-b1a8-d4dba2ffb3d8",
      "event_cluster_id": "3eb68d57-7c14-4dd1-91dd-ff18ff1740e4"
    },
    {
      "claim_cluster_id": "23bbf046-846b-4885-b881-e84d2ca9060e",
      "event_cluster_id": "88ef71b9-0470-4f94-b8a3-c2845e2f29e8"
    },
    {
      "claim_cluster_id": "3d44d914-cf73-4d8b-b531-5db2be83da48",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "11c93b57-586c-4cef-a254-66245b297aca",
      "event_cluster_id": "72702a81-27ae-49f8-9ece-b45b8795d927"
    },
    {
      "claim_cluster_id": "f55fbefe-4ee7-4bc9-a05f-0bee3b933ccd",
      "event_cluster_id": "6dc5280e-6875-44c0-adc9-079542d2d0b2"
    },
    {
      "claim_cluster_id": "12f1ab8f-20c6-41db-928a-d52afb8bd227",
      "event_cluster_id": "71f8bf24-6193-4f81-97b9-208284481b4e"
    },
    {
      "claim_cluster_id": "ddbc1aa3-6d67-4148-96a1-e149d5d02260",
      "event_cluster_id": "aba53f75-eaf6-4231-90b0-0d2dbfd627ce"
    },
    {
      "claim_cluster_id": "74381468-96fe-4ea3-b795-41362208378c",
      "event_cluster_id": "65022a70-336c-4701-8443-508f49365fb4"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "28df4744-3bf2-4a43-80dc-d2bea8f7af7a"
    },
    {
      "claim_cluster_id": "3d9f2bb4-f1d6-41ac-be1a-ac1194130144",
      "event_cluster_id": "17d2f659-e46b-4a1d-9fcb-605a5ebf0a54"
    },
    {
      "claim_cluster_id": "64de7b14-ea9c-48fe-a9a0-a30f01aecc3e",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "09a92b68-8f29-435d-b853-f4c47f64d9da",
      "event_cluster_id": "d2fe7e4c-e188-41bf-8d04-054692838ea8"
    },
    {
      "claim_cluster_id": "89360ae3-18fa-43f0-bd2a-417e02e051c5",
      "event_cluster_id": "cac0be30-203f-425a-ae61-9f6f21636075"
    },
    {
      "claim_cluster_id": "9ffb85b8-5080-4f27-85ad-554406cf7402",
      "event_cluster_id": "2bfeada4-b9e0-40b4-9be2-0655b8d49226"
    },
    {
      "claim_cluster_id": "7781df4b-26ca-4879-a33c-cb83ade5ffa4",
      "event_cluster_id": "30eca979-1f98-4971-a1fe-07481584311b"
    },
    {
      "claim_cluster_id": "d3ef62d6-a9f2-4e02-8cb8-beabc3ead80a",
      "event_cluster_id": "39c57d47-c79f-4298-b9b0-1dca0020b6aa"
    },
    {
      "claim_cluster_id": "837dbefb-7b54-4aa1-aad3-56f0ea97f9ed",
      "event_cluster_id": "8e7cadbd-1c4e-497d-b941-1d05a2c467a3"
    },
    {
      "claim_cluster_id": "e129ef72-bb79-4915-92ec-e1ad0c220280",
      "event_cluster_id": "9a62af93-7112-41ed-b195-640caabb9cb6"
    },
    {
      "claim_cluster_id": "fefd3acb-14d6-4c0d-ac4a-19da8e48bc75",
      "event_cluster_id": "a1ca414a-357f-429e-a9a5-5290a87bd233"
    },
    {
      "claim_cluster_id": "9960f165-6141-4ca0-8dc4-0a136bfde83d",
      "event_cluster_id": "37386c6e-8d47-43fa-9d2e-223bce8f6923"
    },
    {
      "claim_cluster_id": "5cd897af-cb8c-4335-a548-c9963c43f060",
      "event_cluster_id": "16bacf34-8f6f-4fd6-ad3c-f7fed8660b38"
    },
    {
      "claim_cluster_id": "69638d1f-f33d-45d8-beac-6ee7ce61ea29",
      "event_cluster_id": "550b12e3-691c-45b5-8cb2-986a272d3a0f"
    },
    {
      "claim_cluster_id": "b6dd34fe-58a4-4775-be96-ca839f926747",
      "event_cluster_id": "48edb9b3-6de4-47d0-956e-e07e3a6cbfda"
    },
    {
      "claim_cluster_id": "5b935620-b425-4241-8333-a51c2e077394",
      "event_cluster_id": "80e1112c-9669-4621-a0a1-38f35b5f11c3"
    },
    {
      "claim_cluster_id": "69315435-638a-4ef2-abe8-1d91d23ff51a",
      "event_cluster_id": "1d0959a8-981b-4a23-90dc-2a9d7c7c079f"
    },
    {
      "claim_cluster_id": "eb68c709-6220-48fe-b376-95a4f6f10b6d",
      "event_cluster_id": "77ada2fd-a5b1-4d46-9fd3-0fa7022914dd"
    },
    {
      "claim_cluster_id": "fce90f87-0664-4b8a-bb4f-dc7bbf08cf50",
      "event_cluster_id": "128219b8-57d3-4f9e-bdf1-0447f6eb1ba5"
    },
    {
      "claim_cluster_id": "908a4168-b322-4057-a44b-a100dbffbe53",
      "event_cluster_id": "7cf0c1a9-abc0-4370-b846-45ce5ff4c375"
    },
    {
      "claim_cluster_id": "8d06f8b9-e6ed-4b99-89ef-90434792b924",
      "event_cluster_id": "ddcbcb82-918f-4d21-a3ab-fc58bc049dc2"
    },
    {
      "claim_cluster_id": "470bd6d3-39cf-4a39-9a1c-be6c638cdd0d",
      "event_cluster_id": "9fb5a955-823a-4864-b411-b2e83454581e"
    },
    {
      "claim_cluster_id": "13ce1de8-c90f-43f4-ae08-251f1aed012e",
      "event_cluster_id": "782b5668-5ef8-4d83-a8fc-b6464fbee289"
    },
    {
      "claim_cluster_id": "0c265597-6c2b-4efe-9acb-799f67a3b4d1",
      "event_cluster_id": "1501c95d-fe6f-4129-965a-ccb56abb7afe"
    },
    {
      "claim_cluster_id": "c9b6b0e3-811d-4e56-9eba-3408eb1dc06f",
      "event_cluster_id": "080cf60d-e4c8-43d3-806b-a47256c29458"
    },
    {
      "claim_cluster_id": "d89e632e-b2af-4331-9344-c7d1e373d49b",
      "event_cluster_id": "4e1dd449-7872-4183-a210-7ea0e51bbd11"
    },
    {
      "claim_cluster_id": "aaf76232-aab7-40b7-8e1a-16d6b39c4f6b",
      "event_cluster_id": "8b28dee8-f25f-4ea3-a58f-094086b4ac36"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "82015ed8-be97-4f9a-940c-6061a2380bc1"
    },
    {
      "claim_cluster_id": "2dc250b5-58d8-4c44-80d2-2c17640ea117",
      "event_cluster_id": "3f3f44f3-8e86-41c0-a601-c57bd1d46cd6"
    },
    {
      "claim_cluster_id": "93459608-ccd3-4b8a-af7b-ede8b22e8c94",
      "event_cluster_id": "6907e408-863f-4c1c-90bf-e1763a1c2ab8"
    },
    {
      "claim_cluster_id": "4a277b87-4d75-4b75-9416-adcbd06c3a69",
      "event_cluster_id": "4097f204-b4ae-4826-85fe-e2f03051cdcf"
    },
    {
      "claim_cluster_id": "01c08614-0081-4fbf-86e8-a41b845bc4f5",
      "event_cluster_id": "336f0b3b-fcc5-4691-826e-c234e38bf923"
    },
    {
      "claim_cluster_id": "1713cb4d-ab0f-4257-a2cb-4aec01e411ef",
      "event_cluster_id": "c770384d-399a-4efc-a9de-06d7ca1ea0d3"
    },
    {
      "claim_cluster_id": "f5798794-c4ea-4a9f-ad2e-0bf496c0ed12",
      "event_cluster_id": "c52411eb-2b24-4b6d-9936-f82ca57ebb56"
    },
    {
      "claim_cluster_id": "0c265597-6c2b-4efe-9acb-799f67a3b4d1",
      "event_cluster_id": "961d386d-4d5b-4009-a39c-fb6d1a441cf5"
    },
    {
      "claim_cluster_id": "b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10",
      "event_cluster_id": "47f7a131-6ce1-4e01-b64c-61e5f9696bb1"
    },
    {
      "claim_cluster_id": "243cbf96-dba8-41a3-9dc7-8def431d23c9",
      "event_cluster_id": "d82f7ea1-b85f-4ff3-af04-e3f09ca89458"
    },
    {
      "claim_cluster_id": "d2830923-6260-4e70-9fc4-f723af340d1f",
      "event_cluster_id": "0b355c81-92f1-4102-a729-a2af4b606bfe"
    },
    {
      "claim_cluster_id": "b5432b8d-5ac9-4f60-8977-fdbcdae395a3",
      "event_cluster_id": "0b6b6a97-32f4-45c7-ada1-27e50504dcb5"
    },
    {
      "claim_cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "event_cluster_id": "dafa634a-37de-4d53-8bbc-fae67a8455d0"
    },
    {
      "claim_cluster_id": "162f021a-53e9-4f3d-9231-108223f18e9b",
      "event_cluster_id": "81cdaaf8-571d-4a77-8063-fa5e9510b635"
    },
    {
      "claim_cluster_id": "cfad4c19-24e9-4d54-8d59-d0b08718729b",
      "event_cluster_id": "7ea6c0c9-c370-4e5d-93ff-344450b01dd4"
    },
    {
      "claim_cluster_id": "29fe240a-81f6-4aef-a8b5-3cacf3e3985a",
      "event_cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14"
    },
    {
      "claim_cluster_id": "bc56200e-afec-40d7-a87d-167e90733913",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "04c040d8-393f-4b27-af55-1f60d7802605",
      "event_cluster_id": "22c6704f-881c-4e99-abe5-258852387852"
    },
    {
      "claim_cluster_id": "b26a4469-2931-4dab-aa78-be1b6fba8a36",
      "event_cluster_id": "e3e5aa95-d1ae-4cc4-a1f6-993b699c2d34"
    },
    {
      "claim_cluster_id": "94f243ab-1521-4874-b5fc-b80847a7fefc",
      "event_cluster_id": "e4be2259-ba51-439d-9935-9584c06ee048"
    },
    {
      "claim_cluster_id": "902f069d-3703-489a-9dfa-fb26ee837027",
      "event_cluster_id": "214ffe56-f58d-4fdd-a3cd-ef399506aa9a"
    },
    {
      "claim_cluster_id": "ba6f293a-cb12-4697-ba51-b7964934f25d",
      "event_cluster_id": "4c79fc69-3bd0-4180-9718-8d85b8c9dd85"
    },
    {
      "claim_cluster_id": "928cf7ca-8343-47ca-be27-378bc29b7fbe",
      "event_cluster_id": "45429530-4dcd-414e-8a37-8555d0144899"
    },
    {
      "claim_cluster_id": "325111bb-e15c-4f08-a4a4-3f81e99d9f35",
      "event_cluster_id": "8d547757-303e-43b6-9192-6b5dc2fd34da"
    },
    {
      "claim_cluster_id": "fdec6a13-5351-4fa5-9920-1456738e3b76",
      "event_cluster_id": "471ac06a-ad1e-40a8-b238-859f31d2504b"
    },
    {
      "claim_cluster_id": "9bdb548d-7392-42e2-81f0-dc3db0c2af7a",
      "event_cluster_id": "c9427285-3555-4de5-97c9-22592d01516f"
    },
    {
      "claim_cluster_id": "5e767ae7-5475-4d58-9919-b74b88492c8d",
      "event_cluster_id": "f3090987-9e96-4cf1-95d6-22fba3e8d946"
    },
    {
      "claim_cluster_id": "834f4385-ef2b-4b12-81b1-8e94ff3098e8",
      "event_cluster_id": "cca26850-c71b-4446-90d7-2e4d88b1223b"
    },
    {
      "claim_cluster_id": "e129ef72-bb79-4915-92ec-e1ad0c220280",
      "event_cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"
    },
    {
      "claim_cluster_id": "f0bf7f4c-0a27-4681-9eca-ea221b9315a7",
      "event_cluster_id": "2b56b1f6-1627-44ab-9460-b13751cf087b"
    },
    {
      "claim_cluster_id": "2616e42a-b0ac-42ff-93a5-2376cee42b92",
      "event_cluster_id": "f6f61810-826e-4932-a627-c61739848c9f"
    },
    {
      "claim_cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "event_cluster_id": "208620ac-11d0-4163-9345-03d59e805961"
    },
    {
      "claim_cluster_id": "4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8",
      "event_cluster_id": "ad9b8529-0422-40dc-8b6b-9a712020027f"
    },
    {
      "claim_cluster_id": "c8956774-b873-4e48-aca4-1d4ce1428a6f",
      "event_cluster_id": "65d8f691-42a2-4903-8a08-db7d149c26b1"
    },
    {
      "claim_cluster_id": "d30cdd9d-92e1-44ac-aad9-845702e1559f",
      "event_cluster_id": "902b6a60-6994-4d2f-a5c9-4b6398d8e8c1"
    },
    {
      "claim_cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "event_cluster_id": "c124b047-b324-4618-8299-a88ecac6f400"
    },
    {
      "claim_cluster_id": "468c9eea-e420-4271-9b73-0e2e747f6185",
      "event_cluster_id": "273cff70-66df-48dd-9efa-69156787ee64"
    },
    {
      "claim_cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "event_cluster_id": "876fd136-352b-46eb-aeb5-3fca6402213f"
    },
    {
      "claim_cluster_id": "e045b8f3-c755-4ad1-91b0-a0b8f7878680",
      "event_cluster_id": "0a1dc802-b4ef-42f0-aba6-299883ef023b"
    },
    {
      "claim_cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "event_cluster_id": "7633550e-7afa-4184-8ac2-7603de1beef0"
    },
    {
      "claim_cluster_id": "b11a9565-86ce-4b37-aea3-07e84e21fa4a",
      "event_cluster_id": "d6ce2176-c8b1-49b2-89e4-f0620f06cb63"
    },
    {
      "claim_cluster_id": "11f5ada1-39d8-46a5-b3e1-ae12a04328c2",
      "event_cluster_id": "84f2b012-a880-401d-86eb-78a247c92358"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "1dffb0dc-1f11-4a52-8601-13d552598542"
    },
    {
      "claim_cluster_id": "12dfa7c9-8817-4f21-ad00-1e4244142b34",
      "event_cluster_id": "ec52d818-47ba-4361-9b9e-62d7a7a87109"
    },
    {
      "claim_cluster_id": "d08db747-1994-456e-82f1-cca372892842",
      "event_cluster_id": "3ca85742-8366-4a09-815d-244dcb1111f9"
    },
    {
      "claim_cluster_id": "1e9d6c21-797f-4483-9122-2e9582f833c2",
      "event_cluster_id": "1737c28c-8f31-4855-8951-9dd1dd0b8606"
    },
    {
      "claim_cluster_id": "76e8427a-4f65-4a81-bf8d-354e00b7198e",
      "event_cluster_id": "b83cbf56-9c77-41ae-bf34-905116236046"
    },
    {
      "claim_cluster_id": "f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f",
      "event_cluster_id": "6f2fde83-d0f8-429a-88dd-e73036fda6d0"
    },
    {
      "claim_cluster_id": "449f7a4c-3966-4db6-9cf4-d39a2f15feae",
      "event_cluster_id": "5d61ec99-0639-4eaa-b6c6-d29d8645a85f"
    },
    {
      "claim_cluster_id": "cd2c9191-f97a-49fd-9d7d-f0744cdaaf72",
      "event_cluster_id": "2d30ef5f-ee97-4df3-a64c-5e181a81321a"
    },
    {
      "claim_cluster_id": "daf13a88-450f-40a7-bca6-ccfb46ede159",
      "event_cluster_id": "52a6626f-4f02-4c13-bf77-4f58640d6881"
    },
    {
      "claim_cluster_id": "a3cc8d63-1533-4239-bc6b-bedcff828ef9",
      "event_cluster_id": "690e2bf8-3db0-482f-a93c-22f6a0d56631"
    },
    {
      "claim_cluster_id": "5317331a-d0a9-4595-acad-210a92b278d8",
      "event_cluster_id": "43fa0350-2309-4b93-bd2a-6e8c4a716e73"
    },
    {
      "claim_cluster_id": "0ecc8673-156d-41da-a0bd-8ceb3bd503b8",
      "event_cluster_id": "d5e18b03-3515-471f-a4d6-448fbfbfb257"
    },
    {
      "claim_cluster_id": "17b4175b-7c9e-4cac-8f06-6d2c5a65e803",
      "event_cluster_id": "5ccfc9e2-21fe-49eb-816b-e5684332d360"
    },
    {
      "claim_cluster_id": "5a50a1fe-c68d-46bc-b14a-9fe07afb2e36",
      "event_cluster_id": "c442364e-9f75-4af3-92da-fc9202b13019"
    },
    {
      "claim_cluster_id": "18699af2-76ba-4b44-8dd8-cbb2b538e559",
      "event_cluster_id": "605679a7-417f-419b-b13a-f72296af0a8c"
    },
    {
      "claim_cluster_id": "75739be5-4b25-48e8-8d9d-d6319de6bd95",
      "event_cluster_id": "3b24d20e-ac52-4f56-955a-33bcfd5102a2"
    },
    {
      "claim_cluster_id": "7e265407-1dda-4e06-a69c-824b7e191f01",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "954a4240-7358-4649-966c-6f08bf5b088e",
      "event_cluster_id": "8e28231d-7117-46be-8655-ac03e3ec9b13"
    },
    {
      "claim_cluster_id": "a01e0915-a285-410d-9d1b-ce9544139c90",
      "event_cluster_id": "58af047e-cbeb-4069-98f9-896633d3674d"
    },
    {
      "claim_cluster_id": "a0016e91-a98c-4dd9-8feb-b0afadf02f44",
      "event_cluster_id": "c006df76-d7ed-4672-b415-893f6c8476b6"
    },
    {
      "claim_cluster_id": "80a02b1a-c045-453f-ad92-9681e40dad83",
      "event_cluster_id": "6ad5a7cb-930f-4fcb-91a9-e3eccb8d8cb0"
    },
    {
      "claim_cluster_id": "227d3de7-5437-4b66-857c-d51afef721c1",
      "event_cluster_id": "71aef7b0-37f2-43a6-87de-3439a440ada6"
    },
    {
      "claim_cluster_id": "a1d5bcf5-80de-4ba5-b40d-443ea3d3eb11",
      "event_cluster_id": "d23ce59c-1b68-42d1-aa3b-b8143bbd9381"
    },
    {
      "claim_cluster_id": "151738b2-0d24-44aa-896c-fa16a74db380",
      "event_cluster_id": "5949d818-e369-4db8-949d-7a462c260498"
    },
    {
      "claim_cluster_id": "aa09782e-9c11-4715-848f-eac275117bbe",
      "event_cluster_id": "f09e8cd4-4e03-420e-a650-dd40af68dcd7"
    },
    {
      "claim_cluster_id": "23106ade-18c8-44c0-8d3a-ef2f743468af",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "f74a80e3-1327-4636-a252-f4ca8a5b90f7",
      "event_cluster_id": "2f22684c-1c98-4774-aade-6114067fd60b"
    },
    {
      "claim_cluster_id": "aef50142-8ad0-4099-9362-3d45c56385fc",
      "event_cluster_id": "1b9aa65f-dcda-40ea-bbc1-8c1521f177ad"
    },
    {
      "claim_cluster_id": "75e57a3a-a55d-4c36-b291-226154171396",
      "event_cluster_id": "984fa7e0-f763-4f19-b49c-d87ea5159954"
    },
    {
      "claim_cluster_id": "b659052c-10e5-47d2-985e-c2c7d42a67a2",
      "event_cluster_id": "c3301dce-0e38-4465-b94b-ee10e64f783a"
    },
    {
      "claim_cluster_id": "d6760008-6cbf-4c8c-b88a-b478081312d0",
      "event_cluster_id": "6e13551c-ec8b-48ad-a58c-87108dea4e39"
    },
    {
      "claim_cluster_id": "6075c9de-cd99-4e5f-9302-f1b6177720a7",
      "event_cluster_id": "5c72c86b-5dfd-4f55-ab98-8ad01ed266f5"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "cef32527-0357-47cf-9fee-19bd0f13e11a",
      "event_cluster_id": "a5d764cc-6bfa-4c0a-bd16-68401768ed12"
    },
    {
      "claim_cluster_id": "91e6a8b3-0e47-4ed1-b99e-a946e23e0c33",
      "event_cluster_id": "fc55d0f5-c78b-4a1f-a7f3-73448361d186"
    },
    {
      "claim_cluster_id": "4f2be876-d890-4fd4-a767-3f52bbc9c4c4",
      "event_cluster_id": "e2835c22-b372-4e91-9b8e-5ef637ee8966"
    },
    {
      "claim_cluster_id": "2da1e2c0-6b7f-4a59-bbad-c83252a70f91",
      "event_cluster_id": "9854342f-dc2f-4d81-9468-1aeed5b01c1c"
    },
    {
      "claim_cluster_id": "f9f7a124-b259-44e6-a922-abc880fe6775",
      "event_cluster_id": "a793f62f-9462-444a-a9da-d3e2c115a5b1"
    },
    {
      "claim_cluster_id": "774b6df5-ef29-47f3-9ae9-d88dbd184e38",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
      "event_cluster_id": "546b42d0-5005-442c-a548-5a747146aa92"
    },
    {
      "claim_cluster_id": "2bd9ff92-4ea3-492e-a249-5de7759a5956",
      "event_cluster_id": "d7ce0029-7c2c-40fb-8d24-32029ffa4b81"
    },
    {
      "claim_cluster_id": "d089a914-1c7d-48b8-9c48-7a1b65f152b1",
      "event_cluster_id": "b1c61f13-8002-4105-a62d-ec7191746e29"
    },
    {
      "claim_cluster_id": "e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37",
      "event_cluster_id": "6b0c0beb-865e-4025-a8f9-7338b3bfba70"
    },
    {
      "claim_cluster_id": "04e0078c-1ff9-4d1a-8adb-a137164fd78a",
      "event_cluster_id": "26405a6f-ce14-487e-8e9d-f5b3ee953860"
    },
    {
      "claim_cluster_id": "f3d66a5d-cd26-4b6d-a341-2fdc2524c28a",
      "event_cluster_id": "870cf570-e7db-4612-8845-9e41f8062b78"
    },
    {
      "claim_cluster_id": "3769f810-e5f7-4d0a-9821-1876b6cadf34",
      "event_cluster_id": "9eca8644-57d0-4b18-b62b-b394d615bf38"
    },
    {
      "claim_cluster_id": "25934933-94e9-444f-a664-f57c4cea7d17",
      "event_cluster_id": "c35c9880-b71e-4b4b-b29a-43c7d18291ae"
    },
    {
      "claim_cluster_id": "cd21b07f-3941-439e-8ffa-59c6da9df98f",
      "event_cluster_id": "32156667-7185-4800-9042-38e82870feff"
    },
    {
      "claim_cluster_id": "4bc5d44b-029d-49ff-82cb-bbcd84067673",
      "event_cluster_id": "4b9443f4-821d-4fb7-8621-ed3af0ada4a9"
    },
    {
      "claim_cluster_id": "506e309f-6f87-418b-b660-0ad635976c9d",
      "event_cluster_id": "ef2890c7-c6b6-40d0-96fd-72f800a7cb26"
    },
    {
      "claim_cluster_id": "6c812e58-19af-4264-b856-e922307ab466",
      "event_cluster_id": "6e339b28-0894-4d85-a536-569236e90bbf"
    },
    {
      "claim_cluster_id": "fdbce6fb-9c6c-48ff-a187-88c668f79277",
      "event_cluster_id": "895f4da6-0e6e-4170-be66-262513dfdc91"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "35d10df6-7929-4a0c-9fc1-b26cc3d884f2"
    },
    {
      "claim_cluster_id": "f8d50aad-e630-4fcd-a643-313737fc528f",
      "event_cluster_id": "54cb3ed2-7dba-402d-a696-00ebabb32bc1"
    },
    {
      "claim_cluster_id": "47a61e0a-9230-4c4c-962b-f6724c066435",
      "event_cluster_id": "54f8b2dc-d3d6-42f7-bde0-a8a0038707a5"
    },
    {
      "claim_cluster_id": "de1f8a69-eaff-4387-87ee-35fc20ea4a2f",
      "event_cluster_id": "f8ba093e-142e-45ae-b5d0-aef007993c05"
    },
    {
      "claim_cluster_id": "bd4c7f11-9866-4656-98e3-7341cfc6de34",
      "event_cluster_id": "c056dbf1-3293-411e-a56b-f5d55e75ae9c"
    },
    {
      "claim_cluster_id": "924c4170-d405-438e-937c-13478012b72c",
      "event_cluster_id": "d2d5d22c-9f8f-472b-b123-61d32af5f64f"
    },
    {
      "claim_cluster_id": "7051d37c-4575-4653-97a5-3052e1c2b344",
      "event_cluster_id": "8e1bc392-1f79-4373-ac66-b625742b75e3"
    },
    {
      "claim_cluster_id": "a4182192-73bb-4165-ad72-05ff39be899d",
      "event_cluster_id": "27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"
    },
    {
      "claim_cluster_id": "49a8c8f2-03df-436a-8634-670fd40a145c",
      "event_cluster_id": "cb3aa2af-d703-4ae9-b53d-f7c0ae589678"
    },
    {
      "claim_cluster_id": "02dd8817-131f-4c62-a0d0-fa32952b2e01",
      "event_cluster_id": "f4a62cbd-7d48-489c-b0ae-5a2ba587faca"
    },
    {
      "claim_cluster_id": "20030c5c-45db-460b-8663-d9950dc53ebf",
      "event_cluster_id": "a3a7d7be-57b8-4862-a94f-547066bc6b8d"
    },
    {
      "claim_cluster_id": "c8416335-0a4e-4b5d-aa9e-40e533302d3c",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "8f4c47af-fb0d-428c-b422-7767f77bc38d",
      "event_cluster_id": "efde2814-71d1-4a0e-959d-1e37c60dd501"
    },
    {
      "claim_cluster_id": "61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc",
      "event_cluster_id": "fcae1625-9dc6-40ce-b828-c6881213b7e1"
    },
    {
      "claim_cluster_id": "8cc2fa20-28d1-44d8-bdd2-f42d8dc30f18",
      "event_cluster_id": "1be249dd-37fb-4d60-8a83-484cbb6bc5e1"
    },
    {
      "claim_cluster_id": "41369b57-1c08-440a-90c0-cacb7036a45e",
      "event_cluster_id": "a4a343c3-6168-45dd-bb83-595e1841921d"
    },
    {
      "claim_cluster_id": "90ef35f7-8880-490a-bacc-f600f6a11162",
      "event_cluster_id": "b4243b24-8de4-40d1-8e27-1dec1612406d"
    },
    {
      "claim_cluster_id": "6f8b0a89-8965-4d5d-9b89-f48b23ed61a1",
      "event_cluster_id": "81bcd47f-070e-4939-b97e-e26a5423d8a9"
    },
    {
      "claim_cluster_id": "b874b38b-169d-4b90-b373-ae919f14c5a0",
      "event_cluster_id": "ce807753-2437-4a69-9e26-d1ab69fdd2c7"
    },
    {
      "claim_cluster_id": "60b95622-d70d-459f-9ef4-53d53c239154",
      "event_cluster_id": "d94203eb-6224-4f4f-ab68-6b9b570a960b"
    },
    {
      "claim_cluster_id": "e2c6a7c7-ff69-4a0f-a631-41e7e5bd25a0",
      "event_cluster_id": "afcb3ce0-1612-4cdd-a65f-fb2d5a6bf76a"
    },
    {
      "claim_cluster_id": "bcc578f8-a745-46e1-ac64-5315a3ec6900",
      "event_cluster_id": "19c9dde1-93ad-454a-9809-5f87d3869615"
    },
    {
      "claim_cluster_id": "b53db505-a920-4607-b45b-0f9423ee6d04",
      "event_cluster_id": "28ea99a2-454e-42c3-b308-cf4739fc9a02"
    },
    {
      "claim_cluster_id": "bf76e0b1-c54e-4ab8-82d0-979d68c35a65",
      "event_cluster_id": "4ea8be34-570b-4271-a023-3b36e07e963b"
    },
    {
      "claim_cluster_id": "1e74d1b1-7b73-446d-b88a-11111e499ad8",
      "event_cluster_id": "44c28ee3-0ffe-43a2-9aa6-1d7ed2463da1"
    },
    {
      "claim_cluster_id": "ddd4b5a0-2eee-4ff9-bb50-de940c2541e2",
      "event_cluster_id": "639aad5f-e883-4460-bc98-aed364fefe21"
    },
    {
      "claim_cluster_id": "11e43ecc-22c8-4f1c-b13a-fb97013ce963",
      "event_cluster_id": "4e04a5f7-5879-4461-9d2b-d653343b9dbe"
    },
    {
      "claim_cluster_id": "64de7b14-ea9c-48fe-a9a0-a30f01aecc3e",
      "event_cluster_id": "d9598814-d7a3-48d1-b282-0aa4d0dfeb8b"
    },
    {
      "claim_cluster_id": "06da14b8-536e-4d2e-83b1-118cfb44829b",
      "event_cluster_id": "f0626ed9-6a16-4fce-b589-96b444b12fc6"
    },
    {
      "claim_cluster_id": "058ec7b4-d77f-44ec-81fa-004e499dce82",
      "event_cluster_id": "2034d9a0-a9ba-4e99-89d7-79e736b91d31"
    },
    {
      "claim_cluster_id": "8f4c47af-fb0d-428c-b422-7767f77bc38d",
      "event_cluster_id": "1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"
    },
    {
      "claim_cluster_id": "61fac83f-0dd7-4c15-88bc-e40fee962783",
      "event_cluster_id": "32516088-d496-4b04-a09c-540561be5921"
    },
    {
      "claim_cluster_id": "5c890164-2642-4556-87d3-c7dbbd1d4d78",
      "event_cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "e45a7fdb-d8fc-4ccb-adfb-88a463256b7d"
    },
    {
      "claim_cluster_id": "0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f",
      "event_cluster_id": "906602f3-b23d-4091-b462-b74d3ce8894a"
    },
    {
      "claim_cluster_id": "821946a1-401a-4657-be17-b3ed51371c13",
      "event_cluster_id": "c193bcc0-0d98-4b99-869b-53885d805dc1"
    },
    {
      "claim_cluster_id": "fdec6a13-5351-4fa5-9920-1456738e3b76",
      "event_cluster_id": "3465d409-db96-4545-a6fb-c388765f1b4a"
    },
    {
      "claim_cluster_id": "018f6f1c-b2e7-43ca-a443-3a5d27b5033c",
      "event_cluster_id": "204d066b-baf9-4cb1-b94b-16fcde9be401"
    },
    {
      "claim_cluster_id": "21c29f8c-34b7-47c4-8021-91ec84cff803",
      "event_cluster_id": "128d37ad-2ce5-409d-8ce0-e9df31085f42"
    },
    {
      "claim_cluster_id": "5e700671-a24a-4c8f-a1e4-abbfb82f4537",
      "event_cluster_id": "ddce8749-8091-45b0-8366-637dbe518fa7"
    },
    {
      "claim_cluster_id": "07e66c00-a616-4a75-b1a2-efe8ff1edd22",
      "event_cluster_id": "b7e93309-96c4-475e-9ccd-507fa2166b0b"
    },
    {
      "claim_cluster_id": "61922f77-a020-4916-b901-44fe7982b789",
      "event_cluster_id": "b2e6976f-e5a2-4669-ac3d-3e87cd376f99"
    },
    {
      "claim_cluster_id": "595531c2-a2b0-4686-b3ae-4f5525fff05a",
      "event_cluster_id": "6494604d-36ac-42cf-98fa-810683a18200"
    },
    {
      "claim_cluster_id": "bd3c25bb-6683-4bdd-8e97-11de485116b2",
      "event_cluster_id": "505c42ee-a234-45a9-8c74-63207154db3f"
    },
    {
      "claim_cluster_id": "4d3a2478-017b-48f2-862a-30c57fa5055d",
      "event_cluster_id": "08a49e97-cae6-472e-9f1e-189f1a189718"
    },
    {
      "claim_cluster_id": "3945d107-ebd6-4f7f-98d8-84183dc2837f",
      "event_cluster_id": "6faef44d-a395-4b46-93b5-ca7cbd7fcfc0"
    },
    {
      "claim_cluster_id": "8b0aef83-1693-4fa2-8559-a133b18a2dbb",
      "event_cluster_id": "b4530fdc-2dbc-4670-850f-b1965eb9d9e1"
    },
    {
      "claim_cluster_id": "8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4",
      "event_cluster_id": "2a43ad41-42b1-4d3e-8501-88166518eba1"
    },
    {
      "claim_cluster_id": "29469bb2-a496-413c-802b-5a8d1b46d374",
      "event_cluster_id": "491bc782-ae1c-45af-9f60-183d9dcb959e"
    },
    {
      "claim_cluster_id": "b3c35953-f954-44b3-89de-73c75db49fd9",
      "event_cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"
    },
    {
      "claim_cluster_id": "ff43bfb6-1ab6-422e-8045-756b71e70dd1",
      "event_cluster_id": "4d99bd96-2995-4ee1-aaa1-1e78c622a4c4"
    },
    {
      "claim_cluster_id": "e1ad3c4e-eefb-42e0-8fe7-edf486c4da19",
      "event_cluster_id": "41e4adfd-a702-492f-a430-46ac304993d5"
    },
    {
      "claim_cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "event_cluster_id": "411cad01-4640-4a11-9464-9f26565f44b6"
    },
    {
      "claim_cluster_id": "72804ca3-611f-4b19-ada2-8bfb14c2e98a",
      "event_cluster_id": "1f4a4adb-de76-451d-aa05-57dc41f8014d"
    },
    {
      "claim_cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
      "event_cluster_id": "34a8290a-940e-4582-8dbf-cb195db85e28"
    },
    {
      "claim_cluster_id": "905fb380-0de3-42c4-abca-6fd6383deba6",
      "event_cluster_id": "832076ec-b055-496e-aae3-ea8daef2ce04"
    },
    {
      "claim_cluster_id": "3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9",
      "event_cluster_id": "14d0a92d-65cb-4881-998f-aed067993e99"
    },
    {
      "claim_cluster_id": "3f85eb0b-4d61-4e44-8414-15ce2c9f03ad",
      "event_cluster_id": "e5db8adb-166d-4129-bd9b-54f680ec3bdb"
    },
    {
      "claim_cluster_id": "120d61e9-d442-4218-b8d0-9559d9880c3a",
      "event_cluster_id": "1d2ec60f-34f2-42e2-a397-916c3e7ad70d"
    },
    {
      "claim_cluster_id": "cebef5fc-6d79-4e08-878b-8c75696aa6d2",
      "event_cluster_id": "b13b5ee0-1421-43e8-a554-5b3888a5cac7"
    },
    {
      "claim_cluster_id": "049db6be-2ccc-4afd-97c6-e95cb1b50286",
      "event_cluster_id": "b9b30a00-8e82-4f2f-9524-8cbb18357bed"
    },
    {
      "claim_cluster_id": "2fa38dbd-c491-4579-bb95-e37ac00e125d",
      "event_cluster_id": "27d4950e-9d1e-4314-b5b5-7fcf43d21e72"
    },
    {
      "claim_cluster_id": "269d367a-5938-4087-911a-3256c10a910f",
      "event_cluster_id": "3a95c736-dd02-4122-9108-f00df86397af"
    },
    {
      "claim_cluster_id": "61fe3afa-76aa-4838-9dd9-a22a879ae31e",
      "event_cluster_id": "8383b651-21df-4fb5-9d89-77f8c5fdde08"
    },
    {
      "claim_cluster_id": "7bcfb80e-f4a6-4404-be69-078e88ddce1f",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "c75ee75a-e51c-413b-b72e-c2160bcb40c1",
      "event_cluster_id": "c1d9eed7-6c9d-4c45-a896-47b8c389cf48"
    },
    {
      "claim_cluster_id": "d6705dc8-8def-4060-882a-9c13b62a23ad",
      "event_cluster_id": "7c7cd464-a285-4810-881b-7a151a564ae1"
    },
    {
      "claim_cluster_id": "ab5ca9cd-1ca3-48b3-9ae1-79a096d75528",
      "event_cluster_id": "5a1b9522-efaf-458a-8a08-7187a721101c"
    },
    {
      "claim_cluster_id": "4692c588-5e24-491c-9044-3d7dd7c0a2d7",
      "event_cluster_id": "317ecec9-87af-4e3c-acd4-372de58135a0"
    },
    {
      "claim_cluster_id": "f72eb4bb-112f-4556-a279-ad745cb4894c",
      "event_cluster_id": "115fb915-b1b2-4ede-81d0-20680b7749d3"
    },
    {
      "claim_cluster_id": "cce124fe-f108-4571-9074-db48a458127d",
      "event_cluster_id": "272822f1-86c1-4fb0-9f4d-41ee4b639a78"
    },
    {
      "claim_cluster_id": "6e63c4ba-f9ee-49c7-a87f-b38ea11837c4",
      "event_cluster_id": "9dd9bb3f-346d-4bab-978a-64ea761a815a"
    },
    {
      "claim_cluster_id": "1d1fb1a1-0351-478a-ac00-eb42c21a03d9",
      "event_cluster_id": "bf7032f5-cf58-46a3-b595-6510ffda5c2d"
    },
    {
      "claim_cluster_id": "818db8b7-0e38-4d06-8f87-4de475ce7556",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "000d729d-1afe-4b59-b42a-5d8012efd354",
      "event_cluster_id": "712fa0e5-9886-40f6-b761-bb1a99d5fb8c"
    },
    {
      "claim_cluster_id": "5b5325b9-59bb-4b91-9a19-8889095dd496",
      "event_cluster_id": "03e89563-d271-4f75-a47c-92ec9575e524"
    },
    {
      "claim_cluster_id": "5ef68f23-0f9c-4c57-af44-b6d2b7f6107c",
      "event_cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63"
    },
    {
      "claim_cluster_id": "ac6c3346-ea92-4da2-afed-ba431832d85e",
      "event_cluster_id": "ae8f7a24-2c15-4f25-983d-6c8e3d8467ec"
    },
    {
      "claim_cluster_id": "802c7e0c-e913-4631-9fd3-b4b457a510e0",
      "event_cluster_id": "0e2b1f45-559d-4cae-9f78-dbca6d3f4287"
    },
    {
      "claim_cluster_id": "840ac263-91de-449d-b701-c05a4522f3b3",
      "event_cluster_id": "d291acf3-7cf8-4c9d-9ab4-df11bad39953"
    },
    {
      "claim_cluster_id": "3ece6224-aab7-493b-83b2-1f9fc56d3136",
      "event_cluster_id": "99212234-66c3-470f-9dda-4b5f137ff502"
    },
    {
      "claim_cluster_id": "34e272f8-beb9-408f-a252-0fa71406dc4b",
      "event_cluster_id": "388f06a9-49ef-4bdf-8dec-04895f125517"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "9a51f01a-20e0-4f51-8758-8480254254f0"
    },
    {
      "claim_cluster_id": "f68dc41c-3947-416c-8f93-49c606c24bd2",
      "event_cluster_id": "c557e9b2-c812-48ee-97cb-707e7e40672b"
    },
    {
      "claim_cluster_id": "174a0855-e1b9-4e2b-9a6a-957eb12d4b1a",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "e50a9fba-a791-4b5a-bed8-e0accc690c1a",
      "event_cluster_id": "d265d5db-4035-43f0-bc76-bf5945ff3551"
    },
    {
      "claim_cluster_id": "73fff1e2-bc77-421c-8436-e9bf094a9733",
      "event_cluster_id": "8eea3c6d-083a-481c-aa84-30005023f301"
    },
    {
      "claim_cluster_id": "d68f430a-9578-4b21-a27f-13f1a9f8f629",
      "event_cluster_id": "f2f62c1a-8699-46b7-b2e3-61e093884f19"
    },
    {
      "claim_cluster_id": "b9550306-91d4-4e1e-9632-4c73f1957d92",
      "event_cluster_id": "21df275d-4ad2-4f7b-841b-bbaff7511134"
    },
    {
      "claim_cluster_id": "a3cc8d63-1533-4239-bc6b-bedcff828ef9",
      "event_cluster_id": "1ee29b00-1c04-4d47-871a-4fc6d43200cc"
    },
    {
      "claim_cluster_id": "6eb878e4-969f-49ca-8ac8-5c68ead2c13e",
      "event_cluster_id": "92dc2b29-cee7-4ea1-b9e9-d0593544c75b"
    },
    {
      "claim_cluster_id": "d87f03ea-124e-4e30-80f4-ce890ca4d97b",
      "event_cluster_id": "343b7137-128b-41e4-a3ca-cc8e58193569"
    },
    {
      "claim_cluster_id": "01680509-ab3c-4c56-a9a9-62fe3aeaacf8",
      "event_cluster_id": "ac2e2af1-8130-4f38-a6ff-ea4697746269"
    },
    {
      "claim_cluster_id": "89360ae3-18fa-43f0-bd2a-417e02e051c5",
      "event_cluster_id": "64e778b1-1770-4087-ac56-445bf339b8c2"
    },
    {
      "claim_cluster_id": "47fbc359-0497-4aac-8a4b-e63bd060a1e2",
      "event_cluster_id": "4246d514-6e8e-4ea0-b242-f59a58eb4bb7"
    },
    {
      "claim_cluster_id": "dfa7b9d2-5920-4d57-8445-e48ac5ce73da",
      "event_cluster_id": "442fa925-31c9-4639-8516-7ca59dfe469b"
    },
    {
      "claim_cluster_id": "40460222-6c35-47b7-be68-29a1138ce819",
      "event_cluster_id": "c1a9feb3-4c0b-486b-ae22-214c44a6619c"
    },
    {
      "claim_cluster_id": "2c7cf7ec-47d1-4b9e-8095-5a313fd3166e",
      "event_cluster_id": "554d8f5c-047a-4e8e-b996-038e567aa26c"
    },
    {
      "claim_cluster_id": "2b4fc83f-18c3-4ff7-b918-64e0981dd3b2",
      "event_cluster_id": "89d55cf7-6d3f-4328-a78e-26c777948edb"
    },
    {
      "claim_cluster_id": "664823cc-3309-42a4-9224-e9eaa7ee3fe5",
      "event_cluster_id": "e24f9229-3672-4631-abf5-3ab616111d97"
    },
    {
      "claim_cluster_id": "6f7b7d52-9a91-4f92-8a4e-4062c6360cda",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "e840acd4-9152-4039-820b-b347beaec131",
      "event_cluster_id": "f1749a30-d414-494e-8542-2f37dca2357f"
    },
    {
      "claim_cluster_id": "dd5d0634-bc30-45f9-b45a-97773c63db2a",
      "event_cluster_id": "4ccf7bf5-90df-4621-97ed-669020415167"
    },
    {
      "claim_cluster_id": "bed08ef5-4cb1-4f05-b2d4-a996242acd93",
      "event_cluster_id": "93e534a9-c780-4415-bea0-b88f8156dbb0"
    },
    {
      "claim_cluster_id": "0727da75-801a-4ea8-bc54-bca9f4c0cbfc",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "f9741213-db12-438e-ba4b-5df13a3381e4",
      "event_cluster_id": "de89e6b7-8aa5-4a9d-b8b1-927da0ac9c8a"
    },
    {
      "claim_cluster_id": "2870dcce-8def-47de-9196-c66889a0a474",
      "event_cluster_id": "93707dc5-36b1-4b18-b721-a98eb38368ea"
    },
    {
      "claim_cluster_id": "66a36ac1-c9eb-46aa-9ae1-0d7306ddb692",
      "event_cluster_id": "d89daeba-4406-40e6-aed6-08994b1a95d9"
    },
    {
      "claim_cluster_id": "03b37d7e-0ed4-4014-ac24-a898719a8f87",
      "event_cluster_id": "0f0292cd-5ed9-4b41-be37-f307be9f4e80"
    },
    {
      "claim_cluster_id": "3e1920d2-6038-4d0b-b122-137c458f6d99",
      "event_cluster_id": "c92757d9-a065-4dc2-806f-96c7c9890f76"
    },
    {
      "claim_cluster_id": "cef32527-0357-47cf-9fee-19bd0f13e11a",
      "event_cluster_id": "21b3b67f-1874-443c-9458-d23200b40680"
    },
    {
      "claim_cluster_id": "70a36c06-fbb9-4f71-bf77-74f433672b24",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "0f106199-65cd-478b-af43-69825b16fa47",
      "event_cluster_id": "32fafc3d-cccf-4a0c-872b-788d937b0241"
    },
    {
      "claim_cluster_id": "1cd94f5b-6850-44c5-b48e-2bcdab6eefd2",
      "event_cluster_id": "6ad5e833-9ccd-4680-8847-382fff58f760"
    },
    {
      "claim_cluster_id": "4f63d722-2816-4701-89a0-6f6efadc8656",
      "event_cluster_id": "cc9a2a9c-6fc8-4c4a-bdf7-3321a40e8bff"
    },
    {
      "claim_cluster_id": "ba035925-8a5f-42d0-aec3-c91702a47b8d",
      "event_cluster_id": "3a02d9a5-2925-42fc-a9b8-bf0df52af22f"
    },
    {
      "claim_cluster_id": "ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6",
      "event_cluster_id": "059d310b-b926-414f-b010-d79ad9684054"
    },
    {
      "claim_cluster_id": "36ed05e4-cb6f-4b4e-a07c-39d608cb863f",
      "event_cluster_id": "e21706fa-dad7-4365-a0f1-e7a597e49a75"
    },
    {
      "claim_cluster_id": "de5ecea9-1de6-4f23-a787-2b6cd366c836",
      "event_cluster_id": "e6bb5d2b-e815-44c5-957e-bfeac26fe4eb"
    },
    {
      "claim_cluster_id": "74e38083-39b2-4b0b-8874-879983366a75",
      "event_cluster_id": "783f72c7-55f3-4eb7-a87e-43b3ec9f631e"
    },
    {
      "claim_cluster_id": "3e9990d1-ada6-4c9b-b2b3-e8220e956431",
      "event_cluster_id": "7881b67b-b21c-40a3-ac70-ae067b94075c"
    },
    {
      "claim_cluster_id": "98459a3d-d71e-40dc-bfe8-895082c9d11c",
      "event_cluster_id": "a821fab7-385f-4999-8399-e63f4f07d4d9"
    },
    {
      "claim_cluster_id": "175bdcd7-0fff-45d5-9e67-f78e69286a6f",
      "event_cluster_id": "eff3ff70-7d42-45d0-a372-4aa15bf9f280"
    },
    {
      "claim_cluster_id": "d10a4ec7-a74e-4016-996b-f1f3a3c6527f",
      "event_cluster_id": "906d1526-e5ff-4f4e-a0e5-f30c2dfb306d"
    },
    {
      "claim_cluster_id": "1be65d4d-c915-41d3-9d1c-864035425656",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "e36180c3-afe0-495c-8168-73e631f50a1c",
      "event_cluster_id": "23b2fb05-29fc-4502-9ecd-a47d0a63076b"
    },
    {
      "claim_cluster_id": "22c3b77e-fa98-44e1-b509-f721cef0815f",
      "event_cluster_id": "65c190b4-386e-49d9-9ce5-a5d89e355ede"
    },
    {
      "claim_cluster_id": "9142e74b-a217-4be0-8685-ab7ea89b683d",
      "event_cluster_id": "72fcc1d4-63ac-46e2-af29-194e69352aec"
    },
    {
      "claim_cluster_id": "dc9039b4-da9a-4fd0-b97d-d822536a716c",
      "event_cluster_id": "4d6eed7e-0404-4ccd-92b2-df5956550e67"
    },
    {
      "claim_cluster_id": "e3489bfa-95e8-439b-81da-6d84615a5721",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "2cfb50e6-37ad-47a2-87b2-da1a9a512e46",
      "event_cluster_id": "9be7eccf-749e-4a5e-97bb-089da9891c3f"
    },
    {
      "claim_cluster_id": "5443e2c0-e92d-4c21-ba1b-b0cdb2302769",
      "event_cluster_id": "077993b8-9cb6-4b90-bda9-8d4fd6b15198"
    },
    {
      "claim_cluster_id": "bc70c00b-dffe-4092-a775-4a9734094547",
      "event_cluster_id": "2b2effa3-cad0-4ecb-9486-b078278fd3ff"
    },
    {
      "claim_cluster_id": "36b91493-5f3f-412b-a861-2328c6420cc6",
      "event_cluster_id": "82ba6b92-1774-434f-82ee-333e96e53f03"
    },
    {
      "claim_cluster_id": "783f85bb-dceb-450a-9a34-4a650e18ed9f",
      "event_cluster_id": "778d39fb-527e-42ad-a678-aa372a58fc39"
    },
    {
      "claim_cluster_id": "558e806a-d249-4f8a-8e7e-fb4b28552537",
      "event_cluster_id": "634b7e88-e0f0-4f5c-a26b-6d9e0a0fdc06"
    },
    {
      "claim_cluster_id": "9314aa75-84de-490c-95e7-6484ecdba212",
      "event_cluster_id": "dea69c71-f54b-4b5e-a6a9-8af50c3a5a8c"
    },
    {
      "claim_cluster_id": "72804ca3-611f-4b19-ada2-8bfb14c2e98a",
      "event_cluster_id": "b0bd2a7e-c0c5-4afb-ac21-777cf1d80964"
    },
    {
      "claim_cluster_id": "01680509-ab3c-4c56-a9a9-62fe3aeaacf8",
      "event_cluster_id": "78fa9929-a2ff-4f4c-b21a-35134d80f026"
    },
    {
      "claim_cluster_id": "02774183-9d71-4dfd-8f60-b54cf275fbb8",
      "event_cluster_id": "ca3bd404-3299-4dd4-a75b-9491f55542a9"
    },
    {
      "claim_cluster_id": "33e1162a-91ae-476d-b4d5-3b1e2f01a5c1",
      "event_cluster_id": "ca172ee1-fff6-4049-a2d4-1e377d7e0cd8"
    },
    {
      "claim_cluster_id": "17dbd7df-f3d1-4902-a103-f97b03017681",
      "event_cluster_id": "63217c83-a56a-4703-b9b6-f928b5437b8a"
    },
    {
      "claim_cluster_id": "c7013046-8aa1-434c-87b8-1e3317f5578c",
      "event_cluster_id": "fb8928a2-09db-488e-818b-8455b9d3b5aa"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "329efe6d-0194-47fc-abcf-cc9c3ee312f8"
    },
    {
      "claim_cluster_id": "594e0474-2d9d-4582-8963-9fe946d49a1e",
      "event_cluster_id": "94a7144e-4fa6-47f3-9e46-2609b5de45b5"
    },
    {
      "claim_cluster_id": "478c6562-e71b-47f9-8079-8463bc1262ba",
      "event_cluster_id": "dbf5db30-86b6-4686-8710-21f1a647cecd"
    },
    {
      "claim_cluster_id": "72276ba3-4193-4153-879a-b2c7cdf39af4",
      "event_cluster_id": "94b0a214-1e60-4bbb-96cf-031169c35247"
    },
    {
      "claim_cluster_id": "aaf51226-d11b-4c1b-82db-25727f24712a",
      "event_cluster_id": "433a8504-6f95-4801-98c2-808b28575d4f"
    },
    {
      "claim_cluster_id": "e03ac9ce-f105-49c9-9a2f-9442b3b31044",
      "event_cluster_id": "c49f13c9-2c44-44c7-b990-930a2d9264c9"
    },
    {
      "claim_cluster_id": "ab829976-d7fb-4b30-9b92-89eed4e94cc4",
      "event_cluster_id": "4a7e58b2-ad14-4711-92da-e24d91c0e2a2"
    },
    {
      "claim_cluster_id": "6f7b7d52-9a91-4f92-8a4e-4062c6360cda",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "bac292de-05f4-4fd3-a4df-f073c8f09553",
      "event_cluster_id": "d09cadfe-f589-4fe2-9bf8-e5e3a0697237"
    },
    {
      "claim_cluster_id": "02dd8817-131f-4c62-a0d0-fa32952b2e01",
      "event_cluster_id": "b23983b2-f833-47cb-bb9c-14955ae74418"
    },
    {
      "claim_cluster_id": "28aee566-0979-4444-a6e1-cda00f681d91",
      "event_cluster_id": "41741032-ab51-407b-85f5-a7d6f97ca5b8"
    },
    {
      "claim_cluster_id": "e3489bfa-95e8-439b-81da-6d84615a5721",
      "event_cluster_id": "e2b1886a-d41d-4169-be53-e4ed1b6d9d79"
    },
    {
      "claim_cluster_id": "061a86ec-2126-4e4d-85ba-8472db7a97a3",
      "event_cluster_id": "074437b7-382b-4a9d-91da-57d4542a546a"
    },
    {
      "claim_cluster_id": "696180e6-d43f-476a-afce-5f13dbb9929a",
      "event_cluster_id": "8b78f548-1c1b-488a-bf4c-04bfe2488f52"
    },
    {
      "claim_cluster_id": "83176725-df79-43f8-b571-b45c6b2dea8f",
      "event_cluster_id": "5db4a15c-7ce5-458c-89da-0e71f2e155d8"
    },
    {
      "claim_cluster_id": "c2350485-f95c-46d4-9b92-6355ceca86df",
      "event_cluster_id": "dc0f2fc6-867e-476a-b8e1-8031edcf72a7"
    },
    {
      "claim_cluster_id": "e0a2030b-8c63-4b35-9a46-36f1f22b5601",
      "event_cluster_id": "6d2cf6ad-226e-438c-8ae9-0f0b432c0bab"
    },
    {
      "claim_cluster_id": "5ab9d303-668f-48d9-893f-546437484767",
      "event_cluster_id": "8bba2d5b-a20c-44b8-91e1-9dd72d1e1b07"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "0cb30e02-d84d-4557-96e4-2da52513f036"
    },
    {
      "claim_cluster_id": "6d176455-78b5-4454-a405-3f0ba5b91ecb",
      "event_cluster_id": "f6680d6a-ecb6-41e2-9526-051a689d4c68"
    },
    {
      "claim_cluster_id": "c8416335-0a4e-4b5d-aa9e-40e533302d3c",
      "event_cluster_id": "adf0e4d7-03fd-41b1-8559-5505d4d67e0a"
    },
    {
      "claim_cluster_id": "2d2ebd07-a80d-4a48-b320-cc68d39bdc10",
      "event_cluster_id": "8bfff308-f565-423a-9de9-6f9eeebb617f"
    },
    {
      "claim_cluster_id": "4eb17e7e-a0b8-41fd-aeb6-65f4c703f9b7",
      "event_cluster_id": "1122df81-54b6-4861-86f2-c9908073053f"
    },
    {
      "claim_cluster_id": "7576470b-cafe-4c17-9541-256e9ec07097",
      "event_cluster_id": "170734bc-dfb6-42e4-9b5a-6f9747a63ae0"
    },
    {
      "claim_cluster_id": "304f9508-2cf0-4ef2-b524-7a5c78978d94",
      "event_cluster_id": "8098cc1b-8836-490c-9e7f-17c6a8944eb0"
    },
    {
      "claim_cluster_id": "3312bf71-bb24-4752-866e-3b29580d70d1",
      "event_cluster_id": "c9d26401-7e49-4279-ad09-55dcf3457ac8"
    },
    {
      "claim_cluster_id": "78bccd7b-b8a1-4e70-bdf2-26a8b9ac339a",
      "event_cluster_id": "d862e5c2-98e9-4ead-8a8e-98d31f78f4f8"
    },
    {
      "claim_cluster_id": "cdfd2024-64ea-4945-8131-782266513caf",
      "event_cluster_id": "1760a439-ca46-4fac-8653-21cfe35d860c"
    },
    {
      "claim_cluster_id": "21b491b2-20db-42c2-af5c-70af377f068d",
      "event_cluster_id": "71ddb5ae-a33f-4bf8-97d1-9321d27ed4a2"
    },
    {
      "claim_cluster_id": "24e1d750-e055-449a-83a7-236e590f0e5b",
      "event_cluster_id": "20ed0e78-890f-400b-a5b8-9f3252623084"
    },
    {
      "claim_cluster_id": "88c2038a-24a0-497f-bac0-84ee519d160d",
      "event_cluster_id": "cf544ca5-66d4-4d37-bc28-71ce54266ee4"
    },
    {
      "claim_cluster_id": "209935ed-d0a0-4dbe-82d8-2d7d5a2aa866",
      "event_cluster_id": "bd1fd480-bf1e-49b6-a34f-4616e66e256e"
    },
    {
      "claim_cluster_id": "f3d66a5d-cd26-4b6d-a341-2fdc2524c28a",
      "event_cluster_id": "d9df9f73-2328-4c08-a547-bba4c4ece24c"
    },
    {
      "claim_cluster_id": "1574223b-5ec0-4588-8996-6510aa3052d6",
      "event_cluster_id": "d4a86c9e-1cea-4922-914c-e44e0a71bd5f"
    },
    {
      "claim_cluster_id": "0c50e809-0f1b-4656-a0dd-110732b6e47b",
      "event_cluster_id": "47f7a131-6ce1-4e01-b64c-61e5f9696bb1"
    },
    {
      "claim_cluster_id": "52f4370b-6902-4abd-9ee9-d4310ae49cb2",
      "event_cluster_id": "6cafd456-d229-4e09-abf9-1632d52f0462"
    },
    {
      "claim_cluster_id": "06c89f07-f873-4ab4-9068-3bbe6a0c9e11",
      "event_cluster_id": "acb8c5a5-3818-4898-ace2-3330d0f18d6b"
    },
    {
      "claim_cluster_id": "72804ca3-611f-4b19-ada2-8bfb14c2e98a",
      "event_cluster_id": "906602f3-b23d-4091-b462-b74d3ce8894a"
    },
    {
      "claim_cluster_id": "39caeecf-930f-43df-a6d4-e237146a33a8",
      "event_cluster_id": "a1f572c9-19e4-4da8-b35a-87c376dc4fa0"
    },
    {
      "claim_cluster_id": "784725f9-7f56-4fd8-bbd1-9c94d01f5505",
      "event_cluster_id": "28ea99a2-454e-42c3-b308-cf4739fc9a02"
    },
    {
      "claim_cluster_id": "18fe8f4b-896d-47b4-a019-0383dc22d38e",
      "event_cluster_id": "a56532e0-90ee-496a-a60d-c01066fce560"
    },
    {
      "claim_cluster_id": "54bf8eb2-6975-454f-a48b-59abffdfe4f4",
      "event_cluster_id": "789c4f9a-6863-49ee-a41c-e12949429992"
    },
    {
      "claim_cluster_id": "fd424526-ed4e-4b80-99b4-1b131a22e381",
      "event_cluster_id": "e1667646-95da-4708-8fd5-fef1ce4974fe"
    },
    {
      "claim_cluster_id": "f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3",
      "event_cluster_id": "1f7a8e67-3a2d-482a-a62b-2e318f3fda52"
    },
    {
      "claim_cluster_id": "5b5bad5e-15a1-4d61-9521-27fe4f90522e",
      "event_cluster_id": "991ef8e4-a40d-47b2-ae87-93bed03c964e"
    },
    {
      "claim_cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "300e8b62-ec91-41e2-9809-166d3f0a78b2",
      "event_cluster_id": "6e773145-449c-40f0-969b-2f16d4a7c04f"
    },
    {
      "claim_cluster_id": "13470ac2-b4c3-4aff-aa6a-418a5222958e",
      "event_cluster_id": "193fcb1e-c985-42f2-8058-34aadbe0ce78"
    },
    {
      "claim_cluster_id": "7bfb1246-c004-4c78-a34d-8e0a5cdad287",
      "event_cluster_id": "05133a93-3ffe-4993-9c55-47f240923f20"
    },
    {
      "claim_cluster_id": "38711d17-ac82-464c-a077-7a82e0d362fd",
      "event_cluster_id": "6413f39e-1e69-4b93-9d00-8b04286c8041"
    },
    {
      "claim_cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "event_cluster_id": "e80d1fc7-6571-4102-b247-59bf3fa473d7"
    },
    {
      "claim_cluster_id": "e4f4246a-95d9-4d67-94bf-27725af4d71b",
      "event_cluster_id": "ad140612-2296-4f06-9b90-8018512776b7"
    },
    {
      "claim_cluster_id": "f358da84-14e4-4001-acb3-83fa23673eb8",
      "event_cluster_id": "64689f94-8b56-49c1-bd31-9f4133ac52a7"
    },
    {
      "claim_cluster_id": "255ea174-3e00-4506-8a6d-78f62eccfecc",
      "event_cluster_id": "90dd5b61-524c-4738-8cae-d8d3f36a7bf8"
    },
    {
      "claim_cluster_id": "0eef7600-1d71-4d26-9e91-3c6e5b0c6121",
      "event_cluster_id": "0749ed10-4e7c-4fa4-ac39-680414ad6f05"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "efc28260-5d9d-4934-8e08-cb0eaf327cf6"
    },
    {
      "claim_cluster_id": "c9335a55-7c59-42cb-98be-e69b4262faa0",
      "event_cluster_id": "89ca7fbd-adb5-4425-9a07-78efe99244cc"
    },
    {
      "claim_cluster_id": "3e9990d1-ada6-4c9b-b2b3-e8220e956431",
      "event_cluster_id": "77420d84-761c-4596-b8a9-5aa8adb89a0e"
    },
    {
      "claim_cluster_id": "c604d802-912a-4abb-ba43-e290946de463",
      "event_cluster_id": "6d731e69-2664-4f91-adc6-9eac800389a3"
    },
    {
      "claim_cluster_id": "d14315a8-aa93-4c64-a42e-a4307dd0814a",
      "event_cluster_id": "7348cd32-1a61-49ec-88d2-09ed7c4e132b"
    },
    {
      "claim_cluster_id": "8a12011e-a6e7-4e73-a321-a39426ec3d34",
      "event_cluster_id": "1737c28c-8f31-4855-8951-9dd1dd0b8606"
    },
    {
      "claim_cluster_id": "a15b9883-60ad-4e49-8943-56ed500ab8cf",
      "event_cluster_id": "209803f4-b6ac-40bc-97b8-024102ee5865"
    },
    {
      "claim_cluster_id": "2fa38dbd-c491-4579-bb95-e37ac00e125d",
      "event_cluster_id": "3f9df2bc-6f72-4bee-88b2-8ddae64ca085"
    },
    {
      "claim_cluster_id": "bbe61a29-09c0-4f9e-98e6-1cf33324aca4",
      "event_cluster_id": "d2ffb0e6-959f-4fb3-a43b-5fea64c717c0"
    },
    {
      "claim_cluster_id": "a604c242-b8d1-4d4c-9595-5b1b3d840615",
      "event_cluster_id": "07dbae86-71d8-45ff-b18a-4a1bf2ead8e0"
    },
    {
      "claim_cluster_id": "09505049-ee83-46bc-bc41-216c4501ccc0",
      "event_cluster_id": "91a996d6-946d-4317-a60d-c7b9088e7854"
    },
    {
      "claim_cluster_id": "c0a45d49-4b4d-4871-845a-e13c06e06fa2",
      "event_cluster_id": "5113736c-e1bd-4cef-a0d0-94d26dc8aee3"
    },
    {
      "claim_cluster_id": "58b4fd6b-1eec-47dd-b945-a94d957a9933",
      "event_cluster_id": "66195131-3ad8-4241-a0d6-4ab7e32c6962"
    },
    {
      "claim_cluster_id": "470bd6d3-39cf-4a39-9a1c-be6c638cdd0d",
      "event_cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6"
    },
    {
      "claim_cluster_id": "1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07",
      "event_cluster_id": "bc073191-5c75-4ed9-b991-437755cb3cd0"
    },
    {
      "claim_cluster_id": "c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9",
      "event_cluster_id": "65f3a4f7-31a9-4a5f-92ab-a9f153d96b50"
    },
    {
      "claim_cluster_id": "51f9e6ae-7c8a-46e3-8fa3-070377ae9030",
      "event_cluster_id": "7d94faaf-dbe0-4a3f-a991-f9aa1c9db4cf"
    },
    {
      "claim_cluster_id": "c2417696-bc64-4d4a-b3a4-d5d9e3cefb38",
      "event_cluster_id": "bd1a5427-07c8-4a9a-b3bd-6c833ee88f8c"
    },
    {
      "claim_cluster_id": "e12046ad-ffee-4bf5-90ec-51d127135711",
      "event_cluster_id": "904668bf-4a16-4f14-9adf-79655c2a451c"
    },
    {
      "claim_cluster_id": "f3735996-484c-447a-8fe4-4cd5c645a0a9",
      "event_cluster_id": "83593077-334d-4f71-a668-e36e720c6a3d"
    },
    {
      "claim_cluster_id": "763dcb28-8161-4ef1-bcee-20cbd6af7670",
      "event_cluster_id": "287338c2-de9c-4394-a2e1-133139492deb"
    },
    {
      "claim_cluster_id": "1d7ae3fd-fb7a-483b-9d74-2b16ea9b34ba",
      "event_cluster_id": "1c77e648-2237-497b-abcc-acdf4350562a"
    },
    {
      "claim_cluster_id": "54385df9-c5b3-4372-ae3b-cfd7db571df8",
      "event_cluster_id": "0bbc69c0-3b6d-43a9-a4c6-d187b908122b"
    },
    {
      "claim_cluster_id": "73e672aa-47a1-430b-843b-82f236a93650",
      "event_cluster_id": "10df36b6-9ce0-4838-9b29-8a4b4c151281"
    },
    {
      "claim_cluster_id": "162f021a-53e9-4f3d-9231-108223f18e9b",
      "event_cluster_id": "067f4b77-6a0f-43e6-a250-8a682e95f8f7"
    },
    {
      "claim_cluster_id": "49c94f1b-b278-42a0-b8b7-d0f8ec55d536",
      "event_cluster_id": "4b8668b9-ec8e-41f1-b42b-e53f7eac0641"
    },
    {
      "claim_cluster_id": "e50a9fba-a791-4b5a-bed8-e0accc690c1a",
      "event_cluster_id": "36ff0bd5-8344-4d31-824c-e7dea3acb3e6"
    },
    {
      "claim_cluster_id": "72a6b38a-23a2-43db-a788-32ae774a5c77",
      "event_cluster_id": "f0449899-c6ef-4a85-b5c8-5f78e0da96c1"
    },
    {
      "claim_cluster_id": "0a0436c8-54af-4b5e-9725-fc8ed172d1cc",
      "event_cluster_id": "eb9b2ee9-7136-4b80-93fc-c731e2546e36"
    },
    {
      "claim_cluster_id": "174a0855-e1b9-4e2b-9a6a-957eb12d4b1a",
      "event_cluster_id": "cbcdf7dd-2927-468a-83b8-036e8a1b1479"
    },
    {
      "claim_cluster_id": "2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6",
      "event_cluster_id": "a8d5b3e4-8b75-49e0-a915-0b7f6f79f523"
    },
    {
      "claim_cluster_id": "74bc9e46-31ab-4e9e-9240-87a035b90601",
      "event_cluster_id": "5a9527b4-7ddf-4c5a-b860-67170fb02224"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "eb9567f9-4c3d-4f62-bea9-bc557347bb13"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "3e283bf0-1100-4773-9ebf-a90b86b62efc",
      "event_cluster_id": "10c5fb88-3404-4aa6-bc78-257c91344837"
    },
    {
      "claim_cluster_id": "5f2c5e5a-f6ae-4d50-91e8-eee0bd665636",
      "event_cluster_id": "7590439d-277c-48b6-9bb4-812f83d4e421"
    },
    {
      "claim_cluster_id": "fc40e900-5f3a-4200-9723-06366e139ab4",
      "event_cluster_id": "94d7c196-e914-4792-9ae3-448475f12021"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "1b2e8a52-7038-453e-802e-e2b6d0c4da48"
    },
    {
      "claim_cluster_id": "1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07",
      "event_cluster_id": "e4695f74-046d-460d-a794-197c7df92c76"
    },
    {
      "claim_cluster_id": "bd3c25bb-6683-4bdd-8e97-11de485116b2",
      "event_cluster_id": "77cb4584-fbf4-45e6-9a2b-9d46e341c831"
    },
    {
      "claim_cluster_id": "06c89f07-f873-4ab4-9068-3bbe6a0c9e11",
      "event_cluster_id": "13a151a6-c289-4cb5-8bbc-44e52c4f2c13"
    },
    {
      "claim_cluster_id": "2c834413-ef2b-486b-81d5-2e0a687a8ca7",
      "event_cluster_id": "1cebf7eb-146a-47ef-84f4-296315d7b4c5"
    },
    {
      "claim_cluster_id": "b0b87d24-5072-4ac7-bf9b-5891dbcddd35",
      "event_cluster_id": "2672b11d-4ad6-44a1-9b31-f8c01c03c721"
    },
    {
      "claim_cluster_id": "cfda7d82-87df-49b1-8db2-82b62b174a67",
      "event_cluster_id": "06de95aa-ea18-4201-9254-c11dee534162"
    },
    {
      "claim_cluster_id": "27b386d8-58df-4b19-a269-36bb2400c94c",
      "event_cluster_id": "6f00b5de-be1b-4233-883c-1a484844dac3"
    },
    {
      "claim_cluster_id": "97e04a01-6626-4196-a12d-eac1df348581",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "17ea1514-c948-487c-83ee-722001d6184e",
      "event_cluster_id": "dfa97197-5724-4a7b-bce9-4a9f24f7056d"
    },
    {
      "claim_cluster_id": "c02665b8-8535-44f4-96b2-764b54985f66",
      "event_cluster_id": "a56438b9-f9ce-4dfd-beb8-0ced3dfad829"
    },
    {
      "claim_cluster_id": "d4352376-c595-4d9d-928a-8fabbed1e18b",
      "event_cluster_id": "83743532-1cd2-436e-9911-21445ed61af2"
    },
    {
      "claim_cluster_id": "49ede63e-a1af-4931-8ab4-034fed7764ad",
      "event_cluster_id": "17a371ed-b42f-4523-bba1-0b6b3e65c57e"
    },
    {
      "claim_cluster_id": "f42001e5-7364-43c2-8d35-74c3552a9ccb",
      "event_cluster_id": "40e30cac-a785-4067-9a79-c9832fd15372"
    },
    {
      "claim_cluster_id": "5c1d5636-b62a-4962-911d-1136d9629b6a",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "b7cbc93e-51f6-448c-9fc2-c1af44082069",
      "event_cluster_id": "ed2533cf-2013-4e49-885b-231a6c55f0fb"
    },
    {
      "claim_cluster_id": "4ab7d21d-36fc-4f12-857a-8e07c61bf688",
      "event_cluster_id": "c6da85ba-cb8c-4e07-b313-69be94d682d5"
    },
    {
      "claim_cluster_id": "fd554d0c-cd25-4da2-adf1-dcccfd01f292",
      "event_cluster_id": "cb5e091b-477e-46e6-aa3e-6f7875bd065d"
    },
    {
      "claim_cluster_id": "f9741213-db12-438e-ba4b-5df13a3381e4",
      "event_cluster_id": "8822fa56-959e-4020-ae70-4e0f3f35f8fb"
    },
    {
      "claim_cluster_id": "2d7a7088-3ced-40a0-9677-1d14e1c26d8f",
      "event_cluster_id": "a378f92c-87c9-4fc4-85b1-e22948f338e6"
    },
    {
      "claim_cluster_id": "99b20734-bb32-4aff-b60b-a976139937c2",
      "event_cluster_id": "9fe7995d-1f25-429f-b4f7-9af7bc4a7e8a"
    },
    {
      "claim_cluster_id": "770cc261-67a7-4ed4-85d2-93916689a978",
      "event_cluster_id": "e39260dc-c205-47ec-aba4-6672ed7e1722"
    },
    {
      "claim_cluster_id": "5b4b432d-262c-43d8-a2ca-4d8a45a3e1de",
      "event_cluster_id": "d77acdbb-aa93-4e79-8f2a-2afe86ba39c8"
    },
    {
      "claim_cluster_id": "2247b006-05c5-406e-a6b2-d87e6eb59702",
      "event_cluster_id": "5ee42f7d-842e-4bca-a9c2-795ed9870897"
    },
    {
      "claim_cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
      "event_cluster_id": "398a087e-4a63-4bd1-8ad7-e71ca757db9e"
    },
    {
      "claim_cluster_id": "8fed35fe-4af1-484a-bd4d-74f9fac960c8",
      "event_cluster_id": "abbfb703-6da3-4a58-9c1e-a58cf34e5030"
    },
    {
      "claim_cluster_id": "9b7211c2-d426-4818-9305-d12ff5c6e2a5",
      "event_cluster_id": "80650d11-8f1c-4d32-a46d-12e884243f7e"
    },
    {
      "claim_cluster_id": "0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f",
      "event_cluster_id": "2913b0c9-ef79-4e98-9ca0-9e5e2abf9938"
    },
    {
      "claim_cluster_id": "ded98049-aef1-4b4f-a8a6-f68c10032b7f",
      "event_cluster_id": "f2b47c96-3e62-4d1a-98f6-547e71af6858"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "e5736d52-6864-4a19-aa95-57d6bbe8f40d",
      "event_cluster_id": "b70fcbd6-9ed5-4bd6-a526-8679fde82331"
    },
    {
      "claim_cluster_id": "ac1a90d2-3517-43fd-8e60-dd7d570db743",
      "event_cluster_id": "e1314480-d543-4a51-a6ee-6dc61dbfa929"
    },
    {
      "claim_cluster_id": "f854f83f-364d-470a-8cd8-f0bec2c15e68",
      "event_cluster_id": "88bb793a-f03a-44d3-bc64-124f3010e3b7"
    },
    {
      "claim_cluster_id": "dcc1a857-7e25-4b1e-bb30-c67434a5f183",
      "event_cluster_id": "72ed971f-2c7c-4564-b630-36c027e0f1d2"
    },
    {
      "claim_cluster_id": "ee9a474d-ce93-4992-ac4b-8d9da4087257",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "1cbddfd6-c491-40b1-b10c-fd4387edddf6",
      "event_cluster_id": "5de6826d-9cc1-4c89-8c16-3e4d254ae1a9"
    },
    {
      "claim_cluster_id": "fdc7a586-a2b7-43cb-897c-5aacc04ceaff",
      "event_cluster_id": "e581acd0-fb94-4a27-8e52-0501198c921d"
    },
    {
      "claim_cluster_id": "ceec9597-cc69-4304-a584-0cec50748ec3",
      "event_cluster_id": "748efe6a-9ff2-447f-9d13-f72501f7e924"
    },
    {
      "claim_cluster_id": "24accb31-401b-42c1-bd69-e81c04cb2530",
      "event_cluster_id": "4c0dfd84-df3b-4660-9041-a635021908ef"
    },
    {
      "claim_cluster_id": "fc40e900-5f3a-4200-9723-06366e139ab4",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "772127a5-d049-4874-9828-2ed65010852d",
      "event_cluster_id": "6b05928d-06c6-4035-8854-c47627756aaf"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "28c2302e-bfe1-426f-8146-f632519111cc"
    },
    {
      "claim_cluster_id": "4a8ddb73-8e8c-4981-b0f4-e38510f4f712",
      "event_cluster_id": "e0af4c3d-214d-424d-955e-14071d90129c"
    },
    {
      "claim_cluster_id": "385e1f90-483f-4a17-bec9-dd37d561707f",
      "event_cluster_id": "5a363a3c-7ca6-45b2-98ec-b07e07ef38de"
    },
    {
      "claim_cluster_id": "e871839f-962c-43cf-a2f7-5ebaf26de0a1",
      "event_cluster_id": "5be5d4e4-f894-4929-941a-785184a9901d"
    },
    {
      "claim_cluster_id": "17eaa25c-625f-4414-b1ad-78d904209f81",
      "event_cluster_id": "6e55b53e-064d-4b25-b79e-bd27aee62abe"
    },
    {
      "claim_cluster_id": "f3d66a5d-cd26-4b6d-a341-2fdc2524c28a",
      "event_cluster_id": "a9de4b16-c663-4b5e-933f-b9821d2cc80d"
    },
    {
      "claim_cluster_id": "b8208758-3ffb-41f1-97e7-30e90da08e44",
      "event_cluster_id": "238786da-a825-4e96-9851-097b2db705e0"
    },
    {
      "claim_cluster_id": "6d176455-78b5-4454-a405-3f0ba5b91ecb",
      "event_cluster_id": "7598667f-d0d3-42d2-856a-51698f3f1b3c"
    },
    {
      "claim_cluster_id": "38520096-281c-4b53-ba64-f7e18dbd525f",
      "event_cluster_id": "d2bc0c3a-3d51-4a76-89f5-0aef4a862a3f"
    },
    {
      "claim_cluster_id": "ae201524-ae4c-4b92-afa7-2801ac429060",
      "event_cluster_id": "53a00b92-807b-43f5-846e-1b35127294fe"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "67c7f204-fd07-4c45-80b1-5b0bd873efd4"
    },
    {
      "claim_cluster_id": "13f086c1-e440-480a-a882-8d8a742c1d5e",
      "event_cluster_id": "72fcc1d4-63ac-46e2-af29-194e69352aec"
    },
    {
      "claim_cluster_id": "f8618eda-effd-4eda-b2ad-66d8fec0ba02",
      "event_cluster_id": "6c73f0ba-1131-48ad-8cc3-b8a29be7cfff"
    },
    {
      "claim_cluster_id": "d072d7ca-3280-4412-8e76-be63e36fe491",
      "event_cluster_id": "04828ccc-4133-4cf2-961b-b8fc2a3c6d43"
    },
    {
      "claim_cluster_id": "5767d0cf-3070-412a-9136-a29c287f15a1",
      "event_cluster_id": "5cd2aca7-8312-405f-b073-d87b70cdcee0"
    },
    {
      "claim_cluster_id": "85123ed6-1d34-44b3-9644-642bc01ff160",
      "event_cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"
    },
    {
      "claim_cluster_id": "a7d1cc33-aa3a-4ee3-86f6-065986a716af",
      "event_cluster_id": "6773439f-27bf-46ee-884f-6f78667de502"
    },
    {
      "claim_cluster_id": "b877e703-7bf9-4587-919b-bf207b22c607",
      "event_cluster_id": "cf071659-f57a-47ef-8e58-d5ef07d53221"
    },
    {
      "claim_cluster_id": "16667fe1-8cf7-4fec-9aa8-c5bb30920e90",
      "event_cluster_id": "e3cd63c9-b877-4cb4-80a4-d872818bfe3f"
    },
    {
      "claim_cluster_id": "d2830923-6260-4e70-9fc4-f723af340d1f",
      "event_cluster_id": "6b2b1fd9-ebe6-4e20-9f18-a97a395c8d10"
    },
    {
      "claim_cluster_id": "89360ae3-18fa-43f0-bd2a-417e02e051c5",
      "event_cluster_id": "4d6eed7e-0404-4ccd-92b2-df5956550e67"
    },
    {
      "claim_cluster_id": "691c3c1b-0058-48a0-aaa7-5a38747b8c58",
      "event_cluster_id": "7e010522-998f-4102-8a4d-417605255131"
    },
    {
      "claim_cluster_id": "f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3",
      "event_cluster_id": "2baba0c0-38f3-43b9-8755-4293f919fe7d"
    },
    {
      "claim_cluster_id": "151738b2-0d24-44aa-896c-fa16a74db380",
      "event_cluster_id": "35d3d7f4-4964-4980-9833-62b5e004737f"
    },
    {
      "claim_cluster_id": "81fccffb-0c5b-4efd-826c-64c3efbb0393",
      "event_cluster_id": "1ccab5e4-b80e-4900-88c8-f5ed9013c0df"
    },
    {
      "claim_cluster_id": "ccd87163-f5c4-4a49-b3d3-5d5c4788834c",
      "event_cluster_id": "276946c6-5e3d-44d2-b7e3-410789a74a81"
    },
    {
      "claim_cluster_id": "fd96ef0f-c2a3-47f0-b0ee-4580d498d313",
      "event_cluster_id": "0be1925a-4753-4905-9510-39b869eaa6c5"
    },
    {
      "claim_cluster_id": "0e8e4003-b007-4df8-a1a5-948e64fe6342",
      "event_cluster_id": "4ae785fa-8876-494b-8048-bcaeeb28e317"
    },
    {
      "claim_cluster_id": "57752645-2ac6-4482-9e7c-bbaea1506cc5",
      "event_cluster_id": "869d4c13-d074-42b4-bbc1-2f3f74bed7a5"
    },
    {
      "claim_cluster_id": "e521c1db-8ae4-48b6-83c6-efbd02701f4c",
      "event_cluster_id": "19e2179d-5af7-4b00-a62f-bafff28190d0"
    },
    {
      "claim_cluster_id": "61b758fd-ce2c-4502-b494-9618880e66e4",
      "event_cluster_id": "4fdc1bfa-2d9c-4f20-8628-a8f4ff72ccc1"
    },
    {
      "claim_cluster_id": "21b4d7af-e8bf-408f-b63a-f91c28b7ba72",
      "event_cluster_id": "12ee6320-67eb-4e37-918e-874e1948fd36"
    },
    {
      "claim_cluster_id": "a8dc28b0-9676-46fe-a3b7-8eb8e563deb8",
      "event_cluster_id": "4eaa501e-252e-4e04-8606-fd467f380267"
    },
    {
      "claim_cluster_id": "71a82b79-aaaf-4fee-8e73-d292675a2e3a",
      "event_cluster_id": "8dc116ab-03c9-451e-bd40-127719cd94fb"
    },
    {
      "claim_cluster_id": "b49a91d7-446b-421b-9670-7c99bbf5bc28",
      "event_cluster_id": "e2924858-e631-4f3d-8b15-9f5ee8ab3b4e"
    },
    {
      "claim_cluster_id": "997de204-d7ea-4e15-b208-ebc2bd4ddd62",
      "event_cluster_id": "6f88a50d-7c8b-451d-b706-e766cfe9a47a"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "6fb5df41-d443-476b-9fcc-1bb07e6c9654"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "c25ff750-8a41-47e3-b517-245284092082"
    },
    {
      "claim_cluster_id": "0e225927-1e3a-42e7-9ee8-7f9c2bae0dc2",
      "event_cluster_id": "06b0b383-d1f3-4b0b-96d7-d1ed1424d080"
    },
    {
      "claim_cluster_id": "cb357706-7b58-4396-aa24-1c59beae87fa",
      "event_cluster_id": "75279036-9309-48c1-9fcd-8d4eebf44481"
    },
    {
      "claim_cluster_id": "6967755e-61e4-4308-be97-cdea95a155c7",
      "event_cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c"
    },
    {
      "claim_cluster_id": "d59582f7-7e86-41f9-a084-db1da2a740db",
      "event_cluster_id": "c1eef27a-1e7c-4cf7-af1a-61c89699baa9"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "f57aa067-2ae8-4cb7-8526-f9e921a1522a"
    },
    {
      "claim_cluster_id": "f0d99bfd-e20a-4b87-9be0-a227af6f681d",
      "event_cluster_id": "73834fa0-ff83-4c9b-a609-95e04c072ab7"
    },
    {
      "claim_cluster_id": "577be512-045b-4f32-8688-400d686a100d",
      "event_cluster_id": "c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"
    },
    {
      "claim_cluster_id": "1a853cc3-9e33-4539-b70a-cc51380d7526",
      "event_cluster_id": "1abec326-fbb4-4834-a440-05a48bbfed29"
    },
    {
      "claim_cluster_id": "e12046ad-ffee-4bf5-90ec-51d127135711",
      "event_cluster_id": "a3d2131c-63fa-494b-a0bb-572e611c5c5e"
    },
    {
      "claim_cluster_id": "7b1c03fe-e3e1-476b-ab84-c44a6ea52022",
      "event_cluster_id": "aa310c78-7994-4d40-8f0b-2bea418f42a5"
    },
    {
      "claim_cluster_id": "9fb5216e-3d0c-403e-a2bf-9368fa3e3592",
      "event_cluster_id": "002cfac3-c97a-4ec1-b743-37eb0267aef0"
    },
    {
      "claim_cluster_id": "21c29f8c-34b7-47c4-8021-91ec84cff803",
      "event_cluster_id": "503eed9f-ea34-45f7-b3eb-f015bdc664b3"
    },
    {
      "claim_cluster_id": "bd4c7f11-9866-4656-98e3-7341cfc6de34",
      "event_cluster_id": "ed1ec0ec-9794-4ebc-ab7f-279232e95886"
    },
    {
      "claim_cluster_id": "96cef335-1ca0-48d6-912f-d308e0729c0b",
      "event_cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"
    },
    {
      "claim_cluster_id": "a751c83d-9da2-48e9-83a8-bc6d8a1c455f",
      "event_cluster_id": "d26a88d8-31d1-4986-9e0c-b30944f01491"
    },
    {
      "claim_cluster_id": "86bae394-d674-498b-bd18-aa3046f40d19",
      "event_cluster_id": "a59ccb39-5f94-4ce9-bc2c-828e0325e1b2"
    },
    {
      "claim_cluster_id": "be023ca2-f865-4811-854e-b40ab442412b",
      "event_cluster_id": "a7318687-bec9-447f-89a2-3a9e7981d92c"
    },
    {
      "claim_cluster_id": "29469bb2-a496-413c-802b-5a8d1b46d374",
      "event_cluster_id": "80650d11-8f1c-4d32-a46d-12e884243f7e"
    },
    {
      "claim_cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "event_cluster_id": "8d5cbaf2-a64f-4a10-8901-a0b4a2c4582f"
    },
    {
      "claim_cluster_id": "f4175686-5e4d-4fb0-a465-bed7586f6615",
      "event_cluster_id": "53a74c73-495d-4f2b-8724-c28415d16065"
    },
    {
      "claim_cluster_id": "56dc9727-1db9-4dc8-acf2-c70b7f101883",
      "event_cluster_id": "2b84f92b-3438-4364-9cac-d11edad425f9"
    },
    {
      "claim_cluster_id": "8f273fa4-f8bd-4413-8ce1-7183b77e2566",
      "event_cluster_id": "c16a80f4-74b2-4799-878f-766f008df3df"
    },
    {
      "claim_cluster_id": "cdfd2024-64ea-4945-8131-782266513caf",
      "event_cluster_id": "32516088-d496-4b04-a09c-540561be5921"
    },
    {
      "claim_cluster_id": "0a8b23b0-e002-4dc9-aefa-6b8b8922f3ff",
      "event_cluster_id": "24cf159f-beda-439d-a5c9-ae442b6d0260"
    },
    {
      "claim_cluster_id": "0fde95b6-db57-45cd-b6ac-fb0edd1b186b",
      "event_cluster_id": "dc0f2fc6-867e-476a-b8e1-8031edcf72a7"
    },
    {
      "claim_cluster_id": "411175f7-0ca0-4fb5-9db2-35822ef1cc0a",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "4f331c05-6fa5-4bd8-adc2-5458e8c80843",
      "event_cluster_id": "d152f743-9bb8-4932-b2e3-17b89ab993fc"
    },
    {
      "claim_cluster_id": "ea316b29-c411-49a8-8ebd-8e50456fc746",
      "event_cluster_id": "7bf16433-80b0-4f9a-878b-7a95d835ad86"
    },
    {
      "claim_cluster_id": "ac1a90d2-3517-43fd-8e60-dd7d570db743",
      "event_cluster_id": "cfc691ea-395c-407e-9d4f-47222067d9ee"
    },
    {
      "claim_cluster_id": "ae1d4689-4f04-4acd-a0d9-2c0934c3acd4",
      "event_cluster_id": "b3af6432-57a3-4958-a1a0-2d28085f3e29"
    },
    {
      "claim_cluster_id": "24e1d750-e055-449a-83a7-236e590f0e5b",
      "event_cluster_id": "bb498dfb-0342-4611-a82f-6ce424759a23"
    },
    {
      "claim_cluster_id": "168a2344-84cd-4fca-8692-ada3563a273d",
      "event_cluster_id": "36e1cdef-b33a-4858-bed1-0bbaf9ed9bc4"
    },
    {
      "claim_cluster_id": "c830c75d-93e2-4842-b468-b89a47252719",
      "event_cluster_id": "30cd928f-5775-4679-a8af-3acd8dd1a21e"
    },
    {
      "claim_cluster_id": "2e620f14-db3f-4f94-9e90-7ae11cf68067",
      "event_cluster_id": "64ddad58-c0e5-4850-be27-0ed962a47441"
    },
    {
      "claim_cluster_id": "2d7a7088-3ced-40a0-9677-1d14e1c26d8f",
      "event_cluster_id": "18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"
    },
    {
      "claim_cluster_id": "6015f261-315c-43b5-ae1a-b6f1ad2e1ce6",
      "event_cluster_id": "d18f265e-1140-4ce3-9bf4-76f0c6ccf8de"
    },
    {
      "claim_cluster_id": "6a4b35a4-0785-4292-8587-aee85db61288",
      "event_cluster_id": "44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"
    },
    {
      "claim_cluster_id": "719ee837-abdf-462d-a985-984d0a2eb167",
      "event_cluster_id": "615888f6-5d35-4a8c-acd9-9e71127a4cb4"
    },
    {
      "claim_cluster_id": "90a4e218-d5e9-4e12-b842-f6c8e272cb28",
      "event_cluster_id": "9893c9eb-e787-4810-bf5b-6340ac0c0c07"
    },
    {
      "claim_cluster_id": "281fca06-ede2-40bc-9960-0788b1d20c23",
      "event_cluster_id": "dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82"
    },
    {
      "claim_cluster_id": "9594285e-8196-4153-9b31-89250a7200d5",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "baa70e51-5ce2-4e6f-8994-d85027e6b1d9",
      "event_cluster_id": "637433ac-6811-450b-94c9-8c40811c8f6a"
    },
    {
      "claim_cluster_id": "d37ab208-5122-4b14-a2ce-fa0d51ab2a4b",
      "event_cluster_id": "864c05a2-76fd-45dd-8aa5-97a6e22bcf53"
    },
    {
      "claim_cluster_id": "d9041723-b3d2-4f6c-85e6-435010ef6231",
      "event_cluster_id": "7fa3c63b-2bb5-48ea-95da-cc1ed541a317"
    },
    {
      "claim_cluster_id": "a7a78172-b61a-41cd-a089-5fdf5b5e9fdc",
      "event_cluster_id": "77ff5800-b905-4e32-87cc-e4de9525bb38"
    },
    {
      "claim_cluster_id": "8992a182-5ede-4dbb-9979-4dcf0e10c546",
      "event_cluster_id": "6274b067-d713-4a61-a1f2-5f2f2d2df7fa"
    },
    {
      "claim_cluster_id": "57752645-2ac6-4482-9e7c-bbaea1506cc5",
      "event_cluster_id": "232c00d5-5161-4308-8ff9-5bf29dea48c9"
    },
    {
      "claim_cluster_id": "442dded8-bef6-49b2-b7d4-70454c6e8e79",
      "event_cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14"
    },
    {
      "claim_cluster_id": "2b7a55b4-92f1-4438-b42d-086b564be154",
      "event_cluster_id": "e5868b04-4cec-4d02-b896-8db4cc7180db"
    },
    {
      "claim_cluster_id": "cfde4319-eb6f-4277-956f-9a094157160f",
      "event_cluster_id": "3923fc76-d76d-4386-926c-4e8e39862387"
    },
    {
      "claim_cluster_id": "3eeddc05-77ec-4d67-9a78-4b328957fe7f",
      "event_cluster_id": "86986259-8535-49c7-b1f7-162a0bd7065f"
    },
    {
      "claim_cluster_id": "37f5cf93-69fa-41bf-960a-1fd7783d4299",
      "event_cluster_id": "da0898ac-2eb7-477c-8e02-e9f17ebb39af"
    },
    {
      "claim_cluster_id": "7e1a378e-1366-4ff2-9282-46ddc9975cc6",
      "event_cluster_id": "53dbd851-31b8-4afd-8a69-b5ebc32a8f7b"
    },
    {
      "claim_cluster_id": "c6b3d942-ded2-4171-9d53-bf87a1b48b52",
      "event_cluster_id": "0cb84281-0a02-4551-a9b6-e0952da929f7"
    },
    {
      "claim_cluster_id": "8fed35fe-4af1-484a-bd4d-74f9fac960c8",
      "event_cluster_id": "e3403237-7c1c-4e7a-9604-df8d11301d8d"
    },
    {
      "claim_cluster_id": "3b1124a1-83ad-4acf-aefc-fa570a669706",
      "event_cluster_id": "71b309b2-2dda-4212-a921-75eae9813c5d"
    },
    {
      "claim_cluster_id": "e03ac9ce-f105-49c9-9a2f-9442b3b31044",
      "event_cluster_id": "a263e3cc-09b2-4ae5-a252-4665ad483b52"
    },
    {
      "claim_cluster_id": "e2a085c3-49f3-4799-87cc-2b59f85d4bb4",
      "event_cluster_id": "a54ebcea-b85a-4358-b8f9-7f678d18fb51"
    },
    {
      "claim_cluster_id": "689e5dcf-938b-411b-9e5b-4de3aa6f026b",
      "event_cluster_id": "3112aa1b-4574-44ce-bed2-c9c9be423dbd"
    },
    {
      "claim_cluster_id": "02aff357-d128-4a8d-9828-60ab97d0e632",
      "event_cluster_id": "aeb3174b-bc91-4fbe-9027-0eda5304183e"
    },
    {
      "claim_cluster_id": "64599826-faee-4fcf-9432-967663d05451",
      "event_cluster_id": "a7c1c7dd-20e8-417a-8b0d-915fb535b95c"
    },
    {
      "claim_cluster_id": "b49a91d7-446b-421b-9670-7c99bbf5bc28",
      "event_cluster_id": "1c4341b5-18d5-4ba6-a313-e14ad3c93bc5"
    },
    {
      "claim_cluster_id": "97507c06-9158-4dec-af84-2ca3daa906d2",
      "event_cluster_id": "6ddc553f-506b-402a-87ca-b781b2c60932"
    },
    {
      "claim_cluster_id": "bbe7fdd5-62f8-403f-97fb-16e838e19a59",
      "event_cluster_id": "86d86a3a-37c2-4eef-9deb-93d9580b80d1"
    },
    {
      "claim_cluster_id": "1c30353a-a7dc-48dd-bca2-56c91aa06ab6",
      "event_cluster_id": "d3085fed-3741-4d75-9105-e8b0b3511de6"
    },
    {
      "claim_cluster_id": "29bf0ceb-12c5-4f73-8a36-f5d689e7afd2",
      "event_cluster_id": "baef31d1-0183-4a82-91e5-3ce55345b1d6"
    },
    {
      "claim_cluster_id": "503584d7-75a5-4f03-adb1-4844dd4d9b9f",
      "event_cluster_id": "71c5fa4a-0b53-4202-9b3e-1c8038451d63"
    },
    {
      "claim_cluster_id": "e28e105a-739c-4f5f-8b79-8f56f435e121",
      "event_cluster_id": "36b001d3-8cd6-4b58-93ae-5ad737efa236"
    },
    {
      "claim_cluster_id": "d0814fdc-170f-48fa-8def-5a656118ed2d",
      "event_cluster_id": "df890887-499a-48f3-b818-746e4296c3f6"
    },
    {
      "claim_cluster_id": "c537cca1-8aec-41b9-96db-837f4d59c8e4",
      "event_cluster_id": "a36a54af-ea36-46fb-b97e-4f17594784b7"
    },
    {
      "claim_cluster_id": "ea6a2243-de2d-4dba-b6c1-70fc6e903bfb",
      "event_cluster_id": "a33e2184-c58d-453d-a647-1ef27ddf5c17"
    },
    {
      "claim_cluster_id": "81a839cf-9fe4-4f39-95e1-2ebc94ae6380",
      "event_cluster_id": "baa5172c-8725-4cca-b3be-5d512cf618a1"
    },
    {
      "claim_cluster_id": "7bf4f678-55d5-4f6a-922f-0b5de572f033",
      "event_cluster_id": "2c6c7495-70ee-4e85-b85f-579b0d1c01ac"
    },
    {
      "claim_cluster_id": "5cb260df-5e4a-4685-94d3-087687f5dbed",
      "event_cluster_id": "ac86516b-573a-4ca5-9a1d-d4dd1666f20a"
    },
    {
      "claim_cluster_id": "fcbed875-f592-4e43-93ba-c1c4ead8d38a",
      "event_cluster_id": "7c268167-b621-480c-ba79-7005ed13e2de"
    },
    {
      "claim_cluster_id": "f8d5c2ae-ad96-41f1-8875-2d89a574f697",
      "event_cluster_id": "32e37585-3bd0-4873-ab47-c364fef5143f"
    },
    {
      "claim_cluster_id": "31ba7a04-0212-474b-8f8e-9374845e4ab5",
      "event_cluster_id": "5f1d9f8e-2516-4e42-a0a6-815bb97110a4"
    },
    {
      "claim_cluster_id": "e9d22d46-e0d1-45b7-b109-afc6516146e1",
      "event_cluster_id": "60f0b8f5-f6ce-4be8-993b-d99ea8933141"
    },
    {
      "claim_cluster_id": "d30cdd9d-92e1-44ac-aad9-845702e1559f",
      "event_cluster_id": "2f3684a3-db51-45d5-8ab6-a0d061f2a667"
    },
    {
      "claim_cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
      "event_cluster_id": "2d8a2b96-5e68-43e2-a162-f66eeb390e13"
    },
    {
      "claim_cluster_id": "b31e61b9-2010-4063-88bd-0eced0599429",
      "event_cluster_id": "44105fe2-7f1b-4985-910c-f4a271b0cca1"
    },
    {
      "claim_cluster_id": "12605708-2ac7-455e-a636-1d8a235af813",
      "event_cluster_id": "86797f95-8265-40b4-9a2e-f9574ce9ab8c"
    },
    {
      "claim_cluster_id": "175bdcd7-0fff-45d5-9e67-f78e69286a6f",
      "event_cluster_id": "af0ec0ab-3b4f-471b-b656-e88e02335b8a"
    },
    {
      "claim_cluster_id": "69638d1f-f33d-45d8-beac-6ee7ce61ea29",
      "event_cluster_id": "55351f66-3ce1-4720-a5bd-bce9d2bab5d2"
    },
    {
      "claim_cluster_id": "1c849e20-6024-47fa-80b4-e611385ba612",
      "event_cluster_id": "d4ecfa56-5354-4519-b8ae-d7dff0864186"
    },
    {
      "claim_cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
      "event_cluster_id": "cc1a98ca-fc1c-4f29-b58b-0d99bce8b809"
    },
    {
      "claim_cluster_id": "5b4b432d-262c-43d8-a2ca-4d8a45a3e1de",
      "event_cluster_id": "cb02ee47-9033-4860-896e-93d4dd3bca66"
    },
    {
      "claim_cluster_id": "449f7a4c-3966-4db6-9cf4-d39a2f15feae",
      "event_cluster_id": "639772f4-84fc-47d4-a44e-cd508a3d7e6a"
    },
    {
      "claim_cluster_id": "c94810e3-5711-44bc-a55f-5ef59645cf78",
      "event_cluster_id": "e1299aca-73c3-4bf2-9656-1a4bc5aa21cd"
    },
    {
      "claim_cluster_id": "f83b448c-d81d-4175-b604-2783d1df502d",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "3249ee55-684b-4bbb-8b52-6766f62838f9",
      "event_cluster_id": "c48b1546-3855-4755-8da6-3e9352505d7a"
    },
    {
      "claim_cluster_id": "3b7e3ce4-4e60-4c09-986c-9b9376d80c8a",
      "event_cluster_id": "5561c312-8b94-44c1-8be5-5ceb08c13061"
    },
    {
      "claim_cluster_id": "2567422d-b366-451c-a271-4cb76dc8196c",
      "event_cluster_id": "cfb29440-b86f-4923-96db-5f6b8ae72df4"
    },
    {
      "claim_cluster_id": "642bd570-9063-4bca-8050-702e322b8b3c",
      "event_cluster_id": "d7ce0029-7c2c-40fb-8d24-32029ffa4b81"
    },
    {
      "claim_cluster_id": "d10a4ec7-a74e-4016-996b-f1f3a3c6527f",
      "event_cluster_id": "2b56b1f6-1627-44ab-9460-b13751cf087b"
    },
    {
      "claim_cluster_id": "cd37a888-7bea-44b1-9691-e12e7c11fac9",
      "event_cluster_id": "1f4a4adb-de76-451d-aa05-57dc41f8014d"
    },
    {
      "claim_cluster_id": "0fa9f6d7-64f6-4933-aae8-3cfd512cab5c",
      "event_cluster_id": "d0a50ea8-30f3-4820-8087-1083e0d5b05d"
    },
    {
      "claim_cluster_id": "748c24aa-69c4-47c4-a75f-e6da7007b74a",
      "event_cluster_id": "3014a508-0ddc-42e0-9480-97e1310e1f29"
    },
    {
      "claim_cluster_id": "de56a9d8-47ef-4820-ac13-06ed6f8760ef",
      "event_cluster_id": "f8830cd0-0851-4651-a6ad-3f181547090d"
    },
    {
      "claim_cluster_id": "e0c5a85f-7145-4366-aac8-58cd212f7e6a",
      "event_cluster_id": "78c613ac-a6ce-4fc2-859c-265be8fa23d8"
    },
    {
      "claim_cluster_id": "fc40e900-5f3a-4200-9723-06366e139ab4",
      "event_cluster_id": "4a483622-b245-4e23-bd10-793b05ae9fe2"
    },
    {
      "claim_cluster_id": "6717f23b-7a46-4774-9d7d-76c5eb0bdde2",
      "event_cluster_id": "83537dd5-17fd-4fd5-9899-58a782adb8f8"
    },
    {
      "claim_cluster_id": "469a2781-0070-451c-bc21-b7ee2b0da3f0",
      "event_cluster_id": "6781bc51-3496-4995-a431-ee10c271f91c"
    },
    {
      "claim_cluster_id": "883c65b8-c8f1-4a3b-8bd5-fb9d61a95876",
      "event_cluster_id": "80650d11-8f1c-4d32-a46d-12e884243f7e"
    },
    {
      "claim_cluster_id": "38eef897-6e59-4836-bf0e-1e7e106baf53",
      "event_cluster_id": "da887573-bcbf-4c6d-8541-c47ee99de6f7"
    },
    {
      "claim_cluster_id": "ac1a90d2-3517-43fd-8e60-dd7d570db743",
      "event_cluster_id": "a80e30ca-b2de-458a-9b37-eea9f6f3a278"
    },
    {
      "claim_cluster_id": "58a44cd6-3f44-4460-9d07-d5a28bd55747",
      "event_cluster_id": "9d77a640-6134-44b7-85bb-43fc8324bd77"
    },
    {
      "claim_cluster_id": "a4d61819-30e3-46aa-ab08-cf879db00de1",
      "event_cluster_id": "cf284659-5e8d-4417-9c7c-b41b8155ecf8"
    },
    {
      "claim_cluster_id": "58bf9f4a-adda-4853-802b-78d04aa711fa",
      "event_cluster_id": "e069f39e-fe04-4587-9d2f-1992b7189502"
    },
    {
      "claim_cluster_id": "4d2c8d1c-73d7-42b1-87cb-56c8ddf68982",
      "event_cluster_id": "88549cc5-91d9-499e-9367-819f2a75e847"
    },
    {
      "claim_cluster_id": "3232bd90-9251-47f0-ae93-ae2d51218354",
      "event_cluster_id": "e657af4a-ab5e-4efa-9539-dbb94e69e772"
    },
    {
      "claim_cluster_id": "09907625-9889-4def-8ff5-b61d82ce4a21",
      "event_cluster_id": "08268346-74f3-44b1-a6ed-3517ea134f57"
    },
    {
      "claim_cluster_id": "1c220b25-802f-4053-89c5-d8f4805341a5",
      "event_cluster_id": "c9895da0-2b5a-466d-80f2-7637e4a4aa2f"
    },
    {
      "claim_cluster_id": "0e8e4003-b007-4df8-a1a5-948e64fe6342",
      "event_cluster_id": "a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"
    },
    {
      "claim_cluster_id": "fa32fcee-2bb1-444a-8515-123065611c9e",
      "event_cluster_id": "ace987dd-fefd-4144-a25e-4a8cd1ec09c0"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "5317331a-d0a9-4595-acad-210a92b278d8",
      "event_cluster_id": "42214595-36bd-4891-862c-e83b3aae0a8a"
    },
    {
      "claim_cluster_id": "3dd1bcbf-32ed-443e-a942-a8e7446ea6d1",
      "event_cluster_id": "cd8387d2-f3fa-45cb-9628-ef16bef4b5fa"
    },
    {
      "claim_cluster_id": "86478e14-8f65-4b25-93ee-a6036b9de886",
      "event_cluster_id": "1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"
    },
    {
      "claim_cluster_id": "b9579765-0e2f-429b-a723-006d6265617d",
      "event_cluster_id": "b816fa39-a961-4930-9c7a-6091dc870326"
    },
    {
      "claim_cluster_id": "1b63ec5b-2010-4bd3-a351-328e7b4b5470",
      "event_cluster_id": "df948051-689d-40a8-ad8a-28a2dedfe405"
    },
    {
      "claim_cluster_id": "aef50142-8ad0-4099-9362-3d45c56385fc",
      "event_cluster_id": "97137b20-3c93-43e9-b1a9-879cf76db9bf"
    },
    {
      "claim_cluster_id": "0b331741-7f54-4613-ad60-e935b60f7fbe",
      "event_cluster_id": "7efa0178-d8ab-468b-a654-e8cca19d755a"
    },
    {
      "claim_cluster_id": "0e2fe0e5-314e-4455-88c7-a13f3f6e7728",
      "event_cluster_id": "efc4ab9a-f965-4202-ac72-ebf2fe08724d"
    },
    {
      "claim_cluster_id": "d3037252-9ff2-4032-ae65-41b104560fbd",
      "event_cluster_id": "4941bed1-24d8-4571-89bb-5872a51c53ed"
    },
    {
      "claim_cluster_id": "ffb2c778-a1f6-402c-8381-54550bf56799",
      "event_cluster_id": "a4887daa-dc3f-4a40-83f8-3598cedca9f3"
    },
    {
      "claim_cluster_id": "166b6595-ba80-4fe0-a5a2-70307703e855",
      "event_cluster_id": "e4d7e062-89f9-4cad-84e1-ea4d0fd566d5"
    },
    {
      "claim_cluster_id": "ea43c4dd-2096-4292-b914-5c467c6f33db",
      "event_cluster_id": "9054d5e2-4b4d-475e-9960-73215a5d44f4"
    },
    {
      "claim_cluster_id": "33f6801a-acda-4c2e-9708-cf1802dbdbb9",
      "event_cluster_id": "d6ce2176-c8b1-49b2-89e4-f0620f06cb63"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "4bee04c1-3125-4580-8ea5-cbdb4fd88ca9"
    },
    {
      "claim_cluster_id": "7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1",
      "event_cluster_id": "2a61add2-cedd-40b1-9edb-ca1cd948e8c9"
    },
    {
      "claim_cluster_id": "bfc6790e-9007-4b03-90bf-5da6fcce01b7",
      "event_cluster_id": "d47fde78-a16e-43e2-a490-d66e81b31f7c"
    },
    {
      "claim_cluster_id": "aa908c8f-4075-45ac-a932-631e5efec76c",
      "event_cluster_id": "5bdf6eac-3c30-44f7-ad10-121cdd88f987"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "f5798794-c4ea-4a9f-ad2e-0bf496c0ed12",
      "event_cluster_id": "d310e1f7-ee8b-4fed-be89-8b1baac91b0a"
    },
    {
      "claim_cluster_id": "17eaa25c-625f-4414-b1ad-78d904209f81",
      "event_cluster_id": "903c3f33-319a-4f0f-a3a0-b3ad86d56e86"
    },
    {
      "claim_cluster_id": "63fd0e17-6b29-4f19-b984-a861fba2eb14",
      "event_cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965"
    },
    {
      "claim_cluster_id": "b5aab15d-0623-4834-b9a0-c066e3616369",
      "event_cluster_id": "09cc9ddb-b9ec-4c5d-8b8e-25af134763fe"
    },
    {
      "claim_cluster_id": "f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f",
      "event_cluster_id": "121c0233-5b70-408f-8b70-e5ac0b37c748"
    },
    {
      "claim_cluster_id": "2712567d-2895-48f5-8695-f726eb795979",
      "event_cluster_id": "154bbf48-da4f-41b3-ba55-27ca50e6fa44"
    },
    {
      "claim_cluster_id": "d3913637-42d6-426c-8654-a13850b8306c",
      "event_cluster_id": "14a22666-bc11-493d-b981-1e91858f0777"
    },
    {
      "claim_cluster_id": "ad1e5e4c-10d0-4756-a4c9-29132a1c66dc",
      "event_cluster_id": "fdcc5ead-3f56-4e70-b1c1-bcb723b24f72"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "dcb6ab3b-ae6e-4735-8a60-de8d2d30332a"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "4fdaa1a3-7430-423b-81e3-be520cdd6936"
    },
    {
      "claim_cluster_id": "b1abd415-ce48-46da-b8bf-36f727bba7c7",
      "event_cluster_id": "193775cc-4b10-4b36-baba-844635425d37"
    },
    {
      "claim_cluster_id": "21c29f8c-34b7-47c4-8021-91ec84cff803",
      "event_cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7"
    },
    {
      "claim_cluster_id": "746179fc-962b-4500-916f-ca22a3a202d9",
      "event_cluster_id": "e0e1af6a-37f3-439c-b966-bdff95698e49"
    },
    {
      "claim_cluster_id": "49c94f1b-b278-42a0-b8b7-d0f8ec55d536",
      "event_cluster_id": "a51db09c-f39d-441d-9164-06ba998d58ef"
    },
    {
      "claim_cluster_id": "df20aee7-4e88-4c5d-a2d1-ce862c311713",
      "event_cluster_id": "27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"
    },
    {
      "claim_cluster_id": "634ebbc5-474d-42c0-bf34-498666dade49",
      "event_cluster_id": "f8620270-b25d-43a1-ab67-3efa1d1f6e6b"
    },
    {
      "claim_cluster_id": "48cca002-8003-45bd-92b2-3e2945a33b48",
      "event_cluster_id": "249e8c50-f68d-47af-99c9-2bc6ddfd52ad"
    },
    {
      "claim_cluster_id": "28feb358-2926-4cba-8425-f09fe5ebab7a",
      "event_cluster_id": "fd67a670-bb1f-429a-b83a-c92989f510e3"
    },
    {
      "claim_cluster_id": "48ac478a-0a47-432d-9d71-30bc821691af",
      "event_cluster_id": "6c9f4959-d341-4a88-80e2-4c73e592884c"
    },
    {
      "claim_cluster_id": "748c24aa-69c4-47c4-a75f-e6da7007b74a",
      "event_cluster_id": "4e97ff0c-8732-4960-b274-1090e77ec733"
    },
    {
      "claim_cluster_id": "85d98ed5-328a-4d59-91fb-32ddcf786d50",
      "event_cluster_id": "e10095d2-279b-4481-ac92-6fd4df698726"
    },
    {
      "claim_cluster_id": "cb357706-7b58-4396-aa24-1c59beae87fa",
      "event_cluster_id": "2ebae150-b502-48c5-b8c2-6a7238a86864"
    },
    {
      "claim_cluster_id": "54bf8eb2-6975-454f-a48b-59abffdfe4f4",
      "event_cluster_id": "9917626e-0afd-495f-82cd-6e27aa8cc73d"
    },
    {
      "claim_cluster_id": "99dfb4e4-9788-4ea5-81a7-c0dd44f60aba",
      "event_cluster_id": "76ca8734-57fa-4978-bce4-584836cb98e4"
    },
    {
      "claim_cluster_id": "63fd0e17-6b29-4f19-b984-a861fba2eb14",
      "event_cluster_id": "55326ca1-c9a2-4aca-a1ea-bd63160c25ea"
    },
    {
      "claim_cluster_id": "f74a80e3-1327-4636-a252-f4ca8a5b90f7",
      "event_cluster_id": "84fce8b4-ea2c-4b33-883a-03817afe99a2"
    },
    {
      "claim_cluster_id": "5a787097-c657-4d02-a7e7-ce5ddfe404d6",
      "event_cluster_id": "b1943af1-84eb-4734-88d0-58f88d216275"
    },
    {
      "claim_cluster_id": "6d226b20-d54f-48d2-bd7d-2616184afc68",
      "event_cluster_id": "b9073e54-b54f-4298-9384-944112b843d7"
    },
    {
      "claim_cluster_id": "de08eb08-92b3-4974-9e99-e79755582996",
      "event_cluster_id": "9c176d07-6751-4585-9c31-c558b96a7b39"
    },
    {
      "claim_cluster_id": "1ed92023-b891-43ab-ab0c-b464c243f2b0",
      "event_cluster_id": "914bd639-81ab-4467-a8c1-07b0f59b2871"
    },
    {
      "claim_cluster_id": "77de864b-c2fe-4a23-a506-d0665b0f08bf",
      "event_cluster_id": "5a9527b4-7ddf-4c5a-b860-67170fb02224"
    },
    {
      "claim_cluster_id": "d67b58dd-cbc9-4a99-aab7-b31e7a922343",
      "event_cluster_id": "4c1f4530-7a84-49d9-bd89-b51ceb8c5ce5"
    },
    {
      "claim_cluster_id": "464aaab3-50a7-44d6-8c7a-bdc722ee9f18",
      "event_cluster_id": "ce2516ca-003d-4806-948a-12eea340aa15"
    },
    {
      "claim_cluster_id": "fec0d44e-dff3-4478-9317-1b1d954f03c6",
      "event_cluster_id": "568dc264-fa77-45fb-8b1b-5c901f185f7a"
    },
    {
      "claim_cluster_id": "b6c282dd-0c14-4dab-a6ce-3f5caafc52b8",
      "event_cluster_id": "f11e573c-d0ea-44be-a8b4-5ff5949c0ecb"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "ba65859b-0b3d-4140-bf84-cf55b1252051"
    },
    {
      "claim_cluster_id": "589240bc-a0dc-4961-944a-a3594262e220",
      "event_cluster_id": "50f3c500-b81e-4af2-91c4-9121494d6350"
    },
    {
      "claim_cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
      "event_cluster_id": "5cc3d51d-5e99-492c-82ff-4024c6eb9503"
    },
    {
      "claim_cluster_id": "8a2e1f2c-6d19-479b-811f-3ccec4820a64",
      "event_cluster_id": "acf832a3-5be5-4fad-af20-2e71b7b538f5"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "9cacf170-b6e2-4913-a621-eaff66a64541"
    },
    {
      "claim_cluster_id": "4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d",
      "event_cluster_id": "32be984b-e9e5-4559-b00b-15885afc33b8"
    },
    {
      "claim_cluster_id": "d92fe55e-695c-457a-af52-c6044f0ca9ec",
      "event_cluster_id": "ff2e5690-b7e6-4963-9d4c-23d9e31d0e98"
    },
    {
      "claim_cluster_id": "0726cfa9-d89b-45b4-922f-553fde14346a",
      "event_cluster_id": "2bd0b47a-c8f5-4e58-b230-5a58686ed27d"
    },
    {
      "claim_cluster_id": "0a4b2521-caa9-4365-ba6f-ee42c89824c7",
      "event_cluster_id": "0a675e77-bb90-44f7-8297-ab44add96136"
    },
    {
      "claim_cluster_id": "d0619b32-28c7-4624-9e6b-8c81d9ff9019",
      "event_cluster_id": "dfb119a6-40b5-4824-8a20-9b636bd6f4b8"
    },
    {
      "claim_cluster_id": "612e1b04-721a-48bd-b18f-300c7c5af276",
      "event_cluster_id": "0b61ebc9-d9b1-4e5b-9094-6829b839c660"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "d7765332-5dba-4716-b432-1311de3172a6"
    },
    {
      "claim_cluster_id": "99dd456b-c805-4ebb-a82a-80fe2e06dff9",
      "event_cluster_id": "cef4b627-4828-4a00-9a55-7f92b9804c1f"
    },
    {
      "claim_cluster_id": "29009c7f-3a77-46aa-91c0-d0f703c52dab",
      "event_cluster_id": "718b8058-1e91-4465-aeff-7514749404e5"
    },
    {
      "claim_cluster_id": "7f7310ca-5512-45fa-8f93-1b6555e791c0",
      "event_cluster_id": "ea25dfa3-b506-4476-b1e0-0c164e97dea2"
    },
    {
      "claim_cluster_id": "dc464eb9-fc48-4646-8985-9de6d7531d3d",
      "event_cluster_id": "e6f89802-3df1-486d-8ad4-82cdb658549b"
    },
    {
      "claim_cluster_id": "c830c75d-93e2-4842-b468-b89a47252719",
      "event_cluster_id": "8b1769db-6aae-4f31-8eca-13c7641a8a79"
    },
    {
      "claim_cluster_id": "dc3308e5-2250-431f-bef6-733e2b943275",
      "event_cluster_id": "86c9a6a1-8859-49b1-869c-febe929feb9d"
    },
    {
      "claim_cluster_id": "de15f7d6-5167-45b1-bad6-235dd16ae15e",
      "event_cluster_id": "449fd6e4-9161-4742-8b9b-bd7cd0c9d571"
    },
    {
      "claim_cluster_id": "3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8",
      "event_cluster_id": "d419e57d-59b3-4e7e-beeb-1d52b9c76608"
    },
    {
      "claim_cluster_id": "d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3",
      "event_cluster_id": "96455f92-cde3-49f3-934d-a55b0a31ccd5"
    },
    {
      "claim_cluster_id": "1cbddfd6-c491-40b1-b10c-fd4387edddf6",
      "event_cluster_id": "de50b1b9-cb34-4bb1-b3ae-d6dc4e19797d"
    },
    {
      "claim_cluster_id": "469c5194-5b04-4e90-b62c-73b3f79a0955",
      "event_cluster_id": "cf59a1ef-ed9e-457e-802d-c83df70e42c0"
    },
    {
      "claim_cluster_id": "9dbb0955-d2fa-4dce-a46f-5ed43c9e3231",
      "event_cluster_id": "a1ec3b11-8549-44c4-b19b-7113d02a1c7e"
    },
    {
      "claim_cluster_id": "07bacc2e-cf13-4467-917c-ef3c2aa505ca",
      "event_cluster_id": "8b923490-b752-4fe2-9b0a-01c4a9d8d4b7"
    },
    {
      "claim_cluster_id": "71acf2d0-be7b-4d8e-b3fc-93baaa073aa1",
      "event_cluster_id": "9854342f-dc2f-4d81-9468-1aeed5b01c1c"
    },
    {
      "claim_cluster_id": "2d5d8472-462a-48f6-89fe-e8182a74e9c6",
      "event_cluster_id": "6773439f-27bf-46ee-884f-6f78667de502"
    },
    {
      "claim_cluster_id": "0a0436c8-54af-4b5e-9725-fc8ed172d1cc",
      "event_cluster_id": "7e444e77-337a-4bc6-8707-11c965b7d9dd"
    },
    {
      "claim_cluster_id": "d6f2cb3f-8705-43f8-a523-1b8fab745bf8",
      "event_cluster_id": "3ff9d247-61b1-4db1-b0eb-87ae85150e08"
    },
    {
      "claim_cluster_id": "729ff499-2dcf-4524-91fd-7e53fd6e6ad7",
      "event_cluster_id": "b6692507-59c3-458b-bc20-9fc0bbf648db"
    },
    {
      "claim_cluster_id": "d5ad62ab-dd96-48fa-a092-0724cb0c06f6",
      "event_cluster_id": "a13b9666-44db-4c37-94a0-689f377da92a"
    },
    {
      "claim_cluster_id": "bed08ef5-4cb1-4f05-b2d4-a996242acd93",
      "event_cluster_id": "823e369f-d264-405c-a8ab-0edf1095b0fc"
    },
    {
      "claim_cluster_id": "ff43bfb6-1ab6-422e-8045-756b71e70dd1",
      "event_cluster_id": "d56b27d7-daff-43e9-8fd0-8b6cd93b5536"
    },
    {
      "claim_cluster_id": "fe6adf14-e7af-49eb-8b83-de4001fbc495",
      "event_cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965"
    },
    {
      "claim_cluster_id": "35ff7a5e-40b8-42ad-9379-7ba830c9445f",
      "event_cluster_id": "cde4816a-67c9-4232-8144-e08a59a84d64"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "7b4680b9-9676-4736-8ed2-d06a2da6ea63"
    },
    {
      "claim_cluster_id": "e0a99d28-f3a4-477a-b874-8d839c4523f9",
      "event_cluster_id": "95cbf6a7-3664-47e9-8189-3ff3dc6eb96e"
    },
    {
      "claim_cluster_id": "d7cbd37c-10fd-4628-bba8-b434c41ec43f",
      "event_cluster_id": "39f8cdcf-5b14-42ea-aeb8-d3dfeff54bca"
    },
    {
      "claim_cluster_id": "bee4d72b-b159-4b6c-830c-362b42a2b18d",
      "event_cluster_id": "99266a9c-deac-4cbf-b039-93976c0d571b"
    },
    {
      "claim_cluster_id": "4a575d85-5f97-4baa-be78-2c26ecefb471",
      "event_cluster_id": "714c01ca-5d76-4ae8-b75a-06245aaab86c"
    },
    {
      "claim_cluster_id": "3198b672-2780-47ef-8885-73e8c5597d80",
      "event_cluster_id": "b8d995c0-360e-40c1-b216-5c539da3c67d"
    },
    {
      "claim_cluster_id": "36b91493-5f3f-412b-a861-2328c6420cc6",
      "event_cluster_id": "66399bf8-97ea-4b4e-aa54-9b68d82943d5"
    },
    {
      "claim_cluster_id": "f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb",
      "event_cluster_id": "5949d818-e369-4db8-949d-7a462c260498"
    },
    {
      "claim_cluster_id": "aef50142-8ad0-4099-9362-3d45c56385fc",
      "event_cluster_id": "ed6634c6-cfd9-4bcd-92a4-6a9685e6700a"
    },
    {
      "claim_cluster_id": "866c589b-e7dc-4cab-81ad-6d235278edf1",
      "event_cluster_id": "8eff5d20-7a2a-43cd-a95d-697a2eb3fa48"
    },
    {
      "claim_cluster_id": "7eff6a8d-9ae3-41f9-9ad2-cfcb191e7380",
      "event_cluster_id": "b69ad8c1-f3a2-41d7-805d-8cc01784789b"
    },
    {
      "claim_cluster_id": "1a853cc3-9e33-4539-b70a-cc51380d7526",
      "event_cluster_id": "769dd442-b312-4ca1-8bda-308188e59a4c"
    },
    {
      "claim_cluster_id": "1542a1c0-0498-4551-b3c6-794eb9ae6305",
      "event_cluster_id": "503d3ee0-00d1-464f-abcc-e8b8f12f26a4"
    },
    {
      "claim_cluster_id": "43e40d68-962f-4fc6-83f4-ab836f751e9e",
      "event_cluster_id": "752e0a5d-00fb-472d-909a-65284c58e6d5"
    },
    {
      "claim_cluster_id": "b6c851f0-a597-49e8-982b-650d02a8ba55",
      "event_cluster_id": "0133f004-4682-4cbf-aa32-305a065f5e30"
    },
    {
      "claim_cluster_id": "30d2edfa-6d58-40ae-bac6-ec1273c415ac",
      "event_cluster_id": "f6f5b331-ac46-4d22-8195-ed8a8b14d117"
    },
    {
      "claim_cluster_id": "d6c74194-ae1f-4099-a13b-0f247e76b288",
      "event_cluster_id": "e0229a55-a637-4111-a422-27c8a7ddb0b7"
    },
    {
      "claim_cluster_id": "fd424526-ed4e-4b80-99b4-1b131a22e381",
      "event_cluster_id": "67b88198-8628-4938-a751-4acddbc9098d"
    },
    {
      "claim_cluster_id": "d0323adb-673d-4daf-86e2-8d0f732fd9ed",
      "event_cluster_id": "b2700cb5-512c-44b4-a7d2-f6f79575e42a"
    },
    {
      "claim_cluster_id": "90cb536f-af14-4df1-9bdd-da6d690522b4",
      "event_cluster_id": "9dec00dd-14cf-4956-9ce0-5f9d8647e24d"
    },
    {
      "claim_cluster_id": "5767d0cf-3070-412a-9136-a29c287f15a1",
      "event_cluster_id": "cb297a6d-5ff4-4958-bec0-67e510f9e369"
    },
    {
      "claim_cluster_id": "f2df1c45-9507-438e-92d8-0a523b9a842a",
      "event_cluster_id": "d1aa87f5-6e8b-45d2-89ab-5267e8136707"
    },
    {
      "claim_cluster_id": "1c1848e6-9c28-4252-9e24-4dc5cb477be6",
      "event_cluster_id": "a1ee8def-adc3-431c-a4cf-3b3370e7d6e5"
    },
    {
      "claim_cluster_id": "df94ae50-99ca-4e54-802c-ae4f92bf2a1d",
      "event_cluster_id": "a2109d36-1708-4075-ac3d-fd40a7eea59b"
    },
    {
      "claim_cluster_id": "1574223b-5ec0-4588-8996-6510aa3052d6",
      "event_cluster_id": "acba4f1a-9129-40e6-80cc-1b3cb9b40341"
    },
    {
      "claim_cluster_id": "86ef5628-f267-4ce6-97b4-2f06bd91a5fa",
      "event_cluster_id": "4a33c4ea-c4b1-416d-9b76-df3e2b9c5ec9"
    },
    {
      "claim_cluster_id": "541a6555-c116-4473-b1ae-ac7c48578f3d",
      "event_cluster_id": "9132970a-f73a-4805-97b9-6e1d8581a3ef"
    },
    {
      "claim_cluster_id": "3073b261-2ceb-46c8-bad6-3808fb657e33",
      "event_cluster_id": "35b591b0-9a65-46c0-95aa-caf3b8dedd33"
    },
    {
      "claim_cluster_id": "7b578c6f-7be6-4c78-8bf3-3f66b6797db5",
      "event_cluster_id": "b4d1a337-88d8-4989-8d52-1a04d38e6e21"
    },
    {
      "claim_cluster_id": "ab829976-d7fb-4b30-9b92-89eed4e94cc4",
      "event_cluster_id": "fef1afb7-cb5b-46ac-9d94-a3b448d7fa82"
    },
    {
      "claim_cluster_id": "03b37d7e-0ed4-4014-ac24-a898719a8f87",
      "event_cluster_id": "2c1c9214-d791-4513-8352-ad5103d53749"
    },
    {
      "claim_cluster_id": "d602e1f1-5446-4c60-aadc-beabd56dedd8",
      "event_cluster_id": "5788deb7-8fce-4423-98fe-905a919278d0"
    },
    {
      "claim_cluster_id": "c6b3d942-ded2-4171-9d53-bf87a1b48b52",
      "event_cluster_id": "72aa7b94-9121-4289-8302-01ff0cfe298d"
    },
    {
      "claim_cluster_id": "aac18326-5af8-47ed-b7a7-209e78b29dfe",
      "event_cluster_id": "3ba6caab-43f9-4e86-aeca-830be9163573"
    },
    {
      "claim_cluster_id": "90ef35f7-8880-490a-bacc-f600f6a11162",
      "event_cluster_id": "ba73d786-afbd-4fff-a554-010d1e65a4dc"
    },
    {
      "claim_cluster_id": "6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4",
      "event_cluster_id": "0a822774-2208-4f62-a8c9-3dc70aeef8ea"
    },
    {
      "claim_cluster_id": "dd5d0634-bc30-45f9-b45a-97773c63db2a",
      "event_cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff"
    },
    {
      "claim_cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "event_cluster_id": "6e45b980-570a-489b-b31b-a504f6b1257e"
    },
    {
      "claim_cluster_id": "09505049-ee83-46bc-bc41-216c4501ccc0",
      "event_cluster_id": "be17c081-a4ac-42d9-b909-7a4f19b8160b"
    },
    {
      "claim_cluster_id": "3198b672-2780-47ef-8885-73e8c5597d80",
      "event_cluster_id": "a712c5f0-f65a-4cd7-abf6-1f0e442746d4"
    },
    {
      "claim_cluster_id": "f20e8a65-5412-4f81-81b6-1570f9619cbd",
      "event_cluster_id": "e6a2f428-c0e3-4756-a96f-639a0339b06c"
    },
    {
      "claim_cluster_id": "47fbc359-0497-4aac-8a4b-e63bd060a1e2",
      "event_cluster_id": "b6a2032e-1851-4e5a-bb1b-dbcd29c647ef"
    },
    {
      "claim_cluster_id": "b1da162a-fb28-4547-8fd8-715c5361b7af",
      "event_cluster_id": "df3f868f-20bc-4768-8496-fc1bc0744474"
    },
    {
      "claim_cluster_id": "5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa",
      "event_cluster_id": "faba4888-ade5-4854-a98b-43a187c3c84d"
    },
    {
      "claim_cluster_id": "0450cb4c-8816-4bbd-85b6-ac94ecde9af4",
      "event_cluster_id": "a1e41680-35e4-4649-8fd5-66b72c5b42b9"
    },
    {
      "claim_cluster_id": "32bf3674-86a6-4cde-a9e5-20a5e3965e02",
      "event_cluster_id": "120960ec-d747-4eeb-a10b-5a0b594f24f6"
    },
    {
      "claim_cluster_id": "8308c2eb-92cf-4ca4-876b-d1d947564441",
      "event_cluster_id": "7abc7765-0bd9-4361-a00a-d261cc270c4f"
    },
    {
      "claim_cluster_id": "232994db-dcd7-4db4-9ea3-fad6185233a7",
      "event_cluster_id": "c65c30a8-6203-4ff2-8126-866ddc1ad7ee"
    },
    {
      "claim_cluster_id": "8c18859c-7432-4cc4-af8f-8a5eb220876e",
      "event_cluster_id": "47a07292-bc3b-405d-8d76-2c61690495c1"
    },
    {
      "claim_cluster_id": "ff920ca0-1e39-41be-ac8f-cd0534048634",
      "event_cluster_id": "5dcaa7f9-db6c-4bc0-81d7-916cfd750a0f"
    },
    {
      "claim_cluster_id": "28e936b6-8a48-4d96-b4e6-7c0ff60a51fd",
      "event_cluster_id": "d3accedd-14e9-432e-a272-98af2dae3b98"
    },
    {
      "claim_cluster_id": "3da4f222-08f1-4864-8aa3-3576d8a64207",
      "event_cluster_id": "8b5f4d0a-57ca-4fb0-bc01-110872004685"
    },
    {
      "claim_cluster_id": "3d986dc9-6edc-4a4e-9783-63b1c5e7bcd8",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "fb95e7e0-9ac4-4fef-85ca-e17c4d83450d",
      "event_cluster_id": "49ec4675-cceb-45d5-bbb2-56483fcd1319"
    },
    {
      "claim_cluster_id": "02fc2c1c-e5e4-40d6-92bc-a975544e0e30",
      "event_cluster_id": "0ecafb9a-2141-4b23-a024-348c4e1719da"
    },
    {
      "claim_cluster_id": "aac18326-5af8-47ed-b7a7-209e78b29dfe",
      "event_cluster_id": "51d0514d-a16c-49e4-8ac6-e122e83a4777"
    },
    {
      "claim_cluster_id": "7b4db769-a456-496c-a3b6-6f242fdb7665",
      "event_cluster_id": "69563b87-ed4e-43d1-a693-c379aa9b1be9"
    },
    {
      "claim_cluster_id": "427b0ddc-d215-4989-8bcc-336ea7f1f9cd",
      "event_cluster_id": "c61c4f53-7efe-4e66-9392-b281164f47d2"
    },
    {
      "claim_cluster_id": "02e82f7d-c446-4fc6-9794-94910a46d2ac",
      "event_cluster_id": "f70d2311-4ede-4f3e-b4d9-bb1c5def4b48"
    },
    {
      "claim_cluster_id": "626c75be-9b85-4ac5-97e0-e03b79d0191e",
      "event_cluster_id": "3e73f675-0024-47f1-ab95-a4e974bdd22b"
    },
    {
      "claim_cluster_id": "8a60fc08-ff21-49d9-8858-dcff37e21d18",
      "event_cluster_id": "fc762eee-b8ab-4b1f-86f1-0e64c2a63eae"
    },
    {
      "claim_cluster_id": "e871839f-962c-43cf-a2f7-5ebaf26de0a1",
      "event_cluster_id": "0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3"
    },
    {
      "claim_cluster_id": "d6f2cb3f-8705-43f8-a523-1b8fab745bf8",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "e4f4246a-95d9-4d67-94bf-27725af4d71b",
      "event_cluster_id": "9707f2e5-6c57-41c7-a2b2-7fd6a30159c3"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"
    },
    {
      "claim_cluster_id": "6d7d1320-a896-4471-aa98-60a45946bc57",
      "event_cluster_id": "a0a3d302-3c42-4ec6-a980-2d9ce3d3fb0d"
    },
    {
      "claim_cluster_id": "2b132e72-8cc9-4107-a55f-19ac99e2caf3",
      "event_cluster_id": "10d521f9-b2ba-4e4d-ae1c-f8033a7f7147"
    },
    {
      "claim_cluster_id": "63ad18c0-00c0-4509-b669-2aff507b5502",
      "event_cluster_id": "e3336914-7a77-4548-8764-1fd25cd393fd"
    },
    {
      "claim_cluster_id": "e840acd4-9152-4039-820b-b347beaec131",
      "event_cluster_id": "49b59607-bcf5-4471-8809-4106f681d4d2"
    },
    {
      "claim_cluster_id": "5a77fa7e-06f0-487a-a93b-f15e590aa54a",
      "event_cluster_id": "5b79ee45-2abd-45a2-8873-e58d11466b36"
    },
    {
      "claim_cluster_id": "bc70c00b-dffe-4092-a775-4a9734094547",
      "event_cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"
    },
    {
      "claim_cluster_id": "fa361819-d60d-4532-8084-9c75390ba17c",
      "event_cluster_id": "9dc49f5f-af39-44e0-aabc-c941b43e1bd3"
    },
    {
      "claim_cluster_id": "3f85eb0b-4d61-4e44-8414-15ce2c9f03ad",
      "event_cluster_id": "b26ec24c-184f-463d-a8c5-4ef885956b1c"
    },
    {
      "claim_cluster_id": "3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8",
      "event_cluster_id": "0de6c083-ab7f-4e7e-b4a5-f3e13198d24d"
    },
    {
      "claim_cluster_id": "689e5dcf-938b-411b-9e5b-4de3aa6f026b",
      "event_cluster_id": "292fd491-c6f3-4ec8-80ae-030ae0db7baa"
    },
    {
      "claim_cluster_id": "9ffb85b8-5080-4f27-85ad-554406cf7402",
      "event_cluster_id": "5d65bb29-7381-44ed-8856-ec52d73d0a76"
    },
    {
      "claim_cluster_id": "aae7438c-bb2b-4e87-86b8-fc77cf6148d1",
      "event_cluster_id": "4e67b541-7502-4017-a45d-06f9dbc9f516"
    },
    {
      "claim_cluster_id": "245874be-060a-4ca6-afe3-3a367b00ddb5",
      "event_cluster_id": "b794c66a-ad77-44ca-8ddd-457a68feb34b"
    },
    {
      "claim_cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
      "event_cluster_id": "4b36afdb-64c0-4dfe-8f4d-501930c59107"
    },
    {
      "claim_cluster_id": "dd24c0fd-c274-4b3f-aabc-3dbac6784aa9",
      "event_cluster_id": "576d86b7-1d28-4f66-8319-eb34a892467d"
    },
    {
      "claim_cluster_id": "5ece0141-8dd6-405b-93cf-5585050f4efe",
      "event_cluster_id": "b379da86-fb9c-4026-92d2-37b07df028cc"
    },
    {
      "claim_cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "event_cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"
    },
    {
      "claim_cluster_id": "0626769d-4a42-43f4-8356-e89543f6dcc3",
      "event_cluster_id": "49854b0f-e263-4847-a942-d2497d0d1530"
    },
    {
      "claim_cluster_id": "5e3e9898-c954-4e10-be52-6e36f5b36c5c",
      "event_cluster_id": "a263e3cc-09b2-4ae5-a252-4665ad483b52"
    },
    {
      "claim_cluster_id": "24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "8a2e1f2c-6d19-479b-811f-3ccec4820a64",
      "event_cluster_id": "2e4008f0-4f9e-4c2e-bf84-cd19c2b3f87e"
    },
    {
      "claim_cluster_id": "a3a558f9-9b36-49bc-be77-b1d77d8074f6",
      "event_cluster_id": "f3e2df1f-8b35-4bab-b9e2-e82dc9f0ea1f"
    },
    {
      "claim_cluster_id": "cdfd2024-64ea-4945-8131-782266513caf",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "2762cfd3-48ae-4a0c-baf0-bfb36bcdff70",
      "event_cluster_id": "34a1b507-fb03-489f-a79e-be687aeaabe9"
    },
    {
      "claim_cluster_id": "06aec0e1-946f-46e8-835f-efac40b3f6dd",
      "event_cluster_id": "939d6808-ee32-41c3-8d70-73aed1d043da"
    },
    {
      "claim_cluster_id": "9012b6f3-2c16-482a-b276-63925d342482",
      "event_cluster_id": "7e14e717-108e-477a-a145-900678351362"
    },
    {
      "claim_cluster_id": "bbc8c147-b447-4af6-82fb-e416f6108e70",
      "event_cluster_id": "ddc05fce-b4da-4da7-88d2-dbf6d447379a"
    },
    {
      "claim_cluster_id": "24accb31-401b-42c1-bd69-e81c04cb2530",
      "event_cluster_id": "636b2daa-578a-4643-896b-342714f42b34"
    },
    {
      "claim_cluster_id": "c35d9889-06cc-4a13-8fea-d00c7024488b",
      "event_cluster_id": "18718c0f-4c28-4949-a369-9bfa7d8941c1"
    },
    {
      "claim_cluster_id": "eb38044c-3282-4492-916e-08a1ddd715ef",
      "event_cluster_id": "4f84ccb5-4935-4023-8826-9c08d0da261a"
    },
    {
      "claim_cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "event_cluster_id": "3595c0cd-b164-431e-b192-61bc7dc0019f"
    },
    {
      "claim_cluster_id": "1cffe038-9a46-45f7-bcc3-f26914315286",
      "event_cluster_id": "0ffb9af7-6a71-4266-a4bc-ddac4a179c1a"
    },
    {
      "claim_cluster_id": "5e0fea08-89fc-42fe-8906-484d762a1714",
      "event_cluster_id": "2c046222-ca9b-481d-9b9f-68e4ebbf303a"
    },
    {
      "claim_cluster_id": "3786df1e-47ff-4916-973b-ccf57ccb5e4c",
      "event_cluster_id": "84599781-5c1d-4670-83ce-2909c7c1b4c9"
    },
    {
      "claim_cluster_id": "b840591d-33a5-402e-9f7a-8913292b283e",
      "event_cluster_id": "abfe0416-9747-4ab8-9cdc-8e88fa47871d"
    },
    {
      "claim_cluster_id": "9df4486f-c8aa-4f08-a8cd-4ae02c748318",
      "event_cluster_id": "2bfeada4-b9e0-40b4-9be2-0655b8d49226"
    },
    {
      "claim_cluster_id": "7c2161be-91e7-4c74-9f49-fb997b3c5857",
      "event_cluster_id": "c4974eac-c8ce-4c10-a509-e1191979432a"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"
    },
    {
      "claim_cluster_id": "232994db-dcd7-4db4-9ea3-fad6185233a7",
      "event_cluster_id": "b4e6a6dd-1e51-4a7f-a1bb-cfc861598a03"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "7ef0f102-5c71-4651-96e9-1923d9bd80c5"
    },
    {
      "claim_cluster_id": "b26a4469-2931-4dab-aa78-be1b6fba8a36",
      "event_cluster_id": "a0c6e4b4-7d8c-425c-8ff1-2b999fb65fda"
    },
    {
      "claim_cluster_id": "09907625-9889-4def-8ff5-b61d82ce4a21",
      "event_cluster_id": "0791917d-ce61-4b44-9705-c74efbd95241"
    },
    {
      "claim_cluster_id": "fb95e7e0-9ac4-4fef-85ca-e17c4d83450d",
      "event_cluster_id": "dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82"
    },
    {
      "claim_cluster_id": "3dcf8216-5e70-4cd4-962e-dc4b036a0071",
      "event_cluster_id": "e0151ccd-baed-452a-aaa4-6feaeeadc3d9"
    },
    {
      "claim_cluster_id": "636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd",
      "event_cluster_id": "fe89ddfd-a999-4814-9bd3-b0162af3bbe2"
    },
    {
      "claim_cluster_id": "3d1d7e4c-d40b-4ec4-9450-9fc635a45afd",
      "event_cluster_id": "70ddc119-0fe5-44bb-b12a-5f9fe097cd8c"
    },
    {
      "claim_cluster_id": "565a8eff-d3c3-4887-a42a-b357e222a101",
      "event_cluster_id": "0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"
    },
    {
      "claim_cluster_id": "2b77fdbc-c4ed-4e0c-99a3-6dbf568aa8a5",
      "event_cluster_id": "f74c2283-95c8-409c-8db8-ce070f2c2a45"
    },
    {
      "claim_cluster_id": "b865573b-6b72-46cd-b3c0-a1458e7df010",
      "event_cluster_id": "5a9527b4-7ddf-4c5a-b860-67170fb02224"
    },
    {
      "claim_cluster_id": "1e19ebda-0ce5-4c42-b6ac-f081acdf5974",
      "event_cluster_id": "90594f77-57da-4d80-a85e-ef6c61b0cc03"
    },
    {
      "claim_cluster_id": "6d12ca3e-2e36-40ab-9cf4-0663df64745d",
      "event_cluster_id": "f859d7dc-7168-48cd-becb-1199652aaa89"
    },
    {
      "claim_cluster_id": "88c2038a-24a0-497f-bac0-84ee519d160d",
      "event_cluster_id": "ff6b17a5-2973-4397-8f78-b44bc6fa5365"
    },
    {
      "claim_cluster_id": "53bc38bf-651d-46ea-8aaf-f63f52195a45",
      "event_cluster_id": "83b65fa9-1a4b-4243-9c39-2ff350a46323"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "3035cab4-7bf7-4e5f-b8ff-717930d9caf2"
    },
    {
      "claim_cluster_id": "3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9",
      "event_cluster_id": "a8ce1bca-58fe-42ba-8464-607d5c5b57e3"
    },
    {
      "claim_cluster_id": "865d4451-2942-47ff-84cb-46ee2b23dc46",
      "event_cluster_id": "a548b0a4-9a63-47ec-a6ab-6b9d50ab7aaf"
    },
    {
      "claim_cluster_id": "746085cd-6635-459a-8b25-138f4d67d9dc",
      "event_cluster_id": "241d256c-86d7-484e-8aee-4f2f15316b3d"
    },
    {
      "claim_cluster_id": "af503db6-fcf4-45f9-9501-f2732e2af4f7",
      "event_cluster_id": "72ffc77d-60b8-420d-8327-cb12019a9c56"
    },
    {
      "claim_cluster_id": "12ce4240-07a8-40e1-acc7-141144ad6c5d",
      "event_cluster_id": "83578f15-2ee2-4dd4-ae7f-b543ba5e2a87"
    },
    {
      "claim_cluster_id": "8f0344d2-3a73-4534-aa04-5391b7670e72",
      "event_cluster_id": "48334cb3-0717-4823-bc81-52cb1f9c2951"
    },
    {
      "claim_cluster_id": "1e19ebda-0ce5-4c42-b6ac-f081acdf5974",
      "event_cluster_id": "ccffcdf7-168a-480f-bc2b-31955c7b549e"
    },
    {
      "claim_cluster_id": "4c161c1e-d86e-4fbd-9e49-e99d43b2eedc",
      "event_cluster_id": "d44ce227-03db-4ccf-be04-d057a22464a7"
    },
    {
      "claim_cluster_id": "a4d61819-30e3-46aa-ab08-cf879db00de1",
      "event_cluster_id": "5f74295c-f7d9-45d9-bee0-05eb4d5113bf"
    },
    {
      "claim_cluster_id": "1f8ca860-66b4-4b57-a63c-e13332662c2e",
      "event_cluster_id": "3474c474-7d6c-491a-9b70-d72c3c7f2f0d"
    },
    {
      "claim_cluster_id": "eb38044c-3282-4492-916e-08a1ddd715ef",
      "event_cluster_id": "32aeada3-2c0a-4dd6-b828-1733cea88e6b"
    },
    {
      "claim_cluster_id": "c68ce84b-91a0-4925-97f3-1ea49e062e4b",
      "event_cluster_id": "f58ab9e3-79cd-49da-af02-2a9f2fdeec8f"
    },
    {
      "claim_cluster_id": "ce4379b5-864c-4150-b826-c6825e39d887",
      "event_cluster_id": "f67a1af7-61f9-40c0-beb8-34c87a985d6d"
    },
    {
      "claim_cluster_id": "66e9edc1-c40b-47a3-96e9-eebc44c63b9c",
      "event_cluster_id": "1dd73410-26d1-4ffe-8c70-64b5d5bf9994"
    },
    {
      "claim_cluster_id": "cbbb2109-39b9-4308-a4ce-30a48563cab7",
      "event_cluster_id": "78ea610b-38fc-4528-87fe-af950e4ad514"
    },
    {
      "claim_cluster_id": "1be65d4d-c915-41d3-9d1c-864035425656",
      "event_cluster_id": "353c6f78-8367-418a-a322-9feedaea3f81"
    },
    {
      "claim_cluster_id": "3073b261-2ceb-46c8-bad6-3808fb657e33",
      "event_cluster_id": "49ea9af0-b84c-4f28-8cc0-a1e13e95b4c4"
    },
    {
      "claim_cluster_id": "902f069d-3703-489a-9dfa-fb26ee837027",
      "event_cluster_id": "887d717e-5da6-4cf6-995c-bcee081cd128"
    },
    {
      "claim_cluster_id": "bdecd7b0-3449-4d8c-9710-468d872a6514",
      "event_cluster_id": "cef4b627-4828-4a00-9a55-7f92b9804c1f"
    },
    {
      "claim_cluster_id": "58b4a566-79d9-4559-809f-ffd9a84468b4",
      "event_cluster_id": "32516088-d496-4b04-a09c-540561be5921"
    },
    {
      "claim_cluster_id": "f97e4f6c-a73e-4c35-8e7a-51a335141d67",
      "event_cluster_id": "72e8eae4-0f40-4ffb-9af3-05384f47f8b8"
    },
    {
      "claim_cluster_id": "df94ae50-99ca-4e54-802c-ae4f92bf2a1d",
      "event_cluster_id": "bbc52822-dc9f-42d5-a92f-f6eef341a6a2"
    },
    {
      "claim_cluster_id": "1c1848e6-9c28-4252-9e24-4dc5cb477be6",
      "event_cluster_id": "754365fe-ff15-423c-803b-8363cd1da39c"
    },
    {
      "claim_cluster_id": "e64bcf93-086e-429d-9ff7-3a1518b3ae51",
      "event_cluster_id": "e353033e-612f-444b-a7df-06c23368eb22"
    },
    {
      "claim_cluster_id": "ec868d12-f24d-450d-bca9-2e8a9f4e8021",
      "event_cluster_id": "1396142d-5fd2-4c3f-8a9f-e0d1627fb926"
    },
    {
      "claim_cluster_id": "bcc578f8-a745-46e1-ac64-5315a3ec6900",
      "event_cluster_id": "7e23b4ba-cb72-4329-9b5e-d475d9898055"
    },
    {
      "claim_cluster_id": "ab52850c-7dc5-4f99-b37e-0c628b078043",
      "event_cluster_id": "954829b5-b0de-40ec-a999-143a5f855d8b"
    },
    {
      "claim_cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "event_cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"
    },
    {
      "claim_cluster_id": "f10ad797-ad79-4629-861d-4af809502a09",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "13470ac2-b4c3-4aff-aa6a-418a5222958e",
      "event_cluster_id": "f61ff023-8da9-4963-951e-7e62c4121c8c"
    },
    {
      "claim_cluster_id": "61fe3afa-76aa-4838-9dd9-a22a879ae31e",
      "event_cluster_id": "95af035b-c14e-4753-b211-c4a8a4ddbdf2"
    },
    {
      "claim_cluster_id": "02f58db8-b951-46f8-9ff7-76980a66fc66",
      "event_cluster_id": "ab91862c-85f4-4041-ad6f-31e79b4bc25f"
    },
    {
      "claim_cluster_id": "503584d7-75a5-4f03-adb1-4844dd4d9b9f",
      "event_cluster_id": "4005f43b-5b4a-44f8-9781-c0a91127368f"
    },
    {
      "claim_cluster_id": "327aebea-facc-4b65-a419-a9d461f7aa0f",
      "event_cluster_id": "72addbc1-127b-4a33-b16b-7a7f76d03f32"
    },
    {
      "claim_cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "event_cluster_id": "2ff5212c-713e-4d80-b0b9-c7f306cf69fb"
    },
    {
      "claim_cluster_id": "5736135c-d235-4604-8803-ae7412cb8825",
      "event_cluster_id": "c5229738-f89d-48b1-b153-7dc0f6aabc53"
    },
    {
      "claim_cluster_id": "eb38044c-3282-4492-916e-08a1ddd715ef",
      "event_cluster_id": "71cb88c3-3bc3-4a98-bd39-7a91efe626a8"
    },
    {
      "claim_cluster_id": "45931062-6efb-4850-9df7-4bff0b9b4a16",
      "event_cluster_id": "2c4ce8c0-6662-4508-bebd-0134d7b84392"
    },
    {
      "claim_cluster_id": "3d44d914-cf73-4d8b-b531-5db2be83da48",
      "event_cluster_id": "10b1c2ee-a471-4366-9850-b2056c01cf79"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "9a157342-1d61-41a4-92fb-020ea95697bc"
    },
    {
      "claim_cluster_id": "df6be9b1-2675-4ecd-8158-a77b9f4c36c7",
      "event_cluster_id": "f1bddab0-3986-4a79-a51e-8622615c23c4"
    },
    {
      "claim_cluster_id": "9edb82af-1afe-4fbd-8da5-3bc280a95c94",
      "event_cluster_id": "1758ed2e-dc14-4881-941e-3bd76c244d71"
    },
    {
      "claim_cluster_id": "ebad899d-9cc8-49e0-a908-87f53dd79063",
      "event_cluster_id": "01388d43-fe04-46e8-a137-ee7f321c4ae8"
    },
    {
      "claim_cluster_id": "501b66f7-8e87-4810-b05d-6bb95d09a79e",
      "event_cluster_id": "5ca3c47d-e454-491e-8306-a8bcab9a1429"
    },
    {
      "claim_cluster_id": "865d4451-2942-47ff-84cb-46ee2b23dc46",
      "event_cluster_id": "2de6bb89-87af-41d9-9f6e-654985194064"
    },
    {
      "claim_cluster_id": "749b3ec0-39f9-4e3b-bcf2-7f9377d72178",
      "event_cluster_id": "464e7bbb-1cb4-45e2-a510-f3dbf3edebfc"
    },
    {
      "claim_cluster_id": "d8704200-daac-4e95-873c-20cc39771b1c",
      "event_cluster_id": "fb3f730b-85cb-44b0-976b-06ca14bb8acb"
    },
    {
      "claim_cluster_id": "c46be245-9f63-495f-be19-e522e39c13f9",
      "event_cluster_id": "1eac9457-d9a9-4ee2-b922-a850e04ccef6"
    },
    {
      "claim_cluster_id": "61b758fd-ce2c-4502-b494-9618880e66e4",
      "event_cluster_id": "519bca7c-733d-466e-b332-2cb930d5c9b0"
    },
    {
      "claim_cluster_id": "e53d664b-c538-43f3-a025-7686ca315f8a",
      "event_cluster_id": "acddf1eb-d6f9-4c70-9523-034fc5a8acd5"
    },
    {
      "claim_cluster_id": "90ef35f7-8880-490a-bacc-f600f6a11162",
      "event_cluster_id": "1737c28c-8f31-4855-8951-9dd1dd0b8606"
    },
    {
      "claim_cluster_id": "59bf3043-2eaa-48fb-880e-613249cbd976",
      "event_cluster_id": "8c0047bf-e6f3-48a4-98c1-a7a466922ed8"
    },
    {
      "claim_cluster_id": "29fe240a-81f6-4aef-a8b5-3cacf3e3985a",
      "event_cluster_id": "2528bd46-af3f-4f9d-8f91-2dbf49b3388e"
    },
    {
      "claim_cluster_id": "c90c00dc-2c77-42ad-bb5e-2666e53e2bcd",
      "event_cluster_id": "c9f98636-16e1-43ce-a03d-d6e0e40dfac6"
    },
    {
      "claim_cluster_id": "f9c980a9-33b9-4834-922a-947a13f5a035",
      "event_cluster_id": "1238fc85-6b69-4536-a793-8df12f63f9c0"
    },
    {
      "claim_cluster_id": "62fbb5b2-0ba7-4211-b72a-eb1c18543408",
      "event_cluster_id": "6ff9b10a-54cf-4a58-8655-1ec5ccd1ae56"
    },
    {
      "claim_cluster_id": "0c398c2c-4672-4f1e-ba98-17d7320a9537",
      "event_cluster_id": "f9418d59-cbad-4bcd-b387-fb25a67389fd"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "b14c3761-a874-48e7-9fb8-15aebb4dd009"
    },
    {
      "claim_cluster_id": "d017f7be-45ae-4ae5-b72e-a6e53f0a589b",
      "event_cluster_id": "78fb23f3-7fa7-436d-840c-3f1376d6f22b"
    },
    {
      "claim_cluster_id": "de4f148f-cf69-426b-b5bb-f722fb88313c",
      "event_cluster_id": "6b61dc7f-0dcc-4798-86a9-dfa23b5c3897"
    },
    {
      "claim_cluster_id": "773a0c25-df3d-4865-86dd-a73825ed69b0",
      "event_cluster_id": "1b2a4f9c-8284-4418-843c-06b19834c251"
    },
    {
      "claim_cluster_id": "e2676bcb-4f6e-4d98-ba58-3d2aff04d940",
      "event_cluster_id": "6ebfced0-5146-4720-a35b-6dac63f2989a"
    },
    {
      "claim_cluster_id": "db5fd0e4-cf0a-4e94-a4a2-d71a9c25184f",
      "event_cluster_id": "9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"
    },
    {
      "claim_cluster_id": "784725f9-7f56-4fd8-bbd1-9c94d01f5505",
      "event_cluster_id": "51a5661a-48dd-44af-9a97-7d7620877cc6"
    },
    {
      "claim_cluster_id": "f46e8240-2cb3-437d-9e2e-c04f6db7a813",
      "event_cluster_id": "db605ad9-a4d6-40a9-abcb-d200ca16a403"
    },
    {
      "claim_cluster_id": "22c13a77-51bd-41df-afeb-444adbde288e",
      "event_cluster_id": "6e4a0e8e-51f9-46ed-8b84-bcdeb86a6f8d"
    },
    {
      "claim_cluster_id": "4f331c05-6fa5-4bd8-adc2-5458e8c80843",
      "event_cluster_id": "d6133b17-e010-4dda-908f-2aa315f15880"
    },
    {
      "claim_cluster_id": "0fc06cfb-3a25-4176-a530-ab9cb52f7632",
      "event_cluster_id": "38dc9a30-7314-4720-8e2e-f17990947602"
    },
    {
      "claim_cluster_id": "33a57504-12fb-4d65-b0de-90b983174e92",
      "event_cluster_id": "ab0be659-cfc3-42d5-b3a3-1d1264ed5cd9"
    },
    {
      "claim_cluster_id": "166b6595-ba80-4fe0-a5a2-70307703e855",
      "event_cluster_id": "e614332a-840b-4b45-8ec4-5184a874c6a8"
    },
    {
      "claim_cluster_id": "f2096782-318f-42d5-a553-560f508e5016",
      "event_cluster_id": "abca71f2-b0b7-497b-b1ed-9f04c6ea4023"
    },
    {
      "claim_cluster_id": "9477ce9c-5a6e-4e61-9f13-cf68c95b219f",
      "event_cluster_id": "51c627ea-61b3-4175-b1c6-64a2c7928bc9"
    },
    {
      "claim_cluster_id": "327aebea-facc-4b65-a419-a9d461f7aa0f",
      "event_cluster_id": "753c254f-8be9-4b92-b7c7-e32c2713d3c8"
    },
    {
      "claim_cluster_id": "06aec0e1-946f-46e8-835f-efac40b3f6dd",
      "event_cluster_id": "8817a4d0-4aef-4c0e-a907-ff92179dff0d"
    },
    {
      "claim_cluster_id": "5e128621-af42-4a93-b091-b4e768efec3b",
      "event_cluster_id": "f82b2292-d2a6-46b2-8f35-b645fd7735eb"
    },
    {
      "claim_cluster_id": "eea02be7-fd53-47b5-9804-7a2f89de23f2",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "3ca56034-eb2b-4824-906e-24d9da4948a3",
      "event_cluster_id": "6cf816f8-e003-42cf-8cf6-67f77f267b93"
    },
    {
      "claim_cluster_id": "3d44d914-cf73-4d8b-b531-5db2be83da48",
      "event_cluster_id": "6e37e2a5-095e-47b2-8aff-f3c2136725ea"
    },
    {
      "claim_cluster_id": "b0b87d24-5072-4ac7-bf9b-5891dbcddd35",
      "event_cluster_id": "6a2c5b98-767a-485d-a14c-04f05f90984c"
    },
    {
      "claim_cluster_id": "755e1910-15d6-4530-b0f7-b73a35ac9c64",
      "event_cluster_id": "1d986f8d-82e7-4918-bcdd-07f2b4e2658d"
    },
    {
      "claim_cluster_id": "11c93b57-586c-4cef-a254-66245b297aca",
      "event_cluster_id": "03cfca2c-7423-4384-8df2-7f88d1994030"
    },
    {
      "claim_cluster_id": "2e620f14-db3f-4f94-9e90-7ae11cf68067",
      "event_cluster_id": "a4f84d58-e9f3-4a41-a8f9-b81736f1cea9"
    },
    {
      "claim_cluster_id": "f8c898ca-36a7-47ac-838a-8091321433d0",
      "event_cluster_id": "ac20790a-e28e-426a-9c7b-f5ecf7b0aefc"
    },
    {
      "claim_cluster_id": "e840acd4-9152-4039-820b-b347beaec131",
      "event_cluster_id": "bcac4aab-9cd8-4923-b998-bd470cb7fa0f"
    },
    {
      "claim_cluster_id": "6015f261-315c-43b5-ae1a-b6f1ad2e1ce6",
      "event_cluster_id": "32ad70e2-6724-4b9a-a0c3-bd70b56126d0"
    },
    {
      "claim_cluster_id": "c7eb5329-6775-4d3f-aea7-7de4fbeb8175",
      "event_cluster_id": "76382e4c-a4a2-4fb5-bc4f-138c970156c3"
    },
    {
      "claim_cluster_id": "97e04a01-6626-4196-a12d-eac1df348581",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "3b7e3ce4-4e60-4c09-986c-9b9376d80c8a",
      "event_cluster_id": "69fc5164-f4a0-47bb-853d-0382d8d5f3c1"
    },
    {
      "claim_cluster_id": "5c890164-2642-4556-87d3-c7dbbd1d4d78",
      "event_cluster_id": "5993beab-a3f3-40b3-9d6d-5a8cd60d5eb3"
    },
    {
      "claim_cluster_id": "0961c365-4261-4c91-984b-81c62260d807",
      "event_cluster_id": "a305ffe3-19c3-481a-9058-4247bca4ca01"
    },
    {
      "claim_cluster_id": "a8dc28b0-9676-46fe-a3b7-8eb8e563deb8",
      "event_cluster_id": "40e574c7-e1d8-4cc8-a46a-a5e8d1efd793"
    },
    {
      "claim_cluster_id": "3eac5298-75f1-4e1e-94ec-db408d17729a",
      "event_cluster_id": "21518841-2c46-4292-abad-aff342a4f1ac"
    },
    {
      "claim_cluster_id": "d86ea948-08a0-4829-9e48-4f9273b2967d",
      "event_cluster_id": "1bb3c826-37ca-4435-8ad2-e211e6cd9444"
    },
    {
      "claim_cluster_id": "469c5194-5b04-4e90-b62c-73b3f79a0955",
      "event_cluster_id": "44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"
    },
    {
      "claim_cluster_id": "4bc5d44b-029d-49ff-82cb-bbcd84067673",
      "event_cluster_id": "67171e62-bbfa-470a-8469-52d1b51665da"
    },
    {
      "claim_cluster_id": "c2350485-f95c-46d4-9b92-6355ceca86df",
      "event_cluster_id": "38dbd9f2-4706-4ca9-a837-817a4ee621f8"
    },
    {
      "claim_cluster_id": "3bc352c0-0d5e-42f4-ad88-e7f025e20e88",
      "event_cluster_id": "1bbcb23d-9835-462a-b09f-6a4c89faa361"
    },
    {
      "claim_cluster_id": "294d0346-cddf-4b1e-a6bc-ab4686137712",
      "event_cluster_id": "241266d3-592d-42ac-9327-a8fa3d3a1448"
    },
    {
      "claim_cluster_id": "bde9febe-9a28-4f0f-b67c-15f9a243538b",
      "event_cluster_id": "8f6bcfb4-e69d-470b-bf79-44df803a0002"
    },
    {
      "claim_cluster_id": "da4ff089-352e-46ec-bdf8-8e7b8cd2001b",
      "event_cluster_id": "379a52a5-17ca-4b52-8aeb-4f7076fdca3c"
    },
    {
      "claim_cluster_id": "255ea174-3e00-4506-8a6d-78f62eccfecc",
      "event_cluster_id": "8c98812a-8a38-46cf-a002-b105988964fa"
    },
    {
      "claim_cluster_id": "5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6",
      "event_cluster_id": "6c1c53f7-282d-4c0c-a8d8-dac0c8af5a96"
    },
    {
      "claim_cluster_id": "0f733538-ef56-427f-ad23-04cb6fae87ae",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "7f7310ca-5512-45fa-8f93-1b6555e791c0",
      "event_cluster_id": "a8171dc6-d1e7-4f00-80c9-a3281fe32c93"
    },
    {
      "claim_cluster_id": "762409bf-96e2-43cc-99d8-45783ade1b1f",
      "event_cluster_id": "a8453d8d-d762-45e8-9fae-f6302e301be0"
    },
    {
      "claim_cluster_id": "a8c6b9dc-b961-4a1b-bb6d-3aff208b396f",
      "event_cluster_id": "763d8e8c-b156-404c-ae43-97e544b0ec16"
    },
    {
      "claim_cluster_id": "d0228864-78be-4fd7-94b7-908de0276e80",
      "event_cluster_id": "6030a19b-208f-4624-83fa-f8e8a264fea6"
    },
    {
      "claim_cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "event_cluster_id": "b7e82711-b99a-4580-8fb1-a7b6465b462b"
    },
    {
      "claim_cluster_id": "ab0a6f16-1446-472c-af45-f55c0d8ddc3c",
      "event_cluster_id": "b99d5f24-fa76-453e-adeb-2b0a207bd3de"
    },
    {
      "claim_cluster_id": "589240bc-a0dc-4961-944a-a3594262e220",
      "event_cluster_id": "75cc70a1-5be7-40b5-9ce1-1497b1ba2474"
    },
    {
      "claim_cluster_id": "8a4b9d30-600b-48dd-9a32-934835947825",
      "event_cluster_id": "b4d1a337-88d8-4989-8d52-1a04d38e6e21"
    },
    {
      "claim_cluster_id": "b7190356-8b3c-4107-b9f7-680aa8b73b90",
      "event_cluster_id": "c6098f7c-9ca7-42cb-9f44-6b467087e324"
    },
    {
      "claim_cluster_id": "69315435-638a-4ef2-abe8-1d91d23ff51a",
      "event_cluster_id": "f5c0430d-6c19-4e4b-815d-7de708ba52a8"
    },
    {
      "claim_cluster_id": "f9eb0f13-3691-4b5d-b326-0456c31b4402",
      "event_cluster_id": "21c8abd4-e2f1-498b-ac7c-3e0c279db5b8"
    },
    {
      "claim_cluster_id": "bbad87a2-fdaf-4bdc-9b37-124a381131af",
      "event_cluster_id": "58d84750-75e5-4a06-9053-f1a5a8baf564"
    },
    {
      "claim_cluster_id": "721fca95-63af-4a1d-bae5-70b55fce9a8b",
      "event_cluster_id": "2a492648-efc4-44a2-9eee-4d95d05d104b"
    },
    {
      "claim_cluster_id": "35ff7a5e-40b8-42ad-9379-7ba830c9445f",
      "event_cluster_id": "8a9e9225-8d82-4d0e-ab43-4f387b7b1105"
    },
    {
      "claim_cluster_id": "e0b76993-43d7-4b38-b891-9ad858a2c5f6",
      "event_cluster_id": "25ed23a4-7940-477a-9165-7053b4f9330d"
    },
    {
      "claim_cluster_id": "6f9b01a7-d717-4ce1-bd54-f5647d476287",
      "event_cluster_id": "46187cfd-07e9-43ce-ade9-ed6a220120f1"
    },
    {
      "claim_cluster_id": "f982ead8-4101-46e5-9a29-b95c416ed470",
      "event_cluster_id": "c7b0f267-0192-4ba8-86e6-09f6ba274d4f"
    },
    {
      "claim_cluster_id": "02e0cfd6-814a-4276-b8cf-66540b7686e7",
      "event_cluster_id": "5a60b1ad-2d21-44bf-9788-e9579de25e42"
    },
    {
      "claim_cluster_id": "800c3c00-df13-4716-b553-f1b7480d22b7",
      "event_cluster_id": "21be5a19-a4c5-4da5-a267-9d6169f7d6f0"
    },
    {
      "claim_cluster_id": "990aca8f-a2db-4ebd-85da-744c488a8d2b",
      "event_cluster_id": "8f6bcfb4-e69d-470b-bf79-44df803a0002"
    },
    {
      "claim_cluster_id": "c17fd8aa-8336-4796-9c7d-a192509f6809",
      "event_cluster_id": "d342ed30-fc56-4887-9c80-98861f47054d"
    },
    {
      "claim_cluster_id": "ddbc1aa3-6d67-4148-96a1-e149d5d02260",
      "event_cluster_id": "31091b5e-03e8-4b81-8a6c-9a3d02b0c681"
    },
    {
      "claim_cluster_id": "c462838a-420c-4b5a-ad06-676939effe93",
      "event_cluster_id": "be4d477c-befe-4014-a5ff-185b3c58e5d5"
    },
    {
      "claim_cluster_id": "616e962d-58a9-42e5-9a6d-decd8139ddf7",
      "event_cluster_id": "cb0a8f38-8b40-4637-bdbf-1d9a5a12407f"
    },
    {
      "claim_cluster_id": "f9f7a124-b259-44e6-a922-abc880fe6775",
      "event_cluster_id": "01196e0c-7fc3-4e40-8d9d-fcbcee3103a1"
    },
    {
      "claim_cluster_id": "4bc5d44b-029d-49ff-82cb-bbcd84067673",
      "event_cluster_id": "f29558d0-0635-4b49-8d22-a3cce142124f"
    },
    {
      "claim_cluster_id": "09c923c5-0d10-40d6-8825-821711e43905",
      "event_cluster_id": "2a492648-efc4-44a2-9eee-4d95d05d104b"
    },
    {
      "claim_cluster_id": "075f7aea-756f-4e67-bf46-f4305230821b",
      "event_cluster_id": "447c9e43-212c-427e-bbf7-d86cadb216eb"
    },
    {
      "claim_cluster_id": "02e7a900-bce3-4812-8137-1246791846bb",
      "event_cluster_id": "a5ca0f47-c2ad-4e2d-8414-673ee9a9e57d"
    },
    {
      "claim_cluster_id": "cc6a9454-14fd-45d5-b472-64ca4fedbe80",
      "event_cluster_id": "3f8c1bc5-ffc2-4f3c-9751-015716600af2"
    },
    {
      "claim_cluster_id": "56dc9727-1db9-4dc8-acf2-c70b7f101883",
      "event_cluster_id": "81907f87-685a-467f-b4fe-172f6390378d"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "0cd50f6d-7e09-46ef-815c-37b05bef94d0",
      "event_cluster_id": "bc907223-19f6-4c59-ade2-142b6a28be4c"
    },
    {
      "claim_cluster_id": "d14315a8-aa93-4c64-a42e-a4307dd0814a",
      "event_cluster_id": "841f304f-f4f1-471e-aa1e-5c0818b42f86"
    },
    {
      "claim_cluster_id": "61ed0aed-dc5b-413d-8a18-4362324862cc",
      "event_cluster_id": "3ff7a6c9-67a4-434c-ba42-8e735f72fd34"
    },
    {
      "claim_cluster_id": "de15f7d6-5167-45b1-bad6-235dd16ae15e",
      "event_cluster_id": "1737c28c-8f31-4855-8951-9dd1dd0b8606"
    },
    {
      "claim_cluster_id": "698d5e91-6aba-4224-9583-f0b9f9330723",
      "event_cluster_id": "7b5742e3-5955-46ac-9086-6f1852e5681c"
    },
    {
      "claim_cluster_id": "0fde95b6-db57-45cd-b6ac-fb0edd1b186b",
      "event_cluster_id": "3a969b37-0ab9-41ab-b145-dd3f362c8638"
    },
    {
      "claim_cluster_id": "c6b3d942-ded2-4171-9d53-bf87a1b48b52",
      "event_cluster_id": "9ebf6405-2d25-40bf-a1c7-48615c2b0e1d"
    },
    {
      "claim_cluster_id": "9edb82af-1afe-4fbd-8da5-3bc280a95c94",
      "event_cluster_id": "ab43ecb5-72cd-4cd0-9f6f-d31ca04720f7"
    },
    {
      "claim_cluster_id": "0bdfd962-fc80-4c29-8a9f-545619ab3653",
      "event_cluster_id": "c41f696e-07f9-4e6f-84a4-bbc219b21f87"
    },
    {
      "claim_cluster_id": "b66f67b6-3e85-4a7d-9029-7480f97d9f48",
      "event_cluster_id": "3f25d73b-25b5-4e43-b335-2f8f8664eb00"
    },
    {
      "claim_cluster_id": "4cef0d90-5e3b-44f3-ba12-57b1ee19455a",
      "event_cluster_id": "14f2fead-e1a2-4e74-b696-6e535d49d9d6"
    },
    {
      "claim_cluster_id": "891e1da4-bfc6-4524-a5da-153bde60b165",
      "event_cluster_id": "ef19cef5-5810-4243-912b-66c41d184f8d"
    },
    {
      "claim_cluster_id": "7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9",
      "event_cluster_id": "c6e2d109-f8d1-42b8-bb0d-16083a37ad8e"
    },
    {
      "claim_cluster_id": "d5ad62ab-dd96-48fa-a092-0724cb0c06f6",
      "event_cluster_id": "aa24898d-2c81-430f-a430-33fb9aae0db7"
    },
    {
      "claim_cluster_id": "b1da6225-3a48-4f38-b0fb-dac29be99682",
      "event_cluster_id": "b17935cf-677f-4da3-a3e4-c0a86cab1633"
    },
    {
      "claim_cluster_id": "fdbce6fb-9c6c-48ff-a187-88c668f79277",
      "event_cluster_id": "49b4c78b-ed4a-40e7-bdfc-7463c3169502"
    },
    {
      "claim_cluster_id": "594e0474-2d9d-4582-8963-9fe946d49a1e",
      "event_cluster_id": "67cd7c4a-a6b3-4e11-9b6b-362422489e76"
    },
    {
      "claim_cluster_id": "2c8b719a-2363-4f9f-9be2-6d1801374195",
      "event_cluster_id": "4c2caa9f-9774-4e83-aa42-f46bf17280b7"
    },
    {
      "claim_cluster_id": "9d21be2e-9f01-48c9-b454-3a41788e2865",
      "event_cluster_id": "6e25bc0a-2c7d-47cc-a81b-58dba523595b"
    },
    {
      "claim_cluster_id": "226f9322-c9c6-4f2f-948c-b45757d94aa7",
      "event_cluster_id": "bd2a5352-41e8-4479-ac51-89fb57ca65cd"
    },
    {
      "claim_cluster_id": "cfa086e7-654e-40fa-9e14-980617b91e89",
      "event_cluster_id": "bb3ff0db-1a95-4c2e-819a-c84235effd5e"
    },
    {
      "claim_cluster_id": "470bd6d3-39cf-4a39-9a1c-be6c638cdd0d",
      "event_cluster_id": "22a57fde-1c2c-4f1c-9861-888038d4fe31"
    },
    {
      "claim_cluster_id": "f236d68f-fe39-4432-9a36-341eb8900ee6",
      "event_cluster_id": "1a861c93-c5c6-48c2-b775-34eb4363839b"
    },
    {
      "claim_cluster_id": "2c7cf7ec-47d1-4b9e-8095-5a313fd3166e",
      "event_cluster_id": "8585c4f1-4f02-4ac1-9a95-4cc381634f7d"
    },
    {
      "claim_cluster_id": "c75ee75a-e51c-413b-b72e-c2160bcb40c1",
      "event_cluster_id": "c39ad689-c540-4985-928b-b1a54e619b06"
    },
    {
      "claim_cluster_id": "d3123cbc-3543-4f46-aee9-7941c8669a07",
      "event_cluster_id": "63e1fb6c-f4d5-44b0-95bb-4b6a7af8b4d4"
    },
    {
      "claim_cluster_id": "f690f627-f1e3-428b-9d01-bfb966953069",
      "event_cluster_id": "45e218a6-8801-4755-bcad-4c7f5bec819d"
    },
    {
      "claim_cluster_id": "5e0fea08-89fc-42fe-8906-484d762a1714",
      "event_cluster_id": "1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"
    },
    {
      "claim_cluster_id": "ce2b0119-85f6-4619-9c50-256557181c73",
      "event_cluster_id": "71b3e9c3-5afb-45c8-a204-1d5b44e3a33a"
    },
    {
      "claim_cluster_id": "8255a43f-82ec-4f1a-8f29-78e7a247a2d1",
      "event_cluster_id": "219dab96-d91d-4b0d-b347-235846e4bc70"
    },
    {
      "claim_cluster_id": "64b43278-d723-4b63-bcf0-181e1a1658f9",
      "event_cluster_id": "7861388f-c8b9-4ec0-99ed-6ceb81b3764b"
    },
    {
      "claim_cluster_id": "b9ff3223-8bd6-4360-8edc-fa3409378e90",
      "event_cluster_id": "ee97e835-1007-4cd5-b270-714f0880c07e"
    },
    {
      "claim_cluster_id": "a8ca6792-95c5-4826-87fa-d4a8f7047a5f",
      "event_cluster_id": "2cf2f548-46a0-4250-995b-025b4e6eb130"
    },
    {
      "claim_cluster_id": "9594285e-8196-4153-9b31-89250a7200d5",
      "event_cluster_id": "108f968f-7171-480b-9225-ebaea32953bb"
    },
    {
      "claim_cluster_id": "8468be9d-aa33-430a-a3f3-b08169c7651a",
      "event_cluster_id": "9bab6bab-ced4-428f-ad92-fd02b9600f3a"
    },
    {
      "claim_cluster_id": "74664a64-2600-438a-b569-a9d45ae85e93",
      "event_cluster_id": "e0948d6f-1c68-4b82-8be1-2b7d5644b264"
    },
    {
      "claim_cluster_id": "4cc6a578-5e10-41d7-a578-fba88da2dc13",
      "event_cluster_id": "10a3db6f-9669-4c8a-9480-85cb3dd1626c"
    },
    {
      "claim_cluster_id": "a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f",
      "event_cluster_id": "5e5c65ad-4c51-4a27-ad63-eac217deb431"
    },
    {
      "claim_cluster_id": "5389eae7-83b1-4726-86c2-9a8dff51be59",
      "event_cluster_id": "c6ae3e3e-9490-4f23-8d47-5a4b1fb01352"
    },
    {
      "claim_cluster_id": "13470ac2-b4c3-4aff-aa6a-418a5222958e",
      "event_cluster_id": "dd459c3b-7734-4c47-b440-fe088ff89835"
    },
    {
      "claim_cluster_id": "8f273fa4-f8bd-4413-8ce1-7183b77e2566",
      "event_cluster_id": "ceded39c-ad6f-4d12-9e04-8034f780e209"
    },
    {
      "claim_cluster_id": "af167078-1ea4-4d05-a491-aca4808cafd4",
      "event_cluster_id": "ae81b069-06de-4c85-affc-804bac2e778d"
    },
    {
      "claim_cluster_id": "dc3308e5-2250-431f-bef6-733e2b943275",
      "event_cluster_id": "6003df1f-5700-4398-bb5c-3e647fefb73f"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "b407290e-0e65-4bff-90dc-c2ececfb37ab",
      "event_cluster_id": "49ec4675-cceb-45d5-bbb2-56483fcd1319"
    },
    {
      "claim_cluster_id": "457d88a0-1b8d-406f-8eeb-01fdd00cdc30",
      "event_cluster_id": "3380c11c-4d24-494b-b6f2-08440e174107"
    },
    {
      "claim_cluster_id": "36f68109-962e-490e-9101-85d84c5de66a",
      "event_cluster_id": "e47ab492-3177-49bc-9493-e444a1518298"
    },
    {
      "claim_cluster_id": "469e17e6-447a-4bc6-9bab-f2cb595f07e0",
      "event_cluster_id": "49854b0f-e263-4847-a942-d2497d0d1530"
    },
    {
      "claim_cluster_id": "58bf9f4a-adda-4853-802b-78d04aa711fa",
      "event_cluster_id": "1b8daac6-2959-408e-a7dc-dd102f0defee"
    },
    {
      "claim_cluster_id": "9a6fa43d-c803-4c20-bac3-545db67a8241",
      "event_cluster_id": "d63dd03a-5d4f-4d47-9f48-b37f794db992"
    },
    {
      "claim_cluster_id": "5b5325b9-59bb-4b91-9a19-8889095dd496",
      "event_cluster_id": "61c6513c-5b59-4c49-919e-b92af19239e0"
    },
    {
      "claim_cluster_id": "27b386d8-58df-4b19-a269-36bb2400c94c",
      "event_cluster_id": "45df4bbb-00df-47af-9d05-1da924dfb782"
    },
    {
      "claim_cluster_id": "dfa7b9d2-5920-4d57-8445-e48ac5ce73da",
      "event_cluster_id": "dc991813-e94c-49ef-a261-7e441b9dfb8c"
    },
    {
      "claim_cluster_id": "e473874a-9cd2-4a8d-b926-9354bf1b7e19",
      "event_cluster_id": "fe48b63e-4bef-4121-8e7e-7d9b8254bcfc"
    },
    {
      "claim_cluster_id": "b26a20fa-d793-419d-b599-26d1ed57c2b3",
      "event_cluster_id": "277f2c0e-e3d5-4e58-a3ad-823177ebe3dc"
    },
    {
      "claim_cluster_id": "0dedc684-9634-49f1-9f8a-88450509e30c",
      "event_cluster_id": "dbe4672e-f5d2-4914-b987-c4e89610b2b6"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "d3085fed-3741-4d75-9105-e8b0b3511de6"
    },
    {
      "claim_cluster_id": "d26e1561-d7b5-4c15-bc29-d5ba417f64ca",
      "event_cluster_id": "3f685716-0686-4535-807f-feecb0c1246c"
    },
    {
      "claim_cluster_id": "2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6",
      "event_cluster_id": "0ac8de8c-821d-4fe2-90f7-e1d30911339a"
    },
    {
      "claim_cluster_id": "44260a23-35ce-4643-9869-bda1004b447a",
      "event_cluster_id": "6b36db82-3876-45f8-8bf7-ad613dcd8852"
    },
    {
      "claim_cluster_id": "d072d7ca-3280-4412-8e76-be63e36fe491",
      "event_cluster_id": "28b85f28-71e6-4dde-8680-88495b7aecd4"
    },
    {
      "claim_cluster_id": "ed9c7f02-d3d7-4f88-92df-80c91b7dca98",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "21c29f8c-34b7-47c4-8021-91ec84cff803",
      "event_cluster_id": "cbddcfe6-4088-4603-8e7a-ed109a9fff44"
    },
    {
      "claim_cluster_id": "ce637d4c-890f-483b-9ed8-d8130682b8ac",
      "event_cluster_id": "21ccf4a0-84dc-466f-876e-46fb9c86c380"
    },
    {
      "claim_cluster_id": "79c4f8c6-ab1d-43ae-9503-5af83d7fa7e6",
      "event_cluster_id": "783dc097-3e45-45ff-9e18-33ccfd6d47cc"
    },
    {
      "claim_cluster_id": "612e00dc-099b-40a4-b39a-4b7adbab73ce",
      "event_cluster_id": "94f99c45-cd6a-4279-9860-a3fae3c6e14b"
    },
    {
      "claim_cluster_id": "2ee00586-87af-465c-8466-d1bc41c3886f",
      "event_cluster_id": "63ff4667-bd37-45e5-853a-bf5f312c00b3"
    },
    {
      "claim_cluster_id": "dd24c0fd-c274-4b3f-aabc-3dbac6784aa9",
      "event_cluster_id": "32e97d8a-5e17-495f-9681-46a69fce7584"
    },
    {
      "claim_cluster_id": "f8dcd352-7207-4138-bd88-eb7c4051cbbf",
      "event_cluster_id": "ea30f761-5bdf-4c65-ac3f-905c5bb0730a"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "88c2038a-24a0-497f-bac0-84ee519d160d",
      "event_cluster_id": "f6201dc9-cd2a-485c-86d4-622332646365"
    },
    {
      "claim_cluster_id": "c830c75d-93e2-4842-b468-b89a47252719",
      "event_cluster_id": "6ea587ae-3fa9-4e28-822a-cbebc0ee85f8"
    },
    {
      "claim_cluster_id": "58b4a566-79d9-4559-809f-ffd9a84468b4",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "d86ea948-08a0-4829-9e48-4f9273b2967d",
      "event_cluster_id": "02e73dfc-86f2-4fe6-a79c-d071e07721fd"
    },
    {
      "claim_cluster_id": "df0cd74b-d230-4260-9a29-b0bc91923404",
      "event_cluster_id": "bc1909a7-dd59-441d-aab0-42a7a0400bdd"
    },
    {
      "claim_cluster_id": "c7eb5329-6775-4d3f-aea7-7de4fbeb8175",
      "event_cluster_id": "603bb3bf-f1f7-4182-8a09-670b111a3fe8"
    },
    {
      "claim_cluster_id": "b9ff3223-8bd6-4360-8edc-fa3409378e90",
      "event_cluster_id": "345af148-94b5-4202-924c-3b3712e4cb8b"
    },
    {
      "claim_cluster_id": "61152334-8dda-42a2-bb8d-9fb770fd72f7",
      "event_cluster_id": "18cfbf44-b988-4dd5-866b-73fc693898aa"
    },
    {
      "claim_cluster_id": "d8581e68-7fcf-4616-92c1-9daff0a2d8ae",
      "event_cluster_id": "3b02e47c-e307-44b8-85bc-a7863107a268"
    },
    {
      "claim_cluster_id": "505519a5-a059-4c9c-8b16-ce6dffe7e678",
      "event_cluster_id": "14ef59ab-f50d-4bc9-bdf1-1bc17697f5a4"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "6b2b1fd9-ebe6-4e20-9f18-a97a395c8d10"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "ce398b7c-c3fa-42df-8862-5c57ac63cf98"
    },
    {
      "claim_cluster_id": "83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6",
      "event_cluster_id": "e6aabe2f-c2e1-4dd9-a27b-e84ebb5bc406"
    },
    {
      "claim_cluster_id": "73e1870d-5a72-427f-b64a-f2b7b2817260",
      "event_cluster_id": "7f23e350-d82f-4791-a6df-263d08bac5c0"
    },
    {
      "claim_cluster_id": "d47ee5b3-b3df-49e6-9a06-0dbb08c65765",
      "event_cluster_id": "7ef61e9b-09b3-424a-8249-c31cea2c952b"
    },
    {
      "claim_cluster_id": "989e42eb-c62e-4e68-87e6-6b230317d087",
      "event_cluster_id": "49650712-227c-465d-93ab-16c3e2405aae"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "0c9df761-94e1-484a-ad16-41bb0a7c5fb3"
    },
    {
      "claim_cluster_id": "47cee9e4-a547-4914-b31f-89a4963c7d37",
      "event_cluster_id": "8f9c10a7-b7f4-4bce-895c-bb65278b679d"
    },
    {
      "claim_cluster_id": "9b2175d9-8d49-4d83-857c-16d8550ab216",
      "event_cluster_id": "34a1b507-fb03-489f-a79e-be687aeaabe9"
    },
    {
      "claim_cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "event_cluster_id": "925ab71b-2b56-471d-b090-4d83433faa8d"
    },
    {
      "claim_cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "event_cluster_id": "59f7148b-b06f-4868-866d-00139a58abd6"
    },
    {
      "claim_cluster_id": "1b5c8541-b848-4f05-865e-43826009d4e7",
      "event_cluster_id": "c1482f2b-05b5-4755-ad11-c7c127fb4e73"
    },
    {
      "claim_cluster_id": "323efa20-d8ad-424c-9c0e-ac5d255b9276",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "8347f82c-28cc-4206-8266-0d33250fbc4f",
      "event_cluster_id": "325eb390-c83d-4040-b800-a93e29e11141"
    },
    {
      "claim_cluster_id": "0af113aa-da9f-4ed6-a163-dcb48f1459ee",
      "event_cluster_id": "d84db030-75db-4735-a947-d4f90e4deae5"
    },
    {
      "claim_cluster_id": "48cca002-8003-45bd-92b2-3e2945a33b48",
      "event_cluster_id": "172a52ef-f6c4-4bec-a54c-6a0343aa0561"
    },
    {
      "claim_cluster_id": "748c24aa-69c4-47c4-a75f-e6da7007b74a",
      "event_cluster_id": "c04b6a1d-f91c-44bf-b579-d5d4565fc056"
    },
    {
      "claim_cluster_id": "a8c6b9dc-b961-4a1b-bb6d-3aff208b396f",
      "event_cluster_id": "107cb2f5-f373-4a33-aa9c-b2f0173d4807"
    },
    {
      "claim_cluster_id": "f72eb4bb-112f-4556-a279-ad745cb4894c",
      "event_cluster_id": "31dfadd3-c8f6-437b-b8ec-a69992a26cb8"
    },
    {
      "claim_cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "event_cluster_id": "ceded39c-ad6f-4d12-9e04-8034f780e209"
    },
    {
      "claim_cluster_id": "4575f267-4553-4c7c-916e-359800e4fb24",
      "event_cluster_id": "a61f9905-7bda-4da1-b019-fbc601e92e05"
    },
    {
      "claim_cluster_id": "4af97b54-9617-48e3-8125-aa1e8e1ee8a2",
      "event_cluster_id": "224111ea-4ffa-46dd-984c-028b4bc55489"
    },
    {
      "claim_cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "event_cluster_id": "933d50c3-dd0d-4b5f-9957-22bbcfcc55d5"
    },
    {
      "claim_cluster_id": "528a9885-82c7-4bee-beac-f85e4c7c3f1b",
      "event_cluster_id": "6a63b515-0915-46a1-b528-3651a558693f"
    },
    {
      "claim_cluster_id": "38520096-281c-4b53-ba64-f7e18dbd525f",
      "event_cluster_id": "3f1ec78d-49c2-44d1-bdc2-97cf6217c638"
    },
    {
      "claim_cluster_id": "a3c357ac-5159-4eec-ad16-09366a144d09",
      "event_cluster_id": "edc6ba48-0632-4236-9c24-f67f26e9b96b"
    },
    {
      "claim_cluster_id": "800e7e36-7ce1-4e55-a18d-394d83673d71",
      "event_cluster_id": "866d952f-2947-45b5-a10f-e756e9288018"
    },
    {
      "claim_cluster_id": "a99b1332-e477-4168-b8e5-832daa0d6068",
      "event_cluster_id": "c54aa827-069b-4ed6-b43e-bde69590b9e4"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "871a611b-da54-48a2-9c22-fa6f48cccc0c"
    },
    {
      "claim_cluster_id": "51086a98-c771-4b7c-8eaa-b6fbb8629a30",
      "event_cluster_id": "602ccd3f-b2b7-474a-9029-74260beb7902"
    },
    {
      "claim_cluster_id": "d1292088-fa7b-4c5f-a6b8-d1bbb1dc9eae",
      "event_cluster_id": "7378ad43-a016-4ea8-a115-0123a4bd291a"
    },
    {
      "claim_cluster_id": "232c9ea4-0513-4c68-a25b-8b7d952325d2",
      "event_cluster_id": "1760a439-ca46-4fac-8653-21cfe35d860c"
    },
    {
      "claim_cluster_id": "33f6801a-acda-4c2e-9708-cf1802dbdbb9",
      "event_cluster_id": "6fdf651c-dbd2-4ed4-85b1-ba8e9916ed27"
    },
    {
      "claim_cluster_id": "84b73ec4-88f0-4587-a147-47771c41db07",
      "event_cluster_id": "22e5ae9e-51e6-4da6-a862-0555cb893e6a"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "8f04e04a-ea8d-4a08-9f4b-0027f1697329"
    },
    {
      "claim_cluster_id": "b8726f80-5b75-44d5-9a25-5d095109008d",
      "event_cluster_id": "a4a5f3c7-c987-41f6-9618-486ae48abb68"
    },
    {
      "claim_cluster_id": "834f4385-ef2b-4b12-81b1-8e94ff3098e8",
      "event_cluster_id": "95b52cd8-d8dc-42df-9eb9-9f4f8c6db4b2"
    },
    {
      "claim_cluster_id": "de15f7d6-5167-45b1-bad6-235dd16ae15e",
      "event_cluster_id": "ec825820-2066-4bfe-95cd-b11676c4d89c"
    },
    {
      "claim_cluster_id": "de08eb08-92b3-4974-9e99-e79755582996",
      "event_cluster_id": "2b58f035-89d0-48c4-ab98-0571ae348860"
    },
    {
      "claim_cluster_id": "5c68cba2-8519-4f6e-b70e-fbda62c5445c",
      "event_cluster_id": "f629a198-d535-41eb-8981-0a2a15fcbcb9"
    },
    {
      "claim_cluster_id": "1e74d1b1-7b73-446d-b88a-11111e499ad8",
      "event_cluster_id": "682ed3da-b434-4c8b-a46d-5ea8bffc9576"
    },
    {
      "claim_cluster_id": "90ef35f7-8880-490a-bacc-f600f6a11162",
      "event_cluster_id": "c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"
    },
    {
      "claim_cluster_id": "ae1e52fc-461a-4609-8b02-2589611c162e",
      "event_cluster_id": "a50cab62-c330-4a2e-b634-2fd8a82ebcfe"
    },
    {
      "claim_cluster_id": "304f9508-2cf0-4ef2-b524-7a5c78978d94",
      "event_cluster_id": "e25715ec-5983-4c68-b924-9f64b4f03d63"
    },
    {
      "claim_cluster_id": "8db7f2ee-28e7-4abd-b214-9d334508a075",
      "event_cluster_id": "25038dda-b8ca-4dd5-9e0c-c382a4d18a6e"
    },
    {
      "claim_cluster_id": "aaf51226-d11b-4c1b-82db-25727f24712a",
      "event_cluster_id": "00fbd015-4c36-4680-a582-bfc7271c3275"
    },
    {
      "claim_cluster_id": "a5408918-67c4-45bd-afb3-95d8aced1dc9",
      "event_cluster_id": "4e48f414-895d-4241-a8ae-69662f5c3d46"
    },
    {
      "claim_cluster_id": "34db5d7a-86ad-4cf4-abae-67c617853bac",
      "event_cluster_id": "94c94ebf-a12a-4db5-9455-477a88d18b1f"
    },
    {
      "claim_cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "event_cluster_id": "13a151a6-c289-4cb5-8bbc-44e52c4f2c13"
    },
    {
      "claim_cluster_id": "910f66d9-b789-4e64-8888-a565439b59fa",
      "event_cluster_id": "2c29846f-3295-4669-afc6-4c052b5c55d8"
    },
    {
      "claim_cluster_id": "47cee9e4-a547-4914-b31f-89a4963c7d37",
      "event_cluster_id": "c3f8efea-527f-4eda-8f86-1b201d526c1e"
    },
    {
      "claim_cluster_id": "f9c980a9-33b9-4834-922a-947a13f5a035",
      "event_cluster_id": "5c5bbff7-5569-43a1-bcbe-db0b95585d05"
    },
    {
      "claim_cluster_id": "04ba7876-53cc-44c3-8149-fe7ba435f124",
      "event_cluster_id": "c9b63381-9a94-41a6-b33b-4c75f981d835"
    },
    {
      "claim_cluster_id": "f4cd4d9b-6b2b-454a-ae24-3a0150790009",
      "event_cluster_id": "aadbc964-f981-4ea2-bc24-dd4cf5de086c"
    },
    {
      "claim_cluster_id": "cbbb2109-39b9-4308-a4ce-30a48563cab7",
      "event_cluster_id": "42c65788-8111-41df-929a-ce02cb092330"
    },
    {
      "claim_cluster_id": "1ff9104e-969b-469f-b204-88f04894d01f",
      "event_cluster_id": "c07b3261-1d07-4e89-b0d2-db74c9a1f8dd"
    },
    {
      "claim_cluster_id": "b840591d-33a5-402e-9f7a-8913292b283e",
      "event_cluster_id": "8cf3def2-907f-4b61-b37f-0d9e2ed2b954"
    },
    {
      "claim_cluster_id": "253e1524-e402-4a4d-b7db-f94b8f989d9c",
      "event_cluster_id": "f5ceefb1-12c2-41ea-b95c-18c5038560bd"
    },
    {
      "claim_cluster_id": "e9d22d46-e0d1-45b7-b109-afc6516146e1",
      "event_cluster_id": "d3c9a36a-e9bd-4eb9-ae98-c8503d7abb49"
    },
    {
      "claim_cluster_id": "8e873c15-6407-475e-841a-2dcbbce28e18",
      "event_cluster_id": "51102dd8-1276-45b4-9dc0-5dab1b318e57"
    },
    {
      "claim_cluster_id": "8038fcc7-29f8-406c-90cf-ee3b351c6e15",
      "event_cluster_id": "22d09703-f903-41b1-874f-1d44ac956d8e"
    },
    {
      "claim_cluster_id": "e82ed51a-4d19-4b2d-96bc-cb54f9b70858",
      "event_cluster_id": "4fb3ad72-cc0b-4dd7-a137-fc01ed07a902"
    },
    {
      "claim_cluster_id": "bfc6790e-9007-4b03-90bf-5da6fcce01b7",
      "event_cluster_id": "e21a96d2-b5b0-4a69-80bb-66020b0b8a54"
    },
    {
      "claim_cluster_id": "4692c588-5e24-491c-9044-3d7dd7c0a2d7",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "2ebece0c-e502-49a9-94b9-5df90f1b8e51",
      "event_cluster_id": "21e4a786-d932-47c3-955b-b3e7de14d033"
    },
    {
      "claim_cluster_id": "635fb80e-2799-454a-8570-6fc3830d271b",
      "event_cluster_id": "4fecbbe3-fb61-4e10-b666-a2cf1bec8797"
    },
    {
      "claim_cluster_id": "b27abfde-f9d9-4f52-9ce7-8c541388281c",
      "event_cluster_id": "88c327f9-75c2-480a-8aa8-272d021cabe8"
    },
    {
      "claim_cluster_id": "f8c898ca-36a7-47ac-838a-8091321433d0",
      "event_cluster_id": "4baddf1e-d126-4e58-b0e3-19999dfb4341"
    },
    {
      "claim_cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "event_cluster_id": "8d281258-aab1-4ac7-9451-b7a3fe4c46e1"
    },
    {
      "claim_cluster_id": "24e1d750-e055-449a-83a7-236e590f0e5b",
      "event_cluster_id": "800e1de8-b1a3-400a-bda3-2e81d524609f"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "0ac8de8c-821d-4fe2-90f7-e1d30911339a"
    },
    {
      "claim_cluster_id": "7fbd47ed-2abf-42a7-9e7d-74c06dc8b729",
      "event_cluster_id": "cfbc5753-ac66-4d7e-b3ad-5e7f58c3e6df"
    },
    {
      "claim_cluster_id": "e4e03461-6763-4291-b9e4-bd4feccb46e2",
      "event_cluster_id": "3766e219-c028-4750-8fa4-03a0a967da3c"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "52bd4e45-b832-46e3-9698-5812693f4546"
    },
    {
      "claim_cluster_id": "9971c68f-8d21-4436-a5d3-4897996181e7",
      "event_cluster_id": "906602f3-b23d-4091-b462-b74d3ce8894a"
    },
    {
      "claim_cluster_id": "4350947c-093e-43d1-91ad-c33f75e13a1e",
      "event_cluster_id": "e0a277a7-e9c4-43ed-a840-95ca0c8f496c"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "6eee7591-18a7-498f-a4ad-f5aae119dd62"
    },
    {
      "claim_cluster_id": "245874be-060a-4ca6-afe3-3a367b00ddb5",
      "event_cluster_id": "094c5f6c-8f77-4ae5-86e6-0f169bca56ea"
    },
    {
      "claim_cluster_id": "5a77fa7e-06f0-487a-a93b-f15e590aa54a",
      "event_cluster_id": "db350168-e89e-48c8-a5ce-3b8c59130017"
    },
    {
      "claim_cluster_id": "411175f7-0ca0-4fb5-9db2-35822ef1cc0a",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "51ab0b64-787d-450c-9578-4158dfeb97cb"
    },
    {
      "claim_cluster_id": "82cf1bd1-8182-4744-8fc2-6d5af2292aea",
      "event_cluster_id": "5291aa5f-51ac-492f-83f7-3c48258f1866"
    },
    {
      "claim_cluster_id": "800c3c00-df13-4716-b553-f1b7480d22b7",
      "event_cluster_id": "11eba0ed-7efc-4733-b927-256265e60430"
    },
    {
      "claim_cluster_id": "7bf4f678-55d5-4f6a-922f-0b5de572f033",
      "event_cluster_id": "94476e0e-60e0-40ca-89ed-b2626dba60d7"
    },
    {
      "claim_cluster_id": "762409bf-96e2-43cc-99d8-45783ade1b1f",
      "event_cluster_id": "9e059116-3c55-48ed-9078-1c003c9ab524"
    },
    {
      "claim_cluster_id": "92df53c2-d00a-4565-ac4a-1279aad1b2ee",
      "event_cluster_id": "abd5930f-6db1-45e3-b882-ee3ba2f8394b"
    },
    {
      "claim_cluster_id": "64ec2b0f-c55e-42e7-a532-b9948f0a43c1",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "72276ba3-4193-4153-879a-b2c7cdf39af4",
      "event_cluster_id": "fb90f205-10b1-4a80-8c76-1265d7a47a4d"
    },
    {
      "claim_cluster_id": "ccc50930-0ce2-4cb5-aa76-281b7202368b",
      "event_cluster_id": "8bd51f45-6e7b-4825-a6da-736e3f231b22"
    },
    {
      "claim_cluster_id": "cd37a888-7bea-44b1-9691-e12e7c11fac9",
      "event_cluster_id": "7bdac760-2a67-4126-ace8-6bee9660bcc4"
    },
    {
      "claim_cluster_id": "c46be245-9f63-495f-be19-e522e39c13f9",
      "event_cluster_id": "6f318bba-6562-4eeb-ad79-8a89fa75ae26"
    },
    {
      "claim_cluster_id": "50262127-6a56-4d82-bc3b-4ca236eefed1",
      "event_cluster_id": "a28c9cba-981f-4e06-b04d-bde777f88583"
    },
    {
      "claim_cluster_id": "506e309f-6f87-418b-b660-0ad635976c9d",
      "event_cluster_id": "333dab32-099d-476d-86ef-f676846f2e4b"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "712fa0e5-9886-40f6-b761-bb1a99d5fb8c"
    },
    {
      "claim_cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
      "event_cluster_id": "31763d96-84ac-402a-a69c-ea748718f342"
    },
    {
      "claim_cluster_id": "1c5f9ea9-d432-4800-9abd-5af5c927568b",
      "event_cluster_id": "7e49c169-d21d-4097-aa83-c6ac3958ab1b"
    },
    {
      "claim_cluster_id": "e0b3b058-f41a-4ebc-b9bd-9e20a141c340",
      "event_cluster_id": "c4bed539-a0aa-4ff8-9be3-4afa92598dee"
    },
    {
      "claim_cluster_id": "bba799e9-6e80-4ce6-b96c-fc89b2b8200c",
      "event_cluster_id": "49ec4675-cceb-45d5-bbb2-56483fcd1319"
    },
    {
      "claim_cluster_id": "c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9",
      "event_cluster_id": "b900a5fd-9f6d-409a-b2f1-c21b24addff1"
    },
    {
      "claim_cluster_id": "b198bd93-5f96-4992-9aa2-29e396814e39",
      "event_cluster_id": "cb759cf9-83bb-41f1-8a60-65bf2476c5fa"
    },
    {
      "claim_cluster_id": "bc48e3cd-6317-4a4a-b06b-f8629ebbbbcd",
      "event_cluster_id": "2dfd3fb6-1a3a-4beb-9bdb-2191423af570"
    },
    {
      "claim_cluster_id": "3312bf71-bb24-4752-866e-3b29580d70d1",
      "event_cluster_id": "b6f8ab92-0a99-4ae3-a84c-c1ab0b6d7d39"
    },
    {
      "claim_cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "event_cluster_id": "fece93a1-7734-48a4-99b6-9dce302454b2"
    },
    {
      "claim_cluster_id": "702a4627-2eae-451d-b2a9-154358319e24",
      "event_cluster_id": "de42709f-cb35-4f62-b569-11c75f1fbe5e"
    },
    {
      "claim_cluster_id": "dfa7b9d2-5920-4d57-8445-e48ac5ce73da",
      "event_cluster_id": "dc60fa2d-dae3-4ea2-a4d5-1da4424a6919"
    },
    {
      "claim_cluster_id": "1190ac87-5191-4e29-877a-253af15bb185",
      "event_cluster_id": "51b63d4e-9a9e-4f49-a1a8-d50a9f8eff02"
    },
    {
      "claim_cluster_id": "ef74ebaa-c6e0-4356-bf8a-2ce2acf6ad70",
      "event_cluster_id": "d05207e4-1a3a-4cab-84c5-4af79b01b239"
    },
    {
      "claim_cluster_id": "481b0645-4bcd-4df1-ae15-b184375e551e",
      "event_cluster_id": "906602f3-b23d-4091-b462-b74d3ce8894a"
    },
    {
      "claim_cluster_id": "e0f8bbeb-8967-4f3f-ae0d-4b809311c515",
      "event_cluster_id": "6c7741a7-bba5-415f-86fa-1077ed815fec"
    },
    {
      "claim_cluster_id": "06f63413-3561-4a53-933b-589b1f942c37",
      "event_cluster_id": "d285c4ec-3955-47ea-918b-05a93083bebc"
    },
    {
      "claim_cluster_id": "fd554d0c-cd25-4da2-adf1-dcccfd01f292",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "5a772e21-6b8f-413d-9915-01833aadc67f",
      "event_cluster_id": "4c365f8e-324b-474b-8239-fe362d8fca1a"
    },
    {
      "claim_cluster_id": "72804ca3-611f-4b19-ada2-8bfb14c2e98a",
      "event_cluster_id": "d878f267-808b-4a23-9202-10d08ee3053d"
    },
    {
      "claim_cluster_id": "bbad87a2-fdaf-4bdc-9b37-124a381131af",
      "event_cluster_id": "2fc962c7-e77d-4ca3-a166-4f1d011720db"
    },
    {
      "claim_cluster_id": "b9550306-91d4-4e1e-9632-4c73f1957d92",
      "event_cluster_id": "73893bd5-387d-4d08-9fad-0f62b5aacd0c"
    },
    {
      "claim_cluster_id": "e9280ed1-20ec-4c75-8468-086e8c6749dc",
      "event_cluster_id": "0d486f1f-7f93-4053-a807-970ad702d674"
    },
    {
      "claim_cluster_id": "b8208758-3ffb-41f1-97e7-30e90da08e44",
      "event_cluster_id": "a7a90cf5-cc81-4b76-b47f-bd8836b204ba"
    },
    {
      "claim_cluster_id": "96b36513-ec34-4deb-bc5b-c811958c3675",
      "event_cluster_id": "44bced9f-9cdf-42b9-a5c2-b5abf31749ea"
    },
    {
      "claim_cluster_id": "69290a80-8807-401f-b38b-0ff5ba27a43d",
      "event_cluster_id": "37dc3c46-39b6-4d4e-87ad-59040db4662a"
    },
    {
      "claim_cluster_id": "8b3203a2-f473-4957-9689-fdf6ee974697",
      "event_cluster_id": "4005f43b-5b4a-44f8-9781-c0a91127368f"
    },
    {
      "claim_cluster_id": "043e7562-9880-4d36-ba06-fd8e6b3afbe1",
      "event_cluster_id": "f3ad65a5-41f2-46d7-a4ab-cdfd0feea00d"
    },
    {
      "claim_cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "event_cluster_id": "79b49988-337e-4ff8-a4e9-5a2de271d6d6"
    },
    {
      "claim_cluster_id": "1e12b1a7-9bc4-4a98-b698-8392df483432",
      "event_cluster_id": "54852fe8-25a9-4bc3-8ed0-4f252eac7d21"
    },
    {
      "claim_cluster_id": "546f63e2-ef89-4f69-bd49-cde47599b05e",
      "event_cluster_id": "e2b1886a-d41d-4169-be53-e4ed1b6d9d79"
    },
    {
      "claim_cluster_id": "4c95b4a9-d005-4c7c-8a55-a5a0821d7611",
      "event_cluster_id": "dc2b8b73-2640-4b6c-a7d1-9e5c9873bbf6"
    },
    {
      "claim_cluster_id": "770cc261-67a7-4ed4-85d2-93916689a978",
      "event_cluster_id": "86a99b16-df58-43a2-b7eb-e1d03c6f6e5e"
    },
    {
      "claim_cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
      "event_cluster_id": "05905deb-04e3-4e57-afeb-f4e623c176cb"
    },
    {
      "claim_cluster_id": "4b605940-f896-4b59-bf12-36fbeec83b94",
      "event_cluster_id": "65324661-3a29-437c-9b4b-f8ea61a6dabf"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "4cf8f034-c2c7-4891-81cd-bb23d16f75ec",
      "event_cluster_id": "7640b35f-031b-4917-bf34-5555111a4a74"
    },
    {
      "claim_cluster_id": "1b63ec5b-2010-4bd3-a351-328e7b4b5470",
      "event_cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7"
    },
    {
      "claim_cluster_id": "fdc7a586-a2b7-43cb-897c-5aacc04ceaff",
      "event_cluster_id": "2fb41c0c-9dcd-4bc3-b70a-75aee83bcba5"
    },
    {
      "claim_cluster_id": "31ba7a04-0212-474b-8f8e-9374845e4ab5",
      "event_cluster_id": "06aade08-3010-4d09-90ab-647cfcc26947"
    },
    {
      "claim_cluster_id": "be023ca2-f865-4811-854e-b40ab442412b",
      "event_cluster_id": "f15d86b1-5ec6-42af-abb5-8a53b43a9bab"
    },
    {
      "claim_cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "event_cluster_id": "264cec13-14ac-4e28-862c-a8260aede982"
    },
    {
      "claim_cluster_id": "3eeddc05-77ec-4d67-9a78-4b328957fe7f",
      "event_cluster_id": "46b53499-f467-4b91-a839-e6551db764a7"
    },
    {
      "claim_cluster_id": "2712567d-2895-48f5-8695-f726eb795979",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "1071979a-b25a-4432-8eb1-62e54bcd27e1",
      "event_cluster_id": "e8c99cdd-553e-4aba-b844-e1556f7a8787"
    },
    {
      "claim_cluster_id": "c8cf7c39-4d6a-4fec-8451-b46f12ccd07f",
      "event_cluster_id": "d3ddf15f-7261-4b4f-bdd9-6823755811e6"
    },
    {
      "claim_cluster_id": "58a44cd6-3f44-4460-9d07-d5a28bd55747",
      "event_cluster_id": "b4fb9256-1ac5-4cb5-9d11-a73a825665b3"
    },
    {
      "claim_cluster_id": "94a84124-c591-4219-8ef7-52760d608300",
      "event_cluster_id": "cdec7efe-effe-4d5a-84e5-892cd8aa5135"
    },
    {
      "claim_cluster_id": "dad2ba1b-78a6-4e69-91a7-e473e3d79e42",
      "event_cluster_id": "ebb80698-62b6-438e-85ac-44aff649cb30"
    },
    {
      "claim_cluster_id": "77e72686-2baf-45ab-a679-b8f62cdcf982",
      "event_cluster_id": "37b4342a-fb0a-4dc5-96ce-db0bc15c1568"
    },
    {
      "claim_cluster_id": "c05c40cf-fbe6-4e98-aa0e-98f1fcbb5333",
      "event_cluster_id": "90594f77-57da-4d80-a85e-ef6c61b0cc03"
    },
    {
      "claim_cluster_id": "35218630-91b1-47a4-87cf-29094bd87289",
      "event_cluster_id": "c1a62eb0-76d0-46fb-8060-6353e7306396"
    },
    {
      "claim_cluster_id": "1a4ea1ae-4636-425b-b953-e3a50c80caeb",
      "event_cluster_id": "816b8091-ba27-40e8-864f-f38a64991c28"
    },
    {
      "claim_cluster_id": "511c0db2-0769-45d5-a814-00f974a659aa",
      "event_cluster_id": "32ba4740-f52a-47e5-91ff-4fde0ada2a3e"
    },
    {
      "claim_cluster_id": "33f6801a-acda-4c2e-9708-cf1802dbdbb9",
      "event_cluster_id": "ec9f289c-28f3-4c8f-8168-260fc03a8183"
    },
    {
      "claim_cluster_id": "5c7c452c-db3f-4741-97ef-77d49e8c75b4",
      "event_cluster_id": "d8b8cb3c-4059-4ad7-99fc-df25e1b98b1b"
    },
    {
      "claim_cluster_id": "b2dac904-00a6-4c9f-a283-eccc78d22ae0",
      "event_cluster_id": "8b1769db-6aae-4f31-8eca-13c7641a8a79"
    },
    {
      "claim_cluster_id": "29c6f9fc-e1e6-4dfe-a45c-59ee8d9a4489",
      "event_cluster_id": "6c57c5d0-33e4-4282-bbc0-6b80393235a6"
    },
    {
      "claim_cluster_id": "38eef897-6e59-4836-bf0e-1e7e106baf53",
      "event_cluster_id": "00440887-1b0e-4488-8a0b-2f9b2ba9ede3"
    },
    {
      "claim_cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "event_cluster_id": "53832c20-28bd-4cb2-a22b-7698f81c17f5"
    },
    {
      "claim_cluster_id": "b7e33865-58b2-4984-a7e1-eed1512539bb",
      "event_cluster_id": "b7518287-9949-4ec0-a078-3d7e49009d46"
    },
    {
      "claim_cluster_id": "043b0606-561e-4868-8354-4c45ee5a2f95",
      "event_cluster_id": "41739d94-ef7a-4bdc-b95f-35d9d4daaddf"
    },
    {
      "claim_cluster_id": "b8a67936-c036-4a45-8680-bb4909cdd3db",
      "event_cluster_id": "c0fe2a1f-22f3-4601-9b6c-36727a9d81a9"
    },
    {
      "claim_cluster_id": "8a60fc08-ff21-49d9-8858-dcff37e21d18",
      "event_cluster_id": "bf840015-2be2-4173-ba65-4d1448510aee"
    },
    {
      "claim_cluster_id": "dfbd57d9-b4af-48fe-adde-4b27c203374e",
      "event_cluster_id": "fd80dc8e-90e1-45e9-b475-5c0e7ce125c9"
    },
    {
      "claim_cluster_id": "f4b62b28-f2fe-4807-a41e-80bf6c8bad68",
      "event_cluster_id": "43cd70ef-d6cc-421f-9e30-15cc399119b7"
    },
    {
      "claim_cluster_id": "fa79376c-183c-4b27-9b35-5eee39b30f87",
      "event_cluster_id": "6bdf1a93-76ba-4948-be05-d02fbb6488f4"
    },
    {
      "claim_cluster_id": "c35d9889-06cc-4a13-8fea-d00c7024488b",
      "event_cluster_id": "4da3a5b6-2b3a-469e-82e1-4fa291688db8"
    },
    {
      "claim_cluster_id": "b4e4a860-8721-4ac3-8eb3-a9dec18b336d",
      "event_cluster_id": "d6ce2176-c8b1-49b2-89e4-f0620f06cb63"
    },
    {
      "claim_cluster_id": "bde9febe-9a28-4f0f-b67c-15f9a243538b",
      "event_cluster_id": "13bcef3e-fd19-4989-b312-5873b1468a28"
    },
    {
      "claim_cluster_id": "6efc04ea-c5a7-40f2-bf74-98f55c06f1df",
      "event_cluster_id": "24603ad6-f39a-4706-80ce-2840439ad61c"
    },
    {
      "claim_cluster_id": "c8d47411-ab85-4f96-b286-cd76451823f8",
      "event_cluster_id": "8a84554f-19d7-41fa-8647-c3608df3d4f1"
    },
    {
      "claim_cluster_id": "71acf2d0-be7b-4d8e-b3fc-93baaa073aa1",
      "event_cluster_id": "a1395f05-6f91-4eca-a911-53f15292db71"
    },
    {
      "claim_cluster_id": "a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0",
      "event_cluster_id": "0c951d24-0f2c-41e0-a5be-f5200eceb7d7"
    },
    {
      "claim_cluster_id": "5feff95a-4d00-4a01-9b49-f3df3eb263ca",
      "event_cluster_id": "e19196d4-b7bf-49e0-b42c-244f5f90725b"
    },
    {
      "claim_cluster_id": "c02665b8-8535-44f4-96b2-764b54985f66",
      "event_cluster_id": "c65c30a8-6203-4ff2-8126-866ddc1ad7ee"
    },
    {
      "claim_cluster_id": "1e12b1a7-9bc4-4a98-b698-8392df483432",
      "event_cluster_id": "814e8e7c-9951-4225-be99-2e978ab5ec4d"
    },
    {
      "claim_cluster_id": "664823cc-3309-42a4-9224-e9eaa7ee3fe5",
      "event_cluster_id": "9a1b07d6-f1d6-4b71-a6fc-885000909a93"
    },
    {
      "claim_cluster_id": "cd21b07f-3941-439e-8ffa-59c6da9df98f",
      "event_cluster_id": "e15ef239-9f26-4808-8bf7-31e94108dff6"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "dd5d0634-bc30-45f9-b45a-97773c63db2a",
      "event_cluster_id": "a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"
    },
    {
      "claim_cluster_id": "d29a2d68-5d53-4ad3-9792-37db5375f45d",
      "event_cluster_id": "bd325bb2-82ff-445b-9556-5c3579998b1b"
    },
    {
      "claim_cluster_id": "595531c2-a2b0-4686-b3ae-4f5525fff05a",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "234be4d1-d0d0-4b65-aa97-a8cd91a0a32e",
      "event_cluster_id": "039f8cf2-d1ad-441e-b62e-9a9fe0c8c803"
    },
    {
      "claim_cluster_id": "db9b9c53-4b26-4d88-83d5-c4c2d8189711",
      "event_cluster_id": "3680c45d-b58c-4b06-86cb-3a65bd43ebc6"
    },
    {
      "claim_cluster_id": "ca064fa8-d12d-4c48-9fc5-aca6df7f2dc9",
      "event_cluster_id": "360f8a39-1f36-4965-9744-1b8bf78217a1"
    },
    {
      "claim_cluster_id": "8a2e1f2c-6d19-479b-811f-3ccec4820a64",
      "event_cluster_id": "57c8d119-9759-4d0a-a7cd-9c98d4429c3f"
    },
    {
      "claim_cluster_id": "294ad0e1-cad9-4655-b7de-5e21de0e4797",
      "event_cluster_id": "771ff184-5478-488e-90da-69f2d3b1dfbb"
    },
    {
      "claim_cluster_id": "700a7ce5-024e-45ce-bc66-61c8dab09717",
      "event_cluster_id": "b1375511-e3be-4083-816e-ce6ea23f39cf"
    },
    {
      "claim_cluster_id": "d89e632e-b2af-4331-9344-c7d1e373d49b",
      "event_cluster_id": "7aadf7ec-8a12-4805-bf87-51d4575c022f"
    },
    {
      "claim_cluster_id": "1c1848e6-9c28-4252-9e24-4dc5cb477be6",
      "event_cluster_id": "03682aa9-6c66-493a-b7f2-cba3c38176e4"
    },
    {
      "claim_cluster_id": "fce90f87-0664-4b8a-bb4f-dc7bbf08cf50",
      "event_cluster_id": "69235fb0-8a7b-49cf-8a07-8d2aa290c9c9"
    },
    {
      "claim_cluster_id": "8308c2eb-92cf-4ca4-876b-d1d947564441",
      "event_cluster_id": "b56ca1ab-f300-4476-ac21-f73e07a1dfa9"
    },
    {
      "claim_cluster_id": "18699af2-76ba-4b44-8dd8-cbb2b538e559",
      "event_cluster_id": "878ab8c3-2760-46b0-8086-c8aa996e56bc"
    },
    {
      "claim_cluster_id": "2ee00586-87af-465c-8466-d1bc41c3886f",
      "event_cluster_id": "d5fb5705-8036-4366-acc0-f2b5f625126b"
    },
    {
      "claim_cluster_id": "29880646-f50e-47bd-8b04-23f2c8716fdf",
      "event_cluster_id": "02e9df36-756a-4f13-96b7-a64b085d932d"
    },
    {
      "claim_cluster_id": "e2676bcb-4f6e-4d98-ba58-3d2aff04d940",
      "event_cluster_id": "094c0c48-56a8-4f19-bf5d-16a053900cf5"
    },
    {
      "claim_cluster_id": "8d550fbc-5131-4294-a815-b9e32f81ad7a",
      "event_cluster_id": "e209eca1-fa4c-48e0-bce4-5bdadede98cd"
    },
    {
      "claim_cluster_id": "61ac97d3-e62e-41a3-b910-360985f7af21",
      "event_cluster_id": "71c5fa4a-0b53-4202-9b3e-1c8038451d63"
    },
    {
      "claim_cluster_id": "2df1a526-a92c-44a2-a3b2-202bf1d7f6d9",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "8d06f8b9-e6ed-4b99-89ef-90434792b924",
      "event_cluster_id": "68230774-a51a-4451-9136-5aab1d1fcce9"
    },
    {
      "claim_cluster_id": "83150260-cbcb-429e-8e22-0e5b897618ff",
      "event_cluster_id": "49b59607-bcf5-4471-8809-4106f681d4d2"
    },
    {
      "claim_cluster_id": "99dfb4e4-9788-4ea5-81a7-c0dd44f60aba",
      "event_cluster_id": "fecb08d6-7113-4fdf-93c0-d68d7f11e733"
    },
    {
      "claim_cluster_id": "5ebc5950-a889-49b1-a0d8-0d905803d030",
      "event_cluster_id": "01d21517-243e-4d94-b9c5-641f8bca7cbf"
    },
    {
      "claim_cluster_id": "16667fe1-8cf7-4fec-9aa8-c5bb30920e90",
      "event_cluster_id": "b5bd71be-fc38-4eed-90dd-db3dd13d58ab"
    },
    {
      "claim_cluster_id": "9c52e5bb-8493-4b3c-8444-69598adc8932",
      "event_cluster_id": "f387334c-114b-4f0f-8f1a-524773e4b44d"
    },
    {
      "claim_cluster_id": "3ea1c92f-805f-4ecb-b23d-a77a7a362e5b",
      "event_cluster_id": "c7cc8a7a-ef8f-4aaa-8735-139c689f3af1"
    },
    {
      "claim_cluster_id": "e50a9fba-a791-4b5a-bed8-e0accc690c1a",
      "event_cluster_id": "193775cc-4b10-4b36-baba-844635425d37"
    },
    {
      "claim_cluster_id": "61b758fd-ce2c-4502-b494-9618880e66e4",
      "event_cluster_id": "af917a84-5c51-4c7b-9efd-b1ddeecaeb3a"
    },
    {
      "claim_cluster_id": "aac18326-5af8-47ed-b7a7-209e78b29dfe",
      "event_cluster_id": "1072cae9-f711-4ddc-9b33-a14d4050ebba"
    },
    {
      "claim_cluster_id": "04938aaa-1985-4664-bfb5-337fffd62a6d",
      "event_cluster_id": "50321d3e-dfc0-4504-be22-01fb2718ed93"
    },
    {
      "claim_cluster_id": "c6d2f5c4-bb51-435b-a664-174b47ed38ef",
      "event_cluster_id": "8245fae1-2de7-44c3-b580-0a610d90519c"
    },
    {
      "claim_cluster_id": "1e35c814-682d-4b74-be8b-2867b370b971",
      "event_cluster_id": "7f659049-c3cb-424c-9dbd-559d942783fc"
    },
    {
      "claim_cluster_id": "470bd6d3-39cf-4a39-9a1c-be6c638cdd0d",
      "event_cluster_id": "a34d03f2-7fce-45f7-b77c-0c16c720e6db"
    },
    {
      "claim_cluster_id": "c9073334-10d9-4fd4-905b-747ad45c136a",
      "event_cluster_id": "48d341a5-63e7-4586-8058-1ab4e4d8c613"
    },
    {
      "claim_cluster_id": "700a7ce5-024e-45ce-bc66-61c8dab09717",
      "event_cluster_id": "533c13a6-e2bd-46be-9422-2e368c4b5793"
    },
    {
      "claim_cluster_id": "f6aedae8-b368-419e-9158-abbe718748ba",
      "event_cluster_id": "8631d2bd-115e-4513-8568-952af022961b"
    },
    {
      "claim_cluster_id": "f4b62b28-f2fe-4807-a41e-80bf6c8bad68",
      "event_cluster_id": "09d77729-56d6-4baf-a41c-830b574929ac"
    },
    {
      "claim_cluster_id": "6bdcff96-571d-4879-91a7-d6084340625f",
      "event_cluster_id": "1285d3bf-ce3b-4c4d-b6ee-39e378371b65"
    },
    {
      "claim_cluster_id": "ce659db6-9043-4f18-a410-39321ba5fd81",
      "event_cluster_id": "878a9636-1e8d-41b7-b38c-b1f621f47d04"
    },
    {
      "claim_cluster_id": "7cacaa03-4763-4931-91bd-306a3231361c",
      "event_cluster_id": "7628ae8d-befe-43ea-95f0-6fd9a907267a"
    },
    {
      "claim_cluster_id": "19ddcd3b-18db-461a-b208-f198db3e1e07",
      "event_cluster_id": "ae81b069-06de-4c85-affc-804bac2e778d"
    },
    {
      "claim_cluster_id": "c35acce9-0a6f-4e25-8869-1a5e38bf302a",
      "event_cluster_id": "877d0ee7-3726-4284-a1ed-d3b7c9b6d67b"
    },
    {
      "claim_cluster_id": "281fca06-ede2-40bc-9960-0788b1d20c23",
      "event_cluster_id": "8a12c9b8-6999-4708-96d0-9b9b5cea643c"
    },
    {
      "claim_cluster_id": "d6760008-6cbf-4c8c-b88a-b478081312d0",
      "event_cluster_id": "b49e3614-d80a-41ae-8ee2-883e8abec97f"
    },
    {
      "claim_cluster_id": "37f5cf93-69fa-41bf-960a-1fd7783d4299",
      "event_cluster_id": "5ccf3948-9cc8-42f4-a17d-9079c20482ce"
    },
    {
      "claim_cluster_id": "c7013046-8aa1-434c-87b8-1e3317f5578c",
      "event_cluster_id": "4586dde9-ed48-4b34-aa3d-9d5f004f908c"
    },
    {
      "claim_cluster_id": "60269200-21dc-4ddd-bed2-414eb8acfbb9",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "746085cd-6635-459a-8b25-138f4d67d9dc",
      "event_cluster_id": "08ccb8f3-d97c-4442-b830-fac7f751221a"
    },
    {
      "claim_cluster_id": "09505049-ee83-46bc-bc41-216c4501ccc0",
      "event_cluster_id": "25676d7b-137f-4f70-b3ce-39af6bc7a4fe"
    },
    {
      "claim_cluster_id": "9a03a84a-f375-4382-bf36-e4f5df1b4795",
      "event_cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c"
    },
    {
      "claim_cluster_id": "64b58fdb-7776-47be-a603-30c85a60366e",
      "event_cluster_id": "31351498-4fc3-4c6e-8df2-7c515d19509b"
    },
    {
      "claim_cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "event_cluster_id": "df593162-9ce4-4407-acdb-640e7602b7fc"
    },
    {
      "claim_cluster_id": "d2f81fce-8c92-45e8-8294-41af7752f1db",
      "event_cluster_id": "238a575a-ac72-4ae9-8880-72409a39a327"
    },
    {
      "claim_cluster_id": "38711d17-ac82-464c-a077-7a82e0d362fd",
      "event_cluster_id": "2130a389-a1b6-4f7d-b3bc-7b83efb0ab8e"
    },
    {
      "claim_cluster_id": "252d476c-5ce3-4a28-9ab5-6406955b15b2",
      "event_cluster_id": "4ddb3ea0-b81e-40cf-8c94-adef57bca158"
    },
    {
      "claim_cluster_id": "f8d5c2ae-ad96-41f1-8875-2d89a574f697",
      "event_cluster_id": "1d8821bb-7f0e-41b4-86e3-603f9228f781"
    },
    {
      "claim_cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "e53d664b-c538-43f3-a025-7686ca315f8a",
      "event_cluster_id": "1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "8f75e655-8582-4cb0-9320-47aef61dad78"
    },
    {
      "claim_cluster_id": "3da4f222-08f1-4864-8aa3-3576d8a64207",
      "event_cluster_id": "805b132f-a73a-418b-a147-d9899a145b6b"
    },
    {
      "claim_cluster_id": "17326b3f-1222-43e5-90d5-e26c86b0e984",
      "event_cluster_id": "8abd35db-2186-4408-8be6-3af382d275ab"
    },
    {
      "claim_cluster_id": "e0b3b058-f41a-4ebc-b9bd-9e20a141c340",
      "event_cluster_id": "c213afe5-5445-4f82-8c73-fbf8e0f02000"
    },
    {
      "claim_cluster_id": "468c9eea-e420-4271-9b73-0e2e747f6185",
      "event_cluster_id": "c92757d9-a065-4dc2-806f-96c7c9890f76"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "adcf9b34-2bf2-44ce-9216-0201823c4649"
    },
    {
      "claim_cluster_id": "0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f",
      "event_cluster_id": "d821d63f-63c7-4a38-a3fa-ddd32322fec9"
    },
    {
      "claim_cluster_id": "221f2ccb-c412-4e42-8d5c-82e681a61d32",
      "event_cluster_id": "a4bb7e8e-38b8-4326-bf96-4782b99feba1"
    },
    {
      "claim_cluster_id": "bd6de2da-8b5f-4e38-83bd-28294e175aca",
      "event_cluster_id": "ea8c27e8-3141-489f-a75f-e180b110cc1b"
    },
    {
      "claim_cluster_id": "c3dda95e-e922-4b18-b7fd-9f071350fa6d",
      "event_cluster_id": "d2250c76-7e85-4e68-9f7d-cb54aa712276"
    },
    {
      "claim_cluster_id": "bfd0fa79-f057-4e1b-abfc-222496dbeabb",
      "event_cluster_id": "f2531848-788a-44fc-8497-b2d0aa74b135"
    },
    {
      "claim_cluster_id": "cce124fe-f108-4571-9074-db48a458127d",
      "event_cluster_id": "2fba36c8-9087-441b-9f3b-6c08ceeffdb2"
    },
    {
      "claim_cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "event_cluster_id": "3ad1f302-26c2-471c-bf5f-e79fa32778b5"
    },
    {
      "claim_cluster_id": "2cb0cf7d-4f72-4e53-9096-b92c1763568c",
      "event_cluster_id": "0357efdc-cefb-46e1-88fc-fd184c29a753"
    },
    {
      "claim_cluster_id": "a6506a53-789c-4447-b726-b2dd59d9b862",
      "event_cluster_id": "637ffe03-032a-46cd-af4f-d7f5c220eab9"
    },
    {
      "claim_cluster_id": "989e42eb-c62e-4e68-87e6-6b230317d087",
      "event_cluster_id": "b36258d9-8de3-4cee-b76a-8d1ee69dd79c"
    },
    {
      "claim_cluster_id": "4e71d535-1646-4ea5-9c47-04fb1464f390",
      "event_cluster_id": "3c37960f-c2a7-40e7-ba67-6890fc5f05e4"
    },
    {
      "claim_cluster_id": "5ece0141-8dd6-405b-93cf-5585050f4efe",
      "event_cluster_id": "a66bb7d0-dc6f-4116-a7d1-4f4c8d7be3a8"
    },
    {
      "claim_cluster_id": "558484b7-ac90-44c3-8eec-a2f364ca9460",
      "event_cluster_id": "a548b0a4-9a63-47ec-a6ab-6b9d50ab7aaf"
    },
    {
      "claim_cluster_id": "0e92b3d1-2946-4cb0-a0ae-5e9e0cf674a5",
      "event_cluster_id": "aab98ee7-4c57-4777-942d-e109c08eee52"
    },
    {
      "claim_cluster_id": "cbbcd94e-9982-4e51-989e-706618e8fd67",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "event_cluster_id": "752ad0a4-463c-4695-a371-bfed4c14cfc2"
    },
    {
      "claim_cluster_id": "834f4385-ef2b-4b12-81b1-8e94ff3098e8",
      "event_cluster_id": "e4820af7-bf5b-455e-a72e-bb48cada6e0a"
    },
    {
      "claim_cluster_id": "aa973fc5-c596-49d2-86f1-80f2a9f419e9",
      "event_cluster_id": "20eb00aa-eba7-4ec7-aca2-e9f771d49a23"
    },
    {
      "claim_cluster_id": "09287807-b3db-4547-9baf-8656d4a8733f",
      "event_cluster_id": "0dc901d8-d48c-4458-a536-133dced8eb99"
    },
    {
      "claim_cluster_id": "cebef5fc-6d79-4e08-878b-8c75696aa6d2",
      "event_cluster_id": "e21a96d2-b5b0-4a69-80bb-66020b0b8a54"
    },
    {
      "claim_cluster_id": "000d729d-1afe-4b59-b42a-5d8012efd354",
      "event_cluster_id": "802c356d-4c20-44e7-ba85-44dda5294d0b"
    },
    {
      "claim_cluster_id": "09287807-b3db-4547-9baf-8656d4a8733f",
      "event_cluster_id": "a35296f0-09b1-4344-8dc2-fa3ee1b2f399"
    },
    {
      "claim_cluster_id": "86160f22-53c1-4e04-a28d-86c0e883fa44",
      "event_cluster_id": "c9858cae-3215-44c8-9820-2f7cde47d95d"
    },
    {
      "claim_cluster_id": "784725f9-7f56-4fd8-bbd1-9c94d01f5505",
      "event_cluster_id": "d0ea565b-64ab-44f3-9679-c2236d37aa42"
    },
    {
      "claim_cluster_id": "2fa38dbd-c491-4579-bb95-e37ac00e125d",
      "event_cluster_id": "02dbbaf3-2dcd-4ef2-b716-bd9080164205"
    },
    {
      "claim_cluster_id": "36472627-9945-496e-89a2-063ceee22d24",
      "event_cluster_id": "5437d23d-a8b8-4a7b-b296-c42b5945a223"
    },
    {
      "claim_cluster_id": "767a107b-6141-45c6-9ffe-6f7fde1b3426",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "0f733538-ef56-427f-ad23-04cb6fae87ae",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
      "event_cluster_id": "e90ef9df-5189-4af1-8d38-f4bc22fa022a"
    },
    {
      "claim_cluster_id": "c5d18c78-4df0-44fa-9f69-67266b1079e2",
      "event_cluster_id": "d18f265e-1140-4ce3-9bf4-76f0c6ccf8de"
    },
    {
      "claim_cluster_id": "ef636ecf-8b34-4007-8f71-b4d5ed7d3c33",
      "event_cluster_id": "ddb7dbbd-226e-4674-859d-8c16b4f4ce9e"
    },
    {
      "claim_cluster_id": "ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb",
      "event_cluster_id": "a5511c2f-b2db-4795-9bb8-2441a998fd2e"
    },
    {
      "claim_cluster_id": "fa32fcee-2bb1-444a-8515-123065611c9e",
      "event_cluster_id": "f5c0430d-6c19-4e4b-815d-7de708ba52a8"
    },
    {
      "claim_cluster_id": "17be823a-a533-4e33-9ba0-969c3b8ddbd0",
      "event_cluster_id": "350bc7fa-e017-468b-abf6-4d1ab1633f69"
    },
    {
      "claim_cluster_id": "901f6891-5f9b-4fa4-a368-69a4f20e9617",
      "event_cluster_id": "c595259b-ebf4-4c2b-b3d7-406a6b1c52ac"
    },
    {
      "claim_cluster_id": "58021478-0a50-495e-b059-4560ef7c90f4",
      "event_cluster_id": "7ccf5ec9-3916-43b6-a44f-7cfb24300693"
    },
    {
      "claim_cluster_id": "949ec20d-24b3-4de5-a36b-32e35cbe9392",
      "event_cluster_id": "b9c0c358-d5e1-4c6e-9602-a307115394e0"
    },
    {
      "claim_cluster_id": "28e936b6-8a48-4d96-b4e6-7c0ff60a51fd",
      "event_cluster_id": "f004205a-4f06-4d9f-aafe-357afc465bbc"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "0208ef8f-f321-4a60-8e1f-9ae03308e345"
    },
    {
      "claim_cluster_id": "199ae7ec-217a-4cab-a030-ff0a4838c0a8",
      "event_cluster_id": "96dc4289-9f74-41d4-905d-780af68fcb09"
    },
    {
      "claim_cluster_id": "9477ce9c-5a6e-4e61-9f13-cf68c95b219f",
      "event_cluster_id": "35b22dab-25ce-4dde-ab9f-31302b06eb90"
    },
    {
      "claim_cluster_id": "f42001e5-7364-43c2-8d35-74c3552a9ccb",
      "event_cluster_id": "c9720688-df71-4db3-980b-d7e5c9b865b6"
    },
    {
      "claim_cluster_id": "b4fd3f81-2344-4edd-8ae4-fd7b59d99888",
      "event_cluster_id": "0473444c-8fc1-4828-8ed2-8a53db5a4083"
    },
    {
      "claim_cluster_id": "2ac87cef-db31-40dd-8c5e-d88d478fd344",
      "event_cluster_id": "fcff6be0-ae06-401d-8c01-25c7bfff466f"
    },
    {
      "claim_cluster_id": "63fb8530-c54e-452a-b71d-729fca3c7e67",
      "event_cluster_id": "75ded654-747a-4edb-9577-5b6d8ad0c3a1"
    },
    {
      "claim_cluster_id": "32bf3674-86a6-4cde-a9e5-20a5e3965e02",
      "event_cluster_id": "e91dd131-96fc-484a-8d0e-4bac856ecd99"
    },
    {
      "claim_cluster_id": "10317341-49c9-447e-bafb-6ef554948da9",
      "event_cluster_id": "99d7c1e6-04d8-4af7-b4d1-8b1bbaa99691"
    },
    {
      "claim_cluster_id": "7e639892-5cda-4557-94c4-87321bdc3233",
      "event_cluster_id": "5674d01b-2996-4ed7-850d-de449d707ce5"
    },
    {
      "claim_cluster_id": "4d2dc30e-97f5-49d3-80df-c343048e6856",
      "event_cluster_id": "d918fb3a-9d62-4cdd-89a1-68fdc8de204d"
    },
    {
      "claim_cluster_id": "0aded89b-0a86-47dd-8291-b59848abe762",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "91ccf699-eaec-41a7-8213-08934dbe2395",
      "event_cluster_id": "419042ff-8e55-4ecd-bd38-c47ada6d614a"
    },
    {
      "claim_cluster_id": "266128fe-9d68-4687-b95c-b0654a1c7f0e",
      "event_cluster_id": "b4d1a337-88d8-4989-8d52-1a04d38e6e21"
    },
    {
      "claim_cluster_id": "551e444f-6554-45dd-baba-6798fd43af6b",
      "event_cluster_id": "f508c62e-4dcd-4831-9789-bacd1b75b831"
    },
    {
      "claim_cluster_id": "c98491ce-51cb-40b0-93ae-d389e1c9d7a5",
      "event_cluster_id": "7a1c3f26-b729-4a3f-8142-fcd9c6768773"
    },
    {
      "claim_cluster_id": "d96c8f5c-4bb9-48ae-8d6d-0625e7b9a576",
      "event_cluster_id": "f5784495-7eb1-4199-8e36-89b434da6e01"
    },
    {
      "claim_cluster_id": "6c812e58-19af-4264-b856-e922307ab466",
      "event_cluster_id": "adf7c833-60db-4866-83b7-e6d0f1133790"
    },
    {
      "claim_cluster_id": "d87f03ea-124e-4e30-80f4-ce890ca4d97b",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "a5d39319-660b-4b6e-acb4-246464538db6",
      "event_cluster_id": "9db91412-4257-4b55-b7af-99ea85b2a619"
    },
    {
      "claim_cluster_id": "7561e4ca-9d0c-4966-9181-2c8e8d681852",
      "event_cluster_id": "afed780e-77ff-46bf-ac41-4e66698ad45e"
    },
    {
      "claim_cluster_id": "41d64b2b-508f-4c89-9c48-7c598989efd1",
      "event_cluster_id": "47b5a921-4ec9-4534-86e3-d697a2a00470"
    },
    {
      "claim_cluster_id": "18fe8f4b-896d-47b4-a019-0383dc22d38e",
      "event_cluster_id": "29022861-4975-4c12-9a9e-92bb32cd1e85"
    },
    {
      "claim_cluster_id": "0c398c2c-4672-4f1e-ba98-17d7320a9537",
      "event_cluster_id": "7b1f2cfc-5328-4132-ac99-4d91818f60f6"
    },
    {
      "claim_cluster_id": "8a0accb4-caf5-4741-9038-3360a1a08c25",
      "event_cluster_id": "eaf67764-9289-414e-b58d-ac157f48690c"
    },
    {
      "claim_cluster_id": "1c30353a-a7dc-48dd-bca2-56c91aa06ab6",
      "event_cluster_id": "0d5de813-beee-4fba-8db1-09461ff50d02"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "cd034398-fb5e-493c-9a4b-be08f05b5ca7"
    },
    {
      "claim_cluster_id": "97e04a01-6626-4196-a12d-eac1df348581",
      "event_cluster_id": "95af035b-c14e-4753-b211-c4a8a4ddbdf2"
    },
    {
      "claim_cluster_id": "b7635b58-ad1e-4cb4-a317-8d48ce1cdddd",
      "event_cluster_id": "2e33e564-22f6-46fe-85d8-8500ce2d3380"
    },
    {
      "claim_cluster_id": "3ea1c92f-805f-4ecb-b23d-a77a7a362e5b",
      "event_cluster_id": "40612f57-e760-4270-afaa-ede3763cda33"
    },
    {
      "claim_cluster_id": "cebef5fc-6d79-4e08-878b-8c75696aa6d2",
      "event_cluster_id": "7e303676-78ac-40b1-9448-471faabb2115"
    },
    {
      "claim_cluster_id": "543e79b8-1458-43e8-a976-eaa0fcb652ab",
      "event_cluster_id": "be58ac09-a64e-4854-a7b4-83f25a02c250"
    },
    {
      "claim_cluster_id": "d8581e68-7fcf-4616-92c1-9daff0a2d8ae",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "232994db-dcd7-4db4-9ea3-fad6185233a7",
      "event_cluster_id": "b89167c2-18ac-44c5-84c6-4b246cc9bd50"
    },
    {
      "claim_cluster_id": "b27abfde-f9d9-4f52-9ce7-8c541388281c",
      "event_cluster_id": "59c81fc9-37c0-4304-9d97-9e5694d8be20"
    },
    {
      "claim_cluster_id": "a3a558f9-9b36-49bc-be77-b1d77d8074f6",
      "event_cluster_id": "fec224cb-9f4c-46ad-af9f-03437451a2c2"
    },
    {
      "claim_cluster_id": "691c3c1b-0058-48a0-aaa7-5a38747b8c58",
      "event_cluster_id": "722d06bc-1512-434a-8214-a8daff8fb8a9"
    },
    {
      "claim_cluster_id": "b26a4469-2931-4dab-aa78-be1b6fba8a36",
      "event_cluster_id": "9f686d1d-9231-4037-982f-0d37e6ded860"
    },
    {
      "claim_cluster_id": "a4182192-73bb-4165-ad72-05ff39be899d",
      "event_cluster_id": "f4bde172-477b-497a-9e85-fb7b55ca0d1c"
    },
    {
      "claim_cluster_id": "62fbb5b2-0ba7-4211-b72a-eb1c18543408",
      "event_cluster_id": "907e5aa7-c645-41eb-a469-330fec247119"
    },
    {
      "claim_cluster_id": "f9741213-db12-438e-ba4b-5df13a3381e4",
      "event_cluster_id": "48b7513c-41a4-4a7e-876a-36f9b1eed5df"
    },
    {
      "claim_cluster_id": "cd2c9191-f97a-49fd-9d7d-f0744cdaaf72",
      "event_cluster_id": "93df5ce1-4286-44c4-8457-3b0ae5570ff2"
    },
    {
      "claim_cluster_id": "fa79376c-183c-4b27-9b35-5eee39b30f87",
      "event_cluster_id": "ac328a78-ba12-4fbf-888f-9c3c8967ccba"
    },
    {
      "claim_cluster_id": "310f4e19-f7f5-403e-af6f-b2064fadd246",
      "event_cluster_id": "6f277c5a-d392-4a17-b884-6fd70ae638a3"
    },
    {
      "claim_cluster_id": "14ffc7a5-e5c3-48de-a2b4-8b721ff34fcc",
      "event_cluster_id": "a7783b6a-7d1f-4493-9664-55b728cadb9e"
    },
    {
      "claim_cluster_id": "e64bcf93-086e-429d-9ff7-3a1518b3ae51",
      "event_cluster_id": "8a12c9b8-6999-4708-96d0-9b9b5cea643c"
    },
    {
      "claim_cluster_id": "4801b48a-d91c-4dc3-9797-76929432b0ef",
      "event_cluster_id": "9ff255c3-3bb1-4b2b-8446-496debbb40e2"
    },
    {
      "claim_cluster_id": "b654c64c-3acf-45f6-a6ea-c4584b8c70fe",
      "event_cluster_id": "afc9e303-f841-4627-a50f-c58cb00a2220"
    },
    {
      "claim_cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "event_cluster_id": "f9d888bd-a05c-4b7c-9a69-097ffb41a69e"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "65f3a4f7-31a9-4a5f-92ab-a9f153d96b50"
    },
    {
      "claim_cluster_id": "5d4bd659-348a-4fe3-bacf-eb25b0043f94",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "0c0cca84-dd68-41a0-8489-cb2d22400e3a",
      "event_cluster_id": "1480b5d9-5e00-461a-b194-d322e838f544"
    },
    {
      "claim_cluster_id": "beb979e4-f486-4e3c-ba15-47b099971ff0",
      "event_cluster_id": "65ac3d2f-1144-42ab-9435-1522b78a54a3"
    },
    {
      "claim_cluster_id": "203655c2-f1ad-4fb6-94c5-5fc8218603d3",
      "event_cluster_id": "50ed7708-9545-452f-b227-8fc95b9490b9"
    },
    {
      "claim_cluster_id": "ab52850c-7dc5-4f99-b37e-0c628b078043",
      "event_cluster_id": "d53cdbb5-0ed7-4595-a5cc-31ff93c45b69"
    },
    {
      "claim_cluster_id": "54a8d4bb-c88c-46df-a439-6be0dfcdce0d",
      "event_cluster_id": "5b49dda1-0066-4031-bd05-509e4245118d"
    },
    {
      "claim_cluster_id": "c0426c3e-a327-4be7-b689-905cba5cdfca",
      "event_cluster_id": "7130da69-c674-4096-9b2f-90376c9466d7"
    },
    {
      "claim_cluster_id": "4ada70f8-8bb6-4995-8f14-e79e769b0629",
      "event_cluster_id": "61ee629a-3d51-41dc-9089-461569ecf949"
    },
    {
      "claim_cluster_id": "25acea26-0f6c-421d-8050-ebc9dac75b8d",
      "event_cluster_id": "d7ce0029-7c2c-40fb-8d24-32029ffa4b81"
    },
    {
      "claim_cluster_id": "e7e80c41-a749-4b0c-a666-715bedd44f52",
      "event_cluster_id": "3fee6535-a988-4207-9d1e-737120abbcbb"
    },
    {
      "claim_cluster_id": "e36180c3-afe0-495c-8168-73e631f50a1c",
      "event_cluster_id": "749b6cb0-84a3-49bb-a39c-84a371599d47"
    },
    {
      "claim_cluster_id": "528a9885-82c7-4bee-beac-f85e4c7c3f1b",
      "event_cluster_id": "97818d6e-d8de-47c2-bddb-148ab8c2d1b7"
    },
    {
      "claim_cluster_id": "558e806a-d249-4f8a-8e7e-fb4b28552537",
      "event_cluster_id": "e8d4709f-937a-436c-a2c9-ff8bff8819ca"
    },
    {
      "claim_cluster_id": "170448e1-fefc-424b-b5a4-23941f88389e",
      "event_cluster_id": "4aba8ac6-afc1-46c8-8568-0d2d6d6bddaf"
    },
    {
      "claim_cluster_id": "bd0e72d0-0f07-4c8e-ba6f-6a4178be6cee",
      "event_cluster_id": "978027c6-a544-4944-bbb9-ca0424967ff9"
    },
    {
      "claim_cluster_id": "38d2a616-9f37-42ea-8e5e-3010dc76a2ba",
      "event_cluster_id": "bc347754-e0eb-40ff-81ea-81da10f629ed"
    },
    {
      "claim_cluster_id": "a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0",
      "event_cluster_id": "b5cfe764-3a89-4e77-9f9e-c720d7d22394"
    },
    {
      "claim_cluster_id": "0a8b23b0-e002-4dc9-aefa-6b8b8922f3ff",
      "event_cluster_id": "39994f31-5ff9-43be-a15d-3547ec296a5a"
    },
    {
      "claim_cluster_id": "28aee566-0979-4444-a6e1-cda00f681d91",
      "event_cluster_id": "d96ea11e-5d88-4a27-8ab4-66bfb4326c28"
    },
    {
      "claim_cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "event_cluster_id": "4027d10f-7288-4413-85e7-b5b47209b817"
    },
    {
      "claim_cluster_id": "c5298737-21d9-47c4-b52e-e662ee88b15b",
      "event_cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14"
    },
    {
      "claim_cluster_id": "edec9892-cca5-4a34-b102-ebb0bb45e077",
      "event_cluster_id": "9ec7d104-4eab-4fd5-9ba5-4ccd50945a34"
    },
    {
      "claim_cluster_id": "8d20ee1c-7a34-4de3-a19e-635d0eb460b0",
      "event_cluster_id": "da38f087-665c-4abb-8af5-ed1c3c09563d"
    },
    {
      "claim_cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "b26a20fa-d793-419d-b599-26d1ed57c2b3",
      "event_cluster_id": "6f732a42-b524-4da0-a300-f64610c49d4f"
    },
    {
      "claim_cluster_id": "9d1065d7-3830-4746-a836-8da581c0bbb5",
      "event_cluster_id": "d6e26a99-056e-4587-a461-8e9b192ce947"
    },
    {
      "claim_cluster_id": "595531c2-a2b0-4686-b3ae-4f5525fff05a",
      "event_cluster_id": "de3dd2d3-d79d-4172-a1cf-b6ac1238b295"
    },
    {
      "claim_cluster_id": "68637c5d-53b2-4a1b-b193-4fe1333f1416",
      "event_cluster_id": "24603ad6-f39a-4706-80ce-2840439ad61c"
    },
    {
      "claim_cluster_id": "11e43ecc-22c8-4f1c-b13a-fb97013ce963",
      "event_cluster_id": "294c224e-4fa2-412c-a08d-02a89eff2a7b"
    },
    {
      "claim_cluster_id": "4a575d85-5f97-4baa-be78-2c26ecefb471",
      "event_cluster_id": "2d8ca62e-1cf1-4407-a036-bf48f62909c5"
    },
    {
      "claim_cluster_id": "fdec6a13-5351-4fa5-9920-1456738e3b76",
      "event_cluster_id": "14c3f0e3-2371-447c-8445-1ac6c299f633"
    },
    {
      "claim_cluster_id": "03ec1dbc-4ed4-48f3-b875-cc73a019f7f0",
      "event_cluster_id": "a8cd7286-4d2f-4b1f-877f-75865a61f584"
    },
    {
      "claim_cluster_id": "7bfb1246-c004-4c78-a34d-8e0a5cdad287",
      "event_cluster_id": "fe5794f0-39d5-4958-9baa-650967c24ce0"
    },
    {
      "claim_cluster_id": "d9041723-b3d2-4f6c-85e6-435010ef6231",
      "event_cluster_id": "21aa3ba8-e0ce-434f-bbd4-03d295297e84"
    },
    {
      "claim_cluster_id": "469e17e6-447a-4bc6-9bab-f2cb595f07e0",
      "event_cluster_id": "a7fcff89-a4a0-45c3-b800-3d7861e64986"
    },
    {
      "claim_cluster_id": "28e936b6-8a48-4d96-b4e6-7c0ff60a51fd",
      "event_cluster_id": "72fcc1d4-63ac-46e2-af29-194e69352aec"
    },
    {
      "claim_cluster_id": "c25095fd-de4f-41d0-8719-35f31e51779a",
      "event_cluster_id": "37e4b5f9-aa2b-41cd-b6a4-443e69596bba"
    },
    {
      "claim_cluster_id": "d6609854-87fa-44e4-a436-a7b597944aa1",
      "event_cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6"
    },
    {
      "claim_cluster_id": "4c95b4a9-d005-4c7c-8a55-a5a0821d7611",
      "event_cluster_id": "5035fa8a-cb8a-4b4a-a412-c85f5b3586dd"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "e82f3b8b-97c9-4869-b282-3dfd951ace47"
    },
    {
      "claim_cluster_id": "dad2ba1b-78a6-4e69-91a7-e473e3d79e42",
      "event_cluster_id": "cc256628-cc7d-493f-98f7-e2382cb4b346"
    },
    {
      "claim_cluster_id": "d3ee5536-f1ec-4a1b-9b1a-82ff92aa04a4",
      "event_cluster_id": "437a3d9b-28c4-4057-94e1-09375ae72bc9"
    },
    {
      "claim_cluster_id": "c3383556-4a09-4d9a-b202-b1b017162bd3",
      "event_cluster_id": "bf80dbed-695d-42ab-adf5-4b079e397c99"
    },
    {
      "claim_cluster_id": "f6b9e37f-45a9-4864-8489-2f475476f4fc",
      "event_cluster_id": "eb91a168-c109-40bf-9679-0913a309af40"
    },
    {
      "claim_cluster_id": "15b9ef6b-09b3-4dc2-aa2e-09ba6d46709a",
      "event_cluster_id": "efabc150-323f-4c88-9041-fa0370310d1e"
    },
    {
      "claim_cluster_id": "f6b9e37f-45a9-4864-8489-2f475476f4fc",
      "event_cluster_id": "8bfd9054-2484-4b95-af6e-1881fb8804d9"
    },
    {
      "claim_cluster_id": "70a36c06-fbb9-4f71-bf77-74f433672b24",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "9012b6f3-2c16-482a-b276-63925d342482",
      "event_cluster_id": "635251ae-6796-4c05-a3b4-938f1760fe23"
    },
    {
      "claim_cluster_id": "d08db747-1994-456e-82f1-cca372892842",
      "event_cluster_id": "2197b0cf-d748-489f-aa22-936ee02a0c14"
    },
    {
      "claim_cluster_id": "abd83725-20da-4a40-a5cf-bb6715d5460b",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "5ebc5950-a889-49b1-a0d8-0d905803d030",
      "event_cluster_id": "b14f50e3-04b1-4e58-a4b1-8a1de6c4e2d2"
    },
    {
      "claim_cluster_id": "0e92b3d1-2946-4cb0-a0ae-5e9e0cf674a5",
      "event_cluster_id": "24658627-4999-4848-a061-5b2350a4cf4b"
    },
    {
      "claim_cluster_id": "ec868d12-f24d-450d-bca9-2e8a9f4e8021",
      "event_cluster_id": "ed28ca5b-2948-4f9e-a9bc-a57f2f3f7cbd"
    },
    {
      "claim_cluster_id": "463ff506-01da-43ee-96ab-3704e89855e2",
      "event_cluster_id": "1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"
    },
    {
      "claim_cluster_id": "99bf6cc4-ca7c-40f2-9d7f-294c761aeaaf",
      "event_cluster_id": "34a1784c-8849-4447-8724-747b9b1cd1bd"
    },
    {
      "claim_cluster_id": "bd7226f9-5942-4c7e-a2e1-156f8c1e7b81",
      "event_cluster_id": "6eae5590-4ea2-4d5f-b4f2-a402cc15dbc9"
    },
    {
      "claim_cluster_id": "71acf2d0-be7b-4d8e-b3fc-93baaa073aa1",
      "event_cluster_id": "3277c81f-d2ed-42ea-acc4-bb977e68f163"
    },
    {
      "claim_cluster_id": "ba694c90-be36-448b-9da2-f3ed0d816139",
      "event_cluster_id": "68f4e1e3-51cf-46cb-8e4c-826f56e18aae"
    },
    {
      "claim_cluster_id": "11c93b57-586c-4cef-a254-66245b297aca",
      "event_cluster_id": "f0bf93b5-3fae-4f3e-8e8b-13d89108a924"
    },
    {
      "claim_cluster_id": "9594285e-8196-4153-9b31-89250a7200d5",
      "event_cluster_id": "d7ce0029-7c2c-40fb-8d24-32029ffa4b81"
    },
    {
      "claim_cluster_id": "cbbb2109-39b9-4308-a4ce-30a48563cab7",
      "event_cluster_id": "a9534c6f-c812-46b1-a237-7680deaae455"
    },
    {
      "claim_cluster_id": "b877e703-7bf9-4587-919b-bf207b22c607",
      "event_cluster_id": "a22c2709-36d1-4c69-91df-446cf30d0361"
    },
    {
      "claim_cluster_id": "d6760008-6cbf-4c8c-b88a-b478081312d0",
      "event_cluster_id": "e2ca3c4e-ab36-4cff-8fb9-fa527a161a3f"
    },
    {
      "claim_cluster_id": "e03ac9ce-f105-49c9-9a2f-9442b3b31044",
      "event_cluster_id": "341aa4ce-b339-4cde-b356-d8223a398402"
    },
    {
      "claim_cluster_id": "5c1d5636-b62a-4962-911d-1136d9629b6a",
      "event_cluster_id": "d81a0c92-8b3c-4dd5-8534-db608b237cf8"
    },
    {
      "claim_cluster_id": "bbf2648f-d211-49b0-bf5c-a562e43902c5",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "df20aee7-4e88-4c5d-a2d1-ce862c311713",
      "event_cluster_id": "b5041259-ba71-468c-b2f9-83e8ea0057c6"
    },
    {
      "claim_cluster_id": "f731bc0b-cabf-4314-a5f8-e94d31589cea",
      "event_cluster_id": "af431814-360b-4c41-83d1-6147d4068846"
    },
    {
      "claim_cluster_id": "0f3a2cc5-8301-476a-b658-747594635542",
      "event_cluster_id": "273cff70-66df-48dd-9efa-69156787ee64"
    },
    {
      "claim_cluster_id": "aa908c8f-4075-45ac-a932-631e5efec76c",
      "event_cluster_id": "e90f8735-8232-4af5-85c8-b777502c4f0b"
    },
    {
      "claim_cluster_id": "eea02be7-fd53-47b5-9804-7a2f89de23f2",
      "event_cluster_id": "0d76345c-1ef8-406a-a4b5-284717ab866d"
    },
    {
      "claim_cluster_id": "fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec",
      "event_cluster_id": "ecf70116-2753-4a2e-946e-961f8655a246"
    },
    {
      "claim_cluster_id": "d832a602-46fe-4c29-83ff-f47197eab057",
      "event_cluster_id": "1343596d-8a4d-4776-9d4a-d41490b7cb7b"
    },
    {
      "claim_cluster_id": "de30ed78-2cf8-480b-aacb-665d9572f1b4",
      "event_cluster_id": "7767496a-74e6-483e-a0d3-11edd8016ac2"
    },
    {
      "claim_cluster_id": "ac1a90d2-3517-43fd-8e60-dd7d570db743",
      "event_cluster_id": "e2a8c8cd-cdce-473b-b2cd-fa97668f4fb5"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "591d0c93-3cfa-4639-9dee-c69a3f6b0f9b"
    },
    {
      "claim_cluster_id": "a7d1cc33-aa3a-4ee3-86f6-065986a716af",
      "event_cluster_id": "80adf73d-0e40-41bf-902a-efc33053db25"
    },
    {
      "claim_cluster_id": "773a0c25-df3d-4865-86dd-a73825ed69b0",
      "event_cluster_id": "a685f849-800e-4402-90fe-e957d6fe91e6"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "0af9e942-0bcb-4d79-81df-118cf826ff70"
    },
    {
      "claim_cluster_id": "67d719d1-a600-418b-b08c-286005c2cb08",
      "event_cluster_id": "94f3a60f-f903-4813-b891-508644ee87e0"
    },
    {
      "claim_cluster_id": "d21ce376-5e68-41d1-903e-db8ea2f295f8",
      "event_cluster_id": "b98f7184-2007-47d3-9d06-42431c2a8c92"
    },
    {
      "claim_cluster_id": "9fb5216e-3d0c-403e-a2bf-9368fa3e3592",
      "event_cluster_id": "108f968f-7171-480b-9225-ebaea32953bb"
    },
    {
      "claim_cluster_id": "b865573b-6b72-46cd-b3c0-a1458e7df010",
      "event_cluster_id": "a5ff0407-3f9a-4c9e-b0e5-8fe919998cf3"
    },
    {
      "claim_cluster_id": "1cd94f5b-6850-44c5-b48e-2bcdab6eefd2",
      "event_cluster_id": "f8408d7a-6690-478f-a0da-8baa781f898e"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "acddf1eb-d6f9-4c70-9523-034fc5a8acd5"
    },
    {
      "claim_cluster_id": "e4e03461-6763-4291-b9e4-bd4feccb46e2",
      "event_cluster_id": "b04942a2-8d33-487f-9e37-33193a4bf9b5"
    },
    {
      "claim_cluster_id": "f5a86628-9ae6-4d94-ad96-d00a9cad52bb",
      "event_cluster_id": "fc20c413-7f2c-4fbe-b8d9-0aab094ec5bd"
    },
    {
      "claim_cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "event_cluster_id": "db350168-e89e-48c8-a5ce-3b8c59130017"
    },
    {
      "claim_cluster_id": "43e40d68-962f-4fc6-83f4-ab836f751e9e",
      "event_cluster_id": "b10b3160-e0dc-461b-a456-f6327586eb6a"
    },
    {
      "claim_cluster_id": "e4184b4a-b3b8-45cd-9a60-442e840d1a7e",
      "event_cluster_id": "90594f77-57da-4d80-a85e-ef6c61b0cc03"
    },
    {
      "claim_cluster_id": "4c6dd811-1cc8-4f37-9fa7-2bc4bf91d082",
      "event_cluster_id": "b86b1a76-d691-4bc6-9266-214b0cf4e6f3"
    },
    {
      "claim_cluster_id": "b60fefc6-3713-474d-b9b3-03ebad7a4f1c",
      "event_cluster_id": "9bb19a50-cefb-44ce-9b28-e30fd2969d96"
    },
    {
      "claim_cluster_id": "fd554d0c-cd25-4da2-adf1-dcccfd01f292",
      "event_cluster_id": "afc0b94b-3d14-41ac-a746-8c4fbe3bd721"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "b5e4c53f-7f15-4f0d-b014-ab5bdfef9779"
    },
    {
      "claim_cluster_id": "34e272f8-beb9-408f-a252-0fa71406dc4b",
      "event_cluster_id": "96b1dd29-d1cf-4ea9-9b10-e52b59e1a6b5"
    },
    {
      "claim_cluster_id": "cf8a7c88-fcb8-4b8d-aadb-46cb3168db25",
      "event_cluster_id": "220dfe6b-2774-4a8a-8306-3094dfce156d"
    },
    {
      "claim_cluster_id": "10317341-49c9-447e-bafb-6ef554948da9",
      "event_cluster_id": "1dc64c65-d91b-4753-b1f9-a4cf4ca41268"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "4e7a1657-2c4e-4bb2-bcd7-0842a01bbc47"
    },
    {
      "claim_cluster_id": "6e99d559-c095-46a1-a671-2a3d2e8566bb",
      "event_cluster_id": "07b1d44b-f7cd-4319-883a-80ea44f07316"
    },
    {
      "claim_cluster_id": "de08eb08-92b3-4974-9e99-e79755582996",
      "event_cluster_id": "f8408d7a-6690-478f-a0da-8baa781f898e"
    },
    {
      "claim_cluster_id": "e1ad3c4e-eefb-42e0-8fe7-edf486c4da19",
      "event_cluster_id": "2528bd46-af3f-4f9d-8f91-2dbf49b3388e"
    },
    {
      "claim_cluster_id": "ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb",
      "event_cluster_id": "1faa4831-480b-4038-9fea-49267683c570"
    },
    {
      "claim_cluster_id": "9398c496-5e62-4d1b-94c1-e1eeaf48778c",
      "event_cluster_id": "46b03cb2-bbc6-4b28-b240-16cc3f30e3bc"
    },
    {
      "claim_cluster_id": "c214c388-1bcb-48de-9ccf-d250135ec39d",
      "event_cluster_id": "a1591642-57e8-440b-a466-b4c02f9a6be6"
    },
    {
      "claim_cluster_id": "837dbefb-7b54-4aa1-aad3-56f0ea97f9ed",
      "event_cluster_id": "8914f459-9cc2-4812-af44-1d97ee5106e3"
    },
    {
      "claim_cluster_id": "dd24c0fd-c274-4b3f-aabc-3dbac6784aa9",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "c784871a-fcaa-4345-b3a8-ae8869019499",
      "event_cluster_id": "607cc6ab-a0bd-429e-a391-92e1066b96d9"
    },
    {
      "claim_cluster_id": "9096173e-de4b-47e9-9e39-b39282b05e47",
      "event_cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7"
    },
    {
      "claim_cluster_id": "6d2a1320-d829-403b-913c-d7cdbf1cbf14",
      "event_cluster_id": "f419c65f-41b5-4ce9-829b-e8de4a1f6af4"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "5dc7d30c-f418-4e0a-bf24-d3caf57c0ec4"
    },
    {
      "claim_cluster_id": "64664899-be28-4387-939b-822e6b833f08",
      "event_cluster_id": "ce2c1d0b-75ef-45c7-a23e-a0fa3e07457f"
    },
    {
      "claim_cluster_id": "ce2b0119-85f6-4619-9c50-256557181c73",
      "event_cluster_id": "aa5a0292-80cc-40db-8f50-3b92fa1db057"
    },
    {
      "claim_cluster_id": "516e99dd-d52c-4f12-8e2e-b0ba0e0b515d",
      "event_cluster_id": "155333a7-ab36-4219-a8f6-9496d1f00dc8"
    },
    {
      "claim_cluster_id": "4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d",
      "event_cluster_id": "f0e9965e-e941-4451-a097-f16f023a8147"
    },
    {
      "claim_cluster_id": "821946a1-401a-4657-be17-b3ed51371c13",
      "event_cluster_id": "e1005ff4-1bb8-462d-bc29-153ca1f78b3b"
    },
    {
      "claim_cluster_id": "2ebece0c-e502-49a9-94b9-5df90f1b8e51",
      "event_cluster_id": "a7c7aaf0-419c-4efc-8f5e-14d3f71ed9ab"
    },
    {
      "claim_cluster_id": "a6d51f65-13a0-42d8-b6fe-66f9daf5bd01",
      "event_cluster_id": "c3de0789-c302-4248-804e-d8d020c50634"
    },
    {
      "claim_cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
      "event_cluster_id": "d5752cab-3caa-48c6-b67d-7ac6c89bd054"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "e4c129ec-5dad-46c4-884d-38afdd290e76"
    },
    {
      "claim_cluster_id": "9096173e-de4b-47e9-9e39-b39282b05e47",
      "event_cluster_id": "cfc42d88-49ac-4610-a5c7-0cce12304171"
    },
    {
      "claim_cluster_id": "0f8d7640-e263-43ac-9294-0e526087824c",
      "event_cluster_id": "ad5a4bab-60d8-4977-8f90-38b233ab7dad"
    },
    {
      "claim_cluster_id": "a0fb284d-9ce5-4422-a3d9-508052dde7fe",
      "event_cluster_id": "c011b0e5-baf1-40ca-ae4e-97e2c4bd7b62"
    },
    {
      "claim_cluster_id": "b53db505-a920-4607-b45b-0f9423ee6d04",
      "event_cluster_id": "bd148f49-6e19-46a6-bfe3-a19a292ab17a"
    },
    {
      "claim_cluster_id": "6d600ff4-5ee2-443b-9049-7fb530fb454c",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "86a99b16-df58-43a2-b7eb-e1d03c6f6e5e"
    },
    {
      "claim_cluster_id": "b31e61b9-2010-4063-88bd-0eced0599429",
      "event_cluster_id": "c7723f2e-2c6c-486e-98b5-302326a9be1e"
    },
    {
      "claim_cluster_id": "388dcf56-c13f-4ec5-bbc7-b3c71eaffd35",
      "event_cluster_id": "16c38934-13c5-4d45-a617-8e2638f6597e"
    },
    {
      "claim_cluster_id": "0a0436c8-54af-4b5e-9725-fc8ed172d1cc",
      "event_cluster_id": "ae0aa30d-b0b4-4bf5-a41e-7d8900417e46"
    },
    {
      "claim_cluster_id": "04c040d8-393f-4b27-af55-1f60d7802605",
      "event_cluster_id": "b74d0080-2884-4f0b-b58d-88fbcf9d76d7"
    },
    {
      "claim_cluster_id": "09183ea2-b51f-4c35-a3c2-3fbf476237cb",
      "event_cluster_id": "0a2a726f-5f3f-4312-a1f1-087729dc4991"
    },
    {
      "claim_cluster_id": "469a2781-0070-451c-bc21-b7ee2b0da3f0",
      "event_cluster_id": "db160e2d-890a-4e75-a5da-9daa0f1dd2e9"
    },
    {
      "claim_cluster_id": "db9b9c53-4b26-4d88-83d5-c4c2d8189711",
      "event_cluster_id": "aec45825-35ee-46b7-b2b8-bea6a7f40f69"
    },
    {
      "claim_cluster_id": "0cd50f6d-7e09-46ef-815c-37b05bef94d0",
      "event_cluster_id": "9040babf-0be0-48e4-a916-be2a06953769"
    },
    {
      "claim_cluster_id": "08c235e3-44d9-4f4b-9af7-a9491ce983db",
      "event_cluster_id": "92bbe30f-197d-426e-978f-44717acaacac"
    },
    {
      "claim_cluster_id": "90a4e218-d5e9-4e12-b842-f6c8e272cb28",
      "event_cluster_id": "b217e8fc-9e97-45a5-8767-f4c21e8e0b4d"
    },
    {
      "claim_cluster_id": "dd5764ad-ed57-4067-b6a4-35ca15790cc2",
      "event_cluster_id": "76b14a04-38e5-4c33-90b7-69079246c4ac"
    },
    {
      "claim_cluster_id": "f96435db-3d9a-45de-8398-45bc9dbd4fc0",
      "event_cluster_id": "9be937d1-1aab-40a0-9206-7301e1897a68"
    },
    {
      "claim_cluster_id": "d65bf625-e91c-49ac-a498-dc2e95df1f93",
      "event_cluster_id": "8e640a02-ac6c-4b9c-8244-be0e4a058359"
    },
    {
      "claim_cluster_id": "1c220b25-802f-4053-89c5-d8f4805341a5",
      "event_cluster_id": "0b7b0dfe-c42a-4dfa-8860-0ff61e6cc75e"
    },
    {
      "claim_cluster_id": "6d226b20-d54f-48d2-bd7d-2616184afc68",
      "event_cluster_id": "9e3e1492-3c76-4be0-979b-239d4deb8c80"
    },
    {
      "claim_cluster_id": "679ed917-ad46-4856-a427-b83dcc51a53c",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "f9c980a9-33b9-4834-922a-947a13f5a035",
      "event_cluster_id": "d9484da0-ca3b-450a-a45c-787783bba3e7"
    },
    {
      "claim_cluster_id": "c7013046-8aa1-434c-87b8-1e3317f5578c",
      "event_cluster_id": "75d8830c-702b-4013-8c9b-62375f536959"
    },
    {
      "claim_cluster_id": "0d1ccd4f-6f42-4604-a9be-95ea8fe5adc0",
      "event_cluster_id": "d0e8c17f-ac7a-4857-90ac-8a31224cb44f"
    },
    {
      "claim_cluster_id": "37ca2b04-06dc-444f-b96a-20f9e5902a07",
      "event_cluster_id": "4a1b2728-75a5-43bc-8278-ab49e8c8c004"
    },
    {
      "claim_cluster_id": "c1587edf-f13c-4a02-9534-a3653325bfee",
      "event_cluster_id": "00bd60e5-bf2a-4d15-8ed4-8906838875f9"
    },
    {
      "claim_cluster_id": "bba799e9-6e80-4ce6-b96c-fc89b2b8200c",
      "event_cluster_id": "ac7642b8-b25c-45db-8998-1d3c7f1c25e7"
    },
    {
      "claim_cluster_id": "253fbf69-01a5-4352-a109-1aea0fdf1fe3",
      "event_cluster_id": "2bd231ca-b95f-4da8-b52c-5b92d58eef4f"
    },
    {
      "claim_cluster_id": "0726cfa9-d89b-45b4-922f-553fde14346a",
      "event_cluster_id": "160b6b7e-ff36-46d8-bcf4-e711c773e83e"
    },
    {
      "claim_cluster_id": "0a79d737-f594-464b-b3d2-afd57c6349f1",
      "event_cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c"
    },
    {
      "claim_cluster_id": "ed1b332b-c054-4114-82a1-1e645946747e",
      "event_cluster_id": "3b95c6b0-416b-4f6d-9aaf-3287913c0c2f"
    },
    {
      "claim_cluster_id": "02e0cfd6-814a-4276-b8cf-66540b7686e7",
      "event_cluster_id": "0a5b6270-0640-4f06-bb62-1bb490df9669"
    },
    {
      "claim_cluster_id": "541a6555-c116-4473-b1ae-ac7c48578f3d",
      "event_cluster_id": "d4bec07a-ec66-4aae-9ce2-624f9525e0ee"
    },
    {
      "claim_cluster_id": "4a575d85-5f97-4baa-be78-2c26ecefb471",
      "event_cluster_id": "b754c76a-3e29-4a89-b2c2-054b3adbaf0c"
    },
    {
      "claim_cluster_id": "dff8a985-ffc1-4946-ab7d-43e8406aca00",
      "event_cluster_id": "c2fa4be0-a63f-4b63-922e-7a118484c3c8"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "b2894bf3-d539-4a31-9d16-59a88bacee25"
    },
    {
      "claim_cluster_id": "baec81f4-73ba-4194-ab31-e3d64c8a57ab",
      "event_cluster_id": "b88b8f26-8273-40e5-8f02-5f503edd6ce2"
    },
    {
      "claim_cluster_id": "1db866e4-0f7e-4d67-93e0-8d1068f0369d",
      "event_cluster_id": "de8997cf-fd37-4d0e-b22a-dae890492f89"
    },
    {
      "claim_cluster_id": "6606b076-6fdd-4a94-a7c5-b6bfc5191980",
      "event_cluster_id": "3804062b-b30a-4f19-918a-426ffa4b1df7"
    },
    {
      "claim_cluster_id": "3f85eb0b-4d61-4e44-8414-15ce2c9f03ad",
      "event_cluster_id": "750243e1-18a5-4108-92d0-c8875b6d7be7"
    },
    {
      "claim_cluster_id": "73fff1e2-bc77-421c-8436-e9bf094a9733",
      "event_cluster_id": "0e90187a-faaa-48f2-ae7a-c2764c47dffa"
    },
    {
      "claim_cluster_id": "93548381-56c4-4fb7-be49-43e644f447fb",
      "event_cluster_id": "46cde8f4-4b4b-4cae-87a1-063914f15878"
    },
    {
      "claim_cluster_id": "bd0a892b-884e-4c98-8690-8f25949dbaed",
      "event_cluster_id": "f8fb52b1-aa75-4179-86fc-79c103280f3b"
    },
    {
      "claim_cluster_id": "516d27f7-0cda-468f-b3b6-27af200d408b",
      "event_cluster_id": "a2518533-4468-4125-948f-3516caac3b26"
    },
    {
      "claim_cluster_id": "73184e14-aff1-4c97-a2f0-0508b86fc3db",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "b7635b58-ad1e-4cb4-a317-8d48ce1cdddd",
      "event_cluster_id": "a899a63e-c3d0-425f-8700-82abc0fa345a"
    },
    {
      "claim_cluster_id": "8e873c15-6407-475e-841a-2dcbbce28e18",
      "event_cluster_id": "7992895f-6a68-45c7-a087-4ea61dcfa40e"
    },
    {
      "claim_cluster_id": "f4175686-5e4d-4fb0-a465-bed7586f6615",
      "event_cluster_id": "bf638672-92b8-4f28-a31b-d9a286145b07"
    },
    {
      "claim_cluster_id": "9bf70381-221f-4cfd-8e17-16f9ebb35e36",
      "event_cluster_id": "6363c274-1e0e-4e09-85b0-1412131b0c25"
    },
    {
      "claim_cluster_id": "0626769d-4a42-43f4-8356-e89543f6dcc3",
      "event_cluster_id": "4d6e8834-c57b-472a-adbf-630fe4d997d3"
    },
    {
      "claim_cluster_id": "0c0cca84-dd68-41a0-8489-cb2d22400e3a",
      "event_cluster_id": "944be8a6-d37e-42a3-beed-11a9a6d47203"
    },
    {
      "claim_cluster_id": "72a6b38a-23a2-43db-a788-32ae774a5c77",
      "event_cluster_id": "042df2bc-4559-4f30-9abb-b285376932e3"
    },
    {
      "claim_cluster_id": "c70207c5-86bf-4f7f-b715-56b9c8674c3b",
      "event_cluster_id": "c7824331-8340-4b01-8402-1e8e570e3b30"
    },
    {
      "claim_cluster_id": "a6506a53-789c-4447-b726-b2dd59d9b862",
      "event_cluster_id": "181f2787-76c0-40c9-96f6-869aa09e8172"
    },
    {
      "claim_cluster_id": "ae1d4689-4f04-4acd-a0d9-2c0934c3acd4",
      "event_cluster_id": "89669f9f-ac80-4abe-98e3-503ca9625f39"
    },
    {
      "claim_cluster_id": "4a942b66-0607-413f-8ee5-b6f6ddbbd034",
      "event_cluster_id": "2edd3f54-1c62-46b5-9ed0-1f1f90407326"
    },
    {
      "claim_cluster_id": "bba9ba69-2957-4432-9f56-bcb77e8342e2",
      "event_cluster_id": "ffc5ae60-fd21-4d4d-9cbb-be7095643849"
    },
    {
      "claim_cluster_id": "43fb6e85-e148-46ac-99f5-6e9cc985487b",
      "event_cluster_id": "f7f70f61-0229-475b-8a17-6b4740f661e4"
    },
    {
      "claim_cluster_id": "1713cb4d-ab0f-4257-a2cb-4aec01e411ef",
      "event_cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff"
    },
    {
      "claim_cluster_id": "40621ae5-171b-4ff7-a8cc-0957a4cc93da",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "dd5764ad-ed57-4067-b6a4-35ca15790cc2",
      "event_cluster_id": "bd072c00-533b-4c4a-918b-097a11abe63b"
    },
    {
      "claim_cluster_id": "7b36cbc9-6f57-4b29-9c6b-010607eb3738",
      "event_cluster_id": "0ab76786-184f-4825-8328-205b8055cb1c"
    },
    {
      "claim_cluster_id": "1e35c814-682d-4b74-be8b-2867b370b971",
      "event_cluster_id": "4485e5d3-efcb-4d42-a185-349293bfd550"
    },
    {
      "claim_cluster_id": "f7fbb95e-08d7-410a-8e1f-290e984463d7",
      "event_cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7"
    },
    {
      "claim_cluster_id": "327aebea-facc-4b65-a419-a9d461f7aa0f",
      "event_cluster_id": "23c09fb4-b263-485c-8e4e-4908da7910fa"
    },
    {
      "claim_cluster_id": "c3dda95e-e922-4b18-b7fd-9f071350fa6d",
      "event_cluster_id": "70912902-8988-4e45-a0c6-4af51f1f19b7"
    },
    {
      "claim_cluster_id": "9c5c6743-3894-4e82-b69e-bc4e0c19f869",
      "event_cluster_id": "a316c368-440e-4c3f-a293-cbd2c8138a8e"
    },
    {
      "claim_cluster_id": "d2f81fce-8c92-45e8-8294-41af7752f1db",
      "event_cluster_id": "bbcaf773-6ffd-4bd3-98a9-fd76783316d4"
    },
    {
      "claim_cluster_id": "5767d0cf-3070-412a-9136-a29c287f15a1",
      "event_cluster_id": "47cf0031-f643-4c3b-859a-e03a6b23d6e9"
    },
    {
      "claim_cluster_id": "5e0fea08-89fc-42fe-8906-484d762a1714",
      "event_cluster_id": "2c29846f-3295-4669-afc6-4c052b5c55d8"
    },
    {
      "claim_cluster_id": "d7eb8bf6-179c-440e-ad1d-a97e186809d1",
      "event_cluster_id": "aee47b3f-809d-45eb-9cd7-269dd2b5fc95"
    },
    {
      "claim_cluster_id": "e9c91d2d-9c77-43dc-9ccc-c00049984a01",
      "event_cluster_id": "bacf6a38-aa68-4722-a54e-dd8b9dbd45eb"
    },
    {
      "claim_cluster_id": "6a54c6d4-9e49-450e-95c4-f3afc0f85f6c",
      "event_cluster_id": "603803f7-aada-4f64-95b6-3901092a2744"
    },
    {
      "claim_cluster_id": "b45686ea-2849-48a8-b658-78abebbff1dd",
      "event_cluster_id": "4fd61797-afb1-460e-913b-0445bfe516c3"
    },
    {
      "claim_cluster_id": "35218630-91b1-47a4-87cf-29094bd87289",
      "event_cluster_id": "99814cad-01e4-492e-93e2-a867761329f7"
    },
    {
      "claim_cluster_id": "b877e703-7bf9-4587-919b-bf207b22c607",
      "event_cluster_id": "a04f0354-7f2d-4806-8bf1-4cf23f67439b"
    },
    {
      "claim_cluster_id": "e129ef72-bb79-4915-92ec-e1ad0c220280",
      "event_cluster_id": "0e7363bf-ba1a-40d3-b39e-9efa5e6a18ad"
    },
    {
      "claim_cluster_id": "957872f4-ebb4-47bd-9d9e-487c3755644e",
      "event_cluster_id": "7dec92f2-1d70-4104-bd41-d9c058b2c5ef"
    },
    {
      "claim_cluster_id": "a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f",
      "event_cluster_id": "0480c8ed-40a7-40dc-ac24-9b8fa7551edc"
    },
    {
      "claim_cluster_id": "c85112cb-b1b4-4c61-8955-fca094b1a4c4",
      "event_cluster_id": "74848948-285f-4571-adb0-ad9b59d381fc"
    },
    {
      "claim_cluster_id": "1ef62c3d-3750-43b9-855b-d4624938de1e",
      "event_cluster_id": "4a7e58b2-ad14-4711-92da-e24d91c0e2a2"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "cba27e02-b54c-4ae0-80f7-4a7112a6558e"
    },
    {
      "claim_cluster_id": "5102f7b6-4554-4836-b695-c4ff3c598adf",
      "event_cluster_id": "636dbb94-cbc8-4c79-b785-6d406b28db48"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "ab428379-3dca-4ed1-9e68-45a0cb9d3fea"
    },
    {
      "claim_cluster_id": "5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa",
      "event_cluster_id": "4fdaa1a3-7430-423b-81e3-be520cdd6936"
    },
    {
      "claim_cluster_id": "35ff7a5e-40b8-42ad-9379-7ba830c9445f",
      "event_cluster_id": "63531f99-fdf7-4bec-966d-ab104759e21a"
    },
    {
      "claim_cluster_id": "dbcdf7e4-c865-4f31-a79f-0cd2eef3258f",
      "event_cluster_id": "d748319a-ab54-4e2c-9098-21db36bad1c7"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "ee877fbc-1f06-46ff-b006-7c974bc58cf1",
      "event_cluster_id": "822c1997-a0a2-41cb-9793-22c777eab1a6"
    },
    {
      "claim_cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "event_cluster_id": "cf1d89e9-6fd3-4042-9407-6a77d0635415"
    },
    {
      "claim_cluster_id": "b7cbc93e-51f6-448c-9fc2-c1af44082069",
      "event_cluster_id": "e4ca57af-fa5a-4a42-8e77-8ccc8efd6660"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"
    },
    {
      "claim_cluster_id": "800e7e36-7ce1-4e55-a18d-394d83673d71",
      "event_cluster_id": "966cca08-6c6e-46f9-8145-7138653fe7a5"
    },
    {
      "claim_cluster_id": "5528714b-b0b8-40d9-850a-99905744c056",
      "event_cluster_id": "2f6c2f5e-a3c6-4ec4-93b2-6127b5c87ee6"
    },
    {
      "claim_cluster_id": "cf33198d-096c-4e25-8d65-13fe91addce9",
      "event_cluster_id": "73f48f2a-467d-4d70-aac9-42d923ea5f8c"
    },
    {
      "claim_cluster_id": "0961c365-4261-4c91-984b-81c62260d807",
      "event_cluster_id": "ddb6cf7a-94d8-482f-b5e3-c86b7fa8181d"
    },
    {
      "claim_cluster_id": "d0228864-78be-4fd7-94b7-908de0276e80",
      "event_cluster_id": "ea3abea8-dde8-497c-9c04-bcf3a9757f8f"
    },
    {
      "claim_cluster_id": "0de2a028-10da-49bb-8b43-e7f79a0ff6dd",
      "event_cluster_id": "1f210f48-5853-4bb8-8fc2-d9a334fec30a"
    },
    {
      "claim_cluster_id": "18c77ab0-e8d1-492c-912a-03ad6154fa51",
      "event_cluster_id": "4a20b107-b497-42c8-8807-874212cad7e3"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "49feb97e-934e-4b78-b2c2-4acd4705e46e"
    },
    {
      "claim_cluster_id": "77e72686-2baf-45ab-a679-b8f62cdcf982",
      "event_cluster_id": "8cb3d3c4-596a-4d19-9190-9681300abd40"
    },
    {
      "claim_cluster_id": "3dc0cbd1-b381-4df2-846d-e07147e83cbe",
      "event_cluster_id": "a0b134b6-d0a8-434f-86d9-01697dedcb90"
    },
    {
      "claim_cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "event_cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"
    },
    {
      "claim_cluster_id": "5c68cba2-8519-4f6e-b70e-fbda62c5445c",
      "event_cluster_id": "a850938a-0d12-48b8-a366-a53a16388dbb"
    },
    {
      "claim_cluster_id": "f2df1c45-9507-438e-92d8-0a523b9a842a",
      "event_cluster_id": "32516088-d496-4b04-a09c-540561be5921"
    },
    {
      "claim_cluster_id": "90a4e218-d5e9-4e12-b842-f6c8e272cb28",
      "event_cluster_id": "78c6a4d3-5529-4139-b6cb-7f76f21ff807"
    },
    {
      "claim_cluster_id": "cce124fe-f108-4571-9074-db48a458127d",
      "event_cluster_id": "d02fe9fc-02c3-4085-ae05-7b4e0277028c"
    },
    {
      "claim_cluster_id": "c8cf7c39-4d6a-4fec-8451-b46f12ccd07f",
      "event_cluster_id": "39ac0d20-baa7-48d3-8263-9b324a75c453"
    },
    {
      "claim_cluster_id": "b12e5d28-73fe-498d-a612-a3df5aa876b3",
      "event_cluster_id": "dcf0cb56-59c5-419e-a7a3-57fc57640ce0"
    },
    {
      "claim_cluster_id": "616e962d-58a9-42e5-9a6d-decd8139ddf7",
      "event_cluster_id": "920638c0-7694-4767-bc82-851ade0b1652"
    },
    {
      "claim_cluster_id": "2edb056a-640a-40d9-89e2-36dbc25022b5",
      "event_cluster_id": "f6fe4656-91eb-4bf2-98b2-cfac47bcc12d"
    },
    {
      "claim_cluster_id": "63ad18c0-00c0-4509-b669-2aff507b5502",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "b7e33865-58b2-4984-a7e1-eed1512539bb",
      "event_cluster_id": "d4bc60e5-da16-45c3-909d-aa14379adeb2"
    },
    {
      "claim_cluster_id": "d29a2d68-5d53-4ad3-9792-37db5375f45d",
      "event_cluster_id": "b87380f4-8f89-424b-8739-272a52634814"
    },
    {
      "claim_cluster_id": "9bd5e01f-d2aa-4157-a2fd-143c30274710",
      "event_cluster_id": "ed413a70-b4e1-4736-9370-9237ebadaa06"
    },
    {
      "claim_cluster_id": "4f68034e-7758-4136-94fe-82331ab7df47",
      "event_cluster_id": "636f9424-425e-404f-b45f-941b15951311"
    },
    {
      "claim_cluster_id": "7386324d-4730-4b17-8d70-6b33d62d5be3",
      "event_cluster_id": "59b16d26-5dcb-404b-8589-2b9a2089c70d"
    },
    {
      "claim_cluster_id": "8a0accb4-caf5-4741-9038-3360a1a08c25",
      "event_cluster_id": "c2141743-76d8-4904-8bb0-fc81db4f2295"
    },
    {
      "claim_cluster_id": "8a1c4319-f1b2-4b2f-93eb-dd1d35c5dd9e",
      "event_cluster_id": "9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"
    },
    {
      "claim_cluster_id": "6a4b35a4-0785-4292-8587-aee85db61288",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "96b36513-ec34-4deb-bc5b-c811958c3675",
      "event_cluster_id": "761f3fb6-5695-42a3-ba7c-8aee7df904b2"
    },
    {
      "claim_cluster_id": "1927948e-52f7-43b0-aafe-d3f160820394",
      "event_cluster_id": "5f7469b6-8252-4966-99ba-b5fdff4dbf90"
    },
    {
      "claim_cluster_id": "c5298737-21d9-47c4-b52e-e662ee88b15b",
      "event_cluster_id": "8c274c4a-42e3-4136-9ecf-91adb76667f9"
    },
    {
      "claim_cluster_id": "db13aa73-f539-42d8-89d9-1af57cfff5a3",
      "event_cluster_id": "0007cb01-3742-461b-b5c4-5aadc5a55eac"
    },
    {
      "claim_cluster_id": "635fb80e-2799-454a-8570-6fc3830d271b",
      "event_cluster_id": "0de9cc59-0656-46df-93f6-a7ec86e0802b"
    },
    {
      "claim_cluster_id": "4f331c05-6fa5-4bd8-adc2-5458e8c80843",
      "event_cluster_id": "bbb1bc4b-f3a4-434c-a53d-625f1645e395"
    },
    {
      "claim_cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
      "event_cluster_id": "410a0800-e775-4016-b3ff-cc215bfaf3d1"
    },
    {
      "claim_cluster_id": "4a817862-6fa5-4e7c-8998-977aaad70250",
      "event_cluster_id": "ce77bb3a-ea7f-4d98-a5e3-62e70b0597ed"
    },
    {
      "claim_cluster_id": "924c4170-d405-438e-937c-13478012b72c",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "71f3d08b-aa01-4b41-b89d-7fb725538d72",
      "event_cluster_id": "a6d23154-5d6d-475a-a318-8f3c90f26a02"
    },
    {
      "claim_cluster_id": "218a3fc7-ac76-4428-aa52-1f315a03667d",
      "event_cluster_id": "f654e316-c125-44fc-9eae-66baddc079a2"
    },
    {
      "claim_cluster_id": "75d5bddd-c0b4-4755-8a27-ab90a5104373",
      "event_cluster_id": "71435cc5-d65b-4e3e-9454-ffe0371a42f1"
    },
    {
      "claim_cluster_id": "6c51a8d1-6797-4e1d-8707-408a46a11bf5",
      "event_cluster_id": "3625ee09-ea65-4286-ae5a-83daac4e66b6"
    },
    {
      "claim_cluster_id": "174a0855-e1b9-4e2b-9a6a-957eb12d4b1a",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "99dd456b-c805-4ebb-a82a-80fe2e06dff9",
      "event_cluster_id": "d85e9fe5-2b49-48db-b3ed-055f19c978de"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "b49a91d7-446b-421b-9670-7c99bbf5bc28",
      "event_cluster_id": "5b7d9e7f-e24f-4115-ae9c-183a9ef8183c"
    },
    {
      "claim_cluster_id": "d14e115a-dd46-437f-8a57-5893395dde5f",
      "event_cluster_id": "49a61bc5-5b56-4867-98aa-feebd5b63106"
    },
    {
      "claim_cluster_id": "4e71d535-1646-4ea5-9c47-04fb1464f390",
      "event_cluster_id": "81eafdea-26c8-4b44-b5c7-5cd6a9bfece5"
    },
    {
      "claim_cluster_id": "21b4d7af-e8bf-408f-b63a-f91c28b7ba72",
      "event_cluster_id": "d29993d5-ca77-4b15-919e-f95ec679fdca"
    },
    {
      "claim_cluster_id": "80a02b1a-c045-453f-ad92-9681e40dad83",
      "event_cluster_id": "b7f1648b-9e5b-476f-a59b-84d94f8583e3"
    },
    {
      "claim_cluster_id": "bee4d72b-b159-4b6c-830c-362b42a2b18d",
      "event_cluster_id": "06d3a2ea-1d2f-4456-9c1f-ca559e4c2f36"
    },
    {
      "claim_cluster_id": "49c94f1b-b278-42a0-b8b7-d0f8ec55d536",
      "event_cluster_id": "977581f8-a92f-4a60-b0ab-96b42b1d0d8d"
    },
    {
      "claim_cluster_id": "02e82f7d-c446-4fc6-9794-94910a46d2ac",
      "event_cluster_id": "152183a2-1d35-42be-bb3a-d49654ea4707"
    },
    {
      "claim_cluster_id": "86478e14-8f65-4b25-93ee-a6036b9de886",
      "event_cluster_id": "7e7c3417-e29c-4641-b1be-5336c04805ff"
    },
    {
      "claim_cluster_id": "554fbe05-7cef-438d-8e82-567521788239",
      "event_cluster_id": "335c4cdd-12ec-4cfe-80c0-1755c4975b84"
    },
    {
      "claim_cluster_id": "3e505b9a-116f-472b-bc43-8ee1a23943f5",
      "event_cluster_id": "5ee5ee7a-bfa2-482d-bd3e-efb0d1c8544c"
    },
    {
      "claim_cluster_id": "894e29d9-1e82-4e00-b1eb-e5092d46e327",
      "event_cluster_id": "c75d014e-008e-44c1-909b-263543a31c5f"
    },
    {
      "claim_cluster_id": "de08eb08-92b3-4974-9e99-e79755582996",
      "event_cluster_id": "41498260-bda6-49c5-9ad2-acb6340ff494"
    },
    {
      "claim_cluster_id": "7be2aab8-ebba-4a53-8dd8-2f99fbdc274c",
      "event_cluster_id": "17bcb338-5ed9-498a-8f4b-407445dec65f"
    },
    {
      "claim_cluster_id": "a32303e6-4765-4335-9847-b5ee18494799",
      "event_cluster_id": "d3a45ffa-7001-4495-9c5e-b65ea28becba"
    },
    {
      "claim_cluster_id": "d10a4ec7-a74e-4016-996b-f1f3a3c6527f",
      "event_cluster_id": "93a61a8e-4477-45a4-b63b-bc7992dad11c"
    },
    {
      "claim_cluster_id": "729d6508-b5df-44ab-8ffd-349b7a126b16",
      "event_cluster_id": "f795636b-a096-4302-aa9e-87494f4166de"
    },
    {
      "claim_cluster_id": "e8bed2a1-875c-4017-abd5-83f756e2ceb2",
      "event_cluster_id": "adfb27db-3208-49e3-8050-366e93400ac6"
    },
    {
      "claim_cluster_id": "bbe61a29-09c0-4f9e-98e6-1cf33324aca4",
      "event_cluster_id": "d301327b-e031-45ac-903a-5645a313fba7"
    },
    {
      "claim_cluster_id": "ff42e3e5-bb75-45af-be07-89d36dae0d5c",
      "event_cluster_id": "53ad86f3-97ef-4717-9f61-4666c34f7833"
    },
    {
      "claim_cluster_id": "6d7d1320-a896-4471-aa98-60a45946bc57",
      "event_cluster_id": "a23c75f5-2cc2-4ad3-bbfe-8878efe773ea"
    },
    {
      "claim_cluster_id": "00cfa90d-eff5-4498-89d6-85dadca46eb8",
      "event_cluster_id": "bd4e1aad-4b42-4afe-bdd1-8b68fcb5aa16"
    },
    {
      "claim_cluster_id": "8b72504b-7ef9-4a36-b0a5-32d0b76c4553",
      "event_cluster_id": "0affa6f2-96b0-46b9-acf1-01957217922b"
    },
    {
      "claim_cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
      "event_cluster_id": "7681cbe0-1efe-4edf-b906-ebf02351325e"
    },
    {
      "claim_cluster_id": "2432e361-2cb6-4e28-a81d-a8ee7dce9c29",
      "event_cluster_id": "516f819a-378f-4afb-ba61-51d5e2e77e27"
    },
    {
      "claim_cluster_id": "df0cd74b-d230-4260-9a29-b0bc91923404",
      "event_cluster_id": "aed5d13a-0c24-4359-9236-cc780ebe021d"
    },
    {
      "claim_cluster_id": "e9c91d2d-9c77-43dc-9ccc-c00049984a01",
      "event_cluster_id": "d15b1a4a-b0d0-463c-b7c1-b74ef1c0a63a"
    },
    {
      "claim_cluster_id": "c31ea39d-ce0d-46ee-be4c-e32d46721b78",
      "event_cluster_id": "f6f6ac6a-d140-47fb-94ad-797d11509e6a"
    },
    {
      "claim_cluster_id": "1e12b1a7-9bc4-4a98-b698-8392df483432",
      "event_cluster_id": "d58866d1-afac-43ae-b1bb-fbdbeb0b8d62"
    },
    {
      "claim_cluster_id": "0dc504d4-9f05-4936-a43a-c912683c5ac2",
      "event_cluster_id": "b9d8d6cf-41c1-428e-84c8-7e7e2b40a710"
    },
    {
      "claim_cluster_id": "83605bab-42d6-405a-ab45-fb6b68e0609c",
      "event_cluster_id": "f4e22611-4a8c-420d-98fb-79e2c70d616c"
    },
    {
      "claim_cluster_id": "e045b8f3-c755-4ad1-91b0-a0b8f7878680",
      "event_cluster_id": "bbe46b45-db85-4cd0-8c3a-6d46ba80584e"
    },
    {
      "claim_cluster_id": "9f4059ba-333f-4054-ba5f-f1cebaed747e",
      "event_cluster_id": "d3878960-69bc-4fec-92c4-b21753a35a06"
    },
    {
      "claim_cluster_id": "7cad6507-3550-4760-99ab-581f5b103f29",
      "event_cluster_id": "099689d1-bfaf-4b3b-b795-0a924815ef02"
    },
    {
      "claim_cluster_id": "54fa045c-bc33-4348-a964-82cb98ec67f5",
      "event_cluster_id": "9d971a6e-39d0-4da3-9f9b-e8603acb9bc3"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"
    },
    {
      "claim_cluster_id": "fd537f2d-3616-4303-9edb-81c90d602f6d",
      "event_cluster_id": "a06a1094-e3d5-4cdf-b982-d9ff6654fb83"
    },
    {
      "claim_cluster_id": "ac61e213-06f8-4e65-ac52-8d47ef547cc8",
      "event_cluster_id": "69aee0d6-8420-442f-82ab-c95f31fcf4b8"
    },
    {
      "claim_cluster_id": "d5ad62ab-dd96-48fa-a092-0724cb0c06f6",
      "event_cluster_id": "4a1b2728-75a5-43bc-8278-ab49e8c8c004"
    },
    {
      "claim_cluster_id": "0998688e-32a8-4d44-8338-04f2bfaf29d8",
      "event_cluster_id": "f6bf24ea-54ac-45f2-b1ba-27747efe5a47"
    },
    {
      "claim_cluster_id": "e521c1db-8ae4-48b6-83c6-efbd02701f4c",
      "event_cluster_id": "3277c81f-d2ed-42ea-acc4-bb977e68f163"
    },
    {
      "claim_cluster_id": "bdc7e61b-1cd4-494f-b965-4387369e6df2",
      "event_cluster_id": "859ebc03-00a8-4a19-9bda-cf26a29549d4"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "event_cluster_id": "a568feba-940a-47c6-8cff-f4910bd91144"
    },
    {
      "claim_cluster_id": "3dc0cbd1-b381-4df2-846d-e07147e83cbe",
      "event_cluster_id": "d1afbb7a-8d2b-4c24-9c70-b4c56fd56a43"
    },
    {
      "claim_cluster_id": "1cffe038-9a46-45f7-bcc3-f26914315286",
      "event_cluster_id": "aed589a1-07ba-475f-b7f3-a645da58e97b"
    },
    {
      "claim_cluster_id": "b916d619-a85d-4cf6-9af8-c531be4fd3c4",
      "event_cluster_id": "25b06341-ba13-410b-909e-c700b9b55663"
    },
    {
      "claim_cluster_id": "3f85eb0b-4d61-4e44-8414-15ce2c9f03ad",
      "event_cluster_id": "21439ac6-d6cc-43c2-9360-f892b94daf83"
    },
    {
      "claim_cluster_id": "ac74ed42-e193-4a73-9fb7-633a1a28d674",
      "event_cluster_id": "05a27be4-d98e-42f1-b3e3-bf60c499f807"
    },
    {
      "claim_cluster_id": "b5b35a39-f79a-45e8-82ea-b87d21bbba55",
      "event_cluster_id": "5345ad5e-9fbb-47ab-a820-0caca6e3cbd3"
    },
    {
      "claim_cluster_id": "eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0",
      "event_cluster_id": "1b5a113e-43ba-4a33-a76b-09db6a2b33ef"
    },
    {
      "claim_cluster_id": "0727da75-801a-4ea8-bc54-bca9f4c0cbfc",
      "event_cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"
    },
    {
      "claim_cluster_id": "42fd849e-0fa9-43a8-b5fa-5cc192351c79",
      "event_cluster_id": "ed35c2c7-9d1d-46bc-b509-54389b90afc9"
    },
    {
      "claim_cluster_id": "1010a45f-c4e6-41d3-ad44-9a27b9dc7893",
      "event_cluster_id": "60c5d0e9-eed6-41c1-b7fa-8d8163b698f7"
    },
    {
      "claim_cluster_id": "7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9",
      "event_cluster_id": "f4ad4efd-4ba9-41ef-9de7-a560663da99f"
    },
    {
      "claim_cluster_id": "d59582f7-7e86-41f9-a084-db1da2a740db",
      "event_cluster_id": "4dfac31b-2847-4ea8-85ec-0e74ca3ab755"
    },
    {
      "claim_cluster_id": "e7f02350-e0f8-416a-a3fa-4d7dfaaa5615",
      "event_cluster_id": "5a9b6351-c522-46ce-b100-d164df2f3ed9"
    },
    {
      "claim_cluster_id": "e9280ed1-20ec-4c75-8468-086e8c6749dc",
      "event_cluster_id": "5a444351-b082-407c-bb72-a6329cc1e654"
    },
    {
      "claim_cluster_id": "db9b9c53-4b26-4d88-83d5-c4c2d8189711",
      "event_cluster_id": "1541313e-804f-40cb-bfb7-78850471987c"
    },
    {
      "claim_cluster_id": "9747ef56-b31a-4050-8bc2-6df45c0ffbd7",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9",
      "event_cluster_id": "7c1fc423-517b-4edd-ab51-ee1fbb6a01c1"
    },
    {
      "claim_cluster_id": "dd24c0fd-c274-4b3f-aabc-3dbac6784aa9",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4",
      "event_cluster_id": "63e3781f-5042-452b-a77e-11f62bb59587"
    },
    {
      "claim_cluster_id": "d2dff4dc-99e9-4957-9a57-be828ae1a5cf",
      "event_cluster_id": "bf2b7ba7-a6da-4f7a-bc58-63ae1a3267de"
    },
    {
      "claim_cluster_id": "6d600ff4-5ee2-443b-9049-7fb530fb454c",
      "event_cluster_id": "d3ddf15f-7261-4b4f-bdd9-6823755811e6"
    },
    {
      "claim_cluster_id": "9bab62f9-a196-4e9b-9809-8d8f41f0576f",
      "event_cluster_id": "567b1fae-2c0d-4bd2-91bd-d03218bbd8d0"
    },
    {
      "claim_cluster_id": "1c849e20-6024-47fa-80b4-e611385ba612",
      "event_cluster_id": "0463ae92-c5a2-4eed-bc9a-bba00f27b6ff"
    },
    {
      "claim_cluster_id": "5a787097-c657-4d02-a7e7-ce5ddfe404d6",
      "event_cluster_id": "bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093"
    },
    {
      "claim_cluster_id": "f9f7a124-b259-44e6-a922-abc880fe6775",
      "event_cluster_id": "6d563374-a7de-4d4e-bf0b-d89a34f47ac7"
    },
    {
      "claim_cluster_id": "4801b48a-d91c-4dc3-9797-76929432b0ef",
      "event_cluster_id": "a5d642f3-ce31-48e1-93c2-529f31b5ca8c"
    },
    {
      "claim_cluster_id": "ff3f6026-485f-4fce-9d57-b8206b8e11c5",
      "event_cluster_id": "6987d44b-afbc-426b-97f6-9a507fedf197"
    },
    {
      "claim_cluster_id": "dc9039b4-da9a-4fd0-b97d-d822536a716c",
      "event_cluster_id": "db5c7092-c228-4319-b130-e75471c29ec0"
    },
    {
      "claim_cluster_id": "b877e703-7bf9-4587-919b-bf207b22c607",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "380726cc-73a4-4dde-ac40-f10c2a1f6e60",
      "event_cluster_id": "50755387-4b1a-4d72-9887-7b05aa4bf186"
    },
    {
      "claim_cluster_id": "f2df1c45-9507-438e-92d8-0a523b9a842a",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "f690f627-f1e3-428b-9d01-bfb966953069",
      "event_cluster_id": "615888f6-5d35-4a8c-acd9-9e71127a4cb4"
    },
    {
      "claim_cluster_id": "7c045c5d-d9cb-4901-a4fe-8f8a68090a83",
      "event_cluster_id": "4035a796-2dee-4cd0-986f-eb64d79cd560"
    },
    {
      "claim_cluster_id": "06a88819-5b14-47a3-9604-8a61db70f52b",
      "event_cluster_id": "9f40653a-5e27-4d90-9510-e0680c0dbf1e"
    },
    {
      "claim_cluster_id": "89d1d1b7-a65c-42c4-be89-c592ae13b6a1",
      "event_cluster_id": "120d5e71-28b6-4974-a584-3c9108ae5780"
    },
    {
      "claim_cluster_id": "4f2be876-d890-4fd4-a767-3f52bbc9c4c4",
      "event_cluster_id": "ca521545-0a79-4ba0-851e-a60589334127"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "9c03f16d-4308-41ce-a6c3-c0b6eaf8e340",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"
    },
    {
      "claim_cluster_id": "45803076-0698-48ef-a2b4-10f190885998",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "8038fcc7-29f8-406c-90cf-ee3b351c6e15",
      "event_cluster_id": "7b48e171-a32e-4aa5-90bf-b37f44678964"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "b379da86-fb9c-4026-92d2-37b07df028cc"
    },
    {
      "claim_cluster_id": "d2dff4dc-99e9-4957-9a57-be828ae1a5cf",
      "event_cluster_id": "f92a441b-bffa-4b5d-a3f4-495ad67f7ccf"
    },
    {
      "claim_cluster_id": "29c6f9fc-e1e6-4dfe-a45c-59ee8d9a4489",
      "event_cluster_id": "648cf481-ce4a-42cd-869d-b9a572ac3d7d"
    },
    {
      "claim_cluster_id": "8ba29c52-b42b-44a3-86e2-12fd13d42596",
      "event_cluster_id": "994a89fa-3e4a-45ec-b0ad-a34f5031641f"
    },
    {
      "claim_cluster_id": "96cc3b99-284a-4ca8-957e-5bfc2a13a654",
      "event_cluster_id": "9e537f59-fc8d-477f-937c-489e24e51014"
    },
    {
      "claim_cluster_id": "e129ef72-bb79-4915-92ec-e1ad0c220280",
      "event_cluster_id": "ad717816-6a33-4b68-8dcc-4da6a24f22b4"
    },
    {
      "claim_cluster_id": "8c18859c-7432-4cc4-af8f-8a5eb220876e",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "48cca002-8003-45bd-92b2-3e2945a33b48",
      "event_cluster_id": "82f5beda-b460-413d-ba52-232c56bac459"
    },
    {
      "claim_cluster_id": "14a92521-0601-421b-b904-3fc9a965cbb6",
      "event_cluster_id": "7eb16fe5-1729-42a0-bcb4-1a4783656ce6"
    },
    {
      "claim_cluster_id": "ef63ab3c-4c57-460f-989f-0ac957105580",
      "event_cluster_id": "c80180fd-f416-4eda-9cf5-5aa622256189"
    },
    {
      "claim_cluster_id": "1c30353a-a7dc-48dd-bca2-56c91aa06ab6",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "216f7d8c-4948-4e84-9b61-7c4fc880e123",
      "event_cluster_id": "5bb2e685-4a07-4889-91ac-49a28d63a36e"
    },
    {
      "claim_cluster_id": "8567d4c9-fb06-4505-b09d-13b1efafa073",
      "event_cluster_id": "9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"
    },
    {
      "claim_cluster_id": "717225a3-f2cc-4921-bece-db76c2709d99",
      "event_cluster_id": "02428d36-d8ed-40af-ab42-212bc3922840"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "e2b1886a-d41d-4169-be53-e4ed1b6d9d79"
    },
    {
      "claim_cluster_id": "71de3f5e-7d6d-4a6a-b383-b96d1ee24b30",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "fd107d16-4df5-452b-96c2-989c72732db7",
      "event_cluster_id": "72793708-1a46-47bf-a99d-c034462d8ebe"
    },
    {
      "claim_cluster_id": "c35d9889-06cc-4a13-8fea-d00c7024488b",
      "event_cluster_id": "a22b19c4-dd9d-4007-a380-a5d0659b9821"
    },
    {
      "claim_cluster_id": "77de864b-c2fe-4a23-a506-d0665b0f08bf",
      "event_cluster_id": "9a5830fb-a855-4c85-8daf-ed1be558a290"
    },
    {
      "claim_cluster_id": "c5d18c78-4df0-44fa-9f69-67266b1079e2",
      "event_cluster_id": "53ad86f3-97ef-4717-9f61-4666c34f7833"
    },
    {
      "claim_cluster_id": "7e112a5c-41d4-4f1c-b974-99256b5d357b",
      "event_cluster_id": "f78012d1-f500-46ba-802c-d3d1337f7f51"
    },
    {
      "claim_cluster_id": "fd537f2d-3616-4303-9edb-81c90d602f6d",
      "event_cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c"
    },
    {
      "claim_cluster_id": "d89e632e-b2af-4331-9344-c7d1e373d49b",
      "event_cluster_id": "2dba71a0-6409-4877-bd44-bf97b9328d5f"
    },
    {
      "claim_cluster_id": "81a839cf-9fe4-4f39-95e1-2ebc94ae6380",
      "event_cluster_id": "e7f6877c-917d-4e0c-ad46-e366c0fa0b67"
    },
    {
      "claim_cluster_id": "a1593cbe-8c39-423f-abae-2707e84a1e5e",
      "event_cluster_id": "55da7c68-ac05-4727-a906-82d875d3d88f"
    },
    {
      "claim_cluster_id": "dc464eb9-fc48-4646-8985-9de6d7531d3d",
      "event_cluster_id": "af8cdf46-4050-4634-a0b0-6bc6cfa78956"
    },
    {
      "claim_cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
      "event_cluster_id": "25733340-8065-4c67-9da5-97f671877eea"
    },
    {
      "claim_cluster_id": "0de2a028-10da-49bb-8b43-e7f79a0ff6dd",
      "event_cluster_id": "7c268167-b621-480c-ba79-7005ed13e2de"
    },
    {
      "claim_cluster_id": "89d1d1b7-a65c-42c4-be89-c592ae13b6a1",
      "event_cluster_id": "c2075982-499b-4dcd-9327-be17e07c166f"
    },
    {
      "claim_cluster_id": "1db866e4-0f7e-4d67-93e0-8d1068f0369d",
      "event_cluster_id": "320a9519-2826-4d38-88e0-353ff9437484"
    },
    {
      "claim_cluster_id": "44fbf7cb-79bd-4592-b8a7-2bf2362dc392",
      "event_cluster_id": "1dd73410-26d1-4ffe-8c70-64b5d5bf9994"
    },
    {
      "claim_cluster_id": "fe684e64-4226-4567-8e1f-5613fae2c8f8",
      "event_cluster_id": "46d5760c-bd0b-4c2e-8270-d2debd9f3dcb"
    },
    {
      "claim_cluster_id": "f401d633-0e2b-4935-b7d9-1761c201c058",
      "event_cluster_id": "ca922fb6-3b82-47fc-a5a7-c1ff0c4bff12"
    },
    {
      "claim_cluster_id": "a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f",
      "event_cluster_id": "02e73dfc-86f2-4fe6-a79c-d071e07721fd"
    },
    {
      "claim_cluster_id": "ef74ebaa-c6e0-4356-bf8a-2ce2acf6ad70",
      "event_cluster_id": "464e7bbb-1cb4-45e2-a510-f3dbf3edebfc"
    },
    {
      "claim_cluster_id": "db91531a-0712-431d-a04b-9b798db3d3b4",
      "event_cluster_id": "21518841-2c46-4292-abad-aff342a4f1ac"
    },
    {
      "claim_cluster_id": "c6d2f5c4-bb51-435b-a664-174b47ed38ef",
      "event_cluster_id": "55a8e92e-7501-4ea5-a3ee-b628a536a6f9"
    },
    {
      "claim_cluster_id": "24accb31-401b-42c1-bd69-e81c04cb2530",
      "event_cluster_id": "183ebbd4-8012-4c45-ae37-eee1b7b28721"
    },
    {
      "claim_cluster_id": "29009c7f-3a77-46aa-91c0-d0f703c52dab",
      "event_cluster_id": "5fc308a4-b2ac-472f-a711-f5e9a8852593"
    },
    {
      "claim_cluster_id": "2cfb50e6-37ad-47a2-87b2-da1a9a512e46",
      "event_cluster_id": "19d8a06a-0c0d-4355-9204-b73d0ebe4d12"
    },
    {
      "claim_cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
      "event_cluster_id": "92103df4-5a66-4430-95e6-d2ba83f705a1"
    },
    {
      "claim_cluster_id": "dad2ba1b-78a6-4e69-91a7-e473e3d79e42",
      "event_cluster_id": "cacf5ae8-cf4c-4e9d-86a7-1b95a7ab58e2"
    },
    {
      "claim_cluster_id": "13a07f14-45d6-4b31-8d23-23b540ac8090",
      "event_cluster_id": "3596032e-4fde-4840-89ec-0f1fed8a80cc"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "4259fe50-2c67-4157-ba4a-43d33835df49",
      "event_cluster_id": "1543a0aa-5824-449c-b496-3562005d2d52"
    },
    {
      "claim_cluster_id": "5f266248-0a3e-4fc2-afec-4bfc7ba1a633",
      "event_cluster_id": "3b9a3219-78e5-4ff5-948f-415edd9701ed"
    },
    {
      "claim_cluster_id": "d26e1561-d7b5-4c15-bc29-d5ba417f64ca",
      "event_cluster_id": "7640b35f-031b-4917-bf34-5555111a4a74"
    },
    {
      "claim_cluster_id": "87b92fb4-b0e3-4b01-9c2e-cfd9469245f7",
      "event_cluster_id": "0afcbb16-75a7-45dc-9f96-97e351b50a83"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "a1ecb202-6deb-48e9-b7cd-80beb55064e2"
    },
    {
      "claim_cluster_id": "ba4d4a13-eb59-48ce-b75b-0c214fe98953",
      "event_cluster_id": "aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"
    },
    {
      "claim_cluster_id": "9d21be2e-9f01-48c9-b454-3a41788e2865",
      "event_cluster_id": "ee08d940-570d-46a5-a30d-731f0f242ab4"
    },
    {
      "claim_cluster_id": "a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05",
      "event_cluster_id": "2b91a87f-d164-4dfd-97cb-da5b879525ca"
    },
    {
      "claim_cluster_id": "8f0344d2-3a73-4534-aa04-5391b7670e72",
      "event_cluster_id": "3838bfb8-767c-4ce7-8ddf-06338a137af4"
    },
    {
      "claim_cluster_id": "696180e6-d43f-476a-afce-5f13dbb9929a",
      "event_cluster_id": "ce469142-832a-40af-bb9b-acb726cab86d"
    },
    {
      "claim_cluster_id": "cfad4c19-24e9-4d54-8d59-d0b08718729b",
      "event_cluster_id": "fdf8116a-82e6-4a25-a819-a71aa4bc112a"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "2697eb78-b9b3-4edf-8af3-5b14bcd8c383"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "46d5760c-bd0b-4c2e-8270-d2debd9f3dcb"
    },
    {
      "claim_cluster_id": "91ae7c53-2f75-41de-be44-6ce7a4b47412",
      "event_cluster_id": "cfb71f70-69b3-4e36-b2b7-df43f0d519a2"
    },
    {
      "claim_cluster_id": "ccc50930-0ce2-4cb5-aa76-281b7202368b",
      "event_cluster_id": "d40b11df-00d1-4f65-b6c2-6f209bb850d8"
    },
    {
      "claim_cluster_id": "a0698f9c-4bc8-48b3-b669-44befd54559c",
      "event_cluster_id": "58babb7d-bd41-4196-8e7a-e844e8cfa638"
    },
    {
      "claim_cluster_id": "d6145953-8619-428f-9b84-07cd47d4180d",
      "event_cluster_id": "76d7e29b-d686-4238-a931-2118cfe1bf3e"
    },
    {
      "claim_cluster_id": "612e1b04-721a-48bd-b18f-300c7c5af276",
      "event_cluster_id": "69f46f33-8514-4ea2-ba72-362d6d1d202c"
    },
    {
      "claim_cluster_id": "ef78627f-ce46-445c-8434-674b16f6966e",
      "event_cluster_id": "0c9df761-94e1-484a-ad16-41bb0a7c5fb3"
    },
    {
      "claim_cluster_id": "a2f5a4b1-ccba-4cac-9bde-f079d3027db4",
      "event_cluster_id": "6b567caa-773b-451a-88a5-247b75e87a6c"
    },
    {
      "claim_cluster_id": "291e098d-0f3d-4fff-9906-3b21ed1a33a1",
      "event_cluster_id": "ef96efc5-2acd-42e3-8b8d-c3fb75af951a"
    },
    {
      "claim_cluster_id": "51f9e6ae-7c8a-46e3-8fa3-070377ae9030",
      "event_cluster_id": "531ef405-3766-417f-ac2c-f496b00a6ff0"
    },
    {
      "claim_cluster_id": "0f106199-65cd-478b-af43-69825b16fa47",
      "event_cluster_id": "49c36ab4-aedf-4b49-9372-e43ee616873e"
    },
    {
      "claim_cluster_id": "82cf1bd1-8182-4744-8fc2-6d5af2292aea",
      "event_cluster_id": "f315f787-a973-49cc-9719-20a3bfead1b0"
    },
    {
      "claim_cluster_id": "b43b3e32-d544-43ad-b781-20a883c7f4b7",
      "event_cluster_id": "3f4370f6-6231-416d-9478-d27156c80526"
    },
    {
      "claim_cluster_id": "40460222-6c35-47b7-be68-29a1138ce819",
      "event_cluster_id": "2148fe37-01cd-4114-a714-3d111387b22d"
    },
    {
      "claim_cluster_id": "cfa086e7-654e-40fa-9e14-980617b91e89",
      "event_cluster_id": "adce1d4b-0242-41c2-b4ec-d798e0c0dbf8"
    },
    {
      "claim_cluster_id": "b932581a-a432-45a9-94c6-236d0339e45d",
      "event_cluster_id": "2116fedb-8d8c-44ee-b7a0-a2ee29d3edd5"
    },
    {
      "claim_cluster_id": "34e272f8-beb9-408f-a252-0fa71406dc4b",
      "event_cluster_id": "209dbc84-05ee-49b9-b69d-c36d87df72b0"
    },
    {
      "claim_cluster_id": "43de0036-79a8-44f6-b066-25424acf3535",
      "event_cluster_id": "602ccd3f-b2b7-474a-9029-74260beb7902"
    },
    {
      "claim_cluster_id": "19ddcd3b-18db-461a-b208-f198db3e1e07",
      "event_cluster_id": "51cb3861-5c43-4303-b352-2771c991143d"
    },
    {
      "claim_cluster_id": "2010e740-a26e-4489-a685-8115e3933580",
      "event_cluster_id": "cfa0cfe9-0423-44d2-9909-74aa5f5c8e41"
    },
    {
      "claim_cluster_id": "cf33198d-096c-4e25-8d65-13fe91addce9",
      "event_cluster_id": "668e643e-dedd-4afb-8aee-89228ecd7266"
    },
    {
      "claim_cluster_id": "12f1ab8f-20c6-41db-928a-d52afb8bd227",
      "event_cluster_id": "5f2eb0b1-e72b-4484-b09f-d3bfdfdaf028"
    },
    {
      "claim_cluster_id": "b654c64c-3acf-45f6-a6ea-c4584b8c70fe",
      "event_cluster_id": "55bb591f-ecec-4f30-84a4-1528326dbb84"
    },
    {
      "claim_cluster_id": "98459a3d-d71e-40dc-bfe8-895082c9d11c",
      "event_cluster_id": "7cd53b0d-1bfd-45ff-a900-1bdfd6e403a3"
    },
    {
      "claim_cluster_id": "234be4d1-d0d0-4b65-aa97-a8cd91a0a32e",
      "event_cluster_id": "4fe16db2-c3a7-4835-89e2-e57d5e214582"
    },
    {
      "claim_cluster_id": "71f3d08b-aa01-4b41-b89d-7fb725538d72",
      "event_cluster_id": "8017a44f-3587-48ad-93bb-373a715846dc"
    },
    {
      "claim_cluster_id": "756853a7-6f00-41a1-87fe-40396a3fd247",
      "event_cluster_id": "0be2a099-9ff6-4c81-a576-b1f6726557d6"
    },
    {
      "claim_cluster_id": "b11a9565-86ce-4b37-aea3-07e84e21fa4a",
      "event_cluster_id": "4ffbb682-25e8-4ae0-936d-0f256e7b5aaa"
    },
    {
      "claim_cluster_id": "ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db",
      "event_cluster_id": "52ede4ef-4c19-445c-ad39-2f9ff6488929"
    },
    {
      "claim_cluster_id": "94ea82f9-8fc1-4541-8fab-b8354c3ea8f2",
      "event_cluster_id": "3276e11e-189d-4a3f-af8c-0dd0ee752612"
    },
    {
      "claim_cluster_id": "d5e58122-8595-4ce1-b4a3-aa9160204856",
      "event_cluster_id": "c8a1c00c-d162-4708-afc0-8961e0642155"
    },
    {
      "claim_cluster_id": "94a84124-c591-4219-8ef7-52760d608300",
      "event_cluster_id": "ae563379-6971-495d-9872-da508cf0a3c7"
    },
    {
      "claim_cluster_id": "c3383556-4a09-4d9a-b202-b1b017162bd3",
      "event_cluster_id": "a7246654-2dda-48ab-8372-7007a1d4709a"
    },
    {
      "claim_cluster_id": "ff920ca0-1e39-41be-ac8f-cd0534048634",
      "event_cluster_id": "d3c1593a-2221-4777-89bd-fb14c68a1659"
    },
    {
      "claim_cluster_id": "0f047203-3949-4e82-86d9-77d6fe7af9c8",
      "event_cluster_id": "2a47fd74-5995-437d-b0b5-6396ca3119f9"
    },
    {
      "claim_cluster_id": "7eff6a8d-9ae3-41f9-9ad2-cfcb191e7380",
      "event_cluster_id": "b25f7b20-354c-43f5-90f3-fd9a86b1ae72"
    },
    {
      "claim_cluster_id": "64b58fdb-7776-47be-a603-30c85a60366e",
      "event_cluster_id": "2f12da3e-336e-40d2-ba41-61b838ad70f2"
    },
    {
      "claim_cluster_id": "b874b38b-169d-4b90-b373-ae919f14c5a0",
      "event_cluster_id": "2c8a535e-7913-4f01-8d69-eb8f7265032f"
    },
    {
      "claim_cluster_id": "928cf7ca-8343-47ca-be27-378bc29b7fbe",
      "event_cluster_id": "5e55d80c-dfc7-448b-bcef-ae880cfffcd6"
    },
    {
      "claim_cluster_id": "7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607",
      "event_cluster_id": "088ae3ae-ad79-4cbe-9205-0c7fb4deef45"
    },
    {
      "claim_cluster_id": "54bf8eb2-6975-454f-a48b-59abffdfe4f4",
      "event_cluster_id": "d4bc60e5-da16-45c3-909d-aa14379adeb2"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"
    },
    {
      "claim_cluster_id": "c0a45d49-4b4d-4871-845a-e13c06e06fa2",
      "event_cluster_id": "e0d33feb-9779-4cf1-a571-59040d3ea8f1"
    },
    {
      "claim_cluster_id": "e0b76993-43d7-4b38-b891-9ad858a2c5f6",
      "event_cluster_id": "5b9f78e0-35e8-4e52-9ba4-34ecb628f952"
    },
    {
      "claim_cluster_id": "9f34aa0e-2eb3-43e3-b4dd-54a36752af72",
      "event_cluster_id": "1479c6ff-179b-497f-9932-93213bb53a6a"
    },
    {
      "claim_cluster_id": "c03b0c98-53e3-4757-8e78-30293d823fdb",
      "event_cluster_id": "635b07ed-e811-4ba9-90cf-8c1aed9aaaa3"
    },
    {
      "claim_cluster_id": "8b0aef83-1693-4fa2-8559-a133b18a2dbb",
      "event_cluster_id": "64ba9893-281a-4427-95d7-8ab7818e5d93"
    },
    {
      "claim_cluster_id": "fc264446-1206-43b0-b6e2-29d7fc43d99c",
      "event_cluster_id": "52f03b57-8fb1-4ff1-8eda-c0d228097a8f"
    },
    {
      "claim_cluster_id": "5d8665ac-7337-470b-ae27-2d46610e9f97",
      "event_cluster_id": "e18afe50-8e61-4915-8745-6256e6a782cb"
    },
    {
      "claim_cluster_id": "7bf4f678-55d5-4f6a-922f-0b5de572f033",
      "event_cluster_id": "12b80aca-12ee-4bab-a55e-bbfec7c756c7"
    },
    {
      "claim_cluster_id": "ef78627f-ce46-445c-8434-674b16f6966e",
      "event_cluster_id": "2c8bf59a-7972-4ab1-a4ae-680a19fde855"
    },
    {
      "claim_cluster_id": "29880646-f50e-47bd-8b04-23f2c8716fdf",
      "event_cluster_id": "0da6573a-b2db-4671-b4e0-6012c6bd63d6"
    },
    {
      "claim_cluster_id": "97e28e03-c0a3-40ba-8418-88973425525a",
      "event_cluster_id": "eed368dc-e9d0-472f-90ca-6ea4839317c3"
    },
    {
      "claim_cluster_id": "ce4379b5-864c-4150-b826-c6825e39d887",
      "event_cluster_id": "4be56027-8172-47cc-b793-5f37e487c1b0"
    },
    {
      "claim_cluster_id": "970a5cc7-9a05-4850-b0f1-f59128c441c8",
      "event_cluster_id": "8b843277-fda8-4ecf-9981-5b5f31ef86a7"
    },
    {
      "claim_cluster_id": "d017f7be-45ae-4ae5-b72e-a6e53f0a589b",
      "event_cluster_id": "6b5cfe37-19cb-4d16-b4f9-67d51f90495a"
    },
    {
      "claim_cluster_id": "a751c83d-9da2-48e9-83a8-bc6d8a1c455f",
      "event_cluster_id": "8ec5c238-a613-4762-a252-bba4045dc17b"
    },
    {
      "claim_cluster_id": "74e38083-39b2-4b0b-8874-879983366a75",
      "event_cluster_id": "47db3c81-ee29-421a-b1e7-9a9b4cbbe8ce"
    },
    {
      "claim_cluster_id": "a5514e09-1046-4832-bdea-694c3e6ab12a",
      "event_cluster_id": "65229c4d-fc92-48aa-bd10-466bee027dfd"
    },
    {
      "claim_cluster_id": "4f0130b7-d8c3-44c1-892f-fe74aef4cecc",
      "event_cluster_id": "cbce7506-b8ff-4232-9cb2-70afae134899"
    },
    {
      "claim_cluster_id": "0c068743-c246-4fb1-8a38-ed41dc7e9fa3",
      "event_cluster_id": "9a525fe9-9fb6-41e1-85e3-967787b02690"
    },
    {
      "claim_cluster_id": "5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6",
      "event_cluster_id": "d03251b2-2516-4731-9dc4-6cb10da8a70a"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "500957af-7f87-40ca-b575-44450d181bfa",
      "event_cluster_id": "14fc8edb-0dea-4ae6-b573-ec0c5512391b"
    },
    {
      "claim_cluster_id": "9b7211c2-d426-4818-9305-d12ff5c6e2a5",
      "event_cluster_id": "59b16d26-5dcb-404b-8589-2b9a2089c70d"
    },
    {
      "claim_cluster_id": "e7606791-adc1-47d9-b4e0-1e86a03f87ad",
      "event_cluster_id": "67c7f204-fd07-4c45-80b1-5b0bd873efd4"
    },
    {
      "claim_cluster_id": "58bf9f4a-adda-4853-802b-78d04aa711fa",
      "event_cluster_id": "b3c5d56a-6d97-4291-aa82-9075fd6b93ba"
    },
    {
      "claim_cluster_id": "891e1da4-bfc6-4524-a5da-153bde60b165",
      "event_cluster_id": "722d06bc-1512-434a-8214-a8daff8fb8a9"
    },
    {
      "claim_cluster_id": "0257adbd-adf5-4aee-a9de-3500c50d31a2",
      "event_cluster_id": "1b6f0e82-4a2e-409a-a651-9a7baa243dc6"
    },
    {
      "claim_cluster_id": "42314335-3518-45c0-909b-96111c0955f6",
      "event_cluster_id": "1d430602-1893-4300-910c-58f51643ea58"
    },
    {
      "claim_cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "event_cluster_id": "89418c34-2fb2-418b-8359-739bf85f5c05"
    },
    {
      "claim_cluster_id": "c8cf7c39-4d6a-4fec-8451-b46f12ccd07f",
      "event_cluster_id": "b97fc666-43dd-4240-9de8-5f0f42a98b08"
    },
    {
      "claim_cluster_id": "c8416335-0a4e-4b5d-aa9e-40e533302d3c",
      "event_cluster_id": "c0f8ea6d-76da-48d4-a14a-869a34f021c4"
    },
    {
      "claim_cluster_id": "c6e50b1a-e795-43fc-baca-c835ba2bf14d",
      "event_cluster_id": "1137dcb0-70d8-4dce-ad5f-8ffbbf5dde18"
    },
    {
      "claim_cluster_id": "fb1e3132-0050-4db5-a637-391574f70b71",
      "event_cluster_id": "f5a61f8b-83ab-44ed-b769-3208e32281e7"
    },
    {
      "claim_cluster_id": "f9c980a9-33b9-4834-922a-947a13f5a035",
      "event_cluster_id": "3e491056-e070-48f7-a358-499c803ca16f"
    },
    {
      "claim_cluster_id": "a52869e4-c88e-49c1-a8d6-0ba25d6c7cfc",
      "event_cluster_id": "6e7eeae9-331c-4977-a841-a2cc08dd5381"
    },
    {
      "claim_cluster_id": "51086a98-c771-4b7c-8eaa-b6fbb8629a30",
      "event_cluster_id": "576d86b7-1d28-4f66-8319-eb34a892467d"
    },
    {
      "claim_cluster_id": "f006e419-46e2-4ca6-a34c-afa36d7458b2",
      "event_cluster_id": "073edba6-a930-4e69-b786-5decd28e9957"
    },
    {
      "claim_cluster_id": "39f5f705-55d1-4470-8928-bfce04d4f7be",
      "event_cluster_id": "7b1f2cfc-5328-4132-ac99-4d91818f60f6"
    },
    {
      "claim_cluster_id": "e06a0883-b86c-4452-9949-2a46787f07ab",
      "event_cluster_id": "8f445d44-1e7e-4d7a-9a5f-c141941a7046"
    },
    {
      "claim_cluster_id": "2762cfd3-48ae-4a0c-baf0-bfb36bcdff70",
      "event_cluster_id": "1997b709-7204-4376-b1e8-77d6b8518a0f"
    },
    {
      "claim_cluster_id": "2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6",
      "event_cluster_id": "aea06698-0475-487a-a76e-80bcbad00033"
    },
    {
      "claim_cluster_id": "503584d7-75a5-4f03-adb1-4844dd4d9b9f",
      "event_cluster_id": "498d40d5-5e43-40ad-a2cf-e0c8dead042f"
    },
    {
      "claim_cluster_id": "d6f2cb3f-8705-43f8-a523-1b8fab745bf8",
      "event_cluster_id": "800e3797-9c0e-40b0-9390-53c562dabc15"
    },
    {
      "claim_cluster_id": "783f85bb-dceb-450a-9a34-4a650e18ed9f",
      "event_cluster_id": "b059c11d-95fa-4f8b-93e3-1c4f21e60f61"
    },
    {
      "claim_cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "event_cluster_id": "b5cfe764-3a89-4e77-9f9e-c720d7d22394"
    },
    {
      "claim_cluster_id": "22c3b77e-fa98-44e1-b509-f721cef0815f",
      "event_cluster_id": "40e574c7-e1d8-4cc8-a46a-a5e8d1efd793"
    },
    {
      "claim_cluster_id": "800e7e36-7ce1-4e55-a18d-394d83673d71",
      "event_cluster_id": "e6aabf8d-023e-4060-ae58-13d0d54f160c"
    },
    {
      "claim_cluster_id": "cbbb2109-39b9-4308-a4ce-30a48563cab7",
      "event_cluster_id": "c4596456-6844-4eff-9082-8a0cfee4acfd"
    },
    {
      "claim_cluster_id": "69483fde-1234-4c7a-8580-5490aec071f7",
      "event_cluster_id": "bae5df31-d0a5-4216-b755-4add987f460d"
    },
    {
      "claim_cluster_id": "08c235e3-44d9-4f4b-9af7-a9491ce983db",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "64b58fdb-7776-47be-a603-30c85a60366e",
      "event_cluster_id": "52f03b57-8fb1-4ff1-8eda-c0d228097a8f"
    },
    {
      "claim_cluster_id": "a5408918-67c4-45bd-afb3-95d8aced1dc9",
      "event_cluster_id": "72fcc1d4-63ac-46e2-af29-194e69352aec"
    },
    {
      "claim_cluster_id": "17eaa25c-625f-4414-b1ad-78d904209f81",
      "event_cluster_id": "4dc44ea9-8d2b-4f60-a0c5-d10d5af77cfb"
    },
    {
      "claim_cluster_id": "f0d99bfd-e20a-4b87-9be0-a227af6f681d",
      "event_cluster_id": "371a45ea-84b1-459c-8153-e0d2017b4ce1"
    },
    {
      "claim_cluster_id": "762409bf-96e2-43cc-99d8-45783ade1b1f",
      "event_cluster_id": "2e1de1f1-7494-4d78-994d-deb9c207c005"
    },
    {
      "claim_cluster_id": "3073b261-2ceb-46c8-bad6-3808fb657e33",
      "event_cluster_id": "1d4622f2-0a7b-4423-ad78-a011864bf902"
    },
    {
      "claim_cluster_id": "1071979a-b25a-4432-8eb1-62e54bcd27e1",
      "event_cluster_id": "5cf38b83-9e7d-4021-9751-cdd7c1a0b38d"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "65545a07-9406-46c5-9357-571d95749394",
      "event_cluster_id": "a1f52faa-345a-4142-abf0-5bc06a645050"
    },
    {
      "claim_cluster_id": "c9b6b0e3-811d-4e56-9eba-3408eb1dc06f",
      "event_cluster_id": "cfc42d88-49ac-4610-a5c7-0cce12304171"
    },
    {
      "claim_cluster_id": "24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "69fa7886-741a-440f-8a20-2b9ce60729ac",
      "event_cluster_id": "28b9ee99-8c41-4de6-b5e4-1d006511f119"
    },
    {
      "claim_cluster_id": "6efc04ea-c5a7-40f2-bf74-98f55c06f1df",
      "event_cluster_id": "2e504c36-cc23-49bf-9bfa-77adbeb06137"
    },
    {
      "claim_cluster_id": "1cbddfd6-c491-40b1-b10c-fd4387edddf6",
      "event_cluster_id": "b92f2bdb-a4c9-478b-a96f-1f47457a005d"
    },
    {
      "claim_cluster_id": "252d476c-5ce3-4a28-9ab5-6406955b15b2",
      "event_cluster_id": "381be24e-814e-460f-aaf7-24ebc78ab4d4"
    },
    {
      "claim_cluster_id": "696180e6-d43f-476a-afce-5f13dbb9929a",
      "event_cluster_id": "f3cb116f-ca76-4bba-949e-3c48f31bacfe"
    },
    {
      "claim_cluster_id": "b398f217-24d9-4c22-8d5a-732320853c1b",
      "event_cluster_id": "5674d01b-2996-4ed7-850d-de449d707ce5"
    },
    {
      "claim_cluster_id": "6222d4f0-7c6d-42f0-83ec-17412b1907f1",
      "event_cluster_id": "21936564-78e3-425d-afce-2c71d0db68fa"
    },
    {
      "claim_cluster_id": "144fa955-73da-4f76-8472-31c3ddd2636d",
      "event_cluster_id": "336f2ec9-9cdf-4236-a126-80e564dfeb50"
    },
    {
      "claim_cluster_id": "c98491ce-51cb-40b0-93ae-d389e1c9d7a5",
      "event_cluster_id": "02bc5fb8-e0fa-4719-bd7d-c08bd3e70f93"
    },
    {
      "claim_cluster_id": "a9a65207-69ea-45b8-ac25-c8ee16fc4a08",
      "event_cluster_id": "97ffbb55-ab53-43e7-aa63-34930f97c42a"
    },
    {
      "claim_cluster_id": "1c5f9ea9-d432-4800-9abd-5af5c927568b",
      "event_cluster_id": "88ed9b73-fcba-44e5-9474-9587e7fb5ebb"
    },
    {
      "claim_cluster_id": "e871839f-962c-43cf-a2f7-5ebaf26de0a1",
      "event_cluster_id": "139b8293-aa0f-409e-8a4f-0e3ee1191f72"
    },
    {
      "claim_cluster_id": "54a8d4bb-c88c-46df-a439-6be0dfcdce0d",
      "event_cluster_id": "5549ed3d-7dea-4eb0-ad38-1dd76c667c0c"
    },
    {
      "claim_cluster_id": "a6d51f65-13a0-42d8-b6fe-66f9daf5bd01",
      "event_cluster_id": "145084b8-39a8-4c53-8295-e697e796d433"
    },
    {
      "claim_cluster_id": "4a817862-6fa5-4e7c-8998-977aaad70250",
      "event_cluster_id": "25337f06-7f63-4f2c-9964-5f855922e638"
    },
    {
      "claim_cluster_id": "f4e0a38c-1349-4970-a962-5d6d7478cce6",
      "event_cluster_id": "ad846634-778f-48a1-8b99-37387f981b3f"
    },
    {
      "claim_cluster_id": "e4184b4a-b3b8-45cd-9a60-442e840d1a7e",
      "event_cluster_id": "ea03e48a-fe82-4735-a7d5-db2e5351b982"
    },
    {
      "claim_cluster_id": "6e8d0f46-aead-4efe-a267-3f325cfe8dec",
      "event_cluster_id": "9809fa62-b9bf-47df-ad2e-8fa4d84399c4"
    },
    {
      "claim_cluster_id": "96cc3b99-284a-4ca8-957e-5bfc2a13a654",
      "event_cluster_id": "58d84750-75e5-4a06-9053-f1a5a8baf564"
    },
    {
      "claim_cluster_id": "4fe899cb-f73e-4ec7-b569-5ce5b990df8e",
      "event_cluster_id": "f7069e5f-ee25-470b-986d-c157ab1e1613"
    },
    {
      "claim_cluster_id": "843e2174-20bd-4386-beb4-ad4f8d0ba790",
      "event_cluster_id": "59d2954b-c33a-4e1c-87bb-ce014430514e"
    },
    {
      "claim_cluster_id": "2fe163fe-8ed3-4202-aad1-5f84672917c4",
      "event_cluster_id": "cc709bf0-3f13-4e4e-b2f5-adbdf5752221"
    },
    {
      "claim_cluster_id": "323efa20-d8ad-424c-9c0e-ac5d255b9276",
      "event_cluster_id": "84d3d5e2-5fb1-4388-9576-0de3210a0439"
    },
    {
      "claim_cluster_id": "de08eb08-92b3-4974-9e99-e79755582996",
      "event_cluster_id": "7ed6cceb-29b9-4150-b16f-00796c0ac573"
    },
    {
      "claim_cluster_id": "c5298737-21d9-47c4-b52e-e662ee88b15b",
      "event_cluster_id": "9bdbcd6f-9804-4d17-b1b0-8bb5670939d2"
    },
    {
      "claim_cluster_id": "2c8b719a-2363-4f9f-9be2-6d1801374195",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "a07d35a7-6217-400e-856f-516669ebb436"
    },
    {
      "claim_cluster_id": "170448e1-fefc-424b-b5a4-23941f88389e",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8",
      "event_cluster_id": "34a8290a-940e-4582-8dbf-cb195db85e28"
    },
    {
      "claim_cluster_id": "3d5e8f72-7611-4d2c-a35c-668790f97298",
      "event_cluster_id": "918d1070-a60a-4619-b33f-d29c47c7f6cb"
    },
    {
      "claim_cluster_id": "9a6fa43d-c803-4c20-bac3-545db67a8241",
      "event_cluster_id": "2826c59b-a252-4d3e-9bdc-eb92dc90ee16"
    },
    {
      "claim_cluster_id": "1c220b25-802f-4053-89c5-d8f4805341a5",
      "event_cluster_id": "58794c22-3f6d-401d-8ef2-ec12fd369ff0"
    },
    {
      "claim_cluster_id": "1190ac87-5191-4e29-877a-253af15bb185",
      "event_cluster_id": "967932b9-89a1-4f1a-8846-57c7efec1e1b"
    },
    {
      "claim_cluster_id": "639596e6-4b0c-464a-9fa5-8272920e87b4",
      "event_cluster_id": "e4f0ca80-4588-4554-9e20-d646dd11d817"
    },
    {
      "claim_cluster_id": "818db8b7-0e38-4d06-8f87-4de475ce7556",
      "event_cluster_id": "6e9ec51a-5e5f-4dab-8bcb-01b5c15fb587"
    },
    {
      "claim_cluster_id": "818db8b7-0e38-4d06-8f87-4de475ce7556",
      "event_cluster_id": "ce551d12-b33f-4043-8ad2-015e698a2cda"
    },
    {
      "claim_cluster_id": "0c265597-6c2b-4efe-9acb-799f67a3b4d1",
      "event_cluster_id": "a0925808-7df0-46ec-bb06-9cb553f8b8fd"
    },
    {
      "claim_cluster_id": "92df53c2-d00a-4565-ac4a-1279aad1b2ee",
      "event_cluster_id": "615888f6-5d35-4a8c-acd9-9e71127a4cb4"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "ee97e835-1007-4cd5-b270-714f0880c07e"
    },
    {
      "claim_cluster_id": "1c849e20-6024-47fa-80b4-e611385ba612",
      "event_cluster_id": "7f5ce29d-718d-42a9-af2b-7bbc25320894"
    },
    {
      "claim_cluster_id": "63fb8530-c54e-452a-b71d-729fca3c7e67",
      "event_cluster_id": "5949d818-e369-4db8-949d-7a462c260498"
    },
    {
      "claim_cluster_id": "c7e21d17-7b1c-44ba-9b2b-db5a38de4e97",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "2dc250b5-58d8-4c44-80d2-2c17640ea117",
      "event_cluster_id": "c55f11e7-306a-41b0-af0e-b025ab77a3ea"
    },
    {
      "claim_cluster_id": "c462838a-420c-4b5a-ad06-676939effe93",
      "event_cluster_id": "34a1b507-fb03-489f-a79e-be687aeaabe9"
    },
    {
      "claim_cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "event_cluster_id": "4f92bf5d-f880-4cc6-a2da-cbba50d74014"
    },
    {
      "claim_cluster_id": "fd305e86-cd2a-4329-a45e-739147206ba8",
      "event_cluster_id": "eff3ff70-7d42-45d0-a372-4aa15bf9f280"
    },
    {
      "claim_cluster_id": "c3cd1557-129f-4369-b850-25bdf5456c16",
      "event_cluster_id": "4a7e58b2-ad14-4711-92da-e24d91c0e2a2"
    },
    {
      "claim_cluster_id": "6a54c6d4-9e49-450e-95c4-f3afc0f85f6c",
      "event_cluster_id": "d231b87f-915c-4032-9dcd-5f1c1337576b"
    },
    {
      "claim_cluster_id": "77de864b-c2fe-4a23-a506-d0665b0f08bf",
      "event_cluster_id": "73b5bb5e-19ff-4738-bc4e-5908ad8a0474"
    },
    {
      "claim_cluster_id": "c7e21d17-7b1c-44ba-9b2b-db5a38de4e97",
      "event_cluster_id": "a18f54d8-98f1-491a-9d47-c6333890fc51"
    },
    {
      "claim_cluster_id": "bc56200e-afec-40d7-a87d-167e90733913",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "d521ac4e-4810-4638-bb77-9fbf7ba74f52",
      "event_cluster_id": "d6f2ede4-7d0b-48ff-b867-ebcd3c6ff871"
    },
    {
      "claim_cluster_id": "ea6a2243-de2d-4dba-b6c1-70fc6e903bfb",
      "event_cluster_id": "51ee5c3c-1ec7-4729-8ed7-80ffe951b756"
    },
    {
      "claim_cluster_id": "38eef897-6e59-4836-bf0e-1e7e106baf53",
      "event_cluster_id": "e47a5c41-ef67-4e8c-bde7-553670fb6a9f"
    },
    {
      "claim_cluster_id": "0f3a2cc5-8301-476a-b658-747594635542",
      "event_cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63"
    },
    {
      "claim_cluster_id": "c75ee75a-e51c-413b-b72e-c2160bcb40c1",
      "event_cluster_id": "a4ea2030-230b-4e96-b485-ae147aec2613"
    },
    {
      "claim_cluster_id": "14ffc7a5-e5c3-48de-a2b4-8b721ff34fcc",
      "event_cluster_id": "a64b48c8-6765-4ea4-add1-20cd675e1418"
    },
    {
      "claim_cluster_id": "571676ab-8830-47d5-a21a-ef55f09caa73",
      "event_cluster_id": "a06923fa-5b7d-4810-97a1-737122cf8581"
    },
    {
      "claim_cluster_id": "55f659a1-e5dc-41c5-8a43-9846f564af08",
      "event_cluster_id": "970fa237-7a1d-4b64-a4c6-7a158c05542d"
    },
    {
      "claim_cluster_id": "7686685c-6e82-408b-a7b9-2e453038450e",
      "event_cluster_id": "20024815-8b0e-4e7c-9c28-eb57a4f0783f"
    },
    {
      "claim_cluster_id": "06da14b8-536e-4d2e-83b1-118cfb44829b",
      "event_cluster_id": "2f59f9a6-6a8f-409f-8959-e71823889fb2"
    },
    {
      "claim_cluster_id": "235bfc4a-e3f2-4850-83c2-a78043ab464b",
      "event_cluster_id": "d00c4814-110a-4898-a26e-19970d2ed410"
    },
    {
      "claim_cluster_id": "ea43c4dd-2096-4292-b914-5c467c6f33db",
      "event_cluster_id": "867a2b63-9e44-4ba6-82e8-55c04ceb4f4f"
    },
    {
      "claim_cluster_id": "0626769d-4a42-43f4-8356-e89543f6dcc3",
      "event_cluster_id": "e924815f-2da7-4209-b239-ad1c99e71b41"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "0c50e809-0f1b-4656-a0dd-110732b6e47b",
      "event_cluster_id": "c9b1ea29-5b23-4579-928f-8f3b1f3679f1"
    },
    {
      "claim_cluster_id": "0de2a028-10da-49bb-8b43-e7f79a0ff6dd",
      "event_cluster_id": "ecb10f6a-8831-4846-bf71-113659233f12"
    },
    {
      "claim_cluster_id": "c0fbbbbf-776a-47c5-9e8d-f798f722abf7",
      "event_cluster_id": "ab7feba4-a1e3-49aa-a70a-5a191501e657"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "f83b448c-d81d-4175-b604-2783d1df502d",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "f8618eda-effd-4eda-b2ad-66d8fec0ba02",
      "event_cluster_id": "031a0aad-21cd-4ca2-8a60-5a981bd9de8c"
    },
    {
      "claim_cluster_id": "6967755e-61e4-4308-be97-cdea95a155c7",
      "event_cluster_id": "aa27d9a6-1fd7-4a19-84c5-5bd88d623d31"
    },
    {
      "claim_cluster_id": "8f273fa4-f8bd-4413-8ce1-7183b77e2566",
      "event_cluster_id": "6a85e8dd-d86f-4e00-b252-62364be2e0ab"
    },
    {
      "claim_cluster_id": "aa95c9e4-8d02-4bc6-90e1-de547f4e4e60",
      "event_cluster_id": "70bd9665-a0ef-44fe-b03d-553c56604080"
    },
    {
      "claim_cluster_id": "252d476c-5ce3-4a28-9ab5-6406955b15b2",
      "event_cluster_id": "24b2ce3b-aee0-470f-b1ec-7fc4ce0d6235"
    },
    {
      "claim_cluster_id": "11aef681-a744-409f-8cc3-69822e3a86b2",
      "event_cluster_id": "39b04d3b-887f-479b-999b-c671dfd12bd6"
    },
    {
      "claim_cluster_id": "411175f7-0ca0-4fb5-9db2-35822ef1cc0a",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "d2830923-6260-4e70-9fc4-f723af340d1f",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "fe6adf14-e7af-49eb-8b83-de4001fbc495",
      "event_cluster_id": "f1fff97c-e8ee-45ff-b0df-2544c89e909e"
    },
    {
      "claim_cluster_id": "a5408918-67c4-45bd-afb3-95d8aced1dc9",
      "event_cluster_id": "bd9f40ee-8b97-4557-aa2d-1a87da031fda"
    },
    {
      "claim_cluster_id": "bbefdcbd-8560-44a4-b45a-d11652dfe311",
      "event_cluster_id": "432216ce-2589-40bc-b4f7-cabc8c9d84b7"
    },
    {
      "claim_cluster_id": "7576470b-cafe-4c17-9541-256e9ec07097",
      "event_cluster_id": "ef30a0f0-6c8f-4544-8a16-49df03cd9879"
    },
    {
      "claim_cluster_id": "de4f148f-cf69-426b-b5bb-f722fb88313c",
      "event_cluster_id": "0c4c6169-f685-4aa8-b6de-d396766a5c80"
    },
    {
      "claim_cluster_id": "02fc2c1c-e5e4-40d6-92bc-a975544e0e30",
      "event_cluster_id": "03a9ef94-2f49-4a92-bace-dca90bc3fda0"
    },
    {
      "claim_cluster_id": "9920b872-a377-485c-97d1-65b98d038806",
      "event_cluster_id": "b252b9c3-5126-48a5-aa3d-32d7e4a0465f"
    },
    {
      "claim_cluster_id": "325111bb-e15c-4f08-a4a4-3f81e99d9f35",
      "event_cluster_id": "a89bcef2-6caa-4f8e-9e33-b36ab68a4d84"
    },
    {
      "claim_cluster_id": "1b8ba3f8-2b51-4433-9cf8-2a5412413277",
      "event_cluster_id": "f1a2cf3f-1311-40c2-b18c-4f973df71568"
    },
    {
      "claim_cluster_id": "e52244b2-1143-48cf-9735-ce26094681d1",
      "event_cluster_id": "5cdd32a6-f13e-42bd-94a1-e86008aa2d86"
    },
    {
      "claim_cluster_id": "d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3",
      "event_cluster_id": "3a95c736-dd02-4122-9108-f00df86397af"
    },
    {
      "claim_cluster_id": "0cdd2771-1f79-419e-940c-c74f863377bb",
      "event_cluster_id": "4b620911-0006-4874-ad8a-a8595a7140e4"
    },
    {
      "claim_cluster_id": "c31ea39d-ce0d-46ee-be4c-e32d46721b78",
      "event_cluster_id": "33028b3d-3070-4c94-af90-91fb62e4dd68"
    },
    {
      "claim_cluster_id": "f7fbb95e-08d7-410a-8e1f-290e984463d7",
      "event_cluster_id": "5071d605-12eb-4c65-9753-bdff2ac75ffe"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "f6d51725-748d-4605-90f1-5a35204e66b9"
    },
    {
      "claim_cluster_id": "43966195-88ed-478f-bd22-9c59b6eda45a",
      "event_cluster_id": "e1ec3ffd-db25-4cb3-96fb-b11f7546206a"
    },
    {
      "claim_cluster_id": "f731bc0b-cabf-4314-a5f8-e94d31589cea",
      "event_cluster_id": "eb6475eb-91f7-4af2-a9fa-7784d03f74bc"
    },
    {
      "claim_cluster_id": "903d2f0d-f14e-42ff-a685-a20e841d8f7b",
      "event_cluster_id": "ad4af428-e855-4639-a39a-60d90249fe21"
    },
    {
      "claim_cluster_id": "fd96ef0f-c2a3-47f0-b0ee-4580d498d313",
      "event_cluster_id": "51de12f3-d554-4161-b0ec-4b2186f0cb26"
    },
    {
      "claim_cluster_id": "c8956774-b873-4e48-aca4-1d4ce1428a6f",
      "event_cluster_id": "3038e36b-6f90-4a8b-a5ed-b89bec5c7144"
    },
    {
      "claim_cluster_id": "58bf9f4a-adda-4853-802b-78d04aa711fa",
      "event_cluster_id": "1f760b40-15ae-43cb-8956-bedcbe236708"
    },
    {
      "claim_cluster_id": "3401a78f-3a68-442d-942b-4cef401613a8",
      "event_cluster_id": "71435cc5-d65b-4e3e-9454-ffe0371a42f1"
    },
    {
      "claim_cluster_id": "3769f810-e5f7-4d0a-9821-1876b6cadf34",
      "event_cluster_id": "d118efd6-5acc-43c8-a0da-c30ae94fc13d"
    },
    {
      "claim_cluster_id": "11e43ecc-22c8-4f1c-b13a-fb97013ce963",
      "event_cluster_id": "fbf4f33e-0e24-406c-8b43-497c4ae8f7fe"
    },
    {
      "claim_cluster_id": "59905a93-0117-4d6a-a153-cacf3c9feeb8",
      "event_cluster_id": "3e954c39-38a1-4449-bb6c-9e8070f71e04"
    },
    {
      "claim_cluster_id": "ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db",
      "event_cluster_id": "2dc916ab-843e-4007-bf03-57e437a7dc48"
    },
    {
      "claim_cluster_id": "e2c6a7c7-ff69-4a0f-a631-41e7e5bd25a0",
      "event_cluster_id": "a2d75661-0f1a-4093-bbb2-d5f9c836dda0"
    },
    {
      "claim_cluster_id": "ab52850c-7dc5-4f99-b37e-0c628b078043",
      "event_cluster_id": "507a2a11-43b9-4279-b484-7be9d201408d"
    },
    {
      "claim_cluster_id": "2c1958a0-e83a-4912-9902-e6456b756f14",
      "event_cluster_id": "f65902ca-8669-4b7e-9388-0fbc20879e59"
    },
    {
      "claim_cluster_id": "a5114ace-99b6-4b39-875b-8b7056c70002",
      "event_cluster_id": "ab19e784-fddd-46e2-a989-cdf804b997c6"
    },
    {
      "claim_cluster_id": "c054d850-518a-42ab-a850-01492f7fb7ce",
      "event_cluster_id": "8ce1b035-20cf-4e3a-b84e-8642795846fd"
    },
    {
      "claim_cluster_id": "1ae95d89-cea7-4f27-8ed8-d4f49e95c5db",
      "event_cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63"
    },
    {
      "claim_cluster_id": "1977f04e-4cc8-4af7-ae78-39ce7804eadf",
      "event_cluster_id": "e6342a31-63c5-4e60-b405-bead23c2ee06"
    },
    {
      "claim_cluster_id": "ae1e52fc-461a-4609-8b02-2589611c162e",
      "event_cluster_id": "11103fe7-e53a-478f-ac79-6e43af250e15"
    },
    {
      "claim_cluster_id": "39caeecf-930f-43df-a6d4-e237146a33a8",
      "event_cluster_id": "20c1ad4a-8c5e-407a-b67d-ed4158ca87ec"
    },
    {
      "claim_cluster_id": "536df2e4-b955-48b2-8a3c-5b06a58c9d87",
      "event_cluster_id": "23aed1db-c001-4e2a-9a10-0e9f672d2101"
    },
    {
      "claim_cluster_id": "cd21b07f-3941-439e-8ffa-59c6da9df98f",
      "event_cluster_id": "9ed0391b-e831-497d-9d87-ba9ea12680b7"
    },
    {
      "claim_cluster_id": "120d61e9-d442-4218-b8d0-9559d9880c3a",
      "event_cluster_id": "92332b03-095b-4c9b-a429-b33ea258a0f9"
    },
    {
      "claim_cluster_id": "ba6f293a-cb12-4697-ba51-b7964934f25d",
      "event_cluster_id": "47933a91-e43e-4731-9328-ce609581c5cc"
    },
    {
      "claim_cluster_id": "a80ecbee-c55e-46fb-a302-1137d87bdcfa",
      "event_cluster_id": "bf9a8cce-4cc9-4b37-881c-ca94d761d671"
    },
    {
      "claim_cluster_id": "f0d99bfd-e20a-4b87-9be0-a227af6f681d",
      "event_cluster_id": "80650d11-8f1c-4d32-a46d-12e884243f7e"
    },
    {
      "claim_cluster_id": "2567422d-b366-451c-a271-4cb76dc8196c",
      "event_cluster_id": "525348f0-16a2-442b-8f83-be5618731e1e"
    },
    {
      "claim_cluster_id": "2c834413-ef2b-486b-81d5-2e0a687a8ca7",
      "event_cluster_id": "0e9e7c31-725a-4645-86a1-d5bba7071b1e"
    },
    {
      "claim_cluster_id": "be7f1195-f177-4bc7-91dc-0cfb479ebb8e",
      "event_cluster_id": "cc6728f4-4d83-4a2b-9077-fcd32909b298"
    },
    {
      "claim_cluster_id": "99b20734-bb32-4aff-b60b-a976139937c2",
      "event_cluster_id": "988ceba9-18e9-4ef8-9eaf-742eb7f2a4f1"
    },
    {
      "claim_cluster_id": "7b4db769-a456-496c-a3b6-6f242fdb7665",
      "event_cluster_id": "e0f9e573-f9e0-44e0-aff6-2dee5ec70199"
    },
    {
      "claim_cluster_id": "cdfd2024-64ea-4945-8131-782266513caf",
      "event_cluster_id": "8181e898-2713-41af-b776-395891458be2"
    },
    {
      "claim_cluster_id": "0aded89b-0a86-47dd-8291-b59848abe762",
      "event_cluster_id": "ce23ab49-6ed2-4eb9-b4ae-b0b0514251c2"
    },
    {
      "claim_cluster_id": "c3c67b90-f64b-4b19-8a14-0325205ef32e",
      "event_cluster_id": "32f448b3-33d8-4d45-9792-ba9ba2feec34"
    },
    {
      "claim_cluster_id": "42b60cc5-5a50-48f5-a8c0-713eeb591918",
      "event_cluster_id": "7f4c9ab9-c44d-442b-a98c-55507ea1e6cb"
    },
    {
      "claim_cluster_id": "0e4acd7e-6e9e-4ec6-953b-f0301546aee1",
      "event_cluster_id": "65ac3d2f-1144-42ab-9435-1522b78a54a3"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "bed08ef5-4cb1-4f05-b2d4-a996242acd93",
      "event_cluster_id": "812a3386-bb25-454d-924b-c4a0c4d57dfa"
    },
    {
      "claim_cluster_id": "1713cb4d-ab0f-4257-a2cb-4aec01e411ef",
      "event_cluster_id": "bdea90e6-def6-4640-876b-5fa83c1b85d0"
    },
    {
      "claim_cluster_id": "883c65b8-c8f1-4a3b-8bd5-fb9d61a95876",
      "event_cluster_id": "59b16d26-5dcb-404b-8589-2b9a2089c70d"
    },
    {
      "claim_cluster_id": "0dad0e38-e0db-46d5-a25f-8e95be6a721f",
      "event_cluster_id": "d7410313-2ce6-46bc-b39a-d7543341b90b"
    },
    {
      "claim_cluster_id": "c58f6371-bd47-4b22-b946-60358a570901",
      "event_cluster_id": "2e14b451-260d-492b-b69f-85a48e166493"
    },
    {
      "claim_cluster_id": "ec49cf91-92d9-493d-940c-303b8e78e136",
      "event_cluster_id": "116f2145-073f-478d-a5b4-2d21196c953a"
    },
    {
      "claim_cluster_id": "73fff1e2-bc77-421c-8436-e9bf094a9733",
      "event_cluster_id": "c92bd461-8266-4e4d-aba8-e4cf7e3c1fed"
    },
    {
      "claim_cluster_id": "a1593cbe-8c39-423f-abae-2707e84a1e5e",
      "event_cluster_id": "6cc59f40-7aa9-413e-ae5b-64e2c17a2e71"
    },
    {
      "claim_cluster_id": "626c75be-9b85-4ac5-97e0-e03b79d0191e",
      "event_cluster_id": "d147629e-d16f-4224-83bb-da1109733168"
    },
    {
      "claim_cluster_id": "7b2b0362-dab0-48fd-8877-b1ece626a827",
      "event_cluster_id": "91e8fe58-f0fa-44e3-ae52-de74821a1034"
    },
    {
      "claim_cluster_id": "9960f165-6141-4ca0-8dc4-0a136bfde83d",
      "event_cluster_id": "f9ebd297-091c-4753-9543-c123ed3c1fc3"
    },
    {
      "claim_cluster_id": "5c7c452c-db3f-4741-97ef-77d49e8c75b4",
      "event_cluster_id": "844b0e6c-6c02-4726-b2d2-097a5c40629c"
    },
    {
      "claim_cluster_id": "a32303e6-4765-4335-9847-b5ee18494799",
      "event_cluster_id": "25ed23a4-7940-477a-9165-7053b4f9330d"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "f236d68f-fe39-4432-9a36-341eb8900ee6",
      "event_cluster_id": "6f88a50d-7c8b-451d-b706-e766cfe9a47a"
    },
    {
      "claim_cluster_id": "0298b49f-bf28-40f5-acd6-4e9587c690ae",
      "event_cluster_id": "73ef4f09-b38f-4c98-bd02-c07cf7fc2073"
    },
    {
      "claim_cluster_id": "ea08b9f4-137e-40ca-ae54-2e396aa18fc5",
      "event_cluster_id": "22e69426-c76f-4b85-bc81-16af4106a7bd"
    },
    {
      "claim_cluster_id": "20e0f6a7-71df-44b4-b99e-3e278ca655e8",
      "event_cluster_id": "bf1a6f6c-5e34-4a7f-9afc-2b63e460cf67"
    },
    {
      "claim_cluster_id": "f7c875b0-a0b4-45f6-b382-0915f179b2e6",
      "event_cluster_id": "c749df3e-51ac-4d1a-87c6-d17e674f6446"
    },
    {
      "claim_cluster_id": "e12046ad-ffee-4bf5-90ec-51d127135711",
      "event_cluster_id": "8017a44f-3587-48ad-93bb-373a715846dc"
    },
    {
      "claim_cluster_id": "ded98049-aef1-4b4f-a8a6-f68c10032b7f",
      "event_cluster_id": "65ac3d2f-1144-42ab-9435-1522b78a54a3"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "c2f88444-099f-4cbf-b8aa-27e4b2666137"
    },
    {
      "claim_cluster_id": "6967755e-61e4-4308-be97-cdea95a155c7",
      "event_cluster_id": "7150af87-53e1-42a1-8fa3-98b8c7ea1c84"
    },
    {
      "claim_cluster_id": "7885c5ae-734b-4d64-8d84-fc50b9a87ad7",
      "event_cluster_id": "2a4109b0-0594-4c99-979e-19f8908c65ec"
    },
    {
      "claim_cluster_id": "24055b42-2fb3-4a05-8224-3c92490d6a5d",
      "event_cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"
    },
    {
      "claim_cluster_id": "8346c5bc-af0f-44c1-b155-e89d63c46a37",
      "event_cluster_id": "302853ec-6f10-46c6-b305-6047ac1af892"
    },
    {
      "claim_cluster_id": "1e35c814-682d-4b74-be8b-2867b370b971",
      "event_cluster_id": "099689d1-bfaf-4b3b-b795-0a924815ef02"
    },
    {
      "claim_cluster_id": "3d5e8f72-7611-4d2c-a35c-668790f97298",
      "event_cluster_id": "3e001ec5-72ab-4ef2-bec5-7b5552144517"
    },
    {
      "claim_cluster_id": "dfbc19e5-8117-4d40-9c25-774ed7aee906",
      "event_cluster_id": "04a95cfc-f399-41ee-9730-e984f76e78be"
    },
    {
      "claim_cluster_id": "c90c00dc-2c77-42ad-bb5e-2666e53e2bcd",
      "event_cluster_id": "43017a0f-25bd-45a1-b94f-31383b0d5c09"
    },
    {
      "claim_cluster_id": "de7b2349-3e46-436f-9b75-c57089eeaa3c",
      "event_cluster_id": "ce1129a3-23ca-4a3e-bf11-bcbe6b5d487b"
    },
    {
      "claim_cluster_id": "127c457b-8cad-4a81-8d25-66dd51786fe0",
      "event_cluster_id": "5d61b2e4-bbeb-403f-8746-07ecabf64059"
    },
    {
      "claim_cluster_id": "78bccd7b-b8a1-4e70-bdf2-26a8b9ac339a",
      "event_cluster_id": "eb0ee0ba-913e-410b-b9c2-5aa8871f3d24"
    },
    {
      "claim_cluster_id": "698d5e91-6aba-4224-9583-f0b9f9330723",
      "event_cluster_id": "bd2a5352-41e8-4479-ac51-89fb57ca65cd"
    },
    {
      "claim_cluster_id": "3073b261-2ceb-46c8-bad6-3808fb657e33",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "c9f87e7e-e0a4-4be1-aaa4-54f6d3bedaaf",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "ee9a474d-ce93-4992-ac4b-8d9da4087257",
      "event_cluster_id": "b8430087-4ad5-4df6-bc7a-9f268ead6bd8"
    },
    {
      "claim_cluster_id": "1071979a-b25a-4432-8eb1-62e54bcd27e1",
      "event_cluster_id": "1bf0340c-7a77-4298-96fe-bdb20d7a37a7"
    },
    {
      "claim_cluster_id": "7b1c03fe-e3e1-476b-ab84-c44a6ea52022",
      "event_cluster_id": "90d2821b-b505-4e57-a6e2-7f1724a94e93"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "28b8266b-a1c9-4314-9300-fcc436685496"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "ca62b0d7-872b-4a9c-b006-86ccfd239161"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "5fafb978-3006-4010-ae1d-242c5cb188f3"
    },
    {
      "claim_cluster_id": "4180dc5e-36b2-4900-9bf9-c6ecf67fdc08",
      "event_cluster_id": "2caf488d-b467-4866-8066-64992d68542c"
    },
    {
      "claim_cluster_id": "4f331c05-6fa5-4bd8-adc2-5458e8c80843",
      "event_cluster_id": "9db7cf05-3384-426e-a814-edb55b15d53c"
    },
    {
      "claim_cluster_id": "21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb",
      "event_cluster_id": "637ffe03-032a-46cd-af4f-d7f5c220eab9"
    },
    {
      "claim_cluster_id": "eb2ba8af-f927-478b-bc26-2105bdb87c5f",
      "event_cluster_id": "13df1ab3-c8ca-4935-bfac-bf950b3f0183"
    },
    {
      "claim_cluster_id": "b12e5d28-73fe-498d-a612-a3df5aa876b3",
      "event_cluster_id": "03b556ab-fe42-4f7d-954a-c2484c0fac43"
    },
    {
      "claim_cluster_id": "4313d034-31f9-4eb9-9451-e9a5dda6e7c3",
      "event_cluster_id": "72ea99a1-516a-440d-9d00-28c65935de34"
    },
    {
      "claim_cluster_id": "e25eede3-3242-446d-a439-2c4becea51cf",
      "event_cluster_id": "5d6331d6-8b39-45dc-b069-c03168d82aac"
    },
    {
      "claim_cluster_id": "fc64cbea-821d-4f81-89aa-1c161d723583",
      "event_cluster_id": "00bb78a2-a394-4745-839f-91ae646e4371"
    },
    {
      "claim_cluster_id": "95ba204b-d839-49c0-9233-3f2add81da86",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "f02faf57-c72f-4377-8759-469d56737085",
      "event_cluster_id": "7e7ac228-2e81-4fa8-abfb-35fbbdf2b4b2"
    },
    {
      "claim_cluster_id": "bc630aac-e921-4ad6-990d-40d804192d55",
      "event_cluster_id": "ce112f29-472c-464b-84ff-3d5acaf22d38"
    },
    {
      "claim_cluster_id": "444e2d84-e3c4-4a82-a2fc-3577e6124f09",
      "event_cluster_id": "edcd5353-7d93-4a6e-9bfb-a26ec2ae09a3"
    },
    {
      "claim_cluster_id": "5e0fea08-89fc-42fe-8906-484d762a1714",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "8d06f8b9-e6ed-4b99-89ef-90434792b924",
      "event_cluster_id": "eb805fd1-c766-4517-8cad-81a53adf5b1e"
    },
    {
      "claim_cluster_id": "6a13b21b-08c5-4326-8613-c7913554f2c7",
      "event_cluster_id": "ca4d9210-71b4-4ac8-bc7c-f9b4e1772523"
    },
    {
      "claim_cluster_id": "e000263a-3f42-454e-8e66-ba1e28066da4",
      "event_cluster_id": "e0af4c3d-214d-424d-955e-14071d90129c"
    },
    {
      "claim_cluster_id": "7ccd886b-3755-4c15-8f38-f5ccef3c92ac",
      "event_cluster_id": "4c7b4cd7-8288-43da-a54d-f22b707dc22e"
    },
    {
      "claim_cluster_id": "62be0386-404f-434a-884b-4dc379430917",
      "event_cluster_id": "4a931ec3-ec4b-489a-8ad6-020f2eb48663"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "beb979e4-f486-4e3c-ba15-47b099971ff0",
      "event_cluster_id": "297764bc-d5fd-4054-ab93-cb0530d2df4e"
    },
    {
      "claim_cluster_id": "f10ad797-ad79-4629-861d-4af809502a09",
      "event_cluster_id": "c90c2a25-6af0-43d7-8ce5-c04e253daa5e"
    },
    {
      "claim_cluster_id": "4313d034-31f9-4eb9-9451-e9a5dda6e7c3",
      "event_cluster_id": "d9cfd982-76cb-4edd-8452-01187964f15b"
    },
    {
      "claim_cluster_id": "e44edb14-2754-4e0a-969f-2ab83f6f614c",
      "event_cluster_id": "694ef2f3-c0e0-41ec-bcd2-314b770e13f3"
    },
    {
      "claim_cluster_id": "42fd849e-0fa9-43a8-b5fa-5cc192351c79",
      "event_cluster_id": "917875db-927e-4ac1-93db-6f7a0fd24bc3"
    },
    {
      "claim_cluster_id": "ef78627f-ce46-445c-8434-674b16f6966e",
      "event_cluster_id": "bf418d10-64bf-4718-bddd-53c651aaa9eb"
    },
    {
      "claim_cluster_id": "1b8ba3f8-2b51-4433-9cf8-2a5412413277",
      "event_cluster_id": "f63e0793-99cd-4330-8985-abb2d981981a"
    },
    {
      "claim_cluster_id": "679ed917-ad46-4856-a427-b83dcc51a53c",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "62fbb5b2-0ba7-4211-b72a-eb1c18543408",
      "event_cluster_id": "912fe4ed-bb41-46a5-adbb-0dc779234edb"
    },
    {
      "claim_cluster_id": "d4d4c9f9-96b0-478b-85a5-92a5fa51e55c",
      "event_cluster_id": "6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"
    },
    {
      "claim_cluster_id": "565a8eff-d3c3-4887-a42a-b357e222a101",
      "event_cluster_id": "eaeb1421-7550-4957-9610-ed74a0bffc8e"
    },
    {
      "claim_cluster_id": "80a02b1a-c045-453f-ad92-9681e40dad83",
      "event_cluster_id": "2929fcf7-736c-4b1c-b178-3fc95f1bce0c"
    },
    {
      "claim_cluster_id": "3b355bb3-b565-4742-b6f4-50c6f509a1ec",
      "event_cluster_id": "25505b18-cd95-4150-9d26-ae16f59d9924"
    },
    {
      "claim_cluster_id": "e762d6c7-8067-4852-8232-49501526397d",
      "event_cluster_id": "f50f4ad4-412c-4470-94b2-718ecc122ebe"
    },
    {
      "claim_cluster_id": "72a6b38a-23a2-43db-a788-32ae774a5c77",
      "event_cluster_id": "335df50f-3c96-4c54-9d41-b51376489798"
    },
    {
      "claim_cluster_id": "151738b2-0d24-44aa-896c-fa16a74db380",
      "event_cluster_id": "d86ceeb7-05d4-46ab-afb5-94228b85b310"
    },
    {
      "claim_cluster_id": "fc1c32c1-8212-46dc-b3e4-29a2254a34ba",
      "event_cluster_id": "7201e91b-d78c-4827-b8ba-6360e45574c7"
    },
    {
      "claim_cluster_id": "84209a17-a4a4-4c15-a21f-0800fd75d6d8",
      "event_cluster_id": "84b99e8f-a7ed-4a77-92d2-b7e912bf0ca1"
    },
    {
      "claim_cluster_id": "1cffe038-9a46-45f7-bcc3-f26914315286",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "0aded89b-0a86-47dd-8291-b59848abe762",
      "event_cluster_id": "9f572501-f429-45f5-98fb-17c2e50fca11"
    },
    {
      "claim_cluster_id": "1c24dadf-70dd-4f00-84a1-ba00a5d442c5",
      "event_cluster_id": "8945e273-b3ad-4ff1-a46f-200b7adcf6a6"
    },
    {
      "claim_cluster_id": "f636e358-668e-41dd-bffc-037f53b4ab48",
      "event_cluster_id": "39ba0d7c-5f4e-43e3-b6a2-9f87693ee149"
    },
    {
      "claim_cluster_id": "dc9039b4-da9a-4fd0-b97d-d822536a716c",
      "event_cluster_id": "38a250d4-c72a-4095-9b75-66d5fbc4da25"
    },
    {
      "claim_cluster_id": "483b6a3b-d48b-40f7-b28f-e79dfca268e6",
      "event_cluster_id": "a3d3cf62-c1c3-483c-82f2-aeee46f578e5"
    },
    {
      "claim_cluster_id": "159421f9-fc35-4e25-a688-4ecf97e146b4",
      "event_cluster_id": "f06698fe-6625-4ba7-9978-7a2aa54fc4c9"
    },
    {
      "claim_cluster_id": "61922f77-a020-4916-b901-44fe7982b789",
      "event_cluster_id": "edc9ab41-cf63-48e3-8098-f84524398358"
    },
    {
      "claim_cluster_id": "2c7cf7ec-47d1-4b9e-8095-5a313fd3166e",
      "event_cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7"
    },
    {
      "claim_cluster_id": "3d5e8f72-7611-4d2c-a35c-668790f97298",
      "event_cluster_id": "9fa5ddc6-feca-4449-90da-8b78638fa3ce"
    },
    {
      "claim_cluster_id": "ac1a90d2-3517-43fd-8e60-dd7d570db743",
      "event_cluster_id": "db72597d-c5a9-4920-978e-26eb63ca559c"
    },
    {
      "claim_cluster_id": "1473286e-ca60-4128-b82b-a6695a32595a",
      "event_cluster_id": "3a6b381c-f068-44b8-863b-e7023960bcbf"
    },
    {
      "claim_cluster_id": "01680509-ab3c-4c56-a9a9-62fe3aeaacf8",
      "event_cluster_id": "b23a3a32-e361-4bd2-bb69-d01d98ed6b13"
    },
    {
      "claim_cluster_id": "d0c2dc4d-9503-4d98-a218-6e6968c3ac55",
      "event_cluster_id": "5d70f462-c3f9-4394-a045-eee646d218c8"
    },
    {
      "claim_cluster_id": "8346c5bc-af0f-44c1-b155-e89d63c46a37",
      "event_cluster_id": "ed2bff61-1872-4dec-a024-4d1c3d21cddc"
    },
    {
      "claim_cluster_id": "a99b1332-e477-4168-b8e5-832daa0d6068",
      "event_cluster_id": "86339977-5115-476b-96dd-1ca67842fea9"
    },
    {
      "claim_cluster_id": "aef50142-8ad0-4099-9362-3d45c56385fc",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "866c589b-e7dc-4cab-81ad-6d235278edf1",
      "event_cluster_id": "53168731-5f89-48eb-b975-ab6908193c3f"
    },
    {
      "claim_cluster_id": "7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607",
      "event_cluster_id": "e0e1af6a-37f3-439c-b966-bdff95698e49"
    },
    {
      "claim_cluster_id": "1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07",
      "event_cluster_id": "168ce58c-2c86-47ff-b749-0d60377b9053"
    },
    {
      "claim_cluster_id": "a15b9883-60ad-4e49-8943-56ed500ab8cf",
      "event_cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965"
    },
    {
      "claim_cluster_id": "ab7a8719-e742-49dc-b23d-904f2b97e9e2",
      "event_cluster_id": "a5f05825-1201-440d-8dd2-454ae9c16034"
    },
    {
      "claim_cluster_id": "376826e6-eaf6-4628-ab75-e400a091149e",
      "event_cluster_id": "89a3e6a9-addb-4b72-822c-a5a7371734c9"
    },
    {
      "claim_cluster_id": "d072d7ca-3280-4412-8e76-be63e36fe491",
      "event_cluster_id": "a68c5350-6903-408f-b32c-4015ed05945f"
    },
    {
      "claim_cluster_id": "bec9cb65-cf13-44b3-b77b-95d99bace1e4",
      "event_cluster_id": "a74e2cea-b4c4-4a7d-a1c4-162f2fa0ad2e"
    },
    {
      "claim_cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "event_cluster_id": "cbb25dea-baf7-49d5-b9bc-41ab2551292b"
    },
    {
      "claim_cluster_id": "34db5d7a-86ad-4cf4-abae-67c617853bac",
      "event_cluster_id": "2227c158-fdf5-47dd-921b-7c6ca1823ad0"
    },
    {
      "claim_cluster_id": "f18ec76a-50ba-422f-9d7a-596708b1810a",
      "event_cluster_id": "c65c30a8-6203-4ff2-8126-866ddc1ad7ee"
    },
    {
      "claim_cluster_id": "c830c75d-93e2-4842-b468-b89a47252719",
      "event_cluster_id": "814e8e7c-9951-4225-be99-2e978ab5ec4d"
    },
    {
      "claim_cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "event_cluster_id": "941c849f-959d-4e16-a04f-2de733d8f77c"
    },
    {
      "claim_cluster_id": "d47ee5b3-b3df-49e6-9a06-0dbb08c65765",
      "event_cluster_id": "a867149e-e951-4e73-80ca-91c6893b617b"
    },
    {
      "claim_cluster_id": "147befcf-c605-4967-82de-77dc8f9513dd",
      "event_cluster_id": "602ccd3f-b2b7-474a-9029-74260beb7902"
    },
    {
      "claim_cluster_id": "0e6f398e-1206-46db-a98b-ff1425e1c634",
      "event_cluster_id": "682564dd-6904-485d-a9d9-e5a6a5b41de7"
    },
    {
      "claim_cluster_id": "63fb8530-c54e-452a-b71d-729fca3c7e67",
      "event_cluster_id": "4b702552-6558-458e-b6a8-ec2e141d7258"
    },
    {
      "claim_cluster_id": "621b2187-e651-4a6f-becc-2a2a2cd444a2",
      "event_cluster_id": "58be16fc-1f91-4a69-b73f-64ff2035e54c"
    },
    {
      "claim_cluster_id": "749b3ec0-39f9-4e3b-bcf2-7f9377d72178",
      "event_cluster_id": "d8c7e702-0f0f-4bd0-b760-82584697ced7"
    },
    {
      "claim_cluster_id": "a21ce768-676a-4527-b1d1-ee80f9fdf2db",
      "event_cluster_id": "1f210f48-5853-4bb8-8fc2-d9a334fec30a"
    },
    {
      "claim_cluster_id": "5102f7b6-4554-4836-b695-c4ff3c598adf",
      "event_cluster_id": "9ff8b495-2fb3-4416-a1b0-68b8560f98e4"
    },
    {
      "claim_cluster_id": "404cf86d-d513-4c8d-adf3-7f2b9464b34e",
      "event_cluster_id": "f5f9e060-9a81-433b-b601-5ea2fb08b956"
    },
    {
      "claim_cluster_id": "ee877fbc-1f06-46ff-b006-7c974bc58cf1",
      "event_cluster_id": "a8e462eb-2839-4295-9ab7-03216f0e8610"
    },
    {
      "claim_cluster_id": "d7cbd37c-10fd-4628-bba8-b434c41ec43f",
      "event_cluster_id": "db9b2b11-8206-4448-bceb-8073d0878c9a"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "f9662a45-5f67-4be4-be6c-47e92690c44c"
    },
    {
      "claim_cluster_id": "469c5194-5b04-4e90-b62c-73b3f79a0955",
      "event_cluster_id": "28ec4a0f-45df-46a6-a92b-1e0740306f80"
    },
    {
      "claim_cluster_id": "88c2038a-24a0-497f-bac0-84ee519d160d",
      "event_cluster_id": "87ba8d5e-85d4-4d3c-8d48-82520a97a137"
    },
    {
      "claim_cluster_id": "aa973fc5-c596-49d2-86f1-80f2a9f419e9",
      "event_cluster_id": "4262a8eb-f5c3-4d49-bd20-1198efa845c5"
    },
    {
      "claim_cluster_id": "551e444f-6554-45dd-baba-6798fd43af6b",
      "event_cluster_id": "53102493-0297-43e7-a8fe-5dbe6ce36215"
    },
    {
      "claim_cluster_id": "69290a80-8807-401f-b38b-0ff5ba27a43d",
      "event_cluster_id": "ebb3d42c-9f56-4324-89bb-dcd764d2d3e5"
    },
    {
      "claim_cluster_id": "0ed53993-d675-4e0a-91d9-fca7f39d86fc",
      "event_cluster_id": "1351fc52-175d-4410-b8b2-ff88c7747912"
    },
    {
      "claim_cluster_id": "cce124fe-f108-4571-9074-db48a458127d",
      "event_cluster_id": "fb6903ba-fc01-4c20-9ef5-d3ed23d4b4f1"
    },
    {
      "claim_cluster_id": "0e6f398e-1206-46db-a98b-ff1425e1c634",
      "event_cluster_id": "3ebb1b75-d2e9-4210-933a-9f6e5583b377"
    },
    {
      "claim_cluster_id": "0e8e4003-b007-4df8-a1a5-948e64fe6342",
      "event_cluster_id": "4cf2f8c5-1a2b-498f-87b4-2397e881640d"
    },
    {
      "claim_cluster_id": "91ccf699-eaec-41a7-8213-08934dbe2395",
      "event_cluster_id": "fd129e43-f4b3-4fda-a189-8dcb11486ddb"
    },
    {
      "claim_cluster_id": "5ee6d6d6-e296-4f40-9760-4a7737f5c631",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "event_cluster_id": "a08d6d8c-3534-4503-908a-ad9b08709410"
    },
    {
      "claim_cluster_id": "4a4d472c-cd13-4ccf-9f30-e866d14bdbf8",
      "event_cluster_id": "8a1f2e01-5e97-4b63-a054-d879e5cc37f3"
    },
    {
      "claim_cluster_id": "dff8a985-ffc1-4946-ab7d-43e8406aca00",
      "event_cluster_id": "7caf5c56-5f70-4536-ab5a-2d4f84227951"
    },
    {
      "claim_cluster_id": "d14e115a-dd46-437f-8a57-5893395dde5f",
      "event_cluster_id": "1a910fe4-be3d-49ad-b59c-8197b841f3b0"
    },
    {
      "claim_cluster_id": "3232bd90-9251-47f0-ae93-ae2d51218354",
      "event_cluster_id": "03dc9e1b-5b04-46ff-b424-59158328eb35"
    },
    {
      "claim_cluster_id": "75d5bddd-c0b4-4755-8a27-ab90a5104373",
      "event_cluster_id": "b83cbf56-9c77-41ae-bf34-905116236046"
    },
    {
      "claim_cluster_id": "c8c946c0-f2a9-4ddc-bd30-57a913603310",
      "event_cluster_id": "f2b07e8d-84c5-4fbf-bf1e-736428e76d16"
    },
    {
      "claim_cluster_id": "6d2a1320-d829-403b-913c-d7cdbf1cbf14",
      "event_cluster_id": "96d3560e-8a14-4ba4-9eb9-c3d21f7bd78c"
    },
    {
      "claim_cluster_id": "bdc7e61b-1cd4-494f-b965-4387369e6df2",
      "event_cluster_id": "0ae555d0-f055-4458-a22e-cafea01bd69c"
    },
    {
      "claim_cluster_id": "55a85a41-dc09-4546-82c9-33ba7368eb9a",
      "event_cluster_id": "c2d811fd-2174-46c6-9d2b-9483063022fb"
    },
    {
      "claim_cluster_id": "eb6a12b4-268e-4e39-8d84-ba73d40a7ffd",
      "event_cluster_id": "51212bcd-93a4-4cdc-afe3-422f70697f65"
    },
    {
      "claim_cluster_id": "cb357706-7b58-4396-aa24-1c59beae87fa",
      "event_cluster_id": "91bba9c4-4aa2-47af-b118-a7d49761b237"
    },
    {
      "claim_cluster_id": "1c703565-77f6-4eda-962e-77ec869d886d",
      "event_cluster_id": "207aa08d-5028-49a1-8eaa-71f4b633ccfb"
    },
    {
      "claim_cluster_id": "98a5a190-c887-4ce2-b53f-011c39183ade",
      "event_cluster_id": "e47ab492-3177-49bc-9493-e444a1518298"
    },
    {
      "claim_cluster_id": "144fa955-73da-4f76-8472-31c3ddd2636d",
      "event_cluster_id": "528d38ac-7716-475a-b7f4-71caee3d9abf"
    },
    {
      "claim_cluster_id": "9d21be2e-9f01-48c9-b454-3a41788e2865",
      "event_cluster_id": "9fb4d80f-a91c-46b0-856b-b4507d71a702"
    },
    {
      "claim_cluster_id": "043b0606-561e-4868-8354-4c45ee5a2f95",
      "event_cluster_id": "fbf6086c-d11b-4ab9-9b6b-67f0d133c827"
    },
    {
      "claim_cluster_id": "a0977c56-cc0a-4fc9-a35d-0f1fe8c43b6d",
      "event_cluster_id": "163b9274-a266-4214-8b63-6426a20ca29b"
    },
    {
      "claim_cluster_id": "d6c74194-ae1f-4099-a13b-0f247e76b288",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "db13aa73-f539-42d8-89d9-1af57cfff5a3",
      "event_cluster_id": "a7b985be-e866-4775-b4be-7c7e64f9a12a"
    },
    {
      "claim_cluster_id": "53536317-4b6e-4e5f-bcd2-6b2bb3ef9bcb",
      "event_cluster_id": "c2058db3-dc0f-479a-84f0-9c62df9819d4"
    },
    {
      "claim_cluster_id": "3d5e8f72-7611-4d2c-a35c-668790f97298",
      "event_cluster_id": "44f0dccf-8fd1-49a7-88f2-e83b8d0cb422"
    },
    {
      "claim_cluster_id": "ac6c3346-ea92-4da2-afed-ba431832d85e",
      "event_cluster_id": "265185dd-7e1c-462b-bd12-3ea2079d23c8"
    },
    {
      "claim_cluster_id": "64599826-faee-4fcf-9432-967663d05451",
      "event_cluster_id": "01d21517-243e-4d94-b9c5-641f8bca7cbf"
    },
    {
      "claim_cluster_id": "eb38044c-3282-4492-916e-08a1ddd715ef",
      "event_cluster_id": "54050443-7613-4bf2-affb-d73ac2c76683"
    },
    {
      "claim_cluster_id": "910b6c18-44e1-4b51-b616-1f6016486c69",
      "event_cluster_id": "05edffd4-72ed-4cb5-ac3b-f631f2c3d46a"
    },
    {
      "claim_cluster_id": "650bbf0e-b896-4929-a2ae-2f9899d4868f",
      "event_cluster_id": "2913b0c9-ef79-4e98-9ca0-9e5e2abf9938"
    },
    {
      "claim_cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
      "event_cluster_id": "9e7a0088-26cb-464d-887d-c7e715addbcf"
    },
    {
      "claim_cluster_id": "dce54f5f-136c-474f-95c7-ae5b1e1ff60b",
      "event_cluster_id": "2f406046-b590-4796-97c3-ab6b4e6c2d6a"
    },
    {
      "claim_cluster_id": "55f659a1-e5dc-41c5-8a43-9846f564af08",
      "event_cluster_id": "f292e9e8-fecc-473b-b24c-ca3ad9cc0ef9"
    },
    {
      "claim_cluster_id": "1071979a-b25a-4432-8eb1-62e54bcd27e1",
      "event_cluster_id": "65657196-d0ff-4d4a-a7ff-868fd5f099d9"
    },
    {
      "claim_cluster_id": "c90c00dc-2c77-42ad-bb5e-2666e53e2bcd",
      "event_cluster_id": "77a67b7a-5038-4c86-adcc-8306f16e92e1"
    },
    {
      "claim_cluster_id": "767a107b-6141-45c6-9ffe-6f7fde1b3426",
      "event_cluster_id": "1fb4e8e5-4760-48f4-95b8-9dd118893a35"
    },
    {
      "claim_cluster_id": "ee9a474d-ce93-4992-ac4b-8d9da4087257",
      "event_cluster_id": "0f0292cd-5ed9-4b41-be37-f307be9f4e80"
    },
    {
      "claim_cluster_id": "58021478-0a50-495e-b059-4560ef7c90f4",
      "event_cluster_id": "e52fcc8f-16ac-4c0e-8ef2-f3d55d44895d"
    },
    {
      "claim_cluster_id": "719ee837-abdf-462d-a985-984d0a2eb167",
      "event_cluster_id": "939d6808-ee32-41c3-8d70-73aed1d043da"
    },
    {
      "claim_cluster_id": "3232bd90-9251-47f0-ae93-ae2d51218354",
      "event_cluster_id": "7d9d58bd-39b4-4188-a92b-2b9d72ec8bda"
    },
    {
      "claim_cluster_id": "2c49dd92-a97e-4b1e-bac2-607670a0a86d",
      "event_cluster_id": "4863edc0-3025-4ffa-ba81-0d1ed977b2b9"
    },
    {
      "claim_cluster_id": "72a7c01f-5ad0-4d37-b9bd-84c255cc3d32",
      "event_cluster_id": "b38c1227-31d6-4991-a4c5-01c6af14c400"
    },
    {
      "claim_cluster_id": "a2f5a4b1-ccba-4cac-9bde-f079d3027db4",
      "event_cluster_id": "317ecec9-87af-4e3c-acd4-372de58135a0"
    },
    {
      "claim_cluster_id": "1b8ba3f8-2b51-4433-9cf8-2a5412413277",
      "event_cluster_id": "5adabd10-79d1-4a41-a250-38ed66b71fff"
    },
    {
      "claim_cluster_id": "02e0cfd6-814a-4276-b8cf-66540b7686e7",
      "event_cluster_id": "f81e3872-fc8b-4fad-ac23-6ccf86d6cffe"
    },
    {
      "claim_cluster_id": "4b37762b-26f0-4956-9d1d-e433973602e1",
      "event_cluster_id": "aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"
    },
    {
      "claim_cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
      "event_cluster_id": "b50d2222-7f8b-46fd-aef1-62ca57b6cc71"
    },
    {
      "claim_cluster_id": "b874b38b-169d-4b90-b373-ae919f14c5a0",
      "event_cluster_id": "5a95085b-b1ae-4847-9e04-b0336ef06ae4"
    },
    {
      "claim_cluster_id": "51f9e6ae-7c8a-46e3-8fa3-070377ae9030",
      "event_cluster_id": "e09e9595-94ee-4647-99c5-988ef1e8bcb9"
    },
    {
      "claim_cluster_id": "40621ae5-171b-4ff7-a8cc-0957a4cc93da",
      "event_cluster_id": "f4d98260-09b2-436e-8c76-b8fdadb8663b"
    },
    {
      "claim_cluster_id": "9012b6f3-2c16-482a-b276-63925d342482",
      "event_cluster_id": "4c7b4c87-4848-4dfc-82f8-638a5803038a"
    },
    {
      "claim_cluster_id": "21b491b2-20db-42c2-af5c-70af377f068d",
      "event_cluster_id": "d878f267-808b-4a23-9202-10d08ee3053d"
    },
    {
      "claim_cluster_id": "7f94beb2-9a43-4280-9734-5045402a0714",
      "event_cluster_id": "87e5a1c0-9b91-4772-b701-2e6333826ce4"
    },
    {
      "claim_cluster_id": "807e0902-55ee-4c2b-a271-40fd2fb58b9a",
      "event_cluster_id": "b1dcb694-6efc-4b22-9bc7-9254eb290f7d"
    },
    {
      "claim_cluster_id": "901f6891-5f9b-4fa4-a368-69a4f20e9617",
      "event_cluster_id": "cb33e750-c57f-4e58-a355-2b249b902a62"
    },
    {
      "claim_cluster_id": "60269200-21dc-4ddd-bed2-414eb8acfbb9",
      "event_cluster_id": "8da8b4f2-f2e7-44b8-b5b6-7b0f66fba285"
    },
    {
      "claim_cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "event_cluster_id": "59fa4256-c06f-40de-a351-3b6ce5c20978"
    },
    {
      "claim_cluster_id": "25acea26-0f6c-421d-8050-ebc9dac75b8d",
      "event_cluster_id": "57d05796-d479-4bb6-8a2c-cdfddd5731a7"
    },
    {
      "claim_cluster_id": "b9ff3223-8bd6-4360-8edc-fa3409378e90",
      "event_cluster_id": "3fbd6864-531f-4366-93b1-3db5814687fb"
    },
    {
      "claim_cluster_id": "763dcb28-8161-4ef1-bcee-20cbd6af7670",
      "event_cluster_id": "f1749a30-d414-494e-8542-2f37dca2357f"
    },
    {
      "claim_cluster_id": "528a9885-82c7-4bee-beac-f85e4c7c3f1b",
      "event_cluster_id": "37a93514-6b4c-403e-9a3e-4ceb074df89f"
    },
    {
      "claim_cluster_id": "a5114ace-99b6-4b39-875b-8b7056c70002",
      "event_cluster_id": "db9f2811-0988-456d-94ba-acf8fa9e6c6e"
    },
    {
      "claim_cluster_id": "4f0130b7-d8c3-44c1-892f-fe74aef4cecc",
      "event_cluster_id": "fcd2863d-6523-42c5-86f2-9d70faca5e49"
    },
    {
      "claim_cluster_id": "fb6ff34e-94b0-4910-b613-9ebb9af0b6b6",
      "event_cluster_id": "1edce2b9-2c90-4e50-8469-6e4fab4fa23c"
    },
    {
      "claim_cluster_id": "281fca06-ede2-40bc-9960-0788b1d20c23",
      "event_cluster_id": "ff805a1d-a863-4cd5-ad33-a75bc8aa6ed0"
    },
    {
      "claim_cluster_id": "bac292de-05f4-4fd3-a4df-f073c8f09553",
      "event_cluster_id": "773f7bde-1fe5-44c5-9d2c-84b849939bc7"
    },
    {
      "claim_cluster_id": "7e265407-1dda-4e06-a69c-824b7e191f01",
      "event_cluster_id": "919dc1e1-6cb7-4d54-aa99-504278bbf1f4"
    },
    {
      "claim_cluster_id": "59bf3043-2eaa-48fb-880e-613249cbd976",
      "event_cluster_id": "f81472fd-0486-49fc-92fd-9753ce76f44b"
    },
    {
      "claim_cluster_id": "8f4c47af-fb0d-428c-b422-7767f77bc38d",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "0e2fe0e5-314e-4455-88c7-a13f3f6e7728",
      "event_cluster_id": "674e3f33-6edf-4940-a9ac-cec9bedff257"
    },
    {
      "claim_cluster_id": "f4c860ae-1c6c-4478-89c7-fac05f3999c6",
      "event_cluster_id": "27e1dbcf-9461-42c2-9fb6-7b948072caae"
    },
    {
      "claim_cluster_id": "2d5d8472-462a-48f6-89fe-e8182a74e9c6",
      "event_cluster_id": "1e2063e0-1979-4024-9493-206d34c55c1f"
    },
    {
      "claim_cluster_id": "87e60b81-7893-469a-8c14-40e3d6122aa1",
      "event_cluster_id": "7a9e1845-1b7e-4301-8581-ef30d33ccad9"
    },
    {
      "claim_cluster_id": "0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f",
      "event_cluster_id": "9acd0141-e648-4bf5-8aee-3bc494863f46"
    },
    {
      "claim_cluster_id": "b54d16d2-d5db-4746-b15a-e8c01d4fc586",
      "event_cluster_id": "7b2da9c5-ac6d-44df-b539-9a5ad8a18762"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "085a40bb-586e-4634-99d1-21c6d1eb5884"
    },
    {
      "claim_cluster_id": "efb75ced-ba33-4f51-8892-e54a26a45d00",
      "event_cluster_id": "0dd8b4fd-5bcd-4d2e-97ef-0ae1371a8f17"
    },
    {
      "claim_cluster_id": "d8704200-daac-4e95-873c-20cc39771b1c",
      "event_cluster_id": "47e32d49-9365-4f05-bb52-852578030b2f"
    },
    {
      "claim_cluster_id": "aa440a76-9b1c-4801-9031-cdac4add116a",
      "event_cluster_id": "cf64a707-174e-4193-859f-9f55dd41a4a6"
    },
    {
      "claim_cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "event_cluster_id": "ff2f92ab-182c-47dd-8807-28fea5da8eba"
    },
    {
      "claim_cluster_id": "3b1124a1-83ad-4acf-aefc-fa570a669706",
      "event_cluster_id": "a7c0d5f2-2d5e-4a9e-bdf4-5365c1f262be"
    },
    {
      "claim_cluster_id": "14a92521-0601-421b-b904-3fc9a965cbb6",
      "event_cluster_id": "d635b0fd-8741-49c9-a6f1-294159c206bd"
    },
    {
      "claim_cluster_id": "c8657dfd-ec8f-4884-9c32-c4d6cac2c0f4",
      "event_cluster_id": "6870e10f-72e4-4775-9bf6-5b40e5853931"
    },
    {
      "claim_cluster_id": "457d88a0-1b8d-406f-8eeb-01fdd00cdc30",
      "event_cluster_id": "f1447bab-26ff-4b83-b864-e0d728335c30"
    },
    {
      "claim_cluster_id": "a8aabd5b-4955-40cb-b78a-086cb1601de5",
      "event_cluster_id": "db5ce7c4-0a90-4c8e-b702-060aaa2cd9c6"
    },
    {
      "claim_cluster_id": "ee9a474d-ce93-4992-ac4b-8d9da4087257",
      "event_cluster_id": "f646af3d-32fa-49f1-bcbe-d5924a767680"
    },
    {
      "claim_cluster_id": "2b132e72-8cc9-4107-a55f-19ac99e2caf3",
      "event_cluster_id": "476dd033-427f-436a-8631-14fd97a75117"
    },
    {
      "claim_cluster_id": "f17dbb9a-8968-4ade-a774-02688b6da89a",
      "event_cluster_id": "f3475e22-43a4-45ea-ad6a-fe7e7accc82a"
    },
    {
      "claim_cluster_id": "23bbf046-846b-4885-b881-e84d2ca9060e",
      "event_cluster_id": "7e6ac8e9-cc11-4ef0-955b-65da48ed02cd"
    },
    {
      "claim_cluster_id": "0e2fe0e5-314e-4455-88c7-a13f3f6e7728",
      "event_cluster_id": "5c31493c-9070-471a-a409-144d7a3c341a"
    },
    {
      "claim_cluster_id": "5fb2043e-87e6-4ef1-829c-b51f962dada4",
      "event_cluster_id": "a1887544-121f-4fbc-b25f-d4561dfb5e4b"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "b4c10082-ec3a-4c01-a666-d497f9480003"
    },
    {
      "claim_cluster_id": "b27abfde-f9d9-4f52-9ce7-8c541388281c",
      "event_cluster_id": "158c7584-7298-4494-b705-f2d978c25206"
    },
    {
      "claim_cluster_id": "0450cb4c-8816-4bbd-85b6-ac94ecde9af4",
      "event_cluster_id": "d5f473e8-ffa8-45f6-bee7-fb81681c241a"
    },
    {
      "claim_cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "event_cluster_id": "c4df2ece-fef6-47b5-b7cc-a9846a2066d1"
    },
    {
      "claim_cluster_id": "b7190356-8b3c-4107-b9f7-680aa8b73b90",
      "event_cluster_id": "3df2dbeb-6250-425e-8956-8daf269e1976"
    },
    {
      "claim_cluster_id": "9315dcd9-b677-4d15-b61e-ab3ddd7205d6",
      "event_cluster_id": "3277c81f-d2ed-42ea-acc4-bb977e68f163"
    },
    {
      "claim_cluster_id": "b31e61b9-2010-4063-88bd-0eced0599429",
      "event_cluster_id": "d62a8641-ec0a-467e-8fc4-ccff76b670f1"
    },
    {
      "claim_cluster_id": "9d1065d7-3830-4746-a836-8da581c0bbb5",
      "event_cluster_id": "95a8e81f-4308-4c82-a9de-2d2f3b200b4c"
    },
    {
      "claim_cluster_id": "aa95c9e4-8d02-4bc6-90e1-de547f4e4e60",
      "event_cluster_id": "08ecb39e-a545-45c3-b7b6-8257d44a3e9f"
    },
    {
      "claim_cluster_id": "449f7a4c-3966-4db6-9cf4-d39a2f15feae",
      "event_cluster_id": "190c47c8-68da-42d3-b08d-822d259e964f"
    },
    {
      "claim_cluster_id": "c6e50b1a-e795-43fc-baca-c835ba2bf14d",
      "event_cluster_id": "1a9ef0f1-3f2d-4026-a13b-46206f55c61e"
    },
    {
      "claim_cluster_id": "20eecf26-3fb0-4e96-b07f-0dfffef9c628",
      "event_cluster_id": "46ec4fb5-6eba-4f8a-b3a0-e40c112dfda5"
    },
    {
      "claim_cluster_id": "af503db6-fcf4-45f9-9501-f2732e2af4f7",
      "event_cluster_id": "c2b35258-6b6b-4618-98dd-3efdfd8152a2"
    },
    {
      "claim_cluster_id": "ba694c90-be36-448b-9da2-f3ed0d816139",
      "event_cluster_id": "0af61c8d-a534-4af2-a2da-7ed4f4cc7aea"
    },
    {
      "claim_cluster_id": "13470ac2-b4c3-4aff-aa6a-418a5222958e",
      "event_cluster_id": "6869c5c6-393d-450f-8dcf-3be81ce4febe"
    },
    {
      "claim_cluster_id": "74664a64-2600-438a-b569-a9d45ae85e93",
      "event_cluster_id": "02f42105-05b5-4e5d-917a-7eefa123f670"
    },
    {
      "claim_cluster_id": "041ca325-747b-4d3c-b3c4-9ee7fabc37db",
      "event_cluster_id": "44bec0d6-7c8b-4869-801c-2ac35f38611d"
    },
    {
      "claim_cluster_id": "5f9b6057-0fab-4c3c-b1af-a7c26bc6c692",
      "event_cluster_id": "7e4cb312-8581-481c-819b-81c1e9125f8d"
    },
    {
      "claim_cluster_id": "fc9a7668-0501-4f68-9ebd-21d6b6146f62",
      "event_cluster_id": "4cf07546-b901-4002-a89e-1a6f0ae3d9e6"
    },
    {
      "claim_cluster_id": "42302660-b692-4e66-870b-37970eee6c13",
      "event_cluster_id": "01800770-341b-42d0-83d8-a7e215d97f98"
    },
    {
      "claim_cluster_id": "d9366872-6ca9-49e5-9e80-86c5b954d463",
      "event_cluster_id": "65f08a18-b069-4ad1-8cde-ea7ebd30b6db"
    },
    {
      "claim_cluster_id": "9f34aa0e-2eb3-43e3-b4dd-54a36752af72",
      "event_cluster_id": "ed814054-66d7-40f4-897b-99909fd4d531"
    },
    {
      "claim_cluster_id": "bdecd7b0-3449-4d8c-9710-468d872a6514",
      "event_cluster_id": "7effcde4-df93-42c6-842d-c99804764bd5"
    },
    {
      "claim_cluster_id": "c19d9ba5-5f1b-487d-8f8e-af1dd8c97af2",
      "event_cluster_id": "196c610d-29ed-4851-a66d-a936eab5709a"
    },
    {
      "claim_cluster_id": "f9f7a124-b259-44e6-a922-abc880fe6775",
      "event_cluster_id": "a0925808-7df0-46ec-bb06-9cb553f8b8fd"
    },
    {
      "claim_cluster_id": "e7a1e23f-832f-432a-ad19-207015a794b2",
      "event_cluster_id": "3cda3833-2d58-4e6e-a35b-5bec2cd74e4d"
    },
    {
      "claim_cluster_id": "a7614301-2ae0-4bb1-bcf4-8bc8d82acc70",
      "event_cluster_id": "5cb4afbf-e109-4c74-8315-a2a58d421c9c"
    },
    {
      "claim_cluster_id": "71185519-3f2f-4171-84a1-11f08a933f13",
      "event_cluster_id": "7a36ef35-086a-4724-b10d-2245bacdde6a"
    },
    {
      "claim_cluster_id": "fec0d44e-dff3-4478-9317-1b1d954f03c6",
      "event_cluster_id": "5da78bf8-d65b-4a01-8353-c40daa91e80b"
    },
    {
      "claim_cluster_id": "12ff0964-4c5c-4f91-8269-1e4ab61e9602",
      "event_cluster_id": "ecc05d01-ffac-434e-b1f4-f1a58038c91f"
    },
    {
      "claim_cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "event_cluster_id": "ea0b1b6a-993e-4153-b0a6-ac182d884071"
    },
    {
      "claim_cluster_id": "ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db",
      "event_cluster_id": "b224e5a5-61c4-447f-b912-3f4a296442f7"
    },
    {
      "claim_cluster_id": "f74715cf-7efc-4866-8a83-4aec1b75795e",
      "event_cluster_id": "80becc29-3509-4795-9714-7ee69f928767"
    },
    {
      "claim_cluster_id": "09a92b68-8f29-435d-b853-f4c47f64d9da",
      "event_cluster_id": "fc6510d9-839e-4451-a099-a28338b3f8c9"
    },
    {
      "claim_cluster_id": "774b6df5-ef29-47f3-9ae9-d88dbd184e38",
      "event_cluster_id": "4f8dc606-1036-443d-8754-a33caecd77d3"
    },
    {
      "claim_cluster_id": "08f93426-27fb-4a01-8b3a-b106b5f837ec",
      "event_cluster_id": "ca50545a-7854-48c2-bb9c-e0894d7bf854"
    },
    {
      "claim_cluster_id": "16667fe1-8cf7-4fec-9aa8-c5bb30920e90",
      "event_cluster_id": "2de014ab-746a-455c-a496-0833ca28f9b5"
    },
    {
      "claim_cluster_id": "b2635760-bcd6-46c7-88fb-9bbbb7349033",
      "event_cluster_id": "a14e07b9-7624-46b7-920a-7b615bb8f39d"
    },
    {
      "claim_cluster_id": "7659f671-e41e-464a-9184-a08b114b3636",
      "event_cluster_id": "9c4cbf68-9385-4898-9bf2-17346263f863"
    },
    {
      "claim_cluster_id": "696180e6-d43f-476a-afce-5f13dbb9929a",
      "event_cluster_id": "58588aa2-076a-4527-9fd4-663a7871c357"
    },
    {
      "claim_cluster_id": "f3b06c88-86f6-4833-89c1-f778a2910669",
      "event_cluster_id": "58d6742a-73cd-42e8-8a47-4ea3718af2a5"
    },
    {
      "claim_cluster_id": "8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4",
      "event_cluster_id": "522064a5-257c-47c1-b163-e454d1155f76"
    },
    {
      "claim_cluster_id": "6967755e-61e4-4308-be97-cdea95a155c7",
      "event_cluster_id": "89bf1ecc-4cb1-4aca-b3f3-c9c14a8868b7"
    },
    {
      "claim_cluster_id": "29880646-f50e-47bd-8b04-23f2c8716fdf",
      "event_cluster_id": "0c67a873-1e0f-4dd1-9e3b-40d63d120847"
    },
    {
      "claim_cluster_id": "f20df5bd-42ea-43d0-88bb-1d05f549a0e4",
      "event_cluster_id": "75a7abcd-ccae-4606-800a-89412da639cc"
    },
    {
      "claim_cluster_id": "75816fb8-77fb-4eee-a3ec-bbb68393ff86",
      "event_cluster_id": "136ce880-e6d8-4791-8b14-3c42846dc7f3"
    },
    {
      "claim_cluster_id": "5ece0141-8dd6-405b-93cf-5585050f4efe",
      "event_cluster_id": "d8e63a6c-9b16-4691-ad10-679a83e7a296"
    },
    {
      "claim_cluster_id": "c9335a55-7c59-42cb-98be-e69b4262faa0",
      "event_cluster_id": "83578f15-2ee2-4dd4-ae7f-b543ba5e2a87"
    },
    {
      "claim_cluster_id": "24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "97e04a01-6626-4196-a12d-eac1df348581",
      "event_cluster_id": "3360bff0-2a50-48df-84ce-ef5c8f91489d"
    },
    {
      "claim_cluster_id": "bc56200e-afec-40d7-a87d-167e90733913",
      "event_cluster_id": "3e73e60d-d610-4533-a186-9f4c4620025b"
    },
    {
      "claim_cluster_id": "a3c357ac-5159-4eec-ad16-09366a144d09",
      "event_cluster_id": "6a14502a-8c63-426b-8062-c7e8472786ee"
    },
    {
      "claim_cluster_id": "159421f9-fc35-4e25-a688-4ecf97e146b4",
      "event_cluster_id": "9f78a266-9f3f-46d5-948b-3b4d3da9a083"
    },
    {
      "claim_cluster_id": "91e94583-4b9d-4847-9825-9ed7293c7a0e",
      "event_cluster_id": "593dac82-590e-4efe-97bb-2666521b40b5"
    },
    {
      "claim_cluster_id": "1b5c8541-b848-4f05-865e-43826009d4e7",
      "event_cluster_id": "f39790da-a4f6-4366-98f5-449851f41e29"
    },
    {
      "claim_cluster_id": "e762d6c7-8067-4852-8232-49501526397d",
      "event_cluster_id": "30d2097c-43cf-415c-84fd-ec7c279c4c87"
    },
    {
      "claim_cluster_id": "86ef5628-f267-4ce6-97b4-2f06bd91a5fa",
      "event_cluster_id": "fc5ae33a-0165-41ca-a5df-b2b0a56f5100"
    },
    {
      "claim_cluster_id": "9d1065d7-3830-4746-a836-8da581c0bbb5",
      "event_cluster_id": "34782a59-6a9a-4289-8c00-12feb5c0f040"
    },
    {
      "claim_cluster_id": "18fe8f4b-896d-47b4-a019-0383dc22d38e",
      "event_cluster_id": "a1787db1-8710-47fc-b234-f265a8dd366e"
    },
    {
      "claim_cluster_id": "1b63ec5b-2010-4bd3-a351-328e7b4b5470",
      "event_cluster_id": "114c5c62-e2bf-4ad2-a913-3744fd25a373"
    },
    {
      "claim_cluster_id": "9028c8ac-b264-4318-be25-6d627ad54b1d",
      "event_cluster_id": "1fa41b69-dd08-4cf7-879f-ed94078d9d64"
    },
    {
      "claim_cluster_id": "2408ad82-3b39-4925-be26-13cd9f14bf98",
      "event_cluster_id": "f35fd313-149c-4568-ab38-fa2d1f029e32"
    },
    {
      "claim_cluster_id": "61ac97d3-e62e-41a3-b910-360985f7af21",
      "event_cluster_id": "b60886b0-36f1-4d60-bd61-b45768791dc2"
    },
    {
      "claim_cluster_id": "e871839f-962c-43cf-a2f7-5ebaf26de0a1",
      "event_cluster_id": "9ceeac8a-9421-42a3-9891-76c4ef2d8151"
    },
    {
      "claim_cluster_id": "3de3b456-a38d-41d1-85eb-8ea198492839",
      "event_cluster_id": "b5146023-e397-4082-afc2-a8c71c288767"
    },
    {
      "claim_cluster_id": "fb6ff34e-94b0-4910-b613-9ebb9af0b6b6",
      "event_cluster_id": "8d7a2b69-1f50-474a-969f-950408a29268"
    },
    {
      "claim_cluster_id": "634ebbc5-474d-42c0-bf34-498666dade49",
      "event_cluster_id": "af13a573-a204-482f-aa52-9623e30fedfc"
    },
    {
      "claim_cluster_id": "d089a914-1c7d-48b8-9c48-7a1b65f152b1",
      "event_cluster_id": "9f4c8f09-a6ba-4b36-a260-db32b470a2b5"
    },
    {
      "claim_cluster_id": "8308c2eb-92cf-4ca4-876b-d1d947564441",
      "event_cluster_id": "fbda0675-25d1-4968-aecf-16ed15e84db5"
    },
    {
      "claim_cluster_id": "a7614301-2ae0-4bb1-bcf4-8bc8d82acc70",
      "event_cluster_id": "47f7a131-6ce1-4e01-b64c-61e5f9696bb1"
    },
    {
      "claim_cluster_id": "2da1e2c0-6b7f-4a59-bbad-c83252a70f91",
      "event_cluster_id": "afff4757-e8dc-4943-90b2-48114c9bc6d7"
    },
    {
      "claim_cluster_id": "6f7b7d52-9a91-4f92-8a4e-4062c6360cda",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "4d2c8d1c-73d7-42b1-87cb-56c8ddf68982",
      "event_cluster_id": "e92ede91-314d-4f91-a23e-b6bfa200e224"
    },
    {
      "claim_cluster_id": "4af97b54-9617-48e3-8125-aa1e8e1ee8a2",
      "event_cluster_id": "57c8d119-9759-4d0a-a7cd-9c98d4429c3f"
    },
    {
      "claim_cluster_id": "1071979a-b25a-4432-8eb1-62e54bcd27e1",
      "event_cluster_id": "1b374305-b708-454f-b63c-7ff8ae988cdd"
    },
    {
      "claim_cluster_id": "2870dcce-8def-47de-9196-c66889a0a474",
      "event_cluster_id": "3e760dc6-7f77-441d-bf0b-d687031ab57a"
    },
    {
      "claim_cluster_id": "a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20",
      "event_cluster_id": "18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"
    },
    {
      "claim_cluster_id": "d2830923-6260-4e70-9fc4-f723af340d1f",
      "event_cluster_id": "afb80000-29ea-4260-b454-0363d71c9855"
    },
    {
      "claim_cluster_id": "b763139e-3c42-4a2e-8afc-f2941722221f",
      "event_cluster_id": "2d644f06-03ca-439d-b2dc-c42a08782eba"
    },
    {
      "claim_cluster_id": "86160f22-53c1-4e04-a28d-86c0e883fa44",
      "event_cluster_id": "db5c7092-c228-4319-b130-e75471c29ec0"
    },
    {
      "claim_cluster_id": "989e42eb-c62e-4e68-87e6-6b230317d087",
      "event_cluster_id": "bb3ba302-b163-46a5-9a24-14ade245b1de"
    },
    {
      "claim_cluster_id": "4313d034-31f9-4eb9-9451-e9a5dda6e7c3",
      "event_cluster_id": "30d8206d-7f35-4cfd-86b9-4ac411d8d754"
    },
    {
      "claim_cluster_id": "bd4c7f11-9866-4656-98e3-7341cfc6de34",
      "event_cluster_id": "712f6134-d72c-4f1f-bf01-f9fa23374d32"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "ea54647f-e4a4-46e7-bf16-66e30583a4a6",
      "event_cluster_id": "dc5ed306-20f0-45cc-ac9b-9241d0460c7d"
    },
    {
      "claim_cluster_id": "f74715cf-7efc-4866-8a83-4aec1b75795e",
      "event_cluster_id": "5674d01b-2996-4ed7-850d-de449d707ce5"
    },
    {
      "claim_cluster_id": "0f047203-3949-4e82-86d9-77d6fe7af9c8",
      "event_cluster_id": "3e4bfcca-aa45-4a97-8306-e90101b4ccc0"
    },
    {
      "claim_cluster_id": "d26e1561-d7b5-4c15-bc29-d5ba417f64ca",
      "event_cluster_id": "b87bc991-27b5-4e76-ab33-22c0374b82e2"
    },
    {
      "claim_cluster_id": "cbafab62-ed48-49fc-9623-dbadef5cfd91",
      "event_cluster_id": "af4322da-0cf9-4a56-9b07-d10c70b336a9"
    },
    {
      "claim_cluster_id": "bdecd7b0-3449-4d8c-9710-468d872a6514",
      "event_cluster_id": "3a3218a4-ce54-4e61-9c08-41f52d8bf517"
    },
    {
      "claim_cluster_id": "8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4",
      "event_cluster_id": "f23bc705-fad4-4454-82b7-d780cad17182"
    },
    {
      "claim_cluster_id": "12667ac4-7c0c-4916-8553-cead6974cc24",
      "event_cluster_id": "43d693d1-43e9-41bf-9f49-b7662edb6922"
    },
    {
      "claim_cluster_id": "6606b076-6fdd-4a94-a7c5-b6bfc5191980",
      "event_cluster_id": "84a7917f-8218-438c-a1b9-0e45b12c8e34"
    },
    {
      "claim_cluster_id": "20e0f6a7-71df-44b4-b99e-3e278ca655e8",
      "event_cluster_id": "14c3f0e3-2371-447c-8445-1ac6c299f633"
    },
    {
      "claim_cluster_id": "f68dc41c-3947-416c-8f93-49c606c24bd2",
      "event_cluster_id": "249e8c50-f68d-47af-99c9-2bc6ddfd52ad"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "fd554d0c-cd25-4da2-adf1-dcccfd01f292",
      "event_cluster_id": "418af057-88c5-4485-917f-178851436407"
    },
    {
      "claim_cluster_id": "6a4b35a4-0785-4292-8587-aee85db61288",
      "event_cluster_id": "fc3da38c-59ab-4dde-836c-c912a95b1802"
    },
    {
      "claim_cluster_id": "6cfce6ce-fb64-4bfa-a23f-01cbee46c275",
      "event_cluster_id": "757b69bc-6342-44ee-8a8e-c35de9054b6d"
    },
    {
      "claim_cluster_id": "bdc7e61b-1cd4-494f-b965-4387369e6df2",
      "event_cluster_id": "09e091a4-d9df-4ce0-ab1e-d30b85568ee5"
    },
    {
      "claim_cluster_id": "47085082-7091-436e-a3ee-ecf14c90e1a5",
      "event_cluster_id": "6b6a1ba0-8a8c-4bf1-9799-4a4ce9b1d916"
    },
    {
      "claim_cluster_id": "7db64556-43b7-4e29-b1a9-e8fcd5d29233",
      "event_cluster_id": "ba793871-eeec-487b-a1b0-5996d1bd03cf"
    },
    {
      "claim_cluster_id": "25acea26-0f6c-421d-8050-ebc9dac75b8d",
      "event_cluster_id": "6d563374-a7de-4d4e-bf0b-d89a34f47ac7"
    },
    {
      "claim_cluster_id": "cf096384-5ede-4929-b992-9e6ee20d6a8b",
      "event_cluster_id": "0c283d46-2055-4ab8-8bbf-4417f6667e86"
    },
    {
      "claim_cluster_id": "d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3",
      "event_cluster_id": "9979222f-6af5-4d8c-85d9-81f2ad80980a"
    },
    {
      "claim_cluster_id": "8b44daa7-629e-4db8-81b7-5ed88669eb86",
      "event_cluster_id": "8bdd7aea-e82e-44ed-9306-49ba0cde454c"
    },
    {
      "claim_cluster_id": "692c12d0-dff2-4fe9-a351-80422ee99320",
      "event_cluster_id": "9830a54f-6df4-4c84-a14f-819c289e70e5"
    },
    {
      "claim_cluster_id": "4fe899cb-f73e-4ec7-b569-5ce5b990df8e",
      "event_cluster_id": "823656a1-093a-4e85-b706-f48d18e40c29"
    },
    {
      "claim_cluster_id": "4df0c9e7-49c0-478b-aeb5-0b3833932e62",
      "event_cluster_id": "3c2e5bbb-18fd-4888-959d-c7aef1790267"
    },
    {
      "claim_cluster_id": "692c12d0-dff2-4fe9-a351-80422ee99320",
      "event_cluster_id": "11d8d71a-168c-43ed-b532-83903fcd58a8"
    },
    {
      "claim_cluster_id": "78064e33-a38e-4112-b3b2-c02951368282",
      "event_cluster_id": "af86b76d-a390-4847-bb43-41459c4a0513"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "e2ffc2de-64b8-4d49-9767-c601c711ffbd"
    },
    {
      "claim_cluster_id": "99955509-35d5-4623-b165-0b6dc4f83f23",
      "event_cluster_id": "12b1cdcd-4e31-4b05-ae44-98d5b446ed03"
    },
    {
      "claim_cluster_id": "38eef897-6e59-4836-bf0e-1e7e106baf53",
      "event_cluster_id": "8e29592d-1755-4868-982e-348b60636ba1"
    },
    {
      "claim_cluster_id": "1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07",
      "event_cluster_id": "3c292204-fc50-446f-99ed-6fd49056a887"
    },
    {
      "claim_cluster_id": "63fb8530-c54e-452a-b71d-729fca3c7e67",
      "event_cluster_id": "acde1f80-8000-4b4d-8e9d-7d24f15b41d9"
    },
    {
      "claim_cluster_id": "5fd07840-c42a-480f-ac7f-9ffe7168dd63",
      "event_cluster_id": "7eb16fe5-1729-42a0-bcb4-1a4783656ce6"
    },
    {
      "claim_cluster_id": "2fe163fe-8ed3-4202-aad1-5f84672917c4",
      "event_cluster_id": "3be61476-a382-4c84-9990-67e69bae81f5"
    },
    {
      "claim_cluster_id": "3da4f222-08f1-4864-8aa3-3576d8a64207",
      "event_cluster_id": "3124bf40-7b7a-44d7-a83e-a1fe41e14ec6"
    },
    {
      "claim_cluster_id": "7781df4b-26ca-4879-a33c-cb83ade5ffa4",
      "event_cluster_id": "700f9b04-7504-490a-bc2b-7cf163528607"
    },
    {
      "claim_cluster_id": "7e639892-5cda-4557-94c4-87321bdc3233",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "536df2e4-b955-48b2-8a3c-5b06a58c9d87",
      "event_cluster_id": "5540f6ac-c1b9-4d28-95e7-760d9496128d"
    },
    {
      "claim_cluster_id": "939cc578-da0d-4d69-94b9-0a186537275d",
      "event_cluster_id": "a01dee28-83a3-45b0-ab2b-6e6c04b1fe22"
    },
    {
      "claim_cluster_id": "4b037322-86a6-4af9-bfe1-49f968f04baf",
      "event_cluster_id": "71ff5874-dbd0-431c-b097-90e57ae45748"
    },
    {
      "claim_cluster_id": "3af9eb7e-1c8f-4ca9-987f-f38db6d11751",
      "event_cluster_id": "632ff2a8-1423-4189-882c-4d3e14dadc3f"
    },
    {
      "claim_cluster_id": "16b63ffa-da4e-4cff-8fab-fffc1644a634",
      "event_cluster_id": "bea2fa8c-8f73-40e8-949c-4bf3e53cc1a7"
    },
    {
      "claim_cluster_id": "e9d22d46-e0d1-45b7-b109-afc6516146e1",
      "event_cluster_id": "85b2637f-fff4-4688-a95a-adb041e440fa"
    },
    {
      "claim_cluster_id": "3200fc3a-bd08-4faf-ac3c-69eb812ef575",
      "event_cluster_id": "7a13b273-8feb-4f23-b79f-e5f89124c43d"
    },
    {
      "claim_cluster_id": "06f63413-3561-4a53-933b-589b1f942c37",
      "event_cluster_id": "783f72c7-55f3-4eb7-a87e-43b3ec9f631e"
    },
    {
      "claim_cluster_id": "1b178ff0-cd2a-415f-bd8a-4daf71e452c3",
      "event_cluster_id": "1997b709-7204-4376-b1e8-77d6b8518a0f"
    },
    {
      "claim_cluster_id": "2568c212-fcce-44e5-930c-3fe63b8f0d65",
      "event_cluster_id": "d14dd6b6-ea0d-4827-8ef2-ba250811ea5a"
    },
    {
      "claim_cluster_id": "beb979e4-f486-4e3c-ba15-47b099971ff0",
      "event_cluster_id": "22388e5b-3cdc-4eb4-8e97-052ccfe18cfd"
    },
    {
      "claim_cluster_id": "708c11e2-cd61-4685-8e6a-35d93d6b988e",
      "event_cluster_id": "81b74ec1-1e27-4ec6-a6ad-9c28cfcd7074"
    },
    {
      "claim_cluster_id": "e9c91d2d-9c77-43dc-9ccc-c00049984a01",
      "event_cluster_id": "3bda9d5f-2f9e-4086-90e5-207bbda0f725"
    },
    {
      "claim_cluster_id": "049db6be-2ccc-4afd-97c6-e95cb1b50286",
      "event_cluster_id": "32c73de2-95e1-45f0-9627-537de9f0f318"
    },
    {
      "claim_cluster_id": "a3a8e335-b1fe-4cbe-b6f9-626c39d5f0dd",
      "event_cluster_id": "8b24e853-731b-4d1e-ab4f-4eadd5f933df"
    },
    {
      "claim_cluster_id": "9c5c6743-3894-4e82-b69e-bc4e0c19f869",
      "event_cluster_id": "009689fa-763a-4351-a069-4f29c46a8fcf"
    },
    {
      "claim_cluster_id": "3e9990d1-ada6-4c9b-b2b3-e8220e956431",
      "event_cluster_id": "0751c6cb-9d71-46b3-91e2-7b78341d2ce3"
    },
    {
      "claim_cluster_id": "5900a7ab-7cb4-45d4-8807-d20dee337670",
      "event_cluster_id": "9c1a6fcf-db77-4bad-b035-88b7787ab104"
    },
    {
      "claim_cluster_id": "72a7c01f-5ad0-4d37-b9bd-84c255cc3d32",
      "event_cluster_id": "5549ed3d-7dea-4eb0-ad38-1dd76c667c0c"
    },
    {
      "claim_cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "event_cluster_id": "7a5b8ce2-31ac-42cd-bb98-cbeddcf8542a"
    },
    {
      "claim_cluster_id": "d3ef62d6-a9f2-4e02-8cb8-beabc3ead80a",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "2616e42a-b0ac-42ff-93a5-2376cee42b92",
      "event_cluster_id": "8e082e26-8f01-4448-85f9-dcbb694f327e"
    },
    {
      "claim_cluster_id": "0fc06cfb-3a25-4176-a530-ab9cb52f7632",
      "event_cluster_id": "74873448-e290-4f3b-a22d-809e34d02a4e"
    },
    {
      "claim_cluster_id": "24d81b39-c399-4c59-ae9b-c84548655d0b",
      "event_cluster_id": "791e282d-3184-48f1-b9b4-d9976176f1c4"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "16f44bbb-61c5-4b72-873e-79ca1d65deb9"
    },
    {
      "claim_cluster_id": "e762d6c7-8067-4852-8232-49501526397d",
      "event_cluster_id": "b68b2c64-2b71-44ac-a7b3-c79fe12186bd"
    },
    {
      "claim_cluster_id": "5443e2c0-e92d-4c21-ba1b-b0cdb2302769",
      "event_cluster_id": "fb8a3738-fc86-4011-aef4-faadf91c1772"
    },
    {
      "claim_cluster_id": "f3735996-484c-447a-8fe4-4cd5c645a0a9",
      "event_cluster_id": "c5a76746-76c2-4937-b9a7-284d0de20709"
    },
    {
      "claim_cluster_id": "ea316b29-c411-49a8-8ebd-8e50456fc746",
      "event_cluster_id": "54513007-2bf5-4c3c-8060-c65d26b45075"
    },
    {
      "claim_cluster_id": "f18ec76a-50ba-422f-9d7a-596708b1810a",
      "event_cluster_id": "61d73230-504f-4e81-a2e0-6fec552c5517"
    },
    {
      "claim_cluster_id": "a7a78172-b61a-41cd-a089-5fdf5b5e9fdc",
      "event_cluster_id": "6b780a23-d1ce-4c39-8626-c4071a335cc8"
    },
    {
      "claim_cluster_id": "23adc402-b3b7-489f-bbe8-5d7825946d77",
      "event_cluster_id": "460920ff-c88f-43ab-b704-4a3029ef5976"
    },
    {
      "claim_cluster_id": "266128fe-9d68-4687-b95c-b0654a1c7f0e",
      "event_cluster_id": "e2b1886a-d41d-4169-be53-e4ed1b6d9d79"
    },
    {
      "claim_cluster_id": "170448e1-fefc-424b-b5a4-23941f88389e",
      "event_cluster_id": "f29c8da8-dc4f-4133-97b2-dbe8a7c642b2"
    },
    {
      "claim_cluster_id": "843e2174-20bd-4386-beb4-ad4f8d0ba790",
      "event_cluster_id": "dc2b6524-3e37-4978-9dbf-854499aadeb0"
    },
    {
      "claim_cluster_id": "a990d90c-b1b0-4148-b047-5b63c9eb7a78",
      "event_cluster_id": "867076a2-38a3-4bba-9e8e-00167fbd33c9"
    },
    {
      "claim_cluster_id": "1363d4a2-5ea7-481a-b7e3-3e161a6db765",
      "event_cluster_id": "db8f619e-f112-4abd-9c92-e8cda93ee5d3"
    },
    {
      "claim_cluster_id": "18eba947-bd55-4242-95f2-7927edd7f432",
      "event_cluster_id": "91e8fe58-f0fa-44e3-ae52-de74821a1034"
    },
    {
      "claim_cluster_id": "78064e33-a38e-4112-b3b2-c02951368282",
      "event_cluster_id": "2de4265b-f662-429b-82af-a99a27de61cd"
    },
    {
      "claim_cluster_id": "4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8",
      "event_cluster_id": "701cfb5e-4d20-40b0-b06a-cb6fe171068d"
    },
    {
      "claim_cluster_id": "07bacc2e-cf13-4467-917c-ef3c2aa505ca",
      "event_cluster_id": "ffe496a8-ba5b-46e3-94f5-ab61bd09d41a"
    },
    {
      "claim_cluster_id": "997de204-d7ea-4e15-b208-ebc2bd4ddd62",
      "event_cluster_id": "b53434f6-8475-4084-8547-bceb679687ac"
    },
    {
      "claim_cluster_id": "95a560d1-c8b1-4378-a024-d78252f97af6",
      "event_cluster_id": "a55753e6-8f8f-48dc-b731-3ea6f869cd52"
    },
    {
      "claim_cluster_id": "840ac263-91de-449d-b701-c05a4522f3b3",
      "event_cluster_id": "73b5bb5e-19ff-4738-bc4e-5908ad8a0474"
    },
    {
      "claim_cluster_id": "b877e703-7bf9-4587-919b-bf207b22c607",
      "event_cluster_id": "44ed705c-5a34-48f9-ae3d-7f96124493a0"
    },
    {
      "claim_cluster_id": "7e9a80fa-c7f8-4eeb-8f62-09cee3732838",
      "event_cluster_id": "f62a9075-e876-4cd7-80b4-8e9a12641d53"
    },
    {
      "claim_cluster_id": "3198b672-2780-47ef-8885-73e8c5597d80",
      "event_cluster_id": "2cbbdb0c-fd37-40a4-97e3-351c65d658dc"
    },
    {
      "claim_cluster_id": "f51dc065-8987-4a56-b2b7-f53334ad4ee2",
      "event_cluster_id": "fb8d8d1e-9afb-496a-b65d-ca304c598e8b"
    },
    {
      "claim_cluster_id": "ff7a6df5-d64b-4e14-803a-5339b1cffda2",
      "event_cluster_id": "827e3030-1738-4370-a530-42878dd6927d"
    },
    {
      "claim_cluster_id": "83856113-7cf1-435d-bc2c-d1c5e5e5c106",
      "event_cluster_id": "d7af883b-7f94-40af-b74c-503163e2b062"
    },
    {
      "claim_cluster_id": "fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec",
      "event_cluster_id": "5c321eda-59e0-4788-8faa-0808e6c83192"
    },
    {
      "claim_cluster_id": "66a36ac1-c9eb-46aa-9ae1-0d7306ddb692",
      "event_cluster_id": "65cdef1a-e035-4605-9081-f663d9551b62"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "0f047203-3949-4e82-86d9-77d6fe7af9c8",
      "event_cluster_id": "371e032d-d57e-40c0-84fe-6f5fa1665409"
    },
    {
      "claim_cluster_id": "56dc9727-1db9-4dc8-acf2-c70b7f101883",
      "event_cluster_id": "2d62bce3-b515-4666-bea6-d3d1e123e654"
    },
    {
      "claim_cluster_id": "2da1e2c0-6b7f-4a59-bbad-c83252a70f91",
      "event_cluster_id": "436ce4a6-0697-4461-9b3c-0feb3eafc498"
    },
    {
      "claim_cluster_id": "c9f87e7e-e0a4-4be1-aaa4-54f6d3bedaaf",
      "event_cluster_id": "637f444f-2be2-49e6-9376-4e66fc8b211b"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "9e044845-6768-4b18-b4e5-13d72ace241e"
    },
    {
      "claim_cluster_id": "d4352376-c595-4d9d-928a-8fabbed1e18b",
      "event_cluster_id": "89fd947c-c029-4635-8b9d-ca8e953af1ce"
    },
    {
      "claim_cluster_id": "e7e80c41-a749-4b0c-a666-715bedd44f52",
      "event_cluster_id": "f8ba093e-142e-45ae-b5d0-aef007993c05"
    },
    {
      "claim_cluster_id": "54017113-d014-48fd-b57d-6cf55f5a8ff8",
      "event_cluster_id": "317ecec9-87af-4e3c-acd4-372de58135a0"
    },
    {
      "claim_cluster_id": "aae7438c-bb2b-4e87-86b8-fc77cf6148d1",
      "event_cluster_id": "49909022-fed5-4a4d-89a8-bdf0a26dd966"
    },
    {
      "claim_cluster_id": "a841656a-f68d-41d2-ac94-3537d3133ce8",
      "event_cluster_id": "31b521fb-d677-46b2-8db7-b2e8a8fafe49"
    },
    {
      "claim_cluster_id": "997de204-d7ea-4e15-b208-ebc2bd4ddd62",
      "event_cluster_id": "3e954c39-38a1-4449-bb6c-9e8070f71e04"
    },
    {
      "claim_cluster_id": "12dfa7c9-8817-4f21-ad00-1e4244142b34",
      "event_cluster_id": "ff8eb50d-ed26-4f4e-b34d-1dd10e2cdbe4"
    },
    {
      "claim_cluster_id": "a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f",
      "event_cluster_id": "2e675266-c3ed-4fac-a036-217c24ac28e2"
    },
    {
      "claim_cluster_id": "7e639892-5cda-4557-94c4-87321bdc3233",
      "event_cluster_id": "158823d9-8d73-406f-963c-db32a179210b"
    },
    {
      "claim_cluster_id": "bfd9a248-bf68-4994-8af5-882efd424687",
      "event_cluster_id": "00f3a914-1589-47ae-9fd7-4b841e19dce5"
    },
    {
      "claim_cluster_id": "a604694d-4fcd-48e0-a074-6eaa09488a89",
      "event_cluster_id": "4ca4751a-06c9-42b9-935e-8c293fd1cd2e"
    },
    {
      "claim_cluster_id": "6d600ff4-5ee2-443b-9049-7fb530fb454c",
      "event_cluster_id": "e49682e3-c065-43da-be61-a86567e3397f"
    },
    {
      "claim_cluster_id": "f6b0f0ef-f78c-4282-952a-d2ce7128854f",
      "event_cluster_id": "71ddb5ae-a33f-4bf8-97d1-9321d27ed4a2"
    },
    {
      "claim_cluster_id": "cd55cb26-f122-4354-aeec-7ffaa02af90a",
      "event_cluster_id": "39225686-c932-4b86-8609-bcb573981830"
    },
    {
      "claim_cluster_id": "442dded8-bef6-49b2-b7d4-70454c6e8e79",
      "event_cluster_id": "e078499d-145e-47da-8902-0b8d9b181179"
    },
    {
      "claim_cluster_id": "4a817862-6fa5-4e7c-8998-977aaad70250",
      "event_cluster_id": "8fea2c95-9eb5-4a00-9f7e-750ec49f4c61"
    },
    {
      "claim_cluster_id": "5904fe8c-6989-4981-93c1-c6202b0b4d88",
      "event_cluster_id": "be74618d-f629-43fe-be50-6fcf737dd820"
    },
    {
      "claim_cluster_id": "d489ee78-15f6-46b4-8adc-818181d95968",
      "event_cluster_id": "667cedb1-d001-4a4c-af7f-98106fe11ae7"
    },
    {
      "claim_cluster_id": "23adc402-b3b7-489f-bbe8-5d7825946d77",
      "event_cluster_id": "b6748e1b-bb47-47df-a0a7-16d2d7f95e46"
    },
    {
      "claim_cluster_id": "708c11e2-cd61-4685-8e6a-35d93d6b988e",
      "event_cluster_id": "282bf62f-9c0e-4150-9c45-5edc6ab7a29f"
    },
    {
      "claim_cluster_id": "93429ef7-e07c-4686-85f7-679d49d1274f",
      "event_cluster_id": "64c35a09-3986-4a44-8a95-5828f2dd463c"
    },
    {
      "claim_cluster_id": "1b5c8541-b848-4f05-865e-43826009d4e7",
      "event_cluster_id": "4dd085e4-7892-4955-a5ce-d8e90d7e23d4"
    },
    {
      "claim_cluster_id": "aa440a76-9b1c-4801-9031-cdac4add116a",
      "event_cluster_id": "d69ec96e-95a8-4ada-b02b-404a801edc90"
    },
    {
      "claim_cluster_id": "dff8a985-ffc1-4946-ab7d-43e8406aca00",
      "event_cluster_id": "dcae0b06-ee3c-4003-865d-7cc0ed9affe3"
    },
    {
      "claim_cluster_id": "f7c875b0-a0b4-45f6-b382-0915f179b2e6",
      "event_cluster_id": "eee5559c-ba4e-40fd-8448-3d09c753f9ba"
    },
    {
      "claim_cluster_id": "758d6034-7d93-4286-ae2b-f2ffde861da6",
      "event_cluster_id": "814e8e7c-9951-4225-be99-2e978ab5ec4d"
    },
    {
      "claim_cluster_id": "dad0da03-60db-4f17-9025-e5a1ac65e552",
      "event_cluster_id": "e9f22744-079e-483e-97a4-7cefb12988e9"
    },
    {
      "claim_cluster_id": "616e962d-58a9-42e5-9a6d-decd8139ddf7",
      "event_cluster_id": "befb7ee5-b118-46a8-baef-495aee63c618"
    },
    {
      "claim_cluster_id": "9be5c43d-4ef1-465d-bdbc-ed35d95c0689",
      "event_cluster_id": "d6ce2176-c8b1-49b2-89e4-f0620f06cb63"
    },
    {
      "claim_cluster_id": "40621ae5-171b-4ff7-a8cc-0957a4cc93da",
      "event_cluster_id": "719750be-a238-45aa-96a8-065dfd797981"
    },
    {
      "claim_cluster_id": "317ae87f-a4ca-4e46-9ff8-1bebad9fd04f",
      "event_cluster_id": "0e2a258a-cc1c-4d20-82ea-f1ebf02f74b2"
    },
    {
      "claim_cluster_id": "c6d2f5c4-bb51-435b-a664-174b47ed38ef",
      "event_cluster_id": "60bcdb7a-b11c-4760-96c7-2e903b89bd2e"
    },
    {
      "claim_cluster_id": "7e112a5c-41d4-4f1c-b974-99256b5d357b",
      "event_cluster_id": "c786e602-255f-4df8-a9fc-775fc1322fa2"
    },
    {
      "claim_cluster_id": "04938aaa-1985-4664-bfb5-337fffd62a6d",
      "event_cluster_id": "abd6036d-49e1-4e1d-8db5-cfdac174787d"
    },
    {
      "claim_cluster_id": "594e0474-2d9d-4582-8963-9fe946d49a1e",
      "event_cluster_id": "65f7972e-2194-4ad4-97f0-1ccb32281e02"
    },
    {
      "claim_cluster_id": "83176725-df79-43f8-b571-b45c6b2dea8f",
      "event_cluster_id": "44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"
    },
    {
      "claim_cluster_id": "98a5a190-c887-4ce2-b53f-011c39183ade",
      "event_cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63"
    },
    {
      "claim_cluster_id": "f10ad797-ad79-4629-861d-4af809502a09",
      "event_cluster_id": "9fe09fbd-ca4a-419e-94ee-6e49f8b62304"
    },
    {
      "claim_cluster_id": "d6705dc8-8def-4060-882a-9c13b62a23ad",
      "event_cluster_id": "eaf97e4a-55db-4cdb-ae4f-9ab8ecb7e821"
    },
    {
      "claim_cluster_id": "8e347521-7b79-4b75-abb3-86278fb2761f",
      "event_cluster_id": "94238db0-c74d-46ae-8d32-ad4eebd6753f"
    },
    {
      "claim_cluster_id": "0de86638-0241-412b-ab2a-b233d85153a4",
      "event_cluster_id": "b799c029-2c45-4feb-9700-47996ca8a80f"
    },
    {
      "claim_cluster_id": "b7190356-8b3c-4107-b9f7-680aa8b73b90",
      "event_cluster_id": "38fb1864-3682-4d4c-81c3-5ce8e0bbc80e"
    },
    {
      "claim_cluster_id": "717225a3-f2cc-4921-bece-db76c2709d99",
      "event_cluster_id": "fa792d5d-a49f-406b-8386-4253dfbb9e11"
    },
    {
      "claim_cluster_id": "3945d107-ebd6-4f7f-98d8-84183dc2837f",
      "event_cluster_id": "66d45ba9-56c2-4b38-9b31-adec0598a967"
    },
    {
      "claim_cluster_id": "4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d",
      "event_cluster_id": "ced5af6f-55f4-47fb-a25a-cd619d213da3"
    },
    {
      "claim_cluster_id": "61fe3afa-76aa-4838-9dd9-a22a879ae31e",
      "event_cluster_id": "d9598814-d7a3-48d1-b282-0aa4d0dfeb8b"
    },
    {
      "claim_cluster_id": "7553f34f-d61f-419e-8976-cecf89bafb0e",
      "event_cluster_id": "522dac78-ab07-4494-b1cd-d35343e02912"
    },
    {
      "claim_cluster_id": "fc8bfdbe-11b3-42f5-b3d0-f35ef7784a93",
      "event_cluster_id": "53368f02-d082-40dc-87de-4a43534eebcb"
    },
    {
      "claim_cluster_id": "60269200-21dc-4ddd-bed2-414eb8acfbb9",
      "event_cluster_id": "f54b8dca-8c1e-4052-93b8-d1e0396181a2"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "d8fa0364-5dd8-4aab-bf01-01e24a95233b"
    },
    {
      "claim_cluster_id": "be207930-e097-4d94-9b71-209ad62e9e5f",
      "event_cluster_id": "e4488bd7-fb22-40f5-8db9-906cdc42ac18"
    },
    {
      "claim_cluster_id": "72804ca3-611f-4b19-ada2-8bfb14c2e98a",
      "event_cluster_id": "c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"
    },
    {
      "claim_cluster_id": "5fbc247f-99df-408a-8188-29a28a5f5737",
      "event_cluster_id": "ca1ecbfe-0a58-42df-b1c6-c31ad13d1a11"
    },
    {
      "claim_cluster_id": "0fde95b6-db57-45cd-b6ac-fb0edd1b186b",
      "event_cluster_id": "ecb3f4fd-fe1b-4ef4-a13b-94c4c7eea90e"
    },
    {
      "claim_cluster_id": "abfcf3df-912d-43b6-968f-0f586e4e242c",
      "event_cluster_id": "e05bca7f-c97e-42b2-a75d-fdded1101b44"
    },
    {
      "claim_cluster_id": "894e29d9-1e82-4e00-b1eb-e5092d46e327",
      "event_cluster_id": "63342b93-bff9-4530-8c61-5a3714d544f1"
    },
    {
      "claim_cluster_id": "838e6a9b-36b6-4be2-87e8-cb3d0595dcf6",
      "event_cluster_id": "4a121497-0e52-49d8-8aba-88f4fe1ef31b"
    },
    {
      "claim_cluster_id": "218a3fc7-ac76-4428-aa52-1f315a03667d",
      "event_cluster_id": "6ad22c58-94f1-4426-8339-5bd33e29da9e"
    },
    {
      "claim_cluster_id": "0f106199-65cd-478b-af43-69825b16fa47",
      "event_cluster_id": "81889b4e-a54e-4052-b2de-56a05ad20bc2"
    },
    {
      "claim_cluster_id": "a6d51f65-13a0-42d8-b6fe-66f9daf5bd01",
      "event_cluster_id": "31fdbc6b-e989-4270-9e66-1ce2fea0d717"
    },
    {
      "claim_cluster_id": "6f473cd4-feae-4e71-a4f1-47b2820e799e",
      "event_cluster_id": "54f0485d-be26-4b53-bcd8-2b1cb8ee52a3"
    },
    {
      "claim_cluster_id": "b247d35e-9452-4e26-8399-17fe2d8e1df5",
      "event_cluster_id": "60cb910a-8631-4e58-9913-f906c1b2084a"
    },
    {
      "claim_cluster_id": "ce4379b5-864c-4150-b826-c6825e39d887",
      "event_cluster_id": "a1ffb94b-ce0c-4994-8b4a-5885dcc09a67"
    },
    {
      "claim_cluster_id": "b4ee4418-ee26-4134-986b-8e220ef5da22",
      "event_cluster_id": "37f90fa7-4e1a-46b6-b513-6bfba31c2cf2"
    },
    {
      "claim_cluster_id": "0bdfd962-fc80-4c29-8a9f-545619ab3653",
      "event_cluster_id": "e297a044-750d-493d-8fab-439c72fd77f6"
    },
    {
      "claim_cluster_id": "516d27f7-0cda-468f-b3b6-27af200d408b",
      "event_cluster_id": "71236786-30d7-40e5-8b9f-3cc8f5e06fd8"
    },
    {
      "claim_cluster_id": "d08db747-1994-456e-82f1-cca372892842",
      "event_cluster_id": "0212de6c-9c69-4316-ae96-331158f2438a"
    },
    {
      "claim_cluster_id": "94a3af2d-ef6e-49ef-84ee-4d1aa3f90aff",
      "event_cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63"
    },
    {
      "claim_cluster_id": "d232b59a-12d7-48e0-9945-60749a40e538",
      "event_cluster_id": "cc256628-cc7d-493f-98f7-e2382cb4b346"
    },
    {
      "claim_cluster_id": "8ba29c52-b42b-44a3-86e2-12fd13d42596",
      "event_cluster_id": "eafe4828-2ad9-4259-92a7-b6017492bd06"
    },
    {
      "claim_cluster_id": "5e700671-a24a-4c8f-a1e4-abbfb82f4537",
      "event_cluster_id": "6ecdc168-b4c6-42e6-a45f-27cde46257e5"
    },
    {
      "claim_cluster_id": "e6794d6d-e8b8-42e9-8f90-b2940e146fb9",
      "event_cluster_id": "30cd928f-5775-4679-a8af-3acd8dd1a21e"
    },
    {
      "claim_cluster_id": "06dab846-f17e-48d2-94e4-d604af613859",
      "event_cluster_id": "fa13d89b-1dff-4027-a91c-143971ebb4aa"
    },
    {
      "claim_cluster_id": "d5ad62ab-dd96-48fa-a092-0724cb0c06f6",
      "event_cluster_id": "b5ae91f8-14e1-45b9-96d8-d01043f4d725"
    },
    {
      "claim_cluster_id": "ba4d4a13-eb59-48ce-b75b-0c214fe98953",
      "event_cluster_id": "22f29403-f7fd-433f-b37d-85803cc6c208"
    },
    {
      "claim_cluster_id": "505519a5-a059-4c9c-8b16-ce6dffe7e678",
      "event_cluster_id": "34a2bc3b-8f85-4670-8f29-4e2b139366de"
    },
    {
      "claim_cluster_id": "edec9892-cca5-4a34-b102-ebb0bb45e077",
      "event_cluster_id": "0ac8de8c-821d-4fe2-90f7-e1d30911339a"
    },
    {
      "claim_cluster_id": "29009c7f-3a77-46aa-91c0-d0f703c52dab",
      "event_cluster_id": "bf4593ea-9aa1-40b8-a424-04287ae58886"
    },
    {
      "claim_cluster_id": "d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3",
      "event_cluster_id": "5fd9694e-e9ba-4a5a-99d6-b32c720bbf4e"
    },
    {
      "claim_cluster_id": "3db5575b-e4cd-4afc-835e-707980be99ac",
      "event_cluster_id": "3035cab4-7bf7-4e5f-b8ff-717930d9caf2"
    },
    {
      "claim_cluster_id": "3d5e8f72-7611-4d2c-a35c-668790f97298",
      "event_cluster_id": "97a63c8b-423b-4b4d-8ca6-262c543d514e"
    },
    {
      "claim_cluster_id": "49a8c8f2-03df-436a-8634-670fd40a145c",
      "event_cluster_id": "019a31da-45d0-4ffd-a58b-773a16c0362f"
    },
    {
      "claim_cluster_id": "6d12ca3e-2e36-40ab-9cf4-0663df64745d",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "650bbf0e-b896-4929-a2ae-2f9899d4868f",
      "event_cluster_id": "d640924f-577c-4904-972f-ea78d30a1b14"
    },
    {
      "claim_cluster_id": "32bf3674-86a6-4cde-a9e5-20a5e3965e02",
      "event_cluster_id": "621f11b4-2ba1-45f0-bd1e-92caed87da0b"
    },
    {
      "claim_cluster_id": "86160f22-53c1-4e04-a28d-86c0e883fa44",
      "event_cluster_id": "9b0d2d04-ff3d-45df-af3c-018b55e1eabe"
    },
    {
      "claim_cluster_id": "ee877fbc-1f06-46ff-b006-7c974bc58cf1",
      "event_cluster_id": "77f85883-e69f-43a1-9e7c-0df03c9438b4"
    },
    {
      "claim_cluster_id": "bbad87a2-fdaf-4bdc-9b37-124a381131af",
      "event_cluster_id": "0b7703f0-770f-46f4-8c70-921a8b6b2ad7"
    },
    {
      "claim_cluster_id": "20eecf26-3fb0-4e96-b07f-0dfffef9c628",
      "event_cluster_id": "99775dd2-fc60-40f8-87bb-cfdaeb07bbae"
    },
    {
      "claim_cluster_id": "7cc752d0-c62a-4657-a1e6-4213c5baa7cf",
      "event_cluster_id": "14db711f-b761-4a49-a9c7-2b0c0895c032"
    },
    {
      "claim_cluster_id": "0f8d7640-e263-43ac-9294-0e526087824c",
      "event_cluster_id": "1d1ebfc5-8408-4d3f-ae15-fa5d518e6407"
    },
    {
      "claim_cluster_id": "b45686ea-2849-48a8-b658-78abebbff1dd",
      "event_cluster_id": "878ab8c3-2760-46b0-8086-c8aa996e56bc"
    },
    {
      "claim_cluster_id": "5b0ba6ac-d65c-49f0-9ed7-62610378c0e1",
      "event_cluster_id": "a9f4e598-1ac2-4a32-9af3-12230870507a"
    },
    {
      "claim_cluster_id": "39f5f705-55d1-4470-8928-bfce04d4f7be",
      "event_cluster_id": "bacd83d6-baf3-4811-8b78-eb961f99ab8f"
    },
    {
      "claim_cluster_id": "0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f",
      "event_cluster_id": "0d3db024-9b87-4816-98d7-172f0864bf36"
    },
    {
      "claim_cluster_id": "4b37762b-26f0-4956-9d1d-e433973602e1",
      "event_cluster_id": "0d5de813-beee-4fba-8db1-09461ff50d02"
    },
    {
      "claim_cluster_id": "de30ed78-2cf8-480b-aacb-665d9572f1b4",
      "event_cluster_id": "9a05cb71-dda4-4c46-862e-16d08e1809de"
    },
    {
      "claim_cluster_id": "d60742af-37a3-43e0-afb8-5df777dac64e",
      "event_cluster_id": "696c75fe-b8aa-4f76-a6f1-267a591b7b7b"
    },
    {
      "claim_cluster_id": "bfd0fa79-f057-4e1b-abfc-222496dbeabb",
      "event_cluster_id": "f51d8559-af8b-4da0-bbbe-5eb4dde41ccd"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "29477fdd-bbbe-4e39-b779-19de18778240"
    },
    {
      "claim_cluster_id": "43de0036-79a8-44f6-b066-25424acf3535",
      "event_cluster_id": "11875278-ef5e-43b1-8558-2410f47e68af"
    },
    {
      "claim_cluster_id": "5f10e7fa-9adf-4e59-961b-ac04facb9f2b",
      "event_cluster_id": "04e99e38-59fd-4613-8ed1-1ec10ecc384c"
    },
    {
      "claim_cluster_id": "99955509-35d5-4623-b165-0b6dc4f83f23",
      "event_cluster_id": "bd30dba7-ded3-462d-90f7-5fc4ff649bd4"
    },
    {
      "claim_cluster_id": "4c95b4a9-d005-4c7c-8a55-a5a0821d7611",
      "event_cluster_id": "690596f3-57f6-4044-a245-63584bb2f8ea"
    },
    {
      "claim_cluster_id": "292629c2-32f2-451e-b64e-e8f73bb87975",
      "event_cluster_id": "21518841-2c46-4292-abad-aff342a4f1ac"
    },
    {
      "claim_cluster_id": "4180dc5e-36b2-4900-9bf9-c6ecf67fdc08",
      "event_cluster_id": "76557fca-1139-4be6-b8fd-797e3828c438"
    },
    {
      "claim_cluster_id": "664823cc-3309-42a4-9224-e9eaa7ee3fe5",
      "event_cluster_id": "1e66818d-6709-4941-8387-4e813b228894"
    },
    {
      "claim_cluster_id": "9c52e5bb-8493-4b3c-8444-69598adc8932",
      "event_cluster_id": "8c5f2bf0-92e9-41c9-b66d-14747ba819d6"
    },
    {
      "claim_cluster_id": "a5744137-28c3-42a2-94a7-6f90f74e8a86",
      "event_cluster_id": "27647283-49db-4a69-bd08-66190d0e650e"
    },
    {
      "claim_cluster_id": "634ebbc5-474d-42c0-bf34-498666dade49",
      "event_cluster_id": "bfe09009-b8ac-46f6-854c-5d83a7ad4a7f"
    },
    {
      "claim_cluster_id": "6b38f355-a80e-4449-8c83-c5ac56d5a2e6",
      "event_cluster_id": "d673001c-8f3c-4ad3-bd60-90a9445c79f6"
    },
    {
      "claim_cluster_id": "3d52b30c-fa0d-4a4c-9240-38abdfc6ab20",
      "event_cluster_id": "6c82fce7-dc95-4a42-b643-38f90297f22f"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "daf13a88-450f-40a7-bca6-ccfb46ede159",
      "event_cluster_id": "104cce1d-7dd6-445b-b83a-f1e498dd3f09"
    },
    {
      "claim_cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
      "event_cluster_id": "3e95ef61-306a-4cf0-a217-5b910e8ffc01"
    },
    {
      "claim_cluster_id": "ba6f293a-cb12-4697-ba51-b7964934f25d",
      "event_cluster_id": "997ed426-7093-49d8-afde-97f5ea1d37f4"
    },
    {
      "claim_cluster_id": "4350947c-093e-43d1-91ad-c33f75e13a1e",
      "event_cluster_id": "64d91f5a-97ac-46c7-8034-7d2fcfc293b5"
    },
    {
      "claim_cluster_id": "71185519-3f2f-4171-84a1-11f08a933f13",
      "event_cluster_id": "d8fd9aa7-8b30-418d-82de-88746b18d64d"
    },
    {
      "claim_cluster_id": "77763430-7d23-4e23-9288-5fdabfddb4bf",
      "event_cluster_id": "b61e836a-7b6e-4f27-85e3-ad2994cac010"
    },
    {
      "claim_cluster_id": "5d657ce1-e484-4e48-b720-f4927cd733dd",
      "event_cluster_id": "b8e15d0d-b6bd-4105-9d0d-28c9c1a8c47e"
    },
    {
      "claim_cluster_id": "6c2771d0-bfd3-428e-a6d5-47a3f027d3a6",
      "event_cluster_id": "c498b99d-fbf7-4e48-9c94-6d92541e239e"
    },
    {
      "claim_cluster_id": "770fcc6f-66a8-42c3-adcc-243f958e2049",
      "event_cluster_id": "88ac8370-087f-4a90-8111-103d9e01fd10"
    },
    {
      "claim_cluster_id": "d3b98f44-6b27-4d30-a29b-fd80c7643f1b",
      "event_cluster_id": "e2b1886a-d41d-4169-be53-e4ed1b6d9d79"
    },
    {
      "claim_cluster_id": "38bae771-edb0-4c72-84b7-885ee4da4419",
      "event_cluster_id": "95b33dd9-d9c3-4168-aeae-fc027379013c"
    },
    {
      "claim_cluster_id": "ba4d4a13-eb59-48ce-b75b-0c214fe98953",
      "event_cluster_id": "8463c208-4f6b-46d2-8aa4-c6b2f82bc799"
    },
    {
      "claim_cluster_id": "e8bed2a1-875c-4017-abd5-83f756e2ceb2",
      "event_cluster_id": "d2dc78d1-ae53-4ed9-adc5-5e6752f3a1b0"
    },
    {
      "claim_cluster_id": "78064e33-a38e-4112-b3b2-c02951368282",
      "event_cluster_id": "6c5b6495-5a45-4608-8917-e96bd2fcb820"
    },
    {
      "claim_cluster_id": "09a92b68-8f29-435d-b853-f4c47f64d9da",
      "event_cluster_id": "770085f4-c156-40e9-85de-d0bb720ad51c"
    },
    {
      "claim_cluster_id": "df65bddb-06ed-4815-9cbc-5ae170dbdeae",
      "event_cluster_id": "6bd47b8f-99ce-47e4-9910-46d2ae0dd574"
    },
    {
      "claim_cluster_id": "08dc80e4-6332-48c1-99f1-a1bc6a88f48b",
      "event_cluster_id": "5014d6b5-2e76-49bd-95af-b599a74c0052"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "b7c58dbe-be1c-46e8-b987-6a07d4c0753c"
    },
    {
      "claim_cluster_id": "f0d99bfd-e20a-4b87-9be0-a227af6f681d",
      "event_cluster_id": "33b11fcf-85c4-4c95-b81e-d603bced718a"
    },
    {
      "claim_cluster_id": "9c68ef9f-53c9-413e-b008-51e352564820",
      "event_cluster_id": "381be24e-814e-460f-aaf7-24ebc78ab4d4"
    },
    {
      "claim_cluster_id": "6b38f355-a80e-4449-8c83-c5ac56d5a2e6",
      "event_cluster_id": "7f5ce29d-718d-42a9-af2b-7bbc25320894"
    },
    {
      "claim_cluster_id": "388dcf56-c13f-4ec5-bbc7-b3c71eaffd35",
      "event_cluster_id": "fc384be2-9fa7-4507-96ed-913cfeb3e5bf"
    },
    {
      "claim_cluster_id": "e13e75a2-63ed-4bf3-909e-11338445410f",
      "event_cluster_id": "46b03cb2-bbc6-4b28-b240-16cc3f30e3bc"
    },
    {
      "claim_cluster_id": "323efa20-d8ad-424c-9c0e-ac5d255b9276",
      "event_cluster_id": "f37e4c75-6082-4bd0-a321-a0f77cf2c5cf"
    },
    {
      "claim_cluster_id": "4e71d535-1646-4ea5-9c47-04fb1464f390",
      "event_cluster_id": "ce87133c-df51-4ce0-8569-5d86ba96f3d3"
    },
    {
      "claim_cluster_id": "16667fe1-8cf7-4fec-9aa8-c5bb30920e90",
      "event_cluster_id": "41d69a2f-db55-4c96-81a9-27bcb85442bc"
    },
    {
      "claim_cluster_id": "252d476c-5ce3-4a28-9ab5-6406955b15b2",
      "event_cluster_id": "c64955c1-2c6f-41ba-ac81-974a3b1eb981"
    },
    {
      "claim_cluster_id": "93429ef7-e07c-4686-85f7-679d49d1274f",
      "event_cluster_id": "a7d594c1-3fc6-43ed-8545-37320216cb3f"
    },
    {
      "claim_cluster_id": "69fa7886-741a-440f-8a20-2b9ce60729ac",
      "event_cluster_id": "876e8e24-c321-4738-b179-b28d55e4c79c"
    },
    {
      "claim_cluster_id": "cdfd2024-64ea-4945-8131-782266513caf",
      "event_cluster_id": "46d5760c-bd0b-4c2e-8270-d2debd9f3dcb"
    },
    {
      "claim_cluster_id": "992ef0ee-f6fc-4177-b75b-0a3511a615a6",
      "event_cluster_id": "34a1b507-fb03-489f-a79e-be687aeaabe9"
    },
    {
      "claim_cluster_id": "a5114ace-99b6-4b39-875b-8b7056c70002",
      "event_cluster_id": "612d697f-8136-4aba-a8a7-d6de87a2c992"
    },
    {
      "claim_cluster_id": "71acf2d0-be7b-4d8e-b3fc-93baaa073aa1",
      "event_cluster_id": "3d95e05f-6c78-4338-9960-bbc4049a682e"
    },
    {
      "claim_cluster_id": "2d2ebd07-a80d-4a48-b320-cc68d39bdc10",
      "event_cluster_id": "c695ae29-6241-4eba-94f9-8224687bf1a7"
    },
    {
      "claim_cluster_id": "2ebece0c-e502-49a9-94b9-5df90f1b8e51",
      "event_cluster_id": "08918774-fef7-4ef6-9e14-8a7abce1a23c"
    },
    {
      "claim_cluster_id": "2d5d8472-462a-48f6-89fe-e8182a74e9c6",
      "event_cluster_id": "3b28fd20-f6ec-4932-9943-984312470724"
    },
    {
      "claim_cluster_id": "1473286e-ca60-4128-b82b-a6695a32595a",
      "event_cluster_id": "777f1392-cb45-4f46-9166-db9e19c26beb"
    },
    {
      "claim_cluster_id": "45803076-0698-48ef-a2b4-10f190885998",
      "event_cluster_id": "c59b0f7e-3d57-4bed-a62c-40ef9b2d80c1"
    },
    {
      "claim_cluster_id": "528a9885-82c7-4bee-beac-f85e4c7c3f1b",
      "event_cluster_id": "771ff184-5478-488e-90da-69f2d3b1dfbb"
    },
    {
      "claim_cluster_id": "9a03a84a-f375-4382-bf36-e4f5df1b4795",
      "event_cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6"
    },
    {
      "claim_cluster_id": "304f9508-2cf0-4ef2-b524-7a5c78978d94",
      "event_cluster_id": "247c6528-f0e7-49f9-99fb-27ef047a4410"
    },
    {
      "claim_cluster_id": "8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4",
      "event_cluster_id": "b006c022-e811-42d8-ab1c-bed9f97e066b"
    },
    {
      "claim_cluster_id": "50967b88-5546-4fd0-9e1b-6bf235297b83",
      "event_cluster_id": "1352c5e1-e3f4-4bd5-a309-04804d3a9c0a"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "0d1f3710-22b1-4ca4-9501-1c3095b8199a"
    },
    {
      "claim_cluster_id": "c03b0c98-53e3-4757-8e78-30293d823fdb",
      "event_cluster_id": "1e7fb3ce-6e1c-49dc-978d-4116378d449b"
    },
    {
      "claim_cluster_id": "64b58fdb-7776-47be-a603-30c85a60366e",
      "event_cluster_id": "6a03d110-92cd-4da9-913a-56888b17641f"
    },
    {
      "claim_cluster_id": "a837b2bf-502e-4024-b245-761701b0a6d5",
      "event_cluster_id": "9288082a-2c01-4b74-9421-1882494878c4"
    },
    {
      "claim_cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
      "event_cluster_id": "c021fe18-c42c-443c-8de9-a7f8d58891f4"
    },
    {
      "claim_cluster_id": "c9367bb7-c2e3-4341-a799-6ff36d655556",
      "event_cluster_id": "63be6506-f9dd-4d4c-86f5-e451710401ef"
    },
    {
      "claim_cluster_id": "642bd570-9063-4bca-8050-702e322b8b3c",
      "event_cluster_id": "f9c2516c-da15-44ca-94aa-e9d013d3a430"
    },
    {
      "claim_cluster_id": "5a50a1fe-c68d-46bc-b14a-9fe07afb2e36",
      "event_cluster_id": "bf2b7ba7-a6da-4f7a-bc58-63ae1a3267de"
    },
    {
      "claim_cluster_id": "235bfc4a-e3f2-4850-83c2-a78043ab464b",
      "event_cluster_id": "076ca314-f50f-433c-a148-2b657f0a88ab"
    },
    {
      "claim_cluster_id": "1db866e4-0f7e-4d67-93e0-8d1068f0369d",
      "event_cluster_id": "7cc54def-6358-42e1-9afb-ba0b2ba2ac2c"
    },
    {
      "claim_cluster_id": "a15b9883-60ad-4e49-8943-56ed500ab8cf",
      "event_cluster_id": "f10425d5-24f2-425f-821e-7acb93c9e53b"
    },
    {
      "claim_cluster_id": "d41663c0-a43a-40f6-ae8e-9e6eeb720de9",
      "event_cluster_id": "8ec3865c-7644-4e06-bb0d-00ab782e6cd7"
    },
    {
      "claim_cluster_id": "83605bab-42d6-405a-ab45-fb6b68e0609c",
      "event_cluster_id": "03fe8498-7679-447a-af5d-563e12790d0c"
    },
    {
      "claim_cluster_id": "56dc9727-1db9-4dc8-acf2-c70b7f101883",
      "event_cluster_id": "ca92e9ac-f88f-40f7-8676-383e3ddbcb77"
    },
    {
      "claim_cluster_id": "2d2ebd07-a80d-4a48-b320-cc68d39bdc10",
      "event_cluster_id": "2bfb03ed-8bb2-476c-9ace-087ef4a35f09"
    },
    {
      "claim_cluster_id": "97e28e03-c0a3-40ba-8418-88973425525a",
      "event_cluster_id": "ca3c690a-ee2b-4679-9ac7-f2f87ab00ae8"
    },
    {
      "claim_cluster_id": "c9367bb7-c2e3-4341-a799-6ff36d655556",
      "event_cluster_id": "6b0217e7-2354-4152-81ca-d64e5b080b90"
    },
    {
      "claim_cluster_id": "469c5194-5b04-4e90-b62c-73b3f79a0955",
      "event_cluster_id": "3c52b26e-a9d9-4bd3-979f-3455beaaaaec"
    },
    {
      "claim_cluster_id": "12ff0964-4c5c-4f91-8269-1e4ab61e9602",
      "event_cluster_id": "8f75e655-8582-4cb0-9320-47aef61dad78"
    },
    {
      "claim_cluster_id": "c75e8276-e126-4693-a87d-4d748183e6fe",
      "event_cluster_id": "5e94868b-1054-4680-801c-eccafab6e048"
    },
    {
      "claim_cluster_id": "8948b384-0046-47fe-bc91-7f2737b00557",
      "event_cluster_id": "a67c3f7f-a1ca-4dac-ba63-61ecd0d76ed7"
    },
    {
      "claim_cluster_id": "38bae771-edb0-4c72-84b7-885ee4da4419",
      "event_cluster_id": "01d21517-243e-4d94-b9c5-641f8bca7cbf"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"
    },
    {
      "claim_cluster_id": "b8208758-3ffb-41f1-97e7-30e90da08e44",
      "event_cluster_id": "a9f14778-a0da-48d5-9d93-8fa7cd7361ec"
    },
    {
      "claim_cluster_id": "23adc402-b3b7-489f-bbe8-5d7825946d77",
      "event_cluster_id": "b6efa0ef-9a52-43da-8c24-a3f10f0aaf37"
    },
    {
      "claim_cluster_id": "6d7d1320-a896-4471-aa98-60a45946bc57",
      "event_cluster_id": "f13db706-0347-473b-9857-0fcfd7adeb37"
    },
    {
      "claim_cluster_id": "a7a78172-b61a-41cd-a089-5fdf5b5e9fdc",
      "event_cluster_id": "2bb22d37-82ad-420f-8b9d-f5e541da469b"
    },
    {
      "claim_cluster_id": "6c812e58-19af-4264-b856-e922307ab466",
      "event_cluster_id": "e228a8c4-9bff-4634-a77f-16ed4aba6a89"
    },
    {
      "claim_cluster_id": "a4d61819-30e3-46aa-ab08-cf879db00de1",
      "event_cluster_id": "13e53d6a-9b30-4b10-9f27-0687c15666b8"
    },
    {
      "claim_cluster_id": "902f069d-3703-489a-9dfa-fb26ee837027",
      "event_cluster_id": "49854b0f-e263-4847-a942-d2497d0d1530"
    },
    {
      "claim_cluster_id": "7e1a378e-1366-4ff2-9282-46ddc9975cc6",
      "event_cluster_id": "a3b6f394-159b-439a-a766-38bc59e64bb8"
    },
    {
      "claim_cluster_id": "de4f148f-cf69-426b-b5bb-f722fb88313c",
      "event_cluster_id": "7512ed6a-dee9-4a0a-b3bd-71a36d7ff111"
    },
    {
      "claim_cluster_id": "d21ce376-5e68-41d1-903e-db8ea2f295f8",
      "event_cluster_id": "582e1668-0621-414e-a531-9d7ad55393e8"
    },
    {
      "claim_cluster_id": "ba035925-8a5f-42d0-aec3-c91702a47b8d",
      "event_cluster_id": "4cb90529-ce16-437b-99b6-c2cd5dcc786a"
    },
    {
      "claim_cluster_id": "452589b4-0af9-45d5-aee2-979a0dc78876",
      "event_cluster_id": "473a62f7-a375-4113-841d-d6bbd59826b2"
    },
    {
      "claim_cluster_id": "80a02b1a-c045-453f-ad92-9681e40dad83",
      "event_cluster_id": "d64f3c9d-c55d-4ebc-9a01-43d63af153f0"
    },
    {
      "claim_cluster_id": "a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0",
      "event_cluster_id": "27c3b9de-4f86-4091-b50b-7314a2636d6c"
    },
    {
      "claim_cluster_id": "cb239c20-3722-49db-94a4-29c15a45d8b1",
      "event_cluster_id": "71c1ae12-8809-47ac-8b8b-cc34ac436157"
    },
    {
      "claim_cluster_id": "e370d332-674b-403f-8471-184685b21c55",
      "event_cluster_id": "83314d81-ffc5-42be-b8ab-fc7049a1e48f"
    },
    {
      "claim_cluster_id": "4cb70cfd-308b-45d4-a6de-94896ddf47a0",
      "event_cluster_id": "8f35aa71-39a9-43b6-9e1f-9db20e05a30e"
    },
    {
      "claim_cluster_id": "928cf7ca-8343-47ca-be27-378bc29b7fbe",
      "event_cluster_id": "3349d8e0-ebe5-4359-bb8d-083c8d3a9420"
    },
    {
      "claim_cluster_id": "de7b2349-3e46-436f-9b75-c57089eeaa3c",
      "event_cluster_id": "739c0bc4-1bf3-45d5-b4d4-587c8689dc5a"
    },
    {
      "claim_cluster_id": "45803076-0698-48ef-a2b4-10f190885998",
      "event_cluster_id": "719750be-a238-45aa-96a8-065dfd797981"
    },
    {
      "claim_cluster_id": "e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37",
      "event_cluster_id": "1d3c886f-bc05-43fd-9472-810156e4edfd"
    },
    {
      "claim_cluster_id": "a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05",
      "event_cluster_id": "414df1fb-6d9e-4aff-a35e-819202fb6c05"
    },
    {
      "claim_cluster_id": "252d476c-5ce3-4a28-9ab5-6406955b15b2",
      "event_cluster_id": "5ac2f931-1ef9-4c96-8568-845f2751d03d"
    },
    {
      "claim_cluster_id": "61fe3afa-76aa-4838-9dd9-a22a879ae31e",
      "event_cluster_id": "88bb793a-f03a-44d3-bc64-124f3010e3b7"
    },
    {
      "claim_cluster_id": "c7eb5329-6775-4d3f-aea7-7de4fbeb8175",
      "event_cluster_id": "a08b7547-a0f1-452b-9b55-18b72ad44763"
    },
    {
      "claim_cluster_id": "f57f4c9e-1d41-4f34-b42f-aa11437d6812",
      "event_cluster_id": "2f5e01bb-8b8d-4570-9736-c9caf60706be"
    },
    {
      "claim_cluster_id": "5102f7b6-4554-4836-b695-c4ff3c598adf",
      "event_cluster_id": "a222bbbf-dfe3-47ea-9ab7-93e4d89e7fe7"
    },
    {
      "claim_cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "317ae87f-a4ca-4e46-9ff8-1bebad9fd04f",
      "event_cluster_id": "3f25c082-1585-41e9-8842-37a9e6419694"
    },
    {
      "claim_cluster_id": "7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1",
      "event_cluster_id": "c46b62bc-7cc2-4635-bcb1-86c242f419fc"
    },
    {
      "claim_cluster_id": "d6705dc8-8def-4060-882a-9c13b62a23ad",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6",
      "event_cluster_id": "ac2c361f-32c9-4d71-8c96-6c8953a04d75"
    },
    {
      "claim_cluster_id": "294ad0e1-cad9-4655-b7de-5e21de0e4797",
      "event_cluster_id": "e228a8c4-9bff-4634-a77f-16ed4aba6a89"
    },
    {
      "claim_cluster_id": "e045b8f3-c755-4ad1-91b0-a0b8f7878680",
      "event_cluster_id": "64d37d6c-89cb-4974-81c1-3b1735939788"
    },
    {
      "claim_cluster_id": "457d88a0-1b8d-406f-8eeb-01fdd00cdc30",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "1c703565-77f6-4eda-962e-77ec869d886d",
      "event_cluster_id": "ad9e7a2b-7924-46d4-ba72-1397b5c0801b"
    },
    {
      "claim_cluster_id": "b1abd415-ce48-46da-b8bf-36f727bba7c7",
      "event_cluster_id": "72967666-4eb9-48c4-a9dc-dc51036d287d"
    },
    {
      "claim_cluster_id": "075f7aea-756f-4e67-bf46-f4305230821b",
      "event_cluster_id": "a5b4fdb0-8d5b-49c2-aabd-e64213ff8027"
    },
    {
      "claim_cluster_id": "035bc55a-3ae4-48b4-942f-bbef3d308147",
      "event_cluster_id": "5dff1a24-a2b6-4405-a930-eab85cab0d38"
    },
    {
      "claim_cluster_id": "8b0aef83-1693-4fa2-8559-a133b18a2dbb",
      "event_cluster_id": "da1930dd-8986-4fa6-b320-dd6da70d644c"
    },
    {
      "claim_cluster_id": "02e82f7d-c446-4fc6-9794-94910a46d2ac",
      "event_cluster_id": "5502f4b5-10c2-450c-b072-20a0d153fef3"
    },
    {
      "claim_cluster_id": "df20aee7-4e88-4c5d-a2d1-ce862c311713",
      "event_cluster_id": "2f3684a3-db51-45d5-8ab6-a0d061f2a667"
    },
    {
      "claim_cluster_id": "a990d90c-b1b0-4148-b047-5b63c9eb7a78",
      "event_cluster_id": "eb6bb91c-6bc8-4c0a-9783-baf41ad32ae6"
    },
    {
      "claim_cluster_id": "8b44daa7-629e-4db8-81b7-5ed88669eb86",
      "event_cluster_id": "4d6eed7e-0404-4ccd-92b2-df5956550e67"
    },
    {
      "claim_cluster_id": "45931062-6efb-4850-9df7-4bff0b9b4a16",
      "event_cluster_id": "177da242-e804-4b06-8955-3e43352e0145"
    },
    {
      "claim_cluster_id": "ab52850c-7dc5-4f99-b37e-0c628b078043",
      "event_cluster_id": "d87790ba-a7e4-42b2-87ee-50115287f374"
    },
    {
      "claim_cluster_id": "38b659e5-9f63-40c6-bab6-c8934148aa21",
      "event_cluster_id": "efbb863d-f52e-42f9-a671-9fa0b8c1b1fb"
    },
    {
      "claim_cluster_id": "bcc578f8-a745-46e1-ac64-5315a3ec6900",
      "event_cluster_id": "9ed0391b-e831-497d-9d87-ba9ea12680b7"
    },
    {
      "claim_cluster_id": "6c812e58-19af-4264-b856-e922307ab466",
      "event_cluster_id": "5eaa7b8f-5e2f-4cc2-827c-b780c20bc557"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "04a0ae4a-7a1f-4b83-aea9-9fb4dfa80e1a",
      "event_cluster_id": "ef20ba46-c8c3-4085-85f9-b312f9f6802a"
    },
    {
      "claim_cluster_id": "3ea6c360-e1ff-4b61-9454-07814cabc76c",
      "event_cluster_id": "6f715c79-5b97-43d0-a5c3-09848b08ceca"
    },
    {
      "claim_cluster_id": "baa70e51-5ce2-4e6f-8994-d85027e6b1d9",
      "event_cluster_id": "99b6af80-6889-4032-9dda-54d5dbe1fafb"
    },
    {
      "claim_cluster_id": "eb68c709-6220-48fe-b376-95a4f6f10b6d",
      "event_cluster_id": "33b55b1e-2a6f-4f56-affb-50cf2ec05471"
    },
    {
      "claim_cluster_id": "07bacc2e-cf13-4467-917c-ef3c2aa505ca",
      "event_cluster_id": "bfff8af2-9d27-4503-baf3-3e1618c9087a"
    },
    {
      "claim_cluster_id": "0961c365-4261-4c91-984b-81c62260d807",
      "event_cluster_id": "230bb8e2-d4ad-487c-a1d7-42ba2ea0e5cc"
    },
    {
      "claim_cluster_id": "f75e1405-c093-4f18-a3c7-d59d8bfe94d0",
      "event_cluster_id": "991efb3f-2e53-4e93-bf2d-3ba713b91c23"
    },
    {
      "claim_cluster_id": "483b6a3b-d48b-40f7-b28f-e79dfca268e6",
      "event_cluster_id": "3addd54f-eb0f-4cbc-93e6-9436080208cb"
    },
    {
      "claim_cluster_id": "9bf70381-221f-4cfd-8e17-16f9ebb35e36",
      "event_cluster_id": "5d1b0403-1447-4432-b6a8-ce335ce3e162"
    },
    {
      "claim_cluster_id": "226f9322-c9c6-4f2f-948c-b45757d94aa7",
      "event_cluster_id": "2ef5fcdf-761e-402d-8549-a04bd0b86028"
    },
    {
      "claim_cluster_id": "b777a261-40ed-4845-9730-51d3661e3377",
      "event_cluster_id": "02502121-c7d0-43b9-afe9-c557963c5283"
    },
    {
      "claim_cluster_id": "73184e14-aff1-4c97-a2f0-0508b86fc3db",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "38520096-281c-4b53-ba64-f7e18dbd525f",
      "event_cluster_id": "d316d167-369a-4e0d-ad58-337551778176"
    },
    {
      "claim_cluster_id": "1e19ebda-0ce5-4c42-b6ac-f081acdf5974",
      "event_cluster_id": "1ba7e666-27ba-4d77-b5a9-dc9f10927af0"
    },
    {
      "claim_cluster_id": "59e6bbb6-5982-4df0-b59c-33f07ce159f4",
      "event_cluster_id": "e3c9a6ab-aa8e-4a41-9385-a9d893d2acc5"
    },
    {
      "claim_cluster_id": "762409bf-96e2-43cc-99d8-45783ade1b1f",
      "event_cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14"
    },
    {
      "claim_cluster_id": "eea02be7-fd53-47b5-9804-7a2f89de23f2",
      "event_cluster_id": "0f0292cd-5ed9-4b41-be37-f307be9f4e80"
    },
    {
      "claim_cluster_id": "b840591d-33a5-402e-9f7a-8913292b283e",
      "event_cluster_id": "1b8d5fdd-83db-44f0-aa44-0aa853c3b3f8"
    },
    {
      "claim_cluster_id": "db6d1f55-1378-42e6-ab38-0b1046e37cc0",
      "event_cluster_id": "7b66a014-a3c8-4296-b622-d0e9055b14ee"
    },
    {
      "claim_cluster_id": "763dcb28-8161-4ef1-bcee-20cbd6af7670",
      "event_cluster_id": "997b6294-e973-4686-9dd3-38c8184705a9"
    },
    {
      "claim_cluster_id": "b056d050-cc91-4967-a6df-ddb4af36891b",
      "event_cluster_id": "b785d99b-0340-4f57-a54b-f08a5b415aa2"
    },
    {
      "claim_cluster_id": "7e112a5c-41d4-4f1c-b974-99256b5d357b",
      "event_cluster_id": "7354cd90-5ded-45c2-af70-b5cea1cc0045"
    },
    {
      "claim_cluster_id": "218a3fc7-ac76-4428-aa52-1f315a03667d",
      "event_cluster_id": "07d6842c-fb2e-407d-bdda-a29d80ba013b"
    },
    {
      "claim_cluster_id": "c7013046-8aa1-434c-87b8-1e3317f5578c",
      "event_cluster_id": "6a85e8dd-d86f-4e00-b252-62364be2e0ab"
    },
    {
      "claim_cluster_id": "02fc2c1c-e5e4-40d6-92bc-a975544e0e30",
      "event_cluster_id": "8d34ac69-abf2-4d47-a080-a43806db5b67"
    },
    {
      "claim_cluster_id": "f236d68f-fe39-4432-9a36-341eb8900ee6",
      "event_cluster_id": "f7318431-bfb5-4f5f-a2ea-e4c01a34de08"
    },
    {
      "claim_cluster_id": "f72eb4bb-112f-4556-a279-ad745cb4894c",
      "event_cluster_id": "16bcd20b-c8b6-445d-b90e-bca2498ccc21"
    },
    {
      "claim_cluster_id": "f18ec76a-50ba-422f-9d7a-596708b1810a",
      "event_cluster_id": "a663162f-90e6-470c-9356-50de41099dfc"
    },
    {
      "claim_cluster_id": "506e309f-6f87-418b-b660-0ad635976c9d",
      "event_cluster_id": "a42a7921-cdb2-4929-93b9-1642ac38cfed"
    },
    {
      "claim_cluster_id": "24d81b39-c399-4c59-ae9b-c84548655d0b",
      "event_cluster_id": "240e1f26-e6d5-488e-ad06-f573f8486dce"
    },
    {
      "claim_cluster_id": "908a4168-b322-4057-a44b-a100dbffbe53",
      "event_cluster_id": "0dae78f8-77aa-48f9-a01e-03b3a39b4e44"
    },
    {
      "claim_cluster_id": "c8956774-b873-4e48-aca4-1d4ce1428a6f",
      "event_cluster_id": "d5ffcb4c-8c79-4cc4-868f-bca69bb676c5"
    },
    {
      "claim_cluster_id": "7e265407-1dda-4e06-a69c-824b7e191f01",
      "event_cluster_id": "712fa0e5-9886-40f6-b761-bb1a99d5fb8c"
    },
    {
      "claim_cluster_id": "6dfdb047-f69b-420b-87ec-fbcb72244cc6",
      "event_cluster_id": "f98ba1e5-efa5-4a15-9a39-7050f0a81013"
    },
    {
      "claim_cluster_id": "e129ef72-bb79-4915-92ec-e1ad0c220280",
      "event_cluster_id": "5661edb8-2d76-4ef2-88fa-1ef3a23ed765"
    },
    {
      "claim_cluster_id": "be7f1195-f177-4bc7-91dc-0cfb479ebb8e",
      "event_cluster_id": "32b69cec-10c5-48a9-adbb-1a38afa40ede"
    },
    {
      "claim_cluster_id": "89d92c43-6368-4ce1-8b52-63274b65d5df",
      "event_cluster_id": "66723b88-51f0-432a-9dff-39c845623093"
    },
    {
      "claim_cluster_id": "7370b2ae-5bd2-49ba-aa3a-effafe4334a0",
      "event_cluster_id": "b2b194c2-f397-4e76-bb84-c8a37964e533"
    },
    {
      "claim_cluster_id": "c94810e3-5711-44bc-a55f-5ef59645cf78",
      "event_cluster_id": "d77c268e-3ade-486d-9ca6-faf269499c35"
    },
    {
      "claim_cluster_id": "1a689731-c588-4661-b0b5-8beb94a95bb4",
      "event_cluster_id": "3a3218a4-ce54-4e61-9c08-41f52d8bf517"
    },
    {
      "claim_cluster_id": "4f68034e-7758-4136-94fe-82331ab7df47",
      "event_cluster_id": "f1ae2273-40a5-4bb6-b66e-75189e06260e"
    },
    {
      "claim_cluster_id": "68617739-11a1-4108-8d8c-6d8db53fd247",
      "event_cluster_id": "efe217b1-d8a9-48f6-b1d3-7579e75d7788"
    },
    {
      "claim_cluster_id": "f02faf57-c72f-4377-8759-469d56737085",
      "event_cluster_id": "d327e87e-5fd2-4607-86c2-9433a227a64c"
    },
    {
      "claim_cluster_id": "d0619b32-28c7-4624-9e6b-8c81d9ff9019",
      "event_cluster_id": "fa2c7516-f196-48a1-815e-d89c4e4b9860"
    },
    {
      "claim_cluster_id": "34e272f8-beb9-408f-a252-0fa71406dc4b",
      "event_cluster_id": "ceb93865-c529-4780-afd0-1e69709b13f3"
    },
    {
      "claim_cluster_id": "02774183-9d71-4dfd-8f60-b54cf275fbb8",
      "event_cluster_id": "95138155-e999-481e-8c57-056be5d97867"
    },
    {
      "claim_cluster_id": "a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05",
      "event_cluster_id": "389bf865-85bd-4767-9053-03a5fcae6a23"
    },
    {
      "claim_cluster_id": "2ca08905-d2cc-4e5f-80b6-1f1b64356b18",
      "event_cluster_id": "a2109d36-1708-4075-ac3d-fd40a7eea59b"
    },
    {
      "claim_cluster_id": "f731bc0b-cabf-4314-a5f8-e94d31589cea",
      "event_cluster_id": "20d5e5ed-4ce5-4a63-9b10-3e468d3431e2"
    },
    {
      "claim_cluster_id": "43fb6e85-e148-46ac-99f5-6e9cc985487b",
      "event_cluster_id": "55822882-d3bc-4c00-a9c9-30a5c71ddf43"
    },
    {
      "claim_cluster_id": "35218630-91b1-47a4-87cf-29094bd87289",
      "event_cluster_id": "346b1dc3-219c-4228-a017-da35814deb33"
    },
    {
      "claim_cluster_id": "380726cc-73a4-4dde-ac40-f10c2a1f6e60",
      "event_cluster_id": "b83cbf56-9c77-41ae-bf34-905116236046"
    },
    {
      "claim_cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "event_cluster_id": "35d3b29d-3d0c-4461-8663-4b180f0aaa41"
    },
    {
      "claim_cluster_id": "3a5853fd-eaf4-497d-b7fc-b13a9208544c",
      "event_cluster_id": "8bda5e73-cd1a-4ebf-b3bb-55b54ec157d7"
    },
    {
      "claim_cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
      "event_cluster_id": "4796f6d0-5c9d-46eb-a35f-0a235dcf3b0e"
    },
    {
      "claim_cluster_id": "a604694d-4fcd-48e0-a074-6eaa09488a89",
      "event_cluster_id": "90a7e868-64e0-420e-8b7e-dbd99dcaae03"
    },
    {
      "claim_cluster_id": "14a92521-0601-421b-b904-3fc9a965cbb6",
      "event_cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff"
    },
    {
      "claim_cluster_id": "939cc578-da0d-4d69-94b9-0a186537275d",
      "event_cluster_id": "0c52c819-873f-4721-acb7-09c8239a9862"
    },
    {
      "claim_cluster_id": "b49a91d7-446b-421b-9670-7c99bbf5bc28",
      "event_cluster_id": "f0144a0c-5ed5-434b-884c-c56dfe8a915f"
    },
    {
      "claim_cluster_id": "db91531a-0712-431d-a04b-9b798db3d3b4",
      "event_cluster_id": "bc5a19f9-2b61-40ac-ae39-5951370b4cf0"
    },
    {
      "claim_cluster_id": "a89a4b7b-c64e-4a3c-81e8-86dec8a3dad0",
      "event_cluster_id": "414847cb-46dd-4cd3-8ade-e04a5900b77e"
    },
    {
      "claim_cluster_id": "e0a99d28-f3a4-477a-b874-8d839c4523f9",
      "event_cluster_id": "0a2e15ba-2fa7-41ed-a5c1-17b66869fc7d"
    },
    {
      "claim_cluster_id": "7e1a378e-1366-4ff2-9282-46ddc9975cc6",
      "event_cluster_id": "1396142d-5fd2-4c3f-8a9f-e0d1627fb926"
    },
    {
      "claim_cluster_id": "d6b6cc03-8c7b-497a-ad1e-0435bb03fbcc",
      "event_cluster_id": "bacd83d6-baf3-4811-8b78-eb961f99ab8f"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "2867ef8f-0ebb-45b2-b82a-289a3f763133"
    },
    {
      "claim_cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
      "event_cluster_id": "a144123b-7815-4a8e-939f-d8124e0d4a23"
    },
    {
      "claim_cluster_id": "aae7438c-bb2b-4e87-86b8-fc77cf6148d1",
      "event_cluster_id": "8da88efd-932e-4ef9-ba62-12fc265d9255"
    },
    {
      "claim_cluster_id": "68617739-11a1-4108-8d8c-6d8db53fd247",
      "event_cluster_id": "c5394d0c-cc56-4b26-835a-5c9581cceb3a"
    },
    {
      "claim_cluster_id": "ba694c90-be36-448b-9da2-f3ed0d816139",
      "event_cluster_id": "f4f28261-ce76-46eb-a24f-4ced2c41d5f6"
    },
    {
      "claim_cluster_id": "73d871f6-e1be-43a1-b932-df733142abc7",
      "event_cluster_id": "3035cab4-7bf7-4e5f-b8ff-717930d9caf2"
    },
    {
      "claim_cluster_id": "91e94583-4b9d-4847-9825-9ed7293c7a0e",
      "event_cluster_id": "8dc116ab-03c9-451e-bd40-127719cd94fb"
    },
    {
      "claim_cluster_id": "d0228864-78be-4fd7-94b7-908de0276e80",
      "event_cluster_id": "c4ef8aa7-0a73-4837-bdda-5894dfbdb7a0"
    },
    {
      "claim_cluster_id": "f4175686-5e4d-4fb0-a465-bed7586f6615",
      "event_cluster_id": "4c182f86-5af5-4552-bee7-286b991ac0b1"
    },
    {
      "claim_cluster_id": "9c240f69-7202-4a37-b1d5-a3ae10dc5998",
      "event_cluster_id": "927e3b68-c649-4b84-bd7c-c79eecd50812"
    },
    {
      "claim_cluster_id": "e7f02350-e0f8-416a-a3fa-4d7dfaaa5615",
      "event_cluster_id": "2a04252f-e78e-41fb-93da-f1bb87ae8d3a"
    },
    {
      "claim_cluster_id": "07e66c00-a616-4a75-b1a2-efe8ff1edd22",
      "event_cluster_id": "4724ac82-4846-4770-a7bb-6a4edd69c9dd"
    },
    {
      "claim_cluster_id": "19ef8fca-6a45-4387-be0d-efc3fd245b80",
      "event_cluster_id": "f8814fc7-2279-4d32-a22e-1e33adf9e995"
    },
    {
      "claim_cluster_id": "3249ee55-684b-4bbb-8b52-6766f62838f9",
      "event_cluster_id": "5a9527b4-7ddf-4c5a-b860-67170fb02224"
    },
    {
      "claim_cluster_id": "ded98049-aef1-4b4f-a8a6-f68c10032b7f",
      "event_cluster_id": "82025429-31a1-4168-809f-fb0e7a96b10b"
    },
    {
      "claim_cluster_id": "a0fab421-41ab-435c-b6c1-ee353c134771",
      "event_cluster_id": "59fed447-7963-4349-9213-761a767fe70e"
    },
    {
      "claim_cluster_id": "cfda7d82-87df-49b1-8db2-82b62b174a67",
      "event_cluster_id": "38118243-3439-45b9-b0a1-902687ba3cc0"
    },
    {
      "claim_cluster_id": "f8c898ca-36a7-47ac-838a-8091321433d0",
      "event_cluster_id": "abfd51b8-1368-4f82-817b-9f3cd83502dc"
    },
    {
      "claim_cluster_id": "294ad0e1-cad9-4655-b7de-5e21de0e4797",
      "event_cluster_id": "7ba06e8a-b878-421d-9b1d-d395213d16fa"
    },
    {
      "claim_cluster_id": "e5736d52-6864-4a19-aa95-57d6bbe8f40d",
      "event_cluster_id": "77a0df8c-7608-483b-a706-3897667bbac6"
    },
    {
      "claim_cluster_id": "f9f7a124-b259-44e6-a922-abc880fe6775",
      "event_cluster_id": "cc21b294-9fdf-4b80-a922-5a2fda24edfb"
    },
    {
      "claim_cluster_id": "43605210-6be3-4d52-9b42-d4a4a1838ade",
      "event_cluster_id": "9fa0ae4f-fe27-4925-ae63-04bdfeb3953f"
    },
    {
      "claim_cluster_id": "fc4ce4ef-b019-44c8-8060-59b10a33a92b",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "fc64cbea-821d-4f81-89aa-1c161d723583",
      "event_cluster_id": "f544e1b7-c2c0-4236-9e51-6a506ee25e3f"
    },
    {
      "claim_cluster_id": "3368fed2-7688-4846-a7ac-3bfa3045311c",
      "event_cluster_id": "e354903e-091b-4412-9de6-d963f87ab883"
    },
    {
      "claim_cluster_id": "717225a3-f2cc-4921-bece-db76c2709d99",
      "event_cluster_id": "a00b5c34-3d1b-444a-9f62-57418373c9c3"
    },
    {
      "claim_cluster_id": "e4184b4a-b3b8-45cd-9a60-442e840d1a7e",
      "event_cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6"
    },
    {
      "claim_cluster_id": "f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3",
      "event_cluster_id": "47924c3b-71e9-4d32-b64c-af3ed4408382"
    },
    {
      "claim_cluster_id": "9f4059ba-333f-4054-ba5f-f1cebaed747e",
      "event_cluster_id": "9686ee9d-c6fe-4724-a86f-ea5424b54b58"
    },
    {
      "claim_cluster_id": "eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0",
      "event_cluster_id": "1a61f6e2-0fe8-4393-9f81-f3403bde43ac"
    },
    {
      "claim_cluster_id": "d7cbd37c-10fd-4628-bba8-b434c41ec43f",
      "event_cluster_id": "c408b7c7-ef12-40e9-99e7-96b3a920e45e"
    },
    {
      "claim_cluster_id": "04ba7876-53cc-44c3-8149-fe7ba435f124",
      "event_cluster_id": "e47f2b16-ab13-42c0-addb-b9a5881b56d2"
    },
    {
      "claim_cluster_id": "26ee8f8d-a289-4bb8-af4e-67dfc3cca301",
      "event_cluster_id": "bfee71d5-dc3e-4049-85bd-25e416b8ce0f"
    },
    {
      "claim_cluster_id": "bac292de-05f4-4fd3-a4df-f073c8f09553",
      "event_cluster_id": "8ab3c3be-4d7d-4248-a148-6cf7cee2fef5"
    },
    {
      "claim_cluster_id": "099e4f99-da99-4f13-a242-dd05de802ab3",
      "event_cluster_id": "17c6aa84-f614-46fa-bf43-265da2499cba"
    },
    {
      "claim_cluster_id": "fe6adf14-e7af-49eb-8b83-de4001fbc495",
      "event_cluster_id": "b10b3160-e0dc-461b-a456-f6327586eb6a"
    },
    {
      "claim_cluster_id": "d072d7ca-3280-4412-8e76-be63e36fe491",
      "event_cluster_id": "4ab57529-2a41-4128-8cf2-496255864fad"
    },
    {
      "claim_cluster_id": "b4479b0e-003b-4796-9f06-dafafe7cc27d",
      "event_cluster_id": "c1a62eb0-76d0-46fb-8060-6353e7306396"
    },
    {
      "claim_cluster_id": "3af9eb7e-1c8f-4ca9-987f-f38db6d11751",
      "event_cluster_id": "d1aa87f5-6e8b-45d2-89ab-5267e8136707"
    },
    {
      "claim_cluster_id": "5c68cba2-8519-4f6e-b70e-fbda62c5445c",
      "event_cluster_id": "64911a50-55cc-400d-9f35-d372b869e1a7"
    },
    {
      "claim_cluster_id": "16b63ffa-da4e-4cff-8fab-fffc1644a634",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "5ee6d6d6-e296-4f40-9760-4a7737f5c631",
      "event_cluster_id": "ea8f590f-f522-4ce0-8605-6700141bd308"
    },
    {
      "claim_cluster_id": "a9a65207-69ea-45b8-ac25-c8ee16fc4a08",
      "event_cluster_id": "89b0a4a3-f393-4706-9a25-8103c69b53d6"
    },
    {
      "claim_cluster_id": "6910074e-7bb8-4a4e-9f37-3e335d1a57a0",
      "event_cluster_id": "f97d0f4b-71d3-41e4-97ea-bf25e10bfac7"
    },
    {
      "claim_cluster_id": "50967b88-5546-4fd0-9e1b-6bf235297b83",
      "event_cluster_id": "5a08709f-1906-45c5-8ded-3d7e4a3851d0"
    },
    {
      "claim_cluster_id": "a39bfc74-5364-4583-b4c6-2ba30e1ddbf9",
      "event_cluster_id": "e3188c04-70d3-4f55-ab68-49043c888c8a"
    },
    {
      "claim_cluster_id": "746a6f97-55c7-4dc9-ab6a-cc007e33449e",
      "event_cluster_id": "7167c7d7-52bf-4753-8c56-a05326df7c57"
    },
    {
      "claim_cluster_id": "5102f7b6-4554-4836-b695-c4ff3c598adf",
      "event_cluster_id": "84df1dd4-8c28-4b8a-bdf1-47af884e70e3"
    },
    {
      "claim_cluster_id": "fa484c7a-b508-4b38-90f3-04e6ca143d03",
      "event_cluster_id": "5301f4d4-e78b-423c-a3a7-ca0fb632a3d4"
    },
    {
      "claim_cluster_id": "6015f261-315c-43b5-ae1a-b6f1ad2e1ce6",
      "event_cluster_id": "c4bed539-a0aa-4ff8-9be3-4afa92598dee"
    },
    {
      "claim_cluster_id": "c8265999-6e3a-4835-bb5a-9e081a27e9bd",
      "event_cluster_id": "05f4f7be-1927-40b1-a507-9bb7d746892f"
    },
    {
      "claim_cluster_id": "c8d47411-ab85-4f96-b286-cd76451823f8",
      "event_cluster_id": "b9cee305-a96d-440f-a08d-e2f6545e2608"
    },
    {
      "claim_cluster_id": "7bcfb80e-f4a6-4404-be69-078e88ddce1f",
      "event_cluster_id": "204fc215-6ab9-4083-b883-b901ca6c7818"
    },
    {
      "claim_cluster_id": "818fb1f8-d14f-4997-8e8d-f7e228560c99",
      "event_cluster_id": "f140fd40-63a5-49d3-9d17-1114828f483b"
    },
    {
      "claim_cluster_id": "7e265407-1dda-4e06-a69c-824b7e191f01",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "9f14caef-27ce-4bca-afff-6e691839a8df",
      "event_cluster_id": "73ec670b-a1e6-4252-8fc5-cd613c026c27"
    },
    {
      "claim_cluster_id": "c8d47411-ab85-4f96-b286-cd76451823f8",
      "event_cluster_id": "9917626e-0afd-495f-82cd-6e27aa8cc73d"
    },
    {
      "claim_cluster_id": "ac6c3346-ea92-4da2-afed-ba431832d85e",
      "event_cluster_id": "d9eedc94-d312-4947-bb37-d1fdd95dcdd4"
    },
    {
      "claim_cluster_id": "7ddce93b-3cfb-4112-a70b-f91eb14e7082",
      "event_cluster_id": "312c4cbe-161f-46b2-ac85-87a06a693146"
    },
    {
      "claim_cluster_id": "81a839cf-9fe4-4f39-95e1-2ebc94ae6380",
      "event_cluster_id": "74e4eccb-d37c-4913-a081-5e2a47430662"
    },
    {
      "claim_cluster_id": "ff43bfb6-1ab6-422e-8045-756b71e70dd1",
      "event_cluster_id": "d7349c27-6262-43ce-9388-35b7e8a7c225"
    },
    {
      "claim_cluster_id": "3ece6224-aab7-493b-83b2-1f9fc56d3136",
      "event_cluster_id": "b4dd0b00-f893-486e-8f26-56d055b47620"
    },
    {
      "claim_cluster_id": "702a4627-2eae-451d-b2a9-154358319e24",
      "event_cluster_id": "cefafa9f-3780-4e29-9888-658635c4bf8a"
    },
    {
      "claim_cluster_id": "6d2a1320-d829-403b-913c-d7cdbf1cbf14",
      "event_cluster_id": "5ba8f9fd-9c3a-4fe9-8167-be994f757ac9"
    },
    {
      "claim_cluster_id": "4e71d535-1646-4ea5-9c47-04fb1464f390",
      "event_cluster_id": "2be461a2-6406-4213-9577-fc7e617af34f"
    },
    {
      "claim_cluster_id": "7659f671-e41e-464a-9184-a08b114b3636",
      "event_cluster_id": "f19998d7-da9d-4ad2-b0f0-03ca5c82143c"
    },
    {
      "claim_cluster_id": "c8d47411-ab85-4f96-b286-cd76451823f8",
      "event_cluster_id": "bcbfb3b5-386e-4a9d-9149-63379d147048"
    },
    {
      "claim_cluster_id": "09c923c5-0d10-40d6-8825-821711e43905",
      "event_cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff"
    },
    {
      "claim_cluster_id": "060a7355-d23c-448a-8514-2034a0d11495",
      "event_cluster_id": "75c9220d-327e-40e0-adbe-2a476a0c2f1a"
    },
    {
      "claim_cluster_id": "be023ca2-f865-4811-854e-b40ab442412b",
      "event_cluster_id": "8d692cd5-28be-4ffe-a181-b8bc827723ec"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "43605210-6be3-4d52-9b42-d4a4a1838ade",
      "event_cluster_id": "d5f197ec-3802-460d-9ad7-c43d150d3ad0"
    },
    {
      "claim_cluster_id": "5e128621-af42-4a93-b091-b4e768efec3b",
      "event_cluster_id": "03633b9c-b0d8-43dd-b075-5cdc7b02727e"
    },
    {
      "claim_cluster_id": "59e7addf-52f2-469c-800e-61bb55f3ed47",
      "event_cluster_id": "cd47012a-5cc7-45af-9355-7ba2b5b641a1"
    },
    {
      "claim_cluster_id": "65ea2c99-1a78-4321-b690-79dfaf78e443",
      "event_cluster_id": "5f916a06-e83a-45ea-99cd-e223f21451ed"
    },
    {
      "claim_cluster_id": "908a4168-b322-4057-a44b-a100dbffbe53",
      "event_cluster_id": "54e77970-df08-445b-a795-2987113391fb"
    },
    {
      "claim_cluster_id": "9d39778d-eb5c-4c0e-b35c-894a4378bc37",
      "event_cluster_id": "bd47afb3-5229-4410-873e-9a50752f0292"
    },
    {
      "claim_cluster_id": "ce659db6-9043-4f18-a410-39321ba5fd81",
      "event_cluster_id": "9be4b289-aaff-48fa-8680-b2813e6b1340"
    },
    {
      "claim_cluster_id": "61152334-8dda-42a2-bb8d-9fb770fd72f7",
      "event_cluster_id": "4cf126e0-d7f3-4437-b125-365b11c65d70"
    },
    {
      "claim_cluster_id": "29fe240a-81f6-4aef-a8b5-3cacf3e3985a",
      "event_cluster_id": "b02337c9-83ca-426b-b987-f46d1d19a244"
    },
    {
      "claim_cluster_id": "c9335a55-7c59-42cb-98be-e69b4262faa0",
      "event_cluster_id": "008cba92-e4d7-4655-90ad-12cb214fe197"
    },
    {
      "claim_cluster_id": "8a12011e-a6e7-4e73-a321-a39426ec3d34",
      "event_cluster_id": "7b1f2cfc-5328-4132-ac99-4d91818f60f6"
    },
    {
      "claim_cluster_id": "6f4632e9-24cc-42ed-87c9-747133ea5b31",
      "event_cluster_id": "b5dff88c-bd24-425a-aabb-6f3428e4297a"
    },
    {
      "claim_cluster_id": "1ef62c3d-3750-43b9-855b-d4624938de1e",
      "event_cluster_id": "628b9939-51f6-44a8-83a8-ac677a42d942"
    },
    {
      "claim_cluster_id": "99b20734-bb32-4aff-b60b-a976139937c2",
      "event_cluster_id": "b67dd1ae-27f1-42b9-ad69-ee83a298d216"
    },
    {
      "claim_cluster_id": "2cfb50e6-37ad-47a2-87b2-da1a9a512e46",
      "event_cluster_id": "0f6d8e28-a525-480c-9282-bbbd6890cc48"
    },
    {
      "claim_cluster_id": "ee877fbc-1f06-46ff-b006-7c974bc58cf1",
      "event_cluster_id": "bc899377-60fc-4a12-85cb-bbcd12759608"
    },
    {
      "claim_cluster_id": "1075443d-c097-4cb8-acb0-3d21f48f6aca",
      "event_cluster_id": "0a7daf16-3825-48ce-beb6-0161de293451"
    },
    {
      "claim_cluster_id": "c8265999-6e3a-4835-bb5a-9e081a27e9bd",
      "event_cluster_id": "319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"
    },
    {
      "claim_cluster_id": "5fbc247f-99df-408a-8188-29a28a5f5737",
      "event_cluster_id": "bbbc8b46-d558-43ec-8e55-d7d72928442c"
    },
    {
      "claim_cluster_id": "dd5764ad-ed57-4067-b6a4-35ca15790cc2",
      "event_cluster_id": "f5b1b3d0-19e5-49a1-bbc1-690d440e299c"
    },
    {
      "claim_cluster_id": "19b1602b-7236-4e52-b704-1442a85ad752",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "bc630aac-e921-4ad6-990d-40d804192d55",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "f997f1c7-5ae9-4bf5-bd1f-2f46bb8d4a16",
      "event_cluster_id": "726b06eb-9cb3-44bc-9105-8eb731155948"
    },
    {
      "claim_cluster_id": "6b38f355-a80e-4449-8c83-c5ac56d5a2e6",
      "event_cluster_id": "df30b460-1ef4-4fe2-86e2-8192bfc9613d"
    },
    {
      "claim_cluster_id": "1b8ba3f8-2b51-4433-9cf8-2a5412413277",
      "event_cluster_id": "6d514f4a-28a3-42c1-8a0f-d24931c265ce"
    },
    {
      "claim_cluster_id": "71de3f5e-7d6d-4a6a-b383-b96d1ee24b30",
      "event_cluster_id": "6cd94c1d-412f-4288-82d2-a9deb07dfbe3"
    },
    {
      "claim_cluster_id": "ad973751-acf4-4c7e-8032-3a95cf408206",
      "event_cluster_id": "98018dbb-a9a6-4b5d-b356-863340b24362"
    },
    {
      "claim_cluster_id": "f74a80e3-1327-4636-a252-f4ca8a5b90f7",
      "event_cluster_id": "face4903-290b-41c9-8ba8-d5aa2cfa2533"
    },
    {
      "claim_cluster_id": "1190ac87-5191-4e29-877a-253af15bb185",
      "event_cluster_id": "42899209-2504-48c5-8694-2bf64d4edf90"
    },
    {
      "claim_cluster_id": "d8704200-daac-4e95-873c-20cc39771b1c",
      "event_cluster_id": "cdf07443-9a3e-4b94-a668-1930f3a66029"
    },
    {
      "claim_cluster_id": "99dd456b-c805-4ebb-a82a-80fe2e06dff9",
      "event_cluster_id": "67cd7c4a-a6b3-4e11-9b6b-362422489e76"
    },
    {
      "claim_cluster_id": "719ee837-abdf-462d-a985-984d0a2eb167",
      "event_cluster_id": "d9484da0-ca3b-450a-a45c-787783bba3e7"
    },
    {
      "claim_cluster_id": "d20d47b3-a32a-48d4-a8d3-2dd3f07fe8a9",
      "event_cluster_id": "18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"
    },
    {
      "claim_cluster_id": "b54d16d2-d5db-4746-b15a-e8c01d4fc586",
      "event_cluster_id": "95bc2531-eabc-48ae-aefe-417173f45673"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "115eeed7-4973-4efa-aa32-369a2056fa21"
    },
    {
      "claim_cluster_id": "f401d633-0e2b-4935-b7d9-1761c201c058",
      "event_cluster_id": "b8d20c5e-c322-4b49-99bf-b717fffef7d5"
    },
    {
      "claim_cluster_id": "4b037322-86a6-4af9-bfe1-49f968f04baf",
      "event_cluster_id": "a0d901e6-2e0f-43fd-9d25-7b092459f36d"
    },
    {
      "claim_cluster_id": "6bdcff96-571d-4879-91a7-d6084340625f",
      "event_cluster_id": "37b0238b-c658-4977-a22b-36f3d3dc6e36"
    },
    {
      "claim_cluster_id": "7386324d-4730-4b17-8d70-6b33d62d5be3",
      "event_cluster_id": "94b0a214-1e60-4bbb-96cf-031169c35247"
    },
    {
      "claim_cluster_id": "2edb056a-640a-40d9-89e2-36dbc25022b5",
      "event_cluster_id": "dbb1fd32-5705-43e8-a68b-a90c6757768a"
    },
    {
      "claim_cluster_id": "58953090-5955-480d-95b2-311ed2c0f653",
      "event_cluster_id": "143fdbe0-b8f7-4368-95d7-a7983691aac9"
    },
    {
      "claim_cluster_id": "cf8a7c88-fcb8-4b8d-aadb-46cb3168db25",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "481b0645-4bcd-4df1-ae15-b184375e551e",
      "event_cluster_id": "2913b0c9-ef79-4e98-9ca0-9e5e2abf9938"
    },
    {
      "claim_cluster_id": "86160f22-53c1-4e04-a28d-86c0e883fa44",
      "event_cluster_id": "c7b0f267-0192-4ba8-86e6-09f6ba274d4f"
    },
    {
      "claim_cluster_id": "3e505b9a-116f-472b-bc43-8ee1a23943f5",
      "event_cluster_id": "0affe3d3-ec5f-48dc-87ba-10392622a134"
    },
    {
      "claim_cluster_id": "f10ad797-ad79-4629-861d-4af809502a09",
      "event_cluster_id": "a400da3f-ddc6-4851-b855-065d3f101c71"
    },
    {
      "claim_cluster_id": "dfa7b9d2-5920-4d57-8445-e48ac5ce73da",
      "event_cluster_id": "fe283f5f-5575-4095-b65a-cb6fe0d25e44"
    },
    {
      "claim_cluster_id": "e9fd964c-939f-481a-a2ad-a6d738a01a81",
      "event_cluster_id": "87f027a4-571d-4212-8e96-6f46fe317fc0"
    },
    {
      "claim_cluster_id": "536df2e4-b955-48b2-8a3c-5b06a58c9d87",
      "event_cluster_id": "72ff31f6-b46f-456b-85ee-5ab8c2328972"
    },
    {
      "claim_cluster_id": "d0619b32-28c7-4624-9e6b-8c81d9ff9019",
      "event_cluster_id": "8e8e8bbd-6670-4f01-810a-e901866d96f8"
    },
    {
      "claim_cluster_id": "f4de84ae-8f6f-4a0d-afb7-35839203b010",
      "event_cluster_id": "a7e57243-5f25-4292-b208-646cbc973faf"
    },
    {
      "claim_cluster_id": "e0d82e7e-dd46-4e81-a408-b1cd11385d33",
      "event_cluster_id": "e0d1bce3-3239-47f8-946e-5937659f6c85"
    },
    {
      "claim_cluster_id": "3d986dc9-6edc-4a4e-9783-63b1c5e7bcd8",
      "event_cluster_id": "220dfe6b-2774-4a8a-8306-3094dfce156d"
    },
    {
      "claim_cluster_id": "6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4",
      "event_cluster_id": "f9f83549-19b2-4c63-8024-bec6ccd4b48e"
    },
    {
      "claim_cluster_id": "9bf70381-221f-4cfd-8e17-16f9ebb35e36",
      "event_cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965"
    },
    {
      "claim_cluster_id": "d14315a8-aa93-4c64-a42e-a4307dd0814a",
      "event_cluster_id": "bc4c213d-8b78-447a-9835-0a8c9c8149b1"
    },
    {
      "claim_cluster_id": "5ece0141-8dd6-405b-93cf-5585050f4efe",
      "event_cluster_id": "4a1b2728-75a5-43bc-8278-ab49e8c8c004"
    },
    {
      "claim_cluster_id": "763dcb28-8161-4ef1-bcee-20cbd6af7670",
      "event_cluster_id": "0e7e5665-e1ba-44c9-b9e8-62d3501bb81c"
    },
    {
      "claim_cluster_id": "ed1b332b-c054-4114-82a1-1e645946747e",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "20e0f6a7-71df-44b4-b99e-3e278ca655e8",
      "event_cluster_id": "019a6206-d313-408e-aa7d-dd9ebfe68ec1"
    },
    {
      "claim_cluster_id": "5900a7ab-7cb4-45d4-8807-d20dee337670",
      "event_cluster_id": "d53ff534-a3d7-4ffa-9823-7bc6114763e7"
    },
    {
      "claim_cluster_id": "36472627-9945-496e-89a2-063ceee22d24",
      "event_cluster_id": "0555403d-91c7-40d0-bf24-c9c0415e9ad9"
    },
    {
      "claim_cluster_id": "721fca95-63af-4a1d-bae5-70b55fce9a8b",
      "event_cluster_id": "471e4e9c-4ca9-4ee9-ad65-9f3b0fd313ec"
    },
    {
      "claim_cluster_id": "3dc82114-c98e-4342-a6ab-854d95d9efa7",
      "event_cluster_id": "2bfeada4-b9e0-40b4-9be2-0655b8d49226"
    },
    {
      "claim_cluster_id": "b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10",
      "event_cluster_id": "08ccb8f3-d97c-4442-b830-fac7f751221a"
    },
    {
      "claim_cluster_id": "558484b7-ac90-44c3-8eec-a2f364ca9460",
      "event_cluster_id": "7b1f2cfc-5328-4132-ac99-4d91818f60f6"
    },
    {
      "claim_cluster_id": "fe684e64-4226-4567-8e1f-5613fae2c8f8",
      "event_cluster_id": "0d5de813-beee-4fba-8db1-09461ff50d02"
    },
    {
      "claim_cluster_id": "eb6a12b4-268e-4e39-8d84-ba73d40a7ffd",
      "event_cluster_id": "157ed6bf-eaaa-4513-ad02-a2a99adf039a"
    },
    {
      "claim_cluster_id": "9be5c43d-4ef1-465d-bdbc-ed35d95c0689",
      "event_cluster_id": "27baa662-c27a-403b-9e47-b67e42c90e29"
    },
    {
      "claim_cluster_id": "f3b06c88-86f6-4833-89c1-f778a2910669",
      "event_cluster_id": "3d3c026b-80c1-4334-84d1-db19f80712b4"
    },
    {
      "claim_cluster_id": "8f4c47af-fb0d-428c-b422-7767f77bc38d",
      "event_cluster_id": "eebdc162-9389-4ba5-ae4d-d971d7acc73a"
    },
    {
      "claim_cluster_id": "7bfb1246-c004-4c78-a34d-8e0a5cdad287",
      "event_cluster_id": "58d84750-75e5-4a06-9053-f1a5a8baf564"
    },
    {
      "claim_cluster_id": "3d9f2bb4-f1d6-41ac-be1a-ac1194130144",
      "event_cluster_id": "450543ae-8630-4e48-a375-9699e4cb6925"
    },
    {
      "claim_cluster_id": "f1f9481a-c3b7-4912-be82-d974b52e8f30",
      "event_cluster_id": "ed866655-8d58-43f9-93ba-c498e1783c16"
    },
    {
      "claim_cluster_id": "ec613890-df43-48e8-bf2a-a40ccb263efc",
      "event_cluster_id": "7b20021b-470c-46f3-841f-c47d4c52551f"
    },
    {
      "claim_cluster_id": "9314aa75-84de-490c-95e7-6484ecdba212",
      "event_cluster_id": "45a08904-45fb-4937-aec9-3d713915195b"
    },
    {
      "claim_cluster_id": "1c703565-77f6-4eda-962e-77ec869d886d",
      "event_cluster_id": "4b2686df-f0ed-4fbd-b1c1-475a6406601a"
    },
    {
      "claim_cluster_id": "6f9b01a7-d717-4ce1-bd54-f5647d476287",
      "event_cluster_id": "0f1dfea7-22b4-4df1-ad86-305165ef36ec"
    },
    {
      "claim_cluster_id": "108c6941-b645-4904-86a8-cfa0fa34274e",
      "event_cluster_id": "acda69bd-2a78-45aa-a6fc-5eeaa0b45f28"
    },
    {
      "claim_cluster_id": "fec0d44e-dff3-4478-9317-1b1d954f03c6",
      "event_cluster_id": "720ca61f-9942-490c-ab91-755d5a979ee2"
    },
    {
      "claim_cluster_id": "4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1",
      "event_cluster_id": "2b56b1f6-1627-44ab-9460-b13751cf087b"
    },
    {
      "claim_cluster_id": "837dbefb-7b54-4aa1-aad3-56f0ea97f9ed",
      "event_cluster_id": "b560200c-3172-4ff5-9c7f-410b8ee34d25"
    },
    {
      "claim_cluster_id": "69fa7886-741a-440f-8a20-2b9ce60729ac",
      "event_cluster_id": "a1395f05-6f91-4eca-a911-53f15292db71"
    },
    {
      "claim_cluster_id": "ea54647f-e4a4-46e7-bf16-66e30583a4a6",
      "event_cluster_id": "442786eb-7f1c-4cbe-a22b-05ba612dc67d"
    },
    {
      "claim_cluster_id": "61fe3afa-76aa-4838-9dd9-a22a879ae31e",
      "event_cluster_id": "9a157342-1d61-41a4-92fb-020ea95697bc"
    },
    {
      "claim_cluster_id": "d9366872-6ca9-49e5-9e80-86c5b954d463",
      "event_cluster_id": "1919a927-7052-4719-83c2-7118a15e11e3"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "80b309de-fa0b-4abc-ace4-5a54f5c02331"
    },
    {
      "claim_cluster_id": "639596e6-4b0c-464a-9fa5-8272920e87b4",
      "event_cluster_id": "77081589-555b-43cf-8723-b50b060cc231"
    },
    {
      "claim_cluster_id": "c8265999-6e3a-4835-bb5a-9e081a27e9bd",
      "event_cluster_id": "197e7b6e-783a-4813-926e-57380c838db7"
    },
    {
      "claim_cluster_id": "29469bb2-a496-413c-802b-5a8d1b46d374",
      "event_cluster_id": "96c05405-04cf-48e3-824b-2a96332d38b7"
    },
    {
      "claim_cluster_id": "19ef8fca-6a45-4387-be0d-efc3fd245b80",
      "event_cluster_id": "701985dd-4322-488f-8c88-ea50b9053ab8"
    },
    {
      "claim_cluster_id": "0c265597-6c2b-4efe-9acb-799f67a3b4d1",
      "event_cluster_id": "1257662d-03bb-4192-9e0e-d0d2bb753848"
    },
    {
      "claim_cluster_id": "c51e0b3e-03c3-4464-95af-a00db4b0bdd2",
      "event_cluster_id": "e47fcd0d-6eef-4992-8b24-a772ebce5f31"
    },
    {
      "claim_cluster_id": "4fe899cb-f73e-4ec7-b569-5ce5b990df8e",
      "event_cluster_id": "5d6331d6-8b39-45dc-b069-c03168d82aac"
    },
    {
      "claim_cluster_id": "294d0346-cddf-4b1e-a6bc-ab4686137712",
      "event_cluster_id": "602ccd3f-b2b7-474a-9029-74260beb7902"
    },
    {
      "claim_cluster_id": "3a5853fd-eaf4-497d-b7fc-b13a9208544c",
      "event_cluster_id": "0040fc97-03df-421f-96ac-2c09e7b8a54f"
    },
    {
      "claim_cluster_id": "2567422d-b366-451c-a271-4cb76dc8196c",
      "event_cluster_id": "456f0f19-c43e-4805-a01d-f15d26323d29"
    },
    {
      "claim_cluster_id": "df17d3e5-8709-4518-a32e-ebe9d39b417e",
      "event_cluster_id": "3803cd19-3379-4dcf-8227-17e8e94b50a8"
    },
    {
      "claim_cluster_id": "ddd4b5a0-2eee-4ff9-bb50-de940c2541e2",
      "event_cluster_id": "0fd43dca-76e2-435e-9091-21e203301fc4"
    },
    {
      "claim_cluster_id": "2c49dd92-a97e-4b1e-bac2-607670a0a86d",
      "event_cluster_id": "c24c8055-1228-411e-82e6-d5cc151796a6"
    },
    {
      "claim_cluster_id": "a3c357ac-5159-4eec-ad16-09366a144d09",
      "event_cluster_id": "21d331a6-d043-465d-88ff-572098f9f48c"
    },
    {
      "claim_cluster_id": "abd83725-20da-4a40-a5cf-bb6715d5460b",
      "event_cluster_id": "dbcfd453-3fcc-4846-b99a-9b5de23fde7a"
    },
    {
      "claim_cluster_id": "94f243ab-1521-4874-b5fc-b80847a7fefc",
      "event_cluster_id": "62ebe72f-55b5-4dca-b8c6-cb9ed5b82c24"
    },
    {
      "claim_cluster_id": "f8cc40a9-e215-46da-bdf5-b5efc622bb40",
      "event_cluster_id": "a5d008c6-c15a-4302-aa70-e916c52f5451"
    },
    {
      "claim_cluster_id": "a0d6a00c-f05d-49fd-9f81-54bc418a2aec",
      "event_cluster_id": "ccd825e8-99a9-452b-8ea7-e5e98518daca"
    },
    {
      "claim_cluster_id": "f401d633-0e2b-4935-b7d9-1761c201c058",
      "event_cluster_id": "10698f29-8fe6-47a6-b30e-e5ff5dcfea6b"
    },
    {
      "claim_cluster_id": "58a44cd6-3f44-4460-9d07-d5a28bd55747",
      "event_cluster_id": "771e3903-1d96-4871-b3f7-ccc8c72d8493"
    },
    {
      "claim_cluster_id": "8a4b9d30-600b-48dd-9a32-934835947825",
      "event_cluster_id": "3e8cbb71-09f5-4d7a-9358-2ef082adc4f1"
    },
    {
      "claim_cluster_id": "2c7cf7ec-47d1-4b9e-8095-5a313fd3166e",
      "event_cluster_id": "66fb628f-853d-44dd-b0f9-617fd67bcaf1"
    },
    {
      "claim_cluster_id": "e0b3b058-f41a-4ebc-b9bd-9e20a141c340",
      "event_cluster_id": "83c0c29b-58c8-41f0-80a2-462fee4f58ed"
    },
    {
      "claim_cluster_id": "b8a67936-c036-4a45-8680-bb4909cdd3db",
      "event_cluster_id": "6b198d6b-8dea-4096-80f2-e19aa989c1d0"
    },
    {
      "claim_cluster_id": "71de3f5e-7d6d-4a6a-b383-b96d1ee24b30",
      "event_cluster_id": "9ef9723e-224d-4c57-9d96-bcf1933702af"
    },
    {
      "claim_cluster_id": "4cc6a578-5e10-41d7-a578-fba88da2dc13",
      "event_cluster_id": "1b8d5ce9-1627-406b-ad77-075419ad3508"
    },
    {
      "claim_cluster_id": "1a689731-c588-4661-b0b5-8beb94a95bb4",
      "event_cluster_id": "9997ff9b-fea6-429f-b5df-1f0640f5b200"
    },
    {
      "claim_cluster_id": "f68dc41c-3947-416c-8f93-49c606c24bd2",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "4a817862-6fa5-4e7c-8998-977aaad70250",
      "event_cluster_id": "efde2814-71d1-4a0e-959d-1e37c60dd501"
    },
    {
      "claim_cluster_id": "1469928a-aef7-459b-af14-6d6ac0ca72d3",
      "event_cluster_id": "4b36afdb-64c0-4dfe-8f4d-501930c59107"
    },
    {
      "claim_cluster_id": "0653516b-f642-4236-857e-3f4989809104",
      "event_cluster_id": "7f22f643-051f-4c46-8fa4-209f55a6aff1"
    },
    {
      "claim_cluster_id": "c7e21d17-7b1c-44ba-9b2b-db5a38de4e97",
      "event_cluster_id": "86a99b16-df58-43a2-b7eb-e1d03c6f6e5e"
    },
    {
      "claim_cluster_id": "4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8",
      "event_cluster_id": "eea04632-7eb6-45a8-afd1-95556afba561"
    },
    {
      "claim_cluster_id": "df0cd74b-d230-4260-9a29-b0bc91923404",
      "event_cluster_id": "25a859f3-e205-44d1-b703-8d1e9921d967"
    },
    {
      "claim_cluster_id": "43d1e3ac-04ef-4f83-99ee-76241c79a7a0",
      "event_cluster_id": "ed2f46ec-4300-4232-969b-86017e6c6546"
    },
    {
      "claim_cluster_id": "1a689731-c588-4661-b0b5-8beb94a95bb4",
      "event_cluster_id": "48881067-b084-4793-b8c7-6423be69c261"
    },
    {
      "claim_cluster_id": "84900de4-4822-40e2-a41f-f9013bcc0bbe",
      "event_cluster_id": "637cde7e-0523-4cfc-a2d0-d5916b669833"
    },
    {
      "claim_cluster_id": "44d600b5-1259-4b0f-a45c-73f5507156e1",
      "event_cluster_id": "f1adf470-c92b-4dc8-8ffc-81d2f8af3978"
    },
    {
      "claim_cluster_id": "310f4e19-f7f5-403e-af6f-b2064fadd246",
      "event_cluster_id": "53fc6234-d563-426d-a3bc-ba15edc6f530"
    },
    {
      "claim_cluster_id": "a604694d-4fcd-48e0-a074-6eaa09488a89",
      "event_cluster_id": "82c2fba9-344c-4253-9cf5-a05ec938a8a6"
    },
    {
      "claim_cluster_id": "4f68034e-7758-4136-94fe-82331ab7df47",
      "event_cluster_id": "913d6094-0602-4c9d-90e4-9e574b9a8080"
    },
    {
      "claim_cluster_id": "9920b872-a377-485c-97d1-65b98d038806",
      "event_cluster_id": "75fbf587-2351-400e-b397-a778510d68fc"
    },
    {
      "claim_cluster_id": "9d39778d-eb5c-4c0e-b35c-894a4378bc37",
      "event_cluster_id": "9dcce4d2-ce6e-4b1e-a8f5-c853370fae54"
    },
    {
      "claim_cluster_id": "e7e80c41-a749-4b0c-a666-715bedd44f52",
      "event_cluster_id": "9f25d197-8ec1-4d18-aeda-b095d1997826"
    },
    {
      "claim_cluster_id": "94599b0f-3332-46af-911a-e0ea949079dd",
      "event_cluster_id": "b223bdd2-4e37-4cb0-a50b-feb184bdfe78"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "c89da02e-a1bc-4522-a452-82abf8c705c4"
    },
    {
      "claim_cluster_id": "199ae7ec-217a-4cab-a030-ff0a4838c0a8",
      "event_cluster_id": "a4eff04d-c7b6-4d4f-a9de-6ac6a11bad77"
    },
    {
      "claim_cluster_id": "175bdcd7-0fff-45d5-9e67-f78e69286a6f",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "ff26fc04-79ea-483a-b7fa-30217f23ef0c",
      "event_cluster_id": "7af9dd75-d833-4cd3-b3d8-08e6c743ac05"
    },
    {
      "claim_cluster_id": "2d7a7088-3ced-40a0-9677-1d14e1c26d8f",
      "event_cluster_id": "a4004e95-5738-4a9f-9ef9-273901538db0"
    },
    {
      "claim_cluster_id": "1c30353a-a7dc-48dd-bca2-56c91aa06ab6",
      "event_cluster_id": "e8306f6c-1fb0-441e-9dd5-57929514dcf5"
    },
    {
      "claim_cluster_id": "910b6c18-44e1-4b51-b616-1f6016486c69",
      "event_cluster_id": "b1dcb694-6efc-4b22-9bc7-9254eb290f7d"
    },
    {
      "claim_cluster_id": "d87f03ea-124e-4e30-80f4-ce890ca4d97b",
      "event_cluster_id": "cb033bf6-f8da-46c0-a5e0-962c48c82ad6"
    },
    {
      "claim_cluster_id": "80a02b1a-c045-453f-ad92-9681e40dad83",
      "event_cluster_id": "e3403237-7c1c-4e7a-9604-df8d11301d8d"
    },
    {
      "claim_cluster_id": "d0619b32-28c7-4624-9e6b-8c81d9ff9019",
      "event_cluster_id": "15d3bc51-86b6-41c4-8d7b-a993e63544da"
    },
    {
      "claim_cluster_id": "d2c2f402-f56b-4dfa-98d3-daf63239156d",
      "event_cluster_id": "902e4c1f-ffd6-4a43-b284-14e627b17668"
    },
    {
      "claim_cluster_id": "bd4c7f11-9866-4656-98e3-7341cfc6de34",
      "event_cluster_id": "f3b3f1d2-6fee-4073-8509-60422ce0c24d"
    },
    {
      "claim_cluster_id": "23adc402-b3b7-489f-bbe8-5d7825946d77",
      "event_cluster_id": "227678ba-993d-4003-9922-aa2e2a27ca74"
    },
    {
      "claim_cluster_id": "88ebdccc-4a31-4f1b-a74f-989ab096e08f",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "0e8e4003-b007-4df8-a1a5-948e64fe6342",
      "event_cluster_id": "d7765332-5dba-4716-b432-1311de3172a6"
    },
    {
      "claim_cluster_id": "6910074e-7bb8-4a4e-9f37-3e335d1a57a0",
      "event_cluster_id": "7c56640a-84bf-48d1-9c5b-b22b665dd6a8"
    },
    {
      "claim_cluster_id": "416e4c1e-869b-468f-91eb-bba4fac5108a",
      "event_cluster_id": "d3c9a36a-e9bd-4eb9-ae98-c8503d7abb49"
    },
    {
      "claim_cluster_id": "d96c8f5c-4bb9-48ae-8d6d-0625e7b9a576",
      "event_cluster_id": "ed866655-8d58-43f9-93ba-c498e1783c16"
    },
    {
      "claim_cluster_id": "b39ca7cb-8663-4bff-829b-b432d59670f9",
      "event_cluster_id": "a4bee492-f45a-4aa3-94d5-709bdbcd2d39"
    },
    {
      "claim_cluster_id": "612e00dc-099b-40a4-b39a-4b7adbab73ce",
      "event_cluster_id": "4dc1a0fa-5313-4a33-a001-984da53ababb"
    },
    {
      "claim_cluster_id": "73fff1e2-bc77-421c-8436-e9bf094a9733",
      "event_cluster_id": "98ea14c4-be20-4ab3-b8a0-74207d1ea94c"
    },
    {
      "claim_cluster_id": "8a12011e-a6e7-4e73-a321-a39426ec3d34",
      "event_cluster_id": "6dc5280e-6875-44c0-adc9-079542d2d0b2"
    },
    {
      "claim_cluster_id": "4c95b4a9-d005-4c7c-8a55-a5a0821d7611",
      "event_cluster_id": "8f06b71d-e458-4241-be0b-c89c223296af"
    },
    {
      "claim_cluster_id": "b43b3e32-d544-43ad-b781-20a883c7f4b7",
      "event_cluster_id": "ad1bfd32-94c7-4e45-b536-bb4b7ea9411e"
    },
    {
      "claim_cluster_id": "6a54c6d4-9e49-450e-95c4-f3afc0f85f6c",
      "event_cluster_id": "4a483622-b245-4e23-bd10-793b05ae9fe2"
    },
    {
      "claim_cluster_id": "bc630aac-e921-4ad6-990d-40d804192d55",
      "event_cluster_id": "93b80413-3a5d-432a-887d-e727cb82d2f6"
    },
    {
      "claim_cluster_id": "14a92521-0601-421b-b904-3fc9a965cbb6",
      "event_cluster_id": "867afc59-5780-42ae-88e7-83c90a074b4d"
    },
    {
      "claim_cluster_id": "226ceb68-980d-4b72-b053-36c7b5c7f61b",
      "event_cluster_id": "43efd020-0d45-4101-9278-ea22329dba55"
    },
    {
      "claim_cluster_id": "40460222-6c35-47b7-be68-29a1138ce819",
      "event_cluster_id": "b866ed85-f7f0-43c6-a093-04cf15808999"
    },
    {
      "claim_cluster_id": "f2df1c45-9507-438e-92d8-0a523b9a842a",
      "event_cluster_id": "18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"
    },
    {
      "claim_cluster_id": "42314335-3518-45c0-909b-96111c0955f6",
      "event_cluster_id": "450543ae-8630-4e48-a375-9699e4cb6925"
    },
    {
      "claim_cluster_id": "0af113aa-da9f-4ed6-a163-dcb48f1459ee",
      "event_cluster_id": "f3afa262-5d02-4bc0-8506-783a0bf09d56"
    },
    {
      "claim_cluster_id": "1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080",
      "event_cluster_id": "4a20b107-b497-42c8-8807-874212cad7e3"
    },
    {
      "claim_cluster_id": "64de7b14-ea9c-48fe-a9a0-a30f01aecc3e",
      "event_cluster_id": "429b9019-55ed-4d53-b962-21e416686d27"
    },
    {
      "claim_cluster_id": "0eef7600-1d71-4d26-9e91-3c6e5b0c6121",
      "event_cluster_id": "d28e35dd-84d1-4e21-9131-912aee49eabd"
    },
    {
      "claim_cluster_id": "68142908-c71d-4106-9ef3-2de00198c72e",
      "event_cluster_id": "71e63580-38d2-43b7-a5b4-b06b93f3b79d"
    },
    {
      "claim_cluster_id": "b9e4bfc6-c83b-47ab-95a9-d3b6db015c07",
      "event_cluster_id": "182dd0dd-1319-4405-9396-03bc211809ae"
    },
    {
      "claim_cluster_id": "e2676bcb-4f6e-4d98-ba58-3d2aff04d940",
      "event_cluster_id": "2c113efd-6d03-4fd4-9d94-78125d3c286d"
    },
    {
      "claim_cluster_id": "80112f8c-1c78-451e-98a6-361d1ea1a9d4",
      "event_cluster_id": "80c21daf-780b-4d61-a882-6319319c019e"
    },
    {
      "claim_cluster_id": "758d6034-7d93-4286-ae2b-f2ffde861da6",
      "event_cluster_id": "093f494f-e108-4f07-9dbc-35136554407c"
    },
    {
      "claim_cluster_id": "8b44daa7-629e-4db8-81b7-5ed88669eb86",
      "event_cluster_id": "a4ef4316-1b40-4ce1-b5cc-ef7ada4c3a2e"
    },
    {
      "claim_cluster_id": "a3a8e335-b1fe-4cbe-b6f9-626c39d5f0dd",
      "event_cluster_id": "dd94c024-2472-482f-808f-4c85cd16b4f9"
    },
    {
      "claim_cluster_id": "47085082-7091-436e-a3ee-ecf14c90e1a5",
      "event_cluster_id": "f6908b42-dc9a-453f-aa2c-203da06764cf"
    },
    {
      "claim_cluster_id": "99fbb991-8bc1-4254-9fff-a2ac5c926685",
      "event_cluster_id": "ab42726c-f378-41dc-98e2-0ce10f9d6d07"
    },
    {
      "claim_cluster_id": "7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1",
      "event_cluster_id": "304159c4-71dd-47fa-8097-c06173508250"
    },
    {
      "claim_cluster_id": "9920b872-a377-485c-97d1-65b98d038806",
      "event_cluster_id": "2197b0cf-d748-489f-aa22-936ee02a0c14"
    },
    {
      "claim_cluster_id": "563140da-8f58-4b64-8987-47bb018b6821",
      "event_cluster_id": "a0499a4f-f80f-4f0b-ab10-3a54901c48a4"
    },
    {
      "claim_cluster_id": "bbad87a2-fdaf-4bdc-9b37-124a381131af",
      "event_cluster_id": "92dc2b29-cee7-4ea1-b9e9-d0593544c75b"
    },
    {
      "claim_cluster_id": "daf13a88-450f-40a7-bca6-ccfb46ede159",
      "event_cluster_id": "90811b8e-940b-4a7b-bb43-2f0cfe36a594"
    },
    {
      "claim_cluster_id": "702a4627-2eae-451d-b2a9-154358319e24",
      "event_cluster_id": "42aaef22-3993-4ed5-8477-0e78fe2789f9"
    },
    {
      "claim_cluster_id": "99dfb4e4-9788-4ea5-81a7-c0dd44f60aba",
      "event_cluster_id": "19226ea8-73b8-405a-ba2e-087cba3fab92"
    },
    {
      "claim_cluster_id": "eb2ba8af-f927-478b-bc26-2105bdb87c5f",
      "event_cluster_id": "b87e7ed0-8014-419f-b604-584f2337b651"
    },
    {
      "claim_cluster_id": "0fa9f6d7-64f6-4933-aae8-3cfd512cab5c",
      "event_cluster_id": "7763c9f8-5bc5-4b00-83e7-8687863ffb36"
    },
    {
      "claim_cluster_id": "d30cdd9d-92e1-44ac-aad9-845702e1559f",
      "event_cluster_id": "27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"
    },
    {
      "claim_cluster_id": "bbc8c147-b447-4af6-82fb-e416f6108e70",
      "event_cluster_id": "dbf1c410-0096-4098-84d3-5c9270d536df"
    },
    {
      "claim_cluster_id": "6967755e-61e4-4308-be97-cdea95a155c7",
      "event_cluster_id": "bf33acab-5a50-4871-8114-2bad5bcedb80"
    },
    {
      "claim_cluster_id": "e5736d52-6864-4a19-aa95-57d6bbe8f40d",
      "event_cluster_id": "45319dcb-5d0b-4d01-90b1-03022e3ef700"
    },
    {
      "claim_cluster_id": "3f09a0f3-521e-4c59-84d0-5adbf02dbf98",
      "event_cluster_id": "9c2eabc6-f74c-4f84-b44d-2de93cf844a7"
    },
    {
      "claim_cluster_id": "6e99d559-c095-46a1-a671-2a3d2e8566bb",
      "event_cluster_id": "2490cd6a-465d-4de9-bada-79c6b3ffed26"
    },
    {
      "claim_cluster_id": "36f68109-962e-490e-9101-85d84c5de66a",
      "event_cluster_id": "921c5a51-cef0-491b-8b5f-a5f05c5b785f"
    },
    {
      "claim_cluster_id": "d2c2f402-f56b-4dfa-98d3-daf63239156d",
      "event_cluster_id": "4b43ecc5-2325-49de-80fb-8c71f498b44d"
    },
    {
      "claim_cluster_id": "a44bb3c4-918e-4230-8542-c0aebafed121",
      "event_cluster_id": "10142c53-0aae-468e-a5f8-9d5313be2cf3"
    },
    {
      "claim_cluster_id": "8cb0435b-3218-46a5-88b4-47481d4dee85",
      "event_cluster_id": "ae6a51a8-019c-4d5d-a0b6-079828d681e6"
    },
    {
      "claim_cluster_id": "42fd849e-0fa9-43a8-b5fa-5cc192351c79",
      "event_cluster_id": "90594f77-57da-4d80-a85e-ef6c61b0cc03"
    },
    {
      "claim_cluster_id": "a55a36be-0edb-44d4-8400-10d53525802c",
      "event_cluster_id": "4b50f48f-0dd4-4d51-a40b-e932902a32fc"
    },
    {
      "claim_cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "event_cluster_id": "af431814-360b-4c41-83d1-6147d4068846"
    },
    {
      "claim_cluster_id": "b7190356-8b3c-4107-b9f7-680aa8b73b90",
      "event_cluster_id": "2d92a79a-ce61-4af0-b8af-8322336cee3b"
    },
    {
      "claim_cluster_id": "ce28dc91-d0be-44b8-b551-17c831f9e07e",
      "event_cluster_id": "4468d3e5-ac94-44c3-a0b1-a59798ce1b28"
    },
    {
      "claim_cluster_id": "d87f03ea-124e-4e30-80f4-ce890ca4d97b",
      "event_cluster_id": "3595c0cd-b164-431e-b192-61bc7dc0019f"
    },
    {
      "claim_cluster_id": "2c44608d-8e33-4f88-ad5e-7e4885719e31",
      "event_cluster_id": "9a22d933-5b51-4f1a-93f6-12dfd9a6f37a"
    },
    {
      "claim_cluster_id": "ad973751-acf4-4c7e-8032-3a95cf408206",
      "event_cluster_id": "cf92f2d9-5ad3-4f3b-877f-c3c333e4eaa6"
    },
    {
      "claim_cluster_id": "fd127341-6938-4e10-8b5d-771537846e8c",
      "event_cluster_id": "916a8c6f-5ca2-4b3a-b949-ca57daf6bb56"
    },
    {
      "claim_cluster_id": "a39bfc74-5364-4583-b4c6-2ba30e1ddbf9",
      "event_cluster_id": "6aefa1fe-d0f8-4db4-8968-8fa277506a8b"
    },
    {
      "claim_cluster_id": "de60bb28-4ca7-441f-814b-f2ecfe29fb54",
      "event_cluster_id": "e1a7ebff-5254-4bd5-a3d1-966b6a60cd7e"
    },
    {
      "claim_cluster_id": "1c24dadf-70dd-4f00-84a1-ba00a5d442c5",
      "event_cluster_id": "d7895c1b-fc75-4aef-87f4-799e18058cdf"
    },
    {
      "claim_cluster_id": "77119585-efc9-469f-8988-fdb1e15681f0",
      "event_cluster_id": "79cd6f65-ee4d-4695-8b9a-e4b8c86c1536"
    },
    {
      "claim_cluster_id": "9747ef56-b31a-4050-8bc2-6df45c0ffbd7",
      "event_cluster_id": "cfc085d7-3aee-4121-81f4-5053e011112c"
    },
    {
      "claim_cluster_id": "d43a588c-20a7-4ed9-8abb-37e05290fde6",
      "event_cluster_id": "acb8c5a5-3818-4898-ace2-3330d0f18d6b"
    },
    {
      "claim_cluster_id": "b398f217-24d9-4c22-8d5a-732320853c1b",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "09c923c5-0d10-40d6-8825-821711e43905",
      "event_cluster_id": "2e96e776-35fc-4f23-940d-ba30ac558d05"
    },
    {
      "claim_cluster_id": "c80e0125-43dd-49de-bff5-42885acf8ee9",
      "event_cluster_id": "a954b16a-c601-4ed1-9990-0dca57e0a58e"
    },
    {
      "claim_cluster_id": "a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05",
      "event_cluster_id": "f1749a30-d414-494e-8542-2f37dca2357f"
    },
    {
      "claim_cluster_id": "b1da162a-fb28-4547-8fd8-715c5361b7af",
      "event_cluster_id": "8cad6289-2663-4a76-816f-85ae55214831"
    },
    {
      "claim_cluster_id": "5e3e9898-c954-4e10-be52-6e36f5b36c5c",
      "event_cluster_id": "113ba3fc-f5c7-4177-8c57-e763c91f7e2c"
    },
    {
      "claim_cluster_id": "8b8d3259-7bca-4683-902c-7b72552f88ab",
      "event_cluster_id": "dd605b4d-33b6-43de-a73f-acf3e8834d88"
    },
    {
      "claim_cluster_id": "ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6",
      "event_cluster_id": "3800fecc-81a4-49e4-a7cc-dc527d4bd612"
    },
    {
      "claim_cluster_id": "9c5c6743-3894-4e82-b69e-bc4e0c19f869",
      "event_cluster_id": "e53b1b9b-ff90-4db8-bc8b-211c3b969cce"
    },
    {
      "claim_cluster_id": "7eddd539-ebe9-47f6-b0c9-dd9f02f0c8a0",
      "event_cluster_id": "d0fe7b5d-26f1-4baf-86ca-16d7441119ce"
    },
    {
      "claim_cluster_id": "5e767ae7-5475-4d58-9919-b74b88492c8d",
      "event_cluster_id": "86faa30d-3051-4174-a28e-c3bb4b4beacf"
    },
    {
      "claim_cluster_id": "64de434e-21f8-43c2-9395-33dcf3b86c3d",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "902f069d-3703-489a-9dfa-fb26ee837027",
      "event_cluster_id": "994afb12-0656-46cd-8fc2-48a9ab17ddc7"
    },
    {
      "claim_cluster_id": "01c08614-0081-4fbf-86e8-a41b845bc4f5",
      "event_cluster_id": "0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3"
    },
    {
      "claim_cluster_id": "e03ac9ce-f105-49c9-9a2f-9442b3b31044",
      "event_cluster_id": "cd9e4a57-55ca-4538-9460-c81e764492cc"
    },
    {
      "claim_cluster_id": "59b8d1fe-1725-4325-a7c8-5abd450e3124",
      "event_cluster_id": "07499aa1-3238-4e4d-b838-020f0a58eb63"
    },
    {
      "claim_cluster_id": "16b63ffa-da4e-4cff-8fab-fffc1644a634",
      "event_cluster_id": "5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"
    },
    {
      "claim_cluster_id": "13a07f14-45d6-4b31-8d23-23b540ac8090",
      "event_cluster_id": "f2102ba0-d90e-4134-a7ea-638b33257f3a"
    },
    {
      "claim_cluster_id": "163270c6-b91d-429e-9c2d-5cf8a4ff0d2e",
      "event_cluster_id": "cef4b627-4828-4a00-9a55-7f92b9804c1f"
    },
    {
      "claim_cluster_id": "94ea82f9-8fc1-4541-8fab-b8354c3ea8f2",
      "event_cluster_id": "08918774-fef7-4ef6-9e14-8a7abce1a23c"
    },
    {
      "claim_cluster_id": "ff763739-26e3-4daa-93bc-7ecf065c5275",
      "event_cluster_id": "f7d6db0d-ad7a-49ba-bfea-afddcfaa06ba"
    },
    {
      "claim_cluster_id": "da70552d-1a69-4dd8-bc9d-ca358f3caefe",
      "event_cluster_id": "a0e15f6d-9d91-458c-9257-5c60799b9290"
    },
    {
      "claim_cluster_id": "bfd9a248-bf68-4994-8af5-882efd424687",
      "event_cluster_id": "4d6eed7e-0404-4ccd-92b2-df5956550e67"
    },
    {
      "claim_cluster_id": "e7e80c41-a749-4b0c-a666-715bedd44f52",
      "event_cluster_id": "d5f07507-9281-4cfd-81bd-0fc19ffa8a89"
    },
    {
      "claim_cluster_id": "837dbefb-7b54-4aa1-aad3-56f0ea97f9ed",
      "event_cluster_id": "a4149375-9601-4a78-ae4b-69813512b036"
    },
    {
      "claim_cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
      "event_cluster_id": "2ec09e70-73d9-4395-9c36-0dbcac034464"
    },
    {
      "claim_cluster_id": "dfbd57d9-b4af-48fe-adde-4b27c203374e",
      "event_cluster_id": "e74616a0-2316-487b-b0b6-5b60062c2550"
    },
    {
      "claim_cluster_id": "aae0458a-2ab8-46b3-a4d3-61a4d3fd85ca",
      "event_cluster_id": "ee1eb50f-e51b-487b-895c-d08085b62fd8"
    },
    {
      "claim_cluster_id": "24d81b39-c399-4c59-ae9b-c84548655d0b",
      "event_cluster_id": "23a31964-6a33-4514-aa2e-353b4bd3be9d"
    },
    {
      "claim_cluster_id": "147befcf-c605-4967-82de-77dc8f9513dd",
      "event_cluster_id": "346b1dc3-219c-4228-a017-da35814deb33"
    },
    {
      "claim_cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "event_cluster_id": "9854342f-dc2f-4d81-9468-1aeed5b01c1c"
    },
    {
      "claim_cluster_id": "2fa38dbd-c491-4579-bb95-e37ac00e125d",
      "event_cluster_id": "dcae5341-3559-46a5-8605-6aff132b23e8"
    },
    {
      "claim_cluster_id": "cdfd2024-64ea-4945-8131-782266513caf",
      "event_cluster_id": "4970bf10-4486-48dd-9be4-75b2fb5e659e"
    },
    {
      "claim_cluster_id": "d7eb8bf6-179c-440e-ad1d-a97e186809d1",
      "event_cluster_id": "903c3f33-319a-4f0f-a3a0-b3ad86d56e86"
    },
    {
      "claim_cluster_id": "5dd21bbf-0c74-46d7-a4e4-48789f1b2436",
      "event_cluster_id": "001b82c1-e0c7-4fe5-8e7f-c84ae10048f6"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "338cf48b-ad2b-4dbf-8d36-1e19e9e04681"
    },
    {
      "claim_cluster_id": "d14e115a-dd46-437f-8a57-5893395dde5f",
      "event_cluster_id": "90594f77-57da-4d80-a85e-ef6c61b0cc03"
    },
    {
      "claim_cluster_id": "9bdb548d-7392-42e2-81f0-dc3db0c2af7a",
      "event_cluster_id": "3af4feb3-44a5-438e-9179-8a6158407f03"
    },
    {
      "claim_cluster_id": "1450e6e0-be6b-4ab7-8d94-7070623cadb4",
      "event_cluster_id": "c16529d9-b58f-4692-9ca3-61d534ff3c9c"
    },
    {
      "claim_cluster_id": "61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc",
      "event_cluster_id": "173f883f-de30-4d47-bca3-522527267a76"
    },
    {
      "claim_cluster_id": "b7e33865-58b2-4984-a7e1-eed1512539bb",
      "event_cluster_id": "6c806f4f-f4b8-4c40-ad97-ff6d0d5a2a84"
    },
    {
      "claim_cluster_id": "7db64556-43b7-4e29-b1a9-e8fcd5d29233",
      "event_cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63"
    },
    {
      "claim_cluster_id": "b2635760-bcd6-46c7-88fb-9bbbb7349033",
      "event_cluster_id": "76d7e29b-d686-4238-a931-2118cfe1bf3e"
    },
    {
      "claim_cluster_id": "d946674a-0b30-4a82-a7a2-12fe77cdc3f5",
      "event_cluster_id": "0edc35d0-3f90-4beb-b2c7-55c511dba369"
    },
    {
      "claim_cluster_id": "48cca002-8003-45bd-92b2-3e2945a33b48",
      "event_cluster_id": "f623c469-24ac-43e2-8e2e-e888031af996"
    },
    {
      "claim_cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "event_cluster_id": "96b587fb-4363-4d46-8a28-162c4f6a688e"
    },
    {
      "claim_cluster_id": "2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4",
      "event_cluster_id": "33e5cc06-7767-4163-b58e-c98e6d0b542f"
    },
    {
      "claim_cluster_id": "89b27333-1443-478a-ae8d-2e32423dac3d",
      "event_cluster_id": "b9b58ab0-89c7-43c0-9654-023c7dc7edd7"
    },
    {
      "claim_cluster_id": "cd8495d7-023b-4c43-b6e6-6e4c88a0cd79",
      "event_cluster_id": "35826418-a010-4d4a-99fc-5e4fe849cbd8"
    },
    {
      "claim_cluster_id": "baec81f4-73ba-4194-ab31-e3d64c8a57ab",
      "event_cluster_id": "ed0282a9-1dce-4648-ba02-635146d8d79c"
    },
    {
      "claim_cluster_id": "4a942b66-0607-413f-8ee5-b6f6ddbbd034",
      "event_cluster_id": "1d4622f2-0a7b-4423-ad78-a011864bf902"
    },
    {
      "claim_cluster_id": "42fd849e-0fa9-43a8-b5fa-5cc192351c79",
      "event_cluster_id": "c2d29a8c-d30d-4b99-9286-81917e79d3dd"
    },
    {
      "claim_cluster_id": "59905a93-0117-4d6a-a153-cacf3c9feeb8",
      "event_cluster_id": "b92f2bdb-a4c9-478b-a96f-1f47457a005d"
    },
    {
      "claim_cluster_id": "2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4",
      "event_cluster_id": "2adc78cc-7a32-4711-8e39-54e6c3539977"
    },
    {
      "claim_cluster_id": "4d4f9bd6-404f-433c-9423-3e07e0773599",
      "event_cluster_id": "386f4b6c-ead4-4444-9916-d94cb574f068"
    },
    {
      "claim_cluster_id": "8d4f670d-826e-45f3-b1fc-0b828324ae7a",
      "event_cluster_id": "ee698871-2543-42ca-9ed1-652a77429181"
    },
    {
      "claim_cluster_id": "61fe3afa-76aa-4838-9dd9-a22a879ae31e",
      "event_cluster_id": "f839d2fd-5b0b-43b0-bb42-43cd3c1d733b"
    },
    {
      "claim_cluster_id": "7781df4b-26ca-4879-a33c-cb83ade5ffa4",
      "event_cluster_id": "e0f4c0a7-03fa-4df4-af40-cde3c562aff7"
    },
    {
      "claim_cluster_id": "4ef708bd-198e-4a9e-9652-a1b08bc50fd9",
      "event_cluster_id": "9f093a15-003e-4c3e-b942-5c6cfb87c05d"
    },
    {
      "claim_cluster_id": "5e0fea08-89fc-42fe-8906-484d762a1714",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "44d600b5-1259-4b0f-a45c-73f5507156e1",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "f3072807-ef6c-4e5e-9a52-03328278d096",
      "event_cluster_id": "4cf07546-b901-4002-a89e-1a6f0ae3d9e6"
    },
    {
      "claim_cluster_id": "0a79d737-f594-464b-b3d2-afd57c6349f1",
      "event_cluster_id": "a0a7051e-2d37-4a4c-b40d-aaf1f0558e1e"
    },
    {
      "claim_cluster_id": "61fac83f-0dd7-4c15-88bc-e40fee962783",
      "event_cluster_id": "3defb0ae-14b9-488e-979b-534969f6eb1f"
    },
    {
      "claim_cluster_id": "658de6ad-fa34-4d62-b1a8-d4dba2ffb3d8",
      "event_cluster_id": "51d0514d-a16c-49e4-8ac6-e122e83a4777"
    },
    {
      "claim_cluster_id": "4801b48a-d91c-4dc3-9797-76929432b0ef",
      "event_cluster_id": "0d4d1a0e-a8fb-4f12-a4b0-63f68ad14434"
    },
    {
      "claim_cluster_id": "1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07",
      "event_cluster_id": "f53fc0bd-981e-4236-b0fe-25581f5f427a"
    },
    {
      "claim_cluster_id": "541a6555-c116-4473-b1ae-ac7c48578f3d",
      "event_cluster_id": "2b3d52ec-4f80-453e-83c9-9cef80ee3ed0"
    },
    {
      "claim_cluster_id": "5eea51f7-7e2e-46d8-8dff-0d1a87db87b5",
      "event_cluster_id": "6084620c-6cb7-4024-86d0-5c702f76e152"
    },
    {
      "claim_cluster_id": "99bf6cc4-ca7c-40f2-9d7f-294c761aeaaf",
      "event_cluster_id": "fe0044a9-f20d-4a9a-945b-251740ff3a14"
    },
    {
      "claim_cluster_id": "bdb0efc8-0563-4b0b-a277-072e3cddd7c6",
      "event_cluster_id": "9e7833e1-081b-4955-a649-df85a3c6a9e3"
    },
    {
      "claim_cluster_id": "840ac263-91de-449d-b701-c05a4522f3b3",
      "event_cluster_id": "d72d1fb8-e77f-4607-a953-e3e224ada7a6"
    },
    {
      "claim_cluster_id": "e521c1db-8ae4-48b6-83c6-efbd02701f4c",
      "event_cluster_id": "04675e2c-1e61-4971-b87b-4cddc78fd434"
    },
    {
      "claim_cluster_id": "02e82f7d-c446-4fc6-9794-94910a46d2ac",
      "event_cluster_id": "317eba1c-3b6f-43f0-a757-dddfa7966147"
    },
    {
      "claim_cluster_id": "3786df1e-47ff-4916-973b-ccf57ccb5e4c",
      "event_cluster_id": "14786248-4bb0-4ea2-9421-150787f5ff33"
    },
    {
      "claim_cluster_id": "e25eede3-3242-446d-a439-2c4becea51cf",
      "event_cluster_id": "61dc215b-cc5e-49f1-add7-65f02e137ed1"
    },
    {
      "claim_cluster_id": "f8618eda-effd-4eda-b2ad-66d8fec0ba02",
      "event_cluster_id": "bb608fd7-71a8-4a13-839e-8d3ef46c08e2"
    },
    {
      "claim_cluster_id": "db5a201e-a58a-46dc-91a0-0072432f56c4",
      "event_cluster_id": "413ea174-815d-4e35-9f99-9c6c2ede588d"
    },
    {
      "claim_cluster_id": "a01e0915-a285-410d-9d1b-ce9544139c90",
      "event_cluster_id": "0d423859-86f8-4f56-9318-137386b1b279"
    },
    {
      "claim_cluster_id": "43966195-88ed-478f-bd22-9c59b6eda45a",
      "event_cluster_id": "7b4680b9-9676-4736-8ed2-d06a2da6ea63"
    },
    {
      "claim_cluster_id": "954a4240-7358-4649-966c-6f08bf5b088e",
      "event_cluster_id": "2648c3b9-64e2-4596-9353-c37ae996dcce"
    },
    {
      "claim_cluster_id": "64ec2b0f-c55e-42e7-a532-b9948f0a43c1",
      "event_cluster_id": "5d5c8795-a6be-497b-896a-30f8df4f0736"
    },
    {
      "claim_cluster_id": "1a853cc3-9e33-4539-b70a-cc51380d7526",
      "event_cluster_id": "eeb2d0cb-ddf5-48d2-9af4-27f0f7c318af"
    },
    {
      "claim_cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "event_cluster_id": "a644befb-dbc0-4695-b3a4-09f27c71e3c4"
    },
    {
      "claim_cluster_id": "f90286ec-0f96-4266-aa5f-350beb9c1d91",
      "event_cluster_id": "4d4ab9a7-62c6-4187-97c0-f07bf059ad55"
    },
    {
      "claim_cluster_id": "fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec",
      "event_cluster_id": "dedbca30-3396-4307-a69b-7d7c22f5347b"
    },
    {
      "claim_cluster_id": "b54d16d2-d5db-4746-b15a-e8c01d4fc586",
      "event_cluster_id": "00be0a5e-79b9-4671-8dc6-befc37464ba9"
    },
    {
      "claim_cluster_id": "fc4ce4ef-b019-44c8-8060-59b10a33a92b",
      "event_cluster_id": "eff3ff70-7d42-45d0-a372-4aa15bf9f280"
    },
    {
      "claim_cluster_id": "f18ec76a-50ba-422f-9d7a-596708b1810a",
      "event_cluster_id": "e0978a2e-1125-4e65-9d19-ea0e822bd88c"
    },
    {
      "claim_cluster_id": "cfbbcd75-4bf0-4351-b592-afb201b74b60",
      "event_cluster_id": "6ea91435-3e36-4fbf-82c3-faa6793916cf"
    },
    {
      "claim_cluster_id": "293179d1-c66b-4ab3-8e81-318e4b36242c",
      "event_cluster_id": "d6ce2176-c8b1-49b2-89e4-f0620f06cb63"
    },
    {
      "claim_cluster_id": "f9eb0f13-3691-4b5d-b326-0456c31b4402",
      "event_cluster_id": "2d5921ac-7cf9-4259-b8e0-144908d40418"
    },
    {
      "claim_cluster_id": "78064e33-a38e-4112-b3b2-c02951368282",
      "event_cluster_id": "11b98cf9-d431-4639-813c-ea19160c9631"
    },
    {
      "claim_cluster_id": "5d937f92-5b6e-469d-95cb-0e0432a9031d",
      "event_cluster_id": "f19998d7-da9d-4ad2-b0f0-03ca5c82143c"
    },
    {
      "claim_cluster_id": "4f0130b7-d8c3-44c1-892f-fe74aef4cecc",
      "event_cluster_id": "1f2e46b4-6012-4c4f-8e36-ebb4e20f881f"
    },
    {
      "claim_cluster_id": "c19d9ba5-5f1b-487d-8f8e-af1dd8c97af2",
      "event_cluster_id": "41739d94-ef7a-4bdc-b95f-35d9d4daaddf"
    },
    {
      "claim_cluster_id": "dfa7b9d2-5920-4d57-8445-e48ac5ce73da",
      "event_cluster_id": "b61f6891-5a9f-49aa-8194-10b89513a5a2"
    },
    {
      "claim_cluster_id": "c462838a-420c-4b5a-ad06-676939effe93",
      "event_cluster_id": "d291acf3-7cf8-4c9d-9ab4-df11bad39953"
    },
    {
      "claim_cluster_id": "e370d332-674b-403f-8471-184685b21c55",
      "event_cluster_id": "7d17e0b1-02a8-4e94-8aaa-3bb8dcf83cf8"
    },
    {
      "claim_cluster_id": "f66bb1c3-c6f1-4000-8eb0-82b5bd8bc518",
      "event_cluster_id": "ee8407f3-3b78-41fa-b305-9976663fec3b"
    },
    {
      "claim_cluster_id": "8bdd6183-6e5d-4862-87e8-003b661f98ce",
      "event_cluster_id": "3ad13608-e9f5-474c-8ce2-26cf09394813"
    },
    {
      "claim_cluster_id": "f17dbb9a-8968-4ade-a774-02688b6da89a",
      "event_cluster_id": "c21a5302-b063-4bd9-9ecc-b34fe6ec8594"
    },
    {
      "claim_cluster_id": "1cf25dc0-5ba1-4372-8fe0-913839532e6d",
      "event_cluster_id": "4a667d4b-a464-4833-81f6-cd5a99658ce5"
    },
    {
      "claim_cluster_id": "0961c365-4261-4c91-984b-81c62260d807",
      "event_cluster_id": "1bbcb23d-9835-462a-b09f-6a4c89faa361"
    },
    {
      "claim_cluster_id": "3d545073-748d-4207-8e53-2f9ae214848a",
      "event_cluster_id": "b4a34e37-e56c-45d2-8766-c4fab9d7cdf4"
    },
    {
      "claim_cluster_id": "60ed7bd8-a38c-4b99-a08f-6210e30fac23",
      "event_cluster_id": "c62e089c-1780-440d-b990-8342bb6836f8"
    },
    {
      "claim_cluster_id": "a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20",
      "event_cluster_id": "3b057684-8f4b-4670-8bb3-3e44655c051c"
    },
    {
      "claim_cluster_id": "c462838a-420c-4b5a-ad06-676939effe93",
      "event_cluster_id": "31dfadd3-c8f6-437b-b8ec-a69992a26cb8"
    },
    {
      "claim_cluster_id": "4692c588-5e24-491c-9044-3d7dd7c0a2d7",
      "event_cluster_id": "bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093"
    },
    {
      "claim_cluster_id": "ce637d4c-890f-483b-9ed8-d8130682b8ac",
      "event_cluster_id": "bbbc187b-0542-41ab-ac2d-d7a3573b3f23"
    },
    {
      "claim_cluster_id": "c3383556-4a09-4d9a-b202-b1b017162bd3",
      "event_cluster_id": "478586e7-cd47-4bba-a3e6-e954dd593a00"
    },
    {
      "claim_cluster_id": "957872f4-ebb4-47bd-9d9e-487c3755644e",
      "event_cluster_id": "b9a01b27-65e1-4a9d-9166-e606cea6425c"
    },
    {
      "claim_cluster_id": "5e700671-a24a-4c8f-a1e4-abbfb82f4537",
      "event_cluster_id": "39687812-944b-4418-ada5-3588be43da66"
    },
    {
      "claim_cluster_id": "7f94beb2-9a43-4280-9734-5045402a0714",
      "event_cluster_id": "b7685445-3aa6-4ff3-a94e-b37c9df21cb5"
    },
    {
      "claim_cluster_id": "72a6b38a-23a2-43db-a788-32ae774a5c77",
      "event_cluster_id": "3ef2d7ad-744b-4957-b2f1-17396d9e9cba"
    },
    {
      "claim_cluster_id": "dad0da03-60db-4f17-9025-e5a1ac65e552",
      "event_cluster_id": "32ea90b6-1f69-462e-a6fa-1e6c1978de12"
    },
    {
      "claim_cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
      "event_cluster_id": "a8acca84-268a-4542-96c5-6e8d1fb747ac"
    },
    {
      "claim_cluster_id": "f502dcb8-0d11-41eb-afba-f50e74157a5b",
      "event_cluster_id": "e91b49c0-8438-4f30-a193-2c3167f6ab7a"
    },
    {
      "claim_cluster_id": "db5fd0e4-cf0a-4e94-a4a2-d71a9c25184f",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "c63decfc-559c-461a-ad2c-a9922b7e06df",
      "event_cluster_id": "bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093"
    },
    {
      "claim_cluster_id": "5de27702-5e57-4b36-bd94-a31f82ba53eb",
      "event_cluster_id": "1d59e830-9dbc-4506-8070-28b5e75a1284"
    },
    {
      "claim_cluster_id": "3d44d914-cf73-4d8b-b531-5db2be83da48",
      "event_cluster_id": "8a1628d6-9b8d-4872-8726-128c5ec7f01c"
    },
    {
      "claim_cluster_id": "f7fbb95e-08d7-410a-8e1f-290e984463d7",
      "event_cluster_id": "544dff2f-0e7b-440b-a330-646db7ed3912"
    },
    {
      "claim_cluster_id": "ab7a8719-e742-49dc-b23d-904f2b97e9e2",
      "event_cluster_id": "be8fcb60-f85e-4def-aa6a-bd82881e44d3"
    },
    {
      "claim_cluster_id": "86f4bd2f-fbe6-4fe2-b712-f9d4acd0c218",
      "event_cluster_id": "75ba7619-eb16-4658-b147-47f3f92ed383"
    },
    {
      "claim_cluster_id": "d3123cbc-3543-4f46-aee9-7941c8669a07",
      "event_cluster_id": "8f118d54-36b6-4cf4-a60c-7acf617e5bf4"
    },
    {
      "claim_cluster_id": "d9f9cf14-d4ad-4c0a-9482-99b75f7c247f",
      "event_cluster_id": "b1dcb694-6efc-4b22-9bc7-9254eb290f7d"
    },
    {
      "claim_cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
      "event_cluster_id": "08f28ba1-ced8-47f4-a0a0-4116b507d143"
    },
    {
      "claim_cluster_id": "26ee8f8d-a289-4bb8-af4e-67dfc3cca301",
      "event_cluster_id": "b83cbf56-9c77-41ae-bf34-905116236046"
    },
    {
      "claim_cluster_id": "f8618eda-effd-4eda-b2ad-66d8fec0ba02",
      "event_cluster_id": "8a43f903-0edb-4ccc-94e1-29dd080da2dd"
    },
    {
      "claim_cluster_id": "b7190356-8b3c-4107-b9f7-680aa8b73b90",
      "event_cluster_id": "ed2533cf-2013-4e49-885b-231a6c55f0fb"
    },
    {
      "claim_cluster_id": "94599b0f-3332-46af-911a-e0ea949079dd",
      "event_cluster_id": "58ab14ae-8edd-49c2-93f1-5410b8248aac"
    },
    {
      "claim_cluster_id": "b8109116-4fcc-41ae-af96-4f441a585df4",
      "event_cluster_id": "a40aca49-8fcc-4409-91ff-d18e1fba8028"
    },
    {
      "claim_cluster_id": "c2417696-bc64-4d4a-b3a4-d5d9e3cefb38",
      "event_cluster_id": "cfc42d88-49ac-4610-a5c7-0cce12304171"
    },
    {
      "claim_cluster_id": "77e72686-2baf-45ab-a679-b8f62cdcf982",
      "event_cluster_id": "651192ce-035f-4e17-8834-956bf8fefc33"
    },
    {
      "claim_cluster_id": "f415a439-e6f6-4971-a345-2c0b2ac96c23",
      "event_cluster_id": "a1921f6f-8530-42a9-8f36-9fbcf1bb8941"
    },
    {
      "claim_cluster_id": "7cad6507-3550-4760-99ab-581f5b103f29",
      "event_cluster_id": "a00b5c34-3d1b-444a-9f62-57418373c9c3"
    },
    {
      "claim_cluster_id": "12b139d6-738c-48c1-b240-a723ec803e43",
      "event_cluster_id": "366a8fe2-ca03-46c9-b2fb-6c5f6c4014f1"
    },
    {
      "claim_cluster_id": "ded98049-aef1-4b4f-a8a6-f68c10032b7f",
      "event_cluster_id": "7a2de756-9400-4120-b4b6-4dec07a8ec47"
    },
    {
      "claim_cluster_id": "8948b384-0046-47fe-bc91-7f2737b00557",
      "event_cluster_id": "fdd7487d-7bf5-4a71-8bbd-7a8cd0c6d7c4"
    },
    {
      "claim_cluster_id": "56dc9727-1db9-4dc8-acf2-c70b7f101883",
      "event_cluster_id": "01284921-0773-415d-9ce4-f4e93b10a2af"
    },
    {
      "claim_cluster_id": "43fe48a2-ed82-4cef-9784-8e8df627f565",
      "event_cluster_id": "53b1257e-8f17-4723-a98b-5c441d647f48"
    },
    {
      "claim_cluster_id": "83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6",
      "event_cluster_id": "aa460f1b-c007-4666-8137-aaad655dfd7f"
    },
    {
      "claim_cluster_id": "8c18859c-7432-4cc4-af8f-8a5eb220876e",
      "event_cluster_id": "2c1c9214-d791-4513-8352-ad5103d53749"
    },
    {
      "claim_cluster_id": "ff920ca0-1e39-41be-ac8f-cd0534048634",
      "event_cluster_id": "7259b8c6-e5fe-4c56-9293-e3133ae377b8"
    },
    {
      "claim_cluster_id": "8dca8952-fbff-4b47-ba25-a7640fe52fba",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "abd83725-20da-4a40-a5cf-bb6715d5460b",
      "event_cluster_id": "f83e82a8-4441-4c96-b8ec-2b50e32532d9"
    },
    {
      "claim_cluster_id": "464aaab3-50a7-44d6-8c7a-bdc722ee9f18",
      "event_cluster_id": "fc4a44e4-cde7-4210-b1dd-064e7cdc5fc4"
    },
    {
      "claim_cluster_id": "652f1be8-25e9-4267-b7cc-e5ecf9e7919b",
      "event_cluster_id": "a327ab70-71a6-495b-b0af-9116aa9c7d3c"
    },
    {
      "claim_cluster_id": "2c8b719a-2363-4f9f-9be2-6d1801374195",
      "event_cluster_id": "baaa2ca3-1dde-42fe-ad1f-1aae3e927027"
    },
    {
      "claim_cluster_id": "2c1958a0-e83a-4912-9902-e6456b756f14",
      "event_cluster_id": "60b6a6af-f010-44f3-a632-e0a93f1ed5d0"
    },
    {
      "claim_cluster_id": "f9eb0f13-3691-4b5d-b326-0456c31b4402",
      "event_cluster_id": "3749bcc6-b034-4fb0-8ff0-89b445295873"
    },
    {
      "claim_cluster_id": "f51c562e-c0c3-4e9a-aec5-0739526b9b5b",
      "event_cluster_id": "b79a6948-c2a3-43ae-83f7-90168d6803ac"
    },
    {
      "claim_cluster_id": "b5b35a39-f79a-45e8-82ea-b87d21bbba55",
      "event_cluster_id": "d6134f0a-59f2-49b7-85e1-25628c9e022f"
    },
    {
      "claim_cluster_id": "d7eb8bf6-179c-440e-ad1d-a97e186809d1",
      "event_cluster_id": "86a22fd0-1ecc-482a-b682-9b84955dcaf9"
    },
    {
      "claim_cluster_id": "75e57a3a-a55d-4c36-b291-226154171396",
      "event_cluster_id": "4033f6dd-a718-42cc-9426-c47fe47bc182"
    },
    {
      "claim_cluster_id": "2b7a55b4-92f1-4438-b42d-086b564be154",
      "event_cluster_id": "cf5361b0-1dac-4daf-8324-8e2f301900ff"
    },
    {
      "claim_cluster_id": "06f63413-3561-4a53-933b-589b1f942c37",
      "event_cluster_id": "532d9503-bb11-4fbf-b9c1-5c555fd5393f"
    },
    {
      "claim_cluster_id": "f90286ec-0f96-4266-aa5f-350beb9c1d91",
      "event_cluster_id": "aeb6169d-c89e-4c20-9127-6438583dd127"
    },
    {
      "claim_cluster_id": "174a0855-e1b9-4e2b-9a6a-957eb12d4b1a",
      "event_cluster_id": "e44c864d-e3c7-43c1-8d75-3390dbfd5417"
    },
    {
      "claim_cluster_id": "64ec2b0f-c55e-42e7-a532-b9948f0a43c1",
      "event_cluster_id": "9d5a2720-0f92-434c-867d-f7d869c56177"
    },
    {
      "claim_cluster_id": "a383fa5f-a5c9-4c42-8e25-d968285a2473",
      "event_cluster_id": "9aa4bb60-c9b0-4bd6-9189-bb33a4f61778"
    },
    {
      "claim_cluster_id": "b840591d-33a5-402e-9f7a-8913292b283e",
      "event_cluster_id": "5688bb4a-4059-431b-b1bc-a991bc5ccd0e"
    },
    {
      "claim_cluster_id": "7cc752d0-c62a-4657-a1e6-4213c5baa7cf",
      "event_cluster_id": "f1e3a565-29ca-414c-8fa2-90756a824cf2"
    },
    {
      "claim_cluster_id": "b4479b0e-003b-4796-9f06-dafafe7cc27d",
      "event_cluster_id": "1760a439-ca46-4fac-8653-21cfe35d860c"
    },
    {
      "claim_cluster_id": "e684bea9-83ef-4337-93a3-80b8a3708ae0",
      "event_cluster_id": "602cf518-8d43-4cc2-9f69-aa005257dd2f"
    },
    {
      "claim_cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
      "event_cluster_id": "efe63a8c-0f9a-4b9f-ad60-14fabb8e67d3"
    },
    {
      "claim_cluster_id": "e44edb14-2754-4e0a-969f-2ab83f6f614c",
      "event_cluster_id": "5c164c1e-39f8-4082-aad5-890bec3c1681"
    },
    {
      "claim_cluster_id": "d71c3e1e-b92b-4fd2-a1fd-9b3951fec4df",
      "event_cluster_id": "43fc29bf-35e5-405b-9c9f-cf4dbaccd61f"
    },
    {
      "claim_cluster_id": "5ab9d303-668f-48d9-893f-546437484767",
      "event_cluster_id": "60930e0d-3823-4b8f-9390-0e719aa7b09e"
    },
    {
      "claim_cluster_id": "09505049-ee83-46bc-bc41-216c4501ccc0",
      "event_cluster_id": "4fc8d532-69fa-40fd-b28d-a301335dc7b8"
    },
    {
      "claim_cluster_id": "29469bb2-a496-413c-802b-5a8d1b46d374",
      "event_cluster_id": "94b0a214-1e60-4bbb-96cf-031169c35247"
    },
    {
      "claim_cluster_id": "30765e40-3943-483b-8e1e-27d3053ae2bd",
      "event_cluster_id": "7202d20f-cf9b-4054-aa24-3edfd3064cd7"
    },
    {
      "claim_cluster_id": "901f6891-5f9b-4fa4-a368-69a4f20e9617",
      "event_cluster_id": "bdaea9bd-1088-4933-8486-42634bd70322"
    },
    {
      "claim_cluster_id": "78602db4-20a8-484c-8fc6-98f22daf81ff",
      "event_cluster_id": "32516088-d496-4b04-a09c-540561be5921"
    },
    {
      "claim_cluster_id": "f8cc40a9-e215-46da-bdf5-b5efc622bb40",
      "event_cluster_id": "e18afe50-8e61-4915-8745-6256e6a782cb"
    },
    {
      "claim_cluster_id": "b2ae7e4a-67e9-4eed-bd5c-afaef2c19efc",
      "event_cluster_id": "5df7d808-68d6-445c-b39d-37aecaaa35ed"
    },
    {
      "claim_cluster_id": "7a7464b2-8279-45dc-b2ed-48f2c4d22d10",
      "event_cluster_id": "9dee9825-7f6c-4617-8b1e-b3ceb5b3a39f"
    },
    {
      "claim_cluster_id": "b6dd34fe-58a4-4775-be96-ca839f926747",
      "event_cluster_id": "7459e660-f889-4b03-9154-79bc408cffa6"
    },
    {
      "claim_cluster_id": "2bd9ff92-4ea3-492e-a249-5de7759a5956",
      "event_cluster_id": "002cfac3-c97a-4ec1-b743-37eb0267aef0"
    },
    {
      "claim_cluster_id": "a8aabd5b-4955-40cb-b78a-086cb1601de5",
      "event_cluster_id": "4f004657-e8c8-479b-b300-35da0eaa53b8"
    },
    {
      "claim_cluster_id": "e9b06ff3-55a4-46a5-87d3-266dff0dc9c1",
      "event_cluster_id": "71b00bc6-170a-45b7-bfdf-40d740e90b1e"
    },
    {
      "claim_cluster_id": "61ed0aed-dc5b-413d-8a18-4362324862cc",
      "event_cluster_id": "e622291d-8809-42f1-9ac7-ff3aba01b794"
    },
    {
      "claim_cluster_id": "e29603b9-c4aa-4f53-bf09-ee3302f2daff",
      "event_cluster_id": "89863767-163a-4f04-8bbc-fc93772a6aa5"
    },
    {
      "claim_cluster_id": "a5d39319-660b-4b6e-acb4-246464538db6",
      "event_cluster_id": "bdbb752b-6e19-40a1-b874-d58f3b375de7"
    },
    {
      "claim_cluster_id": "88ebdccc-4a31-4f1b-a74f-989ab096e08f",
      "event_cluster_id": "993e530a-4835-4641-a20d-ee6860332c74"
    },
    {
      "claim_cluster_id": "19ddcd3b-18db-461a-b208-f198db3e1e07",
      "event_cluster_id": "ef8af588-0359-41f5-af90-03db72eaaba3"
    },
    {
      "claim_cluster_id": "060a7355-d23c-448a-8514-2034a0d11495",
      "event_cluster_id": "297851ee-0090-4476-be7b-77ecae5b0949"
    },
    {
      "claim_cluster_id": "8d550fbc-5131-4294-a815-b9e32f81ad7a",
      "event_cluster_id": "921f4cda-4607-46f9-83ce-2b7708f3b6a9"
    },
    {
      "claim_cluster_id": "baa70e51-5ce2-4e6f-8994-d85027e6b1d9",
      "event_cluster_id": "b5e4c53f-7f15-4f0d-b014-ab5bdfef9779"
    },
    {
      "claim_cluster_id": "5102f7b6-4554-4836-b695-c4ff3c598adf",
      "event_cluster_id": "9610bc6c-2c1c-47d3-bb20-3bc619407fd0"
    },
    {
      "claim_cluster_id": "84900de4-4822-40e2-a41f-f9013bcc0bbe",
      "event_cluster_id": "abca71f2-b0b7-497b-b1ed-9f04c6ea4023"
    },
    {
      "claim_cluster_id": "99892bd6-22b5-4bc1-bade-41a91e788227",
      "event_cluster_id": "acb8c5a5-3818-4898-ace2-3330d0f18d6b"
    },
    {
      "claim_cluster_id": "cc6a9454-14fd-45d5-b472-64ca4fedbe80",
      "event_cluster_id": "fbc20184-6dc0-4a3f-a944-728af7954e97"
    },
    {
      "claim_cluster_id": "5cab19a1-9532-4ca5-8f94-e19c788f807b",
      "event_cluster_id": "a5420c14-b12d-4c0a-ae41-dc3c93672fd7"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "d32bd6fd-0fc9-411f-b6d0-ef85e52f9cf2"
    },
    {
      "claim_cluster_id": "d077cb01-a835-4272-a09e-399e776f6a6b",
      "event_cluster_id": "5a9527b4-7ddf-4c5a-b860-67170fb02224"
    },
    {
      "claim_cluster_id": "a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05",
      "event_cluster_id": "7d87f4b1-866b-4dd1-b437-00afdcc9c4fe"
    },
    {
      "claim_cluster_id": "8dca8952-fbff-4b47-ba25-a7640fe52fba",
      "event_cluster_id": "e58bb674-2815-4cd8-8385-fa265f1201b2"
    },
    {
      "claim_cluster_id": "2df1a526-a92c-44a2-a3b2-202bf1d7f6d9",
      "event_cluster_id": "d9b685c8-3dc8-407d-b009-8b6a472fbfe9"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "4abef329-5b6f-45d7-988e-0182db3d0240"
    },
    {
      "claim_cluster_id": "fb95e7e0-9ac4-4fef-85ca-e17c4d83450d",
      "event_cluster_id": "7ae8bb79-06c2-4d0f-9d71-30e4b3fb8238"
    },
    {
      "claim_cluster_id": "b865573b-6b72-46cd-b3c0-a1458e7df010",
      "event_cluster_id": "75ca701d-5dd3-4eb2-b641-e9b6d4316367"
    },
    {
      "claim_cluster_id": "5aec5e12-6df7-45c2-ae07-2921310e080b",
      "event_cluster_id": "ffbd77e7-2b57-47a5-8bd4-9b23ebb837b5"
    },
    {
      "claim_cluster_id": "127c457b-8cad-4a81-8d25-66dd51786fe0",
      "event_cluster_id": "b13b5ee0-1421-43e8-a554-5b3888a5cac7"
    },
    {
      "claim_cluster_id": "a45b0120-f89a-4fb7-9d30-32c67bc23fc9",
      "event_cluster_id": "124f0557-d721-4d00-9466-962e5e5fe3ab"
    },
    {
      "claim_cluster_id": "0eef7600-1d71-4d26-9e91-3c6e5b0c6121",
      "event_cluster_id": "bf67fbdf-c97d-45ea-aca3-181ca579afe4"
    },
    {
      "claim_cluster_id": "3d52b30c-fa0d-4a4c-9240-38abdfc6ab20",
      "event_cluster_id": "0a56e25c-3625-49c1-8cd1-fb3ddd10b2d3"
    },
    {
      "claim_cluster_id": "b2635760-bcd6-46c7-88fb-9bbbb7349033",
      "event_cluster_id": "777f19d6-a14f-4d35-a3bb-15bb93dcdf4d"
    },
    {
      "claim_cluster_id": "7b81ca4d-8e93-46ac-878f-890570c00638",
      "event_cluster_id": "1760a439-ca46-4fac-8653-21cfe35d860c"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "23bd5333-419d-453d-bf08-b1b6ca7b3af3"
    },
    {
      "claim_cluster_id": "72804ca3-611f-4b19-ada2-8bfb14c2e98a",
      "event_cluster_id": "1604ef4f-6382-4413-9253-925958021968"
    },
    {
      "claim_cluster_id": "1b36c1d4-6613-4a77-b192-f653249b73a3",
      "event_cluster_id": "c1d2e607-4b20-4663-b826-18bf9ec884ab"
    },
    {
      "claim_cluster_id": "d2c2f402-f56b-4dfa-98d3-daf63239156d",
      "event_cluster_id": "b68b2c64-2b71-44ac-a7b3-c79fe12186bd"
    },
    {
      "claim_cluster_id": "d68f430a-9578-4b21-a27f-13f1a9f8f629",
      "event_cluster_id": "b5f5096f-4606-455f-8c76-949d5ee72c79"
    },
    {
      "claim_cluster_id": "626035be-3dc2-4608-b822-013ba6260905",
      "event_cluster_id": "4b3adf55-a27f-47ae-8d76-9cdeb5e8523c"
    },
    {
      "claim_cluster_id": "291e098d-0f3d-4fff-9906-3b21ed1a33a1",
      "event_cluster_id": "835823ac-6b1a-4b3a-9f19-567a3d13955c"
    },
    {
      "claim_cluster_id": "0998688e-32a8-4d44-8338-04f2bfaf29d8",
      "event_cluster_id": "32b2643e-52f7-4ad5-a0ab-4120423c498b"
    },
    {
      "claim_cluster_id": "908a4168-b322-4057-a44b-a100dbffbe53",
      "event_cluster_id": "b96bf2eb-4edd-4eb7-8c42-ee3fff5f4c9c"
    },
    {
      "claim_cluster_id": "3249ee55-684b-4bbb-8b52-6766f62838f9",
      "event_cluster_id": "3b95c6b0-416b-4f6d-9aaf-3287913c0c2f"
    },
    {
      "claim_cluster_id": "9f4059ba-333f-4054-ba5f-f1cebaed747e",
      "event_cluster_id": "33362f90-8163-4571-a6ec-1aa8d1d2470b"
    },
    {
      "claim_cluster_id": "73dcede2-49d2-4bc1-a599-b15a7d0094cf",
      "event_cluster_id": "cd9fcff5-cee9-4a86-b076-bc2c105f1372"
    },
    {
      "claim_cluster_id": "26ee8f8d-a289-4bb8-af4e-67dfc3cca301",
      "event_cluster_id": "f2b47c96-3e62-4d1a-98f6-547e71af6858"
    },
    {
      "claim_cluster_id": "e473874a-9cd2-4a8d-b926-9354bf1b7e19",
      "event_cluster_id": "b95ab66d-3f95-45f0-b65c-f87d9de7b47c"
    },
    {
      "claim_cluster_id": "e64bcf93-086e-429d-9ff7-3a1518b3ae51",
      "event_cluster_id": "48fd9ac4-d4c3-4877-b46e-dde80ecc5cd1"
    },
    {
      "claim_cluster_id": "a9a65207-69ea-45b8-ac25-c8ee16fc4a08",
      "event_cluster_id": "523ae438-64cf-40ea-839d-1a30cbcf4c63"
    },
    {
      "claim_cluster_id": "0f733538-ef56-427f-ad23-04cb6fae87ae",
      "event_cluster_id": "4cf07546-b901-4002-a89e-1a6f0ae3d9e6"
    },
    {
      "claim_cluster_id": "09c923c5-0d10-40d6-8825-821711e43905",
      "event_cluster_id": "60b30dc1-39f7-4e54-a8fe-0ca30098499b"
    },
    {
      "claim_cluster_id": "aae0458a-2ab8-46b3-a4d3-61a4d3fd85ca",
      "event_cluster_id": "4c79fc69-3bd0-4180-9718-8d85b8c9dd85"
    },
    {
      "claim_cluster_id": "2567422d-b366-451c-a271-4cb76dc8196c",
      "event_cluster_id": "3514e7b6-1754-4c84-b69f-d0a9d29a661f"
    },
    {
      "claim_cluster_id": "e521c1db-8ae4-48b6-83c6-efbd02701f4c",
      "event_cluster_id": "0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"
    },
    {
      "claim_cluster_id": "2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4",
      "event_cluster_id": "1de54c8a-0e53-4b6b-8b96-dacd9745e0a3"
    },
    {
      "claim_cluster_id": "f4e47d52-0a9c-4a42-9a14-47aece599116",
      "event_cluster_id": "11246355-e976-4176-b4cb-550c91543955"
    },
    {
      "claim_cluster_id": "4a277b87-4d75-4b75-9416-adcbd06c3a69",
      "event_cluster_id": "d2a4fdc2-883c-43bb-be4a-653d77acf7ba"
    },
    {
      "claim_cluster_id": "35ff7a5e-40b8-42ad-9379-7ba830c9445f",
      "event_cluster_id": "f0462ff7-d9e3-4bd0-94ad-a4653debf7f6"
    },
    {
      "claim_cluster_id": "1ae95d89-cea7-4f27-8ed8-d4f49e95c5db",
      "event_cluster_id": "37ac1c3c-10ae-411e-a6f7-5a4e0cfd6c1b"
    },
    {
      "claim_cluster_id": "66cd9492-ff5e-477d-9ab7-967722c94dcd",
      "event_cluster_id": "a8aac635-8bd8-48b4-bd49-e815a9015bf1"
    },
    {
      "claim_cluster_id": "732c6dc2-1231-46ca-b1c1-173c0f488176",
      "event_cluster_id": "759b22c3-b9e1-49af-a4a6-7bcb4d79d24f"
    },
    {
      "claim_cluster_id": "edec9892-cca5-4a34-b102-ebb0bb45e077",
      "event_cluster_id": "fe1c4a63-bcaf-4dd2-88f2-589a45ffdabb"
    },
    {
      "claim_cluster_id": "29469bb2-a496-413c-802b-5a8d1b46d374",
      "event_cluster_id": "f471f0e2-f8be-4060-8f3a-33826e6e00b4"
    },
    {
      "claim_cluster_id": "70a36c06-fbb9-4f71-bf77-74f433672b24",
      "event_cluster_id": "be7b3105-d76a-4aca-86c4-5d724f3e84ce"
    },
    {
      "claim_cluster_id": "612e1b04-721a-48bd-b18f-300c7c5af276",
      "event_cluster_id": "7751d40e-e8dc-4a49-ab80-48cd61a84607"
    },
    {
      "claim_cluster_id": "d6705dc8-8def-4060-882a-9c13b62a23ad",
      "event_cluster_id": "82f5beda-b460-413d-ba52-232c56bac459"
    },
    {
      "claim_cluster_id": "c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9",
      "event_cluster_id": "1bb75de7-fa9e-48e1-9651-ee91dc1ce93e"
    },
    {
      "claim_cluster_id": "01611d1d-46c6-40fa-ad44-4b4dcb9a85fa",
      "event_cluster_id": "6a85e8dd-d86f-4e00-b252-62364be2e0ab"
    },
    {
      "claim_cluster_id": "8b0aef83-1693-4fa2-8559-a133b18a2dbb",
      "event_cluster_id": "16e2933e-aa5c-44ff-81fe-873695154b36"
    },
    {
      "claim_cluster_id": "f74715cf-7efc-4866-8a83-4aec1b75795e",
      "event_cluster_id": "186e2ceb-09a9-47a1-9aac-0510446000af"
    },
    {
      "claim_cluster_id": "38520096-281c-4b53-ba64-f7e18dbd525f",
      "event_cluster_id": "c99071d0-4f9f-4d85-a471-8ed03007f96c"
    },
    {
      "claim_cluster_id": "7576470b-cafe-4c17-9541-256e9ec07097",
      "event_cluster_id": "1fcf44f5-43a5-44f5-b144-1142863197ac"
    },
    {
      "claim_cluster_id": "bd5ae3e5-8ac9-4557-ad42-7cdcb0687b6c",
      "event_cluster_id": "59b16d26-5dcb-404b-8589-2b9a2089c70d"
    },
    {
      "claim_cluster_id": "bde9febe-9a28-4f0f-b67c-15f9a243538b",
      "event_cluster_id": "e42d141d-80cc-4e68-848e-2d85ecf6a58c"
    },
    {
      "claim_cluster_id": "174a0855-e1b9-4e2b-9a6a-957eb12d4b1a",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "e684bea9-83ef-4337-93a3-80b8a3708ae0",
      "event_cluster_id": "c3a97d86-3ef3-41b9-9b1d-e19ad5caca74"
    },
    {
      "claim_cluster_id": "5f9b6057-0fab-4c3c-b1af-a7c26bc6c692",
      "event_cluster_id": "930472a6-b976-45c6-814a-9c87d52eedd0"
    },
    {
      "claim_cluster_id": "36b91493-5f3f-412b-a861-2328c6420cc6",
      "event_cluster_id": "6528a411-ccde-4df7-8364-b5129e53c388"
    },
    {
      "claim_cluster_id": "fa9ba14d-4628-4fac-b94e-953f493cb218",
      "event_cluster_id": "d6f2ede4-7d0b-48ff-b867-ebcd3c6ff871"
    },
    {
      "claim_cluster_id": "5f1a9137-7798-4811-b69e-bc8d7d163c7c",
      "event_cluster_id": "f3b3b03f-2658-4df1-9b64-e36964888fbf"
    },
    {
      "claim_cluster_id": "7885c5ae-734b-4d64-8d84-fc50b9a87ad7",
      "event_cluster_id": "4485e5d3-efcb-4d42-a185-349293bfd550"
    },
    {
      "claim_cluster_id": "8f4c47af-fb0d-428c-b422-7767f77bc38d",
      "event_cluster_id": "784c345c-143d-4aef-b094-6eba2f83003c"
    },
    {
      "claim_cluster_id": "12dfa7c9-8817-4f21-ad00-1e4244142b34",
      "event_cluster_id": "06455359-79a6-4ebb-a802-9c4a2595559c"
    },
    {
      "claim_cluster_id": "9367c0e9-bbdd-4398-9de3-210a1f73c88e",
      "event_cluster_id": "0103bebb-a8e1-4ccf-b716-fa6fd4687ac3"
    },
    {
      "claim_cluster_id": "2870dcce-8def-47de-9196-c66889a0a474",
      "event_cluster_id": "d8891f2e-5868-4443-b59d-cc8c86215171"
    },
    {
      "claim_cluster_id": "e4184b4a-b3b8-45cd-9a60-442e840d1a7e",
      "event_cluster_id": "ae19516a-2181-488e-ac04-088ae5ab7d84"
    },
    {
      "claim_cluster_id": "481b0645-4bcd-4df1-ae15-b184375e551e",
      "event_cluster_id": "f6a33dd1-9465-4406-a3a5-1949cd825e71"
    },
    {
      "claim_cluster_id": "2cb0cf7d-4f72-4e53-9096-b92c1763568c",
      "event_cluster_id": "28c6580f-d2db-4b2f-a0b5-3530cff5de7f"
    },
    {
      "claim_cluster_id": "2cb0cf7d-4f72-4e53-9096-b92c1763568c",
      "event_cluster_id": "4ce53ac2-ac2e-43cc-ab0a-b530b8f75695"
    },
    {
      "claim_cluster_id": "f7c875b0-a0b4-45f6-b382-0915f179b2e6",
      "event_cluster_id": "d1dbd6e1-d934-4ffc-ba5a-8d6ce10501d3"
    },
    {
      "claim_cluster_id": "b4e4a860-8721-4ac3-8eb3-a9dec18b336d",
      "event_cluster_id": "03b556ab-fe42-4f7d-954a-c2484c0fac43"
    },
    {
      "claim_cluster_id": "32dde553-bbf3-44a2-afd4-d60807ce0ab7",
      "event_cluster_id": "39ba0d7c-5f4e-43e3-b6a2-9f87693ee149"
    },
    {
      "claim_cluster_id": "db5a201e-a58a-46dc-91a0-0072432f56c4",
      "event_cluster_id": "442ff222-51e2-4836-a92e-ab5d99d9d014"
    },
    {
      "claim_cluster_id": "ef636ecf-8b34-4007-8f71-b4d5ed7d3c33",
      "event_cluster_id": "8abd35db-2186-4408-8be6-3af382d275ab"
    },
    {
      "claim_cluster_id": "d59582f7-7e86-41f9-a084-db1da2a740db",
      "event_cluster_id": "34d1bb66-1439-414b-aa89-28ecbed93a5f"
    },
    {
      "claim_cluster_id": "9d85f9b8-6204-4844-9707-8c2e9351d730",
      "event_cluster_id": "44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"
    },
    {
      "claim_cluster_id": "7c2161be-91e7-4c74-9f49-fb997b3c5857",
      "event_cluster_id": "aa771524-1314-4f8e-8195-c42cbd659c66"
    },
    {
      "claim_cluster_id": "962affe3-ba24-4db1-8a1a-d157fa469f0c",
      "event_cluster_id": "6e27c008-554e-490f-bd40-be5dceee83e2"
    },
    {
      "claim_cluster_id": "300e8b62-ec91-41e2-9809-166d3f0a78b2",
      "event_cluster_id": "8b7f2a67-267c-4f34-bf57-216f33b13adb"
    },
    {
      "claim_cluster_id": "5e700671-a24a-4c8f-a1e4-abbfb82f4537",
      "event_cluster_id": "3b3110cf-93d0-4510-9837-e4eaf9f9a935"
    },
    {
      "claim_cluster_id": "3769f810-e5f7-4d0a-9821-1876b6cadf34",
      "event_cluster_id": "f2a2ed3b-6c1b-49ef-92fd-f294f1deb809"
    },
    {
      "claim_cluster_id": "e50a9fba-a791-4b5a-bed8-e0accc690c1a",
      "event_cluster_id": "72967666-4eb9-48c4-a9dc-dc51036d287d"
    },
    {
      "claim_cluster_id": "9314aa75-84de-490c-95e7-6484ecdba212",
      "event_cluster_id": "978715ff-b53c-4912-969e-25b8f2aa2ba5"
    },
    {
      "claim_cluster_id": "5e128621-af42-4a93-b091-b4e768efec3b",
      "event_cluster_id": "06fc9106-7925-4cb4-a52c-592a739aee82"
    },
    {
      "claim_cluster_id": "e7287d47-759e-41f0-9641-093ab1e3e04c",
      "event_cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965"
    },
    {
      "claim_cluster_id": "269d367a-5938-4087-911a-3256c10a910f",
      "event_cluster_id": "5b30c301-097d-4b93-b41c-2c7775c1b518"
    },
    {
      "claim_cluster_id": "60b95622-d70d-459f-9ef4-53d53c239154",
      "event_cluster_id": "d291acf3-7cf8-4c9d-9ab4-df11bad39953"
    },
    {
      "claim_cluster_id": "9dc5b38b-c904-4a4b-b9f9-a33166585c43",
      "event_cluster_id": "cd18cc59-c362-4812-b494-ea37654755a0"
    },
    {
      "claim_cluster_id": "4d2dc30e-97f5-49d3-80df-c343048e6856",
      "event_cluster_id": "eea04632-7eb6-45a8-afd1-95556afba561"
    },
    {
      "claim_cluster_id": "bf76e0b1-c54e-4ab8-82d0-979d68c35a65",
      "event_cluster_id": "fe5accb2-754b-4498-82d5-eaf3b4116254"
    },
    {
      "claim_cluster_id": "eea02be7-fd53-47b5-9804-7a2f89de23f2",
      "event_cluster_id": "eb5867fb-4e30-491e-839e-081457361ded"
    },
    {
      "claim_cluster_id": "8d550fbc-5131-4294-a815-b9e32f81ad7a",
      "event_cluster_id": "ce319c6f-8ace-40b1-be7e-933bd39cd9c5"
    },
    {
      "claim_cluster_id": "c214c388-1bcb-48de-9ccf-d250135ec39d",
      "event_cluster_id": "71920f88-d391-4321-a826-7f3d2ac6a5db"
    },
    {
      "claim_cluster_id": "c6d2f5c4-bb51-435b-a664-174b47ed38ef",
      "event_cluster_id": "fe271a39-4283-4ba9-9f74-a4db31cc4b3c"
    }
  ]
}